/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(610);
	module.exports = __webpack_require__(784);


/***/ },
/* 1 */
[2188, 1928],
/* 2 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = requiredArgs;
	
	function requiredArgs(required, args) {
	  if (args.length < required) {
	    throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
	  }
	}
	
	module.exports = exports.default;

/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = toDate;
	
	var _index = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name toDate
	 * @category Common Helpers
	 * @summary Convert the given argument to an instance of Date.
	 *
	 * @description
	 * Convert the given argument to an instance of Date.
	 *
	 * If the argument is an instance of Date, the function returns its clone.
	 *
	 * If the argument is a number, it is treated as a timestamp.
	 *
	 * If the argument is none of the above, the function returns Invalid Date.
	 *
	 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
	 *
	 * @param {Date|Number} argument - the value to convert
	 * @returns {Date} the parsed date in the local time zone
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Clone the date:
	 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
	 * //=> Tue Feb 11 2014 11:30:30
	 *
	 * @example
	 * // Convert the timestamp to date:
	 * const result = toDate(1392098430000)
	 * //=> Tue Feb 11 2014 11:30:30
	 */
	function toDate(argument) {
	  (0, _index.default)(1, arguments);
	  var argStr = Object.prototype.toString.call(argument); // Clone the date
	
	  if (argument instanceof Date || typeof argument === 'object' && argStr === '[object Date]') {
	    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
	    return new Date(argument.getTime());
	  } else if (typeof argument === 'number' || argStr === '[object Number]') {
	    return new Date(argument);
	  } else {
	    if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
	      // eslint-disable-next-line no-console
	      console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://git.io/fjule"); // eslint-disable-next-line no-console
	
	      console.warn(new Error().stack);
	    }
	
	    return new Date(NaN);
	  }
	}
	
	module.exports = exports.default;

/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (false) {
	  var ReactIs = require('react-is');
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(1761)();
	}


/***/ },
/* 5 */
/***/ function(module, exports) {

	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : {
	    "default": obj
	  };
	}
	
	module.exports = _interopRequireDefault;
	module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ },
/* 6 */
/***/ function(module, exports) {

	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : {
	    "default": obj
	  };
	}
	module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	var _Object$create = __webpack_require__(613);
	
	var setPrototypeOf = __webpack_require__(622);
	
	function _inheritsLoose(subClass, superClass) {
	  subClass.prototype = _Object$create(superClass.prototype);
	  subClass.prototype.constructor = subClass;
	  setPrototypeOf(subClass, superClass);
	}
	
	module.exports = _inheritsLoose;
	module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	var _Object$assign = __webpack_require__(340);
	
	function _extends() {
	  module.exports = _extends = _Object$assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  module.exports["default"] = module.exports, module.exports.__esModule = true;
	  return _extends.apply(this, arguments);
	}
	
	module.exports = _extends;
	module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ },
/* 9 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = buildFormatLongFn;
	
	function buildFormatLongFn(args) {
	  return function () {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    // TODO: Remove String()
	    var width = options.width ? String(options.width) : args.defaultWidth;
	    var format = args.formats[width] || args.formats[args.defaultWidth];
	    return format;
	  };
	}
	
	module.exports = exports.default;

/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	var _Object$keys = __webpack_require__(616);
	
	function _objectWithoutPropertiesLoose(source, excluded) {
	  if (source == null) return {};
	  var target = {};
	
	  var sourceKeys = _Object$keys(source);
	
	  var key, i;
	
	  for (i = 0; i < sourceKeys.length; i++) {
	    key = sourceKeys[i];
	    if (excluded.indexOf(key) >= 0) continue;
	    target[key] = source[key];
	  }
	
	  return target;
	}
	
	module.exports = _objectWithoutPropertiesLoose;
	module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 * Copyright 2017, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var allLocaleData = _interopDefault(__webpack_require__(2185));
	var IntlMessageFormat = _interopDefault(__webpack_require__(471));
	var IntlRelativeFormat = _interopDefault(__webpack_require__(1645));
	var PropTypes = _interopDefault(__webpack_require__(4));
	var React = __webpack_require__(1);
	var React__default = _interopDefault(React);
	var invariant = _interopDefault(__webpack_require__(37));
	var memoizeIntlConstructor = _interopDefault(__webpack_require__(1637));
	
	// GENERATED FILE
	var defaultLocaleData = { "locale": "en", "pluralRuleFunction": function pluralRuleFunction(n, ord) {
	    var s = String(n).split("."),
	        v0 = !s[1],
	        t0 = Number(s[0]) == n,
	        n10 = t0 && s[0].slice(-1),
	        n100 = t0 && s[0].slice(-2);if (ord) return n10 == 1 && n100 != 11 ? "one" : n10 == 2 && n100 != 12 ? "two" : n10 == 3 && n100 != 13 ? "few" : "other";return n == 1 && v0 ? "one" : "other";
	  }, "fields": { "year": { "displayName": "year", "relative": { "0": "this year", "1": "next year", "-1": "last year" }, "relativeTime": { "future": { "one": "in {0} year", "other": "in {0} years" }, "past": { "one": "{0} year ago", "other": "{0} years ago" } } }, "month": { "displayName": "month", "relative": { "0": "this month", "1": "next month", "-1": "last month" }, "relativeTime": { "future": { "one": "in {0} month", "other": "in {0} months" }, "past": { "one": "{0} month ago", "other": "{0} months ago" } } }, "day": { "displayName": "day", "relative": { "0": "today", "1": "tomorrow", "-1": "yesterday" }, "relativeTime": { "future": { "one": "in {0} day", "other": "in {0} days" }, "past": { "one": "{0} day ago", "other": "{0} days ago" } } }, "hour": { "displayName": "hour", "relativeTime": { "future": { "one": "in {0} hour", "other": "in {0} hours" }, "past": { "one": "{0} hour ago", "other": "{0} hours ago" } } }, "minute": { "displayName": "minute", "relativeTime": { "future": { "one": "in {0} minute", "other": "in {0} minutes" }, "past": { "one": "{0} minute ago", "other": "{0} minutes ago" } } }, "second": { "displayName": "second", "relative": { "0": "now" }, "relativeTime": { "future": { "one": "in {0} second", "other": "in {0} seconds" }, "past": { "one": "{0} second ago", "other": "{0} seconds ago" } } } } };
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	function addLocaleData() {
	    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	    var locales = Array.isArray(data) ? data : [data];
	
	    locales.forEach(function (localeData) {
	        if (localeData && localeData.locale) {
	            IntlMessageFormat.__addLocaleData(localeData);
	            IntlRelativeFormat.__addLocaleData(localeData);
	        }
	    });
	}
	
	function hasLocaleData(locale) {
	    var localeParts = (locale || '').split('-');
	
	    while (localeParts.length > 0) {
	        if (hasIMFAndIRFLocaleData(localeParts.join('-'))) {
	            return true;
	        }
	
	        localeParts.pop();
	    }
	
	    return false;
	}
	
	function hasIMFAndIRFLocaleData(locale) {
	    var normalizedLocale = locale && locale.toLowerCase();
	
	    return !!(IntlMessageFormat.__localeData__[normalizedLocale] && IntlRelativeFormat.__localeData__[normalizedLocale]);
	}
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
	  return typeof obj;
	} : function (obj) {
	  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	};
	
	
	
	
	
	
	
	
	
	
	
	var classCallCheck = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	var createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();
	
	
	
	
	
	var defineProperty = function (obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	};
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};
	
	
	
	var inherits = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }
	
	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	};
	
	
	
	
	
	
	
	
	
	var objectWithoutProperties = function (obj, keys) {
	  var target = {};
	
	  for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;
	    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	    target[i] = obj[i];
	  }
	
	  return target;
	};
	
	var possibleConstructorReturn = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && (typeof call === "object" || typeof call === "function") ? call : self;
	};
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	var toConsumableArray = function (arr) {
	  if (Array.isArray(arr)) {
	    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];
	
	    return arr2;
	  } else {
	    return Array.from(arr);
	  }
	};
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	var bool = PropTypes.bool;
	var number = PropTypes.number;
	var string = PropTypes.string;
	var func = PropTypes.func;
	var object = PropTypes.object;
	var oneOf = PropTypes.oneOf;
	var shape = PropTypes.shape;
	var any = PropTypes.any;
	
	var localeMatcher = oneOf(['best fit', 'lookup']);
	var narrowShortLong = oneOf(['narrow', 'short', 'long']);
	var numeric2digit = oneOf(['numeric', '2-digit']);
	var funcReq = func.isRequired;
	
	var intlConfigPropTypes = {
	    locale: string,
	    formats: object,
	    messages: object,
	    textComponent: any,
	
	    defaultLocale: string,
	    defaultFormats: object
	};
	
	var intlFormatPropTypes = {
	    formatDate: funcReq,
	    formatTime: funcReq,
	    formatRelative: funcReq,
	    formatNumber: funcReq,
	    formatPlural: funcReq,
	    formatMessage: funcReq,
	    formatHTMLMessage: funcReq
	};
	
	var intlShape = shape(_extends({}, intlConfigPropTypes, intlFormatPropTypes, {
	    formatters: object,
	    now: funcReq
	}));
	
	var messageDescriptorPropTypes = {
	    id: string.isRequired,
	    description: string,
	    defaultMessage: string
	};
	
	var dateTimeFormatPropTypes = {
	    localeMatcher: localeMatcher,
	    formatMatcher: oneOf(['basic', 'best fit']),
	
	    timeZone: string,
	    hour12: bool,
	
	    weekday: narrowShortLong,
	    era: narrowShortLong,
	    year: numeric2digit,
	    month: oneOf(['numeric', '2-digit', 'narrow', 'short', 'long']),
	    day: numeric2digit,
	    hour: numeric2digit,
	    minute: numeric2digit,
	    second: numeric2digit,
	    timeZoneName: oneOf(['short', 'long'])
	};
	
	var numberFormatPropTypes = {
	    localeMatcher: localeMatcher,
	
	    style: oneOf(['decimal', 'currency', 'percent']),
	    currency: string,
	    currencyDisplay: oneOf(['symbol', 'code', 'name']),
	    useGrouping: bool,
	
	    minimumIntegerDigits: number,
	    minimumFractionDigits: number,
	    maximumFractionDigits: number,
	    minimumSignificantDigits: number,
	    maximumSignificantDigits: number
	};
	
	var relativeFormatPropTypes = {
	    style: oneOf(['best fit', 'numeric']),
	    units: oneOf(['second', 'minute', 'hour', 'day', 'month', 'year'])
	};
	
	var pluralFormatPropTypes = {
	    style: oneOf(['cardinal', 'ordinal'])
	};
	
	/*
	HTML escaping and shallow-equals implementations are the same as React's
	(on purpose.) Therefore, it has the following Copyright and Licensing:
	
	Copyright 2013-2014, Facebook, Inc.
	All rights reserved.
	
	This source code is licensed under the BSD-style license found in the LICENSE
	file in the root directory of React's source tree.
	*/
	
	var intlConfigPropNames = Object.keys(intlConfigPropTypes);
	
	var ESCAPED_CHARS = {
	    '&': '&amp;',
	    '>': '&gt;',
	    '<': '&lt;',
	    '"': '&quot;',
	    '\'': '&#x27;'
	};
	
	var UNSAFE_CHARS_REGEX = /[&><"']/g;
	
	function escape(str) {
	    return ('' + str).replace(UNSAFE_CHARS_REGEX, function (match) {
	        return ESCAPED_CHARS[match];
	    });
	}
	
	function filterProps(props, whitelist) {
	    var defaults$$1 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	    return whitelist.reduce(function (filtered, name) {
	        if (props.hasOwnProperty(name)) {
	            filtered[name] = props[name];
	        } else if (defaults$$1.hasOwnProperty(name)) {
	            filtered[name] = defaults$$1[name];
	        }
	
	        return filtered;
	    }, {});
	}
	
	function invariantIntlContext() {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        intl = _ref.intl;
	
	    invariant(intl, '[React Intl] Could not find required `intl` object. ' + '<IntlProvider> needs to exist in the component ancestry.');
	}
	
	function shallowEquals(objA, objB) {
	    if (objA === objB) {
	        return true;
	    }
	
	    if ((typeof objA === 'undefined' ? 'undefined' : _typeof(objA)) !== 'object' || objA === null || (typeof objB === 'undefined' ? 'undefined' : _typeof(objB)) !== 'object' || objB === null) {
	        return false;
	    }
	
	    var keysA = Object.keys(objA);
	    var keysB = Object.keys(objB);
	
	    if (keysA.length !== keysB.length) {
	        return false;
	    }
	
	    // Test for A's keys different from B.
	    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	    for (var i = 0; i < keysA.length; i++) {
	        if (!bHasOwnProperty(keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
	            return false;
	        }
	    }
	
	    return true;
	}
	
	function shouldIntlComponentUpdate(_ref2, nextProps, nextState) {
	    var props = _ref2.props,
	        state = _ref2.state,
	        _ref2$context = _ref2.context,
	        context = _ref2$context === undefined ? {} : _ref2$context;
	    var nextContext = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	    var _context$intl = context.intl,
	        intl = _context$intl === undefined ? {} : _context$intl;
	    var _nextContext$intl = nextContext.intl,
	        nextIntl = _nextContext$intl === undefined ? {} : _nextContext$intl;
	
	
	    return !shallowEquals(nextProps, props) || !shallowEquals(nextState, state) || !(nextIntl === intl || shallowEquals(filterProps(nextIntl, intlConfigPropNames), filterProps(intl, intlConfigPropNames)));
	}
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	// Inspired by react-redux's `connect()` HOC factory function implementation:
	// https://github.com/rackt/react-redux
	
	function getDisplayName(Component$$1) {
	    return Component$$1.displayName || Component$$1.name || 'Component';
	}
	
	function injectIntl(WrappedComponent) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var _options$intlPropName = options.intlPropName,
	        intlPropName = _options$intlPropName === undefined ? 'intl' : _options$intlPropName,
	        _options$withRef = options.withRef,
	        withRef = _options$withRef === undefined ? false : _options$withRef;
	
	    var InjectIntl = function (_Component) {
	        inherits(InjectIntl, _Component);
	
	        function InjectIntl(props, context) {
	            classCallCheck(this, InjectIntl);
	
	            var _this = possibleConstructorReturn(this, (InjectIntl.__proto__ || Object.getPrototypeOf(InjectIntl)).call(this, props, context));
	
	            invariantIntlContext(context);
	            return _this;
	        }
	
	        createClass(InjectIntl, [{
	            key: 'getWrappedInstance',
	            value: function getWrappedInstance() {
	                invariant(withRef, '[React Intl] To access the wrapped instance, ' + 'the `{withRef: true}` option must be set when calling: ' + '`injectIntl()`');
	
	                return this.refs.wrappedInstance;
	            }
	        }, {
	            key: 'render',
	            value: function render() {
	                return React__default.createElement(WrappedComponent, _extends({}, this.props, defineProperty({}, intlPropName, this.context.intl), {
	                    ref: withRef ? 'wrappedInstance' : null
	                }));
	            }
	        }]);
	        return InjectIntl;
	    }(React.Component);
	
	    InjectIntl.displayName = 'InjectIntl(' + getDisplayName(WrappedComponent) + ')';
	    InjectIntl.contextTypes = {
	        intl: intlShape
	    };
	    InjectIntl.WrappedComponent = WrappedComponent;
	
	
	    return InjectIntl;
	}
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	function defineMessages(messageDescriptors) {
	  // This simply returns what's passed-in because it's meant to be a hook for
	  // babel-plugin-react-intl.
	  return messageDescriptors;
	}
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	// This is a "hack" until a proper `intl-pluralformat` package is created.
	
	function resolveLocale(locales) {
	    // IntlMessageFormat#_resolveLocale() does not depend on `this`.
	    return IntlMessageFormat.prototype._resolveLocale(locales);
	}
	
	function findPluralFunction(locale) {
	    // IntlMessageFormat#_findPluralFunction() does not depend on `this`.
	    return IntlMessageFormat.prototype._findPluralRuleFunction(locale);
	}
	
	var IntlPluralFormat = function IntlPluralFormat(locales) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    classCallCheck(this, IntlPluralFormat);
	
	    var useOrdinal = options.style === 'ordinal';
	    var pluralFn = findPluralFunction(resolveLocale(locales));
	
	    this.format = function (value) {
	        return pluralFn(value, useOrdinal);
	    };
	};
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	var DATE_TIME_FORMAT_OPTIONS = Object.keys(dateTimeFormatPropTypes);
	var NUMBER_FORMAT_OPTIONS = Object.keys(numberFormatPropTypes);
	var RELATIVE_FORMAT_OPTIONS = Object.keys(relativeFormatPropTypes);
	var PLURAL_FORMAT_OPTIONS = Object.keys(pluralFormatPropTypes);
	
	var RELATIVE_FORMAT_THRESHOLDS = {
	    second: 60, // seconds to minute
	    minute: 60, // minutes to hour
	    hour: 24, // hours to day
	    day: 30, // days to month
	    month: 12 };
	
	function updateRelativeFormatThresholds(newThresholds) {
	    var thresholds = IntlRelativeFormat.thresholds;
	    thresholds.second = newThresholds.second;
	    thresholds.minute = newThresholds.minute;
	    thresholds.hour = newThresholds.hour;
	    thresholds.day = newThresholds.day;
	    thresholds.month = newThresholds.month;
	}
	
	function getNamedFormat(formats, type, name) {
	    var format = formats && formats[type] && formats[type][name];
	    if (format) {
	        return format;
	    }
	
	    if (false) {
	        console.error('[React Intl] No ' + type + ' format named: ' + name);
	    }
	}
	
	function formatDate(config, state, value) {
	    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	    var locale = config.locale,
	        formats = config.formats;
	    var format = options.format;
	
	
	    var date = new Date(value);
	    var defaults$$1 = format && getNamedFormat(formats, 'date', format);
	    var filteredOptions = filterProps(options, DATE_TIME_FORMAT_OPTIONS, defaults$$1);
	
	    try {
	        return state.getDateTimeFormat(locale, filteredOptions).format(date);
	    } catch (e) {
	        if (false) {
	            console.error('[React Intl] Error formatting date.\n' + e);
	        }
	    }
	
	    return String(date);
	}
	
	function formatTime(config, state, value) {
	    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	    var locale = config.locale,
	        formats = config.formats;
	    var format = options.format;
	
	
	    var date = new Date(value);
	    var defaults$$1 = format && getNamedFormat(formats, 'time', format);
	    var filteredOptions = filterProps(options, DATE_TIME_FORMAT_OPTIONS, defaults$$1);
	
	    if (!filteredOptions.hour && !filteredOptions.minute && !filteredOptions.second) {
	        // Add default formatting options if hour, minute, or second isn't defined.
	        filteredOptions = _extends({}, filteredOptions, { hour: 'numeric', minute: 'numeric' });
	    }
	
	    try {
	        return state.getDateTimeFormat(locale, filteredOptions).format(date);
	    } catch (e) {
	        if (false) {
	            console.error('[React Intl] Error formatting time.\n' + e);
	        }
	    }
	
	    return String(date);
	}
	
	function formatRelative(config, state, value) {
	    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	    var locale = config.locale,
	        formats = config.formats;
	    var format = options.format;
	
	
	    var date = new Date(value);
	    var now = new Date(options.now);
	    var defaults$$1 = format && getNamedFormat(formats, 'relative', format);
	    var filteredOptions = filterProps(options, RELATIVE_FORMAT_OPTIONS, defaults$$1);
	
	    // Capture the current threshold values, then temporarily override them with
	    // specific values just for this render.
	    var oldThresholds = _extends({}, IntlRelativeFormat.thresholds);
	    updateRelativeFormatThresholds(RELATIVE_FORMAT_THRESHOLDS);
	
	    try {
	        return state.getRelativeFormat(locale, filteredOptions).format(date, {
	            now: isFinite(now) ? now : state.now()
	        });
	    } catch (e) {
	        if (false) {
	            console.error('[React Intl] Error formatting relative time.\n' + e);
	        }
	    } finally {
	        updateRelativeFormatThresholds(oldThresholds);
	    }
	
	    return String(date);
	}
	
	function formatNumber(config, state, value) {
	    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	    var locale = config.locale,
	        formats = config.formats;
	    var format = options.format;
	
	
	    var defaults$$1 = format && getNamedFormat(formats, 'number', format);
	    var filteredOptions = filterProps(options, NUMBER_FORMAT_OPTIONS, defaults$$1);
	
	    try {
	        return state.getNumberFormat(locale, filteredOptions).format(value);
	    } catch (e) {
	        if (false) {
	            console.error('[React Intl] Error formatting number.\n' + e);
	        }
	    }
	
	    return String(value);
	}
	
	function formatPlural(config, state, value) {
	    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	    var locale = config.locale;
	
	
	    var filteredOptions = filterProps(options, PLURAL_FORMAT_OPTIONS);
	
	    try {
	        return state.getPluralFormat(locale, filteredOptions).format(value);
	    } catch (e) {
	        if (false) {
	            console.error('[React Intl] Error formatting plural.\n' + e);
	        }
	    }
	
	    return 'other';
	}
	
	function formatMessage(config, state) {
	    var messageDescriptor = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var values = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	    var locale = config.locale,
	        formats = config.formats,
	        messages = config.messages,
	        defaultLocale = config.defaultLocale,
	        defaultFormats = config.defaultFormats;
	    var id = messageDescriptor.id,
	        defaultMessage = messageDescriptor.defaultMessage;
	
	    // `id` is a required field of a Message Descriptor.
	
	    invariant(id, '[React Intl] An `id` must be provided to format a message.');
	
	    var message = messages && messages[id];
	    var hasValues = Object.keys(values).length > 0;
	
	    // Avoid expensive message formatting for simple messages without values. In
	    // development messages will always be formatted in case of missing values.
	    if (!hasValues && ("production") === 'production') {
	        return message || defaultMessage || id;
	    }
	
	    var formattedMessage = void 0;
	
	    if (message) {
	        try {
	            var formatter = state.getMessageFormat(message, locale, formats);
	
	            formattedMessage = formatter.format(values);
	        } catch (e) {
	            if (false) {
	                console.error('[React Intl] Error formatting message: "' + id + '" for locale: "' + locale + '"' + (defaultMessage ? ', using default message as fallback.' : '') + ('\n' + e));
	            }
	        }
	    } else {
	        if (false) {
	            // This prevents warnings from littering the console in development
	            // when no `messages` are passed into the <IntlProvider> for the
	            // default locale, and a default message is in the source.
	            if (!defaultMessage || locale && locale.toLowerCase() !== defaultLocale.toLowerCase()) {
	
	                console.error('[React Intl] Missing message: "' + id + '" for locale: "' + locale + '"' + (defaultMessage ? ', using default message as fallback.' : ''));
	            }
	        }
	    }
	
	    if (!formattedMessage && defaultMessage) {
	        try {
	            var _formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats);
	
	            formattedMessage = _formatter.format(values);
	        } catch (e) {
	            if (false) {
	                console.error('[React Intl] Error formatting the default message for: "' + id + '"' + ('\n' + e));
	            }
	        }
	    }
	
	    if (!formattedMessage) {
	        if (false) {
	            console.error('[React Intl] Cannot format message: "' + id + '", ' + ('using message ' + (message || defaultMessage ? 'source' : 'id') + ' as fallback.'));
	        }
	    }
	
	    return formattedMessage || message || defaultMessage || id;
	}
	
	function formatHTMLMessage(config, state, messageDescriptor) {
	    var rawValues = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
	    // Process all the values before they are used when formatting the ICU
	    // Message string. Since the formatted message might be injected via
	    // `innerHTML`, all String-based values need to be HTML-escaped.
	    var escapedValues = Object.keys(rawValues).reduce(function (escaped, name) {
	        var value = rawValues[name];
	        escaped[name] = typeof value === 'string' ? escape(value) : value;
	        return escaped;
	    }, {});
	
	    return formatMessage(config, state, messageDescriptor, escapedValues);
	}
	
	
	
	var format = Object.freeze({
		formatDate: formatDate,
		formatTime: formatTime,
		formatRelative: formatRelative,
		formatNumber: formatNumber,
		formatPlural: formatPlural,
		formatMessage: formatMessage,
		formatHTMLMessage: formatHTMLMessage
	});
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	var intlConfigPropNames$1 = Object.keys(intlConfigPropTypes);
	var intlFormatPropNames = Object.keys(intlFormatPropTypes);
	
	// These are not a static property on the `IntlProvider` class so the intl
	// config values can be inherited from an <IntlProvider> ancestor.
	var defaultProps = {
	    formats: {},
	    messages: {},
	    textComponent: 'span',
	
	    defaultLocale: 'en',
	    defaultFormats: {}
	};
	
	var IntlProvider = function (_Component) {
	    inherits(IntlProvider, _Component);
	
	    function IntlProvider(props) {
	        var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	        classCallCheck(this, IntlProvider);
	
	        var _this = possibleConstructorReturn(this, (IntlProvider.__proto__ || Object.getPrototypeOf(IntlProvider)).call(this, props, context));
	
	        invariant(typeof Intl !== 'undefined', '[React Intl] The `Intl` APIs must be available in the runtime, ' + 'and do not appear to be built-in. An `Intl` polyfill should be loaded.\n' + 'See: http://formatjs.io/guides/runtime-environments/');
	
	        var intlContext = context.intl;
	
	        // Used to stabilize time when performing an initial rendering so that
	        // all relative times use the same reference "now" time.
	
	        var initialNow = void 0;
	        if (isFinite(props.initialNow)) {
	            initialNow = Number(props.initialNow);
	        } else {
	            // When an `initialNow` isn't provided via `props`, look to see an
	            // <IntlProvider> exists in the ancestry and call its `now()`
	            // function to propagate its value for "now".
	            initialNow = intlContext ? intlContext.now() : Date.now();
	        }
	
	        // Creating `Intl*` formatters is expensive. If there's a parent
	        // `<IntlProvider>`, then its formatters will be used. Otherwise, this
	        // memoize the `Intl*` constructors and cache them for the lifecycle of
	        // this IntlProvider instance.
	
	        var _ref = intlContext || {},
	            _ref$formatters = _ref.formatters,
	            formatters = _ref$formatters === undefined ? {
	            getDateTimeFormat: memoizeIntlConstructor(Intl.DateTimeFormat),
	            getNumberFormat: memoizeIntlConstructor(Intl.NumberFormat),
	            getMessageFormat: memoizeIntlConstructor(IntlMessageFormat),
	            getRelativeFormat: memoizeIntlConstructor(IntlRelativeFormat),
	            getPluralFormat: memoizeIntlConstructor(IntlPluralFormat)
	        } : _ref$formatters;
	
	        _this.state = _extends({}, formatters, {
	
	            // Wrapper to provide stable "now" time for initial render.
	            now: function now() {
	                return _this._didDisplay ? Date.now() : initialNow;
	            }
	        });
	        return _this;
	    }
	
	    createClass(IntlProvider, [{
	        key: 'getConfig',
	        value: function getConfig() {
	            var intlContext = this.context.intl;
	
	            // Build a whitelisted config object from `props`, defaults, and
	            // `context.intl`, if an <IntlProvider> exists in the ancestry.
	
	            var config = filterProps(this.props, intlConfigPropNames$1, intlContext);
	
	            // Apply default props. This must be applied last after the props have
	            // been resolved and inherited from any <IntlProvider> in the ancestry.
	            // This matches how React resolves `defaultProps`.
	            for (var propName in defaultProps) {
	                if (config[propName] === undefined) {
	                    config[propName] = defaultProps[propName];
	                }
	            }
	
	            if (!hasLocaleData(config.locale)) {
	                var _config = config,
	                    locale = _config.locale,
	                    defaultLocale = _config.defaultLocale,
	                    defaultFormats = _config.defaultFormats;
	
	
	                if (false) {
	                    console.error('[React Intl] Missing locale data for locale: "' + locale + '". ' + ('Using default locale: "' + defaultLocale + '" as fallback.'));
	                }
	
	                // Since there's no registered locale data for `locale`, this will
	                // fallback to the `defaultLocale` to make sure things can render.
	                // The `messages` are overridden to the `defaultProps` empty object
	                // to maintain referential equality across re-renders. It's assumed
	                // each <FormattedMessage> contains a `defaultMessage` prop.
	                config = _extends({}, config, {
	                    locale: defaultLocale,
	                    formats: defaultFormats,
	                    messages: defaultProps.messages
	                });
	            }
	
	            return config;
	        }
	    }, {
	        key: 'getBoundFormatFns',
	        value: function getBoundFormatFns(config, state) {
	            return intlFormatPropNames.reduce(function (boundFormatFns, name) {
	                boundFormatFns[name] = format[name].bind(null, config, state);
	                return boundFormatFns;
	            }, {});
	        }
	    }, {
	        key: 'getChildContext',
	        value: function getChildContext() {
	            var config = this.getConfig();
	
	            // Bind intl factories and current config to the format functions.
	            var boundFormatFns = this.getBoundFormatFns(config, this.state);
	
	            var _state = this.state,
	                now = _state.now,
	                formatters = objectWithoutProperties(_state, ['now']);
	
	
	            return {
	                intl: _extends({}, config, boundFormatFns, {
	                    formatters: formatters,
	                    now: now
	                })
	            };
	        }
	    }, {
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate() {
	            for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
	                next[_key] = arguments[_key];
	            }
	
	            return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this._didDisplay = true;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return React.Children.only(this.props.children);
	        }
	    }]);
	    return IntlProvider;
	}(React.Component);
	
	IntlProvider.displayName = 'IntlProvider';
	IntlProvider.contextTypes = {
	    intl: intlShape
	};
	IntlProvider.childContextTypes = {
	    intl: intlShape.isRequired
	};
	 false ? IntlProvider.propTypes = _extends({}, intlConfigPropTypes, {
	    children: PropTypes.element.isRequired,
	    initialNow: PropTypes.any
	}) : void 0;
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	var FormattedDate = function (_Component) {
	    inherits(FormattedDate, _Component);
	
	    function FormattedDate(props, context) {
	        classCallCheck(this, FormattedDate);
	
	        var _this = possibleConstructorReturn(this, (FormattedDate.__proto__ || Object.getPrototypeOf(FormattedDate)).call(this, props, context));
	
	        invariantIntlContext(context);
	        return _this;
	    }
	
	    createClass(FormattedDate, [{
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate() {
	            for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
	                next[_key] = arguments[_key];
	            }
	
	            return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _context$intl = this.context.intl,
	                formatDate = _context$intl.formatDate,
	                Text = _context$intl.textComponent;
	            var _props = this.props,
	                value = _props.value,
	                children = _props.children;
	
	
	            var formattedDate = formatDate(value, this.props);
	
	            if (typeof children === 'function') {
	                return children(formattedDate);
	            }
	
	            return React__default.createElement(
	                Text,
	                null,
	                formattedDate
	            );
	        }
	    }]);
	    return FormattedDate;
	}(React.Component);
	
	FormattedDate.displayName = 'FormattedDate';
	FormattedDate.contextTypes = {
	    intl: intlShape
	};
	 false ? FormattedDate.propTypes = _extends({}, dateTimeFormatPropTypes, {
	    value: PropTypes.any.isRequired,
	    format: PropTypes.string,
	    children: PropTypes.func
	}) : void 0;
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	var FormattedTime = function (_Component) {
	    inherits(FormattedTime, _Component);
	
	    function FormattedTime(props, context) {
	        classCallCheck(this, FormattedTime);
	
	        var _this = possibleConstructorReturn(this, (FormattedTime.__proto__ || Object.getPrototypeOf(FormattedTime)).call(this, props, context));
	
	        invariantIntlContext(context);
	        return _this;
	    }
	
	    createClass(FormattedTime, [{
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate() {
	            for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
	                next[_key] = arguments[_key];
	            }
	
	            return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _context$intl = this.context.intl,
	                formatTime = _context$intl.formatTime,
	                Text = _context$intl.textComponent;
	            var _props = this.props,
	                value = _props.value,
	                children = _props.children;
	
	
	            var formattedTime = formatTime(value, this.props);
	
	            if (typeof children === 'function') {
	                return children(formattedTime);
	            }
	
	            return React__default.createElement(
	                Text,
	                null,
	                formattedTime
	            );
	        }
	    }]);
	    return FormattedTime;
	}(React.Component);
	
	FormattedTime.displayName = 'FormattedTime';
	FormattedTime.contextTypes = {
	    intl: intlShape
	};
	 false ? FormattedTime.propTypes = _extends({}, dateTimeFormatPropTypes, {
	    value: PropTypes.any.isRequired,
	    format: PropTypes.string,
	    children: PropTypes.func
	}) : void 0;
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	var SECOND = 1000;
	var MINUTE = 1000 * 60;
	var HOUR = 1000 * 60 * 60;
	var DAY = 1000 * 60 * 60 * 24;
	
	// The maximum timer delay value is a 32-bit signed integer.
	// See: https://mdn.io/setTimeout
	var MAX_TIMER_DELAY = 2147483647;
	
	function selectUnits(delta) {
	    var absDelta = Math.abs(delta);
	
	    if (absDelta < MINUTE) {
	        return 'second';
	    }
	
	    if (absDelta < HOUR) {
	        return 'minute';
	    }
	
	    if (absDelta < DAY) {
	        return 'hour';
	    }
	
	    // The maximum scheduled delay will be measured in days since the maximum
	    // timer delay is less than the number of milliseconds in 25 days.
	    return 'day';
	}
	
	function getUnitDelay(units) {
	    switch (units) {
	        case 'second':
	            return SECOND;
	        case 'minute':
	            return MINUTE;
	        case 'hour':
	            return HOUR;
	        case 'day':
	            return DAY;
	        default:
	            return MAX_TIMER_DELAY;
	    }
	}
	
	function isSameDate(a, b) {
	    if (a === b) {
	        return true;
	    }
	
	    var aTime = new Date(a).getTime();
	    var bTime = new Date(b).getTime();
	
	    return isFinite(aTime) && isFinite(bTime) && aTime === bTime;
	}
	
	var FormattedRelative = function (_Component) {
	    inherits(FormattedRelative, _Component);
	
	    function FormattedRelative(props, context) {
	        classCallCheck(this, FormattedRelative);
	
	        var _this = possibleConstructorReturn(this, (FormattedRelative.__proto__ || Object.getPrototypeOf(FormattedRelative)).call(this, props, context));
	
	        invariantIntlContext(context);
	
	        var now = isFinite(props.initialNow) ? Number(props.initialNow) : context.intl.now();
	
	        // `now` is stored as state so that `render()` remains a function of
	        // props + state, instead of accessing `Date.now()` inside `render()`.
	        _this.state = { now: now };
	        return _this;
	    }
	
	    createClass(FormattedRelative, [{
	        key: 'scheduleNextUpdate',
	        value: function scheduleNextUpdate(props, state) {
	            var _this2 = this;
	
	            // Cancel and pending update because we're scheduling a new update.
	            clearTimeout(this._timer);
	
	            var value = props.value,
	                units = props.units,
	                updateInterval = props.updateInterval;
	
	            var time = new Date(value).getTime();
	
	            // If the `updateInterval` is falsy, including `0` or we don't have a
	            // valid date, then auto updates have been turned off, so we bail and
	            // skip scheduling an update.
	            if (!updateInterval || !isFinite(time)) {
	                return;
	            }
	
	            var delta = time - state.now;
	            var unitDelay = getUnitDelay(units || selectUnits(delta));
	            var unitRemainder = Math.abs(delta % unitDelay);
	
	            // We want the largest possible timer delay which will still display
	            // accurate information while reducing unnecessary re-renders. The delay
	            // should be until the next "interesting" moment, like a tick from
	            // "1 minute ago" to "2 minutes ago" when the delta is 120,000ms.
	            var delay = delta < 0 ? Math.max(updateInterval, unitDelay - unitRemainder) : Math.max(updateInterval, unitRemainder);
	
	            this._timer = setTimeout(function () {
	                _this2.setState({ now: _this2.context.intl.now() });
	            }, delay);
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.scheduleNextUpdate(this.props, this.state);
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(_ref) {
	            var nextValue = _ref.value;
	
	            // When the `props.value` date changes, `state.now` needs to be updated,
	            // and the next update can be rescheduled.
	            if (!isSameDate(nextValue, this.props.value)) {
	                this.setState({ now: this.context.intl.now() });
	            }
	        }
	    }, {
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate() {
	            for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
	                next[_key] = arguments[_key];
	            }
	
	            return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
	        }
	    }, {
	        key: 'componentWillUpdate',
	        value: function componentWillUpdate(nextProps, nextState) {
	            this.scheduleNextUpdate(nextProps, nextState);
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            clearTimeout(this._timer);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _context$intl = this.context.intl,
	                formatRelative = _context$intl.formatRelative,
	                Text = _context$intl.textComponent;
	            var _props = this.props,
	                value = _props.value,
	                children = _props.children;
	
	
	            var formattedRelative = formatRelative(value, _extends({}, this.props, this.state));
	
	            if (typeof children === 'function') {
	                return children(formattedRelative);
	            }
	
	            return React__default.createElement(
	                Text,
	                null,
	                formattedRelative
	            );
	        }
	    }]);
	    return FormattedRelative;
	}(React.Component);
	
	FormattedRelative.displayName = 'FormattedRelative';
	FormattedRelative.contextTypes = {
	    intl: intlShape
	};
	FormattedRelative.defaultProps = {
	    updateInterval: 1000 * 10
	};
	 false ? FormattedRelative.propTypes = _extends({}, relativeFormatPropTypes, {
	    value: PropTypes.any.isRequired,
	    format: PropTypes.string,
	    updateInterval: PropTypes.number,
	    initialNow: PropTypes.any,
	    children: PropTypes.func
	}) : void 0;
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	var FormattedNumber = function (_Component) {
	    inherits(FormattedNumber, _Component);
	
	    function FormattedNumber(props, context) {
	        classCallCheck(this, FormattedNumber);
	
	        var _this = possibleConstructorReturn(this, (FormattedNumber.__proto__ || Object.getPrototypeOf(FormattedNumber)).call(this, props, context));
	
	        invariantIntlContext(context);
	        return _this;
	    }
	
	    createClass(FormattedNumber, [{
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate() {
	            for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
	                next[_key] = arguments[_key];
	            }
	
	            return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _context$intl = this.context.intl,
	                formatNumber = _context$intl.formatNumber,
	                Text = _context$intl.textComponent;
	            var _props = this.props,
	                value = _props.value,
	                children = _props.children;
	
	
	            var formattedNumber = formatNumber(value, this.props);
	
	            if (typeof children === 'function') {
	                return children(formattedNumber);
	            }
	
	            return React__default.createElement(
	                Text,
	                null,
	                formattedNumber
	            );
	        }
	    }]);
	    return FormattedNumber;
	}(React.Component);
	
	FormattedNumber.displayName = 'FormattedNumber';
	FormattedNumber.contextTypes = {
	    intl: intlShape
	};
	 false ? FormattedNumber.propTypes = _extends({}, numberFormatPropTypes, {
	    value: PropTypes.any.isRequired,
	    format: PropTypes.string,
	    children: PropTypes.func
	}) : void 0;
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	var FormattedPlural = function (_Component) {
	    inherits(FormattedPlural, _Component);
	
	    function FormattedPlural(props, context) {
	        classCallCheck(this, FormattedPlural);
	
	        var _this = possibleConstructorReturn(this, (FormattedPlural.__proto__ || Object.getPrototypeOf(FormattedPlural)).call(this, props, context));
	
	        invariantIntlContext(context);
	        return _this;
	    }
	
	    createClass(FormattedPlural, [{
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate() {
	            for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
	                next[_key] = arguments[_key];
	            }
	
	            return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _context$intl = this.context.intl,
	                formatPlural = _context$intl.formatPlural,
	                Text = _context$intl.textComponent;
	            var _props = this.props,
	                value = _props.value,
	                other = _props.other,
	                children = _props.children;
	
	
	            var pluralCategory = formatPlural(value, this.props);
	            var formattedPlural = this.props[pluralCategory] || other;
	
	            if (typeof children === 'function') {
	                return children(formattedPlural);
	            }
	
	            return React__default.createElement(
	                Text,
	                null,
	                formattedPlural
	            );
	        }
	    }]);
	    return FormattedPlural;
	}(React.Component);
	
	FormattedPlural.displayName = 'FormattedPlural';
	FormattedPlural.contextTypes = {
	    intl: intlShape
	};
	FormattedPlural.defaultProps = {
	    style: 'cardinal'
	};
	 false ? FormattedPlural.propTypes = _extends({}, pluralFormatPropTypes, {
	    value: PropTypes.any.isRequired,
	
	    other: PropTypes.node.isRequired,
	    zero: PropTypes.node,
	    one: PropTypes.node,
	    two: PropTypes.node,
	    few: PropTypes.node,
	    many: PropTypes.node,
	
	    children: PropTypes.func
	}) : void 0;
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	var FormattedMessage = function (_Component) {
	    inherits(FormattedMessage, _Component);
	
	    function FormattedMessage(props, context) {
	        classCallCheck(this, FormattedMessage);
	
	        var _this = possibleConstructorReturn(this, (FormattedMessage.__proto__ || Object.getPrototypeOf(FormattedMessage)).call(this, props, context));
	
	        invariantIntlContext(context);
	        return _this;
	    }
	
	    createClass(FormattedMessage, [{
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate(nextProps) {
	            var values = this.props.values;
	            var nextValues = nextProps.values;
	
	
	            if (!shallowEquals(nextValues, values)) {
	                return true;
	            }
	
	            // Since `values` has already been checked, we know they're not
	            // different, so the current `values` are carried over so the shallow
	            // equals comparison on the other props isn't affected by the `values`.
	            var nextPropsToCheck = _extends({}, nextProps, {
	                values: values
	            });
	
	            for (var _len = arguments.length, next = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	                next[_key - 1] = arguments[_key];
	            }
	
	            return shouldIntlComponentUpdate.apply(undefined, [this, nextPropsToCheck].concat(next));
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _context$intl = this.context.intl,
	                formatMessage = _context$intl.formatMessage,
	                Text = _context$intl.textComponent;
	            var _props = this.props,
	                id = _props.id,
	                description = _props.description,
	                defaultMessage = _props.defaultMessage,
	                values = _props.values,
	                _props$tagName = _props.tagName,
	                Component$$1 = _props$tagName === undefined ? Text : _props$tagName,
	                children = _props.children;
	
	
	            var tokenDelimiter = void 0;
	            var tokenizedValues = void 0;
	            var elements = void 0;
	
	            var hasValues = values && Object.keys(values).length > 0;
	            if (hasValues) {
	                // Creates a token with a random UID that should not be guessable or
	                // conflict with other parts of the `message` string.
	                var uid = Math.floor(Math.random() * 0x10000000000).toString(16);
	
	                var generateToken = function () {
	                    var counter = 0;
	                    return function () {
	                        return 'ELEMENT-' + uid + '-' + (counter += 1);
	                    };
	                }();
	
	                // Splitting with a delimiter to support IE8. When using a regex
	                // with a capture group IE8 does not include the capture group in
	                // the resulting array.
	                tokenDelimiter = '@__' + uid + '__@';
	                tokenizedValues = {};
	                elements = {};
	
	                // Iterates over the `props` to keep track of any React Element
	                // values so they can be represented by the `token` as a placeholder
	                // when the `message` is formatted. This allows the formatted
	                // message to then be broken-up into parts with references to the
	                // React Elements inserted back in.
	                Object.keys(values).forEach(function (name) {
	                    var value = values[name];
	
	                    if (React.isValidElement(value)) {
	                        var token = generateToken();
	                        tokenizedValues[name] = tokenDelimiter + token + tokenDelimiter;
	                        elements[token] = value;
	                    } else {
	                        tokenizedValues[name] = value;
	                    }
	                });
	            }
	
	            var descriptor = { id: id, description: description, defaultMessage: defaultMessage };
	            var formattedMessage = formatMessage(descriptor, tokenizedValues || values);
	
	            var nodes = void 0;
	
	            var hasElements = elements && Object.keys(elements).length > 0;
	            if (hasElements) {
	                // Split the message into parts so the React Element values captured
	                // above can be inserted back into the rendered message. This
	                // approach allows messages to render with React Elements while
	                // keeping React's virtual diffing working properly.
	                nodes = formattedMessage.split(tokenDelimiter).filter(function (part) {
	                    return !!part;
	                }).map(function (part) {
	                    return elements[part] || part;
	                });
	            } else {
	                nodes = [formattedMessage];
	            }
	
	            if (typeof children === 'function') {
	                return children.apply(undefined, toConsumableArray(nodes));
	            }
	
	            // Needs to use `createElement()` instead of JSX, otherwise React will
	            // warn about a missing `key` prop with rich-text message formatting.
	            return React.createElement.apply(undefined, [Component$$1, null].concat(toConsumableArray(nodes)));
	        }
	    }]);
	    return FormattedMessage;
	}(React.Component);
	
	FormattedMessage.displayName = 'FormattedMessage';
	FormattedMessage.contextTypes = {
	    intl: intlShape
	};
	FormattedMessage.defaultProps = {
	    values: {}
	};
	 false ? FormattedMessage.propTypes = _extends({}, messageDescriptorPropTypes, {
	    values: PropTypes.object,
	    tagName: PropTypes.string,
	    children: PropTypes.func
	}) : void 0;
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	var FormattedHTMLMessage = function (_Component) {
	    inherits(FormattedHTMLMessage, _Component);
	
	    function FormattedHTMLMessage(props, context) {
	        classCallCheck(this, FormattedHTMLMessage);
	
	        var _this = possibleConstructorReturn(this, (FormattedHTMLMessage.__proto__ || Object.getPrototypeOf(FormattedHTMLMessage)).call(this, props, context));
	
	        invariantIntlContext(context);
	        return _this;
	    }
	
	    createClass(FormattedHTMLMessage, [{
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate(nextProps) {
	            var values = this.props.values;
	            var nextValues = nextProps.values;
	
	
	            if (!shallowEquals(nextValues, values)) {
	                return true;
	            }
	
	            // Since `values` has already been checked, we know they're not
	            // different, so the current `values` are carried over so the shallow
	            // equals comparison on the other props isn't affected by the `values`.
	            var nextPropsToCheck = _extends({}, nextProps, {
	                values: values
	            });
	
	            for (var _len = arguments.length, next = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	                next[_key - 1] = arguments[_key];
	            }
	
	            return shouldIntlComponentUpdate.apply(undefined, [this, nextPropsToCheck].concat(next));
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _context$intl = this.context.intl,
	                formatHTMLMessage = _context$intl.formatHTMLMessage,
	                Text = _context$intl.textComponent;
	            var _props = this.props,
	                id = _props.id,
	                description = _props.description,
	                defaultMessage = _props.defaultMessage,
	                rawValues = _props.values,
	                _props$tagName = _props.tagName,
	                Component$$1 = _props$tagName === undefined ? Text : _props$tagName,
	                children = _props.children;
	
	
	            var descriptor = { id: id, description: description, defaultMessage: defaultMessage };
	            var formattedHTMLMessage = formatHTMLMessage(descriptor, rawValues);
	
	            if (typeof children === 'function') {
	                return children(formattedHTMLMessage);
	            }
	
	            // Since the message presumably has HTML in it, we need to set
	            // `innerHTML` in order for it to be rendered and not escaped by React.
	            // To be safe, all string prop values were escaped when formatting the
	            // message. It is assumed that the message is not UGC, and came from the
	            // developer making it more like a template.
	            //
	            // Note: There's a perf impact of using this component since there's no
	            // way for React to do its virtual DOM diffing.
	            var html = { __html: formattedHTMLMessage };
	            return React__default.createElement(Component$$1, { dangerouslySetInnerHTML: html });
	        }
	    }]);
	    return FormattedHTMLMessage;
	}(React.Component);
	
	FormattedHTMLMessage.displayName = 'FormattedHTMLMessage';
	FormattedHTMLMessage.contextTypes = {
	    intl: intlShape
	};
	FormattedHTMLMessage.defaultProps = {
	    values: {}
	};
	 false ? FormattedHTMLMessage.propTypes = _extends({}, messageDescriptorPropTypes, {
	    values: PropTypes.object,
	    tagName: PropTypes.string,
	    children: PropTypes.func
	}) : void 0;
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	addLocaleData(defaultLocaleData);
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	addLocaleData(allLocaleData);
	
	exports.addLocaleData = addLocaleData;
	exports.intlShape = intlShape;
	exports.injectIntl = injectIntl;
	exports.defineMessages = defineMessages;
	exports.IntlProvider = IntlProvider;
	exports.FormattedDate = FormattedDate;
	exports.FormattedTime = FormattedTime;
	exports.FormattedRelative = FormattedRelative;
	exports.FormattedNumber = FormattedNumber;
	exports.FormattedPlural = FormattedPlural;
	exports.FormattedMessage = FormattedMessage;
	exports.FormattedHTMLMessage = FormattedHTMLMessage;


/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
		Copyright (c) 2018 Jed Watson.
		Licensed under the MIT License (MIT), see
		http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
		var nativeCodeString = '[native code]';
	
		function classNames() {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg)) {
					if (arg.length) {
						var inner = classNames.apply(null, arg);
						if (inner) {
							classes.push(inner);
						}
					}
				} else if (argType === 'object') {
					if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
						classes.push(arg.toString());
						continue;
					}
	
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			classNames.default = classNames;
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ },
/* 13 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = buildLocalizeFn;
	
	function buildLocalizeFn(args) {
	  return function (dirtyIndex, dirtyOptions) {
	    var options = dirtyOptions || {};
	    var context = options.context ? String(options.context) : 'standalone';
	    var valuesArray;
	
	    if (context === 'formatting' && args.formattingValues) {
	      var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
	      var width = options.width ? String(options.width) : defaultWidth;
	      valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
	    } else {
	      var _defaultWidth = args.defaultWidth;
	
	      var _width = options.width ? String(options.width) : args.defaultWidth;
	
	      valuesArray = args.values[_width] || args.values[_defaultWidth];
	    }
	
	    var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex; // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
	
	    return valuesArray[index];
	  };
	}
	
	module.exports = exports.default;

/***/ },
/* 14 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = buildMatchFn;
	
	function buildMatchFn(args) {
	  return function (string) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var width = options.width;
	    var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
	    var matchResult = string.match(matchPattern);
	
	    if (!matchResult) {
	      return null;
	    }
	
	    var matchedString = matchResult[0];
	    var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
	    var key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, function (pattern) {
	      return pattern.test(matchedString);
	    }) : findKey(parsePatterns, function (pattern) {
	      return pattern.test(matchedString);
	    });
	    var value;
	    value = args.valueCallback ? args.valueCallback(key) : key;
	    value = options.valueCallback ? options.valueCallback(value) : value;
	    var rest = string.slice(matchedString.length);
	    return {
	      value: value,
	      rest: rest
	    };
	  };
	}
	
	function findKey(object, predicate) {
	  for (var key in object) {
	    if (object.hasOwnProperty(key) && predicate(object[key])) {
	      return key;
	    }
	  }
	
	  return undefined;
	}
	
	function findIndex(array, predicate) {
	  for (var key = 0; key < array.length; key++) {
	    if (predicate(array[key])) {
	      return key;
	    }
	  }
	
	  return undefined;
	}
	
	module.exports = exports.default;

/***/ },
/* 15 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = buildMatchPatternFn;
	
	function buildMatchPatternFn(args) {
	  return function (string) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var matchResult = string.match(args.matchPattern);
	    if (!matchResult) return null;
	    var matchedString = matchResult[0];
	    var parseResult = string.match(args.parsePattern);
	    if (!parseResult) return null;
	    var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
	    value = options.valueCallback ? options.valueCallback(value) : value;
	    var rest = string.slice(matchedString.length);
	    return {
	      value: value,
	      rest: rest
	    };
	  };
	}
	
	module.exports = exports.default;

/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.prefix = prefix;
	exports.getClassSet = getClassSet;
	exports.splitBsProps = splitBsProps;
	exports.splitBsPropsAndOmit = splitBsPropsAndOmit;
	exports.addStyle = addStyle;
	exports._curry = exports.bsSizes = exports.bsStyles = exports.bsClass = void 0;
	
	var _entries = _interopRequireDefault(__webpack_require__(341));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(8));
	
	var _invariant = _interopRequireDefault(__webpack_require__(37));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _StyleConfig = __webpack_require__(50);
	
	// TODO: The publicly exposed parts of this should be in lib/BootstrapUtils.
	function curry(fn) {
	  return function () {
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var last = args[args.length - 1];
	
	    if (typeof last === 'function') {
	      return fn.apply(void 0, args);
	    }
	
	    return function (Component) {
	      return fn.apply(void 0, args.concat([Component]));
	    };
	  };
	}
	
	function prefix(props, variant) {
	  var bsClass = (props.bsClass || '').trim();
	  !(bsClass != null) ?  false ? (0, _invariant.default)(false, 'A `bsClass` prop is required for this component') : invariant(false) : void 0;
	  return bsClass + (variant ? "-" + variant : '');
	}
	
	var bsClass = curry(function (defaultClass, Component) {
	  var propTypes = Component.propTypes || (Component.propTypes = {});
	  var defaultProps = Component.defaultProps || (Component.defaultProps = {});
	  propTypes.bsClass = _propTypes.default.string;
	  defaultProps.bsClass = defaultClass;
	  return Component;
	});
	exports.bsClass = bsClass;
	var bsStyles = curry(function (styles, defaultStyle, Component) {
	  if (typeof defaultStyle !== 'string') {
	    Component = defaultStyle;
	    defaultStyle = undefined;
	  }
	
	  var existing = Component.STYLES || [];
	  var propTypes = Component.propTypes || {};
	  styles.forEach(function (style) {
	    if (existing.indexOf(style) === -1) {
	      existing.push(style);
	    }
	  });
	
	  var propType = _propTypes.default.oneOf(existing); // expose the values on the propType function for documentation
	
	
	  Component.STYLES = existing;
	  propType._values = existing;
	  Component.propTypes = (0, _extends2.default)({}, propTypes, {
	    bsStyle: propType
	  });
	
	  if (defaultStyle !== undefined) {
	    var defaultProps = Component.defaultProps || (Component.defaultProps = {});
	    defaultProps.bsStyle = defaultStyle;
	  }
	
	  return Component;
	});
	exports.bsStyles = bsStyles;
	var bsSizes = curry(function (sizes, defaultSize, Component) {
	  if (typeof defaultSize !== 'string') {
	    Component = defaultSize;
	    defaultSize = undefined;
	  }
	
	  var existing = Component.SIZES || [];
	  var propTypes = Component.propTypes || {};
	  sizes.forEach(function (size) {
	    if (existing.indexOf(size) === -1) {
	      existing.push(size);
	    }
	  });
	  var values = [];
	  existing.forEach(function (size) {
	    var mappedSize = _StyleConfig.SIZE_MAP[size];
	
	    if (mappedSize && mappedSize !== size) {
	      values.push(mappedSize);
	    }
	
	    values.push(size);
	  });
	
	  var propType = _propTypes.default.oneOf(values);
	
	  propType._values = values; // expose the values on the propType function for documentation
	
	  Component.SIZES = existing;
	  Component.propTypes = (0, _extends2.default)({}, propTypes, {
	    bsSize: propType
	  });
	
	  if (defaultSize !== undefined) {
	    if (!Component.defaultProps) {
	      Component.defaultProps = {};
	    }
	
	    Component.defaultProps.bsSize = defaultSize;
	  }
	
	  return Component;
	});
	exports.bsSizes = bsSizes;
	
	function getClassSet(props) {
	  var _classes;
	
	  var classes = (_classes = {}, _classes[prefix(props)] = true, _classes);
	
	  if (props.bsSize) {
	    var bsSize = _StyleConfig.SIZE_MAP[props.bsSize] || props.bsSize;
	    classes[prefix(props, bsSize)] = true;
	  }
	
	  if (props.bsStyle) {
	    classes[prefix(props, props.bsStyle)] = true;
	  }
	
	  return classes;
	}
	
	function getBsProps(props) {
	  return {
	    bsClass: props.bsClass,
	    bsSize: props.bsSize,
	    bsStyle: props.bsStyle,
	    bsRole: props.bsRole
	  };
	}
	
	function isBsProp(propName) {
	  return propName === 'bsClass' || propName === 'bsSize' || propName === 'bsStyle' || propName === 'bsRole';
	}
	
	function splitBsProps(props) {
	  var elementProps = {};
	  (0, _entries.default)(props).forEach(function (_ref) {
	    var propName = _ref[0],
	        propValue = _ref[1];
	
	    if (!isBsProp(propName)) {
	      elementProps[propName] = propValue;
	    }
	  });
	  return [getBsProps(props), elementProps];
	}
	
	function splitBsPropsAndOmit(props, omittedPropNames) {
	  var isOmittedProp = {};
	  omittedPropNames.forEach(function (propName) {
	    isOmittedProp[propName] = true;
	  });
	  var elementProps = {};
	  (0, _entries.default)(props).forEach(function (_ref2) {
	    var propName = _ref2[0],
	        propValue = _ref2[1];
	
	    if (!isBsProp(propName) && !isOmittedProp[propName]) {
	      elementProps[propName] = propValue;
	    }
	  });
	  return [getBsProps(props), elementProps];
	}
	/**
	 * Add a style variant to a Component. Mutates the propTypes of the component
	 * in order to validate the new variant.
	 */
	
	
	function addStyle(Component) {
	  for (var _len2 = arguments.length, styleVariant = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	    styleVariant[_key2 - 1] = arguments[_key2];
	  }
	
	  bsStyles(styleVariant)(Component);
	}
	
	var _curry = curry;
	exports._curry = _curry;

/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.operate = exports.hasLift = void 0;
	var isFunction_1 = __webpack_require__(31);
	function hasLift(source) {
	    return isFunction_1.isFunction(source === null || source === void 0 ? void 0 : source.lift);
	}
	exports.hasLift = hasLift;
	function operate(init) {
	    return function (source) {
	        if (hasLift(source)) {
	            return source.lift(function (liftedSource) {
	                try {
	                    return init(liftedSource, this);
	                }
	                catch (err) {
	                    this.error(err);
	                }
	            });
	        }
	        throw new TypeError('Unable to lift unknown Observable type');
	    };
	}
	exports.operate = operate;
	//# sourceMappingURL=lift.js.map

/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	var _interopRequireWildcard = __webpack_require__(48);
	
	exports.__esModule = true;
	
	var _Provider = _interopRequireWildcard(__webpack_require__(1874));
	
	exports.Provider = _Provider.default;
	exports.createProvider = _Provider.createProvider;
	
	var _connectAdvanced = _interopRequireDefault(__webpack_require__(531));
	
	exports.connectAdvanced = _connectAdvanced.default;
	
	var _connect = _interopRequireDefault(__webpack_require__(1875));
	
	exports.connect = _connect.default;

/***/ },
/* 19 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = toInteger;
	
	function toInteger(dirtyNumber) {
	  if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
	    return NaN;
	  }
	
	  var number = Number(dirtyNumber);
	
	  if (isNaN(number)) {
	    return number;
	  }
	
	  return number < 0 ? Math.ceil(number) : Math.floor(number);
	}
	
	module.exports = exports.default;

/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        if (typeof b !== "function" && b !== null)
	            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.OperatorSubscriber = exports.createOperatorSubscriber = void 0;
	var Subscriber_1 = __webpack_require__(164);
	function createOperatorSubscriber(destination, onNext, onComplete, onError, onFinalize) {
	    return new OperatorSubscriber(destination, onNext, onComplete, onError, onFinalize);
	}
	exports.createOperatorSubscriber = createOperatorSubscriber;
	var OperatorSubscriber = (function (_super) {
	    __extends(OperatorSubscriber, _super);
	    function OperatorSubscriber(destination, onNext, onComplete, onError, onFinalize, shouldUnsubscribe) {
	        var _this = _super.call(this, destination) || this;
	        _this.onFinalize = onFinalize;
	        _this.shouldUnsubscribe = shouldUnsubscribe;
	        _this._next = onNext
	            ? function (value) {
	                try {
	                    onNext(value);
	                }
	                catch (err) {
	                    destination.error(err);
	                }
	            }
	            : _super.prototype._next;
	        _this._error = onError
	            ? function (err) {
	                try {
	                    onError(err);
	                }
	                catch (err) {
	                    destination.error(err);
	                }
	                finally {
	                    this.unsubscribe();
	                }
	            }
	            : _super.prototype._error;
	        _this._complete = onComplete
	            ? function () {
	                try {
	                    onComplete();
	                }
	                catch (err) {
	                    destination.error(err);
	                }
	                finally {
	                    this.unsubscribe();
	                }
	            }
	            : _super.prototype._complete;
	        return _this;
	    }
	    OperatorSubscriber.prototype.unsubscribe = function () {
	        var _a;
	        if (!this.shouldUnsubscribe || this.shouldUnsubscribe()) {
	            var closed_1 = this.closed;
	            _super.prototype.unsubscribe.call(this);
	            !closed_1 && ((_a = this.onFinalize) === null || _a === void 0 ? void 0 : _a.call(this));
	        }
	    };
	    return OperatorSubscriber;
	}(Subscriber_1.Subscriber));
	exports.OperatorSubscriber = OperatorSubscriber;
	//# sourceMappingURL=OperatorSubscriber.js.map

/***/ },
/* 21 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var APP_ACTIONS = {
	    DISPLAY_LOADER: 'DISPLAY_LOADER',
	    HIDE_LOADER: 'HIDE_LOADER',
	    ADD_ERROR: 'ADD_ERROR',
	
	    ADD_PRODUCTS: 'ADD_PRODUCTS',
	    APPEND_PRODUCTS: 'APPEND_PRODUCTS',
	    ADD_PRODUCT: 'ADD_PRODUCT',
	    ADD_PLACED_ORDER: 'ADD_PLACED_ORDER',
	    DESTROY_PLACED_ORDER: 'DESTROY_PLACED_ORDER',
	    ADD_PRODUCTS_FROM_ALL_STORES: 'ALL_PRODUCTS_FROM_ALL_STORES',
	
	    ADD_ORDERS: 'ADD_ORDERS',
	    ADD_ORDER: 'ADD_ORDER',
	
	    ADD_ORDER_ERROR: 'ADD_ORDER_ERROR',
	    COMPLETE_ORDER_ERROR: 'COMPLETE_ORDER_ERROR',
	    COMPLETE_ORDER_ERROR_HIDE_DIALOG: 'COMPLETE_ORDER_ERROR_HIDE_DIALOG',
	
	    ADD_PAYMENT_METHOD: 'ADD_PAYMENT_METHOD',
	    ADD_REDSYS_PAYMENT_INFO: 'ADD_REDSYS_PAYMENT_INFO',
	    ADD_REDSYS_PAYMENT_ERROR: 'ADD_REDSYS_PAYMENT_ERROR',
	
	    ADD_TAXONS: 'ADD_TAXONS',
	    ADD_KATAPULK_NAVIGATION: 'ADD_KATAPULK_NAVIGATION',
	    ADD_SEARCH_TAXONS: 'ADD_SEARCH_TAXONS',
	
	    ADD_STORES: 'ADD_STORES',
	    ADD_STORES_BY_ZONE: 'ADD_STORES_BY_ZONE',
	    ADD_STORES_GROUPED: 'ADD_STORES_GROUPED',
	    SET_CURRENT_STORE: 'SET_CURRENT_STORE',
	
	    CREATE_ORDER: 'CREATE_ORDER',
	    UPDATE_ORDER: 'UPDATE_ORDER',
	    ADD_PRODUCT_TO_CART: 'ADD_PRODUCT_TO_CART',
	    ADDING_PRODUCT_TO_CART: 'ADDING_PRODUCT_TO_CART',
	    ADDING_PRODUCT_TO_CART_TO_FIX: 'ADDING_PRODUCT_TO_CART_TO_FIX',
	    REMOVING_PRODUCT_TO_CART: 'REMOVING_PRODUCT_TO_CART',
	    DISABLING_ADD: 'DISABLING_ADD',
	    DESTROY_ORDER: 'DESTROY_ORDER',
	    COMPLETE_ORDER: 'COMPLETE_ORDER',
	    REMOVE_LINE_ITEM: 'REMOVE_LINE_ITEM',
	    REMOVE_DATA_EXTRA_ITEM: 'REMOVE_DATA_EXTRA_ITEM',
	    UPDATE_LINE_ITEM: 'UPDATE_LINE_ITEM',
	    VALIDATE_CREDIT_CARD: 'VALIDATE_CREDIT_CARD',
	
	    ADD_COUNTRIES_SHIPPING: 'ADD_COUNTRIES_SHIPPING',
	    ADD_COUNTRIES_BILLING: 'ADD_COUNTRIES_BILLING',
	
	    SET_CURRENT_CHECKOUT_STEP: 'SET_CURRENT_CHECKOUT_STEP',
	    CLEAR_CURRENT_CHECKOUT_STEP: 'CLEAR_CURRENT_CHECKOUT_STEP',
	
	    SET_FETCHING_DATA: 'SET_FETCHING_DATA',
	
	    SET_LOCALE: 'SET_LOCALE',
	    SET_AVAILABLE_ZONES: 'SET_AVAILABLE_ZONES',
	    SET_CURRENT_ZONE: 'SET_CURRENT_ZONE',
	
	    SET_AVAILABLE_MUNICIPALITIES: 'SET_AVAILABLE_MUNICIPALITIES',
	    SET_CURRENT_MUNICIPALITY: 'SET_CURRENT_MUNICIPALITY',
	    SET_IS_MUNICIPALITY_PROMPT_MODAL_OPEN: 'SET_IS_MUNICIPALITY_PROMPT_MODAL_OPEN',
	
	    LOGIN: 'LOGIN',
	    LOGOUT: 'LOGOUT',
	    USER: 'USER',
	    REMOVE_USER: 'REMOVE_USER',
	    ANONYMOUS_USER_AGE_VALID: 'ANONYMOUS_USER_AGE_VALID',
	
	    SET_ACTIVE_CART: 'SET_ACTIVE_CART',
	    SET_CONFIGS_ACTIVE_CART: 'SET_CONFIGS_ACTIVE_CART',
	    UPDATE_MINUTES_TIME_LEFT_CART: 'UPDATE_MINUTES_TIME_LEFT_CART',
	    UPDATE_SECONDS_TIME_LEFT_CART: 'UPDATE_SECONDS_TIME_LEFT_CART',
	    SET_LAST_ALERT_TIME_LEFT_CART: 'SET_LAST_ALERT_TIME_LEFT_CART',
	    SET_EXTRA_TIME_CHECKOUT: 'SET_EXTRA_TIME_CHECKOUT',
	
	    SET_BACKGROUND_DISABLED: 'SET_BACKGROUND_DISABLED',
	    SET_IS_FINAL_STEP_HAPPENING: 'SET_IS_FINAL_STEP_HAPPENING',
	
	    SYNC_ORDER_FROM_STORAGE: 'SYNC_ORDER_FROM_STORAGE',
	
	    CONFIG_SET_MULTI_COUNTRY_SHIPPING: 'CONFIG_SET_MULTI_COUNTRY_SHIPPING',
	    SET_BACKEND_CONFIG: 'SET_BACKEND_CONFIG',
	
	    ERRORS_LINE_ITEMS: 'ERRORS_LINE_ITEMS',
	    CLEAR_ERRORS_LINE_ITEMS: 'CLEAR_ERRORS_LINE_ITEMS',
	
	    UPDATE_WALLETS: 'UPDATE_WALLETS',
	    CLEAR_WALLETS: 'CLEAR_WALLETS'
	};
	
	exports.default = APP_ACTIONS;

/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _objectUtils = __webpack_require__(815);
	
	var _objectUtils2 = _interopRequireDefault(_objectUtils);
	
	var _configs = __webpack_require__(175);
	
	var _configs2 = _interopRequireDefault(_configs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var APP_ROUTES = {
	    homePageRoute: '/',
	    comingSoon: '/coming',
	    classifiedAds: '/classified-ads',
	    mercadoUnicoProducts: _configs2.default.ROUTES.ENABLE_MERCADO_UNICO_PRODUCTS ? '/t/mercado-unico' : null,
	    signup: '/signup',
	    signin: '/signin',
	    sendEmail: '/forgot-password',
	    forgot: '/forgot',
	    frequentQuestions: '/frequent-questions',
	    profile: '/profile',
	    taxonomies: '/t/',
	    orders: '/orders',
	    conversations: '/conversations',
	    notifications: '/notifications',
	    about: '/about',
	    contact: '/contact',
	    sitemap: '/site-map',
	    faqs: '/faqs',
	    terms: '/terms-conditions',
	    affidavitCertification: '/affidavit-certification',
	    policy: '/privacy-policy',
	    returns: '/return-policy',
	    shipping: '/shipping-policy',
	    offers: '/bids-offers',
	    searchPageRoute: '/search',
	    cartPageRoute: '/cart',
	    wishList: '/wish-list',
	    ordersPageRoute: '/orders',
	    products: '/products',
	    manageKWallet: '/manage-k-wallet',
	    addFundsKWallet: '/add-funds-k-wallet',
	    checkout: {
	        addressPageRoute: '/checkout/address',
	        deliveryPageRoute: '/checkout/delivery',
	        paymentPageRoute: '/checkout/payment',
	        confirmPageRoute: '/checkout/confirm',
	        completePageRoute: '/checkout/complete',
	        failPageRoute: '/checkout/fail',
	        redsysRedirectOk: '/checkout/redsys-ok',
	        redsysRedirectKo: '/checkout/redsys-ko'
	    }
	};
	
	exports.default = _objectUtils2.default.removeEmptyProperties(APP_ROUTES);

/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _products = __webpack_require__(644);
	
	var _products2 = _interopRequireDefault(_products);
	
	var _taxons = __webpack_require__(646);
	
	var _taxons2 = _interopRequireDefault(_taxons);
	
	var _loader = __webpack_require__(235);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _order = __webpack_require__(172);
	
	var _order2 = _interopRequireDefault(_order);
	
	var _orderList = __webpack_require__(643);
	
	var _orderList2 = _interopRequireDefault(_orderList);
	
	var _countries = __webpack_require__(639);
	
	var _countries2 = _interopRequireDefault(_countries);
	
	var _checkout = __webpack_require__(638);
	
	var _checkout2 = _interopRequireDefault(_checkout);
	
	var _placedOrder = __webpack_require__(236);
	
	var _placedOrder2 = _interopRequireDefault(_placedOrder);
	
	var _user = __webpack_require__(344);
	
	var _user2 = _interopRequireDefault(_user);
	
	var _locale = __webpack_require__(640);
	
	var _locale2 = _interopRequireDefault(_locale);
	
	var _navigation = __webpack_require__(642);
	
	var _navigation2 = _interopRequireDefault(_navigation);
	
	var _lineItem = __webpack_require__(343);
	
	var _lineItem2 = _interopRequireDefault(_lineItem);
	
	var _error = __webpack_require__(342);
	
	var _error2 = _interopRequireDefault(_error);
	
	var _stores = __webpack_require__(645);
	
	var _stores2 = _interopRequireDefault(_stores);
	
	var _auth = __webpack_require__(636);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _zones = __webpack_require__(648);
	
	var _zones2 = _interopRequireDefault(_zones);
	
	var _anonymousUser = __webpack_require__(635);
	
	var _anonymousUser2 = _interopRequireDefault(_anonymousUser);
	
	var _cartState = __webpack_require__(234);
	
	var _cartState2 = _interopRequireDefault(_cartState);
	
	var _backgroundDisabled = __webpack_require__(637);
	
	var _backgroundDisabled2 = _interopRequireDefault(_backgroundDisabled);
	
	var _municipalities = __webpack_require__(641);
	
	var _municipalities2 = _interopRequireDefault(_municipalities);
	
	var _wallets = __webpack_require__(647);
	
	var _wallets2 = _interopRequireDefault(_wallets);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    addProducts: _products2.default.addProducts,
	    appendProducts: _products2.default.appendProducts,
	    addKatapulkNavigation: _navigation2.default.addKatapulkNavigation,
	    addProduct: _products2.default.addProduct,
	    addAllStoreProducts: _products2.default.addAllStoreProducts,
	    addOrders: _orderList2.default.addOrders,
	    addOrder: _orderList2.default.addOrder,
	    fetchProducts: _products2.default.fetchProducts,
	    fetchAllStoreProducts: _products2.default.fetchAllStoreProducts,
	    addTaxons: _taxons2.default.addTaxons,
	    displayLoader: _loader2.default.displayLoader,
	    hideLoader: _loader2.default.hideLoader,
	    addProductToCart: _order2.default.addProductToCart,
	    addingProductToCart: _order2.default.addingProductToCart,
	    addingProductToCartFix: _order2.default.addingProductToCartFix,
	    removingProductToCart: _order2.default.removingProductToCart,
	    emptyCart: _order2.default.emptyCart,
	    emptyCurrentCart: _order2.default.emptyCurrentCart,
	    clearOrder: _order2.default.clearOrder,
	    updateConfigsActiveCart: _cartState2.default.updateConfigsActiveCart,
	    setTimeMinutesLeft: _cartState2.default.setTimeMinutesLeft,
	    setTimeSecondsLeft: _cartState2.default.setTimeSecondsLeft,
	    setHasExtraTimeCheckout: _cartState2.default.setHasExtraTimeCheckout,
	    fetchStores: _stores2.default.loadStores,
	    fetchStorePayments: _stores2.default.loadStorePayments,
	    getStoresByZone: _stores2.default.getStoresByZone,
	    removeProductFromCart: _order2.default.removeProductFromCart,
	    removeDataExtraFromCart: _order2.default.removeDataExtraFromCart,
	    changeProductQuantityFromCart: _order2.default.changeProductQuantityFromCart,
	    updateOrderInState: _order2.default.updateOrderInState,
	    getById: _order2.default.getById,
	    refreshOrder: _order2.default.refreshOrder,
	    setIsFinalStepHappening: _order2.default.setIsFinalStepHappening,
	    syncOrderFromStorage: _order2.default.syncOrderFromStorage,
	    addShippingCountries: _countries2.default.addShippingCountries,
	    addBillingCountries: _countries2.default.addBillingCountries,
	    goToPrevStep: _checkout2.default.goToPrevStep,
	    goToNextStep: _checkout2.default.goToNextStep,
	    getRedsysInfo: _checkout2.default.getRedsysInfo,
	    addPlacedOrder: _placedOrder2.default.addPlacedOrder,
	    clearPlacedOrder: _placedOrder2.default.clearPlacedOrder,
	    login: _auth2.default.login,
	    logout: _user2.default.logout,
	    authCheckState: _auth2.default.authCheckState,
	    setLocale: _locale2.default.setLocale,
	    addLineItem: _lineItem2.default.addLineItem,
	    disablingAdd: _lineItem2.default.disablingAdd,
	    doError: _error2.default.doError,
	    setCurrentStore: _stores2.default.setCurrentStore,
	    loadGroupedStores: _stores2.default.loadGroupedStores,
	    setAvailableZones: _zones2.default.setAvailableZones,
	    setCurrentZone: _zones2.default.setCurrentZone,
	    setAvailableMunicipalities: _municipalities2.default.setAvailableMunicipalities,
	    setCurrentMunicipality: _municipalities2.default.setCurrentMunicipality,
	    setIsMunicipalityPromptModalOpen: _municipalities2.default.setIsMunicipalityPromptModalOpen,
	    setAnonymousUserAgeValid: _anonymousUser2.default.setAnonymousUserAgeValid,
	    setAgeValid: _user2.default.setAgeValid,
	    addRedsysPaymentError: _checkout2.default.addRedsysPaymentError,
	    setBackgroundDisabled: _backgroundDisabled2.default.setBackgroundDisabled,
	    // wallets
	    fetchWalletTransactions: _wallets2.default.fetchWalletTransactions,
	    fetchWalletDetails: _wallets2.default.fetchWalletDetails,
	    activeWallet: _wallets2.default.activeWallet,
	    activateWallet: _wallets2.default.activateWallet,
	    transferWalletFunds: _wallets2.default.transferWalletFunds
	};

/***/ },
/* 24 */
/***/ function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function() {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};


/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(window.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0,
		styleElementsInsertedAtTop = [];
	
	module.exports = function(list, options) {
		if(false) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
		// By default, add <style> tags to the bottom of <head>.
		if (typeof options.insertAt === "undefined") options.insertAt = "bottom";
	
		var styles = listToStyles(list);
		addStylesToDom(styles, options);
	
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}
	
	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function insertStyleElement(options, styleElement) {
		var head = getHeadElement();
		var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
		if (options.insertAt === "top") {
			if(!lastStyleElementInsertedAtTop) {
				head.insertBefore(styleElement, head.firstChild);
			} else if(lastStyleElementInsertedAtTop.nextSibling) {
				head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
			} else {
				head.appendChild(styleElement);
			}
			styleElementsInsertedAtTop.push(styleElement);
		} else if (options.insertAt === "bottom") {
			head.appendChild(styleElement);
		} else {
			throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
		}
	}
	
	function removeStyleElement(styleElement) {
		styleElement.parentNode.removeChild(styleElement);
		var idx = styleElementsInsertedAtTop.indexOf(styleElement);
		if(idx >= 0) {
			styleElementsInsertedAtTop.splice(idx, 1);
		}
	}
	
	function createStyleElement(options) {
		var styleElement = document.createElement("style");
		styleElement.type = "text/css";
		insertStyleElement(options, styleElement);
		return styleElement;
	}
	
	function createLinkElement(options) {
		var linkElement = document.createElement("link");
		linkElement.rel = "stylesheet";
		insertStyleElement(options, linkElement);
		return linkElement;
	}
	
	function addStyle(obj, options) {
		var styleElement, update, remove;
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement(options));
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else if(obj.sourceMap &&
			typeof URL === "function" &&
			typeof URL.createObjectURL === "function" &&
			typeof URL.revokeObjectURL === "function" &&
			typeof Blob === "function" &&
			typeof btoa === "function") {
			styleElement = createLinkElement(options);
			update = updateLink.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
				if(styleElement.href)
					URL.revokeObjectURL(styleElement.href);
			};
		} else {
			styleElement = createStyleElement(options);
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
			};
		}
	
		update(obj);
	
		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	var replaceText = (function () {
		var textStore = [];
	
		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();
	
	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
	
		if(media) {
			styleElement.setAttribute("media", media)
		}
	
		if(styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}
	
	function updateLink(linkElement, obj) {
		var css = obj.css;
		var sourceMap = obj.sourceMap;
	
		if(sourceMap) {
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}
	
		var blob = new Blob([css], { type: "text/css" });
	
		var oldSrc = linkElement.href;
	
		linkElement.href = URL.createObjectURL(blob);
	
		if(oldSrc)
			URL.revokeObjectURL(oldSrc);
	}


/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.withRouter = exports.matchPath = exports.Switch = exports.StaticRouter = exports.Router = exports.Route = exports.Redirect = exports.Prompt = exports.NavLink = exports.MemoryRouter = exports.Link = exports.HashRouter = exports.BrowserRouter = undefined;
	
	var _BrowserRouter2 = __webpack_require__(1884);
	
	var _BrowserRouter3 = _interopRequireDefault(_BrowserRouter2);
	
	var _HashRouter2 = __webpack_require__(1885);
	
	var _HashRouter3 = _interopRequireDefault(_HashRouter2);
	
	var _Link2 = __webpack_require__(535);
	
	var _Link3 = _interopRequireDefault(_Link2);
	
	var _MemoryRouter2 = __webpack_require__(1886);
	
	var _MemoryRouter3 = _interopRequireDefault(_MemoryRouter2);
	
	var _NavLink2 = __webpack_require__(1887);
	
	var _NavLink3 = _interopRequireDefault(_NavLink2);
	
	var _Prompt2 = __webpack_require__(1888);
	
	var _Prompt3 = _interopRequireDefault(_Prompt2);
	
	var _Redirect2 = __webpack_require__(1889);
	
	var _Redirect3 = _interopRequireDefault(_Redirect2);
	
	var _Route2 = __webpack_require__(1890);
	
	var _Route3 = _interopRequireDefault(_Route2);
	
	var _Router2 = __webpack_require__(1891);
	
	var _Router3 = _interopRequireDefault(_Router2);
	
	var _StaticRouter2 = __webpack_require__(1892);
	
	var _StaticRouter3 = _interopRequireDefault(_StaticRouter2);
	
	var _Switch2 = __webpack_require__(1893);
	
	var _Switch3 = _interopRequireDefault(_Switch2);
	
	var _matchPath2 = __webpack_require__(1894);
	
	var _matchPath3 = _interopRequireDefault(_matchPath2);
	
	var _withRouter2 = __webpack_require__(1910);
	
	var _withRouter3 = _interopRequireDefault(_withRouter2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.BrowserRouter = _BrowserRouter3.default;
	exports.HashRouter = _HashRouter3.default;
	exports.Link = _Link3.default;
	exports.MemoryRouter = _MemoryRouter3.default;
	exports.NavLink = _NavLink3.default;
	exports.Prompt = _Prompt3.default;
	exports.Redirect = _Redirect3.default;
	exports.Route = _Route3.default;
	exports.Router = _Router3.default;
	exports.StaticRouter = _StaticRouter3.default;
	exports.Switch = _Switch3.default;
	exports.matchPath = _matchPath3.default;
	exports.withRouter = _withRouter3.default;

/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _splice = _interopRequireDefault(__webpack_require__(1997));
	
	var _getIn = _interopRequireDefault(__webpack_require__(1994));
	
	var _setIn = _interopRequireDefault(__webpack_require__(1996));
	
	var _deepEqual = _interopRequireDefault(__webpack_require__(1992));
	
	var _deleteIn = _interopRequireDefault(__webpack_require__(1993));
	
	var _keys = _interopRequireDefault(__webpack_require__(1995));
	
	var structure = {
	  allowsArrayErrors: true,
	  empty: {},
	  emptyList: [],
	  getIn: _getIn["default"],
	  setIn: _setIn["default"],
	  deepEqual: _deepEqual["default"],
	  deleteIn: _deleteIn["default"],
	  forEach: function forEach(items, callback) {
	    return items.forEach(callback);
	  },
	  fromJS: function fromJS(value) {
	    return value;
	  },
	  keys: _keys["default"],
	  size: function size(array) {
	    return array ? array.length : 0;
	  },
	  some: function some(items, callback) {
	    return items.some(callback);
	  },
	  splice: _splice["default"],
	  equals: function equals(a, b) {
	    return b.every(function (val) {
	      return ~a.indexOf(val);
	    });
	  },
	  orderChanged: function orderChanged(a, b) {
	    return b.some(function (val, index) {
	      return val !== a[index];
	    });
	  },
	  toJS: function toJS(value) {
	    return value;
	  }
	};
	var _default = structure;
	exports["default"] = _default;

/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {"use strict";
	var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	var __generator = (this && this.__generator) || function (thisArg, body) {
	    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
	    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
	    function verb(n) { return function (v) { return step([n, v]); }; }
	    function step(op) {
	        if (f) throw new TypeError("Generator is already executing.");
	        while (_) try {
	            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
	            if (y = 0, t) op = [op[0] & 2, t.value];
	            switch (op[0]) {
	                case 0: case 1: t = op; break;
	                case 4: _.label++; return { value: op[1], done: false };
	                case 5: _.label++; y = op[1]; op = [0]; continue;
	                case 7: op = _.ops.pop(); _.trys.pop(); continue;
	                default:
	                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
	                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
	                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
	                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
	                    if (t[2]) _.ops.pop();
	                    _.trys.pop(); continue;
	            }
	            op = body.call(thisArg, _);
	        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
	        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
	    }
	};
	var __asyncValues = (this && this.__asyncValues) || function (o) {
	    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
	    var m = o[Symbol.asyncIterator], i;
	    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
	    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
	    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
	};
	var __values = (this && this.__values) || function(o) {
	    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
	    if (m) return m.call(o);
	    if (o && typeof o.length === "number") return {
	        next: function () {
	            if (o && i >= o.length) o = void 0;
	            return { value: o && o[i++], done: !o };
	        }
	    };
	    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.fromReadableStreamLike = exports.fromAsyncIterable = exports.fromIterable = exports.fromPromise = exports.fromArrayLike = exports.fromInteropObservable = exports.innerFrom = void 0;
	var isArrayLike_1 = __webpack_require__(337);
	var isPromise_1 = __webpack_require__(599);
	var Observable_1 = __webpack_require__(34);
	var isInteropObservable_1 = __webpack_require__(597);
	var isAsyncIterable_1 = __webpack_require__(596);
	var throwUnobservableError_1 = __webpack_require__(601);
	var isIterable_1 = __webpack_require__(598);
	var isReadableStreamLike_1 = __webpack_require__(339);
	var isFunction_1 = __webpack_require__(31);
	var reportUnhandledError_1 = __webpack_require__(600);
	var observable_1 = __webpack_require__(230);
	function innerFrom(input) {
	    if (input instanceof Observable_1.Observable) {
	        return input;
	    }
	    if (input != null) {
	        if (isInteropObservable_1.isInteropObservable(input)) {
	            return fromInteropObservable(input);
	        }
	        if (isArrayLike_1.isArrayLike(input)) {
	            return fromArrayLike(input);
	        }
	        if (isPromise_1.isPromise(input)) {
	            return fromPromise(input);
	        }
	        if (isAsyncIterable_1.isAsyncIterable(input)) {
	            return fromAsyncIterable(input);
	        }
	        if (isIterable_1.isIterable(input)) {
	            return fromIterable(input);
	        }
	        if (isReadableStreamLike_1.isReadableStreamLike(input)) {
	            return fromReadableStreamLike(input);
	        }
	    }
	    throw throwUnobservableError_1.createInvalidObservableTypeError(input);
	}
	exports.innerFrom = innerFrom;
	function fromInteropObservable(obj) {
	    return new Observable_1.Observable(function (subscriber) {
	        var obs = obj[observable_1.observable]();
	        if (isFunction_1.isFunction(obs.subscribe)) {
	            return obs.subscribe(subscriber);
	        }
	        throw new TypeError('Provided object does not correctly implement Symbol.observable');
	    });
	}
	exports.fromInteropObservable = fromInteropObservable;
	function fromArrayLike(array) {
	    return new Observable_1.Observable(function (subscriber) {
	        for (var i = 0; i < array.length && !subscriber.closed; i++) {
	            subscriber.next(array[i]);
	        }
	        subscriber.complete();
	    });
	}
	exports.fromArrayLike = fromArrayLike;
	function fromPromise(promise) {
	    return new Observable_1.Observable(function (subscriber) {
	        promise
	            .then(function (value) {
	            if (!subscriber.closed) {
	                subscriber.next(value);
	                subscriber.complete();
	            }
	        }, function (err) { return subscriber.error(err); })
	            .then(null, reportUnhandledError_1.reportUnhandledError);
	    });
	}
	exports.fromPromise = fromPromise;
	function fromIterable(iterable) {
	    return new Observable_1.Observable(function (subscriber) {
	        var e_1, _a;
	        try {
	            for (var iterable_1 = __values(iterable), iterable_1_1 = iterable_1.next(); !iterable_1_1.done; iterable_1_1 = iterable_1.next()) {
	                var value = iterable_1_1.value;
	                subscriber.next(value);
	                if (subscriber.closed) {
	                    return;
	                }
	            }
	        }
	        catch (e_1_1) { e_1 = { error: e_1_1 }; }
	        finally {
	            try {
	                if (iterable_1_1 && !iterable_1_1.done && (_a = iterable_1.return)) _a.call(iterable_1);
	            }
	            finally { if (e_1) throw e_1.error; }
	        }
	        subscriber.complete();
	    });
	}
	exports.fromIterable = fromIterable;
	function fromAsyncIterable(asyncIterable) {
	    return new Observable_1.Observable(function (subscriber) {
	        process(asyncIterable, subscriber).catch(function (err) { return subscriber.error(err); });
	    });
	}
	exports.fromAsyncIterable = fromAsyncIterable;
	function fromReadableStreamLike(readableStream) {
	    return fromAsyncIterable(isReadableStreamLike_1.readableStreamLikeToAsyncGenerator(readableStream));
	}
	exports.fromReadableStreamLike = fromReadableStreamLike;
	function process(asyncIterable, subscriber) {
	    var asyncIterable_1, asyncIterable_1_1;
	    var e_2, _a;
	    return __awaiter(this, void 0, void 0, function () {
	        var value, e_2_1;
	        return __generator(this, function (_b) {
	            switch (_b.label) {
	                case 0:
	                    _b.trys.push([0, 5, 6, 11]);
	                    asyncIterable_1 = __asyncValues(asyncIterable);
	                    _b.label = 1;
	                case 1: return [4, asyncIterable_1.next()];
	                case 2:
	                    if (!(asyncIterable_1_1 = _b.sent(), !asyncIterable_1_1.done)) return [3, 4];
	                    value = asyncIterable_1_1.value;
	                    subscriber.next(value);
	                    if (subscriber.closed) {
	                        return [2];
	                    }
	                    _b.label = 3;
	                case 3: return [3, 1];
	                case 4: return [3, 11];
	                case 5:
	                    e_2_1 = _b.sent();
	                    e_2 = { error: e_2_1 };
	                    return [3, 11];
	                case 6:
	                    _b.trys.push([6, , 9, 10]);
	                    if (!(asyncIterable_1_1 && !asyncIterable_1_1.done && (_a = asyncIterable_1.return))) return [3, 8];
	                    return [4, _a.call(asyncIterable_1)];
	                case 7:
	                    _b.sent();
	                    _b.label = 8;
	                case 8: return [3, 10];
	                case 9:
	                    if (e_2) throw e_2.error;
	                    return [7];
	                case 10: return [7];
	                case 11:
	                    subscriber.complete();
	                    return [2];
	            }
	        });
	    });
	}
	//# sourceMappingURL=innerFrom.js.map
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(304)))

/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(26);
	
	var _reactRedux = __webpack_require__(18);
	
	var _reactReduxToastr = __webpack_require__(42);
	
	var _reactRouterRedux = __webpack_require__(30);
	
	var _appTranslations = __webpack_require__(33);
	
	var _appTranslations2 = _interopRequireDefault(_appTranslations);
	
	var _actions = __webpack_require__(23);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	var _appDefaults = __webpack_require__(39);
	
	var _appDefaults2 = _interopRequireDefault(_appDefaults);
	
	var _homepage = __webpack_require__(602);
	
	var _homepage2 = _interopRequireDefault(_homepage);
	
	var _appRoutes = __webpack_require__(22);
	
	var _appRoutes2 = _interopRequireDefault(_appRoutes);
	
	var _store = __webpack_require__(40);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Layout = function (_Component) {
	    _inherits(Layout, _Component);
	
	    function Layout() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, Layout);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Layout.__proto__ || Object.getPrototypeOf(Layout)).call.apply(_ref, [this].concat(args))), _this), _this.tick = function () {
	            _this.props.emptyCart(_this.props.order, _this.props.locale.currentLocale, _this.props.cartState, _this.props.location);
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(Layout, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.tick();
	            this.interval = setInterval(this.tick, 1000);
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps, prevState) {
	            if (prevProps.order !== this.props.order) {
	                clearInterval(this.interval);
	                this.interval = setInterval(this.tick, 1000);
	            }
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            clearInterval(this.interval);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { style: { display: 'flex', flexFlow: 'column', minHeight: '100vh' } },
	                _react2.default.createElement(
	                    'main',
	                    { className: _homepage2.default.mainContainer + ' ' + (this.props.notShowMarginBottom ? '' : 'margin-bottom-50') },
	                    this.props.children
	                )
	            );
	        }
	    }]);
	
	    return Layout;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	    return {
	        order: state.order,
	        locale: state.locale,
	        cartState: state.cartState
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        emptyCart: function emptyCart(order, locale, cartState, location) {
	            var secondsToEmptyCart = cartState.cartRemoval;
	            if (secondsToEmptyCart > 0 && cartState.hasExtraTimeCheckout) {
	                secondsToEmptyCart += cartState.gracePeriod;
	            }
	
	            if (order.created_at && secondsToEmptyCart > 0) {
	                var diffDate = new Date().getTime() - new Date(order.created_at).getTime();
	                var rest = Math.round((secondsToEmptyCart - diffDate / 1000) / 60);
	                var restOnSeconds = Math.round(secondsToEmptyCart - diffDate / 1000);
	
	                if (order.line_items && order.line_items.length > 0 && cartState.activeCart) {
	                    if ((cartState.timeMinutesLastAlert === 0 || restOnSeconds % 60 === 0 || rest > cartState.timeMinutesLastAlert) && rest !== cartState.timeMinutesLastAlert && rest <= secondsToEmptyCart / 60) {
	                        var index = _appDefaults2.default.showCartExpiringMessageAt.indexOf(rest);
	                        if (index > -1) {
	                            var warningMessage = '' + _appTranslations2.default[locale]['cart-expiring-message-part1'] + rest + _appTranslations2.default[locale]['cart-expiring-message-part2'];
	                            var lowestWarning = _appDefaults2.default.showCartExpiringMessageAt.sort(function (a, b) {
	                                return a - b > 0 ? 1 : -1;
	                            })[0];
	                            if (lowestWarning === rest) {
	                                _reactReduxToastr.toastr.error(warningMessage, '', {
	                                    timeOut: 60000
	                                });
	                            } else {
	                                _reactReduxToastr.toastr.warning(warningMessage, '', {
	                                    timeOut: 60000
	                                });
	                            }
	                        }
	                        dispatch(_actions2.default.setTimeMinutesLeft(rest));
	                    }
	                    dispatch(_actions2.default.setTimeSecondsLeft(restOnSeconds));
	                }
	
	                if (order && order.id && diffDate / 1000 >= secondsToEmptyCart) {
	                    if (cartState.activeCart && !cartState.hasExtraTimeCheckout && (0, _reactRouterDom.matchPath)(location.pathname, { exact: false, path: '/checkout' })) {
	                        dispatch(_actions2.default.setHasExtraTimeCheckout(true));
	                    } else if (!_store2.default.getState().order.isFinalStepHappening) {
	                        _store2.default.dispatch(_actions2.default.setIsFinalStepHappening(true));
	                        dispatch(_actions2.default.emptyCart(order, locale)).then(function (result) {
	                            if (result && result.ok) {
	                                _reactReduxToastr.toastr.error(_appTranslations2.default[locale]['cart-expiring-empty-cart']);
	                                dispatch((0, _reactRouterRedux.push)(_appRoutes2.default.homePageRoute));
	                            }
	                        }, function (error) {
	                            console.log(error);
	                        }).finally(function () {
	                            _store2.default.dispatch(_actions2.default.setIsFinalStepHappening(false));
	                        });
	                    }
	                }
	            }
	        }
	    };
	};
	
	var LayoutWithRouter = (0, _reactRouterDom.withRouter)(Layout);
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(LayoutWithRouter);

/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.routerMiddleware = exports.routerActions = exports.goForward = exports.goBack = exports.go = exports.replace = exports.push = exports.CALL_HISTORY_METHOD = exports.routerReducer = exports.LOCATION_CHANGE = exports.ConnectedRouter = undefined;
	
	var _reducer = __webpack_require__(544);
	
	Object.defineProperty(exports, 'LOCATION_CHANGE', {
	  enumerable: true,
	  get: function get() {
	    return _reducer.LOCATION_CHANGE;
	  }
	});
	Object.defineProperty(exports, 'routerReducer', {
	  enumerable: true,
	  get: function get() {
	    return _reducer.routerReducer;
	  }
	});
	
	var _actions = __webpack_require__(540);
	
	Object.defineProperty(exports, 'CALL_HISTORY_METHOD', {
	  enumerable: true,
	  get: function get() {
	    return _actions.CALL_HISTORY_METHOD;
	  }
	});
	Object.defineProperty(exports, 'push', {
	  enumerable: true,
	  get: function get() {
	    return _actions.push;
	  }
	});
	Object.defineProperty(exports, 'replace', {
	  enumerable: true,
	  get: function get() {
	    return _actions.replace;
	  }
	});
	Object.defineProperty(exports, 'go', {
	  enumerable: true,
	  get: function get() {
	    return _actions.go;
	  }
	});
	Object.defineProperty(exports, 'goBack', {
	  enumerable: true,
	  get: function get() {
	    return _actions.goBack;
	  }
	});
	Object.defineProperty(exports, 'goForward', {
	  enumerable: true,
	  get: function get() {
	    return _actions.goForward;
	  }
	});
	Object.defineProperty(exports, 'routerActions', {
	  enumerable: true,
	  get: function get() {
	    return _actions.routerActions;
	  }
	});
	
	var _ConnectedRouter2 = __webpack_require__(1911);
	
	var _ConnectedRouter3 = _interopRequireDefault(_ConnectedRouter2);
	
	var _middleware = __webpack_require__(1912);
	
	var _middleware2 = _interopRequireDefault(_middleware);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.ConnectedRouter = _ConnectedRouter3.default;
	exports.routerMiddleware = _middleware2.default;

/***/ },
/* 31 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.isFunction = void 0;
	function isFunction(value) {
	    return typeof value === 'function';
	}
	exports.isFunction = isFunction;
	//# sourceMappingURL=isFunction.js.map

/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIs = __webpack_require__(160);
	
	var _createChainableTypeChecker = __webpack_require__(215);
	
	var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function elementType(props, propName, componentName, location, propFullName) {
	  var propValue = props[propName];
	
	  if (_react2.default.isValidElement(propValue)) {
	    return new Error('Invalid ' + location + ' `' + propFullName + '` of type ReactElement ' + ('supplied to `' + componentName + '`,expected an element type (a string ') + ', component class, or function component).');
	  }
	
	  if (!(0, _reactIs.isValidElementType)(propValue)) {
	    return new Error('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected an element type (a string ') + ', component class, or function component).');
	  }
	
	  return null;
	}
	
	exports.default = (0, _createChainableTypeChecker2.default)(elementType);
	module.exports = exports['default'];

/***/ },
/* 33 */
/***/ function(module, exports) {

	module.exports = {
		"en": {
			"a-special-gift": "a special gift?",
			"about-katapulk": "About CubaLicores",
			"about-us": "About Us",
			"add-to-cart": "Add to Cart",
			"add-to-wish-list": "Add to Wish List",
			"address": "Personal Information",
			"address1": "Address Line 1*",
			"address2": "Address Line 2",
			"adjustmentTotal": "Adjustment Total",
			"all": "All",
			"all-details": "All details",
			"attention": "ATTENTION.",
			"attention-not-available": "ATTENTION. NOT AVAILABLE",
			"whatsapp-me-at": "WhatsApp me at",
			"attributes.description": "Description",
			"auth-failed": "Authentication failed",
			"back": "Back",
			"be-the-first-to-comment": "Be the first to comment.",
			"beauty-and-grooming": "Beauty and Grooming",
			"bids-and-offers": "Bids and Offers",
			"billingAddress": "Billing Address",
			"billingInfo": "Billing Address",
			"billingInfoDetails": "Address Associated with your Card",
			"cardExpiration": "Card Expiration*",
			"card-expiry-placeholder": "Expiration",
			"cardNumber": "Card Number*",
			"cart": "Cart",
			"cart-is-empty": "Your cart is empty.",
			"cart-is-now-empty": "Your Cart is now empty!",
			"cart-is-unable-to-empty": "Sorry! We were unable to empty your cart. Please try again later.",
			"cart-already-empty": "Your Cart is already empty.",
			"category": "Category",
			"checkout": "Checkout",
			"city": "City*",
			"classified-ads": "Classified Ads",
			"clear-filter": "Clear Filter",
			"combos": "Combos",
			"coming-soon": "Coming Soon",
			"coming-soon-button": "See CubaLicores Products",
			"coming-soon-desc": "We are adding new features to our platform. Soon these products will be available. Please, be patient and explore our",
			"coming-soon-text": "These products will be available soon",
			"complete": "Complete",
			"confirm": "Confirm",
			"confirmOrder": "Confirm your Order",
			"confirmOrderMobile": "Confirm",
			"confirmPassword": "Confirm Password*",
			"contact": "Contact",
			"continue": "Continue",
			"continue-shopping": "Continue Shopping",
			"conversations": "Conversations",
			"copyright": "2022 © Othar Trade & Logistics Spain all rights reserved.",
			"country": "Country",
			"customer-service": "Customer Service",
			"days": "days",
			"delivery": "Delivery",
			"description": "Description",
			"do-you-need": "Do you need",
			"dont-have-an-account-yet": "Don't have an account yet?",
			"email": "Email*",
			"email-receiver": "Email",
			"email-address": "Email Address",
			"email-order-placeholder": "Email to receive the order confirmation",
			"empty-cart": "Empty Cart",
			"emptyCart": "Empty Cart",
			"error": "Error!",
			"payment-error": "Payment problem!",
			"estimated-arrival-time": "Estimated arrival time",
			"shipping-policy-link-text": "See delivery policy and rates",
			"shippingInfoEmail": "Receiver's email address",
			"faqs": "FAQs",
			"firstname": "First Name*",
			"follow-us": "follow us",
			"food": "Food",
			"store": "Store",
			"mostVisited": "Most visited stores",
			"allStores": "All the stores",
			"paginator-sentence-1": "Showing",
			"paginator-sentence-2": "of",
			"paginator-sentence-3": "results",
			"for-the-best-experience": "for the best experience",
			"forgot-password": "Forgot password?",
			"go": "Go!",
			"goToCart": "Go To Cart",
			"grooming": "Grooming",
			"heading": "Style Collection",
			"hello": "Hi!",
			"in-katapulk": "in CubaLicores",
			"in-stock": "In Stock",
			"inspired-by-cuba": "Inspired by Cuba",
			"invalid-user-password": "Invalid email or password.",
			"invalid-forgot-password": "Error actualizando contraseña",
			"item-added": "Item added to Cart",
			"item-not-removed-from-cart": "The item can't be removed from the cart.",
			"item-removed-from-cart": "Item removed from the cart.",
			"itemTotal": "Item Total",
			"lastname": "Last Name*",
			"loading-more": "Loading more...",
			"loading-please-wait": "Loading, please wait...",
			"loading-recommendations": "Loading recommendations",
			"loading-stores": "Loading stores",
			"location": "Location",
			"login": "Login",
			"logout": "Logout",
			"made-in-cuba": "Made in Cuba",
			"manage-profile": "Manage Profile",
			"mercado-unico": "CubaLicores",
			"message": "Message",
			"modal-store-button-empty": "Empty Cart",
			"modal-store-button-close": "Close",
			"modal-store-title": "Alert",
			"modal-store-text1": "You have a product cart pending from another store",
			"modal-store-text2": "store. Usted esta seguro que desea vaciar su carrito?",
			"modal-zone-text1": "Some of your selected products are not available for current zone",
			"modal-zone-text2": "Are you sure want to empty your cart?",
			"modal-zoneSelect-title": "Hello",
			"modal-zoneSelect-text1": "Please, select the zone where you want to deliver the products:",
			"modal-zoneSelect-accept": "Accept",
			"modal-zoneSelect-cancel": "Cancel",
			"models.country": "Country",
			"models.productProperties": "Product Properties",
			"models.shipment": "Packages",
			"models.state": "State",
			"models.variant": "Variant",
			"municipality": "Municipality*",
			"my-account": "My Account",
			"my-bids-and-offers": "My Bids & Offers",
			"my-orders": "My Orders",
			"myOrders": "My Orders",
			"nameOnCard": "Name on card*",
			"need-help": "Need Help?",
			"no-products-found": "No products found.",
			"not-found": "Not Found",
			"note": "Notes",
			"notifications": "Notifications",
			"offers": "Offers",
			"oops": "Ooops!",
			"oops-text": "We can't seem to find the page you're looking for.",
			"orderItems": "Order Items",
			"orderNumber": "Ref",
			"orderTotal": "Order Total",
			"our": "Our",
			"out-of-stock": "Out of Stock",
			"sorry-out-of-stock": "Sorry Out of Stock",
			"packages": "Package(s)",
			"password": "Password*",
			"payment": "Payment",
			"paymentStatus": "Payment Status",
			"phone": "Phone*",
			"placeOrder": "Place Order",
			"please-wait": "please wait",
			"powered-by-stripe": "Powered by Stripe",
			"price": "Price",
			"price-details": "Price Details",
			"privacy-policy": "Privacy Policy",
			"privacy-policy-copyright-text1": "© Copyright 2020 www.cubalicores.com / cubalicores.com and the collaborating companies of",
			"privacy-policy-copyright-text2": "Forbidden the total or partial reproduction.",
			"privacy-policy-subtitle1": " 1) Introduction",
			"privacy-policy-subtitle1-text1": "a. Access to the www.cubalicores.com / cubalicores.com portal is conditioned on the user's prior reading and acceptance of the conditions, terms, communications, warnings, legal notices and other information contained in these Terms and Conditions. Access to it is free, its viewing does not require prior subscription or registration whatsoever, and its use by the user implies express, full and unreserved agreement with all of its content.",
			"privacy-policy-subtitle1-text2": "b. If the User does not agree with the content of these General Conditions for browsing access and use of this website, they will not be able to access or buy the products and services it offers.",
			"privacy-policy-subtitle1-text3": "c. By accepting these terms and conditions, the user affirms and declares that they are of legal age and have sufficient legal capacity to register on this website. Likewise, you expressly and without exception accept that access to and use of this website, its services and the contents of said services take place under your sole and exclusive responsibility, and cannot guarantee www.cubalicores.com / cubalicores.com that in direct access to other Web sites through links (links) can view information that could hurt your sensitivity or cause damage.",
			"privacy-policy-subtitle1-text4": "d. The connections with other Web sites that may exist, as well as the use that the User may make of them, is subject to these conditions, as well as any specific conditions that the aforementioned Web sites require. Any use other than authorized is expressly prohibited.",
			"privacy-policy-subtitle1-text5": "may modify this website unilaterally and at any time it deems appropriate, updating its configuration, the terms and conditions of the services and their content, eliminate, limit or suspend them temporarily or permanently, as well as prevent access to them by trying inform the User of said change, as long as circumstances allow it, through its publication on the website, which is why Users are recommended to consult the GC, the General Conditions at each access to the Website of Sale, Legal Notices and Particular Conditions set forth in the different pages that make up the website.",
			"privacy-policy-subtitle2": " 2) Characteristics of the web and navigability",
			"privacy-policy-subtitle2-text1": "a. Adapted web design. The www.cubalicores.com / cubalicores.com website has a responsive design that allows the client to access the website from different devices, adapting the image and resolution of the website to each device.",
			"privacy-policy-subtitle2-text2": "b. High in account. There is a Register, which is accessed in the MY ACCOUNT section, which the user will complete with the required data and with the acceptance of the legal notice to be able to access the online shopping services of www.cubalicores.com / cubalicores.com.",
			"privacy-policy-subtitle2-text3": "c. Possibility of managing profile data. There is an INFORMATION section, accessed through MY ACCOUNT, in which the user can:",
			"privacy-policy-subtitle2-text3-1": "i. Manage your personal data",
			"privacy-policy-subtitle2-text3-2": "ii. Add recipients",
			"privacy-policy-subtitle2-text3-3": "iii. Check available credit or bonuses",
			"privacy-policy-subtitle2-text3-4": "iv. Manage orders",
			"privacy-policy-subtitle2-text3-5": "v. View the products added to FAVORITES",
			"privacy-policy-subtitle3": " 3) Rights and obligations of the service provider",
			"privacy-policy-subtitle3-text1": "a. www.cubalicores.com / cubalicores.com is obliged to provide the services offered on the Web and guarantee the communications that may exist with the client, as well as to respond to claims and queries that may arise.",
			"privacy-policy-subtitle3-text2": "b. www.cubalicores.com / cubalicores.com has the right to suspend temporarily and without prior notice the accessibility of this website, as well as to reserve the right to provide or cancel services, in the event of carrying out operations of maintenance, repair, update or improvement of services.",
			"privacy-policy-subtitle3-text3": "c. The intellectual property rights on the website are owned by",
			"privacy-policy-subtitle3-text4": "The rights of reproduction, distribution, public communication and transformation belong to the same company.",
			"privacy-policy-subtitle4": " 4) Rights and obligations of the user",
			"privacy-policy-subtitle4-text1": "a. The contents of this website are available to the user for their use without any commercial purpose and exclusively for their personal use; and only for these purposes the user can transfer the contents of this website. The user cannot, consequently, distribute, modify, transmit, forward or use in any way such content for commercial purposes.",
			"privacy-policy-subtitle4-text2": "b. At all times, the User must make lawful use of the services of this Website in accordance with current legislation, respecting the intellectual property rights of",
			"privacy-policy-subtitle4-text3": "and possible third parties.",
			"privacy-policy-subtitle4-text4": "c. The User will not carry out through the services that www.cubalicores.com / cubalicores.com makes available to them any action that causes damage or alterations to the contents or hinders the proper functioning of the Web, expressly committing themselves to the sole use of the same to not cause technical problems of any kind, transfer elements that may carry computer viruses or damage, interfere or totally or partially intercept the Web, as well as not to intervene or alter the email of other Users.",
			"privacy-policy-subtitle4-text5": "d. The User's responsibility for the veracity of the data entered, in the event that he did so for any circumstance, is exclusive to the User himself; Therefore, in the event of having provided false or inaccurate information, www.cubalicores.com / cubalicores.com and, where appropriate, the collaborating companies of",
			"privacy-policy-subtitle4-text6": ", reserve the right to prohibit the access to this website.",
			"privacy-policy-subtitle5": " 5) Exclusion of guarantees and responsibility for the operation of the website",
			"privacy-policy-subtitle5-text1": "a. www.cubalicores.com / cubalicores.com undertakes to work to maintain the continued availability of this website, but neither www.cubalicores.com / cubalicores.com nor the collaborating companies of",
			"privacy-policy-subtitle5-text2": ", guarantee the availability and continuity of the operation of this website and its services. In this way, any liability for damages of any nature that may arise from the lack of availability or continuity of the operation of the website and its services and the usefulness that Users could have attributed to this website is excluded.",
			"privacy-policy-subtitle5-text3": "b. www.cubalicores.com / cubalicores.com and the collaborating companies of",
			"privacy-policy-subtitle5-text4": "They make personal data privacy systems available to Users that prevent access to them by third parties. www.cubalicores.com / cubalicores.com and the collaborating companies of",
			"privacy-policy-subtitle5-text5": "They have implemented all the necessary technical and organizational security measures to guarantee the integrity, confidentiality and availability of the personal data provided by the User. In this sense, the aforementioned companies are exempt from all liability for damages caused in the event of such knowledge.",
			"privacy-policy-subtitle5-text6": "c. Despite the fact that www.cubalicores.com / cubalicores.com have implemented all the appropriate measures to guarantee security in this matter, it does not control or guarantee the absence of viruses or other elements in the contents of this website that may cause alterations in the computer system (software and hardware) of the User or in the electronic documents and files stored in his computer system.",
			"privacy-policy-subtitle5-text7": "d. www.cubalicores.com / cubalicores.com and the collaborating companies of",
			"privacy-policy-subtitle5-text8": "are exempt from any responsibility for damages of any kind that may be due to the presence of viruses in the contents that may cause alterations in the computer system, electronic documents, files, etc ...",
			"privacy-policy-subtitle5-text9": "e. www.cubalicores.com / cubalicores.com and the collaborating companies of",
			"privacy-policy-subtitle5-text10": "They have no obligation to control, and do not control, the use that Users make of this website, the services that this website provides, or its contents. In particular, www.cubalicores.com / cubalicores.com does not guarantee that Users will use the website, its services and its contents in accordance with the terms and conditions under the www.cubalicores.com / cubalicores.com domain that may result from time to time of application, or that they do so diligently and prudently.",
			"privacy-policy-subtitle5-text11": "f. www.cubalicores.com / cubalicores.com and the collaborating companies of",
			"privacy-policy-subtitle5-text12": "They do not have the obligation to verify, and they do not verify, the identity of the Users of this Web site; nor the veracity of the data that they provide about themselves or recipients.",
			"privacy-policy-subtitle5-text13": "g. The User accepts that the Website has been created and developed in good faith by www.cubalicores.com / cubalicores.com and the collaborating companies of",
			"privacy-policy-subtitle5-text14": "with information from internal and external sources and offers it in its current state to Users, which may contain inaccuracies or errors, for which the User exonerates www.cubalicores.com / cubalicores.com and the collaborating companies of",
			"privacy-policy-subtitle5-text15": "of any responsibility in relation to the reliability, usefulness or false expectations that the website may produce while browsing it",
			"privacy-policy-subtitle6": " 6) Intellectual property",
			"privacy-policy-subtitle6-text1": "a. All rights to the content of this website belong to www.cubalicores.com / cubalicores.com and the collaborating companies of",
			"privacy-policy-subtitle6-text2": "; except for those from companies with which you have signed the corresponding contract for the provision of content.",
			"privacy-policy-subtitle6-text3": "b. www.cubalicores.com / cubalicores.com does not transfer to the User of this website any ownership of their own software or third parties; the User is responsible for the medium in which the software is recorded, retaining www.cubalicores.com / cubalicores.com and the collaborating companies of",
			"privacy-policy-subtitle6-text4": "all industrial and intellectual property rights including software that may correspond to it.",
			"privacy-policy-subtitle6-text5": "c. The design, images, maps, graphics, brands, labels, distinctive signs or logos of www.cubalicores.com / cubalicores.com, frames, banners, the software and its different source and object codes, etc., of this website are owned by de www.cubalicores.com / cubalicores.com and the collaborating companies of",
			"privacy-policy-subtitle6-text6": ", who legitimately and exclusively own the exploitation rights over them.",
			"privacy-policy-subtitle6-text7": "d. The logos or distinctive signs of the Group companies that may appear on this Website during the User's browsing are the property of each of them, legitimately having the exclusive rights of exploitation over them, expressly consenting to their incorporation, where appropriate, to this website.",
			"privacy-policy-subtitle6-text8": "e. The User who accesses this website may not copy, modify, distribute, transmit, reproduce, publish, assign or sell the aforementioned elements; nor create new products or services derived from the information obtained through this website.",
			"privacy-policy-subtitle6-text9": "f. Only viewing and uploading is authorized for the User's personal and non-commercial use, without being able to extend it to third parties or entities. In the case of graphics or designs that appear on this website owned by collaborating companies of www.cubalicores.com / cubalicores.com and collaborating companies of",
			"privacy-policy-subtitle6-text10": "g. Any alteration of this Website or its content by the User is strictly prohibited; as well as the installation of links (hyperlinks, links or hyperlinks), links or similar not previously and expressly authorized by www.cubalicores.com / cubalicores.com and the collaborating companies of",
			"privacy-policy-subtitle6-text11": "h. www.cubalicores.com / cubalicores.com will ensure that the contents of this website are not pornographic, xenophobic, discriminatory, racist, defamatory, or promote any kind of violence.",
			"privacy-policy-subtitle7": " 7) Protection of personal data. In compliance with current regulations for the protection of personal data of users,",
			"privacy-policy-subtitle7-text1": "a. www.cubalicores.com / cubalicores.com and the collaborating companies of",
			"privacy-policy-subtitle7-text2": "will respect, at all times, the provisions of current regulations on the protection of personal data; and guarantee the confidentiality of personal data. In compliance with current regulations on the protection of personal data, we inform you that the data provided will be processed by www.cubalicores.com / cubalicores.com and the collaborating companies of",
			"privacy-policy-subtitle7-text3": ", as of Responsible for the File.",
			"privacy-policy-subtitle7-text4": "b. The provision of personal data, own or of third parties, through the forms provided for this purpose on the www.cubalicores.com / cubalicores.com Website may only be made by persons of legal age.",
			"privacy-policy-subtitle7-text5": "c. The Group entities with access to the personal data of the Users of www.cubalicores.com / cubalicores.com are",
			"privacy-policy-subtitle7-text6": "(commerce),",
			"privacy-policy-subtitle7-text7": "(communications) and",
			"privacy-policy-subtitle7-text8": "(travel agency)",
			"privacy-policy-subtitle7-text9": "d. By accepting this Legal Information, the User authorizes www.cubalicores.com / cubalicores.com and the collaborating companies of",
			"privacy-policy-subtitle7-text10": "and to all the Group companies to process the data provided on this website for any of the following purposes:",
			"privacy-policy-subtitle7-text10-1": "i. Manage the data to process your online purchase orders.",
			"privacy-policy-subtitle7-text10-2": "ii. Manage user participation in possible events and promotional actions",
			"privacy-policy-subtitle7-text10-3": "iii. Manage the selection processes of the",
			"privacy-policy-subtitle7-text10-4": "and the Group companies",
			"privacy-policy-subtitle7-text10-5": "iv. Manage possible relationships between the User of the Website and www.cubalicores.com / cubalicores.com.",
			"privacy-policy-subtitle7-text10-6": "v. Use the data to send the User of www.cubalicores.com / cubalicores.com to surveys and information and / or documentation of products and / or services requested by the User and / or marketed by www.cubalicores.com / cubalicores.com through various media, including electronic (email and telephony mobile).",
			"privacy-policy-subtitle7-text10-7": "vi. The consent for the use of the User's data for the sending of commercial communications through electronic means (email or other current or future) may be revoked by the User at any moment in time, through the section \"MY PROFILE\" from the www.cubalicores.com / cubalicores.com Website",
			"privacy-policy-subtitle7-text10-8": "vii. In any case, for the exercise of the rights of access, rectification, cancellation or opposition, an identified letter must be sent, in which the corresponding request is specified and accompanied by a photocopy of the Identity Card of the interested party, to the following address: C / BARBASTRO 4 1 A HUESCA 22002-HUESCA, Spain.",
			"privacy-policy-subtitle7-text11": "e. When the User provides their data to www.cubalicores.com / cubalicores.com and the collaborating companies of",
			"privacy-policy-subtitle7-text12": ", through any of the forms on the Web, the User will be authorizing the aforementioned companies so that they can process your data in accordance with the purpose of the collection. The data provided will be part of a file, created under the responsibility of the company to which the User provides their data.",
			"privacy-policy-subtitle7-text13": "f. www.cubalicores.com / cubalicores.com informs the User of the existence on this website of links that allow access to different websites of certain entities of the Group, as well as to various organizations or third-party entities whose ownership is not of www .cubalicores.com / cubalicores.com or Group companies",
			"privacy-policy-subtitle7-text14": " g. The User may exercise the rights of access, rectification, cancellation and opposition at the address and before the person responsible for the file indicated in each specific case. In this way, www.cubalicores.com / cubalicores.com and the collaborating companies of",
			"privacy-policy-subtitle7-text15": "aim to guarantee Users the right to information at the time the collection of data is carried out. your data.",
			"privacy-policy-subtitle7-text16": "h. The User will be solely responsible for filling in the forms with false, inaccurate, incomplete or outdated information. All the data provided by the User will be treated confidentially.",
			"privacy-policy-subtitle7-text17": "i. The company to which the User has been able to provide their data, may only transfer them.",
			"privacy-policy-subtitle7-text18": "j. Part of the services of www.cubalicores.com / cubalicores.com use \"cookies\". For more information, see our cookie policy.",
			"privacy-policy-subtitle8": " 8) Links",
			"privacy-policy-subtitle8-text1": "a. Without the express consent of www.cubalicores.com / cubalicores.com and the collaborating companies of",
			"privacy-policy-subtitle8-text2": ", no link to this website can be established from any other website.",
			"privacy-policy-subtitle8-text3": "b. If the website had links to other portals, not managed by",
			"privacy-policy-subtitle8-text4": ", all responsibility on the part of the company regarding the control and responsibility of the products or services offered is excluded, as well as the contents and owners.",
			"privacy-policy-subtitle8-text5": ", are exonerated of all responsibility in relation to the contents and services provided by third parties against any claim of any nature and lawsuits that may be filed in relation to them.",
			"privacy-policy-subtitle9": " 9) Nullity and ineffectiveness of the clauses",
			"privacy-policy-subtitle9-text1": "a. If it were the case that any content of these terms and conditions was declared null or ineffective, it will only affect the indicated content or part of it.",
			"privacy-policy-subtitle10": "10) Applicable law and jurisdiction",
			"privacy-policy-subtitle10-text1": "a. The Terms and Conditions of this website will be governed by Spanish legislation.",
			"privacy-policy-subtitle10-text2": "b. In the event that any User or affected third party considers that there are facts or circumstances that reveal the illicit nature, they must send a communication containing the following points:",
			"privacy-policy-subtitle10-text2-1": "i. Complete personal data of the claimant: Name, surname, address, telephone number and email address.",
			"privacy-policy-subtitle10-text2-2": "ii. Specification, in detail, of the following points: What is the alleged illegal content or illegality of the use of the content. If you are the owner of the illegally used content.",
			"privacy-policy-subtitle10-text2-3": "iii. In the case of an alleged injury to property or rights susceptible to compensation, precise and concrete indication of the protected content, as well as its location on the Web.",
			"privacy-policy-subtitle10-text2-4": "iv. The claimant must send by post to",
			"privacy-policy-subtitle10-text2-5": ", located at C / BARBASTRO 4 1 A HUESCA 22002-HUESCA, Spain the following documentation:",
			"privacy-policy-subtitle10-text2-5.1": "1. Communication signed by hand, from the owner of the rights allegedly infringed or from the person authorized to act on her behalf and on her behalf, which is accompanied by documentation proving the ownership of the property or right allegedly injured, in which it refers precisely the data of the Web page, content, or hyperlink object of complaint.",
			"privacy-policy-subtitle10-text2-5.2": "2. In case of not being the holder of the right or injured, a sworn statement, express, clear and under the responsibility of the claimant that the information provided in the online notification is accurate and that the content or activity referred to is illegal. The document must be signed by hand and accompany a copy of the Identity Card or equivalent identification document.",
			"privacy-policy-subtitle10-text2-5.3": "3. ANONYMOUS COMMUNICATIONS WILL NOT BE ADMITTED AS SUFFICIENT NOTICE TO BRING KNOWLEDGE of www.cubalicores.com / cubalicores.com and the collaborating companies of",
			"privacy-policy-subtitle10-text2-5.4": "THE ILLEGALITY OF CONTENTS OR ACTIVITIES.",
			"privacy-policy-text1": "This legal notice includes the general conditions of access, navigation, and use of the website www.cubalicores.com / cubalicores.com; as well as the details of the treatment of our clients' data. You must accept this legal notice to navigate the pages of www.cubalicores.com and cubalicores.com, as well as to make a purchase.",
			"privacy-policy-title": "LEGAL WARNING AND PRIVACY POLICY",
			"privacy-protected": "Privacy Protected",
			"proceed-to-checkout": "Proceed to Checkout",
			"product": "Product",
			"product-list": "List of products",
			"products": "Products",
			"products-from": "Products from ",
			"qty": "Qty",
			"quantity": "Quantity",
			"quantity-greater-than-zero": "Quantity must be numeric and greater than zero.",
			"quantity-success-update": "Your Product Quantity is successfully updated!",
			"rate": "Fee",
			"recommendations": "recommendations",
			"register": "Register",
			"register-confirmation": "Confirmation of registration",
			"remember-me": "Remember me",
			"rememberAddress": "Remember this Address",
			"reviews": "Reviews",
			"savePayment": "Submit Payment",
			"savePaymentMobile": "Pay",
			"secure-checkout": "Secure Checkout",
			"secure-connection": "Secure Connection",
			"security-digits": "Security digits",
			"send": "Send",
			"send-email-failure": "Email not found.",
			"send-email-success-1": "The email has been successfully sent.",
			"send-email-success-2": "Please, check it out to continue with process.",
			"send-failed": "Shipping Failure",
			"send-failed-message": "Error sending contact details.",
			"send-success": "Success!",
			"send-success-message": "We have received your message. We will attend your request as soon as possible and we will contact you if necessary.",
			"shipment": "Shipment to ",
			"shipmentNumber": "Ref",
			"shipmentState.canceled": "Shipment Cancelled",
			"shipmentState.pending": "Shipment under Review",
			"shipmentState.ready": "Dispatching soon",
			"shipmentState.shipped": "Shipped",
			"shipping-and-rates": "Shipping & Rates",
			"shippingAddress": "Shipping Address",
			"shippingCharges": "Shipping Charges",
			"shippingInfo": "Shipping Address",
			"shippingInfoDetails": "The address to deliver your product",
			"shippingMethod": "Shipping Method",
			"shippingPolicy.subtitle2": "Delivery conditions:",
			"shippingPolicy.subtitle2.subtitle1": "<p>Shipping and handling fees</p><span style=\"color: #d3af71\">CUBALICORES</span>",
			"shippingPolicy.subtitle2.subtitle1.text1": "Shipments to Havana.",
			"shippingPolicy.subtitle2.subtitle1.text2": "Carrier",
			"shippingPolicy.subtitle2.subtitle1.text3": "except those indicated as FREE",
			"shippingPolicy.subtitle2.subtitle1.text4": "Las tarifas de envíos incluyen cargos por manipulación.",
			"shippingPolicy.subtitle.ArtMay": "Shipping to Havana has a rate of: $8.00 USD",
			"shippingPolicy.subtitle3": "Delivery terms:",
			"shippingPolicy.subtitle3.table.text1": "Food, drinks and liquors, jams, other market categories, hygiene and household supplies",
			"shippingPolicy.subtitle3.table.home-deli.text1": "Precooked and frozen products",
			"shippingPolicy.subtitle3.table.jardin-angelica.text1": "Flower arrangements and ceramics",
			"shippingPolicy.subtitle3.table.dolce-tentazione.text1": "Cakes and pies",
			"shippingPolicy.subtitle3.table.el-bodegon.text1": "Prepared and ready-to-eat food",
			"shippingPolicy.subtitle3.table.el-idilio.text1": "Pork leg",
			"shippingPolicy.subtitle3.table.lola-cafe.text1": "Candy store",
			"shippingPolicy.subtitle3.table.text2.10": "10 -12 business days depending on the destination.",
			"shippingPolicy.subtitle3.table.text2.7": "up to 7 business days",
			"shippingPolicy.subtitle3.table.home-deli.text2": "24 hours",
			"shippingPolicy.subtitle3.table.jardin-angelica.text2": "24 - 78 hours",
			"shippingPolicy.subtitle3.table.el idilio.text2": "up to 3 business days",
			"shippingPolicy.subtitle3.table.lola-cafe.text2": "up to 2 business days",
			"shippingPolicy.subtitle3.table.decoceramica.text1": "Decorative products made of ceramics, by hand.",
			"shippingPolicy.subtitle3.table.decoceramica.text2": "up to 10 business days",
			"shippingPolicy.subtitle3.table.decoceramica.text3": "Delivery every saturday",
			"shippingPolicy.subtitle3.table.text3": "Saturdays, Sundays and holidays are excluded.",
			"shippingPolicy.subtitle3.table.text3.2": "Deliveries every day in the schedule from 9:00 am to 6:00 pm",
			"shippingPolicy.subtitle3.table.text3.1": "Delivery every day",
			"shippingPolicy.subtitle3.table.text4": "Fresh food, meat, sausages, viands, grains.",
			"shippingPolicy.subtitle3.table.text5": "Appliances",
			"shippingPolicy.subtitle3.table.text6": "See delivery detail on the product.",
			"shippingPolicy.subtitle3.table.text7": "Imported products and hardware",
			"shippingPolicy.subtitle3.table.text9": "Some products in",
			"shippingPolicy.subtitle3.table.text10": "Shipments to the rest of the country -",
			"shippingPolicy.subtitle3.table.text11": "WE ARE NOT SHIPPING TO THE REST OF THE COUNTRY AT THE MOMENT.",
			"shippingPolicy.subtitle3.table.text12": "store are imported and their delivery times vary between 30 and 60 days. See delivery detail on the product before making the purchase.",
			"shippingPolicy.subtitle3.table.text13": "Estimated deadlines, will vary depending on the selected products",
			"shippingPolicy.subtitle3.table.text14": "Shipping rates and delivery time for",
			"shippingPolicy.subtitle3.table.text15": "STORES AND RESTAURANTS IN HAVANA:",
			"shippingPolicy.subtitle4": "Delivery rates by destinations:",
			"shippingPolicy.subtitle5": "Delivery times by destinations:",
			"shippingPolicy.subtitle5.text1": "Estimated deadlines, will vary depending on the selected products",
			"shippingPolicy.subtitle5.text2": "For the protection against fraud and / or misuse of credit cards,",
			"shippingPolicy.subtitle5.text3": "The right to delay the delivery of the products and / or services is attributed until the authenticity of the purchase is verified and, if deemed appropriate, will delve into the origin of any transaction carried out on the site, as established in the internal regulations of the company.",
			"shippingPolicy.subtitle5.text4": "The delivery times of the shipments or of the provision of the purchased services, begin to govern from the approval of the order once its authenticity has been verified.",
			"shippingPolicy.subtitle5.text5": "If you still have questions about the delivery time of your shipment, please do not hesitate to contact us:",
			"shippingPolicy.subtitle5.text6": "By email at the address",
			"shippingPolicy.subtitle5.text7": "By phone to",
			"shippingPolicy.subtitle5.text8": "Through our social networks",
			"shippingPolicy.subtitle6.text1": "(*) Estimated deadlines, will vary depending on the selected products",
			"shippingPolicy.subtitle6.text2": "Shipping rates and delivery time for",
			"shippingPolicy.subtitle6.text3": "STORES AND RESTAURANTS IN HAVANA",
			"shippingPolicy.subtitle6.text3.1": "(*) All orders can be canceled in less than 24 hours after the purchase is made. The recipient must review the product at the time of delivery, claims are not accepted without clear evidence that the product does not correspond to its description, or evidence that it is in poor condition. This claim will not be valid after 24 hours of delivery. For more information, refer to our",
			"shipping.lola_dulceria_cafe.description": "Repostería artesanal con recetas internacionales, ingredientes locales y sabores tradicionales cubanos. Dulces a base de biscocho, chocolate, canela y frutas tropicales, que buscan elaboraciones creativas y nutritivas para la familia cubana. La única cafetería en La Habana que oferta frozen yogurt con toppins variados. Los productos más populares son los pastelitos de guayaba, rollitos de canela, pastel de hojaldre, galleticas de jengibre y frozen yogurt.",
			"shipping.lola_dulceria_cafe.notes": "It is recommended to consume the sweets that contain custard the same day of delivery, as they are prepared with natural ingredients, a recipe from Lola Café, and do not contain added preservatives or preservatives.",
			"shipping.jardin_angelica.description": "Preparation of flower arrangements of all kinds, as well as interior and exterior decoration. Mainly natural elements, ornamental plants and flowers are used.",
			"shipping.jardin_angelica.notes": "For a better conservation of flowers, it is recommended to keep them in cold places, working with imported flowers, sensitive to high temperatures.",
			"shipping.casa_mia.description": "Project dreamed of by two brothers and their cousin, turning the house where they were born into a place where you can taste exquisite food, with a beautiful view of the sea.",
			"shipping.dulce_tentazione.description": "Center for the production of fine European-style sweets where you can order cakes for various occasions. Semi-cold sweets are made as delicious mousses of various flavors and exquisite pies.",
			"shipping.home_deli.description": "The specialties are pre-made and frozen products. Gourmet offers to the comfort of your home. Italian and Creole food made / pre-made, vacuum sealed and frozen.",
			"shipping.home_deli.delivery": "72 hr * Does not deliver on Sundays.",
			"shipping.home_deli.notes": "It is recommended to follow the chef's instructions written on the packaging for the preparation of the products. This will guarantee a greater enjoyment of them.",
			"shipping.idilio.description": "Creole and international food, and specialty of charcoal food.",
			"shipping.idilio.delivery": "24 hr <br/>72 hr combos.",
			"shipping.chic-salon.description": "Bring the beauty salon to your home. Specialized service in hairdressing, manicuri, pedicuri and exclusive treatments from the comfort of your home.",
			"shipping.chic-salon.delivery": "5 days",
			"shipping.deco-ceramica.description": "Items aimed at home decoration, where you can customize the decoration by assembling the design to your liking to make it reach your home. The quality of the ceramics is authentic and original. There are many types of ornaments such as vases of all sizes and variety in designs, centerpieces with different styles and colors, and other items where each piece is unique.",
			"shipping.deco-ceramica.delivery": "10 days * Delivery only saturdays",
			"shipping.andale.description": "Mexican food restaurant with home delivery to all of Havana. Varied menu of tacos, burritos, quesadillas and other Mexican snacks, special to share on any occasion. If you want to taste the authentic flavor of Mexico in the comfort of your home, we are your option... Ándale Ándale!!!!",
			"shipping.peke-art.delivery": "10 days",
			"shipping.peke-art.description": "Workshop that produces and markets handcraft and design, useful and decorative items, made with different materials. Ideal both for setting and decorating spaces, as well as for the gift of gifts on any occasion that deserves a special detail and an original design.",
			"shipping.magoz.delivery": "20 days",
			"shipping.magoz.description": "<div>On-demand photography agency where several photography and video professionals work in a coordinated manner under the same brand. You can book photography sessions for events such as weddings, quinceañeras, private family or institutional events. Photography of products and advertising, interiors and spaces, for personal dossiers, for social networks, in short, everything you need can be found in this space dedicated to achieving the best image for you.</div><div>Sale of originals of printed and framed photographs for decoration of private or institutional spaces. Photography classes are also offered for those interested in exploring this exciting world of imaging.</div>",
			"shipping.boquitas.description": "Specialized in sandwiches, Tic-Tac proposes 50 different combinations to place on the house baguette. From cheese to beef, bacon or grilled shrimp. Boquitas is full of options to meet the needs of customers, the same alone as in groups. Special tables where they place cheeses, sausages, vegetables and breads, mouthfuls that turn into largemouth twice as rich and at a lower price, and combos, which offer snacks and drinks for the same price. For the Tic-Tac team the thing is simple: so that \"you come, come back and repeat\".",
			"shipping.la-guarida.description": "La Guarida is an opportunity to travel back in time, from yesterday to tomorrow, a place that respects traditions but is committed to the future, an authentic space for those interested in knowing the real Cuba and delving into our culture, customs and ways of doing.",
			"shipping.ya-voy.description": "Ya Voy is the merger of 4 successful restaurants in Havana that when the pandemic arrived and closed, they continued to meet the expectations of their customers with a new Home Service. Ya Voy complied with the Cuban Family despite the regrets, managed to take their dishes to each house fulfilling an invaluable function, with very high costs and very low profits. Thank you for the trust you have placed, today with more experience we try to be better every day.",
			"shipping.atlas-implementos-deportivos.description": "Brand of sporting goods, dedicated to physical preparation and combat sports. Implements for training various combat sports, both grappling and striking. Variety of punching bags, pets, shields and kickers. Our fitness products are an excellent option for exercising, both in gyms and personally at home. Sandbags, medicine balls, and vests are ideal for maintaining good muscle tone.",
			"shipping.la-caja.description": "Project that is part of the creation group of Humidores Habana created more than 20 years ago. Our work is mainly aimed at creating pieces for special moments such as anniversaries and birthdays. There are also utilitarian items such as handcrafted containers of various colors and wood color, also for decorative purposes, and wooden plate holders.",
			"shipping.la-caja.delivery": "5 days",
			"shipping.la-caja.notes": "For the customization of any item, contact Customer Service once the purchase has been made.",
			"shipping.la-brisca.description": "Educational board games for all members of the Home.",
			"shipping.reyes-manso.description": "Pre-made frozen foods (among others) ready to cook in minutes and enjoy a delicious meal. Experts in taking your food to your home in optimal conditions and with the hygienic sanitary measures necessary for your safety and that of your family.",
			"shipping.humidores-habana.delivery": "5 days",
			"shipping.humidores-habana.description": "Cuban creation group dedicated to the design and production of exclusive humidors through the fusion of techniques such as goldsmithing, cabinetmaking and marquetry. All items can be personalized with phrases and logos.",
			"shipping.humidores-habana.notes": "For the customization of any item, contact Customer Service once the purchase has been made.",
			"shipping.zig-zag.delivery": "7 days",
			"shipping.zig-zag.description": "Online handicrafts and gifts store where we try to rescue handicrafts mainly made with thread.",
			"shipping.dforja.delivery": "5 days",
			"shipping.dforja.description": "Utilitarian and decorative metal and wood articles for the house.",
			"shipping.sinmolde.description": "Various and colorful utility and design products for all tastes and needs.",
			"shipping.bodegon-asado.description": "Creole Food Restaurant",
			"shipping.picabu.description": "Picabú is a store dedicated mainly to babies and children, which also seeks to accompany motherhood and fatherhood with practical and functional items that, at the same time, give great value to aesthetics. Pacifier holders, teethers, breastfeeding necklaces, decorative foils, organizers, among others; Most of the proposals are customizable, so they constitute a very useful element in daily life with a child and, in addition, they must become a beautiful memory of these stages. The materials used are very safe for the baby, free of toxic elements and respectful of the environment.",
			"shippingPolicy.any_question": "If you still have questions about delivery terms and conditions, please contact us through the <b>Chat</b> available on the site <b><a href=\"https://www.cubalicores.com\">www.cubalicores.com</a></b> or by email <a href=\"mailto:info@cubalicores.com\">info@cubalicores.com</a>. Our support representatives will receive your message and respond to you as soon as possible.",
			"shippingTotal": "Shipping Total",
			"shopping-cart": "Shopping Cart",
			"signOut": "Sign Out",
			"signUp": "Sign Up",
			"signin": "Sign In",
			"signup": "Sign Up",
			"signup-for": "Sign Up",
			"state": "State or Province",
			"subheading": "Please select a shipping method.",
			"subject": "Subject",
			"successMessage": "Your Order has been placed successfully!",
			"summaryHeader": "Order Summary",
			"term-and-conditions": "Terms & Conditions",
			"terms-conditions-title": "Terms of Use Agreement",
			"terms-conditions-text1": "This Agreement was last revised on February 17th, 2021.",
			"terms-conditions-text2": "Welcome to CubaLicores, the website and online marketplace service (\"Othar Trade & Logistics Spain,” \"we,\" or \"us\"). This page explains the terms by which you may use our online and/or mobile services, web site, and software provided on or in connection with Othar Trade & Logistics Spain (collectively the \"Service\"). By accessing or using the Service, you agree that you have read, understood, and agree to be bound by these Terms of Use (the \"Agreement\"), whether or not you are a registered user of our Service.",
			"terms-conditions-text3": "We reserve the right to amend this Agreement at any time by notifying you as provided in the “Notifications” section of this Agreement, provided that no notice shall be required or given for non-substantive changes to the Agreement. If we substantively amend this Agreement, we will give you at least seven (7) days notice before the changes take effect, during which period of time you may reject the changes by terminating your account. Your continued use of the Service after any such change takes effect constitutes your acceptance of the new Terms of Use. If you do not agree to any of these terms or any future Terms of Use, your only remedy shall be to not use or access (or continue to access) the Service. This Agreement applies to all visitors, users, and others who access the Service (\"Users\").",
			"terms-conditions-subheader1": "USE OF OUR SERVICE",
			"terms-conditions-subheader1-subtitle1": "ELIGIBILITY",
			"terms-conditions-subheader1-subtitle1-text1": "You may use the Service only if you can form a binding contract with Othar Trade & Logistics Spain, and only in compliance with this Agreement and all applicable local, state, national, and international laws, rules and regulations. If you are under 18, your parent or guardian must enter into this Agreement on your behalf, and will be responsible for your use of and access to the Service; this includes financial responsibility for any items you purchase through the Service. Any use or access to the Service by anyone under 13 is strictly prohibited and in violation of this Agreement. If you are under 13, please do not attempt to register for the Service or send any information about yourself to us, including your name, address, telephone number, or email address. If we learn that we have collected personal information from anyone under age 13 without verification of parental consent, we will delete that information as quickly as possible. If you believe that we might have any information from or about anyone under 13, please contact us at ",
			"terms-conditions-subheader1-subtitle1-text2": ". The Service is not available to any Users previously removed from the Service by Othar Trade & Logistics Spain. Othar Trade & Logistics Spain reserves all rights not expressly granted under this Agreement. Any attempt by you to transfer any of the rights, duties or obligations hereunder, except as expressly provided for in this Agreement, is void.",
			"terms-conditions-subheader1-subtitle2": "Othar Trade & Logistics Spain ACCOUNTS",
			"terms-conditions-subheader1-subtitle2-text1": "You must create an account at Othar Trade & Logistics Spain in order to gain access to the services and functionality that we may establish and maintain from time to time and in our sole discretion. You may never use another User's account without permission. You are solely responsible for the activity that occurs on your account, and you must keep your account password secure. You must notify Othar Trade & Logistics Spain immediately of any breach of security or unauthorized use of your account. Othar Trade & Logistics Spain will not be liable for any losses caused by any unauthorized use of your account.",
			"terms-conditions-subheader1-subtitle2-text2": "The Service is available through Facebook’s “Facebook Connect” service. [You must have an active Facebook account in order to access the Service through Facebook Connect], and you hereby represent and warrant that you have read and agreed to be bound by all applicable Facebook policies and will act in accordance with those policies, in addition to your obligations under this Agreement. If you access the Service through Facebook Connect, Othar Trade & Logistics Spain may require that your Othar Trade & Logistics Spain user ID be the same as your user name for Facebook. If you sign into Othar Trade & Logistics Spain through Facebook Connect, you will provide your Facebook account credentials to Othar Trade & Logistics Spain, and you are consenting to have the information in that account transmitted into your Othar Trade & Logistics Spain account, and you agree that you shall only use Facebook accounts owned by you, and not by any other person or entity.",
			"terms-conditions-subheader1-subtitle2-text3": "By providing Othar Trade & Logistics Spain your email address, you consent to our using that email address to send you Service-related notices, including any notices required by law, in lieu of communication by postal mail. We may also use your email address to send you other messages, such as changes to features of the Service and special offers. If you do not want to receive such email messages, you may opt out or change your preferences in your account settings at ",
			"terms-conditions-subheader1-subtitle2-text4": ". Opting out may prevent you from receiving email messages regarding updates, improvements, or offers. Please note that if you do not want to receive legal notices from us, including without limitation a notification that this Agreement has changed, those legal notices will still govern your use of the Service. We will post legal notices to the Service, and you are responsible for reviewing such legal notices for changes. Please see our ",
			"terms-conditions-subheader1-subtitle2-text5": " for more details.",
			"terms-conditions-subheader1-subtitle3": "SERVICE RULES",
			"terms-conditions-subheader1-subtitle3-text1": "You agree not to engage in any of the following prohibited activities in connection with the Service: (i) copying, distributing, or disclosing any part of the Service in any medium, including without limitation by any automated or non-automated \"scraping\"; (ii) using any automated system, including without limitation \"robots,\" \"spiders,\" \"offline readers,\" etc., to access the Service in a manner that sends more request messages to the Othar Trade & Logistics Spain servers than a human can reasonably produce in the same period of time by using a conventional on-line web browser (except that, subject to the privacy settings of our Users, Othar Trade & Logistics Spain grants the operators of public search engines revocable permission to use spiders to copy materials from Othar Trade & Logistics Spain for the sole purpose of and solely to the extent necessary for creating publicly available searchable indices of the materials, but not caches or archives of such materials); (iii) transmitting spam, chain letters, or other unsolicited email; (iv) attempting to interfere with, compromise the system integrity or security or decipher any transmissions to or from the servers running the Service; (v) taking any action that imposes, or may impose at our sole discretion an unreasonable or disproportionately large load on our infrastructure; (vi) uploading invalid data, viruses, worms, or other software agents through the Service; (vii) collecting or harvesting any personally identifiable information, including account names, from the Service; (viii) using the Service for any commercial purposes; (ix) impersonating another person or otherwise misrepresenting your affiliation with a person or entity, conducting fraud, hiding or attempting to hide your identity; (x) interfering with the proper working of the Service; (xi) accessing any content on the Service through any technology or means other than those provided or authorized by the Service; (xii) bypassing the measures we may use to prevent or restrict access to the Service, including without limitation features that prevent or restrict use or copying of any content or enforce limitations on use of the Service or the content therein, or (xiii) decompiling, reverse engineering, or otherwise attempting to obtain the source code of the Service.",
			"terms-conditions-subheader1-subtitle3-text2": "Accessing the audiovisual content available on the Service for any purpose or in any manner other than Streaming (as defined below) is expressly prohibited. “Streaming” means a contemporaneous digital transmission of an audiovisual work via the Internet from the Othar Trade & Logistics Spain Service to a User’s device in such a manner that the data is intended for real-time viewing and not intended to be copied, stored, permanently downloaded, or redistributed by the User.",
			"terms-conditions-subheader1-subtitle3-text3": "We may, without prior notice, change the Service, stop providing the Service or features of the Service (to you or generally), or create usage limits for the Service. We may permanently or temporarily terminate or suspend your access to the Service without notice or liability to Othar Trade & Logistics Spain , for any reason or for no reason, including if in our sole determination you violate any provision of this Agreement. Upon termination of this Agreement or your access to the Service for any reason or no reason, you will continue to be bound by the terms of this Agreement which, by their nature, should survive termination, including without limitation ownership provisions, warranty disclaimers, indemnity, and limitations of liability.",
			"terms-conditions-subheader1-subtitle3-text4": "You are solely responsible for your interactions with other Othar Trade & Logistics Spain Users. We reserve the right, but have no obligation, to monitor disputes between you and other Users. Othar Trade & Logistics Spain shall have no liability for your interactions with other Users, or for any User's action or inaction.",
			"terms-conditions-subheader1-subtitle4": "USER CONTENT",
			"terms-conditions-subheader1-subtitle4-text1": "Some areas of the Service allow Users to post content such as photos and profile information, comments, questions, and other content or information (any such materials a User submits, posts, displays, or otherwise makes available on the Service are referred to as \"User Content\").",
			"terms-conditions-subheader1-subtitle4-text2": "You agree not to post User Content that: (i) may create a risk of harm, loss, physical or mental injury, emotional distress, death, disability, disfigurement, or physical or mental illness to you, to any other person, or to any animal; (ii) may create a risk of any other loss or damage to any person or property; (iii) seeks to harm or exploit children by exposing them to inappropriate content, asking for personally identifiable details or otherwise; (iv) may constitute or contribute to a crime or tort; (v) contains any information or content that we deem to be unlawful, harmful, abusive, racially or ethnically offensive, defamatory, infringing, invasive of personal privacy or publicity rights, harassing, humiliating to other people (publicly or otherwise), libelous, threatening, profane, obscene, pornographic, or otherwise objectionable; (vi) contains any information or content that is illegal (including, without limitation, the disclosure of insider information under securities law or of another party's trade secrets); (vii) contains any information or content that you do not have a right to make available under any law or under contractual or fiduciary relationships; or (viii) contains any information or content that you know is not correct and current. You agree that any User Content that you post does not and will not violate third-party rights of any kind, including without limitation any Intellectual Property Rights (as defined below) or rights of privacy. To the extent that your User Content contains music, you hereby represent that you are the owner of or possess all rights to all the copyright rights, including without limitation the performance, mechanical, and sound recordings rights, with respect to each and every musical composition (including lyrics) and sound recording contained in such User Content and have the power to grant the license granted below. Othar Trade & Logistics Spain reserves the right, but is not obligated, to reject and/or remove any User Content that Othar Trade & Logistics Spain believes, in its sole discretion, violates these provisions. You understand that publishing your User Content on the Service is not a substitute for registering it with the U.S. Copyright Office, the Writer's Guild of America, or any other rights organization.",
			"terms-conditions-subheader1-subtitle4-text3": "For the purposes of this Agreement, \"Intellectual Property Rights\" means all patent rights, copyright rights, mask work rights, moral rights, rights of publicity, trademark, trade dress and service mark rights, goodwill, trade secret rights and other intellectual property rights as may now exist or hereafter come into existence, and all applications therefore and registrations, renewals and extensions thereof, under the laws of any state, country, territory or other jurisdiction.",
			"terms-conditions-subheader1-subtitle4-text4": "In connection with your User Content, you affirm, represent and warrant the following:",
			"terms-conditions-subheader1-subtitle4-text4-1": "You have the written consent of each and every identifiable natural person in the User Content to use such person's name or likeness in the manner contemplated by the Service and this Agreement, and each such person has released you from any liability that may arise in relation to such use.",
			"terms-conditions-subheader1-subtitle4-text4-2": "Your User Content and Othar Trade & Logistics Spain's use thereof as contemplated by this Agreement and the Service will not violate any law or infringe any rights of any third party, including but not limited to any Intellectual Property Rights and privacy rights.",
			"terms-conditions-subheader1-subtitle4-text4-3": "Othar Trade & Logistics Spain may exercise the rights to your User Content that are granted to Othar Trade & Logistics Spain under this Agreement, without payment of any guild fees, residuals, payments, fees, or royalties payable under any collective bargaining agreement or otherwise.",
			"terms-conditions-subheader1-subtitle4-text4-4": "All your User Content and other information that you provide to us is truthful and accurate.",
			"terms-conditions-subheader1-subtitle4-text5": "Othar Trade & Logistics Spain takes no responsibility and assumes no liability for any User Content that you or any other User or third party posts or sends over the Service. You shall be solely responsible for your User Content and the consequences of posting or publishing it, and you agree that we are only acting as a passive conduit for your online distribution and publication of your User Content. You understand and agree that you may be exposed to User Content that is inaccurate, objectionable, inappropriate for children, or otherwise unsuited to your purpose, and you agree that Othar Trade & Logistics Spain shall not be liable for any damages you incur or allege to incur as a result of User Content.",
			"terms-conditions-subheader1-subtitle4-text6": "By posting any User Content on the Service, you hereby expressly grant, and you represent and warrant that you have a right to grant, to Othar Trade & Logistics Spain a royalty-free, sub licensable, transferable, perpetual, irrevocable, non-exclusive, worldwide license to use, reproduce, modify, publish, list information regarding, edit, translate, distribute, syndicate, publicly perform, publicly display, and make derivative works of all such User Content and your name, voice, and/or likeness as contained in your User Content, in whole or in part, and in any form, media or technology, whether now known or hereafter developed, for use in connection with the Service and Othar Trade & Logistics Spain's (and its successors' and affiliates') business, including without limitation for promoting and redistributing part or all of the Service (and derivative works thereof) in any media formats and through any media channels; however, Othar Trade & Logistics Spain will only share your personally identifiable information in accordance with our then-current Privacy Policy. You also hereby grant each User of the Service a non-exclusive license to access your User Content through the Service, and to use, reproduce, distribute, display and perform such User Content as permitted through the functionality of the Service and under this Agreement.",
			"terms-conditions-subheader1-subtitle4-text7": ". You also hereby grant each User of the Service a non-exclusive license to access your User Content through the Service, and to use, reproduce, distribute, display and perform such User Content as permitted through the functionality of the Service and under this Agreement.",
			"terms-conditions-subheader2": "END USER LICENSE GRANT",
			"terms-conditions-subheader2-subtitle1": "Othar Trade & Logistics Spain SERVICE",
			"terms-conditions-subheader2-subtitle1-text1": "Subject to the terms and conditions of this Agreement, you are hereby granted a non-exclusive, limited, non-transferable, freely revocable license to use the Service for your personal, non-commercial use, as permitted by the features of the Service. Othar Trade & Logistics Spain reserves all rights not expressly granted herein in the Service and the Othar Trade & Logistics Spain Content (as defined below). Othar Trade & Logistics Spain may terminate this license at any time for any reason or no reason.",
			"terms-conditions-subheader2-subtitle2": "MOBILE SOFTWARE",
			"terms-conditions-subheader2-subtitle2-text1": "We may make available software to access the Service via a mobile device (\"Mobile Software\"). To use the Mobile Software you must have a mobile device that is compatible with the Mobile Service. Othar Trade & Logistics Spain does not warrant that the Mobile Software will be compatible with your mobile device. Othar Trade & Logistics Spain hereby grants you a non-exclusive, non-transferable, revocable license to use a compiled code copy of the Mobile Software for one Othar Trade & Logistics Spain account on one mobile device owned or leased solely by you, for your personal, non-commercial use. You may not: (i) modify, disassemble, decompile or reverse engineer the Mobile Software, except to the extent that such restriction is expressly prohibited by law; (ii) rent, lease, loan, resell, sublicense, distribute or otherwise transfer the Mobile Software to any third party or use the Mobile Software to provide time sharing or similar services for any third party; (iii) make any copies of the Mobile Software; (iv) remove, circumvent, disable, damage or otherwise interfere with security-related features of the Mobile Software, features that prevent or restrict use or copying of any content accessible through the Mobile Software, or features that enforce limitations on use of the Mobile Software; or (v) delete the copyright and/or other proprietary rights notices on the Mobile Software. You acknowledge that Othar Trade & Logistics Spain may from time to time issue upgraded versions of the Mobile Software, and may automatically electronically upgrade the version of the Mobile Software that you are using on your mobile device. You consent to such automatic upgrading on your mobile device, and agree that the terms and conditions of this Agreement will apply to all such upgrades. Any third-party code that may be incorporated in the Mobile Software is covered by the applicable open source or third-party license EULA, if any, authorizing use of such code. The foregoing license grant is not a sale of the Mobile Software or any copy thereof, and Othar Trade & Logistics Spain or its third party partners or suppliers retain all right, title, and interest in the Mobile Software (and any copy thereof). If the Mobile Software is being acquired on behalf of the United States Government, then the following provision applies. Use, duplication, or disclosure of the Mobile Software by the U.S. Government is subject to restrictions set forth in this Agreement and as provided in DFARS 227.7202-1(a) and 227.7202-3(a) (1995), DFARS 252.227-7013(c)(1)(ii) (OCT 1988), FAR 12.212(a) (1995), FAR 52.227-19, or FAR 52.227-14 (ALT III), as applicable. The Mobile Software originates in the United States, and is subject to United States export laws and regulations. The Mobile Software may not be exported or re-exported to certain countries or those persons or entities prohibited from receiving exports from the United States. In addition, the Mobile Software may be subject to the import and export laws of other countries. You agree to comply with all United States and foreign laws related to use of the Mobile Software and the Othar Trade & Logistics Spain Service.",
			"terms-conditions-subheader2-subtitle3": "MOBILE SOFTWARE FROM ITUNES",
			"terms-conditions-subheader2-subtitle3-text1": "The following applies to any Mobile Software you acquire from the Apple, Inc. (“Apple”) App Store (\"Apple-Sourced Software\"): You acknowledge and agree that this Agreement is solely between you and Othar Trade & Logistics Spain, not Apple, and that Apple has no responsibility for the Apple-Sourced Software or content thereof. Your use of the Apple-Sourced Software must comply with the App Store Terms of Service. You acknowledge that Apple has no obligation whatsoever to furnish any maintenance and support services with respect to the Apple-Sourced Software. In the event of any failure of the Apple-Sourced Software to conform to any applicable warranty, you may notify Apple of such failure; upon such notification, Apple’s sole warranty to you will be to refund the purchase price for the Apple-Sourced Software, if any. To the maximum extent permitted by applicable law, Apple will have no other warranty obligation whatsoever with respect to the Apple-Sourced Software, and any other claims, losses, liabilities, damages, costs or expenses attributable to any failure to conform to any warranty will be solely governed by this Agreement and any law applicable to Othar Trade & Logistics Spain as provider of the Apple-Sourced Software. You acknowledge that Othar Trade & Logistics Spain, and not Apple, is responsible for addressing any claims of you or any third party relating to the Apple-Sourced Software or your possession and/or use of the Apple-Sourced Software, including, but not limited to: (i) product liability claims; (ii) any claim that the Apple-Sourced Software fails to conform to any applicable legal or regulatory requirement; and (iii) claims arising under consumer protection or similar legislation; and all such claims are governed solely by this Agreement and any law applicable to Othar Trade & Logistics Spain as provider of the software. You acknowledge that, in the event of any third party claim that the Apple-Sourced Software or your possession and use of that Apple-Sourced Software infringes that third party's intellectual property rights, Othar Trade & Logistics Spain, not Apple, will be solely responsible for the investigation, defense, settlement and discharge of any such intellectual property infringement claim to the extent required by this Agreement. You and Othar Trade & Logistics Spain acknowledge and agree that Apple, and Apple's subsidiaries, are third party beneficiaries of this Agreement as relates to your license of the Apple-Sourced Software, and that, upon your acceptance of the terms and conditions of this Agreement, Apple will have the right (and will be deemed to have accepted the right) to enforce this Agreement as relates to your license of the Apple-Sourced Software against you as a third party beneficiary thereof. You will only use the Apple-Sourced Software in connection with an Apple device that you own or control. You will comply with any applicable third-party terms of agreement which may affect or be affected by your use of the Apple-Sourced Software.",
			"terms-conditions-subheader2-subtitle4": "OUR PROPRIETARY RIGHTS",
			"terms-conditions-subheader2-subtitle4-text1": "Except for your User Content, the Service and all materials therein or transferred thereby, including, without limitation, software, images, text, graphics, illustrations, logos, patents, trademarks, service marks, copyrights, photographs, audio, videos, music, and User Content (the \"Othar Trade & Logistics Spain Content\"), and all Intellectual Property Rights related thereto, are the exclusive property of Othar Trade & Logistics Spain and its licensors. Except as explicitly provided herein, nothing in this Agreement shall be deemed to create a license in or under any such Intellectual Property Rights, and you agree not to sell, license, rent, modify, distribute, copy, reproduce, transmit, publicly display, publicly perform, publish, adapt, edit or create derivative works from any materials or content accessible on the Service. Use of the Othar Trade & Logistics Spain Content or materials on the Service for any purpose not expressly permitted by this Agreement is strictly prohibited.",
			"terms-conditions-subheader2-subtitle4-text2": "You may choose to or we may invite you to submit comments or ideas about the Service, including without limitation about how to improve the Service or our products (\"Ideas\"). By submitting any Idea, you agree that your disclosure is gratuitous, unsolicited and without restriction and will not place Othar Trade & Logistics Spain under any fiduciary or other obligation, and that we are free to use the Idea without any additional compensation to you, and/or to disclose the Idea on a non-confidential basis or otherwise to anyone. You further acknowledge that, by acceptance of your submission, Othar Trade & Logistics Spain does not waive any rights to use similar or related ideas previously known to Othar Trade & Logistics Spain , or developed by its employees, or obtained from sources other than you.",
			"terms-conditions-subheader2-subtitle5": "CUBALICORES REFERRAL CREDITS",
			"terms-conditions-subheader2-subtitle5-text1": "Othar Trade & Logistics Spain may provide Othar Trade & Logistics Spain members referral credits when members invite their friends to join Othar Trade & Logistics Spain (“Referral Credits”). Referral Credits may be awarded to the referrer when her friends join, as well as when her friends make their first purchases.",
			"terms-conditions-subheader2-subtitle5-text2": "Referral Credits are granted at Othar Trade & Logistics Spain ’s sole discretion. In order for a member to be eligible to receive Referral Credits for friends joining Othar Trade & Logistics Spain , the new friend must join Othar Trade & Logistics Spain via the referring member's unique referral link. Referral Credits are loyalty or promotional discounts or credits offered by Othar Trade & Logistics Spain , and do not constitute an account, a payment instrument or other property owned by any Othar Trade & Logistics Spain member. Referral Credits do not have a cash value, and you may only use Referral Credits in connection with a qualifying purchase on the Othar Trade & Logistics Spain website. Othar Trade & Logistics Spain reserves the right to revoke your Referral Credits if Othar Trade & Logistics Spain determines that you have engaged in fraudulent referral activity (e.g. inviting fake people to join Othar Trade & Logistics Spain ) or otherwise violated our Terms of Use, or or if we terminate your membership. Referral credits expire 6 months after they are granted. Referral credits are not transferable or sellable, are not gift cards, and cannot be used to purchase Othar Trade & Logistics Spain gift cards. Othar Trade & Logistics Spain reserves the right at any time without notice to you to change the terms applicable to the Referral Credits, including expiration period and/or your ability to redeem existing Referral Credits, Othar Trade & Logistics Spain does not impose any fee on your use of Referral Credits. To see your Referral Credits",
			"terms-conditions-subheader2-subtitle5-text3": "please click here",
			"terms-conditions-subheader2-subtitle6": "CUBALICORES E-GIFT CARDS",
			"terms-conditions-subheader2-subtitle6-text1": "Othar Trade & Logistics Spain e-gift cards (\"E-Cards\") may be used to purchase any eligible product available for purchase in Othar Trade & Logistics Spain online catalog. In order to purchase or redeem an E-Card, you must have a Othar Trade & Logistics Spain account. The recipient of an E-Card will be notified via email; if the recipient does not have a Othar Trade & Logistics Spain account at the time he or she receives such email, he or she will be prompted to create a Othar Trade & Logistics Spain account to activate the E-Card.",
			"terms-conditions-subheader2-subtitle6-text2": "You may purchase E-Cards in US dollar denominations of $25, $50, $75 and $100. The amount of the E-Card you purchase will be charged to your credit card when you confirm your purchase of such E-Card. The purchase of E-Cards is governed by the terms set forth under “Orders” in the Top 10 Questions about ",
			"terms-conditions-subheader2-subtitle6-text3": ", except as otherwise provided in this section.",
			"terms-conditions-subheader2-subtitle6-text4": "Once the recipient of the E-Card activates the E-Card, then the value of the E-Card will appear in the recipient's Othar Trade & Logistics Spain account as a credit toward purchases on Othar Trade & Logistics Spain If a purchase exceeds the amount of the E-Card, the balance must be paid by credit card or other available payment method, in accordance with Othar Trade & Logistics Spain standard",
			"terms-conditions-subheader2-subtitle6-text5": "payment policies",
			"terms-conditions-subheader2-subtitle6-text6": ". E- Cards cannot be used to purchase other E-Cards. Purchases made with E-Cards are not eligible to earn Referral Credits. E-Cards do not expire.",
			"terms-conditions-subheader2-subtitle6-text7": "Except where prohibited by applicable law, E-Card recipients may not (a) receive refunds for E-Cards, (b) resell or otherwise transfer E-Cards to others (including without limitation transferring E-Cards to other Othar Trade & Logistics Spain Users’ accounts), (c) reload E-Cards, or (d) redeem unused E-Card balances if they cancel their Othar Trade & Logistics Spain account. E- Cards are not currency, and do not have cash value outside of Othar Trade & Logistics Spain . Othar Trade & Logistics Spain is not responsible for any unauthorized use of an E-Card.",
			"terms-conditions-subheader2-subtitle7": "CUBALICORES FREE SHIPPING OFFERS",
			"terms-conditions-subheader2-subtitle7-text1": "From time to time Othar Trade & Logistics Spain may offer free shipping promotions to its members. Othar Trade & Logistics Spain Free Shipping Offers are valid on standard shipping only. Othar Trade & Logistics Spain free shipping offers may not be used for international shipping nor for shipment of \"non-standard\" items. Additional terms and limitations may apply at the time of offer.",
			"terms-conditions-subheader3": "PAID SERVICES",
			"terms-conditions-subheader3-subtitle1": "BILLING POLICIES",
			"terms-conditions-subheader3-subtitle1-text1": "Certain features of the Service may be provided for a fee or other charge. If you elect to use paid features of the Service, you agree to the pricing and payment terms for such paid features that we will provide to you and that we may update them from time to time. Othar Trade & Logistics Spain may add new services for additional fees and charges, or amend fees and charges for existing services, at any time in its sole discretion. Any change to our pricing or payment terms shall become effective in the billing cycle following notice of such change to you. If you do not wish to pay the new or modified fees or charges, your sole remedy shall be to terminate your access to the applicable services.",
			"terms-conditions-subheader3-subtitle1-text2": "If you purchase an item through the Service, your purchase will be processed in accordance with the “Orders” section of our ",
			"terms-conditions-subheader3-subtitle1-text3": "Top 10 Questions",
			"terms-conditions-subheader3-subtitle1-text4": ", delivered to you according to our ",
			"terms-conditions-subheader3-subtitle1-text5": "Shipping Policies",
			"terms-conditions-subheader3-subtitle1-text6": ", and, if applicable, returns will be handled in accordance with our ",
			"terms-conditions-subheader3-subtitle1-text7": ", all of which are incorporated herein by this reference.",
			"terms-conditions-subheader3-subtitle2": "REFUNDS",
			"terms-conditions-subheader3-subtitle2-text1": "You may cancel your Othar Trade & Logistics Spain account at any time; however, there are no refunds for cancellation of the Service, if you have elected to use paid features of the Service. In the event that Othar Trade & Logistics Spain suspends or terminates your account or this Agreement for your breach of this Agreement, you understand and agree that you shall receive no refund or exchange for any Othar Trade & Logistics Spain Property, any unused time on a subscription, any license or subscription fees for any portion of the Service, any content or data associated with your account, or for anything else.",
			"terms-conditions-subheader3-subtitle2-text2": "Refunds for returned purchases will be handled in accordance with our",
			"terms-conditions-subheader3-subtitle3": "PAYMENT INFORMATION: TAXES",
			"terms-conditions-subheader3-subtitle3-text1": "All information that you provide in connection with a purchase or transaction or other monetary transaction interaction with the Service must be accurate, complete, and current. You agree to pay all charges incurred by users of your credit card, debit card, or other payment method used in connection with a purchase or transaction or other monetary transaction interaction with the Service at the prices in effect when such charges are incurred. You will pay any applicable taxes, if any, relating to any such purchases, transactions or other monetary transaction interactions. For more details on orders, please see our",
			"terms-conditions-subheader3-subtitle4": "PRIVACY",
			"terms-conditions-subheader3-subtitle4-text1": "We care about the privacy of our Users.",
			"terms-conditions-subheader3-subtitle4-text2": " to view our Privacy Policy, which is incorporated herein by this reference. By using the Service, you are consenting to have your personal data collected, used, transferred to and processed in the United States in accordance with our then-current Privacy Policy.",
			"terms-conditions-subheader3-subtitle5": "SECURITY",
			"terms-conditions-subheader3-subtitle5-text1": "Othar Trade & Logistics Spain cares about the integrity and security of your personal information. However, we cannot guarantee that unauthorized third parties will never be able to defeat our security measures or use your personal information for improper purposes. You acknowledge that you provide your personal information at your own risk.",
			"terms-conditions-subheader3-subtitle6": "DMCA NOTICE",
			"terms-conditions-subheader3-subtitle6-text1": "Since we respect artist and content owner rights, it is Othar Trade & Logistics Spain's policy to respond to alleged infringement notices that comply with the Digital Millennium Copyright Act of 1998 (\"DMCA\").",
			"terms-conditions-subheader3-subtitle6-text2": "If you believe that your copyrighted work has been copied in a way that constitutes copyright infringement and is accessible via the Service, please notify Othar Trade & Logistics Spain as set forth in the DMCA. For your complaint to be valid under the DMCA, you must provide the following information in writing:",
			"terms-conditions-subheader3-subtitle6-text2-1": "An electronic or physical signature of a person authorized to act on behalf of the copyright owner;",
			"terms-conditions-subheader3-subtitle6-text2-2": "Identification of the copyrighted work that you claim has been infringed;",
			"terms-conditions-subheader3-subtitle6-text2-3": "Identification of the material that is claimed to be infringing and where it is located on the Service;",
			"terms-conditions-subheader3-subtitle6-text2-4": "Information reasonably sufficient to permit Othar Trade & Logistics Spain to contact you, such as your address, telephone number, and, e-mail address;",
			"terms-conditions-subheader3-subtitle6-text2-5": "A statement that you have a good faith belief that use of the material in the manner complained of is not authorized by the copyright owner, its agent, or law; and",
			"terms-conditions-subheader3-subtitle6-text2-6": "A statement, made under penalty of perjury, that the above information is accurate, and that you are the copyright owner or are authorized to act on behalf of the owner.",
			"terms-conditions-subheader3-subtitle6-text3": "Once proper, bona fide infringement notification is received, it is our policy:",
			"terms-conditions-subheader3-subtitle6-text3-1": "To remove or disable access to the infringing material;",
			"terms-conditions-subheader3-subtitle6-text3-2": "To notify the content provider, member or user that we have removed or disabled access to the material;",
			"terms-conditions-subheader3-subtitle6-text3-3": "That repeat offenders will have the infringing material removed from the system and that we will terminate such content provider’s, member’s or user’s access to the Service.",
			"terms-conditions-subheader3-subtitle6-text4": "If the content provider, member, or user believes that the material that was removed (or to which access was disabled) is not infringing, or the content provider, member or user believes that it has the right to post and use such material from the copyright owner, the copyright owner’s agent, or pursuant to the law, the content provider, member or user must send a counter-notice containing the following information:",
			"terms-conditions-subheader3-subtitle6-text4-1": "A physical or electronic signature of the content provider, member or user;",
			"terms-conditions-subheader3-subtitle6-text4-2": "Identification of the material that has been removed or to which access has been disabled and the location at which the material appeared on the Service before such removal or disabling;",
			"terms-conditions-subheader3-subtitle6-text4-3": "A statement that the content provider, member or user has a good faith belief that the material was removed or disabled as a result of mistake or misidentification of the material;",
			"terms-conditions-subheader3-subtitle6-text4-4": "Content provider’s, member’s, or user’s name, address, telephone number, and, if available, and, if available, email address, and a statement that such person or entity consents to the jurisdiction of the Federal Court for the judicial district in which the content provider’s, member’s or user’s address is located, or, if the content provider’s, member’s or user’s address is located outside the United States, for any judicial district in which Company is located, and that such person or entity will accept service of process from the person who provided notification of the alleged infringement.",
			"terms-conditions-subheader3-subtitle6-text5": "The above information must be submitted to:",
			"terms-conditions-subheader3-subtitle6-text6": "Attn: Othar Trade & Logistics Spain.",
			"terms-conditions-subheader3-subtitle6-text9": "Email: copyright@cubalicores.com",
			"terms-conditions-subheader3-subtitle6-text10": "UNDER FEDERAL LAW, IF YOU KNOWINGLY MISREPRESENT THAT ONLINE MATERIAL IS INFRINGING, YOU MAY BE SUBJECT TO CRIMINAL PROSECUTION FOR PERJURY AND CIVIL PENALTIES, INCLUDING MONETARY DAMAGES, COURT COSTS, AND ATTORNEYS' FEES.",
			"terms-conditions-subheader3-subtitle6-text11": "Please note that this procedure is exclusively for notifying Othar Trade & Logistics Spain and its affiliates that your copyrighted material has been infringed. The preceding requirements are intended to comply with Othar Trade & Logistics Spain's rights and obligations under the DMCA, including 17 U.S.C. §512(c), but do not constitute legal advice. It may be advisable to contact an attorney regarding your rights and obligations under the DMCA and other applicable laws.",
			"terms-conditions-subheader3-subtitle7": "THIRD PARTY LINKS",
			"terms-conditions-subheader3-subtitle7-text1": "The Service may contain links to third-party websites, advertisers, services, special offers, or other events or activities that are not owned or controlled by Othar Trade & Logistics Spain. Othar Trade & Logistics Spain does not endorse or assume any responsibility for any such third-party sites, information, materials, products, or services. If you access a third party website from the Service, such as through Facebook Connect, you do so at your own risk, and you understand that this Agreement and Othar Trade & Logistics Spain 's Privacy Policy do not apply to your use of such sites. You expressly relieve Othar Trade & Logistics Spain from any and all liability arising from your use of any third-party website, service, or content. Additionally, your dealings with or participation in promotions of advertisers found on the Service, including payment and delivery of goods, and any other terms (such as warranties) are solely between you and such advertisers. You agree that Othar Trade & Logistics Spain shall not be responsible for any loss or damage of any sort relating to your dealings with such advertisers.",
			"terms-conditions-subheader3-subtitle8": "INDEMNITY",
			"terms-conditions-subheader3-subtitle8-text1": "You agree to defend, indemnify and hold harmless Othar Trade & Logistics Spain and its subsidiaries, agents, licensors, managers, and other affiliated companies, and their employees, contractors, agents, officers and directors, from and against any and all claims, damages, obligations, losses, liabilities, costs or debt, and expenses (including but not limited to attorney's fees) arising from: (i) your use of and access to the Service, including any data or content transmitted or received by you; (ii) your violation of any term of this Agreement, including without limitation your breach of any of the representations and warranties you make in this Agreement; (iii) your violation of any third-party right, including without limitation any right of privacy or Intellectual Property Rights; (iv) your violation of any applicable law, rule or regulation; (v) any claim or damages that arise as a result of any of your User Content or any that is submitted via your account; or (vi) any other party's access and use of the Service with your username, password or other appropriate security code.",
			"terms-conditions-subheader3-subtitle9": "NO WARRANTY",
			"terms-conditions-subheader3-subtitle9-text1": "THE SERVICE AND ANY PRODUCT OR SERVICE YOU PURCHASE THROUGH THE SERVICE (“PRODUCT”) ARE PROVIDED ON AN \"AS IS\" AND \"AS AVAILABLE\" BASIS. USE OF THE SERVICE IS AT YOUR OWN RISK. TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, THE SERVICE AND THE PRODUCTS ARE PROVIDED WITHOUT WARRANTIES OF ANY KIND, WHETHER EXPRESS OR IMPLIED, INCLUDING, BUT NOT LIMITED TO, IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, OR NON-INFRINGEMENT. WITHOUT LIMITING THE FOREGOING, CUBALICORES, ITS SUBSIDIARIES, AND ITS LICENSORS DO NOT WARRANT THAT THE CONTENT IS ACCURATE, RELIABLE OR CORRECT; THAT THE SERVICE OR THE PRODUCTS WILL MEET YOUR REQUIREMENTS; THAT THE SERVICE WILL BE AVAILABLE AT ANY PARTICULAR TIME OR LOCATION, UNINTERRUPTED OR SECURE; THAT ANY DEFECTS OR ERRORS WILL BE CORRECTED; OR THAT THE SERVICE IS FREE OF VIRUSES OR OTHER HARMFUL COMPONENTS. ANY CONTENT DOWNLOADED OR OTHERWISE OBTAINED THROUGH THE USE OF THE SERVICE IS DOWNLOADED AT YOUR OWN RISK AND YOU WILL BE SOLELY RESPONSIBLE FOR ANY DAMAGE TO YOUR COMPUTER SYSTEM OR LOSS OF DATA THAT RESULTS FROM SUCH DOWNLOAD OR YOUR USE OF THE SERVICE.",
			"terms-conditions-subheader3-subtitle9-text2": "CUBALICORES DOES NOT WARRANT, ENDORSE, GUARANTEE, OR ASSUME RESPONSIBILITY FOR ANY PRODUCT OR SERVICE ADVERTISED OR OFFERED BY A THIRD PARTY THROUGH THE CUBALICORES SERVICE OR ANY HYPERLINKED WEBSITE OR SERVICE, AND CUBALICORES WILL NOT BE A PARTY TO OR IN ANY WAY MONITOR ANY TRANSACTION BETWEEN YOU AND THIRD-PARTY PROVIDERS OF PRODUCTS OR SERVICES.",
			"terms-conditions-subheader3-subtitle10": "LIMITATION OF LIABILITY",
			"terms-conditions-subheader3-subtitle10-text1": "TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, IN NO EVENT SHALL CUBALICORES, ITS AFFILIATES, AGENTS, DIRECTORS, EMPLOYEES, SUPPLIERS OR LICENSORS BE LIABLE FOR ANY DIRECT, INDIRECT, PUNITIVE, INCIDENTAL, SPECIAL, CONSEQUENTIAL OR EXEMPLARY DAMAGES, INCLUDING WITHOUT LIMITATION DAMAGES FOR LOSS OF PROFITS, GOODWILL, USE, DATA OR OTHER INTANGIBLE LOSSES, THAT RESULT FROM THE USE OF, OR INABILITY TO USE, THIS SERVICE OR ANY PRODUCT. UNDER NO CIRCUMSTANCES WILL CUBALICORES BE RESPONSIBLE FOR ANY DAMAGE, LOSS OR INJURY RESULTING FROM HACKING, TAMPERING OR OTHER UNAUTHORIZED ACCESS OR USE OF THE SERVICE OR YOUR ACCOUNT OR THE INFORMATION CONTAINED THEREIN.",
			"terms-conditions-subheader3-subtitle10-text2": "TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, CUBALICORES ASSUMES NO LIABILITY OR RESPONSIBILITY FOR ANY (I) ERRORS, MISTAKES, OR INACCURACIES OF CONTENT AVAILABLE ON OR THROUGH THE SERVICE; (II) PERSONAL INJURY OR PROPERTY DAMAGE, OF ANY NATURE WHATSOEVER, RESULTING FROM YOUR ACCESS TO OR USE OF OUR SERVICE OR ANY PRODUCT; (III) ANY UNAUTHORIZED ACCESS TO OR USE OF OUR SECURE SERVERS AND/OR ANY AND ALL PERSONAL INFORMATION STORED THEREIN; (IV) ANY INTERRUPTION OR CESSATION OF TRANSMISSION TO OR FROM THE SERVICE; (V) ANY BUGS, VIRUSES, TROJAN HORSES, OR THE LIKE THAT MAY BE TRANSMITTED TO OR THROUGH OUR SERVICE BY ANY THIRD PARTY; (VI) ANY ERRORS OR OMISSIONS IN ANY CONTENT OR FOR ANY LOSS OR DAMAGE INCURRED AS A RESULT OF THE USE OF ANY CONTENT POSTED, EMAILED, TRANSMITTED, OR OTHERWISE MADE AVAILABLE THROUGH THE SERVICE; AND/OR (VII) USER CONTENT OR THE DEFAMATORY, OFFENSIVE, OR ILLEGAL CONDUCT OF ANY THIRD PARTY.",
			"terms-conditions-subheader3-subtitle10-text3": "THIS LIMITATION OF LIABILITY SECTION APPLIES WHETHER THE ALLEGED LIABILITY IS BASED ON CONTRACT, TORT, NEGLIGENCE, STRICT LIABILITY, OR ANY OTHER BASIS, EVEN IF CUBALICORES HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGE. THE FOREGOING LIMITATION OF LIABILITY SHALL APPLY TO THE FULLEST EXTENT PERMITTED BY LAW IN THE APPLICABLE JURISDICTION.",
			"terms-conditions-subheader3-subtitle10-text4": "The Service is controlled and operated from its facilities in the United States. Othar Trade & Logistics Spain makes no representations that the Service is appropriate or available for use in other locations. Those who access or use the Service from other jurisdictions do so at their own volition and are entirely responsible for compliance with all applicable United States and local laws and regulations, including but not limited to export and import regulations. You represent and warrant you are not located in a country embargoed by the United States or that has been designated by the United States government as a “terrorist-supporting” country, and that you are not a foreign person or entity blocked or denied by the United States government or otherwise listed on any United States government list of prohibited or restricted parties. Unless otherwise explicitly stated, all materials found on the Service are solely directed to individuals, companies, or other entities located in the United States.",
			"terms-conditions-subheader3-subtitle11": "ASSIGNMENT",
			"terms-conditions-subheader3-subtitle11-text1": "This Agreement, and any rights and licenses granted hereunder, may not be transferred or assigned by you, but may be assigned by Othar Trade & Logistics Spain without restriction.",
			"terms-conditions-subheader3-subtitle12": "GENERAL",
			"terms-conditions-subheader3-subtitle13": "GOVERNING LAW",
			"terms-conditions-subheader3-subtitle12-text1": "You agree that the Service shall be deemed solely based in the State of Florida. This Agreement shall be governed by the internal substantive laws of the State of Florida, without respect to its conflict of laws principles. The application of the United Nations Convention on Contracts for the International Sale of Goods is expressly excluded. You and Othar Trade & Logistics Spain hereby expressly consent to the exclusive personal jurisdiction of the courts of Dade County, Florida.",
			"terms-conditions-subheader3-subtitle14": "ARBITRATION",
			"terms-conditions-subheader3-subtitle14-text1": "Any dispute arising from or relating to the subject matter of this Agreement shall be finally settled by arbitration in Dade County, Florida, using the English language in accordance with the Streamlined Arbitration Rules and Procedures of Judicial Arbitration and Mediation Services, Inc. (\"JAMS\") then in effect, by one commercial arbitrator with substantial experience in resolving intellectual property and commercial contract disputes, who shall be selected from the appropriate list of JAMS arbitrators in accordance with the Streamlined Arbitration Rules and Procedures of JAMS. Judgment upon the award so rendered may be entered in a court having jurisdiction, or application may be made to such court for judicial acceptance of any award and an order of enforcement, as the case may be. Any arbitration under this Agreement will take place on an individual basis: class arbitrations and class actions are not permitted. YOU UNDERSTAND AND AGREE THAT BY ENTERING INTO THIS AGREEMENT, YOU AND CUBALICORES ARE EACH WAIVING THE RIGHT TO TRIAL BY JURY OR TO PARTICIPATE IN A CLASS ACTION. Notwithstanding the foregoing, each party shall have the right to institute an action at any time in a court of proper jurisdiction for injunctive or other equitable relief. ",
			"terms-conditions-subheader3-subtitle15": "NOTIFICATION PROCEDURES",
			"terms-conditions-subheader3-subtitle15-text1": "Othar Trade & Logistics Spain may provide notifications, whether such notifications are required by law or are for marketing or other business related purposes, to you via email notice, written or hard copy notice, or through posting of such notice on our website, as determined by Othar Trade & Logistics Spain in our sole discretion. Othar Trade & Logistics Spain reserves the right to determine the form and means of providing notifications to our Users, provided that you may opt out of certain means of notification as described in this Agreement and our ",
			"terms-conditions-subheader3-subtitle15-text2": ". Othar Trade & Logistics Spain is not responsible for any automatic filtering you or your network provider may apply to email notifications we send to the email address you provide us. We recommend that you add ",
			"terms-conditions-subheader3-subtitle15-text3": " to your email address book to help ensure you receive email notifications from us.",
			"terms-conditions-subheader3-subtitle16": "ENTIRE AGREEMENT / SEVERIBILITY",
			"terms-conditions-subheader3-subtitle16-text1": "This Agreement, together with any amendments and any additional agreements you may enter into with Othar Trade & Logistics Spain in connection with the Service, shall constitute the entire agreement between you and Othar Trade & Logistics Spain concerning the Service. If any provision of this Agreement is deemed invalid by a court of competent jurisdiction, the invalidity of such provision shall not affect the validity of the remaining provisions of this Agreement, which shall remain in full force and effect.",
			"terms-conditions-subheader4": "NO WAIVER",
			"terms-conditions-subheader4-text1": "No waiver of any term of this Agreement shall be deemed a further or continuing waiver of such term or any other term, and Othar Trade & Logistics Spain 's failure to assert any right or provision under this Agreement shall not constitute a waiver of such right or provision.",
			"terms-conditions-subheader4-text2": "Othar Trade & Logistics Spain Card Terms and Conditions",
			"terms-conditions-subheader4-text2-1": "This Agreement was last revised on February 17th, 2021",
			"terms-conditions-subheader4-text2-2": "Fuego Enterprises, Inc. (“Othar Trade & Logistics Spain,” “we,” or “us”) may provide Othar Trade & Logistics Spain members with reward credits when members make qualifying purchases on Othar Trade & Logistics Spain (“Othar Trade & Logistics Spain Card Credits”). These Othar Trade & Logistics Spain Card Terms and Conditions (“Othar Trade & Logistics Spain Card Terms”) govern the Othar Trade & Logistics Spain Card Credits. By accepting an invitation into the Othar Trade & Logistics Spain Card Program, you agree to comply with these Othar Trade & Logistics Spain Card Terms and acknowledge that these Othar Trade & Logistics Spain Card Terms are subject to Othar Trade & Logistics Spain ’s Terms of Use Agreement and Privacy Policy, which are incorporated herein. Membership in the Othar Trade & Logistics Spain Card program is by invitation only.",
			"terms-conditions-subheader5-text2": "Benefits of Membership",
			"terms-conditions-subheader5-text2-1": "With a minimum purchase of $250, excluding shipping, handling and white glove fees, and minus any credits used for the purchase, $25 worth of Othar Trade & Logistics Spain Credits will be added to your Othar Trade & Logistics Spain member account.",
			"terms-conditions-subheader5-text2-2": "With a minimum purchase of $500, excluding shipping, handling and white glove fees, and minus credits used for the purchase, $60 worth of Othar Trade & Logistics Spain Credits will be added to your Othar Trade & Logistics Spain member account.",
			"terms-conditions-subheader5-text2-3": "With a minimum purchase of $1,000, excluding shipping handling and white glove fees, and minus any credits used for the purchase, $125 worth of Othar Trade & Logistics Spain Credits will be added to your Othar Trade & Logistics Spain member account.",
			"terms-conditions-subheader5-text3": "Conditions",
			"terms-conditions-subheader5-text3-1": "You must meet the eligibility requirements set forth in Othar Trade & Logistics Spain ’s Terms of Use Agreement.",
			"terms-conditions-subheader5-text3-2": "You may only have one Othar Trade & Logistics Spain Card Membership per email account.",
			"terms-conditions-subheader5-text3-3": "Your participation in the Othar Trade & Logistics Spain Card Program is revocable by us at any time, at our sole discretion. We may terminate or make material changes to any or all benefits available to you under the Othar Trade & Logistics Spain Card Program.",
			"terms-conditions-subheader5-text3-4": "We reserve the right to limit, modify, alter, waive, or cancel the Othar Trade & Logistics Spain Card Program at any time, prospectively or retroactively, with or without notice.",
			"terms-conditions-subheader5-text3-5": "Your Othar Trade & Logistics Spain Card Membership and Othar Trade & Logistics Spain Credits are non-transferrable.",
			"terms-conditions-subheader5-text3-6": "Othar Trade & Logistics Spain Credits do not have a cash value, and you may only use Othar Trade & Logistics Spain Credits in connection with a purchase on the Othar Trade & Logistics Spain website.",
			"terms-conditions-subheader5-text3-7": "Othar Trade & Logistics Spain Credits are not earned on purchases paid with Othar Trade & Logistics Spain Gift Cards, E-Cards or purchases made using existing Othar Trade & Logistics Spain Credits.",
			"terms-conditions-subheader5-text3-8": "Othar Trade & Logistics Spain Credits cannot be used to purchase Othar Trade & Logistics Spain gift cards.",
			"terms-conditions-subheader5-text3-9": "Othar Trade & Logistics Spain Credits are earned on the value of each individual order placed, not on cumulative orders.",
			"terms-conditions-subheader5-text3-10": "Othar Trade & Logistics Spain Credits are subject to expiration.",
			"terms-conditions-subheader5-text4": "Othar Trade & Logistics Spain Credits",
			"terms-conditions-subheader5-text4-1": "Othar Trade & Logistics Spain Credits are earned on each eligible purchase and are deposited into your Othar Trade & Logistics Spain Member Account within seven (7) business days from the date of purchase. If you cancel or return an item, Othar Trade & Logistics Spain Credits earned for that purchase will be deducted from your Member Account. If you cancel or return an item that was purchased with Othar Trade & Logistics Spain Credits, you will not be reimbursed for the Othar Trade & Logistics Spain Credits used in that transaction. Your Othar Trade & Logistics Spain Credits will expire 6 months after they are granted. However, Othar Trade & Logistics Spain reserves the right at any time, with or without notice, to change the expiration period.",
			"terms-conditions-subheader5-text5": "Term",
			"terms-conditions-subheader5-text5-1": "Your Othar Trade & Logistics Spain Card Membership will commence on the date that you accept the invitation into the Othar Trade & Logistics Spain Card Program and will be valid until December 31, of current year, unless terminated earlier. Othar Trade & Logistics Spain reserves the right to extend the expiration date of your Othar Trade & Logistics Spain Card Membership and the Othar Trade & Logistics Spain Card Program.",
			"terms-conditions-subheader5-text6": "Payment",
			"terms-conditions-subheader5-text6-1": "Your Othar Trade & Logistics Spain Card Membership is offered free of charge in order to reward you for being a valuable Othar Trade & Logistics Spain customer.",
			"terms-conditions-subheader5-text7": "Othar Trade & Logistics Spain Card Membership Cancellation",
			"terms-conditions-subheader5-text7-1": "You have the right to cancel your Othar Trade & Logistics Spain Card Membership at any time; however, there are no refunds for cancellation of the Membership.",
			"terms-conditions-subheader5-text7-2": "For all of your other rights and obligations, see Othar Trade & Logistics Spain ’s Terms of Use Agreement and Privacy Policy.",
			"terms-conditions-subheader5-text8": "CONTACT US",
			"terms-conditions-subheader5-text9": "If you have any questions regarding this Agreement, you can contact us at:",
			"terms-conditions-subheader5-text10": "Othar Trade & Logistics Spain.",
			"terms-conditions-subheader5-text13": "Email: info@cubalicores.com",
			"store-table-header-text1": "Store",
			"store-table-header-text2": "Delivery Time",
			"store-table-header-text3": "Delivery Price",
			"store-table-header-text4": "Description",
			"store-table-header-text5": "Notes",
			"store-table-body-row1-text1": "Artisan pastry with international recipes, local ingredients and traditional Cuban flavors. Sweets based on biscuit, chocolate, cinnamon and tropical fruits, seeking creative and nutritious preparations for the Cuban family. The only cafeteria in Havana that offers frozen yogurt with assorted toppins. The most popular products are guava cupcakes, cinnamon rolls, puff pastry, gingerbread cookies and frozen yogurt.",
			"store-table-body-row1-text2": "It is recommended to consume the sweets that contain Custard the same day of delivery, as they are prepared with natural ingredients, a recipe from Lola Café, and do not contain added preservatives or preservatives.",
			"store-table-body-row2-text1": "Preparation of arrangementsflorals of all kinds, like thisas to the setting ofInterior and exterior. I knowthey use elementsfundamentallynatural plantsornamental and flowers.",
			"store-table-body-row2-text2": "For a greaterconservation offlowers, it is recommendedkeep them in placescold, you work with flowersimport, sensitiveat high temperatures",
			"store-table-body-row3-text1": "Dream project for 2brothers and their cousin,turning the house wherethey were born in a place wheretaste exquisite food,with a beautiful view of thesea.",
			"store-table-body-row3-text2": "days",
			"store-table-body-row4-text1": "Elaboration centerfine-style sweetsEuropean where can youorder cake for severaloccasions.Sweets are madesemi-cold as deliciousmousse of various flavors andexquisite feet.",
			"store-table-body-row4-text2": "Does not deliver on Sundays",
			"store-table-body-row5-text1": "The specialty ispre-made products andfrozen. Offersgourmet untilcomfort of your home.Italian and Creole foodbrewed / pre-brewed,vacuum sealed andfrozen.",
			"store-table-body-row5-text2": "It is recommended to follow the chef's instructions written on the packaging for the elaboration of products. This will guarantee a greater enjoy them.",
			"store-table-body-row6-text1": "Creole food and international, and specialty of food to the coal.",
			"store-table-body-row6-text2": "*Deliver only Saturdays",
			"store-table-body-row7-text1": "Take the beauty salon to your house. Service Specialized in hairdresser, manicuri ,pedicuri and treatments exclusive from comfort of your home",
			"store-table-body-row7-text2": "",
			"store-table-body-row8-text1": "Articles aimed atdecoration home where you can customize the decor assembling to your liking the design to make it reach your home. The quality of the pottery is authentic and original. It has many kinds of ornaments like vases of all sizes and variety in designs, centerpieces with different styles and colors, and other items where each piece is unique.",
			"store-table-body-row8-text2": "",
			"store-table-body-row9-text1": "Food restaurant Mexican with shipments to address to all of Havana.Varied taco menu,burritos, quesadillas and others Mexican dishes,specials to share on any occasion. Yes you want to try the authentic taste of Mexico in the comfort of your home we are your choice ...",
			"store-table-body-row9-text2": "",
			"store-table-body-row10-text1": "Shop-workshop that produces and markets items handcrafted and designer,useful and decorative,made with different materials.Ideal for both setting and decoration of spaces, as well as for the gift of gifts in any occasion that deserves a special detail and an original design.",
			"store-table-body-row10-text2": "",
			"store-table-body-row11-text1": "Photography agency a asked where they work from several coordinated way photography professionals and video under one brand. You can book photography sessions for events such as weddings,quinceañeras, events private family or institutional.It is also done product photography and advertising, interior and spaces, for dossier personal, for networks social in short, everything need you can find it in this space dedicated to achieve the best image for You.Sale of originals from printed photographs and framed for decoration of spaces private or institutional.Classes are also offered photography for those who are interested in explore this interesting world of the image.",
			"store-table-body-row11-text2": "",
			"store-table-body-row12-text1": "Specialized in entrepanes, Tic-Tacproposes 50 combinations different to place in the house baguette. From cheese to beef,grilled bacon or shrimp. Boquitas is full of options to meet the customer needs,the same alone as in groups Special tables where they put cheeses,sausages, vegetables and breads, mouthfuls that I know turn the twice as rich and less price and combos, what they propose little mouths and drinks by oneself price. For the team Tic-Tac the thing is simple:so that you come, come back and repeat",
			"store-table-body-row12-text2": "",
			"store-table-body-row13-text1": "The Den is a opportunity to travel in time, since yesterday until tomorrow, a site that respects the traditions but that you bet on him future, an authentic space for those interested in know the real Cuba and enter our culture, customs and ways to do.",
			"store-table-body-row13-text2": "",
			"store-table-body-row14-text1": "I'm coming is the fusion of 4 successful restaurants in the Havana that when the pandemic and shutdown followed meeting expectations of your customers with anew Home Service.Ya Voy complied with the Cuban family despite regrets, managed to carry his dishes to each house fulfilling a function invaluable, with a few costs very high and profits very low. Thanks for the trust deposited, today with more experience we treat ca",
			"store-table-body-row14-text2": "",
			"store-table-body-row15-text1": "Item brand sports, dedicated tophysical preparation and combat sports.Implements for training combat sports various, both grappling like striking. Variety of sacks (punching bags),pets, shields and kickers.Our products from physical preparation are a excellent choice for exercising, both in gyms as in a personal way at home.The sandbags (bags of sand), medicine balls and vests are ideal for keep a good tone muscular.",
			"store-table-body-row15-text2": "",
			"store-table-body-row16-text1": "Project that is part of the creation group Havana humidors created more than 20 years ago.Our work is directed fundamentally to create pieces for moments special like anniversaries and birthdays.It also has utility items such as craft containers various colors and color wood, for purposes too decorative and wooden plate holder.",
			"store-table-body-row16-text2": "For customization of any item,get in touch with Customer Service at he purchase has been made.",
			"store-table-body-row17-text1": "Educational board games for all members of home.",
			"store-table-body-row17-text2": "",
			"store-table-body-row18-text1": "Pre-made foods frozen (among others)ready to cook in minutes and enjoy a delicious food. Experts to take your food to home in optimal conditions and with the hygienic measures-sanitary necessary for your safety and yours family.",
			"store-table-body-row18-text2": "",
			"store-table-body-row19-text1": "Cuban creation group dedicated to design and production of humidors exclusive through fusion of techniques such as goldsmithing, cabinetmaking and marquetry.All items can be personalized with phrases and logos.",
			"store-table-body-row19-text2": "For customization of any item,get in touch with Customer Service a the purchase has been made.",
			"store-table-body-row20-text1": "Handicraft shop and gifts online where we try to rescue the handicrafts mainly made with thread.",
			"store-table-body-row20-text2": "",
			"store-table-body-row21-text1": "Metal and wood items utilitarian and decorative for home.",
			"store-table-body-row21-text2": "",
			"store-table-body-row22-text1": "Diverse and colorful utility and design for all tastes and needs.",
			"store-table-body-row22-text2": "",
			"store-table-body-row23-text1": "Food restaurant Creole",
			"store-table-body-row23-text2": "",
			"footer-parragraph-text1": "If you still have questions about delivery times and conditions please contact us via",
			"footer-parragraph-text2": "Help Center",
			"footer-parragraph-text3": "available on site www.cubalicores.com or by email",
			"footer-parragraph-text4": "Our support representatives will receive your message and respond as soon as possible.",
			"title": "CubaLicores - Online Liquor Store for Cuba",
			"total": "Total",
			"total-price": "Total price",
			"unable-update-product-quantity": "Unable to update the product quantity",
			"useBilling": "Ship to Billing Address",
			"well": "All right!",
			"yourOrders": "Your Orders",
			"or": "or",
			"wishlist": "Wishlist",
			"registration-error": "There was a problem in registration.",
			"successfully-registered": "Please check your email for instructions.",
			"loading-form": "Loading form...",
			"saving-addresses": "Saving addresses...",
			"saving-delivery": "Saving delivery...",
			"saving-payment": "Saving payment...",
			"confirming": "Confirming the order...",
			"order-number": "Orden no.",
			"shipping-policies": "Shipping Policies and Charges",
			"costumer-service": "Customer service",
			"add-few-products-to-cart": "Add few products to cart",
			"go-shopping": "Go shopping",
			"unit-price": "Unit price",
			"subtotal": "Subtotal",
			"yourInfo": "Your Information",
			"yourInfoDetails": "Your email to keep you in touch",
			"zipCode": "Zip Code*",
			"registed-message": "You have successfully registered",
			"password-reset": "Your password has been updated",
			"unregisted-message": "The email has already been registered",
			"payment-methods": "Payment methods",
			"zone": "Zone",
			"thank-for-your-buy": "Thanks for your order",
			"fail-confirmation-1-message": "You will receive an email once your order is confirmed.",
			"fail-confirmation-2-message": "If you don't receive the confirmation email in a few minutes, make sure the charge is reflected on your card.",
			"fail-confirmation-3-message": "Otherwise, we suggest repeating the purchase.",
			"fail-confirmation-4-message": "For more information on our services and delivery times",
			"fail-confirmation-5-message": "please visit our <strong>Frequently Asked Questions page</strong>",
			"fail-confirmation-6-message": "and our <strong>Shipping Policies and Charges</strong>",
			"sorry-error-occurred-title": "Sorry",
			"error-general-message": "We have not been able to complete your order now, please try later",
			"katapulk-team": "CubaLicores's Team",
			"certify-age-title-1-message": "Hello, product with",
			"certify-age-title-2-message": "age restriction?",
			"certify-age-enter-birthday": "Please enter your date of birth:",
			"certify-age-message": "Upon entering I am certifying that I am really over 21 years of age.",
			"valid-age-enter": "Inter",
			"required-message": "Required",
			"sorry-product-over-21": "Sorry this product is for ages 21 and over",
			"is-not-valid-date": "It is not a valid date",
			"select": "Select",
			"error-invalid-email": "Invalid email",
			"error-password-not-match": "Password doesn't match",
			"destiny": "Destiny",
			"order-state": "Order State",
			"order-date": "Order State",
			"order-total": "Order Total",
			"price-per-unit": "Price, per Unit",
			"amount": "Amount",
			"shipping-amount": "Shipping Amount",
			"shipping-total-amount": "Total shipping amount",
			"total-amount": "Total",
			"order-receiver": "Receiver",
			"details": "Details",
			"order-complete": "Completed",
			"order-cart": "Cart",
			"order-address": "Address",
			"order-payment": "Payment",
			"order-resume": "Resume",
			"order-canceled": "Canceled",
			"order-awaiting-return": "Awaiting return",
			"order-returned": "Returned",
			"redsys-error": "An error has occurred in your payment, try again",
			"menu": "Menu",
			"see-all": "See All",
			"see-less": "See less",
			"for-cuba": "For Cuba",
			"zone-store": "Store in Zone",
			"show-all": "Show all",
			"offer-keep-update": "Keep me updated with news and exclusive offers",
			"outofstock": "Out of stock",
			"legend-required-field": "* Indicates the field is required",
			"invalid-phone-number": "Invalid phone number",
			"invalid-zip-code": "Invalid ZIP Code",
			"cart-expiring-message-part1": "Your cart will expire in ",
			"cart-expiring-message-part2": " minutes. Please, complete your order.",
			"cart-expiring-empty-cart": "Your cart has expired.",
			"payment-modal-extra-time-title": "Time expired",
			"payment-modal-extra-time-text1": "The time to checkout has expired, we have added {time} for you to finish your checkout.",
			"payment-modal-extra-time-button": "Close",
			"time-minute-singular": "minute",
			"time-minute-plural": "minutes",
			"time-second-singular": "second",
			"time-second-plural": "seconds",
			"filters-title": "Filters",
			"apply": "Apply",
			"under-price": "Under",
			"above-price": "Above",
			"shipping-policy__important-info-about-delivery": "<p>CubaLicores has several suppliers and distributors.</p><p><b>ATTENTION.</b> If you order more than one product, some may be distributed from different locations and therefore may be delivered at different times.</p><p>We send purchases to Havana, shortly to Pinar del Río, Artemisa, Mayabeque, Matanzas, Ciego de Ávila, Las Tunas, Holguín, Camagüey, Sancti Spiritus, Granma and Santiago de Cuba.</p><p>There is the possibility of delivering some of our products on special dates. Contact us by email <a href=\"mailto:info@cubalicores.com\">info@cubalicores.com</a> to make this request.</p>",
			"shipping-policy__delivery-conditions": "<p>When placing the order, the customer may specify a person, delivery address and telephone contact. Our team will communicate with this person in two moments 1. To notify the order and confirm the address and 2. To evaluate the quality of the service provided and the products received.</p><p><b>ATTENTION:</b> This service is subject to the SMS and voice call rates established by the recipient's cellphone provider.</p><p><b>ATTENTION:</b>  If you have previously placed orders for the same recipient, we can confirm the delivery address directly from the system and skip the first call. If the recipient is not present at the time of delivery, the order can be delivered to neighbors, friends or others as long as they show a copy of the recipient's ID or can demonstrate their authorization to receive it.</p><p>Orders containing errors in delivery addresses and contacts will be held until the customer provides correct and sufficient information. If the information provided by the customer is incomplete or not sufficient to make the shipment safely, the order can be canceled and the money returned to the buyer.</p><p>The delivery times of the shipments or the provision of the purchased services, begin to govern from the approval of the order and verification of the recipient's contacts.</p><p>The telephone data and / or email address of the recipient, entered by the client in the recipient's file, may be used by the carrier or CubaLicores's management team to coordinate the delivery schedule and other details of the service with the recipient. This service is subject to the SMS and voice call rates established by the recipient's telephone provider.</p><p><b>Distribution times are estimates, not guaranteed.</b></p><p>For the protection against fraud and / or improper use of credit cards, Othar Trade & Logistics Spain attributes the right to delay the delivery of products and / or services until the authenticity of the purchase is verified and, if deemed appropriate, will deepen at the origin of any transaction carried out on the site, as established in the internal regulations of the company.</p>",
			"shipping-policy__delivery-fees-for-stores-disclaimer": "<p><b>(*) All orders can be canceled in less than 24 hours after the purchase is made.</b></p><p>The recipient must check the product at the time of delivery, claims are not accepted without clear evidence that the product does not correspond to its description, or evidence that it is in poor condition. This claim will not be valid after 24 hours of delivery. For more information, refer to our <a target='_blank' href='https://www.cubalicores.com/return-policy'>Claims and Cancellations Policy</a>.</p>",
			"error-refresh-order-title": "Error reload order",
			"error-refresh-order-content": "You are viewing stale data. Please refresh.",
			"error-create-order-title": "Order processing failed",
			"error-create-order-content": "An error occurred while trying to process your order, please reload if the error persists.",
			"error-reload-cart-order": "An error occurred while loading your order",
			"warning-product-change-tittle": "Change in Products",
			"warning-product-change-content": "Check your order, there were changes in the products",
			"session-closed": "Your session has been successfully closed",
			"selected-variant": "Selected variant",
			"phone-number": "Phone Number",
			"extra-data-modal-title": "We need more information to add this product",
			"emailReceptor": "* We will also send notifications of changes in the status of your order to this email address.",
			"login-my-account": "Login to my account",
			"read-and-accept": "I have read and I accept the",
			"error-title": "Order processing failed",
			"invalid-order-title": "There was an error processing your order",
			"invalid-order-contact-info": "To help you complete your order please send us a message to ",
			"invalid-order-contact-info2": " including:",
			"invalid-order-first-and-last-name": "First and Last Name: ",
			"invalid-order-phone-number": "Phone number: ",
			"invalid-order-order-number": "Order Number: ",
			"invalid-order-case-number": "Case Number: ",
			"pay-with": "Pay with",
			"payment-form-cc-name": "Name on card: {name}",
			"payment-form-cc-number": "Card Number: {number}",
			"payment-form-edit": "Edit",
			"delivery.small.text": "* Choose a delivery method. If packages can be merged in a single shipment we'll do it when you click 'Continue'.",
			"shipment.word": "Shipment",
			"of.word": "of",
			"shipping-address-problems": "There are problems shipping some products to the selected address. Please check your products.",
			"shipping-address-problems-item": "Cannot be shipped to the select address.",
			"modal-municipalitySelect-title": "Please, select a municipality:",
			"modal-municipalitySelect-text1": "You need to specify a municipality to proceed.",
			"manage-k-wallet": "Manage K-Wallet",
			"manage-k-wallet-transactions": "Transactions",
			"manage-k-wallet-banner-message": "Our exclusive Rechargeable Card Program makes financial transactions easier and safer",
			"manage-k-wallet-banner-direct-deposit": "Direct deposit (ACH debit)",
			"manage-k-wallet-banner-load-card": "Add funds to the card",
			"manage-k-wallet-banner-peer-to-peer-transfer": "Credit transfer from user to user",
			"manage-k-wallet-banner-check-your-balance": "Check your balance",
			"manage-k-wallet-banner-pay-the-bill": "Pay the bill",
			"manage-k-wallet-banner-account-balance": "Balance:",
			"manage-k-wallet-banner-available-balance": "Available balance:",
			"manage-k-wallet-banner-add-funds": "Add funds to K-Wallet",
			"manage-k-wallet-banner-to-use-k-wallet": "To take advantage of K-Wallet, follow these steps:",
			"manage-k-wallet-banner-transfer-money-link": "Send money to a receiver",
			"manage-k-wallet-banner-your-k-wallet-id": "K-Wallet ID:",
			"manage-k-wallet-banner-click-to-reveal": "Click to reveal",
			"manage-k-wallet-banner-copy-to-clipboard": "Copy to clipboard",
			"manage-k-wallet-banner-copied": "Copied!",
			"modal-kwallet-activate": "Activate K-Wallet",
			"modal-kwallet-activate-text": "Apparently you haven't activated your K-Wallet yet.",
			"modal-kwallet-activate-activate": "Activate",
			"modal-kwallet-activate-cancel": "Maybe later",
			"modal-kwallet-activate-accept": "I accept the",
			"modal-kwallet-activate-terms": "Terms and Conditions",
			"modal-kwallet-activate-and": "and",
			"modal-kwallet-activate-affidavit": "Affidavit Certification",
			"transfer-funds-k-wallet-title": "Send money to a receiver",
			"transfer-funds-k-wallet-amount": "Amount to transfer",
			"transfer-funds-k-wallet-amount-placeholder": "Amount",
			"transfer-funds-k-wallet-id-transfer": "Identifier of the receiver",
			"transfer-funds-k-wallet-id-transfer-placeholder": "Id",
			"transfer-funds-k-wallet-available-balance-error": "You cannot transfer more than your available balance.",
			"transfer-funds-k-wallet-invalid-amount-error": "Only numbers greater than zero are allowed. Use (.) to specify cents",
			"transfer-funds-k-wallet-submitted-successfully": "Funds transferred successfully",
			"transfer-funds-k-wallet-account-not-found": "Account not found",
			"transfer-funds-k-wallet-same-account": "Transfer between same account is not allowed",
			"affidavit-certification-1": "- I, the user, understand that exports from the United States to the Republic of Cuba are prohibited by the United States unless such exports are specifically authorized pursuant to a license or license exception. Specifically, the US Department of Commerce, Bureau of Industry and Security (BIS) administers and enforces the Export Administration Regulations (EAR; 15 C.F.R. §§ 730-774), which regulate exports from the US to the Republic of Cuba, among other exports.",
			"affidavit-certification-2": "- I, the user, declare and certify that:",
			"affidavit-certification-2-1": "The products were purchased from Katapulk Marketplace.",
			"affidavit-certification-2-2": "Exports of the products from the US to the Republic of Cuba are permissible pursuant to, and comply with, one of the following BIS License Exceptions:",
			"affidavit-certification-2-2-1": "• License Exception Gift Parcels and Humanitarian Donations (15 CFR § 740.12);",
			"affidavit-certification-2-2-2": "• License Exception Support for the Cuban People (15 CFR § 740.21); and",
			"affidavit-certification-2-2-3": "• License Exception Baggage (15 CFR § 740.14).",
			"affidavit-certification-3": "- I am not:",
			"affidavit-certification-3-1": "(i) a member of the government of the Republic of Cuba; neither a prohibited officials of the Government of Cuba; nor (ii) purchasing these products on behalf of the government of the Republic of Cuba or any prohibited officials (31 CFR § 515.337).",
			"affidavit-certification-3-2": "(iii) a person designated on a US designated persons list, including the US Treasury Department, Office of Foreign Assets Control Specially Designated National List or the US State Department Cuba Restricted List; (iv) part of an entity on either list; nor (v) purchasing these products on behalf of a person or entity on either list (31 CFR § 515.209).",
			"affidavit-certification-3-3": "(vi) a prohibited members of the Cuban Communist Party (31 CFR § 515.338).",
			"affidavit-certification-4": "- I am 18 years of age or older.",
			"affidavit-certification-5": "- I solemnly affirm under penalty of perjury that, to the best of my knowledge, the foregoing in true and accurate.",
			"transactions-table-date": "Date",
			"transactions-table-description": "Description",
			"transactions-table-status": "Status",
			"transactions-table-amount": "Amount",
			"transactions-table-rows-per-page": "Rows per page",
			"transactions-table-search": "Search",
			"transactions-table-loading": "Loading...",
			"transactions-table-no-records": "No records to show",
			"k-wallet-account-not-active-yet": "Your K-Wallet account is not active yet. Go to <a href='/manage-k-wallet'>Administart K-Wallet</a> to activate it.",
			"add-funds-k-wallet-title": "Add funds to your K-Wallet",
			"add-funds-k-wallet-amount": "Amount to transfer*",
			"add-funds-k-wallet-invalid-debit-card-error-title": "Invalid debit card",
			"add-funds-k-wallet-invalid-debit-card-error-message": "Please provide a valid debit card",
			"add-funds-k-wallet-invalid-card-number-error": "Invalid card number",
			"add-funds-k-wallet-invalid-amount-error": "Only positive numbers are allowed. Use (.) to specify cents",
			"add-funds-k-wallet-submitted-successfully": "Your request has been successfully submitted",
			"generic-error-title": "Something went wrong",
			"generic-error-message": "Please try again",
			"modal-change-municipality-title": "Delivery zone",
			"modal-change-municipality-text1": "You are making a change in the delivery zone initially selected and your cart will be empty.",
			"modal-change-municipality-text2": "Please be sure to select the correct province and municipality where we must deliver your order before you place your order.",
			"modal-change-municipality-text3": "Thank you for trusting us.",
			"modal-change-municipality-button-accept": "Accept",
			"modal-change-municipality-button-cancel": "Cancel",
			"manage-k-wallet-add-balance": "Click to add balance",
			"manage-k-wallet-insufficient-balance": "INSUFFICIENT BALANCE",
			"send-code-to-email": "Send code to email",
			"code": "Code",
			"code-send-successfully": "Code sent successfully.",
			"send-message-code-by-email": "An email will be sent to your email account with a temporary access code to start the section.",
			"send-message-code-by-email-finished": "An email has been sent to your email account with a temporary access code to start the section.",
			"invalid-email-address": "Invalid email address.",
			"info-cubalicores": "info@cubalicores.com",
			"alcohol-abuse": "Alcohol abuse is harmful to health. eat in moderation.",
			"smoking-harms-health": "Health authorities warn: smoking harms health.",
			"frequent-questions": "Frequently Asked Questions",
			"frequent-questions-title": "FREQUENTLY ASKED QUESTIONS",
			"frequent-questions-subtitle1": "1. In which provinces do you deliver?",
			"frequent-questions-response1-1": "A/ We deliver in Havana.",
			"frequent-questions-response1-2": "We are working to extend our services to the rest of the provinces.",
			"frequent-questions-subtitle2": "2. How many days does it take to deliver orders?",
			"frequent-questions-response2-1": "A/ Deliveries to CubaLicores take approximately 8 business days. Weekends are not included. Purchases made in the Pre-Sale store may take 30-60 days depending on the products purchased.",
			"frequent-questions-response2-2": "Please note that our dates are estimates and not exact.",
			"frequent-questions-response2-3": "To learn about shipping times in other stores on the platform, please visit our Shipping and Charges Policies ( <a target='_blank' href='https://www.cubalicores.com/shipping-policy'>https://www.cubalicores.com/shipping-policy</a> ).",
			"frequent-questions-subtitle3": "3. How can I buy?",
			"frequent-questions-response3-1": "A/ All purchases are made online on our site <a target='_blank' href='www.cubalicores.com'>www.cubalicores.com</a>. Select the products, add them to the cart and proceed to pay. We do not receive orders over the phone.",
			"frequent-questions-response3-2": "You can register on our website and access your profile or complete your purchase without registering.",
			"frequent-questions-subtitle4": "4. How do you know if you have a product? When do you supply the store?",
			"frequent-questions-response4-1": "A/ All available products can be found on our website www.cubalicores.com. We do not have specific times or dates to stock, we suggest staying on top of our social networks for updates on new products and offers.",
			"frequent-questions-subtitle5": "5. How much is the shipping cost?",
			"frequent-questions-response5-1": "A/ Regular Shipping + Handling Fee has a cost of $8 USD for all provinces in CubaLicores.",
			"frequent-questions-response5-2": "To learn about shipping costs in other stores on the platform, please visit our Shipping and Charges Policies ( <a target='_blank' href='https://www.cubalicores.com/shipping-policy'>https://www.cubalicores.com/shipping-policy</a> )",
			"frequent-questions-subtitle6": "6. Is there a minimum / maximum purchase amount?",
			"frequent-questions-response6-1": "A/ We do not have minimum or maximum purchase amounts. You can place any number of orders you consider in the same day or period of time. For some products, however, we may set limits on the quantities to be ordered.",
			"frequent-questions-subtitle7": "7. Can I pay with the Banco Metropolitano card or another Cuban bank?",
			"frequent-questions-response7-1": "A/ At the moment we only accept payments with Visa, Mastercard, Discover or any other foreign bank card.",
			"frequent-questions-subtitle8": "8. Can I pay in cash when I receive the products?",
			"frequent-questions-response8-1": "A/ We do not accept cash payments. The entire transaction is done online at the time of purchase.",
			"frequent-questions-subtitle9": "9. Does my relative in Cuba have to pay anything?",
			"frequent-questions-response9-1": "A/ In Cuba your family/friends don't pay anything.",
			"frequent-questions-subtitle10": "10. How does my relative in Cuba know the day the order will be delivered?",
			"frequent-questions-response10-1": "A/ We make a call to your family member once you place the order to verify your data and delivery address (See question 12 for more information about this call). From that moment you should expect that the order will arrive in the next 8 business days",
			"frequent-questions-response10-2": "24 hours before delivery you will receive an email that announces that your order is ready to be shipped and you must notify your family member. The customer who places the order is responsible for providing the contact information in Cuba correctly, as well as for notifying the recipient when he receives the order Sending email, otherwise it may mean delays in delivery.",
			"frequent-questions-subtitle11": "11. I placed an order and my family member has not received any calls",
			"frequent-questions-response11-1": "A/ If you have previously placed orders for the same recipient, we can confirm the delivery address directly from the system and skip the first call. Your family member should only wait for the estimated delivery time.",
			"frequent-questions-subtitle13": "12. How to know if my order was completed successfully?",
			"frequent-questions-response13-1": "A/ There are two elements that will tell you that your order was completed without problems: First check that you received your order confirmation email (also look in the spam folder). Then verify that your card was charged to OTHAR TRADE & LOGISTICS. If any of these indicators fail it means that we did not receive your order. You are responsible for correctly writing the email where you will receive the order confirmation.",
			"frequent-questions-subtitle14": "13. How can I track my order?",
			"frequent-questions-response14-1": "A/ If you need to know the status of your order, contact us through the chat button on our website. Please note that CubaLicores orders take up to 8 business days to be delivered. Do not contact us if your purchase is still within the estimated delivery time.",
			"frequent-questions-subtitle15": "14. If my card is not in USD, how do you change the currency?",
			"frequent-questions-response15-1": "A/ Our prices are exclusively in USD. It is the bank of your card that performs the currency conversion according to the rate it has established.",
			"frequent-questions-subtitle16": "15. Do you have a location to pick up the orders?",
			"frequent-questions-response16-1": "A/ No. All our orders are delivered at home.",
			"frequent-questions-subtitle17": "16. I am making a purchase and my card was declined",
			"frequent-questions-response17-1": "A/ If your card was declined, without specifying the reason, you should check with your bank. If this confirms that you have no problems, and you still cannot buy on our site, we suggest using another card.",
			"frequent-questions-subtitle18": "17. An order has been canceled, when will I get my refund?",
			"frequent-questions-response18-1": "A/ If we cancel your order, it is most likely due to an inventory error. Before canceling, we send you an email announcing you, and then a second email confirming the processing of your refund.",
			"frequent-questions-response18-2": "Once the refund is processed (say after you receive the second email), it may take 3-5 days for it to be reflected in your account, depending on your card bank.",
			"frequent-questions-response18-3": "The total of your money is reimbursed to the same card with which you made your purchase.",
			"frequent-questions-subtitle19": "18. I placed an order and did not receive the Confirmation email",
			"frequent-questions-response19-1": "A/ It can happen for various reasons, the most common being related to typographical errors when writing your email before paying.",
			"frequent-questions-response19-2": "If you placed an order and did not receive the confirmation email, please contact us through our chat on the website or by email <a href=\"mailto:info@cubalicores.com\">info@cubalicores.com</a>. Send us your name, surname, email, amount and the last 4 digits of the card you used.",
			"frequent-questions-response19-3": "Please make sure the charge for your order is reflected on your card. Otherwise, we suggest repeating the purchase.",
			"frequent-questions-subtitle20": "19. I write to the Help Center and send emails and I do not receive a response. What can happen?",
			"frequent-questions-response20-1": "A/ We usually experience high volumes of daily communications. This is why sometimes the response from our agents can take between 24 and 48 hours. However, all requests received are honored.",
			"frequent-questions-response20-2": "To help shorten response times, we suggest you to:",
			"frequent-questions-response20-3": "1. Make sure your order exceeds the estimated delivery time.",
			"frequent-questions-response20-4": "2. Include in your request the Order # and data of the customer who placed the order, when applicable.",
			"frequent-questions-response20-5": "3. Review the information we have available in our Shipping and Charges Policies (<a target='_blank' href='https://www.cubalicores.com/shipping-policy'>https://www.cubalicores.com/shipping-policy</a>) and our Claims and Returns Policies (<a target='_blank' href='https://www.cubalicores.com/return-policy'>https://www.cubalicores.com/return-policy</a>)",
			"return-policy": "Return Policy",
			"return-policy-title": "RETURN POLICY FOR FOOD PRODUCTS",
			"return-policy-text1": "Due to the nature of our products, we do not issue refunds after the order is processed and the product shipped. You as a customer must understand and take it into account before buying any food product offered on our website.",
			"return-policy-text2": "The person who receives the order in Cuba must make sure to verify that the products received match the order placed. Also, check the packaging very well and verify that they are in perfect condition in the company of the carrier before signing the invoice. If they sign without verifying, the right to claim is lost. We are not responsible for defects that are visible, nor for differences in the quantity and assortment of products that the consumer / receiver has accepted at the time of delivery and that he should have noticed in the act of delivery.",
			"return-policy-text3": "However, we realize that exceptional circumstances may exist. Therefore, we make replacements and / or refunds in the following cases:",
			"return-policy-subtitle1": "Product / Order not delivered:",
			"return-policy-subtitle1-text1": "Claims for non-delivery of the order must be made within 15 - 20 days after placing the order.",
			"return-policy-subtitle1-text2": "Claims for non-delivery of a specific product within an order must be made within 24 hours of the purchase delivery date. Otherwise, we will consider that the order was received without problems.",
			"return-policy-subtitle2": "Product does not correspond to its description:",
			"return-policy-subtitle2-text1": "This type of incident must be reported in no more than 24 hours after receiving the order. Clear evidence must be provided to show that the purchased product does not correspond to its description on the product page. Complaints that are based merely on unjustified expectations, personal wishes of the customer or lack of knowledge about how to process a product will not be taken into account.",
			"return-policy-subtitle3": "Product in poor condition:",
			"return-policy-subtitle3-text1": "Although all products are thoroughly checked before they are delivered, sometimes unexpected incidents can occur. This problem must be reported within 24 hours of receiving the order. Clear evidence must be shown that the product is expired, that the original product packaging does not contain the production and / or expiration date, or that the color or odor does not correspond to a fresh product.",
			"return-policy-subtitle4": "Delayed delivery of the Product / Order:",
			"return-policy-subtitle4-text1": "If the order or any of your products is not delivered within the estimated period of 10 - 12 business days (not including weekends) due to failures of our service, you have the right to be reimbursed without any additional compensation. Keep in mind that it is required to have all the updated contact information of the person who will receive the order in Cuba. If such information was not provided in a timely manner, the refund request may be rejected.",
			"return-policy-subtitle5": "CANCELLATION OF ORDERS",
			"return-policy-subtitle5-text1": "All orders can be canceled in less than 24 hours.",
			"return-policy-subtitle5-text2": "Please note that when an order is canceled that has not been due to our fault, we do not refund the amount charged for Shipping and Handling.",
			"return-policy-subtitle5-text3": "The concept of Handling and Shipping includes, in addition to the preparation, packaging, shipping and delivery of the order, the use of the platform, payment processing, and in the case of cancellations, inventory adjustment and the applicable cancellation fee. the payment gateway we work with.",
			"return-policy-subtitle6": "GENERAL NOTES TO TAKE INTO ACCOUNT FOR CLAIMS AND / OR CANCELLATIONS:",
			"return-policy-subtitle6-text1": "1. All cancellations must be made through the Customer Service channels by the customer who made the purchase, within a period of no more than 24 hours after the order is completed.",
			"return-policy-subtitle6-text2": "2. Claims made outside the first 24 hours after delivery of the order will be rejected.",
			"return-policy-subtitle6-text3": "3. For a claim to be valid, the damaged products and / or original packaging must be kept.",
			"return-policy-subtitle6-text4": "4. Items that have been consumed or tampered with can be denied exchange or refund.",
			"return-policy-subtitle6-text5": "5. The exchange of the products may take 5 to 7 days.",
			"return-policy-subtitle6-text6": "6. Refunds are made exclusively to the payment method used for the purchase. It may take 5 to 7 days to reflect on the account, depending on the bank of the card used.",
			"shippingPolicy.title": "DELIVERY POLICY AND RATES",
			"shippingPolicy.subtitle1": "Important shipping information"
		},
		"es": {
			"a-special-gift": "un regalo especial?",
			"about-katapulk": "Sobre CubaLicores",
			"about-us": "Sobre Nosotros",
			"add-to-cart": "Agregar al Carrito",
			"add-to-wish-list": "Añadir a la Lista",
			"address": "Información Personal",
			"address1": "Dirección Línea 1*",
			"address2": "Dirección Línea 2",
			"adjustmentTotal": "Total de ajuste",
			"all": "Todas",
			"all-details": "Todos los detalles",
			"whatsapp-me-at": "WhatsApp a",
			"attention": "ATENCIÓN",
			"attention-not-available": "ATENCIÓN: NO DISPONIBLE",
			"attributes.description": "Descripción",
			"auth-failed": "Autenticación fallida",
			"back": "Anterior",
			"be-the-first-to-comment": "Sé el primero en comentar.",
			"beauty-and-grooming": "Aseo Personal y Belleza",
			"bids-and-offers": "Pujas y Ofertas",
			"billingAddress": "Dirección de facturación",
			"billingInfo": "Dirección de facturación",
			"billingInfoDetails": "Dirección asociada a tu tarjeta",
			"cardExpiration": "Caducidad*",
			"card-expiry-placeholder": "Caducidad",
			"cardNumber": "Número de tarjeta*",
			"cart": "Carrito",
			"cart-is-empty": "Su carro está vacío.",
			"cart-is-now-empty": "¡Su carrito ha sido vaciado!",
			"cart-is-unable-to-empty": "¡Lo sentimos! No pudimos vaciar su carrito. Por favor, inténtelo de nuevo.",
			"cart-already-empty": "Su carrito está vacío.",
			"category": "Categoría",
			"checkout": "Comprar",
			"city": "Ciudad*",
			"classified-ads": "Anuncios clasificados",
			"clear-filter": "Limpiar Filtro",
			"combos": "Combos",
			"coming-soon": "Próximamente",
			"coming-soon-button": "Ver los productos de CubaLicores",
			"coming-soon-desc": "Estamos agregando nuevas funcionalidades a nuestra plataforma. Pronto estos productos estarán disponibles. Por favor, sea paciente y explore nuestro",
			"coming-soon-text": "Estos productos estarán disponibles pronto",
			"complete": "Completar",
			"confirm": "Confirmar",
			"confirmOrder": "Confirme su pedido",
			"confirmOrderMobile": "Confirmar",
			"confirmPassword": "Confirmar contraseña*",
			"contact": "Contactar",
			"continue": "Continuar",
			"continue-shopping": "Continuar comprando",
			"conversations": "Conversaciones",
			"copyright": "2022 © Othar Trade & Logistics Spain all rights reserved.",
			"country": "País",
			"customer-service": "Servicio al cliente",
			"days": "días",
			"delivery": "Entrega",
			"description": "Descripción",
			"do-you-need": "¿Necesitas",
			"dont-have-an-account-yet": "¿No tienes una cuenta todavía?",
			"email": "Email*",
			"email-receiver": "Email",
			"email-address": "Correo",
			"email-order-placeholder": "Correo electrónico para recibir la orden",
			"empty-cart": "Vaciar Carrito",
			"emptyCart": "Cesta vacía",
			"error": "Error!",
			"payment-error": "Problema con el pago!",
			"estimated-arrival-time": "Tiempo estimado de arribo",
			"shipping-policy-link-text": "Ver política de entrega y tarifas",
			"faqs": "Preguntas Frecuentes",
			"fetching-data": "Obteniendo datos",
			"firstname": "Nombre*",
			"follow-us": "síguenos",
			"food": "Alimentos",
			"store": "Tienda",
			"mostVisited": "Tiendas más visitadas",
			"allStores": "Todas las tiendas",
			"paginator-sentence-1": "Mostrando",
			"paginator-sentence-2": "de",
			"paginator-sentence-3": "resultados",
			"for-the-best-experience": "para una mejor experiencia",
			"forgot-password": "¿Olvidaste la contraseña?",
			"go": "Ir!",
			"goToCart": "Ir a la cesta",
			"grooming": "Aseo Personal",
			"heading": "Colección de estilo",
			"hello": "Hola!",
			"in-katapulk": "en CubaLicores",
			"in-stock": "En Stock",
			"inspired-by-cuba": "Inspirado en Cuba",
			"invalid-user-password": "Usuario y/o contraseña no válida.",
			"invalid-forgot-password": "Error updating password",
			"item-added": "Artículo añadido al carrito",
			"item-not-removed-from-cart": "No se puede eliminar el producto del carrito.",
			"item-removed-from-cart": "Producto eliminado del carrito.",
			"itemTotal": "Total de artículo",
			"lastname": "Apellidos*",
			"loading-more": "Cargando...",
			"loading-please-wait": "Cargando, por favor espere...",
			"loading-recommendations": "Cargando recomendaciones",
			"loading-stores": "Cargando tiendas",
			"location": "Localidad",
			"login": "Iniciar sesión",
			"logout": "Salir",
			"made-in-cuba": "Hecho en Cuba",
			"manage-profile": "Editar perfil",
			"mercado-unico": "CubaLicores",
			"message": "Message",
			"modal-store-button-empty": "Vaciar Carrito",
			"modal-store-button-close": "Cerrar",
			"modal-store-title": "Alerta",
			"modal-store-text1": "Tiene un su carrito productos pendiente de otra tienda",
			"modal-store-text2": "Usted está seguro que desea vaciar su carrito?",
			"modal-zone-text1": "Algunos de los productos seleccionados no están disponibles para la zona actual",
			"modal-zone-text2": "Está seguro que desea vaciar su carrito?",
			"modal-municipality-text": "Algunos de los productos seleccionados no están disponibles para este municipio. ¿Está seguro que desea vaciar su carrito?",
			"modal-zoneSelect-title": "Hola",
			"modal-zoneSelect-text1": "Por favor, seleccione la zona en la que desea entregar los productos:",
			"modal-zoneSelect-accept": "Aceptar",
			"modal-zoneSelect-cancel": "Cancelar",
			"models.country": "País",
			"models.productProperties": "Propiedades del producto",
			"models.shipment": "Paquetes",
			"models.state": "estado",
			"models.variant": "Variante",
			"municipality": "Municipio*",
			"my-account": "Mi cuenta",
			"my-bids-and-offers": "Mis Pujas y Ofertas",
			"my-orders": "Mis órdenes",
			"myOrders": "Mis pedidos",
			"nameOnCard": "Nombre en la tarjeta*",
			"need-help": "¿Necesita ayuda?",
			"no-products-found": "Productos no encontrados.",
			"not-found": "No Encontrado",
			"note": "Notas",
			"notifications": "Notificaciones",
			"offers": "Ofertas",
			"oops": "Ups!",
			"oops-text": "Parece que no podemos encontrar la página que está buscando.",
			"orderItems": "Productos en la orden",
			"orderNumber": "No. Orden",
			"orderTotal": "Total del pedido",
			"our": "Nuestras",
			"out-of-stock": "Fuera de stock",
			"sorry-out-of-stock": "Lo sentimos, no hay existencias",
			"packages": "Paquete(s)",
			"password": "Contraseña*",
			"payment": "Pago",
			"paymentStatus": "Estado del pago",
			"phone": "Teléfono*",
			"please-wait": "por favor espere",
			"powered-by-stripe": "Desarrollado por Stripe",
			"price": "Precio",
			"price-details": "Detalles de precio",
			"privacy-policy": "Política de privacidad",
			"privacy-policy-copyright-text1": "© Copyright 2020 www.cubalicores.com / cubalicores.com y las sociedades colaboradoras de",
			"privacy-policy-copyright-text2": "Prohibida la reproducción total o parcial.",
			"privacy-policy-subtitle1": " 1) Introducción",
			"privacy-policy-subtitle1-text1": "a. El acceso al portal www.cubalicores.com / cubalicores.com está condicionado a la previa lectura y aceptación del usuario de las condiciones, términos, comunicaciones, advertencias, avisos legales y demás información contenida en estos Términos y Condiciones. El acceso al mismo tiene carácter gratuito, su visualización no requiere previa suscripción o registro alguno, y su utilización por parte del usuario implica su conformidad de forma expresa, plena y sin reserva, con la totalidad de su contenido.",
			"privacy-policy-subtitle1-text2": "b. Si el Usuario no estuviera de acuerdo con el contenido de las presentes Condiciones Generales de acceso de navegación y uso de esta web no podrá acceder ni comprar los productos y servicios que esta ofrece.",
			"privacy-policy-subtitle1-text3": "c. Aceptando estos términos y condiciones, el usuario afirma y declara ser mayor de edad y disponer de la capacidad jurídica suficiente para registrarse en esta web. Igualmente, acepta de forma expresa y sin excepciones que el acceso y la utilización del presente sitio Web, de sus servicios y de los contenidos de dichos servicios tienen lugar bajo su única y exclusiva responsabilidad, no pudiendo garantizar www.cubalicores.com / cubalicores.com que en el acceso directo a otros sitios Web a través de enlaces (links) pueda visualizar información que pudiera herir su sensibilidad o le provoque daños.",
			"privacy-policy-subtitle1-text4": "d. Las conexiones con otros sitios Web que pudieran existir, así como el uso que el Usuario pueda hacer de las mismas, está sujeto a estas condiciones, así como a los eventuales condicionantes específicos que los citados sitios Web requieran. Cualquier utilización distinta a la autorizada está expresamente prohibida.",
			"privacy-policy-subtitle1-text5": "podrá modificar esta Web de modo unilateral y en cualquier momento que estime oportuno, actualizando su configuración, los términos y condiciones de los servicios y su contenido, eliminarlos, limitarlos o suspenderlos de manera temporal o definitiva, así como impedir el acceso a los mismos procurando informar al Usuario de dicho cambio, siempre y cuando las circunstancias así se lo permitan, a través de su publicación en el sitio Web, motivo por el cual se recomienda a los Usuarios que consulten en cada acceso a la Web las CG, las Condiciones Generales de Venta, Avisos Legales y Condiciones particulares enunciadas en las distintas páginas que componen el sitio Web.",
			"privacy-policy-subtitle2": " 2) Características de la web y navegabilidad",
			"privacy-policy-subtitle2-text1": "a. Diseño de web adaptado. La Web de www.cubalicores.com / cubalicores.com tiene un diseño responsive que permite al cliente acceder a la web desde diferentes dispositivos, adaptando la imagen y resolución de la página Web a cada dispositivo.",
			"privacy-policy-subtitle2-text2": "b. Alta en cuenta. Existe un Registro, al que se accede en el apartado MI CUENTA, que el usuario completará con los datos requeridos y con la aceptación del aviso legal para poder acceder a los servicios de compra online de www.cubalicores.com / cubalicores.com.",
			"privacy-policy-subtitle2-text3": "c. Posibilidad de gestión de datos de perfil. Existe un apartado de INFORMACIÓN, al que se accede a través de MI CUENTA, en que el usuario puede:",
			"privacy-policy-subtitle2-text3-1": "i. Gestionar sus datos personales",
			"privacy-policy-subtitle2-text3-2": "ii. Adicionar destinatarios",
			"privacy-policy-subtitle2-text3-3": "iii. Consultar crédito o bonificaciones disponibles",
			"privacy-policy-subtitle2-text3-4": "iv. Gestionar las ordenes",
			"privacy-policy-subtitle2-text3-5": "v. Visualizar los productos añadidos a FAVORITOS",
			"privacy-policy-subtitle3": " 3) Derechos y obligaciones del prestador de servicios",
			"privacy-policy-subtitle3-text1": "a. www.cubalicores.com / cubalicores.com se encuentra obligada a prestar los servicios ofertados en la Web y garantizar las comunicaciones que pudieran existir con el cliente, así como a responder a las reclamaciones y consultas que puedan surgir.",
			"privacy-policy-subtitle3-text2": "b. www.cubalicores.com / cubalicores.com tiene el derecho a suspender temporalmente y sin necesidad de pre-aviso la accesibilidad a la presente Web, así como a reservarse el derecho de prestación o la cancelación de los servicios, en caso de efectuar operaciones de mantenimiento, reparación, actualización o mejora de los servicios.",
			"privacy-policy-subtitle3-text3": "c. Los derechos de propiedad intelectual sobre el sitio Web son titularidad de",
			"privacy-policy-subtitle3-text4": "Los derechos de reproducción, distribución, comunicación pública y transformación pertenecen a la misma compañía.",
			"privacy-policy-subtitle4": " 4) Derechos y obligaciones del usuario",
			"privacy-policy-subtitle4-text1": "a. Los contenidos de esta web están a disposición del usuario para su utilización sin ningún fin comercial y exclusivamente para su uso personal; y sólo con esos fines el usuario puede transferir los contenidos de esta Web. El usuario no puede, en consecuencia, distribuir, modificar, transmitir, reenviar o usar en forma alguna, dichos contenidos con fines comerciales.",
			"privacy-policy-subtitle4-text2": "b. En todo momento el Usuario debe realizar un uso lícito de los servicios de esta Web de acuerdo con la legalidad vigente, respetando los derechos de propiedad intelectual de",
			"privacy-policy-subtitle4-text3": "y de posibles terceros.",
			"privacy-policy-subtitle4-text4": "c. El Usuario no realizará a través de los servicios que pone a su disposición www.cubalicores.com / cubalicores.com ninguna acción que cause daño o alteraciones de los contenidos u obstaculice el buen funcionamiento de la Web, comprometiéndose expresamente por el solo uso de la misma a no causar problemas técnicos de cualquier índole, transferir elementos susceptibles de portar virus informáticos o dañar, interferir o interceptar total o parcialmente la Web, así como a no intervenir o alterar el correo electrónico de otros Usuarios.",
			"privacy-policy-subtitle4-text5": "d. La responsabilidad del Usuario sobre la veracidad de los datos introducidos, en el caso de que lo hiciera por cualquier circunstancia, es exclusiva del mismo Usuario; por lo que, en caso de haber facilitado datos falsos o inexactos, www.cubalicores.com / cubalicores.com y, en su caso, las sociedades colaboradoras de",
			"privacy-policy-subtitle4-text6": ", se reservan el derecho a prohibirle el acceso a esta Web.",
			"privacy-policy-subtitle5": " 5) Exclusión de garantías y de responsabilidad del funcionamiento del sitio web",
			"privacy-policy-subtitle5-text1": "a. www.cubalicores.com / cubalicores.com se compromete a trabajar para mantener la disponibilidad continuada de la presente Web, pero ni www.cubalicores.com / cubalicores.com ni las sociedades colaboradoras de",
			"privacy-policy-subtitle5-text2": ", garantizan la disponibilidad y continuidad del funcionamiento del presente sitio Web y de sus servicios. De esta forma, se excluye cualquier responsabilidad por los daños y perjuicios de cualquier naturaleza que puedan derivarse de la falta de disponibilidad o de continuidad del funcionamiento del sitio Web y de sus servicios y la utilidad que los Usuarios hubieran podido atribuir al presente sitio Web.",
			"privacy-policy-subtitle5-text3": "b. www.cubalicores.com / cubalicores.com y las sociedades colaboradoras de",
			"privacy-policy-subtitle5-text4": "ponen a disposición de los Usuarios los sistemas de privacidad de datos personales que impidan el acceso a los mismos por parte de terceros. www.cubalicores.com / cubalicores.com y las sociedades colaboradoras deo",
			"privacy-policy-subtitle5-text5": "han implantado todas las medidas de seguridad técnicas y organizativas necesarias que garanticen la integridad, confidencialidad y disponibilidad de los datos personales facilitados por el Usuario. En este sentido, las citadas sociedades se eximen de toda responsabilidad por los daños y perjuicios ocasionados en caso de producirse tal conocimiento.",
			"privacy-policy-subtitle5-text6": "c. Pese a que www.cubalicores.com / cubalicores.com han implantado todas aquellas medidas adecuadas para garantizar la seguridad en esta materia, no controla ni garantiza la ausencia de virus ni de otros elementos en los contenidos de la presente página Web que puedan producir alteraciones en el sistema informático (software y hardware) del Usuario o en los documentos electrónicos y ficheros almacenados en su sistema informático.",
			"privacy-policy-subtitle5-text7": "d. www.cubalicores.com / cubalicores.com y las sociedades colaboradoras de",
			"privacy-policy-subtitle5-text8": "se eximen de cualquier responsabilidad por los daños y perjuicios de toda naturaleza que puedan deberse a la presencia de virus en los contenidos que puedan producir alteraciones en el sistema informático, documentos electrónicos, ficheros, etc…",
			"privacy-policy-subtitle5-text9": "e. www.cubalicores.com / cubalicores.com y las sociedades colaboradoras de",
			"privacy-policy-subtitle5-text10": "no tienen obligación de controlar, y no controlan, la utilización que los Usuarios hacen de este sitio Web, de los servicios que este sitio Web provee, ni de sus contenidos. En particular, www.cubalicores.com / cubalicores.com no garantiza que los Usuarios utilicen el sitio Web, sus servicios y sus contenidos de conformidad con los términos y condiciones bajo dominio www.cubalicores.com / cubalicores.com que en cada momento resulten de aplicación, ni que lo hagan de forma diligente y prudente.",
			"privacy-policy-subtitle5-text11": "f. www.cubalicores.com / cubalicores.com y las sociedades colaboradoras de",
			"privacy-policy-subtitle5-text12": "tampoco tienen la obligación de verificar, y no verifican, la identidad de los Usuarios de este sitio Web; ni la veracidad, de los datos que los mismos proporcionan sobre sí mismos o destinatarios.",
			"privacy-policy-subtitle5-text13": "g. El Usuario acepta que el sitio Web ha sido creado y desarrollado de buena fe por www.cubalicores.com / cubalicores.com y las sociedades colaboradoras de",
			"privacy-policy-subtitle5-text14": "con información procedente de fuentes internas y externas y lo ofrece en su estado actual a los Usuarios, pudiendo contener imprecisiones o erratas por lo cual el Usuario exonera a www.cubalicores.com / cubalicores.com y las sociedades colaboradoras de",
			"privacy-policy-subtitle5-text15": "de cualquier responsabilidad en relación con la fiabilidad, utilidad o falsas expectativas que el sitio Web pudiera producirle durante su navegación por el mismo.",
			"privacy-policy-subtitle6": " 6) Propiedad intelectual",
			"privacy-policy-subtitle6-text1": "a. Todos los derechos sobre el contenido de la presente Web pertenecen a www.cubalicores.com / cubalicores.com y las sociedades colaboradoras de",
			"privacy-policy-subtitle6-text2": "; salvo aquéllos de empresas con las que haya firmado el correspondiente contrato para la provisión de contenidos.",
			"privacy-policy-subtitle6-text3": "b. www.cubalicores.com / cubalicores.com no transfiere al Usuario de esta Web propiedad alguna sobre su propio software o de terceros; el Usuario es el responsable del soporte en el cual el software es grabado, reteniendo www.cubalicores.com / cubalicores.com y las sociedades colaboradoras de",
			"privacy-policy-subtitle6-text4": "todos los derechos de propiedad industrial e intelectual incluyendo el software que le pudiera corresponder.",
			"privacy-policy-subtitle6-text5": "c. El diseño, imágenes, mapas, gráficos, marcas, rótulos, signos distintivos o logos de www.cubalicores.com / cubalicores.com, frames, banners, el software y sus distintos códigos fuente y objeto, etc., de esta Web son titularidad de www.cubalicores.com / cubalicores.com y las sociedades colaboradoras de",
			"privacy-policy-subtitle6-text6": ", quienes poseen legítimamente y en exclusiva los derechos de explotación sobre los mismos.",
			"privacy-policy-subtitle6-text7": "d. Los logos o signos distintivos de las sociedades del Grupo que pudieran aparecer en esta Web durante la navegación del Usuario son titularidad de cada una de ellas, disponiendo legítimamente en exclusiva de los derechos de explotación sobre los mismos, consintiendo expresamente que los mismos sean incorporados, en su caso, a esta Web.",
			"privacy-policy-subtitle6-text8": "e. El Usuario que acceda a esta Web no puede copiar, modificar, distribuir, transmitir, reproducir, publicar, ceder ni vender los elementos anteriormente mencionados; ni crear nuevos productos o servicios derivados de la información obtenida a través de esta Web.",
			"privacy-policy-subtitle6-text9": "f. Únicamente queda autorizada la visualización y carga para el uso personal y no comercial del Usuario, sin que pueda hacerlo extensivo a terceras personas o entidades. En el caso de gráficos o diseños que aparezcan en esta Web cuya titularidad sean de empresas colaboradoras de www.cubalicores.com / cubalicores.com y las sociedades colaboradoras de",
			"privacy-policy-subtitle6-text10": "g. Queda terminantemente prohibida cualquier alteración de esta Web o de su contenido por parte del Usuario; así como la instalación de enlaces (hiperenlaces, vínculos o hipervínculos), links o similares no autorizados previa y expresamente por www.cubalicores.com / cubalicores.com y las sociedades colaboradoras de",
			"privacy-policy-subtitle6-text11": "h. www.cubalicores.com / cubalicores.com velará para que los contenidos de esta Web no sean pornográficos, xenófobos, discriminatorios, racistas, difamatorios, o fomenten cualquier género de violencia.",
			"privacy-policy-subtitle7": " 7) Protección de datos de carácter personal. En cumplimiento con las normativas vigentes de protección de datos de carácter personal de los usuarios,",
			"privacy-policy-subtitle7-text1": "a. www.cubalicores.com / cubalicores.com y las sociedades colaboradoras de",
			"privacy-policy-subtitle7-text2": "respetarán, en todo momento, lo dispuesto en la normativa vigente sobre protección de datos de carácter personal; y garantizan la confidencialidad de los datos personales. En cumplimiento con la normativa vigente sobre protección de datos de carácter personal, le informamos de que los datos aportados serán tratados por www.cubalicores.com / cubalicores.com y las sociedades colaboradoras de",
			"privacy-policy-subtitle7-text3": "en calidad de Responsables del Fichero.",
			"privacy-policy-subtitle7-text4": "b. La aportación de datos personales, propios o de terceros, a través de los formularios dispuestos al efecto en el Sitio Web de www.cubalicores.com / cubalicores.com sólo podrán realizarla personas mayores de edad.",
			"privacy-policy-subtitle7-text5": "c. Las entidades del Grupo con acceso a los datos personales de los Usuarios de www.cubalicores.com / cubalicores.com son",
			"privacy-policy-subtitle7-text6": "(comercio),",
			"privacy-policy-subtitle7-text7": "(comunicaciones) y",
			"privacy-policy-subtitle7-text8": "(agencia de viajes)",
			"privacy-policy-subtitle7-text9": "d. Mediante la aceptación de la presente Información Legal, el Usuario autoriza a www.cubalicores.com / cubalicores.com y las sociedades colaboradoras de",
			"privacy-policy-subtitle7-text10": "y a todas las sociedades del Grupo a tratar los datos aportados en este sitio web con cualquiera de las siguientes finalidades:",
			"privacy-policy-subtitle7-text10-1": "i. Gestionar los datos para tramitar sus pedidos de compra on-line.",
			"privacy-policy-subtitle7-text10-2": "ii. Gestionar la participación del usuario en posibles eventos y acciones promocionales",
			"privacy-policy-subtitle7-text10-3": "iii. Gestionar los procesos de selección de la Entidad ",
			"privacy-policy-subtitle7-text10-4": "y las sociedades del Grupo",
			"privacy-policy-subtitle7-text10-5": "iv. Gestionar las posibles relaciones entre el Usuario del Sitio Web y www.cubalicores.com / cubalicores.com.",
			"privacy-policy-subtitle7-text10-6": "v. Utilizar los datos para remitir al Usuario de www.cubalicores.com / cubalicores.com a encuestas e información y/o documentación de los productos y/o servicios solicitados por el Usuario y/o comercializados por www.cubalicores.com / cubalicores.com a través de diversos medios, inclusive los electrónicos (correo electrónico y telefonía móvil).",
			"privacy-policy-subtitle7-text10-7": "vi. El consentimiento para la utilización de los datos del Usuario para el envío de comunicaciones comerciales a través de medios electrónicos (correo electrónico u otros actuales o futuros) podrá ser revocada por el Usuario en cualquier momento en el tiempo, a través del apartado “MI PERFIL” del Sitio Web de www.cubalicores.com / cubalicores.com",
			"privacy-policy-subtitle7-text10-8": "vii. En todo caso, para el ejercicio de los derechos de acceso rectificación, cancelación u oposición, deberá remitirse un escrito identificado, en el que se concrete la solicitud correspondiente y al que acompañe fotocopia del Carnet de Identidad del interesado, a la siguiente dirección: C/ BARBASTRO 4 1 A HUESCA 22002-HUESCA, España.",
			"privacy-policy-subtitle7-text11": "e. Cuando el Usuario facilite sus datos a www.cubalicores.com / cubalicores.com y las sociedades colaboradoras de",
			"privacy-policy-subtitle7-text12": ", a través de alguno de los formularios de la Web, el Usuario estará autorizando a las referidas sociedades para que puedan tratar sus datos de conformidad con la finalidad de la recogida. Los datos facilitados formarán parte de un fichero, creado bajo la responsabilidad de la sociedad a la que el Usuario facilite sus datos.",
			"privacy-policy-subtitle7-text13": "f. www.cubalicores.com / cubalicores.com informa al Usuario de la existencia en este sitio Web de enlaces que permiten el acceso a diferentes páginas Web de determinadas entidades del Grupo, así como a diversas organizaciones o entidades de terceros cuya titularidad no es de www.cubalicores.com / cubalicores.com ni sociedades del Grupo",
			"privacy-policy-subtitle7-text14": "g. El Usuario podrá ejercitar los derechos de acceso, rectificación, cancelación y oposición en la dirección y ante el responsable del fichero que se indique en cada caso concreto. De esta forma, www.cubalicores.com / cubalicores.com y las sociedades colaboradoras de",
			"privacy-policy-subtitle7-text15": "pretenden garantizar a los Usuarios, el derecho a la información en el momento en que se lleve a cabo la recogida de sus datos.",
			"privacy-policy-subtitle7-text16": "h. El Usuario será el único responsable en caso de que cumplimente los formularios con datos falsos, inexactos, incompletos o no actualizados. Todos los datos facilitados por el Usuario serán tratados de forma confidencial.",
			"privacy-policy-subtitle7-text17": "i. La sociedad a la que el Usuario haya podido facilitar sus datos, sólo podrá cederlos.",
			"privacy-policy-subtitle7-text18": "j. Parte de los servicios de www.cubalicores.com / cubalicores.com utilizan \"cookies\". Para más información, consulte nuestra política de cookies.",
			"privacy-policy-subtitle8": " 8) Vínculos o enlaces",
			"privacy-policy-subtitle8-text1": "a. Sin el expreso consentimiento de www.cubalicores.com / cubalicores.com y las sociedades colaboradoras de",
			"privacy-policy-subtitle8-text2": ", no se podrá establecer vínculo a este sitio web desde cualquier otra web.",
			"privacy-policy-subtitle8-text3": "b. Sí la web tuviese links o vínculos a otros portales, no gestionados por",
			"privacy-policy-subtitle8-text4": ", se excluye toda responsabilidad por parte de la compañía sobre el control y responsabilidad de los productos o servicios ofertados, así como los contenidos y propietarios.",
			"privacy-policy-subtitle8-text5": ", se exoneran de toda responsabilidad en relación con los contenidos y servicios prestados por terceros frente a cualquier reclamación de cualquier naturaleza y demandas que pudieran interponerse en relación con los mismos.",
			"privacy-policy-subtitle9": " 9) Nulidad e ineficacia de las cláusulas",
			"privacy-policy-subtitle9-text1": "a. Si se diera el caso de que cualquier contenido de estos términos y condiciones fuera declarado nulo o ineficaz, sólo afectará a al contenido indicado o parte del mismo.",
			"privacy-policy-subtitle10": "10) Ley aplicable y jurisdicción",
			"privacy-policy-subtitle10-text1": "a. Los Términos y Condiciones de este sitio web se regirán por la legislación Española.",
			"privacy-policy-subtitle10-text2": "b. En caso de que cualquier Usuario o tercero afectado considere que existen hechos o circunstancias que revelen el carácter ilícito deberá enviar una comunicación en la que se contengan los siguientes extremos:",
			"privacy-policy-subtitle10-text2-1": "i. Datos personales completos del reclamante: Nombre, apellidos, dirección, número de teléfono y dirección de correo electrónico.",
			"privacy-policy-subtitle10-text2-2": "ii. Especificación, de manera pormenorizada, de los siguientes extremos: En qué consiste el supuesto contenido ilícito o la ilicitud del uso del contenido. Si se es titular del contenido ilícitamente usado.",
			"privacy-policy-subtitle10-text2-3": "iii. Cuando se trate de una supuesta lesión de bienes o derechos susceptibles de indemnización, indicación precisa y concreta de los contenidos protegidos, así como de su localización en la Web.",
			"privacy-policy-subtitle10-text2-4": "iv. El reclamante habrá de remitir por correo postal a",
			"privacy-policy-subtitle10-text2-5": ", ubicada en C/ BARBASTRO 4 1 A HUESCA 22002-HUESCA, España la siguiente documentación",
			"privacy-policy-subtitle10-text2-5.1": "1. Comunicación firmada a mano, del titular de los derechos supuestamente infringidos o de la persona autorizada para actuar en su nombre y por su cuenta a la que se acompañe documentación acreditativa de la titularidad del bien o derecho presuntamente lesionado, en la que se refiera de manera precisa los datos de la página Web, contenido, o hipervínculo objeto de queja.",
			"privacy-policy-subtitle10-text2-5.2": "2. En caso de no ser titular del derecho o bien lesionado, declaración jurada, expresa, clara y bajo la responsabilidad del reclamante de que la información proporcionada en la notificación online es exacta y que el contenido o actividad referida es ilícita. El documento habrá de ir firmado a mano y acompañar copia del Carnet de Identidad o documento de identificación equivalente.",
			"privacy-policy-subtitle10-text2-5.3": "3. NO SE ADMITIRÁN COMUNICACIONES ANÓNIMAS COMO NOTIFICACIÓN SUFICIENTE PARA PONER EN CONOCIMIENTO www.cubalicores.com / cubalicores.com y las sociedades colaboradoras de",
			"privacy-policy-subtitle10-text2-5.4": "LA ILICITUD DE CONTENIDOS O ACTIVIDADES.",
			"privacy-policy-text1": "Este aviso legal recoge las condiciones generales de acceso, navegación, y uso del sitio web www.cubalicores.com / cubalicores.com; así como los detalles del tratamiento de los datos de nuestros clientes. Es necesario que acepte este aviso legal para navegar las páginas de www.cubalicores.com y cubalicores.com, así como para realizar una compra.",
			"privacy-policy-title": "AVISO LEGAL Y POLÍTICA DE PRIVACIDAD",
			"privacy-protected": "Privacidad protegida",
			"proceed-to-checkout": "Proceder al pago",
			"product": "Producto",
			"product-list": "Lista de Productos",
			"products": "Productos",
			"products-from": "Productos de ",
			"qty": "Cantidad",
			"quantity": "Cantidad",
			"quantity-greater-than-zero": "La cantidad debe ser numérica y mayor que cero.",
			"quantity-success-update": "La cantidad de su producto se ha actualizado correctamente.",
			"rate": "Tarifa",
			"recommendations": "recomendaciones",
			"register": "Registrarse",
			"register-confirmation": "Confirmación de Registro",
			"remember-me": "Recuérdame",
			"rememberAddress": "Recuerde esta dirección",
			"reviews": "Comentarios",
			"savePayment": "Efectuar Pago",
			"savePaymentMobile": "Pagar",
			"savePaymentMethod": "Continuar",
			"send": "Enviar",
			"send-email-failure": "Correo no encontrado.",
			"send-email-success-1": "El correo eléctronico ha sido enviado con éxito.",
			"send-email-success-2": "Por favor, revíselo para continuar con el proceso.",
			"send-failed": "Fallo de Envío",
			"send-failed-message": "Error enviando datos de contacto",
			"send-success": "Envío con éxito",
			"send-success-message": "Hemos recibido su mensaje. Atenderemos su pedido lo antes posible y nos pondremos en contacto de ser necesario.",
			"secure-checkout": "Pago Seguro",
			"secure-connection": "Conexión Segura",
			"security-digits": "Dígitos de seguridad",
			"shipment": "Método de envío para ",
			"shipmentNumber": "No. Envío",
			"shipmentState.canceled": "Envío cancelado",
			"shipmentState.pending": "Envío bajo revisión",
			"shipmentState.ready": "Pronto despacho",
			"shipmentState.shipped": "Enviado",
			"shipping-and-rates": "Tarifas de envío",
			"shippingAddress": "Dirección de envío",
			"shippingCharges": "Gastos de envío",
			"shippingInfo": "Dirección de envío",
			"shippingInfoDetails": "La dirección de entrega del producto",
			"shippingInfoEmail": "Correo electrónico del receptor",
			"shippingMethod": "Método de envío",
			"shippingPolicy.subtitle2.subtitle1.text1": "Envíos a La Habana.",
			"shippingPolicy.subtitle2.subtitle1.text2": "Transportista",
			"shippingPolicy.subtitle2.subtitle1.text3": "excepto los indicados como GRATIS",
			"shippingPolicy.subtitle2.subtitle1.text4": "Las tarifas de envíos incluyen cargos por manipulación.",
			"shippingPolicy.subtitle2.text5": "Los plazos de entrega de los envíos o de la prestación de los servicios comprados, comienzan a regir a partir de la aprobación de la orden y verificación de los contactos del destinatario",
			"shippingPolicy.subtitle3.table.home-deli.text1": "Productos precocinados y congelados",
			"shippingPolicy.subtitle3.table.jardin-angelica.text1": "Arreglos florales y cerámicas",
			"shippingPolicy.subtitle3.table.dolce-tentazione.text1": "Dulces y pies",
			"shippingPolicy.subtitle3.table.el-bodegon.text1": "Comida elaborada y lista para consumir",
			"shippingPolicy.subtitle3.table.el-idilio.text1": "Pierna de cerdo",
			"shippingPolicy.subtitle3.table.lola-cafe.text1": "Dulcería",
			"shippingPolicy.subtitle3.table.text2.7": "hasta 7 días hábiles",
			"shippingPolicy.subtitle3.table.home-deli.text2": "24 horas",
			"shippingPolicy.subtitle3.table.jardin-angelica.text2": "24 - 78 horas",
			"shippingPolicy.subtitle3.table.el idilio.text2": "hasta 3 días hábiles",
			"shippingPolicy.subtitle3.table.lola-cafe.text2": "hasta 2 días hábiles",
			"shippingPolicy.subtitle3.table.decoceramica.text1": "Productos decorativos hechos de cerámica, a mano.",
			"shippingPolicy.subtitle3.table.decoceramica.text2": "Hasta 10 días laborales",
			"shippingPolicy.subtitle3.table.decoceramica.text3": "Entregas los sábados",
			"shippingPolicy.subtitle3.table.text3.1": "Entrega todos los días",
			"shippingPolicy.subtitle3.table.text3.2": "Entregas todos los días en el horario de 9:00 am a 6:00 pm",
			"shippingPolicy.subtitle3.table.text10": "Envíos al resto del país -",
			"shippingPolicy.subtitle3.table.text11": "NO ESTAMOS REALIZANDO ENVÍOS AL RESTO DEL PAÍS POR EL MOMENTO.",
			"shippingPolicy.subtitle3.table.text17": "Política de Reclamaciones y Cancelaciones",
			"shippingPolicy.subtitle5.text1": "Plazos estimados, variarán en función de los productos seleccionados",
			"shippingPolicy.subtitle5.text2": "Para la protección contra fraudes y/o usos indebidos de tarjetas de crédito,",
			"shippingPolicy.subtitle5.text3": "se atribuye el derecho de retardar la entrega de los productos y/o servicios hasta se verifique la autenticidad de la compra y, en caso de considerarlo oportuno, profundizará en el origen de cualquier transacción realizada en el sitio, según lo establecido en las regulaciones internas de la empresa.",
			"shippingPolicy.subtitle5.text4": "Los plazos de entrega de los envíos o de la prestación de los servicios comprados, comienzan a regir a partir de la aprobación de la orden una vez comprobada su autenticidad.",
			"shippingPolicy.subtitle5.text5": "Si aún tiene dudas sobre el tiempo de entrega de su envío, por favor, no dude en contactarnos:",
			"shippingPolicy.subtitle5.text6": "Por email en la dirección",
			"shippingPolicy.subtitle5.text7": "Por teléfono a",
			"shippingPolicy.subtitle5.text8": "Por nuestras redes sociales",
			"shippingPolicy.subtitle6.text1": "(*) Plazos estimados, variarán en función de los productos seleccionados",
			"shippingPolicy.subtitle6.text2": "Tarifas de envío y tiempo de entrega para",
			"shippingPolicy.subtitle6.text3": "TIENDAS Y RESTAURANTES EN LA HABANA",
			"shippingPolicy.subtitle6.text3.1": "(*)Todas las órdenes pueden ser canceladas en un plazo menor de 24 horas después de realizada la compra. El destinatario debe revisar el producto en el momento de la entrega, no se aceptan reclamaciones sin evidencia clara que el producto no se corresponde a su descripción, o pruebas de que esté en mal estado. Esta reclamación no será válida después de 24 horas de la entrega. Para mayor información, referirse a nuestra ",
			"shippingTotal": "Gastos de envío",
			"shipping.lola_dulceria_cafe.description": "Repostería artesanal con recetas internacionales, ingredientes locales y sabores tradicionales cubanos. Dulces a base de biscocho, chocolate, canela y frutas tropicales, que buscan elaboraciones creativas y nutritivas para la familia cubana. La única cafetería en La Habana que oferta frozen yogurt con toppins variados. Los productos más populares son los pastelitos de guayaba, rollitos de canela, pastel de hojaldre, galleticas de jengibre y frozen yogurt.",
			"shipping.casa_mia.description": "Proyecto soñado por 2 hermanos y su primo, convirtiendo la casa donde nacieron en un lugar donde degustar exquisita comida, con una hermosa vista al mar.",
			"shipping.home_deli.delivery": "72 hr *No entrega los domingos.",
			"shipping.idilio.delivery": "24 hr <br/>72 hr combos.",
			"shipping.chic-salon.delivery": "5 días",
			"shipping.deco-ceramica.delivery": "10 días *Entrega solo los sábados",
			"shipping.peke-art.delivery": "10 días",
			"shipping.magoz.delivery": "20 días",
			"shipping.la-caja.description": "Proyecto que forma parte del grupo de creación de Humidores Habana creado hace más de 20 años. Nuestro trabajo se dirige fundamentalmente a crear piezas para momentos especiales como aniversarios y cumpleaños. También se cuenta con artículos utilitarios como los contenedores artesanales de colores varios y color madera, con fines también decorativos y los portalaptos de madera.",
			"shipping.la-caja.delivery": "5 días",
			"shipping.la-caja.notes": "Para la personalización de cualquier artículo, ponerse en contacto con Atención al Cliente una vez realizada la compra.",
			"shipping.la-brisca.description": "Juegos de mesa educativos para todos los integrantes del Hogar.",
			"shipping.humidores-habana.delivery": "5 días",
			"shipping.humidores-habana.description": "Grupo de creación cubano dedicado al diseño y producción de humidores exclusivos a través de la fusión de técnicas como la orfebrería, la ebanistería y la marquetería. Todos los artículos pueden ser personalizados con frases y logotipos.",
			"shipping.humidores-habana.notes": "Para la personalización de cualquier artículo, ponerse en contacto con Atención al Cliente una vez realizada la compra.",
			"shipping.zig-zag.delivery": "7 días",
			"shipping.dforja.delivery": "5 días",
			"shopping-cart": "Carrito",
			"signOut": "Desconectar",
			"signUp": "Regístrate",
			"signin": "Entrar",
			"signup": "Registrarse",
			"signup-for": "Regístrate",
			"state": "Estado o Provincia",
			"subheading": "Seleccione un método de envío.",
			"successMessage": "Su pedido se ha realizado correctamente.",
			"summaryHeader": "Resumen de pedido",
			"term-and-conditions": "Términos y Condiciones",
			"terms-conditions-title": "Acuerdo de Condiciones de Uso",
			"terms-conditions-text1": "Este Acuerdo fue revisado por última vez el 17 de febrero de 2021.",
			"terms-conditions-text2": "Bienvenido a CubaLicores, el sitio web y el servicio de mercado en línea (\"Othar Trade & Logistics Spain\", \"nosotros\" o \"nos\"). Esta página explica los términos por los cuales puede utilizar nuestros servicios en línea y / o móviles, sitio web y software. proporcionado en o en conexión con Othar Trade & Logistics Spain (colectivamente el \"Servicio\"). Al acceder o utilizar el Servicio, usted acepta que ha leído, entendido y acepta estar sujeto a estos Términos de uso (el \"Acuerdo\"), ya sea o no eres un usuario registrado de nuestro Servicio.",
			"terms-conditions-text3": "Nos reservamos el derecho de modificar este Acuerdo en cualquier momento notificándole según lo dispuesto en la sección \"Notificaciones\" de este Acuerdo, siempre que no se requiera ni se proporcione ninguna notificación para cambios no sustanciales en el Acuerdo. Si modificamos sustancialmente este Acuerdo, le avisaremos con al menos siete (7) días de anticipación antes de que los cambios entren en vigencia, período durante el cual puede rechazar los cambios cancelando su cuenta. Su uso continuado del Servicio después de que dicho cambio entre en vigencia constituye su aceptación de los nuevos Términos de uso. Si no está de acuerdo con alguno de estos términos o con los Términos de uso futuros, su único recurso será no usar o acceder (o continuar accediendo) al Servicio. Este Acuerdo se aplica a todos los visitantes, usuarios y otras personas que acceden al Servicio (\"Usuarios\").",
			"terms-conditions-subheader1": "USO DE NUESTRO SERVICIO",
			"terms-conditions-subheader1-subtitle1": "ELEGIBILIDAD",
			"terms-conditions-subheader1-subtitle1-text1": "Puede usar el Servicio solo si puede formar un contrato vinculante con Othar Trade & Logistics Spain, y solo de conformidad con este Acuerdo y todas las leyes, reglas y regulaciones locales, estatales, nacionales e internacionales aplicables. Si es menor de 18 años, su padre o tutor debe celebrar este Acuerdo en su nombre y será responsable de su uso y acceso al Servicio; esto incluye la responsabilidad financiera por cualquier artículo que compre a través del Servicio. Cualquier uso o acceso al Servicio por cualquier persona menor de 13 años está estrictamente prohibido y en violación de este Acuerdo. Si es menor de 13 años, no intente registrarse en el Servicio ni enviarnos ninguna información sobre usted, incluido su nombre, dirección, número de teléfono o dirección de correo electrónico. Si nos enteramos de que hemos recopilado información personal de cualquier persona menor de 13 años sin verificación del consentimiento de los padres, eliminaremos esa información lo antes posible. Si cree que podríamos tener información de o sobre cualquier persona menor de 13 años, comuníquese con nosotros a",
			"terms-conditions-subheader1-subtitle1-text2": ". El Servicio no está disponible para ningún Usuario previamente eliminado del Servicio por Othar Trade & Logistics Spain. Othar Trade & Logistics Spain se reserva todos los derechos no otorgados expresamente en virtud de este Acuerdo. Cualquier intento por su parte de transferir cualquiera de los derechos, deberes u obligaciones en virtud del presente, excepto según lo dispuesto expresamente en este Acuerdo, es nulo.",
			"terms-conditions-subheader1-subtitle2": "CUENTAS de Othar Trade & Logistics Spain",
			"terms-conditions-subheader1-subtitle2-text1": "Debe crear una cuenta en Othar Trade & Logistics Spain para obtener acceso a los servicios y la funcionalidad que podemos establecer y mantener de vez en cuando y a nuestra entera discreción. Nunca puede usar la cuenta de otro usuario sin permiso. Usted es el único responsable de la actividad que ocurra en su cuenta y debe mantener segura la contraseña de su cuenta. Debe notificar a Othar Trade & Logistics Spain de inmediato sobre cualquier violación de seguridad o uso no autorizado de su cuenta. Othar Trade & Logistics Spain no será responsable de las pérdidas causadas por el uso no autorizado de su cuenta.",
			"terms-conditions-subheader1-subtitle2-text2": "El Servicio está disponible a través del servicio \"Facebook Connect\" de Facebook. [Debe tener una cuenta de Facebook activa para acceder al Servicio a través de Facebook Connect], y por la presente declara y garantiza que ha leído y aceptado estar sujeto a todas las políticas de Facebook aplicables y actuará de acuerdo con esas políticas, además a sus obligaciones bajo este Acuerdo. Si accede al Servicio a través de Facebook Connect, Othar Trade & Logistics Spain puede requerir que su ID de usuario de Othar Trade & Logistics Spain sea el mismo que su nombre de usuario de Facebook. Si inicia sesión en Othar Trade & Logistics Spain a través de Facebook Connect, proporcionará las credenciales de su cuenta de Facebook a Othar Trade & Logistics Spain, y acepta que la información de esa cuenta se transmita a su cuenta de Othar Trade & Logistics Spain, y acepta que solo utilizará las cuentas de Facebook de su propiedad. por usted, y no por ninguna otra persona o entidad.",
			"terms-conditions-subheader1-subtitle2-text3": "Al proporcionar a Othar Trade & Logistics Spain su dirección de correo electrónico, usted acepta que usemos esa dirección de correo electrónico para enviarle avisos relacionados con el Servicio, incluidos los avisos requeridos por ley, en lugar de la comunicación por correo postal. También podemos utilizar su dirección de correo electrónico para enviarle otros mensajes, como cambios en las funciones del Servicio y ofertas especiales. Si no desea recibir dichos mensajes de correo electrónico, puede optar por no participar o cambiar sus preferencias en la configuración de su cuenta en",
			"terms-conditions-subheader1-subtitle2-text4": ". Darse de baja puede evitar que reciba mensajes de correo electrónico sobre actualizaciones, mejoras u ofertas. Tenga en cuenta que si no desea recibir avisos legales de nuestra parte, incluida, entre otros, una notificación de que este Acuerdo ha cambiado, esos avisos legales seguirán gobernando su uso del Servicio. Publicaremos avisos legales en el Servicio y usted es responsable de revisar dichos avisos legales en busca de cambios. Consulte nuestra",
			"terms-conditions-subheader1-subtitle2-text5": " para obtener más detalles.",
			"terms-conditions-subheader1-subtitle3": "REGLAS DE SERVICIO",
			"terms-conditions-subheader1-subtitle3-text1": "Usted acepta no participar en ninguna de las siguientes actividades prohibidas en relación con el Servicio: (i) copiar, distribuir o divulgar cualquier parte del Servicio en cualquier medio, incluido, entre otros, el \"scraping\" automatizado o no automatizado; (ii) usar cualquier sistema automatizado, incluidos, entre otros, \"robots\", \"spiders\", \"lectores fuera de línea\", etc., para acceder al Servicio de una manera que envíe más mensajes de solicitud a los servidores de Othar Trade & Logistics Spain de los que un humano puede producir razonablemente en el mismo período de tiempo utilizando un navegador web en línea convencional (excepto que, sujeto a la configuración de privacidad de nuestros Usuarios, Othar Trade & Logistics Spain otorga a los operadores de motores de búsqueda públicos permiso revocable para usar arañas para copiar materiales de Othar Trade & Logistics Spain para el único propósito y únicamente en la medida necesaria para crear índices de búsqueda disponibles públicamente de los materiales, pero no cachés o archivos de dichos materiales); (iii) transmitir spam, cartas en cadena u otro correo electrónico no solicitado; (iv) intentar interferir, comprometer la integridad o seguridad del sistema o descifrar cualquier transmisión hacia o desde los servidores que ejecutan el Servicio; (v) tomar cualquier acción que imponga, o pueda imponer a nuestro exclusivo criterio, una carga irrazonable o desproporcionadamente grande en nuestra infraestructura; (vi) cargar datos no válidos, virus, gusanos u otros agentes de software a través del Servicio; (vii) recopilar o recopilar cualquier información de identificación personal, incluidos los nombres de cuentas, del Servicio; (viii) utilizar el Servicio con fines comerciales; (ix) hacerse pasar por otra persona o tergiversar su afiliación con una persona o entidad, realizar fraude, ocultar o intentar ocultar su identidad; (x) interferir con el correcto funcionamiento del Servicio; (xi) acceder a cualquier contenido del Servicio a través de cualquier tecnología o medios distintos de los proporcionados o autorizados por el Servicio; (xii) eludir las medidas que podemos utilizar para prevenir o restringir el acceso al Servicio, incluidas, entre otras, las funciones que impiden o restringen el uso o la copia de cualquier contenido o imponen limitaciones en el uso del Servicio o el contenido del mismo, o (xiii) descompilar , ingeniería inversa, o intentar obtener el código fuente del Servicio.",
			"terms-conditions-subheader1-subtitle3-text2": "El acceso al contenido audiovisual disponible en el Servicio para cualquier propósito o de cualquier otra manera que no sea Streaming (como se define a continuación) está expresamente prohibido. \"Streaming\" significa una transmisión digital contemporánea de una obra audiovisual a través de Internet desde el Servicio de Othar Trade & Logistics Spain al dispositivo de un Usuario de tal manera que los datos están destinados a ser visualizados en tiempo real y no para ser copiados, almacenados, descargados permanentemente, o redistribuido por el Usuario.",
			"terms-conditions-subheader1-subtitle3-text3": "Podemos, sin previo aviso, cambiar el Servicio, dejar de proporcionar el Servicio o las funciones del Servicio (para usted o en general) o crear límites de uso para el Servicio. Podemos rescindir o suspender de forma permanente o temporal su acceso al Servicio sin previo aviso ni responsabilidad ante Othar Trade & Logistics Spain, por cualquier motivo o sin motivo alguno, incluso si, a nuestro exclusivo criterio, viola alguna disposición de este Acuerdo. Tras la terminación de este Acuerdo o su acceso al Servicio por cualquier motivo o sin motivo alguno, seguirá estando sujeto a los términos de este Acuerdo que, por su naturaleza, deben sobrevivir a la terminación, incluidas, entre otras, las disposiciones de propiedad, renuncias de garantía, indemnización. y limitaciones de responsabilidad.",
			"terms-conditions-subheader1-subtitle3-text4": "Usted es el único responsable de sus interacciones con otros usuarios de Othar Trade & Logistics Spain. Nos reservamos el derecho, pero no tenemos la obligación, de monitorear las disputas entre usted y otros Usuarios. Othar Trade & Logistics Spain no tendrá ninguna responsabilidad por sus interacciones con otros Usuarios, o por la acción o inacción de cualquier Usuario.",
			"terms-conditions-subheader1-subtitle4": "CONTENIDO DEL USUARIO",
			"terms-conditions-subheader1-subtitle4-text1": "Algunas áreas del Servicio permiten que los Usuarios publiquen contenido como fotos e información de perfil, comentarios, preguntas y otro contenido o información (cualquier material de este tipo que un Usuario envíe, publique, muestre o ponga a disposición en el Servicio se denomina \" Contenido del usuario \").",
			"terms-conditions-subheader1-subtitle4-text2": "Usted acepta no publicar Contenido de usuario que: (i) pueda crear un riesgo de daño, pérdida, lesión física o mental, angustia emocional, muerte, discapacidad, desfiguración o enfermedad física o mental para usted, para cualquier otra persona o para cualquier animal; (ii) puede crear un riesgo de cualquier otra pérdida o daño a cualquier persona o propiedad; (iii) busca dañar o explotar a los niños exponiéndolos a contenido inapropiado, solicitando datos de identificación personal o de otra manera; (iv) puede constituir o contribuir a un delito o agravio; (v) contiene cualquier información o contenido que consideremos ilegal, dañino, abusivo, racial o étnicamente ofensivo, difamatorio, que infrinja, invada la privacidad personal o los derechos de publicidad, que acose, humille a otras personas (públicamente o de otro modo), calumnie, amenazante, profano, obsceno, pornográfico o de otra manera objetable; (vi) contiene cualquier información o contenido que sea ilegal (incluyendo, sin limitación, la divulgación de información privilegiada bajo la ley de valores o de secretos comerciales de otra parte); (vii) contiene cualquier información o contenido que no tiene derecho a poner a disposición bajo ninguna ley o bajo relaciones contractuales o fiduciarias; o (viii) contiene cualquier información o contenido que usted sabe que no es correcto y actual. Usted acepta que cualquier Contenido de usuario que publique no viola ni violará los derechos de terceros de ningún tipo, incluidos, entre otros, los Derechos de propiedad intelectual (como se define a continuación) o los derechos de privacidad. En la medida en que su Contenido de usuario contenga música, por la presente declara que es propietario o posee todos los derechos de todos los derechos de autor, incluidos, entre otros, los derechos de interpretación, mecánicos y de grabación de sonido, con respecto a todas y cada una de las composiciones musicales. (incluidas las letras) y la grabación de sonido contenida en dicho Contenido de usuario y tienen el poder de otorgar la licencia otorgada a continuación. Othar Trade & Logistics Spain se reserva el derecho, pero no está obligado, a rechazar y / o eliminar cualquier Contenido de usuario que Othar Trade & Logistics Spain crea, a su sola discreción, viola estas disposiciones. Usted comprende que la publicación de su Contenido de usuario en el Servicio no sustituye su registro en la Oficina de derechos de autor de EE. UU., El Gremio de escritores de América o cualquier otra organización de derechos.",
			"terms-conditions-subheader1-subtitle4-text3": "A los efectos de este Acuerdo, \"Derechos de propiedad intelectual\" significa todos los derechos de patente, derechos de autor, derechos de trabajo enmascarados, derechos morales, derechos de publicidad, marca registrada, imagen comercial y derechos de marca de servicio, buena voluntad, derechos de secreto comercial y otros derechos de propiedad intelectual. tal y como pueda existir ahora o en el futuro, y todas las solicitudes y registros, renovaciones y extensiones de los mismos, bajo las leyes de cualquier estado, país, territorio u otra jurisdicción.",
			"terms-conditions-subheader1-subtitle4-text4": "En relación con su Contenido de usuario, usted afirma, declara y garantiza lo siguiente:",
			"terms-conditions-subheader1-subtitle4-text4-1": "Tiene el consentimiento por escrito de todas y cada una de las personas físicas identificables en el Contenido del usuario para usar el nombre o la imagen de dicha persona de la manera contemplada por el Servicio y este Acuerdo, y cada persona le ha liberado de cualquier responsabilidad que pueda surgir en relación con tal uso.",
			"terms-conditions-subheader1-subtitle4-text4-2": "Su Contenido de usuario y el uso de Othar Trade & Logistics Spain del mismo según lo contemplado por este Acuerdo y el Servicio no violarán ninguna ley ni infringirán ningún derecho de terceros, incluidos, entre otros, los Derechos de propiedad intelectual y los derechos de privacidad.",
			"terms-conditions-subheader1-subtitle4-text4-3": "Othar Trade & Logistics Spain puede ejercer los derechos sobre su Contenido de usuario que se otorgan a Othar Trade & Logistics Spain en virtud de este Acuerdo, sin el pago de tarifas de gremio, residuales, pagos, tarifas o regalías pagaderas en virtud de cualquier acuerdo de negociación colectiva o de otro modo.",
			"terms-conditions-subheader1-subtitle4-text4-4": "All your User Content and other information that you provide to us is truthful and accurate.",
			"terms-conditions-subheader1-subtitle4-text5": "Othar Trade & Logistics Spain no se responsabiliza ni asume ninguna responsabilidad por el Contenido de usuario que usted o cualquier otro Usuario o tercero publique o envíe a través del Servicio. Usted será el único responsable de su Contenido de usuario y las consecuencias de publicarlo, y acepta que solo actuamos como un conducto pasivo para su distribución y publicación en línea de su Contenido de usuario. Usted comprende y acepta que puede estar expuesto a Contenido de usuario que sea inexacto, objetable, inapropiado para los niños o inadecuado para su propósito, y acepta que Othar Trade & Logistics Spain no será responsable de ningún daño en el que incurra o alegue incurrir como un resultado del contenido del usuario.",
			"terms-conditions-subheader1-subtitle4-text6": "Al publicar cualquier Contenido de usuario en el Servicio, usted otorga expresamente, y declara y garantiza que tiene derecho a otorgar a Othar Trade & Logistics Spain una licencia mundial libre de regalías, sublicenciable, transferible, perpetua, irrevocable, no exclusiva. para usar, reproducir, modificar, publicar, enumerar información relacionada con, editar, traducir, distribuir, sindicar, realizar públicamente, mostrar públicamente y realizar trabajos derivados de todo dicho Contenido de usuario y su nombre, voz y / o semejanza tal como figura en su Contenido del usuario, en su totalidad o en parte, y en cualquier forma, medio o tecnología, ya sea conocida ahora o desarrollada en el futuro, para su uso en relación con el Servicio y el negocio de Othar Trade & Logistics Spain (y sus sucesores y afiliados), incluidos, entre otros, los promover y redistribuir parte o la totalidad del Servicio (y trabajos derivados del mismo) en cualquier formato de medios y a través de cualquier canal de medios; sin embargo, Othar Trade & Logistics Spain solo compartirá su información de identificación personal de acuerdo con nuestra",
			"terms-conditions-subheader1-subtitle4-text7": " vigente en ese momento. Por la presente, también otorga a cada Usuario del Servicio una licencia no exclusiva para acceder a su Contenido de usuario a través del Servicio y para usar, reproducir, distribuir, mostrar y ejecutar dicho Contenido de usuario según lo permitido a través de la funcionalidad del Servicio y en virtud de este Acuerdo.",
			"terms-conditions-subheader2": "CONCESIÓN DE LICENCIA DE USUARIO FINAL",
			"terms-conditions-subheader2-subtitle1": "SERVICIO Othar Trade & Logistics Spain",
			"terms-conditions-subheader2-subtitle1-text1": "Sujeto a los términos y condiciones de este Acuerdo, por el presente se le otorga una licencia no exclusiva, limitada, intransferible y libremente revocable para utilizar el Servicio para su uso personal y no comercial, según lo permitan las características del Servicio. Othar Trade & Logistics Spain se reserva todos los derechos no otorgados expresamente en el presente en el Servicio y el Contenido de Othar Trade & Logistics Spain (como se define a continuación). Othar Trade & Logistics Spain puede rescindir esta licencia en cualquier momento por cualquier motivo o sin motivo.",
			"terms-conditions-subheader2-subtitle2": "SOFTWARE MÓVIL",
			"terms-conditions-subheader2-subtitle2-text1": "Podemos poner a disposición software para acceder al Servicio a través de un dispositivo móvil (\"Software móvil\"). Para utilizar el software móvil, debe tener un dispositivo móvil que sea compatible con el servicio móvil. Othar Trade & Logistics Spain no garantiza que el software móvil sea compatible con su dispositivo móvil. Por la presente, Othar Trade & Logistics Spain le otorga una licencia no exclusiva, intransferible y revocable para usar una copia del código compilado del Software móvil para una cuenta de Othar Trade & Logistics Spain en un dispositivo móvil de su propiedad o arrendado únicamente por usted, para su uso personal y no comercial. . No puede: (i) modificar, desensamblar, descompilar o aplicar ingeniería inversa al Software móvil, excepto en la medida en que dicha restricción esté expresamente prohibida por la ley; (ii) alquilar, arrendar, prestar, revender, sublicenciar, distribuir o transferir el Software móvil a cualquier tercero o utilizar el Software móvil para proporcionar tiempo compartido o servicios similares para cualquier tercero; (iii) hacer copias del Software móvil; (iv) eliminar, eludir, deshabilitar, dañar o interferir de otro modo con las funciones relacionadas con la seguridad del Software móvil, las funciones que impiden o restringen el uso o la copia de cualquier contenido accesible a través del Software móvil, o las funciones que imponen limitaciones en el uso del Móvil Software; o (v) eliminar los derechos de autor y / u otros avisos de derechos de propiedad en el Software móvil. Usted reconoce que Othar Trade & Logistics Spain puede, de vez en cuando, emitir versiones actualizadas del Software móvil, y puede actualizar automáticamente de forma electrónica la versión del Software móvil que está utilizando en su dispositivo móvil. Usted acepta dicha actualización automática en su dispositivo móvil y acepta que los términos y condiciones de este Acuerdo se aplicarán a todas esas actualizaciones. Cualquier código de terceros que pueda incorporarse en el Software móvil está cubierto por el CLUF de código abierto o licencia de terceros, si corresponde, que autoriza el uso de dicho código. La concesión de licencia anterior no es una venta del Software móvil o cualquier copia del mismo, y Othar Trade & Logistics Spain o sus socios o proveedores terceros conservan todos los derechos, títulos e intereses en el Software móvil (y cualquier copia del mismo). Si el software móvil se adquiere en nombre del gobierno de los Estados Unidos, se aplica la siguiente disposición. El uso, la duplicación o la divulgación del software móvil por parte del gobierno de los EE. UU. Está sujeto a las restricciones establecidas en este Acuerdo y según lo dispuesto en DFARS 227.7202-1 (a) y 227.7202-3 (a) (1995), DFARS 252.227-7013 ( c) (1) (ii) (OCT 1988), FAR 12.212 (a) (1995), FAR 52.227-19 o FAR 52.227-14 (ALT III), según corresponda. El software móvil se origina en los Estados Unidos y está sujeto a las leyes y regulaciones de exportación de los Estados Unidos. El Software móvil no se puede exportar ni reexportar a ciertos países o aquellas personas o entidades a las que se les prohíba recibir exportaciones de los Estados Unidos. Además, el software móvil puede estar sujeto a las leyes de importación y exportación de otros países. Usted acepta cumplir con todas las leyes de los Estados Unidos y del extranjero relacionadas con el uso del Software móvil y el Servicio de  CubaLicores.",
			"terms-conditions-subheader2-subtitle3": "SOFTWARE MÓVIL DE ITUNES",
			"terms-conditions-subheader2-subtitle3-text1": "Lo siguiente se aplica a cualquier Software móvil que adquiera en la App Store de Apple, Inc. (\"Apple\") (\"Software de origen Apple\"): Usted reconoce y acepta que este Acuerdo es únicamente entre usted y Othar Trade & Logistics Spain, no Apple, y que Apple no tiene ninguna responsabilidad por el Software de origen Apple o su contenido. Su uso del Software de Apple debe cumplir con los Términos de servicio de la App Store. Usted reconoce que Apple no tiene obligación alguna de proporcionar ningún servicio de mantenimiento y soporte con respecto al Software de Apple. En el caso de que el Software de Apple no cumpla con cualquier garantía aplicable, puede notificar a Apple acerca de dicha falla; Tras dicha notificación, la única garantía de Apple para usted será reembolsar el precio de compra del Software de Apple, si lo hubiera. En la medida máxima permitida por la ley aplicable, Apple no tendrá ninguna otra obligación de garantía con respecto al Software de Apple, y cualquier otra reclamación, pérdida, responsabilidad, daño, costo o gasto atribuible a cualquier incumplimiento de cualquier garantía será se regirá únicamente por este Acuerdo y cualquier ley aplicable a Othar Trade & Logistics Spain como proveedor del Software de Apple. Usted reconoce que Othar Trade & Logistics Spain, y no Apple, es responsable de abordar cualquier reclamo de usted o de cualquier tercero relacionado con el Software de Apple o su posesión y / o uso del Software de Apple, incluyendo, pero no limitado a: (i) reclamaciones de responsabilidad por productos; (ii) cualquier reclamo de que el Software de Apple no cumple con los requisitos legales o reglamentarios aplicables; y (iii) reclamaciones derivadas de la protección del consumidor o legislación similar; y todas esas reclamaciones se rigen únicamente por este Acuerdo y cualquier ley aplicable a Othar Trade & Logistics Spain como proveedor del software. Usted reconoce que, en caso de que un tercero reclame que el Software de Apple o su posesión y uso de ese Software de Apple infringe los derechos de propiedad intelectual de ese tercero, Othar Trade & Logistics Spain, no Apple, será el único responsable de la investigación. , defensa, arreglo y descargo de cualquier reclamo por infracción de propiedad intelectual en la medida requerida por este Acuerdo. Usted y Othar Trade & Logistics Spain reconocen y aceptan que Apple, y las subsidiarias de Apple, son terceros beneficiarios de este Acuerdo en lo que respecta a su licencia del Software de origen de Apple, y que, una vez que usted acepta los términos y condiciones de este Acuerdo, Apple tiene el derecho (y se considerará que ha aceptado el derecho) de hacer cumplir este Acuerdo en lo que respecta a su licencia del Software de Apple en su contra como un tercero beneficiario del mismo. Solo utilizará el Software de Apple en relación con un dispositivo Apple que sea de su propiedad o que controle. Cumplirá con los términos del contrato de terceros aplicables que puedan afectar o verse afectados por su uso del Software de Apple.",
			"terms-conditions-subheader2-subtitle4": "NUESTROS DERECHOS DE PROPIEDAD",
			"terms-conditions-subheader2-subtitle4-text1": "Excepto por su Contenido de usuario, el Servicio y todos los materiales en él o transferidos por el mismo, incluidos, entre otros, software, imágenes, texto, gráficos, ilustraciones, logotipos, patentes, marcas comerciales, marcas de servicio, derechos de autor, fotografías, audio, videos, música, y el Contenido del usuario (el \"Contenido de Othar Trade & Logistics Spain\"), y todos los Derechos de propiedad intelectual relacionados con el mismo, son propiedad exclusiva de Othar Trade & Logistics Spain y sus licenciantes. Salvo que se disponga explícitamente en este documento, nada en este Acuerdo se considerará que crea una licencia en o bajo dichos Derechos de propiedad intelectual, y usted acepta no vender, licenciar, alquilar, modificar, distribuir, copiar, reproducir, transmitir, exhibir públicamente, realizar, publicar, adaptar, editar o crear públicamente trabajos derivados de cualquier material o contenido accesible en el Servicio. El uso del Contenido de Othar Trade & Logistics Spain o de los materiales del Servicio para cualquier propósito que no esté expresamente permitido por este Acuerdo está estrictamente prohibido.",
			"terms-conditions-subheader2-subtitle4-text2": "Puede elegir o podemos invitarlo a enviar comentarios o ideas sobre el Servicio, incluido, entre otros, cómo mejorar el Servicio o nuestros productos (\"Ideas\"). Al enviar cualquier Idea, usted acepta que su divulgación es gratuita, no solicitada y sin restricciones y que no colocará a Othar Trade & Logistics Spain bajo ninguna obligación fiduciaria u otra obligación, y que somos libres de usar la Idea sin ninguna compensación adicional para usted y / o para divulgar la Idea de forma no confidencial o de otro modo a cualquier persona. Además, reconoce que, al aceptar su envío, Othar Trade & Logistics Spain no renuncia a ningún derecho de usar ideas similares o relacionadas previamente conocidas por Othar Trade & Logistics Spain, o desarrolladas por sus empleados, u obtenidas de fuentes distintas a usted.",
			"terms-conditions-subheader2-subtitle5": "CRÉDITOS DE REFERENCIA DE CUBALICORES",
			"terms-conditions-subheader2-subtitle5-text1": "Othar Trade & Logistics Spain puede proporcionar créditos de referencia a los miembros de Othar Trade & Logistics Spain cuando los miembros invitan a sus amigos a unirse a Othar Trade & Logistics Spain (\"Créditos de referencia\"). Se pueden otorgar créditos de recomendación a la persona que recomienda cuando se unen sus amigos, así como cuando sus amigos hacen sus primeras compras.",
			"terms-conditions-subheader2-subtitle5-text2": "Los Créditos por recomendación se otorgan a discreción exclusiva de Othar Trade & Logistics Spain. Para que un miembro sea elegible para recibir Créditos de recomendación para los amigos que se unen a Othar Trade & Logistics Spain, el nuevo amigo debe unirse a Othar Trade & Logistics Spain a través del enlace de recomendación único del miembro que refiere. Los Créditos por recomendación son descuentos o créditos promocionales o de lealtad ofrecidos por Othar Trade & Logistics Spain, y no constituyen una cuenta, un instrumento de pago u otra propiedad propiedad de ningún miembro de Othar Trade & Logistics Spain. Los Créditos de referencia no tienen valor en efectivo y solo puede usar Créditos de referencia en relación con una compra que califique en el sitio web de Othar Trade & Logistics Spain. Othar Trade & Logistics Spain se reserva el derecho de revocar sus Créditos de referencia si Othar Trade & Logistics Spain determina que ha participado en una actividad de referencia fraudulenta (por ejemplo, invitar a personas falsas a unirse a Othar Trade & Logistics Spain) o violar nuestros Términos de uso, o si cancelamos su membresía. Los créditos por recomendación vencen 6 meses después de su concesión. Los créditos de referencia no son transferibles ni se pueden vender, no son tarjetas de regalo y no se pueden usar para comprar tarjetas de regalo de Othar Trade & Logistics Spain. Othar Trade & Logistics Spain se reserva el derecho en cualquier momento y sin previo aviso de cambiar los términos aplicables a los Créditos de referencia, incluido el período de vencimiento y / o su capacidad para canjear Créditos de referencia existentes, Othar Trade & Logistics Spain no impone ningún cargo por su uso de Créditos de referencia. Para ver sus Créditos de referencia,",
			"terms-conditions-subheader2-subtitle5-text3": "haga click aquí",
			"terms-conditions-subheader2-subtitle6": "TARJETAS DE REGALO ELECTRÓNICAS DE CUBALICORES",
			"terms-conditions-subheader2-subtitle6-text1": "Othar Trade & Logistics Spain. Para comprar o canjear una tarjeta electrónica, debe tener una cuenta de Othar Trade & Logistics Spain. El destinatario de una tarjeta electrónica será notificado por correo electrónico; Si el destinatario no tiene una cuenta de Othar Trade & Logistics Spain en el momento en que recibe dicho correo electrónico, se le pedirá que cree una cuenta de Othar Trade & Logistics Spain para activar la E-Card.",
			"terms-conditions-subheader2-subtitle6-text2": "Puede comprar tarjetas electrónicas en denominaciones de dólares estadounidenses de $ 25, $ 50, $ 75 y $ 100. El monto de la tarjeta electrónica que compre se cargará a su tarjeta de crédito cuando confirme la compra de dicha tarjeta electrónica. La compra de tarjetas electrónicas se rige por los términos establecidos en \"Pedidos\" en las 10 preguntas principales sobre",
			"terms-conditions-subheader2-subtitle6-text3": ", excepto que se indique lo contrario en esta sección.",
			"terms-conditions-subheader2-subtitle6-text4": "Una vez que el destinatario de la E-Card activa la E-Card, el valor de la E-Card aparecerá en la cuenta de Othar Trade & Logistics Spain del destinatario como crédito para compras en Othar Trade & Logistics Spain Si una compra excede el monto de la E-Card, el saldo debe pagarse con tarjeta de crédito u otro método de pago disponible, de acuerdo con las",
			"terms-conditions-subheader2-subtitle6-text5": "payment policies",
			"terms-conditions-subheader2-subtitle6-text6": "estándar de Othar Trade & Logistics Spain. Las tarjetas electrónicas no se pueden utilizar para comprar otras tarjetas electrónicas. Las compras realizadas con tarjetas electrónicas no son elegibles para ganar créditos por recomendación. Las tarjetas electrónicas no caducan.",
			"terms-conditions-subheader2-subtitle6-text7": "Excepto donde lo prohíba la ley aplicable, los destinatarios de tarjetas electrónicas no pueden (a) recibir reembolsos por tarjetas electrónicas, (b) revender o transferir tarjetas electrónicas a otros (incluida, entre otras, la transferencia de tarjetas electrónicas a otras cuentas de usuarios de Othar Trade & Logistics Spain ), (c) recargar tarjetas electrónicas, o (d) canjear los saldos de tarjetas electrónicas no utilizadas si cancelan su cuenta de Othar Trade & Logistics Spain. Las tarjetas electrónicas no son moneda y no tienen valor en efectivo fuera de Othar Trade & Logistics Spain. Othar Trade & Logistics Spain no se hace responsable del uso no autorizado de una tarjeta electrónica.",
			"terms-conditions-subheader2-subtitle7": "OFERTAS DE ENVÍO GRATIS CUBALICORES",
			"terms-conditions-subheader2-subtitle7-text1": "De vez en cuando, Othar Trade & Logistics Spain puede ofrecer promociones de envío gratuito a sus miembros. Las ofertas de envío gratuito de Othar Trade & Logistics Spain son válidas solo en envío estándar. Las ofertas de envío gratuito de Othar Trade & Logistics Spain no se pueden utilizar para envíos internacionales ni para envíos de artículos \"no estándar\". Es posible que se apliquen términos y limitaciones adicionales al momento de la oferta.",
			"terms-conditions-subheader3": "SERVICIOS PAGADOS",
			"terms-conditions-subheader3-subtitle1": "POLITICAS DE FACTURACION",
			"terms-conditions-subheader3-subtitle1-text1": "Es posible que se proporcionen determinadas funciones del Servicio mediante una tarifa u otro cargo. Si opta por utilizar las funciones de pago del Servicio, acepta los precios y las condiciones de pago de dichas funciones de pago que le proporcionaremos y que podemos actualizar de vez en cuando. Othar Trade & Logistics Spain puede agregar nuevos servicios por tarifas y cargos adicionales, o modificar tarifas y cargos por servicios existentes, en cualquier momento a su entera discreción. Cualquier cambio en nuestros precios o condiciones de pago entrará en vigencia en el ciclo de facturación después de que se le notifique dicho cambio. Si no desea pagar las tarifas o cargos nuevos o modificados, su único recurso será cancelar su acceso a los servicios aplicables.",
			"terms-conditions-subheader3-subtitle1-text2": "Si compra un artículo a través del Servicio, su compra se procesará de acuerdo con la sección \"Pedidos\" de nuestras ",
			"terms-conditions-subheader3-subtitle1-text3": "10 Preguntas principales",
			"terms-conditions-subheader3-subtitle1-text4": ", se le entregará de acuerdo con nuestras ",
			"terms-conditions-subheader3-subtitle1-text5": "Políticas de envío",
			"terms-conditions-subheader3-subtitle1-text6": "y, si corresponde, las devoluciones se manejarán de acuerdo con nuestra ",
			"terms-conditions-subheader3-subtitle1-text7": ", todas las cuales se incorporan aquí mediante esta referencia.",
			"terms-conditions-subheader3-subtitle2": "REEMBOLSOS",
			"terms-conditions-subheader3-subtitle2-text1": "Puede cancelar su cuenta de Othar Trade & Logistics Spain en cualquier momento; sin embargo, no hay reembolsos por la cancelación del Servicio, si ha elegido utilizar las funciones pagas del Servicio. En el caso de que Othar Trade & Logistics Spain suspenda o cancele su cuenta o este Acuerdo por su incumplimiento de este Acuerdo, usted comprende y acepta que no recibirá ningún reembolso o cambio por ninguna Propiedad de Othar Trade & Logistics Spain, cualquier tiempo no utilizado en una suscripción, cualquier licencia o suscripción. tarifas por cualquier parte del Servicio, cualquier contenido o datos asociados con su cuenta, o por cualquier otra cosa.",
			"terms-conditions-subheader3-subtitle2-text2": "Los reembolsos por compras devueltas se manejarán de acuerdo con nuestra",
			"terms-conditions-subheader3-subtitle3": "INFORMACIÓN DE PAGO: IMPUESTOS",
			"terms-conditions-subheader3-subtitle3-text1": " Toda la información que proporcione en relación con una compra o transacción u otra interacción de transacción monetaria con el Servicio debe ser precisa, completa y actualizada. Usted acepta pagar todos los cargos incurridos por los usuarios de su tarjeta de crédito, tarjeta de débito u otro método de pago utilizado en relación con una compra o transacción u otra interacción de transacción monetaria con el Servicio a los precios vigentes cuando se incurra en dichos cargos. Usted pagará los impuestos aplicables, si los hubiera, relacionados con dichas compras, transacciones u otras interacciones de transacciones monetarias. Para obtener más detalles sobre los pedidos, consulte nuestras",
			"terms-conditions-subheader3-subtitle4": "PRIVACIDAD",
			"terms-conditions-subheader3-subtitle4-text1": "Nos preocupamos por la privacidad de nuestros usuarios. ",
			"terms-conditions-subheader3-subtitle4-text2": " para ver nuestra Política de privacidad, que se incorpora aquí como referencia. Al utilizar el Servicio, usted acepta que sus datos personales se recopilen, utilicen, transfieran y procesen en los Estados Unidos de acuerdo con nuestra Política de privacidad vigente en ese momento.",
			"terms-conditions-subheader3-subtitle5": "SECURIDAD",
			"terms-conditions-subheader3-subtitle5-text1": "Othar Trade & Logistics Spain se preocupa por la integridad y seguridad de su información personal. Sin embargo, no podemos garantizar que terceros no autorizados nunca podrán anular nuestras medidas de seguridad o utilizar su información personal para fines indebidos. Usted reconoce que proporciona su información personal bajo su propio riesgo.",
			"terms-conditions-subheader3-subtitle6": "AVISO DMCA",
			"terms-conditions-subheader3-subtitle6-text1": "Dado que respetamos los derechos de los artistas y propietarios de contenido, la política de Othar Trade & Logistics Spain es responder a las notificaciones de presuntas infracciones que cumplan con la Ley de derechos de autor del milenio digital de 1998 (\"DMCA\").",
			"terms-conditions-subheader3-subtitle6-text2": "Si cree que su trabajo protegido por derechos de autor se ha copiado de una manera que constituye una infracción de derechos de autor y es accesible a través del Servicio, notifique a Othar Trade & Logistics Spain como se establece en la DMCA. Para que su queja sea válida bajo la DMCA, debe proporcionar la siguiente información por escrito:",
			"terms-conditions-subheader3-subtitle6-text2-1": "Una firma electrónica o física de una persona autorizada para actuar en nombre del propietario de los derechos de autor;",
			"terms-conditions-subheader3-subtitle6-text2-2": "Identificación de la obra protegida por derechos de autor que afirma que se ha infringido;",
			"terms-conditions-subheader3-subtitle6-text2-3": "Identificación del material que se alega que infringe y dónde se encuentra en el Servicio;",
			"terms-conditions-subheader3-subtitle6-text2-4": "Información razonablemente suficiente para permitir que Othar Trade & Logistics Spain se comunique con usted, como su dirección, número de teléfono y dirección de correo electrónico;",
			"terms-conditions-subheader3-subtitle6-text2-5": "Una declaración de que usted cree de buena fe que el uso del material de la manera denunciada no está autorizado por el propietario de los derechos de autor, su agente o la ley; y",
			"terms-conditions-subheader3-subtitle6-text2-6": "Una declaración, hecha bajo pena de perjurio, de que la información anterior es precisa y que usted es el propietario de los derechos de autor o está autorizado para actuar en nombre del propietario.",
			"terms-conditions-subheader3-subtitle6-text3": "Una vez que se recibe una notificación de infracción adecuada y de buena fe, nuestra política es:",
			"terms-conditions-subheader3-subtitle6-text3-1": "Para eliminar o deshabilitar el acceso al material infractor;",
			"terms-conditions-subheader3-subtitle6-text3-2": "Para notificar al proveedor de contenido, miembro o usuario que hemos eliminado o deshabilitado el acceso al material;",
			"terms-conditions-subheader3-subtitle6-text3-3": "Que a los infractores reincidentes se les eliminará del sistema el material infractor y que cancelaremos el acceso al Servicio de dicho proveedor, miembro o usuario de contenido.",
			"terms-conditions-subheader3-subtitle6-text4": "Si el proveedor de contenido, miembro o usuario cree que el material que se eliminó (o al que se deshabilitó el acceso) no está infringiendo, o el proveedor de contenido, miembro o usuario cree que tiene derecho a publicar y usar dicho material de la propietario de los derechos de autor, el agente del propietario de los derechos de autor o, de conformidad con la ley, el proveedor de contenido, el miembro o el usuario deben enviar una contranotificación que contenga la siguiente información:",
			"terms-conditions-subheader3-subtitle6-text4-1": "Una firma física o electrónica del proveedor de contenido, miembro o usuario;",
			"terms-conditions-subheader3-subtitle6-text4-2": "Identificación del material que se ha eliminado o cuyo acceso se ha desactivado y la ubicación en la que el material apareció en el Servicio antes de dicha eliminación o desactivación;",
			"terms-conditions-subheader3-subtitle6-text4-3": "Una declaración de que el proveedor de contenido, miembro o usuario cree de buena fe que el material fue eliminado o desactivado como resultado de un error o identificación errónea del material;",
			"terms-conditions-subheader3-subtitle6-text4-4": "Nombre, dirección, número de teléfono del proveedor de contenido, miembro o usuario, y, si está disponible, y, si está disponible, dirección de correo electrónico, y una declaración de que dicha persona o entidad da su consentimiento a la jurisdicción del Tribunal Federal para el distrito judicial en el que la dirección del proveedor, miembro o usuario del contenido se encuentra o, si la dirección del proveedor, miembro o usuario del contenido se encuentra fuera de los Estados Unidos, para cualquier distrito judicial en el que se encuentre la Compañía, y que dicha persona o entidad aceptará el servicio del proceso de la persona que notificó la presunta infracción.",
			"terms-conditions-subheader3-subtitle6-text5": "La información anterior debe enviarse a:",
			"terms-conditions-subheader3-subtitle6-text6": "A la atención de: Othar Trade & Logistics Spain.",
			"terms-conditions-subheader3-subtitle6-text9": "Correo electrónico: copyright@cubalicores.com",
			"terms-conditions-subheader3-subtitle6-text10": "SEGÚN LA LEY FEDERAL, SI CONOCIENDO FALSAMENTE QUE EL MATERIAL EN LÍNEA ESTÁ INFRINGIENDO, PUEDE ESTAR SUJETO A ENJUICIAMIENTO PENAL POR PERJURIO Y SANCIONES CIVILES, INCLUYENDO DAÑOS MONETARIOS, COSTOS DE LA CORTE Y HONORARIOS DE ABOGADOS.",
			"terms-conditions-subheader3-subtitle6-text11": "Tenga en cuenta que este procedimiento es exclusivamente para notificar a Othar Trade & Logistics Spain y sus afiliados que su material protegido por derechos de autor ha sido infringido. Los requisitos anteriores están destinados a cumplir con los derechos y obligaciones de Othar Trade & Logistics Spain según la DMCA, incluido el 17 U.S.C. §512 (c), pero no constituyen asesoramiento legal. Puede ser aconsejable ponerse en contacto con un abogado con respecto a sus derechos y obligaciones según la DMCA y otras leyes aplicables.",
			"terms-conditions-subheader3-subtitle7": "ENLACES DE TERCEROS",
			"terms-conditions-subheader3-subtitle7-text1": "El Servicio puede contener enlaces a sitios web de terceros, anunciantes, servicios, ofertas especiales u otros eventos o actividades que no son propiedad ni están controlados por Othar Trade & Logistics Spain. Othar Trade & Logistics Spain no respalda ni asume ninguna responsabilidad por dichos sitios, información, materiales, productos o servicios de terceros. Si accede a un sitio web de terceros desde el Servicio, como a través de Facebook Connect, lo hace bajo su propio riesgo y comprende que este Acuerdo y la Política de privacidad de Othar Trade & Logistics Spain no se aplican a su uso de dichos sitios. Usted libera expresamente a Othar Trade & Logistics Spain de cualquier responsabilidad que surja de su uso de cualquier sitio web, servicio o contenido de terceros. Además, su trato o participación en promociones de anunciantes que se encuentran en el Servicio, incluido el pago y la entrega de bienes, y cualquier otro término (como garantías) son únicamente entre usted y dichos anunciantes. Usted acepta que Othar Trade & Logistics Spain no será responsable de ninguna pérdida o daño de ningún tipo relacionado con sus relaciones con dichos anunciantes.",
			"terms-conditions-subheader3-subtitle8": "INDEMNIDAD",
			"terms-conditions-subheader3-subtitle8-text1": "Usted acepta defender, indemnizar y eximir de responsabilidad a Othar Trade & Logistics Spain y sus subsidiarias, agentes, otorgantes de licencias, gerentes y otras compañías afiliadas, y sus empleados, contratistas, agentes, funcionarios y directores, de y contra todas y cada una de las reclamaciones, daños, obligaciones, pérdidas, responsabilidades, costos o deudas y gastos (incluidos, entre otros, los honorarios de abogados) que surjan de: (i) su uso y acceso al Servicio, incluidos los datos o contenidos transmitidos o recibidos por usted; (ii) su violación de cualquier término de este Acuerdo, incluido, entre otros, su incumplimiento de cualquiera de las representaciones y garantías que realiza en este Acuerdo; (iii) su violación de cualquier derecho de terceros, incluido, entre otros, cualquier derecho de privacidad o Derechos de propiedad intelectual; (iv) su violación de cualquier ley, norma o reglamento aplicable; (v) cualquier reclamo o daño que surja como resultado de su Contenido de usuario o cualquiera que se envíe a través de su cuenta; o (vi) el acceso y uso del Servicio por parte de cualquier otra parte con su nombre de usuario, contraseña u otro código de seguridad apropiado.",
			"terms-conditions-subheader3-subtitle9": "SIN GARANTÍA",
			"terms-conditions-subheader3-subtitle9-text1": "EL SERVICIO Y CUALQUIER PRODUCTO O SERVICIO QUE ADQUIERA A TRAVÉS DEL SERVICIO (\"PRODUCTO\") SE PROPORCIONAN \"TAL CUAL\" Y \"SEGÚN DISPONIBILIDAD\". EL USO DEL SERVICIO ES BAJO SU PROPIO RIESGO. HASTA EL MÁXIMO PERMITIDO POR LA LEY APLICABLE, EL SERVICIO Y LOS PRODUCTOS SE PROPORCIONAN SIN GARANTÍAS DE NINGÚN TIPO, YA SEAN EXPRESAS O IMPLÍCITAS, INCLUYENDO, PERO NO LIMITADO A, GARANTÍAS IMPLÍCITAS DE COMERCIABILIDAD, ADECUACIÓN O NEGACIÓN PARA UN PROPÓSITO DETERMINADO. SIN LIMITAR LO ANTERIOR, CUBALICORES, SUS SUBSIDIARIAS Y SUS LICENCIANTES NO GARANTIZAN QUE EL CONTENIDO ES EXACTO, CONFIABLE O CORRECTO; QUE EL SERVICIO O LOS PRODUCTOS CUMPLIRÁN CON SUS REQUISITOS; QUE EL SERVICIO ESTARÁ DISPONIBLE EN CUALQUIER MOMENTO O LUGAR EN PARTICULAR, ININTERRUMPIDO O SEGURO; QUE CUALQUIER DEFECTO O ERROR SERÁ CORREGIDO; O QUE EL SERVICIO ESTÉ LIBRE DE VIRUS U OTROS COMPONENTES DAÑINOS. CUALQUIER CONTENIDO DESCARGADO U OBTENIDO DE OTRA MANERA MEDIANTE EL USO DEL SERVICIO SE DESCARGA BAJO SU PROPIO RIESGO Y USTED SERÁ EL ÚNICO RESPONSABLE DE CUALQUIER DAÑO A SU SISTEMA DE COMPUTADORA O PÉRDIDA DE DATOS QUE RESULTEN DE DICHA DESCARGA O SU USO DEL SERVICIO.",
			"terms-conditions-subheader3-subtitle9-text2": "CUBALICORES NO GARANTIZA, APRUEBA, GARANTIZA O ASUME RESPONSABILIDAD POR CUALQUIER PRODUCTO O SERVICIO PUBLICITADO U OFRECIDO POR UN TERCERO A TRAVÉS DEL SERVICIO DE CUBALICORES O CUALQUIER SITIO WEB O SERVICIO HIPERVINCULADO O NO SERÁ UN TOCADOR DE WATAPAY MONITOREAR CUALQUIER TRANSACCIÓN ENTRE USTED Y TERCEROS PROVEEDORES DE PRODUCTOS O SERVICIOS.",
			"terms-conditions-subheader3-subtitle10": "LIMITACIÓN DE RESPONSABILIDAD",
			"terms-conditions-subheader3-subtitle10-text1": "EN LA MEDIDA MÁXIMA PERMITIDA POR LA LEY APLICABLE, EN NINGÚN CASO CUBALICORES, SUS AFILIADOS, AGENTES, DIRECTORES, EMPLEADOS, PROVEEDORES O LICENCIADORES SERÁN RESPONSABLES DE NINGÚN CASO DIRECTO, INDIRECTO, PUNITIVO, INCIDENTAL, CONDICIONAL, ESPECIAL, DAÑOS POR PÉRDIDA DE BENEFICIOS, BUENA VOLUNTAD, USO, DATOS U OTRAS PÉRDIDAS INTANGIBLES, QUE RESULTEN DEL USO O LA INCAPACIDAD DE USAR ESTE SERVICIO O CUALQUIER PRODUCTO. BAJO NINGUNA CIRCUNSTANCIA, CUBALICORES SERÁ RESPONSABLE DE CUALQUIER DAÑO, PÉRDIDA O LESIÓN QUE RESULTEN DE HACKING, MANIPULACIÓN U OTRO ACCESO O USO NO AUTORIZADO DEL SERVICIO O SU CUENTA O LA INFORMACIÓN CONTENIDA EN EL MISMO.",
			"terms-conditions-subheader3-subtitle10-text2": "EN LA MEDIDA MÁXIMA PERMITIDA POR LA LEY APLICABLE, CUBALICORES NO ASUME NINGUNA RESPONSABILIDAD POR CUALQUIER (I) ERROR, ERROR O INEXACTITUD DEL CONTENIDO DISPONIBLE EN O A TRAVÉS DEL SERVICIO; (II) LESIONES PERSONALES O DAÑOS A LA PROPIEDAD, DE CUALQUIER NATURALEZA, QUE RESULTEN DE SU ACCESO O USO DE NUESTRO SERVICIO O CUALQUIER PRODUCTO; (III) CUALQUIER ACCESO NO AUTORIZADO O USO DE NUESTROS SERVIDORES SEGUROS Y / O CUALQUIER INFORMACIÓN PERSONAL ALMACENADA EN ELLOS; (IV) CUALQUIER INTERRUPCIÓN O CESE DE TRANSMISIÓN HACIA O DESDE EL SERVICIO; (V) CUALQUIER ERROR, VIRUS, CABALLO TROYANO O SIMILAR QUE PUEDA SER TRANSMITIDO A O A TRAVÉS DE NUESTRO SERVICIO POR CUALQUIER TERCERO; (VI) CUALQUIER ERROR U OMISIÓN EN CUALQUIER CONTENIDO O POR CUALQUIER PÉRDIDA O DAÑO INCURRIDO COMO RESULTADO DEL USO DE CUALQUIER CONTENIDO PUBLICADO, ENVIADO POR CORREO ELECTRÓNICO, TRANSMITIDO O DE OTRA FORMA DISPONIBLE A TRAVÉS DEL SERVICIO; Y / O (VII) EL CONTENIDO DEL USUARIO O LA CONDUCTA DIFAMATORIA, OFENSIVA O ILEGAL DE CUALQUIER TERCERO.",
			"terms-conditions-subheader3-subtitle10-text3": "ESTA SECCIÓN DE LIMITACIÓN DE RESPONSABILIDAD SE APLICA SI LA SUPUESTA RESPONSABILIDAD SE BASA EN CONTRATO, AGRAVIO, NEGLIGENCIA, RESPONSABILIDAD ESTRICTA O CUALQUIER OTRA BASE, INCLUSO SI CUBALICORES HA SIDO ADVERTIDO DE LA POSIBILIDAD DE DICHO DAÑO. LA LIMITACIÓN DE RESPONSABILIDAD ANTERIOR SE APLICARÁ EN LA MÁXIMA MEDIDA PERMITIDA POR LA LEY EN LA JURISDICCIÓN APLICABLE.",
			"terms-conditions-subheader3-subtitle10-text4": "El Servicio se controla y opera desde sus instalaciones en los Estados Unidos. Othar Trade & Logistics Spain no garantiza que el Servicio sea apropiado o esté disponible para su uso en otros lugares. Aquellos que acceden o usan el Servicio desde otras jurisdicciones lo hacen por su propia voluntad y son totalmente responsables del cumplimiento de todas las leyes y regulaciones locales y de los Estados Unidos, incluidas, entre otras, las regulaciones de exportación e importación. Usted declara y garantiza que no se encuentra en un país embargado por los Estados Unidos o que ha sido designado por el gobierno de los Estados Unidos como un país \"que apoya al terrorismo\", y que no es una persona o entidad extranjera bloqueada o negada por el Gobierno de los Estados Unidos o que figure en cualquier lista del gobierno de los Estados Unidos de partes prohibidas o restringidas. A menos que se indique explícitamente lo contrario, todos los materiales que se encuentran en el Servicio están dirigidos únicamente a personas, empresas u otras entidades ubicadas en los Estados Unidos.",
			"terms-conditions-subheader3-subtitle11": "ASIGNACIÓN",
			"terms-conditions-subheader3-subtitle11-text1": "Este Acuerdo, y los derechos y licencias otorgados en virtud del mismo, no pueden ser transferidos ni asignados por usted, pero pueden ser asignados por Othar Trade & Logistics Spain sin restricciones.",
			"terms-conditions-subheader3-subtitle12": "GENERAL",
			"terms-conditions-subheader3-subtitle13": "LEY QUE RIGE",
			"terms-conditions-subheader3-subtitle12-text1": "Usted acepta que el Servicio se considerará basado únicamente en el estado de Florida. Este Acuerdo se regirá por las leyes sustantivas internas del Estado de Florida, sin respetar los principios de conflicto de leyes. Se excluye expresamente la aplicación de la Convención de las Naciones Unidas sobre los Contratos de Compraventa Internacional de Mercaderías. Por la presente, usted y Othar Trade & Logistics Spain dan su consentimiento expreso a la jurisdicción personal exclusiva de los tribunales del condado de Dade, Florida.",
			"terms-conditions-subheader3-subtitle14": "ARBITRAJE",
			"terms-conditions-subheader3-subtitle14-text1": "Cualquier disputa que surja de o se relacione con el objeto de este Acuerdo se resolverá finalmente mediante arbitraje en el condado de Dade, Florida, utilizando el idioma inglés de acuerdo con las Reglas y procedimientos de arbitraje simplificados de Judicial Arbitration and Mediation Services, Inc. (\"JAMS \") entonces en efecto, por un árbitro comercial con experiencia sustancial en la resolución de disputas de contratos comerciales y propiedad intelectual, quien será seleccionado de la lista apropiada de árbitros de JAMS de acuerdo con las Reglas y Procedimientos de Arbitraje Simplificado de JAMS. El fallo sobre el laudo así dictado puede ingresarse en un tribunal que tenga jurisdicción, o se puede solicitar a dicho tribunal la aceptación judicial de cualquier laudo y una orden de ejecución, según sea el caso. Cualquier arbitraje en virtud de este Acuerdo se llevará a cabo de forma individual: no se permiten los arbitrajes colectivos ni las acciones colectivas. USTED ENTIENDE Y ACEPTA QUE AL ACEPTAR ESTE ACUERDO, USTED Y CUBALICORES RENUNCIAN AL DERECHO DE JUICIO POR JURADO O DE PARTICIPAR EN UNA DEMANDA COLECTIVA. Sin perjuicio de lo anterior, cada parte tendrá derecho a iniciar una acción en cualquier momento en un tribunal de la jurisdicción adecuada para obtener una medida cautelar u otra reparación equitativa.",
			"terms-conditions-subheader3-subtitle15": "PROCEDIMIENTOS DE NOTIFICACIÓN",
			"terms-conditions-subheader3-subtitle15-text1": "Othar Trade & Logistics Spain puede proporcionarle notificaciones, ya sea que dichas notificaciones sean requeridas por la ley o tengan fines de marketing u otros fines relacionados con la empresa, mediante notificación por correo electrónico, notificación escrita o impresa, o mediante la publicación de dicha notificación en nuestro sitio web, según lo determine Othar Trade & Logistics Spain. a nuestro exclusivo criterio. Othar Trade & Logistics Spain se reserva el derecho de determinar la forma y los medios para proporcionar notificaciones a nuestros Usuarios, siempre que pueda optar por no recibir ciertos medios de notificación como se describe en este Acuerdo y nuestra ",
			"terms-conditions-subheader3-subtitle15-text2": ". Othar Trade & Logistics Spain no es responsable de ningún filtrado automático que usted o su proveedor de red puedan aplicar a las notificaciones por correo electrónico que enviamos a la dirección de correo electrónico que nos proporciona. Le recomendamos que agregue ",
			"terms-conditions-subheader3-subtitle15-text3": " a su libreta de direcciones de correo electrónico para asegurarse de recibir nuestras notificaciones por correo electrónico.",
			"terms-conditions-subheader3-subtitle16": "ACUERDO COMPLETO / DIVISIBILIDAD",
			"terms-conditions-subheader3-subtitle16-text1": "Este Acuerdo, junto con cualquier enmienda y cualquier acuerdo adicional que pueda celebrar con Othar Trade & Logistics Spain en relación con el Servicio, constituirá el acuerdo completo entre usted y Othar Trade & Logistics Spain con respecto al Servicio. Si alguna disposición de este Acuerdo es considerada inválida por un tribunal de jurisdicción competente, la invalidez de dicha disposición no afectará la validez de las disposiciones restantes de este Acuerdo, que permanecerán en pleno vigor y efecto.",
			"terms-conditions-subheader4": "NO RENUNCIO",
			"terms-conditions-subheader4-text1": "Ninguna renuncia a cualquier término de este Acuerdo se considerará una renuncia adicional o continua de dicho término o cualquier otro término, y el hecho de que Othar Trade & Logistics Spain no haga valer ningún derecho o disposición en virtud de este Acuerdo no constituirá una renuncia a dicho derecho o disposición.",
			"terms-conditions-subheader4-text2": "Términos y condiciones de la tarjeta Othar Trade & Logistics Spain",
			"terms-conditions-subheader4-text2-1": "Este Acuerdo fue revisado por última vez el 17 de febrero de 2021.",
			"terms-conditions-subheader4-text2-2": "Fuego Enterprises, Inc. (\"Othar Trade & Logistics Spain\", \"nosotros\" o \"nos\") puede proporcionar a los miembros de Othar Trade & Logistics Spain créditos de recompensa cuando los miembros realizan compras calificadas en Othar Trade & Logistics Spain (\"Créditos de tarjetas de Othar Trade & Logistics Spain\"). Estos Términos y condiciones de la tarjeta Othar Trade & Logistics Spain (\"Términos de la tarjeta Othar Trade & Logistics Spain\") rigen los créditos de la tarjeta Othar Trade & Logistics Spain. Al aceptar una invitación al Programa de tarjetas de Othar Trade & Logistics Spain, usted acepta cumplir con estos Términos de la tarjeta de Othar Trade & Logistics Spain y reconoce que estos Términos de las tarjetas de Othar Trade & Logistics Spain están sujetos al Acuerdo de términos de uso y la Política de privacidad de Othar Trade & Logistics Spain, que se incorporan aquí. La membresía en el programa Othar Trade & Logistics Spain Card es solo por invitación.",
			"terms-conditions-subheader5-text2": "Beneficios de la membresía",
			"terms-conditions-subheader5-text2-1": "Con una compra mínima de $ 250, excluyendo gastos de envío, manipulación y gastos especiales, y menos los créditos utilizados para la compra, se agregarán $ 25 en créditos de Othar Trade & Logistics Spain a su cuenta de miembro de Othar Trade & Logistics Spain.",
			"terms-conditions-subheader5-text2-2": "Con una compra mínima de $ 500, excluyendo gastos de envío, manipulación y guantes blancos, y menos los créditos utilizados para la compra, se agregarán $ 60 en créditos de Othar Trade & Logistics Spain a su cuenta de miembro de Othar Trade & Logistics Spain.",
			"terms-conditions-subheader5-text2-3": "Con una compra mínima de $ 1,000, excluyendo el manejo de envío y las tarifas de guantes blancos, y menos los créditos utilizados para la compra, se agregarán $ 125 en créditos de Othar Trade & Logistics Spain a su cuenta de miembro de Othar Trade & Logistics Spain.",
			"terms-conditions-subheader5-text3": "Condiciones",
			"terms-conditions-subheader5-text3-1": "Debe cumplir con los requisitos de elegibilidad establecidos en el Acuerdo de términos de uso de Othar Trade & Logistics Spain.",
			"terms-conditions-subheader5-text3-2": "Solo puede tener una membresía de la tarjeta Othar Trade & Logistics Spain por cuenta de correo electrónico.",
			"terms-conditions-subheader5-text3-3": "Su participación en el Programa de tarjetas de CubaLicores es revocable por nosotros en cualquier momento, a nuestro exclusivo criterio. Podemos rescindir o realizar cambios sustanciales a cualquiera o todos los beneficios disponibles para usted bajo el Programa de tarjetas de CubaLicores.",
			"terms-conditions-subheader5-text3-4": "Nos reservamos el derecho de limitar, modificar, alterar, renunciar o cancelar el Programa de tarjetas de CubaLicores en cualquier momento, de manera prospectiva o retroactiva, con o sin previo aviso.",
			"terms-conditions-subheader5-text3-5": "Su membresía de Othar Trade & Logistics Spain Card y los créditos de Othar Trade & Logistics Spain no son transferibles.",
			"terms-conditions-subheader5-text3-6": "Los créditos de CubaLicores no tienen valor en efectivo y solo puede usar los créditos de CubaLicores en relación con una compra en el sitio web de CubaLicores.",
			"terms-conditions-subheader5-text3-7": "Los créditos de Othar Trade & Logistics Spain no se obtienen en compras pagadas con tarjetas de regalo, tarjetas electrónicas de Othar Trade & Logistics Spain o compras realizadas con los créditos de Othar Trade & Logistics Spain existentes.",
			"terms-conditions-subheader5-text3-8": "Los créditos de Othar Trade & Logistics Spain no se pueden usar para comprar tarjetas de regalo de Othar Trade & Logistics Spain.",
			"terms-conditions-subheader5-text3-9": "Los Créditos de CubaLicores se obtienen por el valor de cada pedido individual realizado, no por pedidos acumulativos.",
			"terms-conditions-subheader5-text3-10": "Los créditos de CubaLicores están sujetos a vencimiento.",
			"terms-conditions-subheader5-text4": "Créditos de CubaLicores",
			"terms-conditions-subheader5-text4-1": "Los Créditos de Othar Trade & Logistics Spain se obtienen con cada compra elegible y se depositan en su Cuenta de Miembro de Othar Trade & Logistics Spain dentro de los siete (7) días hábiles a partir de la fecha de compra. Si cancela o devuelve un artículo, los créditos de Othar Trade & Logistics Spain obtenidos por esa compra se deducirán de su cuenta de miembro. Si cancela o devuelve un artículo que se compró con créditos de CubaLicores, no se le reembolsarán los créditos de CubaLicores utilizados en esa transacción. Sus créditos de CubaLicores vencerán 6 meses después de que se otorguen. Sin embargo, Othar Trade & Logistics Spain se reserva el derecho en cualquier momento, con o sin aviso, de cambiar el período de vencimiento.",
			"terms-conditions-subheader5-text5": "Término",
			"terms-conditions-subheader5-text5-1": "Su membresía de Othar Trade & Logistics Spain Card comenzará en la fecha en que acepte la invitación al Programa de Othar Trade & Logistics Spain Card y será válida hasta el 31 de diciembre del año en curso, a menos que se cancele antes. Othar Trade & Logistics Spain se reserva el derecho de extender la fecha de vencimiento de su membresía de la tarjeta Othar Trade & Logistics Spain y el programa de tarjetas Othar Trade & Logistics Spain.",
			"terms-conditions-subheader5-text6": "Pago",
			"terms-conditions-subheader5-text6-1": "Su membresía de Othar Trade & Logistics Spain Card se ofrece sin cargo para recompensarlo por ser un valioso cliente de Othar Trade & Logistics Spain.",
			"terms-conditions-subheader5-text7": "Cancelación de la membresía de la tarjeta Othar Trade & Logistics Spain",
			"terms-conditions-subheader5-text7-1": "Tiene derecho a cancelar su membresía de la tarjeta Othar Trade & Logistics Spain en cualquier momento; sin embargo, no hay reembolsos por cancelación de la Membresía.",
			"terms-conditions-subheader5-text7-2": "Para conocer todos sus otros derechos y obligaciones, consulte el Acuerdo de condiciones de uso y la Política de privacidad de Othar Trade & Logistics Spain.",
			"terms-conditions-subheader5-text8": "CONTÁCTENOS",
			"terms-conditions-subheader5-text9": "Si tiene alguna pregunta sobre este Acuerdo, puede contactarnos en:",
			"terms-conditions-subheader5-text10": "Othar Trade & Logistics Spain.",
			"terms-conditions-subheader5-text13": "Correo electrónico: info@cubalicores.com",
			"store-table-header-text1": "Tienda",
			"store-table-header-text2": "Tiempo de Entrega",
			"store-table-header-text3": "Precio de Entrega",
			"store-table-header-text4": "Descripción",
			"store-table-header-text5": "Notas",
			"store-table-body-row1-text2": "Se recomienda consumir los dulces que contengan Natilla el mismo día de la entrega, pues se preparan con ingredientes naturales, receta de Lola Café, y no contiene preservantes o conservantes agregados.",
			"store-table-body-row2-text1": "Confección de arreglos florales de todo tipo, así como a la ambientación de interiores y exteriores. Se utilizan elementos fundamentalmente naturales, plantas ornamentales y flores.",
			"store-table-body-row2-text2": "Para una mayor conservación de las flores, se recomienda mantenerlas en lugares fríos, se trabaja con flores de importación, sensibles a las altas temperaturas",
			"store-table-body-row3-text1": "Proyecto soñado por 2 hermanos y su primo, convirtiendo la casa donde nacieron en un lugar donde degustar exquisita comida, con una hermosa vista al mar.",
			"store-table-body-row3-text2": "días",
			"store-table-body-row4-text1": "Centro de elaboración de dulces finos al estilo europeo donde se puede encargar cake para varias ocasiones. Se elaboran dulces semifríos como deliciosos mousse de varios sabores y exquisitos pies.",
			"store-table-body-row4-text2": "No entrega los domingos",
			"store-table-body-row5-text1": "La especialidad son los productos pre-elaborados y congelados. Ofertas gourmet hasta la comodidad de su hogar. Comida italiana y criolla elaborada / pre-elaborada,sellada al vacío y congelada.",
			"store-table-body-row5-text2": "Se recomienda seguir las intrucciones del chef escritas en el envase para la elaboración de los productos. Esto garantizará un mayor disfrute de los mismos.",
			"store-table-body-row6-text1": "Comida criolla e internacional, y especialidad de comida al carbón.",
			"store-table-body-row6-text2": "Entrega solo los sábados",
			"store-table-body-row7-text1": "Lleva el salon de belleza a tu casa. Servicio especializado en peluquería, manicuri, pedicuri y tratamientos exclusivos desde la comodidad de tu hogar",
			"store-table-body-row7-text2": "",
			"store-table-body-row8-text1": "Artículos encaminados a la decoración del hogar, donde se puede personalizar el decorado armando a su gusto el diseño para hacerlo llegar a su hogar. La calidad de la cerámica es auténtica y original. Se cuenta con muchos tipos de adornos como búcaros de todos los tamaños y variedad en los diseños, centros de mesa con diferentes estilos y colores, y otros artículos donde cada pieza es única.",
			"store-table-body-row8-text2": "",
			"store-table-body-row9-text1": "Restaurant de comida mexicana con envíos a domicilio a toda La Habana. Menú variado de tacos, burritos, quesadillas y otros antojitos mexicanos, especiales para compartir en cualquier ocasión. Si quieres probar el auténtico sabor de México en la comodidad de tu hogar somos tu opción... Ándale Ándale!!!!",
			"store-table-body-row9-text2": "",
			"store-table-body-row10-text1": "Tienda-taller que produce y comercializa artículos artesanales y de diseño, útiles y decorativos, fabricados con diferentes materiales. Ideales tanto para la ambientación y decoración de espacios, así como para el regalo de obsequios en cualquier ocasión que amerite un detallito especial y un diseño original.",
			"store-table-body-row10-text2": "",
			"store-table-body-row11-text1": "Agencia de fotografía a pedido donde trabajan de manera coordinada varios profesionales de fotografía y video bajo una misma marca. Puede reservar sesiones de fotografía para eventos como bodas, quinceañeras, eventos privados familiares o institucionales. Se realiza también fotografía de productos y publicitaria, de interiores y espacios, para dossier personal, para redes sociales en fin, todo lo que necesite lo podrá encontrar en este espacio dedicado a lograr la mejor imagen para Ud. Venta de originales de fotografías impresas y enmarcadas para decoración de espacios privados o institucionales. También se ofrecen clases de fotografía para los que estén interesados en explorar este interesante mundo de la imagen.",
			"store-table-body-row11-text2": "",
			"store-table-body-row12-text1": "Especializado en entrepanes, Tic-Tac propone 50 combinaciones distintas para colocar en el baguette de la casa. Desde queso hasta carne de res, bacon o camarón grillé. Boquitas está llena de opciones para satisfacer las necesidades de los clientes, lo mismo solos que en grupos.Tablas especiales donde colocan quesos, embutidos, vegetales y panes, boquitas que se convierten en bocazas el doble de ricas y a menor precio y los combos, que proponen boquitas y bebidas por un mismo precio. Para el equipo de Tic- Tac la cosa es simple: para que 'vengas, vuelvas y repitas'.",
			"store-table-body-row12-text2": "",
			"store-table-body-row13-text1": "La Guarida es una oportunidad para viajar en el tiempo, desde el ayer hasta el mañana, un sitio que respeta las tradiciones pero que apuesta por el futuro, Un espacio auténtico para los interesados en conocer la verdadera Cuba y adentrarse en nuestra cultura, costumbres y maneras de hacer.",
			"store-table-body-row13-text2": "",
			"store-table-body-row14-text1": "Ya voy es la fusión de 4 exitosos restaurantes de la Habana que al llegar la pandemia y cerrar siguieron cumpliendo las expectativas de sus clientes con un nuevo Servicio a Domicilio. Ya Voy cumplió con la Familia Cubana a pesar de los pesares, logró llevar sus platos a cada casa cumpliendo una función invaluable, con unos costos altísimos y utilidades muy bajas. Gracias por la confianza depositada, hoy con más experiencia tratamos cada día ser mejores.",
			"store-table-body-row14-text2": "",
			"store-table-body-row15-text1": "Marca de artículos deportivos, dedicados a la preparación física y a los deportes de combate. Implementos para entrenar deportes de combate diversos, tanto grappling como striking. Variedad de sacos (punching bags), mascotas, escudos y pateadores. Nuestros productos de preparación física son una excelente opción para ejercitar, tanto en gimnasios como de manera personal en casa. Los sandbags (sacos de arena), pelotas medicinales y chalecos son ideales para mantener un buen tono muscular.",
			"store-table-body-row15-text2": "",
			"store-table-body-row16-text1": "Proyecto que forma parte del grupo de creación de Humidores Habana creado hace más de 20 años.Nuestro trabajo se dirige fundamentalmente a crear piezas para momentos especiales como aniversarios y cumpleaños. También se cuenta con artículos utilitarios como los contenedores artesanales de colores varios y color madera, con fines también decorativos y los portalaptos de madera.",
			"store-table-body-row16-text2": "Para la personalización de cualquier artículo, ponerse en contacto con Atención al Cliente una vez realizada la compra.",
			"store-table-body-row17-text1": "Juegos de mesa educativos para todos los integrantes del Hogar.",
			"store-table-body-row17-text2": "",
			"store-table-body-row18-text1": "Alimentos pre-elaborados congelados(entre otros) listos para cocinar en minutos y disfrutar de una comida deliciosa. Expertos en llevarte tu comida a domicilio en óptimas condiciones y con las medidas higiénico-sanitarias necesarias para tu seguridad y la de tu familia.",
			"store-table-body-row18-text2": "",
			"store-table-body-row19-text1": "Grupo de creación cubano dedicado al diseño y producción de humidores exclusivos a través de la fusión de técnicas como la orfebrería, la ebanistería y la marquetería. Todos los artículos pueden ser personalizados con frases y logotipos.",
			"store-table-body-row19-text2": "Para la personalización de cualquier artículo, ponerse en contacto con Atención al Cliente una vez realizada la compra.",
			"store-table-body-row20-text1": "Tienda de artesanías y regalos online donde tratamos de rescatar las artesanías principalmente elaboradas con hilo.",
			"store-table-body-row20-text2": "",
			"store-table-body-row21-text1": "Artículos de metal y madera utilitarios y decorativos para el hogar.",
			"store-table-body-row21-text2": "",
			"store-table-body-row22-text1": "Diversos y coloridos productos utilitarios y de diseño para todos los gustos y necesidades.",
			"store-table-body-row22-text2": "",
			"store-table-body-row23-text1": "Restaurante de Comida Criolla",
			"store-table-body-row23-text2": "",
			"footer-parragraph-text1": "Si aún tiene preguntas sobre los plazos y condiciones de entrega por favor contáctenos a través del",
			"footer-parragraph-text2": "Centro de Ayuda",
			"footer-parragraph-text3": "disponible en el sitio www.cubalicores.com o por el email",
			"footer-parragraph-text4": "Nuestros representantes de soporte recibirán su mensaje y le responderán lo antes posible.",
			"title": "CubaLicores - Tienda Online de Licores para Cuba",
			"total": "Total",
			"total-price": "Precio total",
			"unable-update-product-quantity": "No se pudo actualizar la cantidad del producto",
			"useBilling": "Enviar a la dirección de cobro",
			"well": "Bien!",
			"yourOrders": "Sus pedidos",
			"or": "o",
			"wishlist": "Lista de deseos",
			"registration-error": "Hubo un problema durante el registro.",
			"successfully-registered": "Revise su correo para obtener instrucciones.",
			"loading-form": "Cargando formulario...",
			"saving-addresses": "Guardando direcciones...",
			"saving-delivery": "Guardando método de envio...",
			"saving-payment": "Estableciendo la forma de pago...",
			"subject": "Asunto.",
			"confirming": "Confirmando la orden...",
			"order-number": "No. de orden",
			"shipping-policies": "Políticas de Envío y Cargos",
			"costumer-service": "Servicio al cliente",
			"add-few-products-to-cart": "Agregue algunos productos al carrito",
			"go-shopping": "Ir a comprar",
			"unit-price": "Precio unitario",
			"subtotal": "Subtotal",
			"yourInfo": "Tu información",
			"yourInfoDetails": "Tu correo para mantenernos en contacto",
			"zipCode": "Código postal*",
			"registed-message": "Usted se ha registrado satisfactoriamente",
			"password-reset": "Tu contraseña se ha actualizado",
			"unregisted-message": "El email ya fue registrado.",
			"payment-methods": "Métodos de pago",
			"zone": "Zona",
			"thank-for-your-buy": "¡Gracias por su Compra!",
			"fail-confirmation-1-message": "Recibirá un correo electrónico una vez confirmada su orden.",
			"fail-confirmation-2-message": "Si no recibe el correo de confirmación en unos minutos, asegúrese de que el cargo esté reflejado en su tarjeta.",
			"fail-confirmation-3-message": "De lo contrario, sugerimos repetir la compra.",
			"fail-confirmation-4-message": "Para obtener más información sobre nuestros servicios y tiempos de entrega,",
			"fail-confirmation-5-message": "por favor visite nuestra página de <strong>Preguntas Frecuentes</strong>",
			"fail-confirmation-6-message": "y nuestras <strong>Políticas de Envío y Cargos</strong>",
			"sorry-error-occurred-title": "Lo sentimos",
			"error-general-message": "No hemos podido completar su pedido, por favor inténtelo más tarde ",
			"katapulk-team": "Equipo CubaLicores",
			"certify-age-title-1-message": "Hola, producto con",
			"certify-age-title-2-message": "restricción de edad?",
			"certify-age-enter-birthday": "Por favor entrar su fecha de nacimiento:",
			"certify-age-message": "Al entrar estoy certificando que realmente soy mayor de 21 años.",
			"valid-age-enter": "Entrar",
			"required-message": "Requerido",
			"sorry-product-over-21": "Lo sentimos este producto es para mayores de 21 años.",
			"is-not-valid-date": "No es una fecha válida",
			"select": "Seleccione",
			"error-invalid-email": "Correo inválido",
			"error-password-not-match": "Las contraseñas no coinciden",
			"destiny": "Destino",
			"order-state": "Estado del Pedido",
			"order-date": "Fecha de Pedido",
			"order-total": "Total de Pedido",
			"price-per-unit": "Pricio por Unidad",
			"amount": "Monto",
			"shipping-amount": "Gastos de Envío",
			"shipping-total-amount": "Total monto de envío",
			"total-amount": "Total",
			"order-receiver": "Destinatario",
			"details": "Detalles",
			"order-complete": "Completada",
			"order-cart": "Carrito",
			"order-address": "Dirección",
			"order-payment": "Pago",
			"order-resume": "Resumen",
			"order-canceled": "Cancelada",
			"order-awaiting-return": "Esperando reembolso",
			"order-returned": "Reembosada",
			"redsys-error": "Ha ocurrido un error durante el pago, inténtelo de nuevo",
			"menu": "Menu",
			"see-all": "Ver Todo",
			"see-less": "Ver Menos",
			"for-cuba": "Para Cuba",
			"zone-store": "Tiendas de esta Zona",
			"show-all": "Mostrar todas",
			"offer-keep-update": "Mantenme actualizado con noticias y ofertas exclusivas",
			"outofstock": "No disponible",
			"legend-required-field": "* Indica que el campo es requerido",
			"invalid-phone-number": "Número de teléfono inválido",
			"invalid-zip-code": "Código postal inválido",
			"cart-expiring-message-part1": "Tu carrito expirará en ",
			"cart-expiring-message-part2": " minutos. Por favor, completa tu compra.",
			"cart-expiring-empty-cart": "Su carrito ha expirado.",
			"payment-modal-extra-time-title": "Tiempo agotado",
			"payment-modal-extra-time-text1": "Se ha terminado el tiempo para realizar la compra, agregamos {time} más para que pueda terminar su compra.",
			"payment-modal-extra-time-button": "Cerrar",
			"time-minute-singular": "minuto",
			"time-minute-plural": "minutos",
			"time-second-singular": "segundo",
			"time-second-plural": "segundos",
			"filters-title": "Filtros",
			"apply": "Aplicar",
			"under-price": "Menos de",
			"above-price": "Más de",
			"error-refresh-order-title": "Error al recargar orden",
			"error-refresh-order-content": "Estás viendo datos desactualizados. Por favor, recargue.",
			"error-create-order-title": "Error al procesar el pedido",
			"error-create-order-content": "Ha ocurrido un error al procesar el pedido, por favor recargue si el error persiste.",
			"error-reload-cart-order": "Ha ocurrido un error al cargar su orden",
			"warning-product-change-tittle": "Cambio en los Productos",
			"warning-product-change-content": "Revise su orden, hubo cambios en los productos",
			"session-closed": "Su sesión ha sido cerrada satisfactoriamente",
			"selected-variant": "Variante seleccionada",
			"phone-number": "Número de teléfono",
			"extra-data-modal-title": "Necesitamos más información para agregar este producto",
			"emailReceptor": "* Enviaremos también a este email las notificaciones de cambios de estado de su orden",
			"login-my-account": "Entrar a mi cuenta",
			"read-and-accept": "He leído y acepto el",
			"error-title": "Error procesando la orden",
			"invalid-order-title": "Encontramos un problema al procesar su orden",
			"invalid-order-contact-info": "Para ayudarle a completar su orden por favor envíenos un mensaje a ",
			"invalid-order-contact-info2": " donde incluya:",
			"invalid-order-first-and-last-name": "Nombre y Apellido: ",
			"invalid-order-phone-number": "Número de teléfono: ",
			"invalid-order-order-number": "Número de Orden: ",
			"invalid-order-case-number": "Número de Caso: ",
			"pay-with": "Pagar con",
			"payment-form-cc-name": "Nombre en la tarjeta: {name}",
			"payment-form-cc-number": "Número de tarjeta: {number}",
			"payment-form-edit": "Editar",
			"delivery.small.text": "* Seleccione los métodos de entrega. Si algunos paquetes pueden ser unificados en un mismo envío lo haremos cuando selecciones 'Continuar'.",
			"shipment.word": "Envío",
			"of.word": "de",
			"shipping-address-problems": "Hay problemas para enviar algunos productos a la dirección seleccionada. Por favor, compruebe sus productos.",
			"shipping-address-problems-item": "No se puede enviar a la dirección seleccionada.",
			"modal-municipalitySelect-title": "Por favor, seleccione el municipio:",
			"modal-municipalitySelect-text1": "Debes seleccionar un municipio para continuar.",
			"manage-k-wallet": "Administrar K-Wallet",
			"manage-k-wallet-transactions": "Transacciones",
			"manage-k-wallet-banner-message": "Nuestro exclusivo Programa de Tarjeta Recargable hace que las transacciones financieras sean fáciles y seguras",
			"manage-k-wallet-banner-direct-deposit": "Depósito directo (ACH debit)",
			"manage-k-wallet-banner-load-card": "Carga de tarjeta",
			"manage-k-wallet-banner-peer-to-peer-transfer": "Transferencia de crédito de usuario a usuario",
			"manage-k-wallet-banner-check-your-balance": "Consulta de saldo",
			"manage-k-wallet-banner-pay-the-bill": "Pago de la factura",
			"manage-k-wallet-banner-account-balance": "Saldo actual:",
			"manage-k-wallet-banner-available-balance": "Saldo disponible:",
			"manage-k-wallet-banner-add-funds": "Agregar fondos a K-Wallet",
			"manage-k-wallet-banner-to-use-k-wallet": "Para aprovechar K-Wallet, siga estos pasos:",
			"manage-k-wallet-banner-transfer-money-link": "Enviar dinero a un receptor",
			"manage-k-wallet-banner-your-k-wallet-id": "K-Wallet ID:",
			"manage-k-wallet-banner-click-to-reveal": "Click para mostrar",
			"manage-k-wallet-banner-copy-to-clipboard": "Copiar",
			"manage-k-wallet-banner-copied": "Copiado!",
			"modal-kwallet-activate": "Activar K-Wallet",
			"modal-kwallet-activate-text": "Al parecer aun no has activado tu K-Wallet.",
			"modal-kwallet-activate-activate": "Activar",
			"modal-kwallet-activate-cancel": "Tal vez luego",
			"modal-kwallet-activate-accept": "Acepto los",
			"modal-kwallet-activate-terms": "Términos y Condiciones",
			"modal-kwallet-activate-and": "y",
			"modal-kwallet-activate-affidavit": "Certificación Affidavit",
			"transfer-funds-k-wallet-title": "Enviar dinero a un receptor",
			"transfer-funds-k-wallet-amount": "Cantidad a transferir",
			"transfer-funds-k-wallet-amount-placeholder": "Cantidad",
			"transfer-funds-k-wallet-id-transfer": "Identificador de quien recibe",
			"transfer-funds-k-wallet-id-transfer-placeholder": "Id",
			"transfer-funds-k-wallet-available-balance-error": "No puede transferir más que su saldo disponible",
			"transfer-funds-k-wallet-invalid-amount-error": "Solo se permiten números mayores que cero. Use (.) para especificar centavos",
			"transfer-funds-k-wallet-account-not-found": "Cuenta no existente",
			"transfer-funds-k-wallet-same-account": "No se permite la transferencia entre la misma cuenta",
			"affidavit-certification-1": "- Yo, el usuario, entiendo que las exportaciones de los Estados Unidos a la República de Cuba están prohibidas por los Estados Unidos a menos que dichas exportaciones estén específicamente autorizadas de acuerdo con una licencia o una excepción de licencia. En concreto, la Oficina de Industria y Seguridad (BIS) del Departamento de Comercio de EE.UU. administra y hace cumplir el Reglamento de Administración de Exportaciones (EAR; 15 C.F.R. §§ 730-774), que regula las exportaciones de EE.UU. a la República de Cuba, entre otras exportaciones.",
			"affidavit-certification-2": "- Yo, el usuario, declaro y certifico que:",
			"affidavit-certification-2-1": "Los productos se compraron en Katapulk Marketplace.",
			"affidavit-certification-2-2": "Las exportaciones de los productos de los EE.UU. a la República de Cuba están permitidas en virtud de una de las siguientes excepciones de licencia del BIS, y cumplen con ella:",
			"affidavit-certification-2-2-1": "• Excepción de licencia Parcelas de regalo y donaciones humanitarias (15 CFR § 740.12);",
			"affidavit-certification-2-2-2": "• Apoyo a la excepción de la licencia para el pueblo cubano (15 CFR § 740.21); y",
			"affidavit-certification-2-2-3": "• Equipaje con excepción de la licencia (15 CFR § 740.14).",
			"affidavit-certification-3": "- Yo, no soy:",
			"affidavit-certification-3-1": "(i) un miembro del gobierno de la República de Cuba; ni funcionarios prohibidos del gobierno de Cuba; ni (ii) la compra de estos productos en nombre del gobierno de la República de Cuba o de cualquier funcionario prohibido (31 CFR § 515.337).",
			"affidavit-certification-3-2": "(iii) una persona designada en una lista de personas designadas de EE.UU., incluida la Lista Nacional Especialmente Designada del Departamento del Tesoro de EE.UU., de la Oficina de Control de Activos Extranjeros, o la Lista Restringida de Cuba del Departamento de Estado de EE.UU.; (iv) parte de una entidad incluida en cualquiera de las dos listas; ni (v) la compra de estos productos en nombre de una persona o entidad incluida en cualquiera de las dos listas (31 CFR § 515.209).",
			"affidavit-certification-3-3": "(vi) un miembro prohibido del Partido Comunista de Cuba (31 CFR § 515.338).",
			"affidavit-certification-4": "- Tengo 18 años de edad o más.",
			"affidavit-certification-5": "- Afirmo solemnemente, bajo pena de perjurio, que, a mi leal saber y entender, lo anterior es verdadero y exacto.",
			"transactions-table-date": "Fecha",
			"transactions-table-description": "Descripción",
			"transactions-table-status": "Estado",
			"transactions-table-amount": "Cantidad",
			"transactions-table-rows-per-page": "Registros por página",
			"transactions-table-search": "Buscar",
			"transactions-table-loading": "Cargando...",
			"transactions-table-no-records": "No hay registros para mostrar",
			"k-wallet-account-not-active-yet": "Su cuenta K-Wallet aun no se encuentra activa. Diríjase a <a href='/manage-k-wallet'>Administart K-Wallet</a> para activarla.",
			"add-funds-k-wallet-title": "Agregar fondos a tu K-Wallet",
			"add-funds-k-wallet-amount": "Cantidad a transferir*",
			"add-funds-k-wallet-invalid-debit-card-error-title": "Tarjeta de débito inválida",
			"add-funds-k-wallet-invalid-debit-card-error-message": "Por favor, agregue una tarjeta de débito válida",
			"add-funds-k-wallet-invalid-card-number-error": "Número de tarjeta inválido",
			"add-funds-k-wallet-invalid-amount-error": "Utilice números mayores que 0. Use (.) para especificar los centavos",
			"add-funds-k-wallet-submitted-successfully": "Su solicitud ha sido enviada correctamente",
			"generic-error-title": "Ha ocurrido un error",
			"generic-error-message": "Por favor inténtalo nuevamente",
			"modal-change-municipality-title": "Zona de entrega",
			"modal-change-municipality-text1": "Usted está realizando un cambio en la zona de entrega seleccionada inicialmente y su carrito será vaciado.",
			"modal-change-municipality-text2": "Por favor, antes de comenzar la compra, asegúrese de seleccionar la provincia y el municipio correcto donde debemos entregar su orden.",
			"modal-change-municipality-text3": "Gracias por confiar en Nosotros.",
			"modal-change-municipality-button-accept": "Aceptar",
			"modal-change-municipality-button-cancel": "Cancelar",
			"manage-k-wallet-add-balance": "Clic para agregar fondos",
			"manage-k-wallet-insufficient-balance": "SALDO INSUFICIENTE",
			"send-code-to-email": "Enviar código al correo",
			"code": "Código",
			"code-send-successfully": "Código enviado con éxito.",
			"send-message-code-by-email": "Se le enviará un email a su cuenta de correo con un código de acceso temporal para iniciar sección.",
			"send-message-code-by-email-finished": "Se le ha enviado un email a su cuenta de correo con un código de acceso temporal para iniciar sección.",
			"invalid-email-address": "Dirección de correo electrónico no válida.",
			"info-cubalicores": "info@cubalicores.com",
			"alcohol-abuse": "El abuso de alcohol es dañino para la salud. Consuma con moderación.",
			"smoking-harms-health": "Las autoridades sanitarias advierten: fumar daña la salud.",
			"frequent-questions": "Preguntas Frecuentes",
			"frequent-questions-title": "PREGUNTAS FRECUENTES:",
			"frequent-questions-subtitle1": "1. ¿En qué provincias entregan?",
			"frequent-questions-response1-1": "R/ Entregamos en La Habana.",
			"frequent-questions-response1-2": "Estamos trabajando para extender nuestros servicios al resto de las provincias.",
			"frequent-questions-subtitle2": "2. ¿Cuántos días demora la entrega de las órdenes?",
			"frequent-questions-response2-1": "R/ Las entregas en la tienda de CubaLicores demoran aproximadamente 7 días hábiles. No se incluyen fines de semana. Las compras realizadas en la tienda de Pre-Venta pueden tardar de 30-60 días dependiendo de los productos comprados.",
			"frequent-questions-response2-2": "Por favor tenga en cuenta que nuestras fechas son estimadas y no exactas.",
			"frequent-questions-response2-3": "Para conocer sobre los tiempos de envío en otras tiendas de la plataforma por favor visite nuestras Políticas de Envíos y Cargos ( <a target='_blank' href='https://www.cubalicores.com/shipping-policy'>https://www.cubalicores.com/shipping-policy</a> ).",
			"frequent-questions-subtitle3": "3. ¿Cómo puedo comprar? ",
			"frequent-questions-response3-1": "R/ Toda la compra se hace online en nuestro sitio <a target='_blank' href='www.cubalicores.com'>www.cubalicores.com</a>. Seleccione los productos, los agrega al carrito y procede a pagar. No recibimos órdenes vía telefónica.",
			"frequent-questions-response3-2": "Puede registrarse en nuestra página web y acceder a su perfil o completar su compra sin registrarse.",
			"frequent-questions-subtitle4": "4. ¿Cómo saber si tienen un producto? ¿Cuándo abastecen la tienda?",
			"frequent-questions-response4-1": "R/ Todos los productos disponibles los puede encontrar en nuestro sitio web <a target='_blank' href='www.cubalicores.com'>www.cubalicores.com</a>. No tenemos horarios o fechas específicas para surtir, sugerimos mantenerse al tanto de nuestras redes sociales para actualizaciones sobre nuevos productos y ofertas.",
			"frequent-questions-subtitle5": "5. ¿Cuánto es el costo de envío?",
			"frequent-questions-response5-1": "R/ El Envío Regular + Cargo por Manejo tiene un costo de $8 USD para todas las provincias en CubaLicores.",
			"frequent-questions-response5-2": "Para conocer sobre los costos de envío en otras tiendas de la plataforma por favor visite nuestras Políticas de Envíos y Cargos ( <a target='_blank' href='https://www.cubalicores.com/shipping-policy'>https://www.cubalicores.com/shipping-policy</a> )",
			"frequent-questions-subtitle6": "6. ¿Existe un monto mínimo/máximo de compra?",
			"frequent-questions-response6-1": "R/ No tenemos montos mínimos o máximos de compra. Asimismo, puede realizar la cantidad de órdenes que considere en un mismo día o período de tiempo. Para algunos productos, sin embargo, podemos establecer límites en las cantidades a ordenar.",
			"frequent-questions-subtitle7": "7. ¿Puedo pagar con la tarjeta del Banco Metropolitano u otro banco cubano?",
			"frequent-questions-response7-1": "R/ Por el momento solo aceptamos pagos con tarjetas Visa, Mastercard, Discover o cualquier otra de banco extranjero.",
			"frequent-questions-subtitle8": "8. ¿Puedo pagar en efectivo cuando reciba los productos?",
			"frequent-questions-response8-1": "R/ No aceptamos pagos en efectivo. Toda la transacción se realiza online en el momento de la compra.",
			"frequent-questions-subtitle9": "9. ¿Mi familiar en Cuba tiene que pagar algo?",
			"frequent-questions-response9-1": "R/ En Cuba no se paga nada.",
			"frequent-questions-subtitle10": "10. ¿Cómo sabe mi familiar en Cuba el día que le llevarán la orden?",
			"frequent-questions-response10-1": "R/ Hacemos una llamada a su familiar una vez usted realice el pedido para verificar sus datos y dirección de entrega (Ver pregunta 12 para más información sobre esta llamada) A partir de ese momento debe contar con que la orden llegará en los próximos 8 días hábiles o 30 -60 si es una orden de Pre-Venta.",
			"frequent-questions-response10-2": "24 horas antes de la entrega usted recibe un correo electrónico que anuncia que su pedido está listo para ser Enviado y debe notificar a su familiar. El cliente que realiza la orden es responsable de proveer los datos de contacto en Cuba correctamente, así como de notificar al destinatario cuando reciba el email de Envío de la orden, de lo contrario puede significar atrasos en la entrega.",
			"frequent-questions-subtitle11": "11. Hice una orden y mi familiar no ha recibido ninguna llamada",
			"frequent-questions-response11-1": "R/ Si ha realizado previamente órdenes para el mismo destinatario, podemos confirmar la dirección de entrega directamente desde el sistema y omitir la primera llamada. Su familiar solo debe esperar el tiempo estimado de entrega.",
			"frequent-questions-subtitle13": "12. ¿Cómo saber si mi orden se completó satisfactoriamente?",
			"frequent-questions-response13-1": "R/ Hay dos elementos que le indicarán que su orden se completó sin problemas: Primero verifique que recibió el correo de confirmación de su pedido (mire también en la carpeta de spam). Luego verifique que se hizo el cargo a su tarjeta a nombre de OTHAR TRADE & LOGISTICS. Si alguno de estos indicadores falla significa que no recibimos su pedido. Usted es responsable de escribir correctamente el correo electrónico donde recibirá la confirmación de la orden.",
			"frequent-questions-subtitle14": "13. ¿Cómo puedo darle seguimiento a mi orden?",
			"frequent-questions-response14-1": "R/ Si necesita saber el estado de su orden comuníquese con nosotros a través del botón de chat en nuestro sitio web. Tenga en cuenta que los pedidos de CubaLicores tardan hasta 8 días hábiles para ser entregados. No nos contacte si aún su compra se encuentra dentro del plazo estimado de entrega.",
			"frequent-questions-subtitle15": "14. ¿Si mi tarjeta no es en USD cómo realizan el cambio de moneda?",
			"frequent-questions-response15-1": "R/ Nuestros precios son exclusivamente en USD. Es el banco de su tarjeta quien realiza la conversión de moneda según la tasa que tenga establecida.",
			"frequent-questions-subtitle16": "15. ¿Tienen algún lugar donde recoger los pedidos?",
			"frequent-questions-response16-1": "R/ No. Todas las entregas son exclusivamente a domicilio.",
			"frequent-questions-subtitle17": "16. Estoy haciendo una compra y mi tarjeta fue declinada",
			"frequent-questions-response17-1": "R/ Si su tarjeta fue declinada, sin especificar el motivo, debe consultar con su banco. Si este le confirma que no tiene problemas, y aun así no puede comprar en nuestro sitio, sugerimos utilizar otra tarjeta.",
			"frequent-questions-subtitle18": "17. Me han Cancelado una orden, ¿cuándo tendré mi dinero de vuelta?",
			"frequent-questions-response18-1": "R/ Si cancelamos su orden, es muy probable que se deba a un error de inventario. Antes de cancelarla, le enviamos un correo electrónico anunciándole, y luego un segundo correo confirmando el procesamiento de su reembolso.",
			"frequent-questions-response18-2": "Una vez procesado el reembolso (dígase a partir de que recibe el segundo correo electrónico), puede tardar de 3-5 días para que se refleje en su cuenta, dependiendo del banco de su tarjeta.",
			"frequent-questions-response18-3": "El total de su dinero es reembolsado a la misma tarjeta con la que realizó su compra.",
			"frequent-questions-subtitle19": "18. Hice una orden y no recibí el correo electrónico de Confirmación",
			"frequent-questions-response19-1": "R/ Puede suceder por varios motivos, el más común está relacionado con errores tipográficos al escribir su correo electrónico antes de pagar.",
			"frequent-questions-response19-2": "Si realizó una orden y no recibió el email de confirmación, por favor comuníquese con nosotros a través de nuestro chat en el sitio web o por el email <a href=\"mailto:info@cubalicores.com\">info@cubalicores.com</a>. Envíenos nombre, apellidos, correo electrónico, monto y los 4 últimos dígitos de la tarjeta que utilizó.",
			"frequent-questions-response19-3": "Por favor asegúrese que el cargo de su orden esté reflejado en su tarjeta. De lo contrario, sugerimos repetir la compra.",
			"frequent-questions-subtitle20": "19. Escribo al Centro de Ayuda y envío correos electrónicos y no recibo respuesta. ¿Qué puede suceder?",
			"frequent-questions-response20-1": "R/ Usualmente experimentamos altos volúmenes de comunicaciones diarias. Es por esto que en ocasiones la respuesta por parte de nuestros agentes puede demorar entre 24 y 48 horas. Sin embargo, todas las solicitudes recibidas son atendidas.",
			"frequent-questions-response20-2": "Para contribuir a que se acorten los tiempos de respuesta, sugerimos:",
			"frequent-questions-response20-3": "1. Asegurarse de que su orden superó el tiempo estimado de entrega.",
			"frequent-questions-response20-4": "2. Incluir en su solicitud el # de Orden y/o datos del cliente que realizó la orden, cuando corresponda.",
			"frequent-questions-response20-5": "3. Revisar la información que tenemos disponible en nuestras Políticas de Envío y Cargos (<a target='_blank' href='https://www.cubalicores.com/shipping-policy'>https://www.cubalicores.com/shipping-policy</a>) y nuestras Políticas de Reclamaciones y Devoluciones (<a target='_blank' href='https://www.cubalicores.com/return-policy'>https://www.cubalicores.com/return-policy</a>)",
			"return-policy": "Política de devolución",
			"return-policy-title": "POLITICA DE DEVOLUCION PARA PRODUCTOS ALIMENTICIOS",
			"return-policy-text1": "Dada la naturaleza de nuestros productos, no realizamos reembolsos después de procesar el pedido y enviar el producto. Usted como cliente debe entenderlo y tenerlo en cuenta antes de comprar cualquier producto alimenticio ofrecido en nuestro sitio web.",
			"return-policy-text2": "La persona que recibe la orden en Cuba debe asegurarse de verificar que los productos que recibe coincidan con la orden realizada. Asimismo, revisar muy bien los empaques y verificar que estén en perfecto estado en compañía del transportista antes de firmar la factura. Si firman sin verificar se pierde el derecho de reclamación. No nos hacemos responsables por defectos que estén a la vista, ni por diferencias en la cantidad y surtido de los productos que el consumidor/receptor haya aceptado al momento de la entrega y que debió haber advertido en el acto de la entrega.",
			"return-policy-text3": "Sin embargo, nos damos cuenta de que pueden existir circunstancias excepcionales. Por lo tanto, realizamos reemplazos y/o reembolsos en los siguientes casos:",
			"return-policy-subtitle1": "Producto/Orden no entregado:",
			"return-policy-subtitle1-text1": "Las reclamaciones por falta de entrega de la orden se deben realizar en un plazo de 15 - 20 días después de realizada la orden.",
			"return-policy-subtitle1-text2": "Las reclamaciones por la no entrega de un producto específico dentro de una orden debe realizarse dentro de las 24 horas siguientes a la fecha de entrega de la compra. De lo contrario, consideraremos que la orden fue recibida sin problemas.",
			"return-policy-subtitle2": "Producto no corresponde a su descripción:",
			"return-policy-subtitle2-text1": "Este tipo de incidencia debe ser reportada en no más de 24 horas después de haber recibido la orden. Se debe proporcionar una evidencia clara que demuestre que el producto comprado no corresponde a su descripción en la página de producto. Las quejas que se basen meramente en expectativas injustificadas, deseos personales del cliente o desconocimiento sobre cómo procesar un producto no se tomarán en cuenta.",
			"return-policy-subtitle3": "Producto en mal estado:",
			"return-policy-subtitle3-text1": "Aunque todos los productos se chequean minuciosamente antes de ser entregados, a veces pueden ocurrir incidencias inesperadas. Este problema debe ser reportado en no más de 24 horas después de haber recibido la orden. Se debe mostrar una evidencia clara de que el producto está expirado, de que el empaque original del producto no contiene la fecha de producción y/o expiración, o de que el color u olor no corresponde con un producto fresco.",
			"return-policy-subtitle4": "Entrega retrasada del Producto/Orden:",
			"return-policy-subtitle4-text1": "Si la orden o alguno de sus productos no se entrega en el plazo estimado de 10 - 12 días hábiles (sin incluir fines de semana) debido a fallos de nuestro servicio, usted tiene derecho a ser reembolsado sin ninguna compensación adicional. Tenga en cuenta que se requiere tener toda la información de contacto actualizada de la persona que recibirá la orden en Cuba. Si dicha información no se proporcionó de manera oportuna se puede rechazar la solicitud de reembolso.",
			"return-policy-subtitle5": "CANCELACION DE ORDENES:",
			"return-policy-subtitle5-text1": "Todas las órdenes pueden ser canceladas en un plazo menor de 24 horas.",
			"return-policy-subtitle5-text2": "Tenga en cuenta que cuando se cancela una orden que no ha sido por fallo nuestro no reembolsamos el valor cobrado por Manejo y Envío.",
			"return-policy-subtitle5-text3": "El concepto de Manejo y Envío incluye además de la preparación, empaquetado, envío y entrega de la orden, el uso de la plataforma, procesamiento del pago, y en el caso de las cancelaciones ajuste del inventario y la tarifa por concepto de cancelación que aplica la pasarela de pago con la que trabajamos.",
			"return-policy-subtitle6": "NOTAS GENERALES A TENER EN CUENTA PARA LAS RECLAMACIONES Y/O CANCELACIONES:",
			"return-policy-subtitle6-text1": "1. Todas las cancelaciones deben realizarse a través de los canales de Atención al Cliente por el cliente que realizó la compra, en un plazo no mayor de 24 horas después de completada la orden.",
			"return-policy-subtitle6-text2": "2. Las reclamaciones realizadas fuera de las primeras 24 horas después de entregada la orden serán rechazadas.",
			"return-policy-subtitle6-text3": "3. Para que una reclamación sea válida se deben conservar los productos dañados y/o empaques originales.",
			"return-policy-subtitle6-text4": "4. A los artículos que hayan sido consumidos o manipulados se les puede negar el cambio o reembolso.",
			"return-policy-subtitle6-text5": "5. El cambio de los productos puede tomar de 5 a 7 días.",
			"return-policy-subtitle6-text6": "6. Los reembolsos se realizan exclusivamente al método de pago utilizado para la compra. Puede tomar de 5 a 7 días para reflejarse en la cuenta, según el banco de la tarjeta utilizada.",
			"shippingPolicy.title": "POLÍTICA DE ENTREGA Y TARIFAS",
			"shippingPolicy.subtitle1": "Información importante sobre los envíos",
			"shipping-policy__important-info-about-delivery": "<p>CubaLicores cuenta con varios proveedores y distribuidores.</p><p><b>ATENCIÓN.</b> Si usted ordena más de un producto, algunos podrían ser distribuidos desde lugares diferentes y, por lo tanto, podrían ser entregados en distintos momentos.</p><p>Enviamos compras a La Habana, proximamente a Pinar del Río, Artemisa, Mayabeque, Matanzas, Ciego de Ávila, Las Tunas, Holguín, Camagüey, Sancti Spiritus, Granma y Santiago de Cuba.</p><p>Existe la posibilidad de entregar algunos de nuestros productos en fechas especiales.  Contáctenos por el correo electrónico <a href=\"mailto:info@cubalicores.com\">info@cubalicores.com</a> para hacer esta solicitud. </p>",
			"shippingPolicy.subtitle2": "Condiciones de entrega:",
			"shipping-policy__delivery-conditions": "<p>Al realizar la orden, el cliente podrá especificar una persona, dirección de entrega y contacto telefónico. Nuestro equipo se comunicará en dos momentos con esta persona 1. Para notificar el pedido y confirmar la dirección y 2. Para evaluar la calidad del servicio prestado y los productos recibidos.</p><p><b>ATENCIÓN:</b> Este servicio está sujeto a las tarifas de sms y llamada de voz establecido por el proveedor telefónico del destinatario. </p><p><b>ATENCIÓN:</b> Si ha realizado previamente órdenes para el mismo destinatario, podemos confirmar la dirección de entrega directamente desde el sistema y omitir la primera llamada. Si el destinatario no está presente en el momento de la entrega, la orden puede ser entregada a vecinos, amigos u otras personas siempre y cuando <span style=\"text-decoration: underline;\">muestren una copia del ID del destinatario o puedan demostrar su autorización para recibirlo</span>.</p><p>Las órdenes que contengan errores en las direcciones y contactos de entrega serán retenidas hasta que el cliente aporte información correcta y suficiente. Si la información suministrada por el cliente está incompleta o no es suficiente para realizar el envío de forma segura, la orden puede ser cancelada y el dinero devuelto al comprador.</p><p>Los plazos de entrega de los envíos o de la prestación de los servicios comprados, comienzan a regir a partir de la aprobación de la orden y verificación de los contactos del destinatario.</p><p>Los datos de teléfono y/o dirección electrónica del destinatario, ingresados por el cliente en la ficha del destinatario, podrán ser utilizados por el transportista o el equipo de gestión de CubaLicores para coordinar el horario de entrega y otros detalles del servicio con el destinatario. Este servicio esta sujeto a las tarifas de sms y llamada de voz establecido por el proveedor telefónico del destinatario</p><p><b>Los tiempos de distribución son estimados, no garantizados.</b></p><p>Para la protección contra fraudes y/o usos indebidos de tarjetas de crédito, Othar Trade & Logistics Spain se atribuye el derecho de retardar la entrega de los productos y/o servicios hasta se verifique la autenticidad de la compra y, en caso de considerarlo oportuno, profundizará en el origen de cualquier transacción realizada en el sitio, según lo establecido en las regulaciones internas de la empresa.</p>",
			"shippingPolicy.subtitle2.subtitle1": "<p>Tarifas de envío y manipulación</p><span style=\"color: #d3af71\">CUBALICORES</span>",
			"shippingPolicy.subtitle.ArtMay": "Envíos a La Habana tiene una tarifa de: $8.00 USD",
			"shippingPolicy.subtitle3": "Plazo de entrega:",
			"shippingPolicy.subtitle3.table.text1": "Alimentos generales, bebidas y licores, confituras, resto de categorías de mercado, aseo y útiles del hogar",
			"shippingPolicy.subtitle3.table.text2.10": "10 -12 días hábiles dependiendo del destino.",
			"shippingPolicy.subtitle3.table.text3": "Se excluyen sábados, domingos y días feriados",
			"shippingPolicy.subtitle3.table.text4": "Alimentos frescos, carne, embutidos, viandas, granos y módulos",
			"shippingPolicy.subtitle3.table.text5": "Electrodomésticos",
			"shippingPolicy.subtitle3.table.text6": "Ver detalle de entrega en el producto",
			"shippingPolicy.subtitle3.table.text7": "Productos de importación y ferretería",
			"shippingPolicy.subtitle3.table.text9": "Algunos productos en",
			"shippingPolicy.subtitle3.table.text12": "son de importación y sus plazos de entrega varían entre 30 y 60 días. Ver detalle de entrega en el producto antes de efectuar la compra.",
			"shippingPolicy.subtitle4": "Tarifas de entrega por destinos:",
			"shippingPolicy.subtitle5": "Plazos de entrega por destinos:",
			"shippingPolicy.subtitle3.table.text13": "Plazos estimados, variarán en función de los productos seleccionados",
			"shipping-policy__delivery-fees-for-stores-disclaimer": "<p><b>(*)Todas las órdenes pueden ser canceladas en un plazo menor de 24 horas después de realizada la compra.</b></p><p>El destinatario debe revisar el producto en el momento de la entrega, no se aceptan reclamaciones sin evidencia clara que el producto no se corresponde a su descripción, o pruebas de que esté en mal estado. Esta reclamación no será válida después de 24 horas de la entrega. Para mayor información, referirse a nuestra <a target='_blank' href='https://www.cubalicores.com/return-policy'>Política de Reclamaciones y Cancelaciones</a>.</p>",
			"shippingPolicy.subtitle3.table.text14": "Tarifas de envío y tiempo de entrega para",
			"shippingPolicy.subtitle3.table.text15": "TIENDAS Y RESTAURANTES EN LA HABANA:",
			"store-table-body-row1-text1": "Repostería artesanal con recetas internacionales, ingredientes locales y sabores tradicionales cubanos. Dulces a base de biscocho, chocolate, canela y frutas tropicales, que buscan elaboraciones creativas y nutritivas para la familia cubana. La única cafetería en La Habana que oferta frozen yogurt con toppins variados.  Los productos más populares son los pastelitos de guayaba, rollitos de canela, pastel de hojaldre, galleticas de jengibre y frozen yogurt.",
			"shipping.lola_dulceria_cafe.notes": "Se recomienda consumir los dulces que contengan Natilla el mismo día de la entrega, pues se preparan con ingredientes naturales, receta de Lola Café, y no contiene preservantes o conservantes agregados.",
			"shipping.jardin_angelica.description": "Confección de arreglos florales de todo tipo, así como a la ambientación de interiores y exteriores. Se utilizan elementos fundamentalmente naturales, plantas ornamentales y flores.",
			"shipping.jardin_angelica.notes": "Para una mayor conservación de las flores, se recomienda mantenerlas en lugares fríos, se trabaja con flores de importación, sensibles a las altas temperaturas.",
			"shipping.dulce_tentazione.description": "Centro de elaboración de dulces finos al estilo europeo donde se puede encargar cake para varias ocasiones. Se elaboran dulces semifríos como deliciosos mousses de varios sabores y exquisitos pies.",
			"shipping.home_deli.description": "La especialidad son los productos pre-elaborados y congelados. Ofertas gourmet hasta la comodidad de su hogar. Comida italiana y criolla elaborada / pre-elaborada, sellada al vacío y congelada.",
			"shipping.home_deli.notes": "Se recomienda seguir las instrucciones del chef escritas en el envase para la elaboración de los productos. Esto garantizará un mayor disfrute de los mismos. ",
			"shipping.idilio.description": "Comida criolla e internacional, y especialidad de comida al carbón.",
			"shipping.chic-salon.description": "Lleva el salón de belleza a tu casa. Servicio especializado en peluquería, manicuri, pedicuri y tratamientos exclusivos desde la comodidad de tu hogar",
			"shipping.deco-ceramica.description": "Artículos encaminados a la decoración del hogar, donde se puede personalizar el decorado armando a su gusto el diseño para hacerlo llegar a su hogar. La calidad de la cerámica es auténtica y original. Se cuenta con muchos tipos de adornos como búcaros de todos los tamaños y variedad en los diseños, centros de mesa con diferentes estilos y colores, y otros artículos donde cada pieza es única.",
			"shipping.peke-art.description": "Tienda-taller que produce y comercializa artículos artesanales y de diseño, útiles y decorativos, fabricados con diferentes materiales. Ideales tanto para la ambientación y decoración de espacios, así como para el regalo de obsequios en cualquier ocasión que amerite un detallito especial y un diseño original.",
			"shipping.andale.description": "Restaurant de comida mexicana con envíos a domicilio a toda La Habana. Menú variado de tacos, burritos, quesadillas y otros antojitos mexicanos, especiales para compartir en cualquier ocasión. Si quieres probar el auténtico sabor de México en la comodidad de tu hogar somos tu opción... Ándale Ándale!!!!",
			"shipping.bodegon-asado.description": "Restaurante de Comida Criolla",
			"shipping.la-guarida.description": "La Guarida es una oportunidad para viajar en el tiempo, desde el ayer hasta el mañana, un sitio que respeta las tradiciones pero que, apuesta por el futuro, Un espacio auténtico para los interesados en conocer la verdadera Cuba y adentrarse en nuestra cultura, costumbres y maneras de hacer.",
			"shipping.reyes-manso.description": "Alimentos pre-elaborados congelados (entre otros) listos para cocinar en minutos y disfrutar de una comida deliciosa. Expertos en llevarte tu comida a domicilio en óptimas condiciones y con las medidas higiénico sanitarias necesarias para tu seguridad y la de tu familia.",
			"shipping.boquitas.description": "Especializado en entrepanes, Tic-Tac propone 50 combinaciones distintas para colocar en el baguette de la casa. Desde queso hasta carne de res, beicon o camarón grillé. Boquitas está llena de opciones para satisfacer las necesidades de los clientes, lo mismo solos que en grupos. Tablas especiales donde colocan quesos, embutidos, vegetales y panes, boquitas que se convierten en bocazas el doble de ricas y a menor precio y los combos, que proponen boquitas y bebidas por un mismo precio. Para el equipo de Tic-Tac la cosa es simple: para que \"vengas, vuelvas y repitas\"",
			"shipping.zig-zag.description": "Tienda de artesanías y regalos online donde tratamos de rescatar las artesanías principalmente elaboradas con hilo.",
			"shipping.ya-voy.description": "Ya voy es la fusión de 4 exitosos restaurantes de la Habana que al llegar la pandemia y cerrar siguieron cumpliendo las expectativas de sus clientes con un nuevo Servicio a Domicilio. Ya Voy cumplió con la Familia Cubana a pesar de los pesares, logró llevar sus platos a cada casa cumpliendo una función invaluable, con unos costos altísimos y utilidades muy bajas. Gracias por la confianza depositada, hoy con más experiencia tratamos cada día ser mejores. ",
			"shipping.sinmolde.description": "Diversos y coloridos productos utilitarios y de diseño para todos los gustos y necesidades.",
			"shipping.atlas-implementos-deportivos.description": "Marca de artículos deportivos, dedicados a la preparación física y a los deportes de combate.  Implementos para entrenar deportes de combate diversos, tanto grappling como striking. Variedad de sacos (punching bags), mascotas, escudos y pateadores. Nuestros productos de preparación física son una excelente opción para ejercitar, tanto en gimnasios como de manera personal en casa. Los sandbags (sacos de arena), pelotas medicinales y chalecos son ideales para mantener un buen tono muscular.",
			"shipping.picabu.description": "Picabú es una tienda dedicada principalmente al bebé y a los niños, que también busca acompañar la maternidad y paternidad con artículos práctico y funcionales que, al mismo tiempo, dan mucho valor a la estética. Chupeteros, mordedores, collares de lactancia, láminas decorativas, organizadores, entre otros; la mayoría de las propuestas son personalizables, de modo que constituyen un elemento muy útil en la vida diaria con un pequeño o pequeña y, además, han de convertirse en un hermoso recuerdo de estas etapas. Los materiales empleados son muy seguros para el bebé, libre de elementos tóxicos y respetuosos del medio ambiente.",
			"shipping.magoz.description": "<div>Agencia de fotografía a pedido donde trabajan de manera coordinada varios profesionales de fotografía y video bajo una misma marca. Puede reservar sesiones de fotografía para eventos como bodas, quinceañeras, eventos privados familiares o institucionales.</div><div>Se realiza también fotografía de productos y publicitaria, de interiores y espacios, para dossier personal, para redes sociales en fin, todo lo que necesite lo podrá encontrar en este espacio dedicado a lograr la mejor imagen para Ud.</div><div>Venta de originales de fotografías impresas y enmarcadas para decoración de espacios privados o institucionales. También se ofrecen clases de fotografía para los que estén interesados en explorar este interesante mundo de la imagen.</div>",
			"shipping.dforja.description": "Artículos de metal y madera utilitarios y decorativos para el hogar.",
			"shippingPolicy.any_question": "Si aún tiene preguntas sobre los plazos y condiciones de entrega por favor contáctenos a través del <b>Chat</b> disponible en el sitio <b><a href=\"https://www.cubalicores.com\">www.cubalicores.com</a></b> o por el email <a href=\"mailto:info@cubalicores.com\">info@cubalicores.com</a>. Nuestros representantes de soporte recibirán su mensaje y le responderán lo antes posible."
		}
	};

/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.Observable = void 0;
	var Subscriber_1 = __webpack_require__(164);
	var Subscription_1 = __webpack_require__(62);
	var observable_1 = __webpack_require__(230);
	var pipe_1 = __webpack_require__(232);
	var config_1 = __webpack_require__(165);
	var isFunction_1 = __webpack_require__(31);
	var errorContext_1 = __webpack_require__(336);
	var Observable = (function () {
	    function Observable(subscribe) {
	        if (subscribe) {
	            this._subscribe = subscribe;
	        }
	    }
	    Observable.prototype.lift = function (operator) {
	        var observable = new Observable();
	        observable.source = this;
	        observable.operator = operator;
	        return observable;
	    };
	    Observable.prototype.subscribe = function (observerOrNext, error, complete) {
	        var _this = this;
	        var subscriber = isSubscriber(observerOrNext) ? observerOrNext : new Subscriber_1.SafeSubscriber(observerOrNext, error, complete);
	        errorContext_1.errorContext(function () {
	            var _a = _this, operator = _a.operator, source = _a.source;
	            subscriber.add(operator
	                ?
	                    operator.call(subscriber, source)
	                : source
	                    ?
	                        _this._subscribe(subscriber)
	                    :
	                        _this._trySubscribe(subscriber));
	        });
	        return subscriber;
	    };
	    Observable.prototype._trySubscribe = function (sink) {
	        try {
	            return this._subscribe(sink);
	        }
	        catch (err) {
	            sink.error(err);
	        }
	    };
	    Observable.prototype.forEach = function (next, promiseCtor) {
	        var _this = this;
	        promiseCtor = getPromiseCtor(promiseCtor);
	        return new promiseCtor(function (resolve, reject) {
	            var subscriber = new Subscriber_1.SafeSubscriber({
	                next: function (value) {
	                    try {
	                        next(value);
	                    }
	                    catch (err) {
	                        reject(err);
	                        subscriber.unsubscribe();
	                    }
	                },
	                error: reject,
	                complete: resolve,
	            });
	            _this.subscribe(subscriber);
	        });
	    };
	    Observable.prototype._subscribe = function (subscriber) {
	        var _a;
	        return (_a = this.source) === null || _a === void 0 ? void 0 : _a.subscribe(subscriber);
	    };
	    Observable.prototype[observable_1.observable] = function () {
	        return this;
	    };
	    Observable.prototype.pipe = function () {
	        var operations = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            operations[_i] = arguments[_i];
	        }
	        return pipe_1.pipeFromArray(operations)(this);
	    };
	    Observable.prototype.toPromise = function (promiseCtor) {
	        var _this = this;
	        promiseCtor = getPromiseCtor(promiseCtor);
	        return new promiseCtor(function (resolve, reject) {
	            var value;
	            _this.subscribe(function (x) { return (value = x); }, function (err) { return reject(err); }, function () { return resolve(value); });
	        });
	    };
	    Observable.create = function (subscribe) {
	        return new Observable(subscribe);
	    };
	    return Observable;
	}());
	exports.Observable = Observable;
	function getPromiseCtor(promiseCtor) {
	    var _a;
	    return (_a = promiseCtor !== null && promiseCtor !== void 0 ? promiseCtor : config_1.config.Promise) !== null && _a !== void 0 ? _a : Promise;
	}
	function isObserver(value) {
	    return value && isFunction_1.isFunction(value.next) && isFunction_1.isFunction(value.error) && isFunction_1.isFunction(value.complete);
	}
	function isSubscriber(value) {
	    return (value && value instanceof Subscriber_1.Subscriber) || (isObserver(value) && Subscription_1.isSubscription(value));
	}
	//# sourceMappingURL=Observable.js.map

/***/ },
/* 35 */
/***/ function(module, exports) {

	function _extends() {
	  module.exports = _extends = Object.assign ? Object.assign.bind() : function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	    return target;
	  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
	  return _extends.apply(this, arguments);
	}
	module.exports = _extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 36 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.secondsInMinute = exports.secondsInHour = exports.quartersInYear = exports.monthsInYear = exports.monthsInQuarter = exports.minutesInHour = exports.minTime = exports.millisecondsInSecond = exports.millisecondsInHour = exports.millisecondsInMinute = exports.maxTime = exports.daysInWeek = void 0;
	
	/**
	 * Days in 1 week.
	 *
	 * @name daysInWeek
	 * @constant
	 * @type {number}
	 * @default
	 */
	var daysInWeek = 7;
	/**
	 * Maximum allowed time.
	 *
	 * @name maxTime
	 * @constant
	 * @type {number}
	 * @default
	 */
	
	exports.daysInWeek = daysInWeek;
	var maxTime = Math.pow(10, 8) * 24 * 60 * 60 * 1000;
	/**
	 * Milliseconds in 1 minute
	 *
	 * @name millisecondsInMinute
	 * @constant
	 * @type {number}
	 * @default
	 */
	
	exports.maxTime = maxTime;
	var millisecondsInMinute = 60000;
	/**
	 * Milliseconds in 1 hour
	 *
	 * @name millisecondsInHour
	 * @constant
	 * @type {number}
	 * @default
	 */
	
	exports.millisecondsInMinute = millisecondsInMinute;
	var millisecondsInHour = 3600000;
	/**
	 * Milliseconds in 1 second
	 *
	 * @name millisecondsInSecond
	 * @constant
	 * @type {number}
	 * @default
	 */
	
	exports.millisecondsInHour = millisecondsInHour;
	var millisecondsInSecond = 1000;
	/**
	 * Minimum allowed time.
	 *
	 * @name minTime
	 * @constant
	 * @type {number}
	 * @default
	 */
	
	exports.millisecondsInSecond = millisecondsInSecond;
	var minTime = -maxTime;
	/**
	 * Minutes in 1 hour
	 *
	 * @name minutesInHour
	 * @constant
	 * @type {number}
	 * @default
	 */
	
	exports.minTime = minTime;
	var minutesInHour = 60;
	/**
	 * Months in 1 quarter
	 *
	 * @name monthsInQuarter
	 * @constant
	 * @type {number}
	 * @default
	 */
	
	exports.minutesInHour = minutesInHour;
	var monthsInQuarter = 3;
	/**
	 * Months in 1 year
	 *
	 * @name monthsInYear
	 * @constant
	 * @type {number}
	 * @default
	 */
	
	exports.monthsInQuarter = monthsInQuarter;
	var monthsInYear = 12;
	/**
	 * Quarters in 1 year
	 *
	 * @name quartersInYear
	 * @constant
	 * @type {number}
	 * @default
	 */
	
	exports.monthsInYear = monthsInYear;
	var quartersInYear = 4;
	/**
	 * Seconds in 1 hour
	 *
	 * @name secondsInHour
	 * @constant
	 * @type {number}
	 * @default
	 */
	
	exports.quartersInYear = quartersInYear;
	var secondsInHour = 3600;
	/**
	 * Seconds in 1 minute
	 *
	 * @name secondsInMinute
	 * @constant
	 * @type {number}
	 * @default
	 */
	
	exports.secondsInHour = secondsInHour;
	var secondsInMinute = 60;
	exports.secondsInMinute = secondsInMinute;

/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error(
	        'Minified exception occurred; use the non-minified dev environment ' +
	        'for the full error message and additional helpful warnings.'
	      );
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(
	        format.replace(/%s/g, function() { return args[argIndex++]; })
	      );
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;


/***/ },
/* 38 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(47);
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.utils = void 0;
	
	var _Accordion2 = _interopRequireDefault(__webpack_require__(1776));
	
	exports.Accordion = _Accordion2.default;
	
	var _Alert2 = _interopRequireDefault(__webpack_require__(1777));
	
	exports.Alert = _Alert2.default;
	
	var _Badge2 = _interopRequireDefault(__webpack_require__(1778));
	
	exports.Badge = _Badge2.default;
	
	var _Breadcrumb2 = _interopRequireDefault(__webpack_require__(1779));
	
	exports.Breadcrumb = _Breadcrumb2.default;
	
	var _BreadcrumbItem2 = _interopRequireDefault(__webpack_require__(499));
	
	exports.BreadcrumbItem = _BreadcrumbItem2.default;
	
	var _Button2 = _interopRequireDefault(__webpack_require__(158));
	
	exports.Button = _Button2.default;
	
	var _ButtonGroup2 = _interopRequireDefault(__webpack_require__(305));
	
	exports.ButtonGroup = _ButtonGroup2.default;
	
	var _ButtonToolbar2 = _interopRequireDefault(__webpack_require__(1780));
	
	exports.ButtonToolbar = _ButtonToolbar2.default;
	
	var _Carousel2 = _interopRequireDefault(__webpack_require__(1781));
	
	exports.Carousel = _Carousel2.default;
	
	var _CarouselItem2 = _interopRequireDefault(__webpack_require__(500));
	
	exports.CarouselItem = _CarouselItem2.default;
	
	var _Checkbox2 = _interopRequireDefault(__webpack_require__(1783));
	
	exports.Checkbox = _Checkbox2.default;
	
	var _Clearfix2 = _interopRequireDefault(__webpack_require__(1784));
	
	exports.Clearfix = _Clearfix2.default;
	
	var _CloseButton2 = _interopRequireDefault(__webpack_require__(306));
	
	exports.CloseButton = _CloseButton2.default;
	
	var _ControlLabel2 = _interopRequireDefault(__webpack_require__(1786));
	
	exports.ControlLabel = _ControlLabel2.default;
	
	var _Col2 = _interopRequireDefault(__webpack_require__(1785));
	
	exports.Col = _Col2.default;
	
	var _Collapse2 = _interopRequireDefault(__webpack_require__(307));
	
	exports.Collapse = _Collapse2.default;
	
	var _Dropdown2 = _interopRequireDefault(__webpack_require__(216));
	
	exports.Dropdown = _Dropdown2.default;
	
	var _DropdownButton2 = _interopRequireDefault(__webpack_require__(159));
	
	exports.DropdownButton = _DropdownButton2.default;
	
	var _Fade2 = _interopRequireDefault(__webpack_require__(217));
	
	exports.Fade = _Fade2.default;
	
	var _Form2 = _interopRequireDefault(__webpack_require__(1788));
	
	exports.Form = _Form2.default;
	
	var _FormControl2 = _interopRequireDefault(__webpack_require__(1789));
	
	exports.FormControl = _FormControl2.default;
	
	var _FormGroup2 = _interopRequireDefault(__webpack_require__(1792));
	
	exports.FormGroup = _FormGroup2.default;
	
	var _Glyphicon2 = _interopRequireDefault(__webpack_require__(308));
	
	exports.Glyphicon = _Glyphicon2.default;
	
	var _Grid2 = _interopRequireDefault(__webpack_require__(502));
	
	exports.Grid = _Grid2.default;
	
	var _HelpBlock2 = _interopRequireDefault(__webpack_require__(1793));
	
	exports.HelpBlock = _HelpBlock2.default;
	
	var _Image2 = _interopRequireDefault(__webpack_require__(1794));
	
	exports.Image = _Image2.default;
	
	var _InputGroup2 = _interopRequireDefault(__webpack_require__(1795));
	
	exports.InputGroup = _InputGroup2.default;
	
	var _Jumbotron2 = _interopRequireDefault(__webpack_require__(1798));
	
	exports.Jumbotron = _Jumbotron2.default;
	
	var _Label2 = _interopRequireDefault(__webpack_require__(1799));
	
	exports.Label = _Label2.default;
	
	var _ListGroup2 = _interopRequireDefault(__webpack_require__(1800));
	
	exports.ListGroup = _ListGroup2.default;
	
	var _ListGroupItem2 = _interopRequireDefault(__webpack_require__(503));
	
	exports.ListGroupItem = _ListGroupItem2.default;
	
	var _Media2 = _interopRequireDefault(__webpack_require__(218));
	
	exports.Media = _Media2.default;
	
	var _MenuItem2 = _interopRequireDefault(__webpack_require__(504));
	
	exports.MenuItem = _MenuItem2.default;
	
	var _Modal2 = _interopRequireDefault(__webpack_require__(1807));
	
	exports.Modal = _Modal2.default;
	
	var _ModalBody2 = _interopRequireDefault(__webpack_require__(505));
	
	exports.ModalBody = _ModalBody2.default;
	
	var _ModalDialog2 = _interopRequireDefault(__webpack_require__(506));
	
	exports.ModalDialog = _ModalDialog2.default;
	
	var _ModalFooter2 = _interopRequireDefault(__webpack_require__(507));
	
	exports.ModalFooter = _ModalFooter2.default;
	
	var _ModalHeader2 = _interopRequireDefault(__webpack_require__(508));
	
	exports.ModalHeader = _ModalHeader2.default;
	
	var _ModalTitle2 = _interopRequireDefault(__webpack_require__(509));
	
	exports.ModalTitle = _ModalTitle2.default;
	
	var _Nav2 = _interopRequireDefault(__webpack_require__(510));
	
	exports.Nav = _Nav2.default;
	
	var _Navbar2 = _interopRequireDefault(__webpack_require__(1809));
	
	exports.Navbar = _Navbar2.default;
	
	var _NavbarBrand2 = _interopRequireDefault(__webpack_require__(512));
	
	exports.NavbarBrand = _NavbarBrand2.default;
	
	var _NavDropdown2 = _interopRequireDefault(__webpack_require__(1808));
	
	exports.NavDropdown = _NavDropdown2.default;
	
	var _NavItem2 = _interopRequireDefault(__webpack_require__(511));
	
	exports.NavItem = _NavItem2.default;
	
	var _Overlay2 = _interopRequireDefault(__webpack_require__(513));
	
	exports.Overlay = _Overlay2.default;
	
	var _OverlayTrigger2 = _interopRequireDefault(__webpack_require__(1813));
	
	exports.OverlayTrigger = _OverlayTrigger2.default;
	
	var _PageHeader2 = _interopRequireDefault(__webpack_require__(1814));
	
	exports.PageHeader = _PageHeader2.default;
	
	var _PageItem2 = _interopRequireDefault(__webpack_require__(1815));
	
	exports.PageItem = _PageItem2.default;
	
	var _Pager2 = _interopRequireDefault(__webpack_require__(1816));
	
	exports.Pager = _Pager2.default;
	
	var _Pagination2 = _interopRequireDefault(__webpack_require__(1817));
	
	exports.Pagination = _Pagination2.default;
	
	var _Panel2 = _interopRequireDefault(__webpack_require__(1819));
	
	exports.Panel = _Panel2.default;
	
	var _PanelGroup2 = _interopRequireDefault(__webpack_require__(516));
	
	exports.PanelGroup = _PanelGroup2.default;
	
	var _Popover2 = _interopRequireDefault(__webpack_require__(1824));
	
	exports.Popover = _Popover2.default;
	
	var _ProgressBar2 = _interopRequireDefault(__webpack_require__(1825));
	
	exports.ProgressBar = _ProgressBar2.default;
	
	var _Radio2 = _interopRequireDefault(__webpack_require__(1826));
	
	exports.Radio = _Radio2.default;
	
	var _ResponsiveEmbed2 = _interopRequireDefault(__webpack_require__(1827));
	
	exports.ResponsiveEmbed = _ResponsiveEmbed2.default;
	
	var _Row2 = _interopRequireDefault(__webpack_require__(1828));
	
	exports.Row = _Row2.default;
	
	var _SafeAnchor2 = _interopRequireDefault(__webpack_require__(73));
	
	exports.SafeAnchor = _SafeAnchor2.default;
	
	var _SplitButton2 = _interopRequireDefault(__webpack_require__(1829));
	
	exports.SplitButton = _SplitButton2.default;
	
	var _Tab2 = _interopRequireDefault(__webpack_require__(1831));
	
	exports.Tab = _Tab2.default;
	
	var _TabContainer2 = _interopRequireDefault(__webpack_require__(309));
	
	exports.TabContainer = _TabContainer2.default;
	
	var _TabContent2 = _interopRequireDefault(__webpack_require__(310));
	
	exports.TabContent = _TabContent2.default;
	
	var _Table2 = _interopRequireDefault(__webpack_require__(1832));
	
	exports.Table = _Table2.default;
	
	var _TabPane2 = _interopRequireDefault(__webpack_require__(518));
	
	exports.TabPane = _TabPane2.default;
	
	var _Tabs2 = _interopRequireDefault(__webpack_require__(1833));
	
	exports.Tabs = _Tabs2.default;
	
	var _Thumbnail2 = _interopRequireDefault(__webpack_require__(1834));
	
	exports.Thumbnail = _Thumbnail2.default;
	
	var _ToggleButton2 = _interopRequireDefault(__webpack_require__(519));
	
	exports.ToggleButton = _ToggleButton2.default;
	
	var _ToggleButtonGroup2 = _interopRequireDefault(__webpack_require__(1835));
	
	exports.ToggleButtonGroup = _ToggleButtonGroup2.default;
	
	var _Tooltip2 = _interopRequireDefault(__webpack_require__(1836));
	
	exports.Tooltip = _Tooltip2.default;
	
	var _Well2 = _interopRequireDefault(__webpack_require__(1837));
	
	exports.Well = _Well2.default;
	
	var _utils = _interopRequireWildcard(__webpack_require__(1839));
	
	exports.utils = _utils;

/***/ },
/* 39 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var APP_DEFAULTS = {
	    perPage: 12,
	    ordersPerPage: 5,
	    zoneId: 6,
	    zoneLabel: 'Cuba - La Habana',
	    showCartExpiringMessageAt: [10, 5, 3],
	    extraMinutesOnCheckout: 7,
	    desktopBreakpoint: 768,
	    countryIsoCuba: 'CU',
	    countryIsoUS: 'US',
	    info_email: 'info@cubalicores.com',
	    // IT NEEDS TO BE UPDATED
	    toBeDonatedInfo: {
	        zoneId: 0,
	        address1: 'fake-line-1',
	        address2: 'fake-line-2',
	        city: 'San Miguel del Padrón',
	        country_iso: 'CU',
	        firstname: 'Dummy',
	        lastname: 'Dummy',
	        phone: '555555',
	        state_name: 'DON',
	        zipcode: '11000'
	    },
	    theme: {
	        submenuTitleColor: 'black', // overrides blue
	        desktopItemOpenColor: '#b18433', // overrides #d3af71
	        mobileMenuTitleBottomColor: '#b18433', // overrides red
	        mobileMenuItemColor: 'black', // overrides #d3af71
	        mobileMenuSubitemColor: 'black', // overrides #d3af71
	        localeSelectorColor: '#b18433', // overrides #d3af71
	        mainManeDividerColor: 'black', // overrides silver
	        mainMenuDropdownColor: '#dcccae', // overrides #d3af71
	        cartBadgeBackgroundColor: '#b18433', // overrides #d3af71
	        cartFillColor: '#b18433', // overrides #FE6902
	        clearFilterColor: 'black' // overrides #18396C
	    },
	    modalTimeout: 20000
	};
	
	exports.default = APP_DEFAULTS;

/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _redux = __webpack_require__(163);
	
	var _reactRouterRedux = __webpack_require__(30);
	
	var _reduxThunk = __webpack_require__(2007);
	
	var _reduxThunk2 = _interopRequireDefault(_reduxThunk);
	
	var _reduxLogger = __webpack_require__(2006);
	
	var _reduxLogger2 = _interopRequireDefault(_reduxLogger);
	
	var _browserHistory = __webpack_require__(141);
	
	var _browserHistory2 = _interopRequireDefault(_browserHistory);
	
	var _localStorageApi = __webpack_require__(55);
	
	var _localStorageApi2 = _interopRequireDefault(_localStorageApi);
	
	var _reducers = __webpack_require__(797);
	
	var _reducers2 = _interopRequireDefault(_reducers);
	
	var _listenLogoutActionMiddleware = __webpack_require__(786);
	
	var _listenLogoutActionMiddleware2 = _interopRequireDefault(_listenLogoutActionMiddleware);
	
	var _listenLoginActionMiddleware = __webpack_require__(785);
	
	var _listenLoginActionMiddleware2 = _interopRequireDefault(_listenLoginActionMiddleware);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var spreeStoreVariable = void 0;
	var dataFromLocalStorage = _localStorageApi2.default.load();
	
	var middlewares = [_reduxThunk2.default, _listenLogoutActionMiddleware2.default, _listenLoginActionMiddleware2.default, (0, _reactRouterRedux.routerMiddleware)(_browserHistory2.default)];
	//
	// if (process.env.NODE_ENV === 'development') {
	//     const logger = createLogger();
	//
	//     middlewares.push(logger);
	// }
	
	var middlewareEnhancer = _redux.applyMiddleware.apply(undefined, middlewares);
	
	var enhancers = [middlewareEnhancer];
	var composedEnhancers = _redux.compose.apply(undefined, enhancers);
	
	if (dataFromLocalStorage) {
	    var preloadedState = {
	        order: dataFromLocalStorage.order,
	        user: dataFromLocalStorage.user,
	        auth: dataFromLocalStorage.auth,
	        placedOrder: dataFromLocalStorage.placedOrder,
	        locale: dataFromLocalStorage.locale,
	        stores: _reducers2.default.stores,
	        zones: dataFromLocalStorage.zones,
	        municipalities: dataFromLocalStorage.municipalities,
	        wallets: dataFromLocalStorage.wallets,
	        anonymousUser: dataFromLocalStorage.anonymousUser
	    };
	
	    if (preloadedState && preloadedState.order && preloadedState.order.addingProductToCart) {
	        preloadedState.order.addingProductToCart = false;
	    }
	
	    spreeStoreVariable = (0, _redux.createStore)(_reducers2.default, preloadedState, composedEnhancers);
	} else {
	    spreeStoreVariable = (0, _redux.createStore)(_reducers2.default, {}, composedEnhancers);
	}
	
	var spreeStore = spreeStoreVariable;
	
	exports.default = spreeStore;

/***/ },
/* 41 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(818);


/***/ },
/* 42 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.toastr = exports.reducer = exports.actions = exports["default"] = void 0;
	
	var _ReduxToastr = _interopRequireDefault(__webpack_require__(1869));
	
	var ReduxToastrActions = _interopRequireWildcard(__webpack_require__(528));
	
	var _reducer = _interopRequireDefault(__webpack_require__(529));
	
	var _toastrEmitter = __webpack_require__(530);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var _default = _ReduxToastr["default"];
	exports["default"] = _default;
	var actions = ReduxToastrActions;
	exports.actions = actions;
	var reducer = _reducer["default"];
	exports.reducer = reducer;
	var toastr = _toastrEmitter.toastrEmitter;
	exports.toastr = toastr;

/***/ },
/* 43 */
/***/ function(module, exports) {

	function _objectWithoutPropertiesLoose(source, excluded) {
	  if (source == null) return {};
	  var target = {};
	  var sourceKeys = Object.keys(source);
	  var key, i;
	  for (i = 0; i < sourceKeys.length; i++) {
	    key = sourceKeys[i];
	    if (excluded.indexOf(key) >= 0) continue;
	    target[key] = source[key];
	  }
	  return target;
	}
	module.exports = _objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 44 */
/***/ function(module, exports) {

	var core = module.exports = { version: '2.6.12' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ },
/* 45 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	/**
	 * Safe chained function
	 *
	 * Will only create a new function if needed,
	 * otherwise will pass back existing functions or null.
	 *
	 * @param {function} functions to chain
	 * @returns {function|null}
	 */
	function createChainedFunction() {
	  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  return funcs.filter(function (f) {
	    return f != null;
	  }).reduce(function (acc, f) {
	    if (typeof f !== 'function') {
	      throw new Error('Invalid Argument Type, must only provide functions, undefined, or null.');
	    }
	
	    if (acc === null) {
	      return f;
	    }
	
	    return function chainedFunction() {
	      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	
	      acc.apply(this, args);
	      f.apply(this, args);
	    };
	  }, null);
	}
	
	var _default = createChainedFunction;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function checkDCE() {
	  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
	  if (
	    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
	    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
	  ) {
	    return;
	  }
	  if (false) {
	    // This branch is unreachable because this function is only called
	    // in production, but the condition is true only in development.
	    // Therefore if the branch is still here, dead code elimination wasn't
	    // properly applied.
	    // Don't change the message. React DevTools relies on it. Also make sure
	    // this message doesn't occur elsewhere in this function, or it will cause
	    // a false positive.
	    throw new Error('^_^');
	  }
	  try {
	    // Verify that the code above has been dead code eliminated (DCE'd).
	    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
	  } catch (err) {
	    // DevTools shouldn't crash React, no matter what.
	    // We should still report in case we break this code.
	    console.error(err);
	  }
	}
	
	if (true) {
	  // DCE check should happen before ReactDOM bundle executes so that
	  // DevTools can report bad minification during injection.
	  checkDCE();
	  module.exports = __webpack_require__(1842);
	} else {
	  module.exports = require('./cjs/react-dom.development.js');
	}


/***/ },
/* 47 */
/***/ function(module, exports, __webpack_require__) {

	var _typeof = __webpack_require__(623)["default"];
	
	var _WeakMap = __webpack_require__(621);
	
	var _Object$defineProperty = __webpack_require__(614);
	
	var _Object$getOwnPropertyDescriptor = __webpack_require__(615);
	
	function _getRequireWildcardCache(nodeInterop) {
	  if (typeof _WeakMap !== "function") return null;
	  var cacheBabelInterop = new _WeakMap();
	  var cacheNodeInterop = new _WeakMap();
	  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
	    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
	  })(nodeInterop);
	}
	
	function _interopRequireWildcard(obj, nodeInterop) {
	  if (!nodeInterop && obj && obj.__esModule) {
	    return obj;
	  }
	
	  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return {
	      "default": obj
	    };
	  }
	
	  var cache = _getRequireWildcardCache(nodeInterop);
	
	  if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }
	
	  var newObj = {};
	  var hasPropertyDescriptor = _Object$defineProperty && _Object$getOwnPropertyDescriptor;
	
	  for (var key in obj) {
	    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null;
	
	      if (desc && (desc.get || desc.set)) {
	        _Object$defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }
	
	  newObj["default"] = obj;
	
	  if (cache) {
	    cache.set(obj, newObj);
	  }
	
	  return newObj;
	}
	
	module.exports = _interopRequireWildcard;
	module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ },
/* 48 */
/***/ function(module, exports, __webpack_require__) {

	var _typeof = __webpack_require__(233)["default"];
	function _getRequireWildcardCache(nodeInterop) {
	  if (typeof WeakMap !== "function") return null;
	  var cacheBabelInterop = new WeakMap();
	  var cacheNodeInterop = new WeakMap();
	  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
	    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
	  })(nodeInterop);
	}
	function _interopRequireWildcard(obj, nodeInterop) {
	  if (!nodeInterop && obj && obj.__esModule) {
	    return obj;
	  }
	  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return {
	      "default": obj
	    };
	  }
	  var cache = _getRequireWildcardCache(nodeInterop);
	  if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }
	  var newObj = {};
	  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
	  for (var key in obj) {
	    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
	      if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }
	  newObj["default"] = obj;
	  if (cache) {
	    cache.set(obj, newObj);
	  }
	  return newObj;
	}
	module.exports = _interopRequireWildcard, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 49 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(68);
	var core = __webpack_require__(44);
	var ctx = __webpack_require__(124);
	var hide = __webpack_require__(89);
	var has = __webpack_require__(88);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var IS_WRAP = type & $export.W;
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE];
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
	  var key, own, out;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    if (own && has(exports, key)) continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? ctx(out, global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function (C) {
	      var F = function (a, b, c) {
	        if (this instanceof C) {
	          switch (arguments.length) {
	            case 0: return new C();
	            case 1: return new C(a);
	            case 2: return new C(a, b);
	          } return new C(a, b, c);
	        } return C.apply(this, arguments);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
	    if (IS_PROTO) {
	      (exports.virtual || (exports.virtual = {}))[key] = out;
	      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
	      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
	    }
	  }
	};
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ },
/* 50 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.Style = exports.State = exports.DEVICE_SIZES = exports.SIZE_MAP = exports.Size = void 0;
	var Size = {
	  LARGE: 'large',
	  SMALL: 'small',
	  XSMALL: 'xsmall'
	};
	exports.Size = Size;
	var SIZE_MAP = {
	  large: 'lg',
	  medium: 'md',
	  small: 'sm',
	  xsmall: 'xs',
	  lg: 'lg',
	  md: 'md',
	  sm: 'sm',
	  xs: 'xs'
	};
	exports.SIZE_MAP = SIZE_MAP;
	var DEVICE_SIZES = ['lg', 'md', 'sm', 'xs'];
	exports.DEVICE_SIZES = DEVICE_SIZES;
	var State = {
	  SUCCESS: 'success',
	  WARNING: 'warning',
	  DANGER: 'danger',
	  INFO: 'info'
	};
	exports.State = State;
	var Style = {
	  DEFAULT: 'default',
	  PRIMARY: 'primary',
	  LINK: 'link',
	  INVERSE: 'inverse'
	};
	exports.Style = Style;

/***/ },
/* 51 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        if (typeof b !== "function" && b !== null)
	            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __values = (this && this.__values) || function(o) {
	    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
	    if (m) return m.call(o);
	    if (o && typeof o.length === "number") return {
	        next: function () {
	            if (o && i >= o.length) o = void 0;
	            return { value: o && o[i++], done: !o };
	        }
	    };
	    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.AnonymousSubject = exports.Subject = void 0;
	var Observable_1 = __webpack_require__(34);
	var Subscription_1 = __webpack_require__(62);
	var ObjectUnsubscribedError_1 = __webpack_require__(591);
	var arrRemove_1 = __webpack_require__(99);
	var errorContext_1 = __webpack_require__(336);
	var Subject = (function (_super) {
	    __extends(Subject, _super);
	    function Subject() {
	        var _this = _super.call(this) || this;
	        _this.closed = false;
	        _this.currentObservers = null;
	        _this.observers = [];
	        _this.isStopped = false;
	        _this.hasError = false;
	        _this.thrownError = null;
	        return _this;
	    }
	    Subject.prototype.lift = function (operator) {
	        var subject = new AnonymousSubject(this, this);
	        subject.operator = operator;
	        return subject;
	    };
	    Subject.prototype._throwIfClosed = function () {
	        if (this.closed) {
	            throw new ObjectUnsubscribedError_1.ObjectUnsubscribedError();
	        }
	    };
	    Subject.prototype.next = function (value) {
	        var _this = this;
	        errorContext_1.errorContext(function () {
	            var e_1, _a;
	            _this._throwIfClosed();
	            if (!_this.isStopped) {
	                if (!_this.currentObservers) {
	                    _this.currentObservers = Array.from(_this.observers);
	                }
	                try {
	                    for (var _b = __values(_this.currentObservers), _c = _b.next(); !_c.done; _c = _b.next()) {
	                        var observer = _c.value;
	                        observer.next(value);
	                    }
	                }
	                catch (e_1_1) { e_1 = { error: e_1_1 }; }
	                finally {
	                    try {
	                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
	                    }
	                    finally { if (e_1) throw e_1.error; }
	                }
	            }
	        });
	    };
	    Subject.prototype.error = function (err) {
	        var _this = this;
	        errorContext_1.errorContext(function () {
	            _this._throwIfClosed();
	            if (!_this.isStopped) {
	                _this.hasError = _this.isStopped = true;
	                _this.thrownError = err;
	                var observers = _this.observers;
	                while (observers.length) {
	                    observers.shift().error(err);
	                }
	            }
	        });
	    };
	    Subject.prototype.complete = function () {
	        var _this = this;
	        errorContext_1.errorContext(function () {
	            _this._throwIfClosed();
	            if (!_this.isStopped) {
	                _this.isStopped = true;
	                var observers = _this.observers;
	                while (observers.length) {
	                    observers.shift().complete();
	                }
	            }
	        });
	    };
	    Subject.prototype.unsubscribe = function () {
	        this.isStopped = this.closed = true;
	        this.observers = this.currentObservers = null;
	    };
	    Object.defineProperty(Subject.prototype, "observed", {
	        get: function () {
	            var _a;
	            return ((_a = this.observers) === null || _a === void 0 ? void 0 : _a.length) > 0;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Subject.prototype._trySubscribe = function (subscriber) {
	        this._throwIfClosed();
	        return _super.prototype._trySubscribe.call(this, subscriber);
	    };
	    Subject.prototype._subscribe = function (subscriber) {
	        this._throwIfClosed();
	        this._checkFinalizedStatuses(subscriber);
	        return this._innerSubscribe(subscriber);
	    };
	    Subject.prototype._innerSubscribe = function (subscriber) {
	        var _this = this;
	        var _a = this, hasError = _a.hasError, isStopped = _a.isStopped, observers = _a.observers;
	        if (hasError || isStopped) {
	            return Subscription_1.EMPTY_SUBSCRIPTION;
	        }
	        this.currentObservers = null;
	        observers.push(subscriber);
	        return new Subscription_1.Subscription(function () {
	            _this.currentObservers = null;
	            arrRemove_1.arrRemove(observers, subscriber);
	        });
	    };
	    Subject.prototype._checkFinalizedStatuses = function (subscriber) {
	        var _a = this, hasError = _a.hasError, thrownError = _a.thrownError, isStopped = _a.isStopped;
	        if (hasError) {
	            subscriber.error(thrownError);
	        }
	        else if (isStopped) {
	            subscriber.complete();
	        }
	    };
	    Subject.prototype.asObservable = function () {
	        var observable = new Observable_1.Observable();
	        observable.source = this;
	        return observable;
	    };
	    Subject.create = function (destination, source) {
	        return new AnonymousSubject(destination, source);
	    };
	    return Subject;
	}(Observable_1.Observable));
	exports.Subject = Subject;
	var AnonymousSubject = (function (_super) {
	    __extends(AnonymousSubject, _super);
	    function AnonymousSubject(destination, source) {
	        var _this = _super.call(this) || this;
	        _this.destination = destination;
	        _this.source = source;
	        return _this;
	    }
	    AnonymousSubject.prototype.next = function (value) {
	        var _a, _b;
	        (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.next) === null || _b === void 0 ? void 0 : _b.call(_a, value);
	    };
	    AnonymousSubject.prototype.error = function (err) {
	        var _a, _b;
	        (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.error) === null || _b === void 0 ? void 0 : _b.call(_a, err);
	    };
	    AnonymousSubject.prototype.complete = function () {
	        var _a, _b;
	        (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.complete) === null || _b === void 0 ? void 0 : _b.call(_a);
	    };
	    AnonymousSubject.prototype._subscribe = function (subscriber) {
	        var _a, _b;
	        return (_b = (_a = this.source) === null || _a === void 0 ? void 0 : _a.subscribe(subscriber)) !== null && _b !== void 0 ? _b : Subscription_1.EMPTY_SUBSCRIPTION;
	    };
	    return AnonymousSubject;
	}(Subject));
	exports.AnonymousSubject = AnonymousSubject;
	//# sourceMappingURL=Subject.js.map

/***/ },
/* 52 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.noop = void 0;
	function noop() { }
	exports.noop = noop;
	//# sourceMappingURL=noop.js.map

/***/ },
/* 53 */
/***/ function(module, exports, __webpack_require__) {

	var setPrototypeOf = __webpack_require__(625);
	function _inheritsLoose(subClass, superClass) {
	  subClass.prototype = Object.create(superClass.prototype);
	  subClass.prototype.constructor = subClass;
	  setPrototypeOf(subClass, superClass);
	}
	module.exports = _inheritsLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 54 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var CheckoutStepCalculator = {
	    next: function next(checkoutSteps, currentStep, shouldRedirect) {
	        var indexOfCurrentStep = checkoutSteps.indexOf(currentStep);
	
	        if (CheckoutStepCalculator.isLastStep(checkoutSteps, currentStep)) {
	            return '';
	        }
	
	        if (!shouldRedirect) {
	            return checkoutSteps[indexOfCurrentStep];
	        }
	
	        return checkoutSteps[indexOfCurrentStep + 1];
	    },
	
	    previous: function previous(checkoutSteps, currentStep) {
	        if (CheckoutStepCalculator.isFirstStep(checkoutSteps, currentStep)) {
	            return 'cart';
	        }
	
	        var indexOfCurrentStep = checkoutSteps.indexOf(currentStep);
	        return checkoutSteps[indexOfCurrentStep - 1];
	    },
	
	    isStepEditable: function isStepEditable(checkoutSteps, currentStep, orderState) {
	        var indexOfCurrentStep = checkoutSteps.indexOf(currentStep);
	        var indexOfOrderState = checkoutSteps.indexOf(orderState);
	
	        return !CheckoutStepCalculator.isLastStep(checkoutSteps, orderState) && CheckoutStepCalculator.isValidStep(checkoutSteps, currentStep) && (currentStep === orderState || indexOfCurrentStep <= indexOfOrderState);
	    },
	
	    isLastStep: function isLastStep(checkoutSteps, currentStep) {
	        var indexOfCurrentStep = checkoutSteps.indexOf(currentStep);
	
	        return CheckoutStepCalculator.isValidStep(checkoutSteps, currentStep) && indexOfCurrentStep === checkoutSteps.length - 1;
	    },
	
	    isFirstStep: function isFirstStep(checkoutSteps, currentStep) {
	        var indexOfCurrentStep = checkoutSteps.indexOf(currentStep);
	
	        return indexOfCurrentStep === 0;
	    },
	
	    isValidStep: function isValidStep(checkoutSteps, currentStep) {
	        return checkoutSteps.indexOf(currentStep) !== -1;
	    }
	};
	
	exports.default = CheckoutStepCalculator;

/***/ },
/* 55 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var localStorageAPI = {
	    save: function save(payload) {
	        try {
	            localStorage.setItem('localData', JSON.stringify(payload));
	        } catch (err) {/* Silently ignore */}
	    },
	
	    load: function load() {
	        try {
	            var serializedState = localStorage.getItem('localData');
	
	            if (serializedState == null) {
	                return undefined;
	            }
	
	            return JSON.parse(serializedState);
	        } catch (err) {
	            return undefined;
	        }
	    },
	
	    clear: function clear() {
	        try {
	            localStorage.clear();
	        } catch (err) {/* Silently ignore */}
	    }
	};
	
	exports.default = localStorageAPI;

/***/ },
/* 56 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.identity = void 0;
	function identity(x) {
	    return x;
	}
	exports.identity = identity;
	//# sourceMappingURL=identity.js.map

/***/ },
/* 57 */
/***/ function(module, exports) {

	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return self;
	}
	
	module.exports = _assertThisInitialized;
	module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ },
/* 58 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	// TODO: This module should be ElementChildren, and should use named exports.
	
	/**
	 * Iterates through children that are typically specified as `props.children`,
	 * but only maps over children that are "valid components".
	 *
	 * The mapFunction provided index will be normalised to the components mapped,
	 * so an invalid component would not increase the index.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func.
	 * @param {*} context Context for func.
	 * @return {object} Object containing the ordered map of results.
	 */
	function map(children, func, context) {
	  var index = 0;
	  return _react.default.Children.map(children, function (child) {
	    if (!_react.default.isValidElement(child)) {
	      return child;
	    }
	
	    return func.call(context, child, index++);
	  });
	}
	/**
	 * Iterates through children that are "valid components".
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child with the index reflecting the position relative to "valid components".
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func.
	 * @param {*} context Context for context.
	 */
	
	
	function forEach(children, func, context) {
	  var index = 0;
	
	  _react.default.Children.forEach(children, function (child) {
	    if (!_react.default.isValidElement(child)) {
	      return;
	    }
	
	    func.call(context, child, index++);
	  });
	}
	/**
	 * Count the number of "valid components" in the Children container.
	 *
	 * @param {?*} children Children tree container.
	 * @returns {number}
	 */
	
	
	function count(children) {
	  var result = 0;
	
	  _react.default.Children.forEach(children, function (child) {
	    if (!_react.default.isValidElement(child)) {
	      return;
	    }
	
	    ++result;
	  });
	
	  return result;
	}
	/**
	 * Finds children that are typically specified as `props.children`,
	 * but only iterates over children that are "valid components".
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child with the index reflecting the position relative to "valid components".
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func.
	 * @param {*} context Context for func.
	 * @returns {array} of children that meet the func return statement
	 */
	
	
	function filter(children, func, context) {
	  var index = 0;
	  var result = [];
	
	  _react.default.Children.forEach(children, function (child) {
	    if (!_react.default.isValidElement(child)) {
	      return;
	    }
	
	    if (func.call(context, child, index++)) {
	      result.push(child);
	    }
	  });
	
	  return result;
	}
	
	function find(children, func, context) {
	  var index = 0;
	  var result;
	
	  _react.default.Children.forEach(children, function (child) {
	    if (result) {
	      return;
	    }
	
	    if (!_react.default.isValidElement(child)) {
	      return;
	    }
	
	    if (func.call(context, child, index++)) {
	      result = child;
	    }
	  });
	
	  return result;
	}
	
	function every(children, func, context) {
	  var index = 0;
	  var result = true;
	
	  _react.default.Children.forEach(children, function (child) {
	    if (!result) {
	      return;
	    }
	
	    if (!_react.default.isValidElement(child)) {
	      return;
	    }
	
	    if (!func.call(context, child, index++)) {
	      result = false;
	    }
	  });
	
	  return result;
	}
	
	function some(children, func, context) {
	  var index = 0;
	  var result = false;
	
	  _react.default.Children.forEach(children, function (child) {
	    if (result) {
	      return;
	    }
	
	    if (!_react.default.isValidElement(child)) {
	      return;
	    }
	
	    if (func.call(context, child, index++)) {
	      result = true;
	    }
	  });
	
	  return result;
	}
	
	function toArray(children) {
	  var result = [];
	
	  _react.default.Children.forEach(children, function (child) {
	    if (!_react.default.isValidElement(child)) {
	      return;
	    }
	
	    result.push(child);
	  });
	
	  return result;
	}
	
	var _default = {
	  map: map,
	  forEach: forEach,
	  count: count,
	  find: find,
	  filter: filter,
	  every: every,
	  some: some,
	  toArray: toArray
	};
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 59 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = function() {};
	
	if (false) {
	  warning = function(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error(
	        '`warning(condition, format, ...args)` requires a warning ' +
	        'message argument'
	      );
	    }
	
	    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
	      throw new Error(
	        'The warning format should be able to uniquely identify this ' +
	        'warning. Please, use a more descriptive format than: ' + format
	      );
	    }
	
	    if (!condition) {
	      var argIndex = 0;
	      var message = 'Warning: ' +
	        format.replace(/%s/g, function() {
	          return args[argIndex++];
	        });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch(x) {}
	    }
	  };
	}
	
	module.exports = warning;


/***/ },
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.isVisibleInViewport = exports.isMobile = exports.getClientViewportWidth = exports.getPhone = exports.priceFormat = exports.getParamsFromWindowLocationSearch = exports.getParamsFromStringURL = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.formatCreditCardNumber = formatCreditCardNumber;
	exports.formatCVC = formatCVC;
	exports.formatExpirationDate = formatExpirationDate;
	exports.formatFormData = formatFormData;
	exports.formatMoney = formatMoney;
	
	var _payment = __webpack_require__(497);
	
	var _payment2 = _interopRequireDefault(_payment);
	
	var _appDefaults = __webpack_require__(39);
	
	var _appDefaults2 = _interopRequireDefault(_appDefaults);
	
	var _constants = __webpack_require__(363);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Get the URL parameters
	 * source: https://css-tricks.com/snippets/javascript/get-url-variables/
	 * @param  {String} url The URL
	 * @return {Object}     The URL parameters
	 */
	var getParamsFromStringURL = function getParamsFromStringURL(url) {
	    var params = {};
	
	    var parser = document.createElement('a');
	    parser.href = url;
	
	    var query = parser.search.substring(1);
	    var vars = query.split('&');
	
	    // eslint-disable-next-line no-plusplus
	    for (var i = 0; i < vars.length; i++) {
	        var pair = vars[i].split('=');
	        params[pair[0]] = decodeURIComponent(pair[1]);
	    }
	
	    return params;
	};
	
	/**
	 * Get the query parameters from window location search
	 * @return {Map}     The query parameters
	 */
	var getParamsFromWindowLocationSearch = function getParamsFromWindowLocationSearch() {
	    var params = {};
	
	    var query = new URLSearchParams(window.location.search);
	
	    // eslint-disable-next-line no-restricted-syntax
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	        for (var _iterator = query.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var _ref3 = _step.value;
	
	            var _ref2 = _slicedToArray(_ref3, 2);
	
	            var param0 = _ref2[0];
	            var param1 = _ref2[1];
	
	            params[param0] = param1;
	        }
	    } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	    } finally {
	        try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	                _iterator.return();
	            }
	        } finally {
	            if (_didIteratorError) {
	                throw _iteratorError;
	            }
	        }
	    }
	
	    return params;
	};
	
	var priceFormat = new Intl.NumberFormat('en-US', {
	    style: 'currency',
	    currency: 'USD'
	
	    // These options are needed to round to whole numbers if that's what you want.
	    // minimumFractionDigits: 0,
	    // maximumFractionDigits: 0,
	});
	
	var getPhone = function getPhone(value) {
	    var withMask = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	    if (value) {
	        if (withMask) {
	            return _constants.PHONE_PREFIX + ' ' + value.substring(0, 4) + ' ' + value.substring(4);
	        }
	        return '' + _constants.PHONE_PREFIX + value;
	    }
	    return '';
	};
	
	// Credit Cards formatters
	function clearNumber() {
	    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	    return value.replace(/\D+/g, '');
	}
	
	var getClientViewportWidth = function getClientViewportWidth() {
	    return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
	};
	
	var isMobile = function isMobile() {
	    return getClientViewportWidth() < _appDefaults2.default.desktopBreakpoint;
	};
	
	var isVisibleInViewport = function isVisibleInViewport(elem) {
	    var rect = elem.getBoundingClientRect();
	    return rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && rect.right <= (window.innerWidth || document.documentElement.clientWidth);
	};
	
	function formatCreditCardNumber(value) {
	    if (!value) {
	        return value;
	    }
	    var issuer = _payment2.default.fns.cardType(value);
	    var clearValue = clearNumber(value);
	    var nextValue = void 0;
	    switch (issuer) {
	        case 'amex':
	            nextValue = clearValue.slice(0, 4) + ' ' + clearValue.slice(4, 10) + ' ' + clearValue.slice(10, 15);
	            break;
	        case 'dinersclub':
	            nextValue = clearValue.slice(0, 4) + ' ' + clearValue.slice(4, 10) + ' ' + clearValue.slice(10, 14);
	            break;
	        default:
	            nextValue = clearValue.slice(0, 4) + ' ' + clearValue.slice(4, 8) + ' ' + clearValue.slice(8, 12) + ' ' + clearValue.slice(12, 19);
	            break;
	    }
	    return nextValue.trim();
	}
	function formatCVC(value) {
	    var allValues = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    var clearValue = clearNumber(value);
	    var maxLength = 4;
	    if (allValues.number) {
	        var issuer = _payment2.default.fns.cardType(allValues.number);
	        maxLength = issuer === 'amex' ? 4 : 3;
	    }
	    return clearValue.slice(0, maxLength);
	}
	function formatExpirationDate(value) {
	    var clearValue = clearNumber(value);
	    if (clearValue.length >= 3) {
	        if (parseInt(clearValue.slice(0, 2), 10) > 12) {
	            return '0' + clearValue.slice(0, 1) + '/' + clearValue.slice(1, 3);
	        }
	        return clearValue.slice(0, 2) + '/' + clearValue.slice(2, 4);
	    }
	    return clearValue;
	}
	function formatFormData(data) {
	    return Object.keys(data).map(function (d) {
	        return d + ': ' + data[d];
	    });
	}
	function formatMoney(value) {
	    return value ? value.replace(/[^.\d]/g, '') : value;
	}
	
	exports.getParamsFromStringURL = getParamsFromStringURL;
	exports.getParamsFromWindowLocationSearch = getParamsFromWindowLocationSearch;
	exports.priceFormat = priceFormat;
	exports.getPhone = getPhone;
	exports.getClientViewportWidth = getClientViewportWidth;
	exports.isMobile = isMobile;
	exports.isVisibleInViewport = isVisibleInViewport;

/***/ },
/* 61 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(48);
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports.updateSyncErrors = exports.updateSyncWarnings = exports.untouch = exports.unregisterField = exports.touch = exports.submit = exports.stopSubmit = exports.stopAsyncValidation = exports.startSubmit = exports.startAsyncValidation = exports.setSubmitSucceeded = exports.setSubmitFailed = exports.resetSection = exports.reset = exports.registerField = exports.initialize = exports.focus = exports.destroy = exports.clearSubmitErrors = exports.clearSubmit = exports.clearFields = exports.clearAsyncError = exports.change = exports.blur = exports.autofill = exports.arrayUnshift = exports.arraySwap = exports.arraySplice = exports.arrayShift = exports.arrayRemoveAll = exports.arrayRemove = exports.arrayPush = exports.arrayPop = exports.arrayMove = exports.arrayInsert = exports.formPropTypes = exports.fieldArrayPropTypes = exports.fieldArrayMetaPropTypes = exports.fieldArrayFieldsPropTypes = exports.fieldPropTypes = exports.fieldMetaPropTypes = exports.fieldInputPropTypes = exports.SubmissionError = exports.ReduxFormContext = exports.values = exports.reducer = exports.reduxForm = exports.hasSubmitFailed = exports.hasSubmitSucceeded = exports.isSubmitting = exports.isValid = exports.isPristine = exports.isInvalid = exports.isDirty = exports.isAsyncValidating = exports.getFormSubmitErrors = exports.getFormSyncWarnings = exports.getFormAsyncErrors = exports.getFormMeta = exports.getFormSyncErrors = exports.getFormInitialValues = exports.getFormValues = exports.getFormNames = exports.getFormError = exports.formValues = exports.formValueSelector = exports.FieldArray = exports.Fields = exports.Field = exports.propTypes = exports.FormSection = exports.FormName = exports.Form = exports.defaultShouldWarn = exports.defaultShouldError = exports.defaultShouldValidate = exports.defaultShouldAsyncValidate = exports.actionTypes = void 0;
	
	var _actions = _interopRequireDefault(__webpack_require__(547));
	
	var _actionTypes = _interopRequireDefault(__webpack_require__(321));
	
	exports.actionTypes = _actionTypes["default"];
	
	var _ReduxFormContext = __webpack_require__(85);
	
	exports.ReduxFormContext = _ReduxFormContext.ReduxFormContext;
	
	var _defaultShouldAsyncValidate = _interopRequireDefault(__webpack_require__(549));
	
	exports.defaultShouldAsyncValidate = _defaultShouldAsyncValidate["default"];
	
	var _defaultShouldValidate = _interopRequireDefault(__webpack_require__(551));
	
	exports.defaultShouldValidate = _defaultShouldValidate["default"];
	
	var _defaultShouldError = _interopRequireDefault(__webpack_require__(550));
	
	exports.defaultShouldError = _defaultShouldError["default"];
	
	var _defaultShouldWarn = _interopRequireDefault(__webpack_require__(552));
	
	exports.defaultShouldWarn = _defaultShouldWarn["default"];
	
	var _Form = _interopRequireDefault(__webpack_require__(1936));
	
	exports.Form = _Form["default"];
	
	var _FormName = _interopRequireDefault(__webpack_require__(1937));
	
	exports.FormName = _FormName["default"];
	
	var _FormSection = _interopRequireDefault(__webpack_require__(1938));
	
	exports.FormSection = _FormSection["default"];
	
	var _SubmissionError = __webpack_require__(546);
	
	exports.SubmissionError = _SubmissionError.SubmissionError;
	
	var _propTypes = _interopRequireWildcard(__webpack_require__(1974));
	
	exports.propTypes = _propTypes["default"];
	exports.fieldInputPropTypes = _propTypes.fieldInputPropTypes;
	exports.fieldMetaPropTypes = _propTypes.fieldMetaPropTypes;
	exports.fieldPropTypes = _propTypes.fieldPropTypes;
	exports.fieldArrayFieldsPropTypes = _propTypes.fieldArrayFieldsPropTypes;
	exports.fieldArrayMetaPropTypes = _propTypes.fieldArrayMetaPropTypes;
	exports.fieldArrayPropTypes = _propTypes.fieldArrayPropTypes;
	exports.formPropTypes = _propTypes.formPropTypes;
	
	var _Field = _interopRequireDefault(__webpack_require__(1933));
	
	exports.Field = _Field["default"];
	
	var _Fields = _interopRequireDefault(__webpack_require__(1935));
	
	exports.Fields = _Fields["default"];
	
	var _FieldArray = _interopRequireDefault(__webpack_require__(1934));
	
	exports.FieldArray = _FieldArray["default"];
	
	var _formValueSelector = _interopRequireDefault(__webpack_require__(1952));
	
	exports.formValueSelector = _formValueSelector["default"];
	
	var _formValues = _interopRequireDefault(__webpack_require__(1953));
	
	exports.formValues = _formValues["default"];
	
	var _getFormError = _interopRequireDefault(__webpack_require__(1956));
	
	exports.getFormError = _getFormError["default"];
	
	var _getFormNames = _interopRequireDefault(__webpack_require__(1959));
	
	exports.getFormNames = _getFormNames["default"];
	
	var _getFormValues = _interopRequireDefault(__webpack_require__(1963));
	
	exports.getFormValues = _getFormValues["default"];
	
	var _getFormInitialValues = _interopRequireDefault(__webpack_require__(1957));
	
	exports.getFormInitialValues = _getFormInitialValues["default"];
	
	var _getFormSyncErrors = _interopRequireDefault(__webpack_require__(1961));
	
	exports.getFormSyncErrors = _getFormSyncErrors["default"];
	
	var _getFormMeta = _interopRequireDefault(__webpack_require__(1958));
	
	exports.getFormMeta = _getFormMeta["default"];
	
	var _getFormAsyncErrors = _interopRequireDefault(__webpack_require__(1955));
	
	exports.getFormAsyncErrors = _getFormAsyncErrors["default"];
	
	var _getFormSyncWarnings = _interopRequireDefault(__webpack_require__(1962));
	
	exports.getFormSyncWarnings = _getFormSyncWarnings["default"];
	
	var _getFormSubmitErrors = _interopRequireDefault(__webpack_require__(1960));
	
	exports.getFormSubmitErrors = _getFormSubmitErrors["default"];
	
	var _isAsyncValidating = _interopRequireDefault(__webpack_require__(1968));
	
	exports.isAsyncValidating = _isAsyncValidating["default"];
	
	var _isDirty = _interopRequireDefault(__webpack_require__(1969));
	
	exports.isDirty = _isDirty["default"];
	
	var _isInvalid = _interopRequireDefault(__webpack_require__(1970));
	
	exports.isInvalid = _isInvalid["default"];
	
	var _isPristine = _interopRequireDefault(__webpack_require__(1971));
	
	exports.isPristine = _isPristine["default"];
	
	var _isValid = _interopRequireDefault(__webpack_require__(1973));
	
	exports.isValid = _isValid["default"];
	
	var _isSubmitting = _interopRequireDefault(__webpack_require__(1972));
	
	exports.isSubmitting = _isSubmitting["default"];
	
	var _hasSubmitSucceeded = _interopRequireDefault(__webpack_require__(1967));
	
	exports.hasSubmitSucceeded = _hasSubmitSucceeded["default"];
	
	var _hasSubmitFailed = _interopRequireDefault(__webpack_require__(1966));
	
	exports.hasSubmitFailed = _hasSubmitFailed["default"];
	
	var _reduxForm = _interopRequireDefault(__webpack_require__(1976));
	
	exports.reduxForm = _reduxForm["default"];
	
	var _reducer = _interopRequireDefault(__webpack_require__(1975));
	
	exports.reducer = _reducer["default"];
	
	var _values = _interopRequireDefault(__webpack_require__(2001));
	
	exports.values = _values["default"];
	// alias for propTypes
	var arrayInsert = _actions["default"].arrayInsert;
	exports.arrayInsert = arrayInsert;
	var arrayMove = _actions["default"].arrayMove;
	exports.arrayMove = arrayMove;
	var arrayPop = _actions["default"].arrayPop;
	exports.arrayPop = arrayPop;
	var arrayPush = _actions["default"].arrayPush;
	exports.arrayPush = arrayPush;
	var arrayRemove = _actions["default"].arrayRemove;
	exports.arrayRemove = arrayRemove;
	var arrayRemoveAll = _actions["default"].arrayRemoveAll;
	exports.arrayRemoveAll = arrayRemoveAll;
	var arrayShift = _actions["default"].arrayShift;
	exports.arrayShift = arrayShift;
	var arraySplice = _actions["default"].arraySplice;
	exports.arraySplice = arraySplice;
	var arraySwap = _actions["default"].arraySwap;
	exports.arraySwap = arraySwap;
	var arrayUnshift = _actions["default"].arrayUnshift;
	exports.arrayUnshift = arrayUnshift;
	var autofill = _actions["default"].autofill;
	exports.autofill = autofill;
	var blur = _actions["default"].blur;
	exports.blur = blur;
	var change = _actions["default"].change;
	exports.change = change;
	var clearAsyncError = _actions["default"].clearAsyncError;
	exports.clearAsyncError = clearAsyncError;
	var clearFields = _actions["default"].clearFields;
	exports.clearFields = clearFields;
	var clearSubmit = _actions["default"].clearSubmit;
	exports.clearSubmit = clearSubmit;
	var clearSubmitErrors = _actions["default"].clearSubmitErrors;
	exports.clearSubmitErrors = clearSubmitErrors;
	var destroy = _actions["default"].destroy;
	exports.destroy = destroy;
	var focus = _actions["default"].focus;
	exports.focus = focus;
	var initialize = _actions["default"].initialize;
	exports.initialize = initialize;
	var registerField = _actions["default"].registerField;
	exports.registerField = registerField;
	var reset = _actions["default"].reset;
	exports.reset = reset;
	var resetSection = _actions["default"].resetSection;
	exports.resetSection = resetSection;
	var setSubmitFailed = _actions["default"].setSubmitFailed;
	exports.setSubmitFailed = setSubmitFailed;
	var setSubmitSucceeded = _actions["default"].setSubmitSucceeded;
	exports.setSubmitSucceeded = setSubmitSucceeded;
	var startAsyncValidation = _actions["default"].startAsyncValidation;
	exports.startAsyncValidation = startAsyncValidation;
	var startSubmit = _actions["default"].startSubmit;
	exports.startSubmit = startSubmit;
	var stopAsyncValidation = _actions["default"].stopAsyncValidation;
	exports.stopAsyncValidation = stopAsyncValidation;
	var stopSubmit = _actions["default"].stopSubmit;
	exports.stopSubmit = stopSubmit;
	var submit = _actions["default"].submit;
	exports.submit = submit;
	var touch = _actions["default"].touch;
	exports.touch = touch;
	var unregisterField = _actions["default"].unregisterField;
	exports.unregisterField = unregisterField;
	var untouch = _actions["default"].untouch;
	exports.untouch = untouch;
	var updateSyncWarnings = _actions["default"].updateSyncWarnings;
	exports.updateSyncWarnings = updateSyncWarnings;
	var updateSyncErrors = _actions["default"].updateSyncErrors;
	exports.updateSyncErrors = updateSyncErrors;

/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __values = (this && this.__values) || function(o) {
	    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
	    if (m) return m.call(o);
	    if (o && typeof o.length === "number") return {
	        next: function () {
	            if (o && i >= o.length) o = void 0;
	            return { value: o && o[i++], done: !o };
	        }
	    };
	    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
	};
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	var __spreadArray = (this && this.__spreadArray) || function (to, from) {
	    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
	        to[j] = from[i];
	    return to;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.isSubscription = exports.EMPTY_SUBSCRIPTION = exports.Subscription = void 0;
	var isFunction_1 = __webpack_require__(31);
	var UnsubscriptionError_1 = __webpack_require__(593);
	var arrRemove_1 = __webpack_require__(99);
	var Subscription = (function () {
	    function Subscription(initialTeardown) {
	        this.initialTeardown = initialTeardown;
	        this.closed = false;
	        this._parentage = null;
	        this._finalizers = null;
	    }
	    Subscription.prototype.unsubscribe = function () {
	        var e_1, _a, e_2, _b;
	        var errors;
	        if (!this.closed) {
	            this.closed = true;
	            var _parentage = this._parentage;
	            if (_parentage) {
	                this._parentage = null;
	                if (Array.isArray(_parentage)) {
	                    try {
	                        for (var _parentage_1 = __values(_parentage), _parentage_1_1 = _parentage_1.next(); !_parentage_1_1.done; _parentage_1_1 = _parentage_1.next()) {
	                            var parent_1 = _parentage_1_1.value;
	                            parent_1.remove(this);
	                        }
	                    }
	                    catch (e_1_1) { e_1 = { error: e_1_1 }; }
	                    finally {
	                        try {
	                            if (_parentage_1_1 && !_parentage_1_1.done && (_a = _parentage_1.return)) _a.call(_parentage_1);
	                        }
	                        finally { if (e_1) throw e_1.error; }
	                    }
	                }
	                else {
	                    _parentage.remove(this);
	                }
	            }
	            var initialFinalizer = this.initialTeardown;
	            if (isFunction_1.isFunction(initialFinalizer)) {
	                try {
	                    initialFinalizer();
	                }
	                catch (e) {
	                    errors = e instanceof UnsubscriptionError_1.UnsubscriptionError ? e.errors : [e];
	                }
	            }
	            var _finalizers = this._finalizers;
	            if (_finalizers) {
	                this._finalizers = null;
	                try {
	                    for (var _finalizers_1 = __values(_finalizers), _finalizers_1_1 = _finalizers_1.next(); !_finalizers_1_1.done; _finalizers_1_1 = _finalizers_1.next()) {
	                        var finalizer = _finalizers_1_1.value;
	                        try {
	                            execFinalizer(finalizer);
	                        }
	                        catch (err) {
	                            errors = errors !== null && errors !== void 0 ? errors : [];
	                            if (err instanceof UnsubscriptionError_1.UnsubscriptionError) {
	                                errors = __spreadArray(__spreadArray([], __read(errors)), __read(err.errors));
	                            }
	                            else {
	                                errors.push(err);
	                            }
	                        }
	                    }
	                }
	                catch (e_2_1) { e_2 = { error: e_2_1 }; }
	                finally {
	                    try {
	                        if (_finalizers_1_1 && !_finalizers_1_1.done && (_b = _finalizers_1.return)) _b.call(_finalizers_1);
	                    }
	                    finally { if (e_2) throw e_2.error; }
	                }
	            }
	            if (errors) {
	                throw new UnsubscriptionError_1.UnsubscriptionError(errors);
	            }
	        }
	    };
	    Subscription.prototype.add = function (teardown) {
	        var _a;
	        if (teardown && teardown !== this) {
	            if (this.closed) {
	                execFinalizer(teardown);
	            }
	            else {
	                if (teardown instanceof Subscription) {
	                    if (teardown.closed || teardown._hasParent(this)) {
	                        return;
	                    }
	                    teardown._addParent(this);
	                }
	                (this._finalizers = (_a = this._finalizers) !== null && _a !== void 0 ? _a : []).push(teardown);
	            }
	        }
	    };
	    Subscription.prototype._hasParent = function (parent) {
	        var _parentage = this._parentage;
	        return _parentage === parent || (Array.isArray(_parentage) && _parentage.includes(parent));
	    };
	    Subscription.prototype._addParent = function (parent) {
	        var _parentage = this._parentage;
	        this._parentage = Array.isArray(_parentage) ? (_parentage.push(parent), _parentage) : _parentage ? [_parentage, parent] : parent;
	    };
	    Subscription.prototype._removeParent = function (parent) {
	        var _parentage = this._parentage;
	        if (_parentage === parent) {
	            this._parentage = null;
	        }
	        else if (Array.isArray(_parentage)) {
	            arrRemove_1.arrRemove(_parentage, parent);
	        }
	    };
	    Subscription.prototype.remove = function (teardown) {
	        var _finalizers = this._finalizers;
	        _finalizers && arrRemove_1.arrRemove(_finalizers, teardown);
	        if (teardown instanceof Subscription) {
	            teardown._removeParent(this);
	        }
	    };
	    Subscription.EMPTY = (function () {
	        var empty = new Subscription();
	        empty.closed = true;
	        return empty;
	    })();
	    return Subscription;
	}());
	exports.Subscription = Subscription;
	exports.EMPTY_SUBSCRIPTION = Subscription.EMPTY;
	function isSubscription(value) {
	    return (value instanceof Subscription ||
	        (value && 'closed' in value && isFunction_1.isFunction(value.remove) && isFunction_1.isFunction(value.add) && isFunction_1.isFunction(value.unsubscribe)));
	}
	exports.isSubscription = isSubscription;
	function execFinalizer(finalizer) {
	    if (isFunction_1.isFunction(finalizer)) {
	        finalizer();
	    }
	    else {
	        finalizer.unsubscribe();
	    }
	}
	//# sourceMappingURL=Subscription.js.map

/***/ },
/* 63 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.async = exports.asyncScheduler = void 0;
	var AsyncAction_1 = __webpack_require__(168);
	var AsyncScheduler_1 = __webpack_require__(169);
	exports.asyncScheduler = new AsyncScheduler_1.AsyncScheduler(AsyncAction_1.AsyncAction);
	exports.async = exports.asyncScheduler;
	//# sourceMappingURL=async.js.map

/***/ },
/* 64 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.popNumber = exports.popScheduler = exports.popResultSelector = void 0;
	var isFunction_1 = __webpack_require__(31);
	var isScheduler_1 = __webpack_require__(231);
	function last(arr) {
	    return arr[arr.length - 1];
	}
	function popResultSelector(args) {
	    return isFunction_1.isFunction(last(args)) ? args.pop() : undefined;
	}
	exports.popResultSelector = popResultSelector;
	function popScheduler(args) {
	    return isScheduler_1.isScheduler(last(args)) ? args.pop() : undefined;
	}
	exports.popScheduler = popScheduler;
	function popNumber(args, defaultValue) {
	    return typeof last(args) === 'number' ? args.pop() : defaultValue;
	}
	exports.popNumber = popNumber;
	//# sourceMappingURL=args.js.map

/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactLoading = __webpack_require__(1853);
	
	var _reactLoading2 = _interopRequireDefault(_reactLoading);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Loader = function (_Component) {
	    _inherits(Loader, _Component);
	
	    function Loader() {
	        _classCallCheck(this, Loader);
	
	        return _possibleConstructorReturn(this, (Loader.__proto__ || Object.getPrototypeOf(Loader)).apply(this, arguments));
	    }
	
	    _createClass(Loader, [{
	        key: 'render',
	        value: function render() {
	            var loaderDiv = null;
	
	            if (this.props.displayLoader) {
	                loaderDiv = _react2.default.createElement(_reactLoading2.default, { type: 'spin', color: '#555', height: this.props.size ? this.props.size : 30, width: this.props.size ? this.props.size : 30 });
	            }
	
	            return loaderDiv;
	        }
	    }]);
	
	    return Loader;
	}(_react.Component);
	
	exports.default = Loader;

/***/ },
/* 66 */
[2199, 1900, 1901, 1902, 538, 316, 1903, 1904, 539, 317, 1905],
/* 67 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Root reference for iframes.
	 */
	
	var root;
	if (typeof window !== 'undefined') { // Browser window
	  root = window;
	} else if (typeof self !== 'undefined') { // Web Worker
	  root = self;
	} else { // Other environments
	  console.warn("Using browser-only version of superagent in non-browser environment");
	  root = this;
	}
	
	var Emitter = __webpack_require__(822);
	var requestBase = __webpack_require__(2174);
	var isObject = __webpack_require__(605);
	
	/**
	 * Noop.
	 */
	
	function noop(){};
	
	/**
	 * Expose `request`.
	 */
	
	var request = module.exports = __webpack_require__(2175).bind(null, Request);
	
	/**
	 * Determine XHR.
	 */
	
	request.getXHR = function () {
	  if (root.XMLHttpRequest
	      && (!root.location || 'file:' != root.location.protocol
	          || !root.ActiveXObject)) {
	    return new XMLHttpRequest;
	  } else {
	    try { return new ActiveXObject('Microsoft.XMLHTTP'); } catch(e) {}
	    try { return new ActiveXObject('Msxml2.XMLHTTP.6.0'); } catch(e) {}
	    try { return new ActiveXObject('Msxml2.XMLHTTP.3.0'); } catch(e) {}
	    try { return new ActiveXObject('Msxml2.XMLHTTP'); } catch(e) {}
	  }
	  throw Error("Browser-only verison of superagent could not find XHR");
	};
	
	/**
	 * Removes leading and trailing whitespace, added to support IE.
	 *
	 * @param {String} s
	 * @return {String}
	 * @api private
	 */
	
	var trim = ''.trim
	  ? function(s) { return s.trim(); }
	  : function(s) { return s.replace(/(^\s*|\s*$)/g, ''); };
	
	/**
	 * Serialize the given `obj`.
	 *
	 * @param {Object} obj
	 * @return {String}
	 * @api private
	 */
	
	function serialize(obj) {
	  if (!isObject(obj)) return obj;
	  var pairs = [];
	  for (var key in obj) {
	    pushEncodedKeyValuePair(pairs, key, obj[key]);
	  }
	  return pairs.join('&');
	}
	
	/**
	 * Helps 'serialize' with serializing arrays.
	 * Mutates the pairs array.
	 *
	 * @param {Array} pairs
	 * @param {String} key
	 * @param {Mixed} val
	 */
	
	function pushEncodedKeyValuePair(pairs, key, val) {
	  if (val != null) {
	    if (Array.isArray(val)) {
	      val.forEach(function(v) {
	        pushEncodedKeyValuePair(pairs, key, v);
	      });
	    } else if (isObject(val)) {
	      for(var subkey in val) {
	        pushEncodedKeyValuePair(pairs, key + '[' + subkey + ']', val[subkey]);
	      }
	    } else {
	      pairs.push(encodeURIComponent(key)
	        + '=' + encodeURIComponent(val));
	    }
	  } else if (val === null) {
	    pairs.push(encodeURIComponent(key));
	  }
	}
	
	/**
	 * Expose serialization method.
	 */
	
	 request.serializeObject = serialize;
	
	 /**
	  * Parse the given x-www-form-urlencoded `str`.
	  *
	  * @param {String} str
	  * @return {Object}
	  * @api private
	  */
	
	function parseString(str) {
	  var obj = {};
	  var pairs = str.split('&');
	  var pair;
	  var pos;
	
	  for (var i = 0, len = pairs.length; i < len; ++i) {
	    pair = pairs[i];
	    pos = pair.indexOf('=');
	    if (pos == -1) {
	      obj[decodeURIComponent(pair)] = '';
	    } else {
	      obj[decodeURIComponent(pair.slice(0, pos))] =
	        decodeURIComponent(pair.slice(pos + 1));
	    }
	  }
	
	  return obj;
	}
	
	/**
	 * Expose parser.
	 */
	
	request.parseString = parseString;
	
	/**
	 * Default MIME type map.
	 *
	 *     superagent.types.xml = 'application/xml';
	 *
	 */
	
	request.types = {
	  html: 'text/html',
	  json: 'application/json',
	  xml: 'application/xml',
	  urlencoded: 'application/x-www-form-urlencoded',
	  'form': 'application/x-www-form-urlencoded',
	  'form-data': 'application/x-www-form-urlencoded'
	};
	
	/**
	 * Default serialization map.
	 *
	 *     superagent.serialize['application/xml'] = function(obj){
	 *       return 'generated xml here';
	 *     };
	 *
	 */
	
	 request.serialize = {
	   'application/x-www-form-urlencoded': serialize,
	   'application/json': JSON.stringify
	 };
	
	 /**
	  * Default parsers.
	  *
	  *     superagent.parse['application/xml'] = function(str){
	  *       return { object parsed from str };
	  *     };
	  *
	  */
	
	request.parse = {
	  'application/x-www-form-urlencoded': parseString,
	  'application/json': JSON.parse
	};
	
	/**
	 * Parse the given header `str` into
	 * an object containing the mapped fields.
	 *
	 * @param {String} str
	 * @return {Object}
	 * @api private
	 */
	
	function parseHeader(str) {
	  var lines = str.split(/\r?\n/);
	  var fields = {};
	  var index;
	  var line;
	  var field;
	  var val;
	
	  lines.pop(); // trailing CRLF
	
	  for (var i = 0, len = lines.length; i < len; ++i) {
	    line = lines[i];
	    index = line.indexOf(':');
	    field = line.slice(0, index).toLowerCase();
	    val = trim(line.slice(index + 1));
	    fields[field] = val;
	  }
	
	  return fields;
	}
	
	/**
	 * Check if `mime` is json or has +json structured syntax suffix.
	 *
	 * @param {String} mime
	 * @return {Boolean}
	 * @api private
	 */
	
	function isJSON(mime) {
	  return /[\/+]json\b/.test(mime);
	}
	
	/**
	 * Return the mime type for the given `str`.
	 *
	 * @param {String} str
	 * @return {String}
	 * @api private
	 */
	
	function type(str){
	  return str.split(/ *; */).shift();
	};
	
	/**
	 * Return header field parameters.
	 *
	 * @param {String} str
	 * @return {Object}
	 * @api private
	 */
	
	function params(str){
	  return str.split(/ *; */).reduce(function(obj, str){
	    var parts = str.split(/ *= */),
	        key = parts.shift(),
	        val = parts.shift();
	
	    if (key && val) obj[key] = val;
	    return obj;
	  }, {});
	};
	
	/**
	 * Initialize a new `Response` with the given `xhr`.
	 *
	 *  - set flags (.ok, .error, etc)
	 *  - parse header
	 *
	 * Examples:
	 *
	 *  Aliasing `superagent` as `request` is nice:
	 *
	 *      request = superagent;
	 *
	 *  We can use the promise-like API, or pass callbacks:
	 *
	 *      request.get('/').end(function(res){});
	 *      request.get('/', function(res){});
	 *
	 *  Sending data can be chained:
	 *
	 *      request
	 *        .post('/user')
	 *        .send({ name: 'tj' })
	 *        .end(function(res){});
	 *
	 *  Or passed to `.send()`:
	 *
	 *      request
	 *        .post('/user')
	 *        .send({ name: 'tj' }, function(res){});
	 *
	 *  Or passed to `.post()`:
	 *
	 *      request
	 *        .post('/user', { name: 'tj' })
	 *        .end(function(res){});
	 *
	 * Or further reduced to a single call for simple cases:
	 *
	 *      request
	 *        .post('/user', { name: 'tj' }, function(res){});
	 *
	 * @param {XMLHTTPRequest} xhr
	 * @param {Object} options
	 * @api private
	 */
	
	function Response(req, options) {
	  options = options || {};
	  this.req = req;
	  this.xhr = this.req.xhr;
	  // responseText is accessible only if responseType is '' or 'text' and on older browsers
	  this.text = ((this.req.method !='HEAD' && (this.xhr.responseType === '' || this.xhr.responseType === 'text')) || typeof this.xhr.responseType === 'undefined')
	     ? this.xhr.responseText
	     : null;
	  this.statusText = this.req.xhr.statusText;
	  this._setStatusProperties(this.xhr.status);
	  this.header = this.headers = parseHeader(this.xhr.getAllResponseHeaders());
	  // getAllResponseHeaders sometimes falsely returns "" for CORS requests, but
	  // getResponseHeader still works. so we get content-type even if getting
	  // other headers fails.
	  this.header['content-type'] = this.xhr.getResponseHeader('content-type');
	  this._setHeaderProperties(this.header);
	  this.body = this.req.method != 'HEAD'
	    ? this._parseBody(this.text ? this.text : this.xhr.response)
	    : null;
	}
	
	/**
	 * Get case-insensitive `field` value.
	 *
	 * @param {String} field
	 * @return {String}
	 * @api public
	 */
	
	Response.prototype.get = function(field){
	  return this.header[field.toLowerCase()];
	};
	
	/**
	 * Set header related properties:
	 *
	 *   - `.type` the content type without params
	 *
	 * A response of "Content-Type: text/plain; charset=utf-8"
	 * will provide you with a `.type` of "text/plain".
	 *
	 * @param {Object} header
	 * @api private
	 */
	
	Response.prototype._setHeaderProperties = function(header){
	  // content-type
	  var ct = this.header['content-type'] || '';
	  this.type = type(ct);
	
	  // params
	  var obj = params(ct);
	  for (var key in obj) this[key] = obj[key];
	};
	
	/**
	 * Parse the given body `str`.
	 *
	 * Used for auto-parsing of bodies. Parsers
	 * are defined on the `superagent.parse` object.
	 *
	 * @param {String} str
	 * @return {Mixed}
	 * @api private
	 */
	
	Response.prototype._parseBody = function(str){
	  var parse = request.parse[this.type];
	  if (!parse && isJSON(this.type)) {
	    parse = request.parse['application/json'];
	  }
	  return parse && str && (str.length || str instanceof Object)
	    ? parse(str)
	    : null;
	};
	
	/**
	 * Set flags such as `.ok` based on `status`.
	 *
	 * For example a 2xx response will give you a `.ok` of __true__
	 * whereas 5xx will be __false__ and `.error` will be __true__. The
	 * `.clientError` and `.serverError` are also available to be more
	 * specific, and `.statusType` is the class of error ranging from 1..5
	 * sometimes useful for mapping respond colors etc.
	 *
	 * "sugar" properties are also defined for common cases. Currently providing:
	 *
	 *   - .noContent
	 *   - .badRequest
	 *   - .unauthorized
	 *   - .notAcceptable
	 *   - .notFound
	 *
	 * @param {Number} status
	 * @api private
	 */
	
	Response.prototype._setStatusProperties = function(status){
	  // handle IE9 bug: http://stackoverflow.com/questions/10046972/msie-returns-status-code-of-1223-for-ajax-request
	  if (status === 1223) {
	    status = 204;
	  }
	
	  var type = status / 100 | 0;
	
	  // status / class
	  this.status = this.statusCode = status;
	  this.statusType = type;
	
	  // basics
	  this.info = 1 == type;
	  this.ok = 2 == type;
	  this.clientError = 4 == type;
	  this.serverError = 5 == type;
	  this.error = (4 == type || 5 == type)
	    ? this.toError()
	    : false;
	
	  // sugar
	  this.accepted = 202 == status;
	  this.noContent = 204 == status;
	  this.badRequest = 400 == status;
	  this.unauthorized = 401 == status;
	  this.notAcceptable = 406 == status;
	  this.notFound = 404 == status;
	  this.forbidden = 403 == status;
	};
	
	/**
	 * Return an `Error` representative of this response.
	 *
	 * @return {Error}
	 * @api public
	 */
	
	Response.prototype.toError = function(){
	  var req = this.req;
	  var method = req.method;
	  var url = req.url;
	
	  var msg = 'cannot ' + method + ' ' + url + ' (' + this.status + ')';
	  var err = new Error(msg);
	  err.status = this.status;
	  err.method = method;
	  err.url = url;
	
	  return err;
	};
	
	/**
	 * Expose `Response`.
	 */
	
	request.Response = Response;
	
	/**
	 * Initialize a new `Request` with the given `method` and `url`.
	 *
	 * @param {String} method
	 * @param {String} url
	 * @api public
	 */
	
	function Request(method, url) {
	  var self = this;
	  this._query = this._query || [];
	  this.method = method;
	  this.url = url;
	  this.header = {}; // preserves header name case
	  this._header = {}; // coerces header names to lowercase
	  this.on('end', function(){
	    var err = null;
	    var res = null;
	
	    try {
	      res = new Response(self);
	    } catch(e) {
	      err = new Error('Parser is unable to parse the response');
	      err.parse = true;
	      err.original = e;
	      // issue #675: return the raw response if the response parsing fails
	      err.rawResponse = self.xhr && self.xhr.responseText ? self.xhr.responseText : null;
	      // issue #876: return the http status code if the response parsing fails
	      err.statusCode = self.xhr && self.xhr.status ? self.xhr.status : null;
	      return self.callback(err);
	    }
	
	    self.emit('response', res);
	
	    var new_err;
	    try {
	      if (res.status < 200 || res.status >= 300) {
	        new_err = new Error(res.statusText || 'Unsuccessful HTTP response');
	        new_err.original = err;
	        new_err.response = res;
	        new_err.status = res.status;
	      }
	    } catch(e) {
	      new_err = e; // #985 touching res may cause INVALID_STATE_ERR on old Android
	    }
	
	    // #1000 don't catch errors from the callback to avoid double calling it
	    if (new_err) {
	      self.callback(new_err, res);
	    } else {
	      self.callback(null, res);
	    }
	  });
	}
	
	/**
	 * Mixin `Emitter` and `requestBase`.
	 */
	
	Emitter(Request.prototype);
	for (var key in requestBase) {
	  Request.prototype[key] = requestBase[key];
	}
	
	/**
	 * Set Content-Type to `type`, mapping values from `request.types`.
	 *
	 * Examples:
	 *
	 *      superagent.types.xml = 'application/xml';
	 *
	 *      request.post('/')
	 *        .type('xml')
	 *        .send(xmlstring)
	 *        .end(callback);
	 *
	 *      request.post('/')
	 *        .type('application/xml')
	 *        .send(xmlstring)
	 *        .end(callback);
	 *
	 * @param {String} type
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.type = function(type){
	  this.set('Content-Type', request.types[type] || type);
	  return this;
	};
	
	/**
	 * Set responseType to `val`. Presently valid responseTypes are 'blob' and
	 * 'arraybuffer'.
	 *
	 * Examples:
	 *
	 *      req.get('/')
	 *        .responseType('blob')
	 *        .end(callback);
	 *
	 * @param {String} val
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.responseType = function(val){
	  this._responseType = val;
	  return this;
	};
	
	/**
	 * Set Accept to `type`, mapping values from `request.types`.
	 *
	 * Examples:
	 *
	 *      superagent.types.json = 'application/json';
	 *
	 *      request.get('/agent')
	 *        .accept('json')
	 *        .end(callback);
	 *
	 *      request.get('/agent')
	 *        .accept('application/json')
	 *        .end(callback);
	 *
	 * @param {String} accept
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.accept = function(type){
	  this.set('Accept', request.types[type] || type);
	  return this;
	};
	
	/**
	 * Set Authorization field value with `user` and `pass`.
	 *
	 * @param {String} user
	 * @param {String} pass
	 * @param {Object} options with 'type' property 'auto' or 'basic' (default 'basic')
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.auth = function(user, pass, options){
	  if (!options) {
	    options = {
	      type: 'basic'
	    }
	  }
	
	  switch (options.type) {
	    case 'basic':
	      var str = btoa(user + ':' + pass);
	      this.set('Authorization', 'Basic ' + str);
	    break;
	
	    case 'auto':
	      this.username = user;
	      this.password = pass;
	    break;
	  }
	  return this;
	};
	
	/**
	* Add query-string `val`.
	*
	* Examples:
	*
	*   request.get('/shoes')
	*     .query('size=10')
	*     .query({ color: 'blue' })
	*
	* @param {Object|String} val
	* @return {Request} for chaining
	* @api public
	*/
	
	Request.prototype.query = function(val){
	  if ('string' != typeof val) val = serialize(val);
	  if (val) this._query.push(val);
	  return this;
	};
	
	/**
	 * Queue the given `file` as an attachment to the specified `field`,
	 * with optional `filename`.
	 *
	 * ``` js
	 * request.post('/upload')
	 *   .attach('content', new Blob(['<a id="a"><b id="b">hey!</b></a>'], { type: "text/html"}))
	 *   .end(callback);
	 * ```
	 *
	 * @param {String} field
	 * @param {Blob|File} file
	 * @param {String} filename
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.attach = function(field, file, filename){
	  this._getFormData().append(field, file, filename || file.name);
	  return this;
	};
	
	Request.prototype._getFormData = function(){
	  if (!this._formData) {
	    this._formData = new root.FormData();
	  }
	  return this._formData;
	};
	
	/**
	 * Invoke the callback with `err` and `res`
	 * and handle arity check.
	 *
	 * @param {Error} err
	 * @param {Response} res
	 * @api private
	 */
	
	Request.prototype.callback = function(err, res){
	  var fn = this._callback;
	  this.clearTimeout();
	  fn(err, res);
	};
	
	/**
	 * Invoke callback with x-domain error.
	 *
	 * @api private
	 */
	
	Request.prototype.crossDomainError = function(){
	  var err = new Error('Request has been terminated\nPossible causes: the network is offline, Origin is not allowed by Access-Control-Allow-Origin, the page is being unloaded, etc.');
	  err.crossDomain = true;
	
	  err.status = this.status;
	  err.method = this.method;
	  err.url = this.url;
	
	  this.callback(err);
	};
	
	/**
	 * Invoke callback with timeout error.
	 *
	 * @api private
	 */
	
	Request.prototype._timeoutError = function(){
	  var timeout = this._timeout;
	  var err = new Error('timeout of ' + timeout + 'ms exceeded');
	  err.timeout = timeout;
	  this.callback(err);
	};
	
	/**
	 * Compose querystring to append to req.url
	 *
	 * @api private
	 */
	
	Request.prototype._appendQueryString = function(){
	  var query = this._query.join('&');
	  if (query) {
	    this.url += ~this.url.indexOf('?')
	      ? '&' + query
	      : '?' + query;
	  }
	};
	
	/**
	 * Initiate request, invoking callback `fn(res)`
	 * with an instanceof `Response`.
	 *
	 * @param {Function} fn
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.end = function(fn){
	  var self = this;
	  var xhr = this.xhr = request.getXHR();
	  var timeout = this._timeout;
	  var data = this._formData || this._data;
	
	  // store callback
	  this._callback = fn || noop;
	
	  // state change
	  xhr.onreadystatechange = function(){
	    if (4 != xhr.readyState) return;
	
	    // In IE9, reads to any property (e.g. status) off of an aborted XHR will
	    // result in the error "Could not complete the operation due to error c00c023f"
	    var status;
	    try { status = xhr.status } catch(e) { status = 0; }
	
	    if (0 == status) {
	      if (self.timedout) return self._timeoutError();
	      if (self._aborted) return;
	      return self.crossDomainError();
	    }
	    self.emit('end');
	  };
	
	  // progress
	  var handleProgress = function(direction, e) {
	    if (e.total > 0) {
	      e.percent = e.loaded / e.total * 100;
	    }
	    e.direction = direction;
	    self.emit('progress', e);
	  }
	  if (this.hasListeners('progress')) {
	    try {
	      xhr.onprogress = handleProgress.bind(null, 'download');
	      if (xhr.upload) {
	        xhr.upload.onprogress = handleProgress.bind(null, 'upload');
	      }
	    } catch(e) {
	      // Accessing xhr.upload fails in IE from a web worker, so just pretend it doesn't exist.
	      // Reported here:
	      // https://connect.microsoft.com/IE/feedback/details/837245/xmlhttprequest-upload-throws-invalid-argument-when-used-from-web-worker-context
	    }
	  }
	
	  // timeout
	  if (timeout && !this._timer) {
	    this._timer = setTimeout(function(){
	      self.timedout = true;
	      self.abort();
	    }, timeout);
	  }
	
	  // querystring
	  this._appendQueryString();
	
	  // initiate request
	  if (this.username && this.password) {
	    xhr.open(this.method, this.url, true, this.username, this.password);
	  } else {
	    xhr.open(this.method, this.url, true);
	  }
	
	  // CORS
	  if (this._withCredentials) xhr.withCredentials = true;
	
	  // body
	  if ('GET' != this.method && 'HEAD' != this.method && 'string' != typeof data && !this._isHost(data)) {
	    // serialize stuff
	    var contentType = this._header['content-type'];
	    var serialize = this._serializer || request.serialize[contentType ? contentType.split(';')[0] : ''];
	    if (!serialize && isJSON(contentType)) serialize = request.serialize['application/json'];
	    if (serialize) data = serialize(data);
	  }
	
	  // set header fields
	  for (var field in this.header) {
	    if (null == this.header[field]) continue;
	    xhr.setRequestHeader(field, this.header[field]);
	  }
	
	  if (this._responseType) {
	    xhr.responseType = this._responseType;
	  }
	
	  // send stuff
	  this.emit('request', this);
	
	  // IE11 xhr.send(undefined) sends 'undefined' string as POST payload (instead of nothing)
	  // We need null here if data is undefined
	  xhr.send(typeof data !== 'undefined' ? data : null);
	  return this;
	};
	
	
	/**
	 * Expose `Request`.
	 */
	
	request.Request = Request;
	
	/**
	 * GET `url` with optional callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed|Function} [data] or fn
	 * @param {Function} [fn]
	 * @return {Request}
	 * @api public
	 */
	
	request.get = function(url, data, fn){
	  var req = request('GET', url);
	  if ('function' == typeof data) fn = data, data = null;
	  if (data) req.query(data);
	  if (fn) req.end(fn);
	  return req;
	};
	
	/**
	 * HEAD `url` with optional callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed|Function} [data] or fn
	 * @param {Function} [fn]
	 * @return {Request}
	 * @api public
	 */
	
	request.head = function(url, data, fn){
	  var req = request('HEAD', url);
	  if ('function' == typeof data) fn = data, data = null;
	  if (data) req.send(data);
	  if (fn) req.end(fn);
	  return req;
	};
	
	/**
	 * OPTIONS query to `url` with optional callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed|Function} [data] or fn
	 * @param {Function} [fn]
	 * @return {Request}
	 * @api public
	 */
	
	request.options = function(url, data, fn){
	  var req = request('OPTIONS', url);
	  if ('function' == typeof data) fn = data, data = null;
	  if (data) req.send(data);
	  if (fn) req.end(fn);
	  return req;
	};
	
	/**
	 * DELETE `url` with optional callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Function} [fn]
	 * @return {Request}
	 * @api public
	 */
	
	function del(url, fn){
	  var req = request('DELETE', url);
	  if (fn) req.end(fn);
	  return req;
	};
	
	request['del'] = del;
	request['delete'] = del;
	
	/**
	 * PATCH `url` with optional `data` and callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed} [data]
	 * @param {Function} [fn]
	 * @return {Request}
	 * @api public
	 */
	
	request.patch = function(url, data, fn){
	  var req = request('PATCH', url);
	  if ('function' == typeof data) fn = data, data = null;
	  if (data) req.send(data);
	  if (fn) req.end(fn);
	  return req;
	};
	
	/**
	 * POST `url` with optional `data` and callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed} [data]
	 * @param {Function} [fn]
	 * @return {Request}
	 * @api public
	 */
	
	request.post = function(url, data, fn){
	  var req = request('POST', url);
	  if ('function' == typeof data) fn = data, data = null;
	  if (data) req.send(data);
	  if (fn) req.end(fn);
	  return req;
	};
	
	/**
	 * PUT `url` with optional `data` and callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed|Function} [data] or fn
	 * @param {Function} [fn]
	 * @return {Request}
	 * @api public
	 */
	
	request.put = function(url, data, fn){
	  var req = request('PUT', url);
	  if ('function' == typeof data) fn = data, data = null;
	  if (data) req.send(data);
	  if (fn) req.end(fn);
	  return req;
	};


/***/ },
/* 68 */
/***/ function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ },
/* 69 */
/***/ function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ },
/* 70 */
/***/ function(module, exports, __webpack_require__) {

	var store = __webpack_require__(262)('wks');
	var uid = __webpack_require__(187);
	var Symbol = __webpack_require__(68).Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;


/***/ },
/* 71 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isSameUTCWeek;
	
	var _index = _interopRequireDefault(__webpack_require__(2));
	
	var _index2 = _interopRequireDefault(__webpack_require__(148));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// This function will be a part of public API when UTC function will be implemented.
	// See issue: https://github.com/date-fns/date-fns/issues/376
	function isSameUTCWeek(dirtyDateLeft, dirtyDateRight, options) {
	  (0, _index.default)(2, arguments);
	  var dateLeftStartOfWeek = (0, _index2.default)(dirtyDateLeft, options);
	  var dateRightStartOfWeek = (0, _index2.default)(dirtyDateRight, options);
	  return dateLeftStartOfWeek.getTime() === dateRightStartOfWeek.getTime();
	}
	
	module.exports = exports.default;

/***/ },
/* 72 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	module.exports = isArray;


/***/ },
/* 73 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(8));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(57));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _elementType = _interopRequireDefault(__webpack_require__(32));
	
	var _createChainedFunction = _interopRequireDefault(__webpack_require__(45));
	
	var propTypes = {
	  href: _propTypes.default.string,
	  onClick: _propTypes.default.func,
	  onKeyDown: _propTypes.default.func,
	  disabled: _propTypes.default.bool,
	  role: _propTypes.default.string,
	  tabIndex: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	
	  /**
	   * this is sort of silly but needed for Button
	   */
	  componentClass: _elementType.default
	};
	var defaultProps = {
	  componentClass: 'a'
	};
	
	function isTrivialHref(href) {
	  return !href || href.trim() === '#';
	}
	/**
	 * There are situations due to browser quirks or Bootstrap CSS where
	 * an anchor tag is needed, when semantically a button tag is the
	 * better choice. SafeAnchor ensures that when an anchor is used like a
	 * button its accessible. It also emulates input `disabled` behavior for
	 * links, which is usually desirable for Buttons, NavItems, MenuItems, etc.
	 */
	
	
	var SafeAnchor =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(SafeAnchor, _React$Component);
	
	  function SafeAnchor(props, context) {
	    var _this;
	
	    _this = _React$Component.call(this, props, context) || this;
	    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
	    _this.handleKeyDown = _this.handleKeyDown.bind((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
	    return _this;
	  }
	
	  var _proto = SafeAnchor.prototype;
	
	  _proto.handleClick = function handleClick(event) {
	    var _this$props = this.props,
	        disabled = _this$props.disabled,
	        href = _this$props.href,
	        onClick = _this$props.onClick;
	
	    if (disabled || isTrivialHref(href)) {
	      event.preventDefault();
	    }
	
	    if (disabled) {
	      event.stopPropagation();
	      return;
	    }
	
	    if (onClick) {
	      onClick(event);
	    }
	  };
	
	  _proto.handleKeyDown = function handleKeyDown(event) {
	    if (event.key === ' ') {
	      event.preventDefault();
	      this.handleClick(event);
	    }
	  };
	
	  _proto.render = function render() {
	    var _this$props2 = this.props,
	        Component = _this$props2.componentClass,
	        disabled = _this$props2.disabled,
	        onKeyDown = _this$props2.onKeyDown,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props2, ["componentClass", "disabled", "onKeyDown"]);
	
	    if (isTrivialHref(props.href)) {
	      props.role = props.role || 'button'; // we want to make sure there is a href attribute on the node
	      // otherwise, the cursor incorrectly styled (except with role='button')
	
	      props.href = props.href || '#';
	    }
	
	    if (disabled) {
	      props.tabIndex = -1;
	      props.style = (0, _extends2.default)({
	        pointerEvents: 'none'
	      }, props.style);
	    }
	
	    return _react.default.createElement(Component, (0, _extends2.default)({}, props, {
	      onClick: this.handleClick,
	      onKeyDown: (0, _createChainedFunction.default)(this.handleKeyDown, onKeyDown)
	    }));
	  };
	
	  return SafeAnchor;
	}(_react.default.Component);
	
	SafeAnchor.propTypes = propTypes;
	SafeAnchor.defaultProps = defaultProps;
	var _default = SafeAnchor;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 74 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.empty = exports.EMPTY = void 0;
	var Observable_1 = __webpack_require__(34);
	exports.EMPTY = new Observable_1.Observable(function (subscriber) { return subscriber.complete(); });
	function empty(scheduler) {
	    return scheduler ? emptyScheduled(scheduler) : exports.EMPTY;
	}
	exports.empty = empty;
	function emptyScheduled(scheduler) {
	    return new Observable_1.Observable(function (subscriber) { return scheduler.schedule(function () { return subscriber.complete(); }); });
	}
	//# sourceMappingURL=empty.js.map

/***/ },
/* 75 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(11);
	
	var _reactRouterDom = __webpack_require__(26);
	
	var _appRoutes = __webpack_require__(22);
	
	var _appRoutes2 = _interopRequireDefault(_appRoutes);
	
	var _signupPromotion = __webpack_require__(2153);
	
	var _signupPromotion2 = _interopRequireDefault(_signupPromotion);
	
	var _browserHistory = __webpack_require__(141);
	
	var _browserHistory2 = _interopRequireDefault(_browserHistory);
	
	var _userSignupConnector = __webpack_require__(367);
	
	var _userSignupConnector2 = _interopRequireDefault(_userSignupConnector);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SignupPromotion = function (_Component) {
	    _inherits(SignupPromotion, _Component);
	
	    function SignupPromotion() {
	        _classCallCheck(this, SignupPromotion);
	
	        return _possibleConstructorReturn(this, (SignupPromotion.__proto__ || Object.getPrototypeOf(SignupPromotion)).apply(this, arguments));
	    }
	
	    _createClass(SignupPromotion, [{
	        key: 'render',
	        value: function render() {
	            return !(this.props.user && this.props.user.id) && ("false") !== 'true' && _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: _signupPromotion2.default.promotionContainer },
	                    _react2.default.createElement(
	                        'div',
	                        { className: _signupPromotion2.default.signupPromotion },
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            _react2.default.createElement(
	                                'span',
	                                { className: 'hidden-xs' },
	                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'signup-for', defaultMessage: 'Sign Up' })
	                            ),
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'for-the-best-experience', defaultMessage: 'for the best experience' })
	                            ),
	                            _react2.default.createElement(
	                                'span',
	                                { className: 'hidden-xs' },
	                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'in-katapulk', defaultMessage: 'in the Store' })
	                            ),
	                            _react2.default.createElement(
	                                _reactRouterDom.Link,
	                                { to: _appRoutes2.default.signup, className: 'button-highlight font-vegur font-size-medium-small text-uppercase ' + _signupPromotion2.default.buttonHighlight },
	                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'signup', defaultMessage: 'Sign Up' })
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return SignupPromotion;
	}(_react.Component);
	
	exports.default = SignupPromotion;

/***/ },
/* 76 */
/***/ function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(87)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ },
/* 77 */
/***/ function(module, exports, __webpack_require__) {

	var freeGlobal = __webpack_require__(484);
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	module.exports = root;


/***/ },
/* 78 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.from = void 0;
	var scheduled_1 = __webpack_require__(585);
	var innerFrom_1 = __webpack_require__(28);
	function from(input, scheduler) {
	    return scheduler ? scheduled_1.scheduled(input, scheduler) : innerFrom_1.innerFrom(input);
	}
	exports.from = from;
	//# sourceMappingURL=from.js.map

/***/ },
/* 79 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _appDefaults = __webpack_require__(39);
	
	var _appDefaults2 = _interopRequireDefault(_appDefaults);
	
	var _store = __webpack_require__(40);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ZoneService = {
	    getNameCurrentZone: function getNameCurrentZone(availableZones, currentZone) {
	        var sanitizedZone = (availableZones || []).find(function (z) {
	            return z.id === currentZone;
	        });
	        return sanitizedZone ? sanitizedZone.name : 'Cuba - La Habana';
	    },
	    isDonationZone: function isDonationZone() {
	        var state = _store2.default.getState();
	        return state.configs.donation.zone === state.zones.currentZone;
	    },
	    isCurrentZoneCuba: function isCurrentZoneCuba() {
	        var state = _store2.default.getState();
	        var currentZone = state.zones.availableZones.find(function (zone) {
	            return zone.id === state.zones.currentZone;
	        });
	        if (currentZone === undefined) {
	            throw new Error('Current zone id not found in available zones');
	        }
	        return currentZone.countries_iso.indexOf(_appDefaults2.default.countryIsoCuba) > -1;
	    }
	};
	
	exports.default = ZoneService;

/***/ },
/* 80 */
/***/ function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(86);
	var IE8_DOM_DEFINE = __webpack_require__(376);
	var toPrimitive = __webpack_require__(264);
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__(76) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ },
/* 81 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getTimezoneOffsetInMilliseconds;
	
	/**
	 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
	 * They usually appear for dates that denote time before the timezones were introduced
	 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
	 * and GMT+01:00:00 after that date)
	 *
	 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
	 * which would lead to incorrect calculations.
	 *
	 * This function returns the timezone offset in milliseconds that takes seconds in account.
	 */
	function getTimezoneOffsetInMilliseconds(date) {
	  var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
	  utcDate.setUTCFullYear(date.getFullYear());
	  return date.getTime() - utcDate.getTime();
	}
	
	module.exports = exports.default;

/***/ },
/* 82 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addDays;
	
	var _index = _interopRequireDefault(__webpack_require__(19));
	
	var _index2 = _interopRequireDefault(__webpack_require__(3));
	
	var _index3 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name addDays
	 * @category Day Helpers
	 * @summary Add the specified number of days to the given date.
	 *
	 * @description
	 * Add the specified number of days to the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of days to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} - the new date with the days added
	 * @throws {TypeError} - 2 arguments required
	 *
	 * @example
	 * // Add 10 days to 1 September 2014:
	 * const result = addDays(new Date(2014, 8, 1), 10)
	 * //=> Thu Sep 11 2014 00:00:00
	 */
	function addDays(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var amount = (0, _index.default)(dirtyAmount);
	
	  if (isNaN(amount)) {
	    return new Date(NaN);
	  }
	
	  if (!amount) {
	    // If 0 days, no-op to avoid changing times in the hour before end of DST
	    return date;
	  }
	
	  date.setDate(date.getDate() + amount);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 83 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isValid;
	
	var _index = _interopRequireDefault(__webpack_require__(425));
	
	var _index2 = _interopRequireDefault(__webpack_require__(3));
	
	var _index3 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isValid
	 * @category Common Helpers
	 * @summary Is the given date valid?
	 *
	 * @description
	 * Returns false if argument is Invalid Date and true otherwise.
	 * Argument is converted to Date using `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
	 * Invalid Date is a Date, whose time value is NaN.
	 *
	 * Time value of Date: http://es5.github.io/#x15.9.1.1
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * - Now `isValid` doesn't throw an exception
	 *   if the first argument is not an instance of Date.
	 *   Instead, argument is converted beforehand using `toDate`.
	 *
	 *   Examples:
	 *
	 *   | `isValid` argument        | Before v2.0.0 | v2.0.0 onward |
	 *   |---------------------------|---------------|---------------|
	 *   | `new Date()`              | `true`        | `true`        |
	 *   | `new Date('2016-01-01')`  | `true`        | `true`        |
	 *   | `new Date('')`            | `false`       | `false`       |
	 *   | `new Date(1488370835081)` | `true`        | `true`        |
	 *   | `new Date(NaN)`           | `false`       | `false`       |
	 *   | `'2016-01-01'`            | `TypeError`   | `false`       |
	 *   | `''`                      | `TypeError`   | `false`       |
	 *   | `1488370835081`           | `TypeError`   | `true`        |
	 *   | `NaN`                     | `TypeError`   | `false`       |
	 *
	 *   We introduce this change to make *date-fns* consistent with ECMAScript behavior
	 *   that try to coerce arguments to the expected type
	 *   (which is also the case with other *date-fns* functions).
	 *
	 * @param {*} date - the date to check
	 * @returns {Boolean} the date is valid
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // For the valid date:
	 * const result = isValid(new Date(2014, 1, 31))
	 * //=> true
	 *
	 * @example
	 * // For the value, convertable into a date:
	 * const result = isValid(1393804800000)
	 * //=> true
	 *
	 * @example
	 * // For the invalid date:
	 * const result = isValid(new Date(''))
	 * //=> false
	 */
	function isValid(dirtyDate) {
	  (0, _index3.default)(1, arguments);
	
	  if (!(0, _index.default)(dirtyDate) && typeof dirtyDate !== 'number') {
	    return false;
	  }
	
	  var date = (0, _index2.default)(dirtyDate);
	  return !isNaN(Number(date));
	}
	
	module.exports = exports.default;

/***/ },
/* 84 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 85 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(48);
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports.withReduxForm = exports.renderChildren = exports.ReduxFormContext = void 0;
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(53));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(35));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(43));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var ReduxFormContext = React.createContext(null);
	exports.ReduxFormContext = ReduxFormContext;
	
	var renderChildren = function renderChildren(Component, _ref) {
	  var forwardedRef = _ref.forwardedRef,
	      rest = (0, _objectWithoutPropertiesLoose2["default"])(_ref, ["forwardedRef"]);
	  return function (_reduxForm) {
	    return React.createElement(Component, (0, _extends2["default"])({}, rest, {
	      _reduxForm: _reduxForm,
	      ref: forwardedRef
	    }));
	  };
	};
	
	exports.renderChildren = renderChildren;
	
	var withReduxForm = function withReduxForm(Component) {
	  var Hoc = /*#__PURE__*/function (_React$Component) {
	    (0, _inheritsLoose2["default"])(Hoc, _React$Component);
	
	    function Hoc() {
	      return _React$Component.apply(this, arguments) || this;
	    }
	
	    var _proto = Hoc.prototype;
	
	    _proto.render = function render() {
	      return React.createElement(ReduxFormContext.Consumer, {
	        children: renderChildren(Component, this.props)
	      });
	    };
	
	    return Hoc;
	  }(React.Component);
	
	  var ref = React.forwardRef(function (props, ref) {
	    return React.createElement(Hoc, (0, _extends2["default"])({}, props, {
	      forwardedRef: ref
	    }));
	  });
	  ref.displayName = Component.displayName || Component.name || 'Component';
	  return ref;
	};
	
	exports.withReduxForm = withReduxForm;

/***/ },
/* 86 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(69);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ },
/* 87 */
/***/ function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ },
/* 88 */
/***/ function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ },
/* 89 */
/***/ function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(80);
	var createDesc = __webpack_require__(146);
	module.exports = __webpack_require__(76) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ },
/* 90 */
/***/ function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(255);
	var defined = __webpack_require__(182);
	module.exports = function (it) {
	  return IObject(defined(it));
	};


/***/ },
/* 91 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var formatRelativeLocale = {
	  lastWeek: "'last' eeee 'at' p",
	  yesterday: "'yesterday at' p",
	  today: "'today at' p",
	  tomorrow: "'tomorrow at' p",
	  nextWeek: "eeee 'at' p",
	  other: 'P'
	};
	
	var formatRelative = function (token, _date, _baseDate, _options) {
	  return formatRelativeLocale[token];
	};
	
	var _default = formatRelative;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 92 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eraValues = {
	  narrow: ['B', 'A'],
	  abbreviated: ['BC', 'AD'],
	  wide: ['Before Christ', 'Anno Domini']
	};
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
	  wide: ['1st quarter', '2nd quarter', '3rd quarter', '4th quarter']
	}; // Note: in English, the names of days of the week and months are capitalized.
	// If you are making a new locale based on this one, check if the same is true for the language you're working on.
	// Generally, formatted dates should look like they are in the middle of a sentence,
	// e.g. in Spanish language the weekdays and months should be in the lowercase.
	
	var monthValues = {
	  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
	  abbreviated: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
	  wide: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
	};
	var dayValues = {
	  narrow: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
	  short: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
	  abbreviated: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
	  wide: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
	};
	var dayPeriodValues = {
	  narrow: {
	    am: 'a',
	    pm: 'p',
	    midnight: 'mi',
	    noon: 'n',
	    morning: 'morning',
	    afternoon: 'afternoon',
	    evening: 'evening',
	    night: 'night'
	  },
	  abbreviated: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'midnight',
	    noon: 'noon',
	    morning: 'morning',
	    afternoon: 'afternoon',
	    evening: 'evening',
	    night: 'night'
	  },
	  wide: {
	    am: 'a.m.',
	    pm: 'p.m.',
	    midnight: 'midnight',
	    noon: 'noon',
	    morning: 'morning',
	    afternoon: 'afternoon',
	    evening: 'evening',
	    night: 'night'
	  }
	};
	var formattingDayPeriodValues = {
	  narrow: {
	    am: 'a',
	    pm: 'p',
	    midnight: 'mi',
	    noon: 'n',
	    morning: 'in the morning',
	    afternoon: 'in the afternoon',
	    evening: 'in the evening',
	    night: 'at night'
	  },
	  abbreviated: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'midnight',
	    noon: 'noon',
	    morning: 'in the morning',
	    afternoon: 'in the afternoon',
	    evening: 'in the evening',
	    night: 'at night'
	  },
	  wide: {
	    am: 'a.m.',
	    pm: 'p.m.',
	    midnight: 'midnight',
	    noon: 'noon',
	    morning: 'in the morning',
	    afternoon: 'in the afternoon',
	    evening: 'in the evening',
	    night: 'at night'
	  }
	};
	
	var ordinalNumber = function (dirtyNumber, _options) {
	  var number = Number(dirtyNumber); // If ordinal numbers depend on context, for example,
	  // if they are different for different grammatical genders,
	  // use `options.unit`.
	  //
	  // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
	  // 'day', 'hour', 'minute', 'second'.
	
	  var rem100 = number % 100;
	
	  if (rem100 > 20 || rem100 < 10) {
	    switch (rem100 % 10) {
	      case 1:
	        return number + 'st';
	
	      case 2:
	        return number + 'nd';
	
	      case 3:
	        return number + 'rd';
	    }
	  }
	
	  return number + 'th';
	};
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return quarter - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingDayPeriodValues,
	    defaultFormattingWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 93 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(14));
	
	var _index2 = _interopRequireDefault(__webpack_require__(15));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^(b|a)/i,
	  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
	  wide: /^(before christ|before common era|anno domini|common era)/i
	};
	var parseEraPatterns = {
	  any: [/^b/i, /^(a|c)/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^q[1234]/i,
	  wide: /^[1234](th|st|nd|rd)? quarter/i
	};
	var parseQuarterPatterns = {
	  any: [/1/i, /2/i, /3/i, /4/i]
	};
	var matchMonthPatterns = {
	  narrow: /^[jfmasond]/i,
	  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
	  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
	};
	var parseMonthPatterns = {
	  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
	  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
	};
	var matchDayPatterns = {
	  narrow: /^[smtwf]/i,
	  short: /^(su|mo|tu|we|th|fr|sa)/i,
	  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
	  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
	};
	var parseDayPatterns = {
	  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
	  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
	};
	var matchDayPeriodPatterns = {
	  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
	  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^a/i,
	    pm: /^p/i,
	    midnight: /^mi/i,
	    noon: /^no/i,
	    morning: /morning/i,
	    afternoon: /afternoon/i,
	    evening: /evening/i,
	    night: /night/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index2.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 94 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = nextDay;
	
	var _index = _interopRequireDefault(__webpack_require__(82));
	
	var _index2 = _interopRequireDefault(__webpack_require__(192));
	
	var _index3 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name nextDay
	 * @category Weekday Helpers
	 * @summary When is the next day of the week?
	 *
	 * @description
	 * When is the next day of the week? 0-6 the day of the week, 0 represents Sunday.
	 *
	 * @param {Date | number} date - the date to check
	 * @param {Day} day - day of the week
	 * @returns {Date} - the date is the next day of week
	 * @throws {TypeError} - 2 arguments required
	 *
	 * @example
	 * // When is the next Monday after Mar, 20, 2020?
	 * const result = nextDay(new Date(2020, 2, 20), 1)
	 * //=> Mon Mar 23 2020 00:00:00
	 *
	 * @example
	 * // When is the next Tuesday after Mar, 21, 2020?
	 * const result = nextDay(new Date(2020, 2, 21), 2)
	 * //=> Tue Mar 24 2020 00:00:00
	 */
	function nextDay(date, day) {
	  (0, _index3.default)(2, arguments);
	  var delta = day - (0, _index2.default)(date);
	  if (delta <= 0) delta += 7;
	  return (0, _index.default)(date, delta);
	}
	
	module.exports = exports.default;

/***/ },
/* 95 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = previousDay;
	
	var _index = _interopRequireDefault(__webpack_require__(2));
	
	var _index2 = _interopRequireDefault(__webpack_require__(192));
	
	var _index3 = _interopRequireDefault(__webpack_require__(196));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name previousDay
	 * @category Weekday Helpers
	 * @summary When is the previous day of the week?
	 *
	 * @description
	 * When is the previous day of the week? 0-6 the day of the week, 0 represents Sunday.
	 *
	 * @param {Date | number} date - the date to check
	 * @param {number} day - day of the week
	 * @returns {Date} - the date is the previous day of week
	 * @throws {TypeError} - 2 arguments required
	 *
	 * @example
	 * // When is the previous Monday before Mar, 20, 2020?
	 * const result = previousDay(new Date(2020, 2, 20), 1)
	 * //=> Mon Mar 16 2020 00:00:00
	 *
	 * @example
	 * // When is the previous Tuesday before Mar, 21, 2020?
	 * const result = previousDay(new Date(2020, 2, 21), 2)
	 * //=> Tue Mar 17 2020 00:00:00
	 */
	function previousDay(date, day) {
	  (0, _index.default)(2, arguments);
	  var delta = (0, _index2.default)(date) - day;
	  if (delta <= 0) delta += 7;
	  return (0, _index3.default)(date, delta);
	}
	
	module.exports = exports.default;

/***/ },
/* 96 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfWeek;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(19));
	
	var _index3 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name startOfWeek
	 * @category Week Helpers
	 * @summary Return the start of a week for the given date.
	 *
	 * @description
	 * Return the start of a week for the given date.
	 * The result will be in the local timezone.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @returns {Date} the start of a week
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 *
	 * @example
	 * // The start of a week for 2 September 2014 11:55:00:
	 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Sun Aug 31 2014 00:00:00
	 *
	 * @example
	 * // If the week starts on Monday, the start of the week for 2 September 2014 11:55:00:
	 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
	 * //=> Mon Sep 01 2014 00:00:00
	 */
	function startOfWeek(dirtyDate, dirtyOptions) {
	  (0, _index3.default)(1, arguments);
	  var options = dirtyOptions || {};
	  var locale = options.locale;
	  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
	  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0, _index2.default)(localeWeekStartsOn);
	  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0, _index2.default)(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
	
	  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
	    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
	  }
	
	  var date = (0, _index.default)(dirtyDate);
	  var day = date.getDay();
	  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
	  date.setDate(date.getDate() - diff);
	  date.setHours(0, 0, 0, 0);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 97 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ },
/* 98 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.mergeMap = void 0;
	var map_1 = __webpack_require__(114);
	var innerFrom_1 = __webpack_require__(28);
	var lift_1 = __webpack_require__(17);
	var mergeInternals_1 = __webpack_require__(332);
	var isFunction_1 = __webpack_require__(31);
	function mergeMap(project, resultSelector, concurrent) {
	    if (concurrent === void 0) { concurrent = Infinity; }
	    if (isFunction_1.isFunction(resultSelector)) {
	        return mergeMap(function (a, i) { return map_1.map(function (b, ii) { return resultSelector(a, b, i, ii); })(innerFrom_1.innerFrom(project(a, i))); }, concurrent);
	    }
	    else if (typeof resultSelector === 'number') {
	        concurrent = resultSelector;
	    }
	    return lift_1.operate(function (source, subscriber) { return mergeInternals_1.mergeInternals(source, subscriber, project, concurrent); });
	}
	exports.mergeMap = mergeMap;
	//# sourceMappingURL=mergeMap.js.map

/***/ },
/* 99 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.arrRemove = void 0;
	function arrRemove(arr, item) {
	    if (arr) {
	        var index = arr.indexOf(item);
	        0 <= index && arr.splice(index, 1);
	    }
	}
	exports.arrRemove = arrRemove;
	//# sourceMappingURL=arrRemove.js.map

/***/ },
/* 100 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.executeSchedule = void 0;
	function executeSchedule(parentSubscription, scheduler, work, delay, repeat) {
	    if (delay === void 0) { delay = 0; }
	    if (repeat === void 0) { repeat = false; }
	    var scheduleSubscription = scheduler.schedule(function () {
	        work();
	        if (repeat) {
	            parentSubscription.add(this.schedule(null, delay));
	        }
	        else {
	            this.unsubscribe();
	        }
	    }, delay);
	    parentSubscription.add(scheduleSubscription);
	    if (!repeat) {
	        return scheduleSubscription;
	    }
	}
	exports.executeSchedule = executeSchedule;
	//# sourceMappingURL=executeSchedule.js.map

/***/ },
/* 101 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(903);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(25)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!../../../../node_modules/sass-loader/index.js!./header.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!../../../../node_modules/sass-loader/index.js!./header.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 102 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _spreeApiOrderAdapter = __webpack_require__(237);
	
	var _spreeApiOrderAdapter2 = _interopRequireDefault(_spreeApiOrderAdapter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var request = __webpack_require__(67);
	
	var UserAPI = {
	    // Get User
	    getUser: function getUser(params) {
	        var sanitizedQueryParams = {};
	        sanitizedQueryParams.locale = params.locale;
	        return request.get(("https://staging.api.cubalicores.com") + '/api/v2/storefront/account').set('Authorization', 'Bearer ' + params.token).query(sanitizedQueryParams).send();
	    },
	
	    // Login
	    login: function login(params) {
	        return request.post(("https://staging.api.cubalicores.com") + '/spree_oauth/token').set('Content-Type', 'application/x-www-form-urlencoded').send('grant_type=password&username=' + params.email + '&password=' + params.password);
	    },
	
	    // Login
	    loginByCode: function loginByCode(params) {
	        return request.post(("https://staging.api.cubalicores.com") + '/api/otp/check-code').set('Content-Type', 'application/x-www-form-urlencoded').send('email=' + params.email + '&otp_code=' + params.otp_code);
	    },
	
	    // Login
	    sendCodeByEmail: function sendCodeByEmail(params) {
	        return request.post(("https://staging.api.cubalicores.com") + '/api/otp/send-code').set('Content-Type', 'application/x-www-form-urlencoded').send('email=' + params.email);
	    },
	
	    // Refresh
	    refreshToken: function refreshToken(_refreshToken) {
	        return request.post(("https://staging.api.cubalicores.com") + '/spree_oauth/token').set('Content-Type', 'application/x-www-form-urlencoded').send('grant_type=refresh_token&refresh_token=' + _refreshToken);
	    },
	
	    // Signup
	    signup: function signup(params) {
	        var sanitizedQueryParams = {};
	        sanitizedQueryParams.locale = params.locale;
	        return request.post(("https://staging.api.cubalicores.com") + '/api/v2/storefront/account').set('Content-Type', 'application/vnd.api+json').query(sanitizedQueryParams).send(params.data);
	    },
	
	    // Register user by email
	    registerByEmail: function registerByEmail(params) {
	        var sanitizedQueryParams = {
	            locale: params.locale
	        };
	        return request.get(("https://staging.api.cubalicores.com") + '/api/v2/storefront/account_confirmations/' + params.tokens).query(sanitizedQueryParams);
	    },
	
	    // Send Forgot Password Email
	    sendEmail: function sendEmail(data) {
	        return request.post(("https://staging.api.cubalicores.com") + '/api/v2/storefront/passwords').set('Content-Type', 'application/vnd.api+json').send(data);
	    },
	
	    // Send Forgot Password Email
	    forgotPassword: function forgotPassword(data, token) {
	        return request.patch(("https://staging.api.cubalicores.com") + '/api/v2/storefront/passwords/' + token).set('Content-Type', 'application/vnd.api+json').send(data);
	    },
	
	    // Set account valid age
	    setAccountAgeValid: function setAccountAgeValid(data, accessToken) {
	        return request.patch(("https://staging.api.cubalicores.com") + '/api/v2/storefront/account/set_age_valid').set('Authorization', 'Bearer ' + accessToken).field('age_valid', data.age_valid).then(function (response) {
	            return response;
	        });
	    }
	};
	
	exports.default = UserAPI;

/***/ },
/* 103 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /* eslint-disable */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FormField = {
	    inputFieldMarkup: function inputFieldMarkup(_ref) {
	        var input = _ref.input;
	        var label = _ref.label;
	        var type = _ref.type;
	        var _ref$defaultValue = _ref.defaultValue;
	        var defaultValue = _ref$defaultValue === undefined ? null : _ref$defaultValue;
	        var placeholder = _ref.placeholder;
	        var _ref$meta = _ref.meta;
	        var touched = _ref$meta.touched;
	        var error = _ref$meta.error;
	
	        var errorClassName = void 0;
	        var inputClassName = type === 'text' || 'tel' ? 'primary-input-field ' : ' ';
	
	        if (touched && error) {
	            errorClassName = 'has-error ';
	        }
	        return _react2.default.createElement(
	            'div',
	            { className: 'checkout-form-row ' + errorClassName },
	            _react2.default.createElement(
	                'label',
	                { htmlFor: input.name, className: 'checkout-form-label' },
	                label
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'checkout-form-fields' },
	                _react2.default.createElement('input', _extends({}, input, defaultValue !== null && { value: defaultValue }, { className: inputClassName, placeholder: !placeholder ? label : placeholder, type: type, id: input.name })),
	                touched && error && _react2.default.createElement(
	                    'span',
	                    { className: 'help-block' },
	                    error
	                )
	            )
	        );
	    },
	
	    checkboxInputFieldMarkup: function checkboxInputFieldMarkup(_ref2) {
	        var input = _ref2.input;
	        var label = _ref2.label;
	        var type = _ref2.type;
	        var placeholder = _ref2.placeholder;
	        var defaultValue = _ref2.defaultValue;
	        var _ref2$meta = _ref2.meta;
	        var touched = _ref2$meta.touched;
	        var error = _ref2$meta.error;
	        var _ref2$extraClassName = _ref2.extraClassName;
	        var extraClassName = _ref2$extraClassName === undefined ? '' : _ref2$extraClassName;
	
	        var errorClassName = void 0;
	
	        if (touched && error) {
	            errorClassName = 'has-error ';
	        }
	
	        return _react2.default.createElement(
	            'div',
	            { className: 'checkout-form-row ' + errorClassName + ' ' + extraClassName },
	            _react2.default.createElement(
	                'div',
	                { className: 'checkout-form-fields' },
	                _react2.default.createElement(
	                    'label',
	                    { htmlFor: input.name, className: 'checkout-form-label' },
	                    _react2.default.createElement('input', _extends({}, input, { type: type, id: input.name, value: defaultValue })),
	                    ' ',
	                    label
	                )
	            )
	        );
	    }
	};
	
	exports.default = FormField;

/***/ },
/* 104 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _creditCardType = __webpack_require__(391);
	
	var _creditCardType2 = _interopRequireDefault(_creditCardType);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var email = function email(value) {
	    return value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value) ? _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'error-invalid-email', defaultMessage: 'Invalid email' }) : undefined;
	};
	
	var passwordConfirmation = function passwordConfirmation(value, allValues) {
	    return value !== allValues.user.password ? _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'error-password-not-match', defaultMessage: 'Password doesn\'t match' }) : undefined;
	};
	
	var required = function required(value) {
	    return value ? undefined : _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'required-message', defaultMessage: 'Required' });
	};
	
	var minLength = function minLength(min) {
	    return function (value) {
	        return value && value.length < min ? _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'error-min-length', defaultMessage: 'Must be ' + min + ' or more characters', values: { min: min } }) : undefined;
	    };
	};
	
	/**
	 * Phone number must have only numbers, white spaces, (, ), + or -
	 * @param {string} value
	 * @returns
	 */
	var phone = function phone(value) {
	    return value && !/^[0-9 ()+-]*$/.test(value) ? _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'invalid-phone-number', defaultMessage: 'Invalid phone number' }) : undefined;
	};
	
	/**
	 * According to https://en.wikipedia.org/wiki/Postal_code, zip code (or postal code)
	 * only allows numbers, basic latin letters, empty spaces and hyphens.
	 * @param {string} value
	 * @returns
	 */
	var zipCode = function zipCode(value) {
	    return value && !/^[0-9a-zA-Z -]*$/.test(value) ? _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'invalid-zip-code', defaultMessage: 'Invalid zip code' }) : undefined;
	};
	
	var cardNumberLength = function cardNumberLength(cardNum) {
	    var result = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'add-funds-k-wallet-invalid-card-number-error', defaultMessage: 'Invalid card number' });
	    if (!cardNum || cardNum === '') return result;
	
	    var noSpaceNumber = cardNum.trim().replaceAll(' ', '');
	    var possibleCards = (0, _creditCardType2.default)(noSpaceNumber);
	    possibleCards.forEach(function (card) {
	        if (card.type && card.lengths && card.lengths.indexOf(noSpaceNumber.length) > -1) {
	            result = undefined;
	        }
	    });
	    return result;
	};
	
	var validators = {
	    required: required,
	    email: email,
	    passwordConfirmation: passwordConfirmation,
	    minLength: minLength,
	    phone: phone,
	    zipCode: zipCode,
	    cardNumberLength: cardNumberLength
	};
	
	exports.default = validators;

/***/ },
/* 105 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = compareAsc;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name compareAsc
	 * @category Common Helpers
	 * @summary Compare the two dates and return -1, 0 or 1.
	 *
	 * @description
	 * Compare the two dates and return 1 if the first date is after the second,
	 * -1 if the first date is before the second or 0 if dates are equal.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the first date to compare
	 * @param {Date|Number} dateRight - the second date to compare
	 * @returns {Number} the result of the comparison
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Compare 11 February 1987 and 10 July 1989:
	 * const result = compareAsc(new Date(1987, 1, 11), new Date(1989, 6, 10))
	 * //=> -1
	 *
	 * @example
	 * // Sort the array of dates:
	 * const result = [
	 *   new Date(1995, 6, 2),
	 *   new Date(1987, 1, 11),
	 *   new Date(1989, 6, 10)
	 * ].sort(compareAsc)
	 * //=> [
	 * //   Wed Feb 11 1987 00:00:00,
	 * //   Mon Jul 10 1989 00:00:00,
	 * //   Sun Jul 02 1995 00:00:00
	 * // ]
	 */
	function compareAsc(dirtyDateLeft, dirtyDateRight) {
	  (0, _index2.default)(2, arguments);
	  var dateLeft = (0, _index.default)(dirtyDateLeft);
	  var dateRight = (0, _index.default)(dirtyDateRight);
	  var diff = dateLeft.getTime() - dateRight.getTime();
	
	  if (diff < 0) {
	    return -1;
	  } else if (diff > 0) {
	    return 1; // Return 0 if diff is 0; return NaN if diff is NaN
	  } else {
	    return diff;
	  }
	}
	
	module.exports = exports.default;

/***/ },
/* 106 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = differenceInCalendarDays;
	
	var _index = _interopRequireDefault(__webpack_require__(81));
	
	var _index2 = _interopRequireDefault(__webpack_require__(194));
	
	var _index3 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MILLISECONDS_IN_DAY = 86400000;
	/**
	 * @name differenceInCalendarDays
	 * @category Day Helpers
	 * @summary Get the number of calendar days between the given dates.
	 *
	 * @description
	 * Get the number of calendar days between the given dates. This means that the times are removed
	 * from the dates and then the difference in days is calculated.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @returns {Number} the number of calendar days
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // How many calendar days are between
	 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
	 * const result = differenceInCalendarDays(
	 *   new Date(2012, 6, 2, 0, 0),
	 *   new Date(2011, 6, 2, 23, 0)
	 * )
	 * //=> 366
	 * // How many calendar days are between
	 * // 2 July 2011 23:59:00 and 3 July 2011 00:01:00?
	 * const result = differenceInCalendarDays(
	 *   new Date(2011, 6, 3, 0, 1),
	 *   new Date(2011, 6, 2, 23, 59)
	 * )
	 * //=> 1
	 */
	
	function differenceInCalendarDays(dirtyDateLeft, dirtyDateRight) {
	  (0, _index3.default)(2, arguments);
	  var startOfDayLeft = (0, _index2.default)(dirtyDateLeft);
	  var startOfDayRight = (0, _index2.default)(dirtyDateRight);
	  var timestampLeft = startOfDayLeft.getTime() - (0, _index.default)(startOfDayLeft);
	  var timestampRight = startOfDayRight.getTime() - (0, _index.default)(startOfDayRight); // Round the number of days to the nearest integer
	  // because the number of milliseconds in a day is not constant
	  // (e.g. it's different in the day of the daylight saving time clock shift)
	
	  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_DAY);
	}
	
	module.exports = exports.default;

/***/ },
/* 107 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    one: 'less than a second',
	    other: 'less than {{count}} seconds'
	  },
	  xSeconds: {
	    one: '1 second',
	    other: '{{count}} seconds'
	  },
	  halfAMinute: 'half a minute',
	  lessThanXMinutes: {
	    one: 'less than a minute',
	    other: 'less than {{count}} minutes'
	  },
	  xMinutes: {
	    one: '1 minute',
	    other: '{{count}} minutes'
	  },
	  aboutXHours: {
	    one: 'about 1 hour',
	    other: 'about {{count}} hours'
	  },
	  xHours: {
	    one: '1 hour',
	    other: '{{count}} hours'
	  },
	  xDays: {
	    one: '1 day',
	    other: '{{count}} days'
	  },
	  aboutXWeeks: {
	    one: 'about 1 week',
	    other: 'about {{count}} weeks'
	  },
	  xWeeks: {
	    one: '1 week',
	    other: '{{count}} weeks'
	  },
	  aboutXMonths: {
	    one: 'about 1 month',
	    other: 'about {{count}} months'
	  },
	  xMonths: {
	    one: '1 month',
	    other: '{{count}} months'
	  },
	  aboutXYears: {
	    one: 'about 1 year',
	    other: 'about {{count}} years'
	  },
	  xYears: {
	    one: '1 year',
	    other: '{{count}} years'
	  },
	  overXYears: {
	    one: 'over 1 year',
	    other: 'over {{count}} years'
	  },
	  almostXYears: {
	    one: 'almost 1 year',
	    other: 'almost {{count}} years'
	  }
	};
	
	var formatDistance = function (token, count, options) {
	  var result;
	  var tokenValue = formatDistanceLocale[token];
	
	  if (typeof tokenValue === 'string') {
	    result = tokenValue;
	  } else if (count === 1) {
	    result = tokenValue.one;
	  } else {
	    result = tokenValue.other.replace('{{count}}', count.toString());
	  }
	
	  if (options !== null && options !== void 0 && options.addSuffix) {
	    if (options.comparison && options.comparison > 0) {
	      return 'in ' + result;
	    } else {
	      return result + ' ago';
	    }
	  }
	
	  return result;
	};
	
	var _default = formatDistance;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 108 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(107));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1146));
	
	var _index3 = _interopRequireDefault(__webpack_require__(91));
	
	var _index4 = _interopRequireDefault(__webpack_require__(92));
	
	var _index5 = _interopRequireDefault(__webpack_require__(93));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary English locale (United States).
	 * @language English
	 * @iso-639-2 eng
	 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
	 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
	 */
	var locale = {
	  code: 'en-US',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 0
	    /* Sunday */
	    ,
	    firstWeekContainsDate: 1
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 109 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfISOWeek;
	
	var _index = _interopRequireDefault(__webpack_require__(96));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name startOfISOWeek
	 * @category ISO Week Helpers
	 * @summary Return the start of an ISO week for the given date.
	 *
	 * @description
	 * Return the start of an ISO week for the given date.
	 * The result will be in the local timezone.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the start of an ISO week
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The start of an ISO week for 2 September 2014 11:55:00:
	 * var result = startOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Mon Sep 01 2014 00:00:00
	 */
	function startOfISOWeek(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(dirtyDate, {
	    weekStartsOn: 1
	  });
	}
	
	module.exports = exports.default;

/***/ },
/* 110 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsNative = __webpack_require__(1672),
	    getValue = __webpack_require__(1701);
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	module.exports = getNative;


/***/ },
/* 111 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ },
/* 112 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _reactIs = __webpack_require__(160);
	
	var validateComponentProp = function validateComponentProp(props, propName, componentName) {
	  if (!(0, _reactIs.isValidElementType)(props[propName])) {
	    return new Error('Invalid prop `' + propName + '` supplied to' + ' `' + componentName + '`.');
	  }
	
	  return null;
	};
	
	var _default = validateComponentProp;
	exports["default"] = _default;

/***/ },
/* 113 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.timer = void 0;
	var Observable_1 = __webpack_require__(34);
	var async_1 = __webpack_require__(63);
	var isScheduler_1 = __webpack_require__(231);
	var isDate_1 = __webpack_require__(338);
	function timer(dueTime, intervalOrScheduler, scheduler) {
	    if (dueTime === void 0) { dueTime = 0; }
	    if (scheduler === void 0) { scheduler = async_1.async; }
	    var intervalDuration = -1;
	    if (intervalOrScheduler != null) {
	        if (isScheduler_1.isScheduler(intervalOrScheduler)) {
	            scheduler = intervalOrScheduler;
	        }
	        else {
	            intervalDuration = intervalOrScheduler;
	        }
	    }
	    return new Observable_1.Observable(function (subscriber) {
	        var due = isDate_1.isValidDate(dueTime) ? +dueTime - scheduler.now() : dueTime;
	        if (due < 0) {
	            due = 0;
	        }
	        var n = 0;
	        return scheduler.schedule(function () {
	            if (!subscriber.closed) {
	                subscriber.next(n++);
	                if (0 <= intervalDuration) {
	                    this.schedule(undefined, intervalDuration);
	                }
	                else {
	                    subscriber.complete();
	                }
	            }
	        }, due);
	    });
	}
	exports.timer = timer;
	//# sourceMappingURL=timer.js.map

/***/ },
/* 114 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.map = void 0;
	var lift_1 = __webpack_require__(17);
	var OperatorSubscriber_1 = __webpack_require__(20);
	function map(project, thisArg) {
	    return lift_1.operate(function (source, subscriber) {
	        var index = 0;
	        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (value) {
	            subscriber.next(project.call(thisArg, value, index++));
	        }));
	    });
	}
	exports.map = map;
	//# sourceMappingURL=map.js.map

/***/ },
/* 115 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.EmptyError = void 0;
	var createErrorClass_1 = __webpack_require__(116);
	exports.EmptyError = createErrorClass_1.createErrorClass(function (_super) { return function EmptyErrorImpl() {
	    _super(this);
	    this.name = 'EmptyError';
	    this.message = 'no elements in sequence';
	}; });
	//# sourceMappingURL=EmptyError.js.map

/***/ },
/* 116 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.createErrorClass = void 0;
	function createErrorClass(createImpl) {
	    var _super = function (instance) {
	        Error.call(instance);
	        instance.stack = new Error().stack;
	    };
	    var ctorFunc = createImpl(_super);
	    ctorFunc.prototype = Object.create(Error.prototype);
	    ctorFunc.prototype.constructor = ctorFunc;
	    return ctorFunc;
	}
	exports.createErrorClass = createErrorClass;
	//# sourceMappingURL=createErrorClass.js.map

/***/ },
/* 117 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	var __spreadArray = (this && this.__spreadArray) || function (to, from) {
	    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
	        to[j] = from[i];
	    return to;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.mapOneOrManyArgs = void 0;
	var map_1 = __webpack_require__(114);
	var isArray = Array.isArray;
	function callOrApply(fn, args) {
	    return isArray(args) ? fn.apply(void 0, __spreadArray([], __read(args))) : fn(args);
	}
	function mapOneOrManyArgs(fn) {
	    return map_1.map(function (args) { return callOrApply(fn, args); });
	}
	exports.mapOneOrManyArgs = mapOneOrManyArgs;
	//# sourceMappingURL=mapOneOrManyArgs.js.map

/***/ },
/* 118 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(913);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(25)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!../../../../node_modules/sass-loader/index.js!./loading.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!../../../../node_modules/sass-loader/index.js!./loading.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 119 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	var _interopRequireWildcard = __webpack_require__(48);
	
	exports.__esModule = true;
	exports.useUncontrolledProp = exports.uncontrollable = exports.useUncontrolled = void 0;
	
	var _hook = _interopRequireWildcard(__webpack_require__(2178));
	
	exports.useUncontrolled = _hook.default;
	exports.useUncontrolledProp = _hook.useUncontrolledProp;
	
	var _uncontrollable = _interopRequireDefault(__webpack_require__(2179));
	
	exports.uncontrollable = _uncontrollable.default;

/***/ },
/* 120 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(832);

/***/ },
/* 121 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(11);
	
	var _summaryConnector = __webpack_require__(764);
	
	var _summaryConnector2 = _interopRequireDefault(_summaryConnector);
	
	var _stepper = __webpack_require__(681);
	
	var _stepper2 = _interopRequireDefault(_stepper);
	
	var _step = __webpack_require__(680);
	
	var _step2 = _interopRequireDefault(_step);
	
	var _modals = __webpack_require__(241);
	
	var _baseCheckoutLayout = __webpack_require__(2155);
	
	var _baseCheckoutLayout2 = _interopRequireDefault(_baseCheckoutLayout);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BaseCheckoutLayout = function (_Component) {
	    _inherits(BaseCheckoutLayout, _Component);
	
	    function BaseCheckoutLayout(props, context) {
	        _classCallCheck(this, BaseCheckoutLayout);
	
	        var _this = _possibleConstructorReturn(this, (BaseCheckoutLayout.__proto__ || Object.getPrototypeOf(BaseCheckoutLayout)).call(this, props, context));
	
	        _this.state = {
	            showModalExtraTime: false
	        };
	        return _this;
	    }
	
	    _createClass(BaseCheckoutLayout, [{
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps, nextContext) {
	            if (nextProps.hasExtraTimeCheckout !== this.props.hasExtraTimeCheckout) {
	                this.setState(function (prevState) {
	                    return _extends({}, prevState, {
	                        showModalExtraTime: nextProps.hasExtraTimeCheckout
	                    });
	                });
	            }
	        }
	    }, {
	        key: 'isFormLegendRequired',
	        value: function isFormLegendRequired() {
	            var requiredFor = ['address', 'payment'];
	            return this.props.currentStep && requiredFor.indexOf(this.props.currentStep) > -1;
	        }
	
	        /*
	        This function iterates over all the steps and calls another function for
	        generating markup for each step.
	        */
	
	    }, {
	        key: '__generateCheckoutStepsMarkup',
	        value: function __generateCheckoutStepsMarkup(currentStep, order) {
	            var _this2 = this;
	
	            if (currentStep === 'complete') {
	                this.__generateMarkupForStep(currentStep, currentStep, currentStep, order);
	            } else {
	                this.props.checkoutSteps.forEach(function (checkoutStep) {
	                    _this2.__generateMarkupForStep(currentStep, checkoutStep, checkoutStep, order);
	                });
	            }
	        }
	
	        /*
	        This function generates two things, namely, the title section for each
	        checkout step and the content for the checkout step body (actual form).
	        It then pushes the result into +checkoutStepsMarkup+.
	        */
	
	    }, {
	        key: '__generateMarkupForStep',
	        value: function __generateMarkupForStep(currentStep, thisStep, title, order) {
	            thisStep = thisStep.trim();
	
	            /* const thisStepIndex = order.checkout_steps.indexOf(thisStep);
	            const orderStateIndex = order.checkout_steps.indexOf(order.state); */
	
	            var innerHtml = this.__generateMarkupForStepBody(currentStep, thisStep);
	
	            var formattedTitle = _react2.default.createElement(_reactIntl.FormattedMessage, { id: title.toLowerCase(), defaultMessage: title });
	
	            this.checkoutStepsMarkup.push(_react2.default.createElement(
	                'div',
	                { className: 'checkout-block-container checkout-title-block', key: thisStep + '-step' },
	                currentStep === thisStep && _react2.default.createElement(
	                    'h4',
	                    { id: thisStep.trim() + '-section', className: 'section-heading' },
	                    formattedTitle,
	                    thisStep.trim() === 'delivery' && _react2.default.createElement(
	                        'div',
	                        { className: _baseCheckoutLayout2.default.delivery_small_text, style: { paddingTop: '10px' } },
	                        _react2.default.createElement(_reactIntl.FormattedMessage, {
	                            id: 'delivery.small.text',
	                            defaultMessage: 'Choose a delivery method. If a package can be merged in a single shipment we\'ll do it when you click \'Continue\''
	                        })
	                    )
	                ),
	                innerHtml
	            ));
	        }
	
	        /*
	        This generates mark up for step body(form fields for the step etc) if the
	        +thisStep+ is same as the +currentStep+. It doesn't generate markup for the
	        step title.
	        */
	
	    }, {
	        key: '__generateMarkupForStepBody',
	        value: function __generateMarkupForStepBody(currentStep, thisStep) {
	            if (currentStep === thisStep) {
	                return _react2.default.createElement(
	                    'div',
	                    { className: 'checkout-block-content' },
	                    this.props.children
	                );
	            }
	            return null;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            var handleCloseModal = function handleCloseModal() {
	                _this3.setState({
	                    showModalExtraTime: false
	                });
	            };
	            this.checkoutStepsMarkup = [];
	            this.__generateCheckoutStepsMarkup(this.props.currentStep, this.props.order);
	            return _react2.default.createElement(
	                'div',
	                { className: 'checkout-flow checkout-section' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'container' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-sm-8' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'row' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-sm-12' },
	                                    _react2.default.createElement(
	                                        _stepper2.default,
	                                        null,
	                                        this.props.order.checkout_steps.map(function (name, index) {
	                                            return _react2.default.createElement(_step2.default, {
	                                                key: index,
	                                                title: name,
	                                                isComplete: _this3.props.order.checkout_steps.indexOf(_this3.props.currentStep) > _this3.props.order.checkout_steps.indexOf(name),
	                                                isActive: _this3.props.order.checkout_steps.indexOf(_this3.props.currentStep) === _this3.props.order.checkout_steps.indexOf(name)
	                                            });
	                                        })
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'row' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-sm-12' },
	                                    this.checkoutStepsMarkup
	                                )
	                            ),
	                            this.isFormLegendRequired() && _react2.default.createElement(
	                                'div',
	                                { className: 'form-legend' },
	                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'legend-required-field', defaultMessage: '* indicates the field is required' })
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-sm-3 col-sm-offset-1 checkout-block-summary' },
	                            _react2.default.createElement(_summaryConnector2.default, { placedOrder: this.props.placedOrder })
	                        )
	                    )
	                ),
	                this.props.gracePeriod && this.props.locale && _react2.default.createElement(_modals.ExtraTimeModal, { gracePeriod: this.props.gracePeriod, locale: this.props.locale, show: this.state.showModalExtraTime, onHide: handleCloseModal })
	            );
	        }
	    }]);
	
	    return BaseCheckoutLayout;
	}(_react.Component);
	
	exports.default = BaseCheckoutLayout;

/***/ },
/* 122 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var MunicipalityService = {
	    getAvailableMunicipalitiesByZoneId: function getAvailableMunicipalitiesByZoneId(zoneId, availableZones, availableMunicipalities) {
	        var targetZone = availableZones.find(function (zone) {
	            return zone.id === zoneId;
	        });
	        var result = [];
	        if (targetZone && availableMunicipalities.length > 0) {
	            // eslint-disable-next-line no-restricted-syntax
	            var _iteratorNormalCompletion = true;
	            var _didIteratorError = false;
	            var _iteratorError = undefined;
	
	            try {
	                var _loop = function _loop() {
	                    var zone = _step.value;
	
	                    var targetMunicipalities = availableMunicipalities.filter(function (municipality) {
	                        return zone.zoneable_id === municipality.state_id;
	                    });
	                    result = [].concat(_toConsumableArray(result), _toConsumableArray(targetMunicipalities));
	                };
	
	                for (var _iterator = targetZone.zone_members[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                    _loop();
	                }
	            } catch (err) {
	                _didIteratorError = true;
	                _iteratorError = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion && _iterator.return) {
	                        _iterator.return();
	                    }
	                } finally {
	                    if (_didIteratorError) {
	                        throw _iteratorError;
	                    }
	                }
	            }
	        }
	        return result;
	        // return availableMunicipalities;
	    },
	    isMunicipalitySelectorModalRequired: function isMunicipalitySelectorModalRequired(currentMunicipality, selectedZoneMunicipalities) {
	        if (selectedZoneMunicipalities.length > 0 && (!currentMunicipality || !selectedZoneMunicipalities.find(function (municipality) {
	            return municipality.id === currentMunicipality;
	        }))) {
	            return true;
	        }
	        return false;
	    },
	    getMunicipalityInfoFromOrderResponse: function getMunicipalityInfoFromOrderResponse(response) {
	        var municipalityData = response.data.relationships.municipality.data;
	        var included = response.included;
	
	        var municipalityInfo = void 0;
	        if (municipalityData && municipalityData.id) {
	            municipalityInfo = included.find(function (info) {
	                return info.id === municipalityData.id;
	            });
	        }
	        return municipalityInfo;
	    }
	};
	
	exports.default = MunicipalityService;

/***/ },
/* 123 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	/*
	  Returns the URL unchanged if it is an absolute URL
	  Else, appends with REACT_APP_MAIN_STORE_API_HOST.
	*/
	var URLSanitizer = {
	    makeAbsolute: function makeAbsolute(url) {
	        if (url.indexOf('http') !== -1) {
	            return url;
	        }
	
	        return '' + ("https://staging.api.cubalicores.com") + url;
	    }
	};
	
	exports.default = URLSanitizer;

/***/ },
/* 124 */
/***/ function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(373);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ },
/* 125 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(382);
	var enumBugKeys = __webpack_require__(253);
	
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


/***/ },
/* 126 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(182);
	module.exports = function (it) {
	  return Object(defined(it));
	};


/***/ },
/* 127 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addLeadingZeros;
	
	function addLeadingZeros(number, targetLength) {
	  var sign = number < 0 ? '-' : '';
	  var output = Math.abs(number).toString();
	
	  while (output.length < targetLength) {
	    output = '0' + output;
	  }
	
	  return sign + output;
	}
	
	module.exports = exports.default;

/***/ },
/* 128 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getISOWeekYear;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(109));
	
	var _index3 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name getISOWeekYear
	 * @category ISO Week-Numbering Year Helpers
	 * @summary Get the ISO week-numbering year of the given date.
	 *
	 * @description
	 * Get the ISO week-numbering year of the given date,
	 * which always starts 3 days before the year's first Thursday.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * - The function was renamed from `getISOYear` to `getISOWeekYear`.
	 *   "ISO week year" is short for [ISO week-numbering year](https://en.wikipedia.org/wiki/ISO_week_date).
	 *   This change makes the name consistent with
	 *   locale-dependent week-numbering year helpers, e.g., `getWeekYear`.
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the ISO week-numbering year
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Which ISO-week numbering year is 2 January 2005?
	 * const result = getISOWeekYear(new Date(2005, 0, 2))
	 * //=> 2004
	 */
	function getISOWeekYear(dirtyDate) {
	  (0, _index3.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var year = date.getFullYear();
	  var fourthOfJanuaryOfNextYear = new Date(0);
	  fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
	  fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
	  var startOfNextYear = (0, _index2.default)(fourthOfJanuaryOfNextYear);
	  var fourthOfJanuaryOfThisYear = new Date(0);
	  fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
	  fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
	  var startOfThisYear = (0, _index2.default)(fourthOfJanuaryOfThisYear);
	
	  if (date.getTime() >= startOfNextYear.getTime()) {
	    return year + 1;
	  } else if (date.getTime() >= startOfThisYear.getTime()) {
	    return year;
	  } else {
	    return year - 1;
	  }
	}
	
	module.exports = exports.default;

/***/ },
/* 129 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = ownerDocument;
	
	function ownerDocument(node) {
	  return node && node.ownerDocument || document;
	}
	
	module.exports = exports["default"];

/***/ },
/* 130 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _inDOM = _interopRequireDefault(__webpack_require__(84));
	
	var _default = function () {
	  // HTML DOM and SVG DOM may have different support levels,
	  // so we need to check on context instead of a document root element.
	  return _inDOM.default ? function (context, node) {
	    if (context.contains) {
	      return context.contains(node);
	    } else if (context.compareDocumentPosition) {
	      return context === node || !!(context.compareDocumentPosition(node) & 16);
	    } else {
	      return fallback(context, node);
	    }
	  } : fallback;
	}();
	
	exports.default = _default;
	
	function fallback(context, node) {
	  if (node) do {
	    if (node === context) return true;
	  } while (node = node.parentNode);
	  return false;
	}
	
	module.exports = exports["default"];

/***/ },
/* 131 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(199),
	    getRawTag = __webpack_require__(1699),
	    objectToString = __webpack_require__(1727);
	
	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	module.exports = baseGetTag;


/***/ },
/* 132 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	exports.default = function (componentOrElement) {
	  return (0, _ownerDocument2.default)(_reactDom2.default.findDOMNode(componentOrElement));
	};
	
	var _reactDom = __webpack_require__(46);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _ownerDocument = __webpack_require__(129);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = exports['default'];

/***/ },
/* 133 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.toastrWarn = toastrWarn;
	exports.createReducer = createReducer;
	exports.isBrowser = isBrowser;
	exports.keyCode = keyCode;
	exports.mapToToastrMessage = mapToToastrMessage;
	exports.guid = guid;
	exports.onCSSTransitionEnd = onCSSTransitionEnd;
	exports.preventDuplication = preventDuplication;
	exports.updateConfig = updateConfig;
	exports._bind = _bind;
	
	var _config = _interopRequireDefault(__webpack_require__(313));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function whichAnimationEvent() {
	  var t;
	  var el = document.createElement('fakeelement');
	  var transitions = {
	    animation: 'animationend',
	    oanimation: 'oanimationend',
	    MSAnimation: 'MSAnimationEnd',
	    webkitAnimation: 'webkitAnimationEnd'
	  };
	
	  for (t in transitions) {
	    if (el.style[t] !== undefined) {
	      return transitions[t];
	    }
	  }
	}
	
	function createNewEvent(eventName) {
	  var event;
	
	  if (typeof Event === 'function') {
	    event = new Event(eventName);
	  } else {
	    event = document.createEvent('Event');
	    event.initEvent(eventName, true, true);
	  }
	
	  return event;
	}
	
	function isString(obj) {
	  if (typeof obj == 'string') {
	    return true;
	  }
	
	  return false;
	}
	
	function toastrWarn(message) {
	  if (true) {
	    return null;
	  }
	
	  console.warn("[react-redux-toastr] ".concat(message));
	}
	
	function createReducer(initialState, fnMap) {
	  return function () {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	
	    var _ref = arguments.length > 1 ? arguments[1] : undefined,
	        type = _ref.type,
	        payload = _ref.payload;
	
	    var handle = fnMap[type];
	    return handle ? handle(state, payload) : state;
	  };
	}
	
	function isBrowser() {
	  if (typeof window !== 'undefined') {
	    return true;
	  }
	
	  return false;
	}
	
	function keyCode(e) {
	  return e.which ? e.which : e.keyCode;
	}
	
	function mapToToastrMessage(type, array) {
	  var obj = {};
	  obj.type = type;
	  obj.position = _config["default"].position;
	  obj.options = array.filter(function (item) {
	    return _typeof(item) == 'object';
	  })[0] || {};
	
	  if (obj.options.hasOwnProperty('position')) {
	    obj.position = obj.options.position;
	  }
	
	  if (!obj.options.hasOwnProperty('removeOnHover')) {
	    obj.options.removeOnHover = true;
	
	    if (type === 'message') {
	      obj.options.removeOnHover = false;
	    }
	  }
	
	  if (!obj.options.hasOwnProperty('showCloseButton')) {
	    obj.options.showCloseButton = true;
	  }
	
	  if (type === 'message' && !obj.options.hasOwnProperty('timeOut')) {
	    obj.options.timeOut = 0;
	  }
	
	  if (isString(array[0]) && isString(array[1])) {
	    obj.title = array[0];
	    obj.message = array[1];
	  } else if (isString(array[0]) && !isString(array[1])) {
	    obj.title = array[0];
	  } else {
	    obj.message = array[0];
	  }
	
	  return obj;
	}
	
	function guid() {
	  var r = function r() {
	    return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
	  };
	
	  return r() + r() + r() + '-' + r() + '_' + r() + '-' + r() + '_' + r() + r() + r();
	}
	
	function onCSSTransitionEnd(node, callback) {
	  if (!node) {
	    return;
	  } // if css animation is failed - dispatch event manually
	
	
	  var animationEnd = whichAnimationEvent();
	  var timeoutId = setTimeout(function () {
	    var e = createNewEvent(animationEnd);
	    toastrWarn('The toastr box was closed automatically, please check \'transitionOut\' prop value');
	    node.dispatchEvent(e);
	  }, _config["default"].maxAnimationDelay);
	
	  var runOnce = function runOnce(e) {
	    clearTimeout(timeoutId); // stopPropagation is not working in IE11 and Edge, the transitionend from the Button.js is waiting
	    // on the confirm animation to end first and not the Button.js
	
	    e.stopPropagation();
	    node.removeEventListener(animationEnd, runOnce);
	    callback && callback(e);
	  };
	
	  node.addEventListener(animationEnd, runOnce);
	}
	
	function preventDuplication(currentData, newObjec) {
	  var hasDuplication = false;
	  currentData.forEach(function (item) {
	    // If the toastr options implicitly specify not to prevent duplicates then skip
	    if (item.options && item.options.preventDuplicates === false) return; // Because the toastr has a unic id we will check by the title and message.
	
	    if (item.title === newObjec.title && item.message === newObjec.message && item.type === newObjec.type) {
	      hasDuplication = true;
	    }
	  });
	  return hasDuplication;
	}
	
	function updateConfig(obj) {
	  Object.keys(_config["default"]).forEach(function (key) {
	    if (obj.hasOwnProperty(key)) {
	      _config["default"][key] = obj[key];
	    }
	  });
	}
	
	function _bind(strinOrAray, scope) {
	  var array = strinOrAray;
	
	  if (!Array.isArray(strinOrAray)) {
	    array = strinOrAray.split(' ');
	  }
	
	  return array.map(function (item) {
	    return scope[item] = scope[item].bind(scope);
	  });
	}

/***/ },
/* 134 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var __DEV__ = ("production") !== 'production';
	
	var warning = function() {};
	
	if (__DEV__) {
	  var printWarning = function printWarning(format, args) {
	    var len = arguments.length;
	    args = new Array(len > 1 ? len - 1 : 0);
	    for (var key = 1; key < len; key++) {
	      args[key - 1] = arguments[key];
	    }
	    var argIndex = 0;
	    var message = 'Warning: ' +
	      format.replace(/%s/g, function() {
	        return args[argIndex++];
	      });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  }
	
	  warning = function(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error(
	          '`warning(condition, format, ...args)` requires a warning ' +
	          'message argument'
	      );
	    }
	    if (!condition) {
	      printWarning.apply(null, [format].concat(args));
	    }
	  };
	}
	
	module.exports = warning;


/***/ },
/* 135 */
134,
/* 136 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.filter = void 0;
	var lift_1 = __webpack_require__(17);
	var OperatorSubscriber_1 = __webpack_require__(20);
	function filter(predicate, thisArg) {
	    return lift_1.operate(function (source, subscriber) {
	        var index = 0;
	        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (value) { return predicate.call(thisArg, value, index++) && subscriber.next(value); }));
	    });
	}
	exports.filter = filter;
	//# sourceMappingURL=filter.js.map

/***/ },
/* 137 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.argsOrArgArray = void 0;
	var isArray = Array.isArray;
	function argsOrArgArray(args) {
	    return args.length === 1 && isArray(args[0]) ? args[0] : args;
	}
	exports.argsOrArgArray = argsOrArgArray;
	//# sourceMappingURL=argsOrArgArray.js.map

/***/ },
/* 138 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(928);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(25)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!../../../../node_modules/sass-loader/index.js!./signin.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!../../../../node_modules/sass-loader/index.js!./signin.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 139 */
/***/ function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ },
/* 140 */
/***/ function(module, exports, __webpack_require__) {

	var toPropertyKey = __webpack_require__(627);
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];
	    descriptor.enumerable = descriptor.enumerable || false;
	    descriptor.configurable = true;
	    if ("value" in descriptor) descriptor.writable = true;
	    Object.defineProperty(target, toPropertyKey(descriptor.key), descriptor);
	  }
	}
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
	  if (staticProps) _defineProperties(Constructor, staticProps);
	  Object.defineProperty(Constructor, "prototype", {
	    writable: false
	  });
	  return Constructor;
	}
	module.exports = _createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 141 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createBrowserHistory = __webpack_require__(1634);
	
	var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);
	
	var _configs = __webpack_require__(175);
	
	var _configs2 = _interopRequireDefault(_configs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var history = (0, _createBrowserHistory2.default)();
	if (false) {
	    history.listen(function (location) {
	        try {
	            window.gtag('config', _configs2.default.GOOGLE_ANALYTICS.TRACKING_ID, {
	                page_path: location.pathname
	            });
	        } catch (error) {
	            console.log('Error en gtag');
	            console.log(error);
	        }
	    });
	}
	
	/*
	  This is the history object used to initialize store and also supplied into
	  the router component.
	*/
	exports.default = history;

/***/ },
/* 142 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Address = function (_Component) {
	    _inherits(Address, _Component);
	
	    function Address() {
	        _classCallCheck(this, Address);
	
	        return _possibleConstructorReturn(this, (Address.__proto__ || Object.getPrototypeOf(Address)).apply(this, arguments));
	    }
	
	    _createClass(Address, [{
	        key: 'render',
	        value: function render() {
	            var address = this.props.address;
	
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'address-view' },
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    _react2.default.createElement(
	                        'b',
	                        null,
	                        address.firstname + ' ' + address.lastname
	                    )
	                ),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    address.address1
	                ),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    address.address2
	                ),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    address.city + ', ' + address.state_name + ' - ' + address.zipcode
	                ),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    address.country_name
	                ),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    _react2.default.createElement(
	                        'label',
	                        null,
	                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'phone', defaultMessage: 'Phone' }),
	                        ': \xA0'
	                    ),
	                    address.phone
	                )
	            );
	        }
	    }]);
	
	    return Address;
	}(_react.Component);
	
	exports.default = Address;

/***/ },
/* 143 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var ProductModel = {
	    find: function find(productId) {
	        var products = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	
	        var radix = 10;
	        return products.find(function (product) {
	            return parseInt(product.id, radix) === parseInt(productId, radix);
	        });
	    },
	
	    findBySlug: function findBySlug(productSlug) {
	        var products = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	        return products.find(function (product) {
	            return product.attributes.slug === productSlug;
	        });
	    },
	
	    variants: function variants(variantIds) {
	        var productsList = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	        return productsList.included.filter(function (item) {
	            return item.type === 'variant' && variantIds.indexOf(item.id) !== -1;
	        });
	    },
	
	    masterVariant: function masterVariant(id) {
	        var productsList = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	        return productsList.included.find(function (item) {
	            return item.type === 'variant' && item.id === id;
	        });
	    },
	
	    images: function images(imageIds) {
	        var productsList = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	        return productsList.included.filter(function (item) {
	            return item.type === 'image' && imageIds.indexOf(item.id) !== -1;
	        });
	    },
	
	    data_extra_types: function data_extra_types(extraDataTypeIds) {
	        var productsList = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	        return productsList.included.filter(function (item) {
	            return item.type === 'data_extra_type' && extraDataTypeIds.indexOf(item.id) !== -1;
	        });
	    },
	
	    properties: function properties(propertyIds) {
	        var productsList = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    },
	
	    filterUniqueProducts: function filterUniqueProducts(products) {
	        var productsFilters = [];
	
	        // eslint-disable-next-line no-restricted-syntax
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	            var _loop = function _loop() {
	                var product = _step.value;
	
	                var filterCondition = productsFilters.findIndex(function (item) {
	                    return item.id === product.id;
	                }) === -1;
	                if (filterCondition) {
	                    productsFilters.push(product);
	                }
	            };
	
	            for (var _iterator = products[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                _loop();
	            }
	        } catch (err) {
	            _didIteratorError = true;
	            _iteratorError = err;
	        } finally {
	            try {
	                if (!_iteratorNormalCompletion && _iterator.return) {
	                    _iterator.return();
	                }
	            } finally {
	                if (_didIteratorError) {
	                    throw _iteratorError;
	                }
	            }
	        }
	
	        return productsFilters;
	    }
	};
	
	exports.default = ProductModel;

/***/ },
/* 144 */
/***/ function(module, exports) {

	module.exports = {};


/***/ },
/* 145 */
/***/ function(module, exports) {

	exports.f = {}.propertyIsEnumerable;


/***/ },
/* 146 */
/***/ function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ },
/* 147 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getRoundingMethod = getRoundingMethod;
	var roundingMap = {
	  ceil: Math.ceil,
	  round: Math.round,
	  floor: Math.floor,
	  trunc: function (value) {
	    return value < 0 ? Math.ceil(value) : Math.floor(value);
	  } // Math.trunc is not supported by IE
	
	};
	var defaultRoundingMethod = 'trunc';
	
	function getRoundingMethod(method) {
	  return method ? roundingMap[method] : roundingMap[defaultRoundingMethod];
	}

/***/ },
/* 148 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfUTCWeek;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	var _index3 = _interopRequireDefault(__webpack_require__(19));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// This function will be a part of public API when UTC function will be implemented.
	// See issue: https://github.com/date-fns/date-fns/issues/376
	function startOfUTCWeek(dirtyDate, dirtyOptions) {
	  (0, _index2.default)(1, arguments);
	  var options = dirtyOptions || {};
	  var locale = options.locale;
	  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
	  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0, _index3.default)(localeWeekStartsOn);
	  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0, _index3.default)(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
	
	  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
	    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
	  }
	
	  var date = (0, _index.default)(dirtyDate);
	  var day = date.getUTCDay();
	  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
	  date.setUTCDate(date.getUTCDate() - diff);
	  date.setUTCHours(0, 0, 0, 0);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 149 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addMilliseconds;
	
	var _index = _interopRequireDefault(__webpack_require__(19));
	
	var _index2 = _interopRequireDefault(__webpack_require__(3));
	
	var _index3 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name addMilliseconds
	 * @category Millisecond Helpers
	 * @summary Add the specified number of milliseconds to the given date.
	 *
	 * @description
	 * Add the specified number of milliseconds to the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of milliseconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the milliseconds added
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
	 * const result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
	 * //=> Thu Jul 10 2014 12:45:30.750
	 */
	function addMilliseconds(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var timestamp = (0, _index2.default)(dirtyDate).getTime();
	  var amount = (0, _index.default)(dirtyAmount);
	  return new Date(timestamp + amount);
	}
	
	module.exports = exports.default;

/***/ },
/* 150 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addMonths;
	
	var _index = _interopRequireDefault(__webpack_require__(19));
	
	var _index2 = _interopRequireDefault(__webpack_require__(3));
	
	var _index3 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name addMonths
	 * @category Month Helpers
	 * @summary Add the specified number of months to the given date.
	 *
	 * @description
	 * Add the specified number of months to the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of months to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the months added
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Add 5 months to 1 September 2014:
	 * const result = addMonths(new Date(2014, 8, 1), 5)
	 * //=> Sun Feb 01 2015 00:00:00
	 */
	function addMonths(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var amount = (0, _index.default)(dirtyAmount);
	
	  if (isNaN(amount)) {
	    return new Date(NaN);
	  }
	
	  if (!amount) {
	    // If 0 months, no-op to avoid changing times in the hour before end of DST
	    return date;
	  }
	
	  var dayOfMonth = date.getDate(); // The JS Date object supports date math by accepting out-of-bounds values for
	  // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
	  // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
	  // want except that dates will wrap around the end of a month, meaning that
	  // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
	  // we'll default to the end of the desired month by adding 1 to the desired
	  // month and using a date of 0 to back up one day to the end of the desired
	  // month.
	
	  var endOfDesiredMonth = new Date(date.getTime());
	  endOfDesiredMonth.setMonth(date.getMonth() + amount + 1, 0);
	  var daysInMonth = endOfDesiredMonth.getDate();
	
	  if (dayOfMonth >= daysInMonth) {
	    // If we're already at the end of the month, then this is the correct date
	    // and we're done.
	    return endOfDesiredMonth;
	  } else {
	    // Otherwise, we now know that setting the original day-of-month value won't
	    // cause an overflow, so set the desired day-of-month. Note that we can't
	    // just set the date of `endOfDesiredMonth` because that object may have had
	    // its time changed in the unusual case where where a DST transition was on
	    // the last day of the month and its local time was in the hour skipped or
	    // repeated next to a DST transition.  So we use `date` instead which is
	    // guaranteed to still have the original time.
	    date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
	    return date;
	  }
	}
	
	module.exports = exports.default;

/***/ },
/* 151 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isSameDay;
	
	var _index = _interopRequireDefault(__webpack_require__(194));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isSameDay
	 * @category Day Helpers
	 * @summary Are the given dates in the same day (and year and month)?
	 *
	 * @description
	 * Are the given dates in the same day (and year and month)?
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the first date to check
	 * @param {Date|Number} dateRight - the second date to check
	 * @returns {Boolean} the dates are in the same day (and year and month)
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Are 4 September 06:00:00 and 4 September 18:00:00 in the same day?
	 * var result = isSameDay(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 4, 18, 0))
	 * //=> true
	 * 
	 * @example
	 * // Are 4 September and 4 October in the same day?
	 * var result = isSameDay(new Date(2014, 8, 4), new Date(2014, 9, 4))
	 * //=> false
	 * 
	 * @example
	 * // Are 4 September, 2014 and 4 September, 2015 in the same day?
	 * var result = isSameDay(new Date(2014, 8, 4), new Date(2015, 8, 4))
	 * //=> false
	 */
	function isSameDay(dirtyDateLeft, dirtyDateRight) {
	  (0, _index2.default)(2, arguments);
	  var dateLeftStartOfDay = (0, _index.default)(dirtyDateLeft);
	  var dateRightStartOfDay = (0, _index.default)(dirtyDateRight);
	  return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime();
	}
	
	module.exports = exports.default;

/***/ },
/* 152 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfISOWeekYear;
	
	var _index = _interopRequireDefault(__webpack_require__(128));
	
	var _index2 = _interopRequireDefault(__webpack_require__(109));
	
	var _index3 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name startOfISOWeekYear
	 * @category ISO Week-Numbering Year Helpers
	 * @summary Return the start of an ISO week-numbering year for the given date.
	 *
	 * @description
	 * Return the start of an ISO week-numbering year,
	 * which always starts 3 days before the year's first Thursday.
	 * The result will be in the local timezone.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the start of an ISO week-numbering year
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The start of an ISO week-numbering year for 2 July 2005:
	 * const result = startOfISOWeekYear(new Date(2005, 6, 2))
	 * //=> Mon Jan 03 2005 00:00:00
	 */
	function startOfISOWeekYear(dirtyDate) {
	  (0, _index3.default)(1, arguments);
	  var year = (0, _index.default)(dirtyDate);
	  var fourthOfJanuary = new Date(0);
	  fourthOfJanuary.setFullYear(year, 0, 4);
	  fourthOfJanuary.setHours(0, 0, 0, 0);
	  var date = (0, _index2.default)(fourthOfJanuary);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 153 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = subMilliseconds;
	
	var _index = _interopRequireDefault(__webpack_require__(19));
	
	var _index2 = _interopRequireDefault(__webpack_require__(149));
	
	var _index3 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name subMilliseconds
	 * @category Millisecond Helpers
	 * @summary Subtract the specified number of milliseconds from the given date.
	 *
	 * @description
	 * Subtract the specified number of milliseconds from the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of milliseconds to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the milliseconds subtracted
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
	 * const result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
	 * //=> Thu Jul 10 2014 12:45:29.250
	 */
	function subMilliseconds(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  return (0, _index2.default)(dirtyDate, -amount);
	}
	
	module.exports = exports.default;

/***/ },
/* 154 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports.default = style;
	
	var _camelizeStyle = _interopRequireDefault(__webpack_require__(459));
	
	var _hyphenateStyle = _interopRequireDefault(__webpack_require__(1594));
	
	var _getComputedStyle2 = _interopRequireDefault(__webpack_require__(1587));
	
	var _removeStyle = _interopRequireDefault(__webpack_require__(1588));
	
	var _properties = __webpack_require__(292);
	
	var _isTransform = _interopRequireDefault(__webpack_require__(1591));
	
	function style(node, property, value) {
	  var css = '';
	  var transforms = '';
	  var props = property;
	
	  if (typeof property === 'string') {
	    if (value === undefined) {
	      return node.style[(0, _camelizeStyle.default)(property)] || (0, _getComputedStyle2.default)(node).getPropertyValue((0, _hyphenateStyle.default)(property));
	    } else {
	      (props = {})[property] = value;
	    }
	  }
	
	  Object.keys(props).forEach(function (key) {
	    var value = props[key];
	
	    if (!value && value !== 0) {
	      (0, _removeStyle.default)(node, (0, _hyphenateStyle.default)(key));
	    } else if ((0, _isTransform.default)(key)) {
	      transforms += key + "(" + value + ") ";
	    } else {
	      css += (0, _hyphenateStyle.default)(key) + ": " + value + ";";
	    }
	  });
	
	  if (transforms) {
	    css += _properties.transform + ": " + transforms + ";";
	  }
	
	  node.style.cssText += ';' + css;
	}
	
	module.exports = exports["default"];

/***/ },
/* 155 */
/***/ function(module, exports, __webpack_require__) {

	var isSymbol = __webpack_require__(209);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/**
	 * Converts `value` to a string key if it's not a string or symbol.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {string|symbol} Returns the key.
	 */
	function toKey(value) {
	  if (typeof value == 'string' || isSymbol(value)) {
	    return value;
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = toKey;


/***/ },
/* 156 */
/***/ function(module, exports) {

	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	module.exports = eq;


/***/ },
/* 157 */
/***/ function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(208),
	    isLength = __webpack_require__(301);
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	module.exports = isArrayLike;


/***/ },
/* 158 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _values = _interopRequireDefault(__webpack_require__(120));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _extends3 = _interopRequireDefault(__webpack_require__(8));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _elementType = _interopRequireDefault(__webpack_require__(32));
	
	var _bootstrapUtils = __webpack_require__(16);
	
	var _StyleConfig = __webpack_require__(50);
	
	var _SafeAnchor = _interopRequireDefault(__webpack_require__(73));
	
	var propTypes = {
	  active: _propTypes.default.bool,
	  disabled: _propTypes.default.bool,
	  block: _propTypes.default.bool,
	  onClick: _propTypes.default.func,
	  componentClass: _elementType.default,
	  href: _propTypes.default.string,
	
	  /**
	   * Defines HTML button type attribute
	   * @defaultValue 'button'
	   */
	  type: _propTypes.default.oneOf(['button', 'reset', 'submit'])
	};
	var defaultProps = {
	  active: false,
	  block: false,
	  disabled: false
	};
	
	var Button =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(Button, _React$Component);
	
	  function Button() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = Button.prototype;
	
	  _proto.renderAnchor = function renderAnchor(elementProps, className) {
	    return _react.default.createElement(_SafeAnchor.default, (0, _extends3.default)({}, elementProps, {
	      className: (0, _classnames.default)(className, elementProps.disabled && 'disabled')
	    }));
	  };
	
	  _proto.renderButton = function renderButton(_ref, className) {
	    var componentClass = _ref.componentClass,
	        elementProps = (0, _objectWithoutPropertiesLoose2.default)(_ref, ["componentClass"]);
	    var Component = componentClass || 'button';
	    return _react.default.createElement(Component, (0, _extends3.default)({}, elementProps, {
	      type: elementProps.type || 'button',
	      className: className
	    }));
	  };
	
	  _proto.render = function render() {
	    var _extends2;
	
	    var _this$props = this.props,
	        active = _this$props.active,
	        block = _this$props.block,
	        className = _this$props.className,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["active", "block", "className"]);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends3.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {
	      active: active
	    }, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'block')] = block, _extends2));
	    var fullClassName = (0, _classnames.default)(className, classes);
	
	    if (elementProps.href) {
	      return this.renderAnchor(elementProps, fullClassName);
	    }
	
	    return this.renderButton(elementProps, fullClassName);
	  };
	
	  return Button;
	}(_react.default.Component);
	
	Button.propTypes = propTypes;
	Button.defaultProps = defaultProps;
	
	var _default = (0, _bootstrapUtils.bsClass)('btn', (0, _bootstrapUtils.bsSizes)([_StyleConfig.Size.LARGE, _StyleConfig.Size.SMALL, _StyleConfig.Size.XSMALL], (0, _bootstrapUtils.bsStyles)((0, _values.default)(_StyleConfig.State).concat([_StyleConfig.Style.DEFAULT, _StyleConfig.Style.PRIMARY, _StyleConfig.Style.LINK]), _StyleConfig.Style.DEFAULT, Button)));
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 159 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(8));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _Dropdown = _interopRequireDefault(__webpack_require__(216));
	
	var _splitComponentProps2 = _interopRequireDefault(__webpack_require__(219));
	
	var propTypes = (0, _extends2.default)({}, _Dropdown.default.propTypes, {
	  // Toggle props.
	  bsStyle: _propTypes.default.string,
	  bsSize: _propTypes.default.string,
	  title: _propTypes.default.node.isRequired,
	  noCaret: _propTypes.default.bool,
	  // Override generated docs from <Dropdown>.
	
	  /**
	   * @private
	   */
	  children: _propTypes.default.node
	});
	
	var DropdownButton =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(DropdownButton, _React$Component);
	
	  function DropdownButton() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = DropdownButton.prototype;
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        bsSize = _this$props.bsSize,
	        bsStyle = _this$props.bsStyle,
	        title = _this$props.title,
	        children = _this$props.children,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["bsSize", "bsStyle", "title", "children"]);
	
	    var _splitComponentProps = (0, _splitComponentProps2.default)(props, _Dropdown.default.ControlledComponent),
	        dropdownProps = _splitComponentProps[0],
	        toggleProps = _splitComponentProps[1];
	
	    return _react.default.createElement(_Dropdown.default, (0, _extends2.default)({}, dropdownProps, {
	      bsSize: bsSize,
	      bsStyle: bsStyle
	    }), _react.default.createElement(_Dropdown.default.Toggle, (0, _extends2.default)({}, toggleProps, {
	      bsSize: bsSize,
	      bsStyle: bsStyle
	    }), title), _react.default.createElement(_Dropdown.default.Menu, null, children));
	  };
	
	  return DropdownButton;
	}(_react.default.Component);
	
	DropdownButton.propTypes = propTypes;
	var _default = DropdownButton;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 160 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(1848);
	} else {
	  module.exports = require('./cjs/react-is.development.js');
	}


/***/ },
/* 161 */
[2190, 1895],
/* 162 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var formatName = function formatName(_ref, name) {
	  var sectionPrefix = _ref._reduxForm.sectionPrefix;
	  return sectionPrefix ? sectionPrefix + "." + name : name;
	};
	
	var _default = formatName;
	exports["default"] = _default;

/***/ },
/* 163 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var $$observable = _interopDefault(__webpack_require__(2176));
	
	/**
	 * These are private action types reserved by Redux.
	 * For any unknown actions, you must return the current state.
	 * If the current state is undefined, you must return the initial state.
	 * Do not reference these action types directly in your code.
	 */
	var randomString = function randomString() {
	  return Math.random().toString(36).substring(7).split('').join('.');
	};
	
	var ActionTypes = {
	  INIT: "@@redux/INIT" + randomString(),
	  REPLACE: "@@redux/REPLACE" + randomString(),
	  PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
	    return "@@redux/PROBE_UNKNOWN_ACTION" + randomString();
	  }
	};
	
	/**
	 * @param {any} obj The object to inspect.
	 * @returns {boolean} True if the argument appears to be a plain object.
	 */
	function isPlainObject(obj) {
	  if (typeof obj !== 'object' || obj === null) return false;
	  var proto = obj;
	
	  while (Object.getPrototypeOf(proto) !== null) {
	    proto = Object.getPrototypeOf(proto);
	  }
	
	  return Object.getPrototypeOf(obj) === proto;
	}
	
	/**
	 * Creates a Redux store that holds the state tree.
	 * The only way to change the data in the store is to call `dispatch()` on it.
	 *
	 * There should only be a single store in your app. To specify how different
	 * parts of the state tree respond to actions, you may combine several reducers
	 * into a single reducer function by using `combineReducers`.
	 *
	 * @param {Function} reducer A function that returns the next state tree, given
	 * the current state tree and the action to handle.
	 *
	 * @param {any} [preloadedState] The initial state. You may optionally specify it
	 * to hydrate the state from the server in universal apps, or to restore a
	 * previously serialized user session.
	 * If you use `combineReducers` to produce the root reducer function, this must be
	 * an object with the same shape as `combineReducers` keys.
	 *
	 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
	 * to enhance the store with third-party capabilities such as middleware,
	 * time travel, persistence, etc. The only store enhancer that ships with Redux
	 * is `applyMiddleware()`.
	 *
	 * @returns {Store} A Redux store that lets you read the state, dispatch actions
	 * and subscribe to changes.
	 */
	
	function createStore(reducer, preloadedState, enhancer) {
	  var _ref2;
	
	  if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') {
	    throw new Error('It looks like you are passing several store enhancers to ' + 'createStore(). This is not supported. Instead, compose them ' + 'together to a single function.');
	  }
	
	  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
	    enhancer = preloadedState;
	    preloadedState = undefined;
	  }
	
	  if (typeof enhancer !== 'undefined') {
	    if (typeof enhancer !== 'function') {
	      throw new Error('Expected the enhancer to be a function.');
	    }
	
	    return enhancer(createStore)(reducer, preloadedState);
	  }
	
	  if (typeof reducer !== 'function') {
	    throw new Error('Expected the reducer to be a function.');
	  }
	
	  var currentReducer = reducer;
	  var currentState = preloadedState;
	  var currentListeners = [];
	  var nextListeners = currentListeners;
	  var isDispatching = false;
	  /**
	   * This makes a shallow copy of currentListeners so we can use
	   * nextListeners as a temporary list while dispatching.
	   *
	   * This prevents any bugs around consumers calling
	   * subscribe/unsubscribe in the middle of a dispatch.
	   */
	
	  function ensureCanMutateNextListeners() {
	    if (nextListeners === currentListeners) {
	      nextListeners = currentListeners.slice();
	    }
	  }
	  /**
	   * Reads the state tree managed by the store.
	   *
	   * @returns {any} The current state tree of your application.
	   */
	
	
	  function getState() {
	    if (isDispatching) {
	      throw new Error('You may not call store.getState() while the reducer is executing. ' + 'The reducer has already received the state as an argument. ' + 'Pass it down from the top reducer instead of reading it from the store.');
	    }
	
	    return currentState;
	  }
	  /**
	   * Adds a change listener. It will be called any time an action is dispatched,
	   * and some part of the state tree may potentially have changed. You may then
	   * call `getState()` to read the current state tree inside the callback.
	   *
	   * You may call `dispatch()` from a change listener, with the following
	   * caveats:
	   *
	   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
	   * If you subscribe or unsubscribe while the listeners are being invoked, this
	   * will not have any effect on the `dispatch()` that is currently in progress.
	   * However, the next `dispatch()` call, whether nested or not, will use a more
	   * recent snapshot of the subscription list.
	   *
	   * 2. The listener should not expect to see all state changes, as the state
	   * might have been updated multiple times during a nested `dispatch()` before
	   * the listener is called. It is, however, guaranteed that all subscribers
	   * registered before the `dispatch()` started will be called with the latest
	   * state by the time it exits.
	   *
	   * @param {Function} listener A callback to be invoked on every dispatch.
	   * @returns {Function} A function to remove this change listener.
	   */
	
	
	  function subscribe(listener) {
	    if (typeof listener !== 'function') {
	      throw new Error('Expected the listener to be a function.');
	    }
	
	    if (isDispatching) {
	      throw new Error('You may not call store.subscribe() while the reducer is executing. ' + 'If you would like to be notified after the store has been updated, subscribe from a ' + 'component and invoke store.getState() in the callback to access the latest state. ' + 'See https://redux.js.org/api-reference/store#subscribelistener for more details.');
	    }
	
	    var isSubscribed = true;
	    ensureCanMutateNextListeners();
	    nextListeners.push(listener);
	    return function unsubscribe() {
	      if (!isSubscribed) {
	        return;
	      }
	
	      if (isDispatching) {
	        throw new Error('You may not unsubscribe from a store listener while the reducer is executing. ' + 'See https://redux.js.org/api-reference/store#subscribelistener for more details.');
	      }
	
	      isSubscribed = false;
	      ensureCanMutateNextListeners();
	      var index = nextListeners.indexOf(listener);
	      nextListeners.splice(index, 1);
	      currentListeners = null;
	    };
	  }
	  /**
	   * Dispatches an action. It is the only way to trigger a state change.
	   *
	   * The `reducer` function, used to create the store, will be called with the
	   * current state tree and the given `action`. Its return value will
	   * be considered the **next** state of the tree, and the change listeners
	   * will be notified.
	   *
	   * The base implementation only supports plain object actions. If you want to
	   * dispatch a Promise, an Observable, a thunk, or something else, you need to
	   * wrap your store creating function into the corresponding middleware. For
	   * example, see the documentation for the `redux-thunk` package. Even the
	   * middleware will eventually dispatch plain object actions using this method.
	   *
	   * @param {Object} action A plain object representing “what changed”. It is
	   * a good idea to keep actions serializable so you can record and replay user
	   * sessions, or use the time travelling `redux-devtools`. An action must have
	   * a `type` property which may not be `undefined`. It is a good idea to use
	   * string constants for action types.
	   *
	   * @returns {Object} For convenience, the same action object you dispatched.
	   *
	   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
	   * return something else (for example, a Promise you can await).
	   */
	
	
	  function dispatch(action) {
	    if (!isPlainObject(action)) {
	      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
	    }
	
	    if (typeof action.type === 'undefined') {
	      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
	    }
	
	    if (isDispatching) {
	      throw new Error('Reducers may not dispatch actions.');
	    }
	
	    try {
	      isDispatching = true;
	      currentState = currentReducer(currentState, action);
	    } finally {
	      isDispatching = false;
	    }
	
	    var listeners = currentListeners = nextListeners;
	
	    for (var i = 0; i < listeners.length; i++) {
	      var listener = listeners[i];
	      listener();
	    }
	
	    return action;
	  }
	  /**
	   * Replaces the reducer currently used by the store to calculate the state.
	   *
	   * You might need this if your app implements code splitting and you want to
	   * load some of the reducers dynamically. You might also need this if you
	   * implement a hot reloading mechanism for Redux.
	   *
	   * @param {Function} nextReducer The reducer for the store to use instead.
	   * @returns {void}
	   */
	
	
	  function replaceReducer(nextReducer) {
	    if (typeof nextReducer !== 'function') {
	      throw new Error('Expected the nextReducer to be a function.');
	    }
	
	    currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
	    // Any reducers that existed in both the new and old rootReducer
	    // will receive the previous state. This effectively populates
	    // the new state tree with any relevant data from the old one.
	
	    dispatch({
	      type: ActionTypes.REPLACE
	    });
	  }
	  /**
	   * Interoperability point for observable/reactive libraries.
	   * @returns {observable} A minimal observable of state changes.
	   * For more information, see the observable proposal:
	   * https://github.com/tc39/proposal-observable
	   */
	
	
	  function observable() {
	    var _ref;
	
	    var outerSubscribe = subscribe;
	    return _ref = {
	      /**
	       * The minimal observable subscription method.
	       * @param {Object} observer Any object that can be used as an observer.
	       * The observer object should have a `next` method.
	       * @returns {subscription} An object with an `unsubscribe` method that can
	       * be used to unsubscribe the observable from the store, and prevent further
	       * emission of values from the observable.
	       */
	      subscribe: function subscribe(observer) {
	        if (typeof observer !== 'object' || observer === null) {
	          throw new TypeError('Expected the observer to be an object.');
	        }
	
	        function observeState() {
	          if (observer.next) {
	            observer.next(getState());
	          }
	        }
	
	        observeState();
	        var unsubscribe = outerSubscribe(observeState);
	        return {
	          unsubscribe: unsubscribe
	        };
	      }
	    }, _ref[$$observable] = function () {
	      return this;
	    }, _ref;
	  } // When a store is created, an "INIT" action is dispatched so that every
	  // reducer returns their initial state. This effectively populates
	  // the initial state tree.
	
	
	  dispatch({
	    type: ActionTypes.INIT
	  });
	  return _ref2 = {
	    dispatch: dispatch,
	    subscribe: subscribe,
	    getState: getState,
	    replaceReducer: replaceReducer
	  }, _ref2[$$observable] = observable, _ref2;
	}
	
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	
	
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	  } catch (e) {} // eslint-disable-line no-empty
	
	}
	
	function getUndefinedStateErrorMessage(key, action) {
	  var actionType = action && action.type;
	  var actionDescription = actionType && "action \"" + String(actionType) + "\"" || 'an action';
	  return "Given " + actionDescription + ", reducer \"" + key + "\" returned undefined. " + "To ignore an action, you must explicitly return the previous state. " + "If you want this reducer to hold no value, you can return null instead of undefined.";
	}
	
	function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
	  var reducerKeys = Object.keys(reducers);
	  var argumentName = action && action.type === ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
	
	  if (reducerKeys.length === 0) {
	    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
	  }
	
	  if (!isPlainObject(inputState)) {
	    return "The " + argumentName + " has unexpected type of \"" + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + "\". Expected argument to be an object with the following " + ("keys: \"" + reducerKeys.join('", "') + "\"");
	  }
	
	  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
	    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
	  });
	  unexpectedKeys.forEach(function (key) {
	    unexpectedKeyCache[key] = true;
	  });
	  if (action && action.type === ActionTypes.REPLACE) return;
	
	  if (unexpectedKeys.length > 0) {
	    return "Unexpected " + (unexpectedKeys.length > 1 ? 'keys' : 'key') + " " + ("\"" + unexpectedKeys.join('", "') + "\" found in " + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ("\"" + reducerKeys.join('", "') + "\". Unexpected keys will be ignored.");
	  }
	}
	
	function assertReducerShape(reducers) {
	  Object.keys(reducers).forEach(function (key) {
	    var reducer = reducers[key];
	    var initialState = reducer(undefined, {
	      type: ActionTypes.INIT
	    });
	
	    if (typeof initialState === 'undefined') {
	      throw new Error("Reducer \"" + key + "\" returned undefined during initialization. " + "If the state passed to the reducer is undefined, you must " + "explicitly return the initial state. The initial state may " + "not be undefined. If you don't want to set a value for this reducer, " + "you can use null instead of undefined.");
	    }
	
	    if (typeof reducer(undefined, {
	      type: ActionTypes.PROBE_UNKNOWN_ACTION()
	    }) === 'undefined') {
	      throw new Error("Reducer \"" + key + "\" returned undefined when probed with a random type. " + ("Don't try to handle " + ActionTypes.INIT + " or other actions in \"redux/*\" ") + "namespace. They are considered private. Instead, you must return the " + "current state for any unknown actions, unless it is undefined, " + "in which case you must return the initial state, regardless of the " + "action type. The initial state may not be undefined, but can be null.");
	    }
	  });
	}
	/**
	 * Turns an object whose values are different reducer functions, into a single
	 * reducer function. It will call every child reducer, and gather their results
	 * into a single state object, whose keys correspond to the keys of the passed
	 * reducer functions.
	 *
	 * @param {Object} reducers An object whose values correspond to different
	 * reducer functions that need to be combined into one. One handy way to obtain
	 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
	 * undefined for any action. Instead, they should return their initial state
	 * if the state passed to them was undefined, and the current state for any
	 * unrecognized action.
	 *
	 * @returns {Function} A reducer function that invokes every reducer inside the
	 * passed object, and builds a state object with the same shape.
	 */
	
	
	function combineReducers(reducers) {
	  var reducerKeys = Object.keys(reducers);
	  var finalReducers = {};
	
	  for (var i = 0; i < reducerKeys.length; i++) {
	    var key = reducerKeys[i];
	
	    if (false) {
	      if (typeof reducers[key] === 'undefined') {
	        warning("No reducer provided for key \"" + key + "\"");
	      }
	    }
	
	    if (typeof reducers[key] === 'function') {
	      finalReducers[key] = reducers[key];
	    }
	  }
	
	  var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
	  // keys multiple times.
	
	  var unexpectedKeyCache;
	
	  if (false) {
	    unexpectedKeyCache = {};
	  }
	
	  var shapeAssertionError;
	
	  try {
	    assertReducerShape(finalReducers);
	  } catch (e) {
	    shapeAssertionError = e;
	  }
	
	  return function combination(state, action) {
	    if (state === void 0) {
	      state = {};
	    }
	
	    if (shapeAssertionError) {
	      throw shapeAssertionError;
	    }
	
	    if (false) {
	      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
	
	      if (warningMessage) {
	        warning(warningMessage);
	      }
	    }
	
	    var hasChanged = false;
	    var nextState = {};
	
	    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
	      var _key = finalReducerKeys[_i];
	      var reducer = finalReducers[_key];
	      var previousStateForKey = state[_key];
	      var nextStateForKey = reducer(previousStateForKey, action);
	
	      if (typeof nextStateForKey === 'undefined') {
	        var errorMessage = getUndefinedStateErrorMessage(_key, action);
	        throw new Error(errorMessage);
	      }
	
	      nextState[_key] = nextStateForKey;
	      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
	    }
	
	    hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
	    return hasChanged ? nextState : state;
	  };
	}
	
	function bindActionCreator(actionCreator, dispatch) {
	  return function () {
	    return dispatch(actionCreator.apply(this, arguments));
	  };
	}
	/**
	 * Turns an object whose values are action creators, into an object with the
	 * same keys, but with every function wrapped into a `dispatch` call so they
	 * may be invoked directly. This is just a convenience method, as you can call
	 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
	 *
	 * For convenience, you can also pass an action creator as the first argument,
	 * and get a dispatch wrapped function in return.
	 *
	 * @param {Function|Object} actionCreators An object whose values are action
	 * creator functions. One handy way to obtain it is to use ES6 `import * as`
	 * syntax. You may also pass a single function.
	 *
	 * @param {Function} dispatch The `dispatch` function available on your Redux
	 * store.
	 *
	 * @returns {Function|Object} The object mimicking the original object, but with
	 * every action creator wrapped into the `dispatch` call. If you passed a
	 * function as `actionCreators`, the return value will also be a single
	 * function.
	 */
	
	
	function bindActionCreators(actionCreators, dispatch) {
	  if (typeof actionCreators === 'function') {
	    return bindActionCreator(actionCreators, dispatch);
	  }
	
	  if (typeof actionCreators !== 'object' || actionCreators === null) {
	    throw new Error("bindActionCreators expected an object or a function, instead received " + (actionCreators === null ? 'null' : typeof actionCreators) + ". " + "Did you write \"import ActionCreators from\" instead of \"import * as ActionCreators from\"?");
	  }
	
	  var boundActionCreators = {};
	
	  for (var key in actionCreators) {
	    var actionCreator = actionCreators[key];
	
	    if (typeof actionCreator === 'function') {
	      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
	    }
	  }
	
	  return boundActionCreators;
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	}
	
	function ownKeys(object, enumerableOnly) {
	  var keys = Object.keys(object);
	
	  if (Object.getOwnPropertySymbols) {
	    keys.push.apply(keys, Object.getOwnPropertySymbols(object));
	  }
	
	  if (enumerableOnly) keys = keys.filter(function (sym) {
	    return Object.getOwnPropertyDescriptor(object, sym).enumerable;
	  });
	  return keys;
	}
	
	function _objectSpread2(target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i] != null ? arguments[i] : {};
	
	    if (i % 2) {
	      ownKeys(source, true).forEach(function (key) {
	        _defineProperty(target, key, source[key]);
	      });
	    } else if (Object.getOwnPropertyDescriptors) {
	      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
	    } else {
	      ownKeys(source).forEach(function (key) {
	        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
	      });
	    }
	  }
	
	  return target;
	}
	
	/**
	 * Composes single-argument functions from right to left. The rightmost
	 * function can take multiple arguments as it provides the signature for
	 * the resulting composite function.
	 *
	 * @param {...Function} funcs The functions to compose.
	 * @returns {Function} A function obtained by composing the argument functions
	 * from right to left. For example, compose(f, g, h) is identical to doing
	 * (...args) => f(g(h(...args))).
	 */
	function compose() {
	  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  if (funcs.length === 0) {
	    return function (arg) {
	      return arg;
	    };
	  }
	
	  if (funcs.length === 1) {
	    return funcs[0];
	  }
	
	  return funcs.reduce(function (a, b) {
	    return function () {
	      return a(b.apply(void 0, arguments));
	    };
	  });
	}
	
	/**
	 * Creates a store enhancer that applies middleware to the dispatch method
	 * of the Redux store. This is handy for a variety of tasks, such as expressing
	 * asynchronous actions in a concise manner, or logging every action payload.
	 *
	 * See `redux-thunk` package as an example of the Redux middleware.
	 *
	 * Because middleware is potentially asynchronous, this should be the first
	 * store enhancer in the composition chain.
	 *
	 * Note that each middleware will be given the `dispatch` and `getState` functions
	 * as named arguments.
	 *
	 * @param {...Function} middlewares The middleware chain to be applied.
	 * @returns {Function} A store enhancer applying the middleware.
	 */
	
	function applyMiddleware() {
	  for (var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  return function (createStore) {
	    return function () {
	      var store = createStore.apply(void 0, arguments);
	
	      var _dispatch = function dispatch() {
	        throw new Error('Dispatching while constructing your middleware is not allowed. ' + 'Other middleware would not be applied to this dispatch.');
	      };
	
	      var middlewareAPI = {
	        getState: store.getState,
	        dispatch: function dispatch() {
	          return _dispatch.apply(void 0, arguments);
	        }
	      };
	      var chain = middlewares.map(function (middleware) {
	        return middleware(middlewareAPI);
	      });
	      _dispatch = compose.apply(void 0, chain)(store.dispatch);
	      return _objectSpread2({}, store, {
	        dispatch: _dispatch
	      });
	    };
	  };
	}
	
	/*
	 * This is a dummy function to check if the function name has been altered by minification.
	 * If the function has been minified and NODE_ENV !== 'production', warn the user.
	 */
	
	function isCrushed() {}
	
	if (false) {
	  warning('You are currently using minified code outside of NODE_ENV === "production". ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or setting mode to production in webpack (https://webpack.js.org/concepts/mode/) ' + 'to ensure you have the correct code for your production build.');
	}
	
	exports.__DO_NOT_USE__ActionTypes = ActionTypes;
	exports.applyMiddleware = applyMiddleware;
	exports.bindActionCreators = bindActionCreators;
	exports.combineReducers = combineReducers;
	exports.compose = compose;
	exports.createStore = createStore;


/***/ },
/* 164 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        if (typeof b !== "function" && b !== null)
	            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.EMPTY_OBSERVER = exports.SafeSubscriber = exports.Subscriber = void 0;
	var isFunction_1 = __webpack_require__(31);
	var Subscription_1 = __webpack_require__(62);
	var config_1 = __webpack_require__(165);
	var reportUnhandledError_1 = __webpack_require__(600);
	var noop_1 = __webpack_require__(52);
	var NotificationFactories_1 = __webpack_require__(2010);
	var timeoutProvider_1 = __webpack_require__(587);
	var errorContext_1 = __webpack_require__(336);
	var Subscriber = (function (_super) {
	    __extends(Subscriber, _super);
	    function Subscriber(destination) {
	        var _this = _super.call(this) || this;
	        _this.isStopped = false;
	        if (destination) {
	            _this.destination = destination;
	            if (Subscription_1.isSubscription(destination)) {
	                destination.add(_this);
	            }
	        }
	        else {
	            _this.destination = exports.EMPTY_OBSERVER;
	        }
	        return _this;
	    }
	    Subscriber.create = function (next, error, complete) {
	        return new SafeSubscriber(next, error, complete);
	    };
	    Subscriber.prototype.next = function (value) {
	        if (this.isStopped) {
	            handleStoppedNotification(NotificationFactories_1.nextNotification(value), this);
	        }
	        else {
	            this._next(value);
	        }
	    };
	    Subscriber.prototype.error = function (err) {
	        if (this.isStopped) {
	            handleStoppedNotification(NotificationFactories_1.errorNotification(err), this);
	        }
	        else {
	            this.isStopped = true;
	            this._error(err);
	        }
	    };
	    Subscriber.prototype.complete = function () {
	        if (this.isStopped) {
	            handleStoppedNotification(NotificationFactories_1.COMPLETE_NOTIFICATION, this);
	        }
	        else {
	            this.isStopped = true;
	            this._complete();
	        }
	    };
	    Subscriber.prototype.unsubscribe = function () {
	        if (!this.closed) {
	            this.isStopped = true;
	            _super.prototype.unsubscribe.call(this);
	            this.destination = null;
	        }
	    };
	    Subscriber.prototype._next = function (value) {
	        this.destination.next(value);
	    };
	    Subscriber.prototype._error = function (err) {
	        try {
	            this.destination.error(err);
	        }
	        finally {
	            this.unsubscribe();
	        }
	    };
	    Subscriber.prototype._complete = function () {
	        try {
	            this.destination.complete();
	        }
	        finally {
	            this.unsubscribe();
	        }
	    };
	    return Subscriber;
	}(Subscription_1.Subscription));
	exports.Subscriber = Subscriber;
	var _bind = Function.prototype.bind;
	function bind(fn, thisArg) {
	    return _bind.call(fn, thisArg);
	}
	var ConsumerObserver = (function () {
	    function ConsumerObserver(partialObserver) {
	        this.partialObserver = partialObserver;
	    }
	    ConsumerObserver.prototype.next = function (value) {
	        var partialObserver = this.partialObserver;
	        if (partialObserver.next) {
	            try {
	                partialObserver.next(value);
	            }
	            catch (error) {
	                handleUnhandledError(error);
	            }
	        }
	    };
	    ConsumerObserver.prototype.error = function (err) {
	        var partialObserver = this.partialObserver;
	        if (partialObserver.error) {
	            try {
	                partialObserver.error(err);
	            }
	            catch (error) {
	                handleUnhandledError(error);
	            }
	        }
	        else {
	            handleUnhandledError(err);
	        }
	    };
	    ConsumerObserver.prototype.complete = function () {
	        var partialObserver = this.partialObserver;
	        if (partialObserver.complete) {
	            try {
	                partialObserver.complete();
	            }
	            catch (error) {
	                handleUnhandledError(error);
	            }
	        }
	    };
	    return ConsumerObserver;
	}());
	var SafeSubscriber = (function (_super) {
	    __extends(SafeSubscriber, _super);
	    function SafeSubscriber(observerOrNext, error, complete) {
	        var _this = _super.call(this) || this;
	        var partialObserver;
	        if (isFunction_1.isFunction(observerOrNext) || !observerOrNext) {
	            partialObserver = {
	                next: observerOrNext !== null && observerOrNext !== void 0 ? observerOrNext : undefined,
	                error: error !== null && error !== void 0 ? error : undefined,
	                complete: complete !== null && complete !== void 0 ? complete : undefined,
	            };
	        }
	        else {
	            var context_1;
	            if (_this && config_1.config.useDeprecatedNextContext) {
	                context_1 = Object.create(observerOrNext);
	                context_1.unsubscribe = function () { return _this.unsubscribe(); };
	                partialObserver = {
	                    next: observerOrNext.next && bind(observerOrNext.next, context_1),
	                    error: observerOrNext.error && bind(observerOrNext.error, context_1),
	                    complete: observerOrNext.complete && bind(observerOrNext.complete, context_1),
	                };
	            }
	            else {
	                partialObserver = observerOrNext;
	            }
	        }
	        _this.destination = new ConsumerObserver(partialObserver);
	        return _this;
	    }
	    return SafeSubscriber;
	}(Subscriber));
	exports.SafeSubscriber = SafeSubscriber;
	function handleUnhandledError(error) {
	    if (config_1.config.useDeprecatedSynchronousErrorHandling) {
	        errorContext_1.captureError(error);
	    }
	    else {
	        reportUnhandledError_1.reportUnhandledError(error);
	    }
	}
	function defaultErrorHandler(err) {
	    throw err;
	}
	function handleStoppedNotification(notification, subscriber) {
	    var onStoppedNotification = config_1.config.onStoppedNotification;
	    onStoppedNotification && timeoutProvider_1.timeoutProvider.setTimeout(function () { return onStoppedNotification(notification, subscriber); });
	}
	exports.EMPTY_OBSERVER = {
	    closed: true,
	    next: noop_1.noop,
	    error: defaultErrorHandler,
	    complete: noop_1.noop,
	};
	//# sourceMappingURL=Subscriber.js.map

/***/ },
/* 165 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.config = void 0;
	exports.config = {
	    onUnhandledError: null,
	    onStoppedNotification: null,
	    Promise: undefined,
	    useDeprecatedSynchronousErrorHandling: false,
	    useDeprecatedNextContext: false,
	};
	//# sourceMappingURL=config.js.map

/***/ },
/* 166 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.reduce = void 0;
	var scanInternals_1 = __webpack_require__(578);
	var lift_1 = __webpack_require__(17);
	function reduce(accumulator, seed) {
	    return lift_1.operate(scanInternals_1.scanInternals(accumulator, seed, arguments.length >= 2, false, true));
	}
	exports.reduce = reduce;
	//# sourceMappingURL=reduce.js.map

/***/ },
/* 167 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.take = void 0;
	var empty_1 = __webpack_require__(74);
	var lift_1 = __webpack_require__(17);
	var OperatorSubscriber_1 = __webpack_require__(20);
	function take(count) {
	    return count <= 0
	        ?
	            function () { return empty_1.EMPTY; }
	        : lift_1.operate(function (source, subscriber) {
	            var seen = 0;
	            source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (value) {
	                if (++seen <= count) {
	                    subscriber.next(value);
	                    if (count <= seen) {
	                        subscriber.complete();
	                    }
	                }
	            }));
	        });
	}
	exports.take = take;
	//# sourceMappingURL=take.js.map

/***/ },
/* 168 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        if (typeof b !== "function" && b !== null)
	            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.AsyncAction = void 0;
	var Action_1 = __webpack_require__(2114);
	var intervalProvider_1 = __webpack_require__(2125);
	var arrRemove_1 = __webpack_require__(99);
	var AsyncAction = (function (_super) {
	    __extends(AsyncAction, _super);
	    function AsyncAction(scheduler, work) {
	        var _this = _super.call(this, scheduler, work) || this;
	        _this.scheduler = scheduler;
	        _this.work = work;
	        _this.pending = false;
	        return _this;
	    }
	    AsyncAction.prototype.schedule = function (state, delay) {
	        if (delay === void 0) { delay = 0; }
	        if (this.closed) {
	            return this;
	        }
	        this.state = state;
	        var id = this.id;
	        var scheduler = this.scheduler;
	        if (id != null) {
	            this.id = this.recycleAsyncId(scheduler, id, delay);
	        }
	        this.pending = true;
	        this.delay = delay;
	        this.id = this.id || this.requestAsyncId(scheduler, this.id, delay);
	        return this;
	    };
	    AsyncAction.prototype.requestAsyncId = function (scheduler, _id, delay) {
	        if (delay === void 0) { delay = 0; }
	        return intervalProvider_1.intervalProvider.setInterval(scheduler.flush.bind(scheduler, this), delay);
	    };
	    AsyncAction.prototype.recycleAsyncId = function (_scheduler, id, delay) {
	        if (delay === void 0) { delay = 0; }
	        if (delay != null && this.delay === delay && this.pending === false) {
	            return id;
	        }
	        intervalProvider_1.intervalProvider.clearInterval(id);
	        return undefined;
	    };
	    AsyncAction.prototype.execute = function (state, delay) {
	        if (this.closed) {
	            return new Error('executing a cancelled action');
	        }
	        this.pending = false;
	        var error = this._execute(state, delay);
	        if (error) {
	            return error;
	        }
	        else if (this.pending === false && this.id != null) {
	            this.id = this.recycleAsyncId(this.scheduler, this.id, null);
	        }
	    };
	    AsyncAction.prototype._execute = function (state, _delay) {
	        var errored = false;
	        var errorValue;
	        try {
	            this.work(state);
	        }
	        catch (e) {
	            errored = true;
	            errorValue = e ? e : new Error('Scheduled action threw falsy error');
	        }
	        if (errored) {
	            this.unsubscribe();
	            return errorValue;
	        }
	    };
	    AsyncAction.prototype.unsubscribe = function () {
	        if (!this.closed) {
	            var _a = this, id = _a.id, scheduler = _a.scheduler;
	            var actions = scheduler.actions;
	            this.work = this.state = this.scheduler = null;
	            this.pending = false;
	            arrRemove_1.arrRemove(actions, this);
	            if (id != null) {
	                this.id = this.recycleAsyncId(scheduler, id, null);
	            }
	            this.delay = null;
	            _super.prototype.unsubscribe.call(this);
	        }
	    };
	    return AsyncAction;
	}(Action_1.Action));
	exports.AsyncAction = AsyncAction;
	//# sourceMappingURL=AsyncAction.js.map

/***/ },
/* 169 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        if (typeof b !== "function" && b !== null)
	            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.AsyncScheduler = void 0;
	var Scheduler_1 = __webpack_require__(560);
	var AsyncScheduler = (function (_super) {
	    __extends(AsyncScheduler, _super);
	    function AsyncScheduler(SchedulerAction, now) {
	        if (now === void 0) { now = Scheduler_1.Scheduler.now; }
	        var _this = _super.call(this, SchedulerAction, now) || this;
	        _this.actions = [];
	        _this._active = false;
	        _this._scheduled = undefined;
	        return _this;
	    }
	    AsyncScheduler.prototype.flush = function (action) {
	        var actions = this.actions;
	        if (this._active) {
	            actions.push(action);
	            return;
	        }
	        var error;
	        this._active = true;
	        do {
	            if ((error = action.execute(action.state, action.delay))) {
	                break;
	            }
	        } while ((action = actions.shift()));
	        this._active = false;
	        if (error) {
	            while ((action = actions.shift())) {
	                action.unsubscribe();
	            }
	            throw error;
	        }
	    };
	    return AsyncScheduler;
	}(Scheduler_1.Scheduler));
	exports.AsyncScheduler = AsyncScheduler;
	//# sourceMappingURL=AsyncScheduler.js.map

/***/ },
/* 170 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(910);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(25)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!../../../../../../node_modules/sass-loader/index.js!./payment-method-selector.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!../../../../../../node_modules/sass-loader/index.js!./payment-method-selector.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 171 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(919);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(25)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!../../../../node_modules/sass-loader/index.js!./coming-soon.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!../../../../node_modules/sass-loader/index.js!./coming-soon.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 172 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _appActions = __webpack_require__(21);
	
	var _appActions2 = _interopRequireDefault(_appActions);
	
	var _order = __webpack_require__(239);
	
	var _order2 = _interopRequireDefault(_order);
	
	var _lineItem = __webpack_require__(345);
	
	var _lineItem2 = _interopRequireDefault(_lineItem);
	
	var _localStorageApi = __webpack_require__(55);
	
	var _localStorageApi2 = _interopRequireDefault(_localStorageApi);
	
	var _lineItem3 = __webpack_require__(343);
	
	var _lineItem4 = _interopRequireDefault(_lineItem3);
	
	var _cartState = __webpack_require__(234);
	
	var _cartState2 = _interopRequireDefault(_cartState);
	
	var _fingerprintService = __webpack_require__(812);
	
	var _fingerprintService2 = _interopRequireDefault(_fingerprintService);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var order = {
	    clearOrder: function clearOrder() {
	        return function (dispatch, getState) {
	            dispatch(_cartState2.default.setHasExtraTimeCheckout(false));
	            dispatch({ type: _appActions2.default.DESTROY_ORDER });
	            _localStorageApi2.default.save(getState());
	        };
	    },
	
	    /* This is called whenever:
	    1. Order is updated.
	    2. Moved to a different state in checkout flow. */
	    updateOrderInState: function updateOrderInState(receivedOrder) {
	        return function (dispatch, getState) {
	            /*
	            receivedOrder can be empty when, for example, a new user is registered
	            or when a user with no current order logs in.
	            */
	            if (receivedOrder.data.id) {
	                dispatch({ type: _appActions2.default.UPDATE_ORDER, payload: receivedOrder });
	                _localStorageApi2.default.save(getState());
	            }
	        };
	    },
	
	    refreshOrder: function refreshOrder(locale) {
	        return function (dispatch, getState) {
	            var _getState = getState();
	
	            var token = _getState.order.token;
	            var currentZone = _getState.zones.currentZone;
	
	
	            return _order2.default.get({ token: token, locale: locale, currentZone: currentZone }).then(function (response) {
	                dispatch({ type: _appActions2.default.UPDATE_ORDER, payload: response.body });
	                _localStorageApi2.default.save(getState());
	                return response;
	            });
	        };
	    },
	
	    addProductToCart: function addProductToCart(variantId) {
	        var quantity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	        var zoneId = arguments[2];
	        var locale = arguments[3];
	        var userToken = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
	        var extraParam = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
	        return function (dispatch, getState) {
	            var _getState2 = getState();
	
	            var cartOrder = _getState2.order;
	            var currentMunicipality = _getState2.municipalities.currentMunicipality;
	
	            if (cartOrder.id === undefined) {
	                return _fingerprintService2.default.info.then(function (fpInfo) {
	                    return _order2.default.create(locale, userToken, fpInfo, currentMunicipality).then(function (response) {
	                        var cart = response.body.data;
	
	                        dispatch({
	                            type: _appActions2.default.CREATE_ORDER,
	                            payload: _extends({}, cartOrder, { store: getState().stores.currentStore }, cart.attributes, { id: cart.id
	                            })
	                        });
	                        _localStorageApi2.default.save(getState());
	
	                        return dispatch(_lineItem4.default.addLineItem({
	                            variantId: variantId,
	                            quantity: quantity,
	                            zoneId: zoneId,
	                            orderToken: cart.attributes.token,
	                            locale: locale,
	                            extraParam: extraParam
	                        }));
	                    });
	                });
	            }
	            return dispatch(_lineItem4.default.addLineItem({
	                variantId: variantId,
	                quantity: quantity,
	                zoneId: zoneId,
	                orderToken: cartOrder.token,
	                locale: locale,
	                extraParam: extraParam
	            }));
	        };
	    },
	
	    emptyCart: function emptyCart(cartOrder, locale) {
	        var initialToken = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	        return function (dispatch, getState) {
	            var token = initialToken === null ? cartOrder.token : initialToken;
	            return _order2.default.destroy({ token: token, locale: locale }).then(function (response) {
	                return response;
	            }).finally(function () {
	                // no matter what response we receive, if destroy is called we want to clear the local state
	                dispatch({ type: _appActions2.default.DESTROY_ORDER });
	                dispatch(_cartState2.default.setTimeSecondsLeft(0));
	                dispatch(_cartState2.default.setHasExtraTimeCheckout(false));
	                _localStorageApi2.default.save(getState());
	            });
	        };
	    },
	
	    emptyCurrentCart: function emptyCurrentCart() {
	        return function (dispatch, getState) {
	            var _getState3 = getState();
	
	            var token = _getState3.order.token;
	            var locale = _getState3.locale.currentLocale;
	
	            return _order2.default.destroy({ token: token, locale: locale }).then(function (response) {
	                return response;
	            }).finally(function () {
	                // no matter what response we receive, if destroy is called we want to clear the local state
	                dispatch({ type: _appActions2.default.DESTROY_ORDER });
	                dispatch(_cartState2.default.setTimeSecondsLeft(0));
	                dispatch(_cartState2.default.setHasExtraTimeCheckout(false));
	                _localStorageApi2.default.save(getState());
	            });
	        };
	    },
	
	    addingProductToCart: function addingProductToCart() {
	        return function (dispatch, getState) {
	            dispatch({ type: _appActions2.default.ADDING_PRODUCT_TO_CART });
	            _localStorageApi2.default.save(getState());
	        };
	    },
	
	    addingProductToCartFix: function addingProductToCartFix(adding) {
	        return function (dispatch, getState) {
	            dispatch({ type: _appActions2.default.ADDING_PRODUCT_TO_CART_TO_FIX, payload: adding });
	            _localStorageApi2.default.save(getState());
	        };
	    },
	
	    removingProductToCart: function removingProductToCart(nextState) {
	        return function (dispatch, getState) {
	            dispatch({ type: _appActions2.default.REMOVING_PRODUCT_TO_CART, payload: nextState });
	            _localStorageApi2.default.save(getState());
	        };
	    },
	
	    removeProductFromCart: function removeProductFromCart(lineItemId, locale) {
	        return function (dispatch, getState) {
	            var token = getState().order.token;
	
	
	            return _lineItem2.default.destroy({ token: token, lineItemId: lineItemId, locale: locale }).then(function (response) {
	                dispatch({ type: _appActions2.default.REMOVE_LINE_ITEM, payload: lineItemId });
	
	                _localStorageApi2.default.save(getState());
	                return response;
	            });
	        };
	    },
	
	    removeDataExtraFromCart: function removeDataExtraFromCart(dataExtraId, locale) {
	        return function (dispatch, getState) {
	            var token = getState().order.token;
	
	
	            return _lineItem2.default.destroyDataExtra({ token: token, dataExtraId: dataExtraId, locale: locale }).then(function (response) {
	                dispatch({ type: _appActions2.default.REMOVE_DATA_EXTRA_ITEM, payload: response.body });
	
	                _localStorageApi2.default.save(getState());
	                return response;
	            });
	        };
	    },
	
	    changeProductQuantityFromCart: function changeProductQuantityFromCart(quantity, lineItemId, zoneId, locale) {
	        return function (dispatch, getState) {
	            var token = getState().order.token;
	
	            return _lineItem2.default.update({
	                quantity: quantity,
	                token: token,
	                lineItemId: lineItemId,
	                zoneId: zoneId,
	                locale: locale
	            }).then(function (response) {
	                dispatch({ type: _appActions2.default.UPDATE_LINE_ITEM, payload: response.body });
	
	                _localStorageApi2.default.save(getState());
	                return response;
	            });
	        };
	    },
	
	    getById: function getById(id) {
	        return function (dispatch, getState) {
	            var token = getState().order.token;
	
	            return _order2.default.getById({ id: id, token: token });
	        };
	    },
	    setIsFinalStepHappening: function setIsFinalStepHappening(isFinalStepHappening) {
	        return {
	            type: _appActions2.default.SET_IS_FINAL_STEP_HAPPENING,
	            payload: isFinalStepHappening
	        };
	    },
	    syncOrderFromStorage: function syncOrderFromStorage(newOrder) {
	        return {
	            type: _appActions2.default.SYNC_ORDER_FROM_STORAGE,
	            payload: newOrder
	        };
	    }
	};
	
	exports.default = order;

/***/ },
/* 173 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var request = __webpack_require__(67);
	
	var StoreAPI = {
	    getStores: function getStores() {
	        return request.get(("https://staging.api.cubalicores.com") + '/api/v1/multi_stores').set('Accept', 'application/json').send();
	    },
	
	    getGroupedStores: function getGroupedStores() {
	        return request.get(("https://staging.api.cubalicores.com") + '/api/v2/storefront/grouped_stores').set('Accept', 'application/json').send();
	    },
	    getStoreById: function getStoreById(storeId) {
	        return request.get(("https://staging.api.cubalicores.com") + '/api/v1/multi_stores/' + storeId).set('Accept', 'application/json').send();
	    },
	
	    getStorePayments: function getStorePayments(storeId) {
	        return request.get(("https://staging.api.cubalicores.com") + '/api/v1/multi_stores/' + storeId + '/payment').set('Accept', 'application/json').send();
	    },
	
	    getStoresByZone: function getStoresByZone(zoneId, page, limit) {
	        return request.get(("https://staging.api.cubalicores.com") + '/api/v2/storefront/stores').query({ zoneId: zoneId, page: page, limit: limit }).set('Accept', 'application/json').send();
	    }
	};
	
	exports.default = StoreAPI;

/***/ },
/* 174 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _noImageSmall = __webpack_require__(465);
	
	var _noImageSmall2 = _interopRequireDefault(_noImageSmall);
	
	var _urlSanitizer = __webpack_require__(123);
	
	var _urlSanitizer2 = _interopRequireDefault(_urlSanitizer);
	
	var _helper = __webpack_require__(60);
	
	var _lineItem = __webpack_require__(2140);
	
	var _lineItem2 = _interopRequireDefault(_lineItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable prefer-const */
	
	
	var LineItem = function (_Component) {
	    _inherits(LineItem, _Component);
	
	    function LineItem() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, LineItem);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = LineItem.__proto__ || Object.getPrototypeOf(LineItem)).call.apply(_ref, [this].concat(args))), _this), _this.buildPhones = function (data, types) {
	            if (types) {
	                var phoneType = types.find(function (_ref2) {
	                    var attributes = _ref2.attributes;
	                    return attributes.field_type === 'phone';
	                });
	                var phoneData = data.filter(function (_ref3) {
	                    var attributes = _ref3.attributes;
	                    return attributes.type_id === Number(phoneType.id);
	                });
	
	                return phoneData.map(function (_ref4) {
	                    var id = _ref4.id;
	                    var attributes = _ref4.attributes;
	                    return _react2.default.createElement(
	                        'div',
	                        { key: attributes.value },
	                        _react2.default.createElement(
	                            'span',
	                            null,
	                            (0, _helper.getPhone)(attributes.value)
	                        )
	                    );
	                });
	            }
	
	            return null;
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(LineItem, [{
	        key: 'render',
	        value: function render() {
	            // eslint-disable-next-line object-curly-newline
	            var _props = this.props;
	            var lineItem = _props.lineItem;
	            var _props$customContent = _props.customContent;
	            var customContent = _props$customContent === undefined ? false : _props$customContent;
	            var _props$col = _props.col1;
	            var col1 = _props$col === undefined ? false : _props$col;
	            var _props$col2 = _props.col2;
	            var col2 = _props$col2 === undefined ? false : _props$col2;
	            var _props$col3 = _props.col3;
	            var col3 = _props$col3 === undefined ? false : _props$col3;
	            var _props$noBottomBorder = _props.noBottomBorder;
	            var noBottomBorder = _props$noBottomBorder === undefined ? false : _props$noBottomBorder;
	
	            if (!customContent) {
	                var image = lineItem.variant.images[0];
	                var imageUrl = image && image.attributes && image.attributes.styles.length > 0 ? _urlSanitizer2.default.makeAbsolute(image.attributes.styles[0].url) : _noImageSmall2.default;
	                col1 = _react2.default.createElement('img', { className: 'shipment-line-item-image', alt: lineItem.attributes.name, src: imageUrl });
	                col2 = _react2.default.createElement(
	                    'div',
	                    { className: _lineItem2.default.lineItemNameDetailContainer },
	                    _react2.default.createElement(
	                        'span',
	                        { className: _lineItem2.default.lineItemName },
	                        _react2.default.createElement(
	                            'strong',
	                            null,
	                            lineItem.attributes.name
	                        ),
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            lineItem.variant.attributes.display_price + ' x ' + lineItem.attributes.quantity
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: _lineItem2.default.lineItemPhones },
	                        this.buildPhones(lineItem.data_extras, lineItem.data_extra_types)
	                    )
	                );
	                col3 = _react2.default.createElement(
	                    'span',
	                    null,
	                    '' + _helper.priceFormat.format(lineItem.variant.attributes.price * lineItem.attributes.quantity)
	                );
	            }
	            return _react2.default.createElement(
	                'div',
	                { className: 'row shipment-line-item checkout-line-item-row order-items-row ' + (noBottomBorder ? 'no-bottom-border' : '') },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-sm-2 col-xs-3 checkout-line-item-image-block order-items-image-block' },
	                    col1
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-sm-8 col-xs-6 order-items-content-block' },
	                    col2
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-sm-2 col-xs-3 order-items-content-block' },
	                    col3
	                )
	            );
	        }
	    }]);
	
	    return LineItem;
	}(_react.Component);
	
	exports.default = LineItem;

/***/ },
/* 175 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _parser = __webpack_require__(737);
	
	var Configs = {
	    HOME: {
	        STORES_IN_ZONES: (0, _parser.configApp)('SHOW_HOME_STORES_IN_ZONES', true)
	    },
	    SECONDARY_MENU: {
	        STORES: (0, _parser.configApp)('SHOW_SECONDARY_MENU_STORES', true),
	        CATEGORIES: (0, _parser.configApp)('SHOW_SECONDARY_MENU_CATEGORIES', true)
	    },
	    GOOGLE_ANALYTICS: {
	        ENABLE: (0, _parser.configApp)('GOOGLE_ANALYTICS_ENABLE_TAG', true),
	        TRACKING_ID: (0, _parser.configApp)('GOOGLE_ANALYTICS_TRACKING_ID', 'G-E5VSDLHG6E')
	    },
	    ROUTES: {
	        ENABLE_MERCADO_UNICO_PRODUCTS: (0, _parser.configApp)('ROUTE_ENABLE_MERCADO_UNICO_PRODUCTS', true)
	    }
	};
	
	exports.default = Configs;

/***/ },
/* 176 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(41);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _reactRedux = __webpack_require__(18);
	
	var _actions = __webpack_require__(23);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	var _municipality = __webpack_require__(652);
	
	var _municipality2 = _interopRequireDefault(_municipality);
	
	var _taxons = __webpack_require__(347);
	
	var _taxons2 = _interopRequireDefault(_taxons);
	
	var _zones = __webpack_require__(653);
	
	var _zones2 = _interopRequireDefault(_zones);
	
	var _localStorageApi = __webpack_require__(55);
	
	var _localStorageApi2 = _interopRequireDefault(_localStorageApi);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	    return {
	        taxons: state.taxons,
	        user: state.user,
	        navigation: state.navigation,
	        locale: state.locale,
	        order: state.order,
	        currentStore: state.stores.currentStore,
	        currentZone: state.zones.currentZone,
	        availableZones: state.zones.availableZones,
	        stores: state.stores.stores,
	        storesByZone: state.stores.storesByZone,
	        pageCount: state.stores.pageCount,
	        displayLoader: state.displayLoader
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        // TODO: Remover este filtro y traer por default de la api solo el filter[roots]=1
	        rootTaxon: function rootTaxon(taxons) {
	            return taxons.filter(function (taxon) {
	                return taxon.attributes.permalink === 'mercado-unico';
	            })[0];
	        },
	
	        triggerInitialSetup: function () {
	            var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(locale, currentStore, order) {
	                var zones, municipalities, response, store, taxonsMenu, fetchedTaxons, taxonRoot, taxonsCategory, taxonCategorySubcategory;
	                return _regenerator2.default.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                zones = [];
	                                _context.next = 3;
	                                return _zones2.default.getZones().then(function (response) {
	                                    zones = response.body.zones;
	                                });
	
	                            case 3:
	
	                                dispatch(_actions2.default.setAvailableZones(zones));
	
	                                _context.next = 6;
	                                return _municipality2.default.getMunicipalities();
	
	                            case 6:
	                                municipalities = _context.sent;
	
	                                dispatch(_actions2.default.setAvailableMunicipalities(municipalities));
	
	                                _context.next = 10;
	                                return dispatch(_actions2.default.fetchStores());
	
	                            case 10:
	                                response = _context.sent;
	                                store = response.find(function (store) {
	                                    return currentStore ? store.id === currentStore.id : store.id === 1;
	                                });
	
	                                if (store) {
	                                    currentStore = store;
	                                } else {
	                                    // eslint-disable-next-line prefer-destructuring
	                                    currentStore = response[0];
	                                }
	                                if (order.id && order.store && Object.prototype.hasOwnProperty.call(order.store, 'id') && response.findIndex(function (store) {
	                                    return store.id === order.store.id;
	                                }) === -1) {
	                                    dispatch(_actions2.default.emptyCart(order, locale)).then(function () {}, function (error) {
	                                        console.log(error);
	                                    });
	                                }
	                                taxonsMenu = [];
	                                _context.next = 17;
	                                return _taxons2.default.getTaxons(currentStore.id);
	
	                            case 17:
	                                fetchedTaxons = _context.sent;
	                                taxonRoot = fetchedTaxons.filter(function (taxon) {
	                                    return taxon.parent_id === null;
	                                })[0];
	                                taxonsCategory = fetchedTaxons.filter(function (taxon) {
	                                    return taxon.parent_id === taxonRoot.id;
	                                });
	                                taxonCategorySubcategory = taxonsCategory.map(function (taxonCategory) {
	                                    return {
	                                        taxonCategory: taxonCategory,
	                                        taxons: fetchedTaxons.filter(function (taxon) {
	                                            return taxon.parent_id === taxonCategory.id;
	                                        })
	                                    };
	                                });
	
	                                taxonsMenu.push({ store: currentStore, taxonRoot: taxonRoot, taxons: [].concat(_toConsumableArray(taxonCategorySubcategory)) });
	
	                                dispatch(_actions2.default.addTaxons({ taxonsMenu: taxonsMenu, fetchedTaxons: fetchedTaxons }));
	
	                            case 23:
	                            case 'end':
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, undefined);
	            }));
	
	            return function triggerInitialSetup(_x, _x2, _x3) {
	                return _ref.apply(this, arguments);
	            };
	        }()
	    };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps);

/***/ },
/* 177 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(41);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _reactRedux = __webpack_require__(18);
	
	var _reactReduxToastr = __webpack_require__(42);
	
	var _actions = __webpack_require__(23);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	var _appTranslations = __webpack_require__(33);
	
	var _appTranslations2 = _interopRequireDefault(_appTranslations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var distinctProducts = function distinctProducts(products) {
	    var productsFilters = [];
	
	    // eslint-disable-next-line no-restricted-syntax
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	        var _loop = function _loop() {
	            var product = _step.value;
	
	            var filterCondition = productsFilters.findIndex(function (item) {
	                return item.id === product.id;
	            }) === -1;
	            if (filterCondition) {
	                productsFilters.push(product);
	            }
	        };
	
	        for (var _iterator = products[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            _loop();
	        }
	    } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	    } finally {
	        try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	                _iterator.return();
	            }
	        } finally {
	            if (_didIteratorError) {
	                throw _iteratorError;
	            }
	        }
	    }
	
	    return productsFilters;
	};
	
	var fetchedProducts = function fetchedProducts(dispatch, locale) {
	    return dispatch(_actions2.default.fetchProducts({ page_no: 1, locale: locale })).then(function (response) {
	        var fetchedProducts = response.body;
	
	        if (fetchedProducts.data.length === 0) {
	            _reactReduxToastr.toastr.info('' + _appTranslations2.default[locale]['no-products-found']);
	        }
	        dispatch(_actions2.default.addProducts({ products: distinctProducts(fetchedProducts.data), meta: fetchedProducts.meta }));
	        dispatch(_actions2.default.hideLoader());
	    }, function (err) {
	        return console.log(err);
	    });
	};
	
	var fetchedAllStoreProducts = function fetchedAllStoreProducts(dispatch, locale) {
	    return dispatch(_actions2.default.fetchAllStoreProducts({ page_no: 1, locale: locale })).then(function (response) {
	        var fetchedProducts = response.body;
	
	        if (fetchedProducts.data.length === 0) {
	            _reactReduxToastr.toastr.info('' + _appTranslations2.default[locale]['no-recommended-found']);
	        }
	
	        dispatch(_actions2.default.addAllStoreProducts({ allStoreProducts: distinctProducts(fetchedProducts.data), meta: fetchedProducts.meta }));
	        dispatch(_actions2.default.hideLoader());
	    });
	};
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	    return {
	        taxons: state.taxons,
	        products: state.productList.products,
	        allStoreProducts: state.productList.allStoreProducts,
	        navigation: state.navigation,
	        pageCount: state.productList.meta.total_pages,
	        displayLoader: state.displayLoader,
	        locale: state.locale,
	        user: state.user,
	        order: state.order,
	        stores: state.stores.stores,
	        currentStore: state.stores.currentStore,
	        currentZone: state.zones.currentZone,
	        availableZones: state.zones.availableZones
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch, getState) {
	    return {
	        triggerInitialSetup: function () {
	            var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(locale) {
	                return _regenerator2.default.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                dispatch(_actions2.default.displayLoader());
	                                fetchedProducts(dispatch, locale);
	                                // dispatch(Actions.displayLoader());
	                                // fetchedAllStoreProducts(dispatch, locale);
	
	                            case 2:
	                            case 'end':
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, undefined);
	            }));
	
	            return function triggerInitialSetup(_x) {
	                return _ref.apply(this, arguments);
	            };
	        }(),
	
	        loadStores: function loadStores(locale, currentStore, storeId) {
	            dispatch(_actions2.default.displayLoader());
	
	            // Load stores
	            dispatch(_actions2.default.fetchStores()).then(function (response) {
	                // if (!storeId) {
	                // }
	                dispatch(_actions2.default.fetchStorePayments(!currentStore.id ? response[0] : currentStore)).then(function () {
	                    fetchedProducts(dispatch, locale);
	                });
	            });
	        },
	
	        setCurrentStore: function setCurrentStore(locale, currentStore) {
	            dispatch(_actions2.default.displayLoader());
	            dispatch(_actions2.default.fetchStorePayments(currentStore)).then(function () {
	                fetchedProducts(dispatch, locale);
	            }).catch(function (err) {
	                return console.log(err);
	            });
	        },
	
	        loadMoreProducts: function loadMoreProducts(pageNo, locale) {
	            return dispatch(_actions2.default.fetchProducts({ page_no: pageNo, locale: locale })).then(function (response) {
	                var fetchedProducts = response.body;
	
	                dispatch(_actions2.default.appendProducts({ products: distinctProducts(fetchedProducts.data), meta: fetchedProducts.meta }));
	                dispatch(_actions2.default.hideLoader());
	            });
	        }
	    };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps);

/***/ },
/* 178 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reactRedux = __webpack_require__(18);
	
	var _reactRouterRedux = __webpack_require__(30);
	
	var _reactReduxToastr = __webpack_require__(42);
	
	var _baseMenu = __webpack_require__(176);
	
	var _baseMenu2 = _interopRequireDefault(_baseMenu);
	
	var _secondaryMenu = __webpack_require__(732);
	
	var _secondaryMenu2 = _interopRequireDefault(_secondaryMenu);
	
	var _actions = __webpack_require__(23);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	var _addProductToCart = __webpack_require__(249);
	
	var _refreshOrderProcess = __webpack_require__(179);
	
	var _refreshOrderProcess2 = _interopRequireDefault(_refreshOrderProcess);
	
	var _appTranslations = __webpack_require__(33);
	
	var _appTranslations2 = _interopRequireDefault(_appTranslations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var distinctProducts = function distinctProducts(products) {
	    var productsFilters = [];
	
	    // eslint-disable-next-line no-restricted-syntax
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	        var _loop = function _loop() {
	            var product = _step.value;
	
	            var filterCondition = productsFilters.findIndex(function (item) {
	                return item.id === product.id;
	            }) === -1;
	            if (filterCondition) {
	                productsFilters.push(product);
	            }
	        };
	
	        for (var _iterator = products[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            _loop();
	        }
	    } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	    } finally {
	        try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	                _iterator.return();
	            }
	        } finally {
	            if (_didIteratorError) {
	                throw _iteratorError;
	            }
	        }
	    }
	
	    return productsFilters;
	};
	
	var fetchedProducts = function fetchedProducts(dispatch, locale) {
	    return dispatch(_actions2.default.fetchProducts({ page_no: 1, locale: locale })).then(function (response) {
	        var fetchedProducts = response.body;
	
	        dispatch(_actions2.default.addProducts({ products: distinctProducts(fetchedProducts.data), meta: fetchedProducts.meta }));
	        dispatch(_actions2.default.hideLoader());
	    });
	};
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	    return {
	        availableZones: state.zones.availableZones,
	        access_token: state.auth.access_token,
	        currentZone: state.zones.currentZone,
	        stores: state.stores.stores,
	        storesGrouped: state.stores.storesGrouped,
	        currentStore: state.stores.currentStore,
	        currentMunicipality: state.municipalities.currentMunicipality,
	        availableMunicipalities: state.municipalities.availableMunicipalities
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        submitPriceForm: function submitPriceForm(priceMin, priceMax, path) {
	            if (priceMin && priceMax) {
	                dispatch((0, _reactRouterRedux.push)(path + '?price_min=' + priceMin + '&price_max=' + priceMax));
	            }
	        },
	        addProductToCart: function addProductToCart(variantId) {
	            var quantity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	            var zoneId = arguments[2];
	            var locale = arguments[3];
	            var userToken = arguments[4];
	
	            dispatch(_actions2.default.addProductToCart(variantId, quantity, zoneId, locale, userToken)).then(function () {
	                (0, _refreshOrderProcess2.default)(dispatch, locale, _reactReduxToastr.toastr, {
	                    addingProductToCartAction: false,
	                    successNotify: _appTranslations2.default[locale]['item-added'] + '. ' + _appTranslations2.default[locale]['proceed-to-checkout'] + '.'
	                });
	            }).catch(function (error) {
	                (0, _addProductToCart.addProductToCartNotifyEP)(locale, error, _reactReduxToastr.toastr);
	            });
	        },
	        emptyCart: function emptyCart(order, locale) {
	            return dispatch(_actions2.default.emptyCart(order, locale));
	        },
	        setCurrentZone: function setCurrentZone(zoneId) {
	            return dispatch(_actions2.default.setCurrentZone(zoneId));
	        },
	        setCurrentStore: function setCurrentStore(currentStore) {
	            dispatch(_actions2.default.displayLoader());
	            dispatch(_actions2.default.fetchStorePayments(currentStore)).then(function () {
	                fetchedProducts(dispatch);
	            }).catch(function (err) {
	                return console.log(err);
	            });
	        },
	        loadGroupedStores: function loadGroupedStores() {
	            return dispatch(_actions2.default.loadGroupedStores());
	        },
	        setCurrentMunicipality: function setCurrentMunicipality(municipalityId) {
	            return dispatch(_actions2.default.setCurrentMunicipality(municipalityId));
	        }
	    };
	};
	
	var SecondaryMenuConnector = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_secondaryMenu2.default);
	
	exports.default = (0, _baseMenu2.default)(SecondaryMenuConnector);

/***/ },
/* 179 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _actions = __webpack_require__(23);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	var _appTranslations = __webpack_require__(33);
	
	var _appTranslations2 = _interopRequireDefault(_appTranslations);
	
	var _refreshOrder = __webpack_require__(783);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var refreshOrderProcess = function refreshOrderProcess(dispatch, locale, toastr) {
	    var configs = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
	        successNotify: '',
	        addingProductToCartAction: true
	    };
	    return dispatch(_actions2.default.refreshOrder(locale)).then(function () {
	        if (configs.successNotify && configs.successNotify.length > 0) {
	            toastr.success(_appTranslations2.default[locale].well, configs.successNotify);
	        }
	    }).catch(function (error) {
	        (0, _refreshOrder.refreshOrderNotifyEP)(error, locale, toastr);
	    }).finally(function () {
	        if (configs.addingProductToCartAction) {
	            dispatch(_actions2.default.addingProductToCartFix(false));
	        }
	    });
	};
	
	exports.default = refreshOrderProcess;

/***/ },
/* 180 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var ShipmentsUtils = {
	    sameStores: function sameStores(a, b) {
	        return !!(a.attributes && b.attributes && a.attributes.store_ids && b.attributes.store_ids && a.attributes.store_ids.length >= 1 && b.attributes.store_ids.length >= 1 && a.attributes.store_ids[0] === b.attributes.store_ids[0]);
	    },
	
	    compareShipments: function compareShipments(a, b) {
	        return !ShipmentsUtils.sameStores(a, b) ? a.attributes.store_ids[0] - b.attributes.store_ids[0] : 0;
	    },
	
	    prevIsSameStore: function prevIsSameStore(shipments, idx) {
	        return idx === 0 ? false : ShipmentsUtils.sameStores(shipments[idx - 1], shipments[idx]);
	    },
	
	    nextIsSameStore: function nextIsSameStore(shipments, idx) {
	        return !!(idx !== shipments.length - 1 && ShipmentsUtils.sameStores(shipments[idx], shipments[idx + 1]));
	    },
	
	    countAmountOfStores: function countAmountOfStores(shipments) {
	        var storeIds = shipments.map(function (shipment) {
	            return shipment.attributes.store_ids[0];
	        });
	        // count the number of same store ids
	        return storeIds.reduce(function (acc, curr) {
	            acc[curr] = (acc[curr] || 0) + 1;
	            return acc;
	        }, {});
	    },
	
	    shipmentStylePadding: function shipmentStylePadding(shipments, idx) {
	        var prevStyle = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	        var style = _extends({}, prevStyle);
	        if (ShipmentsUtils.nextIsSameStore(shipments, idx)) {
	            style.paddingBottom = '0px';
	        }
	        if (ShipmentsUtils.prevIsSameStore(shipments, idx)) {
	            style.paddingTop = '0px';
	        }
	
	        return style;
	    }
	};
	
	exports.default = ShipmentsUtils;

/***/ },
/* 181 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reactRouterRedux = __webpack_require__(30);
	
	var _reactReduxToastr = __webpack_require__(42);
	
	var _actions = __webpack_require__(23);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	var _user = __webpack_require__(102);
	
	var _user2 = _interopRequireDefault(_user);
	
	var _store = __webpack_require__(40);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _appRoutes = __webpack_require__(22);
	
	var _appRoutes2 = _interopRequireDefault(_appRoutes);
	
	var _appTranslations = __webpack_require__(33);
	
	var _appTranslations2 = _interopRequireDefault(_appTranslations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UserUtils = {
	    isLoggedIn: function isLoggedIn() {
	        var _spreeStore$getState = _store2.default.getState();
	
	        var user = _spreeStore$getState.user;
	
	        return user && user.id;
	    },
	    /**
	     * Log in the user and handle feedback error if fails. If you need custom callbacks you can hook them to the promise.
	     * @param {object} formData
	     * @param {string} locale
	     * @returns Promise
	     */
	    signUp: function signUp(formData, locale) {
	        var logoutOnFail = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	        _store2.default.dispatch(_actions2.default.displayLoader());
	
	        // TODO: Remember Me
	        var _formData$user = formData.user;
	        var email = _formData$user.email;
	        var password = _formData$user.password;
	
	
	        return _user2.default.loginByCode({ email: email, otp_code: password }).then(function (response) {
	            _store2.default.dispatch(_actions2.default.hideLoader());
	            _store2.default.dispatch(_actions2.default.login(response.body, locale));
	            return Promise.resolve(response);
	        }, function () {
	            _reactReduxToastr.toastr.error(_appTranslations2.default[locale]['auth-failed'], _appTranslations2.default[locale]['invalid-user-password']);
	            if (logoutOnFail) {
	                _store2.default.dispatch(_actions2.default.logout());
	            }
	            _store2.default.dispatch(_actions2.default.hideLoader());
	            return Promise.reject();
	        });
	    },
	
	    sendEmail: function sendEmail(email, locale) {
	        var logoutOnFail = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	        _user2.default.sendCodeByEmail({ email: email }).then(function (response) {
	            _reactReduxToastr.toastr.info(_appTranslations2.default[locale].code, _appTranslations2.default[locale]['code-send-successfully']);
	            return Promise.resolve(response);
	        }, function () {
	            _reactReduxToastr.toastr.error(_appTranslations2.default[locale]['auth-failed'], _appTranslations2.default[locale]['invalid-email-code']);
	            if (logoutOnFail) {
	                _store2.default.dispatch(_actions2.default.logout());
	            }
	            _store2.default.dispatch(_actions2.default.hideLoader());
	            return Promise.reject();
	        });
	    },
	    /**
	     * When a user login, and there is a order from before this process, the order is asynchronously associated to the user account.
	     * A maximum time of 20 seconds is expected for the association to be completed.
	     * @returns {Promise<unknown>} It waits until the order is successfully associated to the user account.
	     */
	    subscribeToAssociateOrderLogin: function subscribeToAssociateOrderLogin() {
	        return new Promise(function (resolve, reject) {
	            var unsubscribeStore = void 0;
	            var timeout = void 0;
	            var millisecondsTimeOut = 20000;
	
	            var clearPromise = function clearPromise() {
	                if (unsubscribeStore) {
	                    unsubscribeStore();
	                }
	                if (timeout) {
	                    clearTimeout(timeout);
	                }
	            };
	
	            timeout = setTimeout(function () {
	                if (unsubscribeStore) {
	                    unsubscribeStore();
	                    reject();
	                }
	            }, millisecondsTimeOut);
	
	            unsubscribeStore = _store2.default.subscribe(function () {
	                try {
	                    var _spreeStore$getState2 = _store2.default.getState();
	
	                    var user = _spreeStore$getState2.user;
	                    var order = _spreeStore$getState2.order;
	
	                    if (user && order) {
	                        var userOrder = order.user;
	
	                        if (Object.keys(user).length > 0 && Object.keys(userOrder).length > 0 && user.id === userOrder.id) {
	                            resolve();
	                            clearPromise();
	                        }
	                    } else {
	                        reject();
	                        clearPromise();
	                    }
	                } catch (error) {
	                    reject();
	                    clearPromise();
	                }
	            });
	        });
	    }
	};
	
	exports.default = UserUtils;

/***/ },
/* 182 */
/***/ function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};


/***/ },
/* 183 */
/***/ function(module, exports) {

	module.exports = true;


/***/ },
/* 184 */
/***/ function(module, exports, __webpack_require__) {

	var META = __webpack_require__(187)('meta');
	var isObject = __webpack_require__(69);
	var has = __webpack_require__(88);
	var setDesc = __webpack_require__(80).f;
	var id = 0;
	var isExtensible = Object.isExtensible || function () {
	  return true;
	};
	var FREEZE = !__webpack_require__(87)(function () {
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function (it) {
	  setDesc(it, META, { value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  } });
	};
	var fastKey = function (it, create) {
	  // return primitive with prefix
	  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return 'F';
	    // not necessary to add metadata
	    if (!create) return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function (it, create) {
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return true;
	    // not necessary to add metadata
	    if (!create) return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function (it) {
	  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY: META,
	  NEED: false,
	  fastKey: fastKey,
	  getWeak: getWeak,
	  onFreeze: onFreeze
	};


/***/ },
/* 185 */
/***/ function(module, exports, __webpack_require__) {

	var def = __webpack_require__(80).f;
	var has = __webpack_require__(88);
	var TAG = __webpack_require__(70)('toStringTag');
	
	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};


/***/ },
/* 186 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(263);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ },
/* 187 */
/***/ function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ },
/* 188 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfUTCISOWeek;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// This function will be a part of public API when UTC function will be implemented.
	// See issue: https://github.com/date-fns/date-fns/issues/376
	function startOfUTCISOWeek(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var weekStartsOn = 1;
	  var date = (0, _index.default)(dirtyDate);
	  var day = date.getUTCDay();
	  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
	  date.setUTCDate(date.getUTCDate() - diff);
	  date.setUTCHours(0, 0, 0, 0);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 189 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addWeeks;
	
	var _index = _interopRequireDefault(__webpack_require__(19));
	
	var _index2 = _interopRequireDefault(__webpack_require__(82));
	
	var _index3 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name addWeeks
	 * @category Week Helpers
	 * @summary Add the specified number of weeks to the given date.
	 *
	 * @description
	 * Add the specified number of week to the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of weeks to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the weeks added
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Add 4 weeks to 1 September 2014:
	 * const result = addWeeks(new Date(2014, 8, 1), 4)
	 * //=> Mon Sep 29 2014 00:00:00
	 */
	function addWeeks(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  var days = amount * 7;
	  return (0, _index2.default)(dirtyDate, days);
	}
	
	module.exports = exports.default;

/***/ },
/* 190 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = differenceInMilliseconds;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name differenceInMilliseconds
	 * @category Millisecond Helpers
	 * @summary Get the number of milliseconds between the given dates.
	 *
	 * @description
	 * Get the number of milliseconds between the given dates.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @returns {Number} the number of milliseconds
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // How many milliseconds are between
	 * // 2 July 2014 12:30:20.600 and 2 July 2014 12:30:21.700?
	 * const result = differenceInMilliseconds(
	 *   new Date(2014, 6, 2, 12, 30, 21, 700),
	 *   new Date(2014, 6, 2, 12, 30, 20, 600)
	 * )
	 * //=> 1100
	 */
	function differenceInMilliseconds(dateLeft, dateRight) {
	  (0, _index2.default)(2, arguments);
	  return (0, _index.default)(dateLeft).getTime() - (0, _index.default)(dateRight).getTime();
	}
	
	module.exports = exports.default;

/***/ },
/* 191 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = differenceInMonths;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(406));
	
	var _index3 = _interopRequireDefault(__webpack_require__(105));
	
	var _index4 = _interopRequireDefault(__webpack_require__(2));
	
	var _index5 = _interopRequireDefault(__webpack_require__(426));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name differenceInMonths
	 * @category Month Helpers
	 * @summary Get the number of full months between the given dates.
	 *
	 * @description
	 * Get the number of full months between the given dates using trunc as a default rounding method.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @returns {Number} the number of full months
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // How many full months are between 31 January 2014 and 1 September 2014?
	 * const result = differenceInMonths(new Date(2014, 8, 1), new Date(2014, 0, 31))
	 * //=> 7
	 */
	function differenceInMonths(dirtyDateLeft, dirtyDateRight) {
	  (0, _index4.default)(2, arguments);
	  var dateLeft = (0, _index.default)(dirtyDateLeft);
	  var dateRight = (0, _index.default)(dirtyDateRight);
	  var sign = (0, _index3.default)(dateLeft, dateRight);
	  var difference = Math.abs((0, _index2.default)(dateLeft, dateRight));
	  var result; // Check for the difference of less than month
	
	  if (difference < 1) {
	    result = 0;
	  } else {
	    if (dateLeft.getMonth() === 1 && dateLeft.getDate() > 27) {
	      // This will check if the date is end of Feb and assign a higher end of month date
	      // to compare it with Jan
	      dateLeft.setDate(30);
	    }
	
	    dateLeft.setMonth(dateLeft.getMonth() - sign * difference); // Math.abs(diff in full months - diff in calendar months) === 1 if last calendar month is not full
	    // If so, result must be decreased by 1 in absolute value
	
	    var isLastMonthNotFull = (0, _index3.default)(dateLeft, dateRight) === -sign; // Check for cases of one full calendar month
	
	    if ((0, _index5.default)((0, _index.default)(dirtyDateLeft)) && difference === 1 && (0, _index3.default)(dirtyDateLeft, dateRight) === 1) {
	      isLastMonthNotFull = false;
	    }
	
	    result = sign * (difference - Number(isLastMonthNotFull));
	  } // Prevent negative zero
	
	
	  return result === 0 ? 0 : result;
	}
	
	module.exports = exports.default;

/***/ },
/* 192 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getDay;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name getDay
	 * @category Weekday Helpers
	 * @summary Get the day of the week of the given date.
	 *
	 * @description
	 * Get the day of the week of the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {0|1|2|3|4|5|6} the day of week, 0 represents Sunday
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Which day of the week is 29 February 2012?
	 * const result = getDay(new Date(2012, 1, 29))
	 * //=> 3
	 */
	function getDay(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var day = date.getDay();
	  return day;
	}
	
	module.exports = exports.default;

/***/ },
/* 193 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isWeekend;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isWeekend
	 * @category Weekday Helpers
	 * @summary Does the given date fall on a weekend?
	 *
	 * @description
	 * Does the given date fall on a weekend?
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date falls on a weekend
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Does 5 October 2014 fall on a weekend?
	 * const result = isWeekend(new Date(2014, 9, 5))
	 * //=> true
	 */
	function isWeekend(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var day = date.getDay();
	  return day === 0 || day === 6;
	}
	
	module.exports = exports.default;

/***/ },
/* 194 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfDay;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name startOfDay
	 * @category Day Helpers
	 * @summary Return the start of a day for the given date.
	 *
	 * @description
	 * Return the start of a day for the given date.
	 * The result will be in the local timezone.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the start of a day
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The start of a day for 2 September 2014 11:55:00:
	 * const result = startOfDay(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Tue Sep 02 2014 00:00:00
	 */
	function startOfDay(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  date.setHours(0, 0, 0, 0);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 195 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfMonth;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name startOfMonth
	 * @category Month Helpers
	 * @summary Return the start of a month for the given date.
	 *
	 * @description
	 * Return the start of a month for the given date.
	 * The result will be in the local timezone.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the start of a month
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The start of a month for 2 September 2014 11:55:00:
	 * const result = startOfMonth(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Mon Sep 01 2014 00:00:00
	 */
	function startOfMonth(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  date.setDate(1);
	  date.setHours(0, 0, 0, 0);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 196 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = subDays;
	
	var _index = _interopRequireDefault(__webpack_require__(19));
	
	var _index2 = _interopRequireDefault(__webpack_require__(82));
	
	var _index3 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name subDays
	 * @category Day Helpers
	 * @summary Subtract the specified number of days from the given date.
	 *
	 * @description
	 * Subtract the specified number of days from the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of days to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the days subtracted
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Subtract 10 days from 1 September 2014:
	 * const result = subDays(new Date(2014, 8, 1), 10)
	 * //=> Fri Aug 22 2014 00:00:00
	 */
	function subDays(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  return (0, _index2.default)(dirtyDate, -amount);
	}
	
	module.exports = exports.default;

/***/ },
/* 197 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = getWindow;
	
	function getWindow(node) {
	  return node === node.window ? node : node.nodeType === 9 ? node.defaultView || node.parentWindow : false;
	}
	
	module.exports = exports["default"];

/***/ },
/* 198 */
/***/ function(module, exports, __webpack_require__) {

	var listCacheClear = __webpack_require__(1712),
	    listCacheDelete = __webpack_require__(1713),
	    listCacheGet = __webpack_require__(1714),
	    listCacheHas = __webpack_require__(1715),
	    listCacheSet = __webpack_require__(1716);
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	module.exports = ListCache;


/***/ },
/* 199 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(77);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ },
/* 200 */
/***/ function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(156);
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	module.exports = assocIndexOf;


/***/ },
/* 201 */
/***/ function(module, exports, __webpack_require__) {

	var defineProperty = __webpack_require__(482);
	
	/**
	 * The base implementation of `assignValue` and `assignMergeValue` without
	 * value checks.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function baseAssignValue(object, key, value) {
	  if (key == '__proto__' && defineProperty) {
	    defineProperty(object, key, {
	      'configurable': true,
	      'enumerable': true,
	      'value': value,
	      'writable': true
	    });
	  } else {
	    object[key] = value;
	  }
	}
	
	module.exports = baseAssignValue;


/***/ },
/* 202 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqualDeep = __webpack_require__(1670),
	    isObjectLike = __webpack_require__(111);
	
	/**
	 * The base implementation of `_.isEqual` which supports partial comparisons
	 * and tracks traversed objects.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Unordered comparison
	 *  2 - Partial comparison
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */
	function baseIsEqual(value, other, bitmask, customizer, stack) {
	  if (value === other) {
	    return true;
	  }
	  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	    return value !== value && other !== other;
	  }
	  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	}
	
	module.exports = baseIsEqual;


/***/ },
/* 203 */
/***/ function(module, exports, __webpack_require__) {

	var isKeyable = __webpack_require__(1710);
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	module.exports = getMapData;


/***/ },
/* 204 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	module.exports = isPrototype;


/***/ },
/* 205 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(110);
	
	/* Built-in method references that are verified to be native. */
	var nativeCreate = getNative(Object, 'create');
	
	module.exports = nativeCreate;


/***/ },
/* 206 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsArguments = __webpack_require__(1669),
	    isObjectLike = __webpack_require__(111);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	    !propertyIsEnumerable.call(value, 'callee');
	};
	
	module.exports = isArguments;


/***/ },
/* 207 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(77),
	    stubFalse = __webpack_require__(1750);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	module.exports = isBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(139)(module)))

/***/ },
/* 208 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(131),
	    isObject = __webpack_require__(97);
	
	/** `Object#toString` result references. */
	var asyncTag = '[object AsyncFunction]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    proxyTag = '[object Proxy]';
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.
	  var tag = baseGetTag(value);
	  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	}
	
	module.exports = isFunction;


/***/ },
/* 209 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(131),
	    isObjectLike = __webpack_require__(111);
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && baseGetTag(value) == symbolTag);
	}
	
	module.exports = isSymbol;


/***/ },
/* 210 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsTypedArray = __webpack_require__(1673),
	    baseUnary = __webpack_require__(1686),
	    nodeUtil = __webpack_require__(1726);
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	module.exports = isTypedArray;


/***/ },
/* 211 */
/***/ function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(475),
	    copyArray = __webpack_require__(481),
	    isArray = __webpack_require__(72),
	    isSymbol = __webpack_require__(209),
	    stringToPath = __webpack_require__(491),
	    toKey = __webpack_require__(155),
	    toString = __webpack_require__(496);
	
	/**
	 * Converts `value` to a property path array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Util
	 * @param {*} value The value to convert.
	 * @returns {Array} Returns the new property path array.
	 * @example
	 *
	 * _.toPath('a.b.c');
	 * // => ['a', 'b', 'c']
	 *
	 * _.toPath('a[0].b.c');
	 * // => ['a', '0', 'b', 'c']
	 */
	function toPath(value) {
	  if (isArray(value)) {
	    return arrayMap(value, toKey);
	  }
	  return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
	}
	
	module.exports = toPath;


/***/ },
/* 212 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = all;
	
	var _createChainableTypeChecker = __webpack_require__(215);
	
	var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function all() {
	  for (var _len = arguments.length, validators = Array(_len), _key = 0; _key < _len; _key++) {
	    validators[_key] = arguments[_key];
	  }
	
	  function allPropTypes() {
	    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      args[_key2] = arguments[_key2];
	    }
	
	    var error = null;
	
	    validators.forEach(function (validator) {
	      if (error != null) {
	        return;
	      }
	
	      var result = validator.apply(undefined, args);
	      if (result != null) {
	        error = result;
	      }
	    });
	
	    return error;
	  }
	
	  return (0, _createChainableTypeChecker2.default)(allPropTypes);
	}
	module.exports = exports['default'];

/***/ },
/* 213 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createChainableTypeChecker = __webpack_require__(215);
	
	var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function validate(props, propName, componentName, location, propFullName) {
	  var propValue = props[propName];
	  var propType = typeof propValue === 'undefined' ? 'undefined' : _typeof(propValue);
	
	  if (_react2.default.isValidElement(propValue)) {
	    return new Error('Invalid ' + location + ' `' + propFullName + '` of type ReactElement ' + ('supplied to `' + componentName + '`, expected a ReactComponent or a ') + 'DOMElement. You can usually obtain a ReactComponent or DOMElement ' + 'from a ReactElement by attaching a ref to it.');
	  }
	
	  if ((propType !== 'object' || typeof propValue.render !== 'function') && propValue.nodeType !== 1) {
	    return new Error('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected a ReactComponent or a ') + 'DOMElement.');
	  }
	
	  return null;
	}
	
	exports.default = (0, _createChainableTypeChecker2.default)(validate);
	module.exports = exports['default'];

/***/ },
/* 214 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isRequiredForA11y;
	function isRequiredForA11y(validator) {
	  return function validate(props, propName, componentName, location, propFullName) {
	    var componentNameSafe = componentName || '<<anonymous>>';
	    var propFullNameSafe = propFullName || propName;
	
	    if (props[propName] == null) {
	      return new Error('The ' + location + ' `' + propFullNameSafe + '` is required to make ' + ('`' + componentNameSafe + '` accessible for users of assistive ') + 'technologies such as screen readers.');
	    }
	
	    for (var _len = arguments.length, args = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
	      args[_key - 5] = arguments[_key];
	    }
	
	    return validator.apply(undefined, [props, propName, componentName, location, propFullName].concat(args));
	  };
	}
	module.exports = exports['default'];

/***/ },
/* 215 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createChainableTypeChecker;
	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	// Mostly taken from ReactPropTypes.
	
	function createChainableTypeChecker(validate) {
	  function checkType(isRequired, props, propName, componentName, location, propFullName) {
	    var componentNameSafe = componentName || '<<anonymous>>';
	    var propFullNameSafe = propFullName || propName;
	
	    if (props[propName] == null) {
	      if (isRequired) {
	        return new Error('Required ' + location + ' `' + propFullNameSafe + '` was not specified ' + ('in `' + componentNameSafe + '`.'));
	      }
	
	      return null;
	    }
	
	    for (var _len = arguments.length, args = Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++) {
	      args[_key - 6] = arguments[_key];
	    }
	
	    return validate.apply(undefined, [props, propName, componentNameSafe, location, propFullNameSafe].concat(args));
	  }
	
	  var chainedCheckType = checkType.bind(null, false);
	  chainedCheckType.isRequired = checkType.bind(null, true);
	
	  return chainedCheckType;
	}
	module.exports = exports['default'];

/***/ },
/* 216 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(47);
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(8));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(57));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _activeElement = _interopRequireDefault(__webpack_require__(455));
	
	var _contains = _interopRequireDefault(__webpack_require__(130));
	
	var _keycode = _interopRequireDefault(__webpack_require__(294));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(46));
	
	var _all = _interopRequireDefault(__webpack_require__(212));
	
	var _elementType = _interopRequireDefault(__webpack_require__(32));
	
	var _isRequiredForA11y = _interopRequireDefault(__webpack_require__(214));
	
	var _uncontrollable = __webpack_require__(119);
	
	var _warning = _interopRequireDefault(__webpack_require__(59));
	
	var _ButtonGroup = _interopRequireDefault(__webpack_require__(305));
	
	var _DropdownMenu = _interopRequireDefault(__webpack_require__(1787));
	
	var _DropdownToggle = _interopRequireDefault(__webpack_require__(501));
	
	var _bootstrapUtils = __webpack_require__(16);
	
	var _createChainedFunction = _interopRequireDefault(__webpack_require__(45));
	
	var _PropTypes = __webpack_require__(520);
	
	var _ValidComponentChildren = _interopRequireDefault(__webpack_require__(58));
	
	var TOGGLE_ROLE = _DropdownToggle.default.defaultProps.bsRole;
	var MENU_ROLE = _DropdownMenu.default.defaultProps.bsRole;
	var propTypes = {
	  /**
	   * The menu will open above the dropdown button, instead of below it.
	   */
	  dropup: _propTypes.default.bool,
	
	  /**
	   * An html id attribute, necessary for assistive technologies, such as screen readers.
	   * @type {string|number}
	   * @required
	   */
	  id: (0, _isRequiredForA11y.default)(_propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])),
	  componentClass: _elementType.default,
	
	  /**
	   * The children of a Dropdown may be a `<Dropdown.Toggle>` or a `<Dropdown.Menu>`.
	   * @type {node}
	   */
	  children: (0, _all.default)((0, _PropTypes.requiredRoles)(TOGGLE_ROLE, MENU_ROLE), (0, _PropTypes.exclusiveRoles)(MENU_ROLE)),
	
	  /**
	   * Whether or not component is disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * Align the menu to the right side of the Dropdown toggle
	   */
	  pullRight: _propTypes.default.bool,
	
	  /**
	   * Whether or not the Dropdown is visible.
	   *
	   * @controllable onToggle
	   */
	  open: _propTypes.default.bool,
	  defaultOpen: _propTypes.default.bool,
	
	  /**
	   * A callback fired when the Dropdown wishes to change visibility. Called with the requested
	   * `open` value, the DOM event, and the source that fired it: `'click'`,`'keydown'`,`'rootClose'`, or `'select'`.
	   *
	   * ```js
	   * function(Boolean isOpen, Object event, { String source }) {}
	   * ```
	   * @controllable open
	   */
	  onToggle: _propTypes.default.func,
	
	  /**
	   * A callback fired when a menu item is selected.
	   *
	   * ```js
	   * (eventKey: any, event: Object) => any
	   * ```
	   */
	  onSelect: _propTypes.default.func,
	
	  /**
	   * If `'menuitem'`, causes the dropdown to behave like a menu item rather than
	   * a menu button.
	   */
	  role: _propTypes.default.string,
	
	  /**
	   * Which event when fired outside the component will cause it to be closed
	   *
	   * *Note: For custom dropdown components, you will have to pass the
	   * `rootCloseEvent` to `<RootCloseWrapper>` in your custom dropdown menu
	   * component ([similarly to how it is implemented in `<Dropdown.Menu>`](https://github.com/react-bootstrap/react-bootstrap/blob/v0.31.5/src/DropdownMenu.js#L115-L119)).*
	   */
	  rootCloseEvent: _propTypes.default.oneOf(['click', 'mousedown']),
	
	  /**
	   * @private
	   */
	  onMouseEnter: _propTypes.default.func,
	
	  /**
	   * @private
	   */
	  onMouseLeave: _propTypes.default.func
	};
	var defaultProps = {
	  componentClass: _ButtonGroup.default
	};
	
	var Dropdown =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(Dropdown, _React$Component);
	
	  function Dropdown(props, context) {
	    var _this;
	
	    _this = _React$Component.call(this, props, context) || this;
	    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
	    _this.handleKeyDown = _this.handleKeyDown.bind((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
	    _this.handleClose = _this.handleClose.bind((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
	    _this._focusInDropdown = false;
	    _this.lastOpenEventType = null;
	    return _this;
	  }
	
	  var _proto = Dropdown.prototype;
	
	  _proto.componentDidMount = function componentDidMount() {
	    this.focusNextOnOpen();
	  };
	
	  _proto.UNSAFE_componentWillUpdate = function UNSAFE_componentWillUpdate(nextProps) {
	    // eslint-disable-line
	    if (!nextProps.open && this.props.open) {
	      this._focusInDropdown = (0, _contains.default)(_reactDom.default.findDOMNode(this.menu), (0, _activeElement.default)(document));
	    }
	  };
	
	  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var open = this.props.open;
	    var prevOpen = prevProps.open;
	
	    if (open && !prevOpen) {
	      this.focusNextOnOpen();
	    }
	
	    if (!open && prevOpen) {
	      // if focus hasn't already moved from the menu let's return it
	      // to the toggle
	      if (this._focusInDropdown) {
	        this._focusInDropdown = false;
	        this.focus();
	      }
	    }
	  };
	
	  _proto.focus = function focus() {
	    var toggle = _reactDom.default.findDOMNode(this.toggle);
	
	    if (toggle && toggle.focus) {
	      toggle.focus();
	    }
	  };
	
	  _proto.focusNextOnOpen = function focusNextOnOpen() {
	    var menu = this.menu;
	
	    if (!menu || !menu.focusNext) {
	      return;
	    }
	
	    if (this.lastOpenEventType === 'keydown' || this.props.role === 'menuitem') {
	      menu.focusNext();
	    }
	  };
	
	  _proto.handleClick = function handleClick(event) {
	    if (this.props.disabled) {
	      return;
	    }
	
	    this.toggleOpen(event, {
	      source: 'click'
	    });
	  };
	
	  _proto.handleClose = function handleClose(event, eventDetails) {
	    if (!this.props.open) {
	      return;
	    }
	
	    this.toggleOpen(event, eventDetails);
	  };
	
	  _proto.handleKeyDown = function handleKeyDown(event) {
	    if (this.props.disabled) {
	      return;
	    }
	
	    switch (event.keyCode) {
	      case _keycode.default.codes.down:
	        if (!this.props.open) {
	          this.toggleOpen(event, {
	            source: 'keydown'
	          });
	        } else if (this.menu.focusNext) {
	          this.menu.focusNext();
	        }
	
	        event.preventDefault();
	        break;
	
	      case _keycode.default.codes.esc:
	      case _keycode.default.codes.tab:
	        this.handleClose(event, {
	          source: 'keydown'
	        });
	        break;
	
	      default:
	    }
	  };
	
	  _proto.toggleOpen = function toggleOpen(event, eventDetails) {
	    var open = !this.props.open;
	
	    if (open) {
	      this.lastOpenEventType = eventDetails.source;
	    }
	
	    if (this.props.onToggle) {
	      this.props.onToggle(open, event, eventDetails);
	    }
	  };
	
	  _proto.renderMenu = function renderMenu(child, _ref) {
	    var _this2 = this;
	
	    var id = _ref.id,
	        onSelect = _ref.onSelect,
	        rootCloseEvent = _ref.rootCloseEvent,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_ref, ["id", "onSelect", "rootCloseEvent"]);
	
	    var ref = function ref(c) {
	      _this2.menu = c;
	    };
	
	    if (typeof child.ref === 'string') {
	       false ? (0, _warning.default)(false, 'String refs are not supported on `<Dropdown.Menu>` components. ' + 'To apply a ref to the component use the callback signature:\n\n ' + 'https://facebook.github.io/react/docs/more-about-refs.html#the-ref-callback-attribute') : void 0;
	    } else {
	      ref = (0, _createChainedFunction.default)(child.ref, ref);
	    }
	
	    return (0, _react.cloneElement)(child, (0, _extends2.default)({}, props, {
	      ref: ref,
	      labelledBy: id,
	      bsClass: (0, _bootstrapUtils.prefix)(props, 'menu'),
	      onClose: (0, _createChainedFunction.default)(child.props.onClose, this.handleClose),
	      onSelect: (0, _createChainedFunction.default)(child.props.onSelect, onSelect, function (key, event) {
	        return _this2.handleClose(event, {
	          source: 'select'
	        });
	      }),
	      rootCloseEvent: rootCloseEvent
	    }));
	  };
	
	  _proto.renderToggle = function renderToggle(child, props) {
	    var _this3 = this;
	
	    var ref = function ref(c) {
	      _this3.toggle = c;
	    };
	
	    if (typeof child.ref === 'string') {
	       false ? (0, _warning.default)(false, 'String refs are not supported on `<Dropdown.Toggle>` components. ' + 'To apply a ref to the component use the callback signature:\n\n ' + 'https://facebook.github.io/react/docs/more-about-refs.html#the-ref-callback-attribute') : void 0;
	    } else {
	      ref = (0, _createChainedFunction.default)(child.ref, ref);
	    }
	
	    return (0, _react.cloneElement)(child, (0, _extends2.default)({}, props, {
	      ref: ref,
	      bsClass: (0, _bootstrapUtils.prefix)(props, 'toggle'),
	      onClick: (0, _createChainedFunction.default)(child.props.onClick, this.handleClick),
	      onKeyDown: (0, _createChainedFunction.default)(child.props.onKeyDown, this.handleKeyDown)
	    }));
	  };
	
	  _proto.render = function render() {
	    var _classes,
	        _this4 = this;
	
	    var _this$props = this.props,
	        Component = _this$props.componentClass,
	        id = _this$props.id,
	        dropup = _this$props.dropup,
	        disabled = _this$props.disabled,
	        pullRight = _this$props.pullRight,
	        open = _this$props.open,
	        onSelect = _this$props.onSelect,
	        role = _this$props.role,
	        bsClass = _this$props.bsClass,
	        className = _this$props.className,
	        rootCloseEvent = _this$props.rootCloseEvent,
	        children = _this$props.children,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["componentClass", "id", "dropup", "disabled", "pullRight", "open", "onSelect", "role", "bsClass", "className", "rootCloseEvent", "children"]);
	    delete props.onToggle;
	    var classes = (_classes = {}, _classes[bsClass] = true, _classes.open = open, _classes.disabled = disabled, _classes);
	
	    if (dropup) {
	      classes[bsClass] = false;
	      classes.dropup = true;
	    } // This intentionally forwards bsSize and bsStyle (if set) to the
	    // underlying component, to allow it to render size and style variants.
	
	
	    return _react.default.createElement(Component, (0, _extends2.default)({}, props, {
	      className: (0, _classnames.default)(className, classes)
	    }), _ValidComponentChildren.default.map(children, function (child) {
	      switch (child.props.bsRole) {
	        case TOGGLE_ROLE:
	          return _this4.renderToggle(child, {
	            id: id,
	            disabled: disabled,
	            open: open,
	            role: role,
	            bsClass: bsClass
	          });
	
	        case MENU_ROLE:
	          return _this4.renderMenu(child, {
	            id: id,
	            open: open,
	            pullRight: pullRight,
	            bsClass: bsClass,
	            onSelect: onSelect,
	            rootCloseEvent: rootCloseEvent
	          });
	
	        default:
	          return child;
	      }
	    }));
	  };
	
	  return Dropdown;
	}(_react.default.Component);
	
	Dropdown.propTypes = propTypes;
	Dropdown.defaultProps = defaultProps;
	(0, _bootstrapUtils.bsClass)('dropdown', Dropdown);
	var UncontrolledDropdown = (0, _uncontrollable.uncontrollable)(Dropdown, {
	  open: 'onToggle'
	});
	UncontrolledDropdown.Toggle = _DropdownToggle.default;
	UncontrolledDropdown.Menu = _DropdownMenu.default;
	var _default = UncontrolledDropdown;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 217 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	var _interopRequireWildcard = __webpack_require__(47);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(8));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _Transition = _interopRequireWildcard(__webpack_require__(545));
	
	var _fadeStyles;
	
	var propTypes = {
	  /**
	   * Show the component; triggers the fade in or fade out animation
	   */
	  in: _propTypes.default.bool,
	
	  /**
	   * Wait until the first "enter" transition to mount the component (add it to the DOM)
	   */
	  mountOnEnter: _propTypes.default.bool,
	
	  /**
	   * Unmount the component (remove it from the DOM) when it is faded out
	   */
	  unmountOnExit: _propTypes.default.bool,
	
	  /**
	   * Run the fade in animation when the component mounts, if it is initially
	   * shown
	   */
	  appear: _propTypes.default.bool,
	
	  /**
	   * Duration of the fade animation in milliseconds, to ensure that finishing
	   * callbacks are fired even if the original browser transition end events are
	   * canceled
	   */
	  timeout: _propTypes.default.number,
	
	  /**
	   * Callback fired before the component fades in
	   */
	  onEnter: _propTypes.default.func,
	
	  /**
	   * Callback fired after the component starts to fade in
	   */
	  onEntering: _propTypes.default.func,
	
	  /**
	   * Callback fired after the has component faded in
	   */
	  onEntered: _propTypes.default.func,
	
	  /**
	   * Callback fired before the component fades out
	   */
	  onExit: _propTypes.default.func,
	
	  /**
	   * Callback fired after the component starts to fade out
	   */
	  onExiting: _propTypes.default.func,
	
	  /**
	   * Callback fired after the component has faded out
	   */
	  onExited: _propTypes.default.func
	};
	var defaultProps = {
	  in: false,
	  timeout: 300,
	  mountOnEnter: false,
	  unmountOnExit: false,
	  appear: false
	};
	var fadeStyles = (_fadeStyles = {}, _fadeStyles[_Transition.ENTERING] = 'in', _fadeStyles[_Transition.ENTERED] = 'in', _fadeStyles);
	
	var Fade =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(Fade, _React$Component);
	
	  function Fade() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = Fade.prototype;
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        className = _this$props.className,
	        children = _this$props.children,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["className", "children"]);
	    return _react.default.createElement(_Transition.default, props, function (status, innerProps) {
	      return _react.default.cloneElement(children, (0, _extends2.default)({}, innerProps, {
	        className: (0, _classnames.default)('fade', className, children.props.className, fadeStyles[status])
	      }));
	    });
	  };
	
	  return Fade;
	}(_react.default.Component);
	
	Fade.propTypes = propTypes;
	Fade.defaultProps = defaultProps;
	var _default = Fade;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 218 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(8));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _elementType = _interopRequireDefault(__webpack_require__(32));
	
	var _MediaBody = _interopRequireDefault(__webpack_require__(1801));
	
	var _MediaHeading = _interopRequireDefault(__webpack_require__(1802));
	
	var _MediaLeft = _interopRequireDefault(__webpack_require__(1803));
	
	var _MediaList = _interopRequireDefault(__webpack_require__(1804));
	
	var _MediaListItem = _interopRequireDefault(__webpack_require__(1805));
	
	var _MediaRight = _interopRequireDefault(__webpack_require__(1806));
	
	var _bootstrapUtils = __webpack_require__(16);
	
	var propTypes = {
	  componentClass: _elementType.default
	};
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var Media =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(Media, _React$Component);
	
	  function Media() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = Media.prototype;
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        Component = _this$props.componentClass,
	        className = _this$props.className,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["componentClass", "className"]);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	    return _react.default.createElement(Component, (0, _extends2.default)({}, elementProps, {
	      className: (0, _classnames.default)(className, classes)
	    }));
	  };
	
	  return Media;
	}(_react.default.Component);
	
	Media.propTypes = propTypes;
	Media.defaultProps = defaultProps;
	Media.Heading = _MediaHeading.default;
	Media.Body = _MediaBody.default;
	Media.Left = _MediaLeft.default;
	Media.Right = _MediaRight.default;
	Media.List = _MediaList.default;
	Media.ListItem = _MediaListItem.default;
	
	var _default = (0, _bootstrapUtils.bsClass)('media', Media);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 219 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = splitComponentProps;
	
	var _entries = _interopRequireDefault(__webpack_require__(341));
	
	function splitComponentProps(props, Component) {
	  var componentPropTypes = Component.propTypes;
	  var parentProps = {};
	  var childProps = {};
	  (0, _entries.default)(props).forEach(function (_ref) {
	    var propName = _ref[0],
	        propValue = _ref[1];
	
	    if (componentPropTypes[propName]) {
	      parentProps[propName] = propValue;
	    } else {
	      childProps[propName] = propValue;
	    }
	  });
	  return [parentProps, childProps];
	}
	
	module.exports = exports["default"];

/***/ },
/* 220 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = getContainer;
	
	var _reactDom = __webpack_require__(46);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getContainer(container, defaultContainer) {
	  container = typeof container === 'function' ? container() : container;
	  return _reactDom2.default.findDOMNode(container) || defaultContainer;
	}
	module.exports = exports['default'];

/***/ },
/* 221 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        if (typeof b !== "function" && b !== null)
	            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.ConnectableObservable = void 0;
	var Observable_1 = __webpack_require__(34);
	var Subscription_1 = __webpack_require__(62);
	var refCount_1 = __webpack_require__(576);
	var OperatorSubscriber_1 = __webpack_require__(20);
	var lift_1 = __webpack_require__(17);
	var ConnectableObservable = (function (_super) {
	    __extends(ConnectableObservable, _super);
	    function ConnectableObservable(source, subjectFactory) {
	        var _this = _super.call(this) || this;
	        _this.source = source;
	        _this.subjectFactory = subjectFactory;
	        _this._subject = null;
	        _this._refCount = 0;
	        _this._connection = null;
	        if (lift_1.hasLift(source)) {
	            _this.lift = source.lift;
	        }
	        return _this;
	    }
	    ConnectableObservable.prototype._subscribe = function (subscriber) {
	        return this.getSubject().subscribe(subscriber);
	    };
	    ConnectableObservable.prototype.getSubject = function () {
	        var subject = this._subject;
	        if (!subject || subject.isStopped) {
	            this._subject = this.subjectFactory();
	        }
	        return this._subject;
	    };
	    ConnectableObservable.prototype._teardown = function () {
	        this._refCount = 0;
	        var _connection = this._connection;
	        this._subject = this._connection = null;
	        _connection === null || _connection === void 0 ? void 0 : _connection.unsubscribe();
	    };
	    ConnectableObservable.prototype.connect = function () {
	        var _this = this;
	        var connection = this._connection;
	        if (!connection) {
	            connection = this._connection = new Subscription_1.Subscription();
	            var subject_1 = this.getSubject();
	            connection.add(this.source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subject_1, undefined, function () {
	                _this._teardown();
	                subject_1.complete();
	            }, function (err) {
	                _this._teardown();
	                subject_1.error(err);
	            }, function () { return _this._teardown(); })));
	            if (connection.closed) {
	                this._connection = null;
	                connection = Subscription_1.Subscription.EMPTY;
	            }
	        }
	        return connection;
	    };
	    ConnectableObservable.prototype.refCount = function () {
	        return refCount_1.refCount()(this);
	    };
	    return ConnectableObservable;
	}(Observable_1.Observable));
	exports.ConnectableObservable = ConnectableObservable;
	//# sourceMappingURL=ConnectableObservable.js.map

/***/ },
/* 222 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.concat = void 0;
	var concatAll_1 = __webpack_require__(330);
	var args_1 = __webpack_require__(64);
	var from_1 = __webpack_require__(78);
	function concat() {
	    var args = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        args[_i] = arguments[_i];
	    }
	    return concatAll_1.concatAll()(from_1.from(args, args_1.popScheduler(args)));
	}
	exports.concat = concat;
	//# sourceMappingURL=concat.js.map

/***/ },
/* 223 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.defer = void 0;
	var Observable_1 = __webpack_require__(34);
	var innerFrom_1 = __webpack_require__(28);
	function defer(observableFactory) {
	    return new Observable_1.Observable(function (subscriber) {
	        innerFrom_1.innerFrom(observableFactory()).subscribe(subscriber);
	    });
	}
	exports.defer = defer;
	//# sourceMappingURL=defer.js.map

/***/ },
/* 224 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.defaultIfEmpty = void 0;
	var lift_1 = __webpack_require__(17);
	var OperatorSubscriber_1 = __webpack_require__(20);
	function defaultIfEmpty(defaultValue) {
	    return lift_1.operate(function (source, subscriber) {
	        var hasValue = false;
	        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (value) {
	            hasValue = true;
	            subscriber.next(value);
	        }, function () {
	            if (!hasValue) {
	                subscriber.next(defaultValue);
	            }
	            subscriber.complete();
	        }));
	    });
	}
	exports.defaultIfEmpty = defaultIfEmpty;
	//# sourceMappingURL=defaultIfEmpty.js.map

/***/ },
/* 225 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.mergeAll = void 0;
	var mergeMap_1 = __webpack_require__(98);
	var identity_1 = __webpack_require__(56);
	function mergeAll(concurrent) {
	    if (concurrent === void 0) { concurrent = Infinity; }
	    return mergeMap_1.mergeMap(identity_1.identity, concurrent);
	}
	exports.mergeAll = mergeAll;
	//# sourceMappingURL=mergeAll.js.map

/***/ },
/* 226 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.observeOn = void 0;
	var executeSchedule_1 = __webpack_require__(100);
	var lift_1 = __webpack_require__(17);
	var OperatorSubscriber_1 = __webpack_require__(20);
	function observeOn(scheduler, delay) {
	    if (delay === void 0) { delay = 0; }
	    return lift_1.operate(function (source, subscriber) {
	        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (value) { return executeSchedule_1.executeSchedule(subscriber, scheduler, function () { return subscriber.next(value); }, delay); }, function () { return executeSchedule_1.executeSchedule(subscriber, scheduler, function () { return subscriber.complete(); }, delay); }, function (err) { return executeSchedule_1.executeSchedule(subscriber, scheduler, function () { return subscriber.error(err); }, delay); }));
	    });
	}
	exports.observeOn = observeOn;
	//# sourceMappingURL=observeOn.js.map

/***/ },
/* 227 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.subscribeOn = void 0;
	var lift_1 = __webpack_require__(17);
	function subscribeOn(scheduler, delay) {
	    if (delay === void 0) { delay = 0; }
	    return lift_1.operate(function (source, subscriber) {
	        subscriber.add(scheduler.schedule(function () { return source.subscribe(subscriber); }, delay));
	    });
	}
	exports.subscribeOn = subscribeOn;
	//# sourceMappingURL=subscribeOn.js.map

/***/ },
/* 228 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.switchMap = void 0;
	var innerFrom_1 = __webpack_require__(28);
	var lift_1 = __webpack_require__(17);
	var OperatorSubscriber_1 = __webpack_require__(20);
	function switchMap(project, resultSelector) {
	    return lift_1.operate(function (source, subscriber) {
	        var innerSubscriber = null;
	        var index = 0;
	        var isComplete = false;
	        var checkComplete = function () { return isComplete && !innerSubscriber && subscriber.complete(); };
	        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (value) {
	            innerSubscriber === null || innerSubscriber === void 0 ? void 0 : innerSubscriber.unsubscribe();
	            var innerIndex = 0;
	            var outerIndex = index++;
	            innerFrom_1.innerFrom(project(value, outerIndex)).subscribe((innerSubscriber = OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (innerValue) { return subscriber.next(resultSelector ? resultSelector(value, innerValue, outerIndex, innerIndex++) : innerValue); }, function () {
	                innerSubscriber = null;
	                checkComplete();
	            })));
	        }, function () {
	            isComplete = true;
	            checkComplete();
	        }));
	    });
	}
	exports.switchMap = switchMap;
	//# sourceMappingURL=switchMap.js.map

/***/ },
/* 229 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.throwIfEmpty = void 0;
	var EmptyError_1 = __webpack_require__(115);
	var lift_1 = __webpack_require__(17);
	var OperatorSubscriber_1 = __webpack_require__(20);
	function throwIfEmpty(errorFactory) {
	    if (errorFactory === void 0) { errorFactory = defaultErrorFactory; }
	    return lift_1.operate(function (source, subscriber) {
	        var hasValue = false;
	        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (value) {
	            hasValue = true;
	            subscriber.next(value);
	        }, function () { return (hasValue ? subscriber.complete() : subscriber.error(errorFactory())); }));
	    });
	}
	exports.throwIfEmpty = throwIfEmpty;
	function defaultErrorFactory() {
	    return new EmptyError_1.EmptyError();
	}
	//# sourceMappingURL=throwIfEmpty.js.map

/***/ },
/* 230 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.observable = void 0;
	exports.observable = (function () { return (typeof Symbol === 'function' && Symbol.observable) || '@@observable'; })();
	//# sourceMappingURL=observable.js.map

/***/ },
/* 231 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.isScheduler = void 0;
	var isFunction_1 = __webpack_require__(31);
	function isScheduler(value) {
	    return value && isFunction_1.isFunction(value.schedule);
	}
	exports.isScheduler = isScheduler;
	//# sourceMappingURL=isScheduler.js.map

/***/ },
/* 232 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.pipeFromArray = exports.pipe = void 0;
	var identity_1 = __webpack_require__(56);
	function pipe() {
	    var fns = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        fns[_i] = arguments[_i];
	    }
	    return pipeFromArray(fns);
	}
	exports.pipe = pipe;
	function pipeFromArray(fns) {
	    if (fns.length === 0) {
	        return identity_1.identity;
	    }
	    if (fns.length === 1) {
	        return fns[0];
	    }
	    return function piped(input) {
	        return fns.reduce(function (prev, fn) { return fn(prev); }, input);
	    };
	}
	exports.pipeFromArray = pipeFromArray;
	//# sourceMappingURL=pipe.js.map

/***/ },
/* 233 */
/***/ function(module, exports) {

	function _typeof(obj) {
	  "@babel/helpers - typeof";
	
	  return (module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
	    return typeof obj;
	  } : function (obj) {
	    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	  }, module.exports.__esModule = true, module.exports["default"] = module.exports), _typeof(obj);
	}
	module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 234 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _appActions = __webpack_require__(21);
	
	var _appActions2 = _interopRequireDefault(_appActions);
	
	var _appDefaults = __webpack_require__(39);
	
	var _appDefaults2 = _interopRequireDefault(_appDefaults);
	
	var _localStorageApi = __webpack_require__(55);
	
	var _localStorageApi2 = _interopRequireDefault(_localStorageApi);
	
	var _configs = __webpack_require__(651);
	
	var _configs2 = _interopRequireDefault(_configs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var cartState = {
	    updateConfigsActiveCart: function updateConfigsActiveCart() {
	        return function (dispatch, getState) {
	            return _configs2.default.getConfigs().then(function (response) {
	                dispatch({ type: _appActions2.default.SET_BACKEND_CONFIG, payload: response.body });
	                if (response.body.activeCart && response.body.activeCart.activeCart) {
	                    dispatch({
	                        type: _appActions2.default.SET_CONFIGS_ACTIVE_CART,
	                        payload: {
	                            activeCart: true,
	                            cartRemoval: response.body.activeCart.cartRemoval,
	                            gracePeriod: response.body.activeCart.gracePeriod
	                        }
	                    });
	                } else {
	                    dispatch({ type: _appActions2.default.SET_ACTIVE_CART, payload: false });
	                }
	                _localStorageApi2.default.save(getState());
	                return response;
	            }).catch(function (reason) {
	                dispatch({ type: _appActions2.default.SET_ACTIVE_CART, payload: false });
	                _localStorageApi2.default.save(getState());
	                if (true) {
	                    console.error('It has not been possible to load the values of the active cart, so the values set for the environment are used.', reason);
	                }
	                throw reason;
	            });
	        };
	    },
	    setTimeMinutesLeft: function setTimeMinutesLeft(minutes) {
	        return function (dispatch, getState) {
	            var _getState = getState();
	
	            var timeMinutesLeft = _getState.cartState.timeMinutesLeft;
	
	            if (timeMinutesLeft !== minutes) {
	                dispatch({ type: _appActions2.default.UPDATE_MINUTES_TIME_LEFT_CART, payload: minutes });
	                return minutes;
	            }
	        };
	    },
	    setTimeSecondsLeft: function setTimeSecondsLeft(seconds) {
	        return function (dispatch, getState) {
	            if (seconds === 0) {
	                dispatch({ type: _appActions2.default.UPDATE_SECONDS_TIME_LEFT_CART, payload: 0 });
	            }
	
	            var _getState2 = getState();
	
	            var timeSecondsLeft = _getState2.cartState.timeSecondsLeft;
	
	            if (seconds && timeSecondsLeft !== seconds) {
	                dispatch({ type: _appActions2.default.UPDATE_SECONDS_TIME_LEFT_CART, payload: seconds });
	
	                var _getState3 = getState();
	
	                var _getState3$cartState = _getState3.cartState;
	                var _timeSecondsLeft = _getState3$cartState.timeSecondsLeft;
	                var lastAlert = _getState3$cartState.lastAlert;
	
	                var lastMinuteWarning = _appDefaults2.default.showCartExpiringMessageAt.sort(function (a, b) {
	                    return a - b;
	                })[0];
	                var minute = _timeSecondsLeft / 60;
	                if (minute <= lastMinuteWarning && !lastAlert && _timeSecondsLeft !== 0) {
	                    dispatch({ type: _appActions2.default.SET_LAST_ALERT_TIME_LEFT_CART, payload: true });
	                } else if (lastAlert && minute > lastMinuteWarning || _timeSecondsLeft === 0) {
	                    dispatch({ type: _appActions2.default.SET_LAST_ALERT_TIME_LEFT_CART, payload: false });
	                }
	
	                return seconds;
	            }
	        };
	    },
	    setHasExtraTimeCheckout: function setHasExtraTimeCheckout(hasExtra) {
	        return function (dispatch, getState) {
	            var _getState4 = getState();
	
	            var hasExtraTimeCheckout = _getState4.cartState.hasExtraTimeCheckout;
	
	            if (hasExtraTimeCheckout !== hasExtra) {
	                dispatch({ type: _appActions2.default.SET_EXTRA_TIME_CHECKOUT, payload: hasExtra });
	                _localStorageApi2.default.save(getState());
	            }
	        };
	    }
	};
	
	exports.default = cartState;

/***/ },
/* 235 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _appActions = __webpack_require__(21);
	
	var _appActions2 = _interopRequireDefault(_appActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var loader = {
	    displayLoader: function displayLoader() {
	        return {
	            type: _appActions2.default.DISPLAY_LOADER
	        };
	    },
	
	    hideLoader: function hideLoader() {
	        return {
	            type: _appActions2.default.HIDE_LOADER
	        };
	    }
	};
	
	exports.default = loader;

/***/ },
/* 236 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _appActions = __webpack_require__(21);
	
	var _appActions2 = _interopRequireDefault(_appActions);
	
	var _localStorageApi = __webpack_require__(55);
	
	var _localStorageApi2 = _interopRequireDefault(_localStorageApi);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var placedOrder = {
	    addPlacedOrder: function addPlacedOrder(order) {
	        return function (dispatch, getState) {
	            dispatch({ type: _appActions2.default.ADD_PLACED_ORDER, payload: order });
	            _localStorageApi2.default.save(getState());
	        };
	    },
	
	    clearPlacedOrder: function clearPlacedOrder() {
	        return function (dispatch, getState) {
	            dispatch({ type: _appActions2.default.DESTROY_PLACED_ORDER });
	            _localStorageApi2.default.save(getState());
	        };
	    }
	};
	
	exports.default = placedOrder;

/***/ },
/* 237 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _lineItems = __webpack_require__(369);
	
	var _lineItems2 = _interopRequireDefault(_lineItems);
	
	var _orderModel = __webpack_require__(370);
	
	var _orderModel2 = _interopRequireDefault(_orderModel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SpreeAPIOrderAdapter = {
	    processList: function processList(orderListAMS) {
	        orderListAMS.data.forEach(function (order) {
	            SpreeAPIOrderAdapter._process(order, orderListAMS);
	        });
	
	        return orderListAMS;
	    },
	
	    processItem: function processItem(orderListAMS) {
	        SpreeAPIOrderAdapter._process(orderListAMS.data, orderListAMS);
	
	        return orderListAMS;
	    },
	
	    /*
	       PRIVATE METHODS
	    */
	    _process: function _process(order, orderListAMS) {
	        if (order.relationships.billing_address.data && order.relationships.billing_address.data.id) {
	            order.bill_address = SpreeAPIOrderAdapter._buildAddress(order.relationships.billing_address.data.id, orderListAMS);
	        }
	
	        if (order.relationships.shipping_address.data && order.relationships.shipping_address.data.id) {
	            order.ship_address = SpreeAPIOrderAdapter._buildAddress(order.relationships.shipping_address.data.id, orderListAMS);
	        }
	
	        if (order.relationships.user.data && order.relationships.user.data.id) {
	            order.user = SpreeAPIOrderAdapter._buildUser(order.relationships.user.data.id, orderListAMS);
	        }
	
	        if (order.relationships.line_items.data) {
	            order.line_items = SpreeAPIOrderAdapter._buildLineItems(order.relationships.line_items.data.map(function (a) {
	                return a.id;
	            }), orderListAMS);
	        }
	
	        if (order.relationships.shipments.data) {
	            order.shipments = SpreeAPIOrderAdapter._buildShipments(order.relationships.shipments.data.map(function (a) {
	                return a.id;
	            }), orderListAMS);
	        }
	    },
	
	    _getItem: function _getItem(itemId, itemCollection) {
	        return itemCollection.find(function (item) {
	            return item.id === itemId;
	        });
	    },
	
	    _buildAddress: function _buildAddress(addressId, orderListAMS) {
	        return orderListAMS.included.find(function (item) {
	            return item.type === 'address' && item.id === addressId;
	        });
	    },
	
	    _buildLineItems: function _buildLineItems(lineItemIds, orderListAMS) {
	        var items = [];
	        var lineItems = _lineItems2.default.lineItems(lineItemIds, orderListAMS.included);
	
	        lineItems.forEach(function (item) {
	            item.variant = _lineItems2.default.variant(item.relationships.variant.data.id, orderListAMS.included);
	            item.variant.images = _lineItems2.default.images(item.variant.relationships.images.data.map(function (a) {
	                return a.id;
	            }), orderListAMS.included);
	            item.data_extras = _lineItems2.default.data_extras(item.relationships.data_extras.data.map(function (a) {
	                return a.id;
	            }), orderListAMS.included);
	            item.data_extra_types = _lineItems2.default.data_extra_types(item.data_extras.map(function (a) {
	                return a.attributes.type_id;
	            }), orderListAMS.included);
	
	            if (item.variant.images.length === 0) {
	                var product = _lineItems2.default.product(item.variant.relationships.product.data.id, orderListAMS.included);
	                item.variant.images = _lineItems2.default.images(product.relationships.images.data.map(function (a) {
	                    return a.id;
	                }), orderListAMS.included);
	            }
	
	            items.push(item);
	        });
	
	        return items;
	    },
	
	    _buildShipments: function _buildShipments(shipmentIds, orderListAMS) {
	        var shipments = [];
	        shipmentIds.forEach(function (shipmentId) {
	            var thisShipment = SpreeAPIOrderAdapter._getItem(shipmentId, orderListAMS.included);
	            thisShipment.shipping_rates = _orderModel2.default.shippingRates(thisShipment.relationships.shipping_rates.data.map(function (a) {
	                return a.id;
	            }), orderListAMS.included);
	
	            var selected = _orderModel2.default.selectedShippingRate(thisShipment.relationships.shipping_rates.data.map(function (a) {
	                return a.id;
	            }), orderListAMS.included);
	
	            if (selected) {
	                // eslint-disable-next-line prefer-destructuring
	                thisShipment.selected_shipping_rate = selected[0];
	            }
	
	            shipments.push(thisShipment);
	        });
	
	        return shipments;
	    },
	
	    _buildUser: function _buildUser(userId, orderListAMS) {
	        return orderListAMS.included.find(function (item) {
	            return item.type === 'user' && item.id === userId;
	        });
	    }
	};
	
	exports.default = SpreeAPIOrderAdapter;

/***/ },
/* 238 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var request = __webpack_require__(67);
	
	var CountryAPI = {
	    getCountryList: function getCountryList(params) {
	        return request.get(("https://staging.api.cubalicores.com") + '/api/v1/countries?q[' + params.availableName + ']=true' + (params.zoneId !== undefined ? '&zone_id=' + params.zoneId : '')).query({ per_page: 300 }).set('Accept', 'application/json').send();
	    },
	
	    getStatesByCountry: function getStatesByCountry(params) {
	        return request
	        // eslint-disable-next-line max-len
	        .get(("https://staging.api.cubalicores.com") + '/api/v1/states?' + (params.currentZone ? 'zone_id=' + params.currentZone : '') + '&country_id=' + params.countryId + '&q[' + params.availableName + ']=true').query({ per_page: 300 }).set('Accept', 'application/json').send();
	    },
	
	    getMunicipalityList: function getMunicipalityList(params) {
	        return request.get(("https://staging.api.cubalicores.com") + '/api/v1/cities?country=' + params.countryId + '&state=' + params.stateCode).query({ per_page: 300 }).set('Accept', 'application/json').send();
	    }
	};
	
	exports.default = CountryAPI;

/***/ },
/* 239 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _spreeApiOrderAdapter = __webpack_require__(237);
	
	var _spreeApiOrderAdapter2 = _interopRequireDefault(_spreeApiOrderAdapter);
	
	var _appDefaults = __webpack_require__(39);
	
	var _appDefaults2 = _interopRequireDefault(_appDefaults);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var request = __webpack_require__(67);
	
	var OrdersAPI = {
	    create: function create(locale, userToken) {
	        var fpInfo = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	        var municipality = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
	
	        var sanitizedQueryParams = {};
	        sanitizedQueryParams.locale = locale;
	        if (municipality) {
	            sanitizedQueryParams.municipality = municipality;
	        }
	        var get = request.post(("https://staging.api.cubalicores.com") + '/api/v2/storefront/cart').query(sanitizedQueryParams);
	
	        if (userToken) {
	            get.set('authorization', 'Bearer ' + userToken);
	        }
	
	        var fpPayload = {};
	        // transforming fingerprint info to the expected api format
	        if (fpInfo) {
	            fpPayload.sign = {
	                requestId: fpInfo.requestId,
	                visitorId: fpInfo.visitorId,
	                visitorFound: fpInfo.visitorFound,
	                confidence: fpInfo.confidence.score,
	                incognito: fpInfo.incognito,
	                ip: fpInfo.ip || '',
	                latitude: fpInfo.ipLocation && fpInfo.ipLocation.latitude ? fpInfo.ipLocation.latitude : '',
	                longitude: fpInfo.ipLocation && fpInfo.ipLocation.longitude ? fpInfo.ipLocation.longitude : '',
	                postalCode: fpInfo.ipLocation && fpInfo.ipLocation.postalCode ? fpInfo.ipLocation.postalCode : '',
	                timeZone: fpInfo.ipLocation && fpInfo.ipLocation.timezone ? fpInfo.ipLocation.timezone : '',
	                city: fpInfo.ipLocation && fpInfo.ipLocation.city && fpInfo.ipLocation.city.name ? fpInfo.ipLocation.city.name : '',
	                continent: fpInfo.ipLocation && fpInfo.ipLocation.continent && fpInfo.ipLocation.continent.name ? fpInfo.ipLocation.continent.name : '',
	                country: fpInfo.ipLocation && fpInfo.ipLocation.country && fpInfo.ipLocation.country.name ? fpInfo.ipLocation.country.name : '',
	                state: fpInfo.ipLocation && fpInfo.ipLocation.subdivisions && fpInfo.ipLocation.subdivisions[0] ? fpInfo.ipLocation.subdivisions[0].name : '',
	                browserName: fpInfo.browserName || '',
	                browserVersion: fpInfo.browserVersion || '',
	                osName: fpInfo.os || '',
	                osVersion: fpInfo.osVersion || '',
	                device: fpInfo.device || '',
	                botProbability: fpInfo.bot && fpInfo.bot.probability ? fpInfo.bot.probability : '',
	                botSaf: fpInfo.bot && fpInfo.bot.safe ? fpInfo.bot.safe : ''
	            };
	        }
	
	        return get.send(fpPayload);
	    },
	
	    destroy: function destroy(params) {
	        var sanitizedQueryParams = {};
	        sanitizedQueryParams.locale = params.locale;
	
	        return request.patch(("https://staging.api.cubalicores.com") + '/api/v2/storefront/cart/empty').set('X-Spree-Order-Token', params.token).set('Content-Type', 'application/vnd.api+json').query(sanitizedQueryParams);
	    },
	
	    get: function get(params) {
	        var sanitizedQueryParams = {};
	        sanitizedQueryParams.locale = params.locale;
	        sanitizedQueryParams.zone_id = params.currentZone;
	
	        return request
	        // eslint-disable-next-line max-len
	        .get(("https://staging.api.cubalicores.com") + '/api/v2/storefront/cart?include=line_items,variants,variants.images,variants.product.images,billing_address,shipping_address,user,payments,shipments,promotions,shipments.shipping_rates,line_items.data_extras,variants.product.data_extra_types,municipality,municipality.state').set('X-Spree-Order-Token', params.token).set('Content-Type', 'application/vnd.api+json').query(sanitizedQueryParams).send().then(function (response) {
	            response.body = _spreeApiOrderAdapter2.default.processItem(response.body);
	
	            return response;
	        });
	    },
	
	    getByUser: function getByUser(params) {
	        var sanitizedQueryParams = {};
	        sanitizedQueryParams.locale = params.locale;
	        sanitizedQueryParams.zone_id = params.currentZone;
	
	        return request
	        // eslint-disable-next-line max-len
	        .get(("https://staging.api.cubalicores.com") + '/api/v2/storefront/cart?include=line_items,variants,variants.images,variants.product.images,billing_address,shipping_address,user,payments,shipments,promotions,shipments.shipping_rates,line_items.data_extras,variants.product.data_extra_types,municipality,municipality.state').set('Authorization', 'Bearer ' + params.token).set('Content-Type', 'application/vnd.api+json')
	        // if params.orderToken is undefined header isn't added to the request.
	        .set('X-Spree-Order-Token', params.orderToken).query(sanitizedQueryParams).send().then(function (response) {
	            response.body = _spreeApiOrderAdapter2.default.processItem(response.body);
	
	            return response;
	        });
	    },
	
	    mine: function mine(userToken) {
	        var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	        var sanitizedQueryParams = {};
	        sanitizedQueryParams.locale = params.locale;
	        sanitizedQueryParams.page = params.page_no || 1;
	        sanitizedQueryParams.per_page = _appDefaults2.default.ordersPerPage;
	        sanitizedQueryParams.sort = '-completed_at';
	
	        // eslint-disable-next-line max-len
	        return request.get('' + ("https://staging.api.cubalicores.com") + '/api/v2/storefront/account/orders' + '?include=line_items,variants,variants.images,variants.product.images,billing_address,shipping_address,user,payments,shipments,' + 'promotions,shipments.shipping_rates,line_items.data_extras,variants.product.data_extra_types').query(sanitizedQueryParams).set('authorization', 'Bearer ' + userToken).set('Accept', 'application/json').send().then(function (response) {
	            response.body = _spreeApiOrderAdapter2.default.processList(response.body);
	
	            return response;
	        });
	    }
	};
	
	exports.default = OrdersAPI;

/***/ },
/* 240 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(41);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var request = __webpack_require__(67);
	
	var apiWallets = {
	    kwallet: {
	        getDetails: function getDetails(token) {
	            return request.get(("https://staging.api.cubalicores.com") + '/api/v2/storefront/wallet/account').set('Authorization', 'Bearer ' + token).send();
	        },
	        getTransations: function getTransations(_ref) {
	            var token = _ref.token;
	            var params = _ref.params;
	            return request.get(("https://staging.api.cubalicores.com") + '/api/v2/storefront/wallet/transactions').query(params).set('Authorization', 'Bearer ' + token).send();
	        },
	        makeADeposit: function makeADeposit(_ref2) {
	            var token = _ref2.token;
	            var params = _ref2.params;
	            return request.post(("https://staging.api.cubalicores.com") + '/api/v2/storefront/wallet/deposit').set('Authorization', 'Bearer ' + token).send(params);
	        },
	        getIsActive: function () {
	            var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee(token) {
	                var response;
	                return _regenerator2.default.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                _context.prev = 0;
	                                _context.next = 3;
	                                return request.get(("https://staging.api.cubalicores.com") + '/api/v2/storefront/wallet/account').set('Authorization', 'Bearer ' + token).send();
	
	                            case 3:
	                                response = _context.sent;
	                                return _context.abrupt('return', true);
	
	                            case 7:
	                                _context.prev = 7;
	                                _context.t0 = _context['catch'](0);
	                                return _context.abrupt('return', false);
	
	                            case 10:
	                            case 'end':
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, undefined, [[0, 7]]);
	            }));
	
	            return function getIsActive(_x) {
	                return _ref3.apply(this, arguments);
	            };
	        }(),
	        sendFunds: function sendFunds(_ref4) {
	            var token = _ref4.token;
	            var amount = _ref4.amount;
	            var idTransfer = _ref4.idTransfer;
	            return request.post(("https://staging.api.cubalicores.com") + '/api/v2/storefront/wallet/transfer').set('Authorization', 'Bearer ' + token).set('Content-Type', 'application/json').send({
	                amount: amount,
	                notes: '',
	                target_account_number: idTransfer
	            });
	        },
	        activateWallet: function activateWallet(token) {
	            return request.post(("https://staging.api.cubalicores.com") + '/api/v2/storefront/wallet/create_account').set('Authorization', 'Bearer ' + token).send();
	        }
	    }
	};
	
	var WalletsAPI = {
	    getWalletTransactions: function getWalletTransactions(_ref5) {
	        var wallet = _ref5.wallet;
	        var token = _ref5.token;
	        var params = _ref5.params;
	        return apiWallets[wallet].getTransations({ token: token, params: params });
	    },
	    getWalletDetails: function getWalletDetails(_ref6) {
	        var wallet = _ref6.wallet;
	        var token = _ref6.token;
	        return apiWallets[wallet].getDetails(token);
	    },
	    makeADeposit: function makeADeposit(_ref7) {
	        var wallet = _ref7.wallet;
	        var token = _ref7.token;
	        var params = _ref7.params;
	        return apiWallets[wallet].makeADeposit({ token: token, params: params });
	    },
	    getWalletIsActive: function getWalletIsActive(_ref8) {
	        var wallet = _ref8.wallet;
	        var token = _ref8.token;
	        return apiWallets[wallet].getIsActive(token);
	    },
	    activateWallet: function activateWallet(_ref9) {
	        var wallet = _ref9.wallet;
	        var token = _ref9.token;
	        return apiWallets[wallet].activateWallet(token);
	    },
	    sendFunds: function sendFunds(_ref10) {
	        var wallet = _ref10.wallet;
	        var token = _ref10.token;
	        var amount = _ref10.amount;
	        var idTransfer = _ref10.idTransfer;
	        return apiWallets[wallet].sendFunds({ token: token, amount: amount, idTransfer: idTransfer });
	    }
	};
	
	exports.default = WalletsAPI;

/***/ },
/* 241 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.OrderErrorModal = exports.ExtraTimeModal = undefined;
	
	var _extraTimeModal = __webpack_require__(668);
	
	var _extraTimeModal2 = _interopRequireDefault(_extraTimeModal);
	
	var _fraudulentOrderModal = __webpack_require__(669);
	
	var _fraudulentOrderModal2 = _interopRequireDefault(_fraudulentOrderModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.ExtraTimeModal = _extraTimeModal2.default;
	exports.OrderErrorModal = _fraudulentOrderModal2.default;

/***/ },
/* 242 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(11);
	
	var _helper = __webpack_require__(60);
	
	var _lineItem = __webpack_require__(174);
	
	var _lineItem2 = _interopRequireDefault(_lineItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable react/jsx-one-expression-per-line */
	/* eslint-disable react/jsx-indent */
	
	
	var Shipment = function (_Component) {
	    _inherits(Shipment, _Component);
	
	    function Shipment() {
	        _classCallCheck(this, Shipment);
	
	        return _possibleConstructorReturn(this, (Shipment.__proto__ || Object.getPrototypeOf(Shipment)).apply(this, arguments));
	    }
	
	    _createClass(Shipment, [{
	        key: '_isShipped',
	        value: function _isShipped() {
	            return this.props.shipment.state === 'shipped';
	        }
	    }, {
	        key: '_shipmentStateMarkup',
	        value: function _shipmentStateMarkup() {
	            var thisShipment = this.props.shipment;
	
	            if (this._isShipped()) {
	                return _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'shipmentState.shipped', defaultMessage: 'Shipped' }),
	                    thisShipment.attributes.shipped_at
	                );
	            }
	
	            if (thisShipment.attributes.state === 'pending') {
	                return _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'shipmentState.pending', defaultMessage: 'Shipment under Review' });
	            }
	            if (thisShipment.attributes.state === 'ready') {
	                return _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'shipmentState.ready', defaultMessage: 'Dispatching soon' });
	            }
	            if (thisShipment.attributes.state === 'canceled') {
	                return _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'shipmentState.canceled', defaultMessage: 'Shipment Canceled' });
	            }
	        }
	    }, {
	        key: '_shipmentLineItemsMarkup',
	        value: function _shipmentLineItemsMarkup(storeId, shipment) {
	            var filteredList = this.props.order.line_items.filter(function (item) {
	                return item.attributes && item.attributes.inventory_unit && item.attributes.inventory_unit.shipment_id === Number(shipment.id);
	            });
	            var total = 0;
	            return filteredList && filteredList.length > 0 && filteredList.map(function (lineItem, idx) {
	                total += lineItem.variant.attributes.price * lineItem.attributes.quantity;
	                return _react2.default.createElement(_lineItem2.default, { lineItem: lineItem, key: idx });
	            }).concat(_react2.default.createElement(_lineItem2.default, {
	                customContent: true,
	                col2: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'shippingCharges', defaultMessage: 'Shipping Charges' }),
	                col3: shipment.selected_shipping_rate.attributes.display_cost,
	                key: filteredList.length + 1
	            }), _react2.default.createElement(_lineItem2.default, {
	                customContent: true,
	                col2: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'orderTotal', defaultMessage: 'Order Total' }),
	                col3: _helper.priceFormat.format(total + parseFloat(shipment.selected_shipping_rate.attributes.cost, 10)),
	                key: filteredList.length + 2,
	                noBottomBorder: true
	            }));
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props;
	            var thisShipment = _props.shipment;
	            var store = _props.store;
	            var excludeShipmentNumber = _props.excludeShipmentNumber;
	            var style = _props.style;
	            var _props$hideStoreName = _props.hideStoreName;
	            var hideStoreName = _props$hideStoreName === undefined ? false : _props$hideStoreName;
	            var details = _props.details;
	
	            var others = _objectWithoutProperties(_props, ['shipment', 'store', 'excludeShipmentNumber', 'style', 'hideStoreName', 'details']);
	
	            return _react2.default.createElement(
	                'div',
	                _extends({ className: 'shipment-view' }, others),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row order-padding', style: style },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 margin-top-30' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'shipment-header order-block-header no-margin' },
	                            _react2.default.createElement(
	                                'h3',
	                                { style: { display: hideStoreName ? 'none' : 'initial' } },
	                                store && store.name
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'order-header-labels' },
	                                !excludeShipmentNumber && _react2.default.createElement(
	                                    'label',
	                                    { className: 'label label-default' },
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'shipmentNumber', defaultMessage: 'Ref' }),
	                                    ': ' + thisShipment.attributes.number
	                                ),
	                                thisShipment.selected_shipping_rate &&
	                                // eslint-disable-next-line max-len
	                                _react2.default.createElement(
	                                    'label',
	                                    {
	                                        style: excludeShipmentNumber && {
	                                            fontSize: '13px',
	                                            padding: '0',
	                                            color: 'inherit',
	                                            whiteSpace: 'break-spaces',
	                                            textAlign: 'left'
	                                        },
	                                        className: 'label label-normal shipping-method'
	                                    },
	                                    details && _react2.default.createElement(
	                                        'span',
	                                        null,
	                                        details,
	                                        ' - '
	                                    ),
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'shippingMethod', defaultMessage: 'Shipping Method' }),
	                                    _react2.default.createElement(
	                                        'span',
	                                        null,
	                                        ': ' + thisShipment.selected_shipping_rate.attributes.name
	                                    )
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12' },
	                        store && _react2.default.createElement(
	                            'div',
	                            { className: 'shipment-line-items order-line-items' },
	                            this._shipmentLineItemsMarkup(store.id, thisShipment)
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return Shipment;
	}(_react.Component);
	
	exports.default = Shipment;

/***/ },
/* 243 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _productTileConnector = __webpack_require__(767);
	
	var _productTileConnector2 = _interopRequireDefault(_productTileConnector);
	
	var _infiniteScroller = __webpack_require__(359);
	
	var _infiniteScroller2 = _interopRequireDefault(_infiniteScroller);
	
	var _imageCoomingsoon = __webpack_require__(712);
	
	var _imageCoomingsoon2 = _interopRequireDefault(_imageCoomingsoon);
	
	var _appDefaults = __webpack_require__(39);
	
	var _appDefaults2 = _interopRequireDefault(_appDefaults);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ProductList = function (_Component) {
	    _inherits(ProductList, _Component);
	
	    function ProductList(props) {
	        _classCallCheck(this, ProductList);
	
	        var _this = _possibleConstructorReturn(this, (ProductList.__proto__ || Object.getPrototypeOf(ProductList)).call(this, props));
	
	        _this.state = {
	            currentPage: 1
	        };
	        return _this;
	    }
	
	    _createClass(ProductList, [{
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            this.setState(function (prevState) {
	                return { currentPage: prevState.currentPage + 1 };
	            });
	        }
	    }, {
	        key: 'loadMoreProducts',
	        value: function loadMoreProducts() {
	            return this.props.loadMoreProducts(this.state.currentPage + 1, this.props.locale.currentLocale);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var infiniteScroller = null;
	            var productList = this.props.products.map(function (product, idx) {
	                return _react2.default.createElement(_productTileConnector2.default, { key: idx, product: product });
	            });
	
	            if (this.props.products.length > 0) {
	                infiniteScroller = _react2.default.createElement(
	                    _infiniteScroller2.default,
	                    { loadMore: this.loadMoreProducts.bind(this), pageCount: this.props.pageCount, currentPage: this.state.currentPage },
	                    productList
	                );
	            } else {
	                infiniteScroller = _react2.default.createElement(_imageCoomingsoon2.default, null);
	            }
	
	            return _react2.default.createElement(
	                'article',
	                { className: 'product-list-container product-section' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'product-list' },
	                    _react2.default.createElement(
	                        'div',
	                        { id: 'product-infinite-scroll' },
	                        infiniteScroller
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ProductList;
	}(_react.Component);
	
	exports.default = ProductList;

/***/ },
/* 244 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _categoryBadge = __webpack_require__(2143);
	
	var _categoryBadge2 = _interopRequireDefault(_categoryBadge);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CategoryBadge = function CategoryBadge(props) {
	    var label = props.label;
	    var color = props.color;
	    var _props$isShowProduct = props.isShowProduct;
	    var isShowProduct = _props$isShowProduct === undefined ? false : _props$isShowProduct;
	    var _props$expand = props.expand;
	    var expand = _props$expand === undefined ? false : _props$expand;
	
	    return _react2.default.createElement(
	        'div',
	        { className: _categoryBadge2.default.categoryBadge + ' ' + (isShowProduct ? _categoryBadge2.default.isShowProduct : '') },
	        _react2.default.createElement(
	            'span',
	            {
	                className: _categoryBadge2.default.categoryBadge__title + ' ' + (expand ? _categoryBadge2.default.categoryBadge__title__expand : ''),
	                title: label
	            },
	            label
	        ),
	        _react2.default.createElement('span', { className: _categoryBadge2.default.categoryBadge__tail })
	    );
	};
	
	exports.default = CategoryBadge;

/***/ },
/* 245 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(38);
	
	var _reactIntl = __webpack_require__(11);
	
	var _checkboxTermsAffidavit = __webpack_require__(356);
	
	var _checkboxTermsAffidavit2 = _interopRequireDefault(_checkboxTermsAffidavit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var useState = _react2.default.useState;
	
	
	var KWalletActivateModal = function KWalletActivateModal(props) {
	    var isOpen = props.isOpen;
	    var handleClose = props.handleClose;
	
	    var _useState = useState(false);
	
	    var _useState2 = _slicedToArray(_useState, 2);
	
	    var accept = _useState2[0];
	    var setAccept = _useState2[1];
	
	
	    var onClose = function onClose(result) {
	        setAccept(false);
	        handleClose(result);
	    };
	
	    function handleOnChange(checked) {
	        setAccept(checked);
	    }
	
	    return _react2.default.createElement(
	        _reactBootstrap.Modal,
	        { show: isOpen, 'aria-labelledby': 'contained-modal-title-lg', id: 'modal-municipality-selector' },
	        _react2.default.createElement(
	            _reactBootstrap.Modal.Header,
	            null,
	            _react2.default.createElement(
	                _reactBootstrap.Modal.Title,
	                { id: 'contained-modal-title-lg' },
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'modal-kwallet-activate', defaultMessage: 'Activate Kwallet' })
	            )
	        ),
	        _react2.default.createElement(
	            _reactBootstrap.Modal.Body,
	            null,
	            _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'modal-kwallet-activate-text', defaultMessage: 'Al parecer aun no has activado tu K-Wallet.' }),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement(_checkboxTermsAffidavit2.default, { onChange: handleOnChange })
	            )
	        ),
	        _react2.default.createElement(
	            _reactBootstrap.Modal.Footer,
	            null,
	            _react2.default.createElement(
	                'button',
	                {
	                    disabled: !accept,
	                    type: 'button',
	                    style: { marginRight: '5px' },
	                    className: 'button-secondary button-small',
	                    onClick: function onClick() {
	                        return onClose(true);
	                    }
	                },
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'modal-kwallet-activate-activate', defaultMessage: 'Activate' })
	            ),
	            _react2.default.createElement(
	                'button',
	                {
	                    type: 'button',
	                    style: { marginRight: '5px' },
	                    className: 'button-secondary button-small',
	                    onClick: function onClick() {
	                        return onClose(false);
	                    }
	                },
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'modal-kwallet-activate-cancel', defaultMessage: 'Maybe Later' })
	            )
	        )
	    );
	};
	
	exports.default = KWalletActivateModal;

/***/ },
/* 246 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(38);
	
	var _reactIntl = __webpack_require__(11);
	
	var _actions = __webpack_require__(23);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	var _store = __webpack_require__(40);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MunicipalitySelectorModal = function MunicipalitySelectorModal(props) {
	    var currentZoneMunicipalities = props.currentZoneMunicipalities;
	    var isOpen = props.isOpen;
	    var handleClose = props.handleClose;
	    var intl = props.intl;
	
	    var defaultMunicipality = {
	        id: -1,
	        name: intl.formatMessage({
	            id: 'select',
	            defaultMessage: 'Select'
	        })
	    };
	
	    var _useState = (0, _react.useState)(defaultMunicipality);
	
	    var _useState2 = _slicedToArray(_useState, 2);
	
	    var selectedMunicipality = _useState2[0];
	    var setSelectedMunicipality = _useState2[1];
	
	
	    (0, _react.useEffect)(function () {
	        if (isOpen) {
	            setSelectedMunicipality(defaultMunicipality);
	            _store2.default.dispatch(_actions2.default.setIsMunicipalityPromptModalOpen(true));
	        } else {
	            _store2.default.dispatch(_actions2.default.setIsMunicipalityPromptModalOpen(false));
	        }
	        // eslint-disable-next-line react-hooks/exhaustive-deps
	    }, [isOpen]);
	
	    var onClose = function onClose(selectedMunicipality) {
	        handleClose(selectedMunicipality);
	        _store2.default.dispatch(_actions2.default.setIsMunicipalityPromptModalOpen(false));
	    };
	
	    var isModalValid = function isModalValid() {
	        return selectedMunicipality.id !== -1;
	    };
	    return _react2.default.createElement(
	        _reactBootstrap.Modal,
	        { show: isOpen, 'aria-labelledby': 'contained-modal-title-lg', id: 'modal-municipality-selector' },
	        _react2.default.createElement(
	            _reactBootstrap.Modal.Header,
	            null,
	            _react2.default.createElement(
	                _reactBootstrap.Modal.Title,
	                { id: 'contained-modal-title-lg' },
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'modal-municipalitySelect-title', defaultMessage: 'Please select a municipality' })
	            )
	        ),
	        _react2.default.createElement(
	            _reactBootstrap.Modal.Body,
	            null,
	            _react2.default.createElement(
	                'p',
	                null,
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'modal-municipalitySelect-text1', defaultMessage: 'Por favor, seleccione el municipio en el que desea entregar los productos:' })
	            ),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    _reactBootstrap.DropdownButton,
	                    { id: 'dropdown-basic-button', as: 'button', className: 'button-cancel button-small', title: selectedMunicipality.name },
	                    currentZoneMunicipalities.map(function (municipality) {
	                        return _react2.default.createElement(
	                            _reactBootstrap.MenuItem,
	                            {
	                                as: 'button',
	                                className: 'button-secondary inv button-small',
	                                id: municipality.id,
	                                key: municipality.id,
	                                onClick: function onClick() {
	                                    setSelectedMunicipality(municipality);
	                                }
	                            },
	                            municipality.name
	                        );
	                    })
	                )
	            )
	        ),
	        _react2.default.createElement(
	            _reactBootstrap.Modal.Footer,
	            null,
	            _react2.default.createElement(
	                'button',
	                {
	                    disabled: !isModalValid(),
	                    type: 'button',
	                    style: { marginRight: '5px' },
	                    className: 'button-secondary button-small',
	                    onClick: function onClick() {
	                        return onClose(selectedMunicipality);
	                    }
	                },
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'modal-zoneSelect-accept', defaultMessage: 'Accept' })
	            )
	        )
	    );
	};
	
	exports.default = (0, _reactIntl.injectIntl)(MunicipalitySelectorModal);

/***/ },
/* 247 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(38);
	
	var _reactIntl = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ZoneModal = function (_Component) {
	    _inherits(ZoneModal, _Component);
	
	    function ZoneModal() {
	        _classCallCheck(this, ZoneModal);
	
	        return _possibleConstructorReturn(this, (ZoneModal.__proto__ || Object.getPrototypeOf(ZoneModal)).apply(this, arguments));
	    }
	
	    _createClass(ZoneModal, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            return _react2.default.createElement(
	                _reactBootstrap.Modal,
	                {
	                    show: this.props.show,
	                    bsSize: 'large',
	                    'aria-labelledby': 'contained-modal-title-lg',
	                    onHide: function onHide() {
	                        return _this2.props.onHide(false);
	                    }
	                },
	                _react2.default.createElement(
	                    _reactBootstrap.Modal.Header,
	                    { closeButton: true },
	                    _react2.default.createElement(
	                        _reactBootstrap.Modal.Title,
	                        { id: 'contained-modal-title-lg' },
	                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'modal-store-title', defaultMessage: 'Alert' })
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Modal.Body,
	                    null,
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'modal-zone-text1', defaultMessage: 'default' }),
	                        '. ',
	                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'modal-zone-text2', defaultMessage: '' })
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Modal.Footer,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        { onClick: function onClick() {
	                                return _this2.props.onHide(true);
	                            } },
	                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'modal-store-button-empty', defaultMessage: 'Empty' })
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        { onClick: function onClick() {
	                                return _this2.props.onHide(false);
	                            } },
	                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'modal-store-button-close', defaultMessage: 'Cancel' })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ZoneModal;
	}(_react.Component);
	
	exports.default = ZoneModal;

/***/ },
/* 248 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.PAYMENT_METHOD_COMPONENT_MAPPING = exports.PAYMENT_METHODS = exports.AVAILABLES_FOR = undefined;
	
	var _paymentMethodCreditCard = __webpack_require__(676);
	
	var _paymentMethodCreditCard2 = _interopRequireDefault(_paymentMethodCreditCard);
	
	var _paymentMethodKWallet = __webpack_require__(677);
	
	var _paymentMethodKWallet2 = _interopRequireDefault(_paymentMethodKWallet);
	
	var _paymentMethodRedsys = __webpack_require__(678);
	
	var _paymentMethodRedsys2 = _interopRequireDefault(_paymentMethodRedsys);
	
	var _paymentMethodTropipay = __webpack_require__(679);
	
	var _paymentMethodTropipay2 = _interopRequireDefault(_paymentMethodTropipay);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// eslint-disable-next-line import/no-cycle
	var AVAILABLES_FOR = exports.AVAILABLES_FOR = {
	    billing: 'available_for_billing_true',
	    shipping: 'available_for_shipping_true'
	};
	
	var PAYMENT_METHODS = exports.PAYMENT_METHODS = {
	    credit_card: 'Credit Card',
	    redsys_redirect: 'Redsys',
	    tropipay: 'Tropipay'
	};
	
	var PAYMENT_METHOD_COMPONENT_MAPPING = exports.PAYMENT_METHOD_COMPONENT_MAPPING = function PAYMENT_METHOD_COMPONENT_MAPPING() {
	    var mapping = {};
	    mapping['Spree::Gateway::PinserveGateway'] = _paymentMethodCreditCard2.default;
	    mapping['Spree::Gateway::ElavonGateway'] = _paymentMethodCreditCard2.default;
	    mapping['Spree::BillingIntegration::RedsysPayment'] = _paymentMethodRedsys2.default;
	    mapping['Spree::BillingIntegration::TropiPayPayment'] = _paymentMethodTropipay2.default;
	    if (false) {
	        mapping['Spree::Gateway::KwalletGateway'] = _paymentMethodKWallet2.default;
	    }
	
	    return mapping;
	};

/***/ },
/* 249 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.addProductToCartNextActionEP = exports.addProductToCartNotifyEP = undefined;
	
	var _appTranslations = __webpack_require__(33);
	
	var _appTranslations2 = _interopRequireDefault(_appTranslations);
	
	var _actions = __webpack_require__(23);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var addProductToCartNotifyEP = exports.addProductToCartNotifyEP = function addProductToCartNotifyEP(locale, error, toastr) {
	    if (error && error.response && error.response.body && (error.response.body.error.indexOf('is not available.') > -1 || error.response.body.error.indexOf('no está disponible.') > -1)) {
	        toastr.error(_appTranslations2.default[locale].error, _appTranslations2.default[locale]['sorry-out-of-stock']);
	    } else if (error && error.response && error.response.body && error.response.body.error) {
	        toastr.error(_appTranslations2.default[locale].error, error.response.body.error);
	    } else {
	        toastr.error(_appTranslations2.default[locale]['error-create-order-title'], _appTranslations2.default[locale]['error-create-order-content']);
	    }
	};
	
	var addProductToCartNextActionEP = exports.addProductToCartNextActionEP = function addProductToCartNextActionEP(dispatch, order, locale) {
	    var userToken = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
	
	    if (order.line_items.length > 0) {
	        dispatch(_actions2.default.addingProductToCart());
	    } else {
	        dispatch(_actions2.default.emptyCart(order, locale, userToken));
	    }
	};

/***/ },
/* 250 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _creditCardType = __webpack_require__(391);
	
	var _creditCardType2 = _interopRequireDefault(_creditCardType);
	
	var _binlookup = __webpack_require__(820);
	
	var _binlookup2 = _interopRequireDefault(_binlookup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CreditCard = {
	    mask: function mask(ccNumberStr) {
	        return '************ ' + ccNumberStr.substr(-4);
	    },
	    ccType: function ccType(num) {
	        var ccLogos = ['visa', 'mastercard', 'american-express', 'discover'];
	        var card = (0, _creditCardType2.default)(num);
	        if (num !== '' && card[0] && card[0].type && ccLogos.indexOf(card[0].type) > -1) {
	            return card[0].type;
	        }
	        return 'generic';
	    },
	    getBinLookupInfo: function getBinLookupInfo(cardNum) {
	        if (!cardNum || cardNum === '') return Promise.resolve({});
	        var noSpaceCardNum = cardNum.trim().replaceAll(' ', '');
	        var NUM_OF_DIGITS_TO_SEND = 6;
	        if (noSpaceCardNum.length >= NUM_OF_DIGITS_TO_SEND) {
	            var binLookupService = (0, _binlookup2.default)();
	            return binLookupService(noSpaceCardNum.slice(0, NUM_OF_DIGITS_TO_SEND));
	        }
	        return Promise.resolve({});
	    }
	};
	
	exports.default = CreditCard;

/***/ },
/* 251 */
/***/ function(module, exports, __webpack_require__) {

	// 0 -> Array#forEach
	// 1 -> Array#map
	// 2 -> Array#filter
	// 3 -> Array#some
	// 4 -> Array#every
	// 5 -> Array#find
	// 6 -> Array#findIndex
	var ctx = __webpack_require__(124);
	var IObject = __webpack_require__(255);
	var toObject = __webpack_require__(126);
	var toLength = __webpack_require__(186);
	var asc = __webpack_require__(840);
	module.exports = function (TYPE, $create) {
	  var IS_MAP = TYPE == 1;
	  var IS_FILTER = TYPE == 2;
	  var IS_SOME = TYPE == 3;
	  var IS_EVERY = TYPE == 4;
	  var IS_FIND_INDEX = TYPE == 6;
	  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
	  var create = $create || asc;
	  return function ($this, callbackfn, that) {
	    var O = toObject($this);
	    var self = IObject(O);
	    var f = ctx(callbackfn, that, 3);
	    var length = toLength(self.length);
	    var index = 0;
	    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
	    var val, res;
	    for (;length > index; index++) if (NO_HOLES || index in self) {
	      val = self[index];
	      res = f(val, index, O);
	      if (TYPE) {
	        if (IS_MAP) result[index] = res;   // map
	        else if (res) switch (TYPE) {
	          case 3: return true;             // some
	          case 5: return val;              // find
	          case 6: return index;            // findIndex
	          case 2: result.push(val);        // filter
	        } else if (IS_EVERY) return false; // every
	      }
	    }
	    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
	  };
	};


/***/ },
/* 252 */
/***/ function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


/***/ },
/* 253 */
/***/ function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ },
/* 254 */
/***/ function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(124);
	var call = __webpack_require__(378);
	var isArrayIter = __webpack_require__(377);
	var anObject = __webpack_require__(86);
	var toLength = __webpack_require__(186);
	var getIterFn = __webpack_require__(387);
	var BREAK = {};
	var RETURN = {};
	var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
	  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
	  var f = ctx(fn, that, entries ? 2 : 1);
	  var index = 0;
	  var length, step, iterator, result;
	  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
	  // fast case for arrays with default iterator
	  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
	    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
	    if (result === BREAK || result === RETURN) return result;
	  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
	    result = call(iterator, f, step.value, entries);
	    if (result === BREAK || result === RETURN) return result;
	  }
	};
	exports.BREAK = BREAK;
	exports.RETURN = RETURN;


/***/ },
/* 255 */
/***/ function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(252);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ },
/* 256 */
/***/ function(module, exports, __webpack_require__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(252);
	module.exports = Array.isArray || function isArray(arg) {
	  return cof(arg) == 'Array';
	};


/***/ },
/* 257 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = __webpack_require__(86);
	var dPs = __webpack_require__(850);
	var enumBugKeys = __webpack_require__(253);
	var IE_PROTO = __webpack_require__(261)('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(375)('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(846).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ },
/* 258 */
/***/ function(module, exports, __webpack_require__) {

	var pIE = __webpack_require__(145);
	var createDesc = __webpack_require__(146);
	var toIObject = __webpack_require__(90);
	var toPrimitive = __webpack_require__(264);
	var has = __webpack_require__(88);
	var IE8_DOM_DEFINE = __webpack_require__(376);
	var gOPD = Object.getOwnPropertyDescriptor;
	
	exports.f = __webpack_require__(76) ? gOPD : function getOwnPropertyDescriptor(O, P) {
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if (IE8_DOM_DEFINE) try {
	    return gOPD(O, P);
	  } catch (e) { /* empty */ }
	  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
	};


/***/ },
/* 259 */
/***/ function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;


/***/ },
/* 260 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(89);


/***/ },
/* 261 */
/***/ function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(262)('keys');
	var uid = __webpack_require__(187);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ },
/* 262 */
/***/ function(module, exports, __webpack_require__) {

	var core = __webpack_require__(44);
	var global = __webpack_require__(68);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	
	(module.exports = function (key, value) {
	  return store[key] || (store[key] = value !== undefined ? value : {});
	})('versions', []).push({
	  version: core.version,
	  mode: __webpack_require__(183) ? 'pure' : 'global',
	  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
	});


/***/ },
/* 263 */
/***/ function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ },
/* 264 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(69);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ },
/* 265 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(69);
	module.exports = function (it, TYPE) {
	  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
	  return it;
	};


/***/ },
/* 266 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(68);
	var core = __webpack_require__(44);
	var LIBRARY = __webpack_require__(183);
	var wksExt = __webpack_require__(267);
	var defineProperty = __webpack_require__(80).f;
	module.exports = function (name) {
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
	};


/***/ },
/* 267 */
/***/ function(module, exports, __webpack_require__) {

	exports.f = __webpack_require__(70);


/***/ },
/* 268 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getUTCWeekYear;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	var _index3 = _interopRequireDefault(__webpack_require__(148));
	
	var _index4 = _interopRequireDefault(__webpack_require__(19));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// This function will be a part of public API when UTC function will be implemented.
	// See issue: https://github.com/date-fns/date-fns/issues/376
	function getUTCWeekYear(dirtyDate, dirtyOptions) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var year = date.getUTCFullYear();
	  var options = dirtyOptions || {};
	  var locale = options.locale;
	  var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
	  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : (0, _index4.default)(localeFirstWeekContainsDate);
	  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : (0, _index4.default)(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
	
	  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
	    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
	  }
	
	  var firstWeekOfNextYear = new Date(0);
	  firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
	  firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
	  var startOfNextYear = (0, _index3.default)(firstWeekOfNextYear, dirtyOptions);
	  var firstWeekOfThisYear = new Date(0);
	  firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
	  firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
	  var startOfThisYear = (0, _index3.default)(firstWeekOfThisYear, dirtyOptions);
	
	  if (date.getTime() >= startOfNextYear.getTime()) {
	    return year + 1;
	  } else if (date.getTime() >= startOfThisYear.getTime()) {
	    return year;
	  } else {
	    return year - 1;
	  }
	}
	
	module.exports = exports.default;

/***/ },
/* 269 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addHours;
	
	var _index = _interopRequireDefault(__webpack_require__(19));
	
	var _index2 = _interopRequireDefault(__webpack_require__(149));
	
	var _index3 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MILLISECONDS_IN_HOUR = 3600000;
	/**
	 * @name addHours
	 * @category Hour Helpers
	 * @summary Add the specified number of hours to the given date.
	 *
	 * @description
	 * Add the specified number of hours to the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of hours to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the hours added
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Add 2 hours to 10 July 2014 23:00:00:
	 * const result = addHours(new Date(2014, 6, 10, 23, 0), 2)
	 * //=> Fri Jul 11 2014 01:00:00
	 */
	
	function addHours(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  return (0, _index2.default)(dirtyDate, amount * MILLISECONDS_IN_HOUR);
	}
	
	module.exports = exports.default;

/***/ },
/* 270 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addMinutes;
	
	var _index = _interopRequireDefault(__webpack_require__(19));
	
	var _index2 = _interopRequireDefault(__webpack_require__(149));
	
	var _index3 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MILLISECONDS_IN_MINUTE = 60000;
	/**
	 * @name addMinutes
	 * @category Minute Helpers
	 * @summary Add the specified number of minutes to the given date.
	 *
	 * @description
	 * Add the specified number of minutes to the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of minutes to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the minutes added
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Add 30 minutes to 10 July 2014 12:00:00:
	 * const result = addMinutes(new Date(2014, 6, 10, 12, 0), 30)
	 * //=> Thu Jul 10 2014 12:30:00
	 */
	
	function addMinutes(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  return (0, _index2.default)(dirtyDate, amount * MILLISECONDS_IN_MINUTE);
	}
	
	module.exports = exports.default;

/***/ },
/* 271 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addQuarters;
	
	var _index = _interopRequireDefault(__webpack_require__(19));
	
	var _index2 = _interopRequireDefault(__webpack_require__(150));
	
	var _index3 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name addQuarters
	 * @category Quarter Helpers
	 * @summary Add the specified number of year quarters to the given date.
	 *
	 * @description
	 * Add the specified number of year quarters to the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of quarters to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the quarters added
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Add 1 quarter to 1 September 2014:
	 * const result = addQuarters(new Date(2014, 8, 1), 1)
	 * //=> Mon Dec 01 2014 00:00:00
	 */
	function addQuarters(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  var months = amount * 3;
	  return (0, _index2.default)(dirtyDate, months);
	}
	
	module.exports = exports.default;

/***/ },
/* 272 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = differenceInDays;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(106));
	
	var _index3 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Like `compareAsc` but uses local time not UTC, which is needed
	// for accurate equality comparisons of UTC timestamps that end up
	// having the same representation in local time, e.g. one hour before
	// DST ends vs. the instant that DST ends.
	function compareLocalAsc(dateLeft, dateRight) {
	  var diff = dateLeft.getFullYear() - dateRight.getFullYear() || dateLeft.getMonth() - dateRight.getMonth() || dateLeft.getDate() - dateRight.getDate() || dateLeft.getHours() - dateRight.getHours() || dateLeft.getMinutes() - dateRight.getMinutes() || dateLeft.getSeconds() - dateRight.getSeconds() || dateLeft.getMilliseconds() - dateRight.getMilliseconds();
	
	  if (diff < 0) {
	    return -1;
	  } else if (diff > 0) {
	    return 1; // Return 0 if diff is 0; return NaN if diff is NaN
	  } else {
	    return diff;
	  }
	}
	/**
	 * @name differenceInDays
	 * @category Day Helpers
	 * @summary Get the number of full days between the given dates.
	 *
	 * @description
	 * Get the number of full day periods between two dates. Fractional days are
	 * truncated towards zero.
	 *
	 * One "full day" is the distance between a local time in one day to the same
	 * local time on the next or previous day. A full day can sometimes be less than
	 * or more than 24 hours if a daylight savings change happens between two dates.
	 *
	 * To ignore DST and only measure exact 24-hour periods, use this instead:
	 * `Math.floor(differenceInHours(dateLeft, dateRight)/24)|0`.
	 *
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @returns {Number} the number of full days according to the local timezone
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // How many full days are between
	 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
	 * const result = differenceInDays(
	 *   new Date(2012, 6, 2, 0, 0),
	 *   new Date(2011, 6, 2, 23, 0)
	 * )
	 * //=> 365
	 * // How many full days are between
	 * // 2 July 2011 23:59:00 and 3 July 2011 00:01:00?
	 * const result = differenceInDays(
	 *   new Date(2011, 6, 3, 0, 1),
	 *   new Date(2011, 6, 2, 23, 59)
	 * )
	 * //=> 0
	 * // How many full days are between
	 * // 1 March 2020 0:00 and 1 June 2020 0:00 ?
	 * // Note: because local time is used, the
	 * // result will always be 92 days, even in
	 * // time zones where DST starts and the
	 * // period has only 92*24-1 hours.
	 * const result = differenceInDays(
	 *   new Date(2020, 5, 1),
	 *   new Date(2020, 2, 1)
	 * )
	//=> 92
	 */
	
	
	function differenceInDays(dirtyDateLeft, dirtyDateRight) {
	  (0, _index3.default)(2, arguments);
	  var dateLeft = (0, _index.default)(dirtyDateLeft);
	  var dateRight = (0, _index.default)(dirtyDateRight);
	  var sign = compareLocalAsc(dateLeft, dateRight);
	  var difference = Math.abs((0, _index2.default)(dateLeft, dateRight));
	  dateLeft.setDate(dateLeft.getDate() - sign * difference); // Math.abs(diff in full days - diff in calendar days) === 1 if last calendar day is not full
	  // If so, result must be decreased by 1 in absolute value
	
	  var isLastDayNotFull = Number(compareLocalAsc(dateLeft, dateRight) === -sign);
	  var result = sign * (difference - isLastDayNotFull); // Prevent negative zero
	
	  return result === 0 ? 0 : result;
	}
	
	module.exports = exports.default;

/***/ },
/* 273 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = differenceInSeconds;
	
	var _index = _interopRequireDefault(__webpack_require__(190));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	var _index3 = __webpack_require__(147);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name differenceInSeconds
	 * @category Second Helpers
	 * @summary Get the number of seconds between the given dates.
	 *
	 * @description
	 * Get the number of seconds between the given dates.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @param {Object} [options] - an object with options.
	 * @param {String} [options.roundingMethod='trunc'] - a rounding method (`ceil`, `floor`, `round` or `trunc`)
	 * @returns {Number} the number of seconds
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // How many seconds are between
	 * // 2 July 2014 12:30:07.999 and 2 July 2014 12:30:20.000?
	 * const result = differenceInSeconds(
	 *   new Date(2014, 6, 2, 12, 30, 20, 0),
	 *   new Date(2014, 6, 2, 12, 30, 7, 999)
	 * )
	 * //=> 12
	 */
	function differenceInSeconds(dateLeft, dateRight, options) {
	  (0, _index2.default)(2, arguments);
	  var diff = (0, _index.default)(dateLeft, dateRight) / 1000;
	  return (0, _index3.getRoundingMethod)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
	}
	
	module.exports = exports.default;

/***/ },
/* 274 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = differenceInYears;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(408));
	
	var _index3 = _interopRequireDefault(__webpack_require__(105));
	
	var _index4 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name differenceInYears
	 * @category Year Helpers
	 * @summary Get the number of full years between the given dates.
	 *
	 * @description
	 * Get the number of full years between the given dates.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @returns {Number} the number of full years
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // How many full years are between 31 December 2013 and 11 February 2015?
	 * const result = differenceInYears(new Date(2015, 1, 11), new Date(2013, 11, 31))
	 * //=> 1
	 */
	function differenceInYears(dirtyDateLeft, dirtyDateRight) {
	  (0, _index4.default)(2, arguments);
	  var dateLeft = (0, _index.default)(dirtyDateLeft);
	  var dateRight = (0, _index.default)(dirtyDateRight);
	  var sign = (0, _index3.default)(dateLeft, dateRight);
	  var difference = Math.abs((0, _index2.default)(dateLeft, dateRight)); // Set both dates to a valid leap year for accurate comparison when dealing
	  // with leap days
	
	  dateLeft.setFullYear(1584);
	  dateRight.setFullYear(1584); // Math.abs(diff in full years - diff in calendar years) === 1 if last calendar year is not full
	  // If so, result must be decreased by 1 in absolute value
	
	  var isLastYearNotFull = (0, _index3.default)(dateLeft, dateRight) === -sign;
	  var result = sign * (difference - Number(isLastYearNotFull)); // Prevent negative zero
	
	  return result === 0 ? 0 : result;
	}
	
	module.exports = exports.default;

/***/ },
/* 275 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = eachWeekendOfInterval;
	
	var _index = _interopRequireDefault(__webpack_require__(411));
	
	var _index2 = _interopRequireDefault(__webpack_require__(280));
	
	var _index3 = _interopRequireDefault(__webpack_require__(193));
	
	var _index4 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name eachWeekendOfInterval
	 * @category Interval Helpers
	 * @summary List all the Saturdays and Sundays in the given date interval.
	 *
	 * @description
	 * Get all the Saturdays and Sundays in the given date interval.
	 *
	 * @param {Interval} interval - the given interval. See [Interval]{@link https://date-fns.org/docs/Interval}
	 * @returns {Date[]} an array containing all the Saturdays and Sundays
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} The start of an interval cannot be after its end
	 * @throws {RangeError} Date in interval cannot be `Invalid Date`
	 *
	 * @example
	 * // Lists all Saturdays and Sundays in the given date interval
	 * const result = eachWeekendOfInterval({
	 *   start: new Date(2018, 8, 17),
	 *   end: new Date(2018, 8, 30)
	 * })
	 * //=> [
	 * //   Sat Sep 22 2018 00:00:00,
	 * //   Sun Sep 23 2018 00:00:00,
	 * //   Sat Sep 29 2018 00:00:00,
	 * //   Sun Sep 30 2018 00:00:00
	 * // ]
	 */
	function eachWeekendOfInterval(interval) {
	  (0, _index4.default)(1, arguments);
	  var dateInterval = (0, _index.default)(interval);
	  var weekends = [];
	  var index = 0;
	
	  while (index < dateInterval.length) {
	    var date = dateInterval[index++];
	
	    if ((0, _index3.default)(date)) {
	      weekends.push(date);
	      if ((0, _index2.default)(date)) index = index + 5;
	    }
	  }
	
	  return weekends;
	}
	
	module.exports = exports.default;

/***/ },
/* 276 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = endOfDay;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name endOfDay
	 * @category Day Helpers
	 * @summary Return the end of a day for the given date.
	 *
	 * @description
	 * Return the end of a day for the given date.
	 * The result will be in the local timezone.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the end of a day
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The end of a day for 2 September 2014 11:55:00:
	 * const result = endOfDay(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Tue Sep 02 2014 23:59:59.999
	 */
	function endOfDay(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  date.setHours(23, 59, 59, 999);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 277 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = endOfMonth;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name endOfMonth
	 * @category Month Helpers
	 * @summary Return the end of a month for the given date.
	 *
	 * @description
	 * Return the end of a month for the given date.
	 * The result will be in the local timezone.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the end of a month
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The end of a month for 2 September 2014 11:55:00:
	 * const result = endOfMonth(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Tue Sep 30 2014 23:59:59.999
	 */
	function endOfMonth(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var month = date.getMonth();
	  date.setFullYear(date.getFullYear(), month + 1, 0);
	  date.setHours(23, 59, 59, 999);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 278 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var _exportNames = {
	  add: true,
	  addBusinessDays: true,
	  addDays: true,
	  addHours: true,
	  addISOWeekYears: true,
	  addMilliseconds: true,
	  addMinutes: true,
	  addMonths: true,
	  addQuarters: true,
	  addSeconds: true,
	  addWeeks: true,
	  addYears: true,
	  areIntervalsOverlapping: true,
	  clamp: true,
	  closestIndexTo: true,
	  closestTo: true,
	  compareAsc: true,
	  compareDesc: true,
	  daysToWeeks: true,
	  differenceInBusinessDays: true,
	  differenceInCalendarDays: true,
	  differenceInCalendarISOWeekYears: true,
	  differenceInCalendarISOWeeks: true,
	  differenceInCalendarMonths: true,
	  differenceInCalendarQuarters: true,
	  differenceInCalendarWeeks: true,
	  differenceInCalendarYears: true,
	  differenceInDays: true,
	  differenceInHours: true,
	  differenceInISOWeekYears: true,
	  differenceInMilliseconds: true,
	  differenceInMinutes: true,
	  differenceInMonths: true,
	  differenceInQuarters: true,
	  differenceInSeconds: true,
	  differenceInWeeks: true,
	  differenceInYears: true,
	  eachDayOfInterval: true,
	  eachHourOfInterval: true,
	  eachMinuteOfInterval: true,
	  eachMonthOfInterval: true,
	  eachQuarterOfInterval: true,
	  eachWeekOfInterval: true,
	  eachWeekendOfInterval: true,
	  eachWeekendOfMonth: true,
	  eachWeekendOfYear: true,
	  eachYearOfInterval: true,
	  endOfDay: true,
	  endOfDecade: true,
	  endOfHour: true,
	  endOfISOWeek: true,
	  endOfISOWeekYear: true,
	  endOfMinute: true,
	  endOfMonth: true,
	  endOfQuarter: true,
	  endOfSecond: true,
	  endOfToday: true,
	  endOfTomorrow: true,
	  endOfWeek: true,
	  endOfYear: true,
	  endOfYesterday: true,
	  format: true,
	  formatDistance: true,
	  formatDistanceStrict: true,
	  formatDistanceToNow: true,
	  formatDistanceToNowStrict: true,
	  formatDuration: true,
	  formatISO: true,
	  formatISO9075: true,
	  formatISODuration: true,
	  formatRFC3339: true,
	  formatRFC7231: true,
	  formatRelative: true,
	  fromUnixTime: true,
	  getDate: true,
	  getDay: true,
	  getDayOfYear: true,
	  getDaysInMonth: true,
	  getDaysInYear: true,
	  getDecade: true,
	  getHours: true,
	  getISODay: true,
	  getISOWeek: true,
	  getISOWeekYear: true,
	  getISOWeeksInYear: true,
	  getMilliseconds: true,
	  getMinutes: true,
	  getMonth: true,
	  getOverlappingDaysInIntervals: true,
	  getQuarter: true,
	  getSeconds: true,
	  getTime: true,
	  getUnixTime: true,
	  getWeek: true,
	  getWeekOfMonth: true,
	  getWeekYear: true,
	  getWeeksInMonth: true,
	  getYear: true,
	  hoursToMilliseconds: true,
	  hoursToMinutes: true,
	  hoursToSeconds: true,
	  intervalToDuration: true,
	  intlFormat: true,
	  isAfter: true,
	  isBefore: true,
	  isDate: true,
	  isEqual: true,
	  isExists: true,
	  isFirstDayOfMonth: true,
	  isFriday: true,
	  isFuture: true,
	  isLastDayOfMonth: true,
	  isLeapYear: true,
	  isMatch: true,
	  isMonday: true,
	  isPast: true,
	  isSameDay: true,
	  isSameHour: true,
	  isSameISOWeek: true,
	  isSameISOWeekYear: true,
	  isSameMinute: true,
	  isSameMonth: true,
	  isSameQuarter: true,
	  isSameSecond: true,
	  isSameWeek: true,
	  isSameYear: true,
	  isSaturday: true,
	  isSunday: true,
	  isThisHour: true,
	  isThisISOWeek: true,
	  isThisMinute: true,
	  isThisMonth: true,
	  isThisQuarter: true,
	  isThisSecond: true,
	  isThisWeek: true,
	  isThisYear: true,
	  isThursday: true,
	  isToday: true,
	  isTomorrow: true,
	  isTuesday: true,
	  isValid: true,
	  isWednesday: true,
	  isWeekend: true,
	  isWithinInterval: true,
	  isYesterday: true,
	  lastDayOfDecade: true,
	  lastDayOfISOWeek: true,
	  lastDayOfISOWeekYear: true,
	  lastDayOfMonth: true,
	  lastDayOfQuarter: true,
	  lastDayOfWeek: true,
	  lastDayOfYear: true,
	  lightFormat: true,
	  max: true,
	  milliseconds: true,
	  millisecondsToHours: true,
	  millisecondsToMinutes: true,
	  millisecondsToSeconds: true,
	  min: true,
	  minutesToHours: true,
	  minutesToMilliseconds: true,
	  minutesToSeconds: true,
	  monthsToQuarters: true,
	  monthsToYears: true,
	  nextDay: true,
	  nextFriday: true,
	  nextMonday: true,
	  nextSaturday: true,
	  nextSunday: true,
	  nextThursday: true,
	  nextTuesday: true,
	  nextWednesday: true,
	  parse: true,
	  parseISO: true,
	  parseJSON: true,
	  previousDay: true,
	  previousFriday: true,
	  previousMonday: true,
	  previousSaturday: true,
	  previousSunday: true,
	  previousThursday: true,
	  previousTuesday: true,
	  previousWednesday: true,
	  quartersToMonths: true,
	  quartersToYears: true,
	  roundToNearestMinutes: true,
	  secondsToHours: true,
	  secondsToMilliseconds: true,
	  secondsToMinutes: true,
	  set: true,
	  setDate: true,
	  setDay: true,
	  setDayOfYear: true,
	  setHours: true,
	  setISODay: true,
	  setISOWeek: true,
	  setISOWeekYear: true,
	  setMilliseconds: true,
	  setMinutes: true,
	  setMonth: true,
	  setQuarter: true,
	  setSeconds: true,
	  setWeek: true,
	  setWeekYear: true,
	  setYear: true,
	  startOfDay: true,
	  startOfDecade: true,
	  startOfHour: true,
	  startOfISOWeek: true,
	  startOfISOWeekYear: true,
	  startOfMinute: true,
	  startOfMonth: true,
	  startOfQuarter: true,
	  startOfSecond: true,
	  startOfToday: true,
	  startOfTomorrow: true,
	  startOfWeek: true,
	  startOfWeekYear: true,
	  startOfYear: true,
	  startOfYesterday: true,
	  sub: true,
	  subBusinessDays: true,
	  subDays: true,
	  subHours: true,
	  subISOWeekYears: true,
	  subMilliseconds: true,
	  subMinutes: true,
	  subMonths: true,
	  subQuarters: true,
	  subSeconds: true,
	  subWeeks: true,
	  subYears: true,
	  toDate: true,
	  weeksToDays: true,
	  yearsToMonths: true,
	  yearsToQuarters: true
	};
	Object.defineProperty(exports, "add", {
	  enumerable: true,
	  get: function () {
	    return _index.default;
	  }
	});
	Object.defineProperty(exports, "addBusinessDays", {
	  enumerable: true,
	  get: function () {
	    return _index2.default;
	  }
	});
	Object.defineProperty(exports, "addDays", {
	  enumerable: true,
	  get: function () {
	    return _index3.default;
	  }
	});
	Object.defineProperty(exports, "addHours", {
	  enumerable: true,
	  get: function () {
	    return _index4.default;
	  }
	});
	Object.defineProperty(exports, "addISOWeekYears", {
	  enumerable: true,
	  get: function () {
	    return _index5.default;
	  }
	});
	Object.defineProperty(exports, "addMilliseconds", {
	  enumerable: true,
	  get: function () {
	    return _index6.default;
	  }
	});
	Object.defineProperty(exports, "addMinutes", {
	  enumerable: true,
	  get: function () {
	    return _index7.default;
	  }
	});
	Object.defineProperty(exports, "addMonths", {
	  enumerable: true,
	  get: function () {
	    return _index8.default;
	  }
	});
	Object.defineProperty(exports, "addQuarters", {
	  enumerable: true,
	  get: function () {
	    return _index9.default;
	  }
	});
	Object.defineProperty(exports, "addSeconds", {
	  enumerable: true,
	  get: function () {
	    return _index10.default;
	  }
	});
	Object.defineProperty(exports, "addWeeks", {
	  enumerable: true,
	  get: function () {
	    return _index11.default;
	  }
	});
	Object.defineProperty(exports, "addYears", {
	  enumerable: true,
	  get: function () {
	    return _index12.default;
	  }
	});
	Object.defineProperty(exports, "areIntervalsOverlapping", {
	  enumerable: true,
	  get: function () {
	    return _index13.default;
	  }
	});
	Object.defineProperty(exports, "clamp", {
	  enumerable: true,
	  get: function () {
	    return _index14.default;
	  }
	});
	Object.defineProperty(exports, "closestIndexTo", {
	  enumerable: true,
	  get: function () {
	    return _index15.default;
	  }
	});
	Object.defineProperty(exports, "closestTo", {
	  enumerable: true,
	  get: function () {
	    return _index16.default;
	  }
	});
	Object.defineProperty(exports, "compareAsc", {
	  enumerable: true,
	  get: function () {
	    return _index17.default;
	  }
	});
	Object.defineProperty(exports, "compareDesc", {
	  enumerable: true,
	  get: function () {
	    return _index18.default;
	  }
	});
	Object.defineProperty(exports, "daysToWeeks", {
	  enumerable: true,
	  get: function () {
	    return _index19.default;
	  }
	});
	Object.defineProperty(exports, "differenceInBusinessDays", {
	  enumerable: true,
	  get: function () {
	    return _index20.default;
	  }
	});
	Object.defineProperty(exports, "differenceInCalendarDays", {
	  enumerable: true,
	  get: function () {
	    return _index21.default;
	  }
	});
	Object.defineProperty(exports, "differenceInCalendarISOWeekYears", {
	  enumerable: true,
	  get: function () {
	    return _index22.default;
	  }
	});
	Object.defineProperty(exports, "differenceInCalendarISOWeeks", {
	  enumerable: true,
	  get: function () {
	    return _index23.default;
	  }
	});
	Object.defineProperty(exports, "differenceInCalendarMonths", {
	  enumerable: true,
	  get: function () {
	    return _index24.default;
	  }
	});
	Object.defineProperty(exports, "differenceInCalendarQuarters", {
	  enumerable: true,
	  get: function () {
	    return _index25.default;
	  }
	});
	Object.defineProperty(exports, "differenceInCalendarWeeks", {
	  enumerable: true,
	  get: function () {
	    return _index26.default;
	  }
	});
	Object.defineProperty(exports, "differenceInCalendarYears", {
	  enumerable: true,
	  get: function () {
	    return _index27.default;
	  }
	});
	Object.defineProperty(exports, "differenceInDays", {
	  enumerable: true,
	  get: function () {
	    return _index28.default;
	  }
	});
	Object.defineProperty(exports, "differenceInHours", {
	  enumerable: true,
	  get: function () {
	    return _index29.default;
	  }
	});
	Object.defineProperty(exports, "differenceInISOWeekYears", {
	  enumerable: true,
	  get: function () {
	    return _index30.default;
	  }
	});
	Object.defineProperty(exports, "differenceInMilliseconds", {
	  enumerable: true,
	  get: function () {
	    return _index31.default;
	  }
	});
	Object.defineProperty(exports, "differenceInMinutes", {
	  enumerable: true,
	  get: function () {
	    return _index32.default;
	  }
	});
	Object.defineProperty(exports, "differenceInMonths", {
	  enumerable: true,
	  get: function () {
	    return _index33.default;
	  }
	});
	Object.defineProperty(exports, "differenceInQuarters", {
	  enumerable: true,
	  get: function () {
	    return _index34.default;
	  }
	});
	Object.defineProperty(exports, "differenceInSeconds", {
	  enumerable: true,
	  get: function () {
	    return _index35.default;
	  }
	});
	Object.defineProperty(exports, "differenceInWeeks", {
	  enumerable: true,
	  get: function () {
	    return _index36.default;
	  }
	});
	Object.defineProperty(exports, "differenceInYears", {
	  enumerable: true,
	  get: function () {
	    return _index37.default;
	  }
	});
	Object.defineProperty(exports, "eachDayOfInterval", {
	  enumerable: true,
	  get: function () {
	    return _index38.default;
	  }
	});
	Object.defineProperty(exports, "eachHourOfInterval", {
	  enumerable: true,
	  get: function () {
	    return _index39.default;
	  }
	});
	Object.defineProperty(exports, "eachMinuteOfInterval", {
	  enumerable: true,
	  get: function () {
	    return _index40.default;
	  }
	});
	Object.defineProperty(exports, "eachMonthOfInterval", {
	  enumerable: true,
	  get: function () {
	    return _index41.default;
	  }
	});
	Object.defineProperty(exports, "eachQuarterOfInterval", {
	  enumerable: true,
	  get: function () {
	    return _index42.default;
	  }
	});
	Object.defineProperty(exports, "eachWeekOfInterval", {
	  enumerable: true,
	  get: function () {
	    return _index43.default;
	  }
	});
	Object.defineProperty(exports, "eachWeekendOfInterval", {
	  enumerable: true,
	  get: function () {
	    return _index44.default;
	  }
	});
	Object.defineProperty(exports, "eachWeekendOfMonth", {
	  enumerable: true,
	  get: function () {
	    return _index45.default;
	  }
	});
	Object.defineProperty(exports, "eachWeekendOfYear", {
	  enumerable: true,
	  get: function () {
	    return _index46.default;
	  }
	});
	Object.defineProperty(exports, "eachYearOfInterval", {
	  enumerable: true,
	  get: function () {
	    return _index47.default;
	  }
	});
	Object.defineProperty(exports, "endOfDay", {
	  enumerable: true,
	  get: function () {
	    return _index48.default;
	  }
	});
	Object.defineProperty(exports, "endOfDecade", {
	  enumerable: true,
	  get: function () {
	    return _index49.default;
	  }
	});
	Object.defineProperty(exports, "endOfHour", {
	  enumerable: true,
	  get: function () {
	    return _index50.default;
	  }
	});
	Object.defineProperty(exports, "endOfISOWeek", {
	  enumerable: true,
	  get: function () {
	    return _index51.default;
	  }
	});
	Object.defineProperty(exports, "endOfISOWeekYear", {
	  enumerable: true,
	  get: function () {
	    return _index52.default;
	  }
	});
	Object.defineProperty(exports, "endOfMinute", {
	  enumerable: true,
	  get: function () {
	    return _index53.default;
	  }
	});
	Object.defineProperty(exports, "endOfMonth", {
	  enumerable: true,
	  get: function () {
	    return _index54.default;
	  }
	});
	Object.defineProperty(exports, "endOfQuarter", {
	  enumerable: true,
	  get: function () {
	    return _index55.default;
	  }
	});
	Object.defineProperty(exports, "endOfSecond", {
	  enumerable: true,
	  get: function () {
	    return _index56.default;
	  }
	});
	Object.defineProperty(exports, "endOfToday", {
	  enumerable: true,
	  get: function () {
	    return _index57.default;
	  }
	});
	Object.defineProperty(exports, "endOfTomorrow", {
	  enumerable: true,
	  get: function () {
	    return _index58.default;
	  }
	});
	Object.defineProperty(exports, "endOfWeek", {
	  enumerable: true,
	  get: function () {
	    return _index59.default;
	  }
	});
	Object.defineProperty(exports, "endOfYear", {
	  enumerable: true,
	  get: function () {
	    return _index60.default;
	  }
	});
	Object.defineProperty(exports, "endOfYesterday", {
	  enumerable: true,
	  get: function () {
	    return _index61.default;
	  }
	});
	Object.defineProperty(exports, "format", {
	  enumerable: true,
	  get: function () {
	    return _index62.default;
	  }
	});
	Object.defineProperty(exports, "formatDistance", {
	  enumerable: true,
	  get: function () {
	    return _index63.default;
	  }
	});
	Object.defineProperty(exports, "formatDistanceStrict", {
	  enumerable: true,
	  get: function () {
	    return _index64.default;
	  }
	});
	Object.defineProperty(exports, "formatDistanceToNow", {
	  enumerable: true,
	  get: function () {
	    return _index65.default;
	  }
	});
	Object.defineProperty(exports, "formatDistanceToNowStrict", {
	  enumerable: true,
	  get: function () {
	    return _index66.default;
	  }
	});
	Object.defineProperty(exports, "formatDuration", {
	  enumerable: true,
	  get: function () {
	    return _index67.default;
	  }
	});
	Object.defineProperty(exports, "formatISO", {
	  enumerable: true,
	  get: function () {
	    return _index68.default;
	  }
	});
	Object.defineProperty(exports, "formatISO9075", {
	  enumerable: true,
	  get: function () {
	    return _index69.default;
	  }
	});
	Object.defineProperty(exports, "formatISODuration", {
	  enumerable: true,
	  get: function () {
	    return _index70.default;
	  }
	});
	Object.defineProperty(exports, "formatRFC3339", {
	  enumerable: true,
	  get: function () {
	    return _index71.default;
	  }
	});
	Object.defineProperty(exports, "formatRFC7231", {
	  enumerable: true,
	  get: function () {
	    return _index72.default;
	  }
	});
	Object.defineProperty(exports, "formatRelative", {
	  enumerable: true,
	  get: function () {
	    return _index73.default;
	  }
	});
	Object.defineProperty(exports, "fromUnixTime", {
	  enumerable: true,
	  get: function () {
	    return _index74.default;
	  }
	});
	Object.defineProperty(exports, "getDate", {
	  enumerable: true,
	  get: function () {
	    return _index75.default;
	  }
	});
	Object.defineProperty(exports, "getDay", {
	  enumerable: true,
	  get: function () {
	    return _index76.default;
	  }
	});
	Object.defineProperty(exports, "getDayOfYear", {
	  enumerable: true,
	  get: function () {
	    return _index77.default;
	  }
	});
	Object.defineProperty(exports, "getDaysInMonth", {
	  enumerable: true,
	  get: function () {
	    return _index78.default;
	  }
	});
	Object.defineProperty(exports, "getDaysInYear", {
	  enumerable: true,
	  get: function () {
	    return _index79.default;
	  }
	});
	Object.defineProperty(exports, "getDecade", {
	  enumerable: true,
	  get: function () {
	    return _index80.default;
	  }
	});
	Object.defineProperty(exports, "getHours", {
	  enumerable: true,
	  get: function () {
	    return _index81.default;
	  }
	});
	Object.defineProperty(exports, "getISODay", {
	  enumerable: true,
	  get: function () {
	    return _index82.default;
	  }
	});
	Object.defineProperty(exports, "getISOWeek", {
	  enumerable: true,
	  get: function () {
	    return _index83.default;
	  }
	});
	Object.defineProperty(exports, "getISOWeekYear", {
	  enumerable: true,
	  get: function () {
	    return _index84.default;
	  }
	});
	Object.defineProperty(exports, "getISOWeeksInYear", {
	  enumerable: true,
	  get: function () {
	    return _index85.default;
	  }
	});
	Object.defineProperty(exports, "getMilliseconds", {
	  enumerable: true,
	  get: function () {
	    return _index86.default;
	  }
	});
	Object.defineProperty(exports, "getMinutes", {
	  enumerable: true,
	  get: function () {
	    return _index87.default;
	  }
	});
	Object.defineProperty(exports, "getMonth", {
	  enumerable: true,
	  get: function () {
	    return _index88.default;
	  }
	});
	Object.defineProperty(exports, "getOverlappingDaysInIntervals", {
	  enumerable: true,
	  get: function () {
	    return _index89.default;
	  }
	});
	Object.defineProperty(exports, "getQuarter", {
	  enumerable: true,
	  get: function () {
	    return _index90.default;
	  }
	});
	Object.defineProperty(exports, "getSeconds", {
	  enumerable: true,
	  get: function () {
	    return _index91.default;
	  }
	});
	Object.defineProperty(exports, "getTime", {
	  enumerable: true,
	  get: function () {
	    return _index92.default;
	  }
	});
	Object.defineProperty(exports, "getUnixTime", {
	  enumerable: true,
	  get: function () {
	    return _index93.default;
	  }
	});
	Object.defineProperty(exports, "getWeek", {
	  enumerable: true,
	  get: function () {
	    return _index94.default;
	  }
	});
	Object.defineProperty(exports, "getWeekOfMonth", {
	  enumerable: true,
	  get: function () {
	    return _index95.default;
	  }
	});
	Object.defineProperty(exports, "getWeekYear", {
	  enumerable: true,
	  get: function () {
	    return _index96.default;
	  }
	});
	Object.defineProperty(exports, "getWeeksInMonth", {
	  enumerable: true,
	  get: function () {
	    return _index97.default;
	  }
	});
	Object.defineProperty(exports, "getYear", {
	  enumerable: true,
	  get: function () {
	    return _index98.default;
	  }
	});
	Object.defineProperty(exports, "hoursToMilliseconds", {
	  enumerable: true,
	  get: function () {
	    return _index99.default;
	  }
	});
	Object.defineProperty(exports, "hoursToMinutes", {
	  enumerable: true,
	  get: function () {
	    return _index100.default;
	  }
	});
	Object.defineProperty(exports, "hoursToSeconds", {
	  enumerable: true,
	  get: function () {
	    return _index101.default;
	  }
	});
	Object.defineProperty(exports, "intervalToDuration", {
	  enumerable: true,
	  get: function () {
	    return _index102.default;
	  }
	});
	Object.defineProperty(exports, "intlFormat", {
	  enumerable: true,
	  get: function () {
	    return _index103.default;
	  }
	});
	Object.defineProperty(exports, "isAfter", {
	  enumerable: true,
	  get: function () {
	    return _index104.default;
	  }
	});
	Object.defineProperty(exports, "isBefore", {
	  enumerable: true,
	  get: function () {
	    return _index105.default;
	  }
	});
	Object.defineProperty(exports, "isDate", {
	  enumerable: true,
	  get: function () {
	    return _index106.default;
	  }
	});
	Object.defineProperty(exports, "isEqual", {
	  enumerable: true,
	  get: function () {
	    return _index107.default;
	  }
	});
	Object.defineProperty(exports, "isExists", {
	  enumerable: true,
	  get: function () {
	    return _index108.default;
	  }
	});
	Object.defineProperty(exports, "isFirstDayOfMonth", {
	  enumerable: true,
	  get: function () {
	    return _index109.default;
	  }
	});
	Object.defineProperty(exports, "isFriday", {
	  enumerable: true,
	  get: function () {
	    return _index110.default;
	  }
	});
	Object.defineProperty(exports, "isFuture", {
	  enumerable: true,
	  get: function () {
	    return _index111.default;
	  }
	});
	Object.defineProperty(exports, "isLastDayOfMonth", {
	  enumerable: true,
	  get: function () {
	    return _index112.default;
	  }
	});
	Object.defineProperty(exports, "isLeapYear", {
	  enumerable: true,
	  get: function () {
	    return _index113.default;
	  }
	});
	Object.defineProperty(exports, "isMatch", {
	  enumerable: true,
	  get: function () {
	    return _index114.default;
	  }
	});
	Object.defineProperty(exports, "isMonday", {
	  enumerable: true,
	  get: function () {
	    return _index115.default;
	  }
	});
	Object.defineProperty(exports, "isPast", {
	  enumerable: true,
	  get: function () {
	    return _index116.default;
	  }
	});
	Object.defineProperty(exports, "isSameDay", {
	  enumerable: true,
	  get: function () {
	    return _index117.default;
	  }
	});
	Object.defineProperty(exports, "isSameHour", {
	  enumerable: true,
	  get: function () {
	    return _index118.default;
	  }
	});
	Object.defineProperty(exports, "isSameISOWeek", {
	  enumerable: true,
	  get: function () {
	    return _index119.default;
	  }
	});
	Object.defineProperty(exports, "isSameISOWeekYear", {
	  enumerable: true,
	  get: function () {
	    return _index120.default;
	  }
	});
	Object.defineProperty(exports, "isSameMinute", {
	  enumerable: true,
	  get: function () {
	    return _index121.default;
	  }
	});
	Object.defineProperty(exports, "isSameMonth", {
	  enumerable: true,
	  get: function () {
	    return _index122.default;
	  }
	});
	Object.defineProperty(exports, "isSameQuarter", {
	  enumerable: true,
	  get: function () {
	    return _index123.default;
	  }
	});
	Object.defineProperty(exports, "isSameSecond", {
	  enumerable: true,
	  get: function () {
	    return _index124.default;
	  }
	});
	Object.defineProperty(exports, "isSameWeek", {
	  enumerable: true,
	  get: function () {
	    return _index125.default;
	  }
	});
	Object.defineProperty(exports, "isSameYear", {
	  enumerable: true,
	  get: function () {
	    return _index126.default;
	  }
	});
	Object.defineProperty(exports, "isSaturday", {
	  enumerable: true,
	  get: function () {
	    return _index127.default;
	  }
	});
	Object.defineProperty(exports, "isSunday", {
	  enumerable: true,
	  get: function () {
	    return _index128.default;
	  }
	});
	Object.defineProperty(exports, "isThisHour", {
	  enumerable: true,
	  get: function () {
	    return _index129.default;
	  }
	});
	Object.defineProperty(exports, "isThisISOWeek", {
	  enumerable: true,
	  get: function () {
	    return _index130.default;
	  }
	});
	Object.defineProperty(exports, "isThisMinute", {
	  enumerable: true,
	  get: function () {
	    return _index131.default;
	  }
	});
	Object.defineProperty(exports, "isThisMonth", {
	  enumerable: true,
	  get: function () {
	    return _index132.default;
	  }
	});
	Object.defineProperty(exports, "isThisQuarter", {
	  enumerable: true,
	  get: function () {
	    return _index133.default;
	  }
	});
	Object.defineProperty(exports, "isThisSecond", {
	  enumerable: true,
	  get: function () {
	    return _index134.default;
	  }
	});
	Object.defineProperty(exports, "isThisWeek", {
	  enumerable: true,
	  get: function () {
	    return _index135.default;
	  }
	});
	Object.defineProperty(exports, "isThisYear", {
	  enumerable: true,
	  get: function () {
	    return _index136.default;
	  }
	});
	Object.defineProperty(exports, "isThursday", {
	  enumerable: true,
	  get: function () {
	    return _index137.default;
	  }
	});
	Object.defineProperty(exports, "isToday", {
	  enumerable: true,
	  get: function () {
	    return _index138.default;
	  }
	});
	Object.defineProperty(exports, "isTomorrow", {
	  enumerable: true,
	  get: function () {
	    return _index139.default;
	  }
	});
	Object.defineProperty(exports, "isTuesday", {
	  enumerable: true,
	  get: function () {
	    return _index140.default;
	  }
	});
	Object.defineProperty(exports, "isValid", {
	  enumerable: true,
	  get: function () {
	    return _index141.default;
	  }
	});
	Object.defineProperty(exports, "isWednesday", {
	  enumerable: true,
	  get: function () {
	    return _index142.default;
	  }
	});
	Object.defineProperty(exports, "isWeekend", {
	  enumerable: true,
	  get: function () {
	    return _index143.default;
	  }
	});
	Object.defineProperty(exports, "isWithinInterval", {
	  enumerable: true,
	  get: function () {
	    return _index144.default;
	  }
	});
	Object.defineProperty(exports, "isYesterday", {
	  enumerable: true,
	  get: function () {
	    return _index145.default;
	  }
	});
	Object.defineProperty(exports, "lastDayOfDecade", {
	  enumerable: true,
	  get: function () {
	    return _index146.default;
	  }
	});
	Object.defineProperty(exports, "lastDayOfISOWeek", {
	  enumerable: true,
	  get: function () {
	    return _index147.default;
	  }
	});
	Object.defineProperty(exports, "lastDayOfISOWeekYear", {
	  enumerable: true,
	  get: function () {
	    return _index148.default;
	  }
	});
	Object.defineProperty(exports, "lastDayOfMonth", {
	  enumerable: true,
	  get: function () {
	    return _index149.default;
	  }
	});
	Object.defineProperty(exports, "lastDayOfQuarter", {
	  enumerable: true,
	  get: function () {
	    return _index150.default;
	  }
	});
	Object.defineProperty(exports, "lastDayOfWeek", {
	  enumerable: true,
	  get: function () {
	    return _index151.default;
	  }
	});
	Object.defineProperty(exports, "lastDayOfYear", {
	  enumerable: true,
	  get: function () {
	    return _index152.default;
	  }
	});
	Object.defineProperty(exports, "lightFormat", {
	  enumerable: true,
	  get: function () {
	    return _index153.default;
	  }
	});
	Object.defineProperty(exports, "max", {
	  enumerable: true,
	  get: function () {
	    return _index154.default;
	  }
	});
	Object.defineProperty(exports, "milliseconds", {
	  enumerable: true,
	  get: function () {
	    return _index155.default;
	  }
	});
	Object.defineProperty(exports, "millisecondsToHours", {
	  enumerable: true,
	  get: function () {
	    return _index156.default;
	  }
	});
	Object.defineProperty(exports, "millisecondsToMinutes", {
	  enumerable: true,
	  get: function () {
	    return _index157.default;
	  }
	});
	Object.defineProperty(exports, "millisecondsToSeconds", {
	  enumerable: true,
	  get: function () {
	    return _index158.default;
	  }
	});
	Object.defineProperty(exports, "min", {
	  enumerable: true,
	  get: function () {
	    return _index159.default;
	  }
	});
	Object.defineProperty(exports, "minutesToHours", {
	  enumerable: true,
	  get: function () {
	    return _index160.default;
	  }
	});
	Object.defineProperty(exports, "minutesToMilliseconds", {
	  enumerable: true,
	  get: function () {
	    return _index161.default;
	  }
	});
	Object.defineProperty(exports, "minutesToSeconds", {
	  enumerable: true,
	  get: function () {
	    return _index162.default;
	  }
	});
	Object.defineProperty(exports, "monthsToQuarters", {
	  enumerable: true,
	  get: function () {
	    return _index163.default;
	  }
	});
	Object.defineProperty(exports, "monthsToYears", {
	  enumerable: true,
	  get: function () {
	    return _index164.default;
	  }
	});
	Object.defineProperty(exports, "nextDay", {
	  enumerable: true,
	  get: function () {
	    return _index165.default;
	  }
	});
	Object.defineProperty(exports, "nextFriday", {
	  enumerable: true,
	  get: function () {
	    return _index166.default;
	  }
	});
	Object.defineProperty(exports, "nextMonday", {
	  enumerable: true,
	  get: function () {
	    return _index167.default;
	  }
	});
	Object.defineProperty(exports, "nextSaturday", {
	  enumerable: true,
	  get: function () {
	    return _index168.default;
	  }
	});
	Object.defineProperty(exports, "nextSunday", {
	  enumerable: true,
	  get: function () {
	    return _index169.default;
	  }
	});
	Object.defineProperty(exports, "nextThursday", {
	  enumerable: true,
	  get: function () {
	    return _index170.default;
	  }
	});
	Object.defineProperty(exports, "nextTuesday", {
	  enumerable: true,
	  get: function () {
	    return _index171.default;
	  }
	});
	Object.defineProperty(exports, "nextWednesday", {
	  enumerable: true,
	  get: function () {
	    return _index172.default;
	  }
	});
	Object.defineProperty(exports, "parse", {
	  enumerable: true,
	  get: function () {
	    return _index173.default;
	  }
	});
	Object.defineProperty(exports, "parseISO", {
	  enumerable: true,
	  get: function () {
	    return _index174.default;
	  }
	});
	Object.defineProperty(exports, "parseJSON", {
	  enumerable: true,
	  get: function () {
	    return _index175.default;
	  }
	});
	Object.defineProperty(exports, "previousDay", {
	  enumerable: true,
	  get: function () {
	    return _index176.default;
	  }
	});
	Object.defineProperty(exports, "previousFriday", {
	  enumerable: true,
	  get: function () {
	    return _index177.default;
	  }
	});
	Object.defineProperty(exports, "previousMonday", {
	  enumerable: true,
	  get: function () {
	    return _index178.default;
	  }
	});
	Object.defineProperty(exports, "previousSaturday", {
	  enumerable: true,
	  get: function () {
	    return _index179.default;
	  }
	});
	Object.defineProperty(exports, "previousSunday", {
	  enumerable: true,
	  get: function () {
	    return _index180.default;
	  }
	});
	Object.defineProperty(exports, "previousThursday", {
	  enumerable: true,
	  get: function () {
	    return _index181.default;
	  }
	});
	Object.defineProperty(exports, "previousTuesday", {
	  enumerable: true,
	  get: function () {
	    return _index182.default;
	  }
	});
	Object.defineProperty(exports, "previousWednesday", {
	  enumerable: true,
	  get: function () {
	    return _index183.default;
	  }
	});
	Object.defineProperty(exports, "quartersToMonths", {
	  enumerable: true,
	  get: function () {
	    return _index184.default;
	  }
	});
	Object.defineProperty(exports, "quartersToYears", {
	  enumerable: true,
	  get: function () {
	    return _index185.default;
	  }
	});
	Object.defineProperty(exports, "roundToNearestMinutes", {
	  enumerable: true,
	  get: function () {
	    return _index186.default;
	  }
	});
	Object.defineProperty(exports, "secondsToHours", {
	  enumerable: true,
	  get: function () {
	    return _index187.default;
	  }
	});
	Object.defineProperty(exports, "secondsToMilliseconds", {
	  enumerable: true,
	  get: function () {
	    return _index188.default;
	  }
	});
	Object.defineProperty(exports, "secondsToMinutes", {
	  enumerable: true,
	  get: function () {
	    return _index189.default;
	  }
	});
	Object.defineProperty(exports, "set", {
	  enumerable: true,
	  get: function () {
	    return _index190.default;
	  }
	});
	Object.defineProperty(exports, "setDate", {
	  enumerable: true,
	  get: function () {
	    return _index191.default;
	  }
	});
	Object.defineProperty(exports, "setDay", {
	  enumerable: true,
	  get: function () {
	    return _index192.default;
	  }
	});
	Object.defineProperty(exports, "setDayOfYear", {
	  enumerable: true,
	  get: function () {
	    return _index193.default;
	  }
	});
	Object.defineProperty(exports, "setHours", {
	  enumerable: true,
	  get: function () {
	    return _index194.default;
	  }
	});
	Object.defineProperty(exports, "setISODay", {
	  enumerable: true,
	  get: function () {
	    return _index195.default;
	  }
	});
	Object.defineProperty(exports, "setISOWeek", {
	  enumerable: true,
	  get: function () {
	    return _index196.default;
	  }
	});
	Object.defineProperty(exports, "setISOWeekYear", {
	  enumerable: true,
	  get: function () {
	    return _index197.default;
	  }
	});
	Object.defineProperty(exports, "setMilliseconds", {
	  enumerable: true,
	  get: function () {
	    return _index198.default;
	  }
	});
	Object.defineProperty(exports, "setMinutes", {
	  enumerable: true,
	  get: function () {
	    return _index199.default;
	  }
	});
	Object.defineProperty(exports, "setMonth", {
	  enumerable: true,
	  get: function () {
	    return _index200.default;
	  }
	});
	Object.defineProperty(exports, "setQuarter", {
	  enumerable: true,
	  get: function () {
	    return _index201.default;
	  }
	});
	Object.defineProperty(exports, "setSeconds", {
	  enumerable: true,
	  get: function () {
	    return _index202.default;
	  }
	});
	Object.defineProperty(exports, "setWeek", {
	  enumerable: true,
	  get: function () {
	    return _index203.default;
	  }
	});
	Object.defineProperty(exports, "setWeekYear", {
	  enumerable: true,
	  get: function () {
	    return _index204.default;
	  }
	});
	Object.defineProperty(exports, "setYear", {
	  enumerable: true,
	  get: function () {
	    return _index205.default;
	  }
	});
	Object.defineProperty(exports, "startOfDay", {
	  enumerable: true,
	  get: function () {
	    return _index206.default;
	  }
	});
	Object.defineProperty(exports, "startOfDecade", {
	  enumerable: true,
	  get: function () {
	    return _index207.default;
	  }
	});
	Object.defineProperty(exports, "startOfHour", {
	  enumerable: true,
	  get: function () {
	    return _index208.default;
	  }
	});
	Object.defineProperty(exports, "startOfISOWeek", {
	  enumerable: true,
	  get: function () {
	    return _index209.default;
	  }
	});
	Object.defineProperty(exports, "startOfISOWeekYear", {
	  enumerable: true,
	  get: function () {
	    return _index210.default;
	  }
	});
	Object.defineProperty(exports, "startOfMinute", {
	  enumerable: true,
	  get: function () {
	    return _index211.default;
	  }
	});
	Object.defineProperty(exports, "startOfMonth", {
	  enumerable: true,
	  get: function () {
	    return _index212.default;
	  }
	});
	Object.defineProperty(exports, "startOfQuarter", {
	  enumerable: true,
	  get: function () {
	    return _index213.default;
	  }
	});
	Object.defineProperty(exports, "startOfSecond", {
	  enumerable: true,
	  get: function () {
	    return _index214.default;
	  }
	});
	Object.defineProperty(exports, "startOfToday", {
	  enumerable: true,
	  get: function () {
	    return _index215.default;
	  }
	});
	Object.defineProperty(exports, "startOfTomorrow", {
	  enumerable: true,
	  get: function () {
	    return _index216.default;
	  }
	});
	Object.defineProperty(exports, "startOfWeek", {
	  enumerable: true,
	  get: function () {
	    return _index217.default;
	  }
	});
	Object.defineProperty(exports, "startOfWeekYear", {
	  enumerable: true,
	  get: function () {
	    return _index218.default;
	  }
	});
	Object.defineProperty(exports, "startOfYear", {
	  enumerable: true,
	  get: function () {
	    return _index219.default;
	  }
	});
	Object.defineProperty(exports, "startOfYesterday", {
	  enumerable: true,
	  get: function () {
	    return _index220.default;
	  }
	});
	Object.defineProperty(exports, "sub", {
	  enumerable: true,
	  get: function () {
	    return _index221.default;
	  }
	});
	Object.defineProperty(exports, "subBusinessDays", {
	  enumerable: true,
	  get: function () {
	    return _index222.default;
	  }
	});
	Object.defineProperty(exports, "subDays", {
	  enumerable: true,
	  get: function () {
	    return _index223.default;
	  }
	});
	Object.defineProperty(exports, "subHours", {
	  enumerable: true,
	  get: function () {
	    return _index224.default;
	  }
	});
	Object.defineProperty(exports, "subISOWeekYears", {
	  enumerable: true,
	  get: function () {
	    return _index225.default;
	  }
	});
	Object.defineProperty(exports, "subMilliseconds", {
	  enumerable: true,
	  get: function () {
	    return _index226.default;
	  }
	});
	Object.defineProperty(exports, "subMinutes", {
	  enumerable: true,
	  get: function () {
	    return _index227.default;
	  }
	});
	Object.defineProperty(exports, "subMonths", {
	  enumerable: true,
	  get: function () {
	    return _index228.default;
	  }
	});
	Object.defineProperty(exports, "subQuarters", {
	  enumerable: true,
	  get: function () {
	    return _index229.default;
	  }
	});
	Object.defineProperty(exports, "subSeconds", {
	  enumerable: true,
	  get: function () {
	    return _index230.default;
	  }
	});
	Object.defineProperty(exports, "subWeeks", {
	  enumerable: true,
	  get: function () {
	    return _index231.default;
	  }
	});
	Object.defineProperty(exports, "subYears", {
	  enumerable: true,
	  get: function () {
	    return _index232.default;
	  }
	});
	Object.defineProperty(exports, "toDate", {
	  enumerable: true,
	  get: function () {
	    return _index233.default;
	  }
	});
	Object.defineProperty(exports, "weeksToDays", {
	  enumerable: true,
	  get: function () {
	    return _index234.default;
	  }
	});
	Object.defineProperty(exports, "yearsToMonths", {
	  enumerable: true,
	  get: function () {
	    return _index235.default;
	  }
	});
	Object.defineProperty(exports, "yearsToQuarters", {
	  enumerable: true,
	  get: function () {
	    return _index236.default;
	  }
	});
	
	var _index = _interopRequireDefault(__webpack_require__(938));
	
	var _index2 = _interopRequireDefault(__webpack_require__(401));
	
	var _index3 = _interopRequireDefault(__webpack_require__(82));
	
	var _index4 = _interopRequireDefault(__webpack_require__(269));
	
	var _index5 = _interopRequireDefault(__webpack_require__(402));
	
	var _index6 = _interopRequireDefault(__webpack_require__(149));
	
	var _index7 = _interopRequireDefault(__webpack_require__(270));
	
	var _index8 = _interopRequireDefault(__webpack_require__(150));
	
	var _index9 = _interopRequireDefault(__webpack_require__(271));
	
	var _index10 = _interopRequireDefault(__webpack_require__(403));
	
	var _index11 = _interopRequireDefault(__webpack_require__(189));
	
	var _index12 = _interopRequireDefault(__webpack_require__(404));
	
	var _index13 = _interopRequireDefault(__webpack_require__(939));
	
	var _index14 = _interopRequireDefault(__webpack_require__(940));
	
	var _index15 = _interopRequireDefault(__webpack_require__(941));
	
	var _index16 = _interopRequireDefault(__webpack_require__(942));
	
	var _index17 = _interopRequireDefault(__webpack_require__(105));
	
	var _index18 = _interopRequireDefault(__webpack_require__(943));
	
	var _index19 = _interopRequireDefault(__webpack_require__(944));
	
	var _index20 = _interopRequireDefault(__webpack_require__(945));
	
	var _index21 = _interopRequireDefault(__webpack_require__(106));
	
	var _index22 = _interopRequireDefault(__webpack_require__(405));
	
	var _index23 = _interopRequireDefault(__webpack_require__(946));
	
	var _index24 = _interopRequireDefault(__webpack_require__(406));
	
	var _index25 = _interopRequireDefault(__webpack_require__(947));
	
	var _index26 = _interopRequireDefault(__webpack_require__(407));
	
	var _index27 = _interopRequireDefault(__webpack_require__(408));
	
	var _index28 = _interopRequireDefault(__webpack_require__(272));
	
	var _index29 = _interopRequireDefault(__webpack_require__(409));
	
	var _index30 = _interopRequireDefault(__webpack_require__(948));
	
	var _index31 = _interopRequireDefault(__webpack_require__(190));
	
	var _index32 = _interopRequireDefault(__webpack_require__(410));
	
	var _index33 = _interopRequireDefault(__webpack_require__(191));
	
	var _index34 = _interopRequireDefault(__webpack_require__(949));
	
	var _index35 = _interopRequireDefault(__webpack_require__(273));
	
	var _index36 = _interopRequireDefault(__webpack_require__(950));
	
	var _index37 = _interopRequireDefault(__webpack_require__(274));
	
	var _index38 = _interopRequireDefault(__webpack_require__(411));
	
	var _index39 = _interopRequireDefault(__webpack_require__(951));
	
	var _index40 = _interopRequireDefault(__webpack_require__(952));
	
	var _index41 = _interopRequireDefault(__webpack_require__(953));
	
	var _index42 = _interopRequireDefault(__webpack_require__(954));
	
	var _index43 = _interopRequireDefault(__webpack_require__(955));
	
	var _index44 = _interopRequireDefault(__webpack_require__(275));
	
	var _index45 = _interopRequireDefault(__webpack_require__(956));
	
	var _index46 = _interopRequireDefault(__webpack_require__(957));
	
	var _index47 = _interopRequireDefault(__webpack_require__(958));
	
	var _index48 = _interopRequireDefault(__webpack_require__(276));
	
	var _index49 = _interopRequireDefault(__webpack_require__(959));
	
	var _index50 = _interopRequireDefault(__webpack_require__(960));
	
	var _index51 = _interopRequireDefault(__webpack_require__(961));
	
	var _index52 = _interopRequireDefault(__webpack_require__(962));
	
	var _index53 = _interopRequireDefault(__webpack_require__(963));
	
	var _index54 = _interopRequireDefault(__webpack_require__(277));
	
	var _index55 = _interopRequireDefault(__webpack_require__(964));
	
	var _index56 = _interopRequireDefault(__webpack_require__(965));
	
	var _index57 = _interopRequireDefault(__webpack_require__(966));
	
	var _index58 = _interopRequireDefault(__webpack_require__(967));
	
	var _index59 = _interopRequireDefault(__webpack_require__(412));
	
	var _index60 = _interopRequireDefault(__webpack_require__(413));
	
	var _index61 = _interopRequireDefault(__webpack_require__(968));
	
	var _index62 = _interopRequireDefault(__webpack_require__(414));
	
	var _index63 = _interopRequireDefault(__webpack_require__(415));
	
	var _index64 = _interopRequireDefault(__webpack_require__(416));
	
	var _index65 = _interopRequireDefault(__webpack_require__(969));
	
	var _index66 = _interopRequireDefault(__webpack_require__(970));
	
	var _index67 = _interopRequireDefault(__webpack_require__(971));
	
	var _index68 = _interopRequireDefault(__webpack_require__(972));
	
	var _index69 = _interopRequireDefault(__webpack_require__(973));
	
	var _index70 = _interopRequireDefault(__webpack_require__(974));
	
	var _index71 = _interopRequireDefault(__webpack_require__(975));
	
	var _index72 = _interopRequireDefault(__webpack_require__(976));
	
	var _index73 = _interopRequireDefault(__webpack_require__(977));
	
	var _index74 = _interopRequireDefault(__webpack_require__(978));
	
	var _index75 = _interopRequireDefault(__webpack_require__(417));
	
	var _index76 = _interopRequireDefault(__webpack_require__(192));
	
	var _index77 = _interopRequireDefault(__webpack_require__(979));
	
	var _index78 = _interopRequireDefault(__webpack_require__(418));
	
	var _index79 = _interopRequireDefault(__webpack_require__(980));
	
	var _index80 = _interopRequireDefault(__webpack_require__(981));
	
	var _index81 = _interopRequireDefault(__webpack_require__(982));
	
	var _index82 = _interopRequireDefault(__webpack_require__(419));
	
	var _index83 = _interopRequireDefault(__webpack_require__(420));
	
	var _index84 = _interopRequireDefault(__webpack_require__(128));
	
	var _index85 = _interopRequireDefault(__webpack_require__(983));
	
	var _index86 = _interopRequireDefault(__webpack_require__(984));
	
	var _index87 = _interopRequireDefault(__webpack_require__(985));
	
	var _index88 = _interopRequireDefault(__webpack_require__(986));
	
	var _index89 = _interopRequireDefault(__webpack_require__(987));
	
	var _index90 = _interopRequireDefault(__webpack_require__(421));
	
	var _index91 = _interopRequireDefault(__webpack_require__(988));
	
	var _index92 = _interopRequireDefault(__webpack_require__(422));
	
	var _index93 = _interopRequireDefault(__webpack_require__(989));
	
	var _index94 = _interopRequireDefault(__webpack_require__(423));
	
	var _index95 = _interopRequireDefault(__webpack_require__(990));
	
	var _index96 = _interopRequireDefault(__webpack_require__(424));
	
	var _index97 = _interopRequireDefault(__webpack_require__(991));
	
	var _index98 = _interopRequireDefault(__webpack_require__(992));
	
	var _index99 = _interopRequireDefault(__webpack_require__(993));
	
	var _index100 = _interopRequireDefault(__webpack_require__(994));
	
	var _index101 = _interopRequireDefault(__webpack_require__(995));
	
	var _index102 = _interopRequireDefault(__webpack_require__(996));
	
	var _index103 = _interopRequireDefault(__webpack_require__(997));
	
	var _index104 = _interopRequireDefault(__webpack_require__(998));
	
	var _index105 = _interopRequireDefault(__webpack_require__(999));
	
	var _index106 = _interopRequireDefault(__webpack_require__(425));
	
	var _index107 = _interopRequireDefault(__webpack_require__(1000));
	
	var _index108 = _interopRequireDefault(__webpack_require__(1001));
	
	var _index109 = _interopRequireDefault(__webpack_require__(1002));
	
	var _index110 = _interopRequireDefault(__webpack_require__(1003));
	
	var _index111 = _interopRequireDefault(__webpack_require__(1004));
	
	var _index112 = _interopRequireDefault(__webpack_require__(426));
	
	var _index113 = _interopRequireDefault(__webpack_require__(427));
	
	var _index114 = _interopRequireDefault(__webpack_require__(1005));
	
	var _index115 = _interopRequireDefault(__webpack_require__(1006));
	
	var _index116 = _interopRequireDefault(__webpack_require__(1007));
	
	var _index117 = _interopRequireDefault(__webpack_require__(151));
	
	var _index118 = _interopRequireDefault(__webpack_require__(428));
	
	var _index119 = _interopRequireDefault(__webpack_require__(429));
	
	var _index120 = _interopRequireDefault(__webpack_require__(1008));
	
	var _index121 = _interopRequireDefault(__webpack_require__(430));
	
	var _index122 = _interopRequireDefault(__webpack_require__(431));
	
	var _index123 = _interopRequireDefault(__webpack_require__(432));
	
	var _index124 = _interopRequireDefault(__webpack_require__(433));
	
	var _index125 = _interopRequireDefault(__webpack_require__(279));
	
	var _index126 = _interopRequireDefault(__webpack_require__(434));
	
	var _index127 = _interopRequireDefault(__webpack_require__(435));
	
	var _index128 = _interopRequireDefault(__webpack_require__(280));
	
	var _index129 = _interopRequireDefault(__webpack_require__(1009));
	
	var _index130 = _interopRequireDefault(__webpack_require__(1010));
	
	var _index131 = _interopRequireDefault(__webpack_require__(1011));
	
	var _index132 = _interopRequireDefault(__webpack_require__(1012));
	
	var _index133 = _interopRequireDefault(__webpack_require__(1013));
	
	var _index134 = _interopRequireDefault(__webpack_require__(1014));
	
	var _index135 = _interopRequireDefault(__webpack_require__(1015));
	
	var _index136 = _interopRequireDefault(__webpack_require__(1016));
	
	var _index137 = _interopRequireDefault(__webpack_require__(1017));
	
	var _index138 = _interopRequireDefault(__webpack_require__(1018));
	
	var _index139 = _interopRequireDefault(__webpack_require__(1019));
	
	var _index140 = _interopRequireDefault(__webpack_require__(1020));
	
	var _index141 = _interopRequireDefault(__webpack_require__(83));
	
	var _index142 = _interopRequireDefault(__webpack_require__(1021));
	
	var _index143 = _interopRequireDefault(__webpack_require__(193));
	
	var _index144 = _interopRequireDefault(__webpack_require__(1022));
	
	var _index145 = _interopRequireDefault(__webpack_require__(1023));
	
	var _index146 = _interopRequireDefault(__webpack_require__(1024));
	
	var _index147 = _interopRequireDefault(__webpack_require__(1025));
	
	var _index148 = _interopRequireDefault(__webpack_require__(1026));
	
	var _index149 = _interopRequireDefault(__webpack_require__(436));
	
	var _index150 = _interopRequireDefault(__webpack_require__(1027));
	
	var _index151 = _interopRequireDefault(__webpack_require__(437));
	
	var _index152 = _interopRequireDefault(__webpack_require__(1028));
	
	var _index153 = _interopRequireDefault(__webpack_require__(1029));
	
	var _index154 = _interopRequireDefault(__webpack_require__(446));
	
	var _index155 = _interopRequireDefault(__webpack_require__(1515));
	
	var _index156 = _interopRequireDefault(__webpack_require__(1516));
	
	var _index157 = _interopRequireDefault(__webpack_require__(1517));
	
	var _index158 = _interopRequireDefault(__webpack_require__(1518));
	
	var _index159 = _interopRequireDefault(__webpack_require__(447));
	
	var _index160 = _interopRequireDefault(__webpack_require__(1519));
	
	var _index161 = _interopRequireDefault(__webpack_require__(1520));
	
	var _index162 = _interopRequireDefault(__webpack_require__(1521));
	
	var _index163 = _interopRequireDefault(__webpack_require__(1522));
	
	var _index164 = _interopRequireDefault(__webpack_require__(1523));
	
	var _index165 = _interopRequireDefault(__webpack_require__(94));
	
	var _index166 = _interopRequireDefault(__webpack_require__(1524));
	
	var _index167 = _interopRequireDefault(__webpack_require__(1525));
	
	var _index168 = _interopRequireDefault(__webpack_require__(1526));
	
	var _index169 = _interopRequireDefault(__webpack_require__(1527));
	
	var _index170 = _interopRequireDefault(__webpack_require__(1528));
	
	var _index171 = _interopRequireDefault(__webpack_require__(1529));
	
	var _index172 = _interopRequireDefault(__webpack_require__(1530));
	
	var _index173 = _interopRequireDefault(__webpack_require__(448));
	
	var _index174 = _interopRequireDefault(__webpack_require__(1532));
	
	var _index175 = _interopRequireDefault(__webpack_require__(1533));
	
	var _index176 = _interopRequireDefault(__webpack_require__(95));
	
	var _index177 = _interopRequireDefault(__webpack_require__(1534));
	
	var _index178 = _interopRequireDefault(__webpack_require__(1535));
	
	var _index179 = _interopRequireDefault(__webpack_require__(1536));
	
	var _index180 = _interopRequireDefault(__webpack_require__(1537));
	
	var _index181 = _interopRequireDefault(__webpack_require__(1538));
	
	var _index182 = _interopRequireDefault(__webpack_require__(1539));
	
	var _index183 = _interopRequireDefault(__webpack_require__(1540));
	
	var _index184 = _interopRequireDefault(__webpack_require__(1541));
	
	var _index185 = _interopRequireDefault(__webpack_require__(1542));
	
	var _index186 = _interopRequireDefault(__webpack_require__(1543));
	
	var _index187 = _interopRequireDefault(__webpack_require__(1544));
	
	var _index188 = _interopRequireDefault(__webpack_require__(1545));
	
	var _index189 = _interopRequireDefault(__webpack_require__(1546));
	
	var _index190 = _interopRequireDefault(__webpack_require__(1547));
	
	var _index191 = _interopRequireDefault(__webpack_require__(1548));
	
	var _index192 = _interopRequireDefault(__webpack_require__(1549));
	
	var _index193 = _interopRequireDefault(__webpack_require__(1550));
	
	var _index194 = _interopRequireDefault(__webpack_require__(1551));
	
	var _index195 = _interopRequireDefault(__webpack_require__(1552));
	
	var _index196 = _interopRequireDefault(__webpack_require__(1553));
	
	var _index197 = _interopRequireDefault(__webpack_require__(449));
	
	var _index198 = _interopRequireDefault(__webpack_require__(1554));
	
	var _index199 = _interopRequireDefault(__webpack_require__(1555));
	
	var _index200 = _interopRequireDefault(__webpack_require__(285));
	
	var _index201 = _interopRequireDefault(__webpack_require__(1556));
	
	var _index202 = _interopRequireDefault(__webpack_require__(1557));
	
	var _index203 = _interopRequireDefault(__webpack_require__(1558));
	
	var _index204 = _interopRequireDefault(__webpack_require__(1559));
	
	var _index205 = _interopRequireDefault(__webpack_require__(1560));
	
	var _index206 = _interopRequireDefault(__webpack_require__(194));
	
	var _index207 = _interopRequireDefault(__webpack_require__(1561));
	
	var _index208 = _interopRequireDefault(__webpack_require__(450));
	
	var _index209 = _interopRequireDefault(__webpack_require__(109));
	
	var _index210 = _interopRequireDefault(__webpack_require__(152));
	
	var _index211 = _interopRequireDefault(__webpack_require__(286));
	
	var _index212 = _interopRequireDefault(__webpack_require__(195));
	
	var _index213 = _interopRequireDefault(__webpack_require__(287));
	
	var _index214 = _interopRequireDefault(__webpack_require__(451));
	
	var _index215 = _interopRequireDefault(__webpack_require__(1562));
	
	var _index216 = _interopRequireDefault(__webpack_require__(1563));
	
	var _index217 = _interopRequireDefault(__webpack_require__(96));
	
	var _index218 = _interopRequireDefault(__webpack_require__(288));
	
	var _index219 = _interopRequireDefault(__webpack_require__(289));
	
	var _index220 = _interopRequireDefault(__webpack_require__(1564));
	
	var _index221 = _interopRequireDefault(__webpack_require__(452));
	
	var _index222 = _interopRequireDefault(__webpack_require__(1565));
	
	var _index223 = _interopRequireDefault(__webpack_require__(196));
	
	var _index224 = _interopRequireDefault(__webpack_require__(1566));
	
	var _index225 = _interopRequireDefault(__webpack_require__(453));
	
	var _index226 = _interopRequireDefault(__webpack_require__(153));
	
	var _index227 = _interopRequireDefault(__webpack_require__(1567));
	
	var _index228 = _interopRequireDefault(__webpack_require__(454));
	
	var _index229 = _interopRequireDefault(__webpack_require__(1568));
	
	var _index230 = _interopRequireDefault(__webpack_require__(1569));
	
	var _index231 = _interopRequireDefault(__webpack_require__(1570));
	
	var _index232 = _interopRequireDefault(__webpack_require__(1571));
	
	var _index233 = _interopRequireDefault(__webpack_require__(3));
	
	var _index234 = _interopRequireDefault(__webpack_require__(1572));
	
	var _index235 = _interopRequireDefault(__webpack_require__(1573));
	
	var _index236 = _interopRequireDefault(__webpack_require__(1574));
	
	var _index237 = __webpack_require__(36);
	
	Object.keys(_index237).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function () {
	      return _index237[key];
	    }
	  });
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 279 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isSameWeek;
	
	var _index = _interopRequireDefault(__webpack_require__(96));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isSameWeek
	 * @category Week Helpers
	 * @summary Are the given dates in the same week (and month and year)?
	 *
	 * @description
	 * Are the given dates in the same week (and month and year)?
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the first date to check
	 * @param {Date|Number} dateRight - the second date to check
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @returns {Boolean} the dates are in the same week (and month and year)
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 *
	 * @example
	 * // Are 31 August 2014 and 4 September 2014 in the same week?
	 * var result = isSameWeek(new Date(2014, 7, 31), new Date(2014, 8, 4))
	 * //=> true
	 *
	 * @example
	 * // If week starts with Monday,
	 * // are 31 August 2014 and 4 September 2014 in the same week?
	 * var result = isSameWeek(new Date(2014, 7, 31), new Date(2014, 8, 4), {
	 *   weekStartsOn: 1
	 * })
	 * //=> false
	 * 
	 * @example
	 * // Are 1 January 2014 and 1 January 2015 in the same week?
	 * var result = isSameWeek(new Date(2014, 0, 1), new Date(2015, 0, 1))
	 * //=> false
	 */
	function isSameWeek(dirtyDateLeft, dirtyDateRight, dirtyOptions) {
	  (0, _index2.default)(2, arguments);
	  var dateLeftStartOfWeek = (0, _index.default)(dirtyDateLeft, dirtyOptions);
	  var dateRightStartOfWeek = (0, _index.default)(dirtyDateRight, dirtyOptions);
	  return dateLeftStartOfWeek.getTime() === dateRightStartOfWeek.getTime();
	}
	
	module.exports = exports.default;

/***/ },
/* 280 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isSunday;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isSunday
	 * @category Weekday Helpers
	 * @summary Is the given date Sunday?
	 *
	 * @description
	 * Is the given date Sunday?
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is Sunday
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Is 21 September 2014 Sunday?
	 * var result = isSunday(new Date(2014, 8, 21))
	 * //=> true
	 */
	function isSunday(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(dirtyDate).getDay() === 0;
	}
	
	module.exports = exports.default;

/***/ },
/* 281 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    one: 'moins d’une seconde',
	    other: 'moins de {{count}} secondes'
	  },
	  xSeconds: {
	    one: '1 seconde',
	    other: '{{count}} secondes'
	  },
	  halfAMinute: '30 secondes',
	  lessThanXMinutes: {
	    one: 'moins d’une minute',
	    other: 'moins de {{count}} minutes'
	  },
	  xMinutes: {
	    one: '1 minute',
	    other: '{{count}} minutes'
	  },
	  aboutXHours: {
	    one: 'environ 1 heure',
	    other: 'environ {{count}} heures'
	  },
	  xHours: {
	    one: '1 heure',
	    other: '{{count}} heures'
	  },
	  xDays: {
	    one: '1 jour',
	    other: '{{count}} jours'
	  },
	  aboutXWeeks: {
	    one: 'environ 1 semaine',
	    other: 'environ {{count}} semaines'
	  },
	  xWeeks: {
	    one: '1 semaine',
	    other: '{{count}} semaines'
	  },
	  aboutXMonths: {
	    one: 'environ 1 mois',
	    other: 'environ {{count}} mois'
	  },
	  xMonths: {
	    one: '1 mois',
	    other: '{{count}} mois'
	  },
	  aboutXYears: {
	    one: 'environ 1 an',
	    other: 'environ {{count}} ans'
	  },
	  xYears: {
	    one: '1 an',
	    other: '{{count}} ans'
	  },
	  overXYears: {
	    one: 'plus d’un an',
	    other: 'plus de {{count}} ans'
	  },
	  almostXYears: {
	    one: 'presqu’un an',
	    other: 'presque {{count}} ans'
	  }
	};
	
	var formatDistance = function (token, count, options) {
	  var result;
	  var form = formatDistanceLocale[token];
	
	  if (typeof form === 'string') {
	    result = form;
	  } else if (count === 1) {
	    result = form.one;
	  } else {
	    result = form.other.replace('{{count}}', String(count));
	  }
	
	  if (options !== null && options !== void 0 && options.addSuffix) {
	    if (options.comparison && options.comparison > 0) {
	      return 'dans ' + result;
	    } else {
	      return 'il y a ' + result;
	    }
	  }
	
	  return result;
	};
	
	var _default = formatDistance;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 282 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eraValues = {
	  narrow: ['av. J.-C', 'ap. J.-C'],
	  abbreviated: ['av. J.-C', 'ap. J.-C'],
	  wide: ['avant Jésus-Christ', 'après Jésus-Christ']
	};
	var quarterValues = {
	  narrow: ['T1', 'T2', 'T3', 'T4'],
	  abbreviated: ['1er trim.', '2ème trim.', '3ème trim.', '4ème trim.'],
	  wide: ['1er trimestre', '2ème trimestre', '3ème trimestre', '4ème trimestre']
	};
	var monthValues = {
	  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
	  abbreviated: ['janv.', 'févr.', 'mars', 'avr.', 'mai', 'juin', 'juil.', 'août', 'sept.', 'oct.', 'nov.', 'déc.'],
	  wide: ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre']
	};
	var dayValues = {
	  narrow: ['D', 'L', 'M', 'M', 'J', 'V', 'S'],
	  short: ['di', 'lu', 'ma', 'me', 'je', 've', 'sa'],
	  abbreviated: ['dim.', 'lun.', 'mar.', 'mer.', 'jeu.', 'ven.', 'sam.'],
	  wide: ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi']
	};
	var dayPeriodValues = {
	  narrow: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'minuit',
	    noon: 'midi',
	    morning: 'mat.',
	    afternoon: 'ap.m.',
	    evening: 'soir',
	    night: 'mat.'
	  },
	  abbreviated: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'minuit',
	    noon: 'midi',
	    morning: 'matin',
	    afternoon: 'après-midi',
	    evening: 'soir',
	    night: 'matin'
	  },
	  wide: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'minuit',
	    noon: 'midi',
	    morning: 'du matin',
	    afternoon: 'de l’après-midi',
	    evening: 'du soir',
	    night: 'du matin'
	  }
	};
	
	var ordinalNumber = function (dirtyNumber, options) {
	  var number = Number(dirtyNumber);
	  var unit = options === null || options === void 0 ? void 0 : options.unit;
	  if (number === 0) return '0';
	  var feminineUnits = ['year', 'week', 'hour', 'minute', 'second'];
	  var suffix;
	
	  if (number === 1) {
	    suffix = unit && feminineUnits.includes(unit) ? 'ère' : 'er';
	  } else {
	    suffix = 'ème';
	  }
	
	  return number + suffix;
	};
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return quarter - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 283 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(14));
	
	var _index2 = _interopRequireDefault(__webpack_require__(15));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(\d+)(ième|ère|ème|er|e)?/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^(av\.J\.C|ap\.J\.C|ap\.J\.-C)/i,
	  abbreviated: /^(av\.J\.-C|av\.J-C|apr\.J\.-C|apr\.J-C|ap\.J-C)/i,
	  wide: /^(avant Jésus-Christ|après Jésus-Christ)/i
	};
	var parseEraPatterns = {
	  any: [/^av/i, /^ap/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^T?[1234]/i,
	  abbreviated: /^[1234](er|ème|e)? trim\.?/i,
	  wide: /^[1234](er|ème|e)? trimestre/i
	};
	var parseQuarterPatterns = {
	  any: [/1/i, /2/i, /3/i, /4/i]
	};
	var matchMonthPatterns = {
	  narrow: /^[jfmasond]/i,
	  abbreviated: /^(janv|févr|mars|avr|mai|juin|juill|juil|août|sept|oct|nov|déc)\.?/i,
	  wide: /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i
	};
	var parseMonthPatterns = {
	  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
	  any: [/^ja/i, /^f/i, /^mar/i, /^av/i, /^ma/i, /^juin/i, /^juil/i, /^ao/i, /^s/i, /^o/i, /^n/i, /^d/i]
	};
	var matchDayPatterns = {
	  narrow: /^[lmjvsd]/i,
	  short: /^(di|lu|ma|me|je|ve|sa)/i,
	  abbreviated: /^(dim|lun|mar|mer|jeu|ven|sam)\.?/i,
	  wide: /^(dimanche|lundi|mardi|mercredi|jeudi|vendredi|samedi)/i
	};
	var parseDayPatterns = {
	  narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^j/i, /^v/i, /^s/i],
	  any: [/^di/i, /^lu/i, /^ma/i, /^me/i, /^je/i, /^ve/i, /^sa/i]
	};
	var matchDayPeriodPatterns = {
	  narrow: /^(a|p|minuit|midi|mat\.?|ap\.?m\.?|soir|nuit)/i,
	  any: /^([ap]\.?\s?m\.?|du matin|de l'après[-\s]midi|du soir|de la nuit)/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^a/i,
	    pm: /^p/i,
	    midnight: /^min/i,
	    noon: /^mid/i,
	    morning: /mat/i,
	    afternoon: /ap/i,
	    evening: /soir/i,
	    night: /nuit/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index2.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value);
	    }
	  }),
	  era: (0, _index.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 284 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.localeToNumber = localeToNumber;
	exports.numberToLocale = numberToLocale;
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var numberValues = {
	  locale: {
	    '1': '१',
	    '2': '२',
	    '3': '३',
	    '4': '४',
	    '5': '५',
	    '6': '६',
	    '7': '७',
	    '8': '८',
	    '9': '९',
	    '0': '०'
	  },
	  number: {
	    '१': '1',
	    '२': '2',
	    '३': '3',
	    '४': '4',
	    '५': '5',
	    '६': '6',
	    '७': '7',
	    '८': '8',
	    '९': '9',
	    '०': '0'
	  }
	}; // CLDR #1585 - #1592
	
	var eraValues = {
	  narrow: ['ईसा-पूर्व', 'ईस्वी'],
	  abbreviated: ['ईसा-पूर्व', 'ईस्वी'],
	  wide: ['ईसा-पूर्व', 'ईसवी सन']
	}; // CLDR #1593 - #1616
	
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['ति1', 'ति2', 'ति3', 'ति4'],
	  wide: ['पहली तिमाही', 'दूसरी तिमाही', 'तीसरी तिमाही', 'चौथी तिमाही']
	}; // Note: in English, the names of days of the week and months are capitalized.
	// If you are making a new locale based on this one, check if the same is true for the language you're working on.
	// Generally, formatted dates should look like they are in the middle of a sentence,
	// e.g. in Spanish language the weekdays and months should be in the lowercase.
	// https://www.unicode.org/cldr/charts/32/summary/hi.html
	// CLDR #1617 - #1688
	
	var monthValues = {
	  narrow: ['ज', 'फ़', 'मा', 'अ', 'मई', 'जू', 'जु', 'अग', 'सि', 'अक्टू', 'न', 'दि'],
	  abbreviated: ['जन', 'फ़र', 'मार्च', 'अप्रैल', 'मई', 'जून', 'जुल', 'अग', 'सित', 'अक्टू', 'नव', 'दिस'],
	  wide: ['जनवरी', 'फ़रवरी', 'मार्च', 'अप्रैल', 'मई', 'जून', 'जुलाई', 'अगस्त', 'सितंबर', 'अक्टूबर', 'नवंबर', 'दिसंबर']
	}; // CLDR #1689 - #1744
	
	var dayValues = {
	  narrow: ['र', 'सो', 'मं', 'बु', 'गु', 'शु', 'श'],
	  short: ['र', 'सो', 'मं', 'बु', 'गु', 'शु', 'श'],
	  abbreviated: ['रवि', 'सोम', 'मंगल', 'बुध', 'गुरु', 'शुक्र', 'शनि'],
	  wide: ['रविवार', 'सोमवार', 'मंगलवार', 'बुधवार', 'गुरुवार', 'शुक्रवार', 'शनिवार']
	};
	var dayPeriodValues = {
	  narrow: {
	    am: 'पूर्वाह्न',
	    pm: 'अपराह्न',
	    midnight: 'मध्यरात्रि',
	    noon: 'दोपहर',
	    morning: 'सुबह',
	    afternoon: 'दोपहर',
	    evening: 'शाम',
	    night: 'रात'
	  },
	  abbreviated: {
	    am: 'पूर्वाह्न',
	    pm: 'अपराह्न',
	    midnight: 'मध्यरात्रि',
	    noon: 'दोपहर',
	    morning: 'सुबह',
	    afternoon: 'दोपहर',
	    evening: 'शाम',
	    night: 'रात'
	  },
	  wide: {
	    am: 'पूर्वाह्न',
	    pm: 'अपराह्न',
	    midnight: 'मध्यरात्रि',
	    noon: 'दोपहर',
	    morning: 'सुबह',
	    afternoon: 'दोपहर',
	    evening: 'शाम',
	    night: 'रात'
	  }
	};
	var formattingDayPeriodValues = {
	  narrow: {
	    am: 'पूर्वाह्न',
	    pm: 'अपराह्न',
	    midnight: 'मध्यरात्रि',
	    noon: 'दोपहर',
	    morning: 'सुबह',
	    afternoon: 'दोपहर',
	    evening: 'शाम',
	    night: 'रात'
	  },
	  abbreviated: {
	    am: 'पूर्वाह्न',
	    pm: 'अपराह्न',
	    midnight: 'मध्यरात्रि',
	    noon: 'दोपहर',
	    morning: 'सुबह',
	    afternoon: 'दोपहर',
	    evening: 'शाम',
	    night: 'रात'
	  },
	  wide: {
	    am: 'पूर्वाह्न',
	    pm: 'अपराह्न',
	    midnight: 'मध्यरात्रि',
	    noon: 'दोपहर',
	    morning: 'सुबह',
	    afternoon: 'दोपहर',
	    evening: 'शाम',
	    night: 'रात'
	  }
	};
	
	var ordinalNumber = function (dirtyNumber, _options) {
	  var number = Number(dirtyNumber);
	  return numberToLocale(number);
	};
	
	function localeToNumber(locale) {
	  var enNumber = locale.toString().replace(/[१२३४५६७८९०]/g, function (match) {
	    return numberValues.number[match];
	  });
	  return Number(enNumber);
	}
	
	function numberToLocale(enNumber) {
	  return enNumber.toString().replace(/\d/g, function (match) {
	    return numberValues.locale[match];
	  });
	}
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return quarter - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingDayPeriodValues,
	    defaultFormattingWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;

/***/ },
/* 285 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setMonth;
	
	var _index = _interopRequireDefault(__webpack_require__(19));
	
	var _index2 = _interopRequireDefault(__webpack_require__(3));
	
	var _index3 = _interopRequireDefault(__webpack_require__(418));
	
	var _index4 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name setMonth
	 * @category Month Helpers
	 * @summary Set the month to the given date.
	 *
	 * @description
	 * Set the month to the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} month - the month of the new date
	 * @returns {Date} the new date with the month set
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Set February to 1 September 2014:
	 * const result = setMonth(new Date(2014, 8, 1), 1)
	 * //=> Sat Feb 01 2014 00:00:00
	 */
	function setMonth(dirtyDate, dirtyMonth) {
	  (0, _index4.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var month = (0, _index.default)(dirtyMonth);
	  var year = date.getFullYear();
	  var day = date.getDate();
	  var dateWithDesiredMonth = new Date(0);
	  dateWithDesiredMonth.setFullYear(year, month, 15);
	  dateWithDesiredMonth.setHours(0, 0, 0, 0);
	  var daysInMonth = (0, _index3.default)(dateWithDesiredMonth); // Set the last day of the new month
	  // if the original date was the last day of the longer month
	
	  date.setMonth(month, Math.min(day, daysInMonth));
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 286 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfMinute;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name startOfMinute
	 * @category Minute Helpers
	 * @summary Return the start of a minute for the given date.
	 *
	 * @description
	 * Return the start of a minute for the given date.
	 * The result will be in the local timezone.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the start of a minute
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The start of a minute for 1 December 2014 22:15:45.400:
	 * const result = startOfMinute(new Date(2014, 11, 1, 22, 15, 45, 400))
	 * //=> Mon Dec 01 2014 22:15:00
	 */
	function startOfMinute(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  date.setSeconds(0, 0);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 287 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfQuarter;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name startOfQuarter
	 * @category Quarter Helpers
	 * @summary Return the start of a year quarter for the given date.
	 *
	 * @description
	 * Return the start of a year quarter for the given date.
	 * The result will be in the local timezone.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the start of a quarter
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The start of a quarter for 2 September 2014 11:55:00:
	 * const result = startOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Tue Jul 01 2014 00:00:00
	 */
	function startOfQuarter(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var currentMonth = date.getMonth();
	  var month = currentMonth - currentMonth % 3;
	  date.setMonth(month, 1);
	  date.setHours(0, 0, 0, 0);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 288 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfWeekYear;
	
	var _index = _interopRequireDefault(__webpack_require__(424));
	
	var _index2 = _interopRequireDefault(__webpack_require__(96));
	
	var _index3 = _interopRequireDefault(__webpack_require__(19));
	
	var _index4 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name startOfWeekYear
	 * @category Week-Numbering Year Helpers
	 * @summary Return the start of a local week-numbering year for the given date.
	 *
	 * @description
	 * Return the start of a local week-numbering year.
	 * The exact calculation depends on the values of
	 * `options.weekStartsOn` (which is the index of the first day of the week)
	 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
	 * the first week of the week-numbering year)
	 *
	 * Week numbering: https://en.wikipedia.org/wiki/Week#Week_numbering
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
	 * @returns {Date} the start of a week-numbering year
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
	 *
	 * @example
	 * // The start of an a week-numbering year for 2 July 2005 with default settings:
	 * const result = startOfWeekYear(new Date(2005, 6, 2))
	 * //=> Sun Dec 26 2004 00:00:00
	 *
	 * @example
	 * // The start of a week-numbering year for 2 July 2005
	 * // if Monday is the first day of week
	 * // and 4 January is always in the first week of the year:
	 * const result = startOfWeekYear(new Date(2005, 6, 2), {
	 *   weekStartsOn: 1,
	 *   firstWeekContainsDate: 4
	 * })
	 * //=> Mon Jan 03 2005 00:00:00
	 */
	function startOfWeekYear(dirtyDate, dirtyOptions) {
	  (0, _index4.default)(1, arguments);
	  var options = dirtyOptions || {};
	  var locale = options.locale;
	  var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
	  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : (0, _index3.default)(localeFirstWeekContainsDate);
	  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : (0, _index3.default)(options.firstWeekContainsDate);
	  var year = (0, _index.default)(dirtyDate, dirtyOptions);
	  var firstWeek = new Date(0);
	  firstWeek.setFullYear(year, 0, firstWeekContainsDate);
	  firstWeek.setHours(0, 0, 0, 0);
	  var date = (0, _index2.default)(firstWeek, dirtyOptions);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 289 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfYear;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name startOfYear
	 * @category Year Helpers
	 * @summary Return the start of a year for the given date.
	 *
	 * @description
	 * Return the start of a year for the given date.
	 * The result will be in the local timezone.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the start of a year
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The start of a year for 2 September 2014 11:55:00:
	 * const result = startOfYear(new Date(2014, 8, 2, 11, 55, 00))
	 * //=> Wed Jan 01 2014 00:00:00
	 */
	function startOfYear(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var cleanDate = (0, _index.default)(dirtyDate);
	  var date = new Date(0);
	  date.setFullYear(cleanDate.getFullYear(), 0, 1);
	  date.setHours(0, 0, 0, 0);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 290 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _inDOM = _interopRequireDefault(__webpack_require__(84));
	
	var off = function off() {};
	
	if (_inDOM.default) {
	  off = function () {
	    if (document.addEventListener) return function (node, eventName, handler, capture) {
	      return node.removeEventListener(eventName, handler, capture || false);
	    };else if (document.attachEvent) return function (node, eventName, handler) {
	      return node.detachEvent('on' + eventName, handler);
	    };
	  }();
	}
	
	var _default = off;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 291 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _inDOM = _interopRequireDefault(__webpack_require__(84));
	
	var on = function on() {};
	
	if (_inDOM.default) {
	  on = function () {
	    if (document.addEventListener) return function (node, eventName, handler, capture) {
	      return node.addEventListener(eventName, handler, capture || false);
	    };else if (document.attachEvent) return function (node, eventName, handler) {
	      return node.attachEvent('on' + eventName, function (e) {
	        e = e || window.event;
	        e.target = e.target || e.srcElement;
	        e.currentTarget = node;
	        handler.call(node, e);
	      });
	    };
	  }();
	}
	
	var _default = on;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 292 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports.default = exports.animationEnd = exports.animationDelay = exports.animationTiming = exports.animationDuration = exports.animationName = exports.transitionEnd = exports.transitionDuration = exports.transitionDelay = exports.transitionTiming = exports.transitionProperty = exports.transform = void 0;
	
	var _inDOM = _interopRequireDefault(__webpack_require__(84));
	
	var transform = 'transform';
	exports.transform = transform;
	var prefix, transitionEnd, animationEnd;
	exports.animationEnd = animationEnd;
	exports.transitionEnd = transitionEnd;
	var transitionProperty, transitionDuration, transitionTiming, transitionDelay;
	exports.transitionDelay = transitionDelay;
	exports.transitionTiming = transitionTiming;
	exports.transitionDuration = transitionDuration;
	exports.transitionProperty = transitionProperty;
	var animationName, animationDuration, animationTiming, animationDelay;
	exports.animationDelay = animationDelay;
	exports.animationTiming = animationTiming;
	exports.animationDuration = animationDuration;
	exports.animationName = animationName;
	
	if (_inDOM.default) {
	  var _getTransitionPropert = getTransitionProperties();
	
	  prefix = _getTransitionPropert.prefix;
	  exports.transitionEnd = transitionEnd = _getTransitionPropert.transitionEnd;
	  exports.animationEnd = animationEnd = _getTransitionPropert.animationEnd;
	  exports.transform = transform = prefix + "-" + transform;
	  exports.transitionProperty = transitionProperty = prefix + "-transition-property";
	  exports.transitionDuration = transitionDuration = prefix + "-transition-duration";
	  exports.transitionDelay = transitionDelay = prefix + "-transition-delay";
	  exports.transitionTiming = transitionTiming = prefix + "-transition-timing-function";
	  exports.animationName = animationName = prefix + "-animation-name";
	  exports.animationDuration = animationDuration = prefix + "-animation-duration";
	  exports.animationTiming = animationTiming = prefix + "-animation-delay";
	  exports.animationDelay = animationDelay = prefix + "-animation-timing-function";
	}
	
	var _default = {
	  transform: transform,
	  end: transitionEnd,
	  property: transitionProperty,
	  timing: transitionTiming,
	  delay: transitionDelay,
	  duration: transitionDuration
	};
	exports.default = _default;
	
	function getTransitionProperties() {
	  var style = document.createElement('div').style;
	  var vendorMap = {
	    O: function O(e) {
	      return "o" + e.toLowerCase();
	    },
	    Moz: function Moz(e) {
	      return e.toLowerCase();
	    },
	    Webkit: function Webkit(e) {
	      return "webkit" + e;
	    },
	    ms: function ms(e) {
	      return "MS" + e;
	    }
	  };
	  var vendors = Object.keys(vendorMap);
	  var transitionEnd, animationEnd;
	  var prefix = '';
	
	  for (var i = 0; i < vendors.length; i++) {
	    var vendor = vendors[i];
	
	    if (vendor + "TransitionProperty" in style) {
	      prefix = "-" + vendor.toLowerCase();
	      transitionEnd = vendorMap[vendor]('TransitionEnd');
	      animationEnd = vendorMap[vendor]('AnimationEnd');
	      break;
	    }
	  }
	
	  if (!transitionEnd && 'transitionProperty' in style) transitionEnd = 'transitionend';
	  if (!animationEnd && 'animationName' in style) animationEnd = 'animationend';
	  style = null;
	  return {
	    animationEnd: animationEnd,
	    transitionEnd: transitionEnd,
	    prefix: prefix
	  };
	}

/***/ },
/* 293 */
/***/ function(module, exports) {

	module.exports = isPromise;
	module.exports.default = isPromise;
	
	function isPromise(obj) {
	  return !!obj && (typeof obj === 'object' || typeof obj === 'function') && typeof obj.then === 'function';
	}


/***/ },
/* 294 */
/***/ function(module, exports) {

	// Source: http://jsfiddle.net/vWx8V/
	// http://stackoverflow.com/questions/5603195/full-list-of-javascript-keycodes
	
	/**
	 * Conenience method returns corresponding value for given keyName or keyCode.
	 *
	 * @param {Mixed} keyCode {Number} or keyName {String}
	 * @return {Mixed}
	 * @api public
	 */
	
	function keyCode(searchInput) {
	  // Keyboard Events
	  if (searchInput && 'object' === typeof searchInput) {
	    var hasKeyCode = searchInput.which || searchInput.keyCode || searchInput.charCode
	    if (hasKeyCode) searchInput = hasKeyCode
	  }
	
	  // Numbers
	  if ('number' === typeof searchInput) return names[searchInput]
	
	  // Everything else (cast to string)
	  var search = String(searchInput)
	
	  // check codes
	  var foundNamedKey = codes[search.toLowerCase()]
	  if (foundNamedKey) return foundNamedKey
	
	  // check aliases
	  var foundNamedKey = aliases[search.toLowerCase()]
	  if (foundNamedKey) return foundNamedKey
	
	  // weird character?
	  if (search.length === 1) return search.charCodeAt(0)
	
	  return undefined
	}
	
	/**
	 * Compares a keyboard event with a given keyCode or keyName.
	 *
	 * @param {Event} event Keyboard event that should be tested
	 * @param {Mixed} keyCode {Number} or keyName {String}
	 * @return {Boolean}
	 * @api public
	 */
	keyCode.isEventKey = function isEventKey(event, nameOrCode) {
	  if (event && 'object' === typeof event) {
	    var keyCode = event.which || event.keyCode || event.charCode
	    if (keyCode === null || keyCode === undefined) { return false; }
	    if (typeof nameOrCode === 'string') {
	      // check codes
	      var foundNamedKey = codes[nameOrCode.toLowerCase()]
	      if (foundNamedKey) { return foundNamedKey === keyCode; }
	    
	      // check aliases
	      var foundNamedKey = aliases[nameOrCode.toLowerCase()]
	      if (foundNamedKey) { return foundNamedKey === keyCode; }
	    } else if (typeof nameOrCode === 'number') {
	      return nameOrCode === keyCode;
	    }
	    return false;
	  }
	}
	
	exports = module.exports = keyCode;
	
	/**
	 * Get by name
	 *
	 *   exports.code['enter'] // => 13
	 */
	
	var codes = exports.code = exports.codes = {
	  'backspace': 8,
	  'tab': 9,
	  'enter': 13,
	  'shift': 16,
	  'ctrl': 17,
	  'alt': 18,
	  'pause/break': 19,
	  'caps lock': 20,
	  'esc': 27,
	  'space': 32,
	  'page up': 33,
	  'page down': 34,
	  'end': 35,
	  'home': 36,
	  'left': 37,
	  'up': 38,
	  'right': 39,
	  'down': 40,
	  'insert': 45,
	  'delete': 46,
	  'command': 91,
	  'left command': 91,
	  'right command': 93,
	  'numpad *': 106,
	  'numpad +': 107,
	  'numpad -': 109,
	  'numpad .': 110,
	  'numpad /': 111,
	  'num lock': 144,
	  'scroll lock': 145,
	  'my computer': 182,
	  'my calculator': 183,
	  ';': 186,
	  '=': 187,
	  ',': 188,
	  '-': 189,
	  '.': 190,
	  '/': 191,
	  '`': 192,
	  '[': 219,
	  '\\': 220,
	  ']': 221,
	  "'": 222
	}
	
	// Helper aliases
	
	var aliases = exports.aliases = {
	  'windows': 91,
	  '⇧': 16,
	  '⌥': 18,
	  '⌃': 17,
	  '⌘': 91,
	  'ctl': 17,
	  'control': 17,
	  'option': 18,
	  'pause': 19,
	  'break': 19,
	  'caps': 20,
	  'return': 13,
	  'escape': 27,
	  'spc': 32,
	  'spacebar': 32,
	  'pgup': 33,
	  'pgdn': 34,
	  'ins': 45,
	  'del': 46,
	  'cmd': 91
	}
	
	/*!
	 * Programatically add the following
	 */
	
	// lower case chars
	for (i = 97; i < 123; i++) codes[String.fromCharCode(i)] = i - 32
	
	// numbers
	for (var i = 48; i < 58; i++) codes[i - 48] = i
	
	// function keys
	for (i = 1; i < 13; i++) codes['f'+i] = i + 111
	
	// numpad keys
	for (i = 0; i < 10; i++) codes['numpad '+i] = i + 96
	
	/**
	 * Get by code
	 *
	 *   exports.name[13] // => 'Enter'
	 */
	
	var names = exports.names = exports.title = {} // title for backward compat
	
	// Create reverse mapping
	for (i in codes) names[codes[i]] = i
	
	// Add aliases
	for (var alias in aliases) {
	  codes[alias] = aliases[alias]
	}


/***/ },
/* 295 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(110),
	    root = __webpack_require__(77);
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map');
	
	module.exports = Map;


/***/ },
/* 296 */
/***/ function(module, exports, __webpack_require__) {

	var mapCacheClear = __webpack_require__(1717),
	    mapCacheDelete = __webpack_require__(1718),
	    mapCacheGet = __webpack_require__(1719),
	    mapCacheHas = __webpack_require__(1720),
	    mapCacheSet = __webpack_require__(1721);
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	module.exports = MapCache;


/***/ },
/* 297 */
/***/ function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(198),
	    stackClear = __webpack_require__(1734),
	    stackDelete = __webpack_require__(1735),
	    stackGet = __webpack_require__(1736),
	    stackHas = __webpack_require__(1737),
	    stackSet = __webpack_require__(1738);
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  var data = this.__data__ = new ListCache(entries);
	  this.size = data.size;
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	module.exports = Stack;


/***/ },
/* 298 */
/***/ function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  var type = typeof value;
	  length = length == null ? MAX_SAFE_INTEGER : length;
	
	  return !!length &&
	    (type == 'number' ||
	      (type != 'symbol' && reIsUint.test(value))) &&
	        (value > -1 && value % 1 == 0 && value < length);
	}
	
	module.exports = isIndex;


/***/ },
/* 299 */
/***/ function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(72),
	    isSymbol = __webpack_require__(209);
	
	/** Used to match property names within property paths. */
	var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	    reIsPlainProp = /^\w*$/;
	
	/**
	 * Checks if `value` is a property name and not a property path.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	 */
	function isKey(value, object) {
	  if (isArray(value)) {
	    return false;
	  }
	  var type = typeof value;
	  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	      value == null || isSymbol(value)) {
	    return true;
	  }
	  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	    (object != null && value in Object(object));
	}
	
	module.exports = isKey;


/***/ },
/* 300 */
/***/ function(module, exports) {

	/**
	 * This method returns the first argument it receives.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	module.exports = identity;


/***/ },
/* 301 */
/***/ function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	module.exports = isLength;


/***/ },
/* 302 */
/***/ function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(474),
	    baseKeys = __webpack_require__(479),
	    isArrayLike = __webpack_require__(157);
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	module.exports = keys;


/***/ },
/* 303 */
/***/ function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(201),
	    baseForOwn = __webpack_require__(1666),
	    baseIteratee = __webpack_require__(1674);
	
	/**
	 * Creates an object with the same keys as `object` and values generated
	 * by running each own enumerable string keyed property of `object` thru
	 * `iteratee`. The iteratee is invoked with three arguments:
	 * (value, key, object).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Object
	 * @param {Object} object The object to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Object} Returns the new mapped object.
	 * @see _.mapKeys
	 * @example
	 *
	 * var users = {
	 *   'fred':    { 'user': 'fred',    'age': 40 },
	 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	 * };
	 *
	 * _.mapValues(users, function(o) { return o.age; });
	 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.mapValues(users, 'age');
	 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	 */
	function mapValues(object, iteratee) {
	  var result = {};
	  iteratee = baseIteratee(iteratee, 3);
	
	  baseForOwn(object, function(value, key, object) {
	    baseAssignValue(result, key, iteratee(value, key, object));
	  });
	  return result;
	}
	
	module.exports = mapValues;


/***/ },
/* 304 */
/***/ function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ },
/* 305 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends3 = _interopRequireDefault(__webpack_require__(8));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _all = _interopRequireDefault(__webpack_require__(212));
	
	var _Button = _interopRequireDefault(__webpack_require__(158));
	
	var _bootstrapUtils = __webpack_require__(16);
	
	var propTypes = {
	  vertical: _propTypes.default.bool,
	  justified: _propTypes.default.bool,
	
	  /**
	   * Display block buttons; only useful when used with the "vertical" prop.
	   * @type {bool}
	   */
	  block: (0, _all.default)(_propTypes.default.bool, function (_ref) {
	    var block = _ref.block,
	        vertical = _ref.vertical;
	    return block && !vertical ? new Error('`block` requires `vertical` to be set to have any effect') : null;
	  })
	};
	var defaultProps = {
	  block: false,
	  justified: false,
	  vertical: false
	};
	
	var ButtonGroup =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(ButtonGroup, _React$Component);
	
	  function ButtonGroup() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = ButtonGroup.prototype;
	
	  _proto.render = function render() {
	    var _extends2;
	
	    var _this$props = this.props,
	        block = _this$props.block,
	        justified = _this$props.justified,
	        vertical = _this$props.vertical,
	        className = _this$props.className,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["block", "justified", "vertical", "className"]);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends3.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps)] = !vertical, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'vertical')] = vertical, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'justified')] = justified, _extends2[(0, _bootstrapUtils.prefix)(_Button.default.defaultProps, 'block')] = block, _extends2));
	    return _react.default.createElement("div", (0, _extends3.default)({}, elementProps, {
	      className: (0, _classnames.default)(className, classes)
	    }));
	  };
	
	  return ButtonGroup;
	}(_react.default.Component);
	
	ButtonGroup.propTypes = propTypes;
	ButtonGroup.defaultProps = defaultProps;
	
	var _default = (0, _bootstrapUtils.bsClass)('btn-group', ButtonGroup);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 306 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var propTypes = {
	  label: _propTypes.default.string.isRequired,
	  onClick: _propTypes.default.func
	};
	var defaultProps = {
	  label: 'Close'
	};
	
	var CloseButton =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(CloseButton, _React$Component);
	
	  function CloseButton() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = CloseButton.prototype;
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        label = _this$props.label,
	        onClick = _this$props.onClick;
	    return _react.default.createElement("button", {
	      type: "button",
	      className: "close",
	      onClick: onClick
	    }, _react.default.createElement("span", {
	      "aria-hidden": "true"
	    }, "\xD7"), _react.default.createElement("span", {
	      className: "sr-only"
	    }, label));
	  };
	
	  return CloseButton;
	}(_react.default.Component);
	
	CloseButton.propTypes = propTypes;
	CloseButton.defaultProps = defaultProps;
	var _default = CloseButton;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 307 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	var _interopRequireWildcard = __webpack_require__(47);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(8));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _parseInt2 = _interopRequireDefault(__webpack_require__(618));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _style = _interopRequireDefault(__webpack_require__(154));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _Transition = _interopRequireWildcard(__webpack_require__(545));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(521));
	
	var _createChainedFunction = _interopRequireDefault(__webpack_require__(45));
	
	var _collapseStyles;
	
	var MARGINS = {
	  height: ['marginTop', 'marginBottom'],
	  width: ['marginLeft', 'marginRight']
	}; // reading a dimension prop will cause the browser to recalculate,
	// which will let our animations work
	
	function triggerBrowserReflow(node) {
	  node.offsetHeight; // eslint-disable-line no-unused-expressions
	}
	
	function getDimensionValue(dimension, elem) {
	  var value = elem["offset" + (0, _capitalize.default)(dimension)];
	  var margins = MARGINS[dimension];
	  return value + (0, _parseInt2.default)((0, _style.default)(elem, margins[0]), 10) + (0, _parseInt2.default)((0, _style.default)(elem, margins[1]), 10);
	}
	
	var collapseStyles = (_collapseStyles = {}, _collapseStyles[_Transition.EXITED] = 'collapse', _collapseStyles[_Transition.EXITING] = 'collapsing', _collapseStyles[_Transition.ENTERING] = 'collapsing', _collapseStyles[_Transition.ENTERED] = 'collapse in', _collapseStyles);
	var propTypes = {
	  /**
	   * Show the component; triggers the expand or collapse animation
	   */
	  in: _propTypes.default.bool,
	
	  /**
	   * Wait until the first "enter" transition to mount the component (add it to the DOM)
	   */
	  mountOnEnter: _propTypes.default.bool,
	
	  /**
	   * Unmount the component (remove it from the DOM) when it is collapsed
	   */
	  unmountOnExit: _propTypes.default.bool,
	
	  /**
	   * Run the expand animation when the component mounts, if it is initially
	   * shown
	   */
	  appear: _propTypes.default.bool,
	
	  /**
	   * Duration of the collapse animation in milliseconds, to ensure that
	   * finishing callbacks are fired even if the original browser transition end
	   * events are canceled
	   */
	  timeout: _propTypes.default.number,
	
	  /**
	   * Callback fired before the component expands
	   */
	  onEnter: _propTypes.default.func,
	
	  /**
	   * Callback fired after the component starts to expand
	   */
	  onEntering: _propTypes.default.func,
	
	  /**
	   * Callback fired after the component has expanded
	   */
	  onEntered: _propTypes.default.func,
	
	  /**
	   * Callback fired before the component collapses
	   */
	  onExit: _propTypes.default.func,
	
	  /**
	   * Callback fired after the component starts to collapse
	   */
	  onExiting: _propTypes.default.func,
	
	  /**
	   * Callback fired after the component has collapsed
	   */
	  onExited: _propTypes.default.func,
	
	  /**
	   * The dimension used when collapsing, or a function that returns the
	   * dimension
	   *
	   * _Note: Bootstrap only partially supports 'width'!
	   * You will need to supply your own CSS animation for the `.width` CSS class._
	   */
	  dimension: _propTypes.default.oneOfType([_propTypes.default.oneOf(['height', 'width']), _propTypes.default.func]),
	
	  /**
	   * Function that returns the height or width of the animating DOM node
	   *
	   * Allows for providing some custom logic for how much the Collapse component
	   * should animate in its specified dimension. Called with the current
	   * dimension prop value and the DOM node.
	   */
	  getDimensionValue: _propTypes.default.func,
	
	  /**
	   * ARIA role of collapsible element
	   */
	  role: _propTypes.default.string
	};
	var defaultProps = {
	  in: false,
	  timeout: 300,
	  mountOnEnter: false,
	  unmountOnExit: false,
	  appear: false,
	  dimension: 'height',
	  getDimensionValue: getDimensionValue
	};
	
	var Collapse =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(Collapse, _React$Component);
	
	  function Collapse() {
	    var _this;
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
	
	    _this.handleEnter = function (elem) {
	      elem.style[_this.getDimension()] = '0';
	    };
	
	    _this.handleEntering = function (elem) {
	      var dimension = _this.getDimension();
	
	      elem.style[dimension] = _this._getScrollDimensionValue(elem, dimension);
	    };
	
	    _this.handleEntered = function (elem) {
	      elem.style[_this.getDimension()] = null;
	    };
	
	    _this.handleExit = function (elem) {
	      var dimension = _this.getDimension();
	
	      elem.style[dimension] = _this.props.getDimensionValue(dimension, elem) + "px";
	      triggerBrowserReflow(elem);
	    };
	
	    _this.handleExiting = function (elem) {
	      elem.style[_this.getDimension()] = '0';
	    };
	
	    return _this;
	  }
	
	  var _proto = Collapse.prototype;
	
	  _proto.getDimension = function getDimension() {
	    return typeof this.props.dimension === 'function' ? this.props.dimension() : this.props.dimension;
	  }; // for testing
	
	
	  _proto._getScrollDimensionValue = function _getScrollDimensionValue(elem, dimension) {
	    return elem["scroll" + (0, _capitalize.default)(dimension)] + "px";
	  };
	  /* -- Expanding -- */
	
	
	  _proto.render = function render() {
	    var _this2 = this;
	
	    var _this$props = this.props,
	        onEnter = _this$props.onEnter,
	        onEntering = _this$props.onEntering,
	        onEntered = _this$props.onEntered,
	        onExit = _this$props.onExit,
	        onExiting = _this$props.onExiting,
	        className = _this$props.className,
	        children = _this$props.children,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["onEnter", "onEntering", "onEntered", "onExit", "onExiting", "className", "children"]);
	    delete props.dimension;
	    delete props.getDimensionValue;
	    var handleEnter = (0, _createChainedFunction.default)(this.handleEnter, onEnter);
	    var handleEntering = (0, _createChainedFunction.default)(this.handleEntering, onEntering);
	    var handleEntered = (0, _createChainedFunction.default)(this.handleEntered, onEntered);
	    var handleExit = (0, _createChainedFunction.default)(this.handleExit, onExit);
	    var handleExiting = (0, _createChainedFunction.default)(this.handleExiting, onExiting);
	    return _react.default.createElement(_Transition.default, (0, _extends2.default)({}, props, {
	      "aria-expanded": props.role ? props.in : null,
	      onEnter: handleEnter,
	      onEntering: handleEntering,
	      onEntered: handleEntered,
	      onExit: handleExit,
	      onExiting: handleExiting
	    }), function (state, innerProps) {
	      return _react.default.cloneElement(children, (0, _extends2.default)({}, innerProps, {
	        className: (0, _classnames.default)(className, children.props.className, collapseStyles[state], _this2.getDimension() === 'width' && 'width')
	      }));
	    });
	  };
	
	  return Collapse;
	}(_react.default.Component);
	
	Collapse.propTypes = propTypes;
	Collapse.defaultProps = defaultProps;
	var _default = Collapse;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 308 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends3 = _interopRequireDefault(__webpack_require__(8));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _bootstrapUtils = __webpack_require__(16);
	
	var propTypes = {
	  /**
	   * An icon name without "glyphicon-" prefix. See e.g. http://getbootstrap.com/components/#glyphicons
	   */
	  glyph: _propTypes.default.string.isRequired
	};
	
	var Glyphicon =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(Glyphicon, _React$Component);
	
	  function Glyphicon() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = Glyphicon.prototype;
	
	  _proto.render = function render() {
	    var _extends2;
	
	    var _this$props = this.props,
	        glyph = _this$props.glyph,
	        className = _this$props.className,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["glyph", "className"]);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends3.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps, glyph)] = true, _extends2));
	    return _react.default.createElement("span", (0, _extends3.default)({}, elementProps, {
	      className: (0, _classnames.default)(className, classes)
	    }));
	  };
	
	  return Glyphicon;
	}(_react.default.Component);
	
	Glyphicon.propTypes = propTypes;
	
	var _default = (0, _bootstrapUtils.bsClass)('glyphicon', Glyphicon);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 309 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _uncontrollable = __webpack_require__(119);
	
	var TAB = 'tab';
	var PANE = 'pane';
	
	var idPropType = _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]);
	
	var propTypes = {
	  /**
	   * HTML id attribute, required if no `generateChildId` prop
	   * is specified.
	   */
	  id: function id(props) {
	    var error = null;
	
	    if (!props.generateChildId) {
	      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      error = idPropType.apply(void 0, [props].concat(args));
	
	      if (!error && !props.id) {
	        error = new Error('In order to properly initialize Tabs in a way that is accessible ' + 'to assistive technologies (such as screen readers) an `id` or a ' + '`generateChildId` prop to TabContainer is required');
	      }
	    }
	
	    return error;
	  },
	
	  /**
	   * A function that takes an `eventKey` and `type` and returns a unique id for
	   * child tab `<NavItem>`s and `<TabPane>`s. The function _must_ be a pure
	   * function, meaning it should always return the _same_ id for the same set
	   * of inputs. The default value requires that an `id` to be set for the
	   * `<TabContainer>`.
	   *
	   * The `type` argument will either be `"tab"` or `"pane"`.
	   *
	   * @defaultValue (eventKey, type) => `${this.props.id}-${type}-${key}`
	   */
	  generateChildId: _propTypes.default.func,
	
	  /**
	   * A callback fired when a tab is selected.
	   *
	   * @controllable activeKey
	   */
	  onSelect: _propTypes.default.func,
	
	  /**
	   * The `eventKey` of the currently active tab.
	   *
	   * @controllable onSelect
	   */
	  activeKey: _propTypes.default.any
	};
	var childContextTypes = {
	  $bs_tabContainer: _propTypes.default.shape({
	    activeKey: _propTypes.default.any,
	    onSelect: _propTypes.default.func.isRequired,
	    getTabId: _propTypes.default.func.isRequired,
	    getPaneId: _propTypes.default.func.isRequired
	  })
	};
	
	var TabContainer =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(TabContainer, _React$Component);
	
	  function TabContainer() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = TabContainer.prototype;
	
	  _proto.getChildContext = function getChildContext() {
	    var _this$props = this.props,
	        activeKey = _this$props.activeKey,
	        onSelect = _this$props.onSelect,
	        generateChildId = _this$props.generateChildId,
	        id = _this$props.id;
	
	    var getId = generateChildId || function (key, type) {
	      return id ? id + "-" + type + "-" + key : null;
	    };
	
	    return {
	      $bs_tabContainer: {
	        activeKey: activeKey,
	        onSelect: onSelect,
	        getTabId: function getTabId(key) {
	          return getId(key, TAB);
	        },
	        getPaneId: function getPaneId(key) {
	          return getId(key, PANE);
	        }
	      }
	    };
	  };
	
	  _proto.render = function render() {
	    var _this$props2 = this.props,
	        children = _this$props2.children,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props2, ["children"]);
	    delete props.generateChildId;
	    delete props.onSelect;
	    delete props.activeKey;
	    return _react.default.cloneElement(_react.default.Children.only(children), props);
	  };
	
	  return TabContainer;
	}(_react.default.Component);
	
	TabContainer.propTypes = propTypes;
	TabContainer.childContextTypes = childContextTypes;
	
	var _default = (0, _uncontrollable.uncontrollable)(TabContainer, {
	  activeKey: 'onSelect'
	});
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 310 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(8));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(57));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _elementType = _interopRequireDefault(__webpack_require__(32));
	
	var _bootstrapUtils = __webpack_require__(16);
	
	var propTypes = {
	  componentClass: _elementType.default,
	
	  /**
	   * Sets a default animation strategy for all children `<TabPane>`s. Use
	   * `false` to disable, `true` to enable the default `<Fade>` animation or
	   * a react-transition-group v2 `<Transition/>` component.
	   */
	  animation: _propTypes.default.oneOfType([_propTypes.default.bool, _elementType.default]),
	
	  /**
	   * Wait until the first "enter" transition to mount tabs (add them to the DOM)
	   */
	  mountOnEnter: _propTypes.default.bool,
	
	  /**
	   * Unmount tabs (remove it from the DOM) when they are no longer visible
	   */
	  unmountOnExit: _propTypes.default.bool
	};
	var defaultProps = {
	  componentClass: 'div',
	  animation: true,
	  mountOnEnter: false,
	  unmountOnExit: false
	};
	var contextTypes = {
	  $bs_tabContainer: _propTypes.default.shape({
	    activeKey: _propTypes.default.any
	  })
	};
	var childContextTypes = {
	  $bs_tabContent: _propTypes.default.shape({
	    bsClass: _propTypes.default.string,
	    animation: _propTypes.default.oneOfType([_propTypes.default.bool, _elementType.default]),
	    activeKey: _propTypes.default.any,
	    mountOnEnter: _propTypes.default.bool,
	    unmountOnExit: _propTypes.default.bool,
	    onPaneEnter: _propTypes.default.func.isRequired,
	    onPaneExited: _propTypes.default.func.isRequired,
	    exiting: _propTypes.default.bool.isRequired
	  })
	};
	
	var TabContent =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(TabContent, _React$Component);
	
	  function TabContent(props, context) {
	    var _this;
	
	    _this = _React$Component.call(this, props, context) || this;
	    _this.handlePaneEnter = _this.handlePaneEnter.bind((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
	    _this.handlePaneExited = _this.handlePaneExited.bind((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this))); // Active entries in state will be `null` unless `animation` is set. Need
	    // to track active child in case keys swap and the active child changes
	    // but the active key does not.
	
	    _this.state = {
	      activeKey: null,
	      activeChild: null
	    };
	    return _this;
	  }
	
	  var _proto = TabContent.prototype;
	
	  _proto.getChildContext = function getChildContext() {
	    var _this$props = this.props,
	        bsClass = _this$props.bsClass,
	        animation = _this$props.animation,
	        mountOnEnter = _this$props.mountOnEnter,
	        unmountOnExit = _this$props.unmountOnExit;
	    var stateActiveKey = this.state.activeKey;
	    var containerActiveKey = this.getContainerActiveKey();
	    var activeKey = stateActiveKey != null ? stateActiveKey : containerActiveKey;
	    var exiting = stateActiveKey != null && stateActiveKey !== containerActiveKey;
	    return {
	      $bs_tabContent: {
	        bsClass: bsClass,
	        animation: animation,
	        activeKey: activeKey,
	        mountOnEnter: mountOnEnter,
	        unmountOnExit: unmountOnExit,
	        onPaneEnter: this.handlePaneEnter,
	        onPaneExited: this.handlePaneExited,
	        exiting: exiting
	      }
	    };
	  };
	
	  _proto.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps(nextProps) {
	    // eslint-disable-line
	    if (!nextProps.animation && this.state.activeChild) {
	      this.setState({
	        activeKey: null,
	        activeChild: null
	      });
	    }
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    this.isUnmounted = true;
	  };
	
	  _proto.getContainerActiveKey = function getContainerActiveKey() {
	    var tabContainer = this.context.$bs_tabContainer;
	    return tabContainer && tabContainer.activeKey;
	  };
	
	  _proto.handlePaneEnter = function handlePaneEnter(child, childKey) {
	    if (!this.props.animation) {
	      return false;
	    } // It's possible that this child should be transitioning out.
	
	
	    if (childKey !== this.getContainerActiveKey()) {
	      return false;
	    }
	
	    this.setState({
	      activeKey: childKey,
	      activeChild: child
	    });
	    return true;
	  };
	
	  _proto.handlePaneExited = function handlePaneExited(child) {
	    // This might happen as everything is unmounting.
	    if (this.isUnmounted) {
	      return;
	    }
	
	    this.setState(function (_ref) {
	      var activeChild = _ref.activeChild;
	
	      if (activeChild !== child) {
	        return null;
	      }
	
	      return {
	        activeKey: null,
	        activeChild: null
	      };
	    });
	  };
	
	  _proto.render = function render() {
	    var _this$props2 = this.props,
	        Component = _this$props2.componentClass,
	        className = _this$props2.className,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props2, ["componentClass", "className"]);
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['animation', 'mountOnEnter', 'unmountOnExit']),
	        bsProps = _splitBsPropsAndOmit[0],
	        elementProps = _splitBsPropsAndOmit[1];
	
	    return _react.default.createElement(Component, (0, _extends2.default)({}, elementProps, {
	      className: (0, _classnames.default)(className, (0, _bootstrapUtils.prefix)(bsProps, 'content'))
	    }));
	  };
	
	  return TabContent;
	}(_react.default.Component);
	
	TabContent.propTypes = propTypes;
	TabContent.defaultProps = defaultProps;
	TabContent.contextTypes = contextTypes;
	TabContent.childContextTypes = childContextTypes;
	
	var _default = (0, _bootstrapUtils.bsClass)('tab', TabContent);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 311 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Collapsible = function (_Component) {
	  _inherits(Collapsible, _Component);
	
	  function Collapsible(props) {
	    _classCallCheck(this, Collapsible);
	
	    var _this = _possibleConstructorReturn(this, (Collapsible.__proto__ || Object.getPrototypeOf(Collapsible)).call(this, props));
	
	    _this.timeout = undefined;
	
	    // Bind class methods
	    _this.handleTriggerClick = _this.handleTriggerClick.bind(_this);
	    _this.handleTransitionEnd = _this.handleTransitionEnd.bind(_this);
	    _this.continueOpenCollapsible = _this.continueOpenCollapsible.bind(_this);
	    _this.setInnerRef = _this.setInnerRef.bind(_this);
	
	    // Defaults the dropdown to be closed
	    if (props.open) {
	      _this.state = {
	        isClosed: false,
	        shouldSwitchAutoOnNextCycle: false,
	        height: 'auto',
	        transition: 'none',
	        hasBeenOpened: true,
	        overflow: props.overflowWhenOpen,
	        inTransition: false
	      };
	    } else {
	      _this.state = {
	        isClosed: true,
	        shouldSwitchAutoOnNextCycle: false,
	        height: 0,
	        transition: 'height ' + props.transitionTime + 'ms ' + props.easing,
	        hasBeenOpened: false,
	        overflow: 'hidden',
	        inTransition: false
	      };
	    }
	    return _this;
	  }
	
	  _createClass(Collapsible, [{
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      var _this2 = this;
	
	      if (this.state.shouldOpenOnNextCycle) {
	        this.continueOpenCollapsible();
	      }
	
	      if (prevState.height === 'auto' && this.state.shouldSwitchAutoOnNextCycle === true) {
	        window.clearTimeout(this.timeout);
	        this.timeout = window.setTimeout(function () {
	          // Set small timeout to ensure a true re-render
	          _this2.setState({
	            height: 0,
	            overflow: 'hidden',
	            isClosed: true,
	            shouldSwitchAutoOnNextCycle: false
	          });
	        }, 50);
	      }
	
	      // If there has been a change in the open prop (controlled by accordion)
	      if (prevProps.open !== this.props.open) {
	        if (this.props.open === true) {
	          this.openCollapsible();
	          this.props.onOpening();
	        } else {
	          this.closeCollapsible();
	          this.props.onClosing();
	        }
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.clearTimeout(this.timeout);
	    }
	  }, {
	    key: 'closeCollapsible',
	    value: function closeCollapsible() {
	      this.setState({
	        shouldSwitchAutoOnNextCycle: true,
	        height: this.innerRef.scrollHeight,
	        transition: 'height ' + (this.props.transitionCloseTime ? this.props.transitionCloseTime : this.props.transitionTime) + 'ms ' + this.props.easing,
	        inTransition: true
	      });
	    }
	  }, {
	    key: 'openCollapsible',
	    value: function openCollapsible() {
	      this.setState({
	        inTransition: true,
	        shouldOpenOnNextCycle: true
	      });
	    }
	  }, {
	    key: 'continueOpenCollapsible',
	    value: function continueOpenCollapsible() {
	      this.setState({
	        height: this.innerRef.scrollHeight,
	        transition: 'height ' + this.props.transitionTime + 'ms ' + this.props.easing,
	        isClosed: false,
	        hasBeenOpened: true,
	        inTransition: true,
	        shouldOpenOnNextCycle: false
	      });
	    }
	  }, {
	    key: 'handleTriggerClick',
	    value: function handleTriggerClick(event) {
	      if (this.props.triggerDisabled || this.state.inTransition) {
	        return;
	      }
	
	      event.preventDefault();
	
	      if (this.props.handleTriggerClick) {
	        this.props.handleTriggerClick(this.props.accordionPosition);
	      } else {
	        if (this.state.isClosed === true) {
	          this.openCollapsible();
	          this.props.onOpening();
	          this.props.onTriggerOpening();
	        } else {
	          this.closeCollapsible();
	          this.props.onClosing();
	          this.props.onTriggerClosing();
	        }
	      }
	    }
	  }, {
	    key: 'renderNonClickableTriggerElement',
	    value: function renderNonClickableTriggerElement() {
	      if (this.props.triggerSibling && typeof this.props.triggerSibling === 'string') {
	        return _react2.default.createElement(
	          'span',
	          { className: this.props.classParentString + '__trigger-sibling' },
	          this.props.triggerSibling
	        );
	      } else if (this.props.triggerSibling && typeof this.props.triggerSibling === 'function') {
	        return this.props.triggerSibling();
	      } else if (this.props.triggerSibling) {
	        return _react2.default.createElement(this.props.triggerSibling, null);
	      }
	
	      return null;
	    }
	  }, {
	    key: 'handleTransitionEnd',
	    value: function handleTransitionEnd(e) {
	      // only handle transitions that origin from the container of this component
	      if (e.target !== this.innerRef) {
	        return;
	      }
	      // Switch to height auto to make the container responsive
	      if (!this.state.isClosed) {
	        this.setState({ height: 'auto', overflow: this.props.overflowWhenOpen, inTransition: false });
	        this.props.onOpen();
	      } else {
	        this.setState({ inTransition: false });
	        this.props.onClose();
	      }
	    }
	  }, {
	    key: 'setInnerRef',
	    value: function setInnerRef(ref) {
	      this.innerRef = ref;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var dropdownStyle = {
	        height: this.state.height,
	        WebkitTransition: this.state.transition,
	        msTransition: this.state.transition,
	        transition: this.state.transition,
	        overflow: this.state.overflow
	      };
	
	      var openClass = this.state.isClosed ? 'is-closed' : 'is-open';
	      var disabledClass = this.props.triggerDisabled ? 'is-disabled' : '';
	
	      //If user wants different text when tray is open
	      var trigger = this.state.isClosed === false && this.props.triggerWhenOpen !== undefined ? this.props.triggerWhenOpen : this.props.trigger;
	
	      var ContentContainerElement = this.props.contentContainerTagName;
	
	      // If user wants a trigger wrapping element different than 'span'
	      var TriggerElement = this.props.triggerTagName;
	
	      // Don't render children until the first opening of the Collapsible if lazy rendering is enabled
	      var children = this.props.lazyRender && !this.state.hasBeenOpened && this.state.isClosed && !this.state.inTransition ? null : this.props.children;
	
	      // Construct CSS classes strings
	      var triggerClassString = this.props.classParentString + '__trigger ' + openClass + ' ' + disabledClass + ' ' + (this.state.isClosed ? this.props.triggerClassName : this.props.triggerOpenedClassName);
	      var parentClassString = this.props.classParentString + ' ' + (this.state.isClosed ? this.props.className : this.props.openedClassName);
	      var outerClassString = this.props.classParentString + '__contentOuter ' + this.props.contentOuterClassName;
	      var innerClassString = this.props.classParentString + '__contentInner ' + this.props.contentInnerClassName;
	
	      return _react2.default.createElement(
	        ContentContainerElement,
	        _extends({ className: parentClassString.trim() }, this.props.containerElementProps),
	        _react2.default.createElement(
	          TriggerElement,
	          _extends({
	            className: triggerClassString.trim(),
	            onClick: this.handleTriggerClick,
	            style: this.props.triggerStyle && this.props.triggerStyle,
	            onKeyPress: function onKeyPress(event) {
	              var key = event.key;
	
	              if (key === ' ' && _this3.props.triggerTagName.toLowerCase() !== 'button' || key === 'Enter') {
	                _this3.handleTriggerClick(event);
	              }
	            },
	            tabIndex: this.props.tabIndex && this.props.tabIndex
	          }, this.props.triggerElementProps),
	          trigger
	        ),
	        this.renderNonClickableTriggerElement(),
	        _react2.default.createElement(
	          'div',
	          {
	            className: outerClassString.trim(),
	            style: dropdownStyle,
	            onTransitionEnd: this.handleTransitionEnd,
	            ref: this.setInnerRef,
	            hidden: this.props.contentHiddenWhenClosed && this.state.isClosed && !this.state.inTransition
	          },
	          _react2.default.createElement(
	            'div',
	            {
	              className: innerClassString.trim()
	            },
	            children
	          )
	        )
	      );
	    }
	  }]);
	
	  return Collapsible;
	}(_react.Component);
	
	Collapsible.propTypes = {
	  transitionTime: _propTypes2.default.number,
	  transitionCloseTime: _propTypes2.default.number,
	  triggerTagName: _propTypes2.default.string,
	  easing: _propTypes2.default.string,
	  open: _propTypes2.default.bool,
	  containerElementProps: _propTypes2.default.object,
	  triggerElementProps: _propTypes2.default.object,
	  classParentString: _propTypes2.default.string,
	  openedClassName: _propTypes2.default.string,
	  triggerStyle: _propTypes2.default.object,
	  triggerClassName: _propTypes2.default.string,
	  triggerOpenedClassName: _propTypes2.default.string,
	  contentOuterClassName: _propTypes2.default.string,
	  contentInnerClassName: _propTypes2.default.string,
	  accordionPosition: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  handleTriggerClick: _propTypes2.default.func,
	  onOpen: _propTypes2.default.func,
	  onClose: _propTypes2.default.func,
	  onOpening: _propTypes2.default.func,
	  onClosing: _propTypes2.default.func,
	  onTriggerOpening: _propTypes2.default.func,
	  onTriggerClosing: _propTypes2.default.func,
	  trigger: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
	  triggerWhenOpen: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
	  triggerDisabled: _propTypes2.default.bool,
	  lazyRender: _propTypes2.default.bool,
	  overflowWhenOpen: _propTypes2.default.oneOf(['hidden', 'visible', 'auto', 'scroll', 'inherit', 'initial', 'unset']),
	  contentHiddenWhenClosed: _propTypes2.default.bool,
	  triggerSibling: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func]),
	  tabIndex: _propTypes2.default.number,
	  contentContainerTagName: _propTypes2.default.string
	};
	
	Collapsible.defaultProps = {
	  transitionTime: 400,
	  transitionCloseTime: null,
	  triggerTagName: 'span',
	  easing: 'linear',
	  open: false,
	  classParentString: 'Collapsible',
	  triggerDisabled: false,
	  lazyRender: false,
	  overflowWhenOpen: 'hidden',
	  contentHiddenWhenClosed: false,
	  openedClassName: '',
	  triggerStyle: null,
	  triggerClassName: '',
	  triggerOpenedClassName: '',
	  contentOuterClassName: '',
	  contentInnerClassName: '',
	  className: '',
	  triggerSibling: null,
	  onOpen: function onOpen() {},
	  onClose: function onClose() {},
	  onOpening: function onOpening() {},
	  onClosing: function onClosing() {},
	  onTriggerOpening: function onTriggerOpening() {},
	  onTriggerClosing: function onTriggerClosing() {},
	  tabIndex: null,
	  contentContainerTagName: 'div'
	};
	
	exports.default = Collapsible;
	


/***/ },
/* 312 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createChainableTypeChecker = __webpack_require__(1865);
	
	var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function elementType(props, propName, componentName, location, propFullName) {
	  var propValue = props[propName];
	  var propType = typeof propValue === 'undefined' ? 'undefined' : _typeof(propValue);
	
	  if (_react2.default.isValidElement(propValue)) {
	    return new Error('Invalid ' + location + ' `' + propFullName + '` of type ReactElement ' + ('supplied to `' + componentName + '`, expected an element type (a string ') + 'or a ReactClass).');
	  }
	
	  if (propType !== 'function' && propType !== 'string') {
	    return new Error('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected an element type (a string ') + 'or a ReactClass).');
	  }
	
	  return null;
	}
	
	exports.default = (0, _createChainableTypeChecker2.default)(elementType);

/***/ },
/* 313 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	var toastr = {
	  maxAnimationDelay: 6000,
	  newestOnTop: true,
	  position: 'top-right',
	  preventDuplicates: true
	};
	var _default = toastr;
	exports["default"] = _default;

/***/ },
/* 314 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TRANSITIONS = exports.REMOVE_BY_TYPE = exports.HIDE_CONFIRM = exports.SHOW_CONFIRM = exports.CLEAN_TOASTR = exports.REMOVE_TOASTR = exports.ADD_TOASTR = void 0;
	var ADD_TOASTR = '@ReduxToastr/toastr/ADD';
	exports.ADD_TOASTR = ADD_TOASTR;
	var REMOVE_TOASTR = '@ReduxToastr/toastr/REMOVE';
	exports.REMOVE_TOASTR = REMOVE_TOASTR;
	var CLEAN_TOASTR = '@ReduxToastr/toastr/CLEAN';
	exports.CLEAN_TOASTR = CLEAN_TOASTR;
	var SHOW_CONFIRM = '@ReduxToastr/confirm/SHOW';
	exports.SHOW_CONFIRM = SHOW_CONFIRM;
	var HIDE_CONFIRM = '@ReduxToastr/confirm/HIDE';
	exports.HIDE_CONFIRM = HIDE_CONFIRM;
	var REMOVE_BY_TYPE = '@ReduxToastr/toastr/REMOVE_BY_TYPE'; // before add a new transition - check its presence in src/styles/animations.scss
	
	exports.REMOVE_BY_TYPE = REMOVE_BY_TYPE;
	var TRANSITIONS = {
	  "in": ['bounceIn', 'bounceInDown', 'fadeIn'],
	  out: ['bounceOut', 'bounceOutUp', 'fadeOut']
	};
	exports.TRANSITIONS = TRANSITIONS;

/***/ },
/* 315 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = warning;
	
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	
	
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	
	}

/***/ },
/* 316 */
[2195, 134],
/* 317 */
[2200, 537],
/* 318 */
[2190, 1913],
/* 319 */
[2195, 135],
/* 320 */
[2200, 541],
/* 321 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = exports.UPDATE_SYNC_WARNINGS = exports.UPDATE_SYNC_ERRORS = exports.UNTOUCH = exports.UNREGISTER_FIELD = exports.TOUCH = exports.SUBMIT = exports.STOP_SUBMIT = exports.STOP_ASYNC_VALIDATION = exports.START_SUBMIT = exports.START_ASYNC_VALIDATION = exports.SET_SUBMIT_SUCCEEDED = exports.SET_SUBMIT_FAILED = exports.RESET_SECTION = exports.RESET = exports.REGISTER_FIELD = exports.INITIALIZE = exports.FOCUS = exports.DESTROY = exports.CLEAR_ASYNC_ERROR = exports.CLEAR_SUBMIT_ERRORS = exports.CLEAR_SUBMIT = exports.CLEAR_FIELDS = exports.CHANGE = exports.BLUR = exports.AUTOFILL = exports.ARRAY_SWAP = exports.ARRAY_UNSHIFT = exports.ARRAY_SPLICE = exports.ARRAY_SHIFT = exports.ARRAY_REMOVE_ALL = exports.ARRAY_REMOVE = exports.ARRAY_PUSH = exports.ARRAY_POP = exports.ARRAY_MOVE = exports.ARRAY_INSERT = exports.prefix = void 0;
	var prefix = '@@redux-form/';
	exports.prefix = prefix;
	var ARRAY_INSERT = prefix + "ARRAY_INSERT";
	exports.ARRAY_INSERT = ARRAY_INSERT;
	var ARRAY_MOVE = prefix + "ARRAY_MOVE";
	exports.ARRAY_MOVE = ARRAY_MOVE;
	var ARRAY_POP = prefix + "ARRAY_POP";
	exports.ARRAY_POP = ARRAY_POP;
	var ARRAY_PUSH = prefix + "ARRAY_PUSH";
	exports.ARRAY_PUSH = ARRAY_PUSH;
	var ARRAY_REMOVE = prefix + "ARRAY_REMOVE";
	exports.ARRAY_REMOVE = ARRAY_REMOVE;
	var ARRAY_REMOVE_ALL = prefix + "ARRAY_REMOVE_ALL";
	exports.ARRAY_REMOVE_ALL = ARRAY_REMOVE_ALL;
	var ARRAY_SHIFT = prefix + "ARRAY_SHIFT";
	exports.ARRAY_SHIFT = ARRAY_SHIFT;
	var ARRAY_SPLICE = prefix + "ARRAY_SPLICE";
	exports.ARRAY_SPLICE = ARRAY_SPLICE;
	var ARRAY_UNSHIFT = prefix + "ARRAY_UNSHIFT";
	exports.ARRAY_UNSHIFT = ARRAY_UNSHIFT;
	var ARRAY_SWAP = prefix + "ARRAY_SWAP";
	exports.ARRAY_SWAP = ARRAY_SWAP;
	var AUTOFILL = prefix + "AUTOFILL";
	exports.AUTOFILL = AUTOFILL;
	var BLUR = prefix + "BLUR";
	exports.BLUR = BLUR;
	var CHANGE = prefix + "CHANGE";
	exports.CHANGE = CHANGE;
	var CLEAR_FIELDS = prefix + "CLEAR_FIELDS";
	exports.CLEAR_FIELDS = CLEAR_FIELDS;
	var CLEAR_SUBMIT = prefix + "CLEAR_SUBMIT";
	exports.CLEAR_SUBMIT = CLEAR_SUBMIT;
	var CLEAR_SUBMIT_ERRORS = prefix + "CLEAR_SUBMIT_ERRORS";
	exports.CLEAR_SUBMIT_ERRORS = CLEAR_SUBMIT_ERRORS;
	var CLEAR_ASYNC_ERROR = prefix + "CLEAR_ASYNC_ERROR";
	exports.CLEAR_ASYNC_ERROR = CLEAR_ASYNC_ERROR;
	var DESTROY = prefix + "DESTROY";
	exports.DESTROY = DESTROY;
	var FOCUS = prefix + "FOCUS";
	exports.FOCUS = FOCUS;
	var INITIALIZE = prefix + "INITIALIZE";
	exports.INITIALIZE = INITIALIZE;
	var REGISTER_FIELD = prefix + "REGISTER_FIELD";
	exports.REGISTER_FIELD = REGISTER_FIELD;
	var RESET = prefix + "RESET";
	exports.RESET = RESET;
	var RESET_SECTION = prefix + "RESET_SECTION";
	exports.RESET_SECTION = RESET_SECTION;
	var SET_SUBMIT_FAILED = prefix + "SET_SUBMIT_FAILED";
	exports.SET_SUBMIT_FAILED = SET_SUBMIT_FAILED;
	var SET_SUBMIT_SUCCEEDED = prefix + "SET_SUBMIT_SUCCEEDED";
	exports.SET_SUBMIT_SUCCEEDED = SET_SUBMIT_SUCCEEDED;
	var START_ASYNC_VALIDATION = prefix + "START_ASYNC_VALIDATION";
	exports.START_ASYNC_VALIDATION = START_ASYNC_VALIDATION;
	var START_SUBMIT = prefix + "START_SUBMIT";
	exports.START_SUBMIT = START_SUBMIT;
	var STOP_ASYNC_VALIDATION = prefix + "STOP_ASYNC_VALIDATION";
	exports.STOP_ASYNC_VALIDATION = STOP_ASYNC_VALIDATION;
	var STOP_SUBMIT = prefix + "STOP_SUBMIT";
	exports.STOP_SUBMIT = STOP_SUBMIT;
	var SUBMIT = prefix + "SUBMIT";
	exports.SUBMIT = SUBMIT;
	var TOUCH = prefix + "TOUCH";
	exports.TOUCH = TOUCH;
	var UNREGISTER_FIELD = prefix + "UNREGISTER_FIELD";
	exports.UNREGISTER_FIELD = UNREGISTER_FIELD;
	var UNTOUCH = prefix + "UNTOUCH";
	exports.UNTOUCH = UNTOUCH;
	var UPDATE_SYNC_ERRORS = prefix + "UPDATE_SYNC_ERRORS";
	exports.UPDATE_SYNC_ERRORS = UPDATE_SYNC_ERRORS;
	var UPDATE_SYNC_WARNINGS = prefix + "UPDATE_SYNC_WARNINGS";
	exports.UPDATE_SYNC_WARNINGS = UPDATE_SYNC_WARNINGS;
	var _default = {
	  ARRAY_INSERT: ARRAY_INSERT,
	  ARRAY_MOVE: ARRAY_MOVE,
	  ARRAY_POP: ARRAY_POP,
	  ARRAY_PUSH: ARRAY_PUSH,
	  ARRAY_REMOVE: ARRAY_REMOVE,
	  ARRAY_REMOVE_ALL: ARRAY_REMOVE_ALL,
	  ARRAY_SHIFT: ARRAY_SHIFT,
	  ARRAY_SPLICE: ARRAY_SPLICE,
	  ARRAY_UNSHIFT: ARRAY_UNSHIFT,
	  ARRAY_SWAP: ARRAY_SWAP,
	  AUTOFILL: AUTOFILL,
	  BLUR: BLUR,
	  CHANGE: CHANGE,
	  CLEAR_FIELDS: CLEAR_FIELDS,
	  CLEAR_SUBMIT: CLEAR_SUBMIT,
	  CLEAR_SUBMIT_ERRORS: CLEAR_SUBMIT_ERRORS,
	  CLEAR_ASYNC_ERROR: CLEAR_ASYNC_ERROR,
	  DESTROY: DESTROY,
	  FOCUS: FOCUS,
	  INITIALIZE: INITIALIZE,
	  REGISTER_FIELD: REGISTER_FIELD,
	  RESET: RESET,
	  RESET_SECTION: RESET_SECTION,
	  SET_SUBMIT_FAILED: SET_SUBMIT_FAILED,
	  SET_SUBMIT_SUCCEEDED: SET_SUBMIT_SUCCEEDED,
	  START_ASYNC_VALIDATION: START_ASYNC_VALIDATION,
	  START_SUBMIT: START_SUBMIT,
	  STOP_ASYNC_VALIDATION: STOP_ASYNC_VALIDATION,
	  STOP_SUBMIT: STOP_SUBMIT,
	  SUBMIT: SUBMIT,
	  TOUCH: TOUCH,
	  UNREGISTER_FIELD: UNREGISTER_FIELD,
	  UNTOUCH: UNTOUCH,
	  UPDATE_SYNC_ERRORS: UPDATE_SYNC_ERRORS,
	  UPDATE_SYNC_WARNINGS: UPDATE_SYNC_WARNINGS
	};
	exports["default"] = _default;

/***/ },
/* 322 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var isEvent = function isEvent(candidate) {
	  return !!(candidate && candidate.stopPropagation && candidate.preventDefault);
	};
	
	var _default = isEvent;
	exports["default"] = _default;

/***/ },
/* 323 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports["default"] = createIsValid;
	
	var _hasError = _interopRequireDefault(__webpack_require__(1965));
	
	function createIsValid(structure) {
	  var getIn = structure.getIn,
	      keys = structure.keys;
	  var hasError = (0, _hasError["default"])(structure);
	  return function (form, getFormState, ignoreSubmitErrors) {
	    if (ignoreSubmitErrors === void 0) {
	      ignoreSubmitErrors = false;
	    }
	
	    return function (state) {
	      var nonNullGetFormState = getFormState || function (state) {
	        return getIn(state, 'form');
	      };
	
	      var formState = nonNullGetFormState(state);
	      var syncError = getIn(formState, form + ".syncError");
	
	      if (syncError) {
	        return false;
	      }
	
	      if (!ignoreSubmitErrors) {
	        var error = getIn(formState, form + ".error");
	
	        if (error) {
	          return false;
	        }
	      }
	
	      var syncErrors = getIn(formState, form + ".syncErrors");
	      var asyncErrors = getIn(formState, form + ".asyncErrors");
	      var submitErrors = ignoreSubmitErrors ? undefined : getIn(formState, form + ".submitErrors");
	
	      if (!syncErrors && !asyncErrors && !submitErrors) {
	        return true;
	      }
	
	      var registeredFields = getIn(formState, form + ".registeredFields");
	
	      if (!registeredFields) {
	        return true;
	      }
	
	      return !keys(registeredFields).filter(function (name) {
	        return getIn(registeredFields, "['" + name + "'].count") > 0;
	      }).some(function (name) {
	        return hasError(getIn(registeredFields, "['" + name + "']"), syncErrors, asyncErrors, submitErrors);
	      });
	    };
	  };
	}

/***/ },
/* 324 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        if (typeof b !== "function" && b !== null)
	            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.AsyncSubject = void 0;
	var Subject_1 = __webpack_require__(51);
	var AsyncSubject = (function (_super) {
	    __extends(AsyncSubject, _super);
	    function AsyncSubject() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this._value = null;
	        _this._hasValue = false;
	        _this._isComplete = false;
	        return _this;
	    }
	    AsyncSubject.prototype._checkFinalizedStatuses = function (subscriber) {
	        var _a = this, hasError = _a.hasError, _hasValue = _a._hasValue, _value = _a._value, thrownError = _a.thrownError, isStopped = _a.isStopped, _isComplete = _a._isComplete;
	        if (hasError) {
	            subscriber.error(thrownError);
	        }
	        else if (isStopped || _isComplete) {
	            _hasValue && subscriber.next(_value);
	            subscriber.complete();
	        }
	    };
	    AsyncSubject.prototype.next = function (value) {
	        if (!this.isStopped) {
	            this._value = value;
	            this._hasValue = true;
	        }
	    };
	    AsyncSubject.prototype.complete = function () {
	        var _a = this, _hasValue = _a._hasValue, _value = _a._value, _isComplete = _a._isComplete;
	        if (!_isComplete) {
	            this._isComplete = true;
	            _hasValue && _super.prototype.next.call(this, _value);
	            _super.prototype.complete.call(this);
	        }
	    };
	    return AsyncSubject;
	}(Subject_1.Subject));
	exports.AsyncSubject = AsyncSubject;
	//# sourceMappingURL=AsyncSubject.js.map

/***/ },
/* 325 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.observeNotification = exports.Notification = exports.NotificationKind = void 0;
	var empty_1 = __webpack_require__(74);
	var of_1 = __webpack_require__(328);
	var throwError_1 = __webpack_require__(565);
	var isFunction_1 = __webpack_require__(31);
	var NotificationKind;
	(function (NotificationKind) {
	    NotificationKind["NEXT"] = "N";
	    NotificationKind["ERROR"] = "E";
	    NotificationKind["COMPLETE"] = "C";
	})(NotificationKind = exports.NotificationKind || (exports.NotificationKind = {}));
	var Notification = (function () {
	    function Notification(kind, value, error) {
	        this.kind = kind;
	        this.value = value;
	        this.error = error;
	        this.hasValue = kind === 'N';
	    }
	    Notification.prototype.observe = function (observer) {
	        return observeNotification(this, observer);
	    };
	    Notification.prototype.do = function (nextHandler, errorHandler, completeHandler) {
	        var _a = this, kind = _a.kind, value = _a.value, error = _a.error;
	        return kind === 'N' ? nextHandler === null || nextHandler === void 0 ? void 0 : nextHandler(value) : kind === 'E' ? errorHandler === null || errorHandler === void 0 ? void 0 : errorHandler(error) : completeHandler === null || completeHandler === void 0 ? void 0 : completeHandler();
	    };
	    Notification.prototype.accept = function (nextOrObserver, error, complete) {
	        var _a;
	        return isFunction_1.isFunction((_a = nextOrObserver) === null || _a === void 0 ? void 0 : _a.next)
	            ? this.observe(nextOrObserver)
	            : this.do(nextOrObserver, error, complete);
	    };
	    Notification.prototype.toObservable = function () {
	        var _a = this, kind = _a.kind, value = _a.value, error = _a.error;
	        var result = kind === 'N'
	            ?
	                of_1.of(value)
	            :
	                kind === 'E'
	                    ?
	                        throwError_1.throwError(function () { return error; })
	                    :
	                        kind === 'C'
	                            ?
	                                empty_1.EMPTY
	                            :
	                                0;
	        if (!result) {
	            throw new TypeError("Unexpected notification kind " + kind);
	        }
	        return result;
	    };
	    Notification.createNext = function (value) {
	        return new Notification('N', value);
	    };
	    Notification.createError = function (err) {
	        return new Notification('E', undefined, err);
	    };
	    Notification.createComplete = function () {
	        return Notification.completeNotification;
	    };
	    Notification.completeNotification = new Notification('C');
	    return Notification;
	}());
	exports.Notification = Notification;
	function observeNotification(notification, observer) {
	    var _a, _b, _c;
	    var _d = notification, kind = _d.kind, value = _d.value, error = _d.error;
	    if (typeof kind !== 'string') {
	        throw new TypeError('Invalid notification, missing "kind"');
	    }
	    kind === 'N' ? (_a = observer.next) === null || _a === void 0 ? void 0 : _a.call(observer, value) : kind === 'E' ? (_b = observer.error) === null || _b === void 0 ? void 0 : _b.call(observer, error) : (_c = observer.complete) === null || _c === void 0 ? void 0 : _c.call(observer);
	}
	exports.observeNotification = observeNotification;
	//# sourceMappingURL=Notification.js.map

/***/ },
/* 326 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        if (typeof b !== "function" && b !== null)
	            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.ReplaySubject = void 0;
	var Subject_1 = __webpack_require__(51);
	var dateTimestampProvider_1 = __webpack_require__(335);
	var ReplaySubject = (function (_super) {
	    __extends(ReplaySubject, _super);
	    function ReplaySubject(_bufferSize, _windowTime, _timestampProvider) {
	        if (_bufferSize === void 0) { _bufferSize = Infinity; }
	        if (_windowTime === void 0) { _windowTime = Infinity; }
	        if (_timestampProvider === void 0) { _timestampProvider = dateTimestampProvider_1.dateTimestampProvider; }
	        var _this = _super.call(this) || this;
	        _this._bufferSize = _bufferSize;
	        _this._windowTime = _windowTime;
	        _this._timestampProvider = _timestampProvider;
	        _this._buffer = [];
	        _this._infiniteTimeWindow = true;
	        _this._infiniteTimeWindow = _windowTime === Infinity;
	        _this._bufferSize = Math.max(1, _bufferSize);
	        _this._windowTime = Math.max(1, _windowTime);
	        return _this;
	    }
	    ReplaySubject.prototype.next = function (value) {
	        var _a = this, isStopped = _a.isStopped, _buffer = _a._buffer, _infiniteTimeWindow = _a._infiniteTimeWindow, _timestampProvider = _a._timestampProvider, _windowTime = _a._windowTime;
	        if (!isStopped) {
	            _buffer.push(value);
	            !_infiniteTimeWindow && _buffer.push(_timestampProvider.now() + _windowTime);
	        }
	        this._trimBuffer();
	        _super.prototype.next.call(this, value);
	    };
	    ReplaySubject.prototype._subscribe = function (subscriber) {
	        this._throwIfClosed();
	        this._trimBuffer();
	        var subscription = this._innerSubscribe(subscriber);
	        var _a = this, _infiniteTimeWindow = _a._infiniteTimeWindow, _buffer = _a._buffer;
	        var copy = _buffer.slice();
	        for (var i = 0; i < copy.length && !subscriber.closed; i += _infiniteTimeWindow ? 1 : 2) {
	            subscriber.next(copy[i]);
	        }
	        this._checkFinalizedStatuses(subscriber);
	        return subscription;
	    };
	    ReplaySubject.prototype._trimBuffer = function () {
	        var _a = this, _bufferSize = _a._bufferSize, _timestampProvider = _a._timestampProvider, _buffer = _a._buffer, _infiniteTimeWindow = _a._infiniteTimeWindow;
	        var adjustedBufferSize = (_infiniteTimeWindow ? 1 : 2) * _bufferSize;
	        _bufferSize < Infinity && adjustedBufferSize < _buffer.length && _buffer.splice(0, _buffer.length - adjustedBufferSize);
	        if (!_infiniteTimeWindow) {
	            var now = _timestampProvider.now();
	            var last = 0;
	            for (var i = 1; i < _buffer.length && _buffer[i] <= now; i += 2) {
	                last = i;
	            }
	            last && _buffer.splice(0, last + 1);
	        }
	    };
	    return ReplaySubject;
	}(Subject_1.Subject));
	exports.ReplaySubject = ReplaySubject;
	//# sourceMappingURL=ReplaySubject.js.map

/***/ },
/* 327 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.combineLatestInit = exports.combineLatest = void 0;
	var Observable_1 = __webpack_require__(34);
	var argsArgArrayOrObject_1 = __webpack_require__(594);
	var from_1 = __webpack_require__(78);
	var identity_1 = __webpack_require__(56);
	var mapOneOrManyArgs_1 = __webpack_require__(117);
	var args_1 = __webpack_require__(64);
	var createObject_1 = __webpack_require__(595);
	var OperatorSubscriber_1 = __webpack_require__(20);
	var executeSchedule_1 = __webpack_require__(100);
	function combineLatest() {
	    var args = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        args[_i] = arguments[_i];
	    }
	    var scheduler = args_1.popScheduler(args);
	    var resultSelector = args_1.popResultSelector(args);
	    var _a = argsArgArrayOrObject_1.argsArgArrayOrObject(args), observables = _a.args, keys = _a.keys;
	    if (observables.length === 0) {
	        return from_1.from([], scheduler);
	    }
	    var result = new Observable_1.Observable(combineLatestInit(observables, scheduler, keys
	        ?
	            function (values) { return createObject_1.createObject(keys, values); }
	        :
	            identity_1.identity));
	    return resultSelector ? result.pipe(mapOneOrManyArgs_1.mapOneOrManyArgs(resultSelector)) : result;
	}
	exports.combineLatest = combineLatest;
	function combineLatestInit(observables, scheduler, valueTransform) {
	    if (valueTransform === void 0) { valueTransform = identity_1.identity; }
	    return function (subscriber) {
	        maybeSchedule(scheduler, function () {
	            var length = observables.length;
	            var values = new Array(length);
	            var active = length;
	            var remainingFirstValues = length;
	            var _loop_1 = function (i) {
	                maybeSchedule(scheduler, function () {
	                    var source = from_1.from(observables[i], scheduler);
	                    var hasFirstValue = false;
	                    source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (value) {
	                        values[i] = value;
	                        if (!hasFirstValue) {
	                            hasFirstValue = true;
	                            remainingFirstValues--;
	                        }
	                        if (!remainingFirstValues) {
	                            subscriber.next(valueTransform(values.slice()));
	                        }
	                    }, function () {
	                        if (!--active) {
	                            subscriber.complete();
	                        }
	                    }));
	                }, subscriber);
	            };
	            for (var i = 0; i < length; i++) {
	                _loop_1(i);
	            }
	        }, subscriber);
	    };
	}
	exports.combineLatestInit = combineLatestInit;
	function maybeSchedule(scheduler, execute, subscription) {
	    if (scheduler) {
	        executeSchedule_1.executeSchedule(subscription, scheduler, execute);
	    }
	    else {
	        execute();
	    }
	}
	//# sourceMappingURL=combineLatest.js.map

/***/ },
/* 328 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.of = void 0;
	var args_1 = __webpack_require__(64);
	var from_1 = __webpack_require__(78);
	function of() {
	    var args = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        args[_i] = arguments[_i];
	    }
	    var scheduler = args_1.popScheduler(args);
	    return from_1.from(args, scheduler);
	}
	exports.of = of;
	//# sourceMappingURL=of.js.map

/***/ },
/* 329 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	var __spreadArray = (this && this.__spreadArray) || function (to, from) {
	    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
	        to[j] = from[i];
	    return to;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.zip = void 0;
	var Observable_1 = __webpack_require__(34);
	var innerFrom_1 = __webpack_require__(28);
	var argsOrArgArray_1 = __webpack_require__(137);
	var empty_1 = __webpack_require__(74);
	var OperatorSubscriber_1 = __webpack_require__(20);
	var args_1 = __webpack_require__(64);
	function zip() {
	    var args = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        args[_i] = arguments[_i];
	    }
	    var resultSelector = args_1.popResultSelector(args);
	    var sources = argsOrArgArray_1.argsOrArgArray(args);
	    return sources.length
	        ? new Observable_1.Observable(function (subscriber) {
	            var buffers = sources.map(function () { return []; });
	            var completed = sources.map(function () { return false; });
	            subscriber.add(function () {
	                buffers = completed = null;
	            });
	            var _loop_1 = function (sourceIndex) {
	                innerFrom_1.innerFrom(sources[sourceIndex]).subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (value) {
	                    buffers[sourceIndex].push(value);
	                    if (buffers.every(function (buffer) { return buffer.length; })) {
	                        var result = buffers.map(function (buffer) { return buffer.shift(); });
	                        subscriber.next(resultSelector ? resultSelector.apply(void 0, __spreadArray([], __read(result))) : result);
	                        if (buffers.some(function (buffer, i) { return !buffer.length && completed[i]; })) {
	                            subscriber.complete();
	                        }
	                    }
	                }, function () {
	                    completed[sourceIndex] = true;
	                    !buffers[sourceIndex].length && subscriber.complete();
	                }));
	            };
	            for (var sourceIndex = 0; !subscriber.closed && sourceIndex < sources.length; sourceIndex++) {
	                _loop_1(sourceIndex);
	            }
	            return function () {
	                buffers = completed = null;
	            };
	        })
	        : empty_1.EMPTY;
	}
	exports.zip = zip;
	//# sourceMappingURL=zip.js.map

/***/ },
/* 330 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.concatAll = void 0;
	var mergeAll_1 = __webpack_require__(225);
	function concatAll() {
	    return mergeAll_1.mergeAll(1);
	}
	exports.concatAll = concatAll;
	//# sourceMappingURL=concatAll.js.map

/***/ },
/* 331 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.connect = void 0;
	var Subject_1 = __webpack_require__(51);
	var from_1 = __webpack_require__(78);
	var lift_1 = __webpack_require__(17);
	var fromSubscribable_1 = __webpack_require__(2020);
	var DEFAULT_CONFIG = {
	    connector: function () { return new Subject_1.Subject(); },
	};
	function connect(selector, config) {
	    if (config === void 0) { config = DEFAULT_CONFIG; }
	    var connector = config.connector;
	    return lift_1.operate(function (source, subscriber) {
	        var subject = connector();
	        from_1.from(selector(fromSubscribable_1.fromSubscribable(subject))).subscribe(subscriber);
	        subscriber.add(source.subscribe(subject));
	    });
	}
	exports.connect = connect;
	//# sourceMappingURL=connect.js.map

/***/ },
/* 332 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.mergeInternals = void 0;
	var innerFrom_1 = __webpack_require__(28);
	var executeSchedule_1 = __webpack_require__(100);
	var OperatorSubscriber_1 = __webpack_require__(20);
	function mergeInternals(source, subscriber, project, concurrent, onBeforeNext, expand, innerSubScheduler, additionalFinalizer) {
	    var buffer = [];
	    var active = 0;
	    var index = 0;
	    var isComplete = false;
	    var checkComplete = function () {
	        if (isComplete && !buffer.length && !active) {
	            subscriber.complete();
	        }
	    };
	    var outerNext = function (value) { return (active < concurrent ? doInnerSub(value) : buffer.push(value)); };
	    var doInnerSub = function (value) {
	        expand && subscriber.next(value);
	        active++;
	        var innerComplete = false;
	        innerFrom_1.innerFrom(project(value, index++)).subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (innerValue) {
	            onBeforeNext === null || onBeforeNext === void 0 ? void 0 : onBeforeNext(innerValue);
	            if (expand) {
	                outerNext(innerValue);
	            }
	            else {
	                subscriber.next(innerValue);
	            }
	        }, function () {
	            innerComplete = true;
	        }, undefined, function () {
	            if (innerComplete) {
	                try {
	                    active--;
	                    var _loop_1 = function () {
	                        var bufferedValue = buffer.shift();
	                        if (innerSubScheduler) {
	                            executeSchedule_1.executeSchedule(subscriber, innerSubScheduler, function () { return doInnerSub(bufferedValue); });
	                        }
	                        else {
	                            doInnerSub(bufferedValue);
	                        }
	                    };
	                    while (buffer.length && active < concurrent) {
	                        _loop_1();
	                    }
	                    checkComplete();
	                }
	                catch (err) {
	                    subscriber.error(err);
	                }
	            }
	        }));
	    };
	    source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, outerNext, function () {
	        isComplete = true;
	        checkComplete();
	    }));
	    return function () {
	        additionalFinalizer === null || additionalFinalizer === void 0 ? void 0 : additionalFinalizer();
	    };
	}
	exports.mergeInternals = mergeInternals;
	//# sourceMappingURL=mergeInternals.js.map

/***/ },
/* 333 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.multicast = void 0;
	var ConnectableObservable_1 = __webpack_require__(221);
	var isFunction_1 = __webpack_require__(31);
	var connect_1 = __webpack_require__(331);
	function multicast(subjectOrSubjectFactory, selector) {
	    var subjectFactory = isFunction_1.isFunction(subjectOrSubjectFactory) ? subjectOrSubjectFactory : function () { return subjectOrSubjectFactory; };
	    if (isFunction_1.isFunction(selector)) {
	        return connect_1.connect(selector, {
	            connector: subjectFactory,
	        });
	    }
	    return function (source) { return new ConnectableObservable_1.ConnectableObservable(source, subjectFactory); };
	}
	exports.multicast = multicast;
	//# sourceMappingURL=multicast.js.map

/***/ },
/* 334 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.timeout = exports.TimeoutError = void 0;
	var async_1 = __webpack_require__(63);
	var isDate_1 = __webpack_require__(338);
	var lift_1 = __webpack_require__(17);
	var innerFrom_1 = __webpack_require__(28);
	var createErrorClass_1 = __webpack_require__(116);
	var OperatorSubscriber_1 = __webpack_require__(20);
	var executeSchedule_1 = __webpack_require__(100);
	exports.TimeoutError = createErrorClass_1.createErrorClass(function (_super) {
	    return function TimeoutErrorImpl(info) {
	        if (info === void 0) { info = null; }
	        _super(this);
	        this.message = 'Timeout has occurred';
	        this.name = 'TimeoutError';
	        this.info = info;
	    };
	});
	function timeout(config, schedulerArg) {
	    var _a = (isDate_1.isValidDate(config) ? { first: config } : typeof config === 'number' ? { each: config } : config), first = _a.first, each = _a.each, _b = _a.with, _with = _b === void 0 ? timeoutErrorFactory : _b, _c = _a.scheduler, scheduler = _c === void 0 ? schedulerArg !== null && schedulerArg !== void 0 ? schedulerArg : async_1.asyncScheduler : _c, _d = _a.meta, meta = _d === void 0 ? null : _d;
	    if (first == null && each == null) {
	        throw new TypeError('No timeout provided.');
	    }
	    return lift_1.operate(function (source, subscriber) {
	        var originalSourceSubscription;
	        var timerSubscription;
	        var lastValue = null;
	        var seen = 0;
	        var startTimer = function (delay) {
	            timerSubscription = executeSchedule_1.executeSchedule(subscriber, scheduler, function () {
	                try {
	                    originalSourceSubscription.unsubscribe();
	                    innerFrom_1.innerFrom(_with({
	                        meta: meta,
	                        lastValue: lastValue,
	                        seen: seen,
	                    })).subscribe(subscriber);
	                }
	                catch (err) {
	                    subscriber.error(err);
	                }
	            }, delay);
	        };
	        originalSourceSubscription = source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (value) {
	            timerSubscription === null || timerSubscription === void 0 ? void 0 : timerSubscription.unsubscribe();
	            seen++;
	            subscriber.next((lastValue = value));
	            each > 0 && startTimer(each);
	        }, undefined, undefined, function () {
	            if (!(timerSubscription === null || timerSubscription === void 0 ? void 0 : timerSubscription.closed)) {
	                timerSubscription === null || timerSubscription === void 0 ? void 0 : timerSubscription.unsubscribe();
	            }
	            lastValue = null;
	        }));
	        !seen && startTimer(first != null ? (typeof first === 'number' ? first : +first - scheduler.now()) : each);
	    });
	}
	exports.timeout = timeout;
	function timeoutErrorFactory(info) {
	    throw new exports.TimeoutError(info);
	}
	//# sourceMappingURL=timeout.js.map

/***/ },
/* 335 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.dateTimestampProvider = void 0;
	exports.dateTimestampProvider = {
	    now: function () {
	        return (exports.dateTimestampProvider.delegate || Date).now();
	    },
	    delegate: undefined,
	};
	//# sourceMappingURL=dateTimestampProvider.js.map

/***/ },
/* 336 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.captureError = exports.errorContext = void 0;
	var config_1 = __webpack_require__(165);
	var context = null;
	function errorContext(cb) {
	    if (config_1.config.useDeprecatedSynchronousErrorHandling) {
	        var isRoot = !context;
	        if (isRoot) {
	            context = { errorThrown: false, error: null };
	        }
	        cb();
	        if (isRoot) {
	            var _a = context, errorThrown = _a.errorThrown, error = _a.error;
	            context = null;
	            if (errorThrown) {
	                throw error;
	            }
	        }
	    }
	    else {
	        cb();
	    }
	}
	exports.errorContext = errorContext;
	function captureError(err) {
	    if (config_1.config.useDeprecatedSynchronousErrorHandling && context) {
	        context.errorThrown = true;
	        context.error = err;
	    }
	}
	exports.captureError = captureError;
	//# sourceMappingURL=errorContext.js.map

/***/ },
/* 337 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.isArrayLike = void 0;
	exports.isArrayLike = (function (x) { return x && typeof x.length === 'number' && typeof x !== 'function'; });
	//# sourceMappingURL=isArrayLike.js.map

/***/ },
/* 338 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.isValidDate = void 0;
	function isValidDate(value) {
	    return value instanceof Date && !isNaN(value);
	}
	exports.isValidDate = isValidDate;
	//# sourceMappingURL=isDate.js.map

/***/ },
/* 339 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __generator = (this && this.__generator) || function (thisArg, body) {
	    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
	    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
	    function verb(n) { return function (v) { return step([n, v]); }; }
	    function step(op) {
	        if (f) throw new TypeError("Generator is already executing.");
	        while (_) try {
	            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
	            if (y = 0, t) op = [op[0] & 2, t.value];
	            switch (op[0]) {
	                case 0: case 1: t = op; break;
	                case 4: _.label++; return { value: op[1], done: false };
	                case 5: _.label++; y = op[1]; op = [0]; continue;
	                case 7: op = _.ops.pop(); _.trys.pop(); continue;
	                default:
	                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
	                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
	                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
	                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
	                    if (t[2]) _.ops.pop();
	                    _.trys.pop(); continue;
	            }
	            op = body.call(thisArg, _);
	        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
	        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
	    }
	};
	var __await = (this && this.__await) || function (v) { return this instanceof __await ? (this.v = v, this) : new __await(v); }
	var __asyncGenerator = (this && this.__asyncGenerator) || function (thisArg, _arguments, generator) {
	    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
	    var g = generator.apply(thisArg, _arguments || []), i, q = [];
	    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
	    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
	    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
	    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
	    function fulfill(value) { resume("next", value); }
	    function reject(value) { resume("throw", value); }
	    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.isReadableStreamLike = exports.readableStreamLikeToAsyncGenerator = void 0;
	var isFunction_1 = __webpack_require__(31);
	function readableStreamLikeToAsyncGenerator(readableStream) {
	    return __asyncGenerator(this, arguments, function readableStreamLikeToAsyncGenerator_1() {
	        var reader, _a, value, done;
	        return __generator(this, function (_b) {
	            switch (_b.label) {
	                case 0:
	                    reader = readableStream.getReader();
	                    _b.label = 1;
	                case 1:
	                    _b.trys.push([1, , 9, 10]);
	                    _b.label = 2;
	                case 2:
	                    if (false) return [3, 8];
	                    return [4, __await(reader.read())];
	                case 3:
	                    _a = _b.sent(), value = _a.value, done = _a.done;
	                    if (!done) return [3, 5];
	                    return [4, __await(void 0)];
	                case 4: return [2, _b.sent()];
	                case 5: return [4, __await(value)];
	                case 6: return [4, _b.sent()];
	                case 7:
	                    _b.sent();
	                    return [3, 2];
	                case 8: return [3, 10];
	                case 9:
	                    reader.releaseLock();
	                    return [7];
	                case 10: return [2];
	            }
	        });
	    });
	}
	exports.readableStreamLikeToAsyncGenerator = readableStreamLikeToAsyncGenerator;
	function isReadableStreamLike(obj) {
	    return isFunction_1.isFunction(obj === null || obj === void 0 ? void 0 : obj.getReader);
	}
	exports.isReadableStreamLike = isReadableStreamLike;
	//# sourceMappingURL=isReadableStreamLike.js.map

/***/ },
/* 340 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(825);

/***/ },
/* 341 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(828);

/***/ },
/* 342 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _appActions = __webpack_require__(21);
	
	var _appActions2 = _interopRequireDefault(_appActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var error = {
	    doError: function doError(error) {
	        return {
	            type: _appActions2.default.ADD_ERROR,
	            payload: error
	        };
	    },
	
	    doErrorLineItems: function doErrorLineItems(lineItemsError) {
	        return {
	            type: _appActions2.default.ERRORS_LINE_ITEMS,
	            payload: lineItemsError
	        };
	    },
	
	    clearErrorLineItems: function clearErrorLineItems() {
	        return {
	            type: _appActions2.default.CLEAR_ERRORS_LINE_ITEMS
	        };
	    }
	};
	
	exports.default = error;

/***/ },
/* 343 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _appActions = __webpack_require__(21);
	
	var _appActions2 = _interopRequireDefault(_appActions);
	
	var _lineItem = __webpack_require__(345);
	
	var _lineItem2 = _interopRequireDefault(_lineItem);
	
	var _localStorageApi = __webpack_require__(55);
	
	var _localStorageApi2 = _interopRequireDefault(_localStorageApi);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var lineItem = {
	    addLineItem: function addLineItem(lineItemParams) {
	        return function (dispatch, getState) {
	            return _lineItem2.default.add(lineItemParams).then(function (response) {
	                dispatch({ type: _appActions2.default.ADD_PRODUCT_TO_CART, payload: response.body });
	                _localStorageApi2.default.save(getState());
	                return response;
	            });
	        };
	    },
	    disablingAdd: function disablingAdd(enabled) {
	        return function (dispatch, getState) {
	            dispatch({ type: _appActions2.default.DISABLING_ADD, payload: enabled });
	            _localStorageApi2.default.save(getState());
	        };
	    }
	};
	
	exports.default = lineItem;

/***/ },
/* 344 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _appActions = __webpack_require__(21);
	
	var _appActions2 = _interopRequireDefault(_appActions);
	
	var _localStorageApi = __webpack_require__(55);
	
	var _localStorageApi2 = _interopRequireDefault(_localStorageApi);
	
	var _order = __webpack_require__(172);
	
	var _order2 = _interopRequireDefault(_order);
	
	var _placedOrder = __webpack_require__(236);
	
	var _placedOrder2 = _interopRequireDefault(_placedOrder);
	
	var _user = __webpack_require__(102);
	
	var _user2 = _interopRequireDefault(_user);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var user = {
	    logout: function logout() {
	        return function (dispatch, getState) {
	            dispatch({
	                type: _appActions2.default.LOGOUT
	            });
	            dispatch({
	                type: _appActions2.default.REMOVE_USER
	            });
	            dispatch({
	                type: _appActions2.default.CLEAR_WALLETS
	            });
	            _localStorageApi2.default.clear();
	
	            dispatch(_placedOrder2.default.clearPlacedOrder());
	            dispatch(_order2.default.clearOrder());
	        };
	    },
	    setAgeValid: function setAgeValid(ageValid, accessToken, locale) {
	        return function (dispatch, getState) {
	            _user2.default.setAccountAgeValid({ age_valid: ageValid }, accessToken).then(function (response) {
	                _user2.default.getUser({ token: accessToken, locale: locale }).then(function (response) {
	                    dispatch({
	                        type: _appActions2.default.USER,
	                        payload: _extends({
	                            id: response.body.data.id
	                        }, response.body.data.attributes)
	                    });
	                    _localStorageApi2.default.save(getState());
	                });
	            });
	        };
	    }
	};
	
	exports.default = user;

/***/ },
/* 345 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var request = __webpack_require__(67);
	
	var LineItemAPI = {
	    add: function add(params) {
	        var sanitizedQueryParams = {};
	        sanitizedQueryParams.locale = params.locale;
	
	        return request
	        // eslint-disable-next-line max-len
	        .post(("https://staging.api.cubalicores.com") + '/api/v2/storefront/cart/add_item?include=line_items,line_items.variant.images,variants.product.images,line_items.data_extras,variants.product.data_extra_types').set('X-Spree-Order-Token', params.orderToken).set('Content-Type', 'application/vnd.api+json').query(sanitizedQueryParams).send(_extends({
	            variant_id: params.variantId,
	            quantity: params.quantity,
	            zone_id: params.zoneId
	        }, params.extraParam && { data_extras: params.extraParam })).then(function (response) {
	            return response;
	        });
	    },
	
	    destroy: function destroy(params) {
	        var sanitizedQueryParams = {};
	        sanitizedQueryParams.locale = params.locale;
	
	        return request.delete(("https://staging.api.cubalicores.com") + '/api/v2/storefront/cart/remove_line_item/' + params.lineItemId).set('X-Spree-Order-Token', params.token).set('Content-Type', 'application/vnd.api+json').query(sanitizedQueryParams);
	    },
	
	    destroyDataExtra: function destroyDataExtra(params) {
	        var sanitizedQueryParams = {};
	        sanitizedQueryParams.locale = params.locale;
	
	        return request
	        // eslint-disable-next-line max-len
	        .delete(("https://staging.api.cubalicores.com") + '/api/v2/storefront/cart/remove_data_extra/' + params.dataExtraId + '?include=line_items,line_items.variant.images,variants.product.images,line_items.data_extras,variants.product.data_extra_types').set('X-Spree-Order-Token', params.token).set('Content-Type', 'application/vnd.api+json').query(sanitizedQueryParams);
	    },
	
	    update: function update(params) {
	        var sanitizedQueryParams = {};
	        sanitizedQueryParams.locale = params.locale;
	
	        return request
	        // eslint-disable-next-line max-len
	        .patch(("https://staging.api.cubalicores.com") + '/api/v2/storefront/cart/set_quantity?include=line_items,line_items.variant.images,variants.product.images,line_items.data_extras,variants.product.data_extra_types').set('X-Spree-Order-Token', params.token).set('Content-Type', 'application/vnd.api+json').query(sanitizedQueryParams).send({
	            line_item_id: params.lineItemId,
	            quantity: params.quantity,
	            zone_id: params.zoneId
	        }).then(function (response) {
	            return response;
	        });
	    }
	};
	
	exports.default = LineItemAPI;

/***/ },
/* 346 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _appDefaults = __webpack_require__(39);
	
	var _appDefaults2 = _interopRequireDefault(_appDefaults);
	
	var _spreeApiProductAdapter = __webpack_require__(649);
	
	var _spreeApiProductAdapter2 = _interopRequireDefault(_spreeApiProductAdapter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var request = __webpack_require__(67);
	
	var ProductsAPI = {
	    getList: function getList() {
	        var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	        var apiBase = ("https://staging.api.cubalicores.com");
	        var sanitizedQueryParams = {};
	
	        sanitizedQueryParams.page = params.page_no || 1;
	        sanitizedQueryParams.per_page = _appDefaults2.default.perPage;
	
	        if (params.taxonId) {
	            sanitizedQueryParams['filter[taxons]'] = params.taxonId;
	        }
	
	        if (params.searchTerm) {
	            sanitizedQueryParams['filter[name]'] = params.searchTerm;
	        }
	
	        if (params.price) {
	            sanitizedQueryParams['filter[price]'] = params.price;
	        }
	
	        if (params.locale) {
	            sanitizedQueryParams.locale = params.locale;
	        }
	
	        if (params.municipality) {
	            sanitizedQueryParams.municipality = params.municipality;
	        }
	
	        return request
	        // eslint-disable-next-line max-len
	        .get(apiBase + '/api/v2/storefront/products?zone_id=' + (params.zone || 6) + '&store_id=' + params.storeId + '&include=default_variant,variants,images,variants.images,variants.option_values,data_extra_types&sort=-updated_at').query(sanitizedQueryParams).set('Accept', 'application/json').then(function (response) {
	            response.body = _spreeApiProductAdapter2.default.processList(response.body);
	
	            return response;
	        });
	    },
	
	    getAllStoreList: function getAllStoreList() {
	        var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	        var apiBase = ("https://staging.api.cubalicores.com");
	        var sanitizedQueryParams = {};
	
	        sanitizedQueryParams.page = params.page_no || 1;
	        sanitizedQueryParams.per_page = _appDefaults2.default.perPage;
	
	        if (params.searchTerm) {
	            sanitizedQueryParams['filter[name]'] = params.searchTerm;
	        }
	
	        if (params.locale) {
	            sanitizedQueryParams.locale = params.locale;
	        }
	
	        if (params.municipality) {
	            sanitizedQueryParams.municipality = params.municipality;
	        }
	
	        return request
	        // eslint-disable-next-line max-len
	        .get(apiBase + '/api/v2/storefront/products?zone_id=' + (params.zone || 6) + '&include=default_variant,variants,images,variants.images,variants.option_values&sort=-updated_at').query(sanitizedQueryParams).set('Accept', 'application/json').then(function (response) {
	            response.body = _spreeApiProductAdapter2.default.processList(response.body);
	
	            return response;
	        });
	    },
	
	    getItem: function getItem(productId, locale, zoneId) {
	        var sanitizedQueryParams = {};
	        sanitizedQueryParams.locale = locale;
	
	        return request
	        // eslint-disable-next-line max-len
	        .get(("https://staging.api.cubalicores.com") + '/api/v2/storefront/products/' + productId + '?include=default_variant,variants,images,variants.images,variants.option_values,data_extra_types&zone_id=' + zoneId).set('Accept', 'application/json').query(sanitizedQueryParams).then(function (response) {
	            response.body = _spreeApiProductAdapter2.default.processItem(response.body);
	
	            return response;
	        });
	    }
	};
	
	exports.default = ProductsAPI;

/***/ },
/* 347 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var request = __webpack_require__(67);
	
	var TaxonAPI = {
	    getTaxons: function getTaxons(storeId) {
	        return request.get(("https://staging.api.cubalicores.com") + '/api/v1/multi_stores/' + storeId + '/taxonomies').set('Accept', 'application/json').send().then(function (response) {
	            return response.body;
	        });
	    }
	};
	
	exports.default = TaxonAPI;

/***/ },
/* 348 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(18);
	
	var _reactReduxToastr = __webpack_require__(42);
	
	var _ageValidModal = __webpack_require__(654);
	
	var _ageValidModal2 = _interopRequireDefault(_ageValidModal);
	
	var _appTranslations = __webpack_require__(33);
	
	var _appTranslations2 = _interopRequireDefault(_appTranslations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AgeValidWrapper = function (_Component) {
	    _inherits(AgeValidWrapper, _Component);
	
	    function AgeValidWrapper(props, context) {
	        _classCallCheck(this, AgeValidWrapper);
	
	        var _this = _possibleConstructorReturn(this, (AgeValidWrapper.__proto__ || Object.getPrototypeOf(AgeValidWrapper)).call(this, props, context));
	
	        _this.handleClick = _this.handleClick.bind(_this);
	        _this.preventClick = _this.preventClick.bind(_this);
	        _this.isUnder21 = _this.isUnder21.bind(_this);
	        _this.wrapWithModal = _this.wrapWithModal.bind(_this);
	        _this.state = { showAgeMinModal: false };
	        return _this;
	    }
	
	    _createClass(AgeValidWrapper, [{
	        key: 'closeAgeMinModal',
	        value: function closeAgeMinModal() {
	            this.setState({ showAgeMinModal: false });
	        }
	    }, {
	        key: 'handleClick',
	        value: function handleClick(e) {
	            e.stopPropagation();
	            e.preventDefault();
	            if (this.state.showAgeMinModal === false) {
	                this.setState({ showAgeMinModal: true });
	            }
	        }
	
	        // eslint-disable-next-line class-methods-use-this
	
	    }, {
	        key: 'isUnder21',
	        value: function isUnder21() {
	            var isAgeValid = void 0;
	
	            if (this.props.user && this.props.user.id) {
	                if (this.props.user.age_valid !== null) {
	                    isAgeValid = this.props.user.age_valid;
	                }
	            } else {
	                var ageValid = sessionStorage.getItem('katapulk_age_valid');
	
	                if (ageValid !== null) {
	                    isAgeValid = JSON.parse(ageValid);
	                }
	            }
	
	            return isAgeValid;
	        }
	
	        // eslint-disable-next-line class-methods-use-this
	
	    }, {
	        key: 'preventClick',
	        value: function preventClick(e) {
	            e.stopPropagation();
	            e.preventDefault();
	            _reactReduxToastr.toastr.error(_appTranslations2.default[this.props.locale.currentLocale].error, _appTranslations2.default[this.props.locale.currentLocale]['sorry-product-over-21']);
	        }
	    }, {
	        key: 'wrapWithModal',
	        value: function wrapWithModal() {
	            var _this2 = this;
	
	            return _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                    'span',
	                    { onClickCapture: this.handleClick },
	                    this.props.children
	                ),
	                _react2.default.createElement(_ageValidModal2.default, {
	                    show: this.state.showAgeMinModal,
	                    onHide: function onHide() {
	                        return _this2.closeAgeMinModal();
	                    }
	                })
	            );
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            if (this.props.productAgeValid !== true) {
	                return this.props.children;
	            }
	
	            var isAgeValid = this.isUnder21();
	
	            if (isAgeValid === undefined) {
	                return this.wrapWithModal();
	            }
	
	            return isAgeValid ? this.props.children : _react2.default.createElement(
	                'span',
	                { onClickCapture: this.preventClick },
	                this.props.children
	            );
	        }
	    }]);
	
	    return AgeValidWrapper;
	}(_react.Component);
	
	var AgeValidWrapperConnector = (0, _reactRedux.connect)(function (state) {
	    return {
	        anonymousUser: state.anonymousUser,
	        user: state.user,
	        locale: state.locale
	    };
	})(AgeValidWrapper);
	
	exports.default = AgeValidWrapperConnector;

/***/ },
/* 349 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(11);
	
	var _loader = __webpack_require__(65);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CountryField = function (_Component) {
	    _inherits(CountryField, _Component);
	
	    function CountryField(props) {
	        _classCallCheck(this, CountryField);
	
	        var _this = _possibleConstructorReturn(this, (CountryField.__proto__ || Object.getPrototypeOf(CountryField)).call(this, props));
	
	        _this.handleCountryChange = _this.handleCountryChange.bind(_this);
	        return _this;
	    }
	
	    _createClass(CountryField, [{
	        key: 'handleCountryChange',
	        value: function handleCountryChange(event) {
	            this.props.handleCountryChange(event.currentTarget.value);
	            // Trigger the redux-form onChange callback.
	            this.props.input.onChange(event.currentTarget.value);
	            this.props.input.onBlur();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props$meta = this.props.meta;
	            var touched = _props$meta.touched;
	            var error = _props$meta.error;
	
	            var errorClassName = '';
	            if (touched && error) {
	                errorClassName = 'has-error ';
	            }
	
	            var countryOptionsMarkup = this.props.countries.map(function (country, idx) {
	                return _react2.default.createElement(
	                    'option',
	                    { key: idx, value: country.iso },
	                    country.name
	                );
	            });
	
	            return _react2.default.createElement(
	                'div',
	                { style: { position: 'relative' }, className: '' + errorClassName },
	                _react2.default.createElement(
	                    'select',
	                    { name: this.props.fieldNamePrefix + '[country_iso]', onChange: this.handleCountryChange, className: 'form-control primary-input-field', value: this.props.selectedCountryIso },
	                    _react2.default.createElement(
	                        'option',
	                        { value: '', disabled: true },
	                        this.props.intl.formatMessage({ id: 'select', defaultMessage: 'Select' })
	                    ),
	                    countryOptionsMarkup
	                ),
	                this.props.countries.length === 0 && _react2.default.createElement(
	                    'div',
	                    { style: {
	                            position: 'absolute', top: '5px', right: '4px', backgroundColor: '#fff'
	                        }
	                    },
	                    _react2.default.createElement(_loader2.default, { displayLoader: true, size: 25 })
	                ),
	                touched && error && _react2.default.createElement(
	                    'span',
	                    { className: 'help-block' },
	                    error
	                )
	            );
	        }
	    }]);
	
	    return CountryField;
	}(_react.Component);
	
	exports.default = (0, _reactIntl.injectIntl)(CountryField);

/***/ },
/* 350 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(11);
	
	var _loader = __webpack_require__(65);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var StateField = function (_Component) {
	    _inherits(StateField, _Component);
	
	    function StateField(props) {
	        _classCallCheck(this, StateField);
	
	        var _this = _possibleConstructorReturn(this, (StateField.__proto__ || Object.getPrototypeOf(StateField)).call(this, props));
	
	        _this.handleStateChange = _this.handleStateChange.bind(_this);
	        return _this;
	    }
	
	    _createClass(StateField, [{
	        key: 'handleStateChange',
	        value: function handleStateChange(event) {
	            this.props.handleStateChange(event.currentTarget.value);
	            // Trigger the redux-form onChange callback.
	            this.props.input.onChange(event.currentTarget.value);
	            this.props.input.onBlur();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props$meta = this.props.meta;
	            var touched = _props$meta.touched;
	            var error = _props$meta.error;
	
	            var errorClassName = '';
	            if (touched && error) {
	                errorClassName = 'has-error ';
	            }
	
	            var stateOptionsMarkup = this.props.states.map(function (state, idx) {
	                return _react2.default.createElement(
	                    'option',
	                    { key: idx, value: state.abbr },
	                    state.name
	                );
	            });
	
	            return _react2.default.createElement(
	                'div',
	                { style: { position: 'relative' }, className: '' + errorClassName },
	                !this.props.displayLoader ? _react2.default.createElement(
	                    'select',
	                    {
	                        name: this.props.fieldNamePrefix + '[state_name]',
	                        onChange: this.handleStateChange,
	                        className: 'form-control primary-input-field',
	                        value: this.props.selectedStateCode,
	                        disabled: !this.props.displayLoader && this.props.states.length === 0 || this.props.disabled
	                    },
	                    _react2.default.createElement(
	                        'option',
	                        { value: '', disabled: true },
	                        this.props.intl.formatMessage({ id: 'select', defaultMessage: 'Select' })
	                    ),
	                    stateOptionsMarkup
	                ) : _react2.default.createElement(
	                    'select',
	                    {
	                        name: this.props.fieldNamePrefix + '[state_name]',
	                        onChange: this.handleStateChange,
	                        className: 'form-control primary-input-field',
	                        value: this.props.selectedStateCode,
	                        disabled: !this.props.displayLoader && this.props.states.length === 0 || this.props.disabled
	                    },
	                    _react2.default.createElement('option', { value: '' })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { style: {
	                            position: 'absolute', top: '5px', right: '4px', backgroundColor: !this.props.displayLoader && this.props.states.length === 0 ? '#eee' : '#fff'
	                        }
	                    },
	                    _react2.default.createElement(_loader2.default, { displayLoader: this.props.displayLoader, size: 25 })
	                ),
	                touched && error && _react2.default.createElement(
	                    'span',
	                    { className: 'help-block' },
	                    error
	                )
	            );
	        }
	    }]);
	
	    return StateField;
	}(_react.Component);
	
	exports.default = (0, _reactIntl.injectIntl)(StateField);

/***/ },
/* 351 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(11);
	
	var _layout = __webpack_require__(29);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _baseCheckoutLayout = __webpack_require__(121);
	
	var _baseCheckoutLayout2 = _interopRequireDefault(_baseCheckoutLayout);
	
	var _panelView = __webpack_require__(352);
	
	var _panelView2 = _interopRequireDefault(_panelView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CheckoutSuccessPage = function (_Component) {
	    _inherits(CheckoutSuccessPage, _Component);
	
	    function CheckoutSuccessPage(props) {
	        _classCallCheck(this, CheckoutSuccessPage);
	
	        var _this = _possibleConstructorReturn(this, (CheckoutSuccessPage.__proto__ || Object.getPrototypeOf(CheckoutSuccessPage)).call(this, props));
	
	        document.title = _this.props.intl.formatMessage({ id: 'checkout', defaultMessage: 'Checkout' });
	        return _this;
	    }
	
	    /* Render this step only if order is present and in a valid checkout state. */
	
	
	    _createClass(CheckoutSuccessPage, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            if (this.props.currentCheckoutStep === 'complete') {
	                var dupeOrder = _extends({}, this.props.order);
	                this.props.saveOrderAsPlaced(dupeOrder);
	            } else if (!this.props.placedOrder.id) {
	                this.props.handleCheckoutStepNotEditable(this.props.order);
	            }
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            if (this.props.currentCheckoutStep === 'complete') {
	                this.props.clearOrder();
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps) {
	            if (this.props.locale !== prevProps.locale) {
	                document.title = this.props.intl.formatMessage({ id: 'checkout', defaultMessage: 'Checkout' });
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                _layout2.default,
	                null,
	                _react2.default.createElement(
	                    _baseCheckoutLayout2.default,
	                    {
	                        currentStep: 'complete',
	                        displayLoader: this.props.displayLoader,
	                        checkoutSteps: this.props.placedOrder.checkout_steps || [],
	                        placedOrder: this.props.placedOrder,
	                        order: this.props.order
	                    },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'checkout-confirmation-block' },
	                        _react2.default.createElement(
	                            'strong',
	                            { className: 'text text-success confirmation-success-message' },
	                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'successMessage', defaultMessage: 'Your Order has been placed successfully!' })
	                        ),
	                        _react2.default.createElement(_panelView2.default, { order: this.props.placedOrder, stores: this.props.stores, locale: this.props.intl.locale })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return CheckoutSuccessPage;
	}(_react.Component);
	
	exports.default = (0, _reactIntl.injectIntl)(CheckoutSuccessPage);

/***/ },
/* 352 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(11);
	
	var _shipment = __webpack_require__(242);
	
	var _shipment2 = _interopRequireDefault(_shipment);
	
	var _address = __webpack_require__(142);
	
	var _address2 = _interopRequireDefault(_address);
	
	var _zoneService = __webpack_require__(79);
	
	var _zoneService2 = _interopRequireDefault(_zoneService);
	
	var _shipmentsUtils = __webpack_require__(180);
	
	var _shipmentsUtils2 = _interopRequireDefault(_shipmentsUtils);
	
	var _appTranslations = __webpack_require__(33);
	
	var _appTranslations2 = _interopRequireDefault(_appTranslations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var OrderPanelView = function (_Component) {
	    _inherits(OrderPanelView, _Component);
	
	    function OrderPanelView() {
	        _classCallCheck(this, OrderPanelView);
	
	        return _possibleConstructorReturn(this, (OrderPanelView.__proto__ || Object.getPrototypeOf(OrderPanelView)).apply(this, arguments));
	    }
	
	    _createClass(OrderPanelView, [{
	        key: '_panelHeaderMarkup',
	        value: function _panelHeaderMarkup() {
	            var order = this.props.order;
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'order-panel-header no-margin' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'label-block-row order-padding' },
	                    _react2.default.createElement(
	                        'label',
	                        { className: 'label label-default' },
	                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'orderNumber', defaultMessage: 'Ref' }),
	                        ': ' + order.number
	                    ),
	                    _react2.default.createElement(
	                        'label',
	                        { className: 'label label-normal' },
	                        order.shipments && order.shipments.length,
	                        '\xA0',
	                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'packages', defaultMessage: 'Package(s)' })
	                    ),
	                    _react2.default.createElement(
	                        'label',
	                        { className: 'label label-normal' },
	                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'orderTotal', defaultMessage: 'Order Total' }),
	                        ': ' + order.display_total
	                    ),
	                    !_zoneService2.default.isDonationZone() && _react2.default.createElement(
	                        'div',
	                        { className: 'order-address-block' },
	                        _react2.default.createElement(
	                            'label',
	                            null,
	                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'shippingAddress', defaultMessage: 'Shipping Address' }),
	                            ': \xA0'
	                        ),
	                        _react2.default.createElement(_address2.default, { address: _extends({}, order.ship_address, order.ship_address && order.ship_address.attributes ? order.ship_address.attributes : []) })
	                    )
	                )
	            );
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props;
	            var thisOrder = _props.order;
	            var stores = _props.stores;
	
	            var shipments = stores && stores.length > 0 && thisOrder.shipments && thisOrder.shipments.length > 0 && thisOrder.shipments.sort(_shipmentsUtils2.default.compareShipments);
	
	            var storeIdsCount = _shipmentsUtils2.default.countAmountOfStores(thisOrder.shipments);
	            var lastStore = void 0;
	            var cont = 0;
	
	            var shipmentsMarkup = shipments && shipments.length > 0 && shipments.map(function (shipment, idx) {
	                var store = stores && stores.find(function (store) {
	                    return store.id === shipment.attributes.store_ids[0];
	                });
	                if (store !== lastStore) {
	                    lastStore = store;
	                    cont = 0;
	                } else {
	                    cont += 1;
	                }
	
	                return _react2.default.createElement(_shipment2.default, {
	                    key: idx,
	                    store: stores && stores.find(function (store) {
	                        return store.id === shipment.attributes.store_ids[0];
	                    }),
	                    shipment: shipment,
	                    address: thisOrder.ship_address,
	                    order: _this2.props.order,
	                    hideStoreName: _shipmentsUtils2.default.prevIsSameStore(shipments, idx),
	                    style: _shipmentsUtils2.default.shipmentStylePadding(shipments, idx),
	                    details: _appTranslations2.default[_this2.props.locale]['shipment.word'] + ' ' + (cont + 1) + (' ' + _appTranslations2.default[_this2.props.locale]['of.word'] + ' ' + storeIdsCount[shipment.attributes.store_ids[0]])
	                });
	            });
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'confirmation-details-block' },
	                this._panelHeaderMarkup(),
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    shipmentsMarkup
	                )
	            );
	        }
	    }]);
	
	    return OrderPanelView;
	}(_react.Component);
	
	exports.default = OrderPanelView;

/***/ },
/* 353 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(38);
	
	var _reactIntl = __webpack_require__(11);
	
	var _reactRouterDom = __webpack_require__(26);
	
	var _checkoutStepCalculator = __webpack_require__(54);
	
	var _checkoutStepCalculator2 = _interopRequireDefault(_checkoutStepCalculator);
	
	var _paymentSelectionService = __webpack_require__(371);
	
	var _paymentSelectionService2 = _interopRequireDefault(_paymentSelectionService);
	
	var _store = __webpack_require__(40);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _appTranslations = __webpack_require__(33);
	
	var _appTranslations2 = _interopRequireDefault(_appTranslations);
	
	var _appRoutes = __webpack_require__(22);
	
	var _appRoutes2 = _interopRequireDefault(_appRoutes);
	
	var _actions = __webpack_require__(23);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var OrderSummary = function (_Component) {
	    _inherits(OrderSummary, _Component);
	
	    function OrderSummary(props) {
	        _classCallCheck(this, OrderSummary);
	
	        var _this = _possibleConstructorReturn(this, (OrderSummary.__proto__ || Object.getPrototypeOf(OrderSummary)).call(this, props));
	
	        _this.subscriptionRef = null;
	
	        _this.state = {
	            paymentOption: null
	        };
	        return _this;
	    }
	
	    _createClass(OrderSummary, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            this.subscriptionRef = _paymentSelectionService2.default.selectedPaymentMethod$.subscribe(function (paymentOption) {
	                _this2.setState({
	                    paymentOption: paymentOption
	                });
	            });
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            this.subscriptionRef.unsubscribe();
	        }
	    }, {
	        key: 'onNext',
	        value: function onNext() {
	            // add here any generic logic for payment methods
	            this.state.paymentOption.ref.current.onNext();
	        }
	    }, {
	        key: 'getSubmitButtonLabel',
	        value: function getSubmitButtonLabel() {
	            var locale = this.props.locale;
	
	            return '' + _appTranslations2.default[locale]['pay-with'] + (this.state.paymentOption ? ' ' + this.state.paymentOption.name : '');
	        }
	    }, {
	        key: 'getOrderPropertiesMapper',
	        value: function getOrderPropertiesMapper() {
	            var thisOrder = this.props.order;
	            var ItemOrderNumber = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'order-number', defaultMessage: 'Orden no.' });
	            var ItemTotalRep = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'itemTotal', defaultMessage: 'Item Total' });
	            var adjustmentTotalRep = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'adjustmentTotal', defaultMessage: 'Adjustment Total' });
	            var shippingTotalRep = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'shippingTotal', defaultMessage: 'Shipping Total' });
	            var orderTotalRep = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'orderTotal', defaultMessage: 'Order Total' });
	
	            if (this.props.placedOrder && this.props.placedOrder.id) {
	                thisOrder = this.props.placedOrder;
	            }
	
	            var orderPropertiesMapper = [];
	            var isValidStep = this.props.isCheckoutSummary ? _checkoutStepCalculator2.default.isValidStep(thisOrder.checkout_steps, this.props.currentCheckoutStep) : true;
	
	            // debugger
	            if (isValidStep || !this.props.isCheckoutSummary) {
	                orderPropertiesMapper.push([ItemOrderNumber, thisOrder.number]);
	
	                orderPropertiesMapper.push([ItemTotalRep, thisOrder.display_item_total]);
	
	                // eslint-disable-next-line radix
	                if (parseFloat(thisOrder.adjustment_total) > 0) {
	                    orderPropertiesMapper.push([adjustmentTotalRep, thisOrder.display_adjustment_total]);
	                }
	            }
	
	            if (this.props.isCheckoutSummary) {
	                if (thisOrder.checkout_steps.indexOf(this.props.currentCheckoutStep) >= 1) {
	                    orderPropertiesMapper.push([shippingTotalRep, thisOrder.display_ship_total]);
	                }
	            } else {
	                orderPropertiesMapper.push([shippingTotalRep, thisOrder.display_ship_total]);
	            }
	
	            orderPropertiesMapper.push([orderTotalRep, thisOrder.display_total]);
	
	            return orderPropertiesMapper;
	        }
	    }, {
	        key: 'mapPropertiesToTable',
	        value: function mapPropertiesToTable() {
	            var orderPropertiesMapper = this.getOrderPropertiesMapper();
	            return orderPropertiesMapper.map(function (property, idx) {
	                return _react2.default.createElement(
	                    'tr',
	                    { key: 'order-prop-' + idx },
	                    _react2.default.createElement(
	                        'td',
	                        null,
	                        _react2.default.createElement(
	                            'label',
	                            null,
	                            property[0]
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'td',
	                        null,
	                        property[1]
	                    )
	                );
	            });
	        }
	    }, {
	        key: 'backToPrevStep',
	        value: function backToPrevStep() {
	            window.scrollTo(0, 0);
	            _store2.default.dispatch(_actions2.default.goToPrevStep(this.props.order, this.props.locale, 'payment'));
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            var _spreeStore$getState = _store2.default.getState();
	
	            var currentCheckoutStep = _spreeStore$getState.currentCheckoutStep;
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'checkout-order-details ' + this.props.className },
	                _react2.default.createElement(
	                    _reactBootstrap.Panel,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Panel.Heading,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Panel.Title,
	                            { componentClass: 'h3' },
	                            _react2.default.createElement(
	                                'b',
	                                null,
	                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'summaryHeader', defaultMessage: 'Order Summary' })
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Table,
	                        null,
	                        _react2.default.createElement(
	                            'tbody',
	                            null,
	                            this.mapPropertiesToTable()
	                        )
	                    ),
	                    currentCheckoutStep === 'payment' && this.state.paymentOption && _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement('hr', null),
	                        _react2.default.createElement(
	                            'button',
	                            {
	                                type: 'submit',
	                                className: 'button--outlined',
	                                disabled: !this.state.paymentOption.ref.current || !this.state.paymentOption.ref.current.shouldNextBeEnabled(),
	                                style: { width: '100%', height: 'auto', fontSize: 16 },
	                                onClick: function onClick() {
	                                    _this3.onNext();
	                                }
	                            },
	                            this.getSubmitButtonLabel()
	                        ),
	                        _react2.default.createElement(
	                            'button',
	                            {
	                                onClick: function onClick() {
	                                    _this3.backToPrevStep();
	                                },
	                                type: 'button',
	                                className: 'btn btn-link',
	                                style: { width: '100%' }
	                            },
	                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'back', defaultMessage: 'Back' })
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return OrderSummary;
	}(_react.Component);
	
	exports.default = (0, _reactIntl.injectIntl)(OrderSummary);
	
	
	OrderSummary.defaultProps = {
	    isCheckoutSummary: true,
	    className: ''
	};
	
	OrderSummary.propTypes = {
	    isCheckoutSummary: _propTypes.bool,
	    className: _propTypes.string
	};

/***/ },
/* 354 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(38);
	
	var _reactIntl = __webpack_require__(11);
	
	var _validators = __webpack_require__(104);
	
	var _validators2 = _interopRequireDefault(_validators);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ExtraDataModal(props) {
	    var _useState = (0, _react.useState)(null);
	
	    var _useState2 = _slicedToArray(_useState, 2);
	
	    var currentErrorMessage = _useState2[0];
	    var setCurrentErrorMessage = _useState2[1];
	
	
	    var inputRef = _react2.default.createRef();
	
	    var styles = {
	        errorMessage: {
	            color: '#dc3545'
	        },
	        errorInput: {
	            borderColor: '#dc3545'
	        },
	        phoneStart: {
	            position: 'absolute',
	            left: '28px',
	            top: '46px'
	        },
	        phoneInput: {
	            paddingLeft: '40px'
	        }
	    };
	
	    var isValid = function isValid() {
	        if (props.isRequired && (inputRef.current.value === '' || inputRef.current.value === null)) {
	            setCurrentErrorMessage(_react2.default.createElement(_reactIntl.FormattedMessage, { id: 'required-message', defaultMessage: 'Required' }));
	            return false;
	        }
	        if (props.fieldType === 'phone' && (_validators2.default.phone(inputRef.current.value) !== undefined || inputRef.current.value.length !== 8)) {
	            setCurrentErrorMessage(_react2.default.createElement(_reactIntl.FormattedMessage, { id: 'invalid-phone-number', defaultMessage: 'Invalid phone number' }));
	            return false;
	        }
	        setCurrentErrorMessage(null);
	        return true;
	    };
	
	    /**
	     * @param {string} response ['accept' | 'cancel']
	     */
	    var onResponse = function onResponse(response) {
	        if (response === 'accept' && !isValid()) {
	            return;
	        }
	        props.onResponse(response, inputRef.current.value);
	    };
	
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	            _reactBootstrap.Modal,
	            {
	                show: true,
	                size: 'sm'
	            },
	            _react2.default.createElement(
	                _reactBootstrap.Modal.Header,
	                null,
	                _react2.default.createElement(
	                    _reactBootstrap.Modal.Title,
	                    { id: 'contained-modal-title-lg' },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'extra-data-modal-title', defaultMessage: 'We need more information to add this product' })
	                )
	            ),
	            _react2.default.createElement(
	                _reactBootstrap.Modal.Body,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                        'label',
	                        { htmlFor: props.fieldType, className: 'form-label' },
	                        props.label
	                    ),
	                    props.fieldType === 'phone' && _react2.default.createElement(
	                        'span',
	                        { style: styles.phoneStart },
	                        '+53 '
	                    ),
	                    _react2.default.createElement('input', {
	                        ref: inputRef,
	                        required: props.isRequired,
	                        type: 'text',
	                        className: 'form-control',
	                        id: props.fieldType,
	                        maxLength: props.fieldType === 'phone' ? '8' : false,
	                        style: _extends({}, currentErrorMessage && styles.errorInput, props.fieldType === 'phone' && styles.phoneInput),
	                        onChange: function onChange() {
	                            return isValid();
	                        }
	                    }),
	                    currentErrorMessage && _react2.default.createElement(
	                        'div',
	                        { className: 'invalid-feedback', style: styles.errorMessage },
	                        currentErrorMessage
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                _reactBootstrap.Modal.Footer,
	                null,
	                _react2.default.createElement(
	                    'button',
	                    { type: 'button', style: { marginRight: '15px' }, className: 'button-secondary button-small', onClick: function onClick() {
	                            return onResponse('accept');
	                        } },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'modal-zoneSelect-accept', defaultMessage: 'Accept' })
	                ),
	                _react2.default.createElement(
	                    'button',
	                    { type: 'button', className: 'button-cancel button-small', onClick: function onClick() {
	                            return onResponse('cancel');
	                        } },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'modal-zoneSelect-cancel', defaultMessage: 'Cancel' })
	                )
	            )
	        )
	    );
	}
	
	exports.default = ExtraDataModal;

/***/ },
/* 355 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(11);
	
	var _stripe = __webpack_require__(1625);
	
	var _stripe2 = _interopRequireDefault(_stripe);
	
	var _sslgray = __webpack_require__(1624);
	
	var _sslgray2 = _interopRequireDefault(_sslgray);
	
	var _seccondgray = __webpack_require__(1621);
	
	var _seccondgray2 = _interopRequireDefault(_seccondgray);
	
	var _privacygray = __webpack_require__(1620);
	
	var _privacygray2 = _interopRequireDefault(_privacygray);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function SecurityPaymentIcons(props) {
	    return _react2.default.createElement(
	        'ul',
	        { className: 'list-inline' },
	        _react2.default.createElement(
	            'li',
	            { style: { marginRight: '5px' } },
	            _react2.default.createElement('img', {
	                src: _sslgray2.default,
	                alt: props.intl.formatMessage({
	                    id: 'secure-checkout',
	                    defaultMessage: 'Secure Checkout'
	                }),
	                style: { width: 'auto', height: '30px' }
	            })
	        ),
	        _react2.default.createElement(
	            'li',
	            { style: { marginRight: '5px' } },
	            _react2.default.createElement('img', {
	                src: _seccondgray2.default,
	                alt: props.intl.formatMessage({
	                    id: 'secure-connection',
	                    defaultMessage: 'Secure Connection'
	                }),
	                style: { width: 'auto', height: '30px' }
	            })
	        ),
	        _react2.default.createElement(
	            'li',
	            { style: { marginRight: '5px' } },
	            _react2.default.createElement('img', {
	                src: _privacygray2.default,
	                alt: props.intl.formatMessage({
	                    id: 'privacy-protected',
	                    defaultMessage: 'Privacy Protected'
	                }),
	                style: { width: 'auto', height: '30px' }
	            })
	        )
	    );
	}
	
	exports.default = (0, _reactIntl.injectIntl)(SecurityPaymentIcons);

/***/ },
/* 356 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(38);
	
	var _reactIntl = __webpack_require__(11);
	
	var _reactRouterDom = __webpack_require__(26);
	
	var _appRoutes = __webpack_require__(22);
	
	var _appRoutes2 = _interopRequireDefault(_appRoutes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = function (_ref) {
	    var _onChange = _ref.onChange;
	    return _react2.default.createElement(
	        _reactBootstrap.Checkbox,
	        { onChange: function onChange(e) {
	                return _onChange(e.target.checked);
	            }, className: 'checkbox ' },
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'modal-kwallet-activate-accept', defaultMessage: 'Acepto los' }),
	        '\xA0',
	        _react2.default.createElement(
	            _reactRouterDom.Link,
	            { to: _appRoutes2.default.terms, target: '_blank', className: 'modal-links' },
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'modal-kwallet-activate-terms', defaultMessage: 'Terminos y condiciones' })
	        ),
	        '\xA0',
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'modal-kwallet-activate-and', defaultMessage: 'y' }),
	        '\xA0',
	        _react2.default.createElement(
	            _reactRouterDom.Link,
	            { to: _appRoutes2.default.affidavitCertification, target: '_blank', className: 'modal-links' },
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'modal-kwallet-activate-affidavit', defaultMessage: 'Affidavit Certification' })
	        )
	    );
	};

/***/ },
/* 357 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(26);
	
	var _appDefaults = __webpack_require__(39);
	
	var _appDefaults2 = _interopRequireDefault(_appDefaults);
	
	var _appRoutes = __webpack_require__(22);
	
	var _appRoutes2 = _interopRequireDefault(_appRoutes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ClearFilter = function ClearFilter(props) {
	    return _react2.default.createElement(
	        'div',
	        { className: 'col-xs-10 col-sm-10 col-md-10', style: { marginBottom: 10, marginTop: 5 }, onClick: function onClick() {
	                return props.setParams();
	            } },
	        _react2.default.createElement(
	            _reactRouterDom.Link,
	            {
	                to: { pathname: _appRoutes2.default.searchPageRoute },
	                className: 'pull-right',
	                style: {
	                    color: _appDefaults2.default.theme.clearFilterColor, fontWeight: 'bold', fontSize: 12, fontFamily: 'Lato Bold'
	                }
	            },
	            props.title
	        )
	    );
	};
	
	exports.default = ClearFilter;

/***/ },
/* 358 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var Menu = {
	    buildMenu: function buildMenu(zones, stores) {
	        var tmpMenu = zones.map(function (zone) {
	            var zoneTmp = {
	                type: 'second_level',
	                label: zone.name,
	                id: zone.id,
	                items: []
	            };
	
	            if (stores[zone.id]) {
	                zoneTmp.items = stores[zone.id].map(function (item) {
	                    var store = {
	                        id: item.id,
	                        label: item.name
	                    };
	                    return store;
	                });
	            }
	            return zoneTmp;
	        });
	        return tmpMenu;
	    }
	};
	
	exports.default = Menu;

/***/ },
/* 359 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxLazyScroll = __webpack_require__(2002);
	
	var _reduxLazyScroll2 = _interopRequireDefault(_reduxLazyScroll);
	
	var _loader = __webpack_require__(65);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _infiniteScroller = __webpack_require__(2159);
	
	var _infiniteScroller2 = _interopRequireDefault(_infiniteScroller);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var InfiniteScroller = function (_Component) {
	    _inherits(InfiniteScroller, _Component);
	
	    function InfiniteScroller(props) {
	        _classCallCheck(this, InfiniteScroller);
	
	        var _this = _possibleConstructorReturn(this, (InfiniteScroller.__proto__ || Object.getPrototypeOf(InfiniteScroller)).call(this, props));
	
	        _this.state = {
	            loadingMore: false
	        };
	
	        _this.loadMore = _this.loadMore.bind(_this);
	        return _this;
	    }
	
	    _createClass(InfiniteScroller, [{
	        key: 'loadMore',
	        value: function loadMore() {
	            var _this2 = this;
	
	            this.setState({
	                loadingMore: true
	            });
	
	            this.props.loadMore().then(function () {
	                _this2.setState({ loadingMore: false });
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { className: 'posts-lazy-scroll' },
	                _react2.default.createElement(
	                    _reduxLazyScroll2.default,
	                    {
	                        isFetching: this.state.loadingMore,
	                        loadMore: this.loadMore,
	                        hasMore: this.props.pageCount > this.props.currentPage
	                    },
	                    this.props.children
	                ),
	                this.state.loadingMore && _react2.default.createElement(
	                    'div',
	                    { className: '' + _infiniteScroller2.default.scroller },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'title-section text-center ' + _infiniteScroller2.default.scrollerTitle },
	                        _react2.default.createElement(
	                            'div',
	                            null,
	                            _react2.default.createElement(_loader2.default, { displayLoader: this.state.loadingMore, size: 20 })
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return InfiniteScroller;
	}(_react.Component);
	
	exports.default = InfiniteScroller;

/***/ },
/* 360 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(26);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MenuLink = function MenuLink(props) {
	    return _react2.default.createElement(
	        'li',
	        {
	            onClick: props.setParams,
	            className: props.className,
	            style: props.style
	        },
	        _react2.default.createElement(
	            _reactRouterDom.NavLink,
	            {
	                to: {
	                    pathname: props.pathname,
	                    search: props.search
	                },
	                isActive: props.isActive
	            },
	            props.name
	        )
	    );
	};
	
	exports.default = MenuLink;

/***/ },
/* 361 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(11);
	
	var _reduxForm = __webpack_require__(61);
	
	var _signin = __webpack_require__(138);
	
	var _signin2 = _interopRequireDefault(_signin);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var rxEmailValidator = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+[.]{1}[a-zA-Z]{2,}$/;
	
	// eslint-disable-next-line import/no-mutable-exports
	var SignInForm = function SignInForm(props) {
	    var intl = props.intl;
	    var valid = props.valid;
	    var submitting = props.submitting;
	    var handleSubmit = props.handleSubmit;
	
	    var _useState = (0, _react.useState)({
	        showPassword: true,
	        rememberMe: true,
	        isEmailError: false,
	        user: {
	            email: '',
	            password: ''
	        },
	        isShowCode: false
	    });
	
	    var _useState2 = _slicedToArray(_useState, 2);
	
	    var state = _useState2[0];
	    var setState = _useState2[1];
	
	
	    var onSubmit = function onSubmit(formData) {
	        setState(_extends({}, state, {
	            isShowCode: true
	        }));
	        props.onSubmitCallback(formData);
	    };
	
	    var toggleShowPassword = function toggleShowPassword() {
	        setState(_extends({}, state, {
	            showPassword: !state.showPassword
	        }));
	    };
	
	    var toggleRememberMe = function toggleRememberMe() {
	        setState(_extends({}, state, {
	            rememberMe: !state.rememberMe
	        }));
	    };
	
	    var handleInputChange = function handleInputChange(e) {
	        var _e$target = e.target;
	        var name = _e$target.name;
	        var value = _e$target.value;
	
	        setState(_extends({}, state, {
	            isEmailError: name === 'user[email]' ? !rxEmailValidator.test(value) : state.isEmailError,
	            user: {
	                email: name === 'user[email]' ? value : state.user.email,
	                password: name === 'user[password]' ? value : state.user.password
	            }
	        }));
	    };
	
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	            'form',
	            {
	                className: _signin2.default.form,
	                onSubmit: handleSubmit(onSubmit)
	            },
	            _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'form-group ' + _signin2.default.formGroup },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-lg-12 col-md-12 col-sm-12 col-xs-12 holder', style: { paddingBottom: '5px' } },
	                        _react2.default.createElement(_reduxForm.Field, {
	                            disabled: state.isShowCode,
	                            className: _signin2.default.formInput,
	                            name: 'user[email]',
	                            component: 'input',
	                            type: 'text',
	                            autoComplete: 'off',
	                            placeholder: intl.formatMessage({
	                                id: 'email-address',
	                                defaultMessage: 'Email Address'
	                            }),
	                            onChange: function onChange(e) {
	                                handleInputChange(e);
	                            },
	                            style: {
	                                opacity: state.isShowCode ? '0.5' : ''
	                                // borderColor: state.isEmailError ? 'red' : '',
	                            }
	                        }),
	                        state.isEmailError && _react2.default.createElement(
	                            'span',
	                            { style: {
	                                    position: 'absolute',
	                                    bottom: '0',
	                                    color: '#d3af71',
	                                    fontSize: '12px',
	                                    paddingLeft: '6px'
	                                }
	                            },
	                            _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                id: 'invalid-email-address',
	                                defaultMessage: 'Invalid email address.'
	                            })
	                        )
	                    )
	                ),
	                !state.isShowCode && _react2.default.createElement(
	                    'span',
	                    {
	                        style: {
	                            display: 'flex',
	                            textAlign: 'justify',
	                            marginBottom: '15px',
	                            padding: '0 5px',
	                            fontWeight: 600,
	                            color: '#999'
	                        }
	                    },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                        id: 'send-message-code-by-email',
	                        defaultMessage: 'An email will be sent to your email account with a temporary access code to start the section.'
	                    })
	                ),
	                state.isShowCode && _react2.default.createElement(
	                    'div',
	                    { className: 'form-group ' + _signin2.default.formGroup },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-lg-12 col-md-12 col-sm-12 col-xs-12 ' + _signin2.default.inputGroupEdited },
	                        _react2.default.createElement(_reduxForm.Field, {
	                            className: _signin2.default.formInput,
	                            name: 'user[password]',
	                            component: 'input',
	                            autoComplete: 'off',
	                            type: state.showPassword ? 'text' : 'password',
	                            placeholder: intl.formatMessage({
	                                id: 'code',
	                                defaultMessage: 'Code'
	                            }),
	                            onChange: function onChange(e) {
	                                handleInputChange(e);
	                            }
	                        })
	                    )
	                ),
	                state.isShowCode && _react2.default.createElement(
	                    'span',
	                    {
	                        style: {
	                            display: 'flex',
	                            textAlign: 'justify',
	                            marginBottom: '15px',
	                            padding: '0 5px',
	                            fontWeight: 600,
	                            color: '#999'
	                        }
	                    },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                        id: 'send-message-code-by-email-finished',
	                        defaultMessage: 'An email has been sent to your email account with a temporary access code to start the section.'
	                    })
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'form-group ' + _signin2.default.formGroupHolder },
	                _react2.default.createElement(
	                    'button',
	                    {
	                        className: 'form-control btn btn-default',
	                        type: 'submit',
	                        disabled: !valid || submitting || state.isEmailError || !state.user.password && state.isShowCode || !state.user.email
	                    },
	                    !state.isShowCode && _react2.default.createElement(
	                        'span',
	                        null,
	                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'send-code-to-email', defaultMessage: 'Send code to email' })
	                    ),
	                    state.isShowCode && _react2.default.createElement(
	                        'span',
	                        null,
	                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'signin', defaultMessage: 'Sign In' })
	                    )
	                )
	            )
	        )
	    );
	};
	
	SignInForm = (0, _reduxForm.reduxForm)({
	    form: 'signIn'
	})(SignInForm);
	
	exports.default = (0, _reactIntl.injectIntl)(SignInForm);

/***/ },
/* 362 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _urlSanitizer = __webpack_require__(123);
	
	var _urlSanitizer2 = _interopRequireDefault(_urlSanitizer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var StoreTile = function StoreTile(_ref) {
	    var name = _ref.name;
	    var styles = _ref.styles;
	    var logo = _ref.logo;
	    return _react2.default.createElement('img', {
	        className: styles,
	        alt: name,
	        src: _urlSanitizer2.default.makeAbsolute(logo)
	    });
	};
	
	exports.default = StoreTile;

/***/ },
/* 363 */
/***/ function(module, exports) {

	'use strict';
	
	var PHONE_PREFIX = '+53';
	
	module.exports = {
	    PHONE_PREFIX: PHONE_PREFIX,
	    HTTP_ERRORS: {
	        HTTP_418: 418,
	        HTTP_422: 422
	    }
	};

/***/ },
/* 364 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.LOCALE_FLAGS = undefined;
	
	var _us = __webpack_require__(1628);
	
	var _us2 = _interopRequireDefault(_us);
	
	var _es = __webpack_require__(1614);
	
	var _es2 = _interopRequireDefault(_es);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Flags
	var SUPPORTED_LOCALES = {
	    en: 'English',
	    es: 'Spanish'
	};
	
	var LOCALE_FLAGS = {
	    en: _us2.default,
	    es: _es2.default
	};
	
	exports.default = SUPPORTED_LOCALES;
	exports.LOCALE_FLAGS = LOCALE_FLAGS;

/***/ },
/* 365 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reactRedux = __webpack_require__(18);
	
	var _reactRouterRedux = __webpack_require__(30);
	
	var _actions = __webpack_require__(23);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	var _appActions = __webpack_require__(21);
	
	var _appActions2 = _interopRequireDefault(_appActions);
	
	var _paymentForm = __webpack_require__(670);
	
	var _paymentForm2 = _interopRequireDefault(_paymentForm);
	
	var _checkoutStepCalculator = __webpack_require__(54);
	
	var _checkoutStepCalculator2 = _interopRequireDefault(_checkoutStepCalculator);
	
	var _appRoutes = __webpack_require__(22);
	
	var _appRoutes2 = _interopRequireDefault(_appRoutes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	    return {
	        order: state.order,
	        placedOrder: state.placedOrder,
	        locale: state.locale,
	        displayPreview: false,
	        hasBackButton: false,
	        isReadOnly: state.order.isCreditCardValidated,
	        displayLoader: state.displayLoader
	    };
	};
	// eslint-disable-next-line import/no-cycle
	
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        setCurrentCheckoutStep: function setCurrentCheckoutStep() {
	            dispatch({
	                type: _appActions2.default.SET_CURRENT_CHECKOUT_STEP,
	                payload: 'payment'
	            });
	        },
	
	        handlePaymentFormSubmit: function handlePaymentFormSubmit(formData, order, locale) {
	            return dispatch(_actions2.default.goToNextStep(order, locale, formData, false));
	        },
	
	        handleCheckoutStepNotEditable: function handleCheckoutStepNotEditable(order, placedOrder) {
	            /* Redirect to last step if order is already placed */
	            if (placedOrder.id) {
	                dispatch((0, _reactRouterRedux.push)(_appRoutes2.default.checkout[placedOrder.checkout_steps.slice(-1) + 'PageRoute']));
	            } else if (order.id) {
	                var previousStep = _checkoutStepCalculator2.default.previous(order.checkout_steps, 'payment');
	
	                dispatch((0, _reactRouterRedux.push)(_appRoutes2.default.checkout[previousStep + 'PageRoute']));
	            } else {
	                dispatch((0, _reactRouterRedux.push)(_appRoutes2.default.cartPageRoute));
	            }
	        },
	
	        handleCreditCardChange: function handleCreditCardChange() {
	            dispatch({
	                type: _appActions2.default.VALIDATE_CREDIT_CARD,
	                payload: false
	            });
	        },
	
	        handleSaveCreditCardSuccess: function handleSaveCreditCardSuccess() {
	            dispatch({
	                type: _appActions2.default.VALIDATE_CREDIT_CARD,
	                payload: true
	            });
	        },
	
	        redirectToCart: function redirectToCart() {
	            return dispatch((0, _reactRouterRedux.push)(_appRoutes2.default.cartPageRoute));
	        },
	
	        showFormErrors: function showFormErrors(errorNode) {
	            // dispatch(Actions.showFlash(errorNode, 'danger'));
	        }
	    };
	};
	
	var PaymentFormConnector = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_paymentForm2.default);
	
	exports.default = PaymentFormConnector;

/***/ },
/* 366 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reactRedux = __webpack_require__(18);
	
	var _actions = __webpack_require__(23);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	var _localeSelector = __webpack_require__(725);
	
	var _localeSelector2 = _interopRequireDefault(_localeSelector);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	    return {
	        currentLocale: state.locale.currentLocale
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        setLocale: function setLocale(locale) {
	            dispatch(_actions2.default.setLocale(locale));
	        }
	    };
	};
	
	var LocaleSelectorConnector = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_localeSelector2.default);
	
	exports.default = LocaleSelectorConnector;

/***/ },
/* 367 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reactRedux = __webpack_require__(18);
	
	var _reactRouterRedux = __webpack_require__(30);
	
	var _reactReduxToastr = __webpack_require__(42);
	
	var _userSignup = __webpack_require__(735);
	
	var _userSignup2 = _interopRequireDefault(_userSignup);
	
	var _actions = __webpack_require__(23);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	var _user = __webpack_require__(102);
	
	var _user2 = _interopRequireDefault(_user);
	
	var _appRoutes = __webpack_require__(22);
	
	var _appRoutes2 = _interopRequireDefault(_appRoutes);
	
	var _appTranslations = __webpack_require__(33);
	
	var _appTranslations2 = _interopRequireDefault(_appTranslations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	    return {
	        locale: state.locale
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        submitSignupForm: function submitSignupForm(formData, locale) {
	            dispatch(_actions2.default.displayLoader());
	
	            var signupPromise = _user2.default.signup({ data: formData, locale: locale });
	
	            signupPromise.then(function (response) {
	                dispatch(_actions2.default.hideLoader());
	                dispatch(_actions2.default.login(response.body, locale));
	                _reactReduxToastr.toastr.success(_appTranslations2.default[locale].well, _appTranslations2.default[locale]['successfully-registered']);
	                dispatch((0, _reactRouterRedux.push)(_appRoutes2.default.homePageRoute));
	                // dispatch(Actions.showFlash('Successfully registered'));
	            }, function (error) {
	                if (error.response.body.error) {
	                    _reactReduxToastr.toastr.error(_appTranslations2.default[locale].error, error.response.body.error);
	                } else {
	                    _reactReduxToastr.toastr.error(_appTranslations2.default[locale].error, _appTranslations2.default[locale]['registration-error']);
	                }
	                dispatch(_actions2.default.logout());
	                dispatch(_actions2.default.hideLoader());
	            });
	
	            return signupPromise;
	        }
	    };
	};
	
	var UserSignupConnector = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_userSignup2.default);
	
	exports.default = UserSignupConnector;

/***/ },
/* 368 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ErrorMessageFormatter = {
	    formatFormSubmissionErrors: function formatFormSubmissionErrors(errors) {
	        var title = 'Please fix the below errors.';
	
	        var errorMessageList = errors.map(function (error, idx) {
	            return _react2.default.createElement(
	                'li',
	                { key: idx },
	                error
	            );
	        });
	
	        return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	                'h4',
	                null,
	                title
	            ),
	            _react2.default.createElement(
	                'ul',
	                null,
	                errorMessageList
	            )
	        );
	    }
	};
	
	exports.default = ErrorMessageFormatter;

/***/ },
/* 369 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var LineItemsModel = {
	    variant: function variant(variantId) {
	        var items = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	        return items.filter(function (item) {
	            return item.type === 'variant' && variantId === item.id;
	        })[0];
	    },
	
	    lineItems: function lineItems(lineItemsIds) {
	        var items = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	        return items.filter(function (item) {
	            return item.type === 'line_item' && lineItemsIds.indexOf(item.id) !== -1;
	        });
	    },
	
	    images: function images(imagesIds) {
	        var items = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	        return items.filter(function (item) {
	            return item.type === 'image' && imagesIds.indexOf(item.id) !== -1;
	        });
	    },
	
	    product: function product(productId) {
	        var items = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	        return items.filter(function (item) {
	            return item.type === 'product' && productId === item.id;
	        })[0];
	    },
	
	    data_extras: function data_extras(dataExtrasIds) {
	        var items = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	        return items.filter(function (item) {
	            return item.type === 'data_extra' && dataExtrasIds.indexOf(item.id) !== -1;
	        });
	    },
	
	    data_extra_types: function data_extra_types(dataExtrasIds) {
	        var items = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	        return items.filter(function (item) {
	            return item.type === 'data_extra_type' && dataExtrasIds.indexOf(parseInt(item.id, 10)) !== -1;
	        });
	    }
	
	};
	
	exports.default = LineItemsModel;

/***/ },
/* 370 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var OrderModel = {
	    shippingRates: function shippingRates(shippingRateIds) {
	        var items = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	        return items.filter(function (item) {
	            return item.type === 'shipping_rate' && shippingRateIds.indexOf(item.id) !== -1;
	        });
	    },
	
	    selectedShippingRate: function selectedShippingRate(shippingRateIds) {
	        var items = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	        return items.filter(function (item) {
	            return item.type === 'shipping_rate' && shippingRateIds.indexOf(item.id) !== -1 && item.attributes.selected;
	        });
	    },
	
	    find: function find(orderId) {
	        var orders = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	
	        var radix = 10;
	        return orders.find(function (order) {
	            return parseInt(order.id, radix) === parseInt(orderId, radix);
	        });
	    }
	};
	
	exports.default = OrderModel;

/***/ },
/* 371 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _rxjs = __webpack_require__(2009);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PaymentSelectionService = function PaymentSelectionService() {
	    _classCallCheck(this, PaymentSelectionService);
	};
	
	PaymentSelectionService.selectedPaymentMethod$ = new _rxjs.Subject();
	exports.default = PaymentSelectionService;

/***/ },
/* 372 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _appTranslations = __webpack_require__(33);
	
	var _appTranslations2 = _interopRequireDefault(_appTranslations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TimeParse = {
	    fromSeconds: function fromSeconds(seconds) {
	        if (seconds <= 0) {
	            return '';
	        }
	
	        var dateLeft = new Date(seconds * 1000).toISOString();
	        if (seconds < 3600) {
	            return dateLeft.substr(14, 5);
	        }
	        return dateLeft.substr(11, 8);
	    },
	    fromSecondsToText: function fromSecondsToText(seconds, locale) {
	        var result = '';
	        var minutes = Math.floor(seconds / 60);
	        result = minutes + ' ' + (minutes > 1 ? _appTranslations2.default[locale]['time-minute-plural'] : _appTranslations2.default[locale]['time-minute-singular']);
	        var secondsRest = seconds - minutes * 60;
	        if (secondsRest > 0) {
	            result += ' ' + secondsRest + ' ' + (secondsRest > 1 ? _appTranslations2.default[locale]['time-second-plural'] : _appTranslations2.default[locale]['time-second-singular']);
	        }
	        return result;
	    }
	};
	
	exports.default = TimeParse;

/***/ },
/* 373 */
/***/ function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ },
/* 374 */
/***/ function(module, exports) {

	module.exports = function (it, Constructor, name, forbiddenField) {
	  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
	    throw TypeError(name + ': incorrect invocation!');
	  } return it;
	};


/***/ },
/* 375 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(69);
	var document = __webpack_require__(68).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ },
/* 376 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(76) && !__webpack_require__(87)(function () {
	  return Object.defineProperty(__webpack_require__(375)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ },
/* 377 */
/***/ function(module, exports, __webpack_require__) {

	// check on default Array iterator
	var Iterators = __webpack_require__(144);
	var ITERATOR = __webpack_require__(70)('iterator');
	var ArrayProto = Array.prototype;
	
	module.exports = function (it) {
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};


/***/ },
/* 378 */
/***/ function(module, exports, __webpack_require__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(86);
	module.exports = function (iterator, fn, value, entries) {
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch (e) {
	    var ret = iterator['return'];
	    if (ret !== undefined) anObject(ret.call(iterator));
	    throw e;
	  }
	};


/***/ },
/* 379 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(183);
	var $export = __webpack_require__(49);
	var redefine = __webpack_require__(260);
	var hide = __webpack_require__(89);
	var Iterators = __webpack_require__(144);
	var $iterCreate = __webpack_require__(847);
	var setToStringTag = __webpack_require__(185);
	var getPrototypeOf = __webpack_require__(852);
	var ITERATOR = __webpack_require__(70)('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';
	
	var returnThis = function () { return this; };
	
	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function (kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS: return function keys() { return new Constructor(this, kind); };
	      case VALUES: return function values() { return new Constructor(this, kind); };
	    } return function entries() { return new Constructor(this, kind); };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = $native || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() { return $native.call(this); };
	  }
	  // Define iterator
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};


/***/ },
/* 380 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var DESCRIPTORS = __webpack_require__(76);
	var getKeys = __webpack_require__(125);
	var gOPS = __webpack_require__(259);
	var pIE = __webpack_require__(145);
	var toObject = __webpack_require__(126);
	var IObject = __webpack_require__(255);
	var $assign = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(87)(function () {
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line no-undef
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) { B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
	  var T = toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = gOPS.f;
	  var isEnum = pIE.f;
	  while (aLen > index) {
	    var S = IObject(arguments[index++]);
	    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) {
	      key = keys[j++];
	      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
	    }
	  } return T;
	} : $assign;


/***/ },
/* 381 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys = __webpack_require__(382);
	var hiddenKeys = __webpack_require__(253).concat('length', 'prototype');
	
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return $keys(O, hiddenKeys);
	};


/***/ },
/* 382 */
/***/ function(module, exports, __webpack_require__) {

	var has = __webpack_require__(88);
	var toIObject = __webpack_require__(90);
	var arrayIndexOf = __webpack_require__(838)(false);
	var IE_PROTO = __webpack_require__(261)('IE_PROTO');
	
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ },
/* 383 */
/***/ function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(49);
	var core = __webpack_require__(44);
	var fails = __webpack_require__(87);
	module.exports = function (KEY, exec) {
	  var fn = (core.Object || {})[KEY] || Object[KEY];
	  var exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
	};


/***/ },
/* 384 */
/***/ function(module, exports, __webpack_require__) {

	var DESCRIPTORS = __webpack_require__(76);
	var getKeys = __webpack_require__(125);
	var toIObject = __webpack_require__(90);
	var isEnum = __webpack_require__(145).f;
	module.exports = function (isEntries) {
	  return function (it) {
	    var O = toIObject(it);
	    var keys = getKeys(O);
	    var length = keys.length;
	    var i = 0;
	    var result = [];
	    var key;
	    while (length > i) {
	      key = keys[i++];
	      if (!DESCRIPTORS || isEnum.call(O, key)) {
	        result.push(isEntries ? [key, O[key]] : O[key]);
	      }
	    }
	    return result;
	  };
	};


/***/ },
/* 385 */
/***/ function(module, exports, __webpack_require__) {

	var hide = __webpack_require__(89);
	module.exports = function (target, src, safe) {
	  for (var key in src) {
	    if (safe && target[key]) target[key] = src[key];
	    else hide(target, key, src[key]);
	  } return target;
	};


/***/ },
/* 386 */
/***/ function(module, exports) {

	module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
	  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ },
/* 387 */
/***/ function(module, exports, __webpack_require__) {

	var classof = __webpack_require__(841);
	var ITERATOR = __webpack_require__(70)('iterator');
	var Iterators = __webpack_require__(144);
	module.exports = __webpack_require__(44).getIteratorMethod = function (it) {
	  if (it != undefined) return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};


/***/ },
/* 388 */
/***/ function(module, exports) {



/***/ },
/* 389 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $at = __webpack_require__(857)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(379)(String, 'String', function (iterated) {
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return { value: undefined, done: true };
	  point = $at(O, index);
	  this._i += point.length;
	  return { value: point, done: false };
	});


/***/ },
/* 390 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(862);
	var global = __webpack_require__(68);
	var hide = __webpack_require__(89);
	var Iterators = __webpack_require__(144);
	var TO_STRING_TAG = __webpack_require__(70)('toStringTag');
	
	var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
	  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
	  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
	  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
	  'TextTrackList,TouchList').split(',');
	
	for (var i = 0; i < DOMIterables.length; i++) {
	  var NAME = DOMIterables[i];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	  Iterators[NAME] = Iterators.Array;
	}


/***/ },
/* 391 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __assign = (this && this.__assign) || function () {
	    __assign = Object.assign || function(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	                t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	var cardTypes = __webpack_require__(879);
	var add_matching_cards_to_results_1 = __webpack_require__(878);
	var is_valid_input_type_1 = __webpack_require__(881);
	var find_best_match_1 = __webpack_require__(880);
	var clone_1 = __webpack_require__(392);
	var customCards = {};
	var cardNames = {
	    VISA: "visa",
	    MASTERCARD: "mastercard",
	    AMERICAN_EXPRESS: "american-express",
	    DINERS_CLUB: "diners-club",
	    DISCOVER: "discover",
	    JCB: "jcb",
	    UNIONPAY: "unionpay",
	    MAESTRO: "maestro",
	    ELO: "elo",
	    MIR: "mir",
	    HIPER: "hiper",
	    HIPERCARD: "hipercard",
	};
	var ORIGINAL_TEST_ORDER = [
	    cardNames.VISA,
	    cardNames.MASTERCARD,
	    cardNames.AMERICAN_EXPRESS,
	    cardNames.DINERS_CLUB,
	    cardNames.DISCOVER,
	    cardNames.JCB,
	    cardNames.UNIONPAY,
	    cardNames.MAESTRO,
	    cardNames.ELO,
	    cardNames.MIR,
	    cardNames.HIPER,
	    cardNames.HIPERCARD,
	];
	var testOrder = clone_1.clone(ORIGINAL_TEST_ORDER);
	function findType(cardType) {
	    return customCards[cardType] || cardTypes[cardType];
	}
	function getAllCardTypes() {
	    return testOrder.map(function (cardType) { return clone_1.clone(findType(cardType)); });
	}
	function getCardPosition(name, ignoreErrorForNotExisting) {
	    if (ignoreErrorForNotExisting === void 0) { ignoreErrorForNotExisting = false; }
	    var position = testOrder.indexOf(name);
	    if (!ignoreErrorForNotExisting && position === -1) {
	        throw new Error('"' + name + '" is not a supported card type.');
	    }
	    return position;
	}
	function creditCardType(cardNumber) {
	    var results = [];
	    if (!is_valid_input_type_1.isValidInputType(cardNumber)) {
	        return results;
	    }
	    if (cardNumber.length === 0) {
	        return getAllCardTypes();
	    }
	    testOrder.forEach(function (cardType) {
	        var cardConfiguration = findType(cardType);
	        add_matching_cards_to_results_1.addMatchingCardsToResults(cardNumber, cardConfiguration, results);
	    });
	    var bestMatch = find_best_match_1.findBestMatch(results);
	    if (bestMatch) {
	        return [bestMatch];
	    }
	    return results;
	}
	creditCardType.getTypeInfo = function (cardType) {
	    return clone_1.clone(findType(cardType));
	};
	creditCardType.removeCard = function (name) {
	    var position = getCardPosition(name);
	    testOrder.splice(position, 1);
	};
	creditCardType.addCard = function (config) {
	    var existingCardPosition = getCardPosition(config.type, true);
	    customCards[config.type] = config;
	    if (existingCardPosition === -1) {
	        testOrder.push(config.type);
	    }
	};
	creditCardType.updateCard = function (cardType, updates) {
	    var originalObject = customCards[cardType] || cardTypes[cardType];
	    if (!originalObject) {
	        throw new Error("\"" + cardType + "\" is not a recognized type. Use `addCard` instead.'");
	    }
	    if (updates.type && originalObject.type !== updates.type) {
	        throw new Error("Cannot overwrite type parameter.");
	    }
	    var clonedCard = clone_1.clone(originalObject);
	    clonedCard = __assign(__assign({}, clonedCard), updates);
	    customCards[clonedCard.type] = clonedCard;
	};
	creditCardType.changeOrder = function (name, position) {
	    var currentPosition = getCardPosition(name);
	    testOrder.splice(currentPosition, 1);
	    testOrder.splice(position, 0, name);
	};
	creditCardType.resetModifications = function () {
	    testOrder = clone_1.clone(ORIGINAL_TEST_ORDER);
	    customCards = {};
	};
	creditCardType.types = cardNames;
	module.exports = creditCardType;


/***/ },
/* 392 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.clone = void 0;
	function clone(originalObject) {
	    if (!originalObject) {
	        return null;
	    }
	    return JSON.parse(JSON.stringify(originalObject));
	}
	exports.clone = clone;


/***/ },
/* 393 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = assign;
	
	function assign(target, dirtyObject) {
	  if (target == null) {
	    throw new TypeError('assign requires that input parameter not be null or undefined');
	  }
	
	  dirtyObject = dirtyObject || {};
	
	  for (var property in dirtyObject) {
	    if (Object.prototype.hasOwnProperty.call(dirtyObject, property)) {
	      target[property] = dirtyObject[property];
	    }
	  }
	
	  return target;
	}
	
	module.exports = exports.default;

/***/ },
/* 394 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = cloneObject;
	
	var _index = _interopRequireDefault(__webpack_require__(393));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function cloneObject(dirtyObject) {
	  return (0, _index.default)({}, dirtyObject);
	}
	
	module.exports = exports.default;

/***/ },
/* 395 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(127));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	 * |     | Unit                           |     | Unit                           |
	 * |-----|--------------------------------|-----|--------------------------------|
	 * |  a  | AM, PM                         |  A* |                                |
	 * |  d  | Day of month                   |  D  |                                |
	 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
	 * |  m  | Minute                         |  M  | Month                          |
	 * |  s  | Second                         |  S  | Fraction of second             |
	 * |  y  | Year (abs)                     |  Y  |                                |
	 *
	 * Letters marked by * are not implemented but reserved by Unicode standard.
	 */
	var formatters = {
	  // Year
	  y: function (date, token) {
	    // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
	    // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
	    // |----------|-------|----|-------|-------|-------|
	    // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
	    // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
	    // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
	    // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
	    // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
	    var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)
	
	    var year = signedYear > 0 ? signedYear : 1 - signedYear;
	    return (0, _index.default)(token === 'yy' ? year % 100 : year, token.length);
	  },
	  // Month
	  M: function (date, token) {
	    var month = date.getUTCMonth();
	    return token === 'M' ? String(month + 1) : (0, _index.default)(month + 1, 2);
	  },
	  // Day of the month
	  d: function (date, token) {
	    return (0, _index.default)(date.getUTCDate(), token.length);
	  },
	  // AM or PM
	  a: function (date, token) {
	    var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';
	
	    switch (token) {
	      case 'a':
	      case 'aa':
	        return dayPeriodEnumValue.toUpperCase();
	
	      case 'aaa':
	        return dayPeriodEnumValue;
	
	      case 'aaaaa':
	        return dayPeriodEnumValue[0];
	
	      case 'aaaa':
	      default:
	        return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
	    }
	  },
	  // Hour [1-12]
	  h: function (date, token) {
	    return (0, _index.default)(date.getUTCHours() % 12 || 12, token.length);
	  },
	  // Hour [0-23]
	  H: function (date, token) {
	    return (0, _index.default)(date.getUTCHours(), token.length);
	  },
	  // Minute
	  m: function (date, token) {
	    return (0, _index.default)(date.getUTCMinutes(), token.length);
	  },
	  // Second
	  s: function (date, token) {
	    return (0, _index.default)(date.getUTCSeconds(), token.length);
	  },
	  // Fraction of second
	  S: function (date, token) {
	    var numberOfDigits = token.length;
	    var milliseconds = date.getUTCMilliseconds();
	    var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
	    return (0, _index.default)(fractionalSeconds, token.length);
	  }
	};
	var _default = formatters;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 396 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	function dateLongFormatter(pattern, formatLong) {
	  switch (pattern) {
	    case 'P':
	      return formatLong.date({
	        width: 'short'
	      });
	
	    case 'PP':
	      return formatLong.date({
	        width: 'medium'
	      });
	
	    case 'PPP':
	      return formatLong.date({
	        width: 'long'
	      });
	
	    case 'PPPP':
	    default:
	      return formatLong.date({
	        width: 'full'
	      });
	  }
	}
	
	function timeLongFormatter(pattern, formatLong) {
	  switch (pattern) {
	    case 'p':
	      return formatLong.time({
	        width: 'short'
	      });
	
	    case 'pp':
	      return formatLong.time({
	        width: 'medium'
	      });
	
	    case 'ppp':
	      return formatLong.time({
	        width: 'long'
	      });
	
	    case 'pppp':
	    default:
	      return formatLong.time({
	        width: 'full'
	      });
	  }
	}
	
	function dateTimeLongFormatter(pattern, formatLong) {
	  var matchResult = pattern.match(/(P+)(p+)?/) || [];
	  var datePattern = matchResult[1];
	  var timePattern = matchResult[2];
	
	  if (!timePattern) {
	    return dateLongFormatter(pattern, formatLong);
	  }
	
	  var dateTimeFormat;
	
	  switch (datePattern) {
	    case 'P':
	      dateTimeFormat = formatLong.dateTime({
	        width: 'short'
	      });
	      break;
	
	    case 'PP':
	      dateTimeFormat = formatLong.dateTime({
	        width: 'medium'
	      });
	      break;
	
	    case 'PPP':
	      dateTimeFormat = formatLong.dateTime({
	        width: 'long'
	      });
	      break;
	
	    case 'PPPP':
	    default:
	      dateTimeFormat = formatLong.dateTime({
	        width: 'full'
	      });
	      break;
	  }
	
	  return dateTimeFormat.replace('{{date}}', dateLongFormatter(datePattern, formatLong)).replace('{{time}}', timeLongFormatter(timePattern, formatLong));
	}
	
	var longFormatters = {
	  p: timeLongFormatter,
	  P: dateTimeLongFormatter
	};
	var _default = longFormatters;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 397 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getUTCISOWeek;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(188));
	
	var _index3 = _interopRequireDefault(__webpack_require__(936));
	
	var _index4 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MILLISECONDS_IN_WEEK = 604800000; // This function will be a part of public API when UTC function will be implemented.
	// See issue: https://github.com/date-fns/date-fns/issues/376
	
	function getUTCISOWeek(dirtyDate) {
	  (0, _index4.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var diff = (0, _index2.default)(date).getTime() - (0, _index3.default)(date).getTime(); // Round the number of days to the nearest integer
	  // because the number of milliseconds in a week is not constant
	  // (e.g. it's different in the week of the daylight saving time clock shift)
	
	  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
	}
	
	module.exports = exports.default;

/***/ },
/* 398 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getUTCISOWeekYear;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	var _index3 = _interopRequireDefault(__webpack_require__(188));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// This function will be a part of public API when UTC function will be implemented.
	// See issue: https://github.com/date-fns/date-fns/issues/376
	function getUTCISOWeekYear(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var year = date.getUTCFullYear();
	  var fourthOfJanuaryOfNextYear = new Date(0);
	  fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
	  fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
	  var startOfNextYear = (0, _index3.default)(fourthOfJanuaryOfNextYear);
	  var fourthOfJanuaryOfThisYear = new Date(0);
	  fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
	  fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
	  var startOfThisYear = (0, _index3.default)(fourthOfJanuaryOfThisYear);
	
	  if (date.getTime() >= startOfNextYear.getTime()) {
	    return year + 1;
	  } else if (date.getTime() >= startOfThisYear.getTime()) {
	    return year;
	  } else {
	    return year - 1;
	  }
	}
	
	module.exports = exports.default;

/***/ },
/* 399 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getUTCWeek;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(148));
	
	var _index3 = _interopRequireDefault(__webpack_require__(937));
	
	var _index4 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MILLISECONDS_IN_WEEK = 604800000; // This function will be a part of public API when UTC function will be implemented.
	// See issue: https://github.com/date-fns/date-fns/issues/376
	
	function getUTCWeek(dirtyDate, options) {
	  (0, _index4.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var diff = (0, _index2.default)(date, options).getTime() - (0, _index3.default)(date, options).getTime(); // Round the number of days to the nearest integer
	  // because the number of milliseconds in a week is not constant
	  // (e.g. it's different in the week of the daylight saving time clock shift)
	
	  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
	}
	
	module.exports = exports.default;

/***/ },
/* 400 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isProtectedDayOfYearToken = isProtectedDayOfYearToken;
	exports.isProtectedWeekYearToken = isProtectedWeekYearToken;
	exports.throwProtectedError = throwProtectedError;
	var protectedDayOfYearTokens = ['D', 'DD'];
	var protectedWeekYearTokens = ['YY', 'YYYY'];
	
	function isProtectedDayOfYearToken(token) {
	  return protectedDayOfYearTokens.indexOf(token) !== -1;
	}
	
	function isProtectedWeekYearToken(token) {
	  return protectedWeekYearTokens.indexOf(token) !== -1;
	}
	
	function throwProtectedError(token, format, input) {
	  if (token === 'YYYY') {
	    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://git.io/fxCyr"));
	  } else if (token === 'YY') {
	    throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://git.io/fxCyr"));
	  } else if (token === 'D') {
	    throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://git.io/fxCyr"));
	  } else if (token === 'DD') {
	    throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://git.io/fxCyr"));
	  }
	}

/***/ },
/* 401 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addBusinessDays;
	
	var _index = _interopRequireDefault(__webpack_require__(193));
	
	var _index2 = _interopRequireDefault(__webpack_require__(3));
	
	var _index3 = _interopRequireDefault(__webpack_require__(19));
	
	var _index4 = _interopRequireDefault(__webpack_require__(2));
	
	var _index5 = _interopRequireDefault(__webpack_require__(280));
	
	var _index6 = _interopRequireDefault(__webpack_require__(435));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name addBusinessDays
	 * @category Day Helpers
	 * @summary Add the specified number of business days (mon - fri) to the given date.
	 *
	 * @description
	 * Add the specified number of business days (mon - fri) to the given date, ignoring weekends.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of business days to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the business days added
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Add 10 business days to 1 September 2014:
	 * const result = addBusinessDays(new Date(2014, 8, 1), 10)
	 * //=> Mon Sep 15 2014 00:00:00 (skipped weekend days)
	 */
	function addBusinessDays(dirtyDate, dirtyAmount) {
	  (0, _index4.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var startedOnWeekend = (0, _index.default)(date);
	  var amount = (0, _index3.default)(dirtyAmount);
	  if (isNaN(amount)) return new Date(NaN);
	  var hours = date.getHours();
	  var sign = amount < 0 ? -1 : 1;
	  var fullWeeks = (0, _index3.default)(amount / 5);
	  date.setDate(date.getDate() + fullWeeks * 7); // Get remaining days not part of a full week
	
	  var restDays = Math.abs(amount % 5); // Loops over remaining days
	
	  while (restDays > 0) {
	    date.setDate(date.getDate() + sign);
	    if (!(0, _index.default)(date)) restDays -= 1;
	  } // If the date is a weekend day and we reduce a dividable of
	  // 5 from it, we land on a weekend date.
	  // To counter this, we add days accordingly to land on the next business day
	
	
	  if (startedOnWeekend && (0, _index.default)(date) && amount !== 0) {
	    // If we're reducing days, we want to add days until we land on a weekday
	    // If we're adding days we want to reduce days until we land on a weekday
	    if ((0, _index6.default)(date)) date.setDate(date.getDate() + (sign < 0 ? 2 : -1));
	    if ((0, _index5.default)(date)) date.setDate(date.getDate() + (sign < 0 ? 1 : -2));
	  } // Restore hours to avoid DST lag
	
	
	  date.setHours(hours);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 402 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addISOWeekYears;
	
	var _index = _interopRequireDefault(__webpack_require__(19));
	
	var _index2 = _interopRequireDefault(__webpack_require__(128));
	
	var _index3 = _interopRequireDefault(__webpack_require__(449));
	
	var _index4 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name addISOWeekYears
	 * @category ISO Week-Numbering Year Helpers
	 * @summary Add the specified number of ISO week-numbering years to the given date.
	 *
	 * @description
	 * Add the specified number of ISO week-numbering years to the given date.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * - The function was renamed from `addISOYears` to `addISOWeekYears`.
	 *   "ISO week year" is short for [ISO week-numbering year](https://en.wikipedia.org/wiki/ISO_week_date).
	 *   This change makes the name consistent with
	 *   locale-dependent week-numbering year helpers, e.g., `addWeekYears`.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of ISO week-numbering years to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the ISO week-numbering years added
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Add 5 ISO week-numbering years to 2 July 2010:
	 * const result = addISOWeekYears(new Date(2010, 6, 2), 5)
	 * //=> Fri Jun 26 2015 00:00:00
	 */
	function addISOWeekYears(dirtyDate, dirtyAmount) {
	  (0, _index4.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  return (0, _index3.default)(dirtyDate, (0, _index2.default)(dirtyDate) + amount);
	}
	
	module.exports = exports.default;

/***/ },
/* 403 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addSeconds;
	
	var _index = _interopRequireDefault(__webpack_require__(19));
	
	var _index2 = _interopRequireDefault(__webpack_require__(149));
	
	var _index3 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name addSeconds
	 * @category Second Helpers
	 * @summary Add the specified number of seconds to the given date.
	 *
	 * @description
	 * Add the specified number of seconds to the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of seconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the seconds added
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Add 30 seconds to 10 July 2014 12:45:00:
	 * const result = addSeconds(new Date(2014, 6, 10, 12, 45, 0), 30)
	 * //=> Thu Jul 10 2014 12:45:30
	 */
	function addSeconds(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  return (0, _index2.default)(dirtyDate, amount * 1000);
	}
	
	module.exports = exports.default;

/***/ },
/* 404 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addYears;
	
	var _index = _interopRequireDefault(__webpack_require__(19));
	
	var _index2 = _interopRequireDefault(__webpack_require__(150));
	
	var _index3 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name addYears
	 * @category Year Helpers
	 * @summary Add the specified number of years to the given date.
	 *
	 * @description
	 * Add the specified number of years to the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of years to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the years added
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Add 5 years to 1 September 2014:
	 * const result = addYears(new Date(2014, 8, 1), 5)
	 * //=> Sun Sep 01 2019 00:00:00
	 */
	function addYears(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  return (0, _index2.default)(dirtyDate, amount * 12);
	}
	
	module.exports = exports.default;

/***/ },
/* 405 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = differenceInCalendarISOWeekYears;
	
	var _index = _interopRequireDefault(__webpack_require__(128));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name differenceInCalendarISOWeekYears
	 * @category ISO Week-Numbering Year Helpers
	 * @summary Get the number of calendar ISO week-numbering years between the given dates.
	 *
	 * @description
	 * Get the number of calendar ISO week-numbering years between the given dates.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * - The function was renamed from `differenceInCalendarISOYears` to `differenceInCalendarISOWeekYears`.
	 *   "ISO week year" is short for [ISO week-numbering year](https://en.wikipedia.org/wiki/ISO_week_date).
	 *   This change makes the name consistent with
	 *   locale-dependent week-numbering year helpers, e.g., `addWeekYears`.
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @returns {Number} the number of calendar ISO week-numbering years
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // How many calendar ISO week-numbering years are 1 January 2010 and 1 January 2012?
	 * const result = differenceInCalendarISOWeekYears(
	 *   new Date(2012, 0, 1),
	 *   new Date(2010, 0, 1)
	 * )
	 * //=> 2
	 */
	function differenceInCalendarISOWeekYears(dirtyDateLeft, dirtyDateRight) {
	  (0, _index2.default)(2, arguments);
	  return (0, _index.default)(dirtyDateLeft) - (0, _index.default)(dirtyDateRight);
	}
	
	module.exports = exports.default;

/***/ },
/* 406 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = differenceInCalendarMonths;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name differenceInCalendarMonths
	 * @category Month Helpers
	 * @summary Get the number of calendar months between the given dates.
	 *
	 * @description
	 * Get the number of calendar months between the given dates.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @returns {Number} the number of calendar months
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // How many calendar months are between 31 January 2014 and 1 September 2014?
	 * var result = differenceInCalendarMonths(
	 *   new Date(2014, 8, 1),
	 *   new Date(2014, 0, 31)
	 * )
	 * //=> 8
	 */
	function differenceInCalendarMonths(dirtyDateLeft, dirtyDateRight) {
	  (0, _index2.default)(2, arguments);
	  var dateLeft = (0, _index.default)(dirtyDateLeft);
	  var dateRight = (0, _index.default)(dirtyDateRight);
	  var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear();
	  var monthDiff = dateLeft.getMonth() - dateRight.getMonth();
	  return yearDiff * 12 + monthDiff;
	}
	
	module.exports = exports.default;

/***/ },
/* 407 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = differenceInCalendarWeeks;
	
	var _index = _interopRequireDefault(__webpack_require__(96));
	
	var _index2 = _interopRequireDefault(__webpack_require__(81));
	
	var _index3 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MILLISECONDS_IN_WEEK = 604800000;
	/**
	 * @name differenceInCalendarWeeks
	 * @category Week Helpers
	 * @summary Get the number of calendar weeks between the given dates.
	 *
	 * @description
	 * Get the number of calendar weeks between the given dates.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @returns {Number} the number of calendar weeks
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 *
	 * @example
	 * // How many calendar weeks are between 5 July 2014 and 20 July 2014?
	 * const result = differenceInCalendarWeeks(
	 *   new Date(2014, 6, 20),
	 *   new Date(2014, 6, 5)
	 * )
	 * //=> 3
	 *
	 * @example
	 * // If the week starts on Monday,
	 * // how many calendar weeks are between 5 July 2014 and 20 July 2014?
	 * const result = differenceInCalendarWeeks(
	 *   new Date(2014, 6, 20),
	 *   new Date(2014, 6, 5),
	 *   { weekStartsOn: 1 }
	 * )
	 * //=> 2
	 */
	
	function differenceInCalendarWeeks(dirtyDateLeft, dirtyDateRight, dirtyOptions) {
	  (0, _index3.default)(2, arguments);
	  var startOfWeekLeft = (0, _index.default)(dirtyDateLeft, dirtyOptions);
	  var startOfWeekRight = (0, _index.default)(dirtyDateRight, dirtyOptions);
	  var timestampLeft = startOfWeekLeft.getTime() - (0, _index2.default)(startOfWeekLeft);
	  var timestampRight = startOfWeekRight.getTime() - (0, _index2.default)(startOfWeekRight); // Round the number of days to the nearest integer
	  // because the number of milliseconds in a week is not constant
	  // (e.g. it's different in the week of the daylight saving time clock shift)
	
	  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_WEEK);
	}
	
	module.exports = exports.default;

/***/ },
/* 408 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = differenceInCalendarYears;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name differenceInCalendarYears
	 * @category Year Helpers
	 * @summary Get the number of calendar years between the given dates.
	 *
	 * @description
	 * Get the number of calendar years between the given dates.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @returns {Number} the number of calendar years
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // How many calendar years are between 31 December 2013 and 11 February 2015?
	 * const result = differenceInCalendarYears(
	 *   new Date(2015, 1, 11),
	 *   new Date(2013, 11, 31)
	 * )
	 * //=> 2
	 */
	function differenceInCalendarYears(dirtyDateLeft, dirtyDateRight) {
	  (0, _index2.default)(2, arguments);
	  var dateLeft = (0, _index.default)(dirtyDateLeft);
	  var dateRight = (0, _index.default)(dirtyDateRight);
	  return dateLeft.getFullYear() - dateRight.getFullYear();
	}
	
	module.exports = exports.default;

/***/ },
/* 409 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = differenceInHours;
	
	var _index = __webpack_require__(36);
	
	var _index2 = _interopRequireDefault(__webpack_require__(190));
	
	var _index3 = _interopRequireDefault(__webpack_require__(2));
	
	var _index4 = __webpack_require__(147);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name differenceInHours
	 * @category Hour Helpers
	 * @summary Get the number of hours between the given dates.
	 *
	 * @description
	 * Get the number of hours between the given dates.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @param {Object} [options] - an object with options.
	 * @param {String} [options.roundingMethod='trunc'] - a rounding method (`ceil`, `floor`, `round` or `trunc`)
	 * @returns {Number} the number of hours
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // How many hours are between 2 July 2014 06:50:00 and 2 July 2014 19:00:00?
	 * const result = differenceInHours(
	 *   new Date(2014, 6, 2, 19, 0),
	 *   new Date(2014, 6, 2, 6, 50)
	 * )
	 * //=> 12
	 */
	function differenceInHours(dateLeft, dateRight, options) {
	  (0, _index3.default)(2, arguments);
	
	  var diff = (0, _index2.default)(dateLeft, dateRight) / _index.millisecondsInHour;
	
	  return (0, _index4.getRoundingMethod)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
	}
	
	module.exports = exports.default;

/***/ },
/* 410 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = differenceInMinutes;
	
	var _index = __webpack_require__(36);
	
	var _index2 = _interopRequireDefault(__webpack_require__(190));
	
	var _index3 = _interopRequireDefault(__webpack_require__(2));
	
	var _index4 = __webpack_require__(147);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name differenceInMinutes
	 * @category Minute Helpers
	 * @summary Get the number of minutes between the given dates.
	 *
	 * @description
	 * Get the signed number of full (rounded towards 0) minutes between the given dates.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @param {Object} [options] - an object with options.
	 * @param {String} [options.roundingMethod='trunc'] - a rounding method (`ceil`, `floor`, `round` or `trunc`)
	 * @returns {Number} the number of minutes
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // How many minutes are between 2 July 2014 12:07:59 and 2 July 2014 12:20:00?
	 * const result = differenceInMinutes(
	 *   new Date(2014, 6, 2, 12, 20, 0),
	 *   new Date(2014, 6, 2, 12, 7, 59)
	 * )
	 * //=> 12
	 *
	 * @example
	 * // How many minutes are between 10:01:59 and 10:00:00
	 * const result = differenceInMinutes(
	 *   new Date(2000, 0, 1, 10, 0, 0),
	 *   new Date(2000, 0, 1, 10, 1, 59)
	 * )
	 * //=> -1
	 */
	function differenceInMinutes(dateLeft, dateRight, options) {
	  (0, _index3.default)(2, arguments);
	
	  var diff = (0, _index2.default)(dateLeft, dateRight) / _index.millisecondsInMinute;
	
	  return (0, _index4.getRoundingMethod)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
	}
	
	module.exports = exports.default;

/***/ },
/* 411 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = eachDayOfInterval;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name eachDayOfInterval
	 * @category Interval Helpers
	 * @summary Return the array of dates within the specified time interval.
	 *
	 * @description
	 * Return the array of dates within the specified time interval.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * - The function was renamed from `eachDay` to `eachDayOfInterval`.
	 *   This change was made to mirror the use of the word "interval" in standard ISO 8601:2004 terminology:
	 *
	 *   ```
	 *   2.1.3
	 *   time interval
	 *   part of the time axis limited by two instants
	 *   ```
	 *
	 *   Also, this function now accepts an object with `start` and `end` properties
	 *   instead of two arguments as an interval.
	 *   This function now throws `RangeError` if the start of the interval is after its end
	 *   or if any date in the interval is `Invalid Date`.
	 *
	 *   ```javascript
	 *   // Before v2.0.0
	 *
	 *   eachDay(new Date(2014, 0, 10), new Date(2014, 0, 20))
	 *
	 *   // v2.0.0 onward
	 *
	 *   eachDayOfInterval(
	 *     { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) }
	 *   )
	 *   ```
	 *
	 * @param {Interval} interval - the interval. See [Interval]{@link https://date-fns.org/docs/Interval}
	 * @param {Object} [options] - an object with options.
	 * @param {Number} [options.step=1] - the step to increment by. The value should be more than 1.
	 * @returns {Date[]} the array with starts of days from the day of the interval start to the day of the interval end
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.step` must be a number greater than 1
	 * @throws {RangeError} The start of an interval cannot be after its end
	 * @throws {RangeError} Date in interval cannot be `Invalid Date`
	 *
	 * @example
	 * // Each day between 6 October 2014 and 10 October 2014:
	 * const result = eachDayOfInterval({
	 *   start: new Date(2014, 9, 6),
	 *   end: new Date(2014, 9, 10)
	 * })
	 * //=> [
	 * //   Mon Oct 06 2014 00:00:00,
	 * //   Tue Oct 07 2014 00:00:00,
	 * //   Wed Oct 08 2014 00:00:00,
	 * //   Thu Oct 09 2014 00:00:00,
	 * //   Fri Oct 10 2014 00:00:00
	 * // ]
	 */
	function eachDayOfInterval(dirtyInterval, options) {
	  (0, _index2.default)(1, arguments);
	  var interval = dirtyInterval || {};
	  var startDate = (0, _index.default)(interval.start);
	  var endDate = (0, _index.default)(interval.end);
	  var endTime = endDate.getTime(); // Throw an exception if start date is after end date or if any date is `Invalid Date`
	
	  if (!(startDate.getTime() <= endTime)) {
	    throw new RangeError('Invalid interval');
	  }
	
	  var dates = [];
	  var currentDate = startDate;
	  currentDate.setHours(0, 0, 0, 0);
	  var step = options && 'step' in options ? Number(options.step) : 1;
	  if (step < 1 || isNaN(step)) throw new RangeError('`options.step` must be a number greater than 1');
	
	  while (currentDate.getTime() <= endTime) {
	    dates.push((0, _index.default)(currentDate));
	    currentDate.setDate(currentDate.getDate() + step);
	    currentDate.setHours(0, 0, 0, 0);
	  }
	
	  return dates;
	}
	
	module.exports = exports.default;

/***/ },
/* 412 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = endOfWeek;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(19));
	
	var _index3 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name endOfWeek
	 * @category Week Helpers
	 * @summary Return the end of a week for the given date.
	 *
	 * @description
	 * Return the end of a week for the given date.
	 * The result will be in the local timezone.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @returns {Date} the end of a week
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 *
	 * @example
	 * // The end of a week for 2 September 2014 11:55:00:
	 * const result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Sat Sep 06 2014 23:59:59.999
	 *
	 * @example
	 * // If the week starts on Monday, the end of the week for 2 September 2014 11:55:00:
	 * const result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
	 * //=> Sun Sep 07 2014 23:59:59.999
	 */
	function endOfWeek(dirtyDate, dirtyOptions) {
	  (0, _index3.default)(1, arguments);
	  var options = dirtyOptions || {};
	  var locale = options.locale;
	  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
	  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0, _index2.default)(localeWeekStartsOn);
	  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0, _index2.default)(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
	
	  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
	    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
	  }
	
	  var date = (0, _index.default)(dirtyDate);
	  var day = date.getDay();
	  var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
	  date.setDate(date.getDate() + diff);
	  date.setHours(23, 59, 59, 999);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 413 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = endOfYear;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name endOfYear
	 * @category Year Helpers
	 * @summary Return the end of a year for the given date.
	 *
	 * @description
	 * Return the end of a year for the given date.
	 * The result will be in the local timezone.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the end of a year
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The end of a year for 2 September 2014 11:55:00:
	 * var result = endOfYear(new Date(2014, 8, 2, 11, 55, 00))
	 * //=> Wed Dec 31 2014 23:59:59.999
	 */
	function endOfYear(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var year = date.getFullYear();
	  date.setFullYear(year + 1, 0, 0);
	  date.setHours(23, 59, 59, 999);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 414 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = format;
	
	var _index = _interopRequireDefault(__webpack_require__(83));
	
	var _index2 = _interopRequireDefault(__webpack_require__(108));
	
	var _index3 = _interopRequireDefault(__webpack_require__(153));
	
	var _index4 = _interopRequireDefault(__webpack_require__(3));
	
	var _index5 = _interopRequireDefault(__webpack_require__(930));
	
	var _index6 = _interopRequireDefault(__webpack_require__(396));
	
	var _index7 = _interopRequireDefault(__webpack_require__(81));
	
	var _index8 = __webpack_require__(400);
	
	var _index9 = _interopRequireDefault(__webpack_require__(19));
	
	var _index10 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// This RegExp consists of three parts separated by `|`:
	// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
	//   (one of the certain letters followed by `o`)
	// - (\w)\1* matches any sequences of the same letter
	// - '' matches two quote characters in a row
	// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
	//   except a single quote symbol, which ends the sequence.
	//   Two quote characters do not end the sequence.
	//   If there is no matching single quote
	//   then the sequence will continue until the end of the string.
	// - . matches any single character unmatched by previous parts of the RegExps
	var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g; // This RegExp catches symbols escaped by quotes, and also
	// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
	
	var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
	var escapedStringRegExp = /^'([^]*?)'?$/;
	var doubleQuoteRegExp = /''/g;
	var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
	/**
	 * @name format
	 * @category Common Helpers
	 * @summary Format the date.
	 *
	 * @description
	 * Return the formatted date string in the given format. The result may vary by locale.
	 *
	 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
	 * > See: https://git.io/fxCyr
	 *
	 * The characters wrapped between two single quotes characters (') are escaped.
	 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
	 * (see the last example)
	 *
	 * Format of the string is based on Unicode Technical Standard #35:
	 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
	 * with a few additions (see note 7 below the table).
	 *
	 * Accepted patterns:
	 * | Unit                            | Pattern | Result examples                   | Notes |
	 * |---------------------------------|---------|-----------------------------------|-------|
	 * | Era                             | G..GGG  | AD, BC                            |       |
	 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
	 * |                                 | GGGGG   | A, B                              |       |
	 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
	 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
	 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
	 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
	 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
	 * |                                 | yyyyy   | ...                               | 3,5   |
	 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
	 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
	 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
	 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
	 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
	 * |                                 | YYYYY   | ...                               | 3,5   |
	 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
	 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
	 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
	 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
	 * |                                 | RRRRR   | ...                               | 3,5,7 |
	 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
	 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
	 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
	 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
	 * |                                 | uuuuu   | ...                               | 3,5   |
	 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
	 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
	 * |                                 | QQ      | 01, 02, 03, 04                    |       |
	 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
	 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
	 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
	 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
	 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
	 * |                                 | qq      | 01, 02, 03, 04                    |       |
	 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
	 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
	 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
	 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
	 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
	 * |                                 | MM      | 01, 02, ..., 12                   |       |
	 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
	 * |                                 | MMMM    | January, February, ..., December  | 2     |
	 * |                                 | MMMMM   | J, F, ..., D                      |       |
	 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
	 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
	 * |                                 | LL      | 01, 02, ..., 12                   |       |
	 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
	 * |                                 | LLLL    | January, February, ..., December  | 2     |
	 * |                                 | LLLLL   | J, F, ..., D                      |       |
	 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
	 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
	 * |                                 | ww      | 01, 02, ..., 53                   |       |
	 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
	 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
	 * |                                 | II      | 01, 02, ..., 53                   | 7     |
	 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
	 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
	 * |                                 | dd      | 01, 02, ..., 31                   |       |
	 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
	 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
	 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
	 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
	 * |                                 | DDDD    | ...                               | 3     |
	 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
	 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
	 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
	 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
	 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
	 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
	 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
	 * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
	 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
	 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
	 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 7     |
	 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
	 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
	 * |                                 | ee      | 02, 03, ..., 01                   |       |
	 * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
	 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
	 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
	 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
	 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
	 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
	 * |                                 | cc      | 02, 03, ..., 01                   |       |
	 * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
	 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
	 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
	 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
	 * | AM, PM                          | a..aa   | AM, PM                            |       |
	 * |                                 | aaa     | am, pm                            |       |
	 * |                                 | aaaa    | a.m., p.m.                        | 2     |
	 * |                                 | aaaaa   | a, p                              |       |
	 * | AM, PM, noon, midnight          | b..bb   | AM, PM, noon, midnight            |       |
	 * |                                 | bbb     | am, pm, noon, midnight            |       |
	 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
	 * |                                 | bbbbb   | a, p, n, mi                       |       |
	 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
	 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
	 * |                                 | BBBBB   | at night, in the morning, ...     |       |
	 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
	 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
	 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
	 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
	 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
	 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
	 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
	 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
	 * |                                 | KK      | 01, 02, ..., 11, 00               |       |
	 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
	 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
	 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
	 * | Minute                          | m       | 0, 1, ..., 59                     |       |
	 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
	 * |                                 | mm      | 00, 01, ..., 59                   |       |
	 * | Second                          | s       | 0, 1, ..., 59                     |       |
	 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
	 * |                                 | ss      | 00, 01, ..., 59                   |       |
	 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
	 * |                                 | SS      | 00, 01, ..., 99                   |       |
	 * |                                 | SSS     | 000, 001, ..., 999                |       |
	 * |                                 | SSSS    | ...                               | 3     |
	 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
	 * |                                 | XX      | -0800, +0530, Z                   |       |
	 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
	 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
	 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
	 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
	 * |                                 | xx      | -0800, +0530, +0000               |       |
	 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
	 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
	 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
	 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
	 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
	 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
	 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
	 * | Seconds timestamp               | t       | 512969520                         | 7     |
	 * |                                 | tt      | ...                               | 3,7   |
	 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
	 * |                                 | TT      | ...                               | 3,7   |
	 * | Long localized date             | P       | 04/29/1453                        | 7     |
	 * |                                 | PP      | Apr 29, 1453                      | 7     |
	 * |                                 | PPP     | April 29th, 1453                  | 7     |
	 * |                                 | PPPP    | Friday, April 29th, 1453          | 2,7   |
	 * | Long localized time             | p       | 12:00 AM                          | 7     |
	 * |                                 | pp      | 12:00:00 AM                       | 7     |
	 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
	 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
	 * | Combination of date and time    | Pp      | 04/29/1453, 12:00 AM              | 7     |
	 * |                                 | PPpp    | Apr 29, 1453, 12:00:00 AM         | 7     |
	 * |                                 | PPPppp  | April 29th, 1453 at ...           | 7     |
	 * |                                 | PPPPpppp| Friday, April 29th, 1453 at ...   | 2,7   |
	 * Notes:
	 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
	 *    are the same as "stand-alone" units, but are different in some languages.
	 *    "Formatting" units are declined according to the rules of the language
	 *    in the context of a date. "Stand-alone" units are always nominative singular:
	 *
	 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
	 *
	 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
	 *
	 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
	 *    the single quote characters (see below).
	 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
	 *    the output will be the same as default pattern for this unit, usually
	 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
	 *    are marked with "2" in the last column of the table.
	 *
	 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
	 *
	 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
	 *
	 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
	 *
	 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
	 *
	 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
	 *
	 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
	 *    The output will be padded with zeros to match the length of the pattern.
	 *
	 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
	 *
	 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
	 *    These tokens represent the shortest form of the quarter.
	 *
	 * 5. The main difference between `y` and `u` patterns are B.C. years:
	 *
	 *    | Year | `y` | `u` |
	 *    |------|-----|-----|
	 *    | AC 1 |   1 |   1 |
	 *    | BC 1 |   1 |   0 |
	 *    | BC 2 |   2 |  -1 |
	 *
	 *    Also `yy` always returns the last two digits of a year,
	 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
	 *
	 *    | Year | `yy` | `uu` |
	 *    |------|------|------|
	 *    | 1    |   01 |   01 |
	 *    | 14   |   14 |   14 |
	 *    | 376  |   76 |  376 |
	 *    | 1453 |   53 | 1453 |
	 *
	 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
	 *    except local week-numbering years are dependent on `options.weekStartsOn`
	 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear]{@link https://date-fns.org/docs/getISOWeekYear}
	 *    and [getWeekYear]{@link https://date-fns.org/docs/getWeekYear}).
	 *
	 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
	 *    so right now these tokens fall back to GMT timezones.
	 *
	 * 7. These patterns are not in the Unicode Technical Standard #35:
	 *    - `i`: ISO day of week
	 *    - `I`: ISO week of year
	 *    - `R`: ISO week-numbering year
	 *    - `t`: seconds timestamp
	 *    - `T`: milliseconds timestamp
	 *    - `o`: ordinal number modifier
	 *    - `P`: long localized date
	 *    - `p`: long localized time
	 *
	 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
	 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://git.io/fxCyr
	 *
	 * 9. `D` and `DD` tokens represent days of the year but they are often confused with days of the month.
	 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://git.io/fxCyr
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * - The second argument is now required for the sake of explicitness.
	 *
	 *   ```javascript
	 *   // Before v2.0.0
	 *   format(new Date(2016, 0, 1))
	 *
	 *   // v2.0.0 onward
	 *   format(new Date(2016, 0, 1), "yyyy-MM-dd'T'HH:mm:ss.SSSxxx")
	 *   ```
	 *
	 * - New format string API for `format` function
	 *   which is based on [Unicode Technical Standard #35](https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table).
	 *   See [this post](https://blog.date-fns.org/post/unicode-tokens-in-date-fns-v2-sreatyki91jg) for more details.
	 *
	 * - Characters are now escaped using single quote symbols (`'`) instead of square brackets.
	 *
	 * @param {Date|Number} date - the original date
	 * @param {String} format - the string of tokens
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @param {Number} [options.firstWeekContainsDate=1] - the day of January, which is
	 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
	 *   see: https://git.io/fxCyr
	 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
	 *   see: https://git.io/fxCyr
	 * @returns {String} the formatted date string
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} `date` must not be Invalid Date
	 * @throws {RangeError} `options.locale` must contain `localize` property
	 * @throws {RangeError} `options.locale` must contain `formatLong` property
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
	 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://git.io/fxCyr
	 * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://git.io/fxCyr
	 * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://git.io/fxCyr
	 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://git.io/fxCyr
	 * @throws {RangeError} format string contains an unescaped latin alphabet character
	 *
	 * @example
	 * // Represent 11 February 2014 in middle-endian format:
	 * var result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
	 * //=> '02/11/2014'
	 *
	 * @example
	 * // Represent 2 July 2014 in Esperanto:
	 * import { eoLocale } from 'date-fns/locale/eo'
	 * var result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
	 *   locale: eoLocale
	 * })
	 * //=> '2-a de julio 2014'
	 *
	 * @example
	 * // Escape string by single quote characters:
	 * var result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
	 * //=> "3 o'clock"
	 */
	
	function format(dirtyDate, dirtyFormatStr, dirtyOptions) {
	  (0, _index10.default)(2, arguments);
	  var formatStr = String(dirtyFormatStr);
	  var options = dirtyOptions || {};
	  var locale = options.locale || _index2.default;
	  var localeFirstWeekContainsDate = locale.options && locale.options.firstWeekContainsDate;
	  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : (0, _index9.default)(localeFirstWeekContainsDate);
	  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : (0, _index9.default)(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
	
	  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
	    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
	  }
	
	  var localeWeekStartsOn = locale.options && locale.options.weekStartsOn;
	  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0, _index9.default)(localeWeekStartsOn);
	  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0, _index9.default)(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
	
	  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
	    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
	  }
	
	  if (!locale.localize) {
	    throw new RangeError('locale must contain localize property');
	  }
	
	  if (!locale.formatLong) {
	    throw new RangeError('locale must contain formatLong property');
	  }
	
	  var originalDate = (0, _index4.default)(dirtyDate);
	
	  if (!(0, _index.default)(originalDate)) {
	    throw new RangeError('Invalid time value');
	  } // Convert the date in system timezone to the same date in UTC+00:00 timezone.
	  // This ensures that when UTC functions will be implemented, locales will be compatible with them.
	  // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
	
	
	  var timezoneOffset = (0, _index7.default)(originalDate);
	  var utcDate = (0, _index3.default)(originalDate, timezoneOffset);
	  var formatterOptions = {
	    firstWeekContainsDate: firstWeekContainsDate,
	    weekStartsOn: weekStartsOn,
	    locale: locale,
	    _originalDate: originalDate
	  };
	  var result = formatStr.match(longFormattingTokensRegExp).map(function (substring) {
	    var firstCharacter = substring[0];
	
	    if (firstCharacter === 'p' || firstCharacter === 'P') {
	      var longFormatter = _index6.default[firstCharacter];
	      return longFormatter(substring, locale.formatLong, formatterOptions);
	    }
	
	    return substring;
	  }).join('').match(formattingTokensRegExp).map(function (substring) {
	    // Replace two single quote characters with one single quote character
	    if (substring === "''") {
	      return "'";
	    }
	
	    var firstCharacter = substring[0];
	
	    if (firstCharacter === "'") {
	      return cleanEscapedString(substring);
	    }
	
	    var formatter = _index5.default[firstCharacter];
	
	    if (formatter) {
	      if (!options.useAdditionalWeekYearTokens && (0, _index8.isProtectedWeekYearToken)(substring)) {
	        (0, _index8.throwProtectedError)(substring, dirtyFormatStr, dirtyDate);
	      }
	
	      if (!options.useAdditionalDayOfYearTokens && (0, _index8.isProtectedDayOfYearToken)(substring)) {
	        (0, _index8.throwProtectedError)(substring, dirtyFormatStr, dirtyDate);
	      }
	
	      return formatter(utcDate, substring, locale.localize, formatterOptions);
	    }
	
	    if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
	      throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
	    }
	
	    return substring;
	  }).join('');
	  return result;
	}
	
	function cleanEscapedString(input) {
	  return input.match(escapedStringRegExp)[1].replace(doubleQuoteRegExp, "'");
	}
	
	module.exports = exports.default;

/***/ },
/* 415 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistance;
	
	var _index = _interopRequireDefault(__webpack_require__(105));
	
	var _index2 = _interopRequireDefault(__webpack_require__(191));
	
	var _index3 = _interopRequireDefault(__webpack_require__(273));
	
	var _index4 = _interopRequireDefault(__webpack_require__(108));
	
	var _index5 = _interopRequireDefault(__webpack_require__(3));
	
	var _index6 = _interopRequireDefault(__webpack_require__(394));
	
	var _index7 = _interopRequireDefault(__webpack_require__(81));
	
	var _index8 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MINUTES_IN_DAY = 1440;
	var MINUTES_IN_ALMOST_TWO_DAYS = 2520;
	var MINUTES_IN_MONTH = 43200;
	var MINUTES_IN_TWO_MONTHS = 86400;
	/**
	 * @name formatDistance
	 * @category Common Helpers
	 * @summary Return the distance between the given dates in words.
	 *
	 * @description
	 * Return the distance between the given dates in words.
	 *
	 * | Distance between dates                                            | Result              |
	 * |-------------------------------------------------------------------|---------------------|
	 * | 0 ... 30 secs                                                     | less than a minute  |
	 * | 30 secs ... 1 min 30 secs                                         | 1 minute            |
	 * | 1 min 30 secs ... 44 mins 30 secs                                 | [2..44] minutes     |
	 * | 44 mins ... 30 secs ... 89 mins 30 secs                           | about 1 hour        |
	 * | 89 mins 30 secs ... 23 hrs 59 mins 30 secs                        | about [2..24] hours |
	 * | 23 hrs 59 mins 30 secs ... 41 hrs 59 mins 30 secs                 | 1 day               |
	 * | 41 hrs 59 mins 30 secs ... 29 days 23 hrs 59 mins 30 secs         | [2..30] days        |
	 * | 29 days 23 hrs 59 mins 30 secs ... 44 days 23 hrs 59 mins 30 secs | about 1 month       |
	 * | 44 days 23 hrs 59 mins 30 secs ... 59 days 23 hrs 59 mins 30 secs | about 2 months      |
	 * | 59 days 23 hrs 59 mins 30 secs ... 1 yr                           | [2..12] months      |
	 * | 1 yr ... 1 yr 3 months                                            | about 1 year        |
	 * | 1 yr 3 months ... 1 yr 9 month s                                  | over 1 year         |
	 * | 1 yr 9 months ... 2 yrs                                           | almost 2 years      |
	 * | N yrs ... N yrs 3 months                                          | about N years       |
	 * | N yrs 3 months ... N yrs 9 months                                 | over N years        |
	 * | N yrs 9 months ... N+1 yrs                                        | almost N+1 years    |
	 *
	 * With `options.includeSeconds == true`:
	 * | Distance between dates | Result               |
	 * |------------------------|----------------------|
	 * | 0 secs ... 5 secs      | less than 5 seconds  |
	 * | 5 secs ... 10 secs     | less than 10 seconds |
	 * | 10 secs ... 20 secs    | less than 20 seconds |
	 * | 20 secs ... 40 secs    | half a minute        |
	 * | 40 secs ... 60 secs    | less than a minute   |
	 * | 60 secs ... 90 secs    | 1 minute             |
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * - The function was renamed from `distanceInWords ` to `formatDistance`
	 *   to make its name consistent with `format` and `formatRelative`.
	 *
	 * - The order of arguments is swapped to make the function
	 *   consistent with `differenceIn...` functions.
	 *
	 *   ```javascript
	 *   // Before v2.0.0
	 *
	 *   distanceInWords(
	 *     new Date(1986, 3, 4, 10, 32, 0),
	 *     new Date(1986, 3, 4, 11, 32, 0),
	 *     { addSuffix: true }
	 *   ) //=> 'in about 1 hour'
	 *
	 *   // v2.0.0 onward
	 *
	 *   formatDistance(
	 *     new Date(1986, 3, 4, 11, 32, 0),
	 *     new Date(1986, 3, 4, 10, 32, 0),
	 *     { addSuffix: true }
	 *   ) //=> 'in about 1 hour'
	 *   ```
	 *
	 * @param {Date|Number} date - the date
	 * @param {Date|Number} baseDate - the date to compare with
	 * @param {Object} [options] - an object with options.
	 * @param {Boolean} [options.includeSeconds=false] - distances less than a minute are more detailed
	 * @param {Boolean} [options.addSuffix=false] - result indicates if the second date is earlier or later than the first
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @returns {String} the distance in words
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} `date` must not be Invalid Date
	 * @throws {RangeError} `baseDate` must not be Invalid Date
	 * @throws {RangeError} `options.locale` must contain `formatDistance` property
	 *
	 * @example
	 * // What is the distance between 2 July 2014 and 1 January 2015?
	 * const result = formatDistance(new Date(2014, 6, 2), new Date(2015, 0, 1))
	 * //=> '6 months'
	 *
	 * @example
	 * // What is the distance between 1 January 2015 00:00:15
	 * // and 1 January 2015 00:00:00, including seconds?
	 * const result = formatDistance(
	 *   new Date(2015, 0, 1, 0, 0, 15),
	 *   new Date(2015, 0, 1, 0, 0, 0),
	 *   { includeSeconds: true }
	 * )
	 * //=> 'less than 20 seconds'
	 *
	 * @example
	 * // What is the distance from 1 January 2016
	 * // to 1 January 2015, with a suffix?
	 * const result = formatDistance(new Date(2015, 0, 1), new Date(2016, 0, 1), {
	 *   addSuffix: true
	 * })
	 * //=> 'about 1 year ago'
	 *
	 * @example
	 * // What is the distance between 1 August 2016 and 1 January 2015 in Esperanto?
	 * import { eoLocale } from 'date-fns/locale/eo'
	 * const result = formatDistance(new Date(2016, 7, 1), new Date(2015, 0, 1), {
	 *   locale: eoLocale
	 * })
	 * //=> 'pli ol 1 jaro'
	 */
	
	function formatDistance(dirtyDate, dirtyBaseDate) {
	  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	  (0, _index8.default)(2, arguments);
	  var locale = options.locale || _index4.default;
	
	  if (!locale.formatDistance) {
	    throw new RangeError('locale must contain formatDistance property');
	  }
	
	  var comparison = (0, _index.default)(dirtyDate, dirtyBaseDate);
	
	  if (isNaN(comparison)) {
	    throw new RangeError('Invalid time value');
	  }
	
	  var localizeOptions = (0, _index6.default)(options);
	  localizeOptions.addSuffix = Boolean(options.addSuffix);
	  localizeOptions.comparison = comparison;
	  var dateLeft;
	  var dateRight;
	
	  if (comparison > 0) {
	    dateLeft = (0, _index5.default)(dirtyBaseDate);
	    dateRight = (0, _index5.default)(dirtyDate);
	  } else {
	    dateLeft = (0, _index5.default)(dirtyDate);
	    dateRight = (0, _index5.default)(dirtyBaseDate);
	  }
	
	  var seconds = (0, _index3.default)(dateRight, dateLeft);
	  var offsetInSeconds = ((0, _index7.default)(dateRight) - (0, _index7.default)(dateLeft)) / 1000;
	  var minutes = Math.round((seconds - offsetInSeconds) / 60);
	  var months; // 0 up to 2 mins
	
	  if (minutes < 2) {
	    if (options.includeSeconds) {
	      if (seconds < 5) {
	        return locale.formatDistance('lessThanXSeconds', 5, localizeOptions);
	      } else if (seconds < 10) {
	        return locale.formatDistance('lessThanXSeconds', 10, localizeOptions);
	      } else if (seconds < 20) {
	        return locale.formatDistance('lessThanXSeconds', 20, localizeOptions);
	      } else if (seconds < 40) {
	        return locale.formatDistance('halfAMinute', null, localizeOptions);
	      } else if (seconds < 60) {
	        return locale.formatDistance('lessThanXMinutes', 1, localizeOptions);
	      } else {
	        return locale.formatDistance('xMinutes', 1, localizeOptions);
	      }
	    } else {
	      if (minutes === 0) {
	        return locale.formatDistance('lessThanXMinutes', 1, localizeOptions);
	      } else {
	        return locale.formatDistance('xMinutes', minutes, localizeOptions);
	      }
	    } // 2 mins up to 0.75 hrs
	
	  } else if (minutes < 45) {
	    return locale.formatDistance('xMinutes', minutes, localizeOptions); // 0.75 hrs up to 1.5 hrs
	  } else if (minutes < 90) {
	    return locale.formatDistance('aboutXHours', 1, localizeOptions); // 1.5 hrs up to 24 hrs
	  } else if (minutes < MINUTES_IN_DAY) {
	    var hours = Math.round(minutes / 60);
	    return locale.formatDistance('aboutXHours', hours, localizeOptions); // 1 day up to 1.75 days
	  } else if (minutes < MINUTES_IN_ALMOST_TWO_DAYS) {
	    return locale.formatDistance('xDays', 1, localizeOptions); // 1.75 days up to 30 days
	  } else if (minutes < MINUTES_IN_MONTH) {
	    var days = Math.round(minutes / MINUTES_IN_DAY);
	    return locale.formatDistance('xDays', days, localizeOptions); // 1 month up to 2 months
	  } else if (minutes < MINUTES_IN_TWO_MONTHS) {
	    months = Math.round(minutes / MINUTES_IN_MONTH);
	    return locale.formatDistance('aboutXMonths', months, localizeOptions);
	  }
	
	  months = (0, _index2.default)(dateRight, dateLeft); // 2 months up to 12 months
	
	  if (months < 12) {
	    var nearestMonth = Math.round(minutes / MINUTES_IN_MONTH);
	    return locale.formatDistance('xMonths', nearestMonth, localizeOptions); // 1 year up to max Date
	  } else {
	    var monthsSinceStartOfYear = months % 12;
	    var years = Math.floor(months / 12); // N years up to 1 years 3 months
	
	    if (monthsSinceStartOfYear < 3) {
	      return locale.formatDistance('aboutXYears', years, localizeOptions); // N years 3 months up to N years 9 months
	    } else if (monthsSinceStartOfYear < 9) {
	      return locale.formatDistance('overXYears', years, localizeOptions); // N years 9 months up to N year 12 months
	    } else {
	      return locale.formatDistance('almostXYears', years + 1, localizeOptions);
	    }
	  }
	}
	
	module.exports = exports.default;

/***/ },
/* 416 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistanceStrict;
	
	var _index = _interopRequireDefault(__webpack_require__(81));
	
	var _index2 = _interopRequireDefault(__webpack_require__(105));
	
	var _index3 = _interopRequireDefault(__webpack_require__(3));
	
	var _index4 = _interopRequireDefault(__webpack_require__(394));
	
	var _index5 = _interopRequireDefault(__webpack_require__(108));
	
	var _index6 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MILLISECONDS_IN_MINUTE = 1000 * 60;
	var MINUTES_IN_DAY = 60 * 24;
	var MINUTES_IN_MONTH = MINUTES_IN_DAY * 30;
	var MINUTES_IN_YEAR = MINUTES_IN_DAY * 365;
	/**
	 * @name formatDistanceStrict
	 * @category Common Helpers
	 * @summary Return the distance between the given dates in words.
	 *
	 * @description
	 * Return the distance between the given dates in words, using strict units.
	 * This is like `formatDistance`, but does not use helpers like 'almost', 'over',
	 * 'less than' and the like.
	 *
	 * | Distance between dates | Result              |
	 * |------------------------|---------------------|
	 * | 0 ... 59 secs          | [0..59] seconds     |
	 * | 1 ... 59 mins          | [1..59] minutes     |
	 * | 1 ... 23 hrs           | [1..23] hours       |
	 * | 1 ... 29 days          | [1..29] days        |
	 * | 1 ... 11 months        | [1..11] months      |
	 * | 1 ... N years          | [1..N]  years       |
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * - The function was renamed from `distanceInWordsStrict` to `formatDistanceStrict`
	 *   to make its name consistent with `format` and `formatRelative`.
	 *
	 * - The order of arguments is swapped to make the function
	 *   consistent with `differenceIn...` functions.
	 *
	 *   ```javascript
	 *   // Before v2.0.0
	 *
	 *   distanceInWordsStrict(
	 *     new Date(2015, 0, 2),
	 *     new Date(2014, 6, 2)
	 *   ) //=> '6 months'
	 *
	 *   // v2.0.0 onward
	 *
	 *   formatDistanceStrict(
	 *     new Date(2014, 6, 2),
	 *     new Date(2015, 0, 2)
	 *   ) //=> '6 months'
	 *   ```
	 *
	 * - `partialMethod` option is renamed to `roundingMethod`.
	 *
	 *   ```javascript
	 *   // Before v2.0.0
	 *
	 *   distanceInWordsStrict(
	 *     new Date(1986, 3, 4, 10, 32, 0),
	 *     new Date(1986, 3, 4, 10, 33, 1),
	 *     { partialMethod: 'ceil' }
	 *   ) //=> '2 minutes'
	 *
	 *   // v2.0.0 onward
	 *
	 *   formatDistanceStrict(
	 *     new Date(1986, 3, 4, 10, 33, 1),
	 *     new Date(1986, 3, 4, 10, 32, 0),
	 *     { roundingMethod: 'ceil' }
	 *   ) //=> '2 minutes'
	 *   ```
	 *
	 * - If `roundingMethod` is not specified, it now defaults to `round` instead of `floor`.
	 *
	 * - `unit` option now accepts one of the strings:
	 *   'second', 'minute', 'hour', 'day', 'month' or 'year' instead of 's', 'm', 'h', 'd', 'M' or 'Y'
	 *
	 *   ```javascript
	 *   // Before v2.0.0
	 *
	 *   distanceInWordsStrict(
	 *     new Date(1986, 3, 4, 10, 32, 0),
	 *     new Date(1986, 3, 4, 10, 33, 1),
	 *     { unit: 'm' }
	 *   )
	 *
	 *   // v2.0.0 onward
	 *
	 *   formatDistanceStrict(
	 *     new Date(1986, 3, 4, 10, 33, 1),
	 *     new Date(1986, 3, 4, 10, 32, 0),
	 *     { unit: 'minute' }
	 *   )
	 *   ```
	 *
	 * @param {Date|Number} date - the date
	 * @param {Date|Number} baseDate - the date to compare with
	 * @param {Object} [options] - an object with options.
	 * @param {Boolean} [options.addSuffix=false] - result indicates if the second date is earlier or later than the first
	 * @param {'second'|'minute'|'hour'|'day'|'month'|'year'} [options.unit] - if specified, will force a unit
	 * @param {'floor'|'ceil'|'round'} [options.roundingMethod='round'] - which way to round partial units
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @returns {String} the distance in words
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} `date` must not be Invalid Date
	 * @throws {RangeError} `baseDate` must not be Invalid Date
	 * @throws {RangeError} `options.roundingMethod` must be 'floor', 'ceil' or 'round'
	 * @throws {RangeError} `options.unit` must be 'second', 'minute', 'hour', 'day', 'month' or 'year'
	 * @throws {RangeError} `options.locale` must contain `formatDistance` property
	 *
	 * @example
	 * // What is the distance between 2 July 2014 and 1 January 2015?
	 * const result = formatDistanceStrict(new Date(2014, 6, 2), new Date(2015, 0, 2))
	 * //=> '6 months'
	 *
	 * @example
	 * // What is the distance between 1 January 2015 00:00:15
	 * // and 1 January 2015 00:00:00?
	 * const result = formatDistanceStrict(
	 *   new Date(2015, 0, 1, 0, 0, 15),
	 *   new Date(2015, 0, 1, 0, 0, 0)
	 * )
	 * //=> '15 seconds'
	 *
	 * @example
	 * // What is the distance from 1 January 2016
	 * // to 1 January 2015, with a suffix?
	 * const result = formatDistanceStrict(new Date(2015, 0, 1), new Date(2016, 0, 1), {
	 *   addSuffix: true
	 * })
	 * //=> '1 year ago'
	 *
	 * @example
	 * // What is the distance from 1 January 2016
	 * // to 1 January 2015, in minutes?
	 * const result = formatDistanceStrict(new Date(2016, 0, 1), new Date(2015, 0, 1), {
	 *   unit: 'minute'
	 * })
	 * //=> '525600 minutes'
	 *
	 * @example
	 * // What is the distance from 1 January 2015
	 * // to 28 January 2015, in months, rounded up?
	 * const result = formatDistanceStrict(new Date(2015, 0, 28), new Date(2015, 0, 1), {
	 *   unit: 'month',
	 *   roundingMethod: 'ceil'
	 * })
	 * //=> '1 month'
	 *
	 * @example
	 * // What is the distance between 1 August 2016 and 1 January 2015 in Esperanto?
	 * import { eoLocale } from 'date-fns/locale/eo'
	 * const result = formatDistanceStrict(new Date(2016, 7, 1), new Date(2015, 0, 1), {
	 *   locale: eoLocale
	 * })
	 * //=> '1 jaro'
	 */
	
	function formatDistanceStrict(dirtyDate, dirtyBaseDate) {
	  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	  (0, _index6.default)(2, arguments);
	  var locale = options.locale || _index5.default;
	
	  if (!locale.formatDistance) {
	    throw new RangeError('locale must contain localize.formatDistance property');
	  }
	
	  var comparison = (0, _index2.default)(dirtyDate, dirtyBaseDate);
	
	  if (isNaN(comparison)) {
	    throw new RangeError('Invalid time value');
	  }
	
	  var localizeOptions = (0, _index4.default)(options);
	  localizeOptions.addSuffix = Boolean(options.addSuffix);
	  localizeOptions.comparison = comparison;
	  var dateLeft;
	  var dateRight;
	
	  if (comparison > 0) {
	    dateLeft = (0, _index3.default)(dirtyBaseDate);
	    dateRight = (0, _index3.default)(dirtyDate);
	  } else {
	    dateLeft = (0, _index3.default)(dirtyDate);
	    dateRight = (0, _index3.default)(dirtyBaseDate);
	  }
	
	  var roundingMethod = options.roundingMethod == null ? 'round' : String(options.roundingMethod);
	  var roundingMethodFn;
	
	  if (roundingMethod === 'floor') {
	    roundingMethodFn = Math.floor;
	  } else if (roundingMethod === 'ceil') {
	    roundingMethodFn = Math.ceil;
	  } else if (roundingMethod === 'round') {
	    roundingMethodFn = Math.round;
	  } else {
	    throw new RangeError("roundingMethod must be 'floor', 'ceil' or 'round'");
	  }
	
	  var milliseconds = dateRight.getTime() - dateLeft.getTime();
	  var minutes = milliseconds / MILLISECONDS_IN_MINUTE;
	  var timezoneOffset = (0, _index.default)(dateRight) - (0, _index.default)(dateLeft); // Use DST-normalized difference in minutes for years, months and days;
	  // use regular difference in minutes for hours, minutes and seconds.
	
	  var dstNormalizedMinutes = (milliseconds - timezoneOffset) / MILLISECONDS_IN_MINUTE;
	  var unit;
	
	  if (options.unit == null) {
	    if (minutes < 1) {
	      unit = 'second';
	    } else if (minutes < 60) {
	      unit = 'minute';
	    } else if (minutes < MINUTES_IN_DAY) {
	      unit = 'hour';
	    } else if (dstNormalizedMinutes < MINUTES_IN_MONTH) {
	      unit = 'day';
	    } else if (dstNormalizedMinutes < MINUTES_IN_YEAR) {
	      unit = 'month';
	    } else {
	      unit = 'year';
	    }
	  } else {
	    unit = String(options.unit);
	  } // 0 up to 60 seconds
	
	
	  if (unit === 'second') {
	    var seconds = roundingMethodFn(milliseconds / 1000);
	    return locale.formatDistance('xSeconds', seconds, localizeOptions); // 1 up to 60 mins
	  } else if (unit === 'minute') {
	    var roundedMinutes = roundingMethodFn(minutes);
	    return locale.formatDistance('xMinutes', roundedMinutes, localizeOptions); // 1 up to 24 hours
	  } else if (unit === 'hour') {
	    var hours = roundingMethodFn(minutes / 60);
	    return locale.formatDistance('xHours', hours, localizeOptions); // 1 up to 30 days
	  } else if (unit === 'day') {
	    var days = roundingMethodFn(dstNormalizedMinutes / MINUTES_IN_DAY);
	    return locale.formatDistance('xDays', days, localizeOptions); // 1 up to 12 months
	  } else if (unit === 'month') {
	    var months = roundingMethodFn(dstNormalizedMinutes / MINUTES_IN_MONTH);
	    return months === 12 && options.unit !== 'month' ? locale.formatDistance('xYears', 1, localizeOptions) : locale.formatDistance('xMonths', months, localizeOptions); // 1 year up to max Date
	  } else if (unit === 'year') {
	    var years = roundingMethodFn(dstNormalizedMinutes / MINUTES_IN_YEAR);
	    return locale.formatDistance('xYears', years, localizeOptions);
	  }
	
	  throw new RangeError("unit must be 'second', 'minute', 'hour', 'day', 'month' or 'year'");
	}
	
	module.exports = exports.default;

/***/ },
/* 417 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getDate;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name getDate
	 * @category Day Helpers
	 * @summary Get the day of the month of the given date.
	 *
	 * @description
	 * Get the day of the month of the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the day of month
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Which day of the month is 29 February 2012?
	 * const result = getDate(new Date(2012, 1, 29))
	 * //=> 29
	 */
	function getDate(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var dayOfMonth = date.getDate();
	  return dayOfMonth;
	}
	
	module.exports = exports.default;

/***/ },
/* 418 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getDaysInMonth;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name getDaysInMonth
	 * @category Month Helpers
	 * @summary Get the number of days in a month of the given date.
	 *
	 * @description
	 * Get the number of days in a month of the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the number of days in a month
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // How many days are in February 2000?
	 * const result = getDaysInMonth(new Date(2000, 1))
	 * //=> 29
	 */
	function getDaysInMonth(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var year = date.getFullYear();
	  var monthIndex = date.getMonth();
	  var lastDayOfMonth = new Date(0);
	  lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
	  lastDayOfMonth.setHours(0, 0, 0, 0);
	  return lastDayOfMonth.getDate();
	}
	
	module.exports = exports.default;

/***/ },
/* 419 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getISODay;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name getISODay
	 * @category Weekday Helpers
	 * @summary Get the day of the ISO week of the given date.
	 *
	 * @description
	 * Get the day of the ISO week of the given date,
	 * which is 7 for Sunday, 1 for Monday etc.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the day of ISO week
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Which day of the ISO week is 26 February 2012?
	 * const result = getISODay(new Date(2012, 1, 26))
	 * //=> 7
	 */
	function getISODay(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var day = date.getDay();
	
	  if (day === 0) {
	    day = 7;
	  }
	
	  return day;
	}
	
	module.exports = exports.default;

/***/ },
/* 420 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getISOWeek;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(109));
	
	var _index3 = _interopRequireDefault(__webpack_require__(152));
	
	var _index4 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MILLISECONDS_IN_WEEK = 604800000;
	/**
	 * @name getISOWeek
	 * @category ISO Week Helpers
	 * @summary Get the ISO week of the given date.
	 *
	 * @description
	 * Get the ISO week of the given date.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the ISO week
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Which week of the ISO-week numbering year is 2 January 2005?
	 * const result = getISOWeek(new Date(2005, 0, 2))
	 * //=> 53
	 */
	
	function getISOWeek(dirtyDate) {
	  (0, _index4.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var diff = (0, _index2.default)(date).getTime() - (0, _index3.default)(date).getTime(); // Round the number of days to the nearest integer
	  // because the number of milliseconds in a week is not constant
	  // (e.g. it's different in the week of the daylight saving time clock shift)
	
	  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
	}
	
	module.exports = exports.default;

/***/ },
/* 421 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getQuarter;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name getQuarter
	 * @category Quarter Helpers
	 * @summary Get the year quarter of the given date.
	 *
	 * @description
	 * Get the year quarter of the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the quarter
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Which quarter is 2 July 2014?
	 * const result = getQuarter(new Date(2014, 6, 2))
	 * //=> 3
	 */
	function getQuarter(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var quarter = Math.floor(date.getMonth() / 3) + 1;
	  return quarter;
	}
	
	module.exports = exports.default;

/***/ },
/* 422 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getTime;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name getTime
	 * @category Timestamp Helpers
	 * @summary Get the milliseconds timestamp of the given date.
	 *
	 * @description
	 * Get the milliseconds timestamp of the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the timestamp
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Get the timestamp of 29 February 2012 11:45:05.123:
	 * const result = getTime(new Date(2012, 1, 29, 11, 45, 5, 123))
	 * //=> 1330515905123
	 */
	function getTime(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var timestamp = date.getTime();
	  return timestamp;
	}
	
	module.exports = exports.default;

/***/ },
/* 423 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getWeek;
	
	var _index = _interopRequireDefault(__webpack_require__(96));
	
	var _index2 = _interopRequireDefault(__webpack_require__(288));
	
	var _index3 = _interopRequireDefault(__webpack_require__(3));
	
	var _index4 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MILLISECONDS_IN_WEEK = 604800000;
	/**
	 * @name getWeek
	 * @category Week Helpers
	 * @summary Get the local week index of the given date.
	 *
	 * @description
	 * Get the local week index of the given date.
	 * The exact calculation depends on the values of
	 * `options.weekStartsOn` (which is the index of the first day of the week)
	 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
	 * the first week of the week-numbering year)
	 *
	 * Week numbering: https://en.wikipedia.org/wiki/Week#Week_numbering
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the given date
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
	 * @returns {Number} the week
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
	 *
	 * @example
	 * // Which week of the local week numbering year is 2 January 2005 with default options?
	 * const result = getWeek(new Date(2005, 0, 2))
	 * //=> 2
	 *
	 * // Which week of the local week numbering year is 2 January 2005,
	 * // if Monday is the first day of the week,
	 * // and the first week of the year always contains 4 January?
	 * const result = getWeek(new Date(2005, 0, 2), {
	 *   weekStartsOn: 1,
	 *   firstWeekContainsDate: 4
	 * })
	 * //=> 53
	 */
	
	function getWeek(dirtyDate, options) {
	  (0, _index4.default)(1, arguments);
	  var date = (0, _index3.default)(dirtyDate);
	  var diff = (0, _index.default)(date, options).getTime() - (0, _index2.default)(date, options).getTime(); // Round the number of days to the nearest integer
	  // because the number of milliseconds in a week is not constant
	  // (e.g. it's different in the week of the daylight saving time clock shift)
	
	  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
	}
	
	module.exports = exports.default;

/***/ },
/* 424 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getWeekYear;
	
	var _index = _interopRequireDefault(__webpack_require__(96));
	
	var _index2 = _interopRequireDefault(__webpack_require__(3));
	
	var _index3 = _interopRequireDefault(__webpack_require__(19));
	
	var _index4 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name getWeekYear
	 * @category Week-Numbering Year Helpers
	 * @summary Get the local week-numbering year of the given date.
	 *
	 * @description
	 * Get the local week-numbering year of the given date.
	 * The exact calculation depends on the values of
	 * `options.weekStartsOn` (which is the index of the first day of the week)
	 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
	 * the first week of the week-numbering year)
	 *
	 * Week numbering: https://en.wikipedia.org/wiki/Week#Week_numbering
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the given date
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
	 * @returns {Number} the local week-numbering year
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
	 *
	 * @example
	 * // Which week numbering year is 26 December 2004 with the default settings?
	 * const result = getWeekYear(new Date(2004, 11, 26))
	 * //=> 2005
	 *
	 * @example
	 * // Which week numbering year is 26 December 2004 if week starts on Saturday?
	 * const result = getWeekYear(new Date(2004, 11, 26), { weekStartsOn: 6 })
	 * //=> 2004
	 *
	 * @example
	 * // Which week numbering year is 26 December 2004 if the first week contains 4 January?
	 * const result = getWeekYear(new Date(2004, 11, 26), { firstWeekContainsDate: 4 })
	 * //=> 2004
	 */
	function getWeekYear(dirtyDate, options) {
	  var _options$locale, _options$locale$optio;
	
	  (0, _index4.default)(1, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var year = date.getFullYear();
	  var localeFirstWeekContainsDate = options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate;
	  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : (0, _index3.default)(localeFirstWeekContainsDate);
	  var firstWeekContainsDate = (options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) == null ? defaultFirstWeekContainsDate : (0, _index3.default)(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
	
	  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
	    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
	  }
	
	  var firstWeekOfNextYear = new Date(0);
	  firstWeekOfNextYear.setFullYear(year + 1, 0, firstWeekContainsDate);
	  firstWeekOfNextYear.setHours(0, 0, 0, 0);
	  var startOfNextYear = (0, _index.default)(firstWeekOfNextYear, options);
	  var firstWeekOfThisYear = new Date(0);
	  firstWeekOfThisYear.setFullYear(year, 0, firstWeekContainsDate);
	  firstWeekOfThisYear.setHours(0, 0, 0, 0);
	  var startOfThisYear = (0, _index.default)(firstWeekOfThisYear, options);
	
	  if (date.getTime() >= startOfNextYear.getTime()) {
	    return year + 1;
	  } else if (date.getTime() >= startOfThisYear.getTime()) {
	    return year;
	  } else {
	    return year - 1;
	  }
	}
	
	module.exports = exports.default;

/***/ },
/* 425 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isDate;
	
	var _index = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isDate
	 * @category Common Helpers
	 * @summary Is the given value a date?
	 *
	 * @description
	 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {*} value - the value to check
	 * @returns {boolean} true if the given value is a date
	 * @throws {TypeError} 1 arguments required
	 *
	 * @example
	 * // For a valid date:
	 * const result = isDate(new Date())
	 * //=> true
	 *
	 * @example
	 * // For an invalid date:
	 * const result = isDate(new Date(NaN))
	 * //=> true
	 *
	 * @example
	 * // For some value:
	 * const result = isDate('2014-02-31')
	 * //=> false
	 *
	 * @example
	 * // For an object:
	 * const result = isDate({})
	 * //=> false
	 */
	function isDate(value) {
	  (0, _index.default)(1, arguments);
	  return value instanceof Date || typeof value === 'object' && Object.prototype.toString.call(value) === '[object Date]';
	}
	
	module.exports = exports.default;

/***/ },
/* 426 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isLastDayOfMonth;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(276));
	
	var _index3 = _interopRequireDefault(__webpack_require__(277));
	
	var _index4 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isLastDayOfMonth
	 * @category Month Helpers
	 * @summary Is the given date the last day of a month?
	 *
	 * @description
	 * Is the given date the last day of a month?
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is the last day of a month
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Is 28 February 2014 the last day of a month?
	 * var result = isLastDayOfMonth(new Date(2014, 1, 28))
	 * //=> true
	 */
	function isLastDayOfMonth(dirtyDate) {
	  (0, _index4.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  return (0, _index2.default)(date).getTime() === (0, _index3.default)(date).getTime();
	}
	
	module.exports = exports.default;

/***/ },
/* 427 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isLeapYear;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isLeapYear
	 * @category Year Helpers
	 * @summary Is the given date in the leap year?
	 *
	 * @description
	 * Is the given date in the leap year?
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is in the leap year
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Is 1 September 2012 in the leap year?
	 * var result = isLeapYear(new Date(2012, 8, 1))
	 * //=> true
	 */
	function isLeapYear(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var year = date.getFullYear();
	  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
	}
	
	module.exports = exports.default;

/***/ },
/* 428 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isSameHour;
	
	var _index = _interopRequireDefault(__webpack_require__(450));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isSameHour
	 * @category Hour Helpers
	 * @summary Are the given dates in the same hour (and same day)?
	 *
	 * @description
	 * Are the given dates in the same hour (and same day)?
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the first date to check
	 * @param {Date|Number} dateRight - the second date to check
	 * @returns {Boolean} the dates are in the same hour (and same day)
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Are 4 September 2014 06:00:00 and 4 September 06:30:00 in the same hour?
	 * var result = isSameHour(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 4, 6, 30))
	 * //=> true
	 * 
	 * @example
	 * // Are 4 September 2014 06:00:00 and 5 September 06:00:00 in the same hour?
	 * var result = isSameHour(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 5, 6, 0))
	 * //=> false
	 */
	function isSameHour(dirtyDateLeft, dirtyDateRight) {
	  (0, _index2.default)(2, arguments);
	  var dateLeftStartOfHour = (0, _index.default)(dirtyDateLeft);
	  var dateRightStartOfHour = (0, _index.default)(dirtyDateRight);
	  return dateLeftStartOfHour.getTime() === dateRightStartOfHour.getTime();
	}
	
	module.exports = exports.default;

/***/ },
/* 429 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isSameISOWeek;
	
	var _index = _interopRequireDefault(__webpack_require__(279));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isSameISOWeek
	 * @category ISO Week Helpers
	 * @summary Are the given dates in the same ISO week (and year)?
	 *
	 * @description
	 * Are the given dates in the same ISO week (and year)?
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the first date to check
	 * @param {Date|Number} dateRight - the second date to check
	 * @returns {Boolean} the dates are in the same ISO week (and year)
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Are 1 September 2014 and 7 September 2014 in the same ISO week?
	 * var result = isSameISOWeek(new Date(2014, 8, 1), new Date(2014, 8, 7))
	 * //=> true
	 *
	 * @example
	 * // Are 1 September 2014 and 1 September 2015 in the same ISO week?
	 * var result = isSameISOWeek(new Date(2014, 8, 1), new Date(2015, 8, 1))
	 * //=> false
	 */
	function isSameISOWeek(dirtyDateLeft, dirtyDateRight) {
	  (0, _index2.default)(2, arguments);
	  return (0, _index.default)(dirtyDateLeft, dirtyDateRight, {
	    weekStartsOn: 1
	  });
	}
	
	module.exports = exports.default;

/***/ },
/* 430 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isSameMinute;
	
	var _index = _interopRequireDefault(__webpack_require__(286));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isSameMinute
	 * @category Minute Helpers
	 * @summary Are the given dates in the same minute (and hour and day)?
	 *
	 * @description
	 * Are the given dates in the same minute (and hour and day)?
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the first date to check
	 * @param {Date|Number} dateRight - the second date to check
	 * @returns {Boolean} the dates are in the same minute (and hour and day)
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Are 4 September 2014 06:30:00 and 4 September 2014 06:30:15 in the same minute?
	 * var result = isSameMinute(
	 *   new Date(2014, 8, 4, 6, 30),
	 *   new Date(2014, 8, 4, 6, 30, 15)
	 * )
	 * //=> true
	 * 
	 * @example
	 * // Are 4 September 2014 06:30:00 and 5 September 2014 06:30:00 in the same minute?
	 * var result = isSameMinute(
	 *   new Date(2014, 8, 4, 6, 30),
	 *   new Date(2014, 8, 5, 6, 30)
	 * )
	 * //=> false
	 */
	function isSameMinute(dirtyDateLeft, dirtyDateRight) {
	  (0, _index2.default)(2, arguments);
	  var dateLeftStartOfMinute = (0, _index.default)(dirtyDateLeft);
	  var dateRightStartOfMinute = (0, _index.default)(dirtyDateRight);
	  return dateLeftStartOfMinute.getTime() === dateRightStartOfMinute.getTime();
	}
	
	module.exports = exports.default;

/***/ },
/* 431 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isSameMonth;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isSameMonth
	 * @category Month Helpers
	 * @summary Are the given dates in the same month (and year)?
	 *
	 * @description
	 * Are the given dates in the same month (and year)?
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the first date to check
	 * @param {Date|Number} dateRight - the second date to check
	 * @returns {Boolean} the dates are in the same month (and year)
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Are 2 September 2014 and 25 September 2014 in the same month?
	 * var result = isSameMonth(new Date(2014, 8, 2), new Date(2014, 8, 25))
	 * //=> true
	 *
	 * @example
	 * // Are 2 September 2014 and 25 September 2015 in the same month?
	 * var result = isSameMonth(new Date(2014, 8, 2), new Date(2015, 8, 25))
	 * //=> false
	 */
	function isSameMonth(dirtyDateLeft, dirtyDateRight) {
	  (0, _index2.default)(2, arguments);
	  var dateLeft = (0, _index.default)(dirtyDateLeft);
	  var dateRight = (0, _index.default)(dirtyDateRight);
	  return dateLeft.getFullYear() === dateRight.getFullYear() && dateLeft.getMonth() === dateRight.getMonth();
	}
	
	module.exports = exports.default;

/***/ },
/* 432 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isSameQuarter;
	
	var _index = _interopRequireDefault(__webpack_require__(287));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isSameQuarter
	 * @category Quarter Helpers
	 * @summary Are the given dates in the same quarter (and year)?
	 *
	 * @description
	 * Are the given dates in the same quarter (and year)?
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the first date to check
	 * @param {Date|Number} dateRight - the second date to check
	 * @returns {Boolean} the dates are in the same quarter (and year)
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Are 1 January 2014 and 8 March 2014 in the same quarter?
	 * var result = isSameQuarter(new Date(2014, 0, 1), new Date(2014, 2, 8))
	 * //=> true
	 * 
	 * @example
	 * // Are 1 January 2014 and 1 January 2015 in the same quarter?
	 * var result = isSameQuarter(new Date(2014, 0, 1), new Date(2015, 0, 1))
	 * //=> false
	 */
	function isSameQuarter(dirtyDateLeft, dirtyDateRight) {
	  (0, _index2.default)(2, arguments);
	  var dateLeftStartOfQuarter = (0, _index.default)(dirtyDateLeft);
	  var dateRightStartOfQuarter = (0, _index.default)(dirtyDateRight);
	  return dateLeftStartOfQuarter.getTime() === dateRightStartOfQuarter.getTime();
	}
	
	module.exports = exports.default;

/***/ },
/* 433 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isSameSecond;
	
	var _index = _interopRequireDefault(__webpack_require__(451));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isSameSecond
	 * @category Second Helpers
	 * @summary Are the given dates in the same second (and hour and day)?
	 *
	 * @description
	 * Are the given dates in the same second (and hour and day)?
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the first date to check
	 * @param {Date|Number} dateRight - the second date to check
	 * @returns {Boolean} the dates are in the same second (and hour and day)
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Are 4 September 2014 06:30:15.000 and 4 September 2014 06:30.15.500 in the same second?
	 * var result = isSameSecond(
	 *   new Date(2014, 8, 4, 6, 30, 15),
	 *   new Date(2014, 8, 4, 6, 30, 15, 500)
	 * )
	 * //=> true
	 * 
	 * @example
	 * // Are 4 September 2014 06:00:15.000 and 4 September 2014 06:01.15.000 in the same second?
	 * var result = isSameSecond(
	 *   new Date(2014, 8, 4, 6, 0, 15),
	 *   new Date(2014, 8, 4, 6, 1, 15)
	 * )
	 * //=> false
	 * 
	 * @example
	 * // Are 4 September 2014 06:00:15.000 and 5 September 2014 06:00.15.000 in the same second?
	 * var result = isSameSecond(
	 *   new Date(2014, 8, 4, 6, 0, 15),
	 *   new Date(2014, 8, 5, 6, 0, 15)
	 * )
	 * //=> false
	 */
	function isSameSecond(dirtyDateLeft, dirtyDateRight) {
	  (0, _index2.default)(2, arguments);
	  var dateLeftStartOfSecond = (0, _index.default)(dirtyDateLeft);
	  var dateRightStartOfSecond = (0, _index.default)(dirtyDateRight);
	  return dateLeftStartOfSecond.getTime() === dateRightStartOfSecond.getTime();
	}
	
	module.exports = exports.default;

/***/ },
/* 434 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isSameYear;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isSameYear
	 * @category Year Helpers
	 * @summary Are the given dates in the same year?
	 *
	 * @description
	 * Are the given dates in the same year?
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the first date to check
	 * @param {Date|Number} dateRight - the second date to check
	 * @returns {Boolean} the dates are in the same year
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Are 2 September 2014 and 25 September 2014 in the same year?
	 * var result = isSameYear(new Date(2014, 8, 2), new Date(2014, 8, 25))
	 * //=> true
	 */
	function isSameYear(dirtyDateLeft, dirtyDateRight) {
	  (0, _index2.default)(2, arguments);
	  var dateLeft = (0, _index.default)(dirtyDateLeft);
	  var dateRight = (0, _index.default)(dirtyDateRight);
	  return dateLeft.getFullYear() === dateRight.getFullYear();
	}
	
	module.exports = exports.default;

/***/ },
/* 435 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isSaturday;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isSaturday
	 * @category Weekday Helpers
	 * @summary Is the given date Saturday?
	 *
	 * @description
	 * Is the given date Saturday?
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is Saturday
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Is 27 September 2014 Saturday?
	 * var result = isSaturday(new Date(2014, 8, 27))
	 * //=> true
	 */
	function isSaturday(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(dirtyDate).getDay() === 6;
	}
	
	module.exports = exports.default;

/***/ },
/* 436 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = lastDayOfMonth;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name lastDayOfMonth
	 * @category Month Helpers
	 * @summary Return the last day of a month for the given date.
	 *
	 * @description
	 * Return the last day of a month for the given date.
	 * The result will be in the local timezone.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the last day of a month
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The last day of a month for 2 September 2014 11:55:00:
	 * var result = lastDayOfMonth(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Tue Sep 30 2014 00:00:00
	 */
	function lastDayOfMonth(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var month = date.getMonth();
	  date.setFullYear(date.getFullYear(), month + 1, 0);
	  date.setHours(0, 0, 0, 0);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 437 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = lastDayOfWeek;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(19));
	
	var _index3 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name lastDayOfWeek
	 * @category Week Helpers
	 * @summary Return the last day of a week for the given date.
	 *
	 * @description
	 * Return the last day of a week for the given date.
	 * The result will be in the local timezone.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @returns {Date} the last day of a week
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 *
	 * @example
	 * // The last day of a week for 2 September 2014 11:55:00:
	 * var result = lastDayOfWeek(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Sat Sep 06 2014 00:00:00
	 *
	 * @example
	 * // If the week starts on Monday, the last day of the week for 2 September 2014 11:55:00:
	 * var result = lastDayOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
	 * //=> Sun Sep 07 2014 00:00:00
	 */
	function lastDayOfWeek(dirtyDate, dirtyOptions) {
	  (0, _index3.default)(1, arguments);
	  var options = dirtyOptions || {};
	  var locale = options.locale;
	  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
	  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0, _index2.default)(localeWeekStartsOn);
	  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0, _index2.default)(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
	
	  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
	    throw new RangeError('weekStartsOn must be between 0 and 6');
	  }
	
	  var date = (0, _index.default)(dirtyDate);
	  var day = date.getDay();
	  var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
	  date.setHours(0, 0, 0, 0);
	  date.setDate(date.getDate() + diff);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 438 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.numberToLocale = numberToLocale;
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var numberValues = {
	  locale: {
	    '1': '১',
	    '2': '২',
	    '3': '৩',
	    '4': '৪',
	    '5': '৫',
	    '6': '৬',
	    '7': '৭',
	    '8': '৮',
	    '9': '৯',
	    '0': '০'
	  },
	  number: {
	    '১': '1',
	    '২': '2',
	    '৩': '3',
	    '৪': '4',
	    '৫': '5',
	    '৬': '6',
	    '৭': '7',
	    '৮': '8',
	    '৯': '9',
	    '০': '0'
	  }
	};
	var eraValues = {
	  narrow: ['খ্রিঃপূঃ', 'খ্রিঃ'],
	  abbreviated: ['খ্রিঃপূর্ব', 'খ্রিঃ'],
	  wide: ['খ্রিস্টপূর্ব', 'খ্রিস্টাব্দ']
	};
	var quarterValues = {
	  narrow: ['১', '২', '৩', '৪'],
	  abbreviated: ['১ত্রৈ', '২ত্রৈ', '৩ত্রৈ', '৪ত্রৈ'],
	  wide: ['১ম ত্রৈমাসিক', '২য় ত্রৈমাসিক', '৩য় ত্রৈমাসিক', '৪র্থ ত্রৈমাসিক']
	};
	var monthValues = {
	  narrow: ['জানু', 'ফেব্রু', 'মার্চ', 'এপ্রিল', 'মে', 'জুন', 'জুলাই', 'আগস্ট', 'সেপ্ট', 'অক্টো', 'নভে', 'ডিসে'],
	  abbreviated: ['জানু', 'ফেব্রু', 'মার্চ', 'এপ্রিল', 'মে', 'জুন', 'জুলাই', 'আগস্ট', 'সেপ্ট', 'অক্টো', 'নভে', 'ডিসে'],
	  wide: ['জানুয়ারি', 'ফেব্রুয়ারি', 'মার্চ', 'এপ্রিল', 'মে', 'জুন', 'জুলাই', 'আগস্ট', 'সেপ্টেম্বর', 'অক্টোবর', 'নভেম্বর', 'ডিসেম্বর']
	};
	var dayValues = {
	  narrow: ['র', 'সো', 'ম', 'বু', 'বৃ', 'শু', 'শ'],
	  short: ['রবি', 'সোম', 'মঙ্গল', 'বুধ', 'বৃহ', 'শুক্র', 'শনি'],
	  abbreviated: ['রবি', 'সোম', 'মঙ্গল', 'বুধ', 'বৃহ', 'শুক্র', 'শনি'],
	  wide: ['রবিবার', 'সোমবার', 'মঙ্গলবার', 'বুধবার', 'বৃহস্পতিবার ', 'শুক্রবার', 'শনিবার']
	};
	var dayPeriodValues = {
	  narrow: {
	    am: 'পূ',
	    pm: 'অপ',
	    midnight: 'মধ্যরাত',
	    noon: 'মধ্যাহ্ন',
	    morning: 'সকাল',
	    afternoon: 'বিকাল',
	    evening: 'সন্ধ্যা',
	    night: 'রাত'
	  },
	  abbreviated: {
	    am: 'পূর্বাহ্ন',
	    pm: 'অপরাহ্ন',
	    midnight: 'মধ্যরাত',
	    noon: 'মধ্যাহ্ন',
	    morning: 'সকাল',
	    afternoon: 'বিকাল',
	    evening: 'সন্ধ্যা',
	    night: 'রাত'
	  },
	  wide: {
	    am: 'পূর্বাহ্ন',
	    pm: 'অপরাহ্ন',
	    midnight: 'মধ্যরাত',
	    noon: 'মধ্যাহ্ন',
	    morning: 'সকাল',
	    afternoon: 'বিকাল',
	    evening: 'সন্ধ্যা',
	    night: 'রাত'
	  }
	};
	var formattingDayPeriodValues = {
	  narrow: {
	    am: 'পূ',
	    pm: 'অপ',
	    midnight: 'মধ্যরাত',
	    noon: 'মধ্যাহ্ন',
	    morning: 'সকাল',
	    afternoon: 'বিকাল',
	    evening: 'সন্ধ্যা',
	    night: 'রাত'
	  },
	  abbreviated: {
	    am: 'পূর্বাহ্ন',
	    pm: 'অপরাহ্ন',
	    midnight: 'মধ্যরাত',
	    noon: 'মধ্যাহ্ন',
	    morning: 'সকাল',
	    afternoon: 'বিকাল',
	    evening: 'সন্ধ্যা',
	    night: 'রাত'
	  },
	  wide: {
	    am: 'পূর্বাহ্ন',
	    pm: 'অপরাহ্ন',
	    midnight: 'মধ্যরাত',
	    noon: 'মধ্যাহ্ন',
	    morning: 'সকাল',
	    afternoon: 'বিকাল',
	    evening: 'সন্ধ্যা',
	    night: 'রাত'
	  }
	};
	
	function dateOrdinalNumber(number, localeNumber) {
	  if (number > 18 && number <= 31) {
	    return localeNumber + 'শে';
	  } else {
	    switch (number) {
	      case 1:
	        return localeNumber + 'লা';
	
	      case 2:
	      case 3:
	        return localeNumber + 'রা';
	
	      case 4:
	        return localeNumber + 'ঠা';
	
	      default:
	        return localeNumber + 'ই';
	    }
	  }
	}
	
	var ordinalNumber = function (dirtyNumber, dirtyOptions) {
	  var number = Number(dirtyNumber);
	  var localeNumber = numberToLocale(number);
	  var unit = dirtyOptions === null || dirtyOptions === void 0 ? void 0 : dirtyOptions.unit;
	
	  if (unit === 'date') {
	    return dateOrdinalNumber(number, localeNumber);
	  }
	
	  if (number > 10 || number === 0) return localeNumber + 'তম';
	  var rem10 = number % 10;
	
	  switch (rem10) {
	    case 2:
	    case 3:
	      return localeNumber + 'য়';
	
	    case 4:
	      return localeNumber + 'র্থ';
	
	    case 6:
	      return localeNumber + 'ষ্ঠ';
	
	    default:
	      return localeNumber + 'ম';
	  }
	}; // function localeToNumber(locale: string): number {
	//   const enNumber = locale.toString().replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
	//     return numberValues.number[match as keyof typeof numberValues.number]
	//   })
	//   return Number(enNumber)
	// }
	
	
	function numberToLocale(enNumber) {
	  return enNumber.toString().replace(/\d/g, function (match) {
	    return numberValues.locale[match];
	  });
	}
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return quarter - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingDayPeriodValues,
	    defaultFormattingWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;

/***/ },
/* 439 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    standalone: {
	      one: 'weniger als 1 Sekunde',
	      other: 'weniger als {{count}} Sekunden'
	    },
	    withPreposition: {
	      one: 'weniger als 1 Sekunde',
	      other: 'weniger als {{count}} Sekunden'
	    }
	  },
	  xSeconds: {
	    standalone: {
	      one: '1 Sekunde',
	      other: '{{count}} Sekunden'
	    },
	    withPreposition: {
	      one: '1 Sekunde',
	      other: '{{count}} Sekunden'
	    }
	  },
	  halfAMinute: {
	    standalone: 'halbe Minute',
	    withPreposition: 'halben Minute'
	  },
	  lessThanXMinutes: {
	    standalone: {
	      one: 'weniger als 1 Minute',
	      other: 'weniger als {{count}} Minuten'
	    },
	    withPreposition: {
	      one: 'weniger als 1 Minute',
	      other: 'weniger als {{count}} Minuten'
	    }
	  },
	  xMinutes: {
	    standalone: {
	      one: '1 Minute',
	      other: '{{count}} Minuten'
	    },
	    withPreposition: {
	      one: '1 Minute',
	      other: '{{count}} Minuten'
	    }
	  },
	  aboutXHours: {
	    standalone: {
	      one: 'etwa 1 Stunde',
	      other: 'etwa {{count}} Stunden'
	    },
	    withPreposition: {
	      one: 'etwa 1 Stunde',
	      other: 'etwa {{count}} Stunden'
	    }
	  },
	  xHours: {
	    standalone: {
	      one: '1 Stunde',
	      other: '{{count}} Stunden'
	    },
	    withPreposition: {
	      one: '1 Stunde',
	      other: '{{count}} Stunden'
	    }
	  },
	  xDays: {
	    standalone: {
	      one: '1 Tag',
	      other: '{{count}} Tage'
	    },
	    withPreposition: {
	      one: '1 Tag',
	      other: '{{count}} Tagen'
	    }
	  },
	  aboutXWeeks: {
	    standalone: {
	      one: 'etwa 1 Woche',
	      other: 'etwa {{count}} Wochen'
	    },
	    withPreposition: {
	      one: 'etwa 1 Woche',
	      other: 'etwa {{count}} Wochen'
	    }
	  },
	  xWeeks: {
	    standalone: {
	      one: '1 Woche',
	      other: '{{count}} Wochen'
	    },
	    withPreposition: {
	      one: '1 Woche',
	      other: '{{count}} Wochen'
	    }
	  },
	  aboutXMonths: {
	    standalone: {
	      one: 'etwa 1 Monat',
	      other: 'etwa {{count}} Monate'
	    },
	    withPreposition: {
	      one: 'etwa 1 Monat',
	      other: 'etwa {{count}} Monaten'
	    }
	  },
	  xMonths: {
	    standalone: {
	      one: '1 Monat',
	      other: '{{count}} Monate'
	    },
	    withPreposition: {
	      one: '1 Monat',
	      other: '{{count}} Monaten'
	    }
	  },
	  aboutXYears: {
	    standalone: {
	      one: 'etwa 1 Jahr',
	      other: 'etwa {{count}} Jahre'
	    },
	    withPreposition: {
	      one: 'etwa 1 Jahr',
	      other: 'etwa {{count}} Jahren'
	    }
	  },
	  xYears: {
	    standalone: {
	      one: '1 Jahr',
	      other: '{{count}} Jahre'
	    },
	    withPreposition: {
	      one: '1 Jahr',
	      other: '{{count}} Jahren'
	    }
	  },
	  overXYears: {
	    standalone: {
	      one: 'mehr als 1 Jahr',
	      other: 'mehr als {{count}} Jahre'
	    },
	    withPreposition: {
	      one: 'mehr als 1 Jahr',
	      other: 'mehr als {{count}} Jahren'
	    }
	  },
	  almostXYears: {
	    standalone: {
	      one: 'fast 1 Jahr',
	      other: 'fast {{count}} Jahre'
	    },
	    withPreposition: {
	      one: 'fast 1 Jahr',
	      other: 'fast {{count}} Jahren'
	    }
	  }
	};
	
	var formatDistance = function (token, count, options) {
	  var result;
	  var tokenValue = options !== null && options !== void 0 && options.addSuffix ? formatDistanceLocale[token].withPreposition : formatDistanceLocale[token].standalone;
	
	  if (typeof tokenValue === 'string') {
	    result = tokenValue;
	  } else if (count === 1) {
	    result = tokenValue.one;
	  } else {
	    result = tokenValue.other.replace('{{count}}', String(count));
	  }
	
	  if (options !== null && options !== void 0 && options.addSuffix) {
	    if (options.comparison && options.comparison > 0) {
	      return 'in ' + result;
	    } else {
	      return 'vor ' + result;
	    }
	  }
	
	  return result;
	};
	
	var _default = formatDistance;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 440 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// DIN 5008: https://de.wikipedia.org/wiki/Datumsformat#DIN_5008
	var dateFormats = {
	  full: 'EEEE, do MMMM y',
	  // Montag, 7. Januar 2018
	  long: 'do MMMM y',
	  // 7. Januar 2018
	  medium: 'do MMM y',
	  // 7. Jan. 2018
	  short: 'dd.MM.y' // 07.01.2018
	
	};
	var timeFormats = {
	  full: 'HH:mm:ss zzzz',
	  long: 'HH:mm:ss z',
	  medium: 'HH:mm:ss',
	  short: 'HH:mm'
	};
	var dateTimeFormats = {
	  full: "{{date}} 'um' {{time}}",
	  long: "{{date}} 'um' {{time}}",
	  medium: '{{date}} {{time}}',
	  short: '{{date}} {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 441 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var formatRelativeLocale = {
	  lastWeek: "'letzten' eeee 'um' p",
	  yesterday: "'gestern um' p",
	  today: "'heute um' p",
	  tomorrow: "'morgen um' p",
	  nextWeek: "eeee 'um' p",
	  other: 'P'
	};
	
	var formatRelative = function (token, _date, _baseDate, _options) {
	  return formatRelativeLocale[token];
	};
	
	var _default = formatRelative;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 442 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(14));
	
	var _index2 = _interopRequireDefault(__webpack_require__(15));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(\d+)(\.)?/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
	  abbreviated: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
	  wide: /^(vor Christus|vor unserer Zeitrechnung|nach Christus|unserer Zeitrechnung)/i
	};
	var parseEraPatterns = {
	  any: [/^v/i, /^n/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^q[1234]/i,
	  wide: /^[1234](\.)? Quartal/i
	};
	var parseQuarterPatterns = {
	  any: [/1/i, /2/i, /3/i, /4/i]
	};
	var matchMonthPatterns = {
	  narrow: /^[jfmasond]/i,
	  abbreviated: /^(j[aä]n|feb|mär[z]?|apr|mai|jun[i]?|jul[i]?|aug|sep|okt|nov|dez)\.?/i,
	  wide: /^(januar|februar|märz|april|mai|juni|juli|august|september|oktober|november|dezember)/i
	};
	var parseMonthPatterns = {
	  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
	  any: [/^j[aä]/i, /^f/i, /^mär/i, /^ap/i, /^mai/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
	};
	var matchDayPatterns = {
	  narrow: /^[smdmf]/i,
	  short: /^(so|mo|di|mi|do|fr|sa)/i,
	  abbreviated: /^(son?|mon?|die?|mit?|don?|fre?|sam?)\.?/i,
	  wide: /^(sonntag|montag|dienstag|mittwoch|donnerstag|freitag|samstag)/i
	};
	var parseDayPatterns = {
	  any: [/^so/i, /^mo/i, /^di/i, /^mi/i, /^do/i, /^f/i, /^sa/i]
	};
	var matchDayPeriodPatterns = {
	  narrow: /^(vm\.?|nm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
	  abbreviated: /^(vorm\.?|nachm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
	  wide: /^(vormittags|nachmittags|Mitternacht|Mittag|morgens|nachmittags|abends|nachts)/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^v/i,
	    pm: /^n/i,
	    midnight: /^Mitte/i,
	    noon: /^Mitta/i,
	    morning: /morgens/i,
	    afternoon: /nachmittags/i,
	    // will never be matched. Afternoon is matched by `pm`
	    evening: /abends/i,
	    night: /nachts/i // will never be matched. Night is matched by `pm`
	
	  }
	};
	var match = {
	  ordinalNumber: (0, _index2.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value);
	    }
	  }),
	  era: (0, _index.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 443 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: 'EEEE, d MMMM yyyy',
	  long: 'd MMMM yyyy',
	  medium: 'd MMM yyyy',
	  short: 'dd/MM/yyyy'
	};
	var timeFormats = {
	  full: 'HH:mm:ss zzzz',
	  long: 'HH:mm:ss z',
	  medium: 'HH:mm:ss',
	  short: 'HH:mm'
	};
	var dateTimeFormats = {
	  full: "{{date}} 'at' {{time}}",
	  long: "{{date}} 'at' {{time}}",
	  medium: '{{date}}, {{time}}',
	  short: '{{date}}, {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 444 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var formatRelativeLocale = {
	  lastWeek: "eeee 'dernier à' p",
	  yesterday: "'hier à' p",
	  today: "'aujourd’hui à' p",
	  tomorrow: "'demain à' p'",
	  nextWeek: "eeee 'prochain à' p",
	  other: 'P'
	};
	
	var formatRelative = function (token, _date, _baseDate, _options) {
	  return formatRelativeLocale[token];
	};
	
	var _default = formatRelative;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 445 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "af", {
	  enumerable: true,
	  get: function () {
	    return _index.default;
	  }
	});
	Object.defineProperty(exports, "ar", {
	  enumerable: true,
	  get: function () {
	    return _index2.default;
	  }
	});
	Object.defineProperty(exports, "arDZ", {
	  enumerable: true,
	  get: function () {
	    return _index3.default;
	  }
	});
	Object.defineProperty(exports, "arEG", {
	  enumerable: true,
	  get: function () {
	    return _index4.default;
	  }
	});
	Object.defineProperty(exports, "arMA", {
	  enumerable: true,
	  get: function () {
	    return _index5.default;
	  }
	});
	Object.defineProperty(exports, "arSA", {
	  enumerable: true,
	  get: function () {
	    return _index6.default;
	  }
	});
	Object.defineProperty(exports, "arTN", {
	  enumerable: true,
	  get: function () {
	    return _index7.default;
	  }
	});
	Object.defineProperty(exports, "az", {
	  enumerable: true,
	  get: function () {
	    return _index8.default;
	  }
	});
	Object.defineProperty(exports, "be", {
	  enumerable: true,
	  get: function () {
	    return _index9.default;
	  }
	});
	Object.defineProperty(exports, "bg", {
	  enumerable: true,
	  get: function () {
	    return _index10.default;
	  }
	});
	Object.defineProperty(exports, "bn", {
	  enumerable: true,
	  get: function () {
	    return _index11.default;
	  }
	});
	Object.defineProperty(exports, "bs", {
	  enumerable: true,
	  get: function () {
	    return _index12.default;
	  }
	});
	Object.defineProperty(exports, "ca", {
	  enumerable: true,
	  get: function () {
	    return _index13.default;
	  }
	});
	Object.defineProperty(exports, "cs", {
	  enumerable: true,
	  get: function () {
	    return _index14.default;
	  }
	});
	Object.defineProperty(exports, "cy", {
	  enumerable: true,
	  get: function () {
	    return _index15.default;
	  }
	});
	Object.defineProperty(exports, "da", {
	  enumerable: true,
	  get: function () {
	    return _index16.default;
	  }
	});
	Object.defineProperty(exports, "de", {
	  enumerable: true,
	  get: function () {
	    return _index17.default;
	  }
	});
	Object.defineProperty(exports, "deAT", {
	  enumerable: true,
	  get: function () {
	    return _index18.default;
	  }
	});
	Object.defineProperty(exports, "el", {
	  enumerable: true,
	  get: function () {
	    return _index19.default;
	  }
	});
	Object.defineProperty(exports, "enAU", {
	  enumerable: true,
	  get: function () {
	    return _index20.default;
	  }
	});
	Object.defineProperty(exports, "enCA", {
	  enumerable: true,
	  get: function () {
	    return _index21.default;
	  }
	});
	Object.defineProperty(exports, "enGB", {
	  enumerable: true,
	  get: function () {
	    return _index22.default;
	  }
	});
	Object.defineProperty(exports, "enIE", {
	  enumerable: true,
	  get: function () {
	    return _index23.default;
	  }
	});
	Object.defineProperty(exports, "enIN", {
	  enumerable: true,
	  get: function () {
	    return _index24.default;
	  }
	});
	Object.defineProperty(exports, "enNZ", {
	  enumerable: true,
	  get: function () {
	    return _index25.default;
	  }
	});
	Object.defineProperty(exports, "enUS", {
	  enumerable: true,
	  get: function () {
	    return _index26.default;
	  }
	});
	Object.defineProperty(exports, "enZA", {
	  enumerable: true,
	  get: function () {
	    return _index27.default;
	  }
	});
	Object.defineProperty(exports, "eo", {
	  enumerable: true,
	  get: function () {
	    return _index28.default;
	  }
	});
	Object.defineProperty(exports, "es", {
	  enumerable: true,
	  get: function () {
	    return _index29.default;
	  }
	});
	Object.defineProperty(exports, "et", {
	  enumerable: true,
	  get: function () {
	    return _index30.default;
	  }
	});
	Object.defineProperty(exports, "eu", {
	  enumerable: true,
	  get: function () {
	    return _index31.default;
	  }
	});
	Object.defineProperty(exports, "faIR", {
	  enumerable: true,
	  get: function () {
	    return _index32.default;
	  }
	});
	Object.defineProperty(exports, "fi", {
	  enumerable: true,
	  get: function () {
	    return _index33.default;
	  }
	});
	Object.defineProperty(exports, "fr", {
	  enumerable: true,
	  get: function () {
	    return _index34.default;
	  }
	});
	Object.defineProperty(exports, "frCA", {
	  enumerable: true,
	  get: function () {
	    return _index35.default;
	  }
	});
	Object.defineProperty(exports, "frCH", {
	  enumerable: true,
	  get: function () {
	    return _index36.default;
	  }
	});
	Object.defineProperty(exports, "fy", {
	  enumerable: true,
	  get: function () {
	    return _index37.default;
	  }
	});
	Object.defineProperty(exports, "gd", {
	  enumerable: true,
	  get: function () {
	    return _index38.default;
	  }
	});
	Object.defineProperty(exports, "gl", {
	  enumerable: true,
	  get: function () {
	    return _index39.default;
	  }
	});
	Object.defineProperty(exports, "gu", {
	  enumerable: true,
	  get: function () {
	    return _index40.default;
	  }
	});
	Object.defineProperty(exports, "he", {
	  enumerable: true,
	  get: function () {
	    return _index41.default;
	  }
	});
	Object.defineProperty(exports, "hi", {
	  enumerable: true,
	  get: function () {
	    return _index42.default;
	  }
	});
	Object.defineProperty(exports, "hr", {
	  enumerable: true,
	  get: function () {
	    return _index43.default;
	  }
	});
	Object.defineProperty(exports, "ht", {
	  enumerable: true,
	  get: function () {
	    return _index44.default;
	  }
	});
	Object.defineProperty(exports, "hu", {
	  enumerable: true,
	  get: function () {
	    return _index45.default;
	  }
	});
	Object.defineProperty(exports, "hy", {
	  enumerable: true,
	  get: function () {
	    return _index46.default;
	  }
	});
	Object.defineProperty(exports, "id", {
	  enumerable: true,
	  get: function () {
	    return _index47.default;
	  }
	});
	Object.defineProperty(exports, "is", {
	  enumerable: true,
	  get: function () {
	    return _index48.default;
	  }
	});
	Object.defineProperty(exports, "it", {
	  enumerable: true,
	  get: function () {
	    return _index49.default;
	  }
	});
	Object.defineProperty(exports, "ja", {
	  enumerable: true,
	  get: function () {
	    return _index50.default;
	  }
	});
	Object.defineProperty(exports, "jaHira", {
	  enumerable: true,
	  get: function () {
	    return _index51.default;
	  }
	});
	Object.defineProperty(exports, "ka", {
	  enumerable: true,
	  get: function () {
	    return _index52.default;
	  }
	});
	Object.defineProperty(exports, "kk", {
	  enumerable: true,
	  get: function () {
	    return _index53.default;
	  }
	});
	Object.defineProperty(exports, "km", {
	  enumerable: true,
	  get: function () {
	    return _index54.default;
	  }
	});
	Object.defineProperty(exports, "kn", {
	  enumerable: true,
	  get: function () {
	    return _index55.default;
	  }
	});
	Object.defineProperty(exports, "ko", {
	  enumerable: true,
	  get: function () {
	    return _index56.default;
	  }
	});
	Object.defineProperty(exports, "lb", {
	  enumerable: true,
	  get: function () {
	    return _index57.default;
	  }
	});
	Object.defineProperty(exports, "lt", {
	  enumerable: true,
	  get: function () {
	    return _index58.default;
	  }
	});
	Object.defineProperty(exports, "lv", {
	  enumerable: true,
	  get: function () {
	    return _index59.default;
	  }
	});
	Object.defineProperty(exports, "mk", {
	  enumerable: true,
	  get: function () {
	    return _index60.default;
	  }
	});
	Object.defineProperty(exports, "mn", {
	  enumerable: true,
	  get: function () {
	    return _index61.default;
	  }
	});
	Object.defineProperty(exports, "ms", {
	  enumerable: true,
	  get: function () {
	    return _index62.default;
	  }
	});
	Object.defineProperty(exports, "mt", {
	  enumerable: true,
	  get: function () {
	    return _index63.default;
	  }
	});
	Object.defineProperty(exports, "nb", {
	  enumerable: true,
	  get: function () {
	    return _index64.default;
	  }
	});
	Object.defineProperty(exports, "nl", {
	  enumerable: true,
	  get: function () {
	    return _index65.default;
	  }
	});
	Object.defineProperty(exports, "nlBE", {
	  enumerable: true,
	  get: function () {
	    return _index66.default;
	  }
	});
	Object.defineProperty(exports, "nn", {
	  enumerable: true,
	  get: function () {
	    return _index67.default;
	  }
	});
	Object.defineProperty(exports, "pl", {
	  enumerable: true,
	  get: function () {
	    return _index68.default;
	  }
	});
	Object.defineProperty(exports, "pt", {
	  enumerable: true,
	  get: function () {
	    return _index69.default;
	  }
	});
	Object.defineProperty(exports, "ptBR", {
	  enumerable: true,
	  get: function () {
	    return _index70.default;
	  }
	});
	Object.defineProperty(exports, "ro", {
	  enumerable: true,
	  get: function () {
	    return _index71.default;
	  }
	});
	Object.defineProperty(exports, "ru", {
	  enumerable: true,
	  get: function () {
	    return _index72.default;
	  }
	});
	Object.defineProperty(exports, "sk", {
	  enumerable: true,
	  get: function () {
	    return _index73.default;
	  }
	});
	Object.defineProperty(exports, "sl", {
	  enumerable: true,
	  get: function () {
	    return _index74.default;
	  }
	});
	Object.defineProperty(exports, "sq", {
	  enumerable: true,
	  get: function () {
	    return _index75.default;
	  }
	});
	Object.defineProperty(exports, "sr", {
	  enumerable: true,
	  get: function () {
	    return _index76.default;
	  }
	});
	Object.defineProperty(exports, "srLatn", {
	  enumerable: true,
	  get: function () {
	    return _index77.default;
	  }
	});
	Object.defineProperty(exports, "sv", {
	  enumerable: true,
	  get: function () {
	    return _index78.default;
	  }
	});
	Object.defineProperty(exports, "ta", {
	  enumerable: true,
	  get: function () {
	    return _index79.default;
	  }
	});
	Object.defineProperty(exports, "te", {
	  enumerable: true,
	  get: function () {
	    return _index80.default;
	  }
	});
	Object.defineProperty(exports, "th", {
	  enumerable: true,
	  get: function () {
	    return _index81.default;
	  }
	});
	Object.defineProperty(exports, "tr", {
	  enumerable: true,
	  get: function () {
	    return _index82.default;
	  }
	});
	Object.defineProperty(exports, "ug", {
	  enumerable: true,
	  get: function () {
	    return _index83.default;
	  }
	});
	Object.defineProperty(exports, "uk", {
	  enumerable: true,
	  get: function () {
	    return _index84.default;
	  }
	});
	Object.defineProperty(exports, "uz", {
	  enumerable: true,
	  get: function () {
	    return _index85.default;
	  }
	});
	Object.defineProperty(exports, "uzCyrl", {
	  enumerable: true,
	  get: function () {
	    return _index86.default;
	  }
	});
	Object.defineProperty(exports, "vi", {
	  enumerable: true,
	  get: function () {
	    return _index87.default;
	  }
	});
	Object.defineProperty(exports, "zhCN", {
	  enumerable: true,
	  get: function () {
	    return _index88.default;
	  }
	});
	Object.defineProperty(exports, "zhHK", {
	  enumerable: true,
	  get: function () {
	    return _index89.default;
	  }
	});
	Object.defineProperty(exports, "zhTW", {
	  enumerable: true,
	  get: function () {
	    return _index90.default;
	  }
	});
	
	var _index = _interopRequireDefault(__webpack_require__(1035));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1071));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1041));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1047));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1053));
	
	var _index6 = _interopRequireDefault(__webpack_require__(1059));
	
	var _index7 = _interopRequireDefault(__webpack_require__(1065));
	
	var _index8 = _interopRequireDefault(__webpack_require__(1077));
	
	var _index9 = _interopRequireDefault(__webpack_require__(1083));
	
	var _index10 = _interopRequireDefault(__webpack_require__(1089));
	
	var _index11 = _interopRequireDefault(__webpack_require__(1094));
	
	var _index12 = _interopRequireDefault(__webpack_require__(1100));
	
	var _index13 = _interopRequireDefault(__webpack_require__(1106));
	
	var _index14 = _interopRequireDefault(__webpack_require__(1112));
	
	var _index15 = _interopRequireDefault(__webpack_require__(1118));
	
	var _index16 = _interopRequireDefault(__webpack_require__(1124));
	
	var _index17 = _interopRequireDefault(__webpack_require__(1128));
	
	var _index18 = _interopRequireDefault(__webpack_require__(1126));
	
	var _index19 = _interopRequireDefault(__webpack_require__(1134));
	
	var _index20 = _interopRequireDefault(__webpack_require__(1136));
	
	var _index21 = _interopRequireDefault(__webpack_require__(1139));
	
	var _index22 = _interopRequireDefault(__webpack_require__(1140));
	
	var _index23 = _interopRequireDefault(__webpack_require__(1141));
	
	var _index24 = _interopRequireDefault(__webpack_require__(1143));
	
	var _index25 = _interopRequireDefault(__webpack_require__(1145));
	
	var _index26 = _interopRequireDefault(__webpack_require__(108));
	
	var _index27 = _interopRequireDefault(__webpack_require__(1148));
	
	var _index28 = _interopRequireDefault(__webpack_require__(1154));
	
	var _index29 = _interopRequireDefault(__webpack_require__(1160));
	
	var _index30 = _interopRequireDefault(__webpack_require__(1166));
	
	var _index31 = _interopRequireDefault(__webpack_require__(1172));
	
	var _index32 = _interopRequireDefault(__webpack_require__(1178));
	
	var _index33 = _interopRequireDefault(__webpack_require__(1184));
	
	var _index34 = _interopRequireDefault(__webpack_require__(1191));
	
	var _index35 = _interopRequireDefault(__webpack_require__(1186));
	
	var _index36 = _interopRequireDefault(__webpack_require__(1189));
	
	var _index37 = _interopRequireDefault(__webpack_require__(1197));
	
	var _index38 = _interopRequireDefault(__webpack_require__(1203));
	
	var _index39 = _interopRequireDefault(__webpack_require__(1209));
	
	var _index40 = _interopRequireDefault(__webpack_require__(1215));
	
	var _index41 = _interopRequireDefault(__webpack_require__(1221));
	
	var _index42 = _interopRequireDefault(__webpack_require__(1226));
	
	var _index43 = _interopRequireDefault(__webpack_require__(1232));
	
	var _index44 = _interopRequireDefault(__webpack_require__(1238));
	
	var _index45 = _interopRequireDefault(__webpack_require__(1244));
	
	var _index46 = _interopRequireDefault(__webpack_require__(1250));
	
	var _index47 = _interopRequireDefault(__webpack_require__(1256));
	
	var _index48 = _interopRequireDefault(__webpack_require__(1262));
	
	var _index49 = _interopRequireDefault(__webpack_require__(1268));
	
	var _index50 = _interopRequireDefault(__webpack_require__(1280));
	
	var _index51 = _interopRequireDefault(__webpack_require__(1274));
	
	var _index52 = _interopRequireDefault(__webpack_require__(1286));
	
	var _index53 = _interopRequireDefault(__webpack_require__(1292));
	
	var _index54 = _interopRequireDefault(__webpack_require__(1298));
	
	var _index55 = _interopRequireDefault(__webpack_require__(1304));
	
	var _index56 = _interopRequireDefault(__webpack_require__(1310));
	
	var _index57 = _interopRequireDefault(__webpack_require__(1316));
	
	var _index58 = _interopRequireDefault(__webpack_require__(1322));
	
	var _index59 = _interopRequireDefault(__webpack_require__(1328));
	
	var _index60 = _interopRequireDefault(__webpack_require__(1334));
	
	var _index61 = _interopRequireDefault(__webpack_require__(1340));
	
	var _index62 = _interopRequireDefault(__webpack_require__(1346));
	
	var _index63 = _interopRequireDefault(__webpack_require__(1352));
	
	var _index64 = _interopRequireDefault(__webpack_require__(1358));
	
	var _index65 = _interopRequireDefault(__webpack_require__(1370));
	
	var _index66 = _interopRequireDefault(__webpack_require__(1364));
	
	var _index67 = _interopRequireDefault(__webpack_require__(1376));
	
	var _index68 = _interopRequireDefault(__webpack_require__(1382));
	
	var _index69 = _interopRequireDefault(__webpack_require__(1394));
	
	var _index70 = _interopRequireDefault(__webpack_require__(1388));
	
	var _index71 = _interopRequireDefault(__webpack_require__(1400));
	
	var _index72 = _interopRequireDefault(__webpack_require__(1406));
	
	var _index73 = _interopRequireDefault(__webpack_require__(1412));
	
	var _index74 = _interopRequireDefault(__webpack_require__(1418));
	
	var _index75 = _interopRequireDefault(__webpack_require__(1424));
	
	var _index76 = _interopRequireDefault(__webpack_require__(1436));
	
	var _index77 = _interopRequireDefault(__webpack_require__(1430));
	
	var _index78 = _interopRequireDefault(__webpack_require__(1442));
	
	var _index79 = _interopRequireDefault(__webpack_require__(1448));
	
	var _index80 = _interopRequireDefault(__webpack_require__(1454));
	
	var _index81 = _interopRequireDefault(__webpack_require__(1460));
	
	var _index82 = _interopRequireDefault(__webpack_require__(1466));
	
	var _index83 = _interopRequireDefault(__webpack_require__(1472));
	
	var _index84 = _interopRequireDefault(__webpack_require__(1478));
	
	var _index85 = _interopRequireDefault(__webpack_require__(1490));
	
	var _index86 = _interopRequireDefault(__webpack_require__(1484));
	
	var _index87 = _interopRequireDefault(__webpack_require__(1496));
	
	var _index88 = _interopRequireDefault(__webpack_require__(1502));
	
	var _index89 = _interopRequireDefault(__webpack_require__(1508));
	
	var _index90 = _interopRequireDefault(__webpack_require__(1514));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 446 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = max;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name max
	 * @category Common Helpers
	 * @summary Return the latest of the given dates.
	 *
	 * @description
	 * Return the latest of the given dates.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * - `max` function now accepts an array of dates rather than spread arguments.
	 *
	 *   ```javascript
	 *   // Before v2.0.0
	 *   var date1 = new Date(1989, 6, 10)
	 *   var date2 = new Date(1987, 1, 11)
	 *   var maxDate = max(date1, date2)
	 *
	 *   // v2.0.0 onward:
	 *   var dates = [new Date(1989, 6, 10), new Date(1987, 1, 11)]
	 *   var maxDate = max(dates)
	 *   ```
	 *
	 * @param {Date[]|Number[]} datesArray - the dates to compare
	 * @returns {Date} the latest of the dates
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Which of these dates is the latest?
	 * var result = max([
	 *   new Date(1989, 6, 10),
	 *   new Date(1987, 1, 11),
	 *   new Date(1995, 6, 2),
	 *   new Date(1990, 0, 1)
	 * ])
	 * //=> Sun Jul 02 1995 00:00:00
	 */
	function max(dirtyDatesArray) {
	  (0, _index2.default)(1, arguments);
	  var datesArray; // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method
	
	  if (dirtyDatesArray && typeof dirtyDatesArray.forEach === 'function') {
	    datesArray = dirtyDatesArray; // If `dirtyDatesArray` is Array-like Object, convert to Array.
	  } else if (typeof dirtyDatesArray === 'object' && dirtyDatesArray !== null) {
	    datesArray = Array.prototype.slice.call(dirtyDatesArray);
	  } else {
	    // `dirtyDatesArray` is non-iterable, return Invalid Date
	    return new Date(NaN);
	  }
	
	  var result;
	  datesArray.forEach(function (dirtyDate) {
	    var currentDate = (0, _index.default)(dirtyDate);
	
	    if (result === undefined || result < currentDate || isNaN(Number(currentDate))) {
	      result = currentDate;
	    }
	  });
	  return result || new Date(NaN);
	}
	
	module.exports = exports.default;

/***/ },
/* 447 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = min;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name min
	 * @category Common Helpers
	 * @summary Returns the earliest of the given dates.
	 *
	 * @description
	 * Returns the earliest of the given dates.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * - `min` function now accepts an array of dates rather than spread arguments.
	 *
	 *   ```javascript
	 *   // Before v2.0.0
	 *   const date1 = new Date(1989, 6, 10)
	 *   const date2 = new Date(1987, 1, 11)
	 *   const minDate = min(date1, date2)
	 *
	 *   // v2.0.0 onward:
	 *   const dates = [new Date(1989, 6, 10), new Date(1987, 1, 11)]
	 *   const minDate = min(dates)
	 *   ```
	 *
	 * @param {Date[]|Number[]} datesArray - the dates to compare
	 * @returns {Date} - the earliest of the dates
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Which of these dates is the earliest?
	 * const result = min([
	 *   new Date(1989, 6, 10),
	 *   new Date(1987, 1, 11),
	 *   new Date(1995, 6, 2),
	 *   new Date(1990, 0, 1)
	 * ])
	 * //=> Wed Feb 11 1987 00:00:00
	 */
	function min(dirtyDatesArray) {
	  (0, _index2.default)(1, arguments);
	  var datesArray; // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method
	
	  if (dirtyDatesArray && typeof dirtyDatesArray.forEach === 'function') {
	    datesArray = dirtyDatesArray; // If `dirtyDatesArray` is Array-like Object, convert to Array.
	  } else if (typeof dirtyDatesArray === 'object' && dirtyDatesArray !== null) {
	    datesArray = Array.prototype.slice.call(dirtyDatesArray);
	  } else {
	    // `dirtyDatesArray` is non-iterable, return Invalid Date
	    return new Date(NaN);
	  }
	
	  var result;
	  datesArray.forEach(function (dirtyDate) {
	    var currentDate = (0, _index.default)(dirtyDate);
	
	    if (result === undefined || result > currentDate || isNaN(currentDate.getDate())) {
	      result = currentDate;
	    }
	  });
	  return result || new Date(NaN);
	}
	
	module.exports = exports.default;

/***/ },
/* 448 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = parse;
	
	var _index = _interopRequireDefault(__webpack_require__(108));
	
	var _index2 = _interopRequireDefault(__webpack_require__(153));
	
	var _index3 = _interopRequireDefault(__webpack_require__(3));
	
	var _index4 = _interopRequireDefault(__webpack_require__(393));
	
	var _index5 = _interopRequireDefault(__webpack_require__(396));
	
	var _index6 = _interopRequireDefault(__webpack_require__(81));
	
	var _index7 = __webpack_require__(400);
	
	var _index8 = _interopRequireDefault(__webpack_require__(19));
	
	var _index9 = _interopRequireDefault(__webpack_require__(1531));
	
	var _index10 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TIMEZONE_UNIT_PRIORITY = 10; // This RegExp consists of three parts separated by `|`:
	// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
	//   (one of the certain letters followed by `o`)
	// - (\w)\1* matches any sequences of the same letter
	// - '' matches two quote characters in a row
	// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
	//   except a single quote symbol, which ends the sequence.
	//   Two quote characters do not end the sequence.
	//   If there is no matching single quote
	//   then the sequence will continue until the end of the string.
	// - . matches any single character unmatched by previous parts of the RegExps
	
	var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g; // This RegExp catches symbols escaped by quotes, and also
	// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
	
	var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
	var escapedStringRegExp = /^'([^]*?)'?$/;
	var doubleQuoteRegExp = /''/g;
	var notWhitespaceRegExp = /\S/;
	var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
	/**
	 * @name parse
	 * @category Common Helpers
	 * @summary Parse the date.
	 *
	 * @description
	 * Return the date parsed from string using the given format string.
	 *
	 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
	 * > See: https://git.io/fxCyr
	 *
	 * The characters in the format string wrapped between two single quotes characters (') are escaped.
	 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
	 *
	 * Format of the format string is based on Unicode Technical Standard #35:
	 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
	 * with a few additions (see note 5 below the table).
	 *
	 * Not all tokens are compatible. Combinations that don't make sense or could lead to bugs are prohibited
	 * and will throw `RangeError`. For example usage of 24-hour format token with AM/PM token will throw an exception:
	 *
	 * ```javascript
	 * parse('23 AM', 'HH a', new Date())
	 * //=> RangeError: The format string mustn't contain `HH` and `a` at the same time
	 * ```
	 *
	 * See the compatibility table: https://docs.google.com/spreadsheets/d/e/2PACX-1vQOPU3xUhplll6dyoMmVUXHKl_8CRDs6_ueLmex3SoqwhuolkuN3O05l4rqx5h1dKX8eb46Ul-CCSrq/pubhtml?gid=0&single=true
	 *
	 * Accepted format string patterns:
	 * | Unit                            |Prior| Pattern | Result examples                   | Notes |
	 * |---------------------------------|-----|---------|-----------------------------------|-------|
	 * | Era                             | 140 | G..GGG  | AD, BC                            |       |
	 * |                                 |     | GGGG    | Anno Domini, Before Christ        | 2     |
	 * |                                 |     | GGGGG   | A, B                              |       |
	 * | Calendar year                   | 130 | y       | 44, 1, 1900, 2017, 9999           | 4     |
	 * |                                 |     | yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
	 * |                                 |     | yy      | 44, 01, 00, 17                    | 4     |
	 * |                                 |     | yyy     | 044, 001, 123, 999                | 4     |
	 * |                                 |     | yyyy    | 0044, 0001, 1900, 2017            | 4     |
	 * |                                 |     | yyyyy   | ...                               | 2,4   |
	 * | Local week-numbering year       | 130 | Y       | 44, 1, 1900, 2017, 9000           | 4     |
	 * |                                 |     | Yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
	 * |                                 |     | YY      | 44, 01, 00, 17                    | 4,6   |
	 * |                                 |     | YYY     | 044, 001, 123, 999                | 4     |
	 * |                                 |     | YYYY    | 0044, 0001, 1900, 2017            | 4,6   |
	 * |                                 |     | YYYYY   | ...                               | 2,4   |
	 * | ISO week-numbering year         | 130 | R       | -43, 1, 1900, 2017, 9999, -9999   | 4,5   |
	 * |                                 |     | RR      | -43, 01, 00, 17                   | 4,5   |
	 * |                                 |     | RRR     | -043, 001, 123, 999, -999         | 4,5   |
	 * |                                 |     | RRRR    | -0043, 0001, 2017, 9999, -9999    | 4,5   |
	 * |                                 |     | RRRRR   | ...                               | 2,4,5 |
	 * | Extended year                   | 130 | u       | -43, 1, 1900, 2017, 9999, -999    | 4     |
	 * |                                 |     | uu      | -43, 01, 99, -99                  | 4     |
	 * |                                 |     | uuu     | -043, 001, 123, 999, -999         | 4     |
	 * |                                 |     | uuuu    | -0043, 0001, 2017, 9999, -9999    | 4     |
	 * |                                 |     | uuuuu   | ...                               | 2,4   |
	 * | Quarter (formatting)            | 120 | Q       | 1, 2, 3, 4                        |       |
	 * |                                 |     | Qo      | 1st, 2nd, 3rd, 4th                | 5     |
	 * |                                 |     | QQ      | 01, 02, 03, 04                    |       |
	 * |                                 |     | QQQ     | Q1, Q2, Q3, Q4                    |       |
	 * |                                 |     | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
	 * |                                 |     | QQQQQ   | 1, 2, 3, 4                        | 4     |
	 * | Quarter (stand-alone)           | 120 | q       | 1, 2, 3, 4                        |       |
	 * |                                 |     | qo      | 1st, 2nd, 3rd, 4th                | 5     |
	 * |                                 |     | qq      | 01, 02, 03, 04                    |       |
	 * |                                 |     | qqq     | Q1, Q2, Q3, Q4                    |       |
	 * |                                 |     | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
	 * |                                 |     | qqqqq   | 1, 2, 3, 4                        | 3     |
	 * | Month (formatting)              | 110 | M       | 1, 2, ..., 12                     |       |
	 * |                                 |     | Mo      | 1st, 2nd, ..., 12th               | 5     |
	 * |                                 |     | MM      | 01, 02, ..., 12                   |       |
	 * |                                 |     | MMM     | Jan, Feb, ..., Dec                |       |
	 * |                                 |     | MMMM    | January, February, ..., December  | 2     |
	 * |                                 |     | MMMMM   | J, F, ..., D                      |       |
	 * | Month (stand-alone)             | 110 | L       | 1, 2, ..., 12                     |       |
	 * |                                 |     | Lo      | 1st, 2nd, ..., 12th               | 5     |
	 * |                                 |     | LL      | 01, 02, ..., 12                   |       |
	 * |                                 |     | LLL     | Jan, Feb, ..., Dec                |       |
	 * |                                 |     | LLLL    | January, February, ..., December  | 2     |
	 * |                                 |     | LLLLL   | J, F, ..., D                      |       |
	 * | Local week of year              | 100 | w       | 1, 2, ..., 53                     |       |
	 * |                                 |     | wo      | 1st, 2nd, ..., 53th               | 5     |
	 * |                                 |     | ww      | 01, 02, ..., 53                   |       |
	 * | ISO week of year                | 100 | I       | 1, 2, ..., 53                     | 5     |
	 * |                                 |     | Io      | 1st, 2nd, ..., 53th               | 5     |
	 * |                                 |     | II      | 01, 02, ..., 53                   | 5     |
	 * | Day of month                    |  90 | d       | 1, 2, ..., 31                     |       |
	 * |                                 |     | do      | 1st, 2nd, ..., 31st               | 5     |
	 * |                                 |     | dd      | 01, 02, ..., 31                   |       |
	 * | Day of year                     |  90 | D       | 1, 2, ..., 365, 366               | 7     |
	 * |                                 |     | Do      | 1st, 2nd, ..., 365th, 366th       | 5     |
	 * |                                 |     | DD      | 01, 02, ..., 365, 366             | 7     |
	 * |                                 |     | DDD     | 001, 002, ..., 365, 366           |       |
	 * |                                 |     | DDDD    | ...                               | 2     |
	 * | Day of week (formatting)        |  90 | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
	 * |                                 |     | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
	 * |                                 |     | EEEEE   | M, T, W, T, F, S, S               |       |
	 * |                                 |     | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
	 * | ISO day of week (formatting)    |  90 | i       | 1, 2, 3, ..., 7                   | 5     |
	 * |                                 |     | io      | 1st, 2nd, ..., 7th                | 5     |
	 * |                                 |     | ii      | 01, 02, ..., 07                   | 5     |
	 * |                                 |     | iii     | Mon, Tue, Wed, ..., Sun           | 5     |
	 * |                                 |     | iiii    | Monday, Tuesday, ..., Sunday      | 2,5   |
	 * |                                 |     | iiiii   | M, T, W, T, F, S, S               | 5     |
	 * |                                 |     | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 5     |
	 * | Local day of week (formatting)  |  90 | e       | 2, 3, 4, ..., 1                   |       |
	 * |                                 |     | eo      | 2nd, 3rd, ..., 1st                | 5     |
	 * |                                 |     | ee      | 02, 03, ..., 01                   |       |
	 * |                                 |     | eee     | Mon, Tue, Wed, ..., Sun           |       |
	 * |                                 |     | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
	 * |                                 |     | eeeee   | M, T, W, T, F, S, S               |       |
	 * |                                 |     | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
	 * | Local day of week (stand-alone) |  90 | c       | 2, 3, 4, ..., 1                   |       |
	 * |                                 |     | co      | 2nd, 3rd, ..., 1st                | 5     |
	 * |                                 |     | cc      | 02, 03, ..., 01                   |       |
	 * |                                 |     | ccc     | Mon, Tue, Wed, ..., Sun           |       |
	 * |                                 |     | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
	 * |                                 |     | ccccc   | M, T, W, T, F, S, S               |       |
	 * |                                 |     | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
	 * | AM, PM                          |  80 | a..aaa  | AM, PM                            |       |
	 * |                                 |     | aaaa    | a.m., p.m.                        | 2     |
	 * |                                 |     | aaaaa   | a, p                              |       |
	 * | AM, PM, noon, midnight          |  80 | b..bbb  | AM, PM, noon, midnight            |       |
	 * |                                 |     | bbbb    | a.m., p.m., noon, midnight        | 2     |
	 * |                                 |     | bbbbb   | a, p, n, mi                       |       |
	 * | Flexible day period             |  80 | B..BBB  | at night, in the morning, ...     |       |
	 * |                                 |     | BBBB    | at night, in the morning, ...     | 2     |
	 * |                                 |     | BBBBB   | at night, in the morning, ...     |       |
	 * | Hour [1-12]                     |  70 | h       | 1, 2, ..., 11, 12                 |       |
	 * |                                 |     | ho      | 1st, 2nd, ..., 11th, 12th         | 5     |
	 * |                                 |     | hh      | 01, 02, ..., 11, 12               |       |
	 * | Hour [0-23]                     |  70 | H       | 0, 1, 2, ..., 23                  |       |
	 * |                                 |     | Ho      | 0th, 1st, 2nd, ..., 23rd          | 5     |
	 * |                                 |     | HH      | 00, 01, 02, ..., 23               |       |
	 * | Hour [0-11]                     |  70 | K       | 1, 2, ..., 11, 0                  |       |
	 * |                                 |     | Ko      | 1st, 2nd, ..., 11th, 0th          | 5     |
	 * |                                 |     | KK      | 01, 02, ..., 11, 00               |       |
	 * | Hour [1-24]                     |  70 | k       | 24, 1, 2, ..., 23                 |       |
	 * |                                 |     | ko      | 24th, 1st, 2nd, ..., 23rd         | 5     |
	 * |                                 |     | kk      | 24, 01, 02, ..., 23               |       |
	 * | Minute                          |  60 | m       | 0, 1, ..., 59                     |       |
	 * |                                 |     | mo      | 0th, 1st, ..., 59th               | 5     |
	 * |                                 |     | mm      | 00, 01, ..., 59                   |       |
	 * | Second                          |  50 | s       | 0, 1, ..., 59                     |       |
	 * |                                 |     | so      | 0th, 1st, ..., 59th               | 5     |
	 * |                                 |     | ss      | 00, 01, ..., 59                   |       |
	 * | Seconds timestamp               |  40 | t       | 512969520                         |       |
	 * |                                 |     | tt      | ...                               | 2     |
	 * | Fraction of second              |  30 | S       | 0, 1, ..., 9                      |       |
	 * |                                 |     | SS      | 00, 01, ..., 99                   |       |
	 * |                                 |     | SSS     | 000, 001, ..., 999                |       |
	 * |                                 |     | SSSS    | ...                               | 2     |
	 * | Milliseconds timestamp          |  20 | T       | 512969520900                      |       |
	 * |                                 |     | TT      | ...                               | 2     |
	 * | Timezone (ISO-8601 w/ Z)        |  10 | X       | -08, +0530, Z                     |       |
	 * |                                 |     | XX      | -0800, +0530, Z                   |       |
	 * |                                 |     | XXX     | -08:00, +05:30, Z                 |       |
	 * |                                 |     | XXXX    | -0800, +0530, Z, +123456          | 2     |
	 * |                                 |     | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
	 * | Timezone (ISO-8601 w/o Z)       |  10 | x       | -08, +0530, +00                   |       |
	 * |                                 |     | xx      | -0800, +0530, +0000               |       |
	 * |                                 |     | xxx     | -08:00, +05:30, +00:00            | 2     |
	 * |                                 |     | xxxx    | -0800, +0530, +0000, +123456      |       |
	 * |                                 |     | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
	 * | Long localized date             |  NA | P       | 05/29/1453                        | 5,8   |
	 * |                                 |     | PP      | May 29, 1453                      |       |
	 * |                                 |     | PPP     | May 29th, 1453                    |       |
	 * |                                 |     | PPPP    | Sunday, May 29th, 1453            | 2,5,8 |
	 * | Long localized time             |  NA | p       | 12:00 AM                          | 5,8   |
	 * |                                 |     | pp      | 12:00:00 AM                       |       |
	 * | Combination of date and time    |  NA | Pp      | 05/29/1453, 12:00 AM              |       |
	 * |                                 |     | PPpp    | May 29, 1453, 12:00:00 AM         |       |
	 * |                                 |     | PPPpp   | May 29th, 1453 at ...             |       |
	 * |                                 |     | PPPPpp  | Sunday, May 29th, 1453 at ...     | 2,5,8 |
	 * Notes:
	 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
	 *    are the same as "stand-alone" units, but are different in some languages.
	 *    "Formatting" units are declined according to the rules of the language
	 *    in the context of a date. "Stand-alone" units are always nominative singular.
	 *    In `format` function, they will produce different result:
	 *
	 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
	 *
	 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
	 *
	 *    `parse` will try to match both formatting and stand-alone units interchangably.
	 *
	 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
	 *    the single quote characters (see below).
	 *    If the sequence is longer than listed in table:
	 *    - for numerical units (`yyyyyyyy`) `parse` will try to match a number
	 *      as wide as the sequence
	 *    - for text units (`MMMMMMMM`) `parse` will try to match the widest variation of the unit.
	 *      These variations are marked with "2" in the last column of the table.
	 *
	 * 3. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
	 *    These tokens represent the shortest form of the quarter.
	 *
	 * 4. The main difference between `y` and `u` patterns are B.C. years:
	 *
	 *    | Year | `y` | `u` |
	 *    |------|-----|-----|
	 *    | AC 1 |   1 |   1 |
	 *    | BC 1 |   1 |   0 |
	 *    | BC 2 |   2 |  -1 |
	 *
	 *    Also `yy` will try to guess the century of two digit year by proximity with `referenceDate`:
	 *
	 *    `parse('50', 'yy', new Date(2018, 0, 1)) //=> Sat Jan 01 2050 00:00:00`
	 *
	 *    `parse('75', 'yy', new Date(2018, 0, 1)) //=> Wed Jan 01 1975 00:00:00`
	 *
	 *    while `uu` will just assign the year as is:
	 *
	 *    `parse('50', 'uu', new Date(2018, 0, 1)) //=> Sat Jan 01 0050 00:00:00`
	 *
	 *    `parse('75', 'uu', new Date(2018, 0, 1)) //=> Tue Jan 01 0075 00:00:00`
	 *
	 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
	 *    except local week-numbering years are dependent on `options.weekStartsOn`
	 *    and `options.firstWeekContainsDate` (compare [setISOWeekYear]{@link https://date-fns.org/docs/setISOWeekYear}
	 *    and [setWeekYear]{@link https://date-fns.org/docs/setWeekYear}).
	 *
	 * 5. These patterns are not in the Unicode Technical Standard #35:
	 *    - `i`: ISO day of week
	 *    - `I`: ISO week of year
	 *    - `R`: ISO week-numbering year
	 *    - `o`: ordinal number modifier
	 *    - `P`: long localized date
	 *    - `p`: long localized time
	 *
	 * 6. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
	 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://git.io/fxCyr
	 *
	 * 7. `D` and `DD` tokens represent days of the year but they are ofthen confused with days of the month.
	 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://git.io/fxCyr
	 *
	 * 8. `P+` tokens do not have a defined priority since they are merely aliases to other tokens based
	 *    on the given locale.
	 *
	 *    using `en-US` locale: `P` => `MM/dd/yyyy`
	 *    using `en-US` locale: `p` => `hh:mm a`
	 *    using `pt-BR` locale: `P` => `dd/MM/yyyy`
	 *    using `pt-BR` locale: `p` => `HH:mm`
	 *
	 * Values will be assigned to the date in the descending order of its unit's priority.
	 * Units of an equal priority overwrite each other in the order of appearance.
	 *
	 * If no values of higher priority are parsed (e.g. when parsing string 'January 1st' without a year),
	 * the values will be taken from 3rd argument `referenceDate` which works as a context of parsing.
	 *
	 * `referenceDate` must be passed for correct work of the function.
	 * If you're not sure which `referenceDate` to supply, create a new instance of Date:
	 * `parse('02/11/2014', 'MM/dd/yyyy', new Date())`
	 * In this case parsing will be done in the context of the current date.
	 * If `referenceDate` is `Invalid Date` or a value not convertible to valid `Date`,
	 * then `Invalid Date` will be returned.
	 *
	 * The result may vary by locale.
	 *
	 * If `formatString` matches with `dateString` but does not provides tokens, `referenceDate` will be returned.
	 *
	 * If parsing failed, `Invalid Date` will be returned.
	 * Invalid Date is a Date, whose time value is NaN.
	 * Time value of Date: http://es5.github.io/#x15.9.1.1
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * - Old `parse` was renamed to `toDate`.
	 *   Now `parse` is a new function which parses a string using a provided format.
	 *
	 *   ```javascript
	 *   // Before v2.0.0
	 *   parse('2016-01-01')
	 *
	 *   // v2.0.0 onward (toDate no longer accepts a string)
	 *   toDate(1392098430000) // Unix to timestamp
	 *   toDate(new Date(2014, 1, 11, 11, 30, 30)) // Cloning the date
	 *   parse('2016-01-01', 'yyyy-MM-dd', new Date())
	 *   ```
	 *
	 * @param {String} dateString - the string to parse
	 * @param {String} formatString - the string of tokens
	 * @param {Date|Number} referenceDate - defines values missing from the parsed dateString
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
	 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
	 *   see: https://git.io/fxCyr
	 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
	 *   see: https://git.io/fxCyr
	 * @returns {Date} the parsed date
	 * @throws {TypeError} 3 arguments required
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
	 * @throws {RangeError} `options.locale` must contain `match` property
	 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://git.io/fxCyr
	 * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://git.io/fxCyr
	 * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://git.io/fxCyr
	 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://git.io/fxCyr
	 * @throws {RangeError} format string contains an unescaped latin alphabet character
	 *
	 * @example
	 * // Parse 11 February 2014 from middle-endian format:
	 * var result = parse('02/11/2014', 'MM/dd/yyyy', new Date())
	 * //=> Tue Feb 11 2014 00:00:00
	 *
	 * @example
	 * // Parse 28th of February in Esperanto locale in the context of 2010 year:
	 * import eo from 'date-fns/locale/eo'
	 * var result = parse('28-a de februaro', "do 'de' MMMM", new Date(2010, 0, 1), {
	 *   locale: eo
	 * })
	 * //=> Sun Feb 28 2010 00:00:00
	 */
	
	function parse(dirtyDateString, dirtyFormatString, dirtyReferenceDate, dirtyOptions) {
	  (0, _index10.default)(3, arguments);
	  var dateString = String(dirtyDateString);
	  var formatString = String(dirtyFormatString);
	  var options = dirtyOptions || {};
	  var locale = options.locale || _index.default;
	
	  if (!locale.match) {
	    throw new RangeError('locale must contain match property');
	  }
	
	  var localeFirstWeekContainsDate = locale.options && locale.options.firstWeekContainsDate;
	  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : (0, _index8.default)(localeFirstWeekContainsDate);
	  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : (0, _index8.default)(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
	
	  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
	    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
	  }
	
	  var localeWeekStartsOn = locale.options && locale.options.weekStartsOn;
	  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0, _index8.default)(localeWeekStartsOn);
	  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0, _index8.default)(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
	
	  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
	    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
	  }
	
	  if (formatString === '') {
	    if (dateString === '') {
	      return (0, _index3.default)(dirtyReferenceDate);
	    } else {
	      return new Date(NaN);
	    }
	  }
	
	  var subFnOptions = {
	    firstWeekContainsDate: firstWeekContainsDate,
	    weekStartsOn: weekStartsOn,
	    locale: locale
	  }; // If timezone isn't specified, it will be set to the system timezone
	
	  var setters = [{
	    priority: TIMEZONE_UNIT_PRIORITY,
	    subPriority: -1,
	    set: dateToSystemTimezone,
	    index: 0
	  }];
	  var i;
	  var tokens = formatString.match(longFormattingTokensRegExp).map(function (substring) {
	    var firstCharacter = substring[0];
	
	    if (firstCharacter === 'p' || firstCharacter === 'P') {
	      var longFormatter = _index5.default[firstCharacter];
	      return longFormatter(substring, locale.formatLong, subFnOptions);
	    }
	
	    return substring;
	  }).join('').match(formattingTokensRegExp);
	  var usedTokens = [];
	
	  for (i = 0; i < tokens.length; i++) {
	    var token = tokens[i];
	
	    if (!options.useAdditionalWeekYearTokens && (0, _index7.isProtectedWeekYearToken)(token)) {
	      (0, _index7.throwProtectedError)(token, formatString, dirtyDateString);
	    }
	
	    if (!options.useAdditionalDayOfYearTokens && (0, _index7.isProtectedDayOfYearToken)(token)) {
	      (0, _index7.throwProtectedError)(token, formatString, dirtyDateString);
	    }
	
	    var firstCharacter = token[0];
	    var parser = _index9.default[firstCharacter];
	
	    if (parser) {
	      var incompatibleTokens = parser.incompatibleTokens;
	
	      if (Array.isArray(incompatibleTokens)) {
	        var incompatibleToken = void 0;
	
	        for (var _i = 0; _i < usedTokens.length; _i++) {
	          var usedToken = usedTokens[_i].token;
	
	          if (incompatibleTokens.indexOf(usedToken) !== -1 || usedToken === firstCharacter) {
	            incompatibleToken = usedTokens[_i];
	            break;
	          }
	        }
	
	        if (incompatibleToken) {
	          throw new RangeError("The format string mustn't contain `".concat(incompatibleToken.fullToken, "` and `").concat(token, "` at the same time"));
	        }
	      } else if (parser.incompatibleTokens === '*' && usedTokens.length) {
	        throw new RangeError("The format string mustn't contain `".concat(token, "` and any other token at the same time"));
	      }
	
	      usedTokens.push({
	        token: firstCharacter,
	        fullToken: token
	      });
	      var parseResult = parser.parse(dateString, token, locale.match, subFnOptions);
	
	      if (!parseResult) {
	        return new Date(NaN);
	      }
	
	      setters.push({
	        priority: parser.priority,
	        subPriority: parser.subPriority || 0,
	        set: parser.set,
	        validate: parser.validate,
	        value: parseResult.value,
	        index: setters.length
	      });
	      dateString = parseResult.rest;
	    } else {
	      if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
	        throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
	      } // Replace two single quote characters with one single quote character
	
	
	      if (token === "''") {
	        token = "'";
	      } else if (firstCharacter === "'") {
	        token = cleanEscapedString(token);
	      } // Cut token from string, or, if string doesn't match the token, return Invalid Date
	
	
	      if (dateString.indexOf(token) === 0) {
	        dateString = dateString.slice(token.length);
	      } else {
	        return new Date(NaN);
	      }
	    }
	  } // Check if the remaining input contains something other than whitespace
	
	
	  if (dateString.length > 0 && notWhitespaceRegExp.test(dateString)) {
	    return new Date(NaN);
	  }
	
	  var uniquePrioritySetters = setters.map(function (setter) {
	    return setter.priority;
	  }).sort(function (a, b) {
	    return b - a;
	  }).filter(function (priority, index, array) {
	    return array.indexOf(priority) === index;
	  }).map(function (priority) {
	    return setters.filter(function (setter) {
	      return setter.priority === priority;
	    }).sort(function (a, b) {
	      return b.subPriority - a.subPriority;
	    });
	  }).map(function (setterArray) {
	    return setterArray[0];
	  });
	  var date = (0, _index3.default)(dirtyReferenceDate);
	
	  if (isNaN(date)) {
	    return new Date(NaN);
	  } // Convert the date in system timezone to the same date in UTC+00:00 timezone.
	  // This ensures that when UTC functions will be implemented, locales will be compatible with them.
	  // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/37
	
	
	  var utcDate = (0, _index2.default)(date, (0, _index6.default)(date));
	  var flags = {};
	
	  for (i = 0; i < uniquePrioritySetters.length; i++) {
	    var setter = uniquePrioritySetters[i];
	
	    if (setter.validate && !setter.validate(utcDate, setter.value, subFnOptions)) {
	      return new Date(NaN);
	    }
	
	    var result = setter.set(utcDate, flags, setter.value, subFnOptions); // Result is tuple (date, flags)
	
	    if (result[0]) {
	      utcDate = result[0];
	      (0, _index4.default)(flags, result[1]); // Result is date
	    } else {
	      utcDate = result;
	    }
	  }
	
	  return utcDate;
	}
	
	function dateToSystemTimezone(date, flags) {
	  if (flags.timestampIsSet) {
	    return date;
	  }
	
	  var convertedDate = new Date(0);
	  convertedDate.setFullYear(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
	  convertedDate.setHours(date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds());
	  return convertedDate;
	}
	
	function cleanEscapedString(input) {
	  return input.match(escapedStringRegExp)[1].replace(doubleQuoteRegExp, "'");
	}
	
	module.exports = exports.default;

/***/ },
/* 449 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setISOWeekYear;
	
	var _index = _interopRequireDefault(__webpack_require__(19));
	
	var _index2 = _interopRequireDefault(__webpack_require__(3));
	
	var _index3 = _interopRequireDefault(__webpack_require__(152));
	
	var _index4 = _interopRequireDefault(__webpack_require__(106));
	
	var _index5 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name setISOWeekYear
	 * @category ISO Week-Numbering Year Helpers
	 * @summary Set the ISO week-numbering year to the given date.
	 *
	 * @description
	 * Set the ISO week-numbering year to the given date,
	 * saving the week number and the weekday number.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * - The function was renamed from `setISOYear` to `setISOWeekYear`.
	 *   "ISO week year" is short for [ISO week-numbering year](https://en.wikipedia.org/wiki/ISO_week_date).
	 *   This change makes the name consistent with
	 *   locale-dependent week-numbering year helpers, e.g., `setWeekYear`.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} isoWeekYear - the ISO week-numbering year of the new date
	 * @returns {Date} the new date with the ISO week-numbering year set
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Set ISO week-numbering year 2007 to 29 December 2008:
	 * const result = setISOWeekYear(new Date(2008, 11, 29), 2007)
	 * //=> Mon Jan 01 2007 00:00:00
	 */
	function setISOWeekYear(dirtyDate, dirtyISOWeekYear) {
	  (0, _index5.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var isoWeekYear = (0, _index.default)(dirtyISOWeekYear);
	  var diff = (0, _index4.default)(date, (0, _index3.default)(date));
	  var fourthOfJanuary = new Date(0);
	  fourthOfJanuary.setFullYear(isoWeekYear, 0, 4);
	  fourthOfJanuary.setHours(0, 0, 0, 0);
	  date = (0, _index3.default)(fourthOfJanuary);
	  date.setDate(date.getDate() + diff);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 450 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfHour;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name startOfHour
	 * @category Hour Helpers
	 * @summary Return the start of an hour for the given date.
	 *
	 * @description
	 * Return the start of an hour for the given date.
	 * The result will be in the local timezone.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the start of an hour
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The start of an hour for 2 September 2014 11:55:00:
	 * const result = startOfHour(new Date(2014, 8, 2, 11, 55))
	 * //=> Tue Sep 02 2014 11:00:00
	 */
	function startOfHour(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  date.setMinutes(0, 0, 0);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 451 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfSecond;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name startOfSecond
	 * @category Second Helpers
	 * @summary Return the start of a second for the given date.
	 *
	 * @description
	 * Return the start of a second for the given date.
	 * The result will be in the local timezone.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the start of a second
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The start of a second for 1 December 2014 22:15:45.400:
	 * const result = startOfSecond(new Date(2014, 11, 1, 22, 15, 45, 400))
	 * //=> Mon Dec 01 2014 22:15:45.000
	 */
	function startOfSecond(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  date.setMilliseconds(0);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 452 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = sub;
	
	var _index = _interopRequireDefault(__webpack_require__(196));
	
	var _index2 = _interopRequireDefault(__webpack_require__(454));
	
	var _index3 = _interopRequireDefault(__webpack_require__(2));
	
	var _index4 = _interopRequireDefault(__webpack_require__(19));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name sub
	 * @category Common Helpers
	 * @summary Subtract the specified years, months, weeks, days, hours, minutes and seconds from the given date.
	 *
	 * @description
	 * Subtract the specified years, months, weeks, days, hours, minutes and seconds from the given date.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Duration} duration - the object with years, months, weeks, days, hours, minutes and seconds to be subtracted
	 *
	 * | Key     | Description                        |
	 * |---------|------------------------------------|
	 * | years   | Amount of years to be subtracted   |
	 * | months  | Amount of months to be subtracted  |
	 * | weeks   | Amount of weeks to be subtracted   |
	 * | days    | Amount of days to be subtracted    |
	 * | hours   | Amount of hours to be subtracted   |
	 * | minutes | Amount of minutes to be subtracted |
	 * | seconds | Amount of seconds to be subtracted |
	 *
	 * All values default to 0
	 *
	 * @returns {Date} the new date with the seconds subtracted
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Subtract the following duration from 15 June 2017 15:29:20
	 * const result = sub(new Date(2017, 5, 15, 15, 29, 20), {
	 *   years: 2,
	 *   months: 9,
	 *   weeks: 1,
	 *   days: 7,
	 *   hours: 5,
	 *   minutes: 9,
	 *   seconds: 30
	 * })
	 * //=> Mon Sep 1 2014 10:19:50
	 */
	function sub(date, duration) {
	  (0, _index3.default)(2, arguments);
	  if (!duration || typeof duration !== 'object') return new Date(NaN);
	  var years = duration.years ? (0, _index4.default)(duration.years) : 0;
	  var months = duration.months ? (0, _index4.default)(duration.months) : 0;
	  var weeks = duration.weeks ? (0, _index4.default)(duration.weeks) : 0;
	  var days = duration.days ? (0, _index4.default)(duration.days) : 0;
	  var hours = duration.hours ? (0, _index4.default)(duration.hours) : 0;
	  var minutes = duration.minutes ? (0, _index4.default)(duration.minutes) : 0;
	  var seconds = duration.seconds ? (0, _index4.default)(duration.seconds) : 0; // Subtract years and months
	
	  var dateWithoutMonths = (0, _index2.default)(date, months + years * 12); // Subtract weeks and days
	
	  var dateWithoutDays = (0, _index.default)(dateWithoutMonths, days + weeks * 7); // Subtract hours, minutes and seconds
	
	  var minutestoSub = minutes + hours * 60;
	  var secondstoSub = seconds + minutestoSub * 60;
	  var mstoSub = secondstoSub * 1000;
	  var finalDate = new Date(dateWithoutDays.getTime() - mstoSub);
	  return finalDate;
	}
	
	module.exports = exports.default;

/***/ },
/* 453 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = subISOWeekYears;
	
	var _index = _interopRequireDefault(__webpack_require__(19));
	
	var _index2 = _interopRequireDefault(__webpack_require__(402));
	
	var _index3 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name subISOWeekYears
	 * @category ISO Week-Numbering Year Helpers
	 * @summary Subtract the specified number of ISO week-numbering years from the given date.
	 *
	 * @description
	 * Subtract the specified number of ISO week-numbering years from the given date.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * - The function was renamed from `subISOYears` to `subISOWeekYears`.
	 *   "ISO week year" is short for [ISO week-numbering year](https://en.wikipedia.org/wiki/ISO_week_date).
	 *   This change makes the name consistent with
	 *   locale-dependent week-numbering year helpers, e.g., `setWeekYear`.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of ISO week-numbering years to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the ISO week-numbering years subtracted
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Subtract 5 ISO week-numbering years from 1 September 2014:
	 * const result = subISOWeekYears(new Date(2014, 8, 1), 5)
	 * //=> Mon Aug 31 2009 00:00:00
	 */
	function subISOWeekYears(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  return (0, _index2.default)(dirtyDate, -amount);
	}
	
	module.exports = exports.default;

/***/ },
/* 454 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = subMonths;
	
	var _index = _interopRequireDefault(__webpack_require__(19));
	
	var _index2 = _interopRequireDefault(__webpack_require__(150));
	
	var _index3 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name subMonths
	 * @category Month Helpers
	 * @summary Subtract the specified number of months from the given date.
	 *
	 * @description
	 * Subtract the specified number of months from the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of months to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the months subtracted
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Subtract 5 months from 1 February 2015:
	 * const result = subMonths(new Date(2015, 1, 1), 5)
	 * //=> Mon Sep 01 2014 00:00:00
	 */
	function subMonths(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  return (0, _index2.default)(dirtyDate, -amount);
	}
	
	module.exports = exports.default;

/***/ },
/* 455 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports.default = activeElement;
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(129));
	
	function activeElement(doc) {
	  if (doc === void 0) {
	    doc = (0, _ownerDocument.default)();
	  }
	
	  try {
	    return doc.activeElement;
	  } catch (e) {
	    /* ie throws if no active element */
	  }
	}
	
	module.exports = exports["default"];

/***/ },
/* 456 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = hasClass;
	
	function hasClass(element, className) {
	  if (element.classList) return !!className && element.classList.contains(className);else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
	}
	
	module.exports = exports["default"];

/***/ },
/* 457 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports.default = offset;
	
	var _contains = _interopRequireDefault(__webpack_require__(130));
	
	var _isWindow = _interopRequireDefault(__webpack_require__(197));
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(129));
	
	function offset(node) {
	  var doc = (0, _ownerDocument.default)(node),
	      win = (0, _isWindow.default)(doc),
	      docElem = doc && doc.documentElement,
	      box = {
	    top: 0,
	    left: 0,
	    height: 0,
	    width: 0
	  };
	  if (!doc) return; // Make sure it's not a disconnected DOM node
	
	  if (!(0, _contains.default)(docElem, node)) return box;
	  if (node.getBoundingClientRect !== undefined) box = node.getBoundingClientRect(); // IE8 getBoundingClientRect doesn't support width & height
	
	  box = {
	    top: box.top + (win.pageYOffset || docElem.scrollTop) - (docElem.clientTop || 0),
	    left: box.left + (win.pageXOffset || docElem.scrollLeft) - (docElem.clientLeft || 0),
	    width: (box.width == null ? node.offsetWidth : box.width) || 0,
	    height: (box.height == null ? node.offsetHeight : box.height) || 0
	  };
	  return box;
	}
	
	module.exports = exports["default"];

/***/ },
/* 458 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports.default = scrollTop;
	
	var _isWindow = _interopRequireDefault(__webpack_require__(197));
	
	function scrollTop(node, val) {
	  var win = (0, _isWindow.default)(node);
	  if (val === undefined) return win ? 'pageYOffset' in win ? win.pageYOffset : win.document.documentElement.scrollTop : node.scrollTop;
	  if (win) win.scrollTo('pageXOffset' in win ? win.pageXOffset : win.document.documentElement.scrollLeft, val);else node.scrollTop = val;
	}
	
	module.exports = exports["default"];

/***/ },
/* 459 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports.default = camelizeStyleName;
	
	var _camelize = _interopRequireDefault(__webpack_require__(1592));
	
	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/camelizeStyleName.js
	 */
	var msPattern = /^-ms-/;
	
	function camelizeStyleName(string) {
	  return (0, _camelize.default)(string.replace(msPattern, 'ms-'));
	}
	
	module.exports = exports["default"];

/***/ },
/* 460 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports.default = scrollbarSize;
	
	var _inDOM = _interopRequireDefault(__webpack_require__(84));
	
	var size;
	
	function scrollbarSize(recalc) {
	  if (!size && size !== 0 || recalc) {
	    if (_inDOM.default) {
	      var scrollDiv = document.createElement('div');
	      scrollDiv.style.position = 'absolute';
	      scrollDiv.style.top = '-9999px';
	      scrollDiv.style.width = '50px';
	      scrollDiv.style.height = '50px';
	      scrollDiv.style.overflow = 'scroll';
	      document.body.appendChild(scrollDiv);
	      size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
	      document.body.removeChild(scrollDiv);
	    }
	  }
	
	  return size;
	}
	
	module.exports = exports["default"];

/***/ },
/* 461 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/glyphicons-halflings-regular.f4769f9b.eot";

/***/ },
/* 462 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/image01.1aee3da9.jpg";

/***/ },
/* 463 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/katapulk_logo.a0f1c70d.svg";

/***/ },
/* 464 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/kwallet-logo.4dad36ce.svg";

/***/ },
/* 465 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/no-image-small.c423ac7d.png";

/***/ },
/* 466 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/no-image.e2e1775d.png";

/***/ },
/* 467 */
/***/ function(module, exports, __webpack_require__) {

	var isBuffer = __webpack_require__(1651)
	
	var flat = module.exports = flatten
	flatten.flatten = flatten
	flatten.unflatten = unflatten
	
	function flatten(target, opts) {
	  opts = opts || {}
	
	  var delimiter = opts.delimiter || '.'
	  var maxDepth = opts.maxDepth
	  var output = {}
	
	  function step(object, prev, currentDepth) {
	    currentDepth = currentDepth ? currentDepth : 1
	    Object.keys(object).forEach(function(key) {
	      var value = object[key]
	      var isarray = opts.safe && Array.isArray(value)
	      var type = Object.prototype.toString.call(value)
	      var isbuffer = isBuffer(value)
	      var isobject = (
	        type === "[object Object]" ||
	        type === "[object Array]"
	      )
	
	      var newKey = prev
	        ? prev + delimiter + key
	        : key
	
	      if (!isarray && !isbuffer && isobject && Object.keys(value).length &&
	        (!opts.maxDepth || currentDepth < maxDepth)) {
	        return step(value, newKey, currentDepth + 1)
	      }
	
	      output[newKey] = value
	    })
	  }
	
	  step(target)
	
	  return output
	}
	
	function unflatten(target, opts) {
	  opts = opts || {}
	
	  var delimiter = opts.delimiter || '.'
	  var overwrite = opts.overwrite || false
	  var result = {}
	
	  var isbuffer = isBuffer(target)
	  if (isbuffer || Object.prototype.toString.call(target) !== '[object Object]') {
	    return target
	  }
	
	  // safely ensure that the key is
	  // an integer.
	  function getkey(key) {
	    var parsedKey = Number(key)
	
	    return (
	      isNaN(parsedKey) ||
	      key.indexOf('.') !== -1
	    ) ? key
	      : parsedKey
	  }
	
	  Object.keys(target).forEach(function(key) {
	    var split = key.split(delimiter)
	    var key1 = getkey(split.shift())
	    var key2 = getkey(split[0])
	    var recipient = result
	
	    while (key2 !== undefined) {
	      var type = Object.prototype.toString.call(recipient[key1])
	      var isobject = (
	        type === "[object Object]" ||
	        type === "[object Array]"
	      )
	
	      // do not write over falsey, non-undefined values if overwrite is false
	      if (!overwrite && !isobject && typeof recipient[key1] !== 'undefined') {
	        return
	      }
	
	      if ((overwrite && !isobject) || (!overwrite && recipient[key1] == null)) {
	        recipient[key1] = (
	          typeof key2 === 'number' &&
	          !opts.object ? [] : {}
	        )
	      }
	
	      recipient = recipient[key1]
	      if (split.length > 0) {
	        key1 = getkey(split.shift())
	        key2 = getkey(split[0])
	      }
	    }
	
	    // unflatten again for 'messy objects'
	    recipient[key1] = unflatten(target[key], opts)
	  })
	
	  return result
	}


/***/ },
/* 468 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var addLeadingSlash = exports.addLeadingSlash = function addLeadingSlash(path) {
	  return path.charAt(0) === '/' ? path : '/' + path;
	};
	
	var stripLeadingSlash = exports.stripLeadingSlash = function stripLeadingSlash(path) {
	  return path.charAt(0) === '/' ? path.substr(1) : path;
	};
	
	var hasBasename = exports.hasBasename = function hasBasename(path, prefix) {
	  return new RegExp('^' + prefix + '(\\/|\\?|#|$)', 'i').test(path);
	};
	
	var stripBasename = exports.stripBasename = function stripBasename(path, prefix) {
	  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
	};
	
	var stripTrailingSlash = exports.stripTrailingSlash = function stripTrailingSlash(path) {
	  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
	};
	
	var parsePath = exports.parsePath = function parsePath(path) {
	  var pathname = path || '/';
	  var search = '';
	  var hash = '';
	
	  var hashIndex = pathname.indexOf('#');
	  if (hashIndex !== -1) {
	    hash = pathname.substr(hashIndex);
	    pathname = pathname.substr(0, hashIndex);
	  }
	
	  var searchIndex = pathname.indexOf('?');
	  if (searchIndex !== -1) {
	    search = pathname.substr(searchIndex);
	    pathname = pathname.substr(0, searchIndex);
	  }
	
	  return {
	    pathname: pathname,
	    search: search === '?' ? '' : search,
	    hash: hash === '#' ? '' : hash
	  };
	};
	
	var createPath = exports.createPath = function createPath(location) {
	  var pathname = location.pathname,
	      search = location.search,
	      hash = location.hash;
	
	
	  var path = pathname || '/';
	
	  if (search && search !== '?') path += search.charAt(0) === '?' ? search : '?' + search;
	
	  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : '#' + hash;
	
	  return path;
	};

/***/ },
/* 469 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var reactIs = __webpack_require__(160);
	
	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	var REACT_STATICS = {
	  childContextTypes: true,
	  contextType: true,
	  contextTypes: true,
	  defaultProps: true,
	  displayName: true,
	  getDefaultProps: true,
	  getDerivedStateFromError: true,
	  getDerivedStateFromProps: true,
	  mixins: true,
	  propTypes: true,
	  type: true
	};
	var KNOWN_STATICS = {
	  name: true,
	  length: true,
	  prototype: true,
	  caller: true,
	  callee: true,
	  arguments: true,
	  arity: true
	};
	var FORWARD_REF_STATICS = {
	  '$$typeof': true,
	  render: true,
	  defaultProps: true,
	  displayName: true,
	  propTypes: true
	};
	var MEMO_STATICS = {
	  '$$typeof': true,
	  compare: true,
	  defaultProps: true,
	  displayName: true,
	  propTypes: true,
	  type: true
	};
	var TYPE_STATICS = {};
	TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
	TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;
	
	function getStatics(component) {
	  // React v16.11 and below
	  if (reactIs.isMemo(component)) {
	    return MEMO_STATICS;
	  } // React v16.12 and above
	
	
	  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
	}
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = Object.prototype;
	function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	  if (typeof sourceComponent !== 'string') {
	    // don't hoist over string (html) components
	    if (objectPrototype) {
	      var inheritedComponent = getPrototypeOf(sourceComponent);
	
	      if (inheritedComponent && inheritedComponent !== objectPrototype) {
	        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	      }
	    }
	
	    var keys = getOwnPropertyNames(sourceComponent);
	
	    if (getOwnPropertySymbols) {
	      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	    }
	
	    var targetStatics = getStatics(targetComponent);
	    var sourceStatics = getStatics(sourceComponent);
	
	    for (var i = 0; i < keys.length; ++i) {
	      var key = keys[i];
	
	      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
	        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	
	        try {
	          // Avoid failures from read-only properties
	          defineProperty(targetComponent, key, descriptor);
	        } catch (e) {}
	      }
	    }
	  }
	
	  return targetComponent;
	}
	
	module.exports = hoistNonReactStatics;


/***/ },
/* 470 */
/***/ function(module, exports) {

	'use strict';
	
	toQuerystring.serialize = serialize;
	toQuerystring.shake = shake;
	toQuerystring.normalize = normalize;
	
	module.exports = toQuerystring;
	
	function toQuerystring( i ){
		var shaken = shake(normalize(i));
	
		if (shaken === undefined)
			return '';
	
		return serialize(shaken);
	}
	
	function serialize( i, prefix ){
		if (Array.isArray(i)) {
			var hasComplex = i.some(isComplex);
	
			return i.map(function( i, idx ){
				return serialize(i, prefix+(hasComplex
					? '['+idx+']'
					: '[]'));
			}).join('&');
		}
	
		if (typeof i === 'object')
			return Object.keys(i).map(function( key ){
				return serialize(i[key], prefix === undefined
					? encodeURIComponent(key)
					: prefix+'['+encodeURIComponent(key)+']');
			}).join('&');
	
		return prefix+'='+encodeURIComponent(i);
	}
	
	function shake( i ){
		if (i === undefined)
			return;
	
		if (Array.isArray(i)) {
			var shaken = i.map(shake).filter(isDefined);
	
			if (shaken.length === 0)
				return;
	
			return shaken;
		}
	
		if (typeof i === 'object') {
			var empty = true;
	
			var shaken = Object.keys(i).reduce(function( o, key ){
				var shaken = shake(i[key]);
	
				if (shaken !== undefined) {
					empty = false;
	
					o[key] = shaken;
				}
	
				return o;
			}, {});
	
			if (empty)
				return;
	
			return shaken;
		}
	
		return i;
	}
	
	function normalize( i ){
		if (i === undefined)
			return undefined;
	
		if (i === null)
			return '';
	
		if (i === true)
			return 'y';
	
		if (i === false)
			return 'n';
	
		if (typeof i.toJSON === 'function')
			return normalize(i.toJSON());
	
		var type = typeof i;
	
		if (type === 'string')
			return i;
	
		if (Array.isArray(i))
			return i.map(normalize);
	
		if (type === 'object')
			return Object.keys(i).reduce(function( o, key ){
				o[key] = normalize(i[key]);
	
				return o;
			}, {});
	
		return i+'';
	}
	
	function isDefined( i ){
		return i !== undefined;
	}
	
	function isComplex( i ){
		if (Array.isArray(i))
			return true;
	
		if (typeof i === 'object')
			return true;
	
		return false;
	}


/***/ },
/* 471 */
/***/ function(module, exports, __webpack_require__) {

	/* jshint node:true */
	
	'use strict';
	
	var IntlMessageFormat = __webpack_require__(1644)['default'];
	
	// Add all locale data to `IntlMessageFormat`. This module will be ignored when
	// bundling for the browser with Browserify/Webpack.
	__webpack_require__(2183);
	
	// Re-export `IntlMessageFormat` as the CommonJS default exports with all the
	// locale data registered, and with English set as the default locale. Define
	// the `default` prop for use with other compiled ES6 Modules.
	exports = module.exports = IntlMessageFormat;
	exports['default'] = exports;


/***/ },
/* 472 */
/***/ function(module, exports) {

	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	
	/* jslint esnext: true */
	
	"use strict";
	exports.extend = extend;
	var hop = Object.prototype.hasOwnProperty;
	
	function extend(obj) {
	    var sources = Array.prototype.slice.call(arguments, 1),
	        i, len, source, key;
	
	    for (i = 0, len = sources.length; i < len; i += 1) {
	        source = sources[i];
	        if (!source) { continue; }
	
	        for (key in source) {
	            if (hop.call(source, key)) {
	                obj[key] = source[key];
	            }
	        }
	    }
	
	    return obj;
	}
	exports.hop = hop;
	
	//# sourceMappingURL=utils.js.map

/***/ },
/* 473 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(77);
	
	/** Built-in value references. */
	var Uint8Array = root.Uint8Array;
	
	module.exports = Uint8Array;


/***/ },
/* 474 */
/***/ function(module, exports, __webpack_require__) {

	var baseTimes = __webpack_require__(1684),
	    isArguments = __webpack_require__(206),
	    isArray = __webpack_require__(72),
	    isBuffer = __webpack_require__(207),
	    isIndex = __webpack_require__(298),
	    isTypedArray = __webpack_require__(210);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  var isArr = isArray(value),
	      isArg = !isArr && isArguments(value),
	      isBuff = !isArr && !isArg && isBuffer(value),
	      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	      skipIndexes = isArr || isArg || isBuff || isType,
	      result = skipIndexes ? baseTimes(value.length, String) : [],
	      length = result.length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (
	           // Safari 9 has enumerable `arguments.length` in strict mode.
	           key == 'length' ||
	           // Node.js 0.10 has enumerable non-index properties on buffers.
	           (isBuff && (key == 'offset' || key == 'parent')) ||
	           // PhantomJS 2 has enumerable non-index properties on typed arrays.
	           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	           // Skip index properties.
	           isIndex(key, length)
	        ))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = arrayLikeKeys;


/***/ },
/* 475 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.map` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	module.exports = arrayMap;


/***/ },
/* 476 */
/***/ function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(201),
	    eq = __webpack_require__(156);
	
	/**
	 * This function is like `assignValue` except that it doesn't assign
	 * `undefined` values.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignMergeValue(object, key, value) {
	  if ((value !== undefined && !eq(object[key], value)) ||
	      (value === undefined && !(key in object))) {
	    baseAssignValue(object, key, value);
	  }
	}
	
	module.exports = assignMergeValue;


/***/ },
/* 477 */
/***/ function(module, exports, __webpack_require__) {

	var createBaseFor = __webpack_require__(1694);
	
	/**
	 * The base implementation of `baseForOwn` which iterates over `object`
	 * properties returned by `keysFunc` and invokes `iteratee` for each property.
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	module.exports = baseFor;


/***/ },
/* 478 */
/***/ function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(480),
	    toKey = __webpack_require__(155);
	
	/**
	 * The base implementation of `_.get` without support for default values.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @returns {*} Returns the resolved value.
	 */
	function baseGet(object, path) {
	  path = castPath(path, object);
	
	  var index = 0,
	      length = path.length;
	
	  while (object != null && index < length) {
	    object = object[toKey(path[index++])];
	  }
	  return (index && index == length) ? object : undefined;
	}
	
	module.exports = baseGet;


/***/ },
/* 479 */
/***/ function(module, exports, __webpack_require__) {

	var isPrototype = __webpack_require__(204),
	    nativeKeys = __webpack_require__(1724);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeys;


/***/ },
/* 480 */
/***/ function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(72),
	    isKey = __webpack_require__(299),
	    stringToPath = __webpack_require__(491),
	    toString = __webpack_require__(496);
	
	/**
	 * Casts `value` to a path array if it's not one.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {Array} Returns the cast property path array.
	 */
	function castPath(value, object) {
	  if (isArray(value)) {
	    return value;
	  }
	  return isKey(value, object) ? [value] : stringToPath(toString(value));
	}
	
	module.exports = castPath;


/***/ },
/* 481 */
/***/ function(module, exports) {

	/**
	 * Copies the values of `source` to `array`.
	 *
	 * @private
	 * @param {Array} source The array to copy values from.
	 * @param {Array} [array=[]] The array to copy values to.
	 * @returns {Array} Returns `array`.
	 */
	function copyArray(source, array) {
	  var index = -1,
	      length = source.length;
	
	  array || (array = Array(length));
	  while (++index < length) {
	    array[index] = source[index];
	  }
	  return array;
	}
	
	module.exports = copyArray;


/***/ },
/* 482 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(110);
	
	var defineProperty = (function() {
	  try {
	    var func = getNative(Object, 'defineProperty');
	    func({}, '', {});
	    return func;
	  } catch (e) {}
	}());
	
	module.exports = defineProperty;


/***/ },
/* 483 */
/***/ function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(1658),
	    arraySome = __webpack_require__(1663),
	    cacheHas = __webpack_require__(1687);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `array` and `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      arrLength = array.length,
	      othLength = other.length;
	
	  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	    return false;
	  }
	  // Check that cyclic values are equal.
	  var arrStacked = stack.get(array);
	  var othStacked = stack.get(other);
	  if (arrStacked && othStacked) {
	    return arrStacked == other && othStacked == array;
	  }
	  var index = -1,
	      result = true,
	      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	  stack.set(array, other);
	  stack.set(other, array);
	
	  // Ignore non-index properties.
	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, arrValue, index, other, array, stack)
	        : customizer(arrValue, othValue, index, array, other, stack);
	    }
	    if (compared !== undefined) {
	      if (compared) {
	        continue;
	      }
	      result = false;
	      break;
	    }
	    // Recursively compare arrays (susceptible to call stack limits).
	    if (seen) {
	      if (!arraySome(other, function(othValue, othIndex) {
	            if (!cacheHas(seen, othIndex) &&
	                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	              return seen.push(othIndex);
	            }
	          })) {
	        result = false;
	        break;
	      }
	    } else if (!(
	          arrValue === othValue ||
	            equalFunc(arrValue, othValue, bitmask, customizer, stack)
	        )) {
	      result = false;
	      break;
	    }
	  }
	  stack['delete'](array);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalArrays;


/***/ },
/* 484 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	module.exports = freeGlobal;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 485 */
/***/ function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(489);
	
	/** Built-in value references. */
	var getPrototype = overArg(Object.getPrototypeOf, Object);
	
	module.exports = getPrototype;


/***/ },
/* 486 */
/***/ function(module, exports, __webpack_require__) {

	var DataView = __webpack_require__(1654),
	    Map = __webpack_require__(295),
	    Promise = __webpack_require__(1656),
	    Set = __webpack_require__(1657),
	    WeakMap = __webpack_require__(1659),
	    baseGetTag = __webpack_require__(131),
	    toSource = __webpack_require__(492);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    setTag = '[object Set]',
	    weakMapTag = '[object WeakMap]';
	
	var dataViewTag = '[object DataView]';
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = baseGetTag(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : '';
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	module.exports = getTag;


/***/ },
/* 487 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(97);
	
	/**
	 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` if suitable for strict
	 *  equality comparisons, else `false`.
	 */
	function isStrictComparable(value) {
	  return value === value && !isObject(value);
	}
	
	module.exports = isStrictComparable;


/***/ },
/* 488 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `matchesProperty` for source values suitable
	 * for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function matchesStrictComparable(key, srcValue) {
	  return function(object) {
	    if (object == null) {
	      return false;
	    }
	    return object[key] === srcValue &&
	      (srcValue !== undefined || (key in Object(object)));
	  };
	}
	
	module.exports = matchesStrictComparable;


/***/ },
/* 489 */
/***/ function(module, exports) {

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	module.exports = overArg;


/***/ },
/* 490 */
/***/ function(module, exports) {

	/**
	 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function safeGet(object, key) {
	  if (key === 'constructor' && typeof object[key] === 'function') {
	    return;
	  }
	
	  if (key == '__proto__') {
	    return;
	  }
	
	  return object[key];
	}
	
	module.exports = safeGet;


/***/ },
/* 491 */
/***/ function(module, exports, __webpack_require__) {

	var memoizeCapped = __webpack_require__(1723);
	
	/** Used to match property names within property paths. */
	var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;
	
	/**
	 * Converts `string` to a property path array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the property path array.
	 */
	var stringToPath = memoizeCapped(function(string) {
	  var result = [];
	  if (string.charCodeAt(0) === 46 /* . */) {
	    result.push('');
	  }
	  string.replace(rePropName, function(match, number, quote, subString) {
	    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
	  });
	  return result;
	});
	
	module.exports = stringToPath;


/***/ },
/* 492 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var funcProto = Function.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to convert.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	module.exports = toSource;


/***/ },
/* 493 */
/***/ function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(478);
	
	/**
	 * Gets the value at `path` of `object`. If the resolved value is
	 * `undefined`, the `defaultValue` is returned in its place.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.7.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	 * @returns {*} Returns the resolved value.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.get(object, 'a[0].b.c');
	 * // => 3
	 *
	 * _.get(object, ['a', '0', 'b', 'c']);
	 * // => 3
	 *
	 * _.get(object, 'a.b.c', 'default');
	 * // => 'default'
	 */
	function get(object, path, defaultValue) {
	  var result = object == null ? undefined : baseGet(object, path);
	  return result === undefined ? defaultValue : result;
	}
	
	module.exports = get;


/***/ },
/* 494 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(202);
	
	/**
	 * This method is like `_.isEqual` except that it accepts `customizer` which
	 * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	 * are handled by the method instead. The `customizer` is invoked with up to
	 * six arguments: (objValue, othValue [, index|key, object, other, stack]).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * function isGreeting(value) {
	 *   return /^h(?:i|ello)$/.test(value);
	 * }
	 *
	 * function customizer(objValue, othValue) {
	 *   if (isGreeting(objValue) && isGreeting(othValue)) {
	 *     return true;
	 *   }
	 * }
	 *
	 * var array = ['hello', 'goodbye'];
	 * var other = ['hi', 'goodbye'];
	 *
	 * _.isEqualWith(array, other, customizer);
	 * // => true
	 */
	function isEqualWith(value, other, customizer) {
	  customizer = typeof customizer == 'function' ? customizer : undefined;
	  var result = customizer ? customizer(value, other) : undefined;
	  return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
	}
	
	module.exports = isEqualWith;


/***/ },
/* 495 */
/***/ function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(474),
	    baseKeysIn = __webpack_require__(1675),
	    isArrayLike = __webpack_require__(157);
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	}
	
	module.exports = keysIn;


/***/ },
/* 496 */
/***/ function(module, exports, __webpack_require__) {

	var baseToString = __webpack_require__(1685);
	
	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString(value) {
	  return value == null ? '' : baseToString(value);
	}
	
	module.exports = toString;


/***/ },
/* 497 */
/***/ function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.12.7
	(function() {
	  var Payment, QJ, cardFromNumber, cardFromType, cards, cursorSafeAssignValue, defaultFormat, formatBackCardNumber, formatBackExpiry, formatCardNumber, formatExpiry, formatForwardExpiry, formatForwardSlash, formatMonthExpiry, globalThis, hasTextSelected, luhnCheck, reFormatCardNumber, restrictCVC, restrictCardNumber, restrictCombinedExpiry, restrictExpiry, restrictMonthExpiry, restrictNumeric, restrictYearExpiry, setCardType,
	    indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };
	
	  globalThis = __webpack_require__(1631)();
	
	  QJ = __webpack_require__(1775);
	
	  defaultFormat = /(\d{1,4})/g;
	
	  cards = [
	    {
	      type: 'amex',
	      pattern: /^3[47]/,
	      format: /(\d{1,4})(\d{1,6})?(\d{1,5})?/,
	      length: [15],
	      cvcLength: [4],
	      luhn: true
	    }, {
	      type: 'dankort',
	      pattern: /^5019/,
	      format: defaultFormat,
	      length: [16],
	      cvcLength: [3],
	      luhn: true
	    }, {
	      type: 'dinersclub',
	      pattern: /^(36|38|30[0-5])/,
	      format: /(\d{1,4})(\d{1,6})?(\d{1,4})?/,
	      length: [14],
	      cvcLength: [3],
	      luhn: true
	    }, {
	      type: 'discover',
	      pattern: /^(6011|65|64[4-9]|622)/,
	      format: defaultFormat,
	      length: [16],
	      cvcLength: [3],
	      luhn: true
	    }, {
	      type: 'elo',
	      pattern: /^401178|^401179|^431274|^438935|^451416|^457393|^457631|^457632|^504175|^627780|^636297|^636369|^636368|^(506699|5067[0-6]\d|50677[0-8])|^(50900\d|5090[1-9]\d|509[1-9]\d{2})|^65003[1-3]|^(65003[5-9]|65004\d|65005[0-1])|^(65040[5-9]|6504[1-3]\d)|^(65048[5-9]|65049\d|6505[0-2]\d|65053[0-8])|^(65054[1-9]|6505[5-8]\d|65059[0-8])|^(65070\d|65071[0-8])|^65072[0-7]|^(65090[1-9]|65091\d|650920)|^(65165[2-9]|6516[6-7]\d)|^(65500\d|65501\d)|^(65502[1-9]|6550[3-4]\d|65505[0-8])|^(65092[1-9]|65097[0-8])/,
	      format: defaultFormat,
	      length: [16],
	      cvcLength: [3],
	      luhn: true
	    }, {
	      type: 'hipercard',
	      pattern: /^(384100|384140|384160|606282|637095|637568|60(?!11))/,
	      format: defaultFormat,
	      length: [14, 15, 16, 17, 18, 19],
	      cvcLength: [3],
	      luhn: true
	    }, {
	      type: 'jcb',
	      pattern: /^(308[8-9]|309[0-3]|3094[0]{4}|309[6-9]|310[0-2]|311[2-9]|3120|315[8-9]|333[7-9]|334[0-9]|35)/,
	      format: defaultFormat,
	      length: [16, 19],
	      cvcLength: [3],
	      luhn: true
	    }, {
	      type: 'laser',
	      pattern: /^(6706|6771|6709)/,
	      format: defaultFormat,
	      length: [16, 17, 18, 19],
	      cvcLength: [3],
	      luhn: true
	    }, {
	      type: 'maestro',
	      pattern: /^(50|5[6-9]|6007|6220|6304|6703|6708|6759|676[1-3])/,
	      format: defaultFormat,
	      length: [12, 13, 14, 15, 16, 17, 18, 19],
	      cvcLength: [3],
	      luhn: true
	    }, {
	      type: 'mastercard',
	      pattern: /^(5[1-5]|677189)|^(222[1-9]|2[3-6]\d{2}|27[0-1]\d|2720)/,
	      format: defaultFormat,
	      length: [16],
	      cvcLength: [3],
	      luhn: true
	    }, {
	      type: 'mir',
	      pattern: /^220[0-4][0-9][0-9]\d{10}$/,
	      format: defaultFormat,
	      length: [16],
	      cvcLength: [3],
	      luhn: true
	    }, {
	      type: 'troy',
	      pattern: /^9792/,
	      format: defaultFormat,
	      length: [16],
	      cvcLength: [3],
	      luhn: true
	    }, {
	      type: 'unionpay',
	      pattern: /^62/,
	      format: defaultFormat,
	      length: [16, 17, 18, 19],
	      cvcLength: [3],
	      luhn: false
	    }, {
	      type: 'visaelectron',
	      pattern: /^4(026|17500|405|508|844|91[37])/,
	      format: defaultFormat,
	      length: [16],
	      cvcLength: [3],
	      luhn: true
	    }, {
	      type: 'visa',
	      pattern: /^4/,
	      format: defaultFormat,
	      length: [13, 16],
	      cvcLength: [3],
	      luhn: true
	    }
	  ];
	
	  cardFromNumber = function(num) {
	    var card, foundCard, j, len, match;
	    num = (num + '').replace(/\D/g, '');
	    foundCard = void 0;
	    for (j = 0, len = cards.length; j < len; j++) {
	      card = cards[j];
	      if (match = num.match(card.pattern)) {
	        if (!foundCard || match[0].length > foundCard[1][0].length) {
	          foundCard = [card, match];
	        }
	      }
	    }
	    return foundCard && foundCard[0];
	  };
	
	  cardFromType = function(type) {
	    var card, j, len;
	    for (j = 0, len = cards.length; j < len; j++) {
	      card = cards[j];
	      if (card.type === type) {
	        return card;
	      }
	    }
	  };
	
	  luhnCheck = function(num) {
	    var digit, digits, j, len, odd, sum;
	    odd = true;
	    sum = 0;
	    digits = (num + '').split('').reverse();
	    for (j = 0, len = digits.length; j < len; j++) {
	      digit = digits[j];
	      digit = parseInt(digit, 10);
	      if ((odd = !odd)) {
	        digit *= 2;
	      }
	      if (digit > 9) {
	        digit -= 9;
	      }
	      sum += digit;
	    }
	    return sum % 10 === 0;
	  };
	
	  hasTextSelected = function(target) {
	    var e, ref;
	    try {
	      if ((target.selectionStart != null) && target.selectionStart !== target.selectionEnd) {
	        return true;
	      }
	      if ((typeof document !== "undefined" && document !== null ? (ref = document.selection) != null ? ref.createRange : void 0 : void 0) != null) {
	        if (document.selection.createRange().text) {
	          return true;
	        }
	      }
	    } catch (error) {
	      e = error;
	    }
	    return false;
	  };
	
	  reFormatCardNumber = function(e) {
	    return setTimeout((function(_this) {
	      return function() {
	        var target, value;
	        target = e.target;
	        value = QJ.val(target);
	        value = Payment.fns.formatCardNumber(value);
	        cursorSafeAssignValue(target, value);
	        return QJ.trigger(target, 'change');
	      };
	    })(this));
	  };
	
	  formatCardNumber = function(maxLength) {
	    return function(e) {
	      var card, digit, i, j, len, length, re, target, upperLength, upperLengths, value;
	      if (e.which > 0) {
	        digit = String.fromCharCode(e.which);
	        value = QJ.val(e.target) + digit;
	      } else {
	        digit = e.data;
	        value = QJ.val(e.target);
	      }
	      if (!/^\d+$/.test(digit)) {
	        return;
	      }
	      target = e.target;
	      card = cardFromNumber(value);
	      length = (value.replace(/\D/g, '')).length;
	      upperLengths = [16];
	      if (card) {
	        upperLengths = card.length;
	      }
	      if (maxLength) {
	        upperLengths = upperLengths.filter(function(x) {
	          return x <= maxLength;
	        });
	      }
	      for (i = j = 0, len = upperLengths.length; j < len; i = ++j) {
	        upperLength = upperLengths[i];
	        if (length >= upperLength && upperLengths[i + 1]) {
	          continue;
	        }
	        if (length >= upperLength) {
	          return;
	        }
	      }
	      if (hasTextSelected(target)) {
	        return;
	      }
	      if (card && card.type === 'amex') {
	        re = /^(\d{4}|\d{4}\s\d{6})$/;
	      } else {
	        re = /(?:^|\s)(\d{4})$/;
	      }
	      value = value.substring(0, value.length - 1);
	      if (re.test(value)) {
	        e.preventDefault();
	        QJ.val(target, value + ' ' + digit);
	        return QJ.trigger(target, 'change');
	      }
	    };
	  };
	
	  formatBackCardNumber = function(e) {
	    var target, value;
	    target = e.target;
	    value = QJ.val(target);
	    if (e.meta) {
	      return;
	    }
	    if (e.which !== 8) {
	      return;
	    }
	    if (hasTextSelected(target)) {
	      return;
	    }
	    if (/\d\s$/.test(value)) {
	      e.preventDefault();
	      QJ.val(target, value.replace(/\d\s$/, ''));
	      return QJ.trigger(target, 'change');
	    } else if (/\s\d?$/.test(value)) {
	      e.preventDefault();
	      QJ.val(target, value.replace(/\s\d?$/, ''));
	      return QJ.trigger(target, 'change');
	    }
	  };
	
	  formatExpiry = function(e) {
	    var digit, target, val;
	    target = e.target;
	    if (e.which > 0) {
	      digit = String.fromCharCode(e.which);
	      val = QJ.val(target) + digit;
	    } else {
	      digit = e.data;
	      val = QJ.val(target);
	    }
	    if (!/^\d+$/.test(digit)) {
	      return;
	    }
	    if (/^\d$/.test(val) && (val !== '0' && val !== '1')) {
	      e.preventDefault();
	      QJ.val(target, "0" + val + " / ");
	      return QJ.trigger(target, 'change');
	    } else if (/^\d\d$/.test(val)) {
	      e.preventDefault();
	      QJ.val(target, val + " / ");
	      return QJ.trigger(target, 'change');
	    }
	  };
	
	  formatMonthExpiry = function(e) {
	    var digit, target, val;
	    digit = String.fromCharCode(e.which);
	    if (!/^\d+$/.test(digit)) {
	      return;
	    }
	    target = e.target;
	    val = QJ.val(target) + digit;
	    if (/^\d$/.test(val) && (val !== '0' && val !== '1')) {
	      e.preventDefault();
	      QJ.val(target, "0" + val);
	      return QJ.trigger(target, 'change');
	    } else if (/^\d\d$/.test(val)) {
	      e.preventDefault();
	      QJ.val(target, "" + val);
	      return QJ.trigger(target, 'change');
	    }
	  };
	
	  formatForwardExpiry = function(e) {
	    var digit, target, val;
	    digit = String.fromCharCode(e.which);
	    if (!/^\d+$/.test(digit)) {
	      return;
	    }
	    target = e.target;
	    val = QJ.val(target);
	    if (/^\d\d$/.test(val)) {
	      QJ.val(target, val + " / ");
	      return QJ.trigger(target, 'change');
	    }
	  };
	
	  formatForwardSlash = function(e) {
	    var slash, target, val;
	    slash = String.fromCharCode(e.which);
	    if (slash !== '/') {
	      return;
	    }
	    target = e.target;
	    val = QJ.val(target);
	    if (/^\d$/.test(val) && val !== '0') {
	      QJ.val(target, "0" + val + " / ");
	      return QJ.trigger(target, 'change');
	    }
	  };
	
	  formatBackExpiry = function(e) {
	    var target, value;
	    if (e.metaKey) {
	      return;
	    }
	    target = e.target;
	    value = QJ.val(target);
	    if (e.which !== 8) {
	      return;
	    }
	    if (hasTextSelected(target)) {
	      return;
	    }
	    if (/\d(\s|\/)+$/.test(value)) {
	      e.preventDefault();
	      QJ.val(target, value.replace(/\d(\s|\/)*$/, ''));
	      return QJ.trigger(target, 'change');
	    } else if (/\s\/\s?\d?$/.test(value)) {
	      e.preventDefault();
	      QJ.val(target, value.replace(/\s\/\s?\d?$/, ''));
	      return QJ.trigger(target, 'change');
	    }
	  };
	
	  restrictNumeric = function(e) {
	    var input;
	    if (e.metaKey || e.ctrlKey) {
	      return true;
	    }
	    if (e.which === 32) {
	      return e.preventDefault();
	    }
	    if (e.which === 0) {
	      return true;
	    }
	    if (e.which < 33) {
	      return true;
	    }
	    input = String.fromCharCode(e.which);
	    if (!/[\d\s]/.test(input)) {
	      return e.preventDefault();
	    }
	  };
	
	  restrictCardNumber = function(maxLength) {
	    return function(e) {
	      var card, digit, length, target, value;
	      target = e.target;
	      digit = String.fromCharCode(e.which);
	      if (!/^\d+$/.test(digit)) {
	        return;
	      }
	      if (hasTextSelected(target)) {
	        return;
	      }
	      value = (QJ.val(target) + digit).replace(/\D/g, '');
	      card = cardFromNumber(value);
	      length = 16;
	      if (card) {
	        length = card.length[card.length.length - 1];
	      }
	      if (maxLength) {
	        length = Math.min(length, maxLength);
	      }
	      if (!(value.length <= length)) {
	        return e.preventDefault();
	      }
	    };
	  };
	
	  restrictExpiry = function(e, length) {
	    var digit, target, value;
	    target = e.target;
	    digit = String.fromCharCode(e.which);
	    if (!/^\d+$/.test(digit)) {
	      return;
	    }
	    if (hasTextSelected(target)) {
	      return;
	    }
	    value = QJ.val(target) + digit;
	    value = value.replace(/\D/g, '');
	    if (value.length > length) {
	      return e.preventDefault();
	    }
	  };
	
	  restrictCombinedExpiry = function(e) {
	    return restrictExpiry(e, 6);
	  };
	
	  restrictMonthExpiry = function(e) {
	    return restrictExpiry(e, 2);
	  };
	
	  restrictYearExpiry = function(e) {
	    return restrictExpiry(e, 4);
	  };
	
	  restrictCVC = function(e) {
	    var digit, target, val;
	    target = e.target;
	    digit = String.fromCharCode(e.which);
	    if (!/^\d+$/.test(digit)) {
	      return;
	    }
	    if (hasTextSelected(target)) {
	      return;
	    }
	    val = QJ.val(target) + digit;
	    if (!(val.length <= 4)) {
	      return e.preventDefault();
	    }
	  };
	
	  setCardType = function(e) {
	    var allTypes, card, cardType, target, val;
	    target = e.target;
	    val = QJ.val(target);
	    cardType = Payment.fns.cardType(val) || 'unknown';
	    if (!QJ.hasClass(target, cardType)) {
	      allTypes = (function() {
	        var j, len, results;
	        results = [];
	        for (j = 0, len = cards.length; j < len; j++) {
	          card = cards[j];
	          results.push(card.type);
	        }
	        return results;
	      })();
	      QJ.removeClass(target, 'unknown');
	      QJ.removeClass(target, allTypes.join(' '));
	      QJ.addClass(target, cardType);
	      QJ.toggleClass(target, 'identified', cardType !== 'unknown');
	      return QJ.trigger(target, 'payment.cardType', cardType);
	    }
	  };
	
	  cursorSafeAssignValue = function(target, value) {
	    var selectionEnd;
	    selectionEnd = target.selectionEnd;
	    QJ.val(target, value);
	    if (selectionEnd) {
	      return target.selectionEnd = selectionEnd;
	    }
	  };
	
	  Payment = (function() {
	    function Payment() {}
	
	    Payment.J = QJ;
	
	    Payment.fns = {
	      cardExpiryVal: function(value) {
	        var month, prefix, ref, year;
	        value = value.replace(/\s/g, '');
	        ref = value.split('/', 2), month = ref[0], year = ref[1];
	        if ((year != null ? year.length : void 0) === 2 && /^\d+$/.test(year)) {
	          prefix = (new Date).getFullYear();
	          prefix = prefix.toString().slice(0, 2);
	          year = prefix + year;
	        }
	        month = parseInt(month, 10);
	        year = parseInt(year, 10);
	        return {
	          month: month,
	          year: year
	        };
	      },
	      validateCardNumber: function(num) {
	        var card, ref;
	        num = (num + '').replace(/\s+|-/g, '');
	        if (!/^\d+$/.test(num)) {
	          return false;
	        }
	        card = cardFromNumber(num);
	        if (!card) {
	          return false;
	        }
	        return (ref = num.length, indexOf.call(card.length, ref) >= 0) && (card.luhn === false || luhnCheck(num));
	      },
	      validateCardExpiry: function(month, year) {
	        var currentTime, expiry, prefix, ref, ref1;
	        if (typeof month === 'object' && 'month' in month) {
	          ref = month, month = ref.month, year = ref.year;
	        } else if (typeof month === 'string' && indexOf.call(month, '/') >= 0) {
	          ref1 = Payment.fns.cardExpiryVal(month), month = ref1.month, year = ref1.year;
	        }
	        if (!(month && year)) {
	          return false;
	        }
	        month = QJ.trim(month);
	        year = QJ.trim(year);
	        if (!/^\d+$/.test(month)) {
	          return false;
	        }
	        if (!/^\d+$/.test(year)) {
	          return false;
	        }
	        month = parseInt(month, 10);
	        if (!(month && month <= 12)) {
	          return false;
	        }
	        if (year.length === 2) {
	          prefix = (new Date).getFullYear();
	          prefix = prefix.toString().slice(0, 2);
	          year = prefix + year;
	        }
	        expiry = new Date(year, month);
	        currentTime = new Date;
	        expiry.setMonth(expiry.getMonth() - 1);
	        expiry.setMonth(expiry.getMonth() + 1, 1);
	        return expiry > currentTime;
	      },
	      validateCardCVC: function(cvc, type) {
	        var ref, ref1;
	        cvc = QJ.trim(cvc);
	        if (!/^\d+$/.test(cvc)) {
	          return false;
	        }
	        if (type && cardFromType(type)) {
	          return ref = cvc.length, indexOf.call((ref1 = cardFromType(type)) != null ? ref1.cvcLength : void 0, ref) >= 0;
	        } else {
	          return cvc.length >= 3 && cvc.length <= 4;
	        }
	      },
	      cardType: function(num) {
	        var ref;
	        if (!num) {
	          return null;
	        }
	        return ((ref = cardFromNumber(num)) != null ? ref.type : void 0) || null;
	      },
	      formatCardNumber: function(num) {
	        var card, groups, ref, upperLength;
	        card = cardFromNumber(num);
	        if (!card) {
	          return num;
	        }
	        upperLength = card.length[card.length.length - 1];
	        num = num.replace(/\D/g, '');
	        num = num.slice(0, upperLength);
	        if (card.format.global) {
	          return (ref = num.match(card.format)) != null ? ref.join(' ') : void 0;
	        } else {
	          groups = card.format.exec(num);
	          if (groups == null) {
	            return;
	          }
	          groups.shift();
	          groups = groups.filter(function(n) {
	            return n;
	          });
	          return groups.join(' ');
	        }
	      }
	    };
	
	    Payment.restrictNumeric = function(el) {
	      QJ.on(el, 'keypress', restrictNumeric);
	      return QJ.on(el, 'input', restrictNumeric);
	    };
	
	    Payment.cardExpiryVal = function(el) {
	      return Payment.fns.cardExpiryVal(QJ.val(el));
	    };
	
	    Payment.formatCardCVC = function(el) {
	      Payment.restrictNumeric(el);
	      QJ.on(el, 'keypress', restrictCVC);
	      QJ.on(el, 'input', restrictCVC);
	      return el;
	    };
	
	    Payment.formatCardExpiry = function(el) {
	      var month, year;
	      Payment.restrictNumeric(el);
	      if (el.length && el.length === 2) {
	        month = el[0], year = el[1];
	        this.formatCardExpiryMultiple(month, year);
	      } else {
	        QJ.on(el, 'keypress', restrictCombinedExpiry);
	        QJ.on(el, 'keypress', formatExpiry);
	        QJ.on(el, 'keypress', formatForwardSlash);
	        QJ.on(el, 'keypress', formatForwardExpiry);
	        QJ.on(el, 'keydown', formatBackExpiry);
	        QJ.on(el, 'input', formatExpiry);
	      }
	      return el;
	    };
	
	    Payment.formatCardExpiryMultiple = function(month, year) {
	      QJ.on(month, 'keypress', restrictMonthExpiry);
	      QJ.on(month, 'keypress', formatMonthExpiry);
	      QJ.on(month, 'input', formatMonthExpiry);
	      QJ.on(year, 'keypress', restrictYearExpiry);
	      return QJ.on(year, 'input', restrictYearExpiry);
	    };
	
	    Payment.formatCardNumber = function(el, maxLength) {
	      Payment.restrictNumeric(el);
	      QJ.on(el, 'keypress', restrictCardNumber(maxLength));
	      QJ.on(el, 'keypress', formatCardNumber(maxLength));
	      QJ.on(el, 'keydown', formatBackCardNumber);
	      QJ.on(el, 'keyup blur', setCardType);
	      QJ.on(el, 'blur', formatCardNumber(maxLength));
	      QJ.on(el, 'paste', reFormatCardNumber);
	      QJ.on(el, 'input', formatCardNumber(maxLength));
	      return el;
	    };
	
	    Payment.getCardArray = function() {
	      return cards;
	    };
	
	    Payment.setCardArray = function(cardArray) {
	      cards = cardArray;
	      return true;
	    };
	
	    Payment.addToCardArray = function(cardObject) {
	      return cards.push(cardObject);
	    };
	
	    Payment.removeFromCardArray = function(type) {
	      var key, value;
	      for (key in cards) {
	        value = cards[key];
	        if (value.type === type) {
	          cards.splice(key, 1);
	        }
	      }
	      return true;
	    };
	
	    return Payment;
	
	  })();
	
	  module.exports = Payment;
	
	  globalThis.Payment = Payment;
	
	}).call(this);


/***/ },
/* 498 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var asap = __webpack_require__(632);
	
	function noop() {}
	
	// States:
	//
	// 0 - pending
	// 1 - fulfilled with _value
	// 2 - rejected with _value
	// 3 - adopted the state of another promise, _value
	//
	// once the state is no longer pending (0) it is immutable
	
	// All `_` prefixed properties will be reduced to `_{random number}`
	// at build time to obfuscate them and discourage their use.
	// We don't use symbols or Object.defineProperty to fully hide them
	// because the performance isn't good enough.
	
	
	// to avoid using try/catch inside critical functions, we
	// extract them to here.
	var LAST_ERROR = null;
	var IS_ERROR = {};
	function getThen(obj) {
	  try {
	    return obj.then;
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	function tryCallOne(fn, a) {
	  try {
	    return fn(a);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	function tryCallTwo(fn, a, b) {
	  try {
	    fn(a, b);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	module.exports = Promise;
	
	function Promise(fn) {
	  if (typeof this !== 'object') {
	    throw new TypeError('Promises must be constructed via new');
	  }
	  if (typeof fn !== 'function') {
	    throw new TypeError('not a function');
	  }
	  this._45 = 0;
	  this._81 = 0;
	  this._65 = null;
	  this._54 = null;
	  if (fn === noop) return;
	  doResolve(fn, this);
	}
	Promise._10 = null;
	Promise._97 = null;
	Promise._61 = noop;
	
	Promise.prototype.then = function(onFulfilled, onRejected) {
	  if (this.constructor !== Promise) {
	    return safeThen(this, onFulfilled, onRejected);
	  }
	  var res = new Promise(noop);
	  handle(this, new Handler(onFulfilled, onRejected, res));
	  return res;
	};
	
	function safeThen(self, onFulfilled, onRejected) {
	  return new self.constructor(function (resolve, reject) {
	    var res = new Promise(noop);
	    res.then(resolve, reject);
	    handle(self, new Handler(onFulfilled, onRejected, res));
	  });
	};
	function handle(self, deferred) {
	  while (self._81 === 3) {
	    self = self._65;
	  }
	  if (Promise._10) {
	    Promise._10(self);
	  }
	  if (self._81 === 0) {
	    if (self._45 === 0) {
	      self._45 = 1;
	      self._54 = deferred;
	      return;
	    }
	    if (self._45 === 1) {
	      self._45 = 2;
	      self._54 = [self._54, deferred];
	      return;
	    }
	    self._54.push(deferred);
	    return;
	  }
	  handleResolved(self, deferred);
	}
	
	function handleResolved(self, deferred) {
	  asap(function() {
	    var cb = self._81 === 1 ? deferred.onFulfilled : deferred.onRejected;
	    if (cb === null) {
	      if (self._81 === 1) {
	        resolve(deferred.promise, self._65);
	      } else {
	        reject(deferred.promise, self._65);
	      }
	      return;
	    }
	    var ret = tryCallOne(cb, self._65);
	    if (ret === IS_ERROR) {
	      reject(deferred.promise, LAST_ERROR);
	    } else {
	      resolve(deferred.promise, ret);
	    }
	  });
	}
	function resolve(self, newValue) {
	  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
	  if (newValue === self) {
	    return reject(
	      self,
	      new TypeError('A promise cannot be resolved with itself.')
	    );
	  }
	  if (
	    newValue &&
	    (typeof newValue === 'object' || typeof newValue === 'function')
	  ) {
	    var then = getThen(newValue);
	    if (then === IS_ERROR) {
	      return reject(self, LAST_ERROR);
	    }
	    if (
	      then === self.then &&
	      newValue instanceof Promise
	    ) {
	      self._81 = 3;
	      self._65 = newValue;
	      finale(self);
	      return;
	    } else if (typeof then === 'function') {
	      doResolve(then.bind(newValue), self);
	      return;
	    }
	  }
	  self._81 = 1;
	  self._65 = newValue;
	  finale(self);
	}
	
	function reject(self, newValue) {
	  self._81 = 2;
	  self._65 = newValue;
	  if (Promise._97) {
	    Promise._97(self, newValue);
	  }
	  finale(self);
	}
	function finale(self) {
	  if (self._45 === 1) {
	    handle(self, self._54);
	    self._54 = null;
	  }
	  if (self._45 === 2) {
	    for (var i = 0; i < self._54.length; i++) {
	      handle(self, self._54[i]);
	    }
	    self._54 = null;
	  }
	}
	
	function Handler(onFulfilled, onRejected, promise){
	  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
	  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
	  this.promise = promise;
	}
	
	/**
	 * Take a potentially misbehaving resolver function and make sure
	 * onFulfilled and onRejected are only called once.
	 *
	 * Makes no guarantees about asynchrony.
	 */
	function doResolve(fn, promise) {
	  var done = false;
	  var res = tryCallTwo(fn, function (value) {
	    if (done) return;
	    done = true;
	    resolve(promise, value);
	  }, function (reason) {
	    if (done) return;
	    done = true;
	    reject(promise, reason);
	  })
	  if (!done && res === IS_ERROR) {
	    done = true;
	    reject(promise, LAST_ERROR);
	  }
	}


/***/ },
/* 499 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(8));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _SafeAnchor = _interopRequireDefault(__webpack_require__(73));
	
	var propTypes = {
	  /**
	   * If set to true, renders `span` instead of `a`
	   */
	  active: _propTypes.default.bool,
	
	  /**
	   * `href` attribute for the inner `a` element
	   */
	  href: _propTypes.default.string,
	
	  /**
	   * `title` attribute for the inner `a` element
	   */
	  title: _propTypes.default.node,
	
	  /**
	   * `target` attribute for the inner `a` element
	   */
	  target: _propTypes.default.string
	};
	var defaultProps = {
	  active: false
	};
	
	var BreadcrumbItem =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(BreadcrumbItem, _React$Component);
	
	  function BreadcrumbItem() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = BreadcrumbItem.prototype;
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        active = _this$props.active,
	        href = _this$props.href,
	        title = _this$props.title,
	        target = _this$props.target,
	        className = _this$props.className,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["active", "href", "title", "target", "className"]); // Don't try to render these props on non-active <span>.
	
	    var linkProps = {
	      href: href,
	      title: title,
	      target: target
	    };
	    return _react.default.createElement("li", {
	      className: (0, _classnames.default)(className, {
	        active: active
	      })
	    }, active ? _react.default.createElement("span", props) : _react.default.createElement(_SafeAnchor.default, (0, _extends2.default)({}, props, linkProps)));
	  };
	
	  return BreadcrumbItem;
	}(_react.default.Component);
	
	BreadcrumbItem.propTypes = propTypes;
	BreadcrumbItem.defaultProps = defaultProps;
	var _default = BreadcrumbItem;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 500 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(8));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(57));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(46));
	
	var _transition = _interopRequireDefault(__webpack_require__(1590));
	
	var propTypes = {
	  direction: _propTypes.default.oneOf(['prev', 'next']),
	  onAnimateOutEnd: _propTypes.default.func,
	  active: _propTypes.default.bool,
	  animateIn: _propTypes.default.bool,
	  animateOut: _propTypes.default.bool,
	  index: _propTypes.default.number
	};
	var defaultProps = {
	  active: false,
	  animateIn: false,
	  animateOut: false
	};
	
	var CarouselItem =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(CarouselItem, _React$Component);
	
	  function CarouselItem(props, context) {
	    var _this;
	
	    _this = _React$Component.call(this, props, context) || this;
	    _this.handleAnimateOutEnd = _this.handleAnimateOutEnd.bind((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
	    _this.state = {
	      direction: null
	    };
	    _this.isUnmounted = false;
	    return _this;
	  }
	
	  var _proto = CarouselItem.prototype;
	
	  _proto.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps(nextProps) {
	    // eslint-disable-line
	    if (this.props.active !== nextProps.active) {
	      this.setState({
	        direction: null
	      });
	    }
	  };
	
	  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var _this2 = this;
	
	    var active = this.props.active;
	    var prevActive = prevProps.active;
	
	    if (!active && prevActive) {
	      _transition.default.end(_reactDom.default.findDOMNode(this), this.handleAnimateOutEnd);
	    }
	
	    if (active !== prevActive) {
	      setTimeout(function () {
	        return _this2.startAnimation();
	      }, 20);
	    }
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    this.isUnmounted = true;
	  };
	
	  _proto.handleAnimateOutEnd = function handleAnimateOutEnd() {
	    if (this.isUnmounted) {
	      return;
	    }
	
	    if (this.props.onAnimateOutEnd) {
	      this.props.onAnimateOutEnd(this.props.index);
	    }
	  };
	
	  _proto.startAnimation = function startAnimation() {
	    if (this.isUnmounted) {
	      return;
	    }
	
	    this.setState({
	      direction: this.props.direction === 'prev' ? 'right' : 'left'
	    });
	  };
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        direction = _this$props.direction,
	        active = _this$props.active,
	        animateIn = _this$props.animateIn,
	        animateOut = _this$props.animateOut,
	        className = _this$props.className,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["direction", "active", "animateIn", "animateOut", "className"]);
	    delete props.onAnimateOutEnd;
	    delete props.index;
	    var classes = {
	      item: true,
	      active: active && !animateIn || animateOut
	    };
	
	    if (direction && active && animateIn) {
	      classes[direction] = true;
	    }
	
	    if (this.state.direction && (animateIn || animateOut)) {
	      classes[this.state.direction] = true;
	    }
	
	    return _react.default.createElement("div", (0, _extends2.default)({}, props, {
	      className: (0, _classnames.default)(className, classes)
	    }));
	  };
	
	  return CarouselItem;
	}(_react.default.Component);
	
	CarouselItem.propTypes = propTypes;
	CarouselItem.defaultProps = defaultProps;
	var _default = CarouselItem;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 501 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(8));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _Button = _interopRequireDefault(__webpack_require__(158));
	
	var _SafeAnchor = _interopRequireDefault(__webpack_require__(73));
	
	var _bootstrapUtils = __webpack_require__(16);
	
	var propTypes = {
	  noCaret: _propTypes.default.bool,
	  open: _propTypes.default.bool,
	  title: _propTypes.default.string,
	  useAnchor: _propTypes.default.bool
	};
	var defaultProps = {
	  open: false,
	  useAnchor: false,
	  bsRole: 'toggle'
	};
	
	var DropdownToggle =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(DropdownToggle, _React$Component);
	
	  function DropdownToggle() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = DropdownToggle.prototype;
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        noCaret = _this$props.noCaret,
	        open = _this$props.open,
	        useAnchor = _this$props.useAnchor,
	        bsClass = _this$props.bsClass,
	        className = _this$props.className,
	        children = _this$props.children,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["noCaret", "open", "useAnchor", "bsClass", "className", "children"]);
	    delete props.bsRole;
	    var Component = useAnchor ? _SafeAnchor.default : _Button.default;
	    var useCaret = !noCaret; // This intentionally forwards bsSize and bsStyle (if set) to the
	    // underlying component, to allow it to render size and style variants.
	    // FIXME: Should this really fall back to `title` as children?
	
	    return _react.default.createElement(Component, (0, _extends2.default)({}, props, {
	      role: "button",
	      className: (0, _classnames.default)(className, bsClass),
	      "aria-haspopup": true,
	      "aria-expanded": open
	    }), children || props.title, useCaret && ' ', useCaret && _react.default.createElement("span", {
	      className: "caret"
	    }));
	  };
	
	  return DropdownToggle;
	}(_react.default.Component);
	
	DropdownToggle.propTypes = propTypes;
	DropdownToggle.defaultProps = defaultProps;
	
	var _default = (0, _bootstrapUtils.bsClass)('dropdown-toggle', DropdownToggle);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 502 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(8));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _elementType = _interopRequireDefault(__webpack_require__(32));
	
	var _bootstrapUtils = __webpack_require__(16);
	
	var propTypes = {
	  /**
	   * Turn any fixed-width grid layout into a full-width layout by this property.
	   *
	   * Adds `container-fluid` class.
	   */
	  fluid: _propTypes.default.bool,
	
	  /**
	   * You can use a custom element for this component
	   */
	  componentClass: _elementType.default
	};
	var defaultProps = {
	  componentClass: 'div',
	  fluid: false
	};
	
	var Grid =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(Grid, _React$Component);
	
	  function Grid() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = Grid.prototype;
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        fluid = _this$props.fluid,
	        Component = _this$props.componentClass,
	        className = _this$props.className,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["fluid", "componentClass", "className"]);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.prefix)(bsProps, fluid && 'fluid');
	    return _react.default.createElement(Component, (0, _extends2.default)({}, elementProps, {
	      className: (0, _classnames.default)(className, classes)
	    }));
	  };
	
	  return Grid;
	}(_react.default.Component);
	
	Grid.propTypes = propTypes;
	Grid.defaultProps = defaultProps;
	
	var _default = (0, _bootstrapUtils.bsClass)('container', Grid);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 503 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(47);
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _values = _interopRequireDefault(__webpack_require__(120));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(8));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _bootstrapUtils = __webpack_require__(16);
	
	var _StyleConfig = __webpack_require__(50);
	
	var propTypes = {
	  active: _propTypes.default.any,
	  disabled: _propTypes.default.any,
	  header: _propTypes.default.node,
	  listItem: _propTypes.default.bool,
	  onClick: _propTypes.default.func,
	  href: _propTypes.default.string,
	  type: _propTypes.default.string
	};
	var defaultProps = {
	  listItem: false
	};
	
	var ListGroupItem =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(ListGroupItem, _React$Component);
	
	  function ListGroupItem() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = ListGroupItem.prototype;
	
	  _proto.renderHeader = function renderHeader(header, headingClassName) {
	    if (_react.default.isValidElement(header)) {
	      return (0, _react.cloneElement)(header, {
	        className: (0, _classnames.default)(header.props.className, headingClassName)
	      });
	    }
	
	    return _react.default.createElement("h4", {
	      className: headingClassName
	    }, header);
	  };
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        active = _this$props.active,
	        disabled = _this$props.disabled,
	        className = _this$props.className,
	        header = _this$props.header,
	        listItem = _this$props.listItem,
	        children = _this$props.children,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["active", "disabled", "className", "header", "listItem", "children"]);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends2.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	      active: active,
	      disabled: disabled
	    });
	    var Component;
	
	    if (elementProps.href) {
	      Component = 'a';
	    } else if (elementProps.onClick) {
	      Component = 'button';
	      elementProps.type = elementProps.type || 'button';
	    } else if (listItem) {
	      Component = 'li';
	    } else {
	      Component = 'span';
	    }
	
	    elementProps.className = (0, _classnames.default)(className, classes); // TODO: Deprecate `header` prop.
	
	    if (header) {
	      return _react.default.createElement(Component, elementProps, this.renderHeader(header, (0, _bootstrapUtils.prefix)(bsProps, 'heading')), _react.default.createElement("p", {
	        className: (0, _bootstrapUtils.prefix)(bsProps, 'text')
	      }, children));
	    }
	
	    return _react.default.createElement(Component, elementProps, children);
	  };
	
	  return ListGroupItem;
	}(_react.default.Component);
	
	ListGroupItem.propTypes = propTypes;
	ListGroupItem.defaultProps = defaultProps;
	
	var _default = (0, _bootstrapUtils.bsClass)('list-group-item', (0, _bootstrapUtils.bsStyles)((0, _values.default)(_StyleConfig.State), ListGroupItem));
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 504 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(8));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(57));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _all = _interopRequireDefault(__webpack_require__(212));
	
	var _SafeAnchor = _interopRequireDefault(__webpack_require__(73));
	
	var _bootstrapUtils = __webpack_require__(16);
	
	var _createChainedFunction = _interopRequireDefault(__webpack_require__(45));
	
	var propTypes = {
	  /**
	   * Highlight the menu item as active.
	   */
	  active: _propTypes.default.bool,
	
	  /**
	   * Disable the menu item, making it unselectable.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * Styles the menu item as a horizontal rule, providing visual separation between
	   * groups of menu items.
	   */
	  divider: (0, _all.default)(_propTypes.default.bool, function (_ref) {
	    var divider = _ref.divider,
	        children = _ref.children;
	    return divider && children ? new Error('Children will not be rendered for dividers') : null;
	  }),
	
	  /**
	   * Value passed to the `onSelect` handler, useful for identifying the selected menu item.
	   */
	  eventKey: _propTypes.default.any,
	
	  /**
	   * Styles the menu item as a header label, useful for describing a group of menu items.
	   */
	  header: _propTypes.default.bool,
	
	  /**
	   * HTML `href` attribute corresponding to `a.href`.
	   */
	  href: _propTypes.default.string,
	
	  /**
	   * Callback fired when the menu item is clicked.
	   */
	  onClick: _propTypes.default.func,
	
	  /**
	   * Callback fired when the menu item is selected.
	   *
	   * ```js
	   * (eventKey: any, event: Object) => any
	   * ```
	   */
	  onSelect: _propTypes.default.func
	};
	var defaultProps = {
	  divider: false,
	  disabled: false,
	  header: false
	};
	
	var MenuItem =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(MenuItem, _React$Component);
	
	  function MenuItem(props, context) {
	    var _this;
	
	    _this = _React$Component.call(this, props, context) || this;
	    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
	    return _this;
	  }
	
	  var _proto = MenuItem.prototype;
	
	  _proto.handleClick = function handleClick(event) {
	    var _this$props = this.props,
	        href = _this$props.href,
	        disabled = _this$props.disabled,
	        onSelect = _this$props.onSelect,
	        eventKey = _this$props.eventKey;
	
	    if (!href || disabled) {
	      event.preventDefault();
	    }
	
	    if (disabled) {
	      return;
	    }
	
	    if (onSelect) {
	      onSelect(eventKey, event);
	    }
	  };
	
	  _proto.render = function render() {
	    var _this$props2 = this.props,
	        active = _this$props2.active,
	        disabled = _this$props2.disabled,
	        divider = _this$props2.divider,
	        header = _this$props2.header,
	        onClick = _this$props2.onClick,
	        className = _this$props2.className,
	        style = _this$props2.style,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props2, ["active", "disabled", "divider", "header", "onClick", "className", "style"]);
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['eventKey', 'onSelect']),
	        bsProps = _splitBsPropsAndOmit[0],
	        elementProps = _splitBsPropsAndOmit[1];
	
	    if (divider) {
	      // Forcibly blank out the children; separators shouldn't render any.
	      elementProps.children = undefined;
	      return _react.default.createElement("li", (0, _extends2.default)({}, elementProps, {
	        role: "separator",
	        className: (0, _classnames.default)(className, 'divider'),
	        style: style
	      }));
	    }
	
	    if (header) {
	      return _react.default.createElement("li", (0, _extends2.default)({}, elementProps, {
	        role: "heading",
	        className: (0, _classnames.default)(className, (0, _bootstrapUtils.prefix)(bsProps, 'header')),
	        style: style
	      }));
	    }
	
	    return _react.default.createElement("li", {
	      role: "presentation",
	      className: (0, _classnames.default)(className, {
	        active: active,
	        disabled: disabled
	      }),
	      style: style
	    }, _react.default.createElement(_SafeAnchor.default, (0, _extends2.default)({}, elementProps, {
	      role: "menuitem",
	      tabIndex: "-1",
	      onClick: (0, _createChainedFunction.default)(onClick, this.handleClick)
	    })));
	  };
	
	  return MenuItem;
	}(_react.default.Component);
	
	MenuItem.propTypes = propTypes;
	MenuItem.defaultProps = defaultProps;
	
	var _default = (0, _bootstrapUtils.bsClass)('dropdown', MenuItem);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 505 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(8));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _elementType = _interopRequireDefault(__webpack_require__(32));
	
	var _bootstrapUtils = __webpack_require__(16);
	
	var propTypes = {
	  componentClass: _elementType.default
	};
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var ModalBody =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(ModalBody, _React$Component);
	
	  function ModalBody() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = ModalBody.prototype;
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        Component = _this$props.componentClass,
	        className = _this$props.className,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["componentClass", "className"]);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	    return _react.default.createElement(Component, (0, _extends2.default)({}, elementProps, {
	      className: (0, _classnames.default)(className, classes)
	    }));
	  };
	
	  return ModalBody;
	}(_react.default.Component);
	
	ModalBody.propTypes = propTypes;
	ModalBody.defaultProps = defaultProps;
	
	var _default = (0, _bootstrapUtils.bsClass)('modal-body', ModalBody);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 506 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends3 = _interopRequireDefault(__webpack_require__(8));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _bootstrapUtils = __webpack_require__(16);
	
	var _StyleConfig = __webpack_require__(50);
	
	var propTypes = {
	  /**
	   * A css class to apply to the Modal dialog DOM node.
	   */
	  dialogClassName: _propTypes.default.string
	};
	
	var ModalDialog =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(ModalDialog, _React$Component);
	
	  function ModalDialog() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = ModalDialog.prototype;
	
	  _proto.render = function render() {
	    var _extends2;
	
	    var _this$props = this.props,
	        dialogClassName = _this$props.dialogClassName,
	        className = _this$props.className,
	        style = _this$props.style,
	        children = _this$props.children,
	        onMouseDownDialog = _this$props.onMouseDownDialog,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["dialogClassName", "className", "style", "children", "onMouseDownDialog"]);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var bsClassName = (0, _bootstrapUtils.prefix)(bsProps);
	    var modalStyle = (0, _extends3.default)({
	      display: 'block'
	    }, style);
	    var dialogClasses = (0, _extends3.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[bsClassName] = false, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'dialog')] = true, _extends2));
	    return _react.default.createElement("div", (0, _extends3.default)({}, elementProps, {
	      tabIndex: "-1",
	      role: "dialog",
	      style: modalStyle,
	      className: (0, _classnames.default)(className, bsClassName)
	    }), _react.default.createElement("div", {
	      className: (0, _classnames.default)(dialogClassName, dialogClasses),
	      onMouseDown: onMouseDownDialog
	    }, _react.default.createElement("div", {
	      className: (0, _bootstrapUtils.prefix)(bsProps, 'content'),
	      role: "document"
	    }, children)));
	  };
	
	  return ModalDialog;
	}(_react.default.Component);
	
	ModalDialog.propTypes = propTypes;
	
	var _default = (0, _bootstrapUtils.bsClass)('modal', (0, _bootstrapUtils.bsSizes)([_StyleConfig.Size.LARGE, _StyleConfig.Size.SMALL], ModalDialog));
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 507 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(8));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _elementType = _interopRequireDefault(__webpack_require__(32));
	
	var _bootstrapUtils = __webpack_require__(16);
	
	var propTypes = {
	  componentClass: _elementType.default
	};
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var ModalFooter =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(ModalFooter, _React$Component);
	
	  function ModalFooter() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = ModalFooter.prototype;
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        Component = _this$props.componentClass,
	        className = _this$props.className,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["componentClass", "className"]);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	    return _react.default.createElement(Component, (0, _extends2.default)({}, elementProps, {
	      className: (0, _classnames.default)(className, classes)
	    }));
	  };
	
	  return ModalFooter;
	}(_react.default.Component);
	
	ModalFooter.propTypes = propTypes;
	ModalFooter.defaultProps = defaultProps;
	
	var _default = (0, _bootstrapUtils.bsClass)('modal-footer', ModalFooter);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 508 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(8));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _bootstrapUtils = __webpack_require__(16);
	
	var _createChainedFunction = _interopRequireDefault(__webpack_require__(45));
	
	var _CloseButton = _interopRequireDefault(__webpack_require__(306));
	
	// TODO: `aria-label` should be `closeLabel`.
	var propTypes = {
	  /**
	   * Provides an accessible label for the close
	   * button. It is used for Assistive Technology when the label text is not
	   * readable.
	   */
	  closeLabel: _propTypes.default.string,
	
	  /**
	   * Specify whether the Component should contain a close button
	   */
	  closeButton: _propTypes.default.bool,
	
	  /**
	   * A Callback fired when the close button is clicked. If used directly inside
	   * a Modal component, the onHide will automatically be propagated up to the
	   * parent Modal `onHide`.
	   */
	  onHide: _propTypes.default.func
	};
	var defaultProps = {
	  closeLabel: 'Close',
	  closeButton: false
	};
	var contextTypes = {
	  $bs_modal: _propTypes.default.shape({
	    onHide: _propTypes.default.func
	  })
	};
	
	var ModalHeader =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(ModalHeader, _React$Component);
	
	  function ModalHeader() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = ModalHeader.prototype;
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        closeLabel = _this$props.closeLabel,
	        closeButton = _this$props.closeButton,
	        onHide = _this$props.onHide,
	        className = _this$props.className,
	        children = _this$props.children,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["closeLabel", "closeButton", "onHide", "className", "children"]);
	    var modal = this.context.$bs_modal;
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	    return _react.default.createElement("div", (0, _extends2.default)({}, elementProps, {
	      className: (0, _classnames.default)(className, classes)
	    }), closeButton && _react.default.createElement(_CloseButton.default, {
	      label: closeLabel,
	      onClick: (0, _createChainedFunction.default)(modal && modal.onHide, onHide)
	    }), children);
	  };
	
	  return ModalHeader;
	}(_react.default.Component);
	
	ModalHeader.propTypes = propTypes;
	ModalHeader.defaultProps = defaultProps;
	ModalHeader.contextTypes = contextTypes;
	
	var _default = (0, _bootstrapUtils.bsClass)('modal-header', ModalHeader);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 509 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(8));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _elementType = _interopRequireDefault(__webpack_require__(32));
	
	var _bootstrapUtils = __webpack_require__(16);
	
	var propTypes = {
	  componentClass: _elementType.default
	};
	var defaultProps = {
	  componentClass: 'h4'
	};
	
	var ModalTitle =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(ModalTitle, _React$Component);
	
	  function ModalTitle() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = ModalTitle.prototype;
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        Component = _this$props.componentClass,
	        className = _this$props.className,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["componentClass", "className"]);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	    return _react.default.createElement(Component, (0, _extends2.default)({}, elementProps, {
	      className: (0, _classnames.default)(className, classes)
	    }));
	  };
	
	  return ModalTitle;
	}(_react.default.Component);
	
	ModalTitle.propTypes = propTypes;
	ModalTitle.defaultProps = defaultProps;
	
	var _default = (0, _bootstrapUtils.bsClass)('modal-title', ModalTitle);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 510 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(47);
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends3 = _interopRequireDefault(__webpack_require__(8));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _keycode = _interopRequireDefault(__webpack_require__(294));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(46));
	
	var _all = _interopRequireDefault(__webpack_require__(212));
	
	var _warning = _interopRequireDefault(__webpack_require__(59));
	
	var _bootstrapUtils = __webpack_require__(16);
	
	var _createChainedFunction = _interopRequireDefault(__webpack_require__(45));
	
	var _ValidComponentChildren = _interopRequireDefault(__webpack_require__(58));
	
	// TODO: Should we expose `<NavItem>` as `<Nav.Item>`?
	// TODO: This `bsStyle` is very unlike the others. Should we rename it?
	// TODO: `pullRight` and `pullLeft` don't render right outside of `navbar`.
	// Consider renaming or replacing them.
	var propTypes = {
	  /**
	   * Marks the NavItem with a matching `eventKey` as active. Has a
	   * higher precedence over `activeHref`.
	   */
	  activeKey: _propTypes.default.any,
	
	  /**
	   * Marks the child NavItem with a matching `href` prop as active.
	   */
	  activeHref: _propTypes.default.string,
	
	  /**
	   * NavItems are be positioned vertically.
	   */
	  stacked: _propTypes.default.bool,
	  justified: (0, _all.default)(_propTypes.default.bool, function (_ref) {
	    var justified = _ref.justified,
	        navbar = _ref.navbar;
	    return justified && navbar ? Error('justified navbar `Nav`s are not supported') : null;
	  }),
	
	  /**
	   * A callback fired when a NavItem is selected.
	   *
	   * ```js
	   * function (
	   *  Any eventKey,
	   *  SyntheticEvent event?
	   * )
	   * ```
	   */
	  onSelect: _propTypes.default.func,
	
	  /**
	   * ARIA role for the Nav, in the context of a TabContainer, the default will
	   * be set to "tablist", but can be overridden by the Nav when set explicitly.
	   *
	   * When the role is set to "tablist" NavItem focus is managed according to
	   * the ARIA authoring practices for tabs:
	   * https://www.w3.org/TR/2013/WD-wai-aria-practices-20130307/#tabpanel
	   */
	  role: _propTypes.default.string,
	
	  /**
	   * Apply styling an alignment for use in a Navbar. This prop will be set
	   * automatically when the Nav is used inside a Navbar.
	   */
	  navbar: _propTypes.default.bool,
	
	  /**
	   * Float the Nav to the right. When `navbar` is `true` the appropriate
	   * contextual classes are added as well.
	   */
	  pullRight: _propTypes.default.bool,
	
	  /**
	   * Float the Nav to the left. When `navbar` is `true` the appropriate
	   * contextual classes are added as well.
	   */
	  pullLeft: _propTypes.default.bool
	};
	var defaultProps = {
	  justified: false,
	  pullRight: false,
	  pullLeft: false,
	  stacked: false
	};
	var contextTypes = {
	  $bs_navbar: _propTypes.default.shape({
	    bsClass: _propTypes.default.string,
	    onSelect: _propTypes.default.func
	  }),
	  $bs_tabContainer: _propTypes.default.shape({
	    activeKey: _propTypes.default.any,
	    onSelect: _propTypes.default.func.isRequired,
	    getTabId: _propTypes.default.func.isRequired,
	    getPaneId: _propTypes.default.func.isRequired
	  })
	};
	
	var Nav =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(Nav, _React$Component);
	
	  function Nav() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = Nav.prototype;
	
	  _proto.componentDidUpdate = function componentDidUpdate() {
	    var _this = this;
	
	    if (!this._needsRefocus) {
	      return;
	    }
	
	    this._needsRefocus = false;
	    var children = this.props.children;
	
	    var _this$getActiveProps = this.getActiveProps(),
	        activeKey = _this$getActiveProps.activeKey,
	        activeHref = _this$getActiveProps.activeHref;
	
	    var activeChild = _ValidComponentChildren.default.find(children, function (child) {
	      return _this.isActive(child, activeKey, activeHref);
	    });
	
	    var childrenArray = _ValidComponentChildren.default.toArray(children);
	
	    var activeChildIndex = childrenArray.indexOf(activeChild);
	
	    var childNodes = _reactDom.default.findDOMNode(this).children;
	
	    var activeNode = childNodes && childNodes[activeChildIndex];
	
	    if (!activeNode || !activeNode.firstChild) {
	      return;
	    }
	
	    activeNode.firstChild.focus();
	  };
	
	  _proto.getActiveProps = function getActiveProps() {
	    var tabContainer = this.context.$bs_tabContainer;
	
	    if (tabContainer) {
	       false ? (0, _warning.default)(this.props.activeKey == null && !this.props.activeHref, 'Specifying a `<Nav>` `activeKey` or `activeHref` in the context of ' + 'a `<TabContainer>` is not supported. Instead use `<TabContainer ' + ("activeKey={" + this.props.activeKey + "} />`.")) : void 0;
	      return tabContainer;
	    }
	
	    return this.props;
	  };
	
	  _proto.getNextActiveChild = function getNextActiveChild(offset) {
	    var _this2 = this;
	
	    var children = this.props.children;
	
	    var validChildren = _ValidComponentChildren.default.filter(children, function (child) {
	      return child.props.eventKey != null && !child.props.disabled;
	    });
	
	    var _this$getActiveProps2 = this.getActiveProps(),
	        activeKey = _this$getActiveProps2.activeKey,
	        activeHref = _this$getActiveProps2.activeHref;
	
	    var activeChild = _ValidComponentChildren.default.find(children, function (child) {
	      return _this2.isActive(child, activeKey, activeHref);
	    }); // This assumes the active child is not disabled.
	
	
	    var activeChildIndex = validChildren.indexOf(activeChild);
	
	    if (activeChildIndex === -1) {
	      // Something has gone wrong. Select the first valid child we can find.
	      return validChildren[0];
	    }
	
	    var nextIndex = activeChildIndex + offset;
	    var numValidChildren = validChildren.length;
	
	    if (nextIndex >= numValidChildren) {
	      nextIndex = 0;
	    } else if (nextIndex < 0) {
	      nextIndex = numValidChildren - 1;
	    }
	
	    return validChildren[nextIndex];
	  };
	
	  _proto.getTabProps = function getTabProps(child, tabContainer, navRole, active, onSelect) {
	    var _this3 = this;
	
	    if (!tabContainer && navRole !== 'tablist') {
	      // No tab props here.
	      return null;
	    }
	
	    var _child$props = child.props,
	        id = _child$props.id,
	        controls = _child$props['aria-controls'],
	        eventKey = _child$props.eventKey,
	        role = _child$props.role,
	        onKeyDown = _child$props.onKeyDown,
	        tabIndex = _child$props.tabIndex;
	
	    if (tabContainer) {
	       false ? (0, _warning.default)(!id && !controls, 'In the context of a `<TabContainer>`, `<NavItem>`s are given ' + 'generated `id` and `aria-controls` attributes for the sake of ' + 'proper component accessibility. Any provided ones will be ignored. ' + 'To control these attributes directly, provide a `generateChildId` ' + 'prop to the parent `<TabContainer>`.') : void 0;
	      id = tabContainer.getTabId(eventKey);
	      controls = tabContainer.getPaneId(eventKey);
	    }
	
	    if (navRole === 'tablist') {
	      role = role || 'tab';
	      onKeyDown = (0, _createChainedFunction.default)(function (event) {
	        return _this3.handleTabKeyDown(onSelect, event);
	      }, onKeyDown);
	      tabIndex = active ? tabIndex : -1;
	    }
	
	    return {
	      id: id,
	      role: role,
	      onKeyDown: onKeyDown,
	      'aria-controls': controls,
	      tabIndex: tabIndex
	    };
	  };
	
	  _proto.handleTabKeyDown = function handleTabKeyDown(onSelect, event) {
	    var nextActiveChild;
	
	    switch (event.keyCode) {
	      case _keycode.default.codes.left:
	      case _keycode.default.codes.up:
	        nextActiveChild = this.getNextActiveChild(-1);
	        break;
	
	      case _keycode.default.codes.right:
	      case _keycode.default.codes.down:
	        nextActiveChild = this.getNextActiveChild(1);
	        break;
	
	      default:
	        // It was a different key; don't handle this keypress.
	        return;
	    }
	
	    event.preventDefault();
	
	    if (onSelect && nextActiveChild && nextActiveChild.props.eventKey != null) {
	      onSelect(nextActiveChild.props.eventKey);
	    }
	
	    this._needsRefocus = true;
	  };
	
	  _proto.isActive = function isActive(_ref2, activeKey, activeHref) {
	    var props = _ref2.props;
	
	    if (props.active || activeKey != null && props.eventKey === activeKey || activeHref && props.href === activeHref) {
	      return true;
	    }
	
	    return props.active;
	  };
	
	  _proto.render = function render() {
	    var _extends2,
	        _this4 = this;
	
	    var _this$props = this.props,
	        stacked = _this$props.stacked,
	        justified = _this$props.justified,
	        onSelect = _this$props.onSelect,
	        propsRole = _this$props.role,
	        propsNavbar = _this$props.navbar,
	        pullRight = _this$props.pullRight,
	        pullLeft = _this$props.pullLeft,
	        className = _this$props.className,
	        children = _this$props.children,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["stacked", "justified", "onSelect", "role", "navbar", "pullRight", "pullLeft", "className", "children"]);
	    var tabContainer = this.context.$bs_tabContainer;
	    var role = propsRole || (tabContainer ? 'tablist' : null);
	
	    var _this$getActiveProps3 = this.getActiveProps(),
	        activeKey = _this$getActiveProps3.activeKey,
	        activeHref = _this$getActiveProps3.activeHref;
	
	    delete props.activeKey; // Accessed via this.getActiveProps().
	
	    delete props.activeHref; // Accessed via this.getActiveProps().
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends3.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'stacked')] = stacked, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'justified')] = justified, _extends2));
	    var navbar = propsNavbar != null ? propsNavbar : this.context.$bs_navbar;
	    var pullLeftClassName;
	    var pullRightClassName;
	
	    if (navbar) {
	      var navbarProps = this.context.$bs_navbar || {
	        bsClass: 'navbar'
	      };
	      classes[(0, _bootstrapUtils.prefix)(navbarProps, 'nav')] = true;
	      pullRightClassName = (0, _bootstrapUtils.prefix)(navbarProps, 'right');
	      pullLeftClassName = (0, _bootstrapUtils.prefix)(navbarProps, 'left');
	    } else {
	      pullRightClassName = 'pull-right';
	      pullLeftClassName = 'pull-left';
	    }
	
	    classes[pullRightClassName] = pullRight;
	    classes[pullLeftClassName] = pullLeft;
	    return _react.default.createElement("ul", (0, _extends3.default)({}, elementProps, {
	      role: role,
	      className: (0, _classnames.default)(className, classes)
	    }), _ValidComponentChildren.default.map(children, function (child) {
	      var active = _this4.isActive(child, activeKey, activeHref);
	
	      var childOnSelect = (0, _createChainedFunction.default)(child.props.onSelect, onSelect, navbar && navbar.onSelect, tabContainer && tabContainer.onSelect);
	      return (0, _react.cloneElement)(child, (0, _extends3.default)({}, _this4.getTabProps(child, tabContainer, role, active, childOnSelect), {
	        active: active,
	        activeKey: activeKey,
	        activeHref: activeHref,
	        onSelect: childOnSelect
	      }));
	    }));
	  };
	
	  return Nav;
	}(_react.default.Component);
	
	Nav.propTypes = propTypes;
	Nav.defaultProps = defaultProps;
	Nav.contextTypes = contextTypes;
	
	var _default = (0, _bootstrapUtils.bsClass)('nav', (0, _bootstrapUtils.bsStyles)(['tabs', 'pills'], Nav));
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 511 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(8));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(57));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _SafeAnchor = _interopRequireDefault(__webpack_require__(73));
	
	var _createChainedFunction = _interopRequireDefault(__webpack_require__(45));
	
	var propTypes = {
	  active: _propTypes.default.bool,
	  disabled: _propTypes.default.bool,
	  role: _propTypes.default.string,
	  href: _propTypes.default.string,
	  onClick: _propTypes.default.func,
	  onSelect: _propTypes.default.func,
	  eventKey: _propTypes.default.any
	};
	var defaultProps = {
	  active: false,
	  disabled: false
	};
	
	var NavItem =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(NavItem, _React$Component);
	
	  function NavItem(props, context) {
	    var _this;
	
	    _this = _React$Component.call(this, props, context) || this;
	    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
	    return _this;
	  }
	
	  var _proto = NavItem.prototype;
	
	  _proto.handleClick = function handleClick(e) {
	    if (this.props.disabled) {
	      e.preventDefault();
	      return;
	    }
	
	    if (this.props.onSelect) {
	      this.props.onSelect(this.props.eventKey, e);
	    }
	  };
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        active = _this$props.active,
	        disabled = _this$props.disabled,
	        onClick = _this$props.onClick,
	        className = _this$props.className,
	        style = _this$props.style,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["active", "disabled", "onClick", "className", "style"]);
	    delete props.onSelect;
	    delete props.eventKey; // These are injected down by `<Nav>` for building `<SubNav>`s.
	
	    delete props.activeKey;
	    delete props.activeHref;
	
	    if (!props.role) {
	      if (props.href === '#') {
	        props.role = 'button';
	      }
	    } else if (props.role === 'tab') {
	      props['aria-selected'] = active;
	    }
	
	    return _react.default.createElement("li", {
	      role: "presentation",
	      className: (0, _classnames.default)(className, {
	        active: active,
	        disabled: disabled
	      }),
	      style: style
	    }, _react.default.createElement(_SafeAnchor.default, (0, _extends2.default)({}, props, {
	      disabled: disabled,
	      onClick: (0, _createChainedFunction.default)(onClick, this.handleClick)
	    })));
	  };
	
	  return NavItem;
	}(_react.default.Component);
	
	NavItem.propTypes = propTypes;
	NavItem.defaultProps = defaultProps;
	var _default = NavItem;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 512 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(8));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _bootstrapUtils = __webpack_require__(16);
	
	var contextTypes = {
	  $bs_navbar: _propTypes.default.shape({
	    bsClass: _propTypes.default.string
	  })
	};
	
	var NavbarBrand =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(NavbarBrand, _React$Component);
	
	  function NavbarBrand() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = NavbarBrand.prototype;
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        className = _this$props.className,
	        children = _this$props.children,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["className", "children"]);
	    var navbarProps = this.context.$bs_navbar || {
	      bsClass: 'navbar'
	    };
	    var bsClassName = (0, _bootstrapUtils.prefix)(navbarProps, 'brand');
	
	    if (_react.default.isValidElement(children)) {
	      return _react.default.cloneElement(children, {
	        className: (0, _classnames.default)(children.props.className, className, bsClassName)
	      });
	    }
	
	    return _react.default.createElement("span", (0, _extends2.default)({}, props, {
	      className: (0, _classnames.default)(className, bsClassName)
	    }), children);
	  };
	
	  return NavbarBrand;
	}(_react.default.Component);
	
	NavbarBrand.contextTypes = contextTypes;
	var _default = NavbarBrand;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 513 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(47);
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(8));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _Overlay = _interopRequireDefault(__webpack_require__(1858));
	
	var _elementType = _interopRequireDefault(__webpack_require__(32));
	
	var _Fade = _interopRequireDefault(__webpack_require__(217));
	
	var propTypes = (0, _extends2.default)({}, _Overlay.default.propTypes, {
	  /**
	   * Set the visibility of the Overlay
	   */
	  show: _propTypes.default.bool,
	
	  /**
	   * Specify whether the overlay should trigger onHide when the user clicks outside the overlay
	   */
	  rootClose: _propTypes.default.bool,
	
	  /**
	   * A callback invoked by the overlay when it wishes to be hidden. Required if
	   * `rootClose` is specified.
	   */
	  onHide: _propTypes.default.func,
	
	  /**
	   * Use animation
	   */
	  animation: _propTypes.default.oneOfType([_propTypes.default.bool, _elementType.default]),
	
	  /**
	   * Callback fired before the Overlay transitions in
	   */
	  onEnter: _propTypes.default.func,
	
	  /**
	   * Callback fired as the Overlay begins to transition in
	   */
	  onEntering: _propTypes.default.func,
	
	  /**
	   * Callback fired after the Overlay finishes transitioning in
	   */
	  onEntered: _propTypes.default.func,
	
	  /**
	   * Callback fired right before the Overlay transitions out
	   */
	  onExit: _propTypes.default.func,
	
	  /**
	   * Callback fired as the Overlay begins to transition out
	   */
	  onExiting: _propTypes.default.func,
	
	  /**
	   * Callback fired after the Overlay finishes transitioning out
	   */
	  onExited: _propTypes.default.func,
	
	  /**
	   * Sets the direction of the Overlay.
	   */
	  placement: _propTypes.default.oneOf(['top', 'right', 'bottom', 'left'])
	});
	var defaultProps = {
	  animation: _Fade.default,
	  rootClose: false,
	  show: false,
	  placement: 'right'
	};
	
	var Overlay =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(Overlay, _React$Component);
	
	  function Overlay() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = Overlay.prototype;
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        animation = _this$props.animation,
	        children = _this$props.children,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["animation", "children"]);
	    var transition = animation === true ? _Fade.default : animation || null;
	    var child;
	
	    if (!transition) {
	      child = (0, _react.cloneElement)(children, {
	        className: (0, _classnames.default)(children.props.className, 'in')
	      });
	    } else {
	      child = children;
	    }
	
	    return _react.default.createElement(_Overlay.default, (0, _extends2.default)({}, props, {
	      transition: transition
	    }), child);
	  };
	
	  return Overlay;
	}(_react.default.Component);
	
	Overlay.propTypes = propTypes;
	Overlay.defaultProps = defaultProps;
	var _default = Overlay;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 514 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(8));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(57));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _SafeAnchor = _interopRequireDefault(__webpack_require__(73));
	
	var _createChainedFunction = _interopRequireDefault(__webpack_require__(45));
	
	var propTypes = {
	  disabled: _propTypes.default.bool,
	  previous: _propTypes.default.bool,
	  next: _propTypes.default.bool,
	  onClick: _propTypes.default.func,
	  onSelect: _propTypes.default.func,
	  eventKey: _propTypes.default.any
	};
	var defaultProps = {
	  disabled: false,
	  previous: false,
	  next: false
	};
	
	var PagerItem =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(PagerItem, _React$Component);
	
	  function PagerItem(props, context) {
	    var _this;
	
	    _this = _React$Component.call(this, props, context) || this;
	    _this.handleSelect = _this.handleSelect.bind((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
	    return _this;
	  }
	
	  var _proto = PagerItem.prototype;
	
	  _proto.handleSelect = function handleSelect(e) {
	    var _this$props = this.props,
	        disabled = _this$props.disabled,
	        onSelect = _this$props.onSelect,
	        eventKey = _this$props.eventKey;
	
	    if (disabled) {
	      e.preventDefault();
	      return;
	    }
	
	    if (onSelect) {
	      onSelect(eventKey, e);
	    }
	  };
	
	  _proto.render = function render() {
	    var _this$props2 = this.props,
	        disabled = _this$props2.disabled,
	        previous = _this$props2.previous,
	        next = _this$props2.next,
	        onClick = _this$props2.onClick,
	        className = _this$props2.className,
	        style = _this$props2.style,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props2, ["disabled", "previous", "next", "onClick", "className", "style"]);
	    delete props.onSelect;
	    delete props.eventKey;
	    return _react.default.createElement("li", {
	      className: (0, _classnames.default)(className, {
	        disabled: disabled,
	        previous: previous,
	        next: next
	      }),
	      style: style
	    }, _react.default.createElement(_SafeAnchor.default, (0, _extends2.default)({}, props, {
	      disabled: disabled,
	      onClick: (0, _createChainedFunction.default)(onClick, this.handleSelect)
	    })));
	  };
	
	  return PagerItem;
	}(_react.default.Component);
	
	PagerItem.propTypes = propTypes;
	PagerItem.defaultProps = defaultProps;
	var _default = PagerItem;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 515 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(8));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _bootstrapUtils = __webpack_require__(16);
	
	var _Collapse = _interopRequireDefault(__webpack_require__(307));
	
	var propTypes = {
	  /**
	   * Callback fired before the component expands
	   */
	  onEnter: _propTypes.default.func,
	
	  /**
	   * Callback fired after the component starts to expand
	   */
	  onEntering: _propTypes.default.func,
	
	  /**
	   * Callback fired after the component has expanded
	   */
	  onEntered: _propTypes.default.func,
	
	  /**
	   * Callback fired before the component collapses
	   */
	  onExit: _propTypes.default.func,
	
	  /**
	   * Callback fired after the component starts to collapse
	   */
	  onExiting: _propTypes.default.func,
	
	  /**
	   * Callback fired after the component has collapsed
	   */
	  onExited: _propTypes.default.func
	};
	var contextTypes = {
	  $bs_panel: _propTypes.default.shape({
	    headingId: _propTypes.default.string,
	    bodyId: _propTypes.default.string,
	    bsClass: _propTypes.default.string,
	    expanded: _propTypes.default.bool
	  })
	};
	
	var PanelCollapse =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(PanelCollapse, _React$Component);
	
	  function PanelCollapse() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = PanelCollapse.prototype;
	
	  _proto.render = function render() {
	    var children = this.props.children;
	
	    var _ref = this.context.$bs_panel || {},
	        headingId = _ref.headingId,
	        bodyId = _ref.bodyId,
	        _bsClass = _ref.bsClass,
	        expanded = _ref.expanded;
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(this.props),
	        bsProps = _splitBsProps[0],
	        props = _splitBsProps[1];
	
	    bsProps.bsClass = _bsClass || bsProps.bsClass;
	
	    if (headingId && bodyId) {
	      props.id = bodyId;
	      props.role = props.role || 'tabpanel';
	      props['aria-labelledby'] = headingId;
	    }
	
	    return _react.default.createElement(_Collapse.default, (0, _extends2.default)({
	      in: expanded
	    }, props), _react.default.createElement("div", {
	      className: (0, _bootstrapUtils.prefix)(bsProps, 'collapse')
	    }, children));
	  };
	
	  return PanelCollapse;
	}(_react.default.Component);
	
	PanelCollapse.propTypes = propTypes;
	PanelCollapse.contextTypes = contextTypes;
	
	var _default = (0, _bootstrapUtils.bsClass)('panel', PanelCollapse);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 516 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(47);
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(8));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _uncontrollable = __webpack_require__(119);
	
	var _bootstrapUtils = __webpack_require__(16);
	
	var _ValidComponentChildren = _interopRequireDefault(__webpack_require__(58));
	
	var _PropTypes = __webpack_require__(520);
	
	var propTypes = {
	  accordion: _propTypes.default.bool,
	
	  /**
	   * When `accordion` is enabled, `activeKey` controls the which child `Panel` is expanded. `activeKey` should
	   * match a child Panel `eventKey` prop exactly.
	   *
	   * @controllable onSelect
	   */
	  activeKey: _propTypes.default.any,
	
	  /**
	   * A callback fired when a child Panel collapse state changes. It's called with the next expanded `activeKey`
	   *
	   * @controllable activeKey
	   */
	  onSelect: _propTypes.default.func,
	
	  /**
	   * An HTML role attribute
	   */
	  role: _propTypes.default.string,
	
	  /**
	   * A function that takes an eventKey and type and returns a
	   * unique id for each Panel heading and Panel Collapse. The function _must_ be a pure function,
	   * meaning it should always return the _same_ id for the same set of inputs. The default
	   * value requires that an `id` to be set for the PanelGroup.
	   *
	   * The `type` argument will either be `"body"` or `"heading"`.
	   *
	   * @defaultValue (eventKey, type) => `${this.props.id}-${type}-${key}`
	   */
	  generateChildId: _propTypes.default.func,
	
	  /**
	   * HTML id attribute, required if no `generateChildId` prop
	   * is specified.
	   */
	  id: (0, _PropTypes.generatedId)('PanelGroup')
	};
	var defaultProps = {
	  accordion: false
	};
	var childContextTypes = {
	  $bs_panelGroup: _propTypes.default.shape({
	    getId: _propTypes.default.func,
	    headerRole: _propTypes.default.string,
	    panelRole: _propTypes.default.string,
	    activeKey: _propTypes.default.any,
	    onToggle: _propTypes.default.func
	  })
	};
	
	var PanelGroup =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(PanelGroup, _React$Component);
	
	  function PanelGroup() {
	    var _this;
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
	
	    _this.handleSelect = function (key, expanded, e) {
	      if (expanded) {
	        _this.props.onSelect(key, e);
	      } else if (_this.props.activeKey === key) {
	        _this.props.onSelect(null, e);
	      }
	    };
	
	    return _this;
	  }
	
	  var _proto = PanelGroup.prototype;
	
	  _proto.getChildContext = function getChildContext() {
	    var _this$props = this.props,
	        activeKey = _this$props.activeKey,
	        accordion = _this$props.accordion,
	        generateChildId = _this$props.generateChildId,
	        id = _this$props.id;
	    var getId = null;
	
	    if (accordion) {
	      getId = generateChildId || function (key, type) {
	        return id ? id + "-" + type + "-" + key : null;
	      };
	    }
	
	    return {
	      $bs_panelGroup: (0, _extends2.default)({
	        getId: getId,
	        headerRole: 'tab',
	        panelRole: 'tabpanel'
	      }, accordion && {
	        activeKey: activeKey,
	        onToggle: this.handleSelect
	      })
	    };
	  };
	
	  _proto.render = function render() {
	    var _this$props2 = this.props,
	        accordion = _this$props2.accordion,
	        className = _this$props2.className,
	        children = _this$props2.children,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props2, ["accordion", "className", "children"]);
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['onSelect', 'activeKey']),
	        bsProps = _splitBsPropsAndOmit[0],
	        elementProps = _splitBsPropsAndOmit[1];
	
	    if (accordion) {
	      elementProps.role = elementProps.role || 'tablist';
	    }
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	    return _react.default.createElement("div", (0, _extends2.default)({}, elementProps, {
	      className: (0, _classnames.default)(className, classes)
	    }), _ValidComponentChildren.default.map(children, function (child) {
	      return (0, _react.cloneElement)(child, {
	        bsStyle: child.props.bsStyle || bsProps.bsStyle
	      });
	    }));
	  };
	
	  return PanelGroup;
	}(_react.default.Component);
	
	PanelGroup.propTypes = propTypes;
	PanelGroup.defaultProps = defaultProps;
	PanelGroup.childContextTypes = childContextTypes;
	
	var _default = (0, _uncontrollable.uncontrollable)((0, _bootstrapUtils.bsClass)('panel-group', PanelGroup), {
	  activeKey: 'onSelect'
	});
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 517 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(57));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _elementType = _interopRequireDefault(__webpack_require__(312));
	
	var _SafeAnchor = _interopRequireDefault(__webpack_require__(73));
	
	var _createChainedFunction = _interopRequireDefault(__webpack_require__(45));
	
	var propTypes = {
	  /**
	   * only here to satisfy linting, just the html onClick handler.
	   *
	   * @private
	   */
	  onClick: _propTypes.default.func,
	
	  /**
	   * You can use a custom element for this component
	   */
	  componentClass: _elementType.default
	};
	var defaultProps = {
	  componentClass: _SafeAnchor.default
	};
	var contextTypes = {
	  $bs_panel: _propTypes.default.shape({
	    bodyId: _propTypes.default.string,
	    onToggle: _propTypes.default.func,
	    expanded: _propTypes.default.bool
	  })
	};
	
	var PanelToggle =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(PanelToggle, _React$Component);
	
	  function PanelToggle() {
	    var _this;
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
	    _this.handleToggle = _this.handleToggle.bind((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
	    return _this;
	  }
	
	  var _proto = PanelToggle.prototype;
	
	  _proto.handleToggle = function handleToggle(event) {
	    var _ref = this.context.$bs_panel || {},
	        onToggle = _ref.onToggle;
	
	    if (onToggle) {
	      onToggle(event);
	    }
	  };
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        onClick = _this$props.onClick,
	        className = _this$props.className,
	        componentClass = _this$props.componentClass,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["onClick", "className", "componentClass"]);
	
	    var _ref2 = this.context.$bs_panel || {},
	        expanded = _ref2.expanded,
	        bodyId = _ref2.bodyId;
	
	    var Component = componentClass;
	    props.onClick = (0, _createChainedFunction.default)(onClick, this.handleToggle);
	    props['aria-expanded'] = expanded;
	    props.className = (0, _classnames.default)(className, !expanded && 'collapsed');
	
	    if (bodyId) {
	      props['aria-controls'] = bodyId;
	    }
	
	    return _react.default.createElement(Component, props);
	  };
	
	  return PanelToggle;
	}(_react.default.Component);
	
	PanelToggle.propTypes = propTypes;
	PanelToggle.defaultProps = defaultProps;
	PanelToggle.contextTypes = contextTypes;
	var _default = PanelToggle;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 518 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(8));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(57));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _elementType = _interopRequireDefault(__webpack_require__(32));
	
	var _warning = _interopRequireDefault(__webpack_require__(59));
	
	var _bootstrapUtils = __webpack_require__(16);
	
	var _createChainedFunction = _interopRequireDefault(__webpack_require__(45));
	
	var _Fade = _interopRequireDefault(__webpack_require__(217));
	
	var propTypes = {
	  /**
	   * Uniquely identify the `<TabPane>` among its siblings.
	   */
	  eventKey: _propTypes.default.any,
	
	  /**
	   * Use animation when showing or hiding `<TabPane>`s. Use `false` to disable,
	   * `true` to enable the default `<Fade>` animation or
	   * a react-transition-group v2 `<Transition/>` component.
	   */
	  animation: _propTypes.default.oneOfType([_propTypes.default.bool, _elementType.default]),
	
	  /** @private * */
	  id: _propTypes.default.string,
	
	  /** @private * */
	  'aria-labelledby': _propTypes.default.string,
	
	  /**
	   * If not explicitly specified and rendered in the context of a
	   * `<TabContent>`, the `bsClass` of the `<TabContent>` suffixed by `-pane`.
	   * If otherwise not explicitly specified, `tab-pane`.
	   */
	  bsClass: _propTypes.default.string,
	
	  /**
	   * Transition onEnter callback when animation is not `false`
	   */
	  onEnter: _propTypes.default.func,
	
	  /**
	   * Transition onEntering callback when animation is not `false`
	   */
	  onEntering: _propTypes.default.func,
	
	  /**
	   * Transition onEntered callback when animation is not `false`
	   */
	  onEntered: _propTypes.default.func,
	
	  /**
	   * Transition onExit callback when animation is not `false`
	   */
	  onExit: _propTypes.default.func,
	
	  /**
	   * Transition onExiting callback when animation is not `false`
	   */
	  onExiting: _propTypes.default.func,
	
	  /**
	   * Transition onExited callback when animation is not `false`
	   */
	  onExited: _propTypes.default.func,
	
	  /**
	   * Wait until the first "enter" transition to mount the tab (add it to the DOM)
	   */
	  mountOnEnter: _propTypes.default.bool,
	
	  /**
	   * Unmount the tab (remove it from the DOM) when it is no longer visible
	   */
	  unmountOnExit: _propTypes.default.bool
	};
	var contextTypes = {
	  $bs_tabContainer: _propTypes.default.shape({
	    getTabId: _propTypes.default.func,
	    getPaneId: _propTypes.default.func
	  }),
	  $bs_tabContent: _propTypes.default.shape({
	    bsClass: _propTypes.default.string,
	    animation: _propTypes.default.oneOfType([_propTypes.default.bool, _elementType.default]),
	    activeKey: _propTypes.default.any,
	    mountOnEnter: _propTypes.default.bool,
	    unmountOnExit: _propTypes.default.bool,
	    onPaneEnter: _propTypes.default.func.isRequired,
	    onPaneExited: _propTypes.default.func.isRequired,
	    exiting: _propTypes.default.bool.isRequired
	  })
	};
	/**
	 * We override the `<TabContainer>` context so `<Nav>`s in `<TabPane>`s don't
	 * conflict with the top level one.
	 */
	
	var childContextTypes = {
	  $bs_tabContainer: _propTypes.default.oneOf([null])
	};
	
	var TabPane =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(TabPane, _React$Component);
	
	  function TabPane(props, context) {
	    var _this;
	
	    _this = _React$Component.call(this, props, context) || this;
	    _this.handleEnter = _this.handleEnter.bind((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
	    _this.handleExited = _this.handleExited.bind((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
	    _this.in = false;
	    return _this;
	  }
	
	  var _proto = TabPane.prototype;
	
	  _proto.getChildContext = function getChildContext() {
	    return {
	      $bs_tabContainer: null
	    };
	  };
	
	  _proto.componentDidMount = function componentDidMount() {
	    if (this.shouldBeIn()) {
	      // In lieu of the action event firing.
	      this.handleEnter();
	    }
	  };
	
	  _proto.componentDidUpdate = function componentDidUpdate() {
	    if (this.in) {
	      if (!this.shouldBeIn()) {
	        // We shouldn't be active any more. Notify the parent.
	        this.handleExited();
	      }
	    } else if (this.shouldBeIn()) {
	      // We are the active child. Notify the parent.
	      this.handleEnter();
	    }
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    if (this.in) {
	      // In lieu of the action event firing.
	      this.handleExited();
	    }
	  };
	
	  _proto.getAnimation = function getAnimation() {
	    if (this.props.animation != null) {
	      return this.props.animation;
	    }
	
	    var tabContent = this.context.$bs_tabContent;
	    return tabContent && tabContent.animation;
	  };
	
	  _proto.handleEnter = function handleEnter() {
	    var tabContent = this.context.$bs_tabContent;
	
	    if (!tabContent) {
	      return;
	    }
	
	    this.in = tabContent.onPaneEnter(this, this.props.eventKey);
	  };
	
	  _proto.handleExited = function handleExited() {
	    var tabContent = this.context.$bs_tabContent;
	
	    if (!tabContent) {
	      return;
	    }
	
	    tabContent.onPaneExited(this);
	    this.in = false;
	  };
	
	  _proto.isActive = function isActive() {
	    var tabContent = this.context.$bs_tabContent;
	    var activeKey = tabContent && tabContent.activeKey;
	    return this.props.eventKey === activeKey;
	  };
	
	  _proto.shouldBeIn = function shouldBeIn() {
	    return this.getAnimation() && this.isActive();
	  };
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        eventKey = _this$props.eventKey,
	        className = _this$props.className,
	        onEnter = _this$props.onEnter,
	        onEntering = _this$props.onEntering,
	        onEntered = _this$props.onEntered,
	        onExit = _this$props.onExit,
	        onExiting = _this$props.onExiting,
	        onExited = _this$props.onExited,
	        propsMountOnEnter = _this$props.mountOnEnter,
	        propsUnmountOnExit = _this$props.unmountOnExit,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["eventKey", "className", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "mountOnEnter", "unmountOnExit"]);
	    var _this$context = this.context,
	        tabContent = _this$context.$bs_tabContent,
	        tabContainer = _this$context.$bs_tabContainer;
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['animation']),
	        bsProps = _splitBsPropsAndOmit[0],
	        elementProps = _splitBsPropsAndOmit[1];
	
	    var active = this.isActive();
	    var animation = this.getAnimation();
	    var mountOnEnter = propsMountOnEnter != null ? propsMountOnEnter : tabContent && tabContent.mountOnEnter;
	    var unmountOnExit = propsUnmountOnExit != null ? propsUnmountOnExit : tabContent && tabContent.unmountOnExit;
	
	    if (!active && !animation && unmountOnExit) {
	      return null;
	    }
	
	    var Transition = animation === true ? _Fade.default : animation || null;
	
	    if (tabContent) {
	      bsProps.bsClass = (0, _bootstrapUtils.prefix)(tabContent, 'pane');
	    }
	
	    var classes = (0, _extends2.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	      active: active
	    });
	
	    if (tabContainer) {
	       false ? (0, _warning.default)(!elementProps.id && !elementProps['aria-labelledby'], 'In the context of a `<TabContainer>`, `<TabPanes>` are given ' + 'generated `id` and `aria-labelledby` attributes for the sake of ' + 'proper component accessibility. Any provided ones will be ignored. ' + 'To control these attributes directly provide a `generateChildId` ' + 'prop to the parent `<TabContainer>`.') : void 0;
	      elementProps.id = tabContainer.getPaneId(eventKey);
	      elementProps['aria-labelledby'] = tabContainer.getTabId(eventKey);
	    }
	
	    var pane = _react.default.createElement("div", (0, _extends2.default)({}, elementProps, {
	      role: "tabpanel",
	      "aria-hidden": !active,
	      className: (0, _classnames.default)(className, classes)
	    }));
	
	    if (Transition) {
	      var exiting = tabContent && tabContent.exiting;
	      return _react.default.createElement(Transition, {
	        in: active && !exiting,
	        onEnter: (0, _createChainedFunction.default)(this.handleEnter, onEnter),
	        onEntering: onEntering,
	        onEntered: onEntered,
	        onExit: onExit,
	        onExiting: onExiting,
	        onExited: (0, _createChainedFunction.default)(this.handleExited, onExited),
	        mountOnEnter: mountOnEnter,
	        unmountOnExit: unmountOnExit
	      }, pane);
	    }
	
	    return pane;
	  };
	
	  return TabPane;
	}(_react.default.Component);
	
	TabPane.propTypes = propTypes;
	TabPane.contextTypes = contextTypes;
	TabPane.childContextTypes = childContextTypes;
	
	var _default = (0, _bootstrapUtils.bsClass)('tab-pane', TabPane);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 519 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(8));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _Button = _interopRequireDefault(__webpack_require__(158));
	
	var propTypes = {
	  /**
	   * The `<input>` `type`
	   * @type {[type]}
	   */
	  type: _propTypes.default.oneOf(['checkbox', 'radio']),
	
	  /**
	   * The HTML input name, used to group like checkboxes or radio buttons together
	   * semantically
	   */
	  name: _propTypes.default.string,
	
	  /**
	   * The checked state of the input, managed by `<ToggleButtonGroup>`` automatically
	   */
	  checked: _propTypes.default.bool,
	
	  /**
	   * The disabled state of both the label and input
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * [onChange description]
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * The value of the input, and unique identifier in the ToggleButtonGroup
	   */
	  value: _propTypes.default.any.isRequired
	};
	
	var ToggleButton =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(ToggleButton, _React$Component);
	
	  function ToggleButton() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = ToggleButton.prototype;
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        children = _this$props.children,
	        name = _this$props.name,
	        checked = _this$props.checked,
	        type = _this$props.type,
	        onChange = _this$props.onChange,
	        value = _this$props.value,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["children", "name", "checked", "type", "onChange", "value"]);
	    var disabled = props.disabled;
	    return _react.default.createElement(_Button.default, (0, _extends2.default)({}, props, {
	      active: !!checked,
	      componentClass: "label"
	    }), _react.default.createElement("input", {
	      name: name,
	      type: type,
	      autoComplete: "off",
	      value: value,
	      checked: !!checked,
	      disabled: !!disabled,
	      onChange: onChange
	    }), children);
	  };
	
	  return ToggleButton;
	}(_react.default.Component);
	
	ToggleButton.propTypes = propTypes;
	var _default = ToggleButton;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 520 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.generatedId = generatedId;
	exports.requiredRoles = requiredRoles;
	exports.exclusiveRoles = exclusiveRoles;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _createChainableTypeChecker = _interopRequireDefault(__webpack_require__(215));
	
	var _ValidComponentChildren = _interopRequireDefault(__webpack_require__(58));
	
	var idPropType = _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]);
	
	function generatedId(name) {
	  return function (props) {
	    var error = null;
	
	    if (!props.generateChildId) {
	      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      error = idPropType.apply(void 0, [props].concat(args));
	
	      if (!error && !props.id) {
	        error = new Error("In order to properly initialize the " + name + " in a way that is accessible to assistive technologies " + ("(such as screen readers) an `id` or a `generateChildId` prop to " + name + " is required"));
	      }
	    }
	
	    return error;
	  };
	}
	
	function requiredRoles() {
	  for (var _len2 = arguments.length, roles = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	    roles[_key2] = arguments[_key2];
	  }
	
	  return (0, _createChainableTypeChecker.default)(function (props, propName, component) {
	    var missing;
	    roles.every(function (role) {
	      if (!_ValidComponentChildren.default.some(props.children, function (child) {
	        return child.props.bsRole === role;
	      })) {
	        missing = role;
	        return false;
	      }
	
	      return true;
	    });
	
	    if (missing) {
	      return new Error("(children) " + component + " - Missing a required child with bsRole: " + (missing + ". " + component + " must have at least one child of each of ") + ("the following bsRoles: " + roles.join(', ')));
	    }
	
	    return null;
	  });
	}
	
	function exclusiveRoles() {
	  for (var _len3 = arguments.length, roles = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	    roles[_key3] = arguments[_key3];
	  }
	
	  return (0, _createChainableTypeChecker.default)(function (props, propName, component) {
	    var duplicate;
	    roles.every(function (role) {
	      var childrenWithRole = _ValidComponentChildren.default.filter(props.children, function (child) {
	        return child.props.bsRole === role;
	      });
	
	      if (childrenWithRole.length > 1) {
	        duplicate = role;
	        return false;
	      }
	
	      return true;
	    });
	
	    if (duplicate) {
	      return new Error("(children) " + component + " - Duplicate children detected of bsRole: " + (duplicate + ". Only one child each allowed with the following ") + ("bsRoles: " + roles.join(', ')));
	    }
	
	    return null;
	  });
	}

/***/ },
/* 521 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = capitalize;
	
	function capitalize(string) {
	  return "" + string.charAt(0).toUpperCase() + string.slice(1);
	}
	
	module.exports = exports["default"];

/***/ },
/* 522 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var _extends = __webpack_require__(35);
	var _objectWithoutPropertiesLoose = __webpack_require__(43);
	var React = __webpack_require__(1);
	var finalForm = __webpack_require__(1629);
	
	function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }
	
	function _interopNamespace(e) {
	  if (e && e.__esModule) return e;
	  var n = Object.create(null);
	  if (e) {
	    Object.keys(e).forEach(function (k) {
	      if (k !== 'default') {
	        var d = Object.getOwnPropertyDescriptor(e, k);
	        Object.defineProperty(n, k, d.get ? d : {
	          enumerable: true,
	          get: function () { return e[k]; }
	        });
	      }
	    });
	  }
	  n["default"] = e;
	  return Object.freeze(n);
	}
	
	var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
	var _objectWithoutPropertiesLoose__default = /*#__PURE__*/_interopDefaultLegacy(_objectWithoutPropertiesLoose);
	var React__namespace = /*#__PURE__*/_interopNamespace(React);
	var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
	
	var _excluded$3 = ["render", "children", "component"];
	// shared logic between components that use either render prop,
	// children render function, or component prop
	function renderComponent(props, lazyProps, name) {
	  var render = props.render,
	      children = props.children,
	      component = props.component,
	      rest = _objectWithoutPropertiesLoose__default["default"](props, _excluded$3);
	
	  if (component) {
	    return /*#__PURE__*/React__namespace.createElement(component, Object.assign(lazyProps, rest, {
	      children: children,
	      render: render
	    }));
	  }
	
	  if (render) {
	    return render(children === undefined ? Object.assign(lazyProps, rest) : // inject children back in
	    Object.assign(lazyProps, rest, {
	      children: children
	    }));
	  }
	
	  if (typeof children !== "function") {
	    throw new Error("Must specify either a render prop, a render function as children, or a component prop to " + name);
	  }
	
	  return children(Object.assign(lazyProps, rest));
	}
	
	function useWhenValueChanges(value, callback, isEqual) {
	  if (isEqual === void 0) {
	    isEqual = function isEqual(a, b) {
	      return a === b;
	    };
	  }
	
	  var previous = React__default["default"].useRef(value);
	  React__default["default"].useEffect(function () {
	    if (!isEqual(value, previous.current)) {
	      callback();
	      previous.current = value;
	    }
	  });
	}
	
	/**
	 * A simple hook to create a constant value that lives for
	 * the lifetime of the component.
	 *
	 * Plagiarized from https://github.com/Andarist/use-constant
	 *
	 * Do NOT reuse this code unless you know what you're doing.
	 * Use Andarist's hook; it's more fault tolerant to things like
	 * falsy values.
	 *
	 * @param {Function} init - A function to generate the value
	 */
	
	function useConstant(init) {
	  var ref = React__default["default"].useRef();
	
	  if (!ref.current) {
	    ref.current = init();
	  }
	
	  return ref.current;
	}
	
	var shallowEqual = function shallowEqual(a, b) {
	  if (a === b) {
	    return true;
	  }
	
	  if (typeof a !== "object" || !a || typeof b !== "object" || !b) {
	    return false;
	  }
	
	  var keysA = Object.keys(a);
	  var keysB = Object.keys(b);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(b);
	
	  for (var idx = 0; idx < keysA.length; idx++) {
	    var key = keysA[idx];
	
	    if (!bHasOwnProperty(key) || a[key] !== b[key]) {
	      return false;
	    }
	  }
	
	  return true;
	};
	
	var isSyntheticEvent = function isSyntheticEvent(candidate) {
	  return !!(candidate && typeof candidate.stopPropagation === "function");
	};
	
	var ReactFinalFormContext = /*#__PURE__*/React__namespace.createContext();
	
	function useLatest(value) {
	  var ref = React__default["default"].useRef(value);
	  React__default["default"].useEffect(function () {
	    ref.current = value;
	  });
	  return ref;
	}
	
	var version = "6.5.8";
	
	var addLazyState = function addLazyState(dest, state, keys) {
	  keys.forEach(function (key) {
	    Object.defineProperty(dest, key, {
	      get: function get() {
	        return state[key];
	      },
	      enumerable: true
	    });
	  });
	};
	
	var addLazyFormState = function addLazyFormState(dest, state) {
	  return addLazyState(dest, state, ["active", "dirty", "dirtyFields", "dirtySinceLastSubmit", "dirtyFieldsSinceLastSubmit", "error", "errors", "hasSubmitErrors", "hasValidationErrors", "initialValues", "invalid", "modified", "modifiedSinceLastSubmit", "pristine", "submitError", "submitErrors", "submitFailed", "submitSucceeded", "submitting", "touched", "valid", "validating", "values", "visited"]);
	};
	var addLazyFieldMetaState = function addLazyFieldMetaState(dest, state) {
	  return addLazyState(dest, state, ["active", "data", "dirty", "dirtySinceLastSubmit", "error", "initial", "invalid", "length", "modified", "modifiedSinceLastSubmit", "pristine", "submitError", "submitFailed", "submitSucceeded", "submitting", "touched", "valid", "validating", "visited"]);
	};
	
	var _excluded$2 = ["debug", "decorators", "destroyOnUnregister", "form", "initialValues", "initialValuesEqual", "keepDirtyOnReinitialize", "mutators", "onSubmit", "subscription", "validate", "validateOnBlur"];
	var versions = {
	  "final-form": finalForm.version,
	  "react-final-form": version
	};
	var all$1 = finalForm.formSubscriptionItems.reduce(function (result, key) {
	  result[key] = true;
	  return result;
	}, {});
	
	function ReactFinalForm(_ref) {
	  var debug = _ref.debug,
	      _ref$decorators = _ref.decorators,
	      decorators = _ref$decorators === void 0 ? [] : _ref$decorators,
	      destroyOnUnregister = _ref.destroyOnUnregister,
	      alternateFormApi = _ref.form,
	      initialValues = _ref.initialValues,
	      initialValuesEqual = _ref.initialValuesEqual,
	      keepDirtyOnReinitialize = _ref.keepDirtyOnReinitialize,
	      mutators = _ref.mutators,
	      onSubmit = _ref.onSubmit,
	      _ref$subscription = _ref.subscription,
	      subscription = _ref$subscription === void 0 ? all$1 : _ref$subscription,
	      validate = _ref.validate,
	      validateOnBlur = _ref.validateOnBlur,
	      rest = _objectWithoutPropertiesLoose__default["default"](_ref, _excluded$2);
	
	  var config = {
	    debug: debug,
	    destroyOnUnregister: destroyOnUnregister,
	    initialValues: initialValues,
	    keepDirtyOnReinitialize: keepDirtyOnReinitialize,
	    mutators: mutators,
	    onSubmit: onSubmit,
	    validate: validate,
	    validateOnBlur: validateOnBlur
	  };
	  var form = useConstant(function () {
	    var f = alternateFormApi || finalForm.createForm(config); // pause validation until children register all fields on first render (unpaused in useEffect() below)
	
	    f.pauseValidation();
	    return f;
	  }); // synchronously register and unregister to query form state for our subscription on first render
	
	  var _React$useState = React__namespace.useState(function () {
	    var initialState = {};
	    form.subscribe(function (state) {
	      initialState = state;
	    }, subscription)();
	    return initialState;
	  }),
	      state = _React$useState[0],
	      setState = _React$useState[1]; // save a copy of state that can break through the closure
	  // on the shallowEqual() line below.
	
	
	  var stateRef = useLatest(state);
	  React__namespace.useEffect(function () {
	    // We have rendered, so all fields are now registered, so we can unpause validation
	    form.isValidationPaused() && form.resumeValidation();
	    var unsubscriptions = [form.subscribe(function (s) {
	      if (!shallowEqual(s, stateRef.current)) {
	        setState(s);
	      }
	    }, subscription)].concat(decorators ? decorators.map(function (decorator) {
	      return (// this noop ternary is to appease the flow gods
	        // istanbul ignore next
	        decorator(form)
	      );
	    }) : []);
	    return function () {
	      form.pauseValidation(); // pause validation so we don't revalidate on every field deregistration
	
	      unsubscriptions.reverse().forEach(function (unsubscribe) {
	        return unsubscribe();
	      }); // don't need to resume validation here; either unmounting, or will re-run this hook with new deps
	    }; // eslint-disable-next-line react-hooks/exhaustive-deps
	  }, decorators); // warn about decorator changes
	  // istanbul ignore next
	
	  if (false) {
	    // You're never supposed to use hooks inside a conditional, but in this
	    // case we can be certain that you're not going to be changing your
	    // NODE_ENV between renders, so this is safe.
	    // eslint-disable-next-line react-hooks/rules-of-hooks
	    useWhenValueChanges(decorators, function () {
	      console.error("Form decorators should not change from one render to the next as new values will be ignored");
	    }, shallowEqual);
	  } // allow updatable config
	
	
	  useWhenValueChanges(debug, function () {
	    form.setConfig("debug", debug);
	  });
	  useWhenValueChanges(destroyOnUnregister, function () {
	    form.destroyOnUnregister = !!destroyOnUnregister;
	  });
	  useWhenValueChanges(keepDirtyOnReinitialize, function () {
	    form.setConfig("keepDirtyOnReinitialize", keepDirtyOnReinitialize);
	  });
	  useWhenValueChanges(initialValues, function () {
	    form.setConfig("initialValues", initialValues);
	  }, initialValuesEqual || shallowEqual);
	  useWhenValueChanges(mutators, function () {
	    form.setConfig("mutators", mutators);
	  });
	  useWhenValueChanges(onSubmit, function () {
	    form.setConfig("onSubmit", onSubmit);
	  });
	  useWhenValueChanges(validate, function () {
	    form.setConfig("validate", validate);
	  });
	  useWhenValueChanges(validateOnBlur, function () {
	    form.setConfig("validateOnBlur", validateOnBlur);
	  });
	
	  var handleSubmit = function handleSubmit(event) {
	    if (event) {
	      // sometimes not true, e.g. React Native
	      if (typeof event.preventDefault === "function") {
	        event.preventDefault();
	      }
	
	      if (typeof event.stopPropagation === "function") {
	        // prevent any outer forms from receiving the event too
	        event.stopPropagation();
	      }
	    }
	
	    return form.submit();
	  };
	
	  var renderProps = {
	    form: _extends__default["default"]({}, form, {
	      reset: function reset(eventOrValues) {
	        if (isSyntheticEvent(eventOrValues)) {
	          // it's a React SyntheticEvent, call reset with no arguments
	          form.reset();
	        } else {
	          form.reset(eventOrValues);
	        }
	      }
	    }),
	    handleSubmit: handleSubmit
	  };
	  addLazyFormState(renderProps, state);
	  return /*#__PURE__*/React__namespace.createElement(ReactFinalFormContext.Provider, {
	    value: form
	  }, renderComponent(_extends__default["default"]({}, rest, {
	    __versions: versions
	  }), renderProps, "ReactFinalForm"));
	}
	
	function useForm(componentName) {
	  var form = React__namespace.useContext(ReactFinalFormContext);
	
	  if (!form) {
	    throw new Error((componentName || "useForm") + " must be used inside of a <Form> component");
	  }
	
	  return form;
	}
	
	function useFormState(_temp) {
	  var _ref = _temp === void 0 ? {} : _temp,
	      onChange = _ref.onChange,
	      _ref$subscription = _ref.subscription,
	      subscription = _ref$subscription === void 0 ? all$1 : _ref$subscription;
	
	  var form = useForm("useFormState");
	  var firstRender = React__namespace.useRef(true);
	  var onChangeRef = React__namespace.useRef(onChange);
	  onChangeRef.current = onChange; // synchronously register and unregister to query field state for our subscription on first render
	
	  var _React$useState = React__namespace.useState(function () {
	    var initialState = {};
	    form.subscribe(function (state) {
	      initialState = state;
	    }, subscription)();
	
	    if (onChange) {
	      onChange(initialState);
	    }
	
	    return initialState;
	  }),
	      state = _React$useState[0],
	      setState = _React$useState[1];
	
	  React__namespace.useEffect(function () {
	    return form.subscribe(function (newState) {
	      if (firstRender.current) {
	        firstRender.current = false;
	      } else {
	        setState(newState);
	
	        if (onChangeRef.current) {
	          onChangeRef.current(newState);
	        }
	      }
	    }, subscription);
	  }, // eslint-disable-next-line react-hooks/exhaustive-deps
	  []);
	  var lazyState = {};
	  addLazyFormState(lazyState, state);
	  return lazyState;
	}
	
	var _excluded$1 = ["onChange", "subscription"];
	
	function FormSpy(_ref) {
	  var onChange = _ref.onChange,
	      subscription = _ref.subscription,
	      rest = _objectWithoutPropertiesLoose__default["default"](_ref, _excluded$1);
	
	  var reactFinalForm = useForm("FormSpy");
	  var state = useFormState({
	    onChange: onChange,
	    subscription: subscription
	  });
	
	  if (onChange) {
	    return null;
	  }
	
	  var renderProps = {
	    form: _extends__default["default"]({}, reactFinalForm, {
	      reset: function reset(eventOrValues) {
	        if (isSyntheticEvent(eventOrValues)) {
	          // it's a React SyntheticEvent, call reset with no arguments
	          reactFinalForm.reset();
	        } else {
	          reactFinalForm.reset(eventOrValues);
	        }
	      }
	    })
	  };
	  return renderComponent(_extends__default["default"]({}, rest, renderProps), state, "FormSpy");
	}
	
	var isReactNative = typeof window !== "undefined" && window.navigator && window.navigator.product && window.navigator.product === "ReactNative";
	
	var getSelectedValues = function getSelectedValues(options) {
	  var result = [];
	
	  if (options) {
	    for (var index = 0; index < options.length; index++) {
	      var option = options[index];
	
	      if (option.selected) {
	        result.push(option.value);
	      }
	    }
	  }
	
	  return result;
	};
	
	var getValue = function getValue(event, currentValue, valueProp, isReactNative) {
	  if (!isReactNative && event.nativeEvent && event.nativeEvent.text !== undefined) {
	    return event.nativeEvent.text;
	  }
	
	  if (isReactNative && event.nativeEvent) {
	    return event.nativeEvent.text;
	  }
	
	  var detypedEvent = event;
	  var _detypedEvent$target = detypedEvent.target,
	      type = _detypedEvent$target.type,
	      value = _detypedEvent$target.value,
	      checked = _detypedEvent$target.checked;
	
	  switch (type) {
	    case "checkbox":
	      if (valueProp !== undefined) {
	        // we are maintaining an array, not just a boolean
	        if (checked) {
	          // add value to current array value
	          return Array.isArray(currentValue) ? currentValue.concat(valueProp) : [valueProp];
	        } else {
	          // remove value from current array value
	          if (!Array.isArray(currentValue)) {
	            return currentValue;
	          }
	
	          var index = currentValue.indexOf(valueProp);
	
	          if (index < 0) {
	            return currentValue;
	          } else {
	            return currentValue.slice(0, index).concat(currentValue.slice(index + 1));
	          }
	        }
	      } else {
	        // it's just a boolean
	        return !!checked;
	      }
	
	    case "select-multiple":
	      return getSelectedValues(event.target.options);
	
	    default:
	      return value;
	  }
	};
	
	/**
	 * Creates a callback, even with closures, that will be
	 * instance === for the lifetime of the component, always
	 * calling the most recent version of the function and its
	 * closures.
	 */
	
	function useConstantCallback(callback) {
	  var ref = React__namespace.useRef(callback);
	  React__namespace.useEffect(function () {
	    ref.current = callback;
	  });
	  return React__namespace.useCallback(function () {
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return ref.current.apply(null, args);
	  }, []);
	}
	
	var all = finalForm.fieldSubscriptionItems.reduce(function (result, key) {
	  result[key] = true;
	  return result;
	}, {});
	
	var defaultFormat = function defaultFormat(value, name) {
	  return value === undefined ? "" : value;
	};
	
	var defaultParse = function defaultParse(value, name) {
	  return value === "" ? undefined : value;
	};
	
	var defaultIsEqual = function defaultIsEqual(a, b) {
	  return a === b;
	};
	
	function useField(name, config) {
	  if (config === void 0) {
	    config = {};
	  }
	
	  var _config = config,
	      afterSubmit = _config.afterSubmit,
	      allowNull = _config.allowNull,
	      component = _config.component,
	      data = _config.data,
	      defaultValue = _config.defaultValue,
	      _config$format = _config.format,
	      format = _config$format === void 0 ? defaultFormat : _config$format,
	      formatOnBlur = _config.formatOnBlur,
	      initialValue = _config.initialValue,
	      multiple = _config.multiple,
	      _config$parse = _config.parse,
	      parse = _config$parse === void 0 ? defaultParse : _config$parse,
	      _config$subscription = _config.subscription,
	      subscription = _config$subscription === void 0 ? all : _config$subscription,
	      type = _config.type,
	      validateFields = _config.validateFields,
	      _value = _config.value;
	  var form = useForm("useField");
	  var configRef = useLatest(config);
	
	  var register = function register(callback, silent) {
	    return (// avoid using `state` const in any closures created inside `register`
	      // because they would refer `state` from current execution context
	      // whereas actual `state` would defined in the subsequent `useField` hook
	      // execution
	      // (that would be caused by `setState` call performed in `register` callback)
	      form.registerField(name, callback, subscription, {
	        afterSubmit: afterSubmit,
	        beforeSubmit: function beforeSubmit() {
	          var _configRef$current = configRef.current,
	              beforeSubmit = _configRef$current.beforeSubmit,
	              formatOnBlur = _configRef$current.formatOnBlur,
	              _configRef$current$fo = _configRef$current.format,
	              format = _configRef$current$fo === void 0 ? defaultFormat : _configRef$current$fo;
	
	          if (formatOnBlur) {
	            var _ref = form.getFieldState(name),
	                value = _ref.value;
	
	            var formatted = format(value, name);
	
	            if (formatted !== value) {
	              form.change(name, formatted);
	            }
	          }
	
	          return beforeSubmit && beforeSubmit();
	        },
	        data: data,
	        defaultValue: defaultValue,
	        getValidator: function getValidator() {
	          return configRef.current.validate;
	        },
	        initialValue: initialValue,
	        isEqual: function isEqual(a, b) {
	          return (configRef.current.isEqual || defaultIsEqual)(a, b);
	        },
	        silent: silent,
	        validateFields: validateFields
	      })
	    );
	  };
	
	  var firstRender = React__namespace.useRef(true); // synchronously register and unregister to query field state for our subscription on first render
	
	  var _React$useState = React__namespace.useState(function () {
	    var initialState = {}; // temporarily disable destroyOnUnregister
	
	    // temporarily disable destroyOnUnregister
	    var destroyOnUnregister = form.destroyOnUnregister;
	    form.destroyOnUnregister = false;
	    register(function (state) {
	      initialState = state;
	    }, true)(); // return destroyOnUnregister to its original value
	
	    // return destroyOnUnregister to its original value
	    form.destroyOnUnregister = destroyOnUnregister;
	    return initialState;
	  }),
	      state = _React$useState[0],
	      setState = _React$useState[1];
	
	  React__namespace.useEffect(function () {
	    return register(function (state) {
	      if (firstRender.current) {
	        firstRender.current = false;
	      } else {
	        setState(state);
	      }
	    }, false);
	  }, // eslint-disable-next-line react-hooks/exhaustive-deps
	  [name, data, defaultValue, // If we want to allow inline fat-arrow field-level validation functions, we
	  // cannot reregister field every time validate function !==.
	  // validate,
	  initialValue // The validateFields array is often passed as validateFields={[]}, creating
	  // a !== new array every time. If it needs to be changed, a rerender/reregister
	  // can be forced by changing the key prop
	  // validateFields
	  ]);
	  var meta = {};
	  addLazyFieldMetaState(meta, state);
	  var input = {
	    name: name,
	
	    get value() {
	      var value = state.value;
	
	      if (formatOnBlur) {
	        if (component === "input") {
	          value = defaultFormat(value);
	        }
	      } else {
	        value = format(value, name);
	      }
	
	      if (value === null && !allowNull) {
	        value = "";
	      }
	
	      if (type === "checkbox" || type === "radio") {
	        return _value;
	      } else if (component === "select" && multiple) {
	        return value || [];
	      }
	
	      return value;
	    },
	
	    get checked() {
	      var value = state.value;
	
	      if (type === "checkbox") {
	        value = format(value, name);
	
	        if (_value === undefined) {
	          return !!value;
	        } else {
	          return !!(Array.isArray(value) && ~value.indexOf(_value));
	        }
	      } else if (type === "radio") {
	        return format(value, name) === _value;
	      }
	
	      return undefined;
	    },
	
	    onBlur: useConstantCallback(function (event) {
	      state.blur();
	
	      if (formatOnBlur) {
	        /**
	         * Here we must fetch the value directly from Final Form because we cannot
	         * trust that our `state` closure has the most recent value. This is a problem
	         * if-and-only-if the library consumer has called `onChange()` immediately
	         * before calling `onBlur()`, but before the field has had a chance to receive
	         * the value update from Final Form.
	         */
	        var fieldState = form.getFieldState(state.name);
	        state.change(format(fieldState.value, state.name));
	      }
	    }),
	    onChange: useConstantCallback(function (event) {
	      // istanbul ignore next
	      if (false) {
	        var targetType = event.target.type;
	        var unknown = ~["checkbox", "radio", "select-multiple"].indexOf(targetType) && !type && component !== "select";
	
	        var _value2 = targetType === "select-multiple" ? state.value : _value;
	
	        if (unknown) {
	          console.error("You must pass `type=\"" + (targetType === "select-multiple" ? "select" : targetType) + "\"` prop to your Field(" + name + ") component.\n" + ("Without it we don't know how to unpack your `value` prop - " + (Array.isArray(_value2) ? "[" + _value2 + "]" : "\"" + _value2 + "\"") + "."));
	        }
	      }
	
	      var value = event && event.target ? getValue(event, state.value, _value, isReactNative) : event;
	      state.change(parse(value, name));
	    }),
	    onFocus: useConstantCallback(function (event) {
	      return state.focus();
	    })
	  };
	
	  if (multiple) {
	    input.multiple = multiple;
	  }
	
	  if (type !== undefined) {
	    input.type = type;
	  }
	
	  var renderProps = {
	    input: input,
	    meta: meta
	  }; // assign to force Flow check
	
	  return renderProps;
	}
	
	var _excluded = ["afterSubmit", "allowNull", "beforeSubmit", "children", "component", "data", "defaultValue", "format", "formatOnBlur", "initialValue", "isEqual", "multiple", "name", "parse", "subscription", "type", "validate", "validateFields", "value"];
	var Field = /*#__PURE__*/React__namespace.forwardRef(function Field(_ref, ref) {
	  var afterSubmit = _ref.afterSubmit,
	      allowNull = _ref.allowNull,
	      beforeSubmit = _ref.beforeSubmit,
	      children = _ref.children,
	      component = _ref.component,
	      data = _ref.data,
	      defaultValue = _ref.defaultValue,
	      format = _ref.format,
	      formatOnBlur = _ref.formatOnBlur,
	      initialValue = _ref.initialValue,
	      isEqual = _ref.isEqual,
	      multiple = _ref.multiple,
	      name = _ref.name,
	      parse = _ref.parse,
	      subscription = _ref.subscription,
	      type = _ref.type,
	      validate = _ref.validate,
	      validateFields = _ref.validateFields,
	      value = _ref.value,
	      rest = _objectWithoutPropertiesLoose__default["default"](_ref, _excluded);
	
	  var field = useField(name, {
	    afterSubmit: afterSubmit,
	    allowNull: allowNull,
	    beforeSubmit: beforeSubmit,
	    children: children,
	    component: component,
	    data: data,
	    defaultValue: defaultValue,
	    format: format,
	    formatOnBlur: formatOnBlur,
	    initialValue: initialValue,
	    isEqual: isEqual,
	    multiple: multiple,
	    parse: parse,
	    subscription: subscription,
	    type: type,
	    validate: validate,
	    validateFields: validateFields,
	    value: value
	  });
	
	  if (typeof children === "function") {
	    return children(_extends__default["default"]({}, field, rest));
	  }
	
	  if (typeof component === "string") {
	    // ignore meta, combine input with any other props
	    return /*#__PURE__*/React__namespace.createElement(component, _extends__default["default"]({}, field.input, {
	      children: children,
	      ref: ref
	    }, rest));
	  }
	
	  if (!name) {
	    throw new Error("prop name cannot be undefined in <Field> component");
	  }
	
	  return renderComponent(_extends__default["default"]({
	    children: children,
	    component: component,
	    ref: ref
	  }, rest), field, "Field(" + name + ")");
	});
	
	function withTypes() {
	  return {
	    Form: ReactFinalForm,
	    FormSpy: FormSpy
	  };
	}
	
	exports.Field = Field;
	exports.Form = ReactFinalForm;
	exports.FormSpy = FormSpy;
	exports.useField = useField;
	exports.useForm = useForm;
	exports.useFormState = useFormState;
	exports.version = version;
	exports.withTypes = withTypes;


/***/ },
/* 523 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	function componentWillMount() {
	  // Call this.constructor.gDSFP to support sub-classes.
	  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
	  if (state !== null && state !== undefined) {
	    this.setState(state);
	  }
	}
	
	function componentWillReceiveProps(nextProps) {
	  // Call this.constructor.gDSFP to support sub-classes.
	  // Use the setState() updater to ensure state isn't stale in certain edge cases.
	  function updater(prevState) {
	    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
	    return state !== null && state !== undefined ? state : null;
	  }
	  // Binding "this" is important for shallow renderer support.
	  this.setState(updater.bind(this));
	}
	
	function componentWillUpdate(nextProps, nextState) {
	  try {
	    var prevProps = this.props;
	    var prevState = this.state;
	    this.props = nextProps;
	    this.state = nextState;
	    this.__reactInternalSnapshotFlag = true;
	    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
	      prevProps,
	      prevState
	    );
	  } finally {
	    this.props = prevProps;
	    this.state = prevState;
	  }
	}
	
	// React may warn about cWM/cWRP/cWU methods being deprecated.
	// Add a flag to suppress these warnings for this special case.
	componentWillMount.__suppressDeprecationWarning = true;
	componentWillReceiveProps.__suppressDeprecationWarning = true;
	componentWillUpdate.__suppressDeprecationWarning = true;
	
	function polyfill(Component) {
	  var prototype = Component.prototype;
	
	  if (!prototype || !prototype.isReactComponent) {
	    throw new Error('Can only polyfill class components');
	  }
	
	  if (
	    typeof Component.getDerivedStateFromProps !== 'function' &&
	    typeof prototype.getSnapshotBeforeUpdate !== 'function'
	  ) {
	    return Component;
	  }
	
	  // If new component APIs are defined, "unsafe" lifecycles won't be called.
	  // Error if any of these lifecycles are present,
	  // Because they would work differently between older and newer (16.3+) versions of React.
	  var foundWillMountName = null;
	  var foundWillReceivePropsName = null;
	  var foundWillUpdateName = null;
	  if (typeof prototype.componentWillMount === 'function') {
	    foundWillMountName = 'componentWillMount';
	  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
	    foundWillMountName = 'UNSAFE_componentWillMount';
	  }
	  if (typeof prototype.componentWillReceiveProps === 'function') {
	    foundWillReceivePropsName = 'componentWillReceiveProps';
	  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
	    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
	  }
	  if (typeof prototype.componentWillUpdate === 'function') {
	    foundWillUpdateName = 'componentWillUpdate';
	  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
	    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
	  }
	  if (
	    foundWillMountName !== null ||
	    foundWillReceivePropsName !== null ||
	    foundWillUpdateName !== null
	  ) {
	    var componentName = Component.displayName || Component.name;
	    var newApiName =
	      typeof Component.getDerivedStateFromProps === 'function'
	        ? 'getDerivedStateFromProps()'
	        : 'getSnapshotBeforeUpdate()';
	
	    throw Error(
	      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
	        componentName +
	        ' uses ' +
	        newApiName +
	        ' but also contains the following legacy lifecycles:' +
	        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
	        (foundWillReceivePropsName !== null
	          ? '\n  ' + foundWillReceivePropsName
	          : '') +
	        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
	        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
	        'https://fb.me/react-async-component-lifecycle-hooks'
	    );
	  }
	
	  // React <= 16.2 does not support static getDerivedStateFromProps.
	  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
	  // Newer versions of React will ignore these lifecycles if gDSFP exists.
	  if (typeof Component.getDerivedStateFromProps === 'function') {
	    prototype.componentWillMount = componentWillMount;
	    prototype.componentWillReceiveProps = componentWillReceiveProps;
	  }
	
	  // React <= 16.2 does not support getSnapshotBeforeUpdate.
	  // As a workaround, use cWU to invoke the new lifecycle.
	  // Newer versions of React will ignore that lifecycle if gSBU exists.
	  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
	    if (typeof prototype.componentDidUpdate !== 'function') {
	      throw new Error(
	        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
	      );
	    }
	
	    prototype.componentWillUpdate = componentWillUpdate;
	
	    var componentDidUpdate = prototype.componentDidUpdate;
	
	    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
	      prevProps,
	      prevState,
	      maybeSnapshot
	    ) {
	      // 16.3+ will not execute our will-update method;
	      // It will pass a snapshot value to did-update though.
	      // Older versions will require our polyfilled will-update value.
	      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
	      // Because for <= 15.x versions this might be a "prevContext" object.
	      // We also can't just check "__reactInternalSnapshot",
	      // Because get-snapshot might return a falsy value.
	      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
	      var snapshot = this.__reactInternalSnapshotFlag
	        ? this.__reactInternalSnapshot
	        : maybeSnapshot;
	
	      componentDidUpdate.call(this, prevProps, prevState, snapshot);
	    };
	  }
	
	  return Component;
	}
	
	exports.polyfill = polyfill;


/***/ },
/* 524 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _inDOM = __webpack_require__(84);
	
	var _inDOM2 = _interopRequireDefault(_inDOM);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _componentOrElement = __webpack_require__(213);
	
	var _componentOrElement2 = _interopRequireDefault(_componentOrElement);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(46);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _getContainer = __webpack_require__(220);
	
	var _getContainer2 = _interopRequireDefault(_getContainer);
	
	var _ownerDocument = __webpack_require__(132);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	var _LegacyPortal = __webpack_require__(1855);
	
	var _LegacyPortal2 = _interopRequireDefault(_LegacyPortal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `<Portal/>` component renders its children into a new "subtree" outside of current component hierarchy.
	 * You can think of it as a declarative `appendChild()`, or jQuery's `$.fn.appendTo()`.
	 * The children of `<Portal/>` component will be appended to the `container` specified.
	 */
	var Portal = function (_React$Component) {
	  _inherits(Portal, _React$Component);
	
	  function Portal() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Portal);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.getMountNode = function () {
	      return _this._portalContainerNode;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Portal.prototype.UNSAFE_componentWillMount = function UNSAFE_componentWillMount() {
	    if (!_inDOM2.default) {
	      return;
	    }
	
	    var container = this.props.container;
	
	    if (typeof container === 'function') {
	      container = container();
	    }
	
	    if (container && !_reactDom2.default.findDOMNode(container)) {
	      // The container is a React component that has not yet been rendered.
	      // Don't set the container node yet.
	      return;
	    }
	
	    this.setContainer(container);
	  };
	
	  Portal.prototype.componentDidMount = function componentDidMount() {
	    if (!this._portalContainerNode) {
	      this.setContainer(this.props.container);
	      this.forceUpdate(this.props.onRendered);
	    } else if (this.props.onRendered) {
	      this.props.onRendered();
	    }
	  };
	
	  Portal.prototype.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps(nextProps) {
	    if (nextProps.container !== this.props.container) {
	      this.setContainer(nextProps.container);
	    }
	  };
	
	  Portal.prototype.componentWillUnmount = function componentWillUnmount() {
	    this._portalContainerNode = null;
	  };
	
	  Portal.prototype.setContainer = function setContainer(container) {
	    this._portalContainerNode = (0, _getContainer2.default)(container, (0, _ownerDocument2.default)(this).body);
	  };
	
	  Portal.prototype.render = function render() {
	    return this.props.children && this._portalContainerNode ? _reactDom2.default.createPortal(this.props.children, this._portalContainerNode) : null;
	  };
	
	  return Portal;
	}(_react2.default.Component);
	
	Portal.displayName = 'Portal';
	Portal.propTypes = {
	  /**
	   * A Node, Component instance, or function that returns either. The `container` will have the Portal children
	   * appended to it.
	   */
	  container: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),
	
	  onRendered: _propTypes2.default.func
	};
	exports.default = _reactDom2.default.createPortal ? Portal : _LegacyPortal2.default;
	module.exports = exports['default'];

/***/ },
/* 525 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _contains = __webpack_require__(130);
	
	var _contains2 = _interopRequireDefault(_contains);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(46);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _addEventListener = __webpack_require__(526);
	
	var _addEventListener2 = _interopRequireDefault(_addEventListener);
	
	var _ownerDocument = __webpack_require__(132);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var escapeKeyCode = 27;
	
	function isLeftClickEvent(event) {
	  return event.button === 0;
	}
	
	function isModifiedEvent(event) {
	  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
	}
	
	/**
	 * The `<RootCloseWrapper/>` component registers your callback on the document
	 * when rendered. Powers the `<Overlay/>` component. This is used achieve modal
	 * style behavior where your callback is triggered when the user tries to
	 * interact with the rest of the document or hits the `esc` key.
	 */
	
	var RootCloseWrapper = function (_React$Component) {
	  _inherits(RootCloseWrapper, _React$Component);
	
	  function RootCloseWrapper(props, context) {
	    _classCallCheck(this, RootCloseWrapper);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	    _this.addEventListeners = function () {
	      // Store the current event to avoid triggering handlers immediately
	      // https://github.com/facebook/react/issues/20074
	      _this.currentEvent = window.event;
	
	      var event = _this.props.event;
	
	      var doc = (0, _ownerDocument2.default)(_this);
	
	      // Use capture for this listener so it fires before React's listener, to
	      // avoid false positives in the contains() check below if the target DOM
	      // element is removed in the React mouse callback.
	      _this.documentMouseCaptureListener = (0, _addEventListener2.default)(doc, event, _this.handleMouseCapture, true);
	
	      _this.documentMouseListener = (0, _addEventListener2.default)(doc, event, _this.handleMouse);
	
	      _this.documentKeyupListener = (0, _addEventListener2.default)(doc, 'keyup', _this.handleKeyUp);
	    };
	
	    _this.removeEventListeners = function () {
	      if (_this.documentMouseCaptureListener) {
	        _this.documentMouseCaptureListener.remove();
	      }
	
	      if (_this.documentMouseListener) {
	        _this.documentMouseListener.remove();
	      }
	
	      if (_this.documentKeyupListener) {
	        _this.documentKeyupListener.remove();
	      }
	    };
	
	    _this.handleMouseCapture = function (e) {
	      _this.preventMouseRootClose = isModifiedEvent(e) || !isLeftClickEvent(e) || (0, _contains2.default)(_reactDom2.default.findDOMNode(_this), e.target);
	    };
	
	    _this.handleMouse = function (e) {
	      // skip if this event is the same as the one running when we added the handlers
	      if (e === _this.currentEvent) {
	        _this.currentEvent = undefined;
	        return;
	      }
	
	      if (!_this.preventMouseRootClose && _this.props.onRootClose) {
	        _this.props.onRootClose(e);
	      }
	    };
	
	    _this.handleKeyUp = function (e) {
	      // skip if this event is the same as the one running when we added the handlers
	      if (e === _this.currentEvent) {
	        _this.currentEvent = undefined;
	        return;
	      }
	
	      if (e.keyCode === escapeKeyCode && _this.props.onRootClose) {
	        _this.props.onRootClose(e);
	      }
	    };
	
	    _this.preventMouseRootClose = false;
	    return _this;
	  }
	
	  RootCloseWrapper.prototype.componentDidMount = function componentDidMount() {
	    if (!this.props.disabled) {
	      this.addEventListeners();
	    }
	  };
	
	  RootCloseWrapper.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    if (!this.props.disabled && prevProps.disabled) {
	      this.addEventListeners();
	    } else if (this.props.disabled && !prevProps.disabled) {
	      this.removeEventListeners();
	    }
	  };
	
	  RootCloseWrapper.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (!this.props.disabled) {
	      this.removeEventListeners();
	    }
	  };
	
	  RootCloseWrapper.prototype.render = function render() {
	    return this.props.children;
	  };
	
	  return RootCloseWrapper;
	}(_react2.default.Component);
	
	RootCloseWrapper.displayName = 'RootCloseWrapper';
	
	RootCloseWrapper.propTypes = {
	  /**
	   * Callback fired after click or mousedown. Also triggers when user hits `esc`.
	   */
	  onRootClose: _propTypes2.default.func,
	  /**
	   * Children to render.
	   */
	  children: _propTypes2.default.element,
	  /**
	   * Disable the the RootCloseWrapper, preventing it from triggering `onRootClose`.
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	   * Choose which document mouse event to bind to.
	   */
	  event: _propTypes2.default.oneOf(['click', 'mousedown'])
	};
	
	RootCloseWrapper.defaultProps = {
	  event: 'click'
	};
	
	exports.default = RootCloseWrapper;
	module.exports = exports['default'];

/***/ },
/* 526 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	exports.default = function (node, event, handler, capture) {
	  (0, _on2.default)(node, event, handler, capture);
	
	  return {
	    remove: function remove() {
	      (0, _off2.default)(node, event, handler, capture);
	    }
	  };
	};
	
	var _on = __webpack_require__(291);
	
	var _on2 = _interopRequireDefault(_on);
	
	var _off = __webpack_require__(290);
	
	var _off2 = _interopRequireDefault(_off);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = exports['default'];

/***/ },
/* 527 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = isOverflowing;
	
	var _isWindow = __webpack_require__(197);
	
	var _isWindow2 = _interopRequireDefault(_isWindow);
	
	var _ownerDocument = __webpack_require__(129);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isBody(node) {
	  return node && node.tagName.toLowerCase() === 'body';
	}
	
	function bodyIsOverflowing(node) {
	  var doc = (0, _ownerDocument2.default)(node);
	  var win = (0, _isWindow2.default)(doc);
	  var fullWidth = win.innerWidth;
	
	  // Support: ie8, no innerWidth
	  if (!fullWidth) {
	    var documentElementRect = doc.documentElement.getBoundingClientRect();
	    fullWidth = documentElementRect.right - Math.abs(documentElementRect.left);
	  }
	
	  return doc.body.clientWidth < fullWidth;
	}
	
	function isOverflowing(container) {
	  var win = (0, _isWindow2.default)(container);
	
	  return win || isBody(container) ? bodyIsOverflowing(container) : container.scrollHeight > container.clientHeight;
	}
	module.exports = exports['default'];

/***/ },
/* 528 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.add = add;
	exports.removeByType = exports.hideConfirm = exports.showConfirm = exports.remove = exports.clean = void 0;
	
	var _constants = __webpack_require__(314);
	
	var _utils = __webpack_require__(133);
	
	var _reducer = __webpack_require__(529);
	
	var _config = _interopRequireDefault(__webpack_require__(313));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function add(toastr) {
	  if (_config["default"].preventDuplicates && (0, _utils.preventDuplication)(_reducer.toastrsCache, toastr)) {
	    return {
	      type: _constants.ADD_TOASTR,
	      payload: {
	        ignoreToastr: true
	      }
	    };
	  }
	
	  return {
	    type: _constants.ADD_TOASTR,
	    payload: toastr
	  };
	}
	
	var clean = function clean() {
	  return {
	    type: _constants.CLEAN_TOASTR
	  };
	};
	
	exports.clean = clean;
	
	var remove = function remove(payload) {
	  return {
	    type: _constants.REMOVE_TOASTR,
	    payload: payload
	  };
	};
	
	exports.remove = remove;
	
	var showConfirm = function showConfirm(payload) {
	  return {
	    type: _constants.SHOW_CONFIRM,
	    payload: payload
	  };
	};
	
	exports.showConfirm = showConfirm;
	
	var hideConfirm = function hideConfirm() {
	  return {
	    type: _constants.HIDE_CONFIRM
	  };
	};
	
	exports.hideConfirm = hideConfirm;
	
	var removeByType = function removeByType(payload) {
	  return {
	    type: _constants.REMOVE_BY_TYPE,
	    payload: payload
	  };
	};
	
	exports.removeByType = removeByType;

/***/ },
/* 529 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = exports.toastrsCache = void 0;
	
	var _utils = __webpack_require__(133);
	
	var _config = _interopRequireDefault(__webpack_require__(313));
	
	var _constants = __webpack_require__(314);
	
	var _createReducer;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	
	function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
	
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	// TOTO: find a better way of handling this issue
	// We will cache data so we can check for duplicated before fire the add action.
	var toastrsCache = [];
	exports.toastrsCache = toastrsCache;
	var initialState = {
	  toastrs: [],
	  confirm: null
	};
	
	var _default = (0, _utils.createReducer)(initialState, (_createReducer = {}, _defineProperty(_createReducer, _constants.ADD_TOASTR, function (state, toastr) {
	  if (toastr.ignoreToastr) {
	    return state;
	  }
	
	  var newToastr = _objectSpread({
	    id: (0, _utils.guid)(),
	    position: _config["default"].position
	  }, toastr);
	
	  if (!newToastr.a11yId && toastr && toastr.hasOwnProperty('id') && !toastr.hasOwnProperty('a11yId')) {
	    newToastr.a11yId = toastr.id;
	  }
	
	  var newState = {};
	
	  if (!_config["default"].newestOnTop) {
	    newState = _objectSpread(_objectSpread({}, state), {}, {
	      toastrs: [].concat(_toConsumableArray(state.toastrs), [newToastr])
	    });
	  } else {
	    newState = _objectSpread(_objectSpread({}, state), {}, {
	      toastrs: [newToastr].concat(_toConsumableArray(state.toastrs))
	    });
	  }
	
	  exports.toastrsCache = toastrsCache = newState.toastrs;
	  return newState;
	}), _defineProperty(_createReducer, _constants.REMOVE_TOASTR, function (state, id) {
	  var newState = _objectSpread(_objectSpread({}, state), {}, {
	    toastrs: state.toastrs.filter(function (toastr) {
	      return toastr.id !== id;
	    })
	  });
	
	  exports.toastrsCache = toastrsCache = newState.toastrs;
	  return newState;
	}), _defineProperty(_createReducer, _constants.REMOVE_BY_TYPE, function (state, type) {
	  var newState = _objectSpread(_objectSpread({}, state), {}, {
	    toastrs: state.toastrs.filter(function (toastr) {
	      return toastr.type !== type;
	    })
	  });
	
	  exports.toastrsCache = toastrsCache = newState.toastrs;
	  return newState;
	}), _defineProperty(_createReducer, _constants.CLEAN_TOASTR, function (state) {
	  exports.toastrsCache = toastrsCache = [];
	  return _objectSpread(_objectSpread({}, state), {}, {
	    toastrs: []
	  });
	}), _defineProperty(_createReducer, _constants.SHOW_CONFIRM, function (state, _ref) {
	  var id = _ref.id,
	      message = _ref.message,
	      options = _ref.options;
	  return _objectSpread(_objectSpread({}, state), {}, {
	    confirm: {
	      id: id || (0, _utils.guid)(),
	      show: true,
	      message: message,
	      options: options || {}
	    }
	  });
	}), _defineProperty(_createReducer, _constants.HIDE_CONFIRM, function (state) {
	  return _objectSpread(_objectSpread({}, state), {}, {
	    confirm: null
	  });
	}), _createReducer));
	
	exports["default"] = _default;

/***/ },
/* 530 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.toastrEmitter = exports.EE = void 0;
	
	var _utils = __webpack_require__(133);
	
	var _eventemitter = _interopRequireDefault(__webpack_require__(1873));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var emitter = new _eventemitter["default"]();
	
	var addToToastr = function addToToastr(type, array) {
	  return emitter.emit('add/toastr', (0, _utils.mapToToastrMessage)(type, array));
	};
	
	var actions = {};
	['light', 'message', 'info', 'success', 'warning', 'error'].forEach(function (item) {
	  actions[item] = function () {
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return addToToastr(item, args);
	  };
	});
	
	actions.clean = function () {
	  return emitter.emit('clean/toastr');
	};
	/**
	 * @params: can be a ID or a object that with a property type: 'success'
	 * and by passing this we will remove all toastr with that type.
	 */
	
	
	actions.removeByType = function (type) {
	  return emitter.emit('removeByType/toastr', type);
	};
	
	actions.remove = function (id) {
	  return emitter.emit('remove/toastr', id);
	};
	
	actions.confirm = function () {
	  emitter.emit('toastr/confirm', {
	    message: arguments.length <= 0 ? undefined : arguments[0],
	    options: (arguments.length <= 1 ? undefined : arguments[1]) || {}
	  });
	};
	
	var EE = emitter;
	exports.EE = EE;
	var toastrEmitter = actions;
	exports.toastrEmitter = toastrEmitter;

/***/ },
/* 531 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(48);
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports.default = connectAdvanced;
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(53));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(624));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(35));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(43));
	
	var _hoistNonReactStatics = _interopRequireDefault(__webpack_require__(469));
	
	var _invariant = _interopRequireDefault(__webpack_require__(37));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _reactIs = __webpack_require__(160);
	
	var _Subscription = _interopRequireDefault(__webpack_require__(1881));
	
	var _PropTypes = __webpack_require__(533);
	
	var prefixUnsafeLifecycleMethods = typeof _react.default.forwardRef !== "undefined";
	var hotReloadingVersion = 0;
	var dummyState = {};
	
	function noop() {}
	
	function makeSelectorStateful(sourceSelector, store) {
	  // wrap the selector in an object that tracks its results between runs.
	  var selector = {
	    run: function runComponentSelector(props) {
	      try {
	        var nextProps = sourceSelector(store.getState(), props);
	
	        if (nextProps !== selector.props || selector.error) {
	          selector.shouldComponentUpdate = true;
	          selector.props = nextProps;
	          selector.error = null;
	        }
	      } catch (error) {
	        selector.shouldComponentUpdate = true;
	        selector.error = error;
	      }
	    }
	  };
	  return selector;
	}
	
	function connectAdvanced(
	/*
	  selectorFactory is a func that is responsible for returning the selector function used to
	  compute new props from state, props, and dispatch. For example:
	     export default connectAdvanced((dispatch, options) => (state, props) => ({
	      thing: state.things[props.thingId],
	      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
	    }))(YourComponent)
	   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
	  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
	  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
	   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
	  props. Do not use connectAdvanced directly without memoizing results between calls to your
	  selector, otherwise the Connect component will re-render on every state or props change.
	*/
	selectorFactory, // options object:
	_ref) {
	  var _contextTypes, _childContextTypes;
	
	  if (_ref === void 0) {
	    _ref = {};
	  }
	
	  var _ref2 = _ref,
	      _ref2$getDisplayName = _ref2.getDisplayName,
	      getDisplayName = _ref2$getDisplayName === void 0 ? function (name) {
	    return "ConnectAdvanced(" + name + ")";
	  } : _ref2$getDisplayName,
	      _ref2$methodName = _ref2.methodName,
	      methodName = _ref2$methodName === void 0 ? 'connectAdvanced' : _ref2$methodName,
	      _ref2$renderCountProp = _ref2.renderCountProp,
	      renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp,
	      _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges,
	      shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta,
	      _ref2$storeKey = _ref2.storeKey,
	      storeKey = _ref2$storeKey === void 0 ? 'store' : _ref2$storeKey,
	      _ref2$withRef = _ref2.withRef,
	      withRef = _ref2$withRef === void 0 ? false : _ref2$withRef,
	      connectOptions = (0, _objectWithoutPropertiesLoose2.default)(_ref2, ["getDisplayName", "methodName", "renderCountProp", "shouldHandleStateChanges", "storeKey", "withRef"]);
	  var subscriptionKey = storeKey + 'Subscription';
	  var version = hotReloadingVersion++;
	  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = _PropTypes.storeShape, _contextTypes[subscriptionKey] = _PropTypes.subscriptionShape, _contextTypes);
	  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = _PropTypes.subscriptionShape, _childContextTypes);
	  return function wrapWithConnect(WrappedComponent) {
	    (0, _invariant.default)((0, _reactIs.isValidElementType)(WrappedComponent), "You must pass a component to the function returned by " + (methodName + ". Instead received " + JSON.stringify(WrappedComponent)));
	    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
	    var displayName = getDisplayName(wrappedComponentName);
	    var selectorFactoryOptions = (0, _extends2.default)({}, connectOptions, {
	      getDisplayName: getDisplayName,
	      methodName: methodName,
	      renderCountProp: renderCountProp,
	      shouldHandleStateChanges: shouldHandleStateChanges,
	      storeKey: storeKey,
	      withRef: withRef,
	      displayName: displayName,
	      wrappedComponentName: wrappedComponentName,
	      WrappedComponent: WrappedComponent // TODO Actually fix our use of componentWillReceiveProps
	
	      /* eslint-disable react/no-deprecated */
	
	    });
	
	    var Connect =
	    /*#__PURE__*/
	    function (_Component) {
	      (0, _inheritsLoose2.default)(Connect, _Component);
	
	      function Connect(props, context) {
	        var _this;
	
	        _this = _Component.call(this, props, context) || this;
	        _this.version = version;
	        _this.state = {};
	        _this.renderCount = 0;
	        _this.store = props[storeKey] || context[storeKey];
	        _this.propsMode = Boolean(props[storeKey]);
	        _this.setWrappedInstance = _this.setWrappedInstance.bind((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
	        (0, _invariant.default)(_this.store, "Could not find \"" + storeKey + "\" in either the context or props of " + ("\"" + displayName + "\". Either wrap the root component in a <Provider>, ") + ("or explicitly pass \"" + storeKey + "\" as a prop to \"" + displayName + "\"."));
	
	        _this.initSelector();
	
	        _this.initSubscription();
	
	        return _this;
	      }
	
	      var _proto = Connect.prototype;
	
	      _proto.getChildContext = function getChildContext() {
	        var _ref3;
	
	        // If this component received store from props, its subscription should be transparent
	        // to any descendants receiving store+subscription from context; it passes along
	        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
	        // Connect to control ordering of notifications to flow top-down.
	        var subscription = this.propsMode ? null : this.subscription;
	        return _ref3 = {}, _ref3[subscriptionKey] = subscription || this.context[subscriptionKey], _ref3;
	      };
	
	      _proto.componentDidMount = function componentDidMount() {
	        if (!shouldHandleStateChanges) return; // componentWillMount fires during server side rendering, but componentDidMount and
	        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
	        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
	        // To handle the case where a child component may have triggered a state change by
	        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
	        // re-render.
	
	        this.subscription.trySubscribe();
	        this.selector.run(this.props);
	        if (this.selector.shouldComponentUpdate) this.forceUpdate();
	      }; // Note: this is renamed below to the UNSAFE_ version in React >=16.3.0
	
	
	      _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	        this.selector.run(nextProps);
	      };
	
	      _proto.shouldComponentUpdate = function shouldComponentUpdate() {
	        return this.selector.shouldComponentUpdate;
	      };
	
	      _proto.componentWillUnmount = function componentWillUnmount() {
	        if (this.subscription) this.subscription.tryUnsubscribe();
	        this.subscription = null;
	        this.notifyNestedSubs = noop;
	        this.store = null;
	        this.selector.run = noop;
	        this.selector.shouldComponentUpdate = false;
	      };
	
	      _proto.getWrappedInstance = function getWrappedInstance() {
	        (0, _invariant.default)(withRef, "To access the wrapped instance, you need to specify " + ("{ withRef: true } in the options argument of the " + methodName + "() call."));
	        return this.wrappedInstance;
	      };
	
	      _proto.setWrappedInstance = function setWrappedInstance(ref) {
	        this.wrappedInstance = ref;
	      };
	
	      _proto.initSelector = function initSelector() {
	        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
	        this.selector = makeSelectorStateful(sourceSelector, this.store);
	        this.selector.run(this.props);
	      };
	
	      _proto.initSubscription = function initSubscription() {
	        if (!shouldHandleStateChanges) return; // parentSub's source should match where store came from: props vs. context. A component
	        // connected to the store via props shouldn't use subscription from context, or vice versa.
	
	        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
	        this.subscription = new _Subscription.default(this.store, parentSub, this.onStateChange.bind(this)); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
	        // the middle of the notification loop, where `this.subscription` will then be null. An
	        // extra null check every change can be avoided by copying the method onto `this` and then
	        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
	        // listeners logic is changed to not call listeners that have been unsubscribed in the
	        // middle of the notification loop.
	
	        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
	      };
	
	      _proto.onStateChange = function onStateChange() {
	        this.selector.run(this.props);
	
	        if (!this.selector.shouldComponentUpdate) {
	          this.notifyNestedSubs();
	        } else {
	          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
	          this.setState(dummyState);
	        }
	      };
	
	      _proto.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
	        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
	        // needs to notify nested subs. Once called, it unimplements itself until further state
	        // changes occur. Doing it this way vs having a permanent `componentDidUpdate` that does
	        // a boolean check every time avoids an extra method call most of the time, resulting
	        // in some perf boost.
	        this.componentDidUpdate = undefined;
	        this.notifyNestedSubs();
	      };
	
	      _proto.isSubscribed = function isSubscribed() {
	        return Boolean(this.subscription) && this.subscription.isSubscribed();
	      };
	
	      _proto.addExtraProps = function addExtraProps(props) {
	        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props; // make a shallow copy so that fields added don't leak to the original selector.
	        // this is especially important for 'ref' since that's a reference back to the component
	        // instance. a singleton memoized selector would then be holding a reference to the
	        // instance, preventing the instance from being garbage collected, and that would be bad
	
	        var withExtras = (0, _extends2.default)({}, props);
	        if (withRef) withExtras.ref = this.setWrappedInstance;
	        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
	        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
	        return withExtras;
	      };
	
	      _proto.render = function render() {
	        var selector = this.selector;
	        selector.shouldComponentUpdate = false;
	
	        if (selector.error) {
	          throw selector.error;
	        } else {
	          return (0, _react.createElement)(WrappedComponent, this.addExtraProps(selector.props));
	        }
	      };
	
	      return Connect;
	    }(_react.Component);
	
	    if (prefixUnsafeLifecycleMethods) {
	      // Use UNSAFE_ event name where supported
	      Connect.prototype.UNSAFE_componentWillReceiveProps = Connect.prototype.componentWillReceiveProps;
	      delete Connect.prototype.componentWillReceiveProps;
	    }
	    /* eslint-enable react/no-deprecated */
	
	
	    Connect.WrappedComponent = WrappedComponent;
	    Connect.displayName = displayName;
	    Connect.childContextTypes = childContextTypes;
	    Connect.contextTypes = contextTypes;
	    Connect.propTypes = contextTypes;
	
	    if (false) {
	      // Use UNSAFE_ event name where supported
	      var eventName = prefixUnsafeLifecycleMethods ? 'UNSAFE_componentWillUpdate' : 'componentWillUpdate';
	
	      Connect.prototype[eventName] = function componentWillUpdate() {
	        var _this2 = this;
	
	        // We are hot reloading!
	        if (this.version !== version) {
	          this.version = version;
	          this.initSelector(); // If any connected descendants don't hot reload (and resubscribe in the process), their
	          // listeners will be lost when we unsubscribe. Unfortunately, by copying over all
	          // listeners, this does mean that the old versions of connected descendants will still be
	          // notified of state changes; however, their onStateChange function is a no-op so this
	          // isn't a huge deal.
	
	          var oldListeners = [];
	
	          if (this.subscription) {
	            oldListeners = this.subscription.listeners.get();
	            this.subscription.tryUnsubscribe();
	          }
	
	          this.initSubscription();
	
	          if (shouldHandleStateChanges) {
	            this.subscription.trySubscribe();
	            oldListeners.forEach(function (listener) {
	              return _this2.subscription.listeners.subscribe(listener);
	            });
	          }
	        }
	      };
	    }
	
	    return (0, _hoistNonReactStatics.default)(Connect, WrappedComponent);
	  };
	}

/***/ },
/* 532 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports.wrapMapToPropsConstant = wrapMapToPropsConstant;
	exports.getDependsOnOwnProps = getDependsOnOwnProps;
	exports.wrapMapToPropsFunc = wrapMapToPropsFunc;
	
	var _verifyPlainObject = _interopRequireDefault(__webpack_require__(534));
	
	function wrapMapToPropsConstant(getConstant) {
	  return function initConstantSelector(dispatch, options) {
	    var constant = getConstant(dispatch, options);
	
	    function constantSelector() {
	      return constant;
	    }
	
	    constantSelector.dependsOnOwnProps = false;
	    return constantSelector;
	  };
	} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
	// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
	// whether mapToProps needs to be invoked when props have changed.
	// 
	// A length of one signals that mapToProps does not depend on props from the parent component.
	// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
	// therefore not reporting its length accurately..
	
	
	function getDependsOnOwnProps(mapToProps) {
	  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
	} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
	// this function wraps mapToProps in a proxy function which does several things:
	// 
	//  * Detects whether the mapToProps function being called depends on props, which
	//    is used by selectorFactory to decide if it should reinvoke on props changes.
	//    
	//  * On first call, handles mapToProps if returns another function, and treats that
	//    new function as the true mapToProps for subsequent calls.
	//    
	//  * On first call, verifies the first result is a plain object, in order to warn
	//    the developer that their mapToProps function is not returning a valid result.
	//    
	
	
	function wrapMapToPropsFunc(mapToProps, methodName) {
	  return function initProxySelector(dispatch, _ref) {
	    var displayName = _ref.displayName;
	
	    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
	      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
	    }; // allow detectFactoryAndVerify to get ownProps
	
	
	    proxy.dependsOnOwnProps = true;
	
	    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
	      proxy.mapToProps = mapToProps;
	      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
	      var props = proxy(stateOrDispatch, ownProps);
	
	      if (typeof props === 'function') {
	        proxy.mapToProps = props;
	        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
	        props = proxy(stateOrDispatch, ownProps);
	      }
	
	      if (false) (0, _verifyPlainObject.default)(props, displayName, methodName);
	      return props;
	    };
	
	    return proxy;
	  };
	}

/***/ },
/* 533 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports.storeShape = exports.subscriptionShape = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var subscriptionShape = _propTypes.default.shape({
	  trySubscribe: _propTypes.default.func.isRequired,
	  tryUnsubscribe: _propTypes.default.func.isRequired,
	  notifyNestedSubs: _propTypes.default.func.isRequired,
	  isSubscribed: _propTypes.default.func.isRequired
	});
	
	exports.subscriptionShape = subscriptionShape;
	
	var storeShape = _propTypes.default.shape({
	  subscribe: _propTypes.default.func.isRequired,
	  dispatch: _propTypes.default.func.isRequired,
	  getState: _propTypes.default.func.isRequired
	});
	
	exports.storeShape = storeShape;

/***/ },
/* 534 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports.default = verifyPlainObject;
	
	var _isPlainObject = _interopRequireDefault(__webpack_require__(1882));
	
	var _warning = _interopRequireDefault(__webpack_require__(315));
	
	function verifyPlainObject(value, displayName, methodName) {
	  if (!(0, _isPlainObject.default)(value)) {
	    (0, _warning.default)(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
	  }
	}

/***/ },
/* 535 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var isModifiedEvent = function isModifiedEvent(event) {
	  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
	};
	
	/**
	 * The public API for rendering a history-aware <a>.
	 */
	
	var Link = function (_React$Component) {
	  _inherits(Link, _React$Component);
	
	  function Link() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Link);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
	      if (_this.props.onClick) _this.props.onClick(event);
	
	      if (!event.defaultPrevented && // onClick prevented default
	      event.button === 0 && // ignore right clicks
	      !_this.props.target && // let browser handle "target=_blank" etc.
	      !isModifiedEvent(event) // ignore clicks with modifier keys
	      ) {
	          event.preventDefault();
	
	          var history = _this.context.router.history;
	          var _this$props = _this.props,
	              replace = _this$props.replace,
	              to = _this$props.to;
	
	
	          if (replace) {
	            history.replace(to);
	          } else {
	            history.push(to);
	          }
	        }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Link.prototype.render = function render() {
	    var _props = this.props,
	        replace = _props.replace,
	        to = _props.to,
	        props = _objectWithoutProperties(_props, ['replace', 'to']); // eslint-disable-line no-unused-vars
	
	    var href = this.context.router.history.createHref(typeof to === 'string' ? { pathname: to } : to);
	
	    return _react2.default.createElement('a', _extends({}, props, { onClick: this.handleClick, href: href }));
	  };
	
	  return Link;
	}(_react2.default.Component);
	
	Link.propTypes = {
	  onClick: _propTypes2.default.func,
	  target: _propTypes2.default.string,
	  replace: _propTypes2.default.bool,
	  to: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]).isRequired
	};
	Link.defaultProps = {
	  replace: false
	};
	Link.contextTypes = {
	  router: _propTypes2.default.shape({
	    history: _propTypes2.default.shape({
	      push: _propTypes2.default.func.isRequired,
	      replace: _propTypes2.default.func.isRequired,
	      createHref: _propTypes2.default.func.isRequired
	    }).isRequired
	  }).isRequired
	};
	exports.default = Link;

/***/ },
/* 536 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var printWarning = function() {};
	
	if (false) {
	  printWarning = function(format, subs) {
	    var index = 0;
	    var message =
	      'Warning: ' +
	      (subs.length > 0
	        ? format.replace(/%s/g, function() {
	            return subs[index++];
	          })
	        : format);
	
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	
	    try {
	      // --- Welcome to debugging history ---
	      // This error was thrown as a convenience so that you can use the
	      // stack trace to find the callsite that triggered this warning.
	      throw new Error(message);
	    } catch (e) {}
	  };
	}
	
	module.exports = function(member) {
	  printWarning(
	    'Please use `require("history").%s` instead of `require("history/%s")`. ' +
	      'Support for the latter will be removed in the next major release.',
	    [member, member]
	  );
	};


/***/ },
/* 537 */
[2191, 1899],
/* 538 */
[2194, 134, 317],
/* 539 */
[2198, 537],
/* 540 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	/**
	 * This action type will be dispatched by the history actions below.
	 * If you're writing a middleware to watch for navigation events, be sure to
	 * look for actions of this type.
	 */
	var CALL_HISTORY_METHOD = exports.CALL_HISTORY_METHOD = '@@router/CALL_HISTORY_METHOD';
	
	function updateLocation(method) {
	  return function () {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return {
	      type: CALL_HISTORY_METHOD,
	      payload: { method: method, args: args }
	    };
	  };
	}
	
	/**
	 * These actions correspond to the history API.
	 * The associated routerMiddleware will capture these events before they get to
	 * your reducer and reissue them as the matching function on your history.
	 */
	var push = exports.push = updateLocation('push');
	var replace = exports.replace = updateLocation('replace');
	var go = exports.go = updateLocation('go');
	var goBack = exports.goBack = updateLocation('goBack');
	var goForward = exports.goForward = updateLocation('goForward');
	
	var routerActions = exports.routerActions = { push: push, replace: replace, go: go, goBack: goBack, goForward: goForward };

/***/ },
/* 541 */
[2191, 1915],
/* 542 */
[2194, 135, 320],
/* 543 */
[2198, 541],
/* 544 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.routerReducer = routerReducer;
	/**
	 * This action type will be dispatched when your history
	 * receives a location change.
	 */
	var LOCATION_CHANGE = exports.LOCATION_CHANGE = '@@router/LOCATION_CHANGE';
	
	var initialState = {
	  location: null
	};
	
	/**
	 * This reducer will update the state with the most recent location history
	 * has transitioned to. This may not be in sync with the router, particularly
	 * if you have asynchronously-loaded routes, so reading from and relying on
	 * this state is discouraged.
	 */
	function routerReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	
	  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      type = _ref.type,
	      payload = _ref.payload;
	
	  if (type === LOCATION_CHANGE) {
	    return _extends({}, state, { location: payload });
	  }
	
	  return state;
	}

/***/ },
/* 545 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = void 0;
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(4));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(46));
	
	var _reactLifecyclesCompat = __webpack_require__(523);
	
	var _PropTypes = __webpack_require__(1927);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	var UNMOUNTED = 'unmounted';
	exports.UNMOUNTED = UNMOUNTED;
	var EXITED = 'exited';
	exports.EXITED = EXITED;
	var ENTERING = 'entering';
	exports.ENTERING = ENTERING;
	var ENTERED = 'entered';
	exports.ENTERED = ENTERED;
	var EXITING = 'exiting';
	/**
	 * The Transition component lets you describe a transition from one component
	 * state to another _over time_ with a simple declarative API. Most commonly
	 * it's used to animate the mounting and unmounting of a component, but can also
	 * be used to describe in-place transition states as well.
	 *
	 * ---
	 *
	 * **Note**: `Transition` is a platform-agnostic base component. If you're using
	 * transitions in CSS, you'll probably want to use
	 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
	 * instead. It inherits all the features of `Transition`, but contains
	 * additional features necessary to play nice with CSS transitions (hence the
	 * name of the component).
	 *
	 * ---
	 *
	 * By default the `Transition` component does not alter the behavior of the
	 * component it renders, it only tracks "enter" and "exit" states for the
	 * components. It's up to you to give meaning and effect to those states. For
	 * example we can add styles to a component when it enters or exits:
	 *
	 * ```jsx
	 * import { Transition } from 'react-transition-group';
	 *
	 * const duration = 300;
	 *
	 * const defaultStyle = {
	 *   transition: `opacity ${duration}ms ease-in-out`,
	 *   opacity: 0,
	 * }
	 *
	 * const transitionStyles = {
	 *   entering: { opacity: 0 },
	 *   entered:  { opacity: 1 },
	 * };
	 *
	 * const Fade = ({ in: inProp }) => (
	 *   <Transition in={inProp} timeout={duration}>
	 *     {state => (
	 *       <div style={{
	 *         ...defaultStyle,
	 *         ...transitionStyles[state]
	 *       }}>
	 *         I'm a fade Transition!
	 *       </div>
	 *     )}
	 *   </Transition>
	 * );
	 * ```
	 *
	 * There are 4 main states a Transition can be in:
	 *  - `'entering'`
	 *  - `'entered'`
	 *  - `'exiting'`
	 *  - `'exited'`
	 *
	 * Transition state is toggled via the `in` prop. When `true` the component
	 * begins the "Enter" stage. During this stage, the component will shift from
	 * its current transition state, to `'entering'` for the duration of the
	 * transition and then to the `'entered'` stage once it's complete. Let's take
	 * the following example (we'll use the
	 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
	 *
	 * ```jsx
	 * function App() {
	 *   const [inProp, setInProp] = useState(false);
	 *   return (
	 *     <div>
	 *       <Transition in={inProp} timeout={500}>
	 *         {state => (
	 *           // ...
	 *         )}
	 *       </Transition>
	 *       <button onClick={() => setInProp(true)}>
	 *         Click to Enter
	 *       </button>
	 *     </div>
	 *   );
	 * }
	 * ```
	 *
	 * When the button is clicked the component will shift to the `'entering'` state
	 * and stay there for 500ms (the value of `timeout`) before it finally switches
	 * to `'entered'`.
	 *
	 * When `in` is `false` the same thing happens except the state moves from
	 * `'exiting'` to `'exited'`.
	 */
	
	exports.EXITING = EXITING;
	
	var Transition =
	/*#__PURE__*/
	function (_React$Component) {
	  _inheritsLoose(Transition, _React$Component);
	
	  function Transition(props, context) {
	    var _this;
	
	    _this = _React$Component.call(this, props, context) || this;
	    var parentGroup = context.transitionGroup; // In the context of a TransitionGroup all enters are really appears
	
	    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
	    var initialStatus;
	    _this.appearStatus = null;
	
	    if (props.in) {
	      if (appear) {
	        initialStatus = EXITED;
	        _this.appearStatus = ENTERING;
	      } else {
	        initialStatus = ENTERED;
	      }
	    } else {
	      if (props.unmountOnExit || props.mountOnEnter) {
	        initialStatus = UNMOUNTED;
	      } else {
	        initialStatus = EXITED;
	      }
	    }
	
	    _this.state = {
	      status: initialStatus
	    };
	    _this.nextCallback = null;
	    return _this;
	  }
	
	  var _proto = Transition.prototype;
	
	  _proto.getChildContext = function getChildContext() {
	    return {
	      transitionGroup: null // allows for nested Transitions
	
	    };
	  };
	
	  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
	    var nextIn = _ref.in;
	
	    if (nextIn && prevState.status === UNMOUNTED) {
	      return {
	        status: EXITED
	      };
	    }
	
	    return null;
	  }; // getSnapshotBeforeUpdate(prevProps) {
	  //   let nextStatus = null
	  //   if (prevProps !== this.props) {
	  //     const { status } = this.state
	  //     if (this.props.in) {
	  //       if (status !== ENTERING && status !== ENTERED) {
	  //         nextStatus = ENTERING
	  //       }
	  //     } else {
	  //       if (status === ENTERING || status === ENTERED) {
	  //         nextStatus = EXITING
	  //       }
	  //     }
	  //   }
	  //   return { nextStatus }
	  // }
	
	
	  _proto.componentDidMount = function componentDidMount() {
	    this.updateStatus(true, this.appearStatus);
	  };
	
	  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var nextStatus = null;
	
	    if (prevProps !== this.props) {
	      var status = this.state.status;
	
	      if (this.props.in) {
	        if (status !== ENTERING && status !== ENTERED) {
	          nextStatus = ENTERING;
	        }
	      } else {
	        if (status === ENTERING || status === ENTERED) {
	          nextStatus = EXITING;
	        }
	      }
	    }
	
	    this.updateStatus(false, nextStatus);
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    this.cancelNextCallback();
	  };
	
	  _proto.getTimeouts = function getTimeouts() {
	    var timeout = this.props.timeout;
	    var exit, enter, appear;
	    exit = enter = appear = timeout;
	
	    if (timeout != null && typeof timeout !== 'number') {
	      exit = timeout.exit;
	      enter = timeout.enter; // TODO: remove fallback for next major
	
	      appear = timeout.appear !== undefined ? timeout.appear : enter;
	    }
	
	    return {
	      exit: exit,
	      enter: enter,
	      appear: appear
	    };
	  };
	
	  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
	    if (mounting === void 0) {
	      mounting = false;
	    }
	
	    if (nextStatus !== null) {
	      // nextStatus will always be ENTERING or EXITING.
	      this.cancelNextCallback();
	
	      var node = _reactDom.default.findDOMNode(this);
	
	      if (nextStatus === ENTERING) {
	        this.performEnter(node, mounting);
	      } else {
	        this.performExit(node);
	      }
	    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
	      this.setState({
	        status: UNMOUNTED
	      });
	    }
	  };
	
	  _proto.performEnter = function performEnter(node, mounting) {
	    var _this2 = this;
	
	    var enter = this.props.enter;
	    var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;
	    var timeouts = this.getTimeouts();
	    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
	    // if we are mounting and running this it means appear _must_ be set
	
	    if (!mounting && !enter) {
	      this.safeSetState({
	        status: ENTERED
	      }, function () {
	        _this2.props.onEntered(node);
	      });
	      return;
	    }
	
	    this.props.onEnter(node, appearing);
	    this.safeSetState({
	      status: ENTERING
	    }, function () {
	      _this2.props.onEntering(node, appearing);
	
	      _this2.onTransitionEnd(node, enterTimeout, function () {
	        _this2.safeSetState({
	          status: ENTERED
	        }, function () {
	          _this2.props.onEntered(node, appearing);
	        });
	      });
	    });
	  };
	
	  _proto.performExit = function performExit(node) {
	    var _this3 = this;
	
	    var exit = this.props.exit;
	    var timeouts = this.getTimeouts(); // no exit animation skip right to EXITED
	
	    if (!exit) {
	      this.safeSetState({
	        status: EXITED
	      }, function () {
	        _this3.props.onExited(node);
	      });
	      return;
	    }
	
	    this.props.onExit(node);
	    this.safeSetState({
	      status: EXITING
	    }, function () {
	      _this3.props.onExiting(node);
	
	      _this3.onTransitionEnd(node, timeouts.exit, function () {
	        _this3.safeSetState({
	          status: EXITED
	        }, function () {
	          _this3.props.onExited(node);
	        });
	      });
	    });
	  };
	
	  _proto.cancelNextCallback = function cancelNextCallback() {
	    if (this.nextCallback !== null) {
	      this.nextCallback.cancel();
	      this.nextCallback = null;
	    }
	  };
	
	  _proto.safeSetState = function safeSetState(nextState, callback) {
	    // This shouldn't be necessary, but there are weird race conditions with
	    // setState callbacks and unmounting in testing, so always make sure that
	    // we can cancel any pending setState callbacks after we unmount.
	    callback = this.setNextCallback(callback);
	    this.setState(nextState, callback);
	  };
	
	  _proto.setNextCallback = function setNextCallback(callback) {
	    var _this4 = this;
	
	    var active = true;
	
	    this.nextCallback = function (event) {
	      if (active) {
	        active = false;
	        _this4.nextCallback = null;
	        callback(event);
	      }
	    };
	
	    this.nextCallback.cancel = function () {
	      active = false;
	    };
	
	    return this.nextCallback;
	  };
	
	  _proto.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
	    this.setNextCallback(handler);
	    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
	
	    if (!node || doesNotHaveTimeoutOrListener) {
	      setTimeout(this.nextCallback, 0);
	      return;
	    }
	
	    if (this.props.addEndListener) {
	      this.props.addEndListener(node, this.nextCallback);
	    }
	
	    if (timeout != null) {
	      setTimeout(this.nextCallback, timeout);
	    }
	  };
	
	  _proto.render = function render() {
	    var status = this.state.status;
	
	    if (status === UNMOUNTED) {
	      return null;
	    }
	
	    var _this$props = this.props,
	        children = _this$props.children,
	        childProps = _objectWithoutPropertiesLoose(_this$props, ["children"]); // filter props for Transtition
	
	
	    delete childProps.in;
	    delete childProps.mountOnEnter;
	    delete childProps.unmountOnExit;
	    delete childProps.appear;
	    delete childProps.enter;
	    delete childProps.exit;
	    delete childProps.timeout;
	    delete childProps.addEndListener;
	    delete childProps.onEnter;
	    delete childProps.onEntering;
	    delete childProps.onEntered;
	    delete childProps.onExit;
	    delete childProps.onExiting;
	    delete childProps.onExited;
	
	    if (typeof children === 'function') {
	      return children(status, childProps);
	    }
	
	    var child = _react.default.Children.only(children);
	
	    return _react.default.cloneElement(child, childProps);
	  };
	
	  return Transition;
	}(_react.default.Component);
	
	Transition.contextTypes = {
	  transitionGroup: PropTypes.object
	};
	Transition.childContextTypes = {
	  transitionGroup: function transitionGroup() {}
	};
	Transition.propTypes =  false ? {
	  /**
	   * A `function` child can be used instead of a React element. This function is
	   * called with the current transition status (`'entering'`, `'entered'`,
	   * `'exiting'`, `'exited'`, `'unmounted'`), which can be used to apply context
	   * specific props to a component.
	   *
	   * ```jsx
	   * <Transition in={this.state.in} timeout={150}>
	   *   {state => (
	   *     <MyComponent className={`fade fade-${state}`} />
	   *   )}
	   * </Transition>
	   * ```
	   */
	  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,
	
	  /**
	   * Show the component; triggers the enter or exit states
	   */
	  in: PropTypes.bool,
	
	  /**
	   * By default the child component is mounted immediately along with
	   * the parent `Transition` component. If you want to "lazy mount" the component on the
	   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
	   * mounted, even on "exited", unless you also specify `unmountOnExit`.
	   */
	  mountOnEnter: PropTypes.bool,
	
	  /**
	   * By default the child component stays mounted after it reaches the `'exited'` state.
	   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
	   */
	  unmountOnExit: PropTypes.bool,
	
	  /**
	   * Normally a component is not transitioned if it is shown when the `<Transition>` component mounts.
	   * If you want to transition on the first mount set `appear` to `true`, and the
	   * component will transition in as soon as the `<Transition>` mounts.
	   *
	   * > Note: there are no specific "appear" states. `appear` only adds an additional `enter` transition.
	   */
	  appear: PropTypes.bool,
	
	  /**
	   * Enable or disable enter transitions.
	   */
	  enter: PropTypes.bool,
	
	  /**
	   * Enable or disable exit transitions.
	   */
	  exit: PropTypes.bool,
	
	  /**
	   * The duration of the transition, in milliseconds.
	   * Required unless `addEndListener` is provided.
	   *
	   * You may specify a single timeout for all transitions:
	   *
	   * ```jsx
	   * timeout={500}
	   * ```
	   *
	   * or individually:
	   *
	   * ```jsx
	   * timeout={{
	   *  appear: 500,
	   *  enter: 300,
	   *  exit: 500,
	   * }}
	   * ```
	   *
	   * - `appear` defaults to the value of `enter`
	   * - `enter` defaults to `0`
	   * - `exit` defaults to `0`
	   *
	   * @type {number | { enter?: number, exit?: number, appear?: number }}
	   */
	  timeout: function timeout(props) {
	    var pt = _PropTypes.timeoutsShape;
	    if (!props.addEndListener) pt = pt.isRequired;
	
	    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    return pt.apply(void 0, [props].concat(args));
	  },
	
	  /**
	   * Add a custom transition end trigger. Called with the transitioning
	   * DOM node and a `done` callback. Allows for more fine grained transition end
	   * logic. **Note:** Timeouts are still used as a fallback if provided.
	   *
	   * ```jsx
	   * addEndListener={(node, done) => {
	   *   // use the css transitionend event to mark the finish of a transition
	   *   node.addEventListener('transitionend', done, false);
	   * }}
	   * ```
	   */
	  addEndListener: PropTypes.func,
	
	  /**
	   * Callback fired before the "entering" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool) -> void
	   */
	  onEnter: PropTypes.func,
	
	  /**
	   * Callback fired after the "entering" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEntering: PropTypes.func,
	
	  /**
	   * Callback fired after the "entered" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool) -> void
	   */
	  onEntered: PropTypes.func,
	
	  /**
	   * Callback fired before the "exiting" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExit: PropTypes.func,
	
	  /**
	   * Callback fired after the "exiting" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExiting: PropTypes.func,
	
	  /**
	   * Callback fired after the "exited" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExited: PropTypes.func // Name the function so it is clearer in the documentation
	
	} : {};
	
	function noop() {}
	
	Transition.defaultProps = {
	  in: false,
	  mountOnEnter: false,
	  unmountOnExit: false,
	  appear: false,
	  enter: true,
	  exit: true,
	  onEnter: noop,
	  onEntering: noop,
	  onEntered: noop,
	  onExit: noop,
	  onExiting: noop,
	  onExited: noop
	};
	Transition.UNMOUNTED = 0;
	Transition.EXITED = 1;
	Transition.ENTERING = 2;
	Transition.ENTERED = 3;
	Transition.EXITING = 4;
	
	var _default = (0, _reactLifecyclesCompat.polyfill)(Transition);
	
	exports.default = _default;

/***/ },
/* 546 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports.isSubmissionError = isSubmissionError;
	exports.SubmissionError = void 0;
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(53));
	
	var _es6Error = _interopRequireDefault(__webpack_require__(1595));
	
	var __FLAG__ = '@@redux-form/submission-error-flag';
	
	var SubmissionError = /*#__PURE__*/function (_ExtendableError) {
	  (0, _inheritsLoose2["default"])(SubmissionError, _ExtendableError);
	
	  /** @private */
	  function SubmissionError(errors) {
	    var _this;
	
	    _this = _ExtendableError.call(this, 'Submit Validation Failed') || this;
	    _this.errors = errors;
	    return _this;
	  }
	
	  return SubmissionError;
	}(_es6Error["default"]);
	
	exports.SubmissionError = SubmissionError;
	SubmissionError.__FLAG__ = __FLAG__;
	
	function isSubmissionError(error) {
	  return (error && error.constructor && error.constructor.__FLAG__ === __FLAG__) === true;
	}

/***/ },
/* 547 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(35));
	
	var _actionTypes = __webpack_require__(321);
	
	var arrayInsert = function arrayInsert(form, field, index, value) {
	  return {
	    type: _actionTypes.ARRAY_INSERT,
	    meta: {
	      form: form,
	      field: field,
	      index: index
	    },
	    payload: value
	  };
	};
	
	var arrayMove = function arrayMove(form, field, from, to) {
	  return {
	    type: _actionTypes.ARRAY_MOVE,
	    meta: {
	      form: form,
	      field: field,
	      from: from,
	      to: to
	    }
	  };
	};
	
	var arrayPop = function arrayPop(form, field) {
	  return {
	    type: _actionTypes.ARRAY_POP,
	    meta: {
	      form: form,
	      field: field
	    }
	  };
	};
	
	var arrayPush = function arrayPush(form, field, value) {
	  return {
	    type: _actionTypes.ARRAY_PUSH,
	    meta: {
	      form: form,
	      field: field
	    },
	    payload: value
	  };
	};
	
	var arrayRemove = function arrayRemove(form, field, index) {
	  return {
	    type: _actionTypes.ARRAY_REMOVE,
	    meta: {
	      form: form,
	      field: field,
	      index: index
	    }
	  };
	};
	
	var arrayRemoveAll = function arrayRemoveAll(form, field) {
	  return {
	    type: _actionTypes.ARRAY_REMOVE_ALL,
	    meta: {
	      form: form,
	      field: field
	    }
	  };
	};
	
	var arrayShift = function arrayShift(form, field) {
	  return {
	    type: _actionTypes.ARRAY_SHIFT,
	    meta: {
	      form: form,
	      field: field
	    }
	  };
	};
	
	var arraySplice = function arraySplice(form, field, index, removeNum, value) {
	  var action = {
	    type: _actionTypes.ARRAY_SPLICE,
	    meta: {
	      form: form,
	      field: field,
	      index: index,
	      removeNum: removeNum
	    }
	  };
	
	  if (value !== undefined) {
	    action.payload = value;
	  }
	
	  return action;
	};
	
	var arraySwap = function arraySwap(form, field, indexA, indexB) {
	  if (indexA === indexB) {
	    throw new Error('Swap indices cannot be equal');
	  }
	
	  if (indexA < 0 || indexB < 0) {
	    throw new Error('Swap indices cannot be negative');
	  }
	
	  return {
	    type: _actionTypes.ARRAY_SWAP,
	    meta: {
	      form: form,
	      field: field,
	      indexA: indexA,
	      indexB: indexB
	    }
	  };
	};
	
	var arrayUnshift = function arrayUnshift(form, field, value) {
	  return {
	    type: _actionTypes.ARRAY_UNSHIFT,
	    meta: {
	      form: form,
	      field: field
	    },
	    payload: value
	  };
	};
	
	var autofill = function autofill(form, field, value) {
	  return {
	    type: _actionTypes.AUTOFILL,
	    meta: {
	      form: form,
	      field: field
	    },
	    payload: value
	  };
	};
	
	var blur = function blur(form, field, value, touch) {
	  return {
	    type: _actionTypes.BLUR,
	    meta: {
	      form: form,
	      field: field,
	      touch: touch
	    },
	    payload: value
	  };
	};
	
	var change = function change(form, field, value, touch, persistentSubmitErrors) {
	  return {
	    type: _actionTypes.CHANGE,
	    meta: {
	      form: form,
	      field: field,
	      touch: touch,
	      persistentSubmitErrors: persistentSubmitErrors
	    },
	    payload: value
	  };
	};
	
	var clearSubmit = function clearSubmit(form) {
	  return {
	    type: _actionTypes.CLEAR_SUBMIT,
	    meta: {
	      form: form
	    }
	  };
	};
	
	var clearSubmitErrors = function clearSubmitErrors(form) {
	  return {
	    type: _actionTypes.CLEAR_SUBMIT_ERRORS,
	    meta: {
	      form: form
	    }
	  };
	};
	
	var clearAsyncError = function clearAsyncError(form, field) {
	  return {
	    type: _actionTypes.CLEAR_ASYNC_ERROR,
	    meta: {
	      form: form,
	      field: field
	    }
	  };
	};
	
	var clearFields = function clearFields(form, keepTouched, persistentSubmitErrors) {
	  for (var _len = arguments.length, fields = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
	    fields[_key - 3] = arguments[_key];
	  }
	
	  return {
	    type: _actionTypes.CLEAR_FIELDS,
	    meta: {
	      form: form,
	      keepTouched: keepTouched,
	      persistentSubmitErrors: persistentSubmitErrors,
	      fields: fields
	    }
	  };
	};
	
	var destroy = function destroy() {
	  for (var _len2 = arguments.length, form = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	    form[_key2] = arguments[_key2];
	  }
	
	  return {
	    type: _actionTypes.DESTROY,
	    meta: {
	      form: form
	    }
	  };
	};
	
	var focus = function focus(form, field) {
	  return {
	    type: _actionTypes.FOCUS,
	    meta: {
	      form: form,
	      field: field
	    }
	  };
	};
	
	var initialize = function initialize(form, values, keepDirty, otherMeta) {
	  if (otherMeta === void 0) {
	    otherMeta = {};
	  }
	
	  if (keepDirty instanceof Object) {
	    otherMeta = keepDirty;
	    keepDirty = false;
	  }
	
	  return {
	    type: _actionTypes.INITIALIZE,
	    meta: (0, _extends2["default"])({
	      form: form,
	      keepDirty: keepDirty
	    }, otherMeta),
	    payload: values
	  };
	};
	
	var registerField = function registerField(form, name, type) {
	  return {
	    type: _actionTypes.REGISTER_FIELD,
	    meta: {
	      form: form
	    },
	    payload: {
	      name: name,
	      type: type
	    }
	  };
	};
	
	var reset = function reset(form) {
	  return {
	    type: _actionTypes.RESET,
	    meta: {
	      form: form
	    }
	  };
	};
	
	var resetSection = function resetSection(form) {
	  for (var _len3 = arguments.length, sections = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
	    sections[_key3 - 1] = arguments[_key3];
	  }
	
	  return {
	    type: _actionTypes.RESET_SECTION,
	    meta: {
	      form: form,
	      sections: sections
	    }
	  };
	};
	
	var startAsyncValidation = function startAsyncValidation(form, field) {
	  return {
	    type: _actionTypes.START_ASYNC_VALIDATION,
	    meta: {
	      form: form,
	      field: field
	    }
	  };
	};
	
	var startSubmit = function startSubmit(form) {
	  return {
	    type: _actionTypes.START_SUBMIT,
	    meta: {
	      form: form
	    }
	  };
	};
	
	var stopAsyncValidation = function stopAsyncValidation(form, errors) {
	  return {
	    type: _actionTypes.STOP_ASYNC_VALIDATION,
	    meta: {
	      form: form
	    },
	    payload: errors,
	    error: !!(errors && Object.keys(errors).length)
	  };
	};
	
	var stopSubmit = function stopSubmit(form, errors) {
	  return {
	    type: _actionTypes.STOP_SUBMIT,
	    meta: {
	      form: form
	    },
	    payload: errors,
	    error: !!(errors && Object.keys(errors).length)
	  };
	};
	
	var submit = function submit(form) {
	  return {
	    type: _actionTypes.SUBMIT,
	    meta: {
	      form: form
	    }
	  };
	};
	
	var setSubmitFailed = function setSubmitFailed(form) {
	  for (var _len4 = arguments.length, fields = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
	    fields[_key4 - 1] = arguments[_key4];
	  }
	
	  return {
	    type: _actionTypes.SET_SUBMIT_FAILED,
	    meta: {
	      form: form,
	      fields: fields
	    },
	    error: true
	  };
	};
	
	var setSubmitSucceeded = function setSubmitSucceeded(form) {
	  for (var _len5 = arguments.length, fields = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
	    fields[_key5 - 1] = arguments[_key5];
	  }
	
	  return {
	    type: _actionTypes.SET_SUBMIT_SUCCEEDED,
	    meta: {
	      form: form,
	      fields: fields
	    },
	    error: false
	  };
	};
	
	var touch = function touch(form) {
	  for (var _len6 = arguments.length, fields = new Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++) {
	    fields[_key6 - 1] = arguments[_key6];
	  }
	
	  return {
	    type: _actionTypes.TOUCH,
	    meta: {
	      form: form,
	      fields: fields
	    }
	  };
	};
	
	var unregisterField = function unregisterField(form, name, destroyOnUnmount) {
	  if (destroyOnUnmount === void 0) {
	    destroyOnUnmount = true;
	  }
	
	  return {
	    type: _actionTypes.UNREGISTER_FIELD,
	    meta: {
	      form: form
	    },
	    payload: {
	      name: name,
	      destroyOnUnmount: destroyOnUnmount
	    }
	  };
	};
	
	var untouch = function untouch(form) {
	  for (var _len7 = arguments.length, fields = new Array(_len7 > 1 ? _len7 - 1 : 0), _key7 = 1; _key7 < _len7; _key7++) {
	    fields[_key7 - 1] = arguments[_key7];
	  }
	
	  return {
	    type: _actionTypes.UNTOUCH,
	    meta: {
	      form: form,
	      fields: fields
	    }
	  };
	};
	
	var updateSyncErrors = function updateSyncErrors(form, syncErrors, error) {
	  if (syncErrors === void 0) {
	    syncErrors = {};
	  }
	
	  return {
	    type: _actionTypes.UPDATE_SYNC_ERRORS,
	    meta: {
	      form: form
	    },
	    payload: {
	      syncErrors: syncErrors,
	      error: error
	    }
	  };
	};
	
	var updateSyncWarnings = function updateSyncWarnings(form, syncWarnings, warning) {
	  if (syncWarnings === void 0) {
	    syncWarnings = {};
	  }
	
	  return {
	    type: _actionTypes.UPDATE_SYNC_WARNINGS,
	    meta: {
	      form: form
	    },
	    payload: {
	      syncWarnings: syncWarnings,
	      warning: warning
	    }
	  };
	};
	
	var actions = {
	  arrayInsert: arrayInsert,
	  arrayMove: arrayMove,
	  arrayPop: arrayPop,
	  arrayPush: arrayPush,
	  arrayRemove: arrayRemove,
	  arrayRemoveAll: arrayRemoveAll,
	  arrayShift: arrayShift,
	  arraySplice: arraySplice,
	  arraySwap: arraySwap,
	  arrayUnshift: arrayUnshift,
	  autofill: autofill,
	  blur: blur,
	  change: change,
	  clearFields: clearFields,
	  clearSubmit: clearSubmit,
	  clearSubmitErrors: clearSubmitErrors,
	  clearAsyncError: clearAsyncError,
	  destroy: destroy,
	  focus: focus,
	  initialize: initialize,
	  registerField: registerField,
	  reset: reset,
	  resetSection: resetSection,
	  startAsyncValidation: startAsyncValidation,
	  startSubmit: startSubmit,
	  stopAsyncValidation: stopAsyncValidation,
	  stopSubmit: stopSubmit,
	  submit: submit,
	  setSubmitFailed: setSubmitFailed,
	  setSubmitSucceeded: setSubmitSucceeded,
	  touch: touch,
	  unregisterField: unregisterField,
	  untouch: untouch,
	  updateSyncErrors: updateSyncErrors,
	  updateSyncWarnings: updateSyncWarnings
	};
	var _default = actions;
	exports["default"] = _default;

/***/ },
/* 548 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports["default"] = createFieldProps;
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(43));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(35));
	
	var processProps = function processProps(type, props, _value, deepEqual) {
	  var value = props.value;
	
	  if (type === 'checkbox') {
	    return (0, _extends2["default"])({}, props, {
	      checked: !!value
	    });
	  }
	
	  if (type === 'radio') {
	    return (0, _extends2["default"])({}, props, {
	      checked: deepEqual(value, _value),
	      value: _value
	    });
	  }
	
	  if (type === 'select-multiple') {
	    return (0, _extends2["default"])({}, props, {
	      value: value || []
	    });
	  }
	
	  if (type === 'file') {
	    return (0, _extends2["default"])({}, props, {
	      value: value || undefined
	    });
	  }
	
	  return props;
	};
	
	function createFieldProps(_ref, name, _ref2) {
	  var getIn = _ref.getIn,
	      toJS = _ref.toJS,
	      deepEqual = _ref.deepEqual;
	  var asyncError = _ref2.asyncError,
	      asyncValidating = _ref2.asyncValidating,
	      onBlur = _ref2.onBlur,
	      onChange = _ref2.onChange,
	      onDrop = _ref2.onDrop,
	      onDragStart = _ref2.onDragStart,
	      dirty = _ref2.dirty,
	      dispatch = _ref2.dispatch,
	      onFocus = _ref2.onFocus,
	      form = _ref2.form,
	      format = _ref2.format,
	      initial = _ref2.initial,
	      parse = _ref2.parse,
	      pristine = _ref2.pristine,
	      props = _ref2.props,
	      state = _ref2.state,
	      submitError = _ref2.submitError,
	      submitFailed = _ref2.submitFailed,
	      submitting = _ref2.submitting,
	      syncError = _ref2.syncError,
	      syncWarning = _ref2.syncWarning,
	      validate = _ref2.validate,
	      value = _ref2.value,
	      _value = _ref2._value,
	      warn = _ref2.warn,
	      custom = (0, _objectWithoutPropertiesLoose2["default"])(_ref2, ["asyncError", "asyncValidating", "onBlur", "onChange", "onDrop", "onDragStart", "dirty", "dispatch", "onFocus", "form", "format", "initial", "parse", "pristine", "props", "state", "submitError", "submitFailed", "submitting", "syncError", "syncWarning", "validate", "value", "_value", "warn"]);
	  var error = syncError || asyncError || submitError;
	  var warning = syncWarning;
	
	  var formatFieldValue = function formatFieldValue(value, format) {
	    if (format === null) {
	      return value;
	    }
	
	    var defaultFormattedValue = value == null ? '' : value;
	    return format ? format(value, name) : defaultFormattedValue;
	  };
	
	  var formattedFieldValue = formatFieldValue(value, format);
	  return {
	    input: processProps(custom.type, {
	      name: name,
	      onBlur: onBlur,
	      onChange: onChange,
	      onDragStart: onDragStart,
	      onDrop: onDrop,
	      onFocus: onFocus,
	      value: formattedFieldValue
	    }, _value, deepEqual),
	    meta: (0, _extends2["default"])({}, toJS(state), {
	      active: !!(state && getIn(state, 'active')),
	      asyncValidating: asyncValidating,
	      autofilled: !!(state && getIn(state, 'autofilled')),
	      dirty: dirty,
	      dispatch: dispatch,
	      error: error,
	      form: form,
	      initial: initial,
	      warning: warning,
	      invalid: !!error,
	      pristine: pristine,
	      submitting: !!submitting,
	      submitFailed: !!submitFailed,
	      touched: !!(state && getIn(state, 'touched')),
	      valid: !error,
	      visited: !!(state && getIn(state, 'visited'))
	    }),
	    custom: (0, _extends2["default"])({}, custom, {}, props)
	  };
	}

/***/ },
/* 549 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var defaultShouldAsyncValidate = function defaultShouldAsyncValidate(_ref) {
	  var initialized = _ref.initialized,
	      trigger = _ref.trigger,
	      pristine = _ref.pristine,
	      syncValidationPasses = _ref.syncValidationPasses;
	
	  if (!syncValidationPasses) {
	    return false;
	  }
	
	  switch (trigger) {
	    case 'blur':
	    case 'change':
	      // blurring
	      return true;
	
	    case 'submit':
	      // submitting, so only async validate if form is dirty or was never initialized
	      // conversely, DON'T async validate if the form is pristine just as it was initialized
	      return !pristine || !initialized;
	
	    default:
	      return false;
	  }
	};
	
	var _default = defaultShouldAsyncValidate;
	exports["default"] = _default;

/***/ },
/* 550 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var defaultShouldError = function defaultShouldError(_ref) {
	  var values = _ref.values,
	      nextProps = _ref.nextProps,
	      initialRender = _ref.initialRender,
	      lastFieldValidatorKeys = _ref.lastFieldValidatorKeys,
	      fieldValidatorKeys = _ref.fieldValidatorKeys,
	      structure = _ref.structure;
	
	  if (initialRender) {
	    return true;
	  }
	
	  return !structure.deepEqual(values, nextProps && nextProps.values) || !structure.deepEqual(lastFieldValidatorKeys, fieldValidatorKeys);
	};
	
	var _default = defaultShouldError;
	exports["default"] = _default;

/***/ },
/* 551 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var defaultShouldValidate = function defaultShouldValidate(_ref) {
	  var values = _ref.values,
	      nextProps = _ref.nextProps,
	      initialRender = _ref.initialRender,
	      lastFieldValidatorKeys = _ref.lastFieldValidatorKeys,
	      fieldValidatorKeys = _ref.fieldValidatorKeys,
	      structure = _ref.structure;
	
	  if (initialRender) {
	    return true;
	  }
	
	  return !structure.deepEqual(values, nextProps && nextProps.values) || !structure.deepEqual(lastFieldValidatorKeys, fieldValidatorKeys);
	};
	
	var _default = defaultShouldValidate;
	exports["default"] = _default;

/***/ },
/* 552 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var defaultShouldWarn = function defaultShouldWarn(_ref) {
	  var values = _ref.values,
	      nextProps = _ref.nextProps,
	      initialRender = _ref.initialRender,
	      lastFieldValidatorKeys = _ref.lastFieldValidatorKeys,
	      fieldValidatorKeys = _ref.fieldValidatorKeys,
	      structure = _ref.structure;
	
	  if (initialRender) {
	    return true;
	  }
	
	  return !structure.deepEqual(values, nextProps && nextProps.values) || !structure.deepEqual(lastFieldValidatorKeys, fieldValidatorKeys);
	};
	
	var _default = defaultShouldWarn;
	exports["default"] = _default;

/***/ },
/* 553 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _getValue = _interopRequireDefault(__webpack_require__(1950));
	
	var _isReactNative = _interopRequireDefault(__webpack_require__(555));
	
	var onChangeValue = function onChangeValue(event, _ref) {
	  var name = _ref.name,
	      parse = _ref.parse,
	      normalize = _ref.normalize;
	  // read value from input
	  var value = (0, _getValue["default"])(event, _isReactNative["default"]); // parse value if we have a parser
	
	  if (parse) {
	    value = parse(value, name);
	  } // normalize value
	
	
	  if (normalize) {
	    value = normalize(name, value);
	  }
	
	  return value;
	};
	
	var _default = onChangeValue;
	exports["default"] = _default;

/***/ },
/* 554 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _isEvent = _interopRequireDefault(__webpack_require__(322));
	
	var silenceEvent = function silenceEvent(event) {
	  var is = (0, _isEvent["default"])(event);
	
	  if (is) {
	    event.preventDefault();
	  }
	
	  return is;
	};
	
	var _default = silenceEvent;
	exports["default"] = _default;

/***/ },
/* 555 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	var isReactNative = typeof window !== 'undefined' && window.navigator && window.navigator.product && window.navigator.product === 'ReactNative';
	var _default = isReactNative;
	exports["default"] = _default;

/***/ },
/* 556 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = createIsPristine;
	
	function createIsPristine(_ref) {
	  var deepEqual = _ref.deepEqual,
	      empty = _ref.empty,
	      getIn = _ref.getIn;
	  return function (form, getFormState) {
	    return function (state) {
	      var nonNullGetFormState = getFormState || function (state) {
	        return getIn(state, 'form');
	      };
	
	      var formState = nonNullGetFormState(state);
	
	      for (var _len = arguments.length, fields = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        fields[_key - 1] = arguments[_key];
	      }
	
	      if (fields && fields.length) {
	        return fields.every(function (field) {
	          var fieldInitial = getIn(formState, form + ".initial." + field);
	          var fieldValue = getIn(formState, form + ".values." + field);
	          return deepEqual(fieldInitial, fieldValue);
	        });
	      }
	
	      var initial = getIn(formState, form + ".initial") || empty;
	      var values = getIn(formState, form + ".values") || initial;
	      return deepEqual(initial, values);
	    };
	  };
	}

/***/ },
/* 557 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _isEqualWith2 = _interopRequireDefault(__webpack_require__(494));
	
	var customizer = function customizer(objectValue, otherValue, indexOrkey, object, other, stack) {
	  // https://lodash.com/docs/4.17.4#isEqualWith
	  if (stack) {
	    // Shallow compares
	    // For 1st level, stack === undefined.
	    //   -> Do nothing (and implicitly return undefined so that it goes to compare 2nd level)
	    // For 2nd level and up, stack !== undefined.
	    //   -> Compare by === operator
	    return objectValue === otherValue;
	  }
	};
	
	var shallowCompare = function shallowCompare(instance, nextProps, nextState) {
	  var propsEqual = (0, _isEqualWith2["default"])(instance.props, nextProps, customizer);
	  var stateEqual = (0, _isEqualWith2["default"])(instance.state, nextState, customizer);
	  return !propsEqual || !stateEqual;
	};
	
	var _default = shallowCompare;
	exports["default"] = _default;

/***/ },
/* 558 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var repeat = exports.repeat = function repeat(str, times) {
	  return new Array(times + 1).join(str);
	};
	
	var pad = exports.pad = function pad(num, maxLength) {
	  return repeat("0", maxLength - num.toString().length) + num;
	};
	
	var formatTime = exports.formatTime = function formatTime(time) {
	  return pad(time.getHours(), 2) + ":" + pad(time.getMinutes(), 2) + ":" + pad(time.getSeconds(), 2) + "." + pad(time.getMilliseconds(), 3);
	};
	
	// Use performance API if it's available in order to get better precision
	var timer = exports.timer = typeof performance !== "undefined" && performance !== null && typeof performance.now === "function" ? performance : Date;

/***/ },
/* 559 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        if (typeof b !== "function" && b !== null)
	            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.BehaviorSubject = void 0;
	var Subject_1 = __webpack_require__(51);
	var BehaviorSubject = (function (_super) {
	    __extends(BehaviorSubject, _super);
	    function BehaviorSubject(_value) {
	        var _this = _super.call(this) || this;
	        _this._value = _value;
	        return _this;
	    }
	    Object.defineProperty(BehaviorSubject.prototype, "value", {
	        get: function () {
	            return this.getValue();
	        },
	        enumerable: false,
	        configurable: true
	    });
	    BehaviorSubject.prototype._subscribe = function (subscriber) {
	        var subscription = _super.prototype._subscribe.call(this, subscriber);
	        !subscription.closed && subscriber.next(this._value);
	        return subscription;
	    };
	    BehaviorSubject.prototype.getValue = function () {
	        var _a = this, hasError = _a.hasError, thrownError = _a.thrownError, _value = _a._value;
	        if (hasError) {
	            throw thrownError;
	        }
	        this._throwIfClosed();
	        return _value;
	    };
	    BehaviorSubject.prototype.next = function (value) {
	        _super.prototype.next.call(this, (this._value = value));
	    };
	    return BehaviorSubject;
	}(Subject_1.Subject));
	exports.BehaviorSubject = BehaviorSubject;
	//# sourceMappingURL=BehaviorSubject.js.map

/***/ },
/* 560 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.Scheduler = void 0;
	var dateTimestampProvider_1 = __webpack_require__(335);
	var Scheduler = (function () {
	    function Scheduler(schedulerActionCtor, now) {
	        if (now === void 0) { now = Scheduler.now; }
	        this.schedulerActionCtor = schedulerActionCtor;
	        this.now = now;
	    }
	    Scheduler.prototype.schedule = function (work, delay, state) {
	        if (delay === void 0) { delay = 0; }
	        return new this.schedulerActionCtor(this, work).schedule(state, delay);
	    };
	    Scheduler.now = dateTimestampProvider_1.dateTimestampProvider.now;
	    return Scheduler;
	}());
	exports.Scheduler = Scheduler;
	//# sourceMappingURL=Scheduler.js.map

/***/ },
/* 561 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	var __spreadArray = (this && this.__spreadArray) || function (to, from) {
	    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
	        to[j] = from[i];
	    return to;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.bindCallbackInternals = void 0;
	var isScheduler_1 = __webpack_require__(231);
	var Observable_1 = __webpack_require__(34);
	var subscribeOn_1 = __webpack_require__(227);
	var mapOneOrManyArgs_1 = __webpack_require__(117);
	var observeOn_1 = __webpack_require__(226);
	var AsyncSubject_1 = __webpack_require__(324);
	function bindCallbackInternals(isNodeStyle, callbackFunc, resultSelector, scheduler) {
	    if (resultSelector) {
	        if (isScheduler_1.isScheduler(resultSelector)) {
	            scheduler = resultSelector;
	        }
	        else {
	            return function () {
	                var args = [];
	                for (var _i = 0; _i < arguments.length; _i++) {
	                    args[_i] = arguments[_i];
	                }
	                return bindCallbackInternals(isNodeStyle, callbackFunc, scheduler)
	                    .apply(this, args)
	                    .pipe(mapOneOrManyArgs_1.mapOneOrManyArgs(resultSelector));
	            };
	        }
	    }
	    if (scheduler) {
	        return function () {
	            var args = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                args[_i] = arguments[_i];
	            }
	            return bindCallbackInternals(isNodeStyle, callbackFunc)
	                .apply(this, args)
	                .pipe(subscribeOn_1.subscribeOn(scheduler), observeOn_1.observeOn(scheduler));
	        };
	    }
	    return function () {
	        var _this = this;
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        var subject = new AsyncSubject_1.AsyncSubject();
	        var uninitialized = true;
	        return new Observable_1.Observable(function (subscriber) {
	            var subs = subject.subscribe(subscriber);
	            if (uninitialized) {
	                uninitialized = false;
	                var isAsync_1 = false;
	                var isComplete_1 = false;
	                callbackFunc.apply(_this, __spreadArray(__spreadArray([], __read(args)), [
	                    function () {
	                        var results = [];
	                        for (var _i = 0; _i < arguments.length; _i++) {
	                            results[_i] = arguments[_i];
	                        }
	                        if (isNodeStyle) {
	                            var err = results.shift();
	                            if (err != null) {
	                                subject.error(err);
	                                return;
	                            }
	                        }
	                        subject.next(1 < results.length ? results : results[0]);
	                        isComplete_1 = true;
	                        if (isAsync_1) {
	                            subject.complete();
	                        }
	                    },
	                ]));
	                if (isComplete_1) {
	                    subject.complete();
	                }
	                isAsync_1 = true;
	            }
	            return subs;
	        });
	    };
	}
	exports.bindCallbackInternals = bindCallbackInternals;
	//# sourceMappingURL=bindCallbackInternals.js.map

/***/ },
/* 562 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.interval = void 0;
	var async_1 = __webpack_require__(63);
	var timer_1 = __webpack_require__(113);
	function interval(period, scheduler) {
	    if (period === void 0) { period = 0; }
	    if (scheduler === void 0) { scheduler = async_1.asyncScheduler; }
	    if (period < 0) {
	        period = 0;
	    }
	    return timer_1.timer(period, period, scheduler);
	}
	exports.interval = interval;
	//# sourceMappingURL=interval.js.map

/***/ },
/* 563 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.never = exports.NEVER = void 0;
	var Observable_1 = __webpack_require__(34);
	var noop_1 = __webpack_require__(52);
	exports.NEVER = new Observable_1.Observable(noop_1.noop);
	function never() {
	    return exports.NEVER;
	}
	exports.never = never;
	//# sourceMappingURL=never.js.map

/***/ },
/* 564 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.raceInit = exports.race = void 0;
	var Observable_1 = __webpack_require__(34);
	var innerFrom_1 = __webpack_require__(28);
	var argsOrArgArray_1 = __webpack_require__(137);
	var OperatorSubscriber_1 = __webpack_require__(20);
	function race() {
	    var sources = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        sources[_i] = arguments[_i];
	    }
	    sources = argsOrArgArray_1.argsOrArgArray(sources);
	    return sources.length === 1 ? innerFrom_1.innerFrom(sources[0]) : new Observable_1.Observable(raceInit(sources));
	}
	exports.race = race;
	function raceInit(sources) {
	    return function (subscriber) {
	        var subscriptions = [];
	        var _loop_1 = function (i) {
	            subscriptions.push(innerFrom_1.innerFrom(sources[i]).subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (value) {
	                if (subscriptions) {
	                    for (var s = 0; s < subscriptions.length; s++) {
	                        s !== i && subscriptions[s].unsubscribe();
	                    }
	                    subscriptions = null;
	                }
	                subscriber.next(value);
	            })));
	        };
	        for (var i = 0; subscriptions && !subscriber.closed && i < sources.length; i++) {
	            _loop_1(i);
	        }
	    };
	}
	exports.raceInit = raceInit;
	//# sourceMappingURL=race.js.map

/***/ },
/* 565 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.throwError = void 0;
	var Observable_1 = __webpack_require__(34);
	var isFunction_1 = __webpack_require__(31);
	function throwError(errorOrErrorFactory, scheduler) {
	    var errorFactory = isFunction_1.isFunction(errorOrErrorFactory) ? errorOrErrorFactory : function () { return errorOrErrorFactory; };
	    var init = function (subscriber) { return subscriber.error(errorFactory()); };
	    return new Observable_1.Observable(scheduler ? function (subscriber) { return scheduler.schedule(init, 0, subscriber); } : init);
	}
	exports.throwError = throwError;
	//# sourceMappingURL=throwError.js.map

/***/ },
/* 566 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.audit = void 0;
	var lift_1 = __webpack_require__(17);
	var innerFrom_1 = __webpack_require__(28);
	var OperatorSubscriber_1 = __webpack_require__(20);
	function audit(durationSelector) {
	    return lift_1.operate(function (source, subscriber) {
	        var hasValue = false;
	        var lastValue = null;
	        var durationSubscriber = null;
	        var isComplete = false;
	        var endDuration = function () {
	            durationSubscriber === null || durationSubscriber === void 0 ? void 0 : durationSubscriber.unsubscribe();
	            durationSubscriber = null;
	            if (hasValue) {
	                hasValue = false;
	                var value = lastValue;
	                lastValue = null;
	                subscriber.next(value);
	            }
	            isComplete && subscriber.complete();
	        };
	        var cleanupDuration = function () {
	            durationSubscriber = null;
	            isComplete && subscriber.complete();
	        };
	        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (value) {
	            hasValue = true;
	            lastValue = value;
	            if (!durationSubscriber) {
	                innerFrom_1.innerFrom(durationSelector(value)).subscribe((durationSubscriber = OperatorSubscriber_1.createOperatorSubscriber(subscriber, endDuration, cleanupDuration)));
	            }
	        }, function () {
	            isComplete = true;
	            (!hasValue || !durationSubscriber || durationSubscriber.closed) && subscriber.complete();
	        }));
	    });
	}
	exports.audit = audit;
	//# sourceMappingURL=audit.js.map

/***/ },
/* 567 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.combineLatestAll = void 0;
	var combineLatest_1 = __webpack_require__(327);
	var joinAllInternals_1 = __webpack_require__(574);
	function combineLatestAll(project) {
	    return joinAllInternals_1.joinAllInternals(combineLatest_1.combineLatest, project);
	}
	exports.combineLatestAll = combineLatestAll;
	//# sourceMappingURL=combineLatestAll.js.map

/***/ },
/* 568 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.concatMap = void 0;
	var mergeMap_1 = __webpack_require__(98);
	var isFunction_1 = __webpack_require__(31);
	function concatMap(project, resultSelector) {
	    return isFunction_1.isFunction(resultSelector) ? mergeMap_1.mergeMap(project, resultSelector, 1) : mergeMap_1.mergeMap(project, 1);
	}
	exports.concatMap = concatMap;
	//# sourceMappingURL=concatMap.js.map

/***/ },
/* 569 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.delayWhen = void 0;
	var concat_1 = __webpack_require__(222);
	var take_1 = __webpack_require__(167);
	var ignoreElements_1 = __webpack_require__(573);
	var mapTo_1 = __webpack_require__(575);
	var mergeMap_1 = __webpack_require__(98);
	function delayWhen(delayDurationSelector, subscriptionDelay) {
	    if (subscriptionDelay) {
	        return function (source) {
	            return concat_1.concat(subscriptionDelay.pipe(take_1.take(1), ignoreElements_1.ignoreElements()), source.pipe(delayWhen(delayDurationSelector)));
	        };
	    }
	    return mergeMap_1.mergeMap(function (value, index) { return delayDurationSelector(value, index).pipe(take_1.take(1), mapTo_1.mapTo(value)); });
	}
	exports.delayWhen = delayWhen;
	//# sourceMappingURL=delayWhen.js.map

/***/ },
/* 570 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.distinctUntilChanged = void 0;
	var identity_1 = __webpack_require__(56);
	var lift_1 = __webpack_require__(17);
	var OperatorSubscriber_1 = __webpack_require__(20);
	function distinctUntilChanged(comparator, keySelector) {
	    if (keySelector === void 0) { keySelector = identity_1.identity; }
	    comparator = comparator !== null && comparator !== void 0 ? comparator : defaultCompare;
	    return lift_1.operate(function (source, subscriber) {
	        var previousKey;
	        var first = true;
	        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (value) {
	            var currentKey = keySelector(value);
	            if (first || !comparator(previousKey, currentKey)) {
	                first = false;
	                previousKey = currentKey;
	                subscriber.next(value);
	            }
	        }));
	    });
	}
	exports.distinctUntilChanged = distinctUntilChanged;
	function defaultCompare(a, b) {
	    return a === b;
	}
	//# sourceMappingURL=distinctUntilChanged.js.map

/***/ },
/* 571 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.exhaustAll = void 0;
	var lift_1 = __webpack_require__(17);
	var innerFrom_1 = __webpack_require__(28);
	var OperatorSubscriber_1 = __webpack_require__(20);
	function exhaustAll() {
	    return lift_1.operate(function (source, subscriber) {
	        var isComplete = false;
	        var innerSub = null;
	        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (inner) {
	            if (!innerSub) {
	                innerSub = innerFrom_1.innerFrom(inner).subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, undefined, function () {
	                    innerSub = null;
	                    isComplete && subscriber.complete();
	                }));
	            }
	        }, function () {
	            isComplete = true;
	            !innerSub && subscriber.complete();
	        }));
	    });
	}
	exports.exhaustAll = exhaustAll;
	//# sourceMappingURL=exhaustAll.js.map

/***/ },
/* 572 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.createFind = exports.find = void 0;
	var lift_1 = __webpack_require__(17);
	var OperatorSubscriber_1 = __webpack_require__(20);
	function find(predicate, thisArg) {
	    return lift_1.operate(createFind(predicate, thisArg, 'value'));
	}
	exports.find = find;
	function createFind(predicate, thisArg, emit) {
	    var findIndex = emit === 'index';
	    return function (source, subscriber) {
	        var index = 0;
	        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (value) {
	            var i = index++;
	            if (predicate.call(thisArg, value, i, source)) {
	                subscriber.next(findIndex ? i : value);
	                subscriber.complete();
	            }
	        }, function () {
	            subscriber.next(findIndex ? -1 : undefined);
	            subscriber.complete();
	        }));
	    };
	}
	exports.createFind = createFind;
	//# sourceMappingURL=find.js.map

/***/ },
/* 573 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.ignoreElements = void 0;
	var lift_1 = __webpack_require__(17);
	var OperatorSubscriber_1 = __webpack_require__(20);
	var noop_1 = __webpack_require__(52);
	function ignoreElements() {
	    return lift_1.operate(function (source, subscriber) {
	        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, noop_1.noop));
	    });
	}
	exports.ignoreElements = ignoreElements;
	//# sourceMappingURL=ignoreElements.js.map

/***/ },
/* 574 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.joinAllInternals = void 0;
	var identity_1 = __webpack_require__(56);
	var mapOneOrManyArgs_1 = __webpack_require__(117);
	var pipe_1 = __webpack_require__(232);
	var mergeMap_1 = __webpack_require__(98);
	var toArray_1 = __webpack_require__(582);
	function joinAllInternals(joinFn, project) {
	    return pipe_1.pipe(toArray_1.toArray(), mergeMap_1.mergeMap(function (sources) { return joinFn(sources); }), project ? mapOneOrManyArgs_1.mapOneOrManyArgs(project) : identity_1.identity);
	}
	exports.joinAllInternals = joinAllInternals;
	//# sourceMappingURL=joinAllInternals.js.map

/***/ },
/* 575 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.mapTo = void 0;
	var map_1 = __webpack_require__(114);
	function mapTo(value) {
	    return map_1.map(function () { return value; });
	}
	exports.mapTo = mapTo;
	//# sourceMappingURL=mapTo.js.map

/***/ },
/* 576 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.refCount = void 0;
	var lift_1 = __webpack_require__(17);
	var OperatorSubscriber_1 = __webpack_require__(20);
	function refCount() {
	    return lift_1.operate(function (source, subscriber) {
	        var connection = null;
	        source._refCount++;
	        var refCounter = OperatorSubscriber_1.createOperatorSubscriber(subscriber, undefined, undefined, undefined, function () {
	            if (!source || source._refCount <= 0 || 0 < --source._refCount) {
	                connection = null;
	                return;
	            }
	            var sharedConnection = source._connection;
	            var conn = connection;
	            connection = null;
	            if (sharedConnection && (!conn || sharedConnection === conn)) {
	                sharedConnection.unsubscribe();
	            }
	            subscriber.unsubscribe();
	        });
	        source.subscribe(refCounter);
	        if (!refCounter.closed) {
	            connection = source.connect();
	        }
	    });
	}
	exports.refCount = refCount;
	//# sourceMappingURL=refCount.js.map

/***/ },
/* 577 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.sample = void 0;
	var lift_1 = __webpack_require__(17);
	var noop_1 = __webpack_require__(52);
	var OperatorSubscriber_1 = __webpack_require__(20);
	function sample(notifier) {
	    return lift_1.operate(function (source, subscriber) {
	        var hasValue = false;
	        var lastValue = null;
	        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (value) {
	            hasValue = true;
	            lastValue = value;
	        }));
	        notifier.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function () {
	            if (hasValue) {
	                hasValue = false;
	                var value = lastValue;
	                lastValue = null;
	                subscriber.next(value);
	            }
	        }, noop_1.noop));
	    });
	}
	exports.sample = sample;
	//# sourceMappingURL=sample.js.map

/***/ },
/* 578 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.scanInternals = void 0;
	var OperatorSubscriber_1 = __webpack_require__(20);
	function scanInternals(accumulator, seed, hasSeed, emitOnNext, emitBeforeComplete) {
	    return function (source, subscriber) {
	        var hasState = hasSeed;
	        var state = seed;
	        var index = 0;
	        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (value) {
	            var i = index++;
	            state = hasState
	                ?
	                    accumulator(state, value, i)
	                :
	                    ((hasState = true), value);
	            emitOnNext && subscriber.next(state);
	        }, emitBeforeComplete &&
	            (function () {
	                hasState && subscriber.next(state);
	                subscriber.complete();
	            })));
	    };
	}
	exports.scanInternals = scanInternals;
	//# sourceMappingURL=scanInternals.js.map

/***/ },
/* 579 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	var __spreadArray = (this && this.__spreadArray) || function (to, from) {
	    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
	        to[j] = from[i];
	    return to;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.share = void 0;
	var from_1 = __webpack_require__(78);
	var take_1 = __webpack_require__(167);
	var Subject_1 = __webpack_require__(51);
	var Subscriber_1 = __webpack_require__(164);
	var lift_1 = __webpack_require__(17);
	function share(options) {
	    if (options === void 0) { options = {}; }
	    var _a = options.connector, connector = _a === void 0 ? function () { return new Subject_1.Subject(); } : _a, _b = options.resetOnError, resetOnError = _b === void 0 ? true : _b, _c = options.resetOnComplete, resetOnComplete = _c === void 0 ? true : _c, _d = options.resetOnRefCountZero, resetOnRefCountZero = _d === void 0 ? true : _d;
	    return function (wrapperSource) {
	        var connection = null;
	        var resetConnection = null;
	        var subject = null;
	        var refCount = 0;
	        var hasCompleted = false;
	        var hasErrored = false;
	        var cancelReset = function () {
	            resetConnection === null || resetConnection === void 0 ? void 0 : resetConnection.unsubscribe();
	            resetConnection = null;
	        };
	        var reset = function () {
	            cancelReset();
	            connection = subject = null;
	            hasCompleted = hasErrored = false;
	        };
	        var resetAndUnsubscribe = function () {
	            var conn = connection;
	            reset();
	            conn === null || conn === void 0 ? void 0 : conn.unsubscribe();
	        };
	        return lift_1.operate(function (source, subscriber) {
	            refCount++;
	            if (!hasErrored && !hasCompleted) {
	                cancelReset();
	            }
	            var dest = (subject = subject !== null && subject !== void 0 ? subject : connector());
	            subscriber.add(function () {
	                refCount--;
	                if (refCount === 0 && !hasErrored && !hasCompleted) {
	                    resetConnection = handleReset(resetAndUnsubscribe, resetOnRefCountZero);
	                }
	            });
	            dest.subscribe(subscriber);
	            if (!connection) {
	                connection = new Subscriber_1.SafeSubscriber({
	                    next: function (value) { return dest.next(value); },
	                    error: function (err) {
	                        hasErrored = true;
	                        cancelReset();
	                        resetConnection = handleReset(reset, resetOnError, err);
	                        dest.error(err);
	                    },
	                    complete: function () {
	                        hasCompleted = true;
	                        cancelReset();
	                        resetConnection = handleReset(reset, resetOnComplete);
	                        dest.complete();
	                    },
	                });
	                from_1.from(source).subscribe(connection);
	            }
	        })(wrapperSource);
	    };
	}
	exports.share = share;
	function handleReset(reset, on) {
	    var args = [];
	    for (var _i = 2; _i < arguments.length; _i++) {
	        args[_i - 2] = arguments[_i];
	    }
	    if (on === true) {
	        reset();
	        return null;
	    }
	    if (on === false) {
	        return null;
	    }
	    return on.apply(void 0, __spreadArray([], __read(args))).pipe(take_1.take(1))
	        .subscribe(function () { return reset(); });
	}
	//# sourceMappingURL=share.js.map

/***/ },
/* 580 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __values = (this && this.__values) || function(o) {
	    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
	    if (m) return m.call(o);
	    if (o && typeof o.length === "number") return {
	        next: function () {
	            if (o && i >= o.length) o = void 0;
	            return { value: o && o[i++], done: !o };
	        }
	    };
	    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.takeLast = void 0;
	var empty_1 = __webpack_require__(74);
	var lift_1 = __webpack_require__(17);
	var OperatorSubscriber_1 = __webpack_require__(20);
	function takeLast(count) {
	    return count <= 0
	        ? function () { return empty_1.EMPTY; }
	        : lift_1.operate(function (source, subscriber) {
	            var buffer = [];
	            source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (value) {
	                buffer.push(value);
	                count < buffer.length && buffer.shift();
	            }, function () {
	                var e_1, _a;
	                try {
	                    for (var buffer_1 = __values(buffer), buffer_1_1 = buffer_1.next(); !buffer_1_1.done; buffer_1_1 = buffer_1.next()) {
	                        var value = buffer_1_1.value;
	                        subscriber.next(value);
	                    }
	                }
	                catch (e_1_1) { e_1 = { error: e_1_1 }; }
	                finally {
	                    try {
	                        if (buffer_1_1 && !buffer_1_1.done && (_a = buffer_1.return)) _a.call(buffer_1);
	                    }
	                    finally { if (e_1) throw e_1.error; }
	                }
	                subscriber.complete();
	            }, undefined, function () {
	                buffer = null;
	            }));
	        });
	}
	exports.takeLast = takeLast;
	//# sourceMappingURL=takeLast.js.map

/***/ },
/* 581 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.throttle = exports.defaultThrottleConfig = void 0;
	var lift_1 = __webpack_require__(17);
	var OperatorSubscriber_1 = __webpack_require__(20);
	var innerFrom_1 = __webpack_require__(28);
	exports.defaultThrottleConfig = {
	    leading: true,
	    trailing: false,
	};
	function throttle(durationSelector, config) {
	    if (config === void 0) { config = exports.defaultThrottleConfig; }
	    return lift_1.operate(function (source, subscriber) {
	        var leading = config.leading, trailing = config.trailing;
	        var hasValue = false;
	        var sendValue = null;
	        var throttled = null;
	        var isComplete = false;
	        var endThrottling = function () {
	            throttled === null || throttled === void 0 ? void 0 : throttled.unsubscribe();
	            throttled = null;
	            if (trailing) {
	                send();
	                isComplete && subscriber.complete();
	            }
	        };
	        var cleanupThrottling = function () {
	            throttled = null;
	            isComplete && subscriber.complete();
	        };
	        var startThrottle = function (value) {
	            return (throttled = innerFrom_1.innerFrom(durationSelector(value)).subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, endThrottling, cleanupThrottling)));
	        };
	        var send = function () {
	            if (hasValue) {
	                hasValue = false;
	                var value = sendValue;
	                sendValue = null;
	                subscriber.next(value);
	                !isComplete && startThrottle(value);
	            }
	        };
	        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (value) {
	            hasValue = true;
	            sendValue = value;
	            !(throttled && !throttled.closed) && (leading ? send() : startThrottle(value));
	        }, function () {
	            isComplete = true;
	            !(trailing && hasValue && throttled && !throttled.closed) && subscriber.complete();
	        }));
	    });
	}
	exports.throttle = throttle;
	//# sourceMappingURL=throttle.js.map

/***/ },
/* 582 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.toArray = void 0;
	var reduce_1 = __webpack_require__(166);
	var lift_1 = __webpack_require__(17);
	var arrReducer = function (arr, value) { return (arr.push(value), arr); };
	function toArray() {
	    return lift_1.operate(function (source, subscriber) {
	        reduce_1.reduce(arrReducer, [])(source).subscribe(subscriber);
	    });
	}
	exports.toArray = toArray;
	//# sourceMappingURL=toArray.js.map

/***/ },
/* 583 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.scheduleAsyncIterable = void 0;
	var Observable_1 = __webpack_require__(34);
	var executeSchedule_1 = __webpack_require__(100);
	function scheduleAsyncIterable(input, scheduler) {
	    if (!input) {
	        throw new Error('Iterable cannot be null');
	    }
	    return new Observable_1.Observable(function (subscriber) {
	        executeSchedule_1.executeSchedule(subscriber, scheduler, function () {
	            var iterator = input[Symbol.asyncIterator]();
	            executeSchedule_1.executeSchedule(subscriber, scheduler, function () {
	                iterator.next().then(function (result) {
	                    if (result.done) {
	                        subscriber.complete();
	                    }
	                    else {
	                        subscriber.next(result.value);
	                    }
	                });
	            }, 0, true);
	        });
	    });
	}
	exports.scheduleAsyncIterable = scheduleAsyncIterable;
	//# sourceMappingURL=scheduleAsyncIterable.js.map

/***/ },
/* 584 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.scheduleIterable = void 0;
	var Observable_1 = __webpack_require__(34);
	var iterator_1 = __webpack_require__(588);
	var isFunction_1 = __webpack_require__(31);
	var executeSchedule_1 = __webpack_require__(100);
	function scheduleIterable(input, scheduler) {
	    return new Observable_1.Observable(function (subscriber) {
	        var iterator;
	        executeSchedule_1.executeSchedule(subscriber, scheduler, function () {
	            iterator = input[iterator_1.iterator]();
	            executeSchedule_1.executeSchedule(subscriber, scheduler, function () {
	                var _a;
	                var value;
	                var done;
	                try {
	                    (_a = iterator.next(), value = _a.value, done = _a.done);
	                }
	                catch (err) {
	                    subscriber.error(err);
	                    return;
	                }
	                if (done) {
	                    subscriber.complete();
	                }
	                else {
	                    subscriber.next(value);
	                }
	            }, 0, true);
	        });
	        return function () { return isFunction_1.isFunction(iterator === null || iterator === void 0 ? void 0 : iterator.return) && iterator.return(); };
	    });
	}
	exports.scheduleIterable = scheduleIterable;
	//# sourceMappingURL=scheduleIterable.js.map

/***/ },
/* 585 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.scheduled = void 0;
	var scheduleObservable_1 = __webpack_require__(2111);
	var schedulePromise_1 = __webpack_require__(2112);
	var scheduleArray_1 = __webpack_require__(2110);
	var scheduleIterable_1 = __webpack_require__(584);
	var scheduleAsyncIterable_1 = __webpack_require__(583);
	var isInteropObservable_1 = __webpack_require__(597);
	var isPromise_1 = __webpack_require__(599);
	var isArrayLike_1 = __webpack_require__(337);
	var isIterable_1 = __webpack_require__(598);
	var isAsyncIterable_1 = __webpack_require__(596);
	var throwUnobservableError_1 = __webpack_require__(601);
	var isReadableStreamLike_1 = __webpack_require__(339);
	var scheduleReadableStreamLike_1 = __webpack_require__(2113);
	function scheduled(input, scheduler) {
	    if (input != null) {
	        if (isInteropObservable_1.isInteropObservable(input)) {
	            return scheduleObservable_1.scheduleObservable(input, scheduler);
	        }
	        if (isArrayLike_1.isArrayLike(input)) {
	            return scheduleArray_1.scheduleArray(input, scheduler);
	        }
	        if (isPromise_1.isPromise(input)) {
	            return schedulePromise_1.schedulePromise(input, scheduler);
	        }
	        if (isAsyncIterable_1.isAsyncIterable(input)) {
	            return scheduleAsyncIterable_1.scheduleAsyncIterable(input, scheduler);
	        }
	        if (isIterable_1.isIterable(input)) {
	            return scheduleIterable_1.scheduleIterable(input, scheduler);
	        }
	        if (isReadableStreamLike_1.isReadableStreamLike(input)) {
	            return scheduleReadableStreamLike_1.scheduleReadableStreamLike(input, scheduler);
	        }
	    }
	    throw throwUnobservableError_1.createInvalidObservableTypeError(input);
	}
	exports.scheduled = scheduled;
	//# sourceMappingURL=scheduled.js.map

/***/ },
/* 586 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	var __spreadArray = (this && this.__spreadArray) || function (to, from) {
	    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
	        to[j] = from[i];
	    return to;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.animationFrameProvider = void 0;
	var Subscription_1 = __webpack_require__(62);
	exports.animationFrameProvider = {
	    schedule: function (callback) {
	        var request = requestAnimationFrame;
	        var cancel = cancelAnimationFrame;
	        var delegate = exports.animationFrameProvider.delegate;
	        if (delegate) {
	            request = delegate.requestAnimationFrame;
	            cancel = delegate.cancelAnimationFrame;
	        }
	        var handle = request(function (timestamp) {
	            cancel = undefined;
	            callback(timestamp);
	        });
	        return new Subscription_1.Subscription(function () { return cancel === null || cancel === void 0 ? void 0 : cancel(handle); });
	    },
	    requestAnimationFrame: function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        var delegate = exports.animationFrameProvider.delegate;
	        return ((delegate === null || delegate === void 0 ? void 0 : delegate.requestAnimationFrame) || requestAnimationFrame).apply(void 0, __spreadArray([], __read(args)));
	    },
	    cancelAnimationFrame: function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        var delegate = exports.animationFrameProvider.delegate;
	        return ((delegate === null || delegate === void 0 ? void 0 : delegate.cancelAnimationFrame) || cancelAnimationFrame).apply(void 0, __spreadArray([], __read(args)));
	    },
	    delegate: undefined,
	};
	//# sourceMappingURL=animationFrameProvider.js.map

/***/ },
/* 587 */
/***/ function(module, exports) {

	"use strict";
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	var __spreadArray = (this && this.__spreadArray) || function (to, from) {
	    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
	        to[j] = from[i];
	    return to;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.timeoutProvider = void 0;
	exports.timeoutProvider = {
	    setTimeout: function (handler, timeout) {
	        var args = [];
	        for (var _i = 2; _i < arguments.length; _i++) {
	            args[_i - 2] = arguments[_i];
	        }
	        var delegate = exports.timeoutProvider.delegate;
	        if (delegate === null || delegate === void 0 ? void 0 : delegate.setTimeout) {
	            return delegate.setTimeout.apply(delegate, __spreadArray([handler, timeout], __read(args)));
	        }
	        return setTimeout.apply(void 0, __spreadArray([handler, timeout], __read(args)));
	    },
	    clearTimeout: function (handle) {
	        var delegate = exports.timeoutProvider.delegate;
	        return ((delegate === null || delegate === void 0 ? void 0 : delegate.clearTimeout) || clearTimeout)(handle);
	    },
	    delegate: undefined,
	};
	//# sourceMappingURL=timeoutProvider.js.map

/***/ },
/* 588 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.iterator = exports.getSymbolIterator = void 0;
	function getSymbolIterator() {
	    if (typeof Symbol !== 'function' || !Symbol.iterator) {
	        return '@@iterator';
	    }
	    return Symbol.iterator;
	}
	exports.getSymbolIterator = getSymbolIterator;
	exports.iterator = getSymbolIterator();
	//# sourceMappingURL=iterator.js.map

/***/ },
/* 589 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.ArgumentOutOfRangeError = void 0;
	var createErrorClass_1 = __webpack_require__(116);
	exports.ArgumentOutOfRangeError = createErrorClass_1.createErrorClass(function (_super) {
	    return function ArgumentOutOfRangeErrorImpl() {
	        _super(this);
	        this.name = 'ArgumentOutOfRangeError';
	        this.message = 'argument out of range';
	    };
	});
	//# sourceMappingURL=ArgumentOutOfRangeError.js.map

/***/ },
/* 590 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.NotFoundError = void 0;
	var createErrorClass_1 = __webpack_require__(116);
	exports.NotFoundError = createErrorClass_1.createErrorClass(function (_super) {
	    return function NotFoundErrorImpl(message) {
	        _super(this);
	        this.name = 'NotFoundError';
	        this.message = message;
	    };
	});
	//# sourceMappingURL=NotFoundError.js.map

/***/ },
/* 591 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.ObjectUnsubscribedError = void 0;
	var createErrorClass_1 = __webpack_require__(116);
	exports.ObjectUnsubscribedError = createErrorClass_1.createErrorClass(function (_super) {
	    return function ObjectUnsubscribedErrorImpl() {
	        _super(this);
	        this.name = 'ObjectUnsubscribedError';
	        this.message = 'object unsubscribed';
	    };
	});
	//# sourceMappingURL=ObjectUnsubscribedError.js.map

/***/ },
/* 592 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.SequenceError = void 0;
	var createErrorClass_1 = __webpack_require__(116);
	exports.SequenceError = createErrorClass_1.createErrorClass(function (_super) {
	    return function SequenceErrorImpl(message) {
	        _super(this);
	        this.name = 'SequenceError';
	        this.message = message;
	    };
	});
	//# sourceMappingURL=SequenceError.js.map

/***/ },
/* 593 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.UnsubscriptionError = void 0;
	var createErrorClass_1 = __webpack_require__(116);
	exports.UnsubscriptionError = createErrorClass_1.createErrorClass(function (_super) {
	    return function UnsubscriptionErrorImpl(errors) {
	        _super(this);
	        this.message = errors
	            ? errors.length + " errors occurred during unsubscription:\n" + errors.map(function (err, i) { return i + 1 + ") " + err.toString(); }).join('\n  ')
	            : '';
	        this.name = 'UnsubscriptionError';
	        this.errors = errors;
	    };
	});
	//# sourceMappingURL=UnsubscriptionError.js.map

/***/ },
/* 594 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.argsArgArrayOrObject = void 0;
	var isArray = Array.isArray;
	var getPrototypeOf = Object.getPrototypeOf, objectProto = Object.prototype, getKeys = Object.keys;
	function argsArgArrayOrObject(args) {
	    if (args.length === 1) {
	        var first_1 = args[0];
	        if (isArray(first_1)) {
	            return { args: first_1, keys: null };
	        }
	        if (isPOJO(first_1)) {
	            var keys = getKeys(first_1);
	            return {
	                args: keys.map(function (key) { return first_1[key]; }),
	                keys: keys,
	            };
	        }
	    }
	    return { args: args, keys: null };
	}
	exports.argsArgArrayOrObject = argsArgArrayOrObject;
	function isPOJO(obj) {
	    return obj && typeof obj === 'object' && getPrototypeOf(obj) === objectProto;
	}
	//# sourceMappingURL=argsArgArrayOrObject.js.map

/***/ },
/* 595 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.createObject = void 0;
	function createObject(keys, values) {
	    return keys.reduce(function (result, key, i) { return ((result[key] = values[i]), result); }, {});
	}
	exports.createObject = createObject;
	//# sourceMappingURL=createObject.js.map

/***/ },
/* 596 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.isAsyncIterable = void 0;
	var isFunction_1 = __webpack_require__(31);
	function isAsyncIterable(obj) {
	    return Symbol.asyncIterator && isFunction_1.isFunction(obj === null || obj === void 0 ? void 0 : obj[Symbol.asyncIterator]);
	}
	exports.isAsyncIterable = isAsyncIterable;
	//# sourceMappingURL=isAsyncIterable.js.map

/***/ },
/* 597 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.isInteropObservable = void 0;
	var observable_1 = __webpack_require__(230);
	var isFunction_1 = __webpack_require__(31);
	function isInteropObservable(input) {
	    return isFunction_1.isFunction(input[observable_1.observable]);
	}
	exports.isInteropObservable = isInteropObservable;
	//# sourceMappingURL=isInteropObservable.js.map

/***/ },
/* 598 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.isIterable = void 0;
	var iterator_1 = __webpack_require__(588);
	var isFunction_1 = __webpack_require__(31);
	function isIterable(input) {
	    return isFunction_1.isFunction(input === null || input === void 0 ? void 0 : input[iterator_1.iterator]);
	}
	exports.isIterable = isIterable;
	//# sourceMappingURL=isIterable.js.map

/***/ },
/* 599 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.isPromise = void 0;
	var isFunction_1 = __webpack_require__(31);
	function isPromise(value) {
	    return isFunction_1.isFunction(value === null || value === void 0 ? void 0 : value.then);
	}
	exports.isPromise = isPromise;
	//# sourceMappingURL=isPromise.js.map

/***/ },
/* 600 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.reportUnhandledError = void 0;
	var config_1 = __webpack_require__(165);
	var timeoutProvider_1 = __webpack_require__(587);
	function reportUnhandledError(err) {
	    timeoutProvider_1.timeoutProvider.setTimeout(function () {
	        var onUnhandledError = config_1.config.onUnhandledError;
	        if (onUnhandledError) {
	            onUnhandledError(err);
	        }
	        else {
	            throw err;
	        }
	    });
	}
	exports.reportUnhandledError = reportUnhandledError;
	//# sourceMappingURL=reportUnhandledError.js.map

/***/ },
/* 601 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.createInvalidObservableTypeError = void 0;
	function createInvalidObservableTypeError(input) {
	    return new TypeError("You provided " + (input !== null && typeof input === 'object' ? 'an invalid object' : "'" + input + "'") + " where a stream was expected. You can provide an Observable, Promise, ReadableStream, Array, AsyncIterable, or Iterable.");
	}
	exports.createInvalidObservableTypeError = createInvalidObservableTypeError;
	//# sourceMappingURL=throwUnobservableError.js.map

/***/ },
/* 602 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(921);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(25)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!../../../../node_modules/sass-loader/index.js!./homepage.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!../../../../node_modules/sass-loader/index.js!./homepage.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 603 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(923);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(25)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!../../../../node_modules/sass-loader/index.js!./product-list.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!../../../../node_modules/sass-loader/index.js!./product-list.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 604 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(924);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(25)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!../../../../node_modules/sass-loader/index.js!./product-show.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!../../../../node_modules/sass-loader/index.js!./product-show.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 605 */
/***/ function(module, exports) {

	/**
	 * Check if `obj` is an object.
	 *
	 * @param {Object} obj
	 * @return {Boolean}
	 * @api private
	 */
	
	function isObject(obj) {
	  return null !== obj && 'object' === typeof obj;
	}
	
	module.exports = isObject;


/***/ },
/* 606 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var isProduction = ("production") === 'production';
	var prefix = 'Invariant failed';
	function invariant(condition, message) {
	    if (condition) {
	        return;
	    }
	    if (isProduction) {
	        throw new Error(prefix);
	    }
	    var provided = typeof message === 'function' ? message() : message;
	    var value = provided ? "".concat(prefix, ": ").concat(provided) : prefix;
	    throw new Error(value);
	}
	
	module.exports = invariant;


/***/ },
/* 607 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var isProduction = ("production") === 'production';
	function warning(condition, message) {
	  if (!isProduction) {
	    if (condition) {
	      return;
	    }
	
	    var text = "Warning: " + message;
	
	    if (typeof console !== 'undefined') {
	      console.warn(text);
	    }
	
	    try {
	      throw Error(text);
	    } catch (x) {}
	  }
	}
	
	module.exports = warning;


/***/ },
/* 608 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global) {/******************************************************************************
	Copyright (c) Microsoft Corporation.
	
	Permission to use, copy, modify, and/or distribute this software for any
	purpose with or without fee is hereby granted.
	
	THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
	REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
	AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
	INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
	LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
	OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
	PERFORMANCE OF THIS SOFTWARE.
	***************************************************************************** */
	/* global global, define, System, Reflect, Promise */
	var __extends;
	var __assign;
	var __rest;
	var __decorate;
	var __param;
	var __esDecorate;
	var __runInitializers;
	var __propKey;
	var __setFunctionName;
	var __metadata;
	var __awaiter;
	var __generator;
	var __exportStar;
	var __values;
	var __read;
	var __spread;
	var __spreadArrays;
	var __spreadArray;
	var __await;
	var __asyncGenerator;
	var __asyncDelegator;
	var __asyncValues;
	var __makeTemplateObject;
	var __importStar;
	var __importDefault;
	var __classPrivateFieldGet;
	var __classPrivateFieldSet;
	var __classPrivateFieldIn;
	var __createBinding;
	(function (factory) {
	    var root = typeof global === "object" ? global : typeof self === "object" ? self : typeof this === "object" ? this : {};
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_RESULT__ = function (exports) { factory(createExporter(root, createExporter(exports))); }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    }
	    else if (typeof module === "object" && typeof module.exports === "object") {
	        factory(createExporter(root, createExporter(module.exports)));
	    }
	    else {
	        factory(createExporter(root));
	    }
	    function createExporter(exports, previous) {
	        if (exports !== root) {
	            if (typeof Object.create === "function") {
	                Object.defineProperty(exports, "__esModule", { value: true });
	            }
	            else {
	                exports.__esModule = true;
	            }
	        }
	        return function (id, v) { return exports[id] = previous ? previous(id, v) : v; };
	    }
	})
	(function (exporter) {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
	
	    __extends = function (d, b) {
	        if (typeof b !== "function" && b !== null)
	            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	        }
	        return t;
	    };
	
	    __rest = function (s, e) {
	        var t = {};
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
	            t[p] = s[p];
	        if (s != null && typeof Object.getOwnPropertySymbols === "function")
	            for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	                if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
	                    t[p[i]] = s[p[i]];
	            }
	        return t;
	    };
	
	    __decorate = function (decorators, target, key, desc) {
	        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	        else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	        return c > 3 && r && Object.defineProperty(target, key, r), r;
	    };
	
	    __param = function (paramIndex, decorator) {
	        return function (target, key) { decorator(target, key, paramIndex); }
	    };
	
	    __esDecorate = function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
	        function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
	        var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
	        var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
	        var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
	        var _, done = false;
	        for (var i = decorators.length - 1; i >= 0; i--) {
	            var context = {};
	            for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
	            for (var p in contextIn.access) context.access[p] = contextIn.access[p];
	            context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
	            var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
	            if (kind === "accessor") {
	                if (result === void 0) continue;
	                if (result === null || typeof result !== "object") throw new TypeError("Object expected");
	                if (_ = accept(result.get)) descriptor.get = _;
	                if (_ = accept(result.set)) descriptor.set = _;
	                if (_ = accept(result.init)) initializers.push(_);
	            }
	            else if (_ = accept(result)) {
	                if (kind === "field") initializers.push(_);
	                else descriptor[key] = _;
	            }
	        }
	        if (target) Object.defineProperty(target, contextIn.name, descriptor);
	        done = true;
	    };
	
	    __runInitializers = function (thisArg, initializers, value) {
	        var useValue = arguments.length > 2;
	        for (var i = 0; i < initializers.length; i++) {
	            value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
	        }
	        return useValue ? value : void 0;
	    };
	
	    __propKey = function (x) {
	        return typeof x === "symbol" ? x : "".concat(x);
	    };
	
	    __setFunctionName = function (f, name, prefix) {
	        if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
	        return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
	    };
	
	    __metadata = function (metadataKey, metadataValue) {
	        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
	    };
	
	    __awaiter = function (thisArg, _arguments, P, generator) {
	        function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	        return new (P || (P = Promise))(function (resolve, reject) {
	            function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	            function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	            function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	            step((generator = generator.apply(thisArg, _arguments || [])).next());
	        });
	    };
	
	    __generator = function (thisArg, body) {
	        var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
	        return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
	        function verb(n) { return function (v) { return step([n, v]); }; }
	        function step(op) {
	            if (f) throw new TypeError("Generator is already executing.");
	            while (g && (g = 0, op[0] && (_ = 0)), _) try {
	                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
	                if (y = 0, t) op = [op[0] & 2, t.value];
	                switch (op[0]) {
	                    case 0: case 1: t = op; break;
	                    case 4: _.label++; return { value: op[1], done: false };
	                    case 5: _.label++; y = op[1]; op = [0]; continue;
	                    case 7: op = _.ops.pop(); _.trys.pop(); continue;
	                    default:
	                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
	                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
	                        if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
	                        if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
	                        if (t[2]) _.ops.pop();
	                        _.trys.pop(); continue;
	                }
	                op = body.call(thisArg, _);
	            } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
	            if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
	        }
	    };
	
	    __exportStar = function(m, o) {
	        for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
	    };
	
	    __createBinding = Object.create ? (function(o, m, k, k2) {
	        if (k2 === undefined) k2 = k;
	        var desc = Object.getOwnPropertyDescriptor(m, k);
	        if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	            desc = { enumerable: true, get: function() { return m[k]; } };
	        }
	        Object.defineProperty(o, k2, desc);
	    }) : (function(o, m, k, k2) {
	        if (k2 === undefined) k2 = k;
	        o[k2] = m[k];
	    });
	
	    __values = function (o) {
	        var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
	        if (m) return m.call(o);
	        if (o && typeof o.length === "number") return {
	            next: function () {
	                if (o && i >= o.length) o = void 0;
	                return { value: o && o[i++], done: !o };
	            }
	        };
	        throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
	    };
	
	    __read = function (o, n) {
	        var m = typeof Symbol === "function" && o[Symbol.iterator];
	        if (!m) return o;
	        var i = m.call(o), r, ar = [], e;
	        try {
	            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	        }
	        catch (error) { e = { error: error }; }
	        finally {
	            try {
	                if (r && !r.done && (m = i["return"])) m.call(i);
	            }
	            finally { if (e) throw e.error; }
	        }
	        return ar;
	    };
	
	    /** @deprecated */
	    __spread = function () {
	        for (var ar = [], i = 0; i < arguments.length; i++)
	            ar = ar.concat(__read(arguments[i]));
	        return ar;
	    };
	
	    /** @deprecated */
	    __spreadArrays = function () {
	        for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
	        for (var r = Array(s), k = 0, i = 0; i < il; i++)
	            for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
	                r[k] = a[j];
	        return r;
	    };
	
	    __spreadArray = function (to, from, pack) {
	        if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
	            if (ar || !(i in from)) {
	                if (!ar) ar = Array.prototype.slice.call(from, 0, i);
	                ar[i] = from[i];
	            }
	        }
	        return to.concat(ar || Array.prototype.slice.call(from));
	    };
	
	    __await = function (v) {
	        return this instanceof __await ? (this.v = v, this) : new __await(v);
	    };
	
	    __asyncGenerator = function (thisArg, _arguments, generator) {
	        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
	        var g = generator.apply(thisArg, _arguments || []), i, q = [];
	        return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
	        function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
	        function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
	        function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);  }
	        function fulfill(value) { resume("next", value); }
	        function reject(value) { resume("throw", value); }
	        function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
	    };
	
	    __asyncDelegator = function (o) {
	        var i, p;
	        return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
	        function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: false } : f ? f(v) : v; } : f; }
	    };
	
	    __asyncValues = function (o) {
	        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
	        var m = o[Symbol.asyncIterator], i;
	        return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
	        function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
	        function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
	    };
	
	    __makeTemplateObject = function (cooked, raw) {
	        if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
	        return cooked;
	    };
	
	    var __setModuleDefault = Object.create ? (function(o, v) {
	        Object.defineProperty(o, "default", { enumerable: true, value: v });
	    }) : function(o, v) {
	        o["default"] = v;
	    };
	
	    __importStar = function (mod) {
	        if (mod && mod.__esModule) return mod;
	        var result = {};
	        if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	        __setModuleDefault(result, mod);
	        return result;
	    };
	
	    __importDefault = function (mod) {
	        return (mod && mod.__esModule) ? mod : { "default": mod };
	    };
	
	    __classPrivateFieldGet = function (receiver, state, kind, f) {
	        if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
	        if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
	        return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
	    };
	
	    __classPrivateFieldSet = function (receiver, state, value, kind, f) {
	        if (kind === "m") throw new TypeError("Private method is not writable");
	        if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
	        if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
	        return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
	    };
	
	    __classPrivateFieldIn = function (state, receiver) {
	        if (receiver === null || (typeof receiver !== "object" && typeof receiver !== "function")) throw new TypeError("Cannot use 'in' operator on non-object");
	        return typeof state === "function" ? receiver === state : state.has(receiver);
	    };
	
	    exporter("__extends", __extends);
	    exporter("__assign", __assign);
	    exporter("__rest", __rest);
	    exporter("__decorate", __decorate);
	    exporter("__param", __param);
	    exporter("__esDecorate", __esDecorate);
	    exporter("__runInitializers", __runInitializers);
	    exporter("__propKey", __propKey);
	    exporter("__setFunctionName", __setFunctionName);
	    exporter("__metadata", __metadata);
	    exporter("__awaiter", __awaiter);
	    exporter("__generator", __generator);
	    exporter("__exportStar", __exportStar);
	    exporter("__createBinding", __createBinding);
	    exporter("__values", __values);
	    exporter("__read", __read);
	    exporter("__spread", __spread);
	    exporter("__spreadArrays", __spreadArrays);
	    exporter("__spreadArray", __spreadArray);
	    exporter("__await", __await);
	    exporter("__asyncGenerator", __asyncGenerator);
	    exporter("__asyncDelegator", __asyncDelegator);
	    exporter("__asyncValues", __asyncValues);
	    exporter("__makeTemplateObject", __makeTemplateObject);
	    exporter("__importStar", __importStar);
	    exporter("__importDefault", __importDefault);
	    exporter("__classPrivateFieldGet", __classPrivateFieldGet);
	    exporter("__classPrivateFieldSet", __classPrivateFieldSet);
	    exporter("__classPrivateFieldIn", __classPrivateFieldIn);
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 609 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports.uncontrolledPropTypes = uncontrolledPropTypes;
	exports.isProp = isProp;
	exports.defaultKey = defaultKey;
	exports.canAcceptRef = canAcceptRef;
	
	var _invariant = _interopRequireDefault(__webpack_require__(37));
	
	var noop = function noop() {};
	
	function readOnlyPropType(handler, name) {
	  return function (props, propName) {
	    if (props[propName] !== undefined) {
	      if (!props[handler]) {
	        return new Error("You have provided a `" + propName + "` prop to `" + name + "` " + ("without an `" + handler + "` handler prop. This will render a read-only field. ") + ("If the field should be mutable use `" + defaultKey(propName) + "`. ") + ("Otherwise, set `" + handler + "`."));
	      }
	    }
	  };
	}
	
	function uncontrolledPropTypes(controlledValues, displayName) {
	  var propTypes = {};
	  Object.keys(controlledValues).forEach(function (prop) {
	    // add default propTypes for folks that use runtime checks
	    propTypes[defaultKey(prop)] = noop;
	
	    if (false) {
	      var handler = controlledValues[prop];
	      !(typeof handler === 'string' && handler.trim().length) ? process.env.NODE_ENV !== "production" ? (0, _invariant.default)(false, 'Uncontrollable - [%s]: the prop `%s` needs a valid handler key name in order to make it uncontrollable', displayName, prop) : invariant(false) : void 0;
	      propTypes[prop] = readOnlyPropType(handler, displayName);
	    }
	  });
	  return propTypes;
	}
	
	function isProp(props, prop) {
	  return props[prop] !== undefined;
	}
	
	function defaultKey(key) {
	  return 'default' + key.charAt(0).toUpperCase() + key.substr(1);
	}
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	
	function canAcceptRef(component) {
	  return !!component && (typeof component !== 'function' || component.prototype && component.prototype.isReactComponent);
	}

/***/ },
/* 610 */
/***/ function(module, exports, __webpack_require__) {

	if (typeof Promise === 'undefined') {
	    // Rejection tracking prevents a common issue where React gets into an
	    // inconsistent state due to an error, but it gets swallowed by a Promise,
	    // and the user has no idea what causes React's erratic future behavior.
	    __webpack_require__(1758).enable();
	    window.Promise = __webpack_require__(1757);
	}
	
	// fetch() polyfill for making API calls.
	__webpack_require__(2181);
	
	// Object.assign() is commonly used with React.
	// It will use the native implementation if it's present and isn't buggy.
	Object.assign = __webpack_require__(1754);


/***/ },
/* 611 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(823);

/***/ },
/* 612 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(824);

/***/ },
/* 613 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(826);

/***/ },
/* 614 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(827);

/***/ },
/* 615 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(829);

/***/ },
/* 616 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(830);

/***/ },
/* 617 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(831);

/***/ },
/* 618 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(833);

/***/ },
/* 619 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(834);

/***/ },
/* 620 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(835);

/***/ },
/* 621 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(836);

/***/ },
/* 622 */
/***/ function(module, exports, __webpack_require__) {

	var _Object$setPrototypeOf = __webpack_require__(617);
	
	function _setPrototypeOf(o, p) {
	  module.exports = _setPrototypeOf = _Object$setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;
	    return o;
	  };
	
	  module.exports["default"] = module.exports, module.exports.__esModule = true;
	  return _setPrototypeOf(o, p);
	}
	
	module.exports = _setPrototypeOf;
	module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ },
/* 623 */
/***/ function(module, exports, __webpack_require__) {

	var _Symbol = __webpack_require__(619);
	
	var _Symbol$iterator = __webpack_require__(620);
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	
	  if (typeof _Symbol === "function" && typeof _Symbol$iterator === "symbol") {
	    module.exports = _typeof = function _typeof(obj) {
	      return typeof obj;
	    };
	
	    module.exports["default"] = module.exports, module.exports.__esModule = true;
	  } else {
	    module.exports = _typeof = function _typeof(obj) {
	      return obj && typeof _Symbol === "function" && obj.constructor === _Symbol && obj !== _Symbol.prototype ? "symbol" : typeof obj;
	    };
	
	    module.exports["default"] = module.exports, module.exports.__esModule = true;
	  }
	
	  return _typeof(obj);
	}
	
	module.exports = _typeof;
	module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ },
/* 624 */
/***/ function(module, exports) {

	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	  return self;
	}
	module.exports = _assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 625 */
/***/ function(module, exports) {

	function _setPrototypeOf(o, p) {
	  module.exports = _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
	    o.__proto__ = p;
	    return o;
	  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
	  return _setPrototypeOf(o, p);
	}
	module.exports = _setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 626 */
/***/ function(module, exports, __webpack_require__) {

	var _typeof = __webpack_require__(233)["default"];
	function _toPrimitive(input, hint) {
	  if (_typeof(input) !== "object" || input === null) return input;
	  var prim = input[Symbol.toPrimitive];
	  if (prim !== undefined) {
	    var res = prim.call(input, hint || "default");
	    if (_typeof(res) !== "object") return res;
	    throw new TypeError("@@toPrimitive must return a primitive value.");
	  }
	  return (hint === "string" ? String : Number)(input);
	}
	module.exports = _toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 627 */
/***/ function(module, exports, __webpack_require__) {

	var _typeof = __webpack_require__(233)["default"];
	var toPrimitive = __webpack_require__(626);
	function _toPropertyKey(arg) {
	  var key = toPrimitive(arg, "string");
	  return _typeof(key) === "symbol" ? key : String(key);
	}
	module.exports = _toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 628 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var memoize = _interopDefault(__webpack_require__(629));
	
	var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|inert|itemProp|itemScope|itemType|itemID|itemRef|on|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
	
	var index = memoize(function (prop) {
	  return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111
	  /* o */
	  && prop.charCodeAt(1) === 110
	  /* n */
	  && prop.charCodeAt(2) < 91;
	}
	/* Z+1 */
	);
	
	exports.default = index;


/***/ },
/* 629 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function memoize(fn) {
	  var cache = {};
	  return function (arg) {
	    if (cache[arg] === undefined) cache[arg] = fn(arg);
	    return cache[arg];
	  };
	}
	
	exports.default = memoize;


/***/ },
/* 630 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var unitlessKeys = {
	  animationIterationCount: 1,
	  borderImageOutset: 1,
	  borderImageSlice: 1,
	  borderImageWidth: 1,
	  boxFlex: 1,
	  boxFlexGroup: 1,
	  boxOrdinalGroup: 1,
	  columnCount: 1,
	  columns: 1,
	  flex: 1,
	  flexGrow: 1,
	  flexPositive: 1,
	  flexShrink: 1,
	  flexNegative: 1,
	  flexOrder: 1,
	  gridRow: 1,
	  gridRowEnd: 1,
	  gridRowSpan: 1,
	  gridRowStart: 1,
	  gridColumn: 1,
	  gridColumnEnd: 1,
	  gridColumnSpan: 1,
	  gridColumnStart: 1,
	  msGridRow: 1,
	  msGridRowSpan: 1,
	  msGridColumn: 1,
	  msGridColumnSpan: 1,
	  fontWeight: 1,
	  lineHeight: 1,
	  opacity: 1,
	  order: 1,
	  orphans: 1,
	  tabSize: 1,
	  widows: 1,
	  zIndex: 1,
	  zoom: 1,
	  WebkitLineClamp: 1,
	  // SVG-related properties
	  fillOpacity: 1,
	  floodOpacity: 1,
	  stopOpacity: 1,
	  strokeDasharray: 1,
	  strokeDashoffset: 1,
	  strokeMiterlimit: 1,
	  strokeOpacity: 1,
	  strokeWidth: 1
	};
	
	exports.default = unitlessKeys;


/***/ },
/* 631 */
/***/ function(module, exports) {

	'use strict';
	
	function find(array, predicate, context) {
	  if (typeof Array.prototype.find === 'function') {
	    return array.find(predicate, context);
	  }
	
	  context = context || this;
	  var length = array.length;
	  var i;
	
	  if (typeof predicate !== 'function') {
	    throw new TypeError(predicate + ' is not a function');
	  }
	
	  for (i = 0; i < length; i++) {
	    if (predicate.call(context, array[i], i, array)) {
	      return array[i];
	    }
	  }
	}
	
	module.exports = find;


/***/ },
/* 632 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	// Use the fastest means possible to execute a task in its own turn, with
	// priority over other events including IO, animation, reflow, and redraw
	// events in browsers.
	//
	// An exception thrown by a task will permanently interrupt the processing of
	// subsequent tasks. The higher level `asap` function ensures that if an
	// exception is thrown by a task, that the task queue will continue flushing as
	// soon as possible, but if you use `rawAsap` directly, you are responsible to
	// either ensure that no exceptions are thrown from your task, or to manually
	// call `rawAsap.requestFlush` if an exception is thrown.
	module.exports = rawAsap;
	function rawAsap(task) {
	    if (!queue.length) {
	        requestFlush();
	        flushing = true;
	    }
	    // Equivalent to push, but avoids a function call.
	    queue[queue.length] = task;
	}
	
	var queue = [];
	// Once a flush has been requested, no further calls to `requestFlush` are
	// necessary until the next `flush` completes.
	var flushing = false;
	// `requestFlush` is an implementation-specific method that attempts to kick
	// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
	// the event queue before yielding to the browser's own event loop.
	var requestFlush;
	// The position of the next task to execute in the task queue. This is
	// preserved between calls to `flush` so that it can be resumed if
	// a task throws an exception.
	var index = 0;
	// If a task schedules additional tasks recursively, the task queue can grow
	// unbounded. To prevent memory exhaustion, the task queue will periodically
	// truncate already-completed tasks.
	var capacity = 1024;
	
	// The flush function processes all tasks that have been scheduled with
	// `rawAsap` unless and until one of those tasks throws an exception.
	// If a task throws an exception, `flush` ensures that its state will remain
	// consistent and will resume where it left off when called again.
	// However, `flush` does not make any arrangements to be called again if an
	// exception is thrown.
	function flush() {
	    while (index < queue.length) {
	        var currentIndex = index;
	        // Advance the index before calling the task. This ensures that we will
	        // begin flushing on the next task the task throws an error.
	        index = index + 1;
	        queue[currentIndex].call();
	        // Prevent leaking memory for long chains of recursive calls to `asap`.
	        // If we call `asap` within tasks scheduled by `asap`, the queue will
	        // grow, but to avoid an O(n) walk for every task we execute, we don't
	        // shift tasks off the queue after they have been executed.
	        // Instead, we periodically shift 1024 tasks off the queue.
	        if (index > capacity) {
	            // Manually shift all values starting at the index back to the
	            // beginning of the queue.
	            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
	                queue[scan] = queue[scan + index];
	            }
	            queue.length -= index;
	            index = 0;
	        }
	    }
	    queue.length = 0;
	    index = 0;
	    flushing = false;
	}
	
	// `requestFlush` is implemented using a strategy based on data collected from
	// every available SauceLabs Selenium web driver worker at time of writing.
	// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593
	
	// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
	// have WebKitMutationObserver but not un-prefixed MutationObserver.
	// Must use `global` or `self` instead of `window` to work in both frames and web
	// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.
	
	/* globals self */
	var scope = typeof global !== "undefined" ? global : self;
	var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;
	
	// MutationObservers are desirable because they have high priority and work
	// reliably everywhere they are implemented.
	// They are implemented in all modern browsers.
	//
	// - Android 4-4.3
	// - Chrome 26-34
	// - Firefox 14-29
	// - Internet Explorer 11
	// - iPad Safari 6-7.1
	// - iPhone Safari 7-7.1
	// - Safari 6-7
	if (typeof BrowserMutationObserver === "function") {
	    requestFlush = makeRequestCallFromMutationObserver(flush);
	
	// MessageChannels are desirable because they give direct access to the HTML
	// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
	// 11-12, and in web workers in many engines.
	// Although message channels yield to any queued rendering and IO tasks, they
	// would be better than imposing the 4ms delay of timers.
	// However, they do not work reliably in Internet Explorer or Safari.
	
	// Internet Explorer 10 is the only browser that has setImmediate but does
	// not have MutationObservers.
	// Although setImmediate yields to the browser's renderer, it would be
	// preferrable to falling back to setTimeout since it does not have
	// the minimum 4ms penalty.
	// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
	// Desktop to a lesser extent) that renders both setImmediate and
	// MessageChannel useless for the purposes of ASAP.
	// https://github.com/kriskowal/q/issues/396
	
	// Timers are implemented universally.
	// We fall back to timers in workers in most engines, and in foreground
	// contexts in the following browsers.
	// However, note that even this simple case requires nuances to operate in a
	// broad spectrum of browsers.
	//
	// - Firefox 3-13
	// - Internet Explorer 6-9
	// - iPad Safari 4.3
	// - Lynx 2.8.7
	} else {
	    requestFlush = makeRequestCallFromTimer(flush);
	}
	
	// `requestFlush` requests that the high priority event queue be flushed as
	// soon as possible.
	// This is useful to prevent an error thrown in a task from stalling the event
	// queue if the exception handled by Node.js’s
	// `process.on("uncaughtException")` or by a domain.
	rawAsap.requestFlush = requestFlush;
	
	// To request a high priority event, we induce a mutation observer by toggling
	// the text of a text node between "1" and "-1".
	function makeRequestCallFromMutationObserver(callback) {
	    var toggle = 1;
	    var observer = new BrowserMutationObserver(callback);
	    var node = document.createTextNode("");
	    observer.observe(node, {characterData: true});
	    return function requestCall() {
	        toggle = -toggle;
	        node.data = toggle;
	    };
	}
	
	// The message channel technique was discovered by Malte Ubl and was the
	// original foundation for this library.
	// http://www.nonblocking.io/2011/06/windownexttick.html
	
	// Safari 6.0.5 (at least) intermittently fails to create message ports on a
	// page's first load. Thankfully, this version of Safari supports
	// MutationObservers, so we don't need to fall back in that case.
	
	// function makeRequestCallFromMessageChannel(callback) {
	//     var channel = new MessageChannel();
	//     channel.port1.onmessage = callback;
	//     return function requestCall() {
	//         channel.port2.postMessage(0);
	//     };
	// }
	
	// For reasons explained above, we are also unable to use `setImmediate`
	// under any circumstances.
	// Even if we were, there is another bug in Internet Explorer 10.
	// It is not sufficient to assign `setImmediate` to `requestFlush` because
	// `setImmediate` must be called *by name* and therefore must be wrapped in a
	// closure.
	// Never forget.
	
	// function makeRequestCallFromSetImmediate(callback) {
	//     return function requestCall() {
	//         setImmediate(callback);
	//     };
	// }
	
	// Safari 6.0 has a problem where timers will get lost while the user is
	// scrolling. This problem does not impact ASAP because Safari 6.0 supports
	// mutation observers, so that implementation is used instead.
	// However, if we ever elect to use timers in Safari, the prevalent work-around
	// is to add a scroll event listener that calls for a flush.
	
	// `setTimeout` does not call the passed callback if the delay is less than
	// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
	// even then.
	
	function makeRequestCallFromTimer(callback) {
	    return function requestCall() {
	        // We dispatch a timeout with a specified delay of 0 for engines that
	        // can reliably accommodate that request. This will usually be snapped
	        // to a 4 milisecond delay, but once we're flushing, there's no delay
	        // between events.
	        var timeoutHandle = setTimeout(handleTimer, 0);
	        // However, since this timer gets frequently dropped in Firefox
	        // workers, we enlist an interval handle that will try to fire
	        // an event 20 times per second until it succeeds.
	        var intervalHandle = setInterval(handleTimer, 50);
	
	        function handleTimer() {
	            // Whichever timer succeeds will cancel both timers and
	            // execute the callback.
	            clearTimeout(timeoutHandle);
	            clearInterval(intervalHandle);
	            callback();
	        }
	    };
	}
	
	// This is for `asap.js` only.
	// Its name will be periodically randomized to break any code that depends on
	// its existence.
	rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;
	
	// ASAP was originally a nextTick shim included in Q. This was factored out
	// into this ASAP package. It was later adapted to RSVP which made further
	// amendments. These decisions, particularly to marginalize MessageChannel and
	// to capture the MutationObserver implementation in a closure, were integrated
	// back into ASAP proper.
	// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 633 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * FingerprintJS Pro SPA v0.2.4 - Copyright (c) FingerprintJS, Inc, 2022 (https://fingerprintjs.com)
	 * Licensed under the MIT (http://www.opensource.org/licenses/mit-license.php) license.
	 */
	
	'use strict';
	
	var _regenerator = __webpack_require__(41);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _cacheLocationBuilder;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var tslib = __webpack_require__(608);
	var FingerprintJS = __webpack_require__(634);
	
	function _interopNamespace(e) {
	    if (e && e.__esModule) return e;
	    var n = Object.create(null);
	    if (e) {
	        Object.keys(e).forEach(function (k) {
	            if (k !== 'default') {
	                var d = Object.getOwnPropertyDescriptor(e, k);
	                Object.defineProperty(n, k, d.get ? d : {
	                    enumerable: true,
	                    get: function get() {
	                        return e[k];
	                    }
	                });
	            }
	        });
	    }
	    n["default"] = e;
	    return Object.freeze(n);
	}
	
	var FingerprintJS__namespace = /*#__PURE__*/_interopNamespace(FingerprintJS);
	
	var CACHE_KEY_PREFIX = '@fpjs@client@';
	var MAX_CACHE_LIFE = 60 * 60 * 24; // 24 hours
	var DEFAULT_CACHE_LIFE = 60 * 60; // 1 hour
	var DEFAULT_NOW_PROVIDER = function DEFAULT_NOW_PROVIDER() {
	    return Date.now();
	};
	
	var CacheKey = function () {
	    function CacheKey(options) {
	        _classCallCheck(this, CacheKey);
	
	        var _a;
	        this.tag = options.tag || null;
	        this.linkedId = options.linkedId || null;
	        this.extendedResult = (_a = options.extendedResult) !== null && _a !== void 0 ? _a : false;
	    }
	    /**
	     * Converts this `CacheKey` instance into a string for use in a cache
	     * @returns A string representation of the key
	     */
	
	
	    _createClass(CacheKey, [{
	        key: 'toKey',
	        value: function toKey() {
	            return JSON.stringify(this.tag) + '__' + JSON.stringify(this.linkedId) + '__' + this.extendedResult;
	        }
	    }]);
	
	    return CacheKey;
	}();
	
	function getKeyWithPrefix(key, prefix) {
	    return prefix + '__' + key;
	}
	function removePrefixFromKey(key, prefix) {
	    return key.replace(prefix + '__', '');
	}
	
	var LocalStorageCache = function () {
	    function LocalStorageCache() {
	        var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : CACHE_KEY_PREFIX;
	
	        _classCallCheck(this, LocalStorageCache);
	
	        this.prefix = prefix;
	    }
	
	    _createClass(LocalStorageCache, [{
	        key: 'set',
	        value: function set(key, entry) {
	            window.localStorage.setItem(getKeyWithPrefix(key, this.prefix), JSON.stringify(entry));
	        }
	    }, {
	        key: 'get',
	        value: function get(key) {
	            var json = window.localStorage.getItem(getKeyWithPrefix(key, this.prefix));
	            if (!json) {
	                return;
	            }
	            try {
	                return JSON.parse(json);
	            } catch (e) {
	                return;
	            }
	        }
	    }, {
	        key: 'remove',
	        value: function remove(key) {
	            window.localStorage.removeItem(getKeyWithPrefix(key, this.prefix));
	        }
	    }, {
	        key: 'allKeys',
	        value: function allKeys() {
	            var _this = this;
	
	            return Object.keys(window.localStorage).filter(function (key) {
	                return key.startsWith(_this.prefix);
	            }).map(function (key) {
	                return removePrefixFromKey(key, _this.prefix);
	            });
	        }
	    }]);
	
	    return LocalStorageCache;
	}();
	
	var SessionStorageCache = function () {
	    function SessionStorageCache() {
	        var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : CACHE_KEY_PREFIX;
	
	        _classCallCheck(this, SessionStorageCache);
	
	        this.prefix = prefix;
	    }
	
	    _createClass(SessionStorageCache, [{
	        key: 'set',
	        value: function set(key, entry) {
	            window.sessionStorage.setItem(getKeyWithPrefix(key, this.prefix), JSON.stringify(entry));
	        }
	    }, {
	        key: 'get',
	        value: function get(key) {
	            var json = window.sessionStorage.getItem(getKeyWithPrefix(key, this.prefix));
	            if (!json) {
	                return;
	            }
	            try {
	                return JSON.parse(json);
	            } catch (e) {
	                return;
	            }
	        }
	    }, {
	        key: 'remove',
	        value: function remove(key) {
	            window.sessionStorage.removeItem(getKeyWithPrefix(key, this.prefix));
	        }
	    }, {
	        key: 'allKeys',
	        value: function allKeys() {
	            var _this2 = this;
	
	            return Object.keys(window.sessionStorage).filter(function (key) {
	                return key.startsWith(_this2.prefix);
	            }).map(function (key) {
	                return removePrefixFromKey(key, _this2.prefix);
	            });
	        }
	    }]);
	
	    return SessionStorageCache;
	}();
	
	var CacheManager = function () {
	    function CacheManager(cache) {
	        var cacheTime = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_CACHE_LIFE;
	        var nowProvider = arguments[2];
	
	        _classCallCheck(this, CacheManager);
	
	        this.cache = cache;
	        this.cacheTime = cacheTime;
	        this.nowProvider = nowProvider || DEFAULT_NOW_PROVIDER;
	    }
	
	    _createClass(CacheManager, [{
	        key: 'get',
	        value: function get(cacheKey) {
	            return tslib.__awaiter(this, void 0, void 0, _regenerator2.default.mark(function _callee() {
	                var wrappedEntry, now, nowSeconds;
	                return _regenerator2.default.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                _context.next = 2;
	                                return this.cache.get(cacheKey.toKey());
	
	                            case 2:
	                                wrappedEntry = _context.sent;
	
	                                if (wrappedEntry) {
	                                    _context.next = 5;
	                                    break;
	                                }
	
	                                return _context.abrupt('return');
	
	                            case 5:
	                                _context.next = 7;
	                                return this.nowProvider();
	
	                            case 7:
	                                now = _context.sent;
	                                nowSeconds = Math.floor(now / 1000);
	
	                                if (!(wrappedEntry.expiresAt < nowSeconds)) {
	                                    _context.next = 13;
	                                    break;
	                                }
	
	                                _context.next = 12;
	                                return this.cache.remove(cacheKey.toKey());
	
	                            case 12:
	                                return _context.abrupt('return');
	
	                            case 13:
	                                return _context.abrupt('return', wrappedEntry.body);
	
	                            case 14:
	                            case 'end':
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this);
	            }));
	        }
	    }, {
	        key: 'set',
	        value: function set(cacheKey, entry) {
	            return tslib.__awaiter(this, void 0, void 0, _regenerator2.default.mark(function _callee2() {
	                var wrappedEntry;
	                return _regenerator2.default.wrap(function _callee2$(_context2) {
	                    while (1) {
	                        switch (_context2.prev = _context2.next) {
	                            case 0:
	                                _context2.next = 2;
	                                return this.wrapCacheEntry(entry);
	
	                            case 2:
	                                wrappedEntry = _context2.sent;
	                                _context2.next = 5;
	                                return this.cache.set(cacheKey.toKey(), wrappedEntry);
	
	                            case 5:
	                            case 'end':
	                                return _context2.stop();
	                        }
	                    }
	                }, _callee2, this);
	            }));
	        }
	    }, {
	        key: 'clearCache',
	        value: function clearCache() {
	            return tslib.__awaiter(this, void 0, void 0, _regenerator2.default.mark(function _callee3() {
	                var _this3 = this;
	
	                var keys;
	                return _regenerator2.default.wrap(function _callee3$(_context3) {
	                    while (1) {
	                        switch (_context3.prev = _context3.next) {
	                            case 0:
	                                _context3.next = 2;
	                                return this.cache.allKeys();
	
	                            case 2:
	                                keys = _context3.sent;
	                                _context3.next = 5;
	                                return Promise.all(keys.map(function (key) {
	                                    return _this3.cache.remove(key);
	                                }));
	
	                            case 5:
	                            case 'end':
	                                return _context3.stop();
	                        }
	                    }
	                }, _callee3, this);
	            }));
	        }
	    }, {
	        key: 'wrapCacheEntry',
	        value: function wrapCacheEntry(entry) {
	            return tslib.__awaiter(this, void 0, void 0, _regenerator2.default.mark(function _callee4() {
	                var now, expiresInTime;
	                return _regenerator2.default.wrap(function _callee4$(_context4) {
	                    while (1) {
	                        switch (_context4.prev = _context4.next) {
	                            case 0:
	                                _context4.next = 2;
	                                return this.nowProvider();
	
	                            case 2:
	                                now = _context4.sent;
	                                expiresInTime = Math.floor(now / 1000) + this.cacheTime;
	                                return _context4.abrupt('return', {
	                                    body: entry,
	                                    expiresAt: expiresInTime
	                                });
	
	                            case 5:
	                            case 'end':
	                                return _context4.stop();
	                        }
	                    }
	                }, _callee4, this);
	            }));
	        }
	    }]);
	
	    return CacheManager;
	}();
	
	var InMemoryCache = function InMemoryCache() {
	    _classCallCheck(this, InMemoryCache);
	
	    this.enclosedCache = function () {
	        var cache = {};
	        return {
	            set: function set(key, entry) {
	                cache[key] = entry;
	            },
	            get: function get(key) {
	                var cacheEntry = cache[key];
	                if (!cacheEntry) {
	                    return;
	                }
	                return cacheEntry;
	            },
	            remove: function remove(key) {
	                delete cache[key];
	            },
	            allKeys: function allKeys() {
	                return Object.keys(cache);
	            }
	        };
	    }();
	};
	
	var CacheStub = function () {
	    function CacheStub() {
	        _classCallCheck(this, CacheStub);
	    }
	
	    _createClass(CacheStub, [{
	        key: 'set',
	        value: function set() {}
	    }, {
	        key: 'get',
	        value: function get() {
	            return undefined;
	        }
	    }, {
	        key: 'remove',
	        value: function remove() {}
	    }, {
	        key: 'allKeys',
	        value: function allKeys() {
	            return [];
	        }
	    }]);
	
	    return CacheStub;
	}();
	
	exports.CacheLocation = void 0;
	(function (CacheLocation) {
	    CacheLocation["Memory"] = "memory";
	    CacheLocation["LocalStorage"] = "localstorage";
	    CacheLocation["SessionStorage"] = "sessionstorage";
	    CacheLocation["NoCache"] = "nocache";
	})(exports.CacheLocation || (exports.CacheLocation = {}));
	
	var cacheLocationBuilders = (_cacheLocationBuilder = {}, _defineProperty(_cacheLocationBuilder, exports.CacheLocation.Memory, function () {
	    return new InMemoryCache().enclosedCache;
	}), _defineProperty(_cacheLocationBuilder, exports.CacheLocation.LocalStorage, function (prefix) {
	    return new LocalStorageCache(prefix);
	}), _defineProperty(_cacheLocationBuilder, exports.CacheLocation.SessionStorage, function (prefix) {
	    return new SessionStorageCache(prefix);
	}), _defineProperty(_cacheLocationBuilder, exports.CacheLocation.NoCache, function () {
	    return new CacheStub();
	}), _cacheLocationBuilder);
	var cacheFactory = function cacheFactory(location) {
	    return cacheLocationBuilders[location];
	};
	/**
	 * FingerprintJS SDK for Single Page Applications
	 */
	
	var FpjsClient = function () {
	    function FpjsClient(options) {
	        _classCallCheck(this, FpjsClient);
	
	        var _a;
	        this.options = options;
	        this.inFlightRequests = new Map();
	        this.agentPromise = null;
	        this.agent = {
	            get: function get() {
	                throw new Error("FPJSAgent hasn't loaded yet. Make sure to call the init() method first.");
	            }
	        };
	        this.loadOptions = options.loadOptions;
	        if (options.cache && options.cacheLocation) {
	            console.warn('Both `cache` and `cacheLocation` options have been specified in the FpjsClient configuration; ignoring `cacheLocation` and using `cache`.');
	        }
	        var cache = void 0;
	        if (options.cache) {
	            cache = options.cache;
	        } else {
	            this.cacheLocation = options.cacheLocation || exports.CacheLocation.SessionStorage;
	            if (!cacheFactory(this.cacheLocation)) {
	                throw new Error('Invalid cache location "' + this.cacheLocation + '"');
	            }
	            cache = cacheFactory(this.cacheLocation)(options.cachePrefix);
	        }
	        if (options.cacheTimeInSeconds && options.cacheTimeInSeconds > MAX_CACHE_LIFE) {
	            throw new Error('Cache time cannot exceed 86400 seconds (24 hours)');
	        }
	        var cacheTime = (_a = options.cacheTimeInSeconds) !== null && _a !== void 0 ? _a : DEFAULT_CACHE_LIFE;
	        this.cacheManager = new CacheManager(cache, cacheTime);
	    }
	    /**
	     * Loads FPJS JS agent with certain settings and stores the instance in memory
	     * [https://dev.fingerprintjs.com/docs/js-agent#agent-initialization]
	     */
	
	
	    _createClass(FpjsClient, [{
	        key: 'init',
	        value: function init() {
	            return tslib.__awaiter(this, void 0, void 0, _regenerator2.default.mark(function _callee5() {
	                var _this4 = this;
	
	                return _regenerator2.default.wrap(function _callee5$(_context5) {
	                    while (1) {
	                        switch (_context5.prev = _context5.next) {
	                            case 0:
	                                if (!this.agentPromise) {
	                                    this.agentPromise = FingerprintJS__namespace.load(this.loadOptions).then(function (agent) {
	                                        _this4.agent = agent;
	                                        return agent;
	                                    });
	                                }
	                                return _context5.abrupt('return', this.agentPromise);
	
	                            case 2:
	                            case 'end':
	                                return _context5.stop();
	                        }
	                    }
	                }, _callee5, this);
	            }));
	        }
	        /**
	         * Returns visitor identification data based on the request options
	         * [https://dev.fingerprintjs.com/docs/js-agent#visitor-identification]
	         *
	         * @param options
	         * @param ignoreCache if set to true a request to the API will be made even if the data is present in cache
	         */
	
	    }, {
	        key: 'getVisitorData',
	        value: function getVisitorData() {
	            var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	            var ignoreCache = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	            return tslib.__awaiter(this, void 0, void 0, _regenerator2.default.mark(function _callee6() {
	                var _this5 = this;
	
	                var cacheKey, key, promise;
	                return _regenerator2.default.wrap(function _callee6$(_context6) {
	                    while (1) {
	                        switch (_context6.prev = _context6.next) {
	                            case 0:
	                                cacheKey = FpjsClient.makeCacheKey(options);
	                                key = cacheKey.toKey();
	
	                                if (!this.inFlightRequests.has(key)) {
	                                    promise = this._identify(options, ignoreCache).then(function (visitorData) {
	                                        _this5.inFlightRequests.delete(key);
	                                        return visitorData;
	                                    });
	
	                                    this.inFlightRequests.set(key, promise);
	                                }
	                                _context6.next = 5;
	                                return this.inFlightRequests.get(key);
	
	                            case 5:
	                                return _context6.abrupt('return', _context6.sent);
	
	                            case 6:
	                            case 'end':
	                                return _context6.stop();
	                        }
	                    }
	                }, _callee6, this);
	            }));
	        }
	        /**
	         * Clears visitor data from cache regardless of the cache implementation
	         */
	
	    }, {
	        key: 'clearCache',
	        value: function clearCache() {
	            return tslib.__awaiter(this, void 0, void 0, _regenerator2.default.mark(function _callee7() {
	                return _regenerator2.default.wrap(function _callee7$(_context7) {
	                    while (1) {
	                        switch (_context7.prev = _context7.next) {
	                            case 0:
	                                _context7.next = 2;
	                                return this.cacheManager.clearCache();
	
	                            case 2:
	                            case 'end':
	                                return _context7.stop();
	                        }
	                    }
	                }, _callee7, this);
	            }));
	        }
	        /**
	         * Makes a CacheKey object from GetOptions
	         */
	
	    }, {
	        key: '_identify',
	        value: function _identify(options) {
	            var ignoreCache = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	            return tslib.__awaiter(this, void 0, void 0, _regenerator2.default.mark(function _callee8() {
	                var key, cacheResult, agentResult;
	                return _regenerator2.default.wrap(function _callee8$(_context8) {
	                    while (1) {
	                        switch (_context8.prev = _context8.next) {
	                            case 0:
	                                key = FpjsClient.makeCacheKey(options);
	
	                                if (ignoreCache) {
	                                    _context8.next = 7;
	                                    break;
	                                }
	
	                                _context8.next = 4;
	                                return this.cacheManager.get(key);
	
	                            case 4:
	                                cacheResult = _context8.sent;
	
	                                if (!cacheResult) {
	                                    _context8.next = 7;
	                                    break;
	                                }
	
	                                return _context8.abrupt('return', cacheResult);
	
	                            case 7:
	                                _context8.next = 9;
	                                return this.agent.get(options);
	
	                            case 9:
	                                agentResult = _context8.sent;
	                                _context8.next = 12;
	                                return this.cacheManager.set(key, agentResult);
	
	                            case 12:
	                                return _context8.abrupt('return', agentResult);
	
	                            case 13:
	                            case 'end':
	                                return _context8.stop();
	                        }
	                    }
	                }, _callee8, this);
	            }));
	        }
	    }], [{
	        key: 'makeCacheKey',
	        value: function makeCacheKey(options) {
	            return new CacheKey(options);
	        }
	    }]);
	
	    return FpjsClient;
	}();
	
	exports.CacheStub = CacheStub;
	exports.FpjsClient = FpjsClient;
	exports.InMemoryCache = InMemoryCache;
	exports.LocalStorageCache = LocalStorageCache;
	exports.SessionStorageCache = SessionStorageCache;

/***/ },
/* 634 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * FingerprintJS Pro v3.8.2 - Copyright (c) FingerprintJS, Inc, 2023 (https://fingerprint.com)
	 *
	 * This software contains code from open-source projects:
	 * MurmurHash3 by Karan Lyons (https://github.com/karanlyons/murmurHash3.js)
	 */
	
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: !0 });var e = __webpack_require__(608);function t(e, t) {
	  return function (e, t) {
	    return Object.prototype.hasOwnProperty.call(e, t);
	  }(e, t) ? e[t] : void 0;
	}function r(e) {
	  for (var t = "", r = 0; r < e.length; ++r) {
	    if (r > 0) {
	      var n = e[r].toLowerCase();n !== e[r] ? t += " ".concat(n) : t += e[r];
	    } else t += e[r].toUpperCase();
	  }return t;
	}var n = { default: "endpoint" },
	    R = { default: "tlsEndpoint" },
	    o = "Client timeout",
	    i = "Network connection error",
	    E = "Network request aborted",
	    _ = "Response cannot be parsed",
	    u = "Blocked by CSP",
	    a = r("WrongRegion"),
	    s = r("SubscriptionNotActive"),
	    O = r("UnsupportedVersion"),
	    c = r("InstallationMethodRestricted"),
	    p = r("HostnameRestricted"),
	    I = r("IntegrationFailed"),
	    d = "API key required",
	    l = "API key not found",
	    f = "API key expired",
	    N = "Request cannot be parsed",
	    T = "Request failed",
	    v = "Request failed to process",
	    A = "Too many requests, rate limit exceeded",
	    h = "Not available for this origin",
	    P = "Not available with restricted header",
	    S = d,
	    D = l,
	    x = f,
	    m = "3.8.2",
	    w = "9319";function L(t, r) {
	  var n = [];return function (t, r) {
	    var n = 5,
	        R = (s = t, O = e.__spreadArray([], s, !0), { current: function current() {
	        return O[0];
	      }, postpone: function postpone() {
	        var e = O.shift();void 0 !== e && O.push(e);
	      }, exclude: function exclude() {
	        O.shift();
	      } }),
	        o = (E = 100, _ = 3e3, a = 0, function () {
	      return Math.random() * Math.min(_, E * Math.pow(2, a++));
	    }),
	        i = R.current();var E, _, a;var s, O;if (void 0 === i) return Promise.reject(new TypeError("The list of script URL patterns is empty"));var c = function c(e, t) {
	      return r(e).catch(function (e) {
	        if (t + 1 >= n) throw e;!function (e) {
	          if (!(e instanceof Error)) return !1;var t = e.message;return t === u || t === w;
	        }(e) ? R.postpone() : R.exclude();var r,
	            i = R.current();if (void 0 === i) throw e;return (r = o(), new Promise(function (e) {
	          return setTimeout(e, r);
	        })).then(function () {
	          return c(i, t + 1);
	        });
	      });
	    };return c(i, 0);
	  }(t, function (e) {
	    var t = new Date(),
	        R = function R() {
	      return n.push({ url: e, startedAt: t, finishedAt: new Date() });
	    },
	        o = r(e);return o.then(R, R), o;
	  }).then(function (e) {
	    return [e, { attempts: n }];
	  });
	}var U = "https://fpnpmcdn.net/v<version>/<apiKey>/loader_v<loaderVersion>.js",
	    C = U,
	    y = "Failed to load the JS script of the agent";function K(r) {
	  var n;r.scriptUrlPattern;var R = r.token,
	      o = r.apiKey,
	      i = void 0 === o ? R : o,
	      E = e.__rest(r, ["scriptUrlPattern", "token", "apiKey"]),
	      _ = null !== (n = t(r, "scriptUrlPattern")) && void 0 !== n ? n : U;return Promise.resolve().then(function () {
	    if (!i || "string" != typeof i) throw new Error(d);var e = function (e, t) {
	      return (Array.isArray(e) ? e : [e]).map(function (e) {
	        return function (e, t) {
	          var r = encodeURIComponent;return e.replace(/<[^<>]+>/g, function (e) {
	            return "<version>" === e ? "3" : "<apiKey>" === e ? r(t) : "<loaderVersion>" === e ? r(m) : e;
	          });
	        }(String(e), t);
	      });
	    }(_, i);return L(e, M).catch(B);
	  }).then(function (t) {
	    var r = t[0],
	        n = t[1];return r.load(e.__assign(e.__assign({}, E), { ldi: n }));
	  });
	}function M(e) {
	  return function (e, t, r, n) {
	    var R,
	        o = document,
	        i = "securitypolicyviolation",
	        E = function E(t) {
	      var r = new URL(e, location.href),
	          n = t.blockedURI;n !== r.href && n !== r.protocol.slice(0, -1) && n !== r.origin || (R = t, _());
	    };o.addEventListener(i, E);var _ = function _() {
	      return o.removeEventListener(i, E);
	    };return null == n || n.then(_, _), Promise.resolve().then(t).then(function (e) {
	      return _(), e;
	    }, function (e) {
	      return new Promise(function (e) {
	        return setTimeout(e);
	      }).then(function () {
	        if (_(), R) return r(R);throw e;
	      });
	    });
	  }(e, function () {
	    return function (e) {
	      return new Promise(function (t, r) {
	        var n = document.createElement("script"),
	            R = function R() {
	          var e;return null === (e = n.parentNode) || void 0 === e ? void 0 : e.removeChild(n);
	        },
	            o = document.head || document.getElementsByTagName("head")[0];n.onload = function () {
	          R(), t();
	        }, n.onerror = function () {
	          R(), r(new Error(y));
	        }, n.async = !0, n.src = e, o.appendChild(n);
	      });
	    }(e);
	  }, function () {
	    throw new Error(u);
	  }).then(g);
	}function g() {
	  var e = window,
	      t = "__fpjs_p_l_b",
	      r = e[t];if (function (e, t) {
	    var r,
	        n = null === (r = Object.getOwnPropertyDescriptor) || void 0 === r ? void 0 : r.call(Object, e, t);(null == n ? void 0 : n.configurable) ? delete e[t] : n && !n.writable || (e[t] = void 0);
	  }(e, t), "function" != typeof (null == r ? void 0 : r.load)) throw new Error(w);return r;
	}function B(e) {
	  throw e instanceof Error && e.message === w ? new Error(y) : e;
	}var F = { load: K, defaultScriptUrlPattern: C, ERROR_SCRIPT_LOAD_FAIL: y, ERROR_API_KEY_EXPIRED: f, ERROR_API_KEY_INVALID: l, ERROR_API_KEY_MISSING: d, ERROR_BAD_REQUEST_FORMAT: N, ERROR_BAD_RESPONSE_FORMAT: _, ERROR_CLIENT_TIMEOUT: o, ERROR_CSP_BLOCK: u, ERROR_FORBIDDEN_ENDPOINT: p, ERROR_FORBIDDEN_HEADER: P, ERROR_FORBIDDEN_ORIGIN: h, ERROR_GENERAL_SERVER_FAILURE: T, ERROR_INSTALLATION_METHOD_RESTRICTED: c, ERROR_INTEGRATION_FAILURE: I, ERROR_NETWORK_ABORT: E, ERROR_NETWORK_CONNECTION: i, ERROR_RATE_LIMIT: A, ERROR_SERVER_TIMEOUT: v, ERROR_SUBSCRIPTION_NOT_ACTIVE: s, ERROR_TOKEN_EXPIRED: x, ERROR_TOKEN_INVALID: D, ERROR_TOKEN_MISSING: S, ERROR_UNSUPPORTED_VERSION: O, ERROR_WRONG_REGION: a, defaultEndpoint: n, defaultTlsEndpoint: R };exports.ERROR_API_KEY_EXPIRED = f, exports.ERROR_API_KEY_INVALID = l, exports.ERROR_API_KEY_MISSING = d, exports.ERROR_BAD_REQUEST_FORMAT = N, exports.ERROR_BAD_RESPONSE_FORMAT = _, exports.ERROR_CLIENT_TIMEOUT = o, exports.ERROR_CSP_BLOCK = u, exports.ERROR_FORBIDDEN_ENDPOINT = p, exports.ERROR_FORBIDDEN_HEADER = P, exports.ERROR_FORBIDDEN_ORIGIN = h, exports.ERROR_GENERAL_SERVER_FAILURE = T, exports.ERROR_INSTALLATION_METHOD_RESTRICTED = c, exports.ERROR_INTEGRATION_FAILURE = I, exports.ERROR_NETWORK_ABORT = E, exports.ERROR_NETWORK_CONNECTION = i, exports.ERROR_RATE_LIMIT = A, exports.ERROR_SCRIPT_LOAD_FAIL = y, exports.ERROR_SERVER_TIMEOUT = v, exports.ERROR_SUBSCRIPTION_NOT_ACTIVE = s, exports.ERROR_TOKEN_EXPIRED = x, exports.ERROR_TOKEN_INVALID = D, exports.ERROR_TOKEN_MISSING = S, exports.ERROR_UNSUPPORTED_VERSION = O, exports.ERROR_WRONG_REGION = a, exports.default = F, exports.defaultEndpoint = n, exports.defaultScriptUrlPattern = C, exports.defaultTlsEndpoint = R, exports.load = K;

/***/ },
/* 635 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _appActions = __webpack_require__(21);
	
	var _appActions2 = _interopRequireDefault(_appActions);
	
	var _localStorageApi = __webpack_require__(55);
	
	var _localStorageApi2 = _interopRequireDefault(_localStorageApi);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var anonymousUser = {
	    setAnonymousUserAgeValid: function setAnonymousUserAgeValid(data) {
	        return function (dispatch, getState) {
	            sessionStorage.setItem('katapulk_age_valid', data.age_valid);
	            dispatch({ type: _appActions2.default.ANONYMOUS_USER_AGE_VALID, payload: data });
	        };
	    }
	};
	
	exports.default = anonymousUser;

/***/ },
/* 636 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _appActions = __webpack_require__(21);
	
	var _appActions2 = _interopRequireDefault(_appActions);
	
	var _localStorageApi = __webpack_require__(55);
	
	var _localStorageApi2 = _interopRequireDefault(_localStorageApi);
	
	var _user = __webpack_require__(344);
	
	var _user2 = _interopRequireDefault(_user);
	
	var _placedOrder = __webpack_require__(236);
	
	var _placedOrder2 = _interopRequireDefault(_placedOrder);
	
	var _user3 = __webpack_require__(102);
	
	var _user4 = _interopRequireDefault(_user3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var auth = {
	    login: function login(accessResponse, locale) {
	        return function (dispatch, getState) {
	            dispatch({
	                type: _appActions2.default.LOGIN,
	                payload: accessResponse
	            });
	            dispatch(auth.checkAuthTimeout(accessResponse.expires_in));
	            dispatch(_placedOrder2.default.clearPlacedOrder());
	
	            _user4.default.getUser({ token: accessResponse.access_token, locale: locale }).then(function (response) {
	                dispatch({
	                    type: _appActions2.default.USER,
	                    payload: _extends({
	                        id: response.body.data.id
	                    }, response.body.data.attributes)
	                });
	                _localStorageApi2.default.save(getState());
	            });
	
	            _localStorageApi2.default.save(getState());
	        };
	    },
	
	    authCheckState: function authCheckState() {
	        return function (dispatch, getState) {
	            if (getState().user.id) {
	                _user4.default.refreshToken(getState().auth.refresh_token).then(function (response) {
	                    dispatch({
	                        type: _appActions2.default.LOGIN,
	                        payload: _extends({}, response.body)
	                    });
	                    dispatch(auth.checkAuthTimeout(response.body.expires_in));
	                    _localStorageApi2.default.save(getState());
	                }).catch(function (err) {
	                    console.log(err);
	                    console.log(err.Error);
	                    dispatch(_user2.default.logout());
	                });
	            }
	        };
	    },
	
	    checkAuthTimeout: function checkAuthTimeout(expirationTime) {
	        return function (dispatch, getState) {
	            console.log(expirationTime);
	            setTimeout(function () {
	                dispatch(auth.authCheckState());
	            }, expirationTime * 1000);
	        };
	    }
	};
	
	exports.default = auth;

/***/ },
/* 637 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _appActions = __webpack_require__(21);
	
	var _appActions2 = _interopRequireDefault(_appActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var backgroundDisabled = {
	    setBackgroundDisabled: function setBackgroundDisabled(payload) {
	        return {
	            type: _appActions2.default.SET_BACKGROUND_DISABLED,
	            payload: payload
	        };
	    }
	};
	
	exports.default = backgroundDisabled;

/***/ },
/* 638 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(41);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _reactRouterRedux = __webpack_require__(30);
	
	var _reactReduxToastr = __webpack_require__(42);
	
	var _checkout = __webpack_require__(650);
	
	var _checkout2 = _interopRequireDefault(_checkout);
	
	var _checkoutStepCalculator = __webpack_require__(54);
	
	var _checkoutStepCalculator2 = _interopRequireDefault(_checkoutStepCalculator);
	
	var _invalidCheckoutStep = __webpack_require__(781);
	
	var _invalidCheckoutStep2 = _interopRequireDefault(_invalidCheckoutStep);
	
	var _invalidOrderTransition = __webpack_require__(782);
	
	var _invalidOrderTransition2 = _interopRequireDefault(_invalidOrderTransition);
	
	var _loader = __webpack_require__(235);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _order = __webpack_require__(172);
	
	var _order2 = _interopRequireDefault(_order);
	
	var _error = __webpack_require__(342);
	
	var _error2 = _interopRequireDefault(_error);
	
	var _appRoutes = __webpack_require__(22);
	
	var _appRoutes2 = _interopRequireDefault(_appRoutes);
	
	var _appActions = __webpack_require__(21);
	
	var _appActions2 = _interopRequireDefault(_appActions);
	
	var _appTranslations = __webpack_require__(33);
	
	var _appTranslations2 = _interopRequireDefault(_appTranslations);
	
	var _cartState = __webpack_require__(234);
	
	var _cartState2 = _interopRequireDefault(_cartState);
	
	var _constants = __webpack_require__(363);
	
	var _checkoutDataCalculator = __webpack_require__(811);
	
	var _checkoutDataCalculator2 = _interopRequireDefault(_checkoutDataCalculator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var checkout = {
	    goToPrevStep: function goToPrevStep(orderObj, locale, currentStep) {
	        return function () {
	            var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee2(dispatch, getState) {
	                var orderState, checkoutSteps, prevStep, predecessorStep, formData, token, apiPromise;
	                return _regenerator2.default.wrap(function _callee2$(_context2) {
	                    while (1) {
	                        switch (_context2.prev = _context2.next) {
	                            case 0:
	                                // Show Loader
	                                // Send prev request to API.
	                                // If success ->
	                                //    reset the order
	                                //    re-route to the prev step.
	                                //    hide loader
	                                // If failed ->
	                                //    Do not touch the order.
	                                //    hide loader
	
	                                // Edge Cases:
	                                // Return if order is already complete.
	
	                                dispatch(_loader2.default.displayLoader());
	
	                                orderState = orderObj.state;
	                                checkoutSteps = orderObj.checkout_steps;
	
	                                if (!_checkoutStepCalculator2.default.isLastStep(checkoutSteps, orderState)) {
	                                    _context2.next = 7;
	                                    break;
	                                }
	
	                                // TODO: Show message
	                                // dispatch(flash.showFlash('Your order has already been placed. Thanks!'));
	                                dispatch((0, _reactRouterRedux.push)(_appRoutes2.default.homePageRoute));
	                                _context2.next = 15;
	                                break;
	
	                            case 7:
	                                prevStep = _checkoutStepCalculator2.default.previous(checkoutSteps, currentStep);
	                                predecessorStep = _checkoutStepCalculator2.default.previous(checkoutSteps, prevStep);
	                                formData = _checkoutDataCalculator2.default.calculateFormToStep(orderObj, predecessorStep);
	                                token = getState().order.token;
	                                apiPromise = _checkout2.default.update({ token: token, locale: locale, formData: formData });
	                                _context2.next = 14;
	                                return apiPromise.then(function () {
	                                    var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee(response) {
	                                        var newOrder;
	                                        return _regenerator2.default.wrap(function _callee$(_context) {
	                                            while (1) {
	                                                switch (_context.prev = _context.next) {
	                                                    case 0:
	                                                        dispatch(_order2.default.updateOrderInState(response.body));
	
	                                                        newOrder = getState().order;
	                                                        _context.next = 4;
	                                                        return checkout._fetchNextRoute(newOrder, predecessorStep, token, locale, dispatch, getState);
	
	                                                    case 4:
	                                                        _context.t0 = _context.sent;
	                                                        _context.t1 = (0, _reactRouterRedux.push)(_context.t0);
	                                                        _context.next = 8;
	                                                        return dispatch(_context.t1);
	
	                                                    case 8:
	                                                        dispatch(_loader2.default.hideLoader());
	
	                                                    case 9:
	                                                    case 'end':
	                                                        return _context.stop();
	                                                }
	                                            }
	                                        }, _callee, undefined);
	                                    }));
	
	                                    return function (_x3) {
	                                        return _ref2.apply(this, arguments);
	                                    };
	                                }(), function (error) {
	                                    dispatch(_loader2.default.hideLoader());
	                                    _reactReduxToastr.toastr.error(_appTranslations2.default[locale].error, error.response.body.error);
	                                });
	
	                            case 14:
	                                return _context2.abrupt('return', apiPromise);
	
	                            case 15:
	                            case 'end':
	                                return _context2.stop();
	                        }
	                    }
	                }, _callee2, undefined);
	            }));
	
	            return function (_x, _x2) {
	                return _ref.apply(this, arguments);
	            };
	        }();
	    },
	
	    goToNextStep: function goToNextStep(orderObj, locale) {
	        var formData = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	        var shouldRedirect = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
	        var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
	        return function () {
	            var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(dispatch, getState) {
	                var orderState, checkoutSteps, currentStep, token, apiPromise;
	                return _regenerator2.default.wrap(function _callee4$(_context4) {
	                    while (1) {
	                        switch (_context4.prev = _context4.next) {
	                            case 0:
	                                // Show Loader
	                                // Send next request to API.
	                                // If success ->
	                                //    reset the order
	                                //    re-route to the next step.
	                                //    hide loader
	                                // If failed ->
	                                //    Do not touch the order.
	                                //    hide loader
	
	                                // Edge Cases:
	                                // Return if order is already complete.
	
	                                dispatch(_loader2.default.displayLoader());
	
	                                orderState = orderObj.state;
	                                checkoutSteps = orderObj.checkout_steps;
	
	                                if (!_checkoutStepCalculator2.default.isLastStep(checkoutSteps, orderState)) {
	                                    _context4.next = 7;
	                                    break;
	                                }
	
	                                // TODO: Show message
	                                // dispatch(flash.showFlash('Your order has already been placed. Thanks!'));
	                                dispatch((0, _reactRouterRedux.push)(_appRoutes2.default.homePageRoute));
	                                _context4.next = 13;
	                                break;
	
	                            case 7:
	                                currentStep = getState().currentCheckoutStep;
	                                token = getState().order.token;
	                                apiPromise = _checkout2.default.update({ token: token, locale: locale, formData: formData });
	                                _context4.next = 12;
	                                return apiPromise.then(function () {
	                                    var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(response) {
	                                        var newOrder;
	                                        return _regenerator2.default.wrap(function _callee3$(_context3) {
	                                            while (1) {
	                                                switch (_context3.prev = _context3.next) {
	                                                    case 0:
	                                                        if (!(currentStep === 'address')) {
	                                                            _context3.next = 3;
	                                                            break;
	                                                        }
	
	                                                        _context3.next = 3;
	                                                        return _checkout2.default.getPaymentMethods({ locale: locale, token: token }).then(function (response) {
	                                                            var paymentMethods = response.body.data;
	
	                                                            dispatch(checkout.addPaymentMethods(paymentMethods));
	                                                        });
	
	                                                    case 3:
	
	                                                        dispatch(_order2.default.updateOrderInState(response.body));
	
	                                                        newOrder = getState().order;
	                                                        _context3.next = 7;
	                                                        return checkout._fetchNextRoute(newOrder, currentStep, token, locale, dispatch, getState, shouldRedirect, options);
	
	                                                    case 7:
	                                                        _context3.t0 = _context3.sent;
	                                                        _context3.t1 = (0, _reactRouterRedux.push)(_context3.t0);
	                                                        _context3.next = 11;
	                                                        return dispatch(_context3.t1);
	
	                                                    case 11:
	                                                        dispatch(_loader2.default.hideLoader());
	
	                                                    case 12:
	                                                    case 'end':
	                                                        return _context3.stop();
	                                                }
	                                            }
	                                        }, _callee3, undefined);
	                                    }));
	
	                                    return function (_x9) {
	                                        return _ref4.apply(this, arguments);
	                                    };
	                                }(), function (error) {
	                                    dispatch(_loader2.default.hideLoader());
	                                    _reactReduxToastr.toastr.error(_appTranslations2.default[locale].error, error.response.body.error);
	                                });
	
	                            case 12:
	                                return _context4.abrupt('return', apiPromise);
	
	                            case 13:
	                            case 'end':
	                                return _context4.stop();
	                        }
	                    }
	                }, _callee4, undefined);
	            }));
	
	            return function (_x7, _x8) {
	                return _ref3.apply(this, arguments);
	            };
	        }();
	    },
	
	    addPaymentMethods: function addPaymentMethods(paymentMethodsResponse) {
	        return {
	            type: _appActions2.default.ADD_PAYMENT_METHOD,
	            payload: paymentMethodsResponse
	        };
	    },
	
	    getRedsysInfo: function getRedsysInfo() {
	        return function () {
	            var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(dispatch, getState) {
	                var token, response;
	                return _regenerator2.default.wrap(function _callee5$(_context5) {
	                    while (1) {
	                        switch (_context5.prev = _context5.next) {
	                            case 0:
	                                token = getState().order.token;
	                                _context5.next = 3;
	                                return _checkout2.default.getRedsysInfo({ token: token });
	
	                            case 3:
	                                response = _context5.sent;
	
	                                dispatch({ type: _appActions2.default.ADD_REDSYS_PAYMENT_INFO, payload: response.body });
	
	                            case 5:
	                            case 'end':
	                                return _context5.stop();
	                        }
	                    }
	                }, _callee5, undefined);
	            }));
	
	            return function (_x10, _x11) {
	                return _ref5.apply(this, arguments);
	            };
	        }();
	    },
	    addRedsysPaymentError: function addRedsysPaymentError(error) {
	        return { type: _appActions2.default.ADD_REDSYS_PAYMENT_ERROR, payload: error };
	    },
	
	    setIsFetching: function setIsFetching(isFetching) {
	        return {
	            type: _appActions2.default.SET_FETCHING_DATA,
	            payload: isFetching
	        };
	    },
	
	    _fetchNextRoute: function () {
	        var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee6(orderObj, currentStep, token, locale, dispatch, getState) {
	            var shouldRedirect = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : true;
	            var options = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : {};
	            return _regenerator2.default.wrap(function _callee6$(_context6) {
	                while (1) {
	                    switch (_context6.prev = _context6.next) {
	                        case 0:
	                            _context6.prev = 0;
	                            _context6.next = 3;
	                            return checkout._nextCheckoutStepRoute(orderObj, currentStep, token, locale, dispatch, getState, shouldRedirect, options);
	
	                        case 3:
	                            return _context6.abrupt('return', _context6.sent);
	
	                        case 6:
	                            _context6.prev = 6;
	                            _context6.t0 = _context6['catch'](0);
	
	                            if (!(_context6.t0 instanceof _invalidCheckoutStep2.default)) {
	                                _context6.next = 10;
	                                break;
	                            }
	
	                            return _context6.abrupt('return', _appRoutes2.default.cartPageRoute);
	
	                        case 10:
	                            if (!(_context6.t0 instanceof _invalidOrderTransition2.default)) {
	                                _context6.next = 12;
	                                break;
	                            }
	
	                            return _context6.abrupt('return', _appRoutes2.default.homePageRoute);
	
	                        case 12:
	                        case 'end':
	                            return _context6.stop();
	                    }
	                }
	            }, _callee6, undefined, [[0, 6]]);
	        }));
	
	        function _fetchNextRoute(_x14, _x15, _x16, _x17, _x18, _x19) {
	            return _ref6.apply(this, arguments);
	        }
	
	        return _fetchNextRoute;
	    }(),
	
	    _nextCheckoutStepRoute: function () {
	        var _ref7 = _asyncToGenerator(_regenerator2.default.mark(function _callee7(orderObj, currentStep, token, locale, dispatch, getState, shouldRedirect) {
	            var options = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : {};
	            var currentStepIndex, nextStep, nextStepIndex, orderStepIndex;
	            return _regenerator2.default.wrap(function _callee7$(_context7) {
	                while (1) {
	                    switch (_context7.prev = _context7.next) {
	                        case 0:
	                            currentStepIndex = orderObj.checkout_steps.indexOf(currentStep.trim());
	
	                            /* If currentStep is a valid step and not the last step.
	                            Last step is 'complete' which means order is placed. */
	
	                            if (!(currentStepIndex > -1 || currentStep === 'cart')) {
	                                _context7.next = 32;
	                                break;
	                            }
	
	                            if (_checkoutStepCalculator2.default.isLastStep(orderObj.checkout_steps, currentStep)) {
	                                _context7.next = 29;
	                                break;
	                            }
	
	                            nextStep = _checkoutStepCalculator2.default.next(orderObj.checkout_steps, currentStep, shouldRedirect);
	
	                            if (!(nextStep !== 'complete')) {
	                                _context7.next = 17;
	                                break;
	                            }
	
	                            nextStepIndex = orderObj.checkout_steps.indexOf(nextStep.trim());
	                            orderStepIndex = orderObj.checkout_steps.indexOf(orderObj.state.trim());
	
	                            if (!(nextStepIndex > orderStepIndex && currentStep !== 'cart')) {
	                                _context7.next = 14;
	                                break;
	                            }
	
	                            if (currentStep === 'address') {
	                                dispatch(_error2.default.clearErrorLineItems());
	                            }
	
	                            dispatch(checkout.setIsFetching(true));
	                            _context7.next = 12;
	                            return _checkout2.default.next({ token: token, locale: locale, zone: getState().zones.currentZone }).then(function (response) {
	                                dispatch(_order2.default.updateOrderInState(response.body));
	                                dispatch((0, _reactRouterRedux.push)(_appRoutes2.default.checkout[nextStep + 'PageRoute']));
	                                dispatch(checkout.setIsFetching(false));
	                            }, function (error) {
	                                if (error && error.response && error.response.status === 422 && error.response.body.errors && error.response.body.errors.shipments && error.response.body.errors.shipments.length > 0) {
	                                    var lineItems = [];
	                                    error.response.body.errors.shipments.forEach(function (items) {
	                                        lineItems = [].concat(_toConsumableArray(lineItems), _toConsumableArray(JSON.parse(items)));
	                                    });
	                                    dispatch(_error2.default.doErrorLineItems(lineItems));
	                                    dispatch((0, _reactRouterRedux.push)(_appRoutes2.default.cartPageRoute));
	                                } else {
	                                    dispatch((0, _reactRouterRedux.push)(_appRoutes2.default.checkout[currentStep + 'PageRoute']));
	                                    if (currentStep === 'payment') {
	                                        _reactReduxToastr.toastr.error(_appTranslations2.default[locale]['payment-error'], error.response.body.error);
	                                    } else {
	                                        _reactReduxToastr.toastr.error(_appTranslations2.default[locale].error, error.response.body.error);
	                                    }
	                                }
	                                dispatch(checkout.setIsFetching(false));
	                            });
	
	                        case 12:
	                            _context7.next = 15;
	                            break;
	
	                        case 14:
	                            dispatch((0, _reactRouterRedux.push)(_appRoutes2.default.checkout[nextStep + 'PageRoute']));
	
	                        case 15:
	                            _context7.next = 27;
	                            break;
	
	                        case 17:
	                            _context7.prev = 17;
	                            _context7.next = 20;
	                            return _checkout2.default.complete({ token: token, locale: locale, zone: getState().zones.currentZone }).then(function () {
	                                dispatch(_cartState2.default.setHasExtraTimeCheckout(false));
	                                dispatch({ type: _appActions2.default.SET_CURRENT_CHECKOUT_STEP, payload: 'complete' });
	                                dispatch((0, _reactRouterRedux.push)(_appRoutes2.default.checkout[nextStep + 'PageRoute']));
	                            }, function (error) {
	                                var _error$response = error.response;
	                                var statusCode = _error$response.statusCode;
	                                var body = _error$response.body;
	
	                                var incognitoModeErrorCause = 'incognito_mode_not_allowed';
	                                if (statusCode === _constants.HTTP_ERRORS.HTTP_418 || statusCode === _constants.HTTP_ERRORS.HTTP_422 && body.cause && body.cause === incognitoModeErrorCause) {
	                                    dispatch({ type: _appActions2.default.COMPLETE_ORDER_ERROR, payload: body });
	                                } else {
	                                    _reactReduxToastr.toastr.error(_appTranslations2.default[locale].error, body.error);
	                                }
	                                if (options && options.onCompleteError) {
	                                    options.onCompleteError(error);
	                                }
	                            });
	
	                        case 20:
	                            _context7.next = 27;
	                            break;
	
	                        case 22:
	                            _context7.prev = 22;
	                            _context7.t0 = _context7['catch'](17);
	
	                            console.log(_context7.t0);
	                            dispatch({ type: _appActions2.default.ADD_ORDER_ERROR, payload: 'error' });
	                            dispatch((0, _reactRouterRedux.push)(_appRoutes2.default.checkout.failPageRoute));
	
	                        case 27:
	                            _context7.next = 30;
	                            break;
	
	                        case 29:
	                            throw new _invalidOrderTransition2.default();
	
	                        case 30:
	                            _context7.next = 33;
	                            break;
	
	                        case 32:
	                            throw new _invalidCheckoutStep2.default();
	
	                        case 33:
	                        case 'end':
	                            return _context7.stop();
	                    }
	                }
	            }, _callee7, undefined, [[17, 22]]);
	        }));
	
	        function _nextCheckoutStepRoute(_x21, _x22, _x23, _x24, _x25, _x26, _x27) {
	            return _ref7.apply(this, arguments);
	        }
	
	        return _nextCheckoutStepRoute;
	    }()
	};
	
	exports.default = checkout;

/***/ },
/* 639 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _appActions = __webpack_require__(21);
	
	var _appActions2 = _interopRequireDefault(_appActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var countries = {
	    addBillingCountries: function addBillingCountries(countriesResponse) {
	        return {
	            type: _appActions2.default.ADD_COUNTRIES_BILLING,
	            payload: countriesResponse
	        };
	    },
	    addShippingCountries: function addShippingCountries(countriesResponse) {
	        return {
	            type: _appActions2.default.ADD_COUNTRIES_SHIPPING,
	            payload: countriesResponse
	        };
	    }
	};
	
	exports.default = countries;

/***/ },
/* 640 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _appActions = __webpack_require__(21);
	
	var _appActions2 = _interopRequireDefault(_appActions);
	
	var _localStorageApi = __webpack_require__(55);
	
	var _localStorageApi2 = _interopRequireDefault(_localStorageApi);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var locale = {
	    setLocale: function setLocale(locale) {
	        return function (dispatch, getState) {
	            if (getState().locale.currentLocale !== locale && window.zE) {
	                window.zE('webWidget', 'setLocale', locale);
	            }
	            dispatch({ type: _appActions2.default.SET_LOCALE, payload: { locale: locale } });
	            _localStorageApi2.default.save(getState());
	        };
	    }
	};
	
	exports.default = locale;

/***/ },
/* 641 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _appActions = __webpack_require__(21);
	
	var _appActions2 = _interopRequireDefault(_appActions);
	
	var _localStorageApi = __webpack_require__(55);
	
	var _localStorageApi2 = _interopRequireDefault(_localStorageApi);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var municipalities = {
	    setAvailableMunicipalities: function setAvailableMunicipalities(availableMunicipalities) {
	        return function (dispatch, getState) {
	            dispatch({
	                type: _appActions2.default.SET_AVAILABLE_MUNICIPALITIES,
	                payload: availableMunicipalities
	            });
	            _localStorageApi2.default.save(getState());
	        };
	    },
	    setCurrentMunicipality: function setCurrentMunicipality(municipalityId) {
	        return function (dispatch, getState) {
	            dispatch({
	                type: _appActions2.default.SET_CURRENT_MUNICIPALITY,
	                payload: municipalityId
	            });
	            _localStorageApi2.default.save(getState());
	        };
	    },
	    setIsMunicipalityPromptModalOpen: function setIsMunicipalityPromptModalOpen(isOpen) {
	        return function (dispatch, getState) {
	            dispatch({
	                type: _appActions2.default.SET_IS_MUNICIPALITY_PROMPT_MODAL_OPEN,
	                payload: isOpen
	            });
	        };
	    }
	};
	
	exports.default = municipalities;

/***/ },
/* 642 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _appActions = __webpack_require__(21);
	
	var _appActions2 = _interopRequireDefault(_appActions);
	
	var _localStorageApi = __webpack_require__(55);
	
	var _localStorageApi2 = _interopRequireDefault(_localStorageApi);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var navigation = {
	    addKatapulkNavigation: function addKatapulkNavigation(navigation) {
	        return function (dispatch, getState) {
	            dispatch({
	                type: _appActions2.default.ADD_KATAPULK_NAVIGATION,
	                payload: {
	                    navigation: {
	                        katapulk: navigation
	                    }
	                }
	            });
	            _localStorageApi2.default.save(getState());
	        };
	    }
	};
	
	exports.default = navigation;

/***/ },
/* 643 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _appActions = __webpack_require__(21);
	
	var _appActions2 = _interopRequireDefault(_appActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var orderList = {
	    addOrders: function addOrders(ordersResponse, meta) {
	        return {
	            type: _appActions2.default.ADD_ORDERS,
	            payload: {
	                orders: ordersResponse,
	                meta: {
	                    totalCount: meta.total_count,
	                    totalPages: meta.total_pages
	                }
	            }
	        };
	    },
	
	    addOrder: function addOrder(order, meta) {
	        return {
	            type: _appActions2.default.ADD_ORDER,
	            payload: {
	                order: order,
	                meta: {
	                    totalCount: meta.total_count,
	                    totalPages: meta.total_pages
	                }
	            }
	        };
	    }
	};
	
	exports.default = orderList;

/***/ },
/* 644 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _appActions = __webpack_require__(21);
	
	var _appActions2 = _interopRequireDefault(_appActions);
	
	var _taxonModel = __webpack_require__(816);
	
	var _taxonModel2 = _interopRequireDefault(_taxonModel);
	
	var _navigationModel = __webpack_require__(814);
	
	var _navigationModel2 = _interopRequireDefault(_navigationModel);
	
	var _products = __webpack_require__(346);
	
	var _products2 = _interopRequireDefault(_products);
	
	var _helper = __webpack_require__(60);
	
	var _municipalityService = __webpack_require__(122);
	
	var _municipalityService2 = _interopRequireDefault(_municipalityService);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var products = {
	    addProducts: function addProducts(productsResponse) {
	        return {
	            type: _appActions2.default.ADD_PRODUCTS,
	            payload: productsResponse
	        };
	    },
	
	    addAllStoreProducts: function addAllStoreProducts(productsResponse) {
	        return {
	            type: _appActions2.default.ADD_PRODUCTS_FROM_ALL_STORES,
	            payload: productsResponse
	        };
	    },
	
	    appendProducts: function appendProducts(productsResponse) {
	        return {
	            type: _appActions2.default.APPEND_PRODUCTS,
	            payload: productsResponse
	        };
	    },
	
	    addProduct: function addProduct(product) {
	        return {
	            type: _appActions2.default.ADD_PRODUCT,
	            payload: product
	        };
	    },
	
	    fetchProducts: function fetchProducts() {
	        var paramsToMerge = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	        return function (dispatch, getState) {
	            var currentState = getState();
	
	            var currentPathName = currentState.routing.location.pathname;
	            var taxon = _taxonModel2.default.findByPermalink(currentPathName, currentState.taxons.fetchedTaxons);
	
	            var params = (0, _helper.getParamsFromWindowLocationSearch)();
	
	            if (params.price_min) {
	                paramsToMerge.price = params.price_min;
	                if (params.price_max) {
	                    paramsToMerge.price += ',' + params.price_max;
	                }
	            }
	
	            paramsToMerge.storeId = params.store_id ? params.store_id : currentState.stores.currentStore.id;
	
	            paramsToMerge.searchTerm = params.query || '';
	
	            if (params.category) {
	                var fetchedTaxons = currentState.taxons.taxonsMenu.find(function (taxons) {
	                    return taxons.store.id === currentState.stores.currentStore.id;
	                });
	                if (fetchedTaxons) {
	                    fetchedTaxons.taxons.find(function (storeTaxons) {
	                        if (params.category === storeTaxons.taxonCategory.permalink) {
	                            taxon = storeTaxons.taxonCategory;
	                            return taxon;
	                        }
	                        taxon = _taxonModel2.default.findByPermalink(params.category, storeTaxons.taxons, '');
	                        return taxon;
	                    });
	                }
	                paramsToMerge.searchTerm = '';
	            }
	
	            if (currentState.zones.currentZone) {
	                paramsToMerge.zone = currentState.zones.currentZone;
	            }
	
	            if (taxon) {
	                paramsToMerge.taxonId = taxon.id;
	                paramsToMerge.searchTerm = '';
	            }
	
	            var _currentState$zones = currentState.zones;
	            var availableZones = _currentState$zones.availableZones;
	            var currentZone = _currentState$zones.currentZone;
	            var _currentState$municip = currentState.municipalities;
	            var availableMunicipalities = _currentState$municip.availableMunicipalities;
	            var currentMunicipality = _currentState$municip.currentMunicipality;
	
	            var selectedZoneMunicipalities = _municipalityService2.default.getAvailableMunicipalitiesByZoneId(currentZone, availableZones, availableMunicipalities);
	            if (currentMunicipality && !_municipalityService2.default.isMunicipalitySelectorModalRequired(currentMunicipality, selectedZoneMunicipalities)) {
	                paramsToMerge.municipality = currentState.municipalities.currentMunicipality;
	            }
	
	            return _products2.default.getList(paramsToMerge);
	        };
	    },
	
	    fetchAllStoreProducts: function fetchAllStoreProducts() {
	        var paramsToMerge = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	        return function (dispatch, getState) {
	            var currentState = getState();
	
	            var params = (0, _helper.getParamsFromWindowLocationSearch)();
	
	            paramsToMerge.searchTerm = params.query || '';
	
	            if (currentState.zones.currentZone) {
	                paramsToMerge.zone = currentState.zones.currentZone;
	            }
	
	            if (currentState.municipalities.currentMunicipality) {
	                paramsToMerge.municipality = currentState.municipalities.currentMunicipality;
	            }
	
	            return _products2.default.getAllStoreList(paramsToMerge);
	        };
	    }
	};
	
	exports.default = products;

/***/ },
/* 645 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _appActions = __webpack_require__(21);
	
	var _appActions2 = _interopRequireDefault(_appActions);
	
	var _store = __webpack_require__(173);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _localStorageApi = __webpack_require__(55);
	
	var _localStorageApi2 = _interopRequireDefault(_localStorageApi);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var Stores = {
	    loadStores: function loadStores() {
	        return function (dispatch, getState) {
	            return _store2.default.getStores().then(function (response) {
	                dispatch({ type: _appActions2.default.ADD_STORES, payload: response.body });
	                _localStorageApi2.default.save(getState());
	                return response.body;
	            });
	        };
	    },
	    loadGroupedStores: function loadGroupedStores() {
	        return function (dispatch, getState) {
	            return _store2.default.getGroupedStores().then(function (response) {
	                dispatch({ type: _appActions2.default.ADD_STORES_GROUPED, payload: response.body });
	                _localStorageApi2.default.save(getState());
	                return response.body;
	            });
	        };
	    },
	    setCurrentStore: function setCurrentStore(store) {
	        return function (dispatch, getState) {
	            dispatch({ type: _appActions2.default.SET_CURRENT_STORE, payload: store });
	            _localStorageApi2.default.save(getState());
	            return store;
	        };
	    },
	    loadStorePayments: function loadStorePayments(store) {
	        return function (dispatch, getState) {
	            return _store2.default.getStorePayments(store.id).then(function (response) {
	                dispatch({ type: _appActions2.default.SET_CURRENT_STORE, payload: _extends({}, store, { payments: [].concat(_toConsumableArray(response.body)) }) });
	
	                _localStorageApi2.default.save(getState());
	                return response.body;
	            });
	        };
	    },
	    getStoresByZone: function getStoresByZone(zoneId, page, limit) {
	        return function (dispatch, getState) {
	            return _store2.default.getStoresByZone(zoneId, page, limit).then(function (response) {
	                dispatch({ type: _appActions2.default.ADD_STORES_BY_ZONE, payload: { storesByZone: response.body.data, pageCount: response.body.pagination.total_pages } });
	                _localStorageApi2.default.save(getState());
	                return response.body;
	            });
	        };
	    }
	};
	
	exports.default = Stores;

/***/ },
/* 646 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _appActions = __webpack_require__(21);
	
	var _appActions2 = _interopRequireDefault(_appActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Taxons = {
	    addTaxons: function addTaxons(taxons) {
	        return {
	            type: _appActions2.default.ADD_TAXONS,
	            payload: taxons
	        };
	    }
	};
	
	exports.default = Taxons;

/***/ },
/* 647 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(41);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _appActions = __webpack_require__(21);
	
	var _appActions2 = _interopRequireDefault(_appActions);
	
	var _wallets = __webpack_require__(240);
	
	var _wallets2 = _interopRequireDefault(_wallets);
	
	var _localStorageApi = __webpack_require__(55);
	
	var _localStorageApi2 = _interopRequireDefault(_localStorageApi);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	exports.default = {
	    fetchWalletTransactions: function fetchWalletTransactions(params, wallet, token) {
	        return function (dispatch, getState) {
	            return _wallets2.default.getWalletTransactions({
	                wallet: wallet,
	                token: token,
	                params: params
	            });
	        };
	    },
	    fetchWalletDetails: function fetchWalletDetails(wallet, token) {
	        return function (dispatch, getState) {
	            return _wallets2.default.getWalletDetails({
	                wallet: wallet,
	                token: token
	            });
	        };
	    },
	    activeWallet: function activeWallet(wallet, token) {
	        var forceCheck = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	        return function () {
	            var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(dispatch, getState) {
	                var _getState, wallets;
	
	                return _regenerator2.default.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                _getState = getState();
	                                wallets = _getState.wallets;
	
	                                if (!(typeof wallets[wallet] === 'boolean' && !forceCheck)) {
	                                    _context.next = 4;
	                                    break;
	                                }
	
	                                return _context.abrupt('return', wallets[wallet]);
	
	                            case 4:
	                                _context.next = 6;
	                                return _wallets2.default.getWalletIsActive({
	                                    wallet: wallet,
	                                    token: token
	                                });
	
	                            case 6:
	                                wallets[wallet] = _context.sent;
	
	                                dispatch({
	                                    type: _appActions2.default.UPDATE_WALLETS,
	                                    payload: wallets
	                                });
	                                _localStorageApi2.default.save(getState());
	                                return _context.abrupt('return', wallets[wallet]);
	
	                            case 10:
	                            case 'end':
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, undefined);
	            }));
	
	            return function (_x2, _x3) {
	                return _ref.apply(this, arguments);
	            };
	        }();
	    },
	    activateWallet: function activateWallet(wallet, token) {
	        return function (dispatch, getState) {
	            return _wallets2.default.activateWallet({
	                wallet: wallet,
	                token: token
	            }).then(function (response) {
	                var _getState2 = getState();
	
	                var wallets = _getState2.wallets;
	
	                wallets[wallet] = true; // response.value;
	                dispatch({
	                    type: _appActions2.default.UPDATE_WALLETS,
	                    payload: wallets
	                });
	                _localStorageApi2.default.save(getState());
	                return true;
	            }).catch(function (error) {
	                return false;
	            });
	        };
	    },
	    transferWalletFunds: function transferWalletFunds(_ref2) {
	        var wallet = _ref2.wallet;
	        var token = _ref2.token;
	        var amount = _ref2.amount;
	        var idTransfer = _ref2.idTransfer;
	        return function (dispatch, getState) {
	            return _wallets2.default.sendFunds({
	                wallet: wallet, token: token, amount: amount, idTransfer: idTransfer
	            });
	        };
	    }
	};

/***/ },
/* 648 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _appActions = __webpack_require__(21);
	
	var _appActions2 = _interopRequireDefault(_appActions);
	
	var _localStorageApi = __webpack_require__(55);
	
	var _localStorageApi2 = _interopRequireDefault(_localStorageApi);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// let pendingCheckIds = [];
	
	var zones = {
	    setAvailableZones: function setAvailableZones(zones) {
	        return {
	            type: _appActions2.default.SET_AVAILABLE_ZONES,
	            payload: zones
	        };
	    },
	    setCurrentZone: function setCurrentZone(zoneId) {
	        return function (dispatch, getState) {
	            dispatch({
	                type: _appActions2.default.SET_CURRENT_ZONE,
	                payload: zoneId
	            });
	            var _getState$stores = getState().stores;
	            var data = _getState$stores.storesGrouped.data;
	            var currentStore = _getState$stores.currentStore;
	            var stores = _getState$stores.stores;
	
	            if (data && data[zoneId]) {
	                if (data[zoneId].find(function (store) {
	                    return currentStore.id === store.id;
	                }) === undefined) {
	                    dispatch({
	                        type: _appActions2.default.SET_CURRENT_STORE,
	                        payload: data[zoneId][0]
	                    });
	                }
	            }
	            _localStorageApi2.default.save(getState());
	        };
	    }
	};
	
	exports.default = zones;

/***/ },
/* 649 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _productModel = __webpack_require__(143);
	
	var _productModel2 = _interopRequireDefault(_productModel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SpreeAPIProductAdapter = {
	    processList: function processList(productsListAMS) {
	        productsListAMS.data.forEach(function (product) {
	            SpreeAPIProductAdapter._process(product, productsListAMS);
	        });
	
	        return productsListAMS;
	    },
	
	    processItem: function processItem(productAMS) {
	        var product = productAMS.data;
	
	        SpreeAPIProductAdapter._process(product, productAMS);
	
	        return product;
	    },
	
	    /*
	    PRIVATE METHODS
	    */
	    _addMasterImages: function _addMasterImages(product, productsListAMS) {
	        if (product.master && product.master.relationships && product.master.relationships.images) {
	            product.master.images = _productModel2.default.images(product.master.relationships.images.data.map(function (a) {
	                return a.id;
	            }), productsListAMS);
	        }
	    },
	
	    _addVariantImages: function _addVariantImages(product, productsListAMS) {
	        product.variants.forEach(function (variant) {
	            if (variant.relationships && variant.relationships.images) {
	                variant.images = _productModel2.default.images(variant.relationships.images.data.map(function (a) {
	                    return a.id;
	                }), productsListAMS);
	            }
	        });
	    },
	
	    _process: function _process(product, AMSResponse) {
	        if (product.relationships && product.relationships.variants) {
	            product.master = _productModel2.default.masterVariant(product.relationships.default_variant.data.id, AMSResponse);
	            product.variants = _productModel2.default.variants(product.relationships.variants.data.map(function (a) {
	                return a.id;
	            }), AMSResponse);
	            product.data_extra_types = _productModel2.default.data_extra_types(product.relationships.data_extra_types ? product.relationships.data_extra_types.data.map(function (a) {
	                return a.id;
	            }) : [], AMSResponse);
	        }
	
	        if (product.relationships && product.relationships.images) {
	            product.images = _productModel2.default.images(product.relationships.images.data.map(function (a) {
	                return a.id;
	            }), AMSResponse);
	        }
	
	        SpreeAPIProductAdapter._addMasterImages(product, AMSResponse);
	        SpreeAPIProductAdapter._addVariantImages(product, AMSResponse);
	    }
	
	};
	
	exports.default = SpreeAPIProductAdapter;

/***/ },
/* 650 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _spreeApiOrderAdapter = __webpack_require__(237);
	
	var _spreeApiOrderAdapter2 = _interopRequireDefault(_spreeApiOrderAdapter);
	
	var _appRoutes = __webpack_require__(22);
	
	var _appRoutes2 = _interopRequireDefault(_appRoutes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var request = __webpack_require__(67);
	
	var CheckoutAPI = {
	    next: function next(params) {
	        var sanitizedQueryParams = {};
	        sanitizedQueryParams.locale = params.locale;
	        sanitizedQueryParams.zone = params.zone;
	
	        return request
	        // eslint-disable-next-line max-len
	        .patch(("https://staging.api.cubalicores.com") + '/api/v2/storefront/checkout/next?include=line_items,variants,variants.images,variants.product.images,billing_address,shipping_address,user,payments,shipments,promotions,shipments.shipping_rates,line_items.data_extras,variants.product.data_extra_types').set('X-Spree-Order-Token', params.token).set('Content-Type', 'application/vnd.api+json').query(sanitizedQueryParams).then(function (response) {
	            response.body = _spreeApiOrderAdapter2.default.processItem(response.body);
	            return response;
	        });
	    },
	
	    update: function update(params) {
	        var sanitizedQueryParams = {};
	        sanitizedQueryParams.locale = params.locale;
	
	        return request
	        // eslint-disable-next-line max-len
	        .patch(("https://staging.api.cubalicores.com") + '/api/v2/storefront/checkout?include=line_items,variants,variants.images,variants.product.images,billing_address,shipping_address,user,payments,shipments,promotions,shipments.shipping_rates,line_items.data_extras,variants.product.data_extra_types').set('X-Spree-Order-Token', params.token).set('Content-Type', 'application/vnd.api+json').query(sanitizedQueryParams).send(params.formData).then(function (response) {
	            response.body = _spreeApiOrderAdapter2.default.processItem(response.body);
	            return response;
	        });
	    },
	
	    complete: function complete(params) {
	        var sanitizedQueryParams = {};
	        sanitizedQueryParams.locale = params.locale;
	        sanitizedQueryParams.zone = params.zone;
	
	        return request
	        // eslint-disable-next-line max-len
	        .patch(("https://staging.api.cubalicores.com") + '/api/v2/storefront/checkout/complete?include=line_items,variants,variants.images,variants.product.images,billing_address,shipping_address,user,payments,shipments,promotions,shipments.shipping_rates,line_items.data_extras,variants.product.data_extra_types').set('X-Spree-Order-Token', params.token).set('Content-Type', 'application/vnd.api+json').query(sanitizedQueryParams).then(function (response) {
	            response.body = _spreeApiOrderAdapter2.default.processItem(response.body);
	
	            return response;
	        });
	    },
	
	    getPaymentMethods: function getPaymentMethods(params) {
	        var sanitizedQueryParams = {};
	        sanitizedQueryParams.locale = params.locale;
	
	        return request.get(("https://staging.api.cubalicores.com") + '/api/v2/storefront/checkout/available_payment_methods').set('X-Spree-Order-Token', params.token).set('Content-Type', 'application/vnd.api+json').query(sanitizedQueryParams).then(function (response) {
	            return response;
	        });
	    },
	
	    getRedsysInfo: function getRedsysInfo(params) {
	        var sanitizedQueryParams = {};
	        sanitizedQueryParams.locale = params.locale;
	        sanitizedQueryParams.url_ok = '' + window.location.origin + _appRoutes2.default.checkout.redsysRedirectOk;
	        sanitizedQueryParams.url_ko = '' + window.location.origin + _appRoutes2.default.checkout.redsysRedirectKo;
	
	        return request.get(("https://staging.api.cubalicores.com") + '/api/v2/storefront/checkout/redsys_params').set('X-Spree-Order-Token', params.token).set('Content-Type', 'application/vnd.api+json').query(sanitizedQueryParams).then(function (response) {
	            return response;
	        });
	    }
	};
	
	exports.default = CheckoutAPI;

/***/ },
/* 651 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var request = __webpack_require__(67);
	
	var ConfigsAPI = {
	    getConfigs: function getConfigs() {
	        return request.get(("https://staging.api.cubalicores.com") + '/api/v1/version').set('Accept', 'application/json').send();
	    }
	};
	
	exports.default = ConfigsAPI;

/***/ },
/* 652 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var request = __webpack_require__(67);
	
	var MunicipalityAPI = {
	    getMunicipalities: function getMunicipalities() {
	        return request.get(("https://staging.api.cubalicores.com") + '/api/v1/municipality/get_all_municipalities').set('Accept', 'application/json').send().then(function (response) {
	            return Object.keys(response.body).reduce(function (acc, current) {
	                return [].concat(_toConsumableArray(acc), _toConsumableArray(response.body[current]));
	            }, []);
	        });
	    }
	};
	
	exports.default = MunicipalityAPI;

/***/ },
/* 653 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var request = __webpack_require__(67);
	
	var ZoneAPI = {
	    getZones: function getZones() {
	        return request.get(("https://staging.api.cubalicores.com") + '/api/v1/zones/zones_with_countries').set('Accept', 'application/json').send();
	    }
	};
	
	exports.default = ZoneAPI;

/***/ },
/* 654 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(38);
	
	var _reactIntl = __webpack_require__(11);
	
	var _reduxForm = __webpack_require__(61);
	
	var _reactRedux = __webpack_require__(18);
	
	var _differenceInYears = __webpack_require__(274);
	
	var _differenceInYears2 = _interopRequireDefault(_differenceInYears);
	
	var _locale = __webpack_require__(445);
	
	var _dateFns = __webpack_require__(278);
	
	var _ageValidModal = __webpack_require__(2136);
	
	var _ageValidModal2 = _interopRequireDefault(_ageValidModal);
	
	var _katapulk_logo = __webpack_require__(463);
	
	var _katapulk_logo2 = _interopRequireDefault(_katapulk_logo);
	
	var _actions = __webpack_require__(23);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var validate = function validate(values) {
	    var errors = {};
	    if (!values.day) {
	        errors.day = 'required-message';
	    }
	
	    if (!values.month) {
	        errors.month = 'required-message';
	    }
	
	    if (!values.year) {
	        errors.year = 'required-message';
	    }
	
	    if (values.year && values.month && values.day) {
	        var parsed = (0, _dateFns.parse)(values.day + '/' + values.month + '/' + values.year, 'dd/MM/yyyy', new Date());
	
	        if (!(0, _dateFns.isValid)(parsed)) {
	            errors.day = 'is-not-valid-date';
	        }
	    }
	
	    return errors;
	};
	
	var renderSelectField = function renderSelectField(_ref) {
	    var input = _ref.input;
	    var _ref$meta = _ref.meta;
	    var touched = _ref$meta.touched;
	    var error = _ref$meta.error;
	    var children = _ref.children;
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	            'div',
	            { className: _ageValidModal2.default.inputBox },
	            _react2.default.createElement(
	                'select',
	                _extends({}, input, { className: _ageValidModal2.default.formInput }),
	                children
	            )
	        ),
	        touched && error && _react2.default.createElement(
	            'div',
	            { className: _ageValidModal2.default.errorMsg },
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: error, defaultMessage: error })
	        )
	    );
	};
	
	var AgeValidModal = function (_Component) {
	    _inherits(AgeValidModal, _Component);
	
	    function AgeValidModal(props) {
	        _classCallCheck(this, AgeValidModal);
	
	        var _this = _possibleConstructorReturn(this, (AgeValidModal.__proto__ || Object.getPrototypeOf(AgeValidModal)).call(this, props));
	
	        _this.handleFormSubmit = _this.handleFormSubmit.bind(_this);
	        var startYear = new Date().getFullYear() - 8;
	        _this.state = { days: Array.from({ length: 31 }, function (_, i) {
	                return i + 1;
	            }), months: Array.from({ length: 12 }, function (_, i) {
	                return i + 1;
	            }), years: Array.from({ length: 60 }, function (_, i) {
	                return startYear - i;
	            }) };
	        return _this;
	    }
	
	    _createClass(AgeValidModal, [{
	        key: 'handleFormSubmit',
	        value: function handleFormSubmit(formData) {
	            if (!formData.day || !formData.month || !formData.year) {
	                return;
	            }
	            var selectedDay = (0, _dateFns.parse)(formData.day + '/' + formData.month + '/' + formData.year, 'dd/MM/yyyy', new Date());
	            var currentDate = new Date();
	            var years = (0, _differenceInYears2.default)(currentDate, selectedDay);
	            var ageValid = years >= 21;
	
	            if (this.props.user.id) {
	                this.props.setAgeValid(ageValid, this.props.access_token, this.props.locale.currentLocale);
	            } else {
	                this.props.setAnonymousUserAgeValid(ageValid);
	            }
	
	            this.props.onHide();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props;
	            var handleSubmit = _props.handleSubmit;
	            var valid = _props.valid;
	            var submitting = _props.submitting;
	            var pristine = _props.pristine;
	
	
	            return _react2.default.createElement(
	                _reactBootstrap.Modal,
	                {
	                    onHide: this.props.onHide,
	                    show: this.props.show,
	                    'aria-labelledby': 'contained-modal-title-lg'
	                },
	                _react2.default.createElement(
	                    'form',
	                    { onSubmit: handleSubmit(this.handleFormSubmit) },
	                    _react2.default.createElement(
	                        _reactBootstrap.Modal.Body,
	                        { className: _ageValidModal2.default.modalBody },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'row' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-md-12 text-center' },
	                                _react2.default.createElement('img', { src: _katapulk_logo2.default, alt: 'Logo', className: _ageValidModal2.default.logo })
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'row margin-top-20' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-md-12 text-center' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: _ageValidModal2.default.title },
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'certify-age-title-1-message', defaultMessage: 'Hello, product with' })
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: _ageValidModal2.default.title },
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'certify-age-title-2-message', defaultMessage: 'age restriction?' })
	                                ),
	                                _react2.default.createElement(
	                                    'p',
	                                    { className: _ageValidModal2.default.textInfo },
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'certify-age-enter-birthday', defaultMessage: 'Please enter your date of birth:' })
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'row ' + _ageValidModal2.default.fieldsContainer },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-lg-4 col-md-4 col-sm-4 col-xs-4' },
	                                _react2.default.createElement(
	                                    _reduxForm.Field,
	                                    {
	                                        name: 'day',
	                                        component: renderSelectField,
	                                        locale: this.props.currentLocale
	                                    },
	                                    _react2.default.createElement(
	                                        'option',
	                                        { value: '', disabled: true },
	                                        'DD'
	                                    ),
	                                    this.state.days.map(function (day) {
	                                        return _react2.default.createElement(
	                                            'option',
	                                            { key: day, value: day },
	                                            day
	                                        );
	                                    })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-lg-4 col-md-4 col-sm-4 col-xs-4' },
	                                _react2.default.createElement(
	                                    _reduxForm.Field,
	                                    {
	                                        name: 'month',
	                                        component: renderSelectField
	                                    },
	                                    _react2.default.createElement(
	                                        'option',
	                                        { value: '', disabled: true },
	                                        'MM'
	                                    ),
	                                    this.state.months.map(function (month) {
	                                        return _react2.default.createElement(
	                                            'option',
	                                            { key: month, value: month },
	                                            month
	                                        );
	                                    })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-lg-4 col-md-4 col-sm-4 col-xs-4' },
	                                _react2.default.createElement(
	                                    _reduxForm.Field,
	                                    {
	                                        name: 'year',
	                                        component: renderSelectField
	                                    },
	                                    _react2.default.createElement(
	                                        'option',
	                                        { value: '', disabled: true },
	                                        'YYYY'
	                                    ),
	                                    this.state.years.map(function (year) {
	                                        return _react2.default.createElement(
	                                            'option',
	                                            { key: year, value: year },
	                                            year
	                                        );
	                                    })
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'row margin-top-20' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-md-12 margin-top-20 text-center' },
	                                _react2.default.createElement(
	                                    'button',
	                                    { className: 'form-control btn btn-default ' + _ageValidModal2.default.button, type: 'submit', disabled: submitting },
	                                    _react2.default.createElement(
	                                        'span',
	                                        null,
	                                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'valid-age-enter', defaultMessage: 'Enter' })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'p',
	                                    { className: _ageValidModal2.default.textInfo + ' ' + _ageValidModal2.default.textInfoSmall },
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'certify-age-message', defaultMessage: 'Upon entering I am certifying that I am really over 21 years of age.' })
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return AgeValidModal;
	}(_react.Component);
	
	var AgeValidModalForm = (0, _reduxForm.reduxForm)({
	    form: 'age-min-form', // a unique identifier for this form
	    validate: validate
	})(AgeValidModal);
	
	var AgeValidModalConnector = (0, _reactRedux.connect)(function (state) {
	    return {
	        anonymousUser: state.anonymousUser,
	        user: state.user,
	        access_token: state.auth.access_token,
	        initialValues: {},
	        locale: state.locale
	    };
	}, function (dispatch) {
	    return {
	        setAnonymousUserAgeValid: function setAnonymousUserAgeValid(ageValid) {
	            dispatch(_actions2.default.setAnonymousUserAgeValid({ age_valid: ageValid }));
	        },
	        setAgeValid: function setAgeValid(validAge, accessToken, locale) {
	            dispatch(_actions2.default.setAgeValid(validAge, accessToken, locale));
	        }
	    };
	})(AgeValidModalForm);
	
	exports.default = AgeValidModalConnector;

/***/ },
/* 655 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(26);
	
	var _reactDotdotdot = __webpack_require__(1845);
	
	var _reactDotdotdot2 = _interopRequireDefault(_reactDotdotdot);
	
	var _reactIntl = __webpack_require__(11);
	
	var _lineItem = __webpack_require__(2137);
	
	var _lineItem2 = _interopRequireDefault(_lineItem);
	
	var _categoryBadge = __webpack_require__(244);
	
	var _categoryBadge2 = _interopRequireDefault(_categoryBadge);
	
	var _helper = __webpack_require__(60);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var WAIT_INTERVAL = 1000;
	var ENTER_KEY = 13;
	
	var LineItem = function (_Component) {
	    _inherits(LineItem, _Component);
	
	    function LineItem(props) {
	        _classCallCheck(this, LineItem);
	
	        var _this = _possibleConstructorReturn(this, (LineItem.__proto__ || Object.getPrototypeOf(LineItem)).call(this, props));
	
	        _this.onChangeQuantity = function (e) {
	            if (parseInt(e.target.value, 10) < _this.props.lineItem.attributes.top) {
	                _this.setState({
	                    // eslint-disable-next-line radix
	                    quantity: parseInt(e.target.value)
	                });
	            }
	        };
	
	        _this.handleCheck = function () {
	            // eslint-disable-next-line radix
	            _this.props.changeQuantity(_this.props.lineItem.id, parseInt(_this.state.quantity), _this.props.currentZone, _this.props.locale.currentLocale);
	            // Clears running timer and starts a new one each time the user types
	            // clearTimeout(this.timer);
	            // this.timer = setTimeout(() => {
	            //     // eslint-disable-next-line radix
	            //     this.props.changeQuantity(this.props.lineItem.id, parseInt(this.state.quantity), this.props.locale.currentLocale);
	            // }, WAIT_INTERVAL);
	        };
	
	        _this.minus = function () {
	            _this.setState(function (prevState) {
	                return {
	                    quantity: _this.props.lineItem.attributes.quantity - 1
	                };
	            });
	            _this.props.disablingPlus(false);
	        };
	
	        _this.plus = function () {
	            if (_this.props.lineItem.attributes.top === null || _this.props.lineItem.attributes.quantity < _this.props.lineItem.attributes.top) {
	                _this.setState(function (prevState) {
	                    return {
	                        quantity: prevState.quantity + 1
	                    };
	                });
	            }
	            if (_this.props.lineItem.attributes.quantity + 1 === _this.props.lineItem.attributes.top) {
	                _this.props.disablingPlus(true);
	            }
	        };
	
	        _this.buildPhones = function (data, types) {
	            if (types) {
	                var phoneType = types.find(function (_ref) {
	                    var attributes = _ref.attributes;
	                    return attributes.field_type === 'phone';
	                });
	                var phoneData = data.filter(function (_ref2) {
	                    var attributes = _ref2.attributes;
	                    return attributes.type_id === Number(phoneType.id);
	                });
	
	                return phoneData.map(function (_ref3) {
	                    var id = _ref3.id;
	                    var attributes = _ref3.attributes;
	                    return _react2.default.createElement(
	                        'div',
	                        { className: _lineItem2.default.phoneRow, key: attributes.value },
	                        _react2.default.createElement(
	                            'span',
	                            null,
	                            (0, _helper.getPhone)(attributes.value)
	                        ),
	                        phoneData.length > 1 ? _react2.default.createElement(
	                            'button',
	                            {
	                                type: 'button',
	                                disabled: _this.props.order.removingProductToCart || _this.props.order.addingProductToCart,
	                                className: 'cart-delete-button-small',
	                                onClick: function onClick() {
	                                    return _this.props.destroyDataExtra(id, _this.props.locale.currentLocale);
	                                }
	                            },
	                            _react2.default.createElement('i', { className: 'pe-7f-trash' })
	                        ) : null
	                    );
	                });
	            }
	
	            return null;
	        };
	
	        _this.state = {
	            quantity: _this.props.lineItem.attributes.quantity
	        };
	
	        _this.destroyLineItem = _this.destroyLineItem.bind(_this);
	        // this.onChangeQuantity = this.onChangeQuantity.bind(this);
	        // this.triggerChange = this.triggerChange.bind(this);
	        _this.minus = _this.minus.bind(_this);
	        _this.plus = _this.plus.bind(_this);
	
	        _this.timer = null;
	        return _this;
	    }
	
	    _createClass(LineItem, [{
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps, prevState) {
	            if (prevState.quantity !== this.state.quantity) {
	                this.handleCheck();
	            }
	        }
	    }, {
	        key: 'getCategory',
	        value: function getCategory() {
	            if (this.props.lineItem && this.props.lineItem.shipping_category && this.props.lineItem.shipping_category.name && this.props.lineItem.shipping_category.name !== 'Default') {
	                return this.props.lineItem.shipping_category.name;
	            }
	            return null;
	        }
	    }, {
	        key: 'destroyLineItem',
	        value: function destroyLineItem(lineItem) {
	            if (this.props.lineItemsCount > 1) {
	                this.props.destroyLineItem(lineItem, this.props.locale.currentLocale);
	            } else {
	                this.props.emptyCart(this.props.order, this.props.locale.currentLocale);
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var discountPercent = (this.props.lineItem.attributes.price - this.props.lineItem.attributes.discounted_amount) * 100 / this.props.lineItem.attributes.price;
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'row card-horizontal-holder', key: this.props.productSlug },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-lg-6 col-md-6 col-sm-12 col-xs-12' },
	                    this.getCategory() && _react2.default.createElement(_categoryBadge2.default, { label: this.getCategory(), color: '#FE6902', expand: true }),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'row left' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-lg-4 col-md-4 col-sm-4 col-xs-4 image-product' },
	                            _react2.default.createElement(
	                                _reactRouterDom.Link,
	                                {
	                                    to: '/products/' + this.props.productSlug,
	                                    className: 'cart-image-link'
	                                },
	                                _react2.default.createElement('img', {
	                                    className: 'cart-image',
	                                    alt: this.props.lineItem.attributes.name,
	                                    src: this.props.imageUrl
	                                })
	                            ),
	                            discountPercent > 0 && _react2.default.createElement(
	                                'div',
	                                { className: 'discount' },
	                                '-',
	                                discountPercent,
	                                '%'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-lg-8 col-md-8 col-sm-8 col-xs-8 info-product' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'row product-name' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-lg-12 col-md-12 col-sm-12 col-xs-12' },
	                                    _react2.default.createElement(
	                                        _reactRouterDom.Link,
	                                        { to: '/products/' + this.props.productSlug },
	                                        _react2.default.createElement(
	                                            'h3',
	                                            null,
	                                            this.props.lineItem.attributes.name
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: _lineItem2.default.phones },
	                                        this.buildPhones(this.props.lineItem.data_extras, this.props.lineItem.data_extra_types)
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'row product-description' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-lg-12 col-md-12 col-sm-12 col-xs-12' },
	                                    _react2.default.createElement(
	                                        _reactDotdotdot2.default,
	                                        { clamp: 4 },
	                                        _react2.default.createElement(
	                                            'p',
	                                            null,
	                                            this.props.lineItem.attributes.description
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-lg-6 col-md-6 col-sm-12 col-xs-12' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                            'div',
	                            {
	                                className: 'col-lg-offset-2 col-lg-3 col-md-offset-2 col-md-3 col-sm-offset-1 col-sm-3 col-xs-4'
	                            },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'cart-item-price-col' },
	                                this.props.lineItem.attributes.display_price
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-lg-3 col-md-3 col-sm-3 col-xs-4' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'quantity-prods' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'selector-quantity' },
	                                    _react2.default.createElement(
	                                        'button',
	                                        {
	                                            className: 'minus',
	                                            type: 'button',
	                                            onClick: this.minus,
	                                            disabled: this.state.quantity === 1 || this.props.order.addingProductToCart || this.props.order.removingProductToCart || this.props.lineItem.data_extras.length !== 0 || this.props.errorShipping ? 'disabled' : ''
	                                        },
	                                        '-'
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'quantity-container' },
	                                        _react2.default.createElement('input', {
	                                            type: 'text',
	                                            value: this.props.lineItem.attributes.quantity,
	                                            name: 'quantity',
	                                            className: 'qty-number cart-item-qty-input',
	                                            autoComplete: 'off',
	                                            readOnly: true
	                                        })
	                                    ),
	                                    _react2.default.createElement(
	                                        'button',
	                                        {
	                                            className: 'plus',
	                                            disabled: this.props.order.addingProductToCart || this.props.order.disablingAdd || !this.props.lineItem.attributes.available || this.props.order.removingProductToCart || this.props.lineItem.data_extras.length !== 0 || this.props.errorShipping,
	                                            type: 'button',
	                                            onClick: this.plus
	                                        },
	                                        '+'
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-lg-3 col-md-3 col-sm-3 col-xs-4' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'cart-item-subtotal-col' },
	                                this.props.lineItem.attributes.display_discounted_amount
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'btn-action-holder' },
	                            _react2.default.createElement(
	                                'button',
	                                {
	                                    type: 'button',
	                                    disabled: this.props.order.removingProductToCart || this.props.order.addingProductToCart,
	                                    className: 'cart-delete-button',
	                                    onClick: function onClick() {
	                                        return _this2.destroyLineItem(_this2.props.lineItem);
	                                    }
	                                },
	                                _react2.default.createElement('i', { className: 'pe-7f-trash' })
	                            )
	                        )
	                    ),
	                    this.props.errorShipping && _react2.default.createElement(
	                        'div',
	                        { className: 'row shipping-address-problems-item-container' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'shipping-address-problems-item' },
	                            _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                id: 'shipping-address-problems-item',
	                                defaultMessage: 'Cannot be shipped to the select address.'
	                            })
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return LineItem;
	}(_react.Component);
	
	exports.default = (0, _reactIntl.injectIntl)(LineItem);

/***/ },
/* 656 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(26);
	
	var _reactIntl = __webpack_require__(11);
	
	var _layout = __webpack_require__(29);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _urlSanitizer = __webpack_require__(123);
	
	var _urlSanitizer2 = _interopRequireDefault(_urlSanitizer);
	
	var _appRoutes = __webpack_require__(22);
	
	var _appRoutes2 = _interopRequireDefault(_appRoutes);
	
	var _appDefaults = __webpack_require__(39);
	
	var _appDefaults2 = _interopRequireDefault(_appDefaults);
	
	var _securityIcons = __webpack_require__(355);
	
	var _securityIcons2 = _interopRequireDefault(_securityIcons);
	
	var _noImageSmall = __webpack_require__(465);
	
	var _noImageSmall2 = _interopRequireDefault(_noImageSmall);
	
	var _lineItem = __webpack_require__(655);
	
	var _lineItem2 = _interopRequireDefault(_lineItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CartShow = function (_Component) {
	    _inherits(CartShow, _Component);
	
	    function CartShow(props) {
	        _classCallCheck(this, CartShow);
	
	        var _this = _possibleConstructorReturn(this, (CartShow.__proto__ || Object.getPrototypeOf(CartShow)).call(this, props));
	
	        _this.groupItemsByCategory = function (items) {
	            var groups = {};
	            var result = [];
	            items.forEach(function (elem) {
	                if (groups[elem.shipping_category.name]) {
	                    groups[elem.shipping_category.name].push(elem);
	                } else {
	                    groups[elem.shipping_category.name] = [elem];
	                }
	            });
	            var categories = Object.keys(groups);
	            categories.forEach(function (cat) {
	                if (cat !== 'Default') {
	                    result.push.apply(result, _toConsumableArray(groups[cat]));
	                }
	            });
	            if (groups.Default) {
	                result.push.apply(result, _toConsumableArray(groups.Default));
	            }
	            return result;
	        };
	
	        _this.emptyCart = _this.emptyCart.bind(_this);
	        _this.doCheckout = _this.doCheckout.bind(_this);
	
	        document.title = _this.props.intl.formatMessage({ id: 'shopping-cart', defaultMessage: 'Shopping Cart' });
	        return _this;
	    }
	
	    _createClass(CartShow, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            if (this.props.order.created_at && !this.props.order.addingProductToCart) {
	                this.props.refreshOrder(this.props.order, this.props.locale.currentLocale);
	            }
	            this.props.setCurrentCheckoutStep();
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps) {
	            if (this.props.locale !== prevProps.locale) {
	                document.title = this.props.intl.formatMessage({ id: 'shopping-cart', defaultMessage: 'Shopping Cart' });
	            }
	        }
	    }, {
	        key: 'emptyCart',
	        value: function emptyCart() {
	            this.props.emptyCart(this.props.order, this.props.locale.currentLocale);
	        }
	    }, {
	        key: 'doCheckout',
	        value: function doCheckout() {
	            this.props.doCheckout(this.props.order, this.props.locale.currentLocale);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var lineItems = [];
	            var _props = this.props;
	            var stores = _props.stores;
	            var lineItemsError = _props.lineItemsError;
	
	
	            if (this.props.order.state !== 'complete') {
	                lineItems = this.groupItemsByCategory(this.props.order.line_items);
	            }
	
	            var itemHasError = function itemHasError(idItem) {
	                return lineItemsError && lineItemsError.length > 0
	                // eslint-disable-next-line eqeqeq
	                && !!lineItemsError.find(function (idItemError) {
	                    return idItem == idItemError;
	                });
	            };
	
	            var existItemsWithError = lineItems && lineItems.length > 0 && !!lineItems.find(function (lineItem) {
	                return itemHasError(lineItem.id);
	            });
	
	            var renderString = _react2.default.createElement(
	                'div',
	                { className: 'row text-center cart-empty-block' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-lg-12 col-md-12 col-sm-12 col-xs-12' },
	                    _react2.default.createElement(
	                        'h4',
	                        { className: 'cart-empty-text margin-top-50 margin-top-xs-20' },
	                        _react2.default.createElement(_reactIntl.FormattedMessage, {
	                            id: 'cart-is-empty',
	                            defaultMessage: 'Your cart is empty.'
	                        })
	                    ),
	                    _react2.default.createElement('br', null),
	                    _react2.default.createElement(
	                        'h4',
	                        { className: 'cart-empty-text' },
	                        _react2.default.createElement(_reactIntl.FormattedMessage, {
	                            id: 'add-few-products-to-cart',
	                            defaultMessage: 'Add few products to cart.'
	                        })
	                    ),
	                    _react2.default.createElement(
	                        _reactRouterDom.Link,
	                        {
	                            className: 'button-corner-inverter cart-button-with-glyph margin-top-50',
	                            to: _appRoutes2.default.homePageRoute
	                        },
	                        _react2.default.createElement('span', { className: 'glyphicon glyphicon-chevron-left' }),
	                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'go-shopping', defaultMessage: 'Go Shopping' })
	                    )
	                )
	            );
	
	            if (lineItems.length > 0) {
	                var lineItemList = stores && stores.filter(function (store) {
	                    return lineItems.findIndex(function (item) {
	                        return item.attributes.store_id === store.id;
	                    }) !== -1;
	                }).map(function (store, index) {
	                    return _react2.default.createElement(
	                        'div',
	                        { key: index },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'row cart-store-title' },
	                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'products-from', defaultMessage: 'Products from: ' }),
	                            store.name
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            null,
	                            lineItems.filter(function (item) {
	                                return item.attributes.store_id === store.id;
	                            }).map(function (lineItem, idx) {
	                                var variantImage = lineItem.variant && lineItem.variant.images[0];
	
	                                var imageUrl = '';
	
	                                if (variantImage) {
	                                    imageUrl = _urlSanitizer2.default.makeAbsolute(variantImage.attributes.styles[2].url);
	                                } else {
	                                    imageUrl = _noImageSmall2.default;
	                                }
	
	                                var productSlug = lineItem.variant && lineItem.attributes.slug;
	
	                                return _react2.default.createElement(_lineItem2.default, {
	                                    idx: idx,
	                                    key: 'lineitem-' + idx,
	                                    order: _this2.props.order,
	                                    lineItem: lineItem,
	                                    lineItems: lineItems.filter(function (item) {
	                                        return item.attributes.store_id === store.id;
	                                    }),
	                                    lineItemsCount: lineItems.length,
	                                    imageUrl: imageUrl,
	                                    productSlug: productSlug,
	                                    destroyLineItem: _this2.props.destroyLineItem,
	                                    destroyDataExtra: _this2.props.destroyDataExtra,
	                                    changeQuantity: _this2.props.changeQuantity,
	                                    emptyCart: _this2.props.emptyCart,
	                                    disablingPlus: _this2.props.disablingPlus,
	                                    locale: _this2.props.locale,
	                                    currentZone: _this2.props.currentZone,
	                                    errorShipping: itemHasError(lineItem.id)
	                                });
	                            })
	                        )
	                    );
	                });
	
	                lineItems.map(function (lineItem, idx) {
	                    var variantImage = lineItem.variant && lineItem.variant.images[0];
	
	                    var imageUrl = '';
	
	                    if (variantImage) {
	                        imageUrl = _urlSanitizer2.default.makeAbsolute(variantImage.attributes.styles[2].url);
	                    } else {
	                        imageUrl = _noImageSmall2.default;
	                    }
	
	                    var productSlug = lineItem.variant && lineItem.variant.attributes.slug;
	
	                    return _react2.default.createElement(_lineItem2.default, {
	                        idx: idx,
	                        key: 'lineitem-' + idx,
	                        order: _this2.props.order,
	                        lineItem: lineItem,
	                        lineItems: lineItems,
	                        lineItemsCount: lineItems.length,
	                        imageUrl: imageUrl,
	                        productSlug: productSlug,
	                        destroyLineItem: _this2.props.destroyLineItem,
	                        destroyDataExtra: _this2.props.destroyDataExtra,
	                        changeQuantity: _this2.props.changeQuantity,
	                        emptyCart: _this2.props.emptyCart,
	                        locale: _this2.props.locale,
	                        errorShipping: itemHasError(lineItem.id)
	                    });
	                });
	
	                renderString = _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'row actions-top-cart' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-lg-6 col-md-6 col-sm-6 col-xs-12 text-left margin-top-20 actions-top-cart__contain' },
	                            _react2.default.createElement(
	                                _reactRouterDom.Link,
	                                {
	                                    className: 'button-corner-inverter cart-button-with-glyph margin-left-40 actions-top-cart__contain__btn',
	                                    to: _appRoutes2.default.homePageRoute
	                                },
	                                _react2.default.createElement('span', { className: 'glyphicon glyphicon-chevron-left' }),
	                                _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                    id: 'continue-shopping',
	                                    defaultMessage: 'Continue Shopping'
	                                })
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-lg-6 col-md-6 col-sm-6 col-xs-12 text-right margin-top-20 actions-top-cart__contain' },
	                            _react2.default.createElement(
	                                'button',
	                                {
	                                    type: 'button',
	                                    className: 'button-corner cart-button-with-glyph margin-right-40 actions-top-cart__contain__btn',
	                                    onClick: this.doCheckout
	                                },
	                                _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                    id: 'proceed-to-checkout',
	                                    defaultMessage: 'Proceed to Checkout'
	                                })
	                            )
	                        )
	                    ),
	                    existItemsWithError && _react2.default.createElement(
	                        'div',
	                        { className: 'row shipping-address-problems' },
	                        _react2.default.createElement('i', { className: 'pe-7s-close-circle' }),
	                        _react2.default.createElement(_reactIntl.FormattedMessage, {
	                            id: 'shipping-address-problems',
	                            defaultMessage: 'There are problems shipping some products to the selected address. Please check your products.'
	                        })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'row cart-items-section' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'cart-items-table' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'row cart-items-table-title' },
	                                _react2.default.createElement(
	                                    'div',
	                                    {
	                                        className: 'col-lg-6 col-md-6 col-sm-12 col-xs-12 cart-items-table-title-text'
	                                    },
	                                    _react2.default.createElement('i', { className: 'pe-7s-cart' }),
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'cart', defaultMessage: 'Cart' })
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-lg-6 col-md-6 hidden-sm hidden-xs' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'row cart-table-title-right' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            {
	                                                className: 'col-lg-offset-2 col-lg-3 col-md-offset-2 col-md-3 col-sm-offset-2 col-sm-3 col-xs-offset-2 col-xs-3'
	                                            },
	                                            _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                id: 'unit-price',
	                                                defaultMessage: 'Unit price'
	                                            })
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'col-lg-3 col-md-3 col-sm-3 col-xs-3' },
	                                            _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                id: 'quantity',
	                                                defaultMessage: 'Quantity'
	                                            })
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'col-lg-3 col-md-3 col-sm-3 col-xs-3' },
	                                            _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                id: 'subtotal',
	                                                defaultMessage: 'Subtotal'
	                                            })
	                                        )
	                                    )
	                                )
	                            ),
	                            lineItemList,
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'row footer-table' },
	                                _react2.default.createElement('div', { className: 'col-lg-6 col-md-6 col-sm-12 col-xs-12' }),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-lg-6 col-md-6 col-sm-12 col-xs-12 inner-table' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'row' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'col-lg-offset-2 col-lg-6 col-md-offset-2 col-md-6 col-sm-offset-1 col-sm-6 col-xs-8' },
	                                            _react2.default.createElement(
	                                                'span',
	                                                { className: 'subtotal-title' },
	                                                _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                    id: 'subtotal',
	                                                    defaultMessage: 'Subtotal'
	                                                }),
	                                                ' ( ',
	                                                this.props.order.item_count,
	                                                ' ',
	                                                _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                    id: 'products',
	                                                    defaultMessage: 'Products'
	                                                }),
	                                                ' )'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'col-lg-4 col-md-4 col-sm-5 col-xs-4' },
	                                            _react2.default.createElement(
	                                                'span',
	                                                { className: 'result' },
	                                                this.props.order.display_item_total
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'container cart-buttons-row' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'row justify-content-end' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-4 text-right' },
	                                    _react2.default.createElement(
	                                        'button',
	                                        {
	                                            type: 'button',
	                                            className: 'button-primary button-white',
	                                            onClick: this.doCheckout
	                                        },
	                                        _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                            id: 'proceed-to-checkout',
	                                            defaultMessage: 'Place Order'
	                                        })
	                                    )
	                                )
	                            )
	                        )
	                    )
	                );
	            }
	
	            return _react2.default.createElement(
	                _layout2.default,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'cart-section' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'container' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'cart-section-heading' },
	                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'shopping-cart', defaultMessage: 'Shopping Cart' })
	                        ),
	                        _react2.default.createElement(
	                            'section',
	                            { className: 'cart-table-info' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'row text-center' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-lg-12 col-md-12 col-sm-12 col-xs-12' },
	                                    _react2.default.createElement(
	                                        'ul',
	                                        { className: 'list-inline' },
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            _react2.default.createElement(
	                                                _reactRouterDom.Link,
	                                                {
	                                                    className: 'cart-list-inline-button',
	                                                    to: _appRoutes2.default.shipping
	                                                },
	                                                _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                    id: 'shipping-policies',
	                                                    defaultMessage: 'Shipping Policies and Charges'
	                                                })
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            _react2.default.createElement(
	                                                _reactRouterDom.Link,
	                                                {
	                                                    className: 'cart-list-inline-button',
	                                                    to: _appRoutes2.default.returns
	                                                },
	                                                _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                    id: 'return-policy',
	                                                    defaultMessage: 'Return Policy'
	                                                })
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            _react2.default.createElement(
	                                                'a',
	                                                {
	                                                    role: 'button',
	                                                    className: 'cart-list-inline-button',
	                                                    href: 'mailto:' + _appDefaults2.default.info_email
	                                                },
	                                                _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                    id: 'costumer-service',
	                                                    defaultMessage: 'Customer Service'
	                                                })
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        renderString,
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'row text-center', style: { marginTop: '20px' } },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-lg-12 col-md-12 col-sm-12 col-xs-12' },
	                                _react2.default.createElement(_securityIcons2.default, null)
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return CartShow;
	}(_react.Component);
	
	exports.default = (0, _reactIntl.injectIntl)(CartShow);

/***/ },
/* 657 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(26);
	
	var _reactIntl = __webpack_require__(11);
	
	var _reactLeafCarousel = __webpack_require__(1849);
	
	var _reactLeafCarousel2 = _interopRequireDefault(_reactLeafCarousel);
	
	var _categorySlider = __webpack_require__(2154);
	
	var _categorySlider2 = _interopRequireDefault(_categorySlider);
	
	var _urlSanitizer = __webpack_require__(123);
	
	var _urlSanitizer2 = _interopRequireDefault(_urlSanitizer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CategorySlider = function (_Component) {
	    _inherits(CategorySlider, _Component);
	
	    function CategorySlider() {
	        _classCallCheck(this, CategorySlider);
	
	        return _possibleConstructorReturn(this, (CategorySlider.__proto__ || Object.getPrototypeOf(CategorySlider)).apply(this, arguments));
	    }
	
	    _createClass(CategorySlider, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var storesInZone = this.props.storesGrouped && this.props.storesGrouped.data && this.props.storesGrouped.data[this.props.currentZone] ? this.props.storesGrouped.data[this.props.currentZone] : [];
	
	            if (storesInZone.length === 0) {
	                return null;
	            }
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'container' },
	                _react2.default.createElement(
	                    'h4',
	                    {
	                        className: 'text-center ' + _categorySlider2.default.title
	                    },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'zone-store', defaultMessage: 'Stores in zone' })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-lg-12' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'mb-4' },
	                            _react2.default.createElement(
	                                _reactLeafCarousel2.default,
	                                {
	                                    className: _categorySlider2.default.categorySlider,
	                                    prevArrow: _react2.default.createElement(
	                                        'button',
	                                        {
	                                            className: 'InfiniteCarouselArrow InfiniteCarouselArrowPrev',
	                                            type: 'button',
	                                            style: { left: '0 !important' }
	                                        },
	                                        _react2.default.createElement('i', {
	                                            className: _categorySlider2.default.arrowIcon + ' InfiniteCarouselArrowIcon InfiniteCarouselArrowPrevIcon'
	                                        })
	                                    ),
	                                    nextArrow: _react2.default.createElement(
	                                        'button',
	                                        {
	                                            className: 'InfiniteCarouselArrow InfiniteCarouselArrowNext',
	                                            type: 'button',
	                                            style: { right: '0 !important' }
	                                        },
	                                        _react2.default.createElement('i', {
	                                            className: _categorySlider2.default.arrowIcon + ' InfiniteCarouselArrowIcon InfiniteCarouselArrowNextIcon'
	                                        })
	                                    ),
	                                    breakpoints: [{
	                                        breakpoint: 500,
	                                        settings: {
	                                            slidesToShow: 1,
	                                            slidesToScroll: 1
	                                        }
	                                    }, {
	                                        breakpoint: 768,
	                                        settings: {
	                                            slidesToShow: 2,
	                                            slidesToScroll: 2
	                                        }
	                                    }, {
	                                        breakpoint: 992,
	                                        settings: {
	                                            slidesToShow: 3,
	                                            slidesToScroll: 3
	                                        }
	                                    }, {
	                                        breakpoint: 1200,
	                                        settings: {
	                                            slidesToShow: 4,
	                                            slidesToScroll: 4
	                                        }
	                                    }],
	                                    dots: false,
	                                    showSides: true,
	                                    sidesOpacity: 0,
	                                    sideSize: 0.5,
	                                    slidesToScroll: 4,
	                                    slidesToShow: 6,
	                                    scrollOnDevice: true,
	                                    adaptiveHeight: true
	                                },
	                                storesInZone.map(function (store) {
	                                    return _react2.default.createElement(
	                                        'div',
	                                        {
	                                            className: _categorySlider2.default.slide,
	                                            key: store.id,
	                                            style: store.id === _this2.props.currentStore.id ? {
	
	                                                borderBottom: 'solid',
	                                                borderColor: '#d3af71'
	                                            } : {}
	                                        },
	                                        _react2.default.createElement(
	                                            _reactRouterDom.Link,
	                                            { to: '/' + store.code },
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: _categorySlider2.default.backgroundSlider },
	                                                store.logo_file_name ? _react2.default.createElement('img', {
	                                                    className: _categorySlider2.default.imageSlider,
	                                                    alt: store.name,
	                                                    src: _urlSanitizer2.default.makeAbsolute(store.logo_file_name)
	                                                }) : null,
	                                                _react2.default.createElement('div', { className: _categorySlider2.default.contentOverlay }),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: _categorySlider2.default.contentDetails + ' ' + _categorySlider2.default.fadeInBottom },
	                                                    _react2.default.createElement(
	                                                        'h4',
	                                                        null,
	                                                        store.name
	                                                    )
	                                                )
	                                            )
	                                        )
	                                    );
	                                })
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return CategorySlider;
	}(_react.Component);
	
	exports.default = CategorySlider;

/***/ },
/* 658 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(18);
	
	var _reduxForm = __webpack_require__(61);
	
	var _reactIntl = __webpack_require__(11);
	
	var _layout = __webpack_require__(29);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _baseCheckoutLayout = __webpack_require__(121);
	
	var _baseCheckoutLayout2 = _interopRequireDefault(_baseCheckoutLayout);
	
	var _addressFieldsConnector = __webpack_require__(741);
	
	var _addressFieldsConnector2 = _interopRequireDefault(_addressFieldsConnector);
	
	var _checkoutStepCalculator = __webpack_require__(54);
	
	var _checkoutStepCalculator2 = _interopRequireDefault(_checkoutStepCalculator);
	
	var _formField = __webpack_require__(103);
	
	var _formField2 = _interopRequireDefault(_formField);
	
	var _loader = __webpack_require__(65);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _validators = __webpack_require__(104);
	
	var _validators2 = _interopRequireDefault(_validators);
	
	var _appDefaults = __webpack_require__(39);
	
	var _appDefaults2 = _interopRequireDefault(_appDefaults);
	
	var _zoneService = __webpack_require__(79);
	
	var _zoneService2 = _interopRequireDefault(_zoneService);
	
	var _appRoutes = __webpack_require__(22);
	
	var _appRoutes2 = _interopRequireDefault(_appRoutes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable react/jsx-fragments */
	
	
	var AddressForm = function (_Component) {
	    _inherits(AddressForm, _Component);
	
	    function AddressForm(props) {
	        _classCallCheck(this, AddressForm);
	
	        var _this = _possibleConstructorReturn(this, (AddressForm.__proto__ || Object.getPrototypeOf(AddressForm)).call(this, props));
	
	        document.title = _this.props.intl.formatMessage({ id: 'checkout', defaultMessage: 'Checkout' });
	        return _this;
	    }
	
	    /* Render this step only if order is present and in a valid checkout state. */
	
	
	    _createClass(AddressForm, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var order = this.props.order;
	
	
	            if (!_checkoutStepCalculator2.default.isStepEditable(order.checkout_steps, 'address', order.state) && order.state !== 'cart') {
	                this.props.handleCheckoutStepNotEditable(order, this.props.placedOrder);
	            }
	
	            if (!order.id) {
	                this.props.redirectToCart();
	            }
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.props.setCurrentCheckoutStep();
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps) {
	            if (this.props.locale !== prevProps.locale) {
	                document.title = this.props.intl.formatMessage({ id: 'checkout', defaultMessage: 'Checkout' });
	            }
	        }
	    }, {
	        key: 'handleAddressFormSubmit',
	        value: function handleAddressFormSubmit(formData) {
	            var _this2 = this;
	
	            window.scrollTo(0, 0);
	            return this.props.handleAddressFormSubmit(formData, this.props.order, this.props.locale.currentLocale).then(function () {}, function (error) {
	                var sanitizedErrors = _this2._sanitizedErrorMessages(error.response.body.errors);
	                throw new _reduxForm.SubmissionError({ order: sanitizedErrors });
	            });
	        }
	
	        // eslint-disable-next-line class-methods-use-this
	
	    }, {
	        key: '_sanitizedErrorMessages',
	        value: function _sanitizedErrorMessages(errors) {
	            var _require = __webpack_require__(467);
	
	            var unflatten = _require.unflatten;
	
	
	            var unflattenedErrors = unflatten(errors);
	
	            unflattenedErrors.bill_address_attributes = unflattenedErrors.bill_address;
	            unflattenedErrors.ship_address_attributes = unflattenedErrors.ship_address;
	
	            return unflattenedErrors;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props;
	            var handleSubmit = _props.handleSubmit;
	            var valid = _props.valid;
	            var submitting = _props.submitting;
	            var change = _props.change;
	
	            return _react2.default.createElement(
	                _layout2.default,
	                null,
	                _react2.default.createElement(
	                    _baseCheckoutLayout2.default,
	                    {
	                        hasExtraTimeCheckout: this.props.hasExtraTimeCheckout,
	                        gracePeriod: this.props.gracePeriod,
	                        locale: this.props.locale.currentLocale,
	                        currentStep: 'address',
	                        checkoutSteps: this.props.order.checkout_steps || [],
	                        order: this.props.order
	                    },
	                    (submitting || this.props.fetchData.isFetching) && _react2.default.createElement(
	                        'div',
	                        { className: 'checkout-loading-container' },
	                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'saving-addresses', defaultMessage: 'Saving addresses' }),
	                        _react2.default.createElement(_loader2.default, { displayLoader: true, size: 36 })
	                    ),
	                    !this.props.fetchData.isFetching && _react2.default.createElement(
	                        'form',
	                        { onSubmit: handleSubmit(this.handleAddressFormSubmit.bind(this)), style: { display: submitting ? 'none' : 'inherit' } },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'checkout-section-title' },
	                            _react2.default.createElement('i', { className: 'pe-7s-user icon' }),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'checkout-section-title__text-container' },
	                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'yourInfo', defaultMessage: 'Your Information' }),
	                                _react2.default.createElement(
	                                    'small',
	                                    { className: 'checkout-section-title__text' },
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'yourInfoDetails', defaultMessage: 'infoDetails' })
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(_reduxForm.Field, {
	                            className: 'form-control checkout-form-row',
	                            name: 'order[email]',
	                            component: _formField2.default.inputFieldMarkup,
	                            label: this.props.intl.formatMessage({ id: 'email', defaultMessage: 'Email' }),
	                            placeholder: this.props.intl.formatMessage({ id: 'email-order-placeholder', defaultMessage: 'Email to receive the order confirmation' }),
	                            type: 'text',
	                            validate: [_validators2.default.required, _validators2.default.email]
	                        }),
	                        _react2.default.createElement(_reduxForm.Field, {
	                            name: 'order[receive_offer]',
	                            component: _formField2.default.checkboxInputFieldMarkup,
	                            type: 'checkbox',
	                            extraClassName: 'pb-5',
	                            label: this.props.intl.formatMessage({ id: 'offer-keep-update', defaultMessage: 'Keep me updated with news and exclusive offers' })
	                        }),
	                        _react2.default.createElement(_reduxForm.Field, {
	                            name: 'order[accepts_affidavit_certification]',
	                            component: _formField2.default.checkboxInputFieldMarkup,
	                            type: 'checkbox',
	                            extraClassName: 'pt-5',
	                            label: _react2.default.createElement(
	                                _react.Fragment,
	                                null,
	                                this.props.intl.formatMessage({ id: 'read-and-accept', defaultMessage: 'I have read and I accept the' }),
	                                ' ',
	                                _react2.default.createElement(
	                                    'a',
	                                    { href: _appRoutes2.default.affidavitCertification, target: '_blank' },
	                                    'Affidavit Certification'
	                                )
	                            ),
	                            validate: [_validators2.default.required]
	                        }),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'checkout-section-title' },
	                            _react2.default.createElement('i', { className: 'pe-7s-note2 icon' }),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'checkout-section-title__text-container' },
	                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'billingInfo', defaultMessage: 'Billing Info' }),
	                                _react2.default.createElement(
	                                    'small',
	                                    { className: 'checkout-section-title__text' },
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'billingInfoDetails', defaultMessage: 'billingDetails' })
	                                )
	                            )
	                        ),
	                        this.props.billCountryIso && this.props.billStateName && _react2.default.createElement(_addressFieldsConnector2.default, {
	                            fieldNamePrefix: 'order[bill_address_attributes]',
	                            selectedCountryIso: this.props.billCountryIso,
	                            selectedStateCode: this.props.billStateName,
	                            changeForm: change
	                        }),
	                        !_zoneService2.default.isDonationZone() && _react2.default.createElement(
	                            'div',
	                            { className: 'checkout-section-title' },
	                            _react2.default.createElement('i', { className: 'pe-7s-note2 icon' }),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'checkout-section-title__text-container' },
	                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'shippingInfo', defaultMessage: 'Shipping Info' }),
	                                _react2.default.createElement(
	                                    'small',
	                                    { className: 'checkout-section-title__text' },
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'shippingInfoDetails', defaultMessage: 'shippingDetails' })
	                                )
	                            )
	                        ),
	                        this.props.shipCountryIso && this.props.shipStateName && !_zoneService2.default.isDonationZone() && _react2.default.createElement(
	                            _react.Fragment,
	                            null,
	                            _react2.default.createElement(_reduxForm.Field, {
	                                className: 'form-control checkout-form-row',
	                                name: 'order[email_receiver]',
	                                component: _formField2.default.inputFieldMarkup,
	                                label: this.props.intl.formatMessage({ id: 'email', defaultMessage: 'Email*' }),
	                                placeholder: this.props.intl.formatMessage({ id: 'shippingInfoEmail', defaultMessage: 'Correo electrónico del receptor' }),
	                                type: 'text',
	                                validate: [_validators2.default.email, _validators2.default.required]
	                            }),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'receptor-email-legend' },
	                                _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                    id: 'emailReceptor',
	                                    defaultMessage: '* Enviaremos tambi\xE9n a este email las notificaciones de cambios de estado de su orden'
	                                })
	                            ),
	                            _react2.default.createElement(_addressFieldsConnector2.default, {
	                                fieldNamePrefix: 'order[ship_address_attributes]',
	                                selectedCountryIso: this.props.shipCountryIso,
	                                selectedStateCode: this.props.shipStateName,
	                                shippingStatesIds: this.props.shippingStatesIds,
	                                selectedCity: this.props.shippingCity,
	                                currentZone: this.props.currentZone,
	                                changeForm: change
	                            })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'checkout-form-row navigate' },
	                            _react2.default.createElement(
	                                'button',
	                                { type: 'submit', disabled: !valid || submitting, className: 'button--outlined ' + (submitting && 'button-disabled') },
	                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'continue', defaultMessage: 'Continue' })
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return AddressForm;
	}(_react.Component);
	
	AddressForm = (0, _reduxForm.reduxForm)({
	    form: 'addressForm'
	})(AddressForm);
	
	var selector = (0, _reduxForm.formValueSelector)('addressForm');
	
	AddressForm = (0, _reactRedux.connect)(function (state) {
	    var isCurrentZoneCuba = _zoneService2.default.isCurrentZoneCuba();
	
	    var defaultBillCountryIso = 'US';
	    var defaultBillStateName = 'FL';
	
	    var defaultShippingCountryIso = isCurrentZoneCuba ? 'CU' : 'US';
	    var defaultShippingStateCode = isCurrentZoneCuba ? 'HAB' : 'AL';
	    // const defaultShippingCity = 'Arroyo Naranjo';
	    var defaultShippingCity = state.order.municipalityInfo ? state.order.municipalityInfo.attributes.name : '';
	
	    var defaultShippingZipCode = isCurrentZoneCuba ? '10900' : '';
	
	    var shippingCountriesIds = ['51'];
	    var shippingStatesIds = ['422'];
	
	    var billCountryIso = selector(state, 'order[bill_address_attributes][country_iso]');
	    var billStateName = selector(state, 'order[bill_address_attributes][state_name]');
	
	    var shipCountryIso = selector(state, 'order[ship_address_attributes][country_iso]');
	    var shipStateName = selector(state, 'order[ship_address_attributes][state_name]');
	    var shippingCity = selector(state, 'order[ship_address_attributes][city]');
	
	    var billAddress = state.order.bill_address || {};
	    var shipAddress = state.order.ship_address || {};
	
	    var _APP_DEFAULTS$toBeDon = _appDefaults2.default.toBeDonatedInfo;
	    var zoneId = _APP_DEFAULTS$toBeDon.zoneId;
	
	    var shipAttrs = _objectWithoutProperties(_APP_DEFAULTS$toBeDon, ['zoneId']);
	
	    var shipAddressAttributes = _zoneService2.default.isDonationZone() ? shipAttrs : {
	        firstname: shipAddress.firstname || '',
	        lastname: shipAddress.lastname || '',
	        address1: shipAddress.address1 || '',
	        address2: shipAddress.address2 || '',
	        city: shipAddress.city || defaultShippingCity,
	        phone: shipAddress.phone || '',
	        zipcode: shipAddress.zipcode || defaultShippingZipCode,
	        state_name: shipAddress.state_code || defaultShippingStateCode,
	        country_iso: shipAddress.country_iso || defaultShippingCountryIso
	    };
	    return {
	        billCountryIso: billCountryIso,
	        billStateName: billStateName,
	        shipCountryIso: shipCountryIso,
	        shipStateName: shipStateName,
	        shippingCountriesIds: shippingCountriesIds,
	        shippingStatesIds: shippingStatesIds,
	        shippingCity: shippingCity,
	        // defaultBillCountryIso,
	        // defaultBillStateName,
	        // defaultShippingCountryIso,
	        // defaultShippingStateCode,
	        enableReinitialize: true,
	        initialValues: {
	            save_user_address: true,
	            order: {
	                email: state.order.email || state.user.email,
	                email_receiver: state.order.email_receiver,
	                receive_offer: true,
	                accepts_affidavit_certification: true,
	                bill_address_attributes: {
	                    firstname: billAddress.firstname || '',
	                    lastname: billAddress.lastname || '',
	                    address1: billAddress.address1 || '',
	                    address2: billAddress.address2 || '',
	                    city: billAddress.city || '',
	                    phone: billAddress.phone || '',
	                    zipcode: billAddress.zipcode || '',
	                    state_name: billAddress.state_code || defaultBillStateName,
	                    country_iso: billAddress.country_iso || defaultBillCountryIso
	                },
	                ship_address_attributes: shipAddressAttributes
	            }
	        }
	    };
	})(AddressForm);
	
	exports.default = (0, _reactIntl.injectIntl)(AddressForm);

/***/ },
/* 659 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxForm = __webpack_require__(61);
	
	var _reactIntl = __webpack_require__(11);
	
	var _countryField = __webpack_require__(349);
	
	var _countryField2 = _interopRequireDefault(_countryField);
	
	var _formField = __webpack_require__(103);
	
	var _formField2 = _interopRequireDefault(_formField);
	
	var _stateField = __webpack_require__(350);
	
	var _stateField2 = _interopRequireDefault(_stateField);
	
	var _cityField = __webpack_require__(660);
	
	var _cityField2 = _interopRequireDefault(_cityField);
	
	var _zipcodeField = __webpack_require__(661);
	
	var _zipcodeField2 = _interopRequireDefault(_zipcodeField);
	
	var _appChekout = __webpack_require__(248);
	
	var _validators = __webpack_require__(104);
	
	var _validators2 = _interopRequireDefault(_validators);
	
	var _appDefaults = __webpack_require__(39);
	
	var _appDefaults2 = _interopRequireDefault(_appDefaults);
	
	var _zoneService = __webpack_require__(79);
	
	var _zoneService2 = _interopRequireDefault(_zoneService);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AddressFields = function (_Component) {
	    _inherits(AddressFields, _Component);
	
	    function AddressFields(props) {
	        _classCallCheck(this, AddressFields);
	
	        var _this = _possibleConstructorReturn(this, (AddressFields.__proto__ || Object.getPrototypeOf(AddressFields)).call(this, props));
	
	        _this.state = {
	            loadingStates: true,
	            loadingCities: !_this.isBilling(),
	            stateList: {
	                states: []
	            },
	            citiesList: {
	                cities: []
	            },
	            zipcodesList: {
	                zipcodes: []
	            },
	            selectedStateCode: _this.props.selectedStateCode
	        };
	
	        _this.handleCountryChange = _this.handleCountryChange.bind(_this);
	        _this.handleStateChange = _this.handleStateChange.bind(_this);
	        _this.handleCityChange = _this.handleCityChange.bind(_this);
	        _this.getStatesForCountry = _this.getStatesForCountry.bind(_this);
	        _this.isBilling = _this.isBilling.bind(_this);
	        return _this;
	    }
	
	    _createClass(AddressFields, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.getAllCountries();
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps, prevState, snapshot) {
	            if (this.props.selectedCountryIso !== prevProps.selectedCountryIso) {
	                this.props.changeForm(this.props.fieldNamePrefix + '[city]', '');
	                this.props.changeForm(this.props.fieldNamePrefix + '[zipcode]', '');
	            }
	        }
	    }, {
	        key: 'getAllCountries',
	        value: function getAllCountries() {
	            var _this2 = this;
	
	            var availableFor = !this.isBilling() ? _appChekout.AVAILABLES_FOR.shipping : _appChekout.AVAILABLES_FOR.billing;
	            var shippingZone = !this.isBilling() ? this.props.currentZone : undefined;
	
	            this.props.fetchCountries(availableFor, shippingZone).then(function () {
	                _this2.getStatesForCountry(availableFor, _this2.props.selectedCountryIso, shippingZone);
	            });
	        }
	
	        /**
	         * Since the zone can have multiple states, we need to figure out the state for current municipality
	         */
	
	    }, {
	        key: 'getTargetStateBasedOnMunicipality',
	        value: function getTargetStateBasedOnMunicipality(states) {
	            var municipalityStateId = this.props.municipalityInfo.relationships.state.data.id;
	
	            return states.find(function (state) {
	                return state.id === parseInt(municipalityStateId, 10);
	            });
	        }
	    }, {
	        key: 'getTargetZipcodeBasedOnMunicipality',
	        value: function getTargetZipcodeBasedOnMunicipality(municipalities) {
	            var name = this.props.municipalityInfo.attributes.name;
	
	            return municipalities.find(function (municipality) {
	                return municipality.name.trim().toUpperCase() === name.trim().toUpperCase();
	            });
	        }
	    }, {
	        key: 'getStatesForCountry',
	        value: function getStatesForCountry(availableName, countryIso, currentZone) {
	            var _this3 = this;
	
	            if (!this.isBilling() && !currentZone) {
	                this.getAllCountries();
	                return;
	            }
	
	            var countries = this.isBilling() ? this.props.shippingCountries : this.props.billingCountries;
	            var country = countries.find(function (country) {
	                return country.iso === countryIso;
	            });
	            this.props.fetchStatesForCountry(country && country.id, availableName, currentZone).then(function (response) {
	                var selectedStateCode = null;
	                if (currentZone && response.states.length && _this3.props.municipalityInfo) {
	                    if (response.states.length > 0) {
	                        var targetState = _this3.getTargetStateBasedOnMunicipality(response.states);
	                        selectedStateCode = targetState.abbr;
	                    } else {
	                        selectedStateCode = response.states[0].abbr;
	                    }
	                }
	                _this3.setState(function (prevState) {
	                    return _extends({}, prevState, {
	                        loadingStates: false,
	                        stateList: {
	                            states: response.states
	                        },
	                        selectedStateCode: selectedStateCode || prevState.selectedStateCode
	                    });
	                });
	                _this3.props.changeForm(_this3.props.fieldNamePrefix + '[state_name]', _this3.state.selectedStateCode);
	
	                if (_appChekout.AVAILABLES_FOR.shipping === availableName) {
	                    _this3.props.fetchMunicipalitiesForCountryState(_this3.props.selectedCountryIso, _this3.state.selectedStateCode).then(function (response) {
	                        var cities = response.municipalities ? response.municipalities : [];
	
	                        var zipcodes = [];
	                        if (response.municipalities && response.municipalities.length > 0) {
	                            var targetZipcode = _this3.getTargetZipcodeBasedOnMunicipality(response.municipalities);
	                            if (targetZipcode) {
	                                zipcodes = targetZipcode.zip_code;
	                            } else {
	                                zipcodes = response.municipalities[0].zip_code;
	                            }
	                        }
	
	                        _this3.setState(function (prevState) {
	                            return _extends({}, prevState, {
	                                loadingCities: false,
	                                citiesList: {
	                                    cities: cities
	                                },
	                                zipcodesList: {
	                                    zipcodes: zipcodes
	                                }
	                            });
	                        });
	                    });
	                }
	            });
	        }
	    }, {
	        key: 'filterCities',
	        value: function filterCities(cityName) {
	            return this.state.citiesList.cities.filter(function (city) {
	                return cityName === city.name;
	            });
	        }
	    }, {
	        key: 'handleCountryChange',
	        value: function handleCountryChange(countryIso) {
	            // Start loader
	            this.setState({
	                loadingStates: true
	            });
	            this.getStatesForCountry(_appChekout.AVAILABLES_FOR.billing, countryIso);
	        }
	
	        // Load cities(municipalities) when country state change in shipping
	
	    }, {
	        key: 'handleStateChange',
	        value: function handleStateChange(stateCode) {
	            var _this4 = this;
	
	            if (!this.isBilling()) {
	                // Start loader
	                this.setState({
	                    loadingCities: true
	                });
	                this.props.fetchMunicipalitiesForCountryState(this.props.selectedCountryIso, stateCode).then(function (response) {
	                    var cities = response.municipalities ? response.municipalities : [];
	                    var zipcodes = response.municipalities && response.municipalities.length > 0 ? response.municipalities[0].zip_code : [];
	
	                    _this4.setState(function (prevState) {
	                        return _extends({}, prevState, {
	                            loadingCities: false,
	                            citiesList: {
	                                cities: cities
	                            },
	                            zipcodesList: {
	                                zipcodes: zipcodes
	                            }
	                        });
	                    });
	                    _this4.props.changeForm(_this4.props.fieldNamePrefix + '[state_name]', stateCode);
	                });
	            }
	            this.setState(function (prevState) {
	                return _extends({}, prevState, { selectedStateCode: stateCode });
	            });
	        }
	
	        // Load zipcodes when city change in shipping
	
	    }, {
	        key: 'handleCityChange',
	        value: function handleCityChange(cityName) {
	            var cities = this.filterCities(cityName);
	            var zipcodes = cities.length > 0 ? cities[0].zip_code : [];
	            this.setState(function (prevState) {
	                return _extends({}, prevState, { zipcodesList: { zipcodes: zipcodes } });
	            });
	            this.props.changeForm(this.props.fieldNamePrefix + '[zipcode]', zipcodes[0]);
	        }
	    }, {
	        key: 'isBilling',
	        value: function isBilling() {
	            return this.props.fieldNamePrefix === 'order[bill_address_attributes]';
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                null,
	                this.props.children,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-6' },
	                        _react2.default.createElement(_reduxForm.Field, {
	                            className: 'form-control',
	                            name: this.props.fieldNamePrefix + '[firstname]',
	                            component: _formField2.default.inputFieldMarkup,
	                            label: this.props.intl.formatMessage({ id: 'firstname', defaultMessage: 'First Name' }),
	                            type: 'text',
	                            validate: _validators2.default.required
	                        })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-6' },
	                        _react2.default.createElement(_reduxForm.Field, {
	                            className: 'form-control',
	                            name: this.props.fieldNamePrefix + '[lastname]',
	                            component: _formField2.default.inputFieldMarkup,
	                            label: this.props.intl.formatMessage({ id: 'lastname', defaultMessage: 'Last Name' }),
	                            type: 'text',
	                            validate: _validators2.default.required
	                        })
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-12' },
	                        _react2.default.createElement(_reduxForm.Field, {
	                            className: 'form-control',
	                            name: this.props.fieldNamePrefix + '[address1]',
	                            component: _formField2.default.inputFieldMarkup,
	                            label: this.props.intl.formatMessage({ id: 'address1', defaultMessage: 'Address Line 1' }),
	                            type: 'text',
	                            validate: _validators2.default.required
	                        })
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-12' },
	                        _react2.default.createElement(_reduxForm.Field, {
	                            className: 'form-control',
	                            name: this.props.fieldNamePrefix + '[address2]',
	                            component: _formField2.default.inputFieldMarkup,
	                            label: this.props.intl.formatMessage({ id: 'address2', defaultMessage: 'Address Line 2' }),
	                            type: 'text'
	                        })
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-4' },
	                        this.props.selectedCountryIso !== _appDefaults2.default.countryIsoCuba ? _react2.default.createElement(_reduxForm.Field, {
	                            className: 'form-control',
	                            name: this.props.fieldNamePrefix + '[city]',
	                            component: _formField2.default.inputFieldMarkup,
	                            label: this.props.intl.formatMessage({ id: 'city', defaultMessage: 'City' }),
	                            type: 'text',
	                            validate: _validators2.default.required
	                        }) : _react2.default.createElement(
	                            'div',
	                            { className: 'checkout-form-row' },
	                            _react2.default.createElement(
	                                'label',
	                                { htmlFor: 'city', className: 'checkout-form-label' },
	                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'municipality', defaultMessage: 'Municipality' })
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'checkout-form-fields' },
	                                _react2.default.createElement(_reduxForm.Field, {
	                                    name: this.props.fieldNamePrefix + '[city]',
	                                    fieldNamePrefix: this.props.fieldNamePrefix,
	                                    cities: this.state.citiesList.cities,
	                                    component: _cityField2.default,
	                                    handleCityChange: this.handleCityChange,
	                                    displayLoader: this.state.loadingCities,
	                                    validate: _validators2.default.required,
	                                    noticeChange: {
	                                        availableMunicipalities: this.props.availableMunicipalities,
	                                        setCurrentMunicipality: this.props.setCurrentMunicipality,
	                                        emptyCurrentCart: this.props.emptyCurrentCart,
	                                        goToHome: this.props.goToHome
	                                    }
	                                })
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-4' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'checkout-form-row' },
	                            _react2.default.createElement(
	                                'label',
	                                { htmlFor: 'country', className: 'checkout-form-label' },
	                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'country', defaultMessage: 'Country' })
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'checkout-form-fields' },
	                                _react2.default.createElement(_reduxForm.Field, {
	                                    name: this.props.fieldNamePrefix + '[country_iso]',
	                                    fieldNamePrefix: this.props.fieldNamePrefix,
	                                    countries: this.isBilling() ? this.props.shippingCountries : this.props.billingCountries,
	                                    component: _countryField2.default,
	                                    handleCountryChange: this.handleCountryChange,
	                                    selectedCountryIso: this.props.selectedCountryIso,
	                                    validate: _validators2.default.required
	                                })
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-4' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'checkout-form-row' },
	                            _react2.default.createElement(
	                                'label',
	                                { htmlFor: 'state', className: 'checkout-form-label' },
	                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'state', defaultMessage: 'State' })
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'checkout-form-fields' },
	                                _react2.default.createElement(_reduxForm.Field, {
	                                    name: this.props.fieldNamePrefix + '[state_name]',
	                                    fieldNamePrefix: this.props.fieldNamePrefix,
	                                    states: this.state.stateList.states || [],
	                                    component: _stateField2.default,
	                                    displayLoader: this.state.loadingStates,
	                                    handleStateChange: this.handleStateChange,
	                                    selectedStateCode: this.state.selectedStateCode,
	                                    validate: _validators2.default.required,
	                                    disabled: !this.isBilling() && _zoneService2.default.isCurrentZoneCuba()
	                                })
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-6' },
	                        this.props.selectedCountryIso === _appDefaults2.default.countryIsoCuba ? _react2.default.createElement(
	                            'div',
	                            { className: 'checkout-form-row' },
	                            _react2.default.createElement(
	                                'label',
	                                { htmlFor: 'zipcode', className: 'checkout-form-label' },
	                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'zipCode', defaultMessage: 'Zipcode' })
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'checkout-form-fields' },
	                                _react2.default.createElement(_reduxForm.Field, {
	                                    name: this.props.fieldNamePrefix + '[zipcode]',
	                                    fieldNamePrefix: this.props.fieldNamePrefix,
	                                    component: _zipcodeField2.default,
	                                    zipcodes: this.state.zipcodesList.zipcodes,
	                                    validate: [_validators2.default.required, _validators2.default.zipCode]
	                                })
	                            )
	                        ) : _react2.default.createElement(_reduxForm.Field, {
	                            className: 'form-control',
	                            name: this.props.fieldNamePrefix + '[zipcode]',
	                            component: _formField2.default.inputFieldMarkup,
	                            label: this.props.intl.formatMessage({ id: 'zipCode', defaultMessage: 'Zipcode' }),
	                            type: 'text',
	                            validate: [_validators2.default.required, _validators2.default.zipCode]
	                        })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-6' },
	                        _react2.default.createElement(_reduxForm.Field, {
	                            className: 'form-control',
	                            name: this.props.fieldNamePrefix + '[phone]',
	                            component: _formField2.default.inputFieldMarkup,
	                            label: this.props.intl.formatMessage({ id: 'phone', defaultMessage: 'Phone' }),
	                            type: 'text',
	                            validate: [_validators2.default.required, _validators2.default.phone]
	                        })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return AddressFields;
	}(_react.Component);
	
	exports.default = (0, _reactIntl.injectIntl)(AddressFields);

/***/ },
/* 660 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(11);
	
	var _loader = __webpack_require__(65);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _changeMunicipalityModal = __webpack_require__(667);
	
	var _changeMunicipalityModal2 = _interopRequireDefault(_changeMunicipalityModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CityField = function (_Component) {
	    _inherits(CityField, _Component);
	
	    function CityField(props) {
	        _classCallCheck(this, CityField);
	
	        var _this = _possibleConstructorReturn(this, (CityField.__proto__ || Object.getPrototypeOf(CityField)).call(this, props));
	
	        _this.state = {
	            showModalNoticeChange: false,
	            nextValue: null
	        };
	
	        _this.preHandleCityChange = _this.preHandleCityChange.bind(_this);
	        _this.handleCityChange = _this.handleCityChange.bind(_this);
	        _this.onAcceptChange = _this.onAcceptChange.bind(_this);
	        _this.onCancelChange = _this.onCancelChange.bind(_this);
	        return _this;
	    }
	
	    _createClass(CityField, [{
	        key: 'onAcceptChange',
	        value: function onAcceptChange() {
	            var _this2 = this;
	
	            this.setState(function (prevState) {
	                return _extends({}, prevState, {
	                    showModalNoticeChange: false
	                });
	            });
	
	            if (this.props.noticeChange) {
	                var _props$noticeChange = this.props.noticeChange;
	                var setCurrentMunicipality = _props$noticeChange.setCurrentMunicipality;
	                var availableMunicipalities = _props$noticeChange.availableMunicipalities;
	                var emptyCurrentCart = _props$noticeChange.emptyCurrentCart;
	                var goToHome = _props$noticeChange.goToHome;
	
	
	                var nextMunicipality = availableMunicipalities.find(function (municipality) {
	                    return municipality.name === _this2.state.nextValue;
	                });
	                if (nextMunicipality) {
	                    setCurrentMunicipality(nextMunicipality.id);
	                }
	                goToHome();
	                emptyCurrentCart().finally(function () {
	                    window.scrollTo(0, 0);
	                });
	            }
	            this.handleCityChange(this.state.nextValue);
	            this.setState(function (prevState) {
	                return _extends({}, prevState, {
	                    nextValue: null
	                });
	            });
	        }
	    }, {
	        key: 'onCancelChange',
	        value: function onCancelChange() {
	            this.setState(function (prevState) {
	                return _extends({}, prevState, {
	                    showModalNoticeChange: false,
	                    NextValue: null
	                });
	            });
	        }
	    }, {
	        key: 'preHandleCityChange',
	        value: function preHandleCityChange(event) {
	            event.persist();
	            if (this.props.noticeChange) {
	                this.setState(function (prevState) {
	                    return _extends({}, prevState, {
	                        showModalNoticeChange: true,
	                        nextValue: event.target.value
	                    });
	                });
	            } else {
	                this.handleCityChange(event.target.value);
	            }
	        }
	    }, {
	        key: 'handleCityChange',
	        value: function handleCityChange(value) {
	            this.props.handleCityChange(value);
	            // Trigger the redux-form onChange callback.
	            this.props.input.onChange(value);
	            this.props.input.onBlur();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props$meta = this.props.meta;
	            var touched = _props$meta.touched;
	            var error = _props$meta.error;
	
	            var errorClassName = '';
	            if (touched && error) {
	                errorClassName = 'has-error ';
	            }
	
	            var cityOptionsMarkup = this.props.cities.map(function (city, idx) {
	                return _react2.default.createElement(
	                    'option',
	                    { key: idx, value: city.name },
	                    city.name
	                );
	            });
	
	            return _react2.default.createElement(
	                'div',
	                { style: { position: 'relative' }, className: '' + errorClassName },
	                _react2.default.createElement(_changeMunicipalityModal2.default, {
	                    show: this.state.showModalNoticeChange,
	                    onAccept: this.onAcceptChange,
	                    onCancel: this.onCancelChange
	                }),
	                _react2.default.createElement(
	                    'select',
	                    {
	                        name: this.props.fieldNamePrefix + '[city]',
	                        onChange: this.preHandleCityChange,
	                        className: 'form-control primary-input-field',
	                        value: this.props.input.value,
	                        disabled: !this.props.displayLoader && this.props.cities.length === 0 || this.props.disabled
	                    },
	                    _react2.default.createElement(
	                        'option',
	                        { value: '', disabled: true },
	                        this.props.intl.formatMessage({ id: 'select', defaultMessage: 'Select' })
	                    ),
	                    cityOptionsMarkup
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { style: {
	                            position: 'absolute', top: '5px', right: '4px', backgroundColor: !this.props.displayLoader && this.props.cities.length === 0 ? '#eee' : '#fff'
	                        }
	                    },
	                    _react2.default.createElement(_loader2.default, { displayLoader: this.props.displayLoader, size: 25 })
	                ),
	                touched && error && _react2.default.createElement(
	                    'span',
	                    { className: 'help-block' },
	                    error
	                )
	            );
	        }
	    }]);
	
	    return CityField;
	}(_react.Component);
	
	exports.default = (0, _reactIntl.injectIntl)(CityField);

/***/ },
/* 661 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ZipCodeField = function (_Component) {
	    _inherits(ZipCodeField, _Component);
	
	    function ZipCodeField(props) {
	        _classCallCheck(this, ZipCodeField);
	
	        var _this = _possibleConstructorReturn(this, (ZipCodeField.__proto__ || Object.getPrototypeOf(ZipCodeField)).call(this, props));
	
	        _this.handleZipCodeChange = _this.handleZipCodeChange.bind(_this);
	        return _this;
	    }
	
	    _createClass(ZipCodeField, [{
	        key: 'handleZipCodeChange',
	        value: function handleZipCodeChange(event) {
	            // Trigger the redux-form onChange callback.
	            this.props.input.onChange(event.currentTarget.value);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props$meta = this.props.meta;
	            var touched = _props$meta.touched;
	            var error = _props$meta.error;
	
	            var errorClassName = '';
	            if (touched && error) {
	                errorClassName = 'has-error ';
	            }
	
	            var codeOptionsMarkup = this.props.zipcodes.map(function (code, idx) {
	                return _react2.default.createElement(
	                    'option',
	                    { key: idx, value: code },
	                    code
	                );
	            });
	
	            return _react2.default.createElement(
	                'div',
	                { style: { position: 'relative' }, className: '' + errorClassName },
	                _react2.default.createElement(
	                    'select',
	                    {
	                        name: this.props.fieldNamePrefix + '[zipcode]',
	                        onChange: this.handleZipCodeChange,
	                        className: 'form-control primary-input-field',
	                        value: this.props.input.value
	                    },
	                    codeOptionsMarkup
	                ),
	                touched && error && _react2.default.createElement(
	                    'span',
	                    { className: 'help-block' },
	                    error
	                )
	            );
	        }
	    }]);
	
	    return ZipCodeField;
	}(_react.Component);
	
	exports.default = ZipCodeField;

/***/ },
/* 662 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(11);
	
	var _reactRouterDom = __webpack_require__(26);
	
	var _layout = __webpack_require__(29);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _checkoutFailPage = __webpack_require__(2164);
	
	var _checkoutFailPage2 = _interopRequireDefault(_checkoutFailPage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CheckoutFailPage = function (_Component) {
	    _inherits(CheckoutFailPage, _Component);
	
	    function CheckoutFailPage(props) {
	        _classCallCheck(this, CheckoutFailPage);
	
	        var _this = _possibleConstructorReturn(this, (CheckoutFailPage.__proto__ || Object.getPrototypeOf(CheckoutFailPage)).call(this, props));
	
	        _this.renderTimeOutErrorMsg = _this.renderTimeOutErrorMsg.bind(_this);
	        _this.renderInternalErrorMsg = _this.renderInternalErrorMsg.bind(_this);
	
	        document.title = _this.props.intl.formatMessage({ id: 'checkout', defaultMessage: 'Checkout' });
	        return _this;
	    }
	
	    _createClass(CheckoutFailPage, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.props.clearOrder();
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps) {
	            if (this.props.locale !== prevProps.locale) {
	                document.title = this.props.intl.formatMessage({ id: 'checkout', defaultMessage: 'Checkout' });
	            }
	        }
	
	        // eslint-disable-next-line class-methods-use-this
	
	    }, {
	        key: 'renderTimeOutErrorMsg',
	        value: function renderTimeOutErrorMsg() {
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'h3',
	                    { className: _checkoutFailPage2.default.checkoutMsg },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'thank-for-your-buy', defaultMessage: 'Thanks for your buy' })
	                ),
	                _react2.default.createElement(
	                    'p',
	                    { className: 'margin-top-20' },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'fail-confirmation-1-message', defaultMessage: 'Thanks for your buy' })
	                ),
	                _react2.default.createElement(
	                    'p',
	                    { style: { marginTop: 3 } },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'fail-confirmation-2-message', defaultMessage: 'Otherwise we suggest to repeat the purchase' })
	                ),
	                _react2.default.createElement(
	                    'p',
	                    { className: '', style: { marginTop: 3 } },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'fail-confirmation-3-message', defaultMessage: 'Thanks for your buy' })
	                ),
	                _react2.default.createElement(
	                    'p',
	                    { className: 'margin-top-20', style: { marginTop: 3 } },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'fail-confirmation-4-message', defaultMessage: 'Thanks for your buy' })
	                ),
	                _react2.default.createElement(
	                    'p',
	                    { style: { marginTop: 3 } },
	                    _react2.default.createElement(_reactIntl.FormattedHTMLMessage, { id: 'fail-confirmation-5-message', defaultMessage: 'and our Shipping Policies and Charges' })
	                ),
	                _react2.default.createElement(
	                    'p',
	                    { style: { marginTop: 3 } },
	                    _react2.default.createElement(
	                        _reactRouterDom.Link,
	                        { to: 'frequent-questions', className: _checkoutFailPage2.default.link },
	                        'https://www.katapulk.com/frequent-questions'
	                    )
	                ),
	                _react2.default.createElement(
	                    'p',
	                    { style: { marginTop: 3 } },
	                    _react2.default.createElement(_reactIntl.FormattedHTMLMessage, { id: 'fail-confirmation-6-message', defaultMessage: 'and our Shipping Policies and Charges' })
	                ),
	                _react2.default.createElement(
	                    'p',
	                    { style: { marginTop: 3 } },
	                    _react2.default.createElement(
	                        _reactRouterDom.Link,
	                        { to: 'shipping-policy', className: _checkoutFailPage2.default.link },
	                        'https://www.katapulk.com/shipping-policy'
	                    )
	                ),
	                _react2.default.createElement(
	                    'p',
	                    { className: 'margin-top-20' },
	                    _react2.default.createElement(
	                        'strong',
	                        null,
	                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'katapulk-team', defaultMessage: 'Support Team' })
	                    )
	                )
	            );
	        }
	
	        // eslint-disable-next-line class-methods-use-this
	
	    }, {
	        key: 'renderInternalErrorMsg',
	        value: function renderInternalErrorMsg() {
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'h3',
	                    { className: _checkoutFailPage2.default.checkoutMsg },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'sorry-error-occurred-title', defaultMessage: '' })
	                ),
	                _react2.default.createElement(
	                    'p',
	                    { className: 'margin-top-20 text-center' },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'error-general-message', defaultMessage: 'An error occurred' })
	                ),
	                _react2.default.createElement(
	                    'p',
	                    { className: 'margin-top-20 text-center' },
	                    _react2.default.createElement(
	                        'strong',
	                        null,
	                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'katapulk-team', defaultMessage: 'Support Team' })
	                    )
	                )
	            );
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                _layout2.default,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'checkout-flow checkout-section' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'container' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'row' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-sm-12' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'row' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-sm-12' },
	                                        _react2.default.createElement('div', { className: 'checkout-confirmation-block' }),
	                                        this.props.placedOrder.orderError === 'timeout' ? this.renderTimeOutErrorMsg() : this.renderInternalErrorMsg()
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return CheckoutFailPage;
	}(_react.Component);
	
	exports.default = (0, _reactIntl.injectIntl)(CheckoutFailPage);

/***/ },
/* 663 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(11);
	
	var _zoneService = __webpack_require__(79);
	
	var _zoneService2 = _interopRequireDefault(_zoneService);
	
	var _address = __webpack_require__(142);
	
	var _address2 = _interopRequireDefault(_address);
	
	var _lineItem = __webpack_require__(174);
	
	var _lineItem2 = _interopRequireDefault(_lineItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ConfirmationDetail = function (_Component) {
	    _inherits(ConfirmationDetail, _Component);
	
	    function ConfirmationDetail(props) {
	        _classCallCheck(this, ConfirmationDetail);
	
	        var _this = _possibleConstructorReturn(this, (ConfirmationDetail.__proto__ || Object.getPrototypeOf(ConfirmationDetail)).call(this, props));
	
	        document.title = _this.props.intl.formatMessage({ id: 'checkout', defaultMessage: 'Checkout' });
	        return _this;
	    }
	
	    _createClass(ConfirmationDetail, [{
	        key: '_shipmentLineItemsMarkup',
	        value: function _shipmentLineItemsMarkup() {
	            var _this2 = this;
	
	            return this.props.stores && this.props.stores.filter(function (store) {
	                return _this2.props.order.line_items.findIndex(function (item) {
	                    return item.attributes.store_id === store.id;
	                }) !== -1;
	            }).map(function (store, index) {
	                return _react2.default.createElement(
	                    'div',
	                    { style: { paddingBottom: 30 }, key: index },
	                    _react2.default.createElement(
	                        'h3',
	                        null,
	                        store.name
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        _this2.props.order.line_items.filter(function (item) {
	                            return item.attributes.store_id === store.id;
	                        }).map(function (lineItem, idx) {
	                            return _react2.default.createElement(_lineItem2.default, { lineItem: lineItem, key: idx });
	                        })
	                    )
	                );
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { className: 'confirmation-form__container', style: { width: '100%' } },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-6' },
	                        _react2.default.createElement(
	                            'h4',
	                            null,
	                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'billingAddress', defaultMessage: 'Billing Address' }),
	                            ':'
	                        ),
	                        this.props.order.bill_address && _react2.default.createElement(_address2.default, { address: this.props.order.bill_address })
	                    ),
	                    !_zoneService2.default.isDonationZone() && _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-6' },
	                        _react2.default.createElement(
	                            'h4',
	                            null,
	                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'shippingAddress', defaultMessage: 'Shipping Address' }),
	                            ':'
	                        ),
	                        this.props.order.ship_address && _react2.default.createElement(_address2.default, { address: this.props.order.ship_address })
	                    )
	                ),
	                _react2.default.createElement('hr', null),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'form-group' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-12' },
	                        _react2.default.createElement(
	                            'h4',
	                            null,
	                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'orderItems', defaultMessage: 'Order Items' })
	                        ),
	                        this._shipmentLineItemsMarkup()
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ConfirmationDetail;
	}(_react.Component);
	
	exports.default = (0, _reactIntl.injectIntl)(ConfirmationDetail);

/***/ },
/* 664 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxForm = __webpack_require__(61);
	
	var _reactIntl = __webpack_require__(11);
	
	var _reactRouterDom = __webpack_require__(26);
	
	var _layout = __webpack_require__(29);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _baseCheckoutLayout = __webpack_require__(121);
	
	var _baseCheckoutLayout2 = _interopRequireDefault(_baseCheckoutLayout);
	
	var _checkoutStepCalculator = __webpack_require__(54);
	
	var _checkoutStepCalculator2 = _interopRequireDefault(_checkoutStepCalculator);
	
	var _address = __webpack_require__(142);
	
	var _address2 = _interopRequireDefault(_address);
	
	var _lineItem = __webpack_require__(174);
	
	var _lineItem2 = _interopRequireDefault(_lineItem);
	
	var _loader = __webpack_require__(65);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _appRoutes = __webpack_require__(22);
	
	var _appRoutes2 = _interopRequireDefault(_appRoutes);
	
	var _store = __webpack_require__(40);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _actions = __webpack_require__(23);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	var _zoneService = __webpack_require__(79);
	
	var _zoneService2 = _interopRequireDefault(_zoneService);
	
	var _modals = __webpack_require__(241);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ConfirmationForm = function (_Component) {
	    _inherits(ConfirmationForm, _Component);
	
	    function ConfirmationForm(props) {
	        _classCallCheck(this, ConfirmationForm);
	
	        var _this = _possibleConstructorReturn(this, (ConfirmationForm.__proto__ || Object.getPrototypeOf(ConfirmationForm)).call(this, props));
	
	        document.title = _this.props.intl.formatMessage({ id: 'checkout', defaultMessage: 'Checkout' });
	
	        _this.state = {
	            isFinalStepHappening: false
	        };
	        return _this;
	    }
	
	    /* Render this step only if order is present and in a valid checkout state. */
	
	
	    _createClass(ConfirmationForm, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _this2 = this;
	
	            var order = this.props.order;
	
	
	            if (!order.id) {
	                this.props.redirectToCart();
	            }
	
	            if (!_checkoutStepCalculator2.default.isStepEditable(order.checkout_steps, 'confirm', order.state)) {
	                this.props.handleCheckoutStepNotEditable(order, this.props.placedOrder);
	            }
	            _store2.default.subscribe(function () {
	                if (_store2.default.getState().order.isFinalStepHappening !== _this2.state.isFinalStepHappening) {
	                    _this2.setState({
	                        isFinalStepHappening: _store2.default.getState().order.isFinalStepHappening
	                    });
	                }
	            });
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.props.setCurrentCheckoutStep();
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps) {
	            if (this.props.locale !== prevProps.locale) {
	                document.title = this.props.intl.formatMessage({ id: 'checkout', defaultMessage: 'Checkout' });
	            }
	        }
	    }, {
	        key: 'handleFormSubmit',
	        value: function handleFormSubmit(formData) {
	            if (!this.state.isFinalStepHappening) {
	                _store2.default.dispatch(_actions2.default.setIsFinalStepHappening(true));
	                window.scrollTo(0, 0);
	                return this.props.handleFormSubmit(formData, this.props.order, this.props.locale.currentLocale).then(function () {}, function (error) {
	                    console.log(error);
	                }).finally(function () {
	                    _store2.default.dispatch(_actions2.default.setIsFinalStepHappening(false));
	                });
	            }
	        }
	    }, {
	        key: '_shipmentLineItemsMarkup',
	        value: function _shipmentLineItemsMarkup() {
	            var _this3 = this;
	
	            return this.props.stores && this.props.stores.filter(function (store) {
	                return _this3.props.order.line_items.findIndex(function (item) {
	                    return item.attributes.store_id === store.id;
	                }) !== -1;
	            }).map(function (store, index) {
	                return _react2.default.createElement(
	                    'div',
	                    { style: { paddingBottom: 30 }, key: index },
	                    _react2.default.createElement(
	                        'h3',
	                        null,
	                        store.name
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        _this3.props.order.line_items.filter(function (item) {
	                            return item.attributes.store_id === store.id;
	                        }).map(function (lineItem, idx) {
	                            return _react2.default.createElement(_lineItem2.default, { lineItem: lineItem, key: idx });
	                        })
	                    )
	                );
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props;
	            var handleSubmit = _props.handleSubmit;
	            var valid = _props.valid;
	            var submitting = _props.submitting;
	            var stores = _props.stores;
	
	
	            var thereAreOutOfStockItems = this.props.order.line_items.some(function (item) {
	                return item.attributes.available === false;
	            });
	
	            return _react2.default.createElement(
	                _layout2.default,
	                null,
	                _react2.default.createElement(
	                    _baseCheckoutLayout2.default,
	                    {
	                        hasExtraTimeCheckout: this.props.hasExtraTimeCheckout,
	                        gracePeriod: this.props.gracePeriod,
	                        locale: this.props.locale.currentLocale,
	                        currentStep: 'confirm',
	                        displayLoader: this.props.displayLoader,
	                        checkoutSteps: this.props.order.checkout_steps || [],
	                        order: this.props.order
	                    },
	                    _react2.default.createElement(_modals.OrderErrorModal, {
	                        show: this.props.showDialogError,
	                        onHide: this.props.onHideDialogError,
	                        orderError: this.props.orderError
	                    }),
	                    submitting && _react2.default.createElement(
	                        'div',
	                        { className: 'checkout-loading-container' },
	                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'confirming', defaultMessage: 'Confirming' }),
	                        _react2.default.createElement(_loader2.default, { displayLoader: true, size: 36 })
	                    ),
	                    _react2.default.createElement(
	                        'form',
	                        { className: 'confirmation-form__container', onSubmit: handleSubmit(this.handleFormSubmit.bind(this)), style: { display: submitting ? 'none' : 'inherit' } },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'row' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-md-6' },
	                                _react2.default.createElement(
	                                    'h4',
	                                    null,
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'billingAddress', defaultMessage: 'Billing Address' }),
	                                    ':'
	                                ),
	                                this.props.order.bill_address && _react2.default.createElement(_address2.default, { address: this.props.order.bill_address })
	                            ),
	                            !_zoneService2.default.isDonationZone() && _react2.default.createElement(
	                                'div',
	                                { className: 'col-md-6' },
	                                _react2.default.createElement(
	                                    'h4',
	                                    null,
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'shippingAddress', defaultMessage: 'Shipping Address' }),
	                                    ':'
	                                ),
	                                this.props.order.ship_address && _react2.default.createElement(_address2.default, { address: this.props.order.ship_address })
	                            )
	                        ),
	                        _react2.default.createElement('hr', null),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'form-group' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-md-12' },
	                                _react2.default.createElement(
	                                    'h4',
	                                    null,
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'orderItems', defaultMessage: 'Order Items' })
	                                ),
	                                this._shipmentLineItemsMarkup()
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'buttons-container buttons-container-confirm', style: { position: 'relative', top: '20px' } },
	                            _react2.default.createElement(
	                                _reactRouterDom.Link,
	                                { to: _appRoutes2.default.checkout.paymentPageRoute },
	                                _react2.default.createElement(
	                                    'button',
	                                    {
	                                        type: 'button',
	                                        className: 'button--outlined',
	                                        style: { marging: 30 }
	                                    },
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'back', defaultMessage: 'Back' })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'button',
	                                { type: 'submit', disabled: !valid || submitting || this.state.isFinalStepHappening /* || thereAreOutOfStockItems */, className: 'button--reverted' },
	                                _react2.default.createElement(
	                                    'span',
	                                    { className: 'checkout-button-text__desktop' },
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'confirmOrder', defaultMessage: 'Confirm your Order' })
	                                ),
	                                _react2.default.createElement(
	                                    'span',
	                                    { className: 'checkout-button-text__mobile' },
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'confirmOrderMobile', defaultMessage: 'Confirm' })
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ConfirmationForm;
	}(_react.Component);
	
	ConfirmationForm = (0, _reduxForm.reduxForm)({
	    form: 'confirmationForm'
	})(ConfirmationForm);
	
	exports.default = (0, _reactIntl.injectIntl)(ConfirmationForm);

/***/ },
/* 665 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(26);
	
	var _reactRedux = __webpack_require__(18);
	
	var _reduxForm = __webpack_require__(61);
	
	var _reactIntl = __webpack_require__(11);
	
	var _layout = __webpack_require__(29);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _baseCheckoutLayout = __webpack_require__(121);
	
	var _baseCheckoutLayout2 = _interopRequireDefault(_baseCheckoutLayout);
	
	var _shipment = __webpack_require__(666);
	
	var _shipment2 = _interopRequireDefault(_shipment);
	
	var _checkoutStepCalculator = __webpack_require__(54);
	
	var _checkoutStepCalculator2 = _interopRequireDefault(_checkoutStepCalculator);
	
	var _loader = __webpack_require__(65);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _deliveryForm = __webpack_require__(2156);
	
	var _deliveryForm2 = _interopRequireDefault(_deliveryForm);
	
	var _appRoutes = __webpack_require__(22);
	
	var _appRoutes2 = _interopRequireDefault(_appRoutes);
	
	var _appTranslations = __webpack_require__(33);
	
	var _appTranslations2 = _interopRequireDefault(_appTranslations);
	
	var _shipmentsUtils = __webpack_require__(180);
	
	var _shipmentsUtils2 = _interopRequireDefault(_shipmentsUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DeliveryForm = function (_Component) {
	    _inherits(DeliveryForm, _Component);
	
	    function DeliveryForm(props) {
	        _classCallCheck(this, DeliveryForm);
	
	        var _this = _possibleConstructorReturn(this, (DeliveryForm.__proto__ || Object.getPrototypeOf(DeliveryForm)).call(this, props));
	
	        document.title = _this.props.intl.formatMessage({ id: 'checkout', defaultMessage: 'Checkout' });
	
	        _this.handleDeliveryFormSubmit = _this.handleDeliveryFormSubmit.bind(_this);
	        return _this;
	    }
	
	    /* Render this step only if order is present and in a valid checkout state. */
	
	
	    _createClass(DeliveryForm, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var order = this.props.order;
	
	
	            if (!_checkoutStepCalculator2.default.isStepEditable(order.checkout_steps, 'delivery', order.state)) {
	                this.props.handleCheckoutStepNotEditable(order, this.props.placedOrder);
	            }
	
	            if (!order.id) {
	                this.props.redirectToCart();
	            }
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.props.setCurrentCheckoutStep();
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps) {
	            if (this.props.locale !== prevProps.locale) {
	                document.title = this.props.intl.formatMessage({ id: 'checkout', defaultMessage: 'Checkout' });
	            }
	        }
	    }, {
	        key: 'handleDeliveryFormSubmit',
	        value: function handleDeliveryFormSubmit(formData) {
	            var _this2 = this;
	
	            window.scrollTo(0, 0);
	
	            return this.props.handleDeliveryFormSubmit(formData, this.props.order, this.props.locale.currentLocale).then(function () {}, function (error) {
	                var sanitizedErrors = _this2._sanitizedErrorMessages(error.response.body.errors);
	                throw new _reduxForm.SubmissionError({ order: sanitizedErrors });
	            });
	        }
	
	        // eslint-disable-next-line class-methods-use-this
	
	    }, {
	        key: '_sanitizedErrorMessages',
	        value: function _sanitizedErrorMessages(errors) {
	            var _require = __webpack_require__(467);
	
	            var unflatten = _require.unflatten;
	
	
	            var unflattenedErrors = unflatten(errors);
	
	            unflattenedErrors.bill_address_attributes = unflattenedErrors.bill_address;
	            unflattenedErrors.ship_address_attributes = unflattenedErrors.ship_address;
	
	            return unflattenedErrors;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props;
	            var stores = _props.stores;
	            var locale = _props.locale;
	            var _props$order = this.props.order;
	            var shipments = _props$order.shipments;
	            var lineItems = _props$order.line_items;
	            var _props2 = this.props;
	            var handleSubmit = _props2.handleSubmit;
	            var valid = _props2.valid;
	            var submitting = _props2.submitting;
	
	
	            var storeIdsCount = _shipmentsUtils2.default.countAmountOfStores(shipments);
	            var lastStore = void 0;
	            var cont = 0;
	
	            var shipmentsMarkup = shipments && shipments.length > 0 && shipments.map(function (shipment, idx) {
	                var store = stores && stores.find(function (store) {
	                    return store.id === shipment.attributes.store_ids[0];
	                });
	
	                if (store !== lastStore) {
	                    lastStore = store;
	                    cont = 0;
	                } else {
	                    cont += 1;
	                }
	                return _react2.default.createElement(
	                    'div',
	                    {
	                        key: idx,
	                        className: _deliveryForm2.default.deliveryFormShipments,
	                        style: {
	                            paddingBottom: _shipmentsUtils2.default.nextIsSameStore(shipments, idx) ? 1 : 25,
	                            paddingTop: _shipmentsUtils2.default.prevIsSameStore(shipments, idx) ? 1 : 25,
	                            marginBottom: _shipmentsUtils2.default.nextIsSameStore(shipments, idx) ? 0 : 20
	                        }
	                    },
	                    _react2.default.createElement(_shipment2.default, {
	                        store: store,
	                        shipment: shipment,
	                        lineItems: lineItems,
	                        selected: shipment.selected_shipping_rate,
	                        fieldNamePrefix: 'order[shipments_attributes][' + idx + ']',
	                        hideTitle: _shipmentsUtils2.default.prevIsSameStore(shipments, idx)
	                        /* eslint-disable-next-line max-len */
	                        , details: _appTranslations2.default[locale.currentLocale]['shipment.word'] + ' ' + (cont + 1) + ' ' + _appTranslations2.default[locale.currentLocale]['of.word'] + ' ' + storeIdsCount[shipment.attributes.store_ids[0]]
	                    })
	                );
	            });
	
	            return _react2.default.createElement(
	                _layout2.default,
	                null,
	                _react2.default.createElement(
	                    _baseCheckoutLayout2.default,
	                    {
	                        hasExtraTimeCheckout: this.props.hasExtraTimeCheckout,
	                        gracePeriod: this.props.gracePeriod,
	                        locale: this.props.locale.currentLocale,
	                        currentStep: 'delivery',
	                        checkoutSteps: this.props.order.checkout_steps || [],
	                        order: this.props.order
	                    },
	                    submitting && _react2.default.createElement(
	                        'div',
	                        { className: 'checkout-loading-container' },
	                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'saving-delivery', defaultMessage: 'Saving delivery' }),
	                        _react2.default.createElement(_loader2.default, { displayLoader: true, size: 36 })
	                    ),
	                    _react2.default.createElement(
	                        'form',
	                        { onSubmit: handleSubmit(this.handleDeliveryFormSubmit), style: { display: submitting ? 'none' : 'inherit' } },
	                        shipmentsMarkup,
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'buttons-container' },
	                            _react2.default.createElement(
	                                _reactRouterDom.Link,
	                                { to: _appRoutes2.default.checkout.addressPageRoute },
	                                _react2.default.createElement(
	                                    'button',
	                                    {
	                                        type: 'button',
	                                        className: 'button--outlined',
	                                        style: { marging: 30 }
	                                    },
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'back', defaultMessage: 'Back' })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'button',
	                                {
	                                    type: 'submit',
	                                    className: 'button--outlined ' + (submitting && 'button-disabled'),
	                                    style: { marging: 30 },
	                                    disabled: !valid || submitting
	                                },
	                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'continue', defaultMessage: 'Continue' })
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return DeliveryForm;
	}(_react.Component);
	
	DeliveryForm = (0, _reduxForm.reduxForm)({
	    form: 'deliveryForm'
	})(DeliveryForm);
	
	DeliveryForm = (0, _reactRedux.connect)(function (state) {
	    var shipments = state.order.shipments || [];
	    // eslint-disable-next-line camelcase
	    var shipments_attributes = [];
	
	    if (shipments && shipments.length > 0) {
	        shipments.sort(_shipmentsUtils2.default.compareShipments);
	
	        shipments.forEach(function (shipment, idx) {
	            if (shipment.selected_shipping_rate && shipment.selected_shipping_rate.id) {
	                shipments_attributes[idx] = { selected_shipping_rate_id: '' + shipment.selected_shipping_rate.id };
	            }
	        });
	    }
	
	    return {
	        initialValues: {
	            order: {
	                shipments_attributes: shipments_attributes
	            }
	        }
	    };
	})(DeliveryForm);
	
	exports.default = (0, _reactIntl.injectIntl)(DeliveryForm);

/***/ },
/* 666 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxForm = __webpack_require__(61);
	
	var _reactIntl = __webpack_require__(11);
	
	var _lineItem = __webpack_require__(174);
	
	var _lineItem2 = _interopRequireDefault(_lineItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Shipment = function (_Component) {
	    _inherits(Shipment, _Component);
	
	    function Shipment(props) {
	        _classCallCheck(this, Shipment);
	
	        var _this = _possibleConstructorReturn(this, (Shipment.__proto__ || Object.getPrototypeOf(Shipment)).call(this, props));
	
	        _this.state = {
	            selected: _this.props.selected && _this.props.selected.id
	        };
	
	        _this.renderHiddenFieldForShipmentId = _this.renderHiddenFieldForShipmentId.bind(_this);
	        _this.onChangeShippingRate = _this.onChangeShippingRate.bind(_this);
	        return _this;
	    }
	
	    _createClass(Shipment, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.setShipmentIdInHiddenField(this.props.shipment.id);
	        }
	    }, {
	        key: 'onChangeShippingRate',
	        value: function onChangeShippingRate(e) {
	            this.setState({
	                selected: e.target.value
	            });
	        }
	
	        /*
	          :DIRTY HACK:
	          Redux-form form doesn't support hidden fields. So, we create a hidden field
	          and manually trigger its onChange to set the value in redux-form reducer.
	        */
	
	    }, {
	        key: 'setShipmentIdInHiddenField',
	        value: function setShipmentIdInHiddenField(value) {
	            this.onChangeCallbackForShipmentId(value);
	        }
	    }, {
	        key: 'renderHiddenFieldForShipmentId',
	        value: function renderHiddenFieldForShipmentId(field) {
	            this.onChangeCallbackForShipmentId = field.input.onChange;
	            return _react2.default.createElement('input', _extends({}, field.input, { value: this.props.shipment.id, type: 'hidden' }));
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props;
	            var shipment = _props.shipment;
	            var store = _props.store;
	            var hideTitle = _props.hideTitle;
	            var details = _props.details;
	
	
	            var shipmentMarkup = shipment.shipping_rates.map(function (shippingRate, idx) {
	                var label = shippingRate.attributes.name + ' ( ' + shippingRate.attributes.display_cost + ' )';
	                var isExpress = shippingRate.attributes.name && (shippingRate.attributes.name.includes('Express Shipping') === true || shippingRate.attributes.name.includes('Envío Expedito') === true);
	
	                return _react2.default.createElement(
	                    'div',
	                    { key: idx, className: 'checkout-line-item-options' },
	                    _react2.default.createElement(
	                        'label',
	                        null,
	                        _react2.default.createElement(_reduxForm.Field, {
	                            name: _this2.props.fieldNamePrefix + '[selected_shipping_rate_id]',
	                            component: 'input',
	                            type: 'radio',
	                            value: '' + shippingRate.id,
	                            checked: _this2.state.selected === shippingRate.id,
	                            onClick: _this2.onChangeShippingRate,
	                            disabled: isExpress
	                        }),
	                        _react2.default.createElement(
	                            'span',
	                            { style: { color: isExpress ? '#999' : '#000' } },
	                            label
	                        )
	                    )
	                );
	            });
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'checkout-delivery-block', style: { marginTop: hideTitle ? '1px' : '' } },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'checkout-section-title', style: { paddingTop: '12px', display: hideTitle ? 'none' : 'flex' } },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'shipment', defaultMessage: 'Shipment to ' }),
	                    _react2.default.createElement(
	                        'span',
	                        { style: { marginLeft: 6 } },
	                        store && store.name
	                    )
	                ),
	                _react2.default.createElement(
	                    'p',
	                    { className: 'checkout-section-message' },
	                    details && _react2.default.createElement(
	                        'strong',
	                        null,
	                        _react2.default.createElement(
	                            'span',
	                            null,
	                            details
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'checkout-line-item-options-block' },
	                    shipmentMarkup
	                ),
	                store && _react2.default.createElement(
	                    'div',
	                    null,
	                    this.props.lineItems.filter(function (item) {
	                        return item.attributes.store_id === store.id && item.attributes.inventory_unit
	                        // eslint-disable-next-line eqeqeq
	                        && shipment.id == item.attributes.inventory_unit.shipment_id;
	                    }).map(function (lineItem, idx) {
	                        return _react2.default.createElement(_lineItem2.default, { lineItem: lineItem, key: idx });
	                    })
	                ),
	                _react2.default.createElement(_reduxForm.Field, { name: this.props.fieldNamePrefix + '[id]', component: this.renderHiddenFieldForShipmentId })
	            );
	        }
	    }]);
	
	    return Shipment;
	}(_react.Component);
	
	exports.default = Shipment;

/***/ },
/* 667 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(38);
	
	var _reactIntl = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var ChangeMunicipalityModal = function ChangeMunicipalityModal(_ref) {
	    var onAccept = _ref.onAccept;
	    var onCancel = _ref.onCancel;
	    var show = _ref.show;
	
	    var props = _objectWithoutProperties(_ref, ['onAccept', 'onCancel', 'show']);
	
	    return _react2.default.createElement(
	        _reactBootstrap.Modal,
	        _extends({
	            show: show,
	            onHide: onCancel
	        }, props, {
	            'aria-labelledby': 'contained-modal-title-lg'
	        }),
	        _react2.default.createElement(
	            _reactBootstrap.Modal.Header,
	            { closeButton: true },
	            _react2.default.createElement(
	                _reactBootstrap.Modal.Title,
	                { id: 'contained-modal-title-lg' },
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'modal-change-municipality-title', defaultMessage: 'Delivery zone' })
	            )
	        ),
	        _react2.default.createElement(
	            _reactBootstrap.Modal.Body,
	            null,
	            _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                        id: 'modal-change-municipality-text1',
	                        defaultMessage: 'You are making a change in the delivery zone initially selected and your cart will be empty.'
	                    }),
	                    '\xA0',
	                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                        id: 'modal-change-municipality-text2',
	                        defaultMessage: 'Please be sure to select the correct province and municipality where we must deliver your order before you place your order.'
	                    })
	                )
	            )
	        ),
	        _react2.default.createElement(
	            _reactBootstrap.Modal.Footer,
	            null,
	            _react2.default.createElement(
	                _reactBootstrap.Button,
	                { onClick: function onClick() {
	                        return onAccept();
	                    } },
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'empty-cart', defaultMessage: 'Empty Cart' })
	            ),
	            _react2.default.createElement(
	                _reactBootstrap.Button,
	                { onClick: function onClick() {
	                        return onCancel();
	                    } },
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'modal-change-municipality-button-cancel', defaultMessage: 'Cancel' })
	            )
	        )
	    );
	};
	
	exports.default = ChangeMunicipalityModal;

/***/ },
/* 668 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(38);
	
	var _reactIntl = __webpack_require__(11);
	
	var _timeParse = __webpack_require__(372);
	
	var _timeParse2 = _interopRequireDefault(_timeParse);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var ExtraTimeModal = function ExtraTimeModal(_ref) {
	    var onHide = _ref.onHide;
	    var show = _ref.show;
	    var gracePeriod = _ref.gracePeriod;
	    var locale = _ref.locale;
	
	    var props = _objectWithoutProperties(_ref, ['onHide', 'show', 'gracePeriod', 'locale']);
	
	    return _react2.default.createElement(
	        _reactBootstrap.Modal,
	        _extends({
	            show: show,
	            onHide: onHide
	        }, props, {
	            'aria-labelledby': 'contained-modal-title-lg'
	        }),
	        _react2.default.createElement(
	            _reactBootstrap.Modal.Header,
	            { closeButton: true },
	            _react2.default.createElement(
	                _reactBootstrap.Modal.Title,
	                { id: 'contained-modal-title-lg' },
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'payment-modal-extra-time-title', defaultMessage: 'Time expired' })
	            )
	        ),
	        _react2.default.createElement(
	            _reactBootstrap.Modal.Body,
	            null,
	            _react2.default.createElement(
	                'p',
	                null,
	                _react2.default.createElement(_reactIntl.FormattedMessage, {
	                    id: 'payment-modal-extra-time-text1',
	                    values: { time: _timeParse2.default.fromSecondsToText(gracePeriod, locale) },
	                    defaultMessage: 'The time to checkout has expired, we have added {time} minutes for you to finish your checkout.'
	                })
	            )
	        ),
	        _react2.default.createElement(
	            _reactBootstrap.Modal.Footer,
	            null,
	            _react2.default.createElement(
	                _reactBootstrap.Button,
	                { onClick: function onClick() {
	                        return onHide();
	                    } },
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'payment-modal-extra-time-button', defaultMessage: 'Close' })
	            )
	        )
	    );
	};
	
	exports.default = ExtraTimeModal;

/***/ },
/* 669 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(38);
	
	var _reactIntl = __webpack_require__(11);
	
	var _fraudulentOrderModal = __webpack_require__(2138);
	
	var _fraudulentOrderModal2 = _interopRequireDefault(_fraudulentOrderModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var causes = {
	    INCOGNITO_MODE_NOT_ALLOWED: 'incognito_mode_not_allowed',
	    INVALID_ORDER: 'invalid_order_not_to_process'
	};
	
	var OrderErrorModal = function OrderErrorModal(_ref) {
	    var onHide = _ref.onHide;
	    var show = _ref.show;
	    var orderError = _ref.orderError;
	    var order = _ref.order;
	
	    var props = _objectWithoutProperties(_ref, ['onHide', 'show', 'orderError', 'order']);
	
	    return _react2.default.createElement(
	        _reactBootstrap.Modal,
	        _extends({
	            show: show,
	            onHide: onHide
	        }, props, {
	            'aria-labelledby': 'contained-modal-title-lg'
	        }),
	        _react2.default.createElement(
	            _reactBootstrap.Modal.Header,
	            { closeButton: true },
	            _react2.default.createElement(
	                _reactBootstrap.Modal.Title,
	                { id: 'contained-modal-title-lg' },
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'error-title', defaultMessage: 'Error' })
	            )
	        ),
	        _react2.default.createElement(
	            _reactBootstrap.Modal.Body,
	            { className: _fraudulentOrderModal2.default.modalBody },
	            orderError && orderError.cause === causes.INCOGNITO_MODE_NOT_ALLOWED && _react2.default.createElement(
	                'span',
	                null,
	                orderError.error
	            ),
	            orderError && orderError.cause === causes.INVALID_ORDER && _react2.default.createElement(
	                'section',
	                null,
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'invalid-order-title', defaultMessage: 'There is a problem processing the order' }),
	                _react2.default.createElement(
	                    'div',
	                    { className: _fraudulentOrderModal2.default.headerInfo },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'invalid-order-contact-info', defaultMessage: 'To help you complete your order please send us a message to ' }),
	                    _react2.default.createElement(
	                        'a',
	                        { href: 'mailto:info@katapulk.com' },
	                        'info@katapulk.com'
	                    ),
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'invalid-order-contact-info2', defaultMessage: ' including:' })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: _fraudulentOrderModal2.default.bodyInfo },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'invalid-order-first-and-last-name', defaultMessage: 'First and Last Name: ' })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'invalid-order-phone-number', defaultMessage: 'Phone number: ' })
	                ),
	                order && order.number && _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'invalid-order-order-number', defaultMessage: 'Order Number: ' }),
	                    _react2.default.createElement(
	                        'span',
	                        { className: _fraudulentOrderModal2.default.caseNumber },
	                        order.number
	                    )
	                ),
	                orderError && orderError.case_number && _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'invalid-order-case-number', defaultMessage: 'Case Number: ' }),
	                    _react2.default.createElement(
	                        'span',
	                        { className: _fraudulentOrderModal2.default.caseNumber },
	                        orderError.case_number
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(
	            _reactBootstrap.Modal.Footer,
	            null,
	            _react2.default.createElement(
	                _reactBootstrap.Button,
	                { onClick: function onClick() {
	                        return onHide();
	                    } },
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'payment-modal-extra-time-button', defaultMessage: 'Close' })
	            )
	        )
	    );
	};
	
	exports.default = (0, _reactIntl.injectIntl)(OrderErrorModal);

/***/ },
/* 670 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxForm = __webpack_require__(61);
	
	var _reactRouterDom = __webpack_require__(26);
	
	var _reactRedux = __webpack_require__(18);
	
	var _reactIntl = __webpack_require__(11);
	
	var _reactCreditCards = __webpack_require__(1840);
	
	var _reactCreditCards2 = _interopRequireDefault(_reactCreditCards);
	
	var _cardFields = __webpack_require__(675);
	
	var _cardFields2 = _interopRequireDefault(_cardFields);
	
	var _checkoutStepCalculator = __webpack_require__(54);
	
	var _checkoutStepCalculator2 = _interopRequireDefault(_checkoutStepCalculator);
	
	var _errorMessageFormatter = __webpack_require__(368);
	
	var _errorMessageFormatter2 = _interopRequireDefault(_errorMessageFormatter);
	
	var _creditCard = __webpack_require__(250);
	
	var _creditCard2 = _interopRequireDefault(_creditCard);
	
	var _loader = __webpack_require__(65);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _appChekout = __webpack_require__(248);
	
	var _helper = __webpack_require__(60);
	
	var _paymentForm = __webpack_require__(2139);
	
	var _paymentForm2 = _interopRequireDefault(_paymentForm);
	
	var _store = __webpack_require__(40);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _actions = __webpack_require__(23);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// eslint-disable-next-line import/no-cycle
	
	
	var PaymentForm = function (_Component) {
	    _inherits(PaymentForm, _Component);
	
	    function PaymentForm(props) {
	        _classCallCheck(this, PaymentForm);
	
	        var _this = _possibleConstructorReturn(this, (PaymentForm.__proto__ || Object.getPrototypeOf(PaymentForm)).call(this, props));
	
	        _this.onInputChangeHandler = function (e) {
	            var _e$target = e.target;
	            var name = _e$target.name;
	            var value = _e$target.value;
	
	            var newValue = value;
	            switch (name) {
	                case 'order[payments_attributes][0][source_attributes][number]':
	                    newValue = (0, _helper.formatCreditCardNumber)(value);
	                    break;
	                case 'order[payments_attributes][0][source_attributes][expiry]':
	                    newValue = (0, _helper.formatExpirationDate)(value);
	                    break;
	                case 'order[payments_attributes][0][source_attributes][verification_value]':
	                    newValue = (0, _helper.formatCVC)(value);
	                    break;
	                default:
	                    break;
	            }
	            _this.setState(_defineProperty({}, name, newValue));
	        };
	
	        _this.onInputFocus = function (e) {
	            var focusTarget = '';
	            switch (e.target.name) {
	                case 'order[payments_attributes][0][source_attributes][name]':
	                    focusTarget = 'name';
	                    break;
	                case 'order[payments_attributes][0][source_attributes][number]':
	                    focusTarget = 'number';
	                    break;
	                case 'order[payments_attributes][0][source_attributes][expiry]':
	                    focusTarget = 'expiry';
	                    break;
	                default:
	                    focusTarget = 'cvc';
	                    break;
	            }
	            _this.setState({
	                focus: focusTarget
	            });
	        };
	
	        _this.state = {
	            methodSelected: _this.props.order.payment_methods && _this.props.order.payment_methods[0].id,
	            'order[payments_attributes][0][source_attributes][verification_value]': '',
	            'order[payments_attributes][0][source_attributes][expiry]': '',
	            focus: '',
	            'order[payments_attributes][0][source_attributes][name]': '',
	            'order[payments_attributes][0][source_attributes][number]': '',
	            onInputChangeHandler: _this.onInputChangeHandler,
	            onInputFocus: _this.onInputFocus
	        };
	
	        _this.onChangePaymentMethod = _this.onChangePaymentMethod.bind(_this);
	
	        document.title = _this.props.intl.formatMessage({ id: 'checkout', defaultMessage: 'Checkout' });
	        return _this;
	    }
	
	    /* Render this step only if order is present and in a valid checkout state. */
	
	
	    _createClass(PaymentForm, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var order = this.props.order;
	
	
	            if (!_checkoutStepCalculator2.default.isStepEditable(order.checkout_steps, 'payment', order.state)) {
	                this.props.handleCheckoutStepNotEditable(order, this.props.placedOrder);
	            }
	
	            if (!order.id) {
	                this.props.redirectToCart();
	            }
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            if (!this.hasPaymentMethod()) {
	                this.props.handleCreditCardChange(); // disable payment with card button if the page was refreshed
	            }
	            this.props.setCurrentCheckoutStep();
	            _store2.default.dispatch(_actions2.default.hideLoader());
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps) {
	            if (this.props.locale !== prevProps.locale) {
	                document.title = this.props.intl.formatMessage({ id: 'checkout', defaultMessage: 'Checkout' });
	            }
	        }
	    }, {
	        key: 'onChangePaymentMethod',
	        value: function onChangePaymentMethod(paymentMethodId) {
	            if (paymentMethodId === this.state.methodSelected) {
	                this.setState({
	                    methodSelected: null
	                });
	            } else {
	                this.setState({
	                    methodSelected: paymentMethodId
	                });
	            }
	        }
	    }, {
	        key: 'hasPaymentMethod',
	        value: function hasPaymentMethod() {
	            return !!this.state['order[payments_attributes][0][source_attributes][name]'] && !!this.state['order[payments_attributes][0][source_attributes][number]'];
	        }
	    }, {
	        key: 'handlePaymentFormSubmit',
	        value: function handlePaymentFormSubmit(formData) {
	            var _this2 = this;
	
	            window.scrollTo(0, 0);
	
	            var data = {};
	
	            if (formData && formData.order) {
	                // eslint-disable-next-line camelcase
	                var payments_attributes = formData.order.payments_attributes;
	
	                var _payments_attributes$ = payments_attributes[0].source_attributes.expiry.split('/');
	
	                var _payments_attributes$2 = _slicedToArray(_payments_attributes$, 2);
	
	                var expDateMonth = _payments_attributes$2[0];
	                var expDateYear = _payments_attributes$2[1];
	
	
	                if (expDateYear === undefined) {
	                    expDateYear = null;
	
	                    if (expDateMonth === undefined) {
	                        expDateMonth = null;
	                    } else {
	                        expDateYear = expDateMonth.substring(2);
	                        expDateMonth = expDateMonth.substring(0, 2);
	                    }
	                }
	
	                data = {
	                    order: {
	
	                        payments_attributes: [{
	                            payment_method_id: this.state.methodSelected
	                        }]
	                    },
	                    payment_source: _defineProperty({}, this.state.methodSelected, {
	                        number: payments_attributes[0].source_attributes.number,
	                        month: expDateMonth,
	                        year: expDateYear,
	                        verification_value: payments_attributes[0].source_attributes.verification_value,
	                        name: payments_attributes[0].source_attributes.name
	                    })
	                };
	            }
	
	            return this.props.handlePaymentFormSubmit(data, this.props.order, this.props.locale.currentLocale).then(this.props.handleSaveCreditCardSuccess, function (error) {
	                console.log(error);
	                var sanitizedErrors = _this2.formattedErrorMessages(error.response.body.errors);
	                _this2.props.showFormErrors(sanitizedErrors);
	
	                throw new _reduxForm.SubmissionError({ order: sanitizedErrors });
	            });
	        }
	
	        // eslint-disable-next-line class-methods-use-this
	
	    }, {
	        key: 'formattedErrorMessages',
	        value: function formattedErrorMessages(errors) {
	            var formErrors = errors['payments.Credit Card'];
	            return _errorMessageFormatter2.default.formatFormSubmissionErrors(formErrors);
	        }
	    }, {
	        key: 'buildReadOnlyCreditCardData',
	        value: function buildReadOnlyCreditCardData() {
	            return _react2.default.createElement(
	                'div',
	                { style: { marginLeft: '15px' } },
	                _react2.default.createElement(
	                    'div',
	                    { style: { display: 'flex' } },
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement('img', {
	                            style: {
	                                width: '50px', height: '50px', marginTop: '12px', marginRight: '15px'
	                            },
	                            src: '/pay-types/' + _creditCard2.default.ccType(this.state['order[payments_attributes][0][source_attributes][number]']) + '-logo.png',
	                            alt: 'CC logo'
	                        })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                            'div',
	                            { className: _paymentForm2.default.cardData },
	                            _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                id: 'payment-form-cc-name',
	                                values: { name: this.state['order[payments_attributes][0][source_attributes][name]'] },
	                                defaultMessage: ''
	                            }),
	                            _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                id: 'payment-form-cc-number',
	                                values: { number: _creditCard2.default.mask(this.state['order[payments_attributes][0][source_attributes][number]']) },
	                                defaultMessage: ''
	                            })
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'button',
	                    { type: 'button', className: 'button--outlined', onClick: this.props.handleCreditCardChange },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                        id: 'payment-form-edit',
	                        defaultMessage: 'Edit'
	                    })
	                )
	            );
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            var _props = this.props;
	            var handleSubmit = _props.handleSubmit;
	            var valid = _props.valid;
	            var submitting = _props.submitting;
	            var order = _props.order;
	
	            var paymentMethods = order && order.payment_methods || [];
	
	            var paymentMethodMarkup = paymentMethods.map(function (paymentMethod, idx) {
	                return paymentMethod.attributes.name === _appChekout.PAYMENT_METHODS.credit_card && _react2.default.createElement(
	                    'div',
	                    { className: 'credit-card__container', key: idx },
	                    _react2.default.createElement(_reactCreditCards2.default, {
	                        cvc: _this3.state['order[payments_attributes][0][source_attributes][verification_value]'],
	                        expiry: _this3.state['order[payments_attributes][0][source_attributes][expiry]'],
	                        focused: _this3.state.focus,
	                        name: _this3.state['order[payments_attributes][0][source_attributes][name]'],
	                        number: _this3.state['order[payments_attributes][0][source_attributes][number]'],
	                        callback: function callback(type) {
	                            _this3.setState({
	                                maxLength: type.maxLength
	                            });
	                        }
	                    })
	                );
	            });
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                submitting && _react2.default.createElement(
	                    'div',
	                    { className: 'checkout-loading-container' },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'saving-payment', defaultMessage: 'Saving payment' }),
	                    _react2.default.createElement(_loader2.default, { displayLoader: true, size: 36 })
	                ),
	                !submitting && this.props.displayLoader && _react2.default.createElement(
	                    'div',
	                    { className: 'checkout-loading-container' },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'please-wait', defaultMessage: 'please wait' }),
	                    _react2.default.createElement(_loader2.default, { displayLoader: true, size: 36 })
	                ),
	                _react2.default.createElement(
	                    'form',
	                    {
	                        onSubmit: handleSubmit(this.handlePaymentFormSubmit.bind(this)),
	                        style: { display: submitting || !submitting && this.props.displayLoader ? 'none' : 'inherit' }
	                    },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'checkout-payment-options-block' },
	                        this.props.displayPreview && paymentMethodMarkup
	                    ),
	                    this.props.isReadOnly && this.hasPaymentMethod() ? this.buildReadOnlyCreditCardData() : _react2.default.createElement(_cardFields2.default, this.state),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'checkout-payment-button-block' },
	                        this.props.hasBackButton && _react2.default.createElement(
	                            'button',
	                            {
	                                type: 'button',
	                                className: 'button--outlined',
	                                style: { margin: 30 }
	                            },
	                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'back', defaultMessage: 'Back' })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: _paymentForm2.default.paymentFormAction },
	                            !this.props.isReadOnly && _react2.default.createElement(
	                                'button',
	                                { type: 'submit', style: { width: 'auto' }, className: 'button--outlined ' + (submitting && 'button-disabled'), disabled: !valid || submitting },
	                                _react2.default.createElement(
	                                    'span',
	                                    { className: 'checkout-button-text__desktop' },
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'savePaymentMethod', defaultMessage: 'Save Payment Details' })
	                                ),
	                                _react2.default.createElement(
	                                    'span',
	                                    { className: 'checkout-button-text__mobile' },
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'savePaymentMethod', defaultMessage: 'Pay' })
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return PaymentForm;
	}(_react.Component);
	
	PaymentForm = (0, _reduxForm.reduxForm)({
	    form: 'paymentForm'
	})(PaymentForm);
	
	var selector = (0, _reduxForm.formValueSelector)('paymentForm');
	PaymentForm = (0, _reactRedux.connect)(function (state) {
	    var useCard = selector(state, 'order[payments_attributes][0][payment_method_id]');
	    return {
	        useCard: useCard
	    };
	})(PaymentForm);
	
	exports.default = (0, _reactIntl.injectIntl)(PaymentForm);

/***/ },
/* 671 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(11);
	
	var _confirmationDetail = __webpack_require__(663);
	
	var _confirmationDetail2 = _interopRequireDefault(_confirmationDetail);
	
	var _loader = __webpack_require__(65);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PaymentRedsysForm = function (_Component) {
	    _inherits(PaymentRedsysForm, _Component);
	
	    function PaymentRedsysForm(props) {
	        _classCallCheck(this, PaymentRedsysForm);
	
	        var _this = _possibleConstructorReturn(this, (PaymentRedsysForm.__proto__ || Object.getPrototypeOf(PaymentRedsysForm)).call(this, props));
	
	        document.title = _this.props.intl.formatMessage({ id: 'checkout', defaultMessage: 'Checkout' });
	        _this.form = _react2.default.createRef();
	        _this.state = {
	            ds_MerchantParameters: '',
	            ds_Signature: '',
	            backToPrev: false
	        };
	
	        _this.backToPrevStep = _this.backToPrevStep.bind(_this);
	        return _this;
	    }
	
	    _createClass(PaymentRedsysForm, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            this.props.getRedsysInfo().then(function (result) {
	                _this2.setState({
	                    ds_MerchantParameters: _this2.props.order.redsysPaymentInfo.Ds_MerchantParameters,
	                    ds_Signature: _this2.props.order.redsysPaymentInfo.Ds_Signature
	                });
	            });
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps) {
	            if (this.props.locale !== prevProps.locale) {
	                document.title = this.props.intl.formatMessage({ id: 'checkout', defaultMessage: 'Checkout' });
	            }
	        }
	    }, {
	        key: 'backToPrevStep',
	        value: function backToPrevStep() {
	            var _this3 = this;
	
	            window.scrollTo(0, 0);
	
	            this.setState(function (prevState) {
	                return _extends({}, prevState, {
	                    backToPrev: true
	                });
	            });
	
	            this.props.handlePaymentBackStep(this.props.order, this.props.locale).catch(function () {
	                _this3.setState(function (prevState) {
	                    return _extends({}, prevState, {
	                        backToPrev: false
	                    });
	                });
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this4 = this;
	
	            var _props = this.props;
	            var order = _props.order;
	            var stores = _props.stores;
	
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                this.state.backToPrev && this.props.displayLoader && _react2.default.createElement(
	                    'div',
	                    { className: 'checkout-loading-container' },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'please-wait', defaultMessage: 'please wait' }),
	                    _react2.default.createElement(_loader2.default, { displayLoader: true, size: 36 })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { style: { display: this.state.backToPrev && this.props.displayLoader ? 'none' : 'inherit' } },
	                    order.redsysPaymentError && _react2.default.createElement(
	                        'div',
	                        { className: 'alert alert-danger', role: 'alert', style: { margin: 25 } },
	                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'redsys-error', 'default': 'An error has occurred in your payment' })
	                    ),
	                    _react2.default.createElement(_confirmationDetail2.default, { order: order, stores: stores }),
	                    _react2.default.createElement(
	                        'form',
	                        {
	                            name: 'from',
	                            action: this.props.order.redsysPaymentInfo ? this.props.order.redsysPaymentInfo.Redsys_url : ({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_EMPTY_CART_IN_SECONDS":"720","REACT_APP_FINGERPRINT_ENDPOINT":"https://fku.staging.katapulk.com","REACT_APP_KWALLET_ENABLED":"false","REACT_APP_MAIN_STORE_API_HOST":"https://staging.api.cubalicores.com","REACT_APP_FINGERPRINT_PUBLIC_KEY":"mdaO5TIlVptg2wrFbMdU","REACT_APP_ENV":"develop","REACT_APP_RECAPTCHA_KEY":"b2ce3e581814036777f1fb9b2ccf62b4b368336a0cd142f9045d92dc8b0516670344ee2ac218b7cd98302c719eb99f127a9851f99977e1ba84d0190be8ad8473","REACT_APP_DISABLE_AUTH":"false","REACT_APP_API_HOST":"https://staging.api.cubalicores.com"}).REACT_APP_REDSYS_URL,
	                            method: 'POST',
	                            ref: this.form
	                        },
	                        _react2.default.createElement('input', { type: 'hidden', name: 'Ds_SignatureVersion', value: 'HMAC_SHA256_V1' }),
	                        _react2.default.createElement('input', { type: 'hidden', name: 'Ds_MerchantParameters', value: this.state.ds_MerchantParameters }),
	                        _react2.default.createElement('input', { type: 'hidden', name: 'Ds_Signature', value: this.state.ds_Signature }),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'checkout-payment-button-block' },
	                            _react2.default.createElement(
	                                'button',
	                                {
	                                    onClick: this.backToPrevStep,
	                                    type: 'button',
	                                    className: 'button--outlined',
	                                    style: { margin: 30 }
	                                },
	                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'back', defaultMessage: 'Back' })
	                            ),
	                            _react2.default.createElement(
	                                'button',
	                                {
	                                    type: 'submit',
	                                    className: 'button--outlined',
	                                    disabled: !this.props.order.redsysPaymentInfo || !this.props.order.redsysPaymentInfo.Ds_MerchantParameters,
	                                    onClick: function onClick() {
	                                        return _this4.props.addRedsysPaymentError(false);
	                                    }
	                                },
	                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'savePayment', defaultMessage: 'Save Payment Details' })
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return PaymentRedsysForm;
	}(_react.Component);
	
	exports.default = (0, _reactIntl.injectIntl)(PaymentRedsysForm);

/***/ },
/* 672 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(11);
	
	var _reactRouterDom = __webpack_require__(26);
	
	var _baseCheckoutLayout = __webpack_require__(121);
	
	var _baseCheckoutLayout2 = _interopRequireDefault(_baseCheckoutLayout);
	
	var _layout = __webpack_require__(29);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _appRoutes = __webpack_require__(22);
	
	var _appRoutes2 = _interopRequireDefault(_appRoutes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PaymentRedsysRedirectKo = function (_Component) {
	    _inherits(PaymentRedsysRedirectKo, _Component);
	
	    function PaymentRedsysRedirectKo(props) {
	        _classCallCheck(this, PaymentRedsysRedirectKo);
	
	        var _this = _possibleConstructorReturn(this, (PaymentRedsysRedirectKo.__proto__ || Object.getPrototypeOf(PaymentRedsysRedirectKo)).call(this, props));
	
	        document.title = _this.props.intl.formatMessage({ id: 'checkout', defaultMessage: 'Checkout' });
	        return _this;
	    }
	
	    /* Render this step only if order is present and in a valid checkout state. */
	
	
	    _createClass(PaymentRedsysRedirectKo, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var order = this.props.order;
	
	            this.props.addRedsysPaymentError(true);
	            this.props.history.push(_appRoutes2.default.checkout.paymentPageRoute);
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {}
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps) {
	            if (this.props.locale !== prevProps.locale) {
	                document.title = this.props.intl.formatMessage({ id: 'checkout', defaultMessage: 'Checkout' });
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var order = this.props.order;
	
	
	            return _react2.default.createElement(
	                _layout2.default,
	                null,
	                _react2.default.createElement(
	                    _baseCheckoutLayout2.default,
	                    {
	                        hasExtraTimeCheckout: this.props.hasExtraTimeCheckout,
	                        gracePeriod: this.props.gracePeriod,
	                        locale: this.props.locale.currentLocale,
	                        currentStep: 'payment',
	                        checkoutSteps: order.checkout_steps || [],
	                        order: this.props.order
	                    },
	                    _react2.default.createElement('div', null)
	                )
	            );
	        }
	    }]);
	
	    return PaymentRedsysRedirectKo;
	}(_react.Component);
	
	exports.default = (0, _reactIntl.injectIntl)((0, _reactRouterDom.withRouter)(PaymentRedsysRedirectKo));

/***/ },
/* 673 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(11);
	
	var _reactRouterDom = __webpack_require__(26);
	
	var _appRoutes = __webpack_require__(22);
	
	var _appRoutes2 = _interopRequireDefault(_appRoutes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PaymentRedsysRedirectOk = function (_Component) {
	    _inherits(PaymentRedsysRedirectOk, _Component);
	
	    function PaymentRedsysRedirectOk(props) {
	        _classCallCheck(this, PaymentRedsysRedirectOk);
	
	        var _this = _possibleConstructorReturn(this, (PaymentRedsysRedirectOk.__proto__ || Object.getPrototypeOf(PaymentRedsysRedirectOk)).call(this, props));
	
	        document.title = _this.props.intl.formatMessage({ id: 'checkout', defaultMessage: 'Checkout' });
	        return _this;
	    }
	
	    /* Render this step only if order is present and in a valid checkout state. */
	
	
	    _createClass(PaymentRedsysRedirectOk, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var order = this.props.order;
	
	            this.props.setCurrentCheckoutStep();
	            this.props.history.push(_appRoutes2.default.checkout.completePageRoute);
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {}
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props;
	            var order = _props.order;
	            var stores = _props.stores;
	
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                'Transaccion confirmada'
	            );
	        }
	    }]);
	
	    return PaymentRedsysRedirectOk;
	}(_react.Component);
	
	exports.default = (0, _reactIntl.injectIntl)((0, _reactRouterDom.withRouter)(PaymentRedsysRedirectOk));

/***/ },
/* 674 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(11);
	
	var _layout = __webpack_require__(29);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _baseCheckoutLayout = __webpack_require__(121);
	
	var _baseCheckoutLayout2 = _interopRequireDefault(_baseCheckoutLayout);
	
	var _checkoutStepCalculator = __webpack_require__(54);
	
	var _checkoutStepCalculator2 = _interopRequireDefault(_checkoutStepCalculator);
	
	var _errorMessageFormatter = __webpack_require__(368);
	
	var _errorMessageFormatter2 = _interopRequireDefault(_errorMessageFormatter);
	
	var _appChekout = __webpack_require__(248);
	
	var _store = __webpack_require__(40);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _paymentMethodSelector = __webpack_require__(170);
	
	var _paymentMethodSelector2 = _interopRequireDefault(_paymentMethodSelector);
	
	var _paymentSelectionService = __webpack_require__(371);
	
	var _paymentSelectionService2 = _interopRequireDefault(_paymentSelectionService);
	
	var _address = __webpack_require__(142);
	
	var _address2 = _interopRequireDefault(_address);
	
	var _zoneService = __webpack_require__(79);
	
	var _zoneService2 = _interopRequireDefault(_zoneService);
	
	var _shipment = __webpack_require__(242);
	
	var _shipment2 = _interopRequireDefault(_shipment);
	
	var _modals = __webpack_require__(241);
	
	var _appActions = __webpack_require__(21);
	
	var _appActions2 = _interopRequireDefault(_appActions);
	
	var _shipmentsUtils = __webpack_require__(180);
	
	var _shipmentsUtils2 = _interopRequireDefault(_shipmentsUtils);
	
	var _appTranslations = __webpack_require__(33);
	
	var _appTranslations2 = _interopRequireDefault(_appTranslations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable react/sort-comp */
	/* eslint-disable react/no-unused-state */
	
	
	var PaymentStep = function (_Component) {
	    _inherits(PaymentStep, _Component);
	
	    function PaymentStep(props) {
	        _classCallCheck(this, PaymentStep);
	
	        var _this = _possibleConstructorReturn(this, (PaymentStep.__proto__ || Object.getPrototypeOf(PaymentStep)).call(this, props));
	
	        document.title = _this.props.intl.formatMessage({ id: 'checkout', defaultMessage: 'Checkout' });
	        var order = _this.props.order;
	
	        var paymentOptions = order.payment_methods ? order.payment_methods.map(function (method, index) {
	            return {
	                id: method.id,
	                name: method.attributes.name,
	                description: method.attributes.description,
	                type: method.attributes.type,
	                isDefault: index === 0,
	                ref: _react2.default.createRef()
	            };
	        }) : [];
	
	        _this.state = {
	            paymentOptionSelected: paymentOptions.length > 0 ? paymentOptions[0] : null,
	            paymentOptions: paymentOptions,
	            stores: []
	        };
	        return _this;
	    }
	
	    /* Render this step only if order is present and in a valid checkout state. */
	
	
	    _createClass(PaymentStep, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var order = this.props.order;
	
	            if (!_checkoutStepCalculator2.default.isStepEditable(order.checkout_steps, 'payment', order.state)) {
	                this.props.handleCheckoutStepNotEditable(order, this.props.placedOrder);
	            }
	
	            if (!order.id) {
	                this.props.redirectToCart();
	            }
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            this.props.setCurrentCheckoutStep();
	            var unsubscribe = _store2.default.subscribe(function () {
	                if (_store2.default.getState().stores.stores.length > 0) {
	                    _this2.setState({
	                        stores: _store2.default.getState().stores.stores
	                    });
	                    unsubscribe();
	                }
	            });
	            _paymentSelectionService2.default.selectedPaymentMethod$.next(this.state.paymentOptionSelected);
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps) {
	            if (this.props.locale !== prevProps.locale) {
	                document.title = this.props.intl.formatMessage({ id: 'checkout', defaultMessage: 'Checkout' });
	            }
	        }
	
	        // eslint-disable-next-line class-methods-use-this
	
	    }, {
	        key: 'getPaymentMethodComponentLayout',
	        value: function getPaymentMethodComponentLayout(method) {
	            var _this3 = this;
	
	            var OptionComponent = (0, _appChekout.PAYMENT_METHOD_COMPONENT_MAPPING)()[method.type];
	            if (OptionComponent) {
	                return _react2.default.createElement(OptionComponent, {
	                    method: method,
	                    optionSelected: this.state.paymentOptionSelected,
	                    onOptionSelected: function onOptionSelected(option) {
	                        return _this3.paymentOptionSelected(option);
	                    },
	                    ref: method.ref,
	                    order: this.props.order,
	                    locale: this.props.locale.currentLocale
	                });
	            }
	            return null;
	        }
	
	        // eslint-disable-next-line class-methods-use-this
	
	    }, {
	        key: 'handlePaymentFormSubmit',
	        value: function handlePaymentFormSubmit(formData) {
	            window.scrollTo(0, 0);
	        }
	
	        // eslint-disable-next-line class-methods-use-this
	
	    }, {
	        key: 'formattedErrorMessages',
	        value: function formattedErrorMessages(errors) {
	            var formErrors = errors['payments.Credit Card'];
	            return _errorMessageFormatter2.default.formatFormSubmissionErrors(formErrors);
	        }
	
	        // eslint-disable-next-line class-methods-use-this
	
	    }, {
	        key: 'paymentOptionSelected',
	        value: function paymentOptionSelected(option) {
	            this.props.clearCreditCardData();
	            option.ref.current.shouldNextBeEnabled();
	            this.setState({
	                paymentOptionSelected: option
	            });
	            _paymentSelectionService2.default.selectedPaymentMethod$.next(option);
	        }
	    }, {
	        key: 'getShipmentDetails',
	        value: function getShipmentDetails() {
	            var _this4 = this;
	
	            var thisOrder = this.props.order;
	            var stores = this.state.stores;
	
	
	            var shipments = stores && stores.length > 0 && thisOrder.shipments && thisOrder.shipments.length > 0 && thisOrder.shipments.sort(_shipmentsUtils2.default.compareShipments);
	
	            var storeIdsCount = _shipmentsUtils2.default.countAmountOfStores(thisOrder.shipments);
	            var lastStore = void 0;
	            var cont = 0;
	
	            var shipmentsMarkup = shipments && shipments.length > 0 && shipments.map(function (shipment, idx) {
	                var store = stores && stores.find(function (store) {
	                    return store.id === shipment.attributes.store_ids[0];
	                });
	                if (store !== lastStore) {
	                    lastStore = store;
	                    cont = 0;
	                } else {
	                    cont += 1;
	                }
	
	                return _react2.default.createElement(_shipment2.default, {
	                    key: idx,
	                    store: stores && stores.find(function (store) {
	                        return store.id === shipment.attributes.store_ids[0];
	                    }),
	                    shipment: shipment,
	                    address: thisOrder.ship_address,
	                    order: _this4.props.order,
	                    excludeShipmentNumber: true,
	                    style: _shipmentsUtils2.default.shipmentStylePadding(shipments, idx),
	                    hideStoreName: _shipmentsUtils2.default.prevIsSameStore(shipments, idx),
	                    details: _appTranslations2.default[_this4.props.locale.currentLocale]['shipment.word'] + ' ' + (cont + 1) + (' ' + _appTranslations2.default[_this4.props.locale.currentLocale]['of.word'] + ' ' + storeIdsCount[shipment.attributes.store_ids[0]])
	                });
	            });
	            return shipmentsMarkup;
	        }
	
	        // eslint-disable-next-line class-methods-use-this
	
	    }, {
	        key: 'onHideDialogError',
	        value: function onHideDialogError() {
	            _store2.default.dispatch({
	                type: _appActions2.default.COMPLETE_ORDER_ERROR_HIDE_DIALOG
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this5 = this;
	
	            var order = this.props.order;
	
	            var paymentOptions = this.state.paymentOptions.map(function (option) {
	                return _extends({}, option, {
	                    component: _this5.getPaymentMethodComponentLayout(option)
	                });
	            });
	
	            var _spreeStore$getState$ = _store2.default.getState().placedOrder;
	
	            var orderError = _spreeStore$getState$.orderError;
	            var showDialogError = _spreeStore$getState$.showDialogError;
	
	
	            return _react2.default.createElement(
	                _layout2.default,
	                null,
	                _react2.default.createElement(
	                    _baseCheckoutLayout2.default,
	                    {
	                        hasExtraTimeCheckout: this.props.hasExtraTimeCheckout,
	                        gracePeriod: this.props.gracePeriod,
	                        locale: this.props.locale.currentLocale,
	                        currentStep: 'payment',
	                        checkoutSteps: order.checkout_steps || [],
	                        order: this.props.order
	                    },
	                    order.redsysPaymentError && _react2.default.createElement(
	                        'div',
	                        { className: 'alert alert-danger', role: 'alert', style: { margin: 25 } },
	                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'redsys-error', 'default': 'An error has occurred in your payment' })
	                    ),
	                    _react2.default.createElement(_modals.OrderErrorModal, {
	                        show: showDialogError,
	                        onHide: this.onHideDialogError,
	                        orderError: orderError,
	                        order: order
	                    }),
	                    _react2.default.createElement(
	                        'div',
	                        { className: _paymentMethodSelector2.default.pms },
	                        _react2.default.createElement(
	                            'h3',
	                            { className: _paymentMethodSelector2.default.pms__title },
	                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'pay-with', defaultMessage: 'Pay with' })
	                        ),
	                        _react2.default.createElement('hr', null),
	                        _react2.default.createElement(
	                            'ul',
	                            { className: 'pms__options' },
	                            paymentOptions.map(function (option) {
	                                return _react2.default.createElement(
	                                    'li',
	                                    { key: option.id, className: _paymentMethodSelector2.default.pms__option },
	                                    option.component
	                                );
	                            })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { style: { display: 'flex' } },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'confirmation-form__container', style: { width: '100%' } },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'row' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-md-6', style: { marginBottom: '15px' } },
	                                    _react2.default.createElement(
	                                        'h4',
	                                        { style: { marginBottom: '10px' } },
	                                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'billingAddress', defaultMessage: 'Billing Address' }),
	                                        ':'
	                                    ),
	                                    this.props.order.bill_address && _react2.default.createElement(_address2.default, { address: this.props.order.bill_address })
	                                ),
	                                !_zoneService2.default.isDonationZone() && _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-md-6' },
	                                    _react2.default.createElement(
	                                        'h4',
	                                        { style: { marginBottom: '10px' } },
	                                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'shippingAddress', defaultMessage: 'Shipping Address' }),
	                                        ':'
	                                    ),
	                                    this.props.order.ship_address && _react2.default.createElement(_address2.default, { address: this.props.order.ship_address })
	                                )
	                            ),
	                            _react2.default.createElement('hr', null),
	                            _react2.default.createElement(
	                                'div',
	                                null,
	                                this.getShipmentDetails()
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return PaymentStep;
	}(_react.Component);
	
	exports.default = (0, _reactIntl.injectIntl)(PaymentStep);

/***/ },
/* 675 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxForm = __webpack_require__(61);
	
	var _reactIntl = __webpack_require__(11);
	
	var _validators = __webpack_require__(104);
	
	var _validators2 = _interopRequireDefault(_validators);
	
	var _formField = __webpack_require__(103);
	
	var _formField2 = _interopRequireDefault(_formField);
	
	var _creditCard = __webpack_require__(250);
	
	var _creditCard2 = _interopRequireDefault(_creditCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable max-len */
	
	
	var CardFields = function (_Component) {
	    _inherits(CardFields, _Component);
	
	    function CardFields(props) {
	        _classCallCheck(this, CardFields);
	
	        var _this = _possibleConstructorReturn(this, (CardFields.__proto__ || Object.getPrototypeOf(CardFields)).call(this, props));
	
	        _this.state = {
	            ccType: 'generic'
	        };
	        return _this;
	    }
	
	    _createClass(CardFields, [{
	        key: 'onCCNumberChange',
	        value: function onCCNumberChange(e) {
	            this.setState({
	                ccType: _creditCard2.default.ccType(e.target.value)
	            });
	            this.props.onInputChangeHandler(e);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            return _react2.default.createElement(
	                'div',
	                { className: '', id: 'PaymentForm' },
	                _react2.default.createElement(_reduxForm.Field, {
	                    className: 'form-control',
	                    name: 'order[payments_attributes][0][source_attributes][name]',
	                    component: _formField2.default.inputFieldMarkup,
	                    label: this.props.intl.formatMessage({ id: 'nameOnCard', defaultMessage: 'Name on card' }),
	                    onChange: this.props.onInputChangeHandler,
	                    onFocus: this.props.onInputFocus,
	                    type: 'text',
	                    validate: _validators2.default.required
	                }),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'cc-number-wrapper' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'cc-number-wrapper__input' },
	                        _react2.default.createElement(_reduxForm.Field, {
	                            className: 'form-control',
	                            name: 'order[payments_attributes][0][source_attributes][number]',
	                            component: _formField2.default.inputFieldMarkup,
	                            label: this.props.intl.formatMessage({ id: 'cardNumber', defaultMessage: 'Card Number' }),
	                            onChange: function onChange(e) {
	                                _this2.onCCNumberChange(e);
	                            },
	                            onFocus: this.props.onInputFocus,
	                            defaultValue: this.props['order[payments_attributes][0][source_attributes][number]'],
	                            type: 'tel',
	                            validate: _validators2.default.required
	                        })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'cc-number-wrapper__card-logo' },
	                        _react2.default.createElement('img', { src: '/pay-types/' + this.state.ccType + '-logo.png', alt: 'CC logo' })
	                    )
	                ),
	                _react2.default.createElement(_reduxForm.Field, {
	                    className: 'form-control',
	                    name: 'order[payments_attributes][0][source_attributes][expiry]',
	                    component: _formField2.default.inputFieldMarkup,
	                    label: this.props.intl.formatMessage({ id: 'cardExpiration', defaultMessage: 'Card Expiration' }),
	                    placeholder: this.props.intl.formatMessage({ id: 'card-expiry-placeholder', defaultMessage: 'Expiration' }),
	                    onChange: this.props.onInputChangeHandler,
	                    onFocus: this.props.onInputFocus,
	                    defaultValue: this.props['order[payments_attributes][0][source_attributes][expiry]'],
	                    type: 'tel',
	                    validate: _validators2.default.required
	                }),
	                _react2.default.createElement(_reduxForm.Field, {
	                    className: 'form-control',
	                    name: 'order[payments_attributes][0][source_attributes][verification_value]',
	                    component: _formField2.default.inputFieldMarkup,
	                    label: 'CVV*',
	                    placeholder: this.props.intl.formatMessage({ id: 'security-digits', defaultMessage: 'Security digits' }),
	                    onChange: this.props.onInputChangeHandler,
	                    onFocus: this.props.onInputFocus,
	                    defaultValue: this.props['order[payments_attributes][0][source_attributes][verification_value]'],
	                    type: 'tel',
	                    validate: _validators2.default.required
	                })
	            );
	        }
	    }]);
	
	    return CardFields;
	}(_react.Component);
	
	exports.default = (0, _reactIntl.injectIntl)(CardFields);

/***/ },
/* 676 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _paymentMethodSelector = __webpack_require__(170);
	
	var _paymentMethodSelector2 = _interopRequireDefault(_paymentMethodSelector);
	
	var _paymentFormConnector = __webpack_require__(365);
	
	var _paymentFormConnector2 = _interopRequireDefault(_paymentFormConnector);
	
	var _store = __webpack_require__(40);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _actions = __webpack_require__(23);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable class-methods-use-this */
	
	// eslint-disable-next-line import/no-cycle
	
	
	var CREDIT_CARD_OPTIONS = ['141', '16'];
	
	var PaymentMethodCreditCard = function (_React$Component) {
	    _inherits(PaymentMethodCreditCard, _React$Component);
	
	    function PaymentMethodCreditCard() {
	        _classCallCheck(this, PaymentMethodCreditCard);
	
	        return _possibleConstructorReturn(this, (PaymentMethodCreditCard.__proto__ || Object.getPrototypeOf(PaymentMethodCreditCard)).apply(this, arguments));
	    }
	
	    _createClass(PaymentMethodCreditCard, [{
	        key: 'onNext',
	        value: function onNext() {
	            if (!_store2.default.getState().order.isFinalStepHappening) {
	                _store2.default.dispatch(_actions2.default.setIsFinalStepHappening(true));
	                _store2.default.dispatch(_actions2.default.displayLoader());
	                window.scrollTo(0, 0);
	
	                _store2.default.dispatch(_actions2.default.goToNextStep(this.props.order, this.props.locale, {})).then(function () {}, function (error) {
	                    console.log(error);
	                }).finally(function () {
	                    _store2.default.dispatch(_actions2.default.setIsFinalStepHappening(false));
	                    _store2.default.dispatch(_actions2.default.hideLoader());
	                });
	            }
	        }
	    }, {
	        key: 'isThisOptionSelected',
	        value: function isThisOptionSelected() {
	            return this.props.method && this.props.optionSelected && this.props.method.id === this.props.optionSelected.id;
	        }
	    }, {
	        key: 'shouldNextBeEnabled',
	        value: function shouldNextBeEnabled() {
	            return this.props.order.isCreditCardValidated;
	        }
	    }, {
	        key: 'selectionToggle',
	        value: function selectionToggle() {
	            if (this.props.onOptionSelected) {
	                this.props.onOptionSelected(this.props.method);
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement('input', {
	                        type: 'radio',
	                        id: this.props.method.id,
	                        name: 'payment_method',
	                        value: this.props.method.name,
	                        onChange: function onChange() {
	                            _this2.selectionToggle();
	                        },
	                        defaultChecked: this.props.method.isDefault
	                    }),
	                    _react2.default.createElement(
	                        'label',
	                        { className: _paymentMethodSelector2.default.pms__option__label, htmlFor: this.props.method.id },
	                        this.props.method.name
	                    )
	                ),
	                CREDIT_CARD_OPTIONS.includes(this.props.optionSelected.id) && _react2.default.createElement(_paymentFormConnector2.default, null)
	            );
	        }
	    }]);
	
	    return PaymentMethodCreditCard;
	}(_react2.default.Component);
	
	exports.default = PaymentMethodCreditCard;

/***/ },
/* 677 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(41);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _reactRouterRedux = __webpack_require__(30);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(11);
	
	var _reactBootstrap = __webpack_require__(38);
	
	var _userUtils = __webpack_require__(181);
	
	var _userUtils2 = _interopRequireDefault(_userUtils);
	
	var _paymentMethodSelector = __webpack_require__(170);
	
	var _paymentMethodSelector2 = _interopRequireDefault(_paymentMethodSelector);
	
	var _paymentMethodKWallet = __webpack_require__(2157);
	
	var _paymentMethodKWallet2 = _interopRequireDefault(_paymentMethodKWallet);
	
	var _signin = __webpack_require__(138);
	
	var _signin2 = _interopRequireDefault(_signin);
	
	var _kwalletLogo = __webpack_require__(464);
	
	var _kwalletLogo2 = _interopRequireDefault(_kwalletLogo);
	
	var _signInForm = __webpack_require__(361);
	
	var _signInForm2 = _interopRequireDefault(_signInForm);
	
	var _store = __webpack_require__(40);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _actions = __webpack_require__(23);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	var _loaderUtils = __webpack_require__(813);
	
	var _loaderUtils2 = _interopRequireDefault(_loaderUtils);
	
	var _loader = __webpack_require__(65);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _wallets = __webpack_require__(240);
	
	var _wallets2 = _interopRequireDefault(_wallets);
	
	var _helper = __webpack_require__(60);
	
	var _appRoutes = __webpack_require__(22);
	
	var _appRoutes2 = _interopRequireDefault(_appRoutes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	/* eslint-disable class-methods-use-this */
	
	
	var PaymentMethodKWallet = function (_React$Component) {
	    _inherits(PaymentMethodKWallet, _React$Component);
	
	    function PaymentMethodKWallet(props) {
	        _classCallCheck(this, PaymentMethodKWallet);
	
	        var _this = _possibleConstructorReturn(this, (PaymentMethodKWallet.__proto__ || Object.getPrototypeOf(PaymentMethodKWallet)).call(this, props));
	
	        _this.state = {
	            hasKWalletAccountActive: false,
	            balance: 0,
	            availableBalance: 0
	        };
	        return _this;
	    }
	
	    _createClass(PaymentMethodKWallet, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            var checkKWalletAccount = function () {
	                var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	                    var _spreeStore$getState, hasKWalletAccountActive, accessToken, response, _response$body, balance, availableBalance;
	
	                    return _regenerator2.default.wrap(function _callee$(_context) {
	                        while (1) {
	                            switch (_context.prev = _context.next) {
	                                case 0:
	                                    _spreeStore$getState = _store2.default.getState();
	                                    hasKWalletAccountActive = _spreeStore$getState.wallets.kwallet;
	                                    accessToken = _spreeStore$getState.auth.access_token;
	
	                                    if (!hasKWalletAccountActive) {
	                                        _context.next = 11;
	                                        break;
	                                    }
	
	                                    _context.next = 6;
	                                    return _wallets2.default.getWalletDetails({ wallet: 'kwallet', token: accessToken });
	
	                                case 6:
	                                    response = _context.sent;
	                                    _response$body = response.body;
	                                    balance = _response$body.balance;
	                                    availableBalance = _response$body.available_balance;
	
	                                    _this2.setState({ balance: balance, availableBalance: availableBalance, hasKWalletAccountActive: hasKWalletAccountActive });
	
	                                case 11:
	                                case 'end':
	                                    return _context.stop();
	                            }
	                        }
	                    }, _callee, _this2);
	                }));
	
	                return function checkKWalletAccount() {
	                    return _ref.apply(this, arguments);
	                };
	            }();
	            if (_userUtils2.default.isLoggedIn()) {
	                checkKWalletAccount();
	            }
	        }
	    }, {
	        key: 'onNext',
	        value: function onNext() {
	            var _this3 = this;
	
	            if (!_store2.default.getState().order.isFinalStepHappening && !_loaderUtils2.default.isLoading()) {
	                _store2.default.dispatch(_actions2.default.setIsFinalStepHappening(true));
	                _store2.default.dispatch(_actions2.default.displayLoader());
	                window.scrollTo(0, 0);
	
	                var onCompleteError = function onCompleteError(error) {
	                    _this3.sendDataPaymentMethod();
	                };
	
	                _store2.default.dispatch(_actions2.default.goToNextStep(this.props.order, this.props.locale, {}, true, { onCompleteError: onCompleteError })).then(function () {}, function (error) {
	                    console.log(error);
	                }).finally(function () {
	                    _store2.default.dispatch(_actions2.default.setIsFinalStepHappening(false));
	                    _store2.default.dispatch(_actions2.default.hideLoader());
	                });
	            }
	        }
	    }, {
	        key: 'onSignIn',
	        value: function onSignIn(formData) {
	            var _this4 = this;
	
	            _userUtils2.default.signUp(formData, this.props.locale, false).then(function () {
	                var _spreeStore$getState2 = _store2.default.getState();
	
	                var accessToken = _spreeStore$getState2.auth.access_token;
	
	                _store2.default.dispatch(_actions2.default.activeWallet('kwallet', accessToken, true)).then(function (result) {
	                    if (result) {
	                        _wallets2.default.getWalletDetails({ wallet: 'kwallet', token: accessToken }).then(function (response) {
	                            console.log('response', response);
	                            var _response$body2 = response.body;
	                            var balance = _response$body2.balance;
	                            var availableBalance = _response$body2.available_balance;
	
	                            _this4.setState({ balance: balance, availableBalance: availableBalance, hasKWalletAccountActive: true });
	                        });
	                    }
	                });
	                _store2.default.dispatch(_actions2.default.displayLoader());
	                _userUtils2.default.subscribeToAssociateOrderLogin().then(function () {
	                    _this4.sendDataPaymentMethod();
	                }).finally(function () {
	                    _store2.default.dispatch(_actions2.default.hideLoader());
	                });
	            });
	        }
	    }, {
	        key: 'selectionToggle',
	        value: function selectionToggle() {
	            if (this.props.onOptionSelected) {
	                this.props.onOptionSelected(this.props.method);
	                this.sendDataPaymentMethod();
	            }
	        }
	    }, {
	        key: 'sendDataPaymentMethod',
	        value: function sendDataPaymentMethod() {
	            if (_userUtils2.default.isLoggedIn()) {
	                var accessToken = _store2.default.getState().auth.access_token;
	
	                var paymentMethods = _store2.default.getState().order.payment_methods;
	
	                var kwallet = paymentMethods.find(function (pm) {
	                    return pm.attributes.type === 'Spree::Gateway::KwalletGateway';
	                });
	                var formData = {
	                    order: {
	                        payments_attributes: [{
	                            payment_method_id: kwallet.id
	                        }]
	                    },
	                    payment_source: _defineProperty({}, kwallet.id, {
	                        token_auth: accessToken
	                    })
	                };
	
	                window.scrollTo(0, 0);
	                _store2.default.dispatch(_actions2.default.displayLoader());
	                _store2.default.dispatch(_actions2.default.goToNextStep(this.props.order, this.props.locale, formData, false)).finally(function () {
	                    _store2.default.dispatch(_actions2.default.hideLoader());
	                });
	            }
	        }
	    }, {
	        key: 'isThisOptionSelected',
	        value: function isThisOptionSelected() {
	            return this.props.method && this.props.optionSelected && this.props.method.id === this.props.optionSelected.id;
	        }
	    }, {
	        key: 'shouldNextBeEnabled',
	        value: function shouldNextBeEnabled() {
	            // add logic here to specify when next button should be enabled
	            return _userUtils2.default.isLoggedIn() && this.state.hasKWalletAccountActive && Number(this.state.availableBalance) >= Number(this.props.order.total);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this5 = this;
	
	            var signedInContent = _react2.default.createElement(
	                'div',
	                { className: _paymentMethodKWallet2.default.pmKWalletWrapper__signedIn },
	                _react2.default.createElement(
	                    'div',
	                    { className: _paymentMethodKWallet2.default.pmKWalletWrapper__signedIn__colLeft },
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement('img', { src: _kwalletLogo2.default, alt: 'K-Wallet logo' })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: _paymentMethodKWallet2.default.pmKWalletWrapper__signedIn__description },
	                        this.props.method.description
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: _paymentMethodKWallet2.default.pmKWalletWrapper__signedIn__colRight },
	                    this.state.hasKWalletAccountActive && _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                            'div',
	                            { className: _paymentMethodKWallet2.default.pmKWalletWrapper__signedIn__colRight__balanceSummary },
	                            _react2.default.createElement(
	                                'div',
	                                { className: _paymentMethodKWallet2.default.pmKWalletWrapper__signedIn__colRight__balanceSummary__colLabels },
	                                _react2.default.createElement(
	                                    'div',
	                                    { style: { fontSize: '17px', fontWeight: 'bolder' } },
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'manage-k-wallet-banner-account-balance', defaultMessage: 'Saldo actual:' })
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { style: { fontSize: '16px' } },
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'manage-k-wallet-banner-available-balance', defaultMessage: 'Saldo disponible:' })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: _paymentMethodKWallet2.default.pmKWalletWrapper__signedIn__colRight__balanceSummary__colValues },
	                                _react2.default.createElement(
	                                    'div',
	                                    { style: { fontSize: '17px', fontWeight: 'bolder' } },
	                                    _react2.default.createElement(
	                                        'span',
	                                        null,
	                                        _helper.priceFormat.format(this.state.balance)
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { style: { fontSize: '16px' } },
	                                    _react2.default.createElement(
	                                        'span',
	                                        null,
	                                        _helper.priceFormat.format(this.state.availableBalance)
	                                    )
	                                )
	                            )
	                        ),
	                        Number(this.state.availableBalance) < Number(this.props.order.total) && _react2.default.createElement(
	                            _reactBootstrap.OverlayTrigger,
	                            {
	                                placement: 'bottom',
	                                shouldUpdatePosition: true,
	                                overlay: _react2.default.createElement(
	                                    _reactBootstrap.Tooltip,
	                                    { id: Math.random() },
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'manage-k-wallet-add-balance', defaultMessage: 'Clic para agregar fondos' })
	                                )
	                            },
	                            _react2.default.createElement(
	                                'div',
	                                {
	                                    className: _paymentMethodKWallet2.default.pmKWalletWrapper__signedIn__colRight__balance_insufficient,
	                                    onClick: function onClick() {
	                                        return _store2.default.dispatch((0, _reactRouterRedux.push)(_appRoutes2.default.addFundsKWallet));
	                                    }
	                                },
	                                _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                    id: 'manage-k-wallet-insufficient-balance',
	                                    defaultMessage: 'SALDO INSUFICIENTE'
	                                })
	                            )
	                        )
	                    ),
	                    !this.state.hasKWalletAccountActive && _react2.default.createElement(
	                        'span',
	                        { style: { fontSize: '16px' } },
	                        _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
	                            id: 'k-wallet-account-not-active-yet',
	                            defaultMessage: 'Su cuenta K-Wallet aun no se encuentra activa. Dirigete a \'Administrar K-Wallet\' para activarla.'
	                        })
	                    )
	                )
	            );
	
	            var notSignedInContent = _react2.default.createElement(
	                'div',
	                { className: _paymentMethodKWallet2.default.pmKWalletWrapper__notSignedIn },
	                _react2.default.createElement(
	                    'div',
	                    { className: _paymentMethodKWallet2.default.pmKWalletWrapper__notSignedIn__description },
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement('img', { src: _kwalletLogo2.default, alt: 'K-Wallet logo' })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: _paymentMethodKWallet2.default.pmKWalletWrapper__notSignedIn__description__text },
	                        'Para pagar con K-Wallet debes iniciar sesi\xF3n'
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: _signin2.default.signin + ' ' + _paymentMethodKWallet2.default.pmKWalletWrapper__notSignedIn__signInForm },
	                    _react2.default.createElement(_signInForm2.default, {
	                        onSubmitCallback: function onSubmitCallback(formData) {
	                            _this5.onSignIn(formData);
	                        }
	                    })
	                )
	            );
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement('input', {
	                        type: 'radio',
	                        id: this.props.method.id,
	                        name: 'payment_method',
	                        value: this.props.method.name,
	                        onChange: function onChange() {
	                            _this5.selectionToggle();
	                        },
	                        defaultChecked: this.props.method.isDefault
	                    }),
	                    _react2.default.createElement(
	                        'label',
	                        { className: _paymentMethodSelector2.default.pms__option__label, htmlFor: this.props.method.id },
	                        this.props.method.name
	                    )
	                ),
	                this.isThisOptionSelected() && _loaderUtils2.default.isLoading() && _react2.default.createElement(
	                    'div',
	                    { className: 'checkout-loading-container' },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'please-wait', defaultMessage: 'please wait' }),
	                    _react2.default.createElement(_loader2.default, { displayLoader: true, size: 36 })
	                ),
	                this.isThisOptionSelected() && !_loaderUtils2.default.isLoading() && _react2.default.createElement(
	                    'div',
	                    { style: { padding: '25px' } },
	                    _userUtils2.default.isLoggedIn() ? signedInContent : notSignedInContent
	                )
	            );
	        }
	    }]);
	
	    return PaymentMethodKWallet;
	}(_react2.default.Component);
	
	exports.default = PaymentMethodKWallet;

/***/ },
/* 678 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _paymentRedsysFormConnector = __webpack_require__(747);
	
	var _paymentRedsysFormConnector2 = _interopRequireDefault(_paymentRedsysFormConnector);
	
	var _store = __webpack_require__(40);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _paymentMethodSelector = __webpack_require__(170);
	
	var _paymentMethodSelector2 = _interopRequireDefault(_paymentMethodSelector);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable class-methods-use-this */
	
	
	var PaymentMethodRedsys = function (_React$Component) {
	    _inherits(PaymentMethodRedsys, _React$Component);
	
	    function PaymentMethodRedsys(props) {
	        _classCallCheck(this, PaymentMethodRedsys);
	
	        var _this = _possibleConstructorReturn(this, (PaymentMethodRedsys.__proto__ || Object.getPrototypeOf(PaymentMethodRedsys)).call(this, props));
	
	        _this.redsysFormRef = _react2.default.createRef();
	        return _this;
	    }
	
	    _createClass(PaymentMethodRedsys, [{
	        key: 'onNext',
	        value: function onNext() {
	            this.redsysFormRef.current.querySelector('form').submit();
	        }
	    }, {
	        key: 'selectionToggle',
	        value: function selectionToggle() {
	            if (this.props.onOptionSelected) {
	                window.scrollTo(0, 0);
	                this.props.onOptionSelected(this.props.method);
	            }
	        }
	    }, {
	        key: 'isThisOptionSelected',
	        value: function isThisOptionSelected() {
	            return this.props.method && this.props.optionSelected && this.props.method.id === this.props.optionSelected.id;
	        }
	    }, {
	        key: 'shouldNextBeEnabled',
	        value: function shouldNextBeEnabled() {
	            var _spreeStore$getState = _store2.default.getState();
	
	            var order = _spreeStore$getState.order;
	
	            if (order.redsysPaymentInfo.Ds_MerchantParameters) {
	                return true;
	            }
	            return false;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement('input', {
	                        type: 'radio',
	                        id: this.props.method.id,
	                        name: 'payment_method',
	                        value: this.props.method.name,
	                        onChange: function onChange() {
	                            _this2.selectionToggle();
	                        },
	                        defaultChecked: this.props.method.isDefault
	                    }),
	                    _react2.default.createElement(
	                        'label',
	                        { className: _paymentMethodSelector2.default.pms__option__label, htmlFor: this.props.method.id },
	                        this.props.method.name
	                    )
	                ),
	                this.isThisOptionSelected() && _react2.default.createElement(
	                    'div',
	                    { ref: this.redsysFormRef, style: { display: 'none' } },
	                    _react2.default.createElement(_paymentRedsysFormConnector2.default, null)
	                )
	            );
	        }
	    }]);
	
	    return PaymentMethodRedsys;
	}(_react2.default.Component);
	
	exports.default = PaymentMethodRedsys;

/***/ },
/* 679 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _paymentMethodSelector = __webpack_require__(170);
	
	var _paymentMethodSelector2 = _interopRequireDefault(_paymentMethodSelector);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable class-methods-use-this */
	
	
	var PaymentMethodTropipay = function (_React$Component) {
	    _inherits(PaymentMethodTropipay, _React$Component);
	
	    function PaymentMethodTropipay() {
	        _classCallCheck(this, PaymentMethodTropipay);
	
	        return _possibleConstructorReturn(this, (PaymentMethodTropipay.__proto__ || Object.getPrototypeOf(PaymentMethodTropipay)).apply(this, arguments));
	    }
	
	    _createClass(PaymentMethodTropipay, [{
	        key: 'onNext',
	        value: function onNext() {
	            // add logic here to specify what to do once the Pay With button gets clicked by the user
	            console.log('Executing Tropipay Payment');
	        }
	    }, {
	        key: 'selectionToggle',
	        value: function selectionToggle() {
	            if (this.props.onOptionSelected) {
	                this.props.onOptionSelected(this.props.method);
	            }
	        }
	    }, {
	        key: 'isThisOptionSelected',
	        value: function isThisOptionSelected() {
	            return this.props.method && this.props.optionSelected && this.props.method.id === this.props.optionSelected.id;
	        }
	    }, {
	        key: 'shouldNextBeEnabled',
	        value: function shouldNextBeEnabled() {
	            // add logic here to specify when next button should be enabled
	            return true;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement('input', {
	                        type: 'radio',
	                        id: this.props.method.id,
	                        name: 'payment_method',
	                        value: this.props.method.name,
	                        onChange: function onChange() {
	                            _this2.selectionToggle();
	                        },
	                        defaultChecked: this.props.method.isDefault
	                    }),
	                    _react2.default.createElement(
	                        'label',
	                        { className: _paymentMethodSelector2.default.pms__option__label, htmlFor: this.props.method.id },
	                        this.props.method.name
	                    )
	                )
	            );
	        }
	    }]);
	
	    return PaymentMethodTropipay;
	}(_react2.default.Component);
	
	exports.default = PaymentMethodTropipay;

/***/ },
/* 680 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Step = function Step(_ref) {
	    var title = _ref.title;
	    var isActive = _ref.isActive;
	    var isComplete = _ref.isComplete;
	    return _react2.default.createElement(
	        'li',
	        { className: 'progress-step' + (isActive ? ' is-active' : '') + ' ' + (isComplete ? ' is-complete' : '') },
	        _react2.default.createElement('div', { className: 'progress-marker' }),
	        _react2.default.createElement(
	            'div',
	            { className: 'progress-text' },
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: title, defaultMessage: title })
	        )
	    );
	};
	
	exports.default = Step;

/***/ },
/* 681 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Stepper = function Stepper(props) {
	    return _react2.default.createElement(
	        "ul",
	        { className: "progress-tracker progress-tracker--text progress-tracker--center" },
	        props.children
	    );
	};
	
	exports.default = Stepper;

/***/ },
/* 682 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(38);
	
	var _homeSlider = __webpack_require__(2158);
	
	var _homeSlider2 = _interopRequireDefault(_homeSlider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var HomeSlider = function (_Component) {
	    _inherits(HomeSlider, _Component);
	
	    function HomeSlider() {
	        _classCallCheck(this, HomeSlider);
	
	        return _possibleConstructorReturn(this, (HomeSlider.__proto__ || Object.getPrototypeOf(HomeSlider)).apply(this, arguments));
	    }
	
	    _createClass(HomeSlider, [{
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                _reactBootstrap.Carousel,
	                { className: 'homepage-slider ' + _homeSlider2.default.homeSlider, interval: 10000 },
	                _react2.default.createElement(
	                    _reactBootstrap.Carousel.Item,
	                    {
	                        className: ' ' + _homeSlider2.default.homeSliderRow,
	                        style: { backgroundImage: 'url(' + __webpack_require__(2182)("./" + this.props.locale.currentLocale + '/image01.jpg') + ')', backgroundSize: 'cover' }
	                    },
	                    _react2.default.createElement('div', { className: 'container ' + _homeSlider2.default.sliderContainer })
	                )
	            );
	        }
	    }]);
	
	    return HomeSlider;
	}(_react.Component);
	
	exports.default = HomeSlider;

/***/ },
/* 683 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /* eslint-disable max-len */
	/* eslint-disable indent */
	/* eslint-disable object-curly-newline */
	/* eslint-disable react/jsx-indent */
	/* eslint-disable react/self-closing-comp */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(38);
	
	var _reactIntl = __webpack_require__(11);
	
	var _reactRouterDom = __webpack_require__(26);
	
	var _appRoutes = __webpack_require__(22);
	
	var _appRoutes2 = _interopRequireDefault(_appRoutes);
	
	var _helper = __webpack_require__(60);
	
	var _kwalletLogo = __webpack_require__(464);
	
	var _kwalletLogo2 = _interopRequireDefault(_kwalletLogo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Banner = function Banner(_ref) {
	    var accountBalance = _ref.accountBalance;
	    var availableBalance = _ref.availableBalance;
	    var activeWallet = _ref.activeWallet;
	    var kWalletId = _ref.kWalletId;
	    var transferFunds = _ref.transferFunds;
	    var intl = _ref.intl;
	
	    var _useState = (0, _react.useState)(false);
	
	    var _useState2 = _slicedToArray(_useState, 2);
	
	    var isWalletIdRevealed = _useState2[0];
	    var setIsWalletIdRevealed = _useState2[1];
	
	    var _useState3 = (0, _react.useState)(false);
	
	    var _useState4 = _slicedToArray(_useState3, 2);
	
	    var isCopied = _useState4[0];
	    var setIsCopied = _useState4[1];
	
	    var copyIcon = isCopied ? _react2.default.createElement(
	        'svg',
	        { xmlns: 'http://www.w3.org/2000/svg', width: '20', height: '20', fill: 'currentColor', className: 'bi bi-clipboard-check-fill', viewBox: '0 0 16 16' },
	        _react2.default.createElement('path', { d: 'M6.5 0A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3Zm3 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3Z' }),
	        _react2.default.createElement('path', { d: 'M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1A2.5 2.5 0 0 1 9.5 5h-3A2.5 2.5 0 0 1 4 2.5v-1Zm6.854 7.354-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 0 1 .708-.708L7.5 10.793l2.646-2.647a.5.5 0 0 1 .708.708Z' })
	    ) : _react2.default.createElement(
	        'svg',
	        { xmlns: 'http://www.w3.org/2000/svg', width: '20', height: '20', fill: 'currentColor', className: 'bi bi-clipboard-fill', viewBox: '0 0 16 16' },
	        _react2.default.createElement('path', {
	            fillRule: 'evenodd',
	            d: 'M10 1.5a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-1Zm-5 0A1.5 1.5 0 0 1 6.5 0h3A1.5 1.5 0 0 1 11 1.5v1A1.5 1.5 0 0 1 9.5 4h-3A1.5 1.5 0 0 1 5 2.5v-1Zm-2 0h1v1A2.5 2.5 0 0 0 6.5 5h3A2.5 2.5 0 0 0 12 2.5v-1h1a2 2 0 0 1 2 2V14a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3.5a2 2 0 0 1 2-2Z'
	        })
	    );
	    var onKWalletIdCopied = function onKWalletIdCopied() {
	        navigator.clipboard.writeText(kWalletId).then(function () {
	            setIsCopied(true);
	        }).catch(function (err) {
	            return console.log(err);
	        });
	    };
	
	    return _react2.default.createElement(
	        'section',
	        { className: 'section-banner' },
	        _react2.default.createElement(
	            'div',
	            { className: 'banner-message' },
	            _react2.default.createElement('img', { src: _kwalletLogo2.default, alt: 'K-Wallett' }),
	            _react2.default.createElement(
	                'h4',
	                { className: 'banner-header' },
	                _react2.default.createElement(_reactIntl.FormattedMessage, {
	                    id: 'manage-k-wallet-banner-message',
	                    defaultMessage: 'Nuestro exclusivo Programa de Tarjeta Recargable hace que las transacciones financieras sean f\xE1ciles y seguras'
	                })
	            ),
	            _react2.default.createElement(
	                'ul',
	                { className: 'banner-messages' },
	                _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'manage-k-wallet-banner-direct-deposit', defaultMessage: 'Dep\xF3sito directo (ACH debit)' })
	                ),
	                _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'manage-k-wallet-banner-load-card', defaultMessage: 'Carga de tarjeta' })
	                ),
	                _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'manage-k-wallet-banner-peer-to-peer-transfer', defaultMessage: 'Transferencia de cr\xE9dito de usuario a usuario' })
	                ),
	                _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'manage-k-wallet-banner-check-your-balance', defaultMessage: 'Consulta de saldo' })
	                ),
	                _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'manage-k-wallet-banner-pay-the-bill', defaultMessage: 'Pago de la factura' })
	                )
	            )
	        ),
	        activeWallet && _react2.default.createElement(
	            'div',
	            { className: 'banner-links' },
	            _react2.default.createElement(
	                'div',
	                { className: 'balance-summary' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'balance-summary__col balance-summary__col-left' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'balance-summary__col__label' },
	                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'manage-k-wallet-banner-account-balance', defaultMessage: 'Saldo actual:' })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'balance-summary__col__label', style: { fontSize: '15px' } },
	                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'manage-k-wallet-banner-available-balance', defaultMessage: 'Saldo disponible:' })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'balance-summary__col__label', style: { marginTop: '16px' } },
	                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'manage-k-wallet-banner-your-k-wallet-id', defaultMessage: 'K-Wallet ID' })
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'balance-summary__col balance-summary__col-right' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'balance-summary__col__value' },
	                        _react2.default.createElement(
	                            'span',
	                            null,
	                            accountBalance !== undefined ? _helper.priceFormat.format(accountBalance) : '...'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'balance-summary__col__value', style: { fontSize: '15px' } },
	                        _react2.default.createElement(
	                            'span',
	                            null,
	                            availableBalance !== undefined ? _helper.priceFormat.format(availableBalance) : '...'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'balance-summary__col__wallet-id' },
	                        !isWalletIdRevealed && _react2.default.createElement(
	                            'span',
	                            { style: { flex: '1 1 auto' }, onClick: function onClick() {
	                                    return setIsWalletIdRevealed(!isWalletIdRevealed);
	                                } },
	                            _react2.default.createElement(
	                                _reactBootstrap.OverlayTrigger,
	                                { placement: 'top', shouldUpdatePosition: true, overlay: _react2.default.createElement(
	                                        _reactBootstrap.Tooltip,
	                                        { id: Math.random() },
	                                        intl.formatMessage({ id: 'manage-k-wallet-banner-click-to-reveal', defaultMessage: 'Click to reveal' })
	                                    ) },
	                                _react2.default.createElement('input', { readOnly: true, type: 'password', className: 'form-control', value: kWalletId || '' })
	                            )
	                        ),
	                        isWalletIdRevealed && _react2.default.createElement('input', { style: { flex: '1 1 auto' }, readOnly: true, type: 'text', className: 'form-control', value: kWalletId || '' }),
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'copy-icon', onClick: function onClick() {
	                                    return onKWalletIdCopied();
	                                } },
	                            _react2.default.createElement(
	                                _reactBootstrap.OverlayTrigger,
	                                {
	                                    placement: 'top',
	                                    shouldUpdatePosition: true,
	                                    overlay:
	                                    // eslint-disable-next-line react/jsx-one-expression-per-line
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Tooltip,
	                                        { id: Math.random() },
	                                        isCopied ? intl.formatMessage({ id: 'manage-k-wallet-banner-copied', defaultMessage: 'Copiado!' }) : intl.formatMessage({ id: 'manage-k-wallet-banner-copy-to-clipboard', defaultMessage: 'Copiar' })
	                                    )
	                                },
	                                _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    copyIcon
	                                )
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                _reactRouterDom.Link,
	                { className: 'banner-main-cta', to: _appRoutes2.default.addFundsKWallet },
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'manage-k-wallet-banner-add-funds', defaultMessage: 'Agregar fondos a K-Wallet' })
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'banner-links-subtitle' },
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'manage-k-wallet-banner-to-use-k-wallet', defaultMessage: 'Para aprovechar K-Wallet, siga estos pasos:' })
	            ),
	            _react2.default.createElement(
	                'ul',
	                { className: 'banner-links-k-wallet' },
	                _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                        'a',
	                        { href: '#', onClick: transferFunds },
	                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'manage-k-wallet-banner-transfer-money-link', defaultMessage: 'Enviar dinero a un receptor' })
	                    )
	                )
	            )
	        )
	    );
	};
	
	exports.default = (0, _reactIntl.injectIntl)(Banner);

/***/ },
/* 684 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(38);
	
	var _reactIntl = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TransactionDateTooltip = function TransactionDateTooltip(props) {
	    var content = props.content;
	    var extra = props.extra;
	
	    return _react2.default.createElement(
	        'div',
	        { style: { cursor: 'pointer' } },
	        _react2.default.createElement(
	            _reactBootstrap.OverlayTrigger,
	            {
	                placement: 'top',
	                overlay:
	                // eslint-disable-next-line react/jsx-one-expression-per-line
	                _react2.default.createElement(
	                    _reactBootstrap.Tooltip,
	                    { id: Math.random() },
	                    extra
	                )
	            },
	            _react2.default.createElement(
	                'span',
	                null,
	                content
	            )
	        )
	    );
	};
	
	exports.default = TransactionDateTooltip;

/***/ },
/* 685 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(38);
	
	var _reactIntl = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TransactionNoteTooltip = function TransactionNoteTooltip(props) {
	    var notes = props.notes;
	
	    return _react2.default.createElement(
	        'div',
	        { style: { cursor: 'pointer' } },
	        _react2.default.createElement(
	            _reactBootstrap.OverlayTrigger,
	            {
	                placement: 'top',
	                overlay:
	                // eslint-disable-next-line react/jsx-one-expression-per-line
	                _react2.default.createElement(
	                    _reactBootstrap.Tooltip,
	                    { id: Math.random() },
	                    notes
	                )
	            },
	            _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                    'svg',
	                    { xmlns: 'http://www.w3.org/2000/svg', width: '16', height: '16', fill: 'currentColor', className: 'bi bi-file-earmark-fill', viewBox: '0 0 16 16' },
	                    _react2.default.createElement('path', { d: 'M4 0h5.293A1 1 0 0 1 10 .293L13.707 4a1 1 0 0 1 .293.707V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2zm5.5 1.5v2a1 1 0 0 0 1 1h2l-3-3z' })
	                )
	            )
	        )
	    );
	};
	
	exports.default = TransactionNoteTooltip;

/***/ },
/* 686 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(41);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(38);
	
	var _reactIntl = __webpack_require__(11);
	
	var _reactFinalForm = __webpack_require__(522);
	
	var _formField = __webpack_require__(103);
	
	var _formField2 = _interopRequireDefault(_formField);
	
	var _checkboxTermsAffidavit = __webpack_require__(356);
	
	var _checkboxTermsAffidavit2 = _interopRequireDefault(_checkboxTermsAffidavit);
	
	var _loading = __webpack_require__(118);
	
	var _loading2 = _interopRequireDefault(_loading);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var useState = _react2.default.useState;
	
	
	var TransferDialog = function TransferDialog(_ref) {
	    var onSubmit = function () {
	        var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee(values) {
	            return _regenerator2.default.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            transferFunds(values);
	
	                        case 1:
	                        case 'end':
	                            return _context.stop();
	                    }
	                }
	            }, _callee, this);
	        }));
	
	        return function onSubmit(_x) {
	            return _ref2.apply(this, arguments);
	        };
	    }();
	
	    var intl = _ref.intl;
	    var isOpen = _ref.isOpen;
	    var handleClose = _ref.handleClose;
	    var transferFunds = _ref.transferFunds;
	    var _ref$availableBalance = _ref.availableBalance;
	    var availableBalance = _ref$availableBalance === undefined ? 1000 : _ref$availableBalance;
	    var _ref$loading = _ref.loading;
	    var loading = _ref$loading === undefined ? false : _ref$loading;
	
	    var props = _objectWithoutProperties(_ref, ['intl', 'isOpen', 'handleClose', 'transferFunds', 'availableBalance', 'loading']);
	
	    var _useState = useState(false);
	
	    var _useState2 = _slicedToArray(_useState, 2);
	
	    var handleCheck = _useState2[0];
	    var setHandleCheck = _useState2[1];
	
	
	    var composeValidators = function composeValidators() {
	        for (var _len = arguments.length, validators = Array(_len), _key = 0; _key < _len; _key++) {
	            validators[_key] = arguments[_key];
	        }
	
	        return function (value) {
	            return validators.reduce(function (error, validator) {
	                return error || validator(value);
	            }, undefined);
	        };
	    };
	
	    var amountValidator = function amountValidator() {
	        return function (value) {
	            return !Number.isNaN(value) && value > 0 ? undefined : intl.formatMessage({ id: 'transfer-funds-k-wallet-invalid-amount-error', defaultMessage: 'Only numbers greater than zero are allowed. Use (.) to specify cents' });
	        };
	    };
	    var amountBelowValidator = function amountBelowValidator() {
	        return function (value) {
	            return value <= availableBalance ? undefined : intl.formatMessage({ id: 'transfer-funds-k-wallet-available-balance-error', defaultMessage: 'You cannot transfer more than your available balance.' });
	        };
	    };
	    var requiredValidator = function requiredValidator(value) {
	        return value ? undefined : intl.formatMessage({ id: 'required-message', defaultMessage: 'Required' });
	    };
	
	    function handleOnChange(checked) {
	        setHandleCheck(checked);
	    }
	
	    (0, _react.useEffect)(function () {
	        if (isOpen === false) {
	            setHandleCheck(false);
	        }
	    }, [isOpen]);
	
	    return _react2.default.createElement(
	        _reactBootstrap.Modal,
	        { show: isOpen, 'aria-labelledby': 'contained-modal-title-lg' },
	        _react2.default.createElement(_reactFinalForm.Form, {
	            onSubmit: onSubmit,
	            render: function render(_ref3) {
	                var handleSubmit = _ref3.handleSubmit;
	                var form = _ref3.form;
	                var submitting = _ref3.submitting;
	                var pristine = _ref3.pristine;
	                var values = _ref3.values;
	                var errors = _ref3.errors;
	                return (
	                    // eslint-disable-next-line react/jsx-fragments
	                    _react2.default.createElement(
	                        _react2.default.Fragment,
	                        null,
	                        _react2.default.createElement(
	                            'form',
	                            { onSubmit: handleSubmit },
	                            _react2.default.createElement(
	                                _reactBootstrap.Modal.Header,
	                                null,
	                                _react2.default.createElement(
	                                    _reactBootstrap.Modal.Title,
	                                    { id: 'contained-modal-title-lg' },
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'transfer-funds-k-wallet-title', defaultMessage: 'Enviar dinero a un receptor' })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Modal.Body,
	                                { style: { overflow: 'auto' } },
	                                loading && _react2.default.createElement(
	                                    'div',
	                                    { className: _loading2.default.loadingPanel },
	                                    _react2.default.createElement('div', { className: _loading2.default.spinnerDark })
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-md-6 modal-form-top-space' },
	                                    _react2.default.createElement(_reactFinalForm.Field, {
	                                        className: 'form-control',
	                                        name: 'amount',
	                                        component: _formField2.default.inputFieldMarkup,
	                                        label: intl.formatMessage({ id: 'transfer-funds-k-wallet-amount', defaultMessage: 'Cantidad a transferir' }),
	                                        placeholder: intl.formatMessage({ id: 'transfer-funds-k-wallet-amount-placeholder', defaultMessage: 'Cantidad' }),
	                                        type: 'tel',
	                                        validate: composeValidators(requiredValidator, amountValidator(), amountBelowValidator()),
	                                        focused: true
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-md-6 modal-form-top-space' },
	                                    _react2.default.createElement(_reactFinalForm.Field, {
	                                        className: 'form-control',
	                                        name: 'idTransfer',
	                                        label: intl.formatMessage({ id: 'transfer-funds-k-wallet-id-transfer', defaultMessage: 'Identificador de quien recibe' }),
	                                        placeholder: intl.formatMessage({ id: 'transfer-funds-k-wallet-id-transfer-placeholder', defaultMessage: 'Id' }),
	                                        component: _formField2.default.inputFieldMarkup,
	                                        type: 'text',
	                                        validate: composeValidators(requiredValidator)
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-md-12 modal-form-top-space' },
	                                    _react2.default.createElement(_checkboxTermsAffidavit2.default, { onChange: handleOnChange })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Modal.Footer,
	                                null,
	                                _react2.default.createElement(
	                                    'button',
	                                    {
	                                        disabled: !handleCheck || submitting || pristine || Object.keys(errors).length > 0 || loading,
	                                        type: 'submit',
	                                        style: { marginRight: '5px' },
	                                        className: 'button-secondary button-small'
	                                    },
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'send', defaultMessage: 'Send' })
	                                ),
	                                _react2.default.createElement(
	                                    'button',
	                                    {
	                                        disabled: loading,
	                                        type: 'button',
	                                        style: { marginRight: '5px' },
	                                        className: 'button-secondary button-small',
	                                        onClick: handleClose
	                                    },
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'modal-store-button-close', defaultMessage: 'Close' })
	                                )
	                            )
	                        )
	                    )
	                );
	            }
	        })
	    );
	};
	
	exports.default = (0, _reactIntl.injectIntl)(TransferDialog);

/***/ },
/* 687 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(18);
	
	var _reactReduxToastr = __webpack_require__(42);
	
	var _reactReduxToastr2 = _interopRequireDefault(_reactReduxToastr);
	
	var _reactRouterRedux = __webpack_require__(30);
	
	var _browserHistory = __webpack_require__(141);
	
	var _browserHistory2 = _interopRequireDefault(_browserHistory);
	
	var _routes = __webpack_require__(810);
	
	var _routes2 = _interopRequireDefault(_routes);
	
	var _actions = __webpack_require__(23);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	var _store = __webpack_require__(40);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Main = function (_Component) {
	    _inherits(Main, _Component);
	
	    function Main() {
	        _classCallCheck(this, Main);
	
	        return _possibleConstructorReturn(this, (Main.__proto__ || Object.getPrototypeOf(Main)).apply(this, arguments));
	    }
	
	    _createClass(Main, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.unlisten = _browserHistory2.default.listen(function (location, action) {
	                window.scrollTo(0, 0);
	            });
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.props.updateConfigsActiveCart();
	            if (window.zE) {
	                window.zE('webWidget', 'setLocale', this.props.currentLocale);
	            }
	
	            // Listen to another tab's changes in the storage.
	            // We need to keep the order sync across multiple tabs
	            window.addEventListener('storage', function (evt) {
	                var localData = JSON.parse(window.localStorage.getItem('localData'));
	                var localState = _store2.default.getState();
	                if (localData && localData.order && localState && localState.order) {
	                    if (JSON.stringify(localData.order) !== JSON.stringify(localState.order)) {
	                        setTimeout(function () {
	                            _store2.default.dispatch(_actions2.default.syncOrderFromStorage(localData.order));
	                        }, 0);
	                    }
	                }
	            });
	
	            this.props.onTryAutoRefresh();
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            this.unlisten();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    _reactRouterRedux.ConnectedRouter,
	                    { history: _browserHistory2.default },
	                    (0, _routes2.default)()
	                ),
	                _react2.default.createElement(_reactReduxToastr2.default, {
	                    timeOut: 6000,
	                    newestOnTop: false,
	                    position: 'top-right',
	                    getState: function getState(state) {
	                        return state.toastr;
	                    } // This is the default
	                    , transitionIn: 'bounceIn',
	                    transitionOut: 'bounceOut',
	                    closeOnToastrClick: true,
	                    showCloseButton: false
	                })
	            );
	        }
	    }]);
	
	    return Main;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        isAuthenticated: state.auth.token !== null,
	        currentLocale: state.locale.currentLocale
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        onTryAutoRefresh: function onTryAutoRefresh() {
	            return dispatch(_actions2.default.authCheckState());
	        },
	        updateConfigsActiveCart: function updateConfigsActiveCart() {
	            return dispatch(_actions2.default.updateConfigsActiveCart());
	        }
	    };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Main);

/***/ },
/* 688 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _reactIntl = __webpack_require__(11);
	
	var _dateFns = __webpack_require__(278);
	
	var _locale = __webpack_require__(445);
	
	var _shipment = __webpack_require__(242);
	
	var _shipment2 = _interopRequireDefault(_shipment);
	
	var _listItem = __webpack_require__(2141);
	
	var _listItem2 = _interopRequireDefault(_listItem);
	
	var _orderState = __webpack_require__(690);
	
	var _orderState2 = _interopRequireDefault(_orderState);
	
	var _summary = __webpack_require__(353);
	
	var _summary2 = _interopRequireDefault(_summary);
	
	var _billShipAddress = __webpack_require__(718);
	
	var _billShipAddress2 = _interopRequireDefault(_billShipAddress);
	
	var _shipmentsUtils = __webpack_require__(180);
	
	var _shipmentsUtils2 = _interopRequireDefault(_shipmentsUtils);
	
	var _appTranslations = __webpack_require__(33);
	
	var _appTranslations2 = _interopRequireDefault(_appTranslations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ListItem = function (_Component) {
	    _inherits(ListItem, _Component);
	
	    function ListItem(props, context) {
	        _classCallCheck(this, ListItem);
	
	        var _this = _possibleConstructorReturn(this, (ListItem.__proto__ || Object.getPrototypeOf(ListItem)).call(this, props, context));
	
	        _this.state = {
	            expanded: false
	        };
	        return _this;
	    }
	
	    _createClass(ListItem, [{
	        key: '_panelHeaderMarkup',
	        value: function _panelHeaderMarkup() {
	            var _this2 = this;
	
	            var thisOrder = this.props.order;
	            var lang = this.props.locale.currentLocale === 'es' ? _locale.es : _locale.en;
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'col-lg-12' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row hidden-xs hidden-sm hidden-md' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-lg-2 col-xs-12' },
	                        _react2.default.createElement(
	                            'b',
	                            null,
	                            thisOrder.number
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-lg-2 col-xs-12 text-center' },
	                        (0, _dateFns.format)(new Date(thisOrder.attributes.created_at), 'd MMM', { locale: lang })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-lg-2 col-xs-12 text-center' },
	                        _react2.default.createElement(_orderState2.default, { state: thisOrder.state })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-lg-2 col-xs-12 text-center' },
	                        thisOrder.ship_address.attributes.state_name + ', ' + thisOrder.ship_address.attributes.country_name
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-lg-2 col-xs-12 text-center ' + _listItem2.default.total },
	                        thisOrder.display_total
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-lg-2 col-xs-12 text-center', onClick: function onClick() {
	                                return _this2.setState(function (prevState) {
	                                    return { expanded: !prevState.expanded };
	                                });
	                            } },
	                        this.state.expanded ? _react2.default.createElement('i', { className: 'pe-7s-angle-up pe-1x pe-va font-weight-bold', style: { fontWeight: 'bold', fontSize: 20 } }) : _react2.default.createElement('i', { className: 'pe-7s-angle-down pe-1x pe-va font-weight-bold', style: { fontWeight: 'bold', fontSize: 20 } })
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row hidden-lg' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-lg-2 col-xs-12' },
	                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'order-number', defaultMessage: '#Order' }),
	                        ': ',
	                        _react2.default.createElement(
	                            'b',
	                            null,
	                            thisOrder.number
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-lg-2 col-xs-12' },
	                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'order-date', defaultMessage: 'Order Date' }),
	                        ': ',
	                        (0, _dateFns.format)(new Date(thisOrder.attributes.completed_at), 'd MMM', { locale: lang })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-lg-2 col-xs-12' },
	                        _react2.default.createElement(_orderState2.default, { state: thisOrder.state })
	                    ),
	                    this.state.expanded ? _react2.default.createElement('i', {
	                        className: 'pe-7s-angle-up pe-1x pe-va font-weight-bold',
	                        style: {
	                            fontWeight: 'bold', fontSize: 20, position: 'absolute', top: 0, right: 10
	                        },
	                        onClick: function onClick() {
	                            return _this2.setState(function (prevState) {
	                                return { expanded: !prevState.expanded };
	                            });
	                        }
	                    }) : _react2.default.createElement('i', {
	                        className: 'pe-7s-angle-down pe-1x pe-va font-weight-bold',
	                        style: {
	                            fontWeight: 'bold', fontSize: 20, position: 'absolute', top: 0, right: 10
	                        },
	                        onClick: function onClick() {
	                            return _this2.setState(function (prevState) {
	                                return { expanded: !prevState.expanded };
	                            });
	                        }
	                    })
	                )
	            );
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            var _props = this.props;
	            var thisOrder = _props.order;
	            var stores = _props.stores;
	
	            var shipments = thisOrder.shipments.sort(_shipmentsUtils2.default.compareShipments);
	
	            var storeIdsCount = _shipmentsUtils2.default.countAmountOfStores(thisOrder.shipments);
	            var lastStore = void 0;
	            var cont = 0;
	
	            var shipmentsMarkup = shipments.map(function (shipment, idx) {
	                var store = stores && stores.find(function (store) {
	                    return store.id === shipment.attributes.store_ids[0];
	                });
	                if (store !== lastStore) {
	                    lastStore = store;
	                    cont = 0;
	                } else {
	                    cont += 1;
	                }
	
	                return _react2.default.createElement(_shipment2.default, {
	                    key: idx,
	                    store: stores.find(function (store) {
	                        return store.id === shipment.attributes.store_ids[0];
	                    }),
	                    shipment: shipment,
	                    address: thisOrder.ship_address,
	                    order: _this3.props.order,
	                    className: 'my-orders-shipment',
	                    style: _shipmentsUtils2.default.shipmentStylePadding(shipments, idx),
	                    hideStoreName: _shipmentsUtils2.default.prevIsSameStore(shipments, idx),
	                    details: _appTranslations2.default[_this3.props.locale.currentLocale]['shipment.word'] + ' ' + (cont + 1) + (' ' + _appTranslations2.default[_this3.props.locale.currentLocale]['of.word'] + ' ' + storeIdsCount[shipment.attributes.store_ids[0]])
	                });
	            });
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'row line-item-row' },
	                this._panelHeaderMarkup(),
	                this.state.expanded && shipmentsMarkup,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'address-summary' },
	                    this.state.expanded && _react2.default.createElement(_billShipAddress2.default, { billAddress: this.props.order.bill_address, shipAddress: this.props.order.ship_address, className: 'address' }),
	                    this.state.expanded && _react2.default.createElement(_summary2.default, { key: this.props.order.id, order: this.props.order, stores: this.props.stores, isCheckoutSummary: false, className: 'list-item-summary' })
	                )
	            );
	        }
	    }]);
	
	    return ListItem;
	}(_react.Component);
	
	exports.default = ListItem;
	
	
	ListItem.defaultProps = {
	    order: {
	        shipments: []
	    },
	    stores: []
	};
	
	ListItem.propTypes = {
	    order: (0, _propTypes.shape)({
	        shipments: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
	            attributes: (0, _propTypes.shape)({
	                store_ids: (0, _propTypes.arrayOf)(_propTypes.number)
	            })
	        }))
	    }),
	    stores: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
	        id: _propTypes.number
	    }))
	};

/***/ },
/* 689 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(11);
	
	var _layout = __webpack_require__(29);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _panelView = __webpack_require__(352);
	
	var _panelView2 = _interopRequireDefault(_panelView);
	
	var _loader = __webpack_require__(65);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _infiniteScroller = __webpack_require__(359);
	
	var _infiniteScroller2 = _interopRequireDefault(_infiniteScroller);
	
	var _listItem = __webpack_require__(688);
	
	var _listItem2 = _interopRequireDefault(_listItem);
	
	var _list = __webpack_require__(2142);
	
	var _list2 = _interopRequireDefault(_list);
	
	var _userUtils = __webpack_require__(181);
	
	var _userUtils2 = _interopRequireDefault(_userUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var OrderList = function (_Component) {
	    _inherits(OrderList, _Component);
	
	    function OrderList(props) {
	        _classCallCheck(this, OrderList);
	
	        var _this = _possibleConstructorReturn(this, (OrderList.__proto__ || Object.getPrototypeOf(OrderList)).call(this, props));
	
	        _this.state = {
	            displayLoader: true,
	            currentPage: 1
	        };
	
	        document.title = _this.props.intl.formatMessage({ id: 'yourOrders', defaultMessage: 'Your Orders' });
	        _this.loadMore = _this.loadMore.bind(_this);
	        return _this;
	    }
	
	    _createClass(OrderList, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            if (_userUtils2.default.isLoggedIn()) {
	                this.props.loadOrders(this.props.access_token, this.state.currentPage, this.props.locale).then(function (response) {
	                    _this2.setState({ displayLoader: false });
	                }).catch(function (error) {
	                    console.log(error);
	                });
	            } else {
	                this.props.handleUserNotLoggedIn();
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps) {
	            if (this.props.locale !== prevProps.locale) {
	                document.title = this.props.intl.formatMessage({ id: 'yourOrders', defaultMessage: 'Your Orders' });
	                this.props.loadOrders(this.props.access_token, this.state.currentPage, this.props.locale);
	            }
	        }
	    }, {
	        key: 'loadMore',
	        value: function loadMore() {
	            this.setState(function (prevState) {
	                return { currentPage: prevState.currentPage + 1 };
	            });
	
	            return this.props.loadOrders(this.props.access_token, this.state.currentPage, this.props.locale);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            var orderListMarkup = this.props.orders.map(function (order, idx) {
	                return _react2.default.createElement(
	                    'div',
	                    { key: idx, className: _list2.default.listItem },
	                    _react2.default.createElement(_listItem2.default, { order: _extends({}, order, order.attributes), stores: _this3.props.stores, locale: _this3.props.locale })
	                );
	            });
	
	            return _react2.default.createElement(
	                _layout2.default,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'order-list-page order-section' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'container' },
	                        _react2.default.createElement(
	                            'div',
	                            {
	                                className: 'section-heading text-center ' + _list2.default.header
	                            },
	                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'myOrders', defaultMessage: 'My Orders' })
	                        ),
	                        _react2.default.createElement(_loader2.default, { displayLoader: this.state.displayLoader }),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'row hidden-xs hidden-sm hidden-md ' + _list2.default.tableHeader },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-lg-2 text-center font-weight-bold' },
	                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'order-number', defaultMessage: '#Order' })
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-lg-2 text-center font-weight-bold' },
	                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'order-date', defaultMessage: 'Order Date' })
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-lg-2 text-center font-weight-bold' },
	                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'order-state', defaultMessage: 'Order State' })
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-lg-2 text-center font-weight-bold' },
	                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'destiny', defaultMessage: 'Destiny' })
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-lg-2 text-center' },
	                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'order-total', defaultMessage: 'Total Payment' })
	                            ),
	                            _react2.default.createElement('div', { className: 'col-lg-2 text-center' })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'product-infinite-scroll' },
	                            _react2.default.createElement(
	                                _infiniteScroller2.default,
	                                { loadMore: this.loadMore, pageCount: this.props.pageCount, currentPage: this.state.currentPage },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'confirmation-details-block' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'checkout-block-content ' + _list2.default.orderList },
	                                        orderListMarkup
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return OrderList;
	}(_react.Component);
	
	exports.default = (0, _reactIntl.injectIntl)(OrderList);

/***/ },
/* 690 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(38);
	
	var _reactIntl = __webpack_require__(11);
	
	var _checkoutStepCalculator = __webpack_require__(54);
	
	var _checkoutStepCalculator2 = _interopRequireDefault(_checkoutStepCalculator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var OrderState = function (_Component) {
	    _inherits(OrderState, _Component);
	
	    function OrderState() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, OrderState);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = OrderState.__proto__ || Object.getPrototypeOf(OrderState)).call.apply(_ref, [this].concat(args))), _this), _this.getOrderStateConfig = function (orderState) {
	            var config = {
	                complete: {
	                    color: 'rgb(255, 109,2)',
	                    text: _this.props.intl.formatMessage({ id: 'order-complete', defaultMessage: 'Complete' })
	                },
	                cart: {
	                    color: 'rgb(255, 109,2)',
	                    text: _this.props.intl.formatMessage({ id: 'order-cart', defaultMessage: 'Cart' })
	                },
	                address: {
	                    color: 'rgb(255, 109,2)',
	                    text: _this.props.intl.formatMessage({ id: 'order-address', defaultMessage: 'Address' })
	                },
	                payment: {
	                    color: '#000',
	                    text: _this.props.intl.formatMessage({ id: 'order-payment', defaultMessage: 'Payment' })
	                },
	                resume: {
	                    color: '#000',
	                    text: _this.props.intl.formatMessage({ id: 'order-resume', defaultMessage: 'Resume' })
	                },
	                canceled: {
	                    color: '#000',
	                    text: _this.props.intl.formatMessage({ id: 'order-canceled', defaultMessage: 'Canceled' })
	                },
	                awaiting_return: {
	                    color: '#000',
	                    text: _this.props.intl.formatMessage({ id: 'order-awaiting-return', defaultMessage: 'Awaiting Return' })
	                },
	                returned: {
	                    color: '#000',
	                    text: _this.props.intl.formatMessage({ id: 'order-returned', defaultMessage: 'Returned' })
	                }
	            };
	
	            return config[orderState];
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(OrderState, [{
	        key: 'render',
	        value: function render() {
	            var state = this.props.state;
	
	            var orderStateConfig = this.getOrderStateConfig(state);
	            if (orderStateConfig) {
	                return _react2.default.createElement(
	                    'span',
	                    { style: { color: orderStateConfig.color } },
	                    orderStateConfig.text
	                );
	            }
	            return null;
	        }
	    }]);
	
	    return OrderState;
	}(_react.Component);
	
	exports.default = (0, _reactIntl.injectIntl)(OrderState);

/***/ },
/* 691 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var OrderShow = function (_Component) {
	    _inherits(OrderShow, _Component);
	
	    function OrderShow(props) {
	        _classCallCheck(this, OrderShow);
	
	        var _this = _possibleConstructorReturn(this, (OrderShow.__proto__ || Object.getPrototypeOf(OrderShow)).call(this, props));
	
	        document.title = _this.props.intl.formatMessage({ id: 'orderNumber', defaultMessage: 'Ref' });
	        return _this;
	    }
	
	    _createClass(OrderShow, [{
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps) {
	            if (this.props.locale !== prevProps.locale) {
	                document.title = this.props.intl.formatMessage({ id: 'orderNumber', defaultMessage: 'Ref' });
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement('div', { className: 'product-img col-md-12' });
	        }
	    }]);
	
	    return OrderShow;
	}(_react.Component);
	
	exports.default = (0, _reactIntl.injectIntl)(OrderShow);

/***/ },
/* 692 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(41);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /* eslint-disable no-confusing-arrow */
	/* eslint-disable react/self-closing-comp */
	/* eslint-disable max-len */
	/* eslint-disable object-curly-newline */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(11);
	
	var _reactFinalForm = __webpack_require__(522);
	
	var _reactReduxToastr = __webpack_require__(42);
	
	var _reactRouterRedux = __webpack_require__(30);
	
	var _layout = __webpack_require__(29);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _formField = __webpack_require__(103);
	
	var _formField2 = _interopRequireDefault(_formField);
	
	var _countryField = __webpack_require__(349);
	
	var _countryField2 = _interopRequireDefault(_countryField);
	
	var _stateField = __webpack_require__(350);
	
	var _stateField2 = _interopRequireDefault(_stateField);
	
	var _country = __webpack_require__(238);
	
	var _country2 = _interopRequireDefault(_country);
	
	var _validators = __webpack_require__(104);
	
	var _validators2 = _interopRequireDefault(_validators);
	
	var _helper = __webpack_require__(60);
	
	var _creditCard = __webpack_require__(250);
	
	var _creditCard2 = _interopRequireDefault(_creditCard);
	
	var _userUtils = __webpack_require__(181);
	
	var _userUtils2 = _interopRequireDefault(_userUtils);
	
	var _store = __webpack_require__(40);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _appRoutes = __webpack_require__(22);
	
	var _appRoutes2 = _interopRequireDefault(_appRoutes);
	
	var _loading = __webpack_require__(118);
	
	var _loading2 = _interopRequireDefault(_loading);
	
	var _wallets = __webpack_require__(240);
	
	var _wallets2 = _interopRequireDefault(_wallets);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var AddFundsKWallet = function AddFundsKWallet(props) {
	    var intl = props.intl;
	
	    var _useState = (0, _react.useState)('generic');
	
	    var _useState2 = _slicedToArray(_useState, 2);
	
	    var ccType = _useState2[0];
	    var setCcType = _useState2[1];
	
	    var _useState3 = (0, _react.useState)([]);
	
	    var _useState4 = _slicedToArray(_useState3, 2);
	
	    var countries = _useState4[0];
	    var setCountries = _useState4[1];
	
	    var _useState5 = (0, _react.useState)([]);
	
	    var _useState6 = _slicedToArray(_useState5, 2);
	
	    var states = _useState6[0];
	    var setStates = _useState6[1];
	
	    var _useState7 = (0, _react.useState)('');
	
	    var _useState8 = _slicedToArray(_useState7, 2);
	
	    var selectedCountry = _useState8[0];
	    var setSelectedCountry = _useState8[1];
	
	
	    var showGenericToastError = function showGenericToastError() {
	        _reactReduxToastr.toastr.error(intl.formatMessage({ id: 'generic-error-title', defaultMessage: 'Something went wrong' }), intl.formatMessage({ id: 'generic-error-message', defaultMessage: 'Please try again' }));
	    };
	
	    var composeValidators = function composeValidators() {
	        for (var _len = arguments.length, validators = Array(_len), _key = 0; _key < _len; _key++) {
	            validators[_key] = arguments[_key];
	        }
	
	        return function (value) {
	            return validators.reduce(function (error, validator) {
	                return error || validator(value);
	            }, undefined);
	        };
	    };
	    var amountValidator = function amountValidator() {
	        return function (value) {
	            return !Number.isNaN(value) && value >= 0 ? undefined : _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'add-funds-k-wallet-invalid-amount-error', defaultMessage: 'Only positive numbers are allowed. Use (.) to specify cents' });
	        };
	    };
	    var requiredValidaror = function requiredValidaror(value) {
	        return value ? undefined : _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'required-message', defaultMessage: 'Required' });
	    };
	    var zipcodeAdapterValidator = function zipcodeAdapterValidator(value) {
	        return _validators2.default.zipCode(value) === undefined ? undefined : _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'invalid-zip-code', defaultMessage: 'Invalid ZIP Code' });
	    };
	    var phoneAdapterValidator = function phoneAdapterValidator(value) {
	        return _validators2.default.phone(value) === undefined ? undefined : _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'invalid-phone-number', defaultMessage: 'Invalid phone number' });
	    };
	    var cardNumberLengthAdapterValidator = function cardNumberLengthAdapterValidator(value) {
	        return _validators2.default.cardNumberLength(value) === undefined ? undefined : _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'add-funds-k-wallet-invalid-card-number-error', defaultMessage: 'Invalid card number' });
	    };
	
	    var checkCCType = function checkCCType(num) {
	        var currentCCType = _creditCard2.default.ccType(num);
	        if (currentCCType !== ccType) {
	            setCcType(currentCCType);
	        }
	    };
	
	    (0, _react.useEffect)(function () {
	        if (!_userUtils2.default.isLoggedIn()) {
	            _store2.default.dispatch((0, _reactRouterRedux.push)(_appRoutes2.default.homePageRoute));
	        }
	    });
	
	    (0, _react.useEffect)(function () {
	        var getCountries = function () {
	            var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	                var response;
	                return _regenerator2.default.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                _context.prev = 0;
	                                _context.next = 3;
	                                return _country2.default.getCountryList({ availableName: 'available_for_billing_true' });
	
	                            case 3:
	                                response = _context.sent;
	
	                                if (countries && countries.length !== response.body.countries.length) {
	                                    setCountries(response.body.countries);
	                                }
	                                _context.next = 11;
	                                break;
	
	                            case 7:
	                                _context.prev = 7;
	                                _context.t0 = _context['catch'](0);
	
	                                console.error(_context.t0);
	                                showGenericToastError();
	
	                            case 11:
	                            case 'end':
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this, [[0, 7]]);
	            }));
	
	            return function getCountries() {
	                return _ref.apply(this, arguments);
	            };
	        }();
	
	        if (countries.length === 0) {
	            getCountries();
	        }
	    });
	
	    (0, _react.useEffect)(function () {
	        var getStates = function () {
	            var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	                var country, response;
	                return _regenerator2.default.wrap(function _callee2$(_context2) {
	                    while (1) {
	                        switch (_context2.prev = _context2.next) {
	                            case 0:
	                                _context2.prev = 0;
	                                country = countries.find(function (curr) {
	                                    return curr.iso === selectedCountry;
	                                });
	
	                                if (!country) {
	                                    _context2.next = 7;
	                                    break;
	                                }
	
	                                _context2.next = 5;
	                                return _country2.default.getStatesByCountry({ availableName: 'available_for_billing_true', countryId: country.id });
	
	                            case 5:
	                                response = _context2.sent;
	
	                                setStates(response.body.states.length > 0 ? response.body.states : []);
	
	                            case 7:
	                                _context2.next = 13;
	                                break;
	
	                            case 9:
	                                _context2.prev = 9;
	                                _context2.t0 = _context2['catch'](0);
	
	                                console.error(_context2.t0);
	                                showGenericToastError();
	
	                            case 13:
	                            case 'end':
	                                return _context2.stop();
	                        }
	                    }
	                }, _callee2, this, [[0, 9]]);
	            }));
	
	            return function getStates() {
	                return _ref2.apply(this, arguments);
	            };
	        }();
	
	        getStates();
	        // eslint-disable-next-line react-hooks/exhaustive-deps
	    }, [countries, selectedCountry]);
	
	    var getMakeADepositPayload = function getMakeADepositPayload(values) {
	        var cardNumber = values.cardNumber.trim().replaceAll(' ', '');
	        var expirationDate = (0, _helper.formatExpirationDate)(values.expirationDate);
	
	        var _expirationDate$split = expirationDate.split('/');
	
	        var _expirationDate$split2 = _slicedToArray(_expirationDate$split, 2);
	
	        var expirationDateMonth = _expirationDate$split2[0];
	        var expirationDateYear = _expirationDate$split2[1];
	
	        return {
	            amount: values.amount,
	            notes: '',
	            card: {
	                number: cardNumber,
	                name_in_card: values.nameOnCard,
	                expiration_date_month: parseInt(expirationDateMonth, 10),
	                expiration_date_year: parseInt(expirationDateYear.slice(0, 2), 10),
	                ccv: values.cvv,
	                address: values.address2 ? values.address1 + ' ' + values.address2 : values.address1,
	                city: values.city,
	                state: values.stateName,
	                zip_code: values.zipcode,
	                country: values.countryIso
	            }
	        };
	    };
	
	    var onSubmit = function () {
	        var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(values) {
	            var binLookupInfo, _spreeStore$getState, accessToken, payload;
	
	            return _regenerator2.default.wrap(function _callee3$(_context3) {
	                while (1) {
	                    switch (_context3.prev = _context3.next) {
	                        case 0:
	                            _context3.prev = 0;
	                            _context3.next = 3;
	                            return _creditCard2.default.getBinLookupInfo(values.cardNumber);
	
	                        case 3:
	                            binLookupInfo = _context3.sent;
	
	                            if (!(binLookupInfo && binLookupInfo.type === 'debit')) {
	                                _context3.next = 14;
	                                break;
	                            }
	
	                            _spreeStore$getState = _store2.default.getState();
	                            accessToken = _spreeStore$getState.auth.access_token;
	                            payload = getMakeADepositPayload(values);
	                            _context3.next = 10;
	                            return _wallets2.default.makeADeposit({
	                                wallet: 'kwallet',
	                                token: accessToken,
	                                params: payload
	                            });
	
	                        case 10:
	                            _reactReduxToastr.toastr.success(intl.formatMessage({ id: 'well', defaultMessage: 'Well done' }), intl.formatMessage({ id: 'add-funds-k-wallet-submitted-successfully', defaultMessage: 'add-funds-k-wallet-submitted-successfully' }));
	                            _store2.default.dispatch((0, _reactRouterRedux.push)(_appRoutes2.default.manageKWallet));
	                            _context3.next = 15;
	                            break;
	
	                        case 14:
	                            _reactReduxToastr.toastr.error(intl.formatMessage({ id: 'add-funds-k-wallet-invalid-debit-card-error-title', defaultMessage: 'Invalid debit card' }), intl.formatMessage({ id: 'add-funds-k-wallet-invalid-debit-card-error-message', defaultMessage: 'Please provide a valid debit card' }));
	
	                        case 15:
	                            _context3.next = 21;
	                            break;
	
	                        case 17:
	                            _context3.prev = 17;
	                            _context3.t0 = _context3['catch'](0);
	
	                            console.error(_context3.t0);
	                            if (_context3.t0.message) {
	                                _reactReduxToastr.toastr.error(intl.formatMessage({ id: 'generic-error-title', defaultMessage: 'Something went wrong' }), _context3.t0.message);
	                            } else {
	                                showGenericToastError();
	                            }
	
	                        case 21:
	                        case 'end':
	                            return _context3.stop();
	                    }
	                }
	            }, _callee3, undefined, [[0, 17]]);
	        }));
	
	        return function onSubmit(_x) {
	            return _ref3.apply(this, arguments);
	        };
	    }();
	
	    var cancelAddFunds = function cancelAddFunds() {
	        return _store2.default.dispatch((0, _reactRouterRedux.push)(_appRoutes2.default.manageKWallet));
	    };
	
	    return _react2.default.createElement(
	        _layout2.default,
	        null,
	        _react2.default.createElement(
	            'div',
	            { className: 'body-container manager-k-wallet' },
	            _react2.default.createElement(
	                'div',
	                { className: 'container' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'formWrapper' },
	                    _react2.default.createElement(_reactFinalForm.Form, {
	                        onSubmit: onSubmit,
	                        render: function render(_ref4) {
	                            var handleSubmit = _ref4.handleSubmit;
	                            var form = _ref4.form;
	                            var submitting = _ref4.submitting;
	                            var pristine = _ref4.pristine;
	                            var values = _ref4.values;
	                            var errors = _ref4.errors;
	                            return _react2.default.createElement(
	                                'form',
	                                { onSubmit: handleSubmit },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'add-funds-k-wallet' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'add-funds-k-wallet__title' },
	                                        _react2.default.createElement(
	                                            'svg',
	                                            { xmlns: 'http://www.w3.org/2000/svg', width: '40', height: '40', fill: '#d3af71', className: 'bi bi-wallet-fill', viewBox: '0 0 16 16' },
	                                            _react2.default.createElement('path', { d: 'M1.5 2A1.5 1.5 0 0 0 0 3.5v2h6a.5.5 0 0 1 .5.5c0 .253.08.644.306.958.207.288.557.542 1.194.542.637 0 .987-.254 1.194-.542.226-.314.306-.705.306-.958a.5.5 0 0 1 .5-.5h6v-2A1.5 1.5 0 0 0 14.5 2h-13z' }),
	                                            _react2.default.createElement('path', { d: 'M16 6.5h-5.551a2.678 2.678 0 0 1-.443 1.042C9.613 8.088 8.963 8.5 8 8.5c-.963 0-1.613-.412-2.006-.958A2.679 2.679 0 0 1 5.551 6.5H0v6A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5v-6z' })
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'checkout-section-title__text-container' },
	                                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'add-funds-k-wallet-title', defaultMessage: 'add-funds-k-wallet-title' })
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'add-funds-k-wallet__body' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'add-funds-k-wallet__body__left-side' },
	                                            _react2.default.createElement(
	                                                'div',
	                                                null,
	                                                _react2.default.createElement(_reactFinalForm.Field, {
	                                                    className: 'form-control',
	                                                    name: 'amount',
	                                                    component: _formField2.default.inputFieldMarkup,
	                                                    label: intl.formatMessage({ id: 'add-funds-k-wallet-amount', defaultMessage: 'Cantidad a agregar' }),
	                                                    placeholder: intl.formatMessage({ id: 'add-funds-k-wallet-amount', defaultMessage: 'Cantidad a agregar' }),
	                                                    type: 'tel',
	                                                    validate: composeValidators(requiredValidaror, amountValidator()),
	                                                    format: _helper.formatMoney
	                                                })
	                                            ),
	                                            _react2.default.createElement(
	                                                'div',
	                                                null,
	                                                _react2.default.createElement(_reactFinalForm.Field, {
	                                                    name: 'nameOnCard',
	                                                    component: _formField2.default.inputFieldMarkup,
	                                                    type: 'text',
	                                                    placeholder: intl.formatMessage({ id: 'nameOnCard', defaultMessage: 'Name on card' }),
	                                                    label: intl.formatMessage({ id: 'nameOnCard', defaultMessage: 'Name on card' }),
	                                                    validate: requiredValidaror
	                                                })
	                                            ),
	                                            _react2.default.createElement(
	                                                'div',
	                                                null,
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'cc-number-wrapper' },
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 'cc-number-wrapper__input' },
	                                                        _react2.default.createElement(_reactFinalForm.Field, {
	                                                            className: 'form-control',
	                                                            name: 'cardNumber',
	                                                            component: _formField2.default.inputFieldMarkup,
	                                                            placeholder: intl.formatMessage({ id: 'cardNumber', defaultMessage: 'Card Number' }),
	                                                            label: intl.formatMessage({ id: 'cardNumber', defaultMessage: 'Card Number' }),
	                                                            type: 'tel',
	                                                            format: _helper.formatCreditCardNumber,
	                                                            validate: composeValidators(requiredValidaror, cardNumberLengthAdapterValidator)
	                                                        })
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 'cc-number-wrapper__card-logo' },
	                                                        _react2.default.createElement('img', { src: '/pay-types/' + ccType + '-logo.png', alt: 'CC logo' })
	                                                    )
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'add-funds-k-wallet__body__form-twin-fields' },
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'add-funds-k-wallet__body__form-twin-fields__field' },
	                                                    _react2.default.createElement(_reactFinalForm.Field, {
	                                                        className: 'form-control',
	                                                        name: 'expirationDate',
	                                                        component: _formField2.default.inputFieldMarkup,
	                                                        label: intl.formatMessage({ id: 'cardExpiration', defaultMessage: 'Card Expiration' }),
	                                                        placeholder: intl.formatMessage({ id: 'card-expiry-placeholder', defaultMessage: 'Expiration' }),
	                                                        type: 'tel',
	                                                        format: _helper.formatExpirationDate,
	                                                        validate: requiredValidaror
	                                                    })
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'add-funds-k-wallet__body__form-twin-fields__field' },
	                                                    _react2.default.createElement(_reactFinalForm.Field, {
	                                                        className: 'form-control',
	                                                        name: 'cvv',
	                                                        component: _formField2.default.inputFieldMarkup,
	                                                        label: 'CVV*',
	                                                        placeholder: intl.formatMessage({ id: 'security-digits', defaultMessage: 'Security digits' }),
	                                                        type: 'tel',
	                                                        format: _helper.formatCVC,
	                                                        validate: requiredValidaror
	                                                    })
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'add-funds-k-wallet__body__right-side' },
	                                            _react2.default.createElement(
	                                                'div',
	                                                null,
	                                                _react2.default.createElement(_reactFinalForm.Field, {
	                                                    className: 'form-control',
	                                                    name: 'address1',
	                                                    component: _formField2.default.inputFieldMarkup,
	                                                    label: intl.formatMessage({ id: 'address1', defaultMessage: 'Address Line 1' }),
	                                                    type: 'text',
	                                                    validate: requiredValidaror
	                                                })
	                                            ),
	                                            _react2.default.createElement(
	                                                'div',
	                                                null,
	                                                _react2.default.createElement(_reactFinalForm.Field, {
	                                                    className: 'form-control',
	                                                    name: 'address2',
	                                                    component: _formField2.default.inputFieldMarkup,
	                                                    label: intl.formatMessage({ id: 'address2', defaultMessage: 'Address Line 2' }),
	                                                    type: 'text'
	                                                })
	                                            ),
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'add-funds-k-wallet__body__form-3-in-row-fields' },
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'add-funds-k-wallet__body__form-3-in-row-fields__field' },
	                                                    _react2.default.createElement(_reactFinalForm.Field, {
	                                                        className: 'form-control',
	                                                        name: 'city',
	                                                        component: _formField2.default.inputFieldMarkup,
	                                                        label: intl.formatMessage({ id: 'city', defaultMessage: 'City' }),
	                                                        type: 'text',
	                                                        validate: requiredValidaror
	                                                    })
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'add-funds-k-wallet__body__form-3-in-row-fields__field' },
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 'checkout-form-row' },
	                                                        _react2.default.createElement(
	                                                            'label',
	                                                            { htmlFor: 'country', className: 'checkout-form-label' },
	                                                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'country', defaultMessage: 'Country' })
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { className: 'checkout-form-fields' },
	                                                            _react2.default.createElement(_reactFinalForm.Field, {
	                                                                name: 'countryIso',
	                                                                selectedCountryIso: selectedCountry,
	                                                                countries: countries,
	                                                                component: _countryField2.default,
	                                                                validate: requiredValidaror,
	                                                                handleCountryChange: function handleCountryChange(country) {
	                                                                    return setSelectedCountry(country);
	                                                                }
	                                                            })
	                                                        )
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'add-funds-k-wallet__body__form-3-in-row-fields__field' },
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 'checkout-form-row' },
	                                                        _react2.default.createElement(
	                                                            'label',
	                                                            { htmlFor: 'state', className: 'checkout-form-label' },
	                                                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'state', defaultMessage: 'State' })
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { className: 'checkout-form-fields' },
	                                                            _react2.default.createElement(_reactFinalForm.Field, {
	                                                                name: 'stateName',
	                                                                states: states,
	                                                                component: _stateField2.default,
	                                                                validate: requiredValidaror,
	                                                                handleStateChange: function handleStateChange() {}
	                                                            })
	                                                        )
	                                                    )
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'add-funds-k-wallet__body__form-twin-fields' },
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'add-funds-k-wallet__body__form-twin-fields__field' },
	                                                    _react2.default.createElement(_reactFinalForm.Field, {
	                                                        className: 'form-control',
	                                                        name: 'zipcode',
	                                                        component: _formField2.default.inputFieldMarkup,
	                                                        label: intl.formatMessage({ id: 'zipCode', defaultMessage: 'Zipcode' }),
	                                                        type: 'text',
	                                                        validate: composeValidators(requiredValidaror, zipcodeAdapterValidator)
	                                                    })
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'add-funds-k-wallet__body__form-twin-fields__field' },
	                                                    _react2.default.createElement(_reactFinalForm.Field, {
	                                                        className: 'form-control',
	                                                        name: 'phone',
	                                                        component: _formField2.default.inputFieldMarkup,
	                                                        label: intl.formatMessage({ id: 'phone', defaultMessage: 'Phone' }),
	                                                        type: 'text',
	                                                        validate: composeValidators(requiredValidaror, phoneAdapterValidator)
	                                                    })
	                                                )
	                                            )
	                                        ),
	                                        submitting && _react2.default.createElement(
	                                            'div',
	                                            { className: 'generic-processing' },
	                                            _react2.default.createElement('div', { className: _loading2.default.spinnerDark })
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'add-funds-k-wallet__actions' },
	                                        _react2.default.createElement(
	                                            'button',
	                                            { style: { marginRight: '15px' }, className: 'button--outlined', type: 'submit', disabled: submitting || pristine || Object.keys(errors).length > 0 },
	                                            _react2.default.createElement(
	                                                'span',
	                                                { className: 'checkout-button-text__desktop' },
	                                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'savePaymentMethod', defaultMessage: 'Save Payment Details' })
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'button',
	                                            { className: 'button--outlined', type: 'button', disabled: submitting, onClick: function onClick() {
	                                                    return cancelAddFunds();
	                                                } },
	                                            _react2.default.createElement(
	                                                'span',
	                                                { className: 'checkout-button-text__desktop' },
	                                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'modal-change-municipality-button-cancel', defaultMessage: 'Cancelar' })
	                                            )
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(_reactFinalForm.FormSpy, {
	                                    subscription: { values: true },
	                                    onChange: function onChange(props) {
	                                        checkCCType(props.values.cardNumber);
	                                    }
	                                })
	                            );
	                        }
	                    })
	                )
	            )
	        )
	    );
	};
	
	exports.default = (0, _reactIntl.injectIntl)(AddFundsKWallet);

/***/ },
/* 693 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(11);
	
	var _layout = __webpack_require__(29);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _affidavitCertification = __webpack_require__(2163);
	
	var _affidavitCertification2 = _interopRequireDefault(_affidavitCertification);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AffidavitCertification = function (_Component) {
	    _inherits(AffidavitCertification, _Component);
	
	    function AffidavitCertification(props) {
	        _classCallCheck(this, AffidavitCertification);
	
	        var _this = _possibleConstructorReturn(this, (AffidavitCertification.__proto__ || Object.getPrototypeOf(AffidavitCertification)).call(this, props));
	
	        document.title = 'Affidavit Certification';
	        return _this;
	    }
	
	    _createClass(AffidavitCertification, [{
	        key: 'render',
	        value: function render() {
	            var Paragraph = function Paragraph(props) {
	                return _react2.default.createElement(
	                    'div',
	                    { className: 'text-justify', style: _extends({ paddingBottom: 10 }, props.style) },
	                    props.children
	                );
	            };
	
	            var ParagraphWithMargin = function ParagraphWithMargin(props) {
	                return _react2.default.createElement(
	                    'div',
	                    { className: 'text-justify', style: _extends({ paddingBottom: 10 }, props.style, { marginLeft: 20 }) },
	                    props.children
	                );
	            };
	
	            return _react2.default.createElement(
	                _layout2.default,
	                { notShowMarginBottom: true },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'container' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                            'h4',
	                            { className: _affidavitCertification2.default.mainText },
	                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'modal-kwallet-activate-affidavit', defaultMessage: 'Affidavit Certification' })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: _affidavitCertification2.default.privacyBackround },
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    null,
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'affidavit-certification-1', defaultMessage: 'affidavit-certification-1' }),
	                                    _react2.default.createElement('br', null),
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'affidavit-certification-2', defaultMessage: 'affidavit-certification-2' })
	                                ),
	                                _react2.default.createElement(
	                                    ParagraphWithMargin,
	                                    null,
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'affidavit-certification-2-1', defaultMessage: 'affidavit-certification-3' })
	                                ),
	                                _react2.default.createElement(
	                                    ParagraphWithMargin,
	                                    null,
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'affidavit-certification-2-2', defaultMessage: 'affidavit-certification-4' })
	                                ),
	                                _react2.default.createElement(
	                                    ParagraphWithMargin,
	                                    null,
	                                    _react2.default.createElement(
	                                        ParagraphWithMargin,
	                                        null,
	                                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'affidavit-certification-2-2-1', defaultMessage: 'affidavit-certification-5' })
	                                    ),
	                                    _react2.default.createElement(
	                                        ParagraphWithMargin,
	                                        null,
	                                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'affidavit-certification-2-2-2', defaultMessage: 'affidavit-certification-6' })
	                                    ),
	                                    _react2.default.createElement(
	                                        ParagraphWithMargin,
	                                        null,
	                                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'affidavit-certification-2-2-3', defaultMessage: 'affidavit-certification-7' })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    null,
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'affidavit-certification-3', defaultMessage: 'affidavit-certification-8' })
	                                ),
	                                _react2.default.createElement(
	                                    ParagraphWithMargin,
	                                    null,
	                                    _react2.default.createElement(
	                                        Paragraph,
	                                        null,
	                                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'affidavit-certification-3-1', defaultMessage: 'affidavit-certification-9' })
	                                    ),
	                                    _react2.default.createElement(
	                                        Paragraph,
	                                        null,
	                                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'affidavit-certification-3-2', defaultMessage: 'affidavit-certification-10' })
	                                    ),
	                                    _react2.default.createElement(
	                                        Paragraph,
	                                        null,
	                                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'affidavit-certification-3-3', defaultMessage: 'affidavit-certification-10' })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    null,
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'affidavit-certification-4', defaultMessage: 'affidavit-certification-10' })
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    null,
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'affidavit-certification-5', defaultMessage: 'affidavit-certification-10' })
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return AffidavitCertification;
	}(_react.Component);
	
	exports.default = (0, _reactIntl.injectIntl)(AffidavitCertification);

/***/ },
/* 694 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(11);
	
	var _reactRouterDom = __webpack_require__(26);
	
	var _layout = __webpack_require__(29);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _comingSoon = __webpack_require__(171);
	
	var _comingSoon2 = _interopRequireDefault(_comingSoon);
	
	var _appRoutes = __webpack_require__(22);
	
	var _appRoutes2 = _interopRequireDefault(_appRoutes);
	
	var _signupPromotion = __webpack_require__(75);
	
	var _signupPromotion2 = _interopRequireDefault(_signupPromotion);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ComingSoon = function (_Component) {
	    _inherits(ComingSoon, _Component);
	
	    function ComingSoon(props) {
	        _classCallCheck(this, ComingSoon);
	
	        var _this = _possibleConstructorReturn(this, (ComingSoon.__proto__ || Object.getPrototypeOf(ComingSoon)).call(this, props));
	
	        document.title = _this.props.intl.formatMessage({ id: 'title', defaultMessage: 'Online Store for Cuba' });
	        return _this;
	    }
	
	    _createClass(ComingSoon, [{
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps, prevState) {
	            if (this.props.locale !== prevProps.locale) {
	                document.title = this.props.intl.formatMessage({ id: 'title', defaultMessage: 'Online Store for Cuba' });
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                _layout2.default,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: _comingSoon2.default.comingContainer },
	                    _react2.default.createElement(
	                        'h1',
	                        { className: _comingSoon2.default.mainText },
	                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'coming-soon-text', defaultMessage: 'These products will be available soon' })
	                    ),
	                    _react2.default.createElement(
	                        'h2',
	                        { className: _comingSoon2.default.secondaryText },
	                        _react2.default.createElement(_reactIntl.FormattedMessage, {
	                            id: 'coming-soon-desc',
	                            defaultMessage: 'We are adding new features to our platform. Soon these products will be available. Please, be patient and explore our'
	                        }),
	                        _react2.default.createElement(
	                            _reactRouterDom.Link,
	                            { to: _appRoutes2.default.mercadoUnicoProducts },
	                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'mercado-unico', defaultMessage: 'Mercado Unico' }),
	                            '.'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactRouterDom.Link,
	                        { to: _appRoutes2.default.mercadoUnicoProducts, className: _comingSoon2.default.buttonLink },
	                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'coming-soon-button', defaultMessage: 'See Mercado Unico Products' })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ComingSoon;
	}(_react.Component);
	
	exports.default = (0, _reactIntl.injectIntl)(ComingSoon);

/***/ },
/* 695 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(11);
	
	var _reactRouterRedux = __webpack_require__(30);
	
	var _reduxForm = __webpack_require__(61);
	
	var _reactRouterDom = __webpack_require__(26);
	
	var _validators = __webpack_require__(104);
	
	var _validators2 = _interopRequireDefault(_validators);
	
	var _formField = __webpack_require__(103);
	
	var _formField2 = _interopRequireDefault(_formField);
	
	var _layout = __webpack_require__(29);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _comingSoon = __webpack_require__(171);
	
	var _comingSoon2 = _interopRequireDefault(_comingSoon);
	
	var _appRoutes = __webpack_require__(22);
	
	var _appRoutes2 = _interopRequireDefault(_appRoutes);
	
	var _signin = __webpack_require__(138);
	
	var _signin2 = _interopRequireDefault(_signin);
	
	var _success = __webpack_require__(1626);
	
	var _success2 = _interopRequireDefault(_success);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ForgotPassword = function (_Component) {
	    _inherits(ForgotPassword, _Component);
	
	    function ForgotPassword(props) {
	        _classCallCheck(this, ForgotPassword);
	
	        var _this = _possibleConstructorReturn(this, (ForgotPassword.__proto__ || Object.getPrototypeOf(ForgotPassword)).call(this, props));
	
	        _this.state = {
	            passwordChangeSuccess: false
	        };
	
	        _this.handleFormSubmit = _this.handleFormSubmit.bind(_this);
	
	        document.title = _this.props.intl.formatMessage({ id: 'forgot-password', defaultMessage: 'Forgot Password' });
	        return _this;
	    }
	
	    _createClass(ForgotPassword, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            // Redirect to home if is authenticated
	            if (this.props.user && this.props.user.id) {
	                this.props.dispatch((0, _reactRouterRedux.push)(_appRoutes2.default.homePageRoute));
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps) {
	            if (this.props.locale !== prevProps.locale) {
	                document.title = this.props.intl.formatMessage({ id: 'forgot-password', defaultMessage: 'Forgot Password' });
	            }
	        }
	    }, {
	        key: 'handleFormSubmit',
	        value: function handleFormSubmit(formData) {
	            var _this2 = this;
	
	            var token = this.props.match.params.token;
	
	            this.props.submitForgotPassword(formData, token, this.props.locale.currentLocale).then(function (resp) {
	                if (resp) {
	                    _this2.setState({ passwordChangeSuccess: true });
	                }
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props;
	            var handleSubmit = _props.handleSubmit;
	            var valid = _props.valid;
	            var submitting = _props.submitting;
	            var intl = _props.intl;
	            var passwordChangeSuccess = this.state.passwordChangeSuccess;
	
	            var passwordChangeMessage = _react2.default.createElement(
	                'div',
	                {
	                    className: _comingSoon2.default.comingContainer
	                },
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'text-center', style: { paddingBottom: 45 } },
	                        _react2.default.createElement('img', {
	                            style: { maxWidth: '35%', height: 'auto' },
	                            src: _success2.default,
	                            alt: this.props.intl.formatMessage({
	                                id: 'not-found',
	                                defaultMessage: 'Not'
	                            })
	                        })
	                    )
	                ),
	                _react2.default.createElement(
	                    'h1',
	                    {
	                        className: _comingSoon2.default.mainText
	                    },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                        id: 'password-reset',
	                        defaultMessage: 'Your password has been updated'
	                    })
	                ),
	                _react2.default.createElement(
	                    _reactRouterDom.Link,
	                    {
	                        to: _appRoutes2.default.mercadoUnicoProducts,
	                        className: _comingSoon2.default.buttonLink
	                    },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                        id: 'coming-soon-button',
	                        defaultMessage: 'See Mercado Unico Products'
	                    })
	                ),
	                _react2.default.createElement(
	                    _reactRouterDom.Link,
	                    {
	                        to: _appRoutes2.default.signin,
	                        className: _comingSoon2.default.buttonLink
	                    },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                        id: 'signin',
	                        defaultMessage: 'Sign In'
	                    })
	                )
	            );
	
	            var forgotPasswordForm = _react2.default.createElement(
	                'main',
	                { className: 'content ' + _signin2.default.signin },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'container ' + _signin2.default.bodyContainer },
	                    _react2.default.createElement(
	                        'section',
	                        null,
	                        _react2.default.createElement(
	                            'p',
	                            { className: _signin2.default.titlePage },
	                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'forgot-password', defaultMessage: 'Forgot Password' })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'row' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-lg-offset-4 col-lg-4 col-md-4 col-md-offset-4 col-sm-offset-3 col-sm-6 col-xs-12' },
	                                _react2.default.createElement(
	                                    'form',
	                                    { className: _signin2.default.form, onSubmit: handleSubmit(this.handleFormSubmit) },
	                                    _react2.default.createElement(
	                                        'div',
	                                        null,
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'form-group ' + _signin2.default.formGroup },
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'col-lg-12 col-md-12 col-sm-12 col-xs-12 holder' },
	                                                _react2.default.createElement(_reduxForm.Field, {
	                                                    className: _signin2.default.formInput,
	                                                    name: 'user[password]',
	                                                    component: _formField2.default.inputFieldMarkup,
	                                                    autoComplete: 'off',
	                                                    type: 'password',
	                                                    validate: [_validators2.default.required],
	                                                    placeholder: intl.formatMessage({
	                                                        id: 'password',
	                                                        defaultMessage: 'Password'
	                                                    })
	                                                })
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'form-group ' + _signin2.default.formGroup },
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'col-lg-12 col-md-12 col-sm-12 col-xs-12 holder' },
	                                                _react2.default.createElement(_reduxForm.Field, {
	                                                    className: _signin2.default.formInput,
	                                                    name: 'user[password_confirmation]',
	                                                    component: _formField2.default.inputFieldMarkup,
	                                                    autoComplete: 'off',
	                                                    type: 'password',
	                                                    validate: [_validators2.default.required, _validators2.default.passwordConfirmation],
	                                                    placeholder: intl.formatMessage({
	                                                        id: 'confirmPassword',
	                                                        defaultMessage: 'Confirm Password'
	                                                    })
	                                                })
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'span',
	                                            { hidden: [_validators2.default.passwordConfirmation], className: _signin2.default.fieldError },
	                                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'error-password-not-match', defaultMessage: 'Passwords do not match' })
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'form-group ' + _signin2.default.formGroupHolder },
	                                        _react2.default.createElement(
	                                            'button',
	                                            { className: 'form-control btn btn-default', type: 'submit', disabled: !valid || submitting },
	                                            _react2.default.createElement(
	                                                'span',
	                                                null,
	                                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'send', defaultMessage: 'Send' })
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'form-legend' },
	                                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'legend-required-field', defaultMessage: '* indicates the field is required' })
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	
	            return _react2.default.createElement(
	                _layout2.default,
	                null,
	                passwordChangeSuccess ? passwordChangeMessage : forgotPasswordForm
	            );
	        }
	    }]);
	
	    return ForgotPassword;
	}(_react.Component);
	
	ForgotPassword = (0, _reduxForm.reduxForm)({
	    form: 'forgotPassword'
	})(ForgotPassword);
	
	exports.default = (0, _reactIntl.injectIntl)(ForgotPassword);

/***/ },
/* 696 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(11);
	
	var _reactCollapsible = __webpack_require__(311);
	
	var _reactCollapsible2 = _interopRequireDefault(_reactCollapsible);
	
	var _layout = __webpack_require__(29);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _frequentQuestions = __webpack_require__(2165);
	
	var _frequentQuestions2 = _interopRequireDefault(_frequentQuestions);
	
	var _header = __webpack_require__(101);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _signupPromotion = __webpack_require__(75);
	
	var _signupPromotion2 = _interopRequireDefault(_signupPromotion);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable */
	
	
	var faqs = [{
	    questionDefault: "1. En qué provincias entregan?",
	    answerDefaults: ["R/ Entregamos en La Habana, Artemisa, Mayabeque, Pinar del Río, Matanzas, Ciego de Ávila, Las Tunas, Holguín, Camagüey, Sancti Spíritus, Granma y Santiago de Cuba.", "Estamos trabajando para extender nuestros servicios al resto de las provincias."]
	}, {
	    questionDefault: "2. Cuántos días demora la entrega de las órdenes?",
	    answerDefaults: ["R/ Las entregas en la tienda de CubaLicores demoran aproximadamente 8 días hábiles. No se incluyen fines de semana. Las compras realizadas en la tienda de Pre-Venta pueden tardar de 30-60 días dependiendo de los productos comprados.", "Por favor tenga en cuenta que nuestras fechas son estimadas y no exactas.", "Para conocer sobre los tiempos de envío en otras tiendas de la plataforma por favor visite nuestras Políticas de Envíos y Cargos (https://www.cubalicores.com/shipping-policy)."]
	}, {
	    questionDefault: "3. Cómo puedo comprar?",
	    answerDefaults: ["R/ Toda la compra se hace online en nuestro sitio www.cubalicores.com. Seleccione los productos, los agrega al carrito y procede a pagar. No recibimos órdenes vía telefónica.", "Puede registrarse en nuestra pagina web y acceder a su perfil o completar su compra sin registrarse."]
	}, {
	    questionDefault: "4. Cómo saber si tienen un producto? Cuándo abastecen la tienda?",
	    answerDefaults: ["R/ Todos los productos disponibles los puede encontrar en nuestro sitio web www.cubalicores.com. No tenemos horarios o fechas específicas para surtir, sugerimos mantenerse al tanto de nuestras redes sociales para actualizaciones sobre nuevos productos y ofertas."]
	}, {
	    questionDefault: "5. Cuánto es el costo de envío?",
	    answerDefaults: ["R/ El Envío Regular + Cargo por Manejo tiene un costo de $18 USD para todas las provincias en las tiendas de CubaLicores.", "Para conocer sobre los costos de envío en otras tiendas de la plataforma por favor visite nuestras Políticas de Envíos y Cargos ( https://www.cubalicores.com/shipping-policy )."]
	}, {
	    questionDefault: "6. Existe un monto mínimo/máximo de compra?",
	    answerDefaults: ["R/ No tenemos montos mínimos o máximos de compra. Asimismo, puede realizar la cantidad de órdenes que considere en un mismo día o período de tiempo. Para algunos productos, sin embargo, podemos establecer límites en las cantidades a ordenar."]
	}, {
	    questionDefault: "7. Puedo pagar con la tarjeta del Banco Metropolitano u otro banco cubano?",
	    answerDefaults: ["R/ Por el momento solo aceptamos pagos con tarjetas Visa, Mastercard, Discover o cualquier otra de banco extranjero."]
	}, {
	    questionDefault: "8. Puedo pagar en efectivo cuando reciba los productos?",
	    answerDefaults: ["R/ No aceptamos pagos en efectivo. Toda la transacción se realiza online en el momento de la compra. "]
	}, {
	    questionDefault: "9. Mi familiar en Cuba, ¿tiene que pagar algo?",
	    answerDefaults: ["R/ En Cuba no se paga nada."]
	}, {
	    questionDefault: "10. Cómo sabe mi familiar en Cuba el día que le llevarán la orden?",
	    answerDefaults: ["R/ Hacemos una llamada a su familiar una vez usted realice el pedido para verificar sus datos y dirección de entrega (Ver pregunta 12 para más información sobre esta llamada) A partir de ese momento debe contar con que la orden llegará en los próximos 8 días hábiles o 30 -60 si es una orden de Pre-Venta.", "24 horas antes de la entrega usted recibe un correo electrónico que anuncia que su pedido está listo para ser Enviado y debe notificar a su familiar. El cliente que realiza la orden es responsable de proveer los datos de contacto en Cuba correctamente, así como de notificar al destinatario cuando reciba el email de Envío de la orden, de lo contrario puede significar atrasos en la entrega."]
	}, {
	    questionDefault: "11. Hice una orden y mi familiar no ha recibido ninguna llamada.",
	    answerDefaults: ["R/ Si ha realizado previamente órdenes para el mismo destinatario, podemos confirmar la dirección de entrega directamente desde el sistema y omitir la primera llamada. Su familiar solo debe esperar el tiempo estimado de entrega."]
	}, {
	    questionDefault: "12. Qué venden además de comida?",
	    answerDefaults: ["R/ Nuestra plataforma está diseñada para vender mucho más que productos de mercado. Hemos incrementado nuestras ofertas sumando emprendimientos cubanos que venden comidas elaboradas de restaurantes, dulces, bisutería, artículos decorativos, flores y mucho más. Manténgase al tanto a través de nuestras redes sociales de los nuevos negocios y productos que vamos incorporando."]
	}, {
	    questionDefault: "13. Cómo saber si mi orden se completó satisfactoriamente?",
	    answerDefaults: ["R/ Hay dos elementos que le indicarán que su orden se completó sin problemas: Primero veri- fique que recibió el correo de confirmación de su pedido (mire también en la carpeta de spam). Luego verifique que se hizo el cargo a su tarjeta a nombre de CubaLicores. Si alguno de estos indicadores falla significa que no recibimos su pedido. Usted es responsable de escribir correctamente el correo electrónico donde recibirá la confirmación de la orden."]
	}, {
	    questionDefault: "14. Cómo puedo darle seguimiento a mi orden?",
	    answerDefaults: ["R/ Si necesita saber el estado de su orden comuníquese con nosotros a través del botón de chat en nuestro sitio web. Tenga en cuenta que los pedidos de CubaLicores tardan entre 10 y 12 días hábiles para ser entregados. Las órdenes de Pre-Venta pueden ser entregadas entre 30 - 60 días. No nos contacte si aún su compra se encuentra dentro del plazo estimado de entrega."]
	}, {
	    questionDefault: "15. Si mi tarjeta no es en USD cómo realizan el cambio de moneda?",
	    answerDefaults: ["R/ Nuestros precios son exclusivamente en USD. Es el banco de su tarjeta quien realiza la conversión de moneda según la tasa que tenga establecida."]
	}, {
	    questionDefault: "16. Tienen algún lugar donde recoger los pedidos?",
	    answerDefaults: ["R/ No. Todas las entregas son exclusivamente a domicilio."]
	}, {
	    questionDefault: "17. Estoy haciendo una compra y mi tarjeta fue declinada",
	    answerDefaults: ["R/ Si su tarjeta fue declinada, sin especificar el motivo, debe consultar con su banco. Si este le confirma que no tiene problemas, y aun así no puede comprar en nuestro sitio, sugerimos utilizar otra tarjeta."]
	}, {
	    questionDefault: "18. Me han Cancelado una orden, ¿cuándo tendré mi dinero de vuelta? ",
	    answerDefaults: ["R/ Si cancelamos su orden, es muy probable que se deba a un error de inventario. Antes de cancelarla, le enviamos un correo electrónico anunciándole, y luego un segundo correo confirmando el procesamiento de su reembolso.", "Una vez procesado el reembolso (dígase a partir de que recibe el segundo correo electrónico), puede tardar de 3-5 días para que se refleje en su cuenta, dependiendo del banco de su tarjeta.", "El total de su dinero es reembolsado a la misma tarjeta con la que realizó su compra."]
	}, {
	    questionDefault: "19. Hice una orden y no recibí el correo electrónico de Confirmación",
	    answerDefaults: ["R/ Puede suceder por varios motivos, el más común está relacionado con errores tipográficos al escribir su correo electrónico antes de pagar.", "Si realizó una orden y no recibió el email de confirmación, por favor comuníquese con nosotros a través de nuestro chat en el sitio web o por el email info@cubalicores.com. Envíenos nombre, apellidos, correo electrónico, monto y los 4 últimos dígitos de la tarjeta que utilizó.", "Por favor asegúrese que el cargo de su orden esté reflejado en su tarjeta. De lo contrario, sugerimos repetir la compra."]
	}, {
	    questionDefault: "20. Escribo al Centro de Ayuda y envío correos electrónicos y no recibo respuesta. Qué puede suceder?",
	    answerDefaults: ["R/ Usualmente experimentamos altos volúmenes de comunicaciones diarias. Es por esto que en ocasiones la respuesta por parte de nuestros agentes puede demorar entre 24 y 48 horas. Sin embargo, todas las solicitudes recibidas son atendidas.", "Para contribuir a que se acorten los tiempos de respuesta, sugerimos:", "1. Asegurarse de que su orden superó el tiempo estimado de entrega.", "2. Incluir en su solicitud el # de Orden y/o datos del cliente que realizó la orden, cuando corresponda.", "3. Revisar la información que tenemos disponible en nuestras Políticas de Envío y Cargos (https://www.cubalicores.com/shipping-policy) y nuestras Políticas de Reclamaciones y Devoluciones (https://www.cubalicores.com/return-policy)"]
	}];
	
	var FrequentQuestions = function (_Component) {
	    _inherits(FrequentQuestions, _Component);
	
	    function FrequentQuestions(props) {
	        _classCallCheck(this, FrequentQuestions);
	
	        var _this = _possibleConstructorReturn(this, (FrequentQuestions.__proto__ || Object.getPrototypeOf(FrequentQuestions)).call(this, props));
	
	        _this.state = {
	            showIndex: 0
	        };
	
	        document.title = _this.props.intl.formatMessage({ id: 'frequent-questions-title', defaultMessage: 'LEGAL WARNING AND PRIVACY POLICY' });
	        return _this;
	    }
	
	    _createClass(FrequentQuestions, [{
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps) {
	            if (this.props.locale !== prevProps.locale) {
	                document.title = this.props.intl.formatMessage({ id: 'frequent-questions-title', defaultMessage: 'LEGAL WARNING AND PRIVACY POLICY' });
	            }
	        }
	    }, {
	        key: 'setSelectedIndex',
	        value: function setSelectedIndex(index) {
	            this.setState({ showIndex: index });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var CollapseTitle = function CollapseTitle(title, index) {
	                return _react2.default.createElement(
	                    'div',
	                    { className: _frequentQuestions2.default.accordion },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'text-justify' },
	                        title,
	                        _react2.default.createElement('i', {
	                            className: 'pe-1x pe-va font-weight-bold ' + _header2.default.angleDown + ' ' + _frequentQuestions2.default.chevron + ' ' + (index === _this2.state.showIndex ? 'pe-7s-angle-up' : 'pe-7s-angle-down')
	                        })
	                    )
	                );
	            };
	
	            var Paragraph = function Paragraph(props) {
	                return _react2.default.createElement(
	                    'li',
	                    { style: { paddingLeft: 15, paddingBottom: 5 }, className: 'text-justify' },
	                    props.children
	                );
	            };
	
	            return _react2.default.createElement(
	                _layout2.default,
	                { notShowMarginBottom: true },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'container' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                            'h4',
	                            { className: _frequentQuestions2.default.mainText },
	                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'frequent-questions-title', defaultMessage: 'FREQUENT QUESTIONS' })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: _frequentQuestions2.default.privacyBackround },
	                                faqs.map(function (item, index) {
	                                    return _react2.default.createElement(
	                                        _reactCollapsible2.default,
	                                        {
	                                            trigger: CollapseTitle(_react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                id: 'frequent-questions-subtitle' + (index + 1),
	                                                defaultMessage: item.questionDefault
	                                            }), index + 1),
	                                            onClose: function onClose() {
	                                                return _this2.setSelectedIndex(0);
	                                            },
	                                            onOpen: function onOpen() {
	                                                return _this2.setSelectedIndex(index + 1);
	                                            },
	                                            transitionTime: 200,
	                                            key: index + 1
	                                        },
	                                        _react2.default.createElement(
	                                            'ul',
	                                            null,
	                                            item.answerDefaults.map(function (answerDefault, paragraphIndex) {
	                                                return _react2.default.createElement(
	                                                    Paragraph,
	                                                    { key: index + 1 + '-' + (paragraphIndex + 1) },
	                                                    _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
	                                                        id: 'frequent-questions-response' + (index + 1) + '-' + (paragraphIndex + 1),
	                                                        defaultMessage: answerDefault
	                                                    })
	                                                );
	                                            })
	                                        )
	                                    );
	                                })
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return FrequentQuestions;
	}(_react.Component);
	
	exports.default = (0, _reactIntl.injectIntl)(FrequentQuestions);

/***/ },
/* 697 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(11);
	
	var _productList = __webpack_require__(243);
	
	var _productList2 = _interopRequireDefault(_productList);
	
	var _homeSlider = __webpack_require__(682);
	
	var _homeSlider2 = _interopRequireDefault(_homeSlider);
	
	var _loader = __webpack_require__(65);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _layout = __webpack_require__(29);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _homepage = __webpack_require__(602);
	
	var _homepage2 = _interopRequireDefault(_homepage);
	
	var _categorySlider = __webpack_require__(657);
	
	var _categorySlider2 = _interopRequireDefault(_categorySlider);
	
	var _appRoutes = __webpack_require__(22);
	
	var _appRoutes2 = _interopRequireDefault(_appRoutes);
	
	var _signupPromotion = __webpack_require__(75);
	
	var _signupPromotion2 = _interopRequireDefault(_signupPromotion);
	
	var _secondaryMenuConnector = __webpack_require__(178);
	
	var _secondaryMenuConnector2 = _interopRequireDefault(_secondaryMenuConnector);
	
	var _configs = __webpack_require__(175);
	
	var _configs2 = _interopRequireDefault(_configs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var HomePage = function (_Component) {
	    _inherits(HomePage, _Component);
	
	    function HomePage(props) {
	        _classCallCheck(this, HomePage);
	
	        var _this = _possibleConstructorReturn(this, (HomePage.__proto__ || Object.getPrototypeOf(HomePage)).call(this, props));
	
	        document.title = _this.props.intl.formatMessage({ id: 'title', defaultMessage: 'Online Store for Cuba' });
	        return _this;
	    }
	
	    _createClass(HomePage, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.props.loadStores(this.props.locale.currentLocale, this.props.currentStore);
	        }
	
	        /* If home page icon is clicked. */
	
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps, prevState) {
	            if (prevProps.location.pathname !== this.props.location.pathname || prevProps.locale.currentLocale !== this.props.locale.currentLocale) {
	                this.props.loadStores(this.props.locale.currentLocale, this.props.currentStore);
	            }
	
	            if (this.props.locale !== prevProps.locale) {
	                document.title = this.props.intl.formatMessage({ id: 'title', defaultMessage: 'Online Store for Cuba' });
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var setCurrentStore = function setCurrentStore(store) {
	                _this2.props.setCurrentStore(_this2.props.locale.currentLocale, store);
	            };
	            return _react2.default.createElement(
	                _layout2.default,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: _homepage2.default.homepage },
	                    _react2.default.createElement(_homeSlider2.default, { locale: this.props.locale }),
	                    _configs2.default.HOME.STORES_IN_ZONES && _react2.default.createElement(_categorySlider2.default, {
	                        taxons: this.props.taxons,
	                        storesGrouped: this.props.storesGrouped,
	                        currentZone: this.props.currentZone,
	                        currentStore: this.props.currentStore,
	                        setCurrentStore: setCurrentStore
	                    }),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'container body-container ' + _homepage2.default.bodyContainer },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'row' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-lg-12 col-md-12 col-sm-12 col-xs-12' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'text-center' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: '' + _homepage2.default.productTitle },
	                                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'products', defaultMessage: 'Products' }),
	                                        _react2.default.createElement(
	                                            'div',
	                                            null,
	                                            _react2.default.createElement(_loader2.default, { displayLoader: this.props.displayLoader })
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'row' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-lg-3 col-md-3 col-sm-4 col-xs-12 ' + _homepage2.default.colFilters },
	                                _react2.default.createElement(_secondaryMenuConnector2.default, { location: this.props.location, path: _appRoutes2.default.searchPageRoute })
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-lg-9 col-md-9 col-sm-8 col-xs-12' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'row' },
	                                    !this.props.displayLoader && _react2.default.createElement(_productList2.default, {
	                                        products: this.props.products,
	                                        loadMoreProducts: this.props.loadMoreProducts,
	                                        pageCount: this.props.pageCount,
	                                        locale: this.props.locale
	                                    })
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return HomePage;
	}(_react.Component);
	
	exports.default = (0, _reactIntl.injectIntl)(HomePage);

/***/ },
/* 698 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(41);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(11);
	
	var _reactDataTableComponent = __webpack_require__(1841);
	
	var _reactDataTableComponent2 = _interopRequireDefault(_reactDataTableComponent);
	
	var _reactReduxToastr = __webpack_require__(42);
	
	var _layout = __webpack_require__(29);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _banner = __webpack_require__(683);
	
	var _banner2 = _interopRequireDefault(_banner);
	
	var _transactionNoteTooltip = __webpack_require__(685);
	
	var _transactionNoteTooltip2 = _interopRequireDefault(_transactionNoteTooltip);
	
	var _transactionDateTooltip = __webpack_require__(684);
	
	var _transactionDateTooltip2 = _interopRequireDefault(_transactionDateTooltip);
	
	var _kwalletActivationModal = __webpack_require__(245);
	
	var _kwalletActivationModal2 = _interopRequireDefault(_kwalletActivationModal);
	
	var _transferDialog = __webpack_require__(686);
	
	var _transferDialog2 = _interopRequireDefault(_transferDialog);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var useEffect = _react2.default.useEffect;
	var useState = _react2.default.useState;
	
	
	var ManageKWallet = function ManageKWallet(_ref) {
	    var handleKWalletActivateModal = function () {
	        var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee(result) {
	            var activate;
	            return _regenerator2.default.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            if (!result) {
	                                _context.next = 7;
	                                break;
	                            }
	
	                            _context.next = 3;
	                            return props.activateWallet(accessToken);
	
	                        case 3:
	                            activate = _context.sent;
	
	                            if (activate) {
	                                window.location.reload(); // cambiar a cargar el contenido correctamente.
	                            } else {
	                                window.location.assign('/');
	                            }
	                            _context.next = 8;
	                            break;
	
	                        case 7:
	                            if (props.user.id) {
	                                setShowActivateKWallet(false);
	                            } else {
	                                window.location.assign('/');
	                            }
	
	                        case 8:
	                        case 'end':
	                            return _context.stop();
	                    }
	                }
	            }, _callee, this);
	        }));
	
	        return function handleKWalletActivateModal(_x) {
	            return _ref2.apply(this, arguments);
	        };
	    }();
	
	    var intl = _ref.intl;
	    var activeWallet = _ref.activeWallet;
	    var accessToken = _ref.accessToken;
	
	    var props = _objectWithoutProperties(_ref, ['intl', 'activeWallet', 'accessToken']);
	
	    var parseDescription = function parseDescription(description, row) {
	        return description.replaceAll(/{%(\w+)%}/g, function (match) {
	            var property = match.slice(2, match.length - 2);
	            var value = row[property] !== undefined ? row[property] : '-';
	            // created_on requires an extra parsing to format the date
	            if (value !== '-' && property === 'created_on') {
	                value = new Date(value).toLocaleDateString('en-US');
	            }
	            return value;
	        });
	    };
	
	    function getDetailedError(response) {
	        var detailMessage = intl.formatMessage({ id: 'generic-error-title' });
	        if (response && response.body && response.body.message) {
	            switch (response.body.message) {
	                case 'Account not found':
	                    detailMessage = intl.formatMessage({ id: 'transfer-funds-k-wallet-account-not-found' });break;
	                case 'Transfer between same account is not allowed':
	                    detailMessage = intl.formatMessage({ id: 'transfer-funds-k-wallet-same-account' });break;
	                default:
	                    detailMessage = intl.formatMessage({ id: 'generic-error-title' });
	            }
	        }
	        return detailMessage;
	    }
	
	    var columns = [{
	        name: intl.formatMessage({ id: 'transactions-table-date', defaultMessage: 'transactions-table-date' }),
	        selector: function selector(row) {
	            return row.created_on;
	        },
	        wrap: true,
	        cell: function cell(row) {
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(_transactionDateTooltip2.default, { content: new Date(row.created_on).toLocaleDateString('en-US'), extra: new Date(row.created_on).toLocaleString() })
	            );
	        }
	    }, {
	        name: intl.formatMessage({ id: 'transactions-table-description', defaultMessage: 'transactions-table-description' }),
	        selector: function selector(row) {
	            return row.description;
	        },
	        cell: function cell(row) {
	            return _react2.default.createElement(
	                'div',
	                {
	                    style: {
	                        display: 'flex',
	                        alignItems: 'center',
	                        justifyContent: 'space-between',
	                        width: '100%'
	                    }
	                },
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    parseDescription(row.description, row)
	                ),
	                row.notes && _react2.default.createElement(_transactionNoteTooltip2.default, { notes: row.notes })
	            );
	        },
	        wrap: true,
	        grow: 3
	    }, {
	        name: intl.formatMessage({ id: 'transactions-table-status', defaultMessage: 'transactions-table-status' }),
	        selector: function selector(row) {
	            return row.status;
	        },
	        format: function format(row) {
	            return row.status ? row.status.toUpperCase() : '';
	        }
	    }, {
	        name: intl.formatMessage({ id: 'transactions-table-amount', defaultMessage: 'transactions-table-amount' }),
	        selector: function selector(row) {
	            return row.amount;
	        },
	        format: function format(row, index) {
	            return '$ ' + row.amount.toFixed(2);
	        }
	    }];
	
	    var _useState = useState([]);
	
	    var _useState2 = _slicedToArray(_useState, 2);
	
	    var transactionsData = _useState2[0];
	    var setTransactionsData = _useState2[1];
	    // eslint-disable-next-line no-undef
	
	    var _useState3 = useState({});
	
	    var _useState4 = _slicedToArray(_useState3, 2);
	
	    var walletDetails = _useState4[0];
	    var setWalletDetails = _useState4[1];
	
	    var _useState5 = useState(0);
	
	    var _useState6 = _slicedToArray(_useState5, 2);
	
	    var page = _useState6[0];
	    var setPage = _useState6[1];
	
	    var _useState7 = useState(10);
	
	    var _useState8 = _slicedToArray(_useState7, 2);
	
	    var itemsPerPage = _useState8[0];
	    var setItemsPerPage = _useState8[1];
	
	    var _useState9 = useState(0);
	
	    var _useState10 = _slicedToArray(_useState9, 2);
	
	    var totalItems = _useState10[0];
	    var setTotalItems = _useState10[1];
	
	    var _useState11 = useState('');
	
	    var _useState12 = _slicedToArray(_useState11, 2);
	
	    var searchQuery = _useState12[0];
	    var setSearchQuery = _useState12[1];
	
	    var _useState13 = useState(false);
	
	    var _useState14 = _slicedToArray(_useState13, 2);
	
	    var isLoading = _useState14[0];
	    var setIsLoading = _useState14[1];
	
	    var _useState15 = useState(activeWallet);
	
	    var _useState16 = _slicedToArray(_useState15, 2);
	
	    var showActivateKWallet = _useState16[0];
	    var setShowActivateKWallet = _useState16[1];
	
	    var _useState17 = useState(false);
	
	    var _useState18 = _slicedToArray(_useState17, 2);
	
	    var showTransferFundsKWallet = _useState18[0];
	    var setShowTransferFundsKWallet = _useState18[1];
	
	    var _useState19 = useState(false);
	
	    var _useState20 = _slicedToArray(_useState19, 2);
	
	    var loadingTransferFundsKWallet = _useState20[0];
	    var setLoadingTransferFundsKWallet = _useState20[1];
	
	
	    var customStyles = {
	        headCells: {
	            style: {
	                fontSize: '16px',
	                fontWeight: 'bold'
	            }
	        }
	    };
	
	    function fetchWalletDetails() {
	        props.fetchWalletDetails(accessToken).then(function (response) {
	            setWalletDetails(response.body);
	        });
	    }
	
	    function fetchWalletTransactions() {
	        props.fetchWalletTransactions(accessToken, {
	            page: page,
	            size: itemsPerPage,
	            q: searchQuery
	        }).then(function (response) {
	            var _response$body = response.body;
	            var content = _response$body.content;
	            var pageResponse = _response$body.page;
	
	            setTransactionsData(content);
	            setTotalItems(pageResponse.total_elements);
	            setIsLoading(false);
	        });
	    }
	
	    useEffect(function () {
	        if (!activeWallet && props.user.id) {
	            setShowActivateKWallet(true);
	        } else {
	            setTimeout(fetchWalletDetails, 0);
	        }
	
	        // eslint-disable-next-line react-hooks/exhaustive-deps
	    }, [accessToken]);
	
	    useEffect(function () {
	        setIsLoading(true);
	        setTimeout(fetchWalletTransactions, 0);
	        // eslint-disable-next-line react-hooks/exhaustive-deps
	    }, [page, itemsPerPage, searchQuery, accessToken]);
	
	    var ref = null;
	    var onSearch = function onSearch(q) {
	        if (ref) {
	            clearTimeout(ref);
	        }
	        ref = setTimeout(function () {
	            var param = new URLSearchParams();
	            param.append('q', q);
	            setSearchQuery(param.toString().slice(2));
	        }, 500);
	    };
	
	    function handleClickTransferFunds(e) {
	        setShowTransferFundsKWallet(true);
	    }
	
	    function handleTransferFundsKWalletClose(e) {
	        setShowTransferFundsKWallet(false);
	    }
	
	    function handleTransferFunds(values) {
	        setLoadingTransferFundsKWallet(true);
	        props.transferFunds(accessToken, values.amount, values.idTransfer).then(function (response) {
	            setShowTransferFundsKWallet(false);
	            _reactReduxToastr.toastr.success(intl.formatMessage({ id: 'well', defaultMessage: 'Well done' }), intl.formatMessage({ id: 'transfer-funds-k-wallet-submitted-successfully', defaultMessage: 'Funds transferred successfully' }));
	            fetchWalletTransactions();
	            fetchWalletDetails();
	        }).catch(function (_ref3) {
	            var response = _ref3.response;
	
	            setShowTransferFundsKWallet(false);
	            _reactReduxToastr.toastr.error(intl.formatMessage({ id: 'error', defaultMessage: 'Error' }), getDetailedError(response));
	        }).finally(function () {
	            setLoadingTransferFundsKWallet(false);
	        });
	    }
	
	    return activeWallet ? _react2.default.createElement(
	        _layout2.default,
	        null,
	        _react2.default.createElement(
	            'div',
	            { className: 'body-container manager-k-wallet' },
	            _react2.default.createElement(
	                'div',
	                { className: 'container' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'section-heading no-down-border' },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'manage-k-wallet', defaultMessage: 'manage-k-wallet' })
	                ),
	                _react2.default.createElement(_banner2.default, {
	                    accountBalance: walletDetails.balance,
	                    availableBalance: walletDetails.available_balance,
	                    activeWallet: activeWallet,
	                    kWalletId: walletDetails.number,
	                    transferFunds: handleClickTransferFunds
	                }),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'section-heading no-down-border k-wallet-transactions' },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'manage-k-wallet-transactions', defaultMessage: 'Transacciones' }),
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement('input', {
	                            type: 'search',
	                            className: 'form-control',
	                            placeholder: intl.formatMessage({ id: 'transactions-table-search', defaultMessage: 'transactions-table-search' }),
	                            onChange: function onChange(ev) {
	                                return onSearch(ev.target.value);
	                            }
	                        })
	                    )
	                ),
	                _react2.default.createElement(_reactDataTableComponent2.default, {
	                    columns: columns,
	                    data: transactionsData,
	                    pagination: true,
	                    paginationServer: true,
	                    paginationTotalRows: totalItems,
	                    onChangeRowsPerPage: function onChangeRowsPerPage(newPerPage) {
	                        return setItemsPerPage(newPerPage);
	                    },
	                    onChangePage: function onChangePage(page) {
	                        return setPage(page - 1);
	                    },
	                    customStyles: customStyles,
	                    progressPending: isLoading,
	                    noHeader: true,
	                    noDataComponent: _react2.default.createElement(
	                        'p',
	                        { style: { padding: '20px', fontSize: '16px' } },
	                        intl.formatMessage({ id: 'transactions-table-no-records', defaultMessage: 'transactions-table-no-records' })
	                    ),
	                    progressComponent: _react2.default.createElement(
	                        'p',
	                        { style: { padding: '20px', fontSize: '16px' } },
	                        intl.formatMessage({ id: 'transactions-table-loading', defaultMessage: 'transactions-table-loading' })
	                    ),
	                    paginationComponentOptions: {
	                        rowsPerPageText: intl.formatMessage({ id: 'transactions-table-rows-per-page', defaultMessage: 'transactions-table-rows-per-page' })
	                    }
	                })
	            )
	        ),
	        _react2.default.createElement(_transferDialog2.default, {
	            isOpen: showTransferFundsKWallet,
	            handleClose: handleTransferFundsKWalletClose,
	            availableBalance: walletDetails.available_balance,
	            transferFunds: handleTransferFunds,
	            loading: loadingTransferFundsKWallet
	        })
	    ) : _react2.default.createElement(
	        _layout2.default,
	        null,
	        _react2.default.createElement(
	            'div',
	            { className: 'body-container manager-k-wallet' },
	            _react2.default.createElement(
	                'div',
	                { className: 'container' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'section-heading no-down-border' },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'k-wallet', defaultMessage: 'K-Wallet' })
	                ),
	                _react2.default.createElement(_banner2.default, {
	                    accountBalance: walletDetails.balance,
	                    availableBalance: walletDetails.available_balance,
	                    kWalletId: walletDetails.number,
	                    transferFunds: handleClickTransferFunds
	                })
	            )
	        ),
	        _react2.default.createElement(_kwalletActivationModal2.default, {
	            isOpen: showActivateKWallet,
	            handleClose: handleKWalletActivateModal
	        })
	    );
	};
	
	exports.default = (0, _reactIntl.injectIntl)(ManageKWallet);

/***/ },
/* 699 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(11);
	
	var _reactRouterDom = __webpack_require__(26);
	
	var _layout = __webpack_require__(29);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _comingSoon = __webpack_require__(171);
	
	var _comingSoon2 = _interopRequireDefault(_comingSoon);
	
	var _appRoutes = __webpack_require__(22);
	
	var _appRoutes2 = _interopRequireDefault(_appRoutes);
	
	var _signupPromotion = __webpack_require__(75);
	
	var _signupPromotion2 = _interopRequireDefault(_signupPromotion);
	
	var _error = __webpack_require__(1610);
	
	var _error2 = _interopRequireDefault(_error);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NotFound = function (_Component) {
	    _inherits(NotFound, _Component);
	
	    function NotFound(props) {
	        _classCallCheck(this, NotFound);
	
	        var _this = _possibleConstructorReturn(this, (NotFound.__proto__ || Object.getPrototypeOf(NotFound)).call(this, props));
	
	        document.title = _this.props.intl.formatMessage({ id: 'title', defaultMessage: 'Online Store for Cuba' });
	        return _this;
	    }
	
	    _createClass(NotFound, [{
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps, prevState) {
	            if (this.props.locale !== prevProps.locale) {
	                document.title = this.props.intl.formatMessage({ id: 'title', defaultMessage: 'Online Store for Cuba' });
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                _layout2.default,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: _comingSoon2.default.comingContainer },
	                    _react2.default.createElement(
	                        'div',
	                        { style: { paddingBottom: 45 } },
	                        _react2.default.createElement('img', {
	                            src: _error2.default,
	                            alt: this.props.intl.formatMessage({
	                                id: 'not-found',
	                                defaultMessage: 'Not'
	                            }),
	                            width: '304'
	                        })
	                    ),
	                    _react2.default.createElement(
	                        'h1',
	                        { className: _comingSoon2.default.mainText, style: { paddingBottom: 10 } },
	                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'oops', defaultMessage: 'Ooops!' })
	                    ),
	                    _react2.default.createElement(
	                        'h1',
	                        { className: _comingSoon2.default.mainText, style: { paddingBottom: 10 } },
	                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'oops-text', defaultMessage: 'We can\'t seem to find the page you\'re looking for.' })
	                    ),
	                    _react2.default.createElement(
	                        'h2',
	                        { className: _comingSoon2.default.secondaryText },
	                        _react2.default.createElement(
	                            _reactRouterDom.Link,
	                            { to: _appRoutes2.default.mercadoUnicoProducts },
	                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'coming-soon-button', defaultMessage: 'See Mercado Unico Products' })
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return NotFound;
	}(_react.Component);
	
	exports.default = (0, _reactIntl.injectIntl)(NotFound);

/***/ },
/* 700 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(11);
	
	var _reactCollapsible = __webpack_require__(311);
	
	var _reactCollapsible2 = _interopRequireDefault(_reactCollapsible);
	
	var _layout = __webpack_require__(29);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _privacy = __webpack_require__(2166);
	
	var _privacy2 = _interopRequireDefault(_privacy);
	
	var _header = __webpack_require__(101);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _signupPromotion = __webpack_require__(75);
	
	var _signupPromotion2 = _interopRequireDefault(_signupPromotion);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PrivacyPolicy = function (_Component) {
	    _inherits(PrivacyPolicy, _Component);
	
	    function PrivacyPolicy(props) {
	        _classCallCheck(this, PrivacyPolicy);
	
	        var _this = _possibleConstructorReturn(this, (PrivacyPolicy.__proto__ || Object.getPrototypeOf(PrivacyPolicy)).call(this, props));
	
	        _this.state = {
	            showIndex: 0
	        };
	
	        document.title = _this.props.intl.formatMessage({ id: 'privacy-policy-title', defaultMessage: 'LEGAL WARNING AND PRIVACY POLICY' });
	        return _this;
	    }
	
	    _createClass(PrivacyPolicy, [{
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps) {
	            if (this.props.locale !== prevProps.locale) {
	                document.title = this.props.intl.formatMessage({ id: 'privacy-policy-title', defaultMessage: 'LEGAL WARNING AND PRIVACY POLICY' });
	            }
	        }
	    }, {
	        key: 'setSelectedIndex',
	        value: function setSelectedIndex(index) {
	            this.setState({ showIndex: index });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var CollapseTitle = function CollapseTitle(title, index) {
	                return _react2.default.createElement(
	                    'div',
	                    { className: _privacy2.default.accordion },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'text-justify' },
	                        title,
	                        _react2.default.createElement('i', {
	                            className: 'pe-7s-angle-down pe-1x pe-va font-weight-bold ' + _header2.default.angleDown,
	                            style: { fontSize: 20, color: 'blue', display: index !== _this2.state.showIndex ? 'inline-block' : 'none' }
	                        }),
	                        _react2.default.createElement('i', {
	                            className: 'pe-7s-angle-up pe-1x pe-va font-weight-bold ' + _header2.default.angleUp,
	                            style: { fontSize: 20, color: 'blue', display: index === _this2.state.showIndex ? 'inline-block' : 'none' }
	                        })
	                    )
	                );
	            };
	
	            var Paragraph = function Paragraph(props) {
	                return _react2.default.createElement(
	                    'li',
	                    { style: { paddingLeft: 15, paddingBottom: 5 }, className: 'text-justify' },
	                    props.children
	                );
	            };
	
	            var KatapulkStrongTag = function KatapulkStrongTag() {
	                return _react2.default.createElement(
	                    'strong',
	                    null,
	                    'Othar Trade & Logistics Spain'
	                );
	            };
	
	            return _react2.default.createElement(
	                _layout2.default,
	                { notShowMarginBottom: true },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'container' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                            'h4',
	                            { className: _privacy2.default.mainText },
	                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'privacy-policy-title', defaultMessage: 'LEGAL WARNING AND PRIVACY POLICY' })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: _privacy2.default.privacyBackround },
	                                _react2.default.createElement(
	                                    'p',
	                                    { className: 'text-justify', style: { paddingBottom: 10 } },
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: 'privacy-policy-text1'
	                                        // eslint-disable-next-line max-len
	                                        , defaultMessage: 'This legal notice includes the general conditions of access, navigation, and use of the website www.cubalicores.com / cubalicores.com; as well as the details of the treatment of our clients\' data. You must accept this legal notice to navigate the pages of www.cubalicores.com and cubalicores.com, as well as to make a purchase.'
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    _reactCollapsible2.default,
	                                    {
	                                        trigger: CollapseTitle(_react2.default.createElement(_reactIntl.FormattedMessage, {
	                                            id: 'privacy-policy-subtitle1',
	                                            defaultMessage: ' 1) Introduction'
	                                        }), 1),
	                                        onClose: function onClose() {
	                                            return _this2.setSelectedIndex(0);
	                                        },
	                                        onOpen: function onOpen() {
	                                            return _this2.setSelectedIndex(1);
	                                        },
	                                        transitionTime: 200
	                                    },
	                                    _react2.default.createElement(
	                                        'ul',
	                                        null,
	                                        _react2.default.createElement(
	                                            Paragraph,
	                                            null,
	                                            _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                id: 'privacy-policy-subtitle1-text1'
	                                                // eslint-disable-next-line max-len
	                                                , defaultMessage: 'a. Access to the www.cubalicores.com / cubalicores.com portal is conditioned on the user\'s prior reading and acceptance of the conditions, terms, communications, warnings, legal notices and other information contained in these Terms and Conditions. Access to it is free, its viewing does not require prior subscription or registration whatsoever, and its use by the user implies express, full and unreserved agreement with all of its content.'
	                                            })
	                                        ),
	                                        _react2.default.createElement(
	                                            Paragraph,
	                                            null,
	                                            _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                id: 'privacy-policy-subtitle1-text2'
	                                                // eslint-disable-next-line max-len
	                                                , defaultMessage: 'b. If the User does not agree with the content of these General Conditions for browsing access and use of this website, they will not be able to access or buy the products and services it offers.'
	                                            })
	                                        ),
	                                        _react2.default.createElement(
	                                            Paragraph,
	                                            null,
	                                            _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                id: 'privacy-policy-subtitle1-text3'
	                                                // eslint-disable-next-line max-len
	                                                , defaultMessage: 'c. By accepting these terms and conditions, the user affirms and declares that they are of legal age and have sufficient legal capacity to register on this website. Likewise, you expressly and without exception accept that access to and use of this website, its services and the contents of said services take place under your sole and exclusive responsibility, and cannot guarantee www.cubalicores.com / cubalicores.com that in direct access to other Web sites through links (links) can view information that could hurt your sensitivity or cause damage.'
	                                            })
	                                        ),
	                                        _react2.default.createElement(
	                                            Paragraph,
	                                            null,
	                                            _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                id: 'privacy-policy-subtitle1-text4'
	                                                // eslint-disable-next-line max-len
	                                                , defaultMessage: 'd. The connections with other Web sites that may exist, as well as the use that the User may make of them, is subject to these conditions, as well as any specific conditions that the aforementioned Web sites require. Any use other than authorized is expressly prohibited.'
	                                            })
	                                        ),
	                                        _react2.default.createElement(
	                                            Paragraph,
	                                            null,
	                                            'e.',
	                                            ' ',
	                                            _react2.default.createElement(KatapulkStrongTag, null),
	                                            ' ',
	                                            _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                id: 'privacy-policy-subtitle1-text5'
	                                                // eslint-disable-next-line max-len
	                                                , defaultMessage: 'may modify this website unilaterally and at any time it deems appropriate, updating its configuration, the terms and conditions of the services and their content, eliminate, limit or suspend them temporarily or permanently, as well as prevent access to them by trying inform the User of said change, as long as circumstances allow it, through its publication on the website, which is why Users are recommended to consult the GC, the General Conditions at each access to the Website of Sale, Legal Notices and Particular Conditions set forth in the different pages that make up the website.'
	                                            })
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    _reactCollapsible2.default,
	                                    {
	                                        trigger: CollapseTitle(_react2.default.createElement(_reactIntl.FormattedMessage, {
	                                            id: 'privacy-policy-subtitle2',
	                                            defaultMessage: ' 2) Characteristics of the web and navigability'
	                                        }), 2),
	                                        onClose: function onClose() {
	                                            return _this2.setSelectedIndex(0);
	                                        },
	                                        onOpen: function onOpen() {
	                                            return _this2.setSelectedIndex(2);
	                                        },
	                                        transitionTime: 200
	                                    },
	                                    _react2.default.createElement(
	                                        'ul',
	                                        null,
	                                        _react2.default.createElement(
	                                            Paragraph,
	                                            null,
	                                            _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                id: 'privacy-policy-subtitle2-text1'
	                                                // eslint-disable-next-line max-len
	                                                , defaultMessage: 'a. Adapted web design. The www.cubalicores.com / cubalicores.com website has a responsive design that allows the client to access the website from different devices, adapting the image and resolution of the website to each device.'
	                                            })
	                                        ),
	                                        _react2.default.createElement(
	                                            Paragraph,
	                                            null,
	                                            _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                id: 'privacy-policy-subtitle2-text2'
	                                                // eslint-disable-next-line max-len
	                                                , defaultMessage: 'b. High in account. There is a Register, which is accessed in the MY ACCOUNT section, which the user will complete with the required data and with the acceptance of the legal notice to be able to access the online shopping services of www.cubalicores.com / cubalicores.com.'
	                                            })
	                                        ),
	                                        _react2.default.createElement(
	                                            Paragraph,
	                                            null,
	                                            _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                id: 'privacy-policy-subtitle2-text3',
	                                                defaultMessage: 'c. Possibility of managing profile data. There is an INFORMATION section, accessed through MY ACCOUNT, in which the user can:'
	                                            }),
	                                            _react2.default.createElement(
	                                                'ul',
	                                                { style: { paddingLeft: 10 } },
	                                                _react2.default.createElement(
	                                                    'li',
	                                                    null,
	                                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                        id: 'privacy-policy-subtitle2-text3-1',
	                                                        defaultMessage: 'i. Manage your personal data'
	                                                    })
	                                                ),
	                                                _react2.default.createElement(
	                                                    'li',
	                                                    null,
	                                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                        id: 'privacy-policy-subtitle2-text3-2',
	                                                        defaultMessage: 'ii. Add recipients'
	                                                    })
	                                                ),
	                                                _react2.default.createElement(
	                                                    'li',
	                                                    null,
	                                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                        id: 'privacy-policy-subtitle2-text3-3',
	                                                        defaultMessage: 'iii. Check available credit or bonuses'
	                                                    })
	                                                ),
	                                                _react2.default.createElement(
	                                                    'li',
	                                                    null,
	                                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                        id: 'privacy-policy-subtitle2-text3-4',
	                                                        defaultMessage: 'iv. Manage orders'
	                                                    })
	                                                ),
	                                                _react2.default.createElement(
	                                                    'li',
	                                                    null,
	                                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                        id: 'privacy-policy-subtitle2-text3-5',
	                                                        defaultMessage: 'v. View the products added to FAVORITES'
	                                                    })
	                                                )
	                                            )
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    _reactCollapsible2.default,
	                                    {
	                                        trigger: CollapseTitle(_react2.default.createElement(_reactIntl.FormattedMessage, {
	                                            id: 'privacy-policy-subtitle3',
	                                            defaultMessage: ' 3) Rights and obligations of the service provider'
	                                        }), 3),
	                                        onClose: function onClose() {
	                                            return _this2.setSelectedIndex(0);
	                                        },
	                                        onOpen: function onOpen() {
	                                            return _this2.setSelectedIndex(3);
	                                        },
	                                        transitionTime: 200
	                                    },
	                                    _react2.default.createElement(
	                                        'ul',
	                                        null,
	                                        _react2.default.createElement(
	                                            Paragraph,
	                                            null,
	                                            _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                id: 'privacy-policy-subtitle3-text1'
	                                                // eslint-disable-next-line max-len
	                                                , defaultMessage: 'a. www.cubalicores.com / cubalicores.com is obliged to provide the services offered on the Web and guarantee the communications that may exist with the client, as well as to respond to claims and queries that may arise.'
	                                            })
	                                        ),
	                                        _react2.default.createElement(
	                                            Paragraph,
	                                            null,
	                                            _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                id: 'privacy-policy-subtitle3-text2'
	                                                // eslint-disable-next-line max-len
	                                                , defaultMessage: 'b. www.cubalicores.com / cubalicores.com has the right to suspend temporarily and without prior notice the accessibility of this website, as well as to reserve the right to provide or cancel services, in the event of carrying out operations of maintenance, repair, update or improvement of services.'
	                                            })
	                                        ),
	                                        _react2.default.createElement(
	                                            Paragraph,
	                                            null,
	                                            _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                id: 'privacy-policy-subtitle3-text3',
	                                                defaultMessage: 'c. The intellectual property rights on the website are owned by'
	                                            }),
	                                            ' ',
	                                            _react2.default.createElement(KatapulkStrongTag, null),
	                                            ' ',
	                                            _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                id: 'privacy-policy-subtitle3-text4',
	                                                defaultMessage: 'The rights of reproduction, distribution, public communication and transformation belong to the same company.'
	                                            })
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    _reactCollapsible2.default,
	                                    {
	                                        trigger: CollapseTitle(_react2.default.createElement(_reactIntl.FormattedMessage, {
	                                            id: 'privacy-policy-subtitle4',
	                                            defaultMessage: ' 4) Rights and obligations of the user'
	                                        }), 4),
	                                        onClose: function onClose() {
	                                            return _this2.setSelectedIndex(0);
	                                        },
	                                        onOpen: function onOpen() {
	                                            return _this2.setSelectedIndex(4);
	                                        },
	                                        transitionTime: 200
	                                    },
	                                    _react2.default.createElement(
	                                        'ul',
	                                        null,
	                                        _react2.default.createElement(
	                                            Paragraph,
	                                            null,
	                                            _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                id: 'privacy-policy-subtitle4-text1'
	                                                // eslint-disable-next-line max-len
	                                                , defaultMessage: 'The contents of this website are available to the user for their use without any commercial purpose and exclusively for their personal use; and only for these purposes the user can transfer the contents of this website. The user cannot, consequently, distribute, modify, transmit, forward or use in any way such content for commercial purposes.'
	                                            })
	                                        ),
	                                        _react2.default.createElement(
	                                            Paragraph,
	                                            null,
	                                            _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                id: 'privacy-policy-subtitle4-text2'
	                                                // eslint-disable-next-line max-len
	                                                , defaultMessage: 'b. At all times, the User must make lawful use of the services of this Website in accordance with current legislation, respecting the intellectual property rights of'
	                                            }),
	                                            ' ',
	                                            _react2.default.createElement(KatapulkStrongTag, null),
	                                            ' ',
	                                            _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                id: 'privacy-policy-subtitle4-text3',
	                                                defaultMessage: 'and possible third parties.'
	                                            })
	                                        ),
	                                        _react2.default.createElement(
	                                            Paragraph,
	                                            null,
	                                            _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                id: 'privacy-policy-subtitle4-text4'
	                                                // eslint-disable-next-line max-len
	                                                , defaultMessage: 'c. The User will not carry out through the services that www.cubalicores.com / cubalicores.com makes available to them any action that causes damage or alterations to the contents or hinders the proper functioning of the Web, expressly committing themselves to the sole use of the same to not cause technical problems of any kind, transfer elements that may carry computer viruses or damage, interfere or totally or partially intercept the Web, as well as not to intervene or alter the email of other Users.'
	                                            })
	                                        ),
	                                        _react2.default.createElement(
	                                            Paragraph,
	                                            null,
	                                            _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                id: 'privacy-policy-subtitle4-text5'
	                                                // eslint-disable-next-line max-len
	                                                , defaultMessage: 'd. The User\'s responsibility for the veracity of the data entered, in the event that he did so for any circumstance, is exclusive to the User himself; Therefore, in the event of having provided false or inaccurate information, www.cubalicores.com / cubalicores.com and, where appropriate, the collaborating companies of'
	                                            }),
	                                            ' ',
	                                            _react2.default.createElement(KatapulkStrongTag, null),
	                                            _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                id: 'privacy-policy-subtitle4-text6',
	                                                defaultMessage: ', reserve the right to prohibit the access to this website.'
	                                            })
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    _reactCollapsible2.default,
	                                    {
	                                        trigger: CollapseTitle(_react2.default.createElement(_reactIntl.FormattedMessage, {
	                                            id: 'privacy-policy-subtitle5',
	                                            defaultMessage: ' 5) Exclusion of guarantees and responsibility for the operation of the website'
	                                        }), 5),
	                                        onClose: function onClose() {
	                                            return _this2.setSelectedIndex(0);
	                                        },
	                                        onOpen: function onOpen() {
	                                            return _this2.setSelectedIndex(5);
	                                        },
	                                        transitionTime: 200
	                                    },
	                                    _react2.default.createElement(
	                                        'ul',
	                                        null,
	                                        _react2.default.createElement(
	                                            Paragraph,
	                                            null,
	                                            _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                id: 'privacy-policy-subtitle5-text1'
	                                                // eslint-disable-next-line max-len
	                                                , defaultMessage: 'a. www.cubalicores.com / cubalicores.com undertakes to work to maintain the continued availability of this website, but neither www.cubalicores.com / cubalicores.com nor the collaborating companies of'
	                                            }),
	                                            ' ',
	                                            _react2.default.createElement(KatapulkStrongTag, null),
	                                            _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                id: 'privacy-policy-subtitle5-text2'
	                                                // eslint-disable-next-line max-len
	                                                , defaultMessage: ', guarantee the availability and continuity of the operation of this website and its services. In this way, any liability for damages of any nature that may arise from the lack of availability or continuity of the operation of the website and its services and the usefulness that Users could have attributed to this website is excluded.'
	                                            })
	                                        ),
	                                        _react2.default.createElement(
	                                            Paragraph,
	                                            null,
	                                            _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                id: 'privacy-policy-subtitle5-text3',
	                                                defaultMessage: 'b. www.cubalicores.com / cubalicores.com and the collaborating companies of'
	                                            }),
	                                            ' ',
	                                            _react2.default.createElement(KatapulkStrongTag, null),
	                                            ' ',
	                                            _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                id: 'privacy-policy-subtitle5-text4'
	                                                // eslint-disable-next-line max-len
	                                                , defaultMessage: 'They make personal data privacy systems available to Users that prevent access to them by third parties. www.cubalicores.com / cubalicores.com and the collaborating companies of'
	                                            }),
	                                            ' ',
	                                            _react2.default.createElement(KatapulkStrongTag, null),
	                                            ' ',
	                                            _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                id: 'privacy-policy-subtitle5-text5'
	                                                // eslint-disable-next-line max-len
	                                                , defaultMessage: 'They have implemented all the necessary technical and organizational security measures to guarantee the integrity, confidentiality and availability of the personal data provided by the User. In this sense, the aforementioned companies are exempt from all liability for damages caused in the event of such knowledge.'
	                                            })
	                                        ),
	                                        _react2.default.createElement(
	                                            Paragraph,
	                                            null,
	                                            _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                id: 'privacy-policy-subtitle5-text6'
	                                                // eslint-disable-next-line max-len
	                                                , defaultMessage: 'c. Despite the fact that www.cubalicores.com / cubalicores.com have implemented all the appropriate measures to guarantee security in this matter, it does not control or guarantee the absence of viruses or other elements in the contents of this website that may cause alterations in the computer system (software and hardware) of the User or in the electronic documents and files stored in his computer system.'
	                                            })
	                                        ),
	                                        _react2.default.createElement(
	                                            Paragraph,
	                                            null,
	                                            _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                id: 'privacy-policy-subtitle5-text7',
	                                                defaultMessage: 'd. www.cubalicores.com / cubalicores.com and the collaborating companies of'
	                                            }),
	                                            ' ',
	                                            _react2.default.createElement(KatapulkStrongTag, null),
	                                            ' ',
	                                            _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                id: 'privacy-policy-subtitle5-text8'
	                                                // eslint-disable-next-line max-len
	                                                , defaultMessage: 'are exempt from any responsibility for damages of any kind that may be due to the presence of viruses in the contents that may cause alterations in the computer system, electronic documents, files, etc ...'
	                                            })
	                                        ),
	                                        _react2.default.createElement(
	                                            Paragraph,
	                                            null,
	                                            _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                id: 'privacy-policy-subtitle5-text9',
	                                                defaultMessage: 'e. www.cubalicores.com / cubalicores.com and the collaborating companies of'
	                                            }),
	                                            ' ',
	                                            _react2.default.createElement(KatapulkStrongTag, null),
	                                            ' ',
	                                            _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                id: 'privacy-policy-subtitle5-text10'
	                                                // eslint-disable-next-line max-len
	                                                , defaultMessage: 'They have no obligation to control, and do not control, the use that Users make of this website, the services that this website provides, or its contents. In particular, www.cubalicores.com / cubalicores.com does not guarantee that Users will use the website, its services and its contents in accordance with the terms and conditions under the www.cubalicores.com / cubalicores.com domain that may result from time to time of application, or that they do so diligently and prudently.'
	                                            })
	                                        ),
	                                        _react2.default.createElement(
	                                            Paragraph,
	                                            null,
	                                            _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                id: 'privacy-policy-subtitle5-text11',
	                                                defaultMessage: 'f. www.cubalicores.com / cubalicores.com and the collaborating companies of'
	                                            }),
	                                            ' ',
	                                            _react2.default.createElement(KatapulkStrongTag, null),
	                                            ' ',
	                                            _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                id: 'privacy-policy-subtitle5-text12'
	                                                // eslint-disable-next-line max-len
	                                                , defaultMessage: 'They do not have the obligation to verify, and they do not verify, the identity of the Users of this Web site; nor the veracity of the data that they provide about themselves or recipients.'
	                                            })
	                                        ),
	                                        _react2.default.createElement(
	                                            Paragraph,
	                                            null,
	                                            _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                id: 'privacy-policy-subtitle5-text13'
	                                                // eslint-disable-next-line max-len
	                                                , defaultMessage: 'g. The User accepts that the Website has been created and developed in good faith by www.cubalicores.com / cubalicores.com and the collaborating companies of'
	                                            }),
	                                            ' ',
	                                            _react2.default.createElement(KatapulkStrongTag, null),
	                                            ' ',
	                                            _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                id: 'privacy-policy-subtitle5-text14'
	                                                // eslint-disable-next-line max-len
	                                                , defaultMessage: 'with information from internal and external sources and offers it in its current state to Users, which may contain inaccuracies or errors, for which the User exonerates www.cubalicores.com / cubalicores.com and the collaborating companies of'
	                                            }),
	                                            ' ',
	                                            _react2.default.createElement(KatapulkStrongTag, null),
	                                            ' ',
	                                            _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                id: 'privacy-policy-subtitle5-text15',
	                                                defaultMessage: 'of any responsibility in relation to the reliability, usefulness or false expectations that the website may produce while browsing it'
	                                            })
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    _reactCollapsible2.default,
	                                    {
	                                        trigger: CollapseTitle(_react2.default.createElement(_reactIntl.FormattedMessage, {
	                                            id: 'privacy-policy-subtitle6',
	                                            defaultMessage: ' 6) Intellectual property'
	                                        }), 6),
	                                        onClose: function onClose() {
	                                            return _this2.setSelectedIndex(0);
	                                        },
	                                        onOpen: function onOpen() {
	                                            return _this2.setSelectedIndex(6);
	                                        },
	                                        transitionTime: 200
	                                    },
	                                    _react2.default.createElement(
	                                        'ul',
	                                        null,
	                                        _react2.default.createElement(
	                                            Paragraph,
	                                            null,
	                                            _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                id: 'privacy-policy-subtitle6-text1',
	                                                defaultMessage: 'a. All rights to the content of this website belong to www.cubalicores.com / cubalicores.com and the collaborating companies of'
	                                            }),
	                                            ' ',
	                                            _react2.default.createElement(KatapulkStrongTag, null),
	                                            ' ',
	                                            _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                id: 'privacy-policy-subtitle6-text2',
	                                                defaultMessage: '; except for those from companies with which you have signed the corresponding contract for the provision of content.'
	                                            })
	                                        ),
	                                        _react2.default.createElement(
	                                            Paragraph,
	                                            null,
	                                            _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                id: 'privacy-policy-subtitle6-text3'
	                                                // eslint-disable-next-line max-len
	                                                , defaultMessage: 'b. www.cubalicores.com / cubalicores.com does not transfer to the User of this website any ownership of their own software or third parties; the User is responsible for the medium in which the software is recorded, retaining www.cubalicores.com / cubalicores.com and the collaborating companies of'
	                                            }),
	                                            ' ',
	                                            _react2.default.createElement(KatapulkStrongTag, null),
	                                            ' ',
	                                            _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                id: 'privacy-policy-subtitle6-text4',
	                                                defaultMessage: 'all industrial and intellectual property rights including software that may correspond to it.'
	                                            })
	                                        ),
	                                        _react2.default.createElement(
	                                            Paragraph,
	                                            null,
	                                            _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                id: 'privacy-policy-subtitle6-text5'
	                                                // eslint-disable-next-line max-len
	                                                , defaultMessage: 'c. The design, images, maps, graphics, brands, labels, distinctive signs or logos of www.cubalicores.com / cubalicores.com, frames, banners, the software and its different source and object codes, etc., of this website are owned by de www.cubalicores.com / cubalicores.com and the collaborating companies of'
	                                            }),
	                                            ' ',
	                                            _react2.default.createElement(KatapulkStrongTag, null),
	                                            ' ',
	                                            _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                id: 'privacy-policy-subtitle6-text6',
	                                                defaultMessage: ', who legitimately and exclusively own the exploitation rights over them.'
	                                            })
	                                        ),
	                                        _react2.default.createElement(
	                                            Paragraph,
	                                            null,
	                                            _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                id: 'privacy-policy-subtitle6-text7'
	                                                // eslint-disable-next-line max-len
	                                                , defaultMessage: 'd. The logos or distinctive signs of the Group companies that may appear on this Website during the User\'s browsing are the property of each of them, legitimately having the exclusive rights of exploitation over them, expressly consenting to their incorporation, where appropriate, to this website.'
	                                            })
	                                        ),
	                                        _react2.default.createElement(
	                                            Paragraph,
	                                            null,
	                                            _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                id: 'privacy-policy-subtitle6-text8'
	                                                // eslint-disable-next-line max-len
	                                                , defaultMessage: 'e. The User who accesses this website may not copy, modify, distribute, transmit, reproduce, publish, assign or sell the aforementioned elements; nor create new products or services derived from the information obtained through this website.'
	                                            })
	                                        ),
	                                        _react2.default.createElement(
	                                            Paragraph,
	                                            null,
	                                            _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                id: 'privacy-policy-subtitle6-text9'
	                                                // eslint-disable-next-line max-len
	                                                , defaultMessage: 'f. Only viewing and uploading is authorized for the User\'s personal and non-commercial use, without being able to extend it to third parties or entities. In the case of graphics or designs that appear on this website owned by collaborating companies of www.cubalicores.com / cubalicores.com and collaborating companies of'
	                                            }),
	                                            ' ',
	                                            _react2.default.createElement(KatapulkStrongTag, null)
	                                        ),
	                                        _react2.default.createElement(
	                                            Paragraph,
	                                            null,
	                                            _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                id: 'privacy-policy-subtitle6-text10'
	                                                // eslint-disable-next-line max-len
	                                                , defaultMessage: 'g. Any alteration of this Website or its content by the User is strictly prohibited; as well as the installation of links (links or hyperlinks), links or similar not previously and expressly authorized by www.cubalicores.com / cubalicores.com and the collaborating companies of'
	                                            }),
	                                            ' ',
	                                            _react2.default.createElement(KatapulkStrongTag, null)
	                                        ),
	                                        _react2.default.createElement(
	                                            Paragraph,
	                                            null,
	                                            _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                id: 'privacy-policy-subtitle6-text11'
	                                                // eslint-disable-next-line max-len
	                                                , defaultMessage: 'h. www.cubalicores.com / cubalicores.com will ensure that the contents of this website are not pornographic, xenophobic, discriminatory, racist, defamatory, or promote any kind of violence.'
	                                            })
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    _reactCollapsible2.default,
	                                    {
	                                        trigger: CollapseTitle(_react2.default.createElement(_reactIntl.FormattedMessage, {
	                                            id: 'privacy-policy-subtitle7',
	                                            defaultMessage: ' 7) Protection of personal data. In compliance with current regulations for the protection of personal data of users,'
	                                        }), 7),
	                                        onClose: function onClose() {
	                                            return _this2.setSelectedIndex(0);
	                                        },
	                                        onOpen: function onOpen() {
	                                            return _this2.setSelectedIndex(7);
	                                        },
	                                        transitionTime: 200
	                                    },
	                                    _react2.default.createElement(
	                                        'ul',
	                                        null,
	                                        _react2.default.createElement(
	                                            Paragraph,
	                                            null,
	                                            _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                id: 'privacy-policy-subtitle7-text1',
	                                                defaultMessage: 'a. www.cubalicores.com / cubalicores.com and the collaborating companies of'
	                                            }),
	                                            ' ',
	                                            _react2.default.createElement(KatapulkStrongTag, null),
	                                            ' ',
	                                            _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                id: 'privacy-policy-subtitle7-text2'
	                                                // eslint-disable-next-line max-len
	                                                , defaultMessage: 'will respect, at all times, the provisions of current regulations on the protection of personal data; and guarantee the confidentiality of personal data. In compliance with current regulations on the protection of personal data, we inform you that the data provided will be processed by www.cubalicores.com / cubalicores.com and the collaborating companies of'
	                                            }),
	                                            ' ',
	                                            _react2.default.createElement(KatapulkStrongTag, null),
	                                            ' ',
	                                            _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                id: 'privacy-policy-subtitle7-text3',
	                                                defaultMessage: ', as of Responsible for the File.'
	                                            })
	                                        ),
	                                        _react2.default.createElement(
	                                            Paragraph,
	                                            null,
	                                            _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                id: 'privacy-policy-subtitle7-text4'
	                                                // eslint-disable-next-line max-len
	                                                , defaultMessage: 'b. The provision of personal data, own or of third parties, through the forms provided for this purpose on the www.cubalicores.com / cubalicores.com Website may only be made by persons of legal age.'
	                                            })
	                                        ),
	                                        _react2.default.createElement(
	                                            Paragraph,
	                                            null,
	                                            _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                id: 'privacy-policy-subtitle7-text5',
	                                                defaultMessage: 'c. The Group entities with access to the personal data of the Users of www.cubalicores.com / cubalicores.com are'
	                                            }),
	                                            ' ',
	                                            _react2.default.createElement(KatapulkStrongTag, null),
	                                            ' ',
	                                            _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                id: 'privacy-policy-subtitle7-text6',
	                                                defaultMessage: '(commerce),'
	                                            }),
	                                            ' ',
	                                            _react2.default.createElement(
	                                                'strong',
	                                                null,
	                                                'Fuego Enterprises, Inc. - OnCuba News / OnCuba Magazine'
	                                            ),
	                                            ' ',
	                                            _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                id: 'privacy-policy-subtitle7-text7',
	                                                defaultMessage: '(communications) and'
	                                            }),
	                                            ' ',
	                                            _react2.default.createElement(
	                                                'strong',
	                                                null,
	                                                'OnCuba Travel LLC'
	                                            ),
	                                            ' ',
	                                            _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                id: 'privacy-policy-subtitle7-text8',
	                                                defaultMessage: '(travel agency)'
	                                            })
	                                        ),
	                                        _react2.default.createElement(
	                                            Paragraph,
	                                            null,
	                                            _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                id: 'privacy-policy-subtitle7-text9',
	                                                defaultMessage: 'd. By accepting this Legal Information, the User authorizes www.cubalicores.com / cubalicores.com and the collaborating companies of'
	                                            }),
	                                            ' ',
	                                            _react2.default.createElement(KatapulkStrongTag, null),
	                                            ' ',
	                                            _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                id: 'privacy-policy-subtitle7-text10',
	                                                defaultMessage: 'and to all the Group companies to process the data provided on this website for any of the following purposes:'
	                                            }),
	                                            _react2.default.createElement(
	                                                'ul',
	                                                { style: { paddingLeft: 10 } },
	                                                _react2.default.createElement(
	                                                    'li',
	                                                    null,
	                                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                        id: 'privacy-policy-subtitle7-text10-1',
	                                                        defaultMessage: 'i. Manage the data to process your online purchase orders.'
	                                                    })
	                                                ),
	                                                _react2.default.createElement(
	                                                    'li',
	                                                    null,
	                                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                        id: 'privacy-policy-subtitle7-text10-2',
	                                                        defaultMessage: 'ii. Manage user participation in possible events and promotional actions'
	                                                    })
	                                                ),
	                                                _react2.default.createElement(
	                                                    'li',
	                                                    null,
	                                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                        id: 'privacy-policy-subtitle7-text10-3',
	                                                        defaultMessage: 'iii. Manage the selection processes of the'
	                                                    }),
	                                                    ' ',
	                                                    _react2.default.createElement(KatapulkStrongTag, null),
	                                                    ' ',
	                                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                        id: 'privacy-policy-subtitle7-text10-4',
	                                                        defaultMessage: 'and the Group companies'
	                                                    })
	                                                ),
	                                                _react2.default.createElement(
	                                                    'li',
	                                                    null,
	                                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                        id: 'privacy-policy-subtitle7-text10-5',
	                                                        defaultMessage: 'iv. Manage possible relationships between the User of the Website and www.cubalicores.com / cubalicores.com.'
	                                                    })
	                                                ),
	                                                _react2.default.createElement(
	                                                    'li',
	                                                    null,
	                                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                        id: 'privacy-policy-subtitle7-text10-6'
	                                                        // eslint-disable-next-line max-len
	                                                        , defaultMessage: 'v. Use the data to send the User of www.cubalicores.com / cubalicores.com to surveys and information and / or documentation of products and / or services requested by the User and / or marketed by www.cubalicores.com / cubalicores.com through various media, including electronic (email and telephony mobile).'
	                                                    })
	                                                ),
	                                                _react2.default.createElement(
	                                                    'li',
	                                                    null,
	                                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                        id: 'privacy-policy-subtitle7-text10-7'
	                                                        // eslint-disable-next-line max-len
	                                                        , defaultMessage: 'vi. The consent for the use of the User\'s data for the sending of commercial communications through electronic means (email or other current or future) may be revoked by the User at any moment in time, through the section "MY PROFILE” from the www.cubalicores.com / cubalicores.com Website'
	                                                    })
	                                                ),
	                                                _react2.default.createElement(
	                                                    'li',
	                                                    null,
	                                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                        id: 'privacy-policy-subtitle7-text10-8'
	                                                        // eslint-disable-next-line max-len
	                                                        , defaultMessage: 'vii. In any case, for the exercise of the rights of access, rectification, cancellation or opposition, an identified letter must be sent, in which the corresponding request is specified and accompanied by a photocopy of the Identity Card of the interested party, to the following address: C / BARBASTRO 4 1 A HUESCA 22002-HUESCA, Spain.'
	                                                    })
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            Paragraph,
	                                            null,
	                                            _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                id: 'privacy-policy-subtitle7-text11',
	                                                defaultMessage: 'e. When the User provides their data to www.cubalicores.com / cubalicores.com and the collaborating companies of'
	                                            }),
	                                            ' ',
	                                            _react2.default.createElement(KatapulkStrongTag, null),
	                                            ' ',
	                                            _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                id: 'privacy-policy-subtitle7-text12'
	                                                // eslint-disable-next-line max-len
	                                                , defaultMessage: ', through any of the forms on the Web, the User will be authorizing the aforementioned companies so that they can process your data in accordance with the purpose of the collection. The data provided will be part of a file, created under the responsibility of the company to which the User provides their data.'
	                                            })
	                                        ),
	                                        _react2.default.createElement(
	                                            Paragraph,
	                                            null,
	                                            _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                id: 'privacy-policy-subtitle7-text13'
	                                                // eslint-disable-next-line max-len
	                                                , defaultMessage: 'f. www.cubalicores.com / cubalicores.com informs the User of the existence on this website of links that allow access to different websites of certain entities of the Group, as well as to various organizations or third-party entities whose ownership is not of mercadounico .cubalicores.com / cubalicores.com or Group companies'
	                                            })
	                                        ),
	                                        _react2.default.createElement(
	                                            Paragraph,
	                                            null,
	                                            _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                id: 'privacy-policy-subtitle7-text14'
	                                                // eslint-disable-next-line max-len
	                                                , defaultMessage: 'g. The User may exercise the rights of access, rectification, cancellation and opposition at the address and before the person responsible for the file indicated in each specific case. In this way, www.cubalicores.com / cubalicores.com and the collaborating companies of'
	                                            }),
	                                            ' ',
	                                            _react2.default.createElement(KatapulkStrongTag, null),
	                                            ' ',
	                                            _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                id: 'privacy-policy-subtitle7-text15',
	                                                defaultMessage: 'aim to guarantee Users the right to information at the time the collection of data is carried out. your data.'
	                                            })
	                                        ),
	                                        _react2.default.createElement(
	                                            Paragraph,
	                                            null,
	                                            _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                id: 'privacy-policy-subtitle7-text16'
	                                                // eslint-disable-next-line max-len
	                                                , defaultMessage: 'h. The User will be solely responsible for filling in the forms with false, inaccurate, incomplete or outdated information. All the data provided by the User will be treated confidentially.'
	                                            })
	                                        ),
	                                        _react2.default.createElement(
	                                            Paragraph,
	                                            null,
	                                            _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                id: 'privacy-policy-subtitle7-text17',
	                                                defaultMessage: 'i. The company to which the User has been able to provide their data, may only transfer them.'
	                                            })
	                                        ),
	                                        _react2.default.createElement(
	                                            Paragraph,
	                                            null,
	                                            _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                id: 'privacy-policy-subtitle7-text18',
	                                                defaultMessage: 'j. Part of the services of www.cubalicores.com / cubalicores.com use "cookies". For more information, see our cookie policy.'
	                                            })
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    _reactCollapsible2.default,
	                                    {
	                                        trigger: CollapseTitle(_react2.default.createElement(_reactIntl.FormattedMessage, {
	                                            id: 'privacy-policy-subtitle8',
	                                            defaultMessage: ' 8) Links'
	                                        }), 8),
	                                        onClose: function onClose() {
	                                            return _this2.setSelectedIndex(0);
	                                        },
	                                        onOpen: function onOpen() {
	                                            return _this2.setSelectedIndex(8);
	                                        },
	                                        transitionTime: 200
	                                    },
	                                    _react2.default.createElement(
	                                        'ul',
	                                        null,
	                                        _react2.default.createElement(
	                                            Paragraph,
	                                            null,
	                                            _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                id: 'privacy-policy-subtitle8-text1',
	                                                defaultMessage: 'a. Without the express consent of www.cubalicores.com / cubalicores.com and the collaborating companies of'
	                                            }),
	                                            ' ',
	                                            _react2.default.createElement(KatapulkStrongTag, null),
	                                            _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                id: 'privacy-policy-subtitle8-text2',
	                                                defaultMessage: ', no link to this website can be established from any other website.'
	                                            })
	                                        ),
	                                        _react2.default.createElement(
	                                            Paragraph,
	                                            null,
	                                            _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                id: 'privacy-policy-subtitle8-text3',
	                                                defaultMessage: 'b. If the website had links to other portals, not managed by'
	                                            }),
	                                            ' ',
	                                            _react2.default.createElement(KatapulkStrongTag, null),
	                                            _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                id: 'privacy-policy-subtitle8-text4'
	                                                // eslint-disable-next-line max-len
	                                                , defaultMessage: ', all responsibility on the part of the company regarding the control and responsibility of the products or services offered is excluded, as well as the contents and owners.'
	                                            })
	                                        ),
	                                        _react2.default.createElement(
	                                            Paragraph,
	                                            null,
	                                            'c.',
	                                            ' ',
	                                            _react2.default.createElement(KatapulkStrongTag, null),
	                                            _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                id: 'privacy-policy-subtitle8-text5'
	                                                // eslint-disable-next-line max-len
	                                                , defaultMessage: ', are exonerated of all responsibility in relation to the contents and services provided by third parties against any claim of any nature and lawsuits that may be filed in relation to them.'
	                                            })
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    _reactCollapsible2.default,
	                                    {
	                                        trigger: CollapseTitle(_react2.default.createElement(_reactIntl.FormattedMessage, {
	                                            id: 'privacy-policy-subtitle9',
	                                            defaultMessage: ' 9) Nullity and ineffectiveness of the clauses'
	                                        }), 9),
	                                        onClose: function onClose() {
	                                            return _this2.setSelectedIndex(0);
	                                        },
	                                        onOpen: function onOpen() {
	                                            return _this2.setSelectedIndex(9);
	                                        },
	                                        transitionTime: 200
	                                    },
	                                    _react2.default.createElement(
	                                        'ul',
	                                        null,
	                                        _react2.default.createElement(
	                                            Paragraph,
	                                            null,
	                                            _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                id: 'privacy-policy-subtitle9-text1'
	                                                // eslint-disable-next-line max-len
	                                                , defaultMessage: 'a. If it were the case that any content of these terms and conditions was declared null or ineffective, it will only affect the indicated content or part of it.'
	                                            })
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    _reactCollapsible2.default,
	                                    {
	                                        trigger: CollapseTitle(_react2.default.createElement(_reactIntl.FormattedMessage, {
	                                            id: 'privacy-policy-subtitle10',
	                                            defaultMessage: '10) Applicable law and jurisdiction'
	                                        }), 10),
	                                        onClose: function onClose() {
	                                            return _this2.setSelectedIndex(0);
	                                        },
	                                        onOpen: function onOpen() {
	                                            return _this2.setSelectedIndex(10);
	                                        },
	                                        transitionTime: 200
	                                    },
	                                    _react2.default.createElement(
	                                        'ul',
	                                        null,
	                                        _react2.default.createElement(
	                                            Paragraph,
	                                            null,
	                                            _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                id: 'privacy-policy-subtitle10-text1',
	                                                defaultMessage: 'a. The Terms and Conditions of this website will be governed by Spanish legislation.'
	                                            })
	                                        ),
	                                        _react2.default.createElement(
	                                            Paragraph,
	                                            null,
	                                            _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                id: 'privacy-policy-subtitle10-text2'
	                                                // eslint-disable-next-line max-len
	                                                , defaultMessage: 'b. In the event that any User or affected third party considers that there are facts or circumstances that reveal the illicit nature, they must send a communication containing the following points:'
	                                            }),
	                                            _react2.default.createElement(
	                                                'ul',
	                                                { style: { paddingLeft: 10 } },
	                                                _react2.default.createElement(
	                                                    'li',
	                                                    null,
	                                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                        id: 'privacy-policy-subtitle10-text2-1',
	                                                        defaultMessage: 'i. Complete personal data of the claimant: Name, surname, address, telephone number and email address.'
	                                                    })
	                                                ),
	                                                _react2.default.createElement(
	                                                    'li',
	                                                    null,
	                                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                        id: 'privacy-policy-subtitle10-text2-2'
	                                                        // eslint-disable-next-line max-len
	                                                        , defaultMessage: 'ii. Specification, in detail, of the following points: What is the alleged illegal content or illegality of the use of the content. If you are the owner of the illegally used content.'
	                                                    })
	                                                ),
	                                                _react2.default.createElement(
	                                                    'li',
	                                                    null,
	                                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                        id: 'privacy-policy-subtitle10-text2-3'
	                                                        // eslint-disable-next-line max-len
	                                                        , defaultMessage: 'iii. In the case of an alleged injury to property or rights susceptible to compensation, precise and concrete indication of the protected content, as well as its location on the Web.'
	                                                    })
	                                                ),
	                                                _react2.default.createElement(
	                                                    'li',
	                                                    null,
	                                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                        id: 'privacy-policy-subtitle10-text2-4',
	                                                        defaultMessage: 'iv. The claimant must send by post to'
	                                                    }),
	                                                    ' ',
	                                                    _react2.default.createElement(
	                                                        'strong',
	                                                        null,
	                                                        'Othar Trade & Logistics Spain.'
	                                                    ),
	                                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                        id: 'privacy-policy-subtitle10-text2-5',
	                                                        defaultMessage: ', located at C / BARBASTRO 4 1 A HUESCA 22002-HUESCA, Spain the following documentation:'
	                                                    }),
	                                                    _react2.default.createElement(
	                                                        'ul',
	                                                        { style: { paddingLeft: 10 } },
	                                                        _react2.default.createElement(
	                                                            'li',
	                                                            null,
	                                                            _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                                id: 'privacy-policy-subtitle10-text2-5.1'
	                                                                // eslint-disable-next-line max-len
	                                                                , defaultMessage: '1. Communication signed by hand, from the owner of the rights allegedly infringed or from the person authorized to act on her behalf and on her behalf, which is accompanied by documentation proving the ownership of the property or right allegedly injured, in which it refers precisely the data of the Web page, content, or hyperlink object of complaint.'
	                                                            })
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'li',
	                                                            null,
	                                                            _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                                id: 'privacy-policy-subtitle10-text2-5.2'
	                                                                // eslint-disable-next-line max-len
	                                                                , defaultMessage: '2. In case of not being the holder of the right or injured, a sworn statement, express, clear and under the responsibility of the claimant that the information provided in the online notification is accurate and that the content or activity referred to is illegal. The document must be signed by hand and accompany a copy of the Identity Card or equivalent identification document.'
	                                                            })
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'li',
	                                                            null,
	                                                            _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                                id: 'privacy-policy-subtitle10-text2-5.3'
	                                                                // eslint-disable-next-line max-len
	                                                                , defaultMessage: '3. ANONYMOUS COMMUNICATIONS WILL NOT BE ADMITTED AS SUFFICIENT NOTICE TO BRING KNOWLEDGE of www.cubalicores.com / cubalicores.com and the collaborating companies of'
	                                                            }),
	                                                            ' ',
	                                                            _react2.default.createElement(KatapulkStrongTag, null),
	                                                            ' ',
	                                                            _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                                id: 'privacy-policy-subtitle10-text2-5.4',
	                                                                defaultMessage: 'THE ILLEGALITY OF CONTENTS OR ACTIVITIES.'
	                                                            })
	                                                        )
	                                                    )
	                                                )
	                                            )
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'p',
	                                    { className: 'text-justify', style: { paddingTop: 10 } },
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: 'privacy-policy-copyright-text1',
	                                        defaultMessage: 'privacy policy copyright'
	                                    }),
	                                    ' ',
	                                    _react2.default.createElement(KatapulkStrongTag, null),
	                                    ' ',
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: 'privacy-policy-copyright-text2',
	                                        defaultMessage: 'Forbidden the total or partial reproduction.'
	                                    })
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return PrivacyPolicy;
	}(_react.Component);
	
	exports.default = (0, _reactIntl.injectIntl)(PrivacyPolicy);

/***/ },
/* 701 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(11);
	
	var _layout = __webpack_require__(29);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _productList = __webpack_require__(603);
	
	var _productList2 = _interopRequireDefault(_productList);
	
	var _loading = __webpack_require__(118);
	
	var _loading2 = _interopRequireDefault(_loading);
	
	var _productList3 = __webpack_require__(243);
	
	var _productList4 = _interopRequireDefault(_productList3);
	
	var _appRoutes = __webpack_require__(22);
	
	var _appRoutes2 = _interopRequireDefault(_appRoutes);
	
	var _signupPromotion = __webpack_require__(75);
	
	var _signupPromotion2 = _interopRequireDefault(_signupPromotion);
	
	var _secondaryMenuConnector = __webpack_require__(178);
	
	var _secondaryMenuConnector2 = _interopRequireDefault(_secondaryMenuConnector);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ProductListPage = function (_Component) {
	    _inherits(ProductListPage, _Component);
	
	    function ProductListPage(props) {
	        _classCallCheck(this, ProductListPage);
	
	        var _this = _possibleConstructorReturn(this, (ProductListPage.__proto__ || Object.getPrototypeOf(ProductListPage)).call(this, props));
	
	        document.title = _this.props.intl.formatMessage({ id: 'product-list', defaultMessage: 'List of products' });
	        return _this;
	    }
	
	    _createClass(ProductListPage, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var query = new URLSearchParams(this.props.location.search);
	            var params = {};
	            // eslint-disable-next-line no-restricted-syntax
	            var _iteratorNormalCompletion = true;
	            var _didIteratorError = false;
	            var _iteratorError = undefined;
	
	            try {
	                for (var _iterator = query.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                    var _ref3 = _step.value;
	
	                    var _ref2 = _slicedToArray(_ref3, 2);
	
	                    var param0 = _ref2[0];
	                    var param1 = _ref2[1];
	
	                    params[param0] = param1;
	                }
	            } catch (err) {
	                _didIteratorError = true;
	                _iteratorError = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion && _iterator.return) {
	                        _iterator.return();
	                    }
	                } finally {
	                    if (_didIteratorError) {
	                        throw _iteratorError;
	                    }
	                }
	            }
	
	            this.props.loadStores(this.props.locale.currentLocale, this.props.currentStore);
	        }
	
	        /* If home page icon is clicked. */
	
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps, prevState) {
	            if (prevProps.location.pathname !== this.props.location.pathname || prevProps.locale.currentLocale !== this.props.locale.currentLocale || prevProps.location.search !== this.props.location.search) {
	                var query = new URLSearchParams(this.props.location.search);
	                var params = {};
	
	                // eslint-disable-next-line no-restricted-syntax
	                var _iteratorNormalCompletion2 = true;
	                var _didIteratorError2 = false;
	                var _iteratorError2 = undefined;
	
	                try {
	                    for (var _iterator2 = query.entries()[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	                        var _ref6 = _step2.value;
	
	                        var _ref5 = _slicedToArray(_ref6, 2);
	
	                        var param0 = _ref5[0];
	                        var param1 = _ref5[1];
	
	                        params[param0] = param1;
	                    }
	                } catch (err) {
	                    _didIteratorError2 = true;
	                    _iteratorError2 = err;
	                } finally {
	                    try {
	                        if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                            _iterator2.return();
	                        }
	                    } finally {
	                        if (_didIteratorError2) {
	                            throw _iteratorError2;
	                        }
	                    }
	                }
	
	                this.props.triggerInitialSetup(this.props.locale.currentLocale);
	            }
	            if (this.props.locale !== prevProps.locale) {
	                document.title = this.props.intl.formatMessage({ id: 'product-list', defaultMessage: 'List of products' });
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                _layout2.default,
	                { notShowMarginBottom: true },
	                _react2.default.createElement(
	                    'div',
	                    { className: _productList2.default.productList },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'container body-container ' + _productList2.default.bodyContainer },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'row' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-lg-3 col-md-3 col-sm-4 col-xs-12 ' + _productList2.default.colFilters },
	                                _react2.default.createElement(_secondaryMenuConnector2.default, { location: this.props.location, path: _appRoutes2.default.searchPageRoute })
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-lg-9 col-md-9 col-sm-8 col-xs-12' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: '' + _productList2.default.contentCategory },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'row' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'col-lg-12 col-md-12 col-sm-12 col-xs-12' },
	                                            !this.props.displayLoader && _react2.default.createElement(
	                                                'label',
	                                                { className: '' + _productList2.default.titleSection },
	                                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'our', defaultMessage: 'Our' }),
	                                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'recommendations', defaultMessage: 'recommendations' })
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'row no-margin' },
	                                        this.props.displayLoader && _react2.default.createElement(
	                                            'div',
	                                            { className: 'col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center' },
	                                            _react2.default.createElement(
	                                                'div',
	                                                null,
	                                                _react2.default.createElement(
	                                                    'h4',
	                                                    { className: _productList2.default.loadingText },
	                                                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'loading-recommendations', defaultMessage: 'Loading recommendations' }),
	                                                    _react2.default.createElement(
	                                                        'span',
	                                                        { className: 'hidden-xs' },
	                                                        ', ',
	                                                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'please-wait', defaultMessage: 'please wait' })
	                                                    ),
	                                                    '...'
	                                                ),
	                                                _react2.default.createElement('div', { className: _loading2.default.spinnerDark })
	                                            )
	                                        ),
	                                        !this.props.displayLoader && _react2.default.createElement(_productList4.default, {
	                                            products: this.props.products,
	                                            loadMoreProducts: this.props.loadMoreProducts,
	                                            pageCount: this.props.pageCount,
	                                            searchTerm: this.props.location.pathname,
	                                            locale: this.props.locale
	                                        })
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ProductListPage;
	}(_react.Component);
	
	exports.default = (0, _reactIntl.injectIntl)(ProductListPage);

/***/ },
/* 702 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(41);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(11);
	
	var _reactRouterDom = __webpack_require__(26);
	
	var _layout = __webpack_require__(29);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _comingSoon = __webpack_require__(171);
	
	var _comingSoon2 = _interopRequireDefault(_comingSoon);
	
	var _appRoutes = __webpack_require__(22);
	
	var _appRoutes2 = _interopRequireDefault(_appRoutes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RegisterConfirmation = function (_Component) {
	    _inherits(RegisterConfirmation, _Component);
	
	    function RegisterConfirmation(props) {
	        _classCallCheck(this, RegisterConfirmation);
	
	        var _this = _possibleConstructorReturn(this, (RegisterConfirmation.__proto__ || Object.getPrototypeOf(RegisterConfirmation)).call(this, props));
	
	        _this.state = {
	            registered: false,
	            loading: true,
	            message: ''
	        };
	
	        document.title = _this.props.intl.formatMessage({ id: 'register-confirmation', defaultMessage: 'Confirmation of registration' });
	        return _this;
	    }
	
	    _createClass(RegisterConfirmation, [{
	        key: 'componentDidMount',
	        value: function () {
	            var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	                var _this2 = this;
	
	                var token;
	                return _regenerator2.default.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                token = this.props.match.params.token;
	
	                                this.props.checkregistration(token, this.props.locale).then(function () {
	                                    _this2.setState({
	                                        registered: true,
	                                        loading: false,
	                                        message: ''
	                                    });
	                                }).catch(function (error) {
	                                    _this2.setState({
	                                        loading: false,
	                                        message: error.response.body.error
	                                    });
	                                });
	
	                            case 2:
	                            case 'end':
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this);
	            }));
	
	            function componentDidMount() {
	                return _ref.apply(this, arguments);
	            }
	
	            return componentDidMount;
	        }()
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps) {
	            if (this.props.locale !== prevProps.locale) {
	                document.title = this.props.intl.formatMessage({ id: 'register-confirmation', defaultMessage: 'Confirmation of registration' });
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var registered = this.state.registered;
	
	            var registerMessage = _react2.default.createElement(
	                'div',
	                {
	                    className: _comingSoon2.default.comingContainer
	                },
	                _react2.default.createElement(
	                    'h1',
	                    {
	                        className: _comingSoon2.default.mainText
	                    },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                        id: 'registed-message',
	                        defaultMessage: 'You have successfully registered'
	                    })
	                ),
	                _react2.default.createElement(
	                    _reactRouterDom.Link,
	                    {
	                        to: _appRoutes2.default.mercadoUnicoProducts,
	                        className: _comingSoon2.default.buttonLink
	                    },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                        id: 'coming-soon-button',
	                        defaultMessage: 'See Mercado Unico Products'
	                    })
	                ),
	                _react2.default.createElement(
	                    _reactRouterDom.Link,
	                    {
	                        to: _appRoutes2.default.signin,
	                        className: _comingSoon2.default.buttonLink
	                    },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                        id: 'signin',
	                        defaultMessage: 'Sign In'
	                    })
	                )
	            );
	            var unregisterMessage = _react2.default.createElement(
	                'div',
	                {
	                    className: _comingSoon2.default.comingContainer
	                },
	                _react2.default.createElement(
	                    'h1',
	                    {
	                        className: _comingSoon2.default.mainText
	                    },
	                    this.state.message
	                )
	            );
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                this.state.loading ? _react2.default.createElement('p', null) : _react2.default.createElement(
	                    _layout2.default,
	                    null,
	                    registered ? registerMessage : unregisterMessage
	                )
	            );
	        }
	    }]);
	
	    return RegisterConfirmation;
	}(_react.Component);
	
	exports.default = (0, _reactIntl.injectIntl)(RegisterConfirmation);

/***/ },
/* 703 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(11);
	
	var _layout = __webpack_require__(29);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _returnPolicy = __webpack_require__(2167);
	
	var _returnPolicy2 = _interopRequireDefault(_returnPolicy);
	
	var _signupPromotion = __webpack_require__(75);
	
	var _signupPromotion2 = _interopRequireDefault(_signupPromotion);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ReturnPolicy = function (_Component) {
	    _inherits(ReturnPolicy, _Component);
	
	    function ReturnPolicy(props) {
	        _classCallCheck(this, ReturnPolicy);
	
	        var _this = _possibleConstructorReturn(this, (ReturnPolicy.__proto__ || Object.getPrototypeOf(ReturnPolicy)).call(this, props));
	
	        document.title = _this.props.intl.formatMessage({ id: 'return-policy-title' });
	        return _this;
	    }
	
	    _createClass(ReturnPolicy, [{
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps) {
	            if (this.props.locale !== prevProps.locale) {
	                document.title = this.props.intl.formatMessage({ id: 'return-policy-title' });
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var Paragraph = function Paragraph(props) {
	                return _react2.default.createElement(
	                    'div',
	                    { className: 'text-justify', style: _extends({ paddingBottom: 10 }, props.style) },
	                    props.children
	                );
	            };
	
	            return _react2.default.createElement(
	                _layout2.default,
	                { notShowMarginBottom: true },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'container' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                            'h4',
	                            { className: _returnPolicy2.default.mainText },
	                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'return-policy-title', defaultMessage: '' })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: _returnPolicy2.default.privacyBackround },
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    null,
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'return-policy-text1', defaultMessage: '' })
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    null,
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: 'return-policy-text2',
	                                        defaultMessage: ''
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    null,
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: 'return-policy-text3',
	                                        defaultMessage: ''
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    null,
	                                    _react2.default.createElement(
	                                        'strong',
	                                        { className: _returnPolicy2.default.subtitle },
	                                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'return-policy-subtitle1', defaultMessage: '' })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    null,
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: 'return-policy-subtitle1-text1',
	                                        defaultMessage: ''
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    null,
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: 'return-policy-subtitle1-text2',
	                                        defaultMessage: ''
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    null,
	                                    _react2.default.createElement(
	                                        'strong',
	                                        { className: _returnPolicy2.default.subtitle },
	                                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'return-policy-subtitle2', defaultMessage: '' })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    null,
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: 'return-policy-subtitle2-text1',
	                                        defaultMessage: ''
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    null,
	                                    _react2.default.createElement(
	                                        'strong',
	                                        { className: _returnPolicy2.default.subtitle },
	                                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'return-policy-subtitle3', defaultMessage: '' })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    null,
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: 'return-policy-subtitle3-text1',
	                                        defaultMessage: ''
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    null,
	                                    _react2.default.createElement(
	                                        'strong',
	                                        { className: _returnPolicy2.default.subtitle },
	                                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'return-policy-subtitle4', defaultMessage: '' })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    null,
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: 'return-policy-subtitle4-text1',
	                                        defaultMessage: ''
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    null,
	                                    _react2.default.createElement(
	                                        'strong',
	                                        { className: _returnPolicy2.default.subtitle },
	                                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'return-policy-subtitle5', defaultMessage: '' })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    null,
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: 'return-policy-subtitle5-text1',
	                                        defaultMessage: ''
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    null,
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: 'return-policy-subtitle5-text2',
	                                        defaultMessage: ''
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    null,
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: 'return-policy-subtitle5-text3',
	                                        defaultMessage: ''
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    null,
	                                    _react2.default.createElement(
	                                        'strong',
	                                        { className: _returnPolicy2.default.subtitle },
	                                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'return-policy-subtitle6', defaultMessage: '' })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    { style: { paddingLeft: 10 } },
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: 'return-policy-subtitle6-text1',
	                                        defaultMessage: ''
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    { style: { paddingLeft: 10 } },
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: 'return-policy-subtitle6-text2',
	                                        defaultMessage: ''
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    { style: { paddingLeft: 10 } },
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: 'return-policy-subtitle6-text3',
	                                        defaultMessage: ''
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    { style: { paddingLeft: 10 } },
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: 'return-policy-subtitle6-text4',
	                                        defaultMessage: ''
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    { style: { paddingLeft: 10 } },
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: 'return-policy-subtitle6-text5',
	                                        defaultMessage: ''
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    { style: { paddingLeft: 10 } },
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: 'return-policy-subtitle6-text6',
	                                        defaultMessage: ''
	                                    })
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ReturnPolicy;
	}(_react.Component);
	
	exports.default = (0, _reactIntl.injectIntl)(ReturnPolicy);

/***/ },
/* 704 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxForm = __webpack_require__(61);
	
	var _reactIntl = __webpack_require__(11);
	
	var _reactRouterDom = __webpack_require__(26);
	
	var _reactRouterRedux = __webpack_require__(30);
	
	var _layout = __webpack_require__(29);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _appRoutes = __webpack_require__(22);
	
	var _appRoutes2 = _interopRequireDefault(_appRoutes);
	
	var _signin = __webpack_require__(138);
	
	var _signin2 = _interopRequireDefault(_signin);
	
	var _comingSoon = __webpack_require__(171);
	
	var _comingSoon2 = _interopRequireDefault(_comingSoon);
	
	var _forgotPassword = __webpack_require__(1615);
	
	var _forgotPassword2 = _interopRequireDefault(_forgotPassword);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SendEmail = function (_Component) {
	    _inherits(SendEmail, _Component);
	
	    function SendEmail(props) {
	        _classCallCheck(this, SendEmail);
	
	        var _this = _possibleConstructorReturn(this, (SendEmail.__proto__ || Object.getPrototypeOf(SendEmail)).call(this, props));
	
	        _this.state = {
	            sentEmail: false
	        };
	
	        _this.handleFormSubmit = _this.handleFormSubmit.bind(_this);
	
	        document.title = _this.props.intl.formatMessage({ id: 'forgot-password', defaultMessage: 'Forgot Passowrd' });
	        return _this;
	    }
	
	    _createClass(SendEmail, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            // Redirect to home if is authenticated
	            if (this.props.user && this.props.user.id) {
	                this.props.dispatch((0, _reactRouterRedux.push)(_appRoutes2.default.homePageRoute));
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps) {
	            if (this.props.locale !== prevProps.locale) {
	                document.title = this.props.intl.formatMessage({ id: 'forgot-password', defaultMessage: 'Forgot Password' });
	            }
	        }
	    }, {
	        key: 'handleFormSubmit',
	        value: function handleFormSubmit(formData) {
	            var _this2 = this;
	
	            this.props.submitEmailForm(formData, this.props.locale.currentLocale).then(function (resp) {
	                if (resp) {
	                    _this2.setState({ sentEmail: true });
	                }
	            }, function () {});
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props;
	            var handleSubmit = _props.handleSubmit;
	            var valid = _props.valid;
	            var submitting = _props.submitting;
	            var intl = _props.intl;
	            var sentEmail = this.state.sentEmail;
	
	            var sentEmailMessage = _react2.default.createElement(
	                'div',
	                { className: _comingSoon2.default.comingContainer },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'text-center', style: { paddingBottom: 45 } },
	                    _react2.default.createElement('img', {
	                        style: { maxWidth: '35%', height: 'auto' },
	                        src: _forgotPassword2.default,
	                        alt: this.props.intl.formatMessage({
	                            id: 'not-found',
	                            defaultMessage: 'Not'
	                        })
	                    })
	                ),
	                _react2.default.createElement(
	                    'h2',
	                    { className: _comingSoon2.default.mainText, style: { paddingBottom: 10 } },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'send-email-success-1', defaultMessage: '' })
	                ),
	                _react2.default.createElement(
	                    'h2',
	                    { className: _comingSoon2.default.mainText, style: { paddingBottom: 10 } },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'send-email-success-2', defaultMessage: '' })
	                )
	            );
	
	            var emailForm = _react2.default.createElement(
	                'main',
	                { className: 'content ' + _signin2.default.signin },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'container ' + _signin2.default.bodyContainer },
	                    _react2.default.createElement(
	                        'section',
	                        null,
	                        _react2.default.createElement(
	                            'p',
	                            { className: _signin2.default.titlePage },
	                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'forgot-password', defaultMessage: 'Forgot Password' })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'row' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-lg-offset-4 col-lg-4 col-md-4 col-md-offset-4 col-sm-offset-3 col-sm-6 col-xs-12' },
	                                _react2.default.createElement(
	                                    'form',
	                                    { className: _signin2.default.form, onSubmit: handleSubmit(this.handleFormSubmit) },
	                                    _react2.default.createElement(
	                                        'div',
	                                        null,
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'form-group ' + _signin2.default.formGroup },
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'col-lg-12 col-md-12 col-sm-12 col-xs-12 holder' },
	                                                _react2.default.createElement(_reduxForm.Field, {
	                                                    className: _signin2.default.formInput,
	                                                    name: 'user[email]',
	                                                    component: 'input',
	                                                    type: 'text',
	                                                    autoComplete: 'off',
	                                                    placeholder: intl.formatMessage({
	                                                        id: 'email-address',
	                                                        defaultMessage: 'Email Address'
	                                                    })
	                                                })
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'form-group ' + _signin2.default.formGroupHolder },
	                                        _react2.default.createElement(
	                                            'button',
	                                            { className: 'form-control btn btn-default', type: 'submit', disabled: !valid || submitting },
	                                            _react2.default.createElement(
	                                                'span',
	                                                null,
	                                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'send', defaultMessage: 'Send' })
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	
	            return _react2.default.createElement(
	                _layout2.default,
	                null,
	                sentEmail ? sentEmailMessage : emailForm
	            );
	        }
	    }]);
	
	    return SendEmail;
	}(_react.Component);
	
	SendEmail = (0, _reduxForm.reduxForm)({
	    form: 'sendEmail'
	})(SendEmail);
	
	exports.default = (0, _reactIntl.injectIntl)(SendEmail);

/***/ },
/* 705 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(11);
	
	var _layout = __webpack_require__(29);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _shippingPolicy = __webpack_require__(2168);
	
	var _shippingPolicy2 = _interopRequireDefault(_shippingPolicy);
	
	var _signupPromotion = __webpack_require__(75);
	
	var _signupPromotion2 = _interopRequireDefault(_signupPromotion);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable */
	
	
	var deliveryRatesByLocation = [[{ location: 'Pinar del Río', price: '$n/a' }, { location: 'Camagüey', price: '$n/a' }], [{ location: 'Artemisa', price: '$n/a' }, { location: 'Ciego de Ávila', price: '$n/a' }], [{ location: 'La Habana', price: '$8.00' }, { location: 'Las Tunas', price: '$n/a' }], [{ location: 'Mayabeque', price: '$n/a' }, { location: 'Holguín', price: '$n/a' }], [{ location: 'Matanzas', price: '$n/a' }, { location: 'Granma', price: '$n/a' }], [{ location: 'Cienfuegos', price: '$n/a' }, { location: 'Santiago de Cuba', price: '$n/a' }], [{ location: 'Villa Clara', price: '$n/a' }, { location: 'Guantánamo', price: '$n/a' }], [{ location: 'Sancti Spíritus', price: '$n/a' }]];
	
	var UP_TO_7_DAYS = _react2.default.createElement(
	    'span',
	    { style: { textTransform: 'uppercase' } },
	    _react2.default.createElement(_reactIntl.FormattedMessage, {
	        id: 'shippingPolicy.subtitle3.table.text2.7',
	        defaultMessage: 'up to 7 business days'
	    }),
	    ' ',
	    '(*)'
	);
	var NOT_AVAILABLE = _react2.default.createElement(
	    'span',
	    null,
	    _react2.default.createElement(_reactIntl.FormattedMessage, {
	        id: 'attention-not-available',
	        defaultMessage: 'ATTENTION. NOT AVAILABLE'
	    })
	);
	var deliveryTimeByDestination = [{
	    destination: 'LA HABANA',
	    content: UP_TO_7_DAYS
	}, {
	    destination: 'ARTEMISA',
	    content: NOT_AVAILABLE
	}, {
	    destination: 'MAYABEQUE',
	    content: NOT_AVAILABLE
	}, {
	    destination: 'PINAR DEL RIO',
	    content: NOT_AVAILABLE
	}, {
	    destination: 'MATANZAS',
	    content: NOT_AVAILABLE
	}, {
	    destination: 'VILLA CLARA',
	    content: NOT_AVAILABLE
	}, {
	    destination: 'CIEGO DE ÁVILA',
	    content: NOT_AVAILABLE
	}, {
	    destination: 'CIENFUEGOS',
	    content: NOT_AVAILABLE
	}, {
	    destination: 'LAS TUNAS',
	    content: NOT_AVAILABLE
	}, {
	    destination: 'HOLGUÍN',
	    content: NOT_AVAILABLE
	}, {
	    destination: 'CAMAGÜEY',
	    content: NOT_AVAILABLE
	}, {
	    destination: 'SANCTI SPIRITUS',
	    content: NOT_AVAILABLE
	}, {
	    destination: 'GRANMA',
	    content: NOT_AVAILABLE
	}, {
	    destination: 'SANTIAGO DE CUBA',
	    content: NOT_AVAILABLE
	}, {
	    destination: 'GUANTÁNAMO',
	    content: NOT_AVAILABLE
	}];
	
	var ShippingPolicy = function (_Component) {
	    _inherits(ShippingPolicy, _Component);
	
	    function ShippingPolicy(props) {
	        _classCallCheck(this, ShippingPolicy);
	
	        var _this = _possibleConstructorReturn(this, (ShippingPolicy.__proto__ || Object.getPrototypeOf(ShippingPolicy)).call(this, props));
	
	        document.title = _this.props.intl.formatMessage({ id: 'shippingPolicy.title', defaultMessage: 'DELIVERY POLICY AND RATES' });
	        return _this;
	    }
	
	    _createClass(ShippingPolicy, [{
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps) {
	            if (this.props.locale !== prevProps.locale) {
	                document.title = this.props.intl.formatMessage({ id: 'shippingPolicy.title', defaultMessage: 'DELIVERY POLICY AND RATES' });
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var Paragraph = function Paragraph(props) {
	                return _react2.default.createElement(
	                    'div',
	                    { className: 'text-justify', style: _extends({ paddingBottom: 10 }, props.style) },
	                    props.children
	                );
	            };
	
	            return _react2.default.createElement(
	                _layout2.default,
	                { notShowMarginBottom: true },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'container' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                            'h4',
	                            { className: _shippingPolicy2.default.mainText },
	                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'shippingPolicy.title', defaultMessage: 'DELIVERY POLICY AND RATES' })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: _shippingPolicy2.default.privacyBackround },
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    null,
	                                    _react2.default.createElement(
	                                        'strong',
	                                        { className: _shippingPolicy2.default.subtitle },
	                                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'shippingPolicy.subtitle1', defaultMessage: 'Important information about shipments' })
	                                    )
	                                ),
	                                _react2.default.createElement(_reactIntl.FormattedHTMLMessage, { id: 'shipping-policy__important-info-about-delivery' }),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    null,
	                                    _react2.default.createElement(
	                                        'strong',
	                                        { className: _shippingPolicy2.default.subtitle },
	                                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'shippingPolicy.subtitle2', defaultMessage: 'Delivery conditions:' })
	                                    )
	                                ),
	                                _react2.default.createElement(_reactIntl.FormattedHTMLMessage, { id: 'shipping-policy__delivery-conditions' }),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    null,
	                                    _react2.default.createElement(
	                                        'strong',
	                                        null,
	                                        _react2.default.createElement(_reactIntl.FormattedHTMLMessage, { id: 'shippingPolicy.subtitle2.subtitle1', defaultMessage: 'Shipping and handling fees' })
	                                    ),
	                                    _react2.default.createElement(
	                                        Paragraph,
	                                        { style: { paddingBottom: 0, paddingTop: 10 } },
	                                        _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                            id: 'shippingPolicy.subtitle.ArtMay',
	                                            defaultMessage: 'Shipment to Havana, Artemisa, Mayabeque, Pinar del Rio, Matanzas, Ciego de \xC1vila, Las Tunas, Holgu\xEDn and Santiago de Cuba'
	                                        })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    null,
	                                    _react2.default.createElement(
	                                        'strong',
	                                        { className: _shippingPolicy2.default.subtitle },
	                                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'shippingPolicy.subtitle4', defaultMessage: 'Delivery rates by destinations:' })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: _shippingPolicy2.default.tableResponsive },
	                                    _react2.default.createElement(
	                                        'table',
	                                        { className: 'table table-bordered' },
	                                        _react2.default.createElement(
	                                            'thead',
	                                            null,
	                                            _react2.default.createElement(
	                                                'tr',
	                                                null,
	                                                _react2.default.createElement(
	                                                    'th',
	                                                    { scope: 'col' },
	                                                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'location', defaultMessage: 'Location' })
	                                                ),
	                                                _react2.default.createElement(
	                                                    'th',
	                                                    { scope: 'col' },
	                                                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'price', defaultMessage: 'Price' })
	                                                ),
	                                                _react2.default.createElement(
	                                                    'th',
	                                                    { scope: 'col' },
	                                                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'location', defaultMessage: 'Location' })
	                                                ),
	                                                _react2.default.createElement(
	                                                    'th',
	                                                    { scope: 'col' },
	                                                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'price', defaultMessage: 'Price' })
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tbody',
	                                            null,
	                                            deliveryRatesByLocation.map(function (row, index) {
	                                                return _react2.default.createElement(
	                                                    'tr',
	                                                    { key: index },
	                                                    _react2.default.createElement(
	                                                        'td',
	                                                        null,
	                                                        row[0] ? row[0].location : ''
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'td',
	                                                        null,
	                                                        row[0] ? row[0].price : ''
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'td',
	                                                        null,
	                                                        row[1] ? row[1].location : ''
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'td',
	                                                        null,
	                                                        row[1] ? row[1].price : ''
	                                                    )
	                                                );
	                                            })
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    null,
	                                    _react2.default.createElement(
	                                        'strong',
	                                        { className: _shippingPolicy2.default.subtitle },
	                                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'shippingPolicy.subtitle5', defaultMessage: 'Delivery times by destinations:' })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: _shippingPolicy2.default.tableResponsive },
	                                    _react2.default.createElement(
	                                        'table',
	                                        { className: 'table table-bordered' },
	                                        _react2.default.createElement(
	                                            'tbody',
	                                            null,
	                                            deliveryTimeByDestination.map(function (item, index) {
	                                                return _react2.default.createElement(
	                                                    'tr',
	                                                    { key: index },
	                                                    _react2.default.createElement(
	                                                        'td',
	                                                        null,
	                                                        _react2.default.createElement(
	                                                            'strong',
	                                                            null,
	                                                            item.destination
	                                                        )
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'td',
	                                                        null,
	                                                        item.content
	                                                    )
	                                                );
	                                            })
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    null,
	                                    _react2.default.createElement(
	                                        'strong',
	                                        null,
	                                        '(*)',
	                                        ' ',
	                                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'shippingPolicy.subtitle3.table.text13', defaultMessage: 'Estimated deadlines will vary depending on the selected products' })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    null,
	                                    _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
	                                        id: 'shippingPolicy.any_question',
	                                        defaultMessage: 'Si a\xFAn tiene preguntas sobre los plazos y condiciones de entrega por favor cont\xE1ctenos a trav\xE9s del <b>Centro de Ayuda</b> disponible en el sitio <b><a href=\\"https://www.cubalicores.com\\">www.cubalicores.com</a></b> o por el email <a href=\\"mailto:info@cubalicores.com\\">info@cubalicores.com</a>. Nuestros representantes de soporte recibir\xE1n su mensaje y le responder\xE1n lo antes posible.'
	                                    })
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ShippingPolicy;
	}(_react.Component);
	
	exports.default = (0, _reactIntl.injectIntl)(ShippingPolicy);

/***/ },
/* 706 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(11);
	
	var _reactImageZoom = __webpack_require__(1846);
	
	var _reactImageZoom2 = _interopRequireDefault(_reactImageZoom);
	
	var _reactRouterDom = __webpack_require__(26);
	
	var _layout = __webpack_require__(29);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _urlSanitizer = __webpack_require__(123);
	
	var _urlSanitizer2 = _interopRequireDefault(_urlSanitizer);
	
	var _productModel = __webpack_require__(143);
	
	var _productModel2 = _interopRequireDefault(_productModel);
	
	var _thumbnailList = __webpack_require__(716);
	
	var _thumbnailList2 = _interopRequireDefault(_thumbnailList);
	
	var _helper = __webpack_require__(60);
	
	var _appRoutes = __webpack_require__(22);
	
	var _appRoutes2 = _interopRequireDefault(_appRoutes);
	
	var _noImage = __webpack_require__(466);
	
	var _noImage2 = _interopRequireDefault(_noImage);
	
	var _productShow = __webpack_require__(604);
	
	var _productShow2 = _interopRequireDefault(_productShow);
	
	var _loading = __webpack_require__(118);
	
	var _loading2 = _interopRequireDefault(_loading);
	
	var _categoryBadge = __webpack_require__(244);
	
	var _categoryBadge2 = _interopRequireDefault(_categoryBadge);
	
	var _productDetailsQuantitySelector = __webpack_require__(715);
	
	var _productDetailsQuantitySelector2 = _interopRequireDefault(_productDetailsQuantitySelector);
	
	var _variantSelector = __webpack_require__(717);
	
	var _variantSelector2 = _interopRequireDefault(_variantSelector);
	
	var _extraDataModal = __webpack_require__(354);
	
	var _extraDataModal2 = _interopRequireDefault(_extraDataModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable react/no-danger */
	
	
	var img = new Image();
	
	var ProductShow = function (_Component) {
	    _inherits(ProductShow, _Component);
	
	    function ProductShow(props) {
	        _classCallCheck(this, ProductShow);
	
	        var _this = _possibleConstructorReturn(this, (ProductShow.__proto__ || Object.getPrototypeOf(ProductShow)).call(this, props));
	
	        _this.getGenericImagesFromProduct = function (product) {
	            var allImages = product.images;
	            var imagesFromVariants = product.variants.map(function (variant) {
	                return variant.images;
	            }).flat();
	            console.log('images', allImages.filter(function (image) {
	                return imagesFromVariants.find(function (variantImage) {
	                    return variantImage.id === image.id;
	                }) === undefined;
	            }));
	            return allImages.filter(function (image) {
	                return imagesFromVariants.find(function (variantImage) {
	                    return variantImage.id === image.id;
	                }) === undefined;
	            });
	        };
	
	        _this.filterDuplicatedImages = function (images) {
	            var result = [];
	            images.forEach(function (image) {
	                if (image.attributes && image.attributes.styles && image.attributes.styles[11] && image.attributes.styles[11].url && result.findIndex(function (elem) {
	                    return image.attributes.styles[11].url === elem.attributes.styles[11].url;
	                }) === -1) {
	                    result.push(image);
	                }
	            });
	            return result;
	        };
	
	        _this.state = {
	            currentProduct: {},
	            currentVariant: null,
	            currentImage: '',
	            imageNo: 0,
	            imageThumbs: [],
	            images: [],
	            currentPrice: '',
	            defaultImage: false,
	            showZoom: false,
	            loadingImage: true,
	            reviews: 0,
	            rating: 0,
	            dataExtraType: null,
	            showExtraDataModal: false,
	            extraDataInfo: {}
	        };
	
	        _this.onChangeVariant = _this.onChangeVariant.bind(_this);
	        _this.toggleShowZoom = _this.toggleShowZoom.bind(_this);
	        _this.addReview = _this.addReview.bind(_this);
	        _this.onClickThumbnail = _this.onClickThumbnail.bind(_this);
	        _this.loadProductFromAPI = _this.loadProductFromAPI.bind(_this);
	        return _this;
	    }
	
	    _createClass(ProductShow, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            // TODO
	            // The wrong url error was that triggerInitialSetup now receives only 2 params and we were passing 3 then the
	            // first argument was the path name instead of the locale.
	            //
	            // Why to load all products in show??? It even shows the loader with this line commented.
	            //
	            // this.props.triggerInitialSetup(this.props.locale.currentLocale, this.props.products);
	
	            var productId = this.props.match.params.productId;
	
	            var product = _productModel2.default.findBySlug(productId, this.props.products);
	            if (product) {
	                var images = this.filterDuplicatedImages(this.getGenericImagesFromProduct(product).concat(product.master.images));
	                this.preloadImages(images);
	
	                var masterPrice = product && product.attributes && product.master.attributes && product.master.attributes.price;
	
	                this.setState({
	                    currentProduct: product,
	                    currentPrice: masterPrice,
	                    currentVariant: product.master,
	                    dataExtraType: product.data_extra_types
	                });
	            } else {
	                this.loadProductFromAPI(productId, true);
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps, prevState) {
	            if (prevState.showZoom !== this.state.showZoom || prevState.imageNo !== this.state.imageNo) {
	                var zoomedArea = document.getElementById('image-' + (this.state.imageNo + 1)).getElementsByClassName('js-image-zoom__zoomed-area')[0];
	                var zoomedImage = document.getElementById('image-' + (this.state.imageNo + 1)).getElementsByClassName('js-image-zoom__zoomed-image')[0];
	
	                zoomedArea.style.opacity = !this.state.showZoom ? '0' : '0.15';
	                zoomedImage.style.opacity = !this.state.showZoom ? '0' : '1';
	            }
	
	            if (prevProps.locale.currentLocale !== this.props.locale.currentLocale) {
	                var productId = this.props.match.params.productId;
	
	                this.loadProductFromAPI(productId, false);
	            }
	        }
	    }, {
	        key: 'onChangeVariant',
	        value: function onChangeVariant(variant) {
	            this.setState({ currentVariant: variant, currentPrice: variant.attributes.price });
	            var images = this.filterDuplicatedImages(this.getGenericImagesFromProduct(this.state.currentProduct).concat(variant.images));
	            this.preloadImages(images);
	        }
	    }, {
	        key: 'onClickThumbnail',
	        value: function onClickThumbnail(imageNo) {
	            this.setState(function (prevState) {
	                return { currentImage: prevState.images[imageNo], imageNo: imageNo };
	            });
	        }
	    }, {
	        key: 'onModalResponse',
	        value: function onModalResponse(response, value) {
	            if (response === 'accept') {
	                var extra = {};
	                extra[this.state.extraDataInfo.id] = value;
	
	                this.props.addProductToCart(this.state.currentVariant.id, this.state.extraDataInfo.quantity, this.props.currentZone, this.props.locale.currentLocale, this.props.order, this.props.access_token, extra);
	            }
	            this.setState(function (state) {
	                return {
	                    showExtraDataModal: !state.showExtraDataModal
	                };
	            });
	        }
	    }, {
	        key: 'getCategory',
	        value: function getCategory() {
	            var productId = this.props.match.params.productId;
	
	            var product = _productModel2.default.findBySlug(productId, this.props.products);
	            if (product.attributes && product.attributes.shipping_category && product.attributes.shipping_category.name && product.attributes.shipping_category.name !== 'Default') {
	                return product.attributes.shipping_category.name;
	            }
	            return null;
	        }
	    }, {
	        key: 'loadProductFromAPI',
	        value: function loadProductFromAPI(productId) {
	            var _this2 = this;
	
	            var preloadImages = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	            this.props.fetchProductFromAPI(productId, this.props.locale.currentLocale, this.props.currentZone, function (product) {
	                var images = _this2.filterDuplicatedImages(_this2.getGenericImagesFromProduct(product).concat(product.master.images));
	                if (preloadImages) {
	                    _this2.preloadImages(images);
	                }
	
	                var masterPrice = product && product.attributes && product.attributes.price;
	
	                _this2.setState({
	                    currentProduct: product,
	                    currentPrice: masterPrice,
	                    currentVariant: product.master,
	                    dataExtraType: product.data_extra_types
	                });
	            });
	        }
	    }, {
	        key: 'addReview',
	        value: function addReview() {
	            this.setState(function (prevState) {
	                return { reviews: prevState.reviews + 1 };
	            });
	        }
	    }, {
	        key: 'addProductToCart',
	        value: function addProductToCart(quantity) {
	            if (this.state.currentProduct.data_extra_types && this.state.currentProduct.data_extra_types[0] && this.state.currentProduct.data_extra_types[0].attributes) {
	                var _state$currentProduct = this.state.currentProduct.data_extra_types[0];
	                var id = _state$currentProduct.id;
	                var _state$currentProduct2 = _state$currentProduct.attributes;
	                var fieldType = _state$currentProduct2.field_type;
	                var isRequired = _state$currentProduct2.is_required;
	                var label = _state$currentProduct2.label;
	
	                this.setState(function (state) {
	                    return {
	                        showExtraDataModal: !state.showExtraDataModal,
	                        extraDataInfo: {
	                            fieldType: fieldType,
	                            isRequired: isRequired,
	                            label: label,
	                            id: id,
	                            quantity: quantity
	                        }
	                    };
	                });
	            } else {
	                this.props.addProductToCart(this.state.currentVariant.id, quantity, this.props.currentZone, this.props.locale.currentLocale, this.props.order, this.props.access_token);
	            }
	            // if (this.props.order.id && this.props.order.store.id !== this.props.currentStore.id) {
	            //     this.handleShowModalStore(this.props.order.store);
	            // } else {
	            // }
	        }
	    }, {
	        key: 'toggleShowZoom',
	        value: function toggleShowZoom() {
	            this.setState(function (prevState) {
	                return { showZoom: !prevState.showZoom };
	            });
	        }
	    }, {
	        key: 'preloadImages',
	        value: function preloadImages(images) {
	            var _this3 = this;
	
	            var imageUrl = '';
	            var defaultImage = images[0];
	
	            if (defaultImage && defaultImage.attributes && defaultImage.attributes.styles) {
	                imageUrl = _urlSanitizer2.default.makeAbsolute(defaultImage.attributes.styles[11].url);
	            }
	
	            if (imageUrl) {
	                img.src = imageUrl;
	
	                img.onload = function () {
	                    // when it finishes loading, update the component state
	                    _this3.setState({
	                        currentImage: imageUrl || _noImage2.default,
	                        loadingImage: false,
	                        defaultImage: !imageUrl
	                    });
	                };
	
	                var thumbs = [];
	                var mainImages = [];
	                images.forEach(function (image) {
	                    thumbs.push(_urlSanitizer2.default.makeAbsolute(image.attributes.styles[3].url));
	                    mainImages.push(_urlSanitizer2.default.makeAbsolute(image.attributes.styles[11].url));
	                });
	                this.setState(function () {
	                    return {
	                        imageThumbs: thumbs,
	                        images: mainImages
	                    };
	                });
	            } else {
	                this.setState({
	                    currentImage: _noImage2.default,
	                    loadingImage: false,
	                    defaultImage: true
	                });
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this4 = this;
	
	            var _state = this.state;
	            var currentProduct = _state.currentProduct;
	            var currentVariant = _state.currentVariant;
	            var images = _state.images;
	            var intl = this.props.intl;
	
	
	            var productName = currentProduct && currentProduct.attributes && currentProduct.attributes.name;
	
	            if (productName) {
	                document.title = productName;
	            }
	
	            var productDescription = currentProduct && currentProduct.attributes && currentProduct.attributes.description;
	
	            var productNotes = currentProduct && currentProduct.attributes && currentProduct.attributes && currentProduct.attributes.notes;
	
	            var productAgeValid = currentProduct && currentProduct.attributes && currentProduct.attributes.age_valid;
	
	            var imageList = images.map(function (image, idx) {
	                return _react2.default.createElement(
	                    'li',
	                    {
	                        key: 'image-' + idx,
	                        id: 'image-' + (idx + 1),
	                        style: { width: image === _this4.state.currentImage ? 'auto' : '0' },
	                        className: _productShow2.default.image + ' ' + (image === _this4.state.currentImage ? _productShow2.default.activeImage : '')
	                    },
	                    _react2.default.createElement(_reactImageZoom2.default, {
	                        width: 279,
	                        height: 340,
	                        zoomWidth: 540,
	                        img: image,
	                        zoomStyle: 'border: 1px solid #000; opacity: 0; background-color: white;',
	                        zoomLensStyle: 'border: 1px solid #000; opacity: 0; background-color: gray;'
	                    })
	                );
	            });
	
	            var getProductDescriptionMarkup = function getProductDescriptionMarkup() {
	                return { __html: productDescription };
	            };
	
	            return _react2.default.createElement(
	                _layout2.default,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: _productShow2.default.productShow },
	                    _react2.default.createElement(
	                        'div',
	                        { className: _productShow2.default.productContent },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'container ' + _productShow2.default.productContainer },
	                            _react2.default.createElement(
	                                'div',
	                                { className: _productShow2.default.breadcrumbContent },
	                                _react2.default.createElement('div', { className: 'hidden-sm hidden-md hidden-lg breadcrumb-xs' })
	                            ),
	                            _react2.default.createElement(
	                                'section',
	                                { className: _productShow2.default.productResume },
	                                this.props.displayLoader ? _react2.default.createElement(
	                                    'div',
	                                    { className: _productShow2.default.overlay },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'row ' + _productShow2.default.loadingHolder },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'col-lg-12 col-md-12 col-sm-12 col-xs-12' },
	                                            _react2.default.createElement(
	                                                'h4',
	                                                { className: _productShow2.default.loadingText },
	                                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'loading-please-wait', defaultMessage: 'Loading, please wait' })
	                                            ),
	                                            _react2.default.createElement('div', { className: _loading2.default.spinnerDark })
	                                        )
	                                    )
	                                ) : _react2.default.createElement(
	                                    'div',
	                                    { className: 'row' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-md-5 col-xs-12' },
	                                        this.getCategory() && _react2.default.createElement(_categoryBadge2.default, { isShowProduct: true, label: this.getCategory(), color: '#FE6902' }),
	                                        _react2.default.createElement(
	                                            'div',
	                                            null,
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: _productShow2.default.imgMain },
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: _productShow2.default.mainImage },
	                                                    !this.state.defaultImage && _react2.default.createElement(
	                                                        'div',
	                                                        { className: _productShow2.default.zoomHolder + ' ' + (this.state.showZoom && _productShow2.default.zoomActived), onClick: this.toggleShowZoom },
	                                                        _react2.default.createElement('i', { className: 'pe pe-7s-search' })
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: _productShow2.default.imageWrapper },
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { className: _productShow2.default.imageViewport },
	                                                            _react2.default.createElement(
	                                                                'ul',
	                                                                { className: _productShow2.default.imageSlider },
	                                                                images.length > 0 ? imageList : _react2.default.createElement('img', { src: _noImage2.default, alt: productName })
	                                                            )
	                                                        )
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: _productShow2.default.imgLoadingContainer, style: { display: this.state.loadingImage ? 'block' : 'none' } },
	                                                        _react2.default.createElement('div', { className: _loading2.default.spinnerDark })
	                                                    )
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                'div',
	                                                { style: { marginTop: '10px' } },
	                                                this.state.images && _react2.default.createElement(_thumbnailList2.default, { images: this.state.imageThumbs, onClickThumbnail: this.onClickThumbnail })
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-md-6 col-xs-12 ' + _productShow2.default.resume },
	                                        _react2.default.createElement(
	                                            'form',
	                                            { className: 'form-horizontal ' + _productShow2.default.form },
	                                            _react2.default.createElement(
	                                                'h2',
	                                                { className: '' + _productShow2.default.productName },
	                                                productName
	                                            ),
	                                            currentProduct && currentProduct.variants && currentProduct.variants.length > 1 && _react2.default.createElement(
	                                                'div',
	                                                null,
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    null,
	                                                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'selected-variant', defaultMessage: 'Selected variant' }),
	                                                    ':\xA0',
	                                                    _react2.default.createElement(_variantSelector2.default, {
	                                                        variants: currentProduct.variants,
	                                                        currentVariant: currentVariant,
	                                                        onVariantSelected: function onVariantSelected(variant) {
	                                                            _this4.onChangeVariant(variant);
	                                                        }
	                                                    })
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: '' + _productShow2.default.flexDisplay },
	                                                this.state.rating > 0 && _react2.default.createElement(
	                                                    'div',
	                                                    { className: _productShow2.default.productRating },
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 'row ' + _productShow2.default.ratingDirective },
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { className: 'col-lg-12 col-md-12 col-sm-12 col-xs-12 ' + _productShow2.default.noPadding },
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { style: { display: 'inline-block' } },
	                                                                _react2.default.createElement(
	                                                                    'div',
	                                                                    { className: _productShow2.default.ratingHolder },
	                                                                    _react2.default.createElement(
	                                                                        'div',
	                                                                        { className: _productShow2.default.ratings },
	                                                                        _react2.default.createElement('div', { className: _productShow2.default.emptyStars }),
	                                                                        _react2.default.createElement('div', { className: _productShow2.default.fullStars, style: { width: this.state.rating + '%' } })
	                                                                    )
	                                                                )
	                                                            )
	                                                        )
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'p',
	                                                    { className: _productShow2.default.reviewCount },
	                                                    this.state.reviews > 0 && _react2.default.createElement(
	                                                        'span',
	                                                        null,
	                                                        _react2.default.createElement(
	                                                            'span',
	                                                            { className: _productShow2.default.margins },
	                                                            this.state.reviews
	                                                        ),
	                                                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'reviews', defaultMessage: 'Reviews' }),
	                                                        _react2.default.createElement(
	                                                            'span',
	                                                            { className: _productShow2.default.margins },
	                                                            '|'
	                                                        )
	                                                    ),
	                                                    _react2.default.createElement('span', { className: _productShow2.default.firstCommentLink })
	                                                )
	                                            ),
	                                            _react2.default.createElement('hr', { className: _productShow2.default.separator }),
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: _productShow2.default.priceDetails },
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: _productShow2.default.priceP },
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 'row' },
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { className: 'col-sm-6' },
	                                                            _react2.default.createElement(
	                                                                'span',
	                                                                { className: _productShow2.default.propertyTitle },
	                                                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'price-details', defaultMessage: 'Price Details' })
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'span',
	                                                                { className: _productShow2.default.price },
	                                                                _helper.priceFormat.format(this.state.currentPrice)
	                                                            )
	                                                        )
	                                                    )
	                                                )
	                                            ),
	                                            _react2.default.createElement('hr', { className: _productShow2.default.separator }),
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: _productShow2.default.inStock },
	                                                _react2.default.createElement(
	                                                    'p',
	                                                    null,
	                                                    _react2.default.createElement(
	                                                        'span',
	                                                        { className: _productShow2.default.propertyTitle },
	                                                        currentProduct.attributes && currentProduct.attributes.in_stock ? _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'in-stock', defaultMessage: 'In Stock' }) : _react2.default.createElement(
	                                                            'span',
	                                                            { className: _productShow2.default.outStock },
	                                                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'out-of-stock', defaultMessage: 'Out Stock' })
	                                                        )
	                                                    ),
	                                                    _react2.default.createElement('br', null),
	                                                    currentProduct.attributes && currentProduct.attributes.in_stock && _react2.default.createElement(
	                                                        'span',
	                                                        { className: _productShow2.default.estimatedArrivalTime },
	                                                        '- ',
	                                                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'estimated-arrival-time', defaultMessage: 'Estimated arrival time' }),
	                                                        ': ',
	                                                        _react2.default.createElement(
	                                                            _reactRouterDom.Link,
	                                                            { to: _appRoutes2.default.shipping },
	                                                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'shipping-policy-link-text', defaultMessage: 'See delivery policy and rates' })
	                                                        )
	                                                    )
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: _productShow2.default.itemDetails },
	                                                _react2.default.createElement(
	                                                    'p',
	                                                    null,
	                                                    _react2.default.createElement(
	                                                        'span',
	                                                        { className: _productShow2.default.propertyTitle },
	                                                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'description', defaultMessage: 'Description' })
	                                                    )
	                                                ),
	                                                _react2.default.createElement('p', { className: _productShow2.default.itemDetailsContent, dangerouslySetInnerHTML: getProductDescriptionMarkup() })
	                                            ),
	                                            productNotes && _react2.default.createElement(
	                                                'div',
	                                                { className: _productShow2.default.itemDetails },
	                                                _react2.default.createElement(
	                                                    'p',
	                                                    null,
	                                                    _react2.default.createElement(
	                                                        'span',
	                                                        { className: _productShow2.default.propertyTitle },
	                                                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'note', defaultMessage: 'Note' })
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'p',
	                                                    { className: _productShow2.default.itemDetailsContent },
	                                                    productNotes
	                                                )
	                                            ),
	                                            _react2.default.createElement('hr', { className: _productShow2.default.separator }),
	                                            _react2.default.createElement(_productDetailsQuantitySelector2.default, {
	                                                productPrice: this.state.currentPrice,
	                                                productAgeValid: productAgeValid,
	                                                addingProductToCart: this.props.order.addingProductToCart,
	                                                dataExtraType: this.state.dataExtraType,
	                                                onAddProductToCart: function onAddProductToCart(quantity) {
	                                                    _this4.addProductToCart(quantity);
	                                                }
	                                            })
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    )
	                ),
	                this.state.showExtraDataModal && _react2.default.createElement(_extraDataModal2.default, {
	                    fieldType: this.state.extraDataInfo.fieldType,
	                    label: this.state.extraDataInfo.label,
	                    isRequired: this.state.extraDataInfo.isRequired,
	                    onResponse: function onResponse(response, value) {
	                        _this4.onModalResponse(response, value);
	                    }
	                })
	            );
	        }
	    }]);
	
	    return ProductShow;
	}(_react.Component);
	
	exports.default = (0, _reactIntl.injectIntl)(ProductShow);

/***/ },
/* 707 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(11);
	
	var _reactRouterDom = __webpack_require__(26);
	
	var _DropdownButton = __webpack_require__(159);
	
	var _DropdownButton2 = _interopRequireDefault(_DropdownButton);
	
	var _reactBootstrap = __webpack_require__(38);
	
	var _reactPaginate = __webpack_require__(1864);
	
	var _reactPaginate2 = _interopRequireDefault(_reactPaginate);
	
	var _layout = __webpack_require__(29);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _storeTile = __webpack_require__(362);
	
	var _storeTile2 = _interopRequireDefault(_storeTile);
	
	var _storeCard = __webpack_require__(734);
	
	var _storeCard2 = _interopRequireDefault(_storeCard);
	
	var _showStores = __webpack_require__(2169);
	
	var _showStores2 = _interopRequireDefault(_showStores);
	
	var _loading = __webpack_require__(118);
	
	var _loading2 = _interopRequireDefault(_loading);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var getProperties = function getProperties() {
	    var width = document.documentElement.clientWidth;
	    var bordersWidth = 0.14 * width;
	
	    if (width > 400) {
	        return {
	            marginLeft: '50px',
	            cantInCorousel: Number.parseInt((width - 2 * bordersWidth) / 250, 10),
	            height: '100px'
	        };
	    }
	
	    return {
	        marginLeft: '25px',
	        cantInCorousel: Number.parseInt((width - 2 * bordersWidth) / 200, 10),
	        height: '50px'
	    };
	};
	
	var StorePage = function StorePage(props) {
	    var getZone = function getZone() {
	        return props.availableZones.find(function (zone) {
	            return zone.id === props.currentZone;
	        }).name;
	    };
	
	    var _useState = (0, _react.useState)(getZone());
	
	    var _useState2 = _slicedToArray(_useState, 2);
	
	    var selectedText = _useState2[0];
	    var setSelectedText = _useState2[1];
	
	    var _useState3 = (0, _react.useState)(props.currentZone || 6);
	
	    var _useState4 = _slicedToArray(_useState3, 2);
	
	    var selectedZoneId = _useState4[0];
	    var setSelectedZoneId = _useState4[1];
	
	    var _useState5 = (0, _react.useState)(_extends({}, getProperties()));
	
	    var _useState6 = _slicedToArray(_useState5, 2);
	
	    var properties = _useState6[0];
	    var setProperties = _useState6[1];
	
	    var _useState7 = (0, _react.useState)(15);
	
	    var _useState8 = _slicedToArray(_useState7, 2);
	
	    var limit = _useState8[0];
	    var setLimit = _useState8[1];
	
	    var _useState9 = (0, _react.useState)(1);
	
	    var _useState10 = _slicedToArray(_useState9, 2);
	
	    var page = _useState10[0];
	    var setPage = _useState10[1];
	
	
	    window.addEventListener('resize', function () {
	        setProperties(_extends({}, getProperties()));
	    });
	
	    (0, _react.useEffect)(function () {
	        props.setCurrentZone(selectedZoneId, page, limit);
	    }, [page]);
	
	    var setSelected = function setSelected(id, name) {
	        setSelectedText(name);
	        setSelectedZoneId(id);
	        setPage(1);
	        props.setCurrentZone(id, page);
	    };
	
	    var getFormatedList = function getFormatedList(groupLength) {
	        var result = [];
	        var group = [];
	
	        for (var i = 0; i < props.stores.length; i += 1) {
	            if (i === 0 || i % groupLength !== 0) group = [].concat(_toConsumableArray(group), [props.stores[i]]);else {
	                result = [].concat(_toConsumableArray(result), [group]);
	                group = [props.stores[i]];
	            }
	        }
	
	        if (group !== []) result = [].concat(_toConsumableArray(result), [group]);
	        return result;
	    };
	
	    return _react2.default.createElement(
	        _layout2.default,
	        null,
	        _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement('img', { className: _showStores2.default.headerBanner, src: __webpack_require__(462), alt: 'banner' })
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: _showStores2.default.container },
	            _react2.default.createElement(
	                'div',
	                { className: _showStores2.default.storesContainer },
	                _react2.default.createElement(
	                    'div',
	                    { className: _showStores2.default.zoneSelector },
	                    _react2.default.createElement(
	                        _DropdownButton2.default,
	                        { id: 'dropdown-basic-button', as: 'button', className: 'button-cancel ' + _showStores2.default.zoneSelectorButton, title: selectedText },
	                        props.availableZones.map(function (zone) {
	                            return _react2.default.createElement(
	                                _reactBootstrap.MenuItem,
	                                { as: 'button', className: 'button-secondary inv button-small', id: zone.id, key: zone.id, onClick: function onClick() {
	                                        return setSelected(zone.id, zone.name);
	                                    } },
	                                zone.name
	                            );
	                        })
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: _showStores2.default.allStoresContainer },
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                        'h1',
	                        { className: _showStores2.default.allStoresHeader },
	                        _react2.default.createElement(_reactIntl.FormattedMessage, {
	                            id: 'allStores',
	                            defaultMessage: 'All the stores'
	                        })
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: _showStores2.default.allStoresWrapper },
	                    props.displayLoader && _react2.default.createElement(
	                        'div',
	                        { className: 'col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center' },
	                        _react2.default.createElement(
	                            'div',
	                            null,
	                            _react2.default.createElement(
	                                'h4',
	                                { className: _showStores2.default.loadingText },
	                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'loading-stores', defaultMessage: 'Loading stores' }),
	                                _react2.default.createElement(
	                                    'span',
	                                    { className: 'hidden-xs' },
	                                    ', ',
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'please-wait', defaultMessage: 'please wait' })
	                                ),
	                                '...'
	                            ),
	                            _react2.default.createElement('div', { className: _loading2.default.spinnerDark })
	                        )
	                    ),
	                    !props.displayLoader && props.storesByZone && props.storesByZone.map(function (store) {
	                        return _react2.default.createElement(
	                            _reactRouterDom.Link,
	                            { to: '/' + store.code, key: store.id },
	                            _react2.default.createElement(_storeCard2.default, { name: store.name, styles: _showStores2.default, logo: store.logo_file_name, description: store.description })
	                        );
	                    })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: _showStores2.default.paginatorBottomContainer },
	                    _react2.default.createElement(
	                        'div',
	                        { className: _showStores2.default.paginatorInfo },
	                        _react2.default.createElement(
	                            'span',
	                            null,
	                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'paginator-sentence-1', defaultMessage: 'Showing' }),
	                            ' ' + (page * limit < 19 ? page * props.storesByZone.length : 19) + ' ',
	                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'paginator-sentence-2', defaultMessage: 'of' }),
	                            ' ' + 19 + ' ',
	                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'paginator-sentence-3', defaultMessage: 'results' })
	                        )
	                    ),
	                    _react2.default.createElement(_reactPaginate2.default, {
	                        previousLabel: 'previous',
	                        nextLabel: 'next',
	                        breakLabel: '...',
	                        breakClassName: 'break-me',
	                        pageCount: props.pageCount,
	                        marginPagesDisplayed: 2,
	                        pageRangeDisplayed: 5,
	                        onPageChange: function onPageChange(data) {
	                            return setPage(data.selected + 1);
	                        },
	                        containerClassName: 'pagination',
	                        activeClassName: 'active'
	                    })
	                )
	            )
	        )
	    );
	};
	
	exports.default = (0, _reactIntl.injectIntl)(StorePage);

/***/ },
/* 708 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(11);
	
	var _layout = __webpack_require__(29);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _productList = __webpack_require__(603);
	
	var _productList2 = _interopRequireDefault(_productList);
	
	var _loading = __webpack_require__(118);
	
	var _loading2 = _interopRequireDefault(_loading);
	
	var _productList3 = __webpack_require__(243);
	
	var _productList4 = _interopRequireDefault(_productList3);
	
	var _signupPromotion = __webpack_require__(75);
	
	var _signupPromotion2 = _interopRequireDefault(_signupPromotion);
	
	var _secondaryMenuConnector = __webpack_require__(178);
	
	var _secondaryMenuConnector2 = _interopRequireDefault(_secondaryMenuConnector);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var StoreProductsPage = function (_Component) {
	    _inherits(StoreProductsPage, _Component);
	
	    function StoreProductsPage(props) {
	        _classCallCheck(this, StoreProductsPage);
	
	        var _this = _possibleConstructorReturn(this, (StoreProductsPage.__proto__ || Object.getPrototypeOf(StoreProductsPage)).call(this, props));
	
	        _this.state = {
	            storeCode: ''
	        };
	        return _this;
	    }
	
	    _createClass(StoreProductsPage, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var storeCode = this.props.match.params.storeCode;
	
	            this.setState({ storeCode: storeCode });
	            this.props.loadStoresProducts(this.props.locale.currentLocale, storeCode);
	
	            if (this.props.currentStore.name) {
	                document.title = this.props.currentStore.name;
	            }
	        }
	
	        /* If home page icon is clicked. */
	
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps, prevState) {
	            if (prevProps.location.pathname !== this.props.location.pathname || prevProps.locale.currentLocale !== this.props.locale.currentLocale || prevProps.location.search !== this.props.location.search) {
	                var storeCode = this.props.location.pathname.slice(1);
	                // this.props.triggerInitialSetup(this.props.locale.currentLocale);
	                this.props.loadStoresProducts(this.props.locale.currentLocale, storeCode);
	            }
	
	            if (prevProps.currentStore !== this.props.currentStore) {
	                document.title = this.props.currentStore.name;
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                _layout2.default,
	                { notShowMarginBottom: true },
	                _react2.default.createElement(
	                    'div',
	                    { className: _productList2.default.productList },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'container body-container ' + _productList2.default.bodyContainer },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'row' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-lg-3 col-md-3 col-sm-4 col-xs-12 ' + _productList2.default.colFilters },
	                                _react2.default.createElement(_secondaryMenuConnector2.default, { location: this.props.location, path: this.state.storeCode })
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-lg-9 col-md-9 col-sm-8 col-xs-12' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: '' + _productList2.default.contentCategory },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'row' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'col-lg-12 col-md-12 col-sm-12 col-xs-12' },
	                                            !this.props.displayLoader && _react2.default.createElement(
	                                                'label',
	                                                { className: '' + _productList2.default.titleSection },
	                                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'our', defaultMessage: 'Our' }),
	                                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'recommendations', defaultMessage: 'recommendations' })
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'row no-margin' },
	                                        this.props.displayLoader && _react2.default.createElement(
	                                            'div',
	                                            { className: 'col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center' },
	                                            _react2.default.createElement(
	                                                'div',
	                                                null,
	                                                _react2.default.createElement(
	                                                    'h4',
	                                                    { className: _productList2.default.loadingText },
	                                                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'loading-recommendations', defaultMessage: 'Loading recommendations' }),
	                                                    _react2.default.createElement(
	                                                        'span',
	                                                        { className: 'hidden-xs' },
	                                                        ', ',
	                                                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'please-wait', defaultMessage: 'please wait' })
	                                                    ),
	                                                    '...'
	                                                ),
	                                                _react2.default.createElement('div', { className: _loading2.default.spinnerDark })
	                                            )
	                                        ),
	                                        !this.props.displayLoader && _react2.default.createElement(_productList4.default, {
	                                            products: this.props.products,
	                                            loadMoreProducts: this.props.loadMoreProducts,
	                                            pageCount: this.props.pageCount,
	                                            searchTerm: this.props.location.pathname,
	                                            locale: this.props.locale
	                                        })
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return StoreProductsPage;
	}(_react.Component);
	
	exports.default = (0, _reactIntl.injectIntl)(StoreProductsPage);

/***/ },
/* 709 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(11);
	
	var _layout = __webpack_require__(29);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _termsConditions = __webpack_require__(2170);
	
	var _termsConditions2 = _interopRequireDefault(_termsConditions);
	
	var _signupPromotion = __webpack_require__(75);
	
	var _signupPromotion2 = _interopRequireDefault(_signupPromotion);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ReturnPolicy = function (_Component) {
	    _inherits(ReturnPolicy, _Component);
	
	    function ReturnPolicy(props) {
	        _classCallCheck(this, ReturnPolicy);
	
	        var _this = _possibleConstructorReturn(this, (ReturnPolicy.__proto__ || Object.getPrototypeOf(ReturnPolicy)).call(this, props));
	
	        document.title = _this.props.intl.formatMessage({ id: 'return-policy-title' });
	        return _this;
	    }
	
	    _createClass(ReturnPolicy, [{
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps) {
	            if (this.props.locale !== prevProps.locale) {
	                document.title = this.props.intl.formatMessage({ id: 'return-policy-title' });
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var Paragraph = function Paragraph(props) {
	                return _react2.default.createElement(
	                    'div',
	                    { className: 'text-justify', style: _extends({ paddingBottom: 10 }, props.style) },
	                    props.children
	                );
	            };
	
	            return _react2.default.createElement(
	                _layout2.default,
	                { notShowMarginBottom: true },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'container' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                            'h4',
	                            { className: _termsConditions2.default.mainText },
	                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'term-and-conditions', defaultMessage: '' })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: _termsConditions2.default.privacyBackround },
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    null,
	                                    _react2.default.createElement(
	                                        'strong',
	                                        { className: _termsConditions2.default.subtitle },
	                                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'terms-conditions-title', defaultMessage: '' })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    null,
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: 'terms-conditions-text1',
	                                        defaultMessage: ''
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    null,
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: 'terms-conditions-text2',
	                                        defaultMessage: ''
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    null,
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: 'terms-conditions-text3',
	                                        defaultMessage: ''
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    null,
	                                    _react2.default.createElement(
	                                        'strong',
	                                        { className: _termsConditions2.default.subtitle },
	                                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'terms-conditions-subheader1', defaultMessage: '' })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    { style: { paddingBottom: 0 } },
	                                    _react2.default.createElement(
	                                        'strong',
	                                        { className: _termsConditions2.default.subtitle },
	                                        _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                            id: 'terms-conditions-subheader1-subtitle1',
	                                            defaultMessage: ''
	                                        })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    null,
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: 'terms-conditions-subheader1-subtitle1-text1',
	                                        defaultMessage: ''
	                                    }),
	                                    ' ',
	                                    _react2.default.createElement(
	                                        'u',
	                                        null,
	                                        'info@cubalicores.com'
	                                    ),
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: 'terms-conditions-subheader1-subtitle1-text2',
	                                        defaultMessage: ''
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    { style: { paddingBottom: 0 } },
	                                    _react2.default.createElement(
	                                        'strong',
	                                        { className: _termsConditions2.default.subtitle },
	                                        _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                            id: 'terms-conditions-subheader1-subtitle2',
	                                            defaultMessage: ''
	                                        })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    null,
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: 'terms-conditions-subheader1-subtitle2-text1',
	                                        defaultMessage: ''
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    null,
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: 'terms-conditions-subheader1-subtitle2-text2',
	                                        defaultMessage: ''
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    null,
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: 'terms-conditions-subheader1-subtitle2-text3',
	                                        defaultMessage: ''
	                                    }),
	                                    ' ',
	                                    _react2.default.createElement(
	                                        'a',
	                                        { href: 'https://www.cubalicores.com/settings' },
	                                        _react2.default.createElement(
	                                            'u',
	                                            null,
	                                            'https://www.cubalicores.com/settings'
	                                        )
	                                    ),
	                                    '.',
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: 'terms-conditions-subheader1-subtitle2-text4',
	                                        defaultMessage: ''
	                                    }),
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: 'terms-conditions-subheader1-subtitle2-text5',
	                                        defaultMessage: ''
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    { style: { paddingBottom: 0 } },
	                                    _react2.default.createElement(
	                                        'strong',
	                                        { className: _termsConditions2.default.subtitle },
	                                        _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                            id: 'terms-conditions-subheader1-subtitle3',
	                                            defaultMessage: ''
	                                        })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    null,
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: 'terms-conditions-subheader1-subtitle3-text1',
	                                        defaultMessage: ''
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    null,
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: 'terms-conditions-subheader1-subtitle3-text2',
	                                        defaultMessage: ''
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    null,
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: 'terms-conditions-subheader1-subtitle3-text3',
	                                        defaultMessage: ''
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    null,
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: 'terms-conditions-subheader1-subtitle3-text4',
	                                        defaultMessage: ''
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    { style: { paddingBottom: 0 } },
	                                    _react2.default.createElement(
	                                        'strong',
	                                        { className: _termsConditions2.default.subtitle },
	                                        _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                            id: 'terms-conditions-subheader1-subtitle4',
	                                            defaultMessage: ''
	                                        })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    null,
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: 'terms-conditions-subheader1-subtitle4-text1',
	                                        defaultMessage: ''
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    null,
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: 'terms-conditions-subheader1-subtitle4-text2',
	                                        defaultMessage: ''
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    null,
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: 'terms-conditions-subheader1-subtitle4-text3',
	                                        defaultMessage: ''
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    null,
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: 'terms-conditions-subheader1-subtitle4-text4',
	                                        defaultMessage: ''
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    { style: { paddingLeft: 10 } },
	                                    '- ',
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: 'terms-conditions-subheader1-subtitle4-text4-1',
	                                        defaultMessage: ''
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    { style: { paddingLeft: 10 } },
	                                    '- ',
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: 'terms-conditions-subheader1-subtitle4-text4-2',
	                                        defaultMessage: ''
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    { style: { paddingLeft: 10 } },
	                                    '- ',
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: 'terms-conditions-subheader1-subtitle4-text4-3',
	                                        defaultMessage: ''
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    { style: { paddingLeft: 10 } },
	                                    '- ',
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: 'terms-conditions-subheader1-subtitle4-text4-4',
	                                        defaultMessage: ''
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    null,
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: 'terms-conditions-subheader1-subtitle4-text5',
	                                        defaultMessage: ''
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    null,
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: 'terms-conditions-subheader1-subtitle4-text6',
	                                        defaultMessage: ''
	                                    }),
	                                    ' ',
	                                    _react2.default.createElement(
	                                        'a',
	                                        { href: 'https://www.cubalicores.com/return-policy' },
	                                        _react2.default.createElement(
	                                            'u',
	                                            null,
	                                            _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                id: 'return-policy',
	                                                defaultMessage: ''
	                                            })
	                                        )
	                                    ),
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: 'terms-conditions-subheader1-subtitle4-text7',
	                                        defaultMessage: ''
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    { style: { paddingBottom: 0 } },
	                                    _react2.default.createElement(
	                                        'strong',
	                                        { className: _termsConditions2.default.subtitle },
	                                        _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                            id: 'terms-conditions-subheader2',
	                                            defaultMessage: ''
	                                        })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    { style: { paddingBottom: 0 } },
	                                    _react2.default.createElement(
	                                        'strong',
	                                        { className: _termsConditions2.default.subtitle },
	                                        _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                            id: 'terms-conditions-subheader2-subtitle1',
	                                            defaultMessage: ''
	                                        })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    null,
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: 'terms-conditions-subheader2-subtitle1-text1',
	                                        defaultMessage: ''
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    { style: { paddingBottom: 0 } },
	                                    _react2.default.createElement(
	                                        'strong',
	                                        { className: _termsConditions2.default.subtitle },
	                                        _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                            id: 'terms-conditions-subheader2-subtitle2',
	                                            defaultMessage: ''
	                                        })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    null,
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: 'terms-conditions-subheader2-subtitle2-text1',
	                                        defaultMessage: ''
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    { style: { paddingBottom: 0 } },
	                                    _react2.default.createElement(
	                                        'strong',
	                                        { className: _termsConditions2.default.subtitle },
	                                        _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                            id: 'terms-conditions-subheader2-subtitle3',
	                                            defaultMessage: ''
	                                        })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    null,
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: 'terms-conditions-subheader2-subtitle3-text1',
	                                        defaultMessage: ''
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    { style: { paddingBottom: 0 } },
	                                    _react2.default.createElement(
	                                        'strong',
	                                        { className: _termsConditions2.default.subtitle },
	                                        _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                            id: 'terms-conditions-subheader2-subtitle4',
	                                            defaultMessage: ''
	                                        })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    null,
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: 'terms-conditions-subheader2-subtitle4-text1',
	                                        defaultMessage: ''
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    null,
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: 'terms-conditions-subheader2-subtitle4-text2',
	                                        defaultMessage: ''
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    { style: { paddingBottom: 0 } },
	                                    _react2.default.createElement(
	                                        'strong',
	                                        { className: _termsConditions2.default.subtitle },
	                                        _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                            id: 'terms-conditions-subheader2-subtitle5',
	                                            defaultMessage: ''
	                                        })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    null,
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: 'terms-conditions-subheader2-subtitle5-text1',
	                                        defaultMessage: ''
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    null,
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: 'terms-conditions-subheader2-subtitle5-text2',
	                                        defaultMessage: ''
	                                    }),
	                                    ' ',
	                                    _react2.default.createElement(
	                                        'a',
	                                        { href: 'https://www.cubalicores.com/help' },
	                                        _react2.default.createElement(
	                                            'u',
	                                            null,
	                                            _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                id: 'terms-conditions-subheader2-subtitle5-text3',
	                                                defaultMessage: ''
	                                            })
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    { style: { paddingBottom: 0 } },
	                                    _react2.default.createElement(
	                                        'strong',
	                                        { className: _termsConditions2.default.subtitle },
	                                        _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                            id: 'terms-conditions-subheader2-subtitle6',
	                                            defaultMessage: ''
	                                        })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    null,
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: 'terms-conditions-subheader2-subtitle6-text1',
	                                        defaultMessage: ''
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    null,
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: 'terms-conditions-subheader2-subtitle6-text2',
	                                        defaultMessage: ''
	                                    }),
	                                    ' ',
	                                    _react2.default.createElement(
	                                        'a',
	                                        { href: 'https://www.cubalicores.com/help' },
	                                        _react2.default.createElement(
	                                            'u',
	                                            null,
	                                            'CubaLicores'
	                                        )
	                                    ),
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: 'terms-conditions-subheader2-subtitle6-text3',
	                                        defaultMessage: ''
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    null,
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: 'terms-conditions-subheader2-subtitle6-text4',
	                                        defaultMessage: ''
	                                    }),
	                                    ' ',
	                                    _react2.default.createElement(
	                                        'a',
	                                        { href: 'https://www.cubalicores.com/help' },
	                                        _react2.default.createElement(
	                                            'u',
	                                            null,
	                                            _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                id: 'terms-conditions-subheader2-subtitle6-text5',
	                                                defaultMessage: ''
	                                            })
	                                        )
	                                    ),
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: 'terms-conditions-subheader2-subtitle6-text6',
	                                        defaultMessage: ''
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    null,
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: 'terms-conditions-subheader2-subtitle6-text7',
	                                        defaultMessage: ''
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    { style: { paddingBottom: 0 } },
	                                    _react2.default.createElement(
	                                        'strong',
	                                        { className: _termsConditions2.default.subtitle },
	                                        _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                            id: 'terms-conditions-subheader2-subtitle7',
	                                            defaultMessage: ''
	                                        })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    null,
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: 'terms-conditions-subheader2-subtitle7-text1',
	                                        defaultMessage: ''
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    { style: { paddingBottom: 0 } },
	                                    _react2.default.createElement(
	                                        'strong',
	                                        { className: _termsConditions2.default.subtitle },
	                                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'terms-conditions-subheader3', defaultMessage: '' })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    { style: { paddingBottom: 0 } },
	                                    _react2.default.createElement(
	                                        'strong',
	                                        { className: _termsConditions2.default.subtitle },
	                                        _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                            id: 'terms-conditions-subheader3-subtitle1',
	                                            defaultMessage: ''
	                                        })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    null,
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: 'terms-conditions-subheader3-subtitle1-text1',
	                                        defaultMessage: ''
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    null,
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: 'terms-conditions-subheader3-subtitle1-text2',
	                                        defaultMessage: ''
	                                    }),
	                                    ' ',
	                                    _react2.default.createElement(
	                                        'a',
	                                        { href: 'https://www.cubalicores.com/frequent-questions' },
	                                        _react2.default.createElement(
	                                            'u',
	                                            null,
	                                            _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                id: 'terms-conditions-subheader3-subtitle1-text3',
	                                                defaultMessage: ''
	                                            })
	                                        )
	                                    ),
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: 'terms-conditions-subheader3-subtitle1-text4',
	                                        defaultMessage: ''
	                                    }),
	                                    ' ',
	                                    _react2.default.createElement(
	                                        'a',
	                                        { href: 'https://www.cubalicores.com/shipping-policy' },
	                                        _react2.default.createElement(
	                                            'u',
	                                            null,
	                                            _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                id: 'terms-conditions-subheader3-subtitle1-text5',
	                                                defaultMessage: ''
	                                            })
	                                        )
	                                    ),
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: 'terms-conditions-subheader3-subtitle1-text6',
	                                        defaultMessage: ''
	                                    }),
	                                    ' ',
	                                    _react2.default.createElement(
	                                        'a',
	                                        { href: 'https://www.cubalicores.com/return-policy' },
	                                        _react2.default.createElement(
	                                            'u',
	                                            null,
	                                            _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                id: 'return-policy',
	                                                defaultMessage: ''
	                                            })
	                                        )
	                                    ),
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: 'terms-conditions-subheader3-subtitle1-text7',
	                                        defaultMessage: ''
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    { style: { paddingBottom: 0 } },
	                                    _react2.default.createElement(
	                                        'strong',
	                                        { className: _termsConditions2.default.subtitle },
	                                        _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                            id: 'terms-conditions-subheader3-subtitle2',
	                                            defaultMessage: ''
	                                        })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    null,
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: 'terms-conditions-subheader3-subtitle2-text1',
	                                        defaultMessage: ''
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    null,
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: 'terms-conditions-subheader3-subtitle2-text2',
	                                        defaultMessage: ''
	                                    }),
	                                    ' ',
	                                    _react2.default.createElement(
	                                        'a',
	                                        { href: 'https://www.cubalicores.com/return-policy' },
	                                        _react2.default.createElement(
	                                            'u',
	                                            null,
	                                            _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                id: 'return-policy',
	                                                defaultMessage: ''
	                                            })
	                                        )
	                                    ),
	                                    '.'
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    { style: { paddingBottom: 0 } },
	                                    _react2.default.createElement(
	                                        'strong',
	                                        { className: _termsConditions2.default.subtitle },
	                                        _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                            id: 'terms-conditions-subheader3-subtitle3',
	                                            defaultMessage: ''
	                                        })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    null,
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: 'terms-conditions-subheader3-subtitle3-text1',
	                                        defaultMessage: ''
	                                    }),
	                                    ' ',
	                                    _react2.default.createElement(
	                                        'a',
	                                        { href: 'https://www.cubalicores.com/frequent-questions' },
	                                        _react2.default.createElement(
	                                            'u',
	                                            null,
	                                            _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                id: 'terms-conditions-subheader3-subtitle1-text3',
	                                                defaultMessage: ''
	                                            })
	                                        )
	                                    ),
	                                    '.'
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    { style: { paddingBottom: 0 } },
	                                    _react2.default.createElement(
	                                        'strong',
	                                        { className: _termsConditions2.default.subtitle },
	                                        _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                            id: 'terms-conditions-subheader3-subtitle4',
	                                            defaultMessage: ''
	                                        })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    null,
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: 'terms-conditions-subheader3-subtitle4-text1',
	                                        defaultMessage: ''
	                                    }),
	                                    ' ',
	                                    _react2.default.createElement(
	                                        'a',
	                                        { href: 'https://www.cubalicores.com/privacy-policy' },
	                                        _react2.default.createElement(
	                                            'u',
	                                            null,
	                                            _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                id: 'terms-conditions-subheader2-subtitle5-text3',
	                                                defaultMessage: ''
	                                            })
	                                        )
	                                    ),
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: 'terms-conditions-subheader3-subtitle4-text2',
	                                        defaultMessage: ''
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    { style: { paddingBottom: 0 } },
	                                    _react2.default.createElement(
	                                        'strong',
	                                        { className: _termsConditions2.default.subtitle },
	                                        _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                            id: 'terms-conditions-subheader3-subtitle5',
	                                            defaultMessage: ''
	                                        })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    null,
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: 'terms-conditions-subheader3-subtitle5-text1',
	                                        defaultMessage: ''
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    { style: { paddingBottom: 0 } },
	                                    _react2.default.createElement(
	                                        'strong',
	                                        { className: _termsConditions2.default.subtitle },
	                                        _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                            id: 'terms-conditions-subheader3-subtitle6',
	                                            defaultMessage: ''
	                                        })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    null,
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: 'terms-conditions-subheader3-subtitle6-text1',
	                                        defaultMessage: ''
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    null,
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: 'terms-conditions-subheader3-subtitle6-text2',
	                                        defaultMessage: ''
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    { style: { paddingLeft: 10 } },
	                                    '- ',
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: 'terms-conditions-subheader3-subtitle6-text2-1',
	                                        defaultMessage: ''
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    { style: { paddingLeft: 10 } },
	                                    '- ',
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: 'terms-conditions-subheader3-subtitle6-text2-2',
	                                        defaultMessage: ''
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    { style: { paddingLeft: 10 } },
	                                    '- ',
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: 'terms-conditions-subheader3-subtitle6-text2-3',
	                                        defaultMessage: ''
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    { style: { paddingLeft: 10 } },
	                                    '- ',
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: 'terms-conditions-subheader3-subtitle6-text2-4',
	                                        defaultMessage: ''
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    { style: { paddingLeft: 10 } },
	                                    '- ',
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: 'terms-conditions-subheader3-subtitle6-text2-5',
	                                        defaultMessage: ''
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    { style: { paddingLeft: 10 } },
	                                    '- ',
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: 'terms-conditions-subheader3-subtitle6-text2-6',
	                                        defaultMessage: ''
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    null,
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: 'terms-conditions-subheader3-subtitle6-text3',
	                                        defaultMessage: ''
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    { style: { paddingLeft: 10 } },
	                                    '- ',
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: 'terms-conditions-subheader3-subtitle6-text3-1',
	                                        defaultMessage: ''
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    { style: { paddingLeft: 10 } },
	                                    '- ',
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: 'terms-conditions-subheader3-subtitle6-text3-2',
	                                        defaultMessage: ''
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    { style: { paddingLeft: 10 } },
	                                    '- ',
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: 'terms-conditions-subheader3-subtitle6-text3-3',
	                                        defaultMessage: ''
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    null,
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: 'terms-conditions-subheader3-subtitle6-text4',
	                                        defaultMessage: ''
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    { style: { paddingLeft: 10 } },
	                                    '- ',
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: 'terms-conditions-subheader3-subtitle6-text4-1',
	                                        defaultMessage: ''
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    { style: { paddingLeft: 10 } },
	                                    '- ',
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: 'terms-conditions-subheader3-subtitle6-text4-2',
	                                        defaultMessage: ''
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    { style: { paddingLeft: 10 } },
	                                    '- ',
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: 'terms-conditions-subheader3-subtitle6-text4-3',
	                                        defaultMessage: ''
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    { style: { paddingLeft: 10 } },
	                                    '- ',
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: 'terms-conditions-subheader3-subtitle6-text4-4',
	                                        defaultMessage: ''
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    null,
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: 'terms-conditions-subheader3-subtitle6-text5',
	                                        defaultMessage: ''
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    { style: { paddingBottom: 0 } },
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: 'terms-conditions-subheader3-subtitle6-text6',
	                                        defaultMessage: ''
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    null,
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: 'terms-conditions-subheader3-subtitle6-text9',
	                                        defaultMessage: ''
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    null,
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: 'terms-conditions-subheader3-subtitle6-text10',
	                                        defaultMessage: ''
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    null,
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: 'terms-conditions-subheader3-subtitle6-text11',
	                                        defaultMessage: ''
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    { style: { paddingBottom: 0 } },
	                                    _react2.default.createElement(
	                                        'strong',
	                                        { className: _termsConditions2.default.subtitle },
	                                        _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                            id: 'terms-conditions-subheader3-subtitle7',
	                                            defaultMessage: ''
	                                        })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    null,
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: 'terms-conditions-subheader3-subtitle7-text1',
	                                        defaultMessage: ''
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    { style: { paddingBottom: 0 } },
	                                    _react2.default.createElement(
	                                        'strong',
	                                        { className: _termsConditions2.default.subtitle },
	                                        _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                            id: 'terms-conditions-subheader3-subtitle8',
	                                            defaultMessage: ''
	                                        })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    null,
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: 'terms-conditions-subheader3-subtitle8-text1',
	                                        defaultMessage: ''
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    { style: { paddingBottom: 0 } },
	                                    _react2.default.createElement(
	                                        'strong',
	                                        { className: _termsConditions2.default.subtitle },
	                                        _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                            id: 'terms-conditions-subheader3-subtitle9',
	                                            defaultMessage: ''
	                                        })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    null,
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: 'terms-conditions-subheader3-subtitle9-text1',
	                                        defaultMessage: ''
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    null,
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: 'terms-conditions-subheader3-subtitle9-text2',
	                                        defaultMessage: ''
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    { style: { paddingBottom: 0 } },
	                                    _react2.default.createElement(
	                                        'strong',
	                                        { className: _termsConditions2.default.subtitle },
	                                        _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                            id: 'terms-conditions-subheader3-subtitle10',
	                                            defaultMessage: ''
	                                        })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    null,
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: 'terms-conditions-subheader3-subtitle10-text1',
	                                        defaultMessage: ''
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    null,
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: 'terms-conditions-subheader3-subtitle10-text2',
	                                        defaultMessage: ''
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    null,
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: 'terms-conditions-subheader3-subtitle10-text3',
	                                        defaultMessage: ''
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    null,
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: 'terms-conditions-subheader3-subtitle10-text4',
	                                        defaultMessage: ''
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    { style: { paddingBottom: 0 } },
	                                    _react2.default.createElement(
	                                        'strong',
	                                        { className: _termsConditions2.default.subtitle },
	                                        _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                            id: 'terms-conditions-subheader3-subtitle11',
	                                            defaultMessage: ''
	                                        })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    null,
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: 'terms-conditions-subheader3-subtitle11-text1',
	                                        defaultMessage: ''
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    { style: { paddingBottom: 0 } },
	                                    _react2.default.createElement(
	                                        'strong',
	                                        { className: _termsConditions2.default.subtitle },
	                                        _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                            id: 'terms-conditions-subheader3-subtitle12',
	                                            defaultMessage: ''
	                                        })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    { style: { paddingBottom: 0 } },
	                                    _react2.default.createElement(
	                                        'strong',
	                                        { className: _termsConditions2.default.subtitle },
	                                        _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                            id: 'terms-conditions-subheader3-subtitle13',
	                                            defaultMessage: ''
	                                        })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    null,
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: 'terms-conditions-subheader3-subtitle12-text1',
	                                        defaultMessage: ''
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    { style: { paddingBottom: 0 } },
	                                    _react2.default.createElement(
	                                        'strong',
	                                        { className: _termsConditions2.default.subtitle },
	                                        _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                            id: 'terms-conditions-subheader3-subtitle14',
	                                            defaultMessage: ''
	                                        })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    null,
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: 'terms-conditions-subheader3-subtitle14-text1',
	                                        defaultMessage: ''
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    { style: { paddingBottom: 0 } },
	                                    _react2.default.createElement(
	                                        'strong',
	                                        { className: _termsConditions2.default.subtitle },
	                                        _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                            id: 'terms-conditions-subheader3-subtitle15',
	                                            defaultMessage: ''
	                                        })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    null,
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: 'terms-conditions-subheader3-subtitle15-text1',
	                                        defaultMessage: ''
	                                    }),
	                                    ' ',
	                                    _react2.default.createElement(
	                                        'a',
	                                        { href: 'https://www.cubalicores.com/privacy-policy' },
	                                        _react2.default.createElement(
	                                            'u',
	                                            null,
	                                            _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                id: 'privacy-policy',
	                                                defaultMessage: ''
	                                            })
	                                        )
	                                    ),
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: 'terms-conditions-subheader3-subtitle15-text2',
	                                        defaultMessage: ''
	                                    }),
	                                    ' ',
	                                    _react2.default.createElement(
	                                        'u',
	                                        null,
	                                        'info@cubalicores.com'
	                                    ),
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: 'terms-conditions-subheader3-subtitle15-text3',
	                                        defaultMessage: ''
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    { style: { paddingBottom: 0 } },
	                                    _react2.default.createElement(
	                                        'strong',
	                                        { className: _termsConditions2.default.subtitle },
	                                        _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                            id: 'terms-conditions-subheader3-subtitle16',
	                                            defaultMessage: ''
	                                        })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    null,
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: 'terms-conditions-subheader3-subtitle16-text1',
	                                        defaultMessage: ''
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    { style: { paddingBottom: 0 } },
	                                    _react2.default.createElement(
	                                        'strong',
	                                        { className: _termsConditions2.default.subtitle },
	                                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'terms-conditions-subheader4', defaultMessage: '' })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    null,
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: 'terms-conditions-subheader4-text1',
	                                        defaultMessage: ''
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    { style: { paddingBottom: 0 } },
	                                    _react2.default.createElement(
	                                        'strong',
	                                        { className: _termsConditions2.default.subtitle },
	                                        _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                            id: 'terms-conditions-subheader4-text2',
	                                            defaultMessage: ''
	                                        })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    null,
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: 'terms-conditions-subheader4-text2-1',
	                                        defaultMessage: ''
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    null,
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: 'terms-conditions-subheader4-text2-2',
	                                        defaultMessage: ''
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    null,
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: 'terms-conditions-subheader5-text2',
	                                        defaultMessage: ''
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    { style: { paddingLeft: 10 } },
	                                    '- ',
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: 'terms-conditions-subheader5-text2-1',
	                                        defaultMessage: ''
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    { style: { paddingLeft: 10 } },
	                                    '- ',
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: 'terms-conditions-subheader5-text2-2',
	                                        defaultMessage: ''
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    { style: { paddingLeft: 10 } },
	                                    '- ',
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: 'terms-conditions-subheader5-text2-3',
	                                        defaultMessage: ''
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    null,
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: 'terms-conditions-subheader5-text3',
	                                        defaultMessage: ''
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    { style: { paddingLeft: 10 } },
	                                    '- ',
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: 'terms-conditions-subheader5-text3-1',
	                                        defaultMessage: ''
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    { style: { paddingLeft: 10 } },
	                                    '- ',
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: 'terms-conditions-subheader5-text3-2',
	                                        defaultMessage: ''
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    { style: { paddingLeft: 10 } },
	                                    '- ',
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: 'terms-conditions-subheader5-text3-3',
	                                        defaultMessage: ''
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    { style: { paddingLeft: 10 } },
	                                    '- ',
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: 'terms-conditions-subheader5-text3-4',
	                                        defaultMessage: ''
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    { style: { paddingLeft: 10 } },
	                                    '- ',
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: 'terms-conditions-subheader5-text3-5',
	                                        defaultMessage: ''
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    { style: { paddingLeft: 10 } },
	                                    '- ',
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: 'terms-conditions-subheader5-text3-6',
	                                        defaultMessage: ''
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    { style: { paddingLeft: 10 } },
	                                    '- ',
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: 'terms-conditions-subheader5-text3-7',
	                                        defaultMessage: ''
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    { style: { paddingLeft: 10 } },
	                                    '- ',
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: 'terms-conditions-subheader5-text3-8',
	                                        defaultMessage: ''
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    { style: { paddingLeft: 10 } },
	                                    '- ',
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: 'terms-conditions-subheader5-text3-9',
	                                        defaultMessage: ''
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    { style: { paddingLeft: 10 } },
	                                    '- ',
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: 'terms-conditions-subheader5-text3-10',
	                                        defaultMessage: ''
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    { style: { paddingBottom: 0 } },
	                                    _react2.default.createElement(
	                                        'strong',
	                                        { className: _termsConditions2.default.subtitle },
	                                        _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                            id: 'terms-conditions-subheader5-text4',
	                                            defaultMessage: ''
	                                        })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    null,
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: 'terms-conditions-subheader5-text4-1',
	                                        defaultMessage: ''
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    { style: { paddingBottom: 0 } },
	                                    _react2.default.createElement(
	                                        'strong',
	                                        { className: _termsConditions2.default.subtitle },
	                                        _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                            id: 'terms-conditions-subheader5-text5',
	                                            defaultMessage: ''
	                                        })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    null,
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: 'terms-conditions-subheader5-text5-1',
	                                        defaultMessage: ''
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    { style: { paddingBottom: 0 } },
	                                    _react2.default.createElement(
	                                        'strong',
	                                        { className: _termsConditions2.default.subtitle },
	                                        _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                            id: 'terms-conditions-subheader5-text6',
	                                            defaultMessage: ''
	                                        })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    null,
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: 'terms-conditions-subheader5-text6-1',
	                                        defaultMessage: ''
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    { style: { paddingBottom: 0 } },
	                                    _react2.default.createElement(
	                                        'strong',
	                                        { className: _termsConditions2.default.subtitle },
	                                        _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                            id: 'terms-conditions-subheader5-text7',
	                                            defaultMessage: ''
	                                        })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    null,
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: 'terms-conditions-subheader5-text7-1',
	                                        defaultMessage: ''
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    null,
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: 'terms-conditions-subheader5-text7-2',
	                                        defaultMessage: ''
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    { style: { paddingBottom: 0 } },
	                                    _react2.default.createElement(
	                                        'strong',
	                                        { className: _termsConditions2.default.subtitle },
	                                        _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                            id: 'terms-conditions-subheader5-text8',
	                                            defaultMessage: ''
	                                        })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    null,
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: 'terms-conditions-subheader5-text9',
	                                        defaultMessage: ''
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    { style: { paddingBottom: 3 } },
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: 'terms-conditions-subheader5-text10',
	                                        defaultMessage: ''
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    Paragraph,
	                                    null,
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: 'terms-conditions-subheader5-text13',
	                                        defaultMessage: ''
	                                    })
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ReturnPolicy;
	}(_react.Component);
	
	exports.default = (0, _reactIntl.injectIntl)(ReturnPolicy);

/***/ },
/* 710 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(11);
	
	var _reactRouterDom = __webpack_require__(26);
	
	var _reactRouterRedux = __webpack_require__(30);
	
	var _layout = __webpack_require__(29);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _appRoutes = __webpack_require__(22);
	
	var _appRoutes2 = _interopRequireDefault(_appRoutes);
	
	var _signin = __webpack_require__(138);
	
	var _signin2 = _interopRequireDefault(_signin);
	
	var _signInForm = __webpack_require__(361);
	
	var _signInForm2 = _interopRequireDefault(_signInForm);
	
	var _userUtils = __webpack_require__(181);
	
	var _userUtils2 = _interopRequireDefault(_userUtils);
	
	var _store = __webpack_require__(40);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UserLogin = function (_Component) {
	    _inherits(UserLogin, _Component);
	
	    function UserLogin(props) {
	        _classCallCheck(this, UserLogin);
	
	        var _this = _possibleConstructorReturn(this, (UserLogin.__proto__ || Object.getPrototypeOf(UserLogin)).call(this, props));
	
	        _this.handleFormSubmit = _this.handleFormSubmit.bind(_this);
	        document.title = _this.props.intl.formatMessage({ id: 'signin', defaultMessage: 'Sign In' });
	        return _this;
	    }
	
	    _createClass(UserLogin, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            if (_userUtils2.default.isLoggedIn()) {
	                this.props.dispatch((0, _reactRouterRedux.push)(_appRoutes2.default.homePageRoute));
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps) {
	            if (this.props.locale !== prevProps.locale) {
	                document.title = this.props.intl.formatMessage({ id: 'signin', defaultMessage: 'Sign In' });
	            }
	        }
	    }, {
	        key: 'handleFormSubmit',
	        value: function handleFormSubmit(formData) {
	            if (formData.user.password) {
	                _userUtils2.default.signUp(formData, this.props.locale.currentLocale).then(function () {
	                    _store2.default.dispatch((0, _reactRouterRedux.push)(_appRoutes2.default.homePageRoute));
	                });
	            } else {
	                _userUtils2.default.sendEmail(formData.user.email, this.props.locale.currentLocale);
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            return _react2.default.createElement(
	                _layout2.default,
	                null,
	                _react2.default.createElement(
	                    'main',
	                    { className: 'content ' + _signin2.default.signin },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'container ' + _signin2.default.bodyContainer },
	                        _react2.default.createElement(
	                            'section',
	                            null,
	                            _react2.default.createElement(
	                                'p',
	                                { className: _signin2.default.titlePage },
	                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'signin', defaultMessage: 'Sign In' })
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'row' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-lg-offset-4 col-lg-4 col-md-4 col-md-offset-4 col-sm-offset-3 col-sm-6 col-xs-12' },
	                                    _react2.default.createElement(_signInForm2.default, { onSubmitCallback: function onSubmitCallback(formData) {
	                                            _this2.handleFormSubmit(formData);
	                                        } })
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return UserLogin;
	}(_react.Component);
	
	exports.default = (0, _reactIntl.injectIntl)(UserLogin);

/***/ },
/* 711 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(26);
	
	var _reactIntl = __webpack_require__(11);
	
	var _urlSanitizer = __webpack_require__(123);
	
	var _urlSanitizer2 = _interopRequireDefault(_urlSanitizer);
	
	var _noImage = __webpack_require__(466);
	
	var _noImage2 = _interopRequireDefault(_noImage);
	
	var _noteTooltip = __webpack_require__(714);
	
	var _noteTooltip2 = _interopRequireDefault(_noteTooltip);
	
	var _productTile = __webpack_require__(2161);
	
	var _productTile2 = _interopRequireDefault(_productTile);
	
	var _loading = __webpack_require__(118);
	
	var _loading2 = _interopRequireDefault(_loading);
	
	var _zoneModal = __webpack_require__(247);
	
	var _zoneModal2 = _interopRequireDefault(_zoneModal);
	
	var _ageValidWrapper = __webpack_require__(348);
	
	var _ageValidWrapper2 = _interopRequireDefault(_ageValidWrapper);
	
	var _categoryBadge = __webpack_require__(244);
	
	var _categoryBadge2 = _interopRequireDefault(_categoryBadge);
	
	var _extraDataModal = __webpack_require__(354);
	
	var _extraDataModal2 = _interopRequireDefault(_extraDataModal);
	
	var _appRoutes = __webpack_require__(22);
	
	var _appRoutes2 = _interopRequireDefault(_appRoutes);
	
	var _browserHistory = __webpack_require__(141);
	
	var _browserHistory2 = _interopRequireDefault(_browserHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable react/no-danger */
	/* eslint-disable comma-dangle */
	
	
	var ProductTile = function (_Component) {
	    _inherits(ProductTile, _Component);
	
	    function ProductTile(props) {
	        _classCallCheck(this, ProductTile);
	
	        var _this = _possibleConstructorReturn(this, (ProductTile.__proto__ || Object.getPrototypeOf(ProductTile)).call(this, props));
	
	        _this.getGenericImagesFromProduct = function (product) {
	            var allImages = product.images;
	            var imagesFromVariants = product.variants.map(function (variant) {
	                return variant.images;
	            }).flat();
	            return allImages.filter(function (image) {
	                return imagesFromVariants.find(function (variantImage) {
	                    return variantImage.id === image.id;
	                }) === undefined;
	            });
	        };
	
	        _this.filterDuplicatedImages = function (images) {
	            var result = [];
	            images.forEach(function (image) {
	                if (image.attributes && image.attributes.styles && image.attributes.styles[11] && image.attributes.styles[11].url && result.findIndex(function (elem) {
	                    return image.attributes.styles[11].url === elem.attributes.styles[11].url;
	                }) === -1) {
	                    result.push(image);
	                }
	            });
	            return result;
	        };
	
	        _this.state = {
	            loadingImage: true,
	            showZoneModal: false,
	            showExtraDataModal: false,
	            extraDataInfo: {}
	        };
	
	        _this.addProductToCart = _this.addProductToCart.bind(_this);
	        _this.imageLoaded = _this.imageLoaded.bind(_this);
	        _this.checkAllProdAreAvailables = _this.checkAllProdAreAvailables.bind(_this);
	        return _this;
	    }
	
	    _createClass(ProductTile, [{
	        key: 'onModalResponse',
	        value: function onModalResponse(response, value) {
	            if (response === 'accept') {
	                var extra = {};
	                extra[this.state.extraDataInfo.id] = value;
	
	                this.props.addProductToCart(this.props.product.master.id, 1, this.props.currentZone, this.props.locale.currentLocale, this.props.access_token, this.props.order, extra);
	            }
	            this.setState(function (state) {
	                return {
	                    showExtraDataModal: !state.showExtraDataModal
	                };
	            });
	        }
	    }, {
	        key: 'getCategory',
	        value: function getCategory() {
	            if (this.props.product.attributes && this.props.product.attributes.shipping_category && this.props.product.attributes.shipping_category.name && this.props.product.attributes.shipping_category.name !== 'Default') {
	                return this.props.product.attributes.shipping_category.name;
	            }
	            return null;
	        }
	    }, {
	        key: 'addProductToCart',
	        value: function addProductToCart() {
	            if (this.props.product.variants.length > 1) {
	                _browserHistory2.default.push(_appRoutes2.default.products + '/' + this.props.product.attributes.slug);
	                return;
	            }
	
	            if (this.props.product.data_extra_types && this.props.product.data_extra_types[0] && this.props.product.data_extra_types[0].attributes) {
	                var _props$product$data_e = this.props.product.data_extra_types[0];
	                var id = _props$product$data_e.id;
	                var _props$product$data_e2 = _props$product$data_e.attributes;
	                var fieldType = _props$product$data_e2.field_type;
	                var isRequired = _props$product$data_e2.is_required;
	                var label = _props$product$data_e2.label;
	
	                this.setState(function (state) {
	                    return {
	                        showExtraDataModal: !state.showExtraDataModal,
	                        extraDataInfo: {
	                            fieldType: fieldType,
	                            isRequired: isRequired,
	                            label: label,
	                            id: id
	                        }
	                    };
	                });
	            } else {
	                this.props.addProductToCart(this.props.product.master.id, 1, this.props.currentZone, this.props.locale.currentLocale, this.props.access_token, this.props.order);
	            }
	        }
	    }, {
	        key: 'checkAllProdAreAvailables',
	        value: function checkAllProdAreAvailables() {
	            var _this2 = this;
	
	            if (!this.props.currentZone) {
	                console.log('CurrentZone is NOT available');
	                return false;
	            }
	            if (!this.props.product || !this.props.product.attributes || !this.props.product.attributes.zone_ids) {
	                console.log('Product zone_ids are NOT available');
	                return false;
	            }
	            if (!this.props.product.attributes.zone_ids.some(function (zone) {
	                return zone === _this2.props.currentZone;
	            })) {
	                console.log('Current product NOT available for curent zone', this.props.product.attributes.zone_ids, this.props.currentZone);
	                return false;
	            }
	
	            if (!this.props.order || !this.props.order.line_items || this.props.order.line_items.length > 0 && !this.props.order.line_items[0].attributes.zone_ids) {
	                console.log('Order zones are NOT available');
	                return false;
	            }
	            return this.props.order.line_items.length === 0 || this.props.order.line_items.every(function (item) {
	                return item.attributes.zone_ids.some(function (zone) {
	                    return zone === _this2.props.currentZone;
	                });
	            });
	        }
	    }, {
	        key: 'imageLoaded',
	        value: function imageLoaded() {
	            this.setState({ loadingImage: false });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            var handleCloseModal = function handleCloseModal(cleanOrder) {
	                if (cleanOrder) {
	                    _this3.props.emptyCart(_this3.props.order, _this3.props.locale.currentLocale);
	                }
	                _this3.setState({
	                    showZoneModal: false
	                });
	            };
	
	            var imageUrl = '';
	
	            var defaultImage = this.filterDuplicatedImages(this.getGenericImagesFromProduct(this.props.product).concat(this.props.product.master.images));
	
	            var image = defaultImage[0];
	
	            var productName = this.props.product && this.props.product.attributes && this.props.product.attributes.name;
	
	            var productPrice = this.props.product && this.props.product.master && this.props.product.master.attributes && this.props.product.master.attributes.display_price;
	
	            var productDescription = this.props.product && this.props.product.attributes && this.props.product.attributes.description;
	
	            var getProductDescriptionMarkup = function getProductDescriptionMarkup() {
	                return { __html: productDescription };
	            };
	
	            var productInStock = this.props.product && this.props.product.attributes && this.props.product.attributes.in_stock;
	
	            var productNote = this.props.product && this.props.product.attributes && this.props.product.attributes.notes;
	
	            var productShowURL = this.props.product && this.props.product.attributes && '/products/' + this.props.product.attributes.slug;
	
	            var productAgeValid = this.props.product && this.props.product.attributes && this.props.product.attributes.age_valid;
	
	            if (image && image.attributes && image.attributes.styles) {
	                imageUrl = _urlSanitizer2.default.makeAbsolute(image.attributes.styles[5].url);
	            }
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                productShowURL && _react2.default.createElement(
	                    'div',
	                    { className: 'col-lg-4 col-md-4 col-sm-6 col-xs-12 ' + _productTile2.default.productTile },
	                    _react2.default.createElement(
	                        'div',
	                        { className: '' + _productTile2.default.productBlock },
	                        this.getCategory() && _react2.default.createElement(_categoryBadge2.default, { label: this.getCategory(), color: '#FE6902' }),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'thumb-img-block ' + _productTile2.default.imgMain },
	                            _react2.default.createElement(
	                                _ageValidWrapper2.default,
	                                { productAgeValid: productAgeValid },
	                                _react2.default.createElement(
	                                    _reactRouterDom.Link,
	                                    { to: productShowURL, className: 'product-link' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: '' + _productTile2.default.imgLoadingParent },
	                                        _react2.default.createElement('img', {
	                                            onLoad: this.imageLoaded,
	                                            className: 'product-tile-image ' + _productTile2.default.productMainImage,
	                                            alt: productName,
	                                            src: imageUrl || _noImage2.default,
	                                            style: { display: this.state.loadingImage ? 'none' : 'block', objectFit: imageUrl ? 'contain' : 'cover' }
	                                        }),
	                                        !productInStock && _react2.default.createElement(
	                                            'span',
	                                            { className: _productTile2.default.outStock },
	                                            _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                id: 'out-of-stock',
	                                                defaultMessage: 'Out Stock'
	                                            })
	                                        ),
	                                        productNote && _react2.default.createElement(
	                                            _noteTooltip2.default,
	                                            { note: productNote },
	                                            _react2.default.createElement(
	                                                'span',
	                                                { className: _productTile2.default.note },
	                                                _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                    id: 'note',
	                                                    defaultMessage: 'Notes'
	                                                })
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: _productTile2.default.imgLoadingContainer, style: { display: this.state.loadingImage ? 'block' : 'none' } },
	                                            _react2.default.createElement('div', { className: _loading2.default.spinnerDark })
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: '' + _productTile2.default.textBlock },
	                            _react2.default.createElement(
	                                'h4',
	                                { className: '' + _productTile2.default.titleCard },
	                                _react2.default.createElement(
	                                    _ageValidWrapper2.default,
	                                    { productAgeValid: productAgeValid },
	                                    _react2.default.createElement(
	                                        _reactRouterDom.Link,
	                                        { to: productShowURL },
	                                        productName
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'h5',
	                                { className: '' + _productTile2.default.commentFirst },
	                                _react2.default.createElement(_reactRouterDom.Link, { to: productShowURL + '?a=comment' })
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'row' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-lg-12 col-md-12 col-sm-12 col-xs-12' },
	                                    _react2.default.createElement('div', { dangerouslySetInnerHTML: getProductDescriptionMarkup(), className: '' + _productTile2.default.productDescription })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'row' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-lg-12 col-md-12 col-sm-12 col-xs-12' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'text-right ' + _productTile2.default.lastRow },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: _productTile2.default.price },
	                                            productPrice
	                                        ),
	                                        _react2.default.createElement(
	                                            _ageValidWrapper2.default,
	                                            { productAgeValid: productAgeValid },
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: _productTile2.default.buttons },
	                                                _react2.default.createElement(
	                                                    'span',
	                                                    { className: _productTile2.default.wishlistButton },
	                                                    _react2.default.createElement('span', { className: 'glyphicon glyphicon-heart' })
	                                                ),
	                                                _react2.default.createElement(
	                                                    'span',
	                                                    {
	                                                        className: !this.props.order.addingProductToCart ? _productTile2.default.addToCartButton : _productTile2.default.disableAddToCartButton,
	                                                        onClick: !this.props.order.addingProductToCart ? this.addProductToCart : function () {}
	                                                    },
	                                                    _react2.default.createElement('span', { className: 'glyphicon glyphicon-shopping-cart' })
	                                                )
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(_zoneModal2.default, {
	                        show: this.state.showZoneModal,
	                        onHide: handleCloseModal
	                    })
	                ),
	                this.state.showExtraDataModal && _react2.default.createElement(_extraDataModal2.default, {
	                    fieldType: this.state.extraDataInfo.fieldType,
	                    label: this.state.extraDataInfo.label,
	                    isRequired: this.state.extraDataInfo.isRequired,
	                    onResponse: function onResponse(response, value) {
	                        _this3.onModalResponse(response, value);
	                    }
	                })
	            );
	        }
	    }]);
	
	    return ProductTile;
	}(_react.Component);
	
	exports.default = ProductTile;

/***/ },
/* 712 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _comingSoon = __webpack_require__(1613);
	
	var _comingSoon2 = _interopRequireDefault(_comingSoon);
	
	var _imageComingsoon = __webpack_require__(2144);
	
	var _imageComingsoon2 = _interopRequireDefault(_imageComingsoon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NonSearchResult = function NonSearchResult() {
	    return _react2.default.createElement(
	        'div',
	        { className: _imageComingsoon2.default.nonSearchResult },
	        _react2.default.createElement('img', { className: _imageComingsoon2.default.nonSearchResultImage, src: _comingSoon2.default, alt: 'nonsearch' }),
	        _react2.default.createElement(
	            'p',
	            { className: _imageComingsoon2.default.nonSearchResultMessage },
	            'Muy pronto tendremos muchos productos en esta \xE1rea'
	        )
	    );
	};
	
	exports.default = NonSearchResult;

/***/ },
/* 713 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _productShow = __webpack_require__(604);
	
	var _productShow2 = _interopRequireDefault(_productShow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ProductImageThumb = function (_Component) {
	    _inherits(ProductImageThumb, _Component);
	
	    function ProductImageThumb() {
	        _classCallCheck(this, ProductImageThumb);
	
	        return _possibleConstructorReturn(this, (ProductImageThumb.__proto__ || Object.getPrototypeOf(ProductImageThumb)).apply(this, arguments));
	    }
	
	    _createClass(ProductImageThumb, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'col-sm-4 col-xs-4 col-md-4 col-lg-4 ' + _productShow2.default.thumbnailContainer },
	                _react2.default.createElement(
	                    'div',
	                    { className: _productShow2.default.thumbnail },
	                    _react2.default.createElement('img', {
	                        className: _productShow2.default.productThumbs,
	                        alt: this.props.productName,
	                        src: this.props.imageUrl,
	                        onClick: function onClick() {
	                            return _this2.props.onClickThumbnail(_this2.props.imageNo);
	                        }
	                    })
	                )
	            );
	        }
	    }]);
	
	    return ProductImageThumb;
	}(_react.Component);
	
	exports.default = ProductImageThumb;

/***/ },
/* 714 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = NoteTooltip;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(38);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function NoteTooltip(props) {
	    var tooltip = _react2.default.createElement(
	        _reactBootstrap.Tooltip,
	        { placement: 'right', className: 'in', id: 'tooltip', style: { marginTop: '5px' } },
	        props.note
	    );
	    return _react2.default.createElement(
	        _reactBootstrap.OverlayTrigger,
	        {
	            overlay: tooltip,
	            placement: 'right',
	            delayShow: 300,
	            delayHide: 150
	        },
	        props.children
	    );
	}

/***/ },
/* 715 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(11);
	
	var _productDetailsQuantitySelector = __webpack_require__(2145);
	
	var _productDetailsQuantitySelector2 = _interopRequireDefault(_productDetailsQuantitySelector);
	
	var _helper = __webpack_require__(60);
	
	var _ageValidWrapper = __webpack_require__(348);
	
	var _ageValidWrapper2 = _interopRequireDefault(_ageValidWrapper);
	
	var _securityIcons = __webpack_require__(355);
	
	var _securityIcons2 = _interopRequireDefault(_securityIcons);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProductDetailsQuantitySelector = function ProductDetailsQuantitySelector(props) {
	    var productPrice = props.productPrice;
	    var productAgeValid = props.productAgeValid;
	    var addingProductToCart = props.addingProductToCart;
	    var dataExtraType = props.dataExtraType;
	
	    var _useState = (0, _react.useState)(1);
	
	    var _useState2 = _slicedToArray(_useState, 2);
	
	    var quantity = _useState2[0];
	    var setQuantity = _useState2[1];
	
	    var onPressMinus = function onPressMinus() {
	        if (quantity > 1) {
	            setQuantity(quantity - 1);
	        }
	    };
	    var onChangeQuantity = function onChangeQuantity(e) {
	        if (quantity !== e.target.value && parseInt(e.target.value, 10) > 0) {
	            setQuantity(parseInt(e.target.value, 10));
	        }
	    };
	    var onPressPlus = function onPressPlus() {
	        setQuantity(quantity + 1);
	    };
	    var addProductToCart = function addProductToCart() {
	        return props.onAddProductToCart(quantity);
	    };
	
	    return _react2.default.createElement(
	        'div',
	        { className: _productDetailsQuantitySelector2.default.buyPanel },
	        _react2.default.createElement(
	            'div',
	            { className: '' + _productDetailsQuantitySelector2.default.buyPanelOptions },
	            _react2.default.createElement(
	                'div',
	                { className: 'pull-right ' + _productDetailsQuantitySelector2.default.inlineBlock },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'text-center ' + _productDetailsQuantitySelector2.default.wishCart },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'text-right ' + _productDetailsQuantitySelector2.default.innerAddWish },
	                        _react2.default.createElement(
	                            'a',
	                            { href: '', className: _productDetailsQuantitySelector2.default.addWishList },
	                            _react2.default.createElement(
	                                'span',
	                                { className: _productDetailsQuantitySelector2.default.addWishListButton },
	                                _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                    id: 'add-to-wish-list',
	                                    defaultMessage: 'Add to Wish List'
	                                })
	                            ),
	                            _react2.default.createElement('i', { className: 'pe-7f-like pe-va' })
	                        ),
	                        _react2.default.createElement(
	                            'a',
	                            {
	                                href: '',
	                                className: _productDetailsQuantitySelector2.default.addToCart
	                            },
	                            _react2.default.createElement(
	                                'span',
	                                { className: _productDetailsQuantitySelector2.default.addToCartButton },
	                                _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                    id: 'add-to-cart',
	                                    defaultMessage: 'Add to Cart'
	                                })
	                            ),
	                            _react2.default.createElement('i', { className: 'pe-va pe-7f-cart' })
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: _productDetailsQuantitySelector2.default.quantityProd },
	                _react2.default.createElement(
	                    'div',
	                    { className: _productDetailsQuantitySelector2.default.quantityProdOptions },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                        id: 'quantity',
	                        defaultMessage: 'Quantity'
	                    })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: _productDetailsQuantitySelector2.default.selectorQuantity },
	                    _react2.default.createElement(
	                        'button',
	                        {
	                            className: _productDetailsQuantitySelector2.default.minus,
	                            type: 'button',
	                            disabled: quantity <= 1 || props.dataExtraType && props.dataExtraType.length > 0 ? 'disabled' : '',
	                            onClick: onPressMinus
	                        },
	                        '-'
	                    ),
	                    _react2.default.createElement(
	                        'span',
	                        { className: _productDetailsQuantitySelector2.default.quantityContainer },
	                        _react2.default.createElement('input', {
	                            title: 'Quantity',
	                            type: 'text',
	                            value: quantity,
	                            onChange: onChangeQuantity,
	                            className: 'form-control quantity',
	                            disabled: props.dataExtraType && props.dataExtraType.length > 0 ? 'disabled' : ''
	                        })
	                    ),
	                    _react2.default.createElement(
	                        'button',
	                        { className: _productDetailsQuantitySelector2.default.plus, type: 'button', disabled: props.dataExtraType && props.dataExtraType.length > 0 ? 'disabled' : '', onClick: onPressPlus },
	                        '+'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: _productDetailsQuantitySelector2.default.totalPrice },
	                _react2.default.createElement(
	                    'div',
	                    { className: _productDetailsQuantitySelector2.default.totalPriceTitle },
	                    _react2.default.createElement(
	                        'span',
	                        null,
	                        _react2.default.createElement(_reactIntl.FormattedMessage, {
	                            id: 'total-price',
	                            defaultMessage: 'Total price'
	                        })
	                    )
	                ),
	                _react2.default.createElement(
	                    'span',
	                    { className: _productDetailsQuantitySelector2.default.totalPriceTitleValue },
	                    _helper.priceFormat.format(productPrice * quantity)
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: _productDetailsQuantitySelector2.default.actions },
	                _react2.default.createElement(
	                    'div',
	                    { className: _productDetailsQuantitySelector2.default.addCartAction },
	                    _react2.default.createElement(
	                        'div',
	                        { className: _productDetailsQuantitySelector2.default.addCartActionInner },
	                        _react2.default.createElement(
	                            _ageValidWrapper2.default,
	                            { productAgeValid: productAgeValid },
	                            _react2.default.createElement(
	                                'button',
	                                {
	                                    type: 'button',
	                                    disabled: addingProductToCart,
	                                    className: !addingProductToCart ? _productDetailsQuantitySelector2.default.addCartExpandedButton : _productDetailsQuantitySelector2.default.disableAddCartExpandedButton,
	                                    onClick: addProductToCart
	                                },
	                                _react2.default.createElement('i', { className: 'pe-va pe-7f-cart' }),
	                                _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                    id: 'add-to-cart',
	                                    defaultMessage: 'Add to Cart'
	                                })
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'row', style: { marginTop: '20px' } },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-lg-12 col-md-12 col-sm-12 col-xs-12 hidden-xs' },
	                    _react2.default.createElement(_securityIcons2.default, null)
	                )
	            )
	        )
	    );
	};
	
	exports.default = ProductDetailsQuantitySelector;

/***/ },
/* 716 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _imageThumbnail = __webpack_require__(713);
	
	var _imageThumbnail2 = _interopRequireDefault(_imageThumbnail);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ThumbnailList = function (_Component) {
	    _inherits(ThumbnailList, _Component);
	
	    function ThumbnailList() {
	        _classCallCheck(this, ThumbnailList);
	
	        return _possibleConstructorReturn(this, (ThumbnailList.__proto__ || Object.getPrototypeOf(ThumbnailList)).apply(this, arguments));
	    }
	
	    _createClass(ThumbnailList, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var imagesMarkup = this.props.images.length > 1 && this.props.images.map(function (image, idx) {
	                return _react2.default.createElement(_imageThumbnail2.default, {
	                    key: 'thumbnail-image-' + idx,
	                    imageUrl: image,
	                    onClickThumbnail: _this2.props.onClickThumbnail,
	                    imageNo: idx
	                });
	            });
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                imagesMarkup
	            );
	        }
	    }]);
	
	    return ThumbnailList;
	}(_react.Component);
	
	exports.default = ThumbnailList;

/***/ },
/* 717 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _DropdownButton = __webpack_require__(159);
	
	var _DropdownButton2 = _interopRequireDefault(_DropdownButton);
	
	var _MenuItem = __webpack_require__(504);
	
	var _MenuItem2 = _interopRequireDefault(_MenuItem);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(11);
	
	var _variantSelector = __webpack_require__(2146);
	
	var _variantSelector2 = _interopRequireDefault(_variantSelector);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var VariantSelector = function VariantSelector(props) {
	    var variants = props.variants;
	    var currentVariant = props.currentVariant;
	
	    return currentVariant && _react2.default.createElement(
	        _DropdownButton2.default,
	        {
	            as: 'button',
	            title: currentVariant.attributes.options_text,
	            id: 'variantSelector' },
	        variants.map(function (variant) {
	            return _react2.default.createElement(
	                _MenuItem2.default,
	                {
	                    as: 'button',
	                    className: 'button-secondary inv button-small ' + _variantSelector2.default.variantItem,
	                    id: variant.id,
	                    key: variant.id,
	                    onSelect: function onSelect() {
	                        props.onVariantSelected(variant);
	                    } },
	                variant.attributes.options_text,
	                !variant.attributes.in_stock && _react2.default.createElement(
	                    'span',
	                    null,
	                    '\xA0\xA0-\xA0 (',
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'out-of-stock', defaultMessage: 'Out of stock' }),
	                    ')'
	                )
	            );
	        })
	    );
	}; /* eslint-disable react/jsx-closing-bracket-location */
	exports.default = VariantSelector;

/***/ },
/* 718 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _reactIntl = __webpack_require__(11);
	
	var _address = __webpack_require__(142);
	
	var _address2 = _interopRequireDefault(_address);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BillShipAddress = function (_Component) {
	    _inherits(BillShipAddress, _Component);
	
	    function BillShipAddress() {
	        _classCallCheck(this, BillShipAddress);
	
	        return _possibleConstructorReturn(this, (BillShipAddress.__proto__ || Object.getPrototypeOf(BillShipAddress)).apply(this, arguments));
	    }
	
	    _createClass(BillShipAddress, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props;
	            var billAddress = _props.billAddress;
	            var shipAddress = _props.shipAddress;
	            var className = _props.className;
	
	
	            return _react2.default.createElement(
	                'div',
	                { className: className },
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                        'h4',
	                        null,
	                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'billingAddress', defaultMessage: 'Billing Address' }),
	                        ':'
	                    ),
	                    billAddress && _react2.default.createElement(_address2.default, { address: billAddress.attributes })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                        'h4',
	                        null,
	                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'shippingAddress', defaultMessage: 'Shipping Address' }),
	                        ':'
	                    ),
	                    shipAddress && _react2.default.createElement(_address2.default, { address: shipAddress.attributes })
	                )
	            );
	        }
	    }]);
	
	    return BillShipAddress;
	}(_react.Component);
	
	exports.default = (0, _reactIntl.injectIntl)(BillShipAddress);
	
	
	BillShipAddress.defaultProps = {
	    className: ''
	};
	
	BillShipAddress.propTypes = {
	    billAddress: (0, _propTypes.shape)({
	        attributes: (0, _propTypes.shape)({
	            firstname: _propTypes.string,
	            lastname: _propTypes.string,
	            address1: _propTypes.string,
	            address2: _propTypes.string,
	            city: _propTypes.string,
	            state_name: _propTypes.string,
	            zipcode: _propTypes.string,
	            country_name: _propTypes.string,
	            phone: _propTypes.string
	        })
	    }).isRequired,
	    shipAddress: (0, _propTypes.shape)({
	        attributes: (0, _propTypes.shape)({
	            firstname: _propTypes.string,
	            lastname: _propTypes.string,
	            address1: _propTypes.string,
	            address2: _propTypes.string,
	            city: _propTypes.string,
	            state_name: _propTypes.string,
	            zipcode: _propTypes.string,
	            country_name: _propTypes.string,
	            phone: _propTypes.string
	        })
	    }).isRequired,
	    className: _propTypes.string
	};

/***/ },
/* 719 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(38);
	
	var _reactIntl = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EmptyCartWarningModal = function EmptyCartWarningModal(props) {
	    var onClose = props.onClose;
	    var messageId = props.messageId;
	    var isOpen = props.isOpen;
	
	    return _react2.default.createElement(
	        _reactBootstrap.Modal,
	        { show: isOpen, bsSize: 'large', 'aria-labelledby': 'contained-modal-title-lg', onHide: function onHide() {
	                return onClose(false);
	            } },
	        _react2.default.createElement(
	            _reactBootstrap.Modal.Header,
	            { closeButton: true },
	            _react2.default.createElement(
	                _reactBootstrap.Modal.Title,
	                { id: 'contained-modal-title-lg' },
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'modal-store-title', defaultMessage: 'Alert' })
	            )
	        ),
	        _react2.default.createElement(
	            _reactBootstrap.Modal.Body,
	            null,
	            _react2.default.createElement(
	                'p',
	                null,
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: messageId, defaultMessage: 'default' })
	            )
	        ),
	        _react2.default.createElement(
	            _reactBootstrap.Modal.Footer,
	            null,
	            _react2.default.createElement(
	                _reactBootstrap.Button,
	                { onClick: function onClick() {
	                        return onClose(true);
	                    } },
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'modal-store-button-empty', defaultMessage: 'Empty' })
	            ),
	            _react2.default.createElement(
	                _reactBootstrap.Button,
	                { onClick: function onClick() {
	                        return onClose(false);
	                    } },
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'modal-store-button-close', defaultMessage: 'Cancel' })
	            )
	        )
	    );
	};
	
	exports.default = (0, _reactIntl.injectIntl)(EmptyCartWarningModal);

/***/ },
/* 720 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(26);
	
	var _reactIntl = __webpack_require__(11);
	
	var _appRoutes = __webpack_require__(22);
	
	var _appRoutes2 = _interopRequireDefault(_appRoutes);
	
	var _ssl = __webpack_require__(1623);
	
	var _ssl2 = _interopRequireDefault(_ssl);
	
	var _secconn = __webpack_require__(1622);
	
	var _secconn2 = _interopRequireDefault(_secconn);
	
	var _privacy = __webpack_require__(1619);
	
	var _privacy2 = _interopRequireDefault(_privacy);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Footer = function (_Component) {
	    _inherits(Footer, _Component);
	
	    function Footer() {
	        _classCallCheck(this, Footer);
	
	        return _possibleConstructorReturn(this, (Footer.__proto__ || Object.getPrototypeOf(Footer)).apply(this, arguments));
	    }
	
	    _createClass(Footer, [{
	        key: 'render',
	        value: function render() {
	            var intl = this.props.intl;
	
	
	            return _react2.default.createElement(
	                'footer',
	                { className: 'footer-section' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'footer-container' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'links-block' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'health-message' },
	                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'smoking-harms-health', defaultMessage: 'Health authorities warn: smoking harms health.' }),
	                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'alcohol-abuse', defaultMessage: 'Alcohol abuse is harmful to health. eat in moderation.' })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'container' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'row' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'column col-xs-12 col-sm-12 hidden-md hidden-lg' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'column-inner' },
	                                        _react2.default.createElement(
	                                            'ul',
	                                            { className: 'list-unstyled share' },
	                                            _react2.default.createElement(
	                                                'li',
	                                                { className: 'title title-xs' },
	                                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'follow-us', defaultMessage: 'follow us' })
	                                            ),
	                                            _react2.default.createElement(
	                                                'li',
	                                                { className: 'social-net' },
	                                                _react2.default.createElement(
	                                                    'a',
	                                                    { href: '#' },
	                                                    _react2.default.createElement(
	                                                        'i',
	                                                        { className: 'icon-facebook' },
	                                                        _react2.default.createElement(
	                                                            'svg',
	                                                            { xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 7.76 14.94' },
	                                                            _react2.default.createElement(
	                                                                'g',
	                                                                null,
	                                                                _react2.default.createElement(
	                                                                    'g',
	                                                                    null,
	                                                                    _react2.default.createElement('path', {
	                                                                        /* eslint-disable-next-line max-len */
	                                                                        d: 'M7.32,8.13l.34-2.66H5V3.77C5,3,5.25,2.48,6.35,2.48H7.76V.1a18.74,18.74,0,0,0-2-.1A3.2,3.2,0,0,0,2.29,3.51v2H0V8.13H2.29v6.82H5V8.13Z'
	                                                                    })
	                                                                )
	                                                            )
	                                                        )
	                                                    )
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                'li',
	                                                { className: 'social-net' },
	                                                _react2.default.createElement(
	                                                    'a',
	                                                    { href: '#' },
	                                                    _react2.default.createElement(
	                                                        'i',
	                                                        { className: 'icon-instagram' },
	                                                        _react2.default.createElement(
	                                                            'svg',
	                                                            { xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 13.01 13' },
	                                                            _react2.default.createElement(
	                                                                'g',
	                                                                null,
	                                                                _react2.default.createElement(
	                                                                    'g',
	                                                                    null,
	                                                                    _react2.default.createElement('path', {
	                                                                        /* eslint-disable-next-line max-len */
	                                                                        d: 'M1.67,0h9.67A1.67,1.67,0,0,1,13,1.67v9.67A1.67,1.67,0,0,1,11.34,13H1.67A1.67,1.67,0,0,1,0,11.34V1.67A1.67,1.67,0,0,1,1.67,0Zm7.8,1.44A.59.59,0,0,0,8.89,2v1.4A.59.59,0,0,0,9.47,4h1.47a.59.59,0,0,0,.59-.59V2a.59.59,0,0,0-.59-.59ZM11.54,5.5H10.39a3.8,3.8,0,0,1,.17,1.12,4,4,0,0,1-4,3.92,4,4,0,0,1-4-3.92A3.82,3.82,0,0,1,2.64,5.5H1.45V11a.52.52,0,0,0,.52.52H11a.52.52,0,0,0,.52-.52Zm-5-1.56A2.57,2.57,0,0,0,3.9,6.47,2.57,2.57,0,0,0,6.52,9,2.57,2.57,0,0,0,9.13,6.47,2.57,2.57,0,0,0,6.52,3.94Z'
	                                                                    })
	                                                                )
	                                                            )
	                                                        )
	                                                    )
	                                                )
	                                            )
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'column col-xs-5 col-sm-5 hidden-md hidden-lg' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'column-inner' },
	                                        _react2.default.createElement(
	                                            'ul',
	                                            { className: 'list-unstyled' },
	                                            _react2.default.createElement(
	                                                'li',
	                                                null,
	                                                _react2.default.createElement(
	                                                    _reactRouterDom.Link,
	                                                    { to: _appRoutes2.default.frequentQuestions },
	                                                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'frequent-questions', defaultMessage: 'Frecuent Questions' })
	                                                )
	                                            )
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'column col-xs-7 col-sm-7 hidden-md hidden-lg' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'column-inner' },
	                                        _react2.default.createElement(
	                                            'ul',
	                                            { className: 'list-unstyled' },
	                                            _react2.default.createElement(
	                                                'li',
	                                                null,
	                                                _react2.default.createElement(
	                                                    _reactRouterDom.Link,
	                                                    { to: _appRoutes2.default.policy },
	                                                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'privacy-policy', defaultMessage: 'Privacy Policy' })
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                'li',
	                                                null,
	                                                _react2.default.createElement(
	                                                    _reactRouterDom.Link,
	                                                    { to: _appRoutes2.default.returns },
	                                                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'return-policy', defaultMessage: 'Return Policy' })
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                'li',
	                                                null,
	                                                _react2.default.createElement(
	                                                    _reactRouterDom.Link,
	                                                    { to: _appRoutes2.default.shipping },
	                                                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'shipping-and-rates', defaultMessage: 'Shipping & Rates' })
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                'li',
	                                                null,
	                                                _react2.default.createElement(
	                                                    _reactRouterDom.Link,
	                                                    { to: _appRoutes2.default.terms },
	                                                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'term-and-conditions', defaultMessage: 'Terms & Conditions' })
	                                                )
	                                            )
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'column col-md-2 hidden-md hidden-lg' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'column-inner', style: { marginTop: '15px' } },
	                                        _react2.default.createElement(
	                                            'ul',
	                                            { className: 'list-unstyled' },
	                                            _react2.default.createElement(
	                                                'li',
	                                                null,
	                                                _react2.default.createElement(
	                                                    'a',
	                                                    { href: 'mailto:info@cubalicores.com' },
	                                                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'info-cubalicores', defaultMessage: 'info@cubalicores.com' })
	                                                )
	                                            )
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'column col-md-2 col-md-offset-2 hidden-sm hidden-xs' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'column-inner' },
	                                        _react2.default.createElement(
	                                            'p',
	                                            { className: 'title' },
	                                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'my-account', defaultMessage: 'My Account' })
	                                        ),
	                                        _react2.default.createElement(
	                                            'ul',
	                                            { className: 'list-unstyled' },
	                                            _react2.default.createElement(
	                                                'li',
	                                                null,
	                                                _react2.default.createElement(
	                                                    _reactRouterDom.Link,
	                                                    { to: _appRoutes2.default.terms },
	                                                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'term-and-conditions', defaultMessage: 'Terms & Conditions' })
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                'li',
	                                                null,
	                                                _react2.default.createElement(
	                                                    _reactRouterDom.Link,
	                                                    { to: _appRoutes2.default.frequentQuestions },
	                                                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'frequent-questions', defaultMessage: 'Frecuent Questions' })
	                                                )
	                                            )
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'column col-md-2 hidden-sm hidden-xs' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'column-inner' },
	                                        _react2.default.createElement(
	                                            'p',
	                                            { className: 'title' },
	                                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'customer-service', defaultMessage: 'Customer Service' })
	                                        ),
	                                        _react2.default.createElement(
	                                            'ul',
	                                            { className: 'list-unstyled' },
	                                            _react2.default.createElement(
	                                                'li',
	                                                null,
	                                                _react2.default.createElement(
	                                                    _reactRouterDom.Link,
	                                                    { to: _appRoutes2.default.policy },
	                                                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'privacy-policy', defaultMessage: 'Privacy Policy' })
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                'li',
	                                                null,
	                                                _react2.default.createElement(
	                                                    _reactRouterDom.Link,
	                                                    { to: _appRoutes2.default.returns },
	                                                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'return-policy', defaultMessage: 'Return Policy' })
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                'li',
	                                                null,
	                                                _react2.default.createElement(
	                                                    _reactRouterDom.Link,
	                                                    { to: _appRoutes2.default.shipping },
	                                                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'shipping-and-rates', defaultMessage: 'Shipping & Rates' })
	                                                )
	                                            )
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'column col-md-2 hidden-sm hidden-xs' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'column-inner' },
	                                        _react2.default.createElement(
	                                            'p',
	                                            { className: 'title hidden-xs' },
	                                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'follow-us', defaultMessage: 'follow us' })
	                                        ),
	                                        _react2.default.createElement(
	                                            'ul',
	                                            { className: 'list-unstyled share' },
	                                            _react2.default.createElement(
	                                                'li',
	                                                { className: 'social-net' },
	                                                _react2.default.createElement(
	                                                    'a',
	                                                    { href: '', target: '_blank' },
	                                                    _react2.default.createElement(
	                                                        'i',
	                                                        { className: 'icon-facebook' },
	                                                        _react2.default.createElement(
	                                                            'svg',
	                                                            { xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 7.76 14.94' },
	                                                            _react2.default.createElement(
	                                                                'g',
	                                                                null,
	                                                                _react2.default.createElement(
	                                                                    'g',
	                                                                    null,
	                                                                    _react2.default.createElement('path', {
	                                                                        /* eslint-disable-next-line max-len */
	                                                                        d: 'M7.32,8.13l.34-2.66H5V3.77C5,3,5.25,2.48,6.35,2.48H7.76V.1a18.74,18.74,0,0,0-2-.1A3.2,3.2,0,0,0,2.29,3.51v2H0V8.13H2.29v6.82H5V8.13Z'
	                                                                    })
	                                                                )
	                                                            )
	                                                        )
	                                                    )
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                'li',
	                                                { className: 'social-net' },
	                                                _react2.default.createElement(
	                                                    'a',
	                                                    { href: '#', target: '_blank' },
	                                                    _react2.default.createElement(
	                                                        'i',
	                                                        { className: 'icon-instagram' },
	                                                        _react2.default.createElement(
	                                                            'svg',
	                                                            { xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 13.01 13' },
	                                                            _react2.default.createElement(
	                                                                'g',
	                                                                null,
	                                                                _react2.default.createElement(
	                                                                    'g',
	                                                                    null,
	                                                                    _react2.default.createElement('path', {
	                                                                        /* eslint-disable-next-line max-len */
	                                                                        d: 'M1.67,0h9.67A1.67,1.67,0,0,1,13,1.67v9.67A1.67,1.67,0,0,1,11.34,13H1.67A1.67,1.67,0,0,1,0,11.34V1.67A1.67,1.67,0,0,1,1.67,0Zm7.8,1.44A.59.59,0,0,0,8.89,2v1.4A.59.59,0,0,0,9.47,4h1.47a.59.59,0,0,0,.59-.59V2a.59.59,0,0,0-.59-.59ZM11.54,5.5H10.39a3.8,3.8,0,0,1,.17,1.12,4,4,0,0,1-4,3.92,4,4,0,0,1-4-3.92A3.82,3.82,0,0,1,2.64,5.5H1.45V11a.52.52,0,0,0,.52.52H11a.52.52,0,0,0,.52-.52Zm-5-1.56A2.57,2.57,0,0,0,3.9,6.47,2.57,2.57,0,0,0,6.52,9,2.57,2.57,0,0,0,9.13,6.47,2.57,2.57,0,0,0,6.52,3.94Z'
	                                                                    })
	                                                                )
	                                                            )
	                                                        )
	                                                    )
	                                                )
	                                            )
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'column col-md-2 hidden-sm hidden-xs' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'column-inner' },
	                                        _react2.default.createElement(
	                                            'p',
	                                            { className: 'title hidden-xs' },
	                                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'contact', defaultMessage: 'contact' })
	                                        ),
	                                        _react2.default.createElement(
	                                            'ul',
	                                            { className: 'list-unstyled' },
	                                            _react2.default.createElement(
	                                                'li',
	                                                null,
	                                                _react2.default.createElement(
	                                                    'a',
	                                                    { href: 'mailto:info@cubalicores.com' },
	                                                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'info-cubalicores', defaultMessage: 'info@cubalicores.com' })
	                                                )
	                                            )
	                                        )
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'row text-center margin-top-50' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-lg-12 col-md-12 col-sm-12 col-xs-12' },
	                                    _react2.default.createElement(
	                                        'ul',
	                                        { className: 'list-inline' },
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            _react2.default.createElement('img', {
	                                                src: _ssl2.default,
	                                                alt: intl.formatMessage({
	                                                    id: 'secure-checkout',
	                                                    defaultMessage: 'Secure Checkout'
	                                                })
	                                            })
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            _react2.default.createElement('img', {
	                                                src: _secconn2.default,
	                                                alt: intl.formatMessage({
	                                                    id: 'secure-connection',
	                                                    defaultMessage: 'Secure Connection'
	                                                })
	                                            })
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            _react2.default.createElement('img', {
	                                                src: _privacy2.default,
	                                                alt: intl.formatMessage({
	                                                    id: 'privacy-protected',
	                                                    defaultMessage: 'Privacy Protected'
	                                                })
	                                            })
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'mini-footer-block' },
	                        _react2.default.createElement('div', { className: 'primary-brand pull-left' }),
	                        _react2.default.createElement('div', { className: 'break-left' }),
	                        _react2.default.createElement('div', { className: 'break-right' }),
	                        _react2.default.createElement('div', { className: 'secondary-brand' }),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'copyright' },
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'copyright', defaultMessage: 'Copyright' })
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return Footer;
	}(_react.Component);
	
	exports.default = (0, _reactIntl.injectIntl)(Footer);

/***/ },
/* 721 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(11);
	
	var _reactRouterDom = __webpack_require__(26);
	
	var _brandHeader = __webpack_require__(722);
	
	var _brandHeader2 = _interopRequireDefault(_brandHeader);
	
	var _localeSelectorConnector = __webpack_require__(366);
	
	var _localeSelectorConnector2 = _interopRequireDefault(_localeSelectorConnector);
	
	var _searchFormConnector = __webpack_require__(771);
	
	var _searchFormConnector2 = _interopRequireDefault(_searchFormConnector);
	
	var _userMenuConnector = __webpack_require__(778);
	
	var _userMenuConnector2 = _interopRequireDefault(_userMenuConnector);
	
	var _userMobilMenuConnector = __webpack_require__(779);
	
	var _userMobilMenuConnector2 = _interopRequireDefault(_userMobilMenuConnector);
	
	var _appRoutes = __webpack_require__(22);
	
	var _appRoutes2 = _interopRequireDefault(_appRoutes);
	
	var _header = __webpack_require__(101);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _mobileMenuConnector = __webpack_require__(760);
	
	var _mobileMenuConnector2 = _interopRequireDefault(_mobileMenuConnector);
	
	var _browserHistory = __webpack_require__(141);
	
	var _browserHistory2 = _interopRequireDefault(_browserHistory);
	
	var _desktopMenu = __webpack_require__(723);
	
	var _desktopMenu2 = _interopRequireDefault(_desktopMenu);
	
	var _store = __webpack_require__(173);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _zoneModal = __webpack_require__(247);
	
	var _zoneModal2 = _interopRequireDefault(_zoneModal);
	
	var _headerMenuConnector = __webpack_require__(759);
	
	var _headerMenuConnector2 = _interopRequireDefault(_headerMenuConnector);
	
	var _timeParse = __webpack_require__(372);
	
	var _timeParse2 = _interopRequireDefault(_timeParse);
	
	var _ktpOffCanvas = __webpack_require__(730);
	
	var _ktpOffCanvas2 = _interopRequireDefault(_ktpOffCanvas);
	
	var _secondaryMenuConnector = __webpack_require__(178);
	
	var _secondaryMenuConnector2 = _interopRequireDefault(_secondaryMenuConnector);
	
	var _store3 = __webpack_require__(40);
	
	var _store4 = _interopRequireDefault(_store3);
	
	var _actions = __webpack_require__(23);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	var _zoneService = __webpack_require__(79);
	
	var _zoneService2 = _interopRequireDefault(_zoneService);
	
	var _appDefaults = __webpack_require__(39);
	
	var _appDefaults2 = _interopRequireDefault(_appDefaults);
	
	var _municipalityService = __webpack_require__(122);
	
	var _municipalityService2 = _interopRequireDefault(_municipalityService);
	
	var _municipalitySelectorModal = __webpack_require__(246);
	
	var _municipalitySelectorModal2 = _interopRequireDefault(_municipalitySelectorModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable */
	
	
	var Header = function (_Component) {
	    _inherits(Header, _Component);
	
	    function Header(props) {
	        _classCallCheck(this, Header);
	
	        var _this = _possibleConstructorReturn(this, (Header.__proto__ || Object.getPrototypeOf(Header)).call(this, props));
	
	        _this.getParamsFormURL = function () {
	            var query = new URLSearchParams(_this.props.location.search);
	            var params = {};
	            // eslint-disable-next-line no-restricted-syntax
	            var _iteratorNormalCompletion = true;
	            var _didIteratorError = false;
	            var _iteratorError = undefined;
	
	            try {
	                for (var _iterator = query.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                    var _ref3 = _step.value;
	
	                    var _ref2 = _slicedToArray(_ref3, 2);
	
	                    var param0 = _ref2[0];
	                    var param1 = _ref2[1];
	
	                    params[param0] = param1;
	                }
	            } catch (err) {
	                _didIteratorError = true;
	                _iteratorError = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion && _iterator.return) {
	                        _iterator.return();
	                    }
	                } finally {
	                    if (_didIteratorError) {
	                        throw _iteratorError;
	                    }
	                }
	            }
	
	            return params;
	        };
	
	        _this.state = {
	            showLanguageList: false,
	            showMobileMenu: false,
	            menu: [],
	            showZoneModal: false,
	            selectedZoneId: undefined,
	            pendingPath: undefined,
	            selectStored: undefined,
	            showMobileFilter: false,
	            showMunicipalitySelector: false,
	            selectedZoneMunicipalities: [],
	            paramsToContinue: {}
	        };
	
	        _this.toggleLanguageList = _this.toggleLanguageList.bind(_this);
	        _this.toggleMobileMenu = _this.toggleMobileMenu.bind(_this);
	        _this.toggleFirstMenu = _this.toggleFirstMenu.bind(_this);
	        _this.toggleSecondMenu = _this.toggleSecondMenu.bind(_this);
	        _this.buildMenu = _this.buildMenu.bind(_this);
	        _this.closeMenu = _this.closeMenu.bind(_this);
	        _this.handleClickOnStoreAndZone = _this.handleClickOnStoreAndZone.bind(_this);
	        _this.handleCloseZoneModal = _this.handleCloseZoneModal.bind(_this);
	        _this.toggleMobileFilter = _this.toggleMobileFilter.bind(_this);
	        return _this;
	    }
	
	    _createClass(Header, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _this2 = this;
	
	            this.unlisten = _browserHistory2.default.listen(function (location, action) {
	                _this2.setState({ showMobileMenu: false, showLanguageList: false });
	            });
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this3 = this;
	
	            var params = this.getParamsFormURL();
	            if (params['zone_id']) {
	                this.props.setCurrentZone(parseInt(params['zone_id'], 10));
	            }
	            this.props.loadGroupedStores().then(function (groupedStores) {
	                _this3.buildMenu(groupedStores.zones, groupedStores.data, _this3.props.currentZone, _this3.props.multiCountryShipping);
	            });
	        }
	
	        /* shouldComponentUpdate(nextProps, nextState) {
	            const params = this.getParamsFormURL();
	            const state = spreeStore.getState();
	            let updateRequired = false;
	            if (params['zone_id'] && state.zones && state.zones.currentZone && parseInt(params['zone_id'], 10) !== state.zones.currentZone) {
	                this.props.setCurrentZone(parseInt(params['zone_id'], 10));
	                updateRequired = true;
	            }
	            return updateRequired || JSON.stringify(nextProps) !== JSON.stringify(nextState);
	        } */
	
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps, prevState) {
	            var prevZones = prevProps.stores.storesGrouped.zones || [];
	            var prevStores = prevProps.stores.storesGrouped.data || {};
	            var currentZones = this.props.stores.storesGrouped.zones || [];
	            var currentStores = this.props.stores.storesGrouped.data || {};
	            var currentStore = this.props.stores.currentStore || {};
	
	            if (currentZones.length > 0 && Object.keys(currentStores).length > 0 && Object.keys(currentStore).length > 0 && (prevProps.locale.currentLocale !== this.props.locale.currentLocale || prevProps.currentZone !== this.props.currentZone && this.props.multiCountryShipping || prevZones !== currentZones && this.props.multiCountryShipping || prevStores !== currentStores && this.props.multiCountryShipping || prevProps.stores.currentStore.id !== currentStore.id || prevProps.multiCountryShipping !== this.props.multiCountryShipping)) {
	                this.buildMenu(currentZones, currentStores, this.props.currentZone, this.props.multiCountryShipping);
	            }
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            this.unlisten();
	        }
	    }, {
	        key: 'buildMenu',
	        value: function buildMenu(zones, stores, currentZone, multiStore) {
	            if (zones.length > 0 && Object.keys(stores).length > 0) {
	                var tmpMenu = [{
	                    label: this.props.stores.currentStore.name,
	                    id: this.props.stores.currentStore.id,
	                    type: 'link'
	                }, {
	                    label: multiStore ? _zoneService2.default.getNameCurrentZone(zones, currentZone) : this.props.intl.formatMessage({ id: 'for-cuba' }),
	                    id: 2,
	                    type: 'first_level',
	                    items: zones.map(function (zone) {
	                        var zoneTmp = {
	                            type: 'second_level',
	                            label: zone.name,
	                            id: zone.id,
	                            items: []
	                        };
	
	                        if (stores[zone.id]) {
	                            zoneTmp.items = stores[zone.id].map(function (item) {
	                                var store = {
	                                    id: item.id,
	                                    label: item.name
	                                };
	                                return store;
	                            });
	                        }
	
	                        return zoneTmp;
	                    })
	                }];
	
	                this.setState(function (prevState) {
	                    return { menu: tmpMenu };
	                });
	            }
	        }
	    }, {
	        key: 'toggleMobileMenu',
	        value: function toggleMobileMenu() {
	            var _this4 = this;
	
	            var componentId = 'HEADER';
	            this.setState(function (prevState) {
	                return { showMobileMenu: !prevState.showMobileMenu };
	            }, function () {
	                var rootElem = document.getElementById('root');
	                if (_this4.state.showMobileMenu) {
	                    rootElem.classList.add('disabled');
	                    _store4.default.dispatch(_actions2.default.setBackgroundDisabled({
	                        triggedBy: componentId
	                    }));
	                } else if (_store4.default.getState().backgroundDisabled.triggedBy === componentId) {
	                    rootElem.classList.remove('disabled');
	                    _store4.default.dispatch(_actions2.default.setBackgroundDisabled({
	                        triggedBy: null
	                    }));
	                }
	            });
	        }
	    }, {
	        key: 'toggleLanguageList',
	        value: function toggleLanguageList() {
	            this.setState(function (prevState) {
	                return { showLanguageList: !prevState.showLanguageList };
	            });
	        }
	
	        // eslint-disable-next-line class-methods-use-this
	
	    }, {
	        key: 'handleClickOnStoreAndZone',
	        value: function handleClickOnStoreAndZone(zoneId, storeId) {
	            if (zoneId === undefined) {
	                zoneId = this.props.currentZone;
	            }
	
	            var storesInZone = this.props.stores.storesGrouped.data && this.props.stores.storesGrouped.data[zoneId] ? this.props.stores.storesGrouped.data[zoneId] : [];
	            if (!storesInZone.find(function (store) {
	                return store.id === storeId;
	            })) {
	                if (storesInZone.length > 0) {
	                    storeId = storesInZone[0].id;
	                }
	            }
	            var selectStored = this.props.stores.stores.find(function (store) {
	                return store.id === storeId;
	            });
	            this.closeMenu();
	            var to = '/' + selectStored.code + (zoneId ? '?zone_id=' + zoneId : '');
	
	            if (zoneId !== undefined && this.props.currentZone !== zoneId && this.props.order.line_items.length > 0) {
	                this.setState(function (state) {
	                    return {
	                        selectedZoneId: zoneId, pendingPath: to, showZoneModal: true, selectStored: selectStored
	                    };
	                });
	            } else {
	                var _spreeStore$getState = _store4.default.getState();
	
	                var availableZones = _spreeStore$getState.zones.availableZones;
	                var _spreeStore$getState$ = _spreeStore$getState.municipalities;
	                var availableMunicipalities = _spreeStore$getState$.availableMunicipalities;
	                var currentMunicipality = _spreeStore$getState$.currentMunicipality;
	
	                var selectedZoneMunicipalities = _municipalityService2.default.getAvailableMunicipalitiesByZoneId(zoneId, availableZones, availableMunicipalities);
	                if (_municipalityService2.default.isMunicipalitySelectorModalRequired(currentMunicipality, selectedZoneMunicipalities)) {
	                    this.setState(function (state) {
	                        return {
	                            showMunicipalitySelector: true,
	                            selectedZoneMunicipalities: selectedZoneMunicipalities,
	                            paramsToContinue: { zoneId: zoneId, storeId: storeId }
	                        };
	                    });
	                } else {
	                    this.props.setCurrentStore(selectStored);
	                    if (zoneId !== undefined) {
	                        this.props.setCurrentZone(zoneId);
	                    }
	                    this.props.history.push(to);
	                }
	            }
	        }
	    }, {
	        key: 'handleCloseZoneModal',
	        value: function handleCloseZoneModal(clean) {
	            var _this5 = this;
	
	            if (clean) {
	                this.props.emptyCart(this.props.order, this.props.locale.currentLocale).then(function () {
	                    _this5.props.setCurrentZone(_this5.state.selectedZoneId);
	                    _this5.props.setCurrentStore(_this5.state.selectStored);
	                    _this5.props.history.push(_this5.state.pendingPath);
	                }).catch(function (err) {
	                    return console.log(err);
	                });
	            }
	            this.setState({ showZoneModal: false });
	        }
	    }, {
	        key: 'closeMenu',
	        value: function closeMenu() {
	            var tmpMenu = [].concat(_toConsumableArray(this.state.menu));
	
	            tmpMenu.forEach(function (item) {
	                item.open = false;
	                if (item.items) {
	                    item.items.forEach(function (subitem) {
	                        subitem.open = false;
	                    });
	                }
	            });
	            this.setState(function (prevState) {
	                return { menu: tmpMenu };
	            });
	        }
	    }, {
	        key: 'toggleFirstMenu',
	        value: function toggleFirstMenu(parentId) {
	            var tmpMenu = [].concat(_toConsumableArray(this.state.menu));
	
	            tmpMenu.forEach(function (item) {
	                if (item.id === parentId) {
	                    item.open = !item.open;
	                } else {
	                    item.open = false;
	                }
	            });
	            this.setState(function (prevState) {
	                return { menu: tmpMenu };
	            });
	        }
	    }, {
	        key: 'toggleSecondMenu',
	        value: function toggleSecondMenu(parentId, childId) {
	            var tmpMenu = [].concat(_toConsumableArray(this.state.menu));
	
	            tmpMenu.forEach(function (item) {
	                if (item.id === parentId) {
	                    item.items.forEach(function (subittem) {
	                        if (subittem.id === childId) {
	                            subittem.open = !subittem.open;
	                        } else {
	                            subittem.open = false;
	                        }
	                    });
	                }
	            });
	            this.setState(function (prevState) {
	                return { menu: tmpMenu };
	            });
	        }
	    }, {
	        key: 'toggleMobileFilter',
	        value: function toggleMobileFilter() {
	            this.setState(function (prevState) {
	                return _extends({}, prevState, { showMobileFilter: !prevState.showMobileFilter });
	            });
	        }
	    }, {
	        key: 'handleSelectedMunicipality',
	        value: function handleSelectedMunicipality(municipality) {
	            _store4.default.dispatch(_actions2.default.setCurrentMunicipality(municipality.id));
	            var _state$paramsToContin = this.state.paramsToContinue;
	            var zoneId = _state$paramsToContin.zoneId;
	            var storeId = _state$paramsToContin.storeId;
	
	            this.handleClickOnStoreAndZone(zoneId, storeId);
	            this.setState({
	                showMunicipalitySelector: false,
	                paramsToContinue: {}
	            });
	        }
	    }, {
	        key: 'getCurrentMunicipality',
	        value: function getCurrentMunicipality() {
	            var _this6 = this;
	
	            var _spreeStore$getState2 = _store4.default.getState();
	
	            var _spreeStore$getState3 = _spreeStore$getState2.municipalities.availableMunicipalities;
	            var availableMunicipalities = _spreeStore$getState3 === undefined ? [] : _spreeStore$getState3;
	
	            return availableMunicipalities && availableMunicipalities.find && availableMunicipalities.find(function (mun) {
	                return mun.id === _this6.props.currentMunicipality;
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this7 = this;
	
	            var userLoggedInClass = this.props.user && this.props.user.id ? 'user-logged-in ' : 'guest-user ';
	            var isLogging = this.props.user && this.props.user.id;
	            return _react2.default.createElement(
	                'nav',
	                { className: 'global-header navbar ' + userLoggedInClass + _header2.default.header },
	                _react2.default.createElement(_mobileMenuConnector2.default, {
	                    showMobileMenu: this.state.showMobileMenu,
	                    toggleMobileMenu: this.toggleMobileMenu,
	                    menu: this.state.menu,
	                    toggleFirstMenu: this.toggleFirstMenu,
	                    toggleSecondMenu: this.toggleSecondMenu,
	                    closeMenu: this.closeMenu,
	                    setCurrentZone: this.props.setCurrentZone,
	                    setCurrentStore: this.props.setCurrentStore,
	                    handleClickOnStoreAndZone: this.handleClickOnStoreAndZone
	                }),
	                _react2.default.createElement(
	                    'div',
	                    { style: { height: '70px' } },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'container' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'row' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-md-4 col-sm-12 col-xs-12 ' + _header2.default.headerNavbarCol },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: _header2.default.headerNavbar },
	                                    _react2.default.createElement(
	                                        'button',
	                                        { type: 'button', className: 'navbar-toggle navbar-toggle-left ' + _header2.default.navbarToggle, onClick: this.toggleMobileMenu },
	                                        _react2.default.createElement(
	                                            'span',
	                                            { className: _header2.default.srOnly },
	                                            'Toggle navigation'
	                                        ),
	                                        _react2.default.createElement('span', { className: _header2.default.iconBar }),
	                                        _react2.default.createElement('span', { className: _header2.default.iconBar }),
	                                        _react2.default.createElement('span', { className: _header2.default.iconBar })
	                                    ),
	                                    _react2.default.createElement(_brandHeader2.default, null),
	                                    _react2.default.createElement(
	                                        _reactRouterDom.Link,
	                                        { to: _appRoutes2.default.cartPageRoute, className: 'link-xs hidden-md hidden-lg pull-right ' + _header2.default.addToCartMobile },
	                                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'cart', defaultMessage: 'Cart' }),
	                                        _react2.default.createElement('i', { className: 'pe-7f-cart pe-lg pe-va ' + _header2.default.cartIcon }),
	                                        this.props.order.item_count && _react2.default.createElement(
	                                            'i',
	                                            { className: _header2.default.badge + ' ' + (this.props.cartState.lastAlert ? _header2.default.timeCartLastAlert : '') },
	                                            this.props.order.item_count
	                                        ),
	                                        this.props.order.item_count > 0 && _react2.default.createElement(
	                                            'span',
	                                            { className: 'hidden-md hidden-lg pull-right ' + _header2.default.timeCartLeftMobile },
	                                            _timeParse2.default.fromSeconds(this.props.cartState.timeSecondsLeft)
	                                        )
	                                    ),
	                                    _react2.default.createElement(_userMobilMenuConnector2.default, null),
	                                    _react2.default.createElement('div', { style: { clear: 'both' } })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-md-8 col-xs-12 ' + _header2.default.icons + ' hidden-xs hidden-sm', style: { marginTop: 15 } },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'row' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-md-12 col-sm-12' },
	                                        _react2.default.createElement(
	                                            'ul',
	                                            { className: 'nav navbar-nav navbar-right navbar-medium ' + _header2.default.navbarRight },
	                                            isLogging && _react2.default.createElement(_userMenuConnector2.default, null),
	                                            !isLogging && ("false") !== 'true' && _react2.default.createElement(
	                                                'li',
	                                                null,
	                                                _react2.default.createElement(
	                                                    _reactRouterDom.Link,
	                                                    { to: _appRoutes2.default.signin, className: '' + _header2.default.linkOrange },
	                                                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'signin', defaultMessage: 'Sign In' })
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                'li',
	                                                { style: { display: 'none' } },
	                                                _react2.default.createElement(
	                                                    _reactRouterDom.Link,
	                                                    { to: _appRoutes2.default.wishList },
	                                                    _react2.default.createElement('i', { className: 'pe-7f-like pe-lg pe-va margin-left-10' }),
	                                                    _react2.default.createElement('i', {
	                                                        className: 'badge',
	                                                        style: {
	                                                            marginBottom: '12px',
	                                                            backgroundColor: '#d3af71'
	                                                        }
	                                                    })
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                'li',
	                                                null,
	                                                _react2.default.createElement(
	                                                    _reactRouterDom.Link,
	                                                    { to: _appRoutes2.default.cartPageRoute },
	                                                    _react2.default.createElement('i', { className: 'pe-7f-cart pe-lg pe-va margin-left-10 ' + _header2.default.cartIcon }),
	                                                    _react2.default.createElement(
	                                                        'i',
	                                                        {
	                                                            className: 'badge ' + (this.props.cartState.lastAlert ? _header2.default.timeCartLastAlert : ''),
	                                                            style: {
	                                                                marginBottom: '12px',
	                                                                backgroundColor: _appDefaults2.default.theme.cartBadgeBackgroundColor
	                                                            }
	                                                        },
	                                                        this.props.order.item_count
	                                                    ),
	                                                    this.props.order.item_count > 0 && _react2.default.createElement(
	                                                        'div',
	                                                        { className: _header2.default.timeCartLeftDesktop },
	                                                        _react2.default.createElement(
	                                                            'span',
	                                                            null,
	                                                            _timeParse2.default.fromSeconds(this.props.cartState.timeSecondsLeft)
	                                                        )
	                                                    )
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                'li',
	                                                null,
	                                                _react2.default.createElement(_localeSelectorConnector2.default, null)
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: '' + _header2.default.headerSecondRow },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'container' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: '', style: { flexDirection: 'row' } },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'hidden-xs hidden-sm ' + _header2.default.menuDesktopContainer },
	                                _react2.default.createElement(_desktopMenu2.default, {
	                                    menu: this.state.menu,
	                                    currentMunicipality: this.getCurrentMunicipality(),
	                                    toggleFirstMenu: this.toggleFirstMenu,
	                                    toggleSecondMenu: this.toggleSecondMenu,
	                                    closeMenu: this.closeMenu,
	                                    handleClickOnStoreAndZone: this.handleClickOnStoreAndZone
	                                })
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: '', style: { display: 'flex' } },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: _header2.default.searchContainer },
	                                    _react2.default.createElement(_searchFormConnector2.default, null)
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: _header2.default.filter, onClick: this.toggleMobileFilter },
	                                    _react2.default.createElement(
	                                        'svg',
	                                        { xmlns: 'http://www.w3.org/2000/svg', width: '24', height: '24', fill: _appDefaults2.default.theme.cartFillColor, className: 'bi bi-funnel-fill', viewBox: '0 0 16 16' },
	                                        _react2.default.createElement('path', { d: 'M1.5 1.5A.5.5 0 0 1 2 1h12a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.128.334L10 8.692V13.5a.5.5 0 0 1-.342.474l-3 1A.5.5 0 0 1 6 14.5V8.692L1.628 3.834A.5.5 0 0 1 1.5 3.5v-2z' })
	                                    )
	                                )
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(_zoneModal2.default, {
	                    show: this.state.showZoneModal,
	                    onHide: this.handleCloseZoneModal
	                }),
	                _react2.default.createElement(_municipalitySelectorModal2.default, {
	                    isOpen: this.state.showMunicipalitySelector,
	                    currentZoneMunicipalities: this.state.selectedZoneMunicipalities,
	                    handleClose: function handleClose(municipality) {
	                        return _this7.handleSelectedMunicipality(municipality);
	                    }
	                }),
	                _react2.default.createElement(
	                    _ktpOffCanvas2.default,
	                    { isOpen: this.state.showMobileFilter, onClose: function onClose() {
	                            _this7.toggleMobileFilter();
	                        } },
	                    _react2.default.createElement(_secondaryMenuConnector2.default, { location: this.props.location, path: _appRoutes2.default.searchPageRoute })
	                ),
	                _react2.default.createElement(_headerMenuConnector2.default, null)
	            );
	        }
	    }]);
	
	    return Header;
	}(_react.Component);
	
	exports.default = (0, _reactRouterDom.withRouter)((0, _reactIntl.injectIntl)(Header));

/***/ },
/* 722 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(26);
	
	var _appRoutes = __webpack_require__(22);
	
	var _appRoutes2 = _interopRequireDefault(_appRoutes);
	
	var _headerStyles = __webpack_require__(2148);
	
	var _headerStyles2 = _interopRequireDefault(_headerStyles);
	
	var _katapulk_logo = __webpack_require__(463);
	
	var _katapulk_logo2 = _interopRequireDefault(_katapulk_logo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BrandHeader = function (_Component) {
	    _inherits(BrandHeader, _Component);
	
	    function BrandHeader() {
	        _classCallCheck(this, BrandHeader);
	
	        return _possibleConstructorReturn(this, (BrandHeader.__proto__ || Object.getPrototypeOf(BrandHeader)).apply(this, arguments));
	    }
	
	    _createClass(BrandHeader, [{
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                _reactRouterDom.Link,
	                { to: _appRoutes2.default.homePageRoute, className: 'navbar-brand ' + _headerStyles2.default.navBarHeader },
	                _react2.default.createElement('img', { src: _katapulk_logo2.default, alt: 'Logo' })
	            );
	        }
	    }]);
	
	    return BrandHeader;
	}(_react.Component);
	
	exports.default = BrandHeader;

/***/ },
/* 723 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	// Styles
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactOnclickoutside = __webpack_require__(1854);
	
	var _reactOnclickoutside2 = _interopRequireDefault(_reactOnclickoutside);
	
	var _appDefaults = __webpack_require__(39);
	
	var _appDefaults2 = _interopRequireDefault(_appDefaults);
	
	var _helper = __webpack_require__(60);
	
	var _header = __webpack_require__(101);
	
	var _header2 = _interopRequireDefault(_header);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TOPBAR_HEIGHT = 130;
	
	function DesktopMenu(props) {
	    var menu = props.menu;
	    var closeMenu = props.closeMenu;
	    var toggleFirstMenu = props.toggleFirstMenu;
	    var toggleSecondMenu = props.toggleSecondMenu;
	    var handleClickOnStoreAndZone = props.handleClickOnStoreAndZone;
	    var currentMunicipality = props.currentMunicipality;
	
	    var _useState = (0, _react.useState)(false);
	
	    var _useState2 = _slicedToArray(_useState, 2);
	
	    var seeAll = _useState2[0];
	    var setSeeAll = _useState2[1];
	
	    var _useState3 = (0, _react.useState)({
	        isScrollable: false,
	        maxHeight: document.documentElement.clientHeight - TOPBAR_HEIGHT
	    });
	
	    var _useState4 = _slicedToArray(_useState3, 2);
	
	    var secondaryMenuScrollableConfig = _useState4[0];
	    var setSecondaryMenuScrollableConfig = _useState4[1];
	
	    var secondaryMenuRef = (0, _react.useRef)(0);
	    var fistLevelMenuOpen = menu ? menu.find(function (item) {
	        return item.type === 'first_level' && item.open;
	    }) : [];
	    var secondLevelMenuOpen = fistLevelMenuOpen !== undefined ? fistLevelMenuOpen.items.find(function (item) {
	        return item.type === 'second_level' && item.open;
	    }) : undefined;
	
	    (0, _react.useEffect)(function () {
	        if (secondLevelMenuOpen && secondaryMenuRef.current !== 0) {
	            if (!(0, _helper.isVisibleInViewport)(secondaryMenuRef.current)) {
	                setSecondaryMenuScrollableConfig(_extends({}, secondaryMenuScrollableConfig, {
	                    isScrollable: true
	                }));
	            }
	        }
	    }, [secondLevelMenuOpen, secondaryMenuScrollableConfig]);
	
	    DesktopMenu.handleClickOutside = function () {
	        closeMenu();
	    };
	
	    var secondLevelHtmlMarkup = secondLevelMenuOpen === undefined ? null : _react2.default.createElement(
	        'ul',
	        {
	            className: _header2.default.secondLevelMenu2 + ' ' + (secondaryMenuScrollableConfig.isScrollable && _header2.default.scrollable),
	            ref: secondaryMenuRef,
	            style: { maxHeight: secondaryMenuScrollableConfig.isScrollable ? secondaryMenuScrollableConfig.maxHeight : '' }
	        },
	        secondLevelMenuOpen.items.map(function (subitem) {
	            return _react2.default.createElement(
	                'li',
	                { key: subitem.id, className: 'pe-1x pe-va font-weight-bold', style: { paddingTop: '3px', paddingBottom: '3px' } },
	                _react2.default.createElement(
	                    'a',
	                    {
	                        className: 'line-double',
	                        onClick: function onClick() {
	                            return handleClickOnStoreAndZone(secondLevelMenuOpen.id, subitem.id);
	                        },
	                        style: { fontWeight: 'bold', paddingTop: '3px', paddingBottom: '3px' }
	                    },
	                    subitem.label
	                )
	            );
	        })
	    );
	    return _react2.default.createElement(
	        'ul',
	        { className: 'nav navbar-nav' },
	        menu.map(function (firstLevelMenu) {
	            if (firstLevelMenu.type === 'link') {
	                return _react2.default.createElement(
	                    'li',
	                    {
	                        key: 'L' + firstLevelMenu.id,
	                        className: _header2.default['header__menu-item'],
	                        style: { borderRight: '1px solid ' + _appDefaults2.default.theme.mainManeDividerColor },
	                        onClick: function onClick() {
	                            return handleClickOnStoreAndZone(undefined, firstLevelMenu.id);
	                        }
	                    },
	                    _react2.default.createElement(
	                        'a',
	                        null,
	                        firstLevelMenu.label
	                    )
	                );
	            }if (firstLevelMenu.type === 'first_level') {
	                return _react2.default.createElement(
	                    'li',
	                    { key: 'FL' + firstLevelMenu.id, className: 'dropdown', style: { borderRight: '1px solid ' + _appDefaults2.default.theme.mainManeDividerColor } },
	                    _react2.default.createElement(
	                        'a',
	                        {
	                            className: 'dropdown-toggle line-double ' + (firstLevelMenu.open ? _header2.default.rootMenuSelect : '') + ' font-weight-bold',
	                            'data-toggle': 'dropdown',
	                            onClick: function onClick() {
	                                return toggleFirstMenu(firstLevelMenu.id);
	                            },
	                            style: { color: _appDefaults2.default.theme.mainMenuDropdownColor, display: 'inline-block' }
	                        },
	                        firstLevelMenu.label,
	                        currentMunicipality ? ' - ' + currentMunicipality.name : ' ',
	                        _react2.default.createElement('i', {
	                            className: 'pe-7s-angle-down pe-1x pe-va font-weight-bold ' + _header2.default.angleDown,
	                            style: { display: firstLevelMenu.open ? 'none' : 'inline-block' }
	                        }),
	                        _react2.default.createElement('i', {
	                            className: 'pe-7s-angle-up pe-1x pe-va font-weight-bold ' + _header2.default.angleUp,
	                            style: { display: firstLevelMenu.open ? 'inline-block' : 'none' }
	                        })
	                    ),
	                    _react2.default.createElement(
	                        'ul',
	                        { className: 'dropdown-menu ' + _header2.default.menu + ' ' + _header2.default.firstLevelMenu, style: { display: firstLevelMenu.open ? 'block' : 'none' } },
	                        firstLevelMenu.items.map(function (item) {
	                            return _react2.default.createElement(
	                                'li',
	                                { key: 'I' + item.id, className: 'dropdown' },
	                                _react2.default.createElement(
	                                    'a',
	                                    {
	                                        className: 'dropdown-toggle line-double',
	                                        'data-toggle': 'dropdown',
	                                        style: { color: item.open ? _appDefaults2.default.theme.desktopItemOpenColor : 'white', display: 'inline-block' },
	                                        onClick: function onClick() {
	                                            return toggleSecondMenu(firstLevelMenu.id, item.id);
	                                        }
	                                    },
	                                    item.label,
	                                    ' ',
	                                    _react2.default.createElement('i', {
	                                        className: 'pe-7s-angle-left pe-1x pe-va font-weight-bold ' + _header2.default.angleUp + ' ' + _header2.default.navigationIcon + ' ' + (item.open ? _header2.default.open : '')
	                                    })
	                                )
	                            );
	                        }),
	                        secondLevelHtmlMarkup
	                    )
	                );
	            }
	        })
	    );
	}
	
	var clickOutsideConfig = {
	    handleClickOutside: function handleClickOutside() {
	        return DesktopMenu.handleClickOutside;
	    }
	
	};
	
	exports.default = (0, _reactOnclickoutside2.default)(DesktopMenu, clickOutsideConfig);

/***/ },
/* 724 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(41);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(26);
	
	var _reactIntl = __webpack_require__(11);
	
	var _headerMenu = __webpack_require__(2147);
	
	var _headerMenu2 = _interopRequireDefault(_headerMenu);
	
	var _appRoutes = __webpack_require__(22);
	
	var _appRoutes2 = _interopRequireDefault(_appRoutes);
	
	var _banner = __webpack_require__(1611);
	
	var _banner2 = _interopRequireDefault(_banner);
	
	var _zoneSelectConnector = __webpack_require__(780);
	
	var _zoneSelectConnector2 = _interopRequireDefault(_zoneSelectConnector);
	
	var _municipalityService = __webpack_require__(122);
	
	var _municipalityService2 = _interopRequireDefault(_municipalityService);
	
	var _store = __webpack_require__(40);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _municipalitySelectorModal = __webpack_require__(246);
	
	var _municipalitySelectorModal2 = _interopRequireDefault(_municipalitySelectorModal);
	
	var _actions = __webpack_require__(23);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	var _productModel = __webpack_require__(143);
	
	var _productModel2 = _interopRequireDefault(_productModel);
	
	var _appDefaults = __webpack_require__(39);
	
	var _appDefaults2 = _interopRequireDefault(_appDefaults);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var HeaderMenu = function (_Component) {
	    _inherits(HeaderMenu, _Component);
	
	    function HeaderMenu(props) {
	        _classCallCheck(this, HeaderMenu);
	
	        var _this = _possibleConstructorReturn(this, (HeaderMenu.__proto__ || Object.getPrototypeOf(HeaderMenu)).call(this, props));
	
	        _this.state = {
	            elementHover: '',
	            showZoneSelector: false,
	            showMunicipalitySelector: false,
	            selectedZoneMunicipalities: []
	        };
	
	        _this.toggleUserMenu = _this.toggleUserMenu.bind(_this);
	        _this.manageZoneSelected = _this.manageZoneSelected.bind(_this);
	        return _this;
	    }
	
	    _createClass(HeaderMenu, [{
	        key: 'componentDidMount',
	        value: function () {
	            var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	                var _this2 = this;
	
	                return _regenerator2.default.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                _context.next = 2;
	                                return this.props.triggerInitialSetup(this.props.locale.currentLocale, this.props.currentStore, this.props.order);
	
	                            case 2:
	                                if (this.props.currentZone === undefined) {
	                                    setTimeout(function () {
	                                        _this2.setState({
	                                            showZoneSelector: true
	                                        });
	                                    }, _appDefaults2.default.modalTimeout);
	                                }
	
	                            case 3:
	                            case 'end':
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this);
	            }));
	
	            function componentDidMount() {
	                return _ref.apply(this, arguments);
	            }
	
	            return componentDidMount;
	        }()
	    }, {
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate(nextProps, nextState) {
	            return true;
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps) {
	            var selectedZoneMunicipalities = _municipalityService2.default.getAvailableMunicipalitiesByZoneId(this.props.currentZone, this.props.availableZones, this.props.availableMunicipalities);
	            if (_municipalityService2.default.isMunicipalitySelectorModalRequired(this.props.currentMunicipality, selectedZoneMunicipalities)) {
	                if (!this.props.isMunicipalityPromptModalOpen && !this.state.showMunicipalitySelector) {
	                    // eslint-disable-next-line react/no-did-update-set-state
	                    this.setState({
	                        showMunicipalitySelector: true,
	                        selectedZoneMunicipalities: selectedZoneMunicipalities
	                    });
	                }
	            } else if (this.props.currentZone && selectedZoneMunicipalities.length === 0) {
	                this.props.setCurrentMunicipality(undefined);
	            }
	        }
	    }, {
	        key: 'manageZoneSelected',
	        value: function manageZoneSelected(zoneId) {
	            this.setState({
	                showZoneSelector: false
	            });
	        }
	    }, {
	        key: 'toggleUserMenu',
	        value: function toggleUserMenu(element) {
	            this.setState({ elementHover: element });
	        }
	    }, {
	        key: 'handleSelectedMunicipality',
	        value: function handleSelectedMunicipality(municipality) {
	            this.props.setCurrentMunicipality(municipality.id);
	            this.setState({
	                showMunicipalitySelector: false
	            });
	
	            var _spreeStore$getState = _store2.default.getState();
	
	            var currentLocale = _spreeStore$getState.locale;
	
	            _store2.default.dispatch(_actions2.default.displayLoader());
	            _store2.default.dispatch(_actions2.default.fetchProducts({ page_no: 1, currentLocale: currentLocale })).then(function (response) {
	                var fetchedProducts = response.body;
	                _store2.default.dispatch(_actions2.default.addProducts({ products: _productModel2.default.filterUniqueProducts(fetchedProducts.data), meta: fetchedProducts.meta }));
	                _store2.default.dispatch(_actions2.default.hideLoader());
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            var menuLevel2 = function menuLevel2(taxons) {
	                return taxons.map(function (taxon, index) {
	                    return _react2.default.createElement(
	                        'li',
	                        { key: taxon.id, className: 'dropdown ' + _headerMenu2.default.menuDropdownLevel2, onClick: function onClick() {
	                                return _this3.toggleUserMenu('');
	                            }, onMouseEnter: function onMouseEnter() {
	                                return _this3.toggleUserMenu(taxon.attributes.permalink);
	                            } },
	                        _react2.default.createElement(
	                            _reactRouterDom.Link,
	                            { to: _appRoutes2.default.searchPageRoute + '?category=' + taxon.attributes.permalink },
	                            taxon.attributes.name,
	                            taxon.taxons.length > 0 && _react2.default.createElement('i', {
	                                className: 'pe-7s-angle-right pe-1x pe-va ' + _headerMenu2.default.angleDown,
	                                style: { display: _this3.state.elementHover.split('/')[0] + '/' + _this3.state.elementHover.split('/')[1] === taxon.attributes.permalink ? 'none' : 'inline-block' }
	                            }),
	                            taxon.taxons.length > 0 && _react2.default.createElement('i', {
	                                className: 'pe-7s-angle-left pe-1x pe-va ' + _headerMenu2.default.angleUp,
	                                style: { display: _this3.state.elementHover.split('/')[0] + '/' + _this3.state.elementHover.split('/')[1] === taxon.attributes.permalink ? 'inline-block' : 'none' }
	                            })
	                        )
	                    );
	                });
	            };
	
	            var menuKatapulkLevel2 = function menuKatapulkLevel2(taxons, storeIdParam) {
	                return taxons.map(function (taxon) {
	                    return _react2.default.createElement(
	                        'li',
	                        { key: taxon.id, className: 'dropdown ' + _headerMenu2.default.menuDropdownLevel2, onClick: function onClick() {
	                                return _this3.toggleUserMenu('');
	                            }, onMouseEnter: function onMouseEnter() {
	                                return _this3.toggleUserMenu(taxon.permalink);
	                            } },
	                        _react2.default.createElement(
	                            _reactRouterDom.Link,
	                            { to: _appRoutes2.default.searchPageRoute + '?category=' + taxon.permalink + '&' + storeIdParam },
	                            taxon.name
	                        )
	                    );
	                });
	            };
	
	            var menuKatapulkLevel1 = function menuKatapulkLevel1(taxons, storeIdParam) {
	                return taxons.map(function (taxon) {
	                    return (
	                        // eslint-disable-next-line max-len
	                        _react2.default.createElement(
	                            'li',
	                            { key: taxon.taxonCategory.id, className: 'dropdown ' + _headerMenu2.default.menuDropdownLevel1, onClick: function onClick() {
	                                    return _this3.toggleUserMenu('');
	                                }, onMouseEnter: function onMouseEnter() {
	                                    return _this3.toggleUserMenu(taxon.taxonCategory.permalink);
	                                } },
	                            _react2.default.createElement(
	                                _reactRouterDom.Link,
	                                { to: _appRoutes2.default.searchPageRoute + '?category=' + taxon.taxonCategory.permalink + '&' + storeIdParam },
	                                taxon.taxonCategory.name,
	                                taxon.taxons.length > 0 && _react2.default.createElement('i', {
	                                    className: 'pe-7s-angle-right pe-1x pe-va ' + _headerMenu2.default.angleDown,
	                                    style: { display: _this3.state.elementHover.split('/')[0] + '/' + _this3.state.elementHover.split('/')[1] === taxon.taxonCategory.permalink ? 'none' : 'inline-block' }
	                                }),
	                                taxon.taxons.length > 0 && _react2.default.createElement('i', {
	                                    className: 'pe-7s-angle-left pe-1x pe-va ' + _headerMenu2.default.angleUp,
	                                    style: { display: _this3.state.elementHover.split('/')[0] + '/' + _this3.state.elementHover.split('/')[1] === taxon.taxonCategory.permalink ? 'inline-block' : 'none' }
	                                })
	                            ),
	                            taxon.taxons.length > 0 && _react2.default.createElement(
	                                'ul',
	                                {
	                                    className: 'dropdown ' + _headerMenu2.default.menuSubCategories + '\n                    ' + (_this3.state.elementHover.split('/')[0] + '/' + _this3.state.elementHover.split('/')[1] === taxon.taxonCategory.permalink ? _headerMenu2.default.menuSubCategoriesHover : '')
	                                },
	                                _react2.default.createElement(
	                                    'li',
	                                    { key: taxon.id, className: 'row ' + _headerMenu2.default.menuDropdownLevel2, onMouseEnter: function onMouseEnter() {
	                                            return _this3.toggleUserMenu(taxon.taxonCategory.permalink);
	                                        } },
	                                    _react2.default.createElement(
	                                        'ul',
	                                        { className: _headerMenu2.default.tableCell },
	                                        menuKatapulkLevel2(taxon.taxons.slice(0, taxon.taxons.length / 2 + 1), storeIdParam)
	                                    ),
	                                    _react2.default.createElement(
	                                        'ul',
	                                        { className: _headerMenu2.default.tableCell },
	                                        menuKatapulkLevel2(taxon.taxons.slice(taxon.taxons.length / 2 + 1), storeIdParam)
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'li',
	                                    { className: _headerMenu2.default.specialGifts },
	                                    _react2.default.createElement(
	                                        'a',
	                                        { role: 'button' },
	                                        _react2.default.createElement('img', { className: 'pull-right', src: _banner2.default, alt: 'Banner' }),
	                                        _react2.default.createElement(
	                                            'p',
	                                            { className: _headerMenu2.default.titleSection },
	                                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'do-you-need', defaultMessage: 'Do you need' }),
	                                            _react2.default.createElement('br', null),
	                                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'a-special-gift', defaultMessage: 'a special gift?' })
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    );
	                });
	            };
	
	            var getStore = function getStore(id) {
	                return _this3.props.stores.find(function (item) {
	                    if (id && item.id) {
	                        return item.id === id;
	                    }
	                    return undefined;
	                });
	            };
	
	            return _react2.default.createElement(
	                'nav',
	                {
	                    className: 'navbar-collapse navbar-left collapse ' + _headerMenu2.default.navBar,
	                    id: 'kk-navbar-collapse',
	                    style: { height: '1px' }
	                },
	                _react2.default.createElement(_zoneSelectConnector2.default, {
	                    show: this.state.showZoneSelector,
	                    onHide: this.manageZoneSelected
	                }),
	                _react2.default.createElement(_municipalitySelectorModal2.default, {
	                    isOpen: this.state.showMunicipalitySelector,
	                    currentZoneMunicipalities: this.state.selectedZoneMunicipalities,
	                    handleClose: function handleClose(municipality) {
	                        return _this3.handleSelectedMunicipality(municipality);
	                    }
	                })
	            );
	        }
	    }]);
	
	    return HeaderMenu;
	}(_react.Component);
	
	exports.default = HeaderMenu;

/***/ },
/* 725 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _appDefaults = __webpack_require__(39);
	
	var _appDefaults2 = _interopRequireDefault(_appDefaults);
	
	var _supportedLocales = __webpack_require__(364);
	
	var _supportedLocales2 = _interopRequireDefault(_supportedLocales);
	
	var _header = __webpack_require__(101);
	
	var _header2 = _interopRequireDefault(_header);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Styles
	
	
	var LocaleSelector = function (_Component) {
	    _inherits(LocaleSelector, _Component);
	
	    function LocaleSelector(props) {
	        _classCallCheck(this, LocaleSelector);
	
	        var _this = _possibleConstructorReturn(this, (LocaleSelector.__proto__ || Object.getPrototypeOf(LocaleSelector)).call(this, props));
	
	        _this.handleClickOutside = function (event) {
	            if (_this.container.current && !_this.container.current.contains(event.target)) {
	                document.removeEventListener('mousedown', _this.handleClickOutside);
	                _this.setState({
	                    showLanguageList: false
	                });
	            }
	        };
	
	        _this.container = _react2.default.createRef();
	        _this.state = {
	            showLanguageList: false
	        };
	
	        _this.toggleLanguageList = _this.toggleLanguageList.bind(_this);
	        return _this;
	    }
	
	    _createClass(LocaleSelector, [{
	        key: 'setLanguage',
	        value: function setLanguage(localeKey) {
	            this.props.setLocale(localeKey);
	            this.toggleLanguageList();
	        }
	    }, {
	        key: 'toggleLanguageList',
	        value: function toggleLanguageList() {
	            var _this2 = this;
	
	            this.setState(function (prevState) {
	                return { showLanguageList: !prevState.showLanguageList };
	            }, function () {
	                if (_this2.state.showLanguageList) {
	                    document.addEventListener('mousedown', _this2.handleClickOutside);
	                } else {
	                    document.removeEventListener('mousedown', _this2.handleClickOutside);
	                }
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            var localeSelectorMarkup = Object.keys(_supportedLocales2.default).map(function (localeKey, idx) {
	                return _react2.default.createElement(
	                    'li',
	                    { key: localeKey, value: localeKey, className: 'active', onClick: function onClick() {
	                            return _this3.setLanguage(localeKey);
	                        } },
	                    _react2.default.createElement('img', { className: 'flag', alt: _supportedLocales2.default[localeKey], src: _supportedLocales.LOCALE_FLAGS[localeKey] })
	                );
	            });
	
	            return _react2.default.createElement(
	                'ul',
	                { className: 'nav navbar-nav navbar-right nav-language ' + _header2.default.navbarRight + ' ' + _header2.default.navLanguage, ref: this.container },
	                _react2.default.createElement(
	                    'li',
	                    { id: 'languages', className: 'dropdown ' + _header2.default.languages },
	                    _react2.default.createElement(
	                        'a',
	                        { className: 'dropdown-toggle line-double ' + _header2.default.dropdown, 'data-toggle': 'dropdown', onClick: this.toggleLanguageList },
	                        _react2.default.createElement('img', { className: 'flag', alt: _supportedLocales2.default[this.props.currentLocale], src: _supportedLocales.LOCALE_FLAGS[this.props.currentLocale] }),
	                        _react2.default.createElement('i', {
	                            className: 'pe-7s-angle-down pe-1x pe-va font-weight-bold ' + _header2.default.angleDown,
	                            style: { display: this.state.showLanguageList ? 'none' : 'inline-block' }
	                        }),
	                        _react2.default.createElement('i', { className: 'pe-7s-angle-up pe-1x pe-va font-weight-bold ' + _header2.default.angleUp, style: { display: this.state.showLanguageList ? 'inline-block' : 'none' } })
	                    ),
	                    _react2.default.createElement(
	                        'ul',
	                        { className: 'dropdown-menu languages ' + _header2.default.languageDropdowns, style: { display: this.state.showLanguageList ? 'block' : 'none' } },
	                        localeSelectorMarkup
	                    )
	                )
	            );
	        }
	    }]);
	
	    return LocaleSelector;
	}(_react.Component);
	
	exports.default = LocaleSelector;

/***/ },
/* 726 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(26);
	
	var _reactIntl = __webpack_require__(11);
	
	var _mobileMenu = __webpack_require__(2149);
	
	var _mobileMenu2 = _interopRequireDefault(_mobileMenu);
	
	var _store = __webpack_require__(173);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _zoneService = __webpack_require__(79);
	
	var _zoneService2 = _interopRequireDefault(_zoneService);
	
	var _appDefaults = __webpack_require__(39);
	
	var _appDefaults2 = _interopRequireDefault(_appDefaults);
	
	var _store3 = __webpack_require__(40);
	
	var _store4 = _interopRequireDefault(_store3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MobileMenu = function (_Component) {
	    _inherits(MobileMenu, _Component);
	
	    function MobileMenu(props) {
	        _classCallCheck(this, MobileMenu);
	
	        var _this = _possibleConstructorReturn(this, (MobileMenu.__proto__ || Object.getPrototypeOf(MobileMenu)).call(this, props));
	
	        _this.state = {
	            elementSelected: '',
	            menu: [],
	            seeAll: false
	        };
	
	        _this.selectMenuItem = _this.selectMenuItem.bind(_this);
	        _this.toggleFirstMenu = _this.toggleFirstMenu.bind(_this);
	        _this.toggleSecondMenu = _this.toggleSecondMenu.bind(_this);
	        _this.handleClickOnStoreAndZone = _this.handleClickOnStoreAndZone.bind(_this);
	        _this.buildMenu = _this.buildMenu.bind(_this);
	        return _this;
	    }
	
	    _createClass(MobileMenu, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            _store2.default.getGroupedStores().then(function (response) {
	                _this2.buildMenu(response.body.zones, response.body.data, _this2.props.currentZone, _this2.props.multiCountryShipping);
	            });
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps, prevState) {
	            var prevZones = prevProps.storesGrouped.zones || [];
	            var prevStores = prevProps.storesGrouped.data || {};
	            var currentZones = this.props.storesGrouped.zones || [];
	            var currentStores = this.props.storesGrouped.data || {};
	
	            if (currentZones.length > 0 && Object.keys(currentStores).length > 0 && (prevProps.locale.currentLocale !== this.props.locale.currentLocale || prevProps.currentZone !== this.props.currentZone && this.props.multiCountryShipping || prevZones !== currentZones && this.props.multiCountryShipping || prevStores !== currentStores && this.props.multiCountryShipping || prevProps.currentStore.id !== this.props.currentStore.id || prevProps.multiCountryShipping !== this.props.multiCountryShipping)) {
	                this.buildMenu(currentZones, currentStores, this.props.currentZone, this.props.multiCountryShipping);
	            }
	        }
	
	        // eslint-disable-next-line react/sort-comp
	
	    }, {
	        key: 'buildMenu',
	        value: function buildMenu(zones, stores, currentZone, multiStore) {
	            if (zones.length > 0 && Object.keys(stores).length > 0) {
	                var tmpMenu = [{
	                    label: this.props.currentStore.name,
	                    id: this.props.currentStore.id,
	                    type: 'link'
	                }, {
	                    label: multiStore ? _zoneService2.default.getNameCurrentZone(zones, currentZone) : this.props.intl.formatMessage({ id: 'for-cuba' }),
	                    id: 2,
	                    type: 'first_level',
	                    items: zones.map(function (zone) {
	                        var zoneTmp = {
	                            type: 'second_level',
	                            label: zone.name,
	                            id: zone.id,
	                            items: []
	                        };
	                        if (stores[zone.id]) {
	                            zoneTmp.items = stores[zone.id].map(function (item) {
	                                var store = {
	                                    id: item.id,
	                                    label: item.name
	                                };
	                                return store;
	                            });
	                        }
	                        return zoneTmp;
	                    })
	                }];
	                this.setState(function (prevState) {
	                    return { menu: tmpMenu };
	                });
	            }
	        }
	    }, {
	        key: 'selectMenuItem',
	        value: function selectMenuItem(element) {
	            this.setState(function (prevState) {
	                return {
	                    elementSelected: prevState.elementSelected !== element ? element : ''
	                };
	            });
	        }
	    }, {
	        key: 'toggleFirstMenu',
	        value: function toggleFirstMenu(parentId) {
	            var tmpMenu = [].concat(_toConsumableArray(this.state.menu));
	
	            tmpMenu.forEach(function (item) {
	                if (item.id === parentId) {
	                    item.open = !item.open;
	                } else {
	                    item.open = false;
	                }
	            });
	            this.setState(function (prevState) {
	                return { menu: tmpMenu };
	            });
	        }
	    }, {
	        key: 'toggleSecondMenu',
	        value: function toggleSecondMenu(parentId, childId) {
	            var tmpMenu = [].concat(_toConsumableArray(this.state.menu));
	
	            tmpMenu.forEach(function (item) {
	                if (item.id === parentId) {
	                    item.items.forEach(function (subittem) {
	                        if (subittem.id === childId) {
	                            subittem.open = !subittem.open;
	                        } else {
	                            subittem.open = false;
	                        }
	                    });
	                }
	            });
	            this.setState(function (prevState) {
	                return { menu: tmpMenu };
	            });
	        }
	
	        // eslint-disable-next-line class-methods-use-this
	
	    }, {
	        key: 'handleClickOnStoreAndZone',
	        value: function handleClickOnStoreAndZone(zoneId, storeId) {
	            // const selectStored = this.props.stores.find((store) => store.id === storeId);
	            // this.props.setCurrentStore(selectStored);
	            //
	            // if (zoneId) {
	            //     this.props.setCurrentZone(zoneId);
	            // }
	            //
	            // this.props.toggleMobileMenu();
	            //
	            // const to = `${this.props.location.pathname !== '/' ? this.props.location.pathname : APP_ROUTES.searchPageRoute}?`
	            //     + `store_id=${storeId}`
	            //     + `${zoneId ? `&zone_id=${zoneId}` : ''}`;
	            // this.props.history.push(to);
	            this.props.toggleMobileMenu();
	            this.props.handleClickOnStoreAndZone(zoneId, storeId);
	        }
	    }, {
	        key: 'setSeeAll',
	        value: function setSeeAll(value) {
	            this.setState(function (previewState) {
	                return { seeAll: value };
	            });
	        }
	    }, {
	        key: 'getCurrentMunicipality',
	        value: function getCurrentMunicipality() {
	            var _this3 = this;
	
	            var _spreeStore$getState = _store4.default.getState();
	
	            var _spreeStore$getState$ = _spreeStore$getState.municipalities.availableMunicipalities;
	            var availableMunicipalities = _spreeStore$getState$ === undefined ? [] : _spreeStore$getState$;
	
	            return availableMunicipalities && availableMunicipalities.length > 0 && availableMunicipalities.find(function (mun) {
	                return mun.id === _this3.props.currentMunicipality;
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this4 = this;
	
	            return _react2.default.createElement(
	                'div',
	                {
	                    className: _mobileMenu2.default.mobileMenu,
	                    style: {
	                        display: this.props.showMobileMenu ? 'initial' : 'none',
	                        height: '100vh'
	                    }
	                },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'container ' + _mobileMenu2.default.menuTop },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                            'div',
	                            {
	                                className: 'col-xs-12',
	                                style: {
	                                    fontWeight: 'bold', fontSize: 'x-large'
	                                }
	                            },
	                            _react2.default.createElement(
	                                'div',
	                                { className: _mobileMenu2.default.menuBorder },
	                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'menu', defaultMessage: 'Menu' }),
	                                _react2.default.createElement('i', {
	                                    onClick: this.props.toggleMobileMenu,
	                                    className: 'pe-7s-close pe-1x pe-va font-weight-bold ' + _mobileMenu2.default.angleDown,
	                                    style: { position: 'absolute', right: '10px' }
	                                })
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                            'ul',
	                            { className: 'nav navbar-nav ' + _mobileMenu2.default.menu, style: { fontSize: 'large', fontWeight: 'bold', width: '100%' } },
	                            this.state.menu.map(function (firstLevelMenu, index) {
	                                if (firstLevelMenu.type === 'link') {
	                                    return _react2.default.createElement(
	                                        'li',
	                                        { key: firstLevelMenu.id + '-' + index, style: { width: '100%' } },
	                                        _react2.default.createElement(
	                                            'a',
	                                            { onClick: function onClick() {
	                                                    return _this4.handleClickOnStoreAndZone(undefined, firstLevelMenu.id);
	                                                } },
	                                            firstLevelMenu.label
	                                        )
	                                    );
	                                }if (firstLevelMenu.type === 'first_level') {
	                                    return _react2.default.createElement(
	                                        'li',
	                                        { key: firstLevelMenu.id + '-' + index, className: 'dropdown ' + _mobileMenu2.default.menuItem, style: { width: '100%' } },
	                                        _react2.default.createElement(
	                                            'a',
	                                            {
	                                                className: 'dropdown-toggle line-double font-weight-bold',
	                                                'data-toggle': 'dropdown',
	                                                onClick: function onClick() {
	                                                    return _this4.toggleFirstMenu(firstLevelMenu.id);
	                                                },
	                                                style: { color: _appDefaults2.default.theme.mobileMenuItemColor, display: 'inline-block', width: '100%' }
	                                            },
	                                            firstLevelMenu.label,
	                                            _this4.getCurrentMunicipality() ? ' - ' + _this4.getCurrentMunicipality().name : ' ',
	                                            _react2.default.createElement('i', {
	                                                className: 'pe-7s-angle-down pe-1x pe-va font-weight-bold ' + _mobileMenu2.default.angleDown,
	                                                style: { display: firstLevelMenu.open ? 'none' : 'inline-block', position: 'absolute', right: '10px' }
	                                            }),
	                                            _react2.default.createElement('i', {
	                                                className: 'pe-7s-angle-up pe-1x pe-va font-weight-bold ' + _mobileMenu2.default.angleUp,
	                                                style: { display: firstLevelMenu.open ? 'inline-block' : 'none', position: 'absolute', right: '10px' }
	                                            })
	                                        ),
	                                        _react2.default.createElement(
	                                            'ul',
	                                            { className: '', style: { display: firstLevelMenu.open ? 'block' : 'none', paddingLeft: '30px' } },
	                                            firstLevelMenu.items.map(function (item) {
	                                                return _react2.default.createElement(
	                                                    'li',
	                                                    { key: item.id, className: '' },
	                                                    _react2.default.createElement(
	                                                        'a',
	                                                        {
	                                                            className: 'dropdown-toggle line-double',
	                                                            'data-toggle': 'dropdown',
	                                                            onClick: function onClick() {
	                                                                _this4.toggleSecondMenu(firstLevelMenu.id, item.id);
	                                                            },
	                                                            style: {
	                                                                color: item.open ? _appDefaults2.default.theme.mobileMenuSubitemColor : 'black',
	                                                                display: 'inline-block',
	                                                                width: '100%',
	                                                                paddingTop: 3,
	                                                                paddingBottom: 3
	                                                            }
	                                                        },
	                                                        item.label,
	                                                        ' ',
	                                                        _react2.default.createElement('i', {
	                                                            className: 'pe-7s-angle-up pe-1x pe-va font-weight-bold ' + _mobileMenu2.default.angleUp,
	                                                            style: { display: item.open ? 'inline-block' : 'none', position: 'absolute', right: '10px' }
	                                                        }),
	                                                        _react2.default.createElement('i', {
	                                                            className: 'pe-7s-angle-down pe-1x pe-va font-weight-bold ' + _mobileMenu2.default.angleUp,
	                                                            style: { display: !item.open ? 'inline-block' : 'none', position: 'absolute', right: '10px' }
	                                                        })
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'ul',
	                                                        {
	                                                            className: '' + _mobileMenu2.default.menu,
	                                                            style: { color: '#d3af71', display: item.open ? 'inline-block' : 'none', paddingLeft: '20px' }
	                                                        },
	                                                        !_this4.state.seeAll && item.items.length > 20 ? item.items.slice(0, 19).map(function (subitem) {
	                                                            return _react2.default.createElement(
	                                                                'li',
	                                                                { key: subitem.id, className: 'pe - 1x pe-va font-weight-bold ' + _mobileMenu2.default.menuItem },
	                                                                _react2.default.createElement(
	                                                                    'a',
	                                                                    { style: { fontWeight: 'bold' }, onClick: function onClick() {
	                                                                            return _this4.handleClickOnStoreAndZone(item.id, subitem.id);
	                                                                        } },
	                                                                    subitem.label
	                                                                )
	                                                            );
	                                                        }) : item.items.map(function (subitem) {
	                                                            return _react2.default.createElement(
	                                                                'li',
	                                                                { key: subitem.id, className: 'pe - 1x pe-va font-weight-bold ' + _mobileMenu2.default.menuItem },
	                                                                _react2.default.createElement(
	                                                                    'a',
	                                                                    { style: { fontWeight: 'bold' }, onClick: function onClick() {
	                                                                            return _this4.handleClickOnStoreAndZone(item.id, subitem.id);
	                                                                        } },
	                                                                    subitem.label
	                                                                )
	                                                            );
	                                                        }),
	                                                        !_this4.state.seeAll && item.items.length > 20 ? _react2.default.createElement(
	                                                            'li',
	                                                            { className: _mobileMenu2.default.rowSeeAll },
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                null,
	                                                                _react2.default.createElement(
	                                                                    'a',
	                                                                    {
	                                                                        className: 'font-weight-bold',
	                                                                        onClick: function onClick() {
	                                                                            return _this4.setSeeAll(true);
	                                                                        }
	                                                                    },
	                                                                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'see-all', defaultMessage: 'See all' })
	                                                                )
	                                                            )
	                                                        ) : null,
	                                                        _this4.state.seeAll && item.items.length > 20 ? _react2.default.createElement(
	                                                            'li',
	                                                            { className: _mobileMenu2.default.rowSeeAll },
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                null,
	                                                                _react2.default.createElement(
	                                                                    'a',
	                                                                    {
	                                                                        className: 'font-weight-bold',
	                                                                        onClick: function onClick() {
	                                                                            return _this4.setSeeAll(false);
	                                                                        }
	                                                                    },
	                                                                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'see-less', defaultMessage: 'See less' })
	                                                                )
	                                                            )
	                                                        ) : null
	                                                    )
	                                                );
	                                            })
	                                        )
	                                    );
	                                }
	                            })
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return MobileMenu;
	}(_react.Component);
	
	exports.default = (0, _reactRouterDom.withRouter)((0, _reactIntl.injectIntl)(MobileMenu));

/***/ },
/* 727 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(11);
	
	var _searchForm = __webpack_require__(2150);
	
	var _searchForm2 = _interopRequireDefault(_searchForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable */
	
	
	var SearchForm = function (_Component) {
	    _inherits(SearchForm, _Component);
	
	    function SearchForm(props) {
	        _classCallCheck(this, SearchForm);
	
	        var _this = _possibleConstructorReturn(this, (SearchForm.__proto__ || Object.getPrototypeOf(SearchForm)).call(this, props));
	
	        _this.state = {
	            searchTerm: '',
	            showTaxons: false
	            // taxonSelected: 'all',
	            // taxonSelectedName: 'All',
	        };
	
	        _this.searchInput = _react2.default.createRef();
	
	        _this.submitSearchForm = _this.submitSearchForm.bind(_this);
	        _this.onSearchInputChange = _this.onSearchInputChange.bind(_this);
	        _this.onClear = _this.onClear.bind(_this);
	
	        _this.toggleTaxons = _this.toggleTaxons.bind(_this);
	        return _this;
	    }
	
	    _createClass(SearchForm, [{
	        key: 'onSearchInputChange',
	        value: function onSearchInputChange(event) {
	            this.setState({ searchTerm: event.target.value });
	        }
	    }, {
	        key: 'submitSearchForm',
	        value: function submitSearchForm(event) {
	            event.preventDefault();
	            this.props.submitSearchForm(this.state.searchTerm, this.props.locale.currentLocale);
	        }
	    }, {
	        key: 'toggleTaxons',
	        value: function toggleTaxons() {
	            this.setState(function (prevState) {
	                return { showTaxons: !prevState.showTaxons };
	            });
	        }
	    }, {
	        key: 'selectTaxon',
	        value: function selectTaxon(e) {
	            // this.setState({ taxonSelected: e.target.id, taxonSelectedName: e.target.getAttribute('aria-label') });
	            this.toggleTaxons();
	        }
	    }, {
	        key: 'onClear',
	        value: function onClear() {
	            if (this.state.searchTerm && this.state.searchTerm.length > 0) {
	                this.setState({ searchTerm: '' });
	                this.searchInput.current.focus();
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            // const taxonList = this.props.filterTaxons(this.props.taxons).map((taxon) => (
	            //     <li
	            //         key={taxon.id}
	            //         className={`${this.state.taxonSelected === taxon.attributes.permalink ? styles.activeResultOption : ''} ${styles.selectResultOption}`}
	            //         onClick={(e) => this.selectTaxon(e)}
	            //     >
	            //         <div id={taxon.attributes.permalink} aria-label={taxon.attributes.name} className={taxon.attributes.depth === 0 ? styles.level0 : styles.level1}>
	            //             {taxon.attributes.name}
	            //         </div>
	            //     </li>
	            // ));
	
	            return _react2.default.createElement(
	                'form',
	                { onSubmit: this.submitSearchForm, className: _searchForm2.default.navbarSearch },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'form-group input-group ' + _searchForm2.default.formGroup },
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'input-group-btn ' + _searchForm2.default.inputGroupButton },
	                        _react2.default.createElement(
	                            'button',
	                            { type: 'submit', className: 'btn icon-btn ' + _searchForm2.default.inputButton },
	                            _react2.default.createElement('i', { className: 'pe-7s-search pe-lg ' + _searchForm2.default.headerSearchIcon })
	                        )
	                    ),
	                    _react2.default.createElement('input', {
	                        type: 'text',
	                        className: 'form-control ' + _searchForm2.default.headerSearchInput,
	                        onChange: this.onSearchInputChange,
	                        placeholder: '',
	                        defaultValue: this.props.searchTerm,
	                        id: 'search-input-box',
	                        value: this.state.searchTerm,
	                        ref: this.searchInput
	                    }),
	                    _react2.default.createElement(
	                        'span',
	                        { onClick: this.onClear, className: _searchForm2.default.closeIcon + ' ' + (this.state.searchTerm && this.state.searchTerm.length > 0 ? _searchForm2.default.closeIconEnabled : _searchForm2.default.closeIconDisabled), title: 'Clear' },
	                        _react2.default.createElement(
	                            'svg',
	                            { xmlns: 'http://www.w3.org/2000/svg', width: '16', height: '16', fill: 'currentColor', className: 'bi bi-x-lg', viewBox: '0 0 16 16' },
	                            _react2.default.createElement('path', { d: 'M1.293 1.293a1 1 0 0 1 1.414 0L8 6.586l5.293-5.293a1 1 0 1 1 1.414 1.414L9.414 8l5.293 5.293a1 1 0 0 1-1.414 1.414L8 9.414l-5.293 5.293a1 1 0 0 1-1.414-1.414L6.586 8 1.293 2.707a1 1 0 0 1 0-1.414z' })
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return SearchForm;
	}(_react.Component);
	
	exports.default = SearchForm;

/***/ },
/* 728 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(41);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(26);
	
	var _reactIntl = __webpack_require__(11);
	
	var _header = __webpack_require__(101);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _appRoutes = __webpack_require__(22);
	
	var _appRoutes2 = _interopRequireDefault(_appRoutes);
	
	var _kwalletActivationModal = __webpack_require__(245);
	
	var _kwalletActivationModal2 = _interopRequireDefault(_kwalletActivationModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Styles
	
	
	var pageWallet = 'kwallet';
	
	var UserMenu = function (_Component) {
	    _inherits(UserMenu, _Component);
	
	    function UserMenu(props) {
	        var _this2 = this;
	
	        _classCallCheck(this, UserMenu);
	
	        var _this = _possibleConstructorReturn(this, (UserMenu.__proto__ || Object.getPrototypeOf(UserMenu)).call(this, props));
	
	        _this.handleClickOutside = function (event) {
	            if (_this.container.current && !_this.container.current.contains(event.target)) {
	                document.removeEventListener('mousedown', _this.handleClickOutside);
	                _this.setState({
	                    showUserMenu: false
	                });
	            }
	        };
	
	        _this.handleKWalletActivateModal = function () {
	            var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(result) {
	                var activate;
	                return _regenerator2.default.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                if (!result) {
	                                    _context.next = 8;
	                                    break;
	                                }
	
	                                _context.next = 3;
	                                return _this.props.activateWallet(_this.state.token, pageWallet);
	
	                            case 3:
	                                activate = _context.sent;
	
	                                _this.setState({
	                                    showActivateKWallet: false
	                                });
	                                if (activate) {
	                                    window.location.assign(_appRoutes2.default.manageKWallet);
	                                }
	                                _context.next = 9;
	                                break;
	
	                            case 8:
	                                _this.setState({
	                                    showActivateKWallet: false
	                                });
	
	                            case 9:
	                            case 'end':
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, _this2);
	            }));
	
	            return function (_x) {
	                return _ref.apply(this, arguments);
	            };
	        }();
	
	        _this.checkForActiveWallet = function () {
	            var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(wallet) {
	                var result;
	                return _regenerator2.default.wrap(function _callee2$(_context2) {
	                    while (1) {
	                        switch (_context2.prev = _context2.next) {
	                            case 0:
	                                _context2.next = 2;
	                                return _this.props.isWalletActive(_this.props.access_token, pageWallet);
	
	                            case 2:
	                                result = _context2.sent;
	
	                                if (result) {
	                                    window.location.assign(_appRoutes2.default.manageKWallet);
	                                } else {
	                                    _this.setState({
	                                        showActivateKWallet: true
	                                    });
	                                }
	
	                            case 4:
	                            case 'end':
	                                return _context2.stop();
	                        }
	                    }
	                }, _callee2, _this2);
	            }));
	
	            return function (_x2) {
	                return _ref2.apply(this, arguments);
	            };
	        }();
	
	        _this.container = _react2.default.createRef();
	        _this.state = {
	            showUserMenu: false,
	            showActivateKWallet: false,
	            token: props.access_token
	        };
	
	        _this.toggleUserMenu = _this.toggleUserMenu.bind(_this);
	        _this.handleKWalletActivateModal = _this.handleKWalletActivateModal.bind(_this);
	        _this.checkForActiveWallet = _this.checkForActiveWallet.bind(_this);
	        return _this;
	    }
	
	    _createClass(UserMenu, [{
	        key: 'onLogout',
	        value: function onLogout() {
	            this.toggleUserMenu();
	            this.props.logout();
	        }
	    }, {
	        key: 'toggleUserMenu',
	        value: function toggleUserMenu() {
	            var _this3 = this;
	
	            this.setState(function (prevState) {
	                return { showUserMenu: !prevState.showUserMenu };
	            }, function () {
	                if (_this3.state.showUserMenu) {
	                    document.addEventListener('mousedown', _this3.handleClickOutside);
	                } else {
	                    document.removeEventListener('mousedown', _this3.handleClickOutside);
	                }
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this4 = this;
	
	            var user = this.props.user;
	
	
	            return (
	                // eslint-disable-next-line react/jsx-fragments
	                _react2.default.createElement(
	                    _react2.default.Fragment,
	                    null,
	                    _react2.default.createElement(
	                        'li',
	                        { className: 'dropdown config', ref: this.container },
	                        _react2.default.createElement(
	                            'a',
	                            { className: 'dropdown-toggle line-double ' + _header2.default.lineDouble, onClick: this.toggleUserMenu },
	                            _react2.default.createElement(
	                                'span',
	                                { className: 'text' },
	                                _react2.default.createElement('i', { className: 'pe-7f-user pe-lg pe-va' }),
	                                _react2.default.createElement(
	                                    'span',
	                                    { className: _header2.default.hello },
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'hello', defaultMessage: 'Hello!' })
	                                ),
	                                _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    user.email.split('@')[0]
	                                )
	                            ),
	                            _react2.default.createElement('i', { className: 'pe-7s-angle-down pe-1x pe-va font-weight-bold ' + _header2.default.angleDown, style: { display: this.state.showUserMenu ? 'none' : 'inline-block' } }),
	                            _react2.default.createElement('i', { className: 'pe-7s-angle-up pe-1x pe-va font-weight-bold ' + _header2.default.angleUp, style: { display: this.state.showUserMenu ? 'inline-block' : 'none' } })
	                        ),
	                        _react2.default.createElement(
	                            'ul',
	                            { className: 'dropdown-menu ' + _header2.default.userMenuDropdowns, style: { display: this.state.showUserMenu ? 'block' : 'none' } },
	                            _react2.default.createElement(
	                                'li',
	                                { onClick: function onClick() {
	                                        return _this4.toggleUserMenu();
	                                    } },
	                                _react2.default.createElement(
	                                    _reactRouterDom.Link,
	                                    { to: _appRoutes2.default.orders },
	                                    _react2.default.createElement('span', { className: 'pe-7s pe-7s-user ' + _header2.default.userMenuIcon }),
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'my-orders', defaultMessage: 'My Orders' })
	                                ),
	                                ("false") === 'true' && _react2.default.createElement(
	                                    'a',
	                                    { onClick: function onClick() {
	                                            return _this4.checkForActiveWallet(pageWallet);
	                                        } },
	                                    _react2.default.createElement('span', { className: 'pe-7s pe-7s-user ' + _header2.default.userMenuIcon }),
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'manage-k-wallet', defaultMessage: 'Administrar K-Wallet' })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'li',
	                                null,
	                                _react2.default.createElement(
	                                    'a',
	                                    { onClick: function onClick() {
	                                            return _this4.onLogout();
	                                        } },
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'logout', defaultMessage: 'Logout' })
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(_kwalletActivationModal2.default, { isOpen: this.state.showActivateKWallet, handleClose: this.handleKWalletActivateModal })
	                )
	            );
	        }
	    }]);
	
	    return UserMenu;
	}(_react.Component);
	
	exports.default = UserMenu;

/***/ },
/* 729 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(41);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(26);
	
	var _reactIntl = __webpack_require__(11);
	
	var _header = __webpack_require__(101);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _appRoutes = __webpack_require__(22);
	
	var _appRoutes2 = _interopRequireDefault(_appRoutes);
	
	var _localeSelectorConnector = __webpack_require__(366);
	
	var _localeSelectorConnector2 = _interopRequireDefault(_localeSelectorConnector);
	
	var _kwalletActivationModal = __webpack_require__(245);
	
	var _kwalletActivationModal2 = _interopRequireDefault(_kwalletActivationModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var pageWallet = 'kwallet';
	
	var UserMobilMenu = function (_Component) {
	    _inherits(UserMobilMenu, _Component);
	
	    function UserMobilMenu(props) {
	        var _this2 = this;
	
	        _classCallCheck(this, UserMobilMenu);
	
	        var _this = _possibleConstructorReturn(this, (UserMobilMenu.__proto__ || Object.getPrototypeOf(UserMobilMenu)).call(this, props));
	
	        _this.checkForActiveWallet = function () {
	            var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(wallet) {
	                var result;
	                return _regenerator2.default.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                _context.next = 2;
	                                return _this.props.isWalletActive(_this.props.access_token, pageWallet);
	
	                            case 2:
	                                result = _context.sent;
	
	                                if (result) {
	                                    window.location.assign(_appRoutes2.default.manageKWallet);
	                                } else {
	                                    _this.setState({
	                                        showActivateKWallet: true
	                                    });
	                                }
	
	                            case 4:
	                            case 'end':
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, _this2);
	            }));
	
	            return function (_x) {
	                return _ref.apply(this, arguments);
	            };
	        }();
	
	        _this.handleKWalletActivateModal = function () {
	            var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(result) {
	                var activate;
	                return _regenerator2.default.wrap(function _callee2$(_context2) {
	                    while (1) {
	                        switch (_context2.prev = _context2.next) {
	                            case 0:
	                                if (!result) {
	                                    _context2.next = 8;
	                                    break;
	                                }
	
	                                _context2.next = 3;
	                                return _this.props.activateWallet(_this.props.access_token, pageWallet);
	
	                            case 3:
	                                activate = _context2.sent;
	
	                                _this.setState({
	                                    showActivateKWallet: false
	                                });
	                                if (activate) {
	                                    window.location.assign(_appRoutes2.default.manageKWallet);
	                                }
	                                _context2.next = 9;
	                                break;
	
	                            case 8:
	                                _this.setState({
	                                    showActivateKWallet: false
	                                });
	
	                            case 9:
	                            case 'end':
	                                return _context2.stop();
	                        }
	                    }
	                }, _callee2, _this2);
	            }));
	
	            return function (_x2) {
	                return _ref2.apply(this, arguments);
	            };
	        }();
	
	        _this.handleClickOutside = function (event) {
	            if (_this.container.current && !_this.container.current.contains(event.target)) {
	                document.removeEventListener('mousedown', _this.handleClickOutside);
	                _this.setState({
	                    showUserMenu: false
	                });
	            }
	        };
	
	        _this.container = _react2.default.createRef();
	        _this.state = {
	            showUserMenu: false,
	            showActivateKWallet: false
	        };
	
	        _this.toggleUserMenu = _this.toggleUserMenu.bind(_this);
	        return _this;
	    }
	
	    _createClass(UserMobilMenu, [{
	        key: 'onLogout',
	        value: function onLogout() {
	            this.toggleUserMenu();
	            this.props.logout();
	        }
	    }, {
	        key: 'getResult',
	        value: function getResult() {
	            var _this3 = this;
	
	            var result = void 0;
	            var user = this.props.user;
	
	
	            if (user && user.id) {
	                result = _react2.default.createElement(
	                    'li',
	                    { className: 'dropdown config hidden-md hidden-lg pull-right', style: { marginLeft: '15px' } },
	                    _react2.default.createElement(
	                        'a',
	                        { className: 'dropdown-toggle line-double ' + _header2.default.lineDouble + ' ' + _header2.default.avatar_mobile, onClick: this.toggleUserMenu },
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'text' },
	                            _react2.default.createElement('i', { className: 'pe-7f-user pe-lg pe-va' })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'ul',
	                        { className: 'dropdown-menu ' + _header2.default.userMenuDropdowns, style: { display: this.state.showUserMenu ? 'block' : 'none' } },
	                        _react2.default.createElement(
	                            'li',
	                            { className: _header2.default.mobileWelcomeLine },
	                            _react2.default.createElement(
	                                'div',
	                                null,
	                                _react2.default.createElement(
	                                    'span',
	                                    { className: _header2.default.hello },
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'hello', defaultMessage: 'Hello!' })
	                                ),
	                                _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    user.email.split('@')[0]
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            { onClick: function onClick() {
	                                    return _this3.toggleUserMenu();
	                                } },
	                            _react2.default.createElement(
	                                _reactRouterDom.Link,
	                                { to: _appRoutes2.default.orders },
	                                _react2.default.createElement('span', { className: 'pe-7s pe-7s-user ' + _header2.default.userMenuIcon }),
	                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'my-orders', defaultMessage: 'My Orders' })
	                            )
	                        ),
	                        ("false") === 'true' && _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                                'a',
	                                { onClick: function onClick() {
	                                        return _this3.checkForActiveWallet(pageWallet);
	                                    } },
	                                _react2.default.createElement('span', { className: 'pe-7s pe-7s-user ' + _header2.default.userMenuIcon }),
	                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'manage-k-wallet', defaultMessage: 'Administrar K-Wallet' })
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                                'a',
	                                { onClick: function onClick() {
	                                        return _this3.onLogout();
	                                    } },
	                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'logout', defaultMessage: 'Logout' })
	                            )
	                        )
	                    )
	                );
	            } else {
	                result = ("false") !== 'true' && _react2.default.createElement(
	                    _reactRouterDom.Link,
	                    { to: _appRoutes2.default.signin, className: 'link-xs hidden-md hidden-lg pull-right ' + _header2.default.signin },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'signin', defaultMessage: 'Signin' }),
	                    _react2.default.createElement('i', { className: 'pe-7f-user pe-lg pe-va' })
	                );
	            }
	            return result;
	        }
	    }, {
	        key: 'toggleUserMenu',
	        value: function toggleUserMenu() {
	            var _this4 = this;
	
	            this.setState(function (prevState) {
	                return { showUserMenu: !prevState.showUserMenu };
	            }, function () {
	                if (_this4.state.showUserMenu) {
	                    document.addEventListener('mousedown', _this4.handleClickOutside);
	                } else {
	                    document.removeEventListener('mousedown', _this4.handleClickOutside);
	                }
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var user = this.props.user;
	
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'nav navbar-nav navbar-right hidden-md hidden-lg ' + _header2.default.navbarNav + ' ' + _header2.default.icons, ref: this.container },
	                this.getResult(),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row pull-right', style: { marginRight: '3px' } },
	                    _react2.default.createElement(_localeSelectorConnector2.default, null)
	                ),
	                _react2.default.createElement('div', { style: { clear: 'both' } }),
	                _react2.default.createElement(_kwalletActivationModal2.default, { isOpen: this.state.showActivateKWallet, handleClose: this.handleKWalletActivateModal })
	            );
	        }
	    }]);
	
	    return UserMobilMenu;
	}(_react.Component);
	
	exports.default = UserMobilMenu;

/***/ },
/* 730 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(11);
	
	var _actions = __webpack_require__(23);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	var _appActions = __webpack_require__(21);
	
	var _appActions2 = _interopRequireDefault(_appActions);
	
	var _store = __webpack_require__(40);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _ktpOffCanvas = __webpack_require__(2152);
	
	var _ktpOffCanvas2 = _interopRequireDefault(_ktpOffCanvas);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var KtpOffCanvas = function KtpOffCanvas(props) {
	    var children = props.children;
	    var isOpen = props.isOpen;
	    var onClose = props.onClose;
	
	    var componentId = 'KTP-OFF-CANVAS';
	    var rootElem = document.getElementById('root');
	    if (isOpen) {
	        rootElem.classList.add('disabled');
	        _store2.default.dispatch(_actions2.default.setBackgroundDisabled({
	            triggedBy: componentId
	        }));
	    } else if (_store2.default.getState().backgroundDisabled.triggedBy === componentId) {
	        rootElem.classList.remove('disabled');
	        _store2.default.dispatch(_actions2.default.setBackgroundDisabled({
	            triggedBy: null
	        }));
	    }
	    var domElem = isOpen ? _react2.default.createElement(
	        'div',
	        { className: _ktpOffCanvas2.default.ktpOffCanvas },
	        _react2.default.createElement(
	            'div',
	            { className: _ktpOffCanvas2.default.head },
	            _react2.default.createElement(
	                'div',
	                { className: _ktpOffCanvas2.default.title },
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'filters-title', 'default': 'Filtros' })
	            ),
	            _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'button',
	                    { onClick: onClose, type: 'button' },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'apply', 'default': 'Aplicar' })
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            null,
	            children
	        )
	    ) : false;
	    return domElem;
	};
	
	exports.default = KtpOffCanvas;

/***/ },
/* 731 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(26);
	
	var _reactIntl = __webpack_require__(11);
	
	var _priceForm = __webpack_require__(2160);
	
	var _priceForm2 = _interopRequireDefault(_priceForm);
	
	var _clearFilter = __webpack_require__(357);
	
	var _clearFilter2 = _interopRequireDefault(_clearFilter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Validation with REGEX
	var rxLive = /^\d*(?:[.,]\d*)?$/;
	
	var PriceForm = function (_Component) {
	    _inherits(PriceForm, _Component);
	
	    // eslint-disable-next-line no-useless-constructor
	    function PriceForm(props) {
	        _classCallCheck(this, PriceForm);
	
	        var _this = _possibleConstructorReturn(this, (PriceForm.__proto__ || Object.getPrototypeOf(PriceForm)).call(this, props));
	
	        _this.state = {
	            price_min: '',
	            price_max: ''
	        };
	
	        _this.handleInputChange = _this.handleInputChange.bind(_this);
	        _this.handleSubmit = _this.handleSubmit.bind(_this);
	        return _this;
	    }
	
	    _createClass(PriceForm, [{
	        key: 'handleInputChange',
	        value: function handleInputChange(event) {
	            var target = event.target;
	            var name = target.name;
	            var value = target.value;
	
	            if (rxLive.test(value)) {
	                this.setState(_defineProperty({}, name, value));
	            }
	        }
	    }, {
	        key: 'handleSubmit',
	        value: function handleSubmit() {
	            this.props.submit(this.state.price_min, this.state.price_max, this.props.location);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { className: 'row', style: { marginLeft: 15, paddingTop: 5 } },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-xs-3 col-sm-4 col-md-4', style: { padding: 0, marginRight: 0 } },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'input-group' },
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'input-group-addon ' + _priceForm2.default.addon },
	                            '$'
	                        ),
	                        _react2.default.createElement('input', {
	                            type: 'text',
	                            className: 'form-control ' + _priceForm2.default.inputField,
	                            name: 'price_min',
	                            placeholder: 'Min',
	                            inputMode: 'numeric',
	                            value: this.state.price_min,
	                            onChange: this.handleInputChange
	                        })
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-xs-3 col-sm-4 col-md-4', style: { padding: 0, marginLeft: 0, borderRadius: 0 } },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'input-group' },
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'input-group-addon ' + _priceForm2.default.addon },
	                            '$'
	                        ),
	                        _react2.default.createElement('input', {
	                            type: 'text',
	                            className: 'form-control ' + _priceForm2.default.inputField,
	                            name: 'price_max',
	                            placeholder: 'Max',
	                            inputMode: 'numeric',
	                            value: this.state.price_max,
	                            onChange: this.handleInputChange
	                        })
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-xs-2 col-sm-4 col-md-2', style: { paddingLeft: 0, marginLeft: 0, borderRadius: 0 } },
	                    _react2.default.createElement(
	                        'button',
	                        {
	                            type: 'button',
	                            className: 'btn btn-xs ' + _priceForm2.default.btnPrice,
	                            onClick: this.handleSubmit
	                        },
	                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'go', defaultMessage: 'Go!' })
	                    )
	                ),
	                _react2.default.createElement(_clearFilter2.default, {
	                    title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'clear-filter', defaultMessage: 'Clear Filter' }),
	                    setParams: this.props.setParams
	                })
	            );
	        }
	    }]);
	
	    return PriceForm;
	}(_react.Component);
	
	exports.default = (0, _reactIntl.injectIntl)(PriceForm);

/***/ },
/* 732 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(11);
	
	var _reactRouterDom = __webpack_require__(26);
	
	var _reactBootstrap = __webpack_require__(38);
	
	var _DropdownButton = __webpack_require__(159);
	
	var _DropdownButton2 = _interopRequireDefault(_DropdownButton);
	
	var _secondaryMenu = __webpack_require__(2162);
	
	var _secondaryMenu2 = _interopRequireDefault(_secondaryMenu);
	
	var _helper = __webpack_require__(60);
	
	var _priceForm = __webpack_require__(731);
	
	var _priceForm2 = _interopRequireDefault(_priceForm);
	
	var _clearFilter = __webpack_require__(357);
	
	var _clearFilter2 = _interopRequireDefault(_clearFilter);
	
	var _submenuTitle = __webpack_require__(733);
	
	var _submenuTitle2 = _interopRequireDefault(_submenuTitle);
	
	var _menuLink = __webpack_require__(360);
	
	var _menuLink2 = _interopRequireDefault(_menuLink);
	
	var _zoneModal = __webpack_require__(247);
	
	var _zoneModal2 = _interopRequireDefault(_zoneModal);
	
	var _appTranslations = __webpack_require__(33);
	
	var _appTranslations2 = _interopRequireDefault(_appTranslations);
	
	var _zoneService = __webpack_require__(79);
	
	var _zoneService2 = _interopRequireDefault(_zoneService);
	
	var _configs = __webpack_require__(175);
	
	var _configs2 = _interopRequireDefault(_configs);
	
	var _dropdownBuildMenu = __webpack_require__(358);
	
	var _dropdownBuildMenu2 = _interopRequireDefault(_dropdownBuildMenu);
	
	var _store = __webpack_require__(40);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _municipalityService = __webpack_require__(122);
	
	var _municipalityService2 = _interopRequireDefault(_municipalityService);
	
	var _municipalitySelectorModal = __webpack_require__(246);
	
	var _municipalitySelectorModal2 = _interopRequireDefault(_municipalitySelectorModal);
	
	var _actions = __webpack_require__(23);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	var _productModel = __webpack_require__(143);
	
	var _productModel2 = _interopRequireDefault(_productModel);
	
	var _emptyCartWarningModal = __webpack_require__(719);
	
	var _emptyCartWarningModal2 = _interopRequireDefault(_emptyCartWarningModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SecondaryMenu = function (_Component) {
	    _inherits(SecondaryMenu, _Component);
	
	    function SecondaryMenu(props) {
	        _classCallCheck(this, SecondaryMenu);
	
	        var _this = _possibleConstructorReturn(this, (SecondaryMenu.__proto__ || Object.getPrototypeOf(SecondaryMenu)).call(this, props));
	
	        _this.setSelected = function (id, text, to) {
	            // comprobar si todos los productos estan disponibles
	            if (_this.props.order.line_items.length > 0) {
	                _this.setState({
	                    selectedZoneId: id,
	                    pendingPath: to,
	                    showZoneModal: true
	                });
	            } else {
	                var _spreeStore$getState = _store2.default.getState();
	
	                var availableZones = _spreeStore$getState.zones.availableZones;
	                var _spreeStore$getState$ = _spreeStore$getState.municipalities;
	                var availableMunicipalities = _spreeStore$getState$.availableMunicipalities;
	                var currentMunicipality = _spreeStore$getState$.currentMunicipality;
	                var isMunicipalityPromptModalOpen = _spreeStore$getState$.isMunicipalityPromptModalOpen;
	
	                var selectedZoneMunicipalities = _municipalityService2.default.getAvailableMunicipalitiesByZoneId(id, availableZones, availableMunicipalities);
	                if (_municipalityService2.default.isMunicipalitySelectorModalRequired(currentMunicipality, selectedZoneMunicipalities)) {
	                    if (!_this.state.showMunicipalitySelector && !isMunicipalityPromptModalOpen) {
	                        _this.setState(function (state) {
	                            return {
	                                showMunicipalitySelector: true,
	                                selectedZoneMunicipalities: selectedZoneMunicipalities,
	                                paramsToContinue: { id: id, text: text, to: to }
	                            };
	                        });
	                    }
	                } else {
	                    _this.props.setCurrentZone(id);
	                    _this.props.history.push(to);
	                }
	            }
	            // comprobar si todos los productos estan disponibles
	        };
	
	        _this.handleClickOutside = function (e) {
	            if (e.target.id !== 'dropdown-basic-button' && e.target.className !== 'caret') _this.setState(function (state) {
	                return { deployed: state.deployed ? !state.deployed : state.deployed };
	            });else _this.setState(function (state) {
	                return { deployed: !state.deployed };
	            });
	        };
	
	        _this.handleSelectStore = function (e) {
	            var storeId = parseInt(e.target.id, 10);
	            var selectedStore = _this.props.stores.find(function (store) {
	                return store.id === storeId;
	            });
	            _this.props.setCurrentStore(selectedStore);
	            _this.props.fetchProducts(_this.state.params);
	        };
	
	        _this.isCurrentStoreAvailableInCurrentZone = function () {
	            var state = _store2.default.getState();
	            var isCurrentStoreValid = true;
	            if (state.stores && state.stores.currentStore && state.stores.currentStore.id && state.stores && Object.keys(state.stores.storesGrouped).length > 0) {
	                var currentStoreId = state.stores.currentStore.id;
	                var currentZoneId = state.zones.currentZone;
	                if (state.stores.storesGrouped.data[currentZoneId]) {
	                    var storesOfTheCurrentZone = state.stores.storesGrouped.data[currentZoneId];
	                    isCurrentStoreValid = storesOfTheCurrentZone.find(function (store) {
	                        return store.id === currentStoreId;
	                    }) !== undefined;
	                }
	            }
	            return isCurrentStoreValid;
	        };
	
	        _this.defaultMunicipality = {
	            id: -1,
	            name: _this.props.intl.formatMessage({
	                id: 'select',
	                defaultMessage: 'Select'
	            })
	        };
	
	        var eligibleMunicipalities = _municipalityService2.default.getAvailableMunicipalitiesByZoneId(_this.props.currentZone, _this.props.availableZones, _this.props.availableMunicipalities);
	        var targetMunicipality = eligibleMunicipalities.find(function (mun) {
	            return mun.id === _this.props.currentMunicipality;
	        });
	        _this.state = {
	            showCategory: 1,
	            showPrice: 1,
	            params: (0, _helper.getParamsFromWindowLocationSearch)(),
	            menu: [],
	            showZoneModal: false,
	            deployed: false,
	            selectedZoneId: props.currentZone || 6,
	            pendingPath: '',
	            showMunicipalitySelector: false,
	            selectedZoneMunicipalities: [],
	            paramsToContinue: {},
	            municipality: {
	                eligibleMunicipalities: eligibleMunicipalities,
	                currentMunicipality: _this.props.currentMunicipality && targetMunicipality ? targetMunicipality : _this.defaultMunicipality
	            },
	            showEmptyCartModalDueToMunicipalityChange: false
	        };
	
	        _this.setSelectedIndex = _this.setSelectedIndex.bind(_this);
	        _this.setParams = _this.setParams.bind(_this);
	        _this.selectShowValue = _this.selectShowValue.bind(_this);
	        _this.handleCloseZoneModal = _this.handleCloseZoneModal.bind(_this);
	        _this.setSelected = _this.setSelected.bind(_this);
	        _this.handleClickOutside = _this.handleClickOutside.bind(_this);
	        _this.checkAllProdAreAvailables = _this.checkAllProdAreAvailables.bind(_this);
	        _this.handleSelectedZone = _this.handleSelectedZone.bind(_this);
	        _this.buildMenu = _this.buildMenu.bind(_this);
	        return _this;
	    }
	
	    _createClass(SecondaryMenu, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            document.addEventListener('click', this.handleClickOutside);
	            this.props.loadGroupedStores().then(function (groupedStores) {
	                _this2.buildMenu(groupedStores.zones, groupedStores.data);
	            });
	        }
	    }, {
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate(nextProps, nextState) {
	            var isCurrentStoreValid = this.isCurrentStoreAvailableInCurrentZone();
	            return JSON.stringify(nextProps) !== JSON.stringify(nextState) || !isCurrentStoreValid;
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps) {
	            var _this3 = this;
	
	            var isCurrentStoreValid = this.isCurrentStoreAvailableInCurrentZone();
	            if (!isCurrentStoreValid) {
	                var state = _store2.default.getState();
	                var currentZone = state.zones.availableZones.find(function (zone) {
	                    return zone.id === state.zones.currentZone;
	                });
	                this.handleSelectedZone(currentZone);
	            }
	            if (prevProps.currentZone !== this.props.currentZone) {
	                var eligibleMunicipalities = _municipalityService2.default.getAvailableMunicipalitiesByZoneId(this.props.currentZone, this.props.availableZones, this.props.availableMunicipalities);
	                var targetMunicipality = this.props.currentMunicipality ? eligibleMunicipalities.find(function (mun) {
	                    return mun.id === _this3.props.currentMunicipality;
	                }) : undefined;
	                // eslint-disable-next-line react/no-did-update-set-state
	                this.setState({
	                    municipality: {
	                        eligibleMunicipalities: eligibleMunicipalities,
	                        currentMunicipality: targetMunicipality || this.defaultMunicipality
	                    }
	                });
	            }
	            if (prevProps.currentMunicipality !== this.props.currentMunicipality) {
	                var _eligibleMunicipalities = _municipalityService2.default.getAvailableMunicipalitiesByZoneId(this.props.currentZone, this.props.availableZones, this.props.availableMunicipalities);
	                var _targetMunicipality = _eligibleMunicipalities.find(function (mun) {
	                    return mun.id === _this3.props.currentMunicipality;
	                });
	                // eslint-disable-next-line react/no-did-update-set-state
	                this.setState(function (state) {
	                    return _extends({}, state, {
	                        municipality: {
	                            eligibleMunicipalities: _eligibleMunicipalities,
	                            currentMunicipality: _this3.props.currentMunicipality && _targetMunicipality ? _targetMunicipality : _this3.defaultMunicipality
	                        }
	                    });
	                });
	            }
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            document.removeEventListener('click', this.handleClickOutside);
	        }
	    }, {
	        key: 'setSelectedIndex',
	        value: function setSelectedIndex(index, name) {
	            this.setState(function (state) {
	                return _extends({}, state, _defineProperty({}, name, index));
	            });
	        }
	    }, {
	        key: 'setParams',
	        value: function setParams() {
	            var params = (0, _helper.getParamsFromWindowLocationSearch)();
	            this.setState(function (state) {
	                return _extends({}, state, { params: params });
	            });
	        }
	    }, {
	        key: 'buildMenu',
	        value: function buildMenu(zones, stores) {
	            var tmpMenu = _dropdownBuildMenu2.default.buildMenu(zones, stores);
	            this.setState(function (prevState) {
	                return { menu: tmpMenu };
	            });
	        }
	    }, {
	        key: 'checkAllProdAreAvailables',
	        value: function checkAllProdAreAvailables() {
	            var _this4 = this;
	
	            if (!this.props.currentZone) {
	                console.log('WARNING: currentZone is NOT available');
	                return false;
	            }
	            if (!this.props.order || !this.props.order.line_items || this.props.order.line_items.length > 0 && !this.props.order.line_items[0].attributes.zone_ids) {
	                console.log('Order zones are NOT available');
	                return false;
	            }
	            return this.props.order.line_items.length === 0 || this.props.order.line_items.every(function (item) {
	                return item.attributes.zone_ids.some(function (zone) {
	                    return zone === _this4.props.currentZone;
	                });
	            });
	        }
	    }, {
	        key: 'handleCloseZoneModal',
	        value: function handleCloseZoneModal(clean) {
	            var _this5 = this;
	
	            if (clean) {
	                this.props.emptyCart(this.props.order, this.props.locale.currentLocale).then(function () {
	                    _this5.props.setCurrentZone(_this5.state.selectedZoneId);
	                    _this5.props.history.push(_this5.state.pendingPath);
	                }).catch(function (err) {
	                    return console.log(err);
	                });
	            }
	            this.setState({ showZoneModal: false });
	        }
	    }, {
	        key: 'selectShowValue',
	        value: function selectShowValue(type) {
	            return type === 'category' ? this.state.showCategory : this.state.showPrice;
	        }
	    }, {
	        key: 'handleSelectedZone',
	        value: function handleSelectedZone(zone) {
	            var _this6 = this;
	
	            var storesInZone = this.props.storesGrouped.data[zone.id];
	            var isStoreInNewZone = storesInZone.find(function (store) {
	                return store.id === _this6.props.currentStore.id;
	            }) !== undefined;
	            var to = '';
	
	            if (this.props.location.pathname !== '/' && isStoreInNewZone) {
	                to = this.props.location.pathname;
	            } else if (this.props.location.pathname !== '/') {
	                to = storesInZone[0].code;
	            } else {
	                to = this.props.path;
	            }
	
	            this.setSelected(zone.id, zone.name, to + '?' + ('' + (this.state.params.price_min ? 'price_min=' + this.state.params.price_min : '')) + ('' + (this.state.params.price_max ? '&price_max=' + this.state.params.price_max : '')) + ('' + (this.state.params.category ? '&category=' + this.state.params.category : '')) + ('&zone_id=' + zone.id));
	        }
	    }, {
	        key: 'handleCloseModalSelectedMunicipality',
	        value: function handleCloseModalSelectedMunicipality(municipality) {
	            _store2.default.dispatch(_actions2.default.setCurrentMunicipality(municipality.id));
	            var _state$paramsToContin = this.state.paramsToContinue;
	            var id = _state$paramsToContin.id;
	            var text = _state$paramsToContin.text;
	            var to = _state$paramsToContin.to;
	
	            this.setSelected(id, text, to);
	            this.setState({
	                showMunicipalitySelector: false,
	                paramsToContinue: {}
	            });
	        }
	    }, {
	        key: 'handleSelectedMunicipality',
	        value: function handleSelectedMunicipality(municipality) {
	            if (municipality.id !== this.state.municipality.currentMunicipality.id) {
	                if (this.props.order.line_items.length > 0) {
	                    this.setState({
	                        showEmptyCartModalDueToMunicipalityChange: true,
	                        paramsToContinue: municipality
	                    });
	                } else {
	                    this.changeMunicipality(municipality);
	                }
	            }
	        }
	    }, {
	        key: 'handleCloseEmptyCartModal',
	        value: function handleCloseEmptyCartModal(response) {
	            var _this7 = this;
	
	            if (response) {
	                this.props.emptyCart(this.props.order, this.props.locale.currentLocale).then(function () {
	                    var municipality = _this7.state.paramsToContinue;
	                    _this7.changeMunicipality(municipality);
	                    _this7.setState({
	                        showEmptyCartModalDueToMunicipalityChange: false,
	                        paramsToContinue: {}
	                    });
	                    _this7.props.setCurrentZone(_this7.state.selectedZoneId);
	                    _this7.props.history.push(_this7.state.pendingPath);
	                }).catch(function (err) {
	                    return console.log(err);
	                });
	            } else {
	                this.setState({
	                    showEmptyCartModalDueToMunicipalityChange: false,
	                    paramsToContinue: {}
	                });
	            }
	        }
	    }, {
	        key: 'changeMunicipality',
	        value: function changeMunicipality(municipality) {
	            if (municipality) {
	                _store2.default.dispatch(_actions2.default.setCurrentMunicipality(municipality.id));
	                this.setState({
	                    showMunicipalitySelector: false,
	                    paramsToContinue: {}
	                });
	
	                var _spreeStore$getState2 = _store2.default.getState();
	
	                var currentLocale = _spreeStore$getState2.locale;
	
	                _store2.default.dispatch(_actions2.default.displayLoader());
	                _store2.default.dispatch(_actions2.default.fetchProducts({ page_no: 1, currentLocale: currentLocale })).then(function (response) {
	                    var fetchedProducts = response.body;
	                    _store2.default.dispatch(_actions2.default.addProducts({ products: _productModel2.default.filterUniqueProducts(fetchedProducts.data), meta: fetchedProducts.meta }));
	                    _store2.default.dispatch(_actions2.default.hideLoader());
	                });
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this8 = this;
	
	            var menuStore = !this.props.displayLoader ? this.props.taxons.taxonsMenu.find(function (taxon) {
	                return taxon.store.id === _this8.props.currentStore.id;
	            }) : [];
	
	            var menuLevel2 = function menuLevel2(taxons, store) {
	                return taxons.map(function (taxon, index) {
	                    return _react2.default.createElement(_menuLink2.default, {
	                        key: taxon.id,
	                        className: _this8.state.params.category !== taxon.permalink ? _secondaryMenu2.default.paddingLeft30 : _secondaryMenu2.default.active,
	                        pathname: _this8.props.path,
	                        search: '?category=' + taxon.permalink + (_this8.state.params.price_min && _this8.state.params.price_max ? '&price_min=' + _this8.state.params.price_min + '&price_max=' + _this8.state.params.price_max : ''),
	                        isActive: function isActive(match, location) {
	                            return _this8.state.params.category === taxon.permalink;
	                        },
	                        name: taxon.name,
	                        setParams: _this8.setParams
	                    });
	                });
	            };
	
	            var menuLevel1 = function menuLevel1(item) {
	                return item && item.taxons && [].concat(item.taxons).sort(function (a, b) {
	                    return a.rgt > b.rgt ? 1 : -1;
	                }).map(function (taxon, index) {
	                    return _react2.default.createElement(
	                        'ul',
	                        { key: index },
	                        taxon.taxons.length !== 0 ? _react2.default.createElement(
	                            _submenuTitle2.default,
	                            {
	                                open: true,
	                                isLink: taxon.taxons.length !== 0,
	                                key: taxon.taxonCategory.id,
	                                className: _this8.state.params.category === taxon.taxonCategory.permalink ? _secondaryMenu2.default.activeBorder : undefined,
	                                pathname: _this8.props.path,
	                                search: '?category=' + taxon.taxonCategory.permalink + (_this8.state.params.price_min && _this8.state.params.price_max ? '&price_min=' + _this8.state.params.price_min + '&price_max=' + _this8.state.params.price_max : ''),
	                                isActive: function isActive(match, location) {
	                                    return _this8.state.params.category === taxon.taxonCategory.permalink;
	                                },
	                                title: taxon.taxonCategory.name,
	                                setParams: _this8.setParams
	                            },
	                            taxon.taxons.length ? menuLevel2(taxon.taxons, item.store) : ''
	                        ) : _react2.default.createElement(_menuLink2.default, {
	                            key: taxon.taxonCategory.id,
	                            className: _this8.state.params.category === taxon.taxonCategory.permalink ? _secondaryMenu2.default.activeBorder : undefined,
	                            pathname: _this8.props.path,
	                            search: '?category=' + taxon.taxonCategory.permalink + (_this8.state.params.price_min && _this8.state.params.price_max ? '&price_min=' + _this8.state.params.price_min + '&price_max=' + _this8.state.params.price_max : ''),
	                            isActive: function isActive(match, location) {
	                                return _this8.state.params.category === taxon.taxonCategory.permalink;
	                            },
	                            name: taxon.taxonCategory.name,
	                            setParams: _this8.setParams
	                        })
	                    );
	                });
	            };
	
	            var storesInZone = this.props.storesGrouped && this.props.storesGrouped.data && this.props.storesGrouped.data[this.props.currentZone] ? this.props.storesGrouped.data[this.props.currentZone] : [];
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: _secondaryMenu2.default.marginBottom5 },
	                    _react2.default.createElement(_submenuTitle2.default, { open: true, title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'zone', defaultMessage: 'Zone' }) }),
	                    _react2.default.createElement(
	                        'div',
	                        { id: 'zone-selector', className: _secondaryMenu2.default.leftMenuContent, style: { padding: 16 } },
	                        _react2.default.createElement(
	                            _DropdownButton2.default,
	                            {
	                                id: 'dropdown-basic-button',
	                                as: 'button',
	                                className: 'button-cancel button-small button-wide',
	                                title: _zoneService2.default.getNameCurrentZone(this.props.availableZones, this.props.currentZone)
	                            },
	                            this.state.menu.map(function (zone) {
	                                return _react2.default.createElement(
	                                    _reactBootstrap.MenuItem,
	                                    {
	                                        as: 'button',
	                                        id: zone.id,
	                                        key: zone.id,
	                                        onClick: function onClick() {
	                                            return _this8.handleSelectedZone(zone);
	                                        }
	                                    },
	                                    zone.label
	                                );
	                            })
	                        )
	                    ),
	                    this.state.municipality.eligibleMunicipalities.length > 0 && _react2.default.createElement(
	                        'div',
	                        { id: 'municipalities_selector', className: _secondaryMenu2.default.leftMenuContent, style: { paddingLeft: 16, paddingBottom: 16, paddingTop: 0 } },
	                        _react2.default.createElement(
	                            _DropdownButton2.default,
	                            {
	                                id: 'dropdown-basic-button',
	                                as: 'button',
	                                className: 'button-cancel button-small button-wide',
	                                title: this.state.municipality.currentMunicipality.name
	                            },
	                            this.state.municipality.eligibleMunicipalities.map(function (municipality) {
	                                return _react2.default.createElement(
	                                    _reactBootstrap.MenuItem,
	                                    {
	                                        as: 'button',
	                                        id: municipality.id,
	                                        key: 'menu_' + municipality.id,
	                                        onClick: function onClick() {
	                                            return _this8.handleSelectedMunicipality(municipality);
	                                        }
	                                    },
	                                    municipality.name
	                                );
	                            })
	                        )
	                    )
	                ),
	                _configs2.default.SECONDARY_MENU.STORES && _react2.default.createElement(
	                    'div',
	                    { className: _secondaryMenu2.default.marginBottom5 },
	                    _react2.default.createElement(_submenuTitle2.default, { open: true, title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'store', defaultMessage: 'Store' }) }),
	                    _react2.default.createElement(
	                        'div',
	                        { className: _secondaryMenu2.default.leftMenuContent + ' ' + _secondaryMenu2.default.storeContainer },
	                        _react2.default.createElement(
	                            _DropdownButton2.default,
	                            {
	                                id: 'dropdown-basic-button',
	                                as: 'button',
	                                className: 'button-cancel button-small button-wide',
	                                title: this.props.currentStore.name || ''
	                            },
	                            storesInZone.map(function (store) {
	                                return _react2.default.createElement(_menuLink2.default, {
	                                    key: store.id,
	                                    name: store.name,
	                                    pathname: '/' + store.code
	                                });
	                            })
	                        )
	                    )
	                ),
	                _configs2.default.SECONDARY_MENU.CATEGORIES && _react2.default.createElement(
	                    'div',
	                    { className: _secondaryMenu2.default.marginBottom5 },
	                    _react2.default.createElement(
	                        _submenuTitle2.default,
	                        {
	                            open: true,
	                            title: _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                id: 'category',
	                                defaultMessage: 'Category'
	                            })
	                        },
	                        _react2.default.createElement(
	                            'div',
	                            { className: _secondaryMenu2.default.leftMenuContent },
	                            menuLevel1(menuStore),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'row', style: { marginLeft: 15, paddingTop: 5 } },
	                                _react2.default.createElement(_clearFilter2.default, {
	                                    title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'clear-filter', defaultMessage: 'Clear Filter' }),
	                                    setParams: this.setParams
	                                })
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                        _submenuTitle2.default,
	                        {
	                            open: true,
	                            title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'price', defaultMessage: 'Price' })
	                        },
	                        _react2.default.createElement(
	                            'div',
	                            { className: _secondaryMenu2.default.leftMenuContent },
	                            menuStore && _react2.default.createElement(
	                                'ul',
	                                null,
	                                _react2.default.createElement(_menuLink2.default, {
	                                    className: this.state.params.price_min === '0' && this.state.params.price_max === '25' ? _secondaryMenu2.default.activeBorder : undefined,
	                                    pathname: this.props.location.pathname !== '/' ? this.props.location.pathname : this.props.path,
	                                    search: '?price_min=0&price_max=25' + (this.state.params.category ? '&category=' + this.state.params.category : ''),
	                                    isActive: function isActive(match, location) {
	                                        return _this8.state.params.price_min === '0' && _this8.state.params.price_max === '25';
	                                    },
	                                    name: _appTranslations2.default[this.props.locale.currentLocale]['under-price'] + ' $25',
	                                    setParams: this.setParams,
	                                    style: { textTransform: 'none' }
	                                }),
	                                _react2.default.createElement(_menuLink2.default, {
	                                    className: this.state.params.price_min === '25' && this.state.params.price_max === '50' ? _secondaryMenu2.default.activeBorder : undefined,
	                                    pathname: this.props.location.pathname !== '/' ? this.props.location.pathname : this.props.path,
	                                    search: '?price_min=25&price_max=50' + (this.state.params.category ? '&category=' + this.state.params.category : ''),
	                                    isActive: function isActive(match, location) {
	                                        return _this8.state.params.price_min === '25' && _this8.state.params.price_max === '50';
	                                    },
	                                    name: '$25-$50',
	                                    setParams: this.setParams
	                                }),
	                                _react2.default.createElement(_menuLink2.default, {
	                                    className: this.state.params.price_min === '50' && this.state.params.price_max === '75' ? _secondaryMenu2.default.activeBorder : undefined,
	                                    pathname: this.props.location.pathname !== '/' ? this.props.location.pathname : this.props.path,
	                                    search: '?price_min=50&price_max=75' + (this.state.params.category ? '&category=' + this.state.params.category : ''),
	                                    isActive: function isActive(match, location) {
	                                        return _this8.state.params.price_min === '50' && _this8.state.params.price_max === '75';
	                                    },
	                                    name: '$50-$75',
	                                    setParams: this.setParams
	                                }),
	                                _react2.default.createElement(_menuLink2.default, {
	                                    className: this.state.params.price_min === '75' && this.state.params.price_max === '100' ? _secondaryMenu2.default.activeBorder : undefined,
	                                    pathname: this.props.location.pathname !== '/' ? this.props.location.pathname : this.props.path,
	                                    search: '?price_min=75&price_max=100' + (this.state.params.category ? '&category=' + this.state.params.category : ''),
	                                    isActive: function isActive(match, location) {
	                                        return _this8.state.params.price_min === '75' && _this8.state.params.price_max === '100';
	                                    },
	                                    name: '$75-$100',
	                                    setParams: this.setParams
	                                }),
	                                _react2.default.createElement(_menuLink2.default, {
	                                    className: this.state.params.price_min === '100' && this.state.params.price_max === 'undefined' ? _secondaryMenu2.default.activeBorder : undefined,
	                                    pathname: this.props.location.pathname !== '/' ? this.props.location.pathname : this.props.path,
	                                    search: '?price_min=100' + (this.state.params.category ? '&category=' + this.state.params.category : ''),
	                                    isActive: function isActive(match, location) {
	                                        return _this8.state.params.price_min === '100' && _this8.state.params.price_max === 'undefined';
	                                    },
	                                    name: _appTranslations2.default[this.props.locale.currentLocale]['above-price'] + ' $100',
	                                    setParams: this.setParams,
	                                    style: { textTransform: 'none' }
	                                })
	                            ),
	                            _react2.default.createElement(_priceForm2.default, {
	                                setParams: this.setParams,
	                                location: this.props.location.pathname !== '/' ? this.props.location.pathname : this.props.pat,
	                                submit: this.props.submitPriceForm
	                            })
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(_zoneModal2.default, {
	                        show: this.state.showZoneModal,
	                        onHide: this.handleCloseZoneModal
	                    }),
	                    _react2.default.createElement(_municipalitySelectorModal2.default, {
	                        isOpen: this.state.showMunicipalitySelector,
	                        currentZoneMunicipalities: this.state.selectedZoneMunicipalities,
	                        handleClose: function handleClose(municipality) {
	                            return _this8.handleCloseModalSelectedMunicipality(municipality);
	                        }
	                    }),
	                    _react2.default.createElement(_emptyCartWarningModal2.default, {
	                        isOpen: this.state.showEmptyCartModalDueToMunicipalityChange,
	                        onClose: function onClose(response) {
	                            return _this8.handleCloseEmptyCartModal(response);
	                        },
	                        messageId: 'modal-municipality-text'
	                    })
	                )
	            );
	        }
	    }]);
	
	    return SecondaryMenu;
	}(_react.Component);
	
	exports.default = (0, _reactRouterDom.withRouter)((0, _reactIntl.injectIntl)(SecondaryMenu));

/***/ },
/* 733 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactCollapsible = __webpack_require__(311);
	
	var _reactCollapsible2 = _interopRequireDefault(_reactCollapsible);
	
	var _header = __webpack_require__(101);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _submenuTitle = __webpack_require__(2151);
	
	var _submenuTitle2 = _interopRequireDefault(_submenuTitle);
	
	var _menuLink = __webpack_require__(360);
	
	var _menuLink2 = _interopRequireDefault(_menuLink);
	
	var _helper = __webpack_require__(60);
	
	var _appDefaults = __webpack_require__(39);
	
	var _appDefaults2 = _interopRequireDefault(_appDefaults);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SubmenuTitle = function (_Component) {
	    _inherits(SubmenuTitle, _Component);
	
	    function SubmenuTitle(props) {
	        _classCallCheck(this, SubmenuTitle);
	
	        var _this = _possibleConstructorReturn(this, (SubmenuTitle.__proto__ || Object.getPrototypeOf(SubmenuTitle)).call(this));
	
	        _this.state = {
	            index: props.open ? 1 : 0
	        };
	        _this.setIndex = _this.setIndex.bind(_this);
	        return _this;
	    }
	
	    _createClass(SubmenuTitle, [{
	        key: 'setIndex',
	        value: function setIndex(index) {
	            this.setState({ index: index });
	        }
	    }, {
	        key: 'shouldBeOpened',
	        value: function shouldBeOpened() {
	            return this.props.open;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    _reactCollapsible2.default,
	                    {
	                        trigger: this.props.isLink ? _react2.default.createElement(_menuLink2.default, {
	                            className: this.props.className,
	                            pathname: this.props.pathname,
	                            search: this.props.search,
	                            isActive: this.props.isActive,
	                            setParams: this.props.setParams,
	                            name: _react2.default.createElement(
	                                'div',
	                                { className: 'text-justify' },
	                                _react2.default.createElement(
	                                    'p',
	                                    null,
	                                    this.props.title,
	                                    _react2.default.createElement('i', {
	                                        className: (this.state.index === 1 ? 'pe-7s-angle-down' : 'pe-7s-angle-up') + ' pe-1x pe-va font-weight-bold pull-right \n                                                ' + _header2.default.angleDown + ' \n                                                ' + _submenuTitle2.default.titleArrow
	                                    })
	                                )
	                            )
	                        }) : _react2.default.createElement(
	                            'div',
	                            { className: 'text-justify ' + _submenuTitle2.default.leftMenuTitleContainer },
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                this.props.title,
	                                _react2.default.createElement('i', {
	                                    className: (this.state.index === 1 ? 'pe-7s-angle-down' : 'pe-7s-angle-up') + ' pe-1x pe-va font-weight-bold pull-right \n                                        ' + _header2.default.angleDown + ' \n                                        ' + _submenuTitle2.default.titleArrow
	                                })
	                            )
	                        ),
	                        open: this.shouldBeOpened(),
	                        onClose: function onClose() {
	                            return _this2.setIndex(0);
	                        },
	                        onOpen: function onOpen() {
	                            return _this2.setIndex(1);
	                        },
	                        transitionTime: 200
	                    },
	                    this.props.children
	                )
	            );
	        }
	    }]);
	
	    return SubmenuTitle;
	}(_react.Component);
	
	exports.default = SubmenuTitle;

/***/ },
/* 734 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _storeTile = __webpack_require__(362);
	
	var _storeTile2 = _interopRequireDefault(_storeTile);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var StoreCard = function StoreCard(_ref) {
	    var name = _ref.name;
	    var styles = _ref.styles;
	    var logo = _ref.logo;
	    var description = _ref.description;
	    return _react2.default.createElement(
	        'div',
	        { className: styles.storeCard },
	        _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_storeTile2.default, { name: name, styles: styles.storeTileCard, logo: logo })
	        ),
	        _react2.default.createElement(
	            'div',
	            { style: { textAlign: 'center' } },
	            _react2.default.createElement(
	                'span',
	                { className: styles.storeTileText },
	                name
	            )
	        )
	    );
	};
	
	exports.default = StoreCard;

/***/ },
/* 735 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(11);
	
	var _reduxForm = __webpack_require__(61);
	
	var _reactRouterDom = __webpack_require__(26);
	
	var _layout = __webpack_require__(29);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _validators = __webpack_require__(104);
	
	var _validators2 = _interopRequireDefault(_validators);
	
	var _formField = __webpack_require__(103);
	
	var _formField2 = _interopRequireDefault(_formField);
	
	var _signin = __webpack_require__(138);
	
	var _signin2 = _interopRequireDefault(_signin);
	
	var _appRoutes = __webpack_require__(22);
	
	var _appRoutes2 = _interopRequireDefault(_appRoutes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var userSignup = function (_Component) {
	    _inherits(userSignup, _Component);
	
	    function userSignup(props) {
	        _classCallCheck(this, userSignup);
	
	        var _this = _possibleConstructorReturn(this, (userSignup.__proto__ || Object.getPrototypeOf(userSignup)).call(this, props));
	
	        _this.handleFormSubmit = _this.handleFormSubmit.bind(_this);
	        document.title = _this.props.intl.formatMessage({ id: 'register', defaultMessage: 'Register' });
	        return _this;
	    }
	
	    _createClass(userSignup, [{
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps) {
	            if (this.props.locale !== prevProps.locale) {
	                document.title = this.props.intl.formatMessage({ id: 'register', defaultMessage: 'Register' });
	            }
	        }
	    }, {
	        key: 'closeModal',
	        value: function closeModal() {
	            this.props.closeModal();
	        }
	    }, {
	        key: 'handleFormSubmit',
	        value: function handleFormSubmit(formData) {
	            this.props.submitSignupForm(formData, this.props.locale.currentLocale).then(function () {});
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props;
	            var handleSubmit = _props.handleSubmit;
	            var intl = _props.intl;
	            var valid = _props.valid;
	            var submitting = _props.submitting;
	
	            return _react2.default.createElement(
	                _layout2.default,
	                null,
	                _react2.default.createElement(
	                    'main',
	                    { className: 'content ' + _signin2.default.signin },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'container ' + _signin2.default.bodyContainer },
	                        _react2.default.createElement(
	                            'section',
	                            null,
	                            _react2.default.createElement(
	                                'p',
	                                { className: _signin2.default.titlePage },
	                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'register', defaultMessage: 'Register' })
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'row' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-lg-offset-4 col-lg-4 col-md-4 col-md-offset-4 col-sm-offset-3 col-sm-6 col-xs-12' },
	                                    _react2.default.createElement(
	                                        'form',
	                                        { className: _signin2.default.form, onSubmit: handleSubmit(this.handleFormSubmit) },
	                                        _react2.default.createElement(
	                                            'div',
	                                            null,
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'form-group ' + _signin2.default.formGroup },
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'col-lg-12 col-md-12 col-sm-12 col-xs-12 holder' },
	                                                    _react2.default.createElement(_reduxForm.Field, {
	                                                        className: _signin2.default.formInput,
	                                                        name: 'user[email]',
	                                                        component: _formField2.default.inputFieldMarkup,
	                                                        type: 'text',
	                                                        autoComplete: 'off',
	                                                        validate: [_validators2.default.required, _validators2.default.email],
	                                                        placeholder: intl.formatMessage({
	                                                            id: 'email',
	                                                            defaultMessage: 'Email'
	                                                        })
	                                                    })
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'form-group ' + _signin2.default.formGroup },
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'col-lg-12 col-md-12 col-sm-12 col-xs-12 ' + _signin2.default.inputGroupEdited },
	                                                    _react2.default.createElement(_reduxForm.Field, {
	                                                        className: _signin2.default.formInput,
	                                                        name: 'user[password]',
	                                                        component: _formField2.default.inputFieldMarkup,
	                                                        autoComplete: 'off',
	                                                        type: 'password',
	                                                        validate: [_validators2.default.required],
	                                                        placeholder: intl.formatMessage({
	                                                            id: 'password',
	                                                            defaultMessage: 'Password'
	                                                        })
	                                                    })
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'form-group ' + _signin2.default.formGroup },
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'col-lg-12 col-md-12 col-sm-12 col-xs-12 ' + _signin2.default.inputGroupEdited },
	                                                    _react2.default.createElement(_reduxForm.Field, {
	                                                        className: _signin2.default.formInput,
	                                                        name: 'user[password_confirmation]',
	                                                        component: _formField2.default.inputFieldMarkup,
	                                                        autoComplete: 'off',
	                                                        type: 'password',
	                                                        validate: [_validators2.default.required, _validators2.default.passwordConfirmation],
	                                                        placeholder: intl.formatMessage({
	                                                            id: 'confirmPassword',
	                                                            defaultMessage: 'Confirm Password'
	                                                        })
	                                                    })
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                'span',
	                                                { hidden: [_validators2.default.passwordConfirmation], className: _signin2.default.fieldError },
	                                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'error-password-not-match', defaultMessage: 'Passwords do not match' })
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'form-group ' + _signin2.default.formGroupHolder },
	                                            _react2.default.createElement(
	                                                'button',
	                                                { className: 'form-control btn btn-default', type: 'submit', disabled: !valid || submitting },
	                                                _react2.default.createElement(
	                                                    'span',
	                                                    null,
	                                                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'signup', defaultMessage: 'Sign Up' })
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'form-legend' },
	                                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'legend-required-field', defaultMessage: '* indicates the field is required' })
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: '' + _signin2.default.forgotLinkContainer },
	                            _react2.default.createElement(
	                                _reactRouterDom.Link,
	                                { to: _appRoutes2.default.signin },
	                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'login-my-account', defaultMessage: 'Login to my account' })
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return userSignup;
	}(_react.Component);
	
	// eslint-disable-next-line no-class-assign
	
	
	userSignup = (0, _reduxForm.reduxForm)({
	    form: 'userSignup'
	})(userSignup);
	
	exports.default = (0, _reactIntl.injectIntl)(userSignup);

/***/ },
/* 736 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(41);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _DropdownButton = __webpack_require__(159);
	
	var _DropdownButton2 = _interopRequireDefault(_DropdownButton);
	
	var _reactBootstrap = __webpack_require__(38);
	
	var _reactIntl = __webpack_require__(11);
	
	var _appDefaults = __webpack_require__(39);
	
	var _appDefaults2 = _interopRequireDefault(_appDefaults);
	
	var _store = __webpack_require__(173);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _dropdownBuildMenu = __webpack_require__(358);
	
	var _dropdownBuildMenu2 = _interopRequireDefault(_dropdownBuildMenu);
	
	var _municipalityService = __webpack_require__(122);
	
	var _municipalityService2 = _interopRequireDefault(_municipalityService);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ZoneSelectModal = function (_Component) {
	    _inherits(ZoneSelectModal, _Component);
	
	    function ZoneSelectModal(props) {
	        _classCallCheck(this, ZoneSelectModal);
	
	        var _this = _possibleConstructorReturn(this, (ZoneSelectModal.__proto__ || Object.getPrototypeOf(ZoneSelectModal)).call(this, props));
	
	        _this.setSelectedZone = function (id, text) {
	            _this.setState(function (prevState) {
	                var selectedZoneMunicipalities = _municipalityService2.default.getAvailableMunicipalitiesByZoneId(id, _this.props.availableZones, _this.props.availableMunicipalities);
	                return {
	                    selectedZone: { id: id, label: text },
	                    selectedMunicipality: _this.defaultMunicipalty,
	                    selectedZoneMunicipalities: selectedZoneMunicipalities
	                };
	            });
	        };
	
	        _this.setSelectedMunicipality = function (id, text) {
	            _this.setState({
	                selectedMunicipality: { id: id, name: text }
	            });
	        };
	
	        _this.handleEnd = function () {
	            _this.props.onHide();
	            _this.props.setUserSelection(_this.state.selectedZone.id, _this.state.selectedMunicipality.id);
	        };
	
	        _this.defaultMunicipalty = {
	            id: undefined,
	            name: _this.props.intl.formatMessage({
	                id: 'select',
	                defaultMessage: 'Select'
	            })
	        };
	        _this.state = {
	            selectedZone: {
	                id: _appDefaults2.default.zoneId,
	                label: _appDefaults2.default.zoneLabel
	            },
	            selectedMunicipality: _this.defaultMunicipalty,
	            selectedZoneMunicipalities: [],
	            availableZones: []
	        };
	
	        _this.setSelectedZone = _this.setSelectedZone.bind(_this);
	        _this.setSelectedMunicipality = _this.setSelectedMunicipality.bind(_this);
	        _this.handleEnd = _this.handleEnd.bind(_this);
	        _this.buildMenu = _this.buildMenu.bind(_this);
	        return _this;
	    }
	
	    _createClass(ZoneSelectModal, [{
	        key: 'componentDidMount',
	        value: function () {
	            var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	                var _this2 = this;
	
	                var response;
	                return _regenerator2.default.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                _context.next = 2;
	                                return _store2.default.getGroupedStores();
	
	                            case 2:
	                                response = _context.sent;
	
	                                this.buildMenu(response.body.zones, response.body.data);
	                                this.setState(function (prevState) {
	                                    var selectedZoneMunicipalities = _municipalityService2.default.getAvailableMunicipalitiesByZoneId(prevState.selectedZone.id, _this2.props.availableZones, _this2.props.availableMunicipalities);
	                                    return { selectedZoneMunicipalities: selectedZoneMunicipalities };
	                                });
	
	                            case 5:
	                            case 'end':
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this);
	            }));
	
	            function componentDidMount() {
	                return _ref.apply(this, arguments);
	            }
	
	            return componentDidMount;
	        }()
	    }, {
	        key: 'buildMenu',
	        value: function buildMenu(zones, stores) {
	            var tmpMenu = _dropdownBuildMenu2.default.buildMenu(zones, stores);
	            this.setState(function (prevState) {
	                return { availableZones: tmpMenu };
	            });
	        }
	    }, {
	        key: 'isModalValid',
	        value: function isModalValid() {
	            return this.state.selectedZone.id !== undefined && (this.state.selectedMunicipality.id !== undefined || this.state.selectedZoneMunicipalities.length === 0);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            return _react2.default.createElement(
	                _reactBootstrap.Modal,
	                {
	                    show: this.props.show,
	                    'aria-labelledby': 'contained-modal-title-lg',
	                    id: 'modal-zone-selector'
	                },
	                _react2.default.createElement(
	                    _reactBootstrap.Modal.Header,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Modal.Title,
	                        { id: 'contained-modal-title-lg' },
	                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'modal-zoneSelect-title', defaultMessage: 'Hello' })
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Modal.Body,
	                    null,
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'modal-zoneSelect-text1', defaultMessage: 'default' })
	                    ),
	                    _react2.default.createElement('br', null),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-sm-3 col-12' },
	                            _react2.default.createElement(
	                                _DropdownButton2.default,
	                                { id: 'dropdown-basic-button', as: 'button', className: 'button-cancel button-small', title: this.state.selectedZone.label },
	                                this.state.availableZones.map(function (zone) {
	                                    return _react2.default.createElement(
	                                        _reactBootstrap.MenuItem,
	                                        {
	                                            as: 'button',
	                                            className: 'button-secondary inv button-small',
	                                            id: zone.id,
	                                            key: zone.id,
	                                            onClick: function onClick() {
	                                                return _this3.setSelectedZone(zone.id, zone.label);
	                                            }
	                                        },
	                                        zone.label
	                                    );
	                                })
	                            )
	                        ),
	                        this.state.selectedZoneMunicipalities.length > 0 && _react2.default.createElement(
	                            'div',
	                            { className: 'col-sm-9 col-12' },
	                            _react2.default.createElement(
	                                _DropdownButton2.default,
	                                { id: 'dropdown-basic-button', as: 'button', className: 'button-cancel button-small municipality-selector', title: this.state.selectedMunicipality.name },
	                                this.state.selectedZoneMunicipalities.map(function (municipality) {
	                                    return _react2.default.createElement(
	                                        _reactBootstrap.MenuItem,
	                                        {
	                                            as: 'button',
	                                            className: 'button-secondary inv button-small',
	                                            id: municipality.id,
	                                            key: municipality.id,
	                                            onClick: function onClick() {
	                                                return _this3.setSelectedMunicipality(municipality.id, municipality.name);
	                                            }
	                                        },
	                                        municipality.name
	                                    );
	                                })
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Modal.Footer,
	                    null,
	                    _react2.default.createElement(
	                        'button',
	                        { type: 'button', disabled: !this.isModalValid(), style: { marginRight: '5px' }, className: 'button-secondary button-small', onClick: function onClick() {
	                                return _this3.handleEnd();
	                            } },
	                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'modal-zoneSelect-accept', defaultMessage: 'Accept' })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ZoneSelectModal;
	}(_react.Component);
	
	exports.default = (0, _reactIntl.injectIntl)(ZoneSelectModal);

/***/ },
/* 737 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var configApp = exports.configApp = function configApp(nameEnv, defaultValue) {
	    var result = defaultValue;
	    if (({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_EMPTY_CART_IN_SECONDS":"720","REACT_APP_FINGERPRINT_ENDPOINT":"https://fku.staging.katapulk.com","REACT_APP_KWALLET_ENABLED":"false","REACT_APP_MAIN_STORE_API_HOST":"https://staging.api.cubalicores.com","REACT_APP_FINGERPRINT_PUBLIC_KEY":"mdaO5TIlVptg2wrFbMdU","REACT_APP_ENV":"develop","REACT_APP_RECAPTCHA_KEY":"b2ce3e581814036777f1fb9b2ccf62b4b368336a0cd142f9045d92dc8b0516670344ee2ac218b7cd98302c719eb99f127a9851f99977e1ba84d0190be8ad8473","REACT_APP_DISABLE_AUTH":"false","REACT_APP_API_HOST":"https://staging.api.cubalicores.com"}).REACT_APP_CONFIGS) {
	        var configs = JSON.parse(({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_EMPTY_CART_IN_SECONDS":"720","REACT_APP_FINGERPRINT_ENDPOINT":"https://fku.staging.katapulk.com","REACT_APP_KWALLET_ENABLED":"false","REACT_APP_MAIN_STORE_API_HOST":"https://staging.api.cubalicores.com","REACT_APP_FINGERPRINT_PUBLIC_KEY":"mdaO5TIlVptg2wrFbMdU","REACT_APP_ENV":"develop","REACT_APP_RECAPTCHA_KEY":"b2ce3e581814036777f1fb9b2ccf62b4b368336a0cd142f9045d92dc8b0516670344ee2ac218b7cd98302c719eb99f127a9851f99977e1ba84d0190be8ad8473","REACT_APP_DISABLE_AUTH":"false","REACT_APP_API_HOST":"https://staging.api.cubalicores.com"}).REACT_APP_CONFIGS);
	        if (nameEnv in configs) {
	            result = configs[nameEnv];
	        }
	    }
	    return result;
	};
	
	exports.default = {
	    configApp: configApp
	};

/***/ },
/* 738 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(18);
	
	var _reactIntl = __webpack_require__(11);
	
	var _appTranslations = __webpack_require__(33);
	
	var _appTranslations2 = _interopRequireDefault(_appTranslations);
	
	var _supportedLocales = __webpack_require__(364);
	
	var _supportedLocales2 = _interopRequireDefault(_supportedLocales);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function mapStateToProps(state) {
	  /*
	  Define user's language. Different browsers have the user locale defined
	  on different fields on the `navigator` object, so we make sure to account
	  for these different by checking all of them.
	  */
	  var language = state.locale.currentLocale;
	  if (!Object.keys(_supportedLocales2.default).includes(language)) {
	    language = navigator.languages && navigator.languages[0] || navigator.language || navigator.userLanguage;
	  }
	
	  /*
	  Split locales with a region code
	  */
	  var languageWithoutRegionCode = language.toLowerCase().split(/[_-]+/)[0];
	
	  /*
	  Try full locale, try locale without region code, fallback to 'en'
	  */
	  var messages = _appTranslations2.default[language] || _appTranslations2.default[languageWithoutRegionCode] || _appTranslations2.default.en;
	
	  return { locale: state.locale.currentLocale, messages: messages };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(_reactIntl.IntlProvider);

/***/ },
/* 739 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reactRedux = __webpack_require__(18);
	
	var _affidavitCertification = __webpack_require__(693);
	
	var _affidavitCertification2 = _interopRequireDefault(_affidavitCertification);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	    return {
	        user: state.user,
	        locale: state.locale
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {};
	};
	
	var AffidavitCertificationConnector = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_affidavitCertification2.default);
	
	exports.default = AffidavitCertificationConnector;

/***/ },
/* 740 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reactRedux = __webpack_require__(18);
	
	var _reactRouterRedux = __webpack_require__(30);
	
	var _reactReduxToastr = __webpack_require__(42);
	
	var _show = __webpack_require__(656);
	
	var _show2 = _interopRequireDefault(_show);
	
	var _actions = __webpack_require__(23);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	var _appActions = __webpack_require__(21);
	
	var _appActions2 = _interopRequireDefault(_appActions);
	
	var _appRoutes = __webpack_require__(22);
	
	var _appRoutes2 = _interopRequireDefault(_appRoutes);
	
	var _appTranslations = __webpack_require__(33);
	
	var _appTranslations2 = _interopRequireDefault(_appTranslations);
	
	var _refreshOrderProcess = __webpack_require__(179);
	
	var _refreshOrderProcess2 = _interopRequireDefault(_refreshOrderProcess);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	    return {
	        order: state.order,
	        locale: state.locale,
	        stores: state.stores.stores,
	        disablingAdd: state.order.disablingAdd,
	        currentZone: state.zones.currentZone,
	        lineItemsError: state.error.errorLineItems
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        setCurrentCheckoutStep: function setCurrentCheckoutStep() {
	            dispatch({
	                type: _appActions2.default.SET_CURRENT_CHECKOUT_STEP,
	                payload: 'cart'
	            });
	        },
	        refreshOrder: function refreshOrder(cartOrder, locale) {
	            dispatch(_actions2.default.refreshOrder(locale)).then(function (data) {
	                if (cartOrder.item_count !== data.body.data.attributes.item_count) {
	                    _reactReduxToastr.toastr.warning(_appTranslations2.default[locale]['warning-product-change-tittle'], _appTranslations2.default[locale]['warning-product-change-content']);
	                }
	            }).catch(function (error) {
	                _reactReduxToastr.toastr.error(_appTranslations2.default[locale].error, _appTranslations2.default[locale]['error-reload-cart-order']);
	                if (error.status === 404) {
	                    dispatch(_actions2.default.emptyCart(cartOrder, locale));
	                    dispatch((0, _reactRouterRedux.push)(_appRoutes2.default.homePageRoute));
	                }
	            });
	        },
	        emptyCart: function emptyCart(order, locale) {
	            if (order.id) {
	                dispatch(_actions2.default.addingProductToCartFix(true));
	                dispatch(_actions2.default.emptyCart(order, locale)).finally(function () {
	                    dispatch(_actions2.default.addingProductToCartFix(false));
	                    _reactReduxToastr.toastr.success(_appTranslations2.default[locale].well, _appTranslations2.default[locale]['cart-is-now-empty']);
	                });
	            } else {
	                _reactReduxToastr.toastr.success(_appTranslations2.default[locale].well, _appTranslations2.default[locale]['cart-already-empty']);
	            }
	        },
	
	        destroyLineItem: function destroyLineItem(lineItem, locale) {
	            dispatch(_actions2.default.removingProductToCart(true));
	            dispatch(_actions2.default.removeProductFromCart(lineItem.id, locale)).then(function () {
	                (0, _refreshOrderProcess2.default)(dispatch, locale, _reactReduxToastr.toastr, {
	                    addingProductToCartAction: false,
	                    successNotify: _reactReduxToastr.toastr.success(_appTranslations2.default[locale].well, _appTranslations2.default[locale]['item-removed-from-cart'])
	                }).finally(function () {
	                    dispatch(_actions2.default.removingProductToCart(false));
	                });
	            }, function (error) {
	                console.log(error);
	                _reactReduxToastr.toastr.error(_appTranslations2.default[locale].error, _appTranslations2.default[locale]['item-not-removed-from-cart']);
	                dispatch(_actions2.default.removingProductToCart(false));
	            });
	        },
	
	        destroyDataExtra: function destroyDataExtra(extraDataId, locale) {
	            dispatch(_actions2.default.removingProductToCart(true));
	            dispatch(_actions2.default.removeDataExtraFromCart(extraDataId, locale)).then(function () {
	                (0, _refreshOrderProcess2.default)(dispatch, locale, _reactReduxToastr.toastr, {
	                    addingProductToCartAction: false,
	                    successNotify: _reactReduxToastr.toastr.success(_appTranslations2.default[locale].well, _appTranslations2.default[locale]['item-removed-from-cart'])
	                }).finally(function () {
	                    dispatch(_actions2.default.removingProductToCart(false));
	                });
	            }, function (error) {
	                console.log(error);
	                _reactReduxToastr.toastr.error(_appTranslations2.default[locale].error, _appTranslations2.default[locale]['item-not-removed-from-cart']);
	                dispatch(_actions2.default.removingProductToCart(false));
	            });
	        },
	
	        changeQuantity: function changeQuantity(lineItemId, quantity, zoneId, locale) {
	            if (parseInt(quantity, 10) > 0) {
	                dispatch(_actions2.default.disablingAdd(false));
	                dispatch(_actions2.default.addingProductToCart());
	                dispatch(_actions2.default.changeProductQuantityFromCart(quantity, lineItemId, zoneId, locale)).then(function () {
	                    (0, _refreshOrderProcess2.default)(dispatch, locale, _reactReduxToastr.toastr, {
	                        addingProductToCartAction: true
	                    });
	                }, function (error) {
	                    dispatch(_actions2.default.addingProductToCart());
	                    dispatch(_actions2.default.disablingAdd(true));
	                    dispatch(_actions2.default.changeProductQuantityFromCart(quantity - 1, lineItemId, zoneId, locale));
	                    _reactReduxToastr.toastr.error(_appTranslations2.default[locale].error, _appTranslations2.default[locale]['unable-update-product-quantity']);
	                });
	            } else {
	                _reactReduxToastr.toastr.error(_appTranslations2.default[locale].error, _appTranslations2.default[locale]['quantity-greater-than-zero']);
	            }
	        },
	
	        disablingPlus: function disablingPlus(enabled) {
	            return dispatch(_actions2.default.disablingAdd(enabled));
	        },
	
	        doCheckout: function doCheckout(order, locale) {
	            var orderStepIndex = order.checkout_steps.indexOf(order.state.trim());
	
	            if (orderStepIndex > 0) {
	                dispatch((0, _reactRouterRedux.push)(_appRoutes2.default.checkout[order.state + 'PageRoute']));
	            } else if (order.state === 'cart') {
	                dispatch(_actions2.default.goToNextStep(order, locale));
	            } else {
	                dispatch((0, _reactRouterRedux.push)(_appRoutes2.default.checkout.addressPageRoute));
	            }
	        }
	    };
	};
	
	var CartShowConnector = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_show2.default);
	
	exports.default = CartShowConnector;

/***/ },
/* 741 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reactRedux = __webpack_require__(18);
	
	var _reactRouterRedux = __webpack_require__(30);
	
	var _actions = __webpack_require__(23);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	var _addressFields = __webpack_require__(659);
	
	var _addressFields2 = _interopRequireDefault(_addressFields);
	
	var _country = __webpack_require__(238);
	
	var _country2 = _interopRequireDefault(_country);
	
	var _appRoutes = __webpack_require__(22);
	
	var _appRoutes2 = _interopRequireDefault(_appRoutes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	    return {
	        locale: state.locale,
	        displayLoader: state.displayLoader,
	        billingCountries: state.countryList.shippingCountries,
	        shippingCountries: state.countryList.billingCountries,
	        municipalityInfo: state.order.municipalityInfo,
	        availableMunicipalities: state.municipalities.availableMunicipalities
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	
	        fetchStatesForCountry: function fetchStatesForCountry(selectedCountryIso, availableName, currentZone) {
	            return _country2.default.getStatesByCountry({ countryId: selectedCountryIso, availableName: availableName, currentZone: currentZone }).then(function (response) {
	                return response.body;
	            }, function () {
	                return { states: [] };
	            });
	        },
	
	        fetchCountries: function fetchCountries(availableName, zoneId) {
	            return _country2.default.getCountryList({ availableName: availableName, zoneId: zoneId }).then(function (response) {
	                // Sort countries alphabetically
	                var countries = response.body.countries.sort(function (a, b) {
	                    if (a.name < b.name) {
	                        return -1;
	                    }
	                    if (a.name > b.name) {
	                        return 1;
	                    }
	                    return 0;
	                });
	
	                if (availableName === 'available_for_billing_true') {
	                    dispatch(_actions2.default.addBillingCountries(countries));
	                } else {
	                    dispatch(_actions2.default.addShippingCountries(countries));
	                }
	            }, function (error) {
	                console.log(error);
	
	                // TODO: Show message
	                // dispatch(Actions.showFlash('Unable to connect to server... Please try again later.'));
	            });
	        },
	
	        fetchMunicipalitiesForCountryState: function fetchMunicipalitiesForCountryState(selectedCountryIso, selectedState) {
	            return _country2.default.getMunicipalityList({ countryId: selectedCountryIso, stateCode: selectedState }).then(function (response) {
	                return response.body;
	            }, function () {
	                return { municipalities: [] };
	            });
	        },
	
	        setCurrentMunicipality: function setCurrentMunicipality(municipalityId) {
	            return dispatch(_actions2.default.setCurrentMunicipality(municipalityId));
	        },
	
	        emptyCurrentCart: function emptyCurrentCart() {
	            return dispatch(_actions2.default.emptyCurrentCart());
	        },
	
	        goToHome: function goToHome() {
	            return dispatch((0, _reactRouterRedux.push)(_appRoutes2.default.homePageRoute));
	        }
	    };
	};
	
	var AddressFieldsConnector = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_addressFields2.default);
	
	exports.default = AddressFieldsConnector;

/***/ },
/* 742 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reactRedux = __webpack_require__(18);
	
	var _reactRouterRedux = __webpack_require__(30);
	
	var _actions = __webpack_require__(23);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	var _appActions = __webpack_require__(21);
	
	var _appActions2 = _interopRequireDefault(_appActions);
	
	var _addressForm = __webpack_require__(658);
	
	var _addressForm2 = _interopRequireDefault(_addressForm);
	
	var _country = __webpack_require__(238);
	
	var _country2 = _interopRequireDefault(_country);
	
	var _appRoutes = __webpack_require__(22);
	
	var _appRoutes2 = _interopRequireDefault(_appRoutes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	    return {
	        order: state.order,
	        currentZone: state.zones.currentZone,
	        currentStore: state.stores.currentStore,
	        displayLoader: state.displayLoader,
	        billingCountries: state.countryList.shippingCountries,
	        shippingCountries: state.countryList.billingCountries,
	        placedOrder: state.placedOrder,
	        locale: state.locale,
	        hasExtraTimeCheckout: state.cartState.hasExtraTimeCheckout,
	        gracePeriod: state.cartState.gracePeriod,
	        fetchData: state.fetchData
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        setCurrentCheckoutStep: function setCurrentCheckoutStep() {
	            dispatch({
	                type: _appActions2.default.SET_CURRENT_CHECKOUT_STEP,
	                payload: 'address'
	            });
	        },
	
	        handleAddressFormSubmit: function handleAddressFormSubmit(formData, order, locale) {
	            return dispatch(_actions2.default.goToNextStep(order, locale, formData));
	        },
	
	        handleCheckoutStepNotEditable: function handleCheckoutStepNotEditable(order, placedOrder) {
	            /* Redirect to last step if order is already placed */
	            if (placedOrder.id) {
	                dispatch((0, _reactRouterRedux.push)(_appRoutes2.default.checkout[placedOrder.checkout_steps.slice(-1) + 'PageRoute']));
	            }
	        },
	
	        redirectToCart: function redirectToCart() {
	            return dispatch((0, _reactRouterRedux.push)(_appRoutes2.default.cartPageRoute));
	        }
	    };
	};
	
	var AddressFormConnector = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_addressForm2.default);
	
	exports.default = AddressFormConnector;

/***/ },
/* 743 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reactRedux = __webpack_require__(18);
	
	var _reactRouterRedux = __webpack_require__(30);
	
	var _actions = __webpack_require__(23);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	var _appActions = __webpack_require__(21);
	
	var _appActions2 = _interopRequireDefault(_appActions);
	
	var _checkoutSuccessPage = __webpack_require__(351);
	
	var _checkoutSuccessPage2 = _interopRequireDefault(_checkoutSuccessPage);
	
	var _checkoutStepCalculator = __webpack_require__(54);
	
	var _checkoutStepCalculator2 = _interopRequireDefault(_checkoutStepCalculator);
	
	var _appRoutes = __webpack_require__(22);
	
	var _appRoutes2 = _interopRequireDefault(_appRoutes);
	
	var _checkoutFailPage = __webpack_require__(662);
	
	var _checkoutFailPage2 = _interopRequireDefault(_checkoutFailPage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	    return {
	        currentCheckoutStep: state.currentCheckoutStep,
	        order: state.order,
	        stores: state.stores.stores,
	        placedOrder: state.placedOrder
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        clearOrder: function clearOrder() {
	            dispatch(_actions2.default.clearOrder());
	        }
	    };
	};
	
	var CheckoutFailConnector = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_checkoutFailPage2.default);
	
	exports.default = CheckoutFailConnector;

/***/ },
/* 744 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reactRedux = __webpack_require__(18);
	
	var _reactRouterRedux = __webpack_require__(30);
	
	var _actions = __webpack_require__(23);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	var _appActions = __webpack_require__(21);
	
	var _appActions2 = _interopRequireDefault(_appActions);
	
	var _checkoutSuccessPage = __webpack_require__(351);
	
	var _checkoutSuccessPage2 = _interopRequireDefault(_checkoutSuccessPage);
	
	var _checkoutStepCalculator = __webpack_require__(54);
	
	var _checkoutStepCalculator2 = _interopRequireDefault(_checkoutStepCalculator);
	
	var _appRoutes = __webpack_require__(22);
	
	var _appRoutes2 = _interopRequireDefault(_appRoutes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	    return {
	        currentCheckoutStep: state.currentCheckoutStep,
	        order: state.order,
	        placedOrder: state.placedOrder,
	        stores: state.stores.stores,
	        currentZone: state.zones.currentZone
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        saveOrderAsPlaced: function saveOrderAsPlaced(order) {
	            dispatch(_actions2.default.addPlacedOrder(order));
	        },
	
	        setCurrentCheckoutStep: function setCurrentCheckoutStep() {
	            dispatch({
	                type: _appActions2.default.SET_CURRENT_CHECKOUT_STEP,
	                payload: 'complete'
	            });
	        },
	
	        handleCheckoutStepNotEditable: function handleCheckoutStepNotEditable(order) {
	            if (order.id) {
	                var previousStep = _checkoutStepCalculator2.default.previous(order.checkout_steps, 'complete');
	
	                dispatch((0, _reactRouterRedux.push)(_appRoutes2.default.checkout[previousStep + 'PageRoute']));
	            } else {
	                dispatch((0, _reactRouterRedux.push)(_appRoutes2.default.cartPageRoute));
	            }
	        },
	
	        clearOrder: function clearOrder() {
	            dispatch(_actions2.default.clearOrder());
	        }
	    };
	};
	
	var CheckoutSuccessConnector = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_checkoutSuccessPage2.default);
	
	exports.default = CheckoutSuccessConnector;

/***/ },
/* 745 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reactRedux = __webpack_require__(18);
	
	var _reactRouterRedux = __webpack_require__(30);
	
	var _actions = __webpack_require__(23);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	var _appActions = __webpack_require__(21);
	
	var _appActions2 = _interopRequireDefault(_appActions);
	
	var _confirmationForm = __webpack_require__(664);
	
	var _confirmationForm2 = _interopRequireDefault(_confirmationForm);
	
	var _checkoutStepCalculator = __webpack_require__(54);
	
	var _checkoutStepCalculator2 = _interopRequireDefault(_checkoutStepCalculator);
	
	var _appRoutes = __webpack_require__(22);
	
	var _appRoutes2 = _interopRequireDefault(_appRoutes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	    return {
	        order: state.order,
	        placedOrder: state.placedOrder,
	        stores: state.stores.stores,
	        locale: state.locale,
	        currentZone: state.zones.currentZone,
	        hasExtraTimeCheckout: state.cartState.hasExtraTimeCheckout,
	        gracePeriod: state.cartState.gracePeriod,
	        orderError: state.placedOrder.orderError,
	        showDialogError: state.placedOrder.showDialogError
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        handleCheckoutStepNotEditable: function handleCheckoutStepNotEditable(order, placedOrder) {
	            /* Redirect to last step if order is already placed */
	            if (placedOrder.id) {
	                dispatch((0, _reactRouterRedux.push)(_appRoutes2.default.checkout[placedOrder.checkout_steps.slice(-1) + 'PageRoute']));
	            } else if (order.id) {
	                var previousStep = _checkoutStepCalculator2.default.previous(order.checkout_steps, 'confirm');
	
	                dispatch((0, _reactRouterRedux.push)(_appRoutes2.default.checkout[previousStep + 'PageRoute']));
	            } else {
	                dispatch((0, _reactRouterRedux.push)(_appRoutes2.default.cartPageRoute));
	            }
	        },
	
	        setCurrentCheckoutStep: function setCurrentCheckoutStep() {
	            dispatch({
	                type: _appActions2.default.SET_CURRENT_CHECKOUT_STEP,
	                payload: 'confirm'
	            });
	        },
	
	        handleFormSubmit: function handleFormSubmit(formData, order, locale) {
	            return dispatch(_actions2.default.goToNextStep(order, locale, formData));
	        },
	
	        redirectToCart: function redirectToCart() {
	            return dispatch((0, _reactRouterRedux.push)(_appRoutes2.default.cartPageRoute));
	        },
	
	        onHideDialogError: function onHideDialogError() {
	            dispatch({
	                type: _appActions2.default.COMPLETE_ORDER_ERROR_HIDE_DIALOG
	            });
	        }
	    };
	};
	
	var CheckoutConfirmationConnector = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_confirmationForm2.default);
	
	exports.default = CheckoutConfirmationConnector;

/***/ },
/* 746 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reactRedux = __webpack_require__(18);
	
	var _reactRouterRedux = __webpack_require__(30);
	
	var _actions = __webpack_require__(23);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	var _appActions = __webpack_require__(21);
	
	var _appActions2 = _interopRequireDefault(_appActions);
	
	var _deliveryForm = __webpack_require__(665);
	
	var _deliveryForm2 = _interopRequireDefault(_deliveryForm);
	
	var _checkoutStepCalculator = __webpack_require__(54);
	
	var _checkoutStepCalculator2 = _interopRequireDefault(_checkoutStepCalculator);
	
	var _appRoutes = __webpack_require__(22);
	
	var _appRoutes2 = _interopRequireDefault(_appRoutes);
	
	var _loader = __webpack_require__(235);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	    return {
	        order: state.order,
	        stores: state.stores.stores,
	        locale: state.locale,
	        placedOrder: state.placedOrder,
	        displayLoader: state.displayLoader,
	        hasExtraTimeCheckout: state.cartState.hasExtraTimeCheckout,
	        gracePeriod: state.cartState.gracePeriod
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        setCurrentCheckoutStep: function setCurrentCheckoutStep() {
	            dispatch({
	                type: _appActions2.default.SET_CURRENT_CHECKOUT_STEP,
	                payload: 'delivery'
	            });
	            dispatch(_loader2.default.hideLoader());
	        },
	
	        handleDeliveryFormSubmit: function handleDeliveryFormSubmit(formData, order, locale) {
	            return dispatch(_actions2.default.goToNextStep(order, locale, formData));
	        },
	
	        handleCheckoutStepNotEditable: function handleCheckoutStepNotEditable(order, placedOrder) {
	            /* Redirect to last step if order is already placed */
	            if (placedOrder.id) {
	                dispatch((0, _reactRouterRedux.push)(_appRoutes2.default.checkout[placedOrder.checkout_steps.slice(-1) + 'PageRoute']));
	            } else if (order.id) {
	                var previousStep = _checkoutStepCalculator2.default.previous(order.checkout_steps, 'delivery');
	
	                dispatch((0, _reactRouterRedux.push)(_appRoutes2.default.checkout[previousStep + 'PageRoute']));
	            }
	        },
	
	        redirectToCart: function redirectToCart() {
	            return dispatch((0, _reactRouterRedux.push)(_appRoutes2.default.cartPageRoute));
	        }
	    };
	};
	
	var DeliveryFormConnector = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_deliveryForm2.default);
	
	exports.default = DeliveryFormConnector;

/***/ },
/* 747 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reactRedux = __webpack_require__(18);
	
	var _reactRouterRedux = __webpack_require__(30);
	
	var _actions = __webpack_require__(23);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	var _appActions = __webpack_require__(21);
	
	var _appActions2 = _interopRequireDefault(_appActions);
	
	var _checkoutStepCalculator = __webpack_require__(54);
	
	var _checkoutStepCalculator2 = _interopRequireDefault(_checkoutStepCalculator);
	
	var _appRoutes = __webpack_require__(22);
	
	var _appRoutes2 = _interopRequireDefault(_appRoutes);
	
	var _paymentRedsysForm = __webpack_require__(671);
	
	var _paymentRedsysForm2 = _interopRequireDefault(_paymentRedsysForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	    return {
	        order: state.order,
	        placedOrder: state.placedOrder,
	        locale: state.locale,
	        stores: state.stores.stores,
	        displayLoader: state.displayLoader
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        setCurrentCheckoutStep: function setCurrentCheckoutStep() {
	            dispatch({
	                type: _appActions2.default.SET_CURRENT_CHECKOUT_STEP,
	                payload: 'payment'
	            });
	        },
	
	        handlePaymentFormSubmit: function handlePaymentFormSubmit(formData, order, locale) {
	            return dispatch(_actions2.default.goToNextStep(order, locale, formData));
	        },
	        handlePaymentBackStep: function handlePaymentBackStep(order, locale) {
	            return dispatch(_actions2.default.goToPrevStep(order, locale, 'payment'));
	        },
	
	        handleCheckoutStepNotEditable: function handleCheckoutStepNotEditable(order, placedOrder) {
	            /* Redirect to last step if order is already placed */
	            if (placedOrder.id) {
	                dispatch((0, _reactRouterRedux.push)(_appRoutes2.default.checkout[placedOrder.checkout_steps.slice(-1) + 'PageRoute']));
	            } else if (order.id) {
	                var previousStep = _checkoutStepCalculator2.default.previous(order.checkout_steps, 'payment');
	
	                dispatch((0, _reactRouterRedux.push)(_appRoutes2.default.checkout[previousStep + 'PageRoute']));
	            } else {
	                dispatch((0, _reactRouterRedux.push)(_appRoutes2.default.cartPageRoute));
	            }
	        },
	
	        redirectToCart: function redirectToCart() {
	            return dispatch((0, _reactRouterRedux.push)(_appRoutes2.default.cartPageRoute));
	        },
	
	        showFormErrors: function showFormErrors(errorNode) {
	            // dispatch(Actions.showFlash(errorNode, 'danger'));
	        },
	
	        getRedsysInfo: function getRedsysInfo() {
	            return dispatch(_actions2.default.getRedsysInfo());
	        },
	
	        addRedsysPaymentError: function addRedsysPaymentError(error) {
	            dispatch(_actions2.default.addRedsysPaymentError(error));
	        }
	    };
	};
	
	var PaymentRedsysFormConnector = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_paymentRedsysForm2.default);
	
	exports.default = PaymentRedsysFormConnector;

/***/ },
/* 748 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reactRedux = __webpack_require__(18);
	
	var _actions = __webpack_require__(23);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	var _paymentRedsysRedirectKo = __webpack_require__(672);
	
	var _paymentRedsysRedirectKo2 = _interopRequireDefault(_paymentRedsysRedirectKo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	    return {
	        order: state.order,
	        placedOrder: state.placedOrder,
	        locale: state.locale,
	        stores: state.stores.stores,
	        hasExtraTimeCheckout: state.cartState.hasExtraTimeCheckout,
	        gracePeriod: state.cartState.gracePeriod
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        addRedsysPaymentError: function addRedsysPaymentError(error) {
	            dispatch(_actions2.default.addRedsysPaymentError(error));
	        }
	    };
	};
	
	var PaymentRedsysRedirectKoConnector = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_paymentRedsysRedirectKo2.default);
	
	exports.default = PaymentRedsysRedirectKoConnector;

/***/ },
/* 749 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reactRedux = __webpack_require__(18);
	
	var _paymentRedsysRedirectOk = __webpack_require__(673);
	
	var _paymentRedsysRedirectOk2 = _interopRequireDefault(_paymentRedsysRedirectOk);
	
	var _actions = __webpack_require__(23);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	var _appActions = __webpack_require__(21);
	
	var _appActions2 = _interopRequireDefault(_appActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	    return {
	        order: state.order,
	        placedOrder: state.placedOrder,
	        locale: state.locale,
	        stores: state.stores.stores
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        refreshOrder: function refreshOrder() {
	            dispatch(_actions2.default.refreshOrder());
	        },
	        goToNextStep: function goToNextStep(order, locale, formData) {
	            dispatch(_actions2.default.goToNextStep(order, locale, formData));
	        },
	        setCurrentCheckoutStep: function setCurrentCheckoutStep() {
	            dispatch({
	                type: _appActions2.default.SET_CURRENT_CHECKOUT_STEP,
	                payload: 'complete'
	            });
	        }
	    };
	};
	
	var PaymentRedsysRedirectOkConnector = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_paymentRedsysRedirectOk2.default);
	
	exports.default = PaymentRedsysRedirectOkConnector;

/***/ },
/* 750 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reactRedux = __webpack_require__(18);
	
	var _reactRouterRedux = __webpack_require__(30);
	
	var _actions = __webpack_require__(23);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	var _appActions = __webpack_require__(21);
	
	var _appActions2 = _interopRequireDefault(_appActions);
	
	var _paymentStep = __webpack_require__(674);
	
	var _paymentStep2 = _interopRequireDefault(_paymentStep);
	
	var _checkoutStepCalculator = __webpack_require__(54);
	
	var _checkoutStepCalculator2 = _interopRequireDefault(_checkoutStepCalculator);
	
	var _appRoutes = __webpack_require__(22);
	
	var _appRoutes2 = _interopRequireDefault(_appRoutes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	    return {
	        order: state.order,
	        placedOrder: state.placedOrder,
	        locale: state.locale,
	        hasExtraTimeCheckout: state.cartState.hasExtraTimeCheckout,
	        gracePeriod: state.cartState.gracePeriod
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        setCurrentCheckoutStep: function setCurrentCheckoutStep() {
	            dispatch({
	                type: _appActions2.default.SET_CURRENT_CHECKOUT_STEP,
	                payload: 'payment'
	            });
	        },
	
	        handlePaymentFormSubmit: function handlePaymentFormSubmit(formData, order, locale) {
	            return dispatch(_actions2.default.goToNextStep(order, locale, formData));
	        },
	
	        handleCheckoutStepNotEditable: function handleCheckoutStepNotEditable(order, placedOrder) {
	            /* Redirect to last step if order is already placed */
	            if (placedOrder.id) {
	                dispatch((0, _reactRouterRedux.push)(_appRoutes2.default.checkout[placedOrder.checkout_steps.slice(-1) + 'PageRoute']));
	            } else if (order.id) {
	                var previousStep = _checkoutStepCalculator2.default.previous(order.checkout_steps, 'payment');
	
	                dispatch((0, _reactRouterRedux.push)(_appRoutes2.default.checkout[previousStep + 'PageRoute']));
	            } else {
	                dispatch((0, _reactRouterRedux.push)(_appRoutes2.default.cartPageRoute));
	            }
	        },
	
	        redirectToCart: function redirectToCart() {
	            return dispatch((0, _reactRouterRedux.push)(_appRoutes2.default.cartPageRoute));
	        },
	
	        clearCreditCardData: function clearCreditCardData() {
	            dispatch({
	                type: _appActions2.default.VALIDATE_CREDIT_CARD,
	                payload: false
	            });
	        },
	
	        showFormErrors: function showFormErrors(errorNode) {
	            // dispatch(Actions.showFlash(errorNode, 'danger'));
	        }
	    };
	};
	
	var PaymentStepConnector = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_paymentStep2.default);
	
	exports.default = PaymentStepConnector;

/***/ },
/* 751 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reactRedux = __webpack_require__(18);
	
	var _comingSoon = __webpack_require__(694);
	
	var _comingSoon2 = _interopRequireDefault(_comingSoon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	    return {
	        user: state.user,
	        locale: state.locale
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {};
	};
	
	var ComingSoonConnector = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_comingSoon2.default);
	
	exports.default = ComingSoonConnector;

/***/ },
/* 752 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reactRedux = __webpack_require__(18);
	
	var _footer = __webpack_require__(720);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	    return {
	        user: state.user,
	        locale: state.locale
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {};
	};
	
	var FooterConnector = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_footer2.default);
	
	exports.default = FooterConnector;

/***/ },
/* 753 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(41);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _reactRedux = __webpack_require__(18);
	
	var _reactReduxToastr = __webpack_require__(42);
	
	var _forgotPassword = __webpack_require__(695);
	
	var _forgotPassword2 = _interopRequireDefault(_forgotPassword);
	
	var _actions = __webpack_require__(23);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	var _user = __webpack_require__(102);
	
	var _user2 = _interopRequireDefault(_user);
	
	var _appTranslations = __webpack_require__(33);
	
	var _appTranslations2 = _interopRequireDefault(_appTranslations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	    return {
	        locale: state.locale
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        submitForgotPassword: function submitForgotPassword(formData, token, locale) {
	            var _this = this;
	
	            return _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	                return _regenerator2.default.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                dispatch(_actions2.default.displayLoader());
	
	                                return _context.abrupt('return', _user2.default.forgotPassword(formData, token).then(function (response) {
	                                    dispatch(_actions2.default.hideLoader());
	                                    return true;
	                                }, function (error) {
	                                    var responseMessage = JSON.parse(JSON.stringify(error));
	                                    dispatch(_actions2.default.hideLoader());
	                                    _reactReduxToastr.toastr.error(_appTranslations2.default[locale].password, responseMessage.response.body.error);
	                                    return false;
	                                }));
	
	                            case 2:
	                            case 'end':
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, _this);
	            }))();
	        }
	    };
	};
	
	var ForgotPasswordConnector = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_forgotPassword2.default);
	
	exports.default = ForgotPasswordConnector;

/***/ },
/* 754 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reactRedux = __webpack_require__(18);
	
	var _frequentQuestions = __webpack_require__(696);
	
	var _frequentQuestions2 = _interopRequireDefault(_frequentQuestions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	    return {
	        user: state.user,
	        locale: state.locale
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {};
	};
	
	var FrequentQuestionsConnector = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_frequentQuestions2.default);
	
	exports.default = FrequentQuestionsConnector;

/***/ },
/* 755 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reactRedux = __webpack_require__(18);
	
	var _reactRouterRedux = __webpack_require__(30);
	
	var _header = __webpack_require__(721);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _actions = __webpack_require__(23);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	var _appRoutes = __webpack_require__(22);
	
	var _appRoutes2 = _interopRequireDefault(_appRoutes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	    return {
	        taxons: state.taxons,
	        user: state.user,
	        locale: state.locale,
	        order: state.order,
	        stores: state.stores,
	        currentZone: state.zones.currentZone,
	        cartState: state.cartState,
	        multiCountryShipping: state.configs.multiCountryShipping,
	        currentMunicipality: state.municipalities.currentMunicipality
	    };
	};
	// TODO refactorizar
	var distinctProducts = function distinctProducts(products) {
	    var productsFilters = [];
	
	    // eslint-disable-next-line no-restricted-syntax
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	        var _loop = function _loop() {
	            var product = _step.value;
	
	            var filterCondition = productsFilters.findIndex(function (item) {
	                return item.id === product.id;
	            }) === -1;
	            if (filterCondition) {
	                productsFilters.push(product);
	            }
	        };
	
	        for (var _iterator = products[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            _loop();
	        }
	    } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	    } finally {
	        try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	                _iterator.return();
	            }
	        } finally {
	            if (_didIteratorError) {
	                throw _iteratorError;
	            }
	        }
	    }
	
	    return productsFilters;
	};
	
	var fetchedProducts = function fetchedProducts(dispatch, locale) {
	    return dispatch(_actions2.default.fetchProducts({ page_no: 1, locale: locale })).then(function (response) {
	        var fetchedProducts = response.body;
	
	        dispatch(_actions2.default.addProducts({ products: distinctProducts(fetchedProducts.data), meta: fetchedProducts.meta }));
	        dispatch(_actions2.default.hideLoader());
	    });
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        goToUserOrders: function goToUserOrders() {
	            dispatch((0, _reactRouterRedux.push)(_appRoutes2.default.ordersPageRoute));
	        },
	
	        logout: function logout() {
	            dispatch(_actions2.default.logout());
	            dispatch((0, _reactRouterRedux.push)(_appRoutes2.default.homePageRoute));
	        },
	        setCurrentStore: function setCurrentStore(store) {
	            dispatch(_actions2.default.displayLoader());
	            dispatch(_actions2.default.fetchStorePayments(store)).then(function () {
	                fetchedProducts(dispatch);
	            }).catch(function (err) {
	                return console.log(err);
	            });
	        },
	
	        setCurrentZone: function setCurrentZone(zoneId) {
	            dispatch(_actions2.default.setCurrentZone(zoneId));
	        },
	        emptyCart: function emptyCart(order, locale) {
	            return dispatch(_actions2.default.emptyCart(order, locale));
	        },
	        loadGroupedStores: function loadGroupedStores() {
	            return dispatch(_actions2.default.loadGroupedStores());
	        }
	    };
	};
	
	var HeaderConnector = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_header2.default);
	
	exports.default = HeaderConnector;

/***/ },
/* 756 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reactRedux = __webpack_require__(18);
	
	var _baseProductList = __webpack_require__(177);
	
	var _baseProductList2 = _interopRequireDefault(_baseProductList);
	
	var _homePage = __webpack_require__(697);
	
	var _homePage2 = _interopRequireDefault(_homePage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	    return {
	        storesGrouped: state.stores.storesGrouped
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {};
	};
	
	var HomePageConnector = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_homePage2.default);
	
	exports.default = (0, _baseProductList2.default)(HomePageConnector);

/***/ },
/* 757 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(18);
	
	var _actions = __webpack_require__(23);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	var _addFundsKWallet = __webpack_require__(692);
	
	var _addFundsKWallet2 = _interopRequireDefault(_addFundsKWallet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	  return {};
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {};
	};
	
	var AddFundsKWalletConnector = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_addFundsKWallet2.default);
	
	exports.default = AddFundsKWalletConnector;

/***/ },
/* 758 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(41);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _reactRedux = __webpack_require__(18);
	
	var _actions = __webpack_require__(23);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	var _manageKWallet = __webpack_require__(698);
	
	var _manageKWallet2 = _interopRequireDefault(_manageKWallet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var pageWallet = 'kwallet'; // wallet por defecto con este conector, puede llevarse a la página y dejarlo limpio aquí
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	    return {
	        user: state.user,
	        locale: state.locale,
	        activeWallet: state.wallets[pageWallet],
	        accessToken: state.auth.access_token
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        fetchWalletTransactions: function fetchWalletTransactions(token, params) {
	            var wallet = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : pageWallet;
	            return dispatch(_actions2.default.fetchWalletTransactions(params, wallet, token));
	        },
	        fetchWalletDetails: function fetchWalletDetails(token) {
	            var wallet = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : pageWallet;
	            return dispatch(_actions2.default.fetchWalletDetails(wallet, token));
	        },
	        isWalletActive: function () {
	            var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(token) {
	                var wallet = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : pageWallet;
	                var active;
	                return _regenerator2.default.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                _context.next = 2;
	                                return dispatch(_actions2.default.activeWallet(wallet, token, true));
	
	                            case 2:
	                                active = _context.sent;
	                                return _context.abrupt('return', active);
	
	                            case 4:
	                            case 'end':
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, undefined);
	            }));
	
	            function isWalletActive(_x4) {
	                return _ref.apply(this, arguments);
	            }
	
	            return isWalletActive;
	        }(),
	        activateWallet: function () {
	            var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(token) {
	                var wallet = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : pageWallet;
	                var activate;
	                return _regenerator2.default.wrap(function _callee2$(_context2) {
	                    while (1) {
	                        switch (_context2.prev = _context2.next) {
	                            case 0:
	                                _context2.next = 2;
	                                return dispatch(_actions2.default.activateWallet(wallet, token));
	
	                            case 2:
	                                activate = _context2.sent;
	                                return _context2.abrupt('return', activate);
	
	                            case 4:
	                            case 'end':
	                                return _context2.stop();
	                        }
	                    }
	                }, _callee2, undefined);
	            }));
	
	            function activateWallet(_x6) {
	                return _ref2.apply(this, arguments);
	            }
	
	            return activateWallet;
	        }(),
	        transferFunds: function () {
	            var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(token, amount, idTransfer) {
	                var wallet = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : pageWallet;
	                return _regenerator2.default.wrap(function _callee3$(_context3) {
	                    while (1) {
	                        switch (_context3.prev = _context3.next) {
	                            case 0:
	                                return _context3.abrupt('return', dispatch(_actions2.default.transferWalletFunds({
	                                    wallet: wallet, token: token, amount: amount, idTransfer: idTransfer
	                                })));
	
	                            case 1:
	                            case 'end':
	                                return _context3.stop();
	                        }
	                    }
	                }, _callee3, undefined);
	            }));
	
	            function transferFunds(_x8, _x9, _x10) {
	                return _ref3.apply(this, arguments);
	            }
	
	            return transferFunds;
	        }()
	    };
	};
	
	var ManageKWalletConnector = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_manageKWallet2.default);
	
	exports.default = ManageKWalletConnector;

/***/ },
/* 759 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reactRedux = __webpack_require__(18);
	
	var _actions = __webpack_require__(23);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	var _baseMenu = __webpack_require__(176);
	
	var _baseMenu2 = _interopRequireDefault(_baseMenu);
	
	var _headerMenu = __webpack_require__(724);
	
	var _headerMenu2 = _interopRequireDefault(_headerMenu);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	    return {
	        currentStore: state.currentStore,
	        availableZones: state.zones.availableZones,
	        currentZone: state.zones.currentZone,
	        availableMunicipalities: state.municipalities.availableMunicipalities,
	        currentMunicipality: state.municipalities.currentMunicipality,
	        isMunicipalityPromptModalOpen: state.municipalities.isMunicipalityPromptModalOpen
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        setCurrentStore: function setCurrentStore(store) {
	            dispatch(_actions2.default.setCurrentStore(store));
	        },
	        setCurrentMunicipality: function setCurrentMunicipality(municipalityId) {
	            dispatch(_actions2.default.setCurrentMunicipality(municipalityId));
	        }
	    };
	};
	
	var HeaderMenuConnector = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_headerMenu2.default);
	
	exports.default = (0, _baseMenu2.default)(HeaderMenuConnector);

/***/ },
/* 760 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reactRedux = __webpack_require__(18);
	
	var _baseMenu = __webpack_require__(176);
	
	var _baseMenu2 = _interopRequireDefault(_baseMenu);
	
	var _mobileMenu = __webpack_require__(726);
	
	var _mobileMenu2 = _interopRequireDefault(_mobileMenu);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	    return {
	        storesGrouped: state.stores.storesGrouped,
	        multiCountryShipping: state.configs.multiCountryShipping,
	        currentMunicipality: state.municipalities.currentMunicipality
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {};
	};
	
	var MobileMenuConnector = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_mobileMenu2.default);
	
	exports.default = (0, _baseMenu2.default)(MobileMenuConnector);

/***/ },
/* 761 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reactRedux = __webpack_require__(18);
	
	var _notFound = __webpack_require__(699);
	
	var _notFound2 = _interopRequireDefault(_notFound);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	    return {
	        user: state.user,
	        locale: state.locale
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {};
	};
	
	var NotFoundConnector = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_notFound2.default);
	
	exports.default = NotFoundConnector;

/***/ },
/* 762 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reactRedux = __webpack_require__(18);
	
	var _reactRouterRedux = __webpack_require__(30);
	
	var _actions = __webpack_require__(23);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	var _list = __webpack_require__(689);
	
	var _list2 = _interopRequireDefault(_list);
	
	var _order = __webpack_require__(239);
	
	var _order2 = _interopRequireDefault(_order);
	
	var _appRoutes = __webpack_require__(22);
	
	var _appRoutes2 = _interopRequireDefault(_appRoutes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	    return {
	        orders: state.orderList.orders,
	        pageCount: state.orderList.totalPages,
	        user: state.user,
	        access_token: state.auth.access_token,
	        stores: state.stores.stores,
	        locale: state.locale
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        loadOrders: function loadOrders(userAPIToken, pageNum, locale) {
	            dispatch(_actions2.default.displayLoader());
	            var params = {};
	            params.page_no = pageNum;
	            params.locale = locale.currentLocale;
	
	            return _order2.default.mine(userAPIToken, params).then(function (response) {
	                var _response$body = response.body;
	                var fetchedOrders = _response$body.data;
	                var meta = _response$body.meta;
	
	
	                if (pageNum > 1) {
	                    fetchedOrders.forEach(function (order) {
	                        dispatch(_actions2.default.addOrder(order, meta));
	                    });
	                } else {
	                    dispatch(_actions2.default.addOrders(fetchedOrders, meta));
	                }
	                dispatch(_actions2.default.hideLoader());
	            });
	        },
	
	        handleUserNotLoggedIn: function handleUserNotLoggedIn() {
	            dispatch((0, _reactRouterRedux.push)(_appRoutes2.default.homePageRoute));
	            // dispatch(Actions.showFlash('Please Sign in to view your orders'));
	        }
	    };
	};
	
	var OrderListConnector = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_list2.default);
	
	exports.default = OrderListConnector;

/***/ },
/* 763 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(18);
	
	var _show = __webpack_require__(691);
	
	var _show2 = _interopRequireDefault(_show);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	  return {};
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {};
	};
	
	var OrderShowConnector = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_show2.default);
	
	exports.default = OrderShowConnector;

/***/ },
/* 764 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reactRedux = __webpack_require__(18);
	
	var _summary = __webpack_require__(353);
	
	var _summary2 = _interopRequireDefault(_summary);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	    return {
	        order: state.order,
	        placedOrder: ownProps.placedOrder,
	        currentCheckoutStep: state.currentCheckoutStep,
	        locale: state.locale.currentLocale
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {};
	};
	
	var OrderSummaryConnector = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_summary2.default);
	
	exports.default = OrderSummaryConnector;

/***/ },
/* 765 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reactRedux = __webpack_require__(18);
	
	var _privacyPolicy = __webpack_require__(700);
	
	var _privacyPolicy2 = _interopRequireDefault(_privacyPolicy);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	    return {
	        user: state.user,
	        locale: state.locale
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {};
	};
	
	var PrivacyPolicyConnector = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_privacyPolicy2.default);
	
	exports.default = PrivacyPolicyConnector;

/***/ },
/* 766 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(18);
	
	var _productList = __webpack_require__(701);
	
	var _productList2 = _interopRequireDefault(_productList);
	
	var _baseProductList = __webpack_require__(177);
	
	var _baseProductList2 = _interopRequireDefault(_baseProductList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	  return {};
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {};
	};
	
	var ProductListConnector = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_productList2.default);
	
	exports.default = (0, _baseProductList2.default)(ProductListConnector);

/***/ },
/* 767 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reactRedux = __webpack_require__(18);
	
	var _reactReduxToastr = __webpack_require__(42);
	
	var _actions = __webpack_require__(23);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	var _productTile = __webpack_require__(711);
	
	var _productTile2 = _interopRequireDefault(_productTile);
	
	var _addProductToCart = __webpack_require__(249);
	
	var _refreshOrderProcess = __webpack_require__(179);
	
	var _refreshOrderProcess2 = _interopRequireDefault(_refreshOrderProcess);
	
	var _appTranslations = __webpack_require__(33);
	
	var _appTranslations2 = _interopRequireDefault(_appTranslations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	    return {
	        locale: state.locale,
	        user: state.user,
	        access_token: state.auth.access_token,
	        order: state.order,
	        currentStore: state.stores.currentStore,
	        currentZone: state.zones.currentZone
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        addProductToCart: function addProductToCart(variantId) {
	            var quantity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	            var zoneId = arguments[2];
	            var locale = arguments[3];
	            var userToken = arguments[4];
	            var order = arguments[5];
	            var extraData = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
	
	            dispatch(_actions2.default.addingProductToCart());
	            dispatch(_actions2.default.addProductToCart(variantId, quantity, zoneId, locale, userToken, extraData)).then(function () {
	                (0, _refreshOrderProcess2.default)(dispatch, locale, _reactReduxToastr.toastr, {
	                    addingProductToCartAction: true,
	                    successNotify: _appTranslations2.default[locale]['item-added'] + '. ' + _appTranslations2.default[locale]['proceed-to-checkout'] + '.'
	                });
	            }).catch(function (error) {
	                (0, _addProductToCart.addProductToCartNotifyEP)(locale, error, _reactReduxToastr.toastr);
	                (0, _addProductToCart.addProductToCartNextActionEP)(dispatch, order, locale, userToken);
	            });
	        },
	        emptyCart: function emptyCart(order, locale) {
	            return dispatch(_actions2.default.emptyCart(order, locale));
	        }
	    };
	};
	
	var ProductTileConnector = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_productTile2.default);
	
	exports.default = ProductTileConnector;

/***/ },
/* 768 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reactRedux = __webpack_require__(18);
	
	var _reactReduxToastr = __webpack_require__(42);
	
	var _showProduct = __webpack_require__(706);
	
	var _showProduct2 = _interopRequireDefault(_showProduct);
	
	var _actions = __webpack_require__(23);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	var _products = __webpack_require__(346);
	
	var _products2 = _interopRequireDefault(_products);
	
	var _baseProductList = __webpack_require__(177);
	
	var _baseProductList2 = _interopRequireDefault(_baseProductList);
	
	var _addProductToCart = __webpack_require__(249);
	
	var _refreshOrderProcess = __webpack_require__(179);
	
	var _refreshOrderProcess2 = _interopRequireDefault(_refreshOrderProcess);
	
	var _appTranslations = __webpack_require__(33);
	
	var _appTranslations2 = _interopRequireDefault(_appTranslations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	    return {
	        lineItems: state.order.line_items,
	        products: state.productList.products,
	        order: state.order,
	        currentZone: state.zones.currentZone,
	        access_token: state.auth.access_token
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        fetchProductFromAPI: function fetchProductFromAPI(productId, locale, zoneId, callback) {
	            dispatch(_actions2.default.displayLoader());
	
	            _products2.default.getItem(productId, locale, zoneId).then(function (response) {
	                dispatch(_actions2.default.addProduct(response.body));
	                dispatch(_actions2.default.hideLoader());
	
	                callback(response.body);
	            });
	        },
	
	        addProductToCart: function addProductToCart(variantId) {
	            var quantity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	            var zoneId = arguments[2];
	            var locale = arguments[3];
	            var order = arguments[4];
	            var userToken = arguments[5];
	            var extraData = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
	
	            dispatch(_actions2.default.addingProductToCart());
	            dispatch(_actions2.default.addProductToCart(variantId, quantity, zoneId, locale, userToken, extraData)).then(function () {
	                (0, _refreshOrderProcess2.default)(dispatch, locale, _reactReduxToastr.toastr, {
	                    addingProductToCartAction: true,
	                    successNotify: _appTranslations2.default[locale]['item-added'] + '. ' + _appTranslations2.default[locale]['proceed-to-checkout'] + '.'
	                });
	            }).catch(function (error) {
	                (0, _addProductToCart.addProductToCartNotifyEP)(locale, error, _reactReduxToastr.toastr);
	                (0, _addProductToCart.addProductToCartNextActionEP)(dispatch, order, locale);
	            });
	        },
	        emptyCart: function emptyCart(order, locale) {
	            return dispatch(_actions2.default.emptyCart(order, locale));
	        }
	    };
	};
	
	var ProductShowConnector = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_showProduct2.default);
	
	exports.default = (0, _baseProductList2.default)(ProductShowConnector);

/***/ },
/* 769 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(41);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _reactRedux = __webpack_require__(18);
	
	var _user = __webpack_require__(102);
	
	var _user2 = _interopRequireDefault(_user);
	
	var _registerConfirmation = __webpack_require__(702);
	
	var _registerConfirmation2 = _interopRequireDefault(_registerConfirmation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	    return {
	        locale: state.locale
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        checkregistration: function checkregistration(token, locale, callback) {
	            var _this = this;
	
	            return _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	                var params, registerPromise;
	                return _regenerator2.default.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                params = {
	                                    tokens: token,
	                                    locale: locale.currentLocale
	                                };
	                                registerPromise = _user2.default.registerByEmail(params);
	                                return _context.abrupt('return', registerPromise);
	
	                            case 3:
	                            case 'end':
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, _this);
	            }))();
	        }
	    };
	};
	
	var RegisterConfirmationConnector = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_registerConfirmation2.default);
	
	exports.default = RegisterConfirmationConnector;

/***/ },
/* 770 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reactRedux = __webpack_require__(18);
	
	var _returnPolicy = __webpack_require__(703);
	
	var _returnPolicy2 = _interopRequireDefault(_returnPolicy);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	    return {
	        user: state.user
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {};
	};
	
	var ReturnPolicyConnector = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_returnPolicy2.default);
	
	exports.default = ReturnPolicyConnector;

/***/ },
/* 771 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reactRedux = __webpack_require__(18);
	
	var _reactRouterRedux = __webpack_require__(30);
	
	var _searchForm = __webpack_require__(727);
	
	var _searchForm2 = _interopRequireDefault(_searchForm);
	
	var _urlParser = __webpack_require__(817);
	
	var _urlParser2 = _interopRequireDefault(_urlParser);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	    return {
	        locale: state.locale,
	        taxons: state.taxons,
	        searchTerm: _urlParser2.default.getQueryVariable('searchTerm')
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        filterTaxons: function filterTaxons(taxons) {
	            return taxons.filter(function (taxon) {
	                return taxon.attributes.depth <= 1;
	            });
	        },
	
	        taxonByLink: function taxonByLink(taxons, link) {
	            return taxons.filter(function (taxon) {
	                return taxon.attributes.permalink === link;
	            });
	        },
	
	        submitSearchForm: function submitSearchForm(searchTerm, locale) {
	            dispatch((0, _reactRouterRedux.push)('/search?query=' + searchTerm));
	        }
	    };
	};
	
	var SearchFormConnector = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_searchForm2.default);
	
	exports.default = SearchFormConnector;

/***/ },
/* 772 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reactRedux = __webpack_require__(18);
	
	var _reactRouterRedux = __webpack_require__(30);
	
	var _reactReduxToastr = __webpack_require__(42);
	
	var _sendEmail = __webpack_require__(704);
	
	var _sendEmail2 = _interopRequireDefault(_sendEmail);
	
	var _actions = __webpack_require__(23);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	var _user = __webpack_require__(102);
	
	var _user2 = _interopRequireDefault(_user);
	
	var _appTranslations = __webpack_require__(33);
	
	var _appTranslations2 = _interopRequireDefault(_appTranslations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	    return {
	        user: state.user,
	        locale: state.locale
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        submitEmailForm: function submitEmailForm(formData, locale) {
	            dispatch(_actions2.default.displayLoader());
	
	            return _user2.default.sendEmail(formData).then(function (response) {
	                dispatch(_actions2.default.hideLoader());
	                _reactReduxToastr.toastr.success(_appTranslations2.default[locale]['send-success'], _appTranslations2.default[locale]['send-email-success-1']);
	                return true;
	            }, function () {
	                _reactReduxToastr.toastr.error('Error', _appTranslations2.default[locale]['send-email-failure']);
	                dispatch(_actions2.default.hideLoader());
	                return false;
	            });
	        }
	    };
	};
	
	var SendEmailConnector = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_sendEmail2.default);
	
	exports.default = SendEmailConnector;

/***/ },
/* 773 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reactRedux = __webpack_require__(18);
	
	var _shippingPolicy = __webpack_require__(705);
	
	var _shippingPolicy2 = _interopRequireDefault(_shippingPolicy);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	    return {
	        user: state.user,
	        locale: state.locale
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {};
	};
	
	var ShippingPolicyConnector = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_shippingPolicy2.default);
	
	exports.default = ShippingPolicyConnector;

/***/ },
/* 774 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reactRedux = __webpack_require__(18);
	
	var _showStores = __webpack_require__(707);
	
	var _showStores2 = _interopRequireDefault(_showStores);
	
	var _actions = __webpack_require__(23);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	var _baseMenu = __webpack_require__(176);
	
	var _baseMenu2 = _interopRequireDefault(_baseMenu);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	    return {};
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        setCurrentZone: function setCurrentZone(zoneId, page, limit) {
	            dispatch(_actions2.default.setCurrentZone(zoneId));
	            dispatch(_actions2.default.displayLoader());
	            dispatch(_actions2.default.getStoresByZone(zoneId, page, limit)).then(function () {
	                return dispatch(_actions2.default.hideLoader());
	            });
	        }
	    };
	};
	
	var ShowStoresConnector = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_showStores2.default);
	
	exports.default = (0, _baseMenu2.default)(ShowStoresConnector);

/***/ },
/* 775 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reactRedux = __webpack_require__(18);
	
	var _reactReduxToastr = __webpack_require__(42);
	
	var _baseProductList = __webpack_require__(177);
	
	var _baseProductList2 = _interopRequireDefault(_baseProductList);
	
	var _store_products = __webpack_require__(708);
	
	var _store_products2 = _interopRequireDefault(_store_products);
	
	var _taxons = __webpack_require__(347);
	
	var _taxons2 = _interopRequireDefault(_taxons);
	
	var _actions = __webpack_require__(23);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	var _appTranslations = __webpack_require__(33);
	
	var _appTranslations2 = _interopRequireDefault(_appTranslations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	// TODO: This code(distinctProducts and fetchedProducts functions) is duplicate in base-product-list.js container. Clean and refactor
	var distinctProducts = function distinctProducts(products) {
	    var productsFilters = [];
	
	    // eslint-disable-next-line no-restricted-syntax
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	        var _loop = function _loop() {
	            var product = _step.value;
	
	            var filterCondition = productsFilters.findIndex(function (item) {
	                return item.id === product.id;
	            }) === -1;
	            if (filterCondition) {
	                productsFilters.push(product);
	            }
	        };
	
	        for (var _iterator = products[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            _loop();
	        }
	    } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	    } finally {
	        try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	                _iterator.return();
	            }
	        } finally {
	            if (_didIteratorError) {
	                throw _iteratorError;
	            }
	        }
	    }
	
	    return productsFilters;
	};
	
	var fetchedProducts = function fetchedProducts(dispatch, locale) {
	    return dispatch(_actions2.default.fetchProducts({ page_no: 1, locale: locale })).then(function (response) {
	        var fetchedProducts = response.body;
	
	        if (fetchedProducts.data.length === 0) {
	            _reactReduxToastr.toastr.info('' + _appTranslations2.default[locale]['no-products-found']);
	        }
	
	        dispatch(_actions2.default.addProducts({ products: distinctProducts(fetchedProducts.data), meta: fetchedProducts.meta }));
	        dispatch(_actions2.default.hideLoader());
	    });
	};
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	    return {};
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	
	        loadStoresProducts: function loadStoresProducts(locale, storeIdx) {
	            dispatch(_actions2.default.displayLoader());
	
	            // Load stores
	            dispatch(_actions2.default.fetchStores()).then(function (response) {
	                // TODO: Check if instead of selecting a default store it is better to show a `not-found`
	                // find store for code
	                var selectStore = response.find(function (store) {
	                    return store.code === storeIdx;
	                }) || response[0];
	
	                // change current store value
	                dispatch(_actions2.default.setCurrentStore(selectStore));
	
	                var taxonsMenu = [];
	
	                // load store taxons
	                _taxons2.default.getTaxons(selectStore.id).then(function (response) {
	                    var fetchedTaxons = response;
	                    var taxonRoot = fetchedTaxons.filter(function (taxon) {
	                        return taxon.parent_id === null;
	                    })[0];
	                    var taxonsCategory = fetchedTaxons.filter(function (taxon) {
	                        return taxon.parent_id === taxonRoot.id;
	                    });
	                    var taxonCategorySubcategory = taxonsCategory.map(function (taxonCategory) {
	                        return {
	                            taxonCategory: taxonCategory,
	                            taxons: fetchedTaxons.filter(function (taxon) {
	                                return taxon.parent_id === taxonCategory.id;
	                            })
	                        };
	                    });
	                    taxonsMenu.push({ store: selectStore, taxonRoot: taxonRoot, taxons: [].concat(_toConsumableArray(taxonCategorySubcategory)) });
	
	                    dispatch(_actions2.default.addTaxons({ taxonsMenu: taxonsMenu, fetchedTaxons: fetchedTaxons }));
	
	                    // load products from selected store
	                    fetchedProducts(dispatch, locale);
	                }).catch(function (error) {
	                    // load products from selected store
	                    fetchedProducts(dispatch, locale);
	                });
	            });
	        }
	    };
	};
	
	var StoreProductsConnector = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_store_products2.default);
	
	exports.default = (0, _baseProductList2.default)(StoreProductsConnector);

/***/ },
/* 776 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reactRedux = __webpack_require__(18);
	
	var _termsConditions = __webpack_require__(709);
	
	var _termsConditions2 = _interopRequireDefault(_termsConditions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	    return {
	        user: state.user,
	        locale: state.locale
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {};
	};
	
	var TermsConditionsConnector = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_termsConditions2.default);
	
	exports.default = TermsConditionsConnector;

/***/ },
/* 777 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reactRedux = __webpack_require__(18);
	
	var _userLogin = __webpack_require__(710);
	
	var _userLogin2 = _interopRequireDefault(_userLogin);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	    return {
	        user: state.user,
	        locale: state.locale
	    };
	};
	
	var UserLoginConnector = (0, _reactRedux.connect)(mapStateToProps, {})(_userLogin2.default);
	
	exports.default = UserLoginConnector;

/***/ },
/* 778 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(41);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _reactRedux = __webpack_require__(18);
	
	var _reactRouterRedux = __webpack_require__(30);
	
	var _actions = __webpack_require__(23);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	var _userMenu = __webpack_require__(728);
	
	var _userMenu2 = _interopRequireDefault(_userMenu);
	
	var _appRoutes = __webpack_require__(22);
	
	var _appRoutes2 = _interopRequireDefault(_appRoutes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	    return {
	        user: state.user,
	        locale: state.locale,
	        access_token: state.auth.access_token
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        logout: function logout() {
	            dispatch(_actions2.default.logout());
	            dispatch((0, _reactRouterRedux.push)(_appRoutes2.default.homePageRoute));
	        },
	        isWalletActive: function () {
	            var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(token, wallet) {
	                var active;
	                return _regenerator2.default.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                _context.next = 2;
	                                return dispatch(_actions2.default.activeWallet(wallet, token, true));
	
	                            case 2:
	                                active = _context.sent;
	                                return _context.abrupt('return', active);
	
	                            case 4:
	                            case 'end':
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, undefined);
	            }));
	
	            return function isWalletActive(_x, _x2) {
	                return _ref.apply(this, arguments);
	            };
	        }(),
	        activateWallet: function () {
	            var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(token, wallet) {
	                var activate;
	                return _regenerator2.default.wrap(function _callee2$(_context2) {
	                    while (1) {
	                        switch (_context2.prev = _context2.next) {
	                            case 0:
	                                _context2.next = 2;
	                                return dispatch(_actions2.default.activateWallet(wallet, token));
	
	                            case 2:
	                                activate = _context2.sent;
	                                return _context2.abrupt('return', activate);
	
	                            case 4:
	                            case 'end':
	                                return _context2.stop();
	                        }
	                    }
	                }, _callee2, undefined);
	            }));
	
	            return function activateWallet(_x3, _x4) {
	                return _ref2.apply(this, arguments);
	            };
	        }()
	    };
	};
	
	var UserMenuConnector = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_userMenu2.default);
	
	exports.default = UserMenuConnector;

/***/ },
/* 779 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(41);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _reactRedux = __webpack_require__(18);
	
	var _reactRouterRedux = __webpack_require__(30);
	
	var _actions = __webpack_require__(23);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	var _userMobileMenu = __webpack_require__(729);
	
	var _userMobileMenu2 = _interopRequireDefault(_userMobileMenu);
	
	var _appRoutes = __webpack_require__(22);
	
	var _appRoutes2 = _interopRequireDefault(_appRoutes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	    return {
	        user: state.user,
	        locale: state.locale,
	        access_token: state.auth.access_token
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        logout: function logout() {
	            dispatch(_actions2.default.logout());
	            dispatch((0, _reactRouterRedux.push)(_appRoutes2.default.homePageRoute));
	        },
	        isWalletActive: function () {
	            var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(token, wallet) {
	                var active;
	                return _regenerator2.default.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                _context.next = 2;
	                                return dispatch(_actions2.default.activeWallet(wallet, token, true));
	
	                            case 2:
	                                active = _context.sent;
	                                return _context.abrupt('return', active);
	
	                            case 4:
	                            case 'end':
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, undefined);
	            }));
	
	            return function isWalletActive(_x, _x2) {
	                return _ref.apply(this, arguments);
	            };
	        }(),
	        activateWallet: function () {
	            var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(token, wallet) {
	                var activate;
	                return _regenerator2.default.wrap(function _callee2$(_context2) {
	                    while (1) {
	                        switch (_context2.prev = _context2.next) {
	                            case 0:
	                                _context2.next = 2;
	                                return dispatch(_actions2.default.activateWallet(wallet, token));
	
	                            case 2:
	                                activate = _context2.sent;
	                                return _context2.abrupt('return', activate);
	
	                            case 4:
	                            case 'end':
	                                return _context2.stop();
	                        }
	                    }
	                }, _callee2, undefined);
	            }));
	
	            return function activateWallet(_x3, _x4) {
	                return _ref2.apply(this, arguments);
	            };
	        }()
	    };
	};
	
	var UserMobilMenuConnector = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_userMobileMenu2.default);
	
	exports.default = UserMobilMenuConnector;

/***/ },
/* 780 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reactRedux = __webpack_require__(18);
	
	var _actions = __webpack_require__(23);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	var _zoneSelectModal = __webpack_require__(736);
	
	var _zoneSelectModal2 = _interopRequireDefault(_zoneSelectModal);
	
	var _appDefaults = __webpack_require__(39);
	
	var _appDefaults2 = _interopRequireDefault(_appDefaults);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var distinctProducts = function distinctProducts(products) {
	    var productsFilters = [];
	
	    // eslint-disable-next-line no-restricted-syntax
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	        var _loop = function _loop() {
	            var product = _step.value;
	
	            var filterCondition = productsFilters.findIndex(function (item) {
	                return item.id === product.id;
	            }) === -1;
	            if (filterCondition) {
	                productsFilters.push(product);
	            }
	        };
	
	        for (var _iterator = products[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            _loop();
	        }
	    } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	    } finally {
	        try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	                _iterator.return();
	            }
	        } finally {
	            if (_didIteratorError) {
	                throw _iteratorError;
	            }
	        }
	    }
	
	    return productsFilters;
	};
	
	var fetchProducts = function fetchProducts(dispatch, locale) {
	    return dispatch(_actions2.default.fetchProducts({ page_no: 1, locale: locale })).then(function (response) {
	        var fetchedProducts = response.body;
	        dispatch(_actions2.default.addProducts({ products: distinctProducts(fetchedProducts.data), meta: fetchedProducts.meta }));
	        dispatch(_actions2.default.hideLoader());
	    });
	};
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	    return {
	        availableZones: state.zones.availableZones,
	        currentZone: state.zones.availableZones,
	        availableMunicipalities: state.municipalities.availableMunicipalities
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        setUserSelection: function setUserSelection(zoneId, municipalityId) {
	            dispatch(_actions2.default.setCurrentMunicipality(municipalityId));
	            dispatch(_actions2.default.setCurrentZone(zoneId));
	            dispatch(_actions2.default.displayLoader());
	            fetchProducts(dispatch);
	        }
	    };
	};
	
	var ZoneSelectConnector = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_zoneSelectModal2.default);
	
	exports.default = ZoneSelectConnector;

/***/ },
/* 781 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	function InvalidCheckoutStepException(message) {
	    this.message = message;
	    // Use V8's native method if available, otherwise fallback
	    if ('captureStackTrace' in Error) Error.captureStackTrace(this, InvalidCheckoutStepException);else this.stack = new Error().stack;
	}
	
	InvalidCheckoutStepException.prototype = Object.create(Error.prototype);
	InvalidCheckoutStepException.prototype.name = 'InvalidCheckoutStepException';
	InvalidCheckoutStepException.prototype.constructor = InvalidCheckoutStepException;
	
	exports.default = InvalidCheckoutStepException;

/***/ },
/* 782 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	function InvalidOrderTransitionException(message) {
	    this.message = message;
	    // Use V8's native method if available, otherwise fallback
	    if ('captureStackTrace' in Error) Error.captureStackTrace(this, InvalidOrderTransitionException);else this.stack = new Error().stack;
	}
	
	InvalidOrderTransitionException.prototype = Object.create(Error.prototype);
	InvalidOrderTransitionException.prototype.name = 'InvalidOrderTransitionException';
	InvalidOrderTransitionException.prototype.constructor = InvalidOrderTransitionException;
	
	exports.default = InvalidOrderTransitionException;

/***/ },
/* 783 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.refreshOrderNotifyEP = undefined;
	
	var _appTranslations = __webpack_require__(33);
	
	var _appTranslations2 = _interopRequireDefault(_appTranslations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var refreshOrderNotifyEP = exports.refreshOrderNotifyEP = function refreshOrderNotifyEP(error, locale, toastr) {
	    if (error && error.response && error.response.body && error.response.body.error) {
	        toastr.error(_appTranslations2.default[locale].error, error.response.body.error);
	    } else {
	        toastr.error(_appTranslations2.default[locale]['error-refresh-order-title'], _appTranslations2.default[locale]['error-refresh-order-content'], {
	            timeOut: 60000
	        });
	    }
	};
	
	exports.default = { refreshOrder: refreshOrderNotifyEP };

/***/ },
/* 784 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(46);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactIntl = __webpack_require__(11);
	
	var _reactRedux = __webpack_require__(18);
	
	var _localeData = __webpack_require__(2186);
	
	var _localeData2 = _interopRequireDefault(_localeData);
	
	var _es = __webpack_require__(1847);
	
	var _es2 = _interopRequireDefault(_es);
	
	var _bootstrap = __webpack_require__(2135);
	
	var _bootstrap2 = _interopRequireDefault(_bootstrap);
	
	var _store = __webpack_require__(40);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _connectedIntlProvider = __webpack_require__(738);
	
	var _connectedIntlProvider2 = _interopRequireDefault(_connectedIntlProvider);
	
	var _main = __webpack_require__(687);
	
	var _main2 = _interopRequireDefault(_main);
	
	__webpack_require__(2134);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	/*
	  Load locales that need to be supported
	*/
	
	
	/*
	  We are still loading bootstrap via CSS directly. Not using css-modules here.
	*/
	
	
	/*
	  These are non css-modules styles.
	*/
	
	
	// import 'bootstrap/dist/css/bootstrap.min.css';
	
	(0, _reactIntl.addLocaleData)([].concat(_toConsumableArray(_localeData2.default), _toConsumableArray(_es2.default)));
	
	var app = _react2.default.createElement(
	    _reactRedux.Provider,
	    { store: _store2.default },
	    _react2.default.createElement(
	        _connectedIntlProvider2.default,
	        null,
	        _react2.default.createElement(_main2.default, { style: _bootstrap2.default })
	    )
	);
	
	_reactDom2.default.render(app, document.getElementById('root'));

/***/ },
/* 785 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reactReduxToastr = __webpack_require__(42);
	
	var _appActions = __webpack_require__(21);
	
	var _appActions2 = _interopRequireDefault(_appActions);
	
	var _appTranslations = __webpack_require__(33);
	
	var _appTranslations2 = _interopRequireDefault(_appTranslations);
	
	var _order = __webpack_require__(239);
	
	var _order2 = _interopRequireDefault(_order);
	
	var _order3 = __webpack_require__(172);
	
	var _order4 = _interopRequireDefault(_order3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// eslint-disable-next-line arrow-parens
	var listenLoginActionMiddleware = function listenLoginActionMiddleware(store) {
	    return function (next) {
	        return function (action) {
	            if (action && action.type && action.type === _appActions2.default.LOGIN) {
	                // eslint-disable-next-line camelcase
	                var _store$getState = store.getState();
	
	                var currentZone = _store$getState.zones.currentZone;
	                var currentLocale = _store$getState.locale.currentLocale;
	                var token = _store$getState.order.token;
	
	                _order2.default.getByUser({
	                    token: action.payload.access_token,
	                    currentZone: currentZone,
	                    locale: currentLocale,
	                    orderToken: token
	                }).then(function (response) {
	                    store.dispatch(_order4.default.updateOrderInState(response.body));
	                });
	            }
	            return next(action);
	        };
	    };
	}; /* eslint-disable arrow-body-style */
	exports.default = listenLoginActionMiddleware;

/***/ },
/* 786 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reactReduxToastr = __webpack_require__(42);
	
	var _appActions = __webpack_require__(21);
	
	var _appActions2 = _interopRequireDefault(_appActions);
	
	var _appTranslations = __webpack_require__(33);
	
	var _appTranslations2 = _interopRequireDefault(_appTranslations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// eslint-disable-next-line arrow-parens
	var listenLogoutActionMiddleware = function listenLogoutActionMiddleware(store) {
	    return function (next) {
	        return function (action) {
	            if (action && action.type && action.type === _appActions2.default.LOGOUT) {
	                var state = store.getState();
	                if (state.user && state.user.id) {
	                    var locale = state.locale.currentLocale;
	                    _reactReduxToastr.toastr.success('' + _appTranslations2.default[locale]['session-closed']);
	                }
	            }
	            return next(action);
	        };
	    };
	};
	
	exports.default = listenLogoutActionMiddleware;

/***/ },
/* 787 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _appActions = __webpack_require__(21);
	
	var _appActions2 = _interopRequireDefault(_appActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = {};
	
	var anonymouseUser = function anonymouseUser() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _appActions2.default.ANONYMOUS_USER_AGE_VALID:
	            return _extends({}, state, action.payload);
	        default:
	            return state;
	    }
	};
	
	exports.default = anonymouseUser;

/***/ },
/* 788 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _appActions = __webpack_require__(21);
	
	var _appActions2 = _interopRequireDefault(_appActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = {};
	
	var auth = function auth() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _appActions2.default.LOGIN:
	            return _extends({}, action.payload);
	        case _appActions2.default.LOGOUT:
	            return initialState;
	        default:
	            return state;
	    }
	};
	
	exports.default = auth;

/***/ },
/* 789 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /* eslint-disable */
	
	
	var _appActions = __webpack_require__(21);
	
	var _appActions2 = _interopRequireDefault(_appActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = {
	    triggedBy: null
	};
	
	var backgroundDisabled = function backgroundDisabled() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _appActions2.default.SET_BACKGROUND_DISABLED:
	            return _extends({}, state, { triggedBy: action.payload.triggedBy });
	        default:
	            return state;
	    }
	};
	
	exports.default = backgroundDisabled;

/***/ },
/* 790 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _appActions = __webpack_require__(21);
	
	var _appActions2 = _interopRequireDefault(_appActions);
	
	var _appDefaults = __webpack_require__(39);
	
	var _appDefaults2 = _interopRequireDefault(_appDefaults);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = {
	    timeMinutesLastAlert: 0, // This value is only for computing the earliest alert.
	    timeSecondsLeft: 0,
	    lastAlert: false,
	    hasExtraTimeCheckout: false,
	
	    activeCart: false, // This value is set to false because of waiting for a response from the backend.
	    cartRemoval: Number(("720")) || 0,
	    gracePeriod: _appDefaults2.default.extraMinutesOnCheckout * 60
	};
	
	var cartState = function cartState() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _appActions2.default.SET_ACTIVE_CART:
	            return _extends({}, state, { activeCart: action.payload });
	        case _appActions2.default.SET_CONFIGS_ACTIVE_CART:
	            return _extends({}, state, {
	                activeCart: action.payload.activeCart,
	                cartRemoval: action.payload.cartRemoval,
	                gracePeriod: action.payload.gracePeriod
	            });
	        case _appActions2.default.UPDATE_MINUTES_TIME_LEFT_CART:
	            return _extends({}, state, { timeMinutesLastAlert: action.payload
	            });
	        case _appActions2.default.UPDATE_SECONDS_TIME_LEFT_CART:
	            return _extends({}, state, { timeSecondsLeft: action.payload
	            });
	        case _appActions2.default.SET_LAST_ALERT_TIME_LEFT_CART:
	            return _extends({}, state, { lastAlert: action.payload
	            });
	        case _appActions2.default.SET_EXTRA_TIME_CHECKOUT:
	            return _extends({}, state, { hasExtraTimeCheckout: action.payload
	            });
	        default:
	            return state;
	    }
	};
	
	exports.default = cartState;

/***/ },
/* 791 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _appActions = __webpack_require__(21);
	
	var _appActions2 = _interopRequireDefault(_appActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = {
	    activeCart: {
	        activeCart: false,
	        cartRemoval: 0,
	        gracePeriod: 0,
	        delay: 0
	    },
	    donation: {
	        stores: '',
	        zone: 0
	    },
	    lastVersion: '',
	    minimumRequiredVersion: '',
	    multiCountryShipping: false
	};
	
	var configs = function configs() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _appActions2.default.SET_BACKEND_CONFIG:
	            return _extends({}, state, action.payload);
	        case _appActions2.default.CONFIG_SET_MULTI_COUNTRY_SHIPPING:
	            return _extends({}, state, {
	                multiCountryShipping: action.payload
	            });
	        default:
	            return state;
	    }
	};
	
	exports.default = configs;

/***/ },
/* 792 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _appActions = __webpack_require__(21);
	
	var _appActions2 = _interopRequireDefault(_appActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = {
	    shippingCountries: [],
	    billingCountries: []
	};
	
	var countryList = function countryList() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _appActions2.default.ADD_COUNTRIES_SHIPPING:
	            return _extends({}, state, { shippingCountries: action.payload });
	
	        case _appActions2.default.ADD_COUNTRIES_BILLING:
	            return _extends({}, state, { billingCountries: action.payload });
	
	        default:
	            return state;
	    }
	};
	
	exports.default = countryList;

/***/ },
/* 793 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _appActions = __webpack_require__(21);
	
	var _appActions2 = _interopRequireDefault(_appActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = '';
	
	var currentCheckoutStep = function currentCheckoutStep() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _appActions2.default.SET_CURRENT_CHECKOUT_STEP:
	            return action.payload;
	        case _appActions2.default.CLEAR_CURRENT_CHECKOUT_STEP:
	            return initialState;
	        default:
	            return state;
	    }
	};
	
	exports.default = currentCheckoutStep;

/***/ },
/* 794 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _appActions = __webpack_require__(21);
	
	var _appActions2 = _interopRequireDefault(_appActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = true;
	
	var displayLoader = function displayLoader() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _appActions2.default.DISPLAY_LOADER:
	            return true;
	        case _appActions2.default.HIDE_LOADER:
	            return false;
	        default:
	            return state;
	    }
	};
	
	exports.default = displayLoader;

/***/ },
/* 795 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _appActions = __webpack_require__(21);
	
	var _appActions2 = _interopRequireDefault(_appActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = {
	    error: {}
	};
	
	var error = function error() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _appActions2.default.ADD_ERROR:
	            return _extends({}, state, { error: action.payload });
	        case _appActions2.default.ERRORS_LINE_ITEMS:
	            return _extends({}, state, { errorLineItems: action.payload });
	        case _appActions2.default.CLEAR_ERRORS_LINE_ITEMS:
	            return _extends({}, state, { errorLineItems: [] });
	        default:
	            return state;
	    }
	};
	
	exports.default = error;

/***/ },
/* 796 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _appActions = __webpack_require__(21);
	
	var _appActions2 = _interopRequireDefault(_appActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = {
	    isFetching: false
	};
	
	var fetchData = function fetchData() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _appActions2.default.SET_FETCHING_DATA:
	            return _extends({}, state, { isFetching: action.payload });
	        default:
	            return state;
	    }
	};
	
	exports.default = fetchData;

/***/ },
/* 797 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _redux = __webpack_require__(163);
	
	var _reactRouterRedux = __webpack_require__(30);
	
	var _reduxForm = __webpack_require__(61);
	
	var _reactReduxToastr = __webpack_require__(42);
	
	var _displayLoader = __webpack_require__(794);
	
	var _displayLoader2 = _interopRequireDefault(_displayLoader);
	
	var _productList = __webpack_require__(804);
	
	var _productList2 = _interopRequireDefault(_productList);
	
	var _taxons = __webpack_require__(806);
	
	var _taxons2 = _interopRequireDefault(_taxons);
	
	var _order = __webpack_require__(802);
	
	var _order2 = _interopRequireDefault(_order);
	
	var _cartState = __webpack_require__(790);
	
	var _cartState2 = _interopRequireDefault(_cartState);
	
	var _orderList = __webpack_require__(801);
	
	var _orderList2 = _interopRequireDefault(_orderList);
	
	var _countryList = __webpack_require__(792);
	
	var _countryList2 = _interopRequireDefault(_countryList);
	
	var _currentCheckoutStep = __webpack_require__(793);
	
	var _currentCheckoutStep2 = _interopRequireDefault(_currentCheckoutStep);
	
	var _placedOrder = __webpack_require__(803);
	
	var _placedOrder2 = _interopRequireDefault(_placedOrder);
	
	var _user = __webpack_require__(807);
	
	var _user2 = _interopRequireDefault(_user);
	
	var _stores = __webpack_require__(805);
	
	var _stores2 = _interopRequireDefault(_stores);
	
	var _locale = __webpack_require__(798);
	
	var _locale2 = _interopRequireDefault(_locale);
	
	var _navigation = __webpack_require__(800);
	
	var _navigation2 = _interopRequireDefault(_navigation);
	
	var _error = __webpack_require__(795);
	
	var _error2 = _interopRequireDefault(_error);
	
	var _auth = __webpack_require__(788);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _zone = __webpack_require__(809);
	
	var _zone2 = _interopRequireDefault(_zone);
	
	var _anonymousUser = __webpack_require__(787);
	
	var _anonymousUser2 = _interopRequireDefault(_anonymousUser);
	
	var _backgroundDisabled = __webpack_require__(789);
	
	var _backgroundDisabled2 = _interopRequireDefault(_backgroundDisabled);
	
	var _fetchData = __webpack_require__(796);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _configs = __webpack_require__(791);
	
	var _configs2 = _interopRequireDefault(_configs);
	
	var _municipality = __webpack_require__(799);
	
	var _municipality2 = _interopRequireDefault(_municipality);
	
	var _wallets = __webpack_require__(808);
	
	var _wallets2 = _interopRequireDefault(_wallets);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AppReducer = (0, _redux.combineReducers)({
	    displayLoader: _displayLoader2.default,
	    productList: _productList2.default,
	    taxons: _taxons2.default,
	    order: _order2.default,
	    cartState: _cartState2.default,
	    orderList: _orderList2.default,
	    countryList: _countryList2.default,
	    currentCheckoutStep: _currentCheckoutStep2.default,
	    placedOrder: _placedOrder2.default,
	    user: _user2.default,
	    auth: _auth2.default,
	    stores: _stores2.default,
	    locale: _locale2.default,
	    navigation: _navigation2.default,
	    routing: _reactRouterRedux.routerReducer,
	    form: _reduxForm.reducer,
	    toastr: _reactReduxToastr.reducer,
	    error: _error2.default,
	    zones: _zone2.default,
	    municipalities: _municipality2.default,
	    anonymousUser: _anonymousUser2.default,
	    backgroundDisabled: _backgroundDisabled2.default,
	    fetchData: _fetchData2.default,
	    configs: _configs2.default,
	    wallets: _wallets2.default
	});
	
	exports.default = AppReducer;

/***/ },
/* 798 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _appActions = __webpack_require__(21);
	
	var _appActions2 = _interopRequireDefault(_appActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = {
	    currentLocale: 'es',
	    messages: {}
	};
	
	var locale = function locale() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments[1];
	
	    if (action.type === _appActions2.default.SET_LOCALE) {
	        return _extends({}, state, { currentLocale: action.payload.locale });
	    }
	    return state;
	};
	
	exports.default = locale;

/***/ },
/* 799 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _appActions = __webpack_require__(21);
	
	var _appActions2 = _interopRequireDefault(_appActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = {
	    availableMunicipalities: {},
	    currentMunicipality: undefined,
	    isMunicipalityPromptModalOpen: false
	};
	
	var municipality = function municipality() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments[1];
	
	    if (action.type === _appActions2.default.SET_AVAILABLE_MUNICIPALITIES) {
	        return _extends({}, state, {
	            availableMunicipalities: action.payload
	        });
	    }
	    if (action.type === _appActions2.default.SET_CURRENT_MUNICIPALITY) {
	        return _extends({}, state, {
	            currentMunicipality: action.payload
	        });
	    }
	    if (action.type === _appActions2.default.SET_IS_MUNICIPALITY_PROMPT_MODAL_OPEN) {
	        return _extends({}, state, {
	            isMunicipalityPromptModalOpen: action.payload
	        });
	    }
	    return state;
	};
	
	exports.default = municipality;

/***/ },
/* 800 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _appActions = __webpack_require__(21);
	
	var _appActions2 = _interopRequireDefault(_appActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = {
	    navigation: {
	        katapulk: []
	    }
	};
	
	var navigation = function navigation() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments[1];
	
	    if (action.type === _appActions2.default.ADD_KATAPULK_NAVIGATION) {
	        return _extends({}, state, action.payload.navigation);
	    }
	    return state;
	};
	
	exports.default = navigation;

/***/ },
/* 801 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _appActions = __webpack_require__(21);
	
	var _appActions2 = _interopRequireDefault(_appActions);
	
	var _orderModel = __webpack_require__(370);
	
	var _orderModel2 = _interopRequireDefault(_orderModel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = {
	    orders: []
	};
	
	var orderList = function orderList() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments[1];
	
	    var newOrderList = void 0;
	    var orderInList = void 0;
	
	    switch (action.type) {
	        case _appActions2.default.ADD_ORDERS:
	            return _extends({}, state, { orders: action.payload.orders }, action.payload.meta);
	
	        case _appActions2.default.ADD_ORDER:
	            orderInList = _orderModel2.default.find(action.payload.order.id, state.orders);
	
	            if (orderInList) {
	                return state;
	            }
	
	            newOrderList = Object.assign([], state.orders);
	            newOrderList.push(action.payload.order);
	            return _extends({}, state, { orders: newOrderList }, action.payload.meta);
	
	        default:
	            return state;
	    }
	};
	
	exports.default = orderList;

/***/ },
/* 802 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _appActions = __webpack_require__(21);
	
	var _appActions2 = _interopRequireDefault(_appActions);
	
	var _lineItems = __webpack_require__(369);
	
	var _lineItems2 = _interopRequireDefault(_lineItems);
	
	var _municipalityService = __webpack_require__(122);
	
	var _municipalityService2 = _interopRequireDefault(_municipalityService);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = {
	    addingProductToCart: false,
	    removingProductToCart: false,
	    disablingAdd: false,
	    shipments: [],
	    line_items: [],
	    lastDate: null,
	    checkout_steps: ['address', 'delivery', 'payment', 'complete'],
	    redsysPaymentInfo: {},
	    redsysPaymentError: false,
	    isFinalStepHappening: false,
	    isCreditCardValidated: false
	};
	
	var order = function order() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments[1];
	
	    var items = [];
	    var lineItems = [];
	    var newLineItems = Object.assign([], state.line_items);
	
	    switch (action.type) {
	        case _appActions2.default.CREATE_ORDER:
	            return _extends({}, state, action.payload);
	
	        case _appActions2.default.ADD_PRODUCT_TO_CART:
	        case _appActions2.default.UPDATE_ORDER:
	        case _appActions2.default.REMOVE_DATA_EXTRA_ITEM:
	        case _appActions2.default.UPDATE_LINE_ITEM:
	            lineItems = _lineItems2.default.lineItems(action.payload.data.relationships.line_items.data.map(function (a) {
	                return a.id;
	            }), action.payload.included);
	            lineItems.forEach(function (item) {
	                item.variant = _lineItems2.default.variant(item.relationships.variant.data.id, action.payload.included);
	                item.variant.images = _lineItems2.default.images(item.variant.relationships.images.data.map(function (a) {
	                    return a.id;
	                }), action.payload.included);
	                item.data_extras = _lineItems2.default.data_extras(item.relationships.data_extras.data.map(function (a) {
	                    return a.id;
	                }), action.payload.included);
	                item.data_extra_types = _lineItems2.default.data_extra_types(item.data_extras.map(function (a) {
	                    return a.attributes.type_id;
	                }), action.payload.included);
	
	                var product = _lineItems2.default.product(item.variant.relationships.product.data.id, action.payload.included);
	                item.shipping_category = product.attributes.shipping_category;
	                if (item.variant.images.length === 0) {
	                    item.variant.images = _lineItems2.default.images(product.relationships.images.data.map(function (a) {
	                        return a.id;
	                    }), action.payload.included);
	                }
	                items.push(item);
	            });
	            var municipalityInfo = _municipalityService2.default.getMunicipalityInfoFromOrderResponse(action.payload);
	            return _extends({}, state, action.payload.data.attributes, {
	                id: action.payload.data.id,
	                line_items: items,
	                lastDate: new Date(),
	                bill_address: _extends({
	                    id: action.payload.data.bill_address && action.payload.data.bill_address.id
	                }, action.payload.data.bill_address && action.payload.data.bill_address.attributes),
	                ship_address: _extends({
	                    id: action.payload.data.ship_address && action.payload.data.ship_address.id
	                }, action.payload.data.ship_address && action.payload.data.ship_address.attributes),
	                shipments: action.payload.data.shipments,
	                user: _extends({
	                    id: action.payload.data.user && action.payload.data.user.id
	                }, action.payload.data.user && action.payload.data.user.attributes)
	            }, municipalityInfo && { municipalityInfo: municipalityInfo });
	
	        case _appActions2.default.REMOVE_LINE_ITEM:
	            newLineItems = newLineItems.filter(function (lineItem) {
	                return lineItem.id !== action.payload;
	            });
	
	            return _extends({}, state, {
	                line_items: newLineItems
	            });
	
	        case _appActions2.default.ADD_PAYMENT_METHOD:
	            return _extends({}, state, {
	                payment_methods: action.payload
	            });
	
	        case _appActions2.default.ADDING_PRODUCT_TO_CART:
	            return _extends({}, state, {
	                addingProductToCart: !state.addingProductToCart
	            });
	
	        case _appActions2.default.ADDING_PRODUCT_TO_CART_TO_FIX:
	            return _extends({}, state, {
	                addingProductToCart: action.payload
	            });
	
	        case _appActions2.default.REMOVING_PRODUCT_TO_CART:
	            return _extends({}, state, {
	                removingProductToCart: action.payload
	            });
	        case _appActions2.default.SET_IS_FINAL_STEP_HAPPENING:
	            return _extends({}, state, {
	                isFinalStepHappening: action.payload
	            });
	        case _appActions2.default.SYNC_ORDER_FROM_STORAGE:
	            return _extends({}, action.payload);
	        case _appActions2.default.DISABLING_ADD:
	            return _extends({}, state, {
	                disablingAdd: action.payload
	            });
	
	        case _appActions2.default.ADD_REDSYS_PAYMENT_INFO:
	            return _extends({}, state, { redsysPaymentInfo: action.payload });
	
	        case _appActions2.default.ADD_REDSYS_PAYMENT_ERROR:
	            return _extends({}, state, { redsysPaymentError: action.payload });
	
	        case _appActions2.default.DESTROY_ORDER:
	            return initialState;
	        case _appActions2.default.VALIDATE_CREDIT_CARD:
	            return _extends({}, state, { isCreditCardValidated: action.payload });
	        default:
	            return state;
	    }
	};
	
	exports.default = order;

/***/ },
/* 803 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _appActions = __webpack_require__(21);
	
	var _appActions2 = _interopRequireDefault(_appActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = {
	    shipments: [],
	    checkout_steps: [],
	    state: 'complete',
	    showDialogError: false,
	    orderError: null
	};
	
	var placedOrder = function placedOrder() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _appActions2.default.ADD_PLACED_ORDER:
	            return _extends({}, action.payload, { state: 'complete' });
	        case _appActions2.default.DESTROY_PLACED_ORDER:
	            return _extends({}, initialState);
	        case _appActions2.default.ADD_ORDER_ERROR:
	            return _extends({}, state, { orderError: action.payload });
	        case _appActions2.default.COMPLETE_ORDER_ERROR:
	            return _extends({}, state, { orderError: action.payload, showDialogError: true });
	        case _appActions2.default.COMPLETE_ORDER_ERROR_HIDE_DIALOG:
	            return _extends({}, state, { showDialogError: false });
	        default:
	            return state;
	    }
	};
	
	exports.default = placedOrder;

/***/ },
/* 804 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _appActions = __webpack_require__(21);
	
	var _appActions2 = _interopRequireDefault(_appActions);
	
	var _productModel = __webpack_require__(143);
	
	var _productModel2 = _interopRequireDefault(_productModel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var initialState = {
	    products: [],
	    allStoreProducts: [],
	    meta: {}
	};
	
	var productList = function productList() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments[1];
	
	    var newProductList = void 0;
	    var productInList = void 0;
	    var oldProductList = void 0;
	
	    switch (action.type) {
	        case _appActions2.default.ADD_PRODUCTS:
	            return _extends({}, state, { products: action.payload.products, meta: action.payload.meta });
	
	        case _appActions2.default.APPEND_PRODUCTS:
	            oldProductList = state.products.map(function (oldProduct) {
	                return oldProduct.id;
	            });
	            newProductList = action.payload.products.filter(function (product) {
	                return oldProductList.indexOf(product.id) === -1;
	            });
	
	            return _extends({}, state, {
	                products: [].concat(_toConsumableArray(state.products), _toConsumableArray(newProductList))
	            });
	
	        case _appActions2.default.ADD_PRODUCT:
	            productInList = _productModel2.default.find(action.payload.id, state.products);
	
	            if (productInList) {
	                return state;
	            }
	
	            newProductList = Object.assign([], state.products);
	            newProductList.push(action.payload);
	
	            return _extends({}, state, { products: newProductList });
	
	        case _appActions2.default.ADD_PRODUCTS_FROM_ALL_STORES:
	            return _extends({}, state, { allStoreProducts: action.payload.allStoreProducts, meta: action.payload.meta });
	
	        default:
	            return state;
	    }
	};
	
	exports.default = productList;

/***/ },
/* 805 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _appActions = __webpack_require__(21);
	
	var _appActions2 = _interopRequireDefault(_appActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = {
	    stores: [],
	    currentStore: {},
	    storesByZone: [],
	    pageCount: 1,
	    storesGrouped: {}
	};
	
	var stores = function stores() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments[1];
	
	    if (action.type === _appActions2.default.ADD_STORES) {
	        return _extends({}, state, { stores: action.payload });
	    }
	
	    if (action.type === _appActions2.default.ADD_STORES_BY_ZONE) {
	        return _extends({}, state, { storesByZone: action.payload.storesByZone, pageCount: action.payload.pageCount });
	    }
	
	    if (action.type === _appActions2.default.SET_CURRENT_STORE) {
	        return _extends({}, state, { currentStore: action.payload });
	    }
	    if (action.type === _appActions2.default.ADD_STORES_GROUPED) {
	        return _extends({}, state, { storesGrouped: action.payload });
	    }
	    return state;
	};
	
	exports.default = stores;

/***/ },
/* 806 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _appActions = __webpack_require__(21);
	
	var _appActions2 = _interopRequireDefault(_appActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = {
	    taxonsMenu: [],
	    fetchedTaxons: []
	};
	
	var taxons = function taxons() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments[1];
	
	    if (action.type === _appActions2.default.ADD_TAXONS) {
	        return _extends({}, action.payload);
	    }
	    return state;
	};
	
	exports.default = taxons;

/***/ },
/* 807 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _appActions = __webpack_require__(21);
	
	var _appActions2 = _interopRequireDefault(_appActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = {};
	
	var user = function user() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _appActions2.default.USER:
	            return _extends({}, state, action.payload);
	        case _appActions2.default.REMOVE_USER:
	            return initialState;
	        default:
	            return state;
	    }
	};
	
	exports.default = user;

/***/ },
/* 808 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _appActions = __webpack_require__(21);
	
	var _appActions2 = _interopRequireDefault(_appActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = {};
	
	var wallets = function wallets() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments[1];
	
	    if (action.type === _appActions2.default.UPDATE_WALLETS) {
	        return _extends({}, state, action.payload);
	    }
	    if (action.type === _appActions2.default.CLEAR_WALLETS) {
	        return initialState;
	    }
	    return state;
	};
	
	exports.default = wallets;

/***/ },
/* 809 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _appActions = __webpack_require__(21);
	
	var _appActions2 = _interopRequireDefault(_appActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = {
	    availableZones: [],
	    currentZone: undefined
	};
	
	var zone = function zone() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments[1];
	
	    if (action.type === _appActions2.default.SET_AVAILABLE_ZONES) {
	        return _extends({}, state, {
	            availableZones: action.payload
	        });
	    }
	    if (action.type === _appActions2.default.SET_CURRENT_ZONE) {
	        return _extends({}, state, {
	            currentZone: action.payload
	        });
	    }
	    return state;
	};
	
	exports.default = zone;

/***/ },
/* 810 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = configRoutes;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(26);
	
	var _homePageConnector = __webpack_require__(756);
	
	var _homePageConnector2 = _interopRequireDefault(_homePageConnector);
	
	var _userLoginConnector = __webpack_require__(777);
	
	var _userLoginConnector2 = _interopRequireDefault(_userLoginConnector);
	
	var _userSignupConnector = __webpack_require__(367);
	
	var _userSignupConnector2 = _interopRequireDefault(_userSignupConnector);
	
	var _sendEmailConnector = __webpack_require__(772);
	
	var _sendEmailConnector2 = _interopRequireDefault(_sendEmailConnector);
	
	var _productListConnector = __webpack_require__(766);
	
	var _productListConnector2 = _interopRequireDefault(_productListConnector);
	
	var _storeProductsConnector = __webpack_require__(775);
	
	var _storeProductsConnector2 = _interopRequireDefault(_storeProductsConnector);
	
	var _comingSoonConnector = __webpack_require__(751);
	
	var _comingSoonConnector2 = _interopRequireDefault(_comingSoonConnector);
	
	var _notFoundConnector = __webpack_require__(761);
	
	var _notFoundConnector2 = _interopRequireDefault(_notFoundConnector);
	
	var _registerConfirmationConnector = __webpack_require__(769);
	
	var _registerConfirmationConnector2 = _interopRequireDefault(_registerConfirmationConnector);
	
	var _forgotPasswordConnector = __webpack_require__(753);
	
	var _forgotPasswordConnector2 = _interopRequireDefault(_forgotPasswordConnector);
	
	var _productShowConnector = __webpack_require__(768);
	
	var _productShowConnector2 = _interopRequireDefault(_productShowConnector);
	
	var _cartShowConnector = __webpack_require__(740);
	
	var _cartShowConnector2 = _interopRequireDefault(_cartShowConnector);
	
	var _addressFormConnector = __webpack_require__(742);
	
	var _addressFormConnector2 = _interopRequireDefault(_addressFormConnector);
	
	var _deliveryFormConnector = __webpack_require__(746);
	
	var _deliveryFormConnector2 = _interopRequireDefault(_deliveryFormConnector);
	
	var _paymentFormConnector = __webpack_require__(365);
	
	var _paymentFormConnector2 = _interopRequireDefault(_paymentFormConnector);
	
	var _confirmationFormConnector = __webpack_require__(745);
	
	var _confirmationFormConnector2 = _interopRequireDefault(_confirmationFormConnector);
	
	var _checkoutSuccessConnector = __webpack_require__(744);
	
	var _checkoutSuccessConnector2 = _interopRequireDefault(_checkoutSuccessConnector);
	
	var _listConnector = __webpack_require__(762);
	
	var _listConnector2 = _interopRequireDefault(_listConnector);
	
	var _showConnector = __webpack_require__(763);
	
	var _showConnector2 = _interopRequireDefault(_showConnector);
	
	var _showStoresConnector = __webpack_require__(774);
	
	var _showStoresConnector2 = _interopRequireDefault(_showStoresConnector);
	
	var _privacyPolicyConnector = __webpack_require__(765);
	
	var _privacyPolicyConnector2 = _interopRequireDefault(_privacyPolicyConnector);
	
	var _shippingPolicyConnector = __webpack_require__(773);
	
	var _shippingPolicyConnector2 = _interopRequireDefault(_shippingPolicyConnector);
	
	var _returnPolicyConnector = __webpack_require__(770);
	
	var _returnPolicyConnector2 = _interopRequireDefault(_returnPolicyConnector);
	
	var _frequentQuestionsConnector = __webpack_require__(754);
	
	var _frequentQuestionsConnector2 = _interopRequireDefault(_frequentQuestionsConnector);
	
	var _termsConditionsConnector = __webpack_require__(776);
	
	var _termsConditionsConnector2 = _interopRequireDefault(_termsConditionsConnector);
	
	var _headerConnector = __webpack_require__(755);
	
	var _headerConnector2 = _interopRequireDefault(_headerConnector);
	
	var _footerConnector = __webpack_require__(752);
	
	var _footerConnector2 = _interopRequireDefault(_footerConnector);
	
	var _appRoutes = __webpack_require__(22);
	
	var _appRoutes2 = _interopRequireDefault(_appRoutes);
	
	var _checkoutFailConnector = __webpack_require__(743);
	
	var _checkoutFailConnector2 = _interopRequireDefault(_checkoutFailConnector);
	
	var _paymentStepConnector = __webpack_require__(750);
	
	var _paymentStepConnector2 = _interopRequireDefault(_paymentStepConnector);
	
	var _paymentRedsysRedirectOkConnector = __webpack_require__(749);
	
	var _paymentRedsysRedirectOkConnector2 = _interopRequireDefault(_paymentRedsysRedirectOkConnector);
	
	var _paymentRedsysRedirectKoConnector = __webpack_require__(748);
	
	var _paymentRedsysRedirectKoConnector2 = _interopRequireDefault(_paymentRedsysRedirectKoConnector);
	
	var _affidavitCertificationConnector = __webpack_require__(739);
	
	var _affidavitCertificationConnector2 = _interopRequireDefault(_affidavitCertificationConnector);
	
	var _kWallet = __webpack_require__(758);
	
	var _kWallet2 = _interopRequireDefault(_kWallet);
	
	var _addFundsKWalletConnector = __webpack_require__(757);
	
	var _addFundsKWalletConnector2 = _interopRequireDefault(_addFundsKWalletConnector);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function configRoutes() {
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_headerConnector2.default, null),
	        _react2.default.createElement(
	            _reactRouterDom.Switch,
	            null,
	            _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: _appRoutes2.default.homePageRoute, component: _homePageConnector2.default }),
	            ("false") === 'true' && _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: _appRoutes2.default.manageKWallet, component: _kWallet2.default }),
	            ("false") === 'true' && _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: _appRoutes2.default.addFundsKWallet, component: _addFundsKWalletConnector2.default }),
	            _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/stores', component: _showStoresConnector2.default }),
	            ("false") !== 'true' && _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: _appRoutes2.default.signin, component: _userLoginConnector2.default }),
	            ("false") !== 'true' && _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: _appRoutes2.default.signup, component: _userSignupConnector2.default }),
	            ("false") !== 'true' && _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/c/:token', component: _registerConfirmationConnector2.default }),
	            ("false") !== 'true' && _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: _appRoutes2.default.sendEmail, component: _sendEmailConnector2.default }),
	            ("false") !== 'true' && _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/p/:token', component: _forgotPasswordConnector2.default }),
	            _react2.default.createElement(_reactRouterDom.Route, { path: _appRoutes2.default.searchPageRoute, component: _productListConnector2.default }),
	            _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/products/:productId', component: _productShowConnector2.default }),
	            _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: _appRoutes2.default.cartPageRoute, component: _cartShowConnector2.default }),
	            _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: _appRoutes2.default.checkout.addressPageRoute, component: _addressFormConnector2.default }),
	            _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: _appRoutes2.default.checkout.deliveryPageRoute, component: _deliveryFormConnector2.default }),
	            _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: _appRoutes2.default.checkout.paymentPageRoute, component: _paymentStepConnector2.default }),
	            _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: _appRoutes2.default.checkout.confirmPageRoute, component: _confirmationFormConnector2.default }),
	            _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: _appRoutes2.default.checkout.completePageRoute, component: _checkoutSuccessConnector2.default }),
	            _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: _appRoutes2.default.checkout.failPageRoute, component: _checkoutFailConnector2.default }),
	            _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: _appRoutes2.default.checkout.redsysRedirectOk, component: _paymentRedsysRedirectOkConnector2.default }),
	            _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: _appRoutes2.default.checkout.redsysRedirectKo, component: _paymentRedsysRedirectKoConnector2.default }),
	            _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: _appRoutes2.default.ordersPageRoute, component: _listConnector2.default }),
	            _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/orders/:orderId', component: _showConnector2.default }),
	            _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: _appRoutes2.default.wishList, component: _comingSoonConnector2.default }),
	            _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: _appRoutes2.default.classifiedAds, component: _comingSoonConnector2.default }),
	            _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/brand/*', component: _comingSoonConnector2.default }),
	            _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: _appRoutes2.default.policy, component: _privacyPolicyConnector2.default }),
	            _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: _appRoutes2.default.shipping, component: _shippingPolicyConnector2.default }),
	            _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: _appRoutes2.default.returns, component: _returnPolicyConnector2.default }),
	            _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: _appRoutes2.default.frequentQuestions, component: _frequentQuestionsConnector2.default }),
	            _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: _appRoutes2.default.terms, component: _termsConditionsConnector2.default }),
	            _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: _appRoutes2.default.affidavitCertification, component: _affidavitCertificationConnector2.default }),
	            _react2.default.createElement(_reactRouterDom.Route, { path: '/:storeCode', component: _storeProductsConnector2.default }),
	            _react2.default.createElement(_reactRouterDom.Route, { component: _notFoundConnector2.default })
	        ),
	        _react2.default.createElement(_footerConnector2.default, null)
	    );
	}

/***/ },
/* 811 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var CheckoutDataCalculator = {
	    calculateFormToStep: function calculateFormToStep(order, step) {
	        var formObject = {};
	
	        // TODO: Implement here the calculation for other steps if needed.
	        if (step === 'address') {
	            formObject = CheckoutDataCalculator.calculateFormToAddress(order);
	        }
	
	        return formObject;
	    },
	
	    calculateFormToAddress: function calculateFormToAddress(order) {
	        var propertiesFromOrder = ['email', 'email_receiver'];
	        var propertiesFromAddress = ['firstname', 'lastname', 'address1', 'address2', 'city', 'phone', 'zipcode', 'state_name', 'country_iso'];
	
	        return {
	            save_user_address: true,
	            order: _extends({}, CheckoutDataCalculator.copyObject(order, propertiesFromOrder), {
	                bill_address_attributes: CheckoutDataCalculator.copyObject(order.bill_address, propertiesFromAddress),
	                ship_address_attributes: CheckoutDataCalculator.copyObject(order.ship_address, propertiesFromAddress)
	            })
	        };
	    },
	
	    copyObject: function copyObject(inputObject, attributes) {
	        var outputObject = {};
	        attributes.forEach(function (key) {
	            outputObject[key] = inputObject[key];
	        });
	        return outputObject;
	    }
	};
	
	exports.default = CheckoutDataCalculator;

/***/ },
/* 812 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* eslint-disable lines-between-class-members */
	
	
	var _fingerprintjsProSpa = __webpack_require__(633);
	
	var _appDefaults = __webpack_require__(39);
	
	var _appDefaults2 = _interopRequireDefault(_appDefaults);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Service to interact with Fingerprint.
	 * It implements a singleton to avoid duplicated api calls.
	 */
	var FingerprintService = function () {
	    function FingerprintService() {
	        _classCallCheck(this, FingerprintService);
	    }
	
	    _createClass(FingerprintService, null, [{
	        key: 'info',
	        get: function get() {
	            if (FingerprintService._info !== null) {
	                return new Promise(function (resolve, reject) {
	                    return resolve(FingerprintService._info);
	                });
	            }
	            var fpClient = new _fingerprintjsProSpa.FpjsClient({
	                loadOptions: {
	                    apiKey: ("mdaO5TIlVptg2wrFbMdU"),
	                    endpoint: ("https://fku.staging.katapulk.com")
	                }
	            });
	
	            return new Promise(function (resolve, reject) {
	                var visitorData = fpClient.init().then(function () {
	                    return fpClient.getVisitorData({ extendedResult: true });
	                });
	                visitorData.then(function (info) {
	                    FingerprintService._info = info;
	                    return resolve(info);
	                }).catch(function (err) {
	                    // we must resolve with null even if Fingerprint fails to provide us the user's info
	                    console.error(err);
	                    resolve(null);
	                });
	            });
	        }
	    }]);
	
	    return FingerprintService;
	}();
	
	FingerprintService._info = null;
	exports.default = FingerprintService;

/***/ },
/* 813 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _store = __webpack_require__(40);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LoaderUtils = {
	    isLoading: function isLoading() {
	        var _spreeStore$getState = _store2.default.getState();
	
	        var displayLoader = _spreeStore$getState.displayLoader;
	
	        return displayLoader;
	    }
	};
	
	exports.default = LoaderUtils;

/***/ },
/* 814 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var NavigationModel = {
	    findByPermalink: function findByPermalink(permalink) {
	        var navigations = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	        var index = arguments[2];
	
	        var navigation = navigations && navigations.katapulk && navigations.katapulk.taxons.find(function (navigation) {
	            return "/t/" + navigation.permalink === permalink;
	        });
	
	        return navigation || navigations && navigations.katapulk && navigations.katapulk.taxons[index].taxons.find(function (navigation) {
	            return "/t/" + navigation.permalink === permalink;
	        });
	    }
	};
	
	exports.default = NavigationModel;

/***/ },
/* 815 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var removeEmptyProperties = function removeEmptyProperties(obj) {
	    return Object.fromEntries(Object.entries(obj).filter(function (_ref) {
	        var _ref2 = _slicedToArray(_ref, 2);
	
	        var _ = _ref2[0];
	        var v = _ref2[1];
	        return v != null;
	    }).map(function (_ref3) {
	        var _ref4 = _slicedToArray(_ref3, 2);
	
	        var k = _ref4[0];
	        var v = _ref4[1];
	        return [k, v === Object(v) ? removeEmptyProperties(v) : v];
	    }));
	};
	
	var ObjectUtils = {
	    removeEmptyProperties: removeEmptyProperties
	};
	
	exports.default = ObjectUtils;

/***/ },
/* 816 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var TaxonModel = {
	    findByPermalink: function findByPermalink(permalink) {
	        var taxons = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	        var prefix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '/t/';
	        return taxons.find(function (taxon) {
	            return '' + prefix + taxon.permalink === permalink;
	        });
	    },
	
	    image: function image(imageId) {
	        var taxonList = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	        return taxonList.included.filter(function (item) {
	            return item.type === 'taxon_image' && imageId === item.id;
	        });
	    }
	};
	
	exports.default = TaxonModel;

/***/ },
/* 817 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var UrlParser = {
	
	    getQueryVariable: function getQueryVariable(variable) {
	        var query = window.location.pathname;
	        var vars = query.split('/search/');
	        return vars[1];
	        // TODO: Trying out url params as opposed to query params for search words.
	        // for (let i = 0; i < vars.length; i++) {
	        //   let pair = vars[i].split('=');
	        //   if (decodeURIComponent(pair[0]) === variable) {
	        //       return decodeURIComponent(pair[1]);
	        //   }
	        // }
	    }
	};
	
	exports.default = UrlParser;

/***/ },
/* 818 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {// This method of obtaining a reference to the global object needs to be
	// kept identical to the way it is obtained in runtime.js
	var g =
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this;
	
	// Use `getOwnPropertyNames` because not all browsers support calling
	// `hasOwnProperty` on the global `self` object in a worker. See #183.
	var hadRuntime = g.regeneratorRuntime &&
	  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;
	
	// Save the old regeneratorRuntime in case it needs to be restored later.
	var oldRuntime = hadRuntime && g.regeneratorRuntime;
	
	// Force reevalutation of runtime.js.
	g.regeneratorRuntime = undefined;
	
	module.exports = __webpack_require__(819);
	
	if (hadRuntime) {
	  // Restore the original runtime.
	  g.regeneratorRuntime = oldRuntime;
	} else {
	  // Remove the global property added by runtime.js.
	  try {
	    delete g.regeneratorRuntime;
	  } catch(e) {
	    g.regeneratorRuntime = undefined;
	  }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 819 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {/**
	 * Copyright (c) 2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
	 * additional grant of patent rights can be found in the PATENTS file in
	 * the same directory.
	 */
	
	!(function(global) {
	  "use strict";
	
	  var hasOwn = Object.prototype.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var $Symbol = typeof Symbol === "function" ? Symbol : {};
	  var iteratorSymbol = $Symbol.iterator || "@@iterator";
	  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
	
	  var inModule = typeof module === "object";
	  var runtime = global.regeneratorRuntime;
	  if (runtime) {
	    if (inModule) {
	      // If regeneratorRuntime is defined globally and we're in a module,
	      // make the exports object identical to regeneratorRuntime.
	      module.exports = runtime;
	    }
	    // Don't bother evaluating the rest of this file if the runtime was
	    // already defined globally.
	    return;
	  }
	
	  // Define the runtime globally (as expected by generated code) as either
	  // module.exports (if we're in a module) or a new, empty object.
	  runtime = global.regeneratorRuntime = inModule ? module.exports : {};
	
	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
	    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
	    var generator = Object.create(protoGenerator.prototype);
	    var context = new Context(tryLocsList || []);
	
	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);
	
	    return generator;
	  }
	  runtime.wrap = wrap;
	
	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }
	
	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";
	
	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};
	
	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	
	  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype;
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunctionPrototype[toStringTagSymbol] = GeneratorFunction.displayName = "GeneratorFunction";
	
	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function(method) {
	      prototype[method] = function(arg) {
	        return this._invoke(method, arg);
	      };
	    });
	  }
	
	  runtime.isGeneratorFunction = function(genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor
	      ? ctor === GeneratorFunction ||
	        // For the native GeneratorFunction constructor, the best we can
	        // do is to check its .name property.
	        (ctor.displayName || ctor.name) === "GeneratorFunction"
	      : false;
	  };
	
	  runtime.mark = function(genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	      if (!(toStringTagSymbol in genFun)) {
	        genFun[toStringTagSymbol] = "GeneratorFunction";
	      }
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };
	
	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `value instanceof AwaitArgument` to determine if the yielded value is
	  // meant to be awaited. Some may consider the name of this method too
	  // cutesy, but they are curmudgeons.
	  runtime.awrap = function(arg) {
	    return new AwaitArgument(arg);
	  };
	
	  function AwaitArgument(arg) {
	    this.arg = arg;
	  }
	
	  function AsyncIterator(generator) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);
	      if (record.type === "throw") {
	        reject(record.arg);
	      } else {
	        var result = record.arg;
	        var value = result.value;
	        if (value instanceof AwaitArgument) {
	          return Promise.resolve(value.arg).then(function(value) {
	            invoke("next", value, resolve, reject);
	          }, function(err) {
	            invoke("throw", err, resolve, reject);
	          });
	        }
	
	        return Promise.resolve(value).then(function(unwrapped) {
	          // When a yielded Promise is resolved, its final value becomes
	          // the .value of the Promise<{value,done}> result for the
	          // current iteration. If the Promise is rejected, however, the
	          // result for this iteration will be rejected with the same
	          // reason. Note that rejections of yielded Promises are not
	          // thrown back into the generator function, as is the case
	          // when an awaited Promise is rejected. This difference in
	          // behavior between yield and await is important, because it
	          // allows the consumer to decide what to do with the yielded
	          // rejection (swallow it and continue, manually .throw it back
	          // into the generator, abandon iteration, whatever). With
	          // await, by contrast, there is no opportunity to examine the
	          // rejection reason outside the generator function, so the
	          // only option is to throw it from the await expression, and
	          // let the generator function handle the exception.
	          result.value = unwrapped;
	          resolve(result);
	        }, reject);
	      }
	    }
	
	    if (typeof process === "object" && process.domain) {
	      invoke = process.domain.bind(invoke);
	    }
	
	    var previousPromise;
	
	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return new Promise(function(resolve, reject) {
	          invoke(method, arg, resolve, reject);
	        });
	      }
	
	      return previousPromise =
	        // If enqueue has been called before, then we want to wait until
	        // all previous Promises have been resolved before calling invoke,
	        // so that results are always delivered in the correct order. If
	        // enqueue has not been called before, then it is important to
	        // call invoke immediately, without waiting on a callback to fire,
	        // so that the async generator function has the opportunity to do
	        // any necessary setup in a predictable way. This predictability
	        // is why the Promise constructor synchronously invokes its
	        // executor callback, and why async functions synchronously
	        // execute code before the first await. Since we implement simple
	        // async functions in terms of async generators, it is especially
	        // important to get this right, even though it requires care.
	        previousPromise ? previousPromise.then(
	          callInvokeWithMethodAndArg,
	          // Avoid propagating failures to Promises returned by later
	          // invocations of the iterator.
	          callInvokeWithMethodAndArg
	        ) : callInvokeWithMethodAndArg();
	    }
	
	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }
	
	  defineIteratorMethods(AsyncIterator.prototype);
	
	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
	    var iter = new AsyncIterator(
	      wrap(innerFn, outerFn, self, tryLocsList)
	    );
	
	    return runtime.isGeneratorFunction(outerFn)
	      ? iter // If outerFn is a generator, return the full iterator.
	      : iter.next().then(function(result) {
	          return result.done ? result.value : iter.next();
	        });
	  };
	
	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;
	
	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }
	
	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }
	
	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }
	
	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          if (method === "return" ||
	              (method === "throw" && delegate.iterator[method] === undefined)) {
	            // A return or throw (when the delegate iterator has no throw
	            // method) always terminates the yield* loop.
	            context.delegate = null;
	
	            // If the delegate iterator has a return method, give it a
	            // chance to clean up.
	            var returnMethod = delegate.iterator["return"];
	            if (returnMethod) {
	              var record = tryCatch(returnMethod, delegate.iterator, arg);
	              if (record.type === "throw") {
	                // If the return method threw an exception, let that
	                // exception prevail over the original return or throw.
	                method = "throw";
	                arg = record.arg;
	                continue;
	              }
	            }
	
	            if (method === "return") {
	              // Continue with the outer return, now that the delegate
	              // iterator has been terminated.
	              continue;
	            }
	          }
	
	          var record = tryCatch(
	            delegate.iterator[method],
	            delegate.iterator,
	            arg
	          );
	
	          if (record.type === "throw") {
	            context.delegate = null;
	
	            // Like returning generator.throw(uncaught), but without the
	            // overhead of an extra function call.
	            method = "throw";
	            arg = record.arg;
	            continue;
	          }
	
	          // Delegate generator ran and handled its own exceptions so
	          // regardless of what the method was, we continue as if it is
	          // "next" with an undefined arg.
	          method = "next";
	          arg = undefined;
	
	          var info = record.arg;
	          if (info.done) {
	            context[delegate.resultName] = info.value;
	            context.next = delegate.nextLoc;
	          } else {
	            state = GenStateSuspendedYield;
	            return info;
	          }
	
	          context.delegate = null;
	        }
	
	        if (method === "next") {
	          // Setting context._sent for legacy support of Babel's
	          // function.sent implementation.
	          context.sent = context._sent = arg;
	
	        } else if (method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw arg;
	          }
	
	          if (context.dispatchException(arg)) {
	            // If the dispatched exception was caught by a catch block,
	            // then let that catch block handle the exception normally.
	            method = "next";
	            arg = undefined;
	          }
	
	        } else if (method === "return") {
	          context.abrupt("return", arg);
	        }
	
	        state = GenStateExecuting;
	
	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done
	            ? GenStateCompleted
	            : GenStateSuspendedYield;
	
	          var info = {
	            value: record.arg,
	            done: context.done
	          };
	
	          if (record.arg === ContinueSentinel) {
	            if (context.delegate && method === "next") {
	              // Deliberately forget the last sent value so that we don't
	              // accidentally pass it on to the delegate.
	              arg = undefined;
	            }
	          } else {
	            return info;
	          }
	
	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(arg) call above.
	          method = "throw";
	          arg = record.arg;
	        }
	      }
	    };
	  }
	
	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);
	
	  Gp[iteratorSymbol] = function() {
	    return this;
	  };
	
	  Gp[toStringTagSymbol] = "Generator";
	
	  Gp.toString = function() {
	    return "[object Generator]";
	  };
	
	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };
	
	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }
	
	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }
	
	    this.tryEntries.push(entry);
	  }
	
	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }
	
	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }
	
	  runtime.keys = function(object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();
	
	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }
	
	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };
	
	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }
	
	      if (typeof iterable.next === "function") {
	        return iterable;
	      }
	
	      if (!isNaN(iterable.length)) {
	        var i = -1, next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }
	
	          next.value = undefined;
	          next.done = true;
	
	          return next;
	        };
	
	        return next.next = next;
	      }
	    }
	
	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  runtime.values = values;
	
	  function doneResult() {
	    return { value: undefined, done: true };
	  }
	
	  Context.prototype = {
	    constructor: Context,
	
	    reset: function(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      // Resetting context._sent for legacy support of Babel's
	      // function.sent implementation.
	      this.sent = this._sent = undefined;
	      this.done = false;
	      this.delegate = null;
	
	      this.tryEntries.forEach(resetTryEntry);
	
	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" &&
	              hasOwn.call(this, name) &&
	              !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },
	
	    stop: function() {
	      this.done = true;
	
	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }
	
	      return this.rval;
	    },
	
	    dispatchException: function(exception) {
	      if (this.done) {
	        throw exception;
	      }
	
	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	        return !!caught;
	      }
	
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;
	
	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }
	
	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");
	
	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }
	
	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },
	
	    abrupt: function(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev &&
	            hasOwn.call(entry, "finallyLoc") &&
	            this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }
	
	      if (finallyEntry &&
	          (type === "break" ||
	           type === "continue") &&
	          finallyEntry.tryLoc <= arg &&
	          arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }
	
	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;
	
	      if (finallyEntry) {
	        this.next = finallyEntry.finallyLoc;
	      } else {
	        this.complete(record);
	      }
	
	      return ContinueSentinel;
	    },
	
	    complete: function(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }
	
	      if (record.type === "break" ||
	          record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = record.arg;
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	    },
	
	    finish: function(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },
	
	    "catch": function(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }
	
	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },
	
	    delegateYield: function(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };
	
	      return ContinueSentinel;
	    }
	  };
	})(
	  // Among the various tricks for obtaining a reference to the global
	  // object, this seems to be the most reliable technique that does not
	  // use indirect eval (which violates Content Security Policy).
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this
	);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(304)))

/***/ },
/* 820 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var defined = __webpack_require__(1576);
	var fetch = __webpack_require__(1765);
	var collect = __webpack_require__(1772);
	
	module.exports = binlookup;
	
	function binlookup( opts ){
		if (typeof opts === 'string')
			opts = {
				key: opts,
			};
	
		if (typeof opts === 'undefined')
			opts = {};
	
		var url = defined(opts.url, 'https://lookup.binlist.net/');
	
		var Promise = defined(opts.Promise, global.Promise);
	
		return function( bin, cb ){
			var source = fetch({
				host: url,
				path: bin,
				headers: Object.assign({
					'Accept-Version': '3',
					'X-Client': 'Node.js 2.0.1',
				}, opts.key && {
					'Authorization': 'Basic '+fetch.btoa(opts.key+':'),
				}),
			});
	
			if (cb === undefined)
				return new Promise(function( rs, rj ){
					collect(function( err, ranges){
						if (err)
							return rj(err);
	
						rs(ranges[0]);
					})(source);
				});
	
			collect(function( err, ranges ){
				if (err)
					return cb(err);
	
				cb(null, ranges[0]);
			})(source);
		}
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 821 */
/***/ function(module, exports) {

	module.exports = function _btoa(str) {
	  return btoa(str)
	}


/***/ },
/* 822 */
/***/ function(module, exports, __webpack_require__) {

	
	/**
	 * Expose `Emitter`.
	 */
	
	if (true) {
	  module.exports = Emitter;
	}
	
	/**
	 * Initialize a new `Emitter`.
	 *
	 * @api public
	 */
	
	function Emitter(obj) {
	  if (obj) return mixin(obj);
	};
	
	/**
	 * Mixin the emitter properties.
	 *
	 * @param {Object} obj
	 * @return {Object}
	 * @api private
	 */
	
	function mixin(obj) {
	  for (var key in Emitter.prototype) {
	    obj[key] = Emitter.prototype[key];
	  }
	  return obj;
	}
	
	/**
	 * Listen on the given `event` with `fn`.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.on =
	Emitter.prototype.addEventListener = function(event, fn){
	  this._callbacks = this._callbacks || {};
	  (this._callbacks['$' + event] = this._callbacks['$' + event] || [])
	    .push(fn);
	  return this;
	};
	
	/**
	 * Adds an `event` listener that will be invoked a single
	 * time then automatically removed.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.once = function(event, fn){
	  function on() {
	    this.off(event, on);
	    fn.apply(this, arguments);
	  }
	
	  on.fn = fn;
	  this.on(event, on);
	  return this;
	};
	
	/**
	 * Remove the given callback for `event` or all
	 * registered callbacks.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.off =
	Emitter.prototype.removeListener =
	Emitter.prototype.removeAllListeners =
	Emitter.prototype.removeEventListener = function(event, fn){
	  this._callbacks = this._callbacks || {};
	
	  // all
	  if (0 == arguments.length) {
	    this._callbacks = {};
	    return this;
	  }
	
	  // specific event
	  var callbacks = this._callbacks['$' + event];
	  if (!callbacks) return this;
	
	  // remove all handlers
	  if (1 == arguments.length) {
	    delete this._callbacks['$' + event];
	    return this;
	  }
	
	  // remove specific handler
	  var cb;
	  for (var i = 0; i < callbacks.length; i++) {
	    cb = callbacks[i];
	    if (cb === fn || cb.fn === fn) {
	      callbacks.splice(i, 1);
	      break;
	    }
	  }
	
	  // Remove event specific arrays for event types that no
	  // one is subscribed for to avoid memory leak.
	  if (callbacks.length === 0) {
	    delete this._callbacks['$' + event];
	  }
	
	  return this;
	};
	
	/**
	 * Emit `event` with the given args.
	 *
	 * @param {String} event
	 * @param {Mixed} ...
	 * @return {Emitter}
	 */
	
	Emitter.prototype.emit = function(event){
	  this._callbacks = this._callbacks || {};
	
	  var args = new Array(arguments.length - 1)
	    , callbacks = this._callbacks['$' + event];
	
	  for (var i = 1; i < arguments.length; i++) {
	    args[i - 1] = arguments[i];
	  }
	
	  if (callbacks) {
	    callbacks = callbacks.slice(0);
	    for (var i = 0, len = callbacks.length; i < len; ++i) {
	      callbacks[i].apply(this, args);
	    }
	  }
	
	  return this;
	};
	
	/**
	 * Return array of callbacks for `event`.
	 *
	 * @param {String} event
	 * @return {Array}
	 * @api public
	 */
	
	Emitter.prototype.listeners = function(event){
	  this._callbacks = this._callbacks || {};
	  return this._callbacks['$' + event] || [];
	};
	
	/**
	 * Check if this emitter has `event` handlers.
	 *
	 * @param {String} event
	 * @return {Boolean}
	 * @api public
	 */
	
	Emitter.prototype.hasListeners = function(event){
	  return !! this.listeners(event).length;
	};


/***/ },
/* 823 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(389);
	__webpack_require__(860);
	module.exports = __webpack_require__(44).Array.from;


/***/ },
/* 824 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(861);
	module.exports = __webpack_require__(44).Array.isArray;


/***/ },
/* 825 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(863);
	module.exports = __webpack_require__(44).Object.assign;


/***/ },
/* 826 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(864);
	var $Object = __webpack_require__(44).Object;
	module.exports = function create(P, D) {
	  return $Object.create(P, D);
	};


/***/ },
/* 827 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(865);
	var $Object = __webpack_require__(44).Object;
	module.exports = function defineProperty(it, key, desc) {
	  return $Object.defineProperty(it, key, desc);
	};


/***/ },
/* 828 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(872);
	module.exports = __webpack_require__(44).Object.entries;


/***/ },
/* 829 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(866);
	var $Object = __webpack_require__(44).Object;
	module.exports = function getOwnPropertyDescriptor(it, key) {
	  return $Object.getOwnPropertyDescriptor(it, key);
	};


/***/ },
/* 830 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(867);
	module.exports = __webpack_require__(44).Object.keys;


/***/ },
/* 831 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(868);
	module.exports = __webpack_require__(44).Object.setPrototypeOf;


/***/ },
/* 832 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(873);
	module.exports = __webpack_require__(44).Object.values;


/***/ },
/* 833 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(869);
	module.exports = __webpack_require__(44).parseInt;


/***/ },
/* 834 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(870);
	__webpack_require__(388);
	__webpack_require__(874);
	__webpack_require__(875);
	module.exports = __webpack_require__(44).Symbol;


/***/ },
/* 835 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(389);
	__webpack_require__(390);
	module.exports = __webpack_require__(267).f('iterator');


/***/ },
/* 836 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(388);
	__webpack_require__(390);
	__webpack_require__(871);
	__webpack_require__(877);
	__webpack_require__(876);
	module.exports = __webpack_require__(44).WeakMap;


/***/ },
/* 837 */
/***/ function(module, exports) {

	module.exports = function () { /* empty */ };


/***/ },
/* 838 */
/***/ function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(90);
	var toLength = __webpack_require__(186);
	var toAbsoluteIndex = __webpack_require__(859);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ },
/* 839 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(69);
	var isArray = __webpack_require__(256);
	var SPECIES = __webpack_require__(70)('species');
	
	module.exports = function (original) {
	  var C;
	  if (isArray(original)) {
	    C = original.constructor;
	    // cross-realm fallback
	    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
	    if (isObject(C)) {
	      C = C[SPECIES];
	      if (C === null) C = undefined;
	    }
	  } return C === undefined ? Array : C;
	};


/***/ },
/* 840 */
/***/ function(module, exports, __webpack_require__) {

	// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
	var speciesConstructor = __webpack_require__(839);
	
	module.exports = function (original, length) {
	  return new (speciesConstructor(original))(length);
	};


/***/ },
/* 841 */
/***/ function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(252);
	var TAG = __webpack_require__(70)('toStringTag');
	// ES3 wrong here
	var ARG = cof(function () { return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (e) { /* empty */ }
	};
	
	module.exports = function (it) {
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};


/***/ },
/* 842 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var redefineAll = __webpack_require__(385);
	var getWeak = __webpack_require__(184).getWeak;
	var anObject = __webpack_require__(86);
	var isObject = __webpack_require__(69);
	var anInstance = __webpack_require__(374);
	var forOf = __webpack_require__(254);
	var createArrayMethod = __webpack_require__(251);
	var $has = __webpack_require__(88);
	var validate = __webpack_require__(265);
	var arrayFind = createArrayMethod(5);
	var arrayFindIndex = createArrayMethod(6);
	var id = 0;
	
	// fallback for uncaught frozen keys
	var uncaughtFrozenStore = function (that) {
	  return that._l || (that._l = new UncaughtFrozenStore());
	};
	var UncaughtFrozenStore = function () {
	  this.a = [];
	};
	var findUncaughtFrozen = function (store, key) {
	  return arrayFind(store.a, function (it) {
	    return it[0] === key;
	  });
	};
	UncaughtFrozenStore.prototype = {
	  get: function (key) {
	    var entry = findUncaughtFrozen(this, key);
	    if (entry) return entry[1];
	  },
	  has: function (key) {
	    return !!findUncaughtFrozen(this, key);
	  },
	  set: function (key, value) {
	    var entry = findUncaughtFrozen(this, key);
	    if (entry) entry[1] = value;
	    else this.a.push([key, value]);
	  },
	  'delete': function (key) {
	    var index = arrayFindIndex(this.a, function (it) {
	      return it[0] === key;
	    });
	    if (~index) this.a.splice(index, 1);
	    return !!~index;
	  }
	};
	
	module.exports = {
	  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
	    var C = wrapper(function (that, iterable) {
	      anInstance(that, C, NAME, '_i');
	      that._t = NAME;      // collection type
	      that._i = id++;      // collection id
	      that._l = undefined; // leak store for uncaught frozen objects
	      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.3.3.2 WeakMap.prototype.delete(key)
	      // 23.4.3.3 WeakSet.prototype.delete(value)
	      'delete': function (key) {
	        if (!isObject(key)) return false;
	        var data = getWeak(key);
	        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
	        return data && $has(data, this._i) && delete data[this._i];
	      },
	      // 23.3.3.4 WeakMap.prototype.has(key)
	      // 23.4.3.4 WeakSet.prototype.has(value)
	      has: function has(key) {
	        if (!isObject(key)) return false;
	        var data = getWeak(key);
	        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
	        return data && $has(data, this._i);
	      }
	    });
	    return C;
	  },
	  def: function (that, key, value) {
	    var data = getWeak(anObject(key), true);
	    if (data === true) uncaughtFrozenStore(that).set(key, value);
	    else data[that._i] = value;
	    return that;
	  },
	  ufstore: uncaughtFrozenStore
	};


/***/ },
/* 843 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(68);
	var $export = __webpack_require__(49);
	var meta = __webpack_require__(184);
	var fails = __webpack_require__(87);
	var hide = __webpack_require__(89);
	var redefineAll = __webpack_require__(385);
	var forOf = __webpack_require__(254);
	var anInstance = __webpack_require__(374);
	var isObject = __webpack_require__(69);
	var setToStringTag = __webpack_require__(185);
	var dP = __webpack_require__(80).f;
	var each = __webpack_require__(251)(0);
	var DESCRIPTORS = __webpack_require__(76);
	
	module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
	  var Base = global[NAME];
	  var C = Base;
	  var ADDER = IS_MAP ? 'set' : 'add';
	  var proto = C && C.prototype;
	  var O = {};
	  if (!DESCRIPTORS || typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
	    new C().entries().next();
	  }))) {
	    // create collection constructor
	    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
	    redefineAll(C.prototype, methods);
	    meta.NEED = true;
	  } else {
	    C = wrapper(function (target, iterable) {
	      anInstance(target, C, NAME, '_c');
	      target._c = new Base();
	      if (iterable != undefined) forOf(iterable, IS_MAP, target[ADDER], target);
	    });
	    each('add,clear,delete,forEach,get,has,set,keys,values,entries,toJSON'.split(','), function (KEY) {
	      var IS_ADDER = KEY == 'add' || KEY == 'set';
	      if (KEY in proto && !(IS_WEAK && KEY == 'clear')) hide(C.prototype, KEY, function (a, b) {
	        anInstance(this, C, KEY);
	        if (!IS_ADDER && IS_WEAK && !isObject(a)) return KEY == 'get' ? undefined : false;
	        var result = this._c[KEY](a === 0 ? 0 : a, b);
	        return IS_ADDER ? this : result;
	      });
	    });
	    IS_WEAK || dP(C.prototype, 'size', {
	      get: function () {
	        return this._c.size;
	      }
	    });
	  }
	
	  setToStringTag(C, NAME);
	
	  O[NAME] = C;
	  $export($export.G + $export.W + $export.F, O);
	
	  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);
	
	  return C;
	};


/***/ },
/* 844 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $defineProperty = __webpack_require__(80);
	var createDesc = __webpack_require__(146);
	
	module.exports = function (object, index, value) {
	  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
	  else object[index] = value;
	};


/***/ },
/* 845 */
/***/ function(module, exports, __webpack_require__) {

	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(125);
	var gOPS = __webpack_require__(259);
	var pIE = __webpack_require__(145);
	module.exports = function (it) {
	  var result = getKeys(it);
	  var getSymbols = gOPS.f;
	  if (getSymbols) {
	    var symbols = getSymbols(it);
	    var isEnum = pIE.f;
	    var i = 0;
	    var key;
	    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
	  } return result;
	};


/***/ },
/* 846 */
/***/ function(module, exports, __webpack_require__) {

	var document = __webpack_require__(68).document;
	module.exports = document && document.documentElement;


/***/ },
/* 847 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var create = __webpack_require__(257);
	var descriptor = __webpack_require__(146);
	var setToStringTag = __webpack_require__(185);
	var IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(89)(IteratorPrototype, __webpack_require__(70)('iterator'), function () { return this; });
	
	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};


/***/ },
/* 848 */
/***/ function(module, exports, __webpack_require__) {

	var ITERATOR = __webpack_require__(70)('iterator');
	var SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function () { SAFE_CLOSING = true; };
	  // eslint-disable-next-line no-throw-literal
	  Array.from(riter, function () { throw 2; });
	} catch (e) { /* empty */ }
	
	module.exports = function (exec, skipClosing) {
	  if (!skipClosing && !SAFE_CLOSING) return false;
	  var safe = false;
	  try {
	    var arr = [7];
	    var iter = arr[ITERATOR]();
	    iter.next = function () { return { done: safe = true }; };
	    arr[ITERATOR] = function () { return iter; };
	    exec(arr);
	  } catch (e) { /* empty */ }
	  return safe;
	};


/***/ },
/* 849 */
/***/ function(module, exports) {

	module.exports = function (done, value) {
	  return { value: value, done: !!done };
	};


/***/ },
/* 850 */
/***/ function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(80);
	var anObject = __webpack_require__(86);
	var getKeys = __webpack_require__(125);
	
	module.exports = __webpack_require__(76) ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};


/***/ },
/* 851 */
/***/ function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(90);
	var gOPN = __webpack_require__(381).f;
	var toString = {}.toString;
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function (it) {
	  try {
	    return gOPN(it);
	  } catch (e) {
	    return windowNames.slice();
	  }
	};
	
	module.exports.f = function getOwnPropertyNames(it) {
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};


/***/ },
/* 852 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has = __webpack_require__(88);
	var toObject = __webpack_require__(126);
	var IE_PROTO = __webpack_require__(261)('IE_PROTO');
	var ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};


/***/ },
/* 853 */
/***/ function(module, exports, __webpack_require__) {

	var $parseInt = __webpack_require__(68).parseInt;
	var $trim = __webpack_require__(858).trim;
	var ws = __webpack_require__(386);
	var hex = /^[-+]?0[xX]/;
	
	module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
	  var string = $trim(String(str), 3);
	  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
	} : $parseInt;


/***/ },
/* 854 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-setmap-offrom/
	var $export = __webpack_require__(49);
	var aFunction = __webpack_require__(373);
	var ctx = __webpack_require__(124);
	var forOf = __webpack_require__(254);
	
	module.exports = function (COLLECTION) {
	  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
	    var mapFn = arguments[1];
	    var mapping, A, n, cb;
	    aFunction(this);
	    mapping = mapFn !== undefined;
	    if (mapping) aFunction(mapFn);
	    if (source == undefined) return new this();
	    A = [];
	    if (mapping) {
	      n = 0;
	      cb = ctx(mapFn, arguments[2], 2);
	      forOf(source, false, function (nextItem) {
	        A.push(cb(nextItem, n++));
	      });
	    } else {
	      forOf(source, false, A.push, A);
	    }
	    return new this(A);
	  } });
	};


/***/ },
/* 855 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-setmap-offrom/
	var $export = __webpack_require__(49);
	
	module.exports = function (COLLECTION) {
	  $export($export.S, COLLECTION, { of: function of() {
	    var length = arguments.length;
	    var A = new Array(length);
	    while (length--) A[length] = arguments[length];
	    return new this(A);
	  } });
	};


/***/ },
/* 856 */
/***/ function(module, exports, __webpack_require__) {

	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var isObject = __webpack_require__(69);
	var anObject = __webpack_require__(86);
	var check = function (O, proto) {
	  anObject(O);
	  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	    function (test, buggy, set) {
	      try {
	        set = __webpack_require__(124)(Function.call, __webpack_require__(258).f(Object.prototype, '__proto__').set, 2);
	        set(test, []);
	        buggy = !(test instanceof Array);
	      } catch (e) { buggy = true; }
	      return function setPrototypeOf(O, proto) {
	        check(O, proto);
	        if (buggy) O.__proto__ = proto;
	        else set(O, proto);
	        return O;
	      };
	    }({}, false) : undefined),
	  check: check
	};


/***/ },
/* 857 */
/***/ function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(263);
	var defined = __webpack_require__(182);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(defined(that));
	    var i = toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};


/***/ },
/* 858 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(49);
	var defined = __webpack_require__(182);
	var fails = __webpack_require__(87);
	var spaces = __webpack_require__(386);
	var space = '[' + spaces + ']';
	var non = '\u200b\u0085';
	var ltrim = RegExp('^' + space + space + '*');
	var rtrim = RegExp(space + space + '*$');
	
	var exporter = function (KEY, exec, ALIAS) {
	  var exp = {};
	  var FORCE = fails(function () {
	    return !!spaces[KEY]() || non[KEY]() != non;
	  });
	  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
	  if (ALIAS) exp[ALIAS] = fn;
	  $export($export.P + $export.F * FORCE, 'String', exp);
	};
	
	// 1 -> String#trimLeft
	// 2 -> String#trimRight
	// 3 -> String#trim
	var trim = exporter.trim = function (string, TYPE) {
	  string = String(defined(string));
	  if (TYPE & 1) string = string.replace(ltrim, '');
	  if (TYPE & 2) string = string.replace(rtrim, '');
	  return string;
	};
	
	module.exports = exporter;


/***/ },
/* 859 */
/***/ function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(263);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ },
/* 860 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var ctx = __webpack_require__(124);
	var $export = __webpack_require__(49);
	var toObject = __webpack_require__(126);
	var call = __webpack_require__(378);
	var isArrayIter = __webpack_require__(377);
	var toLength = __webpack_require__(186);
	var createProperty = __webpack_require__(844);
	var getIterFn = __webpack_require__(387);
	
	$export($export.S + $export.F * !__webpack_require__(848)(function (iter) { Array.from(iter); }), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
	    var O = toObject(arrayLike);
	    var C = typeof this == 'function' ? this : Array;
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var index = 0;
	    var iterFn = getIterFn(O);
	    var length, result, step, iterator;
	    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
	    // if object isn't iterable or it's array with default iterator - use simple case
	    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
	      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
	        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
	      }
	    } else {
	      length = toLength(O.length);
	      for (result = new C(length); length > index; index++) {
	        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});


/***/ },
/* 861 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
	var $export = __webpack_require__(49);
	
	$export($export.S, 'Array', { isArray: __webpack_require__(256) });


/***/ },
/* 862 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(837);
	var step = __webpack_require__(849);
	var Iterators = __webpack_require__(144);
	var toIObject = __webpack_require__(90);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(379)(Array, 'Array', function (iterated, kind) {
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return step(1);
	  }
	  if (kind == 'keys') return step(0, index);
	  if (kind == 'values') return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');


/***/ },
/* 863 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(49);
	
	$export($export.S + $export.F, 'Object', { assign: __webpack_require__(380) });


/***/ },
/* 864 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(49);
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	$export($export.S, 'Object', { create: __webpack_require__(257) });


/***/ },
/* 865 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(49);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(76), 'Object', { defineProperty: __webpack_require__(80).f });


/***/ },
/* 866 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	var toIObject = __webpack_require__(90);
	var $getOwnPropertyDescriptor = __webpack_require__(258).f;
	
	__webpack_require__(383)('getOwnPropertyDescriptor', function () {
	  return function getOwnPropertyDescriptor(it, key) {
	    return $getOwnPropertyDescriptor(toIObject(it), key);
	  };
	});


/***/ },
/* 867 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(126);
	var $keys = __webpack_require__(125);
	
	__webpack_require__(383)('keys', function () {
	  return function keys(it) {
	    return $keys(toObject(it));
	  };
	});


/***/ },
/* 868 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.19 Object.setPrototypeOf(O, proto)
	var $export = __webpack_require__(49);
	$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(856).set });


/***/ },
/* 869 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(49);
	var $parseInt = __webpack_require__(853);
	// 18.2.5 parseInt(string, radix)
	$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });


/***/ },
/* 870 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var global = __webpack_require__(68);
	var has = __webpack_require__(88);
	var DESCRIPTORS = __webpack_require__(76);
	var $export = __webpack_require__(49);
	var redefine = __webpack_require__(260);
	var META = __webpack_require__(184).KEY;
	var $fails = __webpack_require__(87);
	var shared = __webpack_require__(262);
	var setToStringTag = __webpack_require__(185);
	var uid = __webpack_require__(187);
	var wks = __webpack_require__(70);
	var wksExt = __webpack_require__(267);
	var wksDefine = __webpack_require__(266);
	var enumKeys = __webpack_require__(845);
	var isArray = __webpack_require__(256);
	var anObject = __webpack_require__(86);
	var isObject = __webpack_require__(69);
	var toObject = __webpack_require__(126);
	var toIObject = __webpack_require__(90);
	var toPrimitive = __webpack_require__(264);
	var createDesc = __webpack_require__(146);
	var _create = __webpack_require__(257);
	var gOPNExt = __webpack_require__(851);
	var $GOPD = __webpack_require__(258);
	var $GOPS = __webpack_require__(259);
	var $DP = __webpack_require__(80);
	var $keys = __webpack_require__(125);
	var gOPD = $GOPD.f;
	var dP = $DP.f;
	var gOPN = gOPNExt.f;
	var $Symbol = global.Symbol;
	var $JSON = global.JSON;
	var _stringify = $JSON && $JSON.stringify;
	var PROTOTYPE = 'prototype';
	var HIDDEN = wks('_hidden');
	var TO_PRIMITIVE = wks('toPrimitive');
	var isEnum = {}.propertyIsEnumerable;
	var SymbolRegistry = shared('symbol-registry');
	var AllSymbols = shared('symbols');
	var OPSymbols = shared('op-symbols');
	var ObjectProto = Object[PROTOTYPE];
	var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
	var QObject = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function () {
	  return _create(dP({}, 'a', {
	    get: function () { return dP(this, 'a', { value: 7 }).a; }
	  })).a != 7;
	}) ? function (it, key, D) {
	  var protoDesc = gOPD(ObjectProto, key);
	  if (protoDesc) delete ObjectProto[key];
	  dP(it, key, D);
	  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
	} : dP;
	
	var wrap = function (tag) {
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};
	
	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
	  return typeof it == 'symbol';
	} : function (it) {
	  return it instanceof $Symbol;
	};
	
	var $defineProperty = function defineProperty(it, key, D) {
	  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if (has(AllSymbols, key)) {
	    if (!D.enumerable) {
	      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
	      D = _create(D, { enumerable: createDesc(0, false) });
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P) {
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P));
	  var i = 0;
	  var l = keys.length;
	  var key;
	  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P) {
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key) {
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
	  it = toIObject(it);
	  key = toPrimitive(key, true);
	  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
	  var D = gOPD(it, key);
	  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it) {
	  var names = gOPN(toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
	  var IS_OP = it === ObjectProto;
	  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
	  } return result;
	};
	
	// 19.4.1.1 Symbol([description])
	if (!USE_NATIVE) {
	  $Symbol = function Symbol() {
	    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function (value) {
	      if (this === ObjectProto) $set.call(OPSymbols, value);
	      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
	    return this._k;
	  });
	
	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f = $defineProperty;
	  __webpack_require__(381).f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(145).f = $propertyIsEnumerable;
	  $GOPS.f = $getOwnPropertySymbols;
	
	  if (DESCRIPTORS && !__webpack_require__(183)) {
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	
	  wksExt.f = function (name) {
	    return wrap(wks(name));
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });
	
	for (var es6Symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);
	
	for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);
	
	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function (key) {
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(sym) {
	    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
	    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
	  },
	  useSetter: function () { setter = true; },
	  useSimple: function () { setter = false; }
	});
	
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
	// https://bugs.chromium.org/p/v8/issues/detail?id=3443
	var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });
	
	$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
	  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
	    return $GOPS.f(toObject(it));
	  }
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it) {
	    var args = [it];
	    var i = 1;
	    var replacer, $replacer;
	    while (arguments.length > i) args.push(arguments[i++]);
	    $replacer = replacer = args[1];
	    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
	    if (!isArray(replacer)) replacer = function (key, value) {
	      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
	      if (!isSymbol(value)) return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});
	
	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(89)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);


/***/ },
/* 871 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(68);
	var each = __webpack_require__(251)(0);
	var redefine = __webpack_require__(260);
	var meta = __webpack_require__(184);
	var assign = __webpack_require__(380);
	var weak = __webpack_require__(842);
	var isObject = __webpack_require__(69);
	var validate = __webpack_require__(265);
	var NATIVE_WEAK_MAP = __webpack_require__(265);
	var IS_IE11 = !global.ActiveXObject && 'ActiveXObject' in global;
	var WEAK_MAP = 'WeakMap';
	var getWeak = meta.getWeak;
	var isExtensible = Object.isExtensible;
	var uncaughtFrozenStore = weak.ufstore;
	var InternalMap;
	
	var wrapper = function (get) {
	  return function WeakMap() {
	    return get(this, arguments.length > 0 ? arguments[0] : undefined);
	  };
	};
	
	var methods = {
	  // 23.3.3.3 WeakMap.prototype.get(key)
	  get: function get(key) {
	    if (isObject(key)) {
	      var data = getWeak(key);
	      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
	      return data ? data[this._i] : undefined;
	    }
	  },
	  // 23.3.3.5 WeakMap.prototype.set(key, value)
	  set: function set(key, value) {
	    return weak.def(validate(this, WEAK_MAP), key, value);
	  }
	};
	
	// 23.3 WeakMap Objects
	var $WeakMap = module.exports = __webpack_require__(843)(WEAK_MAP, wrapper, methods, weak, true, true);
	
	// IE11 WeakMap frozen keys fix
	if (NATIVE_WEAK_MAP && IS_IE11) {
	  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
	  assign(InternalMap.prototype, methods);
	  meta.NEED = true;
	  each(['delete', 'has', 'get', 'set'], function (key) {
	    var proto = $WeakMap.prototype;
	    var method = proto[key];
	    redefine(proto, key, function (a, b) {
	      // store frozen objects on internal weakmap shim
	      if (isObject(a) && !isExtensible(a)) {
	        if (!this._f) this._f = new InternalMap();
	        var result = this._f[key](a, b);
	        return key == 'set' ? this : result;
	      // store all the rest on native weakmap
	      } return method.call(this, a, b);
	    });
	  });
	}


/***/ },
/* 872 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(49);
	var $entries = __webpack_require__(384)(true);
	
	$export($export.S, 'Object', {
	  entries: function entries(it) {
	    return $entries(it);
	  }
	});


/***/ },
/* 873 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(49);
	var $values = __webpack_require__(384)(false);
	
	$export($export.S, 'Object', {
	  values: function values(it) {
	    return $values(it);
	  }
	});


/***/ },
/* 874 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(266)('asyncIterator');


/***/ },
/* 875 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(266)('observable');


/***/ },
/* 876 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
	__webpack_require__(854)('WeakMap');


/***/ },
/* 877 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
	__webpack_require__(855)('WeakMap');


/***/ },
/* 878 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.addMatchingCardsToResults = void 0;
	var clone_1 = __webpack_require__(392);
	var matches_1 = __webpack_require__(882);
	function addMatchingCardsToResults(cardNumber, cardConfiguration, results) {
	    var i, patternLength;
	    for (i = 0; i < cardConfiguration.patterns.length; i++) {
	        var pattern = cardConfiguration.patterns[i];
	        if (!matches_1.matches(cardNumber, pattern)) {
	            continue;
	        }
	        var clonedCardConfiguration = clone_1.clone(cardConfiguration);
	        if (Array.isArray(pattern)) {
	            patternLength = String(pattern[0]).length;
	        }
	        else {
	            patternLength = String(pattern).length;
	        }
	        if (cardNumber.length >= patternLength) {
	            clonedCardConfiguration.matchStrength = patternLength;
	        }
	        results.push(clonedCardConfiguration);
	        break;
	    }
	}
	exports.addMatchingCardsToResults = addMatchingCardsToResults;


/***/ },
/* 879 */
/***/ function(module, exports) {

	"use strict";
	var cardTypes = {
	    visa: {
	        niceType: "Visa",
	        type: "visa",
	        patterns: [4],
	        gaps: [4, 8, 12],
	        lengths: [16, 18, 19],
	        code: {
	            name: "CVV",
	            size: 3,
	        },
	    },
	    mastercard: {
	        niceType: "Mastercard",
	        type: "mastercard",
	        patterns: [[51, 55], [2221, 2229], [223, 229], [23, 26], [270, 271], 2720],
	        gaps: [4, 8, 12],
	        lengths: [16],
	        code: {
	            name: "CVC",
	            size: 3,
	        },
	    },
	    "american-express": {
	        niceType: "American Express",
	        type: "american-express",
	        patterns: [34, 37],
	        gaps: [4, 10],
	        lengths: [15],
	        code: {
	            name: "CID",
	            size: 4,
	        },
	    },
	    "diners-club": {
	        niceType: "Diners Club",
	        type: "diners-club",
	        patterns: [[300, 305], 36, 38, 39],
	        gaps: [4, 10],
	        lengths: [14, 16, 19],
	        code: {
	            name: "CVV",
	            size: 3,
	        },
	    },
	    discover: {
	        niceType: "Discover",
	        type: "discover",
	        patterns: [6011, [644, 649], 65],
	        gaps: [4, 8, 12],
	        lengths: [16, 19],
	        code: {
	            name: "CID",
	            size: 3,
	        },
	    },
	    jcb: {
	        niceType: "JCB",
	        type: "jcb",
	        patterns: [2131, 1800, [3528, 3589]],
	        gaps: [4, 8, 12],
	        lengths: [16, 17, 18, 19],
	        code: {
	            name: "CVV",
	            size: 3,
	        },
	    },
	    unionpay: {
	        niceType: "UnionPay",
	        type: "unionpay",
	        patterns: [
	            620,
	            [624, 626],
	            [62100, 62182],
	            [62184, 62187],
	            [62185, 62197],
	            [62200, 62205],
	            [622010, 622999],
	            622018,
	            [622019, 622999],
	            [62207, 62209],
	            [622126, 622925],
	            [623, 626],
	            6270,
	            6272,
	            6276,
	            [627700, 627779],
	            [627781, 627799],
	            [6282, 6289],
	            6291,
	            6292,
	            810,
	            [8110, 8131],
	            [8132, 8151],
	            [8152, 8163],
	            [8164, 8171],
	        ],
	        gaps: [4, 8, 12],
	        lengths: [14, 15, 16, 17, 18, 19],
	        code: {
	            name: "CVN",
	            size: 3,
	        },
	    },
	    maestro: {
	        niceType: "Maestro",
	        type: "maestro",
	        patterns: [
	            493698,
	            [500000, 504174],
	            [504176, 506698],
	            [506779, 508999],
	            [56, 59],
	            63,
	            67,
	            6,
	        ],
	        gaps: [4, 8, 12],
	        lengths: [12, 13, 14, 15, 16, 17, 18, 19],
	        code: {
	            name: "CVC",
	            size: 3,
	        },
	    },
	    elo: {
	        niceType: "Elo",
	        type: "elo",
	        patterns: [
	            401178,
	            401179,
	            438935,
	            457631,
	            457632,
	            431274,
	            451416,
	            457393,
	            504175,
	            [506699, 506778],
	            [509000, 509999],
	            627780,
	            636297,
	            636368,
	            [650031, 650033],
	            [650035, 650051],
	            [650405, 650439],
	            [650485, 650538],
	            [650541, 650598],
	            [650700, 650718],
	            [650720, 650727],
	            [650901, 650978],
	            [651652, 651679],
	            [655000, 655019],
	            [655021, 655058],
	        ],
	        gaps: [4, 8, 12],
	        lengths: [16],
	        code: {
	            name: "CVE",
	            size: 3,
	        },
	    },
	    mir: {
	        niceType: "Mir",
	        type: "mir",
	        patterns: [[2200, 2204]],
	        gaps: [4, 8, 12],
	        lengths: [16, 17, 18, 19],
	        code: {
	            name: "CVP2",
	            size: 3,
	        },
	    },
	    hiper: {
	        niceType: "Hiper",
	        type: "hiper",
	        patterns: [637095, 63737423, 63743358, 637568, 637599, 637609, 637612],
	        gaps: [4, 8, 12],
	        lengths: [16],
	        code: {
	            name: "CVC",
	            size: 3,
	        },
	    },
	    hipercard: {
	        niceType: "Hipercard",
	        type: "hipercard",
	        patterns: [606282],
	        gaps: [4, 8, 12],
	        lengths: [16],
	        code: {
	            name: "CVC",
	            size: 3,
	        },
	    },
	};
	module.exports = cardTypes;


/***/ },
/* 880 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.findBestMatch = void 0;
	function hasEnoughResultsToDetermineBestMatch(results) {
	    var numberOfResultsWithMaxStrengthProperty = results.filter(function (result) { return result.matchStrength; }).length;
	    /*
	     * if all possible results have a maxStrength property that means the card
	     * number is sufficiently long enough to determine conclusively what the card
	     * type is
	     * */
	    return (numberOfResultsWithMaxStrengthProperty > 0 &&
	        numberOfResultsWithMaxStrengthProperty === results.length);
	}
	function findBestMatch(results) {
	    if (!hasEnoughResultsToDetermineBestMatch(results)) {
	        return null;
	    }
	    return results.reduce(function (bestMatch, result) {
	        if (!bestMatch) {
	            return result;
	        }
	        /*
	         * If the current best match pattern is less specific than this result, set
	         * the result as the new best match
	         * */
	        if (Number(bestMatch.matchStrength) < Number(result.matchStrength)) {
	            return result;
	        }
	        return bestMatch;
	    });
	}
	exports.findBestMatch = findBestMatch;


/***/ },
/* 881 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.isValidInputType = void 0;
	function isValidInputType(cardNumber) {
	    return typeof cardNumber === "string" || cardNumber instanceof String;
	}
	exports.isValidInputType = isValidInputType;


/***/ },
/* 882 */
/***/ function(module, exports) {

	"use strict";
	/*
	 * Adapted from https://github.com/polvo-labs/card-type/blob/aaab11f80fa1939bccc8f24905a06ae3cd864356/src/cardType.js#L37-L42
	 * */
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.matches = void 0;
	function matchesRange(cardNumber, min, max) {
	    var maxLengthToCheck = String(min).length;
	    var substr = cardNumber.substr(0, maxLengthToCheck);
	    var integerRepresentationOfCardNumber = parseInt(substr, 10);
	    min = parseInt(String(min).substr(0, substr.length), 10);
	    max = parseInt(String(max).substr(0, substr.length), 10);
	    return (integerRepresentationOfCardNumber >= min &&
	        integerRepresentationOfCardNumber <= max);
	}
	function matchesPattern(cardNumber, pattern) {
	    pattern = String(pattern);
	    return (pattern.substring(0, cardNumber.length) ===
	        cardNumber.substring(0, pattern.length));
	}
	function matches(cardNumber, pattern) {
	    if (Array.isArray(pattern)) {
	        return matchesRange(cardNumber, pattern[0], pattern[1]);
	    }
	    return matchesPattern(cardNumber, pattern);
	}
	exports.matches = matches;


/***/ },
/* 883 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(24)();
	// imports
	exports.i(__webpack_require__(885), "");
	exports.i(__webpack_require__(884), "");
	exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Roboto:300,300i,400,400i,500,500i,700,700i);", ""]);
	
	// module
	exports.push([module.id, "@font-face{font-family:Pe-icon-7-stroke;src:url(" + __webpack_require__(1606) + ");src:url(" + __webpack_require__(1605) + "?#iefixd7yf1v) format(\"embedded-opentype\"),url(" + __webpack_require__(1609) + ") format(\"woff\"),url(" + __webpack_require__(1608) + ") format(\"truetype\"),url(" + __webpack_require__(1607) + "#Pe-icon-7-stroke) format(\"svg\");font-weight:400;font-style:normal}[class*=\" pe-7s-\"],[class^=pe-7s-]{display:inline-block;font-family:Pe-icon-7-stroke;speak:none;font-style:normal;font-weight:400;font-variant:normal;text-transform:none;line-height:1;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}/*! Modified from font-awesome helper CSS classes - PIXEDEN\n *  Font Awesome 4.0.3 by @davegandy - http://fontawesome.io - @fontawesome\n *  License - http://fontawesome.io/license (CSS: MIT License)\n */.pe-lg{font-size:1.33em;line-height:.75em;vertical-align:-15%}.pe-2x{font-size:2em}.pe-3x{font-size:3em}.pe-4x{font-size:4em}.pe-5x{font-size:5em}.pe-fw{width:1.2857142857142858em;text-align:center}.pe-ul{padding-left:0;margin-left:2.142857142857143em;list-style-type:none}.pe-ul>li{position:relative}.pe-li{position:absolute;left:-2.142857142857143em;width:2.142857142857143em;top:.14285714285714285em;text-align:center}.pe-li.pe-lg{left:-1.8571428571428572em}.pe-border{padding:.2em .25em .15em;border:.08em solid #eee;border-radius:.1em}.pull-right{float:right}.pe.pull-left{float:left;margin-right:.3em;margin-left:.3em}.pe-spin{animation:spin 2s infinite linear}.pe-rotate-90{filter:progid:DXImageTransform.Microsoft.BasicImage(rotation=1);transform:rotate(90deg)}.pe-rotate-180{filter:progid:DXImageTransform.Microsoft.BasicImage(rotation=2);transform:rotate(180deg)}.pe-rotate-270{filter:progid:DXImageTransform.Microsoft.BasicImage(rotation=3);transform:rotate(270deg)}.pe-flip-horizontal{filter:progid:DXImageTransform.Microsoft.BasicImage(rotation=0,mirror=1);transform:scaleX(-1)}.pe-flip-vertical{filter:progid:DXImageTransform.Microsoft.BasicImage(rotation=2,mirror=1);transform:scaleY(-1)}.pe-stack{position:relative;display:inline-block;width:2em;height:2em;line-height:2em;vertical-align:middle}.pe-stack-1x,.pe-stack-2x{position:absolute;left:0;width:100%;text-align:center}.pe-stack-1x{line-height:inherit}.pe-stack-2x{font-size:2em}.pe-inverse{color:#fff}.pe-va{vertical-align:middle}.pe-border{border:.08em solid #eaeaea}.pe-7s-album:before{content:\"\\E6AA\"}.pe-7s-arc:before{content:\"\\E6AB\"}.pe-7s-back-2:before{content:\"\\E6AC\"}.pe-7s-bandaid:before{content:\"\\E6AD\"}.pe-7s-car:before{content:\"\\E6AE\"}.pe-7s-diamond:before{content:\"\\E6AF\"}.pe-7s-door-lock:before{content:\"\\E6B0\"}.pe-7s-eyedropper:before{content:\"\\E6B1\"}.pe-7s-female:before{content:\"\\E6B2\"}.pe-7s-gym:before{content:\"\\E6B3\"}.pe-7s-hammer:before{content:\"\\E6B4\"}.pe-7s-headphones:before{content:\"\\E6B5\"}.pe-7s-helm:before{content:\"\\E6B6\"}.pe-7s-hourglass:before{content:\"\\E6B7\"}.pe-7s-leaf:before{content:\"\\E6B8\"}.pe-7s-magic-wand:before{content:\"\\E6B9\"}.pe-7s-male:before{content:\"\\E6BA\"}.pe-7s-map-2:before{content:\"\\E6BB\"}.pe-7s-next-2:before{content:\"\\E6BC\"}.pe-7s-paint-bucket:before{content:\"\\E6BD\"}.pe-7s-pendrive:before{content:\"\\E6BE\"}.pe-7s-photo:before{content:\"\\E6BF\"}.pe-7s-piggy:before{content:\"\\E6C0\"}.pe-7s-plugin:before{content:\"\\E6C1\"}.pe-7s-refresh-2:before{content:\"\\E6C2\"}.pe-7s-rocket:before{content:\"\\E6C3\"}.pe-7s-settings:before{content:\"\\E6C4\"}.pe-7s-shield:before{content:\"\\E6C5\"}.pe-7s-smile:before{content:\"\\E6C6\"}.pe-7s-usb:before{content:\"\\E6C7\"}.pe-7s-vector:before{content:\"\\E6C8\"}.pe-7s-wine:before{content:\"\\E6C9\"}.pe-7s-cloud-upload:before{content:\"\\E68A\"}.pe-7s-cash:before{content:\"\\E68C\"}.pe-7s-close:before{content:\"\\E680\"}.pe-7s-bluetooth:before{content:\"\\E68D\"}.pe-7s-cloud-download:before{content:\"\\E68B\"}.pe-7s-way:before{content:\"\\E68E\"}.pe-7s-close-circle:before{content:\"\\E681\"}.pe-7s-id:before{content:\"\\E68F\"}.pe-7s-angle-up:before{content:\"\\E682\"}.pe-7s-wristwatch:before{content:\"\\E690\"}.pe-7s-angle-up-circle:before{content:\"\\E683\"}.pe-7s-world:before{content:\"\\E691\"}.pe-7s-angle-right:before{content:\"\\E684\"}.pe-7s-volume:before{content:\"\\E692\"}.pe-7s-angle-right-circle:before{content:\"\\E685\"}.pe-7s-users:before{content:\"\\E693\"}.pe-7s-angle-left:before{content:\"\\E686\"}.pe-7s-user-female:before{content:\"\\E694\"}.pe-7s-angle-left-circle:before{content:\"\\E687\"}.pe-7s-up-arrow:before{content:\"\\E695\"}.pe-7s-angle-down:before{content:\"\\E688\"}.pe-7s-switch:before{content:\"\\E696\"}.pe-7s-angle-down-circle:before{content:\"\\E689\"}.pe-7s-scissors:before{content:\"\\E697\"}.pe-7s-wallet:before{content:\"\\E600\"}.pe-7s-safe:before{content:\"\\E698\"}.pe-7s-volume2:before{content:\"\\E601\"}.pe-7s-volume1:before{content:\"\\E602\"}.pe-7s-voicemail:before{content:\"\\E603\"}.pe-7s-video:before{content:\"\\E604\"}.pe-7s-user:before{content:\"\\E605\"}.pe-7s-upload:before{content:\"\\E606\"}.pe-7s-unlock:before{content:\"\\E607\"}.pe-7s-umbrella:before{content:\"\\E608\"}.pe-7s-trash:before{content:\"\\E609\"}.pe-7s-tools:before{content:\"\\E60A\"}.pe-7s-timer:before{content:\"\\E60B\"}.pe-7s-ticket:before{content:\"\\E60C\"}.pe-7s-target:before{content:\"\\E60D\"}.pe-7s-sun:before{content:\"\\E60E\"}.pe-7s-study:before{content:\"\\E60F\"}.pe-7s-stopwatch:before{content:\"\\E610\"}.pe-7s-star:before{content:\"\\E611\"}.pe-7s-speaker:before{content:\"\\E612\"}.pe-7s-signal:before{content:\"\\E613\"}.pe-7s-shuffle:before{content:\"\\E614\"}.pe-7s-shopbag:before{content:\"\\E615\"}.pe-7s-share:before{content:\"\\E616\"}.pe-7s-server:before{content:\"\\E617\"}.pe-7s-search:before{content:\"\\E618\"}.pe-7s-film:before{content:\"\\E6A5\"}.pe-7s-science:before{content:\"\\E619\"}.pe-7s-disk:before{content:\"\\E6A6\"}.pe-7s-ribbon:before{content:\"\\E61A\"}.pe-7s-repeat:before{content:\"\\E61B\"}.pe-7s-refresh:before{content:\"\\E61C\"}.pe-7s-add-user:before{content:\"\\E6A9\"}.pe-7s-refresh-cloud:before{content:\"\\E61D\"}.pe-7s-paperclip:before{content:\"\\E69C\"}.pe-7s-radio:before{content:\"\\E61E\"}.pe-7s-note2:before{content:\"\\E69D\"}.pe-7s-print:before{content:\"\\E61F\"}.pe-7s-network:before{content:\"\\E69E\"}.pe-7s-prev:before{content:\"\\E620\"}.pe-7s-mute:before{content:\"\\E69F\"}.pe-7s-power:before{content:\"\\E621\"}.pe-7s-medal:before{content:\"\\E6A0\"}.pe-7s-portfolio:before{content:\"\\E622\"}.pe-7s-like2:before{content:\"\\E6A1\"}.pe-7s-plus:before{content:\"\\E623\"}.pe-7s-left-arrow:before{content:\"\\E6A2\"}.pe-7s-play:before{content:\"\\E624\"}.pe-7s-key:before{content:\"\\E6A3\"}.pe-7s-plane:before{content:\"\\E625\"}.pe-7s-joy:before{content:\"\\E6A4\"}.pe-7s-photo-gallery:before{content:\"\\E626\"}.pe-7s-pin:before{content:\"\\E69B\"}.pe-7s-phone:before{content:\"\\E627\"}.pe-7s-plug:before{content:\"\\E69A\"}.pe-7s-pen:before{content:\"\\E628\"}.pe-7s-right-arrow:before{content:\"\\E699\"}.pe-7s-paper-plane:before{content:\"\\E629\"}.pe-7s-delete-user:before{content:\"\\E6A7\"}.pe-7s-paint:before{content:\"\\E62A\"}.pe-7s-bottom-arrow:before{content:\"\\E6A8\"}.pe-7s-notebook:before{content:\"\\E62B\"}.pe-7s-note:before{content:\"\\E62C\"}.pe-7s-next:before{content:\"\\E62D\"}.pe-7s-news-paper:before{content:\"\\E62E\"}.pe-7s-musiclist:before{content:\"\\E62F\"}.pe-7s-music:before{content:\"\\E630\"}.pe-7s-mouse:before{content:\"\\E631\"}.pe-7s-more:before{content:\"\\E632\"}.pe-7s-moon:before{content:\"\\E633\"}.pe-7s-monitor:before{content:\"\\E634\"}.pe-7s-micro:before{content:\"\\E635\"}.pe-7s-menu:before{content:\"\\E636\"}.pe-7s-map:before{content:\"\\E637\"}.pe-7s-map-marker:before{content:\"\\E638\"}.pe-7s-mail:before{content:\"\\E639\"}.pe-7s-mail-open:before{content:\"\\E63A\"}.pe-7s-mail-open-file:before{content:\"\\E63B\"}.pe-7s-magnet:before{content:\"\\E63C\"}.pe-7s-loop:before{content:\"\\E63D\"}.pe-7s-look:before{content:\"\\E63E\"}.pe-7s-lock:before{content:\"\\E63F\"}.pe-7s-lintern:before{content:\"\\E640\"}.pe-7s-link:before{content:\"\\E641\"}.pe-7s-like:before{content:\"\\E642\"}.pe-7s-light:before{content:\"\\E643\"}.pe-7s-less:before{content:\"\\E644\"}.pe-7s-keypad:before{content:\"\\E645\"}.pe-7s-junk:before{content:\"\\E646\"}.pe-7s-info:before{content:\"\\E647\"}.pe-7s-home:before{content:\"\\E648\"}.pe-7s-help2:before{content:\"\\E649\"}.pe-7s-help1:before{content:\"\\E64A\"}.pe-7s-graph3:before{content:\"\\E64B\"}.pe-7s-graph2:before{content:\"\\E64C\"}.pe-7s-graph1:before{content:\"\\E64D\"}.pe-7s-graph:before{content:\"\\E64E\"}.pe-7s-global:before{content:\"\\E64F\"}.pe-7s-gleam:before{content:\"\\E650\"}.pe-7s-glasses:before{content:\"\\E651\"}.pe-7s-gift:before{content:\"\\E652\"}.pe-7s-folder:before{content:\"\\E653\"}.pe-7s-flag:before{content:\"\\E654\"}.pe-7s-filter:before{content:\"\\E655\"}.pe-7s-file:before{content:\"\\E656\"}.pe-7s-expand1:before{content:\"\\E657\"}.pe-7s-exapnd2:before{content:\"\\E658\"}.pe-7s-edit:before{content:\"\\E659\"}.pe-7s-drop:before{content:\"\\E65A\"}.pe-7s-drawer:before{content:\"\\E65B\"}.pe-7s-download:before{content:\"\\E65C\"}.pe-7s-display2:before{content:\"\\E65D\"}.pe-7s-display1:before{content:\"\\E65E\"}.pe-7s-diskette:before{content:\"\\E65F\"}.pe-7s-date:before{content:\"\\E660\"}.pe-7s-cup:before{content:\"\\E661\"}.pe-7s-culture:before{content:\"\\E662\"}.pe-7s-crop:before{content:\"\\E663\"}.pe-7s-credit:before{content:\"\\E664\"}.pe-7s-copy-file:before{content:\"\\E665\"}.pe-7s-config:before{content:\"\\E666\"}.pe-7s-compass:before{content:\"\\E667\"}.pe-7s-comment:before{content:\"\\E668\"}.pe-7s-coffee:before{content:\"\\E669\"}.pe-7s-cloud:before{content:\"\\E66A\"}.pe-7s-clock:before{content:\"\\E66B\"}.pe-7s-check:before{content:\"\\E66C\"}.pe-7s-chat:before{content:\"\\E66D\"}.pe-7s-cart:before{content:\"\\E66E\"}.pe-7s-camera:before{content:\"\\E66F\"}.pe-7s-call:before{content:\"\\E670\"}.pe-7s-calculator:before{content:\"\\E671\"}.pe-7s-browser:before{content:\"\\E672\"}.pe-7s-box2:before{content:\"\\E673\"}.pe-7s-box1:before{content:\"\\E674\"}.pe-7s-bookmarks:before{content:\"\\E675\"}.pe-7s-bicycle:before{content:\"\\E676\"}.pe-7s-bell:before{content:\"\\E677\"}.pe-7s-battery:before{content:\"\\E678\"}.pe-7s-ball:before{content:\"\\E679\"}.pe-7s-back:before{content:\"\\E67A\"}.pe-7s-attention:before{content:\"\\E67B\"}.pe-7s-anchor:before{content:\"\\E67C\"}.pe-7s-albums:before{content:\"\\E67D\"}.pe-7s-alarm:before{content:\"\\E67E\"}.pe-7s-airplay:before{content:\"\\E67F\"}.global-modal{width:100%;height:100%;display:none;position:fixed;top:0;left:0;z-index:999;text-align:left;background:rgba(0,0,0,.7)}.global-modal.show-modal{display:block}.global-modal .modal-close-button{position:absolute;top:30px;right:30px;color:#fff;font-size:30px;cursor:pointer}.global-modal .global-modal-title{border-bottom:1px solid #e1e1e1;padding-bottom:10px;color:#000;font-size:24px;font-weight:500}.global-modal .global-modal-content{width:100%;padding-top:20px;display:table}.global-modal .modal-form-row{width:100%;margin-top:20px;display:table}.global-modal .modal-form-row:first-child{margin-top:0}.global-modal .modal-form-label{margin-bottom:5px;display:block;color:#000;font-size:13px;font-weight:400}.global-modal .form-input{width:100%;height:40px;border:1px solid #e1e1e1;padding:0 10px;color:#000;font-size:13px;background-color:#fff;transition:all .3s ease-in-out}.global-modal .form-input:focus{border-color:#000}@media (max-width:767px){.global-modal .modal-close-button{top:15px;right:10px}}.user-login-modal,.user-signup-modal{width:600px;margin-left:-300px;padding:20px 30px;position:absolute;top:150px;left:50%;background:#fff}@media (max-width:767px){.user-login-modal,.user-signup-modal{width:94%;margin-left:0;padding:15px;top:50px;left:3%}}.modal-links{color:#ffa100}@media (max-width:767px){.modal-form-top-space{margin-top:15px}}.header-menu-dropdown{width:100%;height:100%;position:fixed;top:0;left:0;z-index:999;background:rgba(0,0,0,.8)}.header-menu-dropdown .header-menu-close{position:absolute;top:10px;right:10px;color:#fff;font-size:24px}.header-menu-dropdown .header-menu-holder{width:88%;height:100%;position:relative;background:#fff}.footer-section{flex-shrink:0}.footer-section .footer-container{border:1px solid transparent;border-top:2px solid #dcccae;border-bottom:0!important;margin-bottom:0!important;position:relative;min-height:50px;display:block}.footer-section .footer-container .links-block{background-color:#000;padding-top:10px;padding-bottom:35px}.footer-section .footer-container .links-block .health-message{display:flex;flex-direction:column;justify-content:center;align-items:center;color:#dcccae;padding-bottom:15px}@media (max-width:991px){.footer-section .footer-container .links-block{padding-top:10px;padding-bottom:25px}}.footer-section .footer-container .links-block .column{text-align:center;color:#dcccae}@media (max-width:991px){.footer-section .footer-container .links-block .column{margin-top:15px}}.footer-section .footer-container .links-block .column .column-inner{display:inline-block;text-align:left}.footer-section .footer-container .links-block .column .column-inner .title{font-family:Lato Bold,serif;text-transform:uppercase;line-height:24px;letter-spacing:.7px;margin-bottom:10px;border-left:1px solid #dcccae;padding-left:15px;margin-left:-15px}@media (max-width:991px){.footer-section .footer-container .links-block .column .column-inner .title.title-xs{height:28px;position:relative;display:inline-block;top:-6px;margin-right:20px}}.footer-section .footer-container .links-block .column .column-inner .list-unstyled{font-family:Lato Light,serif;font-size:16px}.footer-section .footer-container .links-block .column .column-inner .list-unstyled a{color:#fff}.footer-section .footer-container .links-block .column .column-inner .list-unstyled a:hover{color:#dcccae}.footer-section .footer-container .links-block .column .column-inner .list-unstyled.share{text-align:center;height:28px;margin:0 0 0 -11px;line-height:28px}.footer-section .footer-container .links-block .column .column-inner .list-unstyled.share .social-net{width:32px;height:28px;position:relative;display:inline-block}.footer-section .footer-container .links-block .column .column-inner .list-unstyled.share .social-net a{position:absolute;top:0;bottom:0;left:0;right:0}.footer-section .footer-container .links-block .column .column-inner .list-unstyled.share .social-net a:hover{bottom:-9px;border-bottom:1px solid #dcccae;transition:none}.footer-section .footer-container .links-block .column .column-inner .list-unstyled.share .social-net a:hover i path{fill:#dcccae}.footer-section .footer-container .links-block .column .column-inner .list-unstyled.share .social-net a i{width:20px;height:100%;display:block;margin:0 auto}.footer-section .footer-container .links-block .column .column-inner .list-unstyled.share .social-net a i.icon-facebook{width:9px}.footer-section .footer-container .links-block .column .column-inner .list-unstyled.share .social-net a i.icon-instagram{width:15px}.footer-section .footer-container .links-block .column .column-inner .list-unstyled.share .social-net a i.icon-whatsapp{width:17px}.footer-section .footer-container .links-block .column .column-inner .list-unstyled.share .social-net a i svg{vertical-align:middle}.footer-section .footer-container .links-block .column .column-inner .list-unstyled.share .social-net a i svg path{fill:#4e4e4e}.footer-section .footer-container .links-block .margin-top-50{margin-top:50px!important}.footer-section .footer-container .links-block .list-inline{margin-left:0;display:flex;flex-flow:row;justify-content:center}.footer-section .footer-container .links-block .list-inline li{margin-right:30px}.footer-section .footer-container .links-block .list-inline li:last-child{margin-right:0}@media (max-width:991px){.footer-section .footer-container .links-block .list-inline li{margin-right:20px}}@media (max-width:480px){.footer-section .footer-container .links-block .list-inline li{margin-right:0}}.footer-section .footer-container .links-block .list-inline li img{height:30px;width:auto}@media (max-width:480px){.footer-section .footer-container .links-block .list-inline li img{height:26px}}.footer-section .footer-container .mini-footer-block{height:24px;position:relative!important;text-align:center}.footer-section .footer-container .mini-footer-block .primary-brand{background-color:#68583c;width:23%;height:100%}@media (max-width:991px){.footer-section .footer-container .mini-footer-block .primary-brand{width:4%}}@media (max-width:480px){.footer-section .footer-container .mini-footer-block .primary-brand{width:1%}}.footer-section .footer-container .mini-footer-block .break-left{float:left;border:12px solid #68583c;border-bottom-color:#000;border-right-color:#000}@media (max-width:479px){.footer-section .footer-container .mini-footer-block .break-left{display:none}}.footer-section .footer-container .mini-footer-block .break-right{float:left;border:12px solid transparent;border-top-color:#000;border-left-color:#000}@media (max-width:479px){.footer-section .footer-container .mini-footer-block .break-right{display:none}}.footer-section .footer-container .mini-footer-block .secondary-brand{background-color:#b18433;width:100%;height:100%}.footer-section .footer-container .mini-footer-block .copyright{top:0;bottom:0;left:0;right:0;line-height:24px;position:absolute!important}.footer-section .footer-container .mini-footer-block .copyright p{font-family:Arial,serif;text-align:center;font-size:12px;margin:0;color:#000}@media (min-width:480px){.footer-section .footer-container .mini-footer-block .copyright p{font-size:14px}}.progress-tracker{display:flex;margin:20px auto;padding:0;list-style:none}.progress-step{flex:1 1 0%;margin:0;padding:0;min-width:24px}.progress-step:last-child{flex-grow:0}.progress-step:last-child .progress-marker:after{display:none}.progress-link,.progress-marker{display:block;position:relative}.progress-marker:before{content:attr(data-text);display:flex;justify-content:center;align-items:center;position:relative;width:24px;height:24px;padding-bottom:2px;border-radius:50%;transition:background-color,border-color;transition-duration:.3s}.progress-marker:after{content:\"\";display:block;position:absolute;z-index:-10;top:10px;right:-12px;width:100%;height:4px;transition:background-color .3s,background-position .3s}.progress-text{display:block;padding:8px;overflow:hidden;text-overflow:ellipsis}.progress-title{margin-top:0}.progress-step .progress-marker{color:#fff}.progress-step .progress-marker:after,.progress-step .progress-marker:before{background-color:#b6b6b6}.progress-step .progress-text{color:#fff}@media (max-width:500px){.progress-step{text-align:-webkit-center;text-align:-moz-center}.progress-step .progress-text{padding-left:0;padding-right:0}.progress-step.is-active .progress-text{width:fit-content;width:-moz-fit-content}.progress-step:not(.is-active) .progress-text{display:none}}.progress-step.is-active .progress-marker:before{background-color:#494747}.progress-step.is-complete .progress-marker:before,.progress-step.is-progress .progress-marker:before{background-color:#dcccae}.progress-step.is-complete .progress-marker:after,.progress-step.is-progress .progress-marker:after{background-color:#868686}.progress-step.is-progress-10 .progress-marker:after{background-image:linear-gradient(90deg,#868686 10%,#b6b6b6 0)}.progress-step.is-progress-20 .progress-marker:after{background-image:linear-gradient(90deg,#868686 20%,#b6b6b6 0)}.progress-step.is-progress-30 .progress-marker:after{background-image:linear-gradient(90deg,#868686 30%,#b6b6b6 0)}.progress-step.is-progress-40 .progress-marker:after{background-image:linear-gradient(90deg,#868686 40%,#b6b6b6 0)}.progress-step.is-progress-50 .progress-marker:after{background-image:linear-gradient(90deg,#868686 50%,#b6b6b6 0)}.progress-step.is-progress-60 .progress-marker:after{background-image:linear-gradient(90deg,#868686 60%,#b6b6b6 0)}.progress-step.is-progress-70 .progress-marker:after{background-image:linear-gradient(90deg,#868686 70%,#b6b6b6 0)}.progress-step.is-progress-80 .progress-marker:after{background-image:linear-gradient(90deg,#868686 80%,#b6b6b6 0)}.progress-step.is-progress-90 .progress-marker:after{background-image:linear-gradient(90deg,#868686 90%,#b6b6b6 0)}.progress-step:hover .progress-marker:before{background-color:#b18433}.progress-tracker--center .progress-step:last-child,.progress-tracker--right .progress-step:last-child,.progress-tracker--text .progress-step:last-child{flex-grow:1}.progress-tracker--center{text-align:center}.progress-tracker--center .progress-marker:before,.progress-tracker--center .progress-text--dotted:before{margin-left:auto;margin-right:auto}.progress-tracker--center .progress-marker:after{right:-50%}.progress-tracker--right{text-align:right}.progress-tracker--right .progress-marker:before,.progress-tracker--right .progress-text--dotted:before{margin-left:auto}.progress-tracker--right .progress-marker:after{right:calc(-100% + 12px)}.progress-tracker--spaced .progress-marker:after{width:calc(100% - 40px);margin-left:20px;margin-right:20px}.progress-tracker--border{padding:4px;border:2px solid #fff;border-radius:32px}.progress-tracker--theme-red .progress-step .progress-marker{color:#fff}.progress-tracker--theme-red .progress-step .progress-marker:after,.progress-tracker--theme-red .progress-step .progress-marker:before{background-color:#666}.progress-tracker--theme-red .progress-step .progress-text{color:#fff}@media (max-width:500px){.progress-tracker--theme-red .progress-step{text-align:-webkit-center;text-align:-moz-center}.progress-tracker--theme-red .progress-step .progress-text{padding-left:0;padding-right:0}.progress-tracker--theme-red .progress-step.is-active .progress-text{width:fit-content;width:-moz-fit-content}.progress-tracker--theme-red .progress-step:not(.is-active) .progress-text{display:none}}.progress-tracker--theme-red .progress-step.is-active .progress-marker:before{background-color:#a62d24}.progress-tracker--theme-red .progress-step.is-complete .progress-marker:before{background-color:#d93b30}.progress-tracker--theme-red .progress-step.is-complete .progress-marker:after{background-color:#333}.progress-tracker--theme-red .progress-step:hover .progress-marker:before{background-color:#df7b74}.progress-text--dotted:before{content:\"\";display:block;width:12px;height:12px;margin:6px -2px;background-size:12px 18px;background-image:repeating-radial-gradient(circle at center 6px,#b6b6b6,#b6b6b6 5px,hsla(0,0%,71%,.5) 5.5px,hsla(0,0%,71%,.01) 6px,transparent 100%)}.progress-text--dotted-1:before{height:12px}.progress-text--dotted-2:before{height:30px}.progress-text--dotted-3:before{height:48px}.progress-text--dotted-4:before{height:66px}.progress-text--dotted-5:before{height:84px}.progress-text--dotted-6:before{height:102px}.progress-text--dotted-7:before{height:120px}.progress-text--dotted-8:before{height:138px}.progress-text--dotted-9:before{height:156px}.progress-text--dotted-10:before{height:174px}.progress-text--dotted-11:before{height:192px}.progress-text--dotted-12:before{height:210px}.progress-tracker--text-top .progress-text{height:100%}.progress-tracker--text-top .progress-marker{top:-24px}.progress-tracker--text-inline{overflow:hidden}.progress-tracker--text-inline .progress-marker,.progress-tracker--text-inline .progress-step{display:flex;align-items:center}.progress-tracker--text-inline .progress-marker{flex-grow:1}.progress-tracker--text-inline .progress-marker:after{top:auto}.progress-tracker--text-inline .progress-text{position:relative;z-index:30;max-width:70%;white-space:nowrap;padding-top:0;padding-bottom:0;background-color:#fff}.progress-tracker--text-inline .progress-marker .progress-text{display:inline-block}.progress-tracker--text-inline .progress-title{margin:0}.progress-tracker--square .progress-marker:before{border-radius:0}.progress-tracker--square .progress-marker:after{top:auto;bottom:0}@media (max-width:575px){.progress-tracker-wrapper{overflow-x:auto;scroll-snap-type:x proximity}.progress-tracker-wrapper .progress-step{min-width:50%;scroll-snap-align:start}}.progress-tracker--vertical{flex-direction:column}.progress-tracker--vertical .progress-step{display:flex;flex:1 1 auto}.progress-tracker--vertical.progress-tracker--right .progress-step{flex-direction:row-reverse}.progress-tracker--vertical .progress-marker:after{right:auto;top:12px;left:10px;width:4px;height:100%}.progress-tracker--vertical .progress-text{padding:0 12px 24px}@keyframes scale-up{0%{opacity:1;transform:translate(-50%,-50%) scale(0)}to{opacity:0;transform:translate(-50%,-50%) scale(1)}}.anim-ripple-large .progress-link:before,.anim-ripple-splash .progress-link:before,.anim-ripple .progress-link:before{content:\"\";display:block;width:24px;height:24px;position:absolute;top:12px;left:12px;z-index:30;background:rgba(0,0,0,.3);border-radius:50%;transform:translate(-50%,-50%) scale(0);visibility:hidden}.anim-ripple-large .progress-link:not(:active):before,.anim-ripple-splash .progress-link:not(:active):before,.anim-ripple .progress-link:not(:active):before{animation:scale-up .3s ease-out}.anim-ripple-large .progress-link:focus:before,.anim-ripple-splash .progress-link:focus:before,.anim-ripple .progress-link:focus:before{visibility:visible}.anim-ripple-double.progress-tracker--center .progress-link:after,.anim-ripple-double.progress-tracker--center .progress-link:before,.anim-ripple-large.progress-tracker--center .progress-link:after,.anim-ripple-large.progress-tracker--center .progress-link:before,.anim-ripple-splash.progress-tracker--center .progress-link:after,.anim-ripple-splash.progress-tracker--center .progress-link:before,.anim-ripple.progress-tracker--center .progress-link:after,.anim-ripple.progress-tracker--center .progress-link:before,.progress-tracker--center .anim-ripple-double .progress-link:after,.progress-tracker--center .anim-ripple-double .progress-link:before,.progress-tracker--center .anim-ripple-large .progress-link:after,.progress-tracker--center .anim-ripple-large .progress-link:before,.progress-tracker--center .anim-ripple-splash .progress-link:after,.progress-tracker--center .anim-ripple-splash .progress-link:before,.progress-tracker--center .anim-ripple .progress-link:after,.progress-tracker--center .anim-ripple .progress-link:before{left:50%}.anim-ripple-double.progress-tracker--right .progress-link:after,.anim-ripple-double.progress-tracker--right .progress-link:before,.anim-ripple-large.progress-tracker--right .progress-link:after,.anim-ripple-large.progress-tracker--right .progress-link:before,.anim-ripple-splash.progress-tracker--right .progress-link:after,.anim-ripple-splash.progress-tracker--right .progress-link:before,.anim-ripple.progress-tracker--right .progress-link:after,.anim-ripple.progress-tracker--right .progress-link:before,.progress-tracker--right .anim-ripple-double .progress-link:after,.progress-tracker--right .anim-ripple-double .progress-link:before,.progress-tracker--right .anim-ripple-large .progress-link:after,.progress-tracker--right .anim-ripple-large .progress-link:before,.progress-tracker--right .anim-ripple-splash .progress-link:after,.progress-tracker--right .anim-ripple-splash .progress-link:before,.progress-tracker--right .anim-ripple .progress-link:after,.progress-tracker--right .anim-ripple .progress-link:before{left:calc(100% - 12px)}.anim-ripple-splash .progress-link:before{width:48px;height:48px;box-shadow:0 0 6px 6px rgba(0,0,0,.35)}.anim-ripple-double .progress-link:after,.anim-ripple-double .progress-link:before{content:\"\";display:block;width:24px;height:24px;position:absolute;top:12px;left:12px;z-index:30;background:rgba(0,0,0,.3);border-radius:50%;transform:translate(-50%,-50%) scale(0);visibility:hidden;background:none;border:3px solid rgba(0,0,0,.3)}.anim-ripple-double .progress-link:not(:active):after,.anim-ripple-double .progress-link:not(:active):before{animation:scale-up .3s ease-out 0s}.anim-ripple-double .progress-link:not(:active):after{animation-delay:.15s}.anim-ripple-double .progress-link:focus:after,.anim-ripple-double .progress-link:focus:before{visibility:visible}.anim--large .progress-link:after,.anim--large .progress-link:before{width:48px;height:48px}.anim--path .progress-marker:after{background-image:linear-gradient(90deg,#b6b6b6 50%,#868686 0);background-size:200% 100%;background-position:0 100%;transition:background-position .3s ease-out}.anim--path .progress-step.is-complete .progress-marker:after,.progress-step.is-complete .anim--path .progress-marker:after{background-position:-100% 100%}[dir=rtl] .progress-marker:after{right:auto;left:-12px}[dir=rtl] .progress-tracker--center .progress-marker:after{left:-50%}.rccs{-webkit-backface-visibility:hidden}@media (max-width:380px){.rccs{transform:scale(.8)}}.rccs__card--front{-webkit-backface-visibility:hidden}.rccs__card--back,.rccs__card--front{border-radius:14.5px!important}.productShow{display:block}.productShow .productContent{height:auto;position:relative}.productShow .productContainer{padding-top:10px;padding-bottom:40px}.productShow .breadcrumbContent{font-family:Lato!important}.productShow .productResume{padding:15px;margin-top:20px;background-color:#fff;display:block;min-height:540px}.productShow .imgMain,.productShow .overlay{position:relative}.productShow .loadingHolder{position:absolute;width:100%;margin-top:120px}.productShow .loadingText{text-align:center!important;font-family:Lato Bold!important;font-size:18px;font-weight:700!important;margin-top:8.5px;margin-bottom:8.5px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;line-height:1.1;color:inherit}.productShow .mainImage{width:100%;height:374px;display:flex;justify-content:center}.productShow .mainImage img{max-width:444px}.productShow .productMainImage{width:100%;min-height:400px;height:374px;display:block;vertical-align:middle}.productShow .zoomHolder{display:block;position:absolute;z-index:10!important;background-color:rgba(0,0,0,.06);top:10px;right:10px;color:#18396c;padding:5px 7px;border-radius:50%!important;cursor:pointer}@media (max-width:991px){.productShow .zoomHolder{display:none}}.productShow .zoomHolder:hover{background-color:rgba(0,0,0,.1)}.productShow .zoomHolder:hover i{color:#d3af71}.productShow .zoomHolder i{font-size:16px;font-weight:700}.productShow .zoomHolder i:before{position:relative;top:1px}.productShow .zoomActived{background-color:rgba(0,0,0,.2)}.productShow .imgLoadingContainer{position:absolute;text-align:center;font-family:Lato Light,Enriqueta,Helvetica Neue,Helvetica,Arial,sans-serif;font-size:14px;top:50%;left:50%;transform:translate(-50%,-50%)}.productShow .resume{padding-right:0!important}.productShow .form{height:auto;display:block;margin-top:0;color:#000}.productShow .form a:hover{color:#b18433}.productShow .productName{font-family:Lato Bold!important;font-size:30px;font-weight:700!important;margin-top:17px;margin-bottom:8.5px;padding-right:15px!important;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;line-height:1.1;color:inherit}.productShow .flexDisplay{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;padding-right:15px!important}.productShow .firstCommentLink{color:#d3af71!important;font-size:16px!important;font-family:Lato Bold!important;background-color:transparent!important;transition:color .15s ease-out,background-color .15s ease-out;cursor:pointer;text-decoration:none}.productShow .reviewCount{font-family:Lato Light!important;font-weight:600;font-size:16px!important;margin:0 0 8.5px;margin-bottom:5px!important}.productShow .margins{margin-left:5px!important;margin-right:5px!important}.productShow .productRating{margin-right:20px!important;float:left!important}.productShow .ratingDirective{display:inline-block;margin:0}.productShow .noPadding{padding:0!important}.productShow .ratingHolder{position:relative}.productShow .ratings{position:relative;vertical-align:middle;display:inline-block;color:#ababab;overflow:hidden}.productShow .emptyStars:before{-webkit-text-stroke:1px #ababab;content:\"\\2605\\2605\\2605\\2605\\2605\";font-size:16pt}.productShow .fullStars{position:absolute;left:0;top:0;white-space:nowrap;overflow:hidden;color:#ffa100}.productShow .fullStars:before{-webkit-text-stroke:1px #ffa100;content:\"\\2605\\2605\\2605\\2605\\2605\";font-size:16pt}.productShow .separator{margin-bottom:10px;border-top:1px solid #dfe1e1}.productShow .priceDetails{padding-right:15px!important}.productShow .priceP{min-height:20px;position:relative!important;margin:0 0 8.5px}.productShow .propertyTitle{font-family:Lato Bold;font-size:12px;text-transform:uppercase;line-height:2;letter-spacing:.6px}.productShow .price{font-size:20px;font-family:Lato Bold;font-weight:700;color:#000;line-height:.9;margin-left:25px!important}.productShow .askQuestion{font-family:Lato Bold;top:4px;color:#5d5d5d;background-color:transparent!important;transition:color .15s ease-out,background-color .15s ease-out;cursor:pointer}.productShow .askQuestion a{color:#d3af71!important}.productShow .askQuestion a:hover{color:#fe9f03!important}.productShow .inStock{padding-right:15px!important;padding-bottom:10px!important}.productShow .outStock{color:#cb3234}.productShow .estimatedArrivalTime{font-family:Lato Light!important;font-weight:600}.productShow .itemDetails{position:relative;margin-top:18px;margin-bottom:10px;padding-right:15px!important}.productShow .itemDetails p{font-family:Lato Light!important;font-weight:600}.productShow .itemDetailsContent{white-space:pre-wrap}.productShow .itemDetailsContent b,.productShow .itemDetailsContent strong{font-family:Lato Bold}.productShow .itemDetailsTitle{font-family:Lato Bold;font-size:12px;text-transform:uppercase;line-height:2;letter-spacing:.6px;color:#d3af71!important;margin-bottom:5px!important;text-decoration:none}.productShow .itemDetailsTitle:focus,.productShow .itemDetailsTitle:hover{color:#5d5d5d!important}.productShow .listInline{list-style:none;margin:0;padding:0}.productShow .listInline li{display:inline-block;padding-left:5px;padding-right:5px}.productShow .listInline li img{vertical-align:middle;-o-object-fit:contain;object-fit:contain;o-object-fit:contain}.productShow .imageWrapper{position:relative;padding:0;-ms-touch-action:pan-y;touch-action:pan-y;background:#fff;max-width:100%;margin-bottom:0;box-shadow:none;border:0}.productShow .imageViewport{width:100%;position:relative;height:374px;min-height:256px;transition:height .15s ease}.productShow .imageSlider{position:relative;transition-duration:0s;height:374px;margin:0;padding:0;list-style:none;display:flex;flex-flow:row}.productShow .imageSlider li{float:left;list-style:none;position:relative;height:100%}.productShow .image{margin:auto;height:100%;-o-object-fit:contain;object-fit:contain;min-height:185px;max-width:100%;width:100%;vertical-align:middle;display:flex;justify-content:center;align-items:center;transition:all 1s ease-in-out;opacity:0;-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\";filter:alpha(opacity=0)}.productShow .image img{width:0!important}.productShow .activeImage{opacity:1;-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=1)\";filter:alpha(opacity=1)}.productShow .activeImage img{width:auto!important}.productShow .thumbnailContainer{padding:0}.productShow .thumbnail{display:block;padding:0;line-height:1.42857143;background-color:#fff;border:1px solid #edf0f7;transition:border .2s ease-in-out;cursor:pointer;margin:1px}.productShow .thumbnail:hover{border:1px solid #969bb3}.productShow .productThumbs{object-fit:contain;width:100%;height:140px}.cart-section{padding:30px 0}.cart-section .cart-section-heading{font-family:Lato Bold;font-size:21px;font-weight:700;line-height:24px;color:#b18433;text-align:center;margin-bottom:15px;margin-top:0!important}.cart-section .cart-contact-block{padding-top:10px;float:right;font-size:13px}.cart-section .cart-items-section{margin-top:20px;overflow:hidden}.cart-section .shipping-address-problems{margin-top:20px;background-color:#b18433;padding:6px 8px;border-radius:10px;color:#fff;font-weight:700;font-size:16px;width:max-content}.cart-section .shipping-address-problems i{margin-right:5px;vertical-align:text-bottom}@media (max-width:991px){.cart-section .shipping-address-problems{width:100%;margin-left:5px}}@media (max-width:991px){.cart-section .cart-table-info ul li{display:block;width:100%;margin-bottom:10px}}.cart-section .cart-table-info .cart-list-inline-button{padding:5px 20px;font-family:Lato Bold;font-size:11px;color:#fff;height:24px;text-transform:uppercase;background-color:transparent;border:1px solid #fff;transition:color .15s ease-out,background-color .15s ease-out,border-color .15s ease-out;cursor:pointer;display:inline-block}.cart-section .cart-table-info .cart-list-inline-button:active,.cart-section .cart-table-info .cart-list-inline-button:focus,.cart-section .cart-table-info .cart-list-inline-button:hover{border-color:#dcccae;color:#dcccae}@media (max-width:991px){.cart-section .cart-table-info .cart-list-inline-button{width:80%}}.cart-section .footer-table{margin:0;background-color:#eee;border-bottom:2px solid #dfe1e1;padding:10px}.cart-section .footer-table .subtotal-title{font-family:Lato Bold;font-size:14px;text-transform:uppercase;padding:10px 0}.cart-section .footer-table .result{font-family:Lato Bold;font-weight:700;font-size:16px}.cart-items-table{width:100%;max-width:100%;margin-bottom:17px;border:2px solid #dfe1e1}.cart-items-table .cart-items-table-title{font-family:Lato Bold;text-transform:uppercase;padding:6px 0;margin:0;background-color:#eee;border-bottom:2px solid #dfe1e1}.cart-items-table .cart-items-table-title i{color:#b18433;font-size:20px;vertical-align:sub;line-height:25px}.cart-items-table .cart-items-table-title .cart-items-table-title-text span{margin:0 5px;font-size:14px}.cart-items-table .cart-table-title-right{font-family:Lato Bold;line-height:25px;font-size:13px}.cart-items-table .cart-store-title{color:#b18433;background-color:#fff;margin:auto;padding-left:20px;font-size:18px;font-weight:700;font-family:Lato;line-height:50px}.cart-items-table .card-horizontal-holder{background-color:#fff;margin:0;border-bottom:2px solid #dfe1e1}@media (max-width:991px){.cart-items-table .card-horizontal-holder .row{display:flex;margin-bottom:4px}}.cart-items-table .card-horizontal-holder .left{display:-ms-flexbox;display:flex}.cart-items-table .card-horizontal-holder .left .image-product a{position:relative;background-color:transparent!important;transition:color .15s ease-out,background-color .15s ease-out;cursor:pointer}.cart-items-table .card-horizontal-holder .left .image-product a:active,.cart-items-table .card-horizontal-holder .left .image-product a:focus,.cart-items-table .card-horizontal-holder .left .image-product a:hover{color:#d3af71;text-decoration:none}.cart-items-table .card-horizontal-holder .left .image-product a img{height:auto;position:relative;top:50%;transform:translateY(-50%);width:100%;-o-object-fit:contain;object-fit:contain;o-object-fit:contain;vertical-align:middle;border:0}.cart-items-table .card-horizontal-holder .left .image-product .discount{font-family:Lato Bold;line-height:1;background-color:#d3af71;color:#fff;display:inline;position:absolute;top:5px;right:5px;padding:8px 10px;letter-spacing:.9px;border-radius:20px}.cart-items-table .card-horizontal-holder .left .info-product .product-name h3{font-family:Lato Bold;margin-top:20px;font-size:18px;font-weight:700;line-height:1.1;color:inherit;color:#000;transition:color .15s ease}.cart-items-table .card-horizontal-holder .left .info-product .product-name h3:active,.cart-items-table .card-horizontal-holder .left .info-product .product-name h3:focus,.cart-items-table .card-horizontal-holder .left .info-product .product-name h3:hover{color:#9e937e}.cart-items-table .card-horizontal-holder .left .info-product .product-description p{font-family:Lato;font-weight:400;font-size:14px;margin-top:8.5px;margin-bottom:8.5px;line-height:1.1;color:#969bb3}.cart-items-table .card-horizontal-holder .cart-item-price-col,.cart-items-table .card-horizontal-holder .cart-item-subtotal-col{font-family:Lato Bold;font-size:18px;font-weight:700;line-height:1.6;margin-top:15px}.cart-items-table .card-horizontal-holder .cart-item-subtotal-col{color:#000}.cart-items-table .card-horizontal-holder .btn-action-holder{margin:20px 0 0}.cart-items-table .card-horizontal-holder .cart-delete-button,.cart-items-table .card-horizontal-holder .cart-delete-button-small{cursor:pointer;background-color:#fff!important;padding:0 8px;display:inline-block;border:0!important;transition:color .15s ease-out,background-color .15s ease-out,border-color .15s ease-out}.cart-items-table .card-horizontal-holder .cart-delete-button-small i,.cart-items-table .card-horizontal-holder .cart-delete-button i{color:#b18433;font-size:23px}.cart-items-table .card-horizontal-holder .cart-delete-button-small:disabled i,.cart-items-table .card-horizontal-holder .cart-delete-button:disabled i{color:#706f6d}.cart-items-table .card-horizontal-holder .cart-delete-button-small i{font-size:medium}.cart-items-table .card-horizontal-holder .quantity-prods{display:-ms-flexbox;display:flex}.cart-items-table .card-horizontal-holder .quantity-prods .selector-quantity{margin-top:17px;position:relative}.cart-items-table .card-horizontal-holder .quantity-prods .selector-quantity .minus,.cart-items-table .card-horizontal-holder .quantity-prods .selector-quantity .plus{display:inline-block;background-color:transparent;border:1px solid #dfe1e1;transition:color .15s ease-out,background-color .15s ease-out,border-color .15s ease-out;height:28px;width:28px;font-size:30px;padding:0;line-height:0;cursor:pointer;text-transform:none;position:absolute}.cart-items-table .card-horizontal-holder .quantity-prods .selector-quantity .minus[disabled],.cart-items-table .card-horizontal-holder .quantity-prods .selector-quantity .plus[disabled]{cursor:not-allowed;pointer-events:none;background-color:#cccfce!important;border:none!important;color:#fff}.cart-items-table .card-horizontal-holder .quantity-prods .selector-quantity .minus{border-right:0!important;left:-28px}.cart-items-table .card-horizontal-holder .quantity-prods .selector-quantity .plus{border-left:0!important;right:-78px}.cart-items-table .card-horizontal-holder .quantity-prods .selector-quantity .quantity-container{display:inline-block;position:absolute;top:0}.cart-items-table .card-horizontal-holder .quantity-prods .selector-quantity .quantity-container input{margin:0;border-radius:0!important;text-align:center;width:50px;height:28px;font-size:14px;font-weight:700;padding:0;font-family:Lato;background-color:#fff;border:1px solid #dfe1e1;color:#5d5d5d;display:block;transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out}.cart-items-table .card-horizontal-holder .quantity-prods .selector-quantity .quantity-container input:hover{border-color:#cccfce}.cart-items-table .card-horizontal-holder .shipping-address-problems-item-container{display:flex;flex-direction:row-reverse}.cart-items-table .card-horizontal-holder .shipping-address-problems-item-container .shipping-address-problems-item{margin:5px;background-color:#b18433;padding:4px 6px;border-radius:6px;color:#fff;font-weight:700;width:fit-content}.cart-items-table .line-item{border-top:1px solid #e1e1e1}.cart-items-table .line-item:nth-child(2n){background:#f7f7f9}.cart-items-table .cart-img-block{text-align:center}.cart-items-table .cart-item-details{padding-top:10px}.cart-items-table .cart-item-title{font-size:18px;font-weight:600}.cart-items-table .cart-item-description{margin-top:8px;font-size:13px;font-weight:300}.cart-items-table .cart-item-qty-input{width:50px;height:30px;padding:0 5px;vertical-align:top}.cart-buttons-row{margin-top:30px;border-top:1px solid #e1e1e1;padding-top:20px}.cart-buttons-row .button-primary{margin-left:20px}@media (max-width:991px){.cart-buttons-row .button-primary{margin-right:20px}}.cart-buttons-row .button-primary:first-child{margin-left:0}.cart-button-with-glyph span.glyphicon{position:absolute;top:8px;left:10px}.cart-button-with-glyph span+span{padding-left:12px}.cart-empty-block{margin-top:20px}.cart-empty-block .cart-empty-text{font-family:Lato Bold!important;font-weight:700!important;color:#fff}.cart-empty-block .button-corner-inverter{color:#fff!important;background-color:#b18433!important;border:none}.cart-empty-block .button-corner-inverter:active,.cart-empty-block .button-corner-inverter:focus,.cart-empty-block .button-corner-inverter:hover{background-color:#9e937e!important;color:#fff!important}.cart-items-section .button-primary:hover{color:#000!important;background:#fff!important}.cart-items-section .continue-shopping-button span:last-child{padding-left:10px}.cart-items-section .delete-button{color:#dc3545!important;border-color:#dc3545!important}.cart-items-section .delete-button:hover{color:#5d5d5d!important;border-color:#5d5d5d!important}.cart-items-section .empty-cart{color:#dc3545!important;border-color:#dc3545!important}.cart-items-section .empty-cart:hover{color:#5d5d5d!important;border-color:#5d5d5d!important}.cart-items-section .continue-shopping:hover{color:#000!important;background:#fff!important}@media (max-width:991px){.actions-top-cart{display:flex;justify-content:space-between}.actions-top-cart:after,.actions-top-cart:before{content:none}.actions-top-cart__contain{width:auto}}@media (max-width:991px) and (max-width:570px){.actions-top-cart{flex-direction:column}.actions-top-cart__contain{padding-right:40px;padding-left:40px}.actions-top-cart__contain__btn{text-align:center;margin-right:0!important;margin-left:0!important;width:100%!important}}.add-funds-k-wallet,.checkout-section{padding:50px 0}.add-funds-k-wallet .checkout-block-content,.checkout-section .checkout-block-content{margin-top:30px;background:#f7f7f9;border:1px solid #ddd}.add-funds-k-wallet .checkout-title-block,.checkout-section .checkout-title-block{margin:0 0 30px}.add-funds-k-wallet .checkout-loading-container,.checkout-section .checkout-loading-container{display:flex;justify-content:center;align-items:center;flex-flow:column;padding:50px 0 80px}.add-funds-k-wallet .checkout-loading-container span,.checkout-section .checkout-loading-container span{font-size:18px;padding-bottom:10px}.add-funds-k-wallet .checkout-section-title,.checkout-section .checkout-section-title{border-bottom:1px solid #e1e1e1;border-top:1px solid #e1e1e1;background-color:#eee;padding-bottom:8px;font-size:18px;font-weight:600;padding:18px;display:flex;align-items:center}.add-funds-k-wallet .checkout-section-title:first-child,.checkout-section .checkout-section-title:first-child{margin-top:0;border-top:none}.add-funds-k-wallet .checkout-section-title__text-container,.checkout-section .checkout-section-title__text-container{display:flex;flex-direction:column}.add-funds-k-wallet .checkout-section-title__text,.checkout-section .checkout-section-title__text{color:#777676;font-size:14.5px;font-style:italic}.add-funds-k-wallet .checkout-section-title .icon,.checkout-section .checkout-section-title .icon{font-size:45px;color:#b18433;margin:0 15px}.add-funds-k-wallet .checkout-section-message,.checkout-section .checkout-section-message{margin:10px 0}.add-funds-k-wallet .checkout-form-row,.checkout-section .checkout-form-row{padding:25px}.add-funds-k-wallet .checkout-form-row.checkbox-row label,.checkout-section .checkout-form-row.checkbox-row label{display:inline-block}.add-funds-k-wallet .checkout-form-row.checkbox-row .checkout-form-fields,.checkout-section .checkout-form-row.checkbox-row .checkout-form-fields{margin-right:10px;float:left}.add-funds-k-wallet .checkout-form-row.navigate,.checkout-section .checkout-form-row.navigate{text-align:end}.add-funds-k-wallet .checkout-form-row.pt-5,.checkout-section .checkout-form-row.pt-5{padding-top:5px!important}.add-funds-k-wallet .checkout-form-row.pb-5,.checkout-section .checkout-form-row.pb-5{padding-bottom:5px!important}.add-funds-k-wallet .button--outlined,.checkout-section .button--outlined{width:150px;height:40px;border-radius:25px;border:1px solid #b18433;color:#b18433;font-size:18px;transition:.4s;background-color:#e9e9ea;padding:6px}.add-funds-k-wallet .button--outlined .checkout-button-text__desktop,.checkout-section .button--outlined .checkout-button-text__desktop{display:inherit}.add-funds-k-wallet .button--outlined .checkout-button-text__mobile,.checkout-section .button--outlined .checkout-button-text__mobile{display:none}@media (max-width:460px){.add-funds-k-wallet .button--outlined,.checkout-section .button--outlined{width:100px}.add-funds-k-wallet .button--outlined .checkout-button-text__desktop,.checkout-section .button--outlined .checkout-button-text__desktop{display:none}.add-funds-k-wallet .button--outlined .checkout-button-text__mobile,.checkout-section .button--outlined .checkout-button-text__mobile{display:inherit}}.add-funds-k-wallet .button--outlined:not([disabled]):hover,.checkout-section .button--outlined:not([disabled]):hover{color:#fff;background-color:#b18433;transition:.4s}.add-funds-k-wallet .button--outlined[disabled],.checkout-section .button--outlined[disabled]{border-color:#e1e1e1;color:#e1e1e1}.add-funds-k-wallet .button--reverted,.checkout-section .button--reverted{width:200px;height:40px;border-radius:25px;border:1px solid #b18433;font-size:18px;transition:.4s;color:#fff;background-color:#b18433;padding:6px}.add-funds-k-wallet .button--reverted[disabled],.checkout-section .button--reverted[disabled]{border-color:#e1e1e1;color:#e1e1e1;background-color:#e9e9ea}.add-funds-k-wallet .button--reverted .checkout-button-text__desktop,.checkout-section .button--reverted .checkout-button-text__desktop{display:inherit}.add-funds-k-wallet .button--reverted .checkout-button-text__mobile,.checkout-section .button--reverted .checkout-button-text__mobile{display:none}@media (max-width:460px){.add-funds-k-wallet .button--reverted,.checkout-section .button--reverted{width:100px}.add-funds-k-wallet .button--reverted .checkout-button-text__desktop,.checkout-section .button--reverted .checkout-button-text__desktop{display:none}.add-funds-k-wallet .button--reverted .checkout-button-text__mobile,.checkout-section .button--reverted .checkout-button-text__mobile{display:inherit}}.add-funds-k-wallet .button--reverted:not([disabled]):hover,.checkout-section .button--reverted:not([disabled]):hover{color:#b18433;background-color:transparent;transition:.4s}.add-funds-k-wallet .buttons-container,.checkout-section .buttons-container{padding:25px;display:flex;justify-content:space-between}.add-funds-k-wallet .buttons-container-confirm,.checkout-section .buttons-container-confirm{padding-right:1px;padding-left:1px}.add-funds-k-wallet .has-error .help-block,.checkout-section .has-error .help-block{margin-left:25px}.add-funds-k-wallet .has-error input,.checkout-section .has-error input{border:1px solid #a94442}.add-funds-k-wallet .checkout-form-label,.checkout-section .checkout-form-label{margin-bottom:3px;margin-left:25px;display:block;color:#2b2b2b;font-size:13px;font-weight:400}.add-funds-k-wallet .checkout-line-item-row,.checkout-section .checkout-line-item-row{margin:0;border-bottom:1px solid #e1e1e1;padding:15px 0}.add-funds-k-wallet .no-bottom-border,.checkout-section .no-bottom-border{border-bottom:none}.add-funds-k-wallet .checkout-line-item-image-block,.checkout-section .checkout-line-item-image-block{text-align:center}.add-funds-k-wallet .checkout-line-item-options-block,.checkout-section .checkout-line-item-options-block{margin-top:15px}.add-funds-k-wallet .checkout-line-item-options,.checkout-section .checkout-line-item-options{padding:10px 0}.add-funds-k-wallet .checkout-line-item-options input[type=radio],.checkout-section .checkout-line-item-options input[type=radio]{margin-right:10px}.add-funds-k-wallet .checkout-payment-options,.checkout-section .checkout-payment-options{margin-right:5px;margin-top:5px;border-style:solid;border-radius:10px;border-width:thin;align-content:center}.add-funds-k-wallet .checkout-payment-icons,.checkout-section .checkout-payment-icons{margin:0;align-content:center;align-self:center}.add-funds-k-wallet .pay-type-image,.checkout-section .pay-type-image{width:52.5px;height:33px;margin-left:5px;margin-right:5px;margin-top:5px;float:right;align-self:center;align-content:center}@media only screen and (max-width:570px){.add-funds-k-wallet .pay-type-image,.checkout-section .pay-type-image{width:26.25px;height:16.5px}}@media only screen and (min-width:570px) and (max-width:770px){.add-funds-k-wallet .pay-type-image,.checkout-section .pay-type-image{width:52.5px;height:33px}}@media only screen and (min-width:770px) and (max-width:995px){.add-funds-k-wallet .pay-type-image,.checkout-section .pay-type-image{width:34.1px;height:21.45px}}.add-funds-k-wallet .checkout-payment-options input[type=radio],.checkout-section .checkout-payment-options input[type=radio]{margin:15px}.add-funds-k-wallet .checkout-payment-options input[type=radio]:checked~.checkmark,.checkout-section .checkout-payment-options input[type=radio]:checked~.checkmark{background-color:#ff6d02}.add-funds-k-wallet .checkout-payment-button-block,.checkout-section .checkout-payment-button-block{padding:25px;display:flex;justify-content:space-between}.add-funds-k-wallet .checkout-payment-button-block .button-disabled,.checkout-section .checkout-payment-button-block .button-disabled{cursor:not-allowed}.add-funds-k-wallet .form-legend,.checkout-section .form-legend{color:#b18433}@media (max-width:768px){.add-funds-k-wallet .form-legend,.checkout-section .form-legend{margin-bottom:50px}}.add-funds-k-wallet .receptor-email-legend,.checkout-section .receptor-email-legend{margin-left:7%;text-align:justify;font-size:small;font-weight:700;margin-top:-20px;margin-bottom:10px}@media (max-width:768px){.add-funds-k-wallet .receptor-email-legend,.checkout-section .receptor-email-legend{margin-right:7%}}@media (min-width:768px) and (max-width:992px){.add-funds-k-wallet .checkout-block-summary,.checkout-section .checkout-block-summary{margin-left:0!important;width:33.33333333%}}.credit-card__container{padding:25px}@media (max-width:380px){.credit-card__container{padding-left:0;padding-right:0}}.confirmation-form__container{padding:25px}.checkout-confirmation-block .confirmation-success-message{display:block;font-size:16px;padding:25px}.checkout-confirmation-block .confirmation-details-block{margin-top:20px}.checkout-confirmation-block .shipment-heading strong{display:block}.checkout-confirmation-block .label-block-row{margin-top:5px}.checkout-confirmation-block .label-block-row label{margin-right:12px;padding:0;display:inline-block;color:#000}.checkout-confirmation-block .label-block-row label.label-default{padding:5px;position:relative;color:#fff}.checkout-confirmation-block .checkout-shipment-order-total{margin-top:10px;font-size:16px;font-weight:600}.checkout-confirmation-block .checkout-shipment-order-total small{margin-right:10px;font-size:14px;font-weight:400}.checkout-confirmation-block .order-header-labels{margin-top:5px;color:#000}.checkout-confirmation-block .order-header-labels .shipping-method{text-align:justify;white-space:normal;font-size:14px}@media (max-width:992px){.checkout-confirmation-block .order-header-labels{display:flex;flex-direction:column;align-items:start}}.checkout-confirmation-block .order-header-labels .label{margin-right:10px;padding:0;color:#000}.checkout-confirmation-block .order-header-labels .label.label-default{padding:5px 10px;color:#fff}.checkout-order-details .panel{padding:15px;border-radius:0;-moz-border-radius:0;-webkit-border-radius:0;box-shadow:0 0 0 transparent;-moz-box-shadow:0 0 0 transparent;-webkit-box-shadow:0 0 0 transparent;-ms-box-shadow:0 0 0 transparent;-o-box-shadow:0 0 0 transparent}.checkout-order-details .panel-heading{padding:0 0 10px;background:transparent}.checkout-order-details table.table tr:first-child td{border-top:none}.checkout-order-details table.table td{padding-left:0}.checkout-payment-paymeth-lab{font-weight:700;font-size:16px}@media (max-width:600px){.checkout-delivery-block .checkout-section-title{text-align:center;flex-direction:column}}@media (max-width:600px) and (max-width:400px){.checkout-delivery-block .checkout-section-title{padding:10px;font-size:16px}.checkout-delivery-block .checkout-section-title span:first-child{display:none}}.order-section{padding:50px 0}.order-section .order-list{margin-top:40px}.order-section .order-block-header{border-bottom:1px solid #e1e1e1;padding-bottom:10px}.order-section .order-header-labels{margin-top:5px;color:#000}.order-section .order-header-labels .label{margin-right:10px;padding:0;color:#000}.order-section .order-header-labels .label.label-default{padding:5px 10px;color:#fff}.order-section .order-line-items{margin-top:30px}.order-section .order-line-items .shipment-line-item-image{width:48px}.order-section .order-items-row{margin:0;border-bottom:1px solid #e1e1e1;padding:15px 0}.order-section .order-items-row:first-child{padding-top:0}.order-section .order-items-image-block{padding-left:0;text-align:center}.order-section .order-address-block{border:1px solid #e1e1e1;padding:15px;background:#f7f7f9}.order-section .order-total-row{padding-top:15px;font-size:16px;font-weight:500}.order-section .order-total-row small{margin-right:10px;font-size:13px;font-weight:300}.order-section .confirmation-details-block{background-color:#fff;border:1px solid #e1e1e1;margin-top:30px;padding:15px}.order-section .confirmation-details-block:first-child{margin-top:0}.order-section .line-item-row .list-item-summary{width:250px}@media (max-width:768px){.order-section .line-item-row .list-item-summary{margin:auto;width:100%}}.order-section .line-item-row .address-summary{display:flex;flex-direction:row;justify-content:space-between;margin:45px 130px 0 150px}.order-section .line-item-row .address-summary .address{display:flex;flex-direction:column}.order-section .line-item-row .address-summary .address div{margin-bottom:20px}@media (max-width:768px){.order-section .line-item-row .address-summary .address{margin:auto;width:100%}}@media (max-width:768px){.order-section .line-item-row .address-summary{flex-direction:column}}@media (max-width:992px){.order-section .line-item-row .address-summary{margin:25px}}@media (max-width:480px){.order-section .line-item-row .order-header-labels .shipping-method{display:block;width:100%;word-wrap:break-word;white-space:normal;margin:5px 0;text-align:left}}.order-padding{padding:25px}.manager-k-wallet .no-down-border{border:0}.manager-k-wallet .banner-header{font-family:Lato Bold;font-size:18px;font-weight:500;line-height:1.3;margin-bottom:25px}.manager-k-wallet .section-banner{background-color:#fff;padding:50px 0;display:flex;flex-direction:row;flex-wrap:nowrap}.manager-k-wallet .banner-message{flex-grow:1;max-width:55%;padding:0 40px}.manager-k-wallet .banner-message img{margin-bottom:35px}.manager-k-wallet .banner-message li{font-size:14px;height:35px}.manager-k-wallet .banner-message li span{margin-top:11px;position:absolute;padding-left:30px}.manager-k-wallet .banner-message li:before{content:url(" + __webpack_require__(1618) + ");width:35px;height:0;display:block}.manager-k-wallet .banner-links{flex-grow:1;border-left:1px solid #dfdfdf;padding:0 40px}.manager-k-wallet .banner-links .amount{font-family:Lato,Arial,Enriqueta,Open Sans,serif;margin-left:10px}.manager-k-wallet .banner-links .banner-header{margin-bottom:0}.manager-k-wallet .banner-links a.banner-main-cta{max-width:260px;font-size:18px;color:#fff;background-color:#f16d07!important;padding:15px;display:block;border-radius:40px;margin-top:15px;margin-bottom:25px;text-align:center}.manager-k-wallet .banner-links .banner-links-subtitle{font-size:16px;margin-bottom:12px}.manager-k-wallet .banner-links .banner-links-k-wallet li{font-size:14px;height:35px}.manager-k-wallet .banner-links .banner-links-k-wallet li span{margin-top:8px;display:block;padding-left:30px}.manager-k-wallet .banner-links .banner-links-k-wallet li a{text-decoration:underline;color:#1c396c}.manager-k-wallet .banner-links .banner-links-k-wallet li a::hover{text-decoration:none}.manager-k-wallet .banner-links .banner-links-k-wallet li:before{content:url(" + __webpack_require__(1617) + ");width:30px;height:0;display:block}.manager-k-wallet .banner-links .balance-summary{display:flex;margin-bottom:25px}.manager-k-wallet .banner-links .balance-summary__col-left{margin-right:15px}.manager-k-wallet .banner-links .balance-summary__col-right{flex:1 1 auto}.manager-k-wallet .banner-links .balance-summary__col-right .copy-icon{margin-left:10px;cursor:pointer}.manager-k-wallet .banner-links .balance-summary__col__wallet-id{display:flex;align-items:center;margin-top:10px}.manager-k-wallet .banner-links .balance-summary__col__wallet-id input[type=password]{cursor:pointer}.manager-k-wallet .banner-links .balance-summary__col__label,.manager-k-wallet .banner-links .balance-summary__col__value{margin:5px 0;font-size:16px}.manager-k-wallet .k-wallet-transactions{margin-top:50px;display:flex;justify-content:space-between}.manager-k-wallet .section-transactions .transactions-title{background-color:#fff;padding:15px 0 15px 25px;font-size:16px;text-transform:uppercase;font-family:Lato Bold;border-bottom:1px solid #dfdfdf;margin-top:10px}.manager-k-wallet .section-transactions .k-wallet-transaction{background-color:#fff}.manager-k-wallet .section-transactions .transaction-detail{display:flex;flex-direction:row;background-color:#fff;padding:15px 0 15px 25px;font-size:14px}.manager-k-wallet .section-transactions .transaction-detail .transaction-detail-info{flex-grow:1}.manager-k-wallet .section-transactions .transaction-detail .transaction-detail-amount{padding:0 15px;align-self:center;font-family:Lato Bold}.manager-k-wallet .section-transactions .transaction-detail .transaction-details-date{color:#7a7a7a}.manager-k-wallet .section-transactions .transaction-detail .transaction-details-card{font-family:Lato Bold;margin-top:15px}.manager-k-wallet .section-transactions .transaction-detail .transaction-details-order{margin-bottom:5px}.manager-k-wallet .section-transactions .transaction-detail .transaction-details-order a{text-decoration:underline;color:#1c396c;margin-bottom:10px}.manager-k-wallet .section-transactions .transaction-detail .transaction-details-order a::hover{text-decoration:none;color:#1c396c}.manager-k-wallet .section-transactions .transaction-separator{height:1px;background-color:#dfdfdf;padding:0 10px}.manager-k-wallet .rdt_TableHeader{background-color:red}@media (max-width:768px){.manager-k-wallet .section-banner{flex-direction:column;padding:20px 0}.manager-k-wallet .banner-message{max-width:100%;padding:0 20px}.manager-k-wallet .banner-links{padding-top:20px;margin-top:20px;border-left:none;border-top:1px solid #dfdfdf;padding:20px 20px 0}}@media (max-width:430px){.manager-k-wallet .banner-links .balance-summary__col{width:100%}.manager-k-wallet .banner-links .balance-summary__col-left{width:55%}.manager-k-wallet .banner-links .balance-summary__col-right{width:45%}}.add-funds-k-wallet__title{border:1px solid #e1e1e1;background-color:#eee;padding-bottom:8px;font-size:18px;font-weight:600;padding:18px;display:flex;align-items:center}.add-funds-k-wallet__title__text-container{display:flex;flex-direction:column}.add-funds-k-wallet__title__text{color:#777676;font-size:14.5px;font-style:italic}.add-funds-k-wallet__title svg{margin-right:15px}.add-funds-k-wallet__body{background:#f7f7f9;border:1px solid #ddd;padding:15px 15px 30px;border-top:none;display:flex;width:100%;position:relative}.add-funds-k-wallet__body__left-side,.add-funds-k-wallet__body__right-side{flex:1 1 auto;width:50%}@media only screen and (max-width:991px){.add-funds-k-wallet__body{display:block}.add-funds-k-wallet__body__left-side{width:100%}.add-funds-k-wallet__body__right-side{flex:1 1 auto;width:100%}}.add-funds-k-wallet__body .checkout-form-row{padding:0 7.5px;margin-top:15px}.add-funds-k-wallet__body__form-twin-fields{display:flex}.add-funds-k-wallet__body__form-twin-fields__field{flex:1 1 auto;width:50%}@media only screen and (max-width:575px){.add-funds-k-wallet__body__form-twin-fields{display:block}.add-funds-k-wallet__body__form-twin-fields__field{width:100%}}.add-funds-k-wallet__body__form-3-in-row-fields{display:flex}.add-funds-k-wallet__body__form-3-in-row-fields__field{flex:1 1 auto;width:33.33333%}@media only screen and (max-width:575px){.add-funds-k-wallet__body__form-3-in-row-fields{display:block}.add-funds-k-wallet__body__form-3-in-row-fields__field{width:100%}}.add-funds-k-wallet__body .cc-number-wrapper{align-items:center;position:relative}.add-funds-k-wallet__body .cc-number-wrapper__card-logo{position:absolute;right:-12px;top:28px;margin-top:0}.add-funds-k-wallet__body .generic-processing{position:absolute;width:100%;height:100%;top:0;left:0;justify-content:center;display:flex;align-items:center}.add-funds-k-wallet__body .generic-processing span{color:#fff;font-size:22px}.add-funds-k-wallet__actions{text-align:right;margin:15px 0}.add-funds-k-wallet__actions .checkout-button-text__desktop{display:inherit!important}.row-no-padding [class*=col-]{padding-left:0!important;padding-right:0!important}.animated{animation-duration:1s;animation-fill-mode:forwards}.animated.bounceIn{animation-duration:.7s}.animated.bounceOut{animation-duration:.5s}.animated.bounceIn{animation-name:bounceIn}.animated.bounceOut{animation-name:bounceOut}.animated.fadeIn{animation-name:fadeIn;animation-duration:.7s}.animated.fadeOut{animation-name:fadeOut;animation-duration:.3s}.animated.bounceInDown{animation-name:bounceInDown}.animated.bounceOutUp{animation-name:bounceOutUp}@keyframes bounceIn{0%,20%,40%,60%,80%,to{animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:perspective(1px) scale3d(.3,.3,.3)}20%{transform:perspective(1px) scale3d(1.1,1.1,1.1)}40%{transform:perspective(1px) scale3d(.9,.9,.9)}60%{opacity:1;transform:perspective(1px) scale3d(1.03,1.03,1.03)}80%{transform:perspective(1px) scale3d(.97,.97,.97)}to{opacity:1;transform:perspective(1px) scaleX(1)}}@keyframes bounceOut{20%{transform:scale3d(.9,.9,.9)}50%,55%{opacity:1;transform:scale3d(1.1,1.1,1.1)}to{opacity:0;transform:scale3d(.3,.3,.3)}}@keyframes fadeIn{0%{opacity:0}to{opacity:1}}@keyframes fadeOut{0%{opacity:1}to{opacity:0}}@keyframes bounceInDown{0%,60%,75%,90%,to{animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:translate3d(0,-3000px,0)}60%{opacity:1;transform:translate3d(0,25px,0)}75%{transform:translate3d(0,-10px,0)}90%{transform:translate3d(0,5px,0)}to{transform:none}}@keyframes bounceOutUp{20%{transform:translate3d(0,-10px,0)}40%,45%{opacity:1;transform:translate3d(0,20px,0)}to{opacity:0;transform:translate3d(0,-2000px,0)}}.rrt-confirm-holder{width:100%;height:100%;position:fixed;top:0;left:0;z-index:99999999}.rrt-confirm-holder .shadow{width:100%;height:100%;background-color:rgba(50,58,68,.8)}.rrt-confirm-holder .rrt-confirm{width:320px;background-color:#fff;position:absolute;z-index:9;top:20%;left:50%;margin-left:-160px;box-shadow:3px 3px 20px #333;border-radius:4px;overflow:hidden}.rrt-confirm-holder .rrt-confirm .rrt-message{width:100%;padding:5%;min-height:50px;font-size:1em;background-color:#fff;text-align:center;font-family:open-sanscondensed-light,sans-serif;clear:both}.rrt-confirm-holder .rrt-confirm .rrt-buttons-holder{display:flex}.rrt-confirm-holder .rrt-confirm .rrt-buttons-holder .rrt-button{flex-grow:1;height:50px;text-transform:capitalize;border:none;background-color:transparent;padding:0;margin:0;float:left;border-top:1px solid #f0f0f0;font-size:14px;overflow:hidden;cursor:pointer}.rrt-confirm-holder .rrt-confirm .rrt-buttons-holder .rrt-button:hover{background-color:#f5f5f5}.rrt-confirm-holder .rrt-confirm .rrt-buttons-holder .rrt-button.rrt-ok-btn:active{background-color:#60bb71;color:#fff}.rrt-confirm-holder .rrt-confirm .rrt-buttons-holder .rrt-button.rrt-cancel-btn:active{background-color:#db6a64;color:#fff}.rrt-confirm-holder .rrt-confirm .rrt-buttons-holder .rrt-button:focus{outline:none}body.toastr-confirm-active{overflow:hidden}.redux-toastr *,.redux-toastr :after,.redux-toastr :before{box-sizing:border-box}.redux-toastr .bottom-center,.redux-toastr .bottom-left,.redux-toastr .bottom-right,.redux-toastr .top-center,.redux-toastr .top-left,.redux-toastr .top-right{width:350px;position:fixed;z-index:99999999;padding:0 10px}.redux-toastr .top-center,.redux-toastr .top-left,.redux-toastr .top-right{top:0}.redux-toastr .bottom-right,.redux-toastr .top-right{right:0}.redux-toastr .bottom-center,.redux-toastr .bottom-left,.redux-toastr .bottom-right{bottom:0}.redux-toastr .bottom-left,.redux-toastr .top-left{left:0}.redux-toastr .bottom-center,.redux-toastr .top-center{left:50%;margin-left:-175px}@media (max-width:320px){.redux-toastr .bottom-center,.redux-toastr .bottom-left,.redux-toastr .bottom-right,.redux-toastr .top-center,.redux-toastr .top-left,.redux-toastr .top-right{width:320px}.redux-toastr .bottom-center,.redux-toastr .top-center{margin-left:-160px}}.redux-toastr .toastr{background-color:#fcfcfc;width:100%;min-height:70px;overflow:hidden;margin:10px 0;border-radius:4px;position:relative;z-index:2;color:#333;opacity:.94;box-shadow:2px 2px 10px rgba(0,0,0,.4)}.redux-toastr .toastr:hover:not(.rrt-message){box-shadow:0 0 10px rgba(0,0,0,.6);opacity:1}.redux-toastr .toastr .toastr-status{width:100%;height:5px}.redux-toastr .toastr .toastr-status.success{background-color:#60bb71}.redux-toastr .toastr .toastr-status.warning{background-color:#f7a336}.redux-toastr .toastr .toastr-status.info{background-color:#58abc3}.redux-toastr .toastr .toastr-status.error{background-color:#db6a64}.redux-toastr .toastr .rrt-left-container,.redux-toastr .toastr .rrt-right-container{float:left;text-align:center;overflow:hidden}.redux-toastr .toastr .rrt-left-container{width:80px;top:0;left:0;position:absolute;bottom:0}.redux-toastr .toastr .rrt-left-container .rrt-holder{width:70px;height:70px;position:absolute;top:50%;margin-top:-35px;left:5px;line-height:60px}.redux-toastr .toastr .rrt-left-container .toastr-icon{fill:#fff;vertical-align:middle;margin-top:5px}.redux-toastr .toastr .rrt-middle-container{width:65%;margin-left:80px;position:relative;float:left;font-family:Arial,Helvetica,sans-serif;font-size:1em;text-align:left;padding:10px 5px}.redux-toastr .toastr .rrt-middle-container .rrt-title{font-size:1.1em;font-weight:700;margin-bottom:5px}.redux-toastr .toastr .rrt-right-container{width:10%}.redux-toastr .toastr .close-toastr{width:10%;height:100%;position:absolute;top:0;right:0;background-color:transparent;font-size:22px;border:none;outline:none;opacity:.5;cursor:pointer;font-family:Helvetica Neue,Helvetica,Arial sans-serif;color:#000}.redux-toastr .toastr .close-toastr:hover{opacity:1}.redux-toastr .toastr .close-toastr:focus{outline:none}.redux-toastr .toastr .close-toastr span{position:absolute;left:0;right:0;top:50%;transform:translateY(-50%)}.redux-toastr .toastr.rrt-error,.redux-toastr .toastr.rrt-info,.redux-toastr .toastr.rrt-success,.redux-toastr .toastr.rrt-warning{color:#fff}.redux-toastr .toastr.rrt-info{background-color:#58abc3}.redux-toastr .toastr.rrt-info .rrt-progressbar{background-color:#378298}.redux-toastr .toastr.rrt-success{background-color:#60bb71}.redux-toastr .toastr.rrt-success .rrt-progressbar{background-color:#3e914d}.redux-toastr .toastr.rrt-warning{background-color:#f7a336}.redux-toastr .toastr.rrt-warning .rrt-progressbar{background-color:#d87e09}.redux-toastr .toastr.rrt-error{background-color:#db6a64}.redux-toastr .toastr.rrt-error .rrt-progressbar{background-color:#c5352e}.redux-toastr .toastr.rrt-light .rrt-progressbar{background-color:#ccc}.redux-toastr .toastr.rrt-light .toastr-icon{fill:#333!important}.redux-toastr .toastr.rrt-message{opacity:1;border:1px solid #dbdbdb}.redux-toastr .toastr.rrt-message .rrt-title{width:90%;height:50px;text-align:center;font-size:1.2em;text-overflow:ellipsis;overflow:hidden;white-space:nowrap;line-height:50px;padding:0 20px}.redux-toastr .toastr.rrt-message .rrt-text{width:100%;max-height:400px;overflow:hidden;overflow-y:auto;border-top:1px solid #f1f1f1;border-bottom:1px solid #f1f1f1;background-color:#fff;padding:15px;font-size:1.1em;margin-bottom:20px}.redux-toastr .toastr.rrt-message .rrt-text img{display:block;margin:10px auto;max-width:100%}.redux-toastr .toastr.rrt-message .close-toastr{height:50px}.redux-toastr .toastr .rrt-progress-container{height:5px;margin:0 -20px -20px -60px;position:absolute;bottom:20px;width:100%}.redux-toastr .toastr .rrt-progress-container .rrt-progressbar{border-radius:0 0 0 4px;height:100%}.redux-toastr .toastr-attention{width:100%;height:100%;position:fixed;top:0;left:0;right:0;bottom:0;background-color:rgba(0,0,0,.4);z-index:1}.rccs{perspective:1000px}.rccs,.rccs__card{margin:0 auto;width:290px}.rccs__card{height:182.873px;position:relative;transform-style:preserve-3d;transition:all .4s linear}.rccs__card--back,.rccs__card--front{backface-visibility:hidden;background:linear-gradient(25deg,#939393,#717171);border-radius:14.5px;color:#fff;height:100%;left:0;overflow:hidden;position:absolute;top:0;transform-style:preserve-3d;width:100%;box-shadow:0 0 20px rgba(0,0,0,.2)}.rccs__card--front{z-index:20}.rccs__card--back{transform:rotateY(180deg)}.rccs__card--back .rccs__issuer{background-position:bottom;bottom:5%;left:50%;opacity:.6;right:auto;top:auto;transform:translateX(-50%)}.rccs__card__background{height:200%;position:absolute;top:-60%;transform:rotate(25deg);transition:all .5s ease-out;width:150%;left:-170%}.rccs__card--flipped{transform:rotateY(180deg)}.rccs__card--flipped .rccs__card--front{z-index:10}.rccs__card--flipped .rccs__card--back{z-index:20}.rccs__card--unknown>div{background:linear-gradient(25deg,#999,#999);box-shadow:none}.rccs__card--unknown .rccs__issuer{visibility:hidden}.rccs__card:not(.rccs__card--unknown) .rccs__card__background{left:-22%}.rccs__card--amex .rccs__card__background{background:linear-gradient(25deg,#308c67,#a3f2cf)}.rccs__card--amex .rccs__issuer{background-image:url(\"data:image/svg+xml;base64,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\")}.rccs__card--amex .rccs__cvc__front{opacity:.5;visibility:visible}.rccs__card--dankort .rccs__card__background{background:linear-gradient(25deg,#ccc,#999)}.rccs__card--dankort .rccs__issuer{background-image:url(\"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTEyIiBoZWlnaHQ9IjMwOCIgdmlld0JveD0iMCAwIDUxMiAzMDgiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgcHJlc2VydmVBc3BlY3RSYXRpbz0ieE1pZFlNaWQiPjxkZWZzPjxsaW5lYXJHcmFkaWVudCB4MT0iNTAlIiB5MT0iMCUiIHgyPSI1MCUiIHkyPSIxMDAlIiBpZD0iYSI+PHN0b3Agc3RvcC1jb2xvcj0iI0Y1MDkxQSIgb2Zmc2V0PSIwJSIvPjxzdG9wIHN0b3AtY29sb3I9IiM5RTBDMTciIG9mZnNldD0iMTAwJSIvPjwvbGluZWFyR3JhZGllbnQ+PC9kZWZzPjxwYXRoIGQ9Ik0zNTguNDA3IDBoLTIwNC43OTVjLTg0Ljg0MiAwLTE1My42MTIgNjguNzcxLTE1My42MTIgMTUzLjU5MyAwIDg0Ljg1MSA2OC43NyAxNTMuNjA2IDE1My42MTIgMTUzLjYwNmgyMDQuNzk1Yzg0LjgyMiAwIDE1My41OTMtNjguNzU1IDE1My41OTMtMTUzLjYwNiAwLTg0LjgyMS02OC43Ny0xNTMuNTkzLTE1My41OTMtMTUzLjU5MyIgZmlsbD0iI0ZFRkVGRSIvPjxwYXRoIGQ9Ik0zOTUuNTkxIDE0NC40ODZsNjguMzI4IDgxLjI2MWMxNC4xNTEtMjAuNDUxIDIyLjQ2Mi00NS4yNDIgMjIuNDYyLTcxLjk0NSAwLTI4LjE4My05LjI1OS01NC4yNDgtMjQuODg0LTc1LjMxNWwtNjUuOTA2IDY1Ljk5OXptLTI0MS4zOTctMTE3LjM4NmMtMzguNTQ3IDAtNzMuMTIxIDE3LjI5My05Ni4zODMgNDQuNTI4aDE0NC4xNTljNTEuMDI3IDAgODkuNDc0IDEyLjk4MyA5My40MzEgNTUuOTc0bDUzLjcwMi01NS45ODFoMTA2LjkzMWMtMjMuMjYzLTI3LjIyNy01Ny44MzEtNDQuNTItOTYuMzYxLTQ0LjUyaC0yMDUuNDc5em0yOS4yMzYgMjA1LjQ3OWgtMTI4LjQyOWMyMy4yMzMgMjkuMTkzIDU5LjA2MiA0Ny45NDYgOTkuMTk0IDQ3Ljk0NmgyMDUuNDc5YzQwLjExNyAwIDc1LjkzNy0xOC43NDUgOTkuMTcxLTQ3LjkzOWgtMTA5LjI5NWwtNTYuNzk2LTcxLjc3NmMtMTAuNTA2IDQ4LjkzOS00NC44ODEgNzEuNzY5LTEwOS4zMjMgNzEuNzY5ek0xMTguNDQgMTI1Ljk5N2wtMTguMjIyIDUwLjFoNzMuNTE3YzIxLjczMyAwIDI4LjMxLTguOTk4IDMzLjE3My0yNi4zMTkgNC44MTUtMTcuMTMxLTcuMjc3LTIzLjc4LTIyLjEyOS0yMy43OGgtNjYuMzM5eiIgZmlsbD0idXJsKCNhKSIvPjwvc3ZnPg==\")}.rccs__card--dinersclub>div{color:#555}.rccs__card--dinersclub .rccs__card__background{background:linear-gradient(25deg,#fff,#eee)}.rccs__card--dinersclub .rccs__issuer{background-image:url(\"data:image/svg+xml;base64,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\")}.rccs__card--discover>div{color:#555}.rccs__card--discover .rccs__card__background{background:linear-gradient(25deg,#fff,#eee)}.rccs__card--discover .rccs__issuer{background-image:url(\"data:image/svg+xml;base64,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\")}.rccs__card--elo .rccs__card__background{background:linear-gradient(25deg,#211c18,#aaa7a2)}.rccs__card--elo .rccs__issuer{background-image:url(\"data:image/svg+xml;base64,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\")}.rccs__card--hipercard .rccs__card__background{background:linear-gradient(25deg,#8b181b,#de1f27)}.rccs__card--hipercard .rccs__issuer{background-image:url(\"data:image/svg+xml;base64,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\")}.rccs__card--jcb .rccs__issuer{background-image:url(\"data:image/svg+xml;base64,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\")}.rccs__card--laser .rccs__issuer{background-image:url(\"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTEyIiBoZWlnaHQ9IjM2OCIgdmlld0JveD0iMCAwIDUxMiAzNjgiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgcHJlc2VydmVBc3BlY3RSYXRpbz0ieE1pZFlNaWQiPjxwYXRoIGZpbGw9IiMyODM0N0QiIGQ9Ik0wIDM2Ny4yMTJoNTEydi0zNjcuMjExaC01MTJ6Ii8+PHBhdGggZD0iTTI1My45MSAyOTEuMDQzaC0yNTMuOTF2Mi4wOTZoMjUyLjY5bC4xMTYgNy42MjIgNC43NjQtNy42MjJoMjU0LjQzdi0yLjA5NmgtMjUzLjI3MWwzLjY2My02LjExMi04LjQ4MiA2LjExMnptMi41NTYtMjAuMDg0aC0yNTYuNDY2djIuMDk2aDI1NS40Mmw5LjE0NyA4LjM5OCA1LjExMi04LjM5OGgyNDIuMzIxdi0yLjA5NmgtMjQxLjA0NWw0LjY3Ny03LjY4NC0xOS4xNjYgNy42ODR6bTIuMTUtMjAuMDgzaC0yNTguNjE2djIuMDk2aDI1NS45OTlsMjAuODgyIDguMjUyIDUuMDIyLTguMjUyaDIzMC4wOTd2LTIuMDk2aC0yMjguODJsNC4xMS02Ljc1Mi0yOC42NzQgNi43NTJ6bS02Ljk3Mi0yMC4wODNoLTI1MS42NDR2Mi4wOTZoMjUwLjAxN2wzOS4zNDIgNy44MzYgNC43Ny03LjgzNmgyMTcuODcxdi0yLjA5NmgtMjE2LjU5NGw0LjEzNC03LjI1Mi00Ny44OTYgNy4yNTJ6bS0yMi43NzUtMTcuMDU3aC0yMjguODY4djIuMDk2aDIzNy43bDYzLjEgNS45OTYgMy43MTEtNS45OTZoMjA3LjQ4OXYtMi4wOTZoLTIwNi4yMTRsNS4xMy04LjMyNC04Mi4wNDggOC4zMjR6bS0zLjMxLTIwLjA4M2gtMjI1LjU1OHYyLjA5NmgyMjYuMDgxbDg2Ljg4OSA2LjExMiAzLjc2Ni02LjExMmgxOTUuMjY0di0yLjA5NmgtMTkzLjk4OGw0LjUzNS03LjQ1MS05Ni45ODkgNy40NTF6bS0zLjEzOC0yMC4wODNoLTIyMi40MnYyLjA5NmgyMjEuOTU1bDEwMy4xMjEgNi4zNDQgMy44ODYtNi4zNDRoMTgzLjAzOHYtMi4wOTZoLTE4MS43NjNsNC40MzQtNy4yMTgtMTEyLjI1MSA3LjIxOHptLTguNzcyLTIwLjA4M2gtMjEzLjY0N3YyLjA5NWgyMTMuMjk4bDEyMy40ODIgNy42NjcgNC42MDUtNy42NjdoMTcwLjYxNXYtMi4wOTVoLTE2OS4zNTZsNC4wNzgtNi43ODgtMTMzLjA3NSA2Ljc4OHptLTE5LjA1Ny0xNy4yODloLTE5NC41OTF2Mi4wOTZoMTk0LjQxNmwxNTMuNjY3IDYuMTM4IDMuNjg5LTYuMTM4aDE2MC4yMjh2LTIuMDk2aC0xNTguOTdsNC42MzEtNy43MDktMTYzLjA3IDcuNzA5em00Ljc2NS0yMC4wODRoLTE5OS4zNTV2Mi4wOTZoMTk4LjMwOGwxNjEuNDQzIDYuODEgNC4wODQtNi44MWgxNDguMTY1di0yLjA5NmgtMTQ2LjkwNmw0LjAxNS02LjY4NC0xNjkuNzU0IDYuNjg0em0tMTEuMzMtMjAuMDgzaC0xODguMDI1djIuMDk2aDE4Ni45NzlsMTg0LjY3NiA3LjEwMiA0LjI0NC03LjEwMmgxMzYuMTAxdi0yLjA5NmgtMTM0Ljg0MmwzLjY3Ny02LjE3MS0xOTIuODEgNi4xNzF6bS04Ljg4OS0yMC4wODNoLTE3OS4xMzZ2Mi4wOTZoMTY0Ljg0NGwyMTkuMDg2IDYuNzEzIDQuMDMzLTYuNzEzaDEyNC4wMzd2LTIuMDk2aC0xMjIuNzc4bDMuNjc4LTYuMTIxLTIxMy43NjQgNi4xMjF6bS0xLjIyLTIwLjA4M2gtMTc3LjkxNnYyLjA5NmgxNzUuNjVsMjE5Ljc0OCA3LjcwNiA0LjYzLTcuNzA2aDExMS45NzJ2LTIuMDk2aC0xMTAuNzE0bDMuOTIyLTYuNTItMjI3LjI5MiA2LjUyem0tMTIuMzc1LTIwLjA4M2gtMTY1LjU0MXYyLjA5NWgxMzIuNTQybDI3NS4yOTkgNy4wNzggNC4yNTEtNy4wNzhoOTkuOTA4di0yLjA5NWgtOTguNjQ5bDMuODE3LTYuMzU2LTI1MS42MjcgNi4zNTZ6bS04Mi4yMjctMTYuNjQ5aC04My4zMTR2Mi4wOTZoMjAwLjA1MmwyMTkuNTU0IDQuMTM4IDIuNDg3LTQuMTM4aDg5LjkwN3YtMi4wOTZoLTg4LjY0OGw1LjU4OC05LjMwMy0zNDUuNjI1IDkuMzAzeiIgZmlsbD0iI0VCMEQ3RiIvPjxwYXRoIGQ9Ik0xMzQuNzEgMzQ5LjE0MXYtMzcuNjE4aDcuNjQzdjMxLjIyN2gxOS4wMDV2Ni4zOTFoLTI2LjY0OHptODMuMTU1IDBoLTguMzE0bC0zLjMwNi04LjYxNWgtMTUuMTMybC0zLjEyNCA4LjYxNWgtOC4xMDhsMTQuNzQ0LTM3LjkyOWg4LjA4MmwxNS4xNTcgMzcuOTI5em0tMTQuMDczLTE1LjAwNmwtNS4yMTYtMTQuMDc1LTUuMTEzIDE0LjA3NWgxMC4zMjl6bTMzLjExMiAyLjY2NWw3LjQzNi0uNzI1Yy40NDcgMi41MDIgMS4zNTYgNC4zMzkgMi43MjUgNS41MTEgMS4zNjggMS4xNzQgMy4yMTUgMS43NTkgNS41MzkgMS43NTkgMi40NiAwIDQuMzE3LS41MjEgNS41NjQtMS41NjYgMS4yNDgtMS4wNDIgMS44NzItMi4yNjMgMS44NzItMy42NiAwLS44OTYtLjI2My0xLjY2LS43ODctMi4yOS0uNTI1LS42MjktMS40NDQtMS4xNzYtMi43NTItMS42NDItLjg5NC0uMzExLTIuOTM1LS44NjItNi4xMTktMS42NTYtNC4wOTctMS4wMTctNi45NzEtMi4yNjctOC42MjQtMy43NTItMi4zMjMtMi4wODYtMy40ODUtNC42MzEtMy40ODUtNy42MzIgMC0xLjkzMS41NDYtMy43MzkgMS42MzktNS40MTkgMS4wOTMtMS42ODMgMi42NjgtMi45NjQgNC43MjYtMy44NDMgMi4wNTctLjg4IDQuNTM5LTEuMzE5IDcuNDUtMS4zMTkgNC43NTEgMCA4LjMyOCAxLjA0NCAxMC43MjggMy4xMyAyLjQwMyAyLjA4NyAzLjY2MSA0Ljg3NCAzLjc4NCA4LjM1NmwtNy42NDMuMzM3Yy0uMzI5LTEuOTQ4LTEuMDMxLTMuMzUtMi4xMDQtNC4yMDUtMS4wNzctLjg1Mi0yLjY5MS0xLjI4LTQuODQ0LTEuMjgtMi4yMjEgMC0zLjk1OS40NTgtNS4yMTYgMS4zNzEtLjgwOS41ODctMS4yMTQgMS4zNzItMS4yMTQgMi4zNTUgMCAuODk3LjM3OCAxLjY2NSAxLjEzNyAyLjMwMi45NjMuODEyIDMuMzA1IDEuNjU2IDcuMDI0IDIuNTM2IDMuNzE4Ljg3OSA2LjQ2OCAxLjc4OSA4LjI0OSAyLjczIDEuNzgzLjkzOSAzLjE3OCAyLjIyNSA0LjE4MyAzLjg1MyAxLjAwOCAxLjYzMiAxLjUxMSAzLjY0NiAxLjUxMSA2LjA0MiAwIDIuMTc0LS42MDMgNC4yMDktMS44MDcgNi4xMDYtMS4yMDcgMS44OTgtMi45MSAzLjMwOC01LjExMiA0LjIzMS0yLjIwNS45MjItNC45NSAxLjM4NC04LjIzOSAxLjM4NC00Ljc4NiAwLTguNDYtMS4xMDktMTEuMDI1LTMuMzI2LTIuNTY1LTIuMjE1LTQuMDk3LTUuNDQ1LTQuNTk2LTkuNjg4em01NC4xMzIgMTIuMzQxdi0zNy45MjloMjguMDY5djYuNDE3aC0yMC40MjZ2OC40MDhoMTkuMDA1djYuMzkxaC0xOS4wMDV2MTAuMzIyaDIxLjE0OXY2LjM5MWgtMjguNzkyem01Mi4yMiAwdi0zNy45MjloMTYuMDg3YzQuMDQ1IDAgNi45ODQuMzQgOC44MTkgMS4wMjEgMS44MzIuNjgzIDMuMzAxIDEuODk1IDQuNDAyIDMuNjM2IDEuMTAxIDEuNzQzIDEuNjUzIDMuNzM1IDEuNjUzIDUuOTc3IDAgMi44NDUtLjgzNiA1LjE5Ni0yLjUwNSA3LjA0OS0xLjY3IDEuODU1LTQuMTY3IDMuMDI1LTcuNDg4IDMuNTA2IDEuNjUzLjk2NyAzLjAxNyAyLjAyOCA0LjA5NCAzLjE4MyAxLjA3NSAxLjE1NiAyLjUyNCAzLjIwOCA0LjM1MSA2LjE1N2w0LjYyMSA3LjRoLTkuMTRsLTUuNTI2LTguMjU0Yy0xLjk2Mi0yLjk0OS0zLjMwNS00LjgwOC00LjAyOC01LjU3Ni0uNzIzLS43NjYtMS40ODktMS4yOTMtMi4yOTktMS41NzctLjgwOS0uMjg2LTIuMDkxLS40MjctMy44NDYtLjQyN2gtMS41NXYxNS44MzRoLTcuNjQzem03LjY0My0yMS44ODhoNS42NTVjMy42NjcgMCA1Ljk1NS0uMTU1IDYuODY5LS40NjYuOTEyLS4zMSAxLjYyNy0uODQ0IDIuMTQ0LTEuNjA0LjUxNi0uNzU5Ljc3NC0xLjcwNy43NzQtMi44NDYgMC0xLjI3Ni0uMzQtMi4zMDctMS4wMTktMy4wOTEtLjY4Mi0uNzg1LTEuNjQxLTEuMjgxLTIuODgtMS40ODgtLjYyLS4wODYtMi40NzgtLjEzLTUuNTc3LS4xM2gtNS45NjV2OS42MjV6IiBmaWxsPSIjZmZmIi8+PC9zdmc+\")}.rccs__card--maestro>div,.rccs__card--mastercard>div{color:#555}.rccs__card--maestro .rccs__card__background,.rccs__card--mastercard .rccs__card__background{background:linear-gradient(25deg,#fbfbfb,#e8e9e5)}.rccs__card--maestro .rccs__issuer{background-image:url(\"data:image/svg+xml;base64,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\")}.rccs__card--mastercard .rccs__issuer{background-image:url(\"data:image/svg+xml;base64,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\")}.rccs__card--unionpay .rccs__issuer{background-image:url(\"data:image/svg+xml;base64,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\")}.rccs__card--visa .rccs__card__background,.rccs__card--visaelectron .rccs__card__background{background:linear-gradient(25deg,#0f509e,#1399cd)}.rccs__card--visa .rccs__issuer,.rccs__card--visaelectron .rccs__issuer{background-size:75%}.rccs__card--visa .rccs__issuer{background-image:url(\"data:image/svg+xml;base64,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\")}.rccs__card--visaelectron .rccs__issuer{background-image:url(\"data:image/svg+xml;base64,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\")}.rccs__number{clear:both;font-family:Consolas,Courier,monospace;font-size:20px;left:10%;position:absolute;top:45%}.rccs__number.rccs__number--large{font-size:17px}.rccs__name{font-family:Consolas,Courier,monospace;font-size:17px;left:10%;overflow:hidden;text-align:left;text-overflow:ellipsis;text-transform:uppercase;width:60%}.rccs__expiry,.rccs__name{bottom:15%;line-height:1;position:absolute}.rccs__expiry{font-size:0;right:10%}.rccs__expiry>*{vertical-align:middle}.rccs__expiry__valid{font-size:10px;margin-bottom:5px}.rccs__expiry__value{font-family:Consolas,Courier,monospace;font-size:16px}.rccs__cvc,.rccs__expiry,.rccs__name,.rccs__number{opacity:.5;transition:opacity .3s}.rccs__chip{background-image:url(\"data:image/svg+xml;base64,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\");height:26.36364px;left:10%;width:41.42857px}.rccs__chip,.rccs__issuer{background-repeat:no-repeat;background-size:contain;position:absolute;top:10%}.rccs__issuer{background-position:100% 0;height:23%;right:10%;width:40%}.rccs__stripe{background-color:#2a1d16;height:22%;left:0;position:absolute;top:9%;width:100%}.rccs__signature{background:repeating-linear-gradient(.1deg,#fff 20%,#fff 40%,#fea 0,#fea 44%,#fff 0);height:18%;left:5%;position:absolute;top:35%;width:75%}.rccs__cvc{color:#222;font-size:14px;left:67%;line-height:1;top:42%}.rccs__cvc,.rccs__cvc__front{font-family:Consolas,Courier,monospace;position:absolute}.rccs__cvc__front{font-size:11.9px;opacity:0;right:10%;top:38%;visibility:hidden}.rccs--filled{opacity:.8!important}.rccs--focused{font-weight:700;opacity:1!important}html{height:100%}*{outline:none}*,:after,:before{box-sizing:border-box}body{display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-flow:column nowrap;flex-flow:column nowrap;min-width:282px;min-height:100vh;font-family:Lato,Arial,Enriqueta,Open Sans,serif;font-size:14px;line-height:1.25;color:#5d5d5d;background:#252525;position:static;overflow-x:hidden}main{flex:1 0 auto}dd,dl,dt,h1,h2,h3,h4,h5,h6,li,p,ul{margin:0;padding:0;list-style:none}h1,h2,h3,h4{font-family:Lato,sans-serif}h1,h2,h3,h4,h5,h6,p{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}a,a:focus,button,button:focus,input,input:focus{outline:none}svg:not(:root){overflow:hidden}:not(.badge){border-radius:0}a{color:#9e937e;background-color:transparent!important;transition:color .15s ease-out,background-color .15s ease-out;cursor:pointer;text-decoration:none}a:active,a:focus,a:hover{color:#d3af71;text-decoration:none}.container-fluid.no-margin,.container.no-margin{margin:0;padding:0}@media (min-width:767px) and (max-width:768px){.hidden-xs{display:none}}.body-container{padding-top:60px;padding-bottom:60px}.section-heading{border-bottom:1px solid #e1e1e1;padding-bottom:10px;font-size:24px;color:#b18433}@media (max-width:500px){.section-heading{display:none}}.button-primary{border:1px solid #000;padding:12px 40px;display:inline-block;color:#fff;background:#000;font-family:Lato,sans-serif;font-size:14px;font-weight:400;text-transform:uppercase;letter-spacing:1px;cursor:pointer;transition:all .3s ease-in-out}.button-primary.button-small{height:30px;padding:0 10px;font-size:11px;line-height:30px}.button-primary.button-green{border-color:#4eaf79;background:#4eaf79}.button-primary.button-green:hover{border-color:#000;color:#fff;background:#000}.button-primary.button-white{color:#000;background:#fff}.button-primary.button-white:hover{color:#fff;background:#000}.button-primary.button-red{width:40px;height:36px;border-color:#d91604;padding:0;line-height:36px;text-align:center;background:#d91604}.button-primary.button-red:hover{border-color:#000;color:#fff;background:#000}.button-primary:hover{color:#000;background:#fff}.button-secondary{border:1px solid #d3af71;padding:12px 40px;color:#fff;background:#d3af71;font-family:Lato,sans-serif;font-size:14px;font-weight:400;text-transform:uppercase;letter-spacing:1px;cursor:pointer;transition:all .3s ease-in-out}.button-secondary.inv{color:#000;border:1px solid #fff;background:#fff;width:100%;text-align:center}.button-secondary.inv:hover{color:#fff;background:#d3af71}.button-secondary.button-small{height:30px;padding:0 10px;font-size:11px;line-height:30px}.button-secondary:hover{color:#000;background:#fff}.button-secondary[disabled]{cursor:not-allowed;pointer-events:none;background-color:#cccfce!important;border:none!important;color:#fff}.button-wide{width:100%;align-content:center;align-self:center}.button-cancel{border:1px solid #252525;padding:12px 40px;color:#dcccae;background:#252525;font-family:Lato,sans-serif;font-size:14px;font-weight:400;text-transform:uppercase;letter-spacing:1px;cursor:pointer;transition:all .3s ease-in-out}.button-cancel.button-small{height:30px;padding:0 10px;font-size:11px;line-height:30px}.button-cancel.dropdown-toggle.btn.btn-default,.button-cancel.dropdown-toggle.btn:active,.button-cancel.dropdown-toggle.btn:focus,.button-cancel.dropdown-toggle.btn:hover{color:#dcccae;background:#252525}#modal-zone-selector .dropdown-menu,#zone-selector .dropdown-menu{font-family:Lato;background:#252525;margin-top:0}#modal-zone-selector .dropdown-menu li,#zone-selector .dropdown-menu li{border-bottom:2px solid #252525;background-color:#252525;border:0;text-align:left}#modal-zone-selector .dropdown-menu li:hover,#zone-selector .dropdown-menu li:hover{border-left:2px solid #b18433}#modal-zone-selector .dropdown-menu li a,#zone-selector .dropdown-menu li a{color:#dcccae}#modal-zone-selector .dropdown-menu li a:hover,#zone-selector .dropdown-menu li a:hover{color:#b18433;background:#252525!important}#modal-zone-selector .modal-footer .button-secondary,#zone-selector .modal-footer .button-secondary{background-color:#b18433;border:1px solid #b18433}#modal-zone-selector .modal-footer .button-secondary:hover,#zone-selector .modal-footer .button-secondary:hover{background-color:#dcccae;border:1px solid #dcccae;color:#000}#modal-zone-selector .modal-footer .button-cancel,#zone-selector .modal-footer .button-cancel{background-color:#68583c;border:1px solid #68583c}#modal-zone-selector .modal-footer .button-cancel:hover,#zone-selector .modal-footer .button-cancel:hover{background-color:#9e937e;border:1px solid #9e937e;color:#000}#modal-zone-selector .municipality-selector{margin-left:15px}@media (max-width:767px){#modal-zone-selector .municipality-selector{margin-left:0;margin-top:15px}}.margin-top-20{margin-top:20px!important}.margin-top-30{margin-top:30px!important}.margin-top-50{margin-top:50px!important}.margin-top-xs-20{margin-top:20px!important}.margin-bottom-50{margin-bottom:50px!important}.margin-bottom-20{margin-bottom:20px!important}.margin-left-40{margin-left:40px}.margin-right-40{margin-right:40px}.redux-lazy-scroll{overflow:hidden!important}.primary-input-field{width:100%;height:40px;border:1px solid #e1e1e1;padding:0 25px;background:#fff;border-radius:25px}.js-image-zoom__zoomed-image{z-index:999999}.infinite-loader{width:100%;height:40px;position:fixed;bottom:0;left:0;z-index:99;color:#fff;text-align:center;line-height:40px;background:#4eaf79}.infinite-loader .glyphicon{padding:0 10px}.button-corner{width:auto;font-size:16px;display:inline-block;height:34px;border-radius:20px!important;line-height:23px;padding:5px 30px;border:1px solid #d3af71;background-color:#d3af71!important;color:#fff!important;position:relative;transition:color .15s ease-out,background-color .15s ease-out,border-color .15s ease-out}.button-corner:hover{color:#d3af71!important;background-color:transparent!important}.button-corner-inverter{width:auto;font-size:16px;display:inline-block;min-height:34px;border-radius:20px!important;line-height:23px;padding:5px 30px;color:#d3af71;background-color:transparent;border:1px solid #d3af71;position:relative;transition:color .15s ease-out,background-color .15s ease-out,border-color .15s ease-out}.button-corner-inverter:hover{background-color:#d3af71!important;color:#fff!important}.rotate-animation{-webkit-animation-name:spin;-webkit-animation-duration:2s;-webkit-animation-iteration-count:infinite;-webkit-animation-timing-function:linear;-moz-animation-name:spin;-moz-animation-duration:2s;-moz-animation-iteration-count:infinite;-moz-animation-timing-function:linear;-ms-animation-name:spin;-ms-animation-duration:2s;-ms-animation-iteration-count:infinite;-ms-animation-timing-function:linear;animation-name:spin;animation-duration:2s;animation-iteration-count:infinite;animation-timing-function:linear}@keyframes spin{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}@media (max-width:767px){.body-container{padding-top:30px;padding-bottom:30px}.section-heading{font-size:18px}.homepage-slider .carousel-control{display:none}}@media (min-width:768px) and (max-width:1023px){.homepage-slider .carousel-control{width:8%}}.close-toastr{display:none}.copyright p{font-family:Lato!important}@supports (-webkit-touch-callout:none){input,select:focus,textarea{font-size:16px!important}}#root.disabled{position:absolute;overflow:hidden;height:0;pointer-events:none}.actions-top-cart__contain__btn{color:#fff!important;background-color:#b18433!important;border:none}.actions-top-cart__contain__btn:active,.actions-top-cart__contain__btn:focus,.actions-top-cart__contain__btn:hover{background-color:#9e937e!important;color:#fff!important}.cc-number-wrapper{display:flex}.cc-number-wrapper__input{width:85%}.cc-number-wrapper__card-logo{width:15%;margin-top:40px}.cc-number-wrapper__card-logo img{height:48px;width:48px}@media (max-width:991px){.cc-number-wrapper__card-logo{display:none}.cc-number-wrapper__input{width:100%}}", ""]);
	
	// exports


/***/ },
/* 884 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(24)();
	// imports
	
	
	// module
	exports.push([module.id, "\n/*! Modified from font-awesome helper CSS classes - PIXEDEN\n *  Font Awesome 4.0.3 by @davegandy - http://fontawesome.io - @fontawesome\n *  License - http://fontawesome.io/license (CSS: MIT License)\n */.pe-lg{font-size:1.3333333333333333em;line-height:.75em;vertical-align:-15%}.pe-2x{font-size:2em}.pe-3x{font-size:3em}.pe-4x{font-size:4em}.pe-5x{font-size:5em}.pe-fw{width:1.2857142857142858em;text-align:center}.pe-ul{padding-left:0;margin-left:2.142857142857143em;list-style-type:none}.pe-ul>li{position:relative}.pe-li{position:absolute;left:-2.142857142857143em;width:2.142857142857143em;top:.14285714285714285em;text-align:center}.pe-li.pe-lg{left:-1.8571428571428572em}.pe-border{padding:.2em .25em .15em;border:.08em solid #eee;border-radius:.1em}.pull-right{float:right}.pull-left{float:left}.pe.pull-left{margin-right:.3em}.pe.pull-right{margin-left:.3em}.pe-spin{animation:spin 2s infinite linear}@keyframes spin{0%{transform:rotate(0deg)}to{transform:rotate(359deg)}}.pe-rotate-90{filter:progid:DXImageTransform.Microsoft.BasicImage(rotation=1);transform:rotate(90deg)}.pe-rotate-180{filter:progid:DXImageTransform.Microsoft.BasicImage(rotation=2);transform:rotate(180deg)}.pe-rotate-270{filter:progid:DXImageTransform.Microsoft.BasicImage(rotation=3);transform:rotate(270deg)}.pe-flip-horizontal{filter:progid:DXImageTransform.Microsoft.BasicImage(rotation=0,mirror=1);transform:scaleX(-1)}.pe-flip-vertical{filter:progid:DXImageTransform.Microsoft.BasicImage(rotation=2,mirror=1);transform:scaleY(-1)}.pe-stack{position:relative;display:inline-block;width:2em;height:2em;line-height:2em;vertical-align:middle}.pe-stack-1x,.pe-stack-2x{position:absolute;left:0;width:100%;text-align:center}.pe-stack-1x{line-height:inherit}.pe-stack-2x{font-size:2em}.pe-inverse{color:#fff}.pe-va{vertical-align:middle}.pe-border{border:.08em solid #eaeaea}[class*=\" pe-7f-\"],[class^=pe-7f-]{display:inline-block}", ""]);
	
	// exports


/***/ },
/* 885 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(24)();
	// imports
	
	
	// module
	exports.push([module.id, "@font-face{font-family:Pe-icon-7-filled;src:url(" + __webpack_require__(1601) + ");src:url(" + __webpack_require__(1600) + "?#iefixkinggk) format(\"embedded-opentype\"),url(" + __webpack_require__(1604) + ") format(\"woff\"),url(" + __webpack_require__(1603) + ") format(\"truetype\"),url(" + __webpack_require__(1602) + "#Pe-icon-7-filled) format(\"svg\");font-weight:400;font-style:normal}[class*=\" pe-7f-\"],[class^=pe-7f-]{display:inline-block;font-family:Pe-icon-7-filled;speak:none;font-style:normal;font-weight:400;font-variant:normal;text-transform:none;line-height:1;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.pe-7f-album:before{content:\"\\E625\"}.pe-7f-arc:before{content:\"\\E626\"}.pe-7f-back-2:before{content:\"\\E627\"}.pe-7f-bandaid:before{content:\"\\E628\"}.pe-7f-car:before{content:\"\\E629\"}.pe-7f-diamond:before{content:\"\\E62A\"}.pe-7f-door-lock:before{content:\"\\E62B\"}.pe-7f-eyedropper:before{content:\"\\E62C\"}.pe-7f-female:before{content:\"\\E62D\"}.pe-7f-gym:before{content:\"\\E62E\"}.pe-7f-hammer:before{content:\"\\E62F\"}.pe-7f-headphones:before{content:\"\\E630\"}.pe-7f-helm:before{content:\"\\E631\"}.pe-7f-hourglass:before{content:\"\\E632\"}.pe-7f-leaf:before{content:\"\\E633\"}.pe-7f-magic-wand:before{content:\"\\E634\"}.pe-7f-male:before{content:\"\\E635\"}.pe-7f-map-2:before{content:\"\\E636\"}.pe-7f-next-2:before{content:\"\\E637\"}.pe-7f-paint-bucket:before{content:\"\\E638\"}.pe-7f-pendrive:before{content:\"\\E639\"}.pe-7f-photo:before{content:\"\\E63A\"}.pe-7f-piggy:before{content:\"\\E63B\"}.pe-7f-plugin:before{content:\"\\E63C\"}.pe-7f-refresh-2:before{content:\"\\E63D\"}.pe-7f-rocket:before{content:\"\\E63E\"}.pe-7f-settings:before{content:\"\\E63F\"}.pe-7f-shield:before{content:\"\\E640\"}.pe-7f-smile:before{content:\"\\E641\"}.pe-7f-usb:before{content:\"\\E642\"}.pe-7f-vector:before{content:\"\\E643\"}.pe-7f-wine:before{content:\"\\E644\"}.pe-7f-cloud-upload:before{content:\"\\E605\"}.pe-7f-angle-up:before{content:\"\\E601\"}.pe-7f-cloud-download:before{content:\"\\E606\"}.pe-7f-angle-right:before{content:\"\\E602\"}.pe-7f-angle-left:before{content:\"\\E603\"}.pe-7f-angle-down:before{content:\"\\E604\"}.pe-7f-wallet:before{content:\"\\E680\"}.pe-7f-volume2:before{content:\"\\E681\"}.pe-7f-volume1:before{content:\"\\E682\"}.pe-7f-voicemail:before{content:\"\\E683\"}.pe-7f-video:before{content:\"\\E684\"}.pe-7f-user:before{content:\"\\E685\"}.pe-7f-upload:before{content:\"\\E686\"}.pe-7f-unlock:before{content:\"\\E687\"}.pe-7f-umbrella:before{content:\"\\E688\"}.pe-7f-trash:before{content:\"\\E689\"}.pe-7f-tools:before{content:\"\\E68A\"}.pe-7f-timer:before{content:\"\\E68B\"}.pe-7f-ticket:before{content:\"\\E68C\"}.pe-7f-target:before{content:\"\\E68D\"}.pe-7f-sun:before{content:\"\\E68E\"}.pe-7f-study:before{content:\"\\E68F\"}.pe-7f-stopwatch:before{content:\"\\E690\"}.pe-7f-star:before{content:\"\\E691\"}.pe-7f-speaker:before{content:\"\\E692\"}.pe-7f-signal:before{content:\"\\E693\"}.pe-7f-shuffle:before{content:\"\\E694\"}.pe-7f-shopbag:before{content:\"\\E695\"}.pe-7f-share:before{content:\"\\E696\"}.pe-7f-server:before{content:\"\\E697\"}.pe-7f-search:before{content:\"\\E698\"}.pe-7f-science:before{content:\"\\E699\"}.pe-7f-ribbon:before{content:\"\\E69A\"}.pe-7f-repeat:before{content:\"\\E69B\"}.pe-7f-refresh:before{content:\"\\E69C\"}.pe-7f-refresh-cloud:before{content:\"\\E69D\"}.pe-7f-radio:before{content:\"\\E69E\"}.pe-7f-print:before{content:\"\\E69F\"}.pe-7f-prev:before{content:\"\\E6A0\"}.pe-7f-power:before{content:\"\\E6A1\"}.pe-7f-portfolio:before{content:\"\\E6A2\"}.pe-7f-plus:before{content:\"\\E6A3\"}.pe-7f-play:before{content:\"\\E6A4\"}.pe-7f-plane:before{content:\"\\E6A5\"}.pe-7f-photo-gallery:before{content:\"\\E6A6\"}.pe-7f-phone:before{content:\"\\E6A7\"}.pe-7f-pen:before{content:\"\\E6A8\"}.pe-7f-paper-plane:before{content:\"\\E6A9\"}.pe-7f-bluetooth:before{content:\"\\E607\"}.pe-7f-paint:before{content:\"\\E6AA\"}.pe-7f-wristwatch:before{content:\"\\E608\"}.pe-7f-notebook:before{content:\"\\E6AB\"}.pe-7f-world:before{content:\"\\E609\"}.pe-7f-note:before{content:\"\\E6AC\"}.pe-7f-volume:before{content:\"\\E60A\"}.pe-7f-paperclip:before{content:\"\\E614\"}.pe-7f-news-paper:before{content:\"\\E6AE\"}.pe-7f-note2:before{content:\"\\E615\"}.pe-7f-musiclist:before{content:\"\\E6AF\"}.pe-7f-network:before{content:\"\\E616\"}.pe-7f-music:before{content:\"\\E6B0\"}.pe-7f-mouse:before{content:\"\\E6B1\"}.pe-7f-cash:before{content:\"\\E621\"}.pe-7f-more:before{content:\"\\E6B2\"}.pe-7f-add-user:before{content:\"\\E622\"}.pe-7f-moon:before{content:\"\\E6B3\"}.pe-7f-way:before{content:\"\\E623\"}.pe-7f-monitor:before{content:\"\\E6B4\"}.pe-7f-bottom-arrow:before{content:\"\\E624\"}.pe-7f-micro:before{content:\"\\E6B5\"}.pe-7f-medal:before{content:\"\\E618\"}.pe-7f-menu:before{content:\"\\E6B6\"}.pe-7f-like2:before{content:\"\\E619\"}.pe-7f-map:before{content:\"\\E6B7\"}.pe-7f-left-arrow:before{content:\"\\E61A\"}.pe-7f-map-marker:before{content:\"\\E6B8\"}.pe-7f-key:before{content:\"\\E61B\"}.pe-7f-mail:before{content:\"\\E6B9\"}.pe-7f-joy:before{content:\"\\E61C\"}.pe-7f-mail-open:before{content:\"\\E6BA\"}.pe-7f-id:before{content:\"\\E61D\"}.pe-7f-mail-open-file:before{content:\"\\E6BB\"}.pe-7f-film:before{content:\"\\E61E\"}.pe-7f-magnet:before{content:\"\\E6BC\"}.pe-7f-disk:before{content:\"\\E61F\"}.pe-7f-loop:before{content:\"\\E6BD\"}.pe-7f-delete-user:before{content:\"\\E620\"}.pe-7f-look:before{content:\"\\E6BE\"}.pe-7f-pin:before{content:\"\\E613\"}.pe-7f-lock:before{content:\"\\E6BF\"}.pe-7f-users:before{content:\"\\E60B\"}.pe-7f-lintern:before{content:\"\\E6C0\"}.pe-7f-user-female:before{content:\"\\E60C\"}.pe-7f-link:before{content:\"\\E6C1\"}.pe-7f-up-arrow:before{content:\"\\E60D\"}.pe-7f-like:before{content:\"\\E6C2\"}.pe-7f-switch:before{content:\"\\E60E\"}.pe-7f-light:before{content:\"\\E6C3\"}.pe-7f-scissors:before{content:\"\\E60F\"}.pe-7f-less:before{content:\"\\E6C4\"}.pe-7f-safe:before{content:\"\\E610\"}.pe-7f-keypad:before{content:\"\\E6C5\"}.pe-7f-right-arrow:before{content:\"\\E611\"}.pe-7f-junk:before{content:\"\\E6C6\"}.pe-7f-plug:before{content:\"\\E612\"}.pe-7f-info:before{content:\"\\E6C7\"}.pe-7f-mute:before{content:\"\\E617\"}.pe-7f-home:before{content:\"\\E6C8\"}.pe-7f-help2:before{content:\"\\E6C9\"}.pe-7f-help1:before{content:\"\\E6CA\"}.pe-7f-graph3:before{content:\"\\E6CC\"}.pe-7f-graph2:before{content:\"\\E6CD\"}.pe-7f-graph1:before{content:\"\\E6CE\"}.pe-7f-graph:before{content:\"\\E6CF\"}.pe-7f-global:before{content:\"\\E6D0\"}.pe-7f-gleam:before{content:\"\\E6D1\"}.pe-7f-glasses:before{content:\"\\E6D2\"}.pe-7f-gift:before{content:\"\\E6D3\"}.pe-7f-folder:before{content:\"\\E6D4\"}.pe-7f-flag:before{content:\"\\E6D5\"}.pe-7f-filter:before{content:\"\\E6D6\"}.pe-7f-file:before{content:\"\\E6D7\"}.pe-7f-expand:before{content:\"\\E6D8\"}.pe-7f-expand1:before{content:\"\\E6D9\"}.pe-7f-edit:before{content:\"\\E6DA\"}.pe-7f-drop:before{content:\"\\E6DB\"}.pe-7f-drawer:before{content:\"\\E6DC\"}.pe-7f-download:before{content:\"\\E6DD\"}.pe-7f-display2:before{content:\"\\E6DE\"}.pe-7f-display1:before{content:\"\\E6DF\"}.pe-7f-diskette:before{content:\"\\E6E0\"}.pe-7f-date:before{content:\"\\E6E1\"}.pe-7f-cup:before{content:\"\\E6E2\"}.pe-7f-culture:before{content:\"\\E6E3\"}.pe-7f-crop:before{content:\"\\E6E4\"}.pe-7f-credit:before{content:\"\\E6E5\"}.pe-7f-copy-file:before{content:\"\\E6E6\"}.pe-7f-config:before{content:\"\\E6E7\"}.pe-7f-compass:before{content:\"\\E6E8\"}.pe-7f-comment:before{content:\"\\E6E9\"}.pe-7f-coffee:before{content:\"\\E6EA\"}.pe-7f-cloud:before{content:\"\\E6EB\"}.pe-7f-clock:before{content:\"\\E6EC\"}.pe-7f-check:before{content:\"\\E6ED\"}.pe-7f-chat:before{content:\"\\E6EE\"}.pe-7f-cart:before{content:\"\\E6EF\"}.pe-7f-camera:before{content:\"\\E6F0\"}.pe-7f-call:before{content:\"\\E6F1\"}.pe-7f-calculator:before{content:\"\\E6F2\"}.pe-7f-browser:before{content:\"\\E6F3\"}.pe-7f-box1:before{content:\"\\E6F5\"}.pe-7f-box:before{content:\"\\E6F6\"}.pe-7f-bookmarks:before{content:\"\\E6F7\"}.pe-7f-bicycle:before{content:\"\\E6F8\"}.pe-7f-bell:before{content:\"\\E6F9\"}.pe-7f-battery:before{content:\"\\E6FA\"}.pe-7f-ball:before{content:\"\\E6FB\"}.pe-7f-back:before{content:\"\\E6FC\"}.pe-7f-attention:before{content:\"\\E6FD\"}.pe-7f-anchor:before{content:\"\\E6FE\"}.pe-7f-albums:before{content:\"\\E6FF\"}.pe-7f-alarm:before{content:\"\\E700\"}.pe-7f-airplay:before{content:\"\\E701\"}.pe-7f-close:before{content:\"\\E600\"}.pe-7f-next:before{content:\"\\E6AD\"}", ""]);
	
	// exports


/***/ },
/* 886 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(24)();
	// imports
	
	
	// module
	exports.push([module.id, "/*!\n * Bootstrap v3.3.7 (http://getbootstrap.com)\n * Copyright 2011-2016 Twitter, Inc.\n * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)\n */\n/*! normalize.css v3.0.3 | MIT License | github.com/necolas/normalize.css */html{font-family:sans-serif;-webkit-text-size-adjust:100%;-ms-text-size-adjust:100%}body{margin:0}article,aside,details,figcaption,figure,footer,header,hgroup,main,menu,nav,section,summary{display:block}audio,canvas,progress,video{display:inline-block;vertical-align:baseline}audio:not([controls]){display:none;height:0}[hidden],template{display:none}a{background-color:transparent}a:active,a:hover{outline:0}abbr[title]{border-bottom:1px dotted}b,strong{font-weight:700}dfn{font-style:italic}h1{margin:.67em 0;font-size:2em}mark{color:#000;background:#ff0}small{font-size:80%}sub,sup{position:relative;font-size:75%;line-height:0;vertical-align:baseline}sup{top:-.5em}sub{bottom:-.25em}img{border:0}svg:not(:root){overflow:hidden}figure{margin:1em 40px}hr{height:0;box-sizing:content-box}pre{overflow:auto}code,kbd,pre,samp{font-family:monospace,monospace;font-size:1em}button,input,optgroup,select,textarea{margin:0;font:inherit;color:inherit}button{overflow:visible}button,select{text-transform:none}button,html input[type=button],input[type=reset],input[type=submit]{-webkit-appearance:button;cursor:pointer}button[disabled],html input[disabled]{cursor:default}button::-moz-focus-inner,input::-moz-focus-inner{padding:0;border:0}input{line-height:normal}input[type=checkbox],input[type=radio]{box-sizing:border-box;padding:0}input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{height:auto}input[type=search]{box-sizing:content-box;-webkit-appearance:textfield}input[type=search]::-webkit-search-cancel-button,input[type=search]::-webkit-search-decoration{-webkit-appearance:none}fieldset{padding:.35em .625em .75em;margin:0 2px;border:1px solid silver}textarea{overflow:auto}optgroup{font-weight:700}table{border-spacing:0;border-collapse:collapse}td,th{padding:0}\n/*! Source: https://github.com/h5bp/html5-boilerplate/blob/master/src/css/main.css */@media print{*,:after,:before{color:#000!important;text-shadow:none!important;background:transparent!important;box-shadow:none!important}a,a:visited{text-decoration:underline}a[href]:after{content:\" (\" attr(href) \")\"}abbr[title]:after{content:\" (\" attr(title) \")\"}a[href^=\"#\"]:after,a[href^=\"javascript:\"]:after{content:\"\"}blockquote,pre{border:1px solid #999;page-break-inside:avoid}thead{display:table-header-group}img,tr{page-break-inside:avoid}img{max-width:100%!important}h2,h3,p{orphans:3;widows:3}h2,h3{page-break-after:avoid}.navbar{display:none}.btn>.caret,.dropup>.btn>.caret{border-top-color:#000!important}.label{border:1px solid #000}.table{border-collapse:collapse!important}.table td,.table th{background-color:#fff!important}.table-bordered td,.table-bordered th{border:1px solid #ddd!important}}@font-face{font-family:Glyphicons Halflings;src:url(" + __webpack_require__(461) + ");src:url(" + __webpack_require__(461) + "?#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__(1599) + ") format(\"woff2\"),url(" + __webpack_require__(1598) + ") format(\"woff\"),url(" + __webpack_require__(1597) + ") format(\"truetype\"),url(" + __webpack_require__(1596) + "#glyphicons_halflingsregular) format(\"svg\")}.glyphicon{position:relative;top:1px;display:inline-block;font-family:Glyphicons Halflings;font-style:normal;font-weight:400;line-height:1;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.glyphicon-asterisk:before{content:\"*\"}.glyphicon-plus:before{content:\"+\"}.glyphicon-eur:before,.glyphicon-euro:before{content:\"\\20AC\"}.glyphicon-minus:before{content:\"\\2212\"}.glyphicon-cloud:before{content:\"\\2601\"}.glyphicon-envelope:before{content:\"\\2709\"}.glyphicon-pencil:before{content:\"\\270F\"}.glyphicon-glass:before{content:\"\\E001\"}.glyphicon-music:before{content:\"\\E002\"}.glyphicon-search:before{content:\"\\E003\"}.glyphicon-heart:before{content:\"\\E005\"}.glyphicon-star:before{content:\"\\E006\"}.glyphicon-star-empty:before{content:\"\\E007\"}.glyphicon-user:before{content:\"\\E008\"}.glyphicon-film:before{content:\"\\E009\"}.glyphicon-th-large:before{content:\"\\E010\"}.glyphicon-th:before{content:\"\\E011\"}.glyphicon-th-list:before{content:\"\\E012\"}.glyphicon-ok:before{content:\"\\E013\"}.glyphicon-remove:before{content:\"\\E014\"}.glyphicon-zoom-in:before{content:\"\\E015\"}.glyphicon-zoom-out:before{content:\"\\E016\"}.glyphicon-off:before{content:\"\\E017\"}.glyphicon-signal:before{content:\"\\E018\"}.glyphicon-cog:before{content:\"\\E019\"}.glyphicon-trash:before{content:\"\\E020\"}.glyphicon-home:before{content:\"\\E021\"}.glyphicon-file:before{content:\"\\E022\"}.glyphicon-time:before{content:\"\\E023\"}.glyphicon-road:before{content:\"\\E024\"}.glyphicon-download-alt:before{content:\"\\E025\"}.glyphicon-download:before{content:\"\\E026\"}.glyphicon-upload:before{content:\"\\E027\"}.glyphicon-inbox:before{content:\"\\E028\"}.glyphicon-play-circle:before{content:\"\\E029\"}.glyphicon-repeat:before{content:\"\\E030\"}.glyphicon-refresh:before{content:\"\\E031\"}.glyphicon-list-alt:before{content:\"\\E032\"}.glyphicon-lock:before{content:\"\\E033\"}.glyphicon-flag:before{content:\"\\E034\"}.glyphicon-headphones:before{content:\"\\E035\"}.glyphicon-volume-off:before{content:\"\\E036\"}.glyphicon-volume-down:before{content:\"\\E037\"}.glyphicon-volume-up:before{content:\"\\E038\"}.glyphicon-qrcode:before{content:\"\\E039\"}.glyphicon-barcode:before{content:\"\\E040\"}.glyphicon-tag:before{content:\"\\E041\"}.glyphicon-tags:before{content:\"\\E042\"}.glyphicon-book:before{content:\"\\E043\"}.glyphicon-bookmark:before{content:\"\\E044\"}.glyphicon-print:before{content:\"\\E045\"}.glyphicon-camera:before{content:\"\\E046\"}.glyphicon-font:before{content:\"\\E047\"}.glyphicon-bold:before{content:\"\\E048\"}.glyphicon-italic:before{content:\"\\E049\"}.glyphicon-text-height:before{content:\"\\E050\"}.glyphicon-text-width:before{content:\"\\E051\"}.glyphicon-align-left:before{content:\"\\E052\"}.glyphicon-align-center:before{content:\"\\E053\"}.glyphicon-align-right:before{content:\"\\E054\"}.glyphicon-align-justify:before{content:\"\\E055\"}.glyphicon-list:before{content:\"\\E056\"}.glyphicon-indent-left:before{content:\"\\E057\"}.glyphicon-indent-right:before{content:\"\\E058\"}.glyphicon-facetime-video:before{content:\"\\E059\"}.glyphicon-picture:before{content:\"\\E060\"}.glyphicon-map-marker:before{content:\"\\E062\"}.glyphicon-adjust:before{content:\"\\E063\"}.glyphicon-tint:before{content:\"\\E064\"}.glyphicon-edit:before{content:\"\\E065\"}.glyphicon-share:before{content:\"\\E066\"}.glyphicon-check:before{content:\"\\E067\"}.glyphicon-move:before{content:\"\\E068\"}.glyphicon-step-backward:before{content:\"\\E069\"}.glyphicon-fast-backward:before{content:\"\\E070\"}.glyphicon-backward:before{content:\"\\E071\"}.glyphicon-play:before{content:\"\\E072\"}.glyphicon-pause:before{content:\"\\E073\"}.glyphicon-stop:before{content:\"\\E074\"}.glyphicon-forward:before{content:\"\\E075\"}.glyphicon-fast-forward:before{content:\"\\E076\"}.glyphicon-step-forward:before{content:\"\\E077\"}.glyphicon-eject:before{content:\"\\E078\"}.glyphicon-chevron-left:before{content:\"\\E079\"}.glyphicon-chevron-right:before{content:\"\\E080\"}.glyphicon-plus-sign:before{content:\"\\E081\"}.glyphicon-minus-sign:before{content:\"\\E082\"}.glyphicon-remove-sign:before{content:\"\\E083\"}.glyphicon-ok-sign:before{content:\"\\E084\"}.glyphicon-question-sign:before{content:\"\\E085\"}.glyphicon-info-sign:before{content:\"\\E086\"}.glyphicon-screenshot:before{content:\"\\E087\"}.glyphicon-remove-circle:before{content:\"\\E088\"}.glyphicon-ok-circle:before{content:\"\\E089\"}.glyphicon-ban-circle:before{content:\"\\E090\"}.glyphicon-arrow-left:before{content:\"\\E091\"}.glyphicon-arrow-right:before{content:\"\\E092\"}.glyphicon-arrow-up:before{content:\"\\E093\"}.glyphicon-arrow-down:before{content:\"\\E094\"}.glyphicon-share-alt:before{content:\"\\E095\"}.glyphicon-resize-full:before{content:\"\\E096\"}.glyphicon-resize-small:before{content:\"\\E097\"}.glyphicon-exclamation-sign:before{content:\"\\E101\"}.glyphicon-gift:before{content:\"\\E102\"}.glyphicon-leaf:before{content:\"\\E103\"}.glyphicon-fire:before{content:\"\\E104\"}.glyphicon-eye-open:before{content:\"\\E105\"}.glyphicon-eye-close:before{content:\"\\E106\"}.glyphicon-warning-sign:before{content:\"\\E107\"}.glyphicon-plane:before{content:\"\\E108\"}.glyphicon-calendar:before{content:\"\\E109\"}.glyphicon-random:before{content:\"\\E110\"}.glyphicon-comment:before{content:\"\\E111\"}.glyphicon-magnet:before{content:\"\\E112\"}.glyphicon-chevron-up:before{content:\"\\E113\"}.glyphicon-chevron-down:before{content:\"\\E114\"}.glyphicon-retweet:before{content:\"\\E115\"}.glyphicon-shopping-cart:before{content:\"\\E116\"}.glyphicon-folder-close:before{content:\"\\E117\"}.glyphicon-folder-open:before{content:\"\\E118\"}.glyphicon-resize-vertical:before{content:\"\\E119\"}.glyphicon-resize-horizontal:before{content:\"\\E120\"}.glyphicon-hdd:before{content:\"\\E121\"}.glyphicon-bullhorn:before{content:\"\\E122\"}.glyphicon-bell:before{content:\"\\E123\"}.glyphicon-certificate:before{content:\"\\E124\"}.glyphicon-thumbs-up:before{content:\"\\E125\"}.glyphicon-thumbs-down:before{content:\"\\E126\"}.glyphicon-hand-right:before{content:\"\\E127\"}.glyphicon-hand-left:before{content:\"\\E128\"}.glyphicon-hand-up:before{content:\"\\E129\"}.glyphicon-hand-down:before{content:\"\\E130\"}.glyphicon-circle-arrow-right:before{content:\"\\E131\"}.glyphicon-circle-arrow-left:before{content:\"\\E132\"}.glyphicon-circle-arrow-up:before{content:\"\\E133\"}.glyphicon-circle-arrow-down:before{content:\"\\E134\"}.glyphicon-globe:before{content:\"\\E135\"}.glyphicon-wrench:before{content:\"\\E136\"}.glyphicon-tasks:before{content:\"\\E137\"}.glyphicon-filter:before{content:\"\\E138\"}.glyphicon-briefcase:before{content:\"\\E139\"}.glyphicon-fullscreen:before{content:\"\\E140\"}.glyphicon-dashboard:before{content:\"\\E141\"}.glyphicon-paperclip:before{content:\"\\E142\"}.glyphicon-heart-empty:before{content:\"\\E143\"}.glyphicon-link:before{content:\"\\E144\"}.glyphicon-phone:before{content:\"\\E145\"}.glyphicon-pushpin:before{content:\"\\E146\"}.glyphicon-usd:before{content:\"\\E148\"}.glyphicon-gbp:before{content:\"\\E149\"}.glyphicon-sort:before{content:\"\\E150\"}.glyphicon-sort-by-alphabet:before{content:\"\\E151\"}.glyphicon-sort-by-alphabet-alt:before{content:\"\\E152\"}.glyphicon-sort-by-order:before{content:\"\\E153\"}.glyphicon-sort-by-order-alt:before{content:\"\\E154\"}.glyphicon-sort-by-attributes:before{content:\"\\E155\"}.glyphicon-sort-by-attributes-alt:before{content:\"\\E156\"}.glyphicon-unchecked:before{content:\"\\E157\"}.glyphicon-expand:before{content:\"\\E158\"}.glyphicon-collapse-down:before{content:\"\\E159\"}.glyphicon-collapse-up:before{content:\"\\E160\"}.glyphicon-log-in:before{content:\"\\E161\"}.glyphicon-flash:before{content:\"\\E162\"}.glyphicon-log-out:before{content:\"\\E163\"}.glyphicon-new-window:before{content:\"\\E164\"}.glyphicon-record:before{content:\"\\E165\"}.glyphicon-save:before{content:\"\\E166\"}.glyphicon-open:before{content:\"\\E167\"}.glyphicon-saved:before{content:\"\\E168\"}.glyphicon-import:before{content:\"\\E169\"}.glyphicon-export:before{content:\"\\E170\"}.glyphicon-send:before{content:\"\\E171\"}.glyphicon-floppy-disk:before{content:\"\\E172\"}.glyphicon-floppy-saved:before{content:\"\\E173\"}.glyphicon-floppy-remove:before{content:\"\\E174\"}.glyphicon-floppy-save:before{content:\"\\E175\"}.glyphicon-floppy-open:before{content:\"\\E176\"}.glyphicon-credit-card:before{content:\"\\E177\"}.glyphicon-transfer:before{content:\"\\E178\"}.glyphicon-cutlery:before{content:\"\\E179\"}.glyphicon-header:before{content:\"\\E180\"}.glyphicon-compressed:before{content:\"\\E181\"}.glyphicon-earphone:before{content:\"\\E182\"}.glyphicon-phone-alt:before{content:\"\\E183\"}.glyphicon-tower:before{content:\"\\E184\"}.glyphicon-stats:before{content:\"\\E185\"}.glyphicon-sd-video:before{content:\"\\E186\"}.glyphicon-hd-video:before{content:\"\\E187\"}.glyphicon-subtitles:before{content:\"\\E188\"}.glyphicon-sound-stereo:before{content:\"\\E189\"}.glyphicon-sound-dolby:before{content:\"\\E190\"}.glyphicon-sound-5-1:before{content:\"\\E191\"}.glyphicon-sound-6-1:before{content:\"\\E192\"}.glyphicon-sound-7-1:before{content:\"\\E193\"}.glyphicon-copyright-mark:before{content:\"\\E194\"}.glyphicon-registration-mark:before{content:\"\\E195\"}.glyphicon-cloud-download:before{content:\"\\E197\"}.glyphicon-cloud-upload:before{content:\"\\E198\"}.glyphicon-tree-conifer:before{content:\"\\E199\"}.glyphicon-tree-deciduous:before{content:\"\\E200\"}.glyphicon-cd:before{content:\"\\E201\"}.glyphicon-save-file:before{content:\"\\E202\"}.glyphicon-open-file:before{content:\"\\E203\"}.glyphicon-level-up:before{content:\"\\E204\"}.glyphicon-copy:before{content:\"\\E205\"}.glyphicon-paste:before{content:\"\\E206\"}.glyphicon-alert:before{content:\"\\E209\"}.glyphicon-equalizer:before{content:\"\\E210\"}.glyphicon-king:before{content:\"\\E211\"}.glyphicon-queen:before{content:\"\\E212\"}.glyphicon-pawn:before{content:\"\\E213\"}.glyphicon-bishop:before{content:\"\\E214\"}.glyphicon-knight:before{content:\"\\E215\"}.glyphicon-baby-formula:before{content:\"\\E216\"}.glyphicon-tent:before{content:\"\\26FA\"}.glyphicon-blackboard:before{content:\"\\E218\"}.glyphicon-bed:before{content:\"\\E219\"}.glyphicon-apple:before{content:\"\\F8FF\"}.glyphicon-erase:before{content:\"\\E221\"}.glyphicon-hourglass:before{content:\"\\231B\"}.glyphicon-lamp:before{content:\"\\E223\"}.glyphicon-duplicate:before{content:\"\\E224\"}.glyphicon-piggy-bank:before{content:\"\\E225\"}.glyphicon-scissors:before{content:\"\\E226\"}.glyphicon-bitcoin:before,.glyphicon-btc:before,.glyphicon-xbt:before{content:\"\\E227\"}.glyphicon-jpy:before,.glyphicon-yen:before{content:\"\\A5\"}.glyphicon-rub:before,.glyphicon-ruble:before{content:\"\\20BD\"}.glyphicon-scale:before{content:\"\\E230\"}.glyphicon-ice-lolly:before{content:\"\\E231\"}.glyphicon-ice-lolly-tasted:before{content:\"\\E232\"}.glyphicon-education:before{content:\"\\E233\"}.glyphicon-option-horizontal:before{content:\"\\E234\"}.glyphicon-option-vertical:before{content:\"\\E235\"}.glyphicon-menu-hamburger:before{content:\"\\E236\"}.glyphicon-modal-window:before{content:\"\\E237\"}.glyphicon-oil:before{content:\"\\E238\"}.glyphicon-grain:before{content:\"\\E239\"}.glyphicon-sunglasses:before{content:\"\\E240\"}.glyphicon-text-size:before{content:\"\\E241\"}.glyphicon-text-color:before{content:\"\\E242\"}.glyphicon-text-background:before{content:\"\\E243\"}.glyphicon-object-align-top:before{content:\"\\E244\"}.glyphicon-object-align-bottom:before{content:\"\\E245\"}.glyphicon-object-align-horizontal:before{content:\"\\E246\"}.glyphicon-object-align-left:before{content:\"\\E247\"}.glyphicon-object-align-vertical:before{content:\"\\E248\"}.glyphicon-object-align-right:before{content:\"\\E249\"}.glyphicon-triangle-right:before{content:\"\\E250\"}.glyphicon-triangle-left:before{content:\"\\E251\"}.glyphicon-triangle-bottom:before{content:\"\\E252\"}.glyphicon-triangle-top:before{content:\"\\E253\"}.glyphicon-console:before{content:\"\\E254\"}.glyphicon-superscript:before{content:\"\\E255\"}.glyphicon-subscript:before{content:\"\\E256\"}.glyphicon-menu-left:before{content:\"\\E257\"}.glyphicon-menu-right:before{content:\"\\E258\"}.glyphicon-menu-down:before{content:\"\\E259\"}.glyphicon-menu-up:before{content:\"\\E260\"}*,:after,:before{box-sizing:border-box}html{font-size:10px;-webkit-tap-highlight-color:rgba(0,0,0,0)}body{font-family:Helvetica Neue,Helvetica,Arial,sans-serif;font-size:14px;line-height:1.42857143;color:#333;background-color:#fff}button,input,select,textarea{font-family:inherit;font-size:inherit;line-height:inherit}a{color:#337ab7;text-decoration:none}a:focus,a:hover{color:#23527c;text-decoration:underline}a:focus{outline:5px auto -webkit-focus-ring-color;outline-offset:-2px}figure{margin:0}img{vertical-align:middle}.carousel-inner>.item>a>img,.carousel-inner>.item>img,.img-responsive,.thumbnail>img,.thumbnail a>img{display:block;max-width:100%;height:auto}.img-rounded{border-radius:6px}.img-thumbnail{display:inline-block;max-width:100%;height:auto;padding:4px;line-height:1.42857143;background-color:#fff;border:1px solid #ddd;border-radius:4px;transition:all .2s ease-in-out}.img-circle{border-radius:50%}hr{margin-top:20px;margin-bottom:20px;border:0;border-top:1px solid #eee}.sr-only{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);border:0}.sr-only-focusable:active,.sr-only-focusable:focus{position:static;width:auto;height:auto;margin:0;overflow:visible;clip:auto}[role=button]{cursor:pointer}.h1,.h2,.h3,.h4,.h5,.h6,h1,h2,h3,h4,h5,h6{font-family:inherit;font-weight:500;line-height:1.1;color:inherit}.h1 .small,.h1 small,.h2 .small,.h2 small,.h3 .small,.h3 small,.h4 .small,.h4 small,.h5 .small,.h5 small,.h6 .small,.h6 small,h1 .small,h1 small,h2 .small,h2 small,h3 .small,h3 small,h4 .small,h4 small,h5 .small,h5 small,h6 .small,h6 small{font-weight:400;line-height:1;color:#777}.h1,.h2,.h3,h1,h2,h3{margin-top:20px;margin-bottom:10px}.h1 .small,.h1 small,.h2 .small,.h2 small,.h3 .small,.h3 small,h1 .small,h1 small,h2 .small,h2 small,h3 .small,h3 small{font-size:65%}.h4,.h5,.h6,h4,h5,h6{margin-top:10px;margin-bottom:10px}.h4 .small,.h4 small,.h5 .small,.h5 small,.h6 .small,.h6 small,h4 .small,h4 small,h5 .small,h5 small,h6 .small,h6 small{font-size:75%}.h1,h1{font-size:36px}.h2,h2{font-size:30px}.h3,h3{font-size:24px}.h4,h4{font-size:18px}.h5,h5{font-size:14px}.h6,h6{font-size:12px}p{margin:0 0 10px}.lead{margin-bottom:20px;font-size:16px;font-weight:300;line-height:1.4}@media (min-width:768px){.lead{font-size:21px}}.small,small{font-size:85%}.mark,mark{padding:.2em;background-color:#fcf8e3}.text-left{text-align:left}.text-right{text-align:right}.text-center{text-align:center}.text-justify{text-align:justify}.text-nowrap{white-space:nowrap}.text-lowercase{text-transform:lowercase}.text-uppercase{text-transform:uppercase}.text-capitalize{text-transform:capitalize}.text-muted{color:#777}.text-primary{color:#337ab7}a.text-primary:focus,a.text-primary:hover{color:#286090}.text-success{color:#3c763d}a.text-success:focus,a.text-success:hover{color:#2b542c}.text-info{color:#31708f}a.text-info:focus,a.text-info:hover{color:#245269}.text-warning{color:#8a6d3b}a.text-warning:focus,a.text-warning:hover{color:#66512c}.text-danger{color:#a94442}a.text-danger:focus,a.text-danger:hover{color:#843534}.bg-primary{color:#fff;background-color:#337ab7}a.bg-primary:focus,a.bg-primary:hover{background-color:#286090}.bg-success{background-color:#dff0d8}a.bg-success:focus,a.bg-success:hover{background-color:#c1e2b3}.bg-info{background-color:#d9edf7}a.bg-info:focus,a.bg-info:hover{background-color:#afd9ee}.bg-warning{background-color:#fcf8e3}a.bg-warning:focus,a.bg-warning:hover{background-color:#f7ecb5}.bg-danger{background-color:#f2dede}a.bg-danger:focus,a.bg-danger:hover{background-color:#e4b9b9}.page-header{padding-bottom:9px;margin:40px 0 20px;border-bottom:1px solid #eee}ol,ul{margin-top:0;margin-bottom:10px}ol ol,ol ul,ul ol,ul ul{margin-bottom:0}.list-inline,.list-unstyled{padding-left:0;list-style:none}.list-inline{margin-left:-5px}.list-inline>li{display:inline-block;padding-right:5px;padding-left:5px}dl{margin-top:0;margin-bottom:20px}dd,dt{line-height:1.42857143}dt{font-weight:700}dd{margin-left:0}@media (min-width:768px){.dl-horizontal dt{float:left;width:160px;overflow:hidden;clear:left;text-align:right;text-overflow:ellipsis;white-space:nowrap}.dl-horizontal dd{margin-left:180px}}abbr[data-original-title],abbr[title]{cursor:help;border-bottom:1px dotted #777}.initialism{font-size:90%;text-transform:uppercase}blockquote{padding:10px 20px;margin:0 0 20px;font-size:17.5px;border-left:5px solid #eee}blockquote ol:last-child,blockquote p:last-child,blockquote ul:last-child{margin-bottom:0}blockquote .small,blockquote footer,blockquote small{display:block;font-size:80%;line-height:1.42857143;color:#777}blockquote .small:before,blockquote footer:before,blockquote small:before{content:\"\\2014   \\A0\"}.blockquote-reverse,blockquote.pull-right{padding-right:15px;padding-left:0;text-align:right;border-right:5px solid #eee;border-left:0}.blockquote-reverse .small:before,.blockquote-reverse footer:before,.blockquote-reverse small:before,blockquote.pull-right .small:before,blockquote.pull-right footer:before,blockquote.pull-right small:before{content:\"\"}.blockquote-reverse .small:after,.blockquote-reverse footer:after,.blockquote-reverse small:after,blockquote.pull-right .small:after,blockquote.pull-right footer:after,blockquote.pull-right small:after{content:\"\\A0   \\2014\"}address{margin-bottom:20px;font-style:normal;line-height:1.42857143}code,kbd,pre,samp{font-family:Menlo,Monaco,Consolas,Courier New,monospace}code{color:#c7254e;background-color:#f9f2f4;border-radius:4px}code,kbd{padding:2px 4px;font-size:90%}kbd{color:#fff;background-color:#333;border-radius:3px;box-shadow:inset 0 -1px 0 rgba(0,0,0,.25)}kbd kbd{padding:0;font-size:100%;font-weight:700;box-shadow:none}pre{display:block;padding:9.5px;margin:0 0 10px;font-size:13px;line-height:1.42857143;color:#333;word-break:break-all;word-wrap:break-word;background-color:#f5f5f5;border:1px solid #ccc;border-radius:4px}pre code{padding:0;font-size:inherit;color:inherit;white-space:pre-wrap;background-color:transparent;border-radius:0}.pre-scrollable{max-height:340px;overflow-y:scroll}.container{padding-right:15px;padding-left:15px;margin-right:auto;margin-left:auto}@media (min-width:768px){.container{width:750px}}@media (min-width:992px){.container{width:970px}}@media (min-width:1200px){.container{width:1170px}}.container-fluid{padding-right:15px;padding-left:15px;margin-right:auto;margin-left:auto}.row{margin-right:-15px;margin-left:-15px}.col-lg-1,.col-lg-2,.col-lg-3,.col-lg-4,.col-lg-5,.col-lg-6,.col-lg-7,.col-lg-8,.col-lg-9,.col-lg-10,.col-lg-11,.col-lg-12,.col-md-1,.col-md-2,.col-md-3,.col-md-4,.col-md-5,.col-md-6,.col-md-7,.col-md-8,.col-md-9,.col-md-10,.col-md-11,.col-md-12,.col-sm-1,.col-sm-2,.col-sm-3,.col-sm-4,.col-sm-5,.col-sm-6,.col-sm-7,.col-sm-8,.col-sm-9,.col-sm-10,.col-sm-11,.col-sm-12,.col-xs-1,.col-xs-2,.col-xs-3,.col-xs-4,.col-xs-5,.col-xs-6,.col-xs-7,.col-xs-8,.col-xs-9,.col-xs-10,.col-xs-11,.col-xs-12{position:relative;min-height:1px;padding-right:15px;padding-left:15px}.col-xs-1,.col-xs-2,.col-xs-3,.col-xs-4,.col-xs-5,.col-xs-6,.col-xs-7,.col-xs-8,.col-xs-9,.col-xs-10,.col-xs-11,.col-xs-12{float:left}.col-xs-12{width:100%}.col-xs-11{width:91.66666667%}.col-xs-10{width:83.33333333%}.col-xs-9{width:75%}.col-xs-8{width:66.66666667%}.col-xs-7{width:58.33333333%}.col-xs-6{width:50%}.col-xs-5{width:41.66666667%}.col-xs-4{width:33.33333333%}.col-xs-3{width:25%}.col-xs-2{width:16.66666667%}.col-xs-1{width:8.33333333%}.col-xs-pull-12{right:100%}.col-xs-pull-11{right:91.66666667%}.col-xs-pull-10{right:83.33333333%}.col-xs-pull-9{right:75%}.col-xs-pull-8{right:66.66666667%}.col-xs-pull-7{right:58.33333333%}.col-xs-pull-6{right:50%}.col-xs-pull-5{right:41.66666667%}.col-xs-pull-4{right:33.33333333%}.col-xs-pull-3{right:25%}.col-xs-pull-2{right:16.66666667%}.col-xs-pull-1{right:8.33333333%}.col-xs-pull-0{right:auto}.col-xs-push-12{left:100%}.col-xs-push-11{left:91.66666667%}.col-xs-push-10{left:83.33333333%}.col-xs-push-9{left:75%}.col-xs-push-8{left:66.66666667%}.col-xs-push-7{left:58.33333333%}.col-xs-push-6{left:50%}.col-xs-push-5{left:41.66666667%}.col-xs-push-4{left:33.33333333%}.col-xs-push-3{left:25%}.col-xs-push-2{left:16.66666667%}.col-xs-push-1{left:8.33333333%}.col-xs-push-0{left:auto}.col-xs-offset-12{margin-left:100%}.col-xs-offset-11{margin-left:91.66666667%}.col-xs-offset-10{margin-left:83.33333333%}.col-xs-offset-9{margin-left:75%}.col-xs-offset-8{margin-left:66.66666667%}.col-xs-offset-7{margin-left:58.33333333%}.col-xs-offset-6{margin-left:50%}.col-xs-offset-5{margin-left:41.66666667%}.col-xs-offset-4{margin-left:33.33333333%}.col-xs-offset-3{margin-left:25%}.col-xs-offset-2{margin-left:16.66666667%}.col-xs-offset-1{margin-left:8.33333333%}.col-xs-offset-0{margin-left:0}@media (min-width:768px){.col-sm-1,.col-sm-2,.col-sm-3,.col-sm-4,.col-sm-5,.col-sm-6,.col-sm-7,.col-sm-8,.col-sm-9,.col-sm-10,.col-sm-11,.col-sm-12{float:left}.col-sm-12{width:100%}.col-sm-11{width:91.66666667%}.col-sm-10{width:83.33333333%}.col-sm-9{width:75%}.col-sm-8{width:66.66666667%}.col-sm-7{width:58.33333333%}.col-sm-6{width:50%}.col-sm-5{width:41.66666667%}.col-sm-4{width:33.33333333%}.col-sm-3{width:25%}.col-sm-2{width:16.66666667%}.col-sm-1{width:8.33333333%}.col-sm-pull-12{right:100%}.col-sm-pull-11{right:91.66666667%}.col-sm-pull-10{right:83.33333333%}.col-sm-pull-9{right:75%}.col-sm-pull-8{right:66.66666667%}.col-sm-pull-7{right:58.33333333%}.col-sm-pull-6{right:50%}.col-sm-pull-5{right:41.66666667%}.col-sm-pull-4{right:33.33333333%}.col-sm-pull-3{right:25%}.col-sm-pull-2{right:16.66666667%}.col-sm-pull-1{right:8.33333333%}.col-sm-pull-0{right:auto}.col-sm-push-12{left:100%}.col-sm-push-11{left:91.66666667%}.col-sm-push-10{left:83.33333333%}.col-sm-push-9{left:75%}.col-sm-push-8{left:66.66666667%}.col-sm-push-7{left:58.33333333%}.col-sm-push-6{left:50%}.col-sm-push-5{left:41.66666667%}.col-sm-push-4{left:33.33333333%}.col-sm-push-3{left:25%}.col-sm-push-2{left:16.66666667%}.col-sm-push-1{left:8.33333333%}.col-sm-push-0{left:auto}.col-sm-offset-12{margin-left:100%}.col-sm-offset-11{margin-left:91.66666667%}.col-sm-offset-10{margin-left:83.33333333%}.col-sm-offset-9{margin-left:75%}.col-sm-offset-8{margin-left:66.66666667%}.col-sm-offset-7{margin-left:58.33333333%}.col-sm-offset-6{margin-left:50%}.col-sm-offset-5{margin-left:41.66666667%}.col-sm-offset-4{margin-left:33.33333333%}.col-sm-offset-3{margin-left:25%}.col-sm-offset-2{margin-left:16.66666667%}.col-sm-offset-1{margin-left:8.33333333%}.col-sm-offset-0{margin-left:0}}@media (min-width:992px){.col-md-1,.col-md-2,.col-md-3,.col-md-4,.col-md-5,.col-md-6,.col-md-7,.col-md-8,.col-md-9,.col-md-10,.col-md-11,.col-md-12{float:left}.col-md-12{width:100%}.col-md-11{width:91.66666667%}.col-md-10{width:83.33333333%}.col-md-9{width:75%}.col-md-8{width:66.66666667%}.col-md-7{width:58.33333333%}.col-md-6{width:50%}.col-md-5{width:41.66666667%}.col-md-4{width:33.33333333%}.col-md-3{width:25%}.col-md-2{width:16.66666667%}.col-md-1{width:8.33333333%}.col-md-pull-12{right:100%}.col-md-pull-11{right:91.66666667%}.col-md-pull-10{right:83.33333333%}.col-md-pull-9{right:75%}.col-md-pull-8{right:66.66666667%}.col-md-pull-7{right:58.33333333%}.col-md-pull-6{right:50%}.col-md-pull-5{right:41.66666667%}.col-md-pull-4{right:33.33333333%}.col-md-pull-3{right:25%}.col-md-pull-2{right:16.66666667%}.col-md-pull-1{right:8.33333333%}.col-md-pull-0{right:auto}.col-md-push-12{left:100%}.col-md-push-11{left:91.66666667%}.col-md-push-10{left:83.33333333%}.col-md-push-9{left:75%}.col-md-push-8{left:66.66666667%}.col-md-push-7{left:58.33333333%}.col-md-push-6{left:50%}.col-md-push-5{left:41.66666667%}.col-md-push-4{left:33.33333333%}.col-md-push-3{left:25%}.col-md-push-2{left:16.66666667%}.col-md-push-1{left:8.33333333%}.col-md-push-0{left:auto}.col-md-offset-12{margin-left:100%}.col-md-offset-11{margin-left:91.66666667%}.col-md-offset-10{margin-left:83.33333333%}.col-md-offset-9{margin-left:75%}.col-md-offset-8{margin-left:66.66666667%}.col-md-offset-7{margin-left:58.33333333%}.col-md-offset-6{margin-left:50%}.col-md-offset-5{margin-left:41.66666667%}.col-md-offset-4{margin-left:33.33333333%}.col-md-offset-3{margin-left:25%}.col-md-offset-2{margin-left:16.66666667%}.col-md-offset-1{margin-left:8.33333333%}.col-md-offset-0{margin-left:0}}@media (min-width:1200px){.col-lg-1,.col-lg-2,.col-lg-3,.col-lg-4,.col-lg-5,.col-lg-6,.col-lg-7,.col-lg-8,.col-lg-9,.col-lg-10,.col-lg-11,.col-lg-12{float:left}.col-lg-12{width:100%}.col-lg-11{width:91.66666667%}.col-lg-10{width:83.33333333%}.col-lg-9{width:75%}.col-lg-8{width:66.66666667%}.col-lg-7{width:58.33333333%}.col-lg-6{width:50%}.col-lg-5{width:41.66666667%}.col-lg-4{width:33.33333333%}.col-lg-3{width:25%}.col-lg-2{width:16.66666667%}.col-lg-1{width:8.33333333%}.col-lg-pull-12{right:100%}.col-lg-pull-11{right:91.66666667%}.col-lg-pull-10{right:83.33333333%}.col-lg-pull-9{right:75%}.col-lg-pull-8{right:66.66666667%}.col-lg-pull-7{right:58.33333333%}.col-lg-pull-6{right:50%}.col-lg-pull-5{right:41.66666667%}.col-lg-pull-4{right:33.33333333%}.col-lg-pull-3{right:25%}.col-lg-pull-2{right:16.66666667%}.col-lg-pull-1{right:8.33333333%}.col-lg-pull-0{right:auto}.col-lg-push-12{left:100%}.col-lg-push-11{left:91.66666667%}.col-lg-push-10{left:83.33333333%}.col-lg-push-9{left:75%}.col-lg-push-8{left:66.66666667%}.col-lg-push-7{left:58.33333333%}.col-lg-push-6{left:50%}.col-lg-push-5{left:41.66666667%}.col-lg-push-4{left:33.33333333%}.col-lg-push-3{left:25%}.col-lg-push-2{left:16.66666667%}.col-lg-push-1{left:8.33333333%}.col-lg-push-0{left:auto}.col-lg-offset-12{margin-left:100%}.col-lg-offset-11{margin-left:91.66666667%}.col-lg-offset-10{margin-left:83.33333333%}.col-lg-offset-9{margin-left:75%}.col-lg-offset-8{margin-left:66.66666667%}.col-lg-offset-7{margin-left:58.33333333%}.col-lg-offset-6{margin-left:50%}.col-lg-offset-5{margin-left:41.66666667%}.col-lg-offset-4{margin-left:33.33333333%}.col-lg-offset-3{margin-left:25%}.col-lg-offset-2{margin-left:16.66666667%}.col-lg-offset-1{margin-left:8.33333333%}.col-lg-offset-0{margin-left:0}}table{background-color:transparent}caption{padding-top:8px;padding-bottom:8px;color:#777}caption,th{text-align:left}.table{width:100%;max-width:100%;margin-bottom:20px}.table>tbody>tr>td,.table>tbody>tr>th,.table>tfoot>tr>td,.table>tfoot>tr>th,.table>thead>tr>td,.table>thead>tr>th{padding:8px;line-height:1.42857143;vertical-align:top;border-top:1px solid #ddd}.table>thead>tr>th{vertical-align:bottom;border-bottom:2px solid #ddd}.table>caption+thead>tr:first-child>td,.table>caption+thead>tr:first-child>th,.table>colgroup+thead>tr:first-child>td,.table>colgroup+thead>tr:first-child>th,.table>thead:first-child>tr:first-child>td,.table>thead:first-child>tr:first-child>th{border-top:0}.table>tbody+tbody{border-top:2px solid #ddd}.table .table{background-color:#fff}.table-condensed>tbody>tr>td,.table-condensed>tbody>tr>th,.table-condensed>tfoot>tr>td,.table-condensed>tfoot>tr>th,.table-condensed>thead>tr>td,.table-condensed>thead>tr>th{padding:5px}.table-bordered,.table-bordered>tbody>tr>td,.table-bordered>tbody>tr>th,.table-bordered>tfoot>tr>td,.table-bordered>tfoot>tr>th,.table-bordered>thead>tr>td,.table-bordered>thead>tr>th{border:1px solid #ddd}.table-bordered>thead>tr>td,.table-bordered>thead>tr>th{border-bottom-width:2px}.table-striped>tbody>tr:nth-of-type(odd){background-color:#f9f9f9}.table-hover>tbody>tr:hover{background-color:#f5f5f5}table col[class*=col-]{position:static;display:table-column;float:none}table td[class*=col-],table th[class*=col-]{position:static;display:table-cell;float:none}.table>tbody>tr.active>td,.table>tbody>tr.active>th,.table>tbody>tr>td.active,.table>tbody>tr>th.active,.table>tfoot>tr.active>td,.table>tfoot>tr.active>th,.table>tfoot>tr>td.active,.table>tfoot>tr>th.active,.table>thead>tr.active>td,.table>thead>tr.active>th,.table>thead>tr>td.active,.table>thead>tr>th.active{background-color:#f5f5f5}.table-hover>tbody>tr.active:hover>td,.table-hover>tbody>tr.active:hover>th,.table-hover>tbody>tr:hover>.active,.table-hover>tbody>tr>td.active:hover,.table-hover>tbody>tr>th.active:hover{background-color:#e8e8e8}.table>tbody>tr.success>td,.table>tbody>tr.success>th,.table>tbody>tr>td.success,.table>tbody>tr>th.success,.table>tfoot>tr.success>td,.table>tfoot>tr.success>th,.table>tfoot>tr>td.success,.table>tfoot>tr>th.success,.table>thead>tr.success>td,.table>thead>tr.success>th,.table>thead>tr>td.success,.table>thead>tr>th.success{background-color:#dff0d8}.table-hover>tbody>tr.success:hover>td,.table-hover>tbody>tr.success:hover>th,.table-hover>tbody>tr:hover>.success,.table-hover>tbody>tr>td.success:hover,.table-hover>tbody>tr>th.success:hover{background-color:#d0e9c6}.table>tbody>tr.info>td,.table>tbody>tr.info>th,.table>tbody>tr>td.info,.table>tbody>tr>th.info,.table>tfoot>tr.info>td,.table>tfoot>tr.info>th,.table>tfoot>tr>td.info,.table>tfoot>tr>th.info,.table>thead>tr.info>td,.table>thead>tr.info>th,.table>thead>tr>td.info,.table>thead>tr>th.info{background-color:#d9edf7}.table-hover>tbody>tr.info:hover>td,.table-hover>tbody>tr.info:hover>th,.table-hover>tbody>tr:hover>.info,.table-hover>tbody>tr>td.info:hover,.table-hover>tbody>tr>th.info:hover{background-color:#c4e3f3}.table>tbody>tr.warning>td,.table>tbody>tr.warning>th,.table>tbody>tr>td.warning,.table>tbody>tr>th.warning,.table>tfoot>tr.warning>td,.table>tfoot>tr.warning>th,.table>tfoot>tr>td.warning,.table>tfoot>tr>th.warning,.table>thead>tr.warning>td,.table>thead>tr.warning>th,.table>thead>tr>td.warning,.table>thead>tr>th.warning{background-color:#fcf8e3}.table-hover>tbody>tr.warning:hover>td,.table-hover>tbody>tr.warning:hover>th,.table-hover>tbody>tr:hover>.warning,.table-hover>tbody>tr>td.warning:hover,.table-hover>tbody>tr>th.warning:hover{background-color:#faf2cc}.table>tbody>tr.danger>td,.table>tbody>tr.danger>th,.table>tbody>tr>td.danger,.table>tbody>tr>th.danger,.table>tfoot>tr.danger>td,.table>tfoot>tr.danger>th,.table>tfoot>tr>td.danger,.table>tfoot>tr>th.danger,.table>thead>tr.danger>td,.table>thead>tr.danger>th,.table>thead>tr>td.danger,.table>thead>tr>th.danger{background-color:#f2dede}.table-hover>tbody>tr.danger:hover>td,.table-hover>tbody>tr.danger:hover>th,.table-hover>tbody>tr:hover>.danger,.table-hover>tbody>tr>td.danger:hover,.table-hover>tbody>tr>th.danger:hover{background-color:#ebcccc}.table-responsive{min-height:.01%;overflow-x:auto}@media screen and (max-width:767px){.table-responsive{width:100%;margin-bottom:15px;overflow-y:hidden;-ms-overflow-style:-ms-autohiding-scrollbar;border:1px solid #ddd}.table-responsive>.table{margin-bottom:0}.table-responsive>.table>tbody>tr>td,.table-responsive>.table>tbody>tr>th,.table-responsive>.table>tfoot>tr>td,.table-responsive>.table>tfoot>tr>th,.table-responsive>.table>thead>tr>td,.table-responsive>.table>thead>tr>th{white-space:nowrap}.table-responsive>.table-bordered{border:0}.table-responsive>.table-bordered>tbody>tr>td:first-child,.table-responsive>.table-bordered>tbody>tr>th:first-child,.table-responsive>.table-bordered>tfoot>tr>td:first-child,.table-responsive>.table-bordered>tfoot>tr>th:first-child,.table-responsive>.table-bordered>thead>tr>td:first-child,.table-responsive>.table-bordered>thead>tr>th:first-child{border-left:0}.table-responsive>.table-bordered>tbody>tr>td:last-child,.table-responsive>.table-bordered>tbody>tr>th:last-child,.table-responsive>.table-bordered>tfoot>tr>td:last-child,.table-responsive>.table-bordered>tfoot>tr>th:last-child,.table-responsive>.table-bordered>thead>tr>td:last-child,.table-responsive>.table-bordered>thead>tr>th:last-child{border-right:0}.table-responsive>.table-bordered>tbody>tr:last-child>td,.table-responsive>.table-bordered>tbody>tr:last-child>th,.table-responsive>.table-bordered>tfoot>tr:last-child>td,.table-responsive>.table-bordered>tfoot>tr:last-child>th{border-bottom:0}}fieldset{min-width:0;margin:0}fieldset,legend{padding:0;border:0}legend{display:block;width:100%;margin-bottom:20px;font-size:21px;line-height:inherit;color:#333;border-bottom:1px solid #e5e5e5}label{display:inline-block;max-width:100%;margin-bottom:5px;font-weight:700}input[type=search]{box-sizing:border-box}input[type=checkbox],input[type=radio]{margin:4px 0 0;margin-top:1px\\9;line-height:normal}input[type=file]{display:block}input[type=range]{display:block;width:100%}select[multiple],select[size]{height:auto}input[type=checkbox]:focus,input[type=file]:focus,input[type=radio]:focus{outline:5px auto -webkit-focus-ring-color;outline-offset:-2px}output{padding-top:7px}.form-control,output{display:block;font-size:14px;line-height:1.42857143;color:#555}.form-control{width:100%;height:34px;padding:6px 12px;background-color:#fff;background-image:none;border:1px solid #ccc;border-radius:4px;box-shadow:inset 0 1px 1px rgba(0,0,0,.075);transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out}.form-control:focus{border-color:#66afe9;outline:0;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(102,175,233,.6)}.form-control::-moz-placeholder{color:#999;opacity:1}.form-control:-ms-input-placeholder{color:#999}.form-control::-webkit-input-placeholder{color:#999}.form-control::-ms-expand{background-color:transparent;border:0}.form-control[disabled],.form-control[readonly],fieldset[disabled] .form-control{background-color:#eee;opacity:1}.form-control[disabled],fieldset[disabled] .form-control{cursor:not-allowed}textarea.form-control{height:auto}input[type=search]{-webkit-appearance:none}@media screen and (-webkit-min-device-pixel-ratio:0){input[type=date].form-control,input[type=datetime-local].form-control,input[type=month].form-control,input[type=time].form-control{line-height:34px}.input-group-sm input[type=date],.input-group-sm input[type=datetime-local],.input-group-sm input[type=month],.input-group-sm input[type=time],input[type=date].input-sm,input[type=datetime-local].input-sm,input[type=month].input-sm,input[type=time].input-sm{line-height:30px}.input-group-lg input[type=date],.input-group-lg input[type=datetime-local],.input-group-lg input[type=month],.input-group-lg input[type=time],input[type=date].input-lg,input[type=datetime-local].input-lg,input[type=month].input-lg,input[type=time].input-lg{line-height:46px}}.form-group{margin-bottom:15px}.checkbox,.radio{position:relative;display:block;margin-top:10px;margin-bottom:10px}.checkbox label,.radio label{min-height:20px;padding-left:20px;margin-bottom:0;font-weight:400;cursor:pointer}.checkbox-inline input[type=checkbox],.checkbox input[type=checkbox],.radio-inline input[type=radio],.radio input[type=radio]{position:absolute;margin-top:4px\\9;margin-left:-20px}.checkbox+.checkbox,.radio+.radio{margin-top:-5px}.checkbox-inline,.radio-inline{position:relative;display:inline-block;padding-left:20px;margin-bottom:0;font-weight:400;vertical-align:middle;cursor:pointer}.checkbox-inline+.checkbox-inline,.radio-inline+.radio-inline{margin-top:0;margin-left:10px}.checkbox-inline.disabled,.checkbox.disabled label,.radio-inline.disabled,.radio.disabled label,fieldset[disabled] .checkbox-inline,fieldset[disabled] .checkbox label,fieldset[disabled] .radio-inline,fieldset[disabled] .radio label,fieldset[disabled] input[type=checkbox],fieldset[disabled] input[type=radio],input[type=checkbox].disabled,input[type=checkbox][disabled],input[type=radio].disabled,input[type=radio][disabled]{cursor:not-allowed}.form-control-static{min-height:34px;padding-top:7px;padding-bottom:7px;margin-bottom:0}.form-control-static.input-lg,.form-control-static.input-sm{padding-right:0;padding-left:0}.input-sm{height:30px;padding:5px 10px;font-size:12px;line-height:1.5;border-radius:3px}select.input-sm{height:30px;line-height:30px}select[multiple].input-sm,textarea.input-sm{height:auto}.form-group-sm .form-control{height:30px;padding:5px 10px;font-size:12px;line-height:1.5;border-radius:3px}.form-group-sm select.form-control{height:30px;line-height:30px}.form-group-sm select[multiple].form-control,.form-group-sm textarea.form-control{height:auto}.form-group-sm .form-control-static{height:30px;min-height:32px;padding:6px 10px;font-size:12px;line-height:1.5}.input-lg{height:46px;padding:10px 16px;font-size:18px;line-height:1.3333333;border-radius:6px}select.input-lg{height:46px;line-height:46px}select[multiple].input-lg,textarea.input-lg{height:auto}.form-group-lg .form-control{height:46px;padding:10px 16px;font-size:18px;line-height:1.3333333;border-radius:6px}.form-group-lg select.form-control{height:46px;line-height:46px}.form-group-lg select[multiple].form-control,.form-group-lg textarea.form-control{height:auto}.form-group-lg .form-control-static{height:46px;min-height:38px;padding:11px 16px;font-size:18px;line-height:1.3333333}.has-feedback{position:relative}.has-feedback .form-control{padding-right:42.5px}.form-control-feedback{position:absolute;top:0;right:0;z-index:2;display:block;width:34px;height:34px;line-height:34px;text-align:center;pointer-events:none}.form-group-lg .form-control+.form-control-feedback,.input-group-lg+.form-control-feedback,.input-lg+.form-control-feedback{width:46px;height:46px;line-height:46px}.form-group-sm .form-control+.form-control-feedback,.input-group-sm+.form-control-feedback,.input-sm+.form-control-feedback{width:30px;height:30px;line-height:30px}.has-success .checkbox,.has-success .checkbox-inline,.has-success.checkbox-inline label,.has-success.checkbox label,.has-success .control-label,.has-success .help-block,.has-success .radio,.has-success .radio-inline,.has-success.radio-inline label,.has-success.radio label{color:#3c763d}.has-success .form-control{border-color:#3c763d;box-shadow:inset 0 1px 1px rgba(0,0,0,.075)}.has-success .form-control:focus{border-color:#2b542c;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #67b168}.has-success .input-group-addon{color:#3c763d;background-color:#dff0d8;border-color:#3c763d}.has-success .form-control-feedback{color:#3c763d}.has-warning .checkbox,.has-warning .checkbox-inline,.has-warning.checkbox-inline label,.has-warning.checkbox label,.has-warning .control-label,.has-warning .help-block,.has-warning .radio,.has-warning .radio-inline,.has-warning.radio-inline label,.has-warning.radio label{color:#8a6d3b}.has-warning .form-control{border-color:#8a6d3b;box-shadow:inset 0 1px 1px rgba(0,0,0,.075)}.has-warning .form-control:focus{border-color:#66512c;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #c0a16b}.has-warning .input-group-addon{color:#8a6d3b;background-color:#fcf8e3;border-color:#8a6d3b}.has-warning .form-control-feedback{color:#8a6d3b}.has-error .checkbox,.has-error .checkbox-inline,.has-error.checkbox-inline label,.has-error.checkbox label,.has-error .control-label,.has-error .help-block,.has-error .radio,.has-error .radio-inline,.has-error.radio-inline label,.has-error.radio label{color:#a94442}.has-error .form-control{border-color:#a94442;box-shadow:inset 0 1px 1px rgba(0,0,0,.075)}.has-error .form-control:focus{border-color:#843534;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #ce8483}.has-error .input-group-addon{color:#a94442;background-color:#f2dede;border-color:#a94442}.has-error .form-control-feedback{color:#a94442}.has-feedback label~.form-control-feedback{top:25px}.has-feedback label.sr-only~.form-control-feedback{top:0}.help-block{display:block;margin-top:5px;margin-bottom:10px;color:#737373}@media (min-width:768px){.form-inline .form-group{display:inline-block;margin-bottom:0;vertical-align:middle}.form-inline .form-control{display:inline-block;width:auto;vertical-align:middle}.form-inline .form-control-static{display:inline-block}.form-inline .input-group{display:inline-table;vertical-align:middle}.form-inline .input-group .form-control,.form-inline .input-group .input-group-addon,.form-inline .input-group .input-group-btn{width:auto}.form-inline .input-group>.form-control{width:100%}.form-inline .control-label{margin-bottom:0;vertical-align:middle}.form-inline .checkbox,.form-inline .radio{display:inline-block;margin-top:0;margin-bottom:0;vertical-align:middle}.form-inline .checkbox label,.form-inline .radio label{padding-left:0}.form-inline .checkbox input[type=checkbox],.form-inline .radio input[type=radio]{position:relative;margin-left:0}.form-inline .has-feedback .form-control-feedback{top:0}}.form-horizontal .checkbox,.form-horizontal .checkbox-inline,.form-horizontal .radio,.form-horizontal .radio-inline{padding-top:7px;margin-top:0;margin-bottom:0}.form-horizontal .checkbox,.form-horizontal .radio{min-height:27px}.form-horizontal .form-group{margin-right:-15px;margin-left:-15px}@media (min-width:768px){.form-horizontal .control-label{padding-top:7px;margin-bottom:0;text-align:right}}.form-horizontal .has-feedback .form-control-feedback{right:15px}@media (min-width:768px){.form-horizontal .form-group-lg .control-label{padding-top:11px;font-size:18px}}@media (min-width:768px){.form-horizontal .form-group-sm .control-label{padding-top:6px;font-size:12px}}.btn{display:inline-block;padding:6px 12px;margin-bottom:0;font-size:14px;font-weight:400;line-height:1.42857143;text-align:center;white-space:nowrap;vertical-align:middle;-ms-touch-action:manipulation;touch-action:manipulation;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;background-image:none;border:1px solid transparent;border-radius:4px}.btn.active.focus,.btn.active:focus,.btn.focus,.btn:active.focus,.btn:active:focus,.btn:focus{outline:5px auto -webkit-focus-ring-color;outline-offset:-2px}.btn.focus,.btn:focus,.btn:hover{color:#333;text-decoration:none}.btn.active,.btn:active{background-image:none;outline:0;box-shadow:inset 0 3px 5px rgba(0,0,0,.125)}.btn.disabled,.btn[disabled],fieldset[disabled] .btn{cursor:not-allowed;filter:alpha(opacity=65);box-shadow:none;opacity:.65}a.btn.disabled,fieldset[disabled] a.btn{pointer-events:none}.btn-default{color:#333;background-color:#fff;border-color:#ccc}.btn-default.focus,.btn-default:focus{color:#333;background-color:#e6e6e6;border-color:#8c8c8c}.btn-default.active,.btn-default:active,.btn-default:hover,.open>.dropdown-toggle.btn-default{color:#333;background-color:#e6e6e6;border-color:#adadad}.btn-default.active.focus,.btn-default.active:focus,.btn-default.active:hover,.btn-default:active.focus,.btn-default:active:focus,.btn-default:active:hover,.open>.dropdown-toggle.btn-default.focus,.open>.dropdown-toggle.btn-default:focus,.open>.dropdown-toggle.btn-default:hover{color:#333;background-color:#d4d4d4;border-color:#8c8c8c}.btn-default.active,.btn-default:active,.open>.dropdown-toggle.btn-default{background-image:none}.btn-default.disabled.focus,.btn-default.disabled:focus,.btn-default.disabled:hover,.btn-default[disabled].focus,.btn-default[disabled]:focus,.btn-default[disabled]:hover,fieldset[disabled] .btn-default.focus,fieldset[disabled] .btn-default:focus,fieldset[disabled] .btn-default:hover{background-color:#fff;border-color:#ccc}.btn-default .badge{color:#fff;background-color:#333}.btn-primary{color:#fff;background-color:#337ab7;border-color:#2e6da4}.btn-primary.focus,.btn-primary:focus{color:#fff;background-color:#286090;border-color:#122b40}.btn-primary.active,.btn-primary:active,.btn-primary:hover,.open>.dropdown-toggle.btn-primary{color:#fff;background-color:#286090;border-color:#204d74}.btn-primary.active.focus,.btn-primary.active:focus,.btn-primary.active:hover,.btn-primary:active.focus,.btn-primary:active:focus,.btn-primary:active:hover,.open>.dropdown-toggle.btn-primary.focus,.open>.dropdown-toggle.btn-primary:focus,.open>.dropdown-toggle.btn-primary:hover{color:#fff;background-color:#204d74;border-color:#122b40}.btn-primary.active,.btn-primary:active,.open>.dropdown-toggle.btn-primary{background-image:none}.btn-primary.disabled.focus,.btn-primary.disabled:focus,.btn-primary.disabled:hover,.btn-primary[disabled].focus,.btn-primary[disabled]:focus,.btn-primary[disabled]:hover,fieldset[disabled] .btn-primary.focus,fieldset[disabled] .btn-primary:focus,fieldset[disabled] .btn-primary:hover{background-color:#337ab7;border-color:#2e6da4}.btn-primary .badge{color:#337ab7;background-color:#fff}.btn-success{color:#fff;background-color:#5cb85c;border-color:#4cae4c}.btn-success.focus,.btn-success:focus{color:#fff;background-color:#449d44;border-color:#255625}.btn-success.active,.btn-success:active,.btn-success:hover,.open>.dropdown-toggle.btn-success{color:#fff;background-color:#449d44;border-color:#398439}.btn-success.active.focus,.btn-success.active:focus,.btn-success.active:hover,.btn-success:active.focus,.btn-success:active:focus,.btn-success:active:hover,.open>.dropdown-toggle.btn-success.focus,.open>.dropdown-toggle.btn-success:focus,.open>.dropdown-toggle.btn-success:hover{color:#fff;background-color:#398439;border-color:#255625}.btn-success.active,.btn-success:active,.open>.dropdown-toggle.btn-success{background-image:none}.btn-success.disabled.focus,.btn-success.disabled:focus,.btn-success.disabled:hover,.btn-success[disabled].focus,.btn-success[disabled]:focus,.btn-success[disabled]:hover,fieldset[disabled] .btn-success.focus,fieldset[disabled] .btn-success:focus,fieldset[disabled] .btn-success:hover{background-color:#5cb85c;border-color:#4cae4c}.btn-success .badge{color:#5cb85c;background-color:#fff}.btn-info{color:#fff;background-color:#5bc0de;border-color:#46b8da}.btn-info.focus,.btn-info:focus{color:#fff;background-color:#31b0d5;border-color:#1b6d85}.btn-info.active,.btn-info:active,.btn-info:hover,.open>.dropdown-toggle.btn-info{color:#fff;background-color:#31b0d5;border-color:#269abc}.btn-info.active.focus,.btn-info.active:focus,.btn-info.active:hover,.btn-info:active.focus,.btn-info:active:focus,.btn-info:active:hover,.open>.dropdown-toggle.btn-info.focus,.open>.dropdown-toggle.btn-info:focus,.open>.dropdown-toggle.btn-info:hover{color:#fff;background-color:#269abc;border-color:#1b6d85}.btn-info.active,.btn-info:active,.open>.dropdown-toggle.btn-info{background-image:none}.btn-info.disabled.focus,.btn-info.disabled:focus,.btn-info.disabled:hover,.btn-info[disabled].focus,.btn-info[disabled]:focus,.btn-info[disabled]:hover,fieldset[disabled] .btn-info.focus,fieldset[disabled] .btn-info:focus,fieldset[disabled] .btn-info:hover{background-color:#5bc0de;border-color:#46b8da}.btn-info .badge{color:#5bc0de;background-color:#fff}.btn-warning{color:#fff;background-color:#f0ad4e;border-color:#eea236}.btn-warning.focus,.btn-warning:focus{color:#fff;background-color:#ec971f;border-color:#985f0d}.btn-warning.active,.btn-warning:active,.btn-warning:hover,.open>.dropdown-toggle.btn-warning{color:#fff;background-color:#ec971f;border-color:#d58512}.btn-warning.active.focus,.btn-warning.active:focus,.btn-warning.active:hover,.btn-warning:active.focus,.btn-warning:active:focus,.btn-warning:active:hover,.open>.dropdown-toggle.btn-warning.focus,.open>.dropdown-toggle.btn-warning:focus,.open>.dropdown-toggle.btn-warning:hover{color:#fff;background-color:#d58512;border-color:#985f0d}.btn-warning.active,.btn-warning:active,.open>.dropdown-toggle.btn-warning{background-image:none}.btn-warning.disabled.focus,.btn-warning.disabled:focus,.btn-warning.disabled:hover,.btn-warning[disabled].focus,.btn-warning[disabled]:focus,.btn-warning[disabled]:hover,fieldset[disabled] .btn-warning.focus,fieldset[disabled] .btn-warning:focus,fieldset[disabled] .btn-warning:hover{background-color:#f0ad4e;border-color:#eea236}.btn-warning .badge{color:#f0ad4e;background-color:#fff}.btn-danger{color:#fff;background-color:#d9534f;border-color:#d43f3a}.btn-danger.focus,.btn-danger:focus{color:#fff;background-color:#c9302c;border-color:#761c19}.btn-danger.active,.btn-danger:active,.btn-danger:hover,.open>.dropdown-toggle.btn-danger{color:#fff;background-color:#c9302c;border-color:#ac2925}.btn-danger.active.focus,.btn-danger.active:focus,.btn-danger.active:hover,.btn-danger:active.focus,.btn-danger:active:focus,.btn-danger:active:hover,.open>.dropdown-toggle.btn-danger.focus,.open>.dropdown-toggle.btn-danger:focus,.open>.dropdown-toggle.btn-danger:hover{color:#fff;background-color:#ac2925;border-color:#761c19}.btn-danger.active,.btn-danger:active,.open>.dropdown-toggle.btn-danger{background-image:none}.btn-danger.disabled.focus,.btn-danger.disabled:focus,.btn-danger.disabled:hover,.btn-danger[disabled].focus,.btn-danger[disabled]:focus,.btn-danger[disabled]:hover,fieldset[disabled] .btn-danger.focus,fieldset[disabled] .btn-danger:focus,fieldset[disabled] .btn-danger:hover{background-color:#d9534f;border-color:#d43f3a}.btn-danger .badge{color:#d9534f;background-color:#fff}.btn-link{font-weight:400;color:#337ab7;border-radius:0}.btn-link,.btn-link.active,.btn-link:active,.btn-link[disabled],fieldset[disabled] .btn-link{background-color:transparent;box-shadow:none}.btn-link,.btn-link:active,.btn-link:focus,.btn-link:hover{border-color:transparent}.btn-link:focus,.btn-link:hover{color:#23527c;text-decoration:underline;background-color:transparent}.btn-link[disabled]:focus,.btn-link[disabled]:hover,fieldset[disabled] .btn-link:focus,fieldset[disabled] .btn-link:hover{color:#777;text-decoration:none}.btn-group-lg>.btn,.btn-lg{padding:10px 16px;font-size:18px;line-height:1.3333333;border-radius:6px}.btn-group-sm>.btn,.btn-sm{padding:5px 10px;font-size:12px;line-height:1.5;border-radius:3px}.btn-group-xs>.btn,.btn-xs{padding:1px 5px;font-size:12px;line-height:1.5;border-radius:3px}.btn-block{display:block;width:100%}.btn-block+.btn-block{margin-top:5px}input[type=button].btn-block,input[type=reset].btn-block,input[type=submit].btn-block{width:100%}.fade{opacity:0;transition:opacity .15s linear}.fade.in{opacity:1}.collapse{display:none}.collapse.in{display:block}tr.collapse.in{display:table-row}tbody.collapse.in{display:table-row-group}.collapsing{position:relative;height:0;overflow:hidden;transition-timing-function:ease;transition-duration:.35s;transition-property:height,visibility}.caret{display:inline-block;width:0;height:0;margin-left:2px;vertical-align:middle;border-top:4px dashed;border-top:4px solid\\9;border-right:4px solid transparent;border-left:4px solid transparent}.dropdown,.dropup{position:relative}.dropdown-toggle:focus{outline:0}.dropdown-menu{position:absolute;top:100%;left:0;z-index:1000;display:none;float:left;min-width:160px;padding:5px 0;margin:2px 0 0;font-size:14px;text-align:left;list-style:none;background-color:#fff;background-clip:padding-box;border:1px solid #ccc;border:1px solid rgba(0,0,0,.15);border-radius:4px;box-shadow:0 6px 12px rgba(0,0,0,.175)}.dropdown-menu.pull-right{right:0;left:auto}.dropdown-menu .divider{height:1px;margin:9px 0;overflow:hidden;background-color:#e5e5e5}.dropdown-menu>li>a{display:block;padding:3px 20px;clear:both;font-weight:400;line-height:1.42857143;color:#333;white-space:nowrap}.dropdown-menu>li>a:focus,.dropdown-menu>li>a:hover{color:#262626;text-decoration:none;background-color:#f5f5f5}.dropdown-menu>.active>a,.dropdown-menu>.active>a:focus,.dropdown-menu>.active>a:hover{color:#fff;text-decoration:none;background-color:#337ab7;outline:0}.dropdown-menu>.disabled>a,.dropdown-menu>.disabled>a:focus,.dropdown-menu>.disabled>a:hover{color:#777}.dropdown-menu>.disabled>a:focus,.dropdown-menu>.disabled>a:hover{text-decoration:none;cursor:not-allowed;background-color:transparent;background-image:none;filter:progid:DXImageTransform.Microsoft.gradient(enabled = false)}.open>.dropdown-menu{display:block}.open>a{outline:0}.dropdown-menu-right{right:0;left:auto}.dropdown-menu-left{right:auto;left:0}.dropdown-header{display:block;padding:3px 20px;font-size:12px;line-height:1.42857143;color:#777;white-space:nowrap}.dropdown-backdrop{position:fixed;top:0;right:0;bottom:0;left:0;z-index:990}.pull-right>.dropdown-menu{right:0;left:auto}.dropup .caret,.navbar-fixed-bottom .dropdown .caret{content:\"\";border-top:0;border-bottom:4px dashed;border-bottom:4px solid\\9}.dropup .dropdown-menu,.navbar-fixed-bottom .dropdown .dropdown-menu{top:auto;bottom:100%;margin-bottom:2px}@media (min-width:768px){.navbar-right .dropdown-menu{right:0;left:auto}.navbar-right .dropdown-menu-left{right:auto;left:0}}.btn-group,.btn-group-vertical{position:relative;display:inline-block;vertical-align:middle}.btn-group-vertical>.btn,.btn-group>.btn{position:relative;float:left}.btn-group-vertical>.btn.active,.btn-group-vertical>.btn:active,.btn-group-vertical>.btn:focus,.btn-group-vertical>.btn:hover,.btn-group>.btn.active,.btn-group>.btn:active,.btn-group>.btn:focus,.btn-group>.btn:hover{z-index:2}.btn-group .btn+.btn,.btn-group .btn+.btn-group,.btn-group .btn-group+.btn,.btn-group .btn-group+.btn-group{margin-left:-1px}.btn-toolbar{margin-left:-5px}.btn-toolbar .btn,.btn-toolbar .btn-group,.btn-toolbar .input-group{float:left}.btn-toolbar>.btn,.btn-toolbar>.btn-group,.btn-toolbar>.input-group{margin-left:5px}.btn-group>.btn:not(:first-child):not(:last-child):not(.dropdown-toggle){border-radius:0}.btn-group>.btn:first-child{margin-left:0}.btn-group>.btn:first-child:not(:last-child):not(.dropdown-toggle){border-top-right-radius:0;border-bottom-right-radius:0}.btn-group>.btn:last-child:not(:first-child),.btn-group>.dropdown-toggle:not(:first-child){border-top-left-radius:0;border-bottom-left-radius:0}.btn-group>.btn-group{float:left}.btn-group>.btn-group:not(:first-child):not(:last-child)>.btn{border-radius:0}.btn-group>.btn-group:first-child:not(:last-child)>.btn:last-child,.btn-group>.btn-group:first-child:not(:last-child)>.dropdown-toggle{border-top-right-radius:0;border-bottom-right-radius:0}.btn-group>.btn-group:last-child:not(:first-child)>.btn:first-child{border-top-left-radius:0;border-bottom-left-radius:0}.btn-group .dropdown-toggle:active,.btn-group.open .dropdown-toggle{outline:0}.btn-group>.btn+.dropdown-toggle{padding-right:8px;padding-left:8px}.btn-group>.btn-lg+.dropdown-toggle{padding-right:12px;padding-left:12px}.btn-group.open .dropdown-toggle{box-shadow:inset 0 3px 5px rgba(0,0,0,.125)}.btn-group.open .dropdown-toggle.btn-link{box-shadow:none}.btn .caret{margin-left:0}.btn-lg .caret{border-width:5px 5px 0;border-bottom-width:0}.dropup .btn-lg .caret{border-width:0 5px 5px}.btn-group-vertical>.btn,.btn-group-vertical>.btn-group,.btn-group-vertical>.btn-group>.btn{display:block;float:none;width:100%;max-width:100%}.btn-group-vertical>.btn-group>.btn{float:none}.btn-group-vertical>.btn+.btn,.btn-group-vertical>.btn+.btn-group,.btn-group-vertical>.btn-group+.btn,.btn-group-vertical>.btn-group+.btn-group{margin-top:-1px;margin-left:0}.btn-group-vertical>.btn:not(:first-child):not(:last-child){border-radius:0}.btn-group-vertical>.btn:first-child:not(:last-child){border-top-left-radius:4px;border-top-right-radius:4px;border-bottom-right-radius:0;border-bottom-left-radius:0}.btn-group-vertical>.btn:last-child:not(:first-child){border-top-left-radius:0;border-top-right-radius:0;border-bottom-right-radius:4px;border-bottom-left-radius:4px}.btn-group-vertical>.btn-group:not(:first-child):not(:last-child)>.btn{border-radius:0}.btn-group-vertical>.btn-group:first-child:not(:last-child)>.btn:last-child,.btn-group-vertical>.btn-group:first-child:not(:last-child)>.dropdown-toggle{border-bottom-right-radius:0;border-bottom-left-radius:0}.btn-group-vertical>.btn-group:last-child:not(:first-child)>.btn:first-child{border-top-left-radius:0;border-top-right-radius:0}.btn-group-justified{display:table;width:100%;table-layout:fixed;border-collapse:separate}.btn-group-justified>.btn,.btn-group-justified>.btn-group{display:table-cell;float:none;width:1%}.btn-group-justified>.btn-group .btn{width:100%}.btn-group-justified>.btn-group .dropdown-menu{left:auto}[data-toggle=buttons]>.btn-group>.btn input[type=checkbox],[data-toggle=buttons]>.btn-group>.btn input[type=radio],[data-toggle=buttons]>.btn input[type=checkbox],[data-toggle=buttons]>.btn input[type=radio]{position:absolute;clip:rect(0,0,0,0);pointer-events:none}.input-group{position:relative;display:table;border-collapse:separate}.input-group[class*=col-]{float:none;padding-right:0;padding-left:0}.input-group .form-control{position:relative;z-index:2;float:left;width:100%;margin-bottom:0}.input-group .form-control:focus{z-index:3}.input-group-lg>.form-control,.input-group-lg>.input-group-addon,.input-group-lg>.input-group-btn>.btn{height:46px;padding:10px 16px;font-size:18px;line-height:1.3333333;border-radius:6px}select.input-group-lg>.form-control,select.input-group-lg>.input-group-addon,select.input-group-lg>.input-group-btn>.btn{height:46px;line-height:46px}select[multiple].input-group-lg>.form-control,select[multiple].input-group-lg>.input-group-addon,select[multiple].input-group-lg>.input-group-btn>.btn,textarea.input-group-lg>.form-control,textarea.input-group-lg>.input-group-addon,textarea.input-group-lg>.input-group-btn>.btn{height:auto}.input-group-sm>.form-control,.input-group-sm>.input-group-addon,.input-group-sm>.input-group-btn>.btn{height:30px;padding:5px 10px;font-size:12px;line-height:1.5;border-radius:3px}select.input-group-sm>.form-control,select.input-group-sm>.input-group-addon,select.input-group-sm>.input-group-btn>.btn{height:30px;line-height:30px}select[multiple].input-group-sm>.form-control,select[multiple].input-group-sm>.input-group-addon,select[multiple].input-group-sm>.input-group-btn>.btn,textarea.input-group-sm>.form-control,textarea.input-group-sm>.input-group-addon,textarea.input-group-sm>.input-group-btn>.btn{height:auto}.input-group-addon,.input-group-btn,.input-group .form-control{display:table-cell}.input-group-addon:not(:first-child):not(:last-child),.input-group-btn:not(:first-child):not(:last-child),.input-group .form-control:not(:first-child):not(:last-child){border-radius:0}.input-group-addon,.input-group-btn{width:1%;white-space:nowrap;vertical-align:middle}.input-group-addon{padding:6px 12px;font-size:14px;font-weight:400;line-height:1;color:#555;text-align:center;background-color:#eee;border:1px solid #ccc;border-radius:4px}.input-group-addon.input-sm{padding:5px 10px;font-size:12px;border-radius:3px}.input-group-addon.input-lg{padding:10px 16px;font-size:18px;border-radius:6px}.input-group-addon input[type=checkbox],.input-group-addon input[type=radio]{margin-top:0}.input-group-addon:first-child,.input-group-btn:first-child>.btn,.input-group-btn:first-child>.btn-group>.btn,.input-group-btn:first-child>.dropdown-toggle,.input-group-btn:last-child>.btn-group:not(:last-child)>.btn,.input-group-btn:last-child>.btn:not(:last-child):not(.dropdown-toggle),.input-group .form-control:first-child{border-top-right-radius:0;border-bottom-right-radius:0}.input-group-addon:first-child{border-right:0}.input-group-addon:last-child,.input-group-btn:first-child>.btn-group:not(:first-child)>.btn,.input-group-btn:first-child>.btn:not(:first-child),.input-group-btn:last-child>.btn,.input-group-btn:last-child>.btn-group>.btn,.input-group-btn:last-child>.dropdown-toggle,.input-group .form-control:last-child{border-top-left-radius:0;border-bottom-left-radius:0}.input-group-addon:last-child{border-left:0}.input-group-btn{font-size:0;white-space:nowrap}.input-group-btn,.input-group-btn>.btn{position:relative}.input-group-btn>.btn+.btn{margin-left:-1px}.input-group-btn>.btn:active,.input-group-btn>.btn:focus,.input-group-btn>.btn:hover{z-index:2}.input-group-btn:first-child>.btn,.input-group-btn:first-child>.btn-group{margin-right:-1px}.input-group-btn:last-child>.btn,.input-group-btn:last-child>.btn-group{z-index:2;margin-left:-1px}.nav{padding-left:0;margin-bottom:0;list-style:none}.nav>li,.nav>li>a{position:relative;display:block}.nav>li>a{padding:10px 15px}.nav>li>a:focus,.nav>li>a:hover{text-decoration:none;background-color:#eee}.nav>li.disabled>a{color:#777}.nav>li.disabled>a:focus,.nav>li.disabled>a:hover{color:#777;text-decoration:none;cursor:not-allowed;background-color:transparent}.nav .open>a,.nav .open>a:focus,.nav .open>a:hover{background-color:#eee;border-color:#337ab7}.nav .nav-divider{height:1px;margin:9px 0;overflow:hidden;background-color:#e5e5e5}.nav>li>a>img{max-width:none}.nav-tabs{border-bottom:1px solid #ddd}.nav-tabs>li{float:left;margin-bottom:-1px}.nav-tabs>li>a{margin-right:2px;line-height:1.42857143;border:1px solid transparent;border-radius:4px 4px 0 0}.nav-tabs>li>a:hover{border-color:#eee #eee #ddd}.nav-tabs>li.active>a,.nav-tabs>li.active>a:focus,.nav-tabs>li.active>a:hover{color:#555;cursor:default;background-color:#fff;border:1px solid #ddd;border-bottom-color:transparent}.nav-tabs.nav-justified{width:100%;border-bottom:0}.nav-tabs.nav-justified>li{float:none}.nav-tabs.nav-justified>li>a{margin-bottom:5px;text-align:center}.nav-tabs.nav-justified>.dropdown .dropdown-menu{top:auto;left:auto}@media (min-width:768px){.nav-tabs.nav-justified>li{display:table-cell;width:1%}.nav-tabs.nav-justified>li>a{margin-bottom:0}}.nav-tabs.nav-justified>li>a{margin-right:0;border-radius:4px}.nav-tabs.nav-justified>.active>a,.nav-tabs.nav-justified>.active>a:focus,.nav-tabs.nav-justified>.active>a:hover{border:1px solid #ddd}@media (min-width:768px){.nav-tabs.nav-justified>li>a{border-bottom:1px solid #ddd;border-radius:4px 4px 0 0}.nav-tabs.nav-justified>.active>a,.nav-tabs.nav-justified>.active>a:focus,.nav-tabs.nav-justified>.active>a:hover{border-bottom-color:#fff}}.nav-pills>li{float:left}.nav-pills>li>a{border-radius:4px}.nav-pills>li+li{margin-left:2px}.nav-pills>li.active>a,.nav-pills>li.active>a:focus,.nav-pills>li.active>a:hover{color:#fff;background-color:#337ab7}.nav-stacked>li{float:none}.nav-stacked>li+li{margin-top:2px;margin-left:0}.nav-justified{width:100%}.nav-justified>li{float:none}.nav-justified>li>a{margin-bottom:5px;text-align:center}.nav-justified>.dropdown .dropdown-menu{top:auto;left:auto}@media (min-width:768px){.nav-justified>li{display:table-cell;width:1%}.nav-justified>li>a{margin-bottom:0}}.nav-tabs-justified{border-bottom:0}.nav-tabs-justified>li>a{margin-right:0;border-radius:4px}.nav-tabs-justified>.active>a,.nav-tabs-justified>.active>a:focus,.nav-tabs-justified>.active>a:hover{border:1px solid #ddd}@media (min-width:768px){.nav-tabs-justified>li>a{border-bottom:1px solid #ddd;border-radius:4px 4px 0 0}.nav-tabs-justified>.active>a,.nav-tabs-justified>.active>a:focus,.nav-tabs-justified>.active>a:hover{border-bottom-color:#fff}}.tab-content>.tab-pane{display:none}.tab-content>.active{display:block}.nav-tabs .dropdown-menu{margin-top:-1px;border-top-left-radius:0;border-top-right-radius:0}.navbar{position:relative;min-height:50px;margin-bottom:20px;border:1px solid transparent}@media (min-width:768px){.navbar{border-radius:4px}}@media (min-width:768px){.navbar-header{float:left}}.navbar-collapse{padding-right:15px;padding-left:15px;overflow-x:visible;-webkit-overflow-scrolling:touch;border-top:1px solid transparent;box-shadow:inset 0 1px 0 hsla(0,0%,100%,.1)}.navbar-collapse.in{overflow-y:auto}@media (min-width:768px){.navbar-collapse{width:auto;border-top:0;box-shadow:none}.navbar-collapse.collapse{display:block!important;height:auto!important;padding-bottom:0;overflow:visible!important}.navbar-collapse.in{overflow-y:visible}.navbar-fixed-bottom .navbar-collapse,.navbar-fixed-top .navbar-collapse,.navbar-static-top .navbar-collapse{padding-right:0;padding-left:0}}.navbar-fixed-bottom .navbar-collapse,.navbar-fixed-top .navbar-collapse{max-height:340px}@media (max-device-width:480px) and (orientation:landscape){.navbar-fixed-bottom .navbar-collapse,.navbar-fixed-top .navbar-collapse{max-height:200px}}.container-fluid>.navbar-collapse,.container-fluid>.navbar-header,.container>.navbar-collapse,.container>.navbar-header{margin-right:-15px;margin-left:-15px}@media (min-width:768px){.container-fluid>.navbar-collapse,.container-fluid>.navbar-header,.container>.navbar-collapse,.container>.navbar-header{margin-right:0;margin-left:0}}.navbar-static-top{z-index:1000;border-width:0 0 1px}@media (min-width:768px){.navbar-static-top{border-radius:0}}.navbar-fixed-bottom,.navbar-fixed-top{position:fixed;right:0;left:0;z-index:1030}@media (min-width:768px){.navbar-fixed-bottom,.navbar-fixed-top{border-radius:0}}.navbar-fixed-top{top:0;border-width:0 0 1px}.navbar-fixed-bottom{bottom:0;margin-bottom:0;border-width:1px 0 0}.navbar-brand{float:left;height:50px;padding:15px;font-size:18px;line-height:20px}.navbar-brand:focus,.navbar-brand:hover{text-decoration:none}.navbar-brand>img{display:block}@media (min-width:768px){.navbar>.container-fluid .navbar-brand,.navbar>.container .navbar-brand{margin-left:-15px}}.navbar-toggle{position:relative;float:right;padding:9px 10px;margin-top:8px;margin-right:15px;margin-bottom:8px;background-color:transparent;background-image:none;border:1px solid transparent;border-radius:4px}.navbar-toggle:focus{outline:0}.navbar-toggle .icon-bar{display:block;width:22px;height:2px;border-radius:1px}.navbar-toggle .icon-bar+.icon-bar{margin-top:4px}@media (min-width:768px){.navbar-toggle{display:none}}.navbar-nav{margin:7.5px -15px}.navbar-nav>li>a{padding-top:10px;padding-bottom:10px;line-height:20px}@media (max-width:767px){.navbar-nav .open .dropdown-menu{position:static;float:none;width:auto;margin-top:0;background-color:transparent;border:0;box-shadow:none}.navbar-nav .open .dropdown-menu .dropdown-header,.navbar-nav .open .dropdown-menu>li>a{padding:5px 15px 5px 25px}.navbar-nav .open .dropdown-menu>li>a{line-height:20px}.navbar-nav .open .dropdown-menu>li>a:focus,.navbar-nav .open .dropdown-menu>li>a:hover{background-image:none}}@media (min-width:768px){.navbar-nav{float:left;margin:0}.navbar-nav>li{float:left}.navbar-nav>li>a{padding-top:15px;padding-bottom:15px}}.navbar-form{padding:10px 15px;margin:8px -15px;border-top:1px solid transparent;border-bottom:1px solid transparent;box-shadow:inset 0 1px 0 hsla(0,0%,100%,.1),0 1px 0 hsla(0,0%,100%,.1)}@media (min-width:768px){.navbar-form .form-group{display:inline-block;margin-bottom:0;vertical-align:middle}.navbar-form .form-control{display:inline-block;width:auto;vertical-align:middle}.navbar-form .form-control-static{display:inline-block}.navbar-form .input-group{display:inline-table;vertical-align:middle}.navbar-form .input-group .form-control,.navbar-form .input-group .input-group-addon,.navbar-form .input-group .input-group-btn{width:auto}.navbar-form .input-group>.form-control{width:100%}.navbar-form .control-label{margin-bottom:0;vertical-align:middle}.navbar-form .checkbox,.navbar-form .radio{display:inline-block;margin-top:0;margin-bottom:0;vertical-align:middle}.navbar-form .checkbox label,.navbar-form .radio label{padding-left:0}.navbar-form .checkbox input[type=checkbox],.navbar-form .radio input[type=radio]{position:relative;margin-left:0}.navbar-form .has-feedback .form-control-feedback{top:0}}@media (max-width:767px){.navbar-form .form-group{margin-bottom:5px}.navbar-form .form-group:last-child{margin-bottom:0}}@media (min-width:768px){.navbar-form{width:auto;padding-top:0;padding-bottom:0;margin-right:0;margin-left:0;border:0;box-shadow:none}}.navbar-nav>li>.dropdown-menu{margin-top:0;border-top-left-radius:0;border-top-right-radius:0}.navbar-fixed-bottom .navbar-nav>li>.dropdown-menu{margin-bottom:0;border-top-left-radius:4px;border-top-right-radius:4px;border-bottom-right-radius:0;border-bottom-left-radius:0}.navbar-btn{margin-top:8px;margin-bottom:8px}.navbar-btn.btn-sm{margin-top:10px;margin-bottom:10px}.navbar-btn.btn-xs{margin-top:14px;margin-bottom:14px}.navbar-text{margin-top:15px;margin-bottom:15px}@media (min-width:768px){.navbar-text{float:left;margin-right:15px;margin-left:15px}}@media (min-width:768px){.navbar-left{float:left!important}.navbar-right{float:right!important;margin-right:-15px}.navbar-right~.navbar-right{margin-right:0}}.navbar-default{background-color:#f8f8f8;border-color:#e7e7e7}.navbar-default .navbar-brand{color:#777}.navbar-default .navbar-brand:focus,.navbar-default .navbar-brand:hover{color:#5e5e5e;background-color:transparent}.navbar-default .navbar-nav>li>a,.navbar-default .navbar-text{color:#777}.navbar-default .navbar-nav>li>a:focus,.navbar-default .navbar-nav>li>a:hover{color:#333;background-color:transparent}.navbar-default .navbar-nav>.active>a,.navbar-default .navbar-nav>.active>a:focus,.navbar-default .navbar-nav>.active>a:hover{color:#555;background-color:#e7e7e7}.navbar-default .navbar-nav>.disabled>a,.navbar-default .navbar-nav>.disabled>a:focus,.navbar-default .navbar-nav>.disabled>a:hover{color:#ccc;background-color:transparent}.navbar-default .navbar-toggle{border-color:#ddd}.navbar-default .navbar-toggle:focus,.navbar-default .navbar-toggle:hover{background-color:#ddd}.navbar-default .navbar-toggle .icon-bar{background-color:#888}.navbar-default .navbar-collapse,.navbar-default .navbar-form{border-color:#e7e7e7}.navbar-default .navbar-nav>.open>a,.navbar-default .navbar-nav>.open>a:focus,.navbar-default .navbar-nav>.open>a:hover{color:#555;background-color:#e7e7e7}@media (max-width:767px){.navbar-default .navbar-nav .open .dropdown-menu>li>a{color:#777}.navbar-default .navbar-nav .open .dropdown-menu>li>a:focus,.navbar-default .navbar-nav .open .dropdown-menu>li>a:hover{color:#333;background-color:transparent}.navbar-default .navbar-nav .open .dropdown-menu>.active>a,.navbar-default .navbar-nav .open .dropdown-menu>.active>a:focus,.navbar-default .navbar-nav .open .dropdown-menu>.active>a:hover{color:#555;background-color:#e7e7e7}.navbar-default .navbar-nav .open .dropdown-menu>.disabled>a,.navbar-default .navbar-nav .open .dropdown-menu>.disabled>a:focus,.navbar-default .navbar-nav .open .dropdown-menu>.disabled>a:hover{color:#ccc;background-color:transparent}}.navbar-default .navbar-link{color:#777}.navbar-default .navbar-link:hover{color:#333}.navbar-default .btn-link{color:#777}.navbar-default .btn-link:focus,.navbar-default .btn-link:hover{color:#333}.navbar-default .btn-link[disabled]:focus,.navbar-default .btn-link[disabled]:hover,fieldset[disabled] .navbar-default .btn-link:focus,fieldset[disabled] .navbar-default .btn-link:hover{color:#ccc}.navbar-inverse{background-color:#222;border-color:#080808}.navbar-inverse .navbar-brand{color:#9d9d9d}.navbar-inverse .navbar-brand:focus,.navbar-inverse .navbar-brand:hover{color:#fff;background-color:transparent}.navbar-inverse .navbar-nav>li>a,.navbar-inverse .navbar-text{color:#9d9d9d}.navbar-inverse .navbar-nav>li>a:focus,.navbar-inverse .navbar-nav>li>a:hover{color:#fff;background-color:transparent}.navbar-inverse .navbar-nav>.active>a,.navbar-inverse .navbar-nav>.active>a:focus,.navbar-inverse .navbar-nav>.active>a:hover{color:#fff;background-color:#080808}.navbar-inverse .navbar-nav>.disabled>a,.navbar-inverse .navbar-nav>.disabled>a:focus,.navbar-inverse .navbar-nav>.disabled>a:hover{color:#444;background-color:transparent}.navbar-inverse .navbar-toggle{border-color:#333}.navbar-inverse .navbar-toggle:focus,.navbar-inverse .navbar-toggle:hover{background-color:#333}.navbar-inverse .navbar-toggle .icon-bar{background-color:#fff}.navbar-inverse .navbar-collapse,.navbar-inverse .navbar-form{border-color:#101010}.navbar-inverse .navbar-nav>.open>a,.navbar-inverse .navbar-nav>.open>a:focus,.navbar-inverse .navbar-nav>.open>a:hover{color:#fff;background-color:#080808}@media (max-width:767px){.navbar-inverse .navbar-nav .open .dropdown-menu>.dropdown-header{border-color:#080808}.navbar-inverse .navbar-nav .open .dropdown-menu .divider{background-color:#080808}.navbar-inverse .navbar-nav .open .dropdown-menu>li>a{color:#9d9d9d}.navbar-inverse .navbar-nav .open .dropdown-menu>li>a:focus,.navbar-inverse .navbar-nav .open .dropdown-menu>li>a:hover{color:#fff;background-color:transparent}.navbar-inverse .navbar-nav .open .dropdown-menu>.active>a,.navbar-inverse .navbar-nav .open .dropdown-menu>.active>a:focus,.navbar-inverse .navbar-nav .open .dropdown-menu>.active>a:hover{color:#fff;background-color:#080808}.navbar-inverse .navbar-nav .open .dropdown-menu>.disabled>a,.navbar-inverse .navbar-nav .open .dropdown-menu>.disabled>a:focus,.navbar-inverse .navbar-nav .open .dropdown-menu>.disabled>a:hover{color:#444;background-color:transparent}}.navbar-inverse .navbar-link{color:#9d9d9d}.navbar-inverse .navbar-link:hover{color:#fff}.navbar-inverse .btn-link{color:#9d9d9d}.navbar-inverse .btn-link:focus,.navbar-inverse .btn-link:hover{color:#fff}.navbar-inverse .btn-link[disabled]:focus,.navbar-inverse .btn-link[disabled]:hover,fieldset[disabled] .navbar-inverse .btn-link:focus,fieldset[disabled] .navbar-inverse .btn-link:hover{color:#444}.breadcrumb{padding:8px 15px;margin-bottom:20px;list-style:none;background-color:#f5f5f5;border-radius:4px}.breadcrumb>li{display:inline-block}.breadcrumb>li+li:before{padding:0 5px;color:#ccc;content:\"/\\A0\"}.breadcrumb>.active{color:#777}.pagination{display:inline-block;padding-left:0;margin:20px 0;border-radius:4px}.pagination>li{display:inline}.pagination>li>a,.pagination>li>span{position:relative;float:left;padding:6px 12px;margin-left:-1px;line-height:1.42857143;color:#337ab7;text-decoration:none;background-color:#fff;border:1px solid #ddd}.pagination>li:first-child>a,.pagination>li:first-child>span{margin-left:0;border-top-left-radius:4px;border-bottom-left-radius:4px}.pagination>li:last-child>a,.pagination>li:last-child>span{border-top-right-radius:4px;border-bottom-right-radius:4px}.pagination>li>a:focus,.pagination>li>a:hover,.pagination>li>span:focus,.pagination>li>span:hover{z-index:2;color:#23527c;background-color:#eee;border-color:#ddd}.pagination>.active>a,.pagination>.active>a:focus,.pagination>.active>a:hover,.pagination>.active>span,.pagination>.active>span:focus,.pagination>.active>span:hover{z-index:3;color:#fff;cursor:default;background-color:#337ab7;border-color:#337ab7}.pagination>.disabled>a,.pagination>.disabled>a:focus,.pagination>.disabled>a:hover,.pagination>.disabled>span,.pagination>.disabled>span:focus,.pagination>.disabled>span:hover{color:#777;cursor:not-allowed;background-color:#fff;border-color:#ddd}.pagination-lg>li>a,.pagination-lg>li>span{padding:10px 16px;font-size:18px;line-height:1.3333333}.pagination-lg>li:first-child>a,.pagination-lg>li:first-child>span{border-top-left-radius:6px;border-bottom-left-radius:6px}.pagination-lg>li:last-child>a,.pagination-lg>li:last-child>span{border-top-right-radius:6px;border-bottom-right-radius:6px}.pagination-sm>li>a,.pagination-sm>li>span{padding:5px 10px;font-size:12px;line-height:1.5}.pagination-sm>li:first-child>a,.pagination-sm>li:first-child>span{border-top-left-radius:3px;border-bottom-left-radius:3px}.pagination-sm>li:last-child>a,.pagination-sm>li:last-child>span{border-top-right-radius:3px;border-bottom-right-radius:3px}.pager{padding-left:0;margin:20px 0;text-align:center;list-style:none}.pager li{display:inline}.pager li>a,.pager li>span{display:inline-block;padding:5px 14px;background-color:#fff;border:1px solid #ddd;border-radius:15px}.pager li>a:focus,.pager li>a:hover{text-decoration:none;background-color:#eee}.pager .next>a,.pager .next>span{float:right}.pager .previous>a,.pager .previous>span{float:left}.pager .disabled>a,.pager .disabled>a:focus,.pager .disabled>a:hover,.pager .disabled>span{color:#777;cursor:not-allowed;background-color:#fff}.label{display:inline;padding:.2em .6em .3em;font-size:75%;font-weight:700;line-height:1;color:#fff;text-align:center;white-space:nowrap;vertical-align:baseline;border-radius:.25em}a.label:focus,a.label:hover{color:#fff;text-decoration:none;cursor:pointer}.label:empty{display:none}.btn .label{position:relative;top:-1px}.label-default{background-color:#777}.label-default[href]:focus,.label-default[href]:hover{background-color:#5e5e5e}.label-primary{background-color:#337ab7}.label-primary[href]:focus,.label-primary[href]:hover{background-color:#286090}.label-success{background-color:#5cb85c}.label-success[href]:focus,.label-success[href]:hover{background-color:#449d44}.label-info{background-color:#5bc0de}.label-info[href]:focus,.label-info[href]:hover{background-color:#31b0d5}.label-warning{background-color:#f0ad4e}.label-warning[href]:focus,.label-warning[href]:hover{background-color:#ec971f}.label-danger{background-color:#d9534f}.label-danger[href]:focus,.label-danger[href]:hover{background-color:#c9302c}.badge{display:inline-block;min-width:10px;padding:3px 7px;font-size:12px;font-weight:700;line-height:1;color:#fff;text-align:center;white-space:nowrap;vertical-align:middle;background-color:#777;border-radius:10px}.badge:empty{display:none}.btn .badge{position:relative;top:-1px}.btn-group-xs>.btn .badge,.btn-xs .badge{top:0;padding:1px 5px}a.badge:focus,a.badge:hover{color:#fff;text-decoration:none;cursor:pointer}.list-group-item.active>.badge,.nav-pills>.active>a>.badge{color:#337ab7;background-color:#fff}.list-group-item>.badge{float:right}.list-group-item>.badge+.badge{margin-right:5px}.nav-pills>li>a>.badge{margin-left:3px}.jumbotron{padding-top:30px;padding-bottom:30px;margin-bottom:30px;background-color:#eee}.jumbotron,.jumbotron .h1,.jumbotron h1{color:inherit}.jumbotron p{margin-bottom:15px;font-size:21px;font-weight:200}.jumbotron>hr{border-top-color:#d5d5d5}.container-fluid .jumbotron,.container .jumbotron{padding-right:15px;padding-left:15px;border-radius:6px}.jumbotron .container{max-width:100%}@media screen and (min-width:768px){.jumbotron{padding-top:48px;padding-bottom:48px}.container-fluid .jumbotron,.container .jumbotron{padding-right:60px;padding-left:60px}.jumbotron .h1,.jumbotron h1{font-size:63px}}.thumbnail{display:block;padding:4px;margin-bottom:20px;line-height:1.42857143;background-color:#fff;border:1px solid #ddd;border-radius:4px;transition:border .2s ease-in-out}.thumbnail>img,.thumbnail a>img{margin-right:auto;margin-left:auto}a.thumbnail.active,a.thumbnail:focus,a.thumbnail:hover{border-color:#337ab7}.thumbnail .caption{padding:9px;color:#333}.alert{padding:15px;margin-bottom:20px;border:1px solid transparent;border-radius:4px}.alert h4{margin-top:0;color:inherit}.alert .alert-link{font-weight:700}.alert>p,.alert>ul{margin-bottom:0}.alert>p+p{margin-top:5px}.alert-dismissable,.alert-dismissible{padding-right:35px}.alert-dismissable .close,.alert-dismissible .close{position:relative;top:-2px;right:-21px;color:inherit}.alert-success{color:#3c763d;background-color:#dff0d8;border-color:#d6e9c6}.alert-success hr{border-top-color:#c9e2b3}.alert-success .alert-link{color:#2b542c}.alert-info{color:#31708f;background-color:#d9edf7;border-color:#bce8f1}.alert-info hr{border-top-color:#a6e1ec}.alert-info .alert-link{color:#245269}.alert-warning{color:#8a6d3b;background-color:#fcf8e3;border-color:#faebcc}.alert-warning hr{border-top-color:#f7e1b5}.alert-warning .alert-link{color:#66512c}.alert-danger{color:#a94442;background-color:#f2dede;border-color:#ebccd1}.alert-danger hr{border-top-color:#e4b9c0}.alert-danger .alert-link{color:#843534}@keyframes progress-bar-stripes{0%{background-position:40px 0}to{background-position:0 0}}.progress{height:20px;margin-bottom:20px;overflow:hidden;background-color:#f5f5f5;border-radius:4px;box-shadow:inset 0 1px 2px rgba(0,0,0,.1)}.progress-bar{float:left;width:0;height:100%;font-size:12px;line-height:20px;color:#fff;text-align:center;background-color:#337ab7;box-shadow:inset 0 -1px 0 rgba(0,0,0,.15);transition:width .6s ease}.progress-bar-striped,.progress-striped .progress-bar{background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent);background-size:40px 40px}.progress-bar.active,.progress.active .progress-bar{animation:progress-bar-stripes 2s linear infinite}.progress-bar-success{background-color:#5cb85c}.progress-striped .progress-bar-success{background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}.progress-bar-info{background-color:#5bc0de}.progress-striped .progress-bar-info{background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}.progress-bar-warning{background-color:#f0ad4e}.progress-striped .progress-bar-warning{background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}.progress-bar-danger{background-color:#d9534f}.progress-striped .progress-bar-danger{background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}.media{margin-top:15px}.media:first-child{margin-top:0}.media,.media-body{overflow:hidden;zoom:1}.media-body{width:10000px}.media-object{display:block}.media-object.img-thumbnail{max-width:none}.media-right,.media>.pull-right{padding-left:10px}.media-left,.media>.pull-left{padding-right:10px}.media-body,.media-left,.media-right{display:table-cell;vertical-align:top}.media-middle{vertical-align:middle}.media-bottom{vertical-align:bottom}.media-heading{margin-top:0;margin-bottom:5px}.media-list{padding-left:0;list-style:none}.list-group{padding-left:0;margin-bottom:20px}.list-group-item{position:relative;display:block;padding:10px 15px;margin-bottom:-1px;background-color:#fff;border:1px solid #ddd}.list-group-item:first-child{border-top-left-radius:4px;border-top-right-radius:4px}.list-group-item:last-child{margin-bottom:0;border-bottom-right-radius:4px;border-bottom-left-radius:4px}a.list-group-item,button.list-group-item{color:#555}a.list-group-item .list-group-item-heading,button.list-group-item .list-group-item-heading{color:#333}a.list-group-item:focus,a.list-group-item:hover,button.list-group-item:focus,button.list-group-item:hover{color:#555;text-decoration:none;background-color:#f5f5f5}button.list-group-item{width:100%;text-align:left}.list-group-item.disabled,.list-group-item.disabled:focus,.list-group-item.disabled:hover{color:#777;cursor:not-allowed;background-color:#eee}.list-group-item.disabled .list-group-item-heading,.list-group-item.disabled:focus .list-group-item-heading,.list-group-item.disabled:hover .list-group-item-heading{color:inherit}.list-group-item.disabled .list-group-item-text,.list-group-item.disabled:focus .list-group-item-text,.list-group-item.disabled:hover .list-group-item-text{color:#777}.list-group-item.active,.list-group-item.active:focus,.list-group-item.active:hover{z-index:2;color:#fff;background-color:#337ab7;border-color:#337ab7}.list-group-item.active .list-group-item-heading,.list-group-item.active .list-group-item-heading>.small,.list-group-item.active .list-group-item-heading>small,.list-group-item.active:focus .list-group-item-heading,.list-group-item.active:focus .list-group-item-heading>.small,.list-group-item.active:focus .list-group-item-heading>small,.list-group-item.active:hover .list-group-item-heading,.list-group-item.active:hover .list-group-item-heading>.small,.list-group-item.active:hover .list-group-item-heading>small{color:inherit}.list-group-item.active .list-group-item-text,.list-group-item.active:focus .list-group-item-text,.list-group-item.active:hover .list-group-item-text{color:#c7ddef}.list-group-item-success{color:#3c763d;background-color:#dff0d8}a.list-group-item-success,button.list-group-item-success{color:#3c763d}a.list-group-item-success .list-group-item-heading,button.list-group-item-success .list-group-item-heading{color:inherit}a.list-group-item-success:focus,a.list-group-item-success:hover,button.list-group-item-success:focus,button.list-group-item-success:hover{color:#3c763d;background-color:#d0e9c6}a.list-group-item-success.active,a.list-group-item-success.active:focus,a.list-group-item-success.active:hover,button.list-group-item-success.active,button.list-group-item-success.active:focus,button.list-group-item-success.active:hover{color:#fff;background-color:#3c763d;border-color:#3c763d}.list-group-item-info{color:#31708f;background-color:#d9edf7}a.list-group-item-info,button.list-group-item-info{color:#31708f}a.list-group-item-info .list-group-item-heading,button.list-group-item-info .list-group-item-heading{color:inherit}a.list-group-item-info:focus,a.list-group-item-info:hover,button.list-group-item-info:focus,button.list-group-item-info:hover{color:#31708f;background-color:#c4e3f3}a.list-group-item-info.active,a.list-group-item-info.active:focus,a.list-group-item-info.active:hover,button.list-group-item-info.active,button.list-group-item-info.active:focus,button.list-group-item-info.active:hover{color:#fff;background-color:#31708f;border-color:#31708f}.list-group-item-warning{color:#8a6d3b;background-color:#fcf8e3}a.list-group-item-warning,button.list-group-item-warning{color:#8a6d3b}a.list-group-item-warning .list-group-item-heading,button.list-group-item-warning .list-group-item-heading{color:inherit}a.list-group-item-warning:focus,a.list-group-item-warning:hover,button.list-group-item-warning:focus,button.list-group-item-warning:hover{color:#8a6d3b;background-color:#faf2cc}a.list-group-item-warning.active,a.list-group-item-warning.active:focus,a.list-group-item-warning.active:hover,button.list-group-item-warning.active,button.list-group-item-warning.active:focus,button.list-group-item-warning.active:hover{color:#fff;background-color:#8a6d3b;border-color:#8a6d3b}.list-group-item-danger{color:#a94442;background-color:#f2dede}a.list-group-item-danger,button.list-group-item-danger{color:#a94442}a.list-group-item-danger .list-group-item-heading,button.list-group-item-danger .list-group-item-heading{color:inherit}a.list-group-item-danger:focus,a.list-group-item-danger:hover,button.list-group-item-danger:focus,button.list-group-item-danger:hover{color:#a94442;background-color:#ebcccc}a.list-group-item-danger.active,a.list-group-item-danger.active:focus,a.list-group-item-danger.active:hover,button.list-group-item-danger.active,button.list-group-item-danger.active:focus,button.list-group-item-danger.active:hover{color:#fff;background-color:#a94442;border-color:#a94442}.list-group-item-heading{margin-top:0;margin-bottom:5px}.list-group-item-text{margin-bottom:0;line-height:1.3}.panel{margin-bottom:20px;background-color:#fff;border:1px solid transparent;border-radius:4px;box-shadow:0 1px 1px rgba(0,0,0,.05)}.panel-body{padding:15px}.panel-heading{padding:10px 15px;border-bottom:1px solid transparent;border-top-left-radius:3px;border-top-right-radius:3px}.panel-heading>.dropdown .dropdown-toggle,.panel-title{color:inherit}.panel-title{margin-top:0;margin-bottom:0;font-size:16px}.panel-title>.small,.panel-title>.small>a,.panel-title>a,.panel-title>small,.panel-title>small>a{color:inherit}.panel-footer{padding:10px 15px;background-color:#f5f5f5;border-top:1px solid #ddd;border-bottom-right-radius:3px;border-bottom-left-radius:3px}.panel>.list-group,.panel>.panel-collapse>.list-group{margin-bottom:0}.panel>.list-group .list-group-item,.panel>.panel-collapse>.list-group .list-group-item{border-width:1px 0;border-radius:0}.panel>.list-group:first-child .list-group-item:first-child,.panel>.panel-collapse>.list-group:first-child .list-group-item:first-child{border-top:0;border-top-left-radius:3px;border-top-right-radius:3px}.panel>.list-group:last-child .list-group-item:last-child,.panel>.panel-collapse>.list-group:last-child .list-group-item:last-child{border-bottom:0;border-bottom-right-radius:3px;border-bottom-left-radius:3px}.panel>.panel-heading+.panel-collapse>.list-group .list-group-item:first-child{border-top-left-radius:0;border-top-right-radius:0}.list-group+.panel-footer,.panel-heading+.list-group .list-group-item:first-child{border-top-width:0}.panel>.panel-collapse>.table,.panel>.table,.panel>.table-responsive>.table{margin-bottom:0}.panel>.panel-collapse>.table caption,.panel>.table-responsive>.table caption,.panel>.table caption{padding-right:15px;padding-left:15px}.panel>.table-responsive:first-child>.table:first-child,.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child,.panel>.table:first-child,.panel>.table:first-child>tbody:first-child>tr:first-child,.panel>.table:first-child>thead:first-child>tr:first-child{border-top-left-radius:3px;border-top-right-radius:3px}.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child td:first-child,.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child th:first-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child td:first-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child th:first-child,.panel>.table:first-child>tbody:first-child>tr:first-child td:first-child,.panel>.table:first-child>tbody:first-child>tr:first-child th:first-child,.panel>.table:first-child>thead:first-child>tr:first-child td:first-child,.panel>.table:first-child>thead:first-child>tr:first-child th:first-child{border-top-left-radius:3px}.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child td:last-child,.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child th:last-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child td:last-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child th:last-child,.panel>.table:first-child>tbody:first-child>tr:first-child td:last-child,.panel>.table:first-child>tbody:first-child>tr:first-child th:last-child,.panel>.table:first-child>thead:first-child>tr:first-child td:last-child,.panel>.table:first-child>thead:first-child>tr:first-child th:last-child{border-top-right-radius:3px}.panel>.table-responsive:last-child>.table:last-child,.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child,.panel>.table:last-child,.panel>.table:last-child>tbody:last-child>tr:last-child,.panel>.table:last-child>tfoot:last-child>tr:last-child{border-bottom-right-radius:3px;border-bottom-left-radius:3px}.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child td:first-child,.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child th:first-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child td:first-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child th:first-child,.panel>.table:last-child>tbody:last-child>tr:last-child td:first-child,.panel>.table:last-child>tbody:last-child>tr:last-child th:first-child,.panel>.table:last-child>tfoot:last-child>tr:last-child td:first-child,.panel>.table:last-child>tfoot:last-child>tr:last-child th:first-child{border-bottom-left-radius:3px}.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child td:last-child,.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child th:last-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child td:last-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child th:last-child,.panel>.table:last-child>tbody:last-child>tr:last-child td:last-child,.panel>.table:last-child>tbody:last-child>tr:last-child th:last-child,.panel>.table:last-child>tfoot:last-child>tr:last-child td:last-child,.panel>.table:last-child>tfoot:last-child>tr:last-child th:last-child{border-bottom-right-radius:3px}.panel>.panel-body+.table,.panel>.panel-body+.table-responsive,.panel>.table+.panel-body,.panel>.table-responsive+.panel-body{border-top:1px solid #ddd}.panel>.table>tbody:first-child>tr:first-child td,.panel>.table>tbody:first-child>tr:first-child th{border-top:0}.panel>.table-bordered,.panel>.table-responsive>.table-bordered{border:0}.panel>.table-bordered>tbody>tr>td:first-child,.panel>.table-bordered>tbody>tr>th:first-child,.panel>.table-bordered>tfoot>tr>td:first-child,.panel>.table-bordered>tfoot>tr>th:first-child,.panel>.table-bordered>thead>tr>td:first-child,.panel>.table-bordered>thead>tr>th:first-child,.panel>.table-responsive>.table-bordered>tbody>tr>td:first-child,.panel>.table-responsive>.table-bordered>tbody>tr>th:first-child,.panel>.table-responsive>.table-bordered>tfoot>tr>td:first-child,.panel>.table-responsive>.table-bordered>tfoot>tr>th:first-child,.panel>.table-responsive>.table-bordered>thead>tr>td:first-child,.panel>.table-responsive>.table-bordered>thead>tr>th:first-child{border-left:0}.panel>.table-bordered>tbody>tr>td:last-child,.panel>.table-bordered>tbody>tr>th:last-child,.panel>.table-bordered>tfoot>tr>td:last-child,.panel>.table-bordered>tfoot>tr>th:last-child,.panel>.table-bordered>thead>tr>td:last-child,.panel>.table-bordered>thead>tr>th:last-child,.panel>.table-responsive>.table-bordered>tbody>tr>td:last-child,.panel>.table-responsive>.table-bordered>tbody>tr>th:last-child,.panel>.table-responsive>.table-bordered>tfoot>tr>td:last-child,.panel>.table-responsive>.table-bordered>tfoot>tr>th:last-child,.panel>.table-responsive>.table-bordered>thead>tr>td:last-child,.panel>.table-responsive>.table-bordered>thead>tr>th:last-child{border-right:0}.panel>.table-bordered>tbody>tr:first-child>td,.panel>.table-bordered>tbody>tr:first-child>th,.panel>.table-bordered>tbody>tr:last-child>td,.panel>.table-bordered>tbody>tr:last-child>th,.panel>.table-bordered>tfoot>tr:last-child>td,.panel>.table-bordered>tfoot>tr:last-child>th,.panel>.table-bordered>thead>tr:first-child>td,.panel>.table-bordered>thead>tr:first-child>th,.panel>.table-responsive>.table-bordered>tbody>tr:first-child>td,.panel>.table-responsive>.table-bordered>tbody>tr:first-child>th,.panel>.table-responsive>.table-bordered>tbody>tr:last-child>td,.panel>.table-responsive>.table-bordered>tbody>tr:last-child>th,.panel>.table-responsive>.table-bordered>tfoot>tr:last-child>td,.panel>.table-responsive>.table-bordered>tfoot>tr:last-child>th,.panel>.table-responsive>.table-bordered>thead>tr:first-child>td,.panel>.table-responsive>.table-bordered>thead>tr:first-child>th{border-bottom:0}.panel>.table-responsive{margin-bottom:0;border:0}.panel-group{margin-bottom:20px}.panel-group .panel{margin-bottom:0;border-radius:4px}.panel-group .panel+.panel{margin-top:5px}.panel-group .panel-heading{border-bottom:0}.panel-group .panel-heading+.panel-collapse>.list-group,.panel-group .panel-heading+.panel-collapse>.panel-body{border-top:1px solid #ddd}.panel-group .panel-footer{border-top:0}.panel-group .panel-footer+.panel-collapse .panel-body{border-bottom:1px solid #ddd}.panel-default{border-color:#ddd}.panel-default>.panel-heading{color:#333;background-color:#f5f5f5;border-color:#ddd}.panel-default>.panel-heading+.panel-collapse>.panel-body{border-top-color:#ddd}.panel-default>.panel-heading .badge{color:#f5f5f5;background-color:#333}.panel-default>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#ddd}.panel-primary{border-color:#337ab7}.panel-primary>.panel-heading{color:#fff;background-color:#337ab7;border-color:#337ab7}.panel-primary>.panel-heading+.panel-collapse>.panel-body{border-top-color:#337ab7}.panel-primary>.panel-heading .badge{color:#337ab7;background-color:#fff}.panel-primary>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#337ab7}.panel-success{border-color:#d6e9c6}.panel-success>.panel-heading{color:#3c763d;background-color:#dff0d8;border-color:#d6e9c6}.panel-success>.panel-heading+.panel-collapse>.panel-body{border-top-color:#d6e9c6}.panel-success>.panel-heading .badge{color:#dff0d8;background-color:#3c763d}.panel-success>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#d6e9c6}.panel-info{border-color:#bce8f1}.panel-info>.panel-heading{color:#31708f;background-color:#d9edf7;border-color:#bce8f1}.panel-info>.panel-heading+.panel-collapse>.panel-body{border-top-color:#bce8f1}.panel-info>.panel-heading .badge{color:#d9edf7;background-color:#31708f}.panel-info>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#bce8f1}.panel-warning{border-color:#faebcc}.panel-warning>.panel-heading{color:#8a6d3b;background-color:#fcf8e3;border-color:#faebcc}.panel-warning>.panel-heading+.panel-collapse>.panel-body{border-top-color:#faebcc}.panel-warning>.panel-heading .badge{color:#fcf8e3;background-color:#8a6d3b}.panel-warning>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#faebcc}.panel-danger{border-color:#ebccd1}.panel-danger>.panel-heading{color:#a94442;background-color:#f2dede;border-color:#ebccd1}.panel-danger>.panel-heading+.panel-collapse>.panel-body{border-top-color:#ebccd1}.panel-danger>.panel-heading .badge{color:#f2dede;background-color:#a94442}.panel-danger>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#ebccd1}.embed-responsive{position:relative;display:block;height:0;padding:0;overflow:hidden}.embed-responsive .embed-responsive-item,.embed-responsive embed,.embed-responsive iframe,.embed-responsive object,.embed-responsive video{position:absolute;top:0;bottom:0;left:0;width:100%;height:100%;border:0}.embed-responsive-16by9{padding-bottom:56.25%}.embed-responsive-4by3{padding-bottom:75%}.well{min-height:20px;padding:19px;margin-bottom:20px;background-color:#f5f5f5;border:1px solid #e3e3e3;border-radius:4px;box-shadow:inset 0 1px 1px rgba(0,0,0,.05)}.well blockquote{border-color:#ddd;border-color:rgba(0,0,0,.15)}.well-lg{padding:24px;border-radius:6px}.well-sm{padding:9px;border-radius:3px}.close{float:right;font-size:21px;font-weight:700;line-height:1;color:#000;text-shadow:0 1px 0 #fff;filter:alpha(opacity=20);opacity:.2}.close:focus,.close:hover{color:#000;text-decoration:none;cursor:pointer;filter:alpha(opacity=50);opacity:.5}button.close{-webkit-appearance:none;padding:0;cursor:pointer;background:transparent;border:0}.modal,.modal-open{overflow:hidden}.modal{position:fixed;top:0;right:0;bottom:0;left:0;z-index:1050;display:none;-webkit-overflow-scrolling:touch;outline:0}.modal.fade .modal-dialog{transition:transform .3s ease-out;transform:translateY(-25%)}.modal.in .modal-dialog{transform:translate(0)}.modal-open .modal{overflow-x:hidden;overflow-y:auto}.modal-dialog{position:relative;width:auto;margin:10px}.modal-content{position:relative;background-color:#fff;background-clip:padding-box;border:1px solid #999;border:1px solid rgba(0,0,0,.2);border-radius:6px;outline:0;box-shadow:0 3px 9px rgba(0,0,0,.5)}.modal-backdrop{position:fixed;top:0;right:0;bottom:0;left:0;z-index:1040;background-color:#000}.modal-backdrop.fade{filter:alpha(opacity=0);opacity:0}.modal-backdrop.in{filter:alpha(opacity=50);opacity:.5}.modal-header{padding:15px;border-bottom:1px solid #e5e5e5}.modal-header .close{margin-top:-2px}.modal-title{margin:0;line-height:1.42857143}.modal-body{position:relative;padding:15px}.modal-footer{padding:15px;text-align:right;border-top:1px solid #e5e5e5}.modal-footer .btn+.btn{margin-bottom:0;margin-left:5px}.modal-footer .btn-group .btn+.btn{margin-left:-1px}.modal-footer .btn-block+.btn-block{margin-left:0}.modal-scrollbar-measure{position:absolute;top:-9999px;width:50px;height:50px;overflow:scroll}@media (min-width:768px){.modal-dialog{width:600px;margin:30px auto}.modal-content{box-shadow:0 5px 15px rgba(0,0,0,.5)}.modal-sm{width:300px}}@media (min-width:992px){.modal-lg{width:900px}}.tooltip{position:absolute;z-index:1070;display:block;font-family:Helvetica Neue,Helvetica,Arial,sans-serif;font-size:12px;font-style:normal;font-weight:400;line-height:1.42857143;text-align:left;text-align:start;text-decoration:none;text-shadow:none;text-transform:none;letter-spacing:normal;word-break:normal;word-spacing:normal;word-wrap:normal;white-space:normal;filter:alpha(opacity=0);opacity:0;line-break:auto}.tooltip.in{filter:alpha(opacity=90);opacity:.9}.tooltip.top{padding:5px 0;margin-top:-3px}.tooltip.right{padding:0 5px;margin-left:3px}.tooltip.bottom{padding:5px 0;margin-top:3px}.tooltip.left{padding:0 5px;margin-left:-3px}.tooltip-inner{max-width:200px;padding:3px 8px;color:#fff;text-align:center;background-color:#000;border-radius:4px}.tooltip-arrow{position:absolute;width:0;height:0;border-color:transparent;border-style:solid}.tooltip.top .tooltip-arrow{bottom:0;left:50%;margin-left:-5px;border-width:5px 5px 0;border-top-color:#000}.tooltip.top-left .tooltip-arrow{right:5px}.tooltip.top-left .tooltip-arrow,.tooltip.top-right .tooltip-arrow{bottom:0;margin-bottom:-5px;border-width:5px 5px 0;border-top-color:#000}.tooltip.top-right .tooltip-arrow{left:5px}.tooltip.right .tooltip-arrow{top:50%;left:0;margin-top:-5px;border-width:5px 5px 5px 0;border-right-color:#000}.tooltip.left .tooltip-arrow{top:50%;right:0;margin-top:-5px;border-width:5px 0 5px 5px;border-left-color:#000}.tooltip.bottom .tooltip-arrow{top:0;left:50%;margin-left:-5px;border-width:0 5px 5px;border-bottom-color:#000}.tooltip.bottom-left .tooltip-arrow{top:0;right:5px;margin-top:-5px;border-width:0 5px 5px;border-bottom-color:#000}.tooltip.bottom-right .tooltip-arrow{top:0;left:5px;margin-top:-5px;border-width:0 5px 5px;border-bottom-color:#000}.popover{position:absolute;top:0;left:0;z-index:1060;display:none;max-width:276px;padding:1px;font-family:Helvetica Neue,Helvetica,Arial,sans-serif;font-size:14px;font-style:normal;font-weight:400;line-height:1.42857143;text-align:left;text-align:start;text-decoration:none;text-shadow:none;text-transform:none;letter-spacing:normal;word-break:normal;word-spacing:normal;word-wrap:normal;white-space:normal;background-color:#fff;background-clip:padding-box;border:1px solid #ccc;border:1px solid rgba(0,0,0,.2);border-radius:6px;box-shadow:0 5px 10px rgba(0,0,0,.2);line-break:auto}.popover.top{margin-top:-10px}.popover.right{margin-left:10px}.popover.bottom{margin-top:10px}.popover.left{margin-left:-10px}.popover-title{padding:8px 14px;margin:0;font-size:14px;background-color:#f7f7f7;border-bottom:1px solid #ebebeb;border-radius:5px 5px 0 0}.popover-content{padding:9px 14px}.popover>.arrow,.popover>.arrow:after{position:absolute;display:block;width:0;height:0;border-color:transparent;border-style:solid}.popover>.arrow{border-width:11px}.popover>.arrow:after{content:\"\";border-width:10px}.popover.top>.arrow{bottom:-11px;left:50%;margin-left:-11px;border-top-color:#999;border-top-color:rgba(0,0,0,.25);border-bottom-width:0}.popover.top>.arrow:after{bottom:1px;margin-left:-10px;content:\" \";border-top-color:#fff;border-bottom-width:0}.popover.right>.arrow{top:50%;left:-11px;margin-top:-11px;border-right-color:#999;border-right-color:rgba(0,0,0,.25);border-left-width:0}.popover.right>.arrow:after{bottom:-10px;left:1px;content:\" \";border-right-color:#fff;border-left-width:0}.popover.bottom>.arrow{top:-11px;left:50%;margin-left:-11px;border-top-width:0;border-bottom-color:#999;border-bottom-color:rgba(0,0,0,.25)}.popover.bottom>.arrow:after{top:1px;margin-left:-10px;content:\" \";border-top-width:0;border-bottom-color:#fff}.popover.left>.arrow{top:50%;right:-11px;margin-top:-11px;border-right-width:0;border-left-color:#999;border-left-color:rgba(0,0,0,.25)}.popover.left>.arrow:after{right:1px;bottom:-10px;content:\" \";border-right-width:0;border-left-color:#fff}.carousel,.carousel-inner{position:relative}.carousel-inner{width:100%;overflow:hidden}.carousel-inner>.item{position:relative;display:none;transition:left .6s ease-in-out}.carousel-inner>.item>a>img,.carousel-inner>.item>img{line-height:1}@media (-webkit-transform-3d),(transform-3d){.carousel-inner>.item{transition:transform .6s ease-in-out;backface-visibility:hidden;perspective:1000px}.carousel-inner>.item.active.right,.carousel-inner>.item.next{left:0;transform:translate3d(100%,0,0)}.carousel-inner>.item.active.left,.carousel-inner>.item.prev{left:0;transform:translate3d(-100%,0,0)}.carousel-inner>.item.active,.carousel-inner>.item.next.left,.carousel-inner>.item.prev.right{left:0;transform:translateZ(0)}}.carousel-inner>.active,.carousel-inner>.next,.carousel-inner>.prev{display:block}.carousel-inner>.active{left:0}.carousel-inner>.next,.carousel-inner>.prev{position:absolute;top:0;width:100%}.carousel-inner>.next{left:100%}.carousel-inner>.prev{left:-100%}.carousel-inner>.next.left,.carousel-inner>.prev.right{left:0}.carousel-inner>.active.left{left:-100%}.carousel-inner>.active.right{left:100%}.carousel-control{position:absolute;top:0;bottom:0;left:0;width:15%;font-size:20px;color:#fff;text-align:center;text-shadow:0 1px 2px rgba(0,0,0,.6);background-color:transparent;filter:alpha(opacity=50);opacity:.5}.carousel-control.left{background-image:linear-gradient(90deg,rgba(0,0,0,.5) 0,rgba(0,0,0,.0001));filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\"#80000000\",endColorstr=\"#00000000\",GradientType=1);background-repeat:repeat-x}.carousel-control.right{right:0;left:auto;background-image:linear-gradient(90deg,rgba(0,0,0,.0001) 0,rgba(0,0,0,.5));filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\"#00000000\",endColorstr=\"#80000000\",GradientType=1);background-repeat:repeat-x}.carousel-control:focus,.carousel-control:hover{color:#fff;text-decoration:none;filter:alpha(opacity=90);outline:0;opacity:.9}.carousel-control .glyphicon-chevron-left,.carousel-control .glyphicon-chevron-right,.carousel-control .icon-next,.carousel-control .icon-prev{position:absolute;top:50%;z-index:5;display:inline-block;margin-top:-10px}.carousel-control .glyphicon-chevron-left,.carousel-control .icon-prev{left:50%;margin-left:-10px}.carousel-control .glyphicon-chevron-right,.carousel-control .icon-next{right:50%;margin-right:-10px}.carousel-control .icon-next,.carousel-control .icon-prev{width:20px;height:20px;font-family:serif;line-height:1}.carousel-control .icon-prev:before{content:\"\\2039\"}.carousel-control .icon-next:before{content:\"\\203A\"}.carousel-indicators{position:absolute;bottom:10px;left:50%;z-index:15;width:60%;padding-left:0;margin-left:-30%;text-align:center;list-style:none}.carousel-indicators li{display:inline-block;width:10px;height:10px;margin:1px;text-indent:-999px;cursor:pointer;background-color:#000\\9;background-color:transparent;border:1px solid #fff;border-radius:10px}.carousel-indicators .active{width:12px;height:12px;margin:0;background-color:#fff}.carousel-caption{position:absolute;right:15%;bottom:20px;left:15%;z-index:10;padding-top:20px;padding-bottom:20px;color:#fff;text-align:center;text-shadow:0 1px 2px rgba(0,0,0,.6)}.carousel-caption .btn{text-shadow:none}@media screen and (min-width:768px){.carousel-control .glyphicon-chevron-left,.carousel-control .glyphicon-chevron-right,.carousel-control .icon-next,.carousel-control .icon-prev{width:30px;height:30px;margin-top:-10px;font-size:30px}.carousel-control .glyphicon-chevron-left,.carousel-control .icon-prev{margin-left:-10px}.carousel-control .glyphicon-chevron-right,.carousel-control .icon-next{margin-right:-10px}.carousel-caption{right:20%;left:20%;padding-bottom:30px}.carousel-indicators{bottom:20px}}.btn-group-vertical>.btn-group:after,.btn-group-vertical>.btn-group:before,.btn-toolbar:after,.btn-toolbar:before,.clearfix:after,.clearfix:before,.container-fluid:after,.container-fluid:before,.container:after,.container:before,.dl-horizontal dd:after,.dl-horizontal dd:before,.form-horizontal .form-group:after,.form-horizontal .form-group:before,.modal-footer:after,.modal-footer:before,.modal-header:after,.modal-header:before,.nav:after,.nav:before,.navbar-collapse:after,.navbar-collapse:before,.navbar-header:after,.navbar-header:before,.navbar:after,.navbar:before,.pager:after,.pager:before,.panel-body:after,.panel-body:before,.row:after,.row:before{display:table;content:\" \"}.btn-group-vertical>.btn-group:after,.btn-toolbar:after,.clearfix:after,.container-fluid:after,.container:after,.dl-horizontal dd:after,.form-horizontal .form-group:after,.modal-footer:after,.modal-header:after,.nav:after,.navbar-collapse:after,.navbar-header:after,.navbar:after,.pager:after,.panel-body:after,.row:after{clear:both}.center-block{display:block;margin-right:auto;margin-left:auto}.pull-right{float:right!important}.pull-left{float:left!important}.hide{display:none!important}.show{display:block!important}.invisible{visibility:hidden}.text-hide{font:0/0 a;color:transparent;text-shadow:none;background-color:transparent;border:0}.hidden{display:none!important}.affix{position:fixed}@-ms-viewport{width:device-width}.visible-lg,.visible-lg-block,.visible-lg-inline,.visible-lg-inline-block,.visible-md,.visible-md-block,.visible-md-inline,.visible-md-inline-block,.visible-sm,.visible-sm-block,.visible-sm-inline,.visible-sm-inline-block,.visible-xs,.visible-xs-block,.visible-xs-inline,.visible-xs-inline-block{display:none!important}@media (max-width:767px){.visible-xs{display:block!important}table.visible-xs{display:table!important}tr.visible-xs{display:table-row!important}td.visible-xs,th.visible-xs{display:table-cell!important}}@media (max-width:767px){.visible-xs-block{display:block!important}}@media (max-width:767px){.visible-xs-inline{display:inline!important}}@media (max-width:767px){.visible-xs-inline-block{display:inline-block!important}}@media (min-width:768px) and (max-width:991px){.visible-sm{display:block!important}table.visible-sm{display:table!important}tr.visible-sm{display:table-row!important}td.visible-sm,th.visible-sm{display:table-cell!important}}@media (min-width:768px) and (max-width:991px){.visible-sm-block{display:block!important}}@media (min-width:768px) and (max-width:991px){.visible-sm-inline{display:inline!important}}@media (min-width:768px) and (max-width:991px){.visible-sm-inline-block{display:inline-block!important}}@media (min-width:992px) and (max-width:1199px){.visible-md{display:block!important}table.visible-md{display:table!important}tr.visible-md{display:table-row!important}td.visible-md,th.visible-md{display:table-cell!important}}@media (min-width:992px) and (max-width:1199px){.visible-md-block{display:block!important}}@media (min-width:992px) and (max-width:1199px){.visible-md-inline{display:inline!important}}@media (min-width:992px) and (max-width:1199px){.visible-md-inline-block{display:inline-block!important}}@media (min-width:1200px){.visible-lg{display:block!important}table.visible-lg{display:table!important}tr.visible-lg{display:table-row!important}td.visible-lg,th.visible-lg{display:table-cell!important}}@media (min-width:1200px){.visible-lg-block{display:block!important}}@media (min-width:1200px){.visible-lg-inline{display:inline!important}}@media (min-width:1200px){.visible-lg-inline-block{display:inline-block!important}}@media (max-width:767px){.hidden-xs{display:none!important}}@media (min-width:768px) and (max-width:991px){.hidden-sm{display:none!important}}@media (min-width:992px) and (max-width:1199px){.hidden-md{display:none!important}}@media (min-width:1200px){.hidden-lg{display:none!important}}.visible-print{display:none!important}@media print{.visible-print{display:block!important}table.visible-print{display:table!important}tr.visible-print{display:table-row!important}td.visible-print,th.visible-print{display:table-cell!important}}.visible-print-block{display:none!important}@media print{.visible-print-block{display:block!important}}.visible-print-inline{display:none!important}@media print{.visible-print-inline{display:inline!important}}.visible-print-inline-block{display:none!important}@media print{.visible-print-inline-block{display:inline-block!important}}@media print{.hidden-print{display:none!important}}", ""]);
	
	// exports


/***/ },
/* 887 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(24)();
	// imports
	
	
	// module
	exports.push([module.id, ".src-components-age-valid-wrapper-styles-___age-valid-modal__modalBody___3Nk08{background-color:#2b2b2b;padding:30px}.src-components-age-valid-wrapper-styles-___age-valid-modal__logo___1chg0{width:200px;margin-top:30px;margin-bottom:40px}.src-components-age-valid-wrapper-styles-___age-valid-modal__title___1lJsp{font-size:2.5em;font-weight:700;color:#fff}@media (max-width:600px){.src-components-age-valid-wrapper-styles-___age-valid-modal__title___1lJsp{font-size:2em}}.src-components-age-valid-wrapper-styles-___age-valid-modal__textInfo___KYXuw{color:#fff;margin-top:20px;font-size:16px}.src-components-age-valid-wrapper-styles-___age-valid-modal__textInfoSmall___1KG7_{font-size:14px!important}.src-components-age-valid-wrapper-styles-___age-valid-modal__formInput___2v9rC{height:60px;font-size:16px;padding:10px;width:100%;background-color:transparent;border:none}.src-components-age-valid-wrapper-styles-___age-valid-modal__inputBox___1Hymc{border:1px solid #fff;padding-left:10px;padding-right:10px}.src-components-age-valid-wrapper-styles-___age-valid-modal__fieldsContainer___2785L{margin-top:40px}.src-components-age-valid-wrapper-styles-___age-valid-modal__button___kjIU_{background-color:#d3af71;color:#fff;height:50px;border:none;font-size:large;font-weight:700}.src-components-age-valid-wrapper-styles-___age-valid-modal__button___kjIU_:hover{background-color:#fe9f03!important;color:#fff!important}.src-components-age-valid-wrapper-styles-___age-valid-modal__padding10___2Ew6q{padding:10px}.src-components-age-valid-wrapper-styles-___age-valid-modal__errorMsg___MHgm3{color:#fff;margin-top:10px}", ""]);
	
	// exports
	exports.locals = {
		"modalBody": "src-components-age-valid-wrapper-styles-___age-valid-modal__modalBody___3Nk08",
		"logo": "src-components-age-valid-wrapper-styles-___age-valid-modal__logo___1chg0",
		"title": "src-components-age-valid-wrapper-styles-___age-valid-modal__title___1lJsp",
		"textInfo": "src-components-age-valid-wrapper-styles-___age-valid-modal__textInfo___KYXuw",
		"textInfoSmall": "src-components-age-valid-wrapper-styles-___age-valid-modal__textInfoSmall___1KG7_",
		"formInput": "src-components-age-valid-wrapper-styles-___age-valid-modal__formInput___2v9rC",
		"inputBox": "src-components-age-valid-wrapper-styles-___age-valid-modal__inputBox___1Hymc",
		"fieldsContainer": "src-components-age-valid-wrapper-styles-___age-valid-modal__fieldsContainer___2785L",
		"button": "src-components-age-valid-wrapper-styles-___age-valid-modal__button___kjIU_",
		"padding10": "src-components-age-valid-wrapper-styles-___age-valid-modal__padding10___2Ew6q",
		"errorMsg": "src-components-age-valid-wrapper-styles-___age-valid-modal__errorMsg___MHgm3"
	};

/***/ },
/* 888 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(24)();
	// imports
	
	
	// module
	exports.push([module.id, ".src-components-cart-styles-___line-item__unavailableCont___3D4xf{padding-bottom:10px}.src-components-cart-styles-___line-item__phoneRow___1FhkD{display:flex;flex-direction:row;margin-top:10px}.src-components-cart-styles-___line-item__phoneRow___1FhkD i{color:#68583c;cursor:pointer;font-size:16px;margin-left:8px;margin-right:12px}.src-components-cart-styles-___line-item__phones___1Zlui{display:flex;flex-direction:column;flex-wrap:wrap}", ""]);
	
	// exports
	exports.locals = {
		"unavailableCont": "src-components-cart-styles-___line-item__unavailableCont___3D4xf",
		"phoneRow": "src-components-cart-styles-___line-item__phoneRow___1FhkD",
		"phones": "src-components-cart-styles-___line-item__phones___1Zlui"
	};

/***/ },
/* 889 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(24)();
	// imports
	
	
	// module
	exports.push([module.id, ".src-components-checkout-steps-modals-styles-___fraudulent-order-modal__modalBody___3ExNg{display:flex;flex-direction:column}.src-components-checkout-steps-modals-styles-___fraudulent-order-modal__headerInfo___1pZpb{margin-top:20px;flex-direction:row}.src-components-checkout-steps-modals-styles-___fraudulent-order-modal__headerInfo___1pZpb a{color:#1f73b7}.src-components-checkout-steps-modals-styles-___fraudulent-order-modal__bodyInfo___3TUhM{margin-top:10px}.src-components-checkout-steps-modals-styles-___fraudulent-order-modal__caseNumber___13pIh{color:#000;margin-left:5px}", ""]);
	
	// exports
	exports.locals = {
		"modalBody": "src-components-checkout-steps-modals-styles-___fraudulent-order-modal__modalBody___3ExNg",
		"headerInfo": "src-components-checkout-steps-modals-styles-___fraudulent-order-modal__headerInfo___1pZpb",
		"bodyInfo": "src-components-checkout-steps-modals-styles-___fraudulent-order-modal__bodyInfo___3TUhM",
		"caseNumber": "src-components-checkout-steps-modals-styles-___fraudulent-order-modal__caseNumber___13pIh"
	};

/***/ },
/* 890 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(24)();
	// imports
	
	
	// module
	exports.push([module.id, ".src-components-checkout-steps-styles-___payment-form__paymentFormAction___1qX-k{display:flex;justify-content:end;width:100%}.src-components-checkout-steps-styles-___payment-form__cardData___3LaX-{display:flex;flex-direction:column;margin:20px 0}", ""]);
	
	// exports
	exports.locals = {
		"paymentFormAction": "src-components-checkout-steps-styles-___payment-form__paymentFormAction___1qX-k",
		"cardData": "src-components-checkout-steps-styles-___payment-form__cardData___3LaX-"
	};

/***/ },
/* 891 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(24)();
	// imports
	
	
	// module
	exports.push([module.id, "@media (max-width:480px){.src-components-order-styles-___line-item__lineItemName___24zyj{margin-bottom:15px}}.src-components-order-styles-___line-item__lineItemNameDetailContainer___mCYMP{display:flex;flex-direction:row}@media (max-width:480px){.src-components-order-styles-___line-item__lineItemNameDetailContainer___mCYMP{flex-direction:column}}.src-components-order-styles-___line-item__lineItemPhones___32oIZ{text-align:center;width:100%}@media (max-width:480px){.src-components-order-styles-___line-item__lineItemPhones___32oIZ{text-align:left}}", ""]);
	
	// exports
	exports.locals = {
		"lineItemName": "src-components-order-styles-___line-item__lineItemName___24zyj",
		"lineItemNameDetailContainer": "src-components-order-styles-___line-item__lineItemNameDetailContainer___mCYMP",
		"lineItemPhones": "src-components-order-styles-___line-item__lineItemPhones___32oIZ"
	};

/***/ },
/* 892 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(24)();
	// imports
	
	
	// module
	exports.push([module.id, "@media (max-width:600px){.src-components-order-styles-___list-item__mt10sm___1I5I2{margin-top:10px}}@media (min-width:600px){.src-components-order-styles-___list-item__lgNoPadding___BRLJg{padding-left:0;padding-right:0}}.src-components-order-styles-___list-item__total___1Zo2s{color:#b18433}", ""]);
	
	// exports
	exports.locals = {
		"mt10sm": "src-components-order-styles-___list-item__mt10sm___1I5I2",
		"lgNoPadding": "src-components-order-styles-___list-item__lgNoPadding___BRLJg",
		"total": "src-components-order-styles-___list-item__total___1Zo2s"
	};

/***/ },
/* 893 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(24)();
	// imports
	
	
	// module
	exports.push([module.id, ".src-components-order-styles-___list__header___lNdFB{margin-bottom:0;color:#b18433;font-weight:\"bold\";border:\"none\"}@media (max-width:600px){.src-components-order-styles-___list__header___lNdFB{margin-top:0}}.src-components-order-styles-___list__listItem___2jyXV{padding-top:20px;border-top:1px solid #ccc;padding-bottom:20px}.src-components-order-styles-___list__listItem___2jyXV:first-of-type{border-top:none}.src-components-order-styles-___list__tableHeader___3dgHK{margin:10px 0;font-weight:700}", ""]);
	
	// exports
	exports.locals = {
		"header": "src-components-order-styles-___list__header___lNdFB",
		"listItem": "src-components-order-styles-___list__listItem___2jyXV",
		"tableHeader": "src-components-order-styles-___list__tableHeader___3dgHK"
	};

/***/ },
/* 894 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(24)();
	// imports
	
	
	// module
	exports.push([module.id, ".src-components-product-styles-___category-badge__categoryBadge___3EmO5{position:absolute;width:100%;z-index:9;top:-1px;left:-1px}.src-components-product-styles-___category-badge__categoryBadge___3EmO5.src-components-product-styles-___category-badge__isShowProduct___2qvfH{top:auto;left:auto}@media (max-width:768px){.src-components-product-styles-___category-badge__categoryBadge___3EmO5.src-components-product-styles-___category-badge__isShowProduct___2qvfH{position:relative;top:0;right:0;width:100%}}@media (max-width:768px){.src-components-product-styles-___category-badge__categoryBadge___3EmO5{position:absolute;top:-1px;right:0;width:100%}}.src-components-product-styles-___category-badge__categoryBadge__title___Ui8Eh{color:#fff;padding:2px 0 2px 5px;font-weight:600;display:inline-block;height:21px;background-color:#b18433;min-width:45%;max-width:80%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.src-components-product-styles-___category-badge__categoryBadge__title__expand___3CeSa{min-width:25%;width:auto}@media (max-width:768px){.src-components-product-styles-___category-badge__categoryBadge__title___Ui8Eh{min-width:25%;width:auto;padding:2px 5px}}.src-components-product-styles-___category-badge__categoryBadge__tail___295l7{border-right:6px solid transparent;border-bottom:21px solid;display:inline-block;position:absolute;border-bottom-color:#b18433}", ""]);
	
	// exports
	exports.locals = {
		"categoryBadge": "src-components-product-styles-___category-badge__categoryBadge___3EmO5",
		"isShowProduct": "src-components-product-styles-___category-badge__isShowProduct___2qvfH",
		"categoryBadge__title": "src-components-product-styles-___category-badge__categoryBadge__title___Ui8Eh",
		"categoryBadge__title__expand": "src-components-product-styles-___category-badge__categoryBadge__title__expand___3CeSa",
		"categoryBadge__tail": "src-components-product-styles-___category-badge__categoryBadge__tail___295l7"
	};

/***/ },
/* 895 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(24)();
	// imports
	
	
	// module
	exports.push([module.id, ".src-components-product-styles-___image-comingsoon__nonSearchResult___1vTcb{display:flex;justify-content:center;align-items:center;flex-direction:column;margin-top:8px}.src-components-product-styles-___image-comingsoon__nonSearchResult___1vTcb .src-components-product-styles-___image-comingsoon__nonSearchResultImage___3AnYm{width:400px;background-color:transparent}@media only screen and (max-width:768px){.src-components-product-styles-___image-comingsoon__nonSearchResult___1vTcb .src-components-product-styles-___image-comingsoon__nonSearchResultImage___3AnYm{width:300px}}.src-components-product-styles-___image-comingsoon__nonSearchResult___1vTcb .src-components-product-styles-___image-comingsoon__nonSearchResultMessage___1Q5EU{font-size:20px;text-align:center;color:#fff}", ""]);
	
	// exports
	exports.locals = {
		"nonSearchResult": "src-components-product-styles-___image-comingsoon__nonSearchResult___1vTcb",
		"nonSearchResultImage": "src-components-product-styles-___image-comingsoon__nonSearchResultImage___3AnYm",
		"nonSearchResultMessage": "src-components-product-styles-___image-comingsoon__nonSearchResultMessage___1Q5EU"
	};

/***/ },
/* 896 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(24)();
	// imports
	
	
	// module
	exports.push([module.id, ".src-components-product-styles-___product-details-quantity-selector__buyPanel___3DuuJ{padding-right:15px!important}.src-components-product-styles-___product-details-quantity-selector__buyPanelOptions___2Jif2{background-color:#edf0f7;padding:15px}.src-components-product-styles-___product-details-quantity-selector__inlineBlock___1-NYs{display:inline-block!important}.src-components-product-styles-___product-details-quantity-selector__wishCart___16-sH{min-height:28px}.src-components-product-styles-___product-details-quantity-selector__innerAddWish___1x6er{display:-ms-flexbox;display:flex;-ms-flex-pack:end;justify-content:flex-end;position:relative}.src-components-product-styles-___product-details-quantity-selector__addWishList___3Smse{display:none;height:28px;width:28px;min-width:28px;position:relative;border-radius:16px!important;background-color:#ffa100!important;overflow:hidden;color:#fff;transform-style:preserve-3d;transition:width .3s ease!important}.src-components-product-styles-___product-details-quantity-selector__addWishList___3Smse:hover{width:155px}.src-components-product-styles-___product-details-quantity-selector__addWishList___3Smse:hover span{left:-3px}.src-components-product-styles-___product-details-quantity-selector__addWishList___3Smse i{background-color:#ffa100;padding:8px 8px 0 0;position:relative;z-index:1;height:28px;width:28px;border-radius:50%!important}.src-components-product-styles-___product-details-quantity-selector__addWishListButton___2mB7H{width:100%;position:absolute;left:100%;font-size:14px;line-height:2;text-align:right;padding-top:0;padding-right:27px!important;transition:left .4s ease!important}.src-components-product-styles-___product-details-quantity-selector__addToCart___3QyEF{height:28px;width:28px;min-width:28px;position:relative;border-radius:16px!important;overflow:hidden;color:#fff;transform-style:preserve-3d;display:none;background-color:#000!important;margin-left:3px;transition:width .3s ease!important}.src-components-product-styles-___product-details-quantity-selector__addToCart___3QyEF i{padding:7px 7px 0 0;font-size:15px;background-color:#000;position:relative;z-index:1;height:28px;width:28px;border-radius:50%!important}.src-components-product-styles-___product-details-quantity-selector__addToCart___3QyEF:hover{width:172px!important}.src-components-product-styles-___product-details-quantity-selector__addToCart___3QyEF:hover span{left:18px;text-align:left}.src-components-product-styles-___product-details-quantity-selector__addToCartButton___11Ti7{width:100%;position:absolute;left:100%;font-size:14px;line-height:2;text-align:right;padding-top:0;padding-right:25px;transition:left .15s ease}.src-components-product-styles-___product-details-quantity-selector__quantityProd___1wImW{display:-ms-flexbox;display:flex;margin-bottom:10px}.src-components-product-styles-___product-details-quantity-selector__quantityProdOptions___10NhG{vertical-align:top;padding-top:3px;display:inline-block;min-width:80px;text-align:right;font-family:Lato Bold;font-size:12px;text-transform:uppercase;line-height:2;letter-spacing:.6px}.src-components-product-styles-___product-details-quantity-selector__selectorQuantity___26t3v{display:-ms-flexbox;display:flex;margin-left:20px!important}.src-components-product-styles-___product-details-quantity-selector__minus___UL5Ux,.src-components-product-styles-___product-details-quantity-selector__plus___3mIiC{display:inline-block!important;cursor:pointer;line-height:0;border-right:0!important;height:28px;width:28px;font-size:30px;padding:0;border-color:#dfe1e1;background-color:#cccfce!important;border:none!important;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.src-components-product-styles-___product-details-quantity-selector__minus___UL5Ux[disabled],.src-components-product-styles-___product-details-quantity-selector__minus___UL5Ux[disabled]:hover,.src-components-product-styles-___product-details-quantity-selector__plus___3mIiC[disabled],.src-components-product-styles-___product-details-quantity-selector__plus___3mIiC[disabled]:hover{color:#fff;cursor:not-allowed}.src-components-product-styles-___product-details-quantity-selector__plus___3mIiC{line-height:28px;background-color:transparent;border-left:0!important;transition:color .15s ease-out,background-color .15s ease-out,border-color .15s ease-out}.src-components-product-styles-___product-details-quantity-selector__quantityContainer___1tVHK{display:inline-block!important}.src-components-product-styles-___product-details-quantity-selector__quantityContainer___1tVHK input{font-family:Arial;color:#5d5d5d;background-color:#fff;border:1px solid #dfe1e1;padding:5px 20px;margin:0;border-radius:0!important;text-align:center;max-width:100px;height:28px;font-size:14px;font-weight:700}.src-components-product-styles-___product-details-quantity-selector__totalPrice___3EDmy{margin-bottom:10px}.src-components-product-styles-___product-details-quantity-selector__totalPriceTitle___1_HDl{display:inline-block;min-width:80px;text-align:right;font-family:Lato Bold;font-size:12px;text-transform:uppercase;line-height:2;letter-spacing:.6px}.src-components-product-styles-___product-details-quantity-selector__totalPriceTitleValue___3bi_C{font-size:18px;line-height:26px;max-width:156px;display:inline-block;text-align:center;font-family:Lato Bold;font-weight:700;color:#000;margin-left:15px!important}.src-components-product-styles-___product-details-quantity-selector__actions___3xjm3{margin-left:100px}.src-components-product-styles-___product-details-quantity-selector__addCartAction___1zzZ6{min-height:28px}.src-components-product-styles-___product-details-quantity-selector__addCartActionInner___1TzfX{-ms-flex-pack:start;justify-content:flex-start;display:-ms-flexbox;display:flex;position:relative}.src-components-product-styles-___product-details-quantity-selector__addCartExpandedButton___dYgsV{min-height:28px;position:relative;overflow:hidden;color:#fff;transform-style:preserve-3d;border-radius:0!important;margin:0;width:158px;padding:7px 10px;background-color:#000!important;transition:width .3s ease!important;display:flex;justify-content:center;border:0}.src-components-product-styles-___product-details-quantity-selector__addCartExpandedButton___dYgsV i{font-size:15px;z-index:1}.src-components-product-styles-___product-details-quantity-selector__addCartExpandedButton___dYgsV span{font-size:14px;transition:left .15s ease;display:inline-block;padding-left:5px}.src-components-product-styles-___product-details-quantity-selector__addCartExpandedButton___dYgsV:hover{background-color:#4e4e4e!important}.src-components-product-styles-___product-details-quantity-selector__disableAddCartExpandedButton___3Z82q{min-height:28px;position:relative;overflow:hidden;color:#fff;transform-style:preserve-3d;border-radius:0!important;margin:0;width:158px;padding:7px 10px;background-color:#706f6d;transition:width .3s ease!important;display:flex;justify-content:center;border:0}.src-components-product-styles-___product-details-quantity-selector__disableAddCartExpandedButton___3Z82q i{font-size:15px;z-index:1}.src-components-product-styles-___product-details-quantity-selector__disableAddCartExpandedButton___3Z82q span{font-size:14px;transition:left .15s ease;display:inline-block;padding-left:5px}", ""]);
	
	// exports
	exports.locals = {
		"buyPanel": "src-components-product-styles-___product-details-quantity-selector__buyPanel___3DuuJ",
		"buyPanelOptions": "src-components-product-styles-___product-details-quantity-selector__buyPanelOptions___2Jif2",
		"inlineBlock": "src-components-product-styles-___product-details-quantity-selector__inlineBlock___1-NYs",
		"wishCart": "src-components-product-styles-___product-details-quantity-selector__wishCart___16-sH",
		"innerAddWish": "src-components-product-styles-___product-details-quantity-selector__innerAddWish___1x6er",
		"addWishList": "src-components-product-styles-___product-details-quantity-selector__addWishList___3Smse",
		"addWishListButton": "src-components-product-styles-___product-details-quantity-selector__addWishListButton___2mB7H",
		"addToCart": "src-components-product-styles-___product-details-quantity-selector__addToCart___3QyEF",
		"addToCartButton": "src-components-product-styles-___product-details-quantity-selector__addToCartButton___11Ti7",
		"quantityProd": "src-components-product-styles-___product-details-quantity-selector__quantityProd___1wImW",
		"quantityProdOptions": "src-components-product-styles-___product-details-quantity-selector__quantityProdOptions___10NhG",
		"selectorQuantity": "src-components-product-styles-___product-details-quantity-selector__selectorQuantity___26t3v",
		"minus": "src-components-product-styles-___product-details-quantity-selector__minus___UL5Ux",
		"plus": "src-components-product-styles-___product-details-quantity-selector__plus___3mIiC",
		"quantityContainer": "src-components-product-styles-___product-details-quantity-selector__quantityContainer___1tVHK",
		"totalPrice": "src-components-product-styles-___product-details-quantity-selector__totalPrice___3EDmy",
		"totalPriceTitle": "src-components-product-styles-___product-details-quantity-selector__totalPriceTitle___1_HDl",
		"totalPriceTitleValue": "src-components-product-styles-___product-details-quantity-selector__totalPriceTitleValue___3bi_C",
		"actions": "src-components-product-styles-___product-details-quantity-selector__actions___3xjm3",
		"addCartAction": "src-components-product-styles-___product-details-quantity-selector__addCartAction___1zzZ6",
		"addCartActionInner": "src-components-product-styles-___product-details-quantity-selector__addCartActionInner___1TzfX",
		"addCartExpandedButton": "src-components-product-styles-___product-details-quantity-selector__addCartExpandedButton___dYgsV",
		"disableAddCartExpandedButton": "src-components-product-styles-___product-details-quantity-selector__disableAddCartExpandedButton___3Z82q"
	};

/***/ },
/* 897 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(24)();
	// imports
	
	
	// module
	exports.push([module.id, ".src-components-product-styles-___variant-selector__variantItem___2RLoy{display:flex;align-items:center;transition:none!important}.src-components-product-styles-___variant-selector__variantItem___2RLoy:hover{background-color:#b18433;color:#fff}.src-components-product-styles-___variant-selector__variantItem___2RLoy a{width:100%;text-align:left;transition:none!important}.src-components-product-styles-___variant-selector__variantItem___2RLoy a:hover{color:#fff!important}", ""]);
	
	// exports
	exports.locals = {
		"variantItem": "src-components-product-styles-___variant-selector__variantItem___2RLoy"
	};

/***/ },
/* 898 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(24)();
	// imports
	
	
	// module
	exports.push([module.id, ".src-components-shared-header-styles-___header-menu__navBar___3FqJM{margin-left:-5px;padding-left:0}.src-components-shared-header-styles-___header-menu__navBar___3FqJM .src-components-shared-header-styles-___header-menu__navBarNav___2IAyX{height:0}.src-components-shared-header-styles-___header-menu__navBar___3FqJM .src-components-shared-header-styles-___header-menu__menuDropdownLevel0___3ym_e a{margin-bottom:1px;display:block;line-height:30px;padding:5px 10px 0;position:relative}.src-components-shared-header-styles-___header-menu__navBar___3FqJM .src-components-shared-header-styles-___header-menu__menuDropdownLevel0___3ym_e a:hover{color:#d3af71}.src-components-shared-header-styles-___header-menu__navBar___3FqJM .src-components-shared-header-styles-___header-menu__menuDropdownLevel1___vZ19b{border-top:2px solid #fff;padding:5px 25px;position:static}.src-components-shared-header-styles-___header-menu__navBar___3FqJM .src-components-shared-header-styles-___header-menu__menuDropdownLevel1___vZ19b:hover{background-color:#fff;color:#d3af71}.src-components-shared-header-styles-___header-menu__navBar___3FqJM .src-components-shared-header-styles-___header-menu__menuDropdownLevel1___vZ19b a{margin-bottom:1px;display:block;color:#ffa100;height:17px;line-height:1.25;padding:0;position:relative}.src-components-shared-header-styles-___header-menu__navBar___3FqJM .src-components-shared-header-styles-___header-menu__angleDown___GYbFk{display:inline-block;line-height:0;font-size:20px;font-weight:700!important}.src-components-shared-header-styles-___header-menu__navBar___3FqJM .src-components-shared-header-styles-___header-menu__angleUp___2euaT{display:none;line-height:0;font-size:20px;font-weight:700!important}.src-components-shared-header-styles-___header-menu__navBar___3FqJM .src-components-shared-header-styles-___header-menu__menuCategories___18Brr{position:absolute;white-space:nowrap;z-index:1;left:-99999em;list-style:none;background-color:#f8f4f3;border:2px solid #fff;border-top:0}.src-components-shared-header-styles-___header-menu__navBar___3FqJM .src-components-shared-header-styles-___header-menu__menuCategoriesHover___hgyhF{box-shadow:-4px 4px 5px rgba(0,0,0,.2);padding:0;left:auto}.src-components-shared-header-styles-___header-menu__navBar___3FqJM .src-components-shared-header-styles-___header-menu__menuSubCategories___1AoJ0{position:absolute;white-space:nowrap;z-index:1;left:-99999em;list-style:none;background-color:#f8f4f3;border:2px solid #fff;border-top:0;border-left:1px solid #fff;height:212px}.src-components-shared-header-styles-___header-menu__navBar___3FqJM .src-components-shared-header-styles-___header-menu__menuSubCategoriesHover___2bmDe{box-shadow:4px 4px 5px rgba(0,0,0,.2);left:97%;top:0;bottom:-2px;min-width:254px;background-color:#fff;height:212px}.src-components-shared-header-styles-___header-menu__navBar___3FqJM .src-components-shared-header-styles-___header-menu__menuDropdownLevel2___1srBK{display:flex;flex-flow:row;margin-left:0;margin-bottom:10px}.src-components-shared-header-styles-___header-menu__navBar___3FqJM .src-components-shared-header-styles-___header-menu__menuDropdownLevel2___1srBK a{margin-bottom:1px;display:block;cursor:pointer}.src-components-shared-header-styles-___header-menu__navBar___3FqJM .src-components-shared-header-styles-___header-menu__menuDropdownLevel2___1srBK a:hover{color:#d3af71}.src-components-shared-header-styles-___header-menu__navBar___3FqJM .src-components-shared-header-styles-___header-menu__specialGifts___1zItf{padding:0;bottom:0;width:100%;position:absolute!important}.src-components-shared-header-styles-___header-menu__navBar___3FqJM .src-components-shared-header-styles-___header-menu__specialGifts___1zItf a{background:url(" + __webpack_require__(1627) + ")!important;height:60px;margin:5px;padding:0;display:block}.src-components-shared-header-styles-___header-menu__navBar___3FqJM .src-components-shared-header-styles-___header-menu__specialGifts___1zItf a img{height:100%;width:auto;float:right!important}.src-components-shared-header-styles-___header-menu__navBar___3FqJM .src-components-shared-header-styles-___header-menu__titleSection___5Y1Gb{margin:0 0 0 13px;font-size:14px;line-height:16px;padding-top:12px;font-family:Lato Bold;color:#fff;text-align:center}.src-components-shared-header-styles-___header-menu__navBar___3FqJM .src-components-shared-header-styles-___header-menu__titleSection___5Y1Gb span:last-child{font-family:Lato Bold;font-weight:700;color:#fff}.src-components-shared-header-styles-___header-menu__navBar___3FqJM .src-components-shared-header-styles-___header-menu__tableCell___3wdVi{position:relative;background-color:#fff;border-left:1px solid #fff;padding:10px 20px}", ""]);
	
	// exports
	exports.locals = {
		"navBar": "src-components-shared-header-styles-___header-menu__navBar___3FqJM",
		"navBarNav": "src-components-shared-header-styles-___header-menu__navBarNav___2IAyX",
		"menuDropdownLevel0": "src-components-shared-header-styles-___header-menu__menuDropdownLevel0___3ym_e",
		"menuDropdownLevel1": "src-components-shared-header-styles-___header-menu__menuDropdownLevel1___vZ19b",
		"angleDown": "src-components-shared-header-styles-___header-menu__angleDown___GYbFk",
		"angleUp": "src-components-shared-header-styles-___header-menu__angleUp___2euaT",
		"menuCategories": "src-components-shared-header-styles-___header-menu__menuCategories___18Brr",
		"menuCategoriesHover": "src-components-shared-header-styles-___header-menu__menuCategoriesHover___hgyhF",
		"menuSubCategories": "src-components-shared-header-styles-___header-menu__menuSubCategories___1AoJ0",
		"menuSubCategoriesHover": "src-components-shared-header-styles-___header-menu__menuSubCategoriesHover___2bmDe",
		"menuDropdownLevel2": "src-components-shared-header-styles-___header-menu__menuDropdownLevel2___1srBK",
		"specialGifts": "src-components-shared-header-styles-___header-menu__specialGifts___1zItf",
		"titleSection": "src-components-shared-header-styles-___header-menu__titleSection___5Y1Gb",
		"tableCell": "src-components-shared-header-styles-___header-menu__tableCell___3wdVi"
	};

/***/ },
/* 899 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(24)();
	// imports
	
	
	// module
	exports.push([module.id, ".src-components-shared-header-styles-___header-styles__navBarHeader___2XswZ{float:left;font-size:28px;line-height:17px;height:50px;padding:16.5px 15px}@media (max-width:768px){.src-components-shared-header-styles-___header-styles__navBarHeader___2XswZ{float:left;width:30%;height:auto;position:absolute;padding:0}}.src-components-shared-header-styles-___header-styles__navBarHeader___2XswZ img{object-fit:fill;display:block;width:200px;margin-top:-5px;margin-left:-30px}@media (max-width:768px){.src-components-shared-header-styles-___header-styles__navBarHeader___2XswZ img{width:107px;margin-top:13px;margin-left:2px}}.src-components-shared-header-styles-___header-styles__headerLanguageButton___AxdSa{border:none!important;padding:0!important;color:#000!important;font-family:Roboto,sans-serif!important;font-size:13px!important}.src-components-shared-header-styles-___header-styles__headerLanguageButton___AxdSa:focus,.src-components-shared-header-styles-___header-styles__headerLanguageButton___AxdSa:hover{color:#00888a!important;text-decoration:none!important}.src-components-shared-header-styles-___header-styles__headerLanguageButton___AxdSa+ul{border:1px solid #c7c7c7;border-radius:0;top:23px}.src-components-shared-header-styles-___header-styles__headerLanguageButton___AxdSa+ul:before{content:\"\";width:10px;height:10px;border:none;border-top:1px solid #c7c7c7;border-left:1px solid #c7c7c7;position:absolute;top:-6px;left:10px;background:#fff;transform:rotate(45deg)}.src-components-shared-header-styles-___header-styles__headerLanguage___1Jb0g{display:inline-block}@media (max-width:768px){.src-components-shared-header-styles-___header-styles__navBarHeader___2XswZ{height:40px}}", ""]);
	
	// exports
	exports.locals = {
		"navBarHeader": "src-components-shared-header-styles-___header-styles__navBarHeader___2XswZ",
		"headerLanguageButton": "src-components-shared-header-styles-___header-styles__headerLanguageButton___AxdSa",
		"headerLanguage": "src-components-shared-header-styles-___header-styles__headerLanguage___1Jb0g"
	};

/***/ },
/* 900 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(24)();
	// imports
	
	
	// module
	exports.push([module.id, ".src-components-shared-header-styles-___mobile-menu__mobileMenu___183Wm{position:fixed;top:0;left:0;width:100%;height:500px;z-index:22;background-color:#fff;font-family:Lato Light;font-size:16px}.src-components-shared-header-styles-___mobile-menu__mobileMenu___183Wm li a{color:#000}.src-components-shared-header-styles-___mobile-menu__mobileMenu___183Wm .src-components-shared-header-styles-___mobile-menu__menuTop___2d0x7{border-bottom:1px solid hsla(0,0%,50%,.5);padding-top:15px;height:100vh;overflow:auto;pointer-events:auto!important}.src-components-shared-header-styles-___mobile-menu__mobileMenu___183Wm .src-components-shared-header-styles-___mobile-menu__menuBorder___1ZCmi{border-bottom:1px solid #b18433;padding-bottom:20px}.src-components-shared-header-styles-___mobile-menu__mobileMenu___183Wm .src-components-shared-header-styles-___mobile-menu__closeIcon___2Xxnr{font-size:38px}.src-components-shared-header-styles-___mobile-menu__mobileMenu___183Wm .src-components-shared-header-styles-___mobile-menu__greeting___3oy_5{font-size:20px;color:rgba(0,0,0,.7)!important;font-weight:900;letter-spacing:.2px}.src-components-shared-header-styles-___mobile-menu__mobileMenu___183Wm .src-components-shared-header-styles-___mobile-menu__loginContainer___159qH{margin-top:-8px;font-size:20px}.src-components-shared-header-styles-___mobile-menu__mobileMenu___183Wm .src-components-shared-header-styles-___mobile-menu__loginLink___1E5lu{line-height:40px;color:#f26d03;cursor:pointer;background-color:transparent!important;transition:color .15s ease-out,background-color .15s ease-out;font-size:20px;font-weight:900;letter-spacing:.2px;text-transform:lowercase}.src-components-shared-header-styles-___mobile-menu__mobileMenu___183Wm .src-components-shared-header-styles-___mobile-menu__registerLink___wOTrF{line-height:40px;cursor:pointer;background-color:transparent!important;transition:color .15s ease-out,background-color .15s ease-out;font-size:20px;text-transform:lowercase;color:#000}.src-components-shared-header-styles-___mobile-menu__mobileMenu___183Wm .src-components-shared-header-styles-___mobile-menu__rowContainer___2x8lS{margin-bottom:0;font-size:20px;width:inherit}.src-components-shared-header-styles-___mobile-menu__mobileMenu___183Wm .src-components-shared-header-styles-___mobile-menu__wishlistContainer___3b_eF{line-height:40px;font-size:16px;cursor:pointer;color:#5d5d5d;background-color:transparent!important;text-decoration:none;transition:color .15s ease-out,background-color .15s ease-out}.src-components-shared-header-styles-___mobile-menu__mobileMenu___183Wm .src-components-shared-header-styles-___mobile-menu__wishlistContainer___3b_eF span{font-size:14px;color:gray}.src-components-shared-header-styles-___mobile-menu__mobileMenu___183Wm .src-components-shared-header-styles-___mobile-menu__likeIcon___2ywaC{color:hsla(0,0%,50%,.7)!important;font-size:1.2em!important;margin-top:-4px;margin-left:5px!important;vertical-align:middle;line-height:.75em;display:inline-block;font-family:Pe-icon-7-filled;speak:none;font-style:normal;font-weight:400;font-variant:normal;text-transform:none;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.src-components-shared-header-styles-___mobile-menu__mobileMenu___183Wm .src-components-shared-header-styles-___mobile-menu__cartContainer___2sNva{line-height:40px;font-size:16px;cursor:pointer;color:#5d5d5d;background-color:transparent!important;transition:color .15s ease-out,background-color .15s ease-out;text-decoration:none;position:relative}.src-components-shared-header-styles-___mobile-menu__mobileMenu___183Wm .src-components-shared-header-styles-___mobile-menu__cartContainer___2sNva span{font-size:14px;color:gray}.src-components-shared-header-styles-___mobile-menu__mobileMenu___183Wm .src-components-shared-header-styles-___mobile-menu__cartIcon___1v_tZ{color:hsla(0,0%,50%,.7)!important;font-size:1.2em!important;margin-top:-4px}.src-components-shared-header-styles-___mobile-menu__mobileMenu___183Wm .src-components-shared-header-styles-___mobile-menu__badge___3ukZS{display:inline-block;min-width:10px;line-height:1;vertical-align:middle;white-space:nowrap;text-align:center;border-radius:10px;padding:2px 5px;font-weight:400;font-style:normal;font-size:12px;background-color:#d3af71;position:relative;right:8px;top:-12px;transition:background-color .15s ease-out;color:#fff!important}.src-components-shared-header-styles-___mobile-menu__mobileMenu___183Wm .src-components-shared-header-styles-___mobile-menu__menuBottom___3da3y{height:636px;overflow:scroll}.src-components-shared-header-styles-___mobile-menu__mobileMenu___183Wm .src-components-shared-header-styles-___mobile-menu__menuDropdownLevel0___16_Cd{padding-top:3px;padding-bottom:3px}.src-components-shared-header-styles-___mobile-menu__mobileMenu___183Wm .src-components-shared-header-styles-___mobile-menu__menuCategory___Kh4la{font-size:18px;margin-top:7px}.src-components-shared-header-styles-___mobile-menu__mobileMenu___183Wm .src-components-shared-header-styles-___mobile-menu__menuCategory___Kh4la span{font-size:18px;color:rgba(0,0,0,.7)!important;font-weight:900;letter-spacing:.2px}.src-components-shared-header-styles-___mobile-menu__mobileMenu___183Wm .src-components-shared-header-styles-___mobile-menu__menuCategoryHover___21LPz span{font-weight:700;color:#f26d03!important}.src-components-shared-header-styles-___mobile-menu__mobileMenu___183Wm .src-components-shared-header-styles-___mobile-menu__angleDown___3rqK9,.src-components-shared-header-styles-___mobile-menu__mobileMenu___183Wm .src-components-shared-header-styles-___mobile-menu__angleUp___3e1bZ{margin-top:11px;margin-left:-3px;line-height:0;font-size:1.3333333333333333em;display:inline-block;font-family:Pe-icon-7-stroke;speak:none;font-style:normal;font-weight:700!important;font-variant:normal;text-transform:none;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.src-components-shared-header-styles-___mobile-menu__mobileMenu___183Wm .src-components-shared-header-styles-___mobile-menu__menuCategories___3P37x{height:1px;overflow-x:visible;padding-right:15px;padding-left:15px;border-top:1px solid transparent;box-shadow:inset 0 1px 0 hsla(0,0%,100%,.1);display:none}.src-components-shared-header-styles-___mobile-menu__mobileMenu___183Wm .src-components-shared-header-styles-___mobile-menu__menuCategoriesHover___3GIfh{overflow-y:auto;display:block;height:auto}.src-components-shared-header-styles-___mobile-menu__mobileMenu___183Wm .src-components-shared-header-styles-___mobile-menu__menuDropdownLevel1___1AGeW{padding-top:3px;padding-bottom:3px;position:relative}.src-components-shared-header-styles-___mobile-menu__mobileMenu___183Wm .src-components-shared-header-styles-___mobile-menu__menuSubcategory___1XiAQ{font-size:15px;color:gray}.src-components-shared-header-styles-___mobile-menu__mobileMenu___183Wm .src-components-shared-header-styles-___mobile-menu__menuSubcategory___1XiAQ span{font-size:16px!important;font-weight:900;letter-spacing:.2px}.src-components-shared-header-styles-___mobile-menu__mobileMenu___183Wm .src-components-shared-header-styles-___mobile-menu__menuSubCategories___1xAV8{overflow-x:visible;padding-right:15px;padding-left:15px;border-top:1px solid transparent;box-shadow:inset 0 1px 0 hsla(0,0%,100%,.1);-webkit-overflow-scrolling:touch;display:none}.src-components-shared-header-styles-___mobile-menu__mobileMenu___183Wm .src-components-shared-header-styles-___mobile-menu__menuSubCategoriesHover___M3Fdo{overflow-y:auto;display:block}.src-components-shared-header-styles-___mobile-menu__mobileMenu___183Wm .src-components-shared-header-styles-___mobile-menu__menuDropdownLevel2___2nTWe{padding-top:3px;padding-bottom:3px}.src-components-shared-header-styles-___mobile-menu__mobileMenu___183Wm .src-components-shared-header-styles-___mobile-menu__menu___3WqYD{padding-left:20px;padding-right:20px}.src-components-shared-header-styles-___mobile-menu__mobileMenu___183Wm .src-components-shared-header-styles-___mobile-menu__rowSeeAll___1Q55N{padding-left:20px;text-align:center;padding-top:20px;padding-bottom:20px}.src-components-shared-header-styles-___mobile-menu__mobileMenu___183Wm .src-components-shared-header-styles-___mobile-menu__rowSeeAll___1Q55N a{color:#fff;border-radius:10px;background-color:#2b2b2b!important;padding:5px 20px}.src-components-shared-header-styles-___mobile-menu__mobileMenu___183Wm .src-components-shared-header-styles-___mobile-menu__rowSeeAll___1Q55N a:hover{color:#ff6d02!important}", ""]);
	
	// exports
	exports.locals = {
		"mobileMenu": "src-components-shared-header-styles-___mobile-menu__mobileMenu___183Wm",
		"menuTop": "src-components-shared-header-styles-___mobile-menu__menuTop___2d0x7",
		"menuBorder": "src-components-shared-header-styles-___mobile-menu__menuBorder___1ZCmi",
		"closeIcon": "src-components-shared-header-styles-___mobile-menu__closeIcon___2Xxnr",
		"greeting": "src-components-shared-header-styles-___mobile-menu__greeting___3oy_5",
		"loginContainer": "src-components-shared-header-styles-___mobile-menu__loginContainer___159qH",
		"loginLink": "src-components-shared-header-styles-___mobile-menu__loginLink___1E5lu",
		"registerLink": "src-components-shared-header-styles-___mobile-menu__registerLink___wOTrF",
		"rowContainer": "src-components-shared-header-styles-___mobile-menu__rowContainer___2x8lS",
		"wishlistContainer": "src-components-shared-header-styles-___mobile-menu__wishlistContainer___3b_eF",
		"likeIcon": "src-components-shared-header-styles-___mobile-menu__likeIcon___2ywaC",
		"cartContainer": "src-components-shared-header-styles-___mobile-menu__cartContainer___2sNva",
		"cartIcon": "src-components-shared-header-styles-___mobile-menu__cartIcon___1v_tZ",
		"badge": "src-components-shared-header-styles-___mobile-menu__badge___3ukZS",
		"menuBottom": "src-components-shared-header-styles-___mobile-menu__menuBottom___3da3y",
		"menuDropdownLevel0": "src-components-shared-header-styles-___mobile-menu__menuDropdownLevel0___16_Cd",
		"menuCategory": "src-components-shared-header-styles-___mobile-menu__menuCategory___Kh4la",
		"menuCategoryHover": "src-components-shared-header-styles-___mobile-menu__menuCategoryHover___21LPz",
		"angleUp": "src-components-shared-header-styles-___mobile-menu__angleUp___3e1bZ",
		"angleDown": "src-components-shared-header-styles-___mobile-menu__angleDown___3rqK9",
		"menuCategories": "src-components-shared-header-styles-___mobile-menu__menuCategories___3P37x",
		"menuCategoriesHover": "src-components-shared-header-styles-___mobile-menu__menuCategoriesHover___3GIfh",
		"menuDropdownLevel1": "src-components-shared-header-styles-___mobile-menu__menuDropdownLevel1___1AGeW",
		"menuSubcategory": "src-components-shared-header-styles-___mobile-menu__menuSubcategory___1XiAQ",
		"menuSubCategories": "src-components-shared-header-styles-___mobile-menu__menuSubCategories___1xAV8",
		"menuSubCategoriesHover": "src-components-shared-header-styles-___mobile-menu__menuSubCategoriesHover___M3Fdo",
		"menuDropdownLevel2": "src-components-shared-header-styles-___mobile-menu__menuDropdownLevel2___2nTWe",
		"menu": "src-components-shared-header-styles-___mobile-menu__menu___3WqYD",
		"rowSeeAll": "src-components-shared-header-styles-___mobile-menu__rowSeeAll___1Q55N"
	};

/***/ },
/* 901 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(24)();
	// imports
	
	
	// module
	exports.push([module.id, ".src-components-shared-header-styles-___search-form__navbarSearch___1pB5S{padding-top:0;padding-bottom:0;margin:8px 0 0 35px}.src-components-shared-header-styles-___search-form__navbarSearch___1pB5S .src-components-shared-header-styles-___search-form__closeIcon___3inI5{position:absolute;right:8px;z-index:9;top:7px}.src-components-shared-header-styles-___search-form__navbarSearch___1pB5S .src-components-shared-header-styles-___search-form__closeIcon___3inI5 svg{color:#b18433;transition:color .25s ease}.src-components-shared-header-styles-___search-form__navbarSearch___1pB5S .src-components-shared-header-styles-___search-form__closeIcon___3inI5 svg:hover{color:#b18433}.src-components-shared-header-styles-___search-form__navbarSearch___1pB5S .src-components-shared-header-styles-___search-form__closeIconEnabled___2c5dk{cursor:pointer}.src-components-shared-header-styles-___search-form__navbarSearch___1pB5S .src-components-shared-header-styles-___search-form__closeIconDisabled___1aaJh{display:none}.src-components-shared-header-styles-___search-form__navbarSearch___1pB5S .src-components-shared-header-styles-___search-form__formGroup___2DtAF{width:100%;margin-bottom:10px}.src-components-shared-header-styles-___search-form__navbarSearch___1pB5S .src-components-shared-header-styles-___search-form__headerSearchInput___dFc_L{padding-left:27px;border-color:#b18433;border-radius:0!important;height:30px;background-color:#000;color:#fff}@media (max-width:768px){.src-components-shared-header-styles-___search-form__navbarSearch___1pB5S .src-components-shared-header-styles-___search-form__headerSearchInput___dFc_L{padding-left:15px!important}}.src-components-shared-header-styles-___search-form__navbarSearch___1pB5S .src-components-shared-header-styles-___search-form__inputGroupButton___B3Dqj{height:30px}.src-components-shared-header-styles-___search-form__navbarSearch___1pB5S .src-components-shared-header-styles-___search-form__inputButton___WEku1{padding:0 10px;line-height:0;height:30px;background-color:#b18433;border-radius:0}.src-components-shared-header-styles-___search-form__navbarSearch___1pB5S .src-components-shared-header-styles-___search-form__inputButton___WEku1.src-components-shared-header-styles-___search-form__active___4hnJR.src-components-shared-header-styles-___search-form__focus___2bfvu,.src-components-shared-header-styles-___search-form__navbarSearch___1pB5S .src-components-shared-header-styles-___search-form__inputButton___WEku1.src-components-shared-header-styles-___search-form__active___4hnJR:focus,.src-components-shared-header-styles-___search-form__navbarSearch___1pB5S .src-components-shared-header-styles-___search-form__inputButton___WEku1.src-components-shared-header-styles-___search-form__focus___2bfvu,.src-components-shared-header-styles-___search-form__navbarSearch___1pB5S .src-components-shared-header-styles-___search-form__inputButton___WEku1:active.src-components-shared-header-styles-___search-form__focus___2bfvu,.src-components-shared-header-styles-___search-form__navbarSearch___1pB5S .src-components-shared-header-styles-___search-form__inputButton___WEku1:active:focus,.src-components-shared-header-styles-___search-form__navbarSearch___1pB5S .src-components-shared-header-styles-___search-form__inputButton___WEku1:focus{border:1px solid #5d5d5d!important;outline:none;outline-offset:0}.src-components-shared-header-styles-___search-form__navbarSearch___1pB5S .src-components-shared-header-styles-___search-form__headerSearchIcon___2g5nv{color:#fff;display:inline-block;speak:none;font-style:normal;font-weight:400;font-variant:normal;text-transform:none;line-height:1;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.src-components-shared-header-styles-___search-form__navbarSearch___1pB5S .src-components-shared-header-styles-___search-form__inputGroup___29ugp{height:30px}.src-components-shared-header-styles-___search-form__navbarSearch___1pB5S .src-components-shared-header-styles-___search-form__inputSelector___37aG1{width:auto!important;min-width:70px;box-sizing:border-box;display:inline-block;margin:0;position:relative;vertical-align:middle}.src-components-shared-header-styles-___search-form__navbarSearch___1pB5S .src-components-shared-header-styles-___search-form__inputSelect___2ZH2T{position:relative;display:inline-block}.src-components-shared-header-styles-___search-form__navbarSearch___1pB5S .src-components-shared-header-styles-___search-form__currentSelection___Baqw6{margin-right:-1px;height:auto;background-color:#f2f2f2;border:1px solid #a9a9a9;border-right-width:0;box-sizing:border-box;cursor:pointer;display:block;user-select:none;-webkit-user-select:none}.src-components-shared-header-styles-___search-form__navbarSearch___1pB5S .src-components-shared-header-styles-___search-form__currentSelectionRender___3vjlf{font-size:14px;text-align:center;color:#5d5d5d;line-height:28px;display:block;padding-left:8px;padding-right:20px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.src-components-shared-header-styles-___search-form__navbarSearch___1pB5S .src-components-shared-header-styles-___search-form__selectionArrow___1oAHg{height:26px;position:absolute;top:1px;right:1px;width:20px}.src-components-shared-header-styles-___search-form__navbarSearch___1pB5S .src-components-shared-header-styles-___search-form__selectionArrow___1oAHg b{border:0;font-family:Pe-icon-7-stroke;font-size:20px;font-weight:700;line-height:1.25!important;width:auto;height:100%;margin:0;position:static;padding:2px 0;display:inline-block}.src-components-shared-header-styles-___search-form__navbarSearch___1pB5S .src-components-shared-header-styles-___search-form__selectionArrow___1oAHg b:before{content:\"\\E688\"}.src-components-shared-header-styles-___search-form__navbarSearch___1pB5S .src-components-shared-header-styles-___search-form__inputFormControl___2EqVi{border:0!important;clip:rect(0 0 0 0)!important;-webkit-clip-path:inset(50%)!important;clip-path:inset(50%)!important;height:1px!important;overflow:hidden!important;padding:0!important;position:absolute!important;width:1px!important;white-space:nowrap!important}.src-components-shared-header-styles-___search-form__navbarSearch___1pB5S .src-components-shared-header-styles-___search-form__selectContainer___2HGBC{box-sizing:border-box;display:inline-block;margin:0;position:absolute;vertical-align:middle}.src-components-shared-header-styles-___search-form__navbarSearch___1pB5S .src-components-shared-header-styles-___search-form__selectDropdown___1giWF{left:0;width:200px;background-color:#fff;box-sizing:border-box;display:block;position:absolute;z-index:1051;border:1px solid #dfe1e1;border-top-style:none}.src-components-shared-header-styles-___search-form__navbarSearch___1pB5S .src-components-shared-header-styles-___search-form__selectResults___3CAvz{display:block}.src-components-shared-header-styles-___search-form__navbarSearch___1pB5S .src-components-shared-header-styles-___search-form__selectResultsOptions___2ufzZ{width:210px;background-color:#f8f4f3;border:2px solid #fff;border-top:0;max-height:200px;overflow-y:auto;list-style:none;margin:0;padding:0}.src-components-shared-header-styles-___search-form__navbarSearch___1pB5S .src-components-shared-header-styles-___search-form__selectResultOption___16Le2{border-bottom:2px solid #fff;text-align:center;color:inherit;cursor:pointer;user-select:none;-webkit-user-select:none;font-family:Lato,Open Sans;font-size:14px;line-height:1.25}.src-components-shared-header-styles-___search-form__navbarSearch___1pB5S .src-components-shared-header-styles-___search-form__selectResultOption___16Le2 div{padding:8px 6px}.src-components-shared-header-styles-___search-form__navbarSearch___1pB5S .src-components-shared-header-styles-___search-form__selectResultOption___16Le2:hover{background-color:#fff;color:inherit}.src-components-shared-header-styles-___search-form__navbarSearch___1pB5S .src-components-shared-header-styles-___search-form__activeResultOption___2V00W{background-color:#fff;color:#d3af71}.src-components-shared-header-styles-___search-form__navbarSearch___1pB5S .src-components-shared-header-styles-___search-form__headerSearchLabel___FQNdz{width:1px;height:1px;position:absolute;top:0;left:0;z-index:0}@media (max-width:768px){.src-components-shared-header-styles-___search-form__navbarSearch___1pB5S{margin-left:15px;margin-right:15px}.src-components-shared-header-styles-___search-form__navbarSearch___1pB5S .src-components-shared-header-styles-___search-form__headerSearchIcon___2g5nv{top:9px;right:5px}.src-components-shared-header-styles-___search-form__navbarSearch___1pB5S .src-components-shared-header-styles-___search-form__headerSearchInput___dFc_L{height:30px;padding:0 15px 0 5px;font-size:14px;line-height:30px}}@media (min-width:768px) and (max-width:991px){.src-components-shared-header-styles-___search-form__navbarSearch___1pB5S{margin-left:0}}", ""]);
	
	// exports
	exports.locals = {
		"navbarSearch": "src-components-shared-header-styles-___search-form__navbarSearch___1pB5S",
		"closeIcon": "src-components-shared-header-styles-___search-form__closeIcon___3inI5",
		"closeIconEnabled": "src-components-shared-header-styles-___search-form__closeIconEnabled___2c5dk",
		"closeIconDisabled": "src-components-shared-header-styles-___search-form__closeIconDisabled___1aaJh",
		"formGroup": "src-components-shared-header-styles-___search-form__formGroup___2DtAF",
		"headerSearchInput": "src-components-shared-header-styles-___search-form__headerSearchInput___dFc_L",
		"inputGroupButton": "src-components-shared-header-styles-___search-form__inputGroupButton___B3Dqj",
		"inputButton": "src-components-shared-header-styles-___search-form__inputButton___WEku1",
		"active": "src-components-shared-header-styles-___search-form__active___4hnJR",
		"focus": "src-components-shared-header-styles-___search-form__focus___2bfvu",
		"headerSearchIcon": "src-components-shared-header-styles-___search-form__headerSearchIcon___2g5nv",
		"inputGroup": "src-components-shared-header-styles-___search-form__inputGroup___29ugp",
		"inputSelector": "src-components-shared-header-styles-___search-form__inputSelector___37aG1",
		"inputSelect": "src-components-shared-header-styles-___search-form__inputSelect___2ZH2T",
		"currentSelection": "src-components-shared-header-styles-___search-form__currentSelection___Baqw6",
		"currentSelectionRender": "src-components-shared-header-styles-___search-form__currentSelectionRender___3vjlf",
		"selectionArrow": "src-components-shared-header-styles-___search-form__selectionArrow___1oAHg",
		"inputFormControl": "src-components-shared-header-styles-___search-form__inputFormControl___2EqVi",
		"selectContainer": "src-components-shared-header-styles-___search-form__selectContainer___2HGBC",
		"selectDropdown": "src-components-shared-header-styles-___search-form__selectDropdown___1giWF",
		"selectResults": "src-components-shared-header-styles-___search-form__selectResults___3CAvz",
		"selectResultsOptions": "src-components-shared-header-styles-___search-form__selectResultsOptions___2ufzZ",
		"selectResultOption": "src-components-shared-header-styles-___search-form__selectResultOption___16Le2",
		"activeResultOption": "src-components-shared-header-styles-___search-form__activeResultOption___2V00W",
		"headerSearchLabel": "src-components-shared-header-styles-___search-form__headerSearchLabel___FQNdz"
	};

/***/ },
/* 902 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(24)();
	// imports
	
	
	// module
	exports.push([module.id, ".src-components-shared-secondary-menu-styles-___submenu-title__leftMenuTitleContainer___2BJkf{background-color:#e0e0e0;text-transform:capitalize;border-bottom:1px solid #252525;padding:10px 10px 10px 15px;cursor:pointer;font-family:Lato,Arial;color:#252525}.src-components-shared-secondary-menu-styles-___submenu-title__titleArrow___2sJnO{font-size:20px;line-height:20px;color:#252525}", ""]);
	
	// exports
	exports.locals = {
		"leftMenuTitleContainer": "src-components-shared-secondary-menu-styles-___submenu-title__leftMenuTitleContainer___2BJkf",
		"titleArrow": "src-components-shared-secondary-menu-styles-___submenu-title__titleArrow___2sJnO"
	};

/***/ },
/* 903 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(24)();
	// imports
	
	
	// module
	exports.push([module.id, ".src-components-shared-styles-___header__header___15GPd{height:122px;margin:0;border-bottom:1px solid #000;background-color:#252525;z-index:12;border-radius:0!important;flex-shrink:0;position:fixed;top:0;width:100%;z-index:20}@media (min-width:768px) and (max-width:991px){.src-components-shared-styles-___header__header___15GPd{height:120px}}@media (max-width:767px){.src-components-shared-styles-___header__header___15GPd{padding-top:0}}@media (max-width:767px){.src-components-shared-styles-___header__header___15GPd .src-components-shared-styles-___header__headerNavbarCol___XJaRZ{padding-left:0!important}}.src-components-shared-styles-___header__header___15GPd .src-components-shared-styles-___header__addToCartMobile___3Slst,.src-components-shared-styles-___header__header___15GPd .src-components-shared-styles-___header__signin___2ilJN{color:#ffa100;line-height:50px;font-size:16px;margin-right:5px!important;margin-left:15px!important}.src-components-shared-styles-___header__header___15GPd .src-components-shared-styles-___header__addToCartMobile___3Slst span,.src-components-shared-styles-___header__header___15GPd .src-components-shared-styles-___header__signin___2ilJN span{display:none}@media (max-width:392px){.src-components-shared-styles-___header__header___15GPd .src-components-shared-styles-___header__addToCartMobile___3Slst span,.src-components-shared-styles-___header__header___15GPd .src-components-shared-styles-___header__signin___2ilJN span{display:none}}.src-components-shared-styles-___header__header___15GPd .src-components-shared-styles-___header__addToCartMobile___3Slst i,.src-components-shared-styles-___header__header___15GPd .src-components-shared-styles-___header__signin___2ilJN i{font-size:1.3333333333333333em;padding-left:5px}.src-components-shared-styles-___header__header___15GPd .src-components-shared-styles-___header__addToCartMobile___3Slst .src-components-shared-styles-___header__badge___fdoZY,.src-components-shared-styles-___header__header___15GPd .src-components-shared-styles-___header__signin___2ilJN .src-components-shared-styles-___header__badge___fdoZY{padding:3px 5px;font-weight:400;font-style:normal;font-size:8px;background-color:#b18433;position:absolute;right:12px;top:12px;transition:background-color .15s ease-out;color:#fff!important;line-height:1;vertical-align:middle;white-space:nowrap;text-align:center;border-radius:10px}.src-components-shared-styles-___header__header___15GPd .src-components-shared-styles-___header__searchContainer___20fD4{width:100%}.src-components-shared-styles-___header__header___15GPd .src-components-shared-styles-___header__navbarToggle___1GTvF{position:relative;float:right;margin-right:15px;padding:9px 10px;margin-top:8px;margin-bottom:8px;background-color:transparent;background-image:none;border:1px solid transparent;border-radius:4px;transition:color .15s ease-out,background-color .15s ease-out,border-color .15s ease-out;line-height:inherit;cursor:pointer;text-transform:none;overflow:visible;color:inherit;font:inherit}@media (max-width:768px){.src-components-shared-styles-___header__header___15GPd .src-components-shared-styles-___header__navbarToggle___1GTvF{margin-left:15px;margin-right:0;padding-left:0;float:left;border:none;display:block}}.src-components-shared-styles-___header__header___15GPd .src-components-shared-styles-___header__navbarToggle___1GTvF .src-components-shared-styles-___header__srOnly___1WZKC{position:absolute;width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;clip:rect(0,0,0,0);border:0}.src-components-shared-styles-___header__header___15GPd .src-components-shared-styles-___header__navbarToggle___1GTvF .src-components-shared-styles-___header__iconBar___1CZuC{display:block;width:22px;height:2px;border-radius:1px}@media (max-width:768px){.src-components-shared-styles-___header__header___15GPd .src-components-shared-styles-___header__navbarToggle___1GTvF .src-components-shared-styles-___header__iconBar___1CZuC{background-color:#5d5d5d;height:4px;width:25px}}.src-components-shared-styles-___header__header___15GPd .src-components-shared-styles-___header__navbarToggle___1GTvF .src-components-shared-styles-___header__iconBar___1CZuC+.src-components-shared-styles-___header__iconBar___1CZuC{margin-top:2px}.src-components-shared-styles-___header__header___15GPd .src-components-shared-styles-___header__cartIcon___1nOER{color:#fff}.src-components-shared-styles-___header__header___15GPd .src-components-shared-styles-___header__cartIcon___1nOER:hover{color:#fff;cursor:pointer}@media (max-width:991px){.src-components-shared-styles-___header__header___15GPd .src-components-shared-styles-___header__classified___2nApP{display:none}}.src-components-shared-styles-___header__header___15GPd .src-components-shared-styles-___header__linkOrange___6veCG{height:40px;line-height:30px;padding:5px 10px 15px;color:#fff!important}.src-components-shared-styles-___header__header___15GPd .src-components-shared-styles-___header__linkOrange___6veCG:active,.src-components-shared-styles-___header__header___15GPd .src-components-shared-styles-___header__linkOrange___6veCG:focus,.src-components-shared-styles-___header__header___15GPd .src-components-shared-styles-___header__linkOrange___6veCG:hover{color:#b18433!important}.src-components-shared-styles-___header__header___15GPd .src-components-shared-styles-___header__avatar_mobile___3a1Wp{margin-top:8px}.src-components-shared-styles-___header__header___15GPd .src-components-shared-styles-___header__lineDouble___sOHvR{height:40px;line-height:30px;padding:5px 10px 15px;color:#fff!important}.src-components-shared-styles-___header__header___15GPd .src-components-shared-styles-___header__lineDouble___sOHvR:active,.src-components-shared-styles-___header__header___15GPd .src-components-shared-styles-___header__lineDouble___sOHvR:focus,.src-components-shared-styles-___header__header___15GPd .src-components-shared-styles-___header__lineDouble___sOHvR:hover{color:#b18433!important}.src-components-shared-styles-___header__header___15GPd .src-components-shared-styles-___header__lineDouble___sOHvR .src-components-shared-styles-___header__text___2on4h{margin-top:-10px;display:inline-block}.src-components-shared-styles-___header__header___15GPd .src-components-shared-styles-___header__lineDouble___sOHvR i{margin-top:-3px}.src-components-shared-styles-___header__header___15GPd .src-components-shared-styles-___header__hello___1JV-G{padding-left:3px;padding-right:5px}.src-components-shared-styles-___header__header___15GPd .src-components-shared-styles-___header__navbarRight___69BCL a{height:40px;padding-bottom:15px;line-height:30px;padding-top:5px}@media (min-width:768px){.src-components-shared-styles-___header__header___15GPd .src-components-shared-styles-___header__navbarRight___69BCL{margin-right:0!important}}.src-components-shared-styles-___header__header___15GPd .src-components-shared-styles-___header__icons___3YX29{margin-top:4px}@media (min-width:767px){.src-components-shared-styles-___header__header___15GPd .src-components-shared-styles-___header__icons___3YX29{margin-top:0}}.src-components-shared-styles-___header__header___15GPd .src-components-shared-styles-___header__navLanguage___OGDGk{margin-left:-4px}.src-components-shared-styles-___header__header___15GPd .src-components-shared-styles-___header__languages___1NaJ3{height:40px;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;padding-left:13px}.src-components-shared-styles-___header__header___15GPd .src-components-shared-styles-___header__languages___1NaJ3 a{padding:0 0 0 2px;line-height:normal;height:auto;display:-ms-inline-grid;display:inline-grid;position:relative}.src-components-shared-styles-___header__header___15GPd .src-components-shared-styles-___header__languages___1NaJ3 a img{max-width:none;display:inline-block;width:24px;height:24px;-o-object-fit:contain;object-fit:contain;o-object-fit:contain}.src-components-shared-styles-___header__header___15GPd .src-components-shared-styles-___header__languages___1NaJ3 a.src-components-shared-styles-___header__dropdown___mTK0J{color:#b18433;display:inline-block}@media (min-width:768px) and (max-width:991px){.src-components-shared-styles-___header__header___15GPd .src-components-shared-styles-___header__languages___1NaJ3{margin-top:6px}}.src-components-shared-styles-___header__header___15GPd .src-components-shared-styles-___header__userMenuDropdowns___398Jb{top:100%;margin-top:5px!important;background-color:#252525;box-shadow:none;border:0;border:2px solid #000;padding-top:0;padding-bottom:0}.src-components-shared-styles-___header__header___15GPd .src-components-shared-styles-___header__userMenuDropdowns___398Jb li{position:static}.src-components-shared-styles-___header__header___15GPd .src-components-shared-styles-___header__userMenuDropdowns___398Jb li:hover{background-color:#252525}.src-components-shared-styles-___header__header___15GPd .src-components-shared-styles-___header__userMenuDropdowns___398Jb li:not(:last-child){border-bottom:2px solid #000}.src-components-shared-styles-___header__header___15GPd .src-components-shared-styles-___header__userMenuDropdowns___398Jb li a{color:#fff;line-height:32px;padding:3px 35px 3px 20px;display:block;clear:both;font-weight:400;white-space:nowrap}.src-components-shared-styles-___header__header___15GPd .src-components-shared-styles-___header__userMenuDropdowns___398Jb li a:hover{color:#b18433;text-decoration:none;background-color:#252525!important;background-image:none}.src-components-shared-styles-___header__header___15GPd .src-components-shared-styles-___header__userMenuIcon___3GsKj{width:21px;text-align:center;font-size:21px;vertical-align:sub;margin-right:9px}.src-components-shared-styles-___header__header___15GPd .src-components-shared-styles-___header__angleDown___EMSTK{display:inline-block;line-height:0;font-size:20px;font-weight:700!important}.src-components-shared-styles-___header__header___15GPd .src-components-shared-styles-___header__angleUp___1XFZL{display:none;line-height:0;font-size:20px;font-weight:700!important}.src-components-shared-styles-___header__header___15GPd .src-components-shared-styles-___header__languageDropdowns___OmLx8{min-width:64px;top:100%;background-color:#252525;box-shadow:none;border:0;border-bottom:1px solid #b18433;padding-top:0;padding-bottom:0}.src-components-shared-styles-___header__header___15GPd .src-components-shared-styles-___header__languageDropdowns___OmLx8 li{padding:2px 10px;text-align:center;cursor:pointer}.src-components-shared-styles-___header__header___15GPd .src-components-shared-styles-___header__languageDropdowns___OmLx8 li:hover{box-shadow:inset 0 -1px 6px rgba(0,0,0,.1)}.src-components-shared-styles-___header__header___15GPd .src-components-shared-styles-___header__languageDropdowns___OmLx8 li.src-components-shared-styles-___header__open___mBE9O,.src-components-shared-styles-___header__header___15GPd .src-components-shared-styles-___header__languageDropdowns___OmLx8 li:hover{background-color:#dcccae}.src-components-shared-styles-___header__header___15GPd .src-components-shared-styles-___header__languageDropdowns___OmLx8 li img{display:inline-block;width:24px;height:24px;-o-object-fit:contain;object-fit:contain;o-object-fit:contain}.src-components-shared-styles-___header__header___15GPd .src-components-shared-styles-___header__headerUserButton___elqPg{border:none;padding:0;color:#000}.src-components-shared-styles-___header__header___15GPd .src-components-shared-styles-___header__headerUserButton___elqPg:focus,.src-components-shared-styles-___header__header___15GPd .src-components-shared-styles-___header__headerUserButton___elqPg:hover{color:#4eaf79;text-decoration:none}.src-components-shared-styles-___header__header___15GPd .src-components-shared-styles-___header__headerUserButton___elqPg+ul{border:1px solid #c7c7c7;border-radius:0;top:23px}.src-components-shared-styles-___header__header___15GPd .src-components-shared-styles-___header__headerUserButton___elqPg+ul:before{content:\"\";width:10px;height:10px;border:none;border-top:1px solid #c7c7c7;border-left:1px solid #c7c7c7;position:absolute;top:-6px;left:10px;background:#fff;transform:rotate(45deg)}.src-components-shared-styles-___header__header___15GPd .src-components-shared-styles-___header__headerLanguageBlock___1vYML,.src-components-shared-styles-___header__header___15GPd .src-components-shared-styles-___header__headerTopNav___8VaPX{padding-top:20px}.src-components-shared-styles-___header__header___15GPd .src-components-shared-styles-___header__globalHeaderLogo___2FHGQ{font-family:Oswald,sans-serif;font-size:32px;font-weight:700}.src-components-shared-styles-___header__header___15GPd .src-components-shared-styles-___header__headerNavHolder___3vsQD{margin-bottom:0}.src-components-shared-styles-___header__header___15GPd .src-components-shared-styles-___header__headerUserLink___XfCRj{font-family:Roboto,sans-serif;font-size:13px}.src-components-shared-styles-___header__header___15GPd .src-components-shared-styles-___header__headerBottomNavRow___JCRob{margin-top:10px}.src-components-shared-styles-___header__header___15GPd .src-components-shared-styles-___header__headerMainNavHolder___1e3ly{padding-top:10px}@media (max-width:767px){.src-components-shared-styles-___header__header___15GPd{height:auto}.src-components-shared-styles-___header__header___15GPd .src-components-shared-styles-___header__globalHeaderLogo___2FHGQ{text-align:left}.src-components-shared-styles-___header__header___15GPd .src-components-shared-styles-___header__headerMobileMenu___3Gnv5{margin:15px 0 0;font-size:18px}}.src-components-shared-styles-___header__header___15GPd .src-components-shared-styles-___header__secondLevelMenu___3JBK9{position:absolute;top:0!important;margin-left:298px;background-color:#ff6d02;color:#2b2b2b;z-index:10000}.src-components-shared-styles-___header__header___15GPd .src-components-shared-styles-___header__secondLevelMenu___3JBK9 li{padding-left:20px}.src-components-shared-styles-___header__header___15GPd .src-components-shared-styles-___header__secondLevelMenu___3JBK9 li a:hover{color:#2b2b2b!important}.src-components-shared-styles-___header__header___15GPd li .src-components-shared-styles-___header__rowSeeAll___1si4d{padding-left:20px;text-align:center;padding-top:20px;padding-bottom:20px}.src-components-shared-styles-___header__header___15GPd li .src-components-shared-styles-___header__rowSeeAll___1si4d a{color:#fff;border-radius:10px;background-color:#2b2b2b!important;padding:5px 20px}.src-components-shared-styles-___header__header___15GPd li .src-components-shared-styles-___header__rowSeeAll___1si4d a:hover{color:#ff6d02!important}.src-components-shared-styles-___header__header___15GPd .src-components-shared-styles-___header__menu___3ACfS{width:300px}.src-components-shared-styles-___header__header___15GPd .src-components-shared-styles-___header__firstLevelMenu___1pH7X{background-color:#2b2b2b;color:#fff}.src-components-shared-styles-___header__header___15GPd .src-components-shared-styles-___header__firstLevelMenu___1pH7X a:hover{color:#b18433!important}.src-components-shared-styles-___header__header___15GPd .src-components-shared-styles-___header__navigationIcon___qJ8UT{position:absolute;right:10px;top:15px;display:none}.src-components-shared-styles-___header__header___15GPd .src-components-shared-styles-___header__navigationIcon___qJ8UT.src-components-shared-styles-___header__open___mBE9O{display:inline-block}.src-components-shared-styles-___header__header___15GPd .src-components-shared-styles-___header__rootMenuSelect___3Jn-L{background-color:#2b2b2b!important;color:#fff!important}.src-components-shared-styles-___header__header___15GPd .src-components-shared-styles-___header__headerSecondRow___OaQxe{background-color:hsla(40,1%,43%,.27)}.src-components-shared-styles-___header__header___15GPd .src-components-shared-styles-___header__secondLevelMenu2___3U1tX{left:298px;width:300px;position:absolute;top:0!important;background-color:#2b2b2b;color:#2b2b2b;z-index:10000;padding:5px}.src-components-shared-styles-___header__header___15GPd .src-components-shared-styles-___header__secondLevelMenu2___3U1tX li{padding-left:20px;padding-top:3px;padding-bottom:3px}.src-components-shared-styles-___header__header___15GPd .src-components-shared-styles-___header__secondLevelMenu2___3U1tX li a:hover{color:#b18433!important}.src-components-shared-styles-___header__header___15GPd .src-components-shared-styles-___header__scrollable___2LJS_{overflow:scroll}.src-components-shared-styles-___header__header___15GPd .src-components-shared-styles-___header__menuDesktopContainer___3enoM{min-width:360px}.src-components-shared-styles-___header__header___15GPd .src-components-shared-styles-___header__timeCartLeftDesktop___2Qw6N,.src-components-shared-styles-___header__header___15GPd .src-components-shared-styles-___header__timeCartLeftMobile___1cARz{display:block!important;position:absolute;color:#fff;top:30px;font-size:small;width:80px;right:-10px;text-align:center}.src-components-shared-styles-___header__header___15GPd .src-components-shared-styles-___header__timeCartLeftDesktop___2Qw6N{color:#fff;left:-15px;margin-top:-4px}.src-components-shared-styles-___header__header___15GPd .src-components-shared-styles-___header__timeCartLeftDesktop___2Qw6N:active,.src-components-shared-styles-___header__header___15GPd .src-components-shared-styles-___header__timeCartLeftDesktop___2Qw6N:focus,.src-components-shared-styles-___header__header___15GPd .src-components-shared-styles-___header__timeCartLeftDesktop___2Qw6N:hover{color:#fff}.src-components-shared-styles-___header__header___15GPd .src-components-shared-styles-___header__timeCartLastAlert___JyQYu{animation:src-components-shared-styles-___header__fadeIt___2Jeyc .8s ease-in-out infinite alternate}@keyframes src-components-shared-styles-___header__fadeIt___2Jeyc{0%{background-color:#b18433}to{background-color:#dcccae}}.src-components-shared-styles-___header__header___15GPd .src-components-shared-styles-___header__filter___-uw3U{align-items:center;display:none}@media (max-width:767px){.src-components-shared-styles-___header__header___15GPd .src-components-shared-styles-___header__filter___-uw3U{display:flex}}.src-components-shared-styles-___header__header___15GPd .src-components-shared-styles-___header__mobileWelcomeLine___2PpHh{padding:8px 20px;border-bottom:2px solid #ffa100!important;color:#ffa100}.src-components-shared-styles-___header__header___15GPd .src-components-shared-styles-___header__mobileWelcomeLine___2PpHh:hover{background-color:#f8f4f3!important}.src-components-shared-styles-___header__header__menu-item___35oZS a:hover{color:#b18433}", ""]);
	
	// exports
	exports.locals = {
		"header": "src-components-shared-styles-___header__header___15GPd",
		"headerNavbarCol": "src-components-shared-styles-___header__headerNavbarCol___XJaRZ",
		"signin": "src-components-shared-styles-___header__signin___2ilJN",
		"addToCartMobile": "src-components-shared-styles-___header__addToCartMobile___3Slst",
		"badge": "src-components-shared-styles-___header__badge___fdoZY",
		"searchContainer": "src-components-shared-styles-___header__searchContainer___20fD4",
		"navbarToggle": "src-components-shared-styles-___header__navbarToggle___1GTvF",
		"srOnly": "src-components-shared-styles-___header__srOnly___1WZKC",
		"iconBar": "src-components-shared-styles-___header__iconBar___1CZuC",
		"cartIcon": "src-components-shared-styles-___header__cartIcon___1nOER",
		"classified": "src-components-shared-styles-___header__classified___2nApP",
		"linkOrange": "src-components-shared-styles-___header__linkOrange___6veCG",
		"avatar_mobile": "src-components-shared-styles-___header__avatar_mobile___3a1Wp",
		"lineDouble": "src-components-shared-styles-___header__lineDouble___sOHvR",
		"text": "src-components-shared-styles-___header__text___2on4h",
		"hello": "src-components-shared-styles-___header__hello___1JV-G",
		"navbarRight": "src-components-shared-styles-___header__navbarRight___69BCL",
		"icons": "src-components-shared-styles-___header__icons___3YX29",
		"navLanguage": "src-components-shared-styles-___header__navLanguage___OGDGk",
		"languages": "src-components-shared-styles-___header__languages___1NaJ3",
		"dropdown": "src-components-shared-styles-___header__dropdown___mTK0J",
		"userMenuDropdowns": "src-components-shared-styles-___header__userMenuDropdowns___398Jb",
		"userMenuIcon": "src-components-shared-styles-___header__userMenuIcon___3GsKj",
		"angleDown": "src-components-shared-styles-___header__angleDown___EMSTK",
		"angleUp": "src-components-shared-styles-___header__angleUp___1XFZL",
		"languageDropdowns": "src-components-shared-styles-___header__languageDropdowns___OmLx8",
		"open": "src-components-shared-styles-___header__open___mBE9O",
		"headerUserButton": "src-components-shared-styles-___header__headerUserButton___elqPg",
		"headerLanguageBlock": "src-components-shared-styles-___header__headerLanguageBlock___1vYML",
		"headerTopNav": "src-components-shared-styles-___header__headerTopNav___8VaPX",
		"globalHeaderLogo": "src-components-shared-styles-___header__globalHeaderLogo___2FHGQ",
		"headerNavHolder": "src-components-shared-styles-___header__headerNavHolder___3vsQD",
		"headerUserLink": "src-components-shared-styles-___header__headerUserLink___XfCRj",
		"headerBottomNavRow": "src-components-shared-styles-___header__headerBottomNavRow___JCRob",
		"headerMainNavHolder": "src-components-shared-styles-___header__headerMainNavHolder___1e3ly",
		"headerMobileMenu": "src-components-shared-styles-___header__headerMobileMenu___3Gnv5",
		"secondLevelMenu": "src-components-shared-styles-___header__secondLevelMenu___3JBK9",
		"rowSeeAll": "src-components-shared-styles-___header__rowSeeAll___1si4d",
		"menu": "src-components-shared-styles-___header__menu___3ACfS",
		"firstLevelMenu": "src-components-shared-styles-___header__firstLevelMenu___1pH7X",
		"navigationIcon": "src-components-shared-styles-___header__navigationIcon___qJ8UT",
		"rootMenuSelect": "src-components-shared-styles-___header__rootMenuSelect___3Jn-L",
		"headerSecondRow": "src-components-shared-styles-___header__headerSecondRow___OaQxe",
		"secondLevelMenu2": "src-components-shared-styles-___header__secondLevelMenu2___3U1tX",
		"scrollable": "src-components-shared-styles-___header__scrollable___2LJS_",
		"menuDesktopContainer": "src-components-shared-styles-___header__menuDesktopContainer___3enoM",
		"timeCartLeftMobile": "src-components-shared-styles-___header__timeCartLeftMobile___1cARz",
		"timeCartLeftDesktop": "src-components-shared-styles-___header__timeCartLeftDesktop___2Qw6N",
		"timeCartLastAlert": "src-components-shared-styles-___header__timeCartLastAlert___JyQYu",
		"fadeIt": "src-components-shared-styles-___header__fadeIt___2Jeyc",
		"filter": "src-components-shared-styles-___header__filter___-uw3U",
		"mobileWelcomeLine": "src-components-shared-styles-___header__mobileWelcomeLine___2PpHh",
		"header__menu-item": "src-components-shared-styles-___header__header__menu-item___35oZS"
	};

/***/ },
/* 904 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(24)();
	// imports
	
	
	// module
	exports.push([module.id, ".src-components-shared-styles-___ktp-off-canvas__ktpOffCanvas___1iaT_{width:100vw;height:100%;position:fixed;top:-1px;left:-1px;background:#e0e0e0;z-index:999999;padding:15px;overflow:auto;pointer-events:auto!important}.src-components-shared-styles-___ktp-off-canvas__ktpOffCanvas___1iaT_ .src-components-shared-styles-___ktp-off-canvas__head___1ghPi{display:flex;justify-content:space-between;margin-bottom:15px}.src-components-shared-styles-___ktp-off-canvas__ktpOffCanvas___1iaT_ .src-components-shared-styles-___ktp-off-canvas__head___1ghPi .src-components-shared-styles-___ktp-off-canvas__title___3XTPu{font-size:24px}.src-components-shared-styles-___ktp-off-canvas__ktpOffCanvas___1iaT_ .src-components-shared-styles-___ktp-off-canvas__head___1ghPi button{min-height:28px;position:relative;overflow:hidden;color:#fff;border-radius:20px!important;margin:0;width:95px;padding:7px 10px;background-color:#b18433!important;transition:width .3s ease!important;justify-content:center;border:0}.src-components-shared-styles-___ktp-off-canvas__ktpOffCanvas___1iaT_ .src-components-shared-styles-___ktp-off-canvas__content___3gtzi{overflow:auto;height:calc(100vh - 39px)}", ""]);
	
	// exports
	exports.locals = {
		"ktpOffCanvas": "src-components-shared-styles-___ktp-off-canvas__ktpOffCanvas___1iaT_",
		"head": "src-components-shared-styles-___ktp-off-canvas__head___1ghPi",
		"title": "src-components-shared-styles-___ktp-off-canvas__title___3XTPu",
		"content": "src-components-shared-styles-___ktp-off-canvas__content___3gtzi"
	};

/***/ },
/* 905 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(24)();
	// imports
	
	
	// module
	exports.push([module.id, ".src-components-shared-styles-___signup-promotion__promotionContainer___2OKXY{border:1px solid transparent;border-top:2px solid #8eadca;border-bottom:0!important;margin-bottom:0!important;position:relative;min-height:50px;display:block;margin-top:0}.src-components-shared-styles-___signup-promotion__promotionContainer___2OKXY .src-components-shared-styles-___signup-promotion__signupPromotion___3mj17{text-align:center;padding:12px;border-bottom:1px solid #8eadca;color:#8eadca;background-color:#eceff6}@media (min-width:992px){.src-components-shared-styles-___signup-promotion__promotionContainer___2OKXY .src-components-shared-styles-___signup-promotion__signupPromotion___3mj17{padding:18px}}.src-components-shared-styles-___signup-promotion__promotionContainer___2OKXY .src-components-shared-styles-___signup-promotion__signupPromotion___3mj17 p{font-family:Lato Bold,serif;font-size:16px;text-transform:uppercase;letter-spacing:.8px;line-height:24px;margin:0}@media (max-width:991px){.src-components-shared-styles-___signup-promotion__promotionContainer___2OKXY .src-components-shared-styles-___signup-promotion__signupPromotion___3mj17 p{font-size:14px;line-height:32px}}.src-components-shared-styles-___signup-promotion__promotionContainer___2OKXY .src-components-shared-styles-___signup-promotion__signupPromotion___3mj17 p span{padding:0 1px}.src-components-shared-styles-___signup-promotion__promotionContainer___2OKXY .src-components-shared-styles-___signup-promotion__signupPromotion___3mj17 .src-components-shared-styles-___signup-promotion__buttonHighlight___fQJ1C{font-family:Arial,serif!important;font-size:16px;padding:4px 14px;margin-left:76px;letter-spacing:.4px;background-color:#18396c!important;color:#fff;border:none;display:inline-block;text-transform:none}@media (max-width:991px){.src-components-shared-styles-___signup-promotion__promotionContainer___2OKXY .src-components-shared-styles-___signup-promotion__signupPromotion___3mj17 .src-components-shared-styles-___signup-promotion__buttonHighlight___fQJ1C{margin-left:5px;padding:2px 14px;line-height:24px}}", ""]);
	
	// exports
	exports.locals = {
		"promotionContainer": "src-components-shared-styles-___signup-promotion__promotionContainer___2OKXY",
		"signupPromotion": "src-components-shared-styles-___signup-promotion__signupPromotion___3mj17",
		"buttonHighlight": "src-components-shared-styles-___signup-promotion__buttonHighlight___fQJ1C"
	};

/***/ },
/* 906 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(24)();
	// imports
	
	
	// module
	exports.push([module.id, ".src-components-styles-components-___category-slider__categorySlider___3Q6CJ i{border:1px solid #000!important}.src-components-styles-components-___category-slider__title___1STx9{margin-bottom:20px;margin-top:20px;color:#d3af71;font-family:Lato Bold;font-weight:700;font-size:21px}@media (max-width:399px){.src-components-styles-components-___category-slider__title___1STx9{margin-top:40px}}.src-components-styles-components-___category-slider__showAll___1lEQu{background-color:#18396c;color:#fff;padding:5px 20px;border-radius:30px}.src-components-styles-components-___category-slider__imageSlider___2d3h4{object-fit:contain;height:100%}.src-components-styles-components-___category-slider__imageSlider___2d3h4:hover{opacity:.2}.src-components-styles-components-___category-slider__backgroundSlider___3TI8w{height:140px}.src-components-styles-components-___category-slider__backgroundSlider___3TI8w .src-components-styles-components-___category-slider__contentOverlay___33hbO{background:#d3af71;position:absolute;height:100%;width:100%;left:0;top:0;bottom:0;right:0;opacity:0;transition:all .4s ease-in-out 0s}.src-components-styles-components-___category-slider__backgroundSlider___3TI8w:hover .src-components-styles-components-___category-slider__contentOverlay___33hbO{opacity:1}.src-components-styles-components-___category-slider__backgroundSlider___3TI8w:hover .src-components-styles-components-___category-slider__contentDetails___HuYFG{top:50%;left:50%;opacity:1}.src-components-styles-components-___category-slider__contentDetails___HuYFG{position:absolute;text-align:center;padding-left:1em;padding-right:1em;overflow-x:hidden;width:100%;top:50%;left:50%;opacity:0;transform:translate(-50%,-50%);transition:all .3s ease-in-out 0s}.src-components-styles-components-___category-slider__contentDetails___HuYFG h4{color:#fff;font-weight:400;margin-bottom:.5em;text-transform:uppercase}.src-components-styles-components-___category-slider__fadeInBottom___32WdT{top:80%}.src-components-styles-components-___category-slider__arrowIcon___1jT5C{border-color:#5d5d5d}", ""]);
	
	// exports
	exports.locals = {
		"categorySlider": "src-components-styles-components-___category-slider__categorySlider___3Q6CJ",
		"title": "src-components-styles-components-___category-slider__title___1STx9",
		"showAll": "src-components-styles-components-___category-slider__showAll___1lEQu",
		"imageSlider": "src-components-styles-components-___category-slider__imageSlider___2d3h4",
		"backgroundSlider": "src-components-styles-components-___category-slider__backgroundSlider___3TI8w",
		"contentOverlay": "src-components-styles-components-___category-slider__contentOverlay___33hbO",
		"contentDetails": "src-components-styles-components-___category-slider__contentDetails___HuYFG",
		"fadeInBottom": "src-components-styles-components-___category-slider__fadeInBottom___32WdT",
		"arrowIcon": "src-components-styles-components-___category-slider__arrowIcon___1jT5C"
	};

/***/ },
/* 907 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(24)();
	// imports
	
	
	// module
	exports.push([module.id, ".src-components-styles-components-checkout-steps-___base-checkout-layout__delivery_small_text___2iWLa{font-size:12px;line-height:1.5;color:#828282;font-style:italic}", ""]);
	
	// exports
	exports.locals = {
		"delivery_small_text": "src-components-styles-components-checkout-steps-___base-checkout-layout__delivery_small_text___2iWLa"
	};

/***/ },
/* 908 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(24)();
	// imports
	
	
	// module
	exports.push([module.id, ".src-components-styles-components-checkout-steps-___delivery-form__deliveryFormShipments___2LygC{padding-left:25px;padding-right:25px;border-style:none;background-color:#e9e9e8}", ""]);
	
	// exports
	exports.locals = {
		"deliveryFormShipments": "src-components-styles-components-checkout-steps-___delivery-form__deliveryFormShipments___2LygC"
	};

/***/ },
/* 909 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(24)();
	// imports
	
	
	// module
	exports.push([module.id, ".src-components-styles-components-checkout-steps-payment-___payment-method-k-wallet__pmKWalletWrapper__signedIn___3KY72{display:flex}.src-components-styles-components-checkout-steps-payment-___payment-method-k-wallet__pmKWalletWrapper__signedIn___3KY72 img{max-width:280px}.src-components-styles-components-checkout-steps-payment-___payment-method-k-wallet__pmKWalletWrapper__signedIn__description___Ecra2{font-size:17px}.src-components-styles-components-checkout-steps-payment-___payment-method-k-wallet__pmKWalletWrapper__signedIn__colLeft___2zgfp{width:60%;padding-right:25px;text-align:center}.src-components-styles-components-checkout-steps-payment-___payment-method-k-wallet__pmKWalletWrapper__signedIn__colRight___Zk3LG{border-left:1px solid #ddd;width:40%;padding-left:25px}.src-components-styles-components-checkout-steps-payment-___payment-method-k-wallet__pmKWalletWrapper__signedIn__colRight__balanceSummary___1BlQl{display:flex}.src-components-styles-components-checkout-steps-payment-___payment-method-k-wallet__pmKWalletWrapper__signedIn__colRight__balanceSummary__colValues___38mQp{margin-left:10px}.src-components-styles-components-checkout-steps-payment-___payment-method-k-wallet__pmKWalletWrapper__signedIn__colRight__balanceSummary__colLabels___2mh9j div,.src-components-styles-components-checkout-steps-payment-___payment-method-k-wallet__pmKWalletWrapper__signedIn__colRight__balanceSummary__colValues___38mQp div{margin:5px 0}.src-components-styles-components-checkout-steps-payment-___payment-method-k-wallet__pmKWalletWrapper__signedIn__colRight__balance_insufficient___2FKO9{display:flex;background-color:#ff6d03;color:#fff;padding:4px;border-radius:5px!important;justify-content:center;border:1px solid #e9e9ea}.src-components-styles-components-checkout-steps-payment-___payment-method-k-wallet__pmKWalletWrapper__signedIn__colRight__balance_insufficient___2FKO9:hover{background-color:#e9e9ea;color:#ff6d03;cursor:pointer;box-shadow:0 0 5px #e9e9ea;border:1px solid #ff6d03}@media (max-width:991px){.src-components-styles-components-checkout-steps-payment-___payment-method-k-wallet__pmKWalletWrapper__signedIn___3KY72{display:block}.src-components-styles-components-checkout-steps-payment-___payment-method-k-wallet__pmKWalletWrapper__signedIn__colLeft___2zgfp{width:100%;padding-right:0;padding-bottom:25px;text-align:center}.src-components-styles-components-checkout-steps-payment-___payment-method-k-wallet__pmKWalletWrapper__signedIn__colRight___Zk3LG{border-top:1px solid #ddd;padding-top:25px;border-left:none;width:100%;padding-left:0}}.src-components-styles-components-checkout-steps-payment-___payment-method-k-wallet__pmKWalletWrapper__notSignedIn___1fyAa{display:flex;justify-content:space-between}.src-components-styles-components-checkout-steps-payment-___payment-method-k-wallet__pmKWalletWrapper__notSignedIn___1fyAa img{max-width:280px}.src-components-styles-components-checkout-steps-payment-___payment-method-k-wallet__pmKWalletWrapper__notSignedIn__description___3XGWB{width:50%}.src-components-styles-components-checkout-steps-payment-___payment-method-k-wallet__pmKWalletWrapper__notSignedIn__description__text___1tZ_A{font-size:17px}.src-components-styles-components-checkout-steps-payment-___payment-method-k-wallet__pmKWalletWrapper__notSignedIn__signInForm___3jcq0{max-width:360px;width:50%}@media (max-width:1200px){.src-components-styles-components-checkout-steps-payment-___payment-method-k-wallet__pmKWalletWrapper__notSignedIn___1fyAa{display:block}.src-components-styles-components-checkout-steps-payment-___payment-method-k-wallet__pmKWalletWrapper__notSignedIn__description___3XGWB{width:auto;margin-bottom:25px}.src-components-styles-components-checkout-steps-payment-___payment-method-k-wallet__pmKWalletWrapper__notSignedIn__signInForm___3jcq0{width:auto}}", ""]);
	
	// exports
	exports.locals = {
		"pmKWalletWrapper__signedIn": "src-components-styles-components-checkout-steps-payment-___payment-method-k-wallet__pmKWalletWrapper__signedIn___3KY72",
		"pmKWalletWrapper__signedIn__description": "src-components-styles-components-checkout-steps-payment-___payment-method-k-wallet__pmKWalletWrapper__signedIn__description___Ecra2",
		"pmKWalletWrapper__signedIn__colLeft": "src-components-styles-components-checkout-steps-payment-___payment-method-k-wallet__pmKWalletWrapper__signedIn__colLeft___2zgfp",
		"pmKWalletWrapper__signedIn__colRight": "src-components-styles-components-checkout-steps-payment-___payment-method-k-wallet__pmKWalletWrapper__signedIn__colRight___Zk3LG",
		"pmKWalletWrapper__signedIn__colRight__balanceSummary": "src-components-styles-components-checkout-steps-payment-___payment-method-k-wallet__pmKWalletWrapper__signedIn__colRight__balanceSummary___1BlQl",
		"pmKWalletWrapper__signedIn__colRight__balanceSummary__colValues": "src-components-styles-components-checkout-steps-payment-___payment-method-k-wallet__pmKWalletWrapper__signedIn__colRight__balanceSummary__colValues___38mQp",
		"pmKWalletWrapper__signedIn__colRight__balanceSummary__colLabels": "src-components-styles-components-checkout-steps-payment-___payment-method-k-wallet__pmKWalletWrapper__signedIn__colRight__balanceSummary__colLabels___2mh9j",
		"pmKWalletWrapper__signedIn__colRight__balance_insufficient": "src-components-styles-components-checkout-steps-payment-___payment-method-k-wallet__pmKWalletWrapper__signedIn__colRight__balance_insufficient___2FKO9",
		"pmKWalletWrapper__notSignedIn": "src-components-styles-components-checkout-steps-payment-___payment-method-k-wallet__pmKWalletWrapper__notSignedIn___1fyAa",
		"pmKWalletWrapper__notSignedIn__description": "src-components-styles-components-checkout-steps-payment-___payment-method-k-wallet__pmKWalletWrapper__notSignedIn__description___3XGWB",
		"pmKWalletWrapper__notSignedIn__description__text": "src-components-styles-components-checkout-steps-payment-___payment-method-k-wallet__pmKWalletWrapper__notSignedIn__description__text___1tZ_A",
		"pmKWalletWrapper__notSignedIn__signInForm": "src-components-styles-components-checkout-steps-payment-___payment-method-k-wallet__pmKWalletWrapper__notSignedIn__signInForm___3jcq0"
	};

/***/ },
/* 910 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(24)();
	// imports
	
	
	// module
	exports.push([module.id, ".src-components-styles-components-checkout-steps-payment-___payment-method-selector__pms___2KD5I{margin:25px}.src-components-styles-components-checkout-steps-payment-___payment-method-selector__pms__title___s74mM{margin-bottom:20px}.src-components-styles-components-checkout-steps-payment-___payment-method-selector__pms__option___2lxBY{background-color:#f7f7f9;padding:5px 5px 5px 10px;border-radius:5px!important}.src-components-styles-components-checkout-steps-payment-___payment-method-selector__pms__option___2lxBY>div{border:1px solid #ddd}.src-components-styles-components-checkout-steps-payment-___payment-method-selector__pms__option___2lxBY>div>div:first-of-type{background-color:#eee;padding:15px}.src-components-styles-components-checkout-steps-payment-___payment-method-selector__pms__option__label___2PcHl{margin:0 0 0 10px;cursor:pointer}.src-components-styles-components-checkout-steps-payment-___payment-method-selector__pms___2KD5I li{margin-bottom:5px}.src-components-styles-components-checkout-steps-payment-___payment-method-selector__pms___2KD5I li:last-of-type{margin-bottom:0}", ""]);
	
	// exports
	exports.locals = {
		"pms": "src-components-styles-components-checkout-steps-payment-___payment-method-selector__pms___2KD5I",
		"pms__title": "src-components-styles-components-checkout-steps-payment-___payment-method-selector__pms__title___s74mM",
		"pms__option": "src-components-styles-components-checkout-steps-payment-___payment-method-selector__pms__option___2lxBY",
		"pms__option__label": "src-components-styles-components-checkout-steps-payment-___payment-method-selector__pms__option__label___2PcHl"
	};

/***/ },
/* 911 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(24)();
	// imports
	
	
	// module
	exports.push([module.id, ".src-components-styles-components-___home-slider__homeSlider___12Noy,.src-components-styles-components-___home-slider__homeSliderRow___1vLs_,.src-components-styles-components-___home-slider__sliderContainer___24x9C{height:31.25vw}", ""]);
	
	// exports
	exports.locals = {
		"homeSlider": "src-components-styles-components-___home-slider__homeSlider___12Noy",
		"homeSliderRow": "src-components-styles-components-___home-slider__homeSliderRow___1vLs_",
		"sliderContainer": "src-components-styles-components-___home-slider__sliderContainer___24x9C"
	};

/***/ },
/* 912 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(24)();
	// imports
	
	
	// module
	exports.push([module.id, ".src-components-styles-components-___infinite-scroller__scroller___2E6Ou{position:relative;top:30px}.src-components-styles-components-___infinite-scroller__scroller___2E6Ou .src-components-styles-components-___infinite-scroller__scrollerTitle___wLnOt>div{display:inline-block;vertical-align:middle;margin-left:8px;margin-top:-6px}", ""]);
	
	// exports
	exports.locals = {
		"scroller": "src-components-styles-components-___infinite-scroller__scroller___2E6Ou",
		"scrollerTitle": "src-components-styles-components-___infinite-scroller__scrollerTitle___wLnOt"
	};

/***/ },
/* 913 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(24)();
	// imports
	
	
	// module
	exports.push([module.id, "@keyframes src-components-styles-components-___loading__spin___3biPD{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}.src-components-styles-components-___loading__spinnerDark___2888d{border-radius:50%!important;width:5em;height:5em;margin:0 auto;font-size:10px;position:relative;text-indent:-9999em;border:.3em solid rgba(85,85,85,.2);border-left-color:#555;transform:translateZ(0);animation:src-components-styles-components-___loading__spin___3biPD 1.1s infinite linear}.src-components-styles-components-___loading__spinnerDark___2888d.src-components-styles-components-___loading__loader___1g3na,.src-components-styles-components-___loading__spinnerDark___2888d.src-components-styles-components-___loading__loader___1g3na:after{border-radius:50%!important;width:5em;height:5em}.src-components-styles-components-___loading__loadingPanel___3ji8U{z-index:99999;height:100%;width:100%;position:absolute;right:0;top:0;display:flex;justify-content:center;align-items:center;background-color:hsla(0,0%,100%,.8)}", ""]);
	
	// exports
	exports.locals = {
		"spinnerDark": "src-components-styles-components-___loading__spinnerDark___2888d",
		"spin": "src-components-styles-components-___loading__spin___3biPD",
		"loader": "src-components-styles-components-___loading__loader___1g3na",
		"loadingPanel": "src-components-styles-components-___loading__loadingPanel___3ji8U"
	};

/***/ },
/* 914 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(24)();
	// imports
	
	
	// module
	exports.push([module.id, ".src-components-styles-components-___price-form__inputField___PWxJE{display:table-cell;position:relative;z-index:2;float:left;width:100%;margin-bottom:0;border-radius:0!important;padding:0 0 0 10px;height:22px;border-left:none}.src-components-styles-components-___price-form__inputField___PWxJE:focus{border-color:#b18433}.src-components-styles-components-___price-form__addon___3Uj59{padding:0 0 3px 1px;background-color:#fff;border-radius:0}.src-components-styles-components-___price-form__btnPrice___u3dy1{background-color:#000;color:#fff;font-size:12;font-family:Arial;border-radius:0}.src-components-styles-components-___price-form__btnPrice___u3dy1:hover{color:#fff}.src-components-styles-components-___price-form__btnPrice___u3dy1:focus{color:#fff;outline:none}", ""]);
	
	// exports
	exports.locals = {
		"inputField": "src-components-styles-components-___price-form__inputField___PWxJE",
		"addon": "src-components-styles-components-___price-form__addon___3Uj59",
		"btnPrice": "src-components-styles-components-___price-form__btnPrice___u3dy1"
	};

/***/ },
/* 915 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(24)();
	// imports
	
	
	// module
	exports.push([module.id, ".src-components-styles-components-___product-tile__productTile___HCVwM{display:flex;justify-content:center;padding-left:0;padding-right:0;flex-wrap:wrap}@media (min-width:768px){.src-components-styles-components-___product-tile__productTile___HCVwM{padding-left:5px;padding-right:5px}}.src-components-styles-components-___product-tile__productTile___HCVwM .src-components-styles-components-___product-tile__productBlock___3KwQm{width:100%;margin:5px 0;padding:8px;background-color:#fff;border:1px solid #dfe1e1;display:block;min-height:375px;float:left;position:relative;height:auto!important}@media (max-width:768px){.src-components-styles-components-___product-tile__productTile___HCVwM .src-components-styles-components-___product-tile__productBlock___3KwQm{display:flex;flex-flow:row;min-height:1px}}.src-components-styles-components-___product-tile__productTile___HCVwM .src-components-styles-components-___product-tile__productBlock___3KwQm .src-components-styles-components-___product-tile__imgMain___2n7EK{position:relative}@media (max-width:768px){.src-components-styles-components-___product-tile__productTile___HCVwM .src-components-styles-components-___product-tile__productBlock___3KwQm .src-components-styles-components-___product-tile__imgMain___2n7EK{width:35%}}.src-components-styles-components-___product-tile__productTile___HCVwM .src-components-styles-components-___product-tile__productBlock___3KwQm .src-components-styles-components-___product-tile__imgLoadingContainer___1RFYk{position:absolute;text-align:center;font-family:Lato Light,Helvetica Neue,Helvetica,Arial,sans-serif;font-size:14px;top:50%;left:50%;transform:translate(-50%,-50%)}.src-components-styles-components-___product-tile__productTile___HCVwM .src-components-styles-components-___product-tile__productBlock___3KwQm .src-components-styles-components-___product-tile__imgLoadingParent___1PTsY{position:relative;width:100%;height:100%;min-height:185px}.src-components-styles-components-___product-tile__productTile___HCVwM .src-components-styles-components-___product-tile__productBlock___3KwQm .src-components-styles-components-___product-tile__imgLoadingParent___1PTsY .src-components-styles-components-___product-tile__outStock___3KKz9{color:#5d5d5d;position:absolute;top:8px;left:16px}.src-components-styles-components-___product-tile__productTile___HCVwM .src-components-styles-components-___product-tile__productBlock___3KwQm .src-components-styles-components-___product-tile__imgLoadingParent___1PTsY .src-components-styles-components-___product-tile__note___nnZwO{color:#d3af71;position:absolute;font-weight:700;top:10px;right:16px}.src-components-styles-components-___product-tile__productTile___HCVwM .src-components-styles-components-___product-tile__productBlock___3KwQm .src-components-styles-components-___product-tile__textBlock___286s4{padding:8px!important;padding-bottom:5px!important}@media (max-width:768px){.src-components-styles-components-___product-tile__productTile___HCVwM .src-components-styles-components-___product-tile__productBlock___3KwQm .src-components-styles-components-___product-tile__textBlock___286s4{width:65%}}.src-components-styles-components-___product-tile__productTile___HCVwM .src-components-styles-components-___product-tile__productBlock___3KwQm .src-components-styles-components-___product-tile__titleCard___3kCr3{font-family:Lato Bold,Enriqueta,sans-serif;font-size:16px;font-weight:700;line-height:1.6;margin:0!important;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;color:inherit;height:51px}@media (max-width:768px){.src-components-styles-components-___product-tile__productTile___HCVwM .src-components-styles-components-___product-tile__productBlock___3KwQm .src-components-styles-components-___product-tile__titleCard___3kCr3{font-size:14px}}.src-components-styles-components-___product-tile__productTile___HCVwM .src-components-styles-components-___product-tile__productBlock___3KwQm .src-components-styles-components-___product-tile__titleCard___3kCr3 a{display:block;overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;color:#000}.src-components-styles-components-___product-tile__productTile___HCVwM .src-components-styles-components-___product-tile__productBlock___3KwQm .src-components-styles-components-___product-tile__commentFirst___Ep9ty{margin:7px 0 8px!important;float:left!important;font-size:14px;font-family:inherit;font-weight:500;line-height:1.1;color:inherit}.src-components-styles-components-___product-tile__productTile___HCVwM .src-components-styles-components-___product-tile__productBlock___3KwQm .src-components-styles-components-___product-tile__commentFirst___Ep9ty a{color:#d3af71!important;font-family:Lato Bold,Vegur Bold!important}.src-components-styles-components-___product-tile__productTile___HCVwM .src-components-styles-components-___product-tile__productBlock___3KwQm .src-components-styles-components-___product-tile__productDescription___3Imvy{font-family:Lato Light;font-size:16px;margin:0 0 3px;height:60px;text-overflow:ellipsis;overflow:hidden;padding-top:2px}@media (max-width:768px){.src-components-styles-components-___product-tile__productTile___HCVwM .src-components-styles-components-___product-tile__productBlock___3KwQm .src-components-styles-components-___product-tile__productDescription___3Imvy{font-size:15px;height:78px}}.src-components-styles-components-___product-tile__productTile___HCVwM .src-components-styles-components-___product-tile__productBlock___3KwQm .src-components-styles-components-___product-tile__productDescription___3Imvy p{margin:0}.src-components-styles-components-___product-tile__productTile___HCVwM .src-components-styles-components-___product-tile__productBlock___3KwQm .src-components-styles-components-___product-tile__lastRow___3Lf8O{display:-ms-flexbox;display:flex;justify-content:space-between;margin-top:10px}.src-components-styles-components-___product-tile__productTile___HCVwM .src-components-styles-components-___product-tile__productBlock___3KwQm .src-components-styles-components-___product-tile__price___249i-{font-size:18px;line-height:27px;left:0;font-family:Lato Bold,Enriqueta;font-weight:700;color:#000}.src-components-styles-components-___product-tile__productTile___HCVwM .src-components-styles-components-___product-tile__productBlock___3KwQm .src-components-styles-components-___product-tile__buttons___28Ej7{display:flex;flex-flow:row}.src-components-styles-components-___product-tile__productTile___HCVwM .src-components-styles-components-___product-tile__productBlock___3KwQm .src-components-styles-components-___product-tile__addToCartButton___3GCyp,.src-components-styles-components-___product-tile__productTile___HCVwM .src-components-styles-components-___product-tile__productBlock___3KwQm .src-components-styles-components-___product-tile__wishlistButton___3WJZH{border-radius:50%;background-color:#b18433;color:#fff;display:flex;justify-content:center;width:32px;align-items:center;height:32px;cursor:pointer}.src-components-styles-components-___product-tile__productTile___HCVwM .src-components-styles-components-___product-tile__productBlock___3KwQm .src-components-styles-components-___product-tile__addToCartButton___3GCyp span,.src-components-styles-components-___product-tile__productTile___HCVwM .src-components-styles-components-___product-tile__productBlock___3KwQm .src-components-styles-components-___product-tile__wishlistButton___3WJZH span{margin-left:-1px}.src-components-styles-components-___product-tile__productTile___HCVwM .src-components-styles-components-___product-tile__productBlock___3KwQm .src-components-styles-components-___product-tile__addToCartButton___3GCyp:hover,.src-components-styles-components-___product-tile__productTile___HCVwM .src-components-styles-components-___product-tile__productBlock___3KwQm .src-components-styles-components-___product-tile__wishlistButton___3WJZH:hover{background-color:#fe6902}.src-components-styles-components-___product-tile__productTile___HCVwM .src-components-styles-components-___product-tile__productBlock___3KwQm .src-components-styles-components-___product-tile__disableAddToCartButton___3oTnI{border-radius:50%;background-color:#706f6d;color:#fff;display:flex;justify-content:center;width:32px;align-items:center;height:32px}.src-components-styles-components-___product-tile__productTile___HCVwM .src-components-styles-components-___product-tile__productBlock___3KwQm .src-components-styles-components-___product-tile__disableAddToCartButton___3oTnI span{margin-left:-1px}.src-components-styles-components-___product-tile__productTile___HCVwM .src-components-styles-components-___product-tile__productBlock___3KwQm .src-components-styles-components-___product-tile__wishlistButton___3WJZH{display:none}.src-components-styles-components-___product-tile__productTile___HCVwM .src-components-styles-components-___product-tile__productBlock___3KwQm .src-components-styles-components-___product-tile__addToCartButton___3GCyp{background-color:#b18433;margin-left:5px}.src-components-styles-components-___product-tile__productTile___HCVwM .src-components-styles-components-___product-tile__productBlock___3KwQm .src-components-styles-components-___product-tile__addToCartButton___3GCyp:hover{background-color:#b18433}.src-components-styles-components-___product-tile__productTile___HCVwM .src-components-styles-components-___product-tile__productBlock___3KwQm .src-components-styles-components-___product-tile__productMainImage___1u8Ms{width:100%;min-height:185px;height:185px;display:block;vertical-align:middle;position:absolute}@media (max-width:768px){.src-components-styles-components-___product-tile__productTile___HCVwM .src-components-styles-components-___product-tile__productBlock___3KwQm .src-components-styles-components-___product-tile__productMainImage___1u8Ms{min-height:150px;height:150px}}", ""]);
	
	// exports
	exports.locals = {
		"productTile": "src-components-styles-components-___product-tile__productTile___HCVwM",
		"productBlock": "src-components-styles-components-___product-tile__productBlock___3KwQm",
		"imgMain": "src-components-styles-components-___product-tile__imgMain___2n7EK",
		"imgLoadingContainer": "src-components-styles-components-___product-tile__imgLoadingContainer___1RFYk",
		"imgLoadingParent": "src-components-styles-components-___product-tile__imgLoadingParent___1PTsY",
		"outStock": "src-components-styles-components-___product-tile__outStock___3KKz9",
		"note": "src-components-styles-components-___product-tile__note___nnZwO",
		"textBlock": "src-components-styles-components-___product-tile__textBlock___286s4",
		"titleCard": "src-components-styles-components-___product-tile__titleCard___3kCr3",
		"commentFirst": "src-components-styles-components-___product-tile__commentFirst___Ep9ty",
		"productDescription": "src-components-styles-components-___product-tile__productDescription___3Imvy",
		"lastRow": "src-components-styles-components-___product-tile__lastRow___3Lf8O",
		"price": "src-components-styles-components-___product-tile__price___249i-",
		"buttons": "src-components-styles-components-___product-tile__buttons___28Ej7",
		"addToCartButton": "src-components-styles-components-___product-tile__addToCartButton___3GCyp",
		"wishlistButton": "src-components-styles-components-___product-tile__wishlistButton___3WJZH",
		"disableAddToCartButton": "src-components-styles-components-___product-tile__disableAddToCartButton___3oTnI",
		"productMainImage": "src-components-styles-components-___product-tile__productMainImage___1u8Ms"
	};

/***/ },
/* 916 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(24)();
	// imports
	
	
	// module
	exports.push([module.id, ".src-components-styles-components-___secondary-menu__leftMenuContent___3MTgR,.src-components-styles-components-___secondary-menu__leftMenuTitleContainer___2hTVM{background-color:#e0e0e0;text-transform:capitalize}.src-components-styles-components-___secondary-menu__leftMenuTitleContainer___2hTVM{border-bottom:1px solid #252525;padding:10px 10px 10px 15px;cursor:pointer;font-family:Lato,Arial;color:#252525}.src-components-styles-components-___secondary-menu__paddingLeft30___1DGSo{padding-left:30px!important}.src-components-styles-components-___secondary-menu__marginBottom5___C1sBc{margin-bottom:5px!important}.src-components-styles-components-___secondary-menu__active___34v50{padding-left:30px!important}.src-components-styles-components-___secondary-menu__active___34v50,.src-components-styles-components-___secondary-menu__activeBorder___N0QuX{border-left:3px solid #b18433;font-weight:700;text-decoration:none;font-family:Lato Bold,Vegur Bold}.src-components-styles-components-___secondary-menu__selectItem___38wID{margin:auto}.src-components-styles-components-___secondary-menu__storeContainer___GGrc_{display:flex;padding:15px}.src-components-styles-components-___secondary-menu__leftMenuContent___3MTgR{position:static;text-overflow:ellipsis;font-size:14px;padding-top:15px;font-family:Lato Light;font-style:normal}.src-components-styles-components-___secondary-menu__leftMenuContent___3MTgR li{padding:0 0 0 15px}.src-components-styles-components-___secondary-menu__leftMenuContent___3MTgR li:hover{border-left:2px solid #b18433}.src-components-styles-components-___secondary-menu__leftMenuContent___3MTgR li:not(:last-child){border-bottom:2px solid #e0e0e0}.src-components-styles-components-___secondary-menu__leftMenuContent___3MTgR li a{display:block;clear:both;font-weight:400;white-space:nowrap;text-overflow:ellipsis;overflow:hidden;color:#000}.src-components-styles-components-___secondary-menu__leftMenuContent___3MTgR li a:hover{color:#b18433;font-weight:700;text-decoration:none;background-color:#e0e0e0!important;background-image:none}", ""]);
	
	// exports
	exports.locals = {
		"leftMenuTitleContainer": "src-components-styles-components-___secondary-menu__leftMenuTitleContainer___2hTVM",
		"leftMenuContent": "src-components-styles-components-___secondary-menu__leftMenuContent___3MTgR",
		"paddingLeft30": "src-components-styles-components-___secondary-menu__paddingLeft30___1DGSo",
		"marginBottom5": "src-components-styles-components-___secondary-menu__marginBottom5___C1sBc",
		"active": "src-components-styles-components-___secondary-menu__active___34v50",
		"activeBorder": "src-components-styles-components-___secondary-menu__activeBorder___N0QuX",
		"selectItem": "src-components-styles-components-___secondary-menu__selectItem___38wID",
		"storeContainer": "src-components-styles-components-___secondary-menu__storeContainer___GGrc_"
	};

/***/ },
/* 917 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(24)();
	// imports
	
	
	// module
	exports.push([module.id, ".src-components-styles-pages-___affidavit-certification__mainText___1G-0Y{padding-top:20px;color:#b18433;text-align:center;font-family:Lato,Open Sans,serif}.src-components-styles-pages-___affidavit-certification__privacyBackround___1fM2C{background-color:#fff;padding:30px 100px;margin:20px 0;box-shadow:0 1px 1px 0 rgba(0,0,0,.2)}@media (max-width:991px){.src-components-styles-pages-___affidavit-certification__privacyBackround___1fM2C{padding:30px}}.src-components-styles-pages-___affidavit-certification__privacyBackround___1fM2C p{text-align:justify;padding-bottom:10px}.src-components-styles-pages-___affidavit-certification__privacyBackround___1fM2C a{color:#b18433!important}.src-components-styles-pages-___affidavit-certification__privacyBackround___1fM2C a:active,.src-components-styles-pages-___affidavit-certification__privacyBackround___1fM2C a:focus,.src-components-styles-pages-___affidavit-certification__privacyBackround___1fM2C a:hover{color:#9e937e!important}.src-components-styles-pages-___affidavit-certification__marginLeft___2gACf{margin-left:20px}.src-components-styles-pages-___affidavit-certification__subtitle___19txN{color:#b18433}", ""]);
	
	// exports
	exports.locals = {
		"mainText": "src-components-styles-pages-___affidavit-certification__mainText___1G-0Y",
		"privacyBackround": "src-components-styles-pages-___affidavit-certification__privacyBackround___1fM2C",
		"marginLeft": "src-components-styles-pages-___affidavit-certification__marginLeft___2gACf",
		"subtitle": "src-components-styles-pages-___affidavit-certification__subtitle___19txN"
	};

/***/ },
/* 918 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(24)();
	// imports
	
	
	// module
	exports.push([module.id, ".src-components-styles-pages-___checkout-fail-page__checkoutMsg___wdp1M{color:#b18433;font-weight:700;text-align:center}.src-components-styles-pages-___checkout-fail-page__link___2GXEV{color:#1f73b7;font-weight:700}", ""]);
	
	// exports
	exports.locals = {
		"checkoutMsg": "src-components-styles-pages-___checkout-fail-page__checkoutMsg___wdp1M",
		"link": "src-components-styles-pages-___checkout-fail-page__link___2GXEV"
	};

/***/ },
/* 919 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(24)();
	// imports
	
	
	// module
	exports.push([module.id, ".src-components-styles-pages-___coming-soon__comingContainer___baOvN{width:100%;height:600px;display:flex;flex-flow:column;justify-content:center;align-items:center}.src-components-styles-pages-___coming-soon__comingContainer___baOvN .src-components-styles-pages-___coming-soon__mainText___2UYzA{color:#d3af71;font-family:Lato Bold,Open Sans,serif;font-size:28px;font-weight:600;text-align:center}.src-components-styles-pages-___coming-soon__comingContainer___baOvN .src-components-styles-pages-___coming-soon__secondaryText___GdsTe{font-family:Lato Light,serif;font-size:18px;font-weight:600;line-height:21px;width:400px;text-align:center;padding-top:10px}.src-components-styles-pages-___coming-soon__comingContainer___baOvN .src-components-styles-pages-___coming-soon__secondaryText___GdsTe a{padding:0 5px;color:#d3af71}.src-components-styles-pages-___coming-soon__comingContainer___baOvN .src-components-styles-pages-___coming-soon__buttonLink___Igsde{margin-top:20px;color:#d3af71;font-family:Lato Bold,serif;font-size:18px;font-weight:600}.src-components-styles-pages-___coming-soon__comingContainer___baOvN .src-components-styles-pages-___coming-soon__buttonLink___Igsde:hover{color:#ffa100!important}", ""]);
	
	// exports
	exports.locals = {
		"comingContainer": "src-components-styles-pages-___coming-soon__comingContainer___baOvN",
		"mainText": "src-components-styles-pages-___coming-soon__mainText___2UYzA",
		"secondaryText": "src-components-styles-pages-___coming-soon__secondaryText___GdsTe",
		"buttonLink": "src-components-styles-pages-___coming-soon__buttonLink___Igsde"
	};

/***/ },
/* 920 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(24)();
	// imports
	
	
	// module
	exports.push([module.id, ".src-components-styles-pages-___frequent-questions__accordion___SB7tR{cursor:pointer;color:#000;font-size:15px;padding-top:3px;width:100%;text-align:left}.src-components-styles-pages-___frequent-questions__mainText___1YpEG{padding-top:20px;color:#b18433;text-align:center;font-family:Lato,Open Sans,serif}.src-components-styles-pages-___frequent-questions__privacyBackround___1dGS1{background-color:#fff;padding:30px 100px;margin:20px 0;box-shadow:0 1px 1px 0 rgba(0,0,0,.2)}@media (max-width:991px){.src-components-styles-pages-___frequent-questions__privacyBackround___1dGS1{padding:30px}}.src-components-styles-pages-___frequent-questions__privacyBackround___1dGS1 p{text-align:justify;padding-bottom:10px}.src-components-styles-pages-___frequent-questions__privacyBackround___1dGS1 a{color:#b18433!important}.src-components-styles-pages-___frequent-questions__privacyBackround___1dGS1 a:active,.src-components-styles-pages-___frequent-questions__privacyBackround___1dGS1 a:focus,.src-components-styles-pages-___frequent-questions__privacyBackround___1dGS1 a:hover{color:#9e937e!important}.src-components-styles-pages-___frequent-questions__chevron___3k6he{font-size:20px;color:#000}.src-components-styles-pages-___frequent-questions__opened___1rvHC{display:inline-block}.src-components-styles-pages-___frequent-questions__closed___1RWxs{display:none}", ""]);
	
	// exports
	exports.locals = {
		"accordion": "src-components-styles-pages-___frequent-questions__accordion___SB7tR",
		"mainText": "src-components-styles-pages-___frequent-questions__mainText___1YpEG",
		"privacyBackround": "src-components-styles-pages-___frequent-questions__privacyBackround___1dGS1",
		"chevron": "src-components-styles-pages-___frequent-questions__chevron___3k6he",
		"opened": "src-components-styles-pages-___frequent-questions__opened___1rvHC",
		"closed": "src-components-styles-pages-___frequent-questions__closed___1RWxs"
	};

/***/ },
/* 921 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(24)();
	// imports
	
	
	// module
	exports.push([module.id, ".src-components-styles-pages-___homepage__mainContainer___1VWLO{margin-top:119px}.src-components-styles-pages-___homepage__homepage___35Rzt .src-components-styles-pages-___homepage__bodyContainer___2aXQU{padding-top:10px;margin-top:20px!important;padding-bottom:25px!important}@media (max-width:767px){.src-components-styles-pages-___homepage__homepage___35Rzt .src-components-styles-pages-___homepage__bodyContainer___2aXQU{padding:0 15px;margin:0 7px}}.src-components-styles-pages-___homepage__homepage___35Rzt .src-components-styles-pages-___homepage__colFilters___1E_tL{padding-top:5px;padding-right:5px}@media (max-width:767px){.src-components-styles-pages-___homepage__homepage___35Rzt .src-components-styles-pages-___homepage__colFilters___1E_tL{display:none}}.src-components-styles-pages-___homepage__homepage___35Rzt .src-components-styles-pages-___homepage__productTitle___3QWLv{position:relative;font-family:Lato Bold;font-size:21px;font-weight:700;color:#fff;text-align:center;margin-bottom:8px!important;margin-top:0!important;display:flex;flex-flow:row;justify-content:center}.src-components-styles-pages-___homepage__homepage___35Rzt .src-components-styles-pages-___homepage__productTitle___3QWLv div{position:absolute;margin-top:-1px;margin-left:35px}", ""]);
	
	// exports
	exports.locals = {
		"mainContainer": "src-components-styles-pages-___homepage__mainContainer___1VWLO",
		"homepage": "src-components-styles-pages-___homepage__homepage___35Rzt",
		"bodyContainer": "src-components-styles-pages-___homepage__bodyContainer___2aXQU",
		"colFilters": "src-components-styles-pages-___homepage__colFilters___1E_tL",
		"productTitle": "src-components-styles-pages-___homepage__productTitle___3QWLv"
	};

/***/ },
/* 922 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(24)();
	// imports
	
	
	// module
	exports.push([module.id, ".src-components-styles-pages-___privacy__mainText___2tOSF{padding-top:20px;color:#b18433;text-align:center;font-family:Lato,Open Sans,serif}.src-components-styles-pages-___privacy__privacyBackround___H7COf{background-color:#fff;padding:30px 100px;margin:20px 0;box-shadow:0 1px 1px 0 rgba(0,0,0,.2)}@media (max-width:991px){.src-components-styles-pages-___privacy__privacyBackround___H7COf{padding:30px}}.src-components-styles-pages-___privacy__privacyBackround___H7COf p{text-align:justify;padding-bottom:10px}@media (max-width:991px){.src-components-styles-pages-___privacy__tableResponsive___3ib-F{overflow-x:scroll;width:100%}}.src-components-styles-pages-___privacy__accordion___zxN6X{cursor:pointer;color:#000;font-size:15px;padding-top:3px;width:100%;text-align:left}.src-components-styles-pages-___privacy__detailColumn___2jtw7{max-width:200px}", ""]);
	
	// exports
	exports.locals = {
		"mainText": "src-components-styles-pages-___privacy__mainText___2tOSF",
		"privacyBackround": "src-components-styles-pages-___privacy__privacyBackround___H7COf",
		"tableResponsive": "src-components-styles-pages-___privacy__tableResponsive___3ib-F",
		"accordion": "src-components-styles-pages-___privacy__accordion___zxN6X",
		"detailColumn": "src-components-styles-pages-___privacy__detailColumn___2jtw7"
	};

/***/ },
/* 923 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(24)();
	// imports
	
	
	// module
	exports.push([module.id, ".src-components-styles-pages-___product-list__productList___1dVrG{min-height:500px}.src-components-styles-pages-___product-list__productList___1dVrG .src-components-styles-pages-___product-list__bodyContainer___2jJoe{padding-top:0!important;padding-bottom:40px}@media (max-width:768px){.src-components-styles-pages-___product-list__productList___1dVrG .src-components-styles-pages-___product-list__bodyContainer___2jJoe{padding:0 10px;margin:0 15px}}.src-components-styles-pages-___product-list__productList___1dVrG .src-components-styles-pages-___product-list__colFilters___3wzEn{margin-top:30px;padding-right:5px}@media (max-width:767px){.src-components-styles-pages-___product-list__productList___1dVrG .src-components-styles-pages-___product-list__colFilters___3wzEn{display:none}}.src-components-styles-pages-___product-list__productList___1dVrG .src-components-styles-pages-___product-list__contentCategory___1HxkP{margin-top:30px}.src-components-styles-pages-___product-list__productList___1dVrG .src-components-styles-pages-___product-list__titleSection___1u7Nt{line-height:0;margin-top:10px!important;font-family:Lato Bold;font-weight:700;font-size:21px;color:#fff;text-align:center;margin-left:-10px}.src-components-styles-pages-___product-list__productList___1dVrG .src-components-styles-pages-___product-list__titleSection___1u7Nt span:not(:first-child){color:#fff;padding-left:5px}.src-components-styles-pages-___product-list__productList___1dVrG .src-components-styles-pages-___product-list__productTitle___10LEb{position:relative;font-family:Lato Bold,serif;font-size:21px;color:#d3af71;text-align:center;margin-bottom:0!important;margin-top:0!important;display:flex;flex-flow:row;justify-content:center}.src-components-styles-pages-___product-list__productList___1dVrG .src-components-styles-pages-___product-list__productTitle___10LEb div{position:relative;margin-top:-1px;margin-left:5px}.src-components-styles-pages-___product-list__productList___1dVrG .src-components-styles-pages-___product-list__loadingText___pNdGb{font-family:Lato Bold!important;font-weight:700!important;font-size:18px;margin-top:8.5px;margin-bottom:8.5px;line-height:1.1;color:inherit;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;color:#fff}", ""]);
	
	// exports
	exports.locals = {
		"productList": "src-components-styles-pages-___product-list__productList___1dVrG",
		"bodyContainer": "src-components-styles-pages-___product-list__bodyContainer___2jJoe",
		"colFilters": "src-components-styles-pages-___product-list__colFilters___3wzEn",
		"contentCategory": "src-components-styles-pages-___product-list__contentCategory___1HxkP",
		"titleSection": "src-components-styles-pages-___product-list__titleSection___1u7Nt",
		"productTitle": "src-components-styles-pages-___product-list__productTitle___10LEb",
		"loadingText": "src-components-styles-pages-___product-list__loadingText___pNdGb"
	};

/***/ },
/* 924 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(24)();
	// imports
	
	
	// module
	exports.push([module.id, ".src-components-styles-pages-___product-show__productShow___31oZy{display:block}.src-components-styles-pages-___product-show__productShow___31oZy .src-components-styles-pages-___product-show__productContent___DFO58{height:auto;position:relative}.src-components-styles-pages-___product-show__productShow___31oZy .src-components-styles-pages-___product-show__productContainer___3Sy22{padding-top:10px;padding-bottom:40px}.src-components-styles-pages-___product-show__productShow___31oZy .src-components-styles-pages-___product-show__breadcrumbContent___3z91s{font-family:Lato!important}.src-components-styles-pages-___product-show__productShow___31oZy .src-components-styles-pages-___product-show__productResume___kBXoV{padding:15px;margin-top:20px;background-color:#fff;display:block;min-height:540px}.src-components-styles-pages-___product-show__productShow___31oZy .src-components-styles-pages-___product-show__imgMain___1dQiN,.src-components-styles-pages-___product-show__productShow___31oZy .src-components-styles-pages-___product-show__overlay___nJ2qt{position:relative}.src-components-styles-pages-___product-show__productShow___31oZy .src-components-styles-pages-___product-show__loadingHolder___2in2V{position:absolute;width:100%;margin-top:120px}.src-components-styles-pages-___product-show__productShow___31oZy .src-components-styles-pages-___product-show__loadingText___30Zop{text-align:center!important;font-family:Lato Bold!important;font-size:18px;font-weight:700!important;margin-top:8.5px;margin-bottom:8.5px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;line-height:1.1;color:inherit}.src-components-styles-pages-___product-show__productShow___31oZy .src-components-styles-pages-___product-show__mainImage___25UKL{width:100%;height:374px;display:flex;justify-content:center}.src-components-styles-pages-___product-show__productShow___31oZy .src-components-styles-pages-___product-show__mainImage___25UKL img{max-width:444px}.src-components-styles-pages-___product-show__productShow___31oZy .src-components-styles-pages-___product-show__productMainImage___25wLm{width:100%;min-height:400px;height:374px;display:block;vertical-align:middle}.src-components-styles-pages-___product-show__productShow___31oZy .src-components-styles-pages-___product-show__zoomHolder___NH6TO{display:block;position:absolute;z-index:10!important;background-color:rgba(0,0,0,.06);top:10px;right:10px;color:#18396c;padding:5px 7px;border-radius:50%!important;cursor:pointer}@media (max-width:991px){.src-components-styles-pages-___product-show__productShow___31oZy .src-components-styles-pages-___product-show__zoomHolder___NH6TO{display:none}}.src-components-styles-pages-___product-show__productShow___31oZy .src-components-styles-pages-___product-show__zoomHolder___NH6TO:hover{background-color:rgba(0,0,0,.1)}.src-components-styles-pages-___product-show__productShow___31oZy .src-components-styles-pages-___product-show__zoomHolder___NH6TO:hover i{color:#d3af71}.src-components-styles-pages-___product-show__productShow___31oZy .src-components-styles-pages-___product-show__zoomHolder___NH6TO i{font-size:16px;font-weight:700}.src-components-styles-pages-___product-show__productShow___31oZy .src-components-styles-pages-___product-show__zoomHolder___NH6TO i:before{position:relative;top:1px}.src-components-styles-pages-___product-show__productShow___31oZy .src-components-styles-pages-___product-show__zoomActived___2d8K_{background-color:rgba(0,0,0,.2)}.src-components-styles-pages-___product-show__productShow___31oZy .src-components-styles-pages-___product-show__imgLoadingContainer___2RJ4P{position:absolute;text-align:center;font-family:Lato Light,Enriqueta,Helvetica Neue,Helvetica,Arial,sans-serif;font-size:14px;top:50%;left:50%;transform:translate(-50%,-50%)}.src-components-styles-pages-___product-show__productShow___31oZy .src-components-styles-pages-___product-show__resume___q1LcX{padding-right:0!important}.src-components-styles-pages-___product-show__productShow___31oZy .src-components-styles-pages-___product-show__form___2Vca6{height:auto;display:block;margin-top:0;color:#000}.src-components-styles-pages-___product-show__productShow___31oZy .src-components-styles-pages-___product-show__form___2Vca6 a:hover{color:#b18433}.src-components-styles-pages-___product-show__productShow___31oZy .src-components-styles-pages-___product-show__productName___1cXOi{font-family:Lato Bold!important;font-size:30px;font-weight:700!important;margin-top:17px;margin-bottom:8.5px;padding-right:15px!important;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;line-height:1.1;color:inherit}.src-components-styles-pages-___product-show__productShow___31oZy .src-components-styles-pages-___product-show__flexDisplay___3l1_3{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;padding-right:15px!important}.src-components-styles-pages-___product-show__productShow___31oZy .src-components-styles-pages-___product-show__firstCommentLink___3dL2_{color:#d3af71!important;font-size:16px!important;font-family:Lato Bold!important;background-color:transparent!important;transition:color .15s ease-out,background-color .15s ease-out;cursor:pointer;text-decoration:none}.src-components-styles-pages-___product-show__productShow___31oZy .src-components-styles-pages-___product-show__reviewCount___rFd6O{font-family:Lato Light!important;font-weight:600;font-size:16px!important;margin:0 0 8.5px;margin-bottom:5px!important}.src-components-styles-pages-___product-show__productShow___31oZy .src-components-styles-pages-___product-show__margins___10-XE{margin-left:5px!important;margin-right:5px!important}.src-components-styles-pages-___product-show__productShow___31oZy .src-components-styles-pages-___product-show__productRating___1zkoW{margin-right:20px!important;float:left!important}.src-components-styles-pages-___product-show__productShow___31oZy .src-components-styles-pages-___product-show__ratingDirective___2DXtz{display:inline-block;margin:0}.src-components-styles-pages-___product-show__productShow___31oZy .src-components-styles-pages-___product-show__noPadding___1fsct{padding:0!important}.src-components-styles-pages-___product-show__productShow___31oZy .src-components-styles-pages-___product-show__ratingHolder___1QWTV{position:relative}.src-components-styles-pages-___product-show__productShow___31oZy .src-components-styles-pages-___product-show__ratings___XNIEB{position:relative;vertical-align:middle;display:inline-block;color:#ababab;overflow:hidden}.src-components-styles-pages-___product-show__productShow___31oZy .src-components-styles-pages-___product-show__emptyStars___3HHJ3:before{-webkit-text-stroke:1px #ababab;content:\"\\2605\\2605\\2605\\2605\\2605\";font-size:16pt}.src-components-styles-pages-___product-show__productShow___31oZy .src-components-styles-pages-___product-show__fullStars___37SrL{position:absolute;left:0;top:0;white-space:nowrap;overflow:hidden;color:#ffa100}.src-components-styles-pages-___product-show__productShow___31oZy .src-components-styles-pages-___product-show__fullStars___37SrL:before{-webkit-text-stroke:1px #ffa100;content:\"\\2605\\2605\\2605\\2605\\2605\";font-size:16pt}.src-components-styles-pages-___product-show__productShow___31oZy .src-components-styles-pages-___product-show__separator___1U1Fw{margin-bottom:10px;border-top:1px solid #dfe1e1}.src-components-styles-pages-___product-show__productShow___31oZy .src-components-styles-pages-___product-show__priceDetails___2U4x9{padding-right:15px!important}.src-components-styles-pages-___product-show__productShow___31oZy .src-components-styles-pages-___product-show__priceP___7PQtN{min-height:20px;position:relative!important;margin:0 0 8.5px}.src-components-styles-pages-___product-show__productShow___31oZy .src-components-styles-pages-___product-show__propertyTitle___qmtVv{font-family:Lato Bold;font-size:12px;text-transform:uppercase;line-height:2;letter-spacing:.6px}.src-components-styles-pages-___product-show__productShow___31oZy .src-components-styles-pages-___product-show__price___phToA{font-size:20px;font-family:Lato Bold;font-weight:700;color:#000;line-height:.9;margin-left:25px!important}.src-components-styles-pages-___product-show__productShow___31oZy .src-components-styles-pages-___product-show__askQuestion___2SZd1{font-family:Lato Bold;top:4px;color:#5d5d5d;background-color:transparent!important;transition:color .15s ease-out,background-color .15s ease-out;cursor:pointer}.src-components-styles-pages-___product-show__productShow___31oZy .src-components-styles-pages-___product-show__askQuestion___2SZd1 a{color:#d3af71!important}.src-components-styles-pages-___product-show__productShow___31oZy .src-components-styles-pages-___product-show__askQuestion___2SZd1 a:hover{color:#fe9f03!important}.src-components-styles-pages-___product-show__productShow___31oZy .src-components-styles-pages-___product-show__inStock___1SdNA{padding-right:15px!important;padding-bottom:10px!important}.src-components-styles-pages-___product-show__productShow___31oZy .src-components-styles-pages-___product-show__outStock___3W3Va{color:#cb3234}.src-components-styles-pages-___product-show__productShow___31oZy .src-components-styles-pages-___product-show__estimatedArrivalTime___2mpjr{font-family:Lato Light!important;font-weight:600}.src-components-styles-pages-___product-show__productShow___31oZy .src-components-styles-pages-___product-show__itemDetails___3of4o{position:relative;margin-top:18px;margin-bottom:10px;padding-right:15px!important}.src-components-styles-pages-___product-show__productShow___31oZy .src-components-styles-pages-___product-show__itemDetails___3of4o p{font-family:Lato Light!important;font-weight:600}.src-components-styles-pages-___product-show__productShow___31oZy .src-components-styles-pages-___product-show__itemDetailsContent___2yOjJ{white-space:pre-wrap}.src-components-styles-pages-___product-show__productShow___31oZy .src-components-styles-pages-___product-show__itemDetailsContent___2yOjJ b,.src-components-styles-pages-___product-show__productShow___31oZy .src-components-styles-pages-___product-show__itemDetailsContent___2yOjJ strong{font-family:Lato Bold}.src-components-styles-pages-___product-show__productShow___31oZy .src-components-styles-pages-___product-show__itemDetailsTitle___24cze{font-family:Lato Bold;font-size:12px;text-transform:uppercase;line-height:2;letter-spacing:.6px;color:#d3af71!important;margin-bottom:5px!important;text-decoration:none}.src-components-styles-pages-___product-show__productShow___31oZy .src-components-styles-pages-___product-show__itemDetailsTitle___24cze:focus,.src-components-styles-pages-___product-show__productShow___31oZy .src-components-styles-pages-___product-show__itemDetailsTitle___24cze:hover{color:#5d5d5d!important}.src-components-styles-pages-___product-show__productShow___31oZy .src-components-styles-pages-___product-show__listInline___5ggs7{list-style:none;margin:0;padding:0}.src-components-styles-pages-___product-show__productShow___31oZy .src-components-styles-pages-___product-show__listInline___5ggs7 li{display:inline-block;padding-left:5px;padding-right:5px}.src-components-styles-pages-___product-show__productShow___31oZy .src-components-styles-pages-___product-show__listInline___5ggs7 li img{vertical-align:middle;-o-object-fit:contain;object-fit:contain;o-object-fit:contain}.src-components-styles-pages-___product-show__productShow___31oZy .src-components-styles-pages-___product-show__imageWrapper___1v3OV{position:relative;padding:0;-ms-touch-action:pan-y;touch-action:pan-y;background:#fff;max-width:100%;margin-bottom:0;box-shadow:none;border:0}.src-components-styles-pages-___product-show__productShow___31oZy .src-components-styles-pages-___product-show__imageViewport___1chlT{width:100%;position:relative;height:374px;min-height:256px;transition:height .15s ease}.src-components-styles-pages-___product-show__productShow___31oZy .src-components-styles-pages-___product-show__imageSlider___1enzt{position:relative;transition-duration:0s;height:374px;margin:0;padding:0;list-style:none;display:flex;flex-flow:row}.src-components-styles-pages-___product-show__productShow___31oZy .src-components-styles-pages-___product-show__imageSlider___1enzt li{float:left;list-style:none;position:relative;height:100%}.src-components-styles-pages-___product-show__productShow___31oZy .src-components-styles-pages-___product-show__image___17DUs{margin:auto;height:100%;-o-object-fit:contain;object-fit:contain;min-height:185px;max-width:100%;width:100%;vertical-align:middle;display:flex;justify-content:center;align-items:center;transition:all 1s ease-in-out;opacity:0;-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\";filter:alpha(opacity=0)}.src-components-styles-pages-___product-show__productShow___31oZy .src-components-styles-pages-___product-show__image___17DUs img{width:0!important}.src-components-styles-pages-___product-show__productShow___31oZy .src-components-styles-pages-___product-show__activeImage___voeXk{opacity:1;-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=1)\";filter:alpha(opacity=1)}.src-components-styles-pages-___product-show__productShow___31oZy .src-components-styles-pages-___product-show__activeImage___voeXk img{width:auto!important}.src-components-styles-pages-___product-show__productShow___31oZy .src-components-styles-pages-___product-show__thumbnailContainer___20QNH{padding:0}.src-components-styles-pages-___product-show__productShow___31oZy .src-components-styles-pages-___product-show__thumbnail___3iG5k{display:block;padding:0;line-height:1.42857143;background-color:#fff;border:1px solid #edf0f7;transition:border .2s ease-in-out;cursor:pointer;margin:1px}.src-components-styles-pages-___product-show__productShow___31oZy .src-components-styles-pages-___product-show__thumbnail___3iG5k:hover{border:1px solid #969bb3}.src-components-styles-pages-___product-show__productShow___31oZy .src-components-styles-pages-___product-show__productThumbs___1VzGO{object-fit:contain;width:100%;height:140px}", ""]);
	
	// exports
	exports.locals = {
		"productShow": "src-components-styles-pages-___product-show__productShow___31oZy",
		"productContent": "src-components-styles-pages-___product-show__productContent___DFO58",
		"productContainer": "src-components-styles-pages-___product-show__productContainer___3Sy22",
		"breadcrumbContent": "src-components-styles-pages-___product-show__breadcrumbContent___3z91s",
		"productResume": "src-components-styles-pages-___product-show__productResume___kBXoV",
		"imgMain": "src-components-styles-pages-___product-show__imgMain___1dQiN",
		"overlay": "src-components-styles-pages-___product-show__overlay___nJ2qt",
		"loadingHolder": "src-components-styles-pages-___product-show__loadingHolder___2in2V",
		"loadingText": "src-components-styles-pages-___product-show__loadingText___30Zop",
		"mainImage": "src-components-styles-pages-___product-show__mainImage___25UKL",
		"productMainImage": "src-components-styles-pages-___product-show__productMainImage___25wLm",
		"zoomHolder": "src-components-styles-pages-___product-show__zoomHolder___NH6TO",
		"zoomActived": "src-components-styles-pages-___product-show__zoomActived___2d8K_",
		"imgLoadingContainer": "src-components-styles-pages-___product-show__imgLoadingContainer___2RJ4P",
		"resume": "src-components-styles-pages-___product-show__resume___q1LcX",
		"form": "src-components-styles-pages-___product-show__form___2Vca6",
		"productName": "src-components-styles-pages-___product-show__productName___1cXOi",
		"flexDisplay": "src-components-styles-pages-___product-show__flexDisplay___3l1_3",
		"firstCommentLink": "src-components-styles-pages-___product-show__firstCommentLink___3dL2_",
		"reviewCount": "src-components-styles-pages-___product-show__reviewCount___rFd6O",
		"margins": "src-components-styles-pages-___product-show__margins___10-XE",
		"productRating": "src-components-styles-pages-___product-show__productRating___1zkoW",
		"ratingDirective": "src-components-styles-pages-___product-show__ratingDirective___2DXtz",
		"noPadding": "src-components-styles-pages-___product-show__noPadding___1fsct",
		"ratingHolder": "src-components-styles-pages-___product-show__ratingHolder___1QWTV",
		"ratings": "src-components-styles-pages-___product-show__ratings___XNIEB",
		"emptyStars": "src-components-styles-pages-___product-show__emptyStars___3HHJ3",
		"fullStars": "src-components-styles-pages-___product-show__fullStars___37SrL",
		"separator": "src-components-styles-pages-___product-show__separator___1U1Fw",
		"priceDetails": "src-components-styles-pages-___product-show__priceDetails___2U4x9",
		"priceP": "src-components-styles-pages-___product-show__priceP___7PQtN",
		"propertyTitle": "src-components-styles-pages-___product-show__propertyTitle___qmtVv",
		"price": "src-components-styles-pages-___product-show__price___phToA",
		"askQuestion": "src-components-styles-pages-___product-show__askQuestion___2SZd1",
		"inStock": "src-components-styles-pages-___product-show__inStock___1SdNA",
		"outStock": "src-components-styles-pages-___product-show__outStock___3W3Va",
		"estimatedArrivalTime": "src-components-styles-pages-___product-show__estimatedArrivalTime___2mpjr",
		"itemDetails": "src-components-styles-pages-___product-show__itemDetails___3of4o",
		"itemDetailsContent": "src-components-styles-pages-___product-show__itemDetailsContent___2yOjJ",
		"itemDetailsTitle": "src-components-styles-pages-___product-show__itemDetailsTitle___24cze",
		"listInline": "src-components-styles-pages-___product-show__listInline___5ggs7",
		"imageWrapper": "src-components-styles-pages-___product-show__imageWrapper___1v3OV",
		"imageViewport": "src-components-styles-pages-___product-show__imageViewport___1chlT",
		"imageSlider": "src-components-styles-pages-___product-show__imageSlider___1enzt",
		"image": "src-components-styles-pages-___product-show__image___17DUs",
		"activeImage": "src-components-styles-pages-___product-show__activeImage___voeXk",
		"thumbnailContainer": "src-components-styles-pages-___product-show__thumbnailContainer___20QNH",
		"thumbnail": "src-components-styles-pages-___product-show__thumbnail___3iG5k",
		"productThumbs": "src-components-styles-pages-___product-show__productThumbs___1VzGO"
	};

/***/ },
/* 925 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(24)();
	// imports
	
	
	// module
	exports.push([module.id, ".src-components-styles-pages-___return-policy__mainText___Ur4b9{padding-top:20px;color:#b18433;text-align:center;font-family:Lato,Open Sans,serif}.src-components-styles-pages-___return-policy__privacyBackround___3WASb{background-color:#fff;padding:30px 100px;margin:20px 0;box-shadow:0 1px 1px 0 rgba(0,0,0,.2)}@media (max-width:991px){.src-components-styles-pages-___return-policy__privacyBackround___3WASb{padding:30px}}.src-components-styles-pages-___return-policy__privacyBackround___3WASb p{text-align:justify;padding-bottom:10px}.src-components-styles-pages-___return-policy__subtitle___1OuHJ{color:#b18433}", ""]);
	
	// exports
	exports.locals = {
		"mainText": "src-components-styles-pages-___return-policy__mainText___Ur4b9",
		"privacyBackround": "src-components-styles-pages-___return-policy__privacyBackround___3WASb",
		"subtitle": "src-components-styles-pages-___return-policy__subtitle___1OuHJ"
	};

/***/ },
/* 926 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(24)();
	// imports
	
	
	// module
	exports.push([module.id, ".src-components-styles-pages-___shipping-policy__mainText___1ZaE_{padding-top:20px;color:#b18433;text-align:center;font-family:Lato,Open Sans,serif}.src-components-styles-pages-___shipping-policy__privacyBackround___2KL0D{background-color:#fff;padding:30px 100px;margin:20px 0;box-shadow:0 1px 1px 0 rgba(0,0,0,.2)}@media (max-width:991px){.src-components-styles-pages-___shipping-policy__privacyBackround___2KL0D{padding:30px}}.src-components-styles-pages-___shipping-policy__privacyBackround___2KL0D p{text-align:justify;padding-bottom:10px}.src-components-styles-pages-___shipping-policy__privacyBackround___2KL0D a{color:#b18433!important}.src-components-styles-pages-___shipping-policy__privacyBackround___2KL0D a:active,.src-components-styles-pages-___shipping-policy__privacyBackround___2KL0D a:focus,.src-components-styles-pages-___shipping-policy__privacyBackround___2KL0D a:hover{color:#9e937e!important}@media (max-width:991px){.src-components-styles-pages-___shipping-policy__tableResponsive___rzvD3{overflow-x:scroll;width:100%}}.src-components-styles-pages-___shipping-policy__subtitle___oB5g_{color:#b18433}", ""]);
	
	// exports
	exports.locals = {
		"mainText": "src-components-styles-pages-___shipping-policy__mainText___1ZaE_",
		"privacyBackround": "src-components-styles-pages-___shipping-policy__privacyBackround___2KL0D",
		"tableResponsive": "src-components-styles-pages-___shipping-policy__tableResponsive___rzvD3",
		"subtitle": "src-components-styles-pages-___shipping-policy__subtitle___oB5g_"
	};

/***/ },
/* 927 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(24)();
	// imports
	
	
	// module
	exports.push([module.id, ".src-components-styles-pages-___show-stores__headerBanner___2lSQZ{width:100%;object-fit:cover;height:400px}@media only screen and (max-width:600px){.src-components-styles-pages-___show-stores__headerBanner___2lSQZ{height:200px;margin-top:70px}}.src-components-styles-pages-___show-stores__container___1T3Mg{padding:25px 340px}@media only screen and (max-width:1024px){.src-components-styles-pages-___show-stores__container___1T3Mg{padding:0}}.src-components-styles-pages-___show-stores__container___1T3Mg .src-components-styles-pages-___show-stores__storesContainer___4x0RF{margin-top:20px;padding-right:15px}@media only screen and (max-width:600px){.src-components-styles-pages-___show-stores__container___1T3Mg .src-components-styles-pages-___show-stores__storesContainer___4x0RF{display:flex;justify-content:flex-end}}.src-components-styles-pages-___show-stores__container___1T3Mg .src-components-styles-pages-___show-stores__storesContainer___4x0RF .src-components-styles-pages-___show-stores__zoneSelector___Dvbnk{display:flex;justify-content:flex-end}.src-components-styles-pages-___show-stores__container___1T3Mg .src-components-styles-pages-___show-stores__storesContainer___4x0RF .src-components-styles-pages-___show-stores__zoneSelector___Dvbnk .src-components-styles-pages-___show-stores__zoneSelectorButton___Cffq5{height:30px;padding:0 10px;font-size:16px;line-height:30px}.src-components-styles-pages-___show-stores__container___1T3Mg .src-components-styles-pages-___show-stores__storeCard___1ZsqD{display:flex;flex-direction:column;align-items:center;justify-content:center;border:1px solid #d3d3d3;background-color:#fff;width:207px;height:200px;margin:14px;padding:10px}@media only screen and (max-width:600px){.src-components-styles-pages-___show-stores__container___1T3Mg .src-components-styles-pages-___show-stores__storeCard___1ZsqD{width:130px;height:185px}}.src-components-styles-pages-___show-stores__container___1T3Mg .src-components-styles-pages-___show-stores__storeCard___1ZsqD .src-components-styles-pages-___show-stores__storeTileCard___2vAjw{height:90px;width:90px;border-radius:45px;margin-bottom:10px}.src-components-styles-pages-___show-stores__container___1T3Mg .src-components-styles-pages-___show-stores__storeCard___1ZsqD .src-components-styles-pages-___show-stores__storeTileText___2jaPj{color:#d3af71;font-weight:700}.src-components-styles-pages-___show-stores__container___1T3Mg .src-components-styles-pages-___show-stores__mostVisitedContainer___227fK{display:flex;flex-direction:column;align-items:center;margin-top:25px}.src-components-styles-pages-___show-stores__container___1T3Mg .src-components-styles-pages-___show-stores__mostVisitedContainer___227fK .src-components-styles-pages-___show-stores__mostVisitedHeader___1aflh{color:#d3af71;font-weight:700;font-size:28px}.src-components-styles-pages-___show-stores__container___1T3Mg .src-components-styles-pages-___show-stores__mostVisitedContainer___227fK .src-components-styles-pages-___show-stores__mostVisitedStores___Z1qq6{margin-top:25px}.src-components-styles-pages-___show-stores__container___1T3Mg .src-components-styles-pages-___show-stores__mostVisitedContainer___227fK .src-components-styles-pages-___show-stores__mostVisitedStores___Z1qq6 .src-components-styles-pages-___show-stores__storeTile___2cMdH{height:90px;width:90px;border-radius:45px;margin-left:20px}.src-components-styles-pages-___show-stores__container___1T3Mg .src-components-styles-pages-___show-stores__allStoresContainer___2PJ7j{display:flex;flex-direction:column;align-items:center;margin-top:75px}.src-components-styles-pages-___show-stores__container___1T3Mg .src-components-styles-pages-___show-stores__allStoresContainer___2PJ7j .src-components-styles-pages-___show-stores__allStoresHeader___34fwL{color:#d3af71;font-weight:700;font-size:28px}.src-components-styles-pages-___show-stores__container___1T3Mg .src-components-styles-pages-___show-stores__allStoresContainer___2PJ7j .src-components-styles-pages-___show-stores__allStoresWrapper___39UP8{display:flex;flex-wrap:wrap;justify-content:space-between}@media only screen and (max-width:600px){.src-components-styles-pages-___show-stores__container___1T3Mg .src-components-styles-pages-___show-stores__allStoresContainer___2PJ7j .src-components-styles-pages-___show-stores__allStoresWrapper___39UP8{justify-content:center}}.src-components-styles-pages-___show-stores__container___1T3Mg .src-components-styles-pages-___show-stores__allStoresContainer___2PJ7j .src-components-styles-pages-___show-stores__paginatorBottomContainer___DgQbt{display:flex;width:100%;justify-content:space-between;align-items:center;padding:0 16px}@media only screen and (max-width:600px){.src-components-styles-pages-___show-stores__container___1T3Mg .src-components-styles-pages-___show-stores__allStoresContainer___2PJ7j .src-components-styles-pages-___show-stores__paginatorBottomContainer___DgQbt{flex-wrap:wrap;justify-content:center}}", ""]);
	
	// exports
	exports.locals = {
		"headerBanner": "src-components-styles-pages-___show-stores__headerBanner___2lSQZ",
		"container": "src-components-styles-pages-___show-stores__container___1T3Mg",
		"storesContainer": "src-components-styles-pages-___show-stores__storesContainer___4x0RF",
		"zoneSelector": "src-components-styles-pages-___show-stores__zoneSelector___Dvbnk",
		"zoneSelectorButton": "src-components-styles-pages-___show-stores__zoneSelectorButton___Cffq5",
		"storeCard": "src-components-styles-pages-___show-stores__storeCard___1ZsqD",
		"storeTileCard": "src-components-styles-pages-___show-stores__storeTileCard___2vAjw",
		"storeTileText": "src-components-styles-pages-___show-stores__storeTileText___2jaPj",
		"mostVisitedContainer": "src-components-styles-pages-___show-stores__mostVisitedContainer___227fK",
		"mostVisitedHeader": "src-components-styles-pages-___show-stores__mostVisitedHeader___1aflh",
		"mostVisitedStores": "src-components-styles-pages-___show-stores__mostVisitedStores___Z1qq6",
		"storeTile": "src-components-styles-pages-___show-stores__storeTile___2cMdH",
		"allStoresContainer": "src-components-styles-pages-___show-stores__allStoresContainer___2PJ7j",
		"allStoresHeader": "src-components-styles-pages-___show-stores__allStoresHeader___34fwL",
		"allStoresWrapper": "src-components-styles-pages-___show-stores__allStoresWrapper___39UP8",
		"paginatorBottomContainer": "src-components-styles-pages-___show-stores__paginatorBottomContainer___DgQbt"
	};

/***/ },
/* 928 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(24)();
	// imports
	
	
	// module
	exports.push([module.id, ".src-components-styles-pages-___signin__signin___OU2ah ::-webkit-input-placeholder{color:#dfe1e1;font-size:14px}.src-components-styles-pages-___signin__signin___OU2ah ::-moz-placeholder{color:#dfe1e1}.src-components-styles-pages-___signin__signin___OU2ah :-ms-input-placeholder{color:#dfe1e1}.src-components-styles-pages-___signin__signin___OU2ah :-moz-placeholder{color:#dfe1e1}.src-components-styles-pages-___signin__signin___OU2ah .src-components-styles-pages-___signin__bodyContainer___2Rq8Y{padding-top:20px;padding-bottom:40px}.src-components-styles-pages-___signin__signin___OU2ah .src-components-styles-pages-___signin__titlePage___ufaTE{font-family:Lato Bold;line-height:24px;color:#d3af71;text-align:center;margin:10px 0 15px;font-size:20px;font-weight:700;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.src-components-styles-pages-___signin__signin___OU2ah .src-components-styles-pages-___signin__form___38Cs3{border:1px solid #dfe1e1;border-top-color:#d3af71;max-width:600px;margin:0 auto;background-color:#fff;padding:30px 35px}.src-components-styles-pages-___signin__signin___OU2ah .src-components-styles-pages-___signin__formGroup___HGRJB{position:relative;margin-left:-15px;margin-right:-15px;margin-bottom:10px}.src-components-styles-pages-___signin__signin___OU2ah .src-components-styles-pages-___signin__formGroup___HGRJB:before{content:\" \";display:table;box-sizing:border-box}.src-components-styles-pages-___signin__signin___OU2ah .src-components-styles-pages-___signin__formGroup___HGRJB:after{clear:both;content:\" \";display:table;box-sizing:border-box}.src-components-styles-pages-___signin__signin___OU2ah .src-components-styles-pages-___signin__formGroupHolder___32Te9{border-top:1px solid #dfe1e1;border-bottom:3px double #dfe1e1;background-color:#fff;padding:25px 35px 15px;margin:0 -35px;text-align:center;position:relative}.src-components-styles-pages-___signin__signin___OU2ah .src-components-styles-pages-___signin__formGroupHolder___32Te9 button{font-family:Arial;font-size:16px;line-height:23px;color:#fff;background:#d3af71;border:1px solid #d3af71;border-radius:20px!important;box-shadow:none!important;width:100%;height:35px;margin-bottom:10px;display:inline-block;font-weight:400;text-align:center;vertical-align:middle;-ms-touch-action:manipulation;touch-action:manipulation;cursor:pointer;white-space:nowrap;padding:4px 12px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;outline:none!important;outline-offset:0!important}.src-components-styles-pages-___signin__signin___OU2ah .src-components-styles-pages-___signin__formGroupHolder___32Te9 button:hover{background:transparent;color:#d3af71;border-color:#d3af71}.src-components-styles-pages-___signin__signin___OU2ah .src-components-styles-pages-___signin__formGroupHolder___32Te9 button:active{color:#fff;background-color:#ffa100;border-color:#ffa100}@media (min-width:768px){.src-components-styles-pages-___signin__signin___OU2ah .src-components-styles-pages-___signin__formGroupHolder___32Te9 button{max-width:200px}}.src-components-styles-pages-___signin__signin___OU2ah .src-components-styles-pages-___signin__inputGroupEdited___2KDS-{position:relative}.src-components-styles-pages-___signin__signin___OU2ah .src-components-styles-pages-___signin__fieldError___2fBLD{color:\"darkred\"}.src-components-styles-pages-___signin__signin___OU2ah .src-components-styles-pages-___signin__formInput___1Z9YL{height:40px;border-radius:20px!important;font-family:Lato;font-size:16px;background-color:#fff;border:1px solid #dfe1e1;width:100%;padding:5px 20px;margin:0 0 10px;box-shadow:none!important;color:#5d5d5d;display:block;line-height:1.25;background-image:none;transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out}.src-components-styles-pages-___signin__signin___OU2ah .src-components-styles-pages-___signin__formInput___1Z9YL:focus{border-color:#d3af71}.src-components-styles-pages-___signin__signin___OU2ah .src-components-styles-pages-___signin__eyeIcon___MFGGQ{cursor:pointer}.src-components-styles-pages-___signin__signin___OU2ah .src-components-styles-pages-___signin__eyeIcon___MFGGQ:focus,.src-components-styles-pages-___signin__signin___OU2ah .src-components-styles-pages-___signin__eyeIcon___MFGGQ:hover{color:#d3af71}.src-components-styles-pages-___signin__signin___OU2ah .src-components-styles-pages-___signin__togglePassword___dBgJm{color:#dfe1e1;position:absolute;right:28px;top:13px;transition:border-color .3s ease;background-color:transparent!important}.src-components-styles-pages-___signin__signin___OU2ah .src-components-styles-pages-___signin__rememberMe___3Kuay{margin-left:15px;margin-top:5px}.src-components-styles-pages-___signin__signin___OU2ah .src-components-styles-pages-___signin__rememberMe___3Kuay label{font-family:Lato;padding:0;display:inline-block;max-width:100%;margin-bottom:5px;cursor:pointer}.src-components-styles-pages-___signin__signin___OU2ah .src-components-styles-pages-___signin__rememberMe___3Kuay label.src-components-styles-pages-___signin__active___2BmLy{color:#d3af71;font-weight:400}.src-components-styles-pages-___signin__signin___OU2ah .src-components-styles-pages-___signin__rememberMe___3Kuay label.src-components-styles-pages-___signin__active___2BmLy div{background-position:-22px 0}.src-components-styles-pages-___signin__signin___OU2ah .src-components-styles-pages-___signin__checkbox___2rTmc{position:relative;display:inline-block;vertical-align:middle;margin:-4px 0 0;padding:0;width:20px;height:20px;background-image:url(" + __webpack_require__(1616) + ");background-repeat:no-repeat;border:none;cursor:pointer}.src-components-styles-pages-___signin__signin___OU2ah .src-components-styles-pages-___signin__iCheckHelper___3cpwj{position:absolute;top:0;left:0;display:block;width:100%;height:100%;margin:0;padding:0;background:#fff;border:0;opacity:0}.src-components-styles-pages-___signin__signin___OU2ah .src-components-styles-pages-___signin__rememberMeLabel___3HrD- span{padding-left:6px}.src-components-styles-pages-___signin__signin___OU2ah .src-components-styles-pages-___signin__forgotLinkContainer___1RyNl{margin-top:30px}.src-components-styles-pages-___signin__signin___OU2ah .src-components-styles-pages-___signin__forgotLinkContainer___1RyNl span{font-family:Lato Bold;font-weight:400;font-size:16px;line-height:18.08px;color:#d3af71!important;display:inline-block!important;text-align:center!important;width:100%!important;background-color:transparent!important;transition:color .15s ease-out,background-color .15s ease-out;cursor:pointer}.src-components-styles-pages-___signin__signin___OU2ah .src-components-styles-pages-___signin__registerContainer___3lqZq h5{font-family:Lato Bold;font-weight:400;color:#18396c;text-align:center;margin:10px 0 0;font-size:16px;line-height:18.08px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.src-components-styles-pages-___signin__signin___OU2ah .src-components-styles-pages-___signin__registerContainer___3lqZq h5 a{color:#d3af71!important;padding-left:7px;font-weight:400}.src-components-styles-pages-___signin__signin___OU2ah .src-components-styles-pages-___signin__registerContainer___3lqZq h5 a:hover{color:#5d5d5d!important}", ""]);
	
	// exports
	exports.locals = {
		"signin": "src-components-styles-pages-___signin__signin___OU2ah",
		"bodyContainer": "src-components-styles-pages-___signin__bodyContainer___2Rq8Y",
		"titlePage": "src-components-styles-pages-___signin__titlePage___ufaTE",
		"form": "src-components-styles-pages-___signin__form___38Cs3",
		"formGroup": "src-components-styles-pages-___signin__formGroup___HGRJB",
		"formGroupHolder": "src-components-styles-pages-___signin__formGroupHolder___32Te9",
		"inputGroupEdited": "src-components-styles-pages-___signin__inputGroupEdited___2KDS-",
		"fieldError": "src-components-styles-pages-___signin__fieldError___2fBLD",
		"formInput": "src-components-styles-pages-___signin__formInput___1Z9YL",
		"eyeIcon": "src-components-styles-pages-___signin__eyeIcon___MFGGQ",
		"togglePassword": "src-components-styles-pages-___signin__togglePassword___dBgJm",
		"rememberMe": "src-components-styles-pages-___signin__rememberMe___3Kuay",
		"active": "src-components-styles-pages-___signin__active___2BmLy",
		"checkbox": "src-components-styles-pages-___signin__checkbox___2rTmc",
		"iCheckHelper": "src-components-styles-pages-___signin__iCheckHelper___3cpwj",
		"rememberMeLabel": "src-components-styles-pages-___signin__rememberMeLabel___3HrD-",
		"forgotLinkContainer": "src-components-styles-pages-___signin__forgotLinkContainer___1RyNl",
		"registerContainer": "src-components-styles-pages-___signin__registerContainer___3lqZq"
	};

/***/ },
/* 929 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(24)();
	// imports
	
	
	// module
	exports.push([module.id, ".src-components-styles-pages-___terms-conditions__mainText___LFeF2{padding-top:20px;color:#b18433;text-align:center;font-family:Lato,Open Sans,serif}.src-components-styles-pages-___terms-conditions__privacyBackround___kp9db{background-color:#fff;padding:30px 100px;margin:20px 0;box-shadow:0 1px 1px 0 rgba(0,0,0,.2)}@media (max-width:991px){.src-components-styles-pages-___terms-conditions__privacyBackround___kp9db{padding:30px}}.src-components-styles-pages-___terms-conditions__privacyBackround___kp9db p{text-align:justify;padding-bottom:10px}.src-components-styles-pages-___terms-conditions__privacyBackround___kp9db a{color:#b18433!important}.src-components-styles-pages-___terms-conditions__privacyBackround___kp9db a:active,.src-components-styles-pages-___terms-conditions__privacyBackround___kp9db a:focus,.src-components-styles-pages-___terms-conditions__privacyBackround___kp9db a:hover{color:#9e937e!important}.src-components-styles-pages-___terms-conditions__subtitle___36G7C{color:#b18433}", ""]);
	
	// exports
	exports.locals = {
		"mainText": "src-components-styles-pages-___terms-conditions__mainText___LFeF2",
		"privacyBackround": "src-components-styles-pages-___terms-conditions__privacyBackround___kp9db",
		"subtitle": "src-components-styles-pages-___terms-conditions__subtitle___36G7C"
	};

/***/ },
/* 930 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(931));
	
	var _index2 = _interopRequireDefault(__webpack_require__(397));
	
	var _index3 = _interopRequireDefault(__webpack_require__(398));
	
	var _index4 = _interopRequireDefault(__webpack_require__(399));
	
	var _index5 = _interopRequireDefault(__webpack_require__(268));
	
	var _index6 = _interopRequireDefault(__webpack_require__(127));
	
	var _index7 = _interopRequireDefault(__webpack_require__(395));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dayPeriodEnum = {
	  am: 'am',
	  pm: 'pm',
	  midnight: 'midnight',
	  noon: 'noon',
	  morning: 'morning',
	  afternoon: 'afternoon',
	  evening: 'evening',
	  night: 'night'
	};
	/*
	 * |     | Unit                           |     | Unit                           |
	 * |-----|--------------------------------|-----|--------------------------------|
	 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
	 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
	 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
	 * |  d  | Day of month                   |  D  | Day of year                    |
	 * |  e  | Local day of week              |  E  | Day of week                    |
	 * |  f  |                                |  F* | Day of week in month           |
	 * |  g* | Modified Julian day            |  G  | Era                            |
	 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
	 * |  i! | ISO day of week                |  I! | ISO week of year               |
	 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
	 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
	 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
	 * |  m  | Minute                         |  M  | Month                          |
	 * |  n  |                                |  N  |                                |
	 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
	 * |  p! | Long localized time            |  P! | Long localized date            |
	 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
	 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
	 * |  s  | Second                         |  S  | Fraction of second             |
	 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
	 * |  u  | Extended year                  |  U* | Cyclic year                    |
	 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
	 * |  w  | Local week of year             |  W* | Week of month                  |
	 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
	 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
	 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
	 *
	 * Letters marked by * are not implemented but reserved by Unicode standard.
	 *
	 * Letters marked by ! are non-standard, but implemented by date-fns:
	 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
	 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
	 *   i.e. 7 for Sunday, 1 for Monday, etc.
	 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
	 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
	 *   `R` is supposed to be used in conjunction with `I` and `i`
	 *   for universal ISO week-numbering date, whereas
	 *   `Y` is supposed to be used in conjunction with `w` and `e`
	 *   for week-numbering date specific to the locale.
	 * - `P` is long localized date format
	 * - `p` is long localized time format
	 */
	
	var formatters = {
	  // Era
	  G: function (date, token, localize) {
	    var era = date.getUTCFullYear() > 0 ? 1 : 0;
	
	    switch (token) {
	      // AD, BC
	      case 'G':
	      case 'GG':
	      case 'GGG':
	        return localize.era(era, {
	          width: 'abbreviated'
	        });
	      // A, B
	
	      case 'GGGGG':
	        return localize.era(era, {
	          width: 'narrow'
	        });
	      // Anno Domini, Before Christ
	
	      case 'GGGG':
	      default:
	        return localize.era(era, {
	          width: 'wide'
	        });
	    }
	  },
	  // Year
	  y: function (date, token, localize) {
	    // Ordinal number
	    if (token === 'yo') {
	      var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)
	
	      var year = signedYear > 0 ? signedYear : 1 - signedYear;
	      return localize.ordinalNumber(year, {
	        unit: 'year'
	      });
	    }
	
	    return _index7.default.y(date, token);
	  },
	  // Local week-numbering year
	  Y: function (date, token, localize, options) {
	    var signedWeekYear = (0, _index5.default)(date, options); // Returns 1 for 1 BC (which is year 0 in JavaScript)
	
	    var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear; // Two digit year
	
	    if (token === 'YY') {
	      var twoDigitYear = weekYear % 100;
	      return (0, _index6.default)(twoDigitYear, 2);
	    } // Ordinal number
	
	
	    if (token === 'Yo') {
	      return localize.ordinalNumber(weekYear, {
	        unit: 'year'
	      });
	    } // Padding
	
	
	    return (0, _index6.default)(weekYear, token.length);
	  },
	  // ISO week-numbering year
	  R: function (date, token) {
	    var isoWeekYear = (0, _index3.default)(date); // Padding
	
	    return (0, _index6.default)(isoWeekYear, token.length);
	  },
	  // Extended year. This is a single number designating the year of this calendar system.
	  // The main difference between `y` and `u` localizers are B.C. years:
	  // | Year | `y` | `u` |
	  // |------|-----|-----|
	  // | AC 1 |   1 |   1 |
	  // | BC 1 |   1 |   0 |
	  // | BC 2 |   2 |  -1 |
	  // Also `yy` always returns the last two digits of a year,
	  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
	  u: function (date, token) {
	    var year = date.getUTCFullYear();
	    return (0, _index6.default)(year, token.length);
	  },
	  // Quarter
	  Q: function (date, token, localize) {
	    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
	
	    switch (token) {
	      // 1, 2, 3, 4
	      case 'Q':
	        return String(quarter);
	      // 01, 02, 03, 04
	
	      case 'QQ':
	        return (0, _index6.default)(quarter, 2);
	      // 1st, 2nd, 3rd, 4th
	
	      case 'Qo':
	        return localize.ordinalNumber(quarter, {
	          unit: 'quarter'
	        });
	      // Q1, Q2, Q3, Q4
	
	      case 'QQQ':
	        return localize.quarter(quarter, {
	          width: 'abbreviated',
	          context: 'formatting'
	        });
	      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
	
	      case 'QQQQQ':
	        return localize.quarter(quarter, {
	          width: 'narrow',
	          context: 'formatting'
	        });
	      // 1st quarter, 2nd quarter, ...
	
	      case 'QQQQ':
	      default:
	        return localize.quarter(quarter, {
	          width: 'wide',
	          context: 'formatting'
	        });
	    }
	  },
	  // Stand-alone quarter
	  q: function (date, token, localize) {
	    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
	
	    switch (token) {
	      // 1, 2, 3, 4
	      case 'q':
	        return String(quarter);
	      // 01, 02, 03, 04
	
	      case 'qq':
	        return (0, _index6.default)(quarter, 2);
	      // 1st, 2nd, 3rd, 4th
	
	      case 'qo':
	        return localize.ordinalNumber(quarter, {
	          unit: 'quarter'
	        });
	      // Q1, Q2, Q3, Q4
	
	      case 'qqq':
	        return localize.quarter(quarter, {
	          width: 'abbreviated',
	          context: 'standalone'
	        });
	      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
	
	      case 'qqqqq':
	        return localize.quarter(quarter, {
	          width: 'narrow',
	          context: 'standalone'
	        });
	      // 1st quarter, 2nd quarter, ...
	
	      case 'qqqq':
	      default:
	        return localize.quarter(quarter, {
	          width: 'wide',
	          context: 'standalone'
	        });
	    }
	  },
	  // Month
	  M: function (date, token, localize) {
	    var month = date.getUTCMonth();
	
	    switch (token) {
	      case 'M':
	      case 'MM':
	        return _index7.default.M(date, token);
	      // 1st, 2nd, ..., 12th
	
	      case 'Mo':
	        return localize.ordinalNumber(month + 1, {
	          unit: 'month'
	        });
	      // Jan, Feb, ..., Dec
	
	      case 'MMM':
	        return localize.month(month, {
	          width: 'abbreviated',
	          context: 'formatting'
	        });
	      // J, F, ..., D
	
	      case 'MMMMM':
	        return localize.month(month, {
	          width: 'narrow',
	          context: 'formatting'
	        });
	      // January, February, ..., December
	
	      case 'MMMM':
	      default:
	        return localize.month(month, {
	          width: 'wide',
	          context: 'formatting'
	        });
	    }
	  },
	  // Stand-alone month
	  L: function (date, token, localize) {
	    var month = date.getUTCMonth();
	
	    switch (token) {
	      // 1, 2, ..., 12
	      case 'L':
	        return String(month + 1);
	      // 01, 02, ..., 12
	
	      case 'LL':
	        return (0, _index6.default)(month + 1, 2);
	      // 1st, 2nd, ..., 12th
	
	      case 'Lo':
	        return localize.ordinalNumber(month + 1, {
	          unit: 'month'
	        });
	      // Jan, Feb, ..., Dec
	
	      case 'LLL':
	        return localize.month(month, {
	          width: 'abbreviated',
	          context: 'standalone'
	        });
	      // J, F, ..., D
	
	      case 'LLLLL':
	        return localize.month(month, {
	          width: 'narrow',
	          context: 'standalone'
	        });
	      // January, February, ..., December
	
	      case 'LLLL':
	      default:
	        return localize.month(month, {
	          width: 'wide',
	          context: 'standalone'
	        });
	    }
	  },
	  // Local week of year
	  w: function (date, token, localize, options) {
	    var week = (0, _index4.default)(date, options);
	
	    if (token === 'wo') {
	      return localize.ordinalNumber(week, {
	        unit: 'week'
	      });
	    }
	
	    return (0, _index6.default)(week, token.length);
	  },
	  // ISO week of year
	  I: function (date, token, localize) {
	    var isoWeek = (0, _index2.default)(date);
	
	    if (token === 'Io') {
	      return localize.ordinalNumber(isoWeek, {
	        unit: 'week'
	      });
	    }
	
	    return (0, _index6.default)(isoWeek, token.length);
	  },
	  // Day of the month
	  d: function (date, token, localize) {
	    if (token === 'do') {
	      return localize.ordinalNumber(date.getUTCDate(), {
	        unit: 'date'
	      });
	    }
	
	    return _index7.default.d(date, token);
	  },
	  // Day of year
	  D: function (date, token, localize) {
	    var dayOfYear = (0, _index.default)(date);
	
	    if (token === 'Do') {
	      return localize.ordinalNumber(dayOfYear, {
	        unit: 'dayOfYear'
	      });
	    }
	
	    return (0, _index6.default)(dayOfYear, token.length);
	  },
	  // Day of week
	  E: function (date, token, localize) {
	    var dayOfWeek = date.getUTCDay();
	
	    switch (token) {
	      // Tue
	      case 'E':
	      case 'EE':
	      case 'EEE':
	        return localize.day(dayOfWeek, {
	          width: 'abbreviated',
	          context: 'formatting'
	        });
	      // T
	
	      case 'EEEEE':
	        return localize.day(dayOfWeek, {
	          width: 'narrow',
	          context: 'formatting'
	        });
	      // Tu
	
	      case 'EEEEEE':
	        return localize.day(dayOfWeek, {
	          width: 'short',
	          context: 'formatting'
	        });
	      // Tuesday
	
	      case 'EEEE':
	      default:
	        return localize.day(dayOfWeek, {
	          width: 'wide',
	          context: 'formatting'
	        });
	    }
	  },
	  // Local day of week
	  e: function (date, token, localize, options) {
	    var dayOfWeek = date.getUTCDay();
	    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
	
	    switch (token) {
	      // Numerical value (Nth day of week with current locale or weekStartsOn)
	      case 'e':
	        return String(localDayOfWeek);
	      // Padded numerical value
	
	      case 'ee':
	        return (0, _index6.default)(localDayOfWeek, 2);
	      // 1st, 2nd, ..., 7th
	
	      case 'eo':
	        return localize.ordinalNumber(localDayOfWeek, {
	          unit: 'day'
	        });
	
	      case 'eee':
	        return localize.day(dayOfWeek, {
	          width: 'abbreviated',
	          context: 'formatting'
	        });
	      // T
	
	      case 'eeeee':
	        return localize.day(dayOfWeek, {
	          width: 'narrow',
	          context: 'formatting'
	        });
	      // Tu
	
	      case 'eeeeee':
	        return localize.day(dayOfWeek, {
	          width: 'short',
	          context: 'formatting'
	        });
	      // Tuesday
	
	      case 'eeee':
	      default:
	        return localize.day(dayOfWeek, {
	          width: 'wide',
	          context: 'formatting'
	        });
	    }
	  },
	  // Stand-alone local day of week
	  c: function (date, token, localize, options) {
	    var dayOfWeek = date.getUTCDay();
	    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
	
	    switch (token) {
	      // Numerical value (same as in `e`)
	      case 'c':
	        return String(localDayOfWeek);
	      // Padded numerical value
	
	      case 'cc':
	        return (0, _index6.default)(localDayOfWeek, token.length);
	      // 1st, 2nd, ..., 7th
	
	      case 'co':
	        return localize.ordinalNumber(localDayOfWeek, {
	          unit: 'day'
	        });
	
	      case 'ccc':
	        return localize.day(dayOfWeek, {
	          width: 'abbreviated',
	          context: 'standalone'
	        });
	      // T
	
	      case 'ccccc':
	        return localize.day(dayOfWeek, {
	          width: 'narrow',
	          context: 'standalone'
	        });
	      // Tu
	
	      case 'cccccc':
	        return localize.day(dayOfWeek, {
	          width: 'short',
	          context: 'standalone'
	        });
	      // Tuesday
	
	      case 'cccc':
	      default:
	        return localize.day(dayOfWeek, {
	          width: 'wide',
	          context: 'standalone'
	        });
	    }
	  },
	  // ISO day of week
	  i: function (date, token, localize) {
	    var dayOfWeek = date.getUTCDay();
	    var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
	
	    switch (token) {
	      // 2
	      case 'i':
	        return String(isoDayOfWeek);
	      // 02
	
	      case 'ii':
	        return (0, _index6.default)(isoDayOfWeek, token.length);
	      // 2nd
	
	      case 'io':
	        return localize.ordinalNumber(isoDayOfWeek, {
	          unit: 'day'
	        });
	      // Tue
	
	      case 'iii':
	        return localize.day(dayOfWeek, {
	          width: 'abbreviated',
	          context: 'formatting'
	        });
	      // T
	
	      case 'iiiii':
	        return localize.day(dayOfWeek, {
	          width: 'narrow',
	          context: 'formatting'
	        });
	      // Tu
	
	      case 'iiiiii':
	        return localize.day(dayOfWeek, {
	          width: 'short',
	          context: 'formatting'
	        });
	      // Tuesday
	
	      case 'iiii':
	      default:
	        return localize.day(dayOfWeek, {
	          width: 'wide',
	          context: 'formatting'
	        });
	    }
	  },
	  // AM or PM
	  a: function (date, token, localize) {
	    var hours = date.getUTCHours();
	    var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
	
	    switch (token) {
	      case 'a':
	      case 'aa':
	        return localize.dayPeriod(dayPeriodEnumValue, {
	          width: 'abbreviated',
	          context: 'formatting'
	        });
	
	      case 'aaa':
	        return localize.dayPeriod(dayPeriodEnumValue, {
	          width: 'abbreviated',
	          context: 'formatting'
	        }).toLowerCase();
	
	      case 'aaaaa':
	        return localize.dayPeriod(dayPeriodEnumValue, {
	          width: 'narrow',
	          context: 'formatting'
	        });
	
	      case 'aaaa':
	      default:
	        return localize.dayPeriod(dayPeriodEnumValue, {
	          width: 'wide',
	          context: 'formatting'
	        });
	    }
	  },
	  // AM, PM, midnight, noon
	  b: function (date, token, localize) {
	    var hours = date.getUTCHours();
	    var dayPeriodEnumValue;
	
	    if (hours === 12) {
	      dayPeriodEnumValue = dayPeriodEnum.noon;
	    } else if (hours === 0) {
	      dayPeriodEnumValue = dayPeriodEnum.midnight;
	    } else {
	      dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
	    }
	
	    switch (token) {
	      case 'b':
	      case 'bb':
	        return localize.dayPeriod(dayPeriodEnumValue, {
	          width: 'abbreviated',
	          context: 'formatting'
	        });
	
	      case 'bbb':
	        return localize.dayPeriod(dayPeriodEnumValue, {
	          width: 'abbreviated',
	          context: 'formatting'
	        }).toLowerCase();
	
	      case 'bbbbb':
	        return localize.dayPeriod(dayPeriodEnumValue, {
	          width: 'narrow',
	          context: 'formatting'
	        });
	
	      case 'bbbb':
	      default:
	        return localize.dayPeriod(dayPeriodEnumValue, {
	          width: 'wide',
	          context: 'formatting'
	        });
	    }
	  },
	  // in the morning, in the afternoon, in the evening, at night
	  B: function (date, token, localize) {
	    var hours = date.getUTCHours();
	    var dayPeriodEnumValue;
	
	    if (hours >= 17) {
	      dayPeriodEnumValue = dayPeriodEnum.evening;
	    } else if (hours >= 12) {
	      dayPeriodEnumValue = dayPeriodEnum.afternoon;
	    } else if (hours >= 4) {
	      dayPeriodEnumValue = dayPeriodEnum.morning;
	    } else {
	      dayPeriodEnumValue = dayPeriodEnum.night;
	    }
	
	    switch (token) {
	      case 'B':
	      case 'BB':
	      case 'BBB':
	        return localize.dayPeriod(dayPeriodEnumValue, {
	          width: 'abbreviated',
	          context: 'formatting'
	        });
	
	      case 'BBBBB':
	        return localize.dayPeriod(dayPeriodEnumValue, {
	          width: 'narrow',
	          context: 'formatting'
	        });
	
	      case 'BBBB':
	      default:
	        return localize.dayPeriod(dayPeriodEnumValue, {
	          width: 'wide',
	          context: 'formatting'
	        });
	    }
	  },
	  // Hour [1-12]
	  h: function (date, token, localize) {
	    if (token === 'ho') {
	      var hours = date.getUTCHours() % 12;
	      if (hours === 0) hours = 12;
	      return localize.ordinalNumber(hours, {
	        unit: 'hour'
	      });
	    }
	
	    return _index7.default.h(date, token);
	  },
	  // Hour [0-23]
	  H: function (date, token, localize) {
	    if (token === 'Ho') {
	      return localize.ordinalNumber(date.getUTCHours(), {
	        unit: 'hour'
	      });
	    }
	
	    return _index7.default.H(date, token);
	  },
	  // Hour [0-11]
	  K: function (date, token, localize) {
	    var hours = date.getUTCHours() % 12;
	
	    if (token === 'Ko') {
	      return localize.ordinalNumber(hours, {
	        unit: 'hour'
	      });
	    }
	
	    return (0, _index6.default)(hours, token.length);
	  },
	  // Hour [1-24]
	  k: function (date, token, localize) {
	    var hours = date.getUTCHours();
	    if (hours === 0) hours = 24;
	
	    if (token === 'ko') {
	      return localize.ordinalNumber(hours, {
	        unit: 'hour'
	      });
	    }
	
	    return (0, _index6.default)(hours, token.length);
	  },
	  // Minute
	  m: function (date, token, localize) {
	    if (token === 'mo') {
	      return localize.ordinalNumber(date.getUTCMinutes(), {
	        unit: 'minute'
	      });
	    }
	
	    return _index7.default.m(date, token);
	  },
	  // Second
	  s: function (date, token, localize) {
	    if (token === 'so') {
	      return localize.ordinalNumber(date.getUTCSeconds(), {
	        unit: 'second'
	      });
	    }
	
	    return _index7.default.s(date, token);
	  },
	  // Fraction of second
	  S: function (date, token) {
	    return _index7.default.S(date, token);
	  },
	  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
	  X: function (date, token, _localize, options) {
	    var originalDate = options._originalDate || date;
	    var timezoneOffset = originalDate.getTimezoneOffset();
	
	    if (timezoneOffset === 0) {
	      return 'Z';
	    }
	
	    switch (token) {
	      // Hours and optional minutes
	      case 'X':
	        return formatTimezoneWithOptionalMinutes(timezoneOffset);
	      // Hours, minutes and optional seconds without `:` delimiter
	      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
	      // so this token always has the same output as `XX`
	
	      case 'XXXX':
	      case 'XX':
	        // Hours and minutes without `:` delimiter
	        return formatTimezone(timezoneOffset);
	      // Hours, minutes and optional seconds with `:` delimiter
	      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
	      // so this token always has the same output as `XXX`
	
	      case 'XXXXX':
	      case 'XXX': // Hours and minutes with `:` delimiter
	
	      default:
	        return formatTimezone(timezoneOffset, ':');
	    }
	  },
	  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
	  x: function (date, token, _localize, options) {
	    var originalDate = options._originalDate || date;
	    var timezoneOffset = originalDate.getTimezoneOffset();
	
	    switch (token) {
	      // Hours and optional minutes
	      case 'x':
	        return formatTimezoneWithOptionalMinutes(timezoneOffset);
	      // Hours, minutes and optional seconds without `:` delimiter
	      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
	      // so this token always has the same output as `xx`
	
	      case 'xxxx':
	      case 'xx':
	        // Hours and minutes without `:` delimiter
	        return formatTimezone(timezoneOffset);
	      // Hours, minutes and optional seconds with `:` delimiter
	      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
	      // so this token always has the same output as `xxx`
	
	      case 'xxxxx':
	      case 'xxx': // Hours and minutes with `:` delimiter
	
	      default:
	        return formatTimezone(timezoneOffset, ':');
	    }
	  },
	  // Timezone (GMT)
	  O: function (date, token, _localize, options) {
	    var originalDate = options._originalDate || date;
	    var timezoneOffset = originalDate.getTimezoneOffset();
	
	    switch (token) {
	      // Short
	      case 'O':
	      case 'OO':
	      case 'OOO':
	        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
	      // Long
	
	      case 'OOOO':
	      default:
	        return 'GMT' + formatTimezone(timezoneOffset, ':');
	    }
	  },
	  // Timezone (specific non-location)
	  z: function (date, token, _localize, options) {
	    var originalDate = options._originalDate || date;
	    var timezoneOffset = originalDate.getTimezoneOffset();
	
	    switch (token) {
	      // Short
	      case 'z':
	      case 'zz':
	      case 'zzz':
	        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
	      // Long
	
	      case 'zzzz':
	      default:
	        return 'GMT' + formatTimezone(timezoneOffset, ':');
	    }
	  },
	  // Seconds timestamp
	  t: function (date, token, _localize, options) {
	    var originalDate = options._originalDate || date;
	    var timestamp = Math.floor(originalDate.getTime() / 1000);
	    return (0, _index6.default)(timestamp, token.length);
	  },
	  // Milliseconds timestamp
	  T: function (date, token, _localize, options) {
	    var originalDate = options._originalDate || date;
	    var timestamp = originalDate.getTime();
	    return (0, _index6.default)(timestamp, token.length);
	  }
	};
	
	function formatTimezoneShort(offset, dirtyDelimiter) {
	  var sign = offset > 0 ? '-' : '+';
	  var absOffset = Math.abs(offset);
	  var hours = Math.floor(absOffset / 60);
	  var minutes = absOffset % 60;
	
	  if (minutes === 0) {
	    return sign + String(hours);
	  }
	
	  var delimiter = dirtyDelimiter || '';
	  return sign + String(hours) + delimiter + (0, _index6.default)(minutes, 2);
	}
	
	function formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
	  if (offset % 60 === 0) {
	    var sign = offset > 0 ? '-' : '+';
	    return sign + (0, _index6.default)(Math.abs(offset) / 60, 2);
	  }
	
	  return formatTimezone(offset, dirtyDelimiter);
	}
	
	function formatTimezone(offset, dirtyDelimiter) {
	  var delimiter = dirtyDelimiter || '';
	  var sign = offset > 0 ? '-' : '+';
	  var absOffset = Math.abs(offset);
	  var hours = (0, _index6.default)(Math.floor(absOffset / 60), 2);
	  var minutes = (0, _index6.default)(absOffset % 60, 2);
	  return sign + hours + delimiter + minutes;
	}
	
	var _default = formatters;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 931 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getUTCDayOfYear;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MILLISECONDS_IN_DAY = 86400000; // This function will be a part of public API when UTC function will be implemented.
	// See issue: https://github.com/date-fns/date-fns/issues/376
	
	function getUTCDayOfYear(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var timestamp = date.getTime();
	  date.setUTCMonth(0, 1);
	  date.setUTCHours(0, 0, 0, 0);
	  var startOfYearTimestamp = date.getTime();
	  var difference = timestamp - startOfYearTimestamp;
	  return Math.floor(difference / MILLISECONDS_IN_DAY) + 1;
	}
	
	module.exports = exports.default;

/***/ },
/* 932 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setUTCDay;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	var _index3 = _interopRequireDefault(__webpack_require__(19));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// This function will be a part of public API when UTC function will be implemented.
	// See issue: https://github.com/date-fns/date-fns/issues/376
	function setUTCDay(dirtyDate, dirtyDay, dirtyOptions) {
	  (0, _index2.default)(2, arguments);
	  var options = dirtyOptions || {};
	  var locale = options.locale;
	  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
	  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0, _index3.default)(localeWeekStartsOn);
	  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0, _index3.default)(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
	
	  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
	    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
	  }
	
	  var date = (0, _index.default)(dirtyDate);
	  var day = (0, _index3.default)(dirtyDay);
	  var currentDay = date.getUTCDay();
	  var remainder = day % 7;
	  var dayIndex = (remainder + 7) % 7;
	  var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
	  date.setUTCDate(date.getUTCDate() + diff);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 933 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setUTCISODay;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	var _index3 = _interopRequireDefault(__webpack_require__(19));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// This function will be a part of public API when UTC function will be implemented.
	// See issue: https://github.com/date-fns/date-fns/issues/376
	function setUTCISODay(dirtyDate, dirtyDay) {
	  (0, _index2.default)(2, arguments);
	  var day = (0, _index3.default)(dirtyDay);
	
	  if (day % 7 === 0) {
	    day = day - 7;
	  }
	
	  var weekStartsOn = 1;
	  var date = (0, _index.default)(dirtyDate);
	  var currentDay = date.getUTCDay();
	  var remainder = day % 7;
	  var dayIndex = (remainder + 7) % 7;
	  var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
	  date.setUTCDate(date.getUTCDate() + diff);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 934 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setUTCISOWeek;
	
	var _index = _interopRequireDefault(__webpack_require__(19));
	
	var _index2 = _interopRequireDefault(__webpack_require__(3));
	
	var _index3 = _interopRequireDefault(__webpack_require__(397));
	
	var _index4 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// This function will be a part of public API when UTC function will be implemented.
	// See issue: https://github.com/date-fns/date-fns/issues/376
	function setUTCISOWeek(dirtyDate, dirtyISOWeek) {
	  (0, _index4.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var isoWeek = (0, _index.default)(dirtyISOWeek);
	  var diff = (0, _index3.default)(date) - isoWeek;
	  date.setUTCDate(date.getUTCDate() - diff * 7);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 935 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setUTCWeek;
	
	var _index = _interopRequireDefault(__webpack_require__(19));
	
	var _index2 = _interopRequireDefault(__webpack_require__(3));
	
	var _index3 = _interopRequireDefault(__webpack_require__(399));
	
	var _index4 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// This function will be a part of public API when UTC function will be implemented.
	// See issue: https://github.com/date-fns/date-fns/issues/376
	function setUTCWeek(dirtyDate, dirtyWeek, options) {
	  (0, _index4.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var week = (0, _index.default)(dirtyWeek);
	  var diff = (0, _index3.default)(date, options) - week;
	  date.setUTCDate(date.getUTCDate() - diff * 7);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 936 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfUTCISOWeekYear;
	
	var _index = _interopRequireDefault(__webpack_require__(398));
	
	var _index2 = _interopRequireDefault(__webpack_require__(188));
	
	var _index3 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// This function will be a part of public API when UTC function will be implemented.
	// See issue: https://github.com/date-fns/date-fns/issues/376
	function startOfUTCISOWeekYear(dirtyDate) {
	  (0, _index3.default)(1, arguments);
	  var year = (0, _index.default)(dirtyDate);
	  var fourthOfJanuary = new Date(0);
	  fourthOfJanuary.setUTCFullYear(year, 0, 4);
	  fourthOfJanuary.setUTCHours(0, 0, 0, 0);
	  var date = (0, _index2.default)(fourthOfJanuary);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 937 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfUTCWeekYear;
	
	var _index = _interopRequireDefault(__webpack_require__(268));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	var _index3 = _interopRequireDefault(__webpack_require__(148));
	
	var _index4 = _interopRequireDefault(__webpack_require__(19));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// This function will be a part of public API when UTC function will be implemented.
	// See issue: https://github.com/date-fns/date-fns/issues/376
	function startOfUTCWeekYear(dirtyDate, dirtyOptions) {
	  (0, _index2.default)(1, arguments);
	  var options = dirtyOptions || {};
	  var locale = options.locale;
	  var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
	  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : (0, _index4.default)(localeFirstWeekContainsDate);
	  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : (0, _index4.default)(options.firstWeekContainsDate);
	  var year = (0, _index.default)(dirtyDate, dirtyOptions);
	  var firstWeek = new Date(0);
	  firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
	  firstWeek.setUTCHours(0, 0, 0, 0);
	  var date = (0, _index3.default)(firstWeek, dirtyOptions);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 938 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = add;
	
	var _index = _interopRequireDefault(__webpack_require__(82));
	
	var _index2 = _interopRequireDefault(__webpack_require__(150));
	
	var _index3 = _interopRequireDefault(__webpack_require__(3));
	
	var _index4 = _interopRequireDefault(__webpack_require__(2));
	
	var _index5 = _interopRequireDefault(__webpack_require__(19));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name add
	 * @category Common Helpers
	 * @summary Add the specified years, months, weeks, days, hours, minutes and seconds to the given date.
	 *
	 * @description
	 * Add the specified years, months, weeks, days, hours, minutes and seconds to the given date.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Duration} duration - the object with years, months, weeks, days, hours, minutes and seconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 *
	 * | Key            | Description                        |
	 * |----------------|------------------------------------|
	 * | years          | Amount of years to be added        |
	 * | months         | Amount of months to be added       |
	 * | weeks          | Amount of weeks to be added        |
	 * | days           | Amount of days to be added         |
	 * | hours          | Amount of hours to be added        |
	 * | minutes        | Amount of minutes to be added      |
	 * | seconds        | Amount of seconds to be added      |
	 *
	 * All values default to 0
	 *
	 * @returns {Date} the new date with the seconds added
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Add the following duration to 1 September 2014, 10:19:50
	 * const result = add(new Date(2014, 8, 1, 10, 19, 50), {
	 *   years: 2,
	 *   months: 9,
	 *   weeks: 1,
	 *   days: 7,
	 *   hours: 5,
	 *   minutes: 9,
	 *   seconds: 30,
	 * })
	 * //=> Thu Jun 15 2017 15:29:20
	 */
	function add(dirtyDate, duration) {
	  (0, _index4.default)(2, arguments);
	  if (!duration || typeof duration !== 'object') return new Date(NaN);
	  var years = duration.years ? (0, _index5.default)(duration.years) : 0;
	  var months = duration.months ? (0, _index5.default)(duration.months) : 0;
	  var weeks = duration.weeks ? (0, _index5.default)(duration.weeks) : 0;
	  var days = duration.days ? (0, _index5.default)(duration.days) : 0;
	  var hours = duration.hours ? (0, _index5.default)(duration.hours) : 0;
	  var minutes = duration.minutes ? (0, _index5.default)(duration.minutes) : 0;
	  var seconds = duration.seconds ? (0, _index5.default)(duration.seconds) : 0; // Add years and months
	
	  var date = (0, _index3.default)(dirtyDate);
	  var dateWithMonths = months || years ? (0, _index2.default)(date, months + years * 12) : date; // Add weeks and days
	
	  var dateWithDays = days || weeks ? (0, _index.default)(dateWithMonths, days + weeks * 7) : dateWithMonths; // Add days, hours, minutes and seconds
	
	  var minutesToAdd = minutes + hours * 60;
	  var secondsToAdd = seconds + minutesToAdd * 60;
	  var msToAdd = secondsToAdd * 1000;
	  var finalDate = new Date(dateWithDays.getTime() + msToAdd);
	  return finalDate;
	}
	
	module.exports = exports.default;

/***/ },
/* 939 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = areIntervalsOverlapping;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name areIntervalsOverlapping
	 * @category Interval Helpers
	 * @summary Is the given time interval overlapping with another time interval?
	 *
	 * @description
	 * Is the given time interval overlapping with another time interval? Adjacent intervals do not count as overlapping.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * - The function was renamed from `areRangesOverlapping` to `areIntervalsOverlapping`.
	 *   This change was made to mirror the use of the word "interval" in standard ISO 8601:2004 terminology:
	 *
	 *   ```
	 *   2.1.3
	 *   time interval
	 *   part of the time axis limited by two instants
	 *   ```
	 *
	 *   Also, this function now accepts an object with `start` and `end` properties
	 *   instead of two arguments as an interval.
	 *   This function now throws `RangeError` if the start of the interval is after its end
	 *   or if any date in the interval is `Invalid Date`.
	 *
	 *   ```javascript
	 *   // Before v2.0.0
	 *
	 *   areRangesOverlapping(
	 *     new Date(2014, 0, 10), new Date(2014, 0, 20),
	 *     new Date(2014, 0, 17), new Date(2014, 0, 21)
	 *   )
	 *
	 *   // v2.0.0 onward
	 *
	 *   areIntervalsOverlapping(
	 *     { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
	 *     { start: new Date(2014, 0, 17), end: new Date(2014, 0, 21) }
	 *   )
	 *   ```
	 *
	 * @param {Interval} intervalLeft - the first interval to compare. See [Interval]{@link https://date-fns.org/docs/Interval}
	 * @param {Interval} intervalRight - the second interval to compare. See [Interval]{@link https://date-fns.org/docs/Interval}
	 * @param {Object} [options] - the object with options
	 * @param {Boolean} [options.inclusive=false] - whether the comparison is inclusive or not
	 * @returns {Boolean} whether the time intervals are overlapping
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} The start of an interval cannot be after its end
	 * @throws {RangeError} Date in interval cannot be `Invalid Date`
	 *
	 * @example
	 * // For overlapping time intervals:
	 * areIntervalsOverlapping(
	 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
	 *   { start: new Date(2014, 0, 17), end: new Date(2014, 0, 21) }
	 * )
	 * //=> true
	 *
	 * @example
	 * // For non-overlapping time intervals:
	 * areIntervalsOverlapping(
	 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
	 *   { start: new Date(2014, 0, 21), end: new Date(2014, 0, 22) }
	 * )
	 * //=> false
	 *
	 * @example
	 * // For adjacent time intervals:
	 * areIntervalsOverlapping(
	 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
	 *   { start: new Date(2014, 0, 20), end: new Date(2014, 0, 30) }
	 * )
	 * //=> false
	 *
	 * @example
	 * // Using the inclusive option:
	 * areIntervalsOverlapping(
	 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
	 *   { start: new Date(2014, 0, 20), end: new Date(2014, 0, 24) }
	 * )
	 * //=> false
	 * areIntervalsOverlapping(
	 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
	 *   { start: new Date(2014, 0, 20), end: new Date(2014, 0, 24) },
	 *   { inclusive: true }
	 * )
	 * //=> true
	 */
	function areIntervalsOverlapping(dirtyIntervalLeft, dirtyIntervalRight) {
	  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
	    inclusive: false
	  };
	  (0, _index2.default)(2, arguments);
	  var intervalLeft = dirtyIntervalLeft || {};
	  var intervalRight = dirtyIntervalRight || {};
	  var leftStartTime = (0, _index.default)(intervalLeft.start).getTime();
	  var leftEndTime = (0, _index.default)(intervalLeft.end).getTime();
	  var rightStartTime = (0, _index.default)(intervalRight.start).getTime();
	  var rightEndTime = (0, _index.default)(intervalRight.end).getTime(); // Throw an exception if start date is after end date or if any date is `Invalid Date`
	
	  if (!(leftStartTime <= leftEndTime && rightStartTime <= rightEndTime)) {
	    throw new RangeError('Invalid interval');
	  }
	
	  if (options.inclusive) {
	    return leftStartTime <= rightEndTime && rightStartTime <= leftEndTime;
	  }
	
	  return leftStartTime < rightEndTime && rightStartTime < leftEndTime;
	}
	
	module.exports = exports.default;

/***/ },
/* 940 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = clamp;
	
	var _index = _interopRequireDefault(__webpack_require__(446));
	
	var _index2 = _interopRequireDefault(__webpack_require__(447));
	
	var _index3 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name clamp
	 * @category Interval Helpers
	 * @summary Return a date bounded by the start and the end of the given interval
	 *
	 * @description
	 * Clamps a date to the lower bound with the start of the interval and the upper
	 * bound with the end of the interval.
	 *
	 * - When the date is less than the start of the interval, the start is returned.
	 * - When the date is greater than the end of the interval, the end is returned.
	 * - Otherwise the date is returned.
	 *
	 * @example
	 * // What is Mar, 21, 2021 bounded to an interval starting at Mar, 22, 2021 and ending at Apr, 01, 2021
	 * const result = clamp(new Date(2021, 2, 21), {
	 *   start: new Date(2021, 2, 22),
	 *   end: new Date(2021, 3, 1),
	 * })
	 * //=> Mon Mar 22 2021 00:00:00
	 *
	 * @param {Date | Number} date - the date to be bounded
	 * @param {Interval} interval - the interval to bound to
	 * @returns {Date} the date bounded by the start and the end of the interval
	 * @throws {TypeError} 2 arguments required
	 */
	function clamp(date, _ref) {
	  var start = _ref.start,
	      end = _ref.end;
	  (0, _index3.default)(2, arguments);
	  return (0, _index2.default)([(0, _index.default)([date, start]), end]);
	}
	
	module.exports = exports.default;

/***/ },
/* 941 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = closestIndexTo;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name closestIndexTo
	 * @category Common Helpers
	 * @summary Return an index of the closest date from the array comparing to the given date.
	 *
	 * @description
	 * Return an index of the closest date from the array comparing to the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * - Now, `closestIndexTo` doesn't throw an exception
	 *   when the second argument is not an array, and returns Invalid Date instead.
	 *
	 * @param {Date | Number} dateToCompare - the date to compare with
	 * @param {Array<Date> | Array<number>} datesArray - the array to search
	 * @returns {Number | undefined} an index of the date closest to the given date or undefined if no valid value is given
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Which date is closer to 6 September 2015?
	 * const dateToCompare = new Date(2015, 8, 6)
	 * const datesArray = [
	 *   new Date(2015, 0, 1),
	 *   new Date(2016, 0, 1),
	 *   new Date(2017, 0, 1)
	 * ]
	 * const result = closestIndexTo(dateToCompare, datesArray)
	 * //=> 1
	 */
	function closestIndexTo(dirtyDateToCompare, dirtyDatesArray) {
	  (0, _index2.default)(2, arguments);
	  var dateToCompare = (0, _index.default)(dirtyDateToCompare);
	  if (isNaN(Number(dateToCompare))) return NaN;
	  var timeToCompare = dateToCompare.getTime();
	  var datesArray; // `dirtyDatesArray` is undefined or null
	
	  if (dirtyDatesArray == null) {
	    datesArray = []; // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method
	  } else if (typeof dirtyDatesArray.forEach === 'function') {
	    datesArray = dirtyDatesArray; // If `dirtyDatesArray` is Array-like Object, convert to Array. Otherwise, make it empty Array
	  } else {
	    datesArray = Array.prototype.slice.call(dirtyDatesArray);
	  }
	
	  var result;
	  var minDistance;
	  datesArray.forEach(function (dirtyDate, index) {
	    var currentDate = (0, _index.default)(dirtyDate);
	
	    if (isNaN(Number(currentDate))) {
	      result = NaN;
	      minDistance = NaN;
	      return;
	    }
	
	    var distance = Math.abs(timeToCompare - currentDate.getTime());
	
	    if (result == null || distance < Number(minDistance)) {
	      result = index;
	      minDistance = distance;
	    }
	  });
	  return result;
	}
	
	module.exports = exports.default;

/***/ },
/* 942 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = closestTo;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name closestTo
	 * @category Common Helpers
	 * @summary Return a date from the array closest to the given date.
	 *
	 * @description
	 * Return a date from the array closest to the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * - Now, `closestTo` doesn't throw an exception
	 *   when the second argument is not an array, and returns Invalid Date instead.
	 *
	 * @param {Date | Number} dateToCompare - the date to compare with
	 * @param {Array<Date> | Array<number>} datesArray - the array to search
	 * @returns {Date | undefined} the date from the array closest to the given date or undefined if no valid value is given
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Which date is closer to 6 September 2015: 1 January 2000 or 1 January 2030?
	 * const dateToCompare = new Date(2015, 8, 6)
	 * const result = closestTo(dateToCompare, [
	 *   new Date(2000, 0, 1),
	 *   new Date(2030, 0, 1)
	 * ])
	 * //=> Tue Jan 01 2030 00:00:00
	 */
	function closestTo(dirtyDateToCompare, dirtyDatesArray) {
	  (0, _index2.default)(2, arguments);
	  var dateToCompare = (0, _index.default)(dirtyDateToCompare);
	  if (isNaN(Number(dateToCompare))) return new Date(NaN);
	  var timeToCompare = dateToCompare.getTime();
	  var datesArray; // `dirtyDatesArray` is undefined or null
	
	  if (dirtyDatesArray == null) {
	    datesArray = []; // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method
	  } else if (typeof dirtyDatesArray.forEach === 'function') {
	    datesArray = dirtyDatesArray; // If `dirtyDatesArray` is Array-like Object, convert to Array. Otherwise, make it empty Array
	  } else {
	    datesArray = Array.prototype.slice.call(dirtyDatesArray);
	  }
	
	  var result;
	  var minDistance;
	  datesArray.forEach(function (dirtyDate) {
	    var currentDate = (0, _index.default)(dirtyDate);
	
	    if (isNaN(Number(currentDate))) {
	      result = new Date(NaN);
	      minDistance = NaN;
	      return;
	    }
	
	    var distance = Math.abs(timeToCompare - currentDate.getTime());
	
	    if (result == null || distance < Number(minDistance)) {
	      result = currentDate;
	      minDistance = distance;
	    }
	  });
	  return result;
	}
	
	module.exports = exports.default;

/***/ },
/* 943 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = compareDesc;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name compareDesc
	 * @category Common Helpers
	 * @summary Compare the two dates reverse chronologically and return -1, 0 or 1.
	 *
	 * @description
	 * Compare the two dates and return -1 if the first date is after the second,
	 * 1 if the first date is before the second or 0 if dates are equal.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the first date to compare
	 * @param {Date|Number} dateRight - the second date to compare
	 * @returns {Number} the result of the comparison
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Compare 11 February 1987 and 10 July 1989 reverse chronologically:
	 * const result = compareDesc(new Date(1987, 1, 11), new Date(1989, 6, 10))
	 * //=> 1
	 *
	 * @example
	 * // Sort the array of dates in reverse chronological order:
	 * const result = [
	 *   new Date(1995, 6, 2),
	 *   new Date(1987, 1, 11),
	 *   new Date(1989, 6, 10)
	 * ].sort(compareDesc)
	 * //=> [
	 * //   Sun Jul 02 1995 00:00:00,
	 * //   Mon Jul 10 1989 00:00:00,
	 * //   Wed Feb 11 1987 00:00:00
	 * // ]
	 */
	function compareDesc(dirtyDateLeft, dirtyDateRight) {
	  (0, _index2.default)(2, arguments);
	  var dateLeft = (0, _index.default)(dirtyDateLeft);
	  var dateRight = (0, _index.default)(dirtyDateRight);
	  var diff = dateLeft.getTime() - dateRight.getTime();
	
	  if (diff > 0) {
	    return -1;
	  } else if (diff < 0) {
	    return 1; // Return 0 if diff is 0; return NaN if diff is NaN
	  } else {
	    return diff;
	  }
	}
	
	module.exports = exports.default;

/***/ },
/* 944 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = daysToWeeks;
	
	var _index = _interopRequireDefault(__webpack_require__(2));
	
	var _index2 = __webpack_require__(36);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name daysToWeeks
	 * @category Conversion Helpers
	 * @summary Convert days to weeks.
	 *
	 * @description
	 * Convert a number of days to a full number of weeks.
	 *
	 * @param {number} days - number of days to be converted
	 *
	 * @returns {number} the number of days converted in weeks
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Convert 14 days to weeks:
	 * const result = daysToWeeks(14)
	 * //=> 2
	 *
	 * @example
	 * // It uses floor rounding:
	 * const result = daysToWeeks(13)
	 * //=> 1
	 */
	function daysToWeeks(days) {
	  (0, _index.default)(1, arguments);
	  var weeks = days / _index2.daysInWeek;
	  return Math.floor(weeks);
	}
	
	module.exports = exports.default;

/***/ },
/* 945 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = differenceInBusinessDays;
	
	var _index = _interopRequireDefault(__webpack_require__(82));
	
	var _index2 = _interopRequireDefault(__webpack_require__(106));
	
	var _index3 = _interopRequireDefault(__webpack_require__(151));
	
	var _index4 = _interopRequireDefault(__webpack_require__(83));
	
	var _index5 = _interopRequireDefault(__webpack_require__(193));
	
	var _index6 = _interopRequireDefault(__webpack_require__(3));
	
	var _index7 = _interopRequireDefault(__webpack_require__(2));
	
	var _index8 = _interopRequireDefault(__webpack_require__(19));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name differenceInBusinessDays
	 * @category Day Helpers
	 * @summary Get the number of business days between the given dates.
	 *
	 * @description
	 * Get the number of business day periods between the given dates.
	 * Business days being days that arent in the weekend.
	 * Like `differenceInCalendarDays`, the function removes the times from
	 * the dates before calculating the difference.
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @returns {Number} the number of business days
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // How many business days are between
	 * // 10 January 2014 and 20 July 2014?
	 * const result = differenceInBusinessDays(
	 *   new Date(2014, 6, 20),
	 *   new Date(2014, 0, 10)
	 * )
	 * //=> 136
	 *
	 * // How many business days are between
	 * // 1 November 2021 and 30 November 2021?
	 * const result = differenceInBusinessDays(
	 *   new Date(2021, 10, 1),
	 *   new Date(2021, 10, 30)
	 * )
	 * //=> 21
	 *
	 * // How many business days are between
	 * // 1 November 2021 and 1 December 2021?
	 * const result = differenceInBusinessDays(
	 *   new Date(2021, 10, 1),
	 *   new Date(2021, 11, 1)
	 * )
	 * //=> 22
	 *
	 * // How many business days are between
	 * // 1 November 2021 and 1 November 2021 ?
	 * const result = differenceInBusinessDays(
	 *   new Date(2021, 10, 1),
	 *   new Date(2021, 10, 1)
	 * )
	 * //=> 0
	 */
	function differenceInBusinessDays(dirtyDateLeft, dirtyDateRight) {
	  (0, _index7.default)(2, arguments);
	  var dateLeft = (0, _index6.default)(dirtyDateLeft);
	  var dateRight = (0, _index6.default)(dirtyDateRight);
	  if (!(0, _index4.default)(dateLeft) || !(0, _index4.default)(dateRight)) return NaN;
	  var calendarDifference = (0, _index2.default)(dateLeft, dateRight);
	  var sign = calendarDifference < 0 ? -1 : 1;
	  var weeks = (0, _index8.default)(calendarDifference / 7);
	  var result = weeks * 5;
	  dateRight = (0, _index.default)(dateRight, weeks * 7); // the loop below will run at most 6 times to account for the remaining days that don't makeup a full week
	
	  while (!(0, _index3.default)(dateLeft, dateRight)) {
	    // sign is used to account for both negative and positive differences
	    result += (0, _index5.default)(dateRight) ? 0 : sign;
	    dateRight = (0, _index.default)(dateRight, sign);
	  }
	
	  return result === 0 ? 0 : result;
	}
	
	module.exports = exports.default;

/***/ },
/* 946 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = differenceInCalendarISOWeeks;
	
	var _index = _interopRequireDefault(__webpack_require__(81));
	
	var _index2 = _interopRequireDefault(__webpack_require__(109));
	
	var _index3 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MILLISECONDS_IN_WEEK = 604800000;
	/**
	 * @name differenceInCalendarISOWeeks
	 * @category ISO Week Helpers
	 * @summary Get the number of calendar ISO weeks between the given dates.
	 *
	 * @description
	 * Get the number of calendar ISO weeks between the given dates.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @returns {Number} the number of calendar ISO weeks
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // How many calendar ISO weeks are between 6 July 2014 and 21 July 2014?
	 * const result = differenceInCalendarISOWeeks(
	 *   new Date(2014, 6, 21),
	 *   new Date(2014, 6, 6)
	 * )
	 * //=> 3
	 */
	
	function differenceInCalendarISOWeeks(dirtyDateLeft, dirtyDateRight) {
	  (0, _index3.default)(2, arguments);
	  var startOfISOWeekLeft = (0, _index2.default)(dirtyDateLeft);
	  var startOfISOWeekRight = (0, _index2.default)(dirtyDateRight);
	  var timestampLeft = startOfISOWeekLeft.getTime() - (0, _index.default)(startOfISOWeekLeft);
	  var timestampRight = startOfISOWeekRight.getTime() - (0, _index.default)(startOfISOWeekRight); // Round the number of days to the nearest integer
	  // because the number of milliseconds in a week is not constant
	  // (e.g. it's different in the week of the daylight saving time clock shift)
	
	  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_WEEK);
	}
	
	module.exports = exports.default;

/***/ },
/* 947 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = differenceInCalendarQuarters;
	
	var _index = _interopRequireDefault(__webpack_require__(421));
	
	var _index2 = _interopRequireDefault(__webpack_require__(3));
	
	var _index3 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name differenceInCalendarQuarters
	 * @category Quarter Helpers
	 * @summary Get the number of calendar quarters between the given dates.
	 *
	 * @description
	 * Get the number of calendar quarters between the given dates.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @returns {Number} the number of calendar quarters
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // How many calendar quarters are between 31 December 2013 and 2 July 2014?
	 * var result = differenceInCalendarQuarters(
	 *   new Date(2014, 6, 2),
	 *   new Date(2013, 11, 31)
	 * )
	 * //=> 3
	 */
	function differenceInCalendarQuarters(dirtyDateLeft, dirtyDateRight) {
	  (0, _index3.default)(2, arguments);
	  var dateLeft = (0, _index2.default)(dirtyDateLeft);
	  var dateRight = (0, _index2.default)(dirtyDateRight);
	  var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear();
	  var quarterDiff = (0, _index.default)(dateLeft) - (0, _index.default)(dateRight);
	  return yearDiff * 4 + quarterDiff;
	}
	
	module.exports = exports.default;

/***/ },
/* 948 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = differenceInISOWeekYears;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(405));
	
	var _index3 = _interopRequireDefault(__webpack_require__(105));
	
	var _index4 = _interopRequireDefault(__webpack_require__(453));
	
	var _index5 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name differenceInISOWeekYears
	 * @category ISO Week-Numbering Year Helpers
	 * @summary Get the number of full ISO week-numbering years between the given dates.
	 *
	 * @description
	 * Get the number of full ISO week-numbering years between the given dates.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * - The function was renamed from `differenceInISOYears` to `differenceInISOWeekYears`.
	 *   "ISO week year" is short for [ISO week-numbering year](https://en.wikipedia.org/wiki/ISO_week_date).
	 *   This change makes the name consistent with
	 *   locale-dependent week-numbering year helpers, e.g., `addWeekYears`.
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @returns {Number} the number of full ISO week-numbering years
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // How many full ISO week-numbering years are between 1 January 2010 and 1 January 2012?
	 * var result = differenceInISOWeekYears(
	 *   new Date(2012, 0, 1),
	 *   new Date(2010, 0, 1)
	 * )
	 * //=> 1
	 */
	function differenceInISOWeekYears(dirtyDateLeft, dirtyDateRight) {
	  (0, _index5.default)(2, arguments);
	  var dateLeft = (0, _index.default)(dirtyDateLeft);
	  var dateRight = (0, _index.default)(dirtyDateRight);
	  var sign = (0, _index3.default)(dateLeft, dateRight);
	  var difference = Math.abs((0, _index2.default)(dateLeft, dateRight));
	  dateLeft = (0, _index4.default)(dateLeft, sign * difference); // Math.abs(diff in full ISO years - diff in calendar ISO years) === 1
	  // if last calendar ISO year is not full
	  // If so, result must be decreased by 1 in absolute value
	
	  var isLastISOWeekYearNotFull = Number((0, _index3.default)(dateLeft, dateRight) === -sign);
	  var result = sign * (difference - isLastISOWeekYearNotFull); // Prevent negative zero
	
	  return result === 0 ? 0 : result;
	}
	
	module.exports = exports.default;

/***/ },
/* 949 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = differenceInQuarters;
	
	var _index = _interopRequireDefault(__webpack_require__(191));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	var _index3 = __webpack_require__(147);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name differenceInQuarters
	 * @category Quarter Helpers
	 * @summary Get the number of quarters between the given dates.
	 *
	 * @description
	 * Get the number of quarters between the given dates.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @param {Object} [options] - an object with options.
	 * @param {String} [options.roundingMethod='trunc'] - a rounding method (`ceil`, `floor`, `round` or `trunc`)
	 * @returns {Number} the number of full quarters
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // How many full quarters are between 31 December 2013 and 2 July 2014?
	 * const result = differenceInQuarters(new Date(2014, 6, 2), new Date(2013, 11, 31))
	 * //=> 2
	 */
	function differenceInQuarters(dateLeft, dateRight, options) {
	  (0, _index2.default)(2, arguments);
	  var diff = (0, _index.default)(dateLeft, dateRight) / 3;
	  return (0, _index3.getRoundingMethod)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
	}
	
	module.exports = exports.default;

/***/ },
/* 950 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = differenceInWeeks;
	
	var _index = _interopRequireDefault(__webpack_require__(272));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	var _index3 = __webpack_require__(147);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name differenceInWeeks
	 * @category Week Helpers
	 * @summary Get the number of full weeks between the given dates.
	 *
	 * @description
	 * Get the number of full weeks between two dates. Fractional weeks are
	 * truncated towards zero by default.
	 *
	 * One "full week" is the distance between a local time in one day to the same
	 * local time 7 days earlier or later. A full week can sometimes be less than
	 * or more than 7*24 hours if a daylight savings change happens between two dates.
	 *
	 * To ignore DST and only measure exact 7*24-hour periods, use this instead:
	 * `Math.floor(differenceInHours(dateLeft, dateRight)/(7*24))|0`.
	 *
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @param {Object} [options] - an object with options.
	 * @param {String} [options.roundingMethod='trunc'] - a rounding method (`ceil`, `floor`, `round` or `trunc`)
	 * @returns {Number} the number of full weeks
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // How many full weeks are between 5 July 2014 and 20 July 2014?
	 * const result = differenceInWeeks(new Date(2014, 6, 20), new Date(2014, 6, 5))
	 * //=> 2
	 *
	 * // How many full weeks are between
	 * // 1 March 2020 0:00 and 6 June 2020 0:00 ?
	 * // Note: because local time is used, the
	 * // result will always be 8 weeks (54 days),
	 * // even if DST starts and the period has
	 * // only 54*24-1 hours.
	 * const result = differenceInWeeks(
	 *   new Date(2020, 5, 1),
	 *   new Date(2020, 2, 6)
	 * )
	 * //=> 8
	 */
	function differenceInWeeks(dateLeft, dateRight, options) {
	  (0, _index2.default)(2, arguments);
	  var diff = (0, _index.default)(dateLeft, dateRight) / 7;
	  return (0, _index3.getRoundingMethod)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
	}
	
	module.exports = exports.default;

/***/ },
/* 951 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = eachHourOfInterval;
	
	var _index = _interopRequireDefault(__webpack_require__(269));
	
	var _index2 = _interopRequireDefault(__webpack_require__(3));
	
	var _index3 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name eachHourOfInterval
	 * @category Interval Helpers
	 * @summary Return the array of hours within the specified time interval.
	 *
	 * @description
	 * Return the array of hours within the specified time interval.
	 *
	 * @param {Interval} interval - the interval. See [Interval]{@link https://date-fns.org/docs/Interval}
	 * @param {Object} [options] - an object with options.
	 * @param {Number} [options.step=1] - the step to increment by. The value should be more than 1.
	 * @returns {Date[]} the array with starts of hours from the hour of the interval start to the hour of the interval end
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.step` must be a number greater than 1
	 * @throws {RangeError} The start of an interval cannot be after its end
	 * @throws {RangeError} Date in interval cannot be `Invalid Date`
	 *
	 * @example
	 * // Each hour between 6 October 2014, 12:00 and 6 October 2014, 15:00
	 * var result = eachHourOfInterval({
	 *   start: new Date(2014, 9, 6, 12),
	 *   end: new Date(2014, 9, 6, 15)
	 * })
	 * //=> [
	 * //   Mon Oct 06 2014 12:00:00,
	 * //   Mon Oct 06 2014 13:00:00,
	 * //   Mon Oct 06 2014 14:00:00,
	 * //   Mon Oct 06 2014 15:00:00
	 * // ]
	 */
	function eachHourOfInterval(dirtyInterval, options) {
	  (0, _index3.default)(1, arguments);
	  var interval = dirtyInterval || {};
	  var startDate = (0, _index2.default)(interval.start);
	  var endDate = (0, _index2.default)(interval.end);
	  var startTime = startDate.getTime();
	  var endTime = endDate.getTime(); // Throw an exception if start date is after end date or if any date is `Invalid Date`
	
	  if (!(startTime <= endTime)) {
	    throw new RangeError('Invalid interval');
	  }
	
	  var dates = [];
	  var currentDate = startDate;
	  currentDate.setMinutes(0, 0, 0);
	  var step = options && 'step' in options ? Number(options.step) : 1;
	  if (step < 1 || isNaN(step)) throw new RangeError('`options.step` must be a number greater than 1');
	
	  while (currentDate.getTime() <= endTime) {
	    dates.push((0, _index2.default)(currentDate));
	    currentDate = (0, _index.default)(currentDate, step);
	  }
	
	  return dates;
	}
	
	module.exports = exports.default;

/***/ },
/* 952 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = eachMinuteOfInterval;
	
	var _index = _interopRequireDefault(__webpack_require__(270));
	
	var _index2 = _interopRequireDefault(__webpack_require__(3));
	
	var _index3 = _interopRequireDefault(__webpack_require__(286));
	
	var _index4 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name eachMinuteOfInterval
	 * @category Interval Helpers
	 * @summary Return the array of minutes within the specified time interval.
	 *
	 * @description
	 * Returns the array of minutes within the specified time interval.
	 *
	 * @param {Interval} interval - the interval. See [Interval]{@link https://date-fns.org/docs/Interval}
	 * @param {Object} [options] - an object with options.
	 * @param {Number} [options.step=1] - the step to increment by. The starts of minutes from the hour of the interval start to the hour of the interval end
	 * @throws {TypeError} 1 argument requie value should be more than 1.
	 * @returns {Date[]} the array withred
	 * @throws {RangeError} `options.step` must be a number equal or greater than 1
	 * @throws {RangeError} The start of an interval cannot be after its end
	 * @throws {RangeError} Date in interval cannot be `Invalid Date`
	 *
	 * @example
	 * // Each minute between 14 October 2020, 13:00 and 14 October 2020, 13:03
	 * const result = eachMinuteOfInterval({
	 *   start: new Date(2014, 9, 14, 13),
	 *   end: new Date(2014, 9, 14, 13, 3)
	 * })
	 * //=> [
	 * //   Wed Oct 14 2014 13:00:00,
	 * //   Wed Oct 14 2014 13:01:00,
	 * //   Wed Oct 14 2014 13:02:00,
	 * //   Wed Oct 14 2014 13:03:00
	 * // ]
	 */
	function eachMinuteOfInterval(interval, options) {
	  (0, _index4.default)(1, arguments);
	  var startDate = (0, _index3.default)((0, _index2.default)(interval.start));
	  var endDate = (0, _index2.default)(interval.end);
	  var startTime = startDate.getTime();
	  var endTime = endDate.getTime();
	
	  if (startTime >= endTime) {
	    throw new RangeError('Invalid interval');
	  }
	
	  var dates = [];
	  var currentDate = startDate;
	  var step = options && 'step' in options ? Number(options.step) : 1;
	  if (step < 1 || isNaN(step)) throw new RangeError('`options.step` must be a number equal or greater than 1');
	
	  while (currentDate.getTime() <= endTime) {
	    dates.push((0, _index2.default)(currentDate));
	    currentDate = (0, _index.default)(currentDate, step);
	  }
	
	  return dates;
	}
	
	module.exports = exports.default;

/***/ },
/* 953 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = eachMonthOfInterval;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name eachMonthOfInterval
	 * @category Interval Helpers
	 * @summary Return the array of months within the specified time interval.
	 *
	 * @description
	 * Return the array of months within the specified time interval.
	 *
	 * @param {Interval} interval - the interval. See [Interval]{@link https://date-fns.org/docs/Interval}
	 * @returns {Date[]} the array with starts of months from the month of the interval start to the month of the interval end
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} The start of an interval cannot be after its end
	 * @throws {RangeError} Date in interval cannot be `Invalid Date`
	 *
	 * @example
	 * // Each month between 6 February 2014 and 10 August 2014:
	 * var result = eachMonthOfInterval({
	 *   start: new Date(2014, 1, 6),
	 *   end: new Date(2014, 7, 10)
	 * })
	 * //=> [
	 * //   Sat Feb 01 2014 00:00:00,
	 * //   Sat Mar 01 2014 00:00:00,
	 * //   Tue Apr 01 2014 00:00:00,
	 * //   Thu May 01 2014 00:00:00,
	 * //   Sun Jun 01 2014 00:00:00,
	 * //   Tue Jul 01 2014 00:00:00,
	 * //   Fri Aug 01 2014 00:00:00
	 * // ]
	 */
	function eachMonthOfInterval(dirtyInterval) {
	  (0, _index2.default)(1, arguments);
	  var interval = dirtyInterval || {};
	  var startDate = (0, _index.default)(interval.start);
	  var endDate = (0, _index.default)(interval.end);
	  var endTime = endDate.getTime();
	  var dates = []; // Throw an exception if start date is after end date or if any date is `Invalid Date`
	
	  if (!(startDate.getTime() <= endTime)) {
	    throw new RangeError('Invalid interval');
	  }
	
	  var currentDate = startDate;
	  currentDate.setHours(0, 0, 0, 0);
	  currentDate.setDate(1);
	
	  while (currentDate.getTime() <= endTime) {
	    dates.push((0, _index.default)(currentDate));
	    currentDate.setMonth(currentDate.getMonth() + 1);
	  }
	
	  return dates;
	}
	
	module.exports = exports.default;

/***/ },
/* 954 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = eachQuarterOfInterval;
	
	var _index = _interopRequireDefault(__webpack_require__(271));
	
	var _index2 = _interopRequireDefault(__webpack_require__(287));
	
	var _index3 = _interopRequireDefault(__webpack_require__(3));
	
	var _index4 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name eachQuarterOfInterval
	 * @category Interval Helpers
	 * @summary Return the array of quarters within the specified time interval.
	 *
	 * @description
	 * Return the array of quarters within the specified time interval.
	 *
	 * @param {Interval} interval - the interval. See [Interval]{@link https://date-fns.org/docs/Interval}
	 * @returns {Date[]} the array with starts of quarters from the quarter of the interval start to the quarter of the interval end
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} The start of an interval cannot be after its end
	 * @throws {RangeError} Date in interval cannot be `Invalid Date`
	 *
	 * @example
	 * // Each quarter within interval 6 February 2014 - 10 August 2014:
	 * var result = eachQuarterOfInterval({
	 *   start: new Date(2014, 1, 6),
	 *   end: new Date(2014, 7, 10)
	 * })
	 * //=> [
	 * //   Wed Jan 01 2014 00:00:00,
	 * //   Tue Apr 01 2014 00:00:00,
	 * //   Tue Jul 01 2014 00:00:00,
	 * // ]
	 */
	function eachQuarterOfInterval(dirtyInterval) {
	  (0, _index4.default)(1, arguments);
	  var interval = dirtyInterval || {};
	  var startDate = (0, _index3.default)(interval.start);
	  var endDate = (0, _index3.default)(interval.end);
	  var endTime = endDate.getTime(); // Throw an exception if start date is after end date or if any date is `Invalid Date`
	
	  if (!(startDate.getTime() <= endTime)) {
	    throw new RangeError('Invalid interval');
	  }
	
	  var startDateQuarter = (0, _index2.default)(startDate);
	  var endDateQuarter = (0, _index2.default)(endDate);
	  endTime = endDateQuarter.getTime();
	  var quarters = [];
	  var currentQuarter = startDateQuarter;
	
	  while (currentQuarter.getTime() <= endTime) {
	    quarters.push((0, _index3.default)(currentQuarter));
	    currentQuarter = (0, _index.default)(currentQuarter, 1);
	  }
	
	  return quarters;
	}
	
	module.exports = exports.default;

/***/ },
/* 955 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = eachWeekOfInterval;
	
	var _index = _interopRequireDefault(__webpack_require__(189));
	
	var _index2 = _interopRequireDefault(__webpack_require__(96));
	
	var _index3 = _interopRequireDefault(__webpack_require__(3));
	
	var _index4 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name eachWeekOfInterval
	 * @category Interval Helpers
	 * @summary Return the array of weeks within the specified time interval.
	 *
	 * @description
	 * Return the array of weeks within the specified time interval.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Interval} interval - the interval. See [Interval]{@link https://date-fns.org/docs/Interval}
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @returns {Date[]} the array with starts of weeks from the week of the interval start to the week of the interval end
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.weekStartsOn` must be 0, 1, ..., 6
	 * @throws {RangeError} The start of an interval cannot be after its end
	 * @throws {RangeError} Date in interval cannot be `Invalid Date`
	 *
	 * @example
	 * // Each week within interval 6 October 2014 - 23 November 2014:
	 * var result = eachWeekOfInterval({
	 *   start: new Date(2014, 9, 6),
	 *   end: new Date(2014, 10, 23)
	 * })
	 * //=> [
	 * //   Sun Oct 05 2014 00:00:00,
	 * //   Sun Oct 12 2014 00:00:00,
	 * //   Sun Oct 19 2014 00:00:00,
	 * //   Sun Oct 26 2014 00:00:00,
	 * //   Sun Nov 02 2014 00:00:00,
	 * //   Sun Nov 09 2014 00:00:00,
	 * //   Sun Nov 16 2014 00:00:00,
	 * //   Sun Nov 23 2014 00:00:00
	 * // ]
	 */
	function eachWeekOfInterval(dirtyInterval, options) {
	  (0, _index4.default)(1, arguments);
	  var interval = dirtyInterval || {};
	  var startDate = (0, _index3.default)(interval.start);
	  var endDate = (0, _index3.default)(interval.end);
	  var endTime = endDate.getTime(); // Throw an exception if start date is after end date or if any date is `Invalid Date`
	
	  if (!(startDate.getTime() <= endTime)) {
	    throw new RangeError('Invalid interval');
	  }
	
	  var startDateWeek = (0, _index2.default)(startDate, options);
	  var endDateWeek = (0, _index2.default)(endDate, options); // Some timezones switch DST at midnight, making start of day unreliable in these timezones, 3pm is a safe bet
	
	  startDateWeek.setHours(15);
	  endDateWeek.setHours(15);
	  endTime = endDateWeek.getTime();
	  var weeks = [];
	  var currentWeek = startDateWeek;
	
	  while (currentWeek.getTime() <= endTime) {
	    currentWeek.setHours(0);
	    weeks.push((0, _index3.default)(currentWeek));
	    currentWeek = (0, _index.default)(currentWeek, 1);
	    currentWeek.setHours(15);
	  }
	
	  return weeks;
	}
	
	module.exports = exports.default;

/***/ },
/* 956 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = eachWeekendOfMonth;
	
	var _index = _interopRequireDefault(__webpack_require__(275));
	
	var _index2 = _interopRequireDefault(__webpack_require__(195));
	
	var _index3 = _interopRequireDefault(__webpack_require__(277));
	
	var _index4 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name eachWeekendOfMonth
	 * @category Month Helpers
	 * @summary List all the Saturdays and Sundays in the given month.
	 *
	 * @description
	 * Get all the Saturdays and Sundays in the given month.
	 *
	 * @param {Date|Number} date - the given month
	 * @returns {Date[]} an array containing all the Saturdays and Sundays
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} The passed date is invalid
	 *
	 * @example
	 * // Lists all Saturdays and Sundays in the given month
	 * const result = eachWeekendOfMonth(new Date(2022, 1, 1))
	 * //=> [
	 * //   Sat Feb 05 2022 00:00:00,
	 * //   Sun Feb 06 2022 00:00:00,
	 * //   Sat Feb 12 2022 00:00:00,
	 * //   Sun Feb 13 2022 00:00:00,
	 * //   Sat Feb 19 2022 00:00:00,
	 * //   Sun Feb 20 2022 00:00:00,
	 * //   Sat Feb 26 2022 00:00:00,
	 * //   Sun Feb 27 2022 00:00:00
	 * // ]
	 */
	function eachWeekendOfMonth(dirtyDate) {
	  (0, _index4.default)(1, arguments);
	  var startDate = (0, _index2.default)(dirtyDate);
	  if (isNaN(startDate.getTime())) throw new RangeError('The passed date is invalid');
	  var endDate = (0, _index3.default)(dirtyDate);
	  return (0, _index.default)({
	    start: startDate,
	    end: endDate
	  });
	}
	
	module.exports = exports.default;

/***/ },
/* 957 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = eachWeekendOfYear;
	
	var _index = _interopRequireDefault(__webpack_require__(275));
	
	var _index2 = _interopRequireDefault(__webpack_require__(289));
	
	var _index3 = _interopRequireDefault(__webpack_require__(413));
	
	var _index4 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name eachWeekendOfYear
	 * @category Year Helpers
	 * @summary List all the Saturdays and Sundays in the year.
	 *
	 * @description
	 * Get all the Saturdays and Sundays in the year.
	 *
	 * @param {Date|Number} date - the given year
	 * @returns {Date[]} an array containing all the Saturdays and Sundays
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} The passed date is invalid
	 *
	 * @example
	 * // Lists all Saturdays and Sundays in the year
	 * var result = eachWeekendOfYear(new Date(2020, 1, 1))
	 * //=> [
	 * //   Sat Jan 03 2020 00:00:00,
	 * //   Sun Jan 04 2020 00:00:00,
	 * //   ...
	 * //   Sun Dec 27 2020 00:00:00
	 * // ]
	 * ]
	 */
	function eachWeekendOfYear(dirtyDate) {
	  (0, _index4.default)(1, arguments);
	  var startDate = (0, _index2.default)(dirtyDate);
	  if (isNaN(startDate)) throw new RangeError('The passed date is invalid');
	  var endDate = (0, _index3.default)(dirtyDate);
	  return (0, _index.default)({
	    start: startDate,
	    end: endDate
	  });
	}
	
	module.exports = exports.default;

/***/ },
/* 958 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = eachYearOfInterval;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name eachYearOfInterval
	 * @category Interval Helpers
	 * @summary Return the array of yearly timestamps within the specified time interval.
	 *
	 * @description
	 * Return the array of yearly timestamps within the specified time interval.
	 *
	 * @param {Interval} interval - the interval. See [Interval]{@link https://date-fns.org/docs/Interval}
	 * @returns {Date[]} the array with starts of yearly timestamps from the month of the interval start to the month of the interval end
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} The start of an interval cannot be after its end
	 * @throws {RangeError} Date in interval cannot be `Invalid Date`
	 *
	 * @example
	 * // Each year between 6 February 2014 and 10 August 2017:
	 * const result = eachYearOfInterval({
	 *   start: new Date(2014, 1, 6),
	 *   end: new Date(2017, 7, 10)
	 * })
	 * //=> [
	 * //   Wed Jan 01 2014 00:00:00,
	 * //   Thu Jan 01 2015 00:00:00,
	 * //   Fri Jan 01 2016 00:00:00,
	 * //   Sun Jan 01 2017 00:00:00
	 * // ]
	 */
	function eachYearOfInterval(dirtyInterval) {
	  (0, _index2.default)(1, arguments);
	  var interval = dirtyInterval || {};
	  var startDate = (0, _index.default)(interval.start);
	  var endDate = (0, _index.default)(interval.end);
	  var endTime = endDate.getTime(); // Throw an exception if start date is after end date or if any date is `Invalid Date`
	
	  if (!(startDate.getTime() <= endTime)) {
	    throw new RangeError('Invalid interval');
	  }
	
	  var dates = [];
	  var currentDate = startDate;
	  currentDate.setHours(0, 0, 0, 0);
	  currentDate.setMonth(0, 1);
	
	  while (currentDate.getTime() <= endTime) {
	    dates.push((0, _index.default)(currentDate));
	    currentDate.setFullYear(currentDate.getFullYear() + 1);
	  }
	
	  return dates;
	}
	
	module.exports = exports.default;

/***/ },
/* 959 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = endOfDecade;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name endOfDecade
	 * @category Decade Helpers
	 * @summary Return the end of a decade for the given date.
	 *
	 * @description
	 * Return the end of a decade for the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the end of a decade
	 * @param {Object} [options] - an object with options.
	 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
	 *
	 * @example
	 * // The end of a decade for 12 May 1984 00:00:00:
	 * const result = endOfDecade(new Date(1984, 4, 12, 00, 00, 00))
	 * //=> Dec 31 1989 23:59:59.999
	 */
	function endOfDecade(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var year = date.getFullYear();
	  var decade = 9 + Math.floor(year / 10) * 10;
	  date.setFullYear(decade, 11, 31);
	  date.setHours(23, 59, 59, 999);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 960 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = endOfHour;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name endOfHour
	 * @category Hour Helpers
	 * @summary Return the end of an hour for the given date.
	 *
	 * @description
	 * Return the end of an hour for the given date.
	 * The result will be in the local timezone.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the end of an hour
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The end of an hour for 2 September 2014 11:55:00:
	 * const result = endOfHour(new Date(2014, 8, 2, 11, 55))
	 * //=> Tue Sep 02 2014 11:59:59.999
	 */
	function endOfHour(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  date.setMinutes(59, 59, 999);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 961 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = endOfISOWeek;
	
	var _index = _interopRequireDefault(__webpack_require__(412));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name endOfISOWeek
	 * @category ISO Week Helpers
	 * @summary Return the end of an ISO week for the given date.
	 *
	 * @description
	 * Return the end of an ISO week for the given date.
	 * The result will be in the local timezone.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the end of an ISO week
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The end of an ISO week for 2 September 2014 11:55:00:
	 * var result = endOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Sun Sep 07 2014 23:59:59.999
	 */
	function endOfISOWeek(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(dirtyDate, {
	    weekStartsOn: 1
	  });
	}
	
	module.exports = exports.default;

/***/ },
/* 962 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = endOfISOWeekYear;
	
	var _index = _interopRequireDefault(__webpack_require__(128));
	
	var _index2 = _interopRequireDefault(__webpack_require__(109));
	
	var _index3 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name endOfISOWeekYear
	 * @category ISO Week-Numbering Year Helpers
	 * @summary Return the end of an ISO week-numbering year for the given date.
	 *
	 * @description
	 * Return the end of an ISO week-numbering year,
	 * which always starts 3 days before the year's first Thursday.
	 * The result will be in the local timezone.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * - The function was renamed from `endOfISOYear` to `endOfISOWeekYear`.
	 *   "ISO week year" is short for [ISO week-numbering year](https://en.wikipedia.org/wiki/ISO_week_date).
	 *   This change makes the name consistent with
	 *   locale-dependent week-numbering year helpers, e.g., `addWeekYears`.
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the end of an ISO week-numbering year
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The end of an ISO week-numbering year for 2 July 2005:
	 * const result = endOfISOWeekYear(new Date(2005, 6, 2))
	 * //=> Sun Jan 01 2006 23:59:59.999
	 */
	function endOfISOWeekYear(dirtyDate) {
	  (0, _index3.default)(1, arguments);
	  var year = (0, _index.default)(dirtyDate);
	  var fourthOfJanuaryOfNextYear = new Date(0);
	  fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
	  fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
	  var date = (0, _index2.default)(fourthOfJanuaryOfNextYear);
	  date.setMilliseconds(date.getMilliseconds() - 1);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 963 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = endOfMinute;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name endOfMinute
	 * @category Minute Helpers
	 * @summary Return the end of a minute for the given date.
	 *
	 * @description
	 * Return the end of a minute for the given date.
	 * The result will be in the local timezone.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the end of a minute
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The end of a minute for 1 December 2014 22:15:45.400:
	 * const result = endOfMinute(new Date(2014, 11, 1, 22, 15, 45, 400))
	 * //=> Mon Dec 01 2014 22:15:59.999
	 */
	function endOfMinute(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  date.setSeconds(59, 999);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 964 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = endOfQuarter;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name endOfQuarter
	 * @category Quarter Helpers
	 * @summary Return the end of a year quarter for the given date.
	 *
	 * @description
	 * Return the end of a year quarter for the given date.
	 * The result will be in the local timezone.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the end of a quarter
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The end of a quarter for 2 September 2014 11:55:00:
	 * const result = endOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Tue Sep 30 2014 23:59:59.999
	 */
	function endOfQuarter(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var currentMonth = date.getMonth();
	  var month = currentMonth - currentMonth % 3 + 3;
	  date.setMonth(month, 0);
	  date.setHours(23, 59, 59, 999);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 965 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = endOfSecond;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name endOfSecond
	 * @category Second Helpers
	 * @summary Return the end of a second for the given date.
	 *
	 * @description
	 * Return the end of a second for the given date.
	 * The result will be in the local timezone.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the end of a second
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The end of a second for 1 December 2014 22:15:45.400:
	 * const result = endOfSecond(new Date(2014, 11, 1, 22, 15, 45, 400))
	 * //=> Mon Dec 01 2014 22:15:45.999
	 */
	function endOfSecond(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  date.setMilliseconds(999);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 966 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = endOfToday;
	
	var _index = _interopRequireDefault(__webpack_require__(276));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name endOfToday
	 * @category Day Helpers
	 * @summary Return the end of today.
	 * @pure false
	 *
	 * @description
	 * Return the end of today.
	 *
	 * > ⚠️ Please note that this function is not present in the FP submodule as
	 * > it uses `Date.now()` internally hence impure and can't be safely curried.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @returns {Date} the end of today
	 *
	 * @example
	 * // If today is 6 October 2014:
	 * var result = endOfToday()
	 * //=> Mon Oct 6 2014 23:59:59.999
	 */
	function endOfToday() {
	  return (0, _index.default)(Date.now());
	}
	
	module.exports = exports.default;

/***/ },
/* 967 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = endOfTomorrow;
	
	/**
	 * @name endOfTomorrow
	 * @category Day Helpers
	 * @summary Return the end of tomorrow.
	 * @pure false
	 *
	 * @description
	 * Return the end of tomorrow.
	 *
	 * > ⚠️ Please note that this function is not present in the FP submodule as
	 * > it uses `new Date()` internally hence impure and can't be safely curried.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @returns {Date} the end of tomorrow
	 *
	 * @example
	 * // If today is 6 October 2014:
	 * const result = endOfTomorrow()
	 * //=> Tue Oct 7 2014 23:59:59.999
	 */
	function endOfTomorrow() {
	  var now = new Date();
	  var year = now.getFullYear();
	  var month = now.getMonth();
	  var day = now.getDate();
	  var date = new Date(0);
	  date.setFullYear(year, month, day + 1);
	  date.setHours(23, 59, 59, 999);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 968 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = endOfYesterday;
	
	/**
	 * @name endOfYesterday
	 * @category Day Helpers
	 * @summary Return the end of yesterday.
	 * @pure false
	 *
	 * @description
	 * Return the end of yesterday.
	 *
	 * > ⚠️ Please note that this function is not present in the FP submodule as
	 * > it uses `new Date()` internally hence impure and can't be safely curried.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @returns {Date} the end of yesterday
	 *
	 * @example
	 * // If today is 6 October 2014:
	 * const result = endOfYesterday()
	 * //=> Sun Oct 5 2014 23:59:59.999
	 */
	function endOfYesterday() {
	  var now = new Date();
	  var year = now.getFullYear();
	  var month = now.getMonth();
	  var day = now.getDate();
	  var date = new Date(0);
	  date.setFullYear(year, month, day - 1);
	  date.setHours(23, 59, 59, 999);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 969 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistanceToNow;
	
	var _index = _interopRequireDefault(__webpack_require__(415));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name formatDistanceToNow
	 * @category Common Helpers
	 * @summary Return the distance between the given date and now in words.
	 * @pure false
	 *
	 * @description
	 * Return the distance between the given date and now in words.
	 *
	 * | Distance to now                                                   | Result              |
	 * |-------------------------------------------------------------------|---------------------|
	 * | 0 ... 30 secs                                                     | less than a minute  |
	 * | 30 secs ... 1 min 30 secs                                         | 1 minute            |
	 * | 1 min 30 secs ... 44 mins 30 secs                                 | [2..44] minutes     |
	 * | 44 mins ... 30 secs ... 89 mins 30 secs                           | about 1 hour        |
	 * | 89 mins 30 secs ... 23 hrs 59 mins 30 secs                        | about [2..24] hours |
	 * | 23 hrs 59 mins 30 secs ... 41 hrs 59 mins 30 secs                 | 1 day               |
	 * | 41 hrs 59 mins 30 secs ... 29 days 23 hrs 59 mins 30 secs         | [2..30] days        |
	 * | 29 days 23 hrs 59 mins 30 secs ... 44 days 23 hrs 59 mins 30 secs | about 1 month       |
	 * | 44 days 23 hrs 59 mins 30 secs ... 59 days 23 hrs 59 mins 30 secs | about 2 months      |
	 * | 59 days 23 hrs 59 mins 30 secs ... 1 yr                           | [2..12] months      |
	 * | 1 yr ... 1 yr 3 months                                            | about 1 year        |
	 * | 1 yr 3 months ... 1 yr 9 month s                                  | over 1 year         |
	 * | 1 yr 9 months ... 2 yrs                                           | almost 2 years      |
	 * | N yrs ... N yrs 3 months                                          | about N years       |
	 * | N yrs 3 months ... N yrs 9 months                                 | over N years        |
	 * | N yrs 9 months ... N+1 yrs                                        | almost N+1 years    |
	 *
	 * With `options.includeSeconds == true`:
	 * | Distance to now     | Result               |
	 * |---------------------|----------------------|
	 * | 0 secs ... 5 secs   | less than 5 seconds  |
	 * | 5 secs ... 10 secs  | less than 10 seconds |
	 * | 10 secs ... 20 secs | less than 20 seconds |
	 * | 20 secs ... 40 secs | half a minute        |
	 * | 40 secs ... 60 secs | less than a minute   |
	 * | 60 secs ... 90 secs | 1 minute             |
	 *
	 * > ⚠️ Please note that this function is not present in the FP submodule as
	 * > it uses `Date.now()` internally hence impure and can't be safely curried.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * - The function was renamed from `distanceInWordsToNow ` to `formatDistanceToNow`
	 *   to make its name consistent with `format` and `formatRelative`.
	 *
	 *   ```javascript
	 *   // Before v2.0.0
	 *
	 *   distanceInWordsToNow(new Date(2014, 6, 2), { addSuffix: true })
	 *   //=> 'in 6 months'
	 *
	 *   // v2.0.0 onward
	 *
	 *   formatDistanceToNow(new Date(2014, 6, 2), { addSuffix: true })
	 *   //=> 'in 6 months'
	 *   ```
	 *
	 * @param {Date|Number} date - the given date
	 * @param {Object} [options] - the object with options
	 * @param {Boolean} [options.includeSeconds=false] - distances less than a minute are more detailed
	 * @param {Boolean} [options.addSuffix=false] - result specifies if now is earlier or later than the passed date
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @returns {String} the distance in words
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `date` must not be Invalid Date
	 * @throws {RangeError} `options.locale` must contain `formatDistance` property
	 *
	 * @example
	 * // If today is 1 January 2015, what is the distance to 2 July 2014?
	 * var result = formatDistanceToNow(
	 *   new Date(2014, 6, 2)
	 * )
	 * //=> '6 months'
	 *
	 * @example
	 * // If now is 1 January 2015 00:00:00,
	 * // what is the distance to 1 January 2015 00:00:15, including seconds?
	 * var result = formatDistanceToNow(
	 *   new Date(2015, 0, 1, 0, 0, 15),
	 *   {includeSeconds: true}
	 * )
	 * //=> 'less than 20 seconds'
	 *
	 * @example
	 * // If today is 1 January 2015,
	 * // what is the distance to 1 January 2016, with a suffix?
	 * var result = formatDistanceToNow(
	 *   new Date(2016, 0, 1),
	 *   {addSuffix: true}
	 * )
	 * //=> 'in about 1 year'
	 *
	 * @example
	 * // If today is 1 January 2015,
	 * // what is the distance to 1 August 2016 in Esperanto?
	 * var eoLocale = require('date-fns/locale/eo')
	 * var result = formatDistanceToNow(
	 *   new Date(2016, 7, 1),
	 *   {locale: eoLocale}
	 * )
	 * //=> 'pli ol 1 jaro'
	 */
	function formatDistanceToNow(dirtyDate, dirtyOptions) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(dirtyDate, Date.now(), dirtyOptions);
	}
	
	module.exports = exports.default;

/***/ },
/* 970 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistanceToNowStrict;
	
	var _index = _interopRequireDefault(__webpack_require__(416));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name formatDistanceToNowStrict
	 * @category Common Helpers
	 * @summary Return the distance between the given date and now in words.
	 * @pure false
	 *
	 * @description
	 * Return the distance between the given dates in words, using strict units.
	 * This is like `formatDistance`, but does not use helpers like 'almost', 'over',
	 * 'less than' and the like.
	 *
	 * | Distance between dates | Result              |
	 * |------------------------|---------------------|
	 * | 0 ... 59 secs          | [0..59] seconds     |
	 * | 1 ... 59 mins          | [1..59] minutes     |
	 * | 1 ... 23 hrs           | [1..23] hours       |
	 * | 1 ... 29 days          | [1..29] days        |
	 * | 1 ... 11 months        | [1..11] months      |
	 * | 1 ... N years          | [1..N]  years       |
	 *
	 * @param {Date|Number} date - the given date
	 * @param {Object} [options] - an object with options.
	 * @param {Boolean} [options.addSuffix=false] - result indicates if the second date is earlier or later than the first
	 * @param {'second'|'minute'|'hour'|'day'|'month'|'year'} [options.unit] - if specified, will force a unit
	 * @param {'floor'|'ceil'|'round'} [options.roundingMethod='round'] - which way to round partial units
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @returns {String} the distance in words
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `date` must not be Invalid Date
	 * @throws {RangeError} `options.locale` must contain `formatDistance` property
	 *
	 * @example
	 * // If today is 1 January 2015, what is the distance to 2 July 2014?
	 * var result = formatDistanceToNowStrict(
	 *   new Date(2014, 6, 2)
	 * )
	 * //=> '6 months'
	 *
	 * @example
	 * // If now is 1 January 2015 00:00:00,
	 * // what is the distance to 1 January 2015 00:00:15, including seconds?
	 * var result = formatDistanceToNowStrict(
	 *   new Date(2015, 0, 1, 0, 0, 15)
	 * )
	 * //=> '20 seconds'
	 *
	 * @example
	 * // If today is 1 January 2015,
	 * // what is the distance to 1 January 2016, with a suffix?
	 * var result = formatDistanceToNowStrict(
	 *   new Date(2016, 0, 1),
	 *   {addSuffix: true}
	 * )
	 * //=> 'in 1 year'
	 *
	 * @example
	 * // If today is 28 January 2015,
	 * // what is the distance to 1 January 2015, in months, rounded up??
	 * var result = formatDistanceToNowStrict(new Date(2015, 0, 1), {
	 *   unit: 'month',
	 *   roundingMethod: 'ceil'
	 * })
	 * //=> '1 month'
	 *
	 * @example
	 * // If today is 1 January 2015,
	 * // what is the distance to 1 August 2016 in Esperanto?
	 * var eoLocale = require('date-fns/locale/eo')
	 * var result = formatDistanceToNowStrict(
	 *   new Date(2016, 7, 1),
	 *   {locale: eoLocale}
	 * )
	 * //=> '1 jaro'
	 */
	function formatDistanceToNowStrict(dirtyDate, dirtyOptions) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(dirtyDate, Date.now(), dirtyOptions);
	}
	
	module.exports = exports.default;

/***/ },
/* 971 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDuration;
	
	var _index = _interopRequireDefault(__webpack_require__(108));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultFormat = ['years', 'months', 'weeks', 'days', 'hours', 'minutes', 'seconds'];
	
	/**
	 * @name formatDuration
	 * @category Common Helpers
	 * @summary Formats a duration in human-readable format
	 *
	 * @description
	 * Return human-readable duration string i.e. "9 months 2 days"
	 *
	 * @param {Duration} duration - the duration to format
	 * @param {Object} [options] - an object with options.
	 * @param {string[]} [options.format=['years', 'months', 'weeks', 'days', 'hours', 'minutes', 'seconds']] - the array of units to format
	 * @param {boolean} [options.zero=false] - should zeros be included in the output?
	 * @param {string} [options.delimiter=' '] - delimiter string
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @returns {string} the formatted date string
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Format full duration
	 * formatDuration({
	 *   years: 2,
	 *   months: 9,
	 *   weeks: 1,
	 *   days: 7,
	 *   hours: 5,
	 *   minutes: 9,
	 *   seconds: 30
	 * })
	 * //=> '2 years 9 months 1 week 7 days 5 hours 9 minutes 30 seconds'
	 *
	 * @example
	 * // Format partial duration
	 * formatDuration({ months: 9, days: 2 })
	 * //=> '9 months 2 days'
	 *
	 * @example
	 * // Customize the format
	 * formatDuration(
	 *   {
	 *     years: 2,
	 *     months: 9,
	 *     weeks: 1,
	 *     days: 7,
	 *     hours: 5,
	 *     minutes: 9,
	 *     seconds: 30
	 *   },
	 *   { format: ['months', 'weeks'] }
	 * ) === '9 months 1 week'
	 *
	 * @example
	 * // Customize the zeros presence
	 * formatDuration({ years: 0, months: 9 })
	 * //=> '9 months'
	 * formatDuration({ years: 0, months: 9 }, { zero: true })
	 * //=> '0 years 9 months'
	 *
	 * @example
	 * // Customize the delimiter
	 * formatDuration({ years: 2, months: 9, weeks: 3 }, { delimiter: ', ' })
	 * //=> '2 years, 9 months, 3 weeks'
	 */
	function formatDuration(duration) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  if (arguments.length < 1) {
	    throw new TypeError("1 argument required, but only ".concat(arguments.length, " present"));
	  }
	
	  var format = (options === null || options === void 0 ? void 0 : options.format) || defaultFormat;
	  var locale = (options === null || options === void 0 ? void 0 : options.locale) || _index.default;
	  var zero = (options === null || options === void 0 ? void 0 : options.zero) || false;
	  var delimiter = (options === null || options === void 0 ? void 0 : options.delimiter) || ' ';
	  var result = format.reduce(function (acc, unit) {
	    var token = "x".concat(unit.replace(/(^.)/, function (m) {
	      return m.toUpperCase();
	    }));
	    var addChunk = typeof duration[unit] === 'number' && (zero || duration[unit]);
	    return addChunk && locale.formatDistance ? acc.concat(locale.formatDistance(token, duration[unit])) : acc;
	  }, []).join(delimiter);
	  return result;
	}
	
	module.exports = exports.default;

/***/ },
/* 972 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatISO;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(127));
	
	var _index3 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name formatISO
	 * @category Common Helpers
	 * @summary Format the date according to the ISO 8601 standard (https://support.sas.com/documentation/cdl/en/lrdict/64316/HTML/default/viewer.htm#a003169814.htm).
	 *
	 * @description
	 * Return the formatted date string in ISO 8601 format. Options may be passed to control the parts and notations of the date.
	 *
	 * @param {Date|Number} date - the original date
	 * @param {Object} [options] - an object with options.
	 * @param {'extended'|'basic'} [options.format='extended'] - if 'basic', hide delimiters between date and time values.
	 * @param {'complete'|'date'|'time'} [options.representation='complete'] - format date, time with local time zone, or both.
	 * @returns {String} the formatted date string (in local time zone)
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `date` must not be Invalid Date
	 * @throws {RangeError} `options.format` must be 'extended' or 'basic'
	 * @throws {RangeError} `options.represenation` must be 'date', 'time' or 'complete'
	 *
	 * @example
	 * // Represent 18 September 2019 in ISO 8601 format (local time zone is UTC):
	 * const result = formatISO(new Date(2019, 8, 18, 19, 0, 52))
	 * //=> '2019-09-18T19:00:52Z'
	 *
	 * @example
	 * // Represent 18 September 2019 in ISO 8601, short format (local time zone is UTC):
	 * const result = formatISO(new Date(2019, 8, 18, 19, 0, 52), { format: 'basic' })
	 * //=> '20190918T190052'
	 *
	 * @example
	 * // Represent 18 September 2019 in ISO 8601 format, date only:
	 * const result = formatISO(new Date(2019, 8, 18, 19, 0, 52), { representation: 'date' })
	 * //=> '2019-09-18'
	 *
	 * @example
	 * // Represent 18 September 2019 in ISO 8601 format, time only (local time zone is UTC):
	 * const result = formatISO(new Date(2019, 8, 18, 19, 0, 52), { representation: 'time' })
	 * //=> '19:00:52Z'
	 */
	function formatISO(date, options) {
	  (0, _index3.default)(1, arguments);
	  var originalDate = (0, _index.default)(date);
	
	  if (isNaN(originalDate.getTime())) {
	    throw new RangeError('Invalid time value');
	  }
	
	  var format = !(options !== null && options !== void 0 && options.format) ? 'extended' : String(options.format);
	  var representation = !(options !== null && options !== void 0 && options.representation) ? 'complete' : String(options.representation);
	
	  if (format !== 'extended' && format !== 'basic') {
	    throw new RangeError("format must be 'extended' or 'basic'");
	  }
	
	  if (representation !== 'date' && representation !== 'time' && representation !== 'complete') {
	    throw new RangeError("representation must be 'date', 'time', or 'complete'");
	  }
	
	  var result = '';
	  var tzOffset = '';
	  var dateDelimiter = format === 'extended' ? '-' : '';
	  var timeDelimiter = format === 'extended' ? ':' : ''; // Representation is either 'date' or 'complete'
	
	  if (representation !== 'time') {
	    var day = (0, _index2.default)(originalDate.getDate(), 2);
	    var month = (0, _index2.default)(originalDate.getMonth() + 1, 2);
	    var year = (0, _index2.default)(originalDate.getFullYear(), 4); // yyyyMMdd or yyyy-MM-dd.
	
	    result = "".concat(year).concat(dateDelimiter).concat(month).concat(dateDelimiter).concat(day);
	  } // Representation is either 'time' or 'complete'
	
	
	  if (representation !== 'date') {
	    // Add the timezone.
	    var offset = originalDate.getTimezoneOffset();
	
	    if (offset !== 0) {
	      var absoluteOffset = Math.abs(offset);
	      var hourOffset = (0, _index2.default)(Math.floor(absoluteOffset / 60), 2);
	      var minuteOffset = (0, _index2.default)(absoluteOffset % 60, 2); // If less than 0, the sign is +, because it is ahead of time.
	
	      var sign = offset < 0 ? '+' : '-';
	      tzOffset = "".concat(sign).concat(hourOffset, ":").concat(minuteOffset);
	    } else {
	      tzOffset = 'Z';
	    }
	
	    var hour = (0, _index2.default)(originalDate.getHours(), 2);
	    var minute = (0, _index2.default)(originalDate.getMinutes(), 2);
	    var second = (0, _index2.default)(originalDate.getSeconds(), 2); // If there's also date, separate it with time with 'T'
	
	    var separator = result === '' ? '' : 'T'; // Creates a time string consisting of hour, minute, and second, separated by delimiters, if defined.
	
	    var time = [hour, minute, second].join(timeDelimiter); // HHmmss or HH:mm:ss.
	
	    result = "".concat(result).concat(separator).concat(time).concat(tzOffset);
	  }
	
	  return result;
	}
	
	module.exports = exports.default;

/***/ },
/* 973 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatISO9075;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(83));
	
	var _index3 = _interopRequireDefault(__webpack_require__(127));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name formatISO9075
	 * @category Common Helpers
	 * @summary Format the date according to the ISO 9075 standard (https://dev.mysql.com/doc/refman/5.7/en/date-and-time-functions.html#function_get-format).
	 *
	 * @description
	 * Return the formatted date string in ISO 9075 format. Options may be passed to control the parts and notations of the date.
	 *
	 * @param {Date|Number} date - the original date
	 * @param {Object} [options] - an object with options.
	 * @param {'extended'|'basic'} [options.format='extended'] - if 'basic', hide delimiters between date and time values.
	 * @param {'complete'|'date'|'time'} [options.representation='complete'] - format date, time, or both.
	 * @returns {String} the formatted date string
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `date` must not be Invalid Date
	 * @throws {RangeError} `options.format` must be 'extended' or 'basic'
	 * @throws {RangeError} `options.represenation` must be 'date', 'time' or 'complete'
	 *
	 * @example
	 * // Represent 18 September 2019 in ISO 9075 format:
	 * const result = formatISO9075(new Date(2019, 8, 18, 19, 0, 52))
	 * //=> '2019-09-18 19:00:52'
	 *
	 * @example
	 * // Represent 18 September 2019 in ISO 9075, short format:
	 * const result = formatISO9075(new Date(2019, 8, 18, 19, 0, 52), { format: 'basic' })
	 * //=> '20190918 190052'
	 *
	 * @example
	 * // Represent 18 September 2019 in ISO 9075 format, date only:
	 * const result = formatISO9075(new Date(2019, 8, 18, 19, 0, 52), { representation: 'date' })
	 * //=> '2019-09-18'
	 *
	 * @example
	 * // Represent 18 September 2019 in ISO 9075 format, time only:
	 * const result = formatISO9075(new Date(2019, 8, 18, 19, 0, 52), { representation: 'time' })
	 * //=> '19:00:52'
	 */
	function formatISO9075(dirtyDate, dirtyOptions) {
	  if (arguments.length < 1) {
	    throw new TypeError("1 argument required, but only ".concat(arguments.length, " present"));
	  }
	
	  var originalDate = (0, _index.default)(dirtyDate);
	
	  if (!(0, _index2.default)(originalDate)) {
	    throw new RangeError('Invalid time value');
	  }
	
	  var options = dirtyOptions || {};
	  var format = options.format == null ? 'extended' : String(options.format);
	  var representation = options.representation == null ? 'complete' : String(options.representation);
	
	  if (format !== 'extended' && format !== 'basic') {
	    throw new RangeError("format must be 'extended' or 'basic'");
	  }
	
	  if (representation !== 'date' && representation !== 'time' && representation !== 'complete') {
	    throw new RangeError("representation must be 'date', 'time', or 'complete'");
	  }
	
	  var result = '';
	  var dateDelimiter = format === 'extended' ? '-' : '';
	  var timeDelimiter = format === 'extended' ? ':' : ''; // Representation is either 'date' or 'complete'
	
	  if (representation !== 'time') {
	    var day = (0, _index3.default)(originalDate.getDate(), 2);
	    var month = (0, _index3.default)(originalDate.getMonth() + 1, 2);
	    var year = (0, _index3.default)(originalDate.getFullYear(), 4); // yyyyMMdd or yyyy-MM-dd.
	
	    result = "".concat(year).concat(dateDelimiter).concat(month).concat(dateDelimiter).concat(day);
	  } // Representation is either 'time' or 'complete'
	
	
	  if (representation !== 'date') {
	    var hour = (0, _index3.default)(originalDate.getHours(), 2);
	    var minute = (0, _index3.default)(originalDate.getMinutes(), 2);
	    var second = (0, _index3.default)(originalDate.getSeconds(), 2); // If there's also date, separate it with time with a space
	
	    var separator = result === '' ? '' : ' '; // HHmmss or HH:mm:ss.
	
	    result = "".concat(result).concat(separator).concat(hour).concat(timeDelimiter).concat(minute).concat(timeDelimiter).concat(second);
	  }
	
	  return result;
	}
	
	module.exports = exports.default;

/***/ },
/* 974 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatISODuration;
	
	var _index = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name formatISODuration
	 * @category Common Helpers
	 * @summary Format a duration object according as ISO 8601 duration string
	 *
	 * @description
	 * Format a duration object according to the ISO 8601 duration standard (https://www.digi.com/resources/documentation/digidocs/90001437-13/reference/r_iso_8601_duration_format.htm)
	 *
	 * @param {Duration} duration - the duration to format
	 *
	 * @returns {String} The ISO 8601 duration string
	 * @throws {TypeError} Requires 1 argument
	 * @throws {Error} Argument must be an object
	 *
	 * @example
	 * // Format the given duration as ISO 8601 string
	 * const result = formatISODuration({
	 *   years: 39,
	 *   months: 2,
	 *   days: 20,
	 *   hours: 7,
	 *   minutes: 5,
	 *   seconds: 0
	 * })
	 * //=> 'P39Y2M20DT0H0M0S'
	 */
	function formatISODuration(duration) {
	  (0, _index.default)(1, arguments);
	  if (typeof duration !== 'object') throw new Error('Duration must be an object');
	  var _duration$years = duration.years,
	      years = _duration$years === void 0 ? 0 : _duration$years,
	      _duration$months = duration.months,
	      months = _duration$months === void 0 ? 0 : _duration$months,
	      _duration$days = duration.days,
	      days = _duration$days === void 0 ? 0 : _duration$days,
	      _duration$hours = duration.hours,
	      hours = _duration$hours === void 0 ? 0 : _duration$hours,
	      _duration$minutes = duration.minutes,
	      minutes = _duration$minutes === void 0 ? 0 : _duration$minutes,
	      _duration$seconds = duration.seconds,
	      seconds = _duration$seconds === void 0 ? 0 : _duration$seconds;
	  return "P".concat(years, "Y").concat(months, "M").concat(days, "DT").concat(hours, "H").concat(minutes, "M").concat(seconds, "S");
	}
	
	module.exports = exports.default;

/***/ },
/* 975 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRFC3339;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(83));
	
	var _index3 = _interopRequireDefault(__webpack_require__(127));
	
	var _index4 = _interopRequireDefault(__webpack_require__(19));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name formatRFC3339
	 * @category Common Helpers
	 * @summary Format the date according to the RFC 3339 standard (https://tools.ietf.org/html/rfc3339#section-5.6).
	 *
	 * @description
	 * Return the formatted date string in RFC 3339 format. Options may be passed to control the parts and notations of the date.
	 *
	 * @param {Date|Number} date - the original date
	 * @param {Object} [options] - an object with options.
	 * @param {0|1|2|3} [options.fractionDigits=0] - number of digits after the decimal point after seconds
	 * @returns {String} the formatted date string
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `date` must not be Invalid Date
	 * @throws {RangeError} `options.fractionDigits` must be between 0 and 3
	 *
	 * @example
	 * // Represent 18 September 2019 in RFC 3339 format:
	 * const result = formatRFC3339(new Date(2019, 8, 18, 19, 0, 52))
	 * //=> '2019-09-18T19:00:52Z'
	 *
	 * @example
	 * // Represent 18 September 2019 in RFC 3339 format, 2 digits of second fraction:
	 * const result = formatRFC3339(new Date(2019, 8, 18, 19, 0, 52, 234), { fractionDigits: 2 })
	 * //=> '2019-09-18T19:00:52.23Z'
	 *
	 * @example
	 * // Represent 18 September 2019 in RFC 3339 format, 3 digits of second fraction
	 * const result = formatRFC3339(new Date(2019, 8, 18, 19, 0, 52, 234), { fractionDigits: 3 })
	 * //=> '2019-09-18T19:00:52.234Z'
	 */
	function formatRFC3339(dirtyDate, dirtyOptions) {
	  if (arguments.length < 1) {
	    throw new TypeError("1 arguments required, but only ".concat(arguments.length, " present"));
	  }
	
	  var originalDate = (0, _index.default)(dirtyDate);
	
	  if (!(0, _index2.default)(originalDate)) {
	    throw new RangeError('Invalid time value');
	  }
	
	  var _ref = dirtyOptions || {},
	      _ref$fractionDigits = _ref.fractionDigits,
	      fractionDigits = _ref$fractionDigits === void 0 ? 0 : _ref$fractionDigits; // Test if fractionDigits is between 0 and 3 _and_ is not NaN
	
	
	  if (!(fractionDigits >= 0 && fractionDigits <= 3)) {
	    throw new RangeError('fractionDigits must be between 0 and 3 inclusively');
	  }
	
	  var day = (0, _index3.default)(originalDate.getDate(), 2);
	  var month = (0, _index3.default)(originalDate.getMonth() + 1, 2);
	  var year = originalDate.getFullYear();
	  var hour = (0, _index3.default)(originalDate.getHours(), 2);
	  var minute = (0, _index3.default)(originalDate.getMinutes(), 2);
	  var second = (0, _index3.default)(originalDate.getSeconds(), 2);
	  var fractionalSecond = '';
	
	  if (fractionDigits > 0) {
	    var milliseconds = originalDate.getMilliseconds();
	    var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, fractionDigits - 3));
	    fractionalSecond = '.' + (0, _index3.default)(fractionalSeconds, fractionDigits);
	  }
	
	  var offset = '';
	  var tzOffset = originalDate.getTimezoneOffset();
	
	  if (tzOffset !== 0) {
	    var absoluteOffset = Math.abs(tzOffset);
	    var hourOffset = (0, _index3.default)((0, _index4.default)(absoluteOffset / 60), 2);
	    var minuteOffset = (0, _index3.default)(absoluteOffset % 60, 2); // If less than 0, the sign is +, because it is ahead of time.
	
	    var sign = tzOffset < 0 ? '+' : '-';
	    offset = "".concat(sign).concat(hourOffset, ":").concat(minuteOffset);
	  } else {
	    offset = 'Z';
	  }
	
	  return "".concat(year, "-").concat(month, "-").concat(day, "T").concat(hour, ":").concat(minute, ":").concat(second).concat(fractionalSecond).concat(offset);
	}
	
	module.exports = exports.default;

/***/ },
/* 976 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRFC7231;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(83));
	
	var _index3 = _interopRequireDefault(__webpack_require__(127));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
	var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
	/**
	 * @name formatRFC7231
	 * @category Common Helpers
	 * @summary Format the date according to the RFC 7231 standard (https://tools.ietf.org/html/rfc7231#section-7.1.1.1).
	 *
	 * @description
	 * Return the formatted date string in RFC 7231 format.
	 * The result will always be in UTC timezone.
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {String} the formatted date string
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `date` must not be Invalid Date
	 *
	 * @example
	 * // Represent 18 September 2019 in RFC 7231 format:
	 * const result = formatRFC7231(new Date(2019, 8, 18, 19, 0, 52))
	 * //=> 'Wed, 18 Sep 2019 19:00:52 GMT'
	 */
	
	function formatRFC7231(dirtyDate) {
	  if (arguments.length < 1) {
	    throw new TypeError("1 arguments required, but only ".concat(arguments.length, " present"));
	  }
	
	  var originalDate = (0, _index.default)(dirtyDate);
	
	  if (!(0, _index2.default)(originalDate)) {
	    throw new RangeError('Invalid time value');
	  }
	
	  var dayName = days[originalDate.getUTCDay()];
	  var dayOfMonth = (0, _index3.default)(originalDate.getUTCDate(), 2);
	  var monthName = months[originalDate.getUTCMonth()];
	  var year = originalDate.getUTCFullYear();
	  var hour = (0, _index3.default)(originalDate.getUTCHours(), 2);
	  var minute = (0, _index3.default)(originalDate.getUTCMinutes(), 2);
	  var second = (0, _index3.default)(originalDate.getUTCSeconds(), 2); // Result variables.
	
	  return "".concat(dayName, ", ").concat(dayOfMonth, " ").concat(monthName, " ").concat(year, " ").concat(hour, ":").concat(minute, ":").concat(second, " GMT");
	}
	
	module.exports = exports.default;

/***/ },
/* 977 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRelative;
	
	var _index = _interopRequireDefault(__webpack_require__(106));
	
	var _index2 = _interopRequireDefault(__webpack_require__(414));
	
	var _index3 = _interopRequireDefault(__webpack_require__(108));
	
	var _index4 = _interopRequireDefault(__webpack_require__(153));
	
	var _index5 = _interopRequireDefault(__webpack_require__(3));
	
	var _index6 = _interopRequireDefault(__webpack_require__(81));
	
	var _index7 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name formatRelative
	 * @category Common Helpers
	 * @summary Represent the date in words relative to the given base date.
	 *
	 * @description
	 * Represent the date in words relative to the given base date.
	 *
	 * | Distance to the base date | Result                    |
	 * |---------------------------|---------------------------|
	 * | Previous 6 days           | last Sunday at 04:30 AM   |
	 * | Last day                  | yesterday at 04:30 AM     |
	 * | Same day                  | today at 04:30 AM         |
	 * | Next day                  | tomorrow at 04:30 AM      |
	 * | Next 6 days               | Sunday at 04:30 AM        |
	 * | Other                     | 12/31/2017                |
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to format
	 * @param {Date|Number} baseDate - the date to compare with
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @returns {String} the date in words
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} `date` must not be Invalid Date
	 * @throws {RangeError} `baseDate` must not be Invalid Date
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 * @throws {RangeError} `options.locale` must contain `localize` property
	 * @throws {RangeError} `options.locale` must contain `formatLong` property
	 * @throws {RangeError} `options.locale` must contain `formatRelative` property
	 *
	 * @example
	 * // Represent the date of 6 days ago in words relative to the given base date. In this example, today is Wednesday
	 * const result = formatRelative(addDays(new Date(), -6), new Date())
	 * //=> "last Thursday at 12:45 AM"
	 */
	function formatRelative(dirtyDate, dirtyBaseDate, dirtyOptions) {
	  (0, _index7.default)(2, arguments);
	  var date = (0, _index5.default)(dirtyDate);
	  var baseDate = (0, _index5.default)(dirtyBaseDate);
	
	  var _ref = dirtyOptions || {},
	      _ref$locale = _ref.locale,
	      locale = _ref$locale === void 0 ? _index3.default : _ref$locale,
	      _ref$weekStartsOn = _ref.weekStartsOn,
	      weekStartsOn = _ref$weekStartsOn === void 0 ? 0 : _ref$weekStartsOn;
	
	  if (!locale.localize) {
	    throw new RangeError('locale must contain localize property');
	  }
	
	  if (!locale.formatLong) {
	    throw new RangeError('locale must contain formatLong property');
	  }
	
	  if (!locale.formatRelative) {
	    throw new RangeError('locale must contain formatRelative property');
	  }
	
	  var diff = (0, _index.default)(date, baseDate);
	
	  if (isNaN(diff)) {
	    throw new RangeError('Invalid time value');
	  }
	
	  var token;
	
	  if (diff < -6) {
	    token = 'other';
	  } else if (diff < -1) {
	    token = 'lastWeek';
	  } else if (diff < 0) {
	    token = 'yesterday';
	  } else if (diff < 1) {
	    token = 'today';
	  } else if (diff < 2) {
	    token = 'tomorrow';
	  } else if (diff < 7) {
	    token = 'nextWeek';
	  } else {
	    token = 'other';
	  }
	
	  var utcDate = (0, _index4.default)(date, (0, _index6.default)(date));
	  var utcBaseDate = (0, _index4.default)(baseDate, (0, _index6.default)(baseDate));
	  var formatStr = locale.formatRelative(token, utcDate, utcBaseDate, {
	    locale: locale,
	    weekStartsOn: weekStartsOn
	  });
	  return (0, _index2.default)(date, formatStr, {
	    locale: locale,
	    weekStartsOn: weekStartsOn
	  });
	}
	
	module.exports = exports.default;

/***/ },
/* 978 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = fromUnixTime;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(19));
	
	var _index3 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name fromUnixTime
	 * @category Timestamp Helpers
	 * @summary Create a date from a Unix timestamp.
	 *
	 * @description
	 * Create a date from a Unix timestamp (in seconds). Decimal values will be discarded.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Number} unixTime - the given Unix timestamp (in seconds)
	 * @returns {Date} the date
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Create the date 29 February 2012 11:45:05:
	 * const result = fromUnixTime(1330515905)
	 * //=> Wed Feb 29 2012 11:45:05
	 */
	function fromUnixTime(dirtyUnixTime) {
	  (0, _index3.default)(1, arguments);
	  var unixTime = (0, _index2.default)(dirtyUnixTime);
	  return (0, _index.default)(unixTime * 1000);
	}
	
	module.exports = exports.default;

/***/ },
/* 979 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getDayOfYear;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(289));
	
	var _index3 = _interopRequireDefault(__webpack_require__(106));
	
	var _index4 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name getDayOfYear
	 * @category Day Helpers
	 * @summary Get the day of the year of the given date.
	 *
	 * @description
	 * Get the day of the year of the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the day of year
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Which day of the year is 2 July 2014?
	 * const result = getDayOfYear(new Date(2014, 6, 2))
	 * //=> 183
	 */
	function getDayOfYear(dirtyDate) {
	  (0, _index4.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var diff = (0, _index3.default)(date, (0, _index2.default)(date));
	  var dayOfYear = diff + 1;
	  return dayOfYear;
	}
	
	module.exports = exports.default;

/***/ },
/* 980 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getDaysInYear;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(427));
	
	var _index3 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name getDaysInYear
	 * @category Year Helpers
	 * @summary Get the number of days in a year of the given date.
	 *
	 * @description
	 * Get the number of days in a year of the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the number of days in a year
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // How many days are in 2012?
	 * const result = getDaysInYear(new Date(2012, 0, 1))
	 * //=> 366
	 */
	function getDaysInYear(dirtyDate) {
	  (0, _index3.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	
	  if (String(new Date(date)) === 'Invalid Date') {
	    return NaN;
	  }
	
	  return (0, _index2.default)(date) ? 366 : 365;
	}
	
	module.exports = exports.default;

/***/ },
/* 981 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getDecade;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name getDecade
	 * @category Decade Helpers
	 * @summary Get the decade of the given date.
	 *
	 * @description
	 * Get the decade of the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the year of decade
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Which decade belongs 27 November 1942?
	 * const result = getDecade(new Date(1942, 10, 27))
	 * //=> 1940
	 */
	function getDecade(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var year = date.getFullYear();
	  var decade = Math.floor(year / 10) * 10;
	  return decade;
	}
	
	module.exports = exports.default;

/***/ },
/* 982 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getHours;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name getHours
	 * @category Hour Helpers
	 * @summary Get the hours of the given date.
	 *
	 * @description
	 * Get the hours of the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the hours
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Get the hours of 29 February 2012 11:45:00:
	 * const result = getHours(new Date(2012, 1, 29, 11, 45))
	 * //=> 11
	 */
	function getHours(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var hours = date.getHours();
	  return hours;
	}
	
	module.exports = exports.default;

/***/ },
/* 983 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getISOWeeksInYear;
	
	var _index = _interopRequireDefault(__webpack_require__(152));
	
	var _index2 = _interopRequireDefault(__webpack_require__(189));
	
	var _index3 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MILLISECONDS_IN_WEEK = 604800000;
	/**
	 * @name getISOWeeksInYear
	 * @category ISO Week-Numbering Year Helpers
	 * @summary Get the number of weeks in an ISO week-numbering year of the given date.
	 *
	 * @description
	 * Get the number of weeks in an ISO week-numbering year of the given date.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the number of ISO weeks in a year
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // How many weeks are in ISO week-numbering year 2015?
	 * const result = getISOWeeksInYear(new Date(2015, 1, 11))
	 * //=> 53
	 */
	
	function getISOWeeksInYear(dirtyDate) {
	  (0, _index3.default)(1, arguments);
	  var thisYear = (0, _index.default)(dirtyDate);
	  var nextYear = (0, _index.default)((0, _index2.default)(thisYear, 60));
	  var diff = nextYear.valueOf() - thisYear.valueOf(); // Round the number of weeks to the nearest integer
	  // because the number of milliseconds in a week is not constant
	  // (e.g. it's different in the week of the daylight saving time clock shift)
	
	  return Math.round(diff / MILLISECONDS_IN_WEEK);
	}
	
	module.exports = exports.default;

/***/ },
/* 984 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getMilliseconds;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name getMilliseconds
	 * @category Millisecond Helpers
	 * @summary Get the milliseconds of the given date.
	 *
	 * @description
	 * Get the milliseconds of the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the milliseconds
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Get the milliseconds of 29 February 2012 11:45:05.123:
	 * const result = getMilliseconds(new Date(2012, 1, 29, 11, 45, 5, 123))
	 * //=> 123
	 */
	function getMilliseconds(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var milliseconds = date.getMilliseconds();
	  return milliseconds;
	}
	
	module.exports = exports.default;

/***/ },
/* 985 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getMinutes;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name getMinutes
	 * @category Minute Helpers
	 * @summary Get the minutes of the given date.
	 *
	 * @description
	 * Get the minutes of the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the minutes
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Get the minutes of 29 February 2012 11:45:05:
	 * const result = getMinutes(new Date(2012, 1, 29, 11, 45, 5))
	 * //=> 45
	 */
	function getMinutes(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var minutes = date.getMinutes();
	  return minutes;
	}
	
	module.exports = exports.default;

/***/ },
/* 986 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getMonth;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name getMonth
	 * @category Month Helpers
	 * @summary Get the month of the given date.
	 *
	 * @description
	 * Get the month of the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the month
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Which month is 29 February 2012?
	 * const result = getMonth(new Date(2012, 1, 29))
	 * //=> 1
	 */
	function getMonth(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var month = date.getMonth();
	  return month;
	}
	
	module.exports = exports.default;

/***/ },
/* 987 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getOverlappingDaysInIntervals;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MILLISECONDS_IN_DAY = 24 * 60 * 60 * 1000;
	/**
	 * @name getOverlappingDaysInIntervals
	 * @category Interval Helpers
	 * @summary Get the number of days that overlap in two time intervals
	 *
	 * @description
	 * Get the number of days that overlap in two time intervals
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * - The function was renamed from `getOverlappingDaysInRanges` to `getOverlappingDaysInIntervals`.
	 *   This change was made to mirror the use of the word "interval" in standard ISO 8601:2004 terminology:
	 *
	 *   ```
	 *   2.1.3
	 *   time interval
	 *   part of the time axis limited by two instants
	 *   ```
	 *
	 *   Also, this function now accepts an object with `start` and `end` properties
	 *   instead of two arguments as an interval.
	 *   This function now throws `RangeError` if the start of the interval is after its end
	 *   or if any date in the interval is `Invalid Date`.
	 *
	 *   ```javascript
	 *   // Before v2.0.0
	 *
	 *   getOverlappingDaysInRanges(
	 *     new Date(2014, 0, 10), new Date(2014, 0, 20),
	 *     new Date(2014, 0, 17), new Date(2014, 0, 21)
	 *   )
	 *
	 *   // v2.0.0 onward
	 *
	 *   getOverlappingDaysInIntervals(
	 *     { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
	 *     { start: new Date(2014, 0, 17), end: new Date(2014, 0, 21) }
	 *   )
	 *   ```
	 *
	 * @param {Interval} intervalLeft - the first interval to compare. See [Interval]{@link docs/Interval}
	 * @param {Interval} intervalRight - the second interval to compare. See [Interval]{@link docs/Interval}
	 * @returns {Number} the number of days that overlap in two time intervals
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} The start of an interval cannot be after its end
	 * @throws {RangeError} Date in interval cannot be `Invalid Date`
	 *
	 * @example
	 * // For overlapping time intervals adds 1 for each started overlapping day:
	 * getOverlappingDaysInIntervals(
	 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
	 *   { start: new Date(2014, 0, 17), end: new Date(2014, 0, 21) }
	 * )
	 * //=> 3
	 *
	 * @example
	 * // For non-overlapping time intervals returns 0:
	 * getOverlappingDaysInIntervals(
	 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
	 *   { start: new Date(2014, 0, 21), end: new Date(2014, 0, 22) }
	 * )
	 * //=> 0
	 */
	
	function getOverlappingDaysInIntervals(dirtyIntervalLeft, dirtyIntervalRight) {
	  (0, _index2.default)(2, arguments);
	  var intervalLeft = dirtyIntervalLeft || {};
	  var intervalRight = dirtyIntervalRight || {};
	  var leftStartTime = (0, _index.default)(intervalLeft.start).getTime();
	  var leftEndTime = (0, _index.default)(intervalLeft.end).getTime();
	  var rightStartTime = (0, _index.default)(intervalRight.start).getTime();
	  var rightEndTime = (0, _index.default)(intervalRight.end).getTime(); // Throw an exception if start date is after end date or if any date is `Invalid Date`
	
	  if (!(leftStartTime <= leftEndTime && rightStartTime <= rightEndTime)) {
	    throw new RangeError('Invalid interval');
	  }
	
	  var isOverlapping = leftStartTime < rightEndTime && rightStartTime < leftEndTime;
	
	  if (!isOverlapping) {
	    return 0;
	  }
	
	  var overlapStartDate = rightStartTime < leftStartTime ? leftStartTime : rightStartTime;
	  var overlapEndDate = rightEndTime > leftEndTime ? leftEndTime : rightEndTime;
	  var differenceInMs = overlapEndDate - overlapStartDate;
	  return Math.ceil(differenceInMs / MILLISECONDS_IN_DAY);
	}
	
	module.exports = exports.default;

/***/ },
/* 988 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getSeconds;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name getSeconds
	 * @category Second Helpers
	 * @summary Get the seconds of the given date.
	 *
	 * @description
	 * Get the seconds of the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the seconds
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Get the seconds of 29 February 2012 11:45:05.123:
	 * const result = getSeconds(new Date(2012, 1, 29, 11, 45, 5, 123))
	 * //=> 5
	 */
	function getSeconds(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var seconds = date.getSeconds();
	  return seconds;
	}
	
	module.exports = exports.default;

/***/ },
/* 989 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getUnixTime;
	
	var _index = _interopRequireDefault(__webpack_require__(422));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name getUnixTime
	 * @category Timestamp Helpers
	 * @summary Get the seconds timestamp of the given date.
	 *
	 * @description
	 * Get the seconds timestamp of the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the timestamp
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Get the timestamp of 29 February 2012 11:45:05 CET:
	 * const result = getUnixTime(new Date(2012, 1, 29, 11, 45, 5))
	 * //=> 1330512305
	 */
	function getUnixTime(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return Math.floor((0, _index.default)(dirtyDate) / 1000);
	}
	
	module.exports = exports.default;

/***/ },
/* 990 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getWeekOfMonth;
	
	var _index = _interopRequireDefault(__webpack_require__(417));
	
	var _index2 = _interopRequireDefault(__webpack_require__(192));
	
	var _index3 = _interopRequireDefault(__webpack_require__(195));
	
	var _index4 = _interopRequireDefault(__webpack_require__(2));
	
	var _index5 = _interopRequireDefault(__webpack_require__(19));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name getWeekOfMonth
	 * @category Week Helpers
	 * @summary Get the week of the month of the given date.
	 *
	 * @description
	 * Get the week of the month of the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the given date
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @returns {Number} the week of month
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6 inclusively
	 *
	 * @example
	 * // Which week of the month is 9 November 2017?
	 * const result = getWeekOfMonth(new Date(2017, 10, 9))
	 * //=> 2
	 */
	function getWeekOfMonth(date, options) {
	  var _options$locale, _options$locale$optio;
	
	  (0, _index4.default)(1, arguments);
	  var defaultWeekStartsOn = (options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) || 0;
	  var weekStartsOn = (options === null || options === void 0 ? void 0 : options.weekStartsOn) == null ? (0, _index5.default)(defaultWeekStartsOn) : (0, _index5.default)(options.weekStartsOn);
	
	  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
	    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
	  }
	
	  var currentDayOfMonth = (0, _index.default)(date);
	  if (isNaN(currentDayOfMonth)) return NaN;
	  var startWeekDay = (0, _index2.default)((0, _index3.default)(date));
	  var lastDayOfFirstWeek = weekStartsOn - startWeekDay;
	  if (lastDayOfFirstWeek <= 0) lastDayOfFirstWeek += 7;
	  var remainingDaysAfterFirstWeek = currentDayOfMonth - lastDayOfFirstWeek;
	  return Math.ceil(remainingDaysAfterFirstWeek / 7) + 1;
	}
	
	module.exports = exports.default;

/***/ },
/* 991 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getWeeksInMonth;
	
	var _index = _interopRequireDefault(__webpack_require__(407));
	
	var _index2 = _interopRequireDefault(__webpack_require__(436));
	
	var _index3 = _interopRequireDefault(__webpack_require__(195));
	
	var _index4 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name getWeeksInMonth
	 * @category Week Helpers
	 * @summary Get the number of calendar weeks a month spans.
	 *
	 * @description
	 * Get the number of calendar weeks the month in the given date spans.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the given date
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @returns {Number} the number of calendar weeks
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 *
	 * @example
	 * // How many calendar weeks does February 2015 span?
	 * const result = getWeeksInMonth(new Date(2015, 1, 8))
	 * //=> 4
	 *
	 * @example
	 * // If the week starts on Monday,
	 * // how many calendar weeks does July 2017 span?
	 * const result = getWeeksInMonth(new Date(2017, 6, 5), { weekStartsOn: 1 })
	 * //=> 6
	 */
	function getWeeksInMonth(date, options) {
	  (0, _index4.default)(1, arguments);
	  return (0, _index.default)((0, _index2.default)(date), (0, _index3.default)(date), options) + 1;
	}
	
	module.exports = exports.default;

/***/ },
/* 992 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getYear;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name getYear
	 * @category Year Helpers
	 * @summary Get the year of the given date.
	 *
	 * @description
	 * Get the year of the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the year
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Which year is 2 July 2014?
	 * const result = getYear(new Date(2014, 6, 2))
	 * //=> 2014
	 */
	function getYear(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(dirtyDate).getFullYear();
	}
	
	module.exports = exports.default;

/***/ },
/* 993 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = hoursToMilliseconds;
	
	var _index = _interopRequireDefault(__webpack_require__(2));
	
	var _index2 = __webpack_require__(36);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name hoursToMilliseconds
	 * @category  Conversion Helpers
	 * @summary Convert hours to milliseconds.
	 *
	 * @description
	 * Convert a number of hours to a full number of milliseconds.
	 *
	 * @param {number} hours - number of hours to be converted
	 *
	 * @returns {number} the number of hours converted to milliseconds
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Convert 2 hours to milliseconds:
	 * const result = hoursToMilliseconds(2)
	 * //=> 7200000
	 */
	function hoursToMilliseconds(hours) {
	  (0, _index.default)(1, arguments);
	  return Math.floor(hours * _index2.millisecondsInHour);
	}
	
	module.exports = exports.default;

/***/ },
/* 994 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = hoursToMinutes;
	
	var _index = _interopRequireDefault(__webpack_require__(2));
	
	var _index2 = __webpack_require__(36);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name hoursToMinutes
	 * @category Conversion Helpers
	 * @summary Convert hours to minutes.
	 *
	 * @description
	 * Convert a number of hours to a full number of minutes.
	 *
	 * @param {number} hours - number of hours to be converted
	 *
	 * @returns {number} the number of hours converted in minutes
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Convert 2 hours to minutes:
	 * const result = hoursToMinutes(2)
	 * //=> 120
	 */
	function hoursToMinutes(hours) {
	  (0, _index.default)(1, arguments);
	  return Math.floor(hours * _index2.minutesInHour);
	}
	
	module.exports = exports.default;

/***/ },
/* 995 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = hoursToSeconds;
	
	var _index = _interopRequireDefault(__webpack_require__(2));
	
	var _index2 = __webpack_require__(36);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name hoursToSeconds
	 * @category Conversion Helpers
	 * @summary Convert hours to seconds.
	 *
	 * @description
	 * Convert a number of hours to a full number of seconds.
	 *
	 * @param {number} hours - number of hours to be converted
	 *
	 * @returns {number} the number of hours converted in seconds
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Convert 2 hours to seconds:
	 * const result = hoursToSeconds(2)
	 * //=> 7200
	 */
	function hoursToSeconds(hours) {
	  (0, _index.default)(1, arguments);
	  return Math.floor(hours * _index2.secondsInHour);
	}
	
	module.exports = exports.default;

/***/ },
/* 996 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = intervalToDuration;
	
	var _index = _interopRequireDefault(__webpack_require__(105));
	
	var _index2 = _interopRequireDefault(__webpack_require__(274));
	
	var _index3 = _interopRequireDefault(__webpack_require__(191));
	
	var _index4 = _interopRequireDefault(__webpack_require__(272));
	
	var _index5 = _interopRequireDefault(__webpack_require__(409));
	
	var _index6 = _interopRequireDefault(__webpack_require__(410));
	
	var _index7 = _interopRequireDefault(__webpack_require__(273));
	
	var _index8 = _interopRequireDefault(__webpack_require__(83));
	
	var _index9 = _interopRequireDefault(__webpack_require__(2));
	
	var _index10 = _interopRequireDefault(__webpack_require__(3));
	
	var _index11 = _interopRequireDefault(__webpack_require__(452));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name intervalToDuration
	 * @category Common Helpers
	 * @summary Convert interval to duration
	 *
	 * @description
	 * Convert a interval object to a duration object.
	 *
	 * @param {Interval} interval - the interval to convert to duration
	 *
	 * @returns {Duration} The duration Object
	 * @throws {TypeError} Requires 2 arguments
	 * @throws {RangeError} `start` must not be Invalid Date
	 * @throws {RangeError} `end` must not be Invalid Date
	 *
	 * @example
	 * // Get the duration between January 15, 1929 and April 4, 1968.
	 * intervalToDuration({
	 *   start: new Date(1929, 0, 15, 12, 0, 0),
	 *   end: new Date(1968, 3, 4, 19, 5, 0)
	 * })
	 * // => { years: 39, months: 2, days: 20, hours: 7, minutes: 5, seconds: 0 }
	 */
	function intervalToDuration(_ref) {
	  var start = _ref.start,
	      end = _ref.end;
	  (0, _index9.default)(1, arguments);
	  var dateLeft = (0, _index10.default)(start);
	  var dateRight = (0, _index10.default)(end);
	
	  if (!(0, _index8.default)(dateLeft)) {
	    throw new RangeError('Start Date is invalid');
	  }
	
	  if (!(0, _index8.default)(dateRight)) {
	    throw new RangeError('End Date is invalid');
	  }
	
	  var duration = {
	    years: 0,
	    months: 0,
	    days: 0,
	    hours: 0,
	    minutes: 0,
	    seconds: 0
	  };
	  var sign = (0, _index.default)(dateLeft, dateRight);
	  duration.years = Math.abs((0, _index2.default)(dateLeft, dateRight));
	  var remainingMonths = (0, _index11.default)(dateLeft, {
	    years: sign * duration.years
	  });
	  duration.months = Math.abs((0, _index3.default)(remainingMonths, dateRight));
	  var remainingDays = (0, _index11.default)(remainingMonths, {
	    months: sign * duration.months
	  });
	  duration.days = Math.abs((0, _index4.default)(remainingDays, dateRight));
	  var remainingHours = (0, _index11.default)(remainingDays, {
	    days: sign * duration.days
	  });
	  duration.hours = Math.abs((0, _index5.default)(remainingHours, dateRight));
	  var remainingMinutes = (0, _index11.default)(remainingHours, {
	    hours: sign * duration.hours
	  });
	  duration.minutes = Math.abs((0, _index6.default)(remainingMinutes, dateRight));
	  var remainingSeconds = (0, _index11.default)(remainingMinutes, {
	    minutes: sign * duration.minutes
	  });
	  duration.seconds = Math.abs((0, _index7.default)(remainingSeconds, dateRight));
	  return duration;
	}
	
	module.exports = exports.default;

/***/ },
/* 997 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = intlFormat;
	
	var _index = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name intlFormat
	 * @category Common Helpers
	 * @summary  Format the date with Intl.DateTimeFormat (https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat).
	 *
	 * @description
	 * Return the formatted date string in the given format.
	 * The method uses [`Intl.DateTimeFormat`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat) inside.
	 * formatOptions are the same as [`Intl.DateTimeFormat` options](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat#using_options)
	 *
	 * > ⚠️ Please note that before Node version 13.0.0, only the locale data for en-US is available by default.
	 *
	 * @param {Date|Number} argument - the original date.
	 * @param {Object} [formatOptions] - an object with options.
	 * @param {'lookup'|'best fit'} [formatOptions.localeMatcher='best fit'] - locale selection algorithm.
	 * @param {'narrow'|'short'|'long'} [formatOptions.weekday] - representation the days of the week.
	 * @param {'narrow'|'short'|'long'} [formatOptions.era] - representation of eras.
	 * @param {'numeric'|'2-digit'} [formatOptions.year] - representation of years.
	 * @param {'numeric'|'2-digit'|'narrow'|'short'|'long'} [formatOptions.month='numeric'] - representation of month.
	 * @param {'numeric'|'2-digit'} [formatOptions.day='numeric'] - representation of day.
	 * @param {'numeric'|'2-digit'} [formatOptions.hour='numeric'] - representation of hours.
	 * @param {'numeric'|'2-digit'} [formatOptions.minute] - representation of minutes.
	 * @param {'numeric'|'2-digit'} [formatOptions.second] - representation of seconds.
	 * @param {'short'|'long'} [formatOptions.timeZoneName] - representation of names of time zones.
	 * @param {'basic'|'best fit'} [formatOptions.formatMatcher='best fit'] - format selection algorithm.
	 * @param {Boolean} [formatOptions.hour12] - determines whether to use 12-hour time format.
	 * @param {String} [formatOptions.timeZone] - the time zone to use.
	 * @param {Object} [localeOptions] - an object with locale.
	 * @param {String|String[]} [localeOptions.locale] - the locale code
	 * @returns {String} the formatted date string.
	 * @throws {TypeError} 1 argument required.
	 * @throws {RangeError} `date` must not be Invalid Date
	 *
	 * @example
	 * // Represent 10 October 2019 in German.
	 * // Convert the date with format's options and locale's options.
	 * const result = intlFormat(new Date(2019, 9, 4, 12, 30, 13, 456), {
	 *      weekday: 'long',
	 *      year: 'numeric',
	 *      month: 'long',
	 *      day: 'numeric',
	 *    }, {
	 *      locale: 'de-DE',
	 *  })
	 * //=> Freitag, 4. Oktober 2019
	 *
	 * @example
	 * // Represent 10 October 2019.
	 * // Convert the date with format's options.
	 * const result = intlFormat.default(new Date(2019, 9, 4, 12, 30, 13, 456), {
	 *      year: 'numeric',
	 *      month: 'numeric',
	 *      day: 'numeric',
	 *      hour: 'numeric',
	 *  })
	 * //=> 10/4/2019, 12 PM
	 *
	 * @example
	 * // Represent 10 October 2019 in Korean.
	 * // Convert the date with locale's options.
	 * const result = intlFormat(new Date(2019, 9, 4, 12, 30, 13, 456), {
	 *      locale: 'ko-KR',
	 *  })
	 * //=> 2019. 10. 4.
	 *
	 * @example
	 * // Represent 10 October 2019 in middle-endian format:
	 * const result = intlFormat(new Date(2019, 9, 4, 12, 30, 13, 456))
	 * //=> 10/4/2019
	 */
	function intlFormat(date, formatOrLocale, localeOptions) {
	  var _localeOptions;
	
	  (0, _index.default)(1, arguments);
	  var formatOptions;
	
	  if (isFormatOptions(formatOrLocale)) {
	    formatOptions = formatOrLocale;
	  } else {
	    localeOptions = formatOrLocale;
	  }
	
	  return new Intl.DateTimeFormat((_localeOptions = localeOptions) === null || _localeOptions === void 0 ? void 0 : _localeOptions.locale, formatOptions).format(date);
	}
	
	function isFormatOptions(opts) {
	  return opts !== undefined && !('locale' in opts);
	}
	
	module.exports = exports.default;

/***/ },
/* 998 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isAfter;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isAfter
	 * @category Common Helpers
	 * @summary Is the first date after the second one?
	 *
	 * @description
	 * Is the first date after the second one?
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date that should be after the other one to return true
	 * @param {Date|Number} dateToCompare - the date to compare with
	 * @returns {Boolean} the first date is after the second date
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Is 10 July 1989 after 11 February 1987?
	 * var result = isAfter(new Date(1989, 6, 10), new Date(1987, 1, 11))
	 * //=> true
	 */
	function isAfter(dirtyDate, dirtyDateToCompare) {
	  (0, _index2.default)(2, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var dateToCompare = (0, _index.default)(dirtyDateToCompare);
	  return date.getTime() > dateToCompare.getTime();
	}
	
	module.exports = exports.default;

/***/ },
/* 999 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isBefore;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isBefore
	 * @category Common Helpers
	 * @summary Is the first date before the second one?
	 *
	 * @description
	 * Is the first date before the second one?
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date that should be before the other one to return true
	 * @param {Date|Number} dateToCompare - the date to compare with
	 * @returns {Boolean} the first date is before the second date
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Is 10 July 1989 before 11 February 1987?
	 * var result = isBefore(new Date(1989, 6, 10), new Date(1987, 1, 11))
	 * //=> false
	 */
	function isBefore(dirtyDate, dirtyDateToCompare) {
	  (0, _index2.default)(2, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var dateToCompare = (0, _index.default)(dirtyDateToCompare);
	  return date.getTime() < dateToCompare.getTime();
	}
	
	module.exports = exports.default;

/***/ },
/* 1000 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isEqual;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isEqual
	 * @category Common Helpers
	 * @summary Are the given dates equal?
	 *
	 * @description
	 * Are the given dates equal?
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the first date to compare
	 * @param {Date|Number} dateRight - the second date to compare
	 * @returns {Boolean} the dates are equal
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Are 2 July 2014 06:30:45.000 and 2 July 2014 06:30:45.500 equal?
	 * var result = isEqual(
	 *   new Date(2014, 6, 2, 6, 30, 45, 0),
	 *   new Date(2014, 6, 2, 6, 30, 45, 500)
	 * )
	 * //=> false
	 */
	function isEqual(dirtyLeftDate, dirtyRightDate) {
	  (0, _index2.default)(2, arguments);
	  var dateLeft = (0, _index.default)(dirtyLeftDate);
	  var dateRight = (0, _index.default)(dirtyRightDate);
	  return dateLeft.getTime() === dateRight.getTime();
	}
	
	module.exports = exports.default;

/***/ },
/* 1001 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isExists;
	
	/**
	 * @name isExists
	 * @category Common Helpers
	 * @summary Is the given date exists?
	 *
	 * @description
	 * Checks if the given arguments convert to an existing date.
	 *
	 * @param {Number} year of the date to check
	 * @param {Number} month of the date to check
	 * @param {Number} day of the date to check
	 * @returns {Boolean} the date exists
	 * @throws {TypeError} 3 arguments required
	 *
	 * @example
	 * // For the valid date:
	 * var result = isExists(2018, 0, 31)
	 * //=> true
	 *
	 * @example
	 * // For the invalid date:
	 * var result = isExists(2018, 1, 31)
	 * //=> false
	 */
	function isExists(year, month, day) {
	  if (arguments.length < 3) {
	    throw new TypeError('3 argument required, but only ' + arguments.length + ' present');
	  }
	
	  var date = new Date(year, month, day);
	  return date.getFullYear() === year && date.getMonth() === month && date.getDate() === day;
	}
	
	module.exports = exports.default;

/***/ },
/* 1002 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isFirstDayOfMonth;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isFirstDayOfMonth
	 * @category Month Helpers
	 * @summary Is the given date the first day of a month?
	 *
	 * @description
	 * Is the given date the first day of a month?
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is the first day of a month
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Is 1 September 2014 the first day of a month?
	 * var result = isFirstDayOfMonth(new Date(2014, 8, 1))
	 * //=> true
	 */
	function isFirstDayOfMonth(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(dirtyDate).getDate() === 1;
	}
	
	module.exports = exports.default;

/***/ },
/* 1003 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isFriday;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isFriday
	 * @category Weekday Helpers
	 * @summary Is the given date Friday?
	 *
	 * @description
	 * Is the given date Friday?
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is Friday
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Is 26 September 2014 Friday?
	 * var result = isFriday(new Date(2014, 8, 26))
	 * //=> true
	 */
	function isFriday(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(dirtyDate).getDay() === 5;
	}
	
	module.exports = exports.default;

/***/ },
/* 1004 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isFuture;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isFuture
	 * @category Common Helpers
	 * @summary Is the given date in the future?
	 * @pure false
	 *
	 * @description
	 * Is the given date in the future?
	 *
	 * > ⚠️ Please note that this function is not present in the FP submodule as
	 * > it uses `Date.now()` internally hence impure and can't be safely curried.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is in the future
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // If today is 6 October 2014, is 31 December 2014 in the future?
	 * var result = isFuture(new Date(2014, 11, 31))
	 * //=> true
	 */
	function isFuture(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(dirtyDate).getTime() > Date.now();
	}
	
	module.exports = exports.default;

/***/ },
/* 1005 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isMatch;
	
	var _index = _interopRequireDefault(__webpack_require__(448));
	
	var _index2 = _interopRequireDefault(__webpack_require__(83));
	
	var _index3 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isMatch
	 * @category Common Helpers
	 * @summary validates the date string against given formats
	 *
	 * @description
	 * Return the true if given date is string correct against the given format else
	 * will return false.
	 *
	 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
	 * > See: https://git.io/fxCyr
	 *
	 * The characters in the format string wrapped between two single quotes characters (') are escaped.
	 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
	 *
	 * Format of the format string is based on Unicode Technical Standard #35:
	 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
	 * with a few additions (see note 5 below the table).
	 *
	 * Not all tokens are compatible. Combinations that don't make sense or could lead to bugs are prohibited
	 * and will throw `RangeError`. For example usage of 24-hour format token with AM/PM token will throw an exception:
	 *
	 * ```javascript
	 * isMatch('23 AM', 'HH a')
	 * //=> RangeError: The format string mustn't contain `HH` and `a` at the same time
	 * ```
	 *
	 * See the compatibility table: https://docs.google.com/spreadsheets/d/e/2PACX-1vQOPU3xUhplll6dyoMmVUXHKl_8CRDs6_ueLmex3SoqwhuolkuN3O05l4rqx5h1dKX8eb46Ul-CCSrq/pubhtml?gid=0&single=true
	 *
	 * Accepted format string patterns:
	 * | Unit                            |Prior| Pattern | Result examples                   | Notes |
	 * |---------------------------------|-----|---------|-----------------------------------|-------|
	 * | Era                             | 140 | G..GGG  | AD, BC                            |       |
	 * |                                 |     | GGGG    | Anno Domini, Before Christ        | 2     |
	 * |                                 |     | GGGGG   | A, B                              |       |
	 * | Calendar year                   | 130 | y       | 44, 1, 1900, 2017, 9999           | 4     |
	 * |                                 |     | yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
	 * |                                 |     | yy      | 44, 01, 00, 17                    | 4     |
	 * |                                 |     | yyy     | 044, 001, 123, 999                | 4     |
	 * |                                 |     | yyyy    | 0044, 0001, 1900, 2017            | 4     |
	 * |                                 |     | yyyyy   | ...                               | 2,4   |
	 * | Local week-numbering year       | 130 | Y       | 44, 1, 1900, 2017, 9000           | 4     |
	 * |                                 |     | Yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
	 * |                                 |     | YY      | 44, 01, 00, 17                    | 4,6   |
	 * |                                 |     | YYY     | 044, 001, 123, 999                | 4     |
	 * |                                 |     | YYYY    | 0044, 0001, 1900, 2017            | 4,6   |
	 * |                                 |     | YYYYY   | ...                               | 2,4   |
	 * | ISO week-numbering year         | 130 | R       | -43, 1, 1900, 2017, 9999, -9999   | 4,5   |
	 * |                                 |     | RR      | -43, 01, 00, 17                   | 4,5   |
	 * |                                 |     | RRR     | -043, 001, 123, 999, -999         | 4,5   |
	 * |                                 |     | RRRR    | -0043, 0001, 2017, 9999, -9999    | 4,5   |
	 * |                                 |     | RRRRR   | ...                               | 2,4,5 |
	 * | Extended year                   | 130 | u       | -43, 1, 1900, 2017, 9999, -999    | 4     |
	 * |                                 |     | uu      | -43, 01, 99, -99                  | 4     |
	 * |                                 |     | uuu     | -043, 001, 123, 999, -999         | 4     |
	 * |                                 |     | uuuu    | -0043, 0001, 2017, 9999, -9999    | 4     |
	 * |                                 |     | uuuuu   | ...                               | 2,4   |
	 * | Quarter (formatting)            | 120 | Q       | 1, 2, 3, 4                        |       |
	 * |                                 |     | Qo      | 1st, 2nd, 3rd, 4th                | 5     |
	 * |                                 |     | QQ      | 01, 02, 03, 04                    |       |
	 * |                                 |     | QQQ     | Q1, Q2, Q3, Q4                    |       |
	 * |                                 |     | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
	 * |                                 |     | QQQQQ   | 1, 2, 3, 4                        | 4     |
	 * | Quarter (stand-alone)           | 120 | q       | 1, 2, 3, 4                        |       |
	 * |                                 |     | qo      | 1st, 2nd, 3rd, 4th                | 5     |
	 * |                                 |     | qq      | 01, 02, 03, 04                    |       |
	 * |                                 |     | qqq     | Q1, Q2, Q3, Q4                    |       |
	 * |                                 |     | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
	 * |                                 |     | qqqqq   | 1, 2, 3, 4                        | 3     |
	 * | Month (formatting)              | 110 | M       | 1, 2, ..., 12                     |       |
	 * |                                 |     | Mo      | 1st, 2nd, ..., 12th               | 5     |
	 * |                                 |     | MM      | 01, 02, ..., 12                   |       |
	 * |                                 |     | MMM     | Jan, Feb, ..., Dec                |       |
	 * |                                 |     | MMMM    | January, February, ..., December  | 2     |
	 * |                                 |     | MMMMM   | J, F, ..., D                      |       |
	 * | Month (stand-alone)             | 110 | L       | 1, 2, ..., 12                     |       |
	 * |                                 |     | Lo      | 1st, 2nd, ..., 12th               | 5     |
	 * |                                 |     | LL      | 01, 02, ..., 12                   |       |
	 * |                                 |     | LLL     | Jan, Feb, ..., Dec                |       |
	 * |                                 |     | LLLL    | January, February, ..., December  | 2     |
	 * |                                 |     | LLLLL   | J, F, ..., D                      |       |
	 * | Local week of year              | 100 | w       | 1, 2, ..., 53                     |       |
	 * |                                 |     | wo      | 1st, 2nd, ..., 53th               | 5     |
	 * |                                 |     | ww      | 01, 02, ..., 53                   |       |
	 * | ISO week of year                | 100 | I       | 1, 2, ..., 53                     | 5     |
	 * |                                 |     | Io      | 1st, 2nd, ..., 53th               | 5     |
	 * |                                 |     | II      | 01, 02, ..., 53                   | 5     |
	 * | Day of month                    |  90 | d       | 1, 2, ..., 31                     |       |
	 * |                                 |     | do      | 1st, 2nd, ..., 31st               | 5     |
	 * |                                 |     | dd      | 01, 02, ..., 31                   |       |
	 * | Day of year                     |  90 | D       | 1, 2, ..., 365, 366               | 7     |
	 * |                                 |     | Do      | 1st, 2nd, ..., 365th, 366th       | 5     |
	 * |                                 |     | DD      | 01, 02, ..., 365, 366             | 7     |
	 * |                                 |     | DDD     | 001, 002, ..., 365, 366           |       |
	 * |                                 |     | DDDD    | ...                               | 2     |
	 * | Day of week (formatting)        |  90 | E..EEE  | Mon, Tue, Wed, ..., Su            |       |
	 * |                                 |     | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
	 * |                                 |     | EEEEE   | M, T, W, T, F, S, S               |       |
	 * |                                 |     | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
	 * | ISO day of week (formatting)    |  90 | i       | 1, 2, 3, ..., 7                   | 5     |
	 * |                                 |     | io      | 1st, 2nd, ..., 7th                | 5     |
	 * |                                 |     | ii      | 01, 02, ..., 07                   | 5     |
	 * |                                 |     | iii     | Mon, Tue, Wed, ..., Su            | 5     |
	 * |                                 |     | iiii    | Monday, Tuesday, ..., Sunday      | 2,5   |
	 * |                                 |     | iiiii   | M, T, W, T, F, S, S               | 5     |
	 * |                                 |     | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 5     |
	 * | Local day of week (formatting)  |  90 | e       | 2, 3, 4, ..., 1                   |       |
	 * |                                 |     | eo      | 2nd, 3rd, ..., 1st                | 5     |
	 * |                                 |     | ee      | 02, 03, ..., 01                   |       |
	 * |                                 |     | eee     | Mon, Tue, Wed, ..., Su            |       |
	 * |                                 |     | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
	 * |                                 |     | eeeee   | M, T, W, T, F, S, S               |       |
	 * |                                 |     | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
	 * | Local day of week (stand-alone) |  90 | c       | 2, 3, 4, ..., 1                   |       |
	 * |                                 |     | co      | 2nd, 3rd, ..., 1st                | 5     |
	 * |                                 |     | cc      | 02, 03, ..., 01                   |       |
	 * |                                 |     | ccc     | Mon, Tue, Wed, ..., Su            |       |
	 * |                                 |     | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
	 * |                                 |     | ccccc   | M, T, W, T, F, S, S               |       |
	 * |                                 |     | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
	 * | AM, PM                          |  80 | a..aaa  | AM, PM                            |       |
	 * |                                 |     | aaaa    | a.m., p.m.                        | 2     |
	 * |                                 |     | aaaaa   | a, p                              |       |
	 * | AM, PM, noon, midnight          |  80 | b..bbb  | AM, PM, noon, midnight            |       |
	 * |                                 |     | bbbb    | a.m., p.m., noon, midnight        | 2     |
	 * |                                 |     | bbbbb   | a, p, n, mi                       |       |
	 * | Flexible day period             |  80 | B..BBB  | at night, in the morning, ...     |       |
	 * |                                 |     | BBBB    | at night, in the morning, ...     | 2     |
	 * |                                 |     | BBBBB   | at night, in the morning, ...     |       |
	 * | Hour [1-12]                     |  70 | h       | 1, 2, ..., 11, 12                 |       |
	 * |                                 |     | ho      | 1st, 2nd, ..., 11th, 12th         | 5     |
	 * |                                 |     | hh      | 01, 02, ..., 11, 12               |       |
	 * | Hour [0-23]                     |  70 | H       | 0, 1, 2, ..., 23                  |       |
	 * |                                 |     | Ho      | 0th, 1st, 2nd, ..., 23rd          | 5     |
	 * |                                 |     | HH      | 00, 01, 02, ..., 23               |       |
	 * | Hour [0-11]                     |  70 | K       | 1, 2, ..., 11, 0                  |       |
	 * |                                 |     | Ko      | 1st, 2nd, ..., 11th, 0th          | 5     |
	 * |                                 |     | KK      | 01, 02, ..., 11, 00               |       |
	 * | Hour [1-24]                     |  70 | k       | 24, 1, 2, ..., 23                 |       |
	 * |                                 |     | ko      | 24th, 1st, 2nd, ..., 23rd         | 5     |
	 * |                                 |     | kk      | 24, 01, 02, ..., 23               |       |
	 * | Minute                          |  60 | m       | 0, 1, ..., 59                     |       |
	 * |                                 |     | mo      | 0th, 1st, ..., 59th               | 5     |
	 * |                                 |     | mm      | 00, 01, ..., 59                   |       |
	 * | Second                          |  50 | s       | 0, 1, ..., 59                     |       |
	 * |                                 |     | so      | 0th, 1st, ..., 59th               | 5     |
	 * |                                 |     | ss      | 00, 01, ..., 59                   |       |
	 * | Seconds timestamp               |  40 | t       | 512969520                         |       |
	 * |                                 |     | tt      | ...                               | 2     |
	 * | Fraction of second              |  30 | S       | 0, 1, ..., 9                      |       |
	 * |                                 |     | SS      | 00, 01, ..., 99                   |       |
	 * |                                 |     | SSS     | 000, 001, ..., 999                |       |
	 * |                                 |     | SSSS    | ...                               | 2     |
	 * | Milliseconds timestamp          |  20 | T       | 512969520900                      |       |
	 * |                                 |     | TT      | ...                               | 2     |
	 * | Timezone (ISO-8601 w/ Z)        |  10 | X       | -08, +0530, Z                     |       |
	 * |                                 |     | XX      | -0800, +0530, Z                   |       |
	 * |                                 |     | XXX     | -08:00, +05:30, Z                 |       |
	 * |                                 |     | XXXX    | -0800, +0530, Z, +123456          | 2     |
	 * |                                 |     | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
	 * | Timezone (ISO-8601 w/o Z)       |  10 | x       | -08, +0530, +00                   |       |
	 * |                                 |     | xx      | -0800, +0530, +0000               |       |
	 * |                                 |     | xxx     | -08:00, +05:30, +00:00            | 2     |
	 * |                                 |     | xxxx    | -0800, +0530, +0000, +123456      |       |
	 * |                                 |     | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
	 * | Long localized date             |  NA | P       | 05/29/1453                        | 5,8   |
	 * |                                 |     | PP      | May 29, 1453                      |       |
	 * |                                 |     | PPP     | May 29th, 1453                    |       |
	 * |                                 |     | PPPP    | Sunday, May 29th, 1453            | 2,5,8 |
	 * | Long localized time             |  NA | p       | 12:00 AM                          | 5,8   |
	 * |                                 |     | pp      | 12:00:00 AM                       |       |
	 * | Combination of date and time    |  NA | Pp      | 05/29/1453, 12:00 AM              |       |
	 * |                                 |     | PPpp    | May 29, 1453, 12:00:00 AM         |       |
	 * |                                 |     | PPPpp   | May 29th, 1453 at ...             |       |
	 * |                                 |     | PPPPpp  | Sunday, May 29th, 1453 at ...     | 2,5,8 |
	 * Notes:
	 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
	 *    are the same as "stand-alone" units, but are different in some languages.
	 *    "Formatting" units are declined according to the rules of the language
	 *    in the context of a date. "Stand-alone" units are always nominative singular.
	 *    In `format` function, they will produce different result:
	 *
	 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
	 *
	 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
	 *
	 *    `isMatch` will try to match both formatting and stand-alone units interchangably.
	 *
	 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
	 *    the single quote characters (see below).
	 *    If the sequence is longer than listed in table:
	 *    - for numerical units (`yyyyyyyy`) `isMatch` will try to match a number
	 *      as wide as the sequence
	 *    - for text units (`MMMMMMMM`) `isMatch` will try to match the widest variation of the unit.
	 *      These variations are marked with "2" in the last column of the table.
	 *
	 * 3. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
	 *    These tokens represent the shortest form of the quarter.
	 *
	 * 4. The main difference between `y` and `u` patterns are B.C. years:
	 *
	 *    | Year | `y` | `u` |
	 *    |------|-----|-----|
	 *    | AC 1 |   1 |   1 |
	 *    | BC 1 |   1 |   0 |
	 *    | BC 2 |   2 |  -1 |
	 *
	 *    Also `yy` will try to guess the century of two digit year by proximity with `referenceDate`:
	 *
	 *    `isMatch('50', 'yy') //=> true`
	 *
	 *    `isMatch('75', 'yy') //=> true`
	 *
	 *    while `uu` will use the year as is:
	 *
	 *    `isMatch('50', 'uu') //=> true`
	 *
	 *    `isMatch('75', 'uu') //=> true`
	 *
	 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
	 *    except local week-numbering years are dependent on `options.weekStartsOn`
	 *    and `options.firstWeekContainsDate` (compare [setISOWeekYear]{@link https://date-fns.org/docs/setISOWeekYear}
	 *    and [setWeekYear]{@link https://date-fns.org/docs/setWeekYear}).
	 *
	 * 5. These patterns are not in the Unicode Technical Standard #35:
	 *    - `i`: ISO day of week
	 *    - `I`: ISO week of year
	 *    - `R`: ISO week-numbering year
	 *    - `o`: ordinal number modifier
	 *    - `P`: long localized date
	 *    - `p`: long localized time
	 *
	 * 6. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
	 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://git.io/fxCyr
	 *
	 * 7. `D` and `DD` tokens represent days of the year but they are ofthen confused with days of the month.
	 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://git.io/fxCyr
	 *
	 * 8. `P+` tokens do not have a defined priority since they are merely aliases to other tokens based
	 *    on the given locale.
	 *
	 *    using `en-US` locale: `P` => `MM/dd/yyyy`
	 *    using `en-US` locale: `p` => `hh:mm a`
	 *    using `pt-BR` locale: `P` => `dd/MM/yyyy`
	 *    using `pt-BR` locale: `p` => `HH:mm`
	 *
	 * Values will be checked in the descending order of its unit's priority.
	 * Units of an equal priority overwrite each other in the order of appearance.
	 *
	 * If no values of higher priority are matched (e.g. when matching string 'January 1st' without a year),
	 * the values will be taken from today's using `new Date()` date which works as a context of parsing.
	 *
	 * The result may vary by locale.
	 *
	 * If `formatString` matches with `dateString` but does not provides tokens, `referenceDate` will be returned.
	 *
	 *
	 *
	 * @param {String} dateString - the date string to verify
	 * @param {String} formatString - the string of tokens
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
	 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
	 *   see: https://git.io/fxCyr
	 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
	 *   see: https://git.io/fxCyr
	 * @returns {Boolean}
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
	 * @throws {RangeError} `options.locale` must contain `match` property
	 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years; see: https://git.io/fxCyr
	 * @throws {RangeError} use `yy` instead of `YY` for formatting years; see: https://git.io/fxCyr
	 * @throws {RangeError} use `d` instead of `D` for formatting days of the month; see: https://git.io/fxCyr
	 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month; see: https://git.io/fxCyr
	 * @throws {RangeError} format string contains an unescaped latin alphabet character
	 *
	 * @example
	 * // Match 11 February 2014 from middle-endian format:
	 * var result = isMatch('02/11/2014', 'MM/dd/yyyy')
	 * //=> true
	 *
	 * @example
	 * // Match 28th of February in Esperanto locale in the context of 2010 year:
	 * import eo from 'date-fns/locale/eo'
	 * var result = isMatch('28-a de februaro', "do 'de' MMMM", {
	 *   locale: eo
	 * })
	 * //=> true
	 */
	function isMatch(dateString, formatString, options) {
	  (0, _index3.default)(2, arguments);
	  return (0, _index2.default)((0, _index.default)(dateString, formatString, new Date(), options));
	}
	
	module.exports = exports.default;

/***/ },
/* 1006 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isMonday;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isMonday
	 * @category Weekday Helpers
	 * @summary Is the given date Monday?
	 *
	 * @description
	 * Is the given date Monday?
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is Monday
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Is 22 September 2014 Monday?
	 * var result = isMonday(new Date(2014, 8, 22))
	 * //=> true
	 */
	function isMonday(date) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(date).getDay() === 1;
	}
	
	module.exports = exports.default;

/***/ },
/* 1007 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isPast;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isPast
	 * @category Common Helpers
	 * @summary Is the given date in the past?
	 * @pure false
	 *
	 * @description
	 * Is the given date in the past?
	 *
	 * > ⚠️ Please note that this function is not present in the FP submodule as
	 * > it uses `Date.now()` internally hence impure and can't be safely curried.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is in the past
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // If today is 6 October 2014, is 2 July 2014 in the past?
	 * var result = isPast(new Date(2014, 6, 2))
	 * //=> true
	 */
	function isPast(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(dirtyDate).getTime() < Date.now();
	}
	
	module.exports = exports.default;

/***/ },
/* 1008 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isSameISOWeekYear;
	
	var _index = _interopRequireDefault(__webpack_require__(152));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isSameISOWeekYear
	 * @category ISO Week-Numbering Year Helpers
	 * @summary Are the given dates in the same ISO week-numbering year?
	 *
	 * @description
	 * Are the given dates in the same ISO week-numbering year?
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * - The function was renamed from `isSameISOYear` to `isSameISOWeekYear`.
	 *   "ISO week year" is short for [ISO week-numbering year](https://en.wikipedia.org/wiki/ISO_week_date).
	 *   This change makes the name consistent with
	 *   locale-dependent week-numbering year helpers, e.g., `getWeekYear`.
	 *
	 * @param {Date|Number} dateLeft - the first date to check
	 * @param {Date|Number} dateRight - the second date to check
	 * @returns {Boolean} the dates are in the same ISO week-numbering year
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Are 29 December 2003 and 2 January 2005 in the same ISO week-numbering year?
	 * var result = isSameISOWeekYear(new Date(2003, 11, 29), new Date(2005, 0, 2))
	 * //=> true
	 */
	function isSameISOWeekYear(dirtyDateLeft, dirtyDateRight) {
	  (0, _index2.default)(2, arguments);
	  var dateLeftStartOfYear = (0, _index.default)(dirtyDateLeft);
	  var dateRightStartOfYear = (0, _index.default)(dirtyDateRight);
	  return dateLeftStartOfYear.getTime() === dateRightStartOfYear.getTime();
	}
	
	module.exports = exports.default;

/***/ },
/* 1009 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isThisHour;
	
	var _index = _interopRequireDefault(__webpack_require__(428));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isThisHour
	 * @category Hour Helpers
	 * @summary Is the given date in the same hour as the current date?
	 * @pure false
	 *
	 * @description
	 * Is the given date in the same hour as the current date?
	 *
	 * > ⚠️ Please note that this function is not present in the FP submodule as
	 * > it uses `Date.now()` internally hence impure and can't be safely curried.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is in this hour
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // If now is 25 September 2014 18:30:15.500,
	 * // is 25 September 2014 18:00:00 in this hour?
	 * var result = isThisHour(new Date(2014, 8, 25, 18))
	 * //=> true
	 */
	function isThisHour(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(Date.now(), dirtyDate);
	}
	
	module.exports = exports.default;

/***/ },
/* 1010 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isThisISOWeek;
	
	var _index = _interopRequireDefault(__webpack_require__(429));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isThisISOWeek
	 * @category ISO Week Helpers
	 * @summary Is the given date in the same ISO week as the current date?
	 * @pure false
	 *
	 * @description
	 * Is the given date in the same ISO week as the current date?
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * > ⚠️ Please note that this function is not present in the FP submodule as
	 * > it uses `Date.now()` internally hence impure and can't be safely curried.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is in this ISO week
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // If today is 25 September 2014, is 22 September 2014 in this ISO week?
	 * var result = isThisISOWeek(new Date(2014, 8, 22))
	 * //=> true
	 */
	function isThisISOWeek(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(dirtyDate, Date.now());
	}
	
	module.exports = exports.default;

/***/ },
/* 1011 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isThisMinute;
	
	var _index = _interopRequireDefault(__webpack_require__(430));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isThisMinute
	 * @category Minute Helpers
	 * @summary Is the given date in the same minute as the current date?
	 * @pure false
	 *
	 * @description
	 * Is the given date in the same minute as the current date?
	 *
	 * > ⚠️ Please note that this function is not present in the FP submodule as
	 * > it uses `Date.now()` internally hence impure and can't be safely curried.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is in this minute
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // If now is 25 September 2014 18:30:15.500,
	 * // is 25 September 2014 18:30:00 in this minute?
	 * var result = isThisMinute(new Date(2014, 8, 25, 18, 30))
	 * //=> true
	 */
	function isThisMinute(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(Date.now(), dirtyDate);
	}
	
	module.exports = exports.default;

/***/ },
/* 1012 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isThisMonth;
	
	var _index = _interopRequireDefault(__webpack_require__(431));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isThisMonth
	 * @category Month Helpers
	 * @summary Is the given date in the same month as the current date?
	 * @pure false
	 *
	 * @description
	 * Is the given date in the same month as the current date?
	 *
	 * > ⚠️ Please note that this function is not present in the FP submodule as
	 * > it uses `Date.now()` internally hence impure and can't be safely curried.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is in this month
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // If today is 25 September 2014, is 15 September 2014 in this month?
	 * var result = isThisMonth(new Date(2014, 8, 15))
	 * //=> true
	 */
	function isThisMonth(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(Date.now(), dirtyDate);
	}
	
	module.exports = exports.default;

/***/ },
/* 1013 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isThisQuarter;
	
	var _index = _interopRequireDefault(__webpack_require__(432));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isThisQuarter
	 * @category Quarter Helpers
	 * @summary Is the given date in the same quarter as the current date?
	 * @pure false
	 *
	 * @description
	 * Is the given date in the same quarter as the current date?
	 *
	 * > ⚠️ Please note that this function is not present in the FP submodule as
	 * > it uses `Date.now()` internally hence impure and can't be safely curried.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is in this quarter
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // If today is 25 September 2014, is 2 July 2014 in this quarter?
	 * var result = isThisQuarter(new Date(2014, 6, 2))
	 * //=> true
	 */
	function isThisQuarter(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(Date.now(), dirtyDate);
	}
	
	module.exports = exports.default;

/***/ },
/* 1014 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isThisSecond;
	
	var _index = _interopRequireDefault(__webpack_require__(433));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isThisSecond
	 * @category Second Helpers
	 * @summary Is the given date in the same second as the current date?
	 * @pure false
	 *
	 * @description
	 * Is the given date in the same second as the current date?
	 *
	 * > ⚠️ Please note that this function is not present in the FP submodule as
	 * > it uses `Date.now()` internally hence impure and can't be safely curried.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is in this second
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // If now is 25 September 2014 18:30:15.500,
	 * // is 25 September 2014 18:30:15.000 in this second?
	 * var result = isThisSecond(new Date(2014, 8, 25, 18, 30, 15))
	 * //=> true
	 */
	function isThisSecond(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(Date.now(), dirtyDate);
	}
	
	module.exports = exports.default;

/***/ },
/* 1015 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isThisWeek;
	
	var _index = _interopRequireDefault(__webpack_require__(279));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isThisWeek
	 * @category Week Helpers
	 * @summary Is the given date in the same week as the current date?
	 * @pure false
	 *
	 * @description
	 * Is the given date in the same week as the current date?
	 *
	 * > ⚠️ Please note that this function is not present in the FP submodule as
	 * > it uses `Date.now()` internally hence impure and can't be safely curried.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to check
	 * @param {Object} [options] - the object with options
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @returns {Boolean} the date is in this week
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 *
	 * @example
	 * // If today is 25 September 2014, is 21 September 2014 in this week?
	 * var result = isThisWeek(new Date(2014, 8, 21))
	 * //=> true
	 *
	 * @example
	 * // If today is 25 September 2014 and week starts with Monday
	 * // is 21 September 2014 in this week?
	 * var result = isThisWeek(new Date(2014, 8, 21), { weekStartsOn: 1 })
	 * //=> false
	 */
	function isThisWeek(dirtyDate, options) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(dirtyDate, Date.now(), options);
	}
	
	module.exports = exports.default;

/***/ },
/* 1016 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isThisYear;
	
	var _index = _interopRequireDefault(__webpack_require__(434));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isThisYear
	 * @category Year Helpers
	 * @summary Is the given date in the same year as the current date?
	 * @pure false
	 *
	 * @description
	 * Is the given date in the same year as the current date?
	 *
	 * > ⚠️ Please note that this function is not present in the FP submodule as
	 * > it uses `Date.now()` internally hence impure and can't be safely curried.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is in this year
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // If today is 25 September 2014, is 2 July 2014 in this year?
	 * var result = isThisYear(new Date(2014, 6, 2))
	 * //=> true
	 */
	function isThisYear(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(dirtyDate, Date.now());
	}
	
	module.exports = exports.default;

/***/ },
/* 1017 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isThursday;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isThursday
	 * @category Weekday Helpers
	 * @summary Is the given date Thursday?
	 *
	 * @description
	 * Is the given date Thursday?
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is Thursday
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Is 25 September 2014 Thursday?
	 * var result = isThursday(new Date(2014, 8, 25))
	 * //=> true
	 */
	function isThursday(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(dirtyDate).getDay() === 4;
	}
	
	module.exports = exports.default;

/***/ },
/* 1018 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isToday;
	
	var _index = _interopRequireDefault(__webpack_require__(151));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isToday
	 * @category Day Helpers
	 * @summary Is the given date today?
	 * @pure false
	 *
	 * @description
	 * Is the given date today?
	 *
	 * > ⚠️ Please note that this function is not present in the FP submodule as
	 * > it uses `Date.now()` internally hence impure and can't be safely curried.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is today
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // If today is 6 October 2014, is 6 October 14:00:00 today?
	 * var result = isToday(new Date(2014, 9, 6, 14, 0))
	 * //=> true
	 */
	function isToday(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(dirtyDate, Date.now());
	}
	
	module.exports = exports.default;

/***/ },
/* 1019 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isTomorrow;
	
	var _index = _interopRequireDefault(__webpack_require__(82));
	
	var _index2 = _interopRequireDefault(__webpack_require__(151));
	
	var _index3 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isTomorrow
	 * @category Day Helpers
	 * @summary Is the given date tomorrow?
	 * @pure false
	 *
	 * @description
	 * Is the given date tomorrow?
	 *
	 * > ⚠️ Please note that this function is not present in the FP submodule as
	 * > it uses `Date.now()` internally hence impure and can't be safely curried.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is tomorrow
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // If today is 6 October 2014, is 7 October 14:00:00 tomorrow?
	 * var result = isTomorrow(new Date(2014, 9, 7, 14, 0))
	 * //=> true
	 */
	function isTomorrow(dirtyDate) {
	  (0, _index3.default)(1, arguments);
	  return (0, _index2.default)(dirtyDate, (0, _index.default)(Date.now(), 1));
	}
	
	module.exports = exports.default;

/***/ },
/* 1020 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isTuesday;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isTuesday
	 * @category Weekday Helpers
	 * @summary Is the given date Tuesday?
	 *
	 * @description
	 * Is the given date Tuesday?
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is Tuesday
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Is 23 September 2014 Tuesday?
	 * var result = isTuesday(new Date(2014, 8, 23))
	 * //=> true
	 */
	function isTuesday(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(dirtyDate).getDay() === 2;
	}
	
	module.exports = exports.default;

/***/ },
/* 1021 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isWednesday;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isWednesday
	 * @category Weekday Helpers
	 * @summary Is the given date Wednesday?
	 *
	 * @description
	 * Is the given date Wednesday?
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is Wednesday
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Is 24 September 2014 Wednesday?
	 * const result = isWednesday(new Date(2014, 8, 24))
	 * //=> true
	 */
	function isWednesday(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(dirtyDate).getDay() === 3;
	}
	
	module.exports = exports.default;

/***/ },
/* 1022 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isWithinInterval;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isWithinInterval
	 * @category Interval Helpers
	 * @summary Is the given date within the interval?
	 *
	 * @description
	 * Is the given date within the interval? (Including start and end.)
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * - The function was renamed from `isWithinRange` to `isWithinInterval`.
	 *   This change was made to mirror the use of the word "interval" in standard ISO 8601:2004 terminology:
	 *
	 *   ```
	 *   2.1.3
	 *   time interval
	 *   part of the time axis limited by two instants
	 *   ```
	 *
	 *   Also, this function now accepts an object with `start` and `end` properties
	 *   instead of two arguments as an interval.
	 *   This function now throws `RangeError` if the start of the interval is after its end
	 *   or if any date in the interval is `Invalid Date`.
	 *
	 *   ```javascript
	 *   // Before v2.0.0
	 *
	 *   isWithinRange(
	 *     new Date(2014, 0, 3),
	 *     new Date(2014, 0, 1), new Date(2014, 0, 7)
	 *   )
	 *
	 *   // v2.0.0 onward
	 *
	 *   isWithinInterval(
	 *     new Date(2014, 0, 3),
	 *     { start: new Date(2014, 0, 1), end: new Date(2014, 0, 7) }
	 *   )
	 *   ```
	 *
	 * @param {Date|Number} date - the date to check
	 * @param {Interval} interval - the interval to check
	 * @returns {Boolean} the date is within the interval
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} The start of an interval cannot be after its end
	 * @throws {RangeError} Date in interval cannot be `Invalid Date`
	 *
	 * @example
	 * // For the date within the interval:
	 * isWithinInterval(new Date(2014, 0, 3), {
	 *   start: new Date(2014, 0, 1),
	 *   end: new Date(2014, 0, 7)
	 * })
	 * //=> true
	 *
	 * @example
	 * // For the date outside of the interval:
	 * isWithinInterval(new Date(2014, 0, 10), {
	 *   start: new Date(2014, 0, 1),
	 *   end: new Date(2014, 0, 7)
	 * })
	 * //=> false
	 *
	 * @example
	 * // For date equal to interval start:
	 * isWithinInterval(date, { start, end: date }) // => true
	 *
	 * @example
	 * // For date equal to interval end:
	 * isWithinInterval(date, { start: date, end }) // => true
	 */
	function isWithinInterval(dirtyDate, interval) {
	  (0, _index2.default)(2, arguments);
	  var time = (0, _index.default)(dirtyDate).getTime();
	  var startTime = (0, _index.default)(interval.start).getTime();
	  var endTime = (0, _index.default)(interval.end).getTime(); // Throw an exception if start date is after end date or if any date is `Invalid Date`
	
	  if (!(startTime <= endTime)) {
	    throw new RangeError('Invalid interval');
	  }
	
	  return time >= startTime && time <= endTime;
	}
	
	module.exports = exports.default;

/***/ },
/* 1023 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isYesterday;
	
	var _index = _interopRequireDefault(__webpack_require__(151));
	
	var _index2 = _interopRequireDefault(__webpack_require__(196));
	
	var _index3 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isYesterday
	 * @category Day Helpers
	 * @summary Is the given date yesterday?
	 * @pure false
	 *
	 * @description
	 * Is the given date yesterday?
	 *
	 * > ⚠️ Please note that this function is not present in the FP submodule as
	 * > it uses `Date.now()` internally hence impure and can't be safely curried.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is yesterday
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // If today is 6 October 2014, is 5 October 14:00:00 yesterday?
	 * var result = isYesterday(new Date(2014, 9, 5, 14, 0))
	 * //=> true
	 */
	function isYesterday(dirtyDate) {
	  (0, _index3.default)(1, arguments);
	  return (0, _index.default)(dirtyDate, (0, _index2.default)(Date.now(), 1));
	}
	
	module.exports = exports.default;

/***/ },
/* 1024 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = lastDayOfDecade;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name lastDayOfDecade
	 * @category Decade Helpers
	 * @summary Return the last day of a decade for the given date.
	 *
	 * @description
	 * Return the last day of a decade for the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the last day of a decade
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The last day of a decade for 21 December 2012 21:12:00:
	 * var result = lastDayOfDecade(new Date(2012, 11, 21, 21, 12, 00))
	 * //=> Wed Dec 31 2019 00:00:00
	 */
	function lastDayOfDecade(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var year = date.getFullYear();
	  var decade = 9 + Math.floor(year / 10) * 10;
	  date.setFullYear(decade + 1, 0, 0);
	  date.setHours(0, 0, 0, 0);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 1025 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = lastDayOfISOWeek;
	
	var _index = _interopRequireDefault(__webpack_require__(437));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name lastDayOfISOWeek
	 * @category ISO Week Helpers
	 * @summary Return the last day of an ISO week for the given date.
	 *
	 * @description
	 * Return the last day of an ISO week for the given date.
	 * The result will be in the local timezone.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the last day of an ISO week
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The last day of an ISO week for 2 September 2014 11:55:00:
	 * var result = lastDayOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Sun Sep 07 2014 00:00:00
	 */
	function lastDayOfISOWeek(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(dirtyDate, {
	    weekStartsOn: 1
	  });
	}
	
	module.exports = exports.default;

/***/ },
/* 1026 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = lastDayOfISOWeekYear;
	
	var _index = _interopRequireDefault(__webpack_require__(128));
	
	var _index2 = _interopRequireDefault(__webpack_require__(109));
	
	var _index3 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name lastDayOfISOWeekYear
	 * @category ISO Week-Numbering Year Helpers
	 * @summary Return the last day of an ISO week-numbering year for the given date.
	 *
	 * @description
	 * Return the last day of an ISO week-numbering year,
	 * which always starts 3 days before the year's first Thursday.
	 * The result will be in the local timezone.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * - The function was renamed from `lastDayOfISOYear` to `lastDayOfISOWeekYear`.
	 *   "ISO week year" is short for [ISO week-numbering year](https://en.wikipedia.org/wiki/ISO_week_date).
	 *   This change makes the name consistent with
	 *   locale-dependent week-numbering year helpers, e.g., `getWeekYear`.
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the end of an ISO week-numbering year
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The last day of an ISO week-numbering year for 2 July 2005:
	 * var result = lastDayOfISOWeekYear(new Date(2005, 6, 2))
	 * //=> Sun Jan 01 2006 00:00:00
	 */
	function lastDayOfISOWeekYear(dirtyDate) {
	  (0, _index3.default)(1, arguments);
	  var year = (0, _index.default)(dirtyDate);
	  var fourthOfJanuary = new Date(0);
	  fourthOfJanuary.setFullYear(year + 1, 0, 4);
	  fourthOfJanuary.setHours(0, 0, 0, 0);
	  var date = (0, _index2.default)(fourthOfJanuary);
	  date.setDate(date.getDate() - 1);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 1027 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = lastDayOfQuarter;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name lastDayOfQuarter
	 * @category Quarter Helpers
	 * @summary Return the last day of a year quarter for the given date.
	 *
	 * @description
	 * Return the last day of a year quarter for the given date.
	 * The result will be in the local timezone.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @param {Object} [options] - an object with options.
	 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
	 * @returns {Date} the last day of a quarter
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
	 *
	 * @example
	 * // The last day of a quarter for 2 September 2014 11:55:00:
	 * var result = lastDayOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Tue Sep 30 2014 00:00:00
	 */
	function lastDayOfQuarter(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var currentMonth = date.getMonth();
	  var month = currentMonth - currentMonth % 3 + 3;
	  date.setMonth(month, 0);
	  date.setHours(0, 0, 0, 0);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 1028 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = lastDayOfYear;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name lastDayOfYear
	 * @category Year Helpers
	 * @summary Return the last day of a year for the given date.
	 *
	 * @description
	 * Return the last day of a year for the given date.
	 * The result will be in the local timezone.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the last day of a year
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The last day of a year for 2 September 2014 11:55:00:
	 * var result = lastDayOfYear(new Date(2014, 8, 2, 11, 55, 00))
	 * //=> Wed Dec 31 2014 00:00:00
	 */
	function lastDayOfYear(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var year = date.getFullYear();
	  date.setFullYear(year + 1, 0, 0);
	  date.setHours(0, 0, 0, 0);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 1029 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = lightFormat;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(395));
	
	var _index3 = _interopRequireDefault(__webpack_require__(81));
	
	var _index4 = _interopRequireDefault(__webpack_require__(83));
	
	var _index5 = _interopRequireDefault(__webpack_require__(153));
	
	var _index6 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// This RegExp consists of three parts separated by `|`:
	// - (\w)\1* matches any sequences of the same letter
	// - '' matches two quote characters in a row
	// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
	//   except a single quote symbol, which ends the sequence.
	//   Two quote characters do not end the sequence.
	//   If there is no matching single quote
	//   then the sequence will continue until the end of the string.
	// - . matches any single character unmatched by previous parts of the RegExps
	var formattingTokensRegExp = /(\w)\1*|''|'(''|[^'])+('|$)|./g;
	var escapedStringRegExp = /^'([^]*?)'?$/;
	var doubleQuoteRegExp = /''/g;
	var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
	/**
	 * @name lightFormat
	 * @category Common Helpers
	 * @summary Format the date.
	 *
	 * @description
	 * Return the formatted date string in the given format. Unlike `format`,
	 * `lightFormat` doesn't use locales and outputs date using the most popular tokens.
	 *
	 * > ⚠️ Please note that the `lightFormat` tokens differ from Moment.js and other libraries.
	 * > See: https://git.io/fxCyr
	 *
	 * The characters wrapped between two single quotes characters (') are escaped.
	 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
	 *
	 * Format of the string is based on Unicode Technical Standard #35:
	 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
	 *
	 * Accepted patterns:
	 * | Unit                            | Pattern | Result examples                   |
	 * |---------------------------------|---------|-----------------------------------|
	 * | AM, PM                          | a..aaa  | AM, PM                            |
	 * |                                 | aaaa    | a.m., p.m.                        |
	 * |                                 | aaaaa   | a, p                              |
	 * | Calendar year                   | y       | 44, 1, 1900, 2017                 |
	 * |                                 | yy      | 44, 01, 00, 17                    |
	 * |                                 | yyy     | 044, 001, 000, 017                |
	 * |                                 | yyyy    | 0044, 0001, 1900, 2017            |
	 * | Month (formatting)              | M       | 1, 2, ..., 12                     |
	 * |                                 | MM      | 01, 02, ..., 12                   |
	 * | Day of month                    | d       | 1, 2, ..., 31                     |
	 * |                                 | dd      | 01, 02, ..., 31                   |
	 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |
	 * |                                 | hh      | 01, 02, ..., 11, 12               |
	 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |
	 * |                                 | HH      | 00, 01, 02, ..., 23               |
	 * | Minute                          | m       | 0, 1, ..., 59                     |
	 * |                                 | mm      | 00, 01, ..., 59                   |
	 * | Second                          | s       | 0, 1, ..., 59                     |
	 * |                                 | ss      | 00, 01, ..., 59                   |
	 * | Fraction of second              | S       | 0, 1, ..., 9                      |
	 * |                                 | SS      | 00, 01, ..., 99                   |
	 * |                                 | SSS     | 000, 001, ..., 999                |
	 * |                                 | SSSS    | ...                               |
	 *
	 * @param {Date|Number} date - the original date
	 * @param {String} format - the string of tokens
	 * @returns {String} the formatted date string
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} format string contains an unescaped latin alphabet character
	 *
	 * @example
	 * const result = lightFormat(new Date(2014, 1, 11), 'yyyy-MM-dd')
	 * //=> '2014-02-11'
	 */
	
	function lightFormat(dirtyDate, formatStr) {
	  (0, _index6.default)(2, arguments);
	  var originalDate = (0, _index.default)(dirtyDate);
	
	  if (!(0, _index4.default)(originalDate)) {
	    throw new RangeError('Invalid time value');
	  } // Convert the date in system timezone to the same date in UTC+00:00 timezone.
	  // This ensures that when UTC functions will be implemented, locales will be compatible with them.
	  // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
	
	
	  var timezoneOffset = (0, _index3.default)(originalDate);
	  var utcDate = (0, _index5.default)(originalDate, timezoneOffset);
	  var tokens = formatStr.match(formattingTokensRegExp); // The only case when formattingTokensRegExp doesn't match the string is when it's empty
	
	  if (!tokens) return '';
	  var result = tokens.map(function (substring) {
	    // Replace two single quote characters with one single quote character
	    if (substring === "''") {
	      return "'";
	    }
	
	    var firstCharacter = substring[0];
	
	    if (firstCharacter === "'") {
	      return cleanEscapedString(substring);
	    }
	
	    var formatter = _index2.default[firstCharacter];
	
	    if (formatter) {
	      return formatter(utcDate, substring);
	    }
	
	    if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
	      throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
	    }
	
	    return substring;
	  }).join('');
	  return result;
	}
	
	function cleanEscapedString(input) {
	  var matches = input.match(escapedStringRegExp);
	
	  if (!matches) {
	    return input;
	  }
	
	  return matches[1].replace(doubleQuoteRegExp, "'");
	}
	
	module.exports = exports.default;

/***/ },
/* 1030 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    one: "minder as 'n sekonde",
	    other: 'minder as {{count}} sekondes'
	  },
	  xSeconds: {
	    one: '1 sekonde',
	    other: '{{count}} sekondes'
	  },
	  halfAMinute: "'n halwe minuut",
	  lessThanXMinutes: {
	    one: "minder as 'n minuut",
	    other: 'minder as {{count}} minute'
	  },
	  xMinutes: {
	    one: "'n minuut",
	    other: '{{count}} minute'
	  },
	  aboutXHours: {
	    one: 'ongeveer 1 uur',
	    other: 'ongeveer {{count}} ure'
	  },
	  xHours: {
	    one: '1 uur',
	    other: '{{count}} ure'
	  },
	  xDays: {
	    one: '1 dag',
	    other: '{{count}} dae'
	  },
	  aboutXWeeks: {
	    one: 'ongeveer 1 week',
	    other: 'ongeveer {{count}} weke'
	  },
	  xWeeks: {
	    one: '1 week',
	    other: '{{count}} weke'
	  },
	  aboutXMonths: {
	    one: 'ongeveer 1 maand',
	    other: 'ongeveer {{count}} maande'
	  },
	  xMonths: {
	    one: '1 maand',
	    other: '{{count}} maande'
	  },
	  aboutXYears: {
	    one: 'ongeveer 1 jaar',
	    other: 'ongeveer {{count}} jaar'
	  },
	  xYears: {
	    one: '1 jaar',
	    other: '{{count}} jaar'
	  },
	  overXYears: {
	    one: 'meer as 1 jaar',
	    other: 'meer as {{count}} jaar'
	  },
	  almostXYears: {
	    one: 'byna 1 jaar',
	    other: 'byna {{count}} jaar'
	  }
	};
	
	var formatDistance = function (token, count) {
	  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	  var usageGroup = formatDistanceLocale[token];
	  var result;
	
	  if (typeof usageGroup === 'string') {
	    result = usageGroup;
	  } else if (count === 1) {
	    result = usageGroup.one;
	  } else {
	    result = usageGroup.other.replace('{{count}}', String(count));
	  }
	
	  if (options.addSuffix) {
	    if (options.comparison && options.comparison > 0) {
	      return 'oor ' + result;
	    } else {
	      return result + ' gelede';
	    }
	  }
	
	  return result;
	};
	
	var _default = formatDistance;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1031 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: 'EEEE, d MMMM yyyy',
	  long: 'd MMMM yyyy',
	  medium: 'd MMM yyyy',
	  short: 'yyyy/MM/dd'
	};
	var timeFormats = {
	  full: 'HH:mm:ss zzzz',
	  long: 'HH:mm:ss z',
	  medium: 'HH:mm:ss',
	  short: 'HH:mm'
	};
	var dateTimeFormats = {
	  full: "{{date}} 'om' {{time}}",
	  long: "{{date}} 'om' {{time}}",
	  medium: '{{date}}, {{time}}',
	  short: '{{date}}, {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1032 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var formatRelativeLocale = {
	  lastWeek: "'verlede' eeee 'om' p",
	  yesterday: "'gister om' p",
	  today: "'vandag om' p",
	  tomorrow: "'môre om' p",
	  nextWeek: "eeee 'om' p",
	  other: 'P'
	};
	
	var formatRelative = function (token) {
	  return formatRelativeLocale[token];
	};
	
	var _default = formatRelative;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1033 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eraValues = {
	  narrow: ['vC', 'nC'],
	  abbreviated: ['vC', 'nC'],
	  wide: ['voor Christus', 'na Christus']
	};
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['K1', 'K2', 'K3', 'K4'],
	  wide: ['1ste kwartaal', '2de kwartaal', '3de kwartaal', '4de kwartaal']
	};
	var monthValues = {
	  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
	  abbreviated: ['Jan', 'Feb', 'Mrt', 'Apr', 'Mei', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Des'],
	  wide: ['Januarie', 'Februarie', 'Maart', 'April', 'Mei', 'Junie', 'Julie', 'Augustus', 'September', 'Oktober', 'November', 'Desember']
	};
	var dayValues = {
	  narrow: ['S', 'M', 'D', 'W', 'D', 'V', 'S'],
	  short: ['So', 'Ma', 'Di', 'Wo', 'Do', 'Vr', 'Sa'],
	  abbreviated: ['Son', 'Maa', 'Din', 'Woe', 'Don', 'Vry', 'Sat'],
	  wide: ['Sondag', 'Maandag', 'Dinsdag', 'Woensdag', 'Donderdag', 'Vrydag', 'Saterdag']
	};
	var dayPeriodValues = {
	  narrow: {
	    am: 'vm',
	    pm: 'nm',
	    midnight: 'middernag',
	    noon: 'middaguur',
	    morning: 'oggend',
	    afternoon: 'middag',
	    evening: 'laat middag',
	    night: 'aand'
	  },
	  abbreviated: {
	    am: 'vm',
	    pm: 'nm',
	    midnight: 'middernag',
	    noon: 'middaguur',
	    morning: 'oggend',
	    afternoon: 'middag',
	    evening: 'laat middag',
	    night: 'aand'
	  },
	  wide: {
	    am: 'vm',
	    pm: 'nm',
	    midnight: 'middernag',
	    noon: 'middaguur',
	    morning: 'oggend',
	    afternoon: 'middag',
	    evening: 'laat middag',
	    night: 'aand'
	  }
	};
	var formattingDayPeriodValues = {
	  narrow: {
	    am: 'vm',
	    pm: 'nm',
	    midnight: 'middernag',
	    noon: 'uur die middag',
	    morning: 'uur die oggend',
	    afternoon: 'uur die middag',
	    evening: 'uur die aand',
	    night: 'uur die aand'
	  },
	  abbreviated: {
	    am: 'vm',
	    pm: 'nm',
	    midnight: 'middernag',
	    noon: 'uur die middag',
	    morning: 'uur die oggend',
	    afternoon: 'uur die middag',
	    evening: 'uur die aand',
	    night: 'uur die aand'
	  },
	  wide: {
	    am: 'vm',
	    pm: 'nm',
	    midnight: 'middernag',
	    noon: 'uur die middag',
	    morning: 'uur die oggend',
	    afternoon: 'uur die middag',
	    evening: 'uur die aand',
	    night: 'uur die aand'
	  }
	};
	
	var ordinalNumber = function (dirtyNumber) {
	  var number = Number(dirtyNumber);
	  var rem100 = number % 100;
	
	  if (rem100 < 20) {
	    switch (rem100) {
	      case 1:
	      case 8:
	        return number + 'ste';
	
	      default:
	        return number + 'de';
	    }
	  }
	
	  return number + 'ste';
	};
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingDayPeriodValues,
	    defaultFormattingWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1034 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(15));
	
	var _index2 = _interopRequireDefault(__webpack_require__(14));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(\d+)(ste|de)?/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^([vn]\.? ?C\.?)/,
	  abbreviated: /^([vn]\. ?C\.?)/,
	  wide: /^((voor|na) Christus)/
	};
	var parseEraPatterns = {
	  any: [/^v/, /^n/]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^K[1234]/i,
	  wide: /^[1234](st|d)e kwartaal/i
	};
	var parseQuarterPatterns = {
	  any: [/1/i, /2/i, /3/i, /4/i]
	};
	var matchMonthPatterns = {
	  narrow: /^[jfmasond]/i,
	  abbreviated: /^(Jan|Feb|Mrt|Apr|Mei|Jun|Jul|Aug|Sep|Okt|Nov|Dec)\.?/i,
	  wide: /^(Januarie|Februarie|Maart|April|Mei|Junie|Julie|Augustus|September|Oktober|November|Desember)/i
	};
	var parseMonthPatterns = {
	  narrow: [/^J/i, /^F/i, /^M/i, /^A/i, /^M/i, /^J/i, /^J/i, /^A/i, /^S/i, /^O/i, /^N/i, /^D/i],
	  any: [/^Jan/i, /^Feb/i, /^Mrt/i, /^Apr/i, /^Mei/i, /^Jun/i, /^Jul/i, /^Aug/i, /^Sep/i, /^Okt/i, /^Nov/i, /^Dec/i]
	};
	var matchDayPatterns = {
	  narrow: /^[smdwv]/i,
	  short: /^(So|Ma|Di|Wo|Do|Vr|Sa)/i,
	  abbreviated: /^(Son|Maa|Din|Woe|Don|Vry|Sat)/i,
	  wide: /^(Sondag|Maandag|Dinsdag|Woensdag|Donderdag|Vrydag|Saterdag)/i
	};
	var parseDayPatterns = {
	  narrow: [/^S/i, /^M/i, /^D/i, /^W/i, /^D/i, /^V/i, /^S/i],
	  any: [/^So/i, /^Ma/i, /^Di/i, /^Wo/i, /^Do/i, /^Vr/i, /^Sa/i]
	};
	var matchDayPeriodPatterns = {
	  any: /^(vm|nm|middernag|(?:uur )?die (oggend|middag|aand))/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^vm/i,
	    pm: /^nm/i,
	    midnight: /^middernag/i,
	    noon: /^middaguur/i,
	    morning: /oggend/i,
	    afternoon: /middag/i,
	    evening: /laat middag/i,
	    night: /aand/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index2.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index2.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return Number(index) + 1;
	    }
	  }),
	  month: (0, _index2.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index2.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index2.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1035 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1030));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1031));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1032));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1033));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1034));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Afrikaans locale.
	 * @language Afrikaans
	 * @iso-639-2 afr
	 * @author Marnus Weststrate [@marnusw]{@link https://github.com/marnusw}
	 */
	var locale = {
	  code: 'af',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 0
	    /* Sunday */
	    ,
	    firstWeekContainsDate: 1
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1036 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    one: 'أقل من ثانية واحدة',
	    two: 'أقل من ثانتين',
	    threeToTen: 'أقل من {{count}} ثواني',
	    other: 'أقل من {{count}} ثانية'
	  },
	  xSeconds: {
	    one: 'ثانية واحدة',
	    two: 'ثانتين',
	    threeToTen: '{{count}} ثواني',
	    other: '{{count}} ثانية'
	  },
	  halfAMinute: 'نصف دقيقة',
	  lessThanXMinutes: {
	    one: 'أقل من دقيقة',
	    two: 'أقل من دقيقتين',
	    threeToTen: 'أقل من {{count}} دقائق',
	    other: 'أقل من {{count}} دقيقة'
	  },
	  xMinutes: {
	    one: 'دقيقة واحدة',
	    two: 'دقيقتين',
	    threeToTen: '{{count}} دقائق',
	    other: '{{count}} دقيقة'
	  },
	  aboutXHours: {
	    one: 'ساعة واحدة تقريباً',
	    two: 'ساعتين تقريباً',
	    threeToTen: '{{count}} ساعات تقريباً',
	    other: '{{count}} ساعة تقريباً'
	  },
	  xHours: {
	    one: 'ساعة واحدة',
	    two: 'ساعتين',
	    threeToTen: '{{count}} ساعات',
	    other: '{{count}} ساعة'
	  },
	  xDays: {
	    one: 'يوم واحد',
	    two: 'يومين',
	    threeToTen: '{{count}} أيام',
	    other: '{{count}} يوم'
	  },
	  aboutXWeeks: {
	    one: 'أسبوع واحد تقريباً',
	    two: 'أسبوعين تقريباً',
	    threeToTen: '{{count}} أسابيع تقريباً',
	    other: '{{count}} أسبوع تقريباً'
	  },
	  xWeeks: {
	    one: 'أسبوع واحد',
	    two: 'أسبوعين',
	    threeToTen: '{{count}} أسابيع',
	    other: '{{count}} أسبوع'
	  },
	  aboutXMonths: {
	    one: 'شهر واحد تقريباً',
	    two: 'شهرين تقريباً',
	    threeToTen: '{{count}} أشهر تقريباً',
	    other: '{{count}} شهر تقريباً'
	  },
	  xMonths: {
	    one: 'شهر واحد',
	    two: 'شهرين',
	    threeToTen: '{{count}} أشهر',
	    other: '{{count}} شهر'
	  },
	  aboutXYears: {
	    one: 'عام واحد تقريباً',
	    two: 'عامين تقريباً',
	    threeToTen: '{{count}} أعوام تقريباً',
	    other: '{{count}} عام تقريباً'
	  },
	  xYears: {
	    one: 'عام واحد',
	    two: 'عامين',
	    threeToTen: '{{count}} أعوام',
	    other: '{{count}} عام'
	  },
	  overXYears: {
	    one: 'أكثر من عام',
	    two: 'أكثر من عامين',
	    threeToTen: 'أكثر من {{count}} أعوام',
	    other: 'أكثر من {{count}} عام'
	  },
	  almostXYears: {
	    one: 'عام واحد تقريباً',
	    two: 'عامين تقريباً',
	    threeToTen: '{{count}} أعوام تقريباً',
	    other: '{{count}} عام تقريباً'
	  }
	};
	
	var formatDistance = function (token, count, options) {
	  options = options || {};
	  var usageGroup = formatDistanceLocale[token];
	  var result;
	
	  if (typeof usageGroup === 'string') {
	    result = usageGroup;
	  } else if (count === 1) {
	    result = usageGroup.one;
	  } else if (count === 2) {
	    result = usageGroup.two;
	  } else if (count <= 10) {
	    result = usageGroup.threeToTen.replace('{{count}}', String(count));
	  } else {
	    result = usageGroup.other.replace('{{count}}', String(count));
	  }
	
	  if (options.addSuffix) {
	    if (options.comparison && options.comparison > 0) {
	      return 'في خلال ' + result;
	    } else {
	      return 'منذ ' + result;
	    }
	  }
	
	  return result;
	};
	
	var _default = formatDistance;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1037 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: 'EEEE, MMMM do, y',
	  long: 'MMMM do, y',
	  medium: 'MMM d, y',
	  short: 'MM/dd/yyyy'
	};
	var timeFormats = {
	  full: 'h:mm:ss a zzzz',
	  long: 'h:mm:ss a z',
	  medium: 'h:mm:ss a',
	  short: 'h:mm a'
	};
	var dateTimeFormats = {
	  full: "{{date}} 'عند' {{time}}",
	  long: "{{date}} 'عند' {{time}}",
	  medium: '{{date}}, {{time}}',
	  short: '{{date}}, {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1038 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var formatRelativeLocale = {
	  lastWeek: "'أخر' eeee 'عند' p",
	  yesterday: "'أمس عند' p",
	  today: "'اليوم عند' p",
	  tomorrow: "'غداً عند' p",
	  nextWeek: "eeee 'عند' p",
	  other: 'P'
	};
	
	var formatRelative = function (token, _date, _baseDate, _options) {
	  return formatRelativeLocale[token];
	};
	
	var _default = formatRelative;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1039 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eraValues = {
	  narrow: ['ق', 'ب'],
	  abbreviated: ['ق.م.', 'ب.م.'],
	  wide: ['قبل الميلاد', 'بعد الميلاد']
	};
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['ر1', 'ر2', 'ر3', 'ر4'],
	  wide: ['الربع الأول', 'الربع الثاني', 'الربع الثالث', 'الربع الرابع']
	};
	var monthValues = {
	  narrow: ['ج', 'ف', 'م', 'أ', 'م', 'ج', 'ج', 'أ', 'س', 'أ', 'ن', 'د'],
	  abbreviated: ['جانـ', 'فيفـ', 'مارس', 'أفريل', 'مايـ', 'جوانـ', 'جويـ', 'أوت', 'سبتـ', 'أكتـ', 'نوفـ', 'ديسـ'],
	  wide: ['جانفي', 'فيفري', 'مارس', 'أفريل', 'ماي', 'جوان', 'جويلية', 'أوت', 'سبتمبر', 'أكتوبر', 'نوفمبر', 'ديسمبر']
	};
	var dayValues = {
	  narrow: ['ح', 'ن', 'ث', 'ر', 'خ', 'ج', 'س'],
	  short: ['أحد', 'اثنين', 'ثلاثاء', 'أربعاء', 'خميس', 'جمعة', 'سبت'],
	  abbreviated: ['أحد', 'اثنـ', 'ثلا', 'أربـ', 'خميـ', 'جمعة', 'سبت'],
	  wide: ['الأحد', 'الاثنين', 'الثلاثاء', 'الأربعاء', 'الخميس', 'الجمعة', 'السبت']
	};
	var dayPeriodValues = {
	  narrow: {
	    am: 'ص',
	    pm: 'م',
	    midnight: 'ن',
	    noon: 'ظ',
	    morning: 'صباحاً',
	    afternoon: 'بعد الظهر',
	    evening: 'مساءاً',
	    night: 'ليلاً'
	  },
	  abbreviated: {
	    am: 'ص',
	    pm: 'م',
	    midnight: 'نصف الليل',
	    noon: 'ظهر',
	    morning: 'صباحاً',
	    afternoon: 'بعد الظهر',
	    evening: 'مساءاً',
	    night: 'ليلاً'
	  },
	  wide: {
	    am: 'ص',
	    pm: 'م',
	    midnight: 'نصف الليل',
	    noon: 'ظهر',
	    morning: 'صباحاً',
	    afternoon: 'بعد الظهر',
	    evening: 'مساءاً',
	    night: 'ليلاً'
	  }
	};
	var formattingDayPeriodValues = {
	  narrow: {
	    am: 'ص',
	    pm: 'م',
	    midnight: 'ن',
	    noon: 'ظ',
	    morning: 'في الصباح',
	    afternoon: 'بعد الظـهر',
	    evening: 'في المساء',
	    night: 'في الليل'
	  },
	  abbreviated: {
	    am: 'ص',
	    pm: 'م',
	    midnight: 'نصف الليل',
	    noon: 'ظهر',
	    morning: 'في الصباح',
	    afternoon: 'بعد الظهر',
	    evening: 'في المساء',
	    night: 'في الليل'
	  },
	  wide: {
	    am: 'ص',
	    pm: 'م',
	    midnight: 'نصف الليل',
	    noon: 'ظهر',
	    morning: 'صباحاً',
	    afternoon: 'بعد الظـهر',
	    evening: 'في المساء',
	    night: 'في الليل'
	  }
	};
	
	var ordinalNumber = function (dirtyNumber) {
	  return String(dirtyNumber);
	};
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingDayPeriodValues,
	    defaultFormattingWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1040 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(15));
	
	var _index2 = _interopRequireDefault(__webpack_require__(14));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^(ق|ب)/i,
	  abbreviated: /^(ق\.?\s?م\.?|ق\.?\s?م\.?\s?|a\.?\s?d\.?|c\.?\s?)/i,
	  wide: /^(قبل الميلاد|قبل الميلاد|بعد الميلاد|بعد الميلاد)/i
	};
	var parseEraPatterns = {
	  any: [/^قبل/i, /^بعد/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^ر[1234]/i,
	  wide: /^الربع [1234]/i
	};
	var parseQuarterPatterns = {
	  any: [/1/i, /2/i, /3/i, /4/i]
	};
	var matchMonthPatterns = {
	  narrow: /^[جفمأسند]/i,
	  abbreviated: /^(جان|فيف|مار|أفر|ماي|جوا|جوي|أوت|سبت|أكت|نوف|ديس)/i,
	  wide: /^(جانفي|فيفري|مارس|أفريل|ماي|جوان|جويلية|أوت|سبتمبر|أكتوبر|نوفمبر|ديسمبر)/i
	};
	var parseMonthPatterns = {
	  narrow: [/^ج/i, /^ف/i, /^م/i, /^أ/i, /^م/i, /^ج/i, /^ج/i, /^أ/i, /^س/i, /^أ/i, /^ن/i, /^د/i],
	  any: [/^جان/i, /^فيف/i, /^مار/i, /^أفر/i, /^ماي/i, /^جوا/i, /^جوي/i, /^أوت/i, /^سبت/i, /^أكت/i, /^نوف/i, /^ديس/i]
	};
	var matchDayPatterns = {
	  narrow: /^[حنثرخجس]/i,
	  short: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
	  abbreviated: /^(أحد|اثن|ثلا|أرب|خمي|جمعة|سبت)/i,
	  wide: /^(الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت)/i
	};
	var parseDayPatterns = {
	  narrow: [/^ح/i, /^ن/i, /^ث/i, /^ر/i, /^خ/i, /^ج/i, /^س/i],
	  wide: [/^الأحد/i, /^الاثنين/i, /^الثلاثاء/i, /^الأربعاء/i, /^الخميس/i, /^الجمعة/i, /^السبت/i],
	  any: [/^أح/i, /^اث/i, /^ث/i, /^أر/i, /^خ/i, /^ج/i, /^س/i]
	};
	var matchDayPeriodPatterns = {
	  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
	  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^a/i,
	    pm: /^p/i,
	    midnight: /^mi/i,
	    noon: /^no/i,
	    morning: /morning/i,
	    afternoon: /afternoon/i,
	    evening: /evening/i,
	    night: /night/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index2.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index2.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return Number(index) + 1;
	    }
	  }),
	  month: (0, _index2.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index2.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index2.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1041 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1036));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1037));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1038));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1039));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1040));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Arabic locale (Algerian Arabic).
	 * @language Algerian Arabic
	 * @iso-639-2 ara
	 * @author Badreddine Boumaza [@badre429]{@link https://github.com/badre429}
	 * @author Ahmed ElShahat [@elshahat]{@link https://github.com/elshahat}
	 */
	var locale = {
	  code: 'ar-DZ',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 0
	    /* Sunday */
	    ,
	    firstWeekContainsDate: 1
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1042 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    one: 'أقل من ثانية',
	    two: 'أقل من ثانيتين',
	    threeToTen: 'أقل من {{count}} ثواني',
	    other: 'أقل من {{count}} ثانية'
	  },
	  xSeconds: {
	    one: 'ثانية',
	    two: 'ثانيتين',
	    threeToTen: '{{count}} ثواني',
	    other: '{{count}} ثانية'
	  },
	  halfAMinute: 'نص دقيقة',
	  lessThanXMinutes: {
	    one: 'أقل من دقيقة',
	    two: 'أقل من دقيقتين',
	    threeToTen: 'أقل من {{count}} دقايق',
	    other: 'أقل من {{count}} دقيقة'
	  },
	  xMinutes: {
	    one: 'دقيقة',
	    two: 'دقيقتين',
	    threeToTen: '{{count}} دقايق',
	    other: '{{count}} دقيقة'
	  },
	  aboutXHours: {
	    one: 'حوالي ساعة',
	    two: 'حوالي ساعتين',
	    threeToTen: 'حوالي {{count}} ساعات',
	    other: 'حوالي {{count}} ساعة'
	  },
	  xHours: {
	    one: 'ساعة',
	    two: 'ساعتين',
	    threeToTen: '{{count}} ساعات',
	    other: '{{count}} ساعة'
	  },
	  xDays: {
	    one: 'يوم',
	    two: 'يومين',
	    threeToTen: '{{count}} أيام',
	    other: '{{count}} يوم'
	  },
	  aboutXWeeks: {
	    one: 'حوالي أسبوع',
	    two: 'حوالي أسبوعين',
	    threeToTen: 'حوالي {{count}} أسابيع',
	    other: 'حوالي {{count}} أسبوع'
	  },
	  xWeeks: {
	    one: 'أسبوع',
	    two: 'أسبوعين',
	    threeToTen: '{{count}} أسابيع',
	    other: '{{count}} أسبوع'
	  },
	  aboutXMonths: {
	    one: 'حوالي شهر',
	    two: 'حوالي شهرين',
	    threeToTen: 'حوالي {{count}} أشهر',
	    other: 'حوالي {{count}} شهر'
	  },
	  xMonths: {
	    one: 'شهر',
	    two: 'شهرين',
	    threeToTen: '{{count}} أشهر',
	    other: '{{count}} شهر'
	  },
	  aboutXYears: {
	    one: 'حوالي سنة',
	    two: 'حوالي سنتين',
	    threeToTen: 'حوالي {{count}} سنين',
	    other: 'حوالي {{count}} سنة'
	  },
	  xYears: {
	    one: 'عام',
	    two: 'عامين',
	    threeToTen: '{{count}} أعوام',
	    other: '{{count}} عام'
	  },
	  overXYears: {
	    one: 'أكثر من سنة',
	    two: 'أكثر من سنتين',
	    threeToTen: 'أكثر من {{count}} سنين',
	    other: 'أكثر من {{count}} سنة'
	  },
	  almostXYears: {
	    one: 'عام تقريبًا',
	    two: 'عامين تقريبًا',
	    threeToTen: '{{count}} أعوام تقريبًا',
	    other: '{{count}} عام تقريبًا'
	  }
	};
	
	var formatDistance = function (token, count, options) {
	  var result;
	  var tokenValue = formatDistanceLocale[token];
	
	  if (typeof tokenValue === 'string') {
	    result = tokenValue;
	  } else if (count === 1) {
	    result = tokenValue.one;
	  } else if (count === 2) {
	    result = tokenValue.two;
	  } else if (count <= 10) {
	    result = tokenValue.threeToTen.replace('{{count}}', String(count));
	  } else {
	    result = tokenValue.other.replace('{{count}}', String(count));
	  }
	
	  if (options !== null && options !== void 0 && options.addSuffix) {
	    if (options.comparison && options.comparison > 0) {
	      return "\u0641\u064A \u062E\u0644\u0627\u0644 ".concat(result);
	    } else {
	      return "\u0645\u0646\u0630 ".concat(result);
	    }
	  }
	
	  return result;
	};
	
	var _default = formatDistance;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1043 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: 'EEEE، do MMMM y',
	  long: 'do MMMM y',
	  medium: 'dd/MMM/y',
	  short: 'd/MM/y'
	};
	var timeFormats = {
	  full: 'h:mm:ss a zzzz',
	  long: 'h:mm:ss a z',
	  medium: 'h:mm:ss a',
	  short: 'h:mm a'
	};
	var dateTimeFormats = {
	  full: "{{date}} 'الساعة' {{time}}",
	  long: "{{date}} 'الساعة' {{time}}",
	  medium: '{{date}}, {{time}}',
	  short: '{{date}}, {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1044 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var formatRelativeLocale = {
	  lastWeek: "eeee 'اللي جاي الساعة' p",
	  yesterday: "'إمبارح الساعة' p",
	  today: "'النهاردة الساعة' p",
	  tomorrow: "'بكرة الساعة' p",
	  nextWeek: "eeee 'الساعة' p",
	  other: 'P'
	};
	
	var formatRelative = function (token, _date, _baseDate, _options) {
	  return formatRelativeLocale[token];
	};
	
	var _default = formatRelative;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1045 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eraValues = {
	  narrow: ['ق', 'ب'],
	  abbreviated: ['ق.م', 'ب.م'],
	  wide: ['قبل الميلاد', 'بعد الميلاد']
	};
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['ر1', 'ر2', 'ر3', 'ر4'],
	  wide: ['الربع الأول', 'الربع الثاني', 'الربع الثالث', 'الربع الرابع']
	};
	var monthValues = {
	  narrow: ['ي', 'ف', 'م', 'أ', 'م', 'ي', 'ي', 'أ', 'س', 'أ', 'ن', 'د'],
	  abbreviated: ['ينا', 'فبر', 'مارس', 'أبريل', 'مايو', 'يونـ', 'يولـ', 'أغسـ', 'سبتـ', 'أكتـ', 'نوفـ', 'ديسـ'],
	  wide: ['يناير', 'فبراير', 'مارس', 'أبريل', 'مايو', 'يونيو', 'يوليو', 'أغسطس', 'سبتمبر', 'أكتوبر', 'نوفمبر', 'ديسمبر']
	};
	var dayValues = {
	  narrow: ['ح', 'ن', 'ث', 'ر', 'خ', 'ج', 'س'],
	  short: ['أحد', 'اثنين', 'ثلاثاء', 'أربعاء', 'خميس', 'جمعة', 'سبت'],
	  abbreviated: ['أحد', 'اثنين', 'ثلاثاء', 'أربعاء', 'خميس', 'جمعة', 'سبت'],
	  wide: ['الأحد', 'الاثنين', 'الثلاثاء', 'الأربعاء', 'الخميس', 'الجمعة', 'السبت']
	};
	var dayPeriodValues = {
	  narrow: {
	    am: 'ص',
	    pm: 'م',
	    midnight: 'ن',
	    noon: 'ظ',
	    morning: 'صباحاً',
	    afternoon: 'بعد الظهر',
	    evening: 'مساءً',
	    night: 'ليلاً'
	  },
	  abbreviated: {
	    am: 'ص',
	    pm: 'م',
	    midnight: 'نصف الليل',
	    noon: 'ظهراً',
	    morning: 'صباحاً',
	    afternoon: 'بعد الظهر',
	    evening: 'مساءً',
	    night: 'ليلاً'
	  },
	  wide: {
	    am: 'ص',
	    pm: 'م',
	    midnight: 'نصف الليل',
	    noon: 'ظهراً',
	    morning: 'صباحاً',
	    afternoon: 'بعد الظهر',
	    evening: 'مساءً',
	    night: 'ليلاً'
	  }
	};
	var formattingDayPeriodValues = {
	  narrow: {
	    am: 'ص',
	    pm: 'م',
	    midnight: 'ن',
	    noon: 'ظ',
	    morning: 'في الصباح',
	    afternoon: 'بعد الظهر',
	    evening: 'في المساء',
	    night: 'في الليل'
	  },
	  abbreviated: {
	    am: 'ص',
	    pm: 'م',
	    midnight: 'نصف الليل',
	    noon: 'ظهراً',
	    morning: 'في الصباح',
	    afternoon: 'بعد الظهر',
	    evening: 'في المساء',
	    night: 'في الليل'
	  },
	  wide: {
	    am: 'ص',
	    pm: 'م',
	    midnight: 'نصف الليل',
	    morning: 'في الصباح',
	    noon: 'ظهراً',
	    afternoon: 'بعد الظهر',
	    evening: 'في المساء',
	    night: 'في الليل'
	  }
	};
	
	var ordinalNumber = function (dirtyNumber, _options) {
	  return String(dirtyNumber);
	};
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return quarter - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingDayPeriodValues,
	    defaultFormattingWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1046 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(14));
	
	var _index2 = _interopRequireDefault(__webpack_require__(15));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(\d+)/;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^(ق|ب)/g,
	  abbreviated: /^(ق.م|ب.م)/g,
	  wide: /^(قبل الميلاد|بعد الميلاد)/g
	};
	var parseEraPatterns = {
	  any: [/^ق/g, /^ب/g]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/,
	  abbreviated: /^ر[1234]/,
	  wide: /^الربع (الأول|الثاني|الثالث|الرابع)/
	};
	var parseQuarterPatterns = {
	  wide: [/الربع الأول/, /الربع الثاني/, /الربع الثالث/, /الربع الرابع/],
	  any: [/1/, /2/, /3/, /4/]
	};
	var matchMonthPatterns = {
	  narrow: /^(ي|ف|م|أ|س|ن|د)/,
	  abbreviated: /^(ينا|فبر|مارس|أبريل|مايو|يونـ|يولـ|أغسـ|سبتـ|أكتـ|نوفـ|ديسـ)/,
	  wide: /^(يناير|فبراير|مارس|أبريل|مايو|يونيو|يوليو|أغسطس|سبتمبر|أكتوبر|نوفمبر|ديسمبر)/
	};
	var parseMonthPatterns = {
	  narrow: [/^ي/, /^ف/, /^م/, /^أ/, /^م/, /^ي/, /^ي/, /^أ/, /^س/, /^أ/, /^ن/, /^د/],
	  any: [/^ينا/, /^فبر/, /^مارس/, /^أبريل/, /^مايو/, /^يون/, /^يول/, /^أغس/, /^سبت/, /^أكت/, /^نوف/, /^ديس/]
	};
	var matchDayPatterns = {
	  narrow: /^(ح|ن|ث|ر|خ|ج|س)/,
	  short: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/,
	  abbreviated: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/,
	  wide: /^(الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت)/
	};
	var parseDayPatterns = {
	  narrow: [/^ح/, /^ن/, /^ث/, /^ر/, /^خ/, /^ج/, /^س/],
	  any: [/أحد/, /اثنين/, /ثلاثاء/, /أربعاء/, /خميس/, /جمعة/, /سبت/]
	};
	var matchDayPeriodPatterns = {
	  narrow: /^(ص|م|ن|ظ|في الصباح|بعد الظهر|في المساء|في الليل)/,
	  abbreviated: /^(ص|م|نصف الليل|ظهراً|في الصباح|بعد الظهر|في المساء|في الليل)/,
	  wide: /^(ص|م|نصف الليل|في الصباح|ظهراً|بعد الظهر|في المساء|في الليل)/,
	  any: /^(ص|م|صباح|ظهر|مساء|ليل)/
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^ص/,
	    pm: /^م/,
	    midnight: /^ن/,
	    noon: /^ظ/,
	    morning: /^ص/,
	    afternoon: /^بعد/,
	    evening: /^م/,
	    night: /^ل/
	  }
	};
	var match = {
	  ordinalNumber: (0, _index2.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1047 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1042));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1043));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1044));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1045));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1046));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Arabic locale (Egypt).
	 * @language Arabic
	 * @iso-639-2 ara
	 * @author AbdAllah AbdElFattah [@AbdAllahAbdElFattah13]{@link https://github.com/AbdAllahAbdElFattah13}
	 */
	var locale = {
	  code: 'ar-EG',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 0
	    /* Sunday */
	    ,
	    firstWeekContainsDate: 1
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1048 */
1036,
/* 1049 */
1037,
/* 1050 */
1038,
/* 1051 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eraValues = {
	  narrow: ['ق', 'ب'],
	  abbreviated: ['ق.م.', 'ب.م.'],
	  wide: ['قبل الميلاد', 'بعد الميلاد']
	};
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['ر1', 'ر2', 'ر3', 'ر4'],
	  wide: ['الربع الأول', 'الربع الثاني', 'الربع الثالث', 'الربع الرابع']
	};
	var monthValues = {
	  narrow: ['ي', 'ف', 'م', 'أ', 'م', 'ي', 'ي', 'غ', 'ش', 'أ', 'ن', 'د'],
	  abbreviated: ['ينا', 'فبر', 'مارس', 'أبريل', 'ماي', 'يونـ', 'يولـ', 'غشت', 'شتنـ', 'أكتـ', 'نونـ', 'دجنـ'],
	  wide: ['يناير', 'فبراير', 'مارس', 'أبريل', 'ماي', 'يونيو', 'يوليوز', 'غشت', 'شتنبر', 'أكتوبر', 'نونبر', 'دجنبر']
	};
	var dayValues = {
	  narrow: ['ح', 'ن', 'ث', 'ر', 'خ', 'ج', 'س'],
	  short: ['أحد', 'اثنين', 'ثلاثاء', 'أربعاء', 'خميس', 'جمعة', 'سبت'],
	  abbreviated: ['أحد', 'اثنـ', 'ثلا', 'أربـ', 'خميـ', 'جمعة', 'سبت'],
	  wide: ['الأحد', 'الإثنين', 'الثلاثاء', 'الأربعاء', 'الخميس', 'الجمعة', 'السبت']
	};
	var dayPeriodValues = {
	  narrow: {
	    am: 'ص',
	    pm: 'م',
	    midnight: 'ن',
	    noon: 'ظ',
	    morning: 'صباحاً',
	    afternoon: 'بعد الظهر',
	    evening: 'مساءاً',
	    night: 'ليلاً'
	  },
	  abbreviated: {
	    am: 'ص',
	    pm: 'م',
	    midnight: 'نصف الليل',
	    noon: 'ظهر',
	    morning: 'صباحاً',
	    afternoon: 'بعد الظهر',
	    evening: 'مساءاً',
	    night: 'ليلاً'
	  },
	  wide: {
	    am: 'ص',
	    pm: 'م',
	    midnight: 'نصف الليل',
	    noon: 'ظهر',
	    morning: 'صباحاً',
	    afternoon: 'بعد الظهر',
	    evening: 'مساءاً',
	    night: 'ليلاً'
	  }
	};
	var formattingDayPeriodValues = {
	  narrow: {
	    am: 'ص',
	    pm: 'م',
	    midnight: 'ن',
	    noon: 'ظ',
	    morning: 'في الصباح',
	    afternoon: 'بعد الظـهر',
	    evening: 'في المساء',
	    night: 'في الليل'
	  },
	  abbreviated: {
	    am: 'ص',
	    pm: 'م',
	    midnight: 'نصف الليل',
	    noon: 'ظهر',
	    morning: 'في الصباح',
	    afternoon: 'بعد الظهر',
	    evening: 'في المساء',
	    night: 'في الليل'
	  },
	  wide: {
	    am: 'ص',
	    pm: 'م',
	    midnight: 'نصف الليل',
	    noon: 'ظهر',
	    morning: 'صباحاً',
	    afternoon: 'بعد الظـهر',
	    evening: 'في المساء',
	    night: 'في الليل'
	  }
	};
	
	var ordinalNumber = function (dirtyNumber) {
	  return String(dirtyNumber);
	};
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingDayPeriodValues,
	    defaultFormattingWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1052 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(15));
	
	var _index2 = _interopRequireDefault(__webpack_require__(14));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^(ق|ب)/i,
	  abbreviated: /^(ق\.?\s?م\.?|ق\.?\s?م\.?\s?|a\.?\s?d\.?|c\.?\s?)/i,
	  wide: /^(قبل الميلاد|قبل الميلاد|بعد الميلاد|بعد الميلاد)/i
	};
	var parseEraPatterns = {
	  any: [/^قبل/i, /^بعد/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^ر[1234]/i,
	  wide: /^الربع [1234]/i
	};
	var parseQuarterPatterns = {
	  any: [/1/i, /2/i, /3/i, /4/i]
	};
	var matchMonthPatterns = {
	  narrow: /^[يفمأمسند]/i,
	  abbreviated: /^(ين|ف|مار|أب|ماي|يون|يول|غش|شت|أك|ن|د)/i,
	  wide: /^(ين|ف|مار|أب|ماي|يون|يول|غش|شت|أك|ن|د)/i
	};
	var parseMonthPatterns = {
	  narrow: [/^ي/i, /^ف/i, /^م/i, /^أ/i, /^م/i, /^ي/i, /^ي/i, /^غ/i, /^ش/i, /^أ/i, /^ن/i, /^د/i],
	  any: [/^ين/i, /^فب/i, /^مار/i, /^أب/i, /^ماي/i, /^يون/i, /^يول/i, /^غشت/i, /^ش/i, /^أك/i, /^ن/i, /^د/i]
	};
	var matchDayPatterns = {
	  narrow: /^[حنثرخجس]/i,
	  short: /^(أحد|إثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
	  abbreviated: /^(أحد|إثن|ثلا|أرب|خمي|جمعة|سبت)/i,
	  wide: /^(الأحد|الإثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت)/i
	};
	var parseDayPatterns = {
	  narrow: [/^ح/i, /^ن/i, /^ث/i, /^ر/i, /^خ/i, /^ج/i, /^س/i],
	  wide: [/^الأحد/i, /^الإثنين/i, /^الثلاثاء/i, /^الأربعاء/i, /^الخميس/i, /^الجمعة/i, /^السبت/i],
	  any: [/^أح/i, /^إث/i, /^ث/i, /^أر/i, /^خ/i, /^ج/i, /^س/i]
	};
	var matchDayPeriodPatterns = {
	  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
	  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^a/i,
	    pm: /^p/i,
	    midnight: /^mi/i,
	    noon: /^no/i,
	    morning: /morning/i,
	    afternoon: /afternoon/i,
	    evening: /evening/i,
	    night: /night/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index2.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index2.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return Number(index) + 1;
	    }
	  }),
	  month: (0, _index2.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index2.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index2.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1053 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1048));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1049));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1050));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1051));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1052));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Arabic locale (Moroccan Arabic).
	 * @language Moroccan Arabic
	 * @iso-639-2 ara
	 * @author Achraf Rrami [@rramiachraf]{@link https://github.com/rramiachraf}
	 */
	var locale = {
	  code: 'ar-MA',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    // Monday is 1
	    weekStartsOn: 1,
	    firstWeekContainsDate: 1
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1054 */
1036,
/* 1055 */
1037,
/* 1056 */
1038,
/* 1057 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eraValues = {
	  narrow: ['ق', 'ب'],
	  abbreviated: ['ق.م.', 'ب.م.'],
	  wide: ['قبل الميلاد', 'بعد الميلاد']
	};
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['ر1', 'ر2', 'ر3', 'ر4'],
	  wide: ['الربع الأول', 'الربع الثاني', 'الربع الثالث', 'الربع الرابع']
	};
	var monthValues = {
	  narrow: ['ي', 'ف', 'م', 'أ', 'م', 'ي', 'ي', 'أ', 'س', 'أ', 'ن', 'د'],
	  abbreviated: ['ينا', 'فبر', 'مارس', 'أبريل', 'مايو', 'يونـ', 'يولـ', 'أغسـ', 'سبتـ', 'أكتـ', 'نوفـ', 'ديسـ'],
	  wide: ['يناير', 'فبراير', 'مارس', 'أبريل', 'مايو', 'يونيو', 'يوليو', 'أغسطس', 'سبتمبر', 'أكتوبر', 'نوفمبر', 'ديسمبر']
	};
	var dayValues = {
	  narrow: ['ح', 'ن', 'ث', 'ر', 'خ', 'ج', 'س'],
	  short: ['أحد', 'اثنين', 'ثلاثاء', 'أربعاء', 'خميس', 'جمعة', 'سبت'],
	  abbreviated: ['أحد', 'اثنـ', 'ثلا', 'أربـ', 'خميـ', 'جمعة', 'سبت'],
	  wide: ['الأحد', 'الاثنين', 'الثلاثاء', 'الأربعاء', 'الخميس', 'الجمعة', 'السبت']
	};
	var dayPeriodValues = {
	  narrow: {
	    am: 'ص',
	    pm: 'م',
	    midnight: 'ن',
	    noon: 'ظ',
	    morning: 'صباحاً',
	    afternoon: 'بعد الظهر',
	    evening: 'مساءاً',
	    night: 'ليلاً'
	  },
	  abbreviated: {
	    am: 'ص',
	    pm: 'م',
	    midnight: 'نصف الليل',
	    noon: 'ظهر',
	    morning: 'صباحاً',
	    afternoon: 'بعد الظهر',
	    evening: 'مساءاً',
	    night: 'ليلاً'
	  },
	  wide: {
	    am: 'ص',
	    pm: 'م',
	    midnight: 'نصف الليل',
	    noon: 'ظهر',
	    morning: 'صباحاً',
	    afternoon: 'بعد الظهر',
	    evening: 'مساءاً',
	    night: 'ليلاً'
	  }
	};
	var formattingDayPeriodValues = {
	  narrow: {
	    am: 'ص',
	    pm: 'م',
	    midnight: 'ن',
	    noon: 'ظ',
	    morning: 'في الصباح',
	    afternoon: 'بعد الظـهر',
	    evening: 'في المساء',
	    night: 'في الليل'
	  },
	  abbreviated: {
	    am: 'ص',
	    pm: 'م',
	    midnight: 'نصف الليل',
	    noon: 'ظهر',
	    morning: 'في الصباح',
	    afternoon: 'بعد الظهر',
	    evening: 'في المساء',
	    night: 'في الليل'
	  },
	  wide: {
	    am: 'ص',
	    pm: 'م',
	    midnight: 'نصف الليل',
	    noon: 'ظهر',
	    morning: 'صباحاً',
	    afternoon: 'بعد الظـهر',
	    evening: 'في المساء',
	    night: 'في الليل'
	  }
	};
	
	var ordinalNumber = function (dirtyNumber) {
	  return String(dirtyNumber);
	};
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingDayPeriodValues,
	    defaultFormattingWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1058 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(15));
	
	var _index2 = _interopRequireDefault(__webpack_require__(14));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^(ق|ب)/i,
	  abbreviated: /^(ق\.?\s?م\.?|ق\.?\s?م\.?\s?|a\.?\s?d\.?|c\.?\s?)/i,
	  wide: /^(قبل الميلاد|قبل الميلاد|بعد الميلاد|بعد الميلاد)/i
	};
	var parseEraPatterns = {
	  any: [/^قبل/i, /^بعد/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^ر[1234]/i,
	  wide: /^الربع [1234]/i
	};
	var parseQuarterPatterns = {
	  any: [/1/i, /2/i, /3/i, /4/i]
	};
	var matchMonthPatterns = {
	  narrow: /^[يفمأمسند]/i,
	  abbreviated: /^(ين|ف|مار|أب|ماي|يون|يول|أغ|س|أك|ن|د)/i,
	  wide: /^(ين|ف|مار|أب|ماي|يون|يول|أغ|س|أك|ن|د)/i
	};
	var parseMonthPatterns = {
	  narrow: [/^ي/i, /^ف/i, /^م/i, /^أ/i, /^م/i, /^ي/i, /^ي/i, /^أ/i, /^س/i, /^أ/i, /^ن/i, /^د/i],
	  any: [/^ين/i, /^ف/i, /^مار/i, /^أب/i, /^ماي/i, /^يون/i, /^يول/i, /^أغ/i, /^س/i, /^أك/i, /^ن/i, /^د/i]
	};
	var matchDayPatterns = {
	  narrow: /^[حنثرخجس]/i,
	  short: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
	  abbreviated: /^(أحد|اثن|ثلا|أرب|خمي|جمعة|سبت)/i,
	  wide: /^(الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت)/i
	};
	var parseDayPatterns = {
	  narrow: [/^ح/i, /^ن/i, /^ث/i, /^ر/i, /^خ/i, /^ج/i, /^س/i],
	  wide: [/^الأحد/i, /^الاثنين/i, /^الثلاثاء/i, /^الأربعاء/i, /^الخميس/i, /^الجمعة/i, /^السبت/i],
	  any: [/^أح/i, /^اث/i, /^ث/i, /^أر/i, /^خ/i, /^ج/i, /^س/i]
	};
	var matchDayPeriodPatterns = {
	  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
	  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^a/i,
	    pm: /^p/i,
	    midnight: /^mi/i,
	    noon: /^no/i,
	    morning: /morning/i,
	    afternoon: /afternoon/i,
	    evening: /evening/i,
	    night: /night/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index2.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index2.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index2.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index2.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index2.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1059 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1054));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1055));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1056));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1057));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1058));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Arabic locale (Sauid Arabic).
	 * @language Arabic
	 * @iso-639-2 ara
	 * @author Dhaifallah Alwadani [@dalwadani]{@link https://github.com/dalwadani}
	 */
	var locale = {
	  code: 'ar-SA',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 0
	    /* Sunday */
	    ,
	    firstWeekContainsDate: 1
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1060 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    one: 'أقل من ثانية',
	    two: 'أقل من زوز ثواني',
	    threeToTen: 'أقل من {{count}} ثواني',
	    other: 'أقل من {{count}} ثانية'
	  },
	  xSeconds: {
	    one: 'ثانية',
	    two: 'زوز ثواني',
	    threeToTen: '{{count}} ثواني',
	    other: '{{count}} ثانية'
	  },
	  halfAMinute: 'نص دقيقة',
	  lessThanXMinutes: {
	    one: 'أقل من دقيقة',
	    two: 'أقل من دقيقتين',
	    threeToTen: 'أقل من {{count}} دقايق',
	    other: 'أقل من {{count}} دقيقة'
	  },
	  xMinutes: {
	    one: 'دقيقة',
	    two: 'دقيقتين',
	    threeToTen: '{{count}} دقايق',
	    other: '{{count}} دقيقة'
	  },
	  aboutXHours: {
	    one: 'ساعة تقريب',
	    two: 'ساعتين تقريب',
	    threeToTen: '{{count}} سوايع تقريب',
	    other: '{{count}} ساعة تقريب'
	  },
	  xHours: {
	    one: 'ساعة',
	    two: 'ساعتين',
	    threeToTen: '{{count}} سوايع',
	    other: '{{count}} ساعة'
	  },
	  xDays: {
	    one: 'نهار',
	    two: 'نهارين',
	    threeToTen: '{{count}} أيام',
	    other: '{{count}} يوم'
	  },
	  aboutXWeeks: {
	    one: 'جمعة تقريب',
	    two: 'جمعتين تقريب',
	    threeToTen: '{{count}} جماع تقريب',
	    other: '{{count}} جمعة تقريب'
	  },
	  xWeeks: {
	    one: 'جمعة',
	    two: 'جمعتين',
	    threeToTen: '{{count}} جماع',
	    other: '{{count}} جمعة'
	  },
	  aboutXMonths: {
	    one: 'شهر تقريب',
	    two: 'شهرين تقريب',
	    threeToTen: '{{count}} أشهرة تقريب',
	    other: '{{count}} شهر تقريب'
	  },
	  xMonths: {
	    one: 'شهر',
	    two: 'شهرين',
	    threeToTen: '{{count}} أشهرة',
	    other: '{{count}} شهر'
	  },
	  aboutXYears: {
	    one: 'عام تقريب',
	    two: 'عامين تقريب',
	    threeToTen: '{{count}} أعوام تقريب',
	    other: '{{count}} عام تقريب'
	  },
	  xYears: {
	    one: 'عام',
	    two: 'عامين',
	    threeToTen: '{{count}} أعوام',
	    other: '{{count}} عام'
	  },
	  overXYears: {
	    one: 'أكثر من عام',
	    two: 'أكثر من عامين',
	    threeToTen: 'أكثر من {{count}} أعوام',
	    other: 'أكثر من {{count}} عام'
	  },
	  almostXYears: {
	    one: 'عام تقريب',
	    two: 'عامين تقريب',
	    threeToTen: '{{count}} أعوام تقريب',
	    other: '{{count}} عام تقريب'
	  }
	};
	
	var formatDistance = function (token, count, options) {
	  var usageGroup = formatDistanceLocale[token];
	  var result;
	
	  if (typeof usageGroup === 'string') {
	    result = usageGroup;
	  } else if (count === 1) {
	    result = usageGroup.one;
	  } else if (count === 2) {
	    result = usageGroup.two;
	  } else if (count <= 10) {
	    result = usageGroup.threeToTen.replace('{{count}}', String(count));
	  } else {
	    result = usageGroup.other.replace('{{count}}', String(count));
	  }
	
	  if (options !== null && options !== void 0 && options.addSuffix) {
	    if (options.comparison && options.comparison > 0) {
	      return 'في ' + result;
	    } else {
	      return 'عندو ' + result;
	    }
	  }
	
	  return result;
	};
	
	var _default = formatDistance;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1061 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: 'EEEE، do MMMM y',
	  long: 'do MMMM y',
	  medium: 'd MMM y',
	  short: 'dd/MM/yyyy'
	};
	var timeFormats = {
	  full: 'HH:mm:ss',
	  long: 'HH:mm:ss',
	  medium: 'HH:mm:ss',
	  short: 'HH:mm'
	};
	var dateTimeFormats = {
	  full: "{{date}} 'مع' {{time}}",
	  long: "{{date}} 'مع' {{time}}",
	  medium: '{{date}}, {{time}}',
	  short: '{{date}}, {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1062 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var formatRelativeLocale = {
	  lastWeek: "eeee 'إلي فات مع' p",
	  yesterday: "'البارح مع' p",
	  today: "'اليوم مع' p",
	  tomorrow: "'غدوة مع' p",
	  nextWeek: "eeee 'الجمعة الجاية مع' p 'نهار'",
	  other: 'P'
	};
	
	var formatRelative = function (token) {
	  return formatRelativeLocale[token];
	};
	
	var _default = formatRelative;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1063 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eraValues = {
	  narrow: ['ق', 'ب'],
	  abbreviated: ['ق.م.', 'ب.م.'],
	  wide: ['قبل الميلاد', 'بعد الميلاد']
	};
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['ر1', 'ر2', 'ر3', 'ر4'],
	  wide: ['الربع الأول', 'الربع الثاني', 'الربع الثالث', 'الربع الرابع']
	};
	var monthValues = {
	  narrow: ['د', 'ن', 'أ', 'س', 'أ', 'ج', 'ج', 'م', 'أ', 'م', 'ف', 'ج'],
	  abbreviated: ['جانفي', 'فيفري', 'مارس', 'أفريل', 'ماي', 'جوان', 'جويلية', 'أوت', 'سبتمبر', 'أكتوبر', 'نوفمبر', 'ديسمبر'],
	  wide: ['جانفي', 'فيفري', 'مارس', 'أفريل', 'ماي', 'جوان', 'جويلية', 'أوت', 'سبتمبر', 'أكتوبر', 'نوفمبر', 'ديسمبر']
	};
	var dayValues = {
	  narrow: ['ح', 'ن', 'ث', 'ر', 'خ', 'ج', 'س'],
	  short: ['أحد', 'اثنين', 'ثلاثاء', 'أربعاء', 'خميس', 'جمعة', 'سبت'],
	  abbreviated: ['أحد', 'اثنين', 'ثلاثاء', 'أربعاء', 'خميس', 'جمعة', 'سبت'],
	  wide: ['الأحد', 'الاثنين', 'الثلاثاء', 'الأربعاء', 'الخميس', 'الجمعة', 'السبت']
	};
	var dayPeriodValues = {
	  narrow: {
	    am: 'ص',
	    pm: 'ع',
	    morning: 'الصباح',
	    noon: 'القايلة',
	    afternoon: 'بعد القايلة',
	    evening: 'العشية',
	    night: 'الليل',
	    midnight: 'نص الليل'
	  },
	  abbreviated: {
	    am: 'ص',
	    pm: 'ع',
	    morning: 'الصباح',
	    noon: 'القايلة',
	    afternoon: 'بعد القايلة',
	    evening: 'العشية',
	    night: 'الليل',
	    midnight: 'نص الليل'
	  },
	  wide: {
	    am: 'ص',
	    pm: 'ع',
	    morning: 'الصباح',
	    noon: 'القايلة',
	    afternoon: 'بعد القايلة',
	    evening: 'العشية',
	    night: 'الليل',
	    midnight: 'نص الليل'
	  }
	};
	var formattingDayPeriodValues = {
	  narrow: {
	    am: 'ص',
	    pm: 'ع',
	    morning: 'في الصباح',
	    noon: 'في القايلة',
	    afternoon: 'بعد القايلة',
	    evening: 'في العشية',
	    night: 'في الليل',
	    midnight: 'نص الليل'
	  },
	  abbreviated: {
	    am: 'ص',
	    pm: 'ع',
	    morning: 'في الصباح',
	    noon: 'في القايلة',
	    afternoon: 'بعد القايلة',
	    evening: 'في العشية',
	    night: 'في الليل',
	    midnight: 'نص الليل'
	  },
	  wide: {
	    am: 'ص',
	    pm: 'ع',
	    morning: 'في الصباح',
	    noon: 'في القايلة',
	    afternoon: 'بعد القايلة',
	    evening: 'في العشية',
	    night: 'في الليل',
	    midnight: 'نص الليل'
	  }
	};
	
	var ordinalNumber = function (num) {
	  return String(num);
	};
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return quarter - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingDayPeriodValues,
	    defaultFormattingWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1064 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(15));
	
	var _index2 = _interopRequireDefault(__webpack_require__(14));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /[قب]/,
	  abbreviated: /[قب]\.م\./,
	  wide: /(قبل|بعد) الميلاد/
	};
	var parseEraPatterns = {
	  any: [/قبل/, /بعد/]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /ر[1234]/,
	  wide: /الربع (الأول|الثاني|الثالث|الرابع)/
	};
	var parseQuarterPatterns = {
	  any: [/1/i, /2/i, /3/i, /4/i]
	};
	var matchMonthPatterns = {
	  narrow: /^[جفمأسند]/,
	  abbreviated: /^(جانفي|فيفري|مارس|أفريل|ماي|جوان|جويلية|أوت|سبتمبر|أكتوبر|نوفمبر|ديسمبر)/,
	  wide: /^(جانفي|فيفري|مارس|أفريل|ماي|جوان|جويلية|أوت|سبتمبر|أكتوبر|نوفمبر|ديسمبر)/
	};
	var parseMonthPatterns = {
	  narrow: [/^ج/i, /^ف/i, /^م/i, /^أ/i, /^م/i, /^ج/i, /^ج/i, /^أ/i, /^س/i, /^أ/i, /^ن/i, /^د/i],
	  any: [/^جانفي/i, /^فيفري/i, /^مارس/i, /^أفريل/i, /^ماي/i, /^جوان/i, /^جويلية/i, /^أوت/i, /^سبتمبر/i, /^أكتوبر/i, /^نوفمبر/i, /^ديسمبر/i]
	};
	var matchDayPatterns = {
	  narrow: /^[حنثرخجس]/i,
	  short: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
	  abbreviated: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
	  wide: /^(الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت)/i
	};
	var parseDayPatterns = {
	  narrow: [/^ح/i, /^ن/i, /^ث/i, /^ر/i, /^خ/i, /^ج/i, /^س/i],
	  wide: [/^الأحد/i, /^الاثنين/i, /^الثلاثاء/i, /^الأربعاء/i, /^الخميس/i, /^الجمعة/i, /^السبت/i],
	  any: [/^أح/i, /^اث/i, /^ث/i, /^أر/i, /^خ/i, /^ج/i, /^س/i]
	};
	var matchDayPeriodPatterns = {
	  narrow: /^(ص|ع|ن ل|ل|(في|مع) (صباح|قايلة|عشية|ليل))/,
	  any: /^([صع]|نص الليل|قايلة|(في|مع) (صباح|قايلة|عشية|ليل))/
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^ص/,
	    pm: /^ع/,
	    midnight: /نص الليل/,
	    noon: /قايلة/,
	    afternoon: /بعد القايلة/,
	    morning: /صباح/,
	    evening: /عشية/,
	    night: /ليل/
	  }
	};
	var match = {
	  ordinalNumber: (0, _index.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index2.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index2.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index2.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index2.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index2.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1065 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1060));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1061));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1062));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1063));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1064));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Arabic locale (Tunisian Arabic).
	 * @language Arabic
	 * @iso-639-2 ara
	 * @author Koussay Haj Kacem [@essana3]{@link https://github.com/essana3}
	 */
	var locale = {
	  code: 'ar-TN',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 1
	    /* Monday */
	    ,
	    firstWeekContainsDate: 1
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1066 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    one: 'أقل من ثانية',
	    two: 'أقل من ثانيتين',
	    threeToTen: 'أقل من {{count}} ثواني',
	    other: 'أقل من {{count}} ثانية'
	  },
	  xSeconds: {
	    one: 'ثانية واحدة',
	    two: 'ثانيتان',
	    threeToTen: '{{count}} ثواني',
	    other: '{{count}} ثانية'
	  },
	  halfAMinute: 'نصف دقيقة',
	  lessThanXMinutes: {
	    one: 'أقل من دقيقة',
	    two: 'أقل من دقيقتين',
	    threeToTen: 'أقل من {{count}} دقائق',
	    other: 'أقل من {{count}} دقيقة'
	  },
	  xMinutes: {
	    one: 'دقيقة واحدة',
	    two: 'دقيقتان',
	    threeToTen: '{{count}} دقائق',
	    other: '{{count}} دقيقة'
	  },
	  aboutXHours: {
	    one: 'ساعة واحدة تقريباً',
	    two: 'ساعتين تقريبا',
	    threeToTen: '{{count}} ساعات تقريباً',
	    other: '{{count}} ساعة تقريباً'
	  },
	  xHours: {
	    one: 'ساعة واحدة',
	    two: 'ساعتان',
	    threeToTen: '{{count}} ساعات',
	    other: '{{count}} ساعة'
	  },
	  xDays: {
	    one: 'يوم واحد',
	    two: 'يومان',
	    threeToTen: '{{count}} أيام',
	    other: '{{count}} يوم'
	  },
	  aboutXWeeks: {
	    one: 'أسبوع واحد تقريبا',
	    two: 'أسبوعين تقريبا',
	    threeToTen: '{{count}} أسابيع تقريبا',
	    other: '{{count}} أسبوعا تقريبا'
	  },
	  xWeeks: {
	    one: 'أسبوع واحد',
	    two: 'أسبوعان',
	    threeToTen: '{{count}} أسابيع',
	    other: '{{count}} أسبوعا'
	  },
	  aboutXMonths: {
	    one: 'شهر واحد تقريباً',
	    two: 'شهرين تقريبا',
	    threeToTen: '{{count}} أشهر تقريبا',
	    other: '{{count}} شهرا تقريباً'
	  },
	  xMonths: {
	    one: 'شهر واحد',
	    two: 'شهران',
	    threeToTen: '{{count}} أشهر',
	    other: '{{count}} شهرا'
	  },
	  aboutXYears: {
	    one: 'سنة واحدة تقريباً',
	    two: 'سنتين تقريبا',
	    threeToTen: '{{count}} سنوات تقريباً',
	    other: '{{count}} سنة تقريباً'
	  },
	  xYears: {
	    one: 'سنة واحد',
	    two: 'سنتان',
	    threeToTen: '{{count}} سنوات',
	    other: '{{count}} سنة'
	  },
	  overXYears: {
	    one: 'أكثر من سنة',
	    two: 'أكثر من سنتين',
	    threeToTen: 'أكثر من {{count}} سنوات',
	    other: 'أكثر من {{count}} سنة'
	  },
	  almostXYears: {
	    one: 'ما يقارب سنة واحدة',
	    two: 'ما يقارب سنتين',
	    threeToTen: 'ما يقارب {{count}} سنوات',
	    other: 'ما يقارب {{count}} سنة'
	  }
	};
	
	var formatDistance = function (token, count, options) {
	  var usageGroup = formatDistanceLocale[token];
	  var result;
	
	  if (typeof usageGroup === 'string') {
	    result = usageGroup;
	  } else if (count === 1) {
	    result = usageGroup.one;
	  } else if (count === 2) {
	    result = usageGroup.two;
	  } else if (count <= 10) {
	    result = usageGroup.threeToTen.replace('{{count}}', String(count));
	  } else {
	    result = usageGroup.other.replace('{{count}}', String(count));
	  }
	
	  if (options !== null && options !== void 0 && options.addSuffix) {
	    if (options.comparison && options.comparison > 0) {
	      return 'خلال ' + result;
	    } else {
	      return 'منذ ' + result;
	    }
	  }
	
	  return result;
	};
	
	var _default = formatDistance;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1067 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: 'EEEE، do MMMM y',
	  long: 'do MMMM y',
	  medium: 'd MMM y',
	  short: 'dd/MM/yyyy'
	};
	var timeFormats = {
	  full: 'HH:mm:ss',
	  long: 'HH:mm:ss',
	  medium: 'HH:mm:ss',
	  short: 'HH:mm'
	};
	var dateTimeFormats = {
	  full: "{{date}} 'عند الساعة' {{time}}",
	  long: "{{date}} 'عند الساعة' {{time}}",
	  medium: '{{date}}, {{time}}',
	  short: '{{date}}, {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1068 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var formatRelativeLocale = {
	  lastWeek: "eeee 'الماضي عند الساعة' p",
	  yesterday: "'الأمس عند الساعة' p",
	  today: "'اليوم عند الساعة' p",
	  tomorrow: "'غدا عند الساعة' p",
	  nextWeek: "eeee 'القادم عند الساعة' p",
	  other: 'P'
	};
	
	var formatRelative = function (token) {
	  return formatRelativeLocale[token];
	};
	
	var _default = formatRelative;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1069 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eraValues = {
	  narrow: ['ق', 'ب'],
	  abbreviated: ['ق.م.', 'ب.م.'],
	  wide: ['قبل الميلاد', 'بعد الميلاد']
	};
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['ر1', 'ر2', 'ر3', 'ر4'],
	  wide: ['الربع الأول', 'الربع الثاني', 'الربع الثالث', 'الربع الرابع']
	};
	var monthValues = {
	  narrow: ['ي', 'ف', 'م', 'أ', 'م', 'ي', 'ي', 'أ', 'س', 'أ', 'ن', 'د'],
	  abbreviated: ['يناير', 'فبراير', 'مارس', 'أبريل', 'مايو', 'يونيو', 'يوليو', 'أغسطس', 'سبتمبر', 'أكتوبر', 'نوفمبر', 'ديسمبر'],
	  wide: ['يناير', 'فبراير', 'مارس', 'أبريل', 'مايو', 'يونيو', 'يوليو', 'أغسطس', 'سبتمبر', 'أكتوبر', 'نوفمبر', 'ديسمبر']
	};
	var dayValues = {
	  narrow: ['ح', 'ن', 'ث', 'ر', 'خ', 'ج', 'س'],
	  short: ['أحد', 'اثنين', 'ثلاثاء', 'أربعاء', 'خميس', 'جمعة', 'سبت'],
	  abbreviated: ['أحد', 'اثنين', 'ثلاثاء', 'أربعاء', 'خميس', 'جمعة', 'سبت'],
	  wide: ['الأحد', 'الاثنين', 'الثلاثاء', 'الأربعاء', 'الخميس', 'الجمعة', 'السبت']
	};
	var dayPeriodValues = {
	  narrow: {
	    am: 'ص',
	    pm: 'م',
	    morning: 'الصباح',
	    noon: 'الظهر',
	    afternoon: 'بعد الظهر',
	    evening: 'المساء',
	    night: 'الليل',
	    midnight: 'منتصف الليل'
	  },
	  abbreviated: {
	    am: 'ص',
	    pm: 'م',
	    morning: 'الصباح',
	    noon: 'الظهر',
	    afternoon: 'بعد الظهر',
	    evening: 'المساء',
	    night: 'الليل',
	    midnight: 'منتصف الليل'
	  },
	  wide: {
	    am: 'ص',
	    pm: 'م',
	    morning: 'الصباح',
	    noon: 'الظهر',
	    afternoon: 'بعد الظهر',
	    evening: 'المساء',
	    night: 'الليل',
	    midnight: 'منتصف الليل'
	  }
	};
	var formattingDayPeriodValues = {
	  narrow: {
	    am: 'ص',
	    pm: 'م',
	    morning: 'في الصباح',
	    noon: 'الظهر',
	    afternoon: 'بعد الظهر',
	    evening: 'في المساء',
	    night: 'في الليل',
	    midnight: 'منتصف الليل'
	  },
	  abbreviated: {
	    am: 'ص',
	    pm: 'م',
	    morning: 'في الصباح',
	    noon: 'الظهر',
	    afternoon: 'بعد الظهر',
	    evening: 'في المساء',
	    night: 'في الليل',
	    midnight: 'منتصف الليل'
	  },
	  wide: {
	    am: 'ص',
	    pm: 'م',
	    morning: 'في الصباح',
	    noon: 'الظهر',
	    afternoon: 'بعد الظهر',
	    evening: 'في المساء',
	    night: 'في الليل',
	    midnight: 'منتصف الليل'
	  }
	};
	
	var ordinalNumber = function (num) {
	  return String(num);
	};
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return quarter - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingDayPeriodValues,
	    defaultFormattingWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1070 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(15));
	
	var _index2 = _interopRequireDefault(__webpack_require__(14));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /[قب]/,
	  abbreviated: /[قب]\.م\./,
	  wide: /(قبل|بعد) الميلاد/
	};
	var parseEraPatterns = {
	  any: [/قبل/, /بعد/]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /ر[1234]/,
	  wide: /الربع (الأول|الثاني|الثالث|الرابع)/
	};
	var parseQuarterPatterns = {
	  any: [/1/i, /2/i, /3/i, /4/i]
	};
	var matchMonthPatterns = {
	  narrow: /^[أيفمسند]/,
	  abbreviated: /^(يناير|فبراير|مارس|أبريل|مايو|يونيو|يوليو|أغسطس|سبتمبر|أكتوبر|نوفمبر|ديسمبر)/,
	  wide: /^(يناير|فبراير|مارس|أبريل|مايو|يونيو|يوليو|أغسطس|سبتمبر|أكتوبر|نوفمبر|ديسمبر)/
	};
	var parseMonthPatterns = {
	  narrow: [/^ي/i, /^ف/i, /^م/i, /^أ/i, /^م/i, /^ي/i, /^ي/i, /^أ/i, /^س/i, /^أ/i, /^ن/i, /^د/i],
	  any: [/^يناير/i, /^فبراير/i, /^مارس/i, /^أبريل/i, /^مايو/i, /^يونيو/i, /^يوليو/i, /^أغسطس/i, /^سبتمبر/i, /^أكتوبر/i, /^نوفمبر/i, /^ديسمبر/i]
	};
	var matchDayPatterns = {
	  narrow: /^[حنثرخجس]/i,
	  short: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
	  abbreviated: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
	  wide: /^(الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت)/i
	};
	var parseDayPatterns = {
	  narrow: [/^ح/i, /^ن/i, /^ث/i, /^ر/i, /^خ/i, /^ج/i, /^س/i],
	  wide: [/^الأحد/i, /^الاثنين/i, /^الثلاثاء/i, /^الأربعاء/i, /^الخميس/i, /^الجمعة/i, /^السبت/i],
	  any: [/^أح/i, /^اث/i, /^ث/i, /^أر/i, /^خ/i, /^ج/i, /^س/i]
	};
	var matchDayPeriodPatterns = {
	  narrow: /^(ص|م|منتصف الليل|الظهر|بعد الظهر|في الصباح|في المساء|في الليل)/,
	  any: /^(ص|م|منتصف الليل|الظهر|بعد الظهر|في الصباح|في المساء|في الليل)/
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^ص/,
	    pm: /^م/,
	    midnight: /منتصف الليل/,
	    noon: /الظهر/,
	    afternoon: /بعد الظهر/,
	    morning: /في الصباح/,
	    evening: /في المساء/,
	    night: /في الليل/
	  }
	};
	var match = {
	  ordinalNumber: (0, _index.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index2.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index2.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index2.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index2.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index2.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1071 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1066));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1067));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1068));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1069));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1070));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Arabic locale (Modern Standard Arabic - Al-fussha).
	 * @language Modern Standard Arabic
	 * @iso-639-2 ara
	 * @author Abdallah Hassan [@AbdallahAHO]{@link https://github.com/AbdallahAHO}
	 * @author Koussay Haj Kacem [@essana3]{@link https://github.com/essana3}
	 */
	var locale = {
	  code: 'ar',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 6
	    /* Saturday */
	    ,
	    firstWeekContainsDate: 1
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1072 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    one: 'bir saniyədən az',
	    other: '{{count}} bir saniyədən az'
	  },
	  xSeconds: {
	    one: '1 saniyə',
	    other: '{{count}} saniyə'
	  },
	  halfAMinute: 'yarım dəqiqə',
	  lessThanXMinutes: {
	    one: 'bir dəqiqədən az',
	    other: '{{count}} bir dəqiqədən az'
	  },
	  xMinutes: {
	    one: 'bir dəqiqə',
	    other: '{{count}} dəqiqə'
	  },
	  aboutXHours: {
	    one: 'təxminən 1 saat',
	    other: 'təxminən {{count}} saat'
	  },
	  xHours: {
	    one: '1 saat',
	    other: '{{count}} saat'
	  },
	  xDays: {
	    one: '1 gün',
	    other: '{{count}} gün'
	  },
	  aboutXWeeks: {
	    one: 'təxminən 1 həftə',
	    other: 'təxminən {{count}} həftə'
	  },
	  xWeeks: {
	    one: '1 həftə',
	    other: '{{count}} həftə'
	  },
	  aboutXMonths: {
	    one: 'təxminən 1 ay',
	    other: 'təxminən {{count}} ay'
	  },
	  xMonths: {
	    one: '1 ay',
	    other: '{{count}} ay'
	  },
	  aboutXYears: {
	    one: 'təxminən 1 il',
	    other: 'təxminən {{count}} il'
	  },
	  xYears: {
	    one: '1 il',
	    other: '{{count}} il'
	  },
	  overXYears: {
	    one: '1 ildən çox',
	    other: '{{count}} ildən çox'
	  },
	  almostXYears: {
	    one: 'demək olar ki 1 il',
	    other: 'demək olar ki {{count}} il'
	  }
	};
	
	var formatDistance = function (token, count, options) {
	  options = options || {};
	  var usageGroup = formatDistanceLocale[token];
	  var result;
	
	  if (typeof usageGroup === 'string') {
	    result = usageGroup;
	  } else if (count === 1) {
	    result = usageGroup.one;
	  } else {
	    result = usageGroup.other.replace('{{count}}', String(count));
	  }
	
	  if (options.addSuffix) {
	    if (options.comparison && options.comparison > 0) {
	      return result + ' əvvəl';
	    } else {
	      return result + ' sonra';
	    }
	  }
	
	  return result;
	};
	
	var _default = formatDistance;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1073 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: "EEEE, do MMMM y 'il'",
	  long: "do MMMM y 'il'",
	  medium: "d MMM y 'il'",
	  short: 'dd.MM.yyyy'
	};
	var timeFormats = {
	  full: 'H:mm:ss zzzz',
	  long: 'H:mm:ss z',
	  medium: 'H:mm:ss',
	  short: 'H:mm'
	};
	var dateTimeFormats = {
	  full: "{{date}} {{time}} - 'də'",
	  long: "{{date}} {{time}} - 'də'",
	  medium: '{{date}}, {{time}}',
	  short: '{{date}}, {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1074 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var formatRelativeLocale = {
	  lastWeek: "'sonuncu' eeee p -'də'",
	  yesterday: "'dünən' p -'də'",
	  today: "'bugün' p -'də'",
	  tomorrow: "'sabah' p -'də'",
	  nextWeek: "eeee p -'də'",
	  other: 'P'
	};
	
	var formatRelative = function (token, _date, _baseDate, _options) {
	  return formatRelativeLocale[token];
	};
	
	var _default = formatRelative;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1075 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eraValues = {
	  narrow: ['e.ə', 'b.e'],
	  abbreviated: ['e.ə', 'b.e'],
	  wide: ['eramızdan əvvəl', 'bizim era']
	};
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['K1', 'K2', 'K3', 'K4'],
	  wide: ['1ci kvartal', '2ci kvartal', '3cü kvartal', '4cü kvartal']
	};
	var monthValues = {
	  narrow: ['Y', 'F', 'M', 'A', 'M', 'İ', 'İ', 'A', 'S', 'O', 'N', 'D'],
	  abbreviated: ['Yan', 'Fev', 'Mar', 'Apr', 'May', 'İyun', 'İyul', 'Avq', 'Sen', 'Okt', 'Noy', 'Dek'],
	  wide: ['Yanvar', 'Fevral', 'Mart', 'Aprel', 'May', 'İyun', 'İyul', 'Avqust', 'Sentyabr', 'Oktyabr', 'Noyabr', 'Dekabr']
	};
	var dayValues = {
	  narrow: ['B.', 'B.e', 'Ç.a', 'Ç.', 'C.a', 'C.', 'Ş.'],
	  short: ['B.', 'B.e', 'Ç.a', 'Ç.', 'C.a', 'C.', 'Ş.'],
	  abbreviated: ['Baz', 'Baz.e', 'Çər.a', 'Çər', 'Cüm.a', 'Cüm', 'Şə'],
	  wide: ['Bazar', 'Bazar ertəsi', 'Çərşənbə axşamı', 'Çərşənbə', 'Cümə axşamı', 'Cümə', 'Şənbə']
	};
	var dayPeriodValues = {
	  narrow: {
	    am: 'am',
	    pm: 'pm',
	    midnight: 'gecəyarı',
	    noon: 'gün',
	    morning: 'səhər',
	    afternoon: 'gündüz',
	    evening: 'axşam',
	    night: 'gecə'
	  },
	  abbreviated: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'gecəyarı',
	    noon: 'gün',
	    morning: 'səhər',
	    afternoon: 'gündüz',
	    evening: 'axşam',
	    night: 'gecə'
	  },
	  wide: {
	    am: 'a.m.',
	    pm: 'p.m.',
	    midnight: 'gecəyarı',
	    noon: 'gün',
	    morning: 'səhər',
	    afternoon: 'gündüz',
	    evening: 'axşam',
	    night: 'gecə'
	  }
	};
	var formattingDayPeriodValues = {
	  narrow: {
	    am: 'a',
	    pm: 'p',
	    midnight: 'gecəyarı',
	    noon: 'gün',
	    morning: 'səhər',
	    afternoon: 'gündüz',
	    evening: 'axşam',
	    night: 'gecə'
	  },
	  abbreviated: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'gecəyarı',
	    noon: 'gün',
	    morning: 'səhər',
	    afternoon: 'gündüz',
	    evening: 'axşam',
	    night: 'gecə'
	  },
	  wide: {
	    am: 'a.m.',
	    pm: 'p.m.',
	    midnight: 'gecəyarı',
	    noon: 'gün',
	    morning: 'səhər',
	    afternoon: 'gündüz',
	    evening: 'axşam',
	    night: 'gecə'
	  }
	};
	var suffixes = {
	  1: '-inci',
	  5: '-inci',
	  8: '-inci',
	  70: '-inci',
	  80: '-inci',
	  2: '-nci',
	  7: '-nci',
	  20: '-nci',
	  50: '-nci',
	  3: '-üncü',
	  4: '-üncü',
	  100: '-üncü',
	  6: '-ncı',
	  9: '-uncu',
	  10: '-uncu',
	  30: '-uncu',
	  60: '-ıncı',
	  90: '-ıncı'
	};
	
	var getSuffix = function (number) {
	  if (number === 0) {
	    // special case for zero
	    return number + '-ıncı';
	  }
	
	  var a = number % 10;
	  var b = number % 100 - a;
	  var c = number >= 100 ? 100 : null;
	
	  if (suffixes[a]) {
	    return suffixes[a];
	  } else if (suffixes[b]) {
	    return suffixes[b];
	  } else if (c !== null) {
	    return suffixes[c];
	  }
	
	  return '';
	};
	
	var ordinalNumber = function (dirtyNumber, _dirtyOptions) {
	  var number = Number(dirtyNumber);
	  var suffix = getSuffix(number);
	  return number + suffix;
	};
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingDayPeriodValues,
	    defaultFormattingWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1076 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(15));
	
	var _index2 = _interopRequireDefault(__webpack_require__(14));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(\d+)(-?(ci|inci|nci|uncu|üncü|ncı))?/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^(b|a)$/i,
	  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)$/i,
	  wide: /^(bizim eradan əvvəl|bizim era)$/i
	};
	var parseEraPatterns = {
	  any: [/^b$/i, /^(a|c)$/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]$/i,
	  abbreviated: /^K[1234]$/i,
	  wide: /^[1234](ci)? kvartal$/i
	};
	var parseQuarterPatterns = {
	  any: [/1/i, /2/i, /3/i, /4/i]
	};
	var matchMonthPatterns = {
	  narrow: /^[(?-i)yfmaisond]$/i,
	  abbreviated: /^(Yan|Fev|Mar|Apr|May|İyun|İyul|Avq|Sen|Okt|Noy|Dek)$/i,
	  wide: /^(Yanvar|Fevral|Mart|Aprel|May|İyun|İyul|Avgust|Sentyabr|Oktyabr|Noyabr|Dekabr)$/i
	};
	var parseMonthPatterns = {
	  narrow: [/^[(?-i)y]$/i, /^[(?-i)f]$/i, /^[(?-i)m]$/i, /^[(?-i)a]$/i, /^[(?-i)m]$/i, /^[(?-i)i]$/i, /^[(?-i)i]$/i, /^[(?-i)a]$/i, /^[(?-i)s]$/i, /^[(?-i)o]$/i, /^[(?-i)n]$/i, /^[(?-i)d]$/i],
	  abbreviated: [/^Yan$/i, /^Fev$/i, /^Mar$/i, /^Apr$/i, /^May$/i, /^İyun$/i, /^İyul$/i, /^Avg$/i, /^Sen$/i, /^Okt$/i, /^Noy$/i, /^Dek$/i],
	  wide: [/^Yanvar$/i, /^Fevral$/i, /^Mart$/i, /^Aprel$/i, /^May$/i, /^İyun$/i, /^İyul$/i, /^Avgust$/i, /^Sentyabr$/i, /^Oktyabr$/i, /^Noyabr$/i, /^Dekabr$/i]
	};
	var matchDayPatterns = {
	  narrow: /^(B\.|B\.e|Ç\.a|Ç\.|C\.a|C\.|Ş\.)$/i,
	  short: /^(B\.|B\.e|Ç\.a|Ç\.|C\.a|C\.|Ş\.)$/i,
	  abbreviated: /^(Baz\.e|Çər|Çər\.a|Cüm|Cüm\.a|Şə)$/i,
	  wide: /^(Bazar|Bazar ertəsi|Çərşənbə axşamı|Çərşənbə|Cümə axşamı|Cümə|Şənbə)$/i
	};
	var parseDayPatterns = {
	  narrow: [/^B\.$/i, /^B\.e$/i, /^Ç\.a$/i, /^Ç\.$/i, /^C\.a$/i, /^C\.$/i, /^Ş\.$/i],
	  abbreviated: [/^Baz$/i, /^Baz\.e$/i, /^Çər\.a$/i, /^Çər$/i, /^Cüm\.a$/i, /^Cüm$/i, /^Şə$/i],
	  wide: [/^Bazar$/i, /^Bazar ertəsi$/i, /^Çərşənbə axşamı$/i, /^Çərşənbə$/i, /^Cümə axşamı$/i, /^Cümə$/i, /^Şənbə$/i],
	  any: [/^B\.$/i, /^B\.e$/i, /^Ç\.a$/i, /^Ç\.$/i, /^C\.a$/i, /^C\.$/i, /^Ş\.$/i]
	};
	var matchDayPeriodPatterns = {
	  narrow: /^(a|p|gecəyarı|gün|səhər|gündüz|axşam|gecə)$/i,
	  any: /^(am|pm|a\.m\.|p\.m\.|AM|PM|gecəyarı|gün|səhər|gündüz|axşam|gecə)$/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^a$/i,
	    pm: /^p$/i,
	    midnight: /^gecəyarı$/i,
	    noon: /^gün$/i,
	    morning: /səhər$/i,
	    afternoon: /gündüz$/i,
	    evening: /axşam$/i,
	    night: /gecə$/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index2.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index2.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return Number(index) + 1;
	    }
	  }),
	  month: (0, _index2.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'narrow'
	  }),
	  day: (0, _index2.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index2.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1077 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1072));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1073));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1074));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1075));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1076));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Azerbaijani locale.
	 * @language Azerbaijani
	 * @iso-639-2 aze
	 */
	var locale = {
	  code: 'az',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 1,
	    firstWeekContainsDate: 1
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1078 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	function declension(scheme, count) {
	  // scheme for count=1 exists
	  if (scheme.one !== undefined && count === 1) {
	    return scheme.one;
	  }
	
	  var rem10 = count % 10;
	  var rem100 = count % 100; // 1, 21, 31, ...
	
	  if (rem10 === 1 && rem100 !== 11) {
	    return scheme.singularNominative.replace('{{count}}', String(count)); // 2, 3, 4, 22, 23, 24, 32 ...
	  } else if (rem10 >= 2 && rem10 <= 4 && (rem100 < 10 || rem100 > 20)) {
	    return scheme.singularGenitive.replace('{{count}}', String(count)); // 5, 6, 7, 8, 9, 10, 11, ...
	  } else {
	    return scheme.pluralGenitive.replace('{{count}}', String(count));
	  }
	}
	
	function buildLocalizeTokenFn(scheme) {
	  return function (count, options) {
	    if (options && options.addSuffix) {
	      if (options.comparison && options.comparison > 0) {
	        if (scheme.future) {
	          return declension(scheme.future, count);
	        } else {
	          return 'праз ' + declension(scheme.regular, count);
	        }
	      } else {
	        if (scheme.past) {
	          return declension(scheme.past, count);
	        } else {
	          return declension(scheme.regular, count) + ' таму';
	        }
	      }
	    } else {
	      return declension(scheme.regular, count);
	    }
	  };
	}
	
	var halfAMinute = function (_, options) {
	  if (options && options.addSuffix) {
	    if (options.comparison && options.comparison > 0) {
	      return 'праз паўхвіліны';
	    } else {
	      return 'паўхвіліны таму';
	    }
	  }
	
	  return 'паўхвіліны';
	};
	
	var formatDistanceLocale = {
	  lessThanXSeconds: buildLocalizeTokenFn({
	    regular: {
	      one: 'менш за секунду',
	      singularNominative: 'менш за {{count}} секунду',
	      singularGenitive: 'менш за {{count}} секунды',
	      pluralGenitive: 'менш за {{count}} секунд'
	    },
	    future: {
	      one: 'менш, чым праз секунду',
	      singularNominative: 'менш, чым праз {{count}} секунду',
	      singularGenitive: 'менш, чым праз {{count}} секунды',
	      pluralGenitive: 'менш, чым праз {{count}} секунд'
	    }
	  }),
	  xSeconds: buildLocalizeTokenFn({
	    regular: {
	      singularNominative: '{{count}} секунда',
	      singularGenitive: '{{count}} секунды',
	      pluralGenitive: '{{count}} секунд'
	    },
	    past: {
	      singularNominative: '{{count}} секунду таму',
	      singularGenitive: '{{count}} секунды таму',
	      pluralGenitive: '{{count}} секунд таму'
	    },
	    future: {
	      singularNominative: 'праз {{count}} секунду',
	      singularGenitive: 'праз {{count}} секунды',
	      pluralGenitive: 'праз {{count}} секунд'
	    }
	  }),
	  halfAMinute: halfAMinute,
	  lessThanXMinutes: buildLocalizeTokenFn({
	    regular: {
	      one: 'менш за хвіліну',
	      singularNominative: 'менш за {{count}} хвіліну',
	      singularGenitive: 'менш за {{count}} хвіліны',
	      pluralGenitive: 'менш за {{count}} хвілін'
	    },
	    future: {
	      one: 'менш, чым праз хвіліну',
	      singularNominative: 'менш, чым праз {{count}} хвіліну',
	      singularGenitive: 'менш, чым праз {{count}} хвіліны',
	      pluralGenitive: 'менш, чым праз {{count}} хвілін'
	    }
	  }),
	  xMinutes: buildLocalizeTokenFn({
	    regular: {
	      singularNominative: '{{count}} хвіліна',
	      singularGenitive: '{{count}} хвіліны',
	      pluralGenitive: '{{count}} хвілін'
	    },
	    past: {
	      singularNominative: '{{count}} хвіліну таму',
	      singularGenitive: '{{count}} хвіліны таму',
	      pluralGenitive: '{{count}} хвілін таму'
	    },
	    future: {
	      singularNominative: 'праз {{count}} хвіліну',
	      singularGenitive: 'праз {{count}} хвіліны',
	      pluralGenitive: 'праз {{count}} хвілін'
	    }
	  }),
	  aboutXHours: buildLocalizeTokenFn({
	    regular: {
	      singularNominative: 'каля {{count}} гадзіны',
	      singularGenitive: 'каля {{count}} гадзін',
	      pluralGenitive: 'каля {{count}} гадзін'
	    },
	    future: {
	      singularNominative: 'прыблізна праз {{count}} гадзіну',
	      singularGenitive: 'прыблізна праз {{count}} гадзіны',
	      pluralGenitive: 'прыблізна праз {{count}} гадзін'
	    }
	  }),
	  xHours: buildLocalizeTokenFn({
	    regular: {
	      singularNominative: '{{count}} гадзіна',
	      singularGenitive: '{{count}} гадзіны',
	      pluralGenitive: '{{count}} гадзін'
	    },
	    past: {
	      singularNominative: '{{count}} гадзіну таму',
	      singularGenitive: '{{count}} гадзіны таму',
	      pluralGenitive: '{{count}} гадзін таму'
	    },
	    future: {
	      singularNominative: 'праз {{count}} гадзіну',
	      singularGenitive: 'праз {{count}} гадзіны',
	      pluralGenitive: 'праз {{count}} гадзін'
	    }
	  }),
	  xDays: buildLocalizeTokenFn({
	    regular: {
	      singularNominative: '{{count}} дзень',
	      singularGenitive: '{{count}} дні',
	      pluralGenitive: '{{count}} дзён'
	    }
	  }),
	  aboutXWeeks: buildLocalizeTokenFn({
	    regular: {
	      singularNominative: 'каля {{count}} месяца',
	      // TODO
	      singularGenitive: 'каля {{count}} месяцаў',
	      // TODO
	      pluralGenitive: 'каля {{count}} месяцаў' // TODO
	
	    },
	    future: {
	      singularNominative: 'прыблізна праз {{count}} месяц',
	      // TODO
	      singularGenitive: 'прыблізна праз {{count}} месяцы',
	      // TODO
	      pluralGenitive: 'прыблізна праз {{count}} месяцаў' // TODO
	
	    }
	  }),
	  xWeeks: buildLocalizeTokenFn({
	    regular: {
	      singularNominative: '{{count}} месяц',
	      singularGenitive: '{{count}} месяцы',
	      pluralGenitive: '{{count}} месяцаў'
	    }
	  }),
	  aboutXMonths: buildLocalizeTokenFn({
	    regular: {
	      singularNominative: 'каля {{count}} месяца',
	      singularGenitive: 'каля {{count}} месяцаў',
	      pluralGenitive: 'каля {{count}} месяцаў'
	    },
	    future: {
	      singularNominative: 'прыблізна праз {{count}} месяц',
	      singularGenitive: 'прыблізна праз {{count}} месяцы',
	      pluralGenitive: 'прыблізна праз {{count}} месяцаў'
	    }
	  }),
	  xMonths: buildLocalizeTokenFn({
	    regular: {
	      singularNominative: '{{count}} месяц',
	      singularGenitive: '{{count}} месяцы',
	      pluralGenitive: '{{count}} месяцаў'
	    }
	  }),
	  aboutXYears: buildLocalizeTokenFn({
	    regular: {
	      singularNominative: 'каля {{count}} года',
	      singularGenitive: 'каля {{count}} гадоў',
	      pluralGenitive: 'каля {{count}} гадоў'
	    },
	    future: {
	      singularNominative: 'прыблізна праз {{count}} год',
	      singularGenitive: 'прыблізна праз {{count}} гады',
	      pluralGenitive: 'прыблізна праз {{count}} гадоў'
	    }
	  }),
	  xYears: buildLocalizeTokenFn({
	    regular: {
	      singularNominative: '{{count}} год',
	      singularGenitive: '{{count}} гады',
	      pluralGenitive: '{{count}} гадоў'
	    }
	  }),
	  overXYears: buildLocalizeTokenFn({
	    regular: {
	      singularNominative: 'больш за {{count}} год',
	      singularGenitive: 'больш за {{count}} гады',
	      pluralGenitive: 'больш за {{count}} гадоў'
	    },
	    future: {
	      singularNominative: 'больш, чым праз {{count}} год',
	      singularGenitive: 'больш, чым праз {{count}} гады',
	      pluralGenitive: 'больш, чым праз {{count}} гадоў'
	    }
	  }),
	  almostXYears: buildLocalizeTokenFn({
	    regular: {
	      singularNominative: 'амаль {{count}} год',
	      singularGenitive: 'амаль {{count}} гады',
	      pluralGenitive: 'амаль {{count}} гадоў'
	    },
	    future: {
	      singularNominative: 'амаль праз {{count}} год',
	      singularGenitive: 'амаль праз {{count}} гады',
	      pluralGenitive: 'амаль праз {{count}} гадоў'
	    }
	  })
	};
	
	var formatDistance = function (token, count, options) {
	  options = options || {};
	  return formatDistanceLocale[token](count, options);
	};
	
	var _default = formatDistance;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1079 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: "EEEE, d MMMM y 'г.'",
	  long: "d MMMM y 'г.'",
	  medium: "d MMM y 'г.'",
	  short: 'dd.MM.y'
	};
	var timeFormats = {
	  full: 'H:mm:ss zzzz',
	  long: 'H:mm:ss z',
	  medium: 'H:mm:ss',
	  short: 'H:mm'
	};
	var dateTimeFormats = {
	  any: '{{date}}, {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'any'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1080 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(71));
	
	var _index2 = __webpack_require__(278);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var accusativeWeekdays = ['нядзелю', 'панядзелак', 'аўторак', 'сераду', 'чацвер', 'пятніцу', 'суботу'];
	
	function lastWeek(day) {
	  var weekday = accusativeWeekdays[day];
	
	  switch (day) {
	    case 0:
	    case 3:
	    case 5:
	    case 6:
	      return "'у мінулую " + weekday + " а' p";
	
	    case 1:
	    case 2:
	    case 4:
	      return "'у мінулы " + weekday + " а' p";
	  }
	}
	
	function thisWeek(day) {
	  var weekday = accusativeWeekdays[day];
	  return "'у " + weekday + " а' p";
	}
	
	function nextWeek(day) {
	  var weekday = accusativeWeekdays[day];
	
	  switch (day) {
	    case 0:
	    case 3:
	    case 5:
	    case 6:
	      return "'у наступную " + weekday + " а' p";
	
	    case 1:
	    case 2:
	    case 4:
	      return "'у наступны " + weekday + " а' p";
	  }
	}
	
	var lastWeekFormat = function (dirtyDate, baseDate, options) {
	  var date = (0, _index2.toDate)(dirtyDate);
	  var day = date.getUTCDay();
	
	  if ((0, _index.default)(date, baseDate, options)) {
	    return thisWeek(day);
	  } else {
	    return lastWeek(day);
	  }
	};
	
	var nextWeekFormat = function (dirtyDate, baseDate, options) {
	  var date = (0, _index2.toDate)(dirtyDate);
	  var day = date.getUTCDay();
	
	  if ((0, _index.default)(date, baseDate, options)) {
	    return thisWeek(day);
	  } else {
	    return nextWeek(day);
	  }
	};
	
	var formatRelativeLocale = {
	  lastWeek: lastWeekFormat,
	  yesterday: "'учора а' p",
	  today: "'сёння а' p",
	  tomorrow: "'заўтра а' p",
	  nextWeek: nextWeekFormat,
	  other: 'P'
	};
	
	var formatRelative = function (token, date, baseDate, options) {
	  var format = formatRelativeLocale[token];
	
	  if (typeof format === 'function') {
	    return format(date, baseDate, options);
	  }
	
	  return format;
	};
	
	var _default = formatRelative;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1081 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eraValues = {
	  narrow: ['да н.э.', 'н.э.'],
	  abbreviated: ['да н. э.', 'н. э.'],
	  wide: ['да нашай эры', 'нашай эры']
	};
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['1-ы кв.', '2-і кв.', '3-і кв.', '4-ы кв.'],
	  wide: ['1-ы квартал', '2-і квартал', '3-і квартал', '4-ы квартал']
	};
	var monthValues = {
	  narrow: ['С', 'Л', 'С', 'К', 'М', 'Ч', 'Л', 'Ж', 'В', 'К', 'Л', 'С'],
	  abbreviated: ['студз.', 'лют.', 'сак.', 'крас.', 'май', 'чэрв.', 'ліп.', 'жн.', 'вер.', 'кастр.', 'ліст.', 'снеж.'],
	  wide: ['студзень', 'люты', 'сакавік', 'красавік', 'май', 'чэрвень', 'ліпень', 'жнівень', 'верасень', 'кастрычнік', 'лістапад', 'снежань']
	};
	var formattingMonthValues = {
	  narrow: ['С', 'Л', 'С', 'К', 'М', 'Ч', 'Л', 'Ж', 'В', 'К', 'Л', 'С'],
	  abbreviated: ['студз.', 'лют.', 'сак.', 'крас.', 'мая', 'чэрв.', 'ліп.', 'жн.', 'вер.', 'кастр.', 'ліст.', 'снеж.'],
	  wide: ['студзеня', 'лютага', 'сакавіка', 'красавіка', 'мая', 'чэрвеня', 'ліпеня', 'жніўня', 'верасня', 'кастрычніка', 'лістапада', 'снежня']
	};
	var dayValues = {
	  narrow: ['Н', 'П', 'А', 'С', 'Ч', 'П', 'С'],
	  short: ['нд', 'пн', 'аў', 'ср', 'чц', 'пт', 'сб'],
	  abbreviated: ['нядз', 'пан', 'аўт', 'сер', 'чац', 'пят', 'суб'],
	  wide: ['нядзеля', 'панядзелак', 'аўторак', 'серада', 'чацвер', 'пятніца', 'субота']
	};
	var dayPeriodValues = {
	  narrow: {
	    am: 'ДП',
	    pm: 'ПП',
	    midnight: 'поўн.',
	    noon: 'поўд.',
	    morning: 'ран.',
	    afternoon: 'дзень',
	    evening: 'веч.',
	    night: 'ноч'
	  },
	  abbreviated: {
	    am: 'ДП',
	    pm: 'ПП',
	    midnight: 'поўн.',
	    noon: 'поўд.',
	    morning: 'ран.',
	    afternoon: 'дзень',
	    evening: 'веч.',
	    night: 'ноч'
	  },
	  wide: {
	    am: 'ДП',
	    pm: 'ПП',
	    midnight: 'поўнач',
	    noon: 'поўдзень',
	    morning: 'раніца',
	    afternoon: 'дзень',
	    evening: 'вечар',
	    night: 'ноч'
	  }
	};
	var formattingDayPeriodValues = {
	  narrow: {
	    am: 'ДП',
	    pm: 'ПП',
	    midnight: 'поўн.',
	    noon: 'поўд.',
	    morning: 'ран.',
	    afternoon: 'дня',
	    evening: 'веч.',
	    night: 'ночы'
	  },
	  abbreviated: {
	    am: 'ДП',
	    pm: 'ПП',
	    midnight: 'поўн.',
	    noon: 'поўд.',
	    morning: 'ран.',
	    afternoon: 'дня',
	    evening: 'веч.',
	    night: 'ночы'
	  },
	  wide: {
	    am: 'ДП',
	    pm: 'ПП',
	    midnight: 'поўнач',
	    noon: 'поўдзень',
	    morning: 'раніцы',
	    afternoon: 'дня',
	    evening: 'вечара',
	    night: 'ночы'
	  }
	};
	
	var ordinalNumber = function (dirtyNumber, dirtyOptions) {
	  var options = dirtyOptions || {};
	  var unit = String(options.unit);
	  var number = Number(dirtyNumber);
	  var suffix;
	  /** Though it's an incorrect ordinal form of a date we use it here for consistency with other similar locales (ru, uk)
	   *  For date-month combinations should be used `d` formatter.
	   *  Correct:   `d MMMM` (4 верасня)
	   *  Incorrect: `do MMMM` (4-га верасня)
	   *
	   *  But following the consistency leads to mistakes for literal uses of `do` formatter (ordinal day of month).
	   *  So for phrase "5th day of month" (`do дзень месяца`)
	   *  library will produce:            `5-га дзень месяца`
	   *  but correct spelling should be:  `5-ы дзень месяца`
	   *
	   *  So I guess there should be a stand-alone and a formatting version of "day of month" formatters
	   */
	
	  if (unit === 'date') {
	    suffix = '-га';
	  } else if (unit === 'hour' || unit === 'minute' || unit === 'second') {
	    suffix = '-я';
	  } else {
	    suffix = (number % 10 === 2 || number % 10 === 3) && number % 100 !== 12 && number % 100 !== 13 ? '-і' : '-ы';
	  }
	
	  return number + suffix;
	};
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingMonthValues,
	    defaultFormattingWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'any',
	    formattingValues: formattingDayPeriodValues,
	    defaultFormattingWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1082 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(15));
	
	var _index2 = _interopRequireDefault(__webpack_require__(14));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(\d+)(-?(е|я|га|і|ы|ае|ая|яя|шы|гі|ці|ты|мы))?/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^((да )?н\.?\s?э\.?)/i,
	  abbreviated: /^((да )?н\.?\s?э\.?)/i,
	  wide: /^(да нашай эры|нашай эры|наша эра)/i
	};
	var parseEraPatterns = {
	  any: [/^д/i, /^н/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^[1234](-?[ыі]?)? кв.?/i,
	  wide: /^[1234](-?[ыі]?)? квартал/i
	};
	var parseQuarterPatterns = {
	  any: [/1/i, /2/i, /3/i, /4/i]
	};
	var matchMonthPatterns = {
	  narrow: /^[слкмчжв]/i,
	  abbreviated: /^(студз|лют|сак|крас|ма[йя]|чэрв|ліп|жн|вер|кастр|ліст|снеж)\.?/i,
	  wide: /^(студзен[ья]|лют(ы|ага)|сакавіка?|красавіка?|ма[йя]|чэрвен[ья]|ліпен[ья]|жні(вень|ўня)|верас(ень|ня)|кастрычніка?|лістапада?|снеж(ань|ня))/i
	};
	var parseMonthPatterns = {
	  narrow: [/^с/i, /^л/i, /^с/i, /^к/i, /^м/i, /^ч/i, /^л/i, /^ж/i, /^в/i, /^к/i, /^л/i, /^с/i],
	  any: [/^ст/i, /^лю/i, /^са/i, /^кр/i, /^ма/i, /^ч/i, /^ліп/i, /^ж/i, /^в/i, /^ка/i, /^ліс/i, /^сн/i]
	};
	var matchDayPatterns = {
	  narrow: /^[нпасч]/i,
	  short: /^(нд|ня|пн|па|аў|ат|ср|се|чц|ча|пт|пя|сб|су)\.?/i,
	  abbreviated: /^(нядз?|ндз|пнд|пан|аўт|срд|сер|чцв|чац|птн|пят|суб).?/i,
	  wide: /^(нядзел[яі]|панядзел(ак|ка)|аўтор(ак|ка)|серад[аы]|чацв(ер|ярга)|пятніц[аы]|субот[аы])/i
	};
	var parseDayPatterns = {
	  narrow: [/^н/i, /^п/i, /^а/i, /^с/i, /^ч/i, /^п/i, /^с/i],
	  any: [/^н/i, /^п[ан]/i, /^а/i, /^с[ер]/i, /^ч/i, /^п[ят]/i, /^с[уб]/i]
	};
	var matchDayPeriodPatterns = {
	  narrow: /^([дп]п|поўн\.?|поўд\.?|ран\.?|дзень|дня|веч\.?|ночы?)/i,
	  abbreviated: /^([дп]п|поўн\.?|поўд\.?|ран\.?|дзень|дня|веч\.?|ночы?)/i,
	  wide: /^([дп]п|поўнач|поўдзень|раніц[аы]|дзень|дня|вечара?|ночы?)/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^дп/i,
	    pm: /^пп/i,
	    midnight: /^поўн/i,
	    noon: /^поўд/i,
	    morning: /^р/i,
	    afternoon: /^д[зн]/i,
	    evening: /^в/i,
	    night: /^н/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index2.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index2.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return Number(index) + 1;
	    }
	  }),
	  month: (0, _index2.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index2.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index2.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1083 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1078));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1079));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1080));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1081));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1082));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Belarusian locale.
	 * @language Belarusian
	 * @iso-639-2 bel
	 * @author Kiryl Anokhin [@alyrik]{@link https://github.com/alyrik}
	 * @author Martin Wind [@arvigeus]{@link https://github.com/mawi12345}
	 */
	var locale = {
	  code: 'be',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 1
	    /* Monday */
	    ,
	    firstWeekContainsDate: 1
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1084 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    one: 'по-малко от секунда',
	    other: 'по-малко от {{count}} секунди'
	  },
	  xSeconds: {
	    one: '1 секунда',
	    other: '{{count}} секунди'
	  },
	  halfAMinute: 'половин минута',
	  lessThanXMinutes: {
	    one: 'по-малко от минута',
	    other: 'по-малко от {{count}} минути'
	  },
	  xMinutes: {
	    one: '1 минута',
	    other: '{{count}} минути'
	  },
	  aboutXHours: {
	    one: 'около час',
	    other: 'около {{count}} часа'
	  },
	  xHours: {
	    one: '1 час',
	    other: '{{count}} часа'
	  },
	  xDays: {
	    one: '1 ден',
	    other: '{{count}} дни'
	  },
	  aboutXWeeks: {
	    one: 'около седмица',
	    other: 'около {{count}} седмици'
	  },
	  xWeeks: {
	    one: '1 седмица',
	    other: '{{count}} седмици'
	  },
	  aboutXMonths: {
	    one: 'около месец',
	    other: 'около {{count}} месеца'
	  },
	  xMonths: {
	    one: '1 месец',
	    other: '{{count}} месеца'
	  },
	  aboutXYears: {
	    one: 'около година',
	    other: 'около {{count}} години'
	  },
	  xYears: {
	    one: '1 година',
	    other: '{{count}} години'
	  },
	  overXYears: {
	    one: 'над година',
	    other: 'над {{count}} години'
	  },
	  almostXYears: {
	    one: 'почти година',
	    other: 'почти {{count}} години'
	  }
	};
	
	var formatDistance = function (token, count) {
	  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	  var usageGroup = formatDistanceLocale[token];
	  var result;
	
	  if (typeof usageGroup === 'string') {
	    result = usageGroup;
	  } else if (count === 1) {
	    result = usageGroup.one;
	  } else {
	    result = usageGroup.other.replace('{{count}}', String(count));
	  }
	
	  if (options.addSuffix) {
	    if (options.comparison && options.comparison > 0) {
	      return 'след ' + result;
	    } else {
	      return 'преди ' + result;
	    }
	  }
	
	  return result;
	};
	
	var _default = formatDistance;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1085 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: 'EEEE, dd MMMM yyyy',
	  long: 'dd MMMM yyyy',
	  medium: 'dd MMM yyyy',
	  short: 'dd/MM/yyyy'
	};
	var timeFormats = {
	  full: 'HH:mm:ss zzzz',
	  long: 'HH:mm:ss z',
	  medium: 'HH:mm:ss',
	  short: 'H:mm'
	};
	var dateTimeFormats = {
	  any: '{{date}} {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'any'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1086 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(71));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Adapted from the `ru` translation
	var weekdays = ['неделя', 'понеделник', 'вторник', 'сряда', 'четвъртък', 'петък', 'събота'];
	
	function lastWeek(day) {
	  var weekday = weekdays[day];
	
	  switch (day) {
	    case 0:
	    case 3:
	    case 6:
	      return "'миналата " + weekday + " в' p";
	
	    case 1:
	    case 2:
	    case 4:
	    case 5:
	      return "'миналия " + weekday + " в' p";
	  }
	}
	
	function thisWeek(day) {
	  var weekday = weekdays[day];
	
	  if (day === 2
	  /* Tue */
	  ) {
	      return "'във " + weekday + " в' p";
	    } else {
	    return "'в " + weekday + " в' p";
	  }
	}
	
	function nextWeek(day) {
	  var weekday = weekdays[day];
	
	  switch (day) {
	    case 0:
	    case 3:
	    case 6:
	      return "'следващата " + weekday + " в' p";
	
	    case 1:
	    case 2:
	    case 4:
	    case 5:
	      return "'следващия " + weekday + " в' p";
	  }
	}
	
	var lastWeekFormatToken = function (dirtyDate, baseDate, options) {
	  var date = (0, _index.default)(dirtyDate);
	  var day = date.getUTCDay();
	
	  if ((0, _index2.default)(date, baseDate, options)) {
	    return thisWeek(day);
	  } else {
	    return lastWeek(day);
	  }
	};
	
	var nextWeekFormatToken = function (dirtyDate, baseDate, options) {
	  var date = (0, _index.default)(dirtyDate);
	  var day = date.getUTCDay();
	
	  if ((0, _index2.default)(date, baseDate, options)) {
	    return thisWeek(day);
	  } else {
	    return nextWeek(day);
	  }
	};
	
	var formatRelativeLocale = {
	  lastWeek: lastWeekFormatToken,
	  yesterday: "'вчера в' p",
	  today: "'днес в' p",
	  tomorrow: "'утре в' p",
	  nextWeek: nextWeekFormatToken,
	  other: 'P'
	};
	
	var formatRelative = function (token, date, baseDate, options) {
	  var format = formatRelativeLocale[token];
	
	  if (typeof format === 'function') {
	    return format(date, baseDate, options);
	  }
	
	  return format;
	};
	
	var _default = formatRelative;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1087 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eraValues = {
	  narrow: ['пр.н.е.', 'н.е.'],
	  abbreviated: ['преди н. е.', 'н. е.'],
	  wide: ['преди новата ера', 'новата ера']
	};
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['1-во тримес.', '2-ро тримес.', '3-то тримес.', '4-то тримес.'],
	  wide: ['1-во тримесечие', '2-ро тримесечие', '3-то тримесечие', '4-то тримесечие']
	};
	var monthValues = {
	  abbreviated: ['яну', 'фев', 'мар', 'апр', 'май', 'юни', 'юли', 'авг', 'сеп', 'окт', 'ное', 'дек'],
	  wide: ['януари', 'февруари', 'март', 'април', 'май', 'юни', 'юли', 'август', 'септември', 'октомври', 'ноември', 'декември']
	};
	var dayValues = {
	  narrow: ['Н', 'П', 'В', 'С', 'Ч', 'П', 'С'],
	  short: ['нд', 'пн', 'вт', 'ср', 'чт', 'пт', 'сб'],
	  abbreviated: ['нед', 'пон', 'вто', 'сря', 'чет', 'пет', 'съб'],
	  wide: ['неделя', 'понеделник', 'вторник', 'сряда', 'четвъртък', 'петък', 'събота']
	};
	var dayPeriodValues = {
	  wide: {
	    am: 'преди обяд',
	    pm: 'след обяд',
	    midnight: 'в полунощ',
	    noon: 'на обяд',
	    morning: 'сутринта',
	    afternoon: 'следобед',
	    evening: 'вечерта',
	    night: 'през нощта'
	  }
	};
	
	function isFeminine(unit) {
	  return unit === 'year' || unit === 'week' || unit === 'minute' || unit === 'second';
	}
	
	function isNeuter(unit) {
	  return unit === 'quarter';
	}
	
	function numberWithSuffix(number, unit, masculine, feminine, neuter) {
	  var suffix = isNeuter(unit) ? neuter : isFeminine(unit) ? feminine : masculine;
	  return number + '-' + suffix;
	}
	
	var ordinalNumber = function (dirtyNumber) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var unit = String(options.unit);
	  var number = Number(dirtyNumber);
	
	  if (number === 0) {
	    return numberWithSuffix(0, unit, 'ев', 'ева', 'ево');
	  } else if (number % 1000 === 0) {
	    return numberWithSuffix(number, unit, 'ен', 'на', 'но');
	  } else if (number % 100 === 0) {
	    return numberWithSuffix(number, unit, 'тен', 'тна', 'тно');
	  }
	
	  var rem100 = number % 100;
	
	  if (rem100 > 20 || rem100 < 10) {
	    switch (rem100 % 10) {
	      case 1:
	        return numberWithSuffix(number, unit, 'ви', 'ва', 'во');
	
	      case 2:
	        return numberWithSuffix(number, unit, 'ри', 'ра', 'ро');
	
	      case 7:
	      case 8:
	        return numberWithSuffix(number, unit, 'ми', 'ма', 'мо');
	    }
	  }
	
	  return numberWithSuffix(number, unit, 'ти', 'та', 'то');
	};
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1088 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(14));
	
	var _index2 = _interopRequireDefault(__webpack_require__(15));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(\d+)(-?[врмт][аи]|-?т?(ен|на)|-?(ев|ева))?/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^((пр)?н\.?\s?е\.?)/i,
	  abbreviated: /^((пр)?н\.?\s?е\.?)/i,
	  wide: /^(преди новата ера|новата ера|нова ера)/i
	};
	var parseEraPatterns = {
	  any: [/^п/i, /^н/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^[1234](-?[врт]?o?)? тримес.?/i,
	  wide: /^[1234](-?[врт]?о?)? тримесечие/i
	};
	var parseQuarterPatterns = {
	  any: [/1/i, /2/i, /3/i, /4/i]
	};
	var matchDayPatterns = {
	  narrow: /^[нпвсч]/i,
	  short: /^(нд|пн|вт|ср|чт|пт|сб)/i,
	  abbreviated: /^(нед|пон|вто|сря|чет|пет|съб)/i,
	  wide: /^(неделя|понеделник|вторник|сряда|четвъртък|петък|събота)/i
	};
	var parseDayPatterns = {
	  narrow: [/^н/i, /^п/i, /^в/i, /^с/i, /^ч/i, /^п/i, /^с/i],
	  any: [/^н[ед]/i, /^п[он]/i, /^вт/i, /^ср/i, /^ч[ет]/i, /^п[ет]/i, /^с[ъб]/i]
	};
	var matchMonthPatterns = {
	  abbreviated: /^(яну|фев|мар|апр|май|юни|юли|авг|сеп|окт|ное|дек)/i,
	  wide: /^(януари|февруари|март|април|май|юни|юли|август|септември|октомври|ноември|декември)/i
	};
	var parseMonthPatterns = {
	  any: [/^я/i, /^ф/i, /^мар/i, /^ап/i, /^май/i, /^юн/i, /^юл/i, /^ав/i, /^се/i, /^окт/i, /^но/i, /^де/i]
	};
	var matchDayPeriodPatterns = {
	  any: /^(преди о|след о|в по|на о|през|веч|сут|следо)/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^преди о/i,
	    pm: /^след о/i,
	    midnight: /^в пол/i,
	    noon: /^на об/i,
	    morning: /^сут/i,
	    afternoon: /^следо/i,
	    evening: /^веч/i,
	    night: /^през н/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index2.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return Number(index) + 1;
	    }
	  }),
	  month: (0, _index.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1089 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1084));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1085));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1086));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1087));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1088));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Bulgarian locale.
	 * @language Bulgarian
	 * @iso-639-2 bul
	 * @author Nikolay Stoynov [@arvigeus]{@link https://github.com/arvigeus}
	 * @author Tsvetan Ovedenski [@fintara]{@link https://github.com/fintara}
	 */
	var locale = {
	  code: 'bg',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 1
	    /* Monday */
	    ,
	    firstWeekContainsDate: 1
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1090 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = __webpack_require__(438);
	
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    one: 'প্রায় ১ সেকেন্ড',
	    other: 'প্রায় {{count}} সেকেন্ড'
	  },
	  xSeconds: {
	    one: '১ সেকেন্ড',
	    other: '{{count}} সেকেন্ড'
	  },
	  halfAMinute: 'আধ মিনিট',
	  lessThanXMinutes: {
	    one: 'প্রায় ১ মিনিট',
	    other: 'প্রায় {{count}} মিনিট'
	  },
	  xMinutes: {
	    one: '১ মিনিট',
	    other: '{{count}} মিনিট'
	  },
	  aboutXHours: {
	    one: 'প্রায় ১ ঘন্টা',
	    other: 'প্রায় {{count}} ঘন্টা'
	  },
	  xHours: {
	    one: '১ ঘন্টা',
	    other: '{{count}} ঘন্টা'
	  },
	  xDays: {
	    one: '১ দিন',
	    other: '{{count}} দিন'
	  },
	  aboutXWeeks: {
	    one: 'প্রায় ১ সপ্তাহ',
	    other: 'প্রায় {{count}} সপ্তাহ'
	  },
	  xWeeks: {
	    one: '১ সপ্তাহ',
	    other: '{{count}} সপ্তাহ'
	  },
	  aboutXMonths: {
	    one: 'প্রায় ১ মাস',
	    other: 'প্রায় {{count}} মাস'
	  },
	  xMonths: {
	    one: '১ মাস',
	    other: '{{count}} মাস'
	  },
	  aboutXYears: {
	    one: 'প্রায় ১ বছর',
	    other: 'প্রায় {{count}} বছর'
	  },
	  xYears: {
	    one: '১ বছর',
	    other: '{{count}} বছর'
	  },
	  overXYears: {
	    one: '১ বছরের বেশি',
	    other: '{{count}} বছরের বেশি'
	  },
	  almostXYears: {
	    one: 'প্রায় ১ বছর',
	    other: 'প্রায় {{count}} বছর'
	  }
	};
	
	var formatDistance = function (token, count, options) {
	  var result;
	  var tokenValue = formatDistanceLocale[token];
	
	  if (typeof tokenValue === 'string') {
	    result = tokenValue;
	  } else if (count === 1) {
	    result = tokenValue.one;
	  } else {
	    result = tokenValue.other.replace('{{count}}', (0, _index.numberToLocale)(count));
	  }
	
	  if (options !== null && options !== void 0 && options.addSuffix) {
	    if (options.comparison && options.comparison > 0) {
	      return result + ' এর মধ্যে';
	    } else {
	      return result + ' আগে';
	    }
	  }
	
	  return result;
	};
	
	var _default = formatDistance;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1091 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: 'EEEE, MMMM do, y',
	  long: 'MMMM do, y',
	  medium: 'MMM d, y',
	  short: 'MM/dd/yyyy'
	};
	var timeFormats = {
	  full: 'h:mm:ss a zzzz',
	  long: 'h:mm:ss a z',
	  medium: 'h:mm:ss a',
	  short: 'h:mm a'
	};
	var dateTimeFormats = {
	  full: "{{date}} {{time}} 'সময়'",
	  long: "{{date}} {{time}} 'সময়'",
	  medium: '{{date}}, {{time}}',
	  short: '{{date}}, {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1092 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var formatRelativeLocale = {
	  lastWeek: "'গত' eeee 'সময়' p",
	  yesterday: "'গতকাল' 'সময়' p",
	  today: "'আজ' 'সময়' p",
	  tomorrow: "'আগামীকাল' 'সময়' p",
	  nextWeek: "eeee 'সময়' p",
	  other: 'P'
	};
	
	var formatRelative = function (token, _date, _baseDate, _options) {
	  return formatRelativeLocale[token];
	};
	
	var _default = formatRelative;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1093 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(14));
	
	var _index2 = _interopRequireDefault(__webpack_require__(15));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(\d+)(ম|য়|র্থ|ষ্ঠ|শে|ই|তম)?/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^(খ্রিঃপূঃ|খ্রিঃ)/i,
	  abbreviated: /^(খ্রিঃপূর্ব|খ্রিঃ)/i,
	  wide: /^(খ্রিস্টপূর্ব|খ্রিস্টাব্দ)/i
	};
	var parseEraPatterns = {
	  narrow: [/^খ্রিঃপূঃ/i, /^খ্রিঃ/i],
	  abbreviated: [/^খ্রিঃপূর্ব/i, /^খ্রিঃ/i],
	  wide: [/^খ্রিস্টপূর্ব/i, /^খ্রিস্টাব্দ/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[১২৩৪]/i,
	  abbreviated: /^[১২৩৪]ত্রৈ/i,
	  wide: /^[১২৩৪](ম|য়|র্থ)? ত্রৈমাসিক/i
	};
	var parseQuarterPatterns = {
	  any: [/১/i, /২/i, /৩/i, /৪/i]
	};
	var matchMonthPatterns = {
	  narrow: /^(জানু|ফেব্রু|মার্চ|এপ্রিল|মে|জুন|জুলাই|আগস্ট|সেপ্ট|অক্টো|নভে|ডিসে)/i,
	  abbreviated: /^(জানু|ফেব্রু|মার্চ|এপ্রিল|মে|জুন|জুলাই|আগস্ট|সেপ্ট|অক্টো|নভে|ডিসে)/i,
	  wide: /^(জানুয়ারি|ফেব্রুয়ারি|মার্চ|এপ্রিল|মে|জুন|জুলাই|আগস্ট|সেপ্টেম্বর|অক্টোবর|নভেম্বর|ডিসেম্বর)/i
	};
	var parseMonthPatterns = {
	  any: [/^জানু/i, /^ফেব্রু/i, /^মার্চ/i, /^এপ্রিল/i, /^মে/i, /^জুন/i, /^জুলাই/i, /^আগস্ট/i, /^সেপ্ট/i, /^অক্টো/i, /^নভে/i, /^ডিসে/i]
	};
	var matchDayPatterns = {
	  narrow: /^(র|সো|ম|বু|বৃ|শু|শ)+/i,
	  short: /^(রবি|সোম|মঙ্গল|বুধ|বৃহ|শুক্র|শনি)+/i,
	  abbreviated: /^(রবি|সোম|মঙ্গল|বুধ|বৃহ|শুক্র|শনি)+/i,
	  wide: /^(রবিবার|সোমবার|মঙ্গলবার|বুধবার|বৃহস্পতিবার |শুক্রবার|শনিবার)+/i
	};
	var parseDayPatterns = {
	  narrow: [/^র/i, /^সো/i, /^ম/i, /^বু/i, /^বৃ/i, /^শু/i, /^শ/i],
	  short: [/^রবি/i, /^সোম/i, /^মঙ্গল/i, /^বুধ/i, /^বৃহ/i, /^শুক্র/i, /^শনি/i],
	  abbreviated: [/^রবি/i, /^সোম/i, /^মঙ্গল/i, /^বুধ/i, /^বৃহ/i, /^শুক্র/i, /^শনি/i],
	  wide: [/^রবিবার/i, /^সোমবার/i, /^মঙ্গলবার/i, /^বুধবার/i, /^বৃহস্পতিবার /i, /^শুক্রবার/i, /^শনিবার/i]
	};
	var matchDayPeriodPatterns = {
	  narrow: /^(পূ|অপ|মধ্যরাত|মধ্যাহ্ন|সকাল|বিকাল|সন্ধ্যা|রাত)/i,
	  abbreviated: /^(পূর্বাহ্ন|অপরাহ্ন|মধ্যরাত|মধ্যাহ্ন|সকাল|বিকাল|সন্ধ্যা|রাত)/i,
	  wide: /^(পূর্বাহ্ন|অপরাহ্ন|মধ্যরাত|মধ্যাহ্ন|সকাল|বিকাল|সন্ধ্যা|রাত)/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^পূ/i,
	    pm: /^অপ/i,
	    midnight: /^মধ্যরাত/i,
	    noon: /^মধ্যাহ্ন/i,
	    morning: /সকাল/i,
	    afternoon: /বিকাল/i,
	    evening: /সন্ধ্যা/i,
	    night: /রাত/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index2.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1094 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1090));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1091));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1092));
	
	var _index4 = _interopRequireDefault(__webpack_require__(438));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1093));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Bengali locale.
	 * @language Bengali
	 * @iso-639-2 ben
	 * @author Touhidur Rahman [@touhidrahman]{@link https://github.com/touhidrahman}
	 * @author Farhad Yasir [@nutboltu]{@link https://github.com/nutboltu}
	 */
	var locale = {
	  code: 'bn',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 0
	    /* Sunday */
	    ,
	    firstWeekContainsDate: 1
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1095 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    one: {
	      standalone: 'manje od 1 sekunde',
	      withPrepositionAgo: 'manje od 1 sekunde',
	      withPrepositionIn: 'manje od 1 sekundu'
	    },
	    dual: 'manje od {{count}} sekunde',
	    other: 'manje od {{count}} sekundi'
	  },
	  xSeconds: {
	    one: {
	      standalone: '1 sekunda',
	      withPrepositionAgo: '1 sekunde',
	      withPrepositionIn: '1 sekundu'
	    },
	    dual: '{{count}} sekunde',
	    other: '{{count}} sekundi'
	  },
	  halfAMinute: 'pola minute',
	  lessThanXMinutes: {
	    one: {
	      standalone: 'manje od 1 minute',
	      withPrepositionAgo: 'manje od 1 minute',
	      withPrepositionIn: 'manje od 1 minutu'
	    },
	    dual: 'manje od {{count}} minute',
	    other: 'manje od {{count}} minuta'
	  },
	  xMinutes: {
	    one: {
	      standalone: '1 minuta',
	      withPrepositionAgo: '1 minute',
	      withPrepositionIn: '1 minutu'
	    },
	    dual: '{{count}} minute',
	    other: '{{count}} minuta'
	  },
	  aboutXHours: {
	    one: {
	      standalone: 'oko 1 sat',
	      withPrepositionAgo: 'oko 1 sat',
	      withPrepositionIn: 'oko 1 sat'
	    },
	    dual: 'oko {{count}} sata',
	    other: 'oko {{count}} sati'
	  },
	  xHours: {
	    one: {
	      standalone: '1 sat',
	      withPrepositionAgo: '1 sat',
	      withPrepositionIn: '1 sat'
	    },
	    dual: '{{count}} sata',
	    other: '{{count}} sati'
	  },
	  xDays: {
	    one: {
	      standalone: '1 dan',
	      withPrepositionAgo: '1 dan',
	      withPrepositionIn: '1 dan'
	    },
	    dual: '{{count}} dana',
	    other: '{{count}} dana'
	  },
	  aboutXWeeks: {
	    one: {
	      standalone: 'oko 1 sedmicu',
	      withPrepositionAgo: 'oko 1 sedmicu',
	      withPrepositionIn: 'oko 1 sedmicu'
	    },
	    dual: 'oko {{count}} sedmice',
	    other: 'oko {{count}} sedmice'
	  },
	  xWeeks: {
	    one: {
	      standalone: '1 sedmicu',
	      withPrepositionAgo: '1 sedmicu',
	      withPrepositionIn: '1 sedmicu'
	    },
	    dual: '{{count}} sedmice',
	    other: '{{count}} sedmice'
	  },
	  aboutXMonths: {
	    one: {
	      standalone: 'oko 1 mjesec',
	      withPrepositionAgo: 'oko 1 mjesec',
	      withPrepositionIn: 'oko 1 mjesec'
	    },
	    dual: 'oko {{count}} mjeseca',
	    other: 'oko {{count}} mjeseci'
	  },
	  xMonths: {
	    one: {
	      standalone: '1 mjesec',
	      withPrepositionAgo: '1 mjesec',
	      withPrepositionIn: '1 mjesec'
	    },
	    dual: '{{count}} mjeseca',
	    other: '{{count}} mjeseci'
	  },
	  aboutXYears: {
	    one: {
	      standalone: 'oko 1 godinu',
	      withPrepositionAgo: 'oko 1 godinu',
	      withPrepositionIn: 'oko 1 godinu'
	    },
	    dual: 'oko {{count}} godine',
	    other: 'oko {{count}} godina'
	  },
	  xYears: {
	    one: {
	      standalone: '1 godina',
	      withPrepositionAgo: '1 godine',
	      withPrepositionIn: '1 godinu'
	    },
	    dual: '{{count}} godine',
	    other: '{{count}} godina'
	  },
	  overXYears: {
	    one: {
	      standalone: 'preko 1 godinu',
	      withPrepositionAgo: 'preko 1 godinu',
	      withPrepositionIn: 'preko 1 godinu'
	    },
	    dual: 'preko {{count}} godine',
	    other: 'preko {{count}} godina'
	  },
	  almostXYears: {
	    one: {
	      standalone: 'gotovo 1 godinu',
	      withPrepositionAgo: 'gotovo 1 godinu',
	      withPrepositionIn: 'gotovo 1 godinu'
	    },
	    dual: 'gotovo {{count}} godine',
	    other: 'gotovo {{count}} godina'
	  }
	};
	
	var formatDistance = function (token, count, options) {
	  var result;
	  var tokenValue = formatDistanceLocale[token];
	
	  if (typeof tokenValue === 'string') {
	    result = tokenValue;
	  } else if (count === 1) {
	    if (options !== null && options !== void 0 && options.addSuffix) {
	      if (options.comparison && options.comparison > 0) {
	        result = tokenValue.one.withPrepositionIn;
	      } else {
	        result = tokenValue.one.withPrepositionAgo;
	      }
	    } else {
	      result = tokenValue.one.standalone;
	    }
	  } else if (count % 10 > 1 && count % 10 < 5 && // if last digit is between 2 and 4
	  String(count).substr(-2, 1) !== '1' // unless the 2nd to last digit is "1"
	  ) {
	      result = tokenValue.dual.replace('{{count}}', String(count));
	    } else {
	    result = tokenValue.other.replace('{{count}}', String(count));
	  }
	
	  if (options !== null && options !== void 0 && options.addSuffix) {
	    if (options.comparison && options.comparison > 0) {
	      return 'za ' + result;
	    } else {
	      return 'prije ' + result;
	    }
	  }
	
	  return result;
	};
	
	var _default = formatDistance;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1096 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: 'EEEE, d. MMMM yyyy.',
	  long: 'd. MMMM yyyy.',
	  medium: 'd. MMM yy.',
	  short: 'dd. MM. yy.'
	};
	var timeFormats = {
	  full: 'HH:mm:ss (zzzz)',
	  long: 'HH:mm:ss z',
	  medium: 'HH:mm:ss',
	  short: 'HH:mm'
	};
	var dateTimeFormats = {
	  full: "{{date}} 'u' {{time}}",
	  long: "{{date}} 'u' {{time}}",
	  medium: '{{date}} {{time}}',
	  short: '{{date}} {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1097 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var formatRelativeLocale = {
	  lastWeek: function (date) {
	    switch (date.getUTCDay()) {
	      case 0:
	        return "'prošle nedjelje u' p";
	
	      case 3:
	        return "'prošle srijede u' p";
	
	      case 6:
	        return "'prošle subote u' p";
	
	      default:
	        return "'prošli' EEEE 'u' p";
	    }
	  },
	  yesterday: "'juče u' p",
	  today: "'danas u' p",
	  tomorrow: "'sutra u' p",
	  nextWeek: function (date) {
	    switch (date.getUTCDay()) {
	      case 0:
	        return "'sljedeće nedjelje u' p";
	
	      case 3:
	        return "'sljedeću srijedu u' p";
	
	      case 6:
	        return "'sljedeću subotu u' p";
	
	      default:
	        return "'sljedeći' EEEE 'u' p";
	    }
	  },
	  other: 'P'
	};
	
	var formatRelative = function (token, date, _baseDate, _options) {
	  var format = formatRelativeLocale[token];
	
	  if (typeof format === 'function') {
	    return format(date);
	  }
	
	  return format;
	};
	
	var _default = formatRelative;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1098 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eraValues = {
	  narrow: ['pr.n.e.', 'AD'],
	  abbreviated: ['pr. Hr.', 'po. Hr.'],
	  wide: ['Prije Hrista', 'Poslije Hrista']
	};
	var quarterValues = {
	  narrow: ['1.', '2.', '3.', '4.'],
	  abbreviated: ['1. kv.', '2. kv.', '3. kv.', '4. kv.'],
	  wide: ['1. kvartal', '2. kvartal', '3. kvartal', '4. kvartal']
	};
	var monthValues = {
	  narrow: ['1.', '2.', '3.', '4.', '5.', '6.', '7.', '8.', '9.', '10.', '11.', '12.'],
	  abbreviated: ['jan', 'feb', 'mar', 'apr', 'maj', 'jun', 'jul', 'avg', 'sep', 'okt', 'nov', 'dec'],
	  wide: ['januar', 'februar', 'mart', 'april', 'maj', 'juni', 'juli', 'avgust', 'septembar', 'oktobar', 'novembar', 'decembar']
	};
	var formattingMonthValues = {
	  narrow: ['1.', '2.', '3.', '4.', '5.', '6.', '7.', '8.', '9.', '10.', '11.', '12.'],
	  abbreviated: ['jan', 'feb', 'mar', 'apr', 'maj', 'jun', 'jul', 'avg', 'sep', 'okt', 'nov', 'dec'],
	  wide: ['januar', 'februar', 'mart', 'april', 'maj', 'juni', 'juli', 'avgust', 'septembar', 'oktobar', 'novembar', 'decembar']
	};
	var dayValues = {
	  narrow: ['N', 'P', 'U', 'S', 'Č', 'P', 'S'],
	  short: ['ned', 'pon', 'uto', 'sre', 'čet', 'pet', 'sub'],
	  abbreviated: ['ned', 'pon', 'uto', 'sre', 'čet', 'pet', 'sub'],
	  wide: ['nedjelja', 'ponedjeljak', 'utorak', 'srijeda', 'četvrtak', 'petak', 'subota']
	};
	var dayPeriodValues = {
	  narrow: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'ponoć',
	    noon: 'podne',
	    morning: 'ujutru',
	    afternoon: 'popodne',
	    evening: 'uveče',
	    night: 'noću'
	  },
	  abbreviated: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'ponoć',
	    noon: 'podne',
	    morning: 'ujutru',
	    afternoon: 'popodne',
	    evening: 'uveče',
	    night: 'noću'
	  },
	  wide: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'ponoć',
	    noon: 'podne',
	    morning: 'ujutru',
	    afternoon: 'poslije podne',
	    evening: 'uveče',
	    night: 'noću'
	  }
	};
	var formattingDayPeriodValues = {
	  narrow: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'ponoć',
	    noon: 'podne',
	    morning: 'ujutru',
	    afternoon: 'popodne',
	    evening: 'uveče',
	    night: 'noću'
	  },
	  abbreviated: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'ponoć',
	    noon: 'podne',
	    morning: 'ujutru',
	    afternoon: 'popodne',
	    evening: 'uveče',
	    night: 'noću'
	  },
	  wide: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'ponoć',
	    noon: 'podne',
	    morning: 'ujutru',
	    afternoon: 'poslije podne',
	    evening: 'uveče',
	    night: 'noću'
	  }
	};
	
	var ordinalNumber = function (dirtyNumber, _options) {
	  var number = Number(dirtyNumber);
	  return String(number) + '.';
	};
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return quarter - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingMonthValues,
	    defaultFormattingWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingDayPeriodValues,
	    defaultFormattingWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1099 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(14));
	
	var _index2 = _interopRequireDefault(__webpack_require__(15));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(\d+)\./i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^(pr\.n\.e\.|AD)/i,
	  abbreviated: /^(pr\.\s?Hr\.|po\.\s?Hr\.)/i,
	  wide: /^(Prije Hrista|prije nove ere|Poslije Hrista|nova era)/i
	};
	var parseEraPatterns = {
	  any: [/^pr/i, /^(po|nova)/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^[1234]\.\s?kv\.?/i,
	  wide: /^[1234]\. kvartal/i
	};
	var parseQuarterPatterns = {
	  any: [/1/i, /2/i, /3/i, /4/i]
	};
	var matchMonthPatterns = {
	  narrow: /^(10|11|12|[123456789])\./i,
	  abbreviated: /^(jan|feb|mar|apr|maj|jun|jul|avg|sep|okt|nov|dec)/i,
	  wide: /^((januar|januara)|(februar|februara)|(mart|marta)|(april|aprila)|(maj|maja)|(juni|juna)|(juli|jula)|(avgust|avgusta)|(septembar|septembra)|(oktobar|oktobra)|(novembar|novembra)|(decembar|decembra))/i
	};
	var parseMonthPatterns = {
	  narrow: [/^1/i, /^2/i, /^3/i, /^4/i, /^5/i, /^6/i, /^7/i, /^8/i, /^9/i, /^10/i, /^11/i, /^12/i],
	  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^maj/i, /^jun/i, /^jul/i, /^avg/i, /^s/i, /^o/i, /^n/i, /^d/i]
	};
	var matchDayPatterns = {
	  narrow: /^[npusčc]/i,
	  short: /^(ned|pon|uto|sre|(čet|cet)|pet|sub)/i,
	  abbreviated: /^(ned|pon|uto|sre|(čet|cet)|pet|sub)/i,
	  wide: /^(nedjelja|ponedjeljak|utorak|srijeda|(četvrtak|cetvrtak)|petak|subota)/i
	};
	var parseDayPatterns = {
	  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
	  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
	};
	var matchDayPeriodPatterns = {
	  any: /^(am|pm|ponoc|ponoć|(po)?podne|uvece|uveče|noću|poslije podne|ujutru)/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^a/i,
	    pm: /^p/i,
	    midnight: /^pono/i,
	    noon: /^pod/i,
	    morning: /jutro/i,
	    afternoon: /(poslije\s|po)+podne/i,
	    evening: /(uvece|uveče)/i,
	    night: /(nocu|noću)/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index2.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1100 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1095));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1096));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1097));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1098));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1099));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Bosnian locale.
	 * @language Bosnian
	 * @iso-639-2 bos
	 * @author Branislav Lazić [@branislavlazic]{@link https://github.com/branislavlazic}
	 */
	var locale = {
	  code: 'bs',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 1
	    /* Monday */
	    ,
	    firstWeekContainsDate: 4
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1101 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistance;
	
	/**
	 * Davant de les xifres que es diuen amb vocal inicial, 1 i 11, s'apostrofen els articles el i la i la preposició de igual que si estiguessin escrits amb lletres.
	 *    l'1 de juliol ('l'u')
	 *    l'11 de novembre ('l'onze')
	 *    l'11a clàusula del contracte ('l'onzena')
	 *    la contractació d'11 jugadors ('d'onze')
	 *    l'aval d'11.000 socis ('d'onze mil')
	 *
	 * Reference: https://aplicacions.llengua.gencat.cat/llc/AppJava/index.html?input_cercar=apostrofaci%25F3+davant+xifres&action=Principal&method=detall_completa&numPagina=1&idHit=11236&database=FITXES_PUB&tipusFont=Fitxes%20de%20l%27Optimot&idFont=11236&titol=apostrofaci%F3%20davant%20de%20xifres%20%2F%20apostrofaci%F3%20davant%20de%201%20i%2011&numeroResultat=1&clickLink=detall&tipusCerca=cerca.normes
	 */
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    one: "menys d'un segon",
	    eleven: "menys d'onze segons",
	    other: 'menys de {{count}} segons'
	  },
	  xSeconds: {
	    one: '1 segon',
	    other: '{{count}} segons'
	  },
	  halfAMinute: 'mig minut',
	  lessThanXMinutes: {
	    one: "menys d'un minut",
	    eleven: "menys d'onze minuts",
	    other: 'menys de {{count}} minuts'
	  },
	  xMinutes: {
	    one: '1 minut',
	    other: '{{count}} minuts'
	  },
	  aboutXHours: {
	    one: 'aproximadament una hora',
	    other: 'aproximadament {{count}} hores'
	  },
	  xHours: {
	    one: '1 hora',
	    other: '{{count}} hores'
	  },
	  xDays: {
	    one: '1 dia',
	    other: '{{count}} dies'
	  },
	  aboutXWeeks: {
	    one: 'aproximadament una setmana',
	    other: 'aproximadament {{count}} setmanes'
	  },
	  xWeeks: {
	    one: '1 setmana',
	    other: '{{count}} setmanes'
	  },
	  aboutXMonths: {
	    one: 'aproximadament un mes',
	    other: 'aproximadament {{count}} mesos'
	  },
	  xMonths: {
	    one: '1 mes',
	    other: '{{count}} mesos'
	  },
	  aboutXYears: {
	    one: 'aproximadament un any',
	    other: 'aproximadament {{count}} anys'
	  },
	  xYears: {
	    one: '1 any',
	    other: '{{count}} anys'
	  },
	  overXYears: {
	    one: "més d'un any",
	    eleven: "més d'onze anys",
	    other: 'més de {{count}} anys'
	  },
	  almostXYears: {
	    one: 'gairebé un any',
	    other: 'gairebé {{count}} anys'
	  }
	};
	
	function formatDistance(token, count, options) {
	  options = options || {};
	  var result;
	
	  if (typeof formatDistanceLocale[token] === 'string') {
	    result = formatDistanceLocale[token];
	  } else if (count === 1) {
	    result = formatDistanceLocale[token].one;
	  } else if (count === 11 && formatDistanceLocale[token].eleven) {
	    result = formatDistanceLocale[token].eleven;
	  } else {
	    result = formatDistanceLocale[token].other.replace('{{count}}', count);
	  }
	
	  if (options.addSuffix) {
	    if (options.comparison > 0) {
	      return 'en ' + result;
	    } else {
	      return 'fa ' + result;
	    }
	  }
	
	  return result;
	}
	
	module.exports = exports.default;

/***/ },
/* 1102 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: "EEEE, d 'de' MMMM y",
	  long: "d 'de' MMMM y",
	  medium: 'd MMM y',
	  short: 'dd/MM/y'
	};
	var timeFormats = {
	  full: 'HH:mm:ss zzzz',
	  long: 'HH:mm:ss z',
	  medium: 'HH:mm:ss',
	  short: 'HH:mm'
	};
	var dateTimeFormats = {
	  full: "{{date}} 'a les' {{time}}",
	  long: "{{date}} 'a les' {{time}}",
	  medium: '{{date}}, {{time}}',
	  short: '{{date}}, {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1103 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRelative;
	var formatRelativeLocale = {
	  lastWeek: "'el' eeee 'passat a la' LT",
	  yesterday: "'ahir a la' p",
	  today: "'avui a la' p",
	  tomorrow: "'demà a la' p",
	  nextWeek: "eeee 'a la' p",
	  other: 'P'
	};
	var formatRelativeLocalePlural = {
	  lastWeek: "'el' eeee 'passat a les' p",
	  yesterday: "'ahir a les' p",
	  today: "'avui a les' p",
	  tomorrow: "'demà a les' p",
	  nextWeek: "eeee 'a les' p",
	  other: 'P'
	};
	
	function formatRelative(token, date, _baseDate, _options) {
	  if (date.getUTCHours() !== 1) {
	    return formatRelativeLocalePlural[token];
	  }
	
	  return formatRelativeLocale[token];
	}
	
	module.exports = exports.default;

/***/ },
/* 1104 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * General information
	 * Reference: https://aplicacions.llengua.gencat.cat
	 * Reference: https://www.uoc.edu/portal/ca/servei-linguistic/convencions/abreviacions/simbols/simbols-habituals.html
	 */
	
	/**
	 * Abans de Crist: https://aplicacions.llengua.gencat.cat/llc/AppJava/index.html?input_cercar=abans+de+crist&action=Principal&method=detall_completa&numPagina=1&idHit=6876&database=FITXES_PUB&tipusFont=Fitxes%20de%20l%27Optimot&idFont=6876&titol=abans%20de%20Crist%20(abreviatura)%20/%20abans%20de%20Crist%20(sigla)&numeroResultat=1&clickLink=detall&tipusCerca=cerca.fitxes
	 * Desprest de Crist: https://aplicacions.llengua.gencat.cat/llc/AppJava/index.html?input_cercar=despr%E9s+de+crist&action=Principal&method=detall_completa&numPagina=1&idHit=6879&database=FITXES_PUB&tipusFont=Fitxes%20de%20l%27Optimot&idFont=6879&titol=despr%E9s%20de%20Crist%20(sigla)%20/%20despr%E9s%20de%20Crist%20(abreviatura)&numeroResultat=1&clickLink=detall&tipusCerca=cerca.fitxes
	 */
	var eraValues = {
	  narrow: ['aC', 'dC'],
	  abbreviated: ['a. de C.', 'd. de C.'],
	  wide: ['abans de Crist', 'després de Crist']
	};
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['T1', 'T2', 'T3', 'T4'],
	  wide: ['1r trimestre', '2n trimestre', '3r trimestre', '4t trimestre']
	};
	/**
	 * Dins d'un text convé fer servir la forma sencera dels mesos, ja que sempre és més clar el mot sencer que l'abreviatura, encara que aquesta sigui força coneguda.
	 * Cal reservar, doncs, les abreviatures per a les llistes o classificacions, els gràfics, les taules o quadres estadístics, els textos publicitaris, etc.
	 *
	 * Reference: https://aplicacions.llengua.gencat.cat/llc/AppJava/index.html?input_cercar=abreviacions+mesos&action=Principal&method=detall_completa&numPagina=1&idHit=8402&database=FITXES_PUB&tipusFont=Fitxes%20de%20l%27Optimot&idFont=8402&titol=abreviatures%20dels%20mesos%20de%20l%27any&numeroResultat=5&clickLink=detall&tipusCerca=cerca.fitxes
	 */
	
	var monthValues = {
	  narrow: ['GN', 'FB', 'MÇ', 'AB', 'MG', 'JN', 'JL', 'AG', 'ST', 'OC', 'NV', 'DS'],
	
	  /**
	   * Les abreviatures dels mesos de l'any es formen seguint una de les normes generals de formació d'abreviatures.
	   * S'escriu la primera síl·laba i les consonants de la síl·laba següent anteriors a la primera vocal.
	   * Els mesos de març, maig i juny no s'abreugen perquè són paraules d'una sola síl·laba.
	   */
	  abbreviated: ['gen.', 'febr.', 'març', 'abr.', 'maig', 'juny', 'jul.', 'ag.', 'set.', 'oct.', 'nov.', 'des.'],
	  wide: ['gener', 'febrer', 'març', 'abril', 'maig', 'juny', 'juliol', 'agost', 'setembre', 'octubre', 'novembre', 'desembre']
	};
	/**
	 * Les abreviatures dels dies de la setmana comencen totes amb la lletra d.
	 * Tot seguit porten la consonant següent a la i, excepte en el cas de dimarts, dimecres i diumenge, en què aquesta consonant és la m i, per tant, hi podria haver confusió.
	 * Per evitar-ho, s'ha substituït la m per una t (en el cas de dimarts), una c (en el cas de dimecres) i una g (en el cas de diumenge), respectivament.
	 *
	 * Seguint la norma general d'ús de les abreviatures, les dels dies de la setmana sempre porten punt final.
	 * Igualment, van amb la primera lletra en majúscula quan la paraula sencera també hi aniria.
	 * En canvi, van amb la primera lletra en minúscula quan la inicial de la paraula sencera també hi aniria.
	 *
	 * Reference: https://aplicacions.llengua.gencat.cat/llc/AppJava/index.html?input_cercar=abreviatures+dies&action=Principal&method=detall_completa&numPagina=1&idHit=8387&database=FITXES_PUB&tipusFont=Fitxes%20de%20l%27Optimot&idFont=8387&titol=abreviatures%20dels%20dies%20de%20la%20setmana&numeroResultat=1&clickLink=detall&tipusCerca=cerca.tot
	 */
	
	var dayValues = {
	  narrow: ['dg.', 'dl.', 'dt.', 'dm.', 'dj.', 'dv.', 'ds.'],
	  short: ['dg.', 'dl.', 'dt.', 'dm.', 'dj.', 'dv.', 'ds.'],
	  abbreviated: ['dg.', 'dl.', 'dt.', 'dm.', 'dj.', 'dv.', 'ds.'],
	  wide: ['diumenge', 'dilluns', 'dimarts', 'dimecres', 'dijous', 'divendres', 'dissabte']
	};
	/**
	 * Reference: https://aplicacions.llengua.gencat.cat/llc/AppJava/index.html?action=Principal&method=detall&input_cercar=parts+del+dia&numPagina=1&database=FITXES_PUB&idFont=12801&idHit=12801&tipusFont=Fitxes+de+l%27Optimot&numeroResultat=1&databases_avansada=&categories_avansada=&clickLink=detall&titol=Nom+de+les+parts+del+dia&tematica=&tipusCerca=cerca.fitxes
	 */
	
	var dayPeriodValues = {
	  narrow: {
	    am: 'am',
	    pm: 'pm',
	    midnight: 'mitjanit',
	    noon: 'migdia',
	    morning: 'matí',
	    afternoon: 'tarda',
	    evening: 'vespre',
	    night: 'nit'
	  },
	  abbreviated: {
	    am: 'a.m.',
	    pm: 'p.m.',
	    midnight: 'mitjanit',
	    noon: 'migdia',
	    morning: 'matí',
	    afternoon: 'tarda',
	    evening: 'vespre',
	    night: 'nit'
	  },
	  wide: {
	    am: 'ante meridiem',
	    pm: 'post meridiem',
	    midnight: 'mitjanit',
	    noon: 'migdia',
	    morning: 'matí',
	    afternoon: 'tarda',
	    evening: 'vespre',
	    night: 'nit'
	  }
	};
	var formattingDayPeriodValues = {
	  narrow: {
	    am: 'am',
	    pm: 'pm',
	    midnight: 'de la mitjanit',
	    noon: 'del migdia',
	    morning: 'del matí',
	    afternoon: 'de la tarda',
	    evening: 'del vespre',
	    night: 'de la nit'
	  },
	  abbreviated: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'de la mitjanit',
	    noon: 'del migdia',
	    morning: 'del matí',
	    afternoon: 'de la tarda',
	    evening: 'del vespre',
	    night: 'de la nit'
	  },
	  wide: {
	    am: 'ante meridiem',
	    pm: 'post meridiem',
	    midnight: 'de la mitjanit',
	    noon: 'del migdia',
	    morning: 'del matí',
	    afternoon: 'de la tarda',
	    evening: 'del vespre',
	    night: 'de la nit'
	  }
	};
	/**
	 * Quan van en singular, els nombres ordinals es representen, en forma d’abreviatura, amb la xifra seguida de l’última lletra del mot desplegat.
	 * És optatiu posar punt després de la lletra.
	 *
	 * Reference: https://aplicacions.llengua.gencat.cat/llc/AppJava/pdf/abrevia.pdf#page=18
	 *
	 * @param {Number} dirtyNumber
	 * @param {Object} [_dirtyOptions]
	 */
	
	function ordinalNumber(dirtyNumber, _dirtyOptions) {
	  var number = Number(dirtyNumber);
	  var rem100 = number % 100;
	
	  if (rem100 > 20 || rem100 < 10) {
	    switch (rem100 % 10) {
	      case 1:
	        return number + 'r';
	
	      case 2:
	        return number + 'n';
	
	      case 3:
	        return number + 'r';
	
	      case 4:
	        return number + 't';
	    }
	  }
	
	  return number + 'è';
	}
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingDayPeriodValues,
	    defaultFormattingWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1105 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(14));
	
	var _index2 = _interopRequireDefault(__webpack_require__(15));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(\d+)(è|r|n|r|t)?/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^(aC|dC)/i,
	  abbreviated: /^(a. de C.|d. de C.)/i,
	  wide: /^(abans de Crist|despr[eé]s de Crist)/i
	};
	var parseEraPatterns = {
	  narrow: [/^aC/i, /^dC/i],
	  abbreviated: [/^(a. de C.)/i, /^(d. de C.)/i],
	  wide: [/^(abans de Crist)/i, /^(despr[eé]s de Crist)/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^T[1234]/i,
	  wide: /^[1234](è|r|n|r|t)? trimestre/i
	};
	var parseQuarterPatterns = {
	  any: [/1/i, /2/i, /3/i, /4/i]
	};
	var matchMonthPatterns = {
	  narrow: /^(GN|FB|MÇ|AB|MG|JN|JL|AG|ST|OC|NV|DS)/i,
	  abbreviated: /^(gen.|febr.|març|abr.|maig|juny|jul.|ag.|set.|oct.|nov.|des.)/i,
	  wide: /^(gener|febrer|març|abril|maig|juny|juliol|agost|setembre|octubre|novembre|desembre)/i
	};
	var parseMonthPatterns = {
	  narrow: [/^GN/i, /^FB/i, /^MÇ/i, /^AB/i, /^MG/i, /^JN/i, /^JL/i, /^AG/i, /^ST/i, /^OC/i, /^NV/i, /^DS/i],
	  abbreviated: [/^gen./i, /^febr./i, /^març/i, /^abr./i, /^maig/i, /^juny/i, /^jul./i, /^ag./i, /^set./i, /^oct./i, /^nov./i, /^des./i],
	  wide: [/^gener/i, /^febrer/i, /^març/i, /^abril/i, /^maig/i, /^juny/i, /^juliol/i, /^agost/i, /^setembre/i, /^octubre/i, /^novembre/i, /^desembre/i]
	};
	var matchDayPatterns = {
	  narrow: /^(dg\.|dl\.|dt\.|dm\.|dj\.|dv\.|ds\.)/i,
	  short: /^(dg\.|dl\.|dt\.|dm\.|dj\.|dv\.|ds\.)/i,
	  abbreviated: /^(dg\.|dl\.|dt\.|dm\.|dj\.|dv\.|ds\.)/i,
	  wide: /^(diumenge|dilluns|dimarts|dimecres|dijous|divendres|dissabte)/i
	};
	var parseDayPatterns = {
	  narrow: [/^dg./i, /^dl./i, /^dt./i, /^dm./i, /^dj./i, /^dv./i, /^ds./i],
	  abbreviated: [/^dg./i, /^dl./i, /^dt./i, /^dm./i, /^dj./i, /^dv./i, /^ds./i],
	  wide: [/^diumenge/i, /^dilluns/i, /^dimarts/i, /^dimecres/i, /^dijous/i, /^divendres/i, /^disssabte/i]
	};
	var matchDayPeriodPatterns = {
	  narrow: /^(a|p|mn|md|(del|de la) (matí|tarda|vespre|nit))/i,
	  abbreviated: /^([ap]\.?\s?m\.?|mitjanit|migdia|(del|de la) (matí|tarda|vespre|nit))/i,
	  wide: /^(ante meridiem|post meridiem|mitjanit|migdia|(del|de la) (matí|tarda|vespre|nit))/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^a/i,
	    pm: /^p/i,
	    midnight: /^mitjanit/i,
	    noon: /^migdia/i,
	    morning: /matí/i,
	    afternoon: /tarda/i,
	    evening: /vespre/i,
	    night: /nit/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index2.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1106 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1101));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1102));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1103));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1104));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1105));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Catalan locale.
	 * @language Catalan
	 * @iso-639-2 cat
	 * @author Guillermo Grau [@guigrpa]{@link https://github.com/guigrpa}
	 * @author Alex Vizcaino [@avizcaino]{@link https://github.com/avizcaino}
	 */
	var locale = {
	  code: 'ca',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 1
	    /* Monday */
	    ,
	    firstWeekContainsDate: 4
	  }
	};
	var _default = locale; // throw new Error('ca locale is currently unavailable. Please check the progress of converting this locale to v2.0.0 in this issue on Github: TBA')
	
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1107 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistance;
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    one: {
	      regular: 'méně než sekunda',
	      past: 'před méně než sekundou',
	      future: 'za méně než sekundu'
	    },
	    few: {
	      regular: 'méně než {{count}} sekundy',
	      past: 'před méně než {{count}} sekundami',
	      future: 'za méně než {{count}} sekundy'
	    },
	    many: {
	      regular: 'méně než {{count}} sekund',
	      past: 'před méně než {{count}} sekundami',
	      future: 'za méně než {{count}} sekund'
	    }
	  },
	  xSeconds: {
	    one: {
	      regular: 'sekunda',
	      past: 'před sekundou',
	      future: 'za sekundu'
	    },
	    few: {
	      regular: '{{count}} sekundy',
	      past: 'před {{count}} sekundami',
	      future: 'za {{count}} sekundy'
	    },
	    many: {
	      regular: '{{count}} sekund',
	      past: 'před {{count}} sekundami',
	      future: 'za {{count}} sekund'
	    }
	  },
	  halfAMinute: {
	    other: {
	      regular: 'půl minuty',
	      past: 'před půl minutou',
	      future: 'za půl minuty'
	    }
	  },
	  lessThanXMinutes: {
	    one: {
	      regular: 'méně než minuta',
	      past: 'před méně než minutou',
	      future: 'za méně než minutu'
	    },
	    few: {
	      regular: 'méně než {{count}} minuty',
	      past: 'před méně než {{count}} minutami',
	      future: 'za méně než {{count}} minuty'
	    },
	    many: {
	      regular: 'méně než {{count}} minut',
	      past: 'před méně než {{count}} minutami',
	      future: 'za méně než {{count}} minut'
	    }
	  },
	  xMinutes: {
	    one: {
	      regular: 'minuta',
	      past: 'před minutou',
	      future: 'za minutu'
	    },
	    few: {
	      regular: '{{count}} minuty',
	      past: 'před {{count}} minutami',
	      future: 'za {{count}} minuty'
	    },
	    many: {
	      regular: '{{count}} minut',
	      past: 'před {{count}} minutami',
	      future: 'za {{count}} minut'
	    }
	  },
	  aboutXHours: {
	    one: {
	      regular: 'přibližně hodina',
	      past: 'přibližně před hodinou',
	      future: 'přibližně za hodinu'
	    },
	    few: {
	      regular: 'přibližně {{count}} hodiny',
	      past: 'přibližně před {{count}} hodinami',
	      future: 'přibližně za {{count}} hodiny'
	    },
	    many: {
	      regular: 'přibližně {{count}} hodin',
	      past: 'přibližně před {{count}} hodinami',
	      future: 'přibližně za {{count}} hodin'
	    }
	  },
	  xHours: {
	    one: {
	      regular: 'hodina',
	      past: 'před hodinou',
	      future: 'za hodinu'
	    },
	    few: {
	      regular: '{{count}} hodiny',
	      past: 'před {{count}} hodinami',
	      future: 'za {{count}} hodiny'
	    },
	    many: {
	      regular: '{{count}} hodin',
	      past: 'před {{count}} hodinami',
	      future: 'za {{count}} hodin'
	    }
	  },
	  xDays: {
	    one: {
	      regular: 'den',
	      past: 'před dnem',
	      future: 'za den'
	    },
	    few: {
	      regular: '{{count}} dny',
	      past: 'před {{count}} dny',
	      future: 'za {{count}} dny'
	    },
	    many: {
	      regular: '{{count}} dní',
	      past: 'před {{count}} dny',
	      future: 'za {{count}} dní'
	    }
	  },
	  aboutXWeeks: {
	    one: {
	      regular: 'přibližně týden',
	      past: 'přibližně před týdnem',
	      future: 'přibližně za týden'
	    },
	    few: {
	      regular: 'přibližně {{count}} týdny',
	      past: 'přibližně před {{count}} týdny',
	      future: 'přibližně za {{count}} týdny'
	    },
	    many: {
	      regular: 'přibližně {{count}} týdnů',
	      past: 'přibližně před {{count}} týdny',
	      future: 'přibližně za {{count}} týdnů'
	    }
	  },
	  xWeeks: {
	    one: {
	      regular: 'týden',
	      past: 'před týdnem',
	      future: 'za týden'
	    },
	    few: {
	      regular: '{{count}} týdny',
	      past: 'před {{count}} týdny',
	      future: 'za {{count}} týdny'
	    },
	    many: {
	      regular: '{{count}} týdnů',
	      past: 'před {{count}} týdny',
	      future: 'za {{count}} týdnů'
	    }
	  },
	  aboutXMonths: {
	    one: {
	      regular: 'přibližně měsíc',
	      past: 'přibližně před měsícem',
	      future: 'přibližně za měsíc'
	    },
	    few: {
	      regular: 'přibližně {{count}} měsíce',
	      past: 'přibližně před {{count}} měsíci',
	      future: 'přibližně za {{count}} měsíce'
	    },
	    many: {
	      regular: 'přibližně {{count}} měsíců',
	      past: 'přibližně před {{count}} měsíci',
	      future: 'přibližně za {{count}} měsíců'
	    }
	  },
	  xMonths: {
	    one: {
	      regular: 'měsíc',
	      past: 'před měsícem',
	      future: 'za měsíc'
	    },
	    few: {
	      regular: '{{count}} měsíce',
	      past: 'před {{count}} měsíci',
	      future: 'za {{count}} měsíce'
	    },
	    many: {
	      regular: '{{count}} měsíců',
	      past: 'před {{count}} měsíci',
	      future: 'za {{count}} měsíců'
	    }
	  },
	  aboutXYears: {
	    one: {
	      regular: 'přibližně rok',
	      past: 'přibližně před rokem',
	      future: 'přibližně za rok'
	    },
	    few: {
	      regular: 'přibližně {{count}} roky',
	      past: 'přibližně před {{count}} roky',
	      future: 'přibližně za {{count}} roky'
	    },
	    many: {
	      regular: 'přibližně {{count}} roků',
	      past: 'přibližně před {{count}} roky',
	      future: 'přibližně za {{count}} roků'
	    }
	  },
	  xYears: {
	    one: {
	      regular: 'rok',
	      past: 'před rokem',
	      future: 'za rok'
	    },
	    few: {
	      regular: '{{count}} roky',
	      past: 'před {{count}} roky',
	      future: 'za {{count}} roky'
	    },
	    many: {
	      regular: '{{count}} roků',
	      past: 'před {{count}} roky',
	      future: 'za {{count}} roků'
	    }
	  },
	  overXYears: {
	    one: {
	      regular: 'více než rok',
	      past: 'před více než rokem',
	      future: 'za více než rok'
	    },
	    few: {
	      regular: 'více než {{count}} roky',
	      past: 'před více než {{count}} roky',
	      future: 'za více než {{count}} roky'
	    },
	    many: {
	      regular: 'více než {{count}} roků',
	      past: 'před více než {{count}} roky',
	      future: 'za více než {{count}} roků'
	    }
	  },
	  almostXYears: {
	    one: {
	      regular: 'skoro rok',
	      past: 'skoro před rokem',
	      future: 'skoro za rok'
	    },
	    few: {
	      regular: 'skoro {{count}} roky',
	      past: 'skoro před {{count}} roky',
	      future: 'skoro za {{count}} roky'
	    },
	    many: {
	      regular: 'skoro {{count}} roků',
	      past: 'skoro před {{count}} roky',
	      future: 'skoro za {{count}} roků'
	    }
	  }
	};
	
	function formatDistance(token, count, options) {
	  options = options || {};
	  var scheme = formatDistanceLocale[token]; // cs pluralization
	
	  var pluralToken;
	
	  if (typeof scheme.other === 'object') {
	    pluralToken = 'other';
	  } else if (count === 1) {
	    pluralToken = 'one';
	  } else if (count > 1 && count < 5) {
	    pluralToken = 'few';
	  } else {
	    pluralToken = 'many';
	  } // times
	
	
	  var suffixExist = options.addSuffix === true;
	  var comparison = options.comparison;
	  var timeToken;
	
	  if (suffixExist && comparison === -1) {
	    timeToken = 'past';
	  } else if (suffixExist && comparison === 1) {
	    timeToken = 'future';
	  } else {
	    timeToken = 'regular';
	  }
	
	  return scheme[pluralToken][timeToken].replace('{{count}}', count);
	}
	
	module.exports = exports.default;

/***/ },
/* 1108 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: 'EEEE, d. MMMM yyyy',
	  long: 'd. MMMM yyyy',
	  medium: 'd. M. yyyy',
	  short: 'dd.MM.yyyy'
	};
	var timeFormats = {
	  full: 'H:mm:ss zzzz',
	  long: 'H:mm:ss z',
	  medium: 'H:mm:ss',
	  short: 'H:mm'
	};
	var dateTimeFormats = {
	  full: "{{date}} 'v' {{time}}",
	  long: "{{date}} 'v' {{time}}",
	  medium: '{{date}}, {{time}}',
	  short: '{{date}}, {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1109 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRelative;
	var accusativeWeekdays = ['neděli', 'pondělí', 'úterý', 'středu', 'čtvrtek', 'pátek', 'sobotu'];
	var formatRelativeLocale = {
	  lastWeek: "'poslední' eeee 've' p",
	  yesterday: "'včera v' p",
	  today: "'dnes v' p",
	  tomorrow: "'zítra v' p",
	  nextWeek: function (date, _baseDate, _options) {
	    var day = date.getUTCDay();
	    return "'v " + accusativeWeekdays[day] + " o' p";
	  },
	  other: 'P'
	};
	
	function formatRelative(token, date, baseDate, options) {
	  var format = formatRelativeLocale[token];
	
	  if (typeof format === 'function') {
	    return format(date, baseDate, options);
	  }
	
	  return format;
	}
	
	module.exports = exports.default;

/***/ },
/* 1110 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eraValues = {
	  narrow: ['př. n. l.', 'n. l.'],
	  abbreviated: ['př. n. l.', 'n. l.'],
	  wide: ['před naším letopočtem', 'našeho letopočtu']
	};
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['1. čtvrtletí', '2. čtvrtletí', '3. čtvrtletí', '4. čtvrtletí'],
	  wide: ['1. čtvrtletí', '2. čtvrtletí', '3. čtvrtletí', '4. čtvrtletí']
	};
	var monthValues = {
	  narrow: ['L', 'Ú', 'B', 'D', 'K', 'Č', 'Č', 'S', 'Z', 'Ř', 'L', 'P'],
	  abbreviated: ['led', 'úno', 'bře', 'dub', 'kvě', 'čvn', 'čvc', 'srp', 'zář', 'říj', 'lis', 'pro'],
	  wide: ['leden', 'únor', 'březen', 'duben', 'květen', 'červen', 'červenec', 'srpen', 'září', 'říjen', 'listopad', 'prosinec']
	};
	var formattingMonthValues = {
	  narrow: ['L', 'Ú', 'B', 'D', 'K', 'Č', 'Č', 'S', 'Z', 'Ř', 'L', 'P'],
	  abbreviated: ['led', 'úno', 'bře', 'dub', 'kvě', 'čvn', 'čvc', 'srp', 'zář', 'říj', 'lis', 'pro'],
	  wide: ['ledna', 'února', 'března', 'dubna', 'května', 'června', 'července', 'srpna', 'září', 'října', 'listopadu', 'prosince']
	};
	var dayValues = {
	  narrow: ['ne', 'po', 'út', 'st', 'čt', 'pá', 'so'],
	  short: ['ne', 'po', 'út', 'st', 'čt', 'pá', 'so'],
	  abbreviated: ['ned', 'pon', 'úte', 'stř', 'čtv', 'pát', 'sob'],
	  wide: ['neděle', 'pondělí', 'úterý', 'středa', 'čtvrtek', 'pátek', 'sobota']
	};
	var dayPeriodValues = {
	  narrow: {
	    am: 'dop.',
	    pm: 'odp.',
	    midnight: 'půlnoc',
	    noon: 'poledne',
	    morning: 'ráno',
	    afternoon: 'odpoledne',
	    evening: 'večer',
	    night: 'noc'
	  },
	  abbreviated: {
	    am: 'dop.',
	    pm: 'odp.',
	    midnight: 'půlnoc',
	    noon: 'poledne',
	    morning: 'ráno',
	    afternoon: 'odpoledne',
	    evening: 'večer',
	    night: 'noc'
	  },
	  wide: {
	    am: 'dopoledne',
	    pm: 'odpoledne',
	    midnight: 'půlnoc',
	    noon: 'poledne',
	    morning: 'ráno',
	    afternoon: 'odpoledne',
	    evening: 'večer',
	    night: 'noc'
	  }
	};
	var formattingDayPeriodValues = {
	  narrow: {
	    am: 'dop.',
	    pm: 'odp.',
	    midnight: 'půlnoc',
	    noon: 'poledne',
	    morning: 'ráno',
	    afternoon: 'odpoledne',
	    evening: 'večer',
	    night: 'noc'
	  },
	  abbreviated: {
	    am: 'dop.',
	    pm: 'odp.',
	    midnight: 'půlnoc',
	    noon: 'poledne',
	    morning: 'ráno',
	    afternoon: 'odpoledne',
	    evening: 'večer',
	    night: 'noc'
	  },
	  wide: {
	    am: 'dopoledne',
	    pm: 'odpoledne',
	    midnight: 'půlnoc',
	    noon: 'poledne',
	    morning: 'ráno',
	    afternoon: 'odpoledne',
	    evening: 'večer',
	    night: 'noc'
	  }
	};
	
	function ordinalNumber(dirtyNumber) {
	  var number = Number(dirtyNumber);
	  return number + '.';
	}
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingMonthValues,
	    defaultFormattingWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingDayPeriodValues,
	    defaultFormattingWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1111 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(14));
	
	var _index2 = _interopRequireDefault(__webpack_require__(15));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(\d+)\.?/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^(p[řr]ed Kr\.|pred n\. l\.|po Kr\.|n\. l\.)/i,
	  abbreviated: /^(pe[řr]ed Kr\.|pe[řr]ed n\. l\.|po Kr\.|n\. l\.)/i,
	  wide: /^(p[řr]ed Kristem|pred na[šs][íi]m letopo[čc]tem|po Kristu|na[šs]eho letopo[čc]tu)/i
	};
	var parseEraPatterns = {
	  any: [/^p[řr]/i, /^(po|n)/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^[1234]\. [čc]tvrtlet[íi]/i,
	  wide: /^[1234]\. [čc]tvrtlet[íi]/i
	};
	var parseQuarterPatterns = {
	  any: [/1/i, /2/i, /3/i, /4/i]
	};
	var matchMonthPatterns = {
	  narrow: /^[lúubdkčcszřrlp]/i,
	  abbreviated: /^(led|[úu]no|b[řr]e|dub|kv[ěe]|[čc]vn|[čc]vc|srp|z[áa][řr]|[řr][íi]j|lis|pro)/i,
	  wide: /^(leden|ledna|[úu]nora?|b[řr]ezen|b[řr]ezna|duben|dubna|kv[ěe]ten|kv[ěe]tna|[čc]erven(ec|ce)?|[čc]ervna|srpen|srpna|z[áa][řr][íi]|[řr][íi]jen|[řr][íi]jna|listopad(a|u)?|prosinec|prosince)/i
	};
	var parseMonthPatterns = {
	  narrow: [/^l/i, /^[úu]/i, /^b/i, /^d/i, /^k/i, /^[čc]/i, /^[čc]/i, /^s/i, /^z/i, /^[řr]/i, /^l/i, /^p/i],
	  any: [/^led/i, /^[úu]n/i, /^b[řr]e/i, /^dub/i, /^kv[ěe]/i, /^[čc]vn|[čc]erven(?!\w)|[čc]ervna/i, /^[čc]vc|[čc]erven(ec|ce)/i, /^srp/i, /^z[áa][řr]/i, /^[řr][íi]j/i, /^lis/i, /^pro/i]
	};
	var matchDayPatterns = {
	  narrow: /^[npuúsčps]/i,
	  short: /^(ne|po|[úu]t|st|[čc]t|p[áa]|so)/i,
	  abbreviated: /^(ne|po|[úu]t|st|[čc]t|p[áa]|so)/i,
	  wide: /^(ned[ěe]le|pond[ěe]l[íi]|[úu]ter[ýy]|st[řr]eda|[čc]tvrtek|p[áa]tek|sobota)/i
	};
	var parseDayPatterns = {
	  narrow: [/^n/i, /^p/i, /^[úu]/i, /^s/i, /^[čc]/i, /^p/i, /^s/i],
	  any: [/^ne/i, /^po/i, /^ut/i, /^st/i, /^[čc]t/i, /^p/i, /^so/i]
	};
	var matchDayPeriodPatterns = {
	  any: /^dopoledne|dop\.?|odpoledne|odp\.?|půlnoc|poledne|r[áa]no|odpoledne|ve[čc]er|(v )?noci/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^dop/i,
	    pm: /^odp/i,
	    midnight: /^p[ůu]lnoc/i,
	    noon: /^poledne/i,
	    morning: /r[áa]no/i,
	    afternoon: /odpoledne/i,
	    evening: /ve[čc]er/i,
	    night: /noc/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index2.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1112 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1107));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1108));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1109));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1110));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1111));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Czech locale.
	 * @language Czech
	 * @iso-639-2 ces
	 * @author David Rus [@davidrus]{@link https://github.com/davidrus}
	 * @author Pavel Hrách [@SilenY]{@link https://github.com/SilenY}
	 * @author Jozef Bíroš [@JozefBiros]{@link https://github.com/JozefBiros}
	 */
	var locale = {
	  code: 'cs',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 1
	    /* Monday */
	    ,
	    firstWeekContainsDate: 4
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1113 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistance;
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    one: 'llai na eiliad',
	    other: 'llai na {{count}} eiliad'
	  },
	  xSeconds: {
	    one: '1 eiliad',
	    other: '{{count}} eiliad'
	  },
	  halfAMinute: 'hanner munud',
	  lessThanXMinutes: {
	    one: 'llai na munud',
	    two: 'llai na 2 funud',
	    other: 'llai na {{count}} munud'
	  },
	  xMinutes: {
	    one: '1 munud',
	    two: '2 funud',
	    other: '{{count}} munud'
	  },
	  aboutXHours: {
	    one: 'tua 1 awr',
	    other: 'tua {{count}} awr'
	  },
	  xHours: {
	    one: '1 awr',
	    other: '{{count}} awr'
	  },
	  xDays: {
	    one: '1 diwrnod',
	    two: '2 ddiwrnod',
	    other: '{{count}} diwrnod'
	  },
	  aboutXWeeks: {
	    one: 'tua 1 wythnos',
	    two: 'tua pythefnos',
	    other: 'tua {{count}} wythnos'
	  },
	  xWeeks: {
	    one: '1 wythnos',
	    two: 'pythefnos',
	    other: '{{count}} wythnos'
	  },
	  aboutXMonths: {
	    one: 'tua 1 mis',
	    two: 'tua 2 fis',
	    other: 'tua {{count}} mis'
	  },
	  xMonths: {
	    one: '1 mis',
	    two: '2 fis',
	    other: '{{count}} mis'
	  },
	  aboutXYears: {
	    one: 'tua 1 flwyddyn',
	    two: 'tua 2 flynedd',
	    other: 'tua {{count}} mlynedd'
	  },
	  xYears: {
	    one: '1 flwyddyn',
	    two: '2 flynedd',
	    other: '{{count}} mlynedd'
	  },
	  overXYears: {
	    one: 'dros 1 flwyddyn',
	    two: 'dros 2 flynedd',
	    other: 'dros {{count}} mlynedd'
	  },
	  almostXYears: {
	    one: 'bron 1 flwyddyn',
	    two: 'bron 2 flynedd',
	    other: 'bron {{count}} mlynedd'
	  }
	};
	
	function formatDistance(token, count, options) {
	  options = options || {};
	  var result;
	
	  if (typeof formatDistanceLocale[token] === 'string') {
	    result = formatDistanceLocale[token];
	  } else if (count === 1) {
	    result = formatDistanceLocale[token].one;
	  } else if (count === 2 && !!formatDistanceLocale[token].two) {
	    result = formatDistanceLocale[token].two;
	  } else {
	    result = formatDistanceLocale[token].other.replace('{{count}}', count);
	  }
	
	  if (options.addSuffix) {
	    if (options.comparison > 0) {
	      return 'mewn ' + result;
	    } else {
	      return result + ' yn ôl';
	    }
	  }
	
	  return result;
	}
	
	module.exports = exports.default;

/***/ },
/* 1114 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: 'EEEE, d MMMM yyyy',
	  long: 'd MMMM yyyy',
	  medium: 'd MMM yyyy',
	  short: 'dd/MM/yyyy'
	};
	var timeFormats = {
	  full: 'h:mm:ss a zzzz',
	  long: 'h:mm:ss a z',
	  medium: 'h:mm:ss a',
	  short: 'h:mm a'
	};
	var dateTimeFormats = {
	  full: "{{date}} 'am' {{time}}",
	  long: "{{date}} 'am' {{time}}",
	  medium: '{{date}}, {{time}}',
	  short: '{{date}}, {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1115 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRelative;
	var formatRelativeLocale = {
	  lastWeek: "eeee 'diwethaf am' p",
	  yesterday: "'ddoe am' p",
	  today: "'heddiw am' p",
	  tomorrow: "'yfory am' p",
	  nextWeek: "eeee 'am' p",
	  other: 'P'
	};
	
	function formatRelative(token, _date, _baseDate, _options) {
	  return formatRelativeLocale[token];
	}
	
	module.exports = exports.default;

/***/ },
/* 1116 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eraValues = {
	  narrow: ['C', 'O'],
	  abbreviated: ['CC', 'OC'],
	  wide: ['Cyn Crist', 'Ar ôl Crist']
	};
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['Ch1', 'Ch2', 'Ch3', 'Ch4'],
	  wide: ['Chwarter 1af', '2ail chwarter', '3ydd chwarter', '4ydd chwarter']
	}; // Note: in English, the names of days of the week and months are capitalized.
	// If you are making a new locale based on this one, check if the same is true for the language you're working on.
	// Generally, formatted dates should look like they are in the middle of a sentence,
	// e.g. in Spanish language the weekdays and months should be in the lowercase.
	
	var monthValues = {
	  narrow: ['I', 'Ch', 'Ma', 'E', 'Mi', 'Me', 'G', 'A', 'Md', 'H', 'T', 'Rh'],
	  abbreviated: ['Ion', 'Chwe', 'Maw', 'Ebr', 'Mai', 'Meh', 'Gor', 'Aws', 'Med', 'Hyd', 'Tach', 'Rhag'],
	  wide: ['Ionawr', 'Chwefror', 'Mawrth', 'Ebrill', 'Mai', 'Mehefin', 'Gorffennaf', 'Awst', 'Medi', 'Hydref', 'Tachwedd', 'Rhagfyr']
	};
	var dayValues = {
	  narrow: ['S', 'Ll', 'M', 'M', 'I', 'G', 'S'],
	  short: ['Su', 'Ll', 'Ma', 'Me', 'Ia', 'Gw', 'Sa'],
	  abbreviated: ['Sul', 'Llun', 'Maw', 'Mer', 'Iau', 'Gwe', 'Sad'],
	  wide: ['dydd Sul', 'dydd Llun', 'dydd Mawrth', 'dydd Mercher', 'dydd Iau', 'dydd Gwener', 'dydd Sadwrn']
	};
	var dayPeriodValues = {
	  narrow: {
	    am: 'b',
	    pm: 'h',
	    midnight: 'hn',
	    noon: 'hd',
	    morning: 'bore',
	    afternoon: 'prynhawn',
	    evening: "gyda'r nos",
	    night: 'nos'
	  },
	  abbreviated: {
	    am: 'yb',
	    pm: 'yh',
	    midnight: 'hanner nos',
	    noon: 'hanner dydd',
	    morning: 'bore',
	    afternoon: 'prynhawn',
	    evening: "gyda'r nos",
	    night: 'nos'
	  },
	  wide: {
	    am: 'y.b.',
	    pm: 'y.h.',
	    midnight: 'hanner nos',
	    noon: 'hanner dydd',
	    morning: 'bore',
	    afternoon: 'prynhawn',
	    evening: "gyda'r nos",
	    night: 'nos'
	  }
	};
	var formattingDayPeriodValues = {
	  narrow: {
	    am: 'b',
	    pm: 'h',
	    midnight: 'hn',
	    noon: 'hd',
	    morning: 'yn y bore',
	    afternoon: 'yn y prynhawn',
	    evening: "gyda'r nos",
	    night: 'yn y nos'
	  },
	  abbreviated: {
	    am: 'yb',
	    pm: 'yh',
	    midnight: 'hanner nos',
	    noon: 'hanner dydd',
	    morning: 'yn y bore',
	    afternoon: 'yn y prynhawn',
	    evening: "gyda'r nos",
	    night: 'yn y nos'
	  },
	  wide: {
	    am: 'y.b.',
	    pm: 'y.h.',
	    midnight: 'hanner nos',
	    noon: 'hanner dydd',
	    morning: 'yn y bore',
	    afternoon: 'yn y prynhawn',
	    evening: "gyda'r nos",
	    night: 'yn y nos'
	  }
	};
	
	function ordinalNumber(dirtyNumber, _dirtyOptions) {
	  var number = Number(dirtyNumber);
	
	  if (number < 20) {
	    switch (number) {
	      case 0:
	        return number + 'fed';
	
	      case 1:
	        return number + 'af';
	
	      case 2:
	        return number + 'ail';
	
	      case 3:
	      case 4:
	        return number + 'ydd';
	
	      case 5:
	      case 6:
	        return number + 'ed';
	
	      case 7:
	      case 8:
	      case 9:
	      case 10:
	      case 12:
	      case 15:
	      case 18:
	        return number + 'fed';
	
	      case 11:
	      case 13:
	      case 14:
	      case 16:
	      case 17:
	      case 19:
	        return number + 'eg';
	    }
	  } else if (number >= 50 && number <= 60 || number === 80 || number >= 100) {
	    return number + 'fed';
	  }
	
	  return number + 'ain';
	}
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingDayPeriodValues,
	    defaultFormattingWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1117 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(15));
	
	var _index2 = _interopRequireDefault(__webpack_require__(14));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(\d+)(af|ail|ydd|ed|fed|eg|ain)?/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^(c|o)/i,
	  abbreviated: /^(c\.?\s?c\.?|o\.?\s?c\.?)/i,
	  wide: /^(cyn christ|ar ôl crist|ar ol crist)/i
	};
	var parseEraPatterns = {
	  wide: [/^c/i, /^(ar ôl crist|ar ol crist)/i],
	  any: [/^c/i, /^o/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^ch[1234]/i,
	  wide: /^(chwarter 1af)|([234](ail|ydd)? chwarter)/i
	};
	var parseQuarterPatterns = {
	  any: [/1/i, /2/i, /3/i, /4/i]
	};
	var matchMonthPatterns = {
	  narrow: /^(i|ch|m|e|g|a|h|t|rh)/i,
	  abbreviated: /^(ion|chwe|maw|ebr|mai|meh|gor|aws|med|hyd|tach|rhag)/i,
	  wide: /^(ionawr|chwefror|mawrth|ebrill|mai|mehefin|gorffennaf|awst|medi|hydref|tachwedd|rhagfyr)/i
	};
	var parseMonthPatterns = {
	  narrow: [/^i/i, /^ch/i, /^m/i, /^e/i, /^m/i, /^m/i, /^g/i, /^a/i, /^m/i, /^h/i, /^t/i, /^rh/i],
	  any: [/^io/i, /^ch/i, /^maw/i, /^e/i, /^mai/i, /^meh/i, /^g/i, /^a/i, /^med/i, /^h/i, /^t/i, /^rh/i]
	};
	var matchDayPatterns = {
	  narrow: /^(s|ll|m|i|g)/i,
	  short: /^(su|ll|ma|me|ia|gw|sa)/i,
	  abbreviated: /^(sul|llun|maw|mer|iau|gwe|sad)/i,
	  wide: /^dydd (sul|llun|mawrth|mercher|iau|gwener|sadwrn)/i
	};
	var parseDayPatterns = {
	  narrow: [/^s/i, /^ll/i, /^m/i, /^m/i, /^i/i, /^g/i, /^s/i],
	  wide: [/^dydd su/i, /^dydd ll/i, /^dydd ma/i, /^dydd me/i, /^dydd i/i, /^dydd g/i, /^dydd sa/i],
	  any: [/^su/i, /^ll/i, /^ma/i, /^me/i, /^i/i, /^g/i, /^sa/i]
	};
	var matchDayPeriodPatterns = {
	  narrow: /^(b|h|hn|hd|(yn y|y|yr|gyda'r) (bore|prynhawn|nos|hwyr))/i,
	  any: /^(y\.?\s?[bh]\.?|hanner nos|hanner dydd|(yn y|y|yr|gyda'r) (bore|prynhawn|nos|hwyr))/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^b|(y\.?\s?b\.?)/i,
	    pm: /^h|(y\.?\s?h\.?)|(yr hwyr)/i,
	    midnight: /^hn|hanner nos/i,
	    noon: /^hd|hanner dydd/i,
	    morning: /bore/i,
	    afternoon: /prynhawn/i,
	    evening: /^gyda'r nos$/i,
	    night: /blah/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index2.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index2.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index2.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index2.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index2.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1118 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1113));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1114));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1115));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1116));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1117));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Welsh locale.
	 * @language Welsh
	 * @iso-639-2 cym
	 * @author Elwyn Malethan [@elmomalmo]{@link https://github.com/elmomalmo}
	 */
	var locale = {
	  code: 'cy',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 0
	    /* Sunday */
	    ,
	    firstWeekContainsDate: 1
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1119 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistance;
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    one: 'mindre end ét sekund',
	    other: 'mindre end {{count}} sekunder'
	  },
	  xSeconds: {
	    one: '1 sekund',
	    other: '{{count}} sekunder'
	  },
	  halfAMinute: 'ét halvt minut',
	  lessThanXMinutes: {
	    one: 'mindre end ét minut',
	    other: 'mindre end {{count}} minutter'
	  },
	  xMinutes: {
	    one: '1 minut',
	    other: '{{count}} minutter'
	  },
	  aboutXHours: {
	    one: 'cirka 1 time',
	    other: 'cirka {{count}} timer'
	  },
	  xHours: {
	    one: '1 time',
	    other: '{{count}} timer'
	  },
	  xDays: {
	    one: '1 dag',
	    other: '{{count}} dage'
	  },
	  aboutXWeeks: {
	    one: 'cirka 1 uge',
	    other: 'cirka {{count}} uger'
	  },
	  xWeeks: {
	    one: '1 uge',
	    other: '{{count}} uger'
	  },
	  aboutXMonths: {
	    one: 'cirka 1 måned',
	    other: 'cirka {{count}} måneder'
	  },
	  xMonths: {
	    one: '1 måned',
	    other: '{{count}} måneder'
	  },
	  aboutXYears: {
	    one: 'cirka 1 år',
	    other: 'cirka {{count}} år'
	  },
	  xYears: {
	    one: '1 år',
	    other: '{{count}} år'
	  },
	  overXYears: {
	    one: 'over 1 år',
	    other: 'over {{count}} år'
	  },
	  almostXYears: {
	    one: 'næsten 1 år',
	    other: 'næsten {{count}} år'
	  }
	};
	
	function formatDistance(token, count, options) {
	  options = options || {};
	  var result;
	
	  if (typeof formatDistanceLocale[token] === 'string') {
	    result = formatDistanceLocale[token];
	  } else if (count === 1) {
	    result = formatDistanceLocale[token].one;
	  } else {
	    result = formatDistanceLocale[token].other.replace('{{count}}', count);
	  }
	
	  if (options.addSuffix) {
	    if (options.comparison > 0) {
	      return 'om ' + result;
	    } else {
	      return result + ' siden';
	    }
	  }
	
	  return result;
	}
	
	module.exports = exports.default;

/***/ },
/* 1120 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: "EEEE 'den' d. MMMM y",
	  long: 'd. MMMM y',
	  medium: 'd. MMM y',
	  short: 'dd/MM/y'
	};
	var timeFormats = {
	  full: 'HH:mm:ss zzzz',
	  long: 'HH:mm:ss z',
	  medium: 'HH:mm:ss',
	  short: 'HH:mm'
	};
	var dateTimeFormats = {
	  full: "{{date}} 'kl'. {{time}}",
	  long: "{{date}} 'kl'. {{time}}",
	  medium: '{{date}} {{time}}',
	  short: '{{date}} {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1121 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRelative;
	var formatRelativeLocale = {
	  lastWeek: "'sidste' eeee 'kl.' p",
	  yesterday: "'i går kl.' p",
	  today: "'i dag kl.' p",
	  tomorrow: "'i morgen kl.' p",
	  nextWeek: "'på' eeee 'kl.' p",
	  other: 'P'
	};
	
	function formatRelative(token, _date, _baseDate, _options) {
	  return formatRelativeLocale[token];
	}
	
	module.exports = exports.default;

/***/ },
/* 1122 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eraValues = {
	  narrow: ['fvt', 'vt'],
	  abbreviated: ['f.v.t.', 'v.t.'],
	  wide: ['før vesterlandsk tidsregning', 'vesterlandsk tidsregning']
	};
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['1. kvt.', '2. kvt.', '3. kvt.', '4. kvt.'],
	  wide: ['1. kvartal', '2. kvartal', '3. kvartal', '4. kvartal']
	};
	var monthValues = {
	  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
	  abbreviated: ['jan.', 'feb.', 'mar.', 'apr.', 'maj', 'jun.', 'jul.', 'aug.', 'sep.', 'okt.', 'nov.', 'dec.'],
	  wide: ['januar', 'februar', 'marts', 'april', 'maj', 'juni', 'juli', 'august', 'september', 'oktober', 'november', 'december']
	}; // Note that 'Days - abbreviated - Formatting' has periods at the end.
	// https://www.unicode.org/cldr/charts/32/summary/da.html#1760
	// This makes grammatical sense in danish, as most abbreviations have periods.
	
	var dayValues = {
	  narrow: ['S', 'M', 'T', 'O', 'T', 'F', 'L'],
	  short: ['sø', 'ma', 'ti', 'on', 'to', 'fr', 'lø'],
	  abbreviated: ['søn.', 'man.', 'tir.', 'ons.', 'tor.', 'fre.', 'lør.'],
	  wide: ['søndag', 'mandag', 'tirsdag', 'onsdag', 'torsdag', 'fredag', 'lørdag']
	};
	var dayPeriodValues = {
	  narrow: {
	    am: 'a',
	    pm: 'p',
	    midnight: 'midnat',
	    noon: 'middag',
	    morning: 'morgen',
	    afternoon: 'eftermiddag',
	    evening: 'aften',
	    night: 'nat'
	  },
	  abbreviated: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'midnat',
	    noon: 'middag',
	    morning: 'morgen',
	    afternoon: 'eftermiddag',
	    evening: 'aften',
	    night: 'nat'
	  },
	  wide: {
	    am: 'a.m.',
	    pm: 'p.m.',
	    midnight: 'midnat',
	    noon: 'middag',
	    morning: 'morgen',
	    afternoon: 'eftermiddag',
	    evening: 'aften',
	    night: 'nat'
	  }
	};
	var formattingDayPeriodValues = {
	  narrow: {
	    am: 'a',
	    pm: 'p',
	    midnight: 'midnat',
	    noon: 'middag',
	    morning: 'om morgenen',
	    afternoon: 'om eftermiddagen',
	    evening: 'om aftenen',
	    night: 'om natten'
	  },
	  abbreviated: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'midnat',
	    noon: 'middag',
	    morning: 'om morgenen',
	    afternoon: 'om eftermiddagen',
	    evening: 'om aftenen',
	    night: 'om natten'
	  },
	  wide: {
	    am: 'a.m.',
	    pm: 'p.m.',
	    midnight: 'midnat',
	    noon: 'middag',
	    morning: 'om morgenen',
	    afternoon: 'om eftermiddagen',
	    evening: 'om aftenen',
	    night: 'om natten'
	  }
	};
	
	function ordinalNumber(dirtyNumber) {
	  var number = Number(dirtyNumber);
	  return number + '.';
	}
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingDayPeriodValues,
	    defaultFormattingWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1123 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(14));
	
	var _index2 = _interopRequireDefault(__webpack_require__(15));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(\d+)(\.)?/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^(fKr|fvt|eKr|vt)/i,
	  abbreviated: /^(f\.Kr\.?|f\.v\.t\.?|e\.Kr\.?|v\.t\.)/i,
	  wide: /^(f.Kr.|før vesterlandsk tidsregning|e.Kr.|vesterlandsk tidsregning)/i
	};
	var parseEraPatterns = {
	  any: [/^f/i, /^(v|e)/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^[1234]. kvt\./i,
	  wide: /^[1234]\.? kvartal/i
	};
	var parseQuarterPatterns = {
	  any: [/1/i, /2/i, /3/i, /4/i]
	};
	var matchMonthPatterns = {
	  narrow: /^[jfmasond]/i,
	  abbreviated: /^(jan.|feb.|mar.|apr.|maj|jun.|jul.|aug.|sep.|okt.|nov.|dec.)/i,
	  wide: /^(januar|februar|marts|april|maj|juni|juli|august|september|oktober|november|december)/i
	};
	var parseMonthPatterns = {
	  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
	  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^maj/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
	};
	var matchDayPatterns = {
	  narrow: /^[smtofl]/i,
	  short: /^(søn.|man.|tir.|ons.|tor.|fre.|lør.)/i,
	  abbreviated: /^(søn|man|tir|ons|tor|fre|lør)/i,
	  wide: /^(søndag|mandag|tirsdag|onsdag|torsdag|fredag|lørdag)/i
	};
	var parseDayPatterns = {
	  narrow: [/^s/i, /^m/i, /^t/i, /^o/i, /^t/i, /^f/i, /^l/i],
	  any: [/^s/i, /^m/i, /^ti/i, /^o/i, /^to/i, /^f/i, /^l/i]
	};
	var matchDayPeriodPatterns = {
	  narrow: /^(a|p|midnat|middag|(om) (morgenen|eftermiddagen|aftenen|natten))/i,
	  any: /^([ap]\.?\s?m\.?|midnat|middag|(om) (morgenen|eftermiddagen|aftenen|natten))/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^a/i,
	    pm: /^p/i,
	    midnight: /midnat/i,
	    noon: /middag/i,
	    morning: /morgen/i,
	    afternoon: /eftermiddag/i,
	    evening: /aften/i,
	    night: /nat/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index2.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1124 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1119));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1120));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1121));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1122));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1123));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Danish locale.
	 * @language Danish
	 * @iso-639-2 dan
	 * @author Mathias Wøbbe [@MathiasKandelborg]{@link https://github.com/MathiasKandelborg}
	 * @author Anders B. Hansen [@Andersbiha]{@link https://github.com/Andersbiha}
	 * @author [@kgram]{@link https://github.com/kgram}
	 * @author [@stefanbugge]{@link https://github.com/stefanbugge}
	 */
	var locale = {
	  code: 'da',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 1
	    /* Monday */
	    ,
	    firstWeekContainsDate: 4
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1125 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eraValues = {
	  narrow: ['v.Chr.', 'n.Chr.'],
	  abbreviated: ['v.Chr.', 'n.Chr.'],
	  wide: ['vor Christus', 'nach Christus']
	};
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
	  wide: ['1. Quartal', '2. Quartal', '3. Quartal', '4. Quartal']
	}; // Note: in German, the names of days of the week and months are capitalized.
	// If you are making a new locale based on this one, check if the same is true for the language you're working on.
	// Generally, formatted dates should look like they are in the middle of a sentence,
	// e.g. in Spanish language the weekdays and months should be in the lowercase.
	
	var monthValues = {
	  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
	  abbreviated: ['Jän', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'],
	  wide: ['Jänner', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember']
	}; // https://st.unicode.org/cldr-apps/v#/de_AT/Gregorian/
	
	var formattingMonthValues = {
	  narrow: monthValues.narrow,
	  abbreviated: ['Jän.', 'Feb.', 'März', 'Apr.', 'Mai', 'Juni', 'Juli', 'Aug.', 'Sep.', 'Okt.', 'Nov.', 'Dez.'],
	  wide: monthValues.wide
	};
	var dayValues = {
	  narrow: ['S', 'M', 'D', 'M', 'D', 'F', 'S'],
	  short: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
	  abbreviated: ['So.', 'Mo.', 'Di.', 'Mi.', 'Do.', 'Fr.', 'Sa.'],
	  wide: ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag']
	}; // https://www.unicode.org/cldr/charts/32/summary/de.html#1881
	
	var dayPeriodValues = {
	  narrow: {
	    am: 'vm.',
	    pm: 'nm.',
	    midnight: 'Mitternacht',
	    noon: 'Mittag',
	    morning: 'Morgen',
	    afternoon: 'Nachm.',
	    evening: 'Abend',
	    night: 'Nacht'
	  },
	  abbreviated: {
	    am: 'vorm.',
	    pm: 'nachm.',
	    midnight: 'Mitternacht',
	    noon: 'Mittag',
	    morning: 'Morgen',
	    afternoon: 'Nachmittag',
	    evening: 'Abend',
	    night: 'Nacht'
	  },
	  wide: {
	    am: 'vormittags',
	    pm: 'nachmittags',
	    midnight: 'Mitternacht',
	    noon: 'Mittag',
	    morning: 'Morgen',
	    afternoon: 'Nachmittag',
	    evening: 'Abend',
	    night: 'Nacht'
	  }
	};
	var formattingDayPeriodValues = {
	  narrow: {
	    am: 'vm.',
	    pm: 'nm.',
	    midnight: 'Mitternacht',
	    noon: 'Mittag',
	    morning: 'morgens',
	    afternoon: 'nachm.',
	    evening: 'abends',
	    night: 'nachts'
	  },
	  abbreviated: {
	    am: 'vorm.',
	    pm: 'nachm.',
	    midnight: 'Mitternacht',
	    noon: 'Mittag',
	    morning: 'morgens',
	    afternoon: 'nachmittags',
	    evening: 'abends',
	    night: 'nachts'
	  },
	  wide: {
	    am: 'vormittags',
	    pm: 'nachmittags',
	    midnight: 'Mitternacht',
	    noon: 'Mittag',
	    morning: 'morgens',
	    afternoon: 'nachmittags',
	    evening: 'abends',
	    night: 'nachts'
	  }
	};
	
	var ordinalNumber = function (dirtyNumber, _dirtyOptions) {
	  var number = Number(dirtyNumber);
	  return number + '.';
	};
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return quarter - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    formattingValues: formattingMonthValues,
	    defaultWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingDayPeriodValues,
	    defaultFormattingWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1126 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(439));
	
	var _index2 = _interopRequireDefault(__webpack_require__(440));
	
	var _index3 = _interopRequireDefault(__webpack_require__(441));
	
	var _index4 = _interopRequireDefault(__webpack_require__(442));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1125));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// difference to 'de' locale
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary German locale (Austria).
	 * @language German
	 * @iso-639-2 deu
	 * @author Christoph Tobias Stenglein [@cstenglein]{@link https://github.com/cstenglein}
	 */
	var locale = {
	  code: 'de-AT',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index5.default,
	  match: _index4.default,
	  options: {
	    weekStartsOn: 1
	    /* Monday */
	    ,
	    firstWeekContainsDate: 4
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1127 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eraValues = {
	  narrow: ['v.Chr.', 'n.Chr.'],
	  abbreviated: ['v.Chr.', 'n.Chr.'],
	  wide: ['vor Christus', 'nach Christus']
	};
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
	  wide: ['1. Quartal', '2. Quartal', '3. Quartal', '4. Quartal']
	}; // Note: in German, the names of days of the week and months are capitalized.
	// If you are making a new locale based on this one, check if the same is true for the language you're working on.
	// Generally, formatted dates should look like they are in the middle of a sentence,
	// e.g. in Spanish language the weekdays and months should be in the lowercase.
	
	var monthValues = {
	  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
	  abbreviated: ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'],
	  wide: ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember']
	}; // https://st.unicode.org/cldr-apps/v#/de/Gregorian/
	
	var formattingMonthValues = {
	  narrow: monthValues.narrow,
	  abbreviated: ['Jan.', 'Feb.', 'März', 'Apr.', 'Mai', 'Juni', 'Juli', 'Aug.', 'Sep.', 'Okt.', 'Nov.', 'Dez.'],
	  wide: monthValues.wide
	};
	var dayValues = {
	  narrow: ['S', 'M', 'D', 'M', 'D', 'F', 'S'],
	  short: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
	  abbreviated: ['So.', 'Mo.', 'Di.', 'Mi.', 'Do.', 'Fr.', 'Sa.'],
	  wide: ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag']
	}; // https://www.unicode.org/cldr/charts/32/summary/de.html#1881
	
	var dayPeriodValues = {
	  narrow: {
	    am: 'vm.',
	    pm: 'nm.',
	    midnight: 'Mitternacht',
	    noon: 'Mittag',
	    morning: 'Morgen',
	    afternoon: 'Nachm.',
	    evening: 'Abend',
	    night: 'Nacht'
	  },
	  abbreviated: {
	    am: 'vorm.',
	    pm: 'nachm.',
	    midnight: 'Mitternacht',
	    noon: 'Mittag',
	    morning: 'Morgen',
	    afternoon: 'Nachmittag',
	    evening: 'Abend',
	    night: 'Nacht'
	  },
	  wide: {
	    am: 'vormittags',
	    pm: 'nachmittags',
	    midnight: 'Mitternacht',
	    noon: 'Mittag',
	    morning: 'Morgen',
	    afternoon: 'Nachmittag',
	    evening: 'Abend',
	    night: 'Nacht'
	  }
	};
	var formattingDayPeriodValues = {
	  narrow: {
	    am: 'vm.',
	    pm: 'nm.',
	    midnight: 'Mitternacht',
	    noon: 'Mittag',
	    morning: 'morgens',
	    afternoon: 'nachm.',
	    evening: 'abends',
	    night: 'nachts'
	  },
	  abbreviated: {
	    am: 'vorm.',
	    pm: 'nachm.',
	    midnight: 'Mitternacht',
	    noon: 'Mittag',
	    morning: 'morgens',
	    afternoon: 'nachmittags',
	    evening: 'abends',
	    night: 'nachts'
	  },
	  wide: {
	    am: 'vormittags',
	    pm: 'nachmittags',
	    midnight: 'Mitternacht',
	    noon: 'Mittag',
	    morning: 'morgens',
	    afternoon: 'nachmittags',
	    evening: 'abends',
	    night: 'nachts'
	  }
	};
	
	var ordinalNumber = function (dirtyNumber) {
	  var number = Number(dirtyNumber);
	  return number + '.';
	};
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return quarter - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    formattingValues: formattingMonthValues,
	    defaultWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingDayPeriodValues,
	    defaultFormattingWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1128 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(439));
	
	var _index2 = _interopRequireDefault(__webpack_require__(440));
	
	var _index3 = _interopRequireDefault(__webpack_require__(441));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1127));
	
	var _index5 = _interopRequireDefault(__webpack_require__(442));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary German locale.
	 * @language German
	 * @iso-639-2 deu
	 * @author Thomas Eilmsteiner [@DeMuu]{@link https://github.com/DeMuu}
	 * @author Asia [@asia-t]{@link https://github.com/asia-t}
	 * @author Van Vuong Ngo [@vanvuongngo]{@link https://github.com/vanvuongngo}
	 * @author RomanErnst [@pex]{@link https://github.com/pex}
	 * @author Philipp Keck [@Philipp91]{@link https://github.com/Philipp91}
	 */
	var locale = {
	  code: 'de',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 1
	    /* Monday */
	    ,
	    firstWeekContainsDate: 4
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1129 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistance;
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    one: 'λιγότερο από ένα δευτερόλεπτο',
	    other: 'λιγότερο από {{count}} δευτερόλεπτα'
	  },
	  xSeconds: {
	    one: '1 δευτερόλεπτο',
	    other: '{{count}} δευτερόλεπτα'
	  },
	  halfAMinute: 'μισό λεπτό',
	  lessThanXMinutes: {
	    one: 'λιγότερο από ένα λεπτό',
	    other: 'λιγότερο από {{count}} λεπτά'
	  },
	  xMinutes: {
	    one: '1 λεπτό',
	    other: '{{count}} λεπτά'
	  },
	  aboutXHours: {
	    one: 'περίπου 1 ώρα',
	    other: 'περίπου {{count}} ώρες'
	  },
	  xHours: {
	    one: '1 ώρα',
	    other: '{{count}} ώρες'
	  },
	  xDays: {
	    one: '1 ημέρα',
	    other: '{{count}} ημέρες'
	  },
	  aboutXWeeks: {
	    one: 'περίπου 1 εβδομάδα',
	    other: 'περίπου {{count}} εβδομάδες'
	  },
	  xWeeks: {
	    one: '1 εβδομάδα',
	    other: '{{count}} εβδομάδες'
	  },
	  aboutXMonths: {
	    one: 'περίπου 1 μήνας',
	    other: 'περίπου {{count}} μήνες'
	  },
	  xMonths: {
	    one: '1 μήνας',
	    other: '{{count}} μήνες'
	  },
	  aboutXYears: {
	    one: 'περίπου 1 χρόνο',
	    other: 'περίπου {{count}} χρόνια'
	  },
	  xYears: {
	    one: '1 χρόνο',
	    other: '{{count}} χρόνια'
	  },
	  overXYears: {
	    one: 'πάνω από 1 χρόνο',
	    other: 'πάνω από {{count}} χρόνια'
	  },
	  almostXYears: {
	    one: 'περίπου 1 χρόνο',
	    other: 'περίπου {{count}} χρόνια'
	  }
	};
	
	function formatDistance(token, count, options) {
	  options = options || {};
	  var result;
	
	  if (typeof formatDistanceLocale[token] === 'string') {
	    result = formatDistanceLocale[token];
	  } else if (count === 1) {
	    result = formatDistanceLocale[token].one;
	  } else {
	    result = formatDistanceLocale[token].other.replace('{{count}}', count);
	  }
	
	  if (options.addSuffix) {
	    if (options.comparison > 0) {
	      return 'σε ' + result;
	    } else {
	      return result + ' πριν';
	    }
	  }
	
	  return result;
	}
	
	module.exports = exports.default;

/***/ },
/* 1130 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: 'EEEE, d MMMM y',
	  long: 'd MMMM y',
	  medium: 'd MMM y',
	  short: 'd/M/yy'
	};
	var timeFormats = {
	  full: 'h:mm:ss a zzzz',
	  long: 'h:mm:ss a z',
	  medium: 'h:mm:ss a',
	  short: 'h:mm a'
	};
	var dateTimeFormats = {
	  full: '{{date}} - {{time}}',
	  long: '{{date}} - {{time}}',
	  medium: '{{date}}, {{time}}',
	  short: '{{date}}, {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1131 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRelative;
	var formatRelativeLocale = {
	  lastWeek: function (date) {
	    switch (date.getUTCDay()) {
	      case 6:
	        //Σάββατο
	        return "'το προηγούμενο' eeee 'στις' p";
	
	      default:
	        return "'την προηγούμενη' eeee 'στις' p";
	    }
	  },
	  yesterday: "'χθες στις' p",
	  today: "'σήμερα στις' p",
	  tomorrow: "'αύριο στις' p",
	  nextWeek: "eeee 'στις' p",
	  other: 'P'
	};
	
	function formatRelative(token, date, baseDate, options) {
	  var format = formatRelativeLocale[token];
	  if (typeof format === 'function') return format(date, baseDate, options);
	  return format;
	}
	
	module.exports = exports.default;

/***/ },
/* 1132 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eraValues = {
	  narrow: ['πΧ', 'μΧ'],
	  abbreviated: ['π.Χ.', 'μ.Χ.'],
	  wide: ['προ Χριστού', 'μετά Χριστόν']
	};
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['Τ1', 'Τ2', 'Τ3', 'Τ4'],
	  wide: ['1ο τρίμηνο', '2ο τρίμηνο', '3ο τρίμηνο', '4ο τρίμηνο']
	};
	var monthValues = {
	  narrow: ['Ι', 'Φ', 'Μ', 'Α', 'Μ', 'Ι', 'Ι', 'Α', 'Σ', 'Ο', 'Ν', 'Δ'],
	  abbreviated: ['Ιαν', 'Φεβ', 'Μάρ', 'Απρ', 'Μάι', 'Ιούν', 'Ιούλ', 'Αύγ', 'Σεπ', 'Οκτ', 'Νοέ', 'Δεκ'],
	  wide: ['Ιανουάριος', 'Φεβρουάριος', 'Μάρτιος', 'Απρίλιος', 'Μάιος', 'Ιούνιος', 'Ιούλιος', 'Αύγουστος', 'Σεπτέμβριος', 'Οκτώβριος', 'Νοέμβριος', 'Δεκέμβριος']
	};
	var formattingMonthValues = {
	  narrow: ['Ι', 'Φ', 'Μ', 'Α', 'Μ', 'Ι', 'Ι', 'Α', 'Σ', 'Ο', 'Ν', 'Δ'],
	  abbreviated: ['Ιαν', 'Φεβ', 'Μαρ', 'Απρ', 'Μαΐ', 'Ιουν', 'Ιουλ', 'Αυγ', 'Σεπ', 'Οκτ', 'Νοε', 'Δεκ'],
	  wide: ['Ιανουαρίου', 'Φεβρουαρίου', 'Μαρτίου', 'Απριλίου', 'Μαΐου', 'Ιουνίου', 'Ιουλίου', 'Αυγούστου', 'Σεπτεμβρίου', 'Οκτωβρίου', 'Νοεμβρίου', 'Δεκεμβρίου']
	};
	var dayValues = {
	  narrow: ['Κ', 'Δ', 'T', 'Τ', 'Π', 'Π', 'Σ'],
	  short: ['Κυ', 'Δε', 'Τρ', 'Τε', 'Πέ', 'Πα', 'Σά'],
	  abbreviated: ['Κυρ', 'Δευ', 'Τρί', 'Τετ', 'Πέμ', 'Παρ', 'Σάβ'],
	  wide: ['Κυριακή', 'Δευτέρα', 'Τρίτη', 'Τετάρτη', 'Πέμπτη', 'Παρασκευή', 'Σάββατο']
	};
	var dayPeriodValues = {
	  narrow: {
	    am: 'πμ',
	    pm: 'μμ',
	    midnight: 'μεσάνυχτα',
	    noon: 'μεσημέρι',
	    morning: 'πρωί',
	    afternoon: 'απόγευμα',
	    evening: 'βράδυ',
	    night: 'νύχτα'
	  },
	  abbreviated: {
	    am: 'π.μ.',
	    pm: 'μ.μ.',
	    midnight: 'μεσάνυχτα',
	    noon: 'μεσημέρι',
	    morning: 'πρωί',
	    afternoon: 'απόγευμα',
	    evening: 'βράδυ',
	    night: 'νύχτα'
	  },
	  wide: {
	    am: 'π.μ.',
	    pm: 'μ.μ.',
	    midnight: 'μεσάνυχτα',
	    noon: 'μεσημέρι',
	    morning: 'πρωί',
	    afternoon: 'απόγευμα',
	    evening: 'βράδυ',
	    night: 'νύχτα'
	  }
	};
	
	function ordinalNumber(dirtyNumber, dirtyOptions) {
	  var options = dirtyOptions || {};
	  var unit = String(options.unit);
	  var suffix;
	
	  if (unit === 'year' || unit === 'month') {
	    suffix = 'ος';
	  } else if (unit === 'week' || unit === 'dayOfYear' || unit === 'day' || unit === 'hour' || unit === 'date') {
	    suffix = 'η';
	  } else {
	    suffix = 'ο';
	  }
	
	  return dirtyNumber + suffix;
	}
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingMonthValues,
	    defaultFormattingWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1133 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(15));
	
	var _index2 = _interopRequireDefault(__webpack_require__(14));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(\d+)(ος|η|ο)?/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^(πΧ|μΧ)/i,
	  abbreviated: /^(π\.?\s?χ\.?|π\.?\s?κ\.?\s?χ\.?|μ\.?\s?χ\.?|κ\.?\s?χ\.?)/i,
	  wide: /^(προ Χριστο(ύ|υ)|πριν απ(ό|ο) την Κοιν(ή|η) Χρονολογ(ί|ι)α|μετ(ά|α) Χριστ(ό|ο)ν|Κοιν(ή|η) Χρονολογ(ί|ι)α)/i
	};
	var parseEraPatterns = {
	  any: [/^π/i, /^(μ|κ)/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^τ[1234]/i,
	  wide: /^[1234]ο? τρ(ί|ι)μηνο/i
	};
	var parseQuarterPatterns = {
	  any: [/1/i, /2/i, /3/i, /4/i]
	};
	var matchMonthPatterns = {
	  narrow: /^[ιφμαμιιασονδ]/i,
	  abbreviated: /^(ιαν|φεβ|μ[άα]ρ|απρ|μ[άα][ιΐ]|ιο[ύυ]ν|ιο[ύυ]λ|α[ύυ]γ|σεπ|οκτ|νο[έε]|δεκ)/i,
	  wide: /^(μ[άα][ιΐ]|α[ύυ]γο[υύ]στ)(ος|ου)|(ιανου[άα]ρ|φεβρου[άα]ρ|μ[άα]ρτ|απρ[ίι]λ|ιο[ύυ]ν|ιο[ύυ]λ|σεπτ[έε]μβρ|οκτ[ώω]βρ|νο[έε]μβρ|δεκ[έε]μβρ)(ιος|ίου)/i
	};
	var parseMonthPatterns = {
	  narrow: [/^ι/i, /^φ/i, /^μ/i, /^α/i, /^μ/i, /^ι/i, /^ι/i, /^α/i, /^σ/i, /^ο/i, /^ν/i, /^δ/i],
	  any: [/^ια/i, /^φ/i, /^μ[άα]ρ/i, /^απ/i, /^μ[άα][ιΐ]/i, /^ιο[ύυ]ν/i, /^ιο[ύυ]λ/i, /^α[ύυ]/i, /^σ/i, /^ο/i, /^ν/i, /^δ/i]
	};
	var matchDayPatterns = {
	  narrow: /^[κδτπσ]/i,
	  short: /^(κυ|δε|τρ|τε|π[εέ]|π[αά]|σ[αά])/i,
	  abbreviated: /^(κυρ|δευ|τρι|τετ|πεμ|παρ|σαβ)/i,
	  wide: /^(κυριακ(ή|η)|δευτ(έ|ε)ρα|τρ(ί|ι)τη|τετ(ά|α)ρτη|π(έ|ε)μπτη|παρασκευ(ή|η)|σ(ά|α)ββατο)/i
	};
	var parseDayPatterns = {
	  narrow: [/^κ/i, /^δ/i, /^τ/i, /^τ/i, /^π/i, /^π/i, /^σ/i],
	  any: [/^κ/i, /^δ/i, /^τρ/i, /^τε/i, /^π[εέ]/i, /^π[αά]/i, /^σ/i]
	};
	var matchDayPeriodPatterns = {
	  narrow: /^(πμ|μμ|μεσ(ά|α)νυχτα|μεσημ(έ|ε)ρι|πρω(ί|ι)|απ(ό|ο)γευμα|βρ(ά|α)δυ|ν(ύ|υ)χτα)/i,
	  any: /^([πμ]\.?\s?μ\.?|μεσ(ά|α)νυχτα|μεσημ(έ|ε)ρι|πρω(ί|ι)|απ(ό|ο)γευμα|βρ(ά|α)δυ|ν(ύ|υ)χτα)/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^πμ|π\.\s?μ\./i,
	    pm: /^μμ|μ\.\s?μ\./i,
	    midnight: /^μεσάν/i,
	    noon: /^μεσημ(έ|ε)/i,
	    morning: /πρω(ί|ι)/i,
	    afternoon: /απ(ό|ο)γευμα/i,
	    evening: /βρ(ά|α)δυ/i,
	    night: /ν(ύ|υ)χτα/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index2.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index2.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index2.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index2.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index2.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1134 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1129));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1130));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1131));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1132));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1133));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Greek locale.
	 * @language Greek
	 * @iso-639-2 ell
	 * @author Fanis Katsimpas [@fanixk]{@link https://github.com/fanixk}
	 * @author Theodoros Orfanidis [@teoulas]{@link https://github.com/teoulas}
	 */
	var locale = {
	  code: 'el',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 1
	    /* Monday */
	    ,
	    firstWeekContainsDate: 4
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1135 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: 'EEEE, d MMMM yyyy',
	  long: 'd MMMM yyyy',
	  medium: 'd MMM yyyy',
	  short: 'dd/MM/yyyy'
	};
	var timeFormats = {
	  full: 'h:mm:ss a zzzz',
	  long: 'h:mm:ss a z',
	  medium: 'h:mm:ss a',
	  short: 'h:mm a'
	};
	var dateTimeFormats = {
	  full: "{{date}} 'at' {{time}}",
	  long: "{{date}} 'at' {{time}}",
	  medium: '{{date}}, {{time}}',
	  short: '{{date}}, {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1136 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(107));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1135));
	
	var _index3 = _interopRequireDefault(__webpack_require__(91));
	
	var _index4 = _interopRequireDefault(__webpack_require__(92));
	
	var _index5 = _interopRequireDefault(__webpack_require__(93));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary English locale (Australia).
	 * @language English
	 * @iso-639-2 eng
	 * @author Julien Malige [@JulienMalige]{@link https://github.com/JulienMalige}
	 */
	var locale = {
	  code: 'en-AU',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 1
	    /* Monday */
	    ,
	    firstWeekContainsDate: 4
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1137 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    one: 'less than a second',
	    other: 'less than {{count}} seconds'
	  },
	  xSeconds: {
	    one: 'a second',
	    other: '{{count}} seconds'
	  },
	  halfAMinute: 'half a minute',
	  lessThanXMinutes: {
	    one: 'less than a minute',
	    other: 'less than {{count}} minutes'
	  },
	  xMinutes: {
	    one: 'a minute',
	    other: '{{count}} minutes'
	  },
	  aboutXHours: {
	    one: 'about an hour',
	    other: 'about {{count}} hours'
	  },
	  xHours: {
	    one: 'an hour',
	    other: '{{count}} hours'
	  },
	  xDays: {
	    one: 'a day',
	    other: '{{count}} days'
	  },
	  aboutXWeeks: {
	    one: 'about a week',
	    other: 'about {{count}} weeks'
	  },
	  xWeeks: {
	    one: 'a week',
	    other: '{{count}} weeks'
	  },
	  aboutXMonths: {
	    one: 'about a month',
	    other: 'about {{count}} months'
	  },
	  xMonths: {
	    one: 'a month',
	    other: '{{count}} months'
	  },
	  aboutXYears: {
	    one: 'about a year',
	    other: 'about {{count}} years'
	  },
	  xYears: {
	    one: 'a year',
	    other: '{{count}} years'
	  },
	  overXYears: {
	    one: 'over a year',
	    other: 'over {{count}} years'
	  },
	  almostXYears: {
	    one: 'almost a year',
	    other: 'almost {{count}} years'
	  }
	};
	
	var formatDistance = function (token, count, options) {
	  var result;
	  var tokenValue = formatDistanceLocale[token];
	
	  if (typeof tokenValue === 'string') {
	    result = tokenValue;
	  } else if (count === 1) {
	    result = tokenValue.one;
	  } else {
	    result = tokenValue.other.replace('{{count}}', count.toString());
	  }
	
	  if (options !== null && options !== void 0 && options.addSuffix) {
	    if (options.comparison && options.comparison > 0) {
	      return 'in ' + result;
	    } else {
	      return result + ' ago';
	    }
	  }
	
	  return result;
	};
	
	var _default = formatDistance;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1138 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: 'EEEE, MMMM do, yyyy',
	  long: 'MMMM do, yyyy',
	  medium: 'MMM d, yyyy',
	  short: 'yyyy-MM-dd'
	};
	var timeFormats = {
	  full: 'h:mm:ss a zzzz',
	  long: 'h:mm:ss a z',
	  medium: 'h:mm:ss a',
	  short: 'h:mm a'
	};
	var dateTimeFormats = {
	  full: "{{date}} 'at' {{time}}",
	  long: "{{date}} 'at' {{time}}",
	  medium: '{{date}}, {{time}}',
	  short: '{{date}}, {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1139 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(91));
	
	var _index2 = _interopRequireDefault(__webpack_require__(92));
	
	var _index3 = _interopRequireDefault(__webpack_require__(93));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1137));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1138));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary English locale (Canada).
	 * @language English
	 * @iso-639-2 eng
	 * @author Mark Owsiak [@markowsiak]{@link https://github.com/markowsiak}
	 * @author Marco Imperatore [@mimperatore]{@link https://github.com/mimperatore}
	 */
	var locale = {
	  code: 'en-CA',
	  formatDistance: _index4.default,
	  formatLong: _index5.default,
	  formatRelative: _index.default,
	  localize: _index2.default,
	  match: _index3.default,
	  options: {
	    weekStartsOn: 0
	    /* Sunday */
	    ,
	    firstWeekContainsDate: 1
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1140 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(107));
	
	var _index2 = _interopRequireDefault(__webpack_require__(91));
	
	var _index3 = _interopRequireDefault(__webpack_require__(92));
	
	var _index4 = _interopRequireDefault(__webpack_require__(93));
	
	var _index5 = _interopRequireDefault(__webpack_require__(443));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary English locale (United Kingdom).
	 * @language English
	 * @iso-639-2 eng
	 * @author Alex [@glintik]{@link https://github.com/glintik}
	 */
	var locale = {
	  code: 'en-GB',
	  formatDistance: _index.default,
	  formatLong: _index5.default,
	  formatRelative: _index2.default,
	  localize: _index3.default,
	  match: _index4.default,
	  options: {
	    weekStartsOn: 1
	    /* Monday */
	    ,
	    firstWeekContainsDate: 4
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1141 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(107));
	
	var _index2 = _interopRequireDefault(__webpack_require__(91));
	
	var _index3 = _interopRequireDefault(__webpack_require__(92));
	
	var _index4 = _interopRequireDefault(__webpack_require__(93));
	
	var _index5 = _interopRequireDefault(__webpack_require__(443));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary English locale (Ireland).
	 * @language English
	 * @iso-639-2 eng
	 * @author Tetiana [@tan75]{@link https://github.com/tan75}
	 */
	var locale = {
	  code: 'en-IE',
	  formatDistance: _index.default,
	  formatLong: _index5.default,
	  formatRelative: _index2.default,
	  localize: _index3.default,
	  match: _index4.default,
	  options: {
	    weekStartsOn: 1
	    /* Monday */
	    ,
	    firstWeekContainsDate: 4
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1142 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: 'EEEE, d MMMM yyyy',
	  long: 'd MMMM, yyyy',
	  medium: 'd MMM, yyyy',
	  short: 'dd/MM/yyyy'
	};
	var timeFormats = {
	  full: 'h:mm:ss a zzzz',
	  long: 'h:mm:ss a z',
	  medium: 'h:mm:ss a',
	  short: 'h:mm a'
	};
	var dateTimeFormats = {
	  full: "{{date}} 'at' {{time}}",
	  long: "{{date}} 'at' {{time}}",
	  medium: '{{date}}, {{time}}',
	  short: '{{date}}, {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1143 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(107));
	
	var _index2 = _interopRequireDefault(__webpack_require__(91));
	
	var _index3 = _interopRequireDefault(__webpack_require__(92));
	
	var _index4 = _interopRequireDefault(__webpack_require__(93));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1142));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary English locale (India).
	 * @language English
	 * @iso-639-2 eng
	 * @author Galeel Bhasha Satthar [@gbhasha]{@link https://github.com/gbhasha}
	 */
	var locale = {
	  code: 'en-IN',
	  formatDistance: _index.default,
	  formatLong: _index5.default,
	  formatRelative: _index2.default,
	  localize: _index3.default,
	  match: _index4.default,
	  options: {
	    weekStartsOn: 1,
	    // Monday is the first day of the week.
	    firstWeekContainsDate: 4 // The week that contains Jan 4th is the first week of the year.
	
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1144 */
1135,
/* 1145 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(107));
	
	var _index2 = _interopRequireDefault(__webpack_require__(91));
	
	var _index3 = _interopRequireDefault(__webpack_require__(92));
	
	var _index4 = _interopRequireDefault(__webpack_require__(93));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1144));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary English locale (New Zealand).
	 * @language English
	 * @iso-639-2 eng
	 * @author Murray Lucas [@muntact]{@link https://github.com/muntact}
	 */
	var locale = {
	  code: 'en-NZ',
	  formatDistance: _index.default,
	  formatLong: _index5.default,
	  formatRelative: _index2.default,
	  localize: _index3.default,
	  match: _index4.default,
	  options: {
	    weekStartsOn: 1
	    /* Monday */
	    ,
	    firstWeekContainsDate: 4
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1146 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: 'EEEE, MMMM do, y',
	  long: 'MMMM do, y',
	  medium: 'MMM d, y',
	  short: 'MM/dd/yyyy'
	};
	var timeFormats = {
	  full: 'h:mm:ss a zzzz',
	  long: 'h:mm:ss a z',
	  medium: 'h:mm:ss a',
	  short: 'h:mm a'
	};
	var dateTimeFormats = {
	  full: "{{date}} 'at' {{time}}",
	  long: "{{date}} 'at' {{time}}",
	  medium: '{{date}}, {{time}}',
	  short: '{{date}}, {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1147 */
1135,
/* 1148 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(107));
	
	var _index2 = _interopRequireDefault(__webpack_require__(91));
	
	var _index3 = _interopRequireDefault(__webpack_require__(92));
	
	var _index4 = _interopRequireDefault(__webpack_require__(93));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1147));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary English locale (South Africa).
	 * @language English
	 * @iso-639-2 eng
	 * @author Shaila Kavrakova [@shaykav]{@link https://github.com/shaykav}
	 */
	var locale = {
	  code: 'en-ZA',
	  formatDistance: _index.default,
	  formatLong: _index5.default,
	  formatRelative: _index2.default,
	  localize: _index3.default,
	  match: _index4.default,
	  options: {
	    weekStartsOn: 0,
	    // Sunday is the first day of the week.
	    firstWeekContainsDate: 1 // The week that contains Jan 1st is the first week of the year.
	
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1149 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    one: 'malpli ol sekundo',
	    other: 'malpli ol {{count}} sekundoj'
	  },
	  xSeconds: {
	    one: '1 sekundo',
	    other: '{{count}} sekundoj'
	  },
	  halfAMinute: 'duonminuto',
	  lessThanXMinutes: {
	    one: 'malpli ol minuto',
	    other: 'malpli ol {{count}} minutoj'
	  },
	  xMinutes: {
	    one: '1 minuto',
	    other: '{{count}} minutoj'
	  },
	  aboutXHours: {
	    one: 'proksimume 1 horo',
	    other: 'proksimume {{count}} horoj'
	  },
	  xHours: {
	    one: '1 horo',
	    other: '{{count}} horoj'
	  },
	  xDays: {
	    one: '1 tago',
	    other: '{{count}} tagoj'
	  },
	  aboutXMonths: {
	    one: 'proksimume 1 monato',
	    other: 'proksimume {{count}} monatoj'
	  },
	  xWeeks: {
	    one: '1 semajno',
	    other: '{{count}} semajnoj'
	  },
	  aboutXWeeks: {
	    one: 'proksimume 1 semajno',
	    other: 'proksimume {{count}} semajnoj'
	  },
	  xMonths: {
	    one: '1 monato',
	    other: '{{count}} monatoj'
	  },
	  aboutXYears: {
	    one: 'proksimume 1 jaro',
	    other: 'proksimume {{count}} jaroj'
	  },
	  xYears: {
	    one: '1 jaro',
	    other: '{{count}} jaroj'
	  },
	  overXYears: {
	    one: 'pli ol 1 jaro',
	    other: 'pli ol {{count}} jaroj'
	  },
	  almostXYears: {
	    one: 'preskaŭ 1 jaro',
	    other: 'preskaŭ {{count}} jaroj'
	  }
	};
	
	var formatDistance = function (token, count, options) {
	  var result;
	  var tokenValue = formatDistanceLocale[token];
	
	  if (typeof tokenValue === 'string') {
	    result = tokenValue;
	  } else if (count === 1) {
	    result = tokenValue.one;
	  } else {
	    result = tokenValue.other.replace('{{count}}', String(count));
	  }
	
	  if (options !== null && options !== void 0 && options.addSuffix) {
	    if (options !== null && options !== void 0 && options.comparison && options.comparison > 0) {
	      return 'post ' + result;
	    } else {
	      return 'antaŭ ' + result;
	    }
	  }
	
	  return result;
	};
	
	var _default = formatDistance;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1150 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: "EEEE, do 'de' MMMM y",
	  long: 'y-MMMM-dd',
	  medium: 'y-MMM-dd',
	  short: 'yyyy-MM-dd'
	};
	var timeFormats = {
	  full: "Ho 'horo kaj' m:ss zzzz",
	  long: 'HH:mm:ss z',
	  medium: 'HH:mm:ss',
	  short: 'HH:mm'
	};
	var dateTimeFormats = {
	  any: '{{date}} {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'any'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1151 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var formatRelativeLocale = {
	  lastWeek: "'pasinta' eeee 'je' p",
	  yesterday: "'hieraŭ je' p",
	  today: "'hodiaŭ je' p",
	  tomorrow: "'morgaŭ je' p",
	  nextWeek: "eeee 'je' p",
	  other: 'P'
	};
	
	var formatRelative = function (token, _date, _baseDate, _options) {
	  return formatRelativeLocale[token];
	};
	
	var _default = formatRelative;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1152 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eraValues = {
	  narrow: ['aK', 'pK'],
	  abbreviated: ['a.K.E.', 'p.K.E.'],
	  wide: ['antaŭ Komuna Erao', 'Komuna Erao']
	};
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['K1', 'K2', 'K3', 'K4'],
	  wide: ['1-a kvaronjaro', '2-a kvaronjaro', '3-a kvaronjaro', '4-a kvaronjaro']
	};
	var monthValues = {
	  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
	  abbreviated: ['jan', 'feb', 'mar', 'apr', 'maj', 'jun', 'jul', 'aŭg', 'sep', 'okt', 'nov', 'dec'],
	  wide: ['januaro', 'februaro', 'marto', 'aprilo', 'majo', 'junio', 'julio', 'aŭgusto', 'septembro', 'oktobro', 'novembro', 'decembro']
	};
	var dayValues = {
	  narrow: ['D', 'L', 'M', 'M', 'Ĵ', 'V', 'S'],
	  short: ['di', 'lu', 'ma', 'me', 'ĵa', 've', 'sa'],
	  abbreviated: ['dim', 'lun', 'mar', 'mer', 'ĵaŭ', 'ven', 'sab'],
	  wide: ['dimanĉo', 'lundo', 'mardo', 'merkredo', 'ĵaŭdo', 'vendredo', 'sabato']
	};
	var dayPeriodValues = {
	  narrow: {
	    am: 'a',
	    pm: 'p',
	    midnight: 'noktomezo',
	    noon: 'tagmezo',
	    morning: 'matene',
	    afternoon: 'posttagmeze',
	    evening: 'vespere',
	    night: 'nokte'
	  },
	  abbreviated: {
	    am: 'a.t.m.',
	    pm: 'p.t.m.',
	    midnight: 'noktomezo',
	    noon: 'tagmezo',
	    morning: 'matene',
	    afternoon: 'posttagmeze',
	    evening: 'vespere',
	    night: 'nokte'
	  },
	  wide: {
	    am: 'antaŭtagmeze',
	    pm: 'posttagmeze',
	    midnight: 'noktomezo',
	    noon: 'tagmezo',
	    morning: 'matene',
	    afternoon: 'posttagmeze',
	    evening: 'vespere',
	    night: 'nokte'
	  }
	};
	
	var ordinalNumber = function (dirtyNumber) {
	  var number = Number(dirtyNumber);
	  return number + '-a';
	};
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1153 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(15));
	
	var _index2 = _interopRequireDefault(__webpack_require__(14));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(\d+)(-?a)?/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^([ap]k)/i,
	  abbreviated: /^([ap]\.?\s?k\.?\s?e\.?)/i,
	  wide: /^((antaǔ |post )?komuna erao)/i
	};
	var parseEraPatterns = {
	  any: [/^a/i, /^[kp]/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^k[1234]/i,
	  wide: /^[1234](-?a)? kvaronjaro/i
	};
	var parseQuarterPatterns = {
	  any: [/1/i, /2/i, /3/i, /4/i]
	};
	var matchMonthPatterns = {
	  narrow: /^[jfmasond]/i,
	  abbreviated: /^(jan|feb|mar|apr|maj|jun|jul|a(ŭ|ux|uh|u)g|sep|okt|nov|dec)/i,
	  wide: /^(januaro|februaro|marto|aprilo|majo|junio|julio|a(ŭ|ux|uh|u)gusto|septembro|oktobro|novembro|decembro)/i
	};
	var parseMonthPatterns = {
	  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
	  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^maj/i, /^jun/i, /^jul/i, /^a(u|ŭ)/i, /^s/i, /^o/i, /^n/i, /^d/i]
	};
	var matchDayPatterns = {
	  narrow: /^[dlmĵjvs]/i,
	  short: /^(di|lu|ma|me|(ĵ|jx|jh|j)a|ve|sa)/i,
	  abbreviated: /^(dim|lun|mar|mer|(ĵ|jx|jh|j)a(ŭ|ux|uh|u)|ven|sab)/i,
	  wide: /^(diman(ĉ|cx|ch|c)o|lundo|mardo|merkredo|(ĵ|jx|jh|j)a(ŭ|ux|uh|u)do|vendredo|sabato)/i
	};
	var parseDayPatterns = {
	  narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^(j|ĵ)/i, /^v/i, /^s/i],
	  any: [/^d/i, /^l/i, /^ma/i, /^me/i, /^(j|ĵ)/i, /^v/i, /^s/i]
	};
	var matchDayPeriodPatterns = {
	  narrow: /^([ap]|(posttagmez|noktomez|tagmez|maten|vesper|nokt)[eo])/i,
	  abbreviated: /^([ap][.\s]?t[.\s]?m[.\s]?|(posttagmez|noktomez|tagmez|maten|vesper|nokt)[eo])/i,
	  wide: /^(anta(ŭ|ux)tagmez|posttagmez|noktomez|tagmez|maten|vesper|nokt)[eo]/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^a/i,
	    pm: /^p/i,
	    midnight: /^noktom/i,
	    noon: /^t/i,
	    morning: /^m/i,
	    afternoon: /^posttagmeze/i,
	    evening: /^v/i,
	    night: /^n/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index2.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index2.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index2.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index2.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index2.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1154 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1149));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1150));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1151));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1152));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1153));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Esperanto locale.
	 * @language Esperanto
	 * @iso-639-2 epo
	 * @author date-fns
	 */
	var locale = {
	  code: 'eo',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 1
	    /* Monday */
	    ,
	    firstWeekContainsDate: 4
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1155 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    one: 'menos de un segundo',
	    other: 'menos de {{count}} segundos'
	  },
	  xSeconds: {
	    one: '1 segundo',
	    other: '{{count}} segundos'
	  },
	  halfAMinute: 'medio minuto',
	  lessThanXMinutes: {
	    one: 'menos de un minuto',
	    other: 'menos de {{count}} minutos'
	  },
	  xMinutes: {
	    one: '1 minuto',
	    other: '{{count}} minutos'
	  },
	  aboutXHours: {
	    one: 'alrededor de 1 hora',
	    other: 'alrededor de {{count}} horas'
	  },
	  xHours: {
	    one: '1 hora',
	    other: '{{count}} horas'
	  },
	  xDays: {
	    one: '1 día',
	    other: '{{count}} días'
	  },
	  aboutXWeeks: {
	    one: 'alrededor de 1 semana',
	    other: 'alrededor de {{count}} semanas'
	  },
	  xWeeks: {
	    one: '1 semana',
	    other: '{{count}} semanas'
	  },
	  aboutXMonths: {
	    one: 'alrededor de 1 mes',
	    other: 'alrededor de {{count}} meses'
	  },
	  xMonths: {
	    one: '1 mes',
	    other: '{{count}} meses'
	  },
	  aboutXYears: {
	    one: 'alrededor de 1 año',
	    other: 'alrededor de {{count}} años'
	  },
	  xYears: {
	    one: '1 año',
	    other: '{{count}} años'
	  },
	  overXYears: {
	    one: 'más de 1 año',
	    other: 'más de {{count}} años'
	  },
	  almostXYears: {
	    one: 'casi 1 año',
	    other: 'casi {{count}} años'
	  }
	};
	
	var formatDistance = function (token, count, options) {
	  var result;
	  var tokenValue = formatDistanceLocale[token];
	
	  if (typeof tokenValue === 'string') {
	    result = tokenValue;
	  } else if (count === 1) {
	    result = tokenValue.one;
	  } else {
	    result = tokenValue.other.replace('{{count}}', count.toString());
	  }
	
	  if (options !== null && options !== void 0 && options.addSuffix) {
	    if (options.comparison && options.comparison > 0) {
	      return 'en ' + result;
	    } else {
	      return 'hace ' + result;
	    }
	  }
	
	  return result;
	};
	
	var _default = formatDistance;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1156 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: "EEEE, d 'de' MMMM 'de' y",
	  long: "d 'de' MMMM 'de' y",
	  medium: 'd MMM y',
	  short: 'dd/MM/y'
	};
	var timeFormats = {
	  full: 'HH:mm:ss zzzz',
	  long: 'HH:mm:ss z',
	  medium: 'HH:mm:ss',
	  short: 'HH:mm'
	};
	var dateTimeFormats = {
	  full: "{{date}} 'a las' {{time}}",
	  long: "{{date}} 'a las' {{time}}",
	  medium: '{{date}}, {{time}}',
	  short: '{{date}}, {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1157 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var formatRelativeLocale = {
	  lastWeek: "'el' eeee 'pasado a la' p",
	  yesterday: "'ayer a la' p",
	  today: "'hoy a la' p",
	  tomorrow: "'mañana a la' p",
	  nextWeek: "eeee 'a la' p",
	  other: 'P'
	};
	var formatRelativeLocalePlural = {
	  lastWeek: "'el' eeee 'pasado a las' p",
	  yesterday: "'ayer a las' p",
	  today: "'hoy a las' p",
	  tomorrow: "'mañana a las' p",
	  nextWeek: "eeee 'a las' p",
	  other: 'P'
	};
	
	var formatRelative = function (token, date, _baseDate, _options) {
	  if (date.getUTCHours() !== 1) {
	    return formatRelativeLocalePlural[token];
	  } else {
	    return formatRelativeLocale[token];
	  }
	};
	
	var _default = formatRelative;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1158 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eraValues = {
	  narrow: ['AC', 'DC'],
	  abbreviated: ['AC', 'DC'],
	  wide: ['antes de cristo', 'después de cristo']
	};
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['T1', 'T2', 'T3', 'T4'],
	  wide: ['1º trimestre', '2º trimestre', '3º trimestre', '4º trimestre']
	};
	var monthValues = {
	  narrow: ['e', 'f', 'm', 'a', 'm', 'j', 'j', 'a', 's', 'o', 'n', 'd'],
	  abbreviated: ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'],
	  wide: ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre']
	};
	var dayValues = {
	  narrow: ['d', 'l', 'm', 'm', 'j', 'v', 's'],
	  short: ['do', 'lu', 'ma', 'mi', 'ju', 'vi', 'sá'],
	  abbreviated: ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'],
	  wide: ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado']
	};
	var dayPeriodValues = {
	  narrow: {
	    am: 'a',
	    pm: 'p',
	    midnight: 'mn',
	    noon: 'md',
	    morning: 'mañana',
	    afternoon: 'tarde',
	    evening: 'tarde',
	    night: 'noche'
	  },
	  abbreviated: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'medianoche',
	    noon: 'mediodia',
	    morning: 'mañana',
	    afternoon: 'tarde',
	    evening: 'tarde',
	    night: 'noche'
	  },
	  wide: {
	    am: 'a.m.',
	    pm: 'p.m.',
	    midnight: 'medianoche',
	    noon: 'mediodia',
	    morning: 'mañana',
	    afternoon: 'tarde',
	    evening: 'tarde',
	    night: 'noche'
	  }
	};
	var formattingDayPeriodValues = {
	  narrow: {
	    am: 'a',
	    pm: 'p',
	    midnight: 'mn',
	    noon: 'md',
	    morning: 'de la mañana',
	    afternoon: 'de la tarde',
	    evening: 'de la tarde',
	    night: 'de la noche'
	  },
	  abbreviated: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'medianoche',
	    noon: 'mediodia',
	    morning: 'de la mañana',
	    afternoon: 'de la tarde',
	    evening: 'de la tarde',
	    night: 'de la noche'
	  },
	  wide: {
	    am: 'a.m.',
	    pm: 'p.m.',
	    midnight: 'medianoche',
	    noon: 'mediodia',
	    morning: 'de la mañana',
	    afternoon: 'de la tarde',
	    evening: 'de la tarde',
	    night: 'de la noche'
	  }
	};
	
	var ordinalNumber = function (dirtyNumber, _options) {
	  var number = Number(dirtyNumber);
	  return number + 'º';
	};
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingDayPeriodValues,
	    defaultFormattingWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1159 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(15));
	
	var _index2 = _interopRequireDefault(__webpack_require__(14));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(\d+)(º)?/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^(ac|dc|a|d)/i,
	  abbreviated: /^(a\.?\s?c\.?|a\.?\s?e\.?\s?c\.?|d\.?\s?c\.?|e\.?\s?c\.?)/i,
	  wide: /^(antes de cristo|antes de la era com[uú]n|despu[eé]s de cristo|era com[uú]n)/i
	};
	var parseEraPatterns = {
	  any: [/^ac/i, /^dc/i],
	  wide: [/^(antes de cristo|antes de la era com[uú]n)/i, /^(despu[eé]s de cristo|era com[uú]n)/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^T[1234]/i,
	  wide: /^[1234](º)? trimestre/i
	};
	var parseQuarterPatterns = {
	  any: [/1/i, /2/i, /3/i, /4/i]
	};
	var matchMonthPatterns = {
	  narrow: /^[efmajsond]/i,
	  abbreviated: /^(ene|feb|mar|abr|may|jun|jul|ago|sep|oct|nov|dic)/i,
	  wide: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i
	};
	var parseMonthPatterns = {
	  narrow: [/^e/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
	  any: [/^en/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i]
	};
	var matchDayPatterns = {
	  narrow: /^[dlmjvs]/i,
	  short: /^(do|lu|ma|mi|ju|vi|s[áa])/i,
	  abbreviated: /^(dom|lun|mar|mi[ée]|jue|vie|s[áa]b)/i,
	  wide: /^(domingo|lunes|martes|mi[ée]rcoles|jueves|viernes|s[áa]bado)/i
	};
	var parseDayPatterns = {
	  narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^j/i, /^v/i, /^s/i],
	  any: [/^do/i, /^lu/i, /^ma/i, /^mi/i, /^ju/i, /^vi/i, /^sa/i]
	};
	var matchDayPeriodPatterns = {
	  narrow: /^(a|p|mn|md|(de la|a las) (mañana|tarde|noche))/i,
	  any: /^([ap]\.?\s?m\.?|medianoche|mediodia|(de la|a las) (mañana|tarde|noche))/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^a/i,
	    pm: /^p/i,
	    midnight: /^mn/i,
	    noon: /^md/i,
	    morning: /mañana/i,
	    afternoon: /tarde/i,
	    evening: /tarde/i,
	    night: /noche/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index2.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index2.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index2.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index2.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index2.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1160 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1155));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1156));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1157));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1158));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1159));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Spanish locale.
	 * @language Spanish
	 * @iso-639-2 spa
	 * @author Juan Angosto [@juanangosto]{@link https://github.com/juanangosto}
	 * @author Guillermo Grau [@guigrpa]{@link https://github.com/guigrpa}
	 * @author Fernando Agüero [@fjaguero]{@link https://github.com/fjaguero}
	 * @author Gastón Haro [@harogaston]{@link https://github.com/harogaston}
	 * @author Yago Carballo [@YagoCarballo]{@link https://github.com/YagoCarballo}
	 */
	var locale = {
	  code: 'es',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 1
	    /* Monday */
	    ,
	    firstWeekContainsDate: 1
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1161 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistance;
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    standalone: {
	      one: 'vähem kui üks sekund',
	      other: 'vähem kui {{count}} sekundit'
	    },
	    withPreposition: {
	      one: 'vähem kui ühe sekundi',
	      other: 'vähem kui {{count}} sekundi'
	    }
	  },
	  xSeconds: {
	    standalone: {
	      one: 'üks sekund',
	      other: '{{count}} sekundit'
	    },
	    withPreposition: {
	      one: 'ühe sekundi',
	      other: '{{count}} sekundi'
	    }
	  },
	  halfAMinute: {
	    standalone: 'pool minutit',
	    withPreposition: 'poole minuti'
	  },
	  lessThanXMinutes: {
	    standalone: {
	      one: 'vähem kui üks minut',
	      other: 'vähem kui {{count}} minutit'
	    },
	    withPreposition: {
	      one: 'vähem kui ühe minuti',
	      other: 'vähem kui {{count}} minuti'
	    }
	  },
	  xMinutes: {
	    standalone: {
	      one: 'üks minut',
	      other: '{{count}} minutit'
	    },
	    withPreposition: {
	      one: 'ühe minuti',
	      other: '{{count}} minuti'
	    }
	  },
	  aboutXHours: {
	    standalone: {
	      one: 'umbes üks tund',
	      other: 'umbes {{count}} tundi'
	    },
	    withPreposition: {
	      one: 'umbes ühe tunni',
	      other: 'umbes {{count}} tunni'
	    }
	  },
	  xHours: {
	    standalone: {
	      one: 'üks tund',
	      other: '{{count}} tundi'
	    },
	    withPreposition: {
	      one: 'ühe tunni',
	      other: '{{count}} tunni'
	    }
	  },
	  xDays: {
	    standalone: {
	      one: 'üks päev',
	      other: '{{count}} päeva'
	    },
	    withPreposition: {
	      one: 'ühe päeva',
	      other: '{{count}} päeva'
	    }
	  },
	  aboutXWeeks: {
	    standalone: {
	      one: 'umbes üks nädal',
	      other: 'umbes {{count}} nädalat'
	    },
	    withPreposition: {
	      one: 'umbes ühe nädala',
	      other: 'umbes {{count}} nädala'
	    }
	  },
	  xWeeks: {
	    standalone: {
	      one: 'üks nädal',
	      other: '{{count}} nädalat'
	    },
	    withPreposition: {
	      one: 'ühe nädala',
	      other: '{{count}} nädala'
	    }
	  },
	  aboutXMonths: {
	    standalone: {
	      one: 'umbes üks kuu',
	      other: 'umbes {{count}} kuud'
	    },
	    withPreposition: {
	      one: 'umbes ühe kuu',
	      other: 'umbes {{count}} kuu'
	    }
	  },
	  xMonths: {
	    standalone: {
	      one: 'üks kuu',
	      other: '{{count}} kuud'
	    },
	    withPreposition: {
	      one: 'ühe kuu',
	      other: '{{count}} kuu'
	    }
	  },
	  aboutXYears: {
	    standalone: {
	      one: 'umbes üks aasta',
	      other: 'umbes {{count}} aastat'
	    },
	    withPreposition: {
	      one: 'umbes ühe aasta',
	      other: 'umbes {{count}} aasta'
	    }
	  },
	  xYears: {
	    standalone: {
	      one: 'üks aasta',
	      other: '{{count}} aastat'
	    },
	    withPreposition: {
	      one: 'ühe aasta',
	      other: '{{count}} aasta'
	    }
	  },
	  overXYears: {
	    standalone: {
	      one: 'rohkem kui üks aasta',
	      other: 'rohkem kui {{count}} aastat'
	    },
	    withPreposition: {
	      one: 'rohkem kui ühe aasta',
	      other: 'rohkem kui {{count}} aasta'
	    }
	  },
	  almostXYears: {
	    standalone: {
	      one: 'peaaegu üks aasta',
	      other: 'peaaegu {{count}} aastat'
	    },
	    withPreposition: {
	      one: 'peaaegu ühe aasta',
	      other: 'peaaegu {{count}} aasta'
	    }
	  }
	};
	
	function formatDistance(token, count, options) {
	  options = options || {};
	  var usageGroup = options.addSuffix ? formatDistanceLocale[token].withPreposition : formatDistanceLocale[token].standalone;
	  var result;
	
	  if (typeof usageGroup === 'string') {
	    result = usageGroup;
	  } else if (count === 1) {
	    result = usageGroup.one;
	  } else {
	    result = usageGroup.other.replace('{{count}}', count);
	  }
	
	  if (options.addSuffix) {
	    if (options.comparison > 0) {
	      return result + ' pärast';
	    } else {
	      return result + ' eest';
	    }
	  }
	
	  return result;
	}
	
	module.exports = exports.default;

/***/ },
/* 1162 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: 'EEEE, d. MMMM y',
	  long: 'd. MMMM y',
	  medium: 'd. MMM y',
	  short: 'dd.MM.y'
	};
	var timeFormats = {
	  full: 'HH:mm:ss zzzz',
	  long: 'HH:mm:ss z',
	  medium: 'HH:mm:ss',
	  short: 'HH:mm'
	};
	var dateTimeFormats = {
	  full: "{{date}} 'kell' {{time}}",
	  long: "{{date}} 'kell' {{time}}",
	  medium: '{{date}}. {{time}}',
	  short: '{{date}}. {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1163 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRelative;
	var formatRelativeLocale = {
	  lastWeek: "'eelmine' eeee 'kell' p",
	  yesterday: "'eile kell' p",
	  today: "'täna kell' p",
	  tomorrow: "'homme kell' p",
	  nextWeek: "'järgmine' eeee 'kell' p",
	  other: 'P'
	};
	
	function formatRelative(token, _date, _baseDate, _options) {
	  return formatRelativeLocale[token];
	}
	
	module.exports = exports.default;

/***/ },
/* 1164 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eraValues = {
	  narrow: ['e.m.a', 'm.a.j'],
	  abbreviated: ['e.m.a', 'm.a.j'],
	  wide: ['enne meie ajaarvamist', 'meie ajaarvamise järgi']
	};
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['K1', 'K2', 'K3', 'K4'],
	  wide: ['1. kvartal', '2. kvartal', '3. kvartal', '4. kvartal']
	};
	var monthValues = {
	  narrow: ['J', 'V', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
	  abbreviated: ['jaan', 'veebr', 'märts', 'apr', 'mai', 'juuni', 'juuli', 'aug', 'sept', 'okt', 'nov', 'dets'],
	  wide: ['jaanuar', 'veebruar', 'märts', 'aprill', 'mai', 'juuni', 'juuli', 'august', 'september', 'oktoober', 'november', 'detsember']
	};
	var dayValues = {
	  narrow: ['P', 'E', 'T', 'K', 'N', 'R', 'L'],
	  short: ['P', 'E', 'T', 'K', 'N', 'R', 'L'],
	  abbreviated: ['pühap.', 'esmasp.', 'teisip.', 'kolmap.', 'neljap.', 'reede.', 'laup.'],
	  wide: ['pühapäev', 'esmaspäev', 'teisipäev', 'kolmapäev', 'neljapäev', 'reede', 'laupäev']
	};
	var dayPeriodValues = {
	  narrow: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'kesköö',
	    noon: 'keskpäev',
	    morning: 'hommik',
	    afternoon: 'pärastlõuna',
	    evening: 'õhtu',
	    night: 'öö'
	  },
	  abbreviated: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'kesköö',
	    noon: 'keskpäev',
	    morning: 'hommik',
	    afternoon: 'pärastlõuna',
	    evening: 'õhtu',
	    night: 'öö'
	  },
	  wide: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'kesköö',
	    noon: 'keskpäev',
	    morning: 'hommik',
	    afternoon: 'pärastlõuna',
	    evening: 'õhtu',
	    night: 'öö'
	  }
	};
	var formattingDayPeriodValues = {
	  narrow: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'keskööl',
	    noon: 'keskpäeval',
	    morning: 'hommikul',
	    afternoon: 'pärastlõunal',
	    evening: 'õhtul',
	    night: 'öösel'
	  },
	  abbreviated: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'keskööl',
	    noon: 'keskpäeval',
	    morning: 'hommikul',
	    afternoon: 'pärastlõunal',
	    evening: 'õhtul',
	    night: 'öösel'
	  },
	  wide: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'keskööl',
	    noon: 'keskpäeval',
	    morning: 'hommikul',
	    afternoon: 'pärastlõunal',
	    evening: 'õhtul',
	    night: 'öösel'
	  }
	};
	
	function ordinalNumber(dirtyNumber) {
	  var number = Number(dirtyNumber);
	  return number + '.';
	}
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    formattingValues: monthValues,
	    defaultWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    formattingValues: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    formattingValues: formattingDayPeriodValues,
	    defaultWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1165 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(15));
	
	var _index2 = _interopRequireDefault(__webpack_require__(14));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^\d+\./i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^(e\.m\.a|m\.a\.j|eKr|pKr)/i,
	  abbreviated: /^(e\.m\.a|m\.a\.j|eKr|pKr)/i,
	  wide: /^(enne meie ajaarvamist|meie ajaarvamise järgi|enne Kristust|pärast Kristust)/i
	};
	var parseEraPatterns = {
	  any: [/^e/i, /^(m|p)/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^K[1234]/i,
	  wide: /^[1234](\.)? kvartal/i
	};
	var parseQuarterPatterns = {
	  any: [/1/i, /2/i, /3/i, /4/i]
	};
	var matchMonthPatterns = {
	  narrow: /^[jvmasond]/i,
	  abbreviated: /^(jaan|veebr|märts|apr|mai|juuni|juuli|aug|sept|okt|nov|dets)/i,
	  wide: /^(jaanuar|veebruar|märts|aprill|mai|juuni|juuli|august|september|oktoober|november|detsember)/i
	};
	var parseMonthPatterns = {
	  narrow: [/^j/i, /^v/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
	  any: [/^ja/i, /^v/i, /^mär/i, /^ap/i, /^mai/i, /^juun/i, /^juul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
	};
	var matchDayPatterns = {
	  narrow: /^[petknrl]/i,
	  short: /^[petknrl]/i,
	  abbreviated: /^(püh?|esm?|tei?|kolm?|nel?|ree?|laup?)\.?/i,
	  wide: /^(pühapäev|esmaspäev|teisipäev|kolmapäev|neljapäev|reede|laupäev)/i
	};
	var parseDayPatterns = {
	  any: [/^p/i, /^e/i, /^t/i, /^k/i, /^n/i, /^r/i, /^l/i]
	};
	var matchDayPeriodPatterns = {
	  any: /^(am|pm|keskööl?|keskpäev(al)?|hommik(ul)?|pärastlõunal?|õhtul?|öö(sel)?)/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^a/i,
	    pm: /^p/i,
	    midnight: /^keskö/i,
	    noon: /^keskp/i,
	    morning: /hommik/i,
	    afternoon: /pärastlõuna/i,
	    evening: /õhtu/i,
	    night: /öö/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index2.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index2.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index2.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index2.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index2.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1166 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1161));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1162));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1163));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1164));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1165));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Estonian locale.
	 * @language Estonian
	 * @iso-639-2 est
	 * @author Priit Hansen [@HansenPriit]{@link https://github.com/priithansen}
	 */
	var locale = {
	  code: 'et',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 1
	    /* Monday */
	    ,
	    firstWeekContainsDate: 4
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1167 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistance;
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    one: 'segundo bat baino gutxiago',
	    other: '{{count}} segundo baino gutxiago'
	  },
	  xSeconds: {
	    one: '1 segundo',
	    other: '{{count}} segundo'
	  },
	  halfAMinute: 'minutu erdi',
	  lessThanXMinutes: {
	    one: 'minutu bat baino gutxiago',
	    other: '{{count}} minutu baino gutxiago'
	  },
	  xMinutes: {
	    one: '1 minutu',
	    other: '{{count}} minutu'
	  },
	  aboutXHours: {
	    one: '1 ordu gutxi gorabehera',
	    other: '{{count}} ordu gutxi gorabehera'
	  },
	  xHours: {
	    one: '1 ordu',
	    other: '{{count}} ordu'
	  },
	  xDays: {
	    one: '1 egun',
	    other: '{{count}} egun'
	  },
	  aboutXWeeks: {
	    one: 'aste 1 inguru',
	    other: '{{count}} aste inguru'
	  },
	  xWeeks: {
	    one: '1 aste',
	    other: '{{count}} astean'
	  },
	  aboutXMonths: {
	    one: '1 hilabete gutxi gorabehera',
	    other: '{{count}} hilabete gutxi gorabehera'
	  },
	  xMonths: {
	    one: '1 hilabete',
	    other: '{{count}} hilabete'
	  },
	  aboutXYears: {
	    one: '1 urte gutxi gorabehera',
	    other: '{{count}} urte gutxi gorabehera'
	  },
	  xYears: {
	    one: '1 urte',
	    other: '{{count}} urte'
	  },
	  overXYears: {
	    one: '1 urte baino gehiago',
	    other: '{{count}} urte baino gehiago'
	  },
	  almostXYears: {
	    one: 'ia 1 urte',
	    other: 'ia {{count}} urte'
	  }
	};
	
	function formatDistance(token, count, options) {
	  options = options || {};
	  var result;
	
	  if (typeof formatDistanceLocale[token] === 'string') {
	    result = formatDistanceLocale[token];
	  } else if (count === 1) {
	    result = formatDistanceLocale[token].one;
	  } else {
	    result = formatDistanceLocale[token].other.replace('{{count}}', count);
	  }
	
	  if (options.addSuffix) {
	    if (options.comparison > 0) {
	      return 'en ' + result;
	    } else {
	      return 'duela ' + result;
	    }
	  }
	
	  return result;
	}
	
	module.exports = exports.default;

/***/ },
/* 1168 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: "EEEE, y'ko' MMMM'ren' d'a' y'ren'",
	  long: "y'ko' MMMM'ren' d'a'",
	  medium: 'y MMM d',
	  short: 'yy/MM/dd'
	};
	var timeFormats = {
	  full: 'HH:mm:ss zzzz',
	  long: 'HH:mm:ss z',
	  medium: 'HH:mm:ss',
	  short: 'HH:mm'
	};
	var dateTimeFormats = {
	  full: "{{date}} 'tan' {{time}}",
	  long: "{{date}} 'tan' {{time}}",
	  medium: '{{date}}, {{time}}',
	  short: '{{date}}, {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1169 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRelative;
	var formatRelativeLocale = {
	  lastWeek: "'joan den' eeee, LT",
	  yesterday: "'atzo,' p",
	  today: "'gaur,' p",
	  tomorrow: "'bihar,' p",
	  nextWeek: 'eeee, p',
	  other: 'P'
	};
	var formatRelativeLocalePlural = {
	  lastWeek: "'joan den' eeee, p",
	  yesterday: "'atzo,' p",
	  today: "'gaur,' p",
	  tomorrow: "'bihar,' p",
	  nextWeek: 'eeee, p',
	  other: 'P'
	};
	
	function formatRelative(token, date, _baseDate, _options) {
	  if (date.getUTCHours() !== 1) {
	    return formatRelativeLocalePlural[token];
	  }
	
	  return formatRelativeLocale[token];
	}
	
	module.exports = exports.default;

/***/ },
/* 1170 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eraValues = {
	  narrow: ['k.a.', 'k.o.'],
	  abbreviated: ['k.a.', 'k.o.'],
	  wide: ['kristo aurretik', 'kristo ondoren']
	};
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['1H', '2H', '3H', '4H'],
	  wide: ['1. hiruhilekoa', '2. hiruhilekoa', '3. hiruhilekoa', '4. hiruhilekoa']
	};
	var monthValues = {
	  narrow: ['u', 'o', 'm', 'a', 'm', 'e', 'u', 'a', 'i', 'u', 'a', 'a'],
	  abbreviated: ['urt', 'ots', 'mar', 'api', 'mai', 'eka', 'uzt', 'abu', 'ira', 'urr', 'aza', 'abe'],
	  wide: ['urtarrila', 'otsaila', 'martxoa', 'apirila', 'maiatza', 'ekaina', 'uztaila', 'abuztua', 'iraila', 'urria', 'azaroa', 'abendua']
	};
	var dayValues = {
	  narrow: ['i', 'a', 'a', 'a', 'o', 'o', 'l'],
	  short: ['ig', 'al', 'as', 'az', 'og', 'or', 'lr'],
	  abbreviated: ['iga', 'ast', 'ast', 'ast', 'ost', 'ost', 'lar'],
	  wide: ['igandea', 'astelehena', 'asteartea', 'asteazkena', 'osteguna', 'ostirala', 'larunbata']
	};
	var dayPeriodValues = {
	  narrow: {
	    am: 'a',
	    pm: 'p',
	    midnight: 'ge',
	    noon: 'eg',
	    morning: 'goiza',
	    afternoon: 'arratsaldea',
	    evening: 'arratsaldea',
	    night: 'gaua'
	  },
	  abbreviated: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'gauerdia',
	    noon: 'eguerdia',
	    morning: 'goiza',
	    afternoon: 'arratsaldea',
	    evening: 'arratsaldea',
	    night: 'gaua'
	  },
	  wide: {
	    am: 'a.m.',
	    pm: 'p.m.',
	    midnight: 'gauerdia',
	    noon: 'eguerdia',
	    morning: 'goiza',
	    afternoon: 'arratsaldea',
	    evening: 'arratsaldea',
	    night: 'gaua'
	  }
	};
	var formattingDayPeriodValues = {
	  narrow: {
	    am: 'a',
	    pm: 'p',
	    midnight: 'ge',
	    noon: 'eg',
	    morning: 'goizean',
	    afternoon: 'arratsaldean',
	    evening: 'arratsaldean',
	    night: 'gauean'
	  },
	  abbreviated: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'gauerdia',
	    noon: 'eguerdia',
	    morning: 'goizean',
	    afternoon: 'arratsaldean',
	    evening: 'arratsaldean',
	    night: 'gauean'
	  },
	  wide: {
	    am: 'a.m.',
	    pm: 'p.m.',
	    midnight: 'gauerdia',
	    noon: 'eguerdia',
	    morning: 'goizean',
	    afternoon: 'arratsaldean',
	    evening: 'arratsaldean',
	    night: 'gauean'
	  }
	};
	
	function ordinalNumber(dirtyNumber) {
	  var number = Number(dirtyNumber);
	  return number + '.';
	}
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingDayPeriodValues,
	    defaultFormattingWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1171 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(15));
	
	var _index2 = _interopRequireDefault(__webpack_require__(14));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(\d+)(.)?/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^(k.a.|k.o.)/i,
	  abbreviated: /^(k.a.|k.o.)/i,
	  wide: /^(kristo aurretik|kristo ondoren)/i
	};
	var parseEraPatterns = {
	  narrow: [/^k.a./i, /^k.o./i],
	  abbreviated: [/^(k.a.)/i, /^(k.o.)/i],
	  wide: [/^(kristo aurretik)/i, /^(kristo ondoren)/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^[1234]H/i,
	  wide: /^[1234](.)? hiruhilekoa/i
	};
	var parseQuarterPatterns = {
	  any: [/1/i, /2/i, /3/i, /4/i]
	};
	var matchMonthPatterns = {
	  narrow: /^[uomaei]/i,
	  abbreviated: /^(urt|ots|mar|api|mai|eka|uzt|abu|ira|urr|aza|abe)/i,
	  wide: /^(urtarrila|otsaila|martxoa|apirila|maiatza|ekaina|uztaila|abuztua|iraila|urria|azaroa|abendua)/i
	};
	var parseMonthPatterns = {
	  narrow: [/^u/i, /^o/i, /^m/i, /^a/i, /^m/i, /^e/i, /^u/i, /^a/i, /^i/i, /^u/i, /^a/i, /^a/i],
	  any: [/^urt/i, /^ots/i, /^mar/i, /^api/i, /^mai/i, /^eka/i, /^uzt/i, /^abu/i, /^ira/i, /^urr/i, /^aza/i, /^abe/i]
	};
	var matchDayPatterns = {
	  narrow: /^[iaol]/i,
	  short: /^(ig|al|as|az|og|or|lr)/i,
	  abbreviated: /^(iga|ast|ast|ast|ost|ost|lar)/i,
	  wide: /^(igandea|astelehena|asteartea|asteazkena|osteguna|ostirala|larunbata)/i
	};
	var parseDayPatterns = {
	  narrow: [/^i/i, /^a/i, /^a/i, /^a/i, /^o/i, /^o/i, /^l/i],
	  short: [/^ig/i, /^al/i, /^as/i, /^az/i, /^og/i, /^or/i, /^lr/i],
	  abbreviated: [/^iga/i, /^ast/i, /^ast/i, /^ast/i, /^ost/i, /^ost/i, /^lar/i],
	  wide: [/^igandea/i, /^astelehena/i, /^asteartea/i, /^asteazkena/i, /^osteguna/i, /^ostirala/i, /^larunbata/i]
	};
	var matchDayPeriodPatterns = {
	  narrow: /^(a|p|ge|eg|((goiza|goizean)|arratsaldea|(gaua|gauean)))/i,
	  any: /^([ap]\.?\s?m\.?|gauerdia|eguerdia|((goiza|goizean)|arratsaldea|(gaua|gauean)))/i
	};
	var parseDayPeriodPatterns = {
	  narrow: {
	    am: /^a/i,
	    pm: /^p/i,
	    midnight: /^ge/i,
	    noon: /^eg/i,
	    morning: /goiz/i,
	    afternoon: /arratsaldea/i,
	    evening: /arratsaldea/i,
	    night: /gau/i
	  },
	  any: {
	    am: /^a/i,
	    pm: /^p/i,
	    midnight: /^gauerdia/i,
	    noon: /^eguerdia/i,
	    morning: /goiz/i,
	    afternoon: /arratsaldea/i,
	    evening: /arratsaldea/i,
	    night: /gau/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index2.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index2.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index2.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index2.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index2.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1172 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1167));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1168));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1169));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1170));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1171));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Basque locale.
	 * @language Basque
	 * @iso-639-2 eus
	 * @author Jacob Söderblom [@JacobSoderblom]{@link https://github.com/JacobSoderblom}
	 */
	var locale = {
	  code: 'eu',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 1
	    /* Monday */
	    ,
	    firstWeekContainsDate: 1
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1173 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistance;
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    one: 'کمتر از یک ثانیه',
	    other: 'کمتر از {{count}} ثانیه'
	  },
	  xSeconds: {
	    one: '1 ثانیه',
	    other: '{{count}} ثانیه'
	  },
	  halfAMinute: 'نیم دقیقه',
	  lessThanXMinutes: {
	    one: 'کمتر از یک دقیقه',
	    other: 'کمتر از {{count}} دقیقه'
	  },
	  xMinutes: {
	    one: '1 دقیقه',
	    other: '{{count}} دقیقه'
	  },
	  aboutXHours: {
	    one: 'حدود 1 ساعت',
	    other: 'حدود {{count}} ساعت'
	  },
	  xHours: {
	    one: '1 ساعت',
	    other: '{{count}} ساعت'
	  },
	  xDays: {
	    one: '1 روز',
	    other: '{{count}} روز'
	  },
	  aboutXWeeks: {
	    one: 'حدود 1 هفته',
	    other: 'حدود {{count}} هفته'
	  },
	  xWeeks: {
	    one: '1 هفته',
	    other: '{{count}} هفته'
	  },
	  aboutXMonths: {
	    one: 'حدود 1 ماه',
	    other: 'حدود {{count}} ماه'
	  },
	  xMonths: {
	    one: '1 ماه',
	    other: '{{count}} ماه'
	  },
	  aboutXYears: {
	    one: 'حدود 1 سال',
	    other: 'حدود {{count}} سال'
	  },
	  xYears: {
	    one: '1 سال',
	    other: '{{count}} سال'
	  },
	  overXYears: {
	    one: 'بیشتر از 1 سال',
	    other: 'بیشتر از {{count}} سال'
	  },
	  almostXYears: {
	    one: 'نزدیک 1 سال',
	    other: 'نزدیک {{count}} سال'
	  }
	};
	
	function formatDistance(token, count, options) {
	  options = options || {};
	  var result;
	
	  if (typeof formatDistanceLocale[token] === 'string') {
	    result = formatDistanceLocale[token];
	  } else if (count === 1) {
	    result = formatDistanceLocale[token].one;
	  } else {
	    result = formatDistanceLocale[token].other.replace('{{count}}', count);
	  }
	
	  if (options.addSuffix) {
	    if (options.comparison > 0) {
	      return 'در ' + result;
	    } else {
	      return result + ' قبل';
	    }
	  }
	
	  return result;
	}
	
	module.exports = exports.default;

/***/ },
/* 1174 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: 'EEEE do MMMM y',
	  long: 'do MMMM y',
	  medium: 'd MMM y',
	  short: 'yyyy/MM/dd'
	};
	var timeFormats = {
	  full: 'h:mm:ss a zzzz',
	  long: 'h:mm:ss a z',
	  medium: 'h:mm:ss a',
	  short: 'h:mm a'
	};
	var dateTimeFormats = {
	  full: "{{date}} 'در' {{time}}",
	  long: "{{date}} 'در' {{time}}",
	  medium: '{{date}}, {{time}}',
	  short: '{{date}}, {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1175 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRelative;
	var formatRelativeLocale = {
	  lastWeek: "eeee 'گذشته در' p",
	  yesterday: "'دیروز در' p",
	  today: "'امروز در' p",
	  tomorrow: "'فردا در' p",
	  nextWeek: "eeee 'در' p",
	  other: 'P'
	};
	
	function formatRelative(token, _date, _baseDate, _options) {
	  return formatRelativeLocale[token];
	}
	
	module.exports = exports.default;

/***/ },
/* 1176 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eraValues = {
	  narrow: ['ق', 'ب'],
	  abbreviated: ['ق.م.', 'ب.م.'],
	  wide: ['قبل از میلاد', 'بعد از میلاد']
	};
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['س‌م1', 'س‌م2', 'س‌م3', 'س‌م4'],
	  wide: ['سه‌ماهه 1', 'سه‌ماهه 2', 'سه‌ماهه 3', 'سه‌ماهه 4']
	}; // Note: in English, the names of days of the week and months are capitalized.
	// If you are making a new locale based on this one, check if the same is true for the language you're working on.
	// Generally, formatted dates should look like they are in the middle of a sentence,
	// e.g. in Spanish language the weekdays and months should be in the lowercase.
	
	var monthValues = {
	  narrow: ['ژ', 'ف', 'م', 'آ', 'م', 'ج', 'ج', 'آ', 'س', 'ا', 'ن', 'د'],
	  abbreviated: ['ژانـ', 'فور', 'مارس', 'آپر', 'می', 'جون', 'جولـ', 'آگو', 'سپتـ', 'اکتـ', 'نوامـ', 'دسامـ'],
	  wide: ['ژانویه', 'فوریه', 'مارس', 'آپریل', 'می', 'جون', 'جولای', 'آگوست', 'سپتامبر', 'اکتبر', 'نوامبر', 'دسامبر']
	};
	var dayValues = {
	  narrow: ['ی', 'د', 'س', 'چ', 'پ', 'ج', 'ش'],
	  short: ['1ش', '2ش', '3ش', '4ش', '5ش', 'ج', 'ش'],
	  abbreviated: ['یکشنبه', 'دوشنبه', 'سه‌شنبه', 'چهارشنبه', 'پنجشنبه', 'جمعه', 'شنبه'],
	  wide: ['یکشنبه', 'دوشنبه', 'سه‌شنبه', 'چهارشنبه', 'پنجشنبه', 'جمعه', 'شنبه']
	};
	var dayPeriodValues = {
	  narrow: {
	    am: 'ق',
	    pm: 'ب',
	    midnight: 'ن',
	    noon: 'ظ',
	    morning: 'ص',
	    afternoon: 'ب.ظ.',
	    evening: 'ع',
	    night: 'ش'
	  },
	  abbreviated: {
	    am: 'ق.ظ.',
	    pm: 'ب.ظ.',
	    midnight: 'نیمه‌شب',
	    noon: 'ظهر',
	    morning: 'صبح',
	    afternoon: 'بعدازظهر',
	    evening: 'عصر',
	    night: 'شب'
	  },
	  wide: {
	    am: 'قبل‌ازظهر',
	    pm: 'بعدازظهر',
	    midnight: 'نیمه‌شب',
	    noon: 'ظهر',
	    morning: 'صبح',
	    afternoon: 'بعدازظهر',
	    evening: 'عصر',
	    night: 'شب'
	  }
	};
	var formattingDayPeriodValues = {
	  narrow: {
	    am: 'ق',
	    pm: 'ب',
	    midnight: 'ن',
	    noon: 'ظ',
	    morning: 'ص',
	    afternoon: 'ب.ظ.',
	    evening: 'ع',
	    night: 'ش'
	  },
	  abbreviated: {
	    am: 'ق.ظ.',
	    pm: 'ب.ظ.',
	    midnight: 'نیمه‌شب',
	    noon: 'ظهر',
	    morning: 'صبح',
	    afternoon: 'بعدازظهر',
	    evening: 'عصر',
	    night: 'شب'
	  },
	  wide: {
	    am: 'قبل‌ازظهر',
	    pm: 'بعدازظهر',
	    midnight: 'نیمه‌شب',
	    noon: 'ظهر',
	    morning: 'صبح',
	    afternoon: 'بعدازظهر',
	    evening: 'عصر',
	    night: 'شب'
	  }
	};
	
	function ordinalNumber(dirtyNumber) {
	  return String(dirtyNumber);
	}
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingDayPeriodValues,
	    defaultFormattingWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1177 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(15));
	
	var _index2 = _interopRequireDefault(__webpack_require__(14));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^(ق|ب)/i,
	  abbreviated: /^(ق\.?\s?م\.?|ق\.?\s?د\.?\s?م\.?|م\.?\s?|د\.?\s?م\.?)/i,
	  wide: /^(قبل از میلاد|قبل از دوران مشترک|میلادی|دوران مشترک|بعد از میلاد)/i
	};
	var parseEraPatterns = {
	  any: [/^قبل/i, /^بعد/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^س‌م[1234]/i,
	  wide: /^سه‌ماهه [1234]/i
	};
	var parseQuarterPatterns = {
	  any: [/1/i, /2/i, /3/i, /4/i]
	};
	var matchMonthPatterns = {
	  narrow: /^[جژفمآاماسند]/i,
	  abbreviated: /^(جنو|ژانـ|ژانویه|فوریه|فور|مارس|آوریل|آپر|مه|می|ژوئن|جون|جول|جولـ|ژوئیه|اوت|آگو|سپتمبر|سپتامبر|اکتبر|اکتوبر|نوامبر|نوامـ|دسامبر|دسامـ|دسم)/i,
	  wide: /^(ژانویه|جنوری|فبروری|فوریه|مارچ|مارس|آپریل|اپریل|ایپریل|آوریل|مه|می|ژوئن|جون|جولای|ژوئیه|آگست|اگست|آگوست|اوت|سپتمبر|سپتامبر|اکتبر|اکتوبر|نوامبر|نومبر|دسامبر|دسمبر)/i
	};
	var parseMonthPatterns = {
	  narrow: [/^(ژ|ج)/i, /^ف/i, /^م/i, /^(آ|ا)/i, /^م/i, /^(ژ|ج)/i, /^(ج|ژ)/i, /^(آ|ا)/i, /^س/i, /^ا/i, /^ن/i, /^د/i],
	  any: [/^ژا/i, /^ف/i, /^ما/i, /^آپ/i, /^(می|مه)/i, /^(ژوئن|جون)/i, /^(ژوئی|جول)/i, /^(اوت|آگ)/i, /^س/i, /^(اوک|اک)/i, /^ن/i, /^د/i]
	};
	var matchDayPatterns = {
	  narrow: /^[شیدسچپج]/i,
	  short: /^(ش|ج|1ش|2ش|3ش|4ش|5ش)/i,
	  abbreviated: /^(یکشنبه|دوشنبه|سه‌شنبه|چهارشنبه|پنج‌شنبه|جمعه|شنبه)/i,
	  wide: /^(یکشنبه|دوشنبه|سه‌شنبه|چهارشنبه|پنج‌شنبه|جمعه|شنبه)/i
	};
	var parseDayPatterns = {
	  narrow: [/^ی/i, /^دو/i, /^س/i, /^چ/i, /^پ/i, /^ج/i, /^ش/i],
	  any: [/^(ی|1ش|یکشنبه)/i, /^(د|2ش|دوشنبه)/i, /^(س|3ش|سه‌شنبه)/i, /^(چ|4ش|چهارشنبه)/i, /^(پ|5ش|پنجشنبه)/i, /^(ج|جمعه)/i, /^(ش|شنبه)/i]
	};
	var matchDayPeriodPatterns = {
	  narrow: /^(ب|ق|ن|ظ|ص|ب.ظ.|ع|ش)/i,
	  abbreviated: /^(ق.ظ.|ب.ظ.|نیمه‌شب|ظهر|صبح|بعدازظهر|عصر|شب)/i,
	  wide: /^(قبل‌ازظهر|نیمه‌شب|ظهر|صبح|بعدازظهر|عصر|شب)/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^(ق|ق.ظ.|قبل‌ازظهر)/i,
	    pm: /^(ب|ب.ظ.|بعدازظهر)/i,
	    midnight: /^(‌نیمه‌شب|ن)/i,
	    noon: /^(ظ|ظهر)/i,
	    morning: /(ص|صبح)/i,
	    afternoon: /(ب|ب.ظ.|بعدازظهر)/i,
	    evening: /(ع|عصر)/i,
	    night: /(ش|شب)/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index2.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index2.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index2.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index2.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index2.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1178 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1173));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1174));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1175));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1176));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1177));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Persian/Farsi locale (Iran).
	 * @language Persian
	 * @iso-639-2 ira
	 * @author Morteza Ziyae [@mort3za]{@link https://github.com/mort3za}
	 */
	var locale = {
	  code: 'fa-IR',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 6
	    /* Saturday */
	    ,
	    firstWeekContainsDate: 1
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1179 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistance;
	
	function futureSeconds(text) {
	  return text.replace(/sekuntia?/, 'sekunnin');
	}
	
	function futureMinutes(text) {
	  return text.replace(/minuuttia?/, 'minuutin');
	}
	
	function futureHours(text) {
	  return text.replace(/tuntia?/, 'tunnin');
	}
	
	function futureDays(text) {
	  return text.replace(/päivää?/, 'päivän');
	}
	
	function futureWeeks(text) {
	  return text.replace(/(viikko|viikkoa)/, 'viikon');
	}
	
	function futureMonths(text) {
	  return text.replace(/(kuukausi|kuukautta)/, 'kuukauden');
	}
	
	function futureYears(text) {
	  return text.replace(/(vuosi|vuotta)/, 'vuoden');
	}
	
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    one: 'alle sekunti',
	    other: 'alle {{count}} sekuntia',
	    futureTense: futureSeconds
	  },
	  xSeconds: {
	    one: 'sekunti',
	    other: '{{count}} sekuntia',
	    futureTense: futureSeconds
	  },
	  halfAMinute: {
	    one: 'puoli minuuttia',
	    other: 'puoli minuuttia',
	    futureTense: function (_text) {
	      return 'puolen minuutin';
	    }
	  },
	  lessThanXMinutes: {
	    one: 'alle minuutti',
	    other: 'alle {{count}} minuuttia',
	    futureTense: futureMinutes
	  },
	  xMinutes: {
	    one: 'minuutti',
	    other: '{{count}} minuuttia',
	    futureTense: futureMinutes
	  },
	  aboutXHours: {
	    one: 'noin tunti',
	    other: 'noin {{count}} tuntia',
	    futureTense: futureHours
	  },
	  xHours: {
	    one: 'tunti',
	    other: '{{count}} tuntia',
	    futureTense: futureHours
	  },
	  xDays: {
	    one: 'päivä',
	    other: '{{count}} päivää',
	    futureTense: futureDays
	  },
	  aboutXWeeks: {
	    one: 'noin viikko',
	    other: 'noin {{count}} viikkoa',
	    futureTense: futureWeeks
	  },
	  xWeeks: {
	    one: 'viikko',
	    other: '{{count}} viikkoa',
	    futureTense: futureWeeks
	  },
	  aboutXMonths: {
	    one: 'noin kuukausi',
	    other: 'noin {{count}} kuukautta',
	    futureTense: futureMonths
	  },
	  xMonths: {
	    one: 'kuukausi',
	    other: '{{count}} kuukautta',
	    futureTense: futureMonths
	  },
	  aboutXYears: {
	    one: 'noin vuosi',
	    other: 'noin {{count}} vuotta',
	    futureTense: futureYears
	  },
	  xYears: {
	    one: 'vuosi',
	    other: '{{count}} vuotta',
	    futureTense: futureYears
	  },
	  overXYears: {
	    one: 'yli vuosi',
	    other: 'yli {{count}} vuotta',
	    futureTense: futureYears
	  },
	  almostXYears: {
	    one: 'lähes vuosi',
	    other: 'lähes {{count}} vuotta',
	    futureTense: futureYears
	  }
	};
	
	function formatDistance(token, count, options) {
	  options = options || {};
	  var distance = formatDistanceLocale[token];
	  var result = count === 1 ? distance.one : distance.other.replace('{{count}}', count);
	
	  if (options.addSuffix) {
	    if (options.comparison > 0) {
	      return distance.futureTense(result) + ' kuluttua';
	    } else {
	      return result + ' sitten';
	    }
	  }
	
	  return result;
	}
	
	module.exports = exports.default;

/***/ },
/* 1180 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: 'eeee d. MMMM y',
	  long: 'd. MMMM y',
	  medium: 'd. MMM y',
	  short: 'd.M.y'
	};
	var timeFormats = {
	  full: 'HH.mm.ss zzzz',
	  long: 'HH.mm.ss z',
	  medium: 'HH.mm.ss',
	  short: 'HH.mm'
	};
	var dateTimeFormats = {
	  full: "{{date}} 'klo' {{time}}",
	  long: "{{date}} 'klo' {{time}}",
	  medium: '{{date}} {{time}}',
	  short: '{{date}} {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1181 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRelative;
	var formatRelativeLocale = {
	  lastWeek: "'viime' eeee 'klo' p",
	  yesterday: "'eilen klo' p",
	  today: "'tänään klo' p",
	  tomorrow: "'huomenna klo' p",
	  nextWeek: "'ensi' eeee 'klo' p",
	  other: 'P'
	};
	
	function formatRelative(token, _date, _baseDate, _options) {
	  return formatRelativeLocale[token];
	}
	
	module.exports = exports.default;

/***/ },
/* 1182 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eraValues = {
	  narrow: ['eaa.', 'jaa.'],
	  abbreviated: ['eaa.', 'jaa.'],
	  wide: ['ennen ajanlaskun alkua', 'jälkeen ajanlaskun alun']
	};
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
	  wide: ['1. kvartaali', '2. kvartaali', '3. kvartaali', '4. kvartaali']
	};
	var monthValues = {
	  narrow: ['T', 'H', 'M', 'H', 'T', 'K', 'H', 'E', 'S', 'L', 'M', 'J'],
	  abbreviated: ['tammi', 'helmi', 'maalis', 'huhti', 'touko', 'kesä', 'heinä', 'elo', 'syys', 'loka', 'marras', 'joulu'],
	  wide: ['tammikuu', 'helmikuu', 'maaliskuu', 'huhtikuu', 'toukokuu', 'kesäkuu', 'heinäkuu', 'elokuu', 'syyskuu', 'lokakuu', 'marraskuu', 'joulukuu']
	};
	var formattingMonthValues = {
	  narrow: monthValues.narrow,
	  abbreviated: monthValues.abbreviated,
	  wide: monthValues.wide.map(function (name) {
	    return name + 'ta';
	  })
	};
	var dayValues = {
	  narrow: ['S', 'M', 'T', 'K', 'T', 'P', 'L'],
	  short: ['su', 'ma', 'ti', 'ke', 'to', 'pe', 'la'],
	  abbreviated: ['sunn.', 'maan.', 'tiis.', 'kesk.', 'torst.', 'perj.', 'la'],
	  wide: ['sunnuntai', 'maanantai', 'tiistai', 'keskiviikko', 'torstai', 'perjantai', 'lauantai']
	};
	var formattingDayValues = {
	  narrow: dayValues.narrow,
	  short: dayValues.short,
	  abbreviated: dayValues.abbreviated,
	  wide: dayValues.wide.map(function (name) {
	    return name + 'na';
	  })
	};
	var dayPeriodValues = {
	  narrow: {
	    am: 'ap',
	    pm: 'ip',
	    midnight: 'keskiyö',
	    noon: 'keskipäivä',
	    morning: 'ap',
	    afternoon: 'ip',
	    evening: 'illalla',
	    night: 'yöllä'
	  },
	  abbreviated: {
	    am: 'ap',
	    pm: 'ip',
	    midnight: 'keskiyö',
	    noon: 'keskipäivä',
	    morning: 'ap',
	    afternoon: 'ip',
	    evening: 'illalla',
	    night: 'yöllä'
	  },
	  wide: {
	    am: 'ap',
	    pm: 'ip',
	    midnight: 'keskiyöllä',
	    noon: 'keskipäivällä',
	    morning: 'aamupäivällä',
	    afternoon: 'iltapäivällä',
	    evening: 'illalla',
	    night: 'yöllä'
	  }
	};
	
	function ordinalNumber(dirtyNumber) {
	  var number = Number(dirtyNumber);
	  return number + '.';
	}
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    formattingValues: formattingMonthValues,
	    defaultWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    formattingValues: formattingDayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1183 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(15));
	
	var _index2 = _interopRequireDefault(__webpack_require__(14));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(\d+)(\.)/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^(e|j)/i,
	  abbreviated: /^(eaa.|jaa.)/i,
	  wide: /^(ennen ajanlaskun alkua|jälkeen ajanlaskun alun)/i
	};
	var parseEraPatterns = {
	  any: [/^e/i, /^j/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^q[1234]/i,
	  wide: /^[1234]\.? kvartaali/i
	};
	var parseQuarterPatterns = {
	  any: [/1/i, /2/i, /3/i, /4/i]
	};
	var matchMonthPatterns = {
	  narrow: /^[thmkeslj]/i,
	  abbreviated: /^(tammi|helmi|maalis|huhti|touko|kesä|heinä|elo|syys|loka|marras|joulu)/i,
	  wide: /^(tammikuu|helmikuu|maaliskuu|huhtikuu|toukokuu|kesäkuu|heinäkuu|elokuu|syyskuu|lokakuu|marraskuu|joulukuu)(ta)?/i
	};
	var parseMonthPatterns = {
	  narrow: [/^t/i, /^h/i, /^m/i, /^h/i, /^t/i, /^k/i, /^h/i, /^e/i, /^s/i, /^l/i, /^m/i, /^j/i],
	  any: [/^ta/i, /^hel/i, /^maa/i, /^hu/i, /^to/i, /^k/i, /^hei/i, /^e/i, /^s/i, /^l/i, /^mar/i, /^j/i]
	};
	var matchDayPatterns = {
	  narrow: /^[smtkpl]/i,
	  short: /^(su|ma|ti|ke|to|pe|la)/i,
	  abbreviated: /^(sunn.|maan.|tiis.|kesk.|torst.|perj.|la)/i,
	  wide: /^(sunnuntai|maanantai|tiistai|keskiviikko|torstai|perjantai|lauantai)(na)?/i
	};
	var parseDayPatterns = {
	  narrow: [/^s/i, /^m/i, /^t/i, /^k/i, /^t/i, /^p/i, /^l/i],
	  any: [/^s/i, /^m/i, /^ti/i, /^k/i, /^to/i, /^p/i, /^l/i]
	};
	var matchDayPeriodPatterns = {
	  narrow: /^(ap|ip|keskiyö|keskipäivä|aamupäivällä|iltapäivällä|illalla|yöllä)/i,
	  any: /^(ap|ip|keskiyöllä|keskipäivällä|aamupäivällä|iltapäivällä|illalla|yöllä)/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^ap/i,
	    pm: /^ip/i,
	    midnight: /^keskiyö/i,
	    noon: /^keskipäivä/i,
	    morning: /aamupäivällä/i,
	    afternoon: /iltapäivällä/i,
	    evening: /illalla/i,
	    night: /yöllä/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index2.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index2.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index2.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index2.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index2.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1184 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1179));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1180));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1181));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1182));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1183));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Finnish locale.
	 * @language Finnish
	 * @iso-639-2 fin
	 * @author Pyry-Samuli Lahti [@Pyppe]{@link https://github.com/Pyppe}
	 * @author Edo Rivai [@mikolajgrzyb]{@link https://github.com/mikolajgrzyb}
	 * @author Samu Juvonen [@sjuvonen]{@link https://github.com/sjuvonen}
	 */
	var locale = {
	  code: 'fi',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 1
	    /* Monday */
	    ,
	    firstWeekContainsDate: 4
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1185 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: 'EEEE d MMMM y',
	  long: 'd MMMM y',
	  medium: 'd MMM y',
	  short: 'yy-MM-dd'
	};
	var timeFormats = {
	  full: 'HH:mm:ss zzzz',
	  long: 'HH:mm:ss z',
	  medium: 'HH:mm:ss',
	  short: 'HH:mm'
	};
	var dateTimeFormats = {
	  full: "{{date}} 'à' {{time}}",
	  long: "{{date}} 'à' {{time}}",
	  medium: '{{date}}, {{time}}',
	  short: '{{date}}, {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1186 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(281));
	
	var _index2 = _interopRequireDefault(__webpack_require__(444));
	
	var _index3 = _interopRequireDefault(__webpack_require__(282));
	
	var _index4 = _interopRequireDefault(__webpack_require__(283));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1185));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Same as fr
	// Unique for fr-CA
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary French locale (Canada).
	 * @language French
	 * @iso-639-2 fra
	 * @author Jean Dupouy [@izeau]{@link https://github.com/izeau}
	 * @author François B [@fbonzon]{@link https://github.com/fbonzon}
	 * @author Gabriele Petrioli [@gpetrioli]{@link https://github.com/gpetrioli}
	 */
	var locale = {
	  code: 'fr-CA',
	  formatDistance: _index.default,
	  formatLong: _index5.default,
	  formatRelative: _index2.default,
	  localize: _index3.default,
	  match: _index4.default,
	  // Unique for fr-CA
	  options: {
	    weekStartsOn: 0
	    /* Sunday */
	    ,
	    firstWeekContainsDate: 1
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1187 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: 'EEEE d MMMM y',
	  long: 'd MMMM y',
	  medium: 'd MMM y',
	  short: 'dd.MM.y'
	};
	var timeFormats = {
	  full: 'HH:mm:ss zzzz',
	  long: 'HH:mm:ss z',
	  medium: 'HH:mm:ss',
	  short: 'HH:mm'
	};
	var dateTimeFormats = {
	  full: "{{date}} 'à' {{time}}",
	  long: "{{date}} 'à' {{time}}",
	  medium: '{{date}}, {{time}}',
	  short: '{{date}}, {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1188 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var formatRelativeLocale = {
	  lastWeek: "eeee 'la semaine dernière à' p",
	  yesterday: "'hier à' p",
	  today: "'aujourd’hui à' p",
	  tomorrow: "'demain à' p'",
	  nextWeek: "eeee 'la semaine prochaine à' p",
	  other: 'P'
	};
	
	var formatRelative = function (token, _date, _baseDate, _options) {
	  return formatRelativeLocale[token];
	};
	
	var _default = formatRelative;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1189 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(281));
	
	var _index2 = _interopRequireDefault(__webpack_require__(282));
	
	var _index3 = _interopRequireDefault(__webpack_require__(283));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1187));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1188));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Same as fr
	// Unique for fr-CH
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary French locale (Switzerland).
	 * @language French
	 * @iso-639-2 fra
	 * @author Jean Dupouy [@izeau]{@link https://github.com/izeau}
	 * @author François B [@fbonzon]{@link https://github.com/fbonzon}
	 * @author Van Vuong Ngo [@vanvuongngo]{@link https://github.com/vanvuongngo}
	 * @author Alex Hoeing [@dcbn]{@link https://github.com/dcbn}
	 */
	var locale = {
	  code: 'fr-CH',
	  formatDistance: _index.default,
	  formatLong: _index4.default,
	  formatRelative: _index5.default,
	  localize: _index2.default,
	  match: _index3.default,
	  options: {
	    weekStartsOn: 1
	    /* Monday */
	    ,
	    firstWeekContainsDate: 4
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1190 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: 'EEEE d MMMM y',
	  long: 'd MMMM y',
	  medium: 'd MMM y',
	  short: 'dd/MM/y'
	};
	var timeFormats = {
	  full: 'HH:mm:ss zzzz',
	  long: 'HH:mm:ss z',
	  medium: 'HH:mm:ss',
	  short: 'HH:mm'
	};
	var dateTimeFormats = {
	  full: "{{date}} 'à' {{time}}",
	  long: "{{date}} 'à' {{time}}",
	  medium: '{{date}}, {{time}}',
	  short: '{{date}}, {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1191 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(281));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1190));
	
	var _index3 = _interopRequireDefault(__webpack_require__(444));
	
	var _index4 = _interopRequireDefault(__webpack_require__(282));
	
	var _index5 = _interopRequireDefault(__webpack_require__(283));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary French locale.
	 * @language French
	 * @iso-639-2 fra
	 * @author Jean Dupouy [@izeau]{@link https://github.com/izeau}
	 * @author François B [@fbonzon]{@link https://github.com/fbonzon}
	 */
	var locale = {
	  code: 'fr',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 1
	    /* Monday */
	    ,
	    firstWeekContainsDate: 4
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1192 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistance;
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    one: 'minder as 1 sekonde',
	    other: 'minder as {{count}} sekonden'
	  },
	  xSeconds: {
	    one: '1 sekonde',
	    other: '{{count}} sekonden'
	  },
	  halfAMinute: 'oardel minút',
	  lessThanXMinutes: {
	    one: 'minder as 1 minút',
	    other: 'minder as {{count}} minuten'
	  },
	  xMinutes: {
	    one: '1 minút',
	    other: '{{count}} minuten'
	  },
	  aboutXHours: {
	    one: 'sawat 1 oere',
	    other: 'sawat {{count}} oere'
	  },
	  xHours: {
	    one: '1 oere',
	    other: '{{count}} oere'
	  },
	  xDays: {
	    one: '1 dei',
	    other: '{{count}} dagen'
	  },
	  aboutXWeeks: {
	    one: 'sawat 1 wike',
	    other: 'sawat {{count}} wiken'
	  },
	  xWeeks: {
	    one: '1 wike',
	    other: '{{count}} wiken'
	  },
	  aboutXMonths: {
	    one: 'sawat 1 moanne',
	    other: 'sawat {{count}} moannen'
	  },
	  xMonths: {
	    one: '1 moanne',
	    other: '{{count}} moannen'
	  },
	  aboutXYears: {
	    one: 'sawat 1 jier',
	    other: 'sawat {{count}} jier'
	  },
	  xYears: {
	    one: '1 jier',
	    other: '{{count}} jier'
	  },
	  overXYears: {
	    one: 'mear as 1 jier',
	    other: 'mear as {{count}}s jier'
	  },
	  almostXYears: {
	    one: 'hast 1 jier',
	    other: 'hast {{count}} jier'
	  }
	};
	
	function formatDistance(token, count, options) {
	  options = options || {};
	  var result;
	
	  if (typeof formatDistanceLocale[token] === 'string') {
	    result = formatDistanceLocale[token];
	  } else if (count === 1) {
	    result = formatDistanceLocale[token].one;
	  } else {
	    result = formatDistanceLocale[token].other.replace('{{count}}', count);
	  }
	
	  if (options.addSuffix) {
	    if (options.comparison > 0) {
	      return 'oer ' + result;
	    } else {
	      return result + ' lyn';
	    }
	  }
	
	  return result;
	}
	
	module.exports = exports.default;

/***/ },
/* 1193 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: 'EEEE d MMMM y',
	  long: 'd MMMM y',
	  medium: 'd MMM y',
	  short: 'dd-MM-y'
	};
	var timeFormats = {
	  full: 'HH:mm:ss zzzz',
	  long: 'HH:mm:ss z',
	  medium: 'HH:mm:ss',
	  short: 'HH:mm'
	};
	var dateTimeFormats = {
	  full: "{{date}} 'om' {{time}}",
	  long: "{{date}} 'om' {{time}}",
	  medium: '{{date}}, {{time}}',
	  short: '{{date}}, {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1194 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRelative;
	var formatRelativeLocale = {
	  lastWeek: "'ôfrûne' eeee 'om' p",
	  yesterday: "'juster om' p",
	  today: "'hjoed om' p",
	  tomorrow: "'moarn om' p",
	  nextWeek: "eeee 'om' p",
	  other: 'P'
	};
	
	function formatRelative(token, _date, _baseDate, _options) {
	  return formatRelativeLocale[token];
	}
	
	module.exports = exports.default;

/***/ },
/* 1195 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eraValues = {
	  narrow: ['f.K.', 'n.K.'],
	  abbreviated: ['f.Kr.', 'n.Kr.'],
	  wide: ['foar Kristus', 'nei Kristus']
	};
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['K1', 'K2', 'K3', 'K4'],
	  wide: ['1e fearnsjier', '2e fearnsjier', '3e fearnsjier', '4e fearnsjier']
	};
	var monthValues = {
	  narrow: ['j', 'f', 'm', 'a', 'm', 'j', 'j', 'a', 's', 'o', 'n', 'd'],
	  abbreviated: ['jan.', 'feb.', 'mrt.', 'apr.', 'mai.', 'jun.', 'jul.', 'aug.', 'sep.', 'okt.', 'nov.', 'des.'],
	  wide: ['jannewaris', 'febrewaris', 'maart', 'april', 'maaie', 'juny', 'july', 'augustus', 'septimber', 'oktober', 'novimber', 'desimber']
	};
	var dayValues = {
	  narrow: ['s', 'm', 't', 'w', 't', 'f', 's'],
	  short: ['si', 'mo', 'ti', 'wo', 'to', 'fr', 'so'],
	  abbreviated: ['snein', 'moa', 'tii', 'woa', 'ton', 'fre', 'sneon'],
	  wide: ['snein', 'moandei', 'tiisdei', 'woansdei', 'tongersdei', 'freed', 'sneon']
	};
	var dayPeriodValues = {
	  narrow: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'middernacht',
	    noon: 'middei',
	    morning: 'moarns',
	    afternoon: 'middeis',
	    evening: 'jûns',
	    night: 'nachts'
	  },
	  abbreviated: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'middernacht',
	    noon: 'middei',
	    morning: 'moarns',
	    afternoon: 'middeis',
	    evening: 'jûns',
	    night: 'nachts'
	  },
	  wide: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'middernacht',
	    noon: 'middei',
	    morning: 'moarns',
	    afternoon: 'middeis',
	    evening: 'jûns',
	    night: 'nachts'
	  }
	};
	
	function ordinalNumber(dirtyNumber) {
	  var number = Number(dirtyNumber);
	  return number + 'e';
	}
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1196 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(15));
	
	var _index2 = _interopRequireDefault(__webpack_require__(14));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(\d+)e?/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^([fn]\.? ?K\.?)/,
	  abbreviated: /^([fn]\. ?Kr\.?)/,
	  wide: /^((foar|nei) Kristus)/
	};
	var parseEraPatterns = {
	  any: [/^f/, /^n/]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^K[1234]/i,
	  wide: /^[1234]e fearnsjier/i
	};
	var parseQuarterPatterns = {
	  any: [/1/i, /2/i, /3/i, /4/i]
	};
	var matchMonthPatterns = {
	  narrow: /^[jfmasond]/i,
	  abbreviated: /^(jan.|feb.|mrt.|apr.|mai.|jun.|jul.|aug.|sep.|okt.|nov.|des.)/i,
	  wide: /^(jannewaris|febrewaris|maart|april|maaie|juny|july|augustus|septimber|oktober|novimber|desimber)/i
	};
	var parseMonthPatterns = {
	  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
	  any: [/^jan/i, /^feb/i, /^m(r|a)/i, /^apr/i, /^mai/i, /^jun/i, /^jul/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^des/i]
	};
	var matchDayPatterns = {
	  narrow: /^[smtwf]/i,
	  short: /^(si|mo|ti|wo|to|fr|so)/i,
	  abbreviated: /^(snein|moa|tii|woa|ton|fre|sneon)/i,
	  wide: /^(snein|moandei|tiisdei|woansdei|tongersdei|freed|sneon)/i
	};
	var parseDayPatterns = {
	  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
	  any: [/^sn/i, /^mo/i, /^ti/i, /^wo/i, /^to/i, /^fr/i, /^sn/i]
	};
	var matchDayPeriodPatterns = {
	  any: /^(am|pm|middernacht|middeis|moarns|middei|jûns|nachts)/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^am/i,
	    pm: /^pm/i,
	    midnight: /^middernacht/i,
	    noon: /^middei/i,
	    morning: /moarns/i,
	    afternoon: /^middeis/i,
	    evening: /jûns/i,
	    night: /nachts/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index2.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index2.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index2.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index2.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index2.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1197 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1192));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1193));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1194));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1195));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1196));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Western Frisian locale (Netherlands).
	 * @language West Frisian
	 * @iso-639-2 fry
	 * @author Damon Asberg [@damon02]{@link https://github.com/damon02}
	 */
	var locale = {
	  code: 'fy',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 1
	    /* Monday */
	    ,
	    firstWeekContainsDate: 4
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1198 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistance;
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    one: 'nas lugha na diog',
	    other: 'nas lugha na {{count}} diogan'
	  },
	  xSeconds: {
	    one: '1 diog',
	    two: '2 dhiog',
	    twenty: '20 diog',
	    other: '{{count}} diogan'
	  },
	  halfAMinute: 'leth mhionaid',
	  lessThanXMinutes: {
	    one: 'nas lugha na mionaid',
	    other: 'nas lugha na {{count}} mionaidean'
	  },
	  xMinutes: {
	    one: '1 mionaid',
	    two: '2 mhionaid',
	    twenty: '20 mionaid',
	    other: '{{count}} mionaidean'
	  },
	  aboutXHours: {
	    one: 'mu uair de thìde',
	    other: 'mu {{count}} uairean de thìde'
	  },
	  xHours: {
	    one: '1 uair de thìde',
	    two: '2 uair de thìde',
	    twenty: '20 uair de thìde',
	    other: '{{count}} uairean de thìde'
	  },
	  xDays: {
	    one: '1 là',
	    other: '{{count}} là'
	  },
	  aboutXWeeks: {
	    one: 'mu 1 seachdain',
	    other: 'mu {{count}} seachdainean'
	  },
	  xWeeks: {
	    one: '1 seachdain',
	    other: '{{count}} seachdainean'
	  },
	  aboutXMonths: {
	    one: 'mu mhìos',
	    other: 'mu {{count}} mìosan'
	  },
	  xMonths: {
	    one: '1 mìos',
	    other: '{{count}} mìosan'
	  },
	  aboutXYears: {
	    one: 'mu bhliadhna',
	    other: 'mu {{count}} bliadhnaichean'
	  },
	  xYears: {
	    one: '1 bhliadhna',
	    other: '{{count}} bliadhna'
	  },
	  overXYears: {
	    one: 'còrr is bliadhna',
	    other: 'còrr is {{count}} bliadhnaichean'
	  },
	  almostXYears: {
	    one: 'cha mhòr bliadhna',
	    other: 'cha mhòr {{count}} bliadhnaichean'
	  }
	};
	
	function formatDistance(token, count, options) {
	  options = options || {};
	  var result;
	
	  if (typeof formatDistanceLocale[token] === 'string') {
	    result = formatDistanceLocale[token];
	  } else if (count === 1) {
	    result = formatDistanceLocale[token].one;
	  } else if (count === 2 && !!formatDistanceLocale[token].two) {
	    result = formatDistanceLocale[token].two;
	  } else if (count === 9 && !!formatDistanceLocale[token].nine) {
	    result = formatDistanceLocale[token].nine;
	  } else if (count === 20 && !!formatDistanceLocale[token].twenty) {
	    result = formatDistanceLocale[token].twenty;
	  } else if (count === 30 && !!formatDistanceLocale[token].thirty) {
	    result = formatDistanceLocale[token].thirty;
	  } else {
	    result = formatDistanceLocale[token].other.replace('{{count}}', count);
	  }
	
	  if (options.addSuffix) {
	    if (options.comparison > 0) {
	      return 'ann an ' + result;
	    } else {
	      return 'o chionn ' + result;
	    }
	  }
	
	  return result;
	}
	
	module.exports = exports.default;

/***/ },
/* 1199 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: 'EEEE, MMMM do, y',
	  long: 'MMMM do, y',
	  medium: 'MMM d, y',
	  short: 'MM/dd/yyyy'
	};
	var timeFormats = {
	  full: 'h:mm:ss a zzzz',
	  long: 'h:mm:ss a z',
	  medium: 'h:mm:ss a',
	  short: 'h:mm a'
	};
	var dateTimeFormats = {
	  full: "{{date}} 'aig' {{time}}",
	  long: "{{date}} 'aig' {{time}}",
	  medium: '{{date}}, {{time}}',
	  short: '{{date}}, {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1200 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRelative;
	var formatRelativeLocale = {
	  lastWeek: "'mu dheireadh' eeee 'aig' p",
	  //FIX
	  yesterday: "'an-dè aig' p",
	  today: "'an-diugh aig' p",
	  tomorrow: "'a-màireach aig' p",
	  nextWeek: "eeee 'aig' p",
	  other: 'P'
	};
	
	function formatRelative(token, _date, _baseDate, _options) {
	  return formatRelativeLocale[token];
	}
	
	module.exports = exports.default;

/***/ },
/* 1201 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eraValues = {
	  narrow: ['R', 'A'],
	  abbreviated: ['RC', 'AD'],
	  wide: ['ro Chrìosta', 'anno domini']
	};
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['C1', 'C2', 'C3', 'C4'],
	  wide: ["a' chiad chairteal", 'an dàrna cairteal', 'an treas cairteal', 'an ceathramh cairteal']
	}; // Note: in English, the names of days of the week and months are capitalized.
	// If you are making a new locale based on this one, check if the same is true for the language you're working on.
	// Generally, formatted dates should look like they are in the middle of a sentence,
	// e.g. in Spanish language the weekdays and months should be in the lowercase.
	
	var monthValues = {
	  narrow: ['F', 'G', 'M', 'G', 'C', 'Ò', 'I', 'L', 'S', 'D', 'S', 'D'],
	  abbreviated: ['Faoi', 'Gear', 'Màrt', 'Gibl', 'Cèit', 'Ògmh', 'Iuch', 'Lùn', 'Sult', 'Dàmh', 'Samh', 'Dùbh'],
	  wide: ['Am Faoilleach', 'An Gearran', 'Am Màrt', 'An Giblean', 'An Cèitean', 'An t-Ògmhios', 'An t-Iuchar', 'An Lùnastal', 'An t-Sultain', 'An Dàmhair', 'An t-Samhain', 'An Dùbhlachd']
	};
	var dayValues = {
	  narrow: ['D', 'L', 'M', 'C', 'A', 'H', 'S'],
	  short: ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'],
	  abbreviated: ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'],
	  wide: ['Didòmhnaich', 'Diluain', 'Dimàirt', 'Diciadain', 'Diardaoin', 'Dihaoine', 'Disathairne']
	};
	var dayPeriodValues = {
	  narrow: {
	    am: 'm',
	    pm: 'f',
	    midnight: 'm.o.',
	    noon: 'm.l.',
	    morning: 'madainn',
	    afternoon: 'feasgar',
	    evening: 'feasgar',
	    night: 'oidhche'
	  },
	  abbreviated: {
	    am: 'M.',
	    pm: 'F.',
	    midnight: 'meadhan oidhche',
	    noon: 'meadhan là',
	    morning: 'madainn',
	    afternoon: 'feasgar',
	    evening: 'feasgar',
	    night: 'oidhche'
	  },
	  wide: {
	    am: 'm.',
	    pm: 'f.',
	    midnight: 'meadhan oidhche',
	    noon: 'meadhan là',
	    morning: 'madainn',
	    afternoon: 'feasgar',
	    evening: 'feasgar',
	    night: 'oidhche'
	  }
	};
	var formattingDayPeriodValues = {
	  narrow: {
	    am: 'm',
	    pm: 'f',
	    midnight: 'm.o.',
	    noon: 'm.l.',
	    morning: 'sa mhadainn',
	    afternoon: 'feasgar',
	    evening: 'feasgar',
	    night: 'air an oidhche'
	  },
	  abbreviated: {
	    am: 'M.',
	    pm: 'F.',
	    midnight: 'meadhan oidhche',
	    noon: 'meadhan là',
	    morning: 'sa mhadainn',
	    afternoon: 'feasgar',
	    evening: 'feasgar',
	    night: 'air an oidhche'
	  },
	  wide: {
	    am: 'm.',
	    pm: 'f.',
	    midnight: 'meadhan oidhche',
	    noon: 'meadhan là',
	    morning: 'sa mhadainn',
	    afternoon: 'feasgar',
	    evening: 'feasgar',
	    night: 'air an oidhche'
	  }
	};
	
	function ordinalNumber(dirtyNumber, _dirtyOptions) {
	  var number = Number(dirtyNumber); // If ordinal numbers depend on context, for example,
	  // if they are different for different grammatical genders,
	  // use `options.unit`:
	  //
	  //   var options = dirtyOptions || {}
	  //   var unit = String(options.unit)
	  //
	  // where `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
	  // 'day', 'hour', 'minute', 'second'
	
	  var rem100 = number % 100;
	
	  if (rem100 > 20 || rem100 < 10) {
	    switch (rem100 % 10) {
	      case 1:
	        return number + 'd';
	
	      case 2:
	        return number + 'na';
	    }
	  }
	
	  if (rem100 === 12) {
	    return number + 'na';
	  }
	
	  return number + 'mh';
	}
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingDayPeriodValues,
	    defaultFormattingWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1202 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(15));
	
	var _index2 = _interopRequireDefault(__webpack_require__(14));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(\d+)(d|na|tr|mh)?/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^(r|a)/i,
	  abbreviated: /^(r\.?\s?c\.?|r\.?\s?a\.?\s?c\.?|a\.?\s?d\.?|a\.?\s?c\.?)/i,
	  wide: /^(ro Chrìosta|ron aois choitchinn|anno domini|aois choitcheann)/i
	};
	var parseEraPatterns = {
	  any: [/^b/i, /^(a|c)/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^c[1234]/i,
	  wide: /^[1234](cd|na|tr|mh)? cairteal/i
	};
	var parseQuarterPatterns = {
	  any: [/1/i, /2/i, /3/i, /4/i]
	};
	var matchMonthPatterns = {
	  narrow: /^[fgmcòilsd]/i,
	  abbreviated: /^(faoi|gear|màrt|gibl|cèit|ògmh|iuch|lùn|sult|dàmh|samh|dùbh)/i,
	  wide: /^(am faoilleach|an gearran|am màrt|an giblean|an cèitean|an t-Ògmhios|an t-Iuchar|an lùnastal|an t-Sultain|an dàmhair|an t-Samhain|an dùbhlachd)/i
	};
	var parseMonthPatterns = {
	  narrow: [/^f/i, /^g/i, /^m/i, /^g/i, /^c/i, /^ò/i, /^i/i, /^l/i, /^s/i, /^d/i, /^s/i, /^d/i],
	  any: [/^fa/i, /^ge/i, /^mà/i, /^gi/i, /^c/i, /^ò/i, /^i/i, /^l/i, /^su/i, /^d/i, /^sa/i, /^d/i]
	};
	var matchDayPatterns = {
	  narrow: /^[dlmcahs]/i,
	  short: /^(dò|lu|mà|ci|ar|ha|sa)/i,
	  abbreviated: /^(did|dil|dim|dic|dia|dih|dis)/i,
	  wide: /^(didòmhnaich|diluain|dimàirt|diciadain|diardaoin|dihaoine|disathairne)/i
	};
	var parseDayPatterns = {
	  narrow: [/^d/i, /^l/i, /^m/i, /^c/i, /^a/i, /^h/i, /^s/i],
	  any: [/^d/i, /^l/i, /^m/i, /^c/i, /^a/i, /^h/i, /^s/i]
	};
	var matchDayPeriodPatterns = {
	  narrow: /^(a|p|mi|n|(san|aig) (madainn|feasgar|feasgar|oidhche))/i,
	  any: /^([ap]\.?\s?m\.?|meadhan oidhche|meadhan là|(san|aig) (madainn|feasgar|feasgar|oidhche))/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^m/i,
	    pm: /^f/i,
	    midnight: /^meadhan oidhche/i,
	    noon: /^meadhan là/i,
	    morning: /sa mhadainn/i,
	    afternoon: /feasgar/i,
	    evening: /feasgar/i,
	    night: /air an oidhche/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index2.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index2.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index2.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index2.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index2.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1203 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1198));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1199));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1200));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1201));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1202));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Scottish Gaelic.
	 * @language Scottish Gaelic
	 * @iso-639-2 gla
	 * @author Lee Driscoll [@leedriscoll]{@link https://github.com/leedriscoll}
	 */
	var locale = {
	  code: 'gd',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 0
	    /* Sunday */
	    ,
	    firstWeekContainsDate: 1
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1204 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistance;
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    one: 'menos dun segundo',
	    other: 'menos de {{count}} segundos'
	  },
	  xSeconds: {
	    one: '1 segundo',
	    other: '{{count}} segundos'
	  },
	  halfAMinute: 'medio minuto',
	  lessThanXMinutes: {
	    one: 'menos dun minuto',
	    other: 'menos de {{count}} minutos'
	  },
	  xMinutes: {
	    one: '1 minuto',
	    other: '{{count}} minutos'
	  },
	  aboutXHours: {
	    one: 'arredor dunha hora',
	    other: 'arredor de {{count}} horas'
	  },
	  xHours: {
	    one: '1 hora',
	    other: '{{count}} horas'
	  },
	  xDays: {
	    one: '1 día',
	    other: '{{count}} días'
	  },
	  aboutXWeeks: {
	    one: 'arredor dunha semana',
	    other: 'arredor de {{count}} semanas'
	  },
	  xWeeks: {
	    one: '1 semana',
	    other: '{{count}} semanas'
	  },
	  aboutXMonths: {
	    one: 'arredor de 1 mes',
	    other: 'arredor de {{count}} meses'
	  },
	  xMonths: {
	    one: '1 mes',
	    other: '{{count}} meses'
	  },
	  aboutXYears: {
	    one: 'arredor dun ano',
	    other: 'arredor de {{count}} anos'
	  },
	  xYears: {
	    one: '1 ano',
	    other: '{{count}} anos'
	  },
	  overXYears: {
	    one: 'máis dun ano',
	    other: 'máis de {{count}} anos'
	  },
	  almostXYears: {
	    one: 'case un ano',
	    other: 'case {{count}} anos'
	  }
	};
	
	function formatDistance(token, count, options) {
	  options = options || {};
	  var result;
	
	  if (typeof formatDistanceLocale[token] === 'string') {
	    result = formatDistanceLocale[token];
	  } else if (count === 1) {
	    result = formatDistanceLocale[token].one;
	  } else {
	    result = formatDistanceLocale[token].other.replace('{{count}}', count);
	  }
	
	  if (options.addSuffix) {
	    if (options.comparison > 0) {
	      return 'en ' + result;
	    } else {
	      return 'hai ' + result;
	    }
	  }
	
	  return result;
	}
	
	module.exports = exports.default;

/***/ },
/* 1205 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: "EEEE, d 'de' MMMM y",
	  long: "d 'de' MMMM y",
	  medium: 'd MMM y',
	  short: 'dd/MM/y'
	};
	var timeFormats = {
	  full: 'HH:mm:ss zzzz',
	  long: 'HH:mm:ss z',
	  medium: 'HH:mm:ss',
	  short: 'HH:mm'
	};
	var dateTimeFormats = {
	  full: "{{date}} 'ás' {{time}}",
	  long: "{{date}} 'ás' {{time}}",
	  medium: '{{date}}, {{time}}',
	  short: '{{date}}, {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1206 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRelative;
	var formatRelativeLocale = {
	  lastWeek: "'o' eeee 'pasado á' LT",
	  yesterday: "'onte á' p",
	  today: "'hoxe á' p",
	  tomorrow: "'mañá á' p",
	  nextWeek: "eeee 'á' p",
	  other: 'P'
	};
	var formatRelativeLocalePlural = {
	  lastWeek: "'o' eeee 'pasado ás' p",
	  yesterday: "'onte ás' p",
	  today: "'hoxe ás' p",
	  tomorrow: "'mañá ás' p",
	  nextWeek: "eeee 'ás' p",
	  other: 'P'
	};
	
	function formatRelative(token, date, _baseDate, _options) {
	  if (date.getUTCHours() !== 1) {
	    return formatRelativeLocalePlural[token];
	  }
	
	  return formatRelativeLocale[token];
	}
	
	module.exports = exports.default;

/***/ },
/* 1207 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eraValues = {
	  narrow: ['AC', 'DC'],
	  abbreviated: ['AC', 'DC'],
	  wide: ['antes de cristo', 'despois de cristo']
	};
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['T1', 'T2', 'T3', 'T4'],
	  wide: ['1º trimestre', '2º trimestre', '3º trimestre', '4º trimestre']
	};
	var monthValues = {
	  narrow: ['e', 'f', 'm', 'a', 'm', 'j', 'j', 'a', 's', 'o', 'n', 'd'],
	  abbreviated: ['xan', 'feb', 'mar', 'abr', 'mai', 'xun', 'xul', 'ago', 'set', 'out', 'nov', 'dec'],
	  wide: ['xaneiro', 'febreiro', 'marzo', 'abril', 'maio', 'xuño', 'xullo', 'agosto', 'setembro', 'outubro', 'novembro', 'decembro']
	};
	var dayValues = {
	  narrow: ['d', 'l', 'm', 'm', 'j', 'v', 's'],
	  short: ['do', 'lu', 'ma', 'me', 'xo', 've', 'sa'],
	  abbreviated: ['dom', 'lun', 'mar', 'mer', 'xov', 'ven', 'sab'],
	  wide: ['domingo', 'luns', 'martes', 'mércores', 'xoves', 'venres', 'sábado']
	};
	var dayPeriodValues = {
	  narrow: {
	    am: 'a',
	    pm: 'p',
	    midnight: 'mn',
	    noon: 'md',
	    morning: 'mañá',
	    afternoon: 'tarde',
	    evening: 'tarde',
	    night: 'noite'
	  },
	  abbreviated: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'medianoite',
	    noon: 'mediodía',
	    morning: 'mañá',
	    afternoon: 'tarde',
	    evening: 'tardiña',
	    night: 'noite'
	  },
	  wide: {
	    am: 'a.m.',
	    pm: 'p.m.',
	    midnight: 'medianoite',
	    noon: 'mediodía',
	    morning: 'mañá',
	    afternoon: 'tarde',
	    evening: 'tardiña',
	    night: 'noite'
	  }
	};
	var formattingDayPeriodValues = {
	  narrow: {
	    am: 'a',
	    pm: 'p',
	    midnight: 'mn',
	    noon: 'md',
	    morning: 'da mañá',
	    afternoon: 'da tarde',
	    evening: 'da tardiña',
	    night: 'da noite'
	  },
	  abbreviated: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'medianoite',
	    noon: 'mediodía',
	    morning: 'da mañá',
	    afternoon: 'da tarde',
	    evening: 'da tardiña',
	    night: 'da noite'
	  },
	  wide: {
	    am: 'a.m.',
	    pm: 'p.m.',
	    midnight: 'medianoite',
	    noon: 'mediodía',
	    morning: 'da mañá',
	    afternoon: 'da tarde',
	    evening: 'da tardiña',
	    night: 'da noite'
	  }
	};
	
	function ordinalNumber(dirtyNumber) {
	  var number = Number(dirtyNumber);
	  return number + 'º';
	}
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingDayPeriodValues,
	    defaultFormattingWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1208 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(15));
	
	var _index2 = _interopRequireDefault(__webpack_require__(14));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(\d+)(º)?/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^(ac|dc|a|d)/i,
	  abbreviated: /^(a\.?\s?c\.?|a\.?\s?e\.?\s?c\.?|d\.?\s?c\.?|e\.?\s?c\.?)/i,
	  wide: /^(antes de cristo|antes da era com[uú]n|despois de cristo|era com[uú]n)/i
	};
	var parseEraPatterns = {
	  any: [/^ac/i, /^dc/i],
	  wide: [/^(antes de cristo|antes da era com[uú]n)/i, /^(despois de cristo|era com[uú]n)/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^T[1234]/i,
	  wide: /^[1234](º)? trimestre/i
	};
	var parseQuarterPatterns = {
	  any: [/1/i, /2/i, /3/i, /4/i]
	};
	var matchMonthPatterns = {
	  narrow: /^[xfmasond]/i,
	  abbreviated: /^(xan|feb|mar|abr|mai|xun|xul|ago|set|out|nov|dec)/i,
	  wide: /^(xaneiro|febreiro|marzo|abril|maio|xuño|xullo|agosto|setembro|outubro|novembro|decembro)/i
	};
	var parseMonthPatterns = {
	  narrow: [/^x/i, /^f/i, /^m/i, /^a/i, /^m/i, /^x/i, /^x/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
	  any: [/^xan/i, /^feb/i, /^mar/i, /^abr/i, /^mai/i, /^xun/i, /^xul/i, /^ago/i, /^set/i, /^out/i, /^nov/i, /^dec/i]
	};
	var matchDayPatterns = {
	  narrow: /^[dlmxvs]/i,
	  short: /^(do|lu|ma|me|xo|ve|sa)/i,
	  abbreviated: /^(dom|lun|mar|mer|xov|ven|sab)/i,
	  wide: /^(domingo|luns|martes|m[eé]rcores|xoves|venres|s[áa]bado)/i
	};
	var parseDayPatterns = {
	  narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^x/i, /^v/i, /^s/i],
	  any: [/^do/i, /^lu/i, /^ma/i, /^me/i, /^xo/i, /^ve/i, /^sa/i]
	};
	var matchDayPeriodPatterns = {
	  narrow: /^(a|p|mn|md|(da|[aá]s) (mañ[aá]|tarde|noite))/i,
	  any: /^([ap]\.?\s?m\.?|medianoite|mediod[ií]a|(da|[aá]s) (mañ[aá]|tarde|noite))/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^a/i,
	    pm: /^p/i,
	    midnight: /^mn/i,
	    noon: /^md/i,
	    morning: /mañ[aá]/i,
	    afternoon: /tarde/i,
	    evening: /tardiña/i,
	    night: /noite/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index2.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index2.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index2.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index2.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index2.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1209 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1204));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1205));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1206));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1207));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1208));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Galician locale.
	 * @language Galician
	 * @iso-639-2 glg
	 * @author Alberto Doval - Cocodin Technology[@cocodinTech]{@link https://github.com/cocodinTech}
	 * @author Fidel Pita [@fidelpita]{@link https://github.com/fidelpita}
	 */
	var locale = {
	  code: 'gl',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 1
	    /* Monday */
	    ,
	    firstWeekContainsDate: 1
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1210 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistance;
	// Source: https://www.unicode.org/cldr/charts/32/summary/gu.html
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    one: 'હમણાં',
	    // CLDR #1461
	    other: '​આશરે {{count}} સેકંડ'
	  },
	  xSeconds: {
	    one: '1 સેકંડ',
	    other: '{{count}} સેકંડ'
	  },
	  halfAMinute: 'અડધી મિનિટ',
	  lessThanXMinutes: {
	    one: 'આ મિનિટ',
	    // CLDR #1448
	    other: '​આશરે {{count}} મિનિટ'
	  },
	  xMinutes: {
	    one: '1 મિનિટ',
	    other: '{{count}} મિનિટ'
	  },
	  aboutXHours: {
	    one: '​આશરે 1 કલાક',
	    other: '​આશરે {{count}} કલાક'
	  },
	  xHours: {
	    one: '1 કલાક',
	    other: '{{count}} કલાક'
	  },
	  xDays: {
	    one: '1 દિવસ',
	    other: '{{count}} દિવસ'
	  },
	  aboutXWeeks: {
	    one: 'આશરે 1 અઠવાડિયું',
	    other: 'આશરે {{count}} અઠવાડિયા'
	  },
	  xWeeks: {
	    one: '1 અઠવાડિયું',
	    other: '{{count}} અઠવાડિયા'
	  },
	  aboutXMonths: {
	    one: 'આશરે 1 મહિનો',
	    other: 'આશરે {{count}} મહિના'
	  },
	  xMonths: {
	    one: '1 મહિનો',
	    other: '{{count}} મહિના'
	  },
	  aboutXYears: {
	    one: 'આશરે 1 વર્ષ',
	    other: 'આશરે {{count}} વર્ષ'
	  },
	  xYears: {
	    one: '1 વર્ષ',
	    other: '{{count}} વર્ષ'
	  },
	  overXYears: {
	    one: '1 વર્ષથી વધુ',
	    other: '{{count}} વર્ષથી વધુ'
	  },
	  almostXYears: {
	    one: 'લગભગ 1 વર્ષ',
	    other: 'લગભગ {{count}} વર્ષ'
	  }
	};
	
	function formatDistance(token, count, options) {
	  options = options || {};
	  var result;
	
	  if (typeof formatDistanceLocale[token] === 'string') {
	    result = formatDistanceLocale[token];
	  } else if (count === 1) {
	    result = formatDistanceLocale[token].one;
	  } else {
	    result = formatDistanceLocale[token].other.replace('{{count}}', count);
	  }
	
	  if (options.addSuffix) {
	    if (options.comparison > 0) {
	      return result + 'માં';
	    } else {
	      return result + ' પહેલાં';
	    }
	  }
	
	  return result;
	}
	
	module.exports = exports.default;

/***/ },
/* 1211 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//Source: https://www.unicode.org/cldr/charts/32/summary/gu.html
	var dateFormats = {
	  full: 'EEEE, d MMMM, y',
	  // CLDR #1825
	  long: 'd MMMM, y',
	  // CLDR #1826
	  medium: 'd MMM, y',
	  // CLDR #1827
	  short: 'd/M/yy' // CLDR #1828
	
	};
	var timeFormats = {
	  full: 'hh:mm:ss a zzzz',
	  // CLDR #1829
	  long: 'hh:mm:ss a z',
	  // CLDR #1830
	  medium: 'hh:mm:ss a',
	  // CLDR #1831
	  short: 'hh:mm a' // CLDR #1832
	
	};
	var dateTimeFormats = {
	  full: '{{date}} {{time}}',
	  // CLDR #1833
	  long: '{{date}} {{time}}',
	  // CLDR #1834
	  medium: '{{date}} {{time}}',
	  // CLDR #1835
	  short: '{{date}} {{time}}' // CLDR #1836
	
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1212 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRelative;
	// Source: https://www.unicode.org/cldr/charts/32/summary/gu.html
	var formatRelativeLocale = {
	  lastWeek: "'પાછલા' eeee p",
	  // CLDR #1384
	  yesterday: "'ગઈકાલે' p",
	  // CLDR #1409
	  today: "'આજે' p",
	  // CLDR #1410
	  tomorrow: "'આવતીકાલે' p",
	  // CLDR #1411
	  nextWeek: 'eeee p',
	  // CLDR #1386
	  other: 'P'
	};
	
	function formatRelative(token, _date, _baseDate, _options) {
	  return formatRelativeLocale[token];
	}
	
	module.exports = exports.default;

/***/ },
/* 1213 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// https://www.unicode.org/cldr/charts/32/summary/gu.html
	// #1621 - #1630
	var eraValues = {
	  narrow: ['ઈસપૂ', 'ઈસ'],
	  abbreviated: ['ઈ.સ.પૂર્વે', 'ઈ.સ.'],
	  wide: ['ઈસવીસન પૂર્વે', 'ઈસવીસન']
	}; // https://www.unicode.org/cldr/charts/32/summary/gu.html
	// #1631 - #1654
	
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
	  wide: ['1લો ત્રિમાસ', '2જો ત્રિમાસ', '3જો ત્રિમાસ', '4થો ત્રિમાસ']
	}; // Note: in English, the names of days of the week and months are capitalized.
	// If you are making a new locale based on this one, check if the same is true for the language you're working on.
	// Generally, formatted dates should look like they are in the middle of a sentence,
	// e.g. in Spanish language the weekdays and months should be in the lowercase.
	// https://www.unicode.org/cldr/charts/32/summary/gu.html
	// #1655 - #1726
	
	var monthValues = {
	  narrow: ['જા', 'ફે', 'મા', 'એ', 'મે', 'જૂ', 'જુ', 'ઓ', 'સ', 'ઓ', 'ન', 'ડિ'],
	  abbreviated: ['જાન્યુ', 'ફેબ્રુ', 'માર્ચ', 'એપ્રિલ', 'મે', 'જૂન', 'જુલાઈ', 'ઑગસ્ટ', 'સપ્ટે', 'ઓક્ટો', 'નવે', 'ડિસે'],
	  wide: ['જાન્યુઆરી', 'ફેબ્રુઆરી', 'માર્ચ', 'એપ્રિલ', 'મે', 'જૂન', 'જુલાઇ', 'ઓગસ્ટ', 'સપ્ટેમ્બર', 'ઓક્ટોબર', 'નવેમ્બર', 'ડિસેમ્બર']
	}; // https://www.unicode.org/cldr/charts/32/summary/gu.html
	// #1727 - #1768
	
	var dayValues = {
	  narrow: ['ર', 'સો', 'મં', 'બુ', 'ગુ', 'શુ', 'શ'],
	  short: ['ર', 'સો', 'મં', 'બુ', 'ગુ', 'શુ', 'શ'],
	  abbreviated: ['રવિ', 'સોમ', 'મંગળ', 'બુધ', 'ગુરુ', 'શુક્ર', 'શનિ'],
	  wide: ['રવિવાર'
	  /* Sunday */
	  , 'સોમવાર'
	  /* Monday */
	  , 'મંગળવાર'
	  /* Tuesday */
	  , 'બુધવાર'
	  /* Wednesday */
	  , 'ગુરુવાર'
	  /* Thursday */
	  , 'શુક્રવાર'
	  /* Friday */
	  , 'શનિવાર'
	  /* Saturday */
	  ]
	}; // https://www.unicode.org/cldr/charts/32/summary/gu.html
	// #1783 - #1824
	
	var dayPeriodValues = {
	  narrow: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'મ.રાત્રિ',
	    noon: 'બ.',
	    morning: 'સવારે',
	    afternoon: 'બપોરે',
	    evening: 'સાંજે',
	    night: 'રાત્રે'
	  },
	  abbreviated: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: '​મધ્યરાત્રિ',
	    noon: 'બપોરે',
	    morning: 'સવારે',
	    afternoon: 'બપોરે',
	    evening: 'સાંજે',
	    night: 'રાત્રે'
	  },
	  wide: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: '​મધ્યરાત્રિ',
	    noon: 'બપોરે',
	    morning: 'સવારે',
	    afternoon: 'બપોરે',
	    evening: 'સાંજે',
	    night: 'રાત્રે'
	  }
	};
	var formattingDayPeriodValues = {
	  narrow: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'મ.રાત્રિ',
	    noon: 'બપોરે',
	    morning: 'સવારે',
	    afternoon: 'બપોરે',
	    evening: 'સાંજે',
	    night: 'રાત્રે'
	  },
	  abbreviated: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'મધ્યરાત્રિ',
	    noon: 'બપોરે',
	    morning: 'સવારે',
	    afternoon: 'બપોરે',
	    evening: 'સાંજે',
	    night: 'રાત્રે'
	  },
	  wide: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: '​મધ્યરાત્રિ',
	    noon: 'બપોરે',
	    morning: 'સવારે',
	    afternoon: 'બપોરે',
	    evening: 'સાંજે',
	    night: 'રાત્રે'
	  }
	};
	
	function ordinalNumber(dirtyNumber, _dirtyOptions) {
	  var number = Number(dirtyNumber);
	  return number;
	}
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingDayPeriodValues,
	    defaultFormattingWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1214 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(15));
	
	var _index2 = _interopRequireDefault(__webpack_require__(14));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(\d+)(લ|જ|થ|ઠ્ઠ|મ)?/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^(ઈસપૂ|ઈસ)/i,
	  abbreviated: /^(ઈ\.સ\.પૂર્વે|ઈ\.સ\.)/i,
	  wide: /^(ઈસવીસન\sપૂર્વે|ઈસવીસન)/i
	};
	var parseEraPatterns = {
	  any: [/^(ઈસપૂ|ઈસ)/i, /^(ઈ\.સ\.પૂર્વે|ઈ\.સ\.)/i, /^(ઈસવીસન\sપૂર્વે|ઈસવીસન)/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^q[1234]/i,
	  wide: /^[1234](લો|જો|થો)? ત્રિમાસ/i
	};
	var parseQuarterPatterns = {
	  any: [/1/i, /2/i, /3/i, /4/i]
	};
	var matchMonthPatterns = {
	  // eslint-disable-next-line no-misleading-character-class
	  narrow: /^[જાફેમાએમેજૂજુઓસઓનડિ]/i,
	  abbreviated: /^(જાન્યુ|ફેબ્રુ|માર્ચ|એપ્રિલ|મે|જૂન|જુલાઈ|ઑગસ્ટ|સપ્ટે|ઓક્ટો|નવે|ડિસે)/i,
	  wide: /^(જાન્યુઆરી|ફેબ્રુઆરી|માર્ચ|એપ્રિલ|મે|જૂન|જુલાઇ|ઓગસ્ટ|સપ્ટેમ્બર|ઓક્ટોબર|નવેમ્બર|ડિસેમ્બર)/i
	};
	var parseMonthPatterns = {
	  narrow: [/^જા/i, /^ફે/i, /^મા/i, /^એ/i, /^મે/i, /^જૂ/i, /^જુ/i, /^ઑગ/i, /^સ/i, /^ઓક્ટો/i, /^ન/i, /^ડિ/i],
	  any: [/^જા/i, /^ફે/i, /^મા/i, /^એ/i, /^મે/i, /^જૂ/i, /^જુ/i, /^ઑગ/i, /^સ/i, /^ઓક્ટો/i, /^ન/i, /^ડિ/i]
	};
	var matchDayPatterns = {
	  narrow: /^(ર|સો|મં|બુ|ગુ|શુ|શ)/i,
	  short: /^(ર|સો|મં|બુ|ગુ|શુ|શ)/i,
	  abbreviated: /^(રવિ|સોમ|મંગળ|બુધ|ગુરુ|શુક્ર|શનિ)/i,
	  wide: /^(રવિવાર|સોમવાર|મંગળવાર|બુધવાર|ગુરુવાર|શુક્રવાર|શનિવાર)/i
	};
	var parseDayPatterns = {
	  narrow: [/^ર/i, /^સો/i, /^મં/i, /^બુ/i, /^ગુ/i, /^શુ/i, /^શ/i],
	  any: [/^ર/i, /^સો/i, /^મં/i, /^બુ/i, /^ગુ/i, /^શુ/i, /^શ/i]
	};
	var matchDayPeriodPatterns = {
	  narrow: /^(a|p|મ\.?|સ|બ|સાં|રા)/i,
	  any: /^(a|p|મ\.?|સ|બ|સાં|રા)/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^a/i,
	    pm: /^p/i,
	    midnight: /^મ\.?/i,
	    noon: /^બ/i,
	    morning: /સ/i,
	    afternoon: /બ/i,
	    evening: /સાં/i,
	    night: /રા/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index2.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index2.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index2.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index2.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index2.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1215 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1210));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1211));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1212));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1213));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1214));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Gujarati locale (India).
	 * @language Gujarati
	 * @iso-639-2 guj
	 * @author Manaday Mavani [@ManadayM]{@link https://github.com/manadaym}
	 */
	var locale = {
	  code: 'gu',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 1
	    /* Monday */
	    ,
	    firstWeekContainsDate: 4
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1216 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistance;
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    one: 'פחות משנייה',
	    two: 'פחות משתי שניות',
	    other: 'פחות מ־{{count}} שניות'
	  },
	  xSeconds: {
	    one: 'שנייה',
	    two: 'שתי שניות',
	    other: '{{count}} שניות'
	  },
	  halfAMinute: 'חצי דקה',
	  lessThanXMinutes: {
	    one: 'פחות מדקה',
	    two: 'פחות משתי דקות',
	    other: 'פחות מ־{{count}} דקות'
	  },
	  xMinutes: {
	    one: 'דקה',
	    two: 'שתי דקות',
	    other: '{{count}} דקות'
	  },
	  aboutXHours: {
	    one: 'כשעה',
	    two: 'כשעתיים',
	    other: 'כ־{{count}} שעות'
	  },
	  xHours: {
	    one: 'שעה',
	    two: 'שעתיים',
	    other: '{{count}} שעות'
	  },
	  xDays: {
	    one: 'יום',
	    two: 'יומיים',
	    other: '{{count}} ימים'
	  },
	  aboutXWeeks: {
	    one: 'כשבוע',
	    two: 'כשבועיים',
	    other: 'כ־{{count}} שבועות'
	  },
	  xWeeks: {
	    one: 'שבוע',
	    two: 'שבועיים',
	    other: '{{count}} שבועות'
	  },
	  aboutXMonths: {
	    one: 'כחודש',
	    two: 'כחודשיים',
	    other: 'כ־{{count}} חודשים'
	  },
	  xMonths: {
	    one: 'חודש',
	    two: 'חודשיים',
	    other: '{{count}} חודשים'
	  },
	  aboutXYears: {
	    one: 'כשנה',
	    two: 'כשנתיים',
	    other: 'כ־{{count}} שנים'
	  },
	  xYears: {
	    one: 'שנה',
	    two: 'שנתיים',
	    other: '{{count}} שנים'
	  },
	  overXYears: {
	    one: 'יותר משנה',
	    two: 'יותר משנתיים',
	    other: 'יותר מ־{{count}} שנים'
	  },
	  almostXYears: {
	    one: 'כמעט שנה',
	    two: 'כמעט שנתיים',
	    other: 'כמעט {{count}} שנים'
	  }
	};
	
	function formatDistance(token, count, options) {
	  options = options || {}; // Return word instead of `in one day` or `one day ago`
	
	  if (token === 'xDays' && options.addSuffix && count <= 2) {
	    var past = {
	      1: 'אתמול',
	      2: 'שלשום'
	    };
	    var future = {
	      1: 'מחר',
	      2: 'מחרתיים'
	    };
	    return options.comparison > 0 ? future[count] : past[count];
	  }
	
	  var result;
	
	  if (typeof formatDistanceLocale[token] === 'string') {
	    result = formatDistanceLocale[token];
	  } else if (count === 1) {
	    result = formatDistanceLocale[token].one;
	  } else if (count === 2) {
	    result = formatDistanceLocale[token].two;
	  } else {
	    result = formatDistanceLocale[token].other.replace('{{count}}', count);
	  }
	
	  if (options.addSuffix) {
	    if (options.comparison > 0) {
	      return 'בעוד ' + result;
	    } else {
	      return 'לפני ' + result;
	    }
	  }
	
	  return result;
	}
	
	module.exports = exports.default;

/***/ },
/* 1217 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: 'EEEE, d בMMMM y',
	  long: 'd בMMMM y',
	  medium: 'd בMMM y',
	  short: 'd.M.y'
	};
	var timeFormats = {
	  full: 'H:mm:ss zzzz',
	  long: 'H:mm:ss z',
	  medium: 'H:mm:ss',
	  short: 'H:mm'
	};
	var dateTimeFormats = {
	  full: "{{date}} 'בשעה' {{time}}",
	  long: "{{date}} 'בשעה' {{time}}",
	  medium: '{{date}}, {{time}}',
	  short: '{{date}}, {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1218 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRelative;
	var formatRelativeLocale = {
	  lastWeek: "eeee 'שעבר בשעה' p",
	  yesterday: "'אתמול בשעה' p",
	  today: "'היום בשעה' p",
	  tomorrow: "'מחר בשעה' p",
	  nextWeek: "eeee 'בשעה' p",
	  other: 'P'
	};
	
	function formatRelative(token, _date, _baseDate, _options) {
	  return formatRelativeLocale[token];
	}
	
	module.exports = exports.default;

/***/ },
/* 1219 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eraValues = {
	  narrow: ['לפנה״ס', 'לספירה'],
	  abbreviated: ['לפנה״ס', 'לספירה'],
	  wide: ['לפני הספירה', 'לספירה']
	};
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
	  wide: ['רבעון 1', 'רבעון 2', 'רבעון 3', 'רבעון 4']
	};
	var monthValues = {
	  narrow: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
	  abbreviated: ['ינו׳', 'פבר׳', 'מרץ', 'אפר׳', 'מאי', 'יוני', 'יולי', 'אוג׳', 'ספט׳', 'אוק׳', 'נוב׳', 'דצמ׳'],
	  wide: ['ינואר', 'פברואר', 'מרץ', 'אפריל', 'מאי', 'יוני', 'יולי', 'אוגוסט', 'ספטמבר', 'אוקטובר', 'נובמבר', 'דצמבר']
	};
	var dayValues = {
	  narrow: ['א׳', 'ב׳', 'ג׳', 'ד׳', 'ה׳', 'ו׳', 'ש׳'],
	  short: ['א׳', 'ב׳', 'ג׳', 'ד׳', 'ה׳', 'ו׳', 'ש׳'],
	  abbreviated: ['יום א׳', 'יום ב׳', 'יום ג׳', 'יום ד׳', 'יום ה׳', 'יום ו׳', 'שבת'],
	  wide: ['יום ראשון', 'יום שני', 'יום שלישי', 'יום רביעי', 'יום חמישי', 'יום שישי', 'יום שבת']
	};
	var dayPeriodValues = {
	  narrow: {
	    am: 'לפנה״צ',
	    pm: 'אחה״צ',
	    midnight: 'חצות',
	    noon: 'צהריים',
	    morning: 'בוקר',
	    afternoon: 'אחר הצהריים',
	    evening: 'ערב',
	    night: 'לילה'
	  },
	  abbreviated: {
	    am: 'לפנה״צ',
	    pm: 'אחה״צ',
	    midnight: 'חצות',
	    noon: 'צהריים',
	    morning: 'בוקר',
	    afternoon: 'אחר הצהריים',
	    evening: 'ערב',
	    night: 'לילה'
	  },
	  wide: {
	    am: 'לפנה״צ',
	    pm: 'אחה״צ',
	    midnight: 'חצות',
	    noon: 'צהריים',
	    morning: 'בוקר',
	    afternoon: 'אחר הצהריים',
	    evening: 'ערב',
	    night: 'לילה'
	  }
	};
	var formattingDayPeriodValues = {
	  narrow: {
	    am: 'לפנה״צ',
	    pm: 'אחה״צ',
	    midnight: 'חצות',
	    noon: 'צהריים',
	    morning: 'בבוקר',
	    afternoon: 'בצהריים',
	    evening: 'בערב',
	    night: 'בלילה'
	  },
	  abbreviated: {
	    am: 'לפנה״צ',
	    pm: 'אחה״צ',
	    midnight: 'חצות',
	    noon: 'צהריים',
	    morning: 'בבוקר',
	    afternoon: 'אחר הצהריים',
	    evening: 'בערב',
	    night: 'בלילה'
	  },
	  wide: {
	    am: 'לפנה״צ',
	    pm: 'אחה״צ',
	    midnight: 'חצות',
	    noon: 'צהריים',
	    morning: 'בבוקר',
	    afternoon: 'אחר הצהריים',
	    evening: 'בערב',
	    night: 'בלילה'
	  }
	};
	
	function ordinalNumber(dirtyNumber, dirtyOptions) {
	  var number = Number(dirtyNumber); // We only show words till 10
	
	  if (number <= 0 || number > 10) return number;
	  var options = dirtyOptions || {};
	  var unit = String(options.unit);
	  var isFemale = ['year', 'hour', 'minute', 'second'].indexOf(unit) >= 0;
	  var male = ['ראשון', 'שני', 'שלישי', 'רביעי', 'חמישי', 'שישי', 'שביעי', 'שמיני', 'תשיעי', 'עשירי'];
	  var female = ['ראשונה', 'שנייה', 'שלישית', 'רביעית', 'חמישית', 'שישית', 'שביעית', 'שמינית', 'תשיעית', 'עשירית'];
	  var index = number - 1;
	  return isFemale ? female[index] : male[index];
	}
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingDayPeriodValues,
	    defaultFormattingWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1220 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(15));
	
	var _index2 = _interopRequireDefault(__webpack_require__(14));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(\d+|(ראשון|שני|שלישי|רביעי|חמישי|שישי|שביעי|שמיני|תשיעי|עשירי|ראשונה|שנייה|שלישית|רביעית|חמישית|שישית|שביעית|שמינית|תשיעית|עשירית))/i;
	var parseOrdinalNumberPattern = /^(\d+|רא|שנ|של|רב|ח|שי|שב|שמ|ת|ע)/i;
	var matchEraPatterns = {
	  narrow: /^ל(ספירה|פנה״ס)/i,
	  abbreviated: /^ל(ספירה|פנה״ס)/i,
	  wide: /^ל(פני ה)?ספירה/i
	};
	var parseEraPatterns = {
	  any: [/^לפ/i, /^לס/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^q[1234]/i,
	  wide: /^רבעון [1234]/i
	};
	var parseQuarterPatterns = {
	  any: [/1/i, /2/i, /3/i, /4/i]
	};
	var matchMonthPatterns = {
	  narrow: /^\d+/i,
	  abbreviated: /^(ינו|פבר|מרץ|אפר|מאי|יוני|יולי|אוג|ספט|אוק|נוב|דצמ)׳?/i,
	  wide: /^(ינואר|פברואר|מרץ|אפריל|מאי|יוני|יולי|אוגוסט|ספטמבר|אוקטובר|נובמבר|דצמבר)/i
	};
	var parseMonthPatterns = {
	  narrow: [/^1$/i, /^2/i, /^3/i, /^4/i, /^5/i, /^6/i, /^7/i, /^8/i, /^9/i, /^10/i, /^11/i, /^12/i],
	  any: [/^ינ/i, /^פ/i, /^מר/i, /^אפ/i, /^מא/i, /^יונ/i, /^יול/i, /^אוג/i, /^ס/i, /^אוק/i, /^נ/i, /^ד/i]
	};
	var matchDayPatterns = {
	  narrow: /^[אבגדהוש]׳/i,
	  short: /^[אבגדהוש]׳/i,
	  abbreviated: /^(שבת|יום (א|ב|ג|ד|ה|ו)׳)/i,
	  wide: /^יום (ראשון|שני|שלישי|רביעי|חמישי|שישי|שבת)/i
	};
	var parseDayPatterns = {
	  abbreviated: [/א׳$/i, /ב׳$/i, /ג׳$/i, /ד׳$/i, /ה׳$/i, /ו׳$/i, /^ש/i],
	  wide: [/ן$/i, /ני$/i, /לישי$/i, /עי$/i, /מישי$/i, /שישי$/i, /ת$/i],
	  any: [/^א/i, /^ב/i, /^ג/i, /^ד/i, /^ה/i, /^ו/i, /^ש/i]
	};
	var matchDayPeriodPatterns = {
	  any: /^(אחר ה|ב)?(חצות|צהריים|בוקר|ערב|לילה|אחה״צ|לפנה״צ)/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^לפ/i,
	    pm: /^אחה/i,
	    midnight: /^ח/i,
	    noon: /^צ/i,
	    morning: /בוקר/i,
	    afternoon: /בצ|אחר/i,
	    evening: /ערב/i,
	    night: /לילה/i
	  }
	};
	var ordinalName = ['רא', 'שנ', 'של', 'רב', 'ח', 'שי', 'שב', 'שמ', 'ת', 'ע'];
	var match = {
	  ordinalNumber: (0, _index.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      var number = parseInt(value, 10);
	      return isNaN(number) ? ordinalName.indexOf(value) + 1 : number;
	    }
	  }),
	  era: (0, _index2.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index2.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index2.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index2.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index2.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1221 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1216));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1217));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1218));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1219));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1220));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Hebrew locale.
	 * @language Hebrew
	 * @iso-639-2 heb
	 * @author Nir Lahad [@nirlah]{@link https://github.com/nirlah}
	 */
	var locale = {
	  code: 'he',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 0
	    /* Sunday */
	    ,
	    firstWeekContainsDate: 1
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1222 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = __webpack_require__(284);
	
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    one: '१ सेकंड से कम',
	    // CLDR #1310
	    other: '{{count}} सेकंड से कम'
	  },
	  xSeconds: {
	    one: '१ सेकंड',
	    other: '{{count}} सेकंड'
	  },
	  halfAMinute: 'आधा मिनट',
	  lessThanXMinutes: {
	    one: '१ मिनट से कम',
	    other: '{{count}} मिनट से कम'
	  },
	  xMinutes: {
	    one: '१ मिनट',
	    // CLDR #1307
	    other: '{{count}} मिनट'
	  },
	  aboutXHours: {
	    one: 'लगभग १ घंटा',
	    other: 'लगभग {{count}} घंटे'
	  },
	  xHours: {
	    one: '१ घंटा',
	    // CLDR #1304
	    other: '{{count}} घंटे' // CLDR #4467
	
	  },
	  xDays: {
	    one: '१ दिन',
	    // CLDR #1286
	    other: '{{count}} दिन'
	  },
	  aboutXWeeks: {
	    one: 'लगभग १ सप्ताह',
	    other: 'लगभग {{count}} सप्ताह'
	  },
	  xWeeks: {
	    one: '१ सप्ताह',
	    other: '{{count}} सप्ताह'
	  },
	  aboutXMonths: {
	    one: 'लगभग १ महीना',
	    other: 'लगभग {{count}} महीने'
	  },
	  xMonths: {
	    one: '१ महीना',
	    other: '{{count}} महीने'
	  },
	  aboutXYears: {
	    one: 'लगभग १ वर्ष',
	    other: 'लगभग {{count}} वर्ष' // CLDR #4823
	
	  },
	  xYears: {
	    one: '१ वर्ष',
	    other: '{{count}} वर्ष'
	  },
	  overXYears: {
	    one: '१ वर्ष से अधिक',
	    other: '{{count}} वर्ष से अधिक'
	  },
	  almostXYears: {
	    one: 'लगभग १ वर्ष',
	    other: 'लगभग {{count}} वर्ष'
	  }
	};
	
	var formatDistance = function (token, count, options) {
	  var result;
	  var tokenValue = formatDistanceLocale[token];
	
	  if (typeof tokenValue === 'string') {
	    result = tokenValue;
	  } else if (count === 1) {
	    result = tokenValue.one;
	  } else {
	    result = tokenValue.other.replace('{{count}}', (0, _index.numberToLocale)(count));
	  }
	
	  if (options !== null && options !== void 0 && options.addSuffix) {
	    if (options.comparison && options.comparison > 0) {
	      return result + 'मे ';
	    } else {
	      return result + ' पहले';
	    }
	  }
	
	  return result;
	};
	
	var _default = formatDistance;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1223 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: 'EEEE, do MMMM, y',
	  // CLDR #1787
	  long: 'do MMMM, y',
	  // CLDR #1788
	  medium: 'd MMM, y',
	  // CLDR #1789
	  short: 'dd/MM/yyyy' // CLDR #1790
	
	};
	var timeFormats = {
	  full: 'h:mm:ss a zzzz',
	  // CLDR #1791
	  long: 'h:mm:ss a z',
	  // CLDR #1792
	  medium: 'h:mm:ss a',
	  // CLDR #1793
	  short: 'h:mm a' // CLDR #1794
	
	};
	var dateTimeFormats = {
	  full: "{{date}} 'को' {{time}}",
	  // CLDR #1795
	  long: "{{date}} 'को' {{time}}",
	  // CLDR #1796
	  medium: '{{date}}, {{time}}',
	  // CLDR #1797
	  short: '{{date}}, {{time}}' // CLDR #1798
	
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1224 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var formatRelativeLocale = {
	  lastWeek: "'पिछले' eeee p",
	  yesterday: "'कल' p",
	  today: "'आज' p",
	  tomorrow: "'कल' p",
	  nextWeek: "eeee 'को' p",
	  other: 'P'
	};
	
	var formatRelative = function (token, _date, _baseDate, _options) {
	  return formatRelativeLocale[token];
	};
	
	var _default = formatRelative;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1225 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(14));
	
	var _index2 = _interopRequireDefault(__webpack_require__(15));
	
	var _index3 = __webpack_require__(284);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^[०१२३४५६७८९]+/i;
	var parseOrdinalNumberPattern = /^[०१२३४५६७८९]+/i;
	var matchEraPatterns = {
	  narrow: /^(ईसा-पूर्व|ईस्वी)/i,
	  abbreviated: /^(ईसा\.?\s?पूर्व\.?|ईसा\.?)/i,
	  wide: /^(ईसा-पूर्व|ईसवी पूर्व|ईसवी सन|ईसवी)/i
	};
	var parseEraPatterns = {
	  any: [/^b/i, /^(a|c)/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^ति[1234]/i,
	  wide: /^[1234](पहली|दूसरी|तीसरी|चौथी)? तिमाही/i
	};
	var parseQuarterPatterns = {
	  any: [/1/i, /2/i, /3/i, /4/i]
	};
	var matchMonthPatterns = {
	  // eslint-disable-next-line no-misleading-character-class
	  narrow: /^[जफ़माअप्मईजूनजुअगसिअक्तनदि]/i,
	  abbreviated: /^(जन|फ़र|मार्च|अप्|मई|जून|जुल|अग|सित|अक्तू|नव|दिस)/i,
	  wide: /^(जनवरी|फ़रवरी|मार्च|अप्रैल|मई|जून|जुलाई|अगस्त|सितंबर|अक्तूबर|नवंबर|दिसंबर)/i
	};
	var parseMonthPatterns = {
	  narrow: [/^ज/i, /^फ़/i, /^मा/i, /^अप्/i, /^मई/i, /^जू/i, /^जु/i, /^अग/i, /^सि/i, /^अक्तू/i, /^न/i, /^दि/i],
	  any: [/^जन/i, /^फ़/i, /^मा/i, /^अप्/i, /^मई/i, /^जू/i, /^जु/i, /^अग/i, /^सि/i, /^अक्तू/i, /^नव/i, /^दिस/i]
	};
	var matchDayPatterns = {
	  // eslint-disable-next-line no-misleading-character-class
	  narrow: /^[रविसोममंगलबुधगुरुशुक्रशनि]/i,
	  short: /^(रवि|सोम|मंगल|बुध|गुरु|शुक्र|शनि)/i,
	  abbreviated: /^(रवि|सोम|मंगल|बुध|गुरु|शुक्र|शनि)/i,
	  wide: /^(रविवार|सोमवार|मंगलवार|बुधवार|गुरुवार|शुक्रवार|शनिवार)/i
	};
	var parseDayPatterns = {
	  narrow: [/^रवि/i, /^सोम/i, /^मंगल/i, /^बुध/i, /^गुरु/i, /^शुक्र/i, /^शनि/i],
	  any: [/^रवि/i, /^सोम/i, /^मंगल/i, /^बुध/i, /^गुरु/i, /^शुक्र/i, /^शनि/i]
	};
	var matchDayPeriodPatterns = {
	  narrow: /^(पू|अ|म|द.\?|सु|दो|शा|रा)/i,
	  any: /^(पूर्वाह्न|अपराह्न|म|द.\?|सु|दो|शा|रा)/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^पूर्वाह्न/i,
	    pm: /^अपराह्न/i,
	    midnight: /^मध्य/i,
	    noon: /^दो/i,
	    morning: /सु/i,
	    afternoon: /दो/i,
	    evening: /शा/i,
	    night: /रा/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index2.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: _index3.localeToNumber
	  }),
	  era: (0, _index.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1226 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1222));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1223));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1224));
	
	var _index4 = _interopRequireDefault(__webpack_require__(284));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1225));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Hindi locale (India).
	 * @language Hindi
	 * @iso-639-2 hin
	 * @author Mukesh Mandiwal [@mukeshmandiwal]{@link https://github.com/mukeshmandiwal}
	 */
	var locale = {
	  code: 'hi',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 0
	    /* Monday */
	    ,
	    firstWeekContainsDate: 4
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1227 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistance;
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    one: {
	      standalone: 'manje od 1 sekunde',
	      withPrepositionAgo: 'manje od 1 sekunde',
	      withPrepositionIn: 'manje od 1 sekundu'
	    },
	    dual: 'manje od {{count}} sekunde',
	    other: 'manje od {{count}} sekundi'
	  },
	  xSeconds: {
	    one: {
	      standalone: '1 sekunda',
	      withPrepositionAgo: '1 sekunde',
	      withPrepositionIn: '1 sekundu'
	    },
	    dual: '{{count}} sekunde',
	    other: '{{count}} sekundi'
	  },
	  halfAMinute: 'pola minute',
	  lessThanXMinutes: {
	    one: {
	      standalone: 'manje od 1 minute',
	      withPrepositionAgo: 'manje od 1 minute',
	      withPrepositionIn: 'manje od 1 minutu'
	    },
	    dual: 'manje od {{count}} minute',
	    other: 'manje od {{count}} minuta'
	  },
	  xMinutes: {
	    one: {
	      standalone: '1 minuta',
	      withPrepositionAgo: '1 minute',
	      withPrepositionIn: '1 minutu'
	    },
	    dual: '{{count}} minute',
	    other: '{{count}} minuta'
	  },
	  aboutXHours: {
	    one: {
	      standalone: 'oko 1 sat',
	      withPrepositionAgo: 'oko 1 sat',
	      withPrepositionIn: 'oko 1 sat'
	    },
	    dual: 'oko {{count}} sata',
	    other: 'oko {{count}} sati'
	  },
	  xHours: {
	    one: {
	      standalone: '1 sat',
	      withPrepositionAgo: '1 sat',
	      withPrepositionIn: '1 sat'
	    },
	    dual: '{{count}} sata',
	    other: '{{count}} sati'
	  },
	  xDays: {
	    one: {
	      standalone: '1 dan',
	      withPrepositionAgo: '1 dan',
	      withPrepositionIn: '1 dan'
	    },
	    dual: '{{count}} dana',
	    other: '{{count}} dana'
	  },
	  aboutXWeeks: {
	    one: {
	      standalone: 'oko 1 tjedan',
	      withPrepositionAgo: 'oko 1 tjedan',
	      withPrepositionIn: 'oko 1 tjedan'
	    },
	    dual: 'oko {{count}} tjedna',
	    other: 'oko {{count}} tjedana'
	  },
	  xWeeks: {
	    one: {
	      standalone: '1 tjedan',
	      withPrepositionAgo: '1 tjedan',
	      withPrepositionIn: '1 tjedan'
	    },
	    dual: '{{count}} tjedna',
	    other: '{{count}} tjedana'
	  },
	  aboutXMonths: {
	    one: {
	      standalone: 'oko 1 mjesec',
	      withPrepositionAgo: 'oko 1 mjesec',
	      withPrepositionIn: 'oko 1 mjesec'
	    },
	    dual: 'oko {{count}} mjeseca',
	    other: 'oko {{count}} mjeseci'
	  },
	  xMonths: {
	    one: {
	      standalone: '1 mjesec',
	      withPrepositionAgo: '1 mjesec',
	      withPrepositionIn: '1 mjesec'
	    },
	    dual: '{{count}} mjeseca',
	    other: '{{count}} mjeseci'
	  },
	  aboutXYears: {
	    one: {
	      standalone: 'oko 1 godinu',
	      withPrepositionAgo: 'oko 1 godinu',
	      withPrepositionIn: 'oko 1 godinu'
	    },
	    dual: 'oko {{count}} godine',
	    other: 'oko {{count}} godina'
	  },
	  xYears: {
	    one: {
	      standalone: '1 godina',
	      withPrepositionAgo: '1 godine',
	      withPrepositionIn: '1 godinu'
	    },
	    dual: '{{count}} godine',
	    other: '{{count}} godina'
	  },
	  overXYears: {
	    one: {
	      standalone: 'preko 1 godinu',
	      withPrepositionAgo: 'preko 1 godinu',
	      withPrepositionIn: 'preko 1 godinu'
	    },
	    dual: 'preko {{count}} godine',
	    other: 'preko {{count}} godina'
	  },
	  almostXYears: {
	    one: {
	      standalone: 'gotovo 1 godinu',
	      withPrepositionAgo: 'gotovo 1 godinu',
	      withPrepositionIn: 'gotovo 1 godinu'
	    },
	    dual: 'gotovo {{count}} godine',
	    other: 'gotovo {{count}} godina'
	  }
	};
	
	function formatDistance(token, count, options) {
	  options = options || {};
	  var result;
	
	  if (typeof formatDistanceLocale[token] === 'string') {
	    result = formatDistanceLocale[token];
	  } else if (count === 1) {
	    if (options.addSuffix) {
	      if (options.comparison > 0) {
	        result = formatDistanceLocale[token].one.withPrepositionIn;
	      } else {
	        result = formatDistanceLocale[token].one.withPrepositionAgo;
	      }
	    } else {
	      result = formatDistanceLocale[token].one.standalone;
	    }
	  } else if (count % 10 > 1 && count % 10 < 5 && // if last digit is between 2 and 4
	  String(count).substr(-2, 1) !== '1' // unless the 2nd to last digit is "1"
	  ) {
	      result = formatDistanceLocale[token].dual.replace('{{count}}', count);
	    } else {
	    result = formatDistanceLocale[token].other.replace('{{count}}', count);
	  }
	
	  if (options.addSuffix) {
	    if (options.comparison > 0) {
	      return 'za ' + result;
	    } else {
	      return 'prije ' + result;
	    }
	  }
	
	  return result;
	}
	
	module.exports = exports.default;

/***/ },
/* 1228 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: 'EEEE, d. MMMM y.',
	  long: 'd. MMMM y.',
	  medium: 'd. MMM y.',
	  short: 'dd. MM. y.'
	};
	var timeFormats = {
	  full: 'HH:mm:ss (zzzz)',
	  long: 'HH:mm:ss z',
	  medium: 'HH:mm:ss',
	  short: 'HH:mm'
	};
	var dateTimeFormats = {
	  full: "{{date}} 'u' {{time}}",
	  long: "{{date}} 'u' {{time}}",
	  medium: '{{date}} {{time}}',
	  short: '{{date}} {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1229 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRelative;
	var formatRelativeLocale = {
	  lastWeek: function (date) {
	    var day = date.getUTCDay();
	
	    switch (day) {
	      case 0:
	        return "'prošlu nedjelju u' p";
	
	      case 3:
	        return "'prošlu srijedu u' p";
	
	      case 6:
	        return "'prošlu subotu u' p";
	
	      default:
	        return "'prošli' EEEE 'u' p";
	    }
	  },
	  yesterday: "'jučer u' p",
	  today: "'danas u' p",
	  tomorrow: "'sutra u' p",
	  nextWeek: function (date) {
	    var day = date.getUTCDay();
	
	    switch (day) {
	      case 0:
	        return "'iduću nedjelju u' p";
	
	      case 3:
	        return "'iduću srijedu u' p";
	
	      case 6:
	        return "'iduću subotu u' p";
	
	      default:
	        return "'prošli' EEEE 'u' p";
	    }
	  },
	  other: 'P'
	};
	
	function formatRelative(token, date, _baseDate, _options) {
	  var format = formatRelativeLocale[token];
	
	  if (typeof format === 'function') {
	    return format(date);
	  }
	
	  return format;
	}
	
	module.exports = exports.default;

/***/ },
/* 1230 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ordinalNumber(dirtyNumber) {
	  var number = Number(dirtyNumber);
	  return String(number).concat('.');
	}
	
	var eraValues = {
	  narrow: ['pr.n.e.', 'AD'],
	  abbreviated: ['pr. Kr.', 'po. Kr.'],
	  wide: ['Prije Krista', 'Poslije Krista']
	};
	var monthValues = {
	  narrow: ['1.', '2.', '3.', '4.', '5.', '6.', '7.', '8.', '9.', '10.', '11.', '12.'],
	  abbreviated: ['sij', 'velj', 'ožu', 'tra', 'svi', 'lip', 'srp', 'kol', 'ruj', 'lis', 'stu', 'pro'],
	  wide: ['siječanj', 'veljača', 'ožujak', 'travanj', 'svibanj', 'lipanj', 'srpanj', 'kolovoz', 'rujan', 'listopad', 'studeni', 'prosinac']
	};
	var formattingMonthValues = {
	  narrow: ['1.', '2.', '3.', '4.', '5.', '6.', '7.', '8.', '9.', '10.', '11.', '12.'],
	  abbreviated: ['sij', 'velj', 'ožu', 'tra', 'svi', 'lip', 'srp', 'kol', 'ruj', 'lis', 'stu', 'pro'],
	  wide: ['siječnja', 'veljače', 'ožujka', 'travnja', 'svibnja', 'lipnja', 'srpnja', 'kolovoza', 'rujna', 'listopada', 'studenog', 'prosinca']
	};
	var quarterValues = {
	  narrow: ['1.', '2.', '3.', '4.'],
	  abbreviated: ['1. kv.', '2. kv.', '3. kv.', '4. kv.'],
	  wide: ['1. kvartal', '2. kvartal', '3. kvartal', '4. kvartal']
	};
	var dayValues = {
	  narrow: ['N', 'P', 'U', 'S', 'Č', 'P', 'S'],
	  short: ['ned', 'pon', 'uto', 'sri', 'čet', 'pet', 'sub'],
	  abbreviated: ['ned', 'pon', 'uto', 'sri', 'čet', 'pet', 'sub'],
	  wide: ['nedjelja', 'ponedjeljak', 'utorak', 'srijeda', 'četvrtak', 'petak', 'subota']
	};
	var formattingDayPeriodValues = {
	  narrow: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'ponoć',
	    noon: 'podne',
	    morning: 'ujutro',
	    afternoon: 'popodne',
	    evening: 'navečer',
	    night: 'noću'
	  },
	  abbreviated: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'ponoć',
	    noon: 'podne',
	    morning: 'ujutro',
	    afternoon: 'popodne',
	    evening: 'navečer',
	    night: 'noću'
	  },
	  wide: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'ponoć',
	    noon: 'podne',
	    morning: 'ujutro',
	    afternoon: 'poslije podne',
	    evening: 'navečer',
	    night: 'noću'
	  }
	};
	var dayPeriodValues = {
	  narrow: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'ponoć',
	    noon: 'podne',
	    morning: 'ujutro',
	    afternoon: 'popodne',
	    evening: 'navečer',
	    night: 'noću'
	  },
	  abbreviated: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'ponoć',
	    noon: 'podne',
	    morning: 'ujutro',
	    afternoon: 'popodne',
	    evening: 'navečer',
	    night: 'noću'
	  },
	  wide: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'ponoć',
	    noon: 'podne',
	    morning: 'ujutro',
	    afternoon: 'poslije podne',
	    evening: 'navečer',
	    night: 'noću'
	  }
	};
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingMonthValues,
	    defaultFormattingWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingDayPeriodValues,
	    defaultFormattingWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1231 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(14));
	
	var _index2 = _interopRequireDefault(__webpack_require__(15));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(\d+)\./i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^(pr\.n\.e\.|AD)/i,
	  abbreviated: /^(pr\.\s?Kr\.|po\.\s?Kr\.)/i,
	  wide: /^(Prije Krista|prije nove ere|Poslije Krista|nova era)/i
	};
	var parseEraPatterns = {
	  any: [/^pr/i, /^(po|nova)/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^[1234]\.\s?kv\.?/i,
	  wide: /^[1234]\. kvartal/i
	};
	var parseQuarterPatterns = {
	  any: [/1/i, /2/i, /3/i, /4/i]
	};
	var matchMonthPatterns = {
	  narrow: /^(10|11|12|[123456789])\./i,
	  abbreviated: /^(sij|velj|(ožu|ozu)|tra|svi|lip|srp|kol|ruj|lis|stu|pro)/i,
	  wide: /^((siječanj|siječnja|sijecanj|sijecnja)|(veljača|veljače|veljaca|veljace)|(ožujak|ožujka|ozujak|ozujka)|(travanj|travnja)|(svibanj|svibnja)|(lipanj|lipnja)|(srpanj|srpnja)|(kolovoz|kolovoza)|(rujan|rujna)|(listopad|listopada)|(studeni|studenog)|(prosinac|prosinca))/i
	};
	var parseMonthPatterns = {
	  narrow: [/(10|11|12|[123456789])/i],
	  abbreviated: [/^sij/i, /^velj/i, /^(ožu|ozu)/i, /^tra/i, /^svi/i, /^lip/i, /^srp/i, /^kol/i, /^ruj/i, /^lis/i, /^stu/i, /^pro/i],
	  wide: [/^sij/i, /^velj/i, /^(ožu|ozu)/i, /^tra/i, /^svi/i, /^lip/i, /^srp/i, /^kol/i, /^ruj/i, /^lis/i, /^stu/i, /^pro/i]
	};
	var matchDayPatterns = {
	  narrow: /^[npusčc]/i,
	  short: /^(ned|pon|uto|sri|(čet|cet)|pet|sub)/i,
	  abbreviated: /^(ned|pon|uto|sri|(čet|cet)|pet|sub)/i,
	  wide: /^(nedjelja|ponedjeljak|utorak|srijeda|(četvrtak|cetvrtak)|petak|subota)/i
	};
	var parseDayPatterns = {
	  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
	  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
	};
	var matchDayPeriodPatterns = {
	  any: /^(am|pm|ponoc|ponoć|(po)?podne|navecer|navečer|noću|poslije podne|ujutro)/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^a/i,
	    pm: /^p/i,
	    midnight: /^pono/i,
	    noon: /^pod/i,
	    morning: /jutro/i,
	    afternoon: /(poslije\s|po)+podne/i,
	    evening: /(navece|naveče)/i,
	    night: /(nocu|noću)/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index2.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1232 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1227));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1228));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1229));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1230));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1231));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Croatian locale.
	 * @language Croatian
	 * @iso-639-2 hrv
	 * @author Matija Marohnić [@silvenon]{@link https://github.com/silvenon}
	 * @author Manico [@manico]{@link https://github.com/manico}
	 * @author Ivan Jeržabek [@jerzabek]{@link https://github.com/jerzabek}
	 */
	var locale = {
	  code: 'hr',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 1
	    /* Monday */
	    ,
	    firstWeekContainsDate: 1
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1233 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistance;
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    one: 'mwens pase yon segond',
	    other: 'mwens pase {{count}} segond'
	  },
	  xSeconds: {
	    one: '1 segond',
	    other: '{{count}} segond'
	  },
	  halfAMinute: '30 segond',
	  lessThanXMinutes: {
	    one: 'mwens pase yon minit',
	    other: 'mwens pase {{count}} minit'
	  },
	  xMinutes: {
	    one: '1 minit',
	    other: '{{count}} minit'
	  },
	  aboutXHours: {
	    one: 'anviwon inè',
	    other: 'anviwon {{count}} è'
	  },
	  xHours: {
	    one: '1 lè',
	    other: '{{count}} lè'
	  },
	  xDays: {
	    one: '1 jou',
	    other: '{{count}} jou'
	  },
	  aboutXWeeks: {
	    one: 'anviwon 1 semèn',
	    other: 'anviwon {{count}} semèn'
	  },
	  xWeeks: {
	    one: '1 semèn',
	    other: '{{count}} semèn'
	  },
	  aboutXMonths: {
	    one: 'anviwon 1 mwa',
	    other: 'anviwon {{count}} mwa'
	  },
	  xMonths: {
	    one: '1 mwa',
	    other: '{{count}} mwa'
	  },
	  aboutXYears: {
	    one: 'anviwon 1 an',
	    other: 'anviwon {{count}} an'
	  },
	  xYears: {
	    one: '1 an',
	    other: '{{count}} an'
	  },
	  overXYears: {
	    one: 'plis pase 1 an',
	    other: 'plis pase {{count}} an'
	  },
	  almostXYears: {
	    one: 'prèske 1 an',
	    other: 'prèske {{count}} an'
	  }
	};
	
	function formatDistance(token, count, options) {
	  options = options || {};
	  var result;
	
	  if (typeof formatDistanceLocale[token] === 'string') {
	    result = formatDistanceLocale[token];
	  } else if (count === 1) {
	    result = formatDistanceLocale[token].one;
	  } else {
	    result = formatDistanceLocale[token].other.replace('{{count}}', count);
	  }
	
	  if (options.addSuffix) {
	    if (options.comparison > 0) {
	      return 'nan ' + result;
	    } else {
	      return 'sa fè ' + result;
	    }
	  }
	
	  return result;
	}
	
	module.exports = exports.default;

/***/ },
/* 1234 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: 'EEEE d MMMM y',
	  long: 'd MMMM y',
	  medium: 'd MMM y',
	  short: 'dd/MM/y'
	};
	var timeFormats = {
	  full: 'HH:mm:ss zzzz',
	  long: 'HH:mm:ss z',
	  medium: 'HH:mm:ss',
	  short: 'HH:mm'
	};
	var dateTimeFormats = {
	  full: "{{date}} 'nan lè' {{time}}",
	  long: "{{date}} 'nan lè' {{time}}",
	  medium: '{{date}}, {{time}}',
	  short: '{{date}}, {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1235 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRelative;
	var formatRelativeLocale = {
	  lastWeek: "eeee 'pase nan lè' p",
	  yesterday: "'yè nan lè' p",
	  today: "'jodi a' p",
	  tomorrow: "'demen nan lè' p'",
	  nextWeek: "eeee 'pwochen nan lè' p",
	  other: 'P'
	};
	
	function formatRelative(token, _date, _baseDate, _options) {
	  return formatRelativeLocale[token];
	}
	
	module.exports = exports.default;

/***/ },
/* 1236 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eraValues = {
	  narrow: ['av. J.-K', 'ap. J.-K'],
	  abbreviated: ['av. J.-K', 'ap. J.-K'],
	  wide: ['anvan Jezi Kris', 'apre Jezi Kris']
	};
	var quarterValues = {
	  narrow: ['T1', 'T2', 'T3', 'T4'],
	  abbreviated: ['1ye trim.', '2yèm trim.', '3yèm trim.', '4yèm trim.'],
	  wide: ['1ye trimès', '2yèm trimès', '3yèm trimès', '4yèm trimès']
	};
	var monthValues = {
	  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'O', 'S', 'O', 'N', 'D'],
	  abbreviated: ['janv.', 'fevr.', 'mas', 'avr.', 'me', 'jen', 'jiyè', 'out', 'sept.', 'okt.', 'nov.', 'des.'],
	  wide: ['janvye', 'fevrye', 'mas', 'avril', 'me', 'jen', 'jiyè', 'out', 'septanm', 'oktòb', 'novanm', 'desanm']
	};
	var dayValues = {
	  narrow: ['D', 'L', 'M', 'M', 'J', 'V', 'S'],
	  short: ['di', 'le', 'ma', 'mè', 'je', 'va', 'sa'],
	  abbreviated: ['dim.', 'len.', 'mad.', 'mèk.', 'jed.', 'van.', 'sam.'],
	  wide: ['dimanch', 'lendi', 'madi', 'mèkredi', 'jedi', 'vandredi', 'samdi']
	};
	var dayPeriodValues = {
	  narrow: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'minwit',
	    noon: 'midi',
	    morning: 'mat.',
	    afternoon: 'ap.m.',
	    evening: 'swa',
	    night: 'mat.'
	  },
	  abbreviated: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'minwit',
	    noon: 'midi',
	    morning: 'maten',
	    afternoon: 'aprèmidi',
	    evening: 'swa',
	    night: 'maten'
	  },
	  wide: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'minwit',
	    noon: 'midi',
	    morning: 'nan maten',
	    afternoon: 'nan aprèmidi',
	    evening: 'nan aswè',
	    night: 'nan maten'
	  }
	};
	
	function ordinalNumber(dirtyNumber, dirtyOptions) {
	  var number = Number(dirtyNumber);
	  var options = dirtyOptions || {};
	  var unit = String(options.unit);
	  var suffix;
	
	  if (number === 0) {
	    return number;
	  }
	
	  if (unit === 'year' || unit === 'hour' || unit === 'week') {
	    if (number === 1) {
	      suffix = 'ye';
	    } else {
	      suffix = 'yèm';
	    }
	  } else {
	    if (number === 1) {
	      suffix = 'ye';
	    } else {
	      suffix = 'yèm';
	    }
	  }
	
	  return number + suffix;
	}
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1237 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(15));
	
	var _index2 = _interopRequireDefault(__webpack_require__(14));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(\d+)(ye|yèm)?/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^(av\.J\.K|ap\.J\.K|ap\.J\.-K)/i,
	  abbreviated: /^(av\.J\.-K|av\.J-K|apr\.J\.-K|apr\.J-K|ap\.J-K)/i,
	  wide: /^(avan Jezi Kris|apre Jezi Kris)/i
	};
	var parseEraPatterns = {
	  any: [/^av/i, /^ap/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^t[1234]/i,
	  wide: /^[1234](ye|yèm)? trimès/i
	};
	var parseQuarterPatterns = {
	  any: [/1/i, /2/i, /3/i, /4/i]
	};
	var matchMonthPatterns = {
	  narrow: /^[jfmasond]/i,
	  abbreviated: /^(janv|fevr|mas|avr|me|jen|jiyè|out|sept|okt|nov|des)\.?/i,
	  wide: /^(janvye|fevrye|mas|avril|me|jen|jiyè|out|septanm|oktòb|novanm|desanm)/i
	};
	var parseMonthPatterns = {
	  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^o/i, /^s/i, /^o/i, /^n/i, /^d/i],
	  any: [/^ja/i, /^f/i, /^ma/i, /^av/i, /^me/i, /^je/i, /^ji/i, /^ou/i, /^s/i, /^ok/i, /^n/i, /^d/i]
	};
	var matchDayPatterns = {
	  narrow: /^[lmjvsd]/i,
	  short: /^(di|le|ma|me|je|va|sa)/i,
	  abbreviated: /^(dim|len|mad|mèk|jed|van|sam)\.?/i,
	  wide: /^(dimanch|lendi|madi|mèkredi|jedi|vandredi|samdi)/i
	};
	var parseDayPatterns = {
	  narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^j/i, /^v/i, /^s/i],
	  any: [/^di/i, /^le/i, /^ma/i, /^mè/i, /^je/i, /^va/i, /^sa/i]
	};
	var matchDayPeriodPatterns = {
	  narrow: /^(a|p|minwit|midi|mat\.?|ap\.?m\.?|swa)/i,
	  any: /^([ap]\.?\s?m\.?|nan maten|nan aprèmidi|nan aswè)/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^a/i,
	    pm: /^p/i,
	    midnight: /^min/i,
	    noon: /^mid/i,
	    morning: /mat/i,
	    afternoon: /ap/i,
	    evening: /sw/i,
	    night: /nwit/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index2.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index2.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index2.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index2.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index2.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1238 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1233));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1234));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1235));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1236));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1237));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Haitian Creole locale.
	 * @language Haitian Creole
	 * @iso-639-2 hat
	 * @author Rubens Mariuzzo [@rmariuzzo]{@link https://github.com/rmariuzzo}
	 * @author Watson Marcelain [@watsongm24]{@link https://github.com/watsongm24}
	 */
	var locale = {
	  code: 'ht',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 1
	    /* Monday */
	    ,
	    firstWeekContainsDate: 4
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1239 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistance;
	var translations = {
	  about: 'körülbelül',
	  over: 'több mint',
	  almost: 'majdnem',
	  lessthan: 'kevesebb mint'
	};
	var withoutSuffixes = {
	  xseconds: ' másodperc',
	  halfaminute: 'fél perc',
	  xminutes: ' perc',
	  xhours: ' óra',
	  xdays: ' nap',
	  xweeks: ' hét',
	  xmonths: ' hónap',
	  xyears: ' év'
	};
	var withSuffixes = {
	  xseconds: {
	    '-1': ' másodperccel ezelőtt',
	    '1': ' másodperc múlva',
	    '0': ' másodperce'
	  },
	  halfaminute: {
	    '-1': 'fél perccel ezelőtt',
	    '1': 'fél perc múlva',
	    '0': 'fél perce'
	  },
	  xminutes: {
	    '-1': ' perccel ezelőtt',
	    '1': ' perc múlva',
	    '0': ' perce'
	  },
	  xhours: {
	    '-1': ' órával ezelőtt',
	    '1': ' óra múlva',
	    '0': ' órája'
	  },
	  xdays: {
	    '-1': ' nappal ezelőtt',
	    '1': ' nap múlva',
	    '0': ' napja'
	  },
	  xweeks: {
	    '-1': ' héttel ezelőtt',
	    '1': ' hét múlva',
	    '0': ' hete'
	  },
	  xmonths: {
	    '-1': ' hónappal ezelőtt',
	    '1': ' hónap múlva',
	    '0': ' hónapja'
	  },
	  xyears: {
	    '-1': ' évvel ezelőtt',
	    '1': ' év múlva',
	    '0': ' éve'
	  }
	};
	
	function translate(number, addSuffix, key, comparison) {
	  var translated = addSuffix ? withSuffixes[key][comparison] : withoutSuffixes[key];
	
	  if (key === 'halfaminute') {
	    return translated;
	  }
	
	  return number + translated;
	}
	
	function formatDistance(token, count, options) {
	  options = options || {};
	  var adverb = token.match(/about|over|almost|lessthan/i);
	  var unit = token.replace(adverb, '');
	  var result;
	  result = translate(count, options.addSuffix, unit.toLowerCase(), options.comparison);
	
	  if (adverb) {
	    result = translations[adverb[0].toLowerCase()] + ' ' + result;
	  }
	
	  return result;
	}
	
	module.exports = exports.default;

/***/ },
/* 1240 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: 'y. MMMM d., EEEE',
	  long: 'y. MMMM d.',
	  medium: 'y. MMM d.',
	  short: 'y. MM. dd.'
	};
	var timeFormats = {
	  full: 'H:mm:ss zzzz',
	  long: 'H:mm:ss z',
	  medium: 'H:mm:ss',
	  short: 'H:mm'
	};
	var dateTimeFormats = {
	  full: '{{date}} {{time}}',
	  long: '{{date}} {{time}}',
	  medium: '{{date}} {{time}}',
	  short: '{{date}} {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1241 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRelative;
	var accusativeWeekdays = ['vasárnap', 'hétfőn', 'kedden', 'szerdán', 'csütörtökön', 'pénteken', 'szombaton'];
	
	function week(isFuture) {
	  return function (date, _baseDate, _options) {
	    var day = date.getUTCDay();
	    return (isFuture ? '' : "'múlt' ") + "'" + accusativeWeekdays[day] + "'" + " p'-kor'";
	  };
	}
	
	var formatRelativeLocale = {
	  lastWeek: week(false),
	  yesterday: "'tegnap' p'-kor'",
	  today: "'ma' p'-kor'",
	  tomorrow: "'holnap' p'-kor'",
	  nextWeek: week(true),
	  other: 'P'
	};
	
	function formatRelative(token, date, baseDate, options) {
	  var format = formatRelativeLocale[token];
	
	  if (typeof format === 'function') {
	    return format(date, baseDate, options);
	  }
	
	  return format;
	}
	
	module.exports = exports.default;

/***/ },
/* 1242 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eraValues = {
	  narrow: ['ie.', 'isz.'],
	  abbreviated: ['i. e.', 'i. sz.'],
	  wide: ['Krisztus előtt', 'időszámításunk szerint']
	};
	var quarterValues = {
	  narrow: ['1.', '2.', '3.', '4.'],
	  abbreviated: ['1. n.év', '2. n.év', '3. n.év', '4. n.év'],
	  wide: ['1. negyedév', '2. negyedév', '3. negyedév', '4. negyedév']
	};
	var formattingQuarterValues = {
	  narrow: ['I.', 'II.', 'III.', 'IV.'],
	  abbreviated: ['I. n.év', 'II. n.év', 'III. n.év', 'IV. n.év'],
	  wide: ['I. negyedév', 'II. negyedév', 'III. negyedév', 'IV. negyedév']
	};
	var monthValues = {
	  narrow: ['J', 'F', 'M', 'Á', 'M', 'J', 'J', 'A', 'Sz', 'O', 'N', 'D'],
	  abbreviated: ['jan.', 'febr.', 'márc.', 'ápr.', 'máj.', 'jún.', 'júl.', 'aug.', 'szept.', 'okt.', 'nov.', 'dec.'],
	  wide: ['január', 'február', 'március', 'április', 'május', 'június', 'július', 'augusztus', 'szeptember', 'október', 'november', 'december']
	};
	var dayValues = {
	  narrow: ['V', 'H', 'K', 'Sz', 'Cs', 'P', 'Sz'],
	  short: ['V', 'H', 'K', 'Sze', 'Cs', 'P', 'Szo'],
	  abbreviated: ['V', 'H', 'K', 'Sze', 'Cs', 'P', 'Szo'],
	  wide: ['vasárnap', 'hétfő', 'kedd', 'szerda', 'csütörtök', 'péntek', 'szombat']
	};
	var dayPeriodValues = {
	  narrow: {
	    am: 'de.',
	    pm: 'du.',
	    midnight: 'éjfél',
	    noon: 'dél',
	    morning: 'reggel',
	    afternoon: 'du.',
	    evening: 'este',
	    night: 'éjjel'
	  },
	  abbreviated: {
	    am: 'de.',
	    pm: 'du.',
	    midnight: 'éjfél',
	    noon: 'dél',
	    morning: 'reggel',
	    afternoon: 'du.',
	    evening: 'este',
	    night: 'éjjel'
	  },
	  wide: {
	    am: 'de.',
	    pm: 'du.',
	    midnight: 'éjfél',
	    noon: 'dél',
	    morning: 'reggel',
	    afternoon: 'délután',
	    evening: 'este',
	    night: 'éjjel'
	  }
	};
	
	function ordinalNumber(dirtyNumber, _dirtyOptions) {
	  var number = Number(dirtyNumber);
	  return number + '.';
	}
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingQuarterValues,
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide',
	    defaultFormattingWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1243 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(15));
	
	var _index2 = _interopRequireDefault(__webpack_require__(14));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(\d+)\.?/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^(ie\.|isz\.)/i,
	  abbreviated: /^(i\.\s?e\.?|b?\s?c\s?e|i\.\s?sz\.?)/i,
	  wide: /^(Krisztus előtt|időszámításunk előtt|időszámításunk szerint|i\. sz\.)/i
	};
	var parseEraPatterns = {
	  narrow: [/ie/i, /isz/i],
	  abbreviated: [/^(i\.?\s?e\.?|b\s?ce)/i, /^(i\.?\s?sz\.?|c\s?e)/i],
	  any: [/előtt/i, /(szerint|i. sz.)/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]\.?/i,
	  abbreviated: /^[1234]?\.?\s?n\.év/i,
	  wide: /^([1234]|I|II|III|IV)?\.?\s?negyedév/i
	};
	var parseQuarterPatterns = {
	  any: [/1|I$/i, /2|II$/i, /3|III/i, /4|IV/i]
	};
	var matchMonthPatterns = {
	  narrow: /^[jfmaásond]|sz/i,
	  abbreviated: /^(jan\.?|febr\.?|márc\.?|ápr\.?|máj\.?|jún\.?|júl\.?|aug\.?|szept\.?|okt\.?|nov\.?|dec\.?)/i,
	  wide: /^(január|február|március|április|május|június|július|augusztus|szeptember|október|november|december)/i
	};
	var parseMonthPatterns = {
	  narrow: [/^j/i, /^f/i, /^m/i, /^a|á/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s|sz/i, /^o/i, /^n/i, /^d/i],
	  any: [/^ja/i, /^f/i, /^már/i, /^áp/i, /^máj/i, /^jún/i, /^júl/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
	};
	var matchDayPatterns = {
	  narrow: /^([vhkpc]|sz|cs|sz)/i,
	  short: /^([vhkp]|sze|cs|szo)/i,
	  abbreviated: /^([vhkp]|sze|cs|szo)/i,
	  wide: /^(vasárnap|hétfő|kedd|szerda|csütörtök|péntek|szombat)/i
	};
	var parseDayPatterns = {
	  narrow: [/^v/i, /^h/i, /^k/i, /^sz/i, /^c/i, /^p/i, /^sz/i],
	  any: [/^v/i, /^h/i, /^k/i, /^sze/i, /^c/i, /^p/i, /^szo/i]
	};
	var matchDayPeriodPatterns = {
	  any: /^((de|du)\.?|éjfél|délután|dél|reggel|este|éjjel)/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^de\.?/i,
	    pm: /^du\.?/i,
	    midnight: /^éjf/i,
	    noon: /^dé/i,
	    morning: /reg/i,
	    afternoon: /^délu\.?/i,
	    evening: /es/i,
	    night: /éjj/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index2.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index2.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index2.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index2.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index2.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1244 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1239));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1240));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1241));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1242));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1243));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 *
	 * @summary Hungarian locale.
	 * @language Hungarian
	 *
	 * @iso-639-2 hun
	 *
	 * @author Pavlo Shpak [@pshpak]{@link https://github.com/pshpak}
	 * @author Eduardo Pardo [@eduardopsll]{@link https://github.com/eduardopsll}
	 * @author Zoltan Szepesi [@twodcube]{@link https://github.com/twodcube}
	 */
	var locale = {
	  code: 'hu',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 1
	    /* Monday */
	    ,
	    firstWeekContainsDate: 4
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1245 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistance;
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    one: 'ավելի քիչ քան 1 վայրկյան',
	    other: 'ավելի քիչ քան {{count}} վայրկյան'
	  },
	  xSeconds: {
	    one: '1 վայրկյան',
	    other: '{{count}} վայրկյան'
	  },
	  halfAMinute: 'կես րոպե',
	  lessThanXMinutes: {
	    one: 'ավելի քիչ քան 1 րոպե',
	    other: 'ավելի քիչ քան {{count}} րոպե'
	  },
	  xMinutes: {
	    one: '1 րոպե',
	    other: '{{count}} րոպե'
	  },
	  aboutXHours: {
	    one: 'մոտ 1 ժամ',
	    other: 'մոտ {{count}} ժամ'
	  },
	  xHours: {
	    one: '1 ժամ',
	    other: '{{count}} ժամ'
	  },
	  xDays: {
	    one: '1 օր',
	    other: '{{count}} օր'
	  },
	  aboutXWeeks: {
	    one: 'մոտ 1 շաբաթ',
	    other: 'մոտ {{count}} շաբաթ'
	  },
	  xWeeks: {
	    one: '1 շաբաթ',
	    other: '{{count}} շաբաթ'
	  },
	  aboutXMonths: {
	    one: 'մոտ 1 ամիս',
	    other: 'մոտ {{count}} ամիս'
	  },
	  xMonths: {
	    one: '1 ամիս',
	    other: '{{count}} ամիս'
	  },
	  aboutXYears: {
	    one: 'մոտ 1 տարի',
	    other: 'մոտ {{count}} տարի'
	  },
	  xYears: {
	    one: '1 տարի',
	    other: '{{count}} տարի'
	  },
	  overXYears: {
	    one: 'ավելի քան 1 տարի',
	    other: 'ավելի քան {{count}} տարի'
	  },
	  almostXYears: {
	    one: 'համարյա 1 տարի',
	    other: 'համարյա {{count}} տարի'
	  }
	};
	
	function formatDistance(token, count, options) {
	  options = options || {};
	  var result;
	
	  if (typeof formatDistanceLocale[token] === 'string') {
	    result = formatDistanceLocale[token];
	  } else if (count === 1) {
	    result = formatDistanceLocale[token].one;
	  } else {
	    result = formatDistanceLocale[token].other.replace('{{count}}', count);
	  }
	
	  if (options.addSuffix) {
	    if (options.comparison > 0) {
	      return result + ' հետո';
	    } else {
	      return result + ' առաջ';
	    }
	  }
	
	  return result;
	}
	
	module.exports = exports.default;

/***/ },
/* 1246 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: 'd MMMM, y, EEEE',
	  long: 'd MMMM, y',
	  medium: 'd MMM, y',
	  short: 'dd.MM.yyyy'
	};
	var timeFormats = {
	  full: 'HH:mm:ss zzzz',
	  long: 'HH:mm:ss z',
	  medium: 'HH:mm:ss',
	  short: 'HH:mm'
	};
	var dateTimeFormats = {
	  full: "{{date}} 'ժ․'{{time}}",
	  long: "{{date}} 'ժ․'{{time}}",
	  medium: '{{date}}, {{time}}',
	  short: '{{date}}, {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1247 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRelative;
	var formatRelativeLocale = {
	  lastWeek: "'նախորդ' eeee p'֊ին'",
	  yesterday: "'երեկ' p'֊ին'",
	  today: "'այսօր' p'֊ին'",
	  tomorrow: "'վաղը' p'֊ին'",
	  nextWeek: "'հաջորդ' eeee p'֊ին'",
	  other: 'P'
	};
	
	function formatRelative(token, _date, _baseDate, _options) {
	  return formatRelativeLocale[token];
	}
	
	module.exports = exports.default;

/***/ },
/* 1248 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eraValues = {
	  narrow: ['Ք', 'Մ'],
	  abbreviated: ['ՔԱ', 'ՄԹ'],
	  wide: ['Քրիստոսից առաջ', 'Մեր թվարկության']
	};
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['Ք1', 'Ք2', 'Ք3', 'Ք4'],
	  wide: ['1֊ին քառորդ', '2֊րդ քառորդ', '3֊րդ քառորդ', '4֊րդ քառորդ']
	};
	var monthValues = {
	  narrow: ['Հ', 'Փ', 'Մ', 'Ա', 'Մ', 'Հ', 'Հ', 'Օ', 'Ս', 'Հ', 'Ն', 'Դ'],
	  abbreviated: ['հուն', 'փետ', 'մար', 'ապր', 'մայ', 'հուն', 'հուլ', 'օգս', 'սեպ', 'հոկ', 'նոյ', 'դեկ'],
	  wide: ['հունվար', 'փետրվար', 'մարտ', 'ապրիլ', 'մայիս', 'հունիս', 'հուլիս', 'օգոստոս', 'սեպտեմբեր', 'հոկտեմբեր', 'նոյեմբեր', 'դեկտեմբեր']
	};
	var dayValues = {
	  narrow: ['Կ', 'Ե', 'Ե', 'Չ', 'Հ', 'Ո', 'Շ'],
	  short: ['կր', 'եր', 'եք', 'չք', 'հգ', 'ուր', 'շբ'],
	  abbreviated: ['կիր', 'երկ', 'երք', 'չոր', 'հնգ', 'ուրբ', 'շաբ'],
	  wide: ['կիրակի', 'երկուշաբթի', 'երեքշաբթի', 'չորեքշաբթի', 'հինգշաբթի', 'ուրբաթ', 'շաբաթ']
	};
	var dayPeriodValues = {
	  narrow: {
	    am: 'a',
	    pm: 'p',
	    midnight: 'կեսգշ',
	    noon: 'կեսօր',
	    morning: 'առավոտ',
	    afternoon: 'ցերեկ',
	    evening: 'երեկո',
	    night: 'գիշեր'
	  },
	  abbreviated: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'կեսգիշեր',
	    noon: 'կեսօր',
	    morning: 'առավոտ',
	    afternoon: 'ցերեկ',
	    evening: 'երեկո',
	    night: 'գիշեր'
	  },
	  wide: {
	    am: 'a.m.',
	    pm: 'p.m.',
	    midnight: 'կեսգիշեր',
	    noon: 'կեսօր',
	    morning: 'առավոտ',
	    afternoon: 'ցերեկ',
	    evening: 'երեկո',
	    night: 'գիշեր'
	  }
	};
	var formattingDayPeriodValues = {
	  narrow: {
	    am: 'a',
	    pm: 'p',
	    midnight: 'կեսգշ',
	    noon: 'կեսօր',
	    morning: 'առավոտը',
	    afternoon: 'ցերեկը',
	    evening: 'երեկոյան',
	    night: 'գիշերը'
	  },
	  abbreviated: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'կեսգիշերին',
	    noon: 'կեսօրին',
	    morning: 'առավոտը',
	    afternoon: 'ցերեկը',
	    evening: 'երեկոյան',
	    night: 'գիշերը'
	  },
	  wide: {
	    am: 'a.m.',
	    pm: 'p.m.',
	    midnight: 'կեսգիշերին',
	    noon: 'կեսօրին',
	    morning: 'առավոտը',
	    afternoon: 'ցերեկը',
	    evening: 'երեկոյան',
	    night: 'գիշերը'
	  }
	};
	
	function ordinalNumber(dirtyNumber, _dirtyOptions) {
	  var number = Number(dirtyNumber); // If ordinal numbers depend on context, for example,
	  // if they are different for different grammatical genders,
	  // use `options.unit`:
	  //
	  //   var options = dirtyOptions || {}
	  //   var unit = String(options.unit)
	  //
	  // where `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
	  // 'day', 'hour', 'minute', 'second'
	
	  var rem100 = number % 100;
	
	  if (rem100 < 10) {
	    if (rem100 % 10 === 1) {
	      return number + '֊ին';
	    }
	  }
	
	  return number + '֊րդ';
	}
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingDayPeriodValues,
	    defaultFormattingWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1249 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(15));
	
	var _index2 = _interopRequireDefault(__webpack_require__(14));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(\d+)((-|֊)?(ին|րդ))?/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^(Ք|Մ)/i,
	  abbreviated: /^(Ք\.?\s?Ա\.?|Մ\.?\s?Թ\.?\s?Ա\.?|Մ\.?\s?Թ\.?|Ք\.?\s?Հ\.?)/i,
	  wide: /^(քրիստոսից առաջ|մեր թվարկությունից առաջ|մեր թվարկության|քրիստոսից հետո)/i
	};
	var parseEraPatterns = {
	  any: [/^(ք|մ)/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^ք[1234]/i,
	  wide: /^[1234]((-|֊)?(ին|րդ)) քառորդ/i
	};
	var parseQuarterPatterns = {
	  any: [/1/i, /2/i, /3/i, /4/i]
	};
	var matchMonthPatterns = {
	  narrow: /^[հփմաօսնդ]/i,
	  abbreviated: /^(հուն|փետ|մար|ապր|մայ|հուն|հուլ|օգս|սեպ|հոկ|նոյ|դեկ)/i,
	  wide: /^(հունվար|փետրվար|մարտ|ապրիլ|մայիս|հունիս|հուլիս|օգոստոս|սեպտեմբեր|հոկտեմբեր|նոյեմբեր|դեկտեմբեր)/i
	};
	var parseMonthPatterns = {
	  narrow: [/^հ/i, /^փ/i, /^մ/i, /^ա/i, /^մ/i, /^հ/i, /^հ/i, /^օ/i, /^ս/i, /^հ/i, /^ն/i, /^դ/i],
	  any: [/^հու/i, /^փ/i, /^մար/i, /^ա/i, /^մայ/i, /^հուն/i, /^հուլ/i, /^օ/i, /^ս/i, /^հոկ/i, /^ն/i, /^դ/i]
	};
	var matchDayPatterns = {
	  narrow: /^[եչհոշկ]/i,
	  short: /^(կր|եր|եք|չք|հգ|ուր|շբ)/i,
	  abbreviated: /^(կիր|երկ|երք|չոր|հնգ|ուրբ|շաբ)/i,
	  wide: /^(կիրակի|երկուշաբթի|երեքշաբթի|չորեքշաբթի|հինգշաբթի|ուրբաթ|շաբաթ)/i
	};
	var parseDayPatterns = {
	  narrow: [/^կ/i, /^ե/i, /^ե/i, /^չ/i, /^հ/i, /^(ո|Ո)/, /^շ/i],
	  short: [/^կ/i, /^եր/i, /^եք/i, /^չ/i, /^հ/i, /^(ո|Ո)/, /^շ/i],
	  abbreviated: [/^կ/i, /^երկ/i, /^երք/i, /^չ/i, /^հ/i, /^(ո|Ո)/, /^շ/i],
	  wide: [/^կ/i, /^երկ/i, /^երե/i, /^չ/i, /^հ/i, /^(ո|Ո)/, /^շ/i]
	};
	var matchDayPeriodPatterns = {
	  narrow: /^([ap]|կեսգշ|կեսօր|(առավոտը?|ցերեկը?|երեկո(յան)?|գիշերը?))/i,
	  any: /^([ap]\.?\s?m\.?|կեսգիշեր(ին)?|կեսօր(ին)?|(առավոտը?|ցերեկը?|երեկո(յան)?|գիշերը?))/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^a/i,
	    pm: /^p/i,
	    midnight: /կեսգիշեր/i,
	    noon: /կեսօր/i,
	    morning: /առավոտ/i,
	    afternoon: /ցերեկ/i,
	    evening: /երեկո/i,
	    night: /գիշեր/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index2.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index2.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index2.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index2.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index2.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1250 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1245));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1246));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1247));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1248));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1249));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Armenian locale
	 * @language Armenian
	 * @iso-639-2 arm
	 * @author Alex Igityan [@alexigityan]{@link https://github.com/alexigityan}
	 */
	var locale = {
	  code: 'hy',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 1
	    /* Monday */
	    ,
	    firstWeekContainsDate: 1
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1251 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    one: 'kurang dari 1 detik',
	    other: 'kurang dari {{count}} detik'
	  },
	  xSeconds: {
	    one: '1 detik',
	    other: '{{count}} detik'
	  },
	  halfAMinute: 'setengah menit',
	  lessThanXMinutes: {
	    one: 'kurang dari 1 menit',
	    other: 'kurang dari {{count}} menit'
	  },
	  xMinutes: {
	    one: '1 menit',
	    other: '{{count}} menit'
	  },
	  aboutXHours: {
	    one: 'sekitar 1 jam',
	    other: 'sekitar {{count}} jam'
	  },
	  xHours: {
	    one: '1 jam',
	    other: '{{count}} jam'
	  },
	  xDays: {
	    one: '1 hari',
	    other: '{{count}} hari'
	  },
	  aboutXWeeks: {
	    one: 'sekitar 1 minggu',
	    other: 'sekitar {{count}} minggu'
	  },
	  xWeeks: {
	    one: '1 minggu',
	    other: '{{count}} minggu'
	  },
	  aboutXMonths: {
	    one: 'sekitar 1 bulan',
	    other: 'sekitar {{count}} bulan'
	  },
	  xMonths: {
	    one: '1 bulan',
	    other: '{{count}} bulan'
	  },
	  aboutXYears: {
	    one: 'sekitar 1 tahun',
	    other: 'sekitar {{count}} tahun'
	  },
	  xYears: {
	    one: '1 tahun',
	    other: '{{count}} tahun'
	  },
	  overXYears: {
	    one: 'lebih dari 1 tahun',
	    other: 'lebih dari {{count}} tahun'
	  },
	  almostXYears: {
	    one: 'hampir 1 tahun',
	    other: 'hampir {{count}} tahun'
	  }
	};
	
	var formatDistance = function (token, count, options) {
	  var result;
	  var tokenValue = formatDistanceLocale[token];
	
	  if (typeof tokenValue === 'string') {
	    result = tokenValue;
	  } else if (count === 1) {
	    result = tokenValue.one;
	  } else {
	    result = tokenValue.other.replace('{{count}}', count.toString());
	  }
	
	  if (options !== null && options !== void 0 && options.addSuffix) {
	    if (options.comparison && options.comparison > 0) {
	      return 'dalam waktu ' + result;
	    } else {
	      return result + ' yang lalu';
	    }
	  }
	
	  return result;
	};
	
	var _default = formatDistance;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1252 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: 'EEEE, d MMMM yyyy',
	  long: 'd MMMM yyyy',
	  medium: 'd MMM yyyy',
	  short: 'd/M/yyyy'
	};
	var timeFormats = {
	  full: 'HH.mm.ss',
	  long: 'HH.mm.ss',
	  medium: 'HH.mm',
	  short: 'HH.mm'
	};
	var dateTimeFormats = {
	  full: "{{date}} 'pukul' {{time}}",
	  long: "{{date}} 'pukul' {{time}}",
	  medium: '{{date}}, {{time}}',
	  short: '{{date}}, {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1253 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var formatRelativeLocale = {
	  lastWeek: "eeee 'lalu pukul' p",
	  yesterday: "'Kemarin pukul' p",
	  today: "'Hari ini pukul' p",
	  tomorrow: "'Besok pukul' p",
	  nextWeek: "eeee 'pukul' p",
	  other: 'P'
	};
	
	var formatRelative = function (token, _date, _baseDate, _options) {
	  return formatRelativeLocale[token];
	};
	
	var _default = formatRelative;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1254 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// All data for localization are taken from this page
	// https://www.unicode.org/cldr/charts/32/summary/id.html
	var eraValues = {
	  narrow: ['SM', 'M'],
	  abbreviated: ['SM', 'M'],
	  wide: ['Sebelum Masehi', 'Masehi']
	};
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['K1', 'K2', 'K3', 'K4'],
	  wide: ['Kuartal ke-1', 'Kuartal ke-2', 'Kuartal ke-3', 'Kuartal ke-4']
	}; // Note: in Indonesian, the names of days of the week and months are capitalized.
	// If you are making a new locale based on this one, check if the same is true for the language you're working on.
	// Generally, formatted dates should look like they are in the middle of a sentence,
	// e.g. in Spanish language the weekdays and months should be in the lowercase.
	
	var monthValues = {
	  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
	  abbreviated: ['Jan', 'Feb', 'Mar', 'Apr', 'Mei', 'Jun', 'Jul', 'Agt', 'Sep', 'Okt', 'Nov', 'Des'],
	  wide: ['Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni', 'Juli', 'Agustus', 'September', 'Oktober', 'November', 'Desember']
	};
	var dayValues = {
	  narrow: ['M', 'S', 'S', 'R', 'K', 'J', 'S'],
	  short: ['Min', 'Sen', 'Sel', 'Rab', 'Kam', 'Jum', 'Sab'],
	  abbreviated: ['Min', 'Sen', 'Sel', 'Rab', 'Kam', 'Jum', 'Sab'],
	  wide: ['Minggu', 'Senin', 'Selasa', 'Rabu', 'Kamis', 'Jumat', 'Sabtu']
	};
	var dayPeriodValues = {
	  narrow: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'tengah malam',
	    noon: 'tengah hari',
	    morning: 'pagi',
	    afternoon: 'siang',
	    evening: 'sore',
	    night: 'malam'
	  },
	  abbreviated: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'tengah malam',
	    noon: 'tengah hari',
	    morning: 'pagi',
	    afternoon: 'siang',
	    evening: 'sore',
	    night: 'malam'
	  },
	  wide: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'tengah malam',
	    noon: 'tengah hari',
	    morning: 'pagi',
	    afternoon: 'siang',
	    evening: 'sore',
	    night: 'malam'
	  }
	};
	var formattingDayPeriodValues = {
	  narrow: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'tengah malam',
	    noon: 'tengah hari',
	    morning: 'pagi',
	    afternoon: 'siang',
	    evening: 'sore',
	    night: 'malam'
	  },
	  abbreviated: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'tengah malam',
	    noon: 'tengah hari',
	    morning: 'pagi',
	    afternoon: 'siang',
	    evening: 'sore',
	    night: 'malam'
	  },
	  wide: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'tengah malam',
	    noon: 'tengah hari',
	    morning: 'pagi',
	    afternoon: 'siang',
	    evening: 'sore',
	    night: 'malam'
	  }
	};
	
	var ordinalNumber = function (dirtyNumber, _options) {
	  var number = Number(dirtyNumber); // Can't use "pertama", "kedua" because can't be parsed
	
	  return 'ke-' + number;
	};
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return quarter - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingDayPeriodValues,
	    defaultFormattingWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1255 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(14));
	
	var _index2 = _interopRequireDefault(__webpack_require__(15));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^ke-(\d+)?/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^(sm|m)/i,
	  abbreviated: /^(s\.?\s?m\.?|s\.?\s?e\.?\s?u\.?|m\.?|e\.?\s?u\.?)/i,
	  wide: /^(sebelum masehi|sebelum era umum|masehi|era umum)/i
	};
	var parseEraPatterns = {
	  any: [/^s/i, /^(m|e)/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^K-?\s[1234]/i,
	  wide: /^Kuartal ke-?\s?[1234]/i
	};
	var parseQuarterPatterns = {
	  any: [/1/i, /2/i, /3/i, /4/i]
	};
	var matchMonthPatterns = {
	  narrow: /^[jfmasond]/i,
	  abbreviated: /^(jan|feb|mar|apr|mei|jun|jul|agt|sep|okt|nov|des)/i,
	  wide: /^(januari|februari|maret|april|mei|juni|juli|agustus|september|oktober|november|desember)/i
	};
	var parseMonthPatterns = {
	  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
	  any: [/^ja/i, /^f/i, /^ma/i, /^ap/i, /^me/i, /^jun/i, /^jul/i, /^ag/i, /^s/i, /^o/i, /^n/i, /^d/i]
	};
	var matchDayPatterns = {
	  narrow: /^[srkjm]/i,
	  short: /^(min|sen|sel|rab|kam|jum|sab)/i,
	  abbreviated: /^(min|sen|sel|rab|kam|jum|sab)/i,
	  wide: /^(minggu|senin|selasa|rabu|kamis|jumat|sabtu)/i
	};
	var parseDayPatterns = {
	  narrow: [/^m/i, /^s/i, /^s/i, /^r/i, /^k/i, /^j/i, /^s/i],
	  any: [/^m/i, /^sen/i, /^sel/i, /^r/i, /^k/i, /^j/i, /^sa/i]
	};
	var matchDayPeriodPatterns = {
	  narrow: /^(a|p|tengah m|tengah h|(di(\swaktu)?) (pagi|siang|sore|malam))/i,
	  any: /^([ap]\.?\s?m\.?|tengah malam|tengah hari|(di(\swaktu)?) (pagi|siang|sore|malam))/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^a/i,
	    pm: /^pm/i,
	    midnight: /^tengah m/i,
	    noon: /^tengah h/i,
	    morning: /pagi/i,
	    afternoon: /siang/i,
	    evening: /sore/i,
	    night: /malam/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index2.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1256 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1251));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1252));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1253));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1254));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1255));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Indonesian locale.
	 * @language Indonesian
	 * @iso-639-2 ind
	 * @author Rahmat Budiharso [@rbudiharso]{@link https://github.com/rbudiharso}
	 * @author Benget Nata [@bentinata]{@link https://github.com/bentinata}
	 * @author Budi Irawan [@deerawan]{@link https://github.com/deerawan}
	 * @author Try Ajitiono [@imballinst]{@link https://github.com/imballinst}
	 */
	var locale = {
	  code: 'id',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 1
	    /* Monday */
	    ,
	    firstWeekContainsDate: 1
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1257 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    one: 'minna en 1 sekúnda',
	    other: 'minna en {{count}} sekúndur'
	  },
	  xSeconds: {
	    one: '1 sekúnda',
	    other: '{{count}} sekúndur'
	  },
	  halfAMinute: 'hálf mínúta',
	  lessThanXMinutes: {
	    one: 'minna en 1 mínúta',
	    other: 'minna en {{count}} mínútur'
	  },
	  xMinutes: {
	    one: '1 mínúta',
	    other: '{{count}} mínútur'
	  },
	  aboutXHours: {
	    one: 'u.þ.b. 1 klukkustund',
	    other: 'u.þ.b. {{count}} klukkustundir'
	  },
	  xHours: {
	    one: '1 klukkustund',
	    other: '{{count}} klukkustundir'
	  },
	  xDays: {
	    one: '1 dagur',
	    other: '{{count}} dagar'
	  },
	  aboutXWeeks: {
	    one: 'um viku',
	    other: 'um {{count}} vikur'
	  },
	  xWeeks: {
	    one: '1 viku',
	    other: '{{count}} vikur'
	  },
	  aboutXMonths: {
	    one: 'u.þ.b. 1 mánuður',
	    other: 'u.þ.b. {{count}} mánuðir'
	  },
	  xMonths: {
	    one: '1 mánuður',
	    other: '{{count}} mánuðir'
	  },
	  aboutXYears: {
	    one: 'u.þ.b. 1 ár',
	    other: 'u.þ.b. {{count}} ár'
	  },
	  xYears: {
	    one: '1 ár',
	    other: '{{count}} ár'
	  },
	  overXYears: {
	    one: 'meira en 1 ár',
	    other: 'meira en {{count}} ár'
	  },
	  almostXYears: {
	    one: 'næstum 1 ár',
	    other: 'næstum {{count}} ár'
	  }
	};
	
	var formatDistance = function (token, count, options) {
	  var result;
	  var tokenValue = formatDistanceLocale[token];
	
	  if (typeof tokenValue === 'string') {
	    result = tokenValue;
	  } else if (count === 1) {
	    result = tokenValue.one;
	  } else {
	    result = tokenValue.other.replace('{{count}}', count.toString());
	  }
	
	  if (options !== null && options !== void 0 && options.addSuffix) {
	    if (options.comparison && options.comparison > 0) {
	      return 'í ' + result;
	    } else {
	      return result + ' síðan';
	    }
	  }
	
	  return result;
	};
	
	var _default = formatDistance;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1258 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: 'EEEE, do MMMM y',
	  long: 'do MMMM y',
	  medium: 'do MMM y',
	  short: 'd.MM.y'
	};
	var timeFormats = {
	  full: "'kl'. HH:mm:ss zzzz",
	  long: 'HH:mm:ss z',
	  medium: 'HH:mm:ss',
	  short: 'HH:mm'
	};
	var dateTimeFormats = {
	  full: "{{date}} 'kl.' {{time}}",
	  long: "{{date}} 'kl.' {{time}}",
	  medium: '{{date}} {{time}}',
	  short: '{{date}} {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1259 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var formatRelativeLocale = {
	  lastWeek: "'síðasta' dddd 'kl.' p",
	  yesterday: "'í gær kl.' p",
	  today: "'í dag kl.' p",
	  tomorrow: "'á morgun kl.' p",
	  nextWeek: "dddd 'kl.' p",
	  other: 'P'
	};
	
	var formatRelative = function (token, _date, _baseDate, _options) {
	  return formatRelativeLocale[token];
	};
	
	var _default = formatRelative;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1260 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eraValues = {
	  narrow: ['f.Kr.', 'e.Kr.'],
	  abbreviated: ['f.Kr.', 'e.Kr.'],
	  wide: ['fyrir Krist', 'eftir Krist']
	};
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['1F', '2F', '3F', '4F'],
	  wide: ['1. fjórðungur', '2. fjórðungur', '3. fjórðungur', '4. fjórðungur']
	};
	var monthValues = {
	  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'Á', 'S', 'Ó', 'N', 'D'],
	  abbreviated: ['jan.', 'feb.', 'mars', 'apríl', 'maí', 'júní', 'júlí', 'ágúst', 'sept.', 'okt.', 'nóv.', 'des.'],
	  wide: ['janúar', 'febrúar', 'mars', 'apríl', 'maí', 'júní', 'júlí', 'ágúst', 'september', 'október', 'nóvember', 'desember']
	};
	var dayValues = {
	  narrow: ['S', 'M', 'Þ', 'M', 'F', 'F', 'L'],
	  short: ['Su', 'Má', 'Þr', 'Mi', 'Fi', 'Fö', 'La'],
	  abbreviated: ['sun.', 'mán.', 'þri.', 'mið.', 'fim.', 'fös.', 'lau'],
	  wide: ['sunnudagur', 'mánudagur', 'þriðjudagur', 'miðvikudagur', 'fimmtudagur', 'föstudagur', 'laugardagur']
	};
	var dayPeriodValues = {
	  narrow: {
	    am: 'f',
	    pm: 'e',
	    midnight: 'miðnætti',
	    noon: 'hádegi',
	    morning: 'morgunn',
	    afternoon: 'síðdegi',
	    evening: 'kvöld',
	    night: 'nótt'
	  },
	  abbreviated: {
	    am: 'f.h.',
	    pm: 'e.h.',
	    midnight: 'miðnætti',
	    noon: 'hádegi',
	    morning: 'morgunn',
	    afternoon: 'síðdegi',
	    evening: 'kvöld',
	    night: 'nótt'
	  },
	  wide: {
	    am: 'fyrir hádegi',
	    pm: 'eftir hádegi',
	    midnight: 'miðnætti',
	    noon: 'hádegi',
	    morning: 'morgunn',
	    afternoon: 'síðdegi',
	    evening: 'kvöld',
	    night: 'nótt'
	  }
	};
	var formattingDayPeriodValues = {
	  narrow: {
	    am: 'f',
	    pm: 'e',
	    midnight: 'á miðnætti',
	    noon: 'á hádegi',
	    morning: 'að morgni',
	    afternoon: 'síðdegis',
	    evening: 'um kvöld',
	    night: 'um nótt'
	  },
	  abbreviated: {
	    am: 'f.h.',
	    pm: 'e.h.',
	    midnight: 'á miðnætti',
	    noon: 'á hádegi',
	    morning: 'að morgni',
	    afternoon: 'síðdegis',
	    evening: 'um kvöld',
	    night: 'um nótt'
	  },
	  wide: {
	    am: 'fyrir hádegi',
	    pm: 'eftir hádegi',
	    midnight: 'á miðnætti',
	    noon: 'á hádegi',
	    morning: 'að morgni',
	    afternoon: 'síðdegis',
	    evening: 'um kvöld',
	    night: 'um nótt'
	  }
	};
	
	var ordinalNumber = function (dirtyNumber, _options) {
	  var number = Number(dirtyNumber);
	  return number + '.';
	};
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return quarter - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingDayPeriodValues,
	    defaultFormattingWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1261 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(14));
	
	var _index2 = _interopRequireDefault(__webpack_require__(15));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(\d+)(\.)?/i;
	var parseOrdinalNumberPattern = /\d+(\.)?/i;
	var matchEraPatterns = {
	  narrow: /^(f\.Kr\.|e\.Kr\.)/i,
	  abbreviated: /^(f\.Kr\.|e\.Kr\.)/i,
	  wide: /^(fyrir Krist|eftir Krist)/i
	};
	var parseEraPatterns = {
	  any: [/^(f\.Kr\.)/i, /^(e\.Kr\.)/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]\.?/i,
	  abbreviated: /^q[1234]\.?/i,
	  wide: /^[1234]\.? fjórðungur/i
	};
	var parseQuarterPatterns = {
	  any: [/1\.?/i, /2\.?/i, /3\.?/i, /4\.?/i]
	};
	var matchMonthPatterns = {
	  narrow: /^[jfmásónd]/i,
	  abbreviated: /^(jan\.|feb\.|mars\.|apríl\.|maí|júní|júlí|águst|sep\.|oct\.|nov\.|dec\.)/i,
	  wide: /^(januar|febrúar|mars|apríl|maí|júní|júlí|águst|september|október|nóvember|desember)/i
	};
	var parseMonthPatterns = {
	  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^á/i, /^s/i, /^ó/i, /^n/i, /^d/i],
	  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^maí/i, /^jún/i, /^júl/i, /^áu/i, /^s/i, /^ó/i, /^n/i, /^d/i]
	};
	var matchDayPatterns = {
	  narrow: /^[smtwf]/i,
	  short: /^(su|má|þr|mi|fi|fö|la)/i,
	  abbreviated: /^(sun|mán|þri|mið|fim|fös|lau)\.?/i,
	  wide: /^(sunnudagur|mánudagur|þriðjudagur|miðvikudagur|fimmtudagur|föstudagur|laugardagur)/i
	};
	var parseDayPatterns = {
	  narrow: [/^s/i, /^m/i, /^þ/i, /^m/i, /^f/i, /^f/i, /^l/i],
	  any: [/^su/i, /^má/i, /^þr/i, /^mi/i, /^fi/i, /^fö/i, /^la/i]
	};
	var matchDayPeriodPatterns = {
	  narrow: /^(f|e|síðdegis|(á|að|um) (morgni|kvöld|nótt|miðnætti))/i,
	  any: /^(fyrir hádegi|eftir hádegi|[ef]\.?h\.?|síðdegis|morgunn|(á|að|um) (morgni|kvöld|nótt|miðnætti))/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^f/i,
	    pm: /^e/i,
	    midnight: /^mi/i,
	    noon: /^há/i,
	    morning: /morgunn/i,
	    afternoon: /síðdegi/i,
	    evening: /kvöld/i,
	    night: /nótt/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index2.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1262 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1257));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1258));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1259));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1260));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1261));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Icelandic locale.
	 * @language Icelandic
	 * @iso-639-2 isl
	 * @author Derek Blank [@derekblank]{@link https://github.com/derekblank}
	 * @author Arnór Ýmir [@lamayg]{@link https://github.com/lamayg}
	 */
	var locale = {
	  code: 'is',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 1
	    /* Monday */
	    ,
	    firstWeekContainsDate: 4
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1263 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    one: 'meno di un secondo',
	    other: 'meno di {{count}} secondi'
	  },
	  xSeconds: {
	    one: 'un secondo',
	    other: '{{count}} secondi'
	  },
	  halfAMinute: 'alcuni secondi',
	  lessThanXMinutes: {
	    one: 'meno di un minuto',
	    other: 'meno di {{count}} minuti'
	  },
	  xMinutes: {
	    one: 'un minuto',
	    other: '{{count}} minuti'
	  },
	  aboutXHours: {
	    one: "circa un'ora",
	    other: 'circa {{count}} ore'
	  },
	  xHours: {
	    one: "un'ora",
	    other: '{{count}} ore'
	  },
	  xDays: {
	    one: 'un giorno',
	    other: '{{count}} giorni'
	  },
	  aboutXWeeks: {
	    one: 'circa una settimana',
	    other: 'circa {{count}} settimane'
	  },
	  xWeeks: {
	    one: 'una settimana',
	    other: '{{count}} settimane'
	  },
	  aboutXMonths: {
	    one: 'circa un mese',
	    other: 'circa {{count}} mesi'
	  },
	  xMonths: {
	    one: 'un mese',
	    other: '{{count}} mesi'
	  },
	  aboutXYears: {
	    one: 'circa un anno',
	    other: 'circa {{count}} anni'
	  },
	  xYears: {
	    one: 'un anno',
	    other: '{{count}} anni'
	  },
	  overXYears: {
	    one: 'più di un anno',
	    other: 'più di {{count}} anni'
	  },
	  almostXYears: {
	    one: 'quasi un anno',
	    other: 'quasi {{count}} anni'
	  }
	};
	
	var formatDistance = function (token, count, options) {
	  var result;
	  var tokenValue = formatDistanceLocale[token];
	
	  if (typeof tokenValue === 'string') {
	    result = tokenValue;
	  } else if (count === 1) {
	    result = tokenValue.one;
	  } else {
	    result = tokenValue.other.replace('{{count}}', count.toString());
	  }
	
	  if (options !== null && options !== void 0 && options.addSuffix) {
	    if (options.comparison && options.comparison > 0) {
	      return 'tra ' + result;
	    } else {
	      return result + ' fa';
	    }
	  }
	
	  return result;
	};
	
	var _default = formatDistance;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1264 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: 'EEEE d MMMM y',
	  long: 'd MMMM y',
	  medium: 'd MMM y',
	  short: 'dd/MM/y'
	};
	var timeFormats = {
	  full: 'HH:mm:ss zzzz',
	  long: 'HH:mm:ss z',
	  medium: 'HH:mm:ss',
	  short: 'HH:mm'
	};
	var dateTimeFormats = {
	  full: '{{date}} {{time}}',
	  long: '{{date}} {{time}}',
	  medium: '{{date}} {{time}}',
	  short: '{{date}} {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1265 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(71));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var weekdays = ['domenica', 'lunedì', 'martedì', 'mercoledì', 'giovedì', 'venerdì', 'sabato'];
	
	function lastWeek(day) {
	  switch (day) {
	    case 0:
	      return "'domenica scorsa alle' p";
	
	    default:
	      return "'" + weekdays[day] + " scorso alle' p";
	  }
	}
	
	function thisWeek(day) {
	  return "'" + weekdays[day] + " alle' p";
	}
	
	function nextWeek(day) {
	  switch (day) {
	    case 0:
	      return "'domenica prossima alle' p";
	
	    default:
	      return "'" + weekdays[day] + " prossimo alle' p";
	  }
	}
	
	var formatRelativeLocale = {
	  lastWeek: function (date, baseDate, options) {
	    var day = date.getUTCDay();
	
	    if ((0, _index.default)(date, baseDate, options)) {
	      return thisWeek(day);
	    } else {
	      return lastWeek(day);
	    }
	  },
	  yesterday: "'ieri alle' p",
	  today: "'oggi alle' p",
	  tomorrow: "'domani alle' p",
	  nextWeek: function (date, baseDate, options) {
	    var day = date.getUTCDay();
	
	    if ((0, _index.default)(date, baseDate, options)) {
	      return thisWeek(day);
	    } else {
	      return nextWeek(day);
	    }
	  },
	  other: 'P'
	};
	
	var formatRelative = function (token, date, baseDate, options) {
	  var format = formatRelativeLocale[token];
	
	  if (typeof format === 'function') {
	    return format(date, baseDate, options);
	  }
	
	  return format;
	};
	
	var _default = formatRelative;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1266 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eraValues = {
	  narrow: ['aC', 'dC'],
	  abbreviated: ['a.C.', 'd.C.'],
	  wide: ['avanti Cristo', 'dopo Cristo']
	};
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['T1', 'T2', 'T3', 'T4'],
	  wide: ['1º trimestre', '2º trimestre', '3º trimestre', '4º trimestre']
	};
	var monthValues = {
	  narrow: ['G', 'F', 'M', 'A', 'M', 'G', 'L', 'A', 'S', 'O', 'N', 'D'],
	  abbreviated: ['gen', 'feb', 'mar', 'apr', 'mag', 'giu', 'lug', 'ago', 'set', 'ott', 'nov', 'dic'],
	  wide: ['gennaio', 'febbraio', 'marzo', 'aprile', 'maggio', 'giugno', 'luglio', 'agosto', 'settembre', 'ottobre', 'novembre', 'dicembre']
	};
	var dayValues = {
	  narrow: ['D', 'L', 'M', 'M', 'G', 'V', 'S'],
	  short: ['dom', 'lun', 'mar', 'mer', 'gio', 'ven', 'sab'],
	  abbreviated: ['dom', 'lun', 'mar', 'mer', 'gio', 'ven', 'sab'],
	  wide: ['domenica', 'lunedì', 'martedì', 'mercoledì', 'giovedì', 'venerdì', 'sabato']
	};
	var dayPeriodValues = {
	  narrow: {
	    am: 'm.',
	    pm: 'p.',
	    midnight: 'mezzanotte',
	    noon: 'mezzogiorno',
	    morning: 'mattina',
	    afternoon: 'pomeriggio',
	    evening: 'sera',
	    night: 'notte'
	  },
	  abbreviated: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'mezzanotte',
	    noon: 'mezzogiorno',
	    morning: 'mattina',
	    afternoon: 'pomeriggio',
	    evening: 'sera',
	    night: 'notte'
	  },
	  wide: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'mezzanotte',
	    noon: 'mezzogiorno',
	    morning: 'mattina',
	    afternoon: 'pomeriggio',
	    evening: 'sera',
	    night: 'notte'
	  }
	};
	var formattingDayPeriodValues = {
	  narrow: {
	    am: 'm.',
	    pm: 'p.',
	    midnight: 'mezzanotte',
	    noon: 'mezzogiorno',
	    morning: 'di mattina',
	    afternoon: 'del pomeriggio',
	    evening: 'di sera',
	    night: 'di notte'
	  },
	  abbreviated: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'mezzanotte',
	    noon: 'mezzogiorno',
	    morning: 'di mattina',
	    afternoon: 'del pomeriggio',
	    evening: 'di sera',
	    night: 'di notte'
	  },
	  wide: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'mezzanotte',
	    noon: 'mezzogiorno',
	    morning: 'di mattina',
	    afternoon: 'del pomeriggio',
	    evening: 'di sera',
	    night: 'di notte'
	  }
	};
	
	var ordinalNumber = function (dirtyNumber, _options) {
	  var number = Number(dirtyNumber);
	  return number + 'º';
	};
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return quarter - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingDayPeriodValues,
	    defaultFormattingWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1267 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(14));
	
	var _index2 = _interopRequireDefault(__webpack_require__(15));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(\d+)(º)?/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^(aC|dC)/i,
	  abbreviated: /^(a\.?\s?C\.?|a\.?\s?e\.?\s?v\.?|d\.?\s?C\.?|e\.?\s?v\.?)/i,
	  wide: /^(avanti Cristo|avanti Era Volgare|dopo Cristo|Era Volgare)/i
	};
	var parseEraPatterns = {
	  any: [/^a/i, /^(d|e)/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^t[1234]/i,
	  wide: /^[1234](º)? trimestre/i
	};
	var parseQuarterPatterns = {
	  any: [/1/i, /2/i, /3/i, /4/i]
	};
	var matchMonthPatterns = {
	  narrow: /^[gfmalsond]/i,
	  abbreviated: /^(gen|feb|mar|apr|mag|giu|lug|ago|set|ott|nov|dic)/i,
	  wide: /^(gennaio|febbraio|marzo|aprile|maggio|giugno|luglio|agosto|settembre|ottobre|novembre|dicembre)/i
	};
	var parseMonthPatterns = {
	  narrow: [/^g/i, /^f/i, /^m/i, /^a/i, /^m/i, /^g/i, /^l/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
	  any: [/^ge/i, /^f/i, /^mar/i, /^ap/i, /^mag/i, /^gi/i, /^l/i, /^ag/i, /^s/i, /^o/i, /^n/i, /^d/i]
	};
	var matchDayPatterns = {
	  narrow: /^[dlmgvs]/i,
	  short: /^(do|lu|ma|me|gi|ve|sa)/i,
	  abbreviated: /^(dom|lun|mar|mer|gio|ven|sab)/i,
	  wide: /^(domenica|luned[i|ì]|marted[i|ì]|mercoled[i|ì]|gioved[i|ì]|venerd[i|ì]|sabato)/i
	};
	var parseDayPatterns = {
	  narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^g/i, /^v/i, /^s/i],
	  any: [/^d/i, /^l/i, /^ma/i, /^me/i, /^g/i, /^v/i, /^s/i]
	};
	var matchDayPeriodPatterns = {
	  narrow: /^(a|m\.|p|mezzanotte|mezzogiorno|(di|del) (mattina|pomeriggio|sera|notte))/i,
	  any: /^([ap]\.?\s?m\.?|mezzanotte|mezzogiorno|(di|del) (mattina|pomeriggio|sera|notte))/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^a/i,
	    pm: /^p/i,
	    midnight: /^mezza/i,
	    noon: /^mezzo/i,
	    morning: /mattina/i,
	    afternoon: /pomeriggio/i,
	    evening: /sera/i,
	    night: /notte/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index2.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1268 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1263));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1264));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1265));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1266));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1267));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Italian locale.
	 * @language Italian
	 * @iso-639-2 ita
	 * @author Alberto Restifo [@albertorestifo]{@link https://github.com/albertorestifo}
	 * @author Giovanni Polimeni [@giofilo]{@link https://github.com/giofilo}
	 * @author Vincenzo Carrese [@vin-car]{@link https://github.com/vin-car}
	 */
	var locale = {
	  code: 'it',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 1
	    /* Monday */
	    ,
	    firstWeekContainsDate: 4
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1269 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    one: '1びょうみまん',
	    other: '{{count}}びょうみまん',
	    oneWithSuffix: 'やく1びょう',
	    otherWithSuffix: 'やく{{count}}びょう'
	  },
	  xSeconds: {
	    one: '1びょう',
	    other: '{{count}}びょう'
	  },
	  halfAMinute: '30びょう',
	  lessThanXMinutes: {
	    one: '1ぷんみまん',
	    other: '{{count}}ふんみまん',
	    oneWithSuffix: 'やく1ぷん',
	    otherWithSuffix: 'やく{{count}}ふん'
	  },
	  xMinutes: {
	    one: '1ぷん',
	    other: '{{count}}ふん'
	  },
	  aboutXHours: {
	    one: 'やく1じかん',
	    other: 'やく{{count}}じかん'
	  },
	  xHours: {
	    one: '1じかん',
	    other: '{{count}}じかん'
	  },
	  xDays: {
	    one: '1にち',
	    other: '{{count}}にち'
	  },
	  aboutXWeeks: {
	    one: 'やく1しゅうかん',
	    other: 'やく{{count}}しゅうかん'
	  },
	  xWeeks: {
	    one: '1しゅうかん',
	    other: '{{count}}しゅうかん'
	  },
	  aboutXMonths: {
	    one: 'やく1かげつ',
	    other: 'やく{{count}}かげつ'
	  },
	  xMonths: {
	    one: '1かげつ',
	    other: '{{count}}かげつ'
	  },
	  aboutXYears: {
	    one: 'やく1ねん',
	    other: 'やく{{count}}ねん'
	  },
	  xYears: {
	    one: '1ねん',
	    other: '{{count}}ねん'
	  },
	  overXYears: {
	    one: '1ねんいじょう',
	    other: '{{count}}ねんいじょう'
	  },
	  almostXYears: {
	    one: '1ねんちかく',
	    other: '{{count}}ねんちかく'
	  }
	};
	
	var formatDistance = function (token, count, options) {
	  options = options || {};
	  var result;
	  var tokenValue = formatDistanceLocale[token];
	
	  if (typeof tokenValue === 'string') {
	    result = tokenValue;
	  } else if (count === 1) {
	    if (options.addSuffix && tokenValue.oneWithSuffix) {
	      result = tokenValue.oneWithSuffix;
	    } else {
	      result = tokenValue.one;
	    }
	  } else {
	    if (options.addSuffix && tokenValue.otherWithSuffix) {
	      result = tokenValue.otherWithSuffix.replace('{{count}}', String(count));
	    } else {
	      result = tokenValue.other.replace('{{count}}', String(count));
	    }
	  }
	
	  if (options.addSuffix) {
	    if (options.comparison && options.comparison > 0) {
	      return result + 'あと';
	    } else {
	      return result + 'まえ';
	    }
	  }
	
	  return result;
	};
	
	var _default = formatDistance;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1270 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: 'yねんMがつdにちEEEE',
	  long: 'yねんMがつdにち',
	  medium: 'y/MM/dd',
	  short: 'y/MM/dd'
	};
	var timeFormats = {
	  full: 'Hじmmふんssびょう zzzz',
	  long: 'H:mm:ss z',
	  medium: 'H:mm:ss',
	  short: 'H:mm'
	};
	var dateTimeFormats = {
	  full: '{{date}} {{time}}',
	  long: '{{date}} {{time}}',
	  medium: '{{date}} {{time}}',
	  short: '{{date}} {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1271 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var formatRelativeLocale = {
	  lastWeek: 'せんしゅうのeeeeのp',
	  yesterday: 'きのうのp',
	  today: 'きょうのp',
	  tomorrow: 'あしたのp',
	  nextWeek: 'よくしゅうのeeeeのp',
	  other: 'P'
	};
	
	var formatRelative = function (token, _date, _baseDate, _options) {
	  return formatRelativeLocale[token];
	};
	
	var _default = formatRelative;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1272 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eraValues = {
	  narrow: ['BC', 'AC'],
	  abbreviated: ['きげんぜん', 'せいれき'],
	  wide: ['きげんぜん', 'せいれき']
	};
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
	  wide: ['だい1しはんき', 'だい2しはんき', 'だい3しはんき', 'だい4しはんき']
	};
	var monthValues = {
	  narrow: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
	  abbreviated: ['1がつ', '2がつ', '3がつ', '4がつ', '5がつ', '6がつ', '7がつ', '8がつ', '9がつ', '10がつ', '11がつ', '12がつ'],
	  wide: ['1がつ', '2がつ', '3がつ', '4がつ', '5がつ', '6がつ', '7がつ', '8がつ', '9がつ', '10がつ', '11がつ', '12がつ']
	};
	var dayValues = {
	  narrow: ['にち', 'げつ', 'か', 'すい', 'もく', 'きん', 'ど'],
	  short: ['にち', 'げつ', 'か', 'すい', 'もく', 'きん', 'ど'],
	  abbreviated: ['にち', 'げつ', 'か', 'すい', 'もく', 'きん', 'ど'],
	  wide: ['にちようび', 'げつようび', 'かようび', 'すいようび', 'もくようび', 'きんようび', 'どようび']
	};
	var dayPeriodValues = {
	  narrow: {
	    am: 'ごぜん',
	    pm: 'ごご',
	    midnight: 'しんや',
	    noon: 'しょうご',
	    morning: 'あさ',
	    afternoon: 'ごご',
	    evening: 'よる',
	    night: 'しんや'
	  },
	  abbreviated: {
	    am: 'ごぜん',
	    pm: 'ごご',
	    midnight: 'しんや',
	    noon: 'しょうご',
	    morning: 'あさ',
	    afternoon: 'ごご',
	    evening: 'よる',
	    night: 'しんや'
	  },
	  wide: {
	    am: 'ごぜん',
	    pm: 'ごご',
	    midnight: 'しんや',
	    noon: 'しょうご',
	    morning: 'あさ',
	    afternoon: 'ごご',
	    evening: 'よる',
	    night: 'しんや'
	  }
	};
	var formattingDayPeriodValues = {
	  narrow: {
	    am: 'ごぜん',
	    pm: 'ごご',
	    midnight: 'しんや',
	    noon: 'しょうご',
	    morning: 'あさ',
	    afternoon: 'ごご',
	    evening: 'よる',
	    night: 'しんや'
	  },
	  abbreviated: {
	    am: 'ごぜん',
	    pm: 'ごご',
	    midnight: 'しんや',
	    noon: 'しょうご',
	    morning: 'あさ',
	    afternoon: 'ごご',
	    evening: 'よる',
	    night: 'しんや'
	  },
	  wide: {
	    am: 'ごぜん',
	    pm: 'ごご',
	    midnight: 'しんや',
	    noon: 'しょうご',
	    morning: 'あさ',
	    afternoon: 'ごご',
	    evening: 'よる',
	    night: 'しんや'
	  }
	};
	
	var ordinalNumber = function (dirtyNumber, dirtyOptions) {
	  var number = Number(dirtyNumber); // If ordinal numbers depend on context, for example,
	  // if they are different for different grammatical genders,
	  // use `options.unit`:
	  //
	  //   const options = dirtyOptions || {}
	  //   const unit = String(options.unit)
	  //
	  // where `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
	  // 'day', 'hour', 'minute', 'second'
	
	  var options = dirtyOptions || {};
	  var unit = String(options.unit);
	
	  switch (unit) {
	    case 'year':
	      return "".concat(number, "\u306D\u3093");
	
	    case 'quarter':
	      return "\u3060\u3044".concat(number, "\u3057\u306F\u3093\u304D");
	
	    case 'month':
	      return "".concat(number, "\u304C\u3064");
	
	    case 'week':
	      return "\u3060\u3044".concat(number, "\u3057\u3085\u3046");
	
	    case 'date':
	      return "".concat(number, "\u306B\u3061");
	
	    case 'hour':
	      return "".concat(number, "\u3058");
	
	    case 'minute':
	      return "".concat(number, "\u3075\u3093");
	
	    case 'second':
	      return "".concat(number, "\u3073\u3087\u3046");
	
	    default:
	      return "".concat(number);
	  }
	};
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingDayPeriodValues,
	    defaultFormattingWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1273 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(14));
	
	var _index2 = _interopRequireDefault(__webpack_require__(15));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^だ?い?\d+(ねん|しはんき|がつ|しゅう|にち|じ|ふん|びょう)?/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^(B\.?C\.?|A\.?D\.?)/i,
	  abbreviated: /^(きげん[前後]|せいれき)/i,
	  wide: /^(きげん[前後]|せいれき)/i
	};
	var parseEraPatterns = {
	  narrow: [/^B/i, /^A/i],
	  any: [/^(きげんぜん)/i, /^(せいれき|きげんご)/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^Q[1234]/i,
	  wide: /^だい[1234一二三四１２３４]しはんき/i
	};
	var parseQuarterPatterns = {
	  any: [/(1|一|１)/i, /(2|二|２)/i, /(3|三|３)/i, /(4|四|４)/i]
	};
	var matchMonthPatterns = {
	  narrow: /^([123456789]|1[012])/,
	  abbreviated: /^([123456789]|1[012])がつ/i,
	  wide: /^([123456789]|1[012])がつ/i
	};
	var parseMonthPatterns = {
	  any: [/^1\D/, /^2/, /^3/, /^4/, /^5/, /^6/, /^7/, /^8/, /^9/, /^10/, /^11/, /^12/]
	};
	var matchDayPatterns = {
	  narrow: /^(にち|げつ|か|すい|もく|きん|ど)/,
	  short: /^(にち|げつ|か|すい|もく|きん|ど)/,
	  abbreviated: /^(にち|げつ|か|すい|もく|きん|ど)/,
	  wide: /^(にち|げつ|か|すい|もく|きん|ど)ようび/
	};
	var parseDayPatterns = {
	  any: [/^にち/, /^げつ/, /^か/, /^すい/, /^もく/, /^きん/, /^ど/]
	};
	var matchDayPeriodPatterns = {
	  any: /^(AM|PM|ごぜん|ごご|しょうご|しんや|まよなか|よる|あさ)/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^(A|ごぜん)/i,
	    pm: /^(P|ごご)/i,
	    midnight: /^しんや|まよなか/i,
	    noon: /^しょうご/i,
	    morning: /^あさ/i,
	    afternoon: /^ごご/i,
	    evening: /^よる/i,
	    night: /^しんや/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index2.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1274 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1269));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1270));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1271));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1272));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1273));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Japanese (Hiragana) locale.
	 * @language Japanese (Hiragana)
	 * @iso-639-2 jpn
	 * @author Eri Hiramatsu [@Eritutteo]{@link https://github.com/Eritutteo}
	 */
	var locale = {
	  code: 'ja-Hira',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 0
	    /* Sunday */
	    ,
	    firstWeekContainsDate: 1
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1275 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    one: '1秒未満',
	    other: '{{count}}秒未満',
	    oneWithSuffix: '約1秒',
	    otherWithSuffix: '約{{count}}秒'
	  },
	  xSeconds: {
	    one: '1秒',
	    other: '{{count}}秒'
	  },
	  halfAMinute: '30秒',
	  lessThanXMinutes: {
	    one: '1分未満',
	    other: '{{count}}分未満',
	    oneWithSuffix: '約1分',
	    otherWithSuffix: '約{{count}}分'
	  },
	  xMinutes: {
	    one: '1分',
	    other: '{{count}}分'
	  },
	  aboutXHours: {
	    one: '約1時間',
	    other: '約{{count}}時間'
	  },
	  xHours: {
	    one: '1時間',
	    other: '{{count}}時間'
	  },
	  xDays: {
	    one: '1日',
	    other: '{{count}}日'
	  },
	  aboutXWeeks: {
	    one: '約1週間',
	    other: '約{{count}}週間'
	  },
	  xWeeks: {
	    one: '1週間',
	    other: '{{count}}週間'
	  },
	  aboutXMonths: {
	    one: '約1か月',
	    other: '約{{count}}か月'
	  },
	  xMonths: {
	    one: '1か月',
	    other: '{{count}}か月'
	  },
	  aboutXYears: {
	    one: '約1年',
	    other: '約{{count}}年'
	  },
	  xYears: {
	    one: '1年',
	    other: '{{count}}年'
	  },
	  overXYears: {
	    one: '1年以上',
	    other: '{{count}}年以上'
	  },
	  almostXYears: {
	    one: '1年近く',
	    other: '{{count}}年近く'
	  }
	};
	
	var formatDistance = function (token, count, options) {
	  options = options || {};
	  var result;
	  var tokenValue = formatDistanceLocale[token];
	
	  if (typeof tokenValue === 'string') {
	    result = tokenValue;
	  } else if (count === 1) {
	    if (options.addSuffix && tokenValue.oneWithSuffix) {
	      result = tokenValue.oneWithSuffix;
	    } else {
	      result = tokenValue.one;
	    }
	  } else {
	    if (options.addSuffix && tokenValue.otherWithSuffix) {
	      result = tokenValue.otherWithSuffix.replace('{{count}}', String(count));
	    } else {
	      result = tokenValue.other.replace('{{count}}', String(count));
	    }
	  }
	
	  if (options.addSuffix) {
	    if (options.comparison && options.comparison > 0) {
	      return result + '後';
	    } else {
	      return result + '前';
	    }
	  }
	
	  return result;
	};
	
	var _default = formatDistance;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1276 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: 'y年M月d日EEEE',
	  long: 'y年M月d日',
	  medium: 'y/MM/dd',
	  short: 'y/MM/dd'
	};
	var timeFormats = {
	  full: 'H時mm分ss秒 zzzz',
	  long: 'H:mm:ss z',
	  medium: 'H:mm:ss',
	  short: 'H:mm'
	};
	var dateTimeFormats = {
	  full: '{{date}} {{time}}',
	  long: '{{date}} {{time}}',
	  medium: '{{date}} {{time}}',
	  short: '{{date}} {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1277 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var formatRelativeLocale = {
	  lastWeek: '先週のeeeeのp',
	  yesterday: '昨日のp',
	  today: '今日のp',
	  tomorrow: '明日のp',
	  nextWeek: '翌週のeeeeのp',
	  other: 'P'
	};
	
	var formatRelative = function (token, _date, _baseDate, _options) {
	  return formatRelativeLocale[token];
	};
	
	var _default = formatRelative;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1278 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eraValues = {
	  narrow: ['BC', 'AC'],
	  abbreviated: ['紀元前', '西暦'],
	  wide: ['紀元前', '西暦']
	};
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
	  wide: ['第1四半期', '第2四半期', '第3四半期', '第4四半期']
	};
	var monthValues = {
	  narrow: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
	  abbreviated: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
	  wide: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月']
	};
	var dayValues = {
	  narrow: ['日', '月', '火', '水', '木', '金', '土'],
	  short: ['日', '月', '火', '水', '木', '金', '土'],
	  abbreviated: ['日', '月', '火', '水', '木', '金', '土'],
	  wide: ['日曜日', '月曜日', '火曜日', '水曜日', '木曜日', '金曜日', '土曜日']
	};
	var dayPeriodValues = {
	  narrow: {
	    am: '午前',
	    pm: '午後',
	    midnight: '深夜',
	    noon: '正午',
	    morning: '朝',
	    afternoon: '午後',
	    evening: '夜',
	    night: '深夜'
	  },
	  abbreviated: {
	    am: '午前',
	    pm: '午後',
	    midnight: '深夜',
	    noon: '正午',
	    morning: '朝',
	    afternoon: '午後',
	    evening: '夜',
	    night: '深夜'
	  },
	  wide: {
	    am: '午前',
	    pm: '午後',
	    midnight: '深夜',
	    noon: '正午',
	    morning: '朝',
	    afternoon: '午後',
	    evening: '夜',
	    night: '深夜'
	  }
	};
	var formattingDayPeriodValues = {
	  narrow: {
	    am: '午前',
	    pm: '午後',
	    midnight: '深夜',
	    noon: '正午',
	    morning: '朝',
	    afternoon: '午後',
	    evening: '夜',
	    night: '深夜'
	  },
	  abbreviated: {
	    am: '午前',
	    pm: '午後',
	    midnight: '深夜',
	    noon: '正午',
	    morning: '朝',
	    afternoon: '午後',
	    evening: '夜',
	    night: '深夜'
	  },
	  wide: {
	    am: '午前',
	    pm: '午後',
	    midnight: '深夜',
	    noon: '正午',
	    morning: '朝',
	    afternoon: '午後',
	    evening: '夜',
	    night: '深夜'
	  }
	};
	
	var ordinalNumber = function (dirtyNumber, dirtyOptions) {
	  var number = Number(dirtyNumber); // If ordinal numbers depend on context, for example,
	  // if they are different for different grammatical genders,
	  // use `options.unit`:
	  //
	  //   const options = dirtyOptions || {}
	  //   const unit = String(options.unit)
	  //
	  // where `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
	  // 'day', 'hour', 'minute', 'second'
	
	  var options = dirtyOptions || {};
	  var unit = String(options.unit);
	
	  switch (unit) {
	    case 'year':
	      return "".concat(number, "\u5E74");
	
	    case 'quarter':
	      return "\u7B2C".concat(number, "\u56DB\u534A\u671F");
	
	    case 'month':
	      return "".concat(number, "\u6708");
	
	    case 'week':
	      return "\u7B2C".concat(number, "\u9031");
	
	    case 'date':
	      return "".concat(number, "\u65E5");
	
	    case 'hour':
	      return "".concat(number, "\u6642");
	
	    case 'minute':
	      return "".concat(number, "\u5206");
	
	    case 'second':
	      return "".concat(number, "\u79D2");
	
	    default:
	      return "".concat(number);
	  }
	};
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingDayPeriodValues,
	    defaultFormattingWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1279 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(15));
	
	var _index2 = _interopRequireDefault(__webpack_require__(14));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^第?\d+(年|四半期|月|週|日|時|分|秒)?/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^(B\.?C\.?|A\.?D\.?)/i,
	  abbreviated: /^(紀元[前後]|西暦)/i,
	  wide: /^(紀元[前後]|西暦)/i
	};
	var parseEraPatterns = {
	  narrow: [/^B/i, /^A/i],
	  any: [/^(紀元前)/i, /^(西暦|紀元後)/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^Q[1234]/i,
	  wide: /^第[1234一二三四１２３４]四半期/i
	};
	var parseQuarterPatterns = {
	  any: [/(1|一|１)/i, /(2|二|２)/i, /(3|三|３)/i, /(4|四|４)/i]
	};
	var matchMonthPatterns = {
	  narrow: /^([123456789]|1[012])/,
	  abbreviated: /^([123456789]|1[012])月/i,
	  wide: /^([123456789]|1[012])月/i
	};
	var parseMonthPatterns = {
	  any: [/^1\D/, /^2/, /^3/, /^4/, /^5/, /^6/, /^7/, /^8/, /^9/, /^10/, /^11/, /^12/]
	};
	var matchDayPatterns = {
	  narrow: /^[日月火水木金土]/,
	  short: /^[日月火水木金土]/,
	  abbreviated: /^[日月火水木金土]/,
	  wide: /^[日月火水木金土]曜日/
	};
	var parseDayPatterns = {
	  any: [/^日/, /^月/, /^火/, /^水/, /^木/, /^金/, /^土/]
	};
	var matchDayPeriodPatterns = {
	  any: /^(AM|PM|午前|午後|正午|深夜|真夜中|夜|朝)/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^(A|午前)/i,
	    pm: /^(P|午後)/i,
	    midnight: /^深夜|真夜中/i,
	    noon: /^正午/i,
	    morning: /^朝/i,
	    afternoon: /^午後/i,
	    evening: /^夜/i,
	    night: /^深夜/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index2.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index2.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index2.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index2.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index2.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1280 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1275));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1276));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1277));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1278));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1279));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Japanese locale.
	 * @language Japanese
	 * @iso-639-2 jpn
	 * @author Thomas Eilmsteiner [@DeMuu]{@link https://github.com/DeMuu}
	 * @author Yamagishi Kazutoshi [@ykzts]{@link https://github.com/ykzts}
	 * @author Luca Ban [@mesqueeb]{@link https://github.com/mesqueeb}
	 * @author Terrence Lam [@skyuplam]{@link https://github.com/skyuplam}
	 * @author Taiki IKeda [@so99ynoodles]{@link https://github.com/so99ynoodles}
	 */
	var locale = {
	  code: 'ja',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 0
	    /* Sunday */
	    ,
	    firstWeekContainsDate: 1
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1281 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistance;
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    past: '{{count}} წამზე ნაკლები ხნის წინ',
	    present: '{{count}} წამზე ნაკლები',
	    future: '{{count}} წამზე ნაკლებში'
	  },
	  xSeconds: {
	    past: '{{count}} წამის წინ',
	    present: '{{count}} წამი',
	    future: '{{count}} წამში'
	  },
	  halfAMinute: {
	    past: 'ნახევარი წუთის წინ',
	    present: 'ნახევარი წუთი',
	    future: 'ნახევარი წუთში'
	  },
	  lessThanXMinutes: {
	    past: '{{count}} წუთზე ნაკლები ხნის წინ',
	    present: '{{count}} წუთზე ნაკლები',
	    future: '{{count}} წუთზე ნაკლებში'
	  },
	  xMinutes: {
	    past: '{{count}} წუთის წინ',
	    present: '{{count}} წუთი',
	    future: '{{count}} წუთში'
	  },
	  aboutXHours: {
	    past: 'დაახლოებით {{count}} საათის წინ',
	    present: 'დაახლოებით {{count}} საათი',
	    future: 'დაახლოებით {{count}} საათში'
	  },
	  xHours: {
	    past: '{{count}} საათის წინ',
	    present: '{{count}} საათი',
	    future: '{{count}} საათში'
	  },
	  xDays: {
	    past: '{{count}} დღის წინ',
	    present: '{{count}} დღე',
	    future: '{{count}} დღეში'
	  },
	  aboutXWeeks: {
	    past: 'დაახლოებით {{count}} კვირას წინ',
	    present: 'დაახლოებით {{count}} კვირა',
	    future: 'დაახლოებით {{count}} კვირაში'
	  },
	  xWeeks: {
	    past: '{{count}} კვირას კვირა',
	    present: '{{count}} კვირა',
	    future: '{{count}} კვირაში'
	  },
	  aboutXMonths: {
	    past: 'დაახლოებით {{count}} თვის წინ',
	    present: 'დაახლოებით {{count}} თვე',
	    future: 'დაახლოებით {{count}} თვეში'
	  },
	  xMonths: {
	    past: '{{count}} თვის წინ',
	    present: '{{count}} თვე',
	    future: '{{count}} თვეში'
	  },
	  aboutXYears: {
	    past: 'დაახლოებით {{count}} წლის წინ',
	    present: 'დაახლოებით {{count}} წელი',
	    future: 'დაახლოებით {{count}} წელში'
	  },
	  xYears: {
	    past: '{{count}} წლის წინ',
	    present: '{{count}} წელი',
	    future: '{{count}} წელში'
	  },
	  overXYears: {
	    past: '{{count}} წელზე მეტი ხნის წინ',
	    present: '{{count}} წელზე მეტი',
	    future: '{{count}} წელზე მეტი ხნის შემდეგ'
	  },
	  almostXYears: {
	    past: 'თითქმის {{count}} წლის წინ',
	    present: 'თითქმის {{count}} წელი',
	    future: 'თითქმის {{count}} წელში'
	  }
	};
	
	function formatDistance(token, count, options) {
	  options = options || {};
	  var result;
	
	  if (typeof formatDistanceLocale[token] === 'string') {
	    result = formatDistanceLocale[token];
	  } else if (options.addSuffix && options.comparison > 0) {
	    result = formatDistanceLocale[token].future.replace('{{count}}', count);
	  } else if (options.addSuffix && options.comparison <= 0) {
	    result = formatDistanceLocale[token].past.replace('{{count}}', count);
	  } else {
	    result = formatDistanceLocale[token].present.replace('{{count}}', count);
	  }
	
	  return result;
	}
	
	module.exports = exports.default;

/***/ },
/* 1282 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: 'EEEE, do MMMM, y',
	  long: 'do, MMMM, y',
	  medium: 'd, MMM, y',
	  short: 'dd/MM/yyyy'
	};
	var timeFormats = {
	  full: 'h:mm:ss a zzzz',
	  long: 'h:mm:ss a z',
	  medium: 'h:mm:ss a',
	  short: 'h:mm a'
	};
	var dateTimeFormats = {
	  full: "{{date}} {{time}}'-ზე'",
	  long: "{{date}} {{time}}'-ზე'",
	  medium: '{{date}}, {{time}}',
	  short: '{{date}}, {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1283 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRelative;
	var formatRelativeLocale = {
	  lastWeek: "'წინა' eeee p'-ზე'",
	  yesterday: "'გუშინ' p'-ზე'",
	  today: "'დღეს' p'-ზე'",
	  tomorrow: "'ხვალ' p'-ზე'",
	  nextWeek: "'შემდეგი' eeee p'-ზე'",
	  other: 'P'
	};
	
	function formatRelative(token, _date, _baseDate, _options) {
	  return formatRelativeLocale[token];
	}
	
	module.exports = exports.default;

/***/ },
/* 1284 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eraValues = {
	  narrow: ['ჩ.წ-მდე', 'ჩ.წ'],
	  abbreviated: ['ჩვ.წ-მდე', 'ჩვ.წ'],
	  wide: ['ჩვენს წელთაღრიცხვამდე', 'ჩვენი წელთაღრიცხვით']
	};
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['1-ლი კვ', '2-ე კვ', '3-ე კვ', '4-ე კვ'],
	  wide: ['1-ლი კვარტალი', '2-ე კვარტალი', '3-ე კვარტალი', '4-ე კვარტალი']
	}; // Note: in English, the names of days of the week and months are capitalized.
	// If you are making a new locale based on this one, check if the same is true for the language you're working on.
	// Generally, formatted dates should look like they are in the middle of a sentence,
	// e.g. in Spanish language the weekdays and months should be in the lowercase.
	
	var monthValues = {
	  narrow: ['ია', 'თე', 'მა', 'აპ', 'მს', 'ვნ', 'ვლ', 'აგ', 'სე', 'ოქ', 'ნო', 'დე'],
	  abbreviated: ['იან', 'თებ', 'მარ', 'აპრ', 'მაი', 'ივნ', 'ივლ', 'აგვ', 'სექ', 'ოქტ', 'ნოე', 'დეკ'],
	  wide: ['იანვარი', 'თებერვალი', 'მარტი', 'აპრილი', 'მაისი', 'ივნისი', 'ივლისი', 'აგვისტო', 'სექტემბერი', 'ოქტომბერი', 'ნოემბერი', 'დეკემბერი']
	};
	var dayValues = {
	  narrow: ['კვ', 'ორ', 'სა', 'ოთ', 'ხუ', 'პა', 'შა'],
	  short: ['კვი', 'ორშ', 'სამ', 'ოთხ', 'ხუთ', 'პარ', 'შაბ'],
	  abbreviated: ['კვი', 'ორშ', 'სამ', 'ოთხ', 'ხუთ', 'პარ', 'შაბ'],
	  wide: ['კვირა', 'ორშაბათი', 'სამშაბათი', 'ოთხშაბათი', 'ხუთშაბათი', 'პარასკევი', 'შაბათი']
	};
	var dayPeriodValues = {
	  narrow: {
	    am: 'a',
	    pm: 'p',
	    midnight: 'შუაღამე',
	    noon: 'შუადღე',
	    morning: 'დილა',
	    afternoon: 'საღამო',
	    evening: 'საღამო',
	    night: 'ღამე'
	  },
	  abbreviated: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'შუაღამე',
	    noon: 'შუადღე',
	    morning: 'დილა',
	    afternoon: 'საღამო',
	    evening: 'საღამო',
	    night: 'ღამე'
	  },
	  wide: {
	    am: 'a.m.',
	    pm: 'p.m.',
	    midnight: 'შუაღამე',
	    noon: 'შუადღე',
	    morning: 'დილა',
	    afternoon: 'საღამო',
	    evening: 'საღამო',
	    night: 'ღამე'
	  }
	};
	var formattingDayPeriodValues = {
	  narrow: {
	    am: 'a',
	    pm: 'p',
	    midnight: 'შუაღამით',
	    noon: 'შუადღისას',
	    morning: 'დილით',
	    afternoon: 'ნაშუადღევს',
	    evening: 'საღამოს',
	    night: 'ღამით'
	  },
	  abbreviated: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'შუაღამით',
	    noon: 'შუადღისას',
	    morning: 'დილით',
	    afternoon: 'ნაშუადღევს',
	    evening: 'საღამოს',
	    night: 'ღამით'
	  },
	  wide: {
	    am: 'a.m.',
	    pm: 'p.m.',
	    midnight: 'შუაღამით',
	    noon: 'შუადღისას',
	    morning: 'დილით',
	    afternoon: 'ნაშუადღევს',
	    evening: 'საღამოს',
	    night: 'ღამით'
	  }
	};
	
	function ordinalNumber(dirtyNumber, _dirtyOptions) {
	  var number = Number(dirtyNumber); // If ordinal numbers depend on context, for example,
	  // if they are different for different grammatical genders,
	  // use `options.unit`:
	  //
	  //   var options = dirtyOptions || {}
	  //   var unit = String(options.unit)
	  //
	  // where `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
	  // 'day', 'hour', 'minute', 'second'
	
	  if (number === 1) {
	    return number + '-ლი';
	  }
	
	  return number + '-ე';
	}
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingDayPeriodValues,
	    defaultFormattingWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1285 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(15));
	
	var _index2 = _interopRequireDefault(__webpack_require__(14));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(\d+)(-ლი|-ე)?/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^(ჩვ?\.წ)/i,
	  abbreviated: /^(ჩვ?\.წ)/i,
	  wide: /^(ჩვენს წელთაღრიცხვამდე|ქრისტეშობამდე|ჩვენი წელთაღრიცხვით|ქრისტეშობიდან)/i
	};
	var parseEraPatterns = {
	  any: [/^(ჩვენს წელთაღრიცხვამდე|ქრისტეშობამდე)/i, /^(ჩვენი წელთაღრიცხვით|ქრისტეშობიდან)/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^[1234]-(ლი|ე)? კვ/i,
	  wide: /^[1234]-(ლი|ე)? კვარტალი/i
	};
	var parseQuarterPatterns = {
	  any: [/1/i, /2/i, /3/i, /4/i]
	};
	var matchMonthPatterns = {
	  any: /^(ია|თე|მა|აპ|მს|ვნ|ვლ|აგ|სე|ოქ|ნო|დე)/i
	};
	var parseMonthPatterns = {
	  any: [/^ია/i, /^თ/i, /^მარ/i, /^აპ/i, /^მაი/i, /^ი?ვნ/i, /^ი?ვლ/i, /^აგ/i, /^ს/i, /^ო/i, /^ნ/i, /^დ/i]
	};
	var matchDayPatterns = {
	  narrow: /^(კვ|ორ|სა|ოთ|ხუ|პა|შა)/i,
	  short: /^(კვი|ორშ|სამ|ოთხ|ხუთ|პარ|შაბ)/i,
	  long: /^(კვირა|ორშაბათი|სამშაბათი|ოთხშაბათი|ხუთშაბათი|პარასკევი|შაბათი)/i
	};
	var parseDayPatterns = {
	  any: [/^კვ/i, /^ორ/i, /^სა/i, /^ოთ/i, /^ხუ/i, /^პა/i, /^შა/i]
	};
	var matchDayPeriodPatterns = {
	  any: /^([ap]\.?\s?m\.?|შუაღ|დილ)/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^a/i,
	    pm: /^p/i,
	    midnight: /^შუაღ/i,
	    noon: /^შუადღ/i,
	    morning: /^დილ/i,
	    afternoon: /ნაშუადღევს/i,
	    evening: /საღამო/i,
	    night: /ღამ/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index2.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index2.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index2.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index2.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index2.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1286 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1281));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1282));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1283));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1284));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1285));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Georgian locale.
	 * @language Georgian
	 * @iso-639-2 geo
	 * @author Lado Lomidze [@Landish]{@link https://github.com/Landish}
	 * @author Nick Shvelidze [@shvelo]{@link https://github.com/shvelo}
	 */
	var locale = {
	  code: 'ka',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 1
	    /* Monday */
	    ,
	    firstWeekContainsDate: 1
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1287 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistance;
	
	function declension(scheme, count) {
	  // scheme for count=1 exists
	  if (scheme.one !== undefined && count === 1) {
	    return scheme.one;
	  }
	
	  var rem10 = count % 10;
	  var rem100 = count % 100; // 1, 21, 31, ...
	
	  if (rem10 === 1 && rem100 !== 11) {
	    return scheme.singularNominative.replace('{{count}}', count); // 2, 3, 4, 22, 23, 24, 32 ...
	  } else if (rem10 >= 2 && rem10 <= 4 && (rem100 < 10 || rem100 > 20)) {
	    return scheme.singularGenitive.replace('{{count}}', count); // 5, 6, 7, 8, 9, 10, 11, ...
	  } else {
	    return scheme.pluralGenitive.replace('{{count}}', count);
	  }
	}
	
	function buildLocalizeTokenFn(scheme) {
	  return function (count, options) {
	    if (options.addSuffix) {
	      if (options.comparison > 0) {
	        if (scheme.future) {
	          return declension(scheme.future, count);
	        } else {
	          return declension(scheme.regular, count) + ' кейін';
	        }
	      } else {
	        if (scheme.past) {
	          return declension(scheme.past, count);
	        } else {
	          return declension(scheme.regular, count) + ' бұрын';
	        }
	      }
	    } else {
	      return declension(scheme.regular, count);
	    }
	  };
	}
	
	var formatDistanceLocale = {
	  lessThanXSeconds: buildLocalizeTokenFn({
	    regular: {
	      one: '1 секундтан аз',
	      singularNominative: '{{count}} секундтан аз',
	      singularGenitive: '{{count}} секундтан аз',
	      pluralGenitive: '{{count}} секундтан аз'
	    },
	    future: {
	      one: 'бір секундтан кейін',
	      singularNominative: '{{count}} секундтан кейін',
	      singularGenitive: '{{count}} секундтан кейін',
	      pluralGenitive: '{{count}} секундтан кейін'
	    }
	  }),
	  xSeconds: buildLocalizeTokenFn({
	    regular: {
	      singularNominative: '{{count}} секунд',
	      singularGenitive: '{{count}} секунд',
	      pluralGenitive: '{{count}} секунд'
	    },
	    past: {
	      singularNominative: '{{count}} секунд бұрын',
	      singularGenitive: '{{count}} секунд бұрын',
	      pluralGenitive: '{{count}} секунд бұрын'
	    },
	    future: {
	      singularNominative: '{{count}} секундтан кейін',
	      singularGenitive: '{{count}} секундтан кейін',
	      pluralGenitive: '{{count}} секундтан кейін'
	    }
	  }),
	  halfAMinute: function (_, options) {
	    if (options.addSuffix) {
	      if (options.comparison > 0) {
	        return 'жарты минут ішінде';
	      } else {
	        return 'жарты минут бұрын';
	      }
	    }
	
	    return 'жарты минут';
	  },
	  lessThanXMinutes: buildLocalizeTokenFn({
	    regular: {
	      one: '1 минуттан аз',
	      singularNominative: '{{count}} минуттан аз',
	      singularGenitive: '{{count}} минуттан аз',
	      pluralGenitive: '{{count}} минуттан аз'
	    },
	    future: {
	      one: 'минуттан кем ',
	      singularNominative: '{{count}} минуттан кем',
	      singularGenitive: '{{count}} минуттан кем',
	      pluralGenitive: '{{count}} минуттан кем'
	    }
	  }),
	  xMinutes: buildLocalizeTokenFn({
	    regular: {
	      singularNominative: '{{count}} минут',
	      singularGenitive: '{{count}} минут',
	      pluralGenitive: '{{count}} минут'
	    },
	    past: {
	      singularNominative: '{{count}} минут бұрын',
	      singularGenitive: '{{count}} минут бұрын',
	      pluralGenitive: '{{count}} минут бұрын'
	    },
	    future: {
	      singularNominative: '{{count}} минуттан кейін',
	      singularGenitive: '{{count}} минуттан кейін',
	      pluralGenitive: '{{count}} минуттан кейін'
	    }
	  }),
	  aboutXHours: buildLocalizeTokenFn({
	    regular: {
	      singularNominative: 'шамамен {{count}} сағат',
	      singularGenitive: 'шамамен {{count}} сағат',
	      pluralGenitive: 'шамамен {{count}} сағат'
	    },
	    future: {
	      singularNominative: 'шамамен {{count}} сағаттан кейін',
	      singularGenitive: 'шамамен {{count}} сағаттан кейін',
	      pluralGenitive: 'шамамен {{count}} сағаттан кейін'
	    }
	  }),
	  xHours: buildLocalizeTokenFn({
	    regular: {
	      singularNominative: '{{count}} сағат',
	      singularGenitive: '{{count}} сағат',
	      pluralGenitive: '{{count}} сағат'
	    }
	  }),
	  xDays: buildLocalizeTokenFn({
	    regular: {
	      singularNominative: '{{count}} күн',
	      singularGenitive: '{{count}} күн',
	      pluralGenitive: '{{count}} күн'
	    },
	    future: {
	      singularNominative: '{{count}} күннен кейін',
	      singularGenitive: '{{count}} күннен кейін',
	      pluralGenitive: '{{count}} күннен кейін'
	    }
	  }),
	  aboutXWeeks: {
	    one: 'шамамен 1 апта',
	    other: 'шамамен {{count}} апта'
	  },
	  xWeeks: {
	    one: '1 апта',
	    other: '{{count}} апта'
	  },
	  aboutXMonths: buildLocalizeTokenFn({
	    regular: {
	      singularNominative: 'шамамен {{count}} ай',
	      singularGenitive: 'шамамен {{count}} ай',
	      pluralGenitive: 'шамамен {{count}} ай'
	    },
	    future: {
	      singularNominative: 'шамамен {{count}} айдан кейін',
	      singularGenitive: 'шамамен {{count}} айдан кейін',
	      pluralGenitive: 'шамамен {{count}} айдан кейін'
	    }
	  }),
	  xMonths: buildLocalizeTokenFn({
	    regular: {
	      singularNominative: '{{count}} ай',
	      singularGenitive: '{{count}} ай',
	      pluralGenitive: '{{count}} ай'
	    }
	  }),
	  aboutXYears: buildLocalizeTokenFn({
	    regular: {
	      singularNominative: 'шамамен {{count}} жыл',
	      singularGenitive: 'шамамен {{count}} жыл',
	      pluralGenitive: 'шамамен {{count}} жыл'
	    },
	    future: {
	      singularNominative: 'шамамен {{count}} жылдан кейін',
	      singularGenitive: 'шамамен {{count}} жылдан кейін',
	      pluralGenitive: 'шамамен {{count}} жылдан кейін'
	    }
	  }),
	  xYears: buildLocalizeTokenFn({
	    regular: {
	      singularNominative: '{{count}} жыл',
	      singularGenitive: '{{count}} жыл',
	      pluralGenitive: '{{count}} жыл'
	    },
	    future: {
	      singularNominative: '{{count}} жылдан кейін',
	      singularGenitive: '{{count}} жылдан кейін',
	      pluralGenitive: '{{count}} жылдан кейін'
	    }
	  }),
	  overXYears: buildLocalizeTokenFn({
	    regular: {
	      singularNominative: '{{count}} жылдан астам',
	      singularGenitive: '{{count}} жылдан астам',
	      pluralGenitive: '{{count}} жылдан астам'
	    },
	    future: {
	      singularNominative: '{{count}} жылдан астам',
	      singularGenitive: '{{count}} жылдан астам',
	      pluralGenitive: '{{count}} жылдан астам'
	    }
	  }),
	  almostXYears: buildLocalizeTokenFn({
	    regular: {
	      singularNominative: '{{count}} жылға жақын',
	      singularGenitive: '{{count}} жылға жақын',
	      pluralGenitive: '{{count}} жылға жақын'
	    },
	    future: {
	      singularNominative: '{{count}} жылдан кейін',
	      singularGenitive: '{{count}} жылдан кейін',
	      pluralGenitive: '{{count}} жылдан кейін'
	    }
	  })
	};
	
	function formatDistance(token, count, options) {
	  options = options || {};
	  return formatDistanceLocale[token](count, options);
	}
	
	module.exports = exports.default;

/***/ },
/* 1288 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: "EEEE, do MMMM y 'ж.'",
	  long: "do MMMM y 'ж.'",
	  medium: "d MMM y 'ж.'",
	  short: 'dd.MM.yyyy'
	};
	var timeFormats = {
	  full: 'H:mm:ss zzzz',
	  long: 'H:mm:ss z',
	  medium: 'H:mm:ss',
	  short: 'H:mm'
	};
	var dateTimeFormats = {
	  any: '{{date}}, {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'any'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1289 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRelative;
	
	var _index = _interopRequireDefault(__webpack_require__(71));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var accusativeWeekdays = ['жексенбіде', 'дүйсенбіде', 'сейсенбіде', 'сәрсенбіде', 'бейсенбіде', 'жұмада', 'сенбіде'];
	
	function lastWeek(day) {
	  var weekday = accusativeWeekdays[day];
	  return "'өткен " + weekday + " сағат' p'-де'";
	}
	
	function thisWeek(day) {
	  var weekday = accusativeWeekdays[day];
	  return "'" + weekday + " сағат' p'-де'";
	}
	
	function nextWeek(day) {
	  var weekday = accusativeWeekdays[day];
	  return "'келесі " + weekday + " сағат' p'-де'";
	}
	
	var formatRelativeLocale = {
	  lastWeek: function (date, baseDate, options) {
	    var day = date.getUTCDay();
	
	    if ((0, _index.default)(date, baseDate, options)) {
	      return thisWeek(day);
	    } else {
	      return lastWeek(day);
	    }
	  },
	  yesterday: "'кеше сағат' p'-де'",
	  today: "'бүгін сағат' p'-де'",
	  tomorrow: "'ертең сағат' p'-де'",
	  nextWeek: function (date, baseDate, options) {
	    var day = date.getUTCDay();
	
	    if ((0, _index.default)(date, baseDate, options)) {
	      return thisWeek(day);
	    } else {
	      return nextWeek(day);
	    }
	  },
	  other: 'P'
	};
	
	function formatRelative(token, date, baseDate, options) {
	  var format = formatRelativeLocale[token];
	
	  if (typeof format === 'function') {
	    return format(date, baseDate, options);
	  }
	
	  return format;
	}
	
	module.exports = exports.default;

/***/ },
/* 1290 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eraValues = {
	  narrow: ['б.з.д.', 'б.з.'],
	  abbreviated: ['б.з.д.', 'б.з.'],
	  wide: ['біздің заманымызға дейін', 'біздің заманымыз']
	};
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['1-ші тоқ.', '2-ші тоқ.', '3-ші тоқ.', '4-ші тоқ.'],
	  wide: ['1-ші тоқсан', '2-ші тоқсан', '3-ші тоқсан', '4-ші тоқсан']
	};
	var monthValues = {
	  narrow: ['Қ', 'А', 'Н', 'С', 'М', 'М', 'Ш', 'Т', 'Қ', 'Қ', 'Қ', 'Ж'],
	  abbreviated: ['қаң', 'ақп', 'нау', 'сәу', 'мам', 'мау', 'шіл', 'там', 'қыр', 'қаз', 'қар', 'жел'],
	  wide: ['қаңтар', 'ақпан', 'наурыз', 'сәуір', 'мамыр', 'маусым', 'шілде', 'тамыз', 'қыркүйек', 'қазан', 'қараша', 'желтоқсан']
	};
	var formattingMonthValues = {
	  narrow: ['Қ', 'А', 'Н', 'С', 'М', 'М', 'Ш', 'Т', 'Қ', 'Қ', 'Қ', 'Ж'],
	  abbreviated: ['қаң', 'ақп', 'нау', 'сәу', 'мам', 'мау', 'шіл', 'там', 'қыр', 'қаз', 'қар', 'жел'],
	  wide: ['қаңтар', 'ақпан', 'наурыз', 'сәуір', 'мамыр', 'маусым', 'шілде', 'тамыз', 'қыркүйек', 'қазан', 'қараша', 'желтоқсан']
	};
	var dayValues = {
	  narrow: ['Ж', 'Д', 'С', 'С', 'Б', 'Ж', 'С'],
	  short: ['жс', 'дс', 'сс', 'ср', 'бс', 'жм', 'сб'],
	  abbreviated: ['жс', 'дс', 'сс', 'ср', 'бс', 'жм', 'сб'],
	  wide: ['жексенбі', 'дүйсенбі', 'сейсенбі', 'сәрсенбі', 'бейсенбі', 'жұма', 'сенбі']
	};
	var dayPeriodValues = {
	  narrow: {
	    am: 'ТД',
	    pm: 'ТК',
	    midnight: 'түн ортасы',
	    noon: 'түс',
	    morning: 'таң',
	    afternoon: 'күндіз',
	    evening: 'кеш',
	    night: 'түн'
	  },
	  wide: {
	    am: 'ТД',
	    pm: 'ТК',
	    midnight: 'түн ортасы',
	    noon: 'түс',
	    morning: 'таң',
	    afternoon: 'күндіз',
	    evening: 'кеш',
	    night: 'түн'
	  }
	};
	var formattingDayPeriodValues = {
	  narrow: {
	    am: 'ТД',
	    pm: 'ТК',
	    midnight: 'түн ортасында',
	    noon: 'түс',
	    morning: 'таң',
	    afternoon: 'күн',
	    evening: 'кеш',
	    night: 'түн'
	  },
	  wide: {
	    am: 'ТД',
	    pm: 'ТК',
	    midnight: 'түн ортасында',
	    noon: 'түсте',
	    morning: 'таңертең',
	    afternoon: 'күндіз',
	    evening: 'кеште',
	    night: 'түнде'
	  }
	};
	var suffixes = {
	  0: '-ші',
	  1: '-ші',
	  2: '-ші',
	  3: '-ші',
	  4: '-ші',
	  5: '-ші',
	  6: '-шы',
	  7: '-ші',
	  8: '-ші',
	  9: '-шы',
	  10: '-шы',
	  20: '-шы',
	  30: '-шы',
	  40: '-шы',
	  50: '-ші',
	  60: '-шы',
	  70: '-ші',
	  80: '-ші',
	  90: '-шы',
	  100: '-ші'
	};
	
	function ordinalNumber(dirtyNumber) {
	  var number = Number(dirtyNumber);
	  var a = number % 10;
	  var b = number >= 100 ? 100 : null;
	  return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	}
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingMonthValues,
	    defaultFormattingWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'any',
	    formattingValues: formattingDayPeriodValues,
	    defaultFormattingWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1291 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(15));
	
	var _index2 = _interopRequireDefault(__webpack_require__(14));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(\d+)(-?(ші|шы))?/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^((б )?з\.?\s?д\.?)/i,
	  abbreviated: /^((б )?з\.?\s?д\.?)/i,
	  wide: /^(біздің заманымызға дейін|біздің заманымыз|біздің заманымыздан)/i
	};
	var parseEraPatterns = {
	  any: [/^б/i, /^з/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^[1234](-?ші)? тоқ.?/i,
	  wide: /^[1234](-?ші)? тоқсан/i
	};
	var parseQuarterPatterns = {
	  any: [/1/i, /2/i, /3/i, /4/i]
	};
	var matchMonthPatterns = {
	  narrow: /^(қ|а|н|с|м|мау|ш|т|қыр|қаз|қар|ж)/i,
	  abbreviated: /^(қаң|ақп|нау|сәу|мам|мау|шіл|там|қыр|қаз|қар|жел)/i,
	  wide: /^(қаңтар|ақпан|наурыз|сәуір|мамыр|маусым|шілде|тамыз|қыркүйек|қазан|қараша|желтоқсан)/i
	};
	var parseMonthPatterns = {
	  narrow: [/^қ/i, /^а/i, /^н/i, /^с/i, /^м/i, /^м/i, /^ш/i, /^т/i, /^қ/i, /^қ/i, /^қ/i, /^ж/i],
	  abbreviated: [/^қаң/i, /^ақп/i, /^нау/i, /^сәу/i, /^мам/i, /^мау/i, /^шіл/i, /^там/i, /^қыр/i, /^қаз/i, /^қар/i, /^жел/i],
	  any: [/^қ/i, /^а/i, /^н/i, /^с/i, /^м/i, /^м/i, /^ш/i, /^т/i, /^қ/i, /^қ/i, /^қ/i, /^ж/i]
	};
	var matchDayPatterns = {
	  narrow: /^(ж|д|с|с|б|ж|с)/i,
	  short: /^(жс|дс|сс|ср|бс|жм|сб)/i,
	  wide: /^(жексенбі|дүйсенбі|сейсенбі|сәрсенбі|бейсенбі|жұма|сенбі)/i
	};
	var parseDayPatterns = {
	  narrow: [/^ж/i, /^д/i, /^с/i, /^с/i, /^б/i, /^ж/i, /^с/i],
	  short: [/^жс/i, /^дс/i, /^сс/i, /^ср/i, /^бс/i, /^жм/i, /^сб/i],
	  any: [/^ж[ек]/i, /^д[үй]/i, /^сe[й]/i, /^сә[р]/i, /^б[ей]/i, /^ж[ұм]/i, /^се[н]/i]
	};
	var matchDayPeriodPatterns = {
	  narrow: /^Т\.?\s?[ДК]\.?|түн ортасында|((түсте|таңертең|таңда|таңертең|таңмен|таң|күндіз|күн|кеште|кеш|түнде|түн)\.?)/i,
	  wide: /^Т\.?\s?[ДК]\.?|түн ортасында|((түсте|таңертең|таңда|таңертең|таңмен|таң|күндіз|күн|кеште|кеш|түнде|түн)\.?)/i,
	  any: /^Т\.?\s?[ДК]\.?|түн ортасында|((түсте|таңертең|таңда|таңертең|таңмен|таң|күндіз|күн|кеште|кеш|түнде|түн)\.?)/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^ТД/i,
	    pm: /^ТК/i,
	    midnight: /^түн орта/i,
	    noon: /^күндіз/i,
	    morning: /таң/i,
	    afternoon: /түс/i,
	    evening: /кеш/i,
	    night: /түн/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index2.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index2.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index2.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index2.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index2.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1292 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1287));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1288));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1289));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1290));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1291));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Kazakh locale.
	 * @language Kazakh
	 * @iso-639-2 kaz
	 * @author Nikita Bayev [@drugoi]{@link https://github.com/drugoi}
	 */
	var locale = {
	  code: 'kk',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 1
	    /* Monday */
	    ,
	    firstWeekContainsDate: 1
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1293 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var formatDistanceLocale = {
	  lessThanXSeconds: 'តិចជាង {{count}} វិនាទី',
	  xSeconds: '{{count}} វិនាទី',
	  halfAMinute: 'កន្លះនាទី',
	  lessThanXMinutes: 'តិចជាង {{count}} នាទី',
	  xMinutes: '{{count}} នាទី',
	  aboutXHours: 'ប្រហែល {{count}} ម៉ោង',
	  xHours: '{{count}} ម៉ោង',
	  xDays: '{{count}} ថ្ងៃ',
	  aboutXWeeks: 'ប្រហែល {{count}} សប្តាហ៍',
	  xWeeks: '{{count}} សប្តាហ៍',
	  aboutXMonths: 'ប្រហែល {{count}} ខែ',
	  xMonths: '{{count}} ខែ',
	  aboutXYears: 'ប្រហែល {{count}} ឆ្នាំ',
	  xYears: '{{count}} ឆ្នាំ',
	  overXYears: 'ជាង {{count}} ឆ្នាំ',
	  almostXYears: 'ជិត {{count}} ឆ្នាំ'
	};
	
	var formatDistance = function (token, count, options) {
	  var tokenValue = formatDistanceLocale[token];
	  var result = tokenValue;
	
	  if (typeof count === 'number') {
	    result = result.replace('{{count}}', count.toString());
	  }
	
	  if (options !== null && options !== void 0 && options.addSuffix) {
	    if (options.comparison && options.comparison > 0) {
	      return 'ក្នុងរយៈពេល ' + result;
	    } else {
	      return result + 'មុន';
	    }
	  }
	
	  return result;
	};
	
	var _default = formatDistance;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1294 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: 'EEEE do MMMM y',
	  long: 'do MMMM y',
	  medium: 'd MMM y',
	  short: 'dd/MM/yyyy'
	};
	var timeFormats = {
	  full: 'h:mm:ss a',
	  long: 'h:mm:ss a',
	  medium: 'h:mm:ss a',
	  short: 'h:mm a'
	};
	var dateTimeFormats = {
	  full: "{{date}} 'ម៉ោង' {{time}}",
	  long: "{{date}} 'ម៉ោង' {{time}}",
	  medium: '{{date}}, {{time}}',
	  short: '{{date}}, {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1295 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var formatRelativeLocale = {
	  lastWeek: "'ថ្ងៃ'eeee'ស​ប្តា​ហ៍​មុនម៉ោង' p",
	  yesterday: "'ម្សិលមិញនៅម៉ោង' p",
	  today: "'ថ្ងៃនេះម៉ោង' p",
	  tomorrow: "'ថ្ងៃស្អែកម៉ោង' p",
	  nextWeek: "'ថ្ងៃ'eeee'ស​ប្តា​ហ៍​ក្រោយម៉ោង' p",
	  other: 'P'
	};
	
	var formatRelative = function (token, _date, _baseDate, _options) {
	  return formatRelativeLocale[token];
	};
	
	var _default = formatRelative;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1296 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eraValues = {
	  narrow: ['ម.គស', 'គស'],
	  abbreviated: ['មុនគ.ស', 'គ.ស'],
	  wide: ['មុនគ្រិស្តសករាជ', 'នៃគ្រិស្តសករាជ']
	};
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
	  wide: ['ត្រីមាសទី 1', 'ត្រីមាសទី 2', 'ត្រីមាសទី 3', 'ត្រីមាសទី 4']
	};
	var monthValues = {
	  narrow: ['ម.ក', 'ក.ម', 'មិ', 'ម.ស', 'ឧ.ស', 'ម.ថ', 'ក.ដ', 'សី', 'កញ', 'តុ', 'វិ', 'ធ'],
	  abbreviated: ['មករា', 'កុម្ភៈ', 'មីនា', 'មេសា', 'ឧសភា', 'មិថុនា', 'កក្កដា', 'សីហា', 'កញ្ញា', 'តុលា', 'វិច្ឆិកា', 'ធ្នូ'],
	  wide: ['មករា', 'កុម្ភៈ', 'មីនា', 'មេសា', 'ឧសភា', 'មិថុនា', 'កក្កដា', 'សីហា', 'កញ្ញា', 'តុលា', 'វិច្ឆិកា', 'ធ្នូ']
	};
	var dayValues = {
	  narrow: ['អា', 'ច', 'អ', 'ព', 'ព្រ', 'សុ', 'ស'],
	  short: ['អា', 'ច', 'អ', 'ព', 'ព្រ', 'សុ', 'ស'],
	  abbreviated: ['អា', 'ច', 'អ', 'ព', 'ព្រ', 'សុ', 'ស'],
	  wide: ['អាទិត្យ', 'ចន្ទ', 'អង្គារ', 'ពុធ', 'ព្រហស្បតិ៍', 'សុក្រ', 'សៅរ៍']
	};
	var dayPeriodValues = {
	  narrow: {
	    am: 'ព្រឹក',
	    pm: 'ល្ងាច',
	    midnight: '​ពេលកណ្ដាលអធ្រាត្រ',
	    noon: 'ពេលថ្ងៃត្រង់',
	    morning: 'ពេលព្រឹក',
	    afternoon: 'ពេលរសៀល',
	    evening: 'ពេលល្ងាច',
	    night: 'ពេលយប់'
	  },
	  abbreviated: {
	    am: 'ព្រឹក',
	    pm: 'ល្ងាច',
	    midnight: '​ពេលកណ្ដាលអធ្រាត្រ',
	    noon: 'ពេលថ្ងៃត្រង់',
	    morning: 'ពេលព្រឹក',
	    afternoon: 'ពេលរសៀល',
	    evening: 'ពេលល្ងាច',
	    night: 'ពេលយប់'
	  },
	  wide: {
	    am: 'ព្រឹក',
	    pm: 'ល្ងាច',
	    midnight: '​ពេលកណ្ដាលអធ្រាត្រ',
	    noon: 'ពេលថ្ងៃត្រង់',
	    morning: 'ពេលព្រឹក',
	    afternoon: 'ពេលរសៀល',
	    evening: 'ពេលល្ងាច',
	    night: 'ពេលយប់'
	  }
	};
	var formattingDayPeriodValues = {
	  narrow: {
	    am: 'ព្រឹក',
	    pm: 'ល្ងាច',
	    midnight: '​ពេលកណ្ដាលអធ្រាត្រ',
	    noon: 'ពេលថ្ងៃត្រង់',
	    morning: 'ពេលព្រឹក',
	    afternoon: 'ពេលរសៀល',
	    evening: 'ពេលល្ងាច',
	    night: 'ពេលយប់'
	  },
	  abbreviated: {
	    am: 'ព្រឹក',
	    pm: 'ល្ងាច',
	    midnight: '​ពេលកណ្ដាលអធ្រាត្រ',
	    noon: 'ពេលថ្ងៃត្រង់',
	    morning: 'ពេលព្រឹក',
	    afternoon: 'ពេលរសៀល',
	    evening: 'ពេលល្ងាច',
	    night: 'ពេលយប់'
	  },
	  wide: {
	    am: 'ព្រឹក',
	    pm: 'ល្ងាច',
	    midnight: '​ពេលកណ្ដាលអធ្រាត្រ',
	    noon: 'ពេលថ្ងៃត្រង់',
	    morning: 'ពេលព្រឹក',
	    afternoon: 'ពេលរសៀល',
	    evening: 'ពេលល្ងាច',
	    night: 'ពេលយប់'
	  }
	};
	
	var ordinalNumber = function (dirtyNumber, _) {
	  var number = Number(dirtyNumber);
	  return number.toString();
	};
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return quarter - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingDayPeriodValues,
	    defaultFormattingWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1297 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(14));
	
	var _index2 = _interopRequireDefault(__webpack_require__(15));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^(ម\.)?គស/i,
	  abbreviated: /^(មុន)?គ\.ស/i,
	  wide: /^(មុន|នៃ)គ្រិស្តសករាជ/i
	};
	var parseEraPatterns = {
	  any: [/^(ម|មុន)គ\.?ស/i, /^(នៃ)?គ\.?ស/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^q[1234]/i,
	  wide: /^(ត្រីមាស)(ទី)?\s?[1234]/i
	};
	var parseQuarterPatterns = {
	  any: [/1/i, /2/i, /3/i, /4/i]
	};
	var matchMonthPatterns = {
	  narrow: /^(ម\.ក|ក\.ម|មិ|ម\.ស|ឧ\.ស|ម\.ថ|ក\.ដ|សី|កញ|តុ|វិ|ធ)/i,
	  abbreviated: /^(មករា|កុម្ភៈ|មីនា|មេសា|ឧសភា|មិថុនា|កក្កដា|សីហា|កញ្ញា|តុលា|វិច្ឆិកា|ធ្នូ)/i,
	  wide: /^(មករា|កុម្ភៈ|មីនា|មេសា|ឧសភា|មិថុនា|កក្កដា|សីហា|កញ្ញា|តុលា|វិច្ឆិកា|ធ្នូ)/i
	};
	var parseMonthPatterns = {
	  narrow: [/^ម\.ក/i, /^ក\.ម/i, /^មិ/i, /^ម\.ស/i, /^ឧ\.ស/i, /^ម\.ថ/i, /^ក\.ដ/i, /^សី/i, /^កញ/i, /^តុ/i, /^វិ/i, /^ធ/i],
	  any: [/^មក/i, /^កុ/i, /^មីន/i, /^មេ/i, /^ឧស/i, /^មិថ/i, /^កក/i, /^សី/i, /^កញ/i, /^តុ/i, /^វិច/i, /^ធ/i]
	};
	var matchDayPatterns = {
	  narrow: /^(អា|ច|អ|ព|ព្រ|សុ|ស)/i,
	  short: /^(អា|ច|អ|ព|ព្រ|សុ|ស)/i,
	  abbreviated: /^(អា|ច|អ|ព|ព្រ|សុ|ស)/i,
	  wide: /^(អាទិត្យ|ចន្ទ|អង្គារ|ពុធ|ព្រហស្បតិ៍|សុក្រ|សៅរ៍)/i
	};
	var parseDayPatterns = {
	  narrow: [/^អា/i, /^ច/i, /^អ/i, /^ព/i, /^ព្រ/i, /^សុ/i, /^ស/i],
	  any: [/^អា/i, /^ច/i, /^អ/i, /^ព/i, /^ព្រ/i, /^សុ/i, /^សៅ/i]
	};
	var matchDayPeriodPatterns = {
	  narrow: /^(ព្រឹក|ល្ងាច|ពេលព្រឹក|ពេលថ្ងៃត្រង់|ពេលល្ងាច|ពេលរសៀល|ពេលយប់|ពេលកណ្ដាលអធ្រាត្រ)/i,
	  any: /^(ព្រឹក|ល្ងាច|ពេលព្រឹក|ពេលថ្ងៃត្រង់|ពេលល្ងាច|ពេលរសៀល|ពេលយប់|ពេលកណ្ដាលអធ្រាត្រ)/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^ព្រឹក/i,
	    pm: /^ល្ងាច/i,
	    midnight: /^ពេលកណ្ដាលអធ្រាត្រ/i,
	    noon: /^ពេលថ្ងៃត្រង់/i,
	    morning: /ពេលព្រឹក/i,
	    afternoon: /ពេលរសៀល/i,
	    evening: /ពេលល្ងាច/i,
	    night: /ពេលយប់/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index2.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1298 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1293));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1294));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1295));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1296));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1297));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Khmer locale (Cambodian).
	 * @language Khmer
	 * @iso-639-2 khm
	 * @author Seanghay Yath [@seanghay]{@link https://github.com/seanghay}
	 */
	var locale = {
	  code: 'km',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 0
	    /* Sunday */
	    ,
	    firstWeekContainsDate: 1
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1299 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistance;
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    one: {
	      default: '1 ಸೆಕೆಂಡ್‌ಗಿಂತ ಕಡಿಮೆ',
	      future: '1 ಸೆಕೆಂಡ್‌ಗಿಂತ ಕಡಿಮೆ',
	      past: '1 ಸೆಕೆಂಡ್‌ಗಿಂತ ಕಡಿಮೆ'
	    },
	    other: {
	      default: '{{count}} ಸೆಕೆಂಡ್‌ಗಿಂತ ಕಡಿಮೆ',
	      future: '{{count}} ಸೆಕೆಂಡ್‌ಗಿಂತ ಕಡಿಮೆ',
	      past: '{{count}} ಸೆಕೆಂಡ್‌ಗಿಂತ ಕಡಿಮೆ'
	    }
	  },
	  xSeconds: {
	    one: {
	      default: '1 ಸೆಕೆಂಡ್',
	      future: '1 ಸೆಕೆಂಡ್‌ನಲ್ಲಿ',
	      past: '1 ಸೆಕೆಂಡ್ ಹಿಂದೆ'
	    },
	    other: {
	      default: '{{count}} ಸೆಕೆಂಡುಗಳು',
	      future: '{{count}} ಸೆಕೆಂಡ್‌ಗಳಲ್ಲಿ',
	      past: '{{count}} ಸೆಕೆಂಡ್ ಹಿಂದೆ'
	    }
	  },
	  halfAMinute: {
	    other: {
	      default: 'ಅರ್ಧ ನಿಮಿಷ',
	      future: 'ಅರ್ಧ ನಿಮಿಷದಲ್ಲಿ',
	      past: 'ಅರ್ಧ ನಿಮಿಷದ ಹಿಂದೆ'
	    }
	  },
	  lessThanXMinutes: {
	    one: {
	      default: '1 ನಿಮಿಷಕ್ಕಿಂತ ಕಡಿಮೆ',
	      future: '1 ನಿಮಿಷಕ್ಕಿಂತ ಕಡಿಮೆ',
	      past: '1 ನಿಮಿಷಕ್ಕಿಂತ ಕಡಿಮೆ'
	    },
	    other: {
	      default: '{{count}} ನಿಮಿಷಕ್ಕಿಂತ ಕಡಿಮೆ',
	      future: '{{count}} ನಿಮಿಷಕ್ಕಿಂತ ಕಡಿಮೆ',
	      past: '{{count}} ನಿಮಿಷಕ್ಕಿಂತ ಕಡಿಮೆ'
	    }
	  },
	  xMinutes: {
	    one: {
	      default: '1 ನಿಮಿಷ',
	      future: '1 ನಿಮಿಷದಲ್ಲಿ',
	      past: '1 ನಿಮಿಷದ ಹಿಂದೆ'
	    },
	    other: {
	      default: '{{count}} ನಿಮಿಷಗಳು',
	      future: '{{count}} ನಿಮಿಷಗಳಲ್ಲಿ',
	      past: '{{count}} ನಿಮಿಷಗಳ ಹಿಂದೆ'
	    }
	  },
	  aboutXHours: {
	    one: {
	      default: 'ಸುಮಾರು 1 ಗಂಟೆ',
	      future: 'ಸುಮಾರು 1 ಗಂಟೆಯಲ್ಲಿ',
	      past: 'ಸುಮಾರು 1 ಗಂಟೆ ಹಿಂದೆ'
	    },
	    other: {
	      default: 'ಸುಮಾರು {{count}} ಗಂಟೆಗಳು',
	      future: 'ಸುಮಾರು {{count}} ಗಂಟೆಗಳಲ್ಲಿ',
	      past: 'ಸುಮಾರು {{count}} ಗಂಟೆಗಳ ಹಿಂದೆ'
	    }
	  },
	  xHours: {
	    one: {
	      default: '1 ಗಂಟೆ',
	      future: '1 ಗಂಟೆಯಲ್ಲಿ',
	      past: '1 ಗಂಟೆ ಹಿಂದೆ'
	    },
	    other: {
	      default: '{{count}} ಗಂಟೆಗಳು',
	      future: '{{count}} ಗಂಟೆಗಳಲ್ಲಿ',
	      past: '{{count}} ಗಂಟೆಗಳ ಹಿಂದೆ'
	    }
	  },
	  xDays: {
	    one: {
	      default: '1 ದಿನ',
	      future: '1 ದಿನದಲ್ಲಿ',
	      past: '1 ದಿನದ ಹಿಂದೆ'
	    },
	    other: {
	      default: '{{count}} ದಿನಗಳು',
	      future: '{{count}} ದಿನಗಳಲ್ಲಿ',
	      past: '{{count}} ದಿನಗಳ ಹಿಂದೆ'
	    }
	  },
	  aboutXMonths: {
	    one: {
	      default: 'ಸುಮಾರು 1 ತಿಂಗಳು',
	      future: 'ಸುಮಾರು 1 ತಿಂಗಳಲ್ಲಿ',
	      past: 'ಸುಮಾರು 1 ತಿಂಗಳ ಹಿಂದೆ'
	    },
	    other: {
	      default: 'ಸುಮಾರು {{count}} ತಿಂಗಳು',
	      future: 'ಸುಮಾರು {{count}} ತಿಂಗಳುಗಳಲ್ಲಿ',
	      past: 'ಸುಮಾರು {{count}} ತಿಂಗಳುಗಳ ಹಿಂದೆ'
	    }
	  },
	  xMonths: {
	    one: {
	      default: '1 ತಿಂಗಳು',
	      future: '1 ತಿಂಗಳಲ್ಲಿ',
	      past: '1 ತಿಂಗಳ ಹಿಂದೆ'
	    },
	    other: {
	      default: '{{count}} ತಿಂಗಳು',
	      future: '{{count}} ತಿಂಗಳುಗಳಲ್ಲಿ',
	      past: '{{count}} ತಿಂಗಳುಗಳ ಹಿಂದೆ'
	    }
	  },
	  aboutXYears: {
	    one: {
	      default: 'ಸುಮಾರು 1 ವರ್ಷ',
	      future: 'ಸುಮಾರು 1 ವರ್ಷದಲ್ಲಿ',
	      past: 'ಸುಮಾರು 1 ವರ್ಷದ ಹಿಂದೆ'
	    },
	    other: {
	      default: 'ಸುಮಾರು {{count}} ವರ್ಷಗಳು',
	      future: 'ಸುಮಾರು {{count}} ವರ್ಷಗಳಲ್ಲಿ',
	      past: 'ಸುಮಾರು {{count}} ವರ್ಷಗಳ ಹಿಂದೆ'
	    }
	  },
	  xYears: {
	    one: {
	      default: '1 ವರ್ಷ',
	      future: '1 ವರ್ಷದಲ್ಲಿ',
	      past: '1 ವರ್ಷದ ಹಿಂದೆ'
	    },
	    other: {
	      default: '{{count}} ವರ್ಷಗಳು',
	      future: '{{count}} ವರ್ಷಗಳಲ್ಲಿ',
	      past: '{{count}} ವರ್ಷಗಳ ಹಿಂದೆ'
	    }
	  },
	  overXYears: {
	    one: {
	      default: '1 ವರ್ಷದ ಮೇಲೆ',
	      future: '1 ವರ್ಷದ ಮೇಲೆ',
	      past: '1 ವರ್ಷದ ಮೇಲೆ'
	    },
	    other: {
	      default: '{{count}} ವರ್ಷಗಳ ಮೇಲೆ',
	      future: '{{count}} ವರ್ಷಗಳ ಮೇಲೆ',
	      past: '{{count}} ವರ್ಷಗಳ ಮೇಲೆ'
	    }
	  },
	  almostXYears: {
	    one: {
	      default: 'ಬಹುತೇಕ 1 ವರ್ಷದಲ್ಲಿ',
	      future: 'ಬಹುತೇಕ 1 ವರ್ಷದಲ್ಲಿ',
	      past: 'ಬಹುತೇಕ 1 ವರ್ಷದಲ್ಲಿ'
	    },
	    other: {
	      default: 'ಬಹುತೇಕ {{count}} ವರ್ಷಗಳಲ್ಲಿ',
	      future: 'ಬಹುತೇಕ {{count}} ವರ್ಷಗಳಲ್ಲಿ',
	      past: 'ಬಹುತೇಕ {{count}} ವರ್ಷಗಳಲ್ಲಿ'
	    }
	  }
	};
	
	function getResultByTense(parentToken, options) {
	  if (options.addSuffix) {
	    if (options.comparison > 0) {
	      return parentToken.future;
	    } else {
	      return parentToken.past;
	    }
	  }
	
	  return parentToken.default;
	}
	
	function formatDistance(token, count, options) {
	  options = options || {};
	  var result;
	
	  if (typeof formatDistanceLocale[token] === 'string') {
	    result = formatDistanceLocale[token];
	  } else if (count === 1) {
	    result = getResultByTense(formatDistanceLocale[token].one, options);
	  } else {
	    result = getResultByTense(formatDistanceLocale[token].other, options);
	  }
	
	  return result.replace('{{count}}', count);
	}
	
	module.exports = exports.default;

/***/ },
/* 1300 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Reference: https://www.unicode.org/cldr/charts/32/summary/kn.html
	var dateFormats = {
	  full: 'EEEE, MMMM d, y',
	  // CLDR 1816
	  long: 'MMMM d, y',
	  // CLDR 1817
	  medium: 'MMM d, y',
	  // CLDR 1818
	  short: 'd/M/yy' // CLDR 1819
	
	};
	var timeFormats = {
	  full: 'hh:mm:ss a zzzz',
	  // CLDR 1820
	  long: 'hh:mm:ss a z',
	  // CLDR 1821
	  medium: 'hh:mm:ss a',
	  // CLDR 1822
	  short: 'hh:mm a' // CLDR 1823
	
	};
	var dateTimeFormats = {
	  full: '{{date}} {{time}}',
	  // CLDR 1824
	  long: '{{date}} {{time}}',
	  // CLDR 1825
	  medium: '{{date}} {{time}}',
	  // CLDR 1826
	  short: '{{date}} {{time}}' // CLDR 1827
	
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1301 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRelative;
	var formatRelativeLocale = {
	  lastWeek: "'ಕಳೆದ' eeee p 'ಕ್ಕೆ'",
	  yesterday: "'ನಿನ್ನೆ' p 'ಕ್ಕೆ'",
	  today: "'ಇಂದು' p 'ಕ್ಕೆ'",
	  tomorrow: "'ನಾಳೆ' p 'ಕ್ಕೆ'",
	  nextWeek: "eeee p 'ಕ್ಕೆ'",
	  other: 'P'
	};
	
	function formatRelative(token, _date, _baseDate, _options) {
	  return formatRelativeLocale[token];
	}
	
	module.exports = exports.default;

/***/ },
/* 1302 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Reference: https://www.unicode.org/cldr/charts/32/summary/kn.html
	var eraValues = {
	  narrow: ['ಕ್ರಿ.ಪೂ', 'ಕ್ರಿ.ಶ'],
	  abbreviated: ['ಕ್ರಿ.ಪೂ', 'ಕ್ರಿ.ಶ'],
	  // CLDR #1618, #1620
	  wide: ['ಕ್ರಿಸ್ತ ಪೂರ್ವ', 'ಕ್ರಿಸ್ತ ಶಕ'] // CLDR #1614, #1616
	
	};
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['ತ್ರೈ 1', 'ತ್ರೈ 2', 'ತ್ರೈ 3', 'ತ್ರೈ 4'],
	  // CLDR #1630 - #1638
	  wide: ['1ನೇ ತ್ರೈಮಾಸಿಕ', '2ನೇ ತ್ರೈಮಾಸಿಕ', '3ನೇ ತ್ರೈಮಾಸಿಕ', '4ನೇ ತ್ರೈಮಾಸಿಕ'] // CLDR #1622 - #1629
	
	}; // CLDR #1646 - #1717
	
	var monthValues = {
	  narrow: ['ಜ', 'ಫೆ', 'ಮಾ', 'ಏ', 'ಮೇ', 'ಜೂ', 'ಜು', 'ಆ', 'ಸೆ', 'ಅ', 'ನ', 'ಡಿ'],
	  abbreviated: ['ಜನ', 'ಫೆಬ್ರ', 'ಮಾರ್ಚ್', 'ಏಪ್ರಿ', 'ಮೇ', 'ಜೂನ್', 'ಜುಲೈ', 'ಆಗ', 'ಸೆಪ್ಟೆಂ', 'ಅಕ್ಟೋ', 'ನವೆಂ', 'ಡಿಸೆಂ'],
	  wide: ['ಜನವರಿ', 'ಫೆಬ್ರವರಿ', 'ಮಾರ್ಚ್', 'ಏಪ್ರಿಲ್', 'ಮೇ', 'ಜೂನ್', 'ಜುಲೈ', 'ಆಗಸ್ಟ್', 'ಸೆಪ್ಟೆಂಬರ್', 'ಅಕ್ಟೋಬರ್', 'ನವೆಂಬರ್', 'ಡಿಸೆಂಬರ್']
	}; // CLDR #1718 - #1773
	
	var dayValues = {
	  narrow: ['ಭಾ', 'ಸೋ', 'ಮಂ', 'ಬು', 'ಗು', 'ಶು', 'ಶ'],
	  short: ['ಭಾನು', 'ಸೋಮ', 'ಮಂಗಳ', 'ಬುಧ', 'ಗುರು', 'ಶುಕ್ರ', 'ಶನಿ'],
	  abbreviated: ['ಭಾನು', 'ಸೋಮ', 'ಮಂಗಳ', 'ಬುಧ', 'ಗುರು', 'ಶುಕ್ರ', 'ಶನಿ'],
	  wide: ['ಭಾನುವಾರ', 'ಸೋಮವಾರ', 'ಮಂಗಳವಾರ', 'ಬುಧವಾರ', 'ಗುರುವಾರ', 'ಶುಕ್ರವಾರ', 'ಶನಿವಾರ']
	}; // CLDR #1774 - #1815
	
	var dayPeriodValues = {
	  narrow: {
	    am: 'ಪೂರ್ವಾಹ್ನ',
	    pm: 'ಅಪರಾಹ್ನ',
	    midnight: 'ಮಧ್ಯರಾತ್ರಿ',
	    noon: 'ಮಧ್ಯಾಹ್ನ',
	    morning: 'ಬೆಳಗ್ಗೆ',
	    afternoon: 'ಮಧ್ಯಾಹ್ನ',
	    evening: 'ಸಂಜೆ',
	    night: 'ರಾತ್ರಿ'
	  },
	  abbreviated: {
	    am: 'ಪೂರ್ವಾಹ್ನ',
	    pm: 'ಅಪರಾಹ್ನ',
	    midnight: 'ಮಧ್ಯರಾತ್ರಿ',
	    noon: 'ಮಧ್ಯಾನ್ಹ',
	    morning: 'ಬೆಳಗ್ಗೆ',
	    afternoon: 'ಮಧ್ಯಾನ್ಹ',
	    evening: 'ಸಂಜೆ',
	    night: 'ರಾತ್ರಿ'
	  },
	  wide: {
	    am: 'ಪೂರ್ವಾಹ್ನ',
	    pm: 'ಅಪರಾಹ್ನ',
	    midnight: 'ಮಧ್ಯರಾತ್ರಿ',
	    noon: 'ಮಧ್ಯಾನ್ಹ',
	    morning: 'ಬೆಳಗ್ಗೆ',
	    afternoon: 'ಮಧ್ಯಾನ್ಹ',
	    evening: 'ಸಂಜೆ',
	    night: 'ರಾತ್ರಿ'
	  }
	};
	var formattingDayPeriodValues = {
	  narrow: {
	    am: 'ಪೂ',
	    pm: 'ಅ',
	    midnight: 'ಮಧ್ಯರಾತ್ರಿ',
	    noon: 'ಮಧ್ಯಾನ್ಹ',
	    morning: 'ಬೆಳಗ್ಗೆ',
	    afternoon: 'ಮಧ್ಯಾನ್ಹ',
	    evening: 'ಸಂಜೆ',
	    night: 'ರಾತ್ರಿ'
	  },
	  abbreviated: {
	    am: 'ಪೂರ್ವಾಹ್ನ',
	    pm: 'ಅಪರಾಹ್ನ',
	    midnight: 'ಮಧ್ಯ ರಾತ್ರಿ',
	    noon: 'ಮಧ್ಯಾನ್ಹ',
	    morning: 'ಬೆಳಗ್ಗೆ',
	    afternoon: 'ಮಧ್ಯಾನ್ಹ',
	    evening: 'ಸಂಜೆ',
	    night: 'ರಾತ್ರಿ'
	  },
	  wide: {
	    am: 'ಪೂರ್ವಾಹ್ನ',
	    pm: 'ಅಪರಾಹ್ನ',
	    midnight: 'ಮಧ್ಯ ರಾತ್ರಿ',
	    noon: 'ಮಧ್ಯಾನ್ಹ',
	    morning: 'ಬೆಳಗ್ಗೆ',
	    afternoon: 'ಮಧ್ಯಾನ್ಹ',
	    evening: 'ಸಂಜೆ',
	    night: 'ರಾತ್ರಿ'
	  }
	};
	
	function ordinalNumber(dirtyNumber, _dirtyOptions) {
	  var number = Number(dirtyNumber);
	  return number + 'ನೇ';
	}
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingDayPeriodValues,
	    defaultFormattingWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1303 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(15));
	
	var _index2 = _interopRequireDefault(__webpack_require__(14));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(\d+)(ನೇ|ನೆ)?/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^(ಕ್ರಿ.ಪೂ|ಕ್ರಿ.ಶ)/i,
	  abbreviated: /^(ಕ್ರಿ\.?\s?ಪೂ\.?|ಕ್ರಿ\.?\s?ಶ\.?|ಪ್ರ\.?\s?ಶ\.?)/i,
	  wide: /^(ಕ್ರಿಸ್ತ ಪೂರ್ವ|ಕ್ರಿಸ್ತ ಶಕ|ಪ್ರಸಕ್ತ ಶಕ)/i
	};
	var parseEraPatterns = {
	  any: [/^ಪೂ/i, /^(ಶ|ಪ್ರ)/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^ತ್ರೈ[1234]|ತ್ರೈ [1234]| [1234]ತ್ರೈ/i,
	  wide: /^[1234](ನೇ)? ತ್ರೈಮಾಸಿಕ/i
	};
	var parseQuarterPatterns = {
	  any: [/1/i, /2/i, /3/i, /4/i]
	};
	var matchMonthPatterns = {
	  narrow: /^(ಜೂ|ಜು|ಜ|ಫೆ|ಮಾ|ಏ|ಮೇ|ಆ|ಸೆ|ಅ|ನ|ಡಿ)/i,
	  abbreviated: /^(ಜನ|ಫೆಬ್ರ|ಮಾರ್ಚ್|ಏಪ್ರಿ|ಮೇ|ಜೂನ್|ಜುಲೈ|ಆಗ|ಸೆಪ್ಟೆಂ|ಅಕ್ಟೋ|ನವೆಂ|ಡಿಸೆಂ)/i,
	  wide: /^(ಜನವರಿ|ಫೆಬ್ರವರಿ|ಮಾರ್ಚ್|ಏಪ್ರಿಲ್|ಮೇ|ಜೂನ್|ಜುಲೈ|ಆಗಸ್ಟ್|ಸೆಪ್ಟೆಂಬರ್|ಅಕ್ಟೋಬರ್|ನವೆಂಬರ್|ಡಿಸೆಂಬರ್)/i
	};
	var parseMonthPatterns = {
	  narrow: [/^ಜ$/i, /^ಫೆ/i, /^ಮಾ/i, /^ಏ/i, /^ಮೇ/i, /^ಜೂ/i, /^ಜು$/i, /^ಆ/i, /^ಸೆ/i, /^ಅ/i, /^ನ/i, /^ಡಿ/i],
	  any: [/^ಜನ/i, /^ಫೆ/i, /^ಮಾ/i, /^ಏ/i, /^ಮೇ/i, /^ಜೂನ್/i, /^ಜುಲೈ/i, /^ಆ/i, /^ಸೆ/i, /^ಅ/i, /^ನ/i, /^ಡಿ/i]
	};
	var matchDayPatterns = {
	  narrow: /^(ಭಾ|ಸೋ|ಮ|ಬು|ಗು|ಶು|ಶ)/i,
	  short: /^(ಭಾನು|ಸೋಮ|ಮಂಗಳ|ಬುಧ|ಗುರು|ಶುಕ್ರ|ಶನಿ)/i,
	  abbreviated: /^(ಭಾನು|ಸೋಮ|ಮಂಗಳ|ಬುಧ|ಗುರು|ಶುಕ್ರ|ಶನಿ)/i,
	  wide: /^(ಭಾನುವಾರ|ಸೋಮವಾರ|ಮಂಗಳವಾರ|ಬುಧವಾರ|ಗುರುವಾರ|ಶುಕ್ರವಾರ|ಶನಿವಾರ)/i
	};
	var parseDayPatterns = {
	  narrow: [/^ಭಾ/i, /^ಸೋ/i, /^ಮ/i, /^ಬು/i, /^ಗು/i, /^ಶು/i, /^ಶ/i],
	  any: [/^ಭಾ/i, /^ಸೋ/i, /^ಮ/i, /^ಬು/i, /^ಗು/i, /^ಶು/i, /^ಶ/i]
	};
	var matchDayPeriodPatterns = {
	  narrow: /^(ಪೂ|ಅ|ಮಧ್ಯರಾತ್ರಿ|ಮಧ್ಯಾನ್ಹ|ಬೆಳಗ್ಗೆ|ಸಂಜೆ|ರಾತ್ರಿ)/i,
	  any: /^(ಪೂರ್ವಾಹ್ನ|ಅಪರಾಹ್ನ|ಮಧ್ಯರಾತ್ರಿ|ಮಧ್ಯಾನ್ಹ|ಬೆಳಗ್ಗೆ|ಸಂಜೆ|ರಾತ್ರಿ)/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^ಪೂ/i,
	    pm: /^ಅ/i,
	    midnight: /ಮಧ್ಯರಾತ್ರಿ/i,
	    noon: /ಮಧ್ಯಾನ್ಹ/i,
	    morning: /ಬೆಳಗ್ಗೆ/i,
	    afternoon: /ಮಧ್ಯಾನ್ಹ/i,
	    evening: /ಸಂಜೆ/i,
	    night: /ರಾತ್ರಿ/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index2.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index2.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index2.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index2.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index2.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1304 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1299));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1300));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1301));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1302));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1303));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Kannada locale (India).
	 * @language Kannada
	 * @iso-639-2 kan
	 * @author Manjunatha Gouli [@developergouli]{@link https://github.com/developergouli}
	 */
	var locale = {
	  code: 'kn',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 1
	    /* Monday */
	    ,
	    firstWeekContainsDate: 1
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1305 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    one: '1초 미만',
	    other: '{{count}}초 미만'
	  },
	  xSeconds: {
	    one: '1초',
	    other: '{{count}}초'
	  },
	  halfAMinute: '30초',
	  lessThanXMinutes: {
	    one: '1분 미만',
	    other: '{{count}}분 미만'
	  },
	  xMinutes: {
	    one: '1분',
	    other: '{{count}}분'
	  },
	  aboutXHours: {
	    one: '약 1시간',
	    other: '약 {{count}}시간'
	  },
	  xHours: {
	    one: '1시간',
	    other: '{{count}}시간'
	  },
	  xDays: {
	    one: '1일',
	    other: '{{count}}일'
	  },
	  aboutXWeeks: {
	    one: '약 1주',
	    other: '약 {{count}}주'
	  },
	  xWeeks: {
	    one: '1주',
	    other: '{{count}}주'
	  },
	  aboutXMonths: {
	    one: '약 1개월',
	    other: '약 {{count}}개월'
	  },
	  xMonths: {
	    one: '1개월',
	    other: '{{count}}개월'
	  },
	  aboutXYears: {
	    one: '약 1년',
	    other: '약 {{count}}년'
	  },
	  xYears: {
	    one: '1년',
	    other: '{{count}}년'
	  },
	  overXYears: {
	    one: '1년 이상',
	    other: '{{count}}년 이상'
	  },
	  almostXYears: {
	    one: '거의 1년',
	    other: '거의 {{count}}년'
	  }
	};
	
	var formatDistance = function (token, count, options) {
	  var result;
	  var tokenValue = formatDistanceLocale[token];
	
	  if (typeof tokenValue === 'string') {
	    result = tokenValue;
	  } else if (count === 1) {
	    result = tokenValue.one;
	  } else {
	    result = tokenValue.other.replace('{{count}}', count.toString());
	  }
	
	  if (options !== null && options !== void 0 && options.addSuffix) {
	    if (options.comparison && options.comparison > 0) {
	      return result + ' 후';
	    } else {
	      return result + ' 전';
	    }
	  }
	
	  return result;
	};
	
	var _default = formatDistance;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1306 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: 'y년 M월 d일 EEEE',
	  long: 'y년 M월 d일',
	  medium: 'y.MM.dd',
	  short: 'y.MM.dd'
	};
	var timeFormats = {
	  full: 'a H시 mm분 ss초 zzzz',
	  long: 'a H:mm:ss z',
	  medium: 'HH:mm:ss',
	  short: 'HH:mm'
	};
	var dateTimeFormats = {
	  full: '{{date}} {{time}}',
	  long: '{{date}} {{time}}',
	  medium: '{{date}} {{time}}',
	  short: '{{date}} {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1307 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var formatRelativeLocale = {
	  lastWeek: "'지난' eeee p",
	  yesterday: "'어제' p",
	  today: "'오늘' p",
	  tomorrow: "'내일' p",
	  nextWeek: "'다음' eeee p",
	  other: 'P'
	};
	
	var formatRelative = function (token, _date, _baseDate, _options) {
	  return formatRelativeLocale[token];
	};
	
	var _default = formatRelative;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1308 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eraValues = {
	  narrow: ['BC', 'AD'],
	  abbreviated: ['BC', 'AD'],
	  wide: ['기원전', '서기']
	};
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
	  wide: ['1분기', '2분기', '3분기', '4분기']
	};
	var monthValues = {
	  narrow: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
	  abbreviated: ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'],
	  wide: ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월']
	};
	var dayValues = {
	  narrow: ['일', '월', '화', '수', '목', '금', '토'],
	  short: ['일', '월', '화', '수', '목', '금', '토'],
	  abbreviated: ['일', '월', '화', '수', '목', '금', '토'],
	  wide: ['일요일', '월요일', '화요일', '수요일', '목요일', '금요일', '토요일']
	};
	var dayPeriodValues = {
	  narrow: {
	    am: '오전',
	    pm: '오후',
	    midnight: '자정',
	    noon: '정오',
	    morning: '아침',
	    afternoon: '오후',
	    evening: '저녁',
	    night: '밤'
	  },
	  abbreviated: {
	    am: '오전',
	    pm: '오후',
	    midnight: '자정',
	    noon: '정오',
	    morning: '아침',
	    afternoon: '오후',
	    evening: '저녁',
	    night: '밤'
	  },
	  wide: {
	    am: '오전',
	    pm: '오후',
	    midnight: '자정',
	    noon: '정오',
	    morning: '아침',
	    afternoon: '오후',
	    evening: '저녁',
	    night: '밤'
	  }
	};
	var formattingDayPeriodValues = {
	  narrow: {
	    am: '오전',
	    pm: '오후',
	    midnight: '자정',
	    noon: '정오',
	    morning: '아침',
	    afternoon: '오후',
	    evening: '저녁',
	    night: '밤'
	  },
	  abbreviated: {
	    am: '오전',
	    pm: '오후',
	    midnight: '자정',
	    noon: '정오',
	    morning: '아침',
	    afternoon: '오후',
	    evening: '저녁',
	    night: '밤'
	  },
	  wide: {
	    am: '오전',
	    pm: '오후',
	    midnight: '자정',
	    noon: '정오',
	    morning: '아침',
	    afternoon: '오후',
	    evening: '저녁',
	    night: '밤'
	  }
	};
	
	var ordinalNumber = function (dirtyNumber, dirtyOptions) {
	  var number = Number(dirtyNumber);
	  var options = dirtyOptions || {};
	  var unit = String(options.unit);
	
	  switch (unit) {
	    case 'minute':
	    case 'second':
	      return String(number);
	
	    case 'date':
	      return number + '일';
	
	    default:
	      return number + '번째';
	  }
	};
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return quarter - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingDayPeriodValues,
	    defaultFormattingWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1309 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(14));
	
	var _index2 = _interopRequireDefault(__webpack_require__(15));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(\d+)(일|번째)?/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
	  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
	  wide: /^(기원전|서기)/i
	};
	var parseEraPatterns = {
	  any: [/^(bc|기원전)/i, /^(ad|서기)/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^q[1234]/i,
	  wide: /^[1234]사?분기/i
	};
	var parseQuarterPatterns = {
	  any: [/1/i, /2/i, /3/i, /4/i]
	};
	var matchMonthPatterns = {
	  narrow: /^(1[012]|[123456789])/,
	  abbreviated: /^(1[012]|[123456789])월/i,
	  wide: /^(1[012]|[123456789])월/i
	};
	var parseMonthPatterns = {
	  any: [/^1월?$/, /^2/, /^3/, /^4/, /^5/, /^6/, /^7/, /^8/, /^9/, /^10/, /^11/, /^12/]
	};
	var matchDayPatterns = {
	  narrow: /^[일월화수목금토]/,
	  short: /^[일월화수목금토]/,
	  abbreviated: /^[일월화수목금토]/,
	  wide: /^[일월화수목금토]요일/
	};
	var parseDayPatterns = {
	  any: [/^일/, /^월/, /^화/, /^수/, /^목/, /^금/, /^토/]
	};
	var matchDayPeriodPatterns = {
	  any: /^(am|pm|오전|오후|자정|정오|아침|저녁|밤)/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^(am|오전)/i,
	    pm: /^(pm|오후)/i,
	    midnight: /^자정/i,
	    noon: /^정오/i,
	    morning: /^아침/i,
	    afternoon: /^오후/i,
	    evening: /^저녁/i,
	    night: /^밤/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index2.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1310 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1305));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1306));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1307));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1308));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1309));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Korean locale.
	 * @language Korean
	 * @iso-639-2 kor
	 * @author Hong Chulju [@angdev]{@link https://github.com/angdev}
	 * @author Lee Seoyoen [@iamssen]{@link https://github.com/iamssen}
	 * @author Taiki IKeda [@so99ynoodles]{@link https://github.com/so99ynoodles}
	 */
	var locale = {
	  code: 'ko',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 0
	    /* Sunday */
	    ,
	    firstWeekContainsDate: 1
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1311 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistance;
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    standalone: {
	      one: 'manner wéi eng Sekonn',
	      other: 'manner wéi {{count}} Sekonnen'
	    },
	    withPreposition: {
	      one: 'manner wéi enger Sekonn',
	      other: 'manner wéi {{count}} Sekonnen'
	    }
	  },
	  xSeconds: {
	    standalone: {
	      one: 'eng Sekonn',
	      other: '{{count}} Sekonnen'
	    },
	    withPreposition: {
	      one: 'enger Sekonn',
	      other: '{{count}} Sekonnen'
	    }
	  },
	  halfAMinute: {
	    standalone: 'eng hallef Minutt',
	    withPreposition: 'enger hallwer Minutt'
	  },
	  lessThanXMinutes: {
	    standalone: {
	      one: 'manner wéi eng Minutt',
	      other: 'manner wéi {{count}} Minutten'
	    },
	    withPreposition: {
	      one: 'manner wéi enger Minutt',
	      other: 'manner wéi {{count}} Minutten'
	    }
	  },
	  xMinutes: {
	    standalone: {
	      one: 'eng Minutt',
	      other: '{{count}} Minutten'
	    },
	    withPreposition: {
	      one: 'enger Minutt',
	      other: '{{count}} Minutten'
	    }
	  },
	  aboutXHours: {
	    standalone: {
	      one: 'ongeféier eng Stonn',
	      other: 'ongeféier {{count}} Stonnen'
	    },
	    withPreposition: {
	      one: 'ongeféier enger Stonn',
	      other: 'ongeféier {{count}} Stonnen'
	    }
	  },
	  xHours: {
	    standalone: {
	      one: 'eng Stonn',
	      other: '{{count}} Stonnen'
	    },
	    withPreposition: {
	      one: 'enger Stonn',
	      other: '{{count}} Stonnen'
	    }
	  },
	  xDays: {
	    standalone: {
	      one: 'een Dag',
	      other: '{{count}} Deeg'
	    },
	    withPreposition: {
	      one: 'engem Dag',
	      other: '{{count}} Deeg'
	    }
	  },
	  aboutXWeeks: {
	    standalone: {
	      one: 'ongeféier eng Woch',
	      other: 'ongeféier {{count}} Wochen'
	    },
	    withPreposition: {
	      one: 'ongeféier enger Woche',
	      other: 'ongeféier {{count}} Wochen'
	    }
	  },
	  xWeeks: {
	    standalone: {
	      one: 'eng Woch',
	      other: '{{count}} Wochen'
	    },
	    withPreposition: {
	      one: 'enger Woch',
	      other: '{{count}} Wochen'
	    }
	  },
	  aboutXMonths: {
	    standalone: {
	      one: 'ongeféier ee Mount',
	      other: 'ongeféier {{count}} Méint'
	    },
	    withPreposition: {
	      one: 'ongeféier engem Mount',
	      other: 'ongeféier {{count}} Méint'
	    }
	  },
	  xMonths: {
	    standalone: {
	      one: 'ee Mount',
	      other: '{{count}} Méint'
	    },
	    withPreposition: {
	      one: 'engem Mount',
	      other: '{{count}} Méint'
	    }
	  },
	  aboutXYears: {
	    standalone: {
	      one: 'ongeféier ee Joer',
	      other: 'ongeféier {{count}} Joer'
	    },
	    withPreposition: {
	      one: 'ongeféier engem Joer',
	      other: 'ongeféier {{count}} Joer'
	    }
	  },
	  xYears: {
	    standalone: {
	      one: 'ee Joer',
	      other: '{{count}} Joer'
	    },
	    withPreposition: {
	      one: 'engem Joer',
	      other: '{{count}} Joer'
	    }
	  },
	  overXYears: {
	    standalone: {
	      one: 'méi wéi ee Joer',
	      other: 'méi wéi {{count}} Joer'
	    },
	    withPreposition: {
	      one: 'méi wéi engem Joer',
	      other: 'méi wéi {{count}} Joer'
	    }
	  },
	  almostXYears: {
	    standalone: {
	      one: 'bal ee Joer',
	      other: 'bal {{count}} Joer'
	    },
	    withPreposition: {
	      one: 'bal engem Joer',
	      other: 'bal {{count}} Joer'
	    }
	  }
	};
	var EXCEPTION_CONSONANTS = ['d', 'h', 'n', 't', 'z'];
	var VOWELS = ['a,', 'e', 'i', 'o', 'u'];
	var DIGITS_SPOKEN_N_NEEDED = [0, 1, 2, 3, 8, 9];
	var FIRST_TWO_DIGITS_SPOKEN_NO_N_NEEDED = [40, 50, 60, 70]; // Eifeler Regel
	
	function isFinalNNeeded(nextWords) {
	  var firstLetter = nextWords.charAt(0).toLowerCase();
	
	  if (VOWELS.indexOf(firstLetter) != -1 || EXCEPTION_CONSONANTS.indexOf(firstLetter) != -1) {
	    return true;
	  } // Numbers would need to converted into words for checking.
	  // Therefore, I have listed the digits that require a preceeding n with a few exceptions.
	
	
	  var firstWord = nextWords.split(' ')[0];
	  var number = parseInt(firstWord);
	
	  if (!isNaN(number) && DIGITS_SPOKEN_N_NEEDED.indexOf(number % 10) != -1 && FIRST_TWO_DIGITS_SPOKEN_NO_N_NEEDED.indexOf(parseInt(firstWord.substring(0, 2))) == -1) {
	    return true;
	  } // Omit other checks as they are not expected here.
	
	
	  return false;
	}
	
	function formatDistance(token, count, options) {
	  options = options || {};
	  var usageGroup = options.addSuffix ? formatDistanceLocale[token].withPreposition : formatDistanceLocale[token].standalone;
	  var result;
	
	  if (typeof usageGroup === 'string') {
	    result = usageGroup;
	  } else if (count === 1) {
	    result = usageGroup.one;
	  } else {
	    result = usageGroup.other.replace('{{count}}', count);
	  }
	
	  if (options.addSuffix) {
	    if (options.comparison > 0) {
	      return 'a' + (isFinalNNeeded(result) ? 'n' : '') + ' ' + result;
	    } else {
	      return 'viru' + (isFinalNNeeded(result) ? 'n' : '') + ' ' + result;
	    }
	  }
	
	  return result;
	}
	
	module.exports = exports.default;

/***/ },
/* 1312 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// DIN 5008: https://de.wikipedia.org/wiki/Datumsformat#DIN_5008
	var dateFormats = {
	  full: 'EEEE, do MMMM y',
	  // Méindeg, 7. Januar 2018
	  long: 'do MMMM y',
	  // 7. Januar 2018
	  medium: 'do MMM y',
	  // 7. Jan 2018
	  short: 'dd.MM.yy' // 07.01.18
	
	};
	var timeFormats = {
	  full: 'HH:mm:ss zzzz',
	  long: 'HH:mm:ss z',
	  medium: 'HH:mm:ss',
	  short: 'HH:mm'
	};
	var dateTimeFormats = {
	  full: "{{date}} 'um' {{time}}",
	  long: "{{date}} 'um' {{time}}",
	  medium: '{{date}} {{time}}',
	  short: '{{date}} {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1313 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRelative;
	var formatRelativeLocale = {
	  lastWeek: function (date) {
	    var day = date.getUTCDay();
	    var result = "'läschte";
	
	    if (day === 2 || day === 4) {
	      // Eifeler Regel: Add an n before the consonant d; Here "Dënschdeg" "and Donneschde".
	      result += 'n';
	    }
	
	    result += "' eeee 'um' p";
	    return result;
	  },
	  yesterday: "'gëschter um' p",
	  today: "'haut um' p",
	  tomorrow: "'moien um' p",
	  nextWeek: "eeee 'um' p",
	  other: 'P'
	};
	
	function formatRelative(token, date, _baseDate, _options) {
	  var format = formatRelativeLocale[token];
	
	  if (typeof format === 'function') {
	    return format(date);
	  }
	
	  return format;
	}
	
	module.exports = exports.default;

/***/ },
/* 1314 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eraValues = {
	  narrow: ['v.Chr.', 'n.Chr.'],
	  abbreviated: ['v.Chr.', 'n.Chr.'],
	  wide: ['viru Christus', 'no Christus']
	};
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
	  wide: ['1. Quartal', '2. Quartal', '3. Quartal', '4. Quartal']
	};
	var monthValues = {
	  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
	  abbreviated: ['Jan', 'Feb', 'Mäe', 'Abr', 'Mee', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'],
	  wide: ['Januar', 'Februar', 'Mäerz', 'Abrëll', 'Mee', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember']
	};
	var dayValues = {
	  narrow: ['S', 'M', 'D', 'M', 'D', 'F', 'S'],
	  short: ['So', 'Mé', 'Dë', 'Më', 'Do', 'Fr', 'Sa'],
	  abbreviated: ['So.', 'Mé.', 'Dë.', 'Më.', 'Do.', 'Fr.', 'Sa.'],
	  wide: ['Sonndeg', 'Méindeg', 'Dënschdeg', 'Mëttwoch', 'Donneschdeg', 'Freideg', 'Samschdeg']
	};
	var dayPeriodValues = {
	  narrow: {
	    am: 'mo.',
	    pm: 'nomë.',
	    midnight: 'Mëtternuecht',
	    noon: 'Mëtteg',
	    morning: 'Moien',
	    afternoon: 'Nomëtteg',
	    evening: 'Owend',
	    night: 'Nuecht'
	  },
	  abbreviated: {
	    am: 'moies',
	    pm: 'nomëttes',
	    midnight: 'Mëtternuecht',
	    noon: 'Mëtteg',
	    morning: 'Moien',
	    afternoon: 'Nomëtteg',
	    evening: 'Owend',
	    night: 'Nuecht'
	  },
	  wide: {
	    am: 'moies',
	    pm: 'nomëttes',
	    midnight: 'Mëtternuecht',
	    noon: 'Mëtteg',
	    morning: 'Moien',
	    afternoon: 'Nomëtteg',
	    evening: 'Owend',
	    night: 'Nuecht'
	  }
	};
	var formattingDayPeriodValues = {
	  narrow: {
	    am: 'mo.',
	    pm: 'nom.',
	    midnight: 'Mëtternuecht',
	    noon: 'mëttes',
	    morning: 'moies',
	    afternoon: 'nomëttes',
	    evening: 'owes',
	    night: 'nuets'
	  },
	  abbreviated: {
	    am: 'moies',
	    pm: 'nomëttes',
	    midnight: 'Mëtternuecht',
	    noon: 'mëttes',
	    morning: 'moies',
	    afternoon: 'nomëttes',
	    evening: 'owes',
	    night: 'nuets'
	  },
	  wide: {
	    am: 'moies',
	    pm: 'nomëttes',
	    midnight: 'Mëtternuecht',
	    noon: 'mëttes',
	    morning: 'moies',
	    afternoon: 'nomëttes',
	    evening: 'owes',
	    night: 'nuets'
	  }
	};
	
	function ordinalNumber(dirtyNumber, _dirtyOptions) {
	  var number = Number(dirtyNumber);
	  return number + '.';
	}
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingDayPeriodValues,
	    defaultFormattingWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1315 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(15));
	
	var _index2 = _interopRequireDefault(__webpack_require__(14));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(\d+)(\.)?/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
	  abbreviated: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
	  wide: /^(viru Christus|virun eiser Zäitrechnung|no Christus|eiser Zäitrechnung)/i
	};
	var parseEraPatterns = {
	  any: [/^v/i, /^n/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^q[1234]/i,
	  wide: /^[1234](\.)? Quartal/i
	};
	var parseQuarterPatterns = {
	  any: [/1/i, /2/i, /3/i, /4/i]
	};
	var matchMonthPatterns = {
	  narrow: /^[jfmasond]/i,
	  abbreviated: /^(jan|feb|mäe|abr|mee|jun|jul|aug|sep|okt|nov|dez)/i,
	  wide: /^(januar|februar|mäerz|abrëll|mee|juni|juli|august|september|oktober|november|dezember)/i
	};
	var parseMonthPatterns = {
	  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
	  any: [/^ja/i, /^f/i, /^mä/i, /^ab/i, /^me/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
	};
	var matchDayPatterns = {
	  narrow: /^[smdf]/i,
	  short: /^(so|mé|dë|më|do|fr|sa)/i,
	  abbreviated: /^(son?|méi?|dën?|mët?|don?|fre?|sam?)\.?/i,
	  wide: /^(sonndeg|méindeg|dënschdeg|mëttwoch|donneschdeg|freideg|samschdeg)/i
	};
	var parseDayPatterns = {
	  any: [/^so/i, /^mé/i, /^dë/i, /^më/i, /^do/i, /^f/i, /^sa/i]
	};
	var matchDayPeriodPatterns = {
	  narrow: /^(mo\.?|nomë\.?|Mëtternuecht|mëttes|moies|nomëttes|owes|nuets)/i,
	  abbreviated: /^(moi\.?|nomët\.?|Mëtternuecht|mëttes|moies|nomëttes|owes|nuets)/i,
	  wide: /^(moies|nomëttes|Mëtternuecht|mëttes|moies|nomëttes|owes|nuets)/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^m/i,
	    pm: /^n/i,
	    midnight: /^Mëtter/i,
	    noon: /^mëttes/i,
	    morning: /moies/i,
	    afternoon: /nomëttes/i,
	    // will never be matched. Afternoon is matched by `pm`
	    evening: /owes/i,
	    night: /nuets/i // will never be matched. Night is matched by `pm`
	
	  }
	};
	var match = {
	  ordinalNumber: (0, _index.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index2.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index2.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index2.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index2.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index2.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1316 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1311));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1312));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1313));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1314));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1315));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Luxembourgish locale.
	 * @language Luxembourgish
	 * @iso-639-2 ltz
	 * @author Daniel Waxweiler [@dwaxweiler]{@link https://github.com/dwaxweiler}
	 */
	var locale = {
	  code: 'lb',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 1
	    /* Monday */
	    ,
	    firstWeekContainsDate: 4
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1317 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistance;
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    one: translateSeconds,
	    other: translate
	  },
	  xSeconds: {
	    one: translateSeconds,
	    other: translate
	  },
	  halfAMinute: 'pusė minutės',
	  lessThanXMinutes: {
	    one: translateSingular,
	    other: translate
	  },
	  xMinutes: {
	    one: translateSingular,
	    other: translate
	  },
	  aboutXHours: {
	    one: translateSingular,
	    other: translate
	  },
	  xHours: {
	    one: translateSingular,
	    other: translate
	  },
	  xDays: {
	    one: translateSingular,
	    other: translate
	  },
	  aboutWeeks: {
	    one: translateSingular,
	    other: translate
	  },
	  xWeeks: {
	    one: translateSingular,
	    other: translate
	  },
	  aboutXMonths: {
	    one: translateSingular,
	    other: translate
	  },
	  xMonths: {
	    one: translateSingular,
	    other: translate
	  },
	  aboutXYears: {
	    one: translateSingular,
	    other: translate
	  },
	  xYears: {
	    one: translateSingular,
	    other: translate
	  },
	  overXYears: {
	    one: translateSingular,
	    other: translate
	  },
	  almostXYears: {
	    one: translateSingular,
	    other: translate
	  }
	};
	var translations = {
	  xseconds_other: 'sekundė_sekundžių_sekundes',
	  xminutes_one: 'minutė_minutės_minutę',
	  xminutes_other: 'minutės_minučių_minutes',
	  xhours_one: 'valanda_valandos_valandą',
	  xhours_other: 'valandos_valandų_valandas',
	  xdays_one: 'diena_dienos_dieną',
	  xdays_other: 'dienos_dienų_dienas',
	  xweeks_one: 'savaitė_savaitės_savaitę',
	  xweeks_other: 'savaitės_savaičių_savaites',
	  xmonths_one: 'mėnuo_mėnesio_mėnesį',
	  xmonths_other: 'mėnesiai_mėnesių_mėnesius',
	  xyears_one: 'metai_metų_metus',
	  xyears_other: 'metai_metų_metus',
	  about: 'apie',
	  over: 'daugiau nei',
	  almost: 'beveik',
	  lessthan: 'mažiau nei'
	};
	
	function translateSeconds(number, addSuffix, key, isFuture) {
	  if (!addSuffix) {
	    return 'kelios sekundės';
	  } else {
	    return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
	  }
	}
	
	function translateSingular(number, addSuffix, key, isFuture) {
	  return !addSuffix ? forms(key)[0] : isFuture ? forms(key)[1] : forms(key)[2];
	}
	
	function special(number) {
	  return number % 10 === 0 || number > 10 && number < 20;
	}
	
	function forms(key) {
	  return translations[key].split('_');
	}
	
	function translate(number, addSuffix, key, isFuture) {
	  var result = number + ' ';
	
	  if (number === 1) {
	    return result + translateSingular(number, addSuffix, key[0], isFuture);
	  } else if (!addSuffix) {
	    return result + (special(number) ? forms(key)[1] : forms(key)[0]);
	  } else {
	    if (isFuture) {
	      return result + forms(key)[1];
	    } else {
	      return result + (special(number) ? forms(key)[1] : forms(key)[2]);
	    }
	  }
	}
	
	function formatDistance(token, count, options) {
	  options = options || {};
	  var adverb = token.match(/about|over|almost|lessthan/i);
	  var unit = token.replace(adverb, '');
	  var result;
	
	  if (typeof formatDistanceLocale[token] === 'string') {
	    result = formatDistanceLocale[token];
	  } else if (count === 1) {
	    result = formatDistanceLocale[token].one(count, options.addSuffix, unit.toLowerCase() + '_one');
	  } else {
	    result = formatDistanceLocale[token].other(count, options.addSuffix, unit.toLowerCase() + '_other');
	  }
	
	  if (adverb) {
	    result = translations[adverb[0].toLowerCase()] + ' ' + result;
	  }
	
	  if (options.addSuffix) {
	    if (options.comparison > 0) {
	      return 'po ' + result;
	    } else {
	      return 'prieš ' + result;
	    }
	  }
	
	  return result;
	}
	
	module.exports = exports.default;

/***/ },
/* 1318 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: "y 'm'. MMMM d 'd'., EEEE",
	  long: "y 'm'. MMMM d 'd'.",
	  medium: 'y-MM-dd',
	  short: 'y-MM-dd'
	};
	var timeFormats = {
	  full: 'HH:mm:ss zzzz',
	  long: 'HH:mm:ss z',
	  medium: 'HH:mm:ss',
	  short: 'HH:mm'
	};
	var dateTimeFormats = {
	  full: '{{date}} {{time}}',
	  long: '{{date}} {{time}}',
	  medium: '{{date}} {{time}}',
	  short: '{{date}} {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1319 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRelative;
	var formatRelativeLocale = {
	  lastWeek: "'Praėjusį' eeee p",
	  yesterday: "'Vakar' p",
	  today: "'Šiandien' p",
	  tomorrow: "'Rytoj' p",
	  nextWeek: 'eeee p',
	  other: 'P'
	};
	
	function formatRelative(token, _date, _baseDate, _options) {
	  return formatRelativeLocale[token];
	}
	
	module.exports = exports.default;

/***/ },
/* 1320 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eraValues = {
	  narrow: ['pr. Kr.', 'po Kr.'],
	  abbreviated: ['pr. Kr.', 'po Kr.'],
	  wide: ['prieš Kristų', 'po Kristaus']
	};
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['I ketv.', 'II ketv.', 'III ketv.', 'IV ketv.'],
	  wide: ['I ketvirtis', 'II ketvirtis', 'III ketvirtis', 'IV ketvirtis']
	};
	var formattingQuarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['I k.', 'II k.', 'III k.', 'IV k.'],
	  wide: ['I ketvirtis', 'II ketvirtis', 'III ketvirtis', 'IV ketvirtis']
	};
	var monthValues = {
	  narrow: ['S', 'V', 'K', 'B', 'G', 'B', 'L', 'R', 'R', 'S', 'L', 'G'],
	  abbreviated: ['saus.', 'vas.', 'kov.', 'bal.', 'geg.', 'birž.', 'liep.', 'rugp.', 'rugs.', 'spal.', 'lapkr.', 'gruod.'],
	  wide: ['sausis', 'vasaris', 'kovas', 'balandis', 'gegužė', 'birželis', 'liepa', 'rugpjūtis', 'rugsėjis', 'spalis', 'lapkritis', 'gruodis']
	};
	var formattingMonthValues = {
	  narrow: ['S', 'V', 'K', 'B', 'G', 'B', 'L', 'R', 'R', 'S', 'L', 'G'],
	  abbreviated: ['saus.', 'vas.', 'kov.', 'bal.', 'geg.', 'birž.', 'liep.', 'rugp.', 'rugs.', 'spal.', 'lapkr.', 'gruod.'],
	  wide: ['sausio', 'vasario', 'kovo', 'balandžio', 'gegužės', 'birželio', 'liepos', 'rugpjūčio', 'rugsėjo', 'spalio', 'lapkričio', 'gruodžio']
	};
	var dayValues = {
	  narrow: ['S', 'P', 'A', 'T', 'K', 'P', 'Š'],
	  short: ['Sk', 'Pr', 'An', 'Tr', 'Kt', 'Pn', 'Št'],
	  abbreviated: ['sk', 'pr', 'an', 'tr', 'kt', 'pn', 'št'],
	  wide: ['sekmadienis', 'pirmadienis', 'antradienis', 'trečiadienis', 'ketvirtadienis', 'penktadienis', 'šeštadienis']
	};
	var formattingDayValues = {
	  narrow: ['S', 'P', 'A', 'T', 'K', 'P', 'Š'],
	  short: ['Sk', 'Pr', 'An', 'Tr', 'Kt', 'Pn', 'Št'],
	  abbreviated: ['sk', 'pr', 'an', 'tr', 'kt', 'pn', 'št'],
	  wide: ['sekmadienį', 'pirmadienį', 'antradienį', 'trečiadienį', 'ketvirtadienį', 'penktadienį', 'šeštadienį']
	};
	var dayPeriodValues = {
	  narrow: {
	    am: 'pr. p.',
	    pm: 'pop.',
	    midnight: 'vidurnaktis',
	    noon: 'vidurdienis',
	    morning: 'rytas',
	    afternoon: 'diena',
	    evening: 'vakaras',
	    night: 'naktis'
	  },
	  abbreviated: {
	    am: 'priešpiet',
	    pm: 'popiet',
	    midnight: 'vidurnaktis',
	    noon: 'vidurdienis',
	    morning: 'rytas',
	    afternoon: 'diena',
	    evening: 'vakaras',
	    night: 'naktis'
	  },
	  wide: {
	    am: 'priešpiet',
	    pm: 'popiet',
	    midnight: 'vidurnaktis',
	    noon: 'vidurdienis',
	    morning: 'rytas',
	    afternoon: 'diena',
	    evening: 'vakaras',
	    night: 'naktis'
	  }
	};
	var formattingDayPeriodValues = {
	  narrow: {
	    am: 'pr. p.',
	    pm: 'pop.',
	    midnight: 'vidurnaktis',
	    noon: 'perpiet',
	    morning: 'rytas',
	    afternoon: 'popietė',
	    evening: 'vakaras',
	    night: 'naktis'
	  },
	  abbreviated: {
	    am: 'priešpiet',
	    pm: 'popiet',
	    midnight: 'vidurnaktis',
	    noon: 'perpiet',
	    morning: 'rytas',
	    afternoon: 'popietė',
	    evening: 'vakaras',
	    night: 'naktis'
	  },
	  wide: {
	    am: 'priešpiet',
	    pm: 'popiet',
	    midnight: 'vidurnaktis',
	    noon: 'perpiet',
	    morning: 'rytas',
	    afternoon: 'popietė',
	    evening: 'vakaras',
	    night: 'naktis'
	  }
	};
	
	function ordinalNumber(dirtyNumber, _dirtyOptions) {
	  var number = Number(dirtyNumber);
	  return number + '-oji';
	}
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingQuarterValues,
	    defaultFormattingWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingMonthValues,
	    defaultFormattingWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingDayValues,
	    defaultFormattingWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingDayPeriodValues,
	    defaultFormattingWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1321 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(15));
	
	var _index2 = _interopRequireDefault(__webpack_require__(14));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(\d+)(-oji)?/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^p(r|o)\.?\s?(kr\.?|me)/i,
	  abbreviated: /^(pr\.\s?(kr\.|m\.\s?e\.)|po\s?kr\.|mūsų eroje)/i,
	  wide: /^(prieš Kristų|prieš mūsų erą|po Kristaus|mūsų eroje)/i
	};
	var parseEraPatterns = {
	  wide: [/prieš/i, /(po|mūsų)/i],
	  any: [/^pr/i, /^(po|m)/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^([1234])/i,
	  abbreviated: /^(I|II|III|IV)\s?ketv?\.?/i,
	  wide: /^(I|II|III|IV)\s?ketvirtis/i
	};
	var parseQuarterPatterns = {
	  narrow: [/1/i, /2/i, /3/i, /4/i],
	  any: [/I$/i, /II$/i, /III/i, /IV/i]
	};
	var matchMonthPatterns = {
	  narrow: /^[svkbglr]/i,
	  abbreviated: /^(saus\.|vas\.|kov\.|bal\.|geg\.|birž\.|liep\.|rugp\.|rugs\.|spal\.|lapkr\.|gruod\.)/i,
	  wide: /^(sausi(s|o)|vasari(s|o)|kov(a|o)s|balandž?i(s|o)|gegužės?|birželi(s|o)|liep(a|os)|rugpjū(t|č)i(s|o)|rugsėj(is|o)|spali(s|o)|lapkri(t|č)i(s|o)|gruodž?i(s|o))/i
	};
	var parseMonthPatterns = {
	  narrow: [/^s/i, /^v/i, /^k/i, /^b/i, /^g/i, /^b/i, /^l/i, /^r/i, /^r/i, /^s/i, /^l/i, /^g/i],
	  any: [/^saus/i, /^vas/i, /^kov/i, /^bal/i, /^geg/i, /^birž/i, /^liep/i, /^rugp/i, /^rugs/i, /^spal/i, /^lapkr/i, /^gruod/i]
	};
	var matchDayPatterns = {
	  narrow: /^[spatkš]/i,
	  short: /^(sk|pr|an|tr|kt|pn|št)/i,
	  abbreviated: /^(sk|pr|an|tr|kt|pn|št)/i,
	  wide: /^(sekmadien(is|į)|pirmadien(is|į)|antradien(is|į)|trečiadien(is|į)|ketvirtadien(is|į)|penktadien(is|į)|šeštadien(is|į))/i
	};
	var parseDayPatterns = {
	  narrow: [/^s/i, /^p/i, /^a/i, /^t/i, /^k/i, /^p/i, /^š/i],
	  wide: [/^se/i, /^pi/i, /^an/i, /^tr/i, /^ke/i, /^pe/i, /^še/i],
	  any: [/^sk/i, /^pr/i, /^an/i, /^tr/i, /^kt/i, /^pn/i, /^št/i]
	};
	var matchDayPeriodPatterns = {
	  narrow: /^(pr.\s?p.|pop.|vidurnaktis|(vidurdienis|perpiet)|rytas|(diena|popietė)|vakaras|naktis)/i,
	  any: /^(priešpiet|popiet$|vidurnaktis|(vidurdienis|perpiet)|rytas|(diena|popietė)|vakaras|naktis)/i
	};
	var parseDayPeriodPatterns = {
	  narrow: {
	    am: /^pr/i,
	    pm: /^pop./i,
	    midnight: /^vidurnaktis/i,
	    noon: /^(vidurdienis|perp)/i,
	    morning: /rytas/i,
	    afternoon: /(die|popietė)/i,
	    evening: /vakaras/i,
	    night: /naktis/i
	  },
	  any: {
	    am: /^pr/i,
	    pm: /^popiet$/i,
	    midnight: /^vidurnaktis/i,
	    noon: /^(vidurdienis|perp)/i,
	    morning: /rytas/i,
	    afternoon: /(die|popietė)/i,
	    evening: /vakaras/i,
	    night: /naktis/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index2.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index2.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index2.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index2.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index2.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1322 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1317));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1318));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1319));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1320));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1321));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 *
	 * @summary Lithuanian locale.
	 * @language Lithuanian
	 *
	 * @iso-639-2 lit
	 *
	 * @author Pavlo Shpak [@pshpak]{@link https://github.com/pshpak}
	 * @author Eduardo Pardo [@eduardopsll]{@link https://github.com/eduardopsll}
	 */
	var locale = {
	  code: 'lt',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 1
	    /* Monday */
	    ,
	    firstWeekContainsDate: 4
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1323 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistance;
	
	function buildLocalizeTokenFn(schema) {
	  return function (count, options) {
	    if (count === 1) {
	      if (options.addSuffix) {
	        return schema.one[0].replace('{{time}}', schema.one[2]);
	      } else {
	        return schema.one[0].replace('{{time}}', schema.one[1]);
	      }
	    } else {
	      var rem = count % 10 === 1 && count % 100 !== 11;
	
	      if (options.addSuffix) {
	        return schema.other[0].replace('{{time}}', rem ? schema.other[3] : schema.other[4]).replace('{{count}}', count);
	      } else {
	        return schema.other[0].replace('{{time}}', rem ? schema.other[1] : schema.other[2]).replace('{{count}}', count);
	      }
	    }
	  };
	}
	
	var formatDistanceLocale = {
	  lessThanXSeconds: buildLocalizeTokenFn({
	    one: ['mazāk par {{time}}', 'sekundi', 'sekundi'],
	    other: ['mazāk nekā {{count}} {{time}}', 'sekunde', 'sekundes', 'sekundes', 'sekundēm']
	  }),
	  xSeconds: buildLocalizeTokenFn({
	    one: ['1 {{time}}', 'sekunde', 'sekundes'],
	    other: ['{{count}} {{time}}', 'sekunde', 'sekundes', 'sekundes', 'sekundēm']
	  }),
	  halfAMinute: function (count, options) {
	    if (options.addSuffix) {
	      return 'pusminūtes';
	    } else {
	      return 'pusminūte';
	    }
	  },
	  lessThanXMinutes: buildLocalizeTokenFn({
	    one: ['mazāk par {{time}}', 'minūti', 'minūti'],
	    other: ['mazāk nekā {{count}} {{time}}', 'minūte', 'minūtes', 'minūtes', 'minūtēm']
	  }),
	  xMinutes: buildLocalizeTokenFn({
	    one: ['1 {{time}}', 'minūte', 'minūtes'],
	    other: ['{{count}} {{time}}', 'minūte', 'minūtes', 'minūtes', 'minūtēm']
	  }),
	  aboutXHours: buildLocalizeTokenFn({
	    one: ['apmēram 1 {{time}}', 'stunda', 'stundas'],
	    other: ['apmēram {{count}} {{time}}', 'stunda', 'stundas', 'stundas', 'stundām']
	  }),
	  xHours: buildLocalizeTokenFn({
	    one: ['1 {{time}}', 'stunda', 'stundas'],
	    other: ['{{count}} {{time}}', 'stunda', 'stundas', 'stundas', 'stundām']
	  }),
	  xDays: buildLocalizeTokenFn({
	    one: ['1 {{time}}', 'diena', 'dienas'],
	    other: ['{{count}} {{time}}', 'diena', 'dienas', 'dienas', 'dienām']
	  }),
	  aboutXWeeks: buildLocalizeTokenFn({
	    one: ['apmēram 1 {{time}}', 'nedēļa', 'nedēļas'],
	    other: ['apmēram {{count}} {{time}}', 'nedēļa', 'nedēļu', 'nedēļas', 'nedēļām']
	  }),
	  xWeeks: buildLocalizeTokenFn({
	    one: ['1 {{time}}', 'nedēļa', 'nedēļas'],
	    other: ['{{count}} {{time}}', // TODO
	    'nedēļa', 'nedēļu', 'nedēļas', 'nedēļām']
	  }),
	  aboutXMonths: buildLocalizeTokenFn({
	    one: ['apmēram 1 {{time}}', 'mēnesis', 'mēneša'],
	    other: ['apmēram {{count}} {{time}}', 'mēnesis', 'mēneši', 'mēneša', 'mēnešiem']
	  }),
	  xMonths: buildLocalizeTokenFn({
	    one: ['1 {{time}}', 'mēnesis', 'mēneša'],
	    other: ['{{count}} {{time}}', 'mēnesis', 'mēneši', 'mēneša', 'mēnešiem']
	  }),
	  aboutXYears: buildLocalizeTokenFn({
	    one: ['apmēram 1 {{time}}', 'gads', 'gada'],
	    other: ['apmēram {{count}} {{time}}', 'gads', 'gadi', 'gada', 'gadiem']
	  }),
	  xYears: buildLocalizeTokenFn({
	    one: ['1 {{time}}', 'gads', 'gada'],
	    other: ['{{count}} {{time}}', 'gads', 'gadi', 'gada', 'gadiem']
	  }),
	  overXYears: buildLocalizeTokenFn({
	    one: ['ilgāk par 1 {{time}}', 'gadu', 'gadu'],
	    other: ['vairāk nekā {{count}} {{time}}', 'gads', 'gadi', 'gada', 'gadiem']
	  }),
	  almostXYears: buildLocalizeTokenFn({
	    one: ['gandrīz 1 {{time}}', 'gads', 'gada'],
	    other: ['vairāk nekā {{count}} {{time}}', 'gads', 'gadi', 'gada', 'gadiem']
	  })
	};
	
	function formatDistance(token, count, options) {
	  options = options || {};
	  var result = formatDistanceLocale[token](count, options);
	
	  if (options.addSuffix) {
	    if (options.comparison > 0) {
	      return 'pēc ' + result;
	    } else {
	      return 'pirms ' + result;
	    }
	  }
	
	  return result;
	}
	
	module.exports = exports.default;

/***/ },
/* 1324 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: "EEEE, y. 'gada' d. MMMM",
	  long: "y. 'gada' d. MMMM",
	  medium: 'dd.MM.y.',
	  short: 'dd.MM.y.'
	};
	var timeFormats = {
	  full: 'HH:mm:ss zzzz',
	  long: 'HH:mm:ss z',
	  medium: 'HH:mm:ss',
	  short: 'HH:mm'
	};
	var dateTimeFormats = {
	  full: "{{date}} 'plkst.' {{time}}",
	  long: "{{date}} 'plkst.' {{time}}",
	  medium: '{{date}}, {{time}}',
	  short: '{{date}}, {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1325 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRelative;
	
	var _index = _interopRequireDefault(__webpack_require__(71));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var weekdays = ['svētdienā', 'pirmdienā', 'otrdienā', 'trešdienā', 'ceturtdienā', 'piektdienā', 'sestdienā'];
	var formatRelativeLocale = {
	  lastWeek: function (date, baseDate, options) {
	    if ((0, _index.default)(date, baseDate, options)) {
	      return "eeee 'plkst.' p";
	    }
	
	    var weekday = weekdays[date.getUTCDay()];
	    return "'Pagājušā " + weekday + " plkst.' p";
	  },
	  yesterday: "'Vakar plkst.' p",
	  today: "'Šodien plkst.' p",
	  tomorrow: "'Rīt plkst.' p",
	  nextWeek: function (date, baseDate, options) {
	    if ((0, _index.default)(date, baseDate, options)) {
	      return "eeee 'plkst.' p";
	    }
	
	    var weekday = weekdays[date.getUTCDay()];
	    return "'Nākamajā " + weekday + " plkst.' p";
	  },
	  other: 'P'
	};
	
	function formatRelative(token, date, baseDate, options) {
	  var format = formatRelativeLocale[token];
	
	  if (typeof format === 'function') {
	    return format(date, baseDate, options);
	  }
	
	  return format;
	}
	
	module.exports = exports.default;

/***/ },
/* 1326 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eraValues = {
	  narrow: ['p.m.ē', 'm.ē'],
	  abbreviated: ['p. m. ē.', 'm. ē.'],
	  wide: ['pirms mūsu ēras', 'mūsu ērā']
	};
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['1. cet.', '2. cet.', '3. cet.', '4. cet.'],
	  wide: ['pirmais ceturksnis', 'otrais ceturksnis', 'trešais ceturksnis', 'ceturtais ceturksnis']
	};
	var formattingQuarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['1. cet.', '2. cet.', '3. cet.', '4. cet.'],
	  wide: ['pirmajā ceturksnī', 'otrajā ceturksnī', 'trešajā ceturksnī', 'ceturtajā ceturksnī']
	};
	var monthValues = {
	  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
	  abbreviated: ['janv.', 'febr.', 'marts', 'apr.', 'maijs', 'jūn.', 'jūl.', 'aug.', 'sept.', 'okt.', 'nov.', 'dec.'],
	  wide: ['janvāris', 'februāris', 'marts', 'aprīlis', 'maijs', 'jūnijs', 'jūlijs', 'augusts', 'septembris', 'oktobris', 'novembris', 'decembris']
	};
	var formattingMonthValues = {
	  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
	  abbreviated: ['janv.', 'febr.', 'martā', 'apr.', 'maijs', 'jūn.', 'jūl.', 'aug.', 'sept.', 'okt.', 'nov.', 'dec.'],
	  wide: ['janvārī', 'februārī', 'martā', 'aprīlī', 'maijā', 'jūnijā', 'jūlijā', 'augustā', 'septembrī', 'oktobrī', 'novembrī', 'decembrī']
	};
	var dayValues = {
	  narrow: ['S', 'P', 'O', 'T', 'C', 'P', 'S'],
	  short: ['Sv', 'P', 'O', 'T', 'C', 'Pk', 'S'],
	  abbreviated: ['svētd.', 'pirmd.', 'otrd.', 'trešd.', 'ceturtd.', 'piektd.', 'sestd.'],
	  wide: ['svētdiena', 'pirmdiena', 'otrdiena', 'trešdiena', 'ceturtdiena', 'piektdiena', 'sestdiena']
	};
	var formattingDayValues = {
	  narrow: ['S', 'P', 'O', 'T', 'C', 'P', 'S'],
	  short: ['Sv', 'P', 'O', 'T', 'C', 'Pk', 'S'],
	  abbreviated: ['svētd.', 'pirmd.', 'otrd.', 'trešd.', 'ceturtd.', 'piektd.', 'sestd.'],
	  wide: ['svētdienā', 'pirmdienā', 'otrdienā', 'trešdienā', 'ceturtdienā', 'piektdienā', 'sestdienā']
	};
	var dayPeriodValues = {
	  narrow: {
	    am: 'am',
	    pm: 'pm',
	    midnight: 'pusn.',
	    noon: 'pusd.',
	    morning: 'rīts',
	    afternoon: 'diena',
	    evening: 'vakars',
	    night: 'nakts'
	  },
	  abbreviated: {
	    am: 'am',
	    pm: 'pm',
	    midnight: 'pusn.',
	    noon: 'pusd.',
	    morning: 'rīts',
	    afternoon: 'pēcpusd.',
	    evening: 'vakars',
	    night: 'nakts'
	  },
	  wide: {
	    am: 'am',
	    pm: 'pm',
	    midnight: 'pusnakts',
	    noon: 'pusdienlaiks',
	    morning: 'rīts',
	    afternoon: 'pēcpusdiena',
	    evening: 'vakars',
	    night: 'nakts'
	  }
	};
	var formattingDayPeriodValues = {
	  narrow: {
	    am: 'am',
	    pm: 'pm',
	    midnight: 'pusn.',
	    noon: 'pusd.',
	    morning: 'rītā',
	    afternoon: 'dienā',
	    evening: 'vakarā',
	    night: 'naktī'
	  },
	  abbreviated: {
	    am: 'am',
	    pm: 'pm',
	    midnight: 'pusn.',
	    noon: 'pusd.',
	    morning: 'rītā',
	    afternoon: 'pēcpusd.',
	    evening: 'vakarā',
	    night: 'naktī'
	  },
	  wide: {
	    am: 'am',
	    pm: 'pm',
	    midnight: 'pusnaktī',
	    noon: 'pusdienlaikā',
	    morning: 'rītā',
	    afternoon: 'pēcpusdienā',
	    evening: 'vakarā',
	    night: 'naktī'
	  }
	};
	
	function ordinalNumber(number, _options) {
	  return number + '.';
	}
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingQuarterValues,
	    defaultFormattingWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingMonthValues,
	    defaultFormattingWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingDayValues,
	    defaultFormattingWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingDayPeriodValues,
	    defaultFormattingWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1327 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(15));
	
	var _index2 = _interopRequireDefault(__webpack_require__(14));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(\d+)\./i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^(p\.m\.ē|m\.ē)/i,
	  abbreviated: /^(p\. m\. ē\.|m\. ē\.)/i,
	  wide: /^(pirms mūsu ēras|mūsu ērā)/i
	};
	var parseEraPatterns = {
	  any: [/^p/i, /^m/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^[1234](\. cet\.)/i,
	  wide: /^(pirma(is|jā)|otra(is|jā)|treša(is|jā)|ceturta(is|jā)) ceturksn(is|ī)/i
	};
	var parseQuarterPatterns = {
	  narrow: [/^1/i, /^2/i, /^3/i, /^4/i],
	  abbreviated: [/^1/i, /^2/i, /^3/i, /^4/i],
	  wide: [/^p/i, /^o/i, /^t/i, /^c/i]
	};
	var matchMonthPatterns = {
	  narrow: /^[jfmasond]/i,
	  abbreviated: /^(janv\.|febr\.|marts|apr\.|maijs|jūn\.|jūl\.|aug\.|sept\.|okt\.|nov\.|dec\.)/i,
	  wide: /^(janvār(is|ī)|februār(is|ī)|mart[sā]|aprīl(is|ī)|maij[sā]|jūnij[sā]|jūlij[sā]|august[sā]|septembr(is|ī)|oktobr(is|ī)|novembr(is|ī)|decembr(is|ī))/i
	};
	var parseMonthPatterns = {
	  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
	  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^mai/i, /^jūn/i, /^jūl/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
	};
	var matchDayPatterns = {
	  narrow: /^[spotc]/i,
	  short: /^(sv|pi|o|t|c|pk|s)/i,
	  abbreviated: /^(svētd\.|pirmd\.|otrd.\|trešd\.|ceturtd\.|piektd\.|sestd\.)/i,
	  wide: /^(svētdien(a|ā)|pirmdien(a|ā)|otrdien(a|ā)|trešdien(a|ā)|ceturtdien(a|ā)|piektdien(a|ā)|sestdien(a|ā))/i
	};
	var parseDayPatterns = {
	  narrow: [/^s/i, /^p/i, /^o/i, /^t/i, /^c/i, /^p/i, /^s/i],
	  any: [/^sv/i, /^pi/i, /^o/i, /^t/i, /^c/i, /^p/i, /^se/i]
	};
	var matchDayPeriodPatterns = {
	  narrow: /^(am|pm|pusn\.|pusd\.|rīt(s|ā)|dien(a|ā)|vakar(s|ā)|nakt(s|ī))/,
	  abbreviated: /^(am|pm|pusn\.|pusd\.|rīt(s|ā)|pēcpusd\.|vakar(s|ā)|nakt(s|ī))/,
	  wide: /^(am|pm|pusnakt(s|ī)|pusdienlaik(s|ā)|rīt(s|ā)|pēcpusdien(a|ā)|vakar(s|ā)|nakt(s|ī))/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^am/i,
	    pm: /^pm/i,
	    midnight: /^pusn/i,
	    noon: /^pusd/i,
	    morning: /^r/i,
	    afternoon: /^(d|pēc)/i,
	    evening: /^v/i,
	    night: /^n/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index2.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index2.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index2.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index2.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index2.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1328 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1323));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1324));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1325));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1326));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1327));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Latvian locale (Latvia).
	 * @language Latvian
	 * @iso-639-2 lav
	 * @author Rūdolfs Puķītis [@prudolfs]{@link https://github.com/prudolfs}
	 */
	var locale = {
	  code: 'lv',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 1
	    /* Monday */
	    ,
	    firstWeekContainsDate: 4
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1329 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistance;
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    one: 'помалку од секунда',
	    other: 'помалку од {{count}} секунди'
	  },
	  xSeconds: {
	    one: '1 секунда',
	    other: '{{count}} секунди'
	  },
	  halfAMinute: 'половина минута',
	  lessThanXMinutes: {
	    one: 'помалку од минута',
	    other: 'помалку од {{count}} минути'
	  },
	  xMinutes: {
	    one: '1 минута',
	    other: '{{count}} минути'
	  },
	  aboutXHours: {
	    one: 'околу 1 час',
	    other: 'околу {{count}} часа'
	  },
	  xHours: {
	    one: '1 час',
	    other: '{{count}} часа'
	  },
	  xDays: {
	    one: '1 ден',
	    other: '{{count}} дена'
	  },
	  aboutXWeeks: {
	    one: 'околу 1 недела',
	    other: 'околу {{count}} месеци'
	  },
	  xWeeks: {
	    one: '1 недела',
	    other: '{{count}} недели'
	  },
	  aboutXMonths: {
	    one: 'околу 1 месец',
	    other: 'околу {{count}} недели'
	  },
	  xMonths: {
	    one: '1 месец',
	    other: '{{count}} месеци'
	  },
	  aboutXYears: {
	    one: 'околу 1 година',
	    other: 'околу {{count}} години'
	  },
	  xYears: {
	    one: '1 година',
	    other: '{{count}} години'
	  },
	  overXYears: {
	    one: 'повеќе од 1 година',
	    other: 'повеќе од {{count}} години'
	  },
	  almostXYears: {
	    one: 'безмалку 1 година',
	    other: 'безмалку {{count}} години'
	  }
	};
	
	function formatDistance(token, count, options) {
	  options = options || {};
	  var result;
	
	  if (typeof formatDistanceLocale[token] === 'string') {
	    result = formatDistanceLocale[token];
	  } else if (count === 1) {
	    result = formatDistanceLocale[token].one;
	  } else {
	    result = formatDistanceLocale[token].other.replace('{{count}}', count);
	  }
	
	  if (options.addSuffix) {
	    if (options.comparison > 0) {
	      return 'за ' + result;
	    } else {
	      return 'пред ' + result;
	    }
	  }
	
	  return result;
	}
	
	module.exports = exports.default;

/***/ },
/* 1330 */
1085,
/* 1331 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRelative;
	
	var _index = _interopRequireDefault(__webpack_require__(71));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var weekdays = ['недела', 'понеделник', 'вторник', 'среда', 'четврток', 'петок', 'сабота'];
	
	function lastWeek(day) {
	  var weekday = weekdays[day];
	
	  switch (day) {
	    case 0:
	    case 3:
	    case 6:
	      return "'минатата " + weekday + " во' p";
	
	    case 1:
	    case 2:
	    case 4:
	    case 5:
	      return "'минатиот " + weekday + " во' p";
	  }
	}
	
	function thisWeek(day) {
	  var weekday = weekdays[day];
	
	  switch (day) {
	    case 0:
	    case 3:
	    case 6:
	      return "'ова " + weekday + " вo' p";
	
	    case 1:
	    case 2:
	    case 4:
	    case 5:
	      return "'овој " + weekday + " вo' p";
	  }
	}
	
	function nextWeek(day) {
	  var weekday = weekdays[day];
	
	  switch (day) {
	    case 0:
	    case 3:
	    case 6:
	      return "'следната " + weekday + " вo' p";
	
	    case 1:
	    case 2:
	    case 4:
	    case 5:
	      return "'следниот " + weekday + " вo' p";
	  }
	}
	
	var formatRelativeLocale = {
	  lastWeek: function (date, baseDate, options) {
	    var day = date.getUTCDay();
	
	    if ((0, _index.default)(date, baseDate, options)) {
	      return thisWeek(day);
	    } else {
	      return lastWeek(day);
	    }
	  },
	  yesterday: "'вчера во' p",
	  today: "'денес во' p",
	  tomorrow: "'утре во' p",
	  nextWeek: function (date, baseDate, options) {
	    var day = date.getUTCDay();
	
	    if ((0, _index.default)(date, baseDate, options)) {
	      return thisWeek(day);
	    } else {
	      return nextWeek(day);
	    }
	  },
	  other: 'P'
	};
	
	function formatRelative(token, date, baseDate, options) {
	  var format = formatRelativeLocale[token];
	
	  if (typeof format === 'function') {
	    return format(date, baseDate, options);
	  }
	
	  return format;
	}
	
	module.exports = exports.default;

/***/ },
/* 1332 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eraValues = {
	  narrow: ['пр.н.е.', 'н.е.'],
	  abbreviated: ['пред н. е.', 'н. е.'],
	  wide: ['пред нашата ера', 'нашата ера']
	};
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['1-ви кв.', '2-ри кв.', '3-ти кв.', '4-ти кв.'],
	  wide: ['1-ви квартал', '2-ри квартал', '3-ти квартал', '4-ти квартал']
	};
	var monthValues = {
	  abbreviated: ['јан', 'фев', 'мар', 'апр', 'мај', 'јун', 'јул', 'авг', 'септ', 'окт', 'ноем', 'дек'],
	  wide: ['јануари', 'февруари', 'март', 'април', 'мај', 'јуни', 'јули', 'август', 'септември', 'октомври', 'ноември', 'декември']
	};
	var dayValues = {
	  narrow: ['Н', 'П', 'В', 'С', 'Ч', 'П', 'С'],
	  short: ['не', 'по', 'вт', 'ср', 'че', 'пе', 'са'],
	  abbreviated: ['нед', 'пон', 'вто', 'сре', 'чет', 'пет', 'саб'],
	  wide: ['недела', 'понеделник', 'вторник', 'среда', 'четврток', 'петок', 'сабота']
	};
	var dayPeriodValues = {
	  wide: {
	    am: 'претпладне',
	    pm: 'попладне',
	    midnight: 'полноќ',
	    noon: 'напладне',
	    morning: 'наутро',
	    afternoon: 'попладне',
	    evening: 'навечер',
	    night: 'ноќе'
	  }
	};
	
	function ordinalNumber(dirtyNumber) {
	  var number = Number(dirtyNumber);
	  var rem100 = number % 100;
	
	  if (rem100 > 20 || rem100 < 10) {
	    switch (rem100 % 10) {
	      case 1:
	        return number + '-ви';
	
	      case 2:
	        return number + '-ри';
	
	      case 7:
	      case 8:
	        return number + '-ми';
	    }
	  }
	
	  return number + '-ти';
	}
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1333 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(14));
	
	var _index2 = _interopRequireDefault(__webpack_require__(15));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(\d+)(-?[врмт][и])?/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^((пр)?н\.?\s?е\.?)/i,
	  abbreviated: /^((пр)?н\.?\s?е\.?)/i,
	  wide: /^(пред нашата ера|нашата ера)/i
	};
	var parseEraPatterns = {
	  any: [/^п/i, /^н/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^[1234](-?[врт]?и?)? кв.?/i,
	  wide: /^[1234](-?[врт]?и?)? квартал/i
	};
	var parseQuarterPatterns = {
	  any: [/1/i, /2/i, /3/i, /4/i]
	};
	var matchDayPatterns = {
	  narrow: /^[нпвсч]/i,
	  short: /^(не|по|вт|ср|че|пе|са)/i,
	  abbreviated: /^(нед|пон|вто|сре|чет|пет|саб)/i,
	  wide: /^(недела|понеделник|вторник|среда|четврток|петок|сабота)/i
	};
	var parseDayPatterns = {
	  narrow: [/^н/i, /^п/i, /^в/i, /^с/i, /^ч/i, /^п/i, /^с/i],
	  any: [/^н[ед]/i, /^п[он]/i, /^вт/i, /^ср/i, /^ч[ет]/i, /^п[ет]/i, /^с[аб]/i]
	};
	var matchMonthPatterns = {
	  abbreviated: /^(јан|фев|мар|апр|мај|јун|јул|авг|сеп|окт|ноем|дек)/i,
	  wide: /^(јануари|февруари|март|април|мај|јуни|јули|август|септември|октомври|ноември|декември)/i
	};
	var parseMonthPatterns = {
	  any: [/^ја/i, /^Ф/i, /^мар/i, /^ап/i, /^мај/i, /^јун/i, /^јул/i, /^ав/i, /^се/i, /^окт/i, /^но/i, /^де/i]
	};
	var matchDayPeriodPatterns = {
	  any: /^(претп|попл|полноќ|утро|пладне|вечер|ноќ)/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /претпладне/i,
	    pm: /попладне/i,
	    midnight: /полноќ/i,
	    noon: /напладне/i,
	    morning: /наутро/i,
	    afternoon: /попладне/i,
	    evening: /навечер/i,
	    night: /ноќе/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index2.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1334 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1329));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1330));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1331));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1332));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1333));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Macedonian locale.
	 * @language Macedonian
	 * @iso-639-2 mkd
	 * @author Petar Vlahu [@vlahupetar]{@link https://github.com/vlahupetar}
	 * @author Altrim Beqiri [@altrim]{@link https://github.com/altrim}
	 */
	var locale = {
	  code: 'mk',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 1
	    /* Monday */
	    ,
	    firstWeekContainsDate: 4
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1335 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistance;
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    one: 'секунд хүрэхгүй',
	    other: '{{count}} секунд хүрэхгүй'
	  },
	  xSeconds: {
	    one: '1 секунд',
	    other: '{{count}} секунд'
	  },
	  halfAMinute: 'хагас минут',
	  lessThanXMinutes: {
	    one: 'минут хүрэхгүй',
	    other: '{{count}} минут хүрэхгүй'
	  },
	  xMinutes: {
	    one: '1 минут',
	    other: '{{count}} минут'
	  },
	  aboutXHours: {
	    one: 'ойролцоогоор 1 цаг',
	    other: 'ойролцоогоор {{count}} цаг'
	  },
	  xHours: {
	    one: '1 цаг',
	    other: '{{count}} цаг'
	  },
	  xDays: {
	    one: '1 өдөр',
	    other: '{{count}} өдөр'
	  },
	  aboutXWeeks: {
	    one: 'ойролцоогоор 1 долоо хоног',
	    other: 'ойролцоогоор {{count}} долоо хоног'
	  },
	  xWeeks: {
	    one: '1 долоо хоног',
	    other: '{{count}} долоо хоног'
	  },
	  aboutXMonths: {
	    one: 'ойролцоогоор 1 сар',
	    other: 'ойролцоогоор {{count}} сар'
	  },
	  xMonths: {
	    one: '1 сар',
	    other: '{{count}} сар'
	  },
	  aboutXYears: {
	    one: 'ойролцоогоор 1 жил',
	    other: 'ойролцоогоор {{count}} жил'
	  },
	  xYears: {
	    one: '1 жил',
	    other: '{{count}} жил'
	  },
	  overXYears: {
	    one: '1 жил гаран',
	    other: '{{count}} жил гаран'
	  },
	  almostXYears: {
	    one: 'бараг 1 жил',
	    other: 'бараг {{count}} жил'
	  }
	};
	
	function formatDistance(token, count, options) {
	  options = options || {};
	  var result;
	
	  if (typeof formatDistanceLocale[token] === 'string') {
	    result = formatDistanceLocale[token];
	  } else if (count === 1) {
	    result = formatDistanceLocale[token].one;
	  } else {
	    result = formatDistanceLocale[token].other.replace('{{count}}', count);
	  }
	
	  if (options.addSuffix) {
	    /**
	     * Append genitive case
	     */
	    var words = result.split(' ');
	    var lastword = words.pop();
	    result = words.join(' ');
	
	    switch (lastword) {
	      case 'секунд':
	        result += ' секундийн';
	        break;
	
	      case 'минут':
	        result += ' минутын';
	        break;
	
	      case 'цаг':
	        result += ' цагийн';
	        break;
	
	      case 'өдөр':
	        result += ' өдрийн';
	        break;
	
	      case 'сар':
	        result += ' сарын';
	        break;
	
	      case 'жил':
	        result += ' жилийн';
	        break;
	
	      case 'хоног':
	        result += ' хоногийн';
	        break;
	
	      case 'гаран':
	        result += ' гараны';
	        break;
	
	      case 'хүрэхгүй':
	        result += ' хүрэхгүй хугацааны';
	        break;
	
	      default:
	        result += lastword + '-н';
	    }
	
	    if (options.comparison > 0) {
	      return result + ' дараа';
	    } else {
	      return result + ' өмнө';
	    }
	  }
	
	  return result;
	}
	
	module.exports = exports.default;

/***/ },
/* 1336 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: "y 'оны' MMMM'ын' d, EEEE 'гараг'",
	  long: "y 'оны' MMMM'ын' d",
	  medium: "y 'оны' MMM'ын' d",
	  short: 'y.MM.dd'
	};
	var timeFormats = {
	  full: 'H:mm:ss zzzz',
	  long: 'H:mm:ss z',
	  medium: 'H:mm:ss',
	  short: 'H:mm'
	};
	var dateTimeFormats = {
	  full: '{{date}} {{time}}',
	  long: '{{date}} {{time}}',
	  medium: '{{date}} {{time}}',
	  short: '{{date}} {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1337 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRelative;
	var formatRelativeLocale = {
	  lastWeek: "'өнгөрсөн' eeee 'гарагийн' p 'цагт'",
	  yesterday: "'өчигдөр' p 'цагт'",
	  today: "'өнөөдөр' p 'цагт'",
	  tomorrow: "'маргааш' p 'цагт'",
	  nextWeek: "'ирэх' eeee 'гарагийн' p 'цагт'",
	  other: 'P'
	};
	
	function formatRelative(token, _date, _baseDate, _options) {
	  return formatRelativeLocale[token];
	}
	
	module.exports = exports.default;

/***/ },
/* 1338 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eraValues = {
	  narrow: ['НТӨ', 'НТ'],
	  abbreviated: ['НТӨ', 'НТ'],
	  wide: ['нийтийн тооллын өмнөх', 'нийтийн тооллын']
	};
	var quarterValues = {
	  narrow: ['I', 'II', 'III', 'IV'],
	  abbreviated: ['I улирал', 'II улирал', 'III улирал', 'IV улирал'],
	  wide: ['1-р улирал', '2-р улирал', '3-р улирал', '4-р улирал']
	}; // Note: in English, the names of days of the week and months are capitalized.
	// If you are making a new locale based on this one, check if the same is true for the language you're working on.
	// Generally, formatted dates should look like they are in the middle of a sentence,
	// e.g. in Spanish language the weekdays and months should be in the lowercase.
	
	var monthValues = {
	  narrow: ['I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX', 'X', 'XI', 'XII'],
	  abbreviated: ['1-р сар', '2-р сар', '3-р сар', '4-р сар', '5-р сар', '6-р сар', '7-р сар', '8-р сар', '9-р сар', '10-р сар', '11-р сар', '12-р сар'],
	  wide: ['Нэгдүгээр сар', 'Хоёрдугаар сар', 'Гуравдугаар сар', 'Дөрөвдүгээр сар', 'Тавдугаар сар', 'Зургаадугаар сар', 'Долоодугаар сар', 'Наймдугаар сар', 'Есдүгээр сар', 'Аравдугаар сар', 'Арваннэгдүгээр сар', 'Арван хоёрдугаар сар']
	};
	var formattingMonthValues = {
	  narrow: ['I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX', 'X', 'XI', 'XII'],
	  abbreviated: ['1-р сар', '2-р сар', '3-р сар', '4-р сар', '5-р сар', '6-р сар', '7-р сар', '8-р сар', '9-р сар', '10-р сар', '11-р сар', '12-р сар'],
	  wide: ['нэгдүгээр сар', 'хоёрдугаар сар', 'гуравдугаар сар', 'дөрөвдүгээр сар', 'тавдугаар сар', 'зургаадугаар сар', 'долоодугаар сар', 'наймдугаар сар', 'есдүгээр сар', 'аравдугаар сар', 'арваннэгдүгээр сар', 'арван хоёрдугаар сар']
	};
	var dayValues = {
	  narrow: ['Н', 'Д', 'М', 'Л', 'П', 'Б', 'Б'],
	  short: ['Ня', 'Да', 'Мя', 'Лх', 'Пү', 'Ба', 'Бя'],
	  abbreviated: ['Ням', 'Дав', 'Мяг', 'Лха', 'Пүр', 'Баа', 'Бям'],
	  wide: ['Ням', 'Даваа', 'Мягмар', 'Лхагва', 'Пүрэв', 'Баасан', 'Бямба']
	};
	var formattingDayValues = {
	  narrow: ['Н', 'Д', 'М', 'Л', 'П', 'Б', 'Б'],
	  short: ['Ня', 'Да', 'Мя', 'Лх', 'Пү', 'Ба', 'Бя'],
	  abbreviated: ['Ням', 'Дав', 'Мяг', 'Лха', 'Пүр', 'Баа', 'Бям'],
	  wide: ['ням', 'даваа', 'мягмар', 'лхагва', 'пүрэв', 'баасан', 'бямба']
	};
	var dayPeriodValues = {
	  narrow: {
	    am: 'ү.ө.',
	    pm: 'ү.х.',
	    midnight: 'шөнө дунд',
	    noon: 'үд дунд',
	    morning: 'өглөө',
	    afternoon: 'өдөр',
	    evening: 'орой',
	    night: 'шөнө'
	  },
	  abbreviated: {
	    am: 'ү.ө.',
	    pm: 'ү.х.',
	    midnight: 'шөнө дунд',
	    noon: 'үд дунд',
	    morning: 'өглөө',
	    afternoon: 'өдөр',
	    evening: 'орой',
	    night: 'шөнө'
	  },
	  wide: {
	    am: 'ү.ө.',
	    pm: 'ү.х.',
	    midnight: 'шөнө дунд',
	    noon: 'үд дунд',
	    morning: 'өглөө',
	    afternoon: 'өдөр',
	    evening: 'орой',
	    night: 'шөнө'
	  }
	};
	
	function ordinalNumber(dirtyNumber, _dirtyOptions) {
	  var number = Number(dirtyNumber); // If ordinal numbers depend on context, for example,
	  // if they are different for different grammatical genders,
	  // use `options.unit`:
	  //
	  //   var options = dirtyOptions || {}
	  //   var unit = String(options.unit)
	  //
	  // where `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
	  // 'day', 'hour', 'minute', 'second'
	
	  return number;
	}
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingMonthValues,
	    defaultFormattingWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingDayValues,
	    defaultFormattingWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1339 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(15));
	
	var _index2 = _interopRequireDefault(__webpack_require__(14));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /\d+/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^(нтө|нт)/i,
	  abbreviated: /^(нтө|нт)/i,
	  wide: /^(нийтийн тооллын өмнө|нийтийн тооллын)/i
	};
	var parseEraPatterns = {
	  any: [/^(нтө|нийтийн тооллын өмнө)/i, /^(нт|нийтийн тооллын)/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^(iv|iii|ii|i)/i,
	  abbreviated: /^(iv|iii|ii|i) улирал/i,
	  wide: /^[1-4]-р улирал/i
	};
	var parseQuarterPatterns = {
	  any: [/^(i(\s|$)|1)/i, /^(ii(\s|$)|2)/i, /^(iii(\s|$)|3)/i, /^(iv(\s|$)|4)/i]
	};
	var matchMonthPatterns = {
	  narrow: /^(xii|xi|x|ix|viii|vii|vi|v|iv|iii|ii|i)/i,
	  abbreviated: /^(1-р сар|2-р сар|3-р сар|4-р сар|5-р сар|6-р сар|7-р сар|8-р сар|9-р сар|10-р сар|11-р сар|12-р сар)/i,
	  wide: /^(нэгдүгээр сар|хоёрдугаар сар|гуравдугаар сар|дөрөвдүгээр сар|тавдугаар сар|зургаадугаар сар|долоодугаар сар|наймдугаар сар|есдүгээр сар|аравдугаар сар|арван нэгдүгээр сар|арван хоёрдугаар сар)/i
	};
	var parseMonthPatterns = {
	  narrow: [/^i$/i, /^ii$/i, /^iii$/i, /^iv$/i, /^v$/i, /^vi$/i, /^vii$/i, /^viii$/i, /^ix$/i, /^x$/i, /^xi$/i, /^xii$/i],
	  any: [/^(1|нэгдүгээр)/i, /^(2|хоёрдугаар)/i, /^(3|гуравдугаар)/i, /^(4|дөрөвдүгээр)/i, /^(5|тавдугаар)/i, /^(6|зургаадугаар)/i, /^(7|долоодугаар)/i, /^(8|наймдугаар)/i, /^(9|есдүгээр)/i, /^(10|аравдугаар)/i, /^(11|арван нэгдүгээр)/i, /^(12|арван хоёрдугаар)/i]
	};
	var matchDayPatterns = {
	  narrow: /^[ндмлпбб]/i,
	  short: /^(ня|да|мя|лх|пү|ба|бя)/i,
	  abbreviated: /^(ням|дав|мяг|лха|пүр|баа|бям)/i,
	  wide: /^(ням|даваа|мягмар|лхагва|пүрэв|баасан|бямба)/i
	};
	var parseDayPatterns = {
	  narrow: [/^н/i, /^д/i, /^м/i, /^л/i, /^п/i, /^б/i, /^б/i],
	  any: [/^ня/i, /^да/i, /^мя/i, /^лх/i, /^пү/i, /^ба/i, /^бя/i]
	};
	var matchDayPeriodPatterns = {
	  narrow: /^(ү\.ө\.|ү\.х\.|шөнө дунд|үд дунд|өглөө|өдөр|орой|шөнө)/i,
	  any: /^(ү\.ө\.|ү\.х\.|шөнө дунд|үд дунд|өглөө|өдөр|орой|шөнө)/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^ү\.ө\./i,
	    pm: /^ү\.х\./i,
	    midnight: /^шөнө дунд/i,
	    noon: /^үд дунд/i,
	    morning: /өглөө/i,
	    afternoon: /өдөр/i,
	    evening: /орой/i,
	    night: /шөнө/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index2.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index2.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index2.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index2.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index2.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1340 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1335));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1336));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1337));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1338));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1339));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Mongolian locale.
	 * @language Mongolian
	 * @iso-639-2 mon
	 * @author Bilguun Ochirbat [@bilguun0203]{@link https://github.com/bilguun0203}
	 */
	var locale = {
	  code: 'mn',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 1
	    /* Monday */
	    ,
	    firstWeekContainsDate: 1
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1341 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistance;
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    one: 'kurang dari 1 saat',
	    other: 'kurang dari {{count}} saat'
	  },
	  xSeconds: {
	    one: '1 saat',
	    other: '{{count}} saat'
	  },
	  halfAMinute: 'setengah minit',
	  lessThanXMinutes: {
	    one: 'kurang dari 1 minit',
	    other: 'kurang dari {{count}} minit'
	  },
	  xMinutes: {
	    one: '1 minit',
	    other: '{{count}} minit'
	  },
	  aboutXHours: {
	    one: 'sekitar 1 jam',
	    other: 'sekitar {{count}} jam'
	  },
	  xHours: {
	    one: '1 jam',
	    other: '{{count}} jam'
	  },
	  xDays: {
	    one: '1 hari',
	    other: '{{count}} hari'
	  },
	  aboutXWeeks: {
	    one: 'sekitar 1 minggu',
	    other: 'sekitar {{count}} minggu'
	  },
	  xWeeks: {
	    one: '1 minggu',
	    other: '{{count}} minggu'
	  },
	  aboutXMonths: {
	    one: 'sekitar 1 bulan',
	    other: 'sekitar {{count}} bulan'
	  },
	  xMonths: {
	    one: '1 bulan',
	    other: '{{count}} bulan'
	  },
	  aboutXYears: {
	    one: 'sekitar 1 tahun',
	    other: 'sekitar {{count}} tahun'
	  },
	  xYears: {
	    one: '1 tahun',
	    other: '{{count}} tahun'
	  },
	  overXYears: {
	    one: 'lebih dari 1 tahun',
	    other: 'lebih dari {{count}} tahun'
	  },
	  almostXYears: {
	    one: 'hampir 1 tahun',
	    other: 'hampir {{count}} tahun'
	  }
	};
	
	function formatDistance(token, count, options) {
	  options = options || {};
	  var result;
	
	  if (typeof formatDistanceLocale[token] === 'string') {
	    result = formatDistanceLocale[token];
	  } else if (count === 1) {
	    result = formatDistanceLocale[token].one;
	  } else {
	    result = formatDistanceLocale[token].other.replace('{{count}}', count);
	  }
	
	  if (options.addSuffix) {
	    if (options.comparison > 0) {
	      return 'dalam masa ' + result;
	    } else {
	      return result + ' yang lalu';
	    }
	  }
	
	  return result;
	}
	
	module.exports = exports.default;

/***/ },
/* 1342 */
1252,
/* 1343 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRelative;
	var formatRelativeLocale = {
	  lastWeek: "eeee 'lepas pada jam' p",
	  yesterday: "'Semalam pada jam' p",
	  today: "'Hari ini pada jam' p",
	  tomorrow: "'Esok pada jam' p",
	  nextWeek: "eeee 'pada jam' p",
	  other: 'P'
	};
	
	function formatRelative(token, _date, _baseDate, _options) {
	  return formatRelativeLocale[token];
	}
	
	module.exports = exports.default;

/***/ },
/* 1344 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Most data for localization are taken from this page
	// https://www.unicode.org/cldr/charts/32/summary/ms.html
	var eraValues = {
	  narrow: ['SM', 'M'],
	  abbreviated: ['SM', 'M'],
	  wide: ['Sebelum Masihi', 'Masihi']
	};
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['S1', 'S2', 'S3', 'S4'],
	  wide: ['Suku pertama', 'Suku kedua', 'Suku ketiga', 'Suku keempat']
	}; // Note: in Malay, the names of days of the week and months are capitalized.
	// If you are making a new locale based on this one, check if the same is true for the language you're working on.
	// Generally, formatted dates should look like they are in the middle of a sentence,
	// e.g. in Spanish language the weekdays and months should be in the lowercase.
	
	var monthValues = {
	  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'O', 'S', 'O', 'N', 'D'],
	  abbreviated: ['Jan', 'Feb', 'Mac', 'Apr', 'Mei', 'Jun', 'Jul', 'Ogo', 'Sep', 'Okt', 'Nov', 'Dis'],
	  wide: ['Januari', 'Februari', 'Mac', 'April', 'Mei', 'Jun', 'Julai', 'Ogos', 'September', 'Oktober', 'November', 'Disember']
	};
	var dayValues = {
	  narrow: ['A', 'I', 'S', 'R', 'K', 'J', 'S'],
	  short: ['Ahd', 'Isn', 'Sel', 'Rab', 'Kha', 'Jum', 'Sab'],
	  abbreviated: ['Ahd', 'Isn', 'Sel', 'Rab', 'Kha', 'Jum', 'Sab'],
	  wide: ['Ahad', 'Isnin', 'Selasa', 'Rabu', 'Khamis', 'Jumaat', 'Sabtu']
	};
	var dayPeriodValues = {
	  narrow: {
	    am: 'am',
	    pm: 'pm',
	    midnight: 'tgh malam',
	    noon: 'tgh hari',
	    morning: 'pagi',
	    afternoon: 'tengah hari',
	    evening: 'petang',
	    night: 'malam'
	  },
	  abbreviated: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'tengah malam',
	    noon: 'tengah hari',
	    morning: 'pagi',
	    afternoon: 'tengah hari',
	    evening: 'petang',
	    night: 'malam'
	  },
	  wide: {
	    am: 'a.m.',
	    pm: 'p.m.',
	    midnight: 'tengah malam',
	    noon: 'tengah hari',
	    morning: 'pagi',
	    afternoon: 'tengah hari',
	    evening: 'petang',
	    night: 'malam'
	  }
	};
	var formattingDayPeriodValues = {
	  narrow: {
	    am: 'am',
	    pm: 'pm',
	    midnight: 'tengah malam',
	    noon: 'tengah hari',
	    morning: 'pagi',
	    afternoon: 'tengah hari',
	    evening: 'petang',
	    night: 'malam'
	  },
	  abbreviated: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'tengah malam',
	    noon: 'tengah hari',
	    morning: 'pagi',
	    afternoon: 'tengah hari',
	    evening: 'petang',
	    night: 'malam'
	  },
	  wide: {
	    am: 'a.m.',
	    pm: 'p.m.',
	    midnight: 'tengah malam',
	    noon: 'tengah hari',
	    morning: 'pagi',
	    afternoon: 'tengah hari',
	    evening: 'petang',
	    night: 'malam'
	  }
	};
	
	function ordinalNumber(dirtyNumber, _dirtyOptions) {
	  var number = Number(dirtyNumber); // Can't use "pertama", "kedua" because can't be parsed
	
	  switch (number) {
	    default:
	      return 'ke-' + number;
	  }
	}
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingDayPeriodValues,
	    defaultFormattingWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1345 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(14));
	
	var _index2 = _interopRequireDefault(__webpack_require__(15));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^ke-(\d+)?/i;
	var parseOrdinalNumberPattern = /petama|\d+/i;
	var matchEraPatterns = {
	  narrow: /^(sm|m)/i,
	  abbreviated: /^(s\.?\s?m\.?|m\.?)/i,
	  wide: /^(sebelum masihi|masihi)/i
	};
	var parseEraPatterns = {
	  any: [/^s/i, /^(m)/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^S[1234]/i,
	  wide: /Suku (pertama|kedua|ketiga|keempat)/i
	};
	var parseQuarterPatterns = {
	  any: [/pertama|1/i, /kedua|2/i, /ketiga|3/i, /keempat|4/i]
	};
	var matchMonthPatterns = {
	  narrow: /^[jfmasond]/i,
	  abbreviated: /^(jan|feb|mac|apr|mei|jun|jul|ogo|sep|okt|nov|dis)/i,
	  wide: /^(januari|februari|mac|april|mei|jun|julai|ogos|september|oktober|november|disember)/i
	};
	var parseMonthPatterns = {
	  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^o/i, /^s/i, /^o/i, /^n/i, /^d/i],
	  any: [/^ja/i, /^f/i, /^ma/i, /^ap/i, /^me/i, /^jun/i, /^jul/i, /^og/i, /^s/i, /^ok/i, /^n/i, /^d/i]
	};
	var matchDayPatterns = {
	  narrow: /^[aisrkj]/i,
	  short: /^(ahd|isn|sel|rab|kha|jum|sab)/i,
	  abbreviated: /^(ahd|isn|sel|rab|kha|jum|sab)/i,
	  wide: /^(ahad|isnin|selasa|rabu|khamis|jumaat|sabtu)/i
	};
	var parseDayPatterns = {
	  narrow: [/^a/i, /^i/i, /^s/i, /^r/i, /^k/i, /^j/i, /^s/i],
	  any: [/^a/i, /^i/i, /^se/i, /^r/i, /^k/i, /^j/i, /^sa/i]
	};
	var matchDayPeriodPatterns = {
	  narrow: /^(am|pm|tengah malam|tengah hari|pagi|petang|malam)/i,
	  any: /^([ap]\.?\s?m\.?|tengah malam|tengah hari|pagi|petang|malam)/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^a/i,
	    pm: /^pm/i,
	    midnight: /^tengah m/i,
	    noon: /^tengah h/i,
	    morning: /pa/i,
	    afternoon: /tengah h/i,
	    evening: /pe/i,
	    night: /m/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index2.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1346 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1341));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1342));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1343));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1344));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1345));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Malay locale.
	 * @language Malay
	 * @iso-639-2 msa
	 * @author Ruban Selvarajah [@Zyten]{@link https://github.com/Zyten}
	 */
	var locale = {
	  code: 'ms',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 1
	    /* Monday */
	    ,
	    firstWeekContainsDate: 1
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1347 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistance;
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    one: 'inqas minn sekonda',
	    other: 'inqas minn {{count}} sekondi'
	  },
	  xSeconds: {
	    one: 'sekonda',
	    other: '{{count}} sekondi'
	  },
	  halfAMinute: 'nofs minuta',
	  lessThanXMinutes: {
	    one: 'inqas minn minuta',
	    other: 'inqas minn {{count}} minuti'
	  },
	  xMinutes: {
	    one: 'minuta',
	    other: '{{count}} minuti'
	  },
	  aboutXHours: {
	    one: 'madwar siegħa',
	    other: 'madwar {{count}} siegħat'
	  },
	  xHours: {
	    one: 'siegħa',
	    other: '{{count}} siegħat'
	  },
	  xDays: {
	    one: 'ġurnata',
	    other: '{{count}} ġranet'
	  },
	  aboutXWeeks: {
	    one: 'madwar ġimgħa',
	    other: 'madwar {{count}} ġimgħat'
	  },
	  xWeeks: {
	    one: 'ġimgħa',
	    other: '{{count}} ġimgħat'
	  },
	  aboutXMonths: {
	    one: 'madwar xahar',
	    other: 'madwar {{count}} xhur'
	  },
	  xMonths: {
	    one: 'xahar',
	    other: '{{count}} xhur'
	  },
	  aboutXYears: {
	    one: 'madwar sena',
	    two: 'madwar sentejn',
	    other: 'madwar {{count}} snin'
	  },
	  xYears: {
	    one: 'sena',
	    two: 'sentejn',
	    other: '{{count}} snin'
	  },
	  overXYears: {
	    one: 'aktar minn sena',
	    two: 'aktar minn sentejn',
	    other: 'aktar minn {{count}} snin'
	  },
	  almostXYears: {
	    one: 'kważi sena',
	    two: 'kważi sentejn',
	    other: 'kważi {{count}} snin'
	  }
	};
	
	function formatDistance(token, count, options) {
	  options = options || {};
	  var adverb = token.match(/years/i);
	  var result;
	
	  if (typeof formatDistanceLocale[token] === 'string') {
	    result = formatDistanceLocale[token];
	  } else if (count === 1) {
	    result = formatDistanceLocale[token].one;
	  } else if (count === 2 && adverb) {
	    result = formatDistanceLocale[token].two;
	  } else {
	    result = formatDistanceLocale[token].other.replace('{{count}}', count);
	  }
	
	  if (options.addSuffix) {
	    if (options.comparison > 0) {
	      return "f'" + result;
	    } else {
	      return result + ' ilu';
	    }
	  }
	
	  return result;
	}
	
	module.exports = exports.default;

/***/ },
/* 1348 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: 'EEEE, d MMMM yyyy',
	  long: 'd MMMM yyyy',
	  medium: 'd MMM yyyy',
	  short: 'dd/MM/yyyy'
	};
	var timeFormats = {
	  full: 'HH:mm:ss zzzz',
	  long: 'HH:mm:ss z',
	  medium: 'HH:mm:ss',
	  short: 'HH:mm'
	};
	var dateTimeFormats = {
	  full: '{{date}} {{time}}',
	  long: '{{date}} {{time}}',
	  medium: '{{date}} {{time}}',
	  short: '{{date}} {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1349 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRelative;
	var formatRelativeLocale = {
	  lastWeek: "eeee 'li għadda' 'fil-'p",
	  yesterday: "'Il-bieraħ fil-'p",
	  today: "'Illum fil-'p",
	  tomorrow: "'Għada fil-'p",
	  nextWeek: "eeee 'fil-'p",
	  other: 'P'
	};
	
	function formatRelative(token, _date, _baseDate, _options) {
	  return formatRelativeLocale[token];
	}
	
	module.exports = exports.default;

/***/ },
/* 1350 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eraValues = {
	  narrow: ['Q', 'W'],
	  abbreviated: ['QK', 'WK'],
	  wide: ['qabel Kristu', 'wara Kristu']
	};
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['K1', 'K2', 'K3', 'K4'],
	  wide: ['1. kwart', '2. kwart', '3. kwart', '4. kwart']
	};
	var monthValues = {
	  narrow: ['J', 'F', 'M', 'A', 'M', 'Ġ', 'L', 'A', 'S', 'O', 'N', 'D'],
	  abbreviated: ['Jan', 'Fra', 'Mar', 'Apr', 'Mej', 'Ġun', 'Lul', 'Aww', 'Set', 'Ott', 'Nov', 'Diċ'],
	  wide: ['Jannar', 'Frar', 'Marzu', 'April', 'Mejju', 'Ġunju', 'Lulju', 'Awwissu', 'Settembru', 'Ottubru', 'Novembru', 'Diċembru']
	};
	var dayValues = {
	  narrow: ['Ħ', 'T', 'T', 'E', 'Ħ', 'Ġ', 'S'],
	  short: ['Ħa', 'Tn', 'Tl', 'Er', 'Ħa', 'Ġi', 'Si'],
	  abbreviated: ['Ħad', 'Tne', 'Tli', 'Erb', 'Ħam', 'Ġim', 'Sib'],
	  wide: ['Il-Ħadd', 'It-Tnejn', 'It-Tlieta', 'L-Erbgħa', 'Il-Ħamis', 'Il-Ġimgħa', 'Is-Sibt']
	};
	var dayPeriodValues = {
	  narrow: {
	    am: 'a',
	    pm: 'p',
	    midnight: 'nofsillejl',
	    noon: 'nofsinhar',
	    morning: 'għodwa',
	    afternoon: 'wara nofsinhar',
	    evening: 'filgħaxija',
	    night: 'lejl'
	  },
	  abbreviated: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'nofsillejl',
	    noon: 'nofsinhar',
	    morning: 'għodwa',
	    afternoon: 'wara nofsinhar',
	    evening: 'filgħaxija',
	    night: 'lejl'
	  },
	  wide: {
	    am: 'a.m.',
	    pm: 'p.m.',
	    midnight: 'nofsillejl',
	    noon: 'nofsinhar',
	    morning: 'għodwa',
	    afternoon: 'wara nofsinhar',
	    evening: 'filgħaxija',
	    night: 'lejl'
	  }
	};
	var formattingDayPeriodValues = {
	  narrow: {
	    am: 'a',
	    pm: 'p',
	    midnight: "f'nofsillejl",
	    noon: "f'nofsinhar",
	    morning: 'filgħodu',
	    afternoon: 'wara nofsinhar',
	    evening: 'filgħaxija',
	    night: 'billejl'
	  },
	  abbreviated: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: "f'nofsillejl",
	    noon: "f'nofsinhar",
	    morning: 'filgħodu',
	    afternoon: 'wara nofsinhar',
	    evening: 'filgħaxija',
	    night: 'billejl'
	  },
	  wide: {
	    am: 'a.m.',
	    pm: 'p.m.',
	    midnight: "f'nofsillejl",
	    noon: "f'nofsinhar",
	    morning: 'filgħodu',
	    afternoon: 'wara nofsinhar',
	    evening: 'filgħaxija',
	    night: 'billejl'
	  }
	};
	
	function ordinalNumber(dirtyNumber) {
	  var number = Number(dirtyNumber);
	  return number + 'º';
	}
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingDayPeriodValues,
	    defaultFormattingWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1351 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(15));
	
	var _index2 = _interopRequireDefault(__webpack_require__(14));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(\d+)(º)?/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^(q|w)/i,
	  abbreviated: /^(q\.?\s?k\.?|b\.?\s?c\.?\s?e\.?|w\.?\s?k\.?)/i,
	  wide: /^(qabel kristu|before common era|wara kristu|common era)/i
	};
	var parseEraPatterns = {
	  any: [/^(q|b)/i, /^(w|c)/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^k[1234]/i,
	  wide: /^[1234](\.)? kwart/i
	};
	var parseQuarterPatterns = {
	  any: [/1/i, /2/i, /3/i, /4/i]
	};
	var matchMonthPatterns = {
	  narrow: /^[jfmaglsond]/i,
	  abbreviated: /^(jan|fra|mar|apr|mej|ġun|lul|aww|set|ott|nov|diċ)/i,
	  wide: /^(jannar|frar|marzu|april|mejju|ġunju|lulju|awwissu|settembru|ottubru|novembru|diċembru)/i
	};
	var parseMonthPatterns = {
	  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^ġ/i, /^l/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
	  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^mej/i, /^ġ/i, /^l/i, /^aw/i, /^s/i, /^o/i, /^n/i, /^d/i]
	};
	var matchDayPatterns = {
	  narrow: /^[ħteġs]/i,
	  short: /^(ħa|tn|tl|er|ħa|ġi|si)/i,
	  abbreviated: /^(ħad|tne|tli|erb|ħam|ġim|sib)/i,
	  wide: /^(il-ħadd|it-tnejn|it-tlieta|l-erbgħa|il-ħamis|il-ġimgħa|is-sibt)/i
	};
	var parseDayPatterns = {
	  narrow: [/^ħ/i, /^t/i, /^t/i, /^e/i, /^ħ/i, /^ġ/i, /^s/i],
	  any: [/^(il-)?ħad/i, /^(it-)?tn/i, /^(it-)?tl/i, /^(l-)?er/i, /^(il-)?ham/i, /^(il-)?ġi/i, /^(is-)?si/i]
	};
	var matchDayPeriodPatterns = {
	  narrow: /^(a|p|f'nofsillejl|f'nofsinhar|(ta') (għodwa|wara nofsinhar|filgħaxija|lejl))/i,
	  any: /^([ap]\.?\s?m\.?|f'nofsillejl|f'nofsinhar|(ta') (għodwa|wara nofsinhar|filgħaxija|lejl))/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^a/i,
	    pm: /^p/i,
	    midnight: /^f'nofsillejl/i,
	    noon: /^f'nofsinhar/i,
	    morning: /għodwa/i,
	    afternoon: /wara(\s.*)nofsinhar/i,
	    evening: /filgħaxija/i,
	    night: /lejl/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index2.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index2.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index2.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index2.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index2.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1352 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1347));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1348));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1349));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1350));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1351));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Maltese locale.
	 * @language Maltese
	 * @iso-639-2 mlt
	 * @author Andras Matzon [@amatzon](@link https://github.com/amatzon)
	 * @author Bryan Borg [@bryanMt](@link https://github.com/bryanMt)
	 */
	var locale = {
	  code: 'mt',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 1
	    /* Monday */
	    ,
	    firstWeekContainsDate: 4
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1353 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistance;
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    singular: 'mindre enn ett sekund',
	    plural: 'mindre enn {{count}} sekunder'
	  },
	  xSeconds: {
	    singular: 'ett sekund',
	    plural: '{{count}} sekunder'
	  },
	  halfAMinute: 'et halvt minutt',
	  lessThanXMinutes: {
	    singular: 'mindre enn ett minutt',
	    plural: 'mindre enn {{count}} minutter'
	  },
	  xMinutes: {
	    singular: 'ett minutt',
	    plural: '{{count}} minutter'
	  },
	  aboutXHours: {
	    singular: 'omtrent en time',
	    plural: 'omtrent {{count}} timer'
	  },
	  xHours: {
	    singular: 'en time',
	    plural: '{{count}} timer'
	  },
	  xDays: {
	    singular: 'en dag',
	    plural: '{{count}} dager'
	  },
	  aboutXWeeks: {
	    singular: 'omtrent en uke',
	    plural: 'omtrent {{count}} uker'
	  },
	  xWeeks: {
	    singular: 'en uke',
	    plural: '{{count}} uker'
	  },
	  aboutXMonths: {
	    singular: 'omtrent en måned',
	    plural: 'omtrent {{count}} måneder'
	  },
	  xMonths: {
	    singular: 'en måned',
	    plural: '{{count}} måneder'
	  },
	  aboutXYears: {
	    singular: 'omtrent ett år',
	    plural: 'omtrent {{count}} år'
	  },
	  xYears: {
	    singular: 'ett år',
	    plural: '{{count}} år'
	  },
	  overXYears: {
	    singular: 'over ett år',
	    plural: 'over {{count}} år'
	  },
	  almostXYears: {
	    singular: 'nesten ett år',
	    plural: 'nesten {{count}} år'
	  }
	};
	
	function formatDistance(token, count, options) {
	  options = options || {};
	  var translation = formatDistanceLocale[token];
	  var result;
	
	  if (typeof translation === 'string') {
	    result = translation;
	  } else if (count === 0 || count > 1) {
	    result = translation.plural.replace('{{count}}', count);
	  } else {
	    result = translation.singular;
	  }
	
	  if (options.addSuffix) {
	    if (options.comparison > 0) {
	      return 'om ' + result;
	    } else {
	      return result + ' siden';
	    }
	  }
	
	  return result;
	}
	
	module.exports = exports.default;

/***/ },
/* 1354 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: 'EEEE d. MMMM y',
	  long: 'd. MMMM y',
	  medium: 'd. MMM y',
	  short: 'dd.MM.y'
	};
	var timeFormats = {
	  full: "'kl'. HH:mm:ss zzzz",
	  long: 'HH:mm:ss z',
	  medium: 'HH:mm:ss',
	  short: 'HH:mm'
	};
	var dateTimeFormats = {
	  full: "{{date}} 'kl.' {{time}}",
	  long: "{{date}} 'kl.' {{time}}",
	  medium: '{{date}} {{time}}',
	  short: '{{date}} {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1355 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRelative;
	var formatRelativeLocale = {
	  lastWeek: "'forrige' eeee 'kl.' p",
	  yesterday: "'i går kl.' p",
	  today: "'i dag kl.' p",
	  tomorrow: "'i morgen kl.' p",
	  nextWeek: "EEEE 'kl.' p",
	  other: 'P'
	};
	
	function formatRelative(token, _date, _baseDate, _options) {
	  return formatRelativeLocale[token];
	}
	
	module.exports = exports.default;

/***/ },
/* 1356 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eraValues = {
	  narrow: ['f.Kr.', 'e.Kr.'],
	  abbreviated: ['f.Kr.', 'e.Kr.'],
	  wide: ['før Kristus', 'etter Kristus']
	};
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
	  wide: ['1. kvartal', '2. kvartal', '3. kvartal', '4. kvartal']
	};
	var monthValues = {
	  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
	  abbreviated: ['jan.', 'feb.', 'mars', 'apr.', 'mai', 'juni', 'juli', 'aug.', 'sep.', 'okt.', 'nov.', 'des.'],
	  wide: ['januar', 'februar', 'mars', 'april', 'mai', 'juni', 'juli', 'august', 'september', 'oktober', 'november', 'desember']
	};
	var dayValues = {
	  narrow: ['S', 'M', 'T', 'O', 'T', 'F', 'L'],
	  short: ['sø', 'ma', 'ti', 'on', 'to', 'fr', 'lø'],
	  abbreviated: ['søn', 'man', 'tir', 'ons', 'tor', 'fre', 'lør'],
	  wide: ['søndag', 'mandag', 'tirsdag', 'onsdag', 'torsdag', 'fredag', 'lørdag']
	};
	var dayPeriodValues = {
	  narrow: {
	    am: 'a',
	    pm: 'p',
	    midnight: 'midnatt',
	    noon: 'middag',
	    morning: 'på morg.',
	    afternoon: 'på etterm.',
	    evening: 'på kvelden',
	    night: 'på natten'
	  },
	  abbreviated: {
	    am: 'a.m.',
	    pm: 'p.m.',
	    midnight: 'midnatt',
	    noon: 'middag',
	    morning: 'på morg.',
	    afternoon: 'på etterm.',
	    evening: 'på kvelden',
	    night: 'på natten'
	  },
	  wide: {
	    am: 'a.m.',
	    pm: 'p.m.',
	    midnight: 'midnatt',
	    noon: 'middag',
	    morning: 'på morgenen',
	    afternoon: 'på ettermiddagen',
	    evening: 'på kvelden',
	    night: 'på natten'
	  }
	};
	
	function ordinalNumber(dirtyNumber) {
	  var number = Number(dirtyNumber);
	  return number + '.';
	}
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1357 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(15));
	
	var _index2 = _interopRequireDefault(__webpack_require__(14));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(\d+)\.?/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^(f\.? ?Kr\.?|fvt\.?|e\.? ?Kr\.?|evt\.?)/i,
	  abbreviated: /^(f\.? ?Kr\.?|fvt\.?|e\.? ?Kr\.?|evt\.?)/i,
	  wide: /^(før Kristus|før vår tid|etter Kristus|vår tid)/i
	};
	var parseEraPatterns = {
	  any: [/^f/i, /^e/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^q[1234]/i,
	  wide: /^[1234](\.)? kvartal/i
	};
	var parseQuarterPatterns = {
	  any: [/1/i, /2/i, /3/i, /4/i]
	};
	var matchMonthPatterns = {
	  narrow: /^[jfmasond]/i,
	  abbreviated: /^(jan|feb|mars?|apr|mai|juni?|juli?|aug|sep|okt|nov|des)\.?/i,
	  wide: /^(januar|februar|mars|april|mai|juni|juli|august|september|oktober|november|desember)/i
	};
	var parseMonthPatterns = {
	  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
	  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^mai/i, /^jun/i, /^jul/i, /^aug/i, /^s/i, /^o/i, /^n/i, /^d/i]
	};
	var matchDayPatterns = {
	  narrow: /^[smtofl]/i,
	  short: /^(sø|ma|ti|on|to|fr|lø)/i,
	  abbreviated: /^(søn|man|tir|ons|tor|fre|lør)/i,
	  wide: /^(søndag|mandag|tirsdag|onsdag|torsdag|fredag|lørdag)/i
	};
	var parseDayPatterns = {
	  any: [/^s/i, /^m/i, /^ti/i, /^o/i, /^to/i, /^f/i, /^l/i]
	};
	var matchDayPeriodPatterns = {
	  narrow: /^(midnatt|middag|(på) (morgenen|ettermiddagen|kvelden|natten)|[ap])/i,
	  any: /^([ap]\.?\s?m\.?|midnatt|middag|(på) (morgenen|ettermiddagen|kvelden|natten))/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^a(\.?\s?m\.?)?$/i,
	    pm: /^p(\.?\s?m\.?)?$/i,
	    midnight: /^midn/i,
	    noon: /^midd/i,
	    morning: /morgen/i,
	    afternoon: /ettermiddag/i,
	    evening: /kveld/i,
	    night: /natt/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index2.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index2.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index2.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index2.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index2.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1358 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1353));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1354));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1355));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1356));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1357));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Norwegian Bokmål locale.
	 * @language Norwegian Bokmål
	 * @iso-639-2 nob
	 * @author Hans-Kristian Koren [@Hanse]{@link https://github.com/Hanse}
	 * @author Mikolaj Grzyb [@mikolajgrzyb]{@link https://github.com/mikolajgrzyb}
	 * @author Dag Stuan [@dagstuan]{@link https://github.com/dagstuan}
	 */
	var locale = {
	  code: 'nb',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 1
	    /* Monday */
	    ,
	    firstWeekContainsDate: 4
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1359 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistance;
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    one: 'minder dan een seconde',
	    other: 'minder dan {{count}} seconden'
	  },
	  xSeconds: {
	    one: '1 seconde',
	    other: '{{count}} seconden'
	  },
	  halfAMinute: 'een halve minuut',
	  lessThanXMinutes: {
	    one: 'minder dan een minuut',
	    other: 'minder dan {{count}} minuten'
	  },
	  xMinutes: {
	    one: 'een minuut',
	    other: '{{count}} minuten'
	  },
	  aboutXHours: {
	    one: 'ongeveer 1 uur',
	    other: 'ongeveer {{count}} uur'
	  },
	  xHours: {
	    one: '1 uur',
	    other: '{{count}} uur'
	  },
	  xDays: {
	    one: '1 dag',
	    other: '{{count}} dagen'
	  },
	  aboutXWeeks: {
	    one: 'ongeveer 1 week',
	    other: 'ongeveer {{count}} weken'
	  },
	  xWeeks: {
	    one: '1 week',
	    other: '{{count}} weken'
	  },
	  aboutXMonths: {
	    one: 'ongeveer 1 maand',
	    other: 'ongeveer {{count}} maanden'
	  },
	  xMonths: {
	    one: '1 maand',
	    other: '{{count}} maanden'
	  },
	  aboutXYears: {
	    one: 'ongeveer 1 jaar',
	    other: 'ongeveer {{count}} jaar'
	  },
	  xYears: {
	    one: '1 jaar',
	    other: '{{count}} jaar'
	  },
	  overXYears: {
	    one: 'meer dan 1 jaar',
	    other: 'meer dan {{count}} jaar'
	  },
	  almostXYears: {
	    one: 'bijna 1 jaar',
	    other: 'bijna {{count}} jaar'
	  }
	};
	
	function formatDistance(token, count, options) {
	  options = options || {};
	  var result;
	
	  if (typeof formatDistanceLocale[token] === 'string') {
	    result = formatDistanceLocale[token];
	  } else if (count === 1) {
	    result = formatDistanceLocale[token].one;
	  } else {
	    result = formatDistanceLocale[token].other.replace('{{count}}', count);
	  }
	
	  if (options.addSuffix) {
	    if (options.comparison > 0) {
	      return 'over ' + result;
	    } else {
	      return result + ' geleden';
	    }
	  }
	
	  return result;
	}
	
	module.exports = exports.default;

/***/ },
/* 1360 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: 'EEEE d MMMM y',
	  long: 'd MMMM y',
	  medium: 'd MMM y',
	  short: 'dd.MM.y'
	};
	var timeFormats = {
	  full: 'HH:mm:ss zzzz',
	  long: 'HH:mm:ss z',
	  medium: 'HH:mm:ss',
	  short: 'HH:mm'
	};
	var dateTimeFormats = {
	  full: "{{date}} 'om' {{time}}",
	  long: "{{date}} 'om' {{time}}",
	  medium: '{{date}}, {{time}}',
	  short: '{{date}}, {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1361 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRelative;
	var formatRelativeLocale = {
	  lastWeek: "'vorige' eeee 'om' p",
	  yesterday: "'gisteren om' p",
	  today: "'vandaag om' p",
	  tomorrow: "'morgen om' p",
	  nextWeek: "eeee 'om' p",
	  other: 'P'
	};
	
	function formatRelative(token, _date, _baseDate, _options) {
	  return formatRelativeLocale[token];
	}
	
	module.exports = exports.default;

/***/ },
/* 1362 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eraValues = {
	  narrow: ['v.C.', 'n.C.'],
	  abbreviated: ['v.Chr.', 'n.Chr.'],
	  wide: ['voor Christus', 'na Christus']
	};
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['K1', 'K2', 'K3', 'K4'],
	  wide: ['1e kwartaal', '2e kwartaal', '3e kwartaal', '4e kwartaal']
	};
	var monthValues = {
	  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
	  abbreviated: ['jan.', 'feb.', 'mrt.', 'apr.', 'mei', 'jun.', 'jul.', 'aug.', 'sep.', 'okt.', 'nov.', 'dec.'],
	  wide: ['januari', 'februari', 'maart', 'april', 'mei', 'juni', 'juli', 'augustus', 'september', 'oktober', 'november', 'december']
	};
	var dayValues = {
	  narrow: ['Z', 'M', 'D', 'W', 'D', 'V', 'Z'],
	  short: ['zo', 'ma', 'di', 'wo', 'do', 'vr', 'za'],
	  abbreviated: ['zon', 'maa', 'din', 'woe', 'don', 'vri', 'zat'],
	  wide: ['zondag', 'maandag', 'dinsdag', 'woensdag', 'donderdag', 'vrijdag', 'zaterdag']
	};
	var dayPeriodValues = {
	  narrow: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'middernacht',
	    noon: 'het middag',
	    morning: "'s ochtends",
	    afternoon: "'s namiddags",
	    evening: "'s avonds",
	    night: "'s nachts"
	  },
	  abbreviated: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'middernacht',
	    noon: 'het middag',
	    morning: "'s ochtends",
	    afternoon: "'s namiddags",
	    evening: "'s avonds",
	    night: "'s nachts"
	  },
	  wide: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'middernacht',
	    noon: 'het middag',
	    morning: "'s ochtends",
	    afternoon: "'s namiddags",
	    evening: "'s avonds",
	    night: "'s nachts"
	  }
	};
	
	function ordinalNumber(dirtyNumber) {
	  var number = Number(dirtyNumber);
	  return number + 'e';
	}
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1363 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(15));
	
	var _index2 = _interopRequireDefault(__webpack_require__(14));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(\d+)e?/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^([vn]\.? ?C\.?)/,
	  abbreviated: /^([vn]\. ?Chr\.?)/,
	  wide: /^((voor|na) Christus)/
	};
	var parseEraPatterns = {
	  any: [/^v/, /^n/]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^K[1234]/i,
	  wide: /^[1234]e kwartaal/i
	};
	var parseQuarterPatterns = {
	  any: [/1/i, /2/i, /3/i, /4/i]
	};
	var matchMonthPatterns = {
	  narrow: /^[jfmasond]/i,
	  abbreviated: /^(jan.|feb.|mrt.|apr.|mei|jun.|jul.|aug.|sep.|okt.|nov.|dec.)/i,
	  wide: /^(januari|februari|maart|april|mei|juni|juli|augustus|september|oktober|november|december)/i
	};
	var parseMonthPatterns = {
	  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
	  any: [/^jan/i, /^feb/i, /^m(r|a)/i, /^apr/i, /^mei/i, /^jun/i, /^jul/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i]
	};
	var matchDayPatterns = {
	  narrow: /^[zmdwv]/i,
	  short: /^(zo|ma|di|wo|do|vr|za)/i,
	  abbreviated: /^(zon|maa|din|woe|don|vri|zat)/i,
	  wide: /^(zondag|maandag|dinsdag|woensdag|donderdag|vrijdag|zaterdag)/i
	};
	var parseDayPatterns = {
	  narrow: [/^z/i, /^m/i, /^d/i, /^w/i, /^d/i, /^v/i, /^z/i],
	  any: [/^zo/i, /^ma/i, /^di/i, /^wo/i, /^do/i, /^vr/i, /^za/i]
	};
	var matchDayPeriodPatterns = {
	  any: /^(am|pm|middernacht|het middaguur|'s (ochtends|middags|avonds|nachts))/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^am/i,
	    pm: /^pm/i,
	    midnight: /^middernacht/i,
	    noon: /^het middaguur/i,
	    morning: /ochtend/i,
	    afternoon: /middag/i,
	    evening: /avond/i,
	    night: /nacht/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index2.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index2.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index2.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index2.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index2.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1364 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1359));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1360));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1361));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1362));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1363));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Dutch locale.
	 * @language Dutch
	 * @iso-639-2 nld
	 * @author Jorik Tangelder [@jtangelder]{@link https://github.com/jtangelder}
	 * @author Ruben Stolk [@rubenstolk]{@link https://github.com/rubenstolk}
	 * @author Lode Vanhove [@bitcrumb]{@link https://github.com/bitcrumb}
	 * @author Alex Hoeing [@dcbn]{@link https://github.com/dcbn}
	 */
	var locale = {
	  code: 'nl-BE',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 1
	    /* Monday */
	    ,
	    firstWeekContainsDate: 4
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1365 */
1359,
/* 1366 */
1193,
/* 1367 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRelative;
	var formatRelativeLocale = {
	  lastWeek: "'afgelopen' eeee 'om' p",
	  yesterday: "'gisteren om' p",
	  today: "'vandaag om' p",
	  tomorrow: "'morgen om' p",
	  nextWeek: "eeee 'om' p",
	  other: 'P'
	};
	
	function formatRelative(token, _date, _baseDate, _options) {
	  return formatRelativeLocale[token];
	}
	
	module.exports = exports.default;

/***/ },
/* 1368 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eraValues = {
	  narrow: ['v.C.', 'n.C.'],
	  abbreviated: ['v.Chr.', 'n.Chr.'],
	  wide: ['voor Christus', 'na Christus']
	};
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['K1', 'K2', 'K3', 'K4'],
	  wide: ['1e kwartaal', '2e kwartaal', '3e kwartaal', '4e kwartaal']
	};
	var monthValues = {
	  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
	  abbreviated: ['jan.', 'feb.', 'mrt.', 'apr.', 'mei', 'jun.', 'jul.', 'aug.', 'sep.', 'okt.', 'nov.', 'dec.'],
	  wide: ['januari', 'februari', 'maart', 'april', 'mei', 'juni', 'juli', 'augustus', 'september', 'oktober', 'november', 'december']
	};
	var dayValues = {
	  narrow: ['Z', 'M', 'D', 'W', 'D', 'V', 'Z'],
	  short: ['zo', 'ma', 'di', 'wo', 'do', 'vr', 'za'],
	  abbreviated: ['zon', 'maa', 'din', 'woe', 'don', 'vri', 'zat'],
	  wide: ['zondag', 'maandag', 'dinsdag', 'woensdag', 'donderdag', 'vrijdag', 'zaterdag']
	};
	var dayPeriodValues = {
	  narrow: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'middernacht',
	    noon: 'het middaguur',
	    morning: "'s ochtends",
	    afternoon: "'s middags",
	    evening: "'s avonds",
	    night: "'s nachts"
	  },
	  abbreviated: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'middernacht',
	    noon: 'het middaguur',
	    morning: "'s ochtends",
	    afternoon: "'s middags",
	    evening: "'s avonds",
	    night: "'s nachts"
	  },
	  wide: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'middernacht',
	    noon: 'het middaguur',
	    morning: "'s ochtends",
	    afternoon: "'s middags",
	    evening: "'s avonds",
	    night: "'s nachts"
	  }
	};
	
	function ordinalNumber(dirtyNumber) {
	  var number = Number(dirtyNumber);
	  return number + 'e';
	}
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1369 */
1363,
/* 1370 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1365));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1366));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1367));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1368));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1369));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Dutch locale.
	 * @language Dutch
	 * @iso-639-2 nld
	 * @author Jorik Tangelder [@jtangelder]{@link https://github.com/jtangelder}
	 * @author Ruben Stolk [@rubenstolk]{@link https://github.com/rubenstolk}
	 * @author Lode Vanhove [@bitcrumb]{@link https://github.com/bitcrumb}
	 * @author Edo Rivai [@edorivai]{@link https://github.com/edorivai}
	 * @author Niels Keurentjes [@curry684]{@link https://github.com/curry684}
	 * @author Stefan Vermaas [@stefanvermaas]{@link https://github.com/stefanvermaas}
	 */
	var locale = {
	  code: 'nl',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 1
	    /* Monday */
	    ,
	    firstWeekContainsDate: 4
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1371 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistance;
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    singular: 'mindre enn eitt sekund',
	    plural: 'mindre enn {{count}} sekund'
	  },
	  xSeconds: {
	    singular: 'eitt sekund',
	    plural: '{{count}} sekund'
	  },
	  halfAMinute: 'eit halvt minutt',
	  lessThanXMinutes: {
	    singular: 'mindre enn eitt minutt',
	    plural: 'mindre enn {{count}} minutt'
	  },
	  xMinutes: {
	    singular: 'eitt minutt',
	    plural: '{{count}} minutt'
	  },
	  aboutXHours: {
	    singular: 'omtrent ein time',
	    plural: 'omtrent {{count}} timar'
	  },
	  xHours: {
	    singular: 'ein time',
	    plural: '{{count}} timar'
	  },
	  xDays: {
	    singular: 'ein dag',
	    plural: '{{count}} dagar'
	  },
	  aboutXWeeks: {
	    singular: 'omtrent ei veke',
	    plural: 'omtrent {{count}} veker'
	  },
	  xWeeks: {
	    singular: 'ei veke',
	    plural: '{{count}} veker'
	  },
	  aboutXMonths: {
	    singular: 'omtrent ein månad',
	    plural: 'omtrent {{count}} månader'
	  },
	  xMonths: {
	    singular: 'ein månad',
	    plural: '{{count}} månader'
	  },
	  aboutXYears: {
	    singular: 'omtrent eitt år',
	    plural: 'omtrent {{count}} år'
	  },
	  xYears: {
	    singular: 'eitt år',
	    plural: '{{count}} år'
	  },
	  overXYears: {
	    singular: 'over eitt år',
	    plural: 'over {{count}} år'
	  },
	  almostXYears: {
	    singular: 'nesten eitt år',
	    plural: 'nesten {{count}} år'
	  }
	};
	var wordMapping = ['null', 'ein', 'to', 'tre', 'fire', 'fem', 'seks', 'sju', 'åtte', 'ni', 'ti', 'elleve', 'tolv'];
	
	function formatDistance(token, count, options) {
	  options = options || {
	    onlyNumeric: false
	  };
	  var translation = formatDistanceLocale[token];
	  var result;
	
	  if (typeof translation === 'string') {
	    result = translation;
	  } else if (count === 0 || count > 1) {
	    if (options.onlyNumeric) {
	      result = translation.plural.replace('{{count}}', count);
	    } else {
	      result = translation.plural.replace('{{count}}', count < 13 ? wordMapping[count] : count);
	    }
	  } else {
	    result = translation.singular;
	  }
	
	  if (options.addSuffix) {
	    if (options.comparison > 0) {
	      return 'om ' + result;
	    } else {
	      return result + ' sidan';
	    }
	  }
	
	  return result;
	}
	
	module.exports = exports.default;

/***/ },
/* 1372 */
1354,
/* 1373 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRelative;
	var formatRelativeLocale = {
	  lastWeek: "'førre' eeee 'kl.' p",
	  yesterday: "'i går kl.' p",
	  today: "'i dag kl.' p",
	  tomorrow: "'i morgon kl.' p",
	  nextWeek: "EEEE 'kl.' p",
	  other: 'P'
	};
	
	function formatRelative(token, _date, _baseDate, _options) {
	  return formatRelativeLocale[token];
	}
	
	module.exports = exports.default;

/***/ },
/* 1374 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eraValues = {
	  narrow: ['f.Kr.', 'e.Kr.'],
	  abbreviated: ['f.Kr.', 'e.Kr.'],
	  wide: ['før Kristus', 'etter Kristus']
	};
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
	  wide: ['1. kvartal', '2. kvartal', '3. kvartal', '4. kvartal']
	};
	var monthValues = {
	  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
	  abbreviated: ['jan.', 'feb.', 'mars', 'apr.', 'mai', 'juni', 'juli', 'aug.', 'sep.', 'okt.', 'nov.', 'des.'],
	  wide: ['januar', 'februar', 'mars', 'april', 'mai', 'juni', 'juli', 'august', 'september', 'oktober', 'november', 'desember']
	};
	var dayValues = {
	  narrow: ['S', 'M', 'T', 'O', 'T', 'F', 'L'],
	  short: ['su', 'må', 'ty', 'on', 'to', 'fr', 'lau'],
	  abbreviated: ['sun', 'mån', 'tys', 'ons', 'tor', 'fre', 'laur'],
	  wide: ['sundag', 'måndag', 'tysdag', 'onsdag', 'torsdag', 'fredag', 'laurdag']
	};
	var dayPeriodValues = {
	  narrow: {
	    am: 'a',
	    pm: 'p',
	    midnight: 'midnatt',
	    noon: 'middag',
	    morning: 'på morg.',
	    afternoon: 'på etterm.',
	    evening: 'på kvelden',
	    night: 'på natta'
	  },
	  abbreviated: {
	    am: 'a.m.',
	    pm: 'p.m.',
	    midnight: 'midnatt',
	    noon: 'middag',
	    morning: 'på morg.',
	    afternoon: 'på etterm.',
	    evening: 'på kvelden',
	    night: 'på natta'
	  },
	  wide: {
	    am: 'a.m.',
	    pm: 'p.m.',
	    midnight: 'midnatt',
	    noon: 'middag',
	    morning: 'på morgonen',
	    afternoon: 'på ettermiddagen',
	    evening: 'på kvelden',
	    night: 'på natta'
	  }
	};
	
	function ordinalNumber(dirtyNumber) {
	  var number = Number(dirtyNumber);
	  return number + '.';
	}
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1375 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(15));
	
	var _index2 = _interopRequireDefault(__webpack_require__(14));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(\d+)\.?/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^(f\.? ?Kr\.?|fvt\.?|e\.? ?Kr\.?|evt\.?)/i,
	  abbreviated: /^(f\.? ?Kr\.?|fvt\.?|e\.? ?Kr\.?|evt\.?)/i,
	  wide: /^(før Kristus|før vår tid|etter Kristus|vår tid)/i
	};
	var parseEraPatterns = {
	  any: [/^f/i, /^e/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^q[1234]/i,
	  wide: /^[1234](\.)? kvartal/i
	};
	var parseQuarterPatterns = {
	  any: [/1/i, /2/i, /3/i, /4/i]
	};
	var matchMonthPatterns = {
	  narrow: /^[jfmasond]/i,
	  abbreviated: /^(jan|feb|mars?|apr|mai|juni?|juli?|aug|sep|okt|nov|des)\.?/i,
	  wide: /^(januar|februar|mars|april|mai|juni|juli|august|september|oktober|november|desember)/i
	};
	var parseMonthPatterns = {
	  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
	  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^mai/i, /^jun/i, /^jul/i, /^aug/i, /^s/i, /^o/i, /^n/i, /^d/i]
	};
	var matchDayPatterns = {
	  narrow: /^[smtofl]/i,
	  short: /^(su|må|ty|on|to|fr|la)/i,
	  abbreviated: /^(sun|mån|tys|ons|tor|fre|laur)/i,
	  wide: /^(sundag|måndag|tysdag|onsdag|torsdag|fredag|laurdag)/i
	};
	var parseDayPatterns = {
	  any: [/^s/i, /^m/i, /^ty/i, /^o/i, /^to/i, /^f/i, /^l/i]
	};
	var matchDayPeriodPatterns = {
	  narrow: /^(midnatt|middag|(på) (morgonen|ettermiddagen|kvelden|natta)|[ap])/i,
	  any: /^([ap]\.?\s?m\.?|midnatt|middag|(på) (morgonen|ettermiddagen|kvelden|natta))/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^a(\.?\s?m\.?)?$/i,
	    pm: /^p(\.?\s?m\.?)?$/i,
	    midnight: /^midn/i,
	    noon: /^midd/i,
	    morning: /morgon/i,
	    afternoon: /ettermiddag/i,
	    evening: /kveld/i,
	    night: /natt/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index2.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index2.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index2.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index2.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index2.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1376 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1371));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1372));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1373));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1374));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1375));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Norwegian Nynorsk locale.
	 * @language Norwegian Nynorsk
	 * @iso-639-2 nno
	 * @author Mats Byrkjeland [@draperunner]{@link https://github.com/draperunner}
	 */
	var locale = {
	  code: 'nn',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 1
	    /* Monday */
	    ,
	    firstWeekContainsDate: 4
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1377 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistance;
	
	function declensionGroup(scheme, count) {
	  if (count === 1) {
	    return scheme.one;
	  }
	
	  var rem100 = count % 100; // ends with 11-20
	
	  if (rem100 <= 20 && rem100 > 10) {
	    return scheme.other;
	  }
	
	  var rem10 = rem100 % 10; // ends with 2, 3, 4
	
	  if (rem10 >= 2 && rem10 <= 4) {
	    return scheme.twoFour;
	  }
	
	  return scheme.other;
	}
	
	function declension(scheme, count, time) {
	  time = time || 'regular';
	  var group = declensionGroup(scheme, count);
	  var finalText = group[time] || group;
	  return finalText.replace('{{count}}', count);
	}
	
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    one: {
	      regular: 'mniej niż sekunda',
	      past: 'mniej niż sekundę',
	      future: 'mniej niż sekundę'
	    },
	    twoFour: 'mniej niż {{count}} sekundy',
	    other: 'mniej niż {{count}} sekund'
	  },
	  xSeconds: {
	    one: {
	      regular: 'sekunda',
	      past: 'sekundę',
	      future: 'sekundę'
	    },
	    twoFour: '{{count}} sekundy',
	    other: '{{count}} sekund'
	  },
	  halfAMinute: {
	    one: 'pół minuty',
	    twoFour: 'pół minuty',
	    other: 'pół minuty'
	  },
	  lessThanXMinutes: {
	    one: {
	      regular: 'mniej niż minuta',
	      past: 'mniej niż minutę',
	      future: 'mniej niż minutę'
	    },
	    twoFour: 'mniej niż {{count}} minuty',
	    other: 'mniej niż {{count}} minut'
	  },
	  xMinutes: {
	    one: {
	      regular: 'minuta',
	      past: 'minutę',
	      future: 'minutę'
	    },
	    twoFour: '{{count}} minuty',
	    other: '{{count}} minut'
	  },
	  aboutXHours: {
	    one: {
	      regular: 'około godziny',
	      past: 'około godziny',
	      future: 'około godzinę'
	    },
	    twoFour: 'około {{count}} godziny',
	    other: 'około {{count}} godzin'
	  },
	  xHours: {
	    one: {
	      regular: 'godzina',
	      past: 'godzinę',
	      future: 'godzinę'
	    },
	    twoFour: '{{count}} godziny',
	    other: '{{count}} godzin'
	  },
	  xDays: {
	    one: {
	      regular: 'dzień',
	      past: 'dzień',
	      future: '1 dzień'
	    },
	    twoFour: '{{count}} dni',
	    other: '{{count}} dni'
	  },
	  aboutXWeeks: {
	    one: 'około tygodnia',
	    twoFour: 'około {{count}} tygodni',
	    other: 'około {{count}} tygodni'
	  },
	  xWeeks: {
	    one: 'tydzień',
	    twoFour: '{{count}} tygodnie',
	    other: '{{count}} tygodni'
	  },
	  aboutXMonths: {
	    one: 'około miesiąc',
	    twoFour: 'około {{count}} miesiące',
	    other: 'około {{count}} miesięcy'
	  },
	  xMonths: {
	    one: 'miesiąc',
	    twoFour: '{{count}} miesiące',
	    other: '{{count}} miesięcy'
	  },
	  aboutXYears: {
	    one: 'około rok',
	    twoFour: 'około {{count}} lata',
	    other: 'około {{count}} lat'
	  },
	  xYears: {
	    one: 'rok',
	    twoFour: '{{count}} lata',
	    other: '{{count}} lat'
	  },
	  overXYears: {
	    one: 'ponad rok',
	    twoFour: 'ponad {{count}} lata',
	    other: 'ponad {{count}} lat'
	  },
	  almostXYears: {
	    one: 'prawie rok',
	    twoFour: 'prawie {{count}} lata',
	    other: 'prawie {{count}} lat'
	  }
	};
	
	function formatDistance(token, count, options) {
	  options = options || {};
	  var scheme = formatDistanceLocale[token];
	
	  if (!options.addSuffix) {
	    return declension(scheme, count);
	  }
	
	  if (options.comparison > 0) {
	    return 'za ' + declension(scheme, count, 'future');
	  } else {
	    return declension(scheme, count, 'past') + ' temu';
	  }
	}
	
	module.exports = exports.default;

/***/ },
/* 1378 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: 'EEEE, do MMMM y',
	  long: 'do MMMM y',
	  medium: 'do MMM y',
	  short: 'dd.MM.y'
	};
	var timeFormats = {
	  full: 'HH:mm:ss zzzz',
	  long: 'HH:mm:ss z',
	  medium: 'HH:mm:ss',
	  short: 'HH:mm'
	};
	var dateTimeFormats = {
	  full: '{{date}} {{time}}',
	  long: '{{date}} {{time}}',
	  medium: '{{date}}, {{time}}',
	  short: '{{date}}, {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1379 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRelative;
	
	var _index = _interopRequireDefault(__webpack_require__(71));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var adjectivesLastWeek = {
	  masculine: 'ostatni',
	  feminine: 'ostatnia'
	};
	var adjectivesThisWeek = {
	  masculine: 'ten',
	  feminine: 'ta'
	};
	var adjectivesNextWeek = {
	  masculine: 'następny',
	  feminine: 'następna'
	};
	var dayGrammaticalGender = {
	  0: 'feminine',
	  1: 'masculine',
	  2: 'masculine',
	  3: 'feminine',
	  4: 'masculine',
	  5: 'masculine',
	  6: 'feminine'
	};
	
	function getAdjectives(token, date, baseDate, options) {
	  if ((0, _index.default)(date, baseDate, options)) {
	    return adjectivesThisWeek;
	  } else if (token === 'lastWeek') {
	    return adjectivesLastWeek;
	  } else if (token === 'nextWeek') {
	    return adjectivesNextWeek;
	  } else {
	    throw new Error("Cannot determine adjectives for token ".concat(token));
	  }
	}
	
	function getAdjective(token, date, baseDate, options) {
	  var day = date.getUTCDay();
	  var adjectives = getAdjectives(token, date, baseDate, options);
	  var grammaticalGender = dayGrammaticalGender[day];
	  return adjectives[grammaticalGender];
	}
	
	function dayAndTimeWithAdjective(token, date, baseDate, options) {
	  var adjective = getAdjective(token, date, baseDate, options);
	  return "'".concat(adjective, "' eeee 'o' p");
	}
	
	var formatRelativeLocale = {
	  lastWeek: dayAndTimeWithAdjective,
	  yesterday: "'wczoraj o' p",
	  today: "'dzisiaj o' p",
	  tomorrow: "'jutro o' p",
	  nextWeek: dayAndTimeWithAdjective,
	  other: 'P'
	};
	
	function formatRelative(token, date, baseDate, options) {
	  var format = formatRelativeLocale[token];
	
	  if (typeof format === 'function') {
	    return format(token, date, baseDate, options);
	  }
	
	  return format;
	}
	
	module.exports = exports.default;

/***/ },
/* 1380 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ordinalNumber(dirtyNumber) {
	  var number = Number(dirtyNumber);
	  return String(number);
	}
	
	var eraValues = {
	  narrow: ['p.n.e.', 'n.e.'],
	  abbreviated: ['p.n.e.', 'n.e.'],
	  wide: ['przed naszą erą', 'naszej ery']
	};
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['I kw.', 'II kw.', 'III kw.', 'IV kw.'],
	  wide: ['I kwartał', 'II kwartał', 'III kwartał', 'IV kwartał']
	};
	var monthValues = {
	  narrow: ['S', 'L', 'M', 'K', 'M', 'C', 'L', 'S', 'W', 'P', 'L', 'G'],
	  abbreviated: ['sty', 'lut', 'mar', 'kwi', 'maj', 'cze', 'lip', 'sie', 'wrz', 'paź', 'lis', 'gru'],
	  wide: ['styczeń', 'luty', 'marzec', 'kwiecień', 'maj', 'czerwiec', 'lipiec', 'sierpień', 'wrzesień', 'październik', 'listopad', 'grudzień']
	};
	var monthFormattingValues = {
	  narrow: ['s', 'l', 'm', 'k', 'm', 'c', 'l', 's', 'w', 'p', 'l', 'g'],
	  abbreviated: ['sty', 'lut', 'mar', 'kwi', 'maj', 'cze', 'lip', 'sie', 'wrz', 'paź', 'lis', 'gru'],
	  wide: ['stycznia', 'lutego', 'marca', 'kwietnia', 'maja', 'czerwca', 'lipca', 'sierpnia', 'września', 'października', 'listopada', 'grudnia']
	};
	var dayValues = {
	  narrow: ['N', 'P', 'W', 'Ś', 'C', 'P', 'S'],
	  short: ['nie', 'pon', 'wto', 'śro', 'czw', 'pią', 'sob'],
	  abbreviated: ['niedz.', 'pon.', 'wt.', 'śr.', 'czw.', 'pt.', 'sob.'],
	  wide: ['niedziela', 'poniedziałek', 'wtorek', 'środa', 'czwartek', 'piątek', 'sobota']
	};
	var dayFormattingValues = {
	  narrow: ['n', 'p', 'w', 'ś', 'c', 'p', 's'],
	  short: ['nie', 'pon', 'wto', 'śro', 'czw', 'pią', 'sob'],
	  abbreviated: ['niedz.', 'pon.', 'wt.', 'śr.', 'czw.', 'pt.', 'sob.'],
	  wide: ['niedziela', 'poniedziałek', 'wtorek', 'środa', 'czwartek', 'piątek', 'sobota']
	};
	var dayPeriodValues = {
	  narrow: {
	    am: 'a',
	    pm: 'p',
	    midnight: 'półn.',
	    noon: 'poł',
	    morning: 'rano',
	    afternoon: 'popoł.',
	    evening: 'wiecz.',
	    night: 'noc'
	  },
	  abbreviated: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'północ',
	    noon: 'południe',
	    morning: 'rano',
	    afternoon: 'popołudnie',
	    evening: 'wieczór',
	    night: 'noc'
	  },
	  wide: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'północ',
	    noon: 'południe',
	    morning: 'rano',
	    afternoon: 'popołudnie',
	    evening: 'wieczór',
	    night: 'noc'
	  }
	};
	var dayPeriodFormattingValues = {
	  narrow: {
	    am: 'a',
	    pm: 'p',
	    midnight: 'o półn.',
	    noon: 'w poł.',
	    morning: 'rano',
	    afternoon: 'po poł.',
	    evening: 'wiecz.',
	    night: 'w nocy'
	  },
	  abbreviated: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'o północy',
	    noon: 'w południe',
	    morning: 'rano',
	    afternoon: 'po południu',
	    evening: 'wieczorem',
	    night: 'w nocy'
	  },
	  wide: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'o północy',
	    noon: 'w południe',
	    morning: 'rano',
	    afternoon: 'po południu',
	    evening: 'wieczorem',
	    night: 'w nocy'
	  }
	};
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide',
	    formattingValues: monthFormattingValues,
	    defaultFormattingWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide',
	    formattingValues: dayFormattingValues,
	    defaultFormattingWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide',
	    formattingValues: dayPeriodFormattingValues,
	    defaultFormattingWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1381 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(15));
	
	var _index2 = _interopRequireDefault(__webpack_require__(14));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(\d+)?/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^(p\.?\s*n\.?\s*e\.?\s*|n\.?\s*e\.?\s*)/i,
	  abbreviated: /^(p\.?\s*n\.?\s*e\.?\s*|n\.?\s*e\.?\s*)/i,
	  wide: /^(przed\s*nasz(ą|a)\s*er(ą|a)|naszej\s*ery)/i
	};
	var parseEraPatterns = {
	  any: [/^p/i, /^n/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^(I|II|III|IV)\s*kw\.?/i,
	  wide: /^(I|II|III|IV)\s*kwarta(ł|l)/i
	};
	var parseQuarterPatterns = {
	  narrow: [/1/i, /2/i, /3/i, /4/i],
	  any: [/^I kw/i, /^II kw/i, /^III kw/i, /^IV kw/i]
	};
	var matchMonthPatterns = {
	  narrow: /^[slmkcwpg]/i,
	  abbreviated: /^(sty|lut|mar|kwi|maj|cze|lip|sie|wrz|pa(ź|z)|lis|gru)/i,
	  wide: /^(stycznia|stycze(ń|n)|lutego|luty|marca|marzec|kwietnia|kwiecie(ń|n)|maja|maj|czerwca|czerwiec|lipca|lipiec|sierpnia|sierpie(ń|n)|wrze(ś|s)nia|wrzesie(ń|n)|pa(ź|z)dziernika|pa(ź|z)dziernik|listopada|listopad|grudnia|grudzie(ń|n))/i
	};
	var parseMonthPatterns = {
	  narrow: [/^s/i, /^l/i, /^m/i, /^k/i, /^m/i, /^c/i, /^l/i, /^s/i, /^w/i, /^p/i, /^l/i, /^g/i],
	  any: [/^st/i, /^lu/i, /^mar/i, /^k/i, /^maj/i, /^c/i, /^lip/i, /^si/i, /^w/i, /^p/i, /^lis/i, /^g/i]
	};
	var matchDayPatterns = {
	  narrow: /^[npwścs]/i,
	  short: /^(nie|pon|wto|(ś|s)ro|czw|pi(ą|a)|sob)/i,
	  abbreviated: /^(niedz|pon|wt|(ś|s)r|czw|pt|sob)\.?/i,
	  wide: /^(niedziela|poniedzia(ł|l)ek|wtorek|(ś|s)roda|czwartek|pi(ą|a)tek|sobota)/i
	};
	var parseDayPatterns = {
	  narrow: [/^n/i, /^p/i, /^w/i, /^ś/i, /^c/i, /^p/i, /^s/i],
	  abbreviated: [/^n/i, /^po/i, /^w/i, /^(ś|s)r/i, /^c/i, /^pt/i, /^so/i],
	  any: [/^n/i, /^po/i, /^w/i, /^(ś|s)r/i, /^c/i, /^pi/i, /^so/i]
	};
	var matchDayPeriodPatterns = {
	  narrow: /^(^a$|^p$|pó(ł|l)n\.?|o\s*pó(ł|l)n\.?|po(ł|l)\.?|w\s*po(ł|l)\.?|po\s*po(ł|l)\.?|rano|wiecz\.?|noc|w\s*nocy)/i,
	  any: /^(am|pm|pó(ł|l)noc|o\s*pó(ł|l)nocy|po(ł|l)udnie|w\s*po(ł|l)udnie|popo(ł|l)udnie|po\s*po(ł|l)udniu|rano|wieczór|wieczorem|noc|w\s*nocy)/i
	};
	var parseDayPeriodPatterns = {
	  narrow: {
	    am: /^a$/i,
	    pm: /^p$/i,
	    midnight: /pó(ł|l)n/i,
	    noon: /po(ł|l)/i,
	    morning: /rano/i,
	    afternoon: /po\s*po(ł|l)/i,
	    evening: /wiecz/i,
	    night: /noc/i
	  },
	  any: {
	    am: /^am/i,
	    pm: /^pm/i,
	    midnight: /pó(ł|l)n/i,
	    noon: /po(ł|l)/i,
	    morning: /rano/i,
	    afternoon: /po\s*po(ł|l)/i,
	    evening: /wiecz/i,
	    night: /noc/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index2.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index2.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index2.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index2.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index2.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1382 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1377));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1378));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1379));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1380));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1381));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Polish locale.
	 * @language Polish
	 * @iso-639-2 pol
	 * @author Mateusz Derks [@ertrzyiks]{@link https://github.com/ertrzyiks}
	 * @author Just RAG [@justrag]{@link https://github.com/justrag}
	 * @author Mikolaj Grzyb [@mikolajgrzyb]{@link https://github.com/mikolajgrzyb}
	 * @author Mateusz Tokarski [@mutisz]{@link https://github.com/mutisz}
	 */
	var locale = {
	  code: 'pl',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 1
	    /* Monday */
	    ,
	    firstWeekContainsDate: 4
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1383 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistance;
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    one: 'menos de um segundo',
	    other: 'menos de {{count}} segundos'
	  },
	  xSeconds: {
	    one: '1 segundo',
	    other: '{{count}} segundos'
	  },
	  halfAMinute: 'meio minuto',
	  lessThanXMinutes: {
	    one: 'menos de um minuto',
	    other: 'menos de {{count}} minutos'
	  },
	  xMinutes: {
	    one: '1 minuto',
	    other: '{{count}} minutos'
	  },
	  aboutXHours: {
	    one: 'cerca de 1 hora',
	    other: 'cerca de {{count}} horas'
	  },
	  xHours: {
	    one: '1 hora',
	    other: '{{count}} horas'
	  },
	  xDays: {
	    one: '1 dia',
	    other: '{{count}} dias'
	  },
	  aboutXWeeks: {
	    one: 'cerca de 1 semana',
	    other: 'cerca de {{count}} semanas'
	  },
	  xWeeks: {
	    one: '1 semana',
	    other: '{{count}} semanas'
	  },
	  aboutXMonths: {
	    one: 'cerca de 1 mês',
	    other: 'cerca de {{count}} meses'
	  },
	  xMonths: {
	    one: '1 mês',
	    other: '{{count}} meses'
	  },
	  aboutXYears: {
	    one: 'cerca de 1 ano',
	    other: 'cerca de {{count}} anos'
	  },
	  xYears: {
	    one: '1 ano',
	    other: '{{count}} anos'
	  },
	  overXYears: {
	    one: 'mais de 1 ano',
	    other: 'mais de {{count}} anos'
	  },
	  almostXYears: {
	    one: 'quase 1 ano',
	    other: 'quase {{count}} anos'
	  }
	};
	
	function formatDistance(token, count, options) {
	  options = options || {};
	  var result;
	
	  if (typeof formatDistanceLocale[token] === 'string') {
	    result = formatDistanceLocale[token];
	  } else if (count === 1) {
	    result = formatDistanceLocale[token].one;
	  } else {
	    result = formatDistanceLocale[token].other.replace('{{count}}', count);
	  }
	
	  if (options.addSuffix) {
	    if (options.comparison > 0) {
	      return 'em ' + result;
	    } else {
	      return 'há ' + result;
	    }
	  }
	
	  return result;
	}
	
	module.exports = exports.default;

/***/ },
/* 1384 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: "EEEE, d 'de' MMMM 'de' y",
	  long: "d 'de' MMMM 'de' y",
	  medium: 'd MMM y',
	  short: 'dd/MM/yyyy'
	};
	var timeFormats = {
	  full: 'HH:mm:ss zzzz',
	  long: 'HH:mm:ss z',
	  medium: 'HH:mm:ss',
	  short: 'HH:mm'
	};
	var dateTimeFormats = {
	  full: "{{date}} 'às' {{time}}",
	  long: "{{date}} 'às' {{time}}",
	  medium: '{{date}}, {{time}}',
	  short: '{{date}}, {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1385 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRelative;
	var formatRelativeLocale = {
	  lastWeek: function (date, _baseDate, _options) {
	    var weekday = date.getUTCDay();
	    var last = weekday === 0 || weekday === 6 ? 'último' : 'última';
	    return "'" + last + "' eeee 'às' p";
	  },
	  yesterday: "'ontem às' p",
	  today: "'hoje às' p",
	  tomorrow: "'amanhã às' p",
	  nextWeek: "eeee 'às' p",
	  other: 'P'
	};
	
	function formatRelative(token, date, baseDate, options) {
	  var format = formatRelativeLocale[token];
	
	  if (typeof format === 'function') {
	    return format(date, baseDate, options);
	  }
	
	  return format;
	}
	
	module.exports = exports.default;

/***/ },
/* 1386 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eraValues = {
	  narrow: ['AC', 'DC'],
	  abbreviated: ['AC', 'DC'],
	  wide: ['antes de cristo', 'depois de cristo']
	};
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['T1', 'T2', 'T3', 'T4'],
	  wide: ['1º trimestre', '2º trimestre', '3º trimestre', '4º trimestre']
	};
	var monthValues = {
	  narrow: ['j', 'f', 'm', 'a', 'm', 'j', 'j', 'a', 's', 'o', 'n', 'd'],
	  abbreviated: ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez'],
	  wide: ['janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho', 'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro']
	};
	var dayValues = {
	  narrow: ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'],
	  short: ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sab'],
	  abbreviated: ['domingo', 'segunda', 'terça', 'quarta', 'quinta', 'sexta', 'sábado'],
	  wide: ['domingo', 'segunda-feira', 'terça-feira', 'quarta-feira', 'quinta-feira', 'sexta-feira', 'sábado']
	};
	var dayPeriodValues = {
	  narrow: {
	    am: 'a',
	    pm: 'p',
	    midnight: 'mn',
	    noon: 'md',
	    morning: 'manhã',
	    afternoon: 'tarde',
	    evening: 'tarde',
	    night: 'noite'
	  },
	  abbreviated: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'meia-noite',
	    noon: 'meio-dia',
	    morning: 'manhã',
	    afternoon: 'tarde',
	    evening: 'tarde',
	    night: 'noite'
	  },
	  wide: {
	    am: 'a.m.',
	    pm: 'p.m.',
	    midnight: 'meia-noite',
	    noon: 'meio-dia',
	    morning: 'manhã',
	    afternoon: 'tarde',
	    evening: 'tarde',
	    night: 'noite'
	  }
	};
	var formattingDayPeriodValues = {
	  narrow: {
	    am: 'a',
	    pm: 'p',
	    midnight: 'mn',
	    noon: 'md',
	    morning: 'da manhã',
	    afternoon: 'da tarde',
	    evening: 'da tarde',
	    night: 'da noite'
	  },
	  abbreviated: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'meia-noite',
	    noon: 'meio-dia',
	    morning: 'da manhã',
	    afternoon: 'da tarde',
	    evening: 'da tarde',
	    night: 'da noite'
	  },
	  wide: {
	    am: 'a.m.',
	    pm: 'p.m.',
	    midnight: 'meia-noite',
	    noon: 'meio-dia',
	    morning: 'da manhã',
	    afternoon: 'da tarde',
	    evening: 'da tarde',
	    night: 'da noite'
	  }
	};
	
	function ordinalNumber(dirtyNumber, dirtyOptions) {
	  var number = Number(dirtyNumber);
	  var options = dirtyOptions || {};
	  var unit = String(options.unit);
	
	  if (unit === 'week' || unit === 'isoWeek') {
	    return number + 'ª';
	  }
	
	  return number + 'º';
	}
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingDayPeriodValues,
	    defaultFormattingWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1387 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(14));
	
	var _index2 = _interopRequireDefault(__webpack_require__(15));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(\d+)[ºªo]?/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^(ac|dc|a|d)/i,
	  abbreviated: /^(a\.?\s?c\.?|d\.?\s?c\.?)/i,
	  wide: /^(antes de cristo|depois de cristo)/i
	};
	var parseEraPatterns = {
	  any: [/^ac/i, /^dc/i],
	  wide: [/^antes de cristo/i, /^depois de cristo/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^T[1234]/i,
	  wide: /^[1234](º)? trimestre/i
	};
	var parseQuarterPatterns = {
	  any: [/1/i, /2/i, /3/i, /4/i]
	};
	var matchMonthPatterns = {
	  narrow: /^[jfmajsond]/i,
	  abbreviated: /^(jan|fev|mar|abr|mai|jun|jul|ago|set|out|nov|dez)/i,
	  wide: /^(janeiro|fevereiro|março|abril|maio|junho|julho|agosto|setembro|outubro|novembro|dezembro)/i
	};
	var parseMonthPatterns = {
	  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
	  any: [/^ja/i, /^fev/i, /^mar/i, /^abr/i, /^mai/i, /^jun/i, /^jul/i, /^ago/i, /^set/i, /^out/i, /^nov/i, /^dez/i]
	};
	var matchDayPatterns = {
	  narrow: /^(dom|[23456]ª?|s[aá]b)/i,
	  short: /^(dom|[23456]ª?|s[aá]b)/i,
	  abbreviated: /^(dom|seg|ter|qua|qui|sex|s[aá]b)/i,
	  wide: /^(domingo|(segunda|ter[cç]a|quarta|quinta|sexta)([- ]feira)?|s[aá]bado)/i
	};
	var parseDayPatterns = {
	  short: [/^d/i, /^2/i, /^3/i, /^4/i, /^5/i, /^6/i, /^s[aá]/i],
	  narrow: [/^d/i, /^2/i, /^3/i, /^4/i, /^5/i, /^6/i, /^s[aá]/i],
	  any: [/^d/i, /^seg/i, /^t/i, /^qua/i, /^qui/i, /^sex/i, /^s[aá]b/i]
	};
	var matchDayPeriodPatterns = {
	  narrow: /^(a|p|mn|md|(da) (manhã|tarde|noite))/i,
	  any: /^([ap]\.?\s?m\.?|meia[-\s]noite|meio[-\s]dia|(da) (manhã|tarde|noite))/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^a/i,
	    pm: /^p/i,
	    midnight: /^mn|^meia[-\s]noite/i,
	    noon: /^md|^meio[-\s]dia/i,
	    morning: /manhã/i,
	    afternoon: /tarde/i,
	    evening: /tarde/i,
	    night: /noite/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index2.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1388 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1383));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1384));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1385));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1386));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1387));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Portuguese locale (Brazil).
	 * @language Portuguese
	 * @iso-639-2 por
	 * @author Lucas Duailibe [@duailibe]{@link https://github.com/duailibe}
	 * @author Yago Carballo [@yagocarballo]{@link https://github.com/YagoCarballo}
	 */
	var locale = {
	  code: 'pt-BR',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 0
	    /* Sunday */
	    ,
	    firstWeekContainsDate: 1
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1389 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistance;
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    one: 'menos de um segundo',
	    other: 'menos de {{count}} segundos'
	  },
	  xSeconds: {
	    one: '1 segundo',
	    other: '{{count}} segundos'
	  },
	  halfAMinute: 'meio minuto',
	  lessThanXMinutes: {
	    one: 'menos de um minuto',
	    other: 'menos de {{count}} minutos'
	  },
	  xMinutes: {
	    one: '1 minuto',
	    other: '{{count}} minutos'
	  },
	  aboutXHours: {
	    one: 'aproximadamente 1 hora',
	    other: 'aproximadamente {{count}} horas'
	  },
	  xHours: {
	    one: '1 hora',
	    other: '{{count}} horas'
	  },
	  xDays: {
	    one: '1 dia',
	    other: '{{count}} dias'
	  },
	  aboutXWeeks: {
	    one: 'aproximadamente 1 semana',
	    other: 'aproximadamente {{count}} semanas'
	  },
	  xWeeks: {
	    one: '1 semana',
	    other: '{{count}} semanas'
	  },
	  aboutXMonths: {
	    one: 'aproximadamente 1 mês',
	    other: 'aproximadamente {{count}} meses'
	  },
	  xMonths: {
	    one: '1 mês',
	    other: '{{count}} meses'
	  },
	  aboutXYears: {
	    one: 'aproximadamente 1 ano',
	    other: 'aproximadamente {{count}} anos'
	  },
	  xYears: {
	    one: '1 ano',
	    other: '{{count}} anos'
	  },
	  overXYears: {
	    one: 'mais de 1 ano',
	    other: 'mais de {{count}} anos'
	  },
	  almostXYears: {
	    one: 'quase 1 ano',
	    other: 'quase {{count}} anos'
	  }
	};
	
	function formatDistance(token, count, options) {
	  options = options || {};
	  var result;
	
	  if (typeof formatDistanceLocale[token] === 'string') {
	    result = formatDistanceLocale[token];
	  } else if (count === 1) {
	    result = formatDistanceLocale[token].one;
	  } else {
	    result = formatDistanceLocale[token].other.replace('{{count}}', count);
	  }
	
	  if (options.addSuffix) {
	    if (options.comparison > 0) {
	      return 'daqui a ' + result;
	    } else {
	      return 'há ' + result;
	    }
	  }
	
	  return result;
	}
	
	module.exports = exports.default;

/***/ },
/* 1390 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: "EEEE, d 'de' MMMM 'de' y",
	  long: "d 'de' MMMM 'de' y",
	  medium: "d 'de' MMM 'de' y",
	  short: 'dd/MM/y'
	};
	var timeFormats = {
	  full: 'HH:mm:ss zzzz',
	  long: 'HH:mm:ss z',
	  medium: 'HH:mm:ss',
	  short: 'HH:mm'
	};
	var dateTimeFormats = {
	  full: "{{date}} 'às' {{time}}",
	  long: "{{date}} 'às' {{time}}",
	  medium: '{{date}}, {{time}}',
	  short: '{{date}}, {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1391 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRelative;
	var formatRelativeLocale = {
	  lastWeek: "'na última' eeee 'às' p",
	  yesterday: "'ontem às' p",
	  today: "'hoje às' p",
	  tomorrow: "'amanhã às' p",
	  nextWeek: "eeee 'às' p",
	  other: 'P'
	};
	
	function formatRelative(token, _date, _baseDate, _options) {
	  return formatRelativeLocale[token];
	}
	
	module.exports = exports.default;

/***/ },
/* 1392 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ordinalNumber(dirtyNumber) {
	  var number = Number(dirtyNumber);
	  return number + 'º';
	}
	
	var eraValues = {
	  narrow: ['aC', 'dC'],
	  abbreviated: ['a.C.', 'd.C.'],
	  wide: ['antes de Cristo', 'depois de Cristo']
	};
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['T1', 'T2', 'T3', 'T4'],
	  wide: ['1º trimestre', '2º trimestre', '3º trimestre', '4º trimestre']
	};
	var monthValues = {
	  narrow: ['j', 'f', 'm', 'a', 'm', 'j', 'j', 'a', 's', 'o', 'n', 'd'],
	  abbreviated: ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez'],
	  wide: ['janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho', 'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro']
	};
	var dayValues = {
	  narrow: ['d', 's', 't', 'q', 'q', 's', 's'],
	  short: ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sáb'],
	  abbreviated: ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sáb'],
	  wide: ['domingo', 'segunda-feira', 'terça-feira', 'quarta-feira', 'quinta-feira', 'sexta-feira', 'sábado']
	};
	var dayPeriodValues = {
	  narrow: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'meia-noite',
	    noon: 'meio-dia',
	    morning: 'manhã',
	    afternoon: 'tarde',
	    evening: 'noite',
	    night: 'madrugada'
	  },
	  abbreviated: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'meia-noite',
	    noon: 'meio-dia',
	    morning: 'manhã',
	    afternoon: 'tarde',
	    evening: 'noite',
	    night: 'madrugada'
	  },
	  wide: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'meia-noite',
	    noon: 'meio-dia',
	    morning: 'manhã',
	    afternoon: 'tarde',
	    evening: 'noite',
	    night: 'madrugada'
	  }
	};
	var formattingDayPeriodValues = {
	  narrow: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'meia-noite',
	    noon: 'meio-dia',
	    morning: 'da manhã',
	    afternoon: 'da tarde',
	    evening: 'da noite',
	    night: 'da madrugada'
	  },
	  abbreviated: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'meia-noite',
	    noon: 'meio-dia',
	    morning: 'da manhã',
	    afternoon: 'da tarde',
	    evening: 'da noite',
	    night: 'da madrugada'
	  },
	  wide: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'meia-noite',
	    noon: 'meio-dia',
	    morning: 'da manhã',
	    afternoon: 'da tarde',
	    evening: 'da noite',
	    night: 'da madrugada'
	  }
	};
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingDayPeriodValues,
	    defaultFormattingWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1393 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(15));
	
	var _index2 = _interopRequireDefault(__webpack_require__(14));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(\d+)(º|ª)?/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^(ac|dc|a|d)/i,
	  abbreviated: /^(a\.?\s?c\.?|a\.?\s?e\.?\s?c\.?|d\.?\s?c\.?|e\.?\s?c\.?)/i,
	  wide: /^(antes de cristo|antes da era comum|depois de cristo|era comum)/i
	};
	var parseEraPatterns = {
	  any: [/^ac/i, /^dc/i],
	  wide: [/^(antes de cristo|antes da era comum)/i, /^(depois de cristo|era comum)/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^T[1234]/i,
	  wide: /^[1234](º|ª)? trimestre/i
	};
	var parseQuarterPatterns = {
	  any: [/1/i, /2/i, /3/i, /4/i]
	};
	var matchMonthPatterns = {
	  narrow: /^[jfmasond]/i,
	  abbreviated: /^(jan|fev|mar|abr|mai|jun|jul|ago|set|out|nov|dez)/i,
	  wide: /^(janeiro|fevereiro|março|abril|maio|junho|julho|agosto|setembro|outubro|novembro|dezembro)/i
	};
	var parseMonthPatterns = {
	  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
	  any: [/^ja/i, /^f/i, /^mar/i, /^ab/i, /^mai/i, /^jun/i, /^jul/i, /^ag/i, /^s/i, /^o/i, /^n/i, /^d/i]
	};
	var matchDayPatterns = {
	  narrow: /^[dstq]/i,
	  short: /^(dom|seg|ter|qua|qui|sex|s[áa]b)/i,
	  abbreviated: /^(dom|seg|ter|qua|qui|sex|s[áa]b)/i,
	  wide: /^(domingo|segunda-?\s?feira|terça-?\s?feira|quarta-?\s?feira|quinta-?\s?feira|sexta-?\s?feira|s[áa]bado)/i
	};
	var parseDayPatterns = {
	  narrow: [/^d/i, /^s/i, /^t/i, /^q/i, /^q/i, /^s/i, /^s/i],
	  any: [/^d/i, /^seg/i, /^t/i, /^qua/i, /^qui/i, /^sex/i, /^s[áa]/i]
	};
	var matchDayPeriodPatterns = {
	  narrow: /^(a|p|meia-?\s?noite|meio-?\s?dia|(da) (manh[ãa]|tarde|noite|madrugada))/i,
	  any: /^([ap]\.?\s?m\.?|meia-?\s?noite|meio-?\s?dia|(da) (manh[ãa]|tarde|noite|madrugada))/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^a/i,
	    pm: /^p/i,
	    midnight: /^meia/i,
	    noon: /^meio/i,
	    morning: /manh[ãa]/i,
	    afternoon: /tarde/i,
	    evening: /noite/i,
	    night: /madrugada/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index2.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index2.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index2.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index2.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index2.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1394 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1389));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1390));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1391));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1392));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1393));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Portuguese locale.
	 * @language Portuguese
	 * @iso-639-2 por
	 * @author Dário Freire [@dfreire]{@link https://github.com/dfreire}
	 * @author Adrián de la Rosa [@adrm]{@link https://github.com/adrm}
	 */
	var locale = {
	  code: 'pt',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 1
	    /* Monday */
	    ,
	    firstWeekContainsDate: 4
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1395 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistance;
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    one: 'mai puțin de o secundă',
	    other: 'mai puțin de {{count}} secunde'
	  },
	  xSeconds: {
	    one: '1 secundă',
	    other: '{{count}} secunde'
	  },
	  halfAMinute: 'jumătate de minut',
	  lessThanXMinutes: {
	    one: 'mai puțin de un minut',
	    other: 'mai puțin de {{count}} minute'
	  },
	  xMinutes: {
	    one: '1 minut',
	    other: '{{count}} minute'
	  },
	  aboutXHours: {
	    one: 'circa 1 oră',
	    other: 'circa {{count}} ore'
	  },
	  xHours: {
	    one: '1 oră',
	    other: '{{count}} ore'
	  },
	  xDays: {
	    one: '1 zi',
	    other: '{{count}} zile'
	  },
	  aboutXWeeks: {
	    one: 'circa o săptămână',
	    other: 'circa {{count}} săptămâni'
	  },
	  xWeeks: {
	    one: '1 săptămână',
	    other: '{{count}} săptămâni'
	  },
	  aboutXMonths: {
	    one: 'circa 1 lună',
	    other: 'circa {{count}} luni'
	  },
	  xMonths: {
	    one: '1 lună',
	    other: '{{count}} luni'
	  },
	  aboutXYears: {
	    one: 'circa 1 an',
	    other: 'circa {{count}} ani'
	  },
	  xYears: {
	    one: '1 an',
	    other: '{{count}} ani'
	  },
	  overXYears: {
	    one: 'peste 1 an',
	    other: 'peste {{count}} ani'
	  },
	  almostXYears: {
	    one: 'aproape 1 an',
	    other: 'aproape {{count}} ani'
	  }
	};
	
	function formatDistance(token, count, options) {
	  options = options || {};
	  var result;
	
	  if (typeof formatDistanceLocale[token] === 'string') {
	    result = formatDistanceLocale[token];
	  } else if (count === 1) {
	    result = formatDistanceLocale[token].one;
	  } else {
	    result = formatDistanceLocale[token].other.replace('{{count}}', count);
	  }
	
	  if (options.addSuffix) {
	    if (options.comparison > 0) {
	      return 'în ' + result;
	    } else {
	      return result + ' în urmă';
	    }
	  }
	
	  return result;
	}
	
	module.exports = exports.default;

/***/ },
/* 1396 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: 'EEEE, d MMMM yyyy',
	  long: 'd MMMM yyyy',
	  medium: 'd MMM yyyy',
	  short: 'dd.MM.yyyy'
	};
	var timeFormats = {
	  full: 'HH:mm:ss zzzz',
	  long: 'HH:mm:ss z',
	  medium: 'HH:mm:ss',
	  short: 'HH:mm'
	};
	var dateTimeFormats = {
	  full: "{{date}} 'la' {{time}}",
	  long: "{{date}} 'la' {{time}}",
	  medium: '{{date}}, {{time}}',
	  short: '{{date}}, {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1397 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRelative;
	var formatRelativeLocale = {
	  lastWeek: "eeee 'trecută la' p",
	  yesterday: "'ieri la' p",
	  today: "'astăzi la' p",
	  tomorrow: "'mâine la' p",
	  nextWeek: "eeee 'viitoare la' p",
	  other: 'P'
	};
	
	function formatRelative(token, _date, _baseDate, _options) {
	  return formatRelativeLocale[token];
	}
	
	module.exports = exports.default;

/***/ },
/* 1398 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eraValues = {
	  narrow: ['Î', 'D'],
	  abbreviated: ['Î.d.C.', 'D.C.'],
	  wide: ['Înainte de Cristos', 'După Cristos']
	};
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['T1', 'T2', 'T3', 'T4'],
	  wide: ['primul trimestru', 'al doilea trimestru', 'al treilea trimestru', 'al patrulea trimestru']
	};
	var monthValues = {
	  narrow: ['I', 'F', 'M', 'A', 'M', 'I', 'I', 'A', 'S', 'O', 'N', 'D'],
	  abbreviated: ['ian', 'feb', 'mar', 'apr', 'mai', 'iun', 'iul', 'aug', 'sep', 'oct', 'noi', 'dec'],
	  wide: ['ianuarie', 'februarie', 'martie', 'aprilie', 'mai', 'iunie', 'iulie', 'august', 'septembrie', 'octombrie', 'noiembrie', 'decembrie']
	};
	var dayValues = {
	  narrow: ['d', 'l', 'm', 'm', 'j', 'v', 's'],
	  short: ['du', 'lu', 'ma', 'mi', 'jo', 'vi', 'sâ'],
	  abbreviated: ['dum', 'lun', 'mar', 'mie', 'joi', 'vin', 'sâm'],
	  wide: ['duminică', 'luni', 'marți', 'miercuri', 'joi', 'vineri', 'sâmbătă']
	};
	var dayPeriodValues = {
	  narrow: {
	    am: 'a',
	    pm: 'p',
	    midnight: 'mn',
	    noon: 'ami',
	    morning: 'dim',
	    afternoon: 'da',
	    evening: 's',
	    night: 'n'
	  },
	  abbreviated: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'miezul nopții',
	    noon: 'amiază',
	    morning: 'dimineață',
	    afternoon: 'după-amiază',
	    evening: 'seară',
	    night: 'noapte'
	  },
	  wide: {
	    am: 'a.m.',
	    pm: 'p.m.',
	    midnight: 'miezul nopții',
	    noon: 'amiază',
	    morning: 'dimineață',
	    afternoon: 'după-amiază',
	    evening: 'seară',
	    night: 'noapte'
	  }
	};
	var formattingDayPeriodValues = {
	  narrow: {
	    am: 'a',
	    pm: 'p',
	    midnight: 'mn',
	    noon: 'amiază',
	    morning: 'dimineață',
	    afternoon: 'după-amiază',
	    evening: 'seară',
	    night: 'noapte'
	  },
	  abbreviated: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'miezul nopții',
	    noon: 'amiază',
	    morning: 'dimineață',
	    afternoon: 'după-amiază',
	    evening: 'seară',
	    night: 'noapte'
	  },
	  wide: {
	    am: 'a.m.',
	    pm: 'p.m.',
	    midnight: 'miezul nopții',
	    noon: 'amiază',
	    morning: 'dimineață',
	    afternoon: 'după-amiază',
	    evening: 'seară',
	    night: 'noapte'
	  }
	};
	
	function ordinalNumber(dirtyNumber) {
	  var number = Number(dirtyNumber);
	  return String(number);
	}
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingDayPeriodValues,
	    defaultFormattingWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1399 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(15));
	
	var _index2 = _interopRequireDefault(__webpack_require__(14));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(\d+)?/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^(Î|D)/i,
	  abbreviated: /^(Î\.?\s?d\.?\s?C\.?|Î\.?\s?e\.?\s?n\.?|D\.?\s?C\.?|e\.?\s?n\.?)/i,
	  wide: /^(Înainte de Cristos|Înaintea erei noastre|După Cristos|Era noastră)/i
	};
	var parseEraPatterns = {
	  any: [/^ÎC/i, /^DC/i],
	  wide: [/^(Înainte de Cristos|Înaintea erei noastre)/i, /^(După Cristos|Era noastră)/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^T[1234]/i,
	  wide: /^trimestrul [1234]/i
	};
	var parseQuarterPatterns = {
	  any: [/1/i, /2/i, /3/i, /4/i]
	};
	var matchMonthPatterns = {
	  narrow: /^[ifmaasond]/i,
	  abbreviated: /^(ian|feb|mar|apr|mai|iun|iul|aug|sep|oct|noi|dec)/i,
	  wide: /^(ianuarie|februarie|martie|aprilie|mai|iunie|iulie|august|septembrie|octombrie|noiembrie|decembrie)/i
	};
	var parseMonthPatterns = {
	  narrow: [/^i/i, /^f/i, /^m/i, /^a/i, /^m/i, /^i/i, /^i/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
	  any: [/^ia/i, /^f/i, /^mar/i, /^ap/i, /^mai/i, /^iun/i, /^iul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
	};
	var matchDayPatterns = {
	  narrow: /^[dlmjvs]/i,
	  short: /^(d|l|ma|mi|j|v|s)/i,
	  abbreviated: /^(dum|lun|mar|mie|jo|vi|sâ)/i,
	  wide: /^(duminica|luni|marţi|miercuri|joi|vineri|sâmbătă)/i
	};
	var parseDayPatterns = {
	  narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^j/i, /^v/i, /^s/i],
	  any: [/^d/i, /^l/i, /^ma/i, /^mi/i, /^j/i, /^v/i, /^s/i]
	};
	var matchDayPeriodPatterns = {
	  narrow: /^(a|p|mn|a|(dimineaţa|după-amiaza|seara|noaptea))/i,
	  any: /^([ap]\.?\s?m\.?|miezul nopții|amiaza|(dimineaţa|după-amiaza|seara|noaptea))/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^a/i,
	    pm: /^p/i,
	    midnight: /^mn/i,
	    noon: /amiaza/i,
	    morning: /dimineaţa/i,
	    afternoon: /după-amiaza/i,
	    evening: /seara/i,
	    night: /noaptea/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index2.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index2.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index2.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index2.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index2.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1400 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1395));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1396));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1397));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1398));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1399));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Romanian locale.
	 * @language Romanian
	 * @iso-639-2 ron
	 * @author Sergiu Munteanu [@jsergiu]{@link https://github.com/jsergiu}
	 * @author Adrian Ocneanu [@aocneanu]{@link https://github.com/aocneanu}
	 * @author Mihai Ocneanu [@gandesc]{@link https://github.com/gandesc}
	 */
	var locale = {
	  code: 'ro',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 1
	    /* Monday */
	    ,
	    firstWeekContainsDate: 1
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1401 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistance;
	
	function declension(scheme, count) {
	  // scheme for count=1 exists
	  if (scheme.one !== undefined && count === 1) {
	    return scheme.one;
	  }
	
	  var rem10 = count % 10;
	  var rem100 = count % 100; // 1, 21, 31, ...
	
	  if (rem10 === 1 && rem100 !== 11) {
	    return scheme.singularNominative.replace('{{count}}', count); // 2, 3, 4, 22, 23, 24, 32 ...
	  } else if (rem10 >= 2 && rem10 <= 4 && (rem100 < 10 || rem100 > 20)) {
	    return scheme.singularGenitive.replace('{{count}}', count); // 5, 6, 7, 8, 9, 10, 11, ...
	  } else {
	    return scheme.pluralGenitive.replace('{{count}}', count);
	  }
	}
	
	function buildLocalizeTokenFn(scheme) {
	  return function (count, options) {
	    if (options.addSuffix) {
	      if (options.comparison > 0) {
	        if (scheme.future) {
	          return declension(scheme.future, count);
	        } else {
	          return 'через ' + declension(scheme.regular, count);
	        }
	      } else {
	        if (scheme.past) {
	          return declension(scheme.past, count);
	        } else {
	          return declension(scheme.regular, count) + ' назад';
	        }
	      }
	    } else {
	      return declension(scheme.regular, count);
	    }
	  };
	}
	
	var formatDistanceLocale = {
	  lessThanXSeconds: buildLocalizeTokenFn({
	    regular: {
	      one: 'меньше секунды',
	      singularNominative: 'меньше {{count}} секунды',
	      singularGenitive: 'меньше {{count}} секунд',
	      pluralGenitive: 'меньше {{count}} секунд'
	    },
	    future: {
	      one: 'меньше, чем через секунду',
	      singularNominative: 'меньше, чем через {{count}} секунду',
	      singularGenitive: 'меньше, чем через {{count}} секунды',
	      pluralGenitive: 'меньше, чем через {{count}} секунд'
	    }
	  }),
	  xSeconds: buildLocalizeTokenFn({
	    regular: {
	      singularNominative: '{{count}} секунда',
	      singularGenitive: '{{count}} секунды',
	      pluralGenitive: '{{count}} секунд'
	    },
	    past: {
	      singularNominative: '{{count}} секунду назад',
	      singularGenitive: '{{count}} секунды назад',
	      pluralGenitive: '{{count}} секунд назад'
	    },
	    future: {
	      singularNominative: 'через {{count}} секунду',
	      singularGenitive: 'через {{count}} секунды',
	      pluralGenitive: 'через {{count}} секунд'
	    }
	  }),
	  halfAMinute: function (_, options) {
	    if (options.addSuffix) {
	      if (options.comparison > 0) {
	        return 'через полминуты';
	      } else {
	        return 'полминуты назад';
	      }
	    }
	
	    return 'полминуты';
	  },
	  lessThanXMinutes: buildLocalizeTokenFn({
	    regular: {
	      one: 'меньше минуты',
	      singularNominative: 'меньше {{count}} минуты',
	      singularGenitive: 'меньше {{count}} минут',
	      pluralGenitive: 'меньше {{count}} минут'
	    },
	    future: {
	      one: 'меньше, чем через минуту',
	      singularNominative: 'меньше, чем через {{count}} минуту',
	      singularGenitive: 'меньше, чем через {{count}} минуты',
	      pluralGenitive: 'меньше, чем через {{count}} минут'
	    }
	  }),
	  xMinutes: buildLocalizeTokenFn({
	    regular: {
	      singularNominative: '{{count}} минута',
	      singularGenitive: '{{count}} минуты',
	      pluralGenitive: '{{count}} минут'
	    },
	    past: {
	      singularNominative: '{{count}} минуту назад',
	      singularGenitive: '{{count}} минуты назад',
	      pluralGenitive: '{{count}} минут назад'
	    },
	    future: {
	      singularNominative: 'через {{count}} минуту',
	      singularGenitive: 'через {{count}} минуты',
	      pluralGenitive: 'через {{count}} минут'
	    }
	  }),
	  aboutXHours: buildLocalizeTokenFn({
	    regular: {
	      singularNominative: 'около {{count}} часа',
	      singularGenitive: 'около {{count}} часов',
	      pluralGenitive: 'около {{count}} часов'
	    },
	    future: {
	      singularNominative: 'приблизительно через {{count}} час',
	      singularGenitive: 'приблизительно через {{count}} часа',
	      pluralGenitive: 'приблизительно через {{count}} часов'
	    }
	  }),
	  xHours: buildLocalizeTokenFn({
	    regular: {
	      singularNominative: '{{count}} час',
	      singularGenitive: '{{count}} часа',
	      pluralGenitive: '{{count}} часов'
	    }
	  }),
	  xDays: buildLocalizeTokenFn({
	    regular: {
	      singularNominative: '{{count}} день',
	      singularGenitive: '{{count}} дня',
	      pluralGenitive: '{{count}} дней'
	    }
	  }),
	  aboutXWeeks: buildLocalizeTokenFn({
	    regular: {
	      singularNominative: 'около {{count}} недели',
	      singularGenitive: 'около {{count}} недель',
	      pluralGenitive: 'около {{count}} недель'
	    },
	    future: {
	      singularNominative: 'приблизительно через {{count}} неделю',
	      singularGenitive: 'приблизительно через {{count}} недели',
	      pluralGenitive: 'приблизительно через {{count}} недель'
	    }
	  }),
	  xWeeks: buildLocalizeTokenFn({
	    regular: {
	      singularNominative: '{{count}} неделя',
	      singularGenitive: '{{count}} недели',
	      pluralGenitive: '{{count}} недель'
	    }
	  }),
	  aboutXMonths: buildLocalizeTokenFn({
	    regular: {
	      singularNominative: 'около {{count}} месяца',
	      singularGenitive: 'около {{count}} месяцев',
	      pluralGenitive: 'около {{count}} месяцев'
	    },
	    future: {
	      singularNominative: 'приблизительно через {{count}} месяц',
	      singularGenitive: 'приблизительно через {{count}} месяца',
	      pluralGenitive: 'приблизительно через {{count}} месяцев'
	    }
	  }),
	  xMonths: buildLocalizeTokenFn({
	    regular: {
	      singularNominative: '{{count}} месяц',
	      singularGenitive: '{{count}} месяца',
	      pluralGenitive: '{{count}} месяцев'
	    }
	  }),
	  aboutXYears: buildLocalizeTokenFn({
	    regular: {
	      singularNominative: 'около {{count}} года',
	      singularGenitive: 'около {{count}} лет',
	      pluralGenitive: 'около {{count}} лет'
	    },
	    future: {
	      singularNominative: 'приблизительно через {{count}} год',
	      singularGenitive: 'приблизительно через {{count}} года',
	      pluralGenitive: 'приблизительно через {{count}} лет'
	    }
	  }),
	  xYears: buildLocalizeTokenFn({
	    regular: {
	      singularNominative: '{{count}} год',
	      singularGenitive: '{{count}} года',
	      pluralGenitive: '{{count}} лет'
	    }
	  }),
	  overXYears: buildLocalizeTokenFn({
	    regular: {
	      singularNominative: 'больше {{count}} года',
	      singularGenitive: 'больше {{count}} лет',
	      pluralGenitive: 'больше {{count}} лет'
	    },
	    future: {
	      singularNominative: 'больше, чем через {{count}} год',
	      singularGenitive: 'больше, чем через {{count}} года',
	      pluralGenitive: 'больше, чем через {{count}} лет'
	    }
	  }),
	  almostXYears: buildLocalizeTokenFn({
	    regular: {
	      singularNominative: 'почти {{count}} год',
	      singularGenitive: 'почти {{count}} года',
	      pluralGenitive: 'почти {{count}} лет'
	    },
	    future: {
	      singularNominative: 'почти через {{count}} год',
	      singularGenitive: 'почти через {{count}} года',
	      pluralGenitive: 'почти через {{count}} лет'
	    }
	  })
	};
	
	function formatDistance(token, count, options) {
	  options = options || {};
	  return formatDistanceLocale[token](count, options);
	}
	
	module.exports = exports.default;

/***/ },
/* 1402 */
1079,
/* 1403 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRelative;
	
	var _index = _interopRequireDefault(__webpack_require__(71));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var accusativeWeekdays = ['воскресенье', 'понедельник', 'вторник', 'среду', 'четверг', 'пятницу', 'субботу'];
	
	function lastWeek(day) {
	  var weekday = accusativeWeekdays[day];
	
	  switch (day) {
	    case 0:
	      return "'в прошлое " + weekday + " в' p";
	
	    case 1:
	    case 2:
	    case 4:
	      return "'в прошлый " + weekday + " в' p";
	
	    case 3:
	    case 5:
	    case 6:
	      return "'в прошлую " + weekday + " в' p";
	  }
	}
	
	function thisWeek(day) {
	  var weekday = accusativeWeekdays[day];
	
	  if (day === 2
	  /* Tue */
	  ) {
	      return "'во " + weekday + " в' p";
	    } else {
	    return "'в " + weekday + " в' p";
	  }
	}
	
	function nextWeek(day) {
	  var weekday = accusativeWeekdays[day];
	
	  switch (day) {
	    case 0:
	      return "'в следующее " + weekday + " в' p";
	
	    case 1:
	    case 2:
	    case 4:
	      return "'в следующий " + weekday + " в' p";
	
	    case 3:
	    case 5:
	    case 6:
	      return "'в следующую " + weekday + " в' p";
	  }
	}
	
	var formatRelativeLocale = {
	  lastWeek: function (date, baseDate, options) {
	    var day = date.getUTCDay();
	
	    if ((0, _index.default)(date, baseDate, options)) {
	      return thisWeek(day);
	    } else {
	      return lastWeek(day);
	    }
	  },
	  yesterday: "'вчера в' p",
	  today: "'сегодня в' p",
	  tomorrow: "'завтра в' p",
	  nextWeek: function (date, baseDate, options) {
	    var day = date.getUTCDay();
	
	    if ((0, _index.default)(date, baseDate, options)) {
	      return thisWeek(day);
	    } else {
	      return nextWeek(day);
	    }
	  },
	  other: 'P'
	};
	
	function formatRelative(token, date, baseDate, options) {
	  var format = formatRelativeLocale[token];
	
	  if (typeof format === 'function') {
	    return format(date, baseDate, options);
	  }
	
	  return format;
	}
	
	module.exports = exports.default;

/***/ },
/* 1404 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eraValues = {
	  narrow: ['до н.э.', 'н.э.'],
	  abbreviated: ['до н. э.', 'н. э.'],
	  wide: ['до нашей эры', 'нашей эры']
	};
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['1-й кв.', '2-й кв.', '3-й кв.', '4-й кв.'],
	  wide: ['1-й квартал', '2-й квартал', '3-й квартал', '4-й квартал']
	};
	var monthValues = {
	  narrow: ['Я', 'Ф', 'М', 'А', 'М', 'И', 'И', 'А', 'С', 'О', 'Н', 'Д'],
	  abbreviated: ['янв.', 'фев.', 'март', 'апр.', 'май', 'июнь', 'июль', 'авг.', 'сент.', 'окт.', 'нояб.', 'дек.'],
	  wide: ['январь', 'февраль', 'март', 'апрель', 'май', 'июнь', 'июль', 'август', 'сентябрь', 'октябрь', 'ноябрь', 'декабрь']
	};
	var formattingMonthValues = {
	  narrow: ['Я', 'Ф', 'М', 'А', 'М', 'И', 'И', 'А', 'С', 'О', 'Н', 'Д'],
	  abbreviated: ['янв.', 'фев.', 'мар.', 'апр.', 'мая', 'июн.', 'июл.', 'авг.', 'сент.', 'окт.', 'нояб.', 'дек.'],
	  wide: ['января', 'февраля', 'марта', 'апреля', 'мая', 'июня', 'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря']
	};
	var dayValues = {
	  narrow: ['В', 'П', 'В', 'С', 'Ч', 'П', 'С'],
	  short: ['вс', 'пн', 'вт', 'ср', 'чт', 'пт', 'сб'],
	  abbreviated: ['вск', 'пнд', 'втр', 'срд', 'чтв', 'птн', 'суб'],
	  wide: ['воскресенье', 'понедельник', 'вторник', 'среда', 'четверг', 'пятница', 'суббота']
	};
	var dayPeriodValues = {
	  narrow: {
	    am: 'ДП',
	    pm: 'ПП',
	    midnight: 'полн.',
	    noon: 'полд.',
	    morning: 'утро',
	    afternoon: 'день',
	    evening: 'веч.',
	    night: 'ночь'
	  },
	  abbreviated: {
	    am: 'ДП',
	    pm: 'ПП',
	    midnight: 'полн.',
	    noon: 'полд.',
	    morning: 'утро',
	    afternoon: 'день',
	    evening: 'веч.',
	    night: 'ночь'
	  },
	  wide: {
	    am: 'ДП',
	    pm: 'ПП',
	    midnight: 'полночь',
	    noon: 'полдень',
	    morning: 'утро',
	    afternoon: 'день',
	    evening: 'вечер',
	    night: 'ночь'
	  }
	};
	var formattingDayPeriodValues = {
	  narrow: {
	    am: 'ДП',
	    pm: 'ПП',
	    midnight: 'полн.',
	    noon: 'полд.',
	    morning: 'утра',
	    afternoon: 'дня',
	    evening: 'веч.',
	    night: 'ночи'
	  },
	  abbreviated: {
	    am: 'ДП',
	    pm: 'ПП',
	    midnight: 'полн.',
	    noon: 'полд.',
	    morning: 'утра',
	    afternoon: 'дня',
	    evening: 'веч.',
	    night: 'ночи'
	  },
	  wide: {
	    am: 'ДП',
	    pm: 'ПП',
	    midnight: 'полночь',
	    noon: 'полдень',
	    morning: 'утра',
	    afternoon: 'дня',
	    evening: 'вечера',
	    night: 'ночи'
	  }
	};
	
	function ordinalNumber(dirtyNumber, dirtyOptions) {
	  var options = dirtyOptions || {};
	  var unit = String(options.unit);
	  var suffix;
	
	  if (unit === 'date') {
	    suffix = '-е';
	  } else if (unit === 'week' || unit === 'minute' || unit === 'second') {
	    suffix = '-я';
	  } else {
	    suffix = '-й';
	  }
	
	  return dirtyNumber + suffix;
	}
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingMonthValues,
	    defaultFormattingWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'any',
	    formattingValues: formattingDayPeriodValues,
	    defaultFormattingWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1405 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(15));
	
	var _index2 = _interopRequireDefault(__webpack_require__(14));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(\d+)(-?(е|я|й|ое|ье|ая|ья|ый|ой|ий|ый))?/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^((до )?н\.?\s?э\.?)/i,
	  abbreviated: /^((до )?н\.?\s?э\.?)/i,
	  wide: /^(до нашей эры|нашей эры|наша эра)/i
	};
	var parseEraPatterns = {
	  any: [/^д/i, /^н/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^[1234](-?[ыои]?й?)? кв.?/i,
	  wide: /^[1234](-?[ыои]?й?)? квартал/i
	};
	var parseQuarterPatterns = {
	  any: [/1/i, /2/i, /3/i, /4/i]
	};
	var matchMonthPatterns = {
	  narrow: /^[яфмаисонд]/i,
	  abbreviated: /^(янв|фев|март?|апр|ма[йя]|июн[ья]?|июл[ья]?|авг|сент?|окт|нояб?|дек)\.?/i,
	  wide: /^(январ[ья]|феврал[ья]|марта?|апрел[ья]|ма[йя]|июн[ья]|июл[ья]|августа?|сентябр[ья]|октябр[ья]|октябр[ья]|ноябр[ья]|декабр[ья])/i
	};
	var parseMonthPatterns = {
	  narrow: [/^я/i, /^ф/i, /^м/i, /^а/i, /^м/i, /^и/i, /^и/i, /^а/i, /^с/i, /^о/i, /^н/i, /^я/i],
	  any: [/^я/i, /^ф/i, /^мар/i, /^ап/i, /^ма[йя]/i, /^июн/i, /^июл/i, /^ав/i, /^с/i, /^о/i, /^н/i, /^д/i]
	};
	var matchDayPatterns = {
	  narrow: /^[впсч]/i,
	  short: /^(вс|во|пн|по|вт|ср|чт|че|пт|пя|сб|су)\.?/i,
	  abbreviated: /^(вск|вос|пнд|пон|втр|вто|срд|сре|чтв|чет|птн|пят|суб).?/i,
	  wide: /^(воскресень[ея]|понедельника?|вторника?|сред[аы]|четверга?|пятниц[аы]|суббот[аы])/i
	};
	var parseDayPatterns = {
	  narrow: [/^в/i, /^п/i, /^в/i, /^с/i, /^ч/i, /^п/i, /^с/i],
	  any: [/^в[ос]/i, /^п[он]/i, /^в/i, /^ср/i, /^ч/i, /^п[ят]/i, /^с[уб]/i]
	};
	var matchDayPeriodPatterns = {
	  narrow: /^([дп]п|полн\.?|полд\.?|утр[оа]|день|дня|веч\.?|ноч[ьи])/i,
	  abbreviated: /^([дп]п|полн\.?|полд\.?|утр[оа]|день|дня|веч\.?|ноч[ьи])/i,
	  wide: /^([дп]п|полночь|полдень|утр[оа]|день|дня|вечера?|ноч[ьи])/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^дп/i,
	    pm: /^пп/i,
	    midnight: /^полн/i,
	    noon: /^полд/i,
	    morning: /^у/i,
	    afternoon: /^д[ен]/i,
	    evening: /^в/i,
	    night: /^н/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index2.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index2.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index2.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index2.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index2.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1406 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1401));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1402));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1403));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1404));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1405));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Russian locale.
	 * @language Russian
	 * @iso-639-2 rus
	 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
	 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
	 */
	var locale = {
	  code: 'ru',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 1
	    /* Monday */
	    ,
	    firstWeekContainsDate: 1
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1407 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	function declensionGroup(scheme, count) {
	  if (count === 1 && scheme.one) {
	    return scheme.one;
	  }
	
	  if (count >= 2 && count <= 4 && scheme.twoFour) {
	    return scheme.twoFour;
	  } // if count === null || count === 0 || count >= 5
	
	
	  return scheme.other;
	}
	
	function declension(scheme, count, time) {
	  var group = declensionGroup(scheme, count);
	  var finalText = group[time];
	  return finalText.replace('{{count}}', String(count));
	}
	
	function extractPreposition(token) {
	  var result = ['lessThan', 'about', 'over', 'almost'].filter(function (preposition) {
	    return !!token.match(new RegExp('^' + preposition));
	  });
	  return result[0];
	}
	
	function prefixPreposition(preposition) {
	  var translation = '';
	
	  if (preposition === 'almost') {
	    translation = 'takmer';
	  }
	
	  if (preposition === 'about') {
	    translation = 'približne';
	  }
	
	  return translation.length > 0 ? translation + ' ' : '';
	}
	
	function suffixPreposition(preposition) {
	  var translation = '';
	
	  if (preposition === 'lessThan') {
	    translation = 'menej než';
	  }
	
	  if (preposition === 'over') {
	    translation = 'viac než';
	  }
	
	  return translation.length > 0 ? translation + ' ' : '';
	}
	
	function lowercaseFirstLetter(string) {
	  return string.charAt(0).toLowerCase() + string.slice(1);
	}
	
	var formatDistanceLocale = {
	  xSeconds: {
	    one: {
	      present: 'sekunda',
	      past: 'sekundou',
	      future: 'sekundu'
	    },
	    twoFour: {
	      present: '{{count}} sekundy',
	      past: '{{count}} sekundami',
	      future: '{{count}} sekundy'
	    },
	    other: {
	      present: '{{count}} sekúnd',
	      past: '{{count}} sekundami',
	      future: '{{count}} sekúnd'
	    }
	  },
	  halfAMinute: {
	    other: {
	      present: 'pol minúty',
	      past: 'pol minútou',
	      future: 'pol minúty'
	    }
	  },
	  xMinutes: {
	    one: {
	      present: 'minúta',
	      past: 'minútou',
	      future: 'minútu'
	    },
	    twoFour: {
	      present: '{{count}} minúty',
	      past: '{{count}} minútami',
	      future: '{{count}} minúty'
	    },
	    other: {
	      present: '{{count}} minút',
	      past: '{{count}} minútami',
	      future: '{{count}} minút'
	    }
	  },
	  xHours: {
	    one: {
	      present: 'hodina',
	      past: 'hodinou',
	      future: 'hodinu'
	    },
	    twoFour: {
	      present: '{{count}} hodiny',
	      past: '{{count}} hodinami',
	      future: '{{count}} hodiny'
	    },
	    other: {
	      present: '{{count}} hodín',
	      past: '{{count}} hodinami',
	      future: '{{count}} hodín'
	    }
	  },
	  xDays: {
	    one: {
	      present: 'deň',
	      past: 'dňom',
	      future: 'deň'
	    },
	    twoFour: {
	      present: '{{count}} dni',
	      past: '{{count}} dňami',
	      future: '{{count}} dni'
	    },
	    other: {
	      present: '{{count}} dní',
	      past: '{{count}} dňami',
	      future: '{{count}} dní'
	    }
	  },
	  xWeeks: {
	    one: {
	      present: 'týždeň',
	      past: 'týždňom',
	      future: 'týždeň'
	    },
	    twoFour: {
	      present: '{{count}} týždne',
	      past: '{{count}} týždňami',
	      future: '{{count}} týždne'
	    },
	    other: {
	      present: '{{count}} týždňov',
	      past: '{{count}} týždňami',
	      future: '{{count}} týždňov'
	    }
	  },
	  xMonths: {
	    one: {
	      present: 'mesiac',
	      past: 'mesiacom',
	      future: 'mesiac'
	    },
	    twoFour: {
	      present: '{{count}} mesiace',
	      past: '{{count}} mesiacmi',
	      future: '{{count}} mesiace'
	    },
	    other: {
	      present: '{{count}} mesiacov',
	      past: '{{count}} mesiacmi',
	      future: '{{count}} mesiacov'
	    }
	  },
	  xYears: {
	    one: {
	      present: 'rok',
	      past: 'rokom',
	      future: 'rok'
	    },
	    twoFour: {
	      present: '{{count}} roky',
	      past: '{{count}} rokmi',
	      future: '{{count}} roky'
	    },
	    other: {
	      present: '{{count}} rokov',
	      past: '{{count}} rokmi',
	      future: '{{count}} rokov'
	    }
	  }
	};
	
	var formatDistance = function (token, count, options) {
	  var preposition = extractPreposition(token) || '';
	  var key = lowercaseFirstLetter(token.substring(preposition.length));
	  var scheme = formatDistanceLocale[key];
	
	  if (!(options !== null && options !== void 0 && options.addSuffix)) {
	    return prefixPreposition(preposition) + suffixPreposition(preposition) + declension(scheme, count, 'present');
	  }
	
	  if (options.comparison && options.comparison > 0) {
	    return prefixPreposition(preposition) + 'o ' + suffixPreposition(preposition) + declension(scheme, count, 'future');
	  } else {
	    return prefixPreposition(preposition) + 'pred ' + suffixPreposition(preposition) + declension(scheme, count, 'past');
	  }
	};
	
	var _default = formatDistance;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1408 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// https://www.unicode.org/cldr/charts/32/summary/sk.html?hide#1986
	var dateFormats = {
	  full: 'EEEE d. MMMM y',
	  long: 'd. MMMM y',
	  medium: 'd. M. y',
	  short: 'd. M. y'
	}; // https://www.unicode.org/cldr/charts/32/summary/sk.html?hide#2149
	
	var timeFormats = {
	  full: 'H:mm:ss zzzz',
	  long: 'H:mm:ss z',
	  medium: 'H:mm:ss',
	  short: 'H:mm'
	}; // https://www.unicode.org/cldr/charts/32/summary/sk.html?hide#1994
	
	var dateTimeFormats = {
	  full: '{{date}}, {{time}}',
	  long: '{{date}}, {{time}}',
	  medium: '{{date}}, {{time}}',
	  short: '{{date}} {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1409 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(71));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// https://www.unicode.org/cldr/charts/32/summary/sk.html?hide#1308
	var accusativeWeekdays = ['nedeľu', 'pondelok', 'utorok', 'stredu', 'štvrtok', 'piatok', 'sobotu'];
	
	function lastWeek(day) {
	  var weekday = accusativeWeekdays[day];
	
	  switch (day) {
	    case 0:
	    /* Sun */
	
	    case 3:
	    /* Wed */
	
	    case 6
	    /* Sat */
	    :
	      return "'minulú " + weekday + " o' p";
	
	    default:
	      return "'minulý' eeee 'o' p";
	  }
	}
	
	function thisWeek(day) {
	  var weekday = accusativeWeekdays[day];
	
	  if (day === 4
	  /* Thu */
	  ) {
	      return "'vo' eeee 'o' p";
	    } else {
	    return "'v " + weekday + " o' p";
	  }
	}
	
	function nextWeek(day) {
	  var weekday = accusativeWeekdays[day];
	
	  switch (day) {
	    case 0:
	    /* Sun */
	
	    case 4:
	    /* Wed */
	
	    case 6
	    /* Sat */
	    :
	      return "'budúcu " + weekday + " o' p";
	
	    default:
	      return "'budúci' eeee 'o' p";
	  }
	}
	
	var formatRelativeLocale = {
	  lastWeek: function (date, baseDate, options) {
	    var day = date.getUTCDay();
	
	    if ((0, _index.default)(date, baseDate, options)) {
	      return thisWeek(day);
	    } else {
	      return lastWeek(day);
	    }
	  },
	  yesterday: "'včera o' p",
	  today: "'dnes o' p",
	  tomorrow: "'zajtra o' p",
	  nextWeek: function (date, baseDate, options) {
	    var day = date.getUTCDay();
	
	    if ((0, _index.default)(date, baseDate, options)) {
	      return thisWeek(day);
	    } else {
	      return nextWeek(day);
	    }
	  },
	  other: 'P'
	};
	
	var formatRelative = function (token, date, baseDate, options) {
	  var format = formatRelativeLocale[token];
	
	  if (typeof format === 'function') {
	    return format(date, baseDate, options);
	  }
	
	  return format;
	};
	
	var _default = formatRelative;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1410 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// https://www.unicode.org/cldr/charts/32/summary/sk.html#1772
	var eraValues = {
	  narrow: ['pred Kr.', 'po Kr.'],
	  abbreviated: ['pred Kr.', 'po Kr.'],
	  wide: ['pred Kristom', 'po Kristovi']
	}; // https://www.unicode.org/cldr/charts/32/summary/sk.html#1780
	
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
	  wide: ['1. štvrťrok', '2. štvrťrok', '3. štvrťrok', '4. štvrťrok']
	}; // https://www.unicode.org/cldr/charts/32/summary/sk.html#1804
	
	var monthValues = {
	  narrow: ['j', 'f', 'm', 'a', 'm', 'j', 'j', 'a', 's', 'o', 'n', 'd'],
	  abbreviated: ['jan', 'feb', 'mar', 'apr', 'máj', 'jún', 'júl', 'aug', 'sep', 'okt', 'nov', 'dec'],
	  wide: ['január', 'február', 'marec', 'apríl', 'máj', 'jún', 'júl', 'august', 'september', 'október', 'november', 'december']
	};
	var formattingMonthValues = {
	  narrow: ['j', 'f', 'm', 'a', 'm', 'j', 'j', 'a', 's', 'o', 'n', 'd'],
	  abbreviated: ['jan', 'feb', 'mar', 'apr', 'máj', 'jún', 'júl', 'aug', 'sep', 'okt', 'nov', 'dec'],
	  wide: ['januára', 'februára', 'marca', 'apríla', 'mája', 'júna', 'júla', 'augusta', 'septembra', 'októbra', 'novembra', 'decembra']
	}; // https://www.unicode.org/cldr/charts/32/summary/sk.html#1876
	
	var dayValues = {
	  narrow: ['n', 'p', 'u', 's', 'š', 'p', 's'],
	  short: ['ne', 'po', 'ut', 'st', 'št', 'pi', 'so'],
	  abbreviated: ['ne', 'po', 'ut', 'st', 'št', 'pi', 'so'],
	  wide: ['nedeľa', 'pondelok', 'utorok', 'streda', 'štvrtok', 'piatok', 'sobota']
	}; // https://www.unicode.org/cldr/charts/32/summary/sk.html#1932
	
	var dayPeriodValues = {
	  narrow: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'poln.',
	    noon: 'pol.',
	    morning: 'ráno',
	    afternoon: 'pop.',
	    evening: 'več.',
	    night: 'noc'
	  },
	  abbreviated: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'poln.',
	    noon: 'pol.',
	    morning: 'ráno',
	    afternoon: 'popol.',
	    evening: 'večer',
	    night: 'noc'
	  },
	  wide: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'polnoc',
	    noon: 'poludnie',
	    morning: 'ráno',
	    afternoon: 'popoludnie',
	    evening: 'večer',
	    night: 'noc'
	  }
	};
	var formattingDayPeriodValues = {
	  narrow: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'o poln.',
	    noon: 'nap.',
	    morning: 'ráno',
	    afternoon: 'pop.',
	    evening: 'več.',
	    night: 'v n.'
	  },
	  abbreviated: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'o poln.',
	    noon: 'napol.',
	    morning: 'ráno',
	    afternoon: 'popol.',
	    evening: 'večer',
	    night: 'v noci'
	  },
	  wide: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'o polnoci',
	    noon: 'napoludnie',
	    morning: 'ráno',
	    afternoon: 'popoludní',
	    evening: 'večer',
	    night: 'v noci'
	  }
	};
	
	var ordinalNumber = function (dirtyNumber, _options) {
	  var number = Number(dirtyNumber);
	  return number + '.';
	};
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return quarter - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingMonthValues,
	    defaultFormattingWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingDayPeriodValues,
	    defaultFormattingWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1411 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(14));
	
	var _index2 = _interopRequireDefault(__webpack_require__(15));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(\d+)\.?/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^(pred Kr\.|pred n\. l\.|po Kr\.|n\. l\.)/i,
	  abbreviated: /^(pred Kr\.|pred n\. l\.|po Kr\.|n\. l\.)/i,
	  wide: /^(pred Kristom|pred na[šs][íi]m letopo[čc]tom|po Kristovi|n[áa][šs]ho letopo[čc]tu)/i
	};
	var parseEraPatterns = {
	  any: [/^pr/i, /^(po|n)/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^q[1234]/i,
	  wide: /^[1234]\. [šs]tvr[ťt]rok/i
	};
	var parseQuarterPatterns = {
	  any: [/1/i, /2/i, /3/i, /4/i]
	};
	var matchMonthPatterns = {
	  narrow: /^[jfmasond]/i,
	  abbreviated: /^(jan|feb|mar|apr|m[áa]j|j[úu]n|j[úu]l|aug|sep|okt|nov|dec)/i,
	  wide: /^(janu[áa]ra?|febru[áa]ra?|(marec|marca)|apr[íi]la?|m[áa]ja?|j[úu]na?|j[úu]la?|augusta?|(september|septembra)|(okt[óo]ber|okt[óo]bra)|(november|novembra)|(december|decembra))/i
	};
	var parseMonthPatterns = {
	  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
	  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^m[áa]j/i, /^j[úu]n/i, /^j[úu]l/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
	};
	var matchDayPatterns = {
	  narrow: /^[npusšp]/i,
	  short: /^(ne|po|ut|st|št|pi|so)/i,
	  abbreviated: /^(ne|po|ut|st|št|pi|so)/i,
	  wide: /^(nede[ľl]a|pondelok|utorok|streda|[šs]tvrtok|piatok|sobota])/i
	};
	var parseDayPatterns = {
	  narrow: [/^n/i, /^p/i, /^u/i, /^s/i, /^š/i, /^p/i, /^s/i],
	  any: [/^n/i, /^po/i, /^u/i, /^st/i, /^(št|stv)/i, /^pi/i, /^so/i]
	};
	var matchDayPeriodPatterns = {
	  narrow: /^(am|pm|(o )?poln\.?|(nap\.?|pol\.?)|r[áa]no|pop\.?|ve[čc]\.?|(v n\.?|noc))/i,
	  abbreviated: /^(am|pm|(o )?poln\.?|(napol\.?|pol\.?)|r[áa]no|pop\.?|ve[čc]er|(v )?noci?)/i,
	  any: /^(am|pm|(o )?polnoci?|(na)?poludnie|r[áa]no|popoludn(ie|í|i)|ve[čc]er|(v )?noci?)/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^am/i,
	    pm: /^pm/i,
	    midnight: /poln/i,
	    noon: /^(nap|(na)?pol(\.|u))/i,
	    morning: /^r[áa]no/i,
	    afternoon: /^pop/i,
	    evening: /^ve[čc]/i,
	    night: /^(noc|v n\.)/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index2.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1412 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1407));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1408));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1409));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1410));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1411));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Slovak locale.
	 * @language Slovak
	 * @iso-639-2 slk
	 * @author Marek Suscak [@mareksuscak]{@link https://github.com/mareksuscak}
	 */
	var locale = {
	  code: 'sk',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 1
	    /* Monday */
	    ,
	    firstWeekContainsDate: 4
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1413 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistance;
	var distanceInWordsLocale = {
	  lessThanXSeconds: {
	    one: 'manj kot {{count}} sekunda',
	    two: 'manj kot {{count}} sekundi',
	    few: 'manj kot {{count}} sekunde',
	    other: 'manj kot {{count}} sekund'
	  },
	  xSeconds: {
	    one: '{{count}} sekunda',
	    two: '{{count}} sekundi',
	    few: '{{count}} sekunde',
	    other: '{{count}} sekund'
	  },
	  halfAMinute: 'pol minute',
	  lessThanXMinutes: {
	    one: 'manj kot {{count}} minuta',
	    two: 'manj kot {{count}} minuti',
	    few: 'manj kot {{count}} minute',
	    other: 'manj kot {{count}} minut'
	  },
	  xMinutes: {
	    one: '{{count}} minuta',
	    two: '{{count}} minuti',
	    few: '{{count}} minute',
	    other: '{{count}} minut'
	  },
	  aboutXHours: {
	    one: 'približno {{count}} ura',
	    two: 'približno {{count}} uri',
	    few: 'približno {{count}} ure',
	    other: 'približno {{count}} ur'
	  },
	  xHours: {
	    one: '{{count}} ura',
	    two: '{{count}} uri',
	    few: '{{count}} ure',
	    other: '{{count}} ur'
	  },
	  xDays: {
	    one: '{{count}} dan',
	    two: '{{count}} dni',
	    few: '{{count}} dni',
	    other: '{{count}} dni'
	  },
	  aboutXWeeks: {
	    one: 'približno {{count}} teden',
	    two: 'približno {{count}} tedna',
	    few: 'približno {{count}} tedne',
	    other: 'približno {{count}} tednov'
	  },
	  xWeeks: {
	    one: '{{count}} teden',
	    two: '{{count}} tedna',
	    few: '{{count}} tedne',
	    other: '{{count}} tednov'
	  },
	  aboutXMonths: {
	    one: 'približno {{count}} mesec',
	    two: 'približno {{count}} meseca',
	    few: 'približno {{count}} mesece',
	    other: 'približno {{count}} mesecev'
	  },
	  xMonths: {
	    one: '{{count}} mesec',
	    two: '{{count}} meseca',
	    few: '{{count}} meseci',
	    other: '{{count}} mesecev'
	  },
	  aboutXYears: {
	    one: 'približno {{count}} leto',
	    two: 'približno {{count}} leti',
	    few: 'približno {{count}} leta',
	    other: 'približno {{count}} let'
	  },
	  xYears: {
	    one: '{{count}} leto',
	    two: '{{count}} leti',
	    few: '{{count}} leta',
	    other: '{{count}} let'
	  },
	  overXYears: {
	    one: 'več kot {{count}} leto',
	    two: 'več kot {{count}} leti',
	    few: 'več kot {{count}} leta',
	    other: 'več kot {{count}} let'
	  },
	  almostXYears: {
	    one: 'skoraj {{count}} leto',
	    two: 'skoraj {{count}} leti',
	    few: 'skoraj {{count}} leta',
	    other: 'skoraj {{count}} let'
	  }
	};
	var distanceInWordsLocalePast = {
	  lessThanXSeconds: {
	    one: 'manj kot {{count}} sekundo',
	    two: 'manj kot {{count}} sekundama',
	    few: 'manj kot {{count}} sekundami',
	    other: 'manj kot {{count}} sekundami'
	  },
	  xSeconds: {
	    one: '{{count}} sekundo',
	    two: '{{count}} sekundama',
	    few: '{{count}} sekundami',
	    other: '{{count}} sekundami'
	  },
	  halfAMinute: 'pol minute',
	  lessThanXMinutes: {
	    one: 'manj kot {{count}} minuto',
	    two: 'manj kot {{count}} minutama',
	    few: 'manj kot {{count}} minutami',
	    other: 'manj kot {{count}} minutami'
	  },
	  xMinutes: {
	    one: '{{count}} minuto',
	    two: '{{count}} minutama',
	    few: '{{count}} minutami',
	    other: '{{count}} minutami'
	  },
	  aboutXHours: {
	    one: 'približno {{count}} uro',
	    two: 'približno {{count}} urama',
	    few: 'približno {{count}} urami',
	    other: 'približno {{count}} urami'
	  },
	  xHours: {
	    one: '{{count}} uro',
	    two: '{{count}} urama',
	    few: '{{count}} urami',
	    other: '{{count}} urami'
	  },
	  xDays: {
	    one: '{{count}} dnem',
	    two: '{{count}} dnevoma',
	    few: '{{count}} dnevi',
	    other: '{{count}} dnevi'
	  },
	  aboutXMonths: {
	    one: 'približno {{count}} mesecem',
	    two: 'približno {{count}} mesecema',
	    few: 'približno {{count}} meseci',
	    other: 'približno {{count}} meseci'
	  },
	  xMonths: {
	    one: '{{count}} mesecem',
	    two: '{{count}} mesecema',
	    few: '{{count}} meseci',
	    other: '{{count}} meseci'
	  },
	  aboutXYears: {
	    one: 'približno {{count}} letom',
	    two: 'približno {{count}} letoma',
	    few: 'približno {{count}} leti',
	    other: 'približno {{count}} leti'
	  },
	  xYears: {
	    one: '{{count}} letom',
	    two: '{{count}} letoma',
	    few: '{{count}} leti',
	    other: '{{count}} leti'
	  },
	  overXYears: {
	    one: 'več kot {{count}} letom',
	    two: 'več kot {{count}} letoma',
	    few: 'več kot {{count}} leti',
	    other: 'več kot {{count}} leti'
	  },
	  almostXYears: {
	    one: 'skoraj {{count}} letom',
	    two: 'skoraj {{count}} letoma',
	    few: 'skoraj {{count}} leti',
	    other: 'skoraj {{count}} leti'
	  }
	};
	var distanceInWordsLocaleFuture = {
	  lessThanXSeconds: {
	    one: 'manj kot {{count}} sekundo',
	    two: 'manj kot {{count}} sekundi',
	    few: 'manj kot {{count}} sekunde',
	    other: 'manj kot {{count}} sekund'
	  },
	  xSeconds: {
	    one: '{{count}} sekundo',
	    two: '{{count}} sekundi',
	    few: '{{count}} sekunde',
	    other: '{{count}} sekund'
	  },
	  halfAMinute: 'pol minute',
	  lessThanXMinutes: {
	    one: 'manj kot {{count}} minuto',
	    two: 'manj kot {{count}} minuti',
	    few: 'manj kot {{count}} minute',
	    other: 'manj kot {{count}} minut'
	  },
	  xMinutes: {
	    one: '{{count}} minuto',
	    two: '{{count}} minuti',
	    few: '{{count}} minute',
	    other: '{{count}} minut'
	  },
	  aboutXHours: {
	    one: 'približno {{count}} uro',
	    two: 'približno {{count}} uri',
	    few: 'približno {{count}} ure',
	    other: 'približno {{count}} ur'
	  },
	  xHours: {
	    one: '{{count}} uro',
	    two: '{{count}} uri',
	    few: '{{count}} ure',
	    other: '{{count}} ur'
	  },
	  xDays: {
	    one: '{{count}} dan',
	    two: '{{count}} dni',
	    few: '{{count}} dni',
	    other: '{{count}} dni'
	  },
	  aboutXMonths: {
	    one: 'približno {{count}} mesec',
	    two: 'približno {{count}} meseca',
	    few: 'približno {{count}} mesece',
	    other: 'približno {{count}} mesecev'
	  },
	  xMonths: {
	    one: '{{count}} mesec',
	    two: '{{count}} meseca',
	    few: '{{count}} mesece',
	    other: '{{count}} mesecev'
	  },
	  aboutXYears: {
	    one: 'približno {{count}} leto',
	    two: 'približno {{count}} leti',
	    few: 'približno {{count}} leta',
	    other: 'približno {{count}} let'
	  },
	  xYears: {
	    one: '{{count}} leto',
	    two: '{{count}} leti',
	    few: '{{count}} leta',
	    other: '{{count}} let'
	  },
	  overXYears: {
	    one: 'več kot {{count}} leto',
	    two: 'več kot {{count}} leti',
	    few: 'več kot {{count}} leta',
	    other: 'več kot {{count}} let'
	  },
	  almostXYears: {
	    one: 'skoraj {{count}} leto',
	    two: 'skoraj {{count}} leti',
	    few: 'skoraj {{count}} leta',
	    other: 'skoraj {{count}} let'
	  }
	};
	
	function getFormFromCount(count) {
	  switch (count % 100) {
	    case 1:
	      return 'one';
	
	    case 2:
	      return 'two';
	
	    case 3:
	    case 4:
	      return 'few';
	
	    default:
	      return 'other';
	  }
	}
	
	function formatDistance(token, count, options) {
	  options = options || {};
	  var localeObject = distanceInWordsLocale;
	  var result = '';
	
	  if (options.addSuffix) {
	    if (options.comparison > 0) {
	      localeObject = distanceInWordsLocaleFuture;
	      result += 'čez ';
	    } else {
	      localeObject = distanceInWordsLocalePast;
	      result += 'pred ';
	    }
	  }
	
	  if (typeof localeObject[token] === 'string') {
	    result += localeObject[token];
	  } else {
	    var form = getFormFromCount(count);
	    result += localeObject[token][form].replace('{{count}}', count);
	  }
	
	  return result;
	}
	
	module.exports = exports.default;

/***/ },
/* 1414 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: 'EEEE, dd. MMMM y',
	  long: 'dd. MMMM y',
	  medium: 'd. MMM y',
	  short: 'd. MM. yy'
	};
	var timeFormats = {
	  full: 'HH:mm:ss zzzz',
	  long: 'HH:mm:ss z',
	  medium: 'HH:mm:ss',
	  short: 'HH:mm'
	};
	var dateTimeFormats = {
	  full: '{{date}} {{time}}',
	  long: '{{date}} {{time}}',
	  medium: '{{date}} {{time}}',
	  short: '{{date}} {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1415 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRelative;
	var formatRelativeLocale = {
	  lastWeek: function (date) {
	    var day = date.getUTCDay();
	
	    switch (day) {
	      case 0:
	        return "'prejšnjo nedeljo ob' p";
	
	      case 3:
	        return "'prejšnjo sredo ob' p";
	
	      case 6:
	        return "'prejšnjo soboto ob' p";
	
	      default:
	        return "'prejšnji' EEEE 'ob' p";
	    }
	  },
	  yesterday: "'včeraj ob' p",
	  today: "'danes ob' p",
	  tomorrow: "'jutri ob' p",
	  nextWeek: function (date) {
	    var day = date.getUTCDay();
	
	    switch (day) {
	      case 0:
	        return "'naslednjo nedeljo ob' p";
	
	      case 3:
	        return "'naslednjo sredo ob' p";
	
	      case 6:
	        return "'naslednjo soboto ob' p";
	
	      default:
	        return "'naslednji' EEEE 'ob' p";
	    }
	  },
	  other: 'P'
	};
	
	function formatRelative(token, date, _baseDate, _options) {
	  var format = formatRelativeLocale[token];
	
	  if (typeof format === 'function') {
	    return format(date);
	  }
	
	  return format;
	}
	
	module.exports = exports.default;

/***/ },
/* 1416 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ordinalNumber(dirtyNumber) {
	  var number = Number(dirtyNumber);
	  return String(number).concat('.');
	}
	
	var eraValues = {
	  narrow: ['pr. n. št.', 'po n. št.'],
	  abbreviated: ['pr. n. št.', 'po n. št.'],
	  wide: ['pred našim štetjem', 'po našem štetju']
	};
	var monthValues = {
	  narrow: ['j', 'f', 'm', 'a', 'm', 'j', 'j', 'a', 's', 'o', 'n', 'd'],
	  abbreviated: ['jan.', 'feb.', 'mar.', 'apr.', 'maj', 'jun.', 'jul.', 'avg.', 'sep.', 'okt.', 'nov.', 'dec.'],
	  wide: ['januar', 'februar', 'marec', 'april', 'maj', 'junij', 'julij', 'avgust', 'september', 'oktober', 'november', 'december']
	};
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['1. čet.', '2. čet.', '3. čet.', '4. čet.'],
	  wide: ['1. četrtletje', '2. četrtletje', '3. četrtletje', '4. četrtletje']
	};
	var dayValues = {
	  narrow: ['n', 'p', 't', 's', 'č', 'p', 's'],
	  short: ['ned.', 'pon.', 'tor.', 'sre.', 'čet.', 'pet.', 'sob.'],
	  abbreviated: ['ned.', 'pon.', 'tor.', 'sre.', 'čet.', 'pet.', 'sob.'],
	  wide: ['nedelja', 'ponedeljek', 'torek', 'sreda', 'četrtek', 'petek', 'sobota']
	};
	var dayPeriodValuesStandalone = {
	  narrow: {
	    am: 'd',
	    pm: 'p',
	    midnight: '24.00',
	    noon: '12.00',
	    morning: 'j',
	    afternoon: 'p',
	    evening: 'v',
	    night: 'n'
	  },
	  abbreviated: {
	    am: 'dop.',
	    pm: 'pop.',
	    midnight: 'poln.',
	    noon: 'pold.',
	    morning: 'jut.',
	    afternoon: 'pop.',
	    evening: 'več.',
	    night: 'noč'
	  },
	  wide: {
	    am: 'dop.',
	    pm: 'pop.',
	    midnight: 'polnoč',
	    noon: 'poldne',
	    morning: 'jutro',
	    afternoon: 'popoldne',
	    evening: 'večer',
	    night: 'noč'
	  }
	};
	var dayPeriodValuesFormatting = {
	  narrow: {
	    am: 'd',
	    pm: 'p',
	    midnight: '24.00',
	    noon: '12.00',
	    morning: 'zj',
	    afternoon: 'p',
	    evening: 'zv',
	    night: 'po'
	  },
	  abbreviated: {
	    am: 'dop.',
	    pm: 'pop.',
	    midnight: 'opoln.',
	    noon: 'opold.',
	    morning: 'zjut.',
	    afternoon: 'pop.',
	    evening: 'zveč.',
	    night: 'ponoči'
	  },
	  wide: {
	    am: 'dop.',
	    pm: 'pop.',
	    midnight: 'opolnoči',
	    noon: 'opoldne',
	    morning: 'zjutraj',
	    afternoon: 'popoldan',
	    evening: 'zvečer',
	    night: 'ponoči'
	  }
	};
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValuesStandalone,
	    defaultWidth: 'wide',
	    formattingValues: dayPeriodValuesFormatting,
	    defaultFormattingWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1417 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(14));
	
	var _index2 = _interopRequireDefault(__webpack_require__(15));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(\d+)\./i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  abbreviated: /^(pr\. n\. št\.|po n\. št\.)/i,
	  wide: /^(pred Kristusom|pred na[sš]im [sš]tetjem|po Kristusu|po na[sš]em [sš]tetju|na[sš]ega [sš]tetja)/i
	};
	var parseEraPatterns = {
	  any: [/^pr/i, /^(po|na[sš]em)/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^[1234]\.\s?[čc]et\.?/i,
	  wide: /^[1234]\. [čc]etrtletje/i
	};
	var parseQuarterPatterns = {
	  any: [/1/i, /2/i, /3/i, /4/i]
	};
	var matchMonthPatterns = {
	  narrow: /^[jfmasond]/i,
	  abbreviated: /^(jan\.|feb\.|mar\.|apr\.|maj|jun\.|jul\.|avg\.|sep\.|okt\.|nov\.|dec\.)/i,
	  wide: /^(januar|februar|marec|april|maj|junij|julij|avgust|september|oktober|november|december)/i
	};
	var parseMonthPatterns = {
	  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
	  abbreviated: [/^ja/i, /^fe/i, /^mar/i, /^ap/i, /^maj/i, /^jun/i, /^jul/i, /^av/i, /^s/i, /^o/i, /^n/i, /^d/i],
	  wide: [/^ja/i, /^fe/i, /^mar/i, /^ap/i, /^maj/i, /^jun/i, /^jul/i, /^av/i, /^s/i, /^o/i, /^n/i, /^d/i]
	};
	var matchDayPatterns = {
	  narrow: /^[nptsčc]/i,
	  short: /^(ned\.|pon\.|tor\.|sre\.|[cč]et\.|pet\.|sob\.)/i,
	  abbreviated: /^(ned\.|pon\.|tor\.|sre\.|[cč]et\.|pet\.|sob\.)/i,
	  wide: /^(nedelja|ponedeljek|torek|sreda|[cč]etrtek|petek|sobota)/i
	};
	var parseDayPatterns = {
	  narrow: [/^n/i, /^p/i, /^t/i, /^s/i, /^[cč]/i, /^p/i, /^s/i],
	  any: [/^n/i, /^po/i, /^t/i, /^sr/i, /^[cč]/i, /^pe/i, /^so/i]
	};
	var matchDayPeriodPatterns = {
	  narrow: /^(d|po?|z?v|n|z?j|24\.00|12\.00)/i,
	  any: /^(dop\.|pop\.|o?poln(\.|o[cč]i?)|o?pold(\.|ne)|z?ve[cč](\.|er)|(po)?no[cč]i?|popold(ne|an)|jut(\.|ro)|zjut(\.|raj))/i
	};
	var parseDayPeriodPatterns = {
	  narrow: {
	    am: /^d/i,
	    pm: /^p/i,
	    midnight: /^24/i,
	    noon: /^12/i,
	    morning: /^(z?j)/i,
	    afternoon: /^p/i,
	    evening: /^(z?v)/i,
	    night: /^(n|po)/i
	  },
	  any: {
	    am: /^dop\./i,
	    pm: /^pop\./i,
	    midnight: /^o?poln/i,
	    noon: /^o?pold/i,
	    morning: /j/i,
	    afternoon: /^pop\./i,
	    evening: /^z?ve/i,
	    night: /(po)?no/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index2.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1418 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1413));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1414));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1415));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1416));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1417));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Slovenian locale.
	 * @language Slovenian
	 * @iso-639-2 slv
	 * @author Adam Stradovnik [@Neoglyph]{@link https://github.com/Neoglyph}
	 * @author Mato Žgajner [@mzgajner]{@link https://github.com/mzgajner}
	 */
	var locale = {
	  code: 'sl',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 1
	    /* Monday */
	    ,
	    firstWeekContainsDate: 1
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1419 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistance;
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    one: 'më pak se një sekondë',
	    other: 'më pak se {{count}} sekonda'
	  },
	  xSeconds: {
	    one: '1 sekondë',
	    other: '{{count}} sekonda'
	  },
	  halfAMinute: 'gjysëm minuti',
	  lessThanXMinutes: {
	    one: 'më pak se një minute',
	    other: 'më pak se {{count}} minuta'
	  },
	  xMinutes: {
	    one: '1 minutë',
	    other: '{{count}} minuta'
	  },
	  aboutXHours: {
	    one: 'rreth 1 orë',
	    other: 'rreth {{count}} orë'
	  },
	  xHours: {
	    one: '1 orë',
	    other: '{{count}} orë'
	  },
	  xDays: {
	    one: '1 ditë',
	    other: '{{count}} ditë'
	  },
	  aboutXWeeks: {
	    one: 'rreth 1 javë',
	    other: 'rreth {{count}} javë'
	  },
	  xWeeks: {
	    one: '1 javë',
	    other: '{{count}} javë'
	  },
	  aboutXMonths: {
	    one: 'rreth 1 muaj',
	    other: 'rreth {{count}} muaj'
	  },
	  xMonths: {
	    one: '1 muaj',
	    other: '{{count}} muaj'
	  },
	  aboutXYears: {
	    one: 'rreth 1 vit',
	    other: 'rreth {{count}} vite'
	  },
	  xYears: {
	    one: '1 vit',
	    other: '{{count}} vite'
	  },
	  overXYears: {
	    one: 'mbi 1 vit',
	    other: 'mbi {{count}} vite'
	  },
	  almostXYears: {
	    one: 'pothuajse 1 vit',
	    other: 'pothuajse {{count}} vite'
	  }
	};
	
	function formatDistance(token, count, options) {
	  options = options || {};
	  var result;
	
	  if (typeof formatDistanceLocale[token] === 'string') {
	    result = formatDistanceLocale[token];
	  } else if (count === 1) {
	    result = formatDistanceLocale[token].one;
	  } else {
	    result = formatDistanceLocale[token].other.replace('{{count}}', count);
	  }
	
	  if (options.addSuffix) {
	    if (options.comparison > 0) {
	      return 'në ' + result;
	    } else {
	      return result + ' më parë';
	    }
	  }
	
	  return result;
	}
	
	module.exports = exports.default;

/***/ },
/* 1420 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: 'EEEE, MMMM do, y',
	  long: 'MMMM do, y',
	  medium: 'MMM d, y',
	  short: 'MM/dd/yyyy'
	};
	var timeFormats = {
	  full: 'h:mm:ss a zzzz',
	  long: 'h:mm:ss a z',
	  medium: 'h:mm:ss a',
	  short: 'h:mm a'
	};
	var dateTimeFormats = {
	  full: "{{date}} 'në' {{time}}",
	  long: "{{date}} 'në' {{time}}",
	  medium: '{{date}}, {{time}}',
	  short: '{{date}}, {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1421 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRelative;
	var formatRelativeLocale = {
	  lastWeek: "'të' eeee 'e shkuar në' p",
	  yesterday: "'dje në' p",
	  today: "'sot në' p",
	  tomorrow: "'nesër në' p",
	  nextWeek: "eeee 'at' p",
	  other: 'P'
	};
	
	function formatRelative(token, _date, _baseDate, _options) {
	  return formatRelativeLocale[token];
	}
	
	module.exports = exports.default;

/***/ },
/* 1422 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eraValues = {
	  narrow: ['P', 'M'],
	  abbreviated: ['PK', 'MK'],
	  wide: ['Para Krishtit', 'Mbas Krishtit']
	};
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
	  wide: ['4-mujori I', '4-mujori II', '4-mujori III', '4-mujori IV']
	}; // Note: in English, the names of days of the week and months are capitalized.
	// If you are making a new locale based on this one, check if the same is true for the language you're working on.
	// Generally, formatted dates should look like they are in the middle of a sentence,
	// e.g. in Spanish language the weekdays and months should be in the lowercase.
	
	var monthValues = {
	  narrow: ['J', 'S', 'M', 'P', 'M', 'Q', 'K', 'G', 'S', 'T', 'N', 'D'],
	  abbreviated: ['Jan', 'Shk', 'Mar', 'Pri', 'Maj', 'Qer', 'Kor', 'Gus', 'Sht', 'Tet', 'Nën', 'Dhj'],
	  wide: ['Janar', 'Shkurt', 'Mars', 'Prill', 'Maj', 'Qershor', 'Korrik', 'Gusht', 'Shtator', 'Tetor', 'Nëntor', 'Dhjetor']
	};
	var dayValues = {
	  narrow: ['D', 'H', 'M', 'M', 'E', 'P', 'S'],
	  short: ['Di', 'Hë', 'Ma', 'Më', 'En', 'Pr', 'Sh'],
	  abbreviated: ['Die', 'Hën', 'Mar', 'Mër', 'Enj', 'Pre', 'Sht'],
	  wide: ['Dielë', 'Hënë', 'Martë', 'Mërkurë', 'Enjte', 'Premte', 'Shtunë']
	};
	var dayPeriodValues = {
	  narrow: {
	    am: 'p',
	    pm: 'm',
	    midnight: 'm',
	    noon: 'd',
	    morning: 'mëngjes',
	    afternoon: 'dite',
	    evening: 'mbrëmje',
	    night: 'natë'
	  },
	  abbreviated: {
	    am: 'PD',
	    pm: 'MD',
	    midnight: 'mesnëtë',
	    noon: 'drek',
	    morning: 'mëngjes',
	    afternoon: 'mbasdite',
	    evening: 'mbrëmje',
	    night: 'natë'
	  },
	  wide: {
	    am: 'p.d.',
	    pm: 'm.d.',
	    midnight: 'mesnëtë',
	    noon: 'drek',
	    morning: 'mëngjes',
	    afternoon: 'mbasdite',
	    evening: 'mbrëmje',
	    night: 'natë'
	  }
	};
	var formattingDayPeriodValues = {
	  narrow: {
	    am: 'p',
	    pm: 'm',
	    midnight: 'm',
	    noon: 'd',
	    morning: 'në mëngjes',
	    afternoon: 'në mbasdite',
	    evening: 'në mbrëmje',
	    night: 'në mesnatë'
	  },
	  abbreviated: {
	    am: 'PD',
	    pm: 'MD',
	    midnight: 'mesnatë',
	    noon: 'drek',
	    morning: 'në mëngjes',
	    afternoon: 'në mbasdite',
	    evening: 'në mbrëmje',
	    night: 'në mesnatë'
	  },
	  wide: {
	    am: 'p.d.',
	    pm: 'm.d.',
	    midnight: 'mesnatë',
	    noon: 'drek',
	    morning: 'në mëngjes',
	    afternoon: 'në mbasdite',
	    evening: 'në mbrëmje',
	    night: 'në mesnatë'
	  }
	};
	
	function ordinalNumber(dirtyNumber, _dirtyOptions) {
	  var number = Number(dirtyNumber); // If ordinal numbers depend on context, for example,
	  // if they are different for different grammatical genders,
	  // use `options.unit`:
	  //
	  //   var options = dirtyOptions || {}
	  //   var unit = String(options.unit)
	  //
	  // where `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
	  // 'day', 'hour', 'minute', 'second'
	
	  var options = _dirtyOptions || {};
	  var unit = String(options.unit);
	  if (unit === 'hour') return number;
	  if (number === 1) return number + '-rë';
	  if (number === 4) return number + 't';
	  return number + '-të';
	}
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingDayPeriodValues,
	    defaultFormattingWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1423 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(15));
	
	var _index2 = _interopRequireDefault(__webpack_require__(14));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(\d+)(-rë|-të|t|)?/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^(p|m)/i,
	  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
	  wide: /^(para krishtit|mbas krishtit)/i
	};
	var parseEraPatterns = {
	  any: [/^b/i, /^(p|m)/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^q[1234]/i,
	  wide: /^[1234]-mujori (i{1,3}|iv)/i
	};
	var parseQuarterPatterns = {
	  any: [/1/i, /2/i, /3/i, /4/i]
	};
	var matchMonthPatterns = {
	  narrow: /^[jsmpqkftnd]/i,
	  abbreviated: /^(jan|shk|mar|pri|maj|qer|kor|gus|sht|tet|nën|dhj)/i,
	  wide: /^(janar|shkurt|mars|prill|maj|qershor|korrik|gusht|shtator|tetor|nëntor|dhjetor)/i
	};
	var parseMonthPatterns = {
	  narrow: [/^j/i, /^s/i, /^m/i, /^p/i, /^m/i, /^q/i, /^k/i, /^g/i, /^s/i, /^t/i, /^n/i, /^d/i],
	  any: [/^ja/i, /^shk/i, /^mar/i, /^pri/i, /^maj/i, /^qer/i, /^kor/i, /^gu/i, /^sht/i, /^tet/i, /^n/i, /^d/i]
	};
	var matchDayPatterns = {
	  narrow: /^[dhmeps]/i,
	  short: /^(di|hë|ma|më|en|pr|sh)/i,
	  abbreviated: /^(die|hën|mar|mër|enj|pre|sht)/i,
	  wide: /^(dielë|hënë|martë|mërkurë|enjte|premte|shtunë)/i
	};
	var parseDayPatterns = {
	  narrow: [/^d/i, /^h/i, /^m/i, /^m/i, /^e/i, /^p/i, /^s/i],
	  any: [/^d/i, /^h/i, /^ma/i, /^më/i, /^e/i, /^p/i, /^s/i]
	};
	var matchDayPeriodPatterns = {
	  narrow: /^(p|m|me|në (mëngjes|mbasdite|mbrëmje|mesnatë))/i,
	  any: /^([pm]\.?\s?d\.?|drek|në (mëngjes|mbasdite|mbrëmje|mesnatë))/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^p/i,
	    pm: /^m/i,
	    midnight: /^me/i,
	    noon: /^dr/i,
	    morning: /mëngjes/i,
	    afternoon: /mbasdite/i,
	    evening: /mbrëmje/i,
	    night: /natë/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index2.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index2.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index2.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index2.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index2.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1424 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1419));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1420));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1421));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1422));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1423));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Albanian locale.
	 * @language Shqip
	 * @iso-639-2 sqi
	 * @author Ardit Dine [@arditdine]{@link https://github.com/arditdine}
	 */
	var locale = {
	  code: 'sq',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 1
	    /* Monday */
	    ,
	    firstWeekContainsDate: 1
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1425 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistance;
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    one: {
	      standalone: 'manje od 1 sekunde',
	      withPrepositionAgo: 'manje od 1 sekunde',
	      withPrepositionIn: 'manje od 1 sekundu'
	    },
	    dual: 'manje od {{count}} sekunde',
	    other: 'manje od {{count}} sekundi'
	  },
	  xSeconds: {
	    one: {
	      standalone: '1 sekunda',
	      withPrepositionAgo: '1 sekunde',
	      withPrepositionIn: '1 sekundu'
	    },
	    dual: '{{count}} sekunde',
	    other: '{{count}} sekundi'
	  },
	  halfAMinute: 'pola minute',
	  lessThanXMinutes: {
	    one: {
	      standalone: 'manje od 1 minute',
	      withPrepositionAgo: 'manje od 1 minute',
	      withPrepositionIn: 'manje od 1 minutu'
	    },
	    dual: 'manje od {{count}} minute',
	    other: 'manje od {{count}} minuta'
	  },
	  xMinutes: {
	    one: {
	      standalone: '1 minuta',
	      withPrepositionAgo: '1 minute',
	      withPrepositionIn: '1 minutu'
	    },
	    dual: '{{count}} minute',
	    other: '{{count}} minuta'
	  },
	  aboutXHours: {
	    one: {
	      standalone: 'oko 1 sat',
	      withPrepositionAgo: 'oko 1 sat',
	      withPrepositionIn: 'oko 1 sat'
	    },
	    dual: 'oko {{count}} sata',
	    other: 'oko {{count}} sati'
	  },
	  xHours: {
	    one: {
	      standalone: '1 sat',
	      withPrepositionAgo: '1 sat',
	      withPrepositionIn: '1 sat'
	    },
	    dual: '{{count}} sata',
	    other: '{{count}} sati'
	  },
	  xDays: {
	    one: {
	      standalone: '1 dan',
	      withPrepositionAgo: '1 dan',
	      withPrepositionIn: '1 dan'
	    },
	    dual: '{{count}} dana',
	    other: '{{count}} dana'
	  },
	  aboutXWeeks: {
	    one: {
	      standalone: 'oko 1 nedelju',
	      withPrepositionAgo: 'oko 1 nedelju',
	      withPrepositionIn: 'oko 1 nedelju'
	    },
	    dual: 'oko {{count}} nedelje',
	    other: 'oko {{count}} nedelje'
	  },
	  xWeeks: {
	    one: {
	      standalone: '1 nedelju',
	      withPrepositionAgo: '1 nedelju',
	      withPrepositionIn: '1 nedelju'
	    },
	    dual: '{{count}} nedelje',
	    other: '{{count}} nedelje'
	  },
	  aboutXMonths: {
	    one: {
	      standalone: 'oko 1 mesec',
	      withPrepositionAgo: 'oko 1 mesec',
	      withPrepositionIn: 'oko 1 mesec'
	    },
	    dual: 'oko {{count}} meseca',
	    other: 'oko {{count}} meseci'
	  },
	  xMonths: {
	    one: {
	      standalone: '1 mesec',
	      withPrepositionAgo: '1 mesec',
	      withPrepositionIn: '1 mesec'
	    },
	    dual: '{{count}} meseca',
	    other: '{{count}} meseci'
	  },
	  aboutXYears: {
	    one: {
	      standalone: 'oko 1 godinu',
	      withPrepositionAgo: 'oko 1 godinu',
	      withPrepositionIn: 'oko 1 godinu'
	    },
	    dual: 'oko {{count}} godine',
	    other: 'oko {{count}} godina'
	  },
	  xYears: {
	    one: {
	      standalone: '1 godina',
	      withPrepositionAgo: '1 godine',
	      withPrepositionIn: '1 godinu'
	    },
	    dual: '{{count}} godine',
	    other: '{{count}} godina'
	  },
	  overXYears: {
	    one: {
	      standalone: 'preko 1 godinu',
	      withPrepositionAgo: 'preko 1 godinu',
	      withPrepositionIn: 'preko 1 godinu'
	    },
	    dual: 'preko {{count}} godine',
	    other: 'preko {{count}} godina'
	  },
	  almostXYears: {
	    one: {
	      standalone: 'gotovo 1 godinu',
	      withPrepositionAgo: 'gotovo 1 godinu',
	      withPrepositionIn: 'gotovo 1 godinu'
	    },
	    dual: 'gotovo {{count}} godine',
	    other: 'gotovo {{count}} godina'
	  }
	};
	
	function formatDistance(token, count, options) {
	  options = options || {};
	  var result;
	
	  if (typeof formatDistanceLocale[token] === 'string') {
	    result = formatDistanceLocale[token];
	  } else if (count === 1) {
	    if (options.addSuffix) {
	      if (options.comparison > 0) {
	        result = formatDistanceLocale[token].one.withPrepositionIn;
	      } else {
	        result = formatDistanceLocale[token].one.withPrepositionAgo;
	      }
	    } else {
	      result = formatDistanceLocale[token].one.standalone;
	    }
	  } else if (count % 10 > 1 && count % 10 < 5 && // if last digit is between 2 and 4
	  String(count).substr(-2, 1) !== '1' // unless the 2nd to last digit is "1"
	  ) {
	      result = formatDistanceLocale[token].dual.replace('{{count}}', count);
	    } else {
	    result = formatDistanceLocale[token].other.replace('{{count}}', count);
	  }
	
	  if (options.addSuffix) {
	    if (options.comparison > 0) {
	      return 'za ' + result;
	    } else {
	      return 'pre ' + result;
	    }
	  }
	
	  return result;
	}
	
	module.exports = exports.default;

/***/ },
/* 1426 */
1096,
/* 1427 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRelative;
	var formatRelativeLocale = {
	  lastWeek: function (date) {
	    var day = date.getUTCDay();
	
	    switch (day) {
	      case 0:
	        return "'prošle nedelje u' p";
	
	      case 3:
	        return "'prošle srede u' p";
	
	      case 6:
	        return "'prošle subote u' p";
	
	      default:
	        return "'prošli' EEEE 'u' p";
	    }
	  },
	  yesterday: "'juče u' p",
	  today: "'danas u' p",
	  tomorrow: "'sutra u' p",
	  nextWeek: function (date) {
	    var day = date.getUTCDay();
	
	    switch (day) {
	      case 0:
	        return "'sledeće nedelje u' p";
	
	      case 3:
	        return "'sledeću sredu u' p";
	
	      case 6:
	        return "'sledeću subotu u' p";
	
	      default:
	        return "'sledeći' EEEE 'u' p";
	    }
	  },
	  other: 'P'
	};
	
	function formatRelative(token, date, _baseDate, _options) {
	  var format = formatRelativeLocale[token];
	
	  if (typeof format === 'function') {
	    return format(date);
	  }
	
	  return format;
	}
	
	module.exports = exports.default;

/***/ },
/* 1428 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ordinalNumber(dirtyNumber) {
	  var number = Number(dirtyNumber);
	  return String(number).concat('.');
	}
	
	var eraValues = {
	  narrow: ['pr.n.e.', 'AD'],
	  abbreviated: ['pr. Hr.', 'po. Hr.'],
	  wide: ['Pre Hrista', 'Posle Hrista']
	};
	var monthValues = {
	  narrow: ['1.', '2.', '3.', '4.', '5.', '6.', '7.', '8.', '9.', '10.', '11.', '12.'],
	  abbreviated: ['jan', 'feb', 'mar', 'apr', 'maj', 'jun', 'jul', 'avg', 'sep', 'okt', 'nov', 'dec'],
	  wide: ['januar', 'februar', 'mart', 'april', 'maj', 'jun', 'jul', 'avgust', 'septembar', 'oktobar', 'novembar', 'decembar']
	};
	var formattingMonthValues = {
	  narrow: ['1.', '2.', '3.', '4.', '5.', '6.', '7.', '8.', '9.', '10.', '11.', '12.'],
	  abbreviated: ['jan', 'feb', 'mar', 'apr', 'maj', 'jun', 'jul', 'avg', 'sep', 'okt', 'nov', 'dec'],
	  wide: ['januar', 'februar', 'mart', 'april', 'maj', 'jun', 'jul', 'avgust', 'septembar', 'oktobar', 'novembar', 'decembar']
	};
	var quarterValues = {
	  narrow: ['1.', '2.', '3.', '4.'],
	  abbreviated: ['1. kv.', '2. kv.', '3. kv.', '4. kv.'],
	  wide: ['1. kvartal', '2. kvartal', '3. kvartal', '4. kvartal']
	};
	var dayValues = {
	  narrow: ['N', 'P', 'U', 'S', 'Č', 'P', 'S'],
	  short: ['ned', 'pon', 'uto', 'sre', 'čet', 'pet', 'sub'],
	  abbreviated: ['ned', 'pon', 'uto', 'sre', 'čet', 'pet', 'sub'],
	  wide: ['nedelja', 'ponedeljak', 'utorak', 'sreda', 'četvrtak', 'petak', 'subota']
	};
	var formattingDayPeriodValues = {
	  narrow: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'ponoć',
	    noon: 'podne',
	    morning: 'ujutru',
	    afternoon: 'popodne',
	    evening: 'uveče',
	    night: 'noću'
	  },
	  abbreviated: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'ponoć',
	    noon: 'podne',
	    morning: 'ujutru',
	    afternoon: 'popodne',
	    evening: 'uveče',
	    night: 'noću'
	  },
	  wide: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'ponoć',
	    noon: 'podne',
	    morning: 'ujutru',
	    afternoon: 'posle podne',
	    evening: 'uveče',
	    night: 'noću'
	  }
	};
	var dayPeriodValues = {
	  narrow: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'ponoć',
	    noon: 'podne',
	    morning: 'ujutru',
	    afternoon: 'popodne',
	    evening: 'uveče',
	    night: 'noću'
	  },
	  abbreviated: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'ponoć',
	    noon: 'podne',
	    morning: 'ujutru',
	    afternoon: 'popodne',
	    evening: 'uveče',
	    night: 'noću'
	  },
	  wide: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'ponoć',
	    noon: 'podne',
	    morning: 'ujutru',
	    afternoon: 'posle podne',
	    evening: 'uveče',
	    night: 'noću'
	  }
	};
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingMonthValues,
	    defaultFormattingWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingDayPeriodValues,
	    defaultFormattingWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1429 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(14));
	
	var _index2 = _interopRequireDefault(__webpack_require__(15));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(\d+)\./i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^(pr\.n\.e\.|AD)/i,
	  abbreviated: /^(pr\.\s?Hr\.|po\.\s?Hr\.)/i,
	  wide: /^(Pre Hrista|pre nove ere|Posle Hrista|nova era)/i
	};
	var parseEraPatterns = {
	  any: [/^pr/i, /^(po|nova)/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^[1234]\.\s?kv\.?/i,
	  wide: /^[1234]\. kvartal/i
	};
	var parseQuarterPatterns = {
	  any: [/1/i, /2/i, /3/i, /4/i]
	};
	var matchMonthPatterns = {
	  narrow: /^(10|11|12|[123456789])\./i,
	  abbreviated: /^(jan|feb|mar|apr|maj|jun|jul|avg|sep|okt|nov|dec)/i,
	  wide: /^((januar|januara)|(februar|februara)|(mart|marta)|(april|aprila)|(maj|maja)|(jun|juna)|(jul|jula)|(avgust|avgusta)|(septembar|septembra)|(oktobar|oktobra)|(novembar|novembra)|(decembar|decembra))/i
	};
	var parseMonthPatterns = {
	  narrow: [/(10|11|12|[123456789])/i],
	  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^maj/i, /^jun/i, /^jul/i, /^avg/i, /^s/i, /^o/i, /^n/i, /^d/i]
	};
	var matchDayPatterns = {
	  narrow: /^[npusčc]/i,
	  short: /^(ned|pon|uto|sre|(čet|cet)|pet|sub)/i,
	  abbreviated: /^(ned|pon|uto|sre|(čet|cet)|pet|sub)/i,
	  wide: /^(nedelja|ponedeljak|utorak|sreda|(četvrtak|cetvrtak)|petak|subota)/i
	};
	var parseDayPatterns = {
	  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
	  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
	};
	var matchDayPeriodPatterns = {
	  any: /^(am|pm|ponoc|ponoć|(po)?podne|uvece|uveče|noću|posle podne|ujutru)/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^a/i,
	    pm: /^p/i,
	    midnight: /^pono/i,
	    noon: /^pod/i,
	    morning: /jutro/i,
	    afternoon: /(posle\s|po)+podne/i,
	    evening: /(uvece|uveče)/i,
	    night: /(nocu|noću)/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index2.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1430 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1425));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1426));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1427));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1428));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1429));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Serbian latin locale.
	 * @language Serbian
	 * @iso-639-2 srp
	 * @author Igor Radivojević [@rogyvoje]{@link https://github.com/rogyvoje}
	 */
	var locale = {
	  code: 'sr-Latn',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 1
	    /* Monday */
	    ,
	    firstWeekContainsDate: 1
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1431 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistance;
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    one: {
	      standalone: 'мање од 1 секунде',
	      withPrepositionAgo: 'мање од 1 секунде',
	      withPrepositionIn: 'мање од 1 секунду'
	    },
	    dual: 'мање од {{count}} секунде',
	    other: 'мање од {{count}} секунди'
	  },
	  xSeconds: {
	    one: {
	      standalone: '1 секунда',
	      withPrepositionAgo: '1 секунде',
	      withPrepositionIn: '1 секунду'
	    },
	    dual: '{{count}} секунде',
	    other: '{{count}} секунди'
	  },
	  halfAMinute: 'пола минуте',
	  lessThanXMinutes: {
	    one: {
	      standalone: 'мање од 1 минуте',
	      withPrepositionAgo: 'мање од 1 минуте',
	      withPrepositionIn: 'мање од 1 минуту'
	    },
	    dual: 'мање од {{count}} минуте',
	    other: 'мање од {{count}} минута'
	  },
	  xMinutes: {
	    one: {
	      standalone: '1 минута',
	      withPrepositionAgo: '1 минуте',
	      withPrepositionIn: '1 минуту'
	    },
	    dual: '{{count}} минуте',
	    other: '{{count}} минута'
	  },
	  aboutXHours: {
	    one: {
	      standalone: 'око 1 сат',
	      withPrepositionAgo: 'око 1 сат',
	      withPrepositionIn: 'око 1 сат'
	    },
	    dual: 'око {{count}} сата',
	    other: 'око {{count}} сати'
	  },
	  xHours: {
	    one: {
	      standalone: '1 сат',
	      withPrepositionAgo: '1 сат',
	      withPrepositionIn: '1 сат'
	    },
	    dual: '{{count}} сата',
	    other: '{{count}} сати'
	  },
	  xDays: {
	    one: {
	      standalone: '1 дан',
	      withPrepositionAgo: '1 дан',
	      withPrepositionIn: '1 дан'
	    },
	    dual: '{{count}} дана',
	    other: '{{count}} дана'
	  },
	  aboutXWeeks: {
	    one: {
	      standalone: 'око 1 недељу',
	      withPrepositionAgo: 'око 1 недељу',
	      withPrepositionIn: 'око 1 недељу'
	    },
	    dual: 'око {{count}} недеље',
	    other: 'око {{count}} недеље'
	  },
	  xWeeks: {
	    one: {
	      standalone: '1 недељу',
	      withPrepositionAgo: '1 недељу',
	      withPrepositionIn: '1 недељу'
	    },
	    dual: '{{count}} недеље',
	    other: '{{count}} недеље'
	  },
	  aboutXMonths: {
	    one: {
	      standalone: 'око 1 месец',
	      withPrepositionAgo: 'око 1 месец',
	      withPrepositionIn: 'око 1 месец'
	    },
	    dual: 'око {{count}} месеца',
	    other: 'око {{count}} месеци'
	  },
	  xMonths: {
	    one: {
	      standalone: '1 месец',
	      withPrepositionAgo: '1 месец',
	      withPrepositionIn: '1 месец'
	    },
	    dual: '{{count}} месеца',
	    other: '{{count}} месеци'
	  },
	  aboutXYears: {
	    one: {
	      standalone: 'око 1 годину',
	      withPrepositionAgo: 'око 1 годину',
	      withPrepositionIn: 'око 1 годину'
	    },
	    dual: 'око {{count}} године',
	    other: 'око {{count}} година'
	  },
	  xYears: {
	    one: {
	      standalone: '1 година',
	      withPrepositionAgo: '1 године',
	      withPrepositionIn: '1 годину'
	    },
	    dual: '{{count}} године',
	    other: '{{count}} година'
	  },
	  overXYears: {
	    one: {
	      standalone: 'преко 1 годину',
	      withPrepositionAgo: 'преко 1 годину',
	      withPrepositionIn: 'преко 1 годину'
	    },
	    dual: 'преко {{count}} године',
	    other: 'преко {{count}} година'
	  },
	  almostXYears: {
	    one: {
	      standalone: 'готово 1 годину',
	      withPrepositionAgo: 'готово 1 годину',
	      withPrepositionIn: 'готово 1 годину'
	    },
	    dual: 'готово {{count}} године',
	    other: 'готово {{count}} година'
	  }
	};
	
	function formatDistance(token, count, options) {
	  options = options || {};
	  var result;
	
	  if (typeof formatDistanceLocale[token] === 'string') {
	    result = formatDistanceLocale[token];
	  } else if (count === 1) {
	    if (options.addSuffix) {
	      if (options.comparison > 0) {
	        result = formatDistanceLocale[token].one.withPrepositionIn;
	      } else {
	        result = formatDistanceLocale[token].one.withPrepositionAgo;
	      }
	    } else {
	      result = formatDistanceLocale[token].one.standalone;
	    }
	  } else if (count % 10 > 1 && count % 10 < 5 && // if last digit is between 2 and 4
	  String(count).substr(-2, 1) !== '1' // unless the 2nd to last digit is "1"
	  ) {
	      result = formatDistanceLocale[token].dual.replace('{{count}}', count);
	    } else {
	    result = formatDistanceLocale[token].other.replace('{{count}}', count);
	  }
	
	  if (options.addSuffix) {
	    if (options.comparison > 0) {
	      return 'за ' + result;
	    } else {
	      return 'пре ' + result;
	    }
	  }
	
	  return result;
	}
	
	module.exports = exports.default;

/***/ },
/* 1432 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: 'EEEE, d. MMMM yyyy.',
	  long: 'd. MMMM yyyy.',
	  medium: 'd. MMM yy.',
	  short: 'dd. MM. yy.'
	};
	var timeFormats = {
	  full: 'HH:mm:ss (zzzz)',
	  long: 'HH:mm:ss z',
	  medium: 'HH:mm:ss',
	  short: 'HH:mm'
	};
	var dateTimeFormats = {
	  full: "{{date}} 'у' {{time}}",
	  long: "{{date}} 'у' {{time}}",
	  medium: '{{date}} {{time}}',
	  short: '{{date}} {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1433 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRelative;
	var formatRelativeLocale = {
	  lastWeek: function (date) {
	    var day = date.getUTCDay();
	
	    switch (day) {
	      case 0:
	        return "'прошле недеље у' p";
	
	      case 3:
	        return "'прошле среде у' p";
	
	      case 6:
	        return "'прошле суботе у' p";
	
	      default:
	        return "'прошли' EEEE 'у' p";
	    }
	  },
	  yesterday: "'јуче у' p",
	  today: "'данас у' p",
	  tomorrow: "'сутра у' p",
	  nextWeek: function (date) {
	    var day = date.getUTCDay();
	
	    switch (day) {
	      case 0:
	        return "'следеће недеље у' p";
	
	      case 3:
	        return "'следећу среду у' p";
	
	      case 6:
	        return "'следећу суботу у' p";
	
	      default:
	        return "'следећи' EEEE 'у' p";
	    }
	  },
	  other: 'P'
	};
	
	function formatRelative(token, date, _baseDate, _options) {
	  var format = formatRelativeLocale[token];
	
	  if (typeof format === 'function') {
	    return format(date);
	  }
	
	  return format;
	}
	
	module.exports = exports.default;

/***/ },
/* 1434 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ordinalNumber(dirtyNumber) {
	  var number = Number(dirtyNumber);
	  return String(number).concat('.');
	}
	
	var eraValues = {
	  narrow: ['пр.н.е.', 'АД'],
	  abbreviated: ['пр. Хр.', 'по. Хр.'],
	  wide: ['Пре Христа', 'После Христа']
	};
	var monthValues = {
	  narrow: ['1.', '2.', '3.', '4.', '5.', '6.', '7.', '8.', '9.', '10.', '11.', '12.'],
	  abbreviated: ['јан', 'феб', 'мар', 'апр', 'мај', 'јун', 'јул', 'авг', 'сеп', 'окт', 'нов', 'дец'],
	  wide: ['јануар', 'фебруар', 'март', 'април', 'мај', 'јун', 'јул', 'август', 'септембар', 'октобар', 'новембар', 'децембар']
	};
	var formattingMonthValues = {
	  narrow: ['1.', '2.', '3.', '4.', '5.', '6.', '7.', '8.', '9.', '10.', '11.', '12.'],
	  abbreviated: ['јан', 'феб', 'мар', 'апр', 'мај', 'јун', 'јул', 'авг', 'сеп', 'окт', 'нов', 'дец'],
	  wide: ['јануар', 'фебруар', 'март', 'април', 'мај', 'јун', 'јул', 'август', 'септембар', 'октобар', 'новембар', 'децембар']
	};
	var quarterValues = {
	  narrow: ['1.', '2.', '3.', '4.'],
	  abbreviated: ['1. кв.', '2. кв.', '3. кв.', '4. кв.'],
	  wide: ['1. квартал', '2. квартал', '3. квартал', '4. квартал']
	};
	var dayValues = {
	  narrow: ['Н', 'П', 'У', 'С', 'Ч', 'П', 'С'],
	  short: ['нед', 'пон', 'уто', 'сре', 'чет', 'пет', 'суб'],
	  abbreviated: ['нед', 'пон', 'уто', 'сре', 'чет', 'пет', 'суб'],
	  wide: ['недеља', 'понедељак', 'уторак', 'среда', 'четвртак', 'петак', 'субота']
	};
	var formattingDayPeriodValues = {
	  narrow: {
	    am: 'АМ',
	    pm: 'ПМ',
	    midnight: 'поноћ',
	    noon: 'подне',
	    morning: 'ујутру',
	    afternoon: 'поподне',
	    evening: 'увече',
	    night: 'ноћу'
	  },
	  abbreviated: {
	    am: 'АМ',
	    pm: 'ПМ',
	    midnight: 'поноћ',
	    noon: 'подне',
	    morning: 'ујутру',
	    afternoon: 'поподне',
	    evening: 'увече',
	    night: 'ноћу'
	  },
	  wide: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'поноћ',
	    noon: 'подне',
	    morning: 'ујутру',
	    afternoon: 'после подне',
	    evening: 'увече',
	    night: 'ноћу'
	  }
	};
	var dayPeriodValues = {
	  narrow: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'поноћ',
	    noon: 'подне',
	    morning: 'ујутру',
	    afternoon: 'поподне',
	    evening: 'увече',
	    night: 'ноћу'
	  },
	  abbreviated: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'поноћ',
	    noon: 'подне',
	    morning: 'ујутру',
	    afternoon: 'поподне',
	    evening: 'увече',
	    night: 'ноћу'
	  },
	  wide: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'поноћ',
	    noon: 'подне',
	    morning: 'ујутру',
	    afternoon: 'после подне',
	    evening: 'увече',
	    night: 'ноћу'
	  }
	};
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingMonthValues,
	    defaultFormattingWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingDayPeriodValues,
	    defaultFormattingWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1435 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(14));
	
	var _index2 = _interopRequireDefault(__webpack_require__(15));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(\d+)\./i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^(пр\.н\.е\.|АД)/i,
	  abbreviated: /^(пр\.\s?Хр\.|по\.\s?Хр\.)/i,
	  wide: /^(Пре Христа|пре нове ере|После Христа|нова ера)/i
	};
	var parseEraPatterns = {
	  any: [/^пр/i, /^(по|нова)/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^[1234]\.\s?кв\.?/i,
	  wide: /^[1234]\. квартал/i
	};
	var parseQuarterPatterns = {
	  any: [/1/i, /2/i, /3/i, /4/i]
	};
	var matchMonthPatterns = {
	  narrow: /^(10|11|12|[123456789])\./i,
	  abbreviated: /^(јан|феб|мар|апр|мај|јун|јул|авг|сеп|окт|нов|дец)/i,
	  wide: /^((јануар|јануара)|(фебруар|фебруара)|(март|марта)|(април|априла)|(мја|маја)|(јун|јуна)|(јул|јула)|(август|августа)|(септембар|септембра)|(октобар|октобра)|(новембар|новембра)|(децембар|децембра))/i
	};
	var parseMonthPatterns = {
	  narrow: [/(10|11|12|[123456789])/i],
	  any: [/^ја/i, /^ф/i, /^мар/i, /^ап/i, /^мај/i, /^јун/i, /^јул/i, /^авг/i, /^с/i, /^о/i, /^н/i, /^д/i]
	};
	var matchDayPatterns = {
	  narrow: /^[пусчн]/i,
	  short: /^(нед|пон|уто|сре|чет|пет|суб)/i,
	  abbreviated: /^(нед|пон|уто|сре|чет|пет|суб)/i,
	  wide: /^(недеља|понедељак|уторак|среда|четвртак|петак|субота)/i
	};
	var parseDayPatterns = {
	  narrow: [/^п/i, /^у/i, /^с/i, /^ч/i, /^н/i],
	  any: [/^нед/i, /^пон/i, /^уто/i, /^сре/i, /^чет/i, /^пет/i, /^суб/i]
	};
	var matchDayPeriodPatterns = {
	  any: /^(ам|пм|поноћ|(по)?подне|увече|ноћу|после подне|ујутру)/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^a/i,
	    pm: /^p/i,
	    midnight: /^поно/i,
	    noon: /^под/i,
	    morning: /ујутру/i,
	    afternoon: /(после\s|по)+подне/i,
	    evening: /(увече)/i,
	    night: /(ноћу)/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index2.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1436 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1431));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1432));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1433));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1434));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1435));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Serbian cyrillic locale.
	 * @language Serbian
	 * @iso-639-2 srp
	 * @author Igor Radivojević [@rogyvoje]{@link https://github.com/rogyvoje}
	 */
	var locale = {
	  code: 'sr',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 1
	    /* Monday */
	    ,
	    firstWeekContainsDate: 1
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1437 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistance;
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    singular: 'mindre än en sekund',
	    plural: 'mindre än {{count}} sekunder'
	  },
	  xSeconds: {
	    singular: 'en sekund',
	    plural: '{{count}} sekunder'
	  },
	  halfAMinute: 'en halv minut',
	  lessThanXMinutes: {
	    singular: 'mindre än en minut',
	    plural: 'mindre än {{count}} minuter'
	  },
	  xMinutes: {
	    singular: 'en minut',
	    plural: '{{count}} minuter'
	  },
	  aboutXHours: {
	    singular: 'ungefär en timme',
	    plural: 'ungefär {{count}} timmar'
	  },
	  xHours: {
	    singular: 'en timme',
	    plural: '{{count}} timmar'
	  },
	  xDays: {
	    singular: 'en dag',
	    plural: '{{count}} dagar'
	  },
	  aboutXWeeks: {
	    singular: 'ungefär en vecka',
	    plural: 'ungefär {{count}} vecka'
	  },
	  xWeeks: {
	    singular: 'en vecka',
	    plural: '{{count}} vecka'
	  },
	  aboutXMonths: {
	    singular: 'ungefär en månad',
	    plural: 'ungefär {{count}} månader'
	  },
	  xMonths: {
	    singular: 'en månad',
	    plural: '{{count}} månader'
	  },
	  aboutXYears: {
	    singular: 'ungefär ett år',
	    plural: 'ungefär {{count}} år'
	  },
	  xYears: {
	    singular: 'ett år',
	    plural: '{{count}} år'
	  },
	  overXYears: {
	    singular: 'över ett år',
	    plural: 'över {{count}} år'
	  },
	  almostXYears: {
	    singular: 'nästan ett år',
	    plural: 'nästan {{count}} år'
	  }
	};
	var wordMapping = ['noll', 'en', 'två', 'tre', 'fyra', 'fem', 'sex', 'sju', 'åtta', 'nio', 'tio', 'elva', 'tolv'];
	
	function formatDistance(token, count, options) {
	  options = options || {
	    onlyNumeric: false
	  };
	  var translation = formatDistanceLocale[token];
	  var result;
	
	  if (typeof translation === 'string') {
	    result = translation;
	  } else if (count === 0 || count > 1) {
	    if (options.onlyNumeric) {
	      result = translation.plural.replace('{{count}}', count);
	    } else {
	      result = translation.plural.replace('{{count}}', count < 13 ? wordMapping[count] : count);
	    }
	  } else {
	    result = translation.singular;
	  }
	
	  if (options.addSuffix) {
	    if (options.comparison > 0) {
	      return 'om ' + result;
	    } else {
	      return result + ' sedan';
	    }
	  }
	
	  return result;
	}
	
	module.exports = exports.default;

/***/ },
/* 1438 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: 'EEEE d MMMM y',
	  long: 'd MMMM y',
	  medium: 'd MMM y',
	  short: 'y-MM-dd'
	};
	var timeFormats = {
	  full: "'kl'. HH:mm:ss zzzz",
	  long: 'HH:mm:ss z',
	  medium: 'HH:mm:ss',
	  short: 'HH:mm'
	};
	var dateTimeFormats = {
	  full: "{{date}} 'kl.' {{time}}",
	  long: "{{date}} 'kl.' {{time}}",
	  medium: '{{date}} {{time}}',
	  short: '{{date}} {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1439 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRelative;
	var formatRelativeLocale = {
	  lastWeek: "'i' EEEE's kl.' p",
	  yesterday: "'igår kl.' p",
	  today: "'idag kl.' p",
	  tomorrow: "'imorgon kl.' p",
	  nextWeek: "EEEE 'kl.' p",
	  other: 'P'
	};
	
	function formatRelative(token, _date, _baseDate, _options) {
	  return formatRelativeLocale[token];
	}
	
	module.exports = exports.default;

/***/ },
/* 1440 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eraValues = {
	  narrow: ['f.Kr.', 'e.Kr.'],
	  abbreviated: ['f.Kr.', 'e.Kr.'],
	  wide: ['före Kristus', 'efter Kristus']
	};
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
	  wide: ['1:a kvartalet', '2:a kvartalet', '3:e kvartalet', '4:e kvartalet']
	};
	var monthValues = {
	  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
	  abbreviated: ['jan.', 'feb.', 'mars', 'apr.', 'maj', 'juni', 'juli', 'aug.', 'sep.', 'okt.', 'nov.', 'dec.'],
	  wide: ['januari', 'februari', 'mars', 'april', 'maj', 'juni', 'juli', 'augusti', 'september', 'oktober', 'november', 'december']
	};
	var dayValues = {
	  narrow: ['S', 'M', 'T', 'O', 'T', 'F', 'L'],
	  short: ['sö', 'må', 'ti', 'on', 'to', 'fr', 'lö'],
	  abbreviated: ['sön', 'mån', 'tis', 'ons', 'tors', 'fre', 'lör'],
	  wide: ['söndag', 'måndag', 'tisdag', 'onsdag', 'torsdag', 'fredag', 'lördag']
	}; // https://www.unicode.org/cldr/charts/32/summary/sv.html#1888
	
	var dayPeriodValues = {
	  narrow: {
	    am: 'fm',
	    pm: 'em',
	    midnight: 'midnatt',
	    noon: 'middag',
	    morning: 'morg.',
	    afternoon: 'efterm.',
	    evening: 'kväll',
	    night: 'natt'
	  },
	  abbreviated: {
	    am: 'f.m.',
	    pm: 'e.m.',
	    midnight: 'midnatt',
	    noon: 'middag',
	    morning: 'morgon',
	    afternoon: 'efterm.',
	    evening: 'kväll',
	    night: 'natt'
	  },
	  wide: {
	    am: 'förmiddag',
	    pm: 'eftermiddag',
	    midnight: 'midnatt',
	    noon: 'middag',
	    morning: 'morgon',
	    afternoon: 'eftermiddag',
	    evening: 'kväll',
	    night: 'natt'
	  }
	};
	var formattingDayPeriodValues = {
	  narrow: {
	    am: 'fm',
	    pm: 'em',
	    midnight: 'midnatt',
	    noon: 'middag',
	    morning: 'på morg.',
	    afternoon: 'på efterm.',
	    evening: 'på kvällen',
	    night: 'på natten'
	  },
	  abbreviated: {
	    am: 'fm',
	    pm: 'em',
	    midnight: 'midnatt',
	    noon: 'middag',
	    morning: 'på morg.',
	    afternoon: 'på efterm.',
	    evening: 'på kvällen',
	    night: 'på natten'
	  },
	  wide: {
	    am: 'fm',
	    pm: 'em',
	    midnight: 'midnatt',
	    noon: 'middag',
	    morning: 'på morgonen',
	    afternoon: 'på eftermiddagen',
	    evening: 'på kvällen',
	    night: 'på natten'
	  }
	};
	
	function ordinalNumber(dirtyNumber) {
	  var number = Number(dirtyNumber);
	  var rem100 = number % 100;
	
	  if (rem100 > 20 || rem100 < 10) {
	    switch (rem100 % 10) {
	      case 1:
	      case 2:
	        return number + ':a';
	    }
	  }
	
	  return number + ':e';
	}
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingDayPeriodValues,
	    defaultFormattingWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1441 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(15));
	
	var _index2 = _interopRequireDefault(__webpack_require__(14));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(\d+)(:a|:e)?/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^(f\.? ?Kr\.?|f\.? ?v\.? ?t\.?|e\.? ?Kr\.?|v\.? ?t\.?)/i,
	  abbreviated: /^(f\.? ?Kr\.?|f\.? ?v\.? ?t\.?|e\.? ?Kr\.?|v\.? ?t\.?)/i,
	  wide: /^(före Kristus|före vår tid|efter Kristus|vår tid)/i
	};
	var parseEraPatterns = {
	  any: [/^f/i, /^[ev]/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^q[1234]/i,
	  wide: /^[1234](:a|:e)? kvartalet/i
	};
	var parseQuarterPatterns = {
	  any: [/1/i, /2/i, /3/i, /4/i]
	};
	var matchMonthPatterns = {
	  narrow: /^[jfmasond]/i,
	  abbreviated: /^(jan|feb|mar|apr|maj|jun|jul|aug|sep|okt|nov|dec)\.?/i,
	  wide: /^(januari|februari|mars|april|maj|juni|juli|augusti|september|oktober|november|december)/i
	};
	var parseMonthPatterns = {
	  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
	  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^maj/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
	};
	var matchDayPatterns = {
	  narrow: /^[smtofl]/i,
	  short: /^(sö|må|ti|on|to|fr|lö)/i,
	  abbreviated: /^(sön|mån|tis|ons|tors|fre|lör)/i,
	  wide: /^(söndag|måndag|tisdag|onsdag|torsdag|fredag|lördag)/i
	};
	var parseDayPatterns = {
	  any: [/^s/i, /^m/i, /^ti/i, /^o/i, /^to/i, /^f/i, /^l/i]
	};
	var matchDayPeriodPatterns = {
	  any: /^([fe]\.?\s?m\.?|midn(att)?|midd(ag)?|(på) (morgonen|eftermiddagen|kvällen|natten))/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^f/i,
	    pm: /^e/i,
	    midnight: /^midn/i,
	    noon: /^midd/i,
	    morning: /morgon/i,
	    afternoon: /eftermiddag/i,
	    evening: /kväll/i,
	    night: /natt/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index2.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index2.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index2.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index2.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index2.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1442 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1437));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1438));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1439));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1440));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1441));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Swedish locale.
	 * @language Swedish
	 * @iso-639-2 swe
	 * @author Johannes Ulén [@ejulen]{@link https://github.com/ejulen}
	 * @author Alexander Nanberg [@alexandernanberg]{@link https://github.com/alexandernanberg}
	 * @author Henrik Andersson [@limelights]{@link https://github.com/limelights}
	 */
	var locale = {
	  code: 'sv',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 1
	    /* Monday */
	    ,
	    firstWeekContainsDate: 4
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1443 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistance;
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    one: {
	      default: 'ஒரு வினாடிக்கு குறைவாக',
	      in: 'ஒரு வினாடிக்குள்',
	      ago: 'ஒரு வினாடிக்கு முன்பு'
	    },
	    other: {
	      default: '{{count}} வினாடிகளுக்கு குறைவாக',
	      in: '{{count}} வினாடிகளுக்குள்',
	      ago: '{{count}} வினாடிகளுக்கு முன்பு'
	    }
	  },
	  xSeconds: {
	    one: {
	      default: '1 வினாடி',
	      in: '1 வினாடியில்',
	      ago: '1 வினாடி முன்பு'
	    },
	    other: {
	      default: '{{count}} விநாடிகள்',
	      in: '{{count}} வினாடிகளில்',
	      ago: '{{count}} விநாடிகளுக்கு முன்பு'
	    }
	  },
	  halfAMinute: {
	    default: 'அரை நிமிடம்',
	    in: 'அரை நிமிடத்தில்',
	    ago: 'அரை நிமிடம் முன்பு'
	  },
	  lessThanXMinutes: {
	    one: {
	      default: 'ஒரு நிமிடத்திற்கும் குறைவாக',
	      in: 'ஒரு நிமிடத்திற்குள்',
	      ago: 'ஒரு நிமிடத்திற்கு முன்பு'
	    },
	    other: {
	      default: '{{count}} நிமிடங்களுக்கும் குறைவாக',
	      in: '{{count}} நிமிடங்களுக்குள்',
	      ago: '{{count}} நிமிடங்களுக்கு முன்பு'
	    }
	  },
	  xMinutes: {
	    one: {
	      default: '1 நிமிடம்',
	      in: '1 நிமிடத்தில்',
	      ago: '1 நிமிடம் முன்பு'
	    },
	    other: {
	      default: '{{count}} நிமிடங்கள்',
	      in: '{{count}} நிமிடங்களில்',
	      ago: '{{count}} நிமிடங்களுக்கு முன்பு'
	    }
	  },
	  aboutXHours: {
	    one: {
	      default: 'சுமார் 1 மணி நேரம்',
	      in: 'சுமார் 1 மணி நேரத்தில்',
	      ago: 'சுமார் 1 மணி நேரத்திற்கு முன்பு'
	    },
	    other: {
	      default: 'சுமார் {{count}} மணி நேரம்',
	      in: 'சுமார் {{count}} மணி நேரத்திற்கு முன்பு',
	      ago: 'சுமார் {{count}} மணி நேரத்தில்'
	    }
	  },
	  xHours: {
	    one: {
	      default: '1 மணி நேரம்',
	      in: '1 மணி நேரத்தில்',
	      ago: '1 மணி நேரத்திற்கு முன்பு'
	    },
	    other: {
	      default: '{{count}} மணி நேரம்',
	      in: '{{count}} மணி நேரத்தில்',
	      ago: '{{count}} மணி நேரத்திற்கு முன்பு'
	    }
	  },
	  xDays: {
	    one: {
	      default: '1 நாள்',
	      in: '1 நாளில்',
	      ago: '1 நாள் முன்பு'
	    },
	    other: {
	      default: '{{count}} நாட்கள்',
	      in: '{{count}} நாட்களில்',
	      ago: '{{count}} நாட்களுக்கு முன்பு'
	    }
	  },
	  aboutXWeeks: {
	    one: {
	      default: 'சுமார் 1 வாரம்',
	      in: 'சுமார் 1 வாரத்தில்',
	      ago: 'சுமார் 1 வாரம் முன்பு'
	    },
	    other: {
	      default: 'சுமார் {{count}} வாரங்கள்',
	      in: 'சுமார் {{count}} வாரங்களில்',
	      ago: 'சுமார் {{count}} வாரங்களுக்கு முன்பு'
	    }
	  },
	  xWeeks: {
	    one: {
	      default: '1 வாரம்',
	      in: '1 வாரத்தில்',
	      ago: '1 வாரம் முன்பு'
	    },
	    other: {
	      default: '{{count}} வாரங்கள்',
	      in: '{{count}} வாரங்களில்',
	      ago: '{{count}} வாரங்களுக்கு முன்பு'
	    }
	  },
	  aboutXMonths: {
	    one: {
	      default: 'சுமார் 1 மாதம்',
	      in: 'சுமார் 1 மாதத்தில்',
	      ago: 'சுமார் 1 மாதத்திற்கு முன்பு'
	    },
	    other: {
	      default: 'சுமார் {{count}} மாதங்கள்',
	      in: 'சுமார் {{count}} மாதங்களில்',
	      ago: 'சுமார் {{count}} மாதங்களுக்கு முன்பு'
	    }
	  },
	  xMonths: {
	    one: {
	      default: '1 மாதம்',
	      in: '1 மாதத்தில்',
	      ago: '1 மாதம் முன்பு'
	    },
	    other: {
	      default: '{{count}} மாதங்கள்',
	      in: '{{count}} மாதங்களில்',
	      ago: '{{count}} மாதங்களுக்கு முன்பு'
	    }
	  },
	  aboutXYears: {
	    one: {
	      default: 'சுமார் 1 வருடம்',
	      in: 'சுமார் 1 ஆண்டில்',
	      ago: 'சுமார் 1 வருடம் முன்பு'
	    },
	    other: {
	      default: 'சுமார் {{count}} ஆண்டுகள்',
	      in: 'சுமார் {{count}} ஆண்டுகளில்',
	      ago: 'சுமார் {{count}} ஆண்டுகளுக்கு முன்பு'
	    }
	  },
	  xYears: {
	    one: {
	      default: '1 வருடம்',
	      in: '1 ஆண்டில்',
	      ago: '1 வருடம் முன்பு'
	    },
	    other: {
	      default: '{{count}} ஆண்டுகள்',
	      in: '{{count}} ஆண்டுகளில்',
	      ago: '{{count}} ஆண்டுகளுக்கு முன்பு'
	    }
	  },
	  overXYears: {
	    one: {
	      default: '1 வருடத்திற்கு மேல்',
	      in: '1 வருடத்திற்கும் மேலாக',
	      ago: '1 வருடம் முன்பு'
	    },
	    other: {
	      default: '{{count}} ஆண்டுகளுக்கும் மேலாக',
	      in: '{{count}} ஆண்டுகளில்',
	      ago: '{{count}} ஆண்டுகளுக்கு முன்பு'
	    }
	  },
	  almostXYears: {
	    one: {
	      default: 'கிட்டத்தட்ட 1 வருடம்',
	      in: 'கிட்டத்தட்ட 1 ஆண்டில்',
	      ago: 'கிட்டத்தட்ட 1 வருடம் முன்பு'
	    },
	    other: {
	      default: 'கிட்டத்தட்ட {{count}} ஆண்டுகள்',
	      in: 'கிட்டத்தட்ட {{count}} ஆண்டுகளில்',
	      ago: 'கிட்டத்தட்ட {{count}} ஆண்டுகளுக்கு முன்பு'
	    }
	  }
	};
	
	function getFormatDistanceLocaleWithSuffix(resultObj, options) {
	  if (options.addSuffix) {
	    if (options.comparison > 0) {
	      return resultObj.in;
	    } else {
	      return resultObj.ago;
	    }
	  }
	
	  return resultObj.default;
	}
	
	function formatDistance(token, count) {
	  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	  var result;
	
	  if (formatDistanceLocale[token].default) {
	    result = getFormatDistanceLocaleWithSuffix(formatDistanceLocale[token], options);
	  } else if (count === 1) {
	    result = getFormatDistanceLocaleWithSuffix(formatDistanceLocale[token].one, options);
	  } else {
	    result = getFormatDistanceLocaleWithSuffix(formatDistanceLocale[token].other, options);
	  }
	
	  return result.replace('{{count}}', count);
	}
	
	module.exports = exports.default;

/***/ },
/* 1444 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Ref: https://www.unicode.org/cldr/charts/32/summary/ta.html
	// CLDR #1846 - #1849
	var dateFormats = {
	  full: 'EEEE, d MMMM, y',
	  long: 'd MMMM, y',
	  medium: 'd MMM, y',
	  short: 'd/M/yy'
	}; // CLDR #1850 - #1853
	
	var timeFormats = {
	  full: 'a h:mm:ss zzzz',
	  long: 'a h:mm:ss z',
	  medium: 'a h:mm:ss',
	  short: 'a h:mm'
	};
	var dateTimeFormats = {
	  full: '{{date}} {{time}}',
	  long: '{{date}} {{time}}',
	  medium: '{{date}}, {{time}}',
	  short: '{{date}}, {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1445 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRelative;
	var formatRelativeLocale = {
	  lastWeek: "'கடந்த' eeee p 'மணிக்கு'",
	  yesterday: "'நேற்று ' p 'மணிக்கு'",
	  today: "'இன்று ' p 'மணிக்கு'",
	  tomorrow: "'நாளை ' p 'மணிக்கு'",
	  nextWeek: "eeee p 'மணிக்கு'",
	  other: 'P'
	};
	
	function formatRelative(token, _date, _baseDate, _options) {
	  return formatRelativeLocale[token];
	}
	
	module.exports = exports.default;

/***/ },
/* 1446 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Ref: https://www.unicode.org/cldr/charts/32/summary/ta.html
	var eraValues = {
	  narrow: ['கி.மு.', 'கி.பி.'],
	  abbreviated: ['கி.மு.', 'கி.பி.'],
	  // CLDR #1624, #1626
	  wide: ['கிறிஸ்துவுக்கு முன்', 'அன்னோ டோமினி'] // CLDR #1620, #1622
	
	};
	var quarterValues = {
	  // CLDR #1644 - #1647
	  narrow: ['1', '2', '3', '4'],
	  // CLDR #1636 - #1639
	  abbreviated: ['காலா.1', 'காலா.2', 'காலா.3', 'காலா.4'],
	  // CLDR #1628 - #1631
	  wide: ['ஒன்றாம் காலாண்டு', 'இரண்டாம் காலாண்டு', 'மூன்றாம் காலாண்டு', 'நான்காம் காலாண்டு']
	};
	var monthValues = {
	  // CLDR #700 - #711
	  narrow: ['ஜ', 'பி', 'மா', 'ஏ', 'மே', 'ஜூ', 'ஜூ', 'ஆ', 'செ', 'அ', 'ந', 'டி'],
	  // CLDR #1676 - #1687
	  abbreviated: ['ஜன.', 'பிப்.', 'மார்.', 'ஏப்.', 'மே', 'ஜூன்', 'ஜூலை', 'ஆக.', 'செப்.', 'அக்.', 'நவ.', 'டிச.'],
	  // CLDR #1652 - #1663
	  wide: ['ஜனவரி', // January
	  'பிப்ரவரி', // February
	  'மார்ச்', // March
	  'ஏப்ரல்', // April
	  'மே', // May
	  'ஜூன்', // June
	  'ஜூலை', // July
	  'ஆகஸ்ட்', // August
	  'செப்டம்பர்', // September
	  'அக்டோபர்', // October
	  'நவம்பர்', // November
	  'டிசம்பர்' // December
	  ]
	};
	var dayValues = {
	  // CLDR #1766 - #1772
	  narrow: ['ஞா', 'தி', 'செ', 'பு', 'வி', 'வெ', 'ச'],
	  // CLDR #1752 - #1758
	  short: ['ஞா', 'தி', 'செ', 'பு', 'வி', 'வெ', 'ச'],
	  // CLDR #1738 - #1744
	  abbreviated: ['ஞாயி.', 'திங்.', 'செவ்.', 'புத.', 'வியா.', 'வெள்.', 'சனி'],
	  // CLDR #1724 - #1730
	  wide: ['ஞாயிறு', // Sunday
	  'திங்கள்', // Monday
	  'செவ்வாய்', // Tuesday
	  'புதன்', // Wednesday
	  'வியாழன்', // Thursday
	  'வெள்ளி', // Friday
	  'சனி' // Saturday
	  ]
	}; // CLDR #1780 - #1845
	
	var dayPeriodValues = {
	  narrow: {
	    am: 'மு.ப',
	    pm: 'பி.ப',
	    midnight: 'நள்.',
	    noon: 'நண்.',
	    morning: 'கா.',
	    afternoon: 'மதி.',
	    evening: 'மா.',
	    night: 'இர.'
	  },
	  abbreviated: {
	    am: 'முற்பகல்',
	    pm: 'பிற்பகல்',
	    midnight: 'நள்ளிரவு',
	    noon: 'நண்பகல்',
	    morning: 'காலை',
	    afternoon: 'மதியம்',
	    evening: 'மாலை',
	    night: 'இரவு'
	  },
	  wide: {
	    am: 'முற்பகல்',
	    pm: 'பிற்பகல்',
	    midnight: 'நள்ளிரவு',
	    noon: 'நண்பகல்',
	    morning: 'காலை',
	    afternoon: 'மதியம்',
	    evening: 'மாலை',
	    night: 'இரவு'
	  }
	}; // CLDR #1780 - #1845
	
	var formattingDayPeriodValues = {
	  narrow: {
	    am: 'மு.ப',
	    pm: 'பி.ப',
	    midnight: 'நள்.',
	    noon: 'நண்.',
	    morning: 'கா.',
	    afternoon: 'மதி.',
	    evening: 'மா.',
	    night: 'இர.'
	  },
	  abbreviated: {
	    am: 'முற்பகல்',
	    pm: 'பிற்பகல்',
	    midnight: 'நள்ளிரவு',
	    noon: 'நண்பகல்',
	    morning: 'காலை',
	    afternoon: 'மதியம்',
	    evening: 'மாலை',
	    night: 'இரவு'
	  },
	  wide: {
	    am: 'முற்பகல்',
	    pm: 'பிற்பகல்',
	    midnight: 'நள்ளிரவு',
	    noon: 'நண்பகல்',
	    morning: 'காலை',
	    afternoon: 'மதியம்',
	    evening: 'மாலை',
	    night: 'இரவு'
	  }
	};
	
	function ordinalNumber(dirtyNumber, _dirtyOptions) {
	  var number = Number(dirtyNumber); // If ordinal numbers depend on context, for example,
	  // if they are different for different grammatical genders,
	  // use `options.unit`:
	  //
	  //   var options = dirtyOptions || {}
	  //   var unit = String(options.unit)
	  //
	  // where `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
	  // 'day', 'hour', 'minute', 'second'
	  // var rem100 = number % 100
	  // if (rem100 > 20 || rem100 < 10) {
	  //   switch (rem100 % 10) {
	  //     case 1:
	  //       return number + 'st'
	  //     case 2:
	  //       return number + 'nd'
	  //     case 3:
	  //       return number + 'rd'
	  //   }
	  // }
	  // return number + 'th'
	
	  return number;
	}
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingDayPeriodValues,
	    defaultFormattingWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1447 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(15));
	
	var _index2 = _interopRequireDefault(__webpack_require__(14));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(\d+)(வது)?/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^(கி.மு.|கி.பி.)/i,
	  abbreviated: /^(கி\.?\s?மு\.?|கி\.?\s?பி\.?)/,
	  wide: /^(கிறிஸ்துவுக்கு\sமுன்|அன்னோ\sடோமினி)/i
	};
	var parseEraPatterns = {
	  any: [/கி\.?\s?மு\.?/, /கி\.?\s?பி\.?/]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^காலா.[1234]/i,
	  wide: /^(ஒன்றாம்|இரண்டாம்|மூன்றாம்|நான்காம்) காலாண்டு/i
	};
	var parseQuarterPatterns = {
	  narrow: [/1/i, /2/i, /3/i, /4/i],
	  any: [/(1|காலா.1|ஒன்றாம்)/i, /(2|காலா.2|இரண்டாம்)/i, /(3|காலா.3|மூன்றாம்)/i, /(4|காலா.4|நான்காம்)/i]
	};
	var matchMonthPatterns = {
	  narrow: /^(ஜ|பி|மா|ஏ|மே|ஜூ|ஆ|செ|அ|ந|டி)$/i,
	  abbreviated: /^(ஜன.|பிப்.|மார்.|ஏப்.|மே|ஜூன்|ஜூலை|ஆக.|செப்.|அக்.|நவ.|டிச.)/i,
	  wide: /^(ஜனவரி|பிப்ரவரி|மார்ச்|ஏப்ரல்|மே|ஜூன்|ஜூலை|ஆகஸ்ட்|செப்டம்பர்|அக்டோபர்|நவம்பர்|டிசம்பர்)/i
	};
	var parseMonthPatterns = {
	  narrow: [/^ஜ$/i, /^பி/i, /^மா/i, /^ஏ/i, /^மே/i, /^ஜூ/i, /^ஜூ/i, /^ஆ/i, /^செ/i, /^அ/i, /^ந/i, /^டி/i],
	  any: [/^ஜன/i, /^பி/i, /^மா/i, /^ஏ/i, /^மே/i, /^ஜூன்/i, /^ஜூலை/i, /^ஆ/i, /^செ/i, /^அ/i, /^ந/i, /^டி/i]
	};
	var matchDayPatterns = {
	  narrow: /^(ஞா|தி|செ|பு|வி|வெ|ச)/i,
	  short: /^(ஞா|தி|செ|பு|வி|வெ|ச)/i,
	  abbreviated: /^(ஞாயி.|திங்.|செவ்.|புத.|வியா.|வெள்.|சனி)/i,
	  wide: /^(ஞாயிறு|திங்கள்|செவ்வாய்|புதன்|வியாழன்|வெள்ளி|சனி)/i
	};
	var parseDayPatterns = {
	  narrow: [/^ஞா/i, /^தி/i, /^செ/i, /^பு/i, /^வி/i, /^வெ/i, /^ச/i],
	  any: [/^ஞா/i, /^தி/i, /^செ/i, /^பு/i, /^வி/i, /^வெ/i, /^ச/i]
	};
	var matchDayPeriodPatterns = {
	  narrow: /^(மு.ப|பி.ப|நள்|நண்|காலை|மதியம்|மாலை|இரவு)/i,
	  any: /^(மு.ப|பி.ப|முற்பகல்|பிற்பகல்|நள்ளிரவு|நண்பகல்|காலை|மதியம்|மாலை|இரவு)/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^மு/i,
	    pm: /^பி/i,
	    midnight: /^நள்/i,
	    noon: /^நண்/i,
	    morning: /காலை/i,
	    afternoon: /மதியம்/i,
	    evening: /மாலை/i,
	    night: /இரவு/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index2.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index2.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index2.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index2.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index2.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1448 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1443));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1444));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1445));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1446));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1447));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Tamil locale (India).
	 * @language Tamil
	 * @iso-639-2 tam
	 * @author Sibiraj [@sibiraj-s]{@link https://github.com/sibiraj-s}
	 */
	var locale = {
	  code: 'ta',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 1
	    /* Monday */
	    ,
	    firstWeekContainsDate: 4
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1449 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistance;
	// Source: https://www.unicode.org/cldr/charts/32/summary/te.html
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    standalone: {
	      one: 'సెకను కన్నా తక్కువ',
	      other: '{{count}} సెకన్ల కన్నా తక్కువ'
	    },
	    withPreposition: {
	      one: 'సెకను',
	      other: '{{count}} సెకన్ల'
	    }
	  },
	  xSeconds: {
	    standalone: {
	      one: 'ఒక సెకను',
	      // CLDR #1314
	      other: '{{count}} సెకన్ల'
	    },
	    withPreposition: {
	      one: 'ఒక సెకను',
	      other: '{{count}} సెకన్ల'
	    }
	  },
	  halfAMinute: {
	    standalone: 'అర నిమిషం',
	    withPreposition: 'అర నిమిషం'
	  },
	  lessThanXMinutes: {
	    standalone: {
	      one: 'ఒక నిమిషం కన్నా తక్కువ',
	      other: '{{count}} నిమిషాల కన్నా తక్కువ'
	    },
	    withPreposition: {
	      one: 'ఒక నిమిషం',
	      other: '{{count}} నిమిషాల'
	    }
	  },
	  xMinutes: {
	    standalone: {
	      one: 'ఒక నిమిషం',
	      // CLDR #1311
	      other: '{{count}} నిమిషాలు'
	    },
	    withPreposition: {
	      one: 'ఒక నిమిషం',
	      // CLDR #1311
	      other: '{{count}} నిమిషాల'
	    }
	  },
	  aboutXHours: {
	    standalone: {
	      one: 'సుమారు ఒక గంట',
	      other: 'సుమారు {{count}} గంటలు'
	    },
	    withPreposition: {
	      one: 'సుమారు ఒక గంట',
	      other: 'సుమారు {{count}} గంటల'
	    }
	  },
	  xHours: {
	    standalone: {
	      one: 'ఒక గంట',
	      // CLDR #1308
	      other: '{{count}} గంటలు'
	    },
	    withPreposition: {
	      one: 'ఒక గంట',
	      other: '{{count}} గంటల'
	    }
	  },
	  xDays: {
	    standalone: {
	      one: 'ఒక రోజు',
	      // CLDR #1292
	      other: '{{count}} రోజులు'
	    },
	    withPreposition: {
	      one: 'ఒక రోజు',
	      other: '{{count}} రోజుల'
	    }
	  },
	  aboutXWeeks: {
	    standalone: {
	      one: 'సుమారు ఒక వారం',
	      other: 'సుమారు {{count}} వారాలు'
	    },
	    withPreposition: {
	      one: 'సుమారు ఒక వారం',
	      other: 'సుమారు {{count}} వారాలల'
	    }
	  },
	  xWeeks: {
	    standalone: {
	      one: 'ఒక వారం',
	      other: '{{count}} వారాలు'
	    },
	    withPreposition: {
	      one: 'ఒక వారం',
	      other: '{{count}} వారాలల'
	    }
	  },
	  aboutXMonths: {
	    standalone: {
	      one: 'సుమారు ఒక నెల',
	      other: 'సుమారు {{count}} నెలలు'
	    },
	    withPreposition: {
	      one: 'సుమారు ఒక నెల',
	      other: 'సుమారు {{count}} నెలల'
	    }
	  },
	  xMonths: {
	    standalone: {
	      one: 'ఒక నెల',
	      // CLDR #1281
	      other: '{{count}} నెలలు'
	    },
	    withPreposition: {
	      one: 'ఒక నెల',
	      other: '{{count}} నెలల'
	    }
	  },
	  aboutXYears: {
	    standalone: {
	      one: 'సుమారు ఒక సంవత్సరం',
	      other: 'సుమారు {{count}} సంవత్సరాలు'
	    },
	    withPreposition: {
	      one: 'సుమారు ఒక సంవత్సరం',
	      other: 'సుమారు {{count}} సంవత్సరాల'
	    }
	  },
	  xYears: {
	    standalone: {
	      one: 'ఒక సంవత్సరం',
	      // CLDR #1275
	      other: '{{count}} సంవత్సరాలు'
	    },
	    withPreposition: {
	      one: 'ఒక సంవత్సరం',
	      other: '{{count}} సంవత్సరాల'
	    }
	  },
	  overXYears: {
	    standalone: {
	      one: 'ఒక సంవత్సరం పైగా',
	      other: '{{count}} సంవత్సరాలకు పైగా'
	    },
	    withPreposition: {
	      one: 'ఒక సంవత్సరం',
	      other: '{{count}} సంవత్సరాల'
	    }
	  },
	  almostXYears: {
	    standalone: {
	      one: 'దాదాపు ఒక సంవత్సరం',
	      other: 'దాదాపు {{count}} సంవత్సరాలు'
	    },
	    withPreposition: {
	      one: 'దాదాపు ఒక సంవత్సరం',
	      other: 'దాదాపు {{count}} సంవత్సరాల'
	    }
	  }
	};
	
	function formatDistance(token, count, options) {
	  options = options || {};
	  var usageGroup = options.addSuffix ? formatDistanceLocale[token].withPreposition : formatDistanceLocale[token].standalone;
	  var result;
	
	  if (typeof usageGroup === 'string') {
	    result = usageGroup;
	  } else if (count === 1) {
	    result = usageGroup.one;
	  } else {
	    result = usageGroup.other.replace('{{count}}', count);
	  }
	
	  if (options.addSuffix) {
	    if (options.comparison > 0) {
	      return result + 'లో';
	    } else {
	      return result + ' క్రితం';
	    }
	  }
	
	  return result;
	}
	
	module.exports = exports.default;

/***/ },
/* 1450 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Source: https://www.unicode.org/cldr/charts/32/summary/te.html
	// CLDR #1807 - #1811
	var dateFormats = {
	  full: 'd, MMMM y, EEEE',
	  long: 'd MMMM, y',
	  medium: 'd MMM, y',
	  short: 'dd-MM-yy'
	}; // CLDR #1807 - #1811
	
	var timeFormats = {
	  full: 'h:mm:ss a zzzz',
	  long: 'h:mm:ss a z',
	  medium: 'h:mm:ss a',
	  short: 'h:mm a'
	}; // CLDR #1815 - #1818
	
	var dateTimeFormats = {
	  full: "{{date}} {{time}}'కి'",
	  long: "{{date}} {{time}}'కి'",
	  medium: '{{date}} {{time}}',
	  short: '{{date}} {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1451 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRelative;
	// Source: https://www.unicode.org/cldr/charts/32/summary/te.html
	var formatRelativeLocale = {
	  lastWeek: "'గత' eeee p",
	  // CLDR #1384
	  yesterday: "'నిన్న' p",
	  // CLDR #1393
	  today: "'ఈ రోజు' p",
	  // CLDR #1394
	  tomorrow: "'రేపు' p",
	  // CLDR #1395
	  nextWeek: "'తదుపరి' eeee p",
	  // CLDR #1386
	  other: 'P'
	};
	
	function formatRelative(token, _date, _baseDate, _options) {
	  return formatRelativeLocale[token];
	}
	
	module.exports = exports.default;

/***/ },
/* 1452 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Source: https://www.unicode.org/cldr/charts/32/summary/te.html
	// Source: https://dsal.uchicago.edu/dictionaries/brown/
	// CLDR #1605 - #1608
	var eraValues = {
	  narrow: ['క్రీ.పూ.', 'క్రీ.శ.'],
	  abbreviated: ['క్రీ.పూ.', 'క్రీ.శ.'],
	  wide: ['క్రీస్తు పూర్వం', 'క్రీస్తుశకం']
	}; // CLDR #1613 - #1628
	
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['త్రై1', 'త్రై2', 'త్రై3', 'త్రై4'],
	  wide: ['1వ త్రైమాసికం', '2వ త్రైమాసికం', '3వ త్రైమాసికం', '4వ త్రైమాసికం']
	}; // CLDR #1637 - #1708
	
	var monthValues = {
	  narrow: ['జ', 'ఫి', 'మా', 'ఏ', 'మే', 'జూ', 'జు', 'ఆ', 'సె', 'అ', 'న', 'డి'],
	  abbreviated: ['జన', 'ఫిబ్ర', 'మార్చి', 'ఏప్రి', 'మే', 'జూన్', 'జులై', 'ఆగ', 'సెప్టెం', 'అక్టో', 'నవం', 'డిసెం'],
	  wide: ['జనవరి', 'ఫిబ్రవరి', 'మార్చి', 'ఏప్రిల్', 'మే', 'జూన్', 'జులై', 'ఆగస్టు', 'సెప్టెంబర్', 'అక్టోబర్', 'నవంబర్', 'డిసెంబర్']
	}; // CLDR #1709 - #1764
	
	var dayValues = {
	  narrow: ['ఆ', 'సో', 'మ', 'బు', 'గు', 'శు', 'శ'],
	  short: ['ఆది', 'సోమ', 'మంగళ', 'బుధ', 'గురు', 'శుక్ర', 'శని'],
	  abbreviated: ['ఆది', 'సోమ', 'మంగళ', 'బుధ', 'గురు', 'శుక్ర', 'శని'],
	  wide: ['ఆదివారం', 'సోమవారం', 'మంగళవారం', 'బుధవారం', 'గురువారం', 'శుక్రవారం', 'శనివారం']
	}; // CLDR #1767 - #1806
	
	var dayPeriodValues = {
	  narrow: {
	    am: 'పూర్వాహ్నం',
	    pm: 'అపరాహ్నం',
	    midnight: 'అర్ధరాత్రి',
	    noon: 'మిట్టమధ్యాహ్నం',
	    morning: 'ఉదయం',
	    afternoon: 'మధ్యాహ్నం',
	    evening: 'సాయంత్రం',
	    night: 'రాత్రి'
	  },
	  abbreviated: {
	    am: 'పూర్వాహ్నం',
	    pm: 'అపరాహ్నం',
	    midnight: 'అర్ధరాత్రి',
	    noon: 'మిట్టమధ్యాహ్నం',
	    morning: 'ఉదయం',
	    afternoon: 'మధ్యాహ్నం',
	    evening: 'సాయంత్రం',
	    night: 'రాత్రి'
	  },
	  wide: {
	    am: 'పూర్వాహ్నం',
	    pm: 'అపరాహ్నం',
	    midnight: 'అర్ధరాత్రి',
	    noon: 'మిట్టమధ్యాహ్నం',
	    morning: 'ఉదయం',
	    afternoon: 'మధ్యాహ్నం',
	    evening: 'సాయంత్రం',
	    night: 'రాత్రి'
	  }
	};
	var formattingDayPeriodValues = {
	  narrow: {
	    am: 'పూర్వాహ్నం',
	    pm: 'అపరాహ్నం',
	    midnight: 'అర్ధరాత్రి',
	    noon: 'మిట్టమధ్యాహ్నం',
	    morning: 'ఉదయం',
	    afternoon: 'మధ్యాహ్నం',
	    evening: 'సాయంత్రం',
	    night: 'రాత్రి'
	  },
	  abbreviated: {
	    am: 'పూర్వాహ్నం',
	    pm: 'అపరాహ్నం',
	    midnight: 'అర్ధరాత్రి',
	    noon: 'మిట్టమధ్యాహ్నం',
	    morning: 'ఉదయం',
	    afternoon: 'మధ్యాహ్నం',
	    evening: 'సాయంత్రం',
	    night: 'రాత్రి'
	  },
	  wide: {
	    am: 'పూర్వాహ్నం',
	    pm: 'అపరాహ్నం',
	    midnight: 'అర్ధరాత్రి',
	    noon: 'మిట్టమధ్యాహ్నం',
	    morning: 'ఉదయం',
	    afternoon: 'మధ్యాహ్నం',
	    evening: 'సాయంత్రం',
	    night: 'రాత్రి'
	  }
	};
	
	function ordinalNumber(dirtyNumber, _dirtyOptions) {
	  var number = Number(dirtyNumber);
	  return number + 'వ';
	}
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingDayPeriodValues,
	    defaultFormattingWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1453 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(15));
	
	var _index2 = _interopRequireDefault(__webpack_require__(14));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(\d+)(వ)?/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^(క్రీ\.పూ\.|క్రీ\.శ\.)/i,
	  abbreviated: /^(క్రీ\.?\s?పూ\.?|ప్ర\.?\s?శ\.?\s?పూ\.?|క్రీ\.?\s?శ\.?|సా\.?\s?శ\.?)/i,
	  wide: /^(క్రీస్తు పూర్వం|ప్రస్తుత శకానికి పూర్వం|క్రీస్తు శకం|ప్రస్తుత శకం)/i
	};
	var parseEraPatterns = {
	  any: [/^(పూ|శ)/i, /^సా/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^త్రై[1234]/i,
	  wide: /^[1234](వ)? త్రైమాసికం/i
	};
	var parseQuarterPatterns = {
	  any: [/1/i, /2/i, /3/i, /4/i]
	};
	var matchMonthPatterns = {
	  narrow: /^(జూ|జు|జ|ఫి|మా|ఏ|మే|ఆ|సె|అ|న|డి)/i,
	  abbreviated: /^(జన|ఫిబ్ర|మార్చి|ఏప్రి|మే|జూన్|జులై|ఆగ|సెప్|అక్టో|నవ|డిసె)/i,
	  wide: /^(జనవరి|ఫిబ్రవరి|మార్చి|ఏప్రిల్|మే|జూన్|జులై|ఆగస్టు|సెప్టెంబర్|అక్టోబర్|నవంబర్|డిసెంబర్)/i
	};
	var parseMonthPatterns = {
	  narrow: [/^జ/i, /^ఫి/i, /^మా/i, /^ఏ/i, /^మే/i, /^జూ/i, /^జు/i, /^ఆ/i, /^సె/i, /^అ/i, /^న/i, /^డి/i],
	  any: [/^జన/i, /^ఫి/i, /^మా/i, /^ఏ/i, /^మే/i, /^జూన్/i, /^జులై/i, /^ఆగ/i, /^సె/i, /^అ/i, /^న/i, /^డి/i]
	};
	var matchDayPatterns = {
	  narrow: /^(ఆ|సో|మ|బు|గు|శు|శ)/i,
	  short: /^(ఆది|సోమ|మం|బుధ|గురు|శుక్ర|శని)/i,
	  abbreviated: /^(ఆది|సోమ|మం|బుధ|గురు|శుక్ర|శని)/i,
	  wide: /^(ఆదివారం|సోమవారం|మంగళవారం|బుధవారం|గురువారం|శుక్రవారం|శనివారం)/i
	};
	var parseDayPatterns = {
	  narrow: [/^ఆ/i, /^సో/i, /^మ/i, /^బు/i, /^గు/i, /^శు/i, /^శ/i],
	  any: [/^ఆది/i, /^సోమ/i, /^మం/i, /^బుధ/i, /^గురు/i, /^శుక్ర/i, /^శని/i]
	};
	var matchDayPeriodPatterns = {
	  narrow: /^(పూర్వాహ్నం|అపరాహ్నం|అర్ధరాత్రి|మిట్టమధ్యాహ్నం|ఉదయం|మధ్యాహ్నం|సాయంత్రం|రాత్రి)/i,
	  any: /^(పూర్వాహ్నం|అపరాహ్నం|అర్ధరాత్రి|మిట్టమధ్యాహ్నం|ఉదయం|మధ్యాహ్నం|సాయంత్రం|రాత్రి)/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^పూర్వాహ్నం/i,
	    pm: /^అపరాహ్నం/i,
	    midnight: /^అర్ధ/i,
	    noon: /^మిట్ట/i,
	    morning: /ఉదయం/i,
	    afternoon: /మధ్యాహ్నం/i,
	    evening: /సాయంత్రం/i,
	    night: /రాత్రి/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index2.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index2.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index2.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index2.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index2.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1454 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1449));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1450));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1451));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1452));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1453));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Telugu locale
	 * @language Telugu
	 * @iso-639-2 tel
	 * @author Kranthi Lakum [@kranthilakum]{@link https://github.com/kranthilakum}
	 */
	var locale = {
	  code: 'te',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 0
	    /* Sunday */
	    ,
	    firstWeekContainsDate: 1
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1455 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistance;
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    one: 'น้อยกว่า 1 วินาที',
	    other: 'น้อยกว่า {{count}} วินาที'
	  },
	  xSeconds: {
	    one: '1 วินาที',
	    other: '{{count}} วินาที'
	  },
	  halfAMinute: 'ครึ่งนาที',
	  lessThanXMinutes: {
	    one: 'น้อยกว่า 1 นาที',
	    other: 'น้อยกว่า {{count}} นาที'
	  },
	  xMinutes: {
	    one: '1 นาที',
	    other: '{{count}} นาที'
	  },
	  aboutXHours: {
	    one: 'ประมาณ 1 ชั่วโมง',
	    other: 'ประมาณ {{count}} ชั่วโมง'
	  },
	  xHours: {
	    one: '1 ชั่วโมง',
	    other: '{{count}} ชั่วโมง'
	  },
	  xDays: {
	    one: '1 วัน',
	    other: '{{count}} วัน'
	  },
	  aboutXWeeks: {
	    one: 'ประมาณ 1 สัปดาห์',
	    other: 'ประมาณ {{count}} สัปดาห์'
	  },
	  xWeeks: {
	    one: '1 สัปดาห์',
	    other: '{{count}} สัปดาห์'
	  },
	  aboutXMonths: {
	    one: 'ประมาณ 1 เดือน',
	    other: 'ประมาณ {{count}} เดือน'
	  },
	  xMonths: {
	    one: '1 เดือน',
	    other: '{{count}} เดือน'
	  },
	  aboutXYears: {
	    one: 'ประมาณ 1 ปี',
	    other: 'ประมาณ {{count}} ปี'
	  },
	  xYears: {
	    one: '1 ปี',
	    other: '{{count}} ปี'
	  },
	  overXYears: {
	    one: 'มากกว่า 1 ปี',
	    other: 'มากกว่า {{count}} ปี'
	  },
	  almostXYears: {
	    one: 'เกือบ 1 ปี',
	    other: 'เกือบ {{count}} ปี'
	  }
	};
	
	function formatDistance(token, count, options) {
	  options = options || {};
	  var result;
	
	  if (typeof formatDistanceLocale[token] === 'string') {
	    result = formatDistanceLocale[token];
	  } else if (count === 1) {
	    result = formatDistanceLocale[token].one;
	  } else {
	    result = formatDistanceLocale[token].other.replace('{{count}}', count);
	  }
	
	  if (options.addSuffix) {
	    if (options.comparison > 0) {
	      if (token === 'halfAMinute') {
	        return 'ใน' + result;
	      } else {
	        return 'ใน ' + result;
	      }
	    } else {
	      return result + 'ที่ผ่านมา';
	    }
	  }
	
	  return result;
	}
	
	module.exports = exports.default;

/***/ },
/* 1456 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: 'วันEEEEที่ do MMMM y',
	  long: 'do MMMM y',
	  medium: 'd MMM y',
	  short: 'dd/MM/yyyy'
	};
	var timeFormats = {
	  full: 'H:mm:ss น. zzzz',
	  long: 'H:mm:ss น. z',
	  medium: 'H:mm:ss น.',
	  short: 'H:mm น.'
	};
	var dateTimeFormats = {
	  full: "{{date}} 'เวลา' {{time}}",
	  long: "{{date}} 'เวลา' {{time}}",
	  medium: '{{date}}, {{time}}',
	  short: '{{date}}, {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'medium'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1457 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRelative;
	var formatRelativeLocale = {
	  lastWeek: "eeee'ที่แล้วเวลา' p",
	  yesterday: "'เมื่อวานนี้เวลา' p",
	  today: "'วันนี้เวลา' p",
	  tomorrow: "'พรุ่งนี้เวลา' p",
	  nextWeek: "eeee 'เวลา' p",
	  other: 'P'
	};
	
	function formatRelative(token, _date, _baseDate, _options) {
	  return formatRelativeLocale[token];
	}
	
	module.exports = exports.default;

/***/ },
/* 1458 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eraValues = {
	  narrow: ['B', 'คศ'],
	  abbreviated: ['BC', 'ค.ศ.'],
	  wide: ['ปีก่อนคริสตกาล', 'คริสต์ศักราช']
	};
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
	  wide: ['ไตรมาสแรก', 'ไตรมาสที่สอง', 'ไตรมาสที่สาม', 'ไตรมาสที่สี่']
	};
	var dayValues = {
	  narrow: ['อา.', 'จ.', 'อ.', 'พ.', 'พฤ.', 'ศ.', 'ส.'],
	  short: ['อา.', 'จ.', 'อ.', 'พ.', 'พฤ.', 'ศ.', 'ส.'],
	  abbreviated: ['อา.', 'จ.', 'อ.', 'พ.', 'พฤ.', 'ศ.', 'ส.'],
	  wide: ['อาทิตย์', 'จันทร์', 'อังคาร', 'พุธ', 'พฤหัสบดี', 'ศุกร์', 'เสาร์']
	};
	var monthValues = {
	  narrow: ['ม.ค.', 'ก.พ.', 'มี.ค.', 'เม.ย.', 'พ.ค.', 'มิ.ย.', 'ก.ค.', 'ส.ค.', 'ก.ย.', 'ต.ค.', 'พ.ย.', 'ธ.ค.'],
	  abbreviated: ['ม.ค.', 'ก.พ.', 'มี.ค.', 'เม.ย.', 'พ.ค.', 'มิ.ย.', 'ก.ค.', 'ส.ค.', 'ก.ย.', 'ต.ค.', 'พ.ย.', 'ธ.ค.'],
	  wide: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม']
	};
	var dayPeriodValues = {
	  narrow: {
	    am: 'ก่อนเที่ยง',
	    pm: 'หลังเที่ยง',
	    midnight: 'เที่ยงคืน',
	    noon: 'เที่ยง',
	    morning: 'เช้า',
	    afternoon: 'บ่าย',
	    evening: 'เย็น',
	    night: 'กลางคืน'
	  },
	  abbreviated: {
	    am: 'ก่อนเที่ยง',
	    pm: 'หลังเที่ยง',
	    midnight: 'เที่ยงคืน',
	    noon: 'เที่ยง',
	    morning: 'เช้า',
	    afternoon: 'บ่าย',
	    evening: 'เย็น',
	    night: 'กลางคืน'
	  },
	  wide: {
	    am: 'ก่อนเที่ยง',
	    pm: 'หลังเที่ยง',
	    midnight: 'เที่ยงคืน',
	    noon: 'เที่ยง',
	    morning: 'เช้า',
	    afternoon: 'บ่าย',
	    evening: 'เย็น',
	    night: 'กลางคืน'
	  }
	};
	var formattingDayPeriodValues = {
	  narrow: {
	    am: 'ก่อนเที่ยง',
	    pm: 'หลังเที่ยง',
	    midnight: 'เที่ยงคืน',
	    noon: 'เที่ยง',
	    morning: 'ตอนเช้า',
	    afternoon: 'ตอนกลางวัน',
	    evening: 'ตอนเย็น',
	    night: 'ตอนกลางคืน'
	  },
	  abbreviated: {
	    am: 'ก่อนเที่ยง',
	    pm: 'หลังเที่ยง',
	    midnight: 'เที่ยงคืน',
	    noon: 'เที่ยง',
	    morning: 'ตอนเช้า',
	    afternoon: 'ตอนกลางวัน',
	    evening: 'ตอนเย็น',
	    night: 'ตอนกลางคืน'
	  },
	  wide: {
	    am: 'ก่อนเที่ยง',
	    pm: 'หลังเที่ยง',
	    midnight: 'เที่ยงคืน',
	    noon: 'เที่ยง',
	    morning: 'ตอนเช้า',
	    afternoon: 'ตอนกลางวัน',
	    evening: 'ตอนเย็น',
	    night: 'ตอนกลางคืน'
	  }
	};
	
	function ordinalNumber(dirtyNumber) {
	  var number = Number(dirtyNumber);
	  return number;
	}
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingDayPeriodValues,
	    defaultFormattingWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1459 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(15));
	
	var _index2 = _interopRequireDefault(__webpack_require__(14));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^\d+/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^([bB]|[aA]|คศ)/i,
	  abbreviated: /^([bB]\.?\s?[cC]\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?|ค\.?ศ\.?)/i,
	  wide: /^(ก่อนคริสตกาล|คริสต์ศักราช|คริสตกาล)/i
	};
	var parseEraPatterns = {
	  any: [/^[bB]/i, /^(^[aA]|ค\.?ศ\.?|คริสตกาล|คริสต์ศักราช|)/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^q[1234]/i,
	  wide: /^ไตรมาส(ที่)? ?[1234]/i
	};
	var parseQuarterPatterns = {
	  any: [/(1|แรก|หนึ่ง)/i, /(2|สอง)/i, /(3|สาม)/i, /(4|สี่)/i]
	};
	var matchMonthPatterns = {
	  narrow: /^(ม\.?ค\.?|ก\.?พ\.?|มี\.?ค\.?|เม\.?ย\.?|พ\.?ค\.?|มิ\.?ย\.?|ก\.?ค\.?|ส\.?ค\.?|ก\.?ย\.?|ต\.?ค\.?|พ\.?ย\.?|ธ\.?ค\.?)/i,
	  abbreviated: /^(ม\.?ค\.?|ก\.?พ\.?|มี\.?ค\.?|เม\.?ย\.?|พ\.?ค\.?|มิ\.?ย\.?|ก\.?ค\.?|ส\.?ค\.?|ก\.?ย\.?|ต\.?ค\.?|พ\.?ย\.?|ธ\.?ค\.?')/i,
	  wide: /^(มกราคม|กุมภาพันธ์|มีนาคม|เมษายน|พฤษภาคม|มิถุนายน|กรกฎาคม|สิงหาคม|กันยายน|ตุลาคม|พฤศจิกายน|ธันวาคม)/i
	};
	var parseMonthPatterns = {
	  wide: [/^มก/i, /^กุม/i, /^มี/i, /^เม/i, /^พฤษ/i, /^มิ/i, /^กรก/i, /^ส/i, /^กัน/i, /^ต/i, /^พฤศ/i, /^ธ/i],
	  any: [/^ม\.?ค\.?/i, /^ก\.?พ\.?/i, /^มี\.?ค\.?/i, /^เม\.?ย\.?/i, /^พ\.?ค\.?/i, /^มิ\.?ย\.?/i, /^ก\.?ค\.?/i, /^ส\.?ค\.?/i, /^ก\.?ย\.?/i, /^ต\.?ค\.?/i, /^พ\.?ย\.?/i, /^ธ\.?ค\.?/i]
	};
	var matchDayPatterns = {
	  narrow: /^(อา\.?|จ\.?|อ\.?|พฤ\.?|พ\.?|ศ\.?|ส\.?)/i,
	  short: /^(อา\.?|จ\.?|อ\.?|พฤ\.?|พ\.?|ศ\.?|ส\.?)/i,
	  abbreviated: /^(อา\.?|จ\.?|อ\.?|พฤ\.?|พ\.?|ศ\.?|ส\.?)/i,
	  wide: /^(อาทิตย์|จันทร์|อังคาร|พุธ|พฤหัสบดี|ศุกร์|เสาร์)/i
	};
	var parseDayPatterns = {
	  wide: [/^อา/i, /^จั/i, /^อั/i, /^พุธ/i, /^พฤ/i, /^ศ/i, /^เส/i],
	  any: [/^อา/i, /^จ/i, /^อ/i, /^พ(?!ฤ)/i, /^พฤ/i, /^ศ/i, /^ส/i]
	};
	var matchDayPeriodPatterns = {
	  any: /^(ก่อนเที่ยง|หลังเที่ยง|เที่ยงคืน|เที่ยง|(ตอน.*?)?.*(เที่ยง|เช้า|บ่าย|เย็น|กลางคืน))/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^ก่อนเที่ยง/i,
	    pm: /^หลังเที่ยง/i,
	    midnight: /^เที่ยงคืน/i,
	    noon: /^เที่ยง/i,
	    morning: /เช้า/i,
	    afternoon: /บ่าย/i,
	    evening: /เย็น/i,
	    night: /กลางคืน/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index2.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index2.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index2.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index2.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index2.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1460 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1455));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1456));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1457));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1458));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1459));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Thai locale.
	 * @language Thai
	 * @iso-639-2 tha
	 * @author Athiwat Hirunworawongkun [@athivvat]{@link https://github.com/athivvat}
	 * @author [@hawkup]{@link https://github.com/hawkup}
	 * @author  Jirawat I. [@nodtem66]{@link https://github.com/nodtem66}
	 */
	var locale = {
	  code: 'th',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 0
	    /* Sunday */
	    ,
	    firstWeekContainsDate: 1
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1461 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    one: 'bir saniyeden az',
	    other: '{{count}} saniyeden az'
	  },
	  xSeconds: {
	    one: '1 saniye',
	    other: '{{count}} saniye'
	  },
	  halfAMinute: 'yarım dakika',
	  lessThanXMinutes: {
	    one: 'bir dakikadan az',
	    other: '{{count}} dakikadan az'
	  },
	  xMinutes: {
	    one: '1 dakika',
	    other: '{{count}} dakika'
	  },
	  aboutXHours: {
	    one: 'yaklaşık 1 saat',
	    other: 'yaklaşık {{count}} saat'
	  },
	  xHours: {
	    one: '1 saat',
	    other: '{{count}} saat'
	  },
	  xDays: {
	    one: '1 gün',
	    other: '{{count}} gün'
	  },
	  aboutXWeeks: {
	    one: 'yaklaşık 1 hafta',
	    other: 'yaklaşık {{count}} hafta'
	  },
	  xWeeks: {
	    one: '1 hafta',
	    other: '{{count}} hafta'
	  },
	  aboutXMonths: {
	    one: 'yaklaşık 1 ay',
	    other: 'yaklaşık {{count}} ay'
	  },
	  xMonths: {
	    one: '1 ay',
	    other: '{{count}} ay'
	  },
	  aboutXYears: {
	    one: 'yaklaşık 1 yıl',
	    other: 'yaklaşık {{count}} yıl'
	  },
	  xYears: {
	    one: '1 yıl',
	    other: '{{count}} yıl'
	  },
	  overXYears: {
	    one: '1 yıldan fazla',
	    other: '{{count}} yıldan fazla'
	  },
	  almostXYears: {
	    one: 'neredeyse 1 yıl',
	    other: 'neredeyse {{count}} yıl'
	  }
	};
	
	var formatDistance = function (token, count, options) {
	  var result;
	  var tokenValue = formatDistanceLocale[token];
	
	  if (typeof tokenValue === 'string') {
	    result = tokenValue;
	  } else if (count === 1) {
	    result = tokenValue.one;
	  } else {
	    result = tokenValue.other.replace('{{count}}', count.toString());
	  }
	
	  if (options !== null && options !== void 0 && options.addSuffix) {
	    if (options.comparison && options.comparison > 0) {
	      return result + ' sonra';
	    } else {
	      return result + ' önce';
	    }
	  }
	
	  return result;
	};
	
	var _default = formatDistance;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1462 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: 'd MMMM y EEEE',
	  long: 'd MMMM y',
	  medium: 'd MMM y',
	  short: 'dd.MM.yyyy'
	};
	var timeFormats = {
	  full: 'HH:mm:ss zzzz',
	  long: 'HH:mm:ss z',
	  medium: 'HH:mm:ss',
	  short: 'HH:mm'
	};
	var dateTimeFormats = {
	  full: "{{date}} 'saat' {{time}}",
	  long: "{{date}} 'saat' {{time}}",
	  medium: '{{date}}, {{time}}',
	  short: '{{date}}, {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1463 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var formatRelativeLocale = {
	  lastWeek: "'geçen hafta' eeee 'saat' p",
	  yesterday: "'dün saat' p",
	  today: "'bugün saat' p",
	  tomorrow: "'yarın saat' p",
	  nextWeek: "eeee 'saat' p",
	  other: 'P'
	};
	
	var formatRelative = function (token, _date, _baseDate, _options) {
	  return formatRelativeLocale[token];
	};
	
	var _default = formatRelative;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1464 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eraValues = {
	  narrow: ['MÖ', 'MS'],
	  abbreviated: ['MÖ', 'MS'],
	  wide: ['Milattan Önce', 'Milattan Sonra']
	};
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['1Ç', '2Ç', '3Ç', '4Ç'],
	  wide: ['İlk çeyrek', 'İkinci Çeyrek', 'Üçüncü çeyrek', 'Son çeyrek']
	};
	var monthValues = {
	  narrow: ['O', 'Ş', 'M', 'N', 'M', 'H', 'T', 'A', 'E', 'E', 'K', 'A'],
	  abbreviated: ['Oca', 'Şub', 'Mar', 'Nis', 'May', 'Haz', 'Tem', 'Ağu', 'Eyl', 'Eki', 'Kas', 'Ara'],
	  wide: ['Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran', 'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık']
	};
	var dayValues = {
	  narrow: ['P', 'P', 'S', 'Ç', 'P', 'C', 'C'],
	  short: ['Pz', 'Pt', 'Sa', 'Ça', 'Pe', 'Cu', 'Ct'],
	  abbreviated: ['Paz', 'Pzt', 'Sal', 'Çar', 'Per', 'Cum', 'Cts'],
	  wide: ['Pazar', 'Pazartesi', 'Salı', 'Çarşamba', 'Perşembe', 'Cuma', 'Cumartesi']
	};
	var dayPeriodValues = {
	  narrow: {
	    am: 'öö',
	    pm: 'ös',
	    midnight: 'gy',
	    noon: 'ö',
	    morning: 'sa',
	    afternoon: 'ös',
	    evening: 'ak',
	    night: 'ge'
	  },
	  abbreviated: {
	    am: 'ÖÖ',
	    pm: 'ÖS',
	    midnight: 'gece yarısı',
	    noon: 'öğle',
	    morning: 'sabah',
	    afternoon: 'öğleden sonra',
	    evening: 'akşam',
	    night: 'gece'
	  },
	  wide: {
	    am: 'Ö.Ö.',
	    pm: 'Ö.S.',
	    midnight: 'gece yarısı',
	    noon: 'öğle',
	    morning: 'sabah',
	    afternoon: 'öğleden sonra',
	    evening: 'akşam',
	    night: 'gece'
	  }
	};
	var formattingDayPeriodValues = {
	  narrow: {
	    am: 'öö',
	    pm: 'ös',
	    midnight: 'gy',
	    noon: 'ö',
	    morning: 'sa',
	    afternoon: 'ös',
	    evening: 'ak',
	    night: 'ge'
	  },
	  abbreviated: {
	    am: 'ÖÖ',
	    pm: 'ÖS',
	    midnight: 'gece yarısı',
	    noon: 'öğlen',
	    morning: 'sabahleyin',
	    afternoon: 'öğleden sonra',
	    evening: 'akşamleyin',
	    night: 'geceleyin'
	  },
	  wide: {
	    am: 'ö.ö.',
	    pm: 'ö.s.',
	    midnight: 'gece yarısı',
	    noon: 'öğlen',
	    morning: 'sabahleyin',
	    afternoon: 'öğleden sonra',
	    evening: 'akşamleyin',
	    night: 'geceleyin'
	  }
	};
	
	var ordinalNumber = function (dirtyNumber, _options) {
	  var number = Number(dirtyNumber);
	  return number + '.';
	};
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingDayPeriodValues,
	    defaultFormattingWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1465 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(14));
	
	var _index2 = _interopRequireDefault(__webpack_require__(15));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(\d+)(\.)?/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^(mö|ms)/i,
	  abbreviated: /^(mö|ms)/i,
	  wide: /^(milattan önce|milattan sonra)/i
	};
	var parseEraPatterns = {
	  any: [/(^mö|^milattan önce)/i, /(^ms|^milattan sonra)/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^[1234]ç/i,
	  wide: /^((i|İ)lk|(i|İ)kinci|üçüncü|son) çeyrek/i
	};
	var parseQuarterPatterns = {
	  any: [/1/i, /2/i, /3/i, /4/i],
	  abbreviated: [/1ç/i, /2ç/i, /3ç/i, /4ç/i],
	  wide: [/^(i|İ)lk çeyrek/i, /(i|İ)kinci çeyrek/i, /üçüncü çeyrek/i, /son çeyrek/i]
	};
	var matchMonthPatterns = {
	  narrow: /^[oşmnhtaek]/i,
	  abbreviated: /^(oca|şub|mar|nis|may|haz|tem|ağu|eyl|eki|kas|ara)/i,
	  wide: /^(ocak|şubat|mart|nisan|mayıs|haziran|temmuz|ağustos|eylül|ekim|kasım|aralık)/i
	};
	var parseMonthPatterns = {
	  narrow: [/^o/i, /^ş/i, /^m/i, /^n/i, /^m/i, /^h/i, /^t/i, /^a/i, /^e/i, /^e/i, /^k/i, /^a/i],
	  any: [/^o/i, /^ş/i, /^mar/i, /^n/i, /^may/i, /^h/i, /^t/i, /^ağ/i, /^ey/i, /^ek/i, /^k/i, /^ar/i]
	};
	var matchDayPatterns = {
	  narrow: /^[psçc]/i,
	  short: /^(pz|pt|sa|ça|pe|cu|ct)/i,
	  abbreviated: /^(paz|pzt|sal|çar|per|cum|cts)/i,
	  wide: /^(pazar|pazartesi|salı|çarşamba|perşembe|cuma|cumartesi)/i
	};
	var parseDayPatterns = {
	  narrow: [/^p/i, /^p/i, /^s/i, /^ç/i, /^p/i, /^c/i, /^c/i],
	  any: [/^pz/i, /^pt/i, /^sa/i, /^ça/i, /^pe/i, /^cu/i, /^ct/i],
	  wide: [/^pazar/i, /^pazartesi/i, /^salı/i, /^çarşamba/i, /^perşembe/i, /^cuma/i, /cumartesi/i]
	};
	var matchDayPeriodPatterns = {
	  narrow: /^(öö|ös|gy|ö|sa|ös|ak|ge)/i,
	  any: /^(ö\.?\s?[ös]\.?|öğleden sonra|gece yarısı|öğle|(sabah|öğ|akşam|gece)(leyin))/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^ö\.?ö\.?/i,
	    pm: /^ö\.?s\.?/i,
	    midnight: /^(gy|gece yarısı)/i,
	    noon: /^öğ/i,
	    morning: /^sa/i,
	    afternoon: /^öğleden sonra/i,
	    evening: /^ak/i,
	    night: /^ge/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index2.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1466 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1461));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1462));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1463));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1464));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1465));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Turkish locale.
	 * @language Turkish
	 * @iso-639-2 tur
	 * @author Alpcan Aydın [@alpcanaydin]{@link https://github.com/alpcanaydin}
	 * @author Berkay Sargın [@berkaey]{@link https://github.com/berkaey}
	 * @author Fatih Bulut [@bulutfatih]{@link https://github.com/bulutfatih}
	 * @author Ismail Demirbilek [@dbtek]{@link https://github.com/dbtek}
	 * @author İsmail Kayar [@ikayar]{@link https://github.com/ikayar}
	 *
	 *
	 */
	var locale = {
	  code: 'tr',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 1
	    /* Monday */
	    ,
	    firstWeekContainsDate: 1
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1467 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistance;
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    one: 'بىر سىكۇنت ئىچىدە',
	    other: 'سىكۇنت ئىچىدە {{count}}'
	  },
	  xSeconds: {
	    one: 'بىر سىكۇنت',
	    other: 'سىكۇنت {{count}}'
	  },
	  halfAMinute: 'يىرىم مىنۇت',
	  lessThanXMinutes: {
	    one: 'بىر مىنۇت ئىچىدە',
	    other: 'مىنۇت ئىچىدە {{count}}'
	  },
	  xMinutes: {
	    one: 'بىر مىنۇت',
	    other: 'مىنۇت {{count}}'
	  },
	  aboutXHours: {
	    one: 'تەخمىنەن بىر سائەت',
	    other: 'سائەت {{count}} تەخمىنەن'
	  },
	  xHours: {
	    one: 'بىر سائەت',
	    other: 'سائەت {{count}}'
	  },
	  xDays: {
	    one: 'بىر كۈن',
	    other: 'كۈن {{count}}'
	  },
	  aboutXWeeks: {
	    one: 'تەخمىنەن بىرھەپتە',
	    other: 'ھەپتە {{count}} تەخمىنەن'
	  },
	  xWeeks: {
	    one: 'بىرھەپتە',
	    other: 'ھەپتە {{count}}'
	  },
	  aboutXMonths: {
	    one: 'تەخمىنەن بىر ئاي',
	    other: 'ئاي {{count}} تەخمىنەن'
	  },
	  xMonths: {
	    one: 'بىر ئاي',
	    other: 'ئاي {{count}}'
	  },
	  aboutXYears: {
	    one: 'تەخمىنەن بىر يىل',
	    other: 'يىل {{count}} تەخمىنەن'
	  },
	  xYears: {
	    one: 'بىر يىل',
	    other: 'يىل {{count}}'
	  },
	  overXYears: {
	    one: 'بىر يىلدىن ئارتۇق',
	    other: 'يىلدىن ئارتۇق {{count}}'
	  },
	  almostXYears: {
	    one: 'ئاساسەن بىر يىل',
	    other: 'يىل {{count}} ئاساسەن'
	  }
	};
	
	function formatDistance(token, count, options) {
	  options = options || {};
	  var result;
	
	  if (typeof formatDistanceLocale[token] === 'string') {
	    result = formatDistanceLocale[token];
	  } else if (count === 1) {
	    result = formatDistanceLocale[token].one;
	  } else {
	    result = formatDistanceLocale[token].other.replace('{{count}}', count);
	  }
	
	  if (options.addSuffix) {
	    if (options.comparison > 0) {
	      return result;
	    } else {
	      return result + ' بولدى';
	    }
	  }
	
	  return result;
	}
	
	module.exports = exports.default;

/***/ },
/* 1468 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: 'EEEE, MMMM do, y',
	  long: 'MMMM do, y',
	  medium: 'MMM d, y',
	  short: 'MM/dd/yyyy'
	};
	var timeFormats = {
	  full: 'h:mm:ss a zzzz',
	  long: 'h:mm:ss a z',
	  medium: 'h:mm:ss a',
	  short: 'h:mm a'
	};
	var dateTimeFormats = {
	  full: "{{date}} 'دە' {{time}}",
	  long: "{{date}} 'دە' {{time}}",
	  medium: '{{date}}, {{time}}',
	  short: '{{date}}, {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1469 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRelative;
	var formatRelativeLocale = {
	  lastWeek: "'ئ‍ۆتكەن' eeee 'دە' p",
	  yesterday: "'تۈنۈگۈن دە' p",
	  today: "'بۈگۈن دە' p",
	  tomorrow: "'ئەتە دە' p",
	  nextWeek: "eeee 'دە' p",
	  other: 'P'
	};
	
	function formatRelative(token, _date, _baseDate, _options) {
	  return formatRelativeLocale[token];
	}
	
	module.exports = exports.default;

/***/ },
/* 1470 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eraValues = {
	  narrow: ['ب', 'ك'],
	  abbreviated: ['ب', 'ك'],
	  wide: ['مىيلادىدىن بۇرۇن', 'مىيلادىدىن كىيىن']
	};
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['1', '2', '3', '4'],
	  wide: ['بىرىنجى چارەك', 'ئىككىنجى چارەك', 'ئۈچىنجى چارەك', 'تۆتىنجى چارەك']
	}; // Note: in English, the names of days of the week and months are capitalized.
	// If you are making a new locale based on this one, check if the same is true for the language you're working on.
	// Generally, formatted dates should look like they are in the middle of a sentence,
	// e.g. in Spanish language the weekdays and months should be in the lowercase.
	
	var monthValues = {
	  narrow: ['ي', 'ف', 'م', 'ا', 'م', 'ى', 'ى', 'ا', 'س', 'ۆ', 'ن', 'د'],
	  abbreviated: ['يانۋار', 'فېۋىرال', 'مارت', 'ئاپرىل', 'ماي', 'ئىيۇن', 'ئىيول', 'ئاۋغۇست', 'سىنتەبىر', 'ئۆكتەبىر', 'نويابىر', 'دىكابىر'],
	  wide: ['يانۋار', 'فېۋىرال', 'مارت', 'ئاپرىل', 'ماي', 'ئىيۇن', 'ئىيول', 'ئاۋغۇست', 'سىنتەبىر', 'ئۆكتەبىر', 'نويابىر', 'دىكابىر']
	};
	var dayValues = {
	  narrow: ['ي', 'د', 'س', 'چ', 'پ', 'ج', 'ش'],
	  short: ['ي', 'د', 'س', 'چ', 'پ', 'ج', 'ش'],
	  abbreviated: ['يەكشەنبە', 'دۈشەنبە', 'سەيشەنبە', 'چارشەنبە', 'پەيشەنبە', 'جۈمە', 'شەنبە'],
	  wide: ['يەكشەنبە', 'دۈشەنبە', 'سەيشەنبە', 'چارشەنبە', 'پەيشەنبە', 'جۈمە', 'شەنبە']
	};
	var dayPeriodValues = {
	  narrow: {
	    am: 'ئە',
	    pm: 'چ',
	    midnight: 'ك',
	    noon: 'چ',
	    morning: 'ئەتىگەن',
	    afternoon: 'چۈشتىن كىيىن',
	    evening: 'ئاخشىم',
	    night: 'كىچە'
	  },
	  abbreviated: {
	    am: 'ئە',
	    pm: 'چ',
	    midnight: 'ك',
	    noon: 'چ',
	    morning: 'ئەتىگەن',
	    afternoon: 'چۈشتىن كىيىن',
	    evening: 'ئاخشىم',
	    night: 'كىچە'
	  },
	  wide: {
	    am: 'ئە',
	    pm: 'چ',
	    midnight: 'ك',
	    noon: 'چ',
	    morning: 'ئەتىگەن',
	    afternoon: 'چۈشتىن كىيىن',
	    evening: 'ئاخشىم',
	    night: 'كىچە'
	  }
	};
	var formattingDayPeriodValues = {
	  narrow: {
	    am: 'ئە',
	    pm: 'چ',
	    midnight: 'ك',
	    noon: 'چ',
	    morning: 'ئەتىگەندە',
	    afternoon: 'چۈشتىن كىيىن',
	    evening: 'ئاخشامدا',
	    night: 'كىچىدە'
	  },
	  abbreviated: {
	    am: 'ئە',
	    pm: 'چ',
	    midnight: 'ك',
	    noon: 'چ',
	    morning: 'ئەتىگەندە',
	    afternoon: 'چۈشتىن كىيىن',
	    evening: 'ئاخشامدا',
	    night: 'كىچىدە'
	  },
	  wide: {
	    am: 'ئە',
	    pm: 'چ',
	    midnight: 'ك',
	    noon: 'چ',
	    morning: 'ئەتىگەندە',
	    afternoon: 'چۈشتىن كىيىن',
	    evening: 'ئاخشامدا',
	    night: 'كىچىدە'
	  }
	};
	
	function ordinalNumber(dirtyNumber, _dirtyOptions) {
	  return String(dirtyNumber);
	}
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingDayPeriodValues,
	    defaultFormattingWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1471 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(15));
	
	var _index2 = _interopRequireDefault(__webpack_require__(14));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^(ب|ك)/i,
	  wide: /^(مىيلادىدىن بۇرۇن|مىيلادىدىن كىيىن)/i
	};
	var parseEraPatterns = {
	  any: [/^بۇرۇن/i, /^كىيىن/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^چ[1234]/i,
	  wide: /^چارەك [1234]/i
	};
	var parseQuarterPatterns = {
	  any: [/1/i, /2/i, /3/i, /4/i]
	};
	var matchMonthPatterns = {
	  // eslint-disable-next-line no-misleading-character-class
	  narrow: /^[يفمئامئ‍ئاسۆند]/i,
	  abbreviated: /^(يانۋار|فېۋىرال|مارت|ئاپرىل|ماي|ئىيۇن|ئىيول|ئاۋغۇست|سىنتەبىر|ئۆكتەبىر|نويابىر|دىكابىر)/i,
	  wide: /^(يانۋار|فېۋىرال|مارت|ئاپرىل|ماي|ئىيۇن|ئىيول|ئاۋغۇست|سىنتەبىر|ئۆكتەبىر|نويابىر|دىكابىر)/i
	};
	var parseMonthPatterns = {
	  narrow: [/^ي/i, /^ف/i, /^م/i, /^ا/i, /^م/i, /^ى‍/i, /^ى‍/i, /^ا‍/i, /^س/i, /^ۆ/i, /^ن/i, /^د/i],
	  any: [/^يان/i, /^فېۋ/i, /^مار/i, /^ئاپ/i, /^ماي/i, /^ئىيۇن/i, /^ئىيول/i, /^ئاۋ/i, /^سىن/i, /^ئۆك/i, /^نوي/i, /^دىك/i]
	};
	var matchDayPatterns = {
	  narrow: /^[دسچپجشي]/i,
	  short: /^(يە|دۈ|سە|چا|پە|جۈ|شە)/i,
	  abbreviated: /^(يە|دۈ|سە|چا|پە|جۈ|شە)/i,
	  wide: /^(يەكشەنبە|دۈشەنبە|سەيشەنبە|چارشەنبە|پەيشەنبە|جۈمە|شەنبە)/i
	};
	var parseDayPatterns = {
	  narrow: [/^ي/i, /^د/i, /^س/i, /^چ/i, /^پ/i, /^ج/i, /^ش/i],
	  any: [/^ي/i, /^د/i, /^س/i, /^چ/i, /^پ/i, /^ج/i, /^ش/i]
	};
	var matchDayPeriodPatterns = {
	  narrow: /^(ئە|چ|ك|چ|(دە|ئەتىگەن) ( ئە‍|چۈشتىن كىيىن|ئاخشىم|كىچە))/i,
	  any: /^(ئە|چ|ك|چ|(دە|ئەتىگەن) ( ئە‍|چۈشتىن كىيىن|ئاخشىم|كىچە))/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^ئە/i,
	    pm: /^چ/i,
	    midnight: /^ك/i,
	    noon: /^چ/i,
	    morning: /ئەتىگەن/i,
	    afternoon: /چۈشتىن كىيىن/i,
	    evening: /ئاخشىم/i,
	    night: /كىچە/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index2.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index2.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index2.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index2.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index2.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1472 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1467));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1468));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1469));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1470));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1471));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Uighur locale
	 * @language Uighur
	 * @iso-639-2 uig
	 * @author Abduwaly M. [@abduwaly]{@link https://github.com/abduwaly}
	 */
	var locale = {
	  code: 'ug',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 0
	    /* Sunday */
	    ,
	    firstWeekContainsDate: 1
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1473 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistance;
	
	function declension(scheme, count) {
	  // scheme for count=1 exists
	  if (scheme.one !== undefined && count === 1) {
	    return scheme.one;
	  }
	
	  var rem10 = count % 10;
	  var rem100 = count % 100; // 1, 21, 31, ...
	
	  if (rem10 === 1 && rem100 !== 11) {
	    return scheme.singularNominative.replace('{{count}}', count); // 2, 3, 4, 22, 23, 24, 32 ...
	  } else if (rem10 >= 2 && rem10 <= 4 && (rem100 < 10 || rem100 > 20)) {
	    return scheme.singularGenitive.replace('{{count}}', count); // 5, 6, 7, 8, 9, 10, 11, ...
	  } else {
	    return scheme.pluralGenitive.replace('{{count}}', count);
	  }
	}
	
	function buildLocalizeTokenFn(scheme) {
	  return function (count, options) {
	    if (options.addSuffix) {
	      if (options.comparison > 0) {
	        if (scheme.future) {
	          return declension(scheme.future, count);
	        } else {
	          return 'за ' + declension(scheme.regular, count);
	        }
	      } else {
	        if (scheme.past) {
	          return declension(scheme.past, count);
	        } else {
	          return declension(scheme.regular, count) + ' тому';
	        }
	      }
	    } else {
	      return declension(scheme.regular, count);
	    }
	  };
	}
	
	var formatDistanceLocale = {
	  lessThanXSeconds: buildLocalizeTokenFn({
	    regular: {
	      one: 'менше секунди',
	      singularNominative: 'менше {{count}} секунди',
	      singularGenitive: 'менше {{count}} секунд',
	      pluralGenitive: 'менше {{count}} секунд'
	    },
	    future: {
	      one: 'менше, ніж за секунду',
	      singularNominative: 'менше, ніж за {{count}} секунду',
	      singularGenitive: 'менше, ніж за {{count}} секунди',
	      pluralGenitive: 'менше, ніж за {{count}} секунд'
	    }
	  }),
	  xSeconds: buildLocalizeTokenFn({
	    regular: {
	      singularNominative: '{{count}} секунда',
	      singularGenitive: '{{count}} секунди',
	      pluralGenitive: '{{count}} секунд'
	    },
	    past: {
	      singularNominative: '{{count}} секунду тому',
	      singularGenitive: '{{count}} секунди тому',
	      pluralGenitive: '{{count}} секунд тому'
	    },
	    future: {
	      singularNominative: 'за {{count}} секунду',
	      singularGenitive: 'за {{count}} секунди',
	      pluralGenitive: 'за {{count}} секунд'
	    }
	  }),
	  halfAMinute: function (_, options) {
	    if (options.addSuffix) {
	      if (options.comparison > 0) {
	        return 'за півхвилини';
	      } else {
	        return 'півхвилини тому';
	      }
	    }
	
	    return 'півхвилини';
	  },
	  lessThanXMinutes: buildLocalizeTokenFn({
	    regular: {
	      one: 'менше хвилини',
	      singularNominative: 'менше {{count}} хвилини',
	      singularGenitive: 'менше {{count}} хвилин',
	      pluralGenitive: 'менше {{count}} хвилин'
	    },
	    future: {
	      one: 'менше, ніж за хвилину',
	      singularNominative: 'менше, ніж за {{count}} хвилину',
	      singularGenitive: 'менше, ніж за {{count}} хвилини',
	      pluralGenitive: 'менше, ніж за {{count}} хвилин'
	    }
	  }),
	  xMinutes: buildLocalizeTokenFn({
	    regular: {
	      singularNominative: '{{count}} хвилина',
	      singularGenitive: '{{count}} хвилини',
	      pluralGenitive: '{{count}} хвилин'
	    },
	    past: {
	      singularNominative: '{{count}} хвилину тому',
	      singularGenitive: '{{count}} хвилини тому',
	      pluralGenitive: '{{count}} хвилин тому'
	    },
	    future: {
	      singularNominative: 'за {{count}} хвилину',
	      singularGenitive: 'за {{count}} хвилини',
	      pluralGenitive: 'за {{count}} хвилин'
	    }
	  }),
	  aboutXHours: buildLocalizeTokenFn({
	    regular: {
	      singularNominative: 'близько {{count}} години',
	      singularGenitive: 'близько {{count}} годин',
	      pluralGenitive: 'близько {{count}} годин'
	    },
	    future: {
	      singularNominative: 'приблизно за {{count}} годину',
	      singularGenitive: 'приблизно за {{count}} години',
	      pluralGenitive: 'приблизно за {{count}} годин'
	    }
	  }),
	  xHours: buildLocalizeTokenFn({
	    regular: {
	      singularNominative: '{{count}} годину',
	      singularGenitive: '{{count}} години',
	      pluralGenitive: '{{count}} годин'
	    }
	  }),
	  xDays: buildLocalizeTokenFn({
	    regular: {
	      singularNominative: '{{count}} день',
	      singularGenitive: '{{count}} дня',
	      pluralGenitive: '{{count}} днів'
	    }
	  }),
	  aboutXWeeks: buildLocalizeTokenFn({
	    regular: {
	      singularNominative: 'близько {{count}} тижня',
	      singularGenitive: 'близько {{count}} тижнів',
	      pluralGenitive: 'близько {{count}} тижнів'
	    },
	    future: {
	      singularNominative: 'приблизно за {{count}} тиждень',
	      singularGenitive: 'приблизно за {{count}} тижні',
	      pluralGenitive: 'приблизно за {{count}} тижні'
	    }
	  }),
	  xWeeks: buildLocalizeTokenFn({
	    regular: {
	      singularNominative: '{{count}} тиждень',
	      singularGenitive: '{{count}} тижня',
	      pluralGenitive: '{{count}} тижні'
	    }
	  }),
	  aboutXMonths: buildLocalizeTokenFn({
	    regular: {
	      singularNominative: 'близько {{count}} місяця',
	      singularGenitive: 'близько {{count}} місяців',
	      pluralGenitive: 'близько {{count}} місяців'
	    },
	    future: {
	      singularNominative: 'приблизно за {{count}} місяць',
	      singularGenitive: 'приблизно за {{count}} місяця',
	      pluralGenitive: 'приблизно за {{count}} місяців'
	    }
	  }),
	  xMonths: buildLocalizeTokenFn({
	    regular: {
	      singularNominative: '{{count}} місяць',
	      singularGenitive: '{{count}} місяця',
	      pluralGenitive: '{{count}} місяців'
	    }
	  }),
	  aboutXYears: buildLocalizeTokenFn({
	    regular: {
	      singularNominative: 'близько {{count}} року',
	      singularGenitive: 'близько {{count}} років',
	      pluralGenitive: 'близько {{count}} років'
	    },
	    future: {
	      singularNominative: 'приблизно за {{count}} рік',
	      singularGenitive: 'приблизно за {{count}} роки',
	      pluralGenitive: 'приблизно за {{count}} років'
	    }
	  }),
	  xYears: buildLocalizeTokenFn({
	    regular: {
	      singularNominative: '{{count}} рік',
	      singularGenitive: '{{count}} роки',
	      pluralGenitive: '{{count}} років'
	    }
	  }),
	  overXYears: buildLocalizeTokenFn({
	    regular: {
	      singularNominative: 'більше {{count}} року',
	      singularGenitive: 'більше {{count}} років',
	      pluralGenitive: 'більше {{count}} років'
	    },
	    future: {
	      singularNominative: 'більше, ніж за {{count}} рік',
	      singularGenitive: 'більше, ніж за {{count}} роки',
	      pluralGenitive: 'більше, ніж за {{count}} років'
	    }
	  }),
	  almostXYears: buildLocalizeTokenFn({
	    regular: {
	      singularNominative: 'майже {{count}} рік',
	      singularGenitive: 'майже {{count}} роки',
	      pluralGenitive: 'майже {{count}} років'
	    },
	    future: {
	      singularNominative: 'майже за {{count}} рік',
	      singularGenitive: 'майже за {{count}} роки',
	      pluralGenitive: 'майже за {{count}} років'
	    }
	  })
	};
	
	function formatDistance(token, count, options) {
	  options = options || {};
	  return formatDistanceLocale[token](count, options);
	}
	
	module.exports = exports.default;

/***/ },
/* 1474 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: "EEEE, do MMMM y 'р.'",
	  long: "do MMMM y 'р.'",
	  medium: "d MMM y 'р.'",
	  short: 'dd.MM.y'
	};
	var timeFormats = {
	  full: 'H:mm:ss zzzz',
	  long: 'H:mm:ss z',
	  medium: 'H:mm:ss',
	  short: 'H:mm'
	};
	var dateTimeFormats = {
	  full: "{{date}} 'о' {{time}}",
	  long: "{{date}} 'о' {{time}}",
	  medium: '{{date}}, {{time}}',
	  short: '{{date}}, {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1475 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRelative;
	
	var _index = _interopRequireDefault(__webpack_require__(71));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var accusativeWeekdays = ['неділю', 'понеділок', 'вівторок', 'середу', 'четвер', 'п’ятницю', 'суботу'];
	
	function lastWeek(day) {
	  var weekday = accusativeWeekdays[day];
	
	  switch (day) {
	    case 0:
	    case 3:
	    case 5:
	    case 6:
	      return "'у минулу " + weekday + " о' p";
	
	    case 1:
	    case 2:
	    case 4:
	      return "'у минулий " + weekday + " о' p";
	  }
	}
	
	function thisWeek(day) {
	  var weekday = accusativeWeekdays[day];
	  return "'у " + weekday + " о' p";
	}
	
	function nextWeek(day) {
	  var weekday = accusativeWeekdays[day];
	
	  switch (day) {
	    case 0:
	    case 3:
	    case 5:
	    case 6:
	      return "'у наступну " + weekday + " о' p";
	
	    case 1:
	    case 2:
	    case 4:
	      return "'у наступний " + weekday + " о' p";
	  }
	}
	
	var formatRelativeLocale = {
	  lastWeek: function (date, baseDate, options) {
	    var day = date.getUTCDay();
	
	    if ((0, _index.default)(date, baseDate, options)) {
	      return thisWeek(day);
	    } else {
	      return lastWeek(day);
	    }
	  },
	  yesterday: "'вчора о' p",
	  today: "'сьогодні о' p",
	  tomorrow: "'завтра о' p",
	  nextWeek: function (date, baseDate, options) {
	    var day = date.getUTCDay();
	
	    if ((0, _index.default)(date, baseDate, options)) {
	      return thisWeek(day);
	    } else {
	      return nextWeek(day);
	    }
	  },
	  other: 'P'
	};
	
	function formatRelative(token, date, baseDate, options) {
	  var format = formatRelativeLocale[token];
	
	  if (typeof format === 'function') {
	    return format(date, baseDate, options);
	  }
	
	  return format;
	}
	
	module.exports = exports.default;

/***/ },
/* 1476 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eraValues = {
	  narrow: ['до н.е.', 'н.е.'],
	  abbreviated: ['до н. е.', 'н. е.'],
	  wide: ['до нашої ери', 'нашої ери']
	};
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['1-й кв.', '2-й кв.', '3-й кв.', '4-й кв.'],
	  wide: ['1-й квартал', '2-й квартал', '3-й квартал', '4-й квартал']
	};
	var monthValues = {
	  // ДСТУ 3582:2013
	  narrow: ['С', 'Л', 'Б', 'К', 'Т', 'Ч', 'Л', 'С', 'В', 'Ж', 'Л', 'Г'],
	  abbreviated: ['січ.', 'лют.', 'берез.', 'квіт.', 'трав.', 'черв.', 'лип.', 'серп.', 'верес.', 'жовт.', 'листоп.', 'груд.'],
	  wide: ['січень', 'лютий', 'березень', 'квітень', 'травень', 'червень', 'липень', 'серпень', 'вересень', 'жовтень', 'листопад', 'грудень']
	};
	var formattingMonthValues = {
	  narrow: ['С', 'Л', 'Б', 'К', 'Т', 'Ч', 'Л', 'С', 'В', 'Ж', 'Л', 'Г'],
	  abbreviated: ['січ.', 'лют.', 'берез.', 'квіт.', 'трав.', 'черв.', 'лип.', 'серп.', 'верес.', 'жовт.', 'листоп.', 'груд.'],
	  wide: ['січня', 'лютого', 'березня', 'квітня', 'травня', 'червня', 'липня', 'серпня', 'вересня', 'жовтня', 'листопада', 'грудня']
	};
	var dayValues = {
	  narrow: ['Н', 'П', 'В', 'С', 'Ч', 'П', 'С'],
	  short: ['нд', 'пн', 'вт', 'ср', 'чт', 'пт', 'сб'],
	  abbreviated: ['нед', 'пон', 'вів', 'сер', 'чтв', 'птн', 'суб'],
	  wide: ['неділя', 'понеділок', 'вівторок', 'середа', 'четвер', 'п’ятниця', 'субота']
	};
	var dayPeriodValues = {
	  narrow: {
	    am: 'ДП',
	    pm: 'ПП',
	    midnight: 'півн.',
	    noon: 'пол.',
	    morning: 'ранок',
	    afternoon: 'день',
	    evening: 'веч.',
	    night: 'ніч'
	  },
	  abbreviated: {
	    am: 'ДП',
	    pm: 'ПП',
	    midnight: 'півн.',
	    noon: 'пол.',
	    morning: 'ранок',
	    afternoon: 'день',
	    evening: 'веч.',
	    night: 'ніч'
	  },
	  wide: {
	    am: 'ДП',
	    pm: 'ПП',
	    midnight: 'північ',
	    noon: 'полудень',
	    morning: 'ранок',
	    afternoon: 'день',
	    evening: 'вечір',
	    night: 'ніч'
	  }
	};
	var formattingDayPeriodValues = {
	  narrow: {
	    am: 'ДП',
	    pm: 'ПП',
	    midnight: 'півн.',
	    noon: 'пол.',
	    morning: 'ранку',
	    afternoon: 'дня',
	    evening: 'веч.',
	    night: 'ночі'
	  },
	  abbreviated: {
	    am: 'ДП',
	    pm: 'ПП',
	    midnight: 'півн.',
	    noon: 'пол.',
	    morning: 'ранку',
	    afternoon: 'дня',
	    evening: 'веч.',
	    night: 'ночі'
	  },
	  wide: {
	    am: 'ДП',
	    pm: 'ПП',
	    midnight: 'північ',
	    noon: 'полудень',
	    morning: 'ранку',
	    afternoon: 'дня',
	    evening: 'веч.',
	    night: 'ночі'
	  }
	};
	
	function ordinalNumber(dirtyNumber, dirtyOptions) {
	  var options = dirtyOptions || {};
	  var unit = String(options.unit);
	  var suffix;
	
	  if (unit === 'date') {
	    if (dirtyNumber === 3 || dirtyNumber === 23) {
	      suffix = '-є';
	    } else {
	      suffix = '-е';
	    }
	  } else if (unit === 'minute' || unit === 'second' || unit === 'hour') {
	    suffix = '-а';
	  } else {
	    suffix = '-й';
	  }
	
	  return dirtyNumber + suffix;
	}
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingMonthValues,
	    defaultFormattingWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'any',
	    formattingValues: formattingDayPeriodValues,
	    defaultFormattingWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1477 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(15));
	
	var _index2 = _interopRequireDefault(__webpack_require__(14));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(\d+)(-?(е|й|є|а|я))?/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^((до )?н\.?\s?е\.?)/i,
	  abbreviated: /^((до )?н\.?\s?е\.?)/i,
	  wide: /^(до нашої ери|нашої ери|наша ера)/i
	};
	var parseEraPatterns = {
	  any: [/^д/i, /^н/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^[1234](-?[иі]?й?)? кв.?/i,
	  wide: /^[1234](-?[иі]?й?)? квартал/i
	};
	var parseQuarterPatterns = {
	  any: [/1/i, /2/i, /3/i, /4/i]
	};
	var matchMonthPatterns = {
	  narrow: /^[слбктчвжг]/i,
	  abbreviated: /^(січ|лют|бер|берез|кві|трав?|чер|лип|сер|вер|жов|лис(топ)?|груд)\.?/i,
	  wide: /^(січень|січня|лютий|лютого|березень|березня|квітень|квітня|травень|травня|липень|липня|серпень|серпня|вересень|вересня|жовтень|жовтня|листопада?|грудень|грудня)/i
	};
	var parseMonthPatterns = {
	  narrow: [/^с/i, /^л/i, /^б/i, /^к/i, /^т/i, /^ч/i, /^л/i, /^с/i, /^в/i, /^ж/i, /^л/i, /^г/i],
	  any: [/^сі/i, /^лю/i, /^б/i, /^к/i, /^т/i, /^ч/i, /^лип/i, /^се/i, /^в/i, /^ж/i, /^лис/i, /^г/i]
	};
	var matchDayPatterns = {
	  narrow: /^[нпвсч]/i,
	  short: /^(нд|пн|вт|ср|чт|пт|сб)\.?/i,
	  abbreviated: /^(нед|пон|вів|сер|че?тв|птн?|суб)\.?/i,
	  wide: /^(неділ[яі]|понеділ[ок][ка]|вівтор[ок][ка]|серед[аи]|четвер(га)?|п\W*?ятниц[яі]|субот[аи])/i
	};
	var parseDayPatterns = {
	  narrow: [/^н/i, /^п/i, /^в/i, /^с/i, /^ч/i, /^п/i, /^с/i],
	  any: [/^н/i, /^п[он]/i, /^в/i, /^с[ер]/i, /^ч/i, /^п\W*?[ят]/i, /^с[уб]/i]
	};
	var matchDayPeriodPatterns = {
	  narrow: /^([дп]п|півн\.?|пол\.?|ранок|ранку|день|дня|веч\.?|ніч|ночі)/i,
	  abbreviated: /^([дп]п|півн\.?|пол\.?|ранок|ранку|день|дня|веч\.?|ніч|ночі)/i,
	  wide: /^([дп]п|північ|полудень|ранок|ранку|день|дня|вечір|вечора|ніч|ночі)/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^дп/i,
	    pm: /^пп/i,
	    midnight: /^півн/i,
	    noon: /^пол/i,
	    morning: /^р/i,
	    afternoon: /^д[ен]/i,
	    evening: /^в/i,
	    night: /^н/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index2.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index2.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index2.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index2.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index2.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1478 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1473));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1474));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1475));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1476));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1477));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Ukrainian locale.
	 * @language Ukrainian
	 * @iso-639-2 ukr
	 * @author Andrii Korzh [@korzhyk]{@link https://github.com/korzhyk}
	 * @author Andriy Shcherbyak [@shcherbyakdev]{@link https://github.com/shcherbyakdev}
	 */
	var locale = {
	  code: 'uk',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 1
	    /* Monday */
	    ,
	    firstWeekContainsDate: 1
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1479 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistance;
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    one: '1 сониядан кам',
	    other: '{{count}} сониядан кам'
	  },
	  xSeconds: {
	    one: '1 сония',
	    other: '{{count}} сония'
	  },
	  halfAMinute: 'ярим дақиқа',
	  lessThanXMinutes: {
	    one: '1 дақиқадан кам',
	    other: '{{count}} дақиқадан кам'
	  },
	  xMinutes: {
	    one: '1 дақиқа',
	    other: '{{count}} дақиқа'
	  },
	  aboutXHours: {
	    one: 'тахминан 1 соат',
	    other: 'тахминан {{count}} соат'
	  },
	  xHours: {
	    one: '1 соат',
	    other: '{{count}} соат'
	  },
	  xDays: {
	    one: '1 кун',
	    other: '{{count}} кун'
	  },
	  aboutXWeeks: {
	    one: 'тахминан 1 хафта',
	    other: 'тахминан {{count}} хафта'
	  },
	  xWeeks: {
	    one: '1 хафта',
	    other: '{{count}} хафта'
	  },
	  aboutXMonths: {
	    one: 'тахминан 1 ой',
	    other: 'тахминан {{count}} ой'
	  },
	  xMonths: {
	    one: '1 ой',
	    other: '{{count}} ой'
	  },
	  aboutXYears: {
	    one: 'тахминан 1 йил',
	    other: 'тахминан {{count}} йил'
	  },
	  xYears: {
	    one: '1 йил',
	    other: '{{count}} йил'
	  },
	  overXYears: {
	    one: '1 йилдан кўп',
	    other: '{{count}} йилдан кўп'
	  },
	  almostXYears: {
	    one: 'деярли 1 йил',
	    other: 'деярли {{count}} йил'
	  }
	};
	
	function formatDistance(token, count, options) {
	  options = options || {};
	  var result;
	
	  if (typeof formatDistanceLocale[token] === 'string') {
	    result = formatDistanceLocale[token];
	  } else if (count === 1) {
	    result = formatDistanceLocale[token].one;
	  } else {
	    result = formatDistanceLocale[token].other.replace('{{count}}', count);
	  }
	
	  if (options.addSuffix) {
	    if (options.comparison > 0) {
	      return result + 'дан кейин';
	    } else {
	      return result + ' олдин';
	    }
	  }
	
	  return result;
	}
	
	module.exports = exports.default;

/***/ },
/* 1480 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: 'EEEE, do MMMM, y',
	  long: 'do MMMM, y',
	  medium: 'd MMM, y',
	  short: 'dd/MM/yyyy'
	};
	var timeFormats = {
	  full: 'H:mm:ss zzzz',
	  long: 'H:mm:ss z',
	  medium: 'H:mm:ss',
	  short: 'H:mm'
	};
	var dateTimeFormats = {
	  any: '{{date}}, {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'any'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1481 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRelative;
	var formatRelativeLocale = {
	  lastWeek: "'ўтган' eeee p 'да'",
	  yesterday: "'кеча' p 'да'",
	  today: "'бугун' p 'да'",
	  tomorrow: "'эртага' p 'да'",
	  nextWeek: "eeee p 'да'",
	  other: 'P'
	};
	
	function formatRelative(token, _date, _baseDate, _options) {
	  return formatRelativeLocale[token];
	}
	
	module.exports = exports.default;

/***/ },
/* 1482 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eraValues = {
	  narrow: ['М.А', 'М'],
	  abbreviated: ['М.А', 'М'],
	  wide: ['Милоддан Аввалги', 'Милодий']
	};
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['1-чор.', '2-чор.', '3-чор.', '4-чор.'],
	  wide: ['1-чорак', '2-чорак', '3-чорак', '4-чорак']
	};
	var monthValues = {
	  narrow: ['Я', 'Ф', 'М', 'А', 'М', 'И', 'И', 'А', 'С', 'О', 'Н', 'Д'],
	  abbreviated: ['янв', 'фев', 'мар', 'апр', 'май', 'июн', 'июл', 'авг', 'сен', 'окт', 'ноя', 'дек'],
	  wide: ['январ', 'феврал', 'март', 'апрел', 'май', 'июн', 'июл', 'август', 'сентабр', 'октабр', 'ноябр', 'декабр']
	};
	var dayValues = {
	  narrow: ['Я', 'Д', 'С', 'Ч', 'П', 'Ж', 'Ш'],
	  short: ['як', 'ду', 'се', 'чо', 'па', 'жу', 'ша'],
	  abbreviated: ['якш', 'душ', 'сеш', 'чор', 'пай', 'жум', 'шан'],
	  wide: ['якшанба', 'душанба', 'сешанба', 'чоршанба', 'пайшанба', 'жума', 'шанба']
	};
	var dayPeriodValues = {
	  any: {
	    am: 'П.О.',
	    pm: 'П.К.',
	    midnight: 'ярим тун',
	    noon: 'пешин',
	    morning: 'эрталаб',
	    afternoon: 'пешиндан кейин',
	    evening: 'кечаси',
	    night: 'тун'
	  }
	};
	var formattingDayPeriodValues = {
	  any: {
	    am: 'П.О.',
	    pm: 'П.К.',
	    midnight: 'ярим тун',
	    noon: 'пешин',
	    morning: 'эрталаб',
	    afternoon: 'пешиндан кейин',
	    evening: 'кечаси',
	    night: 'тун'
	  }
	};
	
	function ordinalNumber(dirtyNumber, _dirtyOptions) {
	  var number = Number(dirtyNumber);
	  return number;
	}
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'any',
	    formattingValues: formattingDayPeriodValues,
	    defaultFormattingWidth: 'any'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1483 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(15));
	
	var _index2 = _interopRequireDefault(__webpack_require__(14));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(\d+)(чи)?/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^(м\.а|м\.)/i,
	  abbreviated: /^(м\.а|м\.)/i,
	  wide: /^(милоддан аввал|милоддан кейин)/i
	};
	var parseEraPatterns = {
	  any: [/^м/i, /^а/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^[1234]-чор./i,
	  wide: /^[1234]-чорак/i
	};
	var parseQuarterPatterns = {
	  any: [/1/i, /2/i, /3/i, /4/i]
	};
	var matchMonthPatterns = {
	  narrow: /^[яфмамииасонд]/i,
	  abbreviated: /^(янв|фев|мар|апр|май|июн|июл|авг|сен|окт|ноя|дек)/i,
	  wide: /^(январ|феврал|март|апрел|май|июн|июл|август|сентабр|октабр|ноябр|декабр)/i
	};
	var parseMonthPatterns = {
	  narrow: [/^я/i, /^ф/i, /^м/i, /^а/i, /^м/i, /^и/i, /^и/i, /^а/i, /^с/i, /^о/i, /^н/i, /^д/i],
	  any: [/^я/i, /^ф/i, /^мар/i, /^ап/i, /^май/i, /^июн/i, /^июл/i, /^ав/i, /^с/i, /^о/i, /^н/i, /^д/i]
	};
	var matchDayPatterns = {
	  narrow: /^[ядсчпжш]/i,
	  short: /^(як|ду|се|чо|па|жу|ша)/i,
	  abbreviated: /^(якш|душ|сеш|чор|пай|жум|шан)/i,
	  wide: /^(якшанба|душанба|сешанба|чоршанба|пайшанба|жума|шанба)/i
	};
	var parseDayPatterns = {
	  narrow: [/^я/i, /^д/i, /^с/i, /^ч/i, /^п/i, /^ж/i, /^ш/i],
	  any: [/^як/i, /^ду/i, /^се/i, /^чор/i, /^пай/i, /^жу/i, /^шан/i]
	};
	var matchDayPeriodPatterns = {
	  any: /^(п\.о\.|п\.к\.|ярим тун|пешиндан кейин|(эрталаб|пешиндан кейин|кечаси|тун))/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^п\.о\./i,
	    pm: /^п\.к\./i,
	    midnight: /^ярим тун/i,
	    noon: /^пешиндан кейин/i,
	    morning: /эрталаб/i,
	    afternoon: /пешиндан кейин/i,
	    evening: /кечаси/i,
	    night: /тун/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index2.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index2.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index2.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index2.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index2.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1484 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1479));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1480));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1481));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1482));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1483));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Uzbek Cyrillic locale.
	 * @language Uzbek
	 * @iso-639-2 uzb
	 * @author Kamronbek Shodmonov [@kamronbek28]{@link https://github.com/kamronbek28}
	 */
	var locale = {
	  code: 'uz-Cyrl',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 1
	    /* Monday */
	    ,
	    firstWeekContainsDate: 1
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1485 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistance;
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    one: 'sekunddan kam',
	    other: '{{count}} sekunddan kam'
	  },
	  xSeconds: {
	    one: '1 sekund',
	    other: '{{count}} sekund'
	  },
	  halfAMinute: 'yarim minut',
	  lessThanXMinutes: {
	    one: 'bir minutdan kam',
	    other: '{{count}} minutdan kam'
	  },
	  xMinutes: {
	    one: '1 minut',
	    other: '{{count}} minut'
	  },
	  aboutXHours: {
	    one: 'tahminan 1 soat',
	    other: 'tahminan {{count}} soat'
	  },
	  xHours: {
	    one: '1 soat',
	    other: '{{count}} soat'
	  },
	  xDays: {
	    one: '1 kun',
	    other: '{{count}} kun'
	  },
	  aboutXWeeks: {
	    one: 'tahminan 1 hafta',
	    other: 'tahminan {{count}} hafta'
	  },
	  xWeeks: {
	    one: '1 hafta',
	    other: '{{count}} hafta'
	  },
	  aboutXMonths: {
	    one: 'tahminan 1 oy',
	    other: 'tahminan {{count}} oy'
	  },
	  xMonths: {
	    one: '1 oy',
	    other: '{{count}} oy'
	  },
	  aboutXYears: {
	    one: 'tahminan 1 yil',
	    other: 'tahminan {{count}} yil'
	  },
	  xYears: {
	    one: '1 yil',
	    other: '{{count}} yil'
	  },
	  overXYears: {
	    one: "1 yildan ko'p",
	    other: "{{count}} yildan ko'p"
	  },
	  almostXYears: {
	    one: 'deyarli 1 yil',
	    other: 'deyarli {{count}} yil'
	  }
	};
	
	function formatDistance(token, count, options) {
	  options = options || {};
	  var result;
	
	  if (typeof formatDistanceLocale[token] === 'string') {
	    result = formatDistanceLocale[token];
	  } else if (count === 1) {
	    result = formatDistanceLocale[token].one;
	  } else {
	    result = formatDistanceLocale[token].other.replace('{{count}}', count);
	  }
	
	  if (options.addSuffix) {
	    if (options.comparison > 0) {
	      return result + ' dan keyin';
	    } else {
	      return result + ' oldin';
	    }
	  }
	
	  return result;
	}
	
	module.exports = exports.default;

/***/ },
/* 1486 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: 'EEEE, do MMMM, y',
	  long: 'do MMMM, y',
	  medium: 'd MMM, y',
	  short: 'dd/MM/yyyy'
	};
	var timeFormats = {
	  full: 'h:mm:ss zzzz',
	  long: 'h:mm:ss z',
	  medium: 'h:mm:ss',
	  short: 'h:mm'
	};
	var dateTimeFormats = {
	  any: '{{date}}, {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'any'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1487 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRelative;
	var formatRelativeLocale = {
	  lastWeek: "'oldingi' eeee p 'da'",
	  yesterday: "'kecha' p 'da'",
	  today: "'bugun' p 'da'",
	  tomorrow: "'ertaga' p 'da'",
	  nextWeek: "eeee p 'da'",
	  other: 'P'
	};
	
	function formatRelative(token, _date, _baseDate, _options) {
	  return formatRelativeLocale[token];
	}
	
	module.exports = exports.default;

/***/ },
/* 1488 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eraValues = {
	  narrow: ['M.A', 'M.'],
	  abbreviated: ['M.A', 'M.'],
	  wide: ['Miloddan Avvalgi', 'Milodiy']
	};
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['CH.1', 'CH.2', 'CH.3', 'CH.4'],
	  wide: ['1-chi chorak', '2-chi chorak', '3-chi chorak', '4-chi chorak']
	}; // Note: in English, the names of days of the week and months are capitalized.
	// If you are making a new locale based on this one, check if the same is true for the language you're working on.
	// Generally, formatted dates should look like they are in the middle of a sentence,
	// e.g. in Spanish language the weekdays and months should be in the lowercase.
	
	var monthValues = {
	  narrow: ['Y', 'F', 'M', 'A', 'M', 'I', 'I', 'A', 'S', 'O', 'N', 'D'],
	  abbreviated: ['Yan', 'Fev', 'Mar', 'Apr', 'May', 'Iyun', 'Iyul', 'Avg', 'Sen', 'Okt', 'Noy', 'Dek'],
	  wide: ['Yanvar', 'Fevral', 'Mart', 'Aprel', 'May', 'Iyun', 'Iyul', 'Avgust', 'Sentabr', 'Oktabr', 'Noyabr', 'Dekabr']
	};
	var dayValues = {
	  narrow: ['Y', 'D', 'S', 'CH', 'P', 'J', 'SH'],
	  short: ['Ya', 'Du', 'Se', 'Cho', 'Pa', 'Ju', 'Sha'],
	  abbreviated: ['Yak', 'Dush', 'Sesh', 'Chor', 'Pay', 'Jum', 'Shan'],
	  wide: ['Yakshanba', 'Dushanba', 'Seshanba', 'Chorshanba', 'Payshanba', 'Juma', 'Shanba']
	};
	var dayPeriodValues = {
	  narrow: {
	    am: 'a',
	    pm: 'p',
	    midnight: 'y.t',
	    noon: 'p.',
	    morning: 'ertalab',
	    afternoon: 'tushdan keyin',
	    evening: 'kechqurun',
	    night: 'tun'
	  },
	  abbreviated: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'yarim tun',
	    noon: 'peshin',
	    morning: 'ertalab',
	    afternoon: 'tushdan keyin',
	    evening: 'kechqurun',
	    night: 'tun'
	  },
	  wide: {
	    am: 'a.m.',
	    pm: 'p.m.',
	    midnight: 'yarim tun',
	    noon: 'peshin',
	    morning: 'ertalab',
	    afternoon: 'tushdan keyin',
	    evening: 'kechqurun',
	    night: 'tun'
	  }
	};
	var formattingDayPeriodValues = {
	  narrow: {
	    am: 'a',
	    pm: 'p',
	    midnight: 'y.t',
	    noon: 'p.',
	    morning: 'ertalab',
	    afternoon: 'tushdan keyin',
	    evening: 'kechqurun',
	    night: 'tun'
	  },
	  abbreviated: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'yarim tun',
	    noon: 'peshin',
	    morning: 'ertalab',
	    afternoon: 'tushdan keyin',
	    evening: 'kechqurun',
	    night: 'tun'
	  },
	  wide: {
	    am: 'a.m.',
	    pm: 'p.m.',
	    midnight: 'yarim tun',
	    noon: 'peshin',
	    morning: 'ertalab',
	    afternoon: 'tushdan keyin',
	    evening: 'kechqurun',
	    night: 'tun'
	  }
	};
	
	function ordinalNumber(dirtyNumber, _dirtyOptions) {
	  var number = Number(dirtyNumber); // If ordinal numbers depend on context, for example,
	  // if they are different for different grammatical genders,
	  // use `options.unit`:
	  //
	  //   var options = dirtyOptions || {}
	  //   var unit = String(options.unit)
	  //
	  // where `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
	  // 'day', 'hour', 'minute', 'second'
	
	  return number;
	}
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingDayPeriodValues,
	    defaultFormattingWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1489 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(15));
	
	var _index2 = _interopRequireDefault(__webpack_require__(14));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(\d+)(chi)?/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^(m\.a|m\.)/i,
	  abbreviated: /^(m\.a\.?\s?m\.?)/i,
	  wide: /^(miloddan avval|miloddan keyin)/i
	};
	var parseEraPatterns = {
	  any: [/^b/i, /^(a|c)/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^q[1234]/i,
	  wide: /^[1234](chi)? chorak/i
	};
	var parseQuarterPatterns = {
	  any: [/1/i, /2/i, /3/i, /4/i]
	};
	var matchMonthPatterns = {
	  narrow: /^[yfmasond]/i,
	  abbreviated: /^(yan|fev|mar|apr|may|iyun|iyul|avg|sen|okt|noy|dek)/i,
	  wide: /^(yanvar|fevral|mart|aprel|may|iyun|iyul|avgust|sentabr|oktabr|noyabr|dekabr)/i
	};
	var parseMonthPatterns = {
	  narrow: [/^y/i, /^f/i, /^m/i, /^a/i, /^m/i, /^i/i, /^i/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
	  any: [/^ya/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^iyun/i, /^iyul/i, /^av/i, /^s/i, /^o/i, /^n/i, /^d/i]
	};
	var matchDayPatterns = {
	  narrow: /^[ydschj]/i,
	  short: /^(ya|du|se|cho|pa|ju|sha)/i,
	  abbreviated: /^(yak|dush|sesh|chor|pay|jum|shan)/i,
	  wide: /^(yakshanba|dushanba|seshanba|chorshanba|payshanba|juma|shanba)/i
	};
	var parseDayPatterns = {
	  narrow: [/^y/i, /^d/i, /^s/i, /^ch/i, /^p/i, /^j/i, /^sh/i],
	  any: [/^ya/i, /^d/i, /^se/i, /^ch/i, /^p/i, /^j/i, /^sh/i]
	};
	var matchDayPeriodPatterns = {
	  narrow: /^(a|p|y\.t|p| (ertalab|tushdan keyin|kechqurun|tun))/i,
	  any: /^([ap]\.?\s?m\.?|yarim tun|peshin| (ertalab|tushdan keyin|kechqurun|tun))/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^a/i,
	    pm: /^p/i,
	    midnight: /^y\.t/i,
	    noon: /^pe/i,
	    morning: /ertalab/i,
	    afternoon: /tushdan keyin/i,
	    evening: /kechqurun/i,
	    night: /tun/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index2.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index2.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index2.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index2.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index2.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1490 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1485));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1486));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1487));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1488));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1489));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Uzbek locale.
	 * @language Uzbek
	 * @iso-639-2 uzb
	 * @author Mukhammadali [@mukhammadali]{@link https://github.com/Mukhammadali}
	 */
	var locale = {
	  code: 'uz',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 1
	    /* Monday */
	    ,
	    firstWeekContainsDate: 1
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1491 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistance;
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    one: 'dưới 1 giây',
	    other: 'dưới {{count}} giây'
	  },
	  xSeconds: {
	    one: '1 giây',
	    other: '{{count}} giây'
	  },
	  halfAMinute: 'nửa phút',
	  lessThanXMinutes: {
	    one: 'dưới 1 phút',
	    other: 'dưới {{count}} phút'
	  },
	  xMinutes: {
	    one: '1 phút',
	    other: '{{count}} phút'
	  },
	  aboutXHours: {
	    one: 'khoảng 1 giờ',
	    other: 'khoảng {{count}} giờ'
	  },
	  xHours: {
	    one: '1 giờ',
	    other: '{{count}} giờ'
	  },
	  xDays: {
	    one: '1 ngày',
	    other: '{{count}} ngày'
	  },
	  aboutXWeeks: {
	    one: 'khoảng 1 tuần',
	    other: 'khoảng {{count}} tuần'
	  },
	  xWeeks: {
	    one: '1 tuần',
	    other: '{{count}} tuần'
	  },
	  aboutXMonths: {
	    one: 'khoảng 1 tháng',
	    other: 'khoảng {{count}} tháng'
	  },
	  xMonths: {
	    one: '1 tháng',
	    other: '{{count}} tháng'
	  },
	  aboutXYears: {
	    one: 'khoảng 1 năm',
	    other: 'khoảng {{count}} năm'
	  },
	  xYears: {
	    one: '1 năm',
	    other: '{{count}} năm'
	  },
	  overXYears: {
	    one: 'hơn 1 năm',
	    other: 'hơn {{count}} năm'
	  },
	  almostXYears: {
	    one: 'gần 1 năm',
	    other: 'gần {{count}} năm'
	  }
	};
	
	function formatDistance(token, count, options) {
	  options = options || {};
	  var result;
	
	  if (typeof formatDistanceLocale[token] === 'string') {
	    result = formatDistanceLocale[token];
	  } else if (count === 1) {
	    result = formatDistanceLocale[token].one;
	  } else {
	    result = formatDistanceLocale[token].other.replace('{{count}}', count);
	  }
	
	  if (options.addSuffix) {
	    if (options.comparison > 0) {
	      return result + ' nữa';
	    } else {
	      return result + ' trước';
	    }
	  }
	
	  return result;
	}
	
	module.exports = exports.default;

/***/ },
/* 1492 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  // thứ Sáu, ngày 25 tháng 08 năm 2017
	  full: "EEEE, 'ngày' d MMMM 'năm' y",
	  // ngày 25 tháng 08 năm 2017
	  long: "'ngày' d MMMM 'năm' y",
	  // 25 thg 08 năm 2017
	  medium: "d MMM 'năm' y",
	  // 25/08/2017
	  short: 'dd/MM/y'
	};
	var timeFormats = {
	  full: 'HH:mm:ss zzzz',
	  long: 'HH:mm:ss z',
	  medium: 'HH:mm:ss',
	  short: 'HH:mm'
	};
	var dateTimeFormats = {
	  // thứ Sáu, ngày 25 tháng 08 năm 2017 23:25:59
	  full: '{{date}} {{time}}',
	  // ngày 25 tháng 08 năm 2017 23:25
	  long: '{{date}} {{time}}',
	  medium: '{{date}} {{time}}',
	  short: '{{date}} {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1493 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRelative;
	var formatRelativeLocale = {
	  lastWeek: "eeee 'tuần trước vào lúc' p",
	  yesterday: "'hôm qua vào lúc' p",
	  today: "'hôm nay vào lúc' p",
	  tomorrow: "'ngày mai vào lúc' p",
	  nextWeek: "eeee 'tới vào lúc' p",
	  other: 'P'
	};
	
	function formatRelative(token, _date, _baseDate, _options) {
	  return formatRelativeLocale[token];
	}
	
	module.exports = exports.default;

/***/ },
/* 1494 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Vietnamese locale reference: http://www.localeplanet.com/icu/vi-VN/index.html
	// Capitalization reference: http://hcmup.edu.vn/index.php?option=com_content&view=article&id=4106%3Avit-hoa-trong-vn-bn-hanh-chinh&catid=2345%3Atham-kho&Itemid=4103&lang=vi&site=134
	var eraValues = {
	  narrow: ['TCN', 'SCN'],
	  abbreviated: ['trước CN', 'sau CN'],
	  wide: ['trước Công Nguyên', 'sau Công Nguyên']
	};
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
	  wide: ['Quý 1', 'Quý 2', 'Quý 3', 'Quý 4']
	};
	var formattingQuarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
	  // I notice many news outlet use this "quý II/2018"
	  wide: ['quý I', 'quý II', 'quý III', 'quý IV']
	}; // Note: in English, the names of days of the week and months are capitalized.
	// If you are making a new locale based on this one, check if the same is true for the language you're working on.
	// Generally, formatted dates should look like they are in the middle of a sentence,
	// e.g. in Spanish language the weekdays and months should be in the lowercase.
	
	var monthValues = {
	  narrow: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
	  abbreviated: ['Thg 1', 'Thg 2', 'Thg 3', 'Thg 4', 'Thg 5', 'Thg 6', 'Thg 7', 'Thg 8', 'Thg 9', 'Thg 10', 'Thg 11', 'Thg 12'],
	  wide: ['Tháng Một', 'Tháng Hai', 'Tháng Ba', 'Tháng Tư', 'Tháng Năm', 'Tháng Sáu', 'Tháng Bảy', 'Tháng Tám', 'Tháng Chín', 'Tháng Mười', 'Tháng Mười Một', 'Tháng Mười Hai']
	}; // In Vietnamese date formatting, month number less than 10 expected to have leading zero
	
	var formattingMonthValues = {
	  narrow: ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'],
	  abbreviated: ['thg 1', 'thg 2', 'thg 3', 'thg 4', 'thg 5', 'thg 6', 'thg 7', 'thg 8', 'thg 9', 'thg 10', 'thg 11', 'thg 12'],
	  wide: ['tháng 01', 'tháng 02', 'tháng 03', 'tháng 04', 'tháng 05', 'tháng 06', 'tháng 07', 'tháng 08', 'tháng 09', 'tháng 10', 'tháng 11', 'tháng 12']
	};
	var dayValues = {
	  narrow: ['CN', 'T2', 'T3', 'T4', 'T5', 'T6', 'T7'],
	  short: ['CN', 'Th 2', 'Th 3', 'Th 4', 'Th 5', 'Th 6', 'Th 7'],
	  abbreviated: ['CN', 'Thứ 2', 'Thứ 3', 'Thứ 4', 'Thứ 5', 'Thứ 6', 'Thứ 7'],
	  wide: ['Chủ Nhật', 'Thứ Hai', 'Thứ Ba', 'Thứ Tư', 'Thứ Năm', 'Thứ Sáu', 'Thứ Bảy']
	}; // Vietnamese are used to AM/PM borrowing from English, hence `narrow` and
	// `abbreviated` are just like English but I'm leaving the `wide`
	// format being localized with abbreviations found in some systems (SÁng / CHiều);
	// however, personally, I don't think `Chiều` sounds appropriate for `PM`
	
	var dayPeriodValues = {
	  // narrow date period is extremely rare in Vietnamese
	  // I used abbreviated form for noon, morning and afternoon
	  // which are regconizable by Vietnamese, others cannot be any shorter
	  narrow: {
	    am: 'am',
	    pm: 'pm',
	    midnight: 'nửa đêm',
	    noon: 'tr',
	    morning: 'sg',
	    afternoon: 'ch',
	    evening: 'tối',
	    night: 'đêm'
	  },
	  abbreviated: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'nửa đêm',
	    noon: 'trưa',
	    morning: 'sáng',
	    afternoon: 'chiều',
	    evening: 'tối',
	    night: 'đêm'
	  },
	  wide: {
	    am: 'SA',
	    pm: 'CH',
	    midnight: 'nửa đêm',
	    noon: 'trưa',
	    morning: 'sáng',
	    afternoon: 'chiều',
	    evening: 'tối',
	    night: 'đêm'
	  }
	};
	var formattingDayPeriodValues = {
	  narrow: {
	    am: 'am',
	    pm: 'pm',
	    midnight: 'nửa đêm',
	    noon: 'tr',
	    morning: 'sg',
	    afternoon: 'ch',
	    evening: 'tối',
	    night: 'đêm'
	  },
	  abbreviated: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'nửa đêm',
	    noon: 'trưa',
	    morning: 'sáng',
	    afternoon: 'chiều',
	    evening: 'tối',
	    night: 'đêm'
	  },
	  wide: {
	    am: 'SA',
	    pm: 'CH',
	    midnight: 'nửa đêm',
	    noon: 'giữa trưa',
	    morning: 'vào buổi sáng',
	    afternoon: 'vào buổi chiều',
	    evening: 'vào buổi tối',
	    night: 'vào ban đêm'
	  }
	}; // If ordinal numbers depend on context, for example,
	// if they are different for different grammatical genders,
	// use `options.unit`:
	//
	//   var options = dirtyOptions || {}
	//   var unit = String(options.unit)
	//
	// where `unit` can be 'month', 'quarter', 'week', 'isoWeek', 'dayOfYear',
	// 'dayOfMonth' or 'dayOfWeek'
	
	function ordinalNumber(dirtyNumber, dirtyOptions) {
	  var options = dirtyOptions || {};
	  var unit = String(options.unit);
	  var number = parseInt(dirtyNumber, 10);
	
	  if (unit === 'quarter') {
	    // many news outlets use "quý I"...
	    switch (number) {
	      case 1:
	        return 'I';
	
	      case 2:
	        return 'II';
	
	      case 3:
	        return 'III';
	
	      case 4:
	        return 'IV';
	    }
	  } else if (unit === 'day') {
	    // day of week in Vietnamese has ordinal number meaning,
	    // so we should use them, else it'll sound weird
	    switch (number) {
	      case 1:
	        return 'thứ 2';
	      // meaning 2nd day but it's the first day of the week :D
	
	      case 2:
	        return 'thứ 3';
	      // meaning 3rd day
	
	      case 3:
	        return 'thứ 4';
	      // meaning 4th day and so on
	
	      case 4:
	        return 'thứ 5';
	
	      case 5:
	        return 'thứ 6';
	
	      case 6:
	        return 'thứ 7';
	
	      case 7:
	        return 'chủ nhật';
	      // meaning Sunday, there's no 8th day :D
	    }
	  } else if (unit === 'week') {
	    if (number === 1) {
	      return 'thứ nhất';
	    } else {
	      return 'thứ ' + number;
	    }
	  } else if (unit === 'dayOfYear') {
	    if (number === 1) {
	      return 'đầu tiên';
	    } else {
	      return 'thứ ' + number;
	    }
	  } // there are no different forms of ordinal numbers in Vietnamese
	
	
	  return number;
	}
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingQuarterValues,
	    defaultFormattingWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingMonthValues,
	    defaultFormattingWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingDayPeriodValues,
	    defaultFormattingWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1495 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(15));
	
	var _index2 = _interopRequireDefault(__webpack_require__(14));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(\d+)/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^(tcn|scn)/i,
	  abbreviated: /^(trước CN|sau CN)/i,
	  wide: /^(trước Công Nguyên|sau Công Nguyên)/i
	};
	var parseEraPatterns = {
	  any: [/^t/i, /^s/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^([1234]|i{1,3}v?)/i,
	  abbreviated: /^q([1234]|i{1,3}v?)/i,
	  wide: /^quý ([1234]|i{1,3}v?)/i
	};
	var parseQuarterPatterns = {
	  any: [/(1|i)$/i, /(2|ii)$/i, /(3|iii)$/i, /(4|iv)$/i]
	};
	var matchMonthPatterns = {
	  // month number may contain leading 0, 'thg' prefix may have space, underscore or empty before number
	  // note the order of '1' since it is a sub-string of '10', so must be lower priority
	  narrow: /^(0?[2-9]|10|11|12|0?1)/i,
	  // note the order of 'thg 1' since it is sub-string of 'thg 10', so must be lower priority
	  abbreviated: /^thg[ _]?(0?[1-9](?!\d)|10|11|12)/i,
	  // note the order of 'Mười' since it is sub-string of Mười Một, so must be lower priority
	  wide: /^tháng ?(Một|Hai|Ba|Tư|Năm|Sáu|Bảy|Tám|Chín|Mười|Mười ?Một|Mười ?Hai|0?[1-9](?!\d)|10|11|12)/i
	};
	var parseMonthPatterns = {
	  narrow: [/0?1$/i, /0?2/i, /3/, /4/, /5/, /6/, /7/, /8/, /9/, /10/, /11/, /12/],
	  abbreviated: [/^thg[ _]?0?1(?!\d)/i, /^thg[ _]?0?2/i, /^thg[ _]?0?3/i, /^thg[ _]?0?4/i, /^thg[ _]?0?5/i, /^thg[ _]?0?6/i, /^thg[ _]?0?7/i, /^thg[ _]?0?8/i, /^thg[ _]?0?9/i, /^thg[ _]?10/i, /^thg[ _]?11/i, /^thg[ _]?12/i],
	  wide: [/^tháng ?(Một|0?1(?!\d))/i, /^tháng ?(Hai|0?2)/i, /^tháng ?(Ba|0?3)/i, /^tháng ?(Tư|0?4)/i, /^tháng ?(Năm|0?5)/i, /^tháng ?(Sáu|0?6)/i, /^tháng ?(Bảy|0?7)/i, /^tháng ?(Tám|0?8)/i, /^tháng ?(Chín|0?9)/i, /^tháng ?(Mười|10)/i, /^tháng ?(Mười ?Một|11)/i, /^tháng ?(Mười ?Hai|12)/i]
	};
	var matchDayPatterns = {
	  narrow: /^(CN|T2|T3|T4|T5|T6|T7)/i,
	  short: /^(CN|Th ?2|Th ?3|Th ?4|Th ?5|Th ?6|Th ?7)/i,
	  abbreviated: /^(CN|Th ?2|Th ?3|Th ?4|Th ?5|Th ?6|Th ?7)/i,
	  wide: /^(Chủ ?Nhật|Chúa ?Nhật|thứ ?Hai|thứ ?Ba|thứ ?Tư|thứ ?Năm|thứ ?Sáu|thứ ?Bảy)/i
	};
	var parseDayPatterns = {
	  narrow: [/CN/i, /2/i, /3/i, /4/i, /5/i, /6/i, /7/i],
	  short: [/CN/i, /2/i, /3/i, /4/i, /5/i, /6/i, /7/i],
	  abbreviated: [/CN/i, /2/i, /3/i, /4/i, /5/i, /6/i, /7/i],
	  wide: [/(Chủ|Chúa) ?Nhật/i, /Hai/i, /Ba/i, /Tư/i, /Năm/i, /Sáu/i, /Bảy/i]
	};
	var matchDayPeriodPatterns = {
	  narrow: /^(a|p|nửa đêm|trưa|(giờ) (sáng|chiều|tối|đêm))/i,
	  abbreviated: /^(am|pm|nửa đêm|trưa|(giờ) (sáng|chiều|tối|đêm))/i,
	  wide: /^(ch[^i]*|sa|nửa đêm|trưa|(giờ) (sáng|chiều|tối|đêm))/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^(a|sa)/i,
	    pm: /^(p|ch[^i]*)/i,
	    midnight: /nửa đêm/i,
	    noon: /trưa/i,
	    morning: /sáng/i,
	    afternoon: /chiều/i,
	    evening: /tối/i,
	    night: /^đêm/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index2.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index2.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index2.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index2.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index2.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1496 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1491));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1492));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1493));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1494));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1495));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Vietnamese locale (Vietnam).
	 * @language Vietnamese
	 * @iso-639-2 vie
	 * @author Thanh Tran [@trongthanh]{@link https://github.com/trongthanh}
	 * @author Leroy Hopson [@lihop]{@link https://github.com/lihop}
	 */
	var locale = {
	  code: 'vi',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 1
	    /* Monday */
	    ,
	    firstWeekContainsDate: 1
	    /* First week of new year contains Jan 1st  */
	
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1497 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistance;
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    one: '不到 1 秒',
	    other: '不到 {{count}} 秒'
	  },
	  xSeconds: {
	    one: '1 秒',
	    other: '{{count}} 秒'
	  },
	  halfAMinute: '半分钟',
	  lessThanXMinutes: {
	    one: '不到 1 分钟',
	    other: '不到 {{count}} 分钟'
	  },
	  xMinutes: {
	    one: '1 分钟',
	    other: '{{count}} 分钟'
	  },
	  xHours: {
	    one: '1 小时',
	    other: '{{count}} 小时'
	  },
	  aboutXHours: {
	    one: '大约 1 小时',
	    other: '大约 {{count}} 小时'
	  },
	  xDays: {
	    one: '1 天',
	    other: '{{count}} 天'
	  },
	  aboutXWeeks: {
	    one: '大约 1 个星期',
	    other: '大约 {{count}} 个星期'
	  },
	  xWeeks: {
	    one: '1 个星期',
	    other: '{{count}} 个星期'
	  },
	  aboutXMonths: {
	    one: '大约 1 个月',
	    other: '大约 {{count}} 个月'
	  },
	  xMonths: {
	    one: '1 个月',
	    other: '{{count}} 个月'
	  },
	  aboutXYears: {
	    one: '大约 1 年',
	    other: '大约 {{count}} 年'
	  },
	  xYears: {
	    one: '1 年',
	    other: '{{count}} 年'
	  },
	  overXYears: {
	    one: '超过 1 年',
	    other: '超过 {{count}} 年'
	  },
	  almostXYears: {
	    one: '将近 1 年',
	    other: '将近 {{count}} 年'
	  }
	};
	
	function formatDistance(token, count, options) {
	  options = options || {};
	  var result;
	
	  if (typeof formatDistanceLocale[token] === 'string') {
	    result = formatDistanceLocale[token];
	  } else if (count === 1) {
	    result = formatDistanceLocale[token].one;
	  } else {
	    result = formatDistanceLocale[token].other.replace('{{count}}', count);
	  }
	
	  if (options.addSuffix) {
	    if (options.comparison > 0) {
	      return result + '内';
	    } else {
	      return result + '前';
	    }
	  }
	
	  return result;
	}
	
	module.exports = exports.default;

/***/ },
/* 1498 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: "y'年'M'月'd'日' EEEE",
	  long: "y'年'M'月'd'日'",
	  medium: 'yyyy-MM-dd',
	  short: 'yy-MM-dd'
	};
	var timeFormats = {
	  full: 'zzzz a h:mm:ss',
	  long: 'z a h:mm:ss',
	  medium: 'a h:mm:ss',
	  short: 'a h:mm'
	};
	var dateTimeFormats = {
	  full: '{{date}} {{time}}',
	  long: '{{date}} {{time}}',
	  medium: '{{date}} {{time}}',
	  short: '{{date}} {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1499 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRelative;
	
	var _index = _interopRequireDefault(__webpack_require__(71));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function checkWeek(_date, _baseDate, _options, baseFormat) {
	  if ((0, _index.default)(_date, _baseDate, _options)) {
	    return baseFormat; // in same week
	  } else if (_date.getTime() > _baseDate.getTime()) {
	    return "'下个'" + baseFormat; // in next week
	  }
	
	  return "'上个'" + baseFormat; // in last week
	}
	
	var formatRelativeLocale = {
	  lastWeek: checkWeek,
	  // days before yesterday, maybe in this week or last week
	  yesterday: "'昨天' p",
	  today: "'今天' p",
	  tomorrow: "'明天' p",
	  nextWeek: checkWeek,
	  // days after tomorrow, maybe in this week or next week
	  other: 'PP p'
	};
	
	function formatRelative(token, _date, _baseDate, _options) {
	  var format = formatRelativeLocale[token];
	
	  if (typeof format === 'function') {
	    return format(_date, _baseDate, _options, 'eeee p');
	  }
	
	  return format;
	}
	
	module.exports = exports.default;

/***/ },
/* 1500 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eraValues = {
	  narrow: ['前', '公元'],
	  abbreviated: ['前', '公元'],
	  wide: ['公元前', '公元']
	};
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['第一季', '第二季', '第三季', '第四季'],
	  wide: ['第一季度', '第二季度', '第三季度', '第四季度']
	};
	var monthValues = {
	  narrow: ['一', '二', '三', '四', '五', '六', '七', '八', '九', '十', '十一', '十二'],
	  abbreviated: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
	  wide: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月']
	};
	var dayValues = {
	  narrow: ['日', '一', '二', '三', '四', '五', '六'],
	  short: ['日', '一', '二', '三', '四', '五', '六'],
	  abbreviated: ['周日', '周一', '周二', '周三', '周四', '周五', '周六'],
	  wide: ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六']
	};
	var dayPeriodValues = {
	  narrow: {
	    am: '上',
	    pm: '下',
	    midnight: '凌晨',
	    noon: '午',
	    morning: '早',
	    afternoon: '下午',
	    evening: '晚',
	    night: '夜'
	  },
	  abbreviated: {
	    am: '上午',
	    pm: '下午',
	    midnight: '凌晨',
	    noon: '中午',
	    morning: '早晨',
	    afternoon: '中午',
	    evening: '晚上',
	    night: '夜间'
	  },
	  wide: {
	    am: '上午',
	    pm: '下午',
	    midnight: '凌晨',
	    noon: '中午',
	    morning: '早晨',
	    afternoon: '中午',
	    evening: '晚上',
	    night: '夜间'
	  }
	};
	var formattingDayPeriodValues = {
	  narrow: {
	    am: '上',
	    pm: '下',
	    midnight: '凌晨',
	    noon: '午',
	    morning: '早',
	    afternoon: '下午',
	    evening: '晚',
	    night: '夜'
	  },
	  abbreviated: {
	    am: '上午',
	    pm: '下午',
	    midnight: '凌晨',
	    noon: '中午',
	    morning: '早晨',
	    afternoon: '中午',
	    evening: '晚上',
	    night: '夜间'
	  },
	  wide: {
	    am: '上午',
	    pm: '下午',
	    midnight: '凌晨',
	    noon: '中午',
	    morning: '早晨',
	    afternoon: '中午',
	    evening: '晚上',
	    night: '夜间'
	  }
	};
	
	function ordinalNumber(dirtyNumber, dirtyOptions) {
	  // If ordinal numbers depend on context, for example,
	  // if they are different for different grammatical genders,
	  // use `options.unit`:
	  //
	  //   var options = dirtyOptions || {}
	  //   var unit = String(options.unit)
	  //
	  // where `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
	  // 'day', 'hour', 'minute', 'second'
	  var number = Number(dirtyNumber);
	  var options = dirtyOptions || {};
	  var unit = String(options.unit);
	
	  switch (unit) {
	    case 'date':
	      return number.toString() + '日';
	
	    case 'hour':
	      return number.toString() + '时';
	
	    case 'minute':
	      return number.toString() + '分';
	
	    case 'second':
	      return number.toString() + '秒';
	
	    default:
	      return '第 ' + number.toString();
	  }
	}
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingDayPeriodValues,
	    defaultFormattingWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1501 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(15));
	
	var _index2 = _interopRequireDefault(__webpack_require__(14));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(第\s*)?\d+(日|时|分|秒)?/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^(前)/i,
	  abbreviated: /^(前)/i,
	  wide: /^(公元前|公元)/i
	};
	var parseEraPatterns = {
	  any: [/^(前)/i, /^(公元)/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^第[一二三四]刻/i,
	  wide: /^第[一二三四]刻钟/i
	};
	var parseQuarterPatterns = {
	  any: [/(1|一)/i, /(2|二)/i, /(3|三)/i, /(4|四)/i]
	};
	var matchMonthPatterns = {
	  narrow: /^(一|二|三|四|五|六|七|八|九|十[二一])/i,
	  abbreviated: /^(一|二|三|四|五|六|七|八|九|十[二一]|\d|1[12])月/i,
	  wide: /^(一|二|三|四|五|六|七|八|九|十[二一])月/i
	};
	var parseMonthPatterns = {
	  narrow: [/^一/i, /^二/i, /^三/i, /^四/i, /^五/i, /^六/i, /^七/i, /^八/i, /^九/i, /^十(?!(一|二))/i, /^十一/i, /^十二/i],
	  any: [/^一|1/i, /^二|2/i, /^三|3/i, /^四|4/i, /^五|5/i, /^六|6/i, /^七|7/i, /^八|8/i, /^九|9/i, /^十(?!(一|二))|10/i, /^十一|11/i, /^十二|12/i]
	};
	var matchDayPatterns = {
	  narrow: /^[一二三四五六日]/i,
	  short: /^[一二三四五六日]/i,
	  abbreviated: /^周[一二三四五六日]/i,
	  wide: /^星期[一二三四五六日]/i
	};
	var parseDayPatterns = {
	  any: [/日/i, /一/i, /二/i, /三/i, /四/i, /五/i, /六/i]
	};
	var matchDayPeriodPatterns = {
	  any: /^(上午?|下午?|午夜|[中正]午|早上?|下午|晚上?|凌晨|)/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^上午?/i,
	    pm: /^下午?/i,
	    midnight: /^午夜/i,
	    noon: /^[中正]午/i,
	    morning: /^早上/i,
	    afternoon: /^下午/i,
	    evening: /^晚上?/i,
	    night: /^凌晨/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index2.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index2.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index2.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index2.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index2.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1502 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1497));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1498));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1499));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1500));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1501));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Chinese Simplified locale.
	 * @language Chinese Simplified
	 * @iso-639-2 zho
	 * @author Changyu Geng [@KingMario]{@link https://github.com/KingMario}
	 * @author Song Shuoyun [@fnlctrl]{@link https://github.com/fnlctrl}
	 * @author sabrinaM [@sabrinamiao]{@link https://github.com/sabrinamiao}
	 * @author Carney Wu [@cubicwork]{@link https://github.com/cubicwork}
	 * @author Terrence Lam [@skyuplam]{@link https://github.com/skyuplam}
	 */
	var locale = {
	  code: 'zh-CN',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 1
	    /* Monday */
	    ,
	    firstWeekContainsDate: 4
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1503 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistance;
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    one: '少於 1 秒',
	    other: '少於 {{count}} 秒'
	  },
	  xSeconds: {
	    one: '1 秒',
	    other: '{{count}} 秒'
	  },
	  halfAMinute: '半分鐘',
	  lessThanXMinutes: {
	    one: '少於 1 分鐘',
	    other: '少於 {{count}} 分鐘'
	  },
	  xMinutes: {
	    one: '1 分鐘',
	    other: '{{count}} 分鐘'
	  },
	  xHours: {
	    one: '1 小時',
	    other: '{{count}} 小時'
	  },
	  aboutXHours: {
	    one: '大約 1 小時',
	    other: '大約 {{count}} 小時'
	  },
	  xDays: {
	    one: '1 天',
	    other: '{{count}} 天'
	  },
	  aboutXWeeks: {
	    one: '大約 1 個星期',
	    other: '大約 {{count}} 個星期'
	  },
	  xWeeks: {
	    one: '1 個星期',
	    other: '{{count}} 個星期'
	  },
	  aboutXMonths: {
	    one: '大約 1 個月',
	    other: '大約 {{count}} 個月'
	  },
	  xMonths: {
	    one: '1 個月',
	    other: '{{count}} 個月'
	  },
	  aboutXYears: {
	    one: '大約 1 年',
	    other: '大約 {{count}} 年'
	  },
	  xYears: {
	    one: '1 年',
	    other: '{{count}} 年'
	  },
	  overXYears: {
	    one: '超過 1 年',
	    other: '超過 {{count}} 年'
	  },
	  almostXYears: {
	    one: '將近 1 年',
	    other: '將近 {{count}} 年'
	  }
	};
	
	function formatDistance(token, count, options) {
	  options = options || {};
	  var result;
	
	  if (typeof formatDistanceLocale[token] === 'string') {
	    result = formatDistanceLocale[token];
	  } else if (count === 1) {
	    result = formatDistanceLocale[token].one;
	  } else {
	    result = formatDistanceLocale[token].other.replace('{{count}}', count);
	  }
	
	  if (options.addSuffix) {
	    if (options.comparison > 0) {
	      return result + '內';
	    } else {
	      return result + '前';
	    }
	  }
	
	  return result;
	}
	
	module.exports = exports.default;

/***/ },
/* 1504 */
1498,
/* 1505 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRelative;
	var formatRelativeLocale = {
	  lastWeek: "'上個'eeee p",
	  yesterday: "'昨天' p",
	  today: "'今天' p",
	  tomorrow: "'明天' p",
	  nextWeek: "'下個'eeee p",
	  other: 'P'
	};
	
	function formatRelative(token, _date, _baseDate, _options) {
	  return formatRelativeLocale[token];
	}
	
	module.exports = exports.default;

/***/ },
/* 1506 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eraValues = {
	  narrow: ['前', '公元'],
	  abbreviated: ['前', '公元'],
	  wide: ['公元前', '公元']
	};
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['第一季', '第二季', '第三季', '第四季'],
	  wide: ['第一季度', '第二季度', '第三季度', '第四季度']
	};
	var monthValues = {
	  narrow: ['一', '二', '三', '四', '五', '六', '七', '八', '九', '十', '十一', '十二'],
	  abbreviated: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
	  wide: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月']
	};
	var dayValues = {
	  narrow: ['日', '一', '二', '三', '四', '五', '六'],
	  short: ['日', '一', '二', '三', '四', '五', '六'],
	  abbreviated: ['週日', '週一', '週二', '週三', '週四', '週五', '週六'],
	  wide: ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六']
	};
	var dayPeriodValues = {
	  narrow: {
	    am: '上',
	    pm: '下',
	    midnight: '午夜',
	    noon: '晌',
	    morning: '早',
	    afternoon: '午',
	    evening: '晚',
	    night: '夜'
	  },
	  abbreviated: {
	    am: '上午',
	    pm: '下午',
	    midnight: '午夜',
	    noon: '中午',
	    morning: '上午',
	    afternoon: '下午',
	    evening: '晚上',
	    night: '夜晚'
	  },
	  wide: {
	    am: '上午',
	    pm: '下午',
	    midnight: '午夜',
	    noon: '中午',
	    morning: '上午',
	    afternoon: '下午',
	    evening: '晚上',
	    night: '夜晚'
	  }
	};
	var formattingDayPeriodValues = {
	  narrow: {
	    am: '上',
	    pm: '下',
	    midnight: '午夜',
	    noon: '晌',
	    morning: '早',
	    afternoon: '午',
	    evening: '晚',
	    night: '夜'
	  },
	  abbreviated: {
	    am: '上午',
	    pm: '下午',
	    midnight: '午夜',
	    noon: '中午',
	    morning: '上午',
	    afternoon: '下午',
	    evening: '晚上',
	    night: '夜晚'
	  },
	  wide: {
	    am: '上午',
	    pm: '下午',
	    midnight: '午夜',
	    noon: '中午',
	    morning: '上午',
	    afternoon: '下午',
	    evening: '晚上',
	    night: '夜晚'
	  }
	};
	
	function ordinalNumber(dirtyNumber, dirtyOptions) {
	  var number = Number(dirtyNumber); // If ordinal numbers depend on context, for example,
	  // if they are different for different grammatical genders,
	  // use `options.unit`:
	  //
	  //   var options = dirtyOptions || {}
	  //   var unit = String(options.unit)
	  //
	  // where `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
	  // 'day', 'hour', 'minute', 'second'
	
	  var options = dirtyOptions || {};
	  var unit = String(options.unit);
	
	  switch (unit) {
	    case 'date':
	      return number.toString() + '日';
	
	    case 'hour':
	      return number.toString() + '時';
	
	    case 'minute':
	      return number.toString() + '分';
	
	    case 'second':
	      return number.toString() + '秒';
	
	    default:
	      return '第 ' + number.toString();
	  }
	}
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingDayPeriodValues,
	    defaultFormattingWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1507 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(15));
	
	var _index2 = _interopRequireDefault(__webpack_require__(14));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(第\s*)?\d+(日|時|分|秒)?/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^(前)/i,
	  abbreviated: /^(前)/i,
	  wide: /^(公元前|公元)/i
	};
	var parseEraPatterns = {
	  any: [/^(前)/i, /^(公元)/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^第[一二三四]季/i,
	  wide: /^第[一二三四]季度/i
	};
	var parseQuarterPatterns = {
	  any: [/(1|一)/i, /(2|二)/i, /(3|三)/i, /(4|四)/i]
	};
	var matchMonthPatterns = {
	  narrow: /^(一|二|三|四|五|六|七|八|九|十[二一])/i,
	  abbreviated: /^(一|二|三|四|五|六|七|八|九|十[二一]|\d|1[12])月/i,
	  wide: /^(一|二|三|四|五|六|七|八|九|十[二一])月/i
	};
	var parseMonthPatterns = {
	  narrow: [/^一/i, /^二/i, /^三/i, /^四/i, /^五/i, /^六/i, /^七/i, /^八/i, /^九/i, /^十(?!(一|二))/i, /^十一/i, /^十二/i],
	  any: [/^一|1/i, /^二|2/i, /^三|3/i, /^四|4/i, /^五|5/i, /^六|6/i, /^七|7/i, /^八|8/i, /^九|9/i, /^十(?!(一|二))|10/i, /^十一|11/i, /^十二|12/i]
	};
	var matchDayPatterns = {
	  narrow: /^[一二三四五六日]/i,
	  short: /^[一二三四五六日]/i,
	  abbreviated: /^週[一二三四五六日]/i,
	  wide: /^星期[一二三四五六日]/i
	};
	var parseDayPatterns = {
	  any: [/日/i, /一/i, /二/i, /三/i, /四/i, /五/i, /六/i]
	};
	var matchDayPeriodPatterns = {
	  any: /^(上午?|下午?|午夜|[中正]午|早上?|下午|晚上?|凌晨)/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^上午?/i,
	    pm: /^下午?/i,
	    midnight: /^午夜/i,
	    noon: /^[中正]午/i,
	    morning: /^早上/i,
	    afternoon: /^下午/i,
	    evening: /^晚上?/i,
	    night: /^凌晨/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index2.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index2.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index2.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index2.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index2.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1508 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1503));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1504));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1505));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1506));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1507));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Chinese Traditional locale.
	 * @language Chinese Traditional
	 * @iso-639-2 zho
	 * @author Gary Ip [@gaplo]{@link https://github.com/gaplo}
	 */
	var locale = {
	  code: 'zh-HK',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 0
	    /* Sunday */
	    ,
	    firstWeekContainsDate: 1
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1509 */
1503,
/* 1510 */
1498,
/* 1511 */
1505,
/* 1512 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eraValues = {
	  narrow: ['前', '公元'],
	  abbreviated: ['前', '公元'],
	  wide: ['公元前', '公元']
	};
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['第一刻', '第二刻', '第三刻', '第四刻'],
	  wide: ['第一刻鐘', '第二刻鐘', '第三刻鐘', '第四刻鐘']
	};
	var monthValues = {
	  narrow: ['一', '二', '三', '四', '五', '六', '七', '八', '九', '十', '十一', '十二'],
	  abbreviated: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
	  wide: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月']
	};
	var dayValues = {
	  narrow: ['日', '一', '二', '三', '四', '五', '六'],
	  short: ['日', '一', '二', '三', '四', '五', '六'],
	  abbreviated: ['週日', '週一', '週二', '週三', '週四', '週五', '週六'],
	  wide: ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六']
	};
	var dayPeriodValues = {
	  narrow: {
	    am: '上',
	    pm: '下',
	    midnight: '凌晨',
	    noon: '午',
	    morning: '早',
	    afternoon: '下午',
	    evening: '晚',
	    night: '夜'
	  },
	  abbreviated: {
	    am: '上午',
	    pm: '下午',
	    midnight: '凌晨',
	    noon: '中午',
	    morning: '早晨',
	    afternoon: '中午',
	    evening: '晚上',
	    night: '夜間'
	  },
	  wide: {
	    am: '上午',
	    pm: '下午',
	    midnight: '凌晨',
	    noon: '中午',
	    morning: '早晨',
	    afternoon: '中午',
	    evening: '晚上',
	    night: '夜間'
	  }
	};
	var formattingDayPeriodValues = {
	  narrow: {
	    am: '上',
	    pm: '下',
	    midnight: '凌晨',
	    noon: '午',
	    morning: '早',
	    afternoon: '下午',
	    evening: '晚',
	    night: '夜'
	  },
	  abbreviated: {
	    am: '上午',
	    pm: '下午',
	    midnight: '凌晨',
	    noon: '中午',
	    morning: '早晨',
	    afternoon: '中午',
	    evening: '晚上',
	    night: '夜間'
	  },
	  wide: {
	    am: '上午',
	    pm: '下午',
	    midnight: '凌晨',
	    noon: '中午',
	    morning: '早晨',
	    afternoon: '中午',
	    evening: '晚上',
	    night: '夜間'
	  }
	};
	
	function ordinalNumber(dirtyNumber, dirtyOptions) {
	  var number = Number(dirtyNumber); // If ordinal numbers depend on context, for example,
	  // if they are different for different grammatical genders,
	  // use `options.unit`:
	  //
	  //   var options = dirtyOptions || {}
	  //   var unit = String(options.unit)
	  //
	  // where `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
	  // 'day', 'hour', 'minute', 'second'
	
	  var options = dirtyOptions || {};
	  var unit = String(options.unit);
	
	  switch (unit) {
	    case 'date':
	      return number.toString() + '日';
	
	    case 'hour':
	      return number.toString() + '時';
	
	    case 'minute':
	      return number.toString() + '分';
	
	    case 'second':
	      return number.toString() + '秒';
	
	    default:
	      return '第 ' + number.toString();
	  }
	}
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingDayPeriodValues,
	    defaultFormattingWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1513 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(15));
	
	var _index2 = _interopRequireDefault(__webpack_require__(14));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(第\s*)?\d+(日|時|分|秒)?/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^(前)/i,
	  abbreviated: /^(前)/i,
	  wide: /^(公元前|公元)/i
	};
	var parseEraPatterns = {
	  any: [/^(前)/i, /^(公元)/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^第[一二三四]刻/i,
	  wide: /^第[一二三四]刻鐘/i
	};
	var parseQuarterPatterns = {
	  any: [/(1|一)/i, /(2|二)/i, /(3|三)/i, /(4|四)/i]
	};
	var matchMonthPatterns = {
	  narrow: /^(一|二|三|四|五|六|七|八|九|十[二一])/i,
	  abbreviated: /^(一|二|三|四|五|六|七|八|九|十[二一]|\d|1[12])月/i,
	  wide: /^(一|二|三|四|五|六|七|八|九|十[二一])月/i
	};
	var parseMonthPatterns = {
	  narrow: [/^一/i, /^二/i, /^三/i, /^四/i, /^五/i, /^六/i, /^七/i, /^八/i, /^九/i, /^十(?!(一|二))/i, /^十一/i, /^十二/i],
	  any: [/^一|1/i, /^二|2/i, /^三|3/i, /^四|4/i, /^五|5/i, /^六|6/i, /^七|7/i, /^八|8/i, /^九|9/i, /^十(?!(一|二))|10/i, /^十一|11/i, /^十二|12/i]
	};
	var matchDayPatterns = {
	  narrow: /^[一二三四五六日]/i,
	  short: /^[一二三四五六日]/i,
	  abbreviated: /^週[一二三四五六日]/i,
	  wide: /^星期[一二三四五六日]/i
	};
	var parseDayPatterns = {
	  any: [/日/i, /一/i, /二/i, /三/i, /四/i, /五/i, /六/i]
	};
	var matchDayPeriodPatterns = {
	  any: /^(上午?|下午?|午夜|[中正]午|早上?|下午|晚上?|凌晨)/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^上午?/i,
	    pm: /^下午?/i,
	    midnight: /^午夜/i,
	    noon: /^[中正]午/i,
	    morning: /^早上/i,
	    afternoon: /^下午/i,
	    evening: /^晚上?/i,
	    night: /^凌晨/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index2.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index2.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index2.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index2.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index2.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1514 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1509));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1510));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1511));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1512));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1513));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Chinese Traditional locale.
	 * @language Chinese Traditional
	 * @iso-639-2 zho
	 * @author tonypai [@tpai]{@link https://github.com/tpai}
	 * @author Jack Hsu [@jackhsu978]{@link https://github.com/jackhsu978}
	 * @author Terrence Lam [@skyuplam]{@link https://github.com/skyuplam}
	 */
	var locale = {
	  code: 'zh-TW',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 1
	    /* Monday */
	    ,
	    firstWeekContainsDate: 4
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1515 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = milliseconds;
	
	var _index = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Leap year occures every 4 years, except for years that are divisable by 100 and not divisable by 400.
	// 1 mean year = (365+1/4-1/100+1/400) days = 365.2425 days
	var daysInYear = 365.2425;
	/**
	 * @name milliseconds
	 * @category Millisecond Helpers
	 * @summary
	 * Returns the number of milliseconds in the specified, years, months, weeks, days, hours, minutes and seconds.
	 *
	 * @description
	 * Returns the number of milliseconds in the specified, years, months, weeks, days, hours, minutes and seconds.
	 *
	 * One years equals 365.2425 days according to the formula:
	 *
	 * > Leap year occures every 4 years, except for years that are divisable by 100 and not divisable by 400.
	 * > 1 mean year = (365+1/4-1/100+1/400) days = 365.2425 days
	 *
	 * One month is a year divided by 12.
	 *
	 * @param {Duration} duration - the object with years, months, weeks, days, hours, minutes and seconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {number} the milliseconds
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // 1 year in milliseconds
	 * milliseconds({ years: 1 })
	 * //=> 31556952000
	 *
	 * // 3 months in milliseconds
	 * milliseconds({ months: 3 })
	 * //=> 7889238000
	 */
	
	function milliseconds(_ref) {
	  var years = _ref.years,
	      months = _ref.months,
	      weeks = _ref.weeks,
	      days = _ref.days,
	      hours = _ref.hours,
	      minutes = _ref.minutes,
	      seconds = _ref.seconds;
	  (0, _index.default)(1, arguments);
	  var totalDays = 0;
	  if (years) totalDays += years * daysInYear;
	  if (months) totalDays += months * (daysInYear / 12);
	  if (weeks) totalDays += weeks * 7;
	  if (days) totalDays += days;
	  var totalSeconds = totalDays * 24 * 60 * 60;
	  if (hours) totalSeconds += hours * 60 * 60;
	  if (minutes) totalSeconds += minutes * 60;
	  if (seconds) totalSeconds += seconds;
	  return Math.round(totalSeconds * 1000);
	}
	
	module.exports = exports.default;

/***/ },
/* 1516 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = millisecondsToHours;
	
	var _index = _interopRequireDefault(__webpack_require__(2));
	
	var _index2 = __webpack_require__(36);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name millisecondsToHours
	 * @category Conversion Helpers
	 * @summary Convert milliseconds to hours.
	 *
	 * @description
	 * Convert a number of milliseconds to a full number of hours.
	 *
	 * @param {number} milliseconds - number of milliseconds to be converted
	 *
	 * @returns {number} the number of milliseconds converted in hours
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Convert 7200000 milliseconds to hours:
	 * const result = millisecondsToHours(7200000)
	 * //=> 2
	 *
	 * @example
	 * // It uses floor rounding:
	 * const result = millisecondsToHours(7199999)
	 * //=> 1
	 */
	function millisecondsToHours(milliseconds) {
	  (0, _index.default)(1, arguments);
	  var hours = milliseconds / _index2.millisecondsInHour;
	  return Math.floor(hours);
	}
	
	module.exports = exports.default;

/***/ },
/* 1517 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = millisecondsToMinutes;
	
	var _index = _interopRequireDefault(__webpack_require__(2));
	
	var _index2 = __webpack_require__(36);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name millisecondsToMinutes
	 * @category Conversion Helpers
	 * @summary Convert milliseconds to minutes.
	 *
	 * @description
	 * Convert a number of milliseconds to a full number of minutes.
	 *
	 * @param {number} milliseconds - number of milliseconds to be converted.
	 *
	 * @returns {number} the number of milliseconds converted in minutes
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Convert 60000 milliseconds to minutes:
	 * const result = millisecondsToMinutes(60000)
	 * //=> 1
	 *
	 * @example
	 * // It uses floor rounding:
	 * const result = millisecondsToMinutes(119999)
	 * //=> 1
	 */
	function millisecondsToMinutes(milliseconds) {
	  (0, _index.default)(1, arguments);
	  var minutes = milliseconds / _index2.millisecondsInMinute;
	  return Math.floor(minutes);
	}
	
	module.exports = exports.default;

/***/ },
/* 1518 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = millisecondsToSeconds;
	
	var _index = _interopRequireDefault(__webpack_require__(2));
	
	var _index2 = __webpack_require__(36);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name millisecondsToSeconds
	 * @category Conversion Helpers
	 * @summary Convert milliseconds to seconds.
	 *
	 * @description
	 * Convert a number of milliseconds to a full number of seconds.
	 *
	 * @param {number} milliseconds - number of milliseconds to be converted
	 *
	 * @returns {number} the number of milliseconds converted in seconds
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Convert 1000 miliseconds to seconds:
	 * const result = millisecondsToSeconds(1000)
	 * //=> 1
	 *
	 * @example
	 * // It uses floor rounding:
	 * const result = millisecondsToSeconds(1999)
	 * //=> 1
	 */
	function millisecondsToSeconds(milliseconds) {
	  (0, _index.default)(1, arguments);
	  var seconds = milliseconds / _index2.millisecondsInSecond;
	  return Math.floor(seconds);
	}
	
	module.exports = exports.default;

/***/ },
/* 1519 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = minutesToHours;
	
	var _index = _interopRequireDefault(__webpack_require__(2));
	
	var _index2 = __webpack_require__(36);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name minutesToHours
	 * @category Conversion Helpers
	 * @summary Convert minutes to hours.
	 *
	 * @description
	 * Convert a number of minutes to a full number of hours.
	 *
	 * @param {number} minutes - number of minutes to be converted
	 *
	 * @returns {number} the number of minutes converted in hours
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Convert 140 minutes to hours:
	 * const result = minutesToHours(120)
	 * //=> 2
	 *
	 * @example
	 * // It uses floor rounding:
	 * const result = minutesToHours(179)
	 * //=> 2
	 */
	function minutesToHours(minutes) {
	  (0, _index.default)(1, arguments);
	  var hours = minutes / _index2.minutesInHour;
	  return Math.floor(hours);
	}
	
	module.exports = exports.default;

/***/ },
/* 1520 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = minutesToMilliseconds;
	
	var _index = _interopRequireDefault(__webpack_require__(2));
	
	var _index2 = __webpack_require__(36);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name minutesToMilliseconds
	 * @category Conversion Helpers
	 * @summary Convert minutes to milliseconds.
	 *
	 * @description
	 * Convert a number of minutes to a full number of milliseconds.
	 *
	 * @param {number} minutes - number of minutes to be converted
	 *
	 * @returns {number} the number of minutes converted in milliseconds
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Convert 2 minutes to milliseconds
	 * const result = minutesToMilliseconds(2)
	 * //=> 120000
	 */
	function minutesToMilliseconds(minutes) {
	  (0, _index.default)(1, arguments);
	  return Math.floor(minutes * _index2.millisecondsInMinute);
	}
	
	module.exports = exports.default;

/***/ },
/* 1521 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = minutesToSeconds;
	
	var _index = _interopRequireDefault(__webpack_require__(2));
	
	var _index2 = __webpack_require__(36);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name minutesToSeconds
	 * @category Conversion Helpers
	 * @summary Convert minutes to seconds.
	 *
	 * @description
	 * Convert a number of minutes to a full number of seconds.
	 *
	 * @param { number } minutes - number of minutes to be converted
	 *
	 * @returns {number} the number of minutes converted in seconds
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Convert 2 minutes to seconds
	 * const result = minutesToSeconds(2)
	 * //=> 120
	 */
	function minutesToSeconds(minutes) {
	  (0, _index.default)(1, arguments);
	  return Math.floor(minutes * _index2.secondsInMinute);
	}
	
	module.exports = exports.default;

/***/ },
/* 1522 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = monthsToQuarters;
	
	var _index = _interopRequireDefault(__webpack_require__(2));
	
	var _index2 = __webpack_require__(36);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name monthsToQuarters
	 * @category Conversion Helpers
	 * @summary Convert number of months to quarters.
	 *
	 * @description
	 * Convert a number of months to a full number of quarters.
	 *
	 * @param {number} months - number of months to be converted.
	 *
	 * @returns {number} the number of months converted in quarters
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Convert 6 months to quarters:
	 * const result = monthsToQuarters(6)
	 * //=> 2
	 *
	 * @example
	 * // It uses floor rounding:
	 * const result = monthsToQuarters(7)
	 * //=> 2
	 */
	function monthsToQuarters(months) {
	  (0, _index.default)(1, arguments);
	  var quarters = months / _index2.monthsInQuarter;
	  return Math.floor(quarters);
	}
	
	module.exports = exports.default;

/***/ },
/* 1523 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = monthsToYears;
	
	var _index = _interopRequireDefault(__webpack_require__(2));
	
	var _index2 = __webpack_require__(36);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name monthsToYears
	 * @category Conversion Helpers
	 * @summary Convert number of months to years.
	 *
	 * @description
	 * Convert a number of months to a full number of years.
	 *
	 * @param {number} months - number of months to be converted
	 *
	 * @returns {number} the number of months converted in years
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Convert 36 months to years:
	 * const result = monthsToYears(36)
	 * //=> 3
	 *
	 * // It uses floor rounding:
	 * const result = monthsToYears(40)
	 * //=> 3
	 */
	function monthsToYears(months) {
	  (0, _index.default)(1, arguments);
	  var years = months / _index2.monthsInYear;
	  return Math.floor(years);
	}
	
	module.exports = exports.default;

/***/ },
/* 1524 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = nextFriday;
	
	var _index = _interopRequireDefault(__webpack_require__(94));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name nextFriday
	 * @category Weekday Helpers
	 * @summary When is the next Friday?
	 *
	 * @description
	 * When is the next Friday?
	 *
	 * @param {Date | number} date - the date to start counting from
	 * @returns {Date} the next Friday
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // When is the next Friday after Mar, 22, 2020?
	 * const result = nextFriday(new Date(2020, 2, 22))
	 * //=> Fri Mar 27 2020 00:00:00
	 */
	function nextFriday(date) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(date, 5);
	}
	
	module.exports = exports.default;

/***/ },
/* 1525 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = nextMonday;
	
	var _index = _interopRequireDefault(__webpack_require__(94));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name nextMonday
	 * @category Weekday Helpers
	 * @summary When is the next Monday?
	 *
	 * @description
	 * When is the next Monday?
	 *
	 * @param {Date | number} date - the date to start counting from
	 * @returns {Date} the next Monday
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // When is the next Monday after Mar, 22, 2020?
	 * const result = nextMonday(new Date(2020, 2, 22))
	 * //=> Mon Mar 23 2020 00:00:00
	 */
	function nextMonday(date) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(date, 1);
	}
	
	module.exports = exports.default;

/***/ },
/* 1526 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = nextSaturday;
	
	var _index = _interopRequireDefault(__webpack_require__(94));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name nextSaturday
	 * @category Weekday Helpers
	 * @summary When is the next Saturday?
	 *
	 * @description
	 * When is the next Saturday?
	 *
	 * @param {Date | number} date - the date to start counting from
	 * @returns {Date} the next Saturday
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // When is the next Saturday after Mar, 22, 2020?
	 * const result = nextSaturday(new Date(2020, 2, 22))
	 * //=> Sat Mar 28 2020 00:00:00
	 */
	function nextSaturday(date) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(date, 6);
	}
	
	module.exports = exports.default;

/***/ },
/* 1527 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = nextSunday;
	
	var _index = _interopRequireDefault(__webpack_require__(94));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name nextSunday
	 * @category Weekday Helpers
	 * @summary When is the next Sunday?
	 *
	 * @description
	 * When is the next Sunday?
	 *
	 * @param {Date | number} date - the date to start counting from
	 * @returns {Date} the next Sunday
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // When is the next Sunday after Mar, 22, 2020?
	 * const result = nextSunday(new Date(2020, 2, 22))
	 * //=> Sun Mar 29 2020 00:00:00
	 */
	function nextSunday(date) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(date, 0);
	}
	
	module.exports = exports.default;

/***/ },
/* 1528 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = nextThursday;
	
	var _index = _interopRequireDefault(__webpack_require__(94));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name nextThursday
	 * @category Weekday Helpers
	 * @summary When is the next Thursday?
	 *
	 * @description
	 * When is the next Thursday?
	 *
	 * @param {Date | number} date - the date to start counting from
	 * @returns {Date} the next Thursday
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // When is the next Thursday after Mar, 22, 2020?
	 * const result = nextThursday(new Date(2020, 2, 22))
	 * //=> Thur Mar 26 2020 00:00:00
	 */
	function nextThursday(date) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(date, 4);
	}
	
	module.exports = exports.default;

/***/ },
/* 1529 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = nextTuesday;
	
	var _index = _interopRequireDefault(__webpack_require__(94));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name nextTuesday
	 * @category Weekday Helpers
	 * @summary When is the next Tuesday?
	 *
	 * @description
	 * When is the next Tuesday?
	 *
	 * @param {Date | number} date - the date to start counting from
	 * @returns {Date} the next Tuesday
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // When is the next Tuesday after Mar, 22, 2020?
	 * const result = nextTuesday(new Date(2020, 2, 22))
	 * //=> Tue Mar 24 2020 00:00:00
	 */
	function nextTuesday(date) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(date, 2);
	}
	
	module.exports = exports.default;

/***/ },
/* 1530 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = nextWednesday;
	
	var _index = _interopRequireDefault(__webpack_require__(94));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name nextWednesday
	 * @category Weekday Helpers
	 * @summary When is the next Wednesday?
	 *
	 * @description
	 * When is the next Wednesday?
	 *
	 * @param {Date | number} date - the date to start counting from
	 * @returns {Date} the next Wednesday
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // When is the next Wednesday after Mar, 22, 2020?
	 * const result = nextWednesday(new Date(2020, 2, 22))
	 * //=> Wed Mar 25 2020 00:00:00
	 */
	function nextWednesday(date) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(date, 3);
	}
	
	module.exports = exports.default;

/***/ },
/* 1531 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(268));
	
	var _index2 = _interopRequireDefault(__webpack_require__(932));
	
	var _index3 = _interopRequireDefault(__webpack_require__(933));
	
	var _index4 = _interopRequireDefault(__webpack_require__(934));
	
	var _index5 = _interopRequireDefault(__webpack_require__(935));
	
	var _index6 = _interopRequireDefault(__webpack_require__(188));
	
	var _index7 = _interopRequireDefault(__webpack_require__(148));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MILLISECONDS_IN_HOUR = 3600000;
	var MILLISECONDS_IN_MINUTE = 60000;
	var MILLISECONDS_IN_SECOND = 1000;
	var numericPatterns = {
	  month: /^(1[0-2]|0?\d)/,
	  // 0 to 12
	  date: /^(3[0-1]|[0-2]?\d)/,
	  // 0 to 31
	  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
	  // 0 to 366
	  week: /^(5[0-3]|[0-4]?\d)/,
	  // 0 to 53
	  hour23h: /^(2[0-3]|[0-1]?\d)/,
	  // 0 to 23
	  hour24h: /^(2[0-4]|[0-1]?\d)/,
	  // 0 to 24
	  hour11h: /^(1[0-1]|0?\d)/,
	  // 0 to 11
	  hour12h: /^(1[0-2]|0?\d)/,
	  // 0 to 12
	  minute: /^[0-5]?\d/,
	  // 0 to 59
	  second: /^[0-5]?\d/,
	  // 0 to 59
	  singleDigit: /^\d/,
	  // 0 to 9
	  twoDigits: /^\d{1,2}/,
	  // 0 to 99
	  threeDigits: /^\d{1,3}/,
	  // 0 to 999
	  fourDigits: /^\d{1,4}/,
	  // 0 to 9999
	  anyDigitsSigned: /^-?\d+/,
	  singleDigitSigned: /^-?\d/,
	  // 0 to 9, -0 to -9
	  twoDigitsSigned: /^-?\d{1,2}/,
	  // 0 to 99, -0 to -99
	  threeDigitsSigned: /^-?\d{1,3}/,
	  // 0 to 999, -0 to -999
	  fourDigitsSigned: /^-?\d{1,4}/ // 0 to 9999, -0 to -9999
	
	};
	var timezonePatterns = {
	  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
	  basic: /^([+-])(\d{2})(\d{2})|Z/,
	  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
	  extended: /^([+-])(\d{2}):(\d{2})|Z/,
	  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
	};
	
	function parseNumericPattern(pattern, string, valueCallback) {
	  var matchResult = string.match(pattern);
	
	  if (!matchResult) {
	    return null;
	  }
	
	  var value = parseInt(matchResult[0], 10);
	  return {
	    value: valueCallback ? valueCallback(value) : value,
	    rest: string.slice(matchResult[0].length)
	  };
	}
	
	function parseTimezonePattern(pattern, string) {
	  var matchResult = string.match(pattern);
	
	  if (!matchResult) {
	    return null;
	  } // Input is 'Z'
	
	
	  if (matchResult[0] === 'Z') {
	    return {
	      value: 0,
	      rest: string.slice(1)
	    };
	  }
	
	  var sign = matchResult[1] === '+' ? 1 : -1;
	  var hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
	  var minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
	  var seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
	  return {
	    value: sign * (hours * MILLISECONDS_IN_HOUR + minutes * MILLISECONDS_IN_MINUTE + seconds * MILLISECONDS_IN_SECOND),
	    rest: string.slice(matchResult[0].length)
	  };
	}
	
	function parseAnyDigitsSigned(string, valueCallback) {
	  return parseNumericPattern(numericPatterns.anyDigitsSigned, string, valueCallback);
	}
	
	function parseNDigits(n, string, valueCallback) {
	  switch (n) {
	    case 1:
	      return parseNumericPattern(numericPatterns.singleDigit, string, valueCallback);
	
	    case 2:
	      return parseNumericPattern(numericPatterns.twoDigits, string, valueCallback);
	
	    case 3:
	      return parseNumericPattern(numericPatterns.threeDigits, string, valueCallback);
	
	    case 4:
	      return parseNumericPattern(numericPatterns.fourDigits, string, valueCallback);
	
	    default:
	      return parseNumericPattern(new RegExp('^\\d{1,' + n + '}'), string, valueCallback);
	  }
	}
	
	function parseNDigitsSigned(n, string, valueCallback) {
	  switch (n) {
	    case 1:
	      return parseNumericPattern(numericPatterns.singleDigitSigned, string, valueCallback);
	
	    case 2:
	      return parseNumericPattern(numericPatterns.twoDigitsSigned, string, valueCallback);
	
	    case 3:
	      return parseNumericPattern(numericPatterns.threeDigitsSigned, string, valueCallback);
	
	    case 4:
	      return parseNumericPattern(numericPatterns.fourDigitsSigned, string, valueCallback);
	
	    default:
	      return parseNumericPattern(new RegExp('^-?\\d{1,' + n + '}'), string, valueCallback);
	  }
	}
	
	function dayPeriodEnumToHours(enumValue) {
	  switch (enumValue) {
	    case 'morning':
	      return 4;
	
	    case 'evening':
	      return 17;
	
	    case 'pm':
	    case 'noon':
	    case 'afternoon':
	      return 12;
	
	    case 'am':
	    case 'midnight':
	    case 'night':
	    default:
	      return 0;
	  }
	}
	
	function normalizeTwoDigitYear(twoDigitYear, currentYear) {
	  var isCommonEra = currentYear > 0; // Absolute number of the current year:
	  // 1 -> 1 AC
	  // 0 -> 1 BC
	  // -1 -> 2 BC
	
	  var absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
	  var result;
	
	  if (absCurrentYear <= 50) {
	    result = twoDigitYear || 100;
	  } else {
	    var rangeEnd = absCurrentYear + 50;
	    var rangeEndCentury = Math.floor(rangeEnd / 100) * 100;
	    var isPreviousCentury = twoDigitYear >= rangeEnd % 100;
	    result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
	  }
	
	  return isCommonEra ? result : 1 - result;
	}
	
	var DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
	var DAYS_IN_MONTH_LEAP_YEAR = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]; // User for validation
	
	function isLeapYearIndex(year) {
	  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
	}
	/*
	 * |     | Unit                           |     | Unit                           |
	 * |-----|--------------------------------|-----|--------------------------------|
	 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
	 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
	 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
	 * |  d  | Day of month                   |  D  | Day of year                    |
	 * |  e  | Local day of week              |  E  | Day of week                    |
	 * |  f  |                                |  F* | Day of week in month           |
	 * |  g* | Modified Julian day            |  G  | Era                            |
	 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
	 * |  i! | ISO day of week                |  I! | ISO week of year               |
	 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
	 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
	 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
	 * |  m  | Minute                         |  M  | Month                          |
	 * |  n  |                                |  N  |                                |
	 * |  o! | Ordinal number modifier        |  O* | Timezone (GMT)                 |
	 * |  p  |                                |  P  |                                |
	 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
	 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
	 * |  s  | Second                         |  S  | Fraction of second             |
	 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
	 * |  u  | Extended year                  |  U* | Cyclic year                    |
	 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
	 * |  w  | Local week of year             |  W* | Week of month                  |
	 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
	 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
	 * |  z* | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
	 *
	 * Letters marked by * are not implemented but reserved by Unicode standard.
	 *
	 * Letters marked by ! are non-standard, but implemented by date-fns:
	 * - `o` modifies the previous token to turn it into an ordinal (see `parse` docs)
	 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
	 *   i.e. 7 for Sunday, 1 for Monday, etc.
	 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
	 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
	 *   `R` is supposed to be used in conjunction with `I` and `i`
	 *   for universal ISO week-numbering date, whereas
	 *   `Y` is supposed to be used in conjunction with `w` and `e`
	 *   for week-numbering date specific to the locale.
	 */
	
	
	var parsers = {
	  // Era
	  G: {
	    priority: 140,
	    parse: function (string, token, match, _options) {
	      switch (token) {
	        // AD, BC
	        case 'G':
	        case 'GG':
	        case 'GGG':
	          return match.era(string, {
	            width: 'abbreviated'
	          }) || match.era(string, {
	            width: 'narrow'
	          });
	        // A, B
	
	        case 'GGGGG':
	          return match.era(string, {
	            width: 'narrow'
	          });
	        // Anno Domini, Before Christ
	
	        case 'GGGG':
	        default:
	          return match.era(string, {
	            width: 'wide'
	          }) || match.era(string, {
	            width: 'abbreviated'
	          }) || match.era(string, {
	            width: 'narrow'
	          });
	      }
	    },
	    set: function (date, flags, value, _options) {
	      flags.era = value;
	      date.setUTCFullYear(value, 0, 1);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    },
	    incompatibleTokens: ['R', 'u', 't', 'T']
	  },
	  // Year
	  y: {
	    // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_Patterns
	    // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
	    // |----------|-------|----|-------|-------|-------|
	    // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
	    // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
	    // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
	    // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
	    // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
	    priority: 130,
	    parse: function (string, token, match, _options) {
	      var valueCallback = function (year) {
	        return {
	          year: year,
	          isTwoDigitYear: token === 'yy'
	        };
	      };
	
	      switch (token) {
	        case 'y':
	          return parseNDigits(4, string, valueCallback);
	
	        case 'yo':
	          return match.ordinalNumber(string, {
	            unit: 'year',
	            valueCallback: valueCallback
	          });
	
	        default:
	          return parseNDigits(token.length, string, valueCallback);
	      }
	    },
	    validate: function (_date, value, _options) {
	      return value.isTwoDigitYear || value.year > 0;
	    },
	    set: function (date, flags, value, _options) {
	      var currentYear = date.getUTCFullYear();
	
	      if (value.isTwoDigitYear) {
	        var normalizedTwoDigitYear = normalizeTwoDigitYear(value.year, currentYear);
	        date.setUTCFullYear(normalizedTwoDigitYear, 0, 1);
	        date.setUTCHours(0, 0, 0, 0);
	        return date;
	      }
	
	      var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
	      date.setUTCFullYear(year, 0, 1);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    },
	    incompatibleTokens: ['Y', 'R', 'u', 'w', 'I', 'i', 'e', 'c', 't', 'T']
	  },
	  // Local week-numbering year
	  Y: {
	    priority: 130,
	    parse: function (string, token, match, _options) {
	      var valueCallback = function (year) {
	        return {
	          year: year,
	          isTwoDigitYear: token === 'YY'
	        };
	      };
	
	      switch (token) {
	        case 'Y':
	          return parseNDigits(4, string, valueCallback);
	
	        case 'Yo':
	          return match.ordinalNumber(string, {
	            unit: 'year',
	            valueCallback: valueCallback
	          });
	
	        default:
	          return parseNDigits(token.length, string, valueCallback);
	      }
	    },
	    validate: function (_date, value, _options) {
	      return value.isTwoDigitYear || value.year > 0;
	    },
	    set: function (date, flags, value, options) {
	      var currentYear = (0, _index.default)(date, options);
	
	      if (value.isTwoDigitYear) {
	        var normalizedTwoDigitYear = normalizeTwoDigitYear(value.year, currentYear);
	        date.setUTCFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
	        date.setUTCHours(0, 0, 0, 0);
	        return (0, _index7.default)(date, options);
	      }
	
	      var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
	      date.setUTCFullYear(year, 0, options.firstWeekContainsDate);
	      date.setUTCHours(0, 0, 0, 0);
	      return (0, _index7.default)(date, options);
	    },
	    incompatibleTokens: ['y', 'R', 'u', 'Q', 'q', 'M', 'L', 'I', 'd', 'D', 'i', 't', 'T']
	  },
	  // ISO week-numbering year
	  R: {
	    priority: 130,
	    parse: function (string, token, _match, _options) {
	      if (token === 'R') {
	        return parseNDigitsSigned(4, string);
	      }
	
	      return parseNDigitsSigned(token.length, string);
	    },
	    set: function (_date, _flags, value, _options) {
	      var firstWeekOfYear = new Date(0);
	      firstWeekOfYear.setUTCFullYear(value, 0, 4);
	      firstWeekOfYear.setUTCHours(0, 0, 0, 0);
	      return (0, _index6.default)(firstWeekOfYear);
	    },
	    incompatibleTokens: ['G', 'y', 'Y', 'u', 'Q', 'q', 'M', 'L', 'w', 'd', 'D', 'e', 'c', 't', 'T']
	  },
	  // Extended year
	  u: {
	    priority: 130,
	    parse: function (string, token, _match, _options) {
	      if (token === 'u') {
	        return parseNDigitsSigned(4, string);
	      }
	
	      return parseNDigitsSigned(token.length, string);
	    },
	    set: function (date, _flags, value, _options) {
	      date.setUTCFullYear(value, 0, 1);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    },
	    incompatibleTokens: ['G', 'y', 'Y', 'R', 'w', 'I', 'i', 'e', 'c', 't', 'T']
	  },
	  // Quarter
	  Q: {
	    priority: 120,
	    parse: function (string, token, match, _options) {
	      switch (token) {
	        // 1, 2, 3, 4
	        case 'Q':
	        case 'QQ':
	          // 01, 02, 03, 04
	          return parseNDigits(token.length, string);
	        // 1st, 2nd, 3rd, 4th
	
	        case 'Qo':
	          return match.ordinalNumber(string, {
	            unit: 'quarter'
	          });
	        // Q1, Q2, Q3, Q4
	
	        case 'QQQ':
	          return match.quarter(string, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.quarter(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	        // 1, 2, 3, 4 (narrow quarter; could be not numerical)
	
	        case 'QQQQQ':
	          return match.quarter(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	        // 1st quarter, 2nd quarter, ...
	
	        case 'QQQQ':
	        default:
	          return match.quarter(string, {
	            width: 'wide',
	            context: 'formatting'
	          }) || match.quarter(string, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.quarter(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	      }
	    },
	    validate: function (_date, value, _options) {
	      return value >= 1 && value <= 4;
	    },
	    set: function (date, _flags, value, _options) {
	      date.setUTCMonth((value - 1) * 3, 1);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    },
	    incompatibleTokens: ['Y', 'R', 'q', 'M', 'L', 'w', 'I', 'd', 'D', 'i', 'e', 'c', 't', 'T']
	  },
	  // Stand-alone quarter
	  q: {
	    priority: 120,
	    parse: function (string, token, match, _options) {
	      switch (token) {
	        // 1, 2, 3, 4
	        case 'q':
	        case 'qq':
	          // 01, 02, 03, 04
	          return parseNDigits(token.length, string);
	        // 1st, 2nd, 3rd, 4th
	
	        case 'qo':
	          return match.ordinalNumber(string, {
	            unit: 'quarter'
	          });
	        // Q1, Q2, Q3, Q4
	
	        case 'qqq':
	          return match.quarter(string, {
	            width: 'abbreviated',
	            context: 'standalone'
	          }) || match.quarter(string, {
	            width: 'narrow',
	            context: 'standalone'
	          });
	        // 1, 2, 3, 4 (narrow quarter; could be not numerical)
	
	        case 'qqqqq':
	          return match.quarter(string, {
	            width: 'narrow',
	            context: 'standalone'
	          });
	        // 1st quarter, 2nd quarter, ...
	
	        case 'qqqq':
	        default:
	          return match.quarter(string, {
	            width: 'wide',
	            context: 'standalone'
	          }) || match.quarter(string, {
	            width: 'abbreviated',
	            context: 'standalone'
	          }) || match.quarter(string, {
	            width: 'narrow',
	            context: 'standalone'
	          });
	      }
	    },
	    validate: function (_date, value, _options) {
	      return value >= 1 && value <= 4;
	    },
	    set: function (date, _flags, value, _options) {
	      date.setUTCMonth((value - 1) * 3, 1);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    },
	    incompatibleTokens: ['Y', 'R', 'Q', 'M', 'L', 'w', 'I', 'd', 'D', 'i', 'e', 'c', 't', 'T']
	  },
	  // Month
	  M: {
	    priority: 110,
	    parse: function (string, token, match, _options) {
	      var valueCallback = function (value) {
	        return value - 1;
	      };
	
	      switch (token) {
	        // 1, 2, ..., 12
	        case 'M':
	          return parseNumericPattern(numericPatterns.month, string, valueCallback);
	        // 01, 02, ..., 12
	
	        case 'MM':
	          return parseNDigits(2, string, valueCallback);
	        // 1st, 2nd, ..., 12th
	
	        case 'Mo':
	          return match.ordinalNumber(string, {
	            unit: 'month',
	            valueCallback: valueCallback
	          });
	        // Jan, Feb, ..., Dec
	
	        case 'MMM':
	          return match.month(string, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.month(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	        // J, F, ..., D
	
	        case 'MMMMM':
	          return match.month(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	        // January, February, ..., December
	
	        case 'MMMM':
	        default:
	          return match.month(string, {
	            width: 'wide',
	            context: 'formatting'
	          }) || match.month(string, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.month(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	      }
	    },
	    validate: function (_date, value, _options) {
	      return value >= 0 && value <= 11;
	    },
	    set: function (date, _flags, value, _options) {
	      date.setUTCMonth(value, 1);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    },
	    incompatibleTokens: ['Y', 'R', 'q', 'Q', 'L', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']
	  },
	  // Stand-alone month
	  L: {
	    priority: 110,
	    parse: function (string, token, match, _options) {
	      var valueCallback = function (value) {
	        return value - 1;
	      };
	
	      switch (token) {
	        // 1, 2, ..., 12
	        case 'L':
	          return parseNumericPattern(numericPatterns.month, string, valueCallback);
	        // 01, 02, ..., 12
	
	        case 'LL':
	          return parseNDigits(2, string, valueCallback);
	        // 1st, 2nd, ..., 12th
	
	        case 'Lo':
	          return match.ordinalNumber(string, {
	            unit: 'month',
	            valueCallback: valueCallback
	          });
	        // Jan, Feb, ..., Dec
	
	        case 'LLL':
	          return match.month(string, {
	            width: 'abbreviated',
	            context: 'standalone'
	          }) || match.month(string, {
	            width: 'narrow',
	            context: 'standalone'
	          });
	        // J, F, ..., D
	
	        case 'LLLLL':
	          return match.month(string, {
	            width: 'narrow',
	            context: 'standalone'
	          });
	        // January, February, ..., December
	
	        case 'LLLL':
	        default:
	          return match.month(string, {
	            width: 'wide',
	            context: 'standalone'
	          }) || match.month(string, {
	            width: 'abbreviated',
	            context: 'standalone'
	          }) || match.month(string, {
	            width: 'narrow',
	            context: 'standalone'
	          });
	      }
	    },
	    validate: function (_date, value, _options) {
	      return value >= 0 && value <= 11;
	    },
	    set: function (date, _flags, value, _options) {
	      date.setUTCMonth(value, 1);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    },
	    incompatibleTokens: ['Y', 'R', 'q', 'Q', 'M', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']
	  },
	  // Local week of year
	  w: {
	    priority: 100,
	    parse: function (string, token, match, _options) {
	      switch (token) {
	        case 'w':
	          return parseNumericPattern(numericPatterns.week, string);
	
	        case 'wo':
	          return match.ordinalNumber(string, {
	            unit: 'week'
	          });
	
	        default:
	          return parseNDigits(token.length, string);
	      }
	    },
	    validate: function (_date, value, _options) {
	      return value >= 1 && value <= 53;
	    },
	    set: function (date, _flags, value, options) {
	      return (0, _index7.default)((0, _index5.default)(date, value, options), options);
	    },
	    incompatibleTokens: ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'i', 't', 'T']
	  },
	  // ISO week of year
	  I: {
	    priority: 100,
	    parse: function (string, token, match, _options) {
	      switch (token) {
	        case 'I':
	          return parseNumericPattern(numericPatterns.week, string);
	
	        case 'Io':
	          return match.ordinalNumber(string, {
	            unit: 'week'
	          });
	
	        default:
	          return parseNDigits(token.length, string);
	      }
	    },
	    validate: function (_date, value, _options) {
	      return value >= 1 && value <= 53;
	    },
	    set: function (date, _flags, value, options) {
	      return (0, _index6.default)((0, _index4.default)(date, value, options), options);
	    },
	    incompatibleTokens: ['y', 'Y', 'u', 'q', 'Q', 'M', 'L', 'w', 'd', 'D', 'e', 'c', 't', 'T']
	  },
	  // Day of the month
	  d: {
	    priority: 90,
	    subPriority: 1,
	    parse: function (string, token, match, _options) {
	      switch (token) {
	        case 'd':
	          return parseNumericPattern(numericPatterns.date, string);
	
	        case 'do':
	          return match.ordinalNumber(string, {
	            unit: 'date'
	          });
	
	        default:
	          return parseNDigits(token.length, string);
	      }
	    },
	    validate: function (date, value, _options) {
	      var year = date.getUTCFullYear();
	      var isLeapYear = isLeapYearIndex(year);
	      var month = date.getUTCMonth();
	
	      if (isLeapYear) {
	        return value >= 1 && value <= DAYS_IN_MONTH_LEAP_YEAR[month];
	      } else {
	        return value >= 1 && value <= DAYS_IN_MONTH[month];
	      }
	    },
	    set: function (date, _flags, value, _options) {
	      date.setUTCDate(value);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    },
	    incompatibleTokens: ['Y', 'R', 'q', 'Q', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']
	  },
	  // Day of year
	  D: {
	    priority: 90,
	    subPriority: 1,
	    parse: function (string, token, match, _options) {
	      switch (token) {
	        case 'D':
	        case 'DD':
	          return parseNumericPattern(numericPatterns.dayOfYear, string);
	
	        case 'Do':
	          return match.ordinalNumber(string, {
	            unit: 'date'
	          });
	
	        default:
	          return parseNDigits(token.length, string);
	      }
	    },
	    validate: function (date, value, _options) {
	      var year = date.getUTCFullYear();
	      var isLeapYear = isLeapYearIndex(year);
	
	      if (isLeapYear) {
	        return value >= 1 && value <= 366;
	      } else {
	        return value >= 1 && value <= 365;
	      }
	    },
	    set: function (date, _flags, value, _options) {
	      date.setUTCMonth(0, value);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    },
	    incompatibleTokens: ['Y', 'R', 'q', 'Q', 'M', 'L', 'w', 'I', 'd', 'E', 'i', 'e', 'c', 't', 'T']
	  },
	  // Day of week
	  E: {
	    priority: 90,
	    parse: function (string, token, match, _options) {
	      switch (token) {
	        // Tue
	        case 'E':
	        case 'EE':
	        case 'EEE':
	          return match.day(string, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.day(string, {
	            width: 'short',
	            context: 'formatting'
	          }) || match.day(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	        // T
	
	        case 'EEEEE':
	          return match.day(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	        // Tu
	
	        case 'EEEEEE':
	          return match.day(string, {
	            width: 'short',
	            context: 'formatting'
	          }) || match.day(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	        // Tuesday
	
	        case 'EEEE':
	        default:
	          return match.day(string, {
	            width: 'wide',
	            context: 'formatting'
	          }) || match.day(string, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.day(string, {
	            width: 'short',
	            context: 'formatting'
	          }) || match.day(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	      }
	    },
	    validate: function (_date, value, _options) {
	      return value >= 0 && value <= 6;
	    },
	    set: function (date, _flags, value, options) {
	      date = (0, _index2.default)(date, value, options);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    },
	    incompatibleTokens: ['D', 'i', 'e', 'c', 't', 'T']
	  },
	  // Local day of week
	  e: {
	    priority: 90,
	    parse: function (string, token, match, options) {
	      var valueCallback = function (value) {
	        var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
	        return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
	      };
	
	      switch (token) {
	        // 3
	        case 'e':
	        case 'ee':
	          // 03
	          return parseNDigits(token.length, string, valueCallback);
	        // 3rd
	
	        case 'eo':
	          return match.ordinalNumber(string, {
	            unit: 'day',
	            valueCallback: valueCallback
	          });
	        // Tue
	
	        case 'eee':
	          return match.day(string, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.day(string, {
	            width: 'short',
	            context: 'formatting'
	          }) || match.day(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	        // T
	
	        case 'eeeee':
	          return match.day(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	        // Tu
	
	        case 'eeeeee':
	          return match.day(string, {
	            width: 'short',
	            context: 'formatting'
	          }) || match.day(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	        // Tuesday
	
	        case 'eeee':
	        default:
	          return match.day(string, {
	            width: 'wide',
	            context: 'formatting'
	          }) || match.day(string, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.day(string, {
	            width: 'short',
	            context: 'formatting'
	          }) || match.day(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	      }
	    },
	    validate: function (_date, value, _options) {
	      return value >= 0 && value <= 6;
	    },
	    set: function (date, _flags, value, options) {
	      date = (0, _index2.default)(date, value, options);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    },
	    incompatibleTokens: ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'E', 'i', 'c', 't', 'T']
	  },
	  // Stand-alone local day of week
	  c: {
	    priority: 90,
	    parse: function (string, token, match, options) {
	      var valueCallback = function (value) {
	        var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
	        return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
	      };
	
	      switch (token) {
	        // 3
	        case 'c':
	        case 'cc':
	          // 03
	          return parseNDigits(token.length, string, valueCallback);
	        // 3rd
	
	        case 'co':
	          return match.ordinalNumber(string, {
	            unit: 'day',
	            valueCallback: valueCallback
	          });
	        // Tue
	
	        case 'ccc':
	          return match.day(string, {
	            width: 'abbreviated',
	            context: 'standalone'
	          }) || match.day(string, {
	            width: 'short',
	            context: 'standalone'
	          }) || match.day(string, {
	            width: 'narrow',
	            context: 'standalone'
	          });
	        // T
	
	        case 'ccccc':
	          return match.day(string, {
	            width: 'narrow',
	            context: 'standalone'
	          });
	        // Tu
	
	        case 'cccccc':
	          return match.day(string, {
	            width: 'short',
	            context: 'standalone'
	          }) || match.day(string, {
	            width: 'narrow',
	            context: 'standalone'
	          });
	        // Tuesday
	
	        case 'cccc':
	        default:
	          return match.day(string, {
	            width: 'wide',
	            context: 'standalone'
	          }) || match.day(string, {
	            width: 'abbreviated',
	            context: 'standalone'
	          }) || match.day(string, {
	            width: 'short',
	            context: 'standalone'
	          }) || match.day(string, {
	            width: 'narrow',
	            context: 'standalone'
	          });
	      }
	    },
	    validate: function (_date, value, _options) {
	      return value >= 0 && value <= 6;
	    },
	    set: function (date, _flags, value, options) {
	      date = (0, _index2.default)(date, value, options);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    },
	    incompatibleTokens: ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'E', 'i', 'e', 't', 'T']
	  },
	  // ISO day of week
	  i: {
	    priority: 90,
	    parse: function (string, token, match, _options) {
	      var valueCallback = function (value) {
	        if (value === 0) {
	          return 7;
	        }
	
	        return value;
	      };
	
	      switch (token) {
	        // 2
	        case 'i':
	        case 'ii':
	          // 02
	          return parseNDigits(token.length, string);
	        // 2nd
	
	        case 'io':
	          return match.ordinalNumber(string, {
	            unit: 'day'
	          });
	        // Tue
	
	        case 'iii':
	          return match.day(string, {
	            width: 'abbreviated',
	            context: 'formatting',
	            valueCallback: valueCallback
	          }) || match.day(string, {
	            width: 'short',
	            context: 'formatting',
	            valueCallback: valueCallback
	          }) || match.day(string, {
	            width: 'narrow',
	            context: 'formatting',
	            valueCallback: valueCallback
	          });
	        // T
	
	        case 'iiiii':
	          return match.day(string, {
	            width: 'narrow',
	            context: 'formatting',
	            valueCallback: valueCallback
	          });
	        // Tu
	
	        case 'iiiiii':
	          return match.day(string, {
	            width: 'short',
	            context: 'formatting',
	            valueCallback: valueCallback
	          }) || match.day(string, {
	            width: 'narrow',
	            context: 'formatting',
	            valueCallback: valueCallback
	          });
	        // Tuesday
	
	        case 'iiii':
	        default:
	          return match.day(string, {
	            width: 'wide',
	            context: 'formatting',
	            valueCallback: valueCallback
	          }) || match.day(string, {
	            width: 'abbreviated',
	            context: 'formatting',
	            valueCallback: valueCallback
	          }) || match.day(string, {
	            width: 'short',
	            context: 'formatting',
	            valueCallback: valueCallback
	          }) || match.day(string, {
	            width: 'narrow',
	            context: 'formatting',
	            valueCallback: valueCallback
	          });
	      }
	    },
	    validate: function (_date, value, _options) {
	      return value >= 1 && value <= 7;
	    },
	    set: function (date, _flags, value, options) {
	      date = (0, _index3.default)(date, value, options);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    },
	    incompatibleTokens: ['y', 'Y', 'u', 'q', 'Q', 'M', 'L', 'w', 'd', 'D', 'E', 'e', 'c', 't', 'T']
	  },
	  // AM or PM
	  a: {
	    priority: 80,
	    parse: function (string, token, match, _options) {
	      switch (token) {
	        case 'a':
	        case 'aa':
	        case 'aaa':
	          return match.dayPeriod(string, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.dayPeriod(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	
	        case 'aaaaa':
	          return match.dayPeriod(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	
	        case 'aaaa':
	        default:
	          return match.dayPeriod(string, {
	            width: 'wide',
	            context: 'formatting'
	          }) || match.dayPeriod(string, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.dayPeriod(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	      }
	    },
	    set: function (date, _flags, value, _options) {
	      date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
	      return date;
	    },
	    incompatibleTokens: ['b', 'B', 'H', 'k', 't', 'T']
	  },
	  // AM, PM, midnight
	  b: {
	    priority: 80,
	    parse: function (string, token, match, _options) {
	      switch (token) {
	        case 'b':
	        case 'bb':
	        case 'bbb':
	          return match.dayPeriod(string, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.dayPeriod(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	
	        case 'bbbbb':
	          return match.dayPeriod(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	
	        case 'bbbb':
	        default:
	          return match.dayPeriod(string, {
	            width: 'wide',
	            context: 'formatting'
	          }) || match.dayPeriod(string, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.dayPeriod(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	      }
	    },
	    set: function (date, _flags, value, _options) {
	      date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
	      return date;
	    },
	    incompatibleTokens: ['a', 'B', 'H', 'k', 't', 'T']
	  },
	  // in the morning, in the afternoon, in the evening, at night
	  B: {
	    priority: 80,
	    parse: function (string, token, match, _options) {
	      switch (token) {
	        case 'B':
	        case 'BB':
	        case 'BBB':
	          return match.dayPeriod(string, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.dayPeriod(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	
	        case 'BBBBB':
	          return match.dayPeriod(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	
	        case 'BBBB':
	        default:
	          return match.dayPeriod(string, {
	            width: 'wide',
	            context: 'formatting'
	          }) || match.dayPeriod(string, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.dayPeriod(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	      }
	    },
	    set: function (date, _flags, value, _options) {
	      date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
	      return date;
	    },
	    incompatibleTokens: ['a', 'b', 't', 'T']
	  },
	  // Hour [1-12]
	  h: {
	    priority: 70,
	    parse: function (string, token, match, _options) {
	      switch (token) {
	        case 'h':
	          return parseNumericPattern(numericPatterns.hour12h, string);
	
	        case 'ho':
	          return match.ordinalNumber(string, {
	            unit: 'hour'
	          });
	
	        default:
	          return parseNDigits(token.length, string);
	      }
	    },
	    validate: function (_date, value, _options) {
	      return value >= 1 && value <= 12;
	    },
	    set: function (date, _flags, value, _options) {
	      var isPM = date.getUTCHours() >= 12;
	
	      if (isPM && value < 12) {
	        date.setUTCHours(value + 12, 0, 0, 0);
	      } else if (!isPM && value === 12) {
	        date.setUTCHours(0, 0, 0, 0);
	      } else {
	        date.setUTCHours(value, 0, 0, 0);
	      }
	
	      return date;
	    },
	    incompatibleTokens: ['H', 'K', 'k', 't', 'T']
	  },
	  // Hour [0-23]
	  H: {
	    priority: 70,
	    parse: function (string, token, match, _options) {
	      switch (token) {
	        case 'H':
	          return parseNumericPattern(numericPatterns.hour23h, string);
	
	        case 'Ho':
	          return match.ordinalNumber(string, {
	            unit: 'hour'
	          });
	
	        default:
	          return parseNDigits(token.length, string);
	      }
	    },
	    validate: function (_date, value, _options) {
	      return value >= 0 && value <= 23;
	    },
	    set: function (date, _flags, value, _options) {
	      date.setUTCHours(value, 0, 0, 0);
	      return date;
	    },
	    incompatibleTokens: ['a', 'b', 'h', 'K', 'k', 't', 'T']
	  },
	  // Hour [0-11]
	  K: {
	    priority: 70,
	    parse: function (string, token, match, _options) {
	      switch (token) {
	        case 'K':
	          return parseNumericPattern(numericPatterns.hour11h, string);
	
	        case 'Ko':
	          return match.ordinalNumber(string, {
	            unit: 'hour'
	          });
	
	        default:
	          return parseNDigits(token.length, string);
	      }
	    },
	    validate: function (_date, value, _options) {
	      return value >= 0 && value <= 11;
	    },
	    set: function (date, _flags, value, _options) {
	      var isPM = date.getUTCHours() >= 12;
	
	      if (isPM && value < 12) {
	        date.setUTCHours(value + 12, 0, 0, 0);
	      } else {
	        date.setUTCHours(value, 0, 0, 0);
	      }
	
	      return date;
	    },
	    incompatibleTokens: ['h', 'H', 'k', 't', 'T']
	  },
	  // Hour [1-24]
	  k: {
	    priority: 70,
	    parse: function (string, token, match, _options) {
	      switch (token) {
	        case 'k':
	          return parseNumericPattern(numericPatterns.hour24h, string);
	
	        case 'ko':
	          return match.ordinalNumber(string, {
	            unit: 'hour'
	          });
	
	        default:
	          return parseNDigits(token.length, string);
	      }
	    },
	    validate: function (_date, value, _options) {
	      return value >= 1 && value <= 24;
	    },
	    set: function (date, _flags, value, _options) {
	      var hours = value <= 24 ? value % 24 : value;
	      date.setUTCHours(hours, 0, 0, 0);
	      return date;
	    },
	    incompatibleTokens: ['a', 'b', 'h', 'H', 'K', 't', 'T']
	  },
	  // Minute
	  m: {
	    priority: 60,
	    parse: function (string, token, match, _options) {
	      switch (token) {
	        case 'm':
	          return parseNumericPattern(numericPatterns.minute, string);
	
	        case 'mo':
	          return match.ordinalNumber(string, {
	            unit: 'minute'
	          });
	
	        default:
	          return parseNDigits(token.length, string);
	      }
	    },
	    validate: function (_date, value, _options) {
	      return value >= 0 && value <= 59;
	    },
	    set: function (date, _flags, value, _options) {
	      date.setUTCMinutes(value, 0, 0);
	      return date;
	    },
	    incompatibleTokens: ['t', 'T']
	  },
	  // Second
	  s: {
	    priority: 50,
	    parse: function (string, token, match, _options) {
	      switch (token) {
	        case 's':
	          return parseNumericPattern(numericPatterns.second, string);
	
	        case 'so':
	          return match.ordinalNumber(string, {
	            unit: 'second'
	          });
	
	        default:
	          return parseNDigits(token.length, string);
	      }
	    },
	    validate: function (_date, value, _options) {
	      return value >= 0 && value <= 59;
	    },
	    set: function (date, _flags, value, _options) {
	      date.setUTCSeconds(value, 0);
	      return date;
	    },
	    incompatibleTokens: ['t', 'T']
	  },
	  // Fraction of second
	  S: {
	    priority: 30,
	    parse: function (string, token, _match, _options) {
	      var valueCallback = function (value) {
	        return Math.floor(value * Math.pow(10, -token.length + 3));
	      };
	
	      return parseNDigits(token.length, string, valueCallback);
	    },
	    set: function (date, _flags, value, _options) {
	      date.setUTCMilliseconds(value);
	      return date;
	    },
	    incompatibleTokens: ['t', 'T']
	  },
	  // Timezone (ISO-8601. +00:00 is `'Z'`)
	  X: {
	    priority: 10,
	    parse: function (string, token, _match, _options) {
	      switch (token) {
	        case 'X':
	          return parseTimezonePattern(timezonePatterns.basicOptionalMinutes, string);
	
	        case 'XX':
	          return parseTimezonePattern(timezonePatterns.basic, string);
	
	        case 'XXXX':
	          return parseTimezonePattern(timezonePatterns.basicOptionalSeconds, string);
	
	        case 'XXXXX':
	          return parseTimezonePattern(timezonePatterns.extendedOptionalSeconds, string);
	
	        case 'XXX':
	        default:
	          return parseTimezonePattern(timezonePatterns.extended, string);
	      }
	    },
	    set: function (date, flags, value, _options) {
	      if (flags.timestampIsSet) {
	        return date;
	      }
	
	      return new Date(date.getTime() - value);
	    },
	    incompatibleTokens: ['t', 'T', 'x']
	  },
	  // Timezone (ISO-8601)
	  x: {
	    priority: 10,
	    parse: function (string, token, _match, _options) {
	      switch (token) {
	        case 'x':
	          return parseTimezonePattern(timezonePatterns.basicOptionalMinutes, string);
	
	        case 'xx':
	          return parseTimezonePattern(timezonePatterns.basic, string);
	
	        case 'xxxx':
	          return parseTimezonePattern(timezonePatterns.basicOptionalSeconds, string);
	
	        case 'xxxxx':
	          return parseTimezonePattern(timezonePatterns.extendedOptionalSeconds, string);
	
	        case 'xxx':
	        default:
	          return parseTimezonePattern(timezonePatterns.extended, string);
	      }
	    },
	    set: function (date, flags, value, _options) {
	      if (flags.timestampIsSet) {
	        return date;
	      }
	
	      return new Date(date.getTime() - value);
	    },
	    incompatibleTokens: ['t', 'T', 'X']
	  },
	  // Seconds timestamp
	  t: {
	    priority: 40,
	    parse: function (string, _token, _match, _options) {
	      return parseAnyDigitsSigned(string);
	    },
	    set: function (_date, _flags, value, _options) {
	      return [new Date(value * 1000), {
	        timestampIsSet: true
	      }];
	    },
	    incompatibleTokens: '*'
	  },
	  // Milliseconds timestamp
	  T: {
	    priority: 20,
	    parse: function (string, _token, _match, _options) {
	      return parseAnyDigitsSigned(string);
	    },
	    set: function (_date, _flags, value, _options) {
	      return [new Date(value), {
	        timestampIsSet: true
	      }];
	    },
	    incompatibleTokens: '*'
	  }
	};
	var _default = parsers;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1532 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = parseISO;
	
	var _index = __webpack_require__(36);
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	var _index3 = _interopRequireDefault(__webpack_require__(19));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name parseISO
	 * @category Common Helpers
	 * @summary Parse ISO string
	 *
	 * @description
	 * Parse the given string in ISO 8601 format and return an instance of Date.
	 *
	 * Function accepts complete ISO 8601 formats as well as partial implementations.
	 * ISO 8601: http://en.wikipedia.org/wiki/ISO_8601
	 *
	 * If the argument isn't a string, the function cannot parse the string or
	 * the values are invalid, it returns Invalid Date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * - The previous `parse` implementation was renamed to `parseISO`.
	 *
	 *   ```javascript
	 *   // Before v2.0.0
	 *   parse('2016-01-01')
	 *
	 *   // v2.0.0 onward
	 *   parseISO('2016-01-01')
	 *   ```
	 *
	 * - `parseISO` now validates separate date and time values in ISO-8601 strings
	 *   and returns `Invalid Date` if the date is invalid.
	 *
	 *   ```javascript
	 *   parseISO('2018-13-32')
	 *   //=> Invalid Date
	 *   ```
	 *
	 * - `parseISO` now doesn't fall back to `new Date` constructor
	 *   if it fails to parse a string argument. Instead, it returns `Invalid Date`.
	 *
	 * @param {String} argument - the value to convert
	 * @param {Object} [options] - an object with options.
	 * @param {0|1|2} [options.additionalDigits=2] - the additional number of digits in the extended year format
	 * @returns {Date} the parsed date in the local time zone
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
	 *
	 * @example
	 * // Convert string '2014-02-11T11:30:30' to date:
	 * const result = parseISO('2014-02-11T11:30:30')
	 * //=> Tue Feb 11 2014 11:30:30
	 *
	 * @example
	 * // Convert string '+02014101' to date,
	 * // if the additional number of digits in the extended year format is 1:
	 * const result = parseISO('+02014101', { additionalDigits: 1 })
	 * //=> Fri Apr 11 2014 00:00:00
	 */
	function parseISO(argument, dirtyOptions) {
	  (0, _index2.default)(1, arguments);
	  var options = dirtyOptions || {};
	  var additionalDigits = options.additionalDigits == null ? 2 : (0, _index3.default)(options.additionalDigits);
	
	  if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) {
	    throw new RangeError('additionalDigits must be 0, 1 or 2');
	  }
	
	  if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) {
	    return new Date(NaN);
	  }
	
	  var dateStrings = splitDateString(argument);
	  var date;
	
	  if (dateStrings.date) {
	    var parseYearResult = parseYear(dateStrings.date, additionalDigits);
	    date = parseDate(parseYearResult.restDateString, parseYearResult.year);
	  }
	
	  if (!date || isNaN(date.getTime())) {
	    return new Date(NaN);
	  }
	
	  var timestamp = date.getTime();
	  var time = 0;
	  var offset;
	
	  if (dateStrings.time) {
	    time = parseTime(dateStrings.time);
	
	    if (isNaN(time)) {
	      return new Date(NaN);
	    }
	  }
	
	  if (dateStrings.timezone) {
	    offset = parseTimezone(dateStrings.timezone);
	
	    if (isNaN(offset)) {
	      return new Date(NaN);
	    }
	  } else {
	    var dirtyDate = new Date(timestamp + time); // js parsed string assuming it's in UTC timezone
	    // but we need it to be parsed in our timezone
	    // so we use utc values to build date in our timezone.
	    // Year values from 0 to 99 map to the years 1900 to 1999
	    // so set year explicitly with setFullYear.
	
	    var result = new Date(0);
	    result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
	    result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
	    return result;
	  }
	
	  return new Date(timestamp + time + offset);
	}
	
	var patterns = {
	  dateTimeDelimiter: /[T ]/,
	  timeZoneDelimiter: /[Z ]/i,
	  timezone: /([Z+-].*)$/
	};
	var dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
	var timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
	var timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
	
	function splitDateString(dateString) {
	  var dateStrings = {};
	  var array = dateString.split(patterns.dateTimeDelimiter);
	  var timeString; // The regex match should only return at maximum two array elements.
	  // [date], [time], or [date, time].
	
	  if (array.length > 2) {
	    return dateStrings;
	  }
	
	  if (/:/.test(array[0])) {
	    timeString = array[0];
	  } else {
	    dateStrings.date = array[0];
	    timeString = array[1];
	
	    if (patterns.timeZoneDelimiter.test(dateStrings.date)) {
	      dateStrings.date = dateString.split(patterns.timeZoneDelimiter)[0];
	      timeString = dateString.substr(dateStrings.date.length, dateString.length);
	    }
	  }
	
	  if (timeString) {
	    var token = patterns.timezone.exec(timeString);
	
	    if (token) {
	      dateStrings.time = timeString.replace(token[1], '');
	      dateStrings.timezone = token[1];
	    } else {
	      dateStrings.time = timeString;
	    }
	  }
	
	  return dateStrings;
	}
	
	function parseYear(dateString, additionalDigits) {
	  var regex = new RegExp('^(?:(\\d{4}|[+-]\\d{' + (4 + additionalDigits) + '})|(\\d{2}|[+-]\\d{' + (2 + additionalDigits) + '})$)');
	  var captures = dateString.match(regex); // Invalid ISO-formatted year
	
	  if (!captures) return {
	    year: NaN,
	    restDateString: ''
	  };
	  var year = captures[1] ? parseInt(captures[1]) : null;
	  var century = captures[2] ? parseInt(captures[2]) : null; // either year or century is null, not both
	
	  return {
	    year: century === null ? year : century * 100,
	    restDateString: dateString.slice((captures[1] || captures[2]).length)
	  };
	}
	
	function parseDate(dateString, year) {
	  // Invalid ISO-formatted year
	  if (year === null) return new Date(NaN);
	  var captures = dateString.match(dateRegex); // Invalid ISO-formatted string
	
	  if (!captures) return new Date(NaN);
	  var isWeekDate = !!captures[4];
	  var dayOfYear = parseDateUnit(captures[1]);
	  var month = parseDateUnit(captures[2]) - 1;
	  var day = parseDateUnit(captures[3]);
	  var week = parseDateUnit(captures[4]);
	  var dayOfWeek = parseDateUnit(captures[5]) - 1;
	
	  if (isWeekDate) {
	    if (!validateWeekDate(year, week, dayOfWeek)) {
	      return new Date(NaN);
	    }
	
	    return dayOfISOWeekYear(year, week, dayOfWeek);
	  } else {
	    var date = new Date(0);
	
	    if (!validateDate(year, month, day) || !validateDayOfYearDate(year, dayOfYear)) {
	      return new Date(NaN);
	    }
	
	    date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
	    return date;
	  }
	}
	
	function parseDateUnit(value) {
	  return value ? parseInt(value) : 1;
	}
	
	function parseTime(timeString) {
	  var captures = timeString.match(timeRegex);
	  if (!captures) return NaN; // Invalid ISO-formatted time
	
	  var hours = parseTimeUnit(captures[1]);
	  var minutes = parseTimeUnit(captures[2]);
	  var seconds = parseTimeUnit(captures[3]);
	
	  if (!validateTime(hours, minutes, seconds)) {
	    return NaN;
	  }
	
	  return hours * _index.millisecondsInHour + minutes * _index.millisecondsInMinute + seconds * 1000;
	}
	
	function parseTimeUnit(value) {
	  return value && parseFloat(value.replace(',', '.')) || 0;
	}
	
	function parseTimezone(timezoneString) {
	  if (timezoneString === 'Z') return 0;
	  var captures = timezoneString.match(timezoneRegex);
	  if (!captures) return 0;
	  var sign = captures[1] === '+' ? -1 : 1;
	  var hours = parseInt(captures[2]);
	  var minutes = captures[3] && parseInt(captures[3]) || 0;
	
	  if (!validateTimezone(hours, minutes)) {
	    return NaN;
	  }
	
	  return sign * (hours * _index.millisecondsInHour + minutes * _index.millisecondsInMinute);
	}
	
	function dayOfISOWeekYear(isoWeekYear, week, day) {
	  var date = new Date(0);
	  date.setUTCFullYear(isoWeekYear, 0, 4);
	  var fourthOfJanuaryDay = date.getUTCDay() || 7;
	  var diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
	  date.setUTCDate(date.getUTCDate() + diff);
	  return date;
	} // Validation functions
	// February is null to handle the leap year (using ||)
	
	
	var daysInMonths = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
	
	function isLeapYearIndex(year) {
	  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
	}
	
	function validateDate(year, month, date) {
	  return month >= 0 && month <= 11 && date >= 1 && date <= (daysInMonths[month] || (isLeapYearIndex(year) ? 29 : 28));
	}
	
	function validateDayOfYearDate(year, dayOfYear) {
	  return dayOfYear >= 1 && dayOfYear <= (isLeapYearIndex(year) ? 366 : 365);
	}
	
	function validateWeekDate(_year, week, day) {
	  return week >= 1 && week <= 53 && day >= 0 && day <= 6;
	}
	
	function validateTime(hours, minutes, seconds) {
	  if (hours === 24) {
	    return minutes === 0 && seconds === 0;
	  }
	
	  return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
	}
	
	function validateTimezone(_hours, minutes) {
	  return minutes >= 0 && minutes <= 59;
	}
	
	module.exports = exports.default;

/***/ },
/* 1533 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = parseJSON;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name parseJSON
	 * @category Common Helpers
	 * @summary Parse a JSON date string
	 *
	 * @description
	 * Converts a complete ISO date string in UTC time, the typical format for transmitting
	 * a date in JSON, to a JavaScript `Date` instance.
	 *
	 * This is a minimal implementation for converting dates retrieved from a JSON API to
	 * a `Date` instance which can be used with other functions in the `date-fns` library.
	 * The following formats are supported:
	 *
	 * - `2000-03-15T05:20:10.123Z`: The output of `.toISOString()` and `JSON.stringify(new Date())`
	 * - `2000-03-15T05:20:10Z`: Without milliseconds
	 * - `2000-03-15T05:20:10+00:00`: With a zero offset, the default JSON encoded format in some other languages
	 * - `2000-03-15T05:20:10+05:45`: With a positive or negative offset, the default JSON encoded format in some other languages
	 * - `2000-03-15T05:20:10+0000`: With a zero offset without a colon
	 * - `2000-03-15T05:20:10`: Without a trailing 'Z' symbol
	 * - `2000-03-15T05:20:10.1234567`: Up to 7 digits in milliseconds field. Only first 3 are taken into account since JS does not allow fractional milliseconds
	 * - `2000-03-15 05:20:10`: With a space instead of a 'T' separator for APIs returning a SQL date without reformatting
	 *
	 * For convenience and ease of use these other input types are also supported
	 * via [toDate]{@link https://date-fns.org/docs/toDate}:
	 *
	 * - A `Date` instance will be cloned
	 * - A `number` will be treated as a timestamp
	 *
	 * Any other input type or invalid date strings will return an `Invalid Date`.
	 *
	 * @param {String|Number|Date} argument A fully formed ISO8601 date string to convert
	 * @returns {Date} the parsed date in the local time zone
	 * @throws {TypeError} 1 argument required
	 */
	function parseJSON(argument) {
	  (0, _index2.default)(1, arguments);
	
	  if (typeof argument === 'string') {
	    var parts = argument.match(/(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2}):(\d{2})(?:\.(\d{0,7}))?(?:Z|(.)(\d{2}):?(\d{2})?)?/);
	
	    if (parts) {
	      // Group 8 matches the sign
	      return new Date(Date.UTC(+parts[1], +parts[2] - 1, +parts[3], +parts[4] - (+parts[9] || 0) * (parts[8] == '-' ? -1 : 1), +parts[5] - (+parts[10] || 0) * (parts[8] == '-' ? -1 : 1), +parts[6], +((parts[7] || '0') + '00').substring(0, 3)));
	    }
	
	    return new Date(NaN);
	  }
	
	  return (0, _index.default)(argument);
	}
	
	module.exports = exports.default;

/***/ },
/* 1534 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = previousFriday;
	
	var _index = _interopRequireDefault(__webpack_require__(2));
	
	var _index2 = _interopRequireDefault(__webpack_require__(95));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name previousFriday
	 * @category Weekday Helpers
	 * @summary When is the previous Friday?
	 *
	 * @description
	 * When is the previous Friday?
	 *
	 * @param {Date | number} date - the date to start counting from
	 * @returns {Date} the previous Friday
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // When is the previous Friday before Jun, 19, 2021?
	 * const result = previousFriday(new Date(2021, 5, 19))
	 * //=> Fri June 18 2021 00:00:00
	 */
	function previousFriday(date) {
	  (0, _index.default)(1, arguments);
	  return (0, _index2.default)(date, 5);
	}
	
	module.exports = exports.default;

/***/ },
/* 1535 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = previousMonday;
	
	var _index = _interopRequireDefault(__webpack_require__(2));
	
	var _index2 = _interopRequireDefault(__webpack_require__(95));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name previousMonday
	 * @category Weekday Helpers
	 * @summary When is the previous Monday?
	 *
	 * @description
	 * When is the previous Monday?
	 *
	 * @param {Date | number} date - the date to start counting from
	 * @returns {Date} the previous Monday
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // When is the previous Monday before Jun, 18, 2021?
	 * const result = previousMonday(new Date(2021, 5, 18))
	 * //=> Mon June 14 2021 00:00:00
	 */
	function previousMonday(date) {
	  (0, _index.default)(1, arguments);
	  return (0, _index2.default)(date, 1);
	}
	
	module.exports = exports.default;

/***/ },
/* 1536 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = previousSaturday;
	
	var _index = _interopRequireDefault(__webpack_require__(2));
	
	var _index2 = _interopRequireDefault(__webpack_require__(95));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name previousSaturday
	 * @category Weekday Helpers
	 * @summary When is the previous Saturday?
	 *
	 * @description
	 * When is the previous Saturday?
	 *
	 * @param {Date | number} date - the date to start counting from
	 * @returns {Date} the previous Saturday
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // When is the previous Saturday before Jun, 20, 2021?
	 * const result = previousSaturday(new Date(2021, 5, 20))
	 * //=> Sat June 19 2021 00:00:00
	 */
	function previousSaturday(date) {
	  (0, _index.default)(1, arguments);
	  return (0, _index2.default)(date, 6);
	}
	
	module.exports = exports.default;

/***/ },
/* 1537 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = previousSunday;
	
	var _index = _interopRequireDefault(__webpack_require__(2));
	
	var _index2 = _interopRequireDefault(__webpack_require__(95));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name previousSunday
	 * @category Weekday Helpers
	 * @summary When is the previous Sunday?
	 *
	 * @description
	 * When is the previous Sunday?
	 *
	 * @param {Date | number} date - the date to start counting from
	 * @returns {Date} the previous Sunday
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // When is the previous Sunday before Jun, 21, 2021?
	 * const result = previousSunday(new Date(2021, 5, 21))
	 * //=> Sun June 20 2021 00:00:00
	 */
	function previousSunday(date) {
	  (0, _index.default)(1, arguments);
	  return (0, _index2.default)(date, 0);
	}
	
	module.exports = exports.default;

/***/ },
/* 1538 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = previousThursday;
	
	var _index = _interopRequireDefault(__webpack_require__(2));
	
	var _index2 = _interopRequireDefault(__webpack_require__(95));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name previousThursday
	 * @category Weekday Helpers
	 * @summary When is the previous Thursday?
	 *
	 * @description
	 * When is the previous Thursday?
	 *
	 * @param {Date | number} date - the date to start counting from
	 * @returns {Date} the previous Thursday
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // When is the previous Thursday before Jun, 18, 2021?
	 * const result = previousThursday(new Date(2021, 5, 18))
	 * //=> Thu June 17 2021 00:00:00
	 */
	function previousThursday(date) {
	  (0, _index.default)(1, arguments);
	  return (0, _index2.default)(date, 4);
	}
	
	module.exports = exports.default;

/***/ },
/* 1539 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = previousTuesday;
	
	var _index = _interopRequireDefault(__webpack_require__(2));
	
	var _index2 = _interopRequireDefault(__webpack_require__(95));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name previousTuesday
	 * @category Weekday Helpers
	 * @summary When is the previous Tuesday?
	 *
	 * @description
	 * When is the previous Tuesday?
	 *
	 * @param {Date | number} date - the date to start counting from
	 * @returns {Date} the previous Tuesday
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // When is the previous Tuesday before Jun, 18, 2021?
	 * const result = previousTuesday(new Date(2021, 5, 18))
	 * //=> Tue June 15 2021 00:00:00
	 */
	function previousTuesday(date) {
	  (0, _index.default)(1, arguments);
	  return (0, _index2.default)(date, 2);
	}
	
	module.exports = exports.default;

/***/ },
/* 1540 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = previousWednesday;
	
	var _index = _interopRequireDefault(__webpack_require__(2));
	
	var _index2 = _interopRequireDefault(__webpack_require__(95));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name previousWednesday
	 * @category Weekday Helpers
	 * @summary When is the previous Wednesday?
	 *
	 * @description
	 * When is the previous Wednesday?
	 *
	 * @param {Date | number} date - the date to start counting from
	 * @returns {Date} the previous Wednesday
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // When is the previous Wednesday before Jun, 18, 2021?
	 * const result = previousWednesday(new Date(2021, 5, 18))
	 * //=> Wed June 16 2021 00:00:00
	 */
	function previousWednesday(date) {
	  (0, _index.default)(1, arguments);
	  return (0, _index2.default)(date, 3);
	}
	
	module.exports = exports.default;

/***/ },
/* 1541 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = quartersToMonths;
	
	var _index = _interopRequireDefault(__webpack_require__(2));
	
	var _index2 = __webpack_require__(36);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name quartersToMonths
	 * @category Conversion Helpers
	 * @summary Convert number of quarters to months.
	 *
	 * @description
	 * Convert a number of quarters to a full number of months.
	 *
	 * @param {number} quarters - number of quarters to be converted
	 *
	 * @returns {number} the number of quarters converted in months
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Convert 2 quarters to months
	 * const result = quartersToMonths(2)
	 * //=> 6
	 */
	function quartersToMonths(quarters) {
	  (0, _index.default)(1, arguments);
	  return Math.floor(quarters * _index2.monthsInQuarter);
	}
	
	module.exports = exports.default;

/***/ },
/* 1542 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = quartersToYears;
	
	var _index = _interopRequireDefault(__webpack_require__(2));
	
	var _index2 = __webpack_require__(36);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name quartersToYears
	 * @category Conversion Helpers
	 * @summary Convert number of quarters to years.
	 *
	 * @description
	 * Convert a number of quarters to a full number of years.
	 *
	 * @param {number} quarters - number of quarters to be converted
	 *
	 * @returns {number} the number of quarters converted in years
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Convert 8 quarters to years
	 * const result = quartersToYears(8)
	 * //=> 2
	 *
	 * @example
	 * // It uses floor rounding:
	 * const result = quartersToYears(11)
	 * //=> 2
	 */
	function quartersToYears(quarters) {
	  (0, _index.default)(1, arguments);
	  var years = quarters / _index2.quartersInYear;
	  return Math.floor(years);
	}
	
	module.exports = exports.default;

/***/ },
/* 1543 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = roundToNearestMinutes;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(19));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name roundToNearestMinutes
	 * @category Minute Helpers
	 * @summary Rounds the given date to the nearest minute
	 *
	 * @description
	 * Rounds the given date to the nearest minute (or number of minutes).
	 * Rounds up when the given date is exactly between the nearest round minutes.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to round
	 * @param {Object} [options] - an object with options.
	 * @param {Number} [options.nearestTo=1] - nearest number of minutes to round to. E.g. `15` to round to quarter hours.
	 * @returns {Date} the new date rounded to the closest minute
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.nearestTo` must be between 1 and 30
	 *
	 * @example
	 * // Round 10 July 2014 12:12:34 to nearest minute:
	 * var result = roundToNearestMinutes(new Date(2014, 6, 10, 12, 12, 34))
	 * //=> Thu Jul 10 2014 12:13:00
	 *
	 * @example
	 * // Round 10 July 2014 12:07:30 to nearest quarter hour:
	 * var result = roundToNearestMinutes(new Date(2014, 6, 10, 12, 12, 34), { nearestTo: 15 })
	 * // rounds up because given date is exactly between 12:00:00 and 12:15:00
	 * //=> Thu Jul 10 2014 12:15:00
	 */
	function roundToNearestMinutes(dirtyDate, options) {
	  if (arguments.length < 1) {
	    throw new TypeError('1 argument required, but only none provided present');
	  }
	
	  var nearestTo = options && 'nearestTo' in options ? (0, _index2.default)(options.nearestTo) : 1;
	
	  if (nearestTo < 1 || nearestTo > 30) {
	    throw new RangeError('`options.nearestTo` must be between 1 and 30');
	  }
	
	  var date = (0, _index.default)(dirtyDate);
	  var seconds = date.getSeconds(); // relevant if nearestTo is 1, which is the default case
	
	  var minutes = date.getMinutes() + seconds / 60;
	  var roundedMinutes = Math.floor(minutes / nearestTo) * nearestTo;
	  var remainderMinutes = minutes % nearestTo;
	  var addedMinutes = Math.round(remainderMinutes / nearestTo) * nearestTo;
	  return new Date(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), roundedMinutes + addedMinutes);
	}
	
	module.exports = exports.default;

/***/ },
/* 1544 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = secondsToHours;
	
	var _index = _interopRequireDefault(__webpack_require__(2));
	
	var _index2 = __webpack_require__(36);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name secondsToHours
	 * @category Conversion Helpers
	 * @summary Convert seconds to hours.
	 *
	 * @description
	 * Convert a number of seconds to a full number of hours.
	 *
	 * @param {number} seconds - number of seconds to be converted
	 *
	 * @returns {number} the number of seconds converted in hours
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Convert 7200 seconds into hours
	 * const result = secondsToHours(7200)
	 * //=> 2
	 *
	 * @example
	 * // It uses floor rounding:
	 * const result = secondsToHours(7199)
	 * //=> 1
	 */
	function secondsToHours(seconds) {
	  (0, _index.default)(1, arguments);
	  var hours = seconds / _index2.secondsInHour;
	  return Math.floor(hours);
	}
	
	module.exports = exports.default;

/***/ },
/* 1545 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = secondsToMilliseconds;
	
	var _index = _interopRequireDefault(__webpack_require__(2));
	
	var _index2 = __webpack_require__(36);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name secondsToMilliseconds
	 * @category Conversion Helpers
	 * @summary Convert seconds to milliseconds.
	 *
	 * @description
	 * Convert a number of seconds to a full number of milliseconds.
	 *
	 * @param {number} seconds - number of seconds to be converted
	 *
	 * @returns {number} the number of seconds converted in milliseconds
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Convert 2 seconds into milliseconds
	 * const result = secondsToMilliseconds(2)
	 * //=> 2000
	 */
	function secondsToMilliseconds(seconds) {
	  (0, _index.default)(1, arguments);
	  return seconds * _index2.millisecondsInSecond;
	}
	
	module.exports = exports.default;

/***/ },
/* 1546 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = secondsToMinutes;
	
	var _index = _interopRequireDefault(__webpack_require__(2));
	
	var _index2 = __webpack_require__(36);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name secondsToMinutes
	 * @category Conversion Helpers
	 * @summary Convert seconds to minutes.
	 *
	 * @description
	 * Convert a number of seconds to a full number of minutes.
	 *
	 * @param {number} seconds - number of seconds to be converted
	 *
	 * @returns {number} the number of seconds converted in minutes
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Convert 120 seconds into minutes
	 * const result = secondsToMinutes(120)
	 * //=> 2
	 *
	 * @example
	 * // It uses floor rounding:
	 * const result = secondsToMinutes(119)
	 * //=> 1
	 */
	function secondsToMinutes(seconds) {
	  (0, _index.default)(1, arguments);
	  var minutes = seconds / _index2.secondsInMinute;
	  return Math.floor(minutes);
	}
	
	module.exports = exports.default;

/***/ },
/* 1547 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = set;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(285));
	
	var _index3 = _interopRequireDefault(__webpack_require__(19));
	
	var _index4 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name set
	 * @category Common Helpers
	 * @summary Set date values to a given date.
	 *
	 * @description
	 * Set date values to a given date.
	 *
	 * Sets time values to date from object `values`.
	 * A value is not set if it is undefined or null or doesn't exist in `values`.
	 *
	 * Note about bundle size: `set` does not internally use `setX` functions from date-fns but instead opts
	 * to use native `Date#setX` methods. If you use this function, you may not want to include the
	 * other `setX` functions that date-fns provides if you are concerned about the bundle size.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Object} values - an object with options
	 * @param {Number} [values.year] - the number of years to be set
	 * @param {Number} [values.month] - the number of months to be set
	 * @param {Number} [values.date] - the number of days to be set
	 * @param {Number} [values.hours] - the number of hours to be set
	 * @param {Number} [values.minutes] - the number of minutes to be set
	 * @param {Number} [values.seconds] - the number of seconds to be set
	 * @param {Number} [values.milliseconds] - the number of milliseconds to be set
	 * @returns {Date} the new date with options set
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} `values` must be an object
	 *
	 * @example
	 * // Transform 1 September 2014 into 20 October 2015 in a single line:
	 * var result = set(new Date(2014, 8, 20), { year: 2015, month: 9, date: 20 })
	 * //=> Tue Oct 20 2015 00:00:00
	 *
	 * @example
	 * // Set 12 PM to 1 September 2014 01:23:45 to 1 September 2014 12:00:00:
	 * var result = set(new Date(2014, 8, 1, 1, 23, 45), { hours: 12 })
	 * //=> Mon Sep 01 2014 12:23:45
	 */
	function set(dirtyDate, values) {
	  (0, _index4.default)(2, arguments);
	
	  if (typeof values !== 'object' || values === null) {
	    throw new RangeError('values parameter must be an object');
	  }
	
	  var date = (0, _index.default)(dirtyDate); // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date
	
	  if (isNaN(date.getTime())) {
	    return new Date(NaN);
	  }
	
	  if (values.year != null) {
	    date.setFullYear(values.year);
	  }
	
	  if (values.month != null) {
	    date = (0, _index2.default)(date, values.month);
	  }
	
	  if (values.date != null) {
	    date.setDate((0, _index3.default)(values.date));
	  }
	
	  if (values.hours != null) {
	    date.setHours((0, _index3.default)(values.hours));
	  }
	
	  if (values.minutes != null) {
	    date.setMinutes((0, _index3.default)(values.minutes));
	  }
	
	  if (values.seconds != null) {
	    date.setSeconds((0, _index3.default)(values.seconds));
	  }
	
	  if (values.milliseconds != null) {
	    date.setMilliseconds((0, _index3.default)(values.milliseconds));
	  }
	
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 1548 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setDate;
	
	var _index = _interopRequireDefault(__webpack_require__(19));
	
	var _index2 = _interopRequireDefault(__webpack_require__(3));
	
	var _index3 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name setDate
	 * @category Day Helpers
	 * @summary Set the day of the month to the given date.
	 *
	 * @description
	 * Set the day of the month to the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} dayOfMonth - the day of the month of the new date
	 * @returns {Date} the new date with the day of the month set
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Set the 30th day of the month to 1 September 2014:
	 * var result = setDate(new Date(2014, 8, 1), 30)
	 * //=> Tue Sep 30 2014 00:00:00
	 */
	function setDate(dirtyDate, dirtyDayOfMonth) {
	  (0, _index3.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var dayOfMonth = (0, _index.default)(dirtyDayOfMonth);
	  date.setDate(dayOfMonth);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 1549 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setDay;
	
	var _index = _interopRequireDefault(__webpack_require__(82));
	
	var _index2 = _interopRequireDefault(__webpack_require__(3));
	
	var _index3 = _interopRequireDefault(__webpack_require__(19));
	
	var _index4 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name setDay
	 * @category Weekday Helpers
	 * @summary Set the day of the week to the given date.
	 *
	 * @description
	 * Set the day of the week to the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} day - the day of the week of the new date
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @returns {Date} the new date with the day of the week set
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 *
	 * @example
	 * // Set week day to Sunday, with the default weekStartsOn of Sunday:
	 * var result = setDay(new Date(2014, 8, 1), 0)
	 * //=> Sun Aug 31 2014 00:00:00
	 *
	 * @example
	 * // Set week day to Sunday, with a weekStartsOn of Monday:
	 * var result = setDay(new Date(2014, 8, 1), 0, { weekStartsOn: 1 })
	 * //=> Sun Sep 07 2014 00:00:00
	 */
	function setDay(dirtyDate, dirtyDay, dirtyOptions) {
	  (0, _index4.default)(2, arguments);
	  var options = dirtyOptions || {};
	  var locale = options.locale;
	  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
	  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0, _index3.default)(localeWeekStartsOn);
	  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0, _index3.default)(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
	
	  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
	    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
	  }
	
	  var date = (0, _index2.default)(dirtyDate);
	  var day = (0, _index3.default)(dirtyDay);
	  var currentDay = date.getDay();
	  var remainder = day % 7;
	  var dayIndex = (remainder + 7) % 7;
	  var delta = 7 - weekStartsOn;
	  var diff = day < 0 || day > 6 ? day - (currentDay + delta) % 7 : (dayIndex + delta) % 7 - (currentDay + delta) % 7;
	  return (0, _index.default)(date, diff);
	}
	
	module.exports = exports.default;

/***/ },
/* 1550 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setDayOfYear;
	
	var _index = _interopRequireDefault(__webpack_require__(19));
	
	var _index2 = _interopRequireDefault(__webpack_require__(3));
	
	var _index3 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name setDayOfYear
	 * @category Day Helpers
	 * @summary Set the day of the year to the given date.
	 *
	 * @description
	 * Set the day of the year to the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} dayOfYear - the day of the year of the new date
	 * @returns {Date} the new date with the day of the year set
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Set the 2nd day of the year to 2 July 2014:
	 * var result = setDayOfYear(new Date(2014, 6, 2), 2)
	 * //=> Thu Jan 02 2014 00:00:00
	 */
	function setDayOfYear(dirtyDate, dirtyDayOfYear) {
	  (0, _index3.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var dayOfYear = (0, _index.default)(dirtyDayOfYear);
	  date.setMonth(0);
	  date.setDate(dayOfYear);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 1551 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setHours;
	
	var _index = _interopRequireDefault(__webpack_require__(19));
	
	var _index2 = _interopRequireDefault(__webpack_require__(3));
	
	var _index3 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name setHours
	 * @category Hour Helpers
	 * @summary Set the hours to the given date.
	 *
	 * @description
	 * Set the hours to the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} hours - the hours of the new date
	 * @returns {Date} the new date with the hours set
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Set 4 hours to 1 September 2014 11:30:00:
	 * var result = setHours(new Date(2014, 8, 1, 11, 30), 4)
	 * //=> Mon Sep 01 2014 04:30:00
	 */
	function setHours(dirtyDate, dirtyHours) {
	  (0, _index3.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var hours = (0, _index.default)(dirtyHours);
	  date.setHours(hours);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 1552 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setISODay;
	
	var _index = _interopRequireDefault(__webpack_require__(19));
	
	var _index2 = _interopRequireDefault(__webpack_require__(3));
	
	var _index3 = _interopRequireDefault(__webpack_require__(82));
	
	var _index4 = _interopRequireDefault(__webpack_require__(419));
	
	var _index5 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name setISODay
	 * @category Weekday Helpers
	 * @summary Set the day of the ISO week to the given date.
	 *
	 * @description
	 * Set the day of the ISO week to the given date.
	 * ISO week starts with Monday.
	 * 7 is the index of Sunday, 1 is the index of Monday etc.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} day - the day of the ISO week of the new date
	 * @returns {Date} the new date with the day of the ISO week set
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Set Sunday to 1 September 2014:
	 * const result = setISODay(new Date(2014, 8, 1), 7)
	 * //=> Sun Sep 07 2014 00:00:00
	 */
	function setISODay(dirtyDate, dirtyDay) {
	  (0, _index5.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var day = (0, _index.default)(dirtyDay);
	  var currentDay = (0, _index4.default)(date);
	  var diff = day - currentDay;
	  return (0, _index3.default)(date, diff);
	}
	
	module.exports = exports.default;

/***/ },
/* 1553 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setISOWeek;
	
	var _index = _interopRequireDefault(__webpack_require__(19));
	
	var _index2 = _interopRequireDefault(__webpack_require__(3));
	
	var _index3 = _interopRequireDefault(__webpack_require__(420));
	
	var _index4 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name setISOWeek
	 * @category ISO Week Helpers
	 * @summary Set the ISO week to the given date.
	 *
	 * @description
	 * Set the ISO week to the given date, saving the weekday number.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} isoWeek - the ISO week of the new date
	 * @returns {Date} the new date with the ISO week set
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Set the 53rd ISO week to 7 August 2004:
	 * const result = setISOWeek(new Date(2004, 7, 7), 53)
	 * //=> Sat Jan 01 2005 00:00:00
	 */
	function setISOWeek(dirtyDate, dirtyISOWeek) {
	  (0, _index4.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var isoWeek = (0, _index.default)(dirtyISOWeek);
	  var diff = (0, _index3.default)(date) - isoWeek;
	  date.setDate(date.getDate() - diff * 7);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 1554 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setMilliseconds;
	
	var _index = _interopRequireDefault(__webpack_require__(19));
	
	var _index2 = _interopRequireDefault(__webpack_require__(3));
	
	var _index3 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name setMilliseconds
	 * @category Millisecond Helpers
	 * @summary Set the milliseconds to the given date.
	 *
	 * @description
	 * Set the milliseconds to the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} milliseconds - the milliseconds of the new date
	 * @returns {Date} the new date with the milliseconds set
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Set 300 milliseconds to 1 September 2014 11:30:40.500:
	 * const result = setMilliseconds(new Date(2014, 8, 1, 11, 30, 40, 500), 300)
	 * //=> Mon Sep 01 2014 11:30:40.300
	 */
	function setMilliseconds(dirtyDate, dirtyMilliseconds) {
	  (0, _index3.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var milliseconds = (0, _index.default)(dirtyMilliseconds);
	  date.setMilliseconds(milliseconds);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 1555 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setMinutes;
	
	var _index = _interopRequireDefault(__webpack_require__(19));
	
	var _index2 = _interopRequireDefault(__webpack_require__(3));
	
	var _index3 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name setMinutes
	 * @category Minute Helpers
	 * @summary Set the minutes to the given date.
	 *
	 * @description
	 * Set the minutes to the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} minutes - the minutes of the new date
	 * @returns {Date} the new date with the minutes set
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Set 45 minutes to 1 September 2014 11:30:40:
	 * const result = setMinutes(new Date(2014, 8, 1, 11, 30, 40), 45)
	 * //=> Mon Sep 01 2014 11:45:40
	 */
	function setMinutes(dirtyDate, dirtyMinutes) {
	  (0, _index3.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var minutes = (0, _index.default)(dirtyMinutes);
	  date.setMinutes(minutes);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 1556 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setQuarter;
	
	var _index = _interopRequireDefault(__webpack_require__(19));
	
	var _index2 = _interopRequireDefault(__webpack_require__(3));
	
	var _index3 = _interopRequireDefault(__webpack_require__(285));
	
	var _index4 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name setQuarter
	 * @category Quarter Helpers
	 * @summary Set the year quarter to the given date.
	 *
	 * @description
	 * Set the year quarter to the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} quarter - the quarter of the new date
	 * @returns {Date} the new date with the quarter set
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Set the 2nd quarter to 2 July 2014:
	 * const result = setQuarter(new Date(2014, 6, 2), 2)
	 * //=> Wed Apr 02 2014 00:00:00
	 */
	function setQuarter(dirtyDate, dirtyQuarter) {
	  (0, _index4.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var quarter = (0, _index.default)(dirtyQuarter);
	  var oldQuarter = Math.floor(date.getMonth() / 3) + 1;
	  var diff = quarter - oldQuarter;
	  return (0, _index3.default)(date, date.getMonth() + diff * 3);
	}
	
	module.exports = exports.default;

/***/ },
/* 1557 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setSeconds;
	
	var _index = _interopRequireDefault(__webpack_require__(19));
	
	var _index2 = _interopRequireDefault(__webpack_require__(3));
	
	var _index3 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name setSeconds
	 * @category Second Helpers
	 * @summary Set the seconds to the given date.
	 *
	 * @description
	 * Set the seconds to the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} seconds - the seconds of the new date
	 * @returns {Date} the new date with the seconds set
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Set 45 seconds to 1 September 2014 11:30:40:
	 * const result = setSeconds(new Date(2014, 8, 1, 11, 30, 40), 45)
	 * //=> Mon Sep 01 2014 11:30:45
	 */
	function setSeconds(dirtyDate, dirtySeconds) {
	  (0, _index3.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var seconds = (0, _index.default)(dirtySeconds);
	  date.setSeconds(seconds);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 1558 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setWeek;
	
	var _index = _interopRequireDefault(__webpack_require__(423));
	
	var _index2 = _interopRequireDefault(__webpack_require__(3));
	
	var _index3 = _interopRequireDefault(__webpack_require__(19));
	
	var _index4 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name setWeek
	 * @category Week Helpers
	 * @summary Set the local week to the given date.
	 *
	 * @description
	 * Set the local week to the given date, saving the weekday number.
	 * The exact calculation depends on the values of
	 * `options.weekStartsOn` (which is the index of the first day of the week)
	 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
	 * the first week of the week-numbering year)
	 *
	 * Week numbering: https://en.wikipedia.org/wiki/Week#Week_numbering
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} week - the week of the new date
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
	 * @returns {Date} the new date with the local week set
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
	 *
	 * @example
	 * // Set the 1st week to 2 January 2005 with default options:
	 * var result = setWeek(new Date(2005, 0, 2), 1)
	 * //=> Sun Dec 26 2004 00:00:00
	 *
	 * @example
	 * // Set the 1st week to 2 January 2005,
	 * // if Monday is the first day of the week,
	 * // and the first week of the year always contains 4 January:
	 * var result = setWeek(new Date(2005, 0, 2), 1, {
	 *   weekStartsOn: 1,
	 *   firstWeekContainsDate: 4
	 * })
	 * //=> Sun Jan 4 2004 00:00:00
	 */
	function setWeek(dirtyDate, dirtyWeek, options) {
	  (0, _index4.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var week = (0, _index3.default)(dirtyWeek);
	  var diff = (0, _index.default)(date, options) - week;
	  date.setDate(date.getDate() - diff * 7);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 1559 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setWeekYear;
	
	var _index = _interopRequireDefault(__webpack_require__(106));
	
	var _index2 = _interopRequireDefault(__webpack_require__(288));
	
	var _index3 = _interopRequireDefault(__webpack_require__(3));
	
	var _index4 = _interopRequireDefault(__webpack_require__(19));
	
	var _index5 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name setWeekYear
	 * @category Week-Numbering Year Helpers
	 * @summary Set the local week-numbering year to the given date.
	 *
	 * @description
	 * Set the local week-numbering year to the given date,
	 * saving the week number and the weekday number.
	 * The exact calculation depends on the values of
	 * `options.weekStartsOn` (which is the index of the first day of the week)
	 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
	 * the first week of the week-numbering year)
	 *
	 * Week numbering: https://en.wikipedia.org/wiki/Week#Week_numbering
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} weekYear - the local week-numbering year of the new date
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
	 * @returns {Date} the new date with the local week-numbering year set
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
	 *
	 * @example
	 * // Set the local week-numbering year 2004 to 2 January 2010 with default options:
	 * var result = setWeekYear(new Date(2010, 0, 2), 2004)
	 * //=> Sat Jan 03 2004 00:00:00
	 *
	 * @example
	 * // Set the local week-numbering year 2004 to 2 January 2010,
	 * // if Monday is the first day of week
	 * // and 4 January is always in the first week of the year:
	 * var result = setWeekYear(new Date(2010, 0, 2), 2004, {
	 *   weekStartsOn: 1,
	 *   firstWeekContainsDate: 4
	 * })
	 * //=> Sat Jan 01 2005 00:00:00
	 */
	function setWeekYear(dirtyDate, dirtyWeekYear) {
	  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	  (0, _index5.default)(2, arguments);
	  var locale = options.locale;
	  var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
	  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : (0, _index4.default)(localeFirstWeekContainsDate);
	  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : (0, _index4.default)(options.firstWeekContainsDate);
	  var date = (0, _index3.default)(dirtyDate);
	  var weekYear = (0, _index4.default)(dirtyWeekYear);
	  var diff = (0, _index.default)(date, (0, _index2.default)(date, options));
	  var firstWeek = new Date(0);
	  firstWeek.setFullYear(weekYear, 0, firstWeekContainsDate);
	  firstWeek.setHours(0, 0, 0, 0);
	  date = (0, _index2.default)(firstWeek, options);
	  date.setDate(date.getDate() + diff);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 1560 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setYear;
	
	var _index = _interopRequireDefault(__webpack_require__(19));
	
	var _index2 = _interopRequireDefault(__webpack_require__(3));
	
	var _index3 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name setYear
	 * @category Year Helpers
	 * @summary Set the year to the given date.
	 *
	 * @description
	 * Set the year to the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} year - the year of the new date
	 * @returns {Date} the new date with the year set
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Set year 2013 to 1 September 2014:
	 * const result = setYear(new Date(2014, 8, 1), 2013)
	 * //=> Sun Sep 01 2013 00:00:00
	 */
	function setYear(dirtyDate, dirtyYear) {
	  (0, _index3.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var year = (0, _index.default)(dirtyYear); // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date
	
	  if (isNaN(date.getTime())) {
	    return new Date(NaN);
	  }
	
	  date.setFullYear(year);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 1561 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfDecade;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name startOfDecade
	 * @category Decade Helpers
	 * @summary Return the start of a decade for the given date.
	 *
	 * @description
	 * Return the start of a decade for the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the start of a decade
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The start of a decade for 21 October 2015 00:00:00:
	 * const result = startOfDecade(new Date(2015, 9, 21, 00, 00, 00))
	 * //=> Jan 01 2010 00:00:00
	 */
	function startOfDecade(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var year = date.getFullYear();
	  var decade = Math.floor(year / 10) * 10;
	  date.setFullYear(decade, 0, 1);
	  date.setHours(0, 0, 0, 0);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 1562 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfToday;
	
	var _index = _interopRequireDefault(__webpack_require__(194));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name startOfToday
	 * @category Day Helpers
	 * @summary Return the start of today.
	 * @pure false
	 *
	 * @description
	 * Return the start of today.
	 *
	 * > ⚠️ Please note that this function is not present in the FP submodule as
	 * > it uses `Date.now()` internally hence impure and can't be safely curried.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @returns {Date} the start of today
	 *
	 * @example
	 * // If today is 6 October 2014:
	 * var result = startOfToday()
	 * //=> Mon Oct 6 2014 00:00:00
	 */
	function startOfToday() {
	  return (0, _index.default)(Date.now());
	}
	
	module.exports = exports.default;

/***/ },
/* 1563 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfTomorrow;
	
	/**
	 * @name startOfTomorrow
	 * @category Day Helpers
	 * @summary Return the start of tomorrow.
	 * @pure false
	 *
	 * @description
	 * Return the start of tomorrow.
	 *
	 * > ⚠️ Please note that this function is not present in the FP submodule as
	 * > it uses `new Date()` internally hence impure and can't be safely curried.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @returns {Date} the start of tomorrow
	 *
	 * @example
	 * // If today is 6 October 2014:
	 * const result = startOfTomorrow()
	 * //=> Tue Oct 7 2014 00:00:00
	 */
	function startOfTomorrow() {
	  var now = new Date();
	  var year = now.getFullYear();
	  var month = now.getMonth();
	  var day = now.getDate();
	  var date = new Date(0);
	  date.setFullYear(year, month, day + 1);
	  date.setHours(0, 0, 0, 0);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 1564 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfYesterday;
	
	/**
	 * @name startOfYesterday
	 * @category Day Helpers
	 * @summary Return the start of yesterday.
	 * @pure false
	 *
	 * @description
	 * Return the start of yesterday.
	 *
	 * > ⚠️ Please note that this function is not present in the FP submodule as
	 * > it uses `new Date()` internally hence impure and can't be safely curried.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @returns {Date} the start of yesterday
	 *
	 * @example
	 * // If today is 6 October 2014:
	 * const result = startOfYesterday()
	 * //=> Sun Oct 5 2014 00:00:00
	 */
	function startOfYesterday() {
	  var now = new Date();
	  var year = now.getFullYear();
	  var month = now.getMonth();
	  var day = now.getDate();
	  var date = new Date(0);
	  date.setFullYear(year, month, day - 1);
	  date.setHours(0, 0, 0, 0);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 1565 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = subBusinessDays;
	
	var _index = _interopRequireDefault(__webpack_require__(401));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	var _index3 = _interopRequireDefault(__webpack_require__(19));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name subBusinessDays
	 * @category Day Helpers
	 * @summary Substract the specified number of business days (mon - fri) to the given date.
	 *
	 * @description
	 * Substract the specified number of business days (mon - fri) to the given date, ignoring weekends.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of business days to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the business days subtracted
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Substract 10 business days from 1 September 2014:
	 * const result = subBusinessDays(new Date(2014, 8, 1), 10)
	 * //=> Mon Aug 18 2014 00:00:00 (skipped weekend days)
	 */
	function subBusinessDays(dirtyDate, dirtyAmount) {
	  (0, _index2.default)(2, arguments);
	  var amount = (0, _index3.default)(dirtyAmount);
	  return (0, _index.default)(dirtyDate, -amount);
	}
	
	module.exports = exports.default;

/***/ },
/* 1566 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = subHours;
	
	var _index = _interopRequireDefault(__webpack_require__(19));
	
	var _index2 = _interopRequireDefault(__webpack_require__(269));
	
	var _index3 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name subHours
	 * @category Hour Helpers
	 * @summary Subtract the specified number of hours from the given date.
	 *
	 * @description
	 * Subtract the specified number of hours from the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of hours to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the hours subtracted
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Subtract 2 hours from 11 July 2014 01:00:00:
	 * const result = subHours(new Date(2014, 6, 11, 1, 0), 2)
	 * //=> Thu Jul 10 2014 23:00:00
	 */
	function subHours(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  return (0, _index2.default)(dirtyDate, -amount);
	}
	
	module.exports = exports.default;

/***/ },
/* 1567 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = subMinutes;
	
	var _index = _interopRequireDefault(__webpack_require__(19));
	
	var _index2 = _interopRequireDefault(__webpack_require__(270));
	
	var _index3 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name subMinutes
	 * @category Minute Helpers
	 * @summary Subtract the specified number of minutes from the given date.
	 *
	 * @description
	 * Subtract the specified number of minutes from the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of minutes to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the minutes subtracted
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Subtract 30 minutes from 10 July 2014 12:00:00:
	 * const result = subMinutes(new Date(2014, 6, 10, 12, 0), 30)
	 * //=> Thu Jul 10 2014 11:30:00
	 */
	function subMinutes(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  return (0, _index2.default)(dirtyDate, -amount);
	}
	
	module.exports = exports.default;

/***/ },
/* 1568 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = subQuarters;
	
	var _index = _interopRequireDefault(__webpack_require__(19));
	
	var _index2 = _interopRequireDefault(__webpack_require__(271));
	
	var _index3 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name subQuarters
	 * @category Quarter Helpers
	 * @summary Subtract the specified number of year quarters from the given date.
	 *
	 * @description
	 * Subtract the specified number of year quarters from the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of quarters to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the quarters subtracted
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Subtract 3 quarters from 1 September 2014:
	 * const result = subQuarters(new Date(2014, 8, 1), 3)
	 * //=> Sun Dec 01 2013 00:00:00
	 */
	function subQuarters(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  return (0, _index2.default)(dirtyDate, -amount);
	}
	
	module.exports = exports.default;

/***/ },
/* 1569 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = subSeconds;
	
	var _index = _interopRequireDefault(__webpack_require__(19));
	
	var _index2 = _interopRequireDefault(__webpack_require__(403));
	
	var _index3 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name subSeconds
	 * @category Second Helpers
	 * @summary Subtract the specified number of seconds from the given date.
	 *
	 * @description
	 * Subtract the specified number of seconds from the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of seconds to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the seconds subtracted
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Subtract 30 seconds from 10 July 2014 12:45:00:
	 * const result = subSeconds(new Date(2014, 6, 10, 12, 45, 0), 30)
	 * //=> Thu Jul 10 2014 12:44:30
	 */
	function subSeconds(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  return (0, _index2.default)(dirtyDate, -amount);
	}
	
	module.exports = exports.default;

/***/ },
/* 1570 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = subWeeks;
	
	var _index = _interopRequireDefault(__webpack_require__(19));
	
	var _index2 = _interopRequireDefault(__webpack_require__(189));
	
	var _index3 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name subWeeks
	 * @category Week Helpers
	 * @summary Subtract the specified number of weeks from the given date.
	 *
	 * @description
	 * Subtract the specified number of weeks from the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of weeks to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the weeks subtracted
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Subtract 4 weeks from 1 September 2014:
	 * const result = subWeeks(new Date(2014, 8, 1), 4)
	 * //=> Mon Aug 04 2014 00:00:00
	 */
	function subWeeks(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  return (0, _index2.default)(dirtyDate, -amount);
	}
	
	module.exports = exports.default;

/***/ },
/* 1571 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = subYears;
	
	var _index = _interopRequireDefault(__webpack_require__(19));
	
	var _index2 = _interopRequireDefault(__webpack_require__(404));
	
	var _index3 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name subYears
	 * @category Year Helpers
	 * @summary Subtract the specified number of years from the given date.
	 *
	 * @description
	 * Subtract the specified number of years from the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of years to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the years subtracted
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Subtract 5 years from 1 September 2014:
	 * const result = subYears(new Date(2014, 8, 1), 5)
	 * //=> Tue Sep 01 2009 00:00:00
	 */
	function subYears(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  return (0, _index2.default)(dirtyDate, -amount);
	}
	
	module.exports = exports.default;

/***/ },
/* 1572 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = weeksToDays;
	
	var _index = _interopRequireDefault(__webpack_require__(2));
	
	var _index2 = __webpack_require__(36);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name weeksToDays
	 * @category Conversion Helpers
	 * @summary Convert weeks to days.
	 *
	 * @description
	 * Convert a number of weeks to a full number of days.
	 *
	 * @param {number} weeks - number of weeks to be converted
	 *
	 * @returns {number} the number of weeks converted in days
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Convert 2 weeks into days
	 * const result = weeksToDays(2)
	 * //=> 14
	 */
	function weeksToDays(weeks) {
	  (0, _index.default)(1, arguments);
	  return Math.floor(weeks * _index2.daysInWeek);
	}
	
	module.exports = exports.default;

/***/ },
/* 1573 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = yearsToMonths;
	
	var _index = _interopRequireDefault(__webpack_require__(2));
	
	var _index2 = __webpack_require__(36);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name yearsToMonths
	 * @category Conversion Helpers
	 * @summary Convert years to months.
	 *
	 * @description
	 * Convert a number of years to a full number of months.
	 *
	 * @param {number} years - number of years to be converted
	 *
	 * @returns {number} the number of years converted in months
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Convert 2 years into months
	 * const result = yearsToMonths(2)
	 * //=> 24
	 */
	function yearsToMonths(years) {
	  (0, _index.default)(1, arguments);
	  return Math.floor(years * _index2.monthsInYear);
	}
	
	module.exports = exports.default;

/***/ },
/* 1574 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = yearsToQuarters;
	
	var _index = _interopRequireDefault(__webpack_require__(2));
	
	var _index2 = __webpack_require__(36);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name yearsToQuarters
	 * @category Conversion Helpers
	 * @summary Convert years to quarters.
	 *
	 * @description
	 * Convert a number of years to a full number of quarters.
	 *
	 * @param {number} years - number of years to be converted
	 *
	 * @returns {number} the number of years converted in quarters
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Convert 2 years to quarters
	 * const result = yearsToQuarters(2)
	 * //=> 8
	 */
	function yearsToQuarters(years) {
	  (0, _index.default)(1, arguments);
	  return Math.floor(years * _index2.quartersInYear);
	}
	
	module.exports = exports.default;

/***/ },
/* 1575 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global) {/*!
	 * deep-diff.
	 * Licensed under the MIT License.
	 */
	;(function(root, factory) {
	  'use strict';
	  if (true) {
	    // AMD. Register as an anonymous module.
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return factory();
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports === 'object') {
	    // Node. Does not work with strict CommonJS, but
	    // only CommonJS-like environments that support module.exports,
	    // like Node.
	    module.exports = factory();
	  } else {
	    // Browser globals (root is window)
	    root.DeepDiff = factory();
	  }
	}(this, function(undefined) {
	  'use strict';
	
	  var $scope, conflict, conflictResolution = [];
	  if (typeof global === 'object' && global) {
	    $scope = global;
	  } else if (typeof window !== 'undefined') {
	    $scope = window;
	  } else {
	    $scope = {};
	  }
	  conflict = $scope.DeepDiff;
	  if (conflict) {
	    conflictResolution.push(
	      function() {
	        if ('undefined' !== typeof conflict && $scope.DeepDiff === accumulateDiff) {
	          $scope.DeepDiff = conflict;
	          conflict = undefined;
	        }
	      });
	  }
	
	  // nodejs compatible on server side and in the browser.
	  function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor;
	    ctor.prototype = Object.create(superCtor.prototype, {
	      constructor: {
	        value: ctor,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	  }
	
	  function Diff(kind, path) {
	    Object.defineProperty(this, 'kind', {
	      value: kind,
	      enumerable: true
	    });
	    if (path && path.length) {
	      Object.defineProperty(this, 'path', {
	        value: path,
	        enumerable: true
	      });
	    }
	  }
	
	  function DiffEdit(path, origin, value) {
	    DiffEdit.super_.call(this, 'E', path);
	    Object.defineProperty(this, 'lhs', {
	      value: origin,
	      enumerable: true
	    });
	    Object.defineProperty(this, 'rhs', {
	      value: value,
	      enumerable: true
	    });
	  }
	  inherits(DiffEdit, Diff);
	
	  function DiffNew(path, value) {
	    DiffNew.super_.call(this, 'N', path);
	    Object.defineProperty(this, 'rhs', {
	      value: value,
	      enumerable: true
	    });
	  }
	  inherits(DiffNew, Diff);
	
	  function DiffDeleted(path, value) {
	    DiffDeleted.super_.call(this, 'D', path);
	    Object.defineProperty(this, 'lhs', {
	      value: value,
	      enumerable: true
	    });
	  }
	  inherits(DiffDeleted, Diff);
	
	  function DiffArray(path, index, item) {
	    DiffArray.super_.call(this, 'A', path);
	    Object.defineProperty(this, 'index', {
	      value: index,
	      enumerable: true
	    });
	    Object.defineProperty(this, 'item', {
	      value: item,
	      enumerable: true
	    });
	  }
	  inherits(DiffArray, Diff);
	
	  function arrayRemove(arr, from, to) {
	    var rest = arr.slice((to || from) + 1 || arr.length);
	    arr.length = from < 0 ? arr.length + from : from;
	    arr.push.apply(arr, rest);
	    return arr;
	  }
	
	  function realTypeOf(subject) {
	    var type = typeof subject;
	    if (type !== 'object') {
	      return type;
	    }
	
	    if (subject === Math) {
	      return 'math';
	    } else if (subject === null) {
	      return 'null';
	    } else if (Array.isArray(subject)) {
	      return 'array';
	    } else if (Object.prototype.toString.call(subject) === '[object Date]') {
	      return 'date';
	    } else if (typeof subject.toString !== 'undefined' && /^\/.*\//.test(subject.toString())) {
	      return 'regexp';
	    }
	    return 'object';
	  }
	
	  function deepDiff(lhs, rhs, changes, prefilter, path, key, stack) {
	    path = path || [];
	    var currentPath = path.slice(0);
	    if (typeof key !== 'undefined') {
	      if (prefilter) {
	        if (typeof(prefilter) === 'function' && prefilter(currentPath, key)) { return; }
	        else if (typeof(prefilter) === 'object') {
	          if (prefilter.prefilter && prefilter.prefilter(currentPath, key)) { return; }
	          if (prefilter.normalize) {
	            var alt = prefilter.normalize(currentPath, key, lhs, rhs);
	            if (alt) {
	              lhs = alt[0];
	              rhs = alt[1];
	            }
	          }
	        }
	      }
	      currentPath.push(key);
	    }
	
	    // Use string comparison for regexes
	    if (realTypeOf(lhs) === 'regexp' && realTypeOf(rhs) === 'regexp') {
	      lhs = lhs.toString();
	      rhs = rhs.toString();
	    }
	
	    var ltype = typeof lhs;
	    var rtype = typeof rhs;
	    if (ltype === 'undefined') {
	      if (rtype !== 'undefined') {
	        changes(new DiffNew(currentPath, rhs));
	      }
	    } else if (rtype === 'undefined') {
	      changes(new DiffDeleted(currentPath, lhs));
	    } else if (realTypeOf(lhs) !== realTypeOf(rhs)) {
	      changes(new DiffEdit(currentPath, lhs, rhs));
	    } else if (Object.prototype.toString.call(lhs) === '[object Date]' && Object.prototype.toString.call(rhs) === '[object Date]' && ((lhs - rhs) !== 0)) {
	      changes(new DiffEdit(currentPath, lhs, rhs));
	    } else if (ltype === 'object' && lhs !== null && rhs !== null) {
	      stack = stack || [];
	      if (stack.indexOf(lhs) < 0) {
	        stack.push(lhs);
	        if (Array.isArray(lhs)) {
	          var i, len = lhs.length;
	          for (i = 0; i < lhs.length; i++) {
	            if (i >= rhs.length) {
	              changes(new DiffArray(currentPath, i, new DiffDeleted(undefined, lhs[i])));
	            } else {
	              deepDiff(lhs[i], rhs[i], changes, prefilter, currentPath, i, stack);
	            }
	          }
	          while (i < rhs.length) {
	            changes(new DiffArray(currentPath, i, new DiffNew(undefined, rhs[i++])));
	          }
	        } else {
	          var akeys = Object.keys(lhs);
	          var pkeys = Object.keys(rhs);
	          akeys.forEach(function(k, i) {
	            var other = pkeys.indexOf(k);
	            if (other >= 0) {
	              deepDiff(lhs[k], rhs[k], changes, prefilter, currentPath, k, stack);
	              pkeys = arrayRemove(pkeys, other);
	            } else {
	              deepDiff(lhs[k], undefined, changes, prefilter, currentPath, k, stack);
	            }
	          });
	          pkeys.forEach(function(k) {
	            deepDiff(undefined, rhs[k], changes, prefilter, currentPath, k, stack);
	          });
	        }
	        stack.length = stack.length - 1;
	      }
	    } else if (lhs !== rhs) {
	      if (!(ltype === 'number' && isNaN(lhs) && isNaN(rhs))) {
	        changes(new DiffEdit(currentPath, lhs, rhs));
	      }
	    }
	  }
	
	  function accumulateDiff(lhs, rhs, prefilter, accum) {
	    accum = accum || [];
	    deepDiff(lhs, rhs,
	      function(diff) {
	        if (diff) {
	          accum.push(diff);
	        }
	      },
	      prefilter);
	    return (accum.length) ? accum : undefined;
	  }
	
	  function applyArrayChange(arr, index, change) {
	    if (change.path && change.path.length) {
	      var it = arr[index],
	          i, u = change.path.length - 1;
	      for (i = 0; i < u; i++) {
	        it = it[change.path[i]];
	      }
	      switch (change.kind) {
	        case 'A':
	          applyArrayChange(it[change.path[i]], change.index, change.item);
	          break;
	        case 'D':
	          delete it[change.path[i]];
	          break;
	        case 'E':
	        case 'N':
	          it[change.path[i]] = change.rhs;
	          break;
	      }
	    } else {
	      switch (change.kind) {
	        case 'A':
	          applyArrayChange(arr[index], change.index, change.item);
	          break;
	        case 'D':
	          arr = arrayRemove(arr, index);
	          break;
	        case 'E':
	        case 'N':
	          arr[index] = change.rhs;
	          break;
	      }
	    }
	    return arr;
	  }
	
	  function applyChange(target, source, change) {
	    if (target && source && change && change.kind) {
	      var it = target,
	          i = -1,
	          last = change.path ? change.path.length - 1 : 0;
	      while (++i < last) {
	        if (typeof it[change.path[i]] === 'undefined') {
	          it[change.path[i]] = (typeof change.path[i] === 'number') ? [] : {};
	        }
	        it = it[change.path[i]];
	      }
	      switch (change.kind) {
	        case 'A':
	          applyArrayChange(change.path ? it[change.path[i]] : it, change.index, change.item);
	          break;
	        case 'D':
	          delete it[change.path[i]];
	          break;
	        case 'E':
	        case 'N':
	          it[change.path[i]] = change.rhs;
	          break;
	      }
	    }
	  }
	
	  function revertArrayChange(arr, index, change) {
	    if (change.path && change.path.length) {
	      // the structure of the object at the index has changed...
	      var it = arr[index],
	          i, u = change.path.length - 1;
	      for (i = 0; i < u; i++) {
	        it = it[change.path[i]];
	      }
	      switch (change.kind) {
	        case 'A':
	          revertArrayChange(it[change.path[i]], change.index, change.item);
	          break;
	        case 'D':
	          it[change.path[i]] = change.lhs;
	          break;
	        case 'E':
	          it[change.path[i]] = change.lhs;
	          break;
	        case 'N':
	          delete it[change.path[i]];
	          break;
	      }
	    } else {
	      // the array item is different...
	      switch (change.kind) {
	        case 'A':
	          revertArrayChange(arr[index], change.index, change.item);
	          break;
	        case 'D':
	          arr[index] = change.lhs;
	          break;
	        case 'E':
	          arr[index] = change.lhs;
	          break;
	        case 'N':
	          arr = arrayRemove(arr, index);
	          break;
	      }
	    }
	    return arr;
	  }
	
	  function revertChange(target, source, change) {
	    if (target && source && change && change.kind) {
	      var it = target,
	          i, u;
	      u = change.path.length - 1;
	      for (i = 0; i < u; i++) {
	        if (typeof it[change.path[i]] === 'undefined') {
	          it[change.path[i]] = {};
	        }
	        it = it[change.path[i]];
	      }
	      switch (change.kind) {
	        case 'A':
	          // Array was modified...
	          // it will be an array...
	          revertArrayChange(it[change.path[i]], change.index, change.item);
	          break;
	        case 'D':
	          // Item was deleted...
	          it[change.path[i]] = change.lhs;
	          break;
	        case 'E':
	          // Item was edited...
	          it[change.path[i]] = change.lhs;
	          break;
	        case 'N':
	          // Item is new...
	          delete it[change.path[i]];
	          break;
	      }
	    }
	  }
	
	  function applyDiff(target, source, filter) {
	    if (target && source) {
	      var onChange = function(change) {
	        if (!filter || filter(target, source, change)) {
	          applyChange(target, source, change);
	        }
	      };
	      deepDiff(target, source, onChange);
	    }
	  }
	
	  Object.defineProperties(accumulateDiff, {
	
	    diff: {
	      value: accumulateDiff,
	      enumerable: true
	    },
	    observableDiff: {
	      value: deepDiff,
	      enumerable: true
	    },
	    applyDiff: {
	      value: applyDiff,
	      enumerable: true
	    },
	    applyChange: {
	      value: applyChange,
	      enumerable: true
	    },
	    revertChange: {
	      value: revertChange,
	      enumerable: true
	    },
	    isConflict: {
	      value: function() {
	        return 'undefined' !== typeof conflict;
	      },
	      enumerable: true
	    },
	    noConflict: {
	      value: function() {
	        if (conflictResolution) {
	          conflictResolution.forEach(function(it) {
	            it();
	          });
	          conflictResolution = null;
	        }
	        return accumulateDiff;
	      },
	      enumerable: true
	    }
	  });
	
	  return accumulateDiff;
	}));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1576 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function defined() {
		for (var i = 0; i < arguments.length; i++) {
			if (typeof arguments[i] !== 'undefined') {
				return arguments[i];
			}
		}
	};


/***/ },
/* 1577 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports.default = addClass;
	
	var _hasClass = _interopRequireDefault(__webpack_require__(456));
	
	function addClass(element, className) {
	  if (element.classList) element.classList.add(className);else if (!(0, _hasClass.default)(element, className)) if (typeof element.className === 'string') element.className = element.className + ' ' + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + ' ' + className);
	}
	
	module.exports = exports["default"];

/***/ },
/* 1578 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _addClass = _interopRequireDefault(__webpack_require__(1577));
	
	exports.addClass = _addClass.default;
	
	var _removeClass = _interopRequireDefault(__webpack_require__(1579));
	
	exports.removeClass = _removeClass.default;
	
	var _hasClass = _interopRequireDefault(__webpack_require__(456));
	
	exports.hasClass = _hasClass.default;
	var _default = {
	  addClass: _addClass.default,
	  removeClass: _removeClass.default,
	  hasClass: _hasClass.default
	};
	exports.default = _default;

/***/ },
/* 1579 */
/***/ function(module, exports) {

	'use strict';
	
	function replaceClassName(origClass, classToRemove) {
	  return origClass.replace(new RegExp('(^|\\s)' + classToRemove + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
	}
	
	module.exports = function removeClass(element, className) {
	  if (element.classList) element.classList.remove(className);else if (typeof element.className === 'string') element.className = replaceClassName(element.className, className);else element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
	};

/***/ },
/* 1580 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports.default = filterEvents;
	
	var _contains = _interopRequireDefault(__webpack_require__(130));
	
	var _querySelectorAll = _interopRequireDefault(__webpack_require__(1585));
	
	function filterEvents(selector, handler) {
	  return function filterHandler(e) {
	    var top = e.currentTarget,
	        target = e.target,
	        matches = (0, _querySelectorAll.default)(top, selector);
	    if (matches.some(function (match) {
	      return (0, _contains.default)(match, target);
	    })) handler.call(this, e);
	  };
	}
	
	module.exports = exports["default"];

/***/ },
/* 1581 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _on = _interopRequireDefault(__webpack_require__(291));
	
	exports.on = _on.default;
	
	var _off = _interopRequireDefault(__webpack_require__(290));
	
	exports.off = _off.default;
	
	var _filter = _interopRequireDefault(__webpack_require__(1580));
	
	exports.filter = _filter.default;
	
	var _listen = _interopRequireDefault(__webpack_require__(1582));
	
	exports.listen = _listen.default;
	var _default = {
	  on: _on.default,
	  off: _off.default,
	  filter: _filter.default,
	  listen: _listen.default
	};
	exports.default = _default;

/***/ },
/* 1582 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _inDOM = _interopRequireDefault(__webpack_require__(84));
	
	var _on = _interopRequireDefault(__webpack_require__(291));
	
	var _off = _interopRequireDefault(__webpack_require__(290));
	
	var listen = function listen() {};
	
	if (_inDOM.default) {
	  listen = function listen(node, eventName, handler, capture) {
	    (0, _on.default)(node, eventName, handler, capture);
	    return function () {
	      (0, _off.default)(node, eventName, handler, capture);
	    };
	  };
	}
	
	var _default = listen;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 1583 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports.default = offsetParent;
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(129));
	
	var _style = _interopRequireDefault(__webpack_require__(154));
	
	function nodeName(node) {
	  return node.nodeName && node.nodeName.toLowerCase();
	}
	
	function offsetParent(node) {
	  var doc = (0, _ownerDocument.default)(node),
	      offsetParent = node && node.offsetParent;
	
	  while (offsetParent && nodeName(node) !== 'html' && (0, _style.default)(offsetParent, 'position') === 'static') {
	    offsetParent = offsetParent.offsetParent;
	  }
	
	  return offsetParent || doc.documentElement;
	}
	
	module.exports = exports["default"];

/***/ },
/* 1584 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports.default = position;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(35));
	
	var _offset = _interopRequireDefault(__webpack_require__(457));
	
	var _offsetParent = _interopRequireDefault(__webpack_require__(1583));
	
	var _scrollTop = _interopRequireDefault(__webpack_require__(458));
	
	var _scrollLeft = _interopRequireDefault(__webpack_require__(1586));
	
	var _style = _interopRequireDefault(__webpack_require__(154));
	
	function nodeName(node) {
	  return node.nodeName && node.nodeName.toLowerCase();
	}
	
	function position(node, offsetParent) {
	  var parentOffset = {
	    top: 0,
	    left: 0
	  },
	      offset; // Fixed elements are offset from window (parentOffset = {top:0, left: 0},
	  // because it is its only offset parent
	
	  if ((0, _style.default)(node, 'position') === 'fixed') {
	    offset = node.getBoundingClientRect();
	  } else {
	    offsetParent = offsetParent || (0, _offsetParent.default)(node);
	    offset = (0, _offset.default)(node);
	    if (nodeName(offsetParent) !== 'html') parentOffset = (0, _offset.default)(offsetParent);
	    parentOffset.top += parseInt((0, _style.default)(offsetParent, 'borderTopWidth'), 10) - (0, _scrollTop.default)(offsetParent) || 0;
	    parentOffset.left += parseInt((0, _style.default)(offsetParent, 'borderLeftWidth'), 10) - (0, _scrollLeft.default)(offsetParent) || 0;
	  } // Subtract parent offsets and node margins
	
	
	  return (0, _extends2.default)({}, offset, {
	    top: offset.top - parentOffset.top - (parseInt((0, _style.default)(node, 'marginTop'), 10) || 0),
	    left: offset.left - parentOffset.left - (parseInt((0, _style.default)(node, 'marginLeft'), 10) || 0)
	  });
	}
	
	module.exports = exports["default"];

/***/ },
/* 1585 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = qsa;
	// Zepto.js
	// (c) 2010-2015 Thomas Fuchs
	// Zepto.js may be freely distributed under the MIT license.
	var simpleSelectorRE = /^[\w-]*$/;
	var toArray = Function.prototype.bind.call(Function.prototype.call, [].slice);
	
	function qsa(element, selector) {
	  var maybeID = selector[0] === '#',
	      maybeClass = selector[0] === '.',
	      nameOnly = maybeID || maybeClass ? selector.slice(1) : selector,
	      isSimple = simpleSelectorRE.test(nameOnly),
	      found;
	
	  if (isSimple) {
	    if (maybeID) {
	      element = element.getElementById ? element : document;
	      return (found = element.getElementById(nameOnly)) ? [found] : [];
	    }
	
	    if (element.getElementsByClassName && maybeClass) return toArray(element.getElementsByClassName(nameOnly));
	    return toArray(element.getElementsByTagName(selector));
	  }
	
	  return toArray(element.querySelectorAll(selector));
	}
	
	module.exports = exports["default"];

/***/ },
/* 1586 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports.default = scrollTop;
	
	var _isWindow = _interopRequireDefault(__webpack_require__(197));
	
	function scrollTop(node, val) {
	  var win = (0, _isWindow.default)(node);
	  if (val === undefined) return win ? 'pageXOffset' in win ? win.pageXOffset : win.document.documentElement.scrollLeft : node.scrollLeft;
	  if (win) win.scrollTo(val, 'pageYOffset' in win ? win.pageYOffset : win.document.documentElement.scrollTop);else node.scrollLeft = val;
	}
	
	module.exports = exports["default"];

/***/ },
/* 1587 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports.default = _getComputedStyle;
	
	var _camelizeStyle = _interopRequireDefault(__webpack_require__(459));
	
	var rposition = /^(top|right|bottom|left)$/;
	var rnumnonpx = /^([+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|))(?!px)[a-z%]+$/i;
	
	function _getComputedStyle(node) {
	  if (!node) throw new TypeError('No Element passed to `getComputedStyle()`');
	  var doc = node.ownerDocument;
	  return 'defaultView' in doc ? doc.defaultView.opener ? node.ownerDocument.defaultView.getComputedStyle(node, null) : window.getComputedStyle(node, null) : {
	    //ie 8 "magic" from: https://github.com/jquery/jquery/blob/1.11-stable/src/css/curCSS.js#L72
	    getPropertyValue: function getPropertyValue(prop) {
	      var style = node.style;
	      prop = (0, _camelizeStyle.default)(prop);
	      if (prop == 'float') prop = 'styleFloat';
	      var current = node.currentStyle[prop] || null;
	      if (current == null && style && style[prop]) current = style[prop];
	
	      if (rnumnonpx.test(current) && !rposition.test(prop)) {
	        // Remember the original values
	        var left = style.left;
	        var runStyle = node.runtimeStyle;
	        var rsLeft = runStyle && runStyle.left; // Put in the new values to get a computed value out
	
	        if (rsLeft) runStyle.left = node.currentStyle.left;
	        style.left = prop === 'fontSize' ? '1em' : current;
	        current = style.pixelLeft + 'px'; // Revert the changed values
	
	        style.left = left;
	        if (rsLeft) runStyle.left = rsLeft;
	      }
	
	      return current;
	    }
	  };
	}
	
	module.exports = exports["default"];

/***/ },
/* 1588 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = removeStyle;
	
	function removeStyle(node, key) {
	  return 'removeProperty' in node.style ? node.style.removeProperty(key) : node.style.removeAttribute(key);
	}
	
	module.exports = exports["default"];

/***/ },
/* 1589 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _properties = _interopRequireDefault(__webpack_require__(292));
	
	var _style = _interopRequireDefault(__webpack_require__(154));
	
	function onEnd(node, handler, duration) {
	  var fakeEvent = {
	    target: node,
	    currentTarget: node
	  },
	      backup;
	  if (!_properties.default.end) duration = 0;else if (duration == null) duration = parseDuration(node) || 0;
	
	  if (_properties.default.end) {
	    node.addEventListener(_properties.default.end, done, false);
	    backup = setTimeout(function () {
	      return done(fakeEvent);
	    }, (duration || 100) * 1.5);
	  } else setTimeout(done.bind(null, fakeEvent), 0);
	
	  function done(event) {
	    if (event.target !== event.currentTarget) return;
	    clearTimeout(backup);
	    event.target.removeEventListener(_properties.default.end, done);
	    handler.call(this);
	  }
	}
	
	onEnd._parseDuration = parseDuration;
	var _default = onEnd;
	exports.default = _default;
	
	function parseDuration(node) {
	  var str = (0, _style.default)(node, _properties.default.duration),
	      mult = str.indexOf('ms') === -1 ? 1000 : 1;
	  return parseFloat(str) * mult;
	}
	
	module.exports = exports["default"];

/***/ },
/* 1590 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _end = _interopRequireDefault(__webpack_require__(1589));
	
	exports.end = _end.default;
	
	var _properties = _interopRequireDefault(__webpack_require__(292));
	
	exports.properties = _properties.default;
	var _default = {
	  end: _end.default,
	  properties: _properties.default
	};
	exports.default = _default;

/***/ },
/* 1591 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = isTransform;
	var supportedTransforms = /^((translate|rotate|scale)(X|Y|Z|3d)?|matrix(3d)?|perspective|skew(X|Y)?)$/i;
	
	function isTransform(property) {
	  return !!(property && supportedTransforms.test(property));
	}
	
	module.exports = exports["default"];

/***/ },
/* 1592 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = camelize;
	var rHyphen = /-(.)/g;
	
	function camelize(string) {
	  return string.replace(rHyphen, function (_, chr) {
	    return chr.toUpperCase();
	  });
	}
	
	module.exports = exports["default"];

/***/ },
/* 1593 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = hyphenate;
	var rUpper = /([A-Z])/g;
	
	function hyphenate(string) {
	  return string.replace(rUpper, '-$1').toLowerCase();
	}
	
	module.exports = exports["default"];

/***/ },
/* 1594 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports.default = hyphenateStyleName;
	
	var _hyphenate = _interopRequireDefault(__webpack_require__(1593));
	
	/**
	 * Copyright 2013-2014, Facebook, Inc.
	 * All rights reserved.
	 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/hyphenateStyleName.js
	 */
	var msPattern = /^ms-/;
	
	function hyphenateStyleName(string) {
	  return (0, _hyphenate.default)(string).replace(msPattern, '-ms-');
	}
	
	module.exports = exports["default"];

/***/ },
/* 1595 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _extendableBuiltin(cls) {
	  function ExtendableBuiltin() {
	    cls.apply(this, arguments);
	  }
	
	  ExtendableBuiltin.prototype = Object.create(cls.prototype, {
	    constructor: {
	      value: cls,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	
	  if (Object.setPrototypeOf) {
	    Object.setPrototypeOf(ExtendableBuiltin, cls);
	  } else {
	    ExtendableBuiltin.__proto__ = cls;
	  }
	
	  return ExtendableBuiltin;
	}
	
	var ExtendableError = function (_extendableBuiltin2) {
	  _inherits(ExtendableError, _extendableBuiltin2);
	
	  function ExtendableError() {
	    var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	    _classCallCheck(this, ExtendableError);
	
	    // extending Error is weird and does not propagate `message`
	    var _this = _possibleConstructorReturn(this, (ExtendableError.__proto__ || Object.getPrototypeOf(ExtendableError)).call(this, message));
	
	    Object.defineProperty(_this, 'message', {
	      configurable: true,
	      enumerable: false,
	      value: message,
	      writable: true
	    });
	
	    Object.defineProperty(_this, 'name', {
	      configurable: true,
	      enumerable: false,
	      value: _this.constructor.name,
	      writable: true
	    });
	
	    if (Error.hasOwnProperty('captureStackTrace')) {
	      Error.captureStackTrace(_this, _this.constructor);
	      return _possibleConstructorReturn(_this);
	    }
	
	    Object.defineProperty(_this, 'stack', {
	      configurable: true,
	      enumerable: false,
	      value: new Error(message).stack,
	      writable: true
	    });
	    return _this;
	  }
	
	  return ExtendableError;
	}(_extendableBuiltin(Error));
	
	exports.default = ExtendableError;
	module.exports = exports['default'];


/***/ },
/* 1596 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/glyphicons-halflings-regular.89889688.svg";

/***/ },
/* 1597 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/glyphicons-halflings-regular.e18bbf61.ttf";

/***/ },
/* 1598 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/glyphicons-halflings-regular.fa277232.woff";

/***/ },
/* 1599 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/glyphicons-halflings-regular.448c34a5.woff2";

/***/ },
/* 1600 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/Pe-icon-7-filled.4483f746.eot";

/***/ },
/* 1601 */
1600,
/* 1602 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/Pe-icon-7-filled.07738af6.svg";

/***/ },
/* 1603 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/Pe-icon-7-filled.05951ccf.ttf";

/***/ },
/* 1604 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/Pe-icon-7-filled.b18b07ac.woff";

/***/ },
/* 1605 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/Pe-icon-7-stroke.71394c0c.eot";

/***/ },
/* 1606 */
1605,
/* 1607 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/Pe-icon-7-stroke.c45f7de0.svg";

/***/ },
/* 1608 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/Pe-icon-7-stroke.01798bc1.ttf";

/***/ },
/* 1609 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/Pe-icon-7-stroke.b38ef310.woff";

/***/ },
/* 1610 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/404-error.62e63b8f.png";

/***/ },
/* 1611 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/banner03.923272d4.png";

/***/ },
/* 1612 */
462,
/* 1613 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/coming-soon.3a144521.png";

/***/ },
/* 1614 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/es.e863471d.png";

/***/ },
/* 1615 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/forgot-password.bc727678.png";

/***/ },
/* 1616 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/icheck-orange.1aeb9bfc.png";

/***/ },
/* 1617 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/icon-business.50b9419d.svg";

/***/ },
/* 1618 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/icon-plus-orange.fb9bf7d8.svg";

/***/ },
/* 1619 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/privacy.b567fcc9.png";

/***/ },
/* 1620 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/privacygray.2a9b3c70.png";

/***/ },
/* 1621 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/seccondgray.82d399d6.png";

/***/ },
/* 1622 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/secconn.fd5275bd.png";

/***/ },
/* 1623 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ssl.b2504e08.png";

/***/ },
/* 1624 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/sslgray.d7c66ea9.png";

/***/ },
/* 1625 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/stripe.3de2c72d.png";

/***/ },
/* 1626 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/success.817436e9.png";

/***/ },
/* 1627 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/textureBanners.3c75d84c.jpg";

/***/ },
/* 1628 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/us.2430007a.png";

/***/ },
/* 1629 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var _extends = __webpack_require__(35);
	var _objectWithoutPropertiesLoose = __webpack_require__(43);
	
	function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }
	
	var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
	var _objectWithoutPropertiesLoose__default = /*#__PURE__*/_interopDefaultLegacy(_objectWithoutPropertiesLoose);
	
	//      
	var charCodeOfDot = ".".charCodeAt(0);
	var reEscapeChar = /\\(\\)?/g;
	var rePropName = RegExp( // Match anything that isn't a dot or bracket.
	"[^.[\\]]+" + "|" + // Or match property names within brackets.
	"\\[(?:" + // Match a non-string expression.
	"([^\"'][^[]*)" + "|" + // Or match strings (supports escaping characters).
	"([\"'])((?:(?!\\2)[^\\\\]|\\\\.)*?)\\2" + ")\\]" + "|" + // Or match "" as the space between consecutive dots or empty brackets.
	"(?=(?:\\.|\\[\\])(?:\\.|\\[\\]|$))", "g");
	/**
	 * Converts `string` to a property path array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the property path array.
	 */
	
	var stringToPath = function stringToPath(string) {
	  var result = [];
	
	  if (string.charCodeAt(0) === charCodeOfDot) {
	    result.push("");
	  }
	
	  string.replace(rePropName, function (match, expression, quote, subString) {
	    var key = match;
	
	    if (quote) {
	      key = subString.replace(reEscapeChar, "$1");
	    } else if (expression) {
	      key = expression.trim();
	    }
	
	    result.push(key);
	  });
	  return result;
	};
	
	var keysCache = {};
	
	var toPath = function toPath(key) {
	  if (key === null || key === undefined || !key.length) {
	    return [];
	  }
	
	  if (typeof key !== "string") {
	    throw new Error("toPath() expects a string");
	  }
	
	  if (keysCache[key] == null) {
	    keysCache[key] = stringToPath(key);
	  }
	
	  return keysCache[key];
	};
	
	//      
	
	var getIn = function getIn(state, complexKey) {
	  // Intentionally using iteration rather than recursion
	  var path = toPath(complexKey);
	  var current = state;
	
	  for (var i = 0; i < path.length; i++) {
	    var key = path[i];
	
	    if (current === undefined || current === null || typeof current !== "object" || Array.isArray(current) && isNaN(key)) {
	      return undefined;
	    }
	
	    current = current[key];
	  }
	
	  return current;
	};
	
	function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
	
	function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
	
	var setInRecursor = function setInRecursor(current, index, path, value, destroyArrays) {
	  if (index >= path.length) {
	    // end of recursion
	    return value;
	  }
	
	  var key = path[index]; // determine type of key
	
	  if (isNaN(key)) {
	    var _extends2;
	
	    // object set
	    if (current === undefined || current === null) {
	      var _ref;
	
	      // recurse
	      var _result2 = setInRecursor(undefined, index + 1, path, value, destroyArrays); // delete or create an object
	
	
	      return _result2 === undefined ? undefined : (_ref = {}, _ref[key] = _result2, _ref);
	    }
	
	    if (Array.isArray(current)) {
	      throw new Error("Cannot set a non-numeric property on an array");
	    } // current exists, so make a copy of all its values, and add/update the new one
	
	
	    var _result = setInRecursor(current[key], index + 1, path, value, destroyArrays);
	
	    if (_result === undefined) {
	      var numKeys = Object.keys(current).length;
	
	      if (current[key] === undefined && numKeys === 0) {
	        // object was already empty
	        return undefined;
	      }
	
	      if (current[key] !== undefined && numKeys <= 1) {
	        // only key we had was the one we are deleting
	        if (!isNaN(path[index - 1]) && !destroyArrays) {
	          // we are in an array, so return an empty object
	          return {};
	        } else {
	          return undefined;
	        }
	      }
	
	      current[key];
	          var _final = _objectWithoutPropertiesLoose__default["default"](current, [key].map(_toPropertyKey));
	
	      return _final;
	    } // set result in key
	
	
	    return _extends__default["default"]({}, current, (_extends2 = {}, _extends2[key] = _result, _extends2));
	  } // array set
	
	
	  var numericKey = Number(key);
	
	  if (current === undefined || current === null) {
	    // recurse
	    var _result3 = setInRecursor(undefined, index + 1, path, value, destroyArrays); // if nothing returned, delete it
	
	
	    if (_result3 === undefined) {
	      return undefined;
	    } // create an array
	
	
	    var _array = [];
	    _array[numericKey] = _result3;
	    return _array;
	  }
	
	  if (!Array.isArray(current)) {
	    throw new Error("Cannot set a numeric property on an object");
	  } // recurse
	
	
	  var existingValue = current[numericKey];
	  var result = setInRecursor(existingValue, index + 1, path, value, destroyArrays); // current exists, so make a copy of all its values, and add/update the new one
	
	  var array = [].concat(current);
	
	  if (destroyArrays && result === undefined) {
	    array.splice(numericKey, 1);
	
	    if (array.length === 0) {
	      return undefined;
	    }
	  } else {
	    array[numericKey] = result;
	  }
	
	  return array;
	};
	
	var setIn = function setIn(state, key, value, destroyArrays) {
	  if (destroyArrays === void 0) {
	    destroyArrays = false;
	  }
	
	  if (state === undefined || state === null) {
	    throw new Error("Cannot call setIn() with " + String(state) + " state");
	  }
	
	  if (key === undefined || key === null) {
	    throw new Error("Cannot call setIn() with " + String(key) + " key");
	  } // Recursive function needs to accept and return State, but public API should
	  // only deal with Objects
	
	
	  return setInRecursor(state, 0, toPath(key), value, destroyArrays);
	};
	
	var FORM_ERROR = "FINAL_FORM/form-error";
	var ARRAY_ERROR = "FINAL_FORM/array-error";
	
	//      
	/**
	 * Converts internal field state to published field state
	 */
	
	function publishFieldState(formState, field) {
	  var errors = formState.errors,
	      initialValues = formState.initialValues,
	      lastSubmittedValues = formState.lastSubmittedValues,
	      submitErrors = formState.submitErrors,
	      submitFailed = formState.submitFailed,
	      submitSucceeded = formState.submitSucceeded,
	      submitting = formState.submitting,
	      values = formState.values;
	  var active = field.active,
	      blur = field.blur,
	      change = field.change,
	      data = field.data,
	      focus = field.focus,
	      modified = field.modified,
	      modifiedSinceLastSubmit = field.modifiedSinceLastSubmit,
	      name = field.name,
	      touched = field.touched,
	      validating = field.validating,
	      visited = field.visited;
	  var value = getIn(values, name);
	  var error = getIn(errors, name);
	
	  if (error && error[ARRAY_ERROR]) {
	    error = error[ARRAY_ERROR];
	  }
	
	  var submitError = submitErrors && getIn(submitErrors, name);
	  var initial = initialValues && getIn(initialValues, name);
	  var pristine = field.isEqual(initial, value);
	  var dirtySinceLastSubmit = !!(lastSubmittedValues && !field.isEqual(getIn(lastSubmittedValues, name), value));
	  var valid = !error && !submitError;
	  return {
	    active: active,
	    blur: blur,
	    change: change,
	    data: data,
	    dirty: !pristine,
	    dirtySinceLastSubmit: dirtySinceLastSubmit,
	    error: error,
	    focus: focus,
	    initial: initial,
	    invalid: !valid,
	    length: Array.isArray(value) ? value.length : undefined,
	    modified: modified,
	    modifiedSinceLastSubmit: modifiedSinceLastSubmit,
	    name: name,
	    pristine: pristine,
	    submitError: submitError,
	    submitFailed: submitFailed,
	    submitSucceeded: submitSucceeded,
	    submitting: submitting,
	    touched: touched,
	    valid: valid,
	    value: value,
	    visited: visited,
	    validating: validating
	  };
	}
	
	//      
	var fieldSubscriptionItems = ["active", "data", "dirty", "dirtySinceLastSubmit", "error", "initial", "invalid", "length", "modified", "modifiedSinceLastSubmit", "pristine", "submitError", "submitFailed", "submitSucceeded", "submitting", "touched", "valid", "value", "visited", "validating"];
	
	//      
	var shallowEqual = function shallowEqual(a, b) {
	  if (a === b) {
	    return true;
	  }
	
	  if (typeof a !== "object" || !a || typeof b !== "object" || !b) {
	    return false;
	  }
	
	  var keysA = Object.keys(a);
	  var keysB = Object.keys(b);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(b);
	
	  for (var idx = 0; idx < keysA.length; idx++) {
	    var key = keysA[idx];
	
	    if (!bHasOwnProperty(key) || a[key] !== b[key]) {
	      return false;
	    }
	  }
	
	  return true;
	};
	
	//      
	function subscriptionFilter (dest, src, previous, subscription, keys, shallowEqualKeys) {
	  var different = false;
	  keys.forEach(function (key) {
	    if (subscription[key]) {
	      dest[key] = src[key];
	
	      if (!previous || (~shallowEqualKeys.indexOf(key) ? !shallowEqual(src[key], previous[key]) : src[key] !== previous[key])) {
	        different = true;
	      }
	    }
	  });
	  return different;
	}
	
	//      
	var shallowEqualKeys$1 = ["data"];
	/**
	 * Filters items in a FieldState based on a FieldSubscription
	 */
	
	var filterFieldState = function filterFieldState(state, previousState, subscription, force) {
	  var result = {
	    blur: state.blur,
	    change: state.change,
	    focus: state.focus,
	    name: state.name
	  };
	  var different = subscriptionFilter(result, state, previousState, subscription, fieldSubscriptionItems, shallowEqualKeys$1) || !previousState;
	  return different || force ? result : undefined;
	};
	
	//      
	var formSubscriptionItems = ["active", "dirty", "dirtyFields", "dirtyFieldsSinceLastSubmit", "dirtySinceLastSubmit", "error", "errors", "hasSubmitErrors", "hasValidationErrors", "initialValues", "invalid", "modified", "modifiedSinceLastSubmit", "pristine", "submitting", "submitError", "submitErrors", "submitFailed", "submitSucceeded", "touched", "valid", "validating", "values", "visited"];
	
	//      
	var shallowEqualKeys = ["touched", "visited"];
	/**
	 * Filters items in a FormState based on a FormSubscription
	 */
	
	function filterFormState(state, previousState, subscription, force) {
	  var result = {};
	  var different = subscriptionFilter(result, state, previousState, subscription, formSubscriptionItems, shallowEqualKeys) || !previousState;
	  return different || force ? result : undefined;
	}
	
	//      
	
	var memoize = function memoize(fn) {
	  var lastArgs;
	  var lastResult;
	  return function () {
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    if (!lastArgs || args.length !== lastArgs.length || args.some(function (arg, index) {
	      return !shallowEqual(lastArgs[index], arg);
	    })) {
	      lastArgs = args;
	      lastResult = fn.apply(void 0, args);
	    }
	
	    return lastResult;
	  };
	};
	
	var isPromise = (function (obj) {
	  return !!obj && (typeof obj === "object" || typeof obj === "function") && typeof obj.then === "function";
	});
	
	var version = "4.20.7";
	
	var configOptions = ["debug", "initialValues", "keepDirtyOnReinitialize", "mutators", "onSubmit", "validate", "validateOnBlur"];
	
	var tripleEquals = function tripleEquals(a, b) {
	  return a === b;
	};
	
	var hasAnyError = function hasAnyError(errors) {
	  return Object.keys(errors).some(function (key) {
	    var value = errors[key];
	
	    if (value && typeof value === "object" && !(value instanceof Error)) {
	      return hasAnyError(value);
	    }
	
	    return typeof value !== "undefined";
	  });
	};
	
	function convertToExternalFormState(_ref) {
	  var active = _ref.active,
	      dirtySinceLastSubmit = _ref.dirtySinceLastSubmit,
	      modifiedSinceLastSubmit = _ref.modifiedSinceLastSubmit,
	      error = _ref.error,
	      errors = _ref.errors,
	      initialValues = _ref.initialValues,
	      pristine = _ref.pristine,
	      submitting = _ref.submitting,
	      submitFailed = _ref.submitFailed,
	      submitSucceeded = _ref.submitSucceeded,
	      submitError = _ref.submitError,
	      submitErrors = _ref.submitErrors,
	      valid = _ref.valid,
	      validating = _ref.validating,
	      values = _ref.values;
	  return {
	    active: active,
	    dirty: !pristine,
	    dirtySinceLastSubmit: dirtySinceLastSubmit,
	    modifiedSinceLastSubmit: modifiedSinceLastSubmit,
	    error: error,
	    errors: errors,
	    hasSubmitErrors: !!(submitError || submitErrors && hasAnyError(submitErrors)),
	    hasValidationErrors: !!(error || hasAnyError(errors)),
	    invalid: !valid,
	    initialValues: initialValues,
	    pristine: pristine,
	    submitting: submitting,
	    submitFailed: submitFailed,
	    submitSucceeded: submitSucceeded,
	    submitError: submitError,
	    submitErrors: submitErrors,
	    valid: valid,
	    validating: validating > 0,
	    values: values
	  };
	}
	
	function notifySubscriber(subscriber, subscription, state, lastState, filter, force) {
	  var notification = filter(state, lastState, subscription, force);
	
	  if (notification) {
	    subscriber(notification);
	    return true;
	  }
	
	  return false;
	}
	
	function notify(_ref2, state, lastState, filter, force) {
	  var entries = _ref2.entries;
	  Object.keys(entries).forEach(function (key) {
	    var entry = entries[Number(key)]; // istanbul ignore next
	
	    if (entry) {
	      var subscription = entry.subscription,
	          subscriber = entry.subscriber,
	          notified = entry.notified;
	
	      if (notifySubscriber(subscriber, subscription, state, lastState, filter, force || !notified)) {
	        entry.notified = true;
	      }
	    }
	  });
	}
	
	function createForm(config) {
	  if (!config) {
	    throw new Error("No config specified");
	  }
	
	  var debug = config.debug,
	      destroyOnUnregister = config.destroyOnUnregister,
	      keepDirtyOnReinitialize = config.keepDirtyOnReinitialize,
	      initialValues = config.initialValues,
	      mutators = config.mutators,
	      onSubmit = config.onSubmit,
	      validate = config.validate,
	      validateOnBlur = config.validateOnBlur;
	
	  if (!onSubmit) {
	    throw new Error("No onSubmit function specified");
	  }
	
	  var state = {
	    subscribers: {
	      index: 0,
	      entries: {}
	    },
	    fieldSubscribers: {},
	    fields: {},
	    formState: {
	      asyncErrors: {},
	      dirtySinceLastSubmit: false,
	      modifiedSinceLastSubmit: false,
	      errors: {},
	      initialValues: initialValues && _extends__default["default"]({}, initialValues),
	      invalid: false,
	      pristine: true,
	      submitting: false,
	      submitFailed: false,
	      submitSucceeded: false,
	      resetWhileSubmitting: false,
	      valid: true,
	      validating: 0,
	      values: initialValues ? _extends__default["default"]({}, initialValues) : {}
	    },
	    lastFormState: undefined
	  };
	  var inBatch = 0;
	  var validationPaused = false;
	  var validationBlocked = false;
	  var preventNotificationWhileValidationPaused = false;
	  var nextAsyncValidationKey = 0;
	  var asyncValidationPromises = {};
	
	  var clearAsyncValidationPromise = function clearAsyncValidationPromise(key) {
	    return function (result) {
	      delete asyncValidationPromises[key];
	      return result;
	    };
	  };
	
	  var changeValue = function changeValue(state, name, mutate) {
	    var before = getIn(state.formState.values, name);
	    var after = mutate(before);
	    state.formState.values = setIn(state.formState.values, name, after) || {};
	  };
	
	  var renameField = function renameField(state, from, to) {
	    if (state.fields[from]) {
	      var _extends2, _extends3;
	
	      state.fields = _extends__default["default"]({}, state.fields, (_extends2 = {}, _extends2[to] = _extends__default["default"]({}, state.fields[from], {
	        name: to,
	        // rebind event handlers
	        blur: function blur() {
	          return api.blur(to);
	        },
	        change: function change(value) {
	          return api.change(to, value);
	        },
	        focus: function focus() {
	          return api.focus(to);
	        },
	        lastFieldState: undefined
	      }), _extends2));
	      delete state.fields[from];
	      state.fieldSubscribers = _extends__default["default"]({}, state.fieldSubscribers, (_extends3 = {}, _extends3[to] = state.fieldSubscribers[from], _extends3));
	      delete state.fieldSubscribers[from];
	      var value = getIn(state.formState.values, from);
	      state.formState.values = setIn(state.formState.values, from, undefined) || {};
	      state.formState.values = setIn(state.formState.values, to, value);
	      delete state.lastFormState;
	    }
	  }; // bind state to mutators
	
	
	  var getMutatorApi = function getMutatorApi(key) {
	    return function () {
	      // istanbul ignore next
	      if (mutators) {
	        // ^^ causes branch coverage warning, but needed to appease the Flow gods
	        var mutatableState = {
	          formState: state.formState,
	          fields: state.fields,
	          fieldSubscribers: state.fieldSubscribers,
	          lastFormState: state.lastFormState
	        };
	
	        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        var returnValue = mutators[key](args, mutatableState, {
	          changeValue: changeValue,
	          getIn: getIn,
	          renameField: renameField,
	          resetFieldState: api.resetFieldState,
	          setIn: setIn,
	          shallowEqual: shallowEqual
	        });
	        state.formState = mutatableState.formState;
	        state.fields = mutatableState.fields;
	        state.fieldSubscribers = mutatableState.fieldSubscribers;
	        state.lastFormState = mutatableState.lastFormState;
	        runValidation(undefined, function () {
	          notifyFieldListeners();
	          notifyFormListeners();
	        });
	        return returnValue;
	      }
	    };
	  };
	
	  var mutatorsApi = mutators ? Object.keys(mutators).reduce(function (result, key) {
	    result[key] = getMutatorApi(key);
	    return result;
	  }, {}) : {};
	
	  var runRecordLevelValidation = function runRecordLevelValidation(setErrors) {
	    var promises = [];
	
	    if (validate) {
	      var errorsOrPromise = validate(_extends__default["default"]({}, state.formState.values)); // clone to avoid writing
	
	      if (isPromise(errorsOrPromise)) {
	        promises.push(errorsOrPromise.then(function (errors) {
	          return setErrors(errors, true);
	        }));
	      } else {
	        setErrors(errorsOrPromise, false);
	      }
	    }
	
	    return promises;
	  };
	
	  var getValidators = function getValidators(field) {
	    return Object.keys(field.validators).reduce(function (result, index) {
	      var validator = field.validators[Number(index)]();
	
	      if (validator) {
	        result.push(validator);
	      }
	
	      return result;
	    }, []);
	  };
	
	  var runFieldLevelValidation = function runFieldLevelValidation(field, setError) {
	    var promises = [];
	    var validators = getValidators(field);
	
	    if (validators.length) {
	      var error;
	      validators.forEach(function (validator) {
	        var errorOrPromise = validator(getIn(state.formState.values, field.name), state.formState.values, validator.length === 0 || validator.length === 3 ? publishFieldState(state.formState, state.fields[field.name]) : undefined);
	
	        if (errorOrPromise && isPromise(errorOrPromise)) {
	          field.validating = true;
	          var promise = errorOrPromise.then(function (error) {
	            if (state.fields[field.name]) {
	              state.fields[field.name].validating = false;
	              setError(error);
	            }
	          }); // errors must be resolved, not rejected
	
	          promises.push(promise);
	        } else if (!error) {
	          // first registered validator wins
	          error = errorOrPromise;
	        }
	      });
	      setError(error);
	    }
	
	    return promises;
	  };
	
	  var runValidation = function runValidation(fieldChanged, callback) {
	    if (validationPaused) {
	      validationBlocked = true;
	      callback();
	      return;
	    }
	
	    var fields = state.fields,
	        formState = state.formState;
	
	    var safeFields = _extends__default["default"]({}, fields);
	
	    var fieldKeys = Object.keys(safeFields);
	
	    if (!validate && !fieldKeys.some(function (key) {
	      return getValidators(safeFields[key]).length;
	    })) {
	      callback();
	      return; // no validation rules
	    } // pare down field keys to actually validate
	
	
	    var limitedFieldLevelValidation = false;
	
	    if (fieldChanged) {
	      var changedField = safeFields[fieldChanged];
	
	      if (changedField) {
	        var validateFields = changedField.validateFields;
	
	        if (validateFields) {
	          limitedFieldLevelValidation = true;
	          fieldKeys = validateFields.length ? validateFields.concat(fieldChanged) : [fieldChanged];
	        }
	      }
	    }
	
	    var recordLevelErrors = {};
	    var asyncRecordLevelErrors = {};
	    var fieldLevelErrors = {};
	    var promises = [].concat(runRecordLevelValidation(function (errors, wasAsync) {
	      if (wasAsync) {
	        asyncRecordLevelErrors = errors || {};
	      } else {
	        recordLevelErrors = errors || {};
	      }
	    }), fieldKeys.reduce(function (result, name) {
	      return result.concat(runFieldLevelValidation(fields[name], function (error) {
	        fieldLevelErrors[name] = error;
	      }));
	    }, []));
	    var hasAsyncValidations = promises.length > 0;
	    var asyncValidationPromiseKey = ++nextAsyncValidationKey;
	    var promise = Promise.all(promises).then(clearAsyncValidationPromise(asyncValidationPromiseKey)); // backwards-compat: add promise to submit-blocking promises iff there are any promises to await
	
	    if (hasAsyncValidations) {
	      asyncValidationPromises[asyncValidationPromiseKey] = promise;
	    }
	
	    var processErrors = function processErrors(afterAsync) {
	      var merged = _extends__default["default"]({}, limitedFieldLevelValidation ? formState.errors : {}, recordLevelErrors, afterAsync ? asyncRecordLevelErrors // new async errors
	      : formState.asyncErrors);
	
	      var forEachError = function forEachError(fn) {
	        fieldKeys.forEach(function (name) {
	          if (fields[name]) {
	            // make sure field is still registered
	            // field-level errors take precedent over record-level errors
	            var recordLevelError = getIn(recordLevelErrors, name);
	            var errorFromParent = getIn(merged, name);
	            var hasFieldLevelValidation = getValidators(safeFields[name]).length;
	            var fieldLevelError = fieldLevelErrors[name];
	            fn(name, hasFieldLevelValidation && fieldLevelError || validate && recordLevelError || (!recordLevelError && !limitedFieldLevelValidation ? errorFromParent : undefined));
	          }
	        });
	      };
	
	      forEachError(function (name, error) {
	        merged = setIn(merged, name, error) || {};
	      });
	      forEachError(function (name, error) {
	        if (error && error[ARRAY_ERROR]) {
	          var existing = getIn(merged, name);
	          var copy = [].concat(existing);
	          copy[ARRAY_ERROR] = error[ARRAY_ERROR];
	          merged = setIn(merged, name, copy);
	        }
	      });
	
	      if (!shallowEqual(formState.errors, merged)) {
	        formState.errors = merged;
	      }
	
	      if (afterAsync) {
	        formState.asyncErrors = asyncRecordLevelErrors;
	      }
	
	      formState.error = recordLevelErrors[FORM_ERROR];
	    };
	
	    if (hasAsyncValidations) {
	      // async validations are running, ensure validating is true before notifying
	      state.formState.validating++;
	      callback();
	    } // process sync errors
	
	
	    processErrors(false); // sync errors have been set. notify listeners while we wait for others
	
	    callback();
	
	    if (hasAsyncValidations) {
	      var afterPromise = function afterPromise() {
	        state.formState.validating--;
	        callback();
	      };
	
	      promise.then(function () {
	        if (nextAsyncValidationKey > asyncValidationPromiseKey) {
	          // if this async validator has been superseded by another, ignore its results
	          return;
	        }
	
	        processErrors(true);
	      }).then(afterPromise, afterPromise);
	    }
	  };
	
	  var notifyFieldListeners = function notifyFieldListeners(name) {
	    if (inBatch) {
	      return;
	    }
	
	    var fields = state.fields,
	        fieldSubscribers = state.fieldSubscribers,
	        formState = state.formState;
	
	    var safeFields = _extends__default["default"]({}, fields);
	
	    var notifyField = function notifyField(name) {
	      var field = safeFields[name];
	      var fieldState = publishFieldState(formState, field);
	      var lastFieldState = field.lastFieldState;
	      field.lastFieldState = fieldState;
	      var fieldSubscriber = fieldSubscribers[name];
	
	      if (fieldSubscriber) {
	        notify(fieldSubscriber, fieldState, lastFieldState, filterFieldState, lastFieldState === undefined);
	      }
	    };
	
	    if (name) {
	      notifyField(name);
	    } else {
	      Object.keys(safeFields).forEach(notifyField);
	    }
	  };
	
	  var markAllFieldsTouched = function markAllFieldsTouched() {
	    Object.keys(state.fields).forEach(function (key) {
	      state.fields[key].touched = true;
	    });
	  };
	
	  var hasSyncErrors = function hasSyncErrors() {
	    return !!(state.formState.error || hasAnyError(state.formState.errors));
	  };
	
	  var calculateNextFormState = function calculateNextFormState() {
	    var fields = state.fields,
	        formState = state.formState,
	        lastFormState = state.lastFormState;
	
	    var safeFields = _extends__default["default"]({}, fields);
	
	    var safeFieldKeys = Object.keys(safeFields); // calculate dirty/pristine
	
	    var foundDirty = false;
	    var dirtyFields = safeFieldKeys.reduce(function (result, key) {
	      var dirty = !safeFields[key].isEqual(getIn(formState.values, key), getIn(formState.initialValues || {}, key));
	
	      if (dirty) {
	        foundDirty = true;
	        result[key] = true;
	      }
	
	      return result;
	    }, {});
	    var dirtyFieldsSinceLastSubmit = safeFieldKeys.reduce(function (result, key) {
	      // istanbul ignore next
	      var nonNullLastSubmittedValues = formState.lastSubmittedValues || {}; // || {} is for flow, but causes branch coverage complaint
	
	      if (!safeFields[key].isEqual(getIn(formState.values, key), getIn(nonNullLastSubmittedValues, key))) {
	        result[key] = true;
	      }
	
	      return result;
	    }, {});
	    formState.pristine = !foundDirty;
	    formState.dirtySinceLastSubmit = !!(formState.lastSubmittedValues && Object.values(dirtyFieldsSinceLastSubmit).some(function (value) {
	      return value;
	    }));
	    formState.modifiedSinceLastSubmit = !!(formState.lastSubmittedValues && // Object.values would treat values as mixed (facebook/flow#2221)
	    Object.keys(safeFields).some(function (value) {
	      return safeFields[value].modifiedSinceLastSubmit;
	    }));
	    formState.valid = !formState.error && !formState.submitError && !hasAnyError(formState.errors) && !(formState.submitErrors && hasAnyError(formState.submitErrors));
	    var nextFormState = convertToExternalFormState(formState);
	
	    var _safeFieldKeys$reduce = safeFieldKeys.reduce(function (result, key) {
	      result.modified[key] = safeFields[key].modified;
	      result.touched[key] = safeFields[key].touched;
	      result.visited[key] = safeFields[key].visited;
	      return result;
	    }, {
	      modified: {},
	      touched: {},
	      visited: {}
	    }),
	        modified = _safeFieldKeys$reduce.modified,
	        touched = _safeFieldKeys$reduce.touched,
	        visited = _safeFieldKeys$reduce.visited;
	
	    nextFormState.dirtyFields = lastFormState && shallowEqual(lastFormState.dirtyFields, dirtyFields) ? lastFormState.dirtyFields : dirtyFields;
	    nextFormState.dirtyFieldsSinceLastSubmit = lastFormState && shallowEqual(lastFormState.dirtyFieldsSinceLastSubmit, dirtyFieldsSinceLastSubmit) ? lastFormState.dirtyFieldsSinceLastSubmit : dirtyFieldsSinceLastSubmit;
	    nextFormState.modified = lastFormState && shallowEqual(lastFormState.modified, modified) ? lastFormState.modified : modified;
	    nextFormState.touched = lastFormState && shallowEqual(lastFormState.touched, touched) ? lastFormState.touched : touched;
	    nextFormState.visited = lastFormState && shallowEqual(lastFormState.visited, visited) ? lastFormState.visited : visited;
	    return lastFormState && shallowEqual(lastFormState, nextFormState) ? lastFormState : nextFormState;
	  };
	
	  var callDebug = function callDebug() {
	    return debug && ("production") !== "production" && debug(calculateNextFormState(), Object.keys(state.fields).reduce(function (result, key) {
	      result[key] = state.fields[key];
	      return result;
	    }, {}));
	  };
	
	  var notifying = false;
	  var scheduleNotification = false;
	
	  var notifyFormListeners = function notifyFormListeners() {
	    if (notifying) {
	      scheduleNotification = true;
	    } else {
	      notifying = true;
	      callDebug();
	
	      if (!inBatch && !(validationPaused && preventNotificationWhileValidationPaused)) {
	        var lastFormState = state.lastFormState;
	        var nextFormState = calculateNextFormState();
	
	        if (nextFormState !== lastFormState) {
	          state.lastFormState = nextFormState;
	          notify(state.subscribers, nextFormState, lastFormState, filterFormState);
	        }
	      }
	
	      notifying = false;
	
	      if (scheduleNotification) {
	        scheduleNotification = false;
	        notifyFormListeners();
	      }
	    }
	  };
	
	  var beforeSubmit = function beforeSubmit() {
	    return Object.keys(state.fields).some(function (name) {
	      return state.fields[name].beforeSubmit && state.fields[name].beforeSubmit() === false;
	    });
	  };
	
	  var afterSubmit = function afterSubmit() {
	    return Object.keys(state.fields).forEach(function (name) {
	      return state.fields[name].afterSubmit && state.fields[name].afterSubmit();
	    });
	  };
	
	  var resetModifiedAfterSubmit = function resetModifiedAfterSubmit() {
	    return Object.keys(state.fields).forEach(function (key) {
	      return state.fields[key].modifiedSinceLastSubmit = false;
	    });
	  }; // generate initial errors
	
	
	  runValidation(undefined, function () {
	    notifyFormListeners();
	  });
	  var api = {
	    batch: function batch(fn) {
	      inBatch++;
	      fn();
	      inBatch--;
	      notifyFieldListeners();
	      notifyFormListeners();
	    },
	    blur: function blur(name) {
	      var fields = state.fields,
	          formState = state.formState;
	      var previous = fields[name];
	
	      if (previous) {
	        // can only blur registered fields
	        delete formState.active;
	        fields[name] = _extends__default["default"]({}, previous, {
	          active: false,
	          touched: true
	        });
	
	        if (validateOnBlur) {
	          runValidation(name, function () {
	            notifyFieldListeners();
	            notifyFormListeners();
	          });
	        } else {
	          notifyFieldListeners();
	          notifyFormListeners();
	        }
	      }
	    },
	    change: function change(name, value) {
	      var fields = state.fields,
	          formState = state.formState;
	
	      if (getIn(formState.values, name) !== value) {
	        changeValue(state, name, function () {
	          return value;
	        });
	        var previous = fields[name];
	
	        if (previous) {
	          // only track modified for registered fields
	          fields[name] = _extends__default["default"]({}, previous, {
	            modified: true,
	            modifiedSinceLastSubmit: !!formState.lastSubmittedValues
	          });
	        }
	
	        if (validateOnBlur) {
	          notifyFieldListeners();
	          notifyFormListeners();
	        } else {
	          runValidation(name, function () {
	            notifyFieldListeners();
	            notifyFormListeners();
	          });
	        }
	      }
	    },
	
	    get destroyOnUnregister() {
	      return !!destroyOnUnregister;
	    },
	
	    set destroyOnUnregister(value) {
	      destroyOnUnregister = value;
	    },
	
	    focus: function focus(name) {
	      var field = state.fields[name];
	
	      if (field && !field.active) {
	        state.formState.active = name;
	        field.active = true;
	        field.visited = true;
	        notifyFieldListeners();
	        notifyFormListeners();
	      }
	    },
	    mutators: mutatorsApi,
	    getFieldState: function getFieldState(name) {
	      var field = state.fields[name];
	      return field && field.lastFieldState;
	    },
	    getRegisteredFields: function getRegisteredFields() {
	      return Object.keys(state.fields);
	    },
	    getState: function getState() {
	      return calculateNextFormState();
	    },
	    initialize: function initialize(data) {
	      var fields = state.fields,
	          formState = state.formState;
	
	      var safeFields = _extends__default["default"]({}, fields);
	
	      var values = typeof data === "function" ? data(formState.values) : data;
	
	      if (!keepDirtyOnReinitialize) {
	        formState.values = values;
	      }
	      /**
	       * Hello, inquisitive code reader! Thanks for taking the time to dig in!
	       *
	       * The following code is the way it is to allow for non-registered deep
	       * field values to be set via initialize()
	       */
	      // save dirty values
	
	
	      var savedDirtyValues = keepDirtyOnReinitialize ? Object.keys(safeFields).reduce(function (result, key) {
	        var field = safeFields[key];
	        var pristine = field.isEqual(getIn(formState.values, key), getIn(formState.initialValues || {}, key));
	
	        if (!pristine) {
	          result[key] = getIn(formState.values, key);
	        }
	
	        return result;
	      }, {}) : {}; // update initalValues and values
	
	      formState.initialValues = values;
	      formState.values = values; // restore the dirty values
	
	      Object.keys(savedDirtyValues).forEach(function (key) {
	        formState.values = setIn(formState.values, key, savedDirtyValues[key]) || {};
	      });
	      runValidation(undefined, function () {
	        notifyFieldListeners();
	        notifyFormListeners();
	      });
	    },
	    isValidationPaused: function isValidationPaused() {
	      return validationPaused;
	    },
	    pauseValidation: function pauseValidation(preventNotification) {
	      if (preventNotification === void 0) {
	        preventNotification = true;
	      }
	
	      validationPaused = true;
	      preventNotificationWhileValidationPaused = preventNotification;
	    },
	    registerField: function registerField(name, subscriber, subscription, fieldConfig) {
	      if (subscription === void 0) {
	        subscription = {};
	      }
	
	      if (!state.fieldSubscribers[name]) {
	        state.fieldSubscribers[name] = {
	          index: 0,
	          entries: {}
	        };
	      }
	
	      var index = state.fieldSubscribers[name].index++; // save field subscriber callback
	
	      state.fieldSubscribers[name].entries[index] = {
	        subscriber: memoize(subscriber),
	        subscription: subscription,
	        notified: false
	      };
	
	      if (!state.fields[name]) {
	        // create initial field state
	        state.fields[name] = {
	          active: false,
	          afterSubmit: fieldConfig && fieldConfig.afterSubmit,
	          beforeSubmit: fieldConfig && fieldConfig.beforeSubmit,
	          blur: function blur() {
	            return api.blur(name);
	          },
	          change: function change(value) {
	            return api.change(name, value);
	          },
	          data: fieldConfig && fieldConfig.data || {},
	          focus: function focus() {
	            return api.focus(name);
	          },
	          isEqual: fieldConfig && fieldConfig.isEqual || tripleEquals,
	          lastFieldState: undefined,
	          modified: false,
	          modifiedSinceLastSubmit: false,
	          name: name,
	          touched: false,
	          valid: true,
	          validateFields: fieldConfig && fieldConfig.validateFields,
	          validators: {},
	          validating: false,
	          visited: false
	        };
	      }
	
	      var haveValidator = false;
	      var silent = fieldConfig && fieldConfig.silent;
	
	      var notify = function notify() {
	        if (silent) {
	          notifyFieldListeners(name);
	        } else {
	          notifyFormListeners();
	          notifyFieldListeners();
	        }
	      };
	
	      if (fieldConfig) {
	        haveValidator = !!(fieldConfig.getValidator && fieldConfig.getValidator());
	
	        if (fieldConfig.getValidator) {
	          state.fields[name].validators[index] = fieldConfig.getValidator;
	        }
	
	        var noValueInFormState = getIn(state.formState.values, name) === undefined;
	
	        if (fieldConfig.initialValue !== undefined && (noValueInFormState || getIn(state.formState.values, name) === getIn(state.formState.initialValues, name)) // only initialize if we don't yet have any value for this field
	        ) {
	          state.formState.initialValues = setIn(state.formState.initialValues || {}, name, fieldConfig.initialValue);
	          state.formState.values = setIn(state.formState.values, name, fieldConfig.initialValue);
	          runValidation(undefined, notify);
	        } // only use defaultValue if we don't yet have any value for this field
	
	
	        if (fieldConfig.defaultValue !== undefined && fieldConfig.initialValue === undefined && getIn(state.formState.initialValues, name) === undefined && noValueInFormState) {
	          state.formState.values = setIn(state.formState.values, name, fieldConfig.defaultValue);
	        }
	      }
	
	      if (haveValidator) {
	        runValidation(undefined, notify);
	      } else {
	        notify();
	      }
	
	      return function () {
	        var validatorRemoved = false; // istanbul ignore next
	
	        if (state.fields[name]) {
	          // state.fields[name] may have been removed by a mutator
	          validatorRemoved = !!(state.fields[name].validators[index] && state.fields[name].validators[index]());
	          delete state.fields[name].validators[index];
	        }
	
	        var hasFieldSubscribers = !!state.fieldSubscribers[name];
	
	        if (hasFieldSubscribers) {
	          // state.fieldSubscribers[name] may have been removed by a mutator
	          delete state.fieldSubscribers[name].entries[index];
	        }
	
	        var lastOne = hasFieldSubscribers && !Object.keys(state.fieldSubscribers[name].entries).length;
	
	        if (lastOne) {
	          delete state.fieldSubscribers[name];
	          delete state.fields[name];
	
	          if (validatorRemoved) {
	            state.formState.errors = setIn(state.formState.errors, name, undefined) || {};
	          }
	
	          if (destroyOnUnregister) {
	            state.formState.values = setIn(state.formState.values, name, undefined, true) || {};
	          }
	        }
	
	        if (!silent) {
	          if (validatorRemoved) {
	            runValidation(undefined, function () {
	              notifyFormListeners();
	              notifyFieldListeners();
	            });
	          } else if (lastOne) {
	            // values or errors may have changed
	            notifyFormListeners();
	          }
	        }
	      };
	    },
	    reset: function reset(initialValues) {
	      if (initialValues === void 0) {
	        initialValues = state.formState.initialValues;
	      }
	
	      if (state.formState.submitting) {
	        state.formState.resetWhileSubmitting = true;
	      }
	
	      state.formState.submitFailed = false;
	      state.formState.submitSucceeded = false;
	      delete state.formState.submitError;
	      delete state.formState.submitErrors;
	      delete state.formState.lastSubmittedValues;
	      api.initialize(initialValues || {});
	    },
	
	    /**
	     * Resets all field flags (e.g. touched, visited, etc.) to their initial state
	     */
	    resetFieldState: function resetFieldState(name) {
	      state.fields[name] = _extends__default["default"]({}, state.fields[name], {
	        active: false,
	        lastFieldState: undefined,
	        modified: false,
	        touched: false,
	        valid: true,
	        validating: false,
	        visited: false
	      });
	      runValidation(undefined, function () {
	        notifyFieldListeners();
	        notifyFormListeners();
	      });
	    },
	
	    /**
	     * Returns the form to a clean slate; that is:
	     * - Clear all values
	     * - Resets all fields to their initial state
	     */
	    restart: function restart(initialValues) {
	      if (initialValues === void 0) {
	        initialValues = state.formState.initialValues;
	      }
	
	      api.batch(function () {
	        for (var name in state.fields) {
	          api.resetFieldState(name);
	          state.fields[name] = _extends__default["default"]({}, state.fields[name], {
	            active: false,
	            lastFieldState: undefined,
	            modified: false,
	            modifiedSinceLastSubmit: false,
	            touched: false,
	            valid: true,
	            validating: false,
	            visited: false
	          });
	        }
	
	        api.reset(initialValues);
	      });
	    },
	    resumeValidation: function resumeValidation() {
	      validationPaused = false;
	      preventNotificationWhileValidationPaused = false;
	
	      if (validationBlocked) {
	        // validation was attempted while it was paused, so run it now
	        runValidation(undefined, function () {
	          notifyFieldListeners();
	          notifyFormListeners();
	        });
	      }
	
	      validationBlocked = false;
	    },
	    setConfig: function setConfig(name, value) {
	      switch (name) {
	        case "debug":
	          debug = value;
	          break;
	
	        case "destroyOnUnregister":
	          destroyOnUnregister = value;
	          break;
	
	        case "initialValues":
	          api.initialize(value);
	          break;
	
	        case "keepDirtyOnReinitialize":
	          keepDirtyOnReinitialize = value;
	          break;
	
	        case "mutators":
	          mutators = value;
	
	          if (value) {
	            Object.keys(mutatorsApi).forEach(function (key) {
	              if (!(key in value)) {
	                delete mutatorsApi[key];
	              }
	            });
	            Object.keys(value).forEach(function (key) {
	              mutatorsApi[key] = getMutatorApi(key);
	            });
	          } else {
	            Object.keys(mutatorsApi).forEach(function (key) {
	              delete mutatorsApi[key];
	            });
	          }
	
	          break;
	
	        case "onSubmit":
	          onSubmit = value;
	          break;
	
	        case "validate":
	          validate = value;
	          runValidation(undefined, function () {
	            notifyFieldListeners();
	            notifyFormListeners();
	          });
	          break;
	
	        case "validateOnBlur":
	          validateOnBlur = value;
	          break;
	
	        default:
	          throw new Error("Unrecognised option " + name);
	      }
	    },
	    submit: function submit() {
	      var formState = state.formState;
	
	      if (formState.submitting) {
	        return;
	      }
	
	      delete formState.submitErrors;
	      delete formState.submitError;
	      formState.lastSubmittedValues = _extends__default["default"]({}, formState.values);
	
	      if (hasSyncErrors()) {
	        markAllFieldsTouched();
	        resetModifiedAfterSubmit();
	        state.formState.submitFailed = true;
	        notifyFormListeners();
	        notifyFieldListeners();
	        return; // no submit for you!!
	      }
	
	      var asyncValidationPromisesKeys = Object.keys(asyncValidationPromises);
	
	      if (asyncValidationPromisesKeys.length) {
	        // still waiting on async validation to complete...
	        Promise.all(asyncValidationPromisesKeys.map(function (key) {
	          return asyncValidationPromises[Number(key)];
	        })).then(api.submit, console.error);
	        return;
	      }
	
	      var submitIsBlocked = beforeSubmit();
	
	      if (submitIsBlocked) {
	        return;
	      }
	
	      var resolvePromise;
	      var completeCalled = false;
	
	      var complete = function complete(errors) {
	        formState.submitting = false;
	        var resetWhileSubmitting = formState.resetWhileSubmitting;
	
	        if (resetWhileSubmitting) {
	          formState.resetWhileSubmitting = false;
	        }
	
	        if (errors && hasAnyError(errors)) {
	          formState.submitFailed = true;
	          formState.submitSucceeded = false;
	          formState.submitErrors = errors;
	          formState.submitError = errors[FORM_ERROR];
	          markAllFieldsTouched();
	        } else {
	          if (!resetWhileSubmitting) {
	            formState.submitFailed = false;
	            formState.submitSucceeded = true;
	          }
	
	          afterSubmit();
	        }
	
	        notifyFormListeners();
	        notifyFieldListeners();
	        completeCalled = true;
	
	        if (resolvePromise) {
	          resolvePromise(errors);
	        }
	
	        return errors;
	      };
	
	      formState.submitting = true;
	      formState.submitFailed = false;
	      formState.submitSucceeded = false;
	      formState.lastSubmittedValues = _extends__default["default"]({}, formState.values);
	      resetModifiedAfterSubmit(); // onSubmit is either sync, callback or async with a Promise
	
	      var result = onSubmit(formState.values, api, complete);
	
	      if (!completeCalled) {
	        if (result && isPromise(result)) {
	          // onSubmit is async with a Promise
	          notifyFormListeners(); // let everyone know we are submitting
	
	          notifyFieldListeners(); // notify fields also
	
	          return result.then(complete, function (error) {
	            complete();
	            throw error;
	          });
	        } else if (onSubmit.length >= 3) {
	          // must be async, so we should return a Promise
	          notifyFormListeners(); // let everyone know we are submitting
	
	          notifyFieldListeners(); // notify fields also
	
	          return new Promise(function (resolve) {
	            resolvePromise = resolve;
	          });
	        } else {
	          // onSubmit is sync
	          complete(result);
	        }
	      }
	    },
	    subscribe: function subscribe(subscriber, subscription) {
	      if (!subscriber) {
	        throw new Error("No callback given.");
	      }
	
	      if (!subscription) {
	        throw new Error("No subscription provided. What values do you want to listen to?");
	      }
	
	      var memoized = memoize(subscriber);
	      var subscribers = state.subscribers;
	      var index = subscribers.index++;
	      subscribers.entries[index] = {
	        subscriber: memoized,
	        subscription: subscription,
	        notified: false
	      };
	      var nextFormState = calculateNextFormState();
	      notifySubscriber(memoized, subscription, nextFormState, nextFormState, filterFormState, true);
	      return function () {
	        delete subscribers.entries[index];
	      };
	    }
	  };
	  return api;
	}
	
	exports.ARRAY_ERROR = ARRAY_ERROR;
	exports.FORM_ERROR = FORM_ERROR;
	exports.configOptions = configOptions;
	exports.createForm = createForm;
	exports.fieldSubscriptionItems = fieldSubscriptionItems;
	exports.formSubscriptionItems = formSubscriptionItems;
	exports.getIn = getIn;
	exports.setIn = setIn;
	exports.version = version;


/***/ },
/* 1630 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	module.exports = global;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1631 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var implementation = __webpack_require__(1630);
	
	module.exports = function getPolyfill() {
		if (typeof global !== 'object' || !global || global.Math !== Math || global.Array !== Array) {
			return implementation;
		}
		return global;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1632 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	var addEventListener = exports.addEventListener = function addEventListener(node, event, listener) {
	  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
	};
	
	var removeEventListener = exports.removeEventListener = function removeEventListener(node, event, listener) {
	  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
	};
	
	var getConfirmation = exports.getConfirmation = function getConfirmation(message, callback) {
	  return callback(window.confirm(message));
	}; // eslint-disable-line no-alert
	
	/**
	 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
	 *
	 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
	 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
	 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
	 */
	var supportsHistory = exports.supportsHistory = function supportsHistory() {
	  var ua = window.navigator.userAgent;
	
	  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
	
	  return window.history && 'pushState' in window.history;
	};
	
	/**
	 * Returns true if browser fires popstate on hash change.
	 * IE10 and IE11 do not.
	 */
	var supportsPopStateOnHashChange = exports.supportsPopStateOnHashChange = function supportsPopStateOnHashChange() {
	  return window.navigator.userAgent.indexOf('Trident') === -1;
	};
	
	/**
	 * Returns false if using go(n) with hash history causes a full page reload.
	 */
	var supportsGoWithoutReloadUsingHash = exports.supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
	  return window.navigator.userAgent.indexOf('Firefox') === -1;
	};
	
	/**
	 * Returns true if a given popstate event is an extraneous WebKit event.
	 * Accounts for the fact that Chrome on iOS fires real popstate events
	 * containing undefined state when pressing the back button.
	 */
	var isExtraneousPopstateEvent = exports.isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
	  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
	};

/***/ },
/* 1633 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.locationsAreEqual = exports.createLocation = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _resolvePathname = __webpack_require__(2008);
	
	var _resolvePathname2 = _interopRequireDefault(_resolvePathname);
	
	var _valueEqual = __webpack_require__(2180);
	
	var _valueEqual2 = _interopRequireDefault(_valueEqual);
	
	var _PathUtils = __webpack_require__(468);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createLocation = exports.createLocation = function createLocation(path, state, key, currentLocation) {
	  var location = void 0;
	  if (typeof path === 'string') {
	    // Two-arg form: push(path, state)
	    location = (0, _PathUtils.parsePath)(path);
	    location.state = state;
	  } else {
	    // One-arg form: push(location)
	    location = _extends({}, path);
	
	    if (location.pathname === undefined) location.pathname = '';
	
	    if (location.search) {
	      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
	    } else {
	      location.search = '';
	    }
	
	    if (location.hash) {
	      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
	    } else {
	      location.hash = '';
	    }
	
	    if (state !== undefined && location.state === undefined) location.state = state;
	  }
	
	  try {
	    location.pathname = decodeURI(location.pathname);
	  } catch (e) {
	    if (e instanceof URIError) {
	      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
	    } else {
	      throw e;
	    }
	  }
	
	  if (key) location.key = key;
	
	  if (currentLocation) {
	    // Resolve incomplete/relative pathname relative to current location.
	    if (!location.pathname) {
	      location.pathname = currentLocation.pathname;
	    } else if (location.pathname.charAt(0) !== '/') {
	      location.pathname = (0, _resolvePathname2.default)(location.pathname, currentLocation.pathname);
	    }
	  } else {
	    // When there is no prior location and pathname is empty, set it to /
	    if (!location.pathname) {
	      location.pathname = '/';
	    }
	  }
	
	  return location;
	};
	
	var locationsAreEqual = exports.locationsAreEqual = function locationsAreEqual(a, b) {
	  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, _valueEqual2.default)(a.state, b.state);
	};

/***/ },
/* 1634 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(59);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(37);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _LocationUtils = __webpack_require__(1633);
	
	var _PathUtils = __webpack_require__(468);
	
	var _createTransitionManager = __webpack_require__(1635);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _DOMUtils = __webpack_require__(1632);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PopStateEvent = 'popstate';
	var HashChangeEvent = 'hashchange';
	
	var getHistoryState = function getHistoryState() {
	  try {
	    return window.history.state || {};
	  } catch (e) {
	    // IE 11 sometimes throws when accessing window.history.state
	    // See https://github.com/ReactTraining/history/pull/289
	    return {};
	  }
	};
	
	/**
	 * Creates a history object that uses the HTML5 history API including
	 * pushState, replaceState, and the popstate event.
	 */
	var createBrowserHistory = function createBrowserHistory() {
	  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  (0, _invariant2.default)(_DOMUtils.canUseDOM, 'Browser history needs a DOM');
	
	  var globalHistory = window.history;
	  var canUseHistory = (0, _DOMUtils.supportsHistory)();
	  var needsHashChangeListener = !(0, _DOMUtils.supportsPopStateOnHashChange)();
	
	  var _props$forceRefresh = props.forceRefresh,
	      forceRefresh = _props$forceRefresh === undefined ? false : _props$forceRefresh,
	      _props$getUserConfirm = props.getUserConfirmation,
	      getUserConfirmation = _props$getUserConfirm === undefined ? _DOMUtils.getConfirmation : _props$getUserConfirm,
	      _props$keyLength = props.keyLength,
	      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;
	
	  var basename = props.basename ? (0, _PathUtils.stripTrailingSlash)((0, _PathUtils.addLeadingSlash)(props.basename)) : '';
	
	  var getDOMLocation = function getDOMLocation(historyState) {
	    var _ref = historyState || {},
	        key = _ref.key,
	        state = _ref.state;
	
	    var _window$location = window.location,
	        pathname = _window$location.pathname,
	        search = _window$location.search,
	        hash = _window$location.hash;
	
	
	    var path = pathname + search + hash;
	
	    (0, _warning2.default)(!basename || (0, _PathUtils.hasBasename)(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');
	
	    if (basename) path = (0, _PathUtils.stripBasename)(path, basename);
	
	    return (0, _LocationUtils.createLocation)(path, state, key);
	  };
	
	  var createKey = function createKey() {
	    return Math.random().toString(36).substr(2, keyLength);
	  };
	
	  var transitionManager = (0, _createTransitionManager2.default)();
	
	  var setState = function setState(nextState) {
	    _extends(history, nextState);
	
	    history.length = globalHistory.length;
	
	    transitionManager.notifyListeners(history.location, history.action);
	  };
	
	  var handlePopState = function handlePopState(event) {
	    // Ignore extraneous popstate events in WebKit.
	    if ((0, _DOMUtils.isExtraneousPopstateEvent)(event)) return;
	
	    handlePop(getDOMLocation(event.state));
	  };
	
	  var handleHashChange = function handleHashChange() {
	    handlePop(getDOMLocation(getHistoryState()));
	  };
	
	  var forceNextPop = false;
	
	  var handlePop = function handlePop(location) {
	    if (forceNextPop) {
	      forceNextPop = false;
	      setState();
	    } else {
	      var action = 'POP';
	
	      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	        if (ok) {
	          setState({ action: action, location: location });
	        } else {
	          revertPop(location);
	        }
	      });
	    }
	  };
	
	  var revertPop = function revertPop(fromLocation) {
	    var toLocation = history.location;
	
	    // TODO: We could probably make this more reliable by
	    // keeping a list of keys we've seen in sessionStorage.
	    // Instead, we just default to 0 for keys we don't know.
	
	    var toIndex = allKeys.indexOf(toLocation.key);
	
	    if (toIndex === -1) toIndex = 0;
	
	    var fromIndex = allKeys.indexOf(fromLocation.key);
	
	    if (fromIndex === -1) fromIndex = 0;
	
	    var delta = toIndex - fromIndex;
	
	    if (delta) {
	      forceNextPop = true;
	      go(delta);
	    }
	  };
	
	  var initialLocation = getDOMLocation(getHistoryState());
	  var allKeys = [initialLocation.key];
	
	  // Public interface
	
	  var createHref = function createHref(location) {
	    return basename + (0, _PathUtils.createPath)(location);
	  };
	
	  var push = function push(path, state) {
	    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');
	
	    var action = 'PUSH';
	    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (!ok) return;
	
	      var href = createHref(location);
	      var key = location.key,
	          state = location.state;
	
	
	      if (canUseHistory) {
	        globalHistory.pushState({ key: key, state: state }, null, href);
	
	        if (forceRefresh) {
	          window.location.href = href;
	        } else {
	          var prevIndex = allKeys.indexOf(history.location.key);
	          var nextKeys = allKeys.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);
	
	          nextKeys.push(location.key);
	          allKeys = nextKeys;
	
	          setState({ action: action, location: location });
	        }
	      } else {
	        (0, _warning2.default)(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history');
	
	        window.location.href = href;
	      }
	    });
	  };
	
	  var replace = function replace(path, state) {
	    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');
	
	    var action = 'REPLACE';
	    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (!ok) return;
	
	      var href = createHref(location);
	      var key = location.key,
	          state = location.state;
	
	
	      if (canUseHistory) {
	        globalHistory.replaceState({ key: key, state: state }, null, href);
	
	        if (forceRefresh) {
	          window.location.replace(href);
	        } else {
	          var prevIndex = allKeys.indexOf(history.location.key);
	
	          if (prevIndex !== -1) allKeys[prevIndex] = location.key;
	
	          setState({ action: action, location: location });
	        }
	      } else {
	        (0, _warning2.default)(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history');
	
	        window.location.replace(href);
	      }
	    });
	  };
	
	  var go = function go(n) {
	    globalHistory.go(n);
	  };
	
	  var goBack = function goBack() {
	    return go(-1);
	  };
	
	  var goForward = function goForward() {
	    return go(1);
	  };
	
	  var listenerCount = 0;
	
	  var checkDOMListeners = function checkDOMListeners(delta) {
	    listenerCount += delta;
	
	    if (listenerCount === 1) {
	      (0, _DOMUtils.addEventListener)(window, PopStateEvent, handlePopState);
	
	      if (needsHashChangeListener) (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
	    } else if (listenerCount === 0) {
	      (0, _DOMUtils.removeEventListener)(window, PopStateEvent, handlePopState);
	
	      if (needsHashChangeListener) (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
	    }
	  };
	
	  var isBlocked = false;
	
	  var block = function block() {
	    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	    var unblock = transitionManager.setPrompt(prompt);
	
	    if (!isBlocked) {
	      checkDOMListeners(1);
	      isBlocked = true;
	    }
	
	    return function () {
	      if (isBlocked) {
	        isBlocked = false;
	        checkDOMListeners(-1);
	      }
	
	      return unblock();
	    };
	  };
	
	  var listen = function listen(listener) {
	    var unlisten = transitionManager.appendListener(listener);
	    checkDOMListeners(1);
	
	    return function () {
	      checkDOMListeners(-1);
	      unlisten();
	    };
	  };
	
	  var history = {
	    length: globalHistory.length,
	    action: 'POP',
	    location: initialLocation,
	    createHref: createHref,
	    push: push,
	    replace: replace,
	    go: go,
	    goBack: goBack,
	    goForward: goForward,
	    block: block,
	    listen: listen
	  };
	
	  return history;
	};
	
	exports.default = createBrowserHistory;

/***/ },
/* 1635 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _warning = __webpack_require__(59);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createTransitionManager = function createTransitionManager() {
	  var prompt = null;
	
	  var setPrompt = function setPrompt(nextPrompt) {
	    (0, _warning2.default)(prompt == null, 'A history supports only one prompt at a time');
	
	    prompt = nextPrompt;
	
	    return function () {
	      if (prompt === nextPrompt) prompt = null;
	    };
	  };
	
	  var confirmTransitionTo = function confirmTransitionTo(location, action, getUserConfirmation, callback) {
	    // TODO: If another transition starts while we're still confirming
	    // the previous one, we may end up in a weird state. Figure out the
	    // best way to handle this.
	    if (prompt != null) {
	      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;
	
	      if (typeof result === 'string') {
	        if (typeof getUserConfirmation === 'function') {
	          getUserConfirmation(result, callback);
	        } else {
	          (0, _warning2.default)(false, 'A history needs a getUserConfirmation function in order to use a prompt message');
	
	          callback(true);
	        }
	      } else {
	        // Return false from a transition hook to cancel the transition.
	        callback(result !== false);
	      }
	    } else {
	      callback(true);
	    }
	  };
	
	  var listeners = [];
	
	  var appendListener = function appendListener(fn) {
	    var isActive = true;
	
	    var listener = function listener() {
	      if (isActive) fn.apply(undefined, arguments);
	    };
	
	    listeners.push(listener);
	
	    return function () {
	      isActive = false;
	      listeners = listeners.filter(function (item) {
	        return item !== listener;
	      });
	    };
	  };
	
	  var notifyListeners = function notifyListeners() {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    listeners.forEach(function (listener) {
	      return listener.apply(undefined, args);
	    });
	  };
	
	  return {
	    setPrompt: setPrompt,
	    confirmTransitionTo: confirmTransitionTo,
	    appendListener: appendListener,
	    notifyListeners: notifyListeners
	  };
	};
	
	exports.default = createTransitionManager;

/***/ },
/* 1636 */
/***/ function(module, exports) {

	"use strict";
	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	Object.defineProperty(exports, "__esModule", { value: true });
	var RelativeTimeFormat;
	// -- Utilities ----------------------------------------------------------------
	function getCacheId(inputs) {
	    return JSON.stringify(inputs.map(function (input) {
	        return input && typeof input === 'object' ? orderedProps(input) : input;
	    }));
	}
	function orderedProps(obj) {
	    return Object.keys(obj)
	        .sort()
	        .map(function (k) {
	        var _a;
	        return (_a = {}, _a[k] = obj[k], _a);
	    });
	}
	var memoizeFormatConstructor = function (FormatConstructor, cache) {
	    if (cache === void 0) { cache = {}; }
	    return function () {
	        var _a;
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        var cacheId = getCacheId(args);
	        var format = cacheId && cache[cacheId];
	        if (!format) {
	            format = new ((_a = FormatConstructor).bind.apply(_a, [void 0].concat(args)))();
	            if (cacheId) {
	                cache[cacheId] = format;
	            }
	        }
	        return format;
	    };
	};
	exports.default = memoizeFormatConstructor;
	//# sourceMappingURL=index.js.map

/***/ },
/* 1637 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports = module.exports = __webpack_require__(1636)['default'];
	exports['default'] = exports;


/***/ },
/* 1638 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports = module.exports = __webpack_require__(1639)['default'];
	exports['default'] = exports;


/***/ },
/* 1639 */
/***/ function(module, exports) {

	"use strict";
	
	exports["default"] = (function() {
	  /*
	   * Generated by PEG.js 0.8.0.
	   *
	   * http://pegjs.majda.cz/
	   */
	
	  function peg$subclass(child, parent) {
	    function ctor() { this.constructor = child; }
	    ctor.prototype = parent.prototype;
	    child.prototype = new ctor();
	  }
	
	  function SyntaxError(message, expected, found, offset, line, column) {
	    this.message  = message;
	    this.expected = expected;
	    this.found    = found;
	    this.offset   = offset;
	    this.line     = line;
	    this.column   = column;
	
	    this.name     = "SyntaxError";
	  }
	
	  peg$subclass(SyntaxError, Error);
	
	  function parse(input) {
	    var options = arguments.length > 1 ? arguments[1] : {},
	
	        peg$FAILED = {},
	
	        peg$startRuleFunctions = { start: peg$parsestart },
	        peg$startRuleFunction  = peg$parsestart,
	
	        peg$c0 = [],
	        peg$c1 = function(elements) {
	                return {
	                    type    : 'messageFormatPattern',
	                    elements: elements
	                };
	            },
	        peg$c2 = peg$FAILED,
	        peg$c3 = function(text) {
	                var string = '',
	                    i, j, outerLen, inner, innerLen;
	
	                for (i = 0, outerLen = text.length; i < outerLen; i += 1) {
	                    inner = text[i];
	
	                    for (j = 0, innerLen = inner.length; j < innerLen; j += 1) {
	                        string += inner[j];
	                    }
	                }
	
	                return string;
	            },
	        peg$c4 = function(messageText) {
	                return {
	                    type : 'messageTextElement',
	                    value: messageText
	                };
	            },
	        peg$c5 = /^[^ \t\n\r,.+={}#]/,
	        peg$c6 = { type: "class", value: "[^ \\t\\n\\r,.+={}#]", description: "[^ \\t\\n\\r,.+={}#]" },
	        peg$c7 = "{",
	        peg$c8 = { type: "literal", value: "{", description: "\"{\"" },
	        peg$c9 = null,
	        peg$c10 = ",",
	        peg$c11 = { type: "literal", value: ",", description: "\",\"" },
	        peg$c12 = "}",
	        peg$c13 = { type: "literal", value: "}", description: "\"}\"" },
	        peg$c14 = function(id, format) {
	                return {
	                    type  : 'argumentElement',
	                    id    : id,
	                    format: format && format[2]
	                };
	            },
	        peg$c15 = "number",
	        peg$c16 = { type: "literal", value: "number", description: "\"number\"" },
	        peg$c17 = "date",
	        peg$c18 = { type: "literal", value: "date", description: "\"date\"" },
	        peg$c19 = "time",
	        peg$c20 = { type: "literal", value: "time", description: "\"time\"" },
	        peg$c21 = function(type, style) {
	                return {
	                    type : type + 'Format',
	                    style: style && style[2]
	                };
	            },
	        peg$c22 = "plural",
	        peg$c23 = { type: "literal", value: "plural", description: "\"plural\"" },
	        peg$c24 = function(pluralStyle) {
	                return {
	                    type   : pluralStyle.type,
	                    ordinal: false,
	                    offset : pluralStyle.offset || 0,
	                    options: pluralStyle.options
	                };
	            },
	        peg$c25 = "selectordinal",
	        peg$c26 = { type: "literal", value: "selectordinal", description: "\"selectordinal\"" },
	        peg$c27 = function(pluralStyle) {
	                return {
	                    type   : pluralStyle.type,
	                    ordinal: true,
	                    offset : pluralStyle.offset || 0,
	                    options: pluralStyle.options
	                }
	            },
	        peg$c28 = "select",
	        peg$c29 = { type: "literal", value: "select", description: "\"select\"" },
	        peg$c30 = function(options) {
	                return {
	                    type   : 'selectFormat',
	                    options: options
	                };
	            },
	        peg$c31 = "=",
	        peg$c32 = { type: "literal", value: "=", description: "\"=\"" },
	        peg$c33 = function(selector, pattern) {
	                return {
	                    type    : 'optionalFormatPattern',
	                    selector: selector,
	                    value   : pattern
	                };
	            },
	        peg$c34 = "offset:",
	        peg$c35 = { type: "literal", value: "offset:", description: "\"offset:\"" },
	        peg$c36 = function(number) {
	                return number;
	            },
	        peg$c37 = function(offset, options) {
	                return {
	                    type   : 'pluralFormat',
	                    offset : offset,
	                    options: options
	                };
	            },
	        peg$c38 = { type: "other", description: "whitespace" },
	        peg$c39 = /^[ \t\n\r]/,
	        peg$c40 = { type: "class", value: "[ \\t\\n\\r]", description: "[ \\t\\n\\r]" },
	        peg$c41 = { type: "other", description: "optionalWhitespace" },
	        peg$c42 = /^[0-9]/,
	        peg$c43 = { type: "class", value: "[0-9]", description: "[0-9]" },
	        peg$c44 = /^[0-9a-f]/i,
	        peg$c45 = { type: "class", value: "[0-9a-f]i", description: "[0-9a-f]i" },
	        peg$c46 = "0",
	        peg$c47 = { type: "literal", value: "0", description: "\"0\"" },
	        peg$c48 = /^[1-9]/,
	        peg$c49 = { type: "class", value: "[1-9]", description: "[1-9]" },
	        peg$c50 = function(digits) {
	            return parseInt(digits, 10);
	        },
	        peg$c51 = /^[^{}\\\0-\x1F \t\n\r]/,
	        peg$c52 = { type: "class", value: "[^{}\\\\\\0-\\x1F \\t\\n\\r]", description: "[^{}\\\\\\0-\\x1F \\t\\n\\r]" },
	        peg$c53 = "\\\\",
	        peg$c54 = { type: "literal", value: "\\\\", description: "\"\\\\\\\\\"" },
	        peg$c55 = function() { return '\\'; },
	        peg$c56 = "\\#",
	        peg$c57 = { type: "literal", value: "\\#", description: "\"\\\\#\"" },
	        peg$c58 = function() { return '\\#'; },
	        peg$c59 = "\\{",
	        peg$c60 = { type: "literal", value: "\\{", description: "\"\\\\{\"" },
	        peg$c61 = function() { return '\u007B'; },
	        peg$c62 = "\\}",
	        peg$c63 = { type: "literal", value: "\\}", description: "\"\\\\}\"" },
	        peg$c64 = function() { return '\u007D'; },
	        peg$c65 = "\\u",
	        peg$c66 = { type: "literal", value: "\\u", description: "\"\\\\u\"" },
	        peg$c67 = function(digits) {
	                return String.fromCharCode(parseInt(digits, 16));
	            },
	        peg$c68 = function(chars) { return chars.join(''); },
	
	        peg$currPos          = 0,
	        peg$reportedPos      = 0,
	        peg$cachedPos        = 0,
	        peg$cachedPosDetails = { line: 1, column: 1, seenCR: false },
	        peg$maxFailPos       = 0,
	        peg$maxFailExpected  = [],
	        peg$silentFails      = 0,
	
	        peg$result;
	
	    if ("startRule" in options) {
	      if (!(options.startRule in peg$startRuleFunctions)) {
	        throw new Error("Can't start parsing from rule \"" + options.startRule + "\".");
	      }
	
	      peg$startRuleFunction = peg$startRuleFunctions[options.startRule];
	    }
	
	    function text() {
	      return input.substring(peg$reportedPos, peg$currPos);
	    }
	
	    function offset() {
	      return peg$reportedPos;
	    }
	
	    function line() {
	      return peg$computePosDetails(peg$reportedPos).line;
	    }
	
	    function column() {
	      return peg$computePosDetails(peg$reportedPos).column;
	    }
	
	    function expected(description) {
	      throw peg$buildException(
	        null,
	        [{ type: "other", description: description }],
	        peg$reportedPos
	      );
	    }
	
	    function error(message) {
	      throw peg$buildException(message, null, peg$reportedPos);
	    }
	
	    function peg$computePosDetails(pos) {
	      function advance(details, startPos, endPos) {
	        var p, ch;
	
	        for (p = startPos; p < endPos; p++) {
	          ch = input.charAt(p);
	          if (ch === "\n") {
	            if (!details.seenCR) { details.line++; }
	            details.column = 1;
	            details.seenCR = false;
	          } else if (ch === "\r" || ch === "\u2028" || ch === "\u2029") {
	            details.line++;
	            details.column = 1;
	            details.seenCR = true;
	          } else {
	            details.column++;
	            details.seenCR = false;
	          }
	        }
	      }
	
	      if (peg$cachedPos !== pos) {
	        if (peg$cachedPos > pos) {
	          peg$cachedPos = 0;
	          peg$cachedPosDetails = { line: 1, column: 1, seenCR: false };
	        }
	        advance(peg$cachedPosDetails, peg$cachedPos, pos);
	        peg$cachedPos = pos;
	      }
	
	      return peg$cachedPosDetails;
	    }
	
	    function peg$fail(expected) {
	      if (peg$currPos < peg$maxFailPos) { return; }
	
	      if (peg$currPos > peg$maxFailPos) {
	        peg$maxFailPos = peg$currPos;
	        peg$maxFailExpected = [];
	      }
	
	      peg$maxFailExpected.push(expected);
	    }
	
	    function peg$buildException(message, expected, pos) {
	      function cleanupExpected(expected) {
	        var i = 1;
	
	        expected.sort(function(a, b) {
	          if (a.description < b.description) {
	            return -1;
	          } else if (a.description > b.description) {
	            return 1;
	          } else {
	            return 0;
	          }
	        });
	
	        while (i < expected.length) {
	          if (expected[i - 1] === expected[i]) {
	            expected.splice(i, 1);
	          } else {
	            i++;
	          }
	        }
	      }
	
	      function buildMessage(expected, found) {
	        function stringEscape(s) {
	          function hex(ch) { return ch.charCodeAt(0).toString(16).toUpperCase(); }
	
	          return s
	            .replace(/\\/g,   '\\\\')
	            .replace(/"/g,    '\\"')
	            .replace(/\x08/g, '\\b')
	            .replace(/\t/g,   '\\t')
	            .replace(/\n/g,   '\\n')
	            .replace(/\f/g,   '\\f')
	            .replace(/\r/g,   '\\r')
	            .replace(/[\x00-\x07\x0B\x0E\x0F]/g, function(ch) { return '\\x0' + hex(ch); })
	            .replace(/[\x10-\x1F\x80-\xFF]/g,    function(ch) { return '\\x'  + hex(ch); })
	            .replace(/[\u0180-\u0FFF]/g,         function(ch) { return '\\u0' + hex(ch); })
	            .replace(/[\u1080-\uFFFF]/g,         function(ch) { return '\\u'  + hex(ch); });
	        }
	
	        var expectedDescs = new Array(expected.length),
	            expectedDesc, foundDesc, i;
	
	        for (i = 0; i < expected.length; i++) {
	          expectedDescs[i] = expected[i].description;
	        }
	
	        expectedDesc = expected.length > 1
	          ? expectedDescs.slice(0, -1).join(", ")
	              + " or "
	              + expectedDescs[expected.length - 1]
	          : expectedDescs[0];
	
	        foundDesc = found ? "\"" + stringEscape(found) + "\"" : "end of input";
	
	        return "Expected " + expectedDesc + " but " + foundDesc + " found.";
	      }
	
	      var posDetails = peg$computePosDetails(pos),
	          found      = pos < input.length ? input.charAt(pos) : null;
	
	      if (expected !== null) {
	        cleanupExpected(expected);
	      }
	
	      return new SyntaxError(
	        message !== null ? message : buildMessage(expected, found),
	        expected,
	        found,
	        pos,
	        posDetails.line,
	        posDetails.column
	      );
	    }
	
	    function peg$parsestart() {
	      var s0;
	
	      s0 = peg$parsemessageFormatPattern();
	
	      return s0;
	    }
	
	    function peg$parsemessageFormatPattern() {
	      var s0, s1, s2;
	
	      s0 = peg$currPos;
	      s1 = [];
	      s2 = peg$parsemessageFormatElement();
	      while (s2 !== peg$FAILED) {
	        s1.push(s2);
	        s2 = peg$parsemessageFormatElement();
	      }
	      if (s1 !== peg$FAILED) {
	        peg$reportedPos = s0;
	        s1 = peg$c1(s1);
	      }
	      s0 = s1;
	
	      return s0;
	    }
	
	    function peg$parsemessageFormatElement() {
	      var s0;
	
	      s0 = peg$parsemessageTextElement();
	      if (s0 === peg$FAILED) {
	        s0 = peg$parseargumentElement();
	      }
	
	      return s0;
	    }
	
	    function peg$parsemessageText() {
	      var s0, s1, s2, s3, s4, s5;
	
	      s0 = peg$currPos;
	      s1 = [];
	      s2 = peg$currPos;
	      s3 = peg$parse_();
	      if (s3 !== peg$FAILED) {
	        s4 = peg$parsechars();
	        if (s4 !== peg$FAILED) {
	          s5 = peg$parse_();
	          if (s5 !== peg$FAILED) {
	            s3 = [s3, s4, s5];
	            s2 = s3;
	          } else {
	            peg$currPos = s2;
	            s2 = peg$c2;
	          }
	        } else {
	          peg$currPos = s2;
	          s2 = peg$c2;
	        }
	      } else {
	        peg$currPos = s2;
	        s2 = peg$c2;
	      }
	      if (s2 !== peg$FAILED) {
	        while (s2 !== peg$FAILED) {
	          s1.push(s2);
	          s2 = peg$currPos;
	          s3 = peg$parse_();
	          if (s3 !== peg$FAILED) {
	            s4 = peg$parsechars();
	            if (s4 !== peg$FAILED) {
	              s5 = peg$parse_();
	              if (s5 !== peg$FAILED) {
	                s3 = [s3, s4, s5];
	                s2 = s3;
	              } else {
	                peg$currPos = s2;
	                s2 = peg$c2;
	              }
	            } else {
	              peg$currPos = s2;
	              s2 = peg$c2;
	            }
	          } else {
	            peg$currPos = s2;
	            s2 = peg$c2;
	          }
	        }
	      } else {
	        s1 = peg$c2;
	      }
	      if (s1 !== peg$FAILED) {
	        peg$reportedPos = s0;
	        s1 = peg$c3(s1);
	      }
	      s0 = s1;
	      if (s0 === peg$FAILED) {
	        s0 = peg$currPos;
	        s1 = peg$parsews();
	        if (s1 !== peg$FAILED) {
	          s1 = input.substring(s0, peg$currPos);
	        }
	        s0 = s1;
	      }
	
	      return s0;
	    }
	
	    function peg$parsemessageTextElement() {
	      var s0, s1;
	
	      s0 = peg$currPos;
	      s1 = peg$parsemessageText();
	      if (s1 !== peg$FAILED) {
	        peg$reportedPos = s0;
	        s1 = peg$c4(s1);
	      }
	      s0 = s1;
	
	      return s0;
	    }
	
	    function peg$parseargument() {
	      var s0, s1, s2;
	
	      s0 = peg$parsenumber();
	      if (s0 === peg$FAILED) {
	        s0 = peg$currPos;
	        s1 = [];
	        if (peg$c5.test(input.charAt(peg$currPos))) {
	          s2 = input.charAt(peg$currPos);
	          peg$currPos++;
	        } else {
	          s2 = peg$FAILED;
	          if (peg$silentFails === 0) { peg$fail(peg$c6); }
	        }
	        if (s2 !== peg$FAILED) {
	          while (s2 !== peg$FAILED) {
	            s1.push(s2);
	            if (peg$c5.test(input.charAt(peg$currPos))) {
	              s2 = input.charAt(peg$currPos);
	              peg$currPos++;
	            } else {
	              s2 = peg$FAILED;
	              if (peg$silentFails === 0) { peg$fail(peg$c6); }
	            }
	          }
	        } else {
	          s1 = peg$c2;
	        }
	        if (s1 !== peg$FAILED) {
	          s1 = input.substring(s0, peg$currPos);
	        }
	        s0 = s1;
	      }
	
	      return s0;
	    }
	
	    function peg$parseargumentElement() {
	      var s0, s1, s2, s3, s4, s5, s6, s7, s8;
	
	      s0 = peg$currPos;
	      if (input.charCodeAt(peg$currPos) === 123) {
	        s1 = peg$c7;
	        peg$currPos++;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c8); }
	      }
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parse_();
	        if (s2 !== peg$FAILED) {
	          s3 = peg$parseargument();
	          if (s3 !== peg$FAILED) {
	            s4 = peg$parse_();
	            if (s4 !== peg$FAILED) {
	              s5 = peg$currPos;
	              if (input.charCodeAt(peg$currPos) === 44) {
	                s6 = peg$c10;
	                peg$currPos++;
	              } else {
	                s6 = peg$FAILED;
	                if (peg$silentFails === 0) { peg$fail(peg$c11); }
	              }
	              if (s6 !== peg$FAILED) {
	                s7 = peg$parse_();
	                if (s7 !== peg$FAILED) {
	                  s8 = peg$parseelementFormat();
	                  if (s8 !== peg$FAILED) {
	                    s6 = [s6, s7, s8];
	                    s5 = s6;
	                  } else {
	                    peg$currPos = s5;
	                    s5 = peg$c2;
	                  }
	                } else {
	                  peg$currPos = s5;
	                  s5 = peg$c2;
	                }
	              } else {
	                peg$currPos = s5;
	                s5 = peg$c2;
	              }
	              if (s5 === peg$FAILED) {
	                s5 = peg$c9;
	              }
	              if (s5 !== peg$FAILED) {
	                s6 = peg$parse_();
	                if (s6 !== peg$FAILED) {
	                  if (input.charCodeAt(peg$currPos) === 125) {
	                    s7 = peg$c12;
	                    peg$currPos++;
	                  } else {
	                    s7 = peg$FAILED;
	                    if (peg$silentFails === 0) { peg$fail(peg$c13); }
	                  }
	                  if (s7 !== peg$FAILED) {
	                    peg$reportedPos = s0;
	                    s1 = peg$c14(s3, s5);
	                    s0 = s1;
	                  } else {
	                    peg$currPos = s0;
	                    s0 = peg$c2;
	                  }
	                } else {
	                  peg$currPos = s0;
	                  s0 = peg$c2;
	                }
	              } else {
	                peg$currPos = s0;
	                s0 = peg$c2;
	              }
	            } else {
	              peg$currPos = s0;
	              s0 = peg$c2;
	            }
	          } else {
	            peg$currPos = s0;
	            s0 = peg$c2;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$c2;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$c2;
	      }
	
	      return s0;
	    }
	
	    function peg$parseelementFormat() {
	      var s0;
	
	      s0 = peg$parsesimpleFormat();
	      if (s0 === peg$FAILED) {
	        s0 = peg$parsepluralFormat();
	        if (s0 === peg$FAILED) {
	          s0 = peg$parseselectOrdinalFormat();
	          if (s0 === peg$FAILED) {
	            s0 = peg$parseselectFormat();
	          }
	        }
	      }
	
	      return s0;
	    }
	
	    function peg$parsesimpleFormat() {
	      var s0, s1, s2, s3, s4, s5, s6;
	
	      s0 = peg$currPos;
	      if (input.substr(peg$currPos, 6) === peg$c15) {
	        s1 = peg$c15;
	        peg$currPos += 6;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c16); }
	      }
	      if (s1 === peg$FAILED) {
	        if (input.substr(peg$currPos, 4) === peg$c17) {
	          s1 = peg$c17;
	          peg$currPos += 4;
	        } else {
	          s1 = peg$FAILED;
	          if (peg$silentFails === 0) { peg$fail(peg$c18); }
	        }
	        if (s1 === peg$FAILED) {
	          if (input.substr(peg$currPos, 4) === peg$c19) {
	            s1 = peg$c19;
	            peg$currPos += 4;
	          } else {
	            s1 = peg$FAILED;
	            if (peg$silentFails === 0) { peg$fail(peg$c20); }
	          }
	        }
	      }
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parse_();
	        if (s2 !== peg$FAILED) {
	          s3 = peg$currPos;
	          if (input.charCodeAt(peg$currPos) === 44) {
	            s4 = peg$c10;
	            peg$currPos++;
	          } else {
	            s4 = peg$FAILED;
	            if (peg$silentFails === 0) { peg$fail(peg$c11); }
	          }
	          if (s4 !== peg$FAILED) {
	            s5 = peg$parse_();
	            if (s5 !== peg$FAILED) {
	              s6 = peg$parsechars();
	              if (s6 !== peg$FAILED) {
	                s4 = [s4, s5, s6];
	                s3 = s4;
	              } else {
	                peg$currPos = s3;
	                s3 = peg$c2;
	              }
	            } else {
	              peg$currPos = s3;
	              s3 = peg$c2;
	            }
	          } else {
	            peg$currPos = s3;
	            s3 = peg$c2;
	          }
	          if (s3 === peg$FAILED) {
	            s3 = peg$c9;
	          }
	          if (s3 !== peg$FAILED) {
	            peg$reportedPos = s0;
	            s1 = peg$c21(s1, s3);
	            s0 = s1;
	          } else {
	            peg$currPos = s0;
	            s0 = peg$c2;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$c2;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$c2;
	      }
	
	      return s0;
	    }
	
	    function peg$parsepluralFormat() {
	      var s0, s1, s2, s3, s4, s5;
	
	      s0 = peg$currPos;
	      if (input.substr(peg$currPos, 6) === peg$c22) {
	        s1 = peg$c22;
	        peg$currPos += 6;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c23); }
	      }
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parse_();
	        if (s2 !== peg$FAILED) {
	          if (input.charCodeAt(peg$currPos) === 44) {
	            s3 = peg$c10;
	            peg$currPos++;
	          } else {
	            s3 = peg$FAILED;
	            if (peg$silentFails === 0) { peg$fail(peg$c11); }
	          }
	          if (s3 !== peg$FAILED) {
	            s4 = peg$parse_();
	            if (s4 !== peg$FAILED) {
	              s5 = peg$parsepluralStyle();
	              if (s5 !== peg$FAILED) {
	                peg$reportedPos = s0;
	                s1 = peg$c24(s5);
	                s0 = s1;
	              } else {
	                peg$currPos = s0;
	                s0 = peg$c2;
	              }
	            } else {
	              peg$currPos = s0;
	              s0 = peg$c2;
	            }
	          } else {
	            peg$currPos = s0;
	            s0 = peg$c2;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$c2;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$c2;
	      }
	
	      return s0;
	    }
	
	    function peg$parseselectOrdinalFormat() {
	      var s0, s1, s2, s3, s4, s5;
	
	      s0 = peg$currPos;
	      if (input.substr(peg$currPos, 13) === peg$c25) {
	        s1 = peg$c25;
	        peg$currPos += 13;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c26); }
	      }
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parse_();
	        if (s2 !== peg$FAILED) {
	          if (input.charCodeAt(peg$currPos) === 44) {
	            s3 = peg$c10;
	            peg$currPos++;
	          } else {
	            s3 = peg$FAILED;
	            if (peg$silentFails === 0) { peg$fail(peg$c11); }
	          }
	          if (s3 !== peg$FAILED) {
	            s4 = peg$parse_();
	            if (s4 !== peg$FAILED) {
	              s5 = peg$parsepluralStyle();
	              if (s5 !== peg$FAILED) {
	                peg$reportedPos = s0;
	                s1 = peg$c27(s5);
	                s0 = s1;
	              } else {
	                peg$currPos = s0;
	                s0 = peg$c2;
	              }
	            } else {
	              peg$currPos = s0;
	              s0 = peg$c2;
	            }
	          } else {
	            peg$currPos = s0;
	            s0 = peg$c2;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$c2;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$c2;
	      }
	
	      return s0;
	    }
	
	    function peg$parseselectFormat() {
	      var s0, s1, s2, s3, s4, s5, s6;
	
	      s0 = peg$currPos;
	      if (input.substr(peg$currPos, 6) === peg$c28) {
	        s1 = peg$c28;
	        peg$currPos += 6;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c29); }
	      }
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parse_();
	        if (s2 !== peg$FAILED) {
	          if (input.charCodeAt(peg$currPos) === 44) {
	            s3 = peg$c10;
	            peg$currPos++;
	          } else {
	            s3 = peg$FAILED;
	            if (peg$silentFails === 0) { peg$fail(peg$c11); }
	          }
	          if (s3 !== peg$FAILED) {
	            s4 = peg$parse_();
	            if (s4 !== peg$FAILED) {
	              s5 = [];
	              s6 = peg$parseoptionalFormatPattern();
	              if (s6 !== peg$FAILED) {
	                while (s6 !== peg$FAILED) {
	                  s5.push(s6);
	                  s6 = peg$parseoptionalFormatPattern();
	                }
	              } else {
	                s5 = peg$c2;
	              }
	              if (s5 !== peg$FAILED) {
	                peg$reportedPos = s0;
	                s1 = peg$c30(s5);
	                s0 = s1;
	              } else {
	                peg$currPos = s0;
	                s0 = peg$c2;
	              }
	            } else {
	              peg$currPos = s0;
	              s0 = peg$c2;
	            }
	          } else {
	            peg$currPos = s0;
	            s0 = peg$c2;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$c2;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$c2;
	      }
	
	      return s0;
	    }
	
	    function peg$parseselector() {
	      var s0, s1, s2, s3;
	
	      s0 = peg$currPos;
	      s1 = peg$currPos;
	      if (input.charCodeAt(peg$currPos) === 61) {
	        s2 = peg$c31;
	        peg$currPos++;
	      } else {
	        s2 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c32); }
	      }
	      if (s2 !== peg$FAILED) {
	        s3 = peg$parsenumber();
	        if (s3 !== peg$FAILED) {
	          s2 = [s2, s3];
	          s1 = s2;
	        } else {
	          peg$currPos = s1;
	          s1 = peg$c2;
	        }
	      } else {
	        peg$currPos = s1;
	        s1 = peg$c2;
	      }
	      if (s1 !== peg$FAILED) {
	        s1 = input.substring(s0, peg$currPos);
	      }
	      s0 = s1;
	      if (s0 === peg$FAILED) {
	        s0 = peg$parsechars();
	      }
	
	      return s0;
	    }
	
	    function peg$parseoptionalFormatPattern() {
	      var s0, s1, s2, s3, s4, s5, s6, s7, s8;
	
	      s0 = peg$currPos;
	      s1 = peg$parse_();
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parseselector();
	        if (s2 !== peg$FAILED) {
	          s3 = peg$parse_();
	          if (s3 !== peg$FAILED) {
	            if (input.charCodeAt(peg$currPos) === 123) {
	              s4 = peg$c7;
	              peg$currPos++;
	            } else {
	              s4 = peg$FAILED;
	              if (peg$silentFails === 0) { peg$fail(peg$c8); }
	            }
	            if (s4 !== peg$FAILED) {
	              s5 = peg$parse_();
	              if (s5 !== peg$FAILED) {
	                s6 = peg$parsemessageFormatPattern();
	                if (s6 !== peg$FAILED) {
	                  s7 = peg$parse_();
	                  if (s7 !== peg$FAILED) {
	                    if (input.charCodeAt(peg$currPos) === 125) {
	                      s8 = peg$c12;
	                      peg$currPos++;
	                    } else {
	                      s8 = peg$FAILED;
	                      if (peg$silentFails === 0) { peg$fail(peg$c13); }
	                    }
	                    if (s8 !== peg$FAILED) {
	                      peg$reportedPos = s0;
	                      s1 = peg$c33(s2, s6);
	                      s0 = s1;
	                    } else {
	                      peg$currPos = s0;
	                      s0 = peg$c2;
	                    }
	                  } else {
	                    peg$currPos = s0;
	                    s0 = peg$c2;
	                  }
	                } else {
	                  peg$currPos = s0;
	                  s0 = peg$c2;
	                }
	              } else {
	                peg$currPos = s0;
	                s0 = peg$c2;
	              }
	            } else {
	              peg$currPos = s0;
	              s0 = peg$c2;
	            }
	          } else {
	            peg$currPos = s0;
	            s0 = peg$c2;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$c2;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$c2;
	      }
	
	      return s0;
	    }
	
	    function peg$parseoffset() {
	      var s0, s1, s2, s3;
	
	      s0 = peg$currPos;
	      if (input.substr(peg$currPos, 7) === peg$c34) {
	        s1 = peg$c34;
	        peg$currPos += 7;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c35); }
	      }
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parse_();
	        if (s2 !== peg$FAILED) {
	          s3 = peg$parsenumber();
	          if (s3 !== peg$FAILED) {
	            peg$reportedPos = s0;
	            s1 = peg$c36(s3);
	            s0 = s1;
	          } else {
	            peg$currPos = s0;
	            s0 = peg$c2;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$c2;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$c2;
	      }
	
	      return s0;
	    }
	
	    function peg$parsepluralStyle() {
	      var s0, s1, s2, s3, s4;
	
	      s0 = peg$currPos;
	      s1 = peg$parseoffset();
	      if (s1 === peg$FAILED) {
	        s1 = peg$c9;
	      }
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parse_();
	        if (s2 !== peg$FAILED) {
	          s3 = [];
	          s4 = peg$parseoptionalFormatPattern();
	          if (s4 !== peg$FAILED) {
	            while (s4 !== peg$FAILED) {
	              s3.push(s4);
	              s4 = peg$parseoptionalFormatPattern();
	            }
	          } else {
	            s3 = peg$c2;
	          }
	          if (s3 !== peg$FAILED) {
	            peg$reportedPos = s0;
	            s1 = peg$c37(s1, s3);
	            s0 = s1;
	          } else {
	            peg$currPos = s0;
	            s0 = peg$c2;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$c2;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$c2;
	      }
	
	      return s0;
	    }
	
	    function peg$parsews() {
	      var s0, s1;
	
	      peg$silentFails++;
	      s0 = [];
	      if (peg$c39.test(input.charAt(peg$currPos))) {
	        s1 = input.charAt(peg$currPos);
	        peg$currPos++;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c40); }
	      }
	      if (s1 !== peg$FAILED) {
	        while (s1 !== peg$FAILED) {
	          s0.push(s1);
	          if (peg$c39.test(input.charAt(peg$currPos))) {
	            s1 = input.charAt(peg$currPos);
	            peg$currPos++;
	          } else {
	            s1 = peg$FAILED;
	            if (peg$silentFails === 0) { peg$fail(peg$c40); }
	          }
	        }
	      } else {
	        s0 = peg$c2;
	      }
	      peg$silentFails--;
	      if (s0 === peg$FAILED) {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c38); }
	      }
	
	      return s0;
	    }
	
	    function peg$parse_() {
	      var s0, s1, s2;
	
	      peg$silentFails++;
	      s0 = peg$currPos;
	      s1 = [];
	      s2 = peg$parsews();
	      while (s2 !== peg$FAILED) {
	        s1.push(s2);
	        s2 = peg$parsews();
	      }
	      if (s1 !== peg$FAILED) {
	        s1 = input.substring(s0, peg$currPos);
	      }
	      s0 = s1;
	      peg$silentFails--;
	      if (s0 === peg$FAILED) {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c41); }
	      }
	
	      return s0;
	    }
	
	    function peg$parsedigit() {
	      var s0;
	
	      if (peg$c42.test(input.charAt(peg$currPos))) {
	        s0 = input.charAt(peg$currPos);
	        peg$currPos++;
	      } else {
	        s0 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c43); }
	      }
	
	      return s0;
	    }
	
	    function peg$parsehexDigit() {
	      var s0;
	
	      if (peg$c44.test(input.charAt(peg$currPos))) {
	        s0 = input.charAt(peg$currPos);
	        peg$currPos++;
	      } else {
	        s0 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c45); }
	      }
	
	      return s0;
	    }
	
	    function peg$parsenumber() {
	      var s0, s1, s2, s3, s4, s5;
	
	      s0 = peg$currPos;
	      if (input.charCodeAt(peg$currPos) === 48) {
	        s1 = peg$c46;
	        peg$currPos++;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c47); }
	      }
	      if (s1 === peg$FAILED) {
	        s1 = peg$currPos;
	        s2 = peg$currPos;
	        if (peg$c48.test(input.charAt(peg$currPos))) {
	          s3 = input.charAt(peg$currPos);
	          peg$currPos++;
	        } else {
	          s3 = peg$FAILED;
	          if (peg$silentFails === 0) { peg$fail(peg$c49); }
	        }
	        if (s3 !== peg$FAILED) {
	          s4 = [];
	          s5 = peg$parsedigit();
	          while (s5 !== peg$FAILED) {
	            s4.push(s5);
	            s5 = peg$parsedigit();
	          }
	          if (s4 !== peg$FAILED) {
	            s3 = [s3, s4];
	            s2 = s3;
	          } else {
	            peg$currPos = s2;
	            s2 = peg$c2;
	          }
	        } else {
	          peg$currPos = s2;
	          s2 = peg$c2;
	        }
	        if (s2 !== peg$FAILED) {
	          s2 = input.substring(s1, peg$currPos);
	        }
	        s1 = s2;
	      }
	      if (s1 !== peg$FAILED) {
	        peg$reportedPos = s0;
	        s1 = peg$c50(s1);
	      }
	      s0 = s1;
	
	      return s0;
	    }
	
	    function peg$parsechar() {
	      var s0, s1, s2, s3, s4, s5, s6, s7;
	
	      if (peg$c51.test(input.charAt(peg$currPos))) {
	        s0 = input.charAt(peg$currPos);
	        peg$currPos++;
	      } else {
	        s0 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c52); }
	      }
	      if (s0 === peg$FAILED) {
	        s0 = peg$currPos;
	        if (input.substr(peg$currPos, 2) === peg$c53) {
	          s1 = peg$c53;
	          peg$currPos += 2;
	        } else {
	          s1 = peg$FAILED;
	          if (peg$silentFails === 0) { peg$fail(peg$c54); }
	        }
	        if (s1 !== peg$FAILED) {
	          peg$reportedPos = s0;
	          s1 = peg$c55();
	        }
	        s0 = s1;
	        if (s0 === peg$FAILED) {
	          s0 = peg$currPos;
	          if (input.substr(peg$currPos, 2) === peg$c56) {
	            s1 = peg$c56;
	            peg$currPos += 2;
	          } else {
	            s1 = peg$FAILED;
	            if (peg$silentFails === 0) { peg$fail(peg$c57); }
	          }
	          if (s1 !== peg$FAILED) {
	            peg$reportedPos = s0;
	            s1 = peg$c58();
	          }
	          s0 = s1;
	          if (s0 === peg$FAILED) {
	            s0 = peg$currPos;
	            if (input.substr(peg$currPos, 2) === peg$c59) {
	              s1 = peg$c59;
	              peg$currPos += 2;
	            } else {
	              s1 = peg$FAILED;
	              if (peg$silentFails === 0) { peg$fail(peg$c60); }
	            }
	            if (s1 !== peg$FAILED) {
	              peg$reportedPos = s0;
	              s1 = peg$c61();
	            }
	            s0 = s1;
	            if (s0 === peg$FAILED) {
	              s0 = peg$currPos;
	              if (input.substr(peg$currPos, 2) === peg$c62) {
	                s1 = peg$c62;
	                peg$currPos += 2;
	              } else {
	                s1 = peg$FAILED;
	                if (peg$silentFails === 0) { peg$fail(peg$c63); }
	              }
	              if (s1 !== peg$FAILED) {
	                peg$reportedPos = s0;
	                s1 = peg$c64();
	              }
	              s0 = s1;
	              if (s0 === peg$FAILED) {
	                s0 = peg$currPos;
	                if (input.substr(peg$currPos, 2) === peg$c65) {
	                  s1 = peg$c65;
	                  peg$currPos += 2;
	                } else {
	                  s1 = peg$FAILED;
	                  if (peg$silentFails === 0) { peg$fail(peg$c66); }
	                }
	                if (s1 !== peg$FAILED) {
	                  s2 = peg$currPos;
	                  s3 = peg$currPos;
	                  s4 = peg$parsehexDigit();
	                  if (s4 !== peg$FAILED) {
	                    s5 = peg$parsehexDigit();
	                    if (s5 !== peg$FAILED) {
	                      s6 = peg$parsehexDigit();
	                      if (s6 !== peg$FAILED) {
	                        s7 = peg$parsehexDigit();
	                        if (s7 !== peg$FAILED) {
	                          s4 = [s4, s5, s6, s7];
	                          s3 = s4;
	                        } else {
	                          peg$currPos = s3;
	                          s3 = peg$c2;
	                        }
	                      } else {
	                        peg$currPos = s3;
	                        s3 = peg$c2;
	                      }
	                    } else {
	                      peg$currPos = s3;
	                      s3 = peg$c2;
	                    }
	                  } else {
	                    peg$currPos = s3;
	                    s3 = peg$c2;
	                  }
	                  if (s3 !== peg$FAILED) {
	                    s3 = input.substring(s2, peg$currPos);
	                  }
	                  s2 = s3;
	                  if (s2 !== peg$FAILED) {
	                    peg$reportedPos = s0;
	                    s1 = peg$c67(s2);
	                    s0 = s1;
	                  } else {
	                    peg$currPos = s0;
	                    s0 = peg$c2;
	                  }
	                } else {
	                  peg$currPos = s0;
	                  s0 = peg$c2;
	                }
	              }
	            }
	          }
	        }
	      }
	
	      return s0;
	    }
	
	    function peg$parsechars() {
	      var s0, s1, s2;
	
	      s0 = peg$currPos;
	      s1 = [];
	      s2 = peg$parsechar();
	      if (s2 !== peg$FAILED) {
	        while (s2 !== peg$FAILED) {
	          s1.push(s2);
	          s2 = peg$parsechar();
	        }
	      } else {
	        s1 = peg$c2;
	      }
	      if (s1 !== peg$FAILED) {
	        peg$reportedPos = s0;
	        s1 = peg$c68(s1);
	      }
	      s0 = s1;
	
	      return s0;
	    }
	
	    peg$result = peg$startRuleFunction();
	
	    if (peg$result !== peg$FAILED && peg$currPos === input.length) {
	      return peg$result;
	    } else {
	      if (peg$result !== peg$FAILED && peg$currPos < input.length) {
	        peg$fail({ type: "end", description: "end of input" });
	      }
	
	      throw peg$buildException(null, peg$maxFailExpected, peg$maxFailPos);
	    }
	  }
	
	  return {
	    SyntaxError: SyntaxError,
	    parse:       parse
	  };
	})();
	
	//# sourceMappingURL=parser.js.map

/***/ },
/* 1640 */
/***/ function(module, exports) {

	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	
	/* jslint esnext: true */
	
	"use strict";
	exports["default"] = Compiler;
	
	function Compiler(locales, formats, pluralFn) {
	    this.locales  = locales;
	    this.formats  = formats;
	    this.pluralFn = pluralFn;
	}
	
	Compiler.prototype.compile = function (ast) {
	    this.pluralStack        = [];
	    this.currentPlural      = null;
	    this.pluralNumberFormat = null;
	
	    return this.compileMessage(ast);
	};
	
	Compiler.prototype.compileMessage = function (ast) {
	    if (!(ast && ast.type === 'messageFormatPattern')) {
	        throw new Error('Message AST is not of type: "messageFormatPattern"');
	    }
	
	    var elements = ast.elements,
	        pattern  = [];
	
	    var i, len, element;
	
	    for (i = 0, len = elements.length; i < len; i += 1) {
	        element = elements[i];
	
	        switch (element.type) {
	            case 'messageTextElement':
	                pattern.push(this.compileMessageText(element));
	                break;
	
	            case 'argumentElement':
	                pattern.push(this.compileArgument(element));
	                break;
	
	            default:
	                throw new Error('Message element does not have a valid type');
	        }
	    }
	
	    return pattern;
	};
	
	Compiler.prototype.compileMessageText = function (element) {
	    // When this `element` is part of plural sub-pattern and its value contains
	    // an unescaped '#', use a `PluralOffsetString` helper to properly output
	    // the number with the correct offset in the string.
	    if (this.currentPlural && /(^|[^\\])#/g.test(element.value)) {
	        // Create a cache a NumberFormat instance that can be reused for any
	        // PluralOffsetString instance in this message.
	        if (!this.pluralNumberFormat) {
	            this.pluralNumberFormat = new Intl.NumberFormat(this.locales);
	        }
	
	        return new PluralOffsetString(
	                this.currentPlural.id,
	                this.currentPlural.format.offset,
	                this.pluralNumberFormat,
	                element.value);
	    }
	
	    // Unescape the escaped '#'s in the message text.
	    return element.value.replace(/\\#/g, '#');
	};
	
	Compiler.prototype.compileArgument = function (element) {
	    var format = element.format;
	
	    if (!format) {
	        return new StringFormat(element.id);
	    }
	
	    var formats  = this.formats,
	        locales  = this.locales,
	        pluralFn = this.pluralFn,
	        options;
	
	    switch (format.type) {
	        case 'numberFormat':
	            options = formats.number[format.style];
	            return {
	                id    : element.id,
	                format: new Intl.NumberFormat(locales, options).format
	            };
	
	        case 'dateFormat':
	            options = formats.date[format.style];
	            return {
	                id    : element.id,
	                format: new Intl.DateTimeFormat(locales, options).format
	            };
	
	        case 'timeFormat':
	            options = formats.time[format.style];
	            return {
	                id    : element.id,
	                format: new Intl.DateTimeFormat(locales, options).format
	            };
	
	        case 'pluralFormat':
	            options = this.compileOptions(element);
	            return new PluralFormat(
	                element.id, format.ordinal, format.offset, options, pluralFn
	            );
	
	        case 'selectFormat':
	            options = this.compileOptions(element);
	            return new SelectFormat(element.id, options);
	
	        default:
	            throw new Error('Message element does not have a valid format type');
	    }
	};
	
	Compiler.prototype.compileOptions = function (element) {
	    var format      = element.format,
	        options     = format.options,
	        optionsHash = {};
	
	    // Save the current plural element, if any, then set it to a new value when
	    // compiling the options sub-patterns. This conforms the spec's algorithm
	    // for handling `"#"` syntax in message text.
	    this.pluralStack.push(this.currentPlural);
	    this.currentPlural = format.type === 'pluralFormat' ? element : null;
	
	    var i, len, option;
	
	    for (i = 0, len = options.length; i < len; i += 1) {
	        option = options[i];
	
	        // Compile the sub-pattern and save it under the options's selector.
	        optionsHash[option.selector] = this.compileMessage(option.value);
	    }
	
	    // Pop the plural stack to put back the original current plural value.
	    this.currentPlural = this.pluralStack.pop();
	
	    return optionsHash;
	};
	
	// -- Compiler Helper Classes --------------------------------------------------
	
	function StringFormat(id) {
	    this.id = id;
	}
	
	StringFormat.prototype.format = function (value) {
	    if (!value) {
	        return '';
	    }
	
	    return typeof value === 'string' ? value : String(value);
	};
	
	function PluralFormat(id, useOrdinal, offset, options, pluralFn) {
	    this.id         = id;
	    this.useOrdinal = useOrdinal;
	    this.offset     = offset;
	    this.options    = options;
	    this.pluralFn   = pluralFn;
	}
	
	PluralFormat.prototype.getOption = function (value) {
	    var options = this.options;
	
	    var option = options['=' + value] ||
	            options[this.pluralFn(value - this.offset, this.useOrdinal)];
	
	    return option || options.other;
	};
	
	function PluralOffsetString(id, offset, numberFormat, string) {
	    this.id           = id;
	    this.offset       = offset;
	    this.numberFormat = numberFormat;
	    this.string       = string;
	}
	
	PluralOffsetString.prototype.format = function (value) {
	    var number = this.numberFormat.format(value - this.offset);
	
	    return this.string
	            .replace(/(^|[^\\])#/g, '$1' + number)
	            .replace(/\\#/g, '#');
	};
	
	function SelectFormat(id, options) {
	    this.id      = id;
	    this.options = options;
	}
	
	SelectFormat.prototype.getOption = function (value) {
	    var options = this.options;
	    return options[value] || options.other;
	};
	
	//# sourceMappingURL=compiler.js.map

/***/ },
/* 1641 */
/***/ function(module, exports, __webpack_require__) {

	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	
	/* jslint esnext: true */
	
	"use strict";
	var src$utils$$ = __webpack_require__(472), src$es5$$ = __webpack_require__(1643), src$compiler$$ = __webpack_require__(1640), intl$messageformat$parser$$ = __webpack_require__(1638);
	exports["default"] = MessageFormat;
	
	// -- MessageFormat --------------------------------------------------------
	
	function MessageFormat(message, locales, formats) {
	    // Parse string messages into an AST.
	    var ast = typeof message === 'string' ?
	            MessageFormat.__parse(message) : message;
	
	    if (!(ast && ast.type === 'messageFormatPattern')) {
	        throw new TypeError('A message must be provided as a String or AST.');
	    }
	
	    // Creates a new object with the specified `formats` merged with the default
	    // formats.
	    formats = this._mergeFormats(MessageFormat.formats, formats);
	
	    // Defined first because it's used to build the format pattern.
	    src$es5$$.defineProperty(this, '_locale',  {value: this._resolveLocale(locales)});
	
	    // Compile the `ast` to a pattern that is highly optimized for repeated
	    // `format()` invocations. **Note:** This passes the `locales` set provided
	    // to the constructor instead of just the resolved locale.
	    var pluralFn = this._findPluralRuleFunction(this._locale);
	    var pattern  = this._compilePattern(ast, locales, formats, pluralFn);
	
	    // "Bind" `format()` method to `this` so it can be passed by reference like
	    // the other `Intl` APIs.
	    var messageFormat = this;
	    this.format = function (values) {
	        return messageFormat._format(pattern, values);
	    };
	}
	
	// Default format options used as the prototype of the `formats` provided to the
	// constructor. These are used when constructing the internal Intl.NumberFormat
	// and Intl.DateTimeFormat instances.
	src$es5$$.defineProperty(MessageFormat, 'formats', {
	    enumerable: true,
	
	    value: {
	        number: {
	            'currency': {
	                style: 'currency'
	            },
	
	            'percent': {
	                style: 'percent'
	            }
	        },
	
	        date: {
	            'short': {
	                month: 'numeric',
	                day  : 'numeric',
	                year : '2-digit'
	            },
	
	            'medium': {
	                month: 'short',
	                day  : 'numeric',
	                year : 'numeric'
	            },
	
	            'long': {
	                month: 'long',
	                day  : 'numeric',
	                year : 'numeric'
	            },
	
	            'full': {
	                weekday: 'long',
	                month  : 'long',
	                day    : 'numeric',
	                year   : 'numeric'
	            }
	        },
	
	        time: {
	            'short': {
	                hour  : 'numeric',
	                minute: 'numeric'
	            },
	
	            'medium':  {
	                hour  : 'numeric',
	                minute: 'numeric',
	                second: 'numeric'
	            },
	
	            'long': {
	                hour        : 'numeric',
	                minute      : 'numeric',
	                second      : 'numeric',
	                timeZoneName: 'short'
	            },
	
	            'full': {
	                hour        : 'numeric',
	                minute      : 'numeric',
	                second      : 'numeric',
	                timeZoneName: 'short'
	            }
	        }
	    }
	});
	
	// Define internal private properties for dealing with locale data.
	src$es5$$.defineProperty(MessageFormat, '__localeData__', {value: src$es5$$.objCreate(null)});
	src$es5$$.defineProperty(MessageFormat, '__addLocaleData', {value: function (data) {
	    if (!(data && data.locale)) {
	        throw new Error(
	            'Locale data provided to IntlMessageFormat is missing a ' +
	            '`locale` property'
	        );
	    }
	
	    MessageFormat.__localeData__[data.locale.toLowerCase()] = data;
	}});
	
	// Defines `__parse()` static method as an exposed private.
	src$es5$$.defineProperty(MessageFormat, '__parse', {value: intl$messageformat$parser$$["default"].parse});
	
	// Define public `defaultLocale` property which defaults to English, but can be
	// set by the developer.
	src$es5$$.defineProperty(MessageFormat, 'defaultLocale', {
	    enumerable: true,
	    writable  : true,
	    value     : undefined
	});
	
	MessageFormat.prototype.resolvedOptions = function () {
	    // TODO: Provide anything else?
	    return {
	        locale: this._locale
	    };
	};
	
	MessageFormat.prototype._compilePattern = function (ast, locales, formats, pluralFn) {
	    var compiler = new src$compiler$$["default"](locales, formats, pluralFn);
	    return compiler.compile(ast);
	};
	
	MessageFormat.prototype._findPluralRuleFunction = function (locale) {
	    var localeData = MessageFormat.__localeData__;
	    var data       = localeData[locale.toLowerCase()];
	
	    // The locale data is de-duplicated, so we have to traverse the locale's
	    // hierarchy until we find a `pluralRuleFunction` to return.
	    while (data) {
	        if (data.pluralRuleFunction) {
	            return data.pluralRuleFunction;
	        }
	
	        data = data.parentLocale && localeData[data.parentLocale.toLowerCase()];
	    }
	
	    throw new Error(
	        'Locale data added to IntlMessageFormat is missing a ' +
	        '`pluralRuleFunction` for :' + locale
	    );
	};
	
	MessageFormat.prototype._format = function (pattern, values) {
	    var result = '',
	        i, len, part, id, value;
	
	    for (i = 0, len = pattern.length; i < len; i += 1) {
	        part = pattern[i];
	
	        // Exist early for string parts.
	        if (typeof part === 'string') {
	            result += part;
	            continue;
	        }
	
	        id = part.id;
	
	        // Enforce that all required values are provided by the caller.
	        if (!(values && src$utils$$.hop.call(values, id))) {
	            throw new Error('A value must be provided for: ' + id);
	        }
	
	        value = values[id];
	
	        // Recursively format plural and select parts' option — which can be a
	        // nested pattern structure. The choosing of the option to use is
	        // abstracted-by and delegated-to the part helper object.
	        if (part.options) {
	            result += this._format(part.getOption(value), values);
	        } else {
	            result += part.format(value);
	        }
	    }
	
	    return result;
	};
	
	MessageFormat.prototype._mergeFormats = function (defaults, formats) {
	    var mergedFormats = {},
	        type, mergedType;
	
	    for (type in defaults) {
	        if (!src$utils$$.hop.call(defaults, type)) { continue; }
	
	        mergedFormats[type] = mergedType = src$es5$$.objCreate(defaults[type]);
	
	        if (formats && src$utils$$.hop.call(formats, type)) {
	            src$utils$$.extend(mergedType, formats[type]);
	        }
	    }
	
	    return mergedFormats;
	};
	
	MessageFormat.prototype._resolveLocale = function (locales) {
	    if (typeof locales === 'string') {
	        locales = [locales];
	    }
	
	    // Create a copy of the array so we can push on the default locale.
	    locales = (locales || []).concat(MessageFormat.defaultLocale);
	
	    var localeData = MessageFormat.__localeData__;
	    var i, len, localeParts, data;
	
	    // Using the set of locales + the default locale, we look for the first one
	    // which that has been registered. When data does not exist for a locale, we
	    // traverse its ancestors to find something that's been registered within
	    // its hierarchy of locales. Since we lack the proper `parentLocale` data
	    // here, we must take a naive approach to traversal.
	    for (i = 0, len = locales.length; i < len; i += 1) {
	        localeParts = locales[i].toLowerCase().split('-');
	
	        while (localeParts.length) {
	            data = localeData[localeParts.join('-')];
	            if (data) {
	                // Return the normalized locale string; e.g., we return "en-US",
	                // instead of "en-us".
	                return data.locale;
	            }
	
	            localeParts.pop();
	        }
	    }
	
	    var defaultLocale = locales.pop();
	    throw new Error(
	        'No locale data has been added to IntlMessageFormat for: ' +
	        locales.join(', ') + ', or the default locale: ' + defaultLocale
	    );
	};
	
	//# sourceMappingURL=core.js.map

/***/ },
/* 1642 */
/***/ function(module, exports) {

	// GENERATED FILE
	"use strict";
	exports["default"] = {"locale":"en","pluralRuleFunction":function (n,ord){var s=String(n).split("."),v0=!s[1],t0=Number(s[0])==n,n10=t0&&s[0].slice(-1),n100=t0&&s[0].slice(-2);if(ord)return n10==1&&n100!=11?"one":n10==2&&n100!=12?"two":n10==3&&n100!=13?"few":"other";return n==1&&v0?"one":"other"}};
	
	//# sourceMappingURL=en.js.map

/***/ },
/* 1643 */
/***/ function(module, exports, __webpack_require__) {

	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	
	/* jslint esnext: true */
	
	"use strict";
	var src$utils$$ = __webpack_require__(472);
	
	// Purposely using the same implementation as the Intl.js `Intl` polyfill.
	// Copyright 2013 Andy Earnshaw, MIT License
	
	var realDefineProp = (function () {
	    try { return !!Object.defineProperty({}, 'a', {}); }
	    catch (e) { return false; }
	})();
	
	var es3 = !realDefineProp && !Object.prototype.__defineGetter__;
	
	var defineProperty = realDefineProp ? Object.defineProperty :
	        function (obj, name, desc) {
	
	    if ('get' in desc && obj.__defineGetter__) {
	        obj.__defineGetter__(name, desc.get);
	    } else if (!src$utils$$.hop.call(obj, name) || 'value' in desc) {
	        obj[name] = desc.value;
	    }
	};
	
	var objCreate = Object.create || function (proto, props) {
	    var obj, k;
	
	    function F() {}
	    F.prototype = proto;
	    obj = new F();
	
	    for (k in props) {
	        if (src$utils$$.hop.call(props, k)) {
	            defineProperty(obj, k, props[k]);
	        }
	    }
	
	    return obj;
	};
	exports.defineProperty = defineProperty, exports.objCreate = objCreate;
	
	//# sourceMappingURL=es5.js.map

/***/ },
/* 1644 */
[2187, 1641, 1642],
/* 1645 */
/***/ function(module, exports, __webpack_require__) {

	/* jshint node:true */
	
	'use strict';
	
	var IntlRelativeFormat = __webpack_require__(1650)['default'];
	
	// Add all locale data to `IntlRelativeFormat`. This module will be ignored when
	// bundling for the browser with Browserify/Webpack.
	__webpack_require__(2184);
	
	// Re-export `IntlRelativeFormat` as the CommonJS default exports with all the
	// locale data registered, and with English set as the default locale. Define
	// the `default` prop for use with other compiled ES6 Modules.
	exports = module.exports = IntlRelativeFormat;
	exports['default'] = exports;


/***/ },
/* 1646 */
/***/ function(module, exports, __webpack_require__) {

	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	
	/* jslint esnext: true */
	
	"use strict";
	var intl$messageformat$$ = __webpack_require__(471), src$diff$$ = __webpack_require__(1647), src$es5$$ = __webpack_require__(1649);
	exports["default"] = RelativeFormat;
	
	// -----------------------------------------------------------------------------
	
	var FIELDS = ['second', 'minute', 'hour', 'day', 'month', 'year'];
	var STYLES = ['best fit', 'numeric'];
	
	// -- RelativeFormat -----------------------------------------------------------
	
	function RelativeFormat(locales, options) {
	    options = options || {};
	
	    // Make a copy of `locales` if it's an array, so that it doesn't change
	    // since it's used lazily.
	    if (src$es5$$.isArray(locales)) {
	        locales = locales.concat();
	    }
	
	    src$es5$$.defineProperty(this, '_locale', {value: this._resolveLocale(locales)});
	    src$es5$$.defineProperty(this, '_options', {value: {
	        style: this._resolveStyle(options.style),
	        units: this._isValidUnits(options.units) && options.units
	    }});
	
	    src$es5$$.defineProperty(this, '_locales', {value: locales});
	    src$es5$$.defineProperty(this, '_fields', {value: this._findFields(this._locale)});
	    src$es5$$.defineProperty(this, '_messages', {value: src$es5$$.objCreate(null)});
	
	    // "Bind" `format()` method to `this` so it can be passed by reference like
	    // the other `Intl` APIs.
	    var relativeFormat = this;
	    this.format = function format(date, options) {
	        return relativeFormat._format(date, options);
	    };
	}
	
	// Define internal private properties for dealing with locale data.
	src$es5$$.defineProperty(RelativeFormat, '__localeData__', {value: src$es5$$.objCreate(null)});
	src$es5$$.defineProperty(RelativeFormat, '__addLocaleData', {value: function (data) {
	    if (!(data && data.locale)) {
	        throw new Error(
	            'Locale data provided to IntlRelativeFormat is missing a ' +
	            '`locale` property value'
	        );
	    }
	
	    RelativeFormat.__localeData__[data.locale.toLowerCase()] = data;
	
	    // Add data to IntlMessageFormat.
	    intl$messageformat$$["default"].__addLocaleData(data);
	}});
	
	// Define public `defaultLocale` property which can be set by the developer, or
	// it will be set when the first RelativeFormat instance is created by
	// leveraging the resolved locale from `Intl`.
	src$es5$$.defineProperty(RelativeFormat, 'defaultLocale', {
	    enumerable: true,
	    writable  : true,
	    value     : undefined
	});
	
	// Define public `thresholds` property which can be set by the developer, and
	// defaults to relative time thresholds from moment.js.
	src$es5$$.defineProperty(RelativeFormat, 'thresholds', {
	    enumerable: true,
	
	    value: {
	        second: 45,  // seconds to minute
	        minute: 45,  // minutes to hour
	        hour  : 22,  // hours to day
	        day   : 26,  // days to month
	        month : 11   // months to year
	    }
	});
	
	RelativeFormat.prototype.resolvedOptions = function () {
	    return {
	        locale: this._locale,
	        style : this._options.style,
	        units : this._options.units
	    };
	};
	
	RelativeFormat.prototype._compileMessage = function (units) {
	    // `this._locales` is the original set of locales the user specified to the
	    // constructor, while `this._locale` is the resolved root locale.
	    var locales        = this._locales;
	    var resolvedLocale = this._locale;
	
	    var field        = this._fields[units];
	    var relativeTime = field.relativeTime;
	    var future       = '';
	    var past         = '';
	    var i;
	
	    for (i in relativeTime.future) {
	        if (relativeTime.future.hasOwnProperty(i)) {
	            future += ' ' + i + ' {' +
	                relativeTime.future[i].replace('{0}', '#') + '}';
	        }
	    }
	
	    for (i in relativeTime.past) {
	        if (relativeTime.past.hasOwnProperty(i)) {
	            past += ' ' + i + ' {' +
	                relativeTime.past[i].replace('{0}', '#') + '}';
	        }
	    }
	
	    var message = '{when, select, future {{0, plural, ' + future + '}}' +
	                                 'past {{0, plural, ' + past + '}}}';
	
	    // Create the synthetic IntlMessageFormat instance using the original
	    // locales value specified by the user when constructing the the parent
	    // IntlRelativeFormat instance.
	    return new intl$messageformat$$["default"](message, locales);
	};
	
	RelativeFormat.prototype._getMessage = function (units) {
	    var messages = this._messages;
	
	    // Create a new synthetic message based on the locale data from CLDR.
	    if (!messages[units]) {
	        messages[units] = this._compileMessage(units);
	    }
	
	    return messages[units];
	};
	
	RelativeFormat.prototype._getRelativeUnits = function (diff, units) {
	    var field = this._fields[units];
	
	    if (field.relative) {
	        return field.relative[diff];
	    }
	};
	
	RelativeFormat.prototype._findFields = function (locale) {
	    var localeData = RelativeFormat.__localeData__;
	    var data       = localeData[locale.toLowerCase()];
	
	    // The locale data is de-duplicated, so we have to traverse the locale's
	    // hierarchy until we find `fields` to return.
	    while (data) {
	        if (data.fields) {
	            return data.fields;
	        }
	
	        data = data.parentLocale && localeData[data.parentLocale.toLowerCase()];
	    }
	
	    throw new Error(
	        'Locale data added to IntlRelativeFormat is missing `fields` for :' +
	        locale
	    );
	};
	
	RelativeFormat.prototype._format = function (date, options) {
	    var now = options && options.now !== undefined ? options.now : src$es5$$.dateNow();
	
	    if (date === undefined) {
	        date = now;
	    }
	
	    // Determine if the `date` and optional `now` values are valid, and throw a
	    // similar error to what `Intl.DateTimeFormat#format()` would throw.
	    if (!isFinite(now)) {
	        throw new RangeError(
	            'The `now` option provided to IntlRelativeFormat#format() is not ' +
	            'in valid range.'
	        );
	    }
	
	    if (!isFinite(date)) {
	        throw new RangeError(
	            'The date value provided to IntlRelativeFormat#format() is not ' +
	            'in valid range.'
	        );
	    }
	
	    var diffReport  = src$diff$$["default"](now, date);
	    var units       = this._options.units || this._selectUnits(diffReport);
	    var diffInUnits = diffReport[units];
	
	    if (this._options.style !== 'numeric') {
	        var relativeUnits = this._getRelativeUnits(diffInUnits, units);
	        if (relativeUnits) {
	            return relativeUnits;
	        }
	    }
	
	    return this._getMessage(units).format({
	        '0' : Math.abs(diffInUnits),
	        when: diffInUnits < 0 ? 'past' : 'future'
	    });
	};
	
	RelativeFormat.prototype._isValidUnits = function (units) {
	    if (!units || src$es5$$.arrIndexOf.call(FIELDS, units) >= 0) {
	        return true;
	    }
	
	    if (typeof units === 'string') {
	        var suggestion = /s$/.test(units) && units.substr(0, units.length - 1);
	        if (suggestion && src$es5$$.arrIndexOf.call(FIELDS, suggestion) >= 0) {
	            throw new Error(
	                '"' + units + '" is not a valid IntlRelativeFormat `units` ' +
	                'value, did you mean: ' + suggestion
	            );
	        }
	    }
	
	    throw new Error(
	        '"' + units + '" is not a valid IntlRelativeFormat `units` value, it ' +
	        'must be one of: "' + FIELDS.join('", "') + '"'
	    );
	};
	
	RelativeFormat.prototype._resolveLocale = function (locales) {
	    if (typeof locales === 'string') {
	        locales = [locales];
	    }
	
	    // Create a copy of the array so we can push on the default locale.
	    locales = (locales || []).concat(RelativeFormat.defaultLocale);
	
	    var localeData = RelativeFormat.__localeData__;
	    var i, len, localeParts, data;
	
	    // Using the set of locales + the default locale, we look for the first one
	    // which that has been registered. When data does not exist for a locale, we
	    // traverse its ancestors to find something that's been registered within
	    // its hierarchy of locales. Since we lack the proper `parentLocale` data
	    // here, we must take a naive approach to traversal.
	    for (i = 0, len = locales.length; i < len; i += 1) {
	        localeParts = locales[i].toLowerCase().split('-');
	
	        while (localeParts.length) {
	            data = localeData[localeParts.join('-')];
	            if (data) {
	                // Return the normalized locale string; e.g., we return "en-US",
	                // instead of "en-us".
	                return data.locale;
	            }
	
	            localeParts.pop();
	        }
	    }
	
	    var defaultLocale = locales.pop();
	    throw new Error(
	        'No locale data has been added to IntlRelativeFormat for: ' +
	        locales.join(', ') + ', or the default locale: ' + defaultLocale
	    );
	};
	
	RelativeFormat.prototype._resolveStyle = function (style) {
	    // Default to "best fit" style.
	    if (!style) {
	        return STYLES[0];
	    }
	
	    if (src$es5$$.arrIndexOf.call(STYLES, style) >= 0) {
	        return style;
	    }
	
	    throw new Error(
	        '"' + style + '" is not a valid IntlRelativeFormat `style` value, it ' +
	        'must be one of: "' + STYLES.join('", "') + '"'
	    );
	};
	
	RelativeFormat.prototype._selectUnits = function (diffReport) {
	    var i, l, units;
	
	    for (i = 0, l = FIELDS.length; i < l; i += 1) {
	        units = FIELDS[i];
	
	        if (Math.abs(diffReport[units]) < RelativeFormat.thresholds[units]) {
	            break;
	        }
	    }
	
	    return units;
	};
	
	//# sourceMappingURL=core.js.map

/***/ },
/* 1647 */
/***/ function(module, exports) {

	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	
	/* jslint esnext: true */
	
	"use strict";
	
	var round = Math.round;
	
	function daysToYears(days) {
	    // 400 years have 146097 days (taking into account leap year rules)
	    return days * 400 / 146097;
	}
	
	exports["default"] = function (from, to) {
	    // Convert to ms timestamps.
	    from = +from;
	    to   = +to;
	
	    var millisecond = round(to - from),
	        second      = round(millisecond / 1000),
	        minute      = round(second / 60),
	        hour        = round(minute / 60),
	        day         = round(hour / 24),
	        week        = round(day / 7);
	
	    var rawYears = daysToYears(day),
	        month    = round(rawYears * 12),
	        year     = round(rawYears);
	
	    return {
	        millisecond: millisecond,
	        second     : second,
	        minute     : minute,
	        hour       : hour,
	        day        : day,
	        week       : week,
	        month      : month,
	        year       : year
	    };
	};
	
	//# sourceMappingURL=diff.js.map

/***/ },
/* 1648 */
/***/ function(module, exports) {

	// GENERATED FILE
	"use strict";
	exports["default"] = {"locale":"en","pluralRuleFunction":function (n,ord){var s=String(n).split("."),v0=!s[1],t0=Number(s[0])==n,n10=t0&&s[0].slice(-1),n100=t0&&s[0].slice(-2);if(ord)return n10==1&&n100!=11?"one":n10==2&&n100!=12?"two":n10==3&&n100!=13?"few":"other";return n==1&&v0?"one":"other"},"fields":{"year":{"displayName":"year","relative":{"0":"this year","1":"next year","-1":"last year"},"relativeTime":{"future":{"one":"in {0} year","other":"in {0} years"},"past":{"one":"{0} year ago","other":"{0} years ago"}}},"month":{"displayName":"month","relative":{"0":"this month","1":"next month","-1":"last month"},"relativeTime":{"future":{"one":"in {0} month","other":"in {0} months"},"past":{"one":"{0} month ago","other":"{0} months ago"}}},"day":{"displayName":"day","relative":{"0":"today","1":"tomorrow","-1":"yesterday"},"relativeTime":{"future":{"one":"in {0} day","other":"in {0} days"},"past":{"one":"{0} day ago","other":"{0} days ago"}}},"hour":{"displayName":"hour","relativeTime":{"future":{"one":"in {0} hour","other":"in {0} hours"},"past":{"one":"{0} hour ago","other":"{0} hours ago"}}},"minute":{"displayName":"minute","relativeTime":{"future":{"one":"in {0} minute","other":"in {0} minutes"},"past":{"one":"{0} minute ago","other":"{0} minutes ago"}}},"second":{"displayName":"second","relative":{"0":"now"},"relativeTime":{"future":{"one":"in {0} second","other":"in {0} seconds"},"past":{"one":"{0} second ago","other":"{0} seconds ago"}}}}};
	
	//# sourceMappingURL=en.js.map

/***/ },
/* 1649 */
/***/ function(module, exports) {

	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	
	/* jslint esnext: true */
	
	"use strict";
	
	// Purposely using the same implementation as the Intl.js `Intl` polyfill.
	// Copyright 2013 Andy Earnshaw, MIT License
	
	var hop = Object.prototype.hasOwnProperty;
	var toString = Object.prototype.toString;
	
	var realDefineProp = (function () {
	    try { return !!Object.defineProperty({}, 'a', {}); }
	    catch (e) { return false; }
	})();
	
	var es3 = !realDefineProp && !Object.prototype.__defineGetter__;
	
	var defineProperty = realDefineProp ? Object.defineProperty :
	        function (obj, name, desc) {
	
	    if ('get' in desc && obj.__defineGetter__) {
	        obj.__defineGetter__(name, desc.get);
	    } else if (!hop.call(obj, name) || 'value' in desc) {
	        obj[name] = desc.value;
	    }
	};
	
	var objCreate = Object.create || function (proto, props) {
	    var obj, k;
	
	    function F() {}
	    F.prototype = proto;
	    obj = new F();
	
	    for (k in props) {
	        if (hop.call(props, k)) {
	            defineProperty(obj, k, props[k]);
	        }
	    }
	
	    return obj;
	};
	
	var arrIndexOf = Array.prototype.indexOf || function (search, fromIndex) {
	    /*jshint validthis:true */
	    var arr = this;
	    if (!arr.length) {
	        return -1;
	    }
	
	    for (var i = fromIndex || 0, max = arr.length; i < max; i++) {
	        if (arr[i] === search) {
	            return i;
	        }
	    }
	
	    return -1;
	};
	
	var isArray = Array.isArray || function (obj) {
	    return toString.call(obj) === '[object Array]';
	};
	
	var dateNow = Date.now || function () {
	    return new Date().getTime();
	};
	exports.defineProperty = defineProperty, exports.objCreate = objCreate, exports.arrIndexOf = arrIndexOf, exports.isArray = isArray, exports.dateNow = dateNow;
	
	//# sourceMappingURL=es5.js.map

/***/ },
/* 1650 */
[2187, 1646, 1648],
/* 1651 */
/***/ function(module, exports) {

	/*!
	 * Determine if an object is a Buffer
	 *
	 * @author   Feross Aboukhadijeh <https://feross.org>
	 * @license  MIT
	 */
	
	// The _isBuffer check is for Safari 5-7 support, because it's missing
	// Object.prototype.constructor. Remove this eventually
	module.exports = function (obj) {
	  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
	}
	
	function isBuffer (obj) {
	  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
	}
	
	// For Node v0.10 support. Remove this eventually.
	function isSlowBuffer (obj) {
	  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
	}


/***/ },
/* 1652 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	/**
	 * Returns the object type of the given payload
	 *
	 * @param {*} payload
	 * @returns {string}
	 */
	function getType(payload) {
	    return Object.prototype.toString.call(payload).slice(8, -1);
	}
	/**
	 * Returns whether the payload is undefined
	 *
	 * @param {*} payload
	 * @returns {payload is undefined}
	 */
	function isUndefined(payload) {
	    return getType(payload) === 'Undefined';
	}
	/**
	 * Returns whether the payload is null
	 *
	 * @param {*} payload
	 * @returns {payload is null}
	 */
	function isNull(payload) {
	    return getType(payload) === 'Null';
	}
	/**
	 * Returns whether the payload is a plain JavaScript object (excluding special classes or objects with other prototypes)
	 *
	 * @param {*} payload
	 * @returns {payload is PlainObject}
	 */
	function isPlainObject(payload) {
	    if (getType(payload) !== 'Object')
	        return false;
	    return payload.constructor === Object && Object.getPrototypeOf(payload) === Object.prototype;
	}
	/**
	 * Returns whether the payload is a plain JavaScript object (excluding special classes or objects with other prototypes)
	 *
	 * @param {*} payload
	 * @returns {payload is PlainObject}
	 */
	function isObject(payload) {
	    return isPlainObject(payload);
	}
	/**
	 * Returns whether the payload is a an empty object (excluding special classes or objects with other prototypes)
	 *
	 * @param {*} payload
	 * @returns {payload is { [K in any]: never }}
	 */
	function isEmptyObject(payload) {
	    return isPlainObject(payload) && Object.keys(payload).length === 0;
	}
	/**
	 * Returns whether the payload is a an empty object (excluding special classes or objects with other prototypes)
	 *
	 * @param {*} payload
	 * @returns {payload is PlainObject}
	 */
	function isFullObject(payload) {
	    return isPlainObject(payload) && Object.keys(payload).length > 0;
	}
	/**
	 * Returns whether the payload is an any kind of object (including special classes or objects with different prototypes)
	 *
	 * @param {*} payload
	 * @returns {payload is PlainObject}
	 */
	function isAnyObject(payload) {
	    return getType(payload) === 'Object';
	}
	/**
	 * Returns whether the payload is an object like a type passed in < >
	 *
	 * Usage: isObjectLike<{id: any}>(payload) // will make sure it's an object and has an `id` prop.
	 *
	 * @template T this must be passed in < >
	 * @param {*} payload
	 * @returns {payload is T}
	 */
	function isObjectLike(payload) {
	    return isAnyObject(payload);
	}
	/**
	 * Returns whether the payload is a function (regular or async)
	 *
	 * @param {*} payload
	 * @returns {payload is AnyFunction}
	 */
	function isFunction(payload) {
	    return typeof payload === 'function';
	}
	/**
	 * Returns whether the payload is an array
	 *
	 * @param {any} payload
	 * @returns {payload is any[]}
	 */
	function isArray(payload) {
	    return getType(payload) === 'Array';
	}
	/**
	 * Returns whether the payload is a an array with at least 1 item
	 *
	 * @param {*} payload
	 * @returns {payload is any[]}
	 */
	function isFullArray(payload) {
	    return isArray(payload) && payload.length > 0;
	}
	/**
	 * Returns whether the payload is a an empty array
	 *
	 * @param {*} payload
	 * @returns {payload is []}
	 */
	function isEmptyArray(payload) {
	    return isArray(payload) && payload.length === 0;
	}
	/**
	 * Returns whether the payload is a string
	 *
	 * @param {*} payload
	 * @returns {payload is string}
	 */
	function isString(payload) {
	    return getType(payload) === 'String';
	}
	/**
	 * Returns whether the payload is a string, BUT returns false for ''
	 *
	 * @param {*} payload
	 * @returns {payload is string}
	 */
	function isFullString(payload) {
	    return isString(payload) && payload !== '';
	}
	/**
	 * Returns whether the payload is ''
	 *
	 * @param {*} payload
	 * @returns {payload is string}
	 */
	function isEmptyString(payload) {
	    return payload === '';
	}
	/**
	 * Returns whether the payload is a number (but not NaN)
	 *
	 * This will return `false` for `NaN`!!
	 *
	 * @param {*} payload
	 * @returns {payload is number}
	 */
	function isNumber(payload) {
	    return getType(payload) === 'Number' && !isNaN(payload);
	}
	/**
	 * Returns whether the payload is a boolean
	 *
	 * @param {*} payload
	 * @returns {payload is boolean}
	 */
	function isBoolean(payload) {
	    return getType(payload) === 'Boolean';
	}
	/**
	 * Returns whether the payload is a regular expression (RegExp)
	 *
	 * @param {*} payload
	 * @returns {payload is RegExp}
	 */
	function isRegExp(payload) {
	    return getType(payload) === 'RegExp';
	}
	/**
	 * Returns whether the payload is a Map
	 *
	 * @param {*} payload
	 * @returns {payload is Map<any, any>}
	 */
	function isMap(payload) {
	    return getType(payload) === 'Map';
	}
	/**
	 * Returns whether the payload is a WeakMap
	 *
	 * @param {*} payload
	 * @returns {payload is WeakMap<any, any>}
	 */
	function isWeakMap(payload) {
	    return getType(payload) === 'WeakMap';
	}
	/**
	 * Returns whether the payload is a Set
	 *
	 * @param {*} payload
	 * @returns {payload is Set<any>}
	 */
	function isSet(payload) {
	    return getType(payload) === 'Set';
	}
	/**
	 * Returns whether the payload is a WeakSet
	 *
	 * @param {*} payload
	 * @returns {payload is WeakSet<any>}
	 */
	function isWeakSet(payload) {
	    return getType(payload) === 'WeakSet';
	}
	/**
	 * Returns whether the payload is a Symbol
	 *
	 * @param {*} payload
	 * @returns {payload is symbol}
	 */
	function isSymbol(payload) {
	    return getType(payload) === 'Symbol';
	}
	/**
	 * Returns whether the payload is a Date, and that the date is valid
	 *
	 * @param {*} payload
	 * @returns {payload is Date}
	 */
	function isDate(payload) {
	    return getType(payload) === 'Date' && !isNaN(payload);
	}
	/**
	 * Returns whether the payload is a Blob
	 *
	 * @param {*} payload
	 * @returns {payload is Blob}
	 */
	function isBlob(payload) {
	    return getType(payload) === 'Blob';
	}
	/**
	 * Returns whether the payload is a File
	 *
	 * @param {*} payload
	 * @returns {payload is File}
	 */
	function isFile(payload) {
	    return getType(payload) === 'File';
	}
	/**
	 * Returns whether the payload is a Promise
	 *
	 * @param {*} payload
	 * @returns {payload is Promise<any>}
	 */
	function isPromise(payload) {
	    return getType(payload) === 'Promise';
	}
	/**
	 * Returns whether the payload is an Error
	 *
	 * @param {*} payload
	 * @returns {payload is Error}
	 */
	function isError(payload) {
	    return getType(payload) === 'Error';
	}
	/**
	 * Returns whether the payload is literally the value `NaN` (it's `NaN` and also a `number`)
	 *
	 * @param {*} payload
	 * @returns {payload is typeof NaN}
	 */
	function isNaNValue(payload) {
	    return getType(payload) === 'Number' && isNaN(payload);
	}
	/**
	 * Returns whether the payload is a primitive type (eg. Boolean | Null | Undefined | Number | String | Symbol)
	 *
	 * @param {*} payload
	 * @returns {(payload is boolean | null | undefined | number | string | symbol)}
	 */
	function isPrimitive(payload) {
	    return (isBoolean(payload) ||
	        isNull(payload) ||
	        isUndefined(payload) ||
	        isNumber(payload) ||
	        isString(payload) ||
	        isSymbol(payload));
	}
	/**
	 * Returns true whether the payload is null or undefined
	 *
	 * @param {*} payload
	 * @returns {(payload is null | undefined)}
	 */
	var isNullOrUndefined = isOneOf(isNull, isUndefined);
	function isOneOf(a, b, c, d, e) {
	    return function (value) {
	        return a(value) || b(value) || (!!c && c(value)) || (!!d && d(value)) || (!!e && e(value));
	    };
	}
	/**
	 * Does a generic check to check that the given payload is of a given type.
	 * In cases like Number, it will return true for NaN as NaN is a Number (thanks javascript!);
	 * It will, however, differentiate between object and null
	 *
	 * @template T
	 * @param {*} payload
	 * @param {T} type
	 * @throws {TypeError} Will throw type error if type is an invalid type
	 * @returns {payload is T}
	 */
	function isType(payload, type) {
	    if (!(type instanceof Function)) {
	        throw new TypeError('Type must be a function');
	    }
	    if (!Object.prototype.hasOwnProperty.call(type, 'prototype')) {
	        throw new TypeError('Type is not a class');
	    }
	    // Classes usually have names (as functions usually have names)
	    var name = type.name;
	    return getType(payload) === name || Boolean(payload && payload.constructor === type);
	}
	
	exports.getType = getType;
	exports.isAnyObject = isAnyObject;
	exports.isArray = isArray;
	exports.isBlob = isBlob;
	exports.isBoolean = isBoolean;
	exports.isDate = isDate;
	exports.isEmptyArray = isEmptyArray;
	exports.isEmptyObject = isEmptyObject;
	exports.isEmptyString = isEmptyString;
	exports.isError = isError;
	exports.isFile = isFile;
	exports.isFullArray = isFullArray;
	exports.isFullObject = isFullObject;
	exports.isFullString = isFullString;
	exports.isFunction = isFunction;
	exports.isMap = isMap;
	exports.isNaNValue = isNaNValue;
	exports.isNull = isNull;
	exports.isNullOrUndefined = isNullOrUndefined;
	exports.isNumber = isNumber;
	exports.isObject = isObject;
	exports.isObjectLike = isObjectLike;
	exports.isOneOf = isOneOf;
	exports.isPlainObject = isPlainObject;
	exports.isPrimitive = isPrimitive;
	exports.isPromise = isPromise;
	exports.isRegExp = isRegExp;
	exports.isSet = isSet;
	exports.isString = isString;
	exports.isSymbol = isSymbol;
	exports.isType = isType;
	exports.isUndefined = isUndefined;
	exports.isWeakMap = isWeakMap;
	exports.isWeakSet = isWeakSet;


/***/ },
/* 1653 */
/***/ function(module, exports) {

	(function (root, factory) {
	    if (typeof module !== 'undefined' && module.exports) {
	        module.exports = factory();
	    } else {
	        root.ImageZoom = factory();
	    }
	}(this, function () {
	    /**
	     * @param {Object} container DOM element, which contains an image to be zoomed (required)
	     * @param {Object} options js-image-zoom options (required)
	     * **width** (number) - width of the source image (optional)
	     * **height** (number) - height of the source image (optional).
	     * **zoomWidth** (number) - width of the zoomed image. Zoomed image height equals source image height (optional)
	     * **img** (string) - url of the source image. Provided if container does not contain img element as a tag (optional)
	     * **scale** (number) - zoom scale. if not provided, scale is calculated as natural image size / image size, provided in params (optional if zoomWidth param is provided)
	     * **offset** (object) - {vertical: number, horizontal: number}. Zoomed image offset (optional)
	     * **zoomContainer** (node) - DOM node reference where zoomedImage will be appended to (default to the container element of image)
	     * **zoomStyle** (string) - custom style applied to the zoomed image (i.e. 'opacity: 0.1;background-color: white;')
	     * **zoomPosition** (string) - position of zoomed image. It can be:  `top`, `left`, `bottom`, `original` or the default `right`.
	     * **zoomLensStyle** (string) custom style applied to to zoom lents (i.e. 'opacity: 0.1;background-color: white;')
	     */
	    return function ImageZoom(container, opts) {
	        "use strict";
	        var options = opts;
	        if (!container) {
	            return;
	        }
	        var data = {
	            sourceImg: {
	                element: null,
	                width: 0,
	                height: 0,
	                naturalWidth: 0,
	                naturalHeight: 0
	            },
	            zoomedImgOffset: {
	                vertical: 0,
	                horizontal: 0
	            },
	            zoomedImg: {
	                element: null,
	                width: 0,
	                height: 0
	            },
	            zoomLens: {
	                element: null,
	                width: 0,
	                height: 0
	            }
	        };
	
	        var div = document.createElement('div');
	        var lensDiv = document.createElement('div');
	        var scaleX;
	        var scaleY;
	        var offset;
	        data.zoomedImgOffset = {
	            vertical: options.offset && options.offset.vertical ? options.offset.vertical : 0,
	            horizontal: options.offset && options.offset.horizontal ? options.offset.horizontal : 0
	        };
	        data.zoomPosition = options.zoomPosition || 'right';
	        data.zoomContainer = (options.zoomContainer) ? options.zoomContainer : container;
	        function getOffset(el) {
	            if (el) {
	                var elRect = el.getBoundingClientRect();
	                return {left: elRect.left, top: elRect.top};
	            }
	            return {left: 0, top: 0};
	        }
	
	        function leftLimit(min) {
	            return options.width - min;
	        }
	
	        function topLimit(min) {
	            return options.height - min;
	        }
	
	        function getValue(val, min, max) {
	            if (val < min) {
	                return min;
	            }
	            if (val > max) {
	                return max;
	            }
	            return val;
	        }
	
	        function getPosition(v, min, max) {
	            var value = getValue(v, min, max);
	            return value - min;
	        }
	
	        function zoomLensLeft(left) {
	            var leftMin = data.zoomLens.width / 2;
	            return getPosition(left, leftMin, leftLimit(leftMin));
	        }
	
	        function zoomLensTop(top) {
	            var topMin = data.zoomLens.height / 2;
	            return getPosition(top, topMin, topLimit(topMin));
	        }
	
	        function setZoomedImgSize(options, data) {
	            if (options.scale) {
	                data.zoomedImg.element.style.width = options.width * options.scale + 'px';
	                data.zoomedImg.element.style.height = options.height * options.scale + 'px';
	            } else if (options.zoomWidth) {
	                data.zoomedImg.element.style.width = options.zoomWidth + 'px';
	                data.zoomedImg.element.style.height = data.sourceImg.element.style.height;
	            } else {
	                data.zoomedImg.element.style.width = '100%';
	                data.zoomedImg.element.style.height = '100%';
	            }
	        }
	
	        function onSourceImgLoad() {
	            // use height determined by browser if height is not set in options
	            options.height = options.height || data.sourceImg.element.height;
	            data.sourceImg.element.style.height = options.height + 'px';
	
	            // use width determined by browser if width is not set in options
	            options.width = options.width || data.sourceImg.element.width;
	            data.sourceImg.element.style.width = options.width + 'px';
	
	            setZoomedImgSize(options, data);
	
	            data.sourceImg.naturalWidth = data.sourceImg.element.naturalWidth;
	            data.sourceImg.naturalHeight = data.sourceImg.element.naturalHeight;
	            data.zoomedImg.element.style.backgroundSize = data.sourceImg.naturalWidth + 'px ' + data.sourceImg.naturalHeight + 'px';
	
	            if (options.zoomStyle) {
	                data.zoomedImg.element.style.cssText += options.zoomStyle;
	            }
	            if (options.zoomLensStyle) {
	                data.zoomLens.element.style.cssText += options.zoomLensStyle;
	            } else {
	                data.zoomLens.element.style.background = 'white';
	                data.zoomLens.element.style.opacity = '0.4';
	            }
	
	            scaleX = data.sourceImg.naturalWidth / options.width;
	            scaleY = data.sourceImg.naturalHeight / options.height;
	            offset = getOffset(data.sourceImg.element);
	
	            // set zoomLens dimensions
	            // if custom scale is set
	            if (options.scale) {
	                data.zoomLens.width = options.width / (data.sourceImg.naturalWidth / (options.width * options.scale));
	                data.zoomLens.height = options.height / (data.sourceImg.naturalHeight / (options.height * options.scale));
	            }
	
	            // else if zoomWidth is set
	            else if (options.zoomWidth) {
	                data.zoomLens.width = options.zoomWidth / scaleX;
	                data.zoomLens.height = options.height / scaleY;
	            }
	
	            // else read from the zoomedImg
	            else {
	                data.zoomedImg.element.style.display = 'block';
	                data.zoomLens.width = data.zoomedImg.element.clientWidth / scaleX;
	                data.zoomLens.height = data.zoomedImg.element.clientHeight / scaleY;
	                data.zoomedImg.element.style.display = 'none';
	            }
	
	            data.zoomLens.element.style.position = 'absolute';
	            data.zoomLens.element.style.width = data.zoomLens.width + 'px';
	            data.zoomLens.element.style.height = data.zoomLens.height + 'px';
	            data.zoomLens.element.pointerEvents = 'none';
	        }
	
	        function setup() {
	            // create sourceImg element
	            if (options.img) {
	                var img = document.createElement('img');
	                img.src = options.img;
	                data.sourceImg.element = container.appendChild(img);
	            }
	
	            // or get sourceImg element from specified container
	            else {
	                data.sourceImg.element = container.children[0];
	
	                // if sourceImg is not an img (might be a picture element), try to find one
	                if (data.sourceImg.element.nodeName !== "IMG") {
	                    data.sourceImg.element = data.sourceImg.element.querySelector('img');
	                }
	            }
	
	            options = options || {};
	            container.style.position = 'relative';
	            data.sourceImg.element.style.width = options.width ? options.width + 'px' : 'auto';
	            data.sourceImg.element.style.height = options.height ? options.height + 'px' : 'auto';
	
	            data.zoomLens.element = container.appendChild(lensDiv);
	            data.zoomLens.element.style.display = 'none';
	            data.zoomLens.element.classList.add('js-image-zoom__zoomed-area');
	
	            data.zoomedImg.element = data.zoomContainer.appendChild(div);
	            data.zoomedImg.element.classList.add('js-image-zoom__zoomed-image');
	            data.zoomedImg.element.style.backgroundImage = "url('" + data.sourceImg.element.src + "')";
	            data.zoomedImg.element.style.backgroundRepeat = 'no-repeat';
	            data.zoomedImg.element.style.display = 'none';
	
	            switch (data.zoomPosition) {
	                case 'left':
	                    data.zoomedImg.element.style.position = 'absolute';
	                    data.zoomedImg.element.style.top = data.zoomedImgOffset.vertical + 'px';
	                    data.zoomedImg.element.style.left = data.zoomedImgOffset.horizontal - (data.zoomedImgOffset.horizontal * 2) + 'px';
	                    data.zoomedImg.element.style.transform = 'translateX(-100%)';
	                    break;
	
	                case 'top':
	                    data.zoomedImg.element.style.position = 'absolute';
	                    data.zoomedImg.element.style.top = data.zoomedImgOffset.vertical - (data.zoomedImgOffset.vertical * 2) + 'px';
	                    data.zoomedImg.element.style.left = 'calc(50% + ' + data.zoomedImgOffset.horizontal + 'px)';
	                    data.zoomedImg.element.style.transform = 'translate3d(-50%, -100%, 0)';
	                    break;
	
	                case 'bottom':
	                    data.zoomedImg.element.style.position = 'absolute';
	                    data.zoomedImg.element.style.bottom = data.zoomedImgOffset.vertical - (data.zoomedImgOffset.vertical * 2) + 'px';
	                    data.zoomedImg.element.style.left = 'calc(50% + ' + data.zoomedImgOffset.horizontal + 'px)';
	                    data.zoomedImg.element.style.transform = 'translate3d(-50%, 100%, 0)';
	                    break;
	
	                case 'original':
	                    data.zoomedImg.element.style.position = 'absolute';
	                    data.zoomedImg.element.style.top = '0px';
	                    data.zoomedImg.element.style.left = '0px';
	                    break;
	
	                // Right Position
	                default:
	                    data.zoomedImg.element.style.position = 'absolute';
	                    data.zoomedImg.element.style.top = data.zoomedImgOffset.vertical + 'px';
	                    data.zoomedImg.element.style.right = data.zoomedImgOffset.horizontal - (data.zoomedImgOffset.horizontal * 2) + 'px';
	                    data.zoomedImg.element.style.transform = 'translateX(100%)';
	                    break;
	            }
	
	
	            // setup event listeners
	            container.addEventListener('mousemove', events, false);
	            container.addEventListener('mouseenter', events, false);
	            container.addEventListener('mouseleave', events, false);
	            data.zoomLens.element.addEventListener('mouseenter', events, false);
	            data.zoomLens.element.addEventListener('mouseleave', events, false);
	            window.addEventListener('scroll', events, false);
	
	            return data;
	        }
	
	        function kill() {
	
	            // remove event listeners
	            container.removeEventListener('mousemove', events, false);
	            container.removeEventListener('mouseenter', events, false);
	            container.removeEventListener('mouseleave', events, false);
	            data.zoomLens.element.removeEventListener('mouseenter', events, false);
	            data.zoomLens.element.removeEventListener('mouseleave', events, false);
	            window.removeEventListener('scroll', events, false);
	
	            // remove dom nodes
	            if (data.zoomLens && data.zoomedImg) {
	                container.removeChild(data.zoomLens.element);
	                data.zoomContainer.removeChild(data.zoomedImg.element);
	            }
	
	            if (options.img) {
	                container.removeChild(data.sourceImg.element);
	            } else {
	                data.sourceImg.element.style.width = '';
	                data.sourceImg.element.style.height = '';
	            }
	
	            return data;
	        }
	
	        var events = {
	            handleEvent: function (event) {
	                switch (event.type) {
	                    case 'mousemove':
	                        return this.handleMouseMove(event);
	                    case 'mouseenter':
	                        return this.handleMouseEnter(event);
	                    case 'mouseleave':
	                        return this.handleMouseLeave(event);
	                    case 'scroll':
	                        return this.handleScroll(event);
	                }
	            },
	            handleMouseMove: function (event) {
	                var offsetX;
	                var offsetY;
	                var backgroundTop;
	                var backgroundRight;
	                var backgroundPosition;
	                if (offset) {
	                    offsetX = zoomLensLeft(event.clientX - offset.left);
	                    offsetY = zoomLensTop(event.clientY - offset.top);
	                    backgroundTop = offsetX * scaleX;
	                    backgroundRight = offsetY * scaleY;
	                    backgroundPosition = '-' + backgroundTop + 'px ' + '-' + backgroundRight + 'px';
	                    data.zoomedImg.element.style.backgroundPosition = backgroundPosition;
	                    data.zoomLens.element.style.cssText += 'top:' + offsetY + 'px;' + 'left:' + offsetX + 'px;display: block;';
	
	                }
	            },
	            handleMouseEnter: function () {
	                data.zoomedImg.element.style.display = 'block';
	                data.zoomLens.element.style.display = 'block';
	
	            },
	            handleMouseLeave: function () {
	                data.zoomedImg.element.style.display = 'none';
	                data.zoomLens.element.style.display = 'none';
	            },
	            handleScroll: function () {
	                offset = getOffset(data.sourceImg.element);
	            }
	        };
	
	        // Setup/Initialize library
	        setup();
	
	        if (data.sourceImg.element.complete) {
	            onSourceImgLoad();
	        } else {
	            data.sourceImg.element.onload = onSourceImgLoad;
	        }
	
	        return {
	            setup: function () {
	                setup();
	            },
	            kill: function () {
	                kill();
	            },
	            _getInstanceInfo: function () {
	                return {
	                    setup: setup,
	                    kill: kill,
	                    onSourceImgLoad: onSourceImgLoad,
	                    data: data,
	                    options: options
	                }
	            }
	        }
	    }
	}));


/***/ },
/* 1654 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(110),
	    root = __webpack_require__(77);
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView');
	
	module.exports = DataView;


/***/ },
/* 1655 */
/***/ function(module, exports, __webpack_require__) {

	var hashClear = __webpack_require__(1703),
	    hashDelete = __webpack_require__(1704),
	    hashGet = __webpack_require__(1705),
	    hashHas = __webpack_require__(1706),
	    hashSet = __webpack_require__(1707);
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	module.exports = Hash;


/***/ },
/* 1656 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(110),
	    root = __webpack_require__(77);
	
	/* Built-in method references that are verified to be native. */
	var Promise = getNative(root, 'Promise');
	
	module.exports = Promise;


/***/ },
/* 1657 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(110),
	    root = __webpack_require__(77);
	
	/* Built-in method references that are verified to be native. */
	var Set = getNative(root, 'Set');
	
	module.exports = Set;


/***/ },
/* 1658 */
/***/ function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(296),
	    setCacheAdd = __webpack_require__(1729),
	    setCacheHas = __webpack_require__(1730);
	
	/**
	 *
	 * Creates an array cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var index = -1,
	      length = values == null ? 0 : values.length;
	
	  this.__data__ = new MapCache;
	  while (++index < length) {
	    this.add(values[index]);
	  }
	}
	
	// Add methods to `SetCache`.
	SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	SetCache.prototype.has = setCacheHas;
	
	module.exports = SetCache;


/***/ },
/* 1659 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(110),
	    root = __webpack_require__(77);
	
	/* Built-in method references that are verified to be native. */
	var WeakMap = getNative(root, 'WeakMap');
	
	module.exports = WeakMap;


/***/ },
/* 1660 */
/***/ function(module, exports) {

	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  switch (args.length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}
	
	module.exports = apply;


/***/ },
/* 1661 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.filter` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function arrayFilter(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (predicate(value, index, array)) {
	      result[resIndex++] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = arrayFilter;


/***/ },
/* 1662 */
/***/ function(module, exports) {

	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	module.exports = arrayPush;


/***/ },
/* 1663 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.some` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function arraySome(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arraySome;


/***/ },
/* 1664 */
/***/ function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(201),
	    eq = __webpack_require__(156);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Assigns `value` to `key` of `object` if the existing value is not equivalent
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignValue(object, key, value) {
	  var objValue = object[key];
	  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	      (value === undefined && !(key in object))) {
	    baseAssignValue(object, key, value);
	  }
	}
	
	module.exports = assignValue;


/***/ },
/* 1665 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(97);
	
	/** Built-in value references. */
	var objectCreate = Object.create;
	
	/**
	 * The base implementation of `_.create` without support for assigning
	 * properties to the created object.
	 *
	 * @private
	 * @param {Object} proto The object to inherit from.
	 * @returns {Object} Returns the new object.
	 */
	var baseCreate = (function() {
	  function object() {}
	  return function(proto) {
	    if (!isObject(proto)) {
	      return {};
	    }
	    if (objectCreate) {
	      return objectCreate(proto);
	    }
	    object.prototype = proto;
	    var result = new object;
	    object.prototype = undefined;
	    return result;
	  };
	}());
	
	module.exports = baseCreate;


/***/ },
/* 1666 */
/***/ function(module, exports, __webpack_require__) {

	var baseFor = __webpack_require__(477),
	    keys = __webpack_require__(302);
	
	/**
	 * The base implementation of `_.forOwn` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForOwn(object, iteratee) {
	  return object && baseFor(object, iteratee, keys);
	}
	
	module.exports = baseForOwn;


/***/ },
/* 1667 */
/***/ function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(1662),
	    isArray = __webpack_require__(72);
	
	/**
	 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @param {Function} symbolsFunc The function to get the symbols of `object`.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	  var result = keysFunc(object);
	  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	}
	
	module.exports = baseGetAllKeys;


/***/ },
/* 1668 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.hasIn` without support for deep paths.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {Array|string} key The key to check.
	 * @returns {boolean} Returns `true` if `key` exists, else `false`.
	 */
	function baseHasIn(object, key) {
	  return object != null && key in Object(object);
	}
	
	module.exports = baseHasIn;


/***/ },
/* 1669 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(131),
	    isObjectLike = __webpack_require__(111);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]';
	
	/**
	 * The base implementation of `_.isArguments`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 */
	function baseIsArguments(value) {
	  return isObjectLike(value) && baseGetTag(value) == argsTag;
	}
	
	module.exports = baseIsArguments;


/***/ },
/* 1670 */
/***/ function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(297),
	    equalArrays = __webpack_require__(483),
	    equalByTag = __webpack_require__(1695),
	    equalObjects = __webpack_require__(1696),
	    getTag = __webpack_require__(486),
	    isArray = __webpack_require__(72),
	    isBuffer = __webpack_require__(207),
	    isTypedArray = __webpack_require__(210);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	  var objIsArr = isArray(object),
	      othIsArr = isArray(other),
	      objTag = objIsArr ? arrayTag : getTag(object),
	      othTag = othIsArr ? arrayTag : getTag(other);
	
	  objTag = objTag == argsTag ? objectTag : objTag;
	  othTag = othTag == argsTag ? objectTag : othTag;
	
	  var objIsObj = objTag == objectTag,
	      othIsObj = othTag == objectTag,
	      isSameTag = objTag == othTag;
	
	  if (isSameTag && isBuffer(object)) {
	    if (!isBuffer(other)) {
	      return false;
	    }
	    objIsArr = true;
	    objIsObj = false;
	  }
	  if (isSameTag && !objIsObj) {
	    stack || (stack = new Stack);
	    return (objIsArr || isTypedArray(object))
	      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	  }
	  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	    if (objIsWrapped || othIsWrapped) {
	      var objUnwrapped = objIsWrapped ? object.value() : object,
	          othUnwrapped = othIsWrapped ? other.value() : other;
	
	      stack || (stack = new Stack);
	      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	    }
	  }
	  if (!isSameTag) {
	    return false;
	  }
	  stack || (stack = new Stack);
	  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	}
	
	module.exports = baseIsEqualDeep;


/***/ },
/* 1671 */
/***/ function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(297),
	    baseIsEqual = __webpack_require__(202);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.isMatch` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to inspect.
	 * @param {Object} source The object of property values to match.
	 * @param {Array} matchData The property names, values, and compare flags to match.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	 */
	function baseIsMatch(object, source, matchData, customizer) {
	  var index = matchData.length,
	      length = index,
	      noCustomizer = !customizer;
	
	  if (object == null) {
	    return !length;
	  }
	  object = Object(object);
	  while (index--) {
	    var data = matchData[index];
	    if ((noCustomizer && data[2])
	          ? data[1] !== object[data[0]]
	          : !(data[0] in object)
	        ) {
	      return false;
	    }
	  }
	  while (++index < length) {
	    data = matchData[index];
	    var key = data[0],
	        objValue = object[key],
	        srcValue = data[1];
	
	    if (noCustomizer && data[2]) {
	      if (objValue === undefined && !(key in object)) {
	        return false;
	      }
	    } else {
	      var stack = new Stack;
	      if (customizer) {
	        var result = customizer(objValue, srcValue, key, object, source, stack);
	      }
	      if (!(result === undefined
	            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	            : result
	          )) {
	        return false;
	      }
	    }
	  }
	  return true;
	}
	
	module.exports = baseIsMatch;


/***/ },
/* 1672 */
/***/ function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(208),
	    isMasked = __webpack_require__(1711),
	    isObject = __webpack_require__(97),
	    toSource = __webpack_require__(492);
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	module.exports = baseIsNative;


/***/ },
/* 1673 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(131),
	    isLength = __webpack_require__(301),
	    isObjectLike = __webpack_require__(111);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	}
	
	module.exports = baseIsTypedArray;


/***/ },
/* 1674 */
/***/ function(module, exports, __webpack_require__) {

	var baseMatches = __webpack_require__(1676),
	    baseMatchesProperty = __webpack_require__(1677),
	    identity = __webpack_require__(300),
	    isArray = __webpack_require__(72),
	    property = __webpack_require__(1748);
	
	/**
	 * The base implementation of `_.iteratee`.
	 *
	 * @private
	 * @param {*} [value=_.identity] The value to convert to an iteratee.
	 * @returns {Function} Returns the iteratee.
	 */
	function baseIteratee(value) {
	  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	  if (typeof value == 'function') {
	    return value;
	  }
	  if (value == null) {
	    return identity;
	  }
	  if (typeof value == 'object') {
	    return isArray(value)
	      ? baseMatchesProperty(value[0], value[1])
	      : baseMatches(value);
	  }
	  return property(value);
	}
	
	module.exports = baseIteratee;


/***/ },
/* 1675 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(97),
	    isPrototype = __webpack_require__(204),
	    nativeKeysIn = __webpack_require__(1725);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeysIn(object) {
	  if (!isObject(object)) {
	    return nativeKeysIn(object);
	  }
	  var isProto = isPrototype(object),
	      result = [];
	
	  for (var key in object) {
	    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeysIn;


/***/ },
/* 1676 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsMatch = __webpack_require__(1671),
	    getMatchData = __webpack_require__(1698),
	    matchesStrictComparable = __webpack_require__(488);
	
	/**
	 * The base implementation of `_.matches` which doesn't clone `source`.
	 *
	 * @private
	 * @param {Object} source The object of property values to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatches(source) {
	  var matchData = getMatchData(source);
	  if (matchData.length == 1 && matchData[0][2]) {
	    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	  }
	  return function(object) {
	    return object === source || baseIsMatch(object, source, matchData);
	  };
	}
	
	module.exports = baseMatches;


/***/ },
/* 1677 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(202),
	    get = __webpack_require__(493),
	    hasIn = __webpack_require__(1740),
	    isKey = __webpack_require__(299),
	    isStrictComparable = __webpack_require__(487),
	    matchesStrictComparable = __webpack_require__(488),
	    toKey = __webpack_require__(155);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	 *
	 * @private
	 * @param {string} path The path of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatchesProperty(path, srcValue) {
	  if (isKey(path) && isStrictComparable(srcValue)) {
	    return matchesStrictComparable(toKey(path), srcValue);
	  }
	  return function(object) {
	    var objValue = get(object, path);
	    return (objValue === undefined && objValue === srcValue)
	      ? hasIn(object, path)
	      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	  };
	}
	
	module.exports = baseMatchesProperty;


/***/ },
/* 1678 */
/***/ function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(297),
	    assignMergeValue = __webpack_require__(476),
	    baseFor = __webpack_require__(477),
	    baseMergeDeep = __webpack_require__(1679),
	    isObject = __webpack_require__(97),
	    keysIn = __webpack_require__(495),
	    safeGet = __webpack_require__(490);
	
	/**
	 * The base implementation of `_.merge` without support for multiple sources.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {number} srcIndex The index of `source`.
	 * @param {Function} [customizer] The function to customize merged values.
	 * @param {Object} [stack] Tracks traversed source values and their merged
	 *  counterparts.
	 */
	function baseMerge(object, source, srcIndex, customizer, stack) {
	  if (object === source) {
	    return;
	  }
	  baseFor(source, function(srcValue, key) {
	    stack || (stack = new Stack);
	    if (isObject(srcValue)) {
	      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	    }
	    else {
	      var newValue = customizer
	        ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
	        : undefined;
	
	      if (newValue === undefined) {
	        newValue = srcValue;
	      }
	      assignMergeValue(object, key, newValue);
	    }
	  }, keysIn);
	}
	
	module.exports = baseMerge;


/***/ },
/* 1679 */
/***/ function(module, exports, __webpack_require__) {

	var assignMergeValue = __webpack_require__(476),
	    cloneBuffer = __webpack_require__(1689),
	    cloneTypedArray = __webpack_require__(1690),
	    copyArray = __webpack_require__(481),
	    initCloneObject = __webpack_require__(1708),
	    isArguments = __webpack_require__(206),
	    isArray = __webpack_require__(72),
	    isArrayLikeObject = __webpack_require__(1741),
	    isBuffer = __webpack_require__(207),
	    isFunction = __webpack_require__(208),
	    isObject = __webpack_require__(97),
	    isPlainObject = __webpack_require__(1745),
	    isTypedArray = __webpack_require__(210),
	    safeGet = __webpack_require__(490),
	    toPlainObject = __webpack_require__(1751);
	
	/**
	 * A specialized version of `baseMerge` for arrays and objects which performs
	 * deep merges and tracks traversed objects enabling objects with circular
	 * references to be merged.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {string} key The key of the value to merge.
	 * @param {number} srcIndex The index of `source`.
	 * @param {Function} mergeFunc The function to merge values.
	 * @param {Function} [customizer] The function to customize assigned values.
	 * @param {Object} [stack] Tracks traversed source values and their merged
	 *  counterparts.
	 */
	function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	  var objValue = safeGet(object, key),
	      srcValue = safeGet(source, key),
	      stacked = stack.get(srcValue);
	
	  if (stacked) {
	    assignMergeValue(object, key, stacked);
	    return;
	  }
	  var newValue = customizer
	    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	    : undefined;
	
	  var isCommon = newValue === undefined;
	
	  if (isCommon) {
	    var isArr = isArray(srcValue),
	        isBuff = !isArr && isBuffer(srcValue),
	        isTyped = !isArr && !isBuff && isTypedArray(srcValue);
	
	    newValue = srcValue;
	    if (isArr || isBuff || isTyped) {
	      if (isArray(objValue)) {
	        newValue = objValue;
	      }
	      else if (isArrayLikeObject(objValue)) {
	        newValue = copyArray(objValue);
	      }
	      else if (isBuff) {
	        isCommon = false;
	        newValue = cloneBuffer(srcValue, true);
	      }
	      else if (isTyped) {
	        isCommon = false;
	        newValue = cloneTypedArray(srcValue, true);
	      }
	      else {
	        newValue = [];
	      }
	    }
	    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	      newValue = objValue;
	      if (isArguments(objValue)) {
	        newValue = toPlainObject(objValue);
	      }
	      else if (!isObject(objValue) || isFunction(objValue)) {
	        newValue = initCloneObject(srcValue);
	      }
	    }
	    else {
	      isCommon = false;
	    }
	  }
	  if (isCommon) {
	    // Recursively merge objects and arrays (susceptible to call stack limits).
	    stack.set(srcValue, newValue);
	    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	    stack['delete'](srcValue);
	  }
	  assignMergeValue(object, key, newValue);
	}
	
	module.exports = baseMergeDeep;


/***/ },
/* 1680 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	module.exports = baseProperty;


/***/ },
/* 1681 */
/***/ function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(478);
	
	/**
	 * A specialized version of `baseProperty` which supports deep paths.
	 *
	 * @private
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function basePropertyDeep(path) {
	  return function(object) {
	    return baseGet(object, path);
	  };
	}
	
	module.exports = basePropertyDeep;


/***/ },
/* 1682 */
/***/ function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(300),
	    overRest = __webpack_require__(1728),
	    setToString = __webpack_require__(1732);
	
	/**
	 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 */
	function baseRest(func, start) {
	  return setToString(overRest(func, start, identity), func + '');
	}
	
	module.exports = baseRest;


/***/ },
/* 1683 */
/***/ function(module, exports, __webpack_require__) {

	var constant = __webpack_require__(1739),
	    defineProperty = __webpack_require__(482),
	    identity = __webpack_require__(300);
	
	/**
	 * The base implementation of `setToString` without support for hot loop shorting.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var baseSetToString = !defineProperty ? identity : function(func, string) {
	  return defineProperty(func, 'toString', {
	    'configurable': true,
	    'enumerable': false,
	    'value': constant(string),
	    'writable': true
	  });
	};
	
	module.exports = baseSetToString;


/***/ },
/* 1684 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	module.exports = baseTimes;


/***/ },
/* 1685 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(199),
	    arrayMap = __webpack_require__(475),
	    isArray = __webpack_require__(72),
	    isSymbol = __webpack_require__(209);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isArray(value)) {
	    // Recursively convert values (susceptible to call stack limits).
	    return arrayMap(value, baseToString) + '';
	  }
	  if (isSymbol(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = baseToString;


/***/ },
/* 1686 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	module.exports = baseUnary;


/***/ },
/* 1687 */
/***/ function(module, exports) {

	/**
	 * Checks if a `cache` value for `key` exists.
	 *
	 * @private
	 * @param {Object} cache The cache to query.
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function cacheHas(cache, key) {
	  return cache.has(key);
	}
	
	module.exports = cacheHas;


/***/ },
/* 1688 */
/***/ function(module, exports, __webpack_require__) {

	var Uint8Array = __webpack_require__(473);
	
	/**
	 * Creates a clone of `arrayBuffer`.
	 *
	 * @private
	 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	 * @returns {ArrayBuffer} Returns the cloned array buffer.
	 */
	function cloneArrayBuffer(arrayBuffer) {
	  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	  return result;
	}
	
	module.exports = cloneArrayBuffer;


/***/ },
/* 1689 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(77);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined,
	    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
	
	/**
	 * Creates a clone of  `buffer`.
	 *
	 * @private
	 * @param {Buffer} buffer The buffer to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Buffer} Returns the cloned buffer.
	 */
	function cloneBuffer(buffer, isDeep) {
	  if (isDeep) {
	    return buffer.slice();
	  }
	  var length = buffer.length,
	      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
	
	  buffer.copy(result);
	  return result;
	}
	
	module.exports = cloneBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(139)(module)))

/***/ },
/* 1690 */
/***/ function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(1688);
	
	/**
	 * Creates a clone of `typedArray`.
	 *
	 * @private
	 * @param {Object} typedArray The typed array to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned typed array.
	 */
	function cloneTypedArray(typedArray, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	}
	
	module.exports = cloneTypedArray;


/***/ },
/* 1691 */
/***/ function(module, exports, __webpack_require__) {

	var assignValue = __webpack_require__(1664),
	    baseAssignValue = __webpack_require__(201);
	
	/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property identifiers to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @param {Function} [customizer] The function to customize copied values.
	 * @returns {Object} Returns `object`.
	 */
	function copyObject(source, props, object, customizer) {
	  var isNew = !object;
	  object || (object = {});
	
	  var index = -1,
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index];
	
	    var newValue = customizer
	      ? customizer(object[key], source[key], key, object, source)
	      : undefined;
	
	    if (newValue === undefined) {
	      newValue = source[key];
	    }
	    if (isNew) {
	      baseAssignValue(object, key, newValue);
	    } else {
	      assignValue(object, key, newValue);
	    }
	  }
	  return object;
	}
	
	module.exports = copyObject;


/***/ },
/* 1692 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(77);
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	module.exports = coreJsData;


/***/ },
/* 1693 */
/***/ function(module, exports, __webpack_require__) {

	var baseRest = __webpack_require__(1682),
	    isIterateeCall = __webpack_require__(1709);
	
	/**
	 * Creates a function like `_.assign`.
	 *
	 * @private
	 * @param {Function} assigner The function to assign values.
	 * @returns {Function} Returns the new assigner function.
	 */
	function createAssigner(assigner) {
	  return baseRest(function(object, sources) {
	    var index = -1,
	        length = sources.length,
	        customizer = length > 1 ? sources[length - 1] : undefined,
	        guard = length > 2 ? sources[2] : undefined;
	
	    customizer = (assigner.length > 3 && typeof customizer == 'function')
	      ? (length--, customizer)
	      : undefined;
	
	    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	      customizer = length < 3 ? undefined : customizer;
	      length = 1;
	    }
	    object = Object(object);
	    while (++index < length) {
	      var source = sources[index];
	      if (source) {
	        assigner(object, source, index, customizer);
	      }
	    }
	    return object;
	  });
	}
	
	module.exports = createAssigner;


/***/ },
/* 1694 */
/***/ function(module, exports) {

	/**
	 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var index = -1,
	        iterable = Object(object),
	        props = keysFunc(object),
	        length = props.length;
	
	    while (length--) {
	      var key = props[fromRight ? length : ++index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	module.exports = createBaseFor;


/***/ },
/* 1695 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(199),
	    Uint8Array = __webpack_require__(473),
	    eq = __webpack_require__(156),
	    equalArrays = __webpack_require__(483),
	    mapToArray = __webpack_require__(1722),
	    setToArray = __webpack_require__(1731);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]';
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	  switch (tag) {
	    case dataViewTag:
	      if ((object.byteLength != other.byteLength) ||
	          (object.byteOffset != other.byteOffset)) {
	        return false;
	      }
	      object = object.buffer;
	      other = other.buffer;
	
	    case arrayBufferTag:
	      if ((object.byteLength != other.byteLength) ||
	          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	        return false;
	      }
	      return true;
	
	    case boolTag:
	    case dateTag:
	    case numberTag:
	      // Coerce booleans to `1` or `0` and dates to milliseconds.
	      // Invalid dates are coerced to `NaN`.
	      return eq(+object, +other);
	
	    case errorTag:
	      return object.name == other.name && object.message == other.message;
	
	    case regexpTag:
	    case stringTag:
	      // Coerce regexes to strings and treat strings, primitives and objects,
	      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	      // for more details.
	      return object == (other + '');
	
	    case mapTag:
	      var convert = mapToArray;
	
	    case setTag:
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	      convert || (convert = setToArray);
	
	      if (object.size != other.size && !isPartial) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked) {
	        return stacked == other;
	      }
	      bitmask |= COMPARE_UNORDERED_FLAG;
	
	      // Recursively compare objects (susceptible to call stack limits).
	      stack.set(object, other);
	      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	      stack['delete'](object);
	      return result;
	
	    case symbolTag:
	      if (symbolValueOf) {
	        return symbolValueOf.call(object) == symbolValueOf.call(other);
	      }
	  }
	  return false;
	}
	
	module.exports = equalByTag;


/***/ },
/* 1696 */
/***/ function(module, exports, __webpack_require__) {

	var getAllKeys = __webpack_require__(1697);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      objProps = getAllKeys(object),
	      objLength = objProps.length,
	      othProps = getAllKeys(other),
	      othLength = othProps.length;
	
	  if (objLength != othLength && !isPartial) {
	    return false;
	  }
	  var index = objLength;
	  while (index--) {
	    var key = objProps[index];
	    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	      return false;
	    }
	  }
	  // Check that cyclic values are equal.
	  var objStacked = stack.get(object);
	  var othStacked = stack.get(other);
	  if (objStacked && othStacked) {
	    return objStacked == other && othStacked == object;
	  }
	  var result = true;
	  stack.set(object, other);
	  stack.set(other, object);
	
	  var skipCtor = isPartial;
	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, objValue, key, other, object, stack)
	        : customizer(objValue, othValue, key, object, other, stack);
	    }
	    // Recursively compare objects (susceptible to call stack limits).
	    if (!(compared === undefined
	          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	          : compared
	        )) {
	      result = false;
	      break;
	    }
	    skipCtor || (skipCtor = key == 'constructor');
	  }
	  if (result && !skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;
	
	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor &&
	        ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      result = false;
	    }
	  }
	  stack['delete'](object);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalObjects;


/***/ },
/* 1697 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetAllKeys = __webpack_require__(1667),
	    getSymbols = __webpack_require__(1700),
	    keys = __webpack_require__(302);
	
	/**
	 * Creates an array of own enumerable property names and symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeys(object) {
	  return baseGetAllKeys(object, keys, getSymbols);
	}
	
	module.exports = getAllKeys;


/***/ },
/* 1698 */
/***/ function(module, exports, __webpack_require__) {

	var isStrictComparable = __webpack_require__(487),
	    keys = __webpack_require__(302);
	
	/**
	 * Gets the property names, values, and compare flags of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the match data of `object`.
	 */
	function getMatchData(object) {
	  var result = keys(object),
	      length = result.length;
	
	  while (length--) {
	    var key = result[length],
	        value = object[key];
	
	    result[length] = [key, value, isStrictComparable(value)];
	  }
	  return result;
	}
	
	module.exports = getMatchData;


/***/ },
/* 1699 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(199);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	module.exports = getRawTag;


/***/ },
/* 1700 */
/***/ function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(1661),
	    stubArray = __webpack_require__(1749);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	  if (object == null) {
	    return [];
	  }
	  object = Object(object);
	  return arrayFilter(nativeGetSymbols(object), function(symbol) {
	    return propertyIsEnumerable.call(object, symbol);
	  });
	};
	
	module.exports = getSymbols;


/***/ },
/* 1701 */
/***/ function(module, exports) {

	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	module.exports = getValue;


/***/ },
/* 1702 */
/***/ function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(480),
	    isArguments = __webpack_require__(206),
	    isArray = __webpack_require__(72),
	    isIndex = __webpack_require__(298),
	    isLength = __webpack_require__(301),
	    toKey = __webpack_require__(155);
	
	/**
	 * Checks if `path` exists on `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @param {Function} hasFunc The function to check properties.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 */
	function hasPath(object, path, hasFunc) {
	  path = castPath(path, object);
	
	  var index = -1,
	      length = path.length,
	      result = false;
	
	  while (++index < length) {
	    var key = toKey(path[index]);
	    if (!(result = object != null && hasFunc(object, key))) {
	      break;
	    }
	    object = object[key];
	  }
	  if (result || ++index != length) {
	    return result;
	  }
	  length = object == null ? 0 : object.length;
	  return !!length && isLength(length) && isIndex(key, length) &&
	    (isArray(object) || isArguments(object));
	}
	
	module.exports = hasPath;


/***/ },
/* 1703 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(205);
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	  this.size = 0;
	}
	
	module.exports = hashClear;


/***/ },
/* 1704 */
/***/ function(module, exports) {

	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  var result = this.has(key) && delete this.__data__[key];
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = hashDelete;


/***/ },
/* 1705 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(205);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	module.exports = hashGet;


/***/ },
/* 1706 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(205);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	}
	
	module.exports = hashHas;


/***/ },
/* 1707 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(205);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  this.size += this.has(key) ? 0 : 1;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	module.exports = hashSet;


/***/ },
/* 1708 */
/***/ function(module, exports, __webpack_require__) {

	var baseCreate = __webpack_require__(1665),
	    getPrototype = __webpack_require__(485),
	    isPrototype = __webpack_require__(204);
	
	/**
	 * Initializes an object clone.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneObject(object) {
	  return (typeof object.constructor == 'function' && !isPrototype(object))
	    ? baseCreate(getPrototype(object))
	    : {};
	}
	
	module.exports = initCloneObject;


/***/ },
/* 1709 */
/***/ function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(156),
	    isArrayLike = __webpack_require__(157),
	    isIndex = __webpack_require__(298),
	    isObject = __webpack_require__(97);
	
	/**
	 * Checks if the given arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	 *  else `false`.
	 */
	function isIterateeCall(value, index, object) {
	  if (!isObject(object)) {
	    return false;
	  }
	  var type = typeof index;
	  if (type == 'number'
	        ? (isArrayLike(object) && isIndex(index, object.length))
	        : (type == 'string' && index in object)
	      ) {
	    return eq(object[index], value);
	  }
	  return false;
	}
	
	module.exports = isIterateeCall;


/***/ },
/* 1710 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	module.exports = isKeyable;


/***/ },
/* 1711 */
/***/ function(module, exports, __webpack_require__) {

	var coreJsData = __webpack_require__(1692);
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	module.exports = isMasked;


/***/ },
/* 1712 */
/***/ function(module, exports) {

	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	  this.size = 0;
	}
	
	module.exports = listCacheClear;


/***/ },
/* 1713 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(200);
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype;
	
	/** Built-in value references. */
	var splice = arrayProto.splice;
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  --this.size;
	  return true;
	}
	
	module.exports = listCacheDelete;


/***/ },
/* 1714 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(200);
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	module.exports = listCacheGet;


/***/ },
/* 1715 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(200);
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	module.exports = listCacheHas;


/***/ },
/* 1716 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(200);
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    ++this.size;
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	module.exports = listCacheSet;


/***/ },
/* 1717 */
/***/ function(module, exports, __webpack_require__) {

	var Hash = __webpack_require__(1655),
	    ListCache = __webpack_require__(198),
	    Map = __webpack_require__(295);
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.size = 0;
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	module.exports = mapCacheClear;


/***/ },
/* 1718 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(203);
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  var result = getMapData(this, key)['delete'](key);
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = mapCacheDelete;


/***/ },
/* 1719 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(203);
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	module.exports = mapCacheGet;


/***/ },
/* 1720 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(203);
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	module.exports = mapCacheHas;


/***/ },
/* 1721 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(203);
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  var data = getMapData(this, key),
	      size = data.size;
	
	  data.set(key, value);
	  this.size += data.size == size ? 0 : 1;
	  return this;
	}
	
	module.exports = mapCacheSet;


/***/ },
/* 1722 */
/***/ function(module, exports) {

	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);
	
	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}
	
	module.exports = mapToArray;


/***/ },
/* 1723 */
/***/ function(module, exports, __webpack_require__) {

	var memoize = __webpack_require__(1746);
	
	/** Used as the maximum memoize cache size. */
	var MAX_MEMOIZE_SIZE = 500;
	
	/**
	 * A specialized version of `_.memoize` which clears the memoized function's
	 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	 *
	 * @private
	 * @param {Function} func The function to have its output memoized.
	 * @returns {Function} Returns the new memoized function.
	 */
	function memoizeCapped(func) {
	  var result = memoize(func, function(key) {
	    if (cache.size === MAX_MEMOIZE_SIZE) {
	      cache.clear();
	    }
	    return key;
	  });
	
	  var cache = result.cache;
	  return result;
	}
	
	module.exports = memoizeCapped;


/***/ },
/* 1724 */
/***/ function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(489);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = overArg(Object.keys, Object);
	
	module.exports = nativeKeys;


/***/ },
/* 1725 */
/***/ function(module, exports) {

	/**
	 * This function is like
	 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * except that it includes inherited enumerable properties.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function nativeKeysIn(object) {
	  var result = [];
	  if (object != null) {
	    for (var key in Object(object)) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = nativeKeysIn;


/***/ },
/* 1726 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(484);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    // Use `util.types` for Node.js 10+.
	    var types = freeModule && freeModule.require && freeModule.require('util').types;
	
	    if (types) {
	      return types;
	    }
	
	    // Legacy `process.binding('util')` for Node.js < 10.
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	module.exports = nodeUtil;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(139)(module)))

/***/ },
/* 1727 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	module.exports = objectToString;


/***/ },
/* 1728 */
/***/ function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(1660);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * A specialized version of `baseRest` which transforms the rest array.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @param {Function} transform The rest array transform.
	 * @returns {Function} Returns the new function.
	 */
	function overRest(func, start, transform) {
	  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        array = Array(length);
	
	    while (++index < length) {
	      array[index] = args[start + index];
	    }
	    index = -1;
	    var otherArgs = Array(start + 1);
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = transform(array);
	    return apply(func, this, otherArgs);
	  };
	}
	
	module.exports = overRest;


/***/ },
/* 1729 */
/***/ function(module, exports) {

	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Adds `value` to the array cache.
	 *
	 * @private
	 * @name add
	 * @memberOf SetCache
	 * @alias push
	 * @param {*} value The value to cache.
	 * @returns {Object} Returns the cache instance.
	 */
	function setCacheAdd(value) {
	  this.__data__.set(value, HASH_UNDEFINED);
	  return this;
	}
	
	module.exports = setCacheAdd;


/***/ },
/* 1730 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is in the array cache.
	 *
	 * @private
	 * @name has
	 * @memberOf SetCache
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `true` if `value` is found, else `false`.
	 */
	function setCacheHas(value) {
	  return this.__data__.has(value);
	}
	
	module.exports = setCacheHas;


/***/ },
/* 1731 */
/***/ function(module, exports) {

	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}
	
	module.exports = setToArray;


/***/ },
/* 1732 */
/***/ function(module, exports, __webpack_require__) {

	var baseSetToString = __webpack_require__(1683),
	    shortOut = __webpack_require__(1733);
	
	/**
	 * Sets the `toString` method of `func` to return `string`.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var setToString = shortOut(baseSetToString);
	
	module.exports = setToString;


/***/ },
/* 1733 */
/***/ function(module, exports) {

	/** Used to detect hot functions by number of calls within a span of milliseconds. */
	var HOT_COUNT = 800,
	    HOT_SPAN = 16;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeNow = Date.now;
	
	/**
	 * Creates a function that'll short out and invoke `identity` instead
	 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	 * milliseconds.
	 *
	 * @private
	 * @param {Function} func The function to restrict.
	 * @returns {Function} Returns the new shortable function.
	 */
	function shortOut(func) {
	  var count = 0,
	      lastCalled = 0;
	
	  return function() {
	    var stamp = nativeNow(),
	        remaining = HOT_SPAN - (stamp - lastCalled);
	
	    lastCalled = stamp;
	    if (remaining > 0) {
	      if (++count >= HOT_COUNT) {
	        return arguments[0];
	      }
	    } else {
	      count = 0;
	    }
	    return func.apply(undefined, arguments);
	  };
	}
	
	module.exports = shortOut;


/***/ },
/* 1734 */
/***/ function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(198);
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	  this.size = 0;
	}
	
	module.exports = stackClear;


/***/ },
/* 1735 */
/***/ function(module, exports) {

	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  var data = this.__data__,
	      result = data['delete'](key);
	
	  this.size = data.size;
	  return result;
	}
	
	module.exports = stackDelete;


/***/ },
/* 1736 */
/***/ function(module, exports) {

	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	module.exports = stackGet;


/***/ },
/* 1737 */
/***/ function(module, exports) {

	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	module.exports = stackHas;


/***/ },
/* 1738 */
/***/ function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(198),
	    Map = __webpack_require__(295),
	    MapCache = __webpack_require__(296);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var data = this.__data__;
	  if (data instanceof ListCache) {
	    var pairs = data.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      this.size = ++data.size;
	      return this;
	    }
	    data = this.__data__ = new MapCache(pairs);
	  }
	  data.set(key, value);
	  this.size = data.size;
	  return this;
	}
	
	module.exports = stackSet;


/***/ },
/* 1739 */
/***/ function(module, exports) {

	/**
	 * Creates a function that returns `value`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {*} value The value to return from the new function.
	 * @returns {Function} Returns the new constant function.
	 * @example
	 *
	 * var objects = _.times(2, _.constant({ 'a': 1 }));
	 *
	 * console.log(objects);
	 * // => [{ 'a': 1 }, { 'a': 1 }]
	 *
	 * console.log(objects[0] === objects[1]);
	 * // => true
	 */
	function constant(value) {
	  return function() {
	    return value;
	  };
	}
	
	module.exports = constant;


/***/ },
/* 1740 */
/***/ function(module, exports, __webpack_require__) {

	var baseHasIn = __webpack_require__(1668),
	    hasPath = __webpack_require__(1702);
	
	/**
	 * Checks if `path` is a direct or inherited property of `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 * @example
	 *
	 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	 *
	 * _.hasIn(object, 'a');
	 * // => true
	 *
	 * _.hasIn(object, 'a.b');
	 * // => true
	 *
	 * _.hasIn(object, ['a', 'b']);
	 * // => true
	 *
	 * _.hasIn(object, 'b');
	 * // => false
	 */
	function hasIn(object, path) {
	  return object != null && hasPath(object, path, baseHasIn);
	}
	
	module.exports = hasIn;


/***/ },
/* 1741 */
/***/ function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(157),
	    isObjectLike = __webpack_require__(111);
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	module.exports = isArrayLikeObject;


/***/ },
/* 1742 */
/***/ function(module, exports, __webpack_require__) {

	var baseKeys = __webpack_require__(479),
	    getTag = __webpack_require__(486),
	    isArguments = __webpack_require__(206),
	    isArray = __webpack_require__(72),
	    isArrayLike = __webpack_require__(157),
	    isBuffer = __webpack_require__(207),
	    isPrototype = __webpack_require__(204),
	    isTypedArray = __webpack_require__(210);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    setTag = '[object Set]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Checks if `value` is an empty object, collection, map, or set.
	 *
	 * Objects are considered empty if they have no own enumerable string keyed
	 * properties.
	 *
	 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
	 * jQuery-like collections are considered empty if they have a `length` of `0`.
	 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	 * @example
	 *
	 * _.isEmpty(null);
	 * // => true
	 *
	 * _.isEmpty(true);
	 * // => true
	 *
	 * _.isEmpty(1);
	 * // => true
	 *
	 * _.isEmpty([1, 2, 3]);
	 * // => false
	 *
	 * _.isEmpty({ 'a': 1 });
	 * // => false
	 */
	function isEmpty(value) {
	  if (value == null) {
	    return true;
	  }
	  if (isArrayLike(value) &&
	      (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
	        isBuffer(value) || isTypedArray(value) || isArguments(value))) {
	    return !value.length;
	  }
	  var tag = getTag(value);
	  if (tag == mapTag || tag == setTag) {
	    return !value.size;
	  }
	  if (isPrototype(value)) {
	    return !baseKeys(value).length;
	  }
	  for (var key in value) {
	    if (hasOwnProperty.call(value, key)) {
	      return false;
	    }
	  }
	  return true;
	}
	
	module.exports = isEmpty;


/***/ },
/* 1743 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(202);
	
	/**
	 * Performs a deep comparison between two values to determine if they are
	 * equivalent.
	 *
	 * **Note:** This method supports comparing arrays, array buffers, booleans,
	 * date objects, error objects, maps, numbers, `Object` objects, regexes,
	 * sets, strings, symbols, and typed arrays. `Object` objects are compared
	 * by their own, not inherited, enumerable properties. Functions and DOM
	 * nodes are compared by strict equality, i.e. `===`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.isEqual(object, other);
	 * // => true
	 *
	 * object === other;
	 * // => false
	 */
	function isEqual(value, other) {
	  return baseIsEqual(value, other);
	}
	
	module.exports = isEqual;


/***/ },
/* 1744 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is `null` or `undefined`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
	 * @example
	 *
	 * _.isNil(null);
	 * // => true
	 *
	 * _.isNil(void 0);
	 * // => true
	 *
	 * _.isNil(NaN);
	 * // => false
	 */
	function isNil(value) {
	  return value == null;
	}
	
	module.exports = isNil;


/***/ },
/* 1745 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(131),
	    getPrototype = __webpack_require__(485),
	    isObjectLike = __webpack_require__(111);
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	    funcToString.call(Ctor) == objectCtorString;
	}
	
	module.exports = isPlainObject;


/***/ },
/* 1746 */
/***/ function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(296);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a function that memoizes the result of `func`. If `resolver` is
	 * provided, it determines the cache key for storing the result based on the
	 * arguments provided to the memoized function. By default, the first argument
	 * provided to the memoized function is used as the map cache key. The `func`
	 * is invoked with the `this` binding of the memoized function.
	 *
	 * **Note:** The cache is exposed as the `cache` property on the memoized
	 * function. Its creation may be customized by replacing the `_.memoize.Cache`
	 * constructor with one whose instances implement the
	 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to have its output memoized.
	 * @param {Function} [resolver] The function to resolve the cache key.
	 * @returns {Function} Returns the new memoized function.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2 };
	 * var other = { 'c': 3, 'd': 4 };
	 *
	 * var values = _.memoize(_.values);
	 * values(object);
	 * // => [1, 2]
	 *
	 * values(other);
	 * // => [3, 4]
	 *
	 * object.a = 2;
	 * values(object);
	 * // => [1, 2]
	 *
	 * // Modify the result cache.
	 * values.cache.set(object, ['a', 'b']);
	 * values(object);
	 * // => ['a', 'b']
	 *
	 * // Replace `_.memoize.Cache`.
	 * _.memoize.Cache = WeakMap;
	 */
	function memoize(func, resolver) {
	  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var memoized = function() {
	    var args = arguments,
	        key = resolver ? resolver.apply(this, args) : args[0],
	        cache = memoized.cache;
	
	    if (cache.has(key)) {
	      return cache.get(key);
	    }
	    var result = func.apply(this, args);
	    memoized.cache = cache.set(key, result) || cache;
	    return result;
	  };
	  memoized.cache = new (memoize.Cache || MapCache);
	  return memoized;
	}
	
	// Expose `MapCache`.
	memoize.Cache = MapCache;
	
	module.exports = memoize;


/***/ },
/* 1747 */
/***/ function(module, exports, __webpack_require__) {

	var baseMerge = __webpack_require__(1678),
	    createAssigner = __webpack_require__(1693);
	
	/**
	 * This method is like `_.assign` except that it recursively merges own and
	 * inherited enumerable string keyed properties of source objects into the
	 * destination object. Source properties that resolve to `undefined` are
	 * skipped if a destination value exists. Array and plain object properties
	 * are merged recursively. Other objects and value types are overridden by
	 * assignment. Source objects are applied from left to right. Subsequent
	 * sources overwrite property assignments of previous sources.
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.5.0
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @returns {Object} Returns `object`.
	 * @example
	 *
	 * var object = {
	 *   'a': [{ 'b': 2 }, { 'd': 4 }]
	 * };
	 *
	 * var other = {
	 *   'a': [{ 'c': 3 }, { 'e': 5 }]
	 * };
	 *
	 * _.merge(object, other);
	 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
	 */
	var merge = createAssigner(function(object, source, srcIndex) {
	  baseMerge(object, source, srcIndex);
	});
	
	module.exports = merge;


/***/ },
/* 1748 */
/***/ function(module, exports, __webpack_require__) {

	var baseProperty = __webpack_require__(1680),
	    basePropertyDeep = __webpack_require__(1681),
	    isKey = __webpack_require__(299),
	    toKey = __webpack_require__(155);
	
	/**
	 * Creates a function that returns the value at `path` of a given object.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 * @example
	 *
	 * var objects = [
	 *   { 'a': { 'b': 2 } },
	 *   { 'a': { 'b': 1 } }
	 * ];
	 *
	 * _.map(objects, _.property('a.b'));
	 * // => [2, 1]
	 *
	 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	 * // => [1, 2]
	 */
	function property(path) {
	  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	}
	
	module.exports = property;


/***/ },
/* 1749 */
/***/ function(module, exports) {

	/**
	 * This method returns a new empty array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {Array} Returns the new empty array.
	 * @example
	 *
	 * var arrays = _.times(2, _.stubArray);
	 *
	 * console.log(arrays);
	 * // => [[], []]
	 *
	 * console.log(arrays[0] === arrays[1]);
	 * // => false
	 */
	function stubArray() {
	  return [];
	}
	
	module.exports = stubArray;


/***/ },
/* 1750 */
/***/ function(module, exports) {

	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = stubFalse;


/***/ },
/* 1751 */
/***/ function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(1691),
	    keysIn = __webpack_require__(495);
	
	/**
	 * Converts `value` to a plain object flattening inherited enumerable string
	 * keyed properties of `value` to own properties of the plain object.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {Object} Returns the converted plain object.
	 * @example
	 *
	 * function Foo() {
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.assign({ 'a': 1 }, new Foo);
	 * // => { 'a': 1, 'b': 2 }
	 *
	 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	 * // => { 'a': 1, 'b': 2, 'c': 3 }
	 */
	function toPlainObject(value) {
	  return copyObject(value, keysIn(value));
	}
	
	module.exports = toPlainObject;


/***/ },
/* 1752 */
/***/ function(module, exports) {

	'use strict';
	
	var safeIsNaN = Number.isNaN ||
	    function ponyfill(value) {
	        return typeof value === 'number' && value !== value;
	    };
	function isEqual(first, second) {
	    if (first === second) {
	        return true;
	    }
	    if (safeIsNaN(first) && safeIsNaN(second)) {
	        return true;
	    }
	    return false;
	}
	function areInputsEqual(newInputs, lastInputs) {
	    if (newInputs.length !== lastInputs.length) {
	        return false;
	    }
	    for (var i = 0; i < newInputs.length; i++) {
	        if (!isEqual(newInputs[i], lastInputs[i])) {
	            return false;
	        }
	    }
	    return true;
	}
	
	function memoizeOne(resultFn, isEqual) {
	    if (isEqual === void 0) { isEqual = areInputsEqual; }
	    var lastThis;
	    var lastArgs = [];
	    var lastResult;
	    var calledOnce = false;
	    function memoized() {
	        var newArgs = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            newArgs[_i] = arguments[_i];
	        }
	        if (calledOnce && lastThis === this && isEqual(newArgs, lastArgs)) {
	            return lastResult;
	        }
	        lastResult = resultFn.apply(this, newArgs);
	        calledOnce = true;
	        lastThis = this;
	        lastArgs = newArgs;
	        return lastResult;
	    }
	    return memoized;
	}
	
	module.exports = memoizeOne;


/***/ },
/* 1753 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var isWhat = __webpack_require__(1652);
	
	/*! *****************************************************************************
	Copyright (c) Microsoft Corporation. All rights reserved.
	Licensed under the Apache License, Version 2.0 (the "License"); you may not use
	this file except in compliance with the License. You may obtain a copy of the
	License at http://www.apache.org/licenses/LICENSE-2.0
	
	THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
	WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
	MERCHANTABLITY OR NON-INFRINGEMENT.
	
	See the Apache Version 2.0 License for specific language governing permissions
	and limitations under the License.
	***************************************************************************** */
	
	function __spreadArrays() {
	    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
	    for (var r = Array(s), k = 0, i = 0; i < il; i++)
	        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
	            r[k] = a[j];
	    return r;
	}
	
	function assignProp(carry, key, newVal, originalObject) {
	    var propType = originalObject.propertyIsEnumerable(key)
	        ? 'enumerable'
	        : 'nonenumerable';
	    if (propType === 'enumerable')
	        carry[key] = newVal;
	    if (propType === 'nonenumerable') {
	        Object.defineProperty(carry, key, {
	            value: newVal,
	            enumerable: false,
	            writable: true,
	            configurable: true
	        });
	    }
	}
	function mergeRecursively(origin, newComer, extensions) {
	    // work directly on newComer if its not an object
	    if (!isWhat.isPlainObject(newComer)) {
	        // extend merge rules
	        if (extensions && isWhat.isArray(extensions)) {
	            extensions.forEach(function (extend) {
	                newComer = extend(origin, newComer);
	            });
	        }
	        return newComer;
	    }
	    // define newObject to merge all values upon
	    var newObject = {};
	    if (isWhat.isPlainObject(origin)) {
	        var props_1 = Object.getOwnPropertyNames(origin);
	        var symbols_1 = Object.getOwnPropertySymbols(origin);
	        newObject = __spreadArrays(props_1, symbols_1).reduce(function (carry, key) {
	            // @ts-ignore
	            var targetVal = origin[key];
	            if ((!isWhat.isSymbol(key) && !Object.getOwnPropertyNames(newComer).includes(key)) ||
	                (isWhat.isSymbol(key) && !Object.getOwnPropertySymbols(newComer).includes(key))) {
	                assignProp(carry, key, targetVal, origin);
	            }
	            return carry;
	        }, {});
	    }
	    var props = Object.getOwnPropertyNames(newComer);
	    var symbols = Object.getOwnPropertySymbols(newComer);
	    var result = __spreadArrays(props, symbols).reduce(function (carry, key) {
	        // re-define the origin and newComer as targetVal and newVal
	        var newVal = newComer[key];
	        var targetVal = (isWhat.isPlainObject(origin))
	            // @ts-ignore
	            ? origin[key]
	            : undefined;
	        // extend merge rules
	        if (extensions && isWhat.isArray(extensions)) {
	            extensions.forEach(function (extend) {
	                newVal = extend(targetVal, newVal);
	            });
	        }
	        // When newVal is an object do the merge recursively
	        if (targetVal !== undefined && isWhat.isPlainObject(newVal)) {
	            newVal = mergeRecursively(targetVal, newVal, extensions);
	        }
	        assignProp(carry, key, newVal, newComer);
	        return carry;
	    }, newObject);
	    return result;
	}
	/**
	 * Merge anything recursively.
	 * Objects get merged, special objects (classes etc.) are re-assigned "as is".
	 * Basic types overwrite objects or other basic types.
	 *
	 * @param {(IConfig | any)} origin
	 * @param {...any[]} newComers
	 * @returns the result
	 */
	function merge(origin) {
	    var newComers = [];
	    for (var _i = 1; _i < arguments.length; _i++) {
	        newComers[_i - 1] = arguments[_i];
	    }
	    var extensions = null;
	    var base = origin;
	    if (isWhat.isPlainObject(origin) && origin.extensions && Object.keys(origin).length === 1) {
	        base = {};
	        extensions = origin.extensions;
	    }
	    return newComers.reduce(function (result, newComer) {
	        return mergeRecursively(result, newComer, extensions);
	    }, base);
	}
	
	function concatArrays(originVal, newVal) {
	    if (isWhat.isArray(originVal) && isWhat.isArray(newVal)) {
	        // concat logic
	        return originVal.concat(newVal);
	    }
	    return newVal; // always return newVal as fallback!!
	}
	
	exports.concatArrays = concatArrays;
	exports.default = merge;
	exports.merge = merge;


/***/ },
/* 1754 */
/***/ function(module, exports) {

	'use strict';
	/* eslint-disable no-unused-vars */
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (e) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (Object.getOwnPropertySymbols) {
				symbols = Object.getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ },
/* 1755 */
/***/ function(module, exports, __webpack_require__) {

	/*!
	 * object.pick <https://github.com/jonschlinkert/object.pick>
	 *
	 * Copyright (c) 2014-2015 Jon Schlinkert, contributors.
	 * Licensed under the MIT License
	 */
	
	'use strict';
	
	var isObject = __webpack_require__(1756);
	
	module.exports = function pick(obj, keys) {
	  if (!isObject(obj) && typeof obj !== 'function') {
	    return {};
	  }
	
	  var res = {};
	  if (typeof keys === 'string') {
	    if (keys in obj) {
	      res[keys] = obj[keys];
	    }
	    return res;
	  }
	
	  var len = keys.length;
	  var idx = -1;
	
	  while (++idx < len) {
	    var key = keys[idx];
	    if (key in obj) {
	      res[key] = obj[key];
	    }
	  }
	  return res;
	};


/***/ },
/* 1756 */
/***/ function(module, exports) {

	/*!
	 * isobject <https://github.com/jonschlinkert/isobject>
	 *
	 * Copyright (c) 2014-2017, Jon Schlinkert.
	 * Released under the MIT License.
	 */
	
	'use strict';
	
	module.exports = function isObject(val) {
	  return val != null && typeof val === 'object' && Array.isArray(val) === false;
	};


/***/ },
/* 1757 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	//This file contains the ES6 extensions to the core Promises/A+ API
	
	var Promise = __webpack_require__(498);
	
	module.exports = Promise;
	
	/* Static Functions */
	
	var TRUE = valuePromise(true);
	var FALSE = valuePromise(false);
	var NULL = valuePromise(null);
	var UNDEFINED = valuePromise(undefined);
	var ZERO = valuePromise(0);
	var EMPTYSTRING = valuePromise('');
	
	function valuePromise(value) {
	  var p = new Promise(Promise._61);
	  p._81 = 1;
	  p._65 = value;
	  return p;
	}
	Promise.resolve = function (value) {
	  if (value instanceof Promise) return value;
	
	  if (value === null) return NULL;
	  if (value === undefined) return UNDEFINED;
	  if (value === true) return TRUE;
	  if (value === false) return FALSE;
	  if (value === 0) return ZERO;
	  if (value === '') return EMPTYSTRING;
	
	  if (typeof value === 'object' || typeof value === 'function') {
	    try {
	      var then = value.then;
	      if (typeof then === 'function') {
	        return new Promise(then.bind(value));
	      }
	    } catch (ex) {
	      return new Promise(function (resolve, reject) {
	        reject(ex);
	      });
	    }
	  }
	  return valuePromise(value);
	};
	
	Promise.all = function (arr) {
	  var args = Array.prototype.slice.call(arr);
	
	  return new Promise(function (resolve, reject) {
	    if (args.length === 0) return resolve([]);
	    var remaining = args.length;
	    function res(i, val) {
	      if (val && (typeof val === 'object' || typeof val === 'function')) {
	        if (val instanceof Promise && val.then === Promise.prototype.then) {
	          while (val._81 === 3) {
	            val = val._65;
	          }
	          if (val._81 === 1) return res(i, val._65);
	          if (val._81 === 2) reject(val._65);
	          val.then(function (val) {
	            res(i, val);
	          }, reject);
	          return;
	        } else {
	          var then = val.then;
	          if (typeof then === 'function') {
	            var p = new Promise(then.bind(val));
	            p.then(function (val) {
	              res(i, val);
	            }, reject);
	            return;
	          }
	        }
	      }
	      args[i] = val;
	      if (--remaining === 0) {
	        resolve(args);
	      }
	    }
	    for (var i = 0; i < args.length; i++) {
	      res(i, args[i]);
	    }
	  });
	};
	
	Promise.reject = function (value) {
	  return new Promise(function (resolve, reject) {
	    reject(value);
	  });
	};
	
	Promise.race = function (values) {
	  return new Promise(function (resolve, reject) {
	    values.forEach(function(value){
	      Promise.resolve(value).then(resolve, reject);
	    });
	  });
	};
	
	/* Prototype Methods */
	
	Promise.prototype['catch'] = function (onRejected) {
	  return this.then(null, onRejected);
	};


/***/ },
/* 1758 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Promise = __webpack_require__(498);
	
	var DEFAULT_WHITELIST = [
	  ReferenceError,
	  TypeError,
	  RangeError
	];
	
	var enabled = false;
	exports.disable = disable;
	function disable() {
	  enabled = false;
	  Promise._10 = null;
	  Promise._97 = null;
	}
	
	exports.enable = enable;
	function enable(options) {
	  options = options || {};
	  if (enabled) disable();
	  enabled = true;
	  var id = 0;
	  var displayId = 0;
	  var rejections = {};
	  Promise._10 = function (promise) {
	    if (
	      promise._81 === 2 && // IS REJECTED
	      rejections[promise._72]
	    ) {
	      if (rejections[promise._72].logged) {
	        onHandled(promise._72);
	      } else {
	        clearTimeout(rejections[promise._72].timeout);
	      }
	      delete rejections[promise._72];
	    }
	  };
	  Promise._97 = function (promise, err) {
	    if (promise._45 === 0) { // not yet handled
	      promise._72 = id++;
	      rejections[promise._72] = {
	        displayId: null,
	        error: err,
	        timeout: setTimeout(
	          onUnhandled.bind(null, promise._72),
	          // For reference errors and type errors, this almost always
	          // means the programmer made a mistake, so log them after just
	          // 100ms
	          // otherwise, wait 2 seconds to see if they get handled
	          matchWhitelist(err, DEFAULT_WHITELIST)
	            ? 100
	            : 2000
	        ),
	        logged: false
	      };
	    }
	  };
	  function onUnhandled(id) {
	    if (
	      options.allRejections ||
	      matchWhitelist(
	        rejections[id].error,
	        options.whitelist || DEFAULT_WHITELIST
	      )
	    ) {
	      rejections[id].displayId = displayId++;
	      if (options.onUnhandled) {
	        rejections[id].logged = true;
	        options.onUnhandled(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      } else {
	        rejections[id].logged = true;
	        logError(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      }
	    }
	  }
	  function onHandled(id) {
	    if (rejections[id].logged) {
	      if (options.onHandled) {
	        options.onHandled(rejections[id].displayId, rejections[id].error);
	      } else if (!rejections[id].onUnhandled) {
	        console.warn(
	          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
	        );
	        console.warn(
	          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
	          rejections[id].displayId + '.'
	        );
	      }
	    }
	  }
	}
	
	function logError(id, error) {
	  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
	  var errStr = (error && (error.stack || error)) + '';
	  errStr.split('\n').forEach(function (line) {
	    console.warn('  ' + line);
	  });
	}
	
	function matchWhitelist(error, list) {
	  return list.some(function (cls) {
	    return error instanceof cls;
	  });
	}

/***/ },
/* 1759 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = deprecated;
	
	var _warning = __webpack_require__(1760);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var warned = {};
	
	function deprecated(validator, reason) {
	  return function validate(props, propName, componentName, location, propFullName) {
	    var componentNameSafe = componentName || '<<anonymous>>';
	    var propFullNameSafe = propFullName || propName;
	
	    if (props[propName] != null) {
	      var messageKey = componentName + '.' + propName;
	
	      (0, _warning2.default)(warned[messageKey], 'The ' + location + ' `' + propFullNameSafe + '` of ' + ('`' + componentNameSafe + '` is deprecated. ' + reason + '.'));
	
	      warned[messageKey] = true;
	    }
	
	    for (var _len = arguments.length, args = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
	      args[_key - 5] = arguments[_key];
	    }
	
	    return validator.apply(undefined, [props, propName, componentName, location, propFullName].concat(args));
	  };
	}
	
	/* eslint-disable no-underscore-dangle */
	function _resetWarned() {
	  warned = {};
	}
	
	deprecated._resetWarned = _resetWarned;
	/* eslint-enable no-underscore-dangle */
	
	module.exports = exports['default'];

/***/ },
/* 1760 */
134,
/* 1761 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = __webpack_require__(1762);
	
	function emptyFunction() {}
	function emptyFunctionWithReset() {}
	emptyFunctionWithReset.resetWarningCache = emptyFunction;
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    var err = new Error(
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	    err.name = 'Invariant Violation';
	    throw err;
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    elementType: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim,
	
	    checkPropTypes: emptyFunctionWithReset,
	    resetWarningCache: emptyFunction
	  };
	
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },
/* 1762 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ },
/* 1763 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var stringify = __webpack_require__(470);
	
	module.exports = appendQuery;
	
	function appendQuery( url, data ){
		if (data === undefined || data === null || data === false)
			return url;
	
		var query = typeof data === 'string'
			? data
			: stringify(data);
	
		if (!query)
			return url;
	
		var delimiter = url.indexOf('?') === -1
			? '?'
			: '&';
	
		return url+delimiter+query;
	}


/***/ },
/* 1764 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Promise = __webpack_require__(1768);
	
	fetch.isPony = true;
	
	module.exports = fetch;
	
	function fetch( url, opts ){
		var r = new XMLHttpRequest();
	
		r.open(opts.method, url);
	
		Object.keys(opts.headers).forEach(function( key ){
			r.setRequestHeader(key, opts.headers[key]);
		});
	
		var promise = new Promise();
	
		r.addEventListener('readystatechange', function(){
			if (r.readyState !== 4)
				return;
	
			var code;
			var message;
			var body;
	
			try { code = r.status } catch(e) { code = 0; }
			try { message = r.statusText } catch(e) {}
			try { body = r.responseText; } catch(e) {}
	
			if (code === 0)
				return promise.settle(new TypeError('Connection trouble'), true);
	
			promise.settle({
				status: code,
				statusText: message,
				ok: code >= 200 && code < 300,
				text: function(){
					return new Promise().settle(body);
				},
				json: function(){
					return new Promise().settle(JSON.parse(body));
				},
				headers: {
					get: function( key ){
						try {
							return r.getResponseHeader(key);
						} catch(e) {}
					},
				},
			});
		});
	
		r.send(opts.body);
	
		return promise;
	}


/***/ },
/* 1765 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var find = __webpack_require__(631);
	var btoa = __webpack_require__(821);
	var jsonParse = __webpack_require__(1771);
	var promiseToPull = __webpack_require__(1770);
	var toQs = __webpack_require__(470);
	
	var appendQuery = __webpack_require__(1763);
	var responses = __webpack_require__(1769);
	var isContentType = __webpack_require__(1767);
	var isAccept = __webpack_require__(1766);
	var ponyFetch = __webpack_require__(1764);
	
	var fetch = typeof window !== 'undefined' && window.fetch || ponyFetch;
	var FormData = typeof window !== 'undefined' && window.FormData;
	var File = typeof window !== 'undefined' && window.File;
	var TextDecoder = typeof window !== 'undefined' && window.TextDecoder;
	
	var responseMap = {
		1: responses.Error,
		2: responses.Success,
		3: responses.Error,
		4: responses.ClientError,
		5: responses.ServerError,
	};
	
	var methodsWithoutBody = [ 'GET', 'DELETE' ];
	
	request.response = responses;
	request.toQs = toQs;
	request.btoa = btoa;
	
	module.exports = request;
	
	function request( opts ){
		var pump = null;
		var retries = 0;
	
		return source;
	
		function source( abort, cb ){
			if (abort)
				return cb && cb(abort);
	
			if (pump)
				return pump(null, cb);
	
			send(opts)
				.then(function( response ){
					var code = response.status;
	
					var contentType = response.headers.get('content-type');
	
					var json = contentType && contentType.indexOf('json') !== -1;
	
					if (!response.ok)
						return (json ? response.json() : response.text())
							.then(function( body ){
								var statusIdentifier = code && (code / 100 | 0);
								var responseType = responseMap[statusIdentifier] || responses.Error;
	
								return cb(new responseType(code, response.statusText || 'Connection trouble', null, body));
							});
	
					if (code === 204 || code === 205)
						return cb(true);
	
					pump = json
						? pumpJson(response)
						: pumpBinary(response);
	
					return pump(null, cb);
				})
				.catch(function( err ){
					if (!opts.retries)
						return cb(err);
	
					var retry = opts.retries[retries];
	
					if (retry === undefined)
						return cb(err);
	
					retries++;
	
					if (!retry.delay)
						return source(null, cb);
	
					setTimeout(function(){
						source(null, cb);
					}, retry.delay);
				})
				.catch(cb);
		}
	}
	
	function send( opts ){
		var url = typeof opts === 'string'
			? opts
			: appendQuery(opts.url || opts.host+(opts.path || ''), opts.query);
	
		var method = opts.method || (opts.data ? 'POST' : 'GET');
		var headers = opts.headers || {};
		var data = opts.data;
	
		var isMethodWithBody = methodsWithoutBody.indexOf(method) === -1;
	
		var headerKeys = Object.keys(headers);
	
		var contentTypeHeader = find(headerKeys, isContentType);
		var acceptHeader = find(headerKeys, isAccept);
	
		if (
			isMethodWithBody
			&& contentTypeHeader === undefined
			&& !(File && data instanceof File)
			&& !(FormData && data instanceof FormData)
		)
			headers['Content-Type'] = 'application/json';
	
		if (acceptHeader === undefined)
			headers.Accept = 'application/json';
	
		var contentType = headers[contentTypeHeader || 'Content-Type'];
	
		var body;
	
		if (data) {
			if (!isMethodWithBody)
				throw new Error('You should not send data for DELETE or GET requests');
	
			if (contentType === 'application/json') {
				body = JSON.stringify(data);
			} else {
				body = data;
			}
		}
	
		return fetch(url, {
			method: method,
			headers: fetch.isPony
				? headers
				: Object.keys(headers).reduce(function( c, key ){
					c.append(key, headers[key]);
	
					return c;
				}, new Headers()),
			body: body,
		});
	}
	
	function pumpJson( response ){
		if (response.source)
			return jsonParse(response.source);
	
		var reader = TextDecoder && response.body && response.body.getReader();
	
		if (!reader)
			return jsonParse(promiseToPull(response.text()));
	
		var decoder = new TextDecoder();
		var done = false;
	
		return jsonParse(function( abort, cb ){
			if (abort) {
				reader.cancel();
	
				return cb(abort);
			}
	
			if (done)
				return cb(true)
	
			return reader.read().then(function( chunk ){
				done = chunk.done;
	
				return cb(null, decoder.decode(chunk.value || new Uint8Array, {
					stream: chunk.done,
				}));
			}).catch(cb);
		});
	}
	
	function pumpBinary( response ){
		if (response.source)
			return response.source;
	
		var reader = response.body && response.body.getReader();
	
		if (!reader)
			return promiseToPull(response.text());
	
		return function pump( abort, cb ){
			if (abort) {
				reader.cancel();
	
				return cb(abort);
			}
	
			return reader.read().then(function( chunk ){
				if (chunk.done)
					return cb(true);
	
				return cb(null, chunk.value);
			}).catch(cb);
		}
	}


/***/ },
/* 1766 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = isAccept;
	
	function isAccept( header ){
		return header.toLowerCase() === 'accept';
	}


/***/ },
/* 1767 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = isContentType;
	
	function isContentType( header ){
		return header.toLowerCase() === 'content-type';
	}


/***/ },
/* 1768 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = Promise;
	
	function Promise( value ){
		this.then = then;
		this.catch = fail;
		this.settle = settle;
	}
	
	function settle( value, reject ){
		this.value = value;
		this.settled = true;
		this.rejected = reject;
	
		if (reject && this.onFail)
			this.onFail(this.value);
	
		if (!reject && this.onSuccess)
			this.onSuccess(this.value);
	
		return this;
	}
	
	function then( success ){
		this.onSuccess = success;
	
		if (this.settled && !this.rejected)
			this.onSuccess(this.value);
	
		return this;
	}
	
	function fail( fail ){
		this.onFail = fail;
	
		if (this.settled && this.rejected)
			this.onFail(this.value);
	
		return this;
	}


/***/ },
/* 1769 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = {
		Success: Success,
		Error: ErrorResponse,
		Redirect: Redirect,
		ClientError: ClientError,
		ServerError: ServerError,
	};
	
	function Response( code, message, headers, body ){
		this.code = code;
		this.message = message;
		this.headers = headers;
		this.body = body;
	}
	
	Response.prototype.toString = responseToString;
	
	function ErrorResponse(){
		Response.apply(this, arguments);
	}
	
	ErrorResponse.prototype = Object.create(Error.prototype);
	ErrorResponse.prototype.toString = responseToString;
	
	// 200 - success (resolved)
	function Success(){
		Response.apply(this, arguments);
	}
	
	Success.prototype = Object.create(Response.prototype);
	
	// 300 - redirection (resolved)
	function Redirect(){
		Response.apply(this, arguments);
	}
	
	Redirect.prototype = Object.create(Response.prototype);
	
	// 400 - client error (rejected)
	function ClientError(){
		Response.apply(this, arguments);
	}
	
	ClientError.prototype = Object.create(ErrorResponse.prototype);
	
	// 500 - server error (rejected)
	function ServerError(){
		Response.apply(this, arguments);
	}
	
	ServerError.prototype = Object.create(ErrorResponse.prototype);
	
	function responseToString(){
		return this.code+': '+this.message;
	}


/***/ },
/* 1770 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = promiseToPull;
	
	function promiseToPull( promise, spread ){
		var done = false;
		var queue = false;
		var pos = 0;
	
		return function again( abort, cb ){
			if (abort)
				return cb(abort);
	
			if (queue) {
				if (queue.length > pos)
					return cb(null, queue[pos++]);
	
				return cb(true);
			}
	
			if (done)
				return cb(true);
	
			return promise
				.then(function( value ){
					done = true;
	
					if (!spread)
						return cb(null, value);
	
					if (!Array.isArray(value))
						throw new Error('promise-to-pull expected an array but got '+value);
	
					queue = value;
	
					return again(null, cb);
				})
				.catch(cb);
		}	
	}


/***/ },
/* 1771 */
/***/ function(module, exports) {

	'use strict';
	
	var COMMA = 0x2c;
	var BRACKET_START = 0x5b;
	var BRACKET_END = 0x5d;
	var NEWLINE = 0xa;
	
	module.exports = parse;
	
	function parse( read ){
		var done = false;
		var queue = [];
		var pos = 0;
		var ni = 0;
		var head = '';
		var tail = '';
		var line = '';
		var cc = 0;
		var ll = 0;
	
		return function again( abort, cb ){
			if (abort)
				return read(abort, cb);
	
			if (queue.length > 0)
				return cb(null, queue.shift());
	
			if (done)
				return cb(true);
	
			return read(null, function( end, data ){
				if (end !== null) {
					if (end !== true)
						return cb(end);	// error
	
					if (head === '')
						return cb(true);
	
					done = true;
					data = '\n';
				}
	
				pos = 0;
	
				if (typeof data !== 'string')
					data = data.toString();
	
				while ((ni = data.indexOf('\n', pos)) !== -1) {
					tail = data.slice(pos, data.charCodeAt(ni - 1) === COMMA
						? ni - 1
						: ni);
	
					line = (pos === 0
						? (ni === 0 && head.charCodeAt(head.length - 1) === COMMA
							? head.slice(0, -1)
							: head)
						: '')+tail;
	
					pos = ni + 1;
	
					ll = line.length;
	
					if (ll === 0)
						continue;
	
					if (ll === 1) {
						cc = line.charCodeAt(0);
	
						if (cc === BRACKET_START
							|| cc === BRACKET_END
							|| cc === NEWLINE)
							continue;
					}
	
					queue.push(JSON.parse(line));
				}
	
				head = (pos === 0 ? head : '')+data.slice(pos);
	
				return again(null, cb);
			});
		}
	}


/***/ },
/* 1772 */
/***/ function(module, exports, __webpack_require__) {

	'use strict'
	
	var reduce = __webpack_require__(1774)
	
	module.exports = function collect (cb) {
	  return reduce(function (arr, item) {
	    arr.push(item)
	    return arr
	  }, [], cb)
	}


/***/ },
/* 1773 */
/***/ function(module, exports) {

	'use strict'
	
	module.exports = function drain (op, done) {
	  var read, abort
	
	  // Declared here so that it captures the drain's stack trace
	  var doneLackingErr
	  if (!done) {
	    doneLackingErr = new Error('no done callback supplied')
	  }
	
	  function sink (_read) {
	    read = _read
	    if(abort) return sink.abort()
	    //this function is much simpler to write if you
	    //just use recursion, but by using a while loop
	    //we do not blow the stack if the stream happens to be sync.
	    ;(function next() {
	        var loop = true, cbed = false
	        while(loop) {
	          cbed = false
	          read(null, function (end, data) {
	            cbed = true
	            if(end = end || abort) {
	              loop = false
	              if(done) done(end === true ? null : end)
	              else if(end && end !== true) {
	                console.warn(doneLackingErr)
	                throw end
	              }
	            }
	            else if(op && false === op(data) || abort) {
	              loop = false
	              read(abort || true, done || function () {})
	            }
	            else if(!loop){
	              next()
	            }
	          })
	          if(!cbed) {
	            loop = false
	            return
	          }
	        }
	      })()
	  }
	
	  sink.abort = function (err, cb) {
	    if('function' == typeof err)
	      cb = err, err = true
	    abort = err || true
	    if(read) return read(abort, cb || function () {})
	  }
	
	  return sink
	}


/***/ },
/* 1774 */
/***/ function(module, exports, __webpack_require__) {

	'use strict'
	
	var drain = __webpack_require__(1773)
	
	module.exports = function reduce (reducer, acc, cb ) {
	  if(!cb) cb = acc, acc = null
	  var sink = drain(function (data) {
	    acc = reducer(acc, data)
	  }, function (err) {
	    cb(err, acc)
	  })
	  if (arguments.length === 2)
	    return function (source) {
	      source(null, function (end, data) {
	        //if ended immediately, and no initial...
	        if(end) return cb(end === true ? null : end)
	        acc = data; sink(source)
	      })
	    }
	  else
	    return sink
	}


/***/ },
/* 1775 */
/***/ function(module, exports) {

	// Generated by CoffeeScript 1.10.0
	(function() {
	  var QJ, rreturn, rtrim;
	
	  QJ = function(selector) {
	    if (QJ.isDOMElement(selector)) {
	      return selector;
	    }
	    return document.querySelectorAll(selector);
	  };
	
	  QJ.isDOMElement = function(el) {
	    return el && (el.nodeName != null);
	  };
	
	  rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
	
	  QJ.trim = function(text) {
	    if (text === null) {
	      return "";
	    } else {
	      return (text + "").replace(rtrim, "");
	    }
	  };
	
	  rreturn = /\r/g;
	
	  QJ.val = function(el, val) {
	    var ret;
	    if (arguments.length > 1) {
	      return el.value = val;
	    } else {
	      ret = el.value;
	      if (typeof ret === "string") {
	        return ret.replace(rreturn, "");
	      } else {
	        if (ret === null) {
	          return "";
	        } else {
	          return ret;
	        }
	      }
	    }
	  };
	
	  QJ.preventDefault = function(eventObject) {
	    if (typeof eventObject.preventDefault === "function") {
	      eventObject.preventDefault();
	      return;
	    }
	    eventObject.returnValue = false;
	    return false;
	  };
	
	  QJ.normalizeEvent = function(e) {
	    var original;
	    original = e;
	    e = {
	      which: original.which != null ? original.which : void 0,
	      target: original.target || original.srcElement,
	      preventDefault: function() {
	        return QJ.preventDefault(original);
	      },
	      originalEvent: original,
	      data: original.data || original.detail
	    };
	    if (e.which == null) {
	      e.which = original.charCode != null ? original.charCode : original.keyCode;
	    }
	    return e;
	  };
	
	  QJ.on = function(element, eventName, callback) {
	    var el, i, j, len, len1, multEventName, originalCallback, ref;
	    if (element.length) {
	      for (i = 0, len = element.length; i < len; i++) {
	        el = element[i];
	        QJ.on(el, eventName, callback);
	      }
	      return;
	    }
	    if (eventName.match(" ")) {
	      ref = eventName.split(" ");
	      for (j = 0, len1 = ref.length; j < len1; j++) {
	        multEventName = ref[j];
	        QJ.on(element, multEventName, callback);
	      }
	      return;
	    }
	    originalCallback = callback;
	    callback = function(e) {
	      e = QJ.normalizeEvent(e);
	      return originalCallback(e);
	    };
	    if (element.addEventListener) {
	      return element.addEventListener(eventName, callback, false);
	    }
	    if (element.attachEvent) {
	      eventName = "on" + eventName;
	      return element.attachEvent(eventName, callback);
	    }
	    element['on' + eventName] = callback;
	  };
	
	  QJ.addClass = function(el, className) {
	    var e;
	    if (el.length) {
	      return (function() {
	        var i, len, results;
	        results = [];
	        for (i = 0, len = el.length; i < len; i++) {
	          e = el[i];
	          results.push(QJ.addClass(e, className));
	        }
	        return results;
	      })();
	    }
	    if (el.classList) {
	      return el.classList.add(className);
	    } else {
	      return el.className += ' ' + className;
	    }
	  };
	
	  QJ.hasClass = function(el, className) {
	    var e, hasClass, i, len;
	    if (el.length) {
	      hasClass = true;
	      for (i = 0, len = el.length; i < len; i++) {
	        e = el[i];
	        hasClass = hasClass && QJ.hasClass(e, className);
	      }
	      return hasClass;
	    }
	    if (el.classList) {
	      return el.classList.contains(className);
	    } else {
	      return new RegExp('(^| )' + className + '( |$)', 'gi').test(el.className);
	    }
	  };
	
	  QJ.removeClass = function(el, className) {
	    var cls, e, i, len, ref, results;
	    if (el.length) {
	      return (function() {
	        var i, len, results;
	        results = [];
	        for (i = 0, len = el.length; i < len; i++) {
	          e = el[i];
	          results.push(QJ.removeClass(e, className));
	        }
	        return results;
	      })();
	    }
	    if (el.classList) {
	      ref = className.split(' ');
	      results = [];
	      for (i = 0, len = ref.length; i < len; i++) {
	        cls = ref[i];
	        results.push(el.classList.remove(cls));
	      }
	      return results;
	    } else {
	      return el.className = el.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
	    }
	  };
	
	  QJ.toggleClass = function(el, className, bool) {
	    var e;
	    if (el.length) {
	      return (function() {
	        var i, len, results;
	        results = [];
	        for (i = 0, len = el.length; i < len; i++) {
	          e = el[i];
	          results.push(QJ.toggleClass(e, className, bool));
	        }
	        return results;
	      })();
	    }
	    if (bool) {
	      if (!QJ.hasClass(el, className)) {
	        return QJ.addClass(el, className);
	      }
	    } else {
	      return QJ.removeClass(el, className);
	    }
	  };
	
	  QJ.append = function(el, toAppend) {
	    var e;
	    if (el.length) {
	      return (function() {
	        var i, len, results;
	        results = [];
	        for (i = 0, len = el.length; i < len; i++) {
	          e = el[i];
	          results.push(QJ.append(e, toAppend));
	        }
	        return results;
	      })();
	    }
	    return el.insertAdjacentHTML('beforeend', toAppend);
	  };
	
	  QJ.find = function(el, selector) {
	    if (el instanceof NodeList || el instanceof Array) {
	      el = el[0];
	    }
	    return el.querySelectorAll(selector);
	  };
	
	  QJ.trigger = function(el, name, data) {
	    var e, error, ev;
	    try {
	      ev = new CustomEvent(name, {
	        detail: data
	      });
	    } catch (error) {
	      e = error;
	      ev = document.createEvent('CustomEvent');
	      if (ev.initCustomEvent) {
	        ev.initCustomEvent(name, true, true, data);
	      } else {
	        ev.initEvent(name, true, true, data);
	      }
	    }
	    return el.dispatchEvent(ev);
	  };
	
	  module.exports = QJ;
	
	}).call(this);


/***/ },
/* 1776 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(8));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _PanelGroup = _interopRequireDefault(__webpack_require__(516));
	
	var Accordion =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(Accordion, _React$Component);
	
	  function Accordion() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = Accordion.prototype;
	
	  _proto.render = function render() {
	    return _react.default.createElement(_PanelGroup.default, (0, _extends2.default)({}, this.props, {
	      accordion: true
	    }), this.props.children);
	  };
	
	  return Accordion;
	}(_react.default.Component);
	
	var _default = Accordion;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 1777 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _values = _interopRequireDefault(__webpack_require__(120));
	
	var _extends3 = _interopRequireDefault(__webpack_require__(8));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _bootstrapUtils = __webpack_require__(16);
	
	var _StyleConfig = __webpack_require__(50);
	
	var _CloseButton = _interopRequireDefault(__webpack_require__(306));
	
	var propTypes = {
	  onDismiss: _propTypes.default.func,
	  closeLabel: _propTypes.default.string
	};
	var defaultProps = {
	  closeLabel: 'Close alert'
	};
	
	var Alert =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(Alert, _React$Component);
	
	  function Alert() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = Alert.prototype;
	
	  _proto.render = function render() {
	    var _extends2;
	
	    var _this$props = this.props,
	        onDismiss = _this$props.onDismiss,
	        closeLabel = _this$props.closeLabel,
	        className = _this$props.className,
	        children = _this$props.children,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["onDismiss", "closeLabel", "className", "children"]);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var dismissable = !!onDismiss;
	    var classes = (0, _extends3.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'dismissable')] = dismissable, _extends2));
	    return _react.default.createElement("div", (0, _extends3.default)({}, elementProps, {
	      role: "alert",
	      className: (0, _classnames.default)(className, classes)
	    }), dismissable && _react.default.createElement(_CloseButton.default, {
	      onClick: onDismiss,
	      label: closeLabel
	    }), children);
	  };
	
	  return Alert;
	}(_react.default.Component);
	
	Alert.propTypes = propTypes;
	Alert.defaultProps = defaultProps;
	
	var _default = (0, _bootstrapUtils.bsStyles)((0, _values.default)(_StyleConfig.State), _StyleConfig.State.INFO, (0, _bootstrapUtils.bsClass)('alert', Alert));
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 1778 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(8));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _bootstrapUtils = __webpack_require__(16);
	
	// TODO: `pullRight` doesn't belong here. There's no special handling here.
	var propTypes = {
	  pullRight: _propTypes.default.bool
	};
	var defaultProps = {
	  pullRight: false
	};
	
	var Badge =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(Badge, _React$Component);
	
	  function Badge() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = Badge.prototype;
	
	  _proto.hasContent = function hasContent(children) {
	    var result = false;
	
	    _react.default.Children.forEach(children, function (child) {
	      if (result) {
	        return;
	      }
	
	      if (child || child === 0) {
	        result = true;
	      }
	    });
	
	    return result;
	  };
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        pullRight = _this$props.pullRight,
	        className = _this$props.className,
	        children = _this$props.children,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["pullRight", "className", "children"]);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends2.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	      'pull-right': pullRight,
	      // Hack for collapsing on IE8.
	      hidden: !this.hasContent(children)
	    });
	    return _react.default.createElement("span", (0, _extends2.default)({}, elementProps, {
	      className: (0, _classnames.default)(className, classes)
	    }), children);
	  };
	
	  return Badge;
	}(_react.default.Component);
	
	Badge.propTypes = propTypes;
	Badge.defaultProps = defaultProps;
	
	var _default = (0, _bootstrapUtils.bsClass)('badge', Badge);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 1779 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(8));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _BreadcrumbItem = _interopRequireDefault(__webpack_require__(499));
	
	var _bootstrapUtils = __webpack_require__(16);
	
	var Breadcrumb =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(Breadcrumb, _React$Component);
	
	  function Breadcrumb() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = Breadcrumb.prototype;
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        className = _this$props.className,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["className"]);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	    return _react.default.createElement("ol", (0, _extends2.default)({}, elementProps, {
	      role: "navigation",
	      "aria-label": "breadcrumbs",
	      className: (0, _classnames.default)(className, classes)
	    }));
	  };
	
	  return Breadcrumb;
	}(_react.default.Component);
	
	Breadcrumb.Item = _BreadcrumbItem.default;
	
	var _default = (0, _bootstrapUtils.bsClass)('breadcrumb', Breadcrumb);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 1780 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(8));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _bootstrapUtils = __webpack_require__(16);
	
	var ButtonToolbar =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(ButtonToolbar, _React$Component);
	
	  function ButtonToolbar() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = ButtonToolbar.prototype;
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        className = _this$props.className,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["className"]);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	    return _react.default.createElement("div", (0, _extends2.default)({}, elementProps, {
	      role: "toolbar",
	      className: (0, _classnames.default)(className, classes)
	    }));
	  };
	
	  return ButtonToolbar;
	}(_react.default.Component);
	
	var _default = (0, _bootstrapUtils.bsClass)('btn-toolbar', ButtonToolbar);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 1781 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(47);
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(8));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(57));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _CarouselCaption = _interopRequireDefault(__webpack_require__(1782));
	
	var _CarouselItem = _interopRequireDefault(__webpack_require__(500));
	
	var _Glyphicon = _interopRequireDefault(__webpack_require__(308));
	
	var _SafeAnchor = _interopRequireDefault(__webpack_require__(73));
	
	var _bootstrapUtils = __webpack_require__(16);
	
	var _ValidComponentChildren = _interopRequireDefault(__webpack_require__(58));
	
	// TODO: `slide` should be `animate`.
	// TODO: Use uncontrollable.
	var propTypes = {
	  slide: _propTypes.default.bool,
	  indicators: _propTypes.default.bool,
	
	  /**
	   * The amount of time to delay between automatically cycling an item.
	   * If `null`, carousel will not automatically cycle.
	   */
	  interval: _propTypes.default.number,
	  controls: _propTypes.default.bool,
	  pauseOnHover: _propTypes.default.bool,
	  wrap: _propTypes.default.bool,
	
	  /**
	   * Callback fired when the active item changes.
	   *
	   * ```js
	   * (eventKey: any, ?event: Object) => any
	   * ```
	   *
	   * If this callback takes two or more arguments, the second argument will
	   * be a persisted event object with `direction` set to the direction of the
	   * transition.
	   */
	  onSelect: _propTypes.default.func,
	  onSlideEnd: _propTypes.default.func,
	  activeIndex: _propTypes.default.number,
	  defaultActiveIndex: _propTypes.default.number,
	  direction: _propTypes.default.oneOf(['prev', 'next']),
	  prevIcon: _propTypes.default.node,
	
	  /**
	   * Label shown to screen readers only, can be used to show the previous element
	   * in the carousel.
	   * Set to null to deactivate.
	   */
	  prevLabel: _propTypes.default.string,
	  nextIcon: _propTypes.default.node,
	
	  /**
	   * Label shown to screen readers only, can be used to show the next element
	   * in the carousel.
	   * Set to null to deactivate.
	   */
	  nextLabel: _propTypes.default.string
	};
	var defaultProps = {
	  slide: true,
	  interval: 5000,
	  pauseOnHover: true,
	  wrap: true,
	  indicators: true,
	  controls: true,
	  prevIcon: _react.default.createElement(_Glyphicon.default, {
	    glyph: "chevron-left"
	  }),
	  prevLabel: 'Previous',
	  nextIcon: _react.default.createElement(_Glyphicon.default, {
	    glyph: "chevron-right"
	  }),
	  nextLabel: 'Next'
	};
	
	var Carousel =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(Carousel, _React$Component);
	
	  function Carousel(props, context) {
	    var _this;
	
	    _this = _React$Component.call(this, props, context) || this;
	    _this.handleMouseOver = _this.handleMouseOver.bind((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
	    _this.handleMouseOut = _this.handleMouseOut.bind((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
	    _this.handlePrev = _this.handlePrev.bind((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
	    _this.handleNext = _this.handleNext.bind((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
	    _this.handleItemAnimateOutEnd = _this.handleItemAnimateOutEnd.bind((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
	    var defaultActiveIndex = props.defaultActiveIndex;
	    _this.state = {
	      activeIndex: defaultActiveIndex != null ? defaultActiveIndex : 0,
	      previousActiveIndex: null,
	      direction: null
	    };
	    _this.isUnmounted = false;
	    return _this;
	  }
	
	  var _proto = Carousel.prototype;
	
	  _proto.componentDidMount = function componentDidMount() {
	    this.waitForNext();
	  };
	
	  _proto.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps(nextProps) {
	    // eslint-disable-line
	    var activeIndex = this.getActiveIndex();
	
	    if (nextProps.activeIndex != null && nextProps.activeIndex !== activeIndex) {
	      clearTimeout(this.timeout);
	      this.setState({
	        previousActiveIndex: activeIndex,
	        direction: nextProps.direction != null ? nextProps.direction : this.getDirection(activeIndex, nextProps.activeIndex)
	      });
	    }
	
	    if (nextProps.activeIndex == null && this.state.activeIndex >= nextProps.children.length) {
	      this.setState({
	        activeIndex: 0,
	        previousActiveIndex: null,
	        direction: null
	      });
	    }
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    clearTimeout(this.timeout);
	    this.isUnmounted = true;
	  };
	
	  _proto.getActiveIndex = function getActiveIndex() {
	    var activeIndexProp = this.props.activeIndex;
	    return activeIndexProp != null ? activeIndexProp : this.state.activeIndex;
	  };
	
	  _proto.getDirection = function getDirection(prevIndex, index) {
	    if (prevIndex === index) {
	      return null;
	    }
	
	    return prevIndex > index ? 'prev' : 'next';
	  };
	
	  _proto.handleItemAnimateOutEnd = function handleItemAnimateOutEnd() {
	    var _this2 = this;
	
	    this.setState({
	      previousActiveIndex: null,
	      direction: null
	    }, function () {
	      _this2.waitForNext();
	
	      if (_this2.props.onSlideEnd) {
	        _this2.props.onSlideEnd();
	      }
	    });
	  };
	
	  _proto.handleMouseOut = function handleMouseOut() {
	    if (this.isPaused) {
	      this.play();
	    }
	  };
	
	  _proto.handleMouseOver = function handleMouseOver() {
	    if (this.props.pauseOnHover) {
	      this.pause();
	    }
	  };
	
	  _proto.handleNext = function handleNext(e) {
	    var index = this.getActiveIndex() + 1;
	
	    var count = _ValidComponentChildren.default.count(this.props.children);
	
	    if (index > count - 1) {
	      if (!this.props.wrap) {
	        return;
	      }
	
	      index = 0;
	    }
	
	    this.select(index, e, 'next');
	  };
	
	  _proto.handlePrev = function handlePrev(e) {
	    var index = this.getActiveIndex() - 1;
	
	    if (index < 0) {
	      if (!this.props.wrap) {
	        return;
	      }
	
	      index = _ValidComponentChildren.default.count(this.props.children) - 1;
	    }
	
	    this.select(index, e, 'prev');
	  }; // This might be a public API.
	
	
	  _proto.pause = function pause() {
	    this.isPaused = true;
	    clearTimeout(this.timeout);
	  }; // This might be a public API.
	
	
	  _proto.play = function play() {
	    this.isPaused = false;
	    this.waitForNext();
	  };
	
	  _proto.select = function select(index, e, direction) {
	    clearTimeout(this.timeout); // TODO: Is this necessary? Seems like the only risk is if the component
	    // unmounts while handleItemAnimateOutEnd fires.
	
	    if (this.isUnmounted) {
	      return;
	    }
	
	    var previousActiveIndex = this.props.slide ? this.getActiveIndex() : null;
	    direction = direction || this.getDirection(previousActiveIndex, index);
	    var onSelect = this.props.onSelect;
	
	    if (onSelect) {
	      if (onSelect.length > 1) {
	        // React SyntheticEvents are pooled, so we need to remove this event
	        // from the pool to add a custom property. To avoid unnecessarily
	        // removing objects from the pool, only do this when the listener
	        // actually wants the event.
	        if (e) {
	          e.persist();
	          e.direction = direction;
	        } else {
	          e = {
	            direction: direction
	          };
	        }
	
	        onSelect(index, e);
	      } else {
	        onSelect(index);
	      }
	    }
	
	    if (this.props.activeIndex == null && index !== previousActiveIndex) {
	      if (this.state.previousActiveIndex != null) {
	        // If currently animating don't activate the new index.
	        // TODO: look into queueing this canceled call and
	        // animating after the current animation has ended.
	        return;
	      }
	
	      this.setState({
	        activeIndex: index,
	        previousActiveIndex: previousActiveIndex,
	        direction: direction
	      });
	    }
	  };
	
	  _proto.waitForNext = function waitForNext() {
	    var _this$props = this.props,
	        slide = _this$props.slide,
	        interval = _this$props.interval,
	        activeIndexProp = _this$props.activeIndex;
	
	    if (!this.isPaused && slide && interval && activeIndexProp == null) {
	      this.timeout = setTimeout(this.handleNext, interval);
	    }
	  };
	
	  _proto.renderControls = function renderControls(properties) {
	    var wrap = properties.wrap,
	        children = properties.children,
	        activeIndex = properties.activeIndex,
	        prevIcon = properties.prevIcon,
	        nextIcon = properties.nextIcon,
	        bsProps = properties.bsProps,
	        prevLabel = properties.prevLabel,
	        nextLabel = properties.nextLabel;
	    var controlClassName = (0, _bootstrapUtils.prefix)(bsProps, 'control');
	
	    var count = _ValidComponentChildren.default.count(children);
	
	    return [(wrap || activeIndex !== 0) && _react.default.createElement(_SafeAnchor.default, {
	      key: "prev",
	      className: (0, _classnames.default)(controlClassName, 'left'),
	      onClick: this.handlePrev
	    }, prevIcon, prevLabel && _react.default.createElement("span", {
	      className: "sr-only"
	    }, prevLabel)), (wrap || activeIndex !== count - 1) && _react.default.createElement(_SafeAnchor.default, {
	      key: "next",
	      className: (0, _classnames.default)(controlClassName, 'right'),
	      onClick: this.handleNext
	    }, nextIcon, nextLabel && _react.default.createElement("span", {
	      className: "sr-only"
	    }, nextLabel))];
	  };
	
	  _proto.renderIndicators = function renderIndicators(children, activeIndex, bsProps) {
	    var _this3 = this;
	
	    var indicators = [];
	
	    _ValidComponentChildren.default.forEach(children, function (child, index) {
	      indicators.push(_react.default.createElement("li", {
	        key: index,
	        className: index === activeIndex ? 'active' : null,
	        onClick: function onClick(e) {
	          return _this3.select(index, e);
	        }
	      }), // Force whitespace between indicator elements. Bootstrap requires
	      // this for correct spacing of elements.
	      ' ');
	    });
	
	    return _react.default.createElement("ol", {
	      className: (0, _bootstrapUtils.prefix)(bsProps, 'indicators')
	    }, indicators);
	  };
	
	  _proto.render = function render() {
	    var _this4 = this;
	
	    var _this$props2 = this.props,
	        slide = _this$props2.slide,
	        indicators = _this$props2.indicators,
	        controls = _this$props2.controls,
	        wrap = _this$props2.wrap,
	        prevIcon = _this$props2.prevIcon,
	        prevLabel = _this$props2.prevLabel,
	        nextIcon = _this$props2.nextIcon,
	        nextLabel = _this$props2.nextLabel,
	        className = _this$props2.className,
	        children = _this$props2.children,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props2, ["slide", "indicators", "controls", "wrap", "prevIcon", "prevLabel", "nextIcon", "nextLabel", "className", "children"]);
	    var _this$state = this.state,
	        previousActiveIndex = _this$state.previousActiveIndex,
	        direction = _this$state.direction;
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['interval', 'pauseOnHover', 'onSelect', 'onSlideEnd', 'activeIndex', // Accessed via this.getActiveIndex().
	    'defaultActiveIndex', 'direction']),
	        bsProps = _splitBsPropsAndOmit[0],
	        elementProps = _splitBsPropsAndOmit[1];
	
	    var activeIndex = this.getActiveIndex();
	    var classes = (0, _extends2.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	      slide: slide
	    });
	    return _react.default.createElement("div", (0, _extends2.default)({}, elementProps, {
	      className: (0, _classnames.default)(className, classes),
	      onMouseOver: this.handleMouseOver,
	      onMouseOut: this.handleMouseOut
	    }), indicators && this.renderIndicators(children, activeIndex, bsProps), _react.default.createElement("div", {
	      className: (0, _bootstrapUtils.prefix)(bsProps, 'inner')
	    }, _ValidComponentChildren.default.map(children, function (child, index) {
	      var active = index === activeIndex;
	      var previousActive = slide && index === previousActiveIndex;
	      return (0, _react.cloneElement)(child, {
	        active: active,
	        index: index,
	        animateOut: previousActive,
	        animateIn: active && previousActiveIndex != null && slide,
	        direction: direction,
	        onAnimateOutEnd: previousActive ? _this4.handleItemAnimateOutEnd : null
	      });
	    })), controls && this.renderControls({
	      wrap: wrap,
	      children: children,
	      activeIndex: activeIndex,
	      prevIcon: prevIcon,
	      prevLabel: prevLabel,
	      nextIcon: nextIcon,
	      nextLabel: nextLabel,
	      bsProps: bsProps
	    }));
	  };
	
	  return Carousel;
	}(_react.default.Component);
	
	Carousel.propTypes = propTypes;
	Carousel.defaultProps = defaultProps;
	Carousel.Caption = _CarouselCaption.default;
	Carousel.Item = _CarouselItem.default;
	
	var _default = (0, _bootstrapUtils.bsClass)('carousel', Carousel);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 1782 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(8));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _elementType = _interopRequireDefault(__webpack_require__(32));
	
	var _bootstrapUtils = __webpack_require__(16);
	
	var propTypes = {
	  componentClass: _elementType.default
	};
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var CarouselCaption =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(CarouselCaption, _React$Component);
	
	  function CarouselCaption() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = CarouselCaption.prototype;
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        Component = _this$props.componentClass,
	        className = _this$props.className,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["componentClass", "className"]);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	    return _react.default.createElement(Component, (0, _extends2.default)({}, elementProps, {
	      className: (0, _classnames.default)(className, classes)
	    }));
	  };
	
	  return CarouselCaption;
	}(_react.default.Component);
	
	CarouselCaption.propTypes = propTypes;
	CarouselCaption.defaultProps = defaultProps;
	
	var _default = (0, _bootstrapUtils.bsClass)('carousel-caption', CarouselCaption);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 1783 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(8));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _warning = _interopRequireDefault(__webpack_require__(59));
	
	var _bootstrapUtils = __webpack_require__(16);
	
	/* eslint-disable jsx-a11y/label-has-for */
	var propTypes = {
	  inline: _propTypes.default.bool,
	  disabled: _propTypes.default.bool,
	  title: _propTypes.default.string,
	
	  /**
	   * Only valid if `inline` is not set.
	   */
	  validationState: _propTypes.default.oneOf(['success', 'warning', 'error', null]),
	
	  /**
	   * Attaches a ref to the `<input>` element. Only functions can be used here.
	   *
	   * ```js
	   * <Checkbox inputRef={ref => { this.input = ref; }} />
	   * ```
	   */
	  inputRef: _propTypes.default.func
	};
	var defaultProps = {
	  inline: false,
	  disabled: false,
	  title: ''
	};
	
	var Checkbox =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(Checkbox, _React$Component);
	
	  function Checkbox() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = Checkbox.prototype;
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        inline = _this$props.inline,
	        disabled = _this$props.disabled,
	        validationState = _this$props.validationState,
	        inputRef = _this$props.inputRef,
	        className = _this$props.className,
	        style = _this$props.style,
	        title = _this$props.title,
	        children = _this$props.children,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["inline", "disabled", "validationState", "inputRef", "className", "style", "title", "children"]);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var input = _react.default.createElement("input", (0, _extends2.default)({}, elementProps, {
	      ref: inputRef,
	      type: "checkbox",
	      disabled: disabled
	    }));
	
	    if (inline) {
	      var _classes2;
	
	      var _classes = (_classes2 = {}, _classes2[(0, _bootstrapUtils.prefix)(bsProps, 'inline')] = true, _classes2.disabled = disabled, _classes2); // Use a warning here instead of in propTypes to get better-looking
	      // generated documentation.
	
	
	       false ? (0, _warning.default)(!validationState, '`validationState` is ignored on `<Checkbox inline>`. To display ' + 'validation state on an inline checkbox, set `validationState` on a ' + 'parent `<FormGroup>` or other element instead.') : void 0;
	      return _react.default.createElement("label", {
	        className: (0, _classnames.default)(className, _classes),
	        style: style,
	        title: title
	      }, input, children);
	    }
	
	    var classes = (0, _extends2.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	      disabled: disabled
	    });
	
	    if (validationState) {
	      classes["has-" + validationState] = true;
	    }
	
	    return _react.default.createElement("div", {
	      className: (0, _classnames.default)(className, classes),
	      style: style
	    }, _react.default.createElement("label", {
	      title: title
	    }, input, children));
	  };
	
	  return Checkbox;
	}(_react.default.Component);
	
	Checkbox.propTypes = propTypes;
	Checkbox.defaultProps = defaultProps;
	
	var _default = (0, _bootstrapUtils.bsClass)('checkbox', Checkbox);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 1784 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(8));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _elementType = _interopRequireDefault(__webpack_require__(32));
	
	var _bootstrapUtils = __webpack_require__(16);
	
	var _capitalize = _interopRequireDefault(__webpack_require__(521));
	
	var _StyleConfig = __webpack_require__(50);
	
	var propTypes = {
	  componentClass: _elementType.default,
	
	  /**
	   * Apply clearfix
	   *
	   * on Extra small devices Phones
	   *
	   * adds class `visible-xs-block`
	   */
	  visibleXsBlock: _propTypes.default.bool,
	
	  /**
	   * Apply clearfix
	   *
	   * on Small devices Tablets
	   *
	   * adds class `visible-sm-block`
	   */
	  visibleSmBlock: _propTypes.default.bool,
	
	  /**
	   * Apply clearfix
	   *
	   * on Medium devices Desktops
	   *
	   * adds class `visible-md-block`
	   */
	  visibleMdBlock: _propTypes.default.bool,
	
	  /**
	   * Apply clearfix
	   *
	   * on Large devices Desktops
	   *
	   * adds class `visible-lg-block`
	   */
	  visibleLgBlock: _propTypes.default.bool
	};
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var Clearfix =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(Clearfix, _React$Component);
	
	  function Clearfix() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = Clearfix.prototype;
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        Component = _this$props.componentClass,
	        className = _this$props.className,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["componentClass", "className"]);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    _StyleConfig.DEVICE_SIZES.forEach(function (size) {
	      var propName = "visible" + (0, _capitalize.default)(size) + "Block";
	
	      if (elementProps[propName]) {
	        classes["visible-" + size + "-block"] = true;
	      }
	
	      delete elementProps[propName];
	    });
	
	    return _react.default.createElement(Component, (0, _extends2.default)({}, elementProps, {
	      className: (0, _classnames.default)(className, classes)
	    }));
	  };
	
	  return Clearfix;
	}(_react.default.Component);
	
	Clearfix.propTypes = propTypes;
	Clearfix.defaultProps = defaultProps;
	
	var _default = (0, _bootstrapUtils.bsClass)('clearfix', Clearfix);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 1785 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(8));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _elementType = _interopRequireDefault(__webpack_require__(32));
	
	var _bootstrapUtils = __webpack_require__(16);
	
	var _StyleConfig = __webpack_require__(50);
	
	var propTypes = {
	  componentClass: _elementType.default,
	
	  /**
	   * The number of columns you wish to span
	   *
	   * for Extra small devices Phones (<768px)
	   *
	   * class-prefix `col-xs-`
	   */
	  xs: _propTypes.default.number,
	
	  /**
	   * The number of columns you wish to span
	   *
	   * for Small devices Tablets (≥768px)
	   *
	   * class-prefix `col-sm-`
	   */
	  sm: _propTypes.default.number,
	
	  /**
	   * The number of columns you wish to span
	   *
	   * for Medium devices Desktops (≥992px)
	   *
	   * class-prefix `col-md-`
	   */
	  md: _propTypes.default.number,
	
	  /**
	   * The number of columns you wish to span
	   *
	   * for Large devices Desktops (≥1200px)
	   *
	   * class-prefix `col-lg-`
	   */
	  lg: _propTypes.default.number,
	
	  /**
	   * Hide column
	   *
	   * on Extra small devices Phones
	   *
	   * adds class `hidden-xs`
	   */
	  xsHidden: _propTypes.default.bool,
	
	  /**
	   * Hide column
	   *
	   * on Small devices Tablets
	   *
	   * adds class `hidden-sm`
	   */
	  smHidden: _propTypes.default.bool,
	
	  /**
	   * Hide column
	   *
	   * on Medium devices Desktops
	   *
	   * adds class `hidden-md`
	   */
	  mdHidden: _propTypes.default.bool,
	
	  /**
	   * Hide column
	   *
	   * on Large devices Desktops
	   *
	   * adds class `hidden-lg`
	   */
	  lgHidden: _propTypes.default.bool,
	
	  /**
	   * Move columns to the right
	   *
	   * for Extra small devices Phones
	   *
	   * class-prefix `col-xs-offset-`
	   */
	  xsOffset: _propTypes.default.number,
	
	  /**
	   * Move columns to the right
	   *
	   * for Small devices Tablets
	   *
	   * class-prefix `col-sm-offset-`
	   */
	  smOffset: _propTypes.default.number,
	
	  /**
	   * Move columns to the right
	   *
	   * for Medium devices Desktops
	   *
	   * class-prefix `col-md-offset-`
	   */
	  mdOffset: _propTypes.default.number,
	
	  /**
	   * Move columns to the right
	   *
	   * for Large devices Desktops
	   *
	   * class-prefix `col-lg-offset-`
	   */
	  lgOffset: _propTypes.default.number,
	
	  /**
	   * Change the order of grid columns to the right
	   *
	   * for Extra small devices Phones
	   *
	   * class-prefix `col-xs-push-`
	   */
	  xsPush: _propTypes.default.number,
	
	  /**
	   * Change the order of grid columns to the right
	   *
	   * for Small devices Tablets
	   *
	   * class-prefix `col-sm-push-`
	   */
	  smPush: _propTypes.default.number,
	
	  /**
	   * Change the order of grid columns to the right
	   *
	   * for Medium devices Desktops
	   *
	   * class-prefix `col-md-push-`
	   */
	  mdPush: _propTypes.default.number,
	
	  /**
	   * Change the order of grid columns to the right
	   *
	   * for Large devices Desktops
	   *
	   * class-prefix `col-lg-push-`
	   */
	  lgPush: _propTypes.default.number,
	
	  /**
	   * Change the order of grid columns to the left
	   *
	   * for Extra small devices Phones
	   *
	   * class-prefix `col-xs-pull-`
	   */
	  xsPull: _propTypes.default.number,
	
	  /**
	   * Change the order of grid columns to the left
	   *
	   * for Small devices Tablets
	   *
	   * class-prefix `col-sm-pull-`
	   */
	  smPull: _propTypes.default.number,
	
	  /**
	   * Change the order of grid columns to the left
	   *
	   * for Medium devices Desktops
	   *
	   * class-prefix `col-md-pull-`
	   */
	  mdPull: _propTypes.default.number,
	
	  /**
	   * Change the order of grid columns to the left
	   *
	   * for Large devices Desktops
	   *
	   * class-prefix `col-lg-pull-`
	   */
	  lgPull: _propTypes.default.number
	};
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var Col =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(Col, _React$Component);
	
	  function Col() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = Col.prototype;
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        Component = _this$props.componentClass,
	        className = _this$props.className,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["componentClass", "className"]);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = [];
	
	    _StyleConfig.DEVICE_SIZES.forEach(function (size) {
	      function popProp(propSuffix, modifier) {
	        var propName = "" + size + propSuffix;
	        var propValue = elementProps[propName];
	
	        if (propValue != null) {
	          classes.push((0, _bootstrapUtils.prefix)(bsProps, "" + size + modifier + "-" + propValue));
	        }
	
	        delete elementProps[propName];
	      }
	
	      popProp('', '');
	      popProp('Offset', '-offset');
	      popProp('Push', '-push');
	      popProp('Pull', '-pull');
	      var hiddenPropName = size + "Hidden";
	
	      if (elementProps[hiddenPropName]) {
	        classes.push("hidden-" + size);
	      }
	
	      delete elementProps[hiddenPropName];
	    });
	
	    return _react.default.createElement(Component, (0, _extends2.default)({}, elementProps, {
	      className: (0, _classnames.default)(className, classes)
	    }));
	  };
	
	  return Col;
	}(_react.default.Component);
	
	Col.propTypes = propTypes;
	Col.defaultProps = defaultProps;
	
	var _default = (0, _bootstrapUtils.bsClass)('col', Col);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 1786 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(8));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _warning = _interopRequireDefault(__webpack_require__(59));
	
	var _bootstrapUtils = __webpack_require__(16);
	
	var propTypes = {
	  /**
	   * Uses `controlId` from `<FormGroup>` if not explicitly specified.
	   */
	  htmlFor: _propTypes.default.string,
	  srOnly: _propTypes.default.bool
	};
	var defaultProps = {
	  srOnly: false
	};
	var contextTypes = {
	  $bs_formGroup: _propTypes.default.object
	};
	
	var ControlLabel =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(ControlLabel, _React$Component);
	
	  function ControlLabel() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = ControlLabel.prototype;
	
	  _proto.render = function render() {
	    var formGroup = this.context.$bs_formGroup;
	    var controlId = formGroup && formGroup.controlId;
	    var _this$props = this.props,
	        _this$props$htmlFor = _this$props.htmlFor,
	        htmlFor = _this$props$htmlFor === void 0 ? controlId : _this$props$htmlFor,
	        srOnly = _this$props.srOnly,
	        className = _this$props.className,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["htmlFor", "srOnly", "className"]);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	     false ? (0, _warning.default)(controlId == null || htmlFor === controlId, '`controlId` is ignored on `<ControlLabel>` when `htmlFor` is specified.') : void 0;
	    var classes = (0, _extends2.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	      'sr-only': srOnly
	    });
	    return _react.default.createElement("label", (0, _extends2.default)({}, elementProps, {
	      htmlFor: htmlFor,
	      className: (0, _classnames.default)(className, classes)
	    }));
	  };
	
	  return ControlLabel;
	}(_react.default.Component);
	
	ControlLabel.propTypes = propTypes;
	ControlLabel.defaultProps = defaultProps;
	ControlLabel.contextTypes = contextTypes;
	
	var _default = (0, _bootstrapUtils.bsClass)('control-label', ControlLabel);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 1787 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends3 = _interopRequireDefault(__webpack_require__(8));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _from = _interopRequireDefault(__webpack_require__(611));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(57));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _keycode = _interopRequireDefault(__webpack_require__(294));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(46));
	
	var _RootCloseWrapper = _interopRequireDefault(__webpack_require__(525));
	
	var _bootstrapUtils = __webpack_require__(16);
	
	var _createChainedFunction = _interopRequireDefault(__webpack_require__(45));
	
	var _ValidComponentChildren = _interopRequireDefault(__webpack_require__(58));
	
	var propTypes = {
	  open: _propTypes.default.bool,
	  pullRight: _propTypes.default.bool,
	  onClose: _propTypes.default.func,
	  labelledBy: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
	  onSelect: _propTypes.default.func,
	  rootCloseEvent: _propTypes.default.oneOf(['click', 'mousedown'])
	};
	var defaultProps = {
	  bsRole: 'menu',
	  pullRight: false
	};
	
	var DropdownMenu =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(DropdownMenu, _React$Component);
	
	  function DropdownMenu(props) {
	    var _this;
	
	    _this = _React$Component.call(this, props) || this;
	    _this.handleRootClose = _this.handleRootClose.bind((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
	    _this.handleKeyDown = _this.handleKeyDown.bind((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
	    return _this;
	  }
	
	  var _proto = DropdownMenu.prototype;
	
	  _proto.getFocusableMenuItems = function getFocusableMenuItems() {
	    var node = _reactDom.default.findDOMNode(this);
	
	    if (!node) {
	      return [];
	    }
	
	    return (0, _from.default)(node.querySelectorAll('[tabIndex="-1"]'));
	  };
	
	  _proto.getItemsAndActiveIndex = function getItemsAndActiveIndex() {
	    var items = this.getFocusableMenuItems();
	    var activeIndex = items.indexOf(document.activeElement);
	    return {
	      items: items,
	      activeIndex: activeIndex
	    };
	  };
	
	  _proto.focusNext = function focusNext() {
	    var _this$getItemsAndActi = this.getItemsAndActiveIndex(),
	        items = _this$getItemsAndActi.items,
	        activeIndex = _this$getItemsAndActi.activeIndex;
	
	    if (items.length === 0) {
	      return;
	    }
	
	    var nextIndex = activeIndex === items.length - 1 ? 0 : activeIndex + 1;
	    items[nextIndex].focus();
	  };
	
	  _proto.focusPrevious = function focusPrevious() {
	    var _this$getItemsAndActi2 = this.getItemsAndActiveIndex(),
	        items = _this$getItemsAndActi2.items,
	        activeIndex = _this$getItemsAndActi2.activeIndex;
	
	    if (items.length === 0) {
	      return;
	    }
	
	    var prevIndex = activeIndex === 0 ? items.length - 1 : activeIndex - 1;
	    items[prevIndex].focus();
	  };
	
	  _proto.handleKeyDown = function handleKeyDown(event) {
	    switch (event.keyCode) {
	      case _keycode.default.codes.down:
	        this.focusNext();
	        event.preventDefault();
	        break;
	
	      case _keycode.default.codes.up:
	        this.focusPrevious();
	        event.preventDefault();
	        break;
	
	      case _keycode.default.codes.esc:
	      case _keycode.default.codes.tab:
	        this.props.onClose(event, {
	          source: 'keydown'
	        });
	        break;
	
	      default:
	    }
	  };
	
	  _proto.handleRootClose = function handleRootClose(event) {
	    this.props.onClose(event, {
	      source: 'rootClose'
	    });
	  };
	
	  _proto.render = function render() {
	    var _extends2,
	        _this2 = this;
	
	    var _this$props = this.props,
	        open = _this$props.open,
	        pullRight = _this$props.pullRight,
	        labelledBy = _this$props.labelledBy,
	        onSelect = _this$props.onSelect,
	        className = _this$props.className,
	        rootCloseEvent = _this$props.rootCloseEvent,
	        children = _this$props.children,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["open", "pullRight", "labelledBy", "onSelect", "className", "rootCloseEvent", "children"]);
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['onClose']),
	        bsProps = _splitBsPropsAndOmit[0],
	        elementProps = _splitBsPropsAndOmit[1];
	
	    var classes = (0, _extends3.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'right')] = pullRight, _extends2));
	    return _react.default.createElement(_RootCloseWrapper.default, {
	      disabled: !open,
	      onRootClose: this.handleRootClose,
	      event: rootCloseEvent
	    }, _react.default.createElement("ul", (0, _extends3.default)({}, elementProps, {
	      role: "menu",
	      className: (0, _classnames.default)(className, classes),
	      "aria-labelledby": labelledBy
	    }), _ValidComponentChildren.default.map(children, function (child) {
	      return _react.default.cloneElement(child, {
	        onKeyDown: (0, _createChainedFunction.default)(child.props.onKeyDown, _this2.handleKeyDown),
	        onSelect: (0, _createChainedFunction.default)(child.props.onSelect, onSelect)
	      });
	    })));
	  };
	
	  return DropdownMenu;
	}(_react.default.Component);
	
	DropdownMenu.propTypes = propTypes;
	DropdownMenu.defaultProps = defaultProps;
	
	var _default = (0, _bootstrapUtils.bsClass)('dropdown-menu', DropdownMenu);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 1788 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(8));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _elementType = _interopRequireDefault(__webpack_require__(32));
	
	var _bootstrapUtils = __webpack_require__(16);
	
	var propTypes = {
	  horizontal: _propTypes.default.bool,
	  inline: _propTypes.default.bool,
	  componentClass: _elementType.default
	};
	var defaultProps = {
	  horizontal: false,
	  inline: false,
	  componentClass: 'form'
	};
	
	var Form =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(Form, _React$Component);
	
	  function Form() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = Form.prototype;
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        horizontal = _this$props.horizontal,
	        inline = _this$props.inline,
	        Component = _this$props.componentClass,
	        className = _this$props.className,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["horizontal", "inline", "componentClass", "className"]);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = [];
	
	    if (horizontal) {
	      classes.push((0, _bootstrapUtils.prefix)(bsProps, 'horizontal'));
	    }
	
	    if (inline) {
	      classes.push((0, _bootstrapUtils.prefix)(bsProps, 'inline'));
	    }
	
	    return _react.default.createElement(Component, (0, _extends2.default)({}, elementProps, {
	      className: (0, _classnames.default)(className, classes)
	    }));
	  };
	
	  return Form;
	}(_react.default.Component);
	
	Form.propTypes = propTypes;
	Form.defaultProps = defaultProps;
	
	var _default = (0, _bootstrapUtils.bsClass)('form', Form);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 1789 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(8));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _elementType = _interopRequireDefault(__webpack_require__(32));
	
	var _warning = _interopRequireDefault(__webpack_require__(59));
	
	var _FormControlFeedback = _interopRequireDefault(__webpack_require__(1790));
	
	var _FormControlStatic = _interopRequireDefault(__webpack_require__(1791));
	
	var _bootstrapUtils = __webpack_require__(16);
	
	var _StyleConfig = __webpack_require__(50);
	
	var propTypes = {
	  componentClass: _elementType.default,
	
	  /**
	   * Only relevant if `componentClass` is `'input'`.
	   */
	  type: _propTypes.default.string,
	
	  /**
	   * Uses `controlId` from `<FormGroup>` if not explicitly specified.
	   */
	  id: _propTypes.default.string,
	
	  /**
	   * Attaches a ref to the `<input>` element. Only functions can be used here.
	   *
	   * ```js
	   * <FormControl inputRef={ref => { this.input = ref; }} />
	   * ```
	   */
	  inputRef: _propTypes.default.func
	};
	var defaultProps = {
	  componentClass: 'input'
	};
	var contextTypes = {
	  $bs_formGroup: _propTypes.default.object
	};
	
	var FormControl =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(FormControl, _React$Component);
	
	  function FormControl() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = FormControl.prototype;
	
	  _proto.render = function render() {
	    var formGroup = this.context.$bs_formGroup;
	    var controlId = formGroup && formGroup.controlId;
	    var _this$props = this.props,
	        Component = _this$props.componentClass,
	        type = _this$props.type,
	        _this$props$id = _this$props.id,
	        id = _this$props$id === void 0 ? controlId : _this$props$id,
	        inputRef = _this$props.inputRef,
	        className = _this$props.className,
	        bsSize = _this$props.bsSize,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["componentClass", "type", "id", "inputRef", "className", "bsSize"]);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	     false ? (0, _warning.default)(controlId == null || id === controlId, '`controlId` is ignored on `<FormControl>` when `id` is specified.') : void 0; // input[type="file"] should not have .form-control.
	
	    var classes;
	
	    if (type !== 'file') {
	      classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	    } // If user provides a size, make sure to append it to classes as input-
	    // e.g. if bsSize is small, it will append input-sm
	
	
	    if (bsSize) {
	      var size = _StyleConfig.SIZE_MAP[bsSize] || bsSize;
	      classes[(0, _bootstrapUtils.prefix)({
	        bsClass: 'input'
	      }, size)] = true;
	    }
	
	    return _react.default.createElement(Component, (0, _extends2.default)({}, elementProps, {
	      type: type,
	      id: id,
	      ref: inputRef,
	      className: (0, _classnames.default)(className, classes)
	    }));
	  };
	
	  return FormControl;
	}(_react.default.Component);
	
	FormControl.propTypes = propTypes;
	FormControl.defaultProps = defaultProps;
	FormControl.contextTypes = contextTypes;
	FormControl.Feedback = _FormControlFeedback.default;
	FormControl.Static = _FormControlStatic.default;
	
	var _default = (0, _bootstrapUtils.bsClass)('form-control', (0, _bootstrapUtils.bsSizes)([_StyleConfig.Size.SMALL, _StyleConfig.Size.LARGE], FormControl));
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 1790 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(8));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _Glyphicon = _interopRequireDefault(__webpack_require__(308));
	
	var _bootstrapUtils = __webpack_require__(16);
	
	var defaultProps = {
	  bsRole: 'feedback'
	};
	var contextTypes = {
	  $bs_formGroup: _propTypes.default.object
	};
	
	var FormControlFeedback =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(FormControlFeedback, _React$Component);
	
	  function FormControlFeedback() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = FormControlFeedback.prototype;
	
	  _proto.getGlyph = function getGlyph(validationState) {
	    switch (validationState) {
	      case 'success':
	        return 'ok';
	
	      case 'warning':
	        return 'warning-sign';
	
	      case 'error':
	        return 'remove';
	
	      default:
	        return null;
	    }
	  };
	
	  _proto.renderDefaultFeedback = function renderDefaultFeedback(formGroup, className, classes, elementProps) {
	    var glyph = this.getGlyph(formGroup && formGroup.validationState);
	
	    if (!glyph) {
	      return null;
	    }
	
	    return _react.default.createElement(_Glyphicon.default, (0, _extends2.default)({}, elementProps, {
	      glyph: glyph,
	      className: (0, _classnames.default)(className, classes)
	    }));
	  };
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        className = _this$props.className,
	        children = _this$props.children,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["className", "children"]);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    if (!children) {
	      return this.renderDefaultFeedback(this.context.$bs_formGroup, className, classes, elementProps);
	    }
	
	    var child = _react.default.Children.only(children);
	
	    return _react.default.cloneElement(child, (0, _extends2.default)({}, elementProps, {
	      className: (0, _classnames.default)(child.props.className, className, classes)
	    }));
	  };
	
	  return FormControlFeedback;
	}(_react.default.Component);
	
	FormControlFeedback.defaultProps = defaultProps;
	FormControlFeedback.contextTypes = contextTypes;
	
	var _default = (0, _bootstrapUtils.bsClass)('form-control-feedback', FormControlFeedback);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 1791 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(8));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _elementType = _interopRequireDefault(__webpack_require__(32));
	
	var _bootstrapUtils = __webpack_require__(16);
	
	var propTypes = {
	  componentClass: _elementType.default
	};
	var defaultProps = {
	  componentClass: 'p'
	};
	
	var FormControlStatic =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(FormControlStatic, _React$Component);
	
	  function FormControlStatic() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = FormControlStatic.prototype;
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        Component = _this$props.componentClass,
	        className = _this$props.className,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["componentClass", "className"]);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	    return _react.default.createElement(Component, (0, _extends2.default)({}, elementProps, {
	      className: (0, _classnames.default)(className, classes)
	    }));
	  };
	
	  return FormControlStatic;
	}(_react.default.Component);
	
	FormControlStatic.propTypes = propTypes;
	FormControlStatic.defaultProps = defaultProps;
	
	var _default = (0, _bootstrapUtils.bsClass)('form-control-static', FormControlStatic);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 1792 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(8));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _bootstrapUtils = __webpack_require__(16);
	
	var _StyleConfig = __webpack_require__(50);
	
	var _ValidComponentChildren = _interopRequireDefault(__webpack_require__(58));
	
	var propTypes = {
	  /**
	   * Sets `id` on `<FormControl>` and `htmlFor` on `<FormGroup.Label>`.
	   */
	  controlId: _propTypes.default.string,
	  validationState: _propTypes.default.oneOf(['success', 'warning', 'error', null])
	};
	var childContextTypes = {
	  $bs_formGroup: _propTypes.default.object.isRequired
	};
	
	var FormGroup =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(FormGroup, _React$Component);
	
	  function FormGroup() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = FormGroup.prototype;
	
	  _proto.getChildContext = function getChildContext() {
	    var _this$props = this.props,
	        controlId = _this$props.controlId,
	        validationState = _this$props.validationState;
	    return {
	      $bs_formGroup: {
	        controlId: controlId,
	        validationState: validationState
	      }
	    };
	  };
	
	  _proto.hasFeedback = function hasFeedback(children) {
	    var _this = this;
	
	    return _ValidComponentChildren.default.some(children, function (child) {
	      return child.props.bsRole === 'feedback' || child.props.children && _this.hasFeedback(child.props.children);
	    });
	  };
	
	  _proto.render = function render() {
	    var _this$props2 = this.props,
	        validationState = _this$props2.validationState,
	        className = _this$props2.className,
	        children = _this$props2.children,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props2, ["validationState", "className", "children"]);
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['controlId']),
	        bsProps = _splitBsPropsAndOmit[0],
	        elementProps = _splitBsPropsAndOmit[1];
	
	    var classes = (0, _extends2.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	      'has-feedback': this.hasFeedback(children)
	    });
	
	    if (validationState) {
	      classes["has-" + validationState] = true;
	    }
	
	    return _react.default.createElement("div", (0, _extends2.default)({}, elementProps, {
	      className: (0, _classnames.default)(className, classes)
	    }), children);
	  };
	
	  return FormGroup;
	}(_react.default.Component);
	
	FormGroup.propTypes = propTypes;
	FormGroup.childContextTypes = childContextTypes;
	
	var _default = (0, _bootstrapUtils.bsClass)('form-group', (0, _bootstrapUtils.bsSizes)([_StyleConfig.Size.LARGE, _StyleConfig.Size.SMALL], FormGroup));
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 1793 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(8));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _bootstrapUtils = __webpack_require__(16);
	
	var HelpBlock =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(HelpBlock, _React$Component);
	
	  function HelpBlock() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = HelpBlock.prototype;
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        className = _this$props.className,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["className"]);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	    return _react.default.createElement("span", (0, _extends2.default)({}, elementProps, {
	      className: (0, _classnames.default)(className, classes)
	    }));
	  };
	
	  return HelpBlock;
	}(_react.default.Component);
	
	var _default = (0, _bootstrapUtils.bsClass)('help-block', HelpBlock);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 1794 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(8));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _bootstrapUtils = __webpack_require__(16);
	
	var propTypes = {
	  /**
	   * Sets image as responsive image
	   */
	  responsive: _propTypes.default.bool,
	
	  /**
	   * Sets image shape as rounded
	   */
	  rounded: _propTypes.default.bool,
	
	  /**
	   * Sets image shape as circle
	   */
	  circle: _propTypes.default.bool,
	
	  /**
	   * Sets image shape as thumbnail
	   */
	  thumbnail: _propTypes.default.bool
	};
	var defaultProps = {
	  responsive: false,
	  rounded: false,
	  circle: false,
	  thumbnail: false
	};
	
	var Image =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(Image, _React$Component);
	
	  function Image() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = Image.prototype;
	
	  _proto.render = function render() {
	    var _classes;
	
	    var _this$props = this.props,
	        responsive = _this$props.responsive,
	        rounded = _this$props.rounded,
	        circle = _this$props.circle,
	        thumbnail = _this$props.thumbnail,
	        className = _this$props.className,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["responsive", "rounded", "circle", "thumbnail", "className"]);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (_classes = {}, _classes[(0, _bootstrapUtils.prefix)(bsProps, 'responsive')] = responsive, _classes[(0, _bootstrapUtils.prefix)(bsProps, 'rounded')] = rounded, _classes[(0, _bootstrapUtils.prefix)(bsProps, 'circle')] = circle, _classes[(0, _bootstrapUtils.prefix)(bsProps, 'thumbnail')] = thumbnail, _classes);
	    return _react.default.createElement("img", (0, _extends2.default)({}, elementProps, {
	      className: (0, _classnames.default)(className, classes)
	    }));
	  };
	
	  return Image;
	}(_react.default.Component);
	
	Image.propTypes = propTypes;
	Image.defaultProps = defaultProps;
	
	var _default = (0, _bootstrapUtils.bsClass)('img', Image);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 1795 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(8));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _InputGroupAddon = _interopRequireDefault(__webpack_require__(1796));
	
	var _InputGroupButton = _interopRequireDefault(__webpack_require__(1797));
	
	var _bootstrapUtils = __webpack_require__(16);
	
	var _StyleConfig = __webpack_require__(50);
	
	var InputGroup =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(InputGroup, _React$Component);
	
	  function InputGroup() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = InputGroup.prototype;
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        className = _this$props.className,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["className"]);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	    return _react.default.createElement("span", (0, _extends2.default)({}, elementProps, {
	      className: (0, _classnames.default)(className, classes)
	    }));
	  };
	
	  return InputGroup;
	}(_react.default.Component);
	
	InputGroup.Addon = _InputGroupAddon.default;
	InputGroup.Button = _InputGroupButton.default;
	
	var _default = (0, _bootstrapUtils.bsClass)('input-group', (0, _bootstrapUtils.bsSizes)([_StyleConfig.Size.LARGE, _StyleConfig.Size.SMALL], InputGroup));
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 1796 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(8));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _bootstrapUtils = __webpack_require__(16);
	
	var InputGroupAddon =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(InputGroupAddon, _React$Component);
	
	  function InputGroupAddon() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = InputGroupAddon.prototype;
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        className = _this$props.className,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["className"]);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	    return _react.default.createElement("span", (0, _extends2.default)({}, elementProps, {
	      className: (0, _classnames.default)(className, classes)
	    }));
	  };
	
	  return InputGroupAddon;
	}(_react.default.Component);
	
	var _default = (0, _bootstrapUtils.bsClass)('input-group-addon', InputGroupAddon);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 1797 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(8));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _bootstrapUtils = __webpack_require__(16);
	
	var InputGroupButton =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(InputGroupButton, _React$Component);
	
	  function InputGroupButton() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = InputGroupButton.prototype;
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        className = _this$props.className,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["className"]);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	    return _react.default.createElement("span", (0, _extends2.default)({}, elementProps, {
	      className: (0, _classnames.default)(className, classes)
	    }));
	  };
	
	  return InputGroupButton;
	}(_react.default.Component);
	
	var _default = (0, _bootstrapUtils.bsClass)('input-group-btn', InputGroupButton);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 1798 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(8));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _elementType = _interopRequireDefault(__webpack_require__(32));
	
	var _bootstrapUtils = __webpack_require__(16);
	
	var propTypes = {
	  componentClass: _elementType.default
	};
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var Jumbotron =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(Jumbotron, _React$Component);
	
	  function Jumbotron() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = Jumbotron.prototype;
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        Component = _this$props.componentClass,
	        className = _this$props.className,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["componentClass", "className"]);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	    return _react.default.createElement(Component, (0, _extends2.default)({}, elementProps, {
	      className: (0, _classnames.default)(className, classes)
	    }));
	  };
	
	  return Jumbotron;
	}(_react.default.Component);
	
	Jumbotron.propTypes = propTypes;
	Jumbotron.defaultProps = defaultProps;
	
	var _default = (0, _bootstrapUtils.bsClass)('jumbotron', Jumbotron);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 1799 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _values = _interopRequireDefault(__webpack_require__(120));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(8));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _bootstrapUtils = __webpack_require__(16);
	
	var _StyleConfig = __webpack_require__(50);
	
	var Label =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(Label, _React$Component);
	
	  function Label() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = Label.prototype;
	
	  _proto.hasContent = function hasContent(children) {
	    var result = false;
	
	    _react.default.Children.forEach(children, function (child) {
	      if (result) {
	        return;
	      }
	
	      if (child || child === 0) {
	        result = true;
	      }
	    });
	
	    return result;
	  };
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        className = _this$props.className,
	        children = _this$props.children,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["className", "children"]);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends2.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	      // Hack for collapsing on IE8.
	      hidden: !this.hasContent(children)
	    });
	    return _react.default.createElement("span", (0, _extends2.default)({}, elementProps, {
	      className: (0, _classnames.default)(className, classes)
	    }), children);
	  };
	
	  return Label;
	}(_react.default.Component);
	
	var _default = (0, _bootstrapUtils.bsClass)('label', (0, _bootstrapUtils.bsStyles)((0, _values.default)(_StyleConfig.State).concat([_StyleConfig.Style.DEFAULT, _StyleConfig.Style.PRIMARY]), _StyleConfig.Style.DEFAULT, Label));
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 1800 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(47);
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(8));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _elementType = _interopRequireDefault(__webpack_require__(32));
	
	var _ListGroupItem = _interopRequireDefault(__webpack_require__(503));
	
	var _bootstrapUtils = __webpack_require__(16);
	
	var _ValidComponentChildren = _interopRequireDefault(__webpack_require__(58));
	
	var propTypes = {
	  /**
	   * You can use a custom element type for this component.
	   *
	   * If not specified, it will be treated as `'li'` if every child is a
	   * non-actionable `<ListGroupItem>`, and `'div'` otherwise.
	   */
	  componentClass: _elementType.default
	};
	
	function getDefaultComponent(children) {
	  if (!children) {
	    // FIXME: This is the old behavior. Is this right?
	    return 'div';
	  }
	
	  if (_ValidComponentChildren.default.some(children, function (child) {
	    return child.type !== _ListGroupItem.default || child.props.href || child.props.onClick;
	  })) {
	    return 'div';
	  }
	
	  return 'ul';
	}
	
	var ListGroup =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(ListGroup, _React$Component);
	
	  function ListGroup() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = ListGroup.prototype;
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        children = _this$props.children,
	        _this$props$component = _this$props.componentClass,
	        Component = _this$props$component === void 0 ? getDefaultComponent(children) : _this$props$component,
	        className = _this$props.className,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["children", "componentClass", "className"]);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    var useListItem = Component === 'ul' && _ValidComponentChildren.default.every(children, function (child) {
	      return child.type === _ListGroupItem.default;
	    });
	
	    return _react.default.createElement(Component, (0, _extends2.default)({}, elementProps, {
	      className: (0, _classnames.default)(className, classes)
	    }), useListItem ? _ValidComponentChildren.default.map(children, function (child) {
	      return (0, _react.cloneElement)(child, {
	        listItem: true
	      });
	    }) : children);
	  };
	
	  return ListGroup;
	}(_react.default.Component);
	
	ListGroup.propTypes = propTypes;
	
	var _default = (0, _bootstrapUtils.bsClass)('list-group', ListGroup);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 1801 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(8));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _elementType = _interopRequireDefault(__webpack_require__(32));
	
	var _Media = _interopRequireDefault(__webpack_require__(218));
	
	var _bootstrapUtils = __webpack_require__(16);
	
	var propTypes = {
	  /**
	   * Align the media to the top, middle, or bottom of the media object.
	   */
	  align: _propTypes.default.oneOf(['top', 'middle', 'bottom']),
	  componentClass: _elementType.default
	};
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var MediaBody =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(MediaBody, _React$Component);
	
	  function MediaBody() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = MediaBody.prototype;
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        Component = _this$props.componentClass,
	        align = _this$props.align,
	        className = _this$props.className,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["componentClass", "align", "className"]);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    if (align) {
	      // The class is e.g. `media-top`, not `media-left-top`.
	      classes[(0, _bootstrapUtils.prefix)(_Media.default.defaultProps, align)] = true;
	    }
	
	    return _react.default.createElement(Component, (0, _extends2.default)({}, elementProps, {
	      className: (0, _classnames.default)(className, classes)
	    }));
	  };
	
	  return MediaBody;
	}(_react.default.Component);
	
	MediaBody.propTypes = propTypes;
	MediaBody.defaultProps = defaultProps;
	
	var _default = (0, _bootstrapUtils.bsClass)('media-body', MediaBody);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 1802 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(8));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _elementType = _interopRequireDefault(__webpack_require__(32));
	
	var _bootstrapUtils = __webpack_require__(16);
	
	var propTypes = {
	  componentClass: _elementType.default
	};
	var defaultProps = {
	  componentClass: 'h4'
	};
	
	var MediaHeading =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(MediaHeading, _React$Component);
	
	  function MediaHeading() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = MediaHeading.prototype;
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        Component = _this$props.componentClass,
	        className = _this$props.className,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["componentClass", "className"]);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	    return _react.default.createElement(Component, (0, _extends2.default)({}, elementProps, {
	      className: (0, _classnames.default)(className, classes)
	    }));
	  };
	
	  return MediaHeading;
	}(_react.default.Component);
	
	MediaHeading.propTypes = propTypes;
	MediaHeading.defaultProps = defaultProps;
	
	var _default = (0, _bootstrapUtils.bsClass)('media-heading', MediaHeading);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 1803 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(8));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _Media = _interopRequireDefault(__webpack_require__(218));
	
	var _bootstrapUtils = __webpack_require__(16);
	
	var propTypes = {
	  /**
	   * Align the media to the top, middle, or bottom of the media object.
	   */
	  align: _propTypes.default.oneOf(['top', 'middle', 'bottom'])
	};
	
	var MediaLeft =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(MediaLeft, _React$Component);
	
	  function MediaLeft() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = MediaLeft.prototype;
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        align = _this$props.align,
	        className = _this$props.className,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["align", "className"]);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    if (align) {
	      // The class is e.g. `media-top`, not `media-left-top`.
	      classes[(0, _bootstrapUtils.prefix)(_Media.default.defaultProps, align)] = true;
	    }
	
	    return _react.default.createElement("div", (0, _extends2.default)({}, elementProps, {
	      className: (0, _classnames.default)(className, classes)
	    }));
	  };
	
	  return MediaLeft;
	}(_react.default.Component);
	
	MediaLeft.propTypes = propTypes;
	
	var _default = (0, _bootstrapUtils.bsClass)('media-left', MediaLeft);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 1804 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(8));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _bootstrapUtils = __webpack_require__(16);
	
	var MediaList =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(MediaList, _React$Component);
	
	  function MediaList() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = MediaList.prototype;
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        className = _this$props.className,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["className"]);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	    return _react.default.createElement("ul", (0, _extends2.default)({}, elementProps, {
	      className: (0, _classnames.default)(className, classes)
	    }));
	  };
	
	  return MediaList;
	}(_react.default.Component);
	
	var _default = (0, _bootstrapUtils.bsClass)('media-list', MediaList);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 1805 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(8));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _bootstrapUtils = __webpack_require__(16);
	
	var MediaListItem =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(MediaListItem, _React$Component);
	
	  function MediaListItem() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = MediaListItem.prototype;
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        className = _this$props.className,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["className"]);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	    return _react.default.createElement("li", (0, _extends2.default)({}, elementProps, {
	      className: (0, _classnames.default)(className, classes)
	    }));
	  };
	
	  return MediaListItem;
	}(_react.default.Component);
	
	var _default = (0, _bootstrapUtils.bsClass)('media', MediaListItem);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 1806 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(8));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _Media = _interopRequireDefault(__webpack_require__(218));
	
	var _bootstrapUtils = __webpack_require__(16);
	
	var propTypes = {
	  /**
	   * Align the media to the top, middle, or bottom of the media object.
	   */
	  align: _propTypes.default.oneOf(['top', 'middle', 'bottom'])
	};
	
	var MediaRight =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(MediaRight, _React$Component);
	
	  function MediaRight() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = MediaRight.prototype;
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        align = _this$props.align,
	        className = _this$props.className,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["align", "className"]);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    if (align) {
	      // The class is e.g. `media-top`, not `media-right-top`.
	      classes[(0, _bootstrapUtils.prefix)(_Media.default.defaultProps, align)] = true;
	    }
	
	    return _react.default.createElement("div", (0, _extends2.default)({}, elementProps, {
	      className: (0, _classnames.default)(className, classes)
	    }));
	  };
	
	  return MediaRight;
	}(_react.default.Component);
	
	MediaRight.propTypes = propTypes;
	
	var _default = (0, _bootstrapUtils.bsClass)('media-right', MediaRight);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 1807 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(57));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(8));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _events = _interopRequireDefault(__webpack_require__(1581));
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(129));
	
	var _inDOM = _interopRequireDefault(__webpack_require__(84));
	
	var _scrollbarSize = _interopRequireDefault(__webpack_require__(460));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(46));
	
	var _Modal = _interopRequireDefault(__webpack_require__(1856));
	
	var _isOverflowing = _interopRequireDefault(__webpack_require__(527));
	
	var _elementType = _interopRequireDefault(__webpack_require__(32));
	
	var _Fade = _interopRequireDefault(__webpack_require__(217));
	
	var _ModalBody = _interopRequireDefault(__webpack_require__(505));
	
	var _ModalDialog = _interopRequireDefault(__webpack_require__(506));
	
	var _ModalFooter = _interopRequireDefault(__webpack_require__(507));
	
	var _ModalHeader = _interopRequireDefault(__webpack_require__(508));
	
	var _ModalTitle = _interopRequireDefault(__webpack_require__(509));
	
	var _bootstrapUtils = __webpack_require__(16);
	
	var _createChainedFunction = _interopRequireDefault(__webpack_require__(45));
	
	var _splitComponentProps2 = _interopRequireDefault(__webpack_require__(219));
	
	var _StyleConfig = __webpack_require__(50);
	
	var propTypes = (0, _extends2.default)({}, _Modal.default.propTypes, _ModalDialog.default.propTypes, {
	  /**
	   * Include a backdrop component. Specify 'static' for a backdrop that doesn't
	   * trigger an "onHide" when clicked.
	   */
	  backdrop: _propTypes.default.oneOf(['static', true, false]),
	
	  /**
	   * Add an optional extra class name to .modal-backdrop
	   * It could end up looking like class="modal-backdrop foo-modal-backdrop in".
	   */
	  backdropClassName: _propTypes.default.string,
	
	  /**
	   * Close the modal when escape key is pressed
	   */
	  keyboard: _propTypes.default.bool,
	
	  /**
	   * Open and close the Modal with a slide and fade animation.
	   */
	  animation: _propTypes.default.bool,
	
	  /**
	   * A Component type that provides the modal content Markup. This is a useful
	   * prop when you want to use your own styles and markup to create a custom
	   * modal component.
	   */
	  dialogComponentClass: _elementType.default,
	
	  /**
	   * When `true` The modal will automatically shift focus to itself when it
	   * opens, and replace it to the last focused element when it closes.
	   * Generally this should never be set to false as it makes the Modal less
	   * accessible to assistive technologies, like screen-readers.
	   */
	  autoFocus: _propTypes.default.bool,
	
	  /**
	   * When `true` The modal will prevent focus from leaving the Modal while
	   * open. Consider leaving the default value here, as it is necessary to make
	   * the Modal work well with assistive technologies, such as screen readers.
	   */
	  enforceFocus: _propTypes.default.bool,
	
	  /**
	   * When `true` The modal will restore focus to previously focused element once
	   * modal is hidden
	   */
	  restoreFocus: _propTypes.default.bool,
	
	  /**
	   * When `true` The modal will show itself.
	   */
	  show: _propTypes.default.bool,
	
	  /**
	   * A callback fired when the header closeButton or non-static backdrop is
	   * clicked. Required if either are specified.
	   */
	  onHide: _propTypes.default.func,
	
	  /**
	   * Callback fired before the Modal transitions in
	   */
	  onEnter: _propTypes.default.func,
	
	  /**
	   * Callback fired as the Modal begins to transition in
	   */
	  onEntering: _propTypes.default.func,
	
	  /**
	   * Callback fired after the Modal finishes transitioning in
	   */
	  onEntered: _propTypes.default.func,
	
	  /**
	   * Callback fired right before the Modal transitions out
	   */
	  onExit: _propTypes.default.func,
	
	  /**
	   * Callback fired as the Modal begins to transition out
	   */
	  onExiting: _propTypes.default.func,
	
	  /**
	   * Callback fired after the Modal finishes transitioning out
	   */
	  onExited: _propTypes.default.func,
	
	  /**
	   * @private
	   */
	  container: _Modal.default.propTypes.container
	});
	var defaultProps = (0, _extends2.default)({}, _Modal.default.defaultProps, {
	  animation: true,
	  dialogComponentClass: _ModalDialog.default
	});
	var childContextTypes = {
	  $bs_modal: _propTypes.default.shape({
	    onHide: _propTypes.default.func
	  })
	};
	/* eslint-disable no-use-before-define, react/no-multi-comp */
	
	function DialogTransition(props) {
	  return _react.default.createElement(_Fade.default, (0, _extends2.default)({}, props, {
	    timeout: Modal.TRANSITION_DURATION
	  }));
	}
	
	function BackdropTransition(props) {
	  return _react.default.createElement(_Fade.default, (0, _extends2.default)({}, props, {
	    timeout: Modal.BACKDROP_TRANSITION_DURATION
	  }));
	}
	/* eslint-enable no-use-before-define */
	
	
	var Modal =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(Modal, _React$Component);
	
	  function Modal(props, context) {
	    var _this;
	
	    _this = _React$Component.call(this, props, context) || this;
	
	    _this.handleDialogBackdropMouseDown = function () {
	      _this._waitingForMouseUp = true;
	    };
	
	    _this.handleMouseUp = function (ev) {
	      var dialogNode = _this._modal.getDialogElement();
	
	      if (_this._waitingForMouseUp && ev.target === dialogNode) {
	        _this._ignoreBackdropClick = true;
	      }
	
	      _this._waitingForMouseUp = false;
	    };
	
	    _this.handleEntering = _this.handleEntering.bind((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
	    _this.handleExited = _this.handleExited.bind((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
	    _this.handleWindowResize = _this.handleWindowResize.bind((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
	    _this.handleDialogClick = _this.handleDialogClick.bind((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
	    _this.setModalRef = _this.setModalRef.bind((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
	    _this.state = {
	      style: {}
	    };
	    return _this;
	  }
	
	  var _proto = Modal.prototype;
	
	  _proto.getChildContext = function getChildContext() {
	    return {
	      $bs_modal: {
	        onHide: this.props.onHide
	      }
	    };
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    // Clean up the listener if we need to.
	    this.handleExited();
	  };
	
	  _proto.setModalRef = function setModalRef(ref) {
	    this._modal = ref;
	  };
	
	  _proto.handleDialogClick = function handleDialogClick(e) {
	    if (this._ignoreBackdropClick || e.target !== e.currentTarget) {
	      this._ignoreBackdropClick = false;
	      return;
	    }
	
	    this.props.onHide();
	  };
	
	  _proto.handleEntering = function handleEntering() {
	    // FIXME: This should work even when animation is disabled.
	    _events.default.on(window, 'resize', this.handleWindowResize);
	
	    this.updateStyle();
	  };
	
	  _proto.handleExited = function handleExited() {
	    // FIXME: This should work even when animation is disabled.
	    _events.default.off(window, 'resize', this.handleWindowResize);
	  };
	
	  _proto.handleWindowResize = function handleWindowResize() {
	    this.updateStyle();
	  };
	
	  _proto.updateStyle = function updateStyle() {
	    if (!_inDOM.default) {
	      return;
	    }
	
	    var dialogNode = this._modal.getDialogElement();
	
	    var dialogHeight = dialogNode.scrollHeight;
	    var document = (0, _ownerDocument.default)(dialogNode);
	    var bodyIsOverflowing = (0, _isOverflowing.default)(_reactDom.default.findDOMNode(this.props.container || document.body));
	    var modalIsOverflowing = dialogHeight > document.documentElement.clientHeight;
	    this.setState({
	      style: {
	        paddingRight: bodyIsOverflowing && !modalIsOverflowing ? (0, _scrollbarSize.default)() : undefined,
	        paddingLeft: !bodyIsOverflowing && modalIsOverflowing ? (0, _scrollbarSize.default)() : undefined
	      }
	    });
	  };
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        backdrop = _this$props.backdrop,
	        backdropClassName = _this$props.backdropClassName,
	        animation = _this$props.animation,
	        show = _this$props.show,
	        Dialog = _this$props.dialogComponentClass,
	        className = _this$props.className,
	        style = _this$props.style,
	        children = _this$props.children,
	        onEntering = _this$props.onEntering,
	        onExited = _this$props.onExited,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["backdrop", "backdropClassName", "animation", "show", "dialogComponentClass", "className", "style", "children", "onEntering", "onExited"]);
	
	    var _splitComponentProps = (0, _splitComponentProps2.default)(props, _Modal.default),
	        baseModalProps = _splitComponentProps[0],
	        dialogProps = _splitComponentProps[1];
	
	    var inClassName = show && !animation && 'in';
	    return _react.default.createElement(_Modal.default, (0, _extends2.default)({}, baseModalProps, {
	      ref: this.setModalRef,
	      show: show,
	      containerClassName: (0, _bootstrapUtils.prefix)(props, 'open'),
	      transition: animation ? DialogTransition : undefined,
	      backdrop: backdrop,
	      backdropTransition: animation ? BackdropTransition : undefined,
	      backdropClassName: (0, _classnames.default)((0, _bootstrapUtils.prefix)(props, 'backdrop'), backdropClassName, inClassName),
	      onEntering: (0, _createChainedFunction.default)(onEntering, this.handleEntering),
	      onExited: (0, _createChainedFunction.default)(onExited, this.handleExited),
	      onMouseUp: this.handleMouseUp
	    }), _react.default.createElement(Dialog, (0, _extends2.default)({}, dialogProps, {
	      style: (0, _extends2.default)({}, this.state.style, style),
	      className: (0, _classnames.default)(className, inClassName),
	      onClick: backdrop === true ? this.handleDialogClick : null,
	      onMouseDownDialog: this.handleDialogBackdropMouseDown
	    }), children));
	  };
	
	  return Modal;
	}(_react.default.Component);
	
	Modal.propTypes = propTypes;
	Modal.defaultProps = defaultProps;
	Modal.childContextTypes = childContextTypes;
	Modal.Body = _ModalBody.default;
	Modal.Header = _ModalHeader.default;
	Modal.Title = _ModalTitle.default;
	Modal.Footer = _ModalFooter.default;
	Modal.Dialog = _ModalDialog.default;
	Modal.TRANSITION_DURATION = 300;
	Modal.BACKDROP_TRANSITION_DURATION = 150;
	
	var _default = (0, _bootstrapUtils.bsClass)('modal', (0, _bootstrapUtils.bsSizes)([_StyleConfig.Size.LARGE, _StyleConfig.Size.SMALL], Modal));
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 1808 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(8));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _Dropdown = _interopRequireDefault(__webpack_require__(216));
	
	var _splitComponentProps2 = _interopRequireDefault(__webpack_require__(219));
	
	var _ValidComponentChildren = _interopRequireDefault(__webpack_require__(58));
	
	var propTypes = (0, _extends2.default)({}, _Dropdown.default.propTypes, {
	  // Toggle props.
	  title: _propTypes.default.node.isRequired,
	  noCaret: _propTypes.default.bool,
	  active: _propTypes.default.bool,
	  activeKey: _propTypes.default.any,
	  activeHref: _propTypes.default.string,
	  // Override generated docs from <Dropdown>.
	
	  /**
	   * @private
	   */
	  children: _propTypes.default.node
	});
	
	var NavDropdown =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(NavDropdown, _React$Component);
	
	  function NavDropdown() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = NavDropdown.prototype;
	
	  _proto.isActive = function isActive(_ref, activeKey, activeHref) {
	    var _this = this;
	
	    var props = _ref.props;
	
	    if (props.active || activeKey != null && props.eventKey === activeKey || activeHref && props.href === activeHref) {
	      return true;
	    }
	
	    if (_ValidComponentChildren.default.some(props.children, function (child) {
	      return _this.isActive(child, activeKey, activeHref);
	    })) {
	      return true;
	    }
	
	    return props.active;
	  };
	
	  _proto.render = function render() {
	    var _this2 = this;
	
	    var _this$props = this.props,
	        title = _this$props.title,
	        activeKey = _this$props.activeKey,
	        activeHref = _this$props.activeHref,
	        className = _this$props.className,
	        style = _this$props.style,
	        children = _this$props.children,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["title", "activeKey", "activeHref", "className", "style", "children"]);
	    var active = this.isActive(this, activeKey, activeHref);
	    delete props.active; // Accessed via this.isActive().
	
	    delete props.eventKey; // Accessed via this.isActive().
	
	    var _splitComponentProps = (0, _splitComponentProps2.default)(props, _Dropdown.default.ControlledComponent),
	        dropdownProps = _splitComponentProps[0],
	        toggleProps = _splitComponentProps[1]; // Unlike for the other dropdowns, styling needs to go to the `<Dropdown>`
	    // rather than the `<Dropdown.Toggle>`.
	
	
	    return _react.default.createElement(_Dropdown.default, (0, _extends2.default)({}, dropdownProps, {
	      componentClass: "li",
	      className: (0, _classnames.default)(className, {
	        active: active
	      }),
	      style: style
	    }), _react.default.createElement(_Dropdown.default.Toggle, (0, _extends2.default)({}, toggleProps, {
	      useAnchor: true
	    }), title), _react.default.createElement(_Dropdown.default.Menu, null, _ValidComponentChildren.default.map(children, function (child) {
	      return _react.default.cloneElement(child, {
	        active: _this2.isActive(child, activeKey, activeHref)
	      });
	    })));
	  };
	
	  return NavDropdown;
	}(_react.default.Component);
	
	NavDropdown.propTypes = propTypes;
	var _default = NavDropdown;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 1809 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends3 = _interopRequireDefault(__webpack_require__(8));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(57));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _elementType = _interopRequireDefault(__webpack_require__(32));
	
	var _uncontrollable = __webpack_require__(119);
	
	var _Grid = _interopRequireDefault(__webpack_require__(502));
	
	var _NavbarBrand = _interopRequireDefault(__webpack_require__(512));
	
	var _NavbarCollapse = _interopRequireDefault(__webpack_require__(1810));
	
	var _NavbarHeader = _interopRequireDefault(__webpack_require__(1811));
	
	var _NavbarToggle = _interopRequireDefault(__webpack_require__(1812));
	
	var _bootstrapUtils = __webpack_require__(16);
	
	var _StyleConfig = __webpack_require__(50);
	
	var _createChainedFunction = _interopRequireDefault(__webpack_require__(45));
	
	// TODO: Remove this pragma once we upgrade eslint-config-airbnb.
	
	/* eslint-disable react/no-multi-comp */
	var propTypes = {
	  /**
	   * Create a fixed navbar along the top of the screen, that scrolls with the
	   * page
	   */
	  fixedTop: _propTypes.default.bool,
	
	  /**
	   * Create a fixed navbar along the bottom of the screen, that scrolls with
	   * the page
	   */
	  fixedBottom: _propTypes.default.bool,
	
	  /**
	   * Create a full-width navbar that scrolls away with the page
	   */
	  staticTop: _propTypes.default.bool,
	
	  /**
	   * An alternative dark visual style for the Navbar
	   */
	  inverse: _propTypes.default.bool,
	
	  /**
	   * Allow the Navbar to fluidly adjust to the page or container width, instead
	   * of at the predefined screen breakpoints
	   */
	  fluid: _propTypes.default.bool,
	
	  /**
	   * Set a custom element for this component.
	   */
	  componentClass: _elementType.default,
	
	  /**
	   * A callback fired when the `<Navbar>` body collapses or expands. Fired when
	   * a `<Navbar.Toggle>` is clicked and called with the new `expanded`
	   * boolean value.
	   *
	   * @controllable expanded
	   */
	  onToggle: _propTypes.default.func,
	
	  /**
	   * A callback fired when a descendant of a child `<Nav>` is selected. Should
	   * be used to execute complex closing or other miscellaneous actions desired
	   * after selecting a descendant of `<Nav>`. Does nothing if no `<Nav>` or `<Nav>`
	   * descendants exist. The callback is called with an eventKey, which is a
	   * prop from the selected `<Nav>` descendant, and an event.
	   *
	   * ```js
	   * function (
	   *  Any eventKey,
	   *  SyntheticEvent event?
	   * )
	   * ```
	   *
	   * For basic closing behavior after all `<Nav>` descendant onSelect events in
	   * mobile viewports, try using collapseOnSelect.
	   *
	   * Note: If you are manually closing the navbar using this `OnSelect` prop,
	   * ensure that you are setting `expanded` to false and not *toggling* between
	   * true and false.
	   */
	  onSelect: _propTypes.default.func,
	
	  /**
	   * Sets `expanded` to `false` after the onSelect event of a descendant of a
	   * child `<Nav>`. Does nothing if no `<Nav>` or `<Nav>` descendants exist.
	   *
	   * The onSelect callback should be used instead for more complex operations
	   * that need to be executed after the `select` event of `<Nav>` descendants.
	   */
	  collapseOnSelect: _propTypes.default.bool,
	
	  /**
	   * Explicitly set the visiblity of the navbar body
	   *
	   * @controllable onToggle
	   */
	  expanded: _propTypes.default.bool,
	  role: _propTypes.default.string
	};
	var defaultProps = {
	  componentClass: 'nav',
	  fixedTop: false,
	  fixedBottom: false,
	  staticTop: false,
	  inverse: false,
	  fluid: false,
	  collapseOnSelect: false
	};
	var childContextTypes = {
	  $bs_navbar: _propTypes.default.shape({
	    bsClass: _propTypes.default.string,
	    expanded: _propTypes.default.bool,
	    onToggle: _propTypes.default.func.isRequired,
	    onSelect: _propTypes.default.func
	  })
	};
	
	var Navbar =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(Navbar, _React$Component);
	
	  function Navbar(props, context) {
	    var _this;
	
	    _this = _React$Component.call(this, props, context) || this;
	    _this.handleToggle = _this.handleToggle.bind((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
	    _this.handleCollapse = _this.handleCollapse.bind((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
	    return _this;
	  }
	
	  var _proto = Navbar.prototype;
	
	  _proto.getChildContext = function getChildContext() {
	    var _this$props = this.props,
	        bsClass = _this$props.bsClass,
	        expanded = _this$props.expanded,
	        onSelect = _this$props.onSelect,
	        collapseOnSelect = _this$props.collapseOnSelect;
	    return {
	      $bs_navbar: {
	        bsClass: bsClass,
	        expanded: expanded,
	        onToggle: this.handleToggle,
	        onSelect: (0, _createChainedFunction.default)(onSelect, collapseOnSelect ? this.handleCollapse : null)
	      }
	    };
	  };
	
	  _proto.handleCollapse = function handleCollapse() {
	    var _this$props2 = this.props,
	        onToggle = _this$props2.onToggle,
	        expanded = _this$props2.expanded;
	
	    if (expanded) {
	      onToggle(false);
	    }
	  };
	
	  _proto.handleToggle = function handleToggle() {
	    var _this$props3 = this.props,
	        onToggle = _this$props3.onToggle,
	        expanded = _this$props3.expanded;
	    onToggle(!expanded);
	  };
	
	  _proto.render = function render() {
	    var _extends2;
	
	    var _this$props4 = this.props,
	        Component = _this$props4.componentClass,
	        fixedTop = _this$props4.fixedTop,
	        fixedBottom = _this$props4.fixedBottom,
	        staticTop = _this$props4.staticTop,
	        inverse = _this$props4.inverse,
	        fluid = _this$props4.fluid,
	        className = _this$props4.className,
	        children = _this$props4.children,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props4, ["componentClass", "fixedTop", "fixedBottom", "staticTop", "inverse", "fluid", "className", "children"]);
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['expanded', 'onToggle', 'onSelect', 'collapseOnSelect']),
	        bsProps = _splitBsPropsAndOmit[0],
	        elementProps = _splitBsPropsAndOmit[1]; // will result in some false positives but that seems better
	    // than false negatives. strict `undefined` check allows explicit
	    // "nulling" of the role if the user really doesn't want one
	
	
	    if (elementProps.role === undefined && Component !== 'nav') {
	      elementProps.role = 'navigation';
	    }
	
	    if (inverse) {
	      bsProps.bsStyle = _StyleConfig.Style.INVERSE;
	    }
	
	    var classes = (0, _extends3.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'fixed-top')] = fixedTop, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'fixed-bottom')] = fixedBottom, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'static-top')] = staticTop, _extends2));
	    return _react.default.createElement(Component, (0, _extends3.default)({}, elementProps, {
	      className: (0, _classnames.default)(className, classes)
	    }), _react.default.createElement(_Grid.default, {
	      fluid: fluid
	    }, children));
	  };
	
	  return Navbar;
	}(_react.default.Component);
	
	Navbar.propTypes = propTypes;
	Navbar.defaultProps = defaultProps;
	Navbar.childContextTypes = childContextTypes;
	(0, _bootstrapUtils.bsClass)('navbar', Navbar);
	var UncontrollableNavbar = (0, _uncontrollable.uncontrollable)(Navbar, {
	  expanded: 'onToggle'
	});
	
	function createSimpleWrapper(tag, suffix, displayName) {
	  var Wrapper = function Wrapper(_ref, _ref2) {
	    var Component = _ref.componentClass,
	        className = _ref.className,
	        pullRight = _ref.pullRight,
	        pullLeft = _ref.pullLeft,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_ref, ["componentClass", "className", "pullRight", "pullLeft"]);
	    var _ref2$$bs_navbar = _ref2.$bs_navbar,
	        navbarProps = _ref2$$bs_navbar === void 0 ? {
	      bsClass: 'navbar'
	    } : _ref2$$bs_navbar;
	    return _react.default.createElement(Component, (0, _extends3.default)({}, props, {
	      className: (0, _classnames.default)(className, (0, _bootstrapUtils.prefix)(navbarProps, suffix), pullRight && (0, _bootstrapUtils.prefix)(navbarProps, 'right'), pullLeft && (0, _bootstrapUtils.prefix)(navbarProps, 'left'))
	    }));
	  };
	
	  Wrapper.displayName = displayName;
	  Wrapper.propTypes = {
	    componentClass: _elementType.default,
	    pullRight: _propTypes.default.bool,
	    pullLeft: _propTypes.default.bool
	  };
	  Wrapper.defaultProps = {
	    componentClass: tag,
	    pullRight: false,
	    pullLeft: false
	  };
	  Wrapper.contextTypes = {
	    $bs_navbar: _propTypes.default.shape({
	      bsClass: _propTypes.default.string
	    })
	  };
	  return Wrapper;
	}
	
	UncontrollableNavbar.Brand = _NavbarBrand.default;
	UncontrollableNavbar.Header = _NavbarHeader.default;
	UncontrollableNavbar.Toggle = _NavbarToggle.default;
	UncontrollableNavbar.Collapse = _NavbarCollapse.default;
	UncontrollableNavbar.Form = createSimpleWrapper('div', 'form', 'NavbarForm');
	UncontrollableNavbar.Text = createSimpleWrapper('p', 'text', 'NavbarText');
	UncontrollableNavbar.Link = createSimpleWrapper('a', 'link', 'NavbarLink'); // Set bsStyles here so they can be overridden.
	
	var _default = (0, _bootstrapUtils.bsStyles)([_StyleConfig.Style.DEFAULT, _StyleConfig.Style.INVERSE], _StyleConfig.Style.DEFAULT)(UncontrollableNavbar);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 1810 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(8));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _Collapse = _interopRequireDefault(__webpack_require__(307));
	
	var _bootstrapUtils = __webpack_require__(16);
	
	var contextTypes = {
	  $bs_navbar: _propTypes.default.shape({
	    bsClass: _propTypes.default.string,
	    expanded: _propTypes.default.bool
	  })
	};
	
	var NavbarCollapse =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(NavbarCollapse, _React$Component);
	
	  function NavbarCollapse() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = NavbarCollapse.prototype;
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        children = _this$props.children,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["children"]);
	    var navbarProps = this.context.$bs_navbar || {
	      bsClass: 'navbar'
	    };
	    var bsClassName = (0, _bootstrapUtils.prefix)(navbarProps, 'collapse');
	    return _react.default.createElement(_Collapse.default, (0, _extends2.default)({
	      in: navbarProps.expanded
	    }, props), _react.default.createElement("div", {
	      className: bsClassName
	    }, children));
	  };
	
	  return NavbarCollapse;
	}(_react.default.Component);
	
	NavbarCollapse.contextTypes = contextTypes;
	var _default = NavbarCollapse;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 1811 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(8));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _bootstrapUtils = __webpack_require__(16);
	
	var contextTypes = {
	  $bs_navbar: _propTypes.default.shape({
	    bsClass: _propTypes.default.string
	  })
	};
	
	var NavbarHeader =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(NavbarHeader, _React$Component);
	
	  function NavbarHeader() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = NavbarHeader.prototype;
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        className = _this$props.className,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["className"]);
	    var navbarProps = this.context.$bs_navbar || {
	      bsClass: 'navbar'
	    };
	    var bsClassName = (0, _bootstrapUtils.prefix)(navbarProps, 'header');
	    return _react.default.createElement("div", (0, _extends2.default)({}, props, {
	      className: (0, _classnames.default)(className, bsClassName)
	    }));
	  };
	
	  return NavbarHeader;
	}(_react.default.Component);
	
	NavbarHeader.contextTypes = contextTypes;
	var _default = NavbarHeader;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 1812 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(8));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _bootstrapUtils = __webpack_require__(16);
	
	var _createChainedFunction = _interopRequireDefault(__webpack_require__(45));
	
	var propTypes = {
	  onClick: _propTypes.default.func,
	
	  /**
	   * The toggle content, if left empty it will render the default toggle (seen above).
	   */
	  children: _propTypes.default.node
	};
	var contextTypes = {
	  $bs_navbar: _propTypes.default.shape({
	    bsClass: _propTypes.default.string,
	    expanded: _propTypes.default.bool,
	    onToggle: _propTypes.default.func.isRequired
	  })
	};
	
	var NavbarToggle =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(NavbarToggle, _React$Component);
	
	  function NavbarToggle() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = NavbarToggle.prototype;
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        onClick = _this$props.onClick,
	        className = _this$props.className,
	        children = _this$props.children,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["onClick", "className", "children"]);
	    var navbarProps = this.context.$bs_navbar || {
	      bsClass: 'navbar'
	    };
	    var buttonProps = (0, _extends2.default)({
	      type: 'button'
	    }, props, {
	      onClick: (0, _createChainedFunction.default)(onClick, navbarProps.onToggle),
	      className: (0, _classnames.default)(className, (0, _bootstrapUtils.prefix)(navbarProps, 'toggle'), !navbarProps.expanded && 'collapsed')
	    });
	
	    if (children) {
	      return _react.default.createElement("button", buttonProps, children);
	    }
	
	    return _react.default.createElement("button", buttonProps, _react.default.createElement("span", {
	      className: "sr-only"
	    }, "Toggle navigation"), _react.default.createElement("span", {
	      className: "icon-bar"
	    }), _react.default.createElement("span", {
	      className: "icon-bar"
	    }), _react.default.createElement("span", {
	      className: "icon-bar"
	    }));
	  };
	
	  return NavbarToggle;
	}(_react.default.Component);
	
	NavbarToggle.propTypes = propTypes;
	NavbarToggle.contextTypes = contextTypes;
	var _default = NavbarToggle;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 1813 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(47);
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(57));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(8));
	
	var _isArray = _interopRequireDefault(__webpack_require__(612));
	
	var _contains = _interopRequireDefault(__webpack_require__(130));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(46));
	
	var _warning = _interopRequireDefault(__webpack_require__(59));
	
	var _Overlay = _interopRequireDefault(__webpack_require__(513));
	
	var _createChainedFunction = _interopRequireDefault(__webpack_require__(45));
	
	/**
	 * Check if value one is inside or equal to the of value
	 *
	 * @param {string} one
	 * @param {string|array} of
	 * @returns {boolean}
	 */
	function isOneOf(one, of) {
	  if ((0, _isArray.default)(of)) {
	    return of.indexOf(one) >= 0;
	  }
	
	  return one === of;
	}
	
	var triggerType = _propTypes.default.oneOf(['click', 'hover', 'focus']);
	
	var propTypes = (0, _extends2.default)({}, _Overlay.default.propTypes, {
	  /**
	   * Specify which action or actions trigger Overlay visibility
	   */
	  trigger: _propTypes.default.oneOfType([triggerType, _propTypes.default.arrayOf(triggerType)]),
	
	  /**
	   * A millisecond delay amount to show and hide the Overlay once triggered
	   */
	  delay: _propTypes.default.number,
	
	  /**
	   * A millisecond delay amount before showing the Overlay once triggered.
	   */
	  delayShow: _propTypes.default.number,
	
	  /**
	   * A millisecond delay amount before hiding the Overlay once triggered.
	   */
	  delayHide: _propTypes.default.number,
	  // FIXME: This should be `defaultShow`.
	
	  /**
	   * The initial visibility state of the Overlay. For more nuanced visibility
	   * control, consider using the Overlay component directly.
	   */
	  defaultOverlayShown: _propTypes.default.bool,
	
	  /**
	   * An element or text to overlay next to the target.
	   */
	  overlay: _propTypes.default.node.isRequired,
	
	  /**
	   * @private
	   */
	  onBlur: _propTypes.default.func,
	
	  /**
	   * @private
	   */
	  onClick: _propTypes.default.func,
	
	  /**
	   * @private
	   */
	  onFocus: _propTypes.default.func,
	
	  /**
	   * @private
	   */
	  onMouseOut: _propTypes.default.func,
	
	  /**
	   * @private
	   */
	  onMouseOver: _propTypes.default.func,
	  // Overridden props from `<Overlay>`.
	
	  /**
	   * @private
	   */
	  target: _propTypes.default.oneOf([null]),
	
	  /**
	   * @private
	   */
	  onHide: _propTypes.default.oneOf([null]),
	
	  /**
	   * @private
	   */
	  show: _propTypes.default.oneOf([null])
	});
	var defaultProps = {
	  defaultOverlayShown: false,
	  trigger: ['hover', 'focus']
	};
	
	var OverlayTrigger =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(OverlayTrigger, _React$Component);
	
	  function OverlayTrigger(props, context) {
	    var _this;
	
	    _this = _React$Component.call(this, props, context) || this;
	    _this.handleToggle = _this.handleToggle.bind((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
	    _this.handleDelayedShow = _this.handleDelayedShow.bind((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
	    _this.handleDelayedHide = _this.handleDelayedHide.bind((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
	    _this.handleHide = _this.handleHide.bind((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
	
	    _this.handleMouseOver = function (e) {
	      return _this.handleMouseOverOut(_this.handleDelayedShow, e, 'fromElement');
	    };
	
	    _this.handleMouseOut = function (e) {
	      return _this.handleMouseOverOut(_this.handleDelayedHide, e, 'toElement');
	    };
	
	    _this._mountNode = null;
	    _this.state = {
	      show: props.defaultOverlayShown
	    };
	    return _this;
	  }
	
	  var _proto = OverlayTrigger.prototype;
	
	  _proto.componentDidMount = function componentDidMount() {
	    this._mountNode = document.createElement('div');
	    this.renderOverlay();
	  };
	
	  _proto.componentDidUpdate = function componentDidUpdate() {
	    this.renderOverlay();
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    _reactDom.default.unmountComponentAtNode(this._mountNode);
	
	    this._mountNode = null;
	    clearTimeout(this._hoverShowDelay);
	    clearTimeout(this._hoverHideDelay);
	  };
	
	  _proto.handleDelayedHide = function handleDelayedHide() {
	    var _this2 = this;
	
	    if (this._hoverShowDelay != null) {
	      clearTimeout(this._hoverShowDelay);
	      this._hoverShowDelay = null;
	      return;
	    }
	
	    if (!this.state.show || this._hoverHideDelay != null) {
	      return;
	    }
	
	    var delay = this.props.delayHide != null ? this.props.delayHide : this.props.delay;
	
	    if (!delay) {
	      this.hide();
	      return;
	    }
	
	    this._hoverHideDelay = setTimeout(function () {
	      _this2._hoverHideDelay = null;
	
	      _this2.hide();
	    }, delay);
	  };
	
	  _proto.handleDelayedShow = function handleDelayedShow() {
	    var _this3 = this;
	
	    if (this._hoverHideDelay != null) {
	      clearTimeout(this._hoverHideDelay);
	      this._hoverHideDelay = null;
	      return;
	    }
	
	    if (this.state.show || this._hoverShowDelay != null) {
	      return;
	    }
	
	    var delay = this.props.delayShow != null ? this.props.delayShow : this.props.delay;
	
	    if (!delay) {
	      this.show();
	      return;
	    }
	
	    this._hoverShowDelay = setTimeout(function () {
	      _this3._hoverShowDelay = null;
	
	      _this3.show();
	    }, delay);
	  };
	
	  _proto.handleHide = function handleHide() {
	    this.hide();
	  }; // Simple implementation of mouseEnter and mouseLeave.
	  // React's built version is broken: https://github.com/facebook/react/issues/4251
	  // for cases when the trigger is disabled and mouseOut/Over can cause flicker
	  // moving from one child element to another.
	
	
	  _proto.handleMouseOverOut = function handleMouseOverOut(handler, e, relatedNative) {
	    var target = e.currentTarget;
	    var related = e.relatedTarget || e.nativeEvent[relatedNative];
	
	    if ((!related || related !== target) && !(0, _contains.default)(target, related)) {
	      handler(e);
	    }
	  };
	
	  _proto.handleToggle = function handleToggle() {
	    if (this.state.show) {
	      this.hide();
	    } else {
	      this.show();
	    }
	  };
	
	  _proto.hide = function hide() {
	    this.setState({
	      show: false
	    });
	  };
	
	  _proto.makeOverlay = function makeOverlay(overlay, props) {
	    return _react.default.createElement(_Overlay.default, (0, _extends2.default)({}, props, {
	      show: this.state.show,
	      onHide: this.handleHide,
	      target: this
	    }), overlay);
	  };
	
	  _proto.show = function show() {
	    this.setState({
	      show: true
	    });
	  };
	
	  _proto.renderOverlay = function renderOverlay() {
	    _reactDom.default.unstable_renderSubtreeIntoContainer(this, this._overlay, this._mountNode);
	  };
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        trigger = _this$props.trigger,
	        overlay = _this$props.overlay,
	        children = _this$props.children,
	        onBlur = _this$props.onBlur,
	        onClick = _this$props.onClick,
	        onFocus = _this$props.onFocus,
	        onMouseOut = _this$props.onMouseOut,
	        onMouseOver = _this$props.onMouseOver,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["trigger", "overlay", "children", "onBlur", "onClick", "onFocus", "onMouseOut", "onMouseOver"]);
	    delete props.delay;
	    delete props.delayShow;
	    delete props.delayHide;
	    delete props.defaultOverlayShown;
	
	    var child = _react.default.Children.only(children);
	
	    var childProps = child.props;
	    var triggerProps = {};
	
	    if (this.state.show) {
	      triggerProps['aria-describedby'] = overlay.props.id;
	    } // FIXME: The logic here for passing through handlers on this component is
	    // inconsistent. We shouldn't be passing any of these props through.
	
	
	    triggerProps.onClick = (0, _createChainedFunction.default)(childProps.onClick, onClick);
	
	    if (isOneOf('click', trigger)) {
	      triggerProps.onClick = (0, _createChainedFunction.default)(triggerProps.onClick, this.handleToggle);
	    }
	
	    if (isOneOf('hover', trigger)) {
	       false ? (0, _warning.default)(!(trigger === 'hover'), '[react-bootstrap] Specifying only the `"hover"` trigger limits the ' + 'visibility of the overlay to just mouse users. Consider also ' + 'including the `"focus"` trigger so that touch and keyboard only ' + 'users can see the overlay as well.') : void 0;
	      triggerProps.onMouseOver = (0, _createChainedFunction.default)(childProps.onMouseOver, onMouseOver, this.handleMouseOver);
	      triggerProps.onMouseOut = (0, _createChainedFunction.default)(childProps.onMouseOut, onMouseOut, this.handleMouseOut);
	    }
	
	    if (isOneOf('focus', trigger)) {
	      triggerProps.onFocus = (0, _createChainedFunction.default)(childProps.onFocus, onFocus, this.handleDelayedShow);
	      triggerProps.onBlur = (0, _createChainedFunction.default)(childProps.onBlur, onBlur, this.handleDelayedHide);
	    }
	
	    this._overlay = this.makeOverlay(overlay, props);
	    return (0, _react.cloneElement)(child, triggerProps);
	  };
	
	  return OverlayTrigger;
	}(_react.default.Component);
	
	OverlayTrigger.propTypes = propTypes;
	OverlayTrigger.defaultProps = defaultProps;
	var _default = OverlayTrigger;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 1814 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(8));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _bootstrapUtils = __webpack_require__(16);
	
	var PageHeader =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(PageHeader, _React$Component);
	
	  function PageHeader() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = PageHeader.prototype;
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        className = _this$props.className,
	        children = _this$props.children,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["className", "children"]);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	    return _react.default.createElement("div", (0, _extends2.default)({}, elementProps, {
	      className: (0, _classnames.default)(className, classes)
	    }), _react.default.createElement("h1", null, children));
	  };
	
	  return PageHeader;
	}(_react.default.Component);
	
	var _default = (0, _bootstrapUtils.bsClass)('page-header', PageHeader);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 1815 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _PagerItem = _interopRequireDefault(__webpack_require__(514));
	
	var _deprecationWarning = _interopRequireDefault(__webpack_require__(1838));
	
	var _default = _deprecationWarning.default.wrapper(_PagerItem.default, '`<PageItem>`', '`<Pager.Item>`');
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 1816 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(47);
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(8));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _PagerItem = _interopRequireDefault(__webpack_require__(514));
	
	var _bootstrapUtils = __webpack_require__(16);
	
	var _createChainedFunction = _interopRequireDefault(__webpack_require__(45));
	
	var _ValidComponentChildren = _interopRequireDefault(__webpack_require__(58));
	
	var propTypes = {
	  onSelect: _propTypes.default.func
	};
	
	var Pager =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(Pager, _React$Component);
	
	  function Pager() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = Pager.prototype;
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        onSelect = _this$props.onSelect,
	        className = _this$props.className,
	        children = _this$props.children,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["onSelect", "className", "children"]);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	    return _react.default.createElement("ul", (0, _extends2.default)({}, elementProps, {
	      className: (0, _classnames.default)(className, classes)
	    }), _ValidComponentChildren.default.map(children, function (child) {
	      return (0, _react.cloneElement)(child, {
	        onSelect: (0, _createChainedFunction.default)(child.props.onSelect, onSelect)
	      });
	    }));
	  };
	
	  return Pager;
	}(_react.default.Component);
	
	Pager.propTypes = propTypes;
	Pager.Item = _PagerItem.default;
	
	var _default = (0, _bootstrapUtils.bsClass)('pager', Pager);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 1817 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(47);
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(8));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _PaginationItem = _interopRequireWildcard(__webpack_require__(1818));
	
	var _bootstrapUtils = __webpack_require__(16);
	
	var Pagination =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(Pagination, _React$Component);
	
	  function Pagination() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = Pagination.prototype;
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        className = _this$props.className,
	        children = _this$props.children,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["className", "children"]);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	    return _react.default.createElement("ul", (0, _extends2.default)({}, elementProps, {
	      className: (0, _classnames.default)(className, classes)
	    }), children);
	  };
	
	  return Pagination;
	}(_react.default.Component);
	
	(0, _bootstrapUtils.bsClass)('pagination', Pagination);
	Pagination.First = _PaginationItem.First;
	Pagination.Prev = _PaginationItem.Prev;
	Pagination.Ellipsis = _PaginationItem.Ellipsis;
	Pagination.Item = _PaginationItem.default;
	Pagination.Next = _PaginationItem.Next;
	Pagination.Last = _PaginationItem.Last;
	var _default = Pagination;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 1818 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = PaginationItem;
	exports.Last = exports.Next = exports.Ellipsis = exports.Prev = exports.First = void 0;
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(8));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _SafeAnchor = _interopRequireDefault(__webpack_require__(73));
	
	/* eslint-disable react/no-multi-comp */
	var propTypes = {
	  eventKey: _propTypes.default.any,
	  className: _propTypes.default.string,
	  onSelect: _propTypes.default.func,
	  disabled: _propTypes.default.bool,
	  active: _propTypes.default.bool,
	  activeLabel: _propTypes.default.string.isRequired
	};
	var defaultProps = {
	  active: false,
	  disabled: false,
	  activeLabel: '(current)'
	};
	
	function PaginationItem(_ref) {
	  var active = _ref.active,
	      disabled = _ref.disabled,
	      className = _ref.className,
	      style = _ref.style,
	      activeLabel = _ref.activeLabel,
	      children = _ref.children,
	      props = (0, _objectWithoutPropertiesLoose2.default)(_ref, ["active", "disabled", "className", "style", "activeLabel", "children"]);
	  var Component = active || disabled ? 'span' : _SafeAnchor.default;
	  return _react.default.createElement("li", {
	    style: style,
	    className: (0, _classnames.default)(className, {
	      active: active,
	      disabled: disabled
	    })
	  }, _react.default.createElement(Component, (0, _extends2.default)({
	    disabled: disabled
	  }, props), children, active && _react.default.createElement("span", {
	    className: "sr-only"
	  }, activeLabel)));
	}
	
	PaginationItem.propTypes = propTypes;
	PaginationItem.defaultProps = defaultProps;
	
	function createButton(name, defaultValue, label) {
	  var _class, _temp;
	
	  if (label === void 0) {
	    label = name;
	  }
	
	  return _temp = _class =
	  /*#__PURE__*/
	  function (_React$Component) {
	    (0, _inheritsLoose2.default)(_class, _React$Component);
	
	    function _class() {
	      return _React$Component.apply(this, arguments) || this;
	    }
	
	    var _proto = _class.prototype;
	
	    _proto.render = function render() {
	      var _this$props = this.props,
	          disabled = _this$props.disabled,
	          children = _this$props.children,
	          className = _this$props.className,
	          props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["disabled", "children", "className"]);
	      var Component = disabled ? 'span' : _SafeAnchor.default;
	      return _react.default.createElement("li", (0, _extends2.default)({
	        "aria-label": label,
	        className: (0, _classnames.default)(className, {
	          disabled: disabled
	        })
	      }, props), _react.default.createElement(Component, null, children || defaultValue));
	    };
	
	    return _class;
	  }(_react.default.Component), _class.displayName = name, _class.propTypes = {
	    disabled: _propTypes.default.bool
	  }, _temp;
	}
	
	var First = createButton('First', "\xAB");
	exports.First = First;
	var Prev = createButton('Prev', "\u2039");
	exports.Prev = Prev;
	var Ellipsis = createButton('Ellipsis', "\u2026", 'More');
	exports.Ellipsis = Ellipsis;
	var Next = createButton('Next', "\u203A");
	exports.Next = Next;
	var Last = createButton('Last', "\xBB");
	exports.Last = Last;

/***/ },
/* 1819 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _assign = _interopRequireDefault(__webpack_require__(340));
	
	var _values = _interopRequireDefault(__webpack_require__(120));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(8));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _uncontrollable = __webpack_require__(119);
	
	var _warning = _interopRequireDefault(__webpack_require__(59));
	
	var _bootstrapUtils = __webpack_require__(16);
	
	var _StyleConfig = __webpack_require__(50);
	
	var _PanelBody = _interopRequireDefault(__webpack_require__(1820));
	
	var _PanelHeading = _interopRequireDefault(__webpack_require__(1822));
	
	var _PanelTitle = _interopRequireDefault(__webpack_require__(1823));
	
	var _PanelFooter = _interopRequireDefault(__webpack_require__(1821));
	
	var _PanelToggle = _interopRequireDefault(__webpack_require__(517));
	
	var _PanelCollapse = _interopRequireDefault(__webpack_require__(515));
	
	var has = Object.prototype.hasOwnProperty;
	
	var defaultGetId = function defaultGetId(id, type) {
	  return id ? id + "--" + type : null;
	};
	
	var propTypes = {
	  /**
	   * Controls the collapsed/expanded state ofthe Panel. Requires
	   * a `Panel.Collapse` or `<Panel.Body collapsible>` child component
	   * in order to actually animate out or in.
	   *
	   * @controllable onToggle
	   */
	  expanded: _propTypes.default.bool,
	
	  /**
	   * A callback fired when the collapse state changes.
	   *
	   * @controllable expanded
	   */
	  onToggle: _propTypes.default.func,
	  eventKey: _propTypes.default.any,
	
	  /**
	   * An HTML `id` attribute uniquely identifying the Panel component.
	   */
	  id: _propTypes.default.string
	};
	var contextTypes = {
	  $bs_panelGroup: _propTypes.default.shape({
	    getId: _propTypes.default.func,
	    activeKey: _propTypes.default.any,
	    onToggle: _propTypes.default.func
	  })
	};
	var childContextTypes = {
	  $bs_panel: _propTypes.default.shape({
	    headingId: _propTypes.default.string,
	    bodyId: _propTypes.default.string,
	    bsClass: _propTypes.default.string,
	    onToggle: _propTypes.default.func,
	    expanded: _propTypes.default.bool
	  })
	};
	
	var Panel =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(Panel, _React$Component);
	
	  function Panel() {
	    var _this;
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
	
	    _this.handleToggle = function (e) {
	      var panelGroup = _this.context.$bs_panelGroup;
	      var expanded = !_this.getExpanded();
	
	      if (panelGroup && panelGroup.onToggle) {
	        panelGroup.onToggle(_this.props.eventKey, expanded, e);
	      } else {
	        _this.props.onToggle(expanded, e);
	      }
	    };
	
	    return _this;
	  }
	
	  var _proto = Panel.prototype;
	
	  _proto.getChildContext = function getChildContext() {
	    var _this$props = this.props,
	        eventKey = _this$props.eventKey,
	        id = _this$props.id;
	    var idKey = eventKey == null ? id : eventKey;
	    var ids;
	
	    if (idKey !== null) {
	      var panelGroup = this.context.$bs_panelGroup;
	      var getId = panelGroup && panelGroup.getId || defaultGetId;
	      ids = {
	        headingId: getId(idKey, 'heading'),
	        bodyId: getId(idKey, 'body')
	      };
	    }
	
	    return {
	      $bs_panel: (0, _extends2.default)({}, ids, {
	        bsClass: this.props.bsClass,
	        expanded: this.getExpanded(),
	        onToggle: this.handleToggle
	      })
	    };
	  };
	
	  _proto.getExpanded = function getExpanded() {
	    var panelGroup = this.context.$bs_panelGroup;
	
	    if (panelGroup && has.call(panelGroup, 'activeKey')) {
	       false ? (0, _warning.default)(this.props.expanded == null, 'Specifying `<Panel>` `expanded` in the context of an accordion ' + '`<PanelGroup>` is not supported. Set `activeKey` on the ' + '`<PanelGroup>` instead.') : void 0;
	      return panelGroup.activeKey === this.props.eventKey;
	    }
	
	    return !!this.props.expanded;
	  };
	
	  _proto.render = function render() {
	    var _this$props2 = this.props,
	        className = _this$props2.className,
	        children = _this$props2.children;
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(this.props, ['onToggle', 'eventKey', 'expanded']),
	        bsProps = _splitBsPropsAndOmit[0],
	        props = _splitBsPropsAndOmit[1];
	
	    return _react.default.createElement("div", (0, _extends2.default)({}, props, {
	      className: (0, _classnames.default)(className, (0, _bootstrapUtils.getClassSet)(bsProps))
	    }), children);
	  };
	
	  return Panel;
	}(_react.default.Component);
	
	Panel.propTypes = propTypes;
	Panel.contextTypes = contextTypes;
	Panel.childContextTypes = childContextTypes;
	var UncontrolledPanel = (0, _uncontrollable.uncontrollable)((0, _bootstrapUtils.bsClass)('panel', (0, _bootstrapUtils.bsStyles)((0, _values.default)(_StyleConfig.State).concat([_StyleConfig.Style.DEFAULT, _StyleConfig.Style.PRIMARY]), _StyleConfig.Style.DEFAULT, Panel)), {
	  expanded: 'onToggle'
	});
	(0, _assign.default)(UncontrolledPanel, {
	  Heading: _PanelHeading.default,
	  Title: _PanelTitle.default,
	  Body: _PanelBody.default,
	  Footer: _PanelFooter.default,
	  Toggle: _PanelToggle.default,
	  Collapse: _PanelCollapse.default
	});
	var _default = UncontrolledPanel;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 1820 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(8));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _bootstrapUtils = __webpack_require__(16);
	
	var _PanelCollapse = _interopRequireDefault(__webpack_require__(515));
	
	var propTypes = {
	  /**
	   * A convenience prop that renders a Collapse component around the Body for
	   * situations when the parent Panel only contains a single Panel.Body child.
	   *
	   * renders:
	   * ```jsx
	   * <Panel.Collapse>
	   *  <Panel.Body />
	   * </Panel.Collapse>
	   * ```
	   */
	  collapsible: _propTypes.default.bool.isRequired
	};
	var defaultProps = {
	  collapsible: false
	};
	var contextTypes = {
	  $bs_panel: _propTypes.default.shape({
	    bsClass: _propTypes.default.string
	  })
	};
	
	var PanelBody =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(PanelBody, _React$Component);
	
	  function PanelBody() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = PanelBody.prototype;
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        children = _this$props.children,
	        className = _this$props.className,
	        collapsible = _this$props.collapsible;
	
	    var _ref = this.context.$bs_panel || {},
	        _bsClass = _ref.bsClass;
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(this.props, ['collapsible']),
	        bsProps = _splitBsPropsAndOmit[0],
	        elementProps = _splitBsPropsAndOmit[1];
	
	    bsProps.bsClass = _bsClass || bsProps.bsClass;
	
	    var body = _react.default.createElement("div", (0, _extends2.default)({}, elementProps, {
	      className: (0, _classnames.default)(className, (0, _bootstrapUtils.prefix)(bsProps, 'body'))
	    }), children);
	
	    if (collapsible) {
	      body = _react.default.createElement(_PanelCollapse.default, null, body);
	    }
	
	    return body;
	  };
	
	  return PanelBody;
	}(_react.default.Component);
	
	PanelBody.propTypes = propTypes;
	PanelBody.defaultProps = defaultProps;
	PanelBody.contextTypes = contextTypes;
	
	var _default = (0, _bootstrapUtils.bsClass)('panel', PanelBody);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 1821 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(8));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _bootstrapUtils = __webpack_require__(16);
	
	var contextTypes = {
	  $bs_panel: _propTypes.default.shape({
	    bsClass: _propTypes.default.string
	  })
	};
	
	var PanelFooter =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(PanelFooter, _React$Component);
	
	  function PanelFooter() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = PanelFooter.prototype;
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        children = _this$props.children,
	        className = _this$props.className;
	
	    var _ref = this.context.$bs_panel || {},
	        _bsClass = _ref.bsClass;
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(this.props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    bsProps.bsClass = _bsClass || bsProps.bsClass;
	    return _react.default.createElement("div", (0, _extends2.default)({}, elementProps, {
	      className: (0, _classnames.default)(className, (0, _bootstrapUtils.prefix)(bsProps, 'footer'))
	    }), children);
	  };
	
	  return PanelFooter;
	}(_react.default.Component);
	
	PanelFooter.contextTypes = contextTypes;
	
	var _default = (0, _bootstrapUtils.bsClass)('panel', PanelFooter);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 1822 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(8));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _elementType = _interopRequireDefault(__webpack_require__(312));
	
	var _bootstrapUtils = __webpack_require__(16);
	
	var propTypes = {
	  componentClass: _elementType.default
	};
	var defaultProps = {
	  componentClass: 'div'
	};
	var contextTypes = {
	  $bs_panel: _propTypes.default.shape({
	    headingId: _propTypes.default.string,
	    bsClass: _propTypes.default.string
	  })
	};
	
	var PanelHeading =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(PanelHeading, _React$Component);
	
	  function PanelHeading() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = PanelHeading.prototype;
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        children = _this$props.children,
	        className = _this$props.className,
	        Component = _this$props.componentClass,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["children", "className", "componentClass"]);
	
	    var _ref = this.context.$bs_panel || {},
	        headingId = _ref.headingId,
	        _bsClass = _ref.bsClass;
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    bsProps.bsClass = _bsClass || bsProps.bsClass;
	
	    if (headingId) {
	      elementProps.role = elementProps.role || 'tab';
	      elementProps.id = headingId;
	    }
	
	    return _react.default.createElement(Component, (0, _extends2.default)({}, elementProps, {
	      className: (0, _classnames.default)(className, (0, _bootstrapUtils.prefix)(bsProps, 'heading'))
	    }), children);
	  };
	
	  return PanelHeading;
	}(_react.default.Component);
	
	PanelHeading.propTypes = propTypes;
	PanelHeading.defaultProps = defaultProps;
	PanelHeading.contextTypes = contextTypes;
	
	var _default = (0, _bootstrapUtils.bsClass)('panel', PanelHeading);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 1823 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(8));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _elementType = _interopRequireDefault(__webpack_require__(312));
	
	var _bootstrapUtils = __webpack_require__(16);
	
	var _PanelToggle = _interopRequireDefault(__webpack_require__(517));
	
	var propTypes = {
	  componentClass: _elementType.default,
	
	  /**
	   * A convenience prop that renders the Panel.Title as a panel collapse toggle component
	   * for the common use-case.
	   */
	  toggle: _propTypes.default.bool
	};
	var contextTypes = {
	  $bs_panel: _propTypes.default.shape({
	    bsClass: _propTypes.default.string
	  })
	};
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var PanelTitle =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(PanelTitle, _React$Component);
	
	  function PanelTitle() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = PanelTitle.prototype;
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        children = _this$props.children,
	        className = _this$props.className,
	        toggle = _this$props.toggle,
	        Component = _this$props.componentClass,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["children", "className", "toggle", "componentClass"]);
	
	    var _ref = this.context.$bs_panel || {},
	        _bsClass = _ref.bsClass;
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    bsProps.bsClass = _bsClass || bsProps.bsClass;
	
	    if (toggle) {
	      children = _react.default.createElement(_PanelToggle.default, null, children);
	    }
	
	    return _react.default.createElement(Component, (0, _extends2.default)({}, elementProps, {
	      className: (0, _classnames.default)(className, (0, _bootstrapUtils.prefix)(bsProps, 'title'))
	    }), children);
	  };
	
	  return PanelTitle;
	}(_react.default.Component);
	
	PanelTitle.propTypes = propTypes;
	PanelTitle.defaultProps = defaultProps;
	PanelTitle.contextTypes = contextTypes;
	
	var _default = (0, _bootstrapUtils.bsClass)('panel', PanelTitle);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 1824 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends3 = _interopRequireDefault(__webpack_require__(8));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _isRequiredForA11y = _interopRequireDefault(__webpack_require__(214));
	
	var _bootstrapUtils = __webpack_require__(16);
	
	var propTypes = {
	  /**
	   * An html id attribute, necessary for accessibility
	   * @type {string}
	   * @required
	   */
	  id: (0, _isRequiredForA11y.default)(_propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])),
	
	  /**
	   * Sets the direction the Popover is positioned towards.
	   */
	  placement: _propTypes.default.oneOf(['top', 'right', 'bottom', 'left']),
	
	  /**
	   * The "top" position value for the Popover.
	   */
	  positionTop: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	
	  /**
	   * The "left" position value for the Popover.
	   */
	  positionLeft: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	
	  /**
	   * The "top" position value for the Popover arrow.
	   */
	  arrowOffsetTop: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	
	  /**
	   * The "left" position value for the Popover arrow.
	   */
	  arrowOffsetLeft: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	
	  /**
	   * Title content
	   */
	  title: _propTypes.default.node
	};
	var defaultProps = {
	  placement: 'right'
	};
	
	var Popover =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(Popover, _React$Component);
	
	  function Popover() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = Popover.prototype;
	
	  _proto.render = function render() {
	    var _extends2;
	
	    var _this$props = this.props,
	        placement = _this$props.placement,
	        positionTop = _this$props.positionTop,
	        positionLeft = _this$props.positionLeft,
	        arrowOffsetTop = _this$props.arrowOffsetTop,
	        arrowOffsetLeft = _this$props.arrowOffsetLeft,
	        title = _this$props.title,
	        className = _this$props.className,
	        style = _this$props.style,
	        children = _this$props.children,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["placement", "positionTop", "positionLeft", "arrowOffsetTop", "arrowOffsetLeft", "title", "className", "style", "children"]);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends3.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[placement] = true, _extends2));
	    var outerStyle = (0, _extends3.default)({
	      display: 'block',
	      top: positionTop,
	      left: positionLeft
	    }, style);
	    var arrowStyle = {
	      top: arrowOffsetTop,
	      left: arrowOffsetLeft
	    };
	    return _react.default.createElement("div", (0, _extends3.default)({}, elementProps, {
	      role: "tooltip",
	      className: (0, _classnames.default)(className, classes),
	      style: outerStyle
	    }), _react.default.createElement("div", {
	      className: "arrow",
	      style: arrowStyle
	    }), title && _react.default.createElement("h3", {
	      className: (0, _bootstrapUtils.prefix)(bsProps, 'title')
	    }, title), _react.default.createElement("div", {
	      className: (0, _bootstrapUtils.prefix)(bsProps, 'content')
	    }, children));
	  };
	
	  return Popover;
	}(_react.default.Component);
	
	Popover.propTypes = propTypes;
	Popover.defaultProps = defaultProps;
	
	var _default = (0, _bootstrapUtils.bsClass)('popover', Popover);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 1825 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(47);
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _values = _interopRequireDefault(__webpack_require__(120));
	
	var _extends3 = _interopRequireDefault(__webpack_require__(8));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _bootstrapUtils = __webpack_require__(16);
	
	var _StyleConfig = __webpack_require__(50);
	
	var _ValidComponentChildren = _interopRequireDefault(__webpack_require__(58));
	
	var ROUND_PRECISION = 1000;
	/**
	 * Validate that children, if any, are instances of `<ProgressBar>`.
	 */
	
	function onlyProgressBar(props, propName, componentName) {
	  var children = props[propName];
	
	  if (!children) {
	    return null;
	  }
	
	  var error = null;
	
	  _react.default.Children.forEach(children, function (child) {
	    if (error) {
	      return;
	    }
	    /**
	     * Compare types in a way that works with libraries that patch and proxy
	     * components like react-hot-loader.
	     *
	     * see https://github.com/gaearon/react-hot-loader#checking-element-types
	     */
	
	
	    var element = _react.default.createElement(ProgressBar, null);
	
	    if (child.type === element.type) return;
	    var childIdentifier = _react.default.isValidElement(child) ? child.type.displayName || child.type.name || child.type : child;
	    error = new Error("Children of " + componentName + " can contain only ProgressBar " + ("components. Found " + childIdentifier + "."));
	  });
	
	  return error;
	}
	
	var propTypes = {
	  min: _propTypes.default.number,
	  now: _propTypes.default.number,
	  max: _propTypes.default.number,
	  label: _propTypes.default.node,
	  srOnly: _propTypes.default.bool,
	  striped: _propTypes.default.bool,
	  active: _propTypes.default.bool,
	  children: onlyProgressBar,
	
	  /**
	   * @private
	   */
	  isChild: _propTypes.default.bool
	};
	var defaultProps = {
	  min: 0,
	  max: 100,
	  active: false,
	  isChild: false,
	  srOnly: false,
	  striped: false
	};
	
	function getPercentage(now, min, max) {
	  var percentage = (now - min) / (max - min) * 100;
	  return Math.round(percentage * ROUND_PRECISION) / ROUND_PRECISION;
	}
	
	var ProgressBar =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(ProgressBar, _React$Component);
	
	  function ProgressBar() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = ProgressBar.prototype;
	
	  _proto.renderProgressBar = function renderProgressBar(_ref) {
	    var _extends2;
	
	    var min = _ref.min,
	        now = _ref.now,
	        max = _ref.max,
	        label = _ref.label,
	        srOnly = _ref.srOnly,
	        striped = _ref.striped,
	        active = _ref.active,
	        className = _ref.className,
	        style = _ref.style,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_ref, ["min", "now", "max", "label", "srOnly", "striped", "active", "className", "style"]);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends3.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {
	      active: active
	    }, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'striped')] = active || striped, _extends2));
	    return _react.default.createElement("div", (0, _extends3.default)({}, elementProps, {
	      role: "progressbar",
	      className: (0, _classnames.default)(className, classes),
	      style: (0, _extends3.default)({
	        width: getPercentage(now, min, max) + "%"
	      }, style),
	      "aria-valuenow": now,
	      "aria-valuemin": min,
	      "aria-valuemax": max
	    }), srOnly ? _react.default.createElement("span", {
	      className: "sr-only"
	    }, label) : label);
	  };
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        isChild = _this$props.isChild,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["isChild"]);
	
	    if (isChild) {
	      return this.renderProgressBar(props);
	    }
	
	    var min = props.min,
	        now = props.now,
	        max = props.max,
	        label = props.label,
	        srOnly = props.srOnly,
	        striped = props.striped,
	        active = props.active,
	        bsClass = props.bsClass,
	        bsStyle = props.bsStyle,
	        className = props.className,
	        children = props.children,
	        wrapperProps = (0, _objectWithoutPropertiesLoose2.default)(props, ["min", "now", "max", "label", "srOnly", "striped", "active", "bsClass", "bsStyle", "className", "children"]);
	    return _react.default.createElement("div", (0, _extends3.default)({}, wrapperProps, {
	      className: (0, _classnames.default)(className, 'progress')
	    }), children ? _ValidComponentChildren.default.map(children, function (child) {
	      return (0, _react.cloneElement)(child, {
	        isChild: true
	      });
	    }) : this.renderProgressBar({
	      min: min,
	      now: now,
	      max: max,
	      label: label,
	      srOnly: srOnly,
	      striped: striped,
	      active: active,
	      bsClass: bsClass,
	      bsStyle: bsStyle
	    }));
	  };
	
	  return ProgressBar;
	}(_react.default.Component);
	
	ProgressBar.propTypes = propTypes;
	ProgressBar.defaultProps = defaultProps;
	
	var _default = (0, _bootstrapUtils.bsClass)('progress-bar', (0, _bootstrapUtils.bsStyles)((0, _values.default)(_StyleConfig.State), ProgressBar));
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 1826 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(8));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _warning = _interopRequireDefault(__webpack_require__(59));
	
	var _bootstrapUtils = __webpack_require__(16);
	
	/* eslint-disable jsx-a11y/label-has-for */
	var propTypes = {
	  inline: _propTypes.default.bool,
	  disabled: _propTypes.default.bool,
	  title: _propTypes.default.string,
	
	  /**
	   * Only valid if `inline` is not set.
	   */
	  validationState: _propTypes.default.oneOf(['success', 'warning', 'error', null]),
	
	  /**
	   * Attaches a ref to the `<input>` element. Only functions can be used here.
	   *
	   * ```js
	   * <Radio inputRef={ref => { this.input = ref; }} />
	   * ```
	   */
	  inputRef: _propTypes.default.func
	};
	var defaultProps = {
	  inline: false,
	  disabled: false,
	  title: ''
	};
	
	var Radio =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(Radio, _React$Component);
	
	  function Radio() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = Radio.prototype;
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        inline = _this$props.inline,
	        disabled = _this$props.disabled,
	        validationState = _this$props.validationState,
	        inputRef = _this$props.inputRef,
	        className = _this$props.className,
	        style = _this$props.style,
	        title = _this$props.title,
	        children = _this$props.children,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["inline", "disabled", "validationState", "inputRef", "className", "style", "title", "children"]);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var input = _react.default.createElement("input", (0, _extends2.default)({}, elementProps, {
	      ref: inputRef,
	      type: "radio",
	      disabled: disabled
	    }));
	
	    if (inline) {
	      var _classes2;
	
	      var _classes = (_classes2 = {}, _classes2[(0, _bootstrapUtils.prefix)(bsProps, 'inline')] = true, _classes2.disabled = disabled, _classes2); // Use a warning here instead of in propTypes to get better-looking
	      // generated documentation.
	
	
	       false ? (0, _warning.default)(!validationState, '`validationState` is ignored on `<Radio inline>`. To display ' + 'validation state on an inline radio, set `validationState` on a ' + 'parent `<FormGroup>` or other element instead.') : void 0;
	      return _react.default.createElement("label", {
	        className: (0, _classnames.default)(className, _classes),
	        style: style,
	        title: title
	      }, input, children);
	    }
	
	    var classes = (0, _extends2.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	      disabled: disabled
	    });
	
	    if (validationState) {
	      classes["has-" + validationState] = true;
	    }
	
	    return _react.default.createElement("div", {
	      className: (0, _classnames.default)(className, classes),
	      style: style
	    }, _react.default.createElement("label", {
	      title: title
	    }, input, children));
	  };
	
	  return Radio;
	}(_react.default.Component);
	
	Radio.propTypes = propTypes;
	Radio.defaultProps = defaultProps;
	
	var _default = (0, _bootstrapUtils.bsClass)('radio', Radio);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 1827 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(47);
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends3 = _interopRequireDefault(__webpack_require__(8));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _warning = _interopRequireDefault(__webpack_require__(59));
	
	var _bootstrapUtils = __webpack_require__(16);
	
	// TODO: This should probably take a single `aspectRatio` prop.
	var propTypes = {
	  /**
	   * This component requires a single child element
	   */
	  children: _propTypes.default.element.isRequired,
	
	  /**
	   * 16by9 aspect ratio
	   */
	  a16by9: _propTypes.default.bool,
	
	  /**
	   * 4by3 aspect ratio
	   */
	  a4by3: _propTypes.default.bool
	};
	var defaultProps = {
	  a16by9: false,
	  a4by3: false
	};
	
	var ResponsiveEmbed =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(ResponsiveEmbed, _React$Component);
	
	  function ResponsiveEmbed() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = ResponsiveEmbed.prototype;
	
	  _proto.render = function render() {
	    var _extends2;
	
	    var _this$props = this.props,
	        a16by9 = _this$props.a16by9,
	        a4by3 = _this$props.a4by3,
	        className = _this$props.className,
	        children = _this$props.children,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["a16by9", "a4by3", "className", "children"]);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	     false ? (0, _warning.default)(a16by9 || a4by3, 'Either `a16by9` or `a4by3` must be set.') : void 0;
	     false ? (0, _warning.default)(!(a16by9 && a4by3), 'Only one of `a16by9` or `a4by3` can be set.') : void 0;
	    var classes = (0, _extends3.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps, '16by9')] = a16by9, _extends2[(0, _bootstrapUtils.prefix)(bsProps, '4by3')] = a4by3, _extends2));
	    return _react.default.createElement("div", {
	      className: (0, _classnames.default)(classes)
	    }, (0, _react.cloneElement)(children, (0, _extends3.default)({}, elementProps, {
	      className: (0, _classnames.default)(className, (0, _bootstrapUtils.prefix)(bsProps, 'item'))
	    })));
	  };
	
	  return ResponsiveEmbed;
	}(_react.default.Component);
	
	ResponsiveEmbed.propTypes = propTypes;
	ResponsiveEmbed.defaultProps = defaultProps;
	
	var _default = (0, _bootstrapUtils.bsClass)('embed-responsive', ResponsiveEmbed);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 1828 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(8));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _elementType = _interopRequireDefault(__webpack_require__(32));
	
	var _bootstrapUtils = __webpack_require__(16);
	
	var propTypes = {
	  componentClass: _elementType.default
	};
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var Row =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(Row, _React$Component);
	
	  function Row() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = Row.prototype;
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        Component = _this$props.componentClass,
	        className = _this$props.className,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["componentClass", "className"]);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	    return _react.default.createElement(Component, (0, _extends2.default)({}, elementProps, {
	      className: (0, _classnames.default)(className, classes)
	    }));
	  };
	
	  return Row;
	}(_react.default.Component);
	
	Row.propTypes = propTypes;
	Row.defaultProps = defaultProps;
	
	var _default = (0, _bootstrapUtils.bsClass)('row', Row);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 1829 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(8));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _Button = _interopRequireDefault(__webpack_require__(158));
	
	var _Dropdown = _interopRequireDefault(__webpack_require__(216));
	
	var _SplitToggle = _interopRequireDefault(__webpack_require__(1830));
	
	var _splitComponentProps2 = _interopRequireDefault(__webpack_require__(219));
	
	var propTypes = (0, _extends2.default)({}, _Dropdown.default.propTypes, {
	  // Toggle props.
	  bsStyle: _propTypes.default.string,
	  bsSize: _propTypes.default.string,
	  href: _propTypes.default.string,
	  onClick: _propTypes.default.func,
	
	  /**
	   * The content of the split button.
	   */
	  title: _propTypes.default.node.isRequired,
	
	  /**
	   * Accessible label for the toggle; the value of `title` if not specified.
	   */
	  toggleLabel: _propTypes.default.string,
	  // Override generated docs from <Dropdown>.
	
	  /**
	   * @private
	   */
	  children: _propTypes.default.node
	});
	
	var SplitButton =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(SplitButton, _React$Component);
	
	  function SplitButton() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = SplitButton.prototype;
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        bsSize = _this$props.bsSize,
	        bsStyle = _this$props.bsStyle,
	        title = _this$props.title,
	        toggleLabel = _this$props.toggleLabel,
	        children = _this$props.children,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["bsSize", "bsStyle", "title", "toggleLabel", "children"]);
	
	    var _splitComponentProps = (0, _splitComponentProps2.default)(props, _Dropdown.default.ControlledComponent),
	        dropdownProps = _splitComponentProps[0],
	        buttonProps = _splitComponentProps[1];
	
	    return _react.default.createElement(_Dropdown.default, (0, _extends2.default)({}, dropdownProps, {
	      bsSize: bsSize,
	      bsStyle: bsStyle
	    }), _react.default.createElement(_Button.default, (0, _extends2.default)({}, buttonProps, {
	      disabled: props.disabled,
	      bsSize: bsSize,
	      bsStyle: bsStyle
	    }), title), _react.default.createElement(_SplitToggle.default, {
	      "aria-label": toggleLabel || title,
	      bsSize: bsSize,
	      bsStyle: bsStyle
	    }), _react.default.createElement(_Dropdown.default.Menu, null, children));
	  };
	
	  return SplitButton;
	}(_react.default.Component);
	
	SplitButton.propTypes = propTypes;
	SplitButton.Toggle = _SplitToggle.default;
	var _default = SplitButton;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 1830 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(8));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _DropdownToggle = _interopRequireDefault(__webpack_require__(501));
	
	var SplitToggle =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(SplitToggle, _React$Component);
	
	  function SplitToggle() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = SplitToggle.prototype;
	
	  _proto.render = function render() {
	    return _react.default.createElement(_DropdownToggle.default, (0, _extends2.default)({}, this.props, {
	      useAnchor: false,
	      noCaret: false
	    }));
	  };
	
	  return SplitToggle;
	}(_react.default.Component);
	
	SplitToggle.defaultProps = _DropdownToggle.default.defaultProps;
	var _default = SplitToggle;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 1831 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(8));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _TabContainer = _interopRequireDefault(__webpack_require__(309));
	
	var _TabContent = _interopRequireDefault(__webpack_require__(310));
	
	var _TabPane = _interopRequireDefault(__webpack_require__(518));
	
	var propTypes = (0, _extends2.default)({}, _TabPane.default.propTypes, {
	  disabled: _propTypes.default.bool,
	  title: _propTypes.default.node,
	
	  /**
	   * tabClassName is used as className for the associated NavItem
	   */
	  tabClassName: _propTypes.default.string
	});
	
	var Tab =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(Tab, _React$Component);
	
	  function Tab() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = Tab.prototype;
	
	  _proto.render = function render() {
	    var props = (0, _extends2.default)({}, this.props); // These props are for the parent `<Tabs>` rather than the `<TabPane>`.
	
	    delete props.title;
	    delete props.disabled;
	    delete props.tabClassName;
	    return _react.default.createElement(_TabPane.default, props);
	  };
	
	  return Tab;
	}(_react.default.Component);
	
	Tab.propTypes = propTypes;
	Tab.Container = _TabContainer.default;
	Tab.Content = _TabContent.default;
	Tab.Pane = _TabPane.default;
	var _default = Tab;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 1832 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends3 = _interopRequireDefault(__webpack_require__(8));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _bootstrapUtils = __webpack_require__(16);
	
	var propTypes = {
	  striped: _propTypes.default.bool,
	  bordered: _propTypes.default.bool,
	  condensed: _propTypes.default.bool,
	  hover: _propTypes.default.bool,
	  responsive: _propTypes.default.bool
	};
	var defaultProps = {
	  bordered: false,
	  condensed: false,
	  hover: false,
	  responsive: false,
	  striped: false
	};
	
	var Table =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(Table, _React$Component);
	
	  function Table() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = Table.prototype;
	
	  _proto.render = function render() {
	    var _extends2;
	
	    var _this$props = this.props,
	        striped = _this$props.striped,
	        bordered = _this$props.bordered,
	        condensed = _this$props.condensed,
	        hover = _this$props.hover,
	        responsive = _this$props.responsive,
	        className = _this$props.className,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["striped", "bordered", "condensed", "hover", "responsive", "className"]);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends3.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'striped')] = striped, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'bordered')] = bordered, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'condensed')] = condensed, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'hover')] = hover, _extends2));
	
	    var table = _react.default.createElement("table", (0, _extends3.default)({}, elementProps, {
	      className: (0, _classnames.default)(className, classes)
	    }));
	
	    if (responsive) {
	      return _react.default.createElement("div", {
	        className: (0, _bootstrapUtils.prefix)(bsProps, 'responsive')
	      }, table);
	    }
	
	    return table;
	  };
	
	  return Table;
	}(_react.default.Component);
	
	Table.propTypes = propTypes;
	Table.defaultProps = defaultProps;
	
	var _default = (0, _bootstrapUtils.bsClass)('table', Table);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 1833 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(8));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _isRequiredForA11y = _interopRequireDefault(__webpack_require__(214));
	
	var _uncontrollable = __webpack_require__(119);
	
	var _elementType = _interopRequireDefault(__webpack_require__(32));
	
	var _Nav = _interopRequireDefault(__webpack_require__(510));
	
	var _NavItem = _interopRequireDefault(__webpack_require__(511));
	
	var _TabContainer = _interopRequireDefault(__webpack_require__(309));
	
	var _TabContent = _interopRequireDefault(__webpack_require__(310));
	
	var _bootstrapUtils = __webpack_require__(16);
	
	var _ValidComponentChildren = _interopRequireDefault(__webpack_require__(58));
	
	var TabContainer = _TabContainer.default.ControlledComponent;
	var propTypes = {
	  /**
	   * Mark the Tab with a matching `eventKey` as active.
	   *
	   * @controllable onSelect
	   */
	  activeKey: _propTypes.default.any,
	
	  /**
	   * Navigation style
	   */
	  bsStyle: _propTypes.default.oneOf(['tabs', 'pills']),
	
	  /**
	   * Sets a default animation strategy. Use `false` to disable, `true`
	   * to enable the default `<Fade>` animation, or a react-transition-group
	   * v2 `<Transition/>` component.
	   */
	  animation: _propTypes.default.oneOfType([_propTypes.default.bool, _elementType.default]),
	  id: (0, _isRequiredForA11y.default)(_propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])),
	
	  /**
	   * Callback fired when a Tab is selected.
	   *
	   * ```js
	   * function (
	   *   Any eventKey,
	   *   SyntheticEvent event?
	   * )
	   * ```
	   *
	   * @controllable activeKey
	   */
	  onSelect: _propTypes.default.func,
	
	  /**
	   * Wait until the first "enter" transition to mount tabs (add them to the DOM)
	   */
	  mountOnEnter: _propTypes.default.bool,
	
	  /**
	   * Unmount tabs (remove it from the DOM) when it is no longer visible
	   */
	  unmountOnExit: _propTypes.default.bool
	};
	var defaultProps = {
	  bsStyle: 'tabs',
	  animation: true,
	  mountOnEnter: false,
	  unmountOnExit: false
	};
	
	function getDefaultActiveKey(children) {
	  var defaultActiveKey;
	
	  _ValidComponentChildren.default.forEach(children, function (child) {
	    if (defaultActiveKey == null) {
	      defaultActiveKey = child.props.eventKey;
	    }
	  });
	
	  return defaultActiveKey;
	}
	
	var Tabs =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(Tabs, _React$Component);
	
	  function Tabs() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = Tabs.prototype;
	
	  _proto.renderTab = function renderTab(child) {
	    var _child$props = child.props,
	        title = _child$props.title,
	        eventKey = _child$props.eventKey,
	        disabled = _child$props.disabled,
	        tabClassName = _child$props.tabClassName;
	
	    if (title == null) {
	      return null;
	    }
	
	    return _react.default.createElement(_NavItem.default, {
	      eventKey: eventKey,
	      disabled: disabled,
	      className: tabClassName
	    }, title);
	  };
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        id = _this$props.id,
	        onSelect = _this$props.onSelect,
	        animation = _this$props.animation,
	        mountOnEnter = _this$props.mountOnEnter,
	        unmountOnExit = _this$props.unmountOnExit,
	        bsClass = _this$props.bsClass,
	        className = _this$props.className,
	        style = _this$props.style,
	        children = _this$props.children,
	        _this$props$activeKey = _this$props.activeKey,
	        activeKey = _this$props$activeKey === void 0 ? getDefaultActiveKey(children) : _this$props$activeKey,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["id", "onSelect", "animation", "mountOnEnter", "unmountOnExit", "bsClass", "className", "style", "children", "activeKey"]);
	    return _react.default.createElement(TabContainer, {
	      id: id,
	      activeKey: activeKey,
	      onSelect: onSelect,
	      className: className,
	      style: style
	    }, _react.default.createElement("div", null, _react.default.createElement(_Nav.default, (0, _extends2.default)({}, props, {
	      role: "tablist"
	    }), _ValidComponentChildren.default.map(children, this.renderTab)), _react.default.createElement(_TabContent.default, {
	      bsClass: bsClass,
	      animation: animation,
	      mountOnEnter: mountOnEnter,
	      unmountOnExit: unmountOnExit
	    }, children)));
	  };
	
	  return Tabs;
	}(_react.default.Component);
	
	Tabs.propTypes = propTypes;
	Tabs.defaultProps = defaultProps;
	(0, _bootstrapUtils.bsClass)('tab', Tabs);
	
	var _default = (0, _uncontrollable.uncontrollable)(Tabs, {
	  activeKey: 'onSelect'
	});
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 1834 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(8));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _SafeAnchor = _interopRequireDefault(__webpack_require__(73));
	
	var _bootstrapUtils = __webpack_require__(16);
	
	/* eslint-disable jsx-a11y/alt-text */
	var propTypes = {
	  /**
	   * src property that is passed down to the image inside this component
	   */
	  src: _propTypes.default.string,
	
	  /**
	   * alt property that is passed down to the image inside this component
	   */
	  alt: _propTypes.default.string,
	
	  /**
	   * href property that is passed down to the image inside this component
	   */
	  href: _propTypes.default.string,
	
	  /**
	   * onError callback that is passed down to the image inside this component
	   */
	  onError: _propTypes.default.func,
	
	  /**
	   * onLoad callback that is passed down to the image inside this component
	   */
	  onLoad: _propTypes.default.func
	};
	
	var Thumbnail =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(Thumbnail, _React$Component);
	
	  function Thumbnail() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = Thumbnail.prototype;
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        src = _this$props.src,
	        alt = _this$props.alt,
	        onError = _this$props.onError,
	        onLoad = _this$props.onLoad,
	        className = _this$props.className,
	        children = _this$props.children,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["src", "alt", "onError", "onLoad", "className", "children"]);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var Component = elementProps.href ? _SafeAnchor.default : 'div';
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	    return _react.default.createElement(Component, (0, _extends2.default)({}, elementProps, {
	      className: (0, _classnames.default)(className, classes)
	    }), _react.default.createElement("img", {
	      src: src,
	      alt: alt,
	      onError: onError,
	      onLoad: onLoad
	    }), children && _react.default.createElement("div", {
	      className: "caption"
	    }, children));
	  };
	
	  return Thumbnail;
	}(_react.default.Component);
	
	Thumbnail.propTypes = propTypes;
	
	var _default = (0, _bootstrapUtils.bsClass)('thumbnail', Thumbnail);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 1835 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(8));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _invariant = _interopRequireDefault(__webpack_require__(37));
	
	var _uncontrollable = __webpack_require__(119);
	
	var _createChainedFunction = _interopRequireDefault(__webpack_require__(45));
	
	var _ValidComponentChildren = _interopRequireDefault(__webpack_require__(58));
	
	var _ButtonGroup = _interopRequireDefault(__webpack_require__(305));
	
	var _ToggleButton = _interopRequireDefault(__webpack_require__(519));
	
	var propTypes = {
	  /**
	   * An HTML `<input>` name for each child button.
	   *
	   * __Required if `type` is set to `'radio'`__
	   */
	  name: _propTypes.default.string,
	
	  /**
	   * The value, or array of values, of the active (pressed) buttons
	   *
	   * @controllable onChange
	   */
	  value: _propTypes.default.any,
	
	  /**
	   * Callback fired when a button is pressed, depending on whether the `type`
	   * is `'radio'` or `'checkbox'`, `onChange` will be called with the value or
	   * array of active values
	   *
	   * @controllable values
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * The input `type` of the rendered buttons, determines the toggle behavior
	   * of the buttons
	   */
	  type: _propTypes.default.oneOf(['checkbox', 'radio']).isRequired
	};
	var defaultProps = {
	  type: 'radio'
	};
	
	var ToggleButtonGroup =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(ToggleButtonGroup, _React$Component);
	
	  function ToggleButtonGroup() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = ToggleButtonGroup.prototype;
	
	  _proto.getValues = function getValues() {
	    var value = this.props.value;
	    return value == null ? [] : [].concat(value);
	  };
	
	  _proto.handleToggle = function handleToggle(value) {
	    var _this$props = this.props,
	        type = _this$props.type,
	        onChange = _this$props.onChange;
	    var values = this.getValues();
	    var isActive = values.indexOf(value) !== -1;
	
	    if (type === 'radio') {
	      if (!isActive) {
	        onChange(value);
	      }
	
	      return;
	    }
	
	    if (isActive) {
	      onChange(values.filter(function (n) {
	        return n !== value;
	      }));
	    } else {
	      onChange(values.concat([value]));
	    }
	  };
	
	  _proto.render = function render() {
	    var _this = this;
	
	    var _this$props2 = this.props,
	        children = _this$props2.children,
	        type = _this$props2.type,
	        name = _this$props2.name,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props2, ["children", "type", "name"]);
	    var values = this.getValues();
	    !(type !== 'radio' || !!name) ?  false ? (0, _invariant.default)(false, 'A `name` is required to group the toggle buttons when the `type` ' + 'is set to "radio"') : invariant(false) : void 0;
	    delete props.onChange;
	    delete props.value; // the data attribute is required b/c twbs css uses it in the selector
	
	    return _react.default.createElement(_ButtonGroup.default, (0, _extends2.default)({}, props, {
	      "data-toggle": "buttons"
	    }), _ValidComponentChildren.default.map(children, function (child) {
	      var _child$props = child.props,
	          value = _child$props.value,
	          onChange = _child$props.onChange;
	
	      var handler = function handler() {
	        return _this.handleToggle(value);
	      };
	
	      return _react.default.cloneElement(child, {
	        type: type,
	        name: child.name || name,
	        checked: values.indexOf(value) !== -1,
	        onChange: (0, _createChainedFunction.default)(onChange, handler)
	      });
	    }));
	  };
	
	  return ToggleButtonGroup;
	}(_react.default.Component);
	
	ToggleButtonGroup.propTypes = propTypes;
	ToggleButtonGroup.defaultProps = defaultProps;
	var UncontrolledToggleButtonGroup = (0, _uncontrollable.uncontrollable)(ToggleButtonGroup, {
	  value: 'onChange'
	});
	UncontrolledToggleButtonGroup.Button = _ToggleButton.default;
	var _default = UncontrolledToggleButtonGroup;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 1836 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends3 = _interopRequireDefault(__webpack_require__(8));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _isRequiredForA11y = _interopRequireDefault(__webpack_require__(214));
	
	var _bootstrapUtils = __webpack_require__(16);
	
	var propTypes = {
	  /**
	   * An html id attribute, necessary for accessibility
	   * @type {string|number}
	   * @required
	   */
	  id: (0, _isRequiredForA11y.default)(_propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])),
	
	  /**
	   * Sets the direction the Tooltip is positioned towards.
	   */
	  placement: _propTypes.default.oneOf(['top', 'right', 'bottom', 'left']),
	
	  /**
	   * The "top" position value for the Tooltip.
	   */
	  positionTop: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	
	  /**
	   * The "left" position value for the Tooltip.
	   */
	  positionLeft: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	
	  /**
	   * The "top" position value for the Tooltip arrow.
	   */
	  arrowOffsetTop: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	
	  /**
	   * The "left" position value for the Tooltip arrow.
	   */
	  arrowOffsetLeft: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string])
	};
	var defaultProps = {
	  placement: 'right'
	};
	
	var Tooltip =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(Tooltip, _React$Component);
	
	  function Tooltip() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = Tooltip.prototype;
	
	  _proto.render = function render() {
	    var _extends2;
	
	    var _this$props = this.props,
	        placement = _this$props.placement,
	        positionTop = _this$props.positionTop,
	        positionLeft = _this$props.positionLeft,
	        arrowOffsetTop = _this$props.arrowOffsetTop,
	        arrowOffsetLeft = _this$props.arrowOffsetLeft,
	        className = _this$props.className,
	        style = _this$props.style,
	        children = _this$props.children,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["placement", "positionTop", "positionLeft", "arrowOffsetTop", "arrowOffsetLeft", "className", "style", "children"]);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends3.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[placement] = true, _extends2));
	    var outerStyle = (0, _extends3.default)({
	      top: positionTop,
	      left: positionLeft
	    }, style);
	    var arrowStyle = {
	      top: arrowOffsetTop,
	      left: arrowOffsetLeft
	    };
	    return _react.default.createElement("div", (0, _extends3.default)({}, elementProps, {
	      role: "tooltip",
	      className: (0, _classnames.default)(className, classes),
	      style: outerStyle
	    }), _react.default.createElement("div", {
	      className: (0, _bootstrapUtils.prefix)(bsProps, 'arrow'),
	      style: arrowStyle
	    }), _react.default.createElement("div", {
	      className: (0, _bootstrapUtils.prefix)(bsProps, 'inner')
	    }, children));
	  };
	
	  return Tooltip;
	}(_react.default.Component);
	
	Tooltip.propTypes = propTypes;
	Tooltip.defaultProps = defaultProps;
	
	var _default = (0, _bootstrapUtils.bsClass)('tooltip', Tooltip);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 1837 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(8));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _bootstrapUtils = __webpack_require__(16);
	
	var _StyleConfig = __webpack_require__(50);
	
	var Well =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(Well, _React$Component);
	
	  function Well() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = Well.prototype;
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        className = _this$props.className,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["className"]);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	    return _react.default.createElement("div", (0, _extends2.default)({}, elementProps, {
	      className: (0, _classnames.default)(className, classes)
	    }));
	  };
	
	  return Well;
	}(_react.default.Component);
	
	var _default = (0, _bootstrapUtils.bsClass)('well', (0, _bootstrapUtils.bsSizes)([_StyleConfig.Size.LARGE, _StyleConfig.Size.SMALL], Well));
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 1838 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	exports.__esModule = true;
	exports._resetWarned = _resetWarned;
	exports.default = void 0;
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _warning = _interopRequireDefault(__webpack_require__(59));
	
	var warned = {};
	
	function deprecationWarning(oldname, newname, link) {
	  var message;
	
	  if (typeof oldname === 'object') {
	    message = oldname.message;
	  } else {
	    message = oldname + " is deprecated. Use " + newname + " instead.";
	
	    if (link) {
	      message += "\nYou can read more about it at " + link;
	    }
	  }
	
	  if (warned[message]) {
	    return;
	  }
	
	   false ? (0, _warning.default)(false, message) : void 0;
	  warned[message] = true;
	}
	
	deprecationWarning.wrapper = function (Component) {
	  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    args[_key - 1] = arguments[_key];
	  }
	
	  return (
	    /*#__PURE__*/
	    function (_Component) {
	      (0, _inheritsLoose2.default)(DeprecatedComponent, _Component);
	
	      function DeprecatedComponent() {
	        return _Component.apply(this, arguments) || this;
	      }
	
	      var _proto = DeprecatedComponent.prototype;
	
	      _proto.UNSAFE_componentWillMount = function UNSAFE_componentWillMount() {
	        // eslint-disable-line
	        deprecationWarning.apply(void 0, args);
	
	        if (_Component.prototype.UNSAFE_componentWillMount) {
	          var _Component$prototype$;
	
	          for (var _len2 = arguments.length, methodArgs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	            methodArgs[_key2] = arguments[_key2];
	          }
	
	          (_Component$prototype$ = _Component.prototype.UNSAFE_componentWillMount).call.apply(_Component$prototype$, [this].concat(methodArgs));
	        }
	      };
	
	      return DeprecatedComponent;
	    }(Component)
	  );
	};
	
	var _default = deprecationWarning;
	exports.default = _default;
	
	function _resetWarned() {
	  warned = {};
	}

/***/ },
/* 1839 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(5);
	
	var _interopRequireWildcard = __webpack_require__(47);
	
	exports.__esModule = true;
	exports.bootstrapUtils = void 0;
	
	var _bootstrapUtils = _interopRequireWildcard(__webpack_require__(16));
	
	exports.bootstrapUtils = _bootstrapUtils;
	
	var _createChainedFunction2 = _interopRequireDefault(__webpack_require__(45));
	
	exports.createChainedFunction = _createChainedFunction2.default;
	
	var _ValidComponentChildren2 = _interopRequireDefault(__webpack_require__(58));
	
	exports.ValidComponentChildren = _ValidComponentChildren2.default;

/***/ },
/* 1840 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _payment = _interopRequireDefault(__webpack_require__(497));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	
	function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var ReactCreditCards = /*#__PURE__*/function (_React$Component) {
	  _inherits(ReactCreditCards, _React$Component);
	
	  var _super = _createSuper(ReactCreditCards);
	
	  function ReactCreditCards(props) {
	    var _this;
	
	    _classCallCheck(this, ReactCreditCards);
	
	    _this = _super.call(this, props);
	
	    _this.setCards();
	
	    return _this;
	  }
	
	  _createClass(ReactCreditCards, [{
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      var _this$props = this.props,
	          acceptedCards = _this$props.acceptedCards,
	          callback = _this$props.callback,
	          number = _this$props.number;
	
	      if (prevProps.number !== number) {
	        /* istanbul ignore else */
	        if (typeof callback === 'function') {
	          callback(this.options, _payment.default.fns.validateCardNumber(number));
	        }
	      }
	
	      if (prevProps.acceptedCards.toString() !== acceptedCards.toString()) {
	        this.setCards();
	      }
	    }
	  }, {
	    key: "setCards",
	    value: function setCards() {
	      var acceptedCards = this.props.acceptedCards;
	      var newCardArray = [];
	
	      if (acceptedCards.length) {
	        _payment.default.getCardArray().forEach(function (d) {
	          if (acceptedCards.indexOf(d.type) !== -1) {
	            newCardArray.push(d);
	          }
	        });
	      } else {
	        newCardArray = newCardArray.concat(_payment.default.getCardArray());
	      }
	
	      _payment.default.setCardArray(newCardArray);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props2 = this.props,
	          cvc = _this$props2.cvc,
	          focused = _this$props2.focused,
	          locale = _this$props2.locale,
	          name = _this$props2.name,
	          placeholders = _this$props2.placeholders;
	      var number = this.number,
	          expiry = this.expiry;
	      return /*#__PURE__*/_react.default.createElement("div", {
	        key: "Cards",
	        className: "rccs"
	      }, /*#__PURE__*/_react.default.createElement("div", {
	        className: ['rccs__card', "rccs__card--".concat(this.issuer), focused === 'cvc' && this.issuer !== 'amex' ? 'rccs__card--flipped' : ''].join(' ').trim()
	      }, /*#__PURE__*/_react.default.createElement("div", {
	        className: "rccs__card--front"
	      }, /*#__PURE__*/_react.default.createElement("div", {
	        className: "rccs__card__background"
	      }), /*#__PURE__*/_react.default.createElement("div", {
	        className: "rccs__issuer"
	      }), /*#__PURE__*/_react.default.createElement("div", {
	        className: ['rccs__cvc__front', focused === 'cvc' ? 'rccs--focused' : ''].join(' ').trim()
	      }, cvc), /*#__PURE__*/_react.default.createElement("div", {
	        className: ['rccs__number', number.replace(/ /g, '').length > 16 ? 'rccs__number--large' : '', focused === 'number' ? 'rccs--focused' : '', number.substr(0, 1) !== '•' ? 'rccs--filled' : ''].join(' ').trim()
	      }, number), /*#__PURE__*/_react.default.createElement("div", {
	        className: ['rccs__name', focused === 'name' ? 'rccs--focused' : '', name ? 'rccs--filled' : ''].join(' ').trim()
	      }, name || placeholders.name), /*#__PURE__*/_react.default.createElement("div", {
	        className: ['rccs__expiry', focused === 'expiry' ? 'rccs--focused' : '', expiry.substr(0, 1) !== '•' ? 'rccs--filled' : ''].join(' ').trim()
	      }, /*#__PURE__*/_react.default.createElement("div", {
	        className: "rccs__expiry__valid"
	      }, locale.valid), /*#__PURE__*/_react.default.createElement("div", {
	        className: "rccs__expiry__value"
	      }, expiry)), /*#__PURE__*/_react.default.createElement("div", {
	        className: "rccs__chip"
	      })), /*#__PURE__*/_react.default.createElement("div", {
	        className: "rccs__card--back"
	      }, /*#__PURE__*/_react.default.createElement("div", {
	        className: "rccs__card__background"
	      }), /*#__PURE__*/_react.default.createElement("div", {
	        className: "rccs__stripe"
	      }), /*#__PURE__*/_react.default.createElement("div", {
	        className: "rccs__signature"
	      }), /*#__PURE__*/_react.default.createElement("div", {
	        className: ['rccs__cvc', focused === 'cvc' ? 'rccs--focused' : ''].join(' ').trim()
	      }, cvc), /*#__PURE__*/_react.default.createElement("div", {
	        className: "rccs__issuer"
	      }))));
	    }
	  }, {
	    key: "issuer",
	    get: function get() {
	      var _this$props3 = this.props,
	          issuer = _this$props3.issuer,
	          preview = _this$props3.preview;
	      return preview && issuer ? issuer.toLowerCase() : this.options.issuer;
	    }
	  }, {
	    key: "number",
	    get: function get() {
	      var _this$props4 = this.props,
	          number = _this$props4.number,
	          preview = _this$props4.preview;
	      var maxLength = preview ? 19 : this.options.maxLength;
	      var nextNumber = typeof number === 'number' ? number.toString() : number.replace(/[A-Za-z]| /g, '');
	
	      if (isNaN(parseInt(nextNumber, 10)) && !preview) {
	        nextNumber = '';
	      }
	
	      if (maxLength > 16) {
	        maxLength = nextNumber.length <= 16 ? 16 : maxLength;
	      }
	
	      if (nextNumber.length > maxLength) {
	        nextNumber = nextNumber.slice(0, maxLength);
	      }
	
	      while (nextNumber.length < maxLength) {
	        nextNumber += '•';
	      }
	
	      if (['amex', 'dinersclub'].indexOf(this.issuer) !== -1) {
	        var format = [0, 4, 10];
	        var limit = [4, 6, 5];
	        nextNumber = "".concat(nextNumber.substr(format[0], limit[0]), " ").concat(nextNumber.substr(format[1], limit[1]), " ").concat(nextNumber.substr(format[2], limit[2]));
	      } else if (nextNumber.length > 16) {
	        var _format = [0, 4, 8, 12];
	        var _limit = [4, 7];
	        nextNumber = "".concat(nextNumber.substr(_format[0], _limit[0]), " ").concat(nextNumber.substr(_format[1], _limit[0]), " ").concat(nextNumber.substr(_format[2], _limit[0]), " ").concat(nextNumber.substr(_format[3], _limit[1]));
	      } else {
	        for (var i = 1; i < maxLength / 4; i++) {
	          var space_index = i * 4 + (i - 1);
	          nextNumber = "".concat(nextNumber.slice(0, space_index), " ").concat(nextNumber.slice(space_index));
	        }
	      }
	
	      return nextNumber;
	    }
	  }, {
	    key: "expiry",
	    get: function get() {
	      var _this$props$expiry = this.props.expiry,
	          expiry = _this$props$expiry === void 0 ? '' : _this$props$expiry;
	      var date = typeof expiry === 'number' ? expiry.toString() : expiry;
	      var month = '';
	      var year = '';
	
	      if (date.indexOf('/') !== -1) {
	        var _date$split = date.split('/');
	
	        var _date$split2 = _slicedToArray(_date$split, 2);
	
	        month = _date$split2[0];
	        year = _date$split2[1];
	      } else if (date.length) {
	        month = date.substr(0, 2);
	        year = date.substr(2, 6);
	      }
	
	      while (month.length < 2) {
	        month += '•';
	      }
	
	      if (year.length > 2) {
	        year = year.substr(2, 4);
	      }
	
	      while (year.length < 2) {
	        year += '•';
	      }
	
	      return "".concat(month, "/").concat(year);
	    }
	  }, {
	    key: "options",
	    get: function get() {
	      var number = this.props.number;
	      var issuer = _payment.default.fns.cardType(number) || 'unknown';
	      var maxLength = 16;
	
	      if (issuer === 'amex') {
	        maxLength = 15;
	      } else if (issuer === 'dinersclub') {
	        maxLength = 14;
	      } else if (['hipercard', 'mastercard', 'visa'].indexOf(issuer) !== -1) {
	        maxLength = 19;
	      }
	
	      return {
	        issuer: issuer,
	        maxLength: maxLength
	      };
	    }
	  }]);
	
	  return ReactCreditCards;
	}(_react.default.Component);
	
	_defineProperty(ReactCreditCards, "propTypes", {
	  acceptedCards: _propTypes.default.array,
	  callback: _propTypes.default.func,
	  cvc: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]).isRequired,
	  expiry: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]).isRequired,
	  focused: _propTypes.default.string,
	  issuer: _propTypes.default.string,
	  locale: _propTypes.default.shape({
	    valid: _propTypes.default.string
	  }),
	  name: _propTypes.default.string.isRequired,
	  number: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]).isRequired,
	  placeholders: _propTypes.default.shape({
	    name: _propTypes.default.string
	  }),
	  preview: _propTypes.default.bool
	});
	
	_defineProperty(ReactCreditCards, "defaultProps", {
	  acceptedCards: [],
	  locale: {
	    valid: 'valid thru'
	  },
	  placeholders: {
	    name: 'YOUR NAME HERE'
	  },
	  preview: false
	});
	
	var _default = ReactCreditCards;
	exports.default = _default;

/***/ },
/* 1841 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var React=__webpack_require__(1),styled=__webpack_require__(2171);function _interopDefaultLegacy(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var React__default=_interopDefaultLegacy(React),styled__default=_interopDefaultLegacy(styled);function _typeof(e){return(_typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function _defineProperty(e,t,n){return t in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}function _extends(){return(_extends=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n,r=arguments[t];for(n in r)Object.prototype.hasOwnProperty.call(r,n)&&(e[n]=r[n])}return e}).apply(this,arguments)}function ownKeys(t,e){var n,r=Object.keys(t);return Object.getOwnPropertySymbols&&(n=Object.getOwnPropertySymbols(t),e&&(n=n.filter(function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable})),r.push.apply(r,n)),r}function _objectSpread2(t){for(var e=1;e<arguments.length;e++){var n=null!=arguments[e]?arguments[e]:{};e%2?ownKeys(Object(n),!0).forEach(function(e){_defineProperty(t,e,n[e])}):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(n)):ownKeys(Object(n)).forEach(function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(n,e))})}return t}function _taggedTemplateLiteral(e,t){return t=t||e.slice(0),Object.freeze(Object.defineProperties(e,{raw:{value:Object.freeze(t)}}))}function _slicedToArray(e,t){return _arrayWithHoles(e)||_iterableToArrayLimit(e,t)||_unsupportedIterableToArray(e,t)||_nonIterableRest()}function _toConsumableArray(e){return _arrayWithoutHoles(e)||_iterableToArray(e)||_unsupportedIterableToArray(e)||_nonIterableSpread()}function _arrayWithoutHoles(e){if(Array.isArray(e))return _arrayLikeToArray(e)}function _arrayWithHoles(e){if(Array.isArray(e))return e}function _iterableToArray(e){if("undefined"!=typeof Symbol&&Symbol.iterator in Object(e))return Array.from(e)}function _iterableToArrayLimit(e,t){if("undefined"!=typeof Symbol&&Symbol.iterator in Object(e)){var n=[],r=!0,o=!1,a=void 0;try{for(var l,i=e[Symbol.iterator]();!(r=(l=i.next()).done)&&(n.push(l.value),!t||n.length!==t);r=!0);}catch(e){o=!0,a=e}finally{try{r||null==i.return||i.return()}finally{if(o)throw a}}return n}}function _unsupportedIterableToArray(e,t){if(e){if("string"==typeof e)return _arrayLikeToArray(e,t);var n=Object.prototype.toString.call(e).slice(8,-1);return"Object"===n&&e.constructor&&(n=e.constructor.name),"Map"===n||"Set"===n?Array.from(e):"Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)?_arrayLikeToArray(e,t):void 0}}function _arrayLikeToArray(e,t){(null==t||t>e.length)&&(t=e.length);for(var n=0,r=new Array(t);n<t;n++)r[n]=e[n];return r}function _nonIterableSpread(){throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}function _nonIterableRest(){throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}var commonjsGlobal="undefined"!=typeof globalThis?globalThis:"undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{};function createCommonjsModule(e,t){return e(t={exports:{}},t.exports),t.exports}var b="function"==typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;function z(o){if("object"==typeof o&&null!==o){var a=o.$$typeof;switch(a){case c:switch(o=o.type){case l:case m:case e:case g:case f:case p:return o;default:switch(o=o&&o.$$typeof){case k:case n:case t:case r:case h:return o;default:return a}}case d:return a}}}function A(e){return z(e)===m}var AsyncMode=l,ConcurrentMode=m,ContextConsumer=k,ContextProvider=h,Element=c,ForwardRef=n,Fragment=e,Lazy=t,Memo=r,Portal=d,Profiler=g,StrictMode=f,Suspense=p,isAsyncMode=function(e){return A(e)||z(e)===l},isConcurrentMode=A,isContextConsumer=function(e){return z(e)===k},isContextProvider=function(e){return z(e)===h},isElement=function(e){return"object"==typeof e&&null!==e&&e.$$typeof===c},isForwardRef=function(e){return z(e)===n},isFragment=function(t){return z(t)===e},isLazy=function(e){return z(e)===t},isMemo=function(e){return z(e)===r},isPortal=function(e){return z(e)===d},isProfiler=function(e){return z(e)===g},isStrictMode=function(e){return z(e)===f},isSuspense=function(e){return z(e)===p},isValidElementType=function(o){return"string"==typeof o||"function"==typeof o||o===e||o===m||o===g||o===f||o===p||o===q||"object"==typeof o&&null!==o&&(o.$$typeof===t||o.$$typeof===r||o.$$typeof===h||o.$$typeof===k||o.$$typeof===n||o.$$typeof===w||o.$$typeof===x||o.$$typeof===y||o.$$typeof===v)},typeOf=z,reactIs_production_min={AsyncMode:l,ConcurrentMode:m,ContextConsumer:k,ContextProvider:h,Element:c,ForwardRef:n,Fragment:e,Lazy:t,Memo:r,Portal:d,Profiler:g,StrictMode:f,Suspense:p,isAsyncMode:isAsyncMode,isConcurrentMode:A,isContextConsumer:isContextConsumer,isContextProvider:isContextProvider,isElement:isElement,isForwardRef:isForwardRef,isFragment:isFragment,isLazy:isLazy,isMemo:isMemo,isPortal:isPortal,isProfiler:isProfiler,isStrictMode:isStrictMode,isSuspense:isSuspense,isValidElementType:isValidElementType,typeOf:z},reactIs_development=createCommonjsModule(function(e,t){function n(e){if("object"==typeof e&&null!==e){var t=e.$$typeof;switch(t){case a:e=e.type;switch(e){case d:case f:case i:case u:case c:case b:return e;default:e=e&&e.$$typeof;switch(e){case p:case y:case _:case g:case s:return e;default:return t}}case l:return t}}}function r(e){return n(e)===f}var o,a,l,i,c,u,s,p,d,f,y,b,m,g,_,h,v,T,w,R,x,O,S,C,j,E,P,$,I,k,A;"production"!==("production")&&(o="function"==typeof Symbol&&Symbol.for,a=o?Symbol.for("react.element"):60103,l=o?Symbol.for("react.portal"):60106,i=o?Symbol.for("react.fragment"):60107,c=o?Symbol.for("react.strict_mode"):60108,u=o?Symbol.for("react.profiler"):60114,s=o?Symbol.for("react.provider"):60109,p=o?Symbol.for("react.context"):60110,d=o?Symbol.for("react.async_mode"):60111,f=o?Symbol.for("react.concurrent_mode"):60111,y=o?Symbol.for("react.forward_ref"):60112,b=o?Symbol.for("react.suspense"):60113,m=o?Symbol.for("react.suspense_list"):60120,g=o?Symbol.for("react.memo"):60115,_=o?Symbol.for("react.lazy"):60116,h=o?Symbol.for("react.block"):60121,v=o?Symbol.for("react.fundamental"):60117,T=o?Symbol.for("react.responder"):60118,w=o?Symbol.for("react.scope"):60119,R=f,x=p,O=s,S=a,C=y,j=i,E=_,P=g,$=l,I=u,k=c,o=b,A=!1,t.AsyncMode=d,t.ConcurrentMode=R,t.ContextConsumer=x,t.ContextProvider=O,t.Element=S,t.ForwardRef=C,t.Fragment=j,t.Lazy=E,t.Memo=P,t.Portal=$,t.Profiler=I,t.StrictMode=k,t.Suspense=o,t.isAsyncMode=function(e){return A||(A=!0,console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")),r(e)||n(e)===d},t.isConcurrentMode=r,t.isContextConsumer=function(e){return n(e)===p},t.isContextProvider=function(e){return n(e)===s},t.isElement=function(e){return"object"==typeof e&&null!==e&&e.$$typeof===a},t.isForwardRef=function(e){return n(e)===y},t.isFragment=function(e){return n(e)===i},t.isLazy=function(e){return n(e)===_},t.isMemo=function(e){return n(e)===g},t.isPortal=function(e){return n(e)===l},t.isProfiler=function(e){return n(e)===u},t.isStrictMode=function(e){return n(e)===c},t.isSuspense=function(e){return n(e)===b},t.isValidElementType=function(e){return"string"==typeof e||"function"==typeof e||e===i||e===f||e===u||e===c||e===b||e===m||"object"==typeof e&&null!==e&&(e.$$typeof===_||e.$$typeof===g||e.$$typeof===s||e.$$typeof===p||e.$$typeof===y||e.$$typeof===v||e.$$typeof===T||e.$$typeof===w||e.$$typeof===h)},t.typeOf=n)}),reactIs_development_1=reactIs_development.AsyncMode,reactIs_development_2=reactIs_development.ConcurrentMode,reactIs_development_3=reactIs_development.ContextConsumer,reactIs_development_4=reactIs_development.ContextProvider,reactIs_development_5=reactIs_development.Element,reactIs_development_6=reactIs_development.ForwardRef,reactIs_development_7=reactIs_development.Fragment,reactIs_development_8=reactIs_development.Lazy,reactIs_development_9=reactIs_development.Memo,reactIs_development_10=reactIs_development.Portal,reactIs_development_11=reactIs_development.Profiler,reactIs_development_12=reactIs_development.StrictMode,reactIs_development_13=reactIs_development.Suspense,reactIs_development_14=reactIs_development.isAsyncMode,reactIs_development_15=reactIs_development.isConcurrentMode,reactIs_development_16=reactIs_development.isContextConsumer,reactIs_development_17=reactIs_development.isContextProvider,reactIs_development_18=reactIs_development.isElement,reactIs_development_19=reactIs_development.isForwardRef,reactIs_development_20=reactIs_development.isFragment,reactIs_development_21=reactIs_development.isLazy,reactIs_development_22=reactIs_development.isMemo,reactIs_development_23=reactIs_development.isPortal,reactIs_development_24=reactIs_development.isProfiler,reactIs_development_25=reactIs_development.isStrictMode,reactIs_development_26=reactIs_development.isSuspense,reactIs_development_27=reactIs_development.isValidElementType,reactIs_development_28=reactIs_development.typeOf,reactIs=createCommonjsModule(function(e){ true?e.exports=reactIs_production_min:e.exports=reactIs_development}),getOwnPropertySymbols=Object.getOwnPropertySymbols,hasOwnProperty=Object.prototype.hasOwnProperty,propIsEnumerable=Object.prototype.propertyIsEnumerable;function toObject(e){if(null==e)throw new TypeError("Object.assign cannot be called with null or undefined");return Object(e)}function shouldUseNative(){try{if(!Object.assign)return!1;var e=new String("abc");if(e[5]="de","5"===Object.getOwnPropertyNames(e)[0])return!1;for(var t={},n=0;n<10;n++)t["_"+String.fromCharCode(n)]=n;if("0123456789"!==Object.getOwnPropertyNames(t).map(function(e){return t[e]}).join(""))return!1;var r={};return"abcdefghijklmnopqrst".split("").forEach(function(e){r[e]=e}),"abcdefghijklmnopqrst"===Object.keys(Object.assign({},r)).join("")}catch(e){return!1}}var ReactPropTypesSecret$1,loggedTypeFailures,has,objectAssign=shouldUseNative()?Object.assign:function(e,t){for(var n,r,o=toObject(e),a=1;a<arguments.length;a++){for(var l in n=Object(arguments[a]))hasOwnProperty.call(n,l)&&(o[l]=n[l]);if(getOwnPropertySymbols){r=getOwnPropertySymbols(n);for(var i=0;i<r.length;i++)propIsEnumerable.call(n,r[i])&&(o[r[i]]=n[r[i]])}}return o},ReactPropTypesSecret="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED",ReactPropTypesSecret_1=ReactPropTypesSecret,printWarning=function(){};function checkPropTypes(e,t,n,r,o){if(false)for(var a in e)if(has(e,a)){var l,i;try{if("function"!=typeof e[a]){var c=Error((r||"React class")+": "+n+" type `"+a+"` is invalid; it must be a function, usually from the `prop-types` package, but received `"+typeof e[a]+"`.");throw c.name="Invariant Violation",c}l=e[a](t,a,r,n,null,ReactPropTypesSecret$1)}catch(e){l=e}!l||l instanceof Error||printWarning((r||"React class")+": type specification of "+n+" `"+a+"` is invalid; the type checker function must return `null` or an `Error` but returned a "+typeof l+". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."),l instanceof Error&&!(l.message in loggedTypeFailures)&&(loggedTypeFailures[l.message]=!0,i=o?o():"",printWarning("Failed "+n+" type: "+l.message+(null!=i?i:"")))}}"production"!==("production")&&(ReactPropTypesSecret$1=ReactPropTypesSecret_1,loggedTypeFailures={},has=Function.call.bind(Object.prototype.hasOwnProperty),printWarning=function(e){var t="Warning: "+e;"undefined"!=typeof console&&console.error(t);try{throw new Error(t)}catch(e){}}),checkPropTypes.resetWarningCache=function(){"production"!==("production")&&(loggedTypeFailures={})};var checkPropTypes_1=checkPropTypes,has$1=Function.call.bind(Object.prototype.hasOwnProperty),printWarning$1=function(){};function emptyFunctionThatReturnsNull(){return null}"production"!==("production")&&(printWarning$1=function(e){var t="Warning: "+e;"undefined"!=typeof console&&console.error(t);try{throw new Error(t)}catch(e){}});var factoryWithTypeCheckers=function(a,p){var l="function"==typeof Symbol&&Symbol.iterator,i="@@iterator";var d="<<anonymous>>",e={array:t("array"),bool:t("boolean"),func:t("function"),number:t("number"),object:t("object"),string:t("string"),symbol:t("symbol"),any:n(emptyFunctionThatReturnsNull),arrayOf:function(c){return n(function(e,t,n,r,o){if("function"!=typeof c)return new f("Property `"+o+"` of component `"+n+"` has invalid PropType notation inside arrayOf.");var a=e[t];if(!Array.isArray(a))return new f("Invalid "+r+" `"+o+"` of type `"+s(a)+"` supplied to `"+n+"`, expected an array.");for(var l=0;l<a.length;l++){var i=c(a,l,n,r,o+"["+l+"]",ReactPropTypesSecret_1);if(i instanceof Error)return i}return null})},element:n(function(e,t,n,r,o){return t=e[t],a(t)?null:new f("Invalid "+r+" `"+o+"` of type `"+s(t)+"` supplied to `"+n+"`, expected a single ReactElement.")}),elementType:n(function(e,t,n,r,o){return t=e[t],reactIs.isValidElementType(t)?null:new f("Invalid "+r+" `"+o+"` of type `"+s(t)+"` supplied to `"+n+"`, expected a single ReactElement type.")}),instanceOf:function(l){return n(function(e,t,n,r,o){if(e[t]instanceof l)return null;var a=l.name||d;return new f("Invalid "+r+" `"+o+"` of type `"+((t=e[t]).constructor&&t.constructor.name?t.constructor.name:d)+"` supplied to `"+n+"`, expected instance of `"+a+"`.")})},node:n(function(e,t,n,r,o){return c(e[t])?null:new f("Invalid "+r+" `"+o+"` supplied to `"+n+"`, expected a ReactNode.")}),objectOf:function(c){return n(function(e,t,n,r,o){if("function"!=typeof c)return new f("Property `"+o+"` of component `"+n+"` has invalid PropType notation inside objectOf.");var a,l=e[t];if("object"!==(t=s(l)))return new f("Invalid "+r+" `"+o+"` of type `"+t+"` supplied to `"+n+"`, expected an object.");for(a in l)if(has$1(l,a)){var i=c(l,a,n,r,o+"."+a,ReactPropTypesSecret_1);if(i instanceof Error)return i}return null})},oneOf:function(i){if(Array.isArray(i))return n(function(e,t,n,r,o){for(var a=e[t],l=0;l<i.length;l++)if(function(e,t){return e===t?0!==e||1/e==1/t:e!=e&&t!=t}(a,i[l]))return null;t=JSON.stringify(i,function(e,t){return"symbol"===u(t)?String(t):t});return new f("Invalid "+r+" `"+o+"` of value `"+String(a)+"` supplied to `"+n+"`, expected one of "+t+".")});"production"!==("production")&&printWarning$1(1<arguments.length?"Invalid arguments supplied to oneOf, expected an array, got "+arguments.length+" arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).":"Invalid argument supplied to oneOf, expected an array.");return emptyFunctionThatReturnsNull},oneOfType:function(l){if(!Array.isArray(l))return"production"!==("production")&&printWarning$1("Invalid argument supplied to oneOfType, expected an instance of array."),emptyFunctionThatReturnsNull;for(var e=0;e<l.length;e++){var t=l[e];if("function"!=typeof t)return printWarning$1("Invalid argument supplied to oneOfType. Expected an array of check functions, but received "+function(e){e=u(e);switch(e){case"array":case"object":return"an "+e;case"boolean":case"date":case"regexp":return"a "+e;default:return e}}(t)+" at index "+e+"."),emptyFunctionThatReturnsNull}return n(function(e,t,n,r,o){for(var a=0;a<l.length;a++)if(null==(0,l[a])(e,t,n,r,o,ReactPropTypesSecret_1))return null;return new f("Invalid "+r+" `"+o+"` supplied to `"+n+"`.")})},shape:function(c){return n(function(e,t,n,r,o){var a,l=e[t];if("object"!==(t=s(l)))return new f("Invalid "+r+" `"+o+"` of type `"+t+"` supplied to `"+n+"`, expected `object`.");for(a in c){var i=c[a];if(i){i=i(l,a,n,r,o+"."+a,ReactPropTypesSecret_1);if(i)return i}}return null})},exact:function(u){return n(function(e,t,n,r,o){var a,l=e[t],i=s(l);if("object"!==i)return new f("Invalid "+r+" `"+o+"` of type `"+i+"` supplied to `"+n+"`, expected `object`.");for(a in objectAssign({},e[t],u)){var c=u[a];if(!c)return new f("Invalid "+r+" `"+o+"` key `"+a+"` supplied to `"+n+"`.\nBad object: "+JSON.stringify(e[t],null,"  ")+"\nValid keys: "+JSON.stringify(Object.keys(u),null,"  "));c=c(l,a,n,r,o+"."+a,ReactPropTypesSecret_1);if(c)return c}return null})}};function f(e){this.message=e,this.stack=""}function n(c){var u,s;function e(e,t,n,r,o,a,l){if(r=r||d,a=a||n,l!==ReactPropTypesSecret_1){if(p){var i=new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");throw i.name="Invariant Violation",i}"production"===("production")||"undefined"==typeof console||!u[i=r+":"+n]&&s<3&&(printWarning$1("You are manually calling a React.PropTypes validation function for the `"+a+"` prop on `"+r+"`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."),u[i]=!0,s++)}return null==t[n]?e?null===t[n]?new f("The "+o+" `"+a+"` is marked as required in `"+r+"`, but its value is `null`."):new f("The "+o+" `"+a+"` is marked as required in `"+r+"`, but its value is `undefined`."):null:c(t,n,r,o,a)}"production"!==("production")&&(u={},s=0);var t=e.bind(null,!1);return t.isRequired=e.bind(null,!0),t}function t(l){return n(function(e,t,n,r,o,a){return s(t=e[t])===l?null:new f("Invalid "+r+" `"+o+"` of type `"+u(t)+"` supplied to `"+n+"`, expected `"+l+"`.")})}function c(e){switch(typeof e){case"number":case"string":case"undefined":return!0;case"boolean":return!e;case"object":if(Array.isArray(e))return e.every(c);if(null===e||a(e))return!0;var t=function(e){if("function"==typeof(e=e&&(l&&e[l]||e[i])))return e}(e);if(!t)return!1;var n,r=t.call(e);if(t!==e.entries){for(;!(n=r.next()).done;)if(!c(n.value))return!1}else for(;!(n=r.next()).done;){var o=n.value;if(o&&!c(o[1]))return!1}return!0;default:return!1}}function s(e){var t=typeof e;return Array.isArray(e)?"array":e instanceof RegExp?"object":(e=e,"symbol"===t||e&&("Symbol"===e["@@toStringTag"]||"function"==typeof Symbol&&e instanceof Symbol)?"symbol":t)}function u(e){if(null==e)return""+e;var t=s(e);if("object"===t){if(e instanceof Date)return"date";if(e instanceof RegExp)return"regexp"}return t}return f.prototype=Error.prototype,e.checkPropTypes=checkPropTypes_1,e.resetWarningCache=checkPropTypes_1.resetWarningCache,e.PropTypes=e};function emptyFunction(){}function emptyFunctionWithReset(){}emptyFunctionWithReset.resetWarningCache=emptyFunction;var factoryWithThrowingShims=function(){function e(e,t,n,r,o,a){if(a!==ReactPropTypesSecret_1){a=new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");throw a.name="Invariant Violation",a}}function t(){return e}var n={array:e.isRequired=e,bool:e,func:e,number:e,object:e,string:e,symbol:e,any:e,arrayOf:t,element:e,elementType:e,instanceOf:t,node:e,objectOf:t,oneOf:t,oneOfType:t,shape:t,exact:t,checkPropTypes:emptyFunctionWithReset,resetWarningCache:emptyFunction};return n.PropTypes=n},propTypes=createCommonjsModule(function(e){ false?e.exports=factoryWithTypeCheckers(reactIs.isElement,!0):e.exports=factoryWithThrowingShims()}),DataTableStateContext=React.createContext(),useTableContext=function(){return React.useContext(DataTableStateContext)},DataTableProvider=function(e){var t=e.children,e=e.initialState;return React__default.default.createElement(DataTableStateContext.Provider,{value:e},t)};DataTableProvider.propTypes={initialState:propTypes.object.isRequired,children:propTypes.oneOfType([propTypes.arrayOf(propTypes.node),propTypes.node]).isRequired};var seed=1;function getNextValue(){return(seed=(9301*seed+49297)%233280)/233280}function setSeed(e){seed=e}var alphabet,previousSeed,shuffled,randomFromSeed={nextValue:getNextValue,seed:setSeed},ORIGINAL="0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ_-";function reset(){shuffled=!1}function setCharacters(e){if(e){if(e!==alphabet){if(e.length!==ORIGINAL.length)throw new Error("Custom alphabet for shortid must be "+ORIGINAL.length+" unique characters. You submitted "+e.length+" characters: "+e);var t=e.split("").filter(function(e,t,n){return t!==n.lastIndexOf(e)});if(t.length)throw new Error("Custom alphabet for shortid must be "+ORIGINAL.length+" unique characters. These characters were not unique: "+t.join(", "));alphabet=e,reset()}}else alphabet!==ORIGINAL&&(alphabet=ORIGINAL,reset())}function characters(e){return setCharacters(e),alphabet}function setSeed$1(e){randomFromSeed.seed(e),previousSeed!==e&&(reset(),previousSeed=e)}function shuffle(){alphabet||setCharacters(ORIGINAL);for(var e,t=alphabet.split(""),n=[],r=randomFromSeed.nextValue();0<t.length;)r=randomFromSeed.nextValue(),e=Math.floor(r*t.length),n.push(t.splice(e,1)[0]);return n.join("")}function getShuffled(){return shuffled=shuffled||shuffle()}function lookup(e){return getShuffled()[e]}function get(){return alphabet||ORIGINAL}var alphabet_1={get:get,characters:characters,seed:setSeed$1,lookup:lookup,shuffled:getShuffled},crypto="object"==typeof window&&(window.crypto||window.msCrypto),randomByte=crypto&&crypto.getRandomValues?function(e){return crypto.getRandomValues(new Uint8Array(e))}:function(e){for(var t=[],n=0;n<e;n++)t.push(Math.floor(256*Math.random()));return t},randomByteBrowser=randomByte,format_browser=function(e,t,n){for(var r=(2<<Math.log(t.length-1)/Math.LN2)-1,o=-~(1.6*r*n/t.length),a="";;)for(var l=e(o),i=o;i--;)if((a+=t[l[i]&r]||"").length===+n)return a};function generate(e){for(var t,n=0,r="";!t;)r+=format_browser(randomByteBrowser,alphabet_1.get(),1),t=e<Math.pow(16,n+1),n++;return r}var counter,previousSeconds,generate_1=generate,REDUCE_TIME=1567752802062,version=7;function build(e){var t="",n=Math.floor(.001*(Date.now()-REDUCE_TIME));return n===previousSeconds?counter++:(counter=0,previousSeconds=n),t+=generate_1(version),t+=generate_1(e),0<counter&&(t+=generate_1(counter)),t+=generate_1(n)}var build_1=build;function isShortId(e){return!(!e||"string"!=typeof e||e.length<6)&&!new RegExp("[^"+alphabet_1.get().replace(/[|\\{}()[\]^$+*?.-]/g,"\\$&")+"]").test(e)}var isValid=isShortId,lib=createCommonjsModule(function(t){var n=0;function e(){return build_1(n)}t.exports=e,t.exports.generate=e,t.exports.seed=function(e){return alphabet_1.seed(e),t.exports},t.exports.worker=function(e){return n=e,t.exports},t.exports.characters=function(e){return void 0!==e&&alphabet_1.characters(e),alphabet_1.shuffled()},t.exports.isValid=isValid}),lib_1=lib.generate,lib_2=lib.seed,lib_3=lib.worker,lib_4=lib.characters,lib_5=lib.isValid,shortid=lib,lodash_orderby=createCommonjsModule(function(e,t){var n="Expected a function",r="__lodash_hash_undefined__",b=1,_=2,a=1/0,o=9007199254740991,p="[object Arguments]",d="[object Array]",f="[object Boolean]",y="[object Date]",m="[object Error]",l="[object Function]",i="[object GeneratorFunction]",g="[object Map]",h="[object Number]",v="[object Object]",c="[object Promise]",T="[object RegExp]",w="[object Set]",R="[object String]",x="[object Symbol]",u="[object WeakMap]",O="[object ArrayBuffer]",S="[object DataView]",s=/\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,C=/^\w*$/,j=/^\./,E=/[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,P=/\\(\\)?/g,$=/^\[object .+?Constructor\]$/,I=/^(?:0|[1-9]\d*)$/,k={};k["[object Float32Array]"]=k["[object Float64Array]"]=k["[object Int8Array]"]=k["[object Int16Array]"]=k["[object Int32Array]"]=k["[object Uint8Array]"]=k["[object Uint8ClampedArray]"]=k["[object Uint16Array]"]=k["[object Uint32Array]"]=!0,k[p]=k[d]=k[O]=k[f]=k[S]=k[y]=k[m]=k[l]=k[g]=k[h]=k[v]=k[T]=k[w]=k[R]=k[u]=!1;var A="object"==typeof commonjsGlobal&&commonjsGlobal&&commonjsGlobal.Object===Object&&commonjsGlobal,L="object"==typeof self&&self&&self.Object===Object&&self,F=A||L||Function("return this")(),M=t&&!t.nodeType&&t,H=M&&e&&!e.nodeType&&e,N=H&&H.exports===M&&A.process,L=function(){try{return N&&N.binding("util")}catch(e){}}(),t=L&&L.isTypedArray;function D(e,t){for(var n=-1,r=e?e.length:0,o=Array(r);++n<r;)o[n]=t(e[n],n,e);return o}function z(t){return function(e){return t(e)}}function W(e){var t=!1;if(null!=e&&"function"!=typeof e.toString)try{t=!!(e+"")}catch(e){}return t}function q(e){var n=-1,r=Array(e.size);return e.forEach(function(e,t){r[++n]=[t,e]}),r}function B(e){var t=-1,n=Array(e.size);return e.forEach(function(e){n[++t]=e}),n}var V,U,H=Array.prototype,M=Function.prototype,G=Object.prototype,A=F["__core-js_shared__"],Y=(L=/[^.]+$/.exec(A&&A.keys&&A.keys.IE_PROTO||""))?"Symbol(src)_1."+L:"",K=M.toString,J=G.hasOwnProperty,Q=G.toString,X=RegExp("^"+K.call(J).replace(/[\\^$.*+?()[\]{}|]/g,"\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,"$1.*?")+"$"),A=F.Symbol,Z=F.Uint8Array,ee=G.propertyIsEnumerable,te=H.splice,ne=(V=Object.keys,U=Object,function(e){return V(U(e))}),L=Ae(F,"DataView"),re=Ae(F,"Map"),M=Ae(F,"Promise"),H=Ae(F,"Set"),F=Ae(F,"WeakMap"),oe=Ae(Object,"create"),ae=We(L),le=We(re),ie=We(M),ce=We(H),ue=We(F),A=A?A.prototype:void 0,se=A?A.valueOf:void 0,pe=A?A.toString:void 0;function de(e){var t=-1,n=e?e.length:0;for(this.clear();++t<n;){var r=e[t];this.set(r[0],r[1])}}function fe(e){var t=-1,n=e?e.length:0;for(this.clear();++t<n;){var r=e[t];this.set(r[0],r[1])}}function ye(e){var t=-1,n=e?e.length:0;for(this.clear();++t<n;){var r=e[t];this.set(r[0],r[1])}}function be(e){var t=-1,n=e?e.length:0;for(this.__data__=new ye;++t<n;)this.add(e[t])}function me(e){this.__data__=new fe(e)}function ge(e,t){var n,r=Ue(e)||Ve(e)?function(e,t){for(var n=-1,r=Array(e);++n<e;)r[n]=t(n);return r}(e.length,String):[],o=r.length,a=!!o;for(n in e)!t&&!J.call(e,n)||a&&("length"==n||Fe(n,o))||r.push(n);return r}function _e(e,t){for(var n=e.length;n--;)if(Be(e[n][0],t))return n;return-1}de.prototype.clear=function(){this.__data__=oe?oe(null):{}},de.prototype.delete=function(e){return this.has(e)&&delete this.__data__[e]},de.prototype.get=function(e){var t=this.__data__;if(oe){var n=t[e];return n===r?void 0:n}return J.call(t,e)?t[e]:void 0},de.prototype.has=function(e){var t=this.__data__;return oe?void 0!==t[e]:J.call(t,e)},de.prototype.set=function(e,t){return this.__data__[e]=oe&&void 0===t?r:t,this},fe.prototype.clear=function(){this.__data__=[]},fe.prototype.delete=function(e){var t=this.__data__;return!((e=_e(t,e))<0)&&(e==t.length-1?t.pop():te.call(t,e,1),!0)},fe.prototype.get=function(e){var t=this.__data__;return(e=_e(t,e))<0?void 0:t[e][1]},fe.prototype.has=function(e){return-1<_e(this.__data__,e)},fe.prototype.set=function(e,t){var n=this.__data__,r=_e(n,e);return r<0?n.push([e,t]):n[r][1]=t,this},ye.prototype.clear=function(){this.__data__={hash:new de,map:new(re||fe),string:new de}},ye.prototype.delete=function(e){return ke(this,e).delete(e)},ye.prototype.get=function(e){return ke(this,e).get(e)},ye.prototype.has=function(e){return ke(this,e).has(e)},ye.prototype.set=function(e,t){return ke(this,e).set(e,t),this},be.prototype.add=be.prototype.push=function(e){return this.__data__.set(e,r),this},be.prototype.has=function(e){return this.__data__.has(e)},me.prototype.clear=function(){this.__data__=new fe},me.prototype.delete=function(e){return this.__data__.delete(e)},me.prototype.get=function(e){return this.__data__.get(e)},me.prototype.has=function(e){return this.__data__.has(e)},me.prototype.set=function(e,t){var n=this.__data__;if(n instanceof fe){var r=n.__data__;if(!re||r.length<199)return r.push([e,t]),this;n=this.__data__=new ye(r)}return n.set(e,t),this};var he,ve,Te,we=(he=function(e,t){return e&&Re(e,t,et)},function(e,t){if(null==e)return e;if(!Ge(e))return he(e,t);for(var n=e.length,r=ve?n:-1,o=Object(e);(ve?r--:++r<n)&&!1!==t(o[r],r,o););return e}),Re=function(e,t,n){for(var r=-1,o=Object(e),a=n(e),l=a.length;l--;){var i=a[Te?l:++r];if(!1===t(o[i],i,o))break}return e};function xe(e,t){for(var n=0,r=(t=Me(t,e)?[t]:$e(t)).length;null!=e&&n<r;)e=e[ze(t[n++])];return n&&n==r?e:void 0}function Oe(e,t){return null!=e&&t in Object(e)}function Se(e,t,n,r,o){return e===t||(null==e||null==t||!Je(e)&&!Qe(t)?e!=e&&t!=t:function(e,t,n,r,o,a){var l=Ue(e),i=Ue(t),c=d,u=d;l||(c=(c=Le(e))==p?v:c);i||(u=(u=Le(t))==p?v:u);var s=c==v&&!W(e),i=u==v&&!W(t),u=c==u;if(u&&!s)return a=a||new me,l||Ze(e)?Ie(e,t,n,r,o,a):function(e,t,n,r,o,a,l){switch(n){case S:if(e.byteLength!=t.byteLength||e.byteOffset!=t.byteOffset)return!1;e=e.buffer,t=t.buffer;case O:return e.byteLength==t.byteLength&&r(new Z(e),new Z(t))?!0:!1;case f:case y:case h:return Be(+e,+t);case m:return e.name==t.name&&e.message==t.message;case T:case R:return e==t+"";case g:var i=q;case w:n=a&_;if(i=i||B,e.size!=t.size&&!n)return!1;n=l.get(e);if(n)return n==t;a|=b,l.set(e,t);a=Ie(i(e),i(t),r,o,a,l);return l.delete(e),a;case x:if(se)return se.call(e)==se.call(t)}return!1}(e,t,c,n,r,o,a);if(!(o&_)){s=s&&J.call(e,"__wrapped__"),i=i&&J.call(t,"__wrapped__");if(s||i){s=s?e.value():e,i=i?t.value():t;return a=a||new me,n(s,i,r,o,a)}}return u&&(a=a||new me,function(e,t,n,r,o,a){var l=o&_,i=et(e),c=i.length,u=et(t).length;if(c!=u&&!l)return!1;var s=c;for(;s--;){var p=i[s];if(!(l?p in t:J.call(t,p)))return!1}var d=a.get(e);if(d&&a.get(t))return d==t;var f=!0;a.set(e,t),a.set(t,e);var y=l;for(;++s<c;){p=i[s];var b,m=e[p],g=t[p];if(r&&(b=l?r(g,m,p,t,e,a):r(m,g,p,e,t,a)),!(void 0===b?m===g||n(m,g,r,o,a):b)){f=!1;break}y=y||"constructor"==p}f&&!y&&(u=e.constructor,d=t.constructor,u!=d&&"constructor"in e&&"constructor"in t&&!("function"==typeof u&&u instanceof u&&"function"==typeof d&&d instanceof d)&&(f=!1));return a.delete(e),a.delete(t),f}(e,t,n,r,o,a))}(e,t,Se,n,r,o))}function Ce(e){var t;return Je(e)&&(t=e,!(Y&&Y in t))&&(Ye(e)||W(e)?X:$).test(We(e))}function je(e){return"function"==typeof e?e:null==e?tt:"object"==typeof e?Ue(e)?function(r,o){if(Me(r)&&He(o))return Ne(ze(r),o);return function(e){var t,n=function(e,t,n){t=null==e?void 0:xe(e,t);return void 0===t?n:t}(e,r);return void 0===n&&n===o?(t=r,null!=(e=e)&&function(e,t,n){t=Me(t,e)?[t]:$e(t);var r,o=-1,a=t.length;for(;++o<a;){var l=ze(t[o]);if(!(r=null!=e&&n(e,l)))break;e=e[l]}if(r)return r;return!!(a=e?e.length:0)&&Ke(a)&&Fe(l,a)&&(Ue(e)||Ve(e))}(e,t,Oe)):Se(o,n,void 0,b|_)}}(e[0],e[1]):function(t){var n=function(e){var t=et(e),n=t.length;for(;n--;){var r=t[n],o=e[r];t[n]=[r,o,He(o)]}return t}(t);if(1==n.length&&n[0][2])return Ne(n[0][0],n[0][1]);return function(e){return e===t||function(e,t,n,r){var o=n.length,a=o,l=!r;if(null==e)return!a;for(e=Object(e);o--;){var i=n[o];if(l&&i[2]?i[1]!==e[i[0]]:!(i[0]in e))return!1}for(;++o<a;){var c=(i=n[o])[0],u=e[c],s=i[1];if(l&&i[2]){if(void 0===u&&!(c in e))return!1}else{var p,d=new me;if(r&&(p=r(u,s,c,e,t,d)),!(void 0===p?Se(s,u,r,b|_,d):p))return!1}}return!0}(e,t,n)}}(e):Me(e=e)?function(t){return function(e){return null==e?void 0:e[t]}}(ze(e)):function(t){return function(e){return xe(e,t)}}(e)}function Ee(e){if(n="function"==typeof(n=(t=e)&&t.constructor)&&n.prototype||G,t!==n)return ne(e);var t,n,r,o=[];for(r in Object(e))J.call(e,r)&&"constructor"!=r&&o.push(r);return o}function Pe(e,r,n){var o,a,l,i=-1;return r=D(r.length?r:[tt],z(je)),function(e,t){var n=e.length;for(e.sort(t);n--;)e[n]=e[n].value;return e}((o=function(t,e,n){return{criteria:D(r,function(e){return e(t)}),index:++i,value:t}},a=-1,l=Ge(e=e)?Array(e.length):[],we(e,function(e,t,n){l[++a]=o(e,t,n)}),l),function(e,t){return function(e,t,n){var r=-1,o=e.criteria,a=t.criteria,l=o.length,i=n.length;for(;++r<l;){var c=function(e,t){if(e!==t){var n=void 0!==e,r=null===e,o=e==e,a=Xe(e),l=void 0!==t,i=null===t,c=t==t,u=Xe(t);if(!i&&!u&&!a&&t<e||a&&l&&c&&!i&&!u||r&&l&&c||!n&&c||!o)return 1;if(!r&&!a&&!u&&e<t||u&&n&&o&&!r&&!a||i&&n&&o||!l&&o||!c)return-1}return 0}(o[r],a[r]);if(c){if(i<=r)return c;var u=n[r];return c*("desc"==u?-1:1)}}return e.index-t.index}(e,t,n)})}function $e(e){return Ue(e)?e:De(e)}function Ie(e,t,n,r,o,a){var l=o&_,i=e.length,c=t.length;if(i!=c&&!(l&&i<c))return!1;c=a.get(e);if(c&&a.get(t))return c==t;var u=-1,s=!0,p=o&b?new be:void 0;for(a.set(e,t),a.set(t,e);++u<i;){var d,f=e[u],y=t[u];if(r&&(d=l?r(y,f,u,t,e,a):r(f,y,u,e,t,a)),void 0!==d){if(d)continue;s=!1;break}if(p){if(!function(e,t){for(var n=-1,r=e?e.length:0;++n<r;)if(t(e[n],n,e))return 1}(t,function(e,t){return!p.has(t)&&(f===e||n(f,e,r,o,a))&&p.add(t)})){s=!1;break}}else if(f!==y&&!n(f,y,r,o,a)){s=!1;break}}return a.delete(e),a.delete(t),s}function ke(e,t){var n,r=e.__data__;return("string"==(e=typeof(n=t))||"number"==e||"symbol"==e||"boolean"==e?"__proto__"!==n:null===n)?r["string"==typeof t?"string":"hash"]:r.map}function Ae(e,t){t=t,t=null==(e=e)?void 0:e[t];return Ce(t)?t:void 0}var Le=function(e){return Q.call(e)};function Fe(e,t){return!!(t=null==t?o:t)&&("number"==typeof e||I.test(e))&&-1<e&&e%1==0&&e<t}function Me(e,t){if(!Ue(e)){var n=typeof e;return"number"==n||"symbol"==n||"boolean"==n||null==e||Xe(e)||(C.test(e)||!s.test(e)||null!=t&&e in Object(t))}}function He(e){return e==e&&!Je(e)}function Ne(t,n){return function(e){return null!=e&&(e[t]===n&&(void 0!==n||t in Object(e)))}}(L&&Le(new L(new ArrayBuffer(1)))!=S||re&&Le(new re)!=g||M&&Le(M.resolve())!=c||H&&Le(new H)!=w||F&&Le(new F)!=u)&&(Le=function(e){var t=Q.call(e),e=t==v?e.constructor:void 0,e=e?We(e):void 0;if(e)switch(e){case ae:return S;case le:return g;case ie:return c;case ce:return w;case ue:return u}return t});var De=qe(function(e){var t;e=null==(t=e)?"":function(e){if("string"==typeof e)return e;if(Xe(e))return pe?pe.call(e):"";var t=e+"";return"0"==t&&1/e==-a?"-0":t}(t);var o=[];return j.test(e)&&o.push(""),e.replace(E,function(e,t,n,r){o.push(n?r.replace(P,"$1"):t||e)}),o});function ze(e){if("string"==typeof e||Xe(e))return e;var t=e+"";return"0"==t&&1/e==-a?"-0":t}function We(e){if(null!=e){try{return K.call(e)}catch(e){}try{return e+""}catch(e){}}return""}function qe(r,o){if("function"!=typeof r||o&&"function"!=typeof o)throw new TypeError(n);var a=function(){var e=arguments,t=o?o.apply(this,e):e[0],n=a.cache;if(n.has(t))return n.get(t);e=r.apply(this,e);return a.cache=n.set(t,e),e};return a.cache=new(qe.Cache||ye),a}function Be(e,t){return e===t||e!=e&&t!=t}function Ve(e){return Qe(t=e)&&Ge(t)&&J.call(e,"callee")&&(!ee.call(e,"callee")||Q.call(e)==p);var t}qe.Cache=ye;var Ue=Array.isArray;function Ge(e){return null!=e&&Ke(e.length)&&!Ye(e)}function Ye(e){e=Je(e)?Q.call(e):"";return e==l||e==i}function Ke(e){return"number"==typeof e&&-1<e&&e%1==0&&e<=o}function Je(e){var t=typeof e;return e&&("object"==t||"function"==t)}function Qe(e){return!!e&&"object"==typeof e}function Xe(e){return"symbol"==typeof e||Qe(e)&&Q.call(e)==x}var Ze=t?z(t):function(e){return Qe(e)&&Ke(e.length)&&!!k[Q.call(e)]};function et(e){return(Ge(e)?ge:Ee)(e)}function tt(e){return e}e.exports=function(e,t,n,r){return null==e?[]:(Ue(t)||(t=null==t?[]:[t]),Ue(n=r?void 0:n)||(n=null==n?[]:[n]),Pe(e,t,n))}}),isEmpty=function(e){e=0<arguments.length&&void 0!==e?e:"";return null==e||0===e.length},sort=function(e,t,n,r){t=1<arguments.length&&void 0!==t?t:"",n=2<arguments.length?n:void 0,r=3<arguments.length?r:void 0;return(r&&"function"==typeof r?r:lodash_orderby)(e,t,n)},getProperty=function(e,t,n,r){if(!t)return null;if("string"!=typeof t&&"function"!=typeof t)throw new Error("selector must be a . delimited string eg (my.property) or function (e.g. row => row.field");return n&&"function"==typeof n?n(e,r):t&&"function"==typeof t?t(e,r):t.split(".").reduce(function(e,t){var n=t.match(/[^\]\\[.]+/g);if(1<n.length){var r=0;if(r<n.length)return e[n[r]][n[r+1]]}return e[t]},e)},insertItem=function(e,t,n){e=0<arguments.length&&void 0!==e?e:[],t=1<arguments.length&&void 0!==t?t:{},n=2<arguments.length&&void 0!==n?n:0;return[].concat(_toConsumableArray(e.slice(0,n)),[t],_toConsumableArray(e.slice(n)))},removeItem=function(e,t,n){var r=1<arguments.length&&void 0!==t?t:{},o=2<arguments.length?n:void 0,e=(0<arguments.length&&void 0!==e?e:[]).slice();return r[o]?e.splice(e.findIndex(function(e){return e[o]===r[o]}),1):e.splice(e.findIndex(function(e){return e===r}),1),e},decorateColumns=function(e){return e.map(function(e){return _objectSpread2(_objectSpread2({id:shortid.generate()},e),{},{sortable:e.sortable||!!e.sortFunction||void 0})})},getSortDirection=function(e){return e?"asc":"desc"},handleFunctionProps=function(r){for(var o,e=arguments.length,a=new Array(1<e?e-1:0),t=1;t<e;t++)a[t-1]=arguments[t];return Object.keys(r).map(function(e){return r[e]}).forEach(function(e,t){var n=r;"function"==typeof e&&(o=_objectSpread2(_objectSpread2({},n),{},_defineProperty({},Object.keys(r)[t],e.apply(void 0,a))),delete n[e])}),o||r},getNumberOfPages=function(e,t){return Math.ceil(e/t)},recalculatePage=function(e,t){return Math.min(e,t)},noop=function(){return null},getConditionalStyle=function(e,t){var n=0<arguments.length&&void 0!==e?e:{},t=1<arguments.length&&void 0!==t?t:[],r={};return t.length&&t.forEach(function(e){if(!e.when||"function"!=typeof e.when)throw new Error('"when" must be defined in the conditional style object and must be function');e.when(n)&&(r=e.style||{},"function"==typeof e.style&&(r=e.style(n)||{}))}),r},isRowSelected=function(e,t,n){var r=0<arguments.length&&void 0!==e?e:{},t=1<arguments.length&&void 0!==t?t:[],o=2<arguments.length&&void 0!==n?n:"id";return r[o]?t.some(function(e){return e[o]===r[o]}):t.some(function(e){return e===r})},detectRTL=function(e){e=0<arguments.length&&void 0!==e?e:"auto";return"auto"!==e?"rtl"===e:!("undefined"==typeof window||!window.document||!window.document.createElement)&&("rtl"===document.getElementsByTagName("BODY")[0]||"rtl"===document.getElementsByTagName("HTML")[0].dir)},isOdd=function(e){return e%2};function tableReducer(t,e){switch(e.type){case"SELECT_ALL_ROWS":var n=e.rows,r=e.rowCount,o=e.mergeSelections,a=e.keyField,l=!t.allSelected;if(o){var i=l?[].concat(_toConsumableArray(t.selectedRows),_toConsumableArray(n.filter(function(e){return!isRowSelected(e,t.selectedRows,a)}))):t.selectedRows.filter(function(e){return!isRowSelected(e,n,a)});return _objectSpread2(_objectSpread2({},t),{},{allSelected:l,selectedCount:i.length,selectedRows:i})}return _objectSpread2(_objectSpread2({},t),{},{allSelected:l,selectedCount:l?r:0,selectedRows:l?n:[]});case"SELECT_SINGLE_ROW":o=e.row,i=e.isSelected,r=e.keyField,l=e.rowCount;return i?_objectSpread2(_objectSpread2({},t),{},{selectedCount:0<t.selectedRows.length?t.selectedRows.length-1:0,allSelected:!1,selectedRows:removeItem(t.selectedRows,o,r)}):_objectSpread2(_objectSpread2({},t),{},{selectedCount:t.selectedRows.length+1,allSelected:t.selectedRows.length+1===l,selectedRows:insertItem(t.selectedRows,o)});case"SELECT_MULTIPLE_ROWS":var c=e.selectedRows,u=e.rows,s=e.mergeSelections,p=e.keyField;if(s){var d=[].concat(_toConsumableArray(t.selectedRows),_toConsumableArray(c.filter(function(e){return!isRowSelected(e,t.selectedRows,p)})));return _objectSpread2(_objectSpread2({},t),{},{selectedCount:d.length,allSelected:!1,selectedRows:d})}return _objectSpread2(_objectSpread2({},t),{},{selectedCount:c.length,allSelected:c.length===u.length,selectedRows:c});case"SORT_CHANGE":var f=e.sortColumn,y=e.sortDirection,s=e.sortServer,b=e.selectedColumn,d=e.pagination,u=e.paginationServer,m=e.visibleOnly,c=e.persistSelectedOnSort,m=d&&u&&!c||s||m;return _objectSpread2(_objectSpread2({},t),{},{sortColumn:f,selectedColumn:b,sortDirection:y,currentPage:1},m&&{allSelected:!1,selectedCount:0,selectedRows:[]});case"CHANGE_PAGE":var f=e.page,b=e.paginationServer,g=e.visibleOnly,y=e.persistSelectedOnPageChange,m=b&&y,g=b&&!y||g;return _objectSpread2(_objectSpread2(_objectSpread2({},t),{},{currentPage:f},m&&{allSelected:!1}),g&&{allSelected:!1,selectedCount:0,selectedRows:[]});case"CHANGE_ROWS_PER_PAGE":var _=e.rowsPerPage,g=e.page;return _objectSpread2(_objectSpread2({},t),{},{currentPage:g,rowsPerPage:_});case"CLEAR_SELECTED_ROWS":_=e.selectedRowsFlag;return _objectSpread2(_objectSpread2({},t),{},{allSelected:!1,selectedCount:0,selectedRows:[],selectedRowsFlag:_});default:throw new Error("Unhandled action type: ".concat(e.type))}}function _templateObject2(){var e=_taggedTemplateLiteral(["\n  position: relative;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  height: 100%;\n  max-width: 100%;\n  ",";\n  ",";\n"]);return _templateObject2=function(){return e},e}function _templateObject(){var e=_taggedTemplateLiteral(["\n  pointer-events: none;\n  opacity: 0.4;\n"]);return _templateObject=function(){return e},e}var disabled=styled.css(_templateObject()),TableStyle=styled__default.default.div(_templateObject2(),function(e){return e.disabled&&disabled},function(e){return e.theme.table.style});function _templateObject$1(){var e=_taggedTemplateLiteral(["\n  display: flex;\n  text-align: left;\n  ",";\n"]);return _templateObject$1=function(){return e},e}var TableHead=styled__default.default.div(_templateObject$1(),function(e){return e.theme.head.style});function _templateObject2$1(){var e=_taggedTemplateLiteral(["\n  display: flex;\n  align-items: stretch;\n  width: 100%;\n  ",";\n  ",";\n  ",";\n"]);return _templateObject2$1=function(){return e},e}function _templateObject$2(){var e=_taggedTemplateLiteral(["\n  pointer-events: none;\n"]);return _templateObject$2=function(){return e},e}var disabled$1=styled.css(_templateObject$2()),TableHeadRow=styled__default.default.div(_templateObject2$1(),function(e){return e.theme.headRow.style},function(e){return e.dense&&e.theme.headRow.denseStyle},function(e){return e.disabled&&disabled$1});function _templateObject4(){var e=_taggedTemplateLiteral(["\n    @media screen and (max-width: ","px) {\n      ","\n    }\n  "]);return _templateObject4=function(){return e},e}function _templateObject3(){var e=_taggedTemplateLiteral(["\n    @media screen and (max-width: ","px) {\n      ","\n    }\n  "]);return _templateObject3=function(){return e},e}function _templateObject2$2(){var e=_taggedTemplateLiteral(["\n    @media screen and (max-width: ","px) {\n      ","\n    }\n  "]);return _templateObject2$2=function(){return e},e}function _templateObject$3(){var e=_taggedTemplateLiteral(["\n    @media screen and (max-width: ","px) {\n      ","\n    }\n  "]);return _templateObject$3=function(){return e},e}var SMALL=599,MEDIUM=959,LARGE=1280,media={sm:function(){return styled.css(_templateObject$3(),SMALL,styled.css.apply(void 0,arguments))},md:function(){return styled.css(_templateObject2$2(),MEDIUM,styled.css.apply(void 0,arguments))},lg:function(){return styled.css(_templateObject3(),LARGE,styled.css.apply(void 0,arguments))},custom:function(e){return function(){return styled.css(_templateObject4(),e,styled.css.apply(void 0,arguments))}}};function _templateObject7(){var e=_taggedTemplateLiteral(["\n    display: none;\n  "]);return _templateObject7=function(){return e},e}function _templateObject6(){var e=_taggedTemplateLiteral(["\n    display: none;\n  "]);return _templateObject6=function(){return e},e}function _templateObject5(){var e=_taggedTemplateLiteral(["\n    display: none;\n  "]);return _templateObject5=function(){return e},e}function _templateObject4$1(){var e=_taggedTemplateLiteral(["\n    display: none;\n  "]);return _templateObject4$1=function(){return e},e}function _templateObject3$1(){var e=_taggedTemplateLiteral(["\n    min-width: ",";\n    max-width: ",";\n  "]);return _templateObject3$1=function(){return e},e}function _templateObject2$3(){var e=_taggedTemplateLiteral(["\n  flex-grow: ",";\n  flex-shrink: 0;\n  flex-basis: 0;\n  max-width: ",";\n  min-width: ",";\n  ",";\n  ",";\n  ",";\n  ",";\n\n  /* handle hiding cells */\n  ",";\n  ",";\n  ",";\n  ",";\n"]);return _templateObject2$3=function(){return e},e}function _templateObject$4(){var e=_taggedTemplateLiteral(["\n  position: relative;\n  display: flex;\n  align-items: center;\n  box-sizing: border-box;\n  line-height: normal;\n  ",";\n  ",";\n"]);return _templateObject$4=function(){return e},e}var CellBase=styled__default.default.div(_templateObject$4(),function(e){return e.theme[e.head?"headCells":"cells"].style},function(e){return e.noPadding&&"padding: 0"}),Cell=styled__default.default(CellBase)(_templateObject2$3(),function(e){return 0===e.column.grow||e.column.button?0:e.column.grow||1},function(e){return e.column.maxWidth||"100%"},function(e){return e.column.minWidth||"100px"},function(e){return e.column.width&&styled.css(_templateObject3$1(),e.column.width,e.column.width)},function(e){return e.column.right&&"justify-content: flex-end"},function(e){return(e.column.center||e.column.button)&&"justify-content: center"},function(e){return(e.column.compact||e.column.button)&&"padding: 0"},function(e){return e.column.hide&&"sm"===e.column.hide&&media.sm(_templateObject4$1())},function(e){return e.column.hide&&"md"===e.column.hide&&media.md(_templateObject5())},function(e){return e.column.hide&&"lg"===e.column.hide&&media.lg(_templateObject6())},function(e){return e.column.hide&&Number.isInteger(e.column.hide)&&media.custom(e.column.hide)(_templateObject7())}),STOP_PROP_TAG="allowRowEvents";function _templateObject2$4(){var e=_taggedTemplateLiteral(["\n  font-size: ",";\n  font-weight: 400;\n  ",";\n  ",";\n  ",";\n"]);return _templateObject2$4=function(){return e},e}function _templateObject$5(){var e=_taggedTemplateLiteral(["\n  div:first-child {\n    white-space: ",";\n    overflow: ",";\n    text-overflow: ellipsis;\n  }\n"]);return _templateObject$5=function(){return e},e}var overflowCSS=styled.css(_templateObject$5(),function(e){return e.column.wrap?"normal":"nowrap"},function(e){return e.column.allowOverflow?"visible":"hidden"}),TableCellStyle=styled__default.default(Cell)(_templateObject2$4(),function(e){return e.theme.rows.fontSize},function(e){return!e.column.cell&&overflowCSS},function(e){return e.column.style},function(e){return e.extendedCellStyle}),TableCell=React.memo(function(e){var t=e.id,n=e.rowIndex,r=e.column,o=e.row;if(r.omit)return null;var a=r.ignoreRowClick||r.button?null:STOP_PROP_TAG,e=getConditionalStyle(o,r.conditionalCellStyles);return React__default.default.createElement(TableCellStyle,{id:t,role:"gridcell",column:r,"data-tag":a,className:"rdt_TableCell",extendedCellStyle:e},!r.cell&&React__default.default.createElement("div",{"data-tag":a},getProperty(o,r.selector,r.format,n)),r.cell&&r.cell(o,n,r,t))});TableCell.propTypes={id:propTypes.string.isRequired,rowIndex:propTypes.number.isRequired,column:propTypes.object.isRequired,row:propTypes.object.isRequired};var calculateBaseStyle=function(e){return _objectSpread2(_objectSpread2({fontSize:"18px"},!e&&{cursor:"pointer"}),{},{padding:0,marginTop:"1px",verticalAlign:"middle",position:"relative"})},Checkbox=React.memo(function(e){var t=e.component,n=e.componentOptions,r=e.indeterminate,o=e.checked,a=e.name,l=e.onClick,i=e.disabled,c=t,e="input"!==c?n.style:calculateBaseStyle(i),t=React.useMemo(function(){return handleFunctionProps(n,r)},[n,r]);return React__default.default.createElement(c,_extends({type:"checkbox",ref:function(e){e&&(e.indeterminate=r)},style:e,onClick:i?noop:l,name:a,"aria-label":a,checked:o,disabled:i},t,{onChange:noop}))});function _templateObject$6(){var e=_taggedTemplateLiteral(["\n  flex: 0 0 48px;\n  justify-content: center;\n  align-items: center;\n  user-select: none;\n  white-space: nowrap;\n"]);return _templateObject$6=function(){return e},e}Checkbox.propTypes={name:propTypes.string.isRequired,indeterminate:propTypes.bool,component:propTypes.oneOfType([propTypes.string,propTypes.node,propTypes.func,propTypes.object]),componentOptions:propTypes.object,checked:propTypes.bool,disabled:propTypes.bool,onClick:propTypes.func},Checkbox.defaultProps={indeterminate:!1,component:"input",componentOptions:{style:{}},checked:!1,disabled:!1,onClick:null};var TableCellCheckboxStyle=styled__default.default(CellBase)(_templateObject$6()),TableCellCheckbox=function(e){var t=e.name,n=e.row,r=e.selected,o=useTableContext(),a=o.dispatch,l=o.data,i=o.keyField,c=o.selectableRowsComponent,u=o.selectableRowsComponentProps,e=o.selectableRowDisabled,o=e&&e(n),e=React.useCallback(function(){return a({type:"SELECT_SINGLE_ROW",row:n,isSelected:r,keyField:i,rowCount:l.length})},[a,n,r,i,l.length]);return React__default.default.createElement(TableCellCheckboxStyle,{onClick:function(e){return e.stopPropagation()},className:"rdt_TableCell",noPadding:!0},React__default.default.createElement(Checkbox,{name:t,component:c,componentOptions:u,checked:r,"aria-checked":r,onClick:e,disabled:o}))};function _templateObject$7(){var e=_taggedTemplateLiteral(["\n  display: inline-flex;\n  align-items: center;\n  user-select: none;\n  white-space: nowrap;\n  border: none;\n  background-color: transparent;\n  ",";\n"]);return _templateObject$7=function(){return e},e}TableCellCheckbox.propTypes={name:propTypes.string.isRequired,row:propTypes.object.isRequired,selected:propTypes.bool.isRequired};var ButtonStyle=styled__default.default.button(_templateObject$7(),function(e){return e.theme.expanderButton.style}),ExpanderButton=function(e){var t=e.expanded,n=e.row,r=e.onToggled,o=e.disabled,a=useTableContext(),e=a.expandableIcon,a=a.keyField,e=t?e.expanded:e.collapsed;return React__default.default.createElement(ButtonStyle,{"aria-disabled":o,onClick:function(e){return r&&r(n,e)},"data-testid":"expander-button-".concat(n[a]),disabled:o,"aria-label":t?"Collapse Row":"Expand Row",role:"button",type:"button"},e)};function _templateObject$8(){var e=_taggedTemplateLiteral(["\n  white-space: nowrap;\n  font-weight: 400;\n  ",";\n"]);return _templateObject$8=function(){return e},e}ExpanderButton.propTypes={row:propTypes.object.isRequired,expanded:propTypes.bool,onToggled:propTypes.func,disabled:propTypes.bool},ExpanderButton.defaultProps={onToggled:null,expanded:!1,disabled:!1};var TableCellExpanderStyle=styled__default.default(CellBase)(_templateObject$8(),function(e){return e.theme.expanderCell.style}),TableCellExpander=function(e){var t=e.column,n=e.row,r=e.expanded,o=e.onRowExpandToggled,e=e.disabled;return React__default.default.createElement(TableCellExpanderStyle,{column:t,onClick:function(e){return e.stopPropagation()},noPadding:!0},React__default.default.createElement(ExpanderButton,{onToggled:o,row:n,expanded:r,disabled:e}))};function _templateObject$9(){var e=_taggedTemplateLiteral(["\n  width: 100%;\n  box-sizing: border-box;\n  ",";\n  ",";\n"]);return _templateObject$9=function(){return e},e}TableCellExpander.propTypes={column:propTypes.object,row:propTypes.object,expanded:propTypes.bool,onRowExpandToggled:propTypes.func.isRequired,disabled:propTypes.bool},TableCellExpander.defaultProps={column:{},row:{},expanded:!1,disabled:!1};var renderChildren=function(e,t){return React.Children.map(e,function(e){return React.cloneElement(e,{data:t})})},ExpanderRowStyle=styled__default.default.div(_templateObject$9(),function(e){return e.theme.expanderRow.style},function(e){return e.extendedRowStyle}),ExpanderRow=function(e){var t=e.data,n=e.children,e=e.extendedRowStyle;return React__default.default.createElement(ExpanderRowStyle,{className:"rdt_ExpanderRow",extendedRowStyle:e},renderChildren(n,t))};function _templateObject3$2(){var e=_taggedTemplateLiteral(["\n  display: flex;\n  align-items: stretch;\n  align-content: stretch;\n  width: 100%;\n  box-sizing: border-box;\n  ",";\n  ",";\n  ",";\n  ",";\n  ",";\n  ",";\n  ",";\n"]);return _templateObject3$2=function(){return e},e}function _templateObject2$5(){var e=_taggedTemplateLiteral(["\n  &:hover {\n    cursor: pointer;\n  }\n"]);return _templateObject2$5=function(){return e},e}function _templateObject$a(){var e=_taggedTemplateLiteral(["\n  &:hover {\n    ",";\n  }\n"]);return _templateObject$a=function(){return e},e}ExpanderRow.propTypes={data:propTypes.object,children:propTypes.oneOfType([propTypes.arrayOf(propTypes.node),propTypes.node]),extendedRowStyle:propTypes.object},ExpanderRow.defaultProps={data:{},children:null,extendedRowStyle:null};var highlightCSS=styled.css(_templateObject$a(),function(e){return e.highlightOnHover&&e.theme.rows.highlightOnHoverStyle}),pointerCSS=styled.css(_templateObject2$5()),TableRowStyle=styled__default.default.div(_templateObject3$2(),function(e){return e.theme.rows.style},function(e){return e.dense&&e.theme.rows.denseStyle},function(e){return e.striped&&e.theme.rows.stripedStyle},function(e){return e.highlightOnHover&&highlightCSS},function(e){return e.pointerOnHover&&pointerCSS},function(e){return e.selected&&e.theme.rows.selectedHighlightStyle},function(e){return e.extendedRowStyle}),TableRow=React.memo(function(e){var t=e.id,n=e.keyField,r=e.columns,o=e.row,a=e.onRowClicked,l=e.onRowDoubleClicked,i=e.selectableRows,c=e.expandableRows,u=e.striped,s=e.highlightOnHover,p=e.pointerOnHover,d=e.dense,f=e.expandableRowsComponent,y=e.defaultExpanderDisabled,b=e.defaultExpanded,m=e.expandableRowsHideExpander,g=e.expandOnRowClicked,_=e.expandOnRowDoubleClicked,h=e.conditionalRowStyles,v=e.inheritConditionalStyles,T=e.onRowExpandToggled,w=e.selected,R=e.selectableRowsHighlight,x=e.rowIndex,O=_slicedToArray(React.useState(b),2),S=O[0],C=O[1];React.useEffect(function(){C(b)},[b]);var j=React.useCallback(function(){C(!S),T(!S,o)},[S,T,o]),e=p||c&&(g||_),O=React.useCallback(function(e){e.target&&e.target.getAttribute("data-tag")===STOP_PROP_TAG&&(a(o,e),!y&&c&&g&&j())},[y,g,c,j,a,o]),p=React.useCallback(function(e){e.target&&e.target.getAttribute("data-tag")===STOP_PROP_TAG&&(l(o,e),!y&&c&&_&&j())},[y,_,c,j,l,o]),h=getConditionalStyle(o,h),R=R&&w,v=v?h:null,u=u&&isOdd(x);return React__default.default.createElement(React__default.default.Fragment,null,React__default.default.createElement(TableRowStyle,{id:"row-".concat(t),role:"row",striped:u,highlightOnHover:s,pointerOnHover:!y&&e,dense:d,onClick:O,onDoubleClick:p,className:"rdt_TableRow",extendedRowStyle:h,selected:R},i&&React__default.default.createElement(TableCellCheckbox,{name:"select-row-".concat(o[n]),row:o,selected:w}),c&&!m&&React__default.default.createElement(TableCellExpander,{expanded:S,row:o,onRowExpandToggled:j,disabled:y}),r.map(function(e){return React__default.default.createElement(TableCell,{id:"cell-".concat(e.id,"-").concat(o[n]),key:"cell-".concat(e.id,"-").concat(o[n]),column:e,row:o,rowIndex:x})})),c&&S&&React__default.default.createElement(ExpanderRow,{key:"expander--".concat(o[n]),data:o,extendedRowStyle:v},f))});function _templateObject$b(){var e=_taggedTemplateLiteral(["\n  padding: 2px;\n  color: inherit;\n  flex-grow: 0;\n  flex-shrink: 0;\n  ",";\n  ",";\n"]);return _templateObject$b=function(){return e},e}TableRow.propTypes={id:propTypes.any.isRequired,keyField:propTypes.string.isRequired,columns:propTypes.array.isRequired,row:propTypes.object.isRequired,rowIndex:propTypes.number.isRequired,onRowClicked:propTypes.func.isRequired,onRowDoubleClicked:propTypes.func.isRequired,onRowExpandToggled:propTypes.func.isRequired,defaultExpanded:propTypes.bool,defaultExpanderDisabled:propTypes.bool,selectableRows:propTypes.bool.isRequired,expandableRows:propTypes.bool.isRequired,striped:propTypes.bool.isRequired,highlightOnHover:propTypes.bool.isRequired,pointerOnHover:propTypes.bool.isRequired,dense:propTypes.bool.isRequired,expandableRowsComponent:propTypes.oneOfType([propTypes.arrayOf(propTypes.node),propTypes.node,propTypes.func]).isRequired,expandableRowsHideExpander:propTypes.bool.isRequired,expandOnRowClicked:propTypes.bool.isRequired,expandOnRowDoubleClicked:propTypes.bool.isRequired,conditionalRowStyles:propTypes.array.isRequired,inheritConditionalStyles:propTypes.bool.isRequired,selected:propTypes.bool.isRequired,selectableRowsHighlight:propTypes.bool.isRequired},TableRow.defaultProps={defaultExpanded:!1,defaultExpanderDisabled:!1};var Icon=styled__default.default.span(_templateObject$b(),function(e){return e.sortActive?"opacity: 1":"opacity: 0"},function(e){return"desc"===e.sortDirection&&"transform: rotate(180deg)"}),NativeSortIcon=function(e){var t=e.sortActive,n=e.sortDirection,e=e.sortIcon;return React__default.default.createElement(Icon,{sortActive:t,sortDirection:n},e)};function _templateObject2$6(){var e=_taggedTemplateLiteral(["\n  display: inline-flex;\n  align-items: center;\n  height: 100%;\n  line-height: 1;\n  user-select: none;\n  ",";\n\n  span.__rdt_custom_sort_icon__ {\n    i,\n    svg {\n      ",";\n      color: inherit;\n      font-size: 18px !important;\n      height: 18px !important;\n      width: 18px !important;\n      backface-visibility: hidden;\n      transform-style: preserve-3d;\n      transition-duration: 125ms;\n      transition-property: transform;\n    }\n\n    &.asc i,\n    &.asc svg {\n      transform: rotate(180deg);\n    }\n  }\n\n  &:hover {\n    ",";\n    ",";\n\n    span,\n    span.__rdt_custom_sort_icon__ * {\n      ",";\n    }\n  }\n"]);return _templateObject2$6=function(){return e},e}function _templateObject$c(){var e=_taggedTemplateLiteral(["\n  ",";\n"]);return _templateObject$c=function(){return e},e}NativeSortIcon.propTypes={sortDirection:propTypes.string.isRequired,sortActive:propTypes.bool,sortIcon:propTypes.node},NativeSortIcon.defaultProps={sortActive:!1,sortIcon:React__default.default.createElement(React__default.default.Fragment,null,"▲")};var TableColStyle=styled__default.default(Cell)(_templateObject$c(),function(e){return e.column.button&&"text-align: center"}),ColumnSortable=styled__default.default.div(_templateObject2$6(),function(e){return e.sortActive?e.theme.headCells.activeSortStyle:e.theme.headCells.inactiveSortStyle},function(e){return e.sortActive?"opacity: 1":"opacity: 0"},function(e){return e.column.sortable&&"cursor: pointer"},function(e){var t=e.column,e=e.theme;return t.sortable&&e.headCells.activeStyle},function(e){var t=e.sortActive,e=e.column;return!t&&e.sortable&&"opacity: 1"}),TableCol=React.memo(function(e){var t=e.column,n=e.sortIcon,r=useTableContext(),o=r.dispatch,a=r.pagination,l=r.paginationServer,i=r.sortColumn,c=r.sortDirection,u=r.sortServer,s=r.selectableRowsVisibleOnly,p=r.persistSelectedOnSort;if(t.omit)return null;function d(){var e;t.sortable&&(e=c,i===t.selector&&(e="asc"===c?"desc":"asc"),o({type:"SORT_CHANGE",sortDirection:e,sortColumn:t.selector,sortServer:u,selectedColumn:t,pagination:a,paginationServer:l,visibleOnly:s,persistSelectedOnSort:p}))}function f(e){return React__default.default.createElement(NativeSortIcon,{column:t,sortActive:e,sortDirection:c})}function y(){return React__default.default.createElement("span",{className:[c,"__rdt_custom_sort_icon__"].join(" ")},n)}var b=t.sortable&&i===t.selector,m=t.sortable&&!n&&!t.right,g=t.sortable&&!n&&t.right,e=t.sortable&&n&&!t.right,r=t.sortable&&n&&t.right;return React__default.default.createElement(TableColStyle,{className:"rdt_TableCol",column:t,head:!0},t.name&&React__default.default.createElement(ColumnSortable,{id:"column-".concat(t.selector),role:"columnheader",tabIndex:0,className:"rdt_TableCol_Sortable",onClick:d,onKeyPress:function(e){"Enter"===e.key&&d()},sortActive:b,column:t},r&&y(),g&&f(b),React__default.default.createElement("div",null,t.name),e&&y(),m&&f(b)))});function _templateObject$d(){var e=_taggedTemplateLiteral(["\n  flex: 0 0 48px;\n  justify-content: center;\n  align-items: center;\n  user-select: none;\n  white-space: nowrap;\n"]);return _templateObject$d=function(){return e},e}TableCol.propTypes={column:propTypes.object.isRequired,sortIcon:propTypes.oneOfType([propTypes.bool,propTypes.object]).isRequired};var TableColStyle$1=styled__default.default(CellBase)(_templateObject$d()),TableColCheckbox=function(e){var t=e.head,n=useTableContext(),r=n.dispatch,o=n.data,a=n.selectedRows,l=n.allSelected,i=n.selectableRowsComponent,e=n.selectableRowsComponentProps,c=n.selectableRowDisabled,u=n.keyField,s=n.mergeSelections,n=0<a.length&&!l,p=c?o.filter(function(e){return!c(e)}):o,a=0===p.length,d=Math.min(o.length,p.length),o=React.useCallback(function(){return r({type:"SELECT_ALL_ROWS",rows:p,rowCount:d,mergeSelections:s,keyField:u})},[r,u,s,d,p]);return React__default.default.createElement(TableColStyle$1,{className:"rdt_TableCol",head:t,noPadding:!0},React__default.default.createElement(Checkbox,{name:"select-all-rows",component:i,componentOptions:e,onClick:o,checked:l,indeterminate:n,disabled:a}))};function _templateObject3$3(){var e=_taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  box-sizing: inherit;\n  z-index: 1;\n  align-items: center;\n  justify-content: space-between;\n  display: flex;\n  ",";\n  ",";\n"]);return _templateObject3$3=function(){return e},e}function _templateObject2$7(){var e=_taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  flex-wrap: wrap;\n"]);return _templateObject2$7=function(){return e},e}function _templateObject$e(){var e=_taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  flex: 1 0 auto;\n  height: 100%;\n  color: ",";\n  font-size: ",";\n  font-weight: 400;\n"]);return _templateObject$e=function(){return e},e}TableColCheckbox.propTypes={head:propTypes.bool},TableColCheckbox.defaultProps={head:!0};var Title=styled__default.default.div(_templateObject$e(),function(e){return e.theme.contextMenu.fontColor},function(e){return e.theme.contextMenu.fontSize}),ContextActions=styled__default.default.div(_templateObject2$7()),ContextMenuStyle=styled__default.default.div(_templateObject3$3(),function(e){return e.theme.contextMenu.style},function(e){return e.visible&&e.theme.contextMenu.activeStyle}),generateDefaultContextTitle=function(e,t,n){if(0===t)return null;var r=1===t?e.singular:e.plural;return detectRTL(n)?"".concat(t," ").concat(e.message||""," ").concat(r):"".concat(t," ").concat(r," ").concat(e.message||"")},ContextMenu=function(){var e=useTableContext(),t=e.contextMessage,n=e.contextActions,r=e.contextComponent,o=e.selectedCount,a=e.direction,e=0<o;return r?React__default.default.createElement(ContextMenuStyle,{visible:e},React.cloneElement(r,{selectedCount:o})):React__default.default.createElement(ContextMenuStyle,{visible:e},React__default.default.createElement(Title,null,generateDefaultContextTitle(t,o,a)),React__default.default.createElement(ContextActions,null,n))};function _templateObject3$4(){var e=_taggedTemplateLiteral(["\n  flex: 1 0 auto;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n\n  > * {\n    margin-left: 5px;\n  }\n"]);return _templateObject3$4=function(){return e},e}function _templateObject2$8(){var e=_taggedTemplateLiteral(["\n  flex: 1 0 auto;\n  color: ",";\n  font-size: ",";\n  font-weight: 400;\n"]);return _templateObject2$8=function(){return e},e}function _templateObject$f(){var e=_taggedTemplateLiteral(["\n  position: relative;\n  box-sizing: border-box;\n  overflow: hidden;\n  display: flex;\n  flex: 1 1 auto;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  flex-wrap: wrap;\n  ","\n"]);return _templateObject$f=function(){return e},e}var TableHeaderStyle=styled__default.default.div(_templateObject$f(),function(e){return e.theme.header.style}),Title$1=styled__default.default.div(_templateObject2$8(),function(e){return e.theme.header.fontColor},function(e){return e.theme.header.fontSize}),Actions=styled__default.default.div(_templateObject3$4()),TableHeader=function(e){var t=e.title,n=e.actions,e=e.showMenu;return React__default.default.createElement(TableHeaderStyle,{className:"rdt_TableHeader",role:"heading","aria-level":"1"},React__default.default.createElement(Title$1,null,t),React__default.default.createElement(Actions,null,n),e&&React__default.default.createElement(ContextMenu,null))};function _templateObject$g(){var e=_taggedTemplateLiteral(["\n  position: relative;\n  display: flex;\n  flex: 1 1 auto;\n  box-sizing: border-box;\n  align-items: center;\n  padding: 4px 16px 4px 24px;\n  width: 100%;\n  justify-content: ",";\n  flex-wrap: ",";\n  ","\n"]);return _templateObject$g=function(){return e},e}TableHeader.propTypes={title:propTypes.oneOfType([propTypes.string,propTypes.node]).isRequired,actions:propTypes.oneOfType([propTypes.arrayOf(propTypes.node),propTypes.node]),showMenu:propTypes.bool},TableHeader.defaultProps={actions:[],showMenu:!0};var alignMap={left:"flex-start",right:"flex-end",center:"center"},SubheaderWrapper=styled__default.default.header(_templateObject$g(),function(e){return alignMap[e.align]},function(e){return e.wrapContent?"wrap":"nowrap"},function(e){return e.theme.subHeader.style}),TableSubheader=function(e){var t=e.align,n=e.wrapContent,e=e.children;return React__default.default.createElement(SubheaderWrapper,{align:t,wrapContent:n},e)};function _templateObject2$9(){var e=_taggedTemplateLiteral(["\n    max-height: ",";\n    overflow-y: auto;\n    -webkit-overflow-scrolling: touch;\n  "]);return _templateObject2$9=function(){return e},e}function _templateObject$h(){var e=_taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  ",";\n"]);return _templateObject$h=function(){return e},e}TableSubheader.propTypes={children:propTypes.oneOfType([propTypes.arrayOf(propTypes.node),propTypes.node,propTypes.string]),align:propTypes.oneOf(["center","left","right"]),wrapContent:propTypes.bool},TableSubheader.defaultProps={children:null,align:"right",wrapContent:!0};var TableBody=styled__default.default.div(_templateObject$h(),function(e){var t=e.fixedHeader,n=e.hasOffset,r=e.offset,e=e.fixedHeaderScrollHeight;return t&&styled.css(_templateObject2$9(),n?"calc(".concat(e," - ").concat(r,")"):e)});function _templateObject3$5(){var e=_taggedTemplateLiteral(["\n    padding-bottom: ",";\n    margin-bottom: -",";\n  "]);return _templateObject3$5=function(){return e},e}function _templateObject2$a(){var e=_taggedTemplateLiteral(["\n    overflow-x: auto;\n\n    // prevents vertical scrolling in firefox\n    overflow-y: hidden;\n    min-height: 0;\n  "]);return _templateObject2$a=function(){return e},e}function _templateObject$i(){var e=_taggedTemplateLiteral(["\n  position: relative;\n  width: 100%;\n  border-radius: inherit;\n  ",";\n  ",";\n"]);return _templateObject$i=function(){return e},e}TableBody.defaultProps={fixedHeaderScrollHeight:"100vh",offset:0};var ResponsiveWrapper=styled__default.default.div(_templateObject$i(),function(e){return e.responsive&&styled.css(_templateObject2$a())},function(e){return e.overflowY&&e.responsive&&e.overflowYOffset&&styled.css(_templateObject3$5(),e.overflowYOffset,e.overflowYOffset)});function _templateObject$j(){var e=_taggedTemplateLiteral(["\n  position: relative;\n  box-sizing: border-box;\n  width: 100%;\n  height: 100%;\n  ",";\n"]);return _templateObject$j=function(){return e},e}var ProgressWrapperStyle=styled__default.default.div(_templateObject$j(),function(e){return e.theme.progress.style}),ProgressWrapper=function(e){e=e.children;return React__default.default.createElement(ProgressWrapperStyle,null,e)};function _templateObject$k(){var e=_taggedTemplateLiteral(["\n  position: relative;\n  width: 100%;\n  ",";\n"]);return _templateObject$k=function(){return e},e}ProgressWrapper.propTypes={children:propTypes.oneOfType([propTypes.string,propTypes.node,propTypes.func]).isRequired};var TableWrapper=styled__default.default.div(_templateObject$k(),function(e){return e.theme.tableWrapper.style});function _templateObject$l(){var e=_taggedTemplateLiteral(["\n  white-space: nowrap;\n  ",";\n"]);return _templateObject$l=function(){return e},e}var TableColExpander=styled__default.default(CellBase)(_templateObject$l(),function(e){return e.theme.expanderCell.style});function _templateObject$m(){var e=_taggedTemplateLiteral(["\n  box-sizing: border-box;\n  width: 100%;\n  height: 100%;\n  ",";\n"]);return _templateObject$m=function(){return e},e}var NoDataWrapperStyle=styled__default.default.div(_templateObject$m(),function(e){return e.theme.noData.style}),NoDataWrapper=function(e){e=e.children;return React__default.default.createElement(NoDataWrapperStyle,null,e)};NoDataWrapper.propTypes={children:propTypes.oneOfType([propTypes.string,propTypes.node]).isRequired};var DropDownIcon=function(){return React__default.default.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",width:"24",height:"24",viewBox:"0 0 24 24"},React__default.default.createElement("path",{d:"M7 10l5 5 5-5z"}),React__default.default.createElement("path",{d:"M0 0h24v24H0z",fill:"none"}))};function _templateObject2$b(){var e=_taggedTemplateLiteral(["\n  position: relative;\n  flex-shrink: 0;\n  font-size: inherit;\n  color: inherit;\n  margin-top: 1px;\n\n  svg {\n    top: 0;\n    right: 0;\n    color: inherit;\n    position: absolute;\n    fill: currentColor;\n    width: 24px;\n    height: 24px;\n    display: inline-block;\n    user-select: none;\n    pointer-events: none;\n  }\n"]);return _templateObject2$b=function(){return e},e}function _templateObject$n(){var e=_taggedTemplateLiteral(["\n  cursor: pointer;\n  height: 24px;\n  min-width: 24px;\n  user-select: none;\n  padding-left: 8px;\n  padding-right: 12px;\n  box-sizing: content-box;\n  font-size: inherit;\n  color: inherit;\n  border: none;\n  background-color: transparent;\n  appearance: none;\n  direction: ltr;\n\n  &::-ms-expand {\n    display: none;\n  }\n\n  &:disabled::-ms-expand {\n    background: #f60;\n  }\n\n  option {\n    color: initial;\n  }\n"]);return _templateObject$n=function(){return e},e}var SelectControl=styled__default.default.select(_templateObject$n()),SelectWrapper=styled__default.default.div(_templateObject2$b()),Select=function(e){return React__default.default.createElement(SelectWrapper,null,React__default.default.createElement(SelectControl,e),React__default.default.createElement(DropDownIcon,null))};function useWindowSize(){var t="object"===("undefined"==typeof window?"undefined":_typeof(window));function n(){return{width:t?window.innerWidth:void 0,height:t?window.innerHeight:void 0}}var e=_slicedToArray(React.useState(n),2),r=e[0],o=e[1];return React.useEffect(function(){return!!t&&(window.addEventListener("resize",e),function(){return window.removeEventListener("resize",e)});function e(){o(n())}},[]),r}function _templateObject7$1(){var e=_taggedTemplateLiteral(["\n  margin: 0 4px;\n"]);return _templateObject7$1=function(){return e},e}function _templateObject6$1(){var e=_taggedTemplateLiteral(["\n  margin: 0 24px;\n"]);return _templateObject6$1=function(){return e},e}function _templateObject5$1(){var e=_taggedTemplateLiteral(["\n  flex-shrink: 1;\n  user-select: none;\n"]);return _templateObject5$1=function(){return e},e}function _templateObject4$2(){var e=_taggedTemplateLiteral(["\n    width: 100%;\n    justify-content: space-around;\n  "]);return _templateObject4$2=function(){return e},e}function _templateObject3$6(){var e=_taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  border-radius: 4px;\n  white-space: nowrap;\n  ",";\n"]);return _templateObject3$6=function(){return e},e}function _templateObject2$c(){var e=_taggedTemplateLiteral(["\n  position: relative;\n  display: block;\n  user-select: none;\n  border: none;\n  ",";\n  ",";\n"]);return _templateObject2$c=function(){return e},e}function _templateObject$o(){var e=_taggedTemplateLiteral(["\n  display: flex;\n  flex: 1 1 auto;\n  justify-content: flex-end;\n  align-items: center;\n  box-sizing: border-box;\n  padding-right: 8px;\n  padding-left: 8px;\n  width: 100%;\n  ",";\n"]);return _templateObject$o=function(){return e},e}var defaultComponentOptions={rowsPerPageText:"Rows per page:",rangeSeparatorText:"of",noRowsPerPage:!1,selectAllRowsItem:!1,selectAllRowsItemText:"All"},PaginationWrapper=styled__default.default.nav(_templateObject$o(),function(e){return e.theme.pagination.style}),Button=styled__default.default.button(_templateObject2$c(),function(e){return e.theme.pagination.pageButtonsStyle},function(e){return e.isRTL&&"transform: scale(-1, -1)"}),PageList=styled__default.default.div(_templateObject3$6(),media.sm(_templateObject4$2())),Span=styled__default.default.span(_templateObject5$1()),Range=styled__default.default(Span)(_templateObject6$1()),RowLabel=styled__default.default(Span)(_templateObject7$1()),Pagination=function(e){var t=e.rowsPerPage,n=e.rowCount,r=e.onChangePage,o=e.onChangeRowsPerPage,a=e.currentPage,l=useTableContext(),i=l.direction,c=l.paginationRowsPerPageOptions,u=l.paginationIconLastPage,s=l.paginationIconFirstPage,p=l.paginationIconNext,d=l.paginationIconPrevious,f=l.paginationComponentOptions,y=useWindowSize().width>SMALL,b=detectRTL(i),m=getNumberOfPages(n,t),g=a*t,_=g-t+1,h=1===a,v=a===m,e=_objectSpread2(_objectSpread2({},defaultComponentOptions),f),l=(a===m?"".concat(_,"-").concat(n," "):"".concat(_,"-").concat(g," ")).concat(e.rangeSeparatorText," ").concat(n),i=React.useCallback(function(){return r(a-1)},[a,r]),f=React.useCallback(function(){return r(a+1)},[a,r]),m=React.useCallback(function(){return r(1)},[r]),_=React.useCallback(function(){return r(getNumberOfPages(n,t))},[r,n,t]),g=React.useCallback(function(e){e=e.target;return o(Number(e.value),a)},[a,o]),c=c.map(function(e){return React__default.default.createElement("option",{key:e,value:e},e)});e.selectAllRowsItem&&c.push(React__default.default.createElement("option",{key:-1,value:n},e.selectAllRowsItemText));c=React__default.default.createElement(Select,{onChange:g,defaultValue:t,"aria-label":e.rowsPerPageText},c);return React__default.default.createElement(PaginationWrapper,{className:"rdt_Pagination"},!e.noRowsPerPage&&y&&React__default.default.createElement(React__default.default.Fragment,null,React__default.default.createElement(RowLabel,null,e.rowsPerPageText),c),y&&React__default.default.createElement(Range,null,l),React__default.default.createElement(PageList,null,React__default.default.createElement(Button,{id:"pagination-first-page",type:"button","aria-label":"First Page","aria-disabled":h,onClick:m,disabled:h,isRTL:b},s),React__default.default.createElement(Button,{id:"pagination-previous-page",type:"button","aria-label":"Previous Page","aria-disabled":h,onClick:i,disabled:h,isRTL:b},d),!y&&c,React__default.default.createElement(Button,{id:"pagination-next-page",type:"button","aria-label":"Next Page","aria-disabled":v,onClick:f,disabled:v,isRTL:b},p),React__default.default.createElement(Button,{id:"pagination-last-page",type:"button","aria-label":"Last Page","aria-disabled":v,onClick:_,disabled:v,isRTL:b},u)))};function useFirstUpdate(e,t){var n=React.useRef(!0);React.useEffect(function(){n.current?n.current=!1:e()},t)}Pagination.propTypes={rowsPerPage:propTypes.number.isRequired,rowCount:propTypes.number.isRequired,onChangePage:propTypes.func.isRequired,onChangeRowsPerPage:propTypes.func.isRequired,currentPage:propTypes.number.isRequired};var FirstPageIcon=function(){return React__default.default.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",width:"24",height:"24",viewBox:"0 0 24 24","aria-hidden":"true",role:"presentation"},React__default.default.createElement("path",{d:"M18.41 16.59L13.82 12l4.59-4.59L17 6l-6 6 6 6zM6 6h2v12H6z"}),React__default.default.createElement("path",{fill:"none",d:"M24 24H0V0h24v24z"}))},LastPageIcon=function(){return React__default.default.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",width:"24",height:"24",viewBox:"0 0 24 24","aria-hidden":"true",role:"presentation"},React__default.default.createElement("path",{d:"M5.59 7.41L10.18 12l-4.59 4.59L7 18l6-6-6-6zM16 6h2v12h-2z"}),React__default.default.createElement("path",{fill:"none",d:"M0 0h24v24H0V0z"}))},LeftIcon=function(){return React__default.default.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",width:"24",height:"24",viewBox:"0 0 24 24","aria-hidden":"true",role:"presentation"},React__default.default.createElement("path",{d:"M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"}),React__default.default.createElement("path",{d:"M0 0h24v24H0z",fill:"none"}))},RightIcon=function(){return React__default.default.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",width:"24",height:"24",viewBox:"0 0 24 24","aria-hidden":"true",role:"presentation"},React__default.default.createElement("path",{d:"M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"}),React__default.default.createElement("path",{d:"M0 0h24v24H0z",fill:"none"}))},ExpanderCollapsedIcon=function(){return React__default.default.createElement("svg",{fill:"currentColor",height:"24",viewBox:"0 0 24 24",width:"24",xmlns:"http://www.w3.org/2000/svg"},React__default.default.createElement("path",{d:"M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"}),React__default.default.createElement("path",{d:"M0-.25h24v24H0z",fill:"none"}))},ExpanderExpandedIcon=function(){return React__default.default.createElement("svg",{fill:"currentColor",height:"24",viewBox:"0 0 24 24",width:"24",xmlns:"http://www.w3.org/2000/svg"},React__default.default.createElement("path",{d:"M7.41 7.84L12 12.42l4.59-4.58L18 9.25l-6 6-6-6z"}),React__default.default.createElement("path",{d:"M0-.75h24v24H0z",fill:"none"}))},propTypes$1={title:propTypes.oneOfType([propTypes.string,propTypes.node]),selectableRows:propTypes.bool,selectableRowsHighlight:propTypes.bool,selectableRowsVisibleOnly:propTypes.bool,selectableRowsNoSelectAll:propTypes.bool,selectableRowSelected:propTypes.func,selectableRowDisabled:propTypes.func,selectableRowsComponent:propTypes.oneOfType([propTypes.string,propTypes.node,propTypes.func,propTypes.object]),selectableRowsComponentProps:propTypes.object,onRowsSelectedUpdate:propTypes.func,clearSelectedRows:propTypes.bool,expandableRows:propTypes.bool,expandableRowDisabled:propTypes.func,expandableRowExpanded:propTypes.func,expandOnRowClicked:propTypes.bool,expandableRowsHideExpander:propTypes.bool,expandOnRowDoubleClicked:propTypes.bool,onRowExpandToggled:propTypes.func,expandableInheritConditionalStyles:propTypes.bool,keyField:propTypes.string,progressPending:propTypes.bool,progressComponent:propTypes.oneOfType([propTypes.string,propTypes.node,propTypes.func]),persistTableHead:propTypes.bool,expandableRowsComponent:propTypes.oneOfType([propTypes.arrayOf(propTypes.node),propTypes.node,propTypes.func]),expandableIcon:propTypes.shape({collapsed:propTypes.oneOfType([propTypes.string,propTypes.node,propTypes.func]),expanded:propTypes.oneOfType([propTypes.string,propTypes.node,propTypes.func])}),sortIcon:propTypes.oneOfType([propTypes.bool,propTypes.node]),sortFunction:propTypes.func,sortServer:propTypes.bool,onSort:propTypes.func,striped:propTypes.bool,highlightOnHover:propTypes.bool,pointerOnHover:propTypes.bool,actions:propTypes.oneOfType([propTypes.arrayOf(propTypes.node),propTypes.node]),noContextMenu:propTypes.bool,contextMessage:propTypes.shape({singular:propTypes.string.isRequired,plural:propTypes.string.isRequired,message:propTypes.string}),contextActions:propTypes.oneOfType([propTypes.arrayOf(propTypes.node),propTypes.node]),contextComponent:propTypes.oneOfType([propTypes.node,propTypes.func]),defaultSortField:propTypes.string,defaultSortAsc:propTypes.bool,columns:propTypes.array,data:propTypes.array,className:propTypes.string,style:propTypes.object,responsive:propTypes.bool,overflowY:propTypes.bool,overflowYOffset:propTypes.string,noDataComponent:propTypes.oneOfType([propTypes.string,propTypes.node,propTypes.func]),disabled:propTypes.bool,noTableHead:propTypes.bool,noHeader:propTypes.bool,subHeader:propTypes.bool,subHeaderAlign:propTypes.string,subHeaderWrap:propTypes.bool,subHeaderComponent:propTypes.oneOfType([propTypes.arrayOf(propTypes.node),propTypes.node,propTypes.string]),onRowClicked:propTypes.func,onRowDoubleClicked:propTypes.func,fixedHeader:propTypes.bool,fixedHeaderScrollHeight:propTypes.string,pagination:propTypes.bool,paginationServer:propTypes.bool,paginationServerOptions:propTypes.shape({persistSelectedOnSort:propTypes.bool,persistSelectedOnPageChange:propTypes.bool}),paginationDefaultPage:propTypes.number,paginationResetDefaultPage:propTypes.bool,paginationTotalRows:propTypes.number,paginationPerPage:propTypes.number,paginationRowsPerPageOptions:propTypes.array,onChangePage:propTypes.func,onChangeRowsPerPage:propTypes.func,paginationComponent:propTypes.oneOfType([propTypes.arrayOf(propTypes.node),propTypes.node,propTypes.func]),paginationComponentOptions:propTypes.object,paginationIconFirstPage:propTypes.oneOfType([propTypes.string,propTypes.node,propTypes.func]),paginationIconLastPage:propTypes.oneOfType([propTypes.string,propTypes.node,propTypes.func]),paginationIconNext:propTypes.oneOfType([propTypes.string,propTypes.node,propTypes.func]),paginationIconPrevious:propTypes.oneOfType([propTypes.string,propTypes.node,propTypes.func]),dense:propTypes.bool,conditionalRowStyles:propTypes.arrayOf(propTypes.shape({when:propTypes.func.isRequired,style:propTypes.object.isRequired})),theme:propTypes.string,customStyles:propTypes.object,direction:propTypes.oneOf(["ltr","rtl","auto"])},defaultProps={title:"",keyField:"id",selectableRows:!1,selectableRowsHighlight:!1,selectableRowsNoSelectAll:!1,selectableRowSelected:null,selectableRowDisabled:null,selectableRowsComponent:"input",selectableRowsComponentProps:{},onSelectedRowsChange:function(){return null},clearSelectedRows:!1,expandableRows:!1,expandableRowDisabled:null,expandableRowExpanded:null,expandOnRowClicked:!1,expandableRowsHideExpander:!1,expandOnRowDoubleClicked:!1,expandableInheritConditionalStyles:!1,onRowExpandToggled:function(){return null},progressPending:!1,progressComponent:React__default.default.createElement("div",{style:{fontSize:"24px",fontWeight:700,padding:"24px"}},"Loading..."),persistTableHead:!1,expandableRowsComponent:React__default.default.createElement("div",{style:{padding:"24px"}},"Add a custom expander component. Use props.data for row data"),expandableIcon:{collapsed:React__default.default.createElement(ExpanderCollapsedIcon,null),expanded:React__default.default.createElement(ExpanderExpandedIcon,null)},sortIcon:!1,sortFunction:null,sortServer:!1,onSort:function(){return null},striped:!1,highlightOnHover:!1,pointerOnHover:!1,noContextMenu:!1,contextMessage:{singular:"item",plural:"items",message:"selected"},contextActions:[],contextComponent:null,defaultSortField:null,defaultSortAsc:!0,columns:[],data:[],className:null,style:{},responsive:!0,overflowY:!1,overflowYOffset:"250px",noDataComponent:React__default.default.createElement("div",{style:{padding:"24px"}},"There are no records to display"),disabled:!1,noTableHead:!1,noHeader:!1,subHeader:!1,subHeaderAlign:"right",subHeaderWrap:!0,subHeaderComponent:[],onRowClicked:function(){return null},onRowDoubleClicked:function(){return null},fixedHeader:!1,fixedHeaderScrollHeight:"100vh",pagination:!1,paginationServer:!1,paginationServerOptions:{persistSelectedOnSort:!1,persistSelectedOnPageChange:!1},paginationDefaultPage:1,paginationResetDefaultPage:!1,paginationTotalRows:0,paginationPerPage:10,paginationRowsPerPageOptions:[10,15,20,25,30],onChangePage:function(){return null},onChangeRowsPerPage:function(){return null},paginationComponent:null,paginationComponentOptions:{},paginationIconFirstPage:React__default.default.createElement(FirstPageIcon,null),paginationIconLastPage:React__default.default.createElement(LastPageIcon,null),paginationIconNext:React__default.default.createElement(RightIcon,null),paginationIconPrevious:React__default.default.createElement(LeftIcon,null),dense:!1,conditionalRowStyles:[],theme:"default",customStyles:{},direction:"auto"},isMergeableObject=function(e){return isNonNullObject(e)&&!isSpecial(e)};function isNonNullObject(e){return!!e&&"object"==typeof e}function isSpecial(e){var t=Object.prototype.toString.call(e);return"[object RegExp]"===t||"[object Date]"===t||isReactElement(e)}var canUseSymbol="function"==typeof Symbol&&Symbol.for,REACT_ELEMENT_TYPE=canUseSymbol?Symbol.for("react.element"):60103;function isReactElement(e){return e.$$typeof===REACT_ELEMENT_TYPE}function emptyTarget(e){return Array.isArray(e)?[]:{}}function cloneUnlessOtherwiseSpecified(e,t){return!1!==t.clone&&t.isMergeableObject(e)?deepmerge(emptyTarget(e),e,t):e}function defaultArrayMerge(e,t,n){return e.concat(t).map(function(e){return cloneUnlessOtherwiseSpecified(e,n)})}function getMergeFunction(e,t){if(!t.customMerge)return deepmerge;e=t.customMerge(e);return"function"==typeof e?e:deepmerge}function getEnumerableOwnPropertySymbols(t){return Object.getOwnPropertySymbols?Object.getOwnPropertySymbols(t).filter(function(e){return t.propertyIsEnumerable(e)}):[]}function getKeys(e){return Object.keys(e).concat(getEnumerableOwnPropertySymbols(e))}function propertyIsOnObject(e,t){try{return t in e}catch(e){return!1}}function propertyIsUnsafe(e,t){return propertyIsOnObject(e,t)&&!(Object.hasOwnProperty.call(e,t)&&Object.propertyIsEnumerable.call(e,t))}function mergeObject(t,n,r){var o={};return r.isMergeableObject(t)&&getKeys(t).forEach(function(e){o[e]=cloneUnlessOtherwiseSpecified(t[e],r)}),getKeys(n).forEach(function(e){propertyIsUnsafe(t,e)||(propertyIsOnObject(t,e)&&r.isMergeableObject(n[e])?o[e]=getMergeFunction(e,r)(t[e],n[e],r):o[e]=cloneUnlessOtherwiseSpecified(n[e],r))}),o}function deepmerge(e,t,n){(n=n||{}).arrayMerge=n.arrayMerge||defaultArrayMerge,n.isMergeableObject=n.isMergeableObject||isMergeableObject,n.cloneUnlessOtherwiseSpecified=cloneUnlessOtherwiseSpecified;var r=Array.isArray(t);return r===Array.isArray(e)?r?n.arrayMerge(e,t,n):mergeObject(e,t,n):cloneUnlessOtherwiseSpecified(t,n)}deepmerge.all=function(e,n){if(!Array.isArray(e))throw new Error("first argument should be an array");return e.reduce(function(e,t){return deepmerge(e,t,n)},{})};var deepmerge_1=deepmerge,cjs=deepmerge,defaultThemes={default:{text:{primary:"rgba(0, 0, 0, 0.87)",secondary:"rgba(0, 0, 0, 0.54)",disabled:"rgba(0, 0, 0, 0.38)"},background:{default:"#FFFFFF"},context:{background:"#e3f2fd",text:"rgba(0, 0, 0, 0.87)"},divider:{default:"rgba(0,0,0,.12)"},button:{default:"rgba(0,0,0,.54)",focus:"rgba(0,0,0,.12)",hover:"rgba(0,0,0,.12)",disabled:"rgba(0, 0, 0, .18)"},sortFocus:{default:"rgba(0, 0, 0, .54)"},selected:{default:"#e3f2fd",text:"rgba(0, 0, 0, 0.87)"},highlightOnHover:{default:"#EEEEEE",text:"rgba(0, 0, 0, 0.87)"},striped:{default:"#FAFAFA",text:"rgba(0, 0, 0, 0.87)"}},dark:{text:{primary:"#FFFFFF",secondary:"rgba(255, 255, 255, 0.7)",disabled:"rgba(0,0,0,.12)"},background:{default:"#424242"},context:{background:"#E91E63",text:"#FFFFFF"},divider:{default:"rgba(81, 81, 81, 1)"},button:{default:"#FFFFFF",focus:"rgba(255, 255, 255, .54)",hover:"rgba(255, 255, 255, .12)",disabled:"rgba(255, 255, 255, .18)"},sortFocus:{default:"rgba(255, 255, 255, .54)"},selected:{default:"rgba(0, 0, 0, .7)",text:"#FFFFFF"},highlightOnHover:{default:"rgba(0, 0, 0, .7)",text:"#FFFFFF"},striped:{default:"rgba(0, 0, 0, .87)",text:"#FFFFFF"}}},createTheme=function(e,t){t=1<arguments.length&&void 0!==t?t:{};return defaultThemes[e]=cjs(defaultThemes.default,t),defaultThemes[e]},defaultStyles=function(e){return{table:{style:{color:e.text.primary,backgroundColor:e.background.default}},tableWrapper:{style:{display:"table"}},header:{style:{fontSize:"22px",color:e.text.primary,backgroundColor:e.background.default,minHeight:"56px",paddingLeft:"16px",paddingRight:"8px"}},subHeader:{style:{backgroundColor:e.background.default,minHeight:"52px"}},head:{style:{}},headRow:{style:{backgroundColor:e.background.default,minHeight:"56px",borderBottomWidth:"1px",borderBottomColor:e.divider.default,borderBottomStyle:"solid"},denseStyle:{minHeight:"32px"}},headCells:{style:{fontSize:"12px",fontWeight:500,color:e.text.primary,paddingLeft:"16px",paddingRight:"16px"},activeSortStyle:{color:e.text.primary,"&:focus":{outline:"none"},"&:hover:not(:focus)":{color:e.sortFocus.default}},inactiveSortStyle:{"&:focus":{outline:"none",color:e.sortFocus.default},"&:hover":{color:e.sortFocus.default}}},contextMenu:{style:{backgroundColor:e.context.background,fontSize:"18px",fontWeight:400,color:e.context.text,paddingLeft:"16px",paddingRight:"8px",transform:"translate3d(0, -100%, 0)",transitionDuration:"125ms",transitionTimingFunction:"cubic-bezier(0, 0, 0.2, 1)",willChange:"transform"},activeStyle:{transform:"translate3d(0, 0, 0)"}},cells:{style:{paddingLeft:"16px",paddingRight:"16px",wordBreak:"break-word"}},rows:{style:{fontSize:"13px",color:e.text.primary,backgroundColor:e.background.default,minHeight:"48px","&:not(:last-of-type)":{borderBottomStyle:"solid",borderBottomWidth:"1px",borderBottomColor:e.divider.default}},denseStyle:{minHeight:"32px"},selectedHighlightStyle:{"&:nth-of-type(n)":{color:e.selected.text,backgroundColor:e.selected.default,borderBottomColor:e.background.default}},highlightOnHoverStyle:{color:e.highlightOnHover.text,backgroundColor:e.highlightOnHover.default,transitionDuration:"0.15s",transitionProperty:"background-color",borderBottomColor:e.background.default,outlineStyle:"solid",outlineWidth:"1px",outlineColor:e.background.default},stripedStyle:{color:e.striped.text,backgroundColor:e.striped.default}},expanderRow:{style:{color:e.text.primary,backgroundColor:e.background.default}},expanderCell:{style:{flex:"0 0 48px"}},expanderButton:{style:{color:e.button.default,fill:e.button.default,backgroundColor:"transparent",borderRadius:"2px",transition:"0.25s",height:"100%",width:"100%","&:hover:enabled":{cursor:"pointer"},"&:disabled":{color:e.button.disabled},"&:hover:not(:disabled)":{cursor:"pointer",backgroundColor:e.button.hover},"&:focus":{outline:"none",backgroundColor:e.button.focus},svg:{margin:"auto"}}},pagination:{style:{color:e.text.secondary,fontSize:"13px",minHeight:"56px",backgroundColor:e.background.default,borderTopStyle:"solid",borderTopWidth:"1px",borderTopColor:e.divider.default},pageButtonsStyle:{borderRadius:"50%",height:"40px",width:"40px",padding:"8px",margin:"px",cursor:"pointer",transition:"0.4s",color:e.button.default,fill:e.button.default,backgroundColor:"transparent","&:disabled":{cursor:"unset",color:e.button.disabled,fill:e.button.disabled},"&:hover:not(:disabled)":{backgroundColor:e.button.hover},"&:focus":{outline:"none",backgroundColor:e.button.focus}}},noData:{style:{display:"flex",alignItems:"center",justifyContent:"center",color:e.text.primary,backgroundColor:e.background.default}},progress:{style:{display:"flex",alignItems:"center",justifyContent:"center",color:e.text.primary,backgroundColor:e.background.default}}}},createStyles=function(e,t){e=0<arguments.length&&void 0!==e?e:{},t=1<arguments.length&&void 0!==t?t:"default",t=defaultThemes[t]?t:"default";return cjs(defaultStyles(defaultThemes[t]),e)},DataTable=React.memo(function(e){function n(e){return Le({type:"CHANGE_PAGE",page:e,paginationServer:x,visibleOnly:y,persistSelectedOnPageChange:Fe})}var t=e.data,r=e.columns,o=e.title,a=e.actions,l=e.keyField,i=e.striped,c=e.highlightOnHover,u=e.pointerOnHover,s=e.dense,p=e.selectableRows,d=e.selectableRowsHighlight,f=e.selectableRowsNoSelectAll,y=e.selectableRowsVisibleOnly,b=e.selectableRowSelected,m=e.selectableRowDisabled,g=e.selectableRowsComponent,_=e.selectableRowsComponentProps,h=e.onRowExpandToggled,v=e.onSelectedRowsChange,T=e.expandableIcon,w=e.onChangeRowsPerPage,R=e.onChangePage,x=e.paginationServer,O=e.paginationServerOptions,S=e.paginationTotalRows,C=e.paginationDefaultPage,j=e.paginationResetDefaultPage,E=e.paginationPerPage,P=e.paginationRowsPerPageOptions,$=e.paginationIconLastPage,I=e.paginationIconFirstPage,k=e.paginationIconNext,A=e.paginationIconPrevious,L=e.paginationComponent,F=e.paginationComponentOptions,M=e.className,H=e.style,N=e.responsive,D=e.overflowY,z=e.overflowYOffset,W=e.progressPending,q=e.progressComponent,B=e.persistTableHead,V=e.noDataComponent,U=e.disabled,G=e.noTableHead,Y=e.noHeader,K=e.fixedHeader,J=e.fixedHeaderScrollHeight,Q=e.pagination,X=e.subHeader,Z=e.subHeaderAlign,ee=e.subHeaderWrap,te=e.subHeaderComponent,ne=e.noContextMenu,re=e.contextMessage,oe=e.contextActions,ae=e.contextComponent,le=e.expandableRows,ie=e.onRowClicked,ce=e.onRowDoubleClicked,ue=e.sortIcon,se=e.onSort,pe=e.sortFunction,de=e.sortServer,fe=e.expandableRowsComponent,ye=e.expandableRowDisabled,be=e.expandableRowsHideExpander,me=e.expandOnRowClicked,ge=e.expandOnRowDoubleClicked,_e=e.expandableRowExpanded,he=e.expandableInheritConditionalStyles,ve=e.defaultSortField,Te=e.defaultSortAsc,we=e.clearSelectedRows,Re=e.conditionalRowStyles,xe=e.theme,Oe=e.customStyles,Se=e.direction,e={allSelected:!1,selectedCount:0,selectedRows:[],sortColumn:ve,selectedColumn:{},sortDirection:getSortDirection(Te),currentPage:C,rowsPerPage:E},ve=_slicedToArray(React.useReducer(tableReducer,e),2),Te=ve[0],Ce=Te.rowsPerPage,je=Te.currentPage,Ee=Te.selectedRows,Pe=Te.allSelected,$e=Te.selectedCount,Ie=Te.sortColumn,ke=Te.selectedColumn,Ae=Te.sortDirection,Le=ve[1],E=O.persistSelectedOnSort,Fe=O.persistSelectedOnPageChange,Me=x&&(Fe||E),e=Q&&!W&&0<t.length,Te=L||Pagination,He=React.useMemo(function(){return decorateColumns(r)},[r]),ve=React.useMemo(function(){return createStyles(Oe,xe)},[Oe,xe]),Ne=React.useMemo(function(){return fe},[fe]),L=React.useMemo(function(){return _objectSpread2({},"auto"!==Se&&{dir:Se})},[Se]),De=React.useCallback(function(e,t){return ie(e,t)},[ie]),ze=React.useCallback(function(e,t){return ce(e,t)},[ce]);useFirstUpdate(function(){v({allSelected:Pe,selectedCount:$e,selectedRows:Ee})},[$e]),useFirstUpdate(function(){R(je,S||t.length)},[je]),useFirstUpdate(function(){w(Ce,je)},[Ce]),useFirstUpdate(function(){se(ke,Ae)},[Ie,Ae]),React.useEffect(function(){Le({type:"CLEAR_SELECTED_ROWS",selectedRowsFlag:we})},[we]),useFirstUpdate(function(){n(C)},[C,j]),React.useEffect(function(){var e;b&&(e=t.filter(function(e){return b(e)}),Le({type:"SELECT_MULTIPLE_ROWS",selectedRows:e,rows:t,mergeSelections:Me}))},[t]),useFirstUpdate(function(){var e;Q&&x&&0<S&&(e=getNumberOfPages(S,Ce),e=recalculatePage(je,e),je!==e&&n(e))},[S]);var We=React.useMemo(function(){return r.reduce(function(e,t){return _objectSpread2(_objectSpread2({},e),{},_defineProperty({},t.selector,t))},{})},[r]),qe=React.useMemo(function(){if(de)return t;var n=Ie&&We[Ie];if(!n||!n.sortFunction)return sort(t,Ie,Ae,pe);var e="asc"===Ae?n.sortFunction:function(e,t){return-1*n.sortFunction(e,t)};return _toConsumableArray(t).sort(e)},[de,Ie,We,Ae,t,pe]),Be=React.useMemo(function(){if(!Q||x)return qe;var e=je*Ce,t=e-Ce;return qe.slice(t,e)},[je,Q,x,Ce,qe]);Q&&!x&&0<t.length&&0===Be.length&&(j=getNumberOfPages(t.length,Ce),j=recalculatePage(je,j),n(j));F={dispatch:Le,data:y?Be:t,allSelected:Pe,selectedRows:Ee,selectedCount:$e,sortColumn:Ie,sortDirection:Ae,keyField:l,contextMessage:re,contextActions:oe,contextComponent:ae,sortServer:de,selectableRowsVisibleOnly:y,selectableRowSelected:b,selectableRowDisabled:m,selectableRowsComponent:g,selectableRowsComponentProps:_,persistSelectedOnSort:E,expandableIcon:T,pagination:Q,paginationServer:x,paginationServerOptions:O,paginationTotalRows:S,paginationRowsPerPageOptions:P,paginationIconLastPage:$,paginationIconFirstPage:I,paginationIconNext:k,paginationIconPrevious:A,paginationComponentOptions:F,direction:Se,mergeSelections:Me},f=Fe||f;return React__default.default.createElement(styled.ThemeProvider,{theme:ve},React__default.default.createElement(DataTableProvider,{initialState:F},!Y&&React__default.default.createElement(TableHeader,{title:o,actions:a,showMenu:!ne}),X&&React__default.default.createElement(TableSubheader,{align:Z,wrapContent:ee},te),React__default.default.createElement(ResponsiveWrapper,_extends({responsive:N,className:M,style:H,overflowYOffset:z,overflowY:D},L),React__default.default.createElement(TableWrapper,null,W&&!B&&React__default.default.createElement(ProgressWrapper,null,q),React__default.default.createElement(TableStyle,{disabled:U,className:"rdt_Table",role:"table"},!G&&(!!B||0<t.length&&!W)&&React__default.default.createElement(TableHead,{className:"rdt_TableHead",role:"rowgroup"},React__default.default.createElement(TableHeadRow,{className:"rdt_TableHeadRow",role:"row",dense:s,disabled:W||0===t.length},p&&(f?React__default.default.createElement(CellBase,{style:{flex:"0 0 48px"}}):React__default.default.createElement(TableColCheckbox,null)),le&&!be&&React__default.default.createElement(TableColExpander,null),He.map(function(e){return React__default.default.createElement(TableCol,{key:e.id,column:e,sortIcon:ue})}))),0<!t.length&&!W&&React__default.default.createElement(NoDataWrapper,null,V),W&&B&&React__default.default.createElement(ProgressWrapper,null,q),!W&&0<t.length&&React__default.default.createElement(TableBody,{fixedHeader:K,fixedHeaderScrollHeight:J,hasOffset:D,offset:z,className:"rdt_TableBody",role:"rowgroup"},Be.map(function(e,t){var n=isEmpty(e[l])?t:e[l],r=isRowSelected(e,Ee,l),o=le&&_e&&_e(e),a=le&&ye&&ye(e);return React__default.default.createElement(TableRow,{id:n,key:n,keyField:l,row:e,columns:He,selectableRows:p,expandableRows:le,striped:i,highlightOnHover:c,pointerOnHover:u,dense:s,expandOnRowClicked:me,expandOnRowDoubleClicked:ge,expandableRowsComponent:Ne,expandableRowsHideExpander:be,onRowExpandToggled:h,defaultExpanderDisabled:a,defaultExpanded:o,inheritConditionalStyles:he,onRowClicked:De,onRowDoubleClicked:ze,conditionalRowStyles:Re,selected:r,selectableRowsHighlight:d,rowIndex:t})}))))),e&&React__default.default.createElement("div",null,React__default.default.createElement(Te,{onChangePage:n,onChangeRowsPerPage:function(e){var t=S||Be.length,t=getNumberOfPages(t,e),t=recalculatePage(je,t);x||n(t),Le({type:"CHANGE_ROWS_PER_PAGE",page:t,rowsPerPage:e})},rowCount:S||t.length,currentPage:je,rowsPerPage:Ce}))))});DataTable.propTypes=propTypes$1,DataTable.defaultProps=defaultProps,exports.createTheme=createTheme,exports.default=DataTable,exports.defaultThemes=defaultThemes;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1842 */
/***/ function(module, exports, __webpack_require__) {

	/** @license React v16.8.6
	 * react-dom.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	/*
	 Modernizr 3.0.0pre (Custom Build) | MIT
	*/
	'use strict';var aa=__webpack_require__(1),n=__webpack_require__(1843),r=__webpack_require__(2133);function ba(a,b,c,d,e,f,g,h){if(!a){a=void 0;if(void 0===b)a=Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var l=[c,d,e,f,g,h],k=0;a=Error(b.replace(/%s/g,function(){return l[k++]}));a.name="Invariant Violation"}a.framesToPop=1;throw a;}}
	function x(a){for(var b=arguments.length-1,c="https://reactjs.org/docs/error-decoder.html?invariant="+a,d=0;d<b;d++)c+="&args[]="+encodeURIComponent(arguments[d+1]);ba(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",c)}aa?void 0:x("227");function ca(a,b,c,d,e,f,g,h,l){var k=Array.prototype.slice.call(arguments,3);try{b.apply(c,k)}catch(m){this.onError(m)}}
	var da=!1,ea=null,fa=!1,ha=null,ia={onError:function(a){da=!0;ea=a}};function ja(a,b,c,d,e,f,g,h,l){da=!1;ea=null;ca.apply(ia,arguments)}function ka(a,b,c,d,e,f,g,h,l){ja.apply(this,arguments);if(da){if(da){var k=ea;da=!1;ea=null}else x("198"),k=void 0;fa||(fa=!0,ha=k)}}var la=null,ma={};
	function na(){if(la)for(var a in ma){var b=ma[a],c=la.indexOf(a);-1<c?void 0:x("96",a);if(!oa[c]){b.extractEvents?void 0:x("97",a);oa[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;pa.hasOwnProperty(h)?x("99",h):void 0;pa[h]=f;var l=f.phasedRegistrationNames;if(l){for(e in l)l.hasOwnProperty(e)&&qa(l[e],g,h);e=!0}else f.registrationName?(qa(f.registrationName,g,h),e=!0):e=!1;e?void 0:x("98",d,a)}}}}
	function qa(a,b,c){ra[a]?x("100",a):void 0;ra[a]=b;sa[a]=b.eventTypes[c].dependencies}var oa=[],pa={},ra={},sa={},ta=null,ua=null,va=null;function wa(a,b,c){var d=a.type||"unknown-event";a.currentTarget=va(c);ka(d,b,void 0,a);a.currentTarget=null}function xa(a,b){null==b?x("30"):void 0;if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}
	function ya(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var za=null;function Aa(a){if(a){var b=a._dispatchListeners,c=a._dispatchInstances;if(Array.isArray(b))for(var d=0;d<b.length&&!a.isPropagationStopped();d++)wa(a,b[d],c[d]);else b&&wa(a,b,c);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}
	var Ba={injectEventPluginOrder:function(a){la?x("101"):void 0;la=Array.prototype.slice.call(a);na()},injectEventPluginsByName:function(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];ma.hasOwnProperty(c)&&ma[c]===d||(ma[c]?x("102",c):void 0,ma[c]=d,b=!0)}b&&na()}};
	function Ca(a,b){var c=a.stateNode;if(!c)return null;var d=ta(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;c&&"function"!==typeof c?x("231",b,typeof c):void 0;
	return c}function Da(a){null!==a&&(za=xa(za,a));a=za;za=null;if(a&&(ya(a,Aa),za?x("95"):void 0,fa))throw a=ha,fa=!1,ha=null,a;}var Ea=Math.random().toString(36).slice(2),Fa="__reactInternalInstance$"+Ea,Ga="__reactEventHandlers$"+Ea;function Ha(a){if(a[Fa])return a[Fa];for(;!a[Fa];)if(a.parentNode)a=a.parentNode;else return null;a=a[Fa];return 5===a.tag||6===a.tag?a:null}function Ia(a){a=a[Fa];return!a||5!==a.tag&&6!==a.tag?null:a}
	function Ja(a){if(5===a.tag||6===a.tag)return a.stateNode;x("33")}function Ka(a){return a[Ga]||null}function La(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}function Ma(a,b,c){if(b=Ca(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=xa(c._dispatchListeners,b),c._dispatchInstances=xa(c._dispatchInstances,a)}
	function Na(a){if(a&&a.dispatchConfig.phasedRegistrationNames){for(var b=a._targetInst,c=[];b;)c.push(b),b=La(b);for(b=c.length;0<b--;)Ma(c[b],"captured",a);for(b=0;b<c.length;b++)Ma(c[b],"bubbled",a)}}function Oa(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Ca(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=xa(c._dispatchListeners,b),c._dispatchInstances=xa(c._dispatchInstances,a))}function Pa(a){a&&a.dispatchConfig.registrationName&&Oa(a._targetInst,null,a)}
	function Qa(a){ya(a,Na)}var Ra=!("undefined"===typeof window||!window.document||!window.document.createElement);function Sa(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;return c}var Ta={animationend:Sa("Animation","AnimationEnd"),animationiteration:Sa("Animation","AnimationIteration"),animationstart:Sa("Animation","AnimationStart"),transitionend:Sa("Transition","TransitionEnd")},Ua={},Va={};
	Ra&&(Va=document.createElement("div").style,"AnimationEvent"in window||(delete Ta.animationend.animation,delete Ta.animationiteration.animation,delete Ta.animationstart.animation),"TransitionEvent"in window||delete Ta.transitionend.transition);function Wa(a){if(Ua[a])return Ua[a];if(!Ta[a])return a;var b=Ta[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Va)return Ua[a]=b[c];return a}
	var Xa=Wa("animationend"),Ya=Wa("animationiteration"),Za=Wa("animationstart"),$a=Wa("transitionend"),ab="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),bb=null,cb=null,db=null;
	function eb(){if(db)return db;var a,b=cb,c=b.length,d,e="value"in bb?bb.value:bb.textContent,f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);return db=e.slice(a,1<d?1-d:void 0)}function fb(){return!0}function gb(){return!1}
	function y(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?fb:gb;this.isPropagationStopped=gb;return this}
	n(y.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=fb)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=fb)},persist:function(){this.isPersistent=fb},isPersistent:gb,destructor:function(){var a=this.constructor.Interface,
	b;for(b in a)this[b]=null;this.nativeEvent=this._targetInst=this.dispatchConfig=null;this.isPropagationStopped=this.isDefaultPrevented=gb;this._dispatchInstances=this._dispatchListeners=null}});y.Interface={type:null,target:null,currentTarget:function(){return null},eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
	y.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;n(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=n({},d.Interface,a);c.extend=d.extend;hb(c);return c};hb(y);function ib(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}function jb(a){a instanceof this?void 0:x("279");a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}
	function hb(a){a.eventPool=[];a.getPooled=ib;a.release=jb}var kb=y.extend({data:null}),lb=y.extend({data:null}),mb=[9,13,27,32],nb=Ra&&"CompositionEvent"in window,ob=null;Ra&&"documentMode"in document&&(ob=document.documentMode);
	var pb=Ra&&"TextEvent"in window&&!ob,qb=Ra&&(!nb||ob&&8<ob&&11>=ob),rb=String.fromCharCode(32),sb={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
	captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},tb=!1;
	function ub(a,b){switch(a){case "keyup":return-1!==mb.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function vb(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var wb=!1;function xb(a,b){switch(a){case "compositionend":return vb(b);case "keypress":if(32!==b.which)return null;tb=!0;return rb;case "textInput":return a=b.data,a===rb&&tb?null:a;default:return null}}
	function yb(a,b){if(wb)return"compositionend"===a||!nb&&ub(a,b)?(a=eb(),db=cb=bb=null,wb=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return qb&&"ko"!==b.locale?null:b.data;default:return null}}
	var zb={eventTypes:sb,extractEvents:function(a,b,c,d){var e=void 0;var f=void 0;if(nb)b:{switch(a){case "compositionstart":e=sb.compositionStart;break b;case "compositionend":e=sb.compositionEnd;break b;case "compositionupdate":e=sb.compositionUpdate;break b}e=void 0}else wb?ub(a,c)&&(e=sb.compositionEnd):"keydown"===a&&229===c.keyCode&&(e=sb.compositionStart);e?(qb&&"ko"!==c.locale&&(wb||e!==sb.compositionStart?e===sb.compositionEnd&&wb&&(f=eb()):(bb=d,cb="value"in bb?bb.value:bb.textContent,wb=
	!0)),e=kb.getPooled(e,b,c,d),f?e.data=f:(f=vb(c),null!==f&&(e.data=f)),Qa(e),f=e):f=null;(a=pb?xb(a,c):yb(a,c))?(b=lb.getPooled(sb.beforeInput,b,c,d),b.data=a,Qa(b)):b=null;return null===f?b:null===b?f:[f,b]}},Ab=null,Bb=null,Cb=null;function Db(a){if(a=ua(a)){"function"!==typeof Ab?x("280"):void 0;var b=ta(a.stateNode);Ab(a.stateNode,a.type,b)}}function Eb(a){Bb?Cb?Cb.push(a):Cb=[a]:Bb=a}function Fb(){if(Bb){var a=Bb,b=Cb;Cb=Bb=null;Db(a);if(b)for(a=0;a<b.length;a++)Db(b[a])}}
	function Gb(a,b){return a(b)}function Hb(a,b,c){return a(b,c)}function Ib(){}var Jb=!1;function Kb(a,b){if(Jb)return a(b);Jb=!0;try{return Gb(a,b)}finally{if(Jb=!1,null!==Bb||null!==Cb)Ib(),Fb()}}var Lb={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function Mb(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!Lb[a.type]:"textarea"===b?!0:!1}
	function Nb(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}function Ob(a){if(!Ra)return!1;a="on"+a;var b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}function Pb(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
	function Qb(a){var b=Pb(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
	null;delete a[b]}}}}function Rb(a){a._valueTracker||(a._valueTracker=Qb(a))}function Sb(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=Pb(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}var Tb=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;Tb.hasOwnProperty("ReactCurrentDispatcher")||(Tb.ReactCurrentDispatcher={current:null});
	var Ub=/^(.*)[\\\/]/,z="function"===typeof Symbol&&Symbol.for,Vb=z?Symbol.for("react.element"):60103,Wb=z?Symbol.for("react.portal"):60106,Xb=z?Symbol.for("react.fragment"):60107,Yb=z?Symbol.for("react.strict_mode"):60108,Zb=z?Symbol.for("react.profiler"):60114,$b=z?Symbol.for("react.provider"):60109,ac=z?Symbol.for("react.context"):60110,bc=z?Symbol.for("react.concurrent_mode"):60111,cc=z?Symbol.for("react.forward_ref"):60112,dc=z?Symbol.for("react.suspense"):60113,ec=z?Symbol.for("react.memo"):
	60115,fc=z?Symbol.for("react.lazy"):60116,gc="function"===typeof Symbol&&Symbol.iterator;function hc(a){if(null===a||"object"!==typeof a)return null;a=gc&&a[gc]||a["@@iterator"];return"function"===typeof a?a:null}
	function ic(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case bc:return"ConcurrentMode";case Xb:return"Fragment";case Wb:return"Portal";case Zb:return"Profiler";case Yb:return"StrictMode";case dc:return"Suspense"}if("object"===typeof a)switch(a.$$typeof){case ac:return"Context.Consumer";case $b:return"Context.Provider";case cc:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+
	")":"ForwardRef");case ec:return ic(a.type);case fc:if(a=1===a._status?a._result:null)return ic(a)}return null}function jc(a){var b="";do{a:switch(a.tag){case 3:case 4:case 6:case 7:case 10:case 9:var c="";break a;default:var d=a._debugOwner,e=a._debugSource,f=ic(a.type);c=null;d&&(c=ic(d.type));d=f;f="";e?f=" (at "+e.fileName.replace(Ub,"")+":"+e.lineNumber+")":c&&(f=" (created by "+c+")");c="\n    in "+(d||"Unknown")+f}b+=c;a=a.return}while(a);return b}
	var kc=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,lc=Object.prototype.hasOwnProperty,mc={},nc={};
	function oc(a){if(lc.call(nc,a))return!0;if(lc.call(mc,a))return!1;if(kc.test(a))return nc[a]=!0;mc[a]=!0;return!1}function pc(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
	function qc(a,b,c,d){if(null===b||"undefined"===typeof b||pc(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function C(a,b,c,d,e){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b}var D={};
	"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){D[a]=new C(a,0,!1,a,null)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];D[b]=new C(b,1,!1,a[1],null)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){D[a]=new C(a,2,!1,a.toLowerCase(),null)});
	["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){D[a]=new C(a,2,!1,a,null)});"allowFullScreen async autoFocus autoPlay controls default defer disabled formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){D[a]=new C(a,3,!1,a.toLowerCase(),null)});["checked","multiple","muted","selected"].forEach(function(a){D[a]=new C(a,3,!0,a,null)});
	["capture","download"].forEach(function(a){D[a]=new C(a,4,!1,a,null)});["cols","rows","size","span"].forEach(function(a){D[a]=new C(a,6,!1,a,null)});["rowSpan","start"].forEach(function(a){D[a]=new C(a,5,!1,a.toLowerCase(),null)});var rc=/[\-:]([a-z])/g;function sc(a){return a[1].toUpperCase()}
	"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(rc,
	sc);D[b]=new C(b,1,!1,a,null)});"xlink:actuate xlink:arcrole xlink:href xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(rc,sc);D[b]=new C(b,1,!1,a,"http://www.w3.org/1999/xlink")});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(rc,sc);D[b]=new C(b,1,!1,a,"http://www.w3.org/XML/1998/namespace")});["tabIndex","crossOrigin"].forEach(function(a){D[a]=new C(a,1,!1,a.toLowerCase(),null)});
	function tc(a,b,c,d){var e=D.hasOwnProperty(b)?D[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(qc(b,c,e,d)&&(c=null),d||null===e?oc(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
	function uc(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}function vc(a,b){var c=b.checked;return n({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}
	function wc(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=uc(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function xc(a,b){b=b.checked;null!=b&&tc(a,"checked",b,!1)}
	function yc(a,b){xc(a,b);var c=uc(b.value),d=b.type;if(null!=c)if("number"===d){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else if("submit"===d||"reset"===d){a.removeAttribute("value");return}b.hasOwnProperty("value")?zc(a,b.type,c):b.hasOwnProperty("defaultValue")&&zc(a,b.type,uc(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
	function Ac(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){var d=b.type;if(!("submit"!==d&&"reset"!==d||void 0!==b.value&&null!==b.value))return;b=""+a._wrapperState.initialValue;c||b===a.value||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!a.defaultChecked;a.defaultChecked=!!a._wrapperState.initialChecked;""!==c&&(a.name=c)}
	function zc(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}var Bc={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function Cc(a,b,c){a=y.getPooled(Bc.change,a,b,c);a.type="change";Eb(c);Qa(a);return a}var Dc=null,Ec=null;function Fc(a){Da(a)}
	function Gc(a){var b=Ja(a);if(Sb(b))return a}function Hc(a,b){if("change"===a)return b}var Ic=!1;Ra&&(Ic=Ob("input")&&(!document.documentMode||9<document.documentMode));function Jc(){Dc&&(Dc.detachEvent("onpropertychange",Kc),Ec=Dc=null)}function Kc(a){"value"===a.propertyName&&Gc(Ec)&&(a=Cc(Ec,a,Nb(a)),Kb(Fc,a))}function Lc(a,b,c){"focus"===a?(Jc(),Dc=b,Ec=c,Dc.attachEvent("onpropertychange",Kc)):"blur"===a&&Jc()}function Mc(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return Gc(Ec)}
	function Nc(a,b){if("click"===a)return Gc(b)}function Oc(a,b){if("input"===a||"change"===a)return Gc(b)}
	var Pc={eventTypes:Bc,_isInputEventSupported:Ic,extractEvents:function(a,b,c,d){var e=b?Ja(b):window,f=void 0,g=void 0,h=e.nodeName&&e.nodeName.toLowerCase();"select"===h||"input"===h&&"file"===e.type?f=Hc:Mb(e)?Ic?f=Oc:(f=Mc,g=Lc):(h=e.nodeName)&&"input"===h.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(f=Nc);if(f&&(f=f(a,b)))return Cc(f,c,d);g&&g(a,e,b);"blur"===a&&(a=e._wrapperState)&&a.controlled&&"number"===e.type&&zc(e,"number",e.value)}},Qc=y.extend({view:null,detail:null}),Rc={Alt:"altKey",
	Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function Sc(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=Rc[a])?!!b[a]:!1}function Tc(){return Sc}
	var Uc=0,Vc=0,Wc=!1,Xc=!1,Yc=Qc.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:Tc,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)},movementX:function(a){if("movementX"in a)return a.movementX;var b=Uc;Uc=a.screenX;return Wc?"mousemove"===a.type?a.screenX-b:0:(Wc=!0,0)},movementY:function(a){if("movementY"in a)return a.movementY;
	var b=Vc;Vc=a.screenY;return Xc?"mousemove"===a.type?a.screenY-b:0:(Xc=!0,0)}}),Zc=Yc.extend({pointerId:null,width:null,height:null,pressure:null,tangentialPressure:null,tiltX:null,tiltY:null,twist:null,pointerType:null,isPrimary:null}),$c={mouseEnter:{registrationName:"onMouseEnter",dependencies:["mouseout","mouseover"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",
	dependencies:["pointerout","pointerover"]}},ad={eventTypes:$c,extractEvents:function(a,b,c,d){var e="mouseover"===a||"pointerover"===a,f="mouseout"===a||"pointerout"===a;if(e&&(c.relatedTarget||c.fromElement)||!f&&!e)return null;e=d.window===d?d:(e=d.ownerDocument)?e.defaultView||e.parentWindow:window;f?(f=b,b=(b=c.relatedTarget||c.toElement)?Ha(b):null):f=null;if(f===b)return null;var g=void 0,h=void 0,l=void 0,k=void 0;if("mouseout"===a||"mouseover"===a)g=Yc,h=$c.mouseLeave,l=$c.mouseEnter,k="mouse";
	else if("pointerout"===a||"pointerover"===a)g=Zc,h=$c.pointerLeave,l=$c.pointerEnter,k="pointer";var m=null==f?e:Ja(f);e=null==b?e:Ja(b);a=g.getPooled(h,f,c,d);a.type=k+"leave";a.target=m;a.relatedTarget=e;c=g.getPooled(l,b,c,d);c.type=k+"enter";c.target=e;c.relatedTarget=m;d=b;if(f&&d)a:{b=f;e=d;k=0;for(g=b;g;g=La(g))k++;g=0;for(l=e;l;l=La(l))g++;for(;0<k-g;)b=La(b),k--;for(;0<g-k;)e=La(e),g--;for(;k--;){if(b===e||b===e.alternate)break a;b=La(b);e=La(e)}b=null}else b=null;e=b;for(b=[];f&&f!==e;){k=
	f.alternate;if(null!==k&&k===e)break;b.push(f);f=La(f)}for(f=[];d&&d!==e;){k=d.alternate;if(null!==k&&k===e)break;f.push(d);d=La(d)}for(d=0;d<b.length;d++)Oa(b[d],"bubbled",a);for(d=f.length;0<d--;)Oa(f[d],"captured",c);return[a,c]}};function bd(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var cd=Object.prototype.hasOwnProperty;
	function dd(a,b){if(bd(a,b))return!0;if("object"!==typeof a||null===a||"object"!==typeof b||null===b)return!1;var c=Object.keys(a),d=Object.keys(b);if(c.length!==d.length)return!1;for(d=0;d<c.length;d++)if(!cd.call(b,c[d])||!bd(a[c[d]],b[c[d]]))return!1;return!0}function ed(a){var b=a;if(a.alternate)for(;b.return;)b=b.return;else{if(0!==(b.effectTag&2))return 1;for(;b.return;)if(b=b.return,0!==(b.effectTag&2))return 1}return 3===b.tag?2:3}function fd(a){2!==ed(a)?x("188"):void 0}
	function gd(a){var b=a.alternate;if(!b)return b=ed(a),3===b?x("188"):void 0,1===b?null:a;for(var c=a,d=b;;){var e=c.return,f=e?e.alternate:null;if(!e||!f)break;if(e.child===f.child){for(var g=e.child;g;){if(g===c)return fd(e),a;if(g===d)return fd(e),b;g=g.sibling}x("188")}if(c.return!==d.return)c=e,d=f;else{g=!1;for(var h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}g?
	void 0:x("189")}}c.alternate!==d?x("190"):void 0}3!==c.tag?x("188"):void 0;return c.stateNode.current===c?a:b}function hd(a){a=gd(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
	var id=y.extend({animationName:null,elapsedTime:null,pseudoElement:null}),jd=y.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),kd=Qc.extend({relatedTarget:null});function ld(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
	var md={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},nd={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
	116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},od=Qc.extend({key:function(a){if(a.key){var b=md[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=ld(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?nd[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:Tc,charCode:function(a){return"keypress"===
	a.type?ld(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?ld(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),pd=Yc.extend({dataTransfer:null}),qd=Qc.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:Tc}),rd=y.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),sd=Yc.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in
	a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),td=[["abort","abort"],[Xa,"animationEnd"],[Ya,"animationIteration"],[Za,"animationStart"],["canplay","canPlay"],["canplaythrough","canPlayThrough"],["drag","drag"],["dragenter","dragEnter"],["dragexit","dragExit"],["dragleave","dragLeave"],["dragover","dragOver"],["durationchange","durationChange"],["emptied","emptied"],["encrypted","encrypted"],
	["ended","ended"],["error","error"],["gotpointercapture","gotPointerCapture"],["load","load"],["loadeddata","loadedData"],["loadedmetadata","loadedMetadata"],["loadstart","loadStart"],["lostpointercapture","lostPointerCapture"],["mousemove","mouseMove"],["mouseout","mouseOut"],["mouseover","mouseOver"],["playing","playing"],["pointermove","pointerMove"],["pointerout","pointerOut"],["pointerover","pointerOver"],["progress","progress"],["scroll","scroll"],["seeking","seeking"],["stalled","stalled"],
	["suspend","suspend"],["timeupdate","timeUpdate"],["toggle","toggle"],["touchmove","touchMove"],[$a,"transitionEnd"],["waiting","waiting"],["wheel","wheel"]],ud={},vd={};function wd(a,b){var c=a[0];a=a[1];var d="on"+(a[0].toUpperCase()+a.slice(1));b={phasedRegistrationNames:{bubbled:d,captured:d+"Capture"},dependencies:[c],isInteractive:b};ud[a]=b;vd[c]=b}
	[["blur","blur"],["cancel","cancel"],["click","click"],["close","close"],["contextmenu","contextMenu"],["copy","copy"],["cut","cut"],["auxclick","auxClick"],["dblclick","doubleClick"],["dragend","dragEnd"],["dragstart","dragStart"],["drop","drop"],["focus","focus"],["input","input"],["invalid","invalid"],["keydown","keyDown"],["keypress","keyPress"],["keyup","keyUp"],["mousedown","mouseDown"],["mouseup","mouseUp"],["paste","paste"],["pause","pause"],["play","play"],["pointercancel","pointerCancel"],
	["pointerdown","pointerDown"],["pointerup","pointerUp"],["ratechange","rateChange"],["reset","reset"],["seeked","seeked"],["submit","submit"],["touchcancel","touchCancel"],["touchend","touchEnd"],["touchstart","touchStart"],["volumechange","volumeChange"]].forEach(function(a){wd(a,!0)});td.forEach(function(a){wd(a,!1)});
	var xd={eventTypes:ud,isInteractiveTopLevelEventType:function(a){a=vd[a];return void 0!==a&&!0===a.isInteractive},extractEvents:function(a,b,c,d){var e=vd[a];if(!e)return null;switch(a){case "keypress":if(0===ld(c))return null;case "keydown":case "keyup":a=od;break;case "blur":case "focus":a=kd;break;case "click":if(2===c.button)return null;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=Yc;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=
	pd;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=qd;break;case Xa:case Ya:case Za:a=id;break;case $a:a=rd;break;case "scroll":a=Qc;break;case "wheel":a=sd;break;case "copy":case "cut":case "paste":a=jd;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=Zc;break;default:a=y}b=a.getPooled(e,b,c,d);Qa(b);return b}},yd=xd.isInteractiveTopLevelEventType,
	zd=[];function Ad(a){var b=a.targetInst,c=b;do{if(!c){a.ancestors.push(c);break}var d;for(d=c;d.return;)d=d.return;d=3!==d.tag?null:d.stateNode.containerInfo;if(!d)break;a.ancestors.push(c);c=Ha(d)}while(c);for(c=0;c<a.ancestors.length;c++){b=a.ancestors[c];var e=Nb(a.nativeEvent);d=a.topLevelType;for(var f=a.nativeEvent,g=null,h=0;h<oa.length;h++){var l=oa[h];l&&(l=l.extractEvents(d,b,f,e))&&(g=xa(g,l))}Da(g)}}var Bd=!0;
	function E(a,b){if(!b)return null;var c=(yd(a)?Cd:Dd).bind(null,a);b.addEventListener(a,c,!1)}function Ed(a,b){if(!b)return null;var c=(yd(a)?Cd:Dd).bind(null,a);b.addEventListener(a,c,!0)}function Cd(a,b){Hb(Dd,a,b)}
	function Dd(a,b){if(Bd){var c=Nb(b);c=Ha(c);null===c||"number"!==typeof c.tag||2===ed(c)||(c=null);if(zd.length){var d=zd.pop();d.topLevelType=a;d.nativeEvent=b;d.targetInst=c;a=d}else a={topLevelType:a,nativeEvent:b,targetInst:c,ancestors:[]};try{Kb(Ad,a)}finally{a.topLevelType=null,a.nativeEvent=null,a.targetInst=null,a.ancestors.length=0,10>zd.length&&zd.push(a)}}}var Fd={},Gd=0,Hd="_reactListenersID"+(""+Math.random()).slice(2);
	function Id(a){Object.prototype.hasOwnProperty.call(a,Hd)||(a[Hd]=Gd++,Fd[a[Hd]]={});return Fd[a[Hd]]}function Jd(a){a=a||("undefined"!==typeof document?document:void 0);if("undefined"===typeof a)return null;try{return a.activeElement||a.body}catch(b){return a.body}}function Kd(a){for(;a&&a.firstChild;)a=a.firstChild;return a}
	function Ld(a,b){var c=Kd(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=Kd(c)}}function Md(a,b){return a&&b?a===b?!0:a&&3===a.nodeType?!1:b&&3===b.nodeType?Md(a,b.parentNode):"contains"in a?a.contains(b):a.compareDocumentPosition?!!(a.compareDocumentPosition(b)&16):!1:!1}
	function Nd(){for(var a=window,b=Jd();b instanceof a.HTMLIFrameElement;){try{var c="string"===typeof b.contentWindow.location.href}catch(d){c=!1}if(c)a=b.contentWindow;else break;b=Jd(a.document)}return b}function Od(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}
	function Pd(){var a=Nd();if(Od(a)){if("selectionStart"in a)var b={start:a.selectionStart,end:a.selectionEnd};else a:{b=(b=a.ownerDocument)&&b.defaultView||window;var c=b.getSelection&&b.getSelection();if(c&&0!==c.rangeCount){b=c.anchorNode;var d=c.anchorOffset,e=c.focusNode;c=c.focusOffset;try{b.nodeType,e.nodeType}catch(A){b=null;break a}var f=0,g=-1,h=-1,l=0,k=0,m=a,p=null;b:for(;;){for(var t;;){m!==b||0!==d&&3!==m.nodeType||(g=f+d);m!==e||0!==c&&3!==m.nodeType||(h=f+c);3===m.nodeType&&(f+=m.nodeValue.length);
	if(null===(t=m.firstChild))break;p=m;m=t}for(;;){if(m===a)break b;p===b&&++l===d&&(g=f);p===e&&++k===c&&(h=f);if(null!==(t=m.nextSibling))break;m=p;p=m.parentNode}m=t}b=-1===g||-1===h?null:{start:g,end:h}}else b=null}b=b||{start:0,end:0}}else b=null;return{focusedElem:a,selectionRange:b}}
	function Qd(a){var b=Nd(),c=a.focusedElem,d=a.selectionRange;if(b!==c&&c&&c.ownerDocument&&Md(c.ownerDocument.documentElement,c)){if(null!==d&&Od(c))if(b=d.start,a=d.end,void 0===a&&(a=b),"selectionStart"in c)c.selectionStart=b,c.selectionEnd=Math.min(a,c.value.length);else if(a=(b=c.ownerDocument||document)&&b.defaultView||window,a.getSelection){a=a.getSelection();var e=c.textContent.length,f=Math.min(d.start,e);d=void 0===d.end?f:Math.min(d.end,e);!a.extend&&f>d&&(e=d,d=f,f=e);e=Ld(c,f);var g=Ld(c,
	d);e&&g&&(1!==a.rangeCount||a.anchorNode!==e.node||a.anchorOffset!==e.offset||a.focusNode!==g.node||a.focusOffset!==g.offset)&&(b=b.createRange(),b.setStart(e.node,e.offset),a.removeAllRanges(),f>d?(a.addRange(b),a.extend(g.node,g.offset)):(b.setEnd(g.node,g.offset),a.addRange(b)))}b=[];for(a=c;a=a.parentNode;)1===a.nodeType&&b.push({element:a,left:a.scrollLeft,top:a.scrollTop});"function"===typeof c.focus&&c.focus();for(c=0;c<b.length;c++)a=b[c],a.element.scrollLeft=a.left,a.element.scrollTop=a.top}}
	var Rd=Ra&&"documentMode"in document&&11>=document.documentMode,Sd={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")}},Td=null,Ud=null,Vd=null,Wd=!1;
	function Xd(a,b){var c=b.window===b?b.document:9===b.nodeType?b:b.ownerDocument;if(Wd||null==Td||Td!==Jd(c))return null;c=Td;"selectionStart"in c&&Od(c)?c={start:c.selectionStart,end:c.selectionEnd}:(c=(c.ownerDocument&&c.ownerDocument.defaultView||window).getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset});return Vd&&dd(Vd,c)?null:(Vd=c,a=y.getPooled(Sd.select,Ud,a,b),a.type="select",a.target=Td,Qa(a),a)}
	var Yd={eventTypes:Sd,extractEvents:function(a,b,c,d){var e=d.window===d?d.document:9===d.nodeType?d:d.ownerDocument,f;if(!(f=!e)){a:{e=Id(e);f=sa.onSelect;for(var g=0;g<f.length;g++){var h=f[g];if(!e.hasOwnProperty(h)||!e[h]){e=!1;break a}}e=!0}f=!e}if(f)return null;e=b?Ja(b):window;switch(a){case "focus":if(Mb(e)||"true"===e.contentEditable)Td=e,Ud=b,Vd=null;break;case "blur":Vd=Ud=Td=null;break;case "mousedown":Wd=!0;break;case "contextmenu":case "mouseup":case "dragend":return Wd=!1,Xd(c,d);case "selectionchange":if(Rd)break;
	case "keydown":case "keyup":return Xd(c,d)}return null}};Ba.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));ta=Ka;ua=Ia;va=Ja;Ba.injectEventPluginsByName({SimpleEventPlugin:xd,EnterLeaveEventPlugin:ad,ChangeEventPlugin:Pc,SelectEventPlugin:Yd,BeforeInputEventPlugin:zb});function Zd(a){var b="";aa.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}
	function $d(a,b){a=n({children:void 0},b);if(b=Zd(b.children))a.children=b;return a}function ae(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+uc(c);b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
	function be(a,b){null!=b.dangerouslySetInnerHTML?x("91"):void 0;return n({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function ce(a,b){var c=b.value;null==c&&(c=b.defaultValue,b=b.children,null!=b&&(null!=c?x("92"):void 0,Array.isArray(b)&&(1>=b.length?void 0:x("93"),b=b[0]),c=b),null==c&&(c=""));a._wrapperState={initialValue:uc(c)}}
	function de(a,b){var c=uc(b.value),d=uc(b.defaultValue);null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&a.defaultValue!==c&&(a.defaultValue=c));null!=d&&(a.defaultValue=""+d)}function ee(a){var b=a.textContent;b===a._wrapperState.initialValue&&(a.value=b)}var fe={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
	function ge(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function he(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?ge(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
	var ie=void 0,je=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==fe.svg||"innerHTML"in a)a.innerHTML=b;else{ie=ie||document.createElement("div");ie.innerHTML="<svg>"+b+"</svg>";for(b=ie.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
	function ke(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}
	var le={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,
	floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},me=["Webkit","ms","Moz","O"];Object.keys(le).forEach(function(a){me.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);le[b]=le[a]})});function ne(a,b,c){return null==b||"boolean"===typeof b||""===b?"":c||"number"!==typeof b||0===b||le.hasOwnProperty(a)&&le[a]?(""+b).trim():b+"px"}
	function oe(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--"),e=ne(c,b[c],d);"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var pe=n({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
	function qe(a,b){b&&(pe[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML?x("137",a,""):void 0),null!=b.dangerouslySetInnerHTML&&(null!=b.children?x("60"):void 0,"object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML?void 0:x("61")),null!=b.style&&"object"!==typeof b.style?x("62",""):void 0)}
	function re(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}
	function se(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=Id(a);b=sa[b];for(var d=0;d<b.length;d++){var e=b[d];if(!c.hasOwnProperty(e)||!c[e]){switch(e){case "scroll":Ed("scroll",a);break;case "focus":case "blur":Ed("focus",a);Ed("blur",a);c.blur=!0;c.focus=!0;break;case "cancel":case "close":Ob(e)&&Ed(e,a);break;case "invalid":case "submit":case "reset":break;default:-1===ab.indexOf(e)&&E(e,a)}c[e]=!0}}}function te(){}var ue=null,ve=null;
	function we(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}function xe(a,b){return"textarea"===a||"option"===a||"noscript"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&null!=b.dangerouslySetInnerHTML.__html}
	var ye="function"===typeof setTimeout?setTimeout:void 0,ze="function"===typeof clearTimeout?clearTimeout:void 0,Ae=r.unstable_scheduleCallback,Be=r.unstable_cancelCallback;
	function Ce(a,b,c,d,e){a[Ga]=e;"input"===c&&"radio"===e.type&&null!=e.name&&xc(a,e);re(c,d);d=re(c,e);for(var f=0;f<b.length;f+=2){var g=b[f],h=b[f+1];"style"===g?oe(a,h):"dangerouslySetInnerHTML"===g?je(a,h):"children"===g?ke(a,h):tc(a,g,h,d)}switch(c){case "input":yc(a,e);break;case "textarea":de(a,e);break;case "select":b=a._wrapperState.wasMultiple,a._wrapperState.wasMultiple=!!e.multiple,c=e.value,null!=c?ae(a,!!e.multiple,c,!1):b!==!!e.multiple&&(null!=e.defaultValue?ae(a,!!e.multiple,e.defaultValue,
	!0):ae(a,!!e.multiple,e.multiple?[]:"",!1))}}function De(a){for(a=a.nextSibling;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a}function Ee(a){for(a=a.firstChild;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a}new Set;var Fe=[],Ge=-1;function F(a){0>Ge||(a.current=Fe[Ge],Fe[Ge]=null,Ge--)}function G(a,b){Ge++;Fe[Ge]=a.current;a.current=b}var He={},H={current:He},I={current:!1},Ie=He;
	function Je(a,b){var c=a.type.contextTypes;if(!c)return He;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function J(a){a=a.childContextTypes;return null!==a&&void 0!==a}function Ke(a){F(I,a);F(H,a)}function Le(a){F(I,a);F(H,a)}
	function Me(a,b,c){H.current!==He?x("168"):void 0;G(H,b,a);G(I,c,a)}function Ne(a,b,c){var d=a.stateNode;a=b.childContextTypes;if("function"!==typeof d.getChildContext)return c;d=d.getChildContext();for(var e in d)e in a?void 0:x("108",ic(b)||"Unknown",e);return n({},c,d)}function Oe(a){var b=a.stateNode;b=b&&b.__reactInternalMemoizedMergedChildContext||He;Ie=H.current;G(H,b,a);G(I,I.current,a);return!0}
	function Pe(a,b,c){var d=a.stateNode;d?void 0:x("169");c?(b=Ne(a,b,Ie),d.__reactInternalMemoizedMergedChildContext=b,F(I,a),F(H,a),G(H,b,a)):F(I,a);G(I,c,a)}var Qe=null,Re=null;function Se(a){return function(b){try{return a(b)}catch(c){}}}
	function Te(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);Qe=Se(function(a){return b.onCommitFiberRoot(c,a)});Re=Se(function(a){return b.onCommitFiberUnmount(c,a)})}catch(d){}return!0}
	function Ue(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null;this.index=0;this.ref=null;this.pendingProps=b;this.contextDependencies=this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.childExpirationTime=this.expirationTime=0;this.alternate=null}function K(a,b,c,d){return new Ue(a,b,c,d)}
	function Ve(a){a=a.prototype;return!(!a||!a.isReactComponent)}function We(a){if("function"===typeof a)return Ve(a)?1:0;if(void 0!==a&&null!==a){a=a.$$typeof;if(a===cc)return 11;if(a===ec)return 14}return 2}
	function Xe(a,b){var c=a.alternate;null===c?(c=K(a.tag,b,a.key,a.mode),c.elementType=a.elementType,c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.pendingProps=b,c.effectTag=0,c.nextEffect=null,c.firstEffect=null,c.lastEffect=null);c.childExpirationTime=a.childExpirationTime;c.expirationTime=a.expirationTime;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;c.contextDependencies=a.contextDependencies;c.sibling=a.sibling;
	c.index=a.index;c.ref=a.ref;return c}
	function Ye(a,b,c,d,e,f){var g=2;d=a;if("function"===typeof a)Ve(a)&&(g=1);else if("string"===typeof a)g=5;else a:switch(a){case Xb:return Ze(c.children,e,f,b);case bc:return $e(c,e|3,f,b);case Yb:return $e(c,e|2,f,b);case Zb:return a=K(12,c,b,e|4),a.elementType=Zb,a.type=Zb,a.expirationTime=f,a;case dc:return a=K(13,c,b,e),a.elementType=dc,a.type=dc,a.expirationTime=f,a;default:if("object"===typeof a&&null!==a)switch(a.$$typeof){case $b:g=10;break a;case ac:g=9;break a;case cc:g=11;break a;case ec:g=
	14;break a;case fc:g=16;d=null;break a}x("130",null==a?a:typeof a,"")}b=K(g,c,b,e);b.elementType=a;b.type=d;b.expirationTime=f;return b}function Ze(a,b,c,d){a=K(7,a,d,b);a.expirationTime=c;return a}function $e(a,b,c,d){a=K(8,a,d,b);b=0===(b&1)?Yb:bc;a.elementType=b;a.type=b;a.expirationTime=c;return a}function af(a,b,c){a=K(6,a,null,b);a.expirationTime=c;return a}
	function bf(a,b,c){b=K(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}function cf(a,b){a.didError=!1;var c=a.earliestPendingTime;0===c?a.earliestPendingTime=a.latestPendingTime=b:c<b?a.earliestPendingTime=b:a.latestPendingTime>b&&(a.latestPendingTime=b);df(b,a)}
	function ef(a,b){a.didError=!1;if(0===b)a.earliestPendingTime=0,a.latestPendingTime=0,a.earliestSuspendedTime=0,a.latestSuspendedTime=0,a.latestPingedTime=0;else{b<a.latestPingedTime&&(a.latestPingedTime=0);var c=a.latestPendingTime;0!==c&&(c>b?a.earliestPendingTime=a.latestPendingTime=0:a.earliestPendingTime>b&&(a.earliestPendingTime=a.latestPendingTime));c=a.earliestSuspendedTime;0===c?cf(a,b):b<a.latestSuspendedTime?(a.earliestSuspendedTime=0,a.latestSuspendedTime=0,a.latestPingedTime=0,cf(a,b)):
	b>c&&cf(a,b)}df(0,a)}function ff(a,b){a.didError=!1;a.latestPingedTime>=b&&(a.latestPingedTime=0);var c=a.earliestPendingTime,d=a.latestPendingTime;c===b?a.earliestPendingTime=d===b?a.latestPendingTime=0:d:d===b&&(a.latestPendingTime=c);c=a.earliestSuspendedTime;d=a.latestSuspendedTime;0===c?a.earliestSuspendedTime=a.latestSuspendedTime=b:c<b?a.earliestSuspendedTime=b:d>b&&(a.latestSuspendedTime=b);df(b,a)}
	function gf(a,b){var c=a.earliestPendingTime;a=a.earliestSuspendedTime;c>b&&(b=c);a>b&&(b=a);return b}function df(a,b){var c=b.earliestSuspendedTime,d=b.latestSuspendedTime,e=b.earliestPendingTime,f=b.latestPingedTime;e=0!==e?e:f;0===e&&(0===a||d<a)&&(e=d);a=e;0!==a&&c>a&&(a=c);b.nextExpirationTimeToWorkOn=e;b.expirationTime=a}function L(a,b){if(a&&a.defaultProps){b=n({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c])}return b}
	function hf(a){var b=a._result;switch(a._status){case 1:return b;case 2:throw b;case 0:throw b;default:a._status=0;b=a._ctor;b=b();b.then(function(b){0===a._status&&(b=b.default,a._status=1,a._result=b)},function(b){0===a._status&&(a._status=2,a._result=b)});switch(a._status){case 1:return a._result;case 2:throw a._result;}a._result=b;throw b;}}var jf=(new aa.Component).refs;
	function kf(a,b,c,d){b=a.memoizedState;c=c(d,b);c=null===c||void 0===c?b:n({},b,c);a.memoizedState=c;d=a.updateQueue;null!==d&&0===a.expirationTime&&(d.baseState=c)}
	var tf={isMounted:function(a){return(a=a._reactInternalFiber)?2===ed(a):!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=lf();d=mf(d,a);var e=nf(d);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);of();pf(a,e);qf(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=lf();d=mf(d,a);var e=nf(d);e.tag=rf;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);of();pf(a,e);qf(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=lf();c=mf(c,a);var d=nf(c);d.tag=
	sf;void 0!==b&&null!==b&&(d.callback=b);of();pf(a,d);qf(a,c)}};function uf(a,b,c,d,e,f,g){a=a.stateNode;return"function"===typeof a.shouldComponentUpdate?a.shouldComponentUpdate(d,f,g):b.prototype&&b.prototype.isPureReactComponent?!dd(c,d)||!dd(e,f):!0}
	function vf(a,b,c){var d=!1,e=He;var f=b.contextType;"object"===typeof f&&null!==f?f=M(f):(e=J(b)?Ie:H.current,d=b.contextTypes,f=(d=null!==d&&void 0!==d)?Je(a,e):He);b=new b(c,f);a.memoizedState=null!==b.state&&void 0!==b.state?b.state:null;b.updater=tf;a.stateNode=b;b._reactInternalFiber=a;d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=e,a.__reactInternalMemoizedMaskedChildContext=f);return b}
	function wf(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&tf.enqueueReplaceState(b,b.state,null)}
	function xf(a,b,c,d){var e=a.stateNode;e.props=c;e.state=a.memoizedState;e.refs=jf;var f=b.contextType;"object"===typeof f&&null!==f?e.context=M(f):(f=J(b)?Ie:H.current,e.context=Je(a,f));f=a.updateQueue;null!==f&&(yf(a,f,c,e,d),e.state=a.memoizedState);f=b.getDerivedStateFromProps;"function"===typeof f&&(kf(a,b,f,c),e.state=a.memoizedState);"function"===typeof b.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==
	typeof e.componentWillMount||(b=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),b!==e.state&&tf.enqueueReplaceState(e,e.state,null),f=a.updateQueue,null!==f&&(yf(a,f,c,e,d),e.state=a.memoizedState));"function"===typeof e.componentDidMount&&(a.effectTag|=4)}var zf=Array.isArray;
	function Af(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;var d=void 0;c&&(1!==c.tag?x("309"):void 0,d=c.stateNode);d?void 0:x("147",a);var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs;b===jf&&(b=d.refs={});null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}"string"!==typeof a?x("284"):void 0;c._owner?void 0:x("290",a)}return a}
	function Bf(a,b){"textarea"!==a.type&&x("31","[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,"")}
	function Cf(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b,c){a=Xe(a,b,c);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
	2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=af(c,a.mode,d),b.return=a,b;b=e(b,c,d);b.return=a;return b}function l(a,b,c,d){if(null!==b&&b.elementType===c.type)return d=e(b,c.props,d),d.ref=Af(a,b,c),d.return=a,d;d=Ye(c.type,c.key,c.props,null,a.mode,d);d.ref=Af(a,b,c);d.return=a;return d}function k(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==
	c.implementation)return b=bf(c,a.mode,d),b.return=a,b;b=e(b,c.children||[],d);b.return=a;return b}function m(a,b,c,d,f){if(null===b||7!==b.tag)return b=Ze(c,a.mode,d,f),b.return=a,b;b=e(b,c,d);b.return=a;return b}function p(a,b,c){if("string"===typeof b||"number"===typeof b)return b=af(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case Vb:return c=Ye(b.type,b.key,b.props,null,a.mode,c),c.ref=Af(a,null,b),c.return=a,c;case Wb:return b=bf(b,a.mode,c),b.return=a,b}if(zf(b)||
	hc(b))return b=Ze(b,a.mode,c,null),b.return=a,b;Bf(a,b)}return null}function t(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case Vb:return c.key===e?c.type===Xb?m(a,b,c.props.children,d,e):l(a,b,c,d):null;case Wb:return c.key===e?k(a,b,c,d):null}if(zf(c)||hc(c))return null!==e?null:m(a,b,c,d,null);Bf(a,c)}return null}function A(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=
	a.get(c)||null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case Vb:return a=a.get(null===d.key?c:d.key)||null,d.type===Xb?m(b,a,d.props.children,e,d.key):l(b,a,d,e);case Wb:return a=a.get(null===d.key?c:d.key)||null,k(b,a,d,e)}if(zf(d)||hc(d))return a=a.get(c)||null,m(b,a,d,e,null);Bf(b,d)}return null}function v(e,g,h,k){for(var l=null,m=null,q=g,u=g=0,B=null;null!==q&&u<h.length;u++){q.index>u?(B=q,q=null):B=q.sibling;var w=t(e,q,h[u],k);if(null===w){null===q&&(q=B);break}a&&
	q&&null===w.alternate&&b(e,q);g=f(w,g,u);null===m?l=w:m.sibling=w;m=w;q=B}if(u===h.length)return c(e,q),l;if(null===q){for(;u<h.length;u++)if(q=p(e,h[u],k))g=f(q,g,u),null===m?l=q:m.sibling=q,m=q;return l}for(q=d(e,q);u<h.length;u++)if(B=A(q,e,u,h[u],k))a&&null!==B.alternate&&q.delete(null===B.key?u:B.key),g=f(B,g,u),null===m?l=B:m.sibling=B,m=B;a&&q.forEach(function(a){return b(e,a)});return l}function R(e,g,h,k){var l=hc(h);"function"!==typeof l?x("150"):void 0;h=l.call(h);null==h?x("151"):void 0;
	for(var m=l=null,q=g,u=g=0,B=null,w=h.next();null!==q&&!w.done;u++,w=h.next()){q.index>u?(B=q,q=null):B=q.sibling;var v=t(e,q,w.value,k);if(null===v){q||(q=B);break}a&&q&&null===v.alternate&&b(e,q);g=f(v,g,u);null===m?l=v:m.sibling=v;m=v;q=B}if(w.done)return c(e,q),l;if(null===q){for(;!w.done;u++,w=h.next())w=p(e,w.value,k),null!==w&&(g=f(w,g,u),null===m?l=w:m.sibling=w,m=w);return l}for(q=d(e,q);!w.done;u++,w=h.next())w=A(q,e,u,w.value,k),null!==w&&(a&&null!==w.alternate&&q.delete(null===w.key?u:
	w.key),g=f(w,g,u),null===m?l=w:m.sibling=w,m=w);a&&q.forEach(function(a){return b(e,a)});return l}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===Xb&&null===f.key;k&&(f=f.props.children);var l="object"===typeof f&&null!==f;if(l)switch(f.$$typeof){case Vb:a:{l=f.key;for(k=d;null!==k;){if(k.key===l)if(7===k.tag?f.type===Xb:k.elementType===f.type){c(a,k.sibling);d=e(k,f.type===Xb?f.props.children:f.props,h);d.ref=Af(a,k,f);d.return=a;a=d;break a}else{c(a,k);break}else b(a,k);k=
	k.sibling}f.type===Xb?(d=Ze(f.props.children,a.mode,h,f.key),d.return=a,a=d):(h=Ye(f.type,f.key,f.props,null,a.mode,h),h.ref=Af(a,d,f),h.return=a,a=h)}return g(a);case Wb:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[],h);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=d.sibling}d=bf(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=
	""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f,h),d.return=a,a=d):(c(a,d),d=af(f,a.mode,h),d.return=a,a=d),g(a);if(zf(f))return v(a,d,f,h);if(hc(f))return R(a,d,f,h);l&&Bf(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 1:case 0:h=a.type,x("152",h.displayName||h.name||"Component")}return c(a,d)}}var Df=Cf(!0),Ef=Cf(!1),Ff={},N={current:Ff},Gf={current:Ff},Hf={current:Ff};function If(a){a===Ff?x("174"):void 0;return a}
	function Jf(a,b){G(Hf,b,a);G(Gf,a,a);G(N,Ff,a);var c=b.nodeType;switch(c){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:he(null,"");break;default:c=8===c?b.parentNode:b,b=c.namespaceURI||null,c=c.tagName,b=he(b,c)}F(N,a);G(N,b,a)}function Kf(a){F(N,a);F(Gf,a);F(Hf,a)}function Lf(a){If(Hf.current);var b=If(N.current);var c=he(b,a.type);b!==c&&(G(Gf,a,a),G(N,c,a))}function Mf(a){Gf.current===a&&(F(N,a),F(Gf,a))}
	var Nf=0,Of=2,Pf=4,Qf=8,Rf=16,Sf=32,Tf=64,Uf=128,Vf=Tb.ReactCurrentDispatcher,Wf=0,Xf=null,O=null,P=null,Yf=null,Q=null,Zf=null,$f=0,ag=null,bg=0,cg=!1,dg=null,eg=0;function fg(){x("321")}function gg(a,b){if(null===b)return!1;for(var c=0;c<b.length&&c<a.length;c++)if(!bd(a[c],b[c]))return!1;return!0}
	function hg(a,b,c,d,e,f){Wf=f;Xf=b;P=null!==a?a.memoizedState:null;Vf.current=null===P?ig:jg;b=c(d,e);if(cg){do cg=!1,eg+=1,P=null!==a?a.memoizedState:null,Zf=Yf,ag=Q=O=null,Vf.current=jg,b=c(d,e);while(cg);dg=null;eg=0}Vf.current=kg;a=Xf;a.memoizedState=Yf;a.expirationTime=$f;a.updateQueue=ag;a.effectTag|=bg;a=null!==O&&null!==O.next;Wf=0;Zf=Q=Yf=P=O=Xf=null;$f=0;ag=null;bg=0;a?x("300"):void 0;return b}function lg(){Vf.current=kg;Wf=0;Zf=Q=Yf=P=O=Xf=null;$f=0;ag=null;bg=0;cg=!1;dg=null;eg=0}
	function mg(){var a={memoizedState:null,baseState:null,queue:null,baseUpdate:null,next:null};null===Q?Yf=Q=a:Q=Q.next=a;return Q}function ng(){if(null!==Zf)Q=Zf,Zf=Q.next,O=P,P=null!==O?O.next:null;else{null===P?x("310"):void 0;O=P;var a={memoizedState:O.memoizedState,baseState:O.baseState,queue:O.queue,baseUpdate:O.baseUpdate,next:null};Q=null===Q?Yf=a:Q.next=a;P=O.next}return Q}function og(a,b){return"function"===typeof b?b(a):b}
	function pg(a){var b=ng(),c=b.queue;null===c?x("311"):void 0;c.lastRenderedReducer=a;if(0<eg){var d=c.dispatch;if(null!==dg){var e=dg.get(c);if(void 0!==e){dg.delete(c);var f=b.memoizedState;do f=a(f,e.action),e=e.next;while(null!==e);bd(f,b.memoizedState)||(qg=!0);b.memoizedState=f;b.baseUpdate===c.last&&(b.baseState=f);c.lastRenderedState=f;return[f,d]}}return[b.memoizedState,d]}d=c.last;var g=b.baseUpdate;f=b.baseState;null!==g?(null!==d&&(d.next=null),d=g.next):d=null!==d?d.next:null;if(null!==
	d){var h=e=null,l=d,k=!1;do{var m=l.expirationTime;m<Wf?(k||(k=!0,h=g,e=f),m>$f&&($f=m)):f=l.eagerReducer===a?l.eagerState:a(f,l.action);g=l;l=l.next}while(null!==l&&l!==d);k||(h=g,e=f);bd(f,b.memoizedState)||(qg=!0);b.memoizedState=f;b.baseUpdate=h;b.baseState=e;c.lastRenderedState=f}return[b.memoizedState,c.dispatch]}
	function rg(a,b,c,d){a={tag:a,create:b,destroy:c,deps:d,next:null};null===ag?(ag={lastEffect:null},ag.lastEffect=a.next=a):(b=ag.lastEffect,null===b?ag.lastEffect=a.next=a:(c=b.next,b.next=a,a.next=c,ag.lastEffect=a));return a}function sg(a,b,c,d){var e=mg();bg|=a;e.memoizedState=rg(b,c,void 0,void 0===d?null:d)}
	function tg(a,b,c,d){var e=ng();d=void 0===d?null:d;var f=void 0;if(null!==O){var g=O.memoizedState;f=g.destroy;if(null!==d&&gg(d,g.deps)){rg(Nf,c,f,d);return}}bg|=a;e.memoizedState=rg(b,c,f,d)}function ug(a,b){if("function"===typeof b)return a=a(),b(a),function(){b(null)};if(null!==b&&void 0!==b)return a=a(),b.current=a,function(){b.current=null}}function vg(){}
	function wg(a,b,c){25>eg?void 0:x("301");var d=a.alternate;if(a===Xf||null!==d&&d===Xf)if(cg=!0,a={expirationTime:Wf,action:c,eagerReducer:null,eagerState:null,next:null},null===dg&&(dg=new Map),c=dg.get(b),void 0===c)dg.set(b,a);else{for(b=c;null!==b.next;)b=b.next;b.next=a}else{of();var e=lf();e=mf(e,a);var f={expirationTime:e,action:c,eagerReducer:null,eagerState:null,next:null},g=b.last;if(null===g)f.next=f;else{var h=g.next;null!==h&&(f.next=h);g.next=f}b.last=f;if(0===a.expirationTime&&(null===
	d||0===d.expirationTime)&&(d=b.lastRenderedReducer,null!==d))try{var l=b.lastRenderedState,k=d(l,c);f.eagerReducer=d;f.eagerState=k;if(bd(k,l))return}catch(m){}finally{}qf(a,e)}}
	var kg={readContext:M,useCallback:fg,useContext:fg,useEffect:fg,useImperativeHandle:fg,useLayoutEffect:fg,useMemo:fg,useReducer:fg,useRef:fg,useState:fg,useDebugValue:fg},ig={readContext:M,useCallback:function(a,b){mg().memoizedState=[a,void 0===b?null:b];return a},useContext:M,useEffect:function(a,b){return sg(516,Uf|Tf,a,b)},useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return sg(4,Pf|Sf,ug.bind(null,b,a),c)},useLayoutEffect:function(a,b){return sg(4,Pf|Sf,a,b)},
	useMemo:function(a,b){var c=mg();b=void 0===b?null:b;a=a();c.memoizedState=[a,b];return a},useReducer:function(a,b,c){var d=mg();b=void 0!==c?c(b):b;d.memoizedState=d.baseState=b;a=d.queue={last:null,dispatch:null,lastRenderedReducer:a,lastRenderedState:b};a=a.dispatch=wg.bind(null,Xf,a);return[d.memoizedState,a]},useRef:function(a){var b=mg();a={current:a};return b.memoizedState=a},useState:function(a){var b=mg();"function"===typeof a&&(a=a());b.memoizedState=b.baseState=a;a=b.queue={last:null,dispatch:null,
	lastRenderedReducer:og,lastRenderedState:a};a=a.dispatch=wg.bind(null,Xf,a);return[b.memoizedState,a]},useDebugValue:vg},jg={readContext:M,useCallback:function(a,b){var c=ng();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&gg(b,d[1]))return d[0];c.memoizedState=[a,b];return a},useContext:M,useEffect:function(a,b){return tg(516,Uf|Tf,a,b)},useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return tg(4,Pf|Sf,ug.bind(null,b,a),c)},useLayoutEffect:function(a,
	b){return tg(4,Pf|Sf,a,b)},useMemo:function(a,b){var c=ng();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&gg(b,d[1]))return d[0];a=a();c.memoizedState=[a,b];return a},useReducer:pg,useRef:function(){return ng().memoizedState},useState:function(a){return pg(og,a)},useDebugValue:vg},xg=null,yg=null,zg=!1;
	function Ag(a,b){var c=K(5,null,null,0);c.elementType="DELETED";c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}function Bg(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;case 13:return!1;default:return!1}}
	function Cg(a){if(zg){var b=yg;if(b){var c=b;if(!Bg(a,b)){b=De(c);if(!b||!Bg(a,b)){a.effectTag|=2;zg=!1;xg=a;return}Ag(xg,c)}xg=a;yg=Ee(b)}else a.effectTag|=2,zg=!1,xg=a}}function Dg(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag&&18!==a.tag;)a=a.return;xg=a}function Eg(a){if(a!==xg)return!1;if(!zg)return Dg(a),zg=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!xe(b,a.memoizedProps))for(b=yg;b;)Ag(a,b),b=De(b);Dg(a);yg=xg?De(a.stateNode):null;return!0}function Fg(){yg=xg=null;zg=!1}
	var Gg=Tb.ReactCurrentOwner,qg=!1;function S(a,b,c,d){b.child=null===a?Ef(b,null,c,d):Df(b,a.child,c,d)}function Hg(a,b,c,d,e){c=c.render;var f=b.ref;Ig(b,e);d=hg(a,b,c,d,f,e);if(null!==a&&!qg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),Jg(a,b,e);b.effectTag|=1;S(a,b,d,e);return b.child}
	function Kg(a,b,c,d,e,f){if(null===a){var g=c.type;if("function"===typeof g&&!Ve(g)&&void 0===g.defaultProps&&null===c.compare&&void 0===c.defaultProps)return b.tag=15,b.type=g,Lg(a,b,g,d,e,f);a=Ye(c.type,null,d,null,b.mode,f);a.ref=b.ref;a.return=b;return b.child=a}g=a.child;if(e<f&&(e=g.memoizedProps,c=c.compare,c=null!==c?c:dd,c(e,d)&&a.ref===b.ref))return Jg(a,b,f);b.effectTag|=1;a=Xe(g,d,f);a.ref=b.ref;a.return=b;return b.child=a}
	function Lg(a,b,c,d,e,f){return null!==a&&dd(a.memoizedProps,d)&&a.ref===b.ref&&(qg=!1,e<f)?Jg(a,b,f):Mg(a,b,c,d,f)}function Ng(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function Mg(a,b,c,d,e){var f=J(c)?Ie:H.current;f=Je(b,f);Ig(b,e);c=hg(a,b,c,d,f,e);if(null!==a&&!qg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),Jg(a,b,e);b.effectTag|=1;S(a,b,c,e);return b.child}
	function Og(a,b,c,d,e){if(J(c)){var f=!0;Oe(b)}else f=!1;Ig(b,e);if(null===b.stateNode)null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),vf(b,c,d,e),xf(b,c,d,e),d=!0;else if(null===a){var g=b.stateNode,h=b.memoizedProps;g.props=h;var l=g.context,k=c.contextType;"object"===typeof k&&null!==k?k=M(k):(k=J(c)?Ie:H.current,k=Je(b,k));var m=c.getDerivedStateFromProps,p="function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate;p||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&
	"function"!==typeof g.componentWillReceiveProps||(h!==d||l!==k)&&wf(b,g,d,k);Pg=!1;var t=b.memoizedState;l=g.state=t;var A=b.updateQueue;null!==A&&(yf(b,A,d,g,e),l=b.memoizedState);h!==d||t!==l||I.current||Pg?("function"===typeof m&&(kf(b,c,m,d),l=b.memoizedState),(h=Pg||uf(b,c,h,d,t,l,k))?(p||"function"!==typeof g.UNSAFE_componentWillMount&&"function"!==typeof g.componentWillMount||("function"===typeof g.componentWillMount&&g.componentWillMount(),"function"===typeof g.UNSAFE_componentWillMount&&
	g.UNSAFE_componentWillMount()),"function"===typeof g.componentDidMount&&(b.effectTag|=4)):("function"===typeof g.componentDidMount&&(b.effectTag|=4),b.memoizedProps=d,b.memoizedState=l),g.props=d,g.state=l,g.context=k,d=h):("function"===typeof g.componentDidMount&&(b.effectTag|=4),d=!1)}else g=b.stateNode,h=b.memoizedProps,g.props=b.type===b.elementType?h:L(b.type,h),l=g.context,k=c.contextType,"object"===typeof k&&null!==k?k=M(k):(k=J(c)?Ie:H.current,k=Je(b,k)),m=c.getDerivedStateFromProps,(p="function"===
	typeof m||"function"===typeof g.getSnapshotBeforeUpdate)||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&"function"!==typeof g.componentWillReceiveProps||(h!==d||l!==k)&&wf(b,g,d,k),Pg=!1,l=b.memoizedState,t=g.state=l,A=b.updateQueue,null!==A&&(yf(b,A,d,g,e),t=b.memoizedState),h!==d||l!==t||I.current||Pg?("function"===typeof m&&(kf(b,c,m,d),t=b.memoizedState),(m=Pg||uf(b,c,h,d,l,t,k))?(p||"function"!==typeof g.UNSAFE_componentWillUpdate&&"function"!==typeof g.componentWillUpdate||("function"===
	typeof g.componentWillUpdate&&g.componentWillUpdate(d,t,k),"function"===typeof g.UNSAFE_componentWillUpdate&&g.UNSAFE_componentWillUpdate(d,t,k)),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4),"function"===typeof g.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&l===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&l===a.memoizedState||(b.effectTag|=256),b.memoizedProps=d,b.memoizedState=
	t),g.props=d,g.state=t,g.context=k,d=m):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&l===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&l===a.memoizedState||(b.effectTag|=256),d=!1);return Qg(a,b,c,d,f,e)}
	function Qg(a,b,c,d,e,f){Ng(a,b);var g=0!==(b.effectTag&64);if(!d&&!g)return e&&Pe(b,c,!1),Jg(a,b,f);d=b.stateNode;Gg.current=b;var h=g&&"function"!==typeof c.getDerivedStateFromError?null:d.render();b.effectTag|=1;null!==a&&g?(b.child=Df(b,a.child,null,f),b.child=Df(b,null,h,f)):S(a,b,h,f);b.memoizedState=d.state;e&&Pe(b,c,!0);return b.child}function Rg(a){var b=a.stateNode;b.pendingContext?Me(a,b.pendingContext,b.pendingContext!==b.context):b.context&&Me(a,b.context,!1);Jf(a,b.containerInfo)}
	function Sg(a,b,c){var d=b.mode,e=b.pendingProps,f=b.memoizedState;if(0===(b.effectTag&64)){f=null;var g=!1}else f={timedOutAt:null!==f?f.timedOutAt:0},g=!0,b.effectTag&=-65;if(null===a)if(g){var h=e.fallback;a=Ze(null,d,0,null);0===(b.mode&1)&&(a.child=null!==b.memoizedState?b.child.child:b.child);d=Ze(h,d,c,null);a.sibling=d;c=a;c.return=d.return=b}else c=d=Ef(b,null,e.children,c);else null!==a.memoizedState?(d=a.child,h=d.sibling,g?(c=e.fallback,e=Xe(d,d.pendingProps,0),0===(b.mode&1)&&(g=null!==
	b.memoizedState?b.child.child:b.child,g!==d.child&&(e.child=g)),d=e.sibling=Xe(h,c,h.expirationTime),c=e,e.childExpirationTime=0,c.return=d.return=b):c=d=Df(b,d.child,e.children,c)):(h=a.child,g?(g=e.fallback,e=Ze(null,d,0,null),e.child=h,0===(b.mode&1)&&(e.child=null!==b.memoizedState?b.child.child:b.child),d=e.sibling=Ze(g,d,c,null),d.effectTag|=2,c=e,e.childExpirationTime=0,c.return=d.return=b):d=c=Df(b,h,e.children,c)),b.stateNode=a.stateNode;b.memoizedState=f;b.child=c;return d}
	function Jg(a,b,c){null!==a&&(b.contextDependencies=a.contextDependencies);if(b.childExpirationTime<c)return null;null!==a&&b.child!==a.child?x("153"):void 0;if(null!==b.child){a=b.child;c=Xe(a,a.pendingProps,a.expirationTime);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=Xe(a,a.pendingProps,a.expirationTime),c.return=b;c.sibling=null}return b.child}
	function Tg(a,b,c){var d=b.expirationTime;if(null!==a)if(a.memoizedProps!==b.pendingProps||I.current)qg=!0;else{if(d<c){qg=!1;switch(b.tag){case 3:Rg(b);Fg();break;case 5:Lf(b);break;case 1:J(b.type)&&Oe(b);break;case 4:Jf(b,b.stateNode.containerInfo);break;case 10:Ug(b,b.memoizedProps.value);break;case 13:if(null!==b.memoizedState){d=b.child.childExpirationTime;if(0!==d&&d>=c)return Sg(a,b,c);b=Jg(a,b,c);return null!==b?b.sibling:null}}return Jg(a,b,c)}}else qg=!1;b.expirationTime=0;switch(b.tag){case 2:d=
	b.elementType;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;var e=Je(b,H.current);Ig(b,c);e=hg(null,b,d,a,e,c);b.effectTag|=1;if("object"===typeof e&&null!==e&&"function"===typeof e.render&&void 0===e.$$typeof){b.tag=1;lg();if(J(d)){var f=!0;Oe(b)}else f=!1;b.memoizedState=null!==e.state&&void 0!==e.state?e.state:null;var g=d.getDerivedStateFromProps;"function"===typeof g&&kf(b,d,g,a);e.updater=tf;b.stateNode=e;e._reactInternalFiber=b;xf(b,d,a,c);b=Qg(null,b,d,!0,f,
	c)}else b.tag=0,S(null,b,e,c),b=b.child;return b;case 16:e=b.elementType;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);f=b.pendingProps;a=hf(e);b.type=a;e=b.tag=We(a);f=L(a,f);g=void 0;switch(e){case 0:g=Mg(null,b,a,f,c);break;case 1:g=Og(null,b,a,f,c);break;case 11:g=Hg(null,b,a,f,c);break;case 14:g=Kg(null,b,a,L(a.type,f),d,c);break;default:x("306",a,"")}return g;case 0:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:L(d,e),Mg(a,b,d,e,c);case 1:return d=b.type,e=b.pendingProps,
	e=b.elementType===d?e:L(d,e),Og(a,b,d,e,c);case 3:Rg(b);d=b.updateQueue;null===d?x("282"):void 0;e=b.memoizedState;e=null!==e?e.element:null;yf(b,d,b.pendingProps,null,c);d=b.memoizedState.element;if(d===e)Fg(),b=Jg(a,b,c);else{e=b.stateNode;if(e=(null===a||null===a.child)&&e.hydrate)yg=Ee(b.stateNode.containerInfo),xg=b,e=zg=!0;e?(b.effectTag|=2,b.child=Ef(b,null,d,c)):(S(a,b,d,c),Fg());b=b.child}return b;case 5:return Lf(b),null===a&&Cg(b),d=b.type,e=b.pendingProps,f=null!==a?a.memoizedProps:null,
	g=e.children,xe(d,e)?g=null:null!==f&&xe(d,f)&&(b.effectTag|=16),Ng(a,b),1!==c&&b.mode&1&&e.hidden?(b.expirationTime=b.childExpirationTime=1,b=null):(S(a,b,g,c),b=b.child),b;case 6:return null===a&&Cg(b),null;case 13:return Sg(a,b,c);case 4:return Jf(b,b.stateNode.containerInfo),d=b.pendingProps,null===a?b.child=Df(b,null,d,c):S(a,b,d,c),b.child;case 11:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:L(d,e),Hg(a,b,d,e,c);case 7:return S(a,b,b.pendingProps,c),b.child;case 8:return S(a,b,b.pendingProps.children,
	c),b.child;case 12:return S(a,b,b.pendingProps.children,c),b.child;case 10:a:{d=b.type._context;e=b.pendingProps;g=b.memoizedProps;f=e.value;Ug(b,f);if(null!==g){var h=g.value;f=bd(h,f)?0:("function"===typeof d._calculateChangedBits?d._calculateChangedBits(h,f):1073741823)|0;if(0===f){if(g.children===e.children&&!I.current){b=Jg(a,b,c);break a}}else for(h=b.child,null!==h&&(h.return=b);null!==h;){var l=h.contextDependencies;if(null!==l){g=h.child;for(var k=l.first;null!==k;){if(k.context===d&&0!==
	(k.observedBits&f)){1===h.tag&&(k=nf(c),k.tag=sf,pf(h,k));h.expirationTime<c&&(h.expirationTime=c);k=h.alternate;null!==k&&k.expirationTime<c&&(k.expirationTime=c);k=c;for(var m=h.return;null!==m;){var p=m.alternate;if(m.childExpirationTime<k)m.childExpirationTime=k,null!==p&&p.childExpirationTime<k&&(p.childExpirationTime=k);else if(null!==p&&p.childExpirationTime<k)p.childExpirationTime=k;else break;m=m.return}l.expirationTime<c&&(l.expirationTime=c);break}k=k.next}}else g=10===h.tag?h.type===b.type?
	null:h.child:h.child;if(null!==g)g.return=h;else for(g=h;null!==g;){if(g===b){g=null;break}h=g.sibling;if(null!==h){h.return=g.return;g=h;break}g=g.return}h=g}}S(a,b,e.children,c);b=b.child}return b;case 9:return e=b.type,f=b.pendingProps,d=f.children,Ig(b,c),e=M(e,f.unstable_observedBits),d=d(e),b.effectTag|=1,S(a,b,d,c),b.child;case 14:return e=b.type,f=L(e,b.pendingProps),f=L(e.type,f),Kg(a,b,e,f,d,c);case 15:return Lg(a,b,b.type,b.pendingProps,d,c);case 17:return d=b.type,e=b.pendingProps,e=b.elementType===
	d?e:L(d,e),null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),b.tag=1,J(d)?(a=!0,Oe(b)):a=!1,Ig(b,c),vf(b,d,e,c),xf(b,d,e,c),Qg(null,b,d,!0,a,c)}x("156")}var Vg={current:null},Wg=null,Xg=null,Yg=null;function Ug(a,b){var c=a.type._context;G(Vg,c._currentValue,a);c._currentValue=b}function Zg(a){var b=Vg.current;F(Vg,a);a.type._context._currentValue=b}function Ig(a,b){Wg=a;Yg=Xg=null;var c=a.contextDependencies;null!==c&&c.expirationTime>=b&&(qg=!0);a.contextDependencies=null}
	function M(a,b){if(Yg!==a&&!1!==b&&0!==b){if("number"!==typeof b||1073741823===b)Yg=a,b=1073741823;b={context:a,observedBits:b,next:null};null===Xg?(null===Wg?x("308"):void 0,Xg=b,Wg.contextDependencies={first:b,expirationTime:0}):Xg=Xg.next=b}return a._currentValue}var $g=0,rf=1,sf=2,ah=3,Pg=!1;function bh(a){return{baseState:a,firstUpdate:null,lastUpdate:null,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}
	function ch(a){return{baseState:a.baseState,firstUpdate:a.firstUpdate,lastUpdate:a.lastUpdate,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}function nf(a){return{expirationTime:a,tag:$g,payload:null,callback:null,next:null,nextEffect:null}}function dh(a,b){null===a.lastUpdate?a.firstUpdate=a.lastUpdate=b:(a.lastUpdate.next=b,a.lastUpdate=b)}
	function pf(a,b){var c=a.alternate;if(null===c){var d=a.updateQueue;var e=null;null===d&&(d=a.updateQueue=bh(a.memoizedState))}else d=a.updateQueue,e=c.updateQueue,null===d?null===e?(d=a.updateQueue=bh(a.memoizedState),e=c.updateQueue=bh(c.memoizedState)):d=a.updateQueue=ch(e):null===e&&(e=c.updateQueue=ch(d));null===e||d===e?dh(d,b):null===d.lastUpdate||null===e.lastUpdate?(dh(d,b),dh(e,b)):(dh(d,b),e.lastUpdate=b)}
	function eh(a,b){var c=a.updateQueue;c=null===c?a.updateQueue=bh(a.memoizedState):fh(a,c);null===c.lastCapturedUpdate?c.firstCapturedUpdate=c.lastCapturedUpdate=b:(c.lastCapturedUpdate.next=b,c.lastCapturedUpdate=b)}function fh(a,b){var c=a.alternate;null!==c&&b===c.updateQueue&&(b=a.updateQueue=ch(b));return b}
	function gh(a,b,c,d,e,f){switch(c.tag){case rf:return a=c.payload,"function"===typeof a?a.call(f,d,e):a;case ah:a.effectTag=a.effectTag&-2049|64;case $g:a=c.payload;e="function"===typeof a?a.call(f,d,e):a;if(null===e||void 0===e)break;return n({},d,e);case sf:Pg=!0}return d}
	function yf(a,b,c,d,e){Pg=!1;b=fh(a,b);for(var f=b.baseState,g=null,h=0,l=b.firstUpdate,k=f;null!==l;){var m=l.expirationTime;m<e?(null===g&&(g=l,f=k),h<m&&(h=m)):(k=gh(a,b,l,k,c,d),null!==l.callback&&(a.effectTag|=32,l.nextEffect=null,null===b.lastEffect?b.firstEffect=b.lastEffect=l:(b.lastEffect.nextEffect=l,b.lastEffect=l)));l=l.next}m=null;for(l=b.firstCapturedUpdate;null!==l;){var p=l.expirationTime;p<e?(null===m&&(m=l,null===g&&(f=k)),h<p&&(h=p)):(k=gh(a,b,l,k,c,d),null!==l.callback&&(a.effectTag|=
	32,l.nextEffect=null,null===b.lastCapturedEffect?b.firstCapturedEffect=b.lastCapturedEffect=l:(b.lastCapturedEffect.nextEffect=l,b.lastCapturedEffect=l)));l=l.next}null===g&&(b.lastUpdate=null);null===m?b.lastCapturedUpdate=null:a.effectTag|=32;null===g&&null===m&&(f=k);b.baseState=f;b.firstUpdate=g;b.firstCapturedUpdate=m;a.expirationTime=h;a.memoizedState=k}
	function hh(a,b,c){null!==b.firstCapturedUpdate&&(null!==b.lastUpdate&&(b.lastUpdate.next=b.firstCapturedUpdate,b.lastUpdate=b.lastCapturedUpdate),b.firstCapturedUpdate=b.lastCapturedUpdate=null);ih(b.firstEffect,c);b.firstEffect=b.lastEffect=null;ih(b.firstCapturedEffect,c);b.firstCapturedEffect=b.lastCapturedEffect=null}function ih(a,b){for(;null!==a;){var c=a.callback;if(null!==c){a.callback=null;var d=b;"function"!==typeof c?x("191",c):void 0;c.call(d)}a=a.nextEffect}}
	function jh(a,b){return{value:a,source:b,stack:jc(b)}}function kh(a){a.effectTag|=4}var lh=void 0,mh=void 0,nh=void 0,oh=void 0;lh=function(a,b){for(var c=b.child;null!==c;){if(5===c.tag||6===c.tag)a.appendChild(c.stateNode);else if(4!==c.tag&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return}c.sibling.return=c.return;c=c.sibling}};mh=function(){};
	nh=function(a,b,c,d,e){var f=a.memoizedProps;if(f!==d){var g=b.stateNode;If(N.current);a=null;switch(c){case "input":f=vc(g,f);d=vc(g,d);a=[];break;case "option":f=$d(g,f);d=$d(g,d);a=[];break;case "select":f=n({},f,{value:void 0});d=n({},d,{value:void 0});a=[];break;case "textarea":f=be(g,f);d=be(g,d);a=[];break;default:"function"!==typeof f.onClick&&"function"===typeof d.onClick&&(g.onclick=te)}qe(c,d);g=c=void 0;var h=null;for(c in f)if(!d.hasOwnProperty(c)&&f.hasOwnProperty(c)&&null!=f[c])if("style"===
	c){var l=f[c];for(g in l)l.hasOwnProperty(g)&&(h||(h={}),h[g]="")}else"dangerouslySetInnerHTML"!==c&&"children"!==c&&"suppressContentEditableWarning"!==c&&"suppressHydrationWarning"!==c&&"autoFocus"!==c&&(ra.hasOwnProperty(c)?a||(a=[]):(a=a||[]).push(c,null));for(c in d){var k=d[c];l=null!=f?f[c]:void 0;if(d.hasOwnProperty(c)&&k!==l&&(null!=k||null!=l))if("style"===c)if(l){for(g in l)!l.hasOwnProperty(g)||k&&k.hasOwnProperty(g)||(h||(h={}),h[g]="");for(g in k)k.hasOwnProperty(g)&&l[g]!==k[g]&&(h||
	(h={}),h[g]=k[g])}else h||(a||(a=[]),a.push(c,h)),h=k;else"dangerouslySetInnerHTML"===c?(k=k?k.__html:void 0,l=l?l.__html:void 0,null!=k&&l!==k&&(a=a||[]).push(c,""+k)):"children"===c?l===k||"string"!==typeof k&&"number"!==typeof k||(a=a||[]).push(c,""+k):"suppressContentEditableWarning"!==c&&"suppressHydrationWarning"!==c&&(ra.hasOwnProperty(c)?(null!=k&&se(e,c),a||l===k||(a=[])):(a=a||[]).push(c,k))}h&&(a=a||[]).push("style",h);e=a;(b.updateQueue=e)&&kh(b)}};oh=function(a,b,c,d){c!==d&&kh(b)};
	var ph="function"===typeof WeakSet?WeakSet:Set;function qh(a,b){var c=b.source,d=b.stack;null===d&&null!==c&&(d=jc(c));null!==c&&ic(c.type);b=b.value;null!==a&&1===a.tag&&ic(a.type);try{console.error(b)}catch(e){setTimeout(function(){throw e;})}}function rh(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){sh(a,c)}else b.current=null}
	function th(a,b,c){c=c.updateQueue;c=null!==c?c.lastEffect:null;if(null!==c){var d=c=c.next;do{if((d.tag&a)!==Nf){var e=d.destroy;d.destroy=void 0;void 0!==e&&e()}(d.tag&b)!==Nf&&(e=d.create,d.destroy=e());d=d.next}while(d!==c)}}
	function uh(a,b){for(var c=a;;){if(5===c.tag){var d=c.stateNode;if(b)d.style.display="none";else{d=c.stateNode;var e=c.memoizedProps.style;e=void 0!==e&&null!==e&&e.hasOwnProperty("display")?e.display:null;d.style.display=ne("display",e)}}else if(6===c.tag)c.stateNode.nodeValue=b?"":c.memoizedProps;else if(13===c.tag&&null!==c.memoizedState){d=c.child.sibling;d.return=c;c=d;continue}else if(null!==c.child){c.child.return=c;c=c.child;continue}if(c===a)break;for(;null===c.sibling;){if(null===c.return||
	c.return===a)return;c=c.return}c.sibling.return=c.return;c=c.sibling}}
	function vh(a){"function"===typeof Re&&Re(a);switch(a.tag){case 0:case 11:case 14:case 15:var b=a.updateQueue;if(null!==b&&(b=b.lastEffect,null!==b)){var c=b=b.next;do{var d=c.destroy;if(void 0!==d){var e=a;try{d()}catch(f){sh(e,f)}}c=c.next}while(c!==b)}break;case 1:rh(a);b=a.stateNode;if("function"===typeof b.componentWillUnmount)try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(f){sh(a,f)}break;case 5:rh(a);break;case 4:wh(a)}}
	function xh(a){return 5===a.tag||3===a.tag||4===a.tag}
	function yh(a){a:{for(var b=a.return;null!==b;){if(xh(b)){var c=b;break a}b=b.return}x("160");c=void 0}var d=b=void 0;switch(c.tag){case 5:b=c.stateNode;d=!1;break;case 3:b=c.stateNode.containerInfo;d=!0;break;case 4:b=c.stateNode.containerInfo;d=!0;break;default:x("161")}c.effectTag&16&&(ke(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||xh(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag&&18!==c.tag;){if(c.effectTag&
	2)continue b;if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}for(var e=a;;){if(5===e.tag||6===e.tag)if(c)if(d){var f=b,g=e.stateNode,h=c;8===f.nodeType?f.parentNode.insertBefore(g,h):f.insertBefore(g,h)}else b.insertBefore(e.stateNode,c);else d?(g=b,h=e.stateNode,8===g.nodeType?(f=g.parentNode,f.insertBefore(h,g)):(f=g,f.appendChild(h)),g=g._reactRootContainer,null!==g&&void 0!==g||null!==f.onclick||(f.onclick=te)):b.appendChild(e.stateNode);
	else if(4!==e.tag&&null!==e.child){e.child.return=e;e=e.child;continue}if(e===a)break;for(;null===e.sibling;){if(null===e.return||e.return===a)return;e=e.return}e.sibling.return=e.return;e=e.sibling}}
	function wh(a){for(var b=a,c=!1,d=void 0,e=void 0;;){if(!c){c=b.return;a:for(;;){null===c?x("160"):void 0;switch(c.tag){case 5:d=c.stateNode;e=!1;break a;case 3:d=c.stateNode.containerInfo;e=!0;break a;case 4:d=c.stateNode.containerInfo;e=!0;break a}c=c.return}c=!0}if(5===b.tag||6===b.tag){a:for(var f=b,g=f;;)if(vh(g),null!==g.child&&4!==g.tag)g.child.return=g,g=g.child;else{if(g===f)break;for(;null===g.sibling;){if(null===g.return||g.return===f)break a;g=g.return}g.sibling.return=g.return;g=g.sibling}e?
	(f=d,g=b.stateNode,8===f.nodeType?f.parentNode.removeChild(g):f.removeChild(g)):d.removeChild(b.stateNode)}else if(4===b.tag){if(null!==b.child){d=b.stateNode.containerInfo;e=!0;b.child.return=b;b=b.child;continue}}else if(vh(b),null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return;b=b.return;4===b.tag&&(c=!1)}b.sibling.return=b.return;b=b.sibling}}
	function zh(a,b){switch(b.tag){case 0:case 11:case 14:case 15:th(Pf,Qf,b);break;case 1:break;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps;a=null!==a?a.memoizedProps:d;var e=b.type,f=b.updateQueue;b.updateQueue=null;null!==f&&Ce(c,f,e,a,d,b)}break;case 6:null===b.stateNode?x("162"):void 0;b.stateNode.nodeValue=b.memoizedProps;break;case 3:break;case 12:break;case 13:c=b.memoizedState;d=void 0;a=b;null===c?d=!1:(d=!0,a=b.child,0===c.timedOutAt&&(c.timedOutAt=lf()));null!==a&&uh(a,d);c=
	b.updateQueue;if(null!==c){b.updateQueue=null;var g=b.stateNode;null===g&&(g=b.stateNode=new ph);c.forEach(function(a){var c=Ah.bind(null,b,a);g.has(a)||(g.add(a),a.then(c,c))})}break;case 17:break;default:x("163")}}var Bh="function"===typeof WeakMap?WeakMap:Map;function Ch(a,b,c){c=nf(c);c.tag=ah;c.payload={element:null};var d=b.value;c.callback=function(){Dh(d);qh(a,b)};return c}
	function Eh(a,b,c){c=nf(c);c.tag=ah;var d=a.type.getDerivedStateFromError;if("function"===typeof d){var e=b.value;c.payload=function(){return d(e)}}var f=a.stateNode;null!==f&&"function"===typeof f.componentDidCatch&&(c.callback=function(){"function"!==typeof d&&(null===Fh?Fh=new Set([this]):Fh.add(this));var c=b.value,e=b.stack;qh(a,b);this.componentDidCatch(c,{componentStack:null!==e?e:""})});return c}
	function Gh(a){switch(a.tag){case 1:J(a.type)&&Ke(a);var b=a.effectTag;return b&2048?(a.effectTag=b&-2049|64,a):null;case 3:return Kf(a),Le(a),b=a.effectTag,0!==(b&64)?x("285"):void 0,a.effectTag=b&-2049|64,a;case 5:return Mf(a),null;case 13:return b=a.effectTag,b&2048?(a.effectTag=b&-2049|64,a):null;case 18:return null;case 4:return Kf(a),null;case 10:return Zg(a),null;default:return null}}
	var Hh=Tb.ReactCurrentDispatcher,Ih=Tb.ReactCurrentOwner,Jh=1073741822,Kh=!1,T=null,Lh=null,U=0,Mh=-1,Nh=!1,V=null,Oh=!1,Ph=null,Qh=null,Rh=null,Fh=null;function Sh(){if(null!==T)for(var a=T.return;null!==a;){var b=a;switch(b.tag){case 1:var c=b.type.childContextTypes;null!==c&&void 0!==c&&Ke(b);break;case 3:Kf(b);Le(b);break;case 5:Mf(b);break;case 4:Kf(b);break;case 10:Zg(b)}a=a.return}Lh=null;U=0;Mh=-1;Nh=!1;T=null}
	function Th(){for(;null!==V;){var a=V.effectTag;a&16&&ke(V.stateNode,"");if(a&128){var b=V.alternate;null!==b&&(b=b.ref,null!==b&&("function"===typeof b?b(null):b.current=null))}switch(a&14){case 2:yh(V);V.effectTag&=-3;break;case 6:yh(V);V.effectTag&=-3;zh(V.alternate,V);break;case 4:zh(V.alternate,V);break;case 8:a=V,wh(a),a.return=null,a.child=null,a.memoizedState=null,a.updateQueue=null,a=a.alternate,null!==a&&(a.return=null,a.child=null,a.memoizedState=null,a.updateQueue=null)}V=V.nextEffect}}
	function Uh(){for(;null!==V;){if(V.effectTag&256)a:{var a=V.alternate,b=V;switch(b.tag){case 0:case 11:case 15:th(Of,Nf,b);break a;case 1:if(b.effectTag&256&&null!==a){var c=a.memoizedProps,d=a.memoizedState;a=b.stateNode;b=a.getSnapshotBeforeUpdate(b.elementType===b.type?c:L(b.type,c),d);a.__reactInternalSnapshotBeforeUpdate=b}break a;case 3:case 5:case 6:case 4:case 17:break a;default:x("163")}}V=V.nextEffect}}
	function Vh(a,b){for(;null!==V;){var c=V.effectTag;if(c&36){var d=V.alternate,e=V,f=b;switch(e.tag){case 0:case 11:case 15:th(Rf,Sf,e);break;case 1:var g=e.stateNode;if(e.effectTag&4)if(null===d)g.componentDidMount();else{var h=e.elementType===e.type?d.memoizedProps:L(e.type,d.memoizedProps);g.componentDidUpdate(h,d.memoizedState,g.__reactInternalSnapshotBeforeUpdate)}d=e.updateQueue;null!==d&&hh(e,d,g,f);break;case 3:d=e.updateQueue;if(null!==d){g=null;if(null!==e.child)switch(e.child.tag){case 5:g=
	e.child.stateNode;break;case 1:g=e.child.stateNode}hh(e,d,g,f)}break;case 5:f=e.stateNode;null===d&&e.effectTag&4&&we(e.type,e.memoizedProps)&&f.focus();break;case 6:break;case 4:break;case 12:break;case 13:break;case 17:break;default:x("163")}}c&128&&(e=V.ref,null!==e&&(f=V.stateNode,"function"===typeof e?e(f):e.current=f));c&512&&(Ph=a);V=V.nextEffect}}
	function Wh(a,b){Rh=Qh=Ph=null;var c=W;W=!0;do{if(b.effectTag&512){var d=!1,e=void 0;try{var f=b;th(Uf,Nf,f);th(Nf,Tf,f)}catch(g){d=!0,e=g}d&&sh(b,e)}b=b.nextEffect}while(null!==b);W=c;c=a.expirationTime;0!==c&&Xh(a,c);X||W||Yh(1073741823,!1)}function of(){null!==Qh&&Be(Qh);null!==Rh&&Rh()}
	function Zh(a,b){Oh=Kh=!0;a.current===b?x("177"):void 0;var c=a.pendingCommitExpirationTime;0===c?x("261"):void 0;a.pendingCommitExpirationTime=0;var d=b.expirationTime,e=b.childExpirationTime;ef(a,e>d?e:d);Ih.current=null;d=void 0;1<b.effectTag?null!==b.lastEffect?(b.lastEffect.nextEffect=b,d=b.firstEffect):d=b:d=b.firstEffect;ue=Bd;ve=Pd();Bd=!1;for(V=d;null!==V;){e=!1;var f=void 0;try{Uh()}catch(h){e=!0,f=h}e&&(null===V?x("178"):void 0,sh(V,f),null!==V&&(V=V.nextEffect))}for(V=d;null!==V;){e=!1;
	f=void 0;try{Th()}catch(h){e=!0,f=h}e&&(null===V?x("178"):void 0,sh(V,f),null!==V&&(V=V.nextEffect))}Qd(ve);ve=null;Bd=!!ue;ue=null;a.current=b;for(V=d;null!==V;){e=!1;f=void 0;try{Vh(a,c)}catch(h){e=!0,f=h}e&&(null===V?x("178"):void 0,sh(V,f),null!==V&&(V=V.nextEffect))}if(null!==d&&null!==Ph){var g=Wh.bind(null,a,d);Qh=r.unstable_runWithPriority(r.unstable_NormalPriority,function(){return Ae(g)});Rh=g}Kh=Oh=!1;"function"===typeof Qe&&Qe(b.stateNode);c=b.expirationTime;b=b.childExpirationTime;b=
	b>c?b:c;0===b&&(Fh=null);$h(a,b)}
	function ai(a){for(;;){var b=a.alternate,c=a.return,d=a.sibling;if(0===(a.effectTag&1024)){T=a;a:{var e=b;b=a;var f=U;var g=b.pendingProps;switch(b.tag){case 2:break;case 16:break;case 15:case 0:break;case 1:J(b.type)&&Ke(b);break;case 3:Kf(b);Le(b);g=b.stateNode;g.pendingContext&&(g.context=g.pendingContext,g.pendingContext=null);if(null===e||null===e.child)Eg(b),b.effectTag&=-3;mh(b);break;case 5:Mf(b);var h=If(Hf.current);f=b.type;if(null!==e&&null!=b.stateNode)nh(e,b,f,g,h),e.ref!==b.ref&&(b.effectTag|=
	128);else if(g){var l=If(N.current);if(Eg(b)){g=b;e=g.stateNode;var k=g.type,m=g.memoizedProps,p=h;e[Fa]=g;e[Ga]=m;f=void 0;h=k;switch(h){case "iframe":case "object":E("load",e);break;case "video":case "audio":for(k=0;k<ab.length;k++)E(ab[k],e);break;case "source":E("error",e);break;case "img":case "image":case "link":E("error",e);E("load",e);break;case "form":E("reset",e);E("submit",e);break;case "details":E("toggle",e);break;case "input":wc(e,m);E("invalid",e);se(p,"onChange");break;case "select":e._wrapperState=
	{wasMultiple:!!m.multiple};E("invalid",e);se(p,"onChange");break;case "textarea":ce(e,m),E("invalid",e),se(p,"onChange")}qe(h,m);k=null;for(f in m)m.hasOwnProperty(f)&&(l=m[f],"children"===f?"string"===typeof l?e.textContent!==l&&(k=["children",l]):"number"===typeof l&&e.textContent!==""+l&&(k=["children",""+l]):ra.hasOwnProperty(f)&&null!=l&&se(p,f));switch(h){case "input":Rb(e);Ac(e,m,!0);break;case "textarea":Rb(e);ee(e,m);break;case "select":case "option":break;default:"function"===typeof m.onClick&&
	(e.onclick=te)}f=k;g.updateQueue=f;g=null!==f?!0:!1;g&&kh(b)}else{m=b;p=f;e=g;k=9===h.nodeType?h:h.ownerDocument;l===fe.html&&(l=ge(p));l===fe.html?"script"===p?(e=k.createElement("div"),e.innerHTML="<script>\x3c/script>",k=e.removeChild(e.firstChild)):"string"===typeof e.is?k=k.createElement(p,{is:e.is}):(k=k.createElement(p),"select"===p&&(p=k,e.multiple?p.multiple=!0:e.size&&(p.size=e.size))):k=k.createElementNS(l,p);e=k;e[Fa]=m;e[Ga]=g;lh(e,b,!1,!1);p=e;k=f;m=g;var t=h,A=re(k,m);switch(k){case "iframe":case "object":E("load",
	p);h=m;break;case "video":case "audio":for(h=0;h<ab.length;h++)E(ab[h],p);h=m;break;case "source":E("error",p);h=m;break;case "img":case "image":case "link":E("error",p);E("load",p);h=m;break;case "form":E("reset",p);E("submit",p);h=m;break;case "details":E("toggle",p);h=m;break;case "input":wc(p,m);h=vc(p,m);E("invalid",p);se(t,"onChange");break;case "option":h=$d(p,m);break;case "select":p._wrapperState={wasMultiple:!!m.multiple};h=n({},m,{value:void 0});E("invalid",p);se(t,"onChange");break;case "textarea":ce(p,
	m);h=be(p,m);E("invalid",p);se(t,"onChange");break;default:h=m}qe(k,h);l=void 0;var v=k,R=p,u=h;for(l in u)if(u.hasOwnProperty(l)){var q=u[l];"style"===l?oe(R,q):"dangerouslySetInnerHTML"===l?(q=q?q.__html:void 0,null!=q&&je(R,q)):"children"===l?"string"===typeof q?("textarea"!==v||""!==q)&&ke(R,q):"number"===typeof q&&ke(R,""+q):"suppressContentEditableWarning"!==l&&"suppressHydrationWarning"!==l&&"autoFocus"!==l&&(ra.hasOwnProperty(l)?null!=q&&se(t,l):null!=q&&tc(R,l,q,A))}switch(k){case "input":Rb(p);
	Ac(p,m,!1);break;case "textarea":Rb(p);ee(p,m);break;case "option":null!=m.value&&p.setAttribute("value",""+uc(m.value));break;case "select":h=p;h.multiple=!!m.multiple;p=m.value;null!=p?ae(h,!!m.multiple,p,!1):null!=m.defaultValue&&ae(h,!!m.multiple,m.defaultValue,!0);break;default:"function"===typeof h.onClick&&(p.onclick=te)}(g=we(f,g))&&kh(b);b.stateNode=e}null!==b.ref&&(b.effectTag|=128)}else null===b.stateNode?x("166"):void 0;break;case 6:e&&null!=b.stateNode?oh(e,b,e.memoizedProps,g):("string"!==
	typeof g&&(null===b.stateNode?x("166"):void 0),e=If(Hf.current),If(N.current),Eg(b)?(g=b,f=g.stateNode,e=g.memoizedProps,f[Fa]=g,(g=f.nodeValue!==e)&&kh(b)):(f=b,g=(9===e.nodeType?e:e.ownerDocument).createTextNode(g),g[Fa]=b,f.stateNode=g));break;case 11:break;case 13:g=b.memoizedState;if(0!==(b.effectTag&64)){b.expirationTime=f;T=b;break a}g=null!==g;f=null!==e&&null!==e.memoizedState;null!==e&&!g&&f&&(e=e.child.sibling,null!==e&&(h=b.firstEffect,null!==h?(b.firstEffect=e,e.nextEffect=h):(b.firstEffect=
	b.lastEffect=e,e.nextEffect=null),e.effectTag=8));if(g||f)b.effectTag|=4;break;case 7:break;case 8:break;case 12:break;case 4:Kf(b);mh(b);break;case 10:Zg(b);break;case 9:break;case 14:break;case 17:J(b.type)&&Ke(b);break;case 18:break;default:x("156")}T=null}b=a;if(1===U||1!==b.childExpirationTime){g=0;for(f=b.child;null!==f;)e=f.expirationTime,h=f.childExpirationTime,e>g&&(g=e),h>g&&(g=h),f=f.sibling;b.childExpirationTime=g}if(null!==T)return T;null!==c&&0===(c.effectTag&1024)&&(null===c.firstEffect&&
	(c.firstEffect=a.firstEffect),null!==a.lastEffect&&(null!==c.lastEffect&&(c.lastEffect.nextEffect=a.firstEffect),c.lastEffect=a.lastEffect),1<a.effectTag&&(null!==c.lastEffect?c.lastEffect.nextEffect=a:c.firstEffect=a,c.lastEffect=a))}else{a=Gh(a,U);if(null!==a)return a.effectTag&=1023,a;null!==c&&(c.firstEffect=c.lastEffect=null,c.effectTag|=1024)}if(null!==d)return d;if(null!==c)a=c;else break}return null}
	function bi(a){var b=Tg(a.alternate,a,U);a.memoizedProps=a.pendingProps;null===b&&(b=ai(a));Ih.current=null;return b}
	function ci(a,b){Kh?x("243"):void 0;of();Kh=!0;var c=Hh.current;Hh.current=kg;var d=a.nextExpirationTimeToWorkOn;if(d!==U||a!==Lh||null===T)Sh(),Lh=a,U=d,T=Xe(Lh.current,null,U),a.pendingCommitExpirationTime=0;var e=!1;do{try{if(b)for(;null!==T&&!di();)T=bi(T);else for(;null!==T;)T=bi(T)}catch(u){if(Yg=Xg=Wg=null,lg(),null===T)e=!0,Dh(u);else{null===T?x("271"):void 0;var f=T,g=f.return;if(null===g)e=!0,Dh(u);else{a:{var h=a,l=g,k=f,m=u;g=U;k.effectTag|=1024;k.firstEffect=k.lastEffect=null;if(null!==
	m&&"object"===typeof m&&"function"===typeof m.then){var p=m;m=l;var t=-1,A=-1;do{if(13===m.tag){var v=m.alternate;if(null!==v&&(v=v.memoizedState,null!==v)){A=10*(1073741822-v.timedOutAt);break}v=m.pendingProps.maxDuration;if("number"===typeof v)if(0>=v)t=0;else if(-1===t||v<t)t=v}m=m.return}while(null!==m);m=l;do{if(v=13===m.tag)v=void 0===m.memoizedProps.fallback?!1:null===m.memoizedState;if(v){l=m.updateQueue;null===l?(l=new Set,l.add(p),m.updateQueue=l):l.add(p);if(0===(m.mode&1)){m.effectTag|=
	64;k.effectTag&=-1957;1===k.tag&&(null===k.alternate?k.tag=17:(g=nf(1073741823),g.tag=sf,pf(k,g)));k.expirationTime=1073741823;break a}k=h;l=g;var R=k.pingCache;null===R?(R=k.pingCache=new Bh,v=new Set,R.set(p,v)):(v=R.get(p),void 0===v&&(v=new Set,R.set(p,v)));v.has(l)||(v.add(l),k=ei.bind(null,k,p,l),p.then(k,k));-1===t?h=1073741823:(-1===A&&(A=10*(1073741822-gf(h,g))-5E3),h=A+t);0<=h&&Mh<h&&(Mh=h);m.effectTag|=2048;m.expirationTime=g;break a}m=m.return}while(null!==m);m=Error((ic(k.type)||"A React component")+
	" suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display."+jc(k))}Nh=!0;m=jh(m,k);h=l;do{switch(h.tag){case 3:h.effectTag|=2048;h.expirationTime=g;g=Ch(h,m,g);eh(h,g);break a;case 1:if(t=m,A=h.type,k=h.stateNode,0===(h.effectTag&64)&&("function"===typeof A.getDerivedStateFromError||null!==k&&"function"===typeof k.componentDidCatch&&(null===Fh||!Fh.has(k)))){h.effectTag|=2048;
	h.expirationTime=g;g=Eh(h,t,g);eh(h,g);break a}}h=h.return}while(null!==h)}T=ai(f);continue}}}break}while(1);Kh=!1;Hh.current=c;Yg=Xg=Wg=null;lg();if(e)Lh=null,a.finishedWork=null;else if(null!==T)a.finishedWork=null;else{c=a.current.alternate;null===c?x("281"):void 0;Lh=null;if(Nh){e=a.latestPendingTime;f=a.latestSuspendedTime;g=a.latestPingedTime;if(0!==e&&e<d||0!==f&&f<d||0!==g&&g<d){ff(a,d);fi(a,c,d,a.expirationTime,-1);return}if(!a.didError&&b){a.didError=!0;d=a.nextExpirationTimeToWorkOn=d;
	b=a.expirationTime=1073741823;fi(a,c,d,b,-1);return}}b&&-1!==Mh?(ff(a,d),b=10*(1073741822-gf(a,d)),b<Mh&&(Mh=b),b=10*(1073741822-lf()),b=Mh-b,fi(a,c,d,a.expirationTime,0>b?0:b)):(a.pendingCommitExpirationTime=d,a.finishedWork=c)}}
	function sh(a,b){for(var c=a.return;null!==c;){switch(c.tag){case 1:var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromError||"function"===typeof d.componentDidCatch&&(null===Fh||!Fh.has(d))){a=jh(b,a);a=Eh(c,a,1073741823);pf(c,a);qf(c,1073741823);return}break;case 3:a=jh(b,a);a=Ch(c,a,1073741823);pf(c,a);qf(c,1073741823);return}c=c.return}3===a.tag&&(c=jh(b,a),c=Ch(a,c,1073741823),pf(a,c),qf(a,1073741823))}
	function mf(a,b){var c=r.unstable_getCurrentPriorityLevel(),d=void 0;if(0===(b.mode&1))d=1073741823;else if(Kh&&!Oh)d=U;else{switch(c){case r.unstable_ImmediatePriority:d=1073741823;break;case r.unstable_UserBlockingPriority:d=1073741822-10*(((1073741822-a+15)/10|0)+1);break;case r.unstable_NormalPriority:d=1073741822-25*(((1073741822-a+500)/25|0)+1);break;case r.unstable_LowPriority:case r.unstable_IdlePriority:d=1;break;default:x("313")}null!==Lh&&d===U&&--d}c===r.unstable_UserBlockingPriority&&
	(0===gi||d<gi)&&(gi=d);return d}function ei(a,b,c){var d=a.pingCache;null!==d&&d.delete(b);if(null!==Lh&&U===c)Lh=null;else if(b=a.earliestSuspendedTime,d=a.latestSuspendedTime,0!==b&&c<=b&&c>=d){a.didError=!1;b=a.latestPingedTime;if(0===b||b>c)a.latestPingedTime=c;df(c,a);c=a.expirationTime;0!==c&&Xh(a,c)}}function Ah(a,b){var c=a.stateNode;null!==c&&c.delete(b);b=lf();b=mf(b,a);a=hi(a,b);null!==a&&(cf(a,b),b=a.expirationTime,0!==b&&Xh(a,b))}
	function hi(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);var d=a.return,e=null;if(null===d&&3===a.tag)e=a.stateNode;else for(;null!==d;){c=d.alternate;d.childExpirationTime<b&&(d.childExpirationTime=b);null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);if(null===d.return&&3===d.tag){e=d.stateNode;break}d=d.return}return e}
	function qf(a,b){a=hi(a,b);null!==a&&(!Kh&&0!==U&&b>U&&Sh(),cf(a,b),Kh&&!Oh&&Lh===a||Xh(a,a.expirationTime),ii>ji&&(ii=0,x("185")))}function ki(a,b,c,d,e){return r.unstable_runWithPriority(r.unstable_ImmediatePriority,function(){return a(b,c,d,e)})}var li=null,Y=null,mi=0,ni=void 0,W=!1,oi=null,Z=0,gi=0,pi=!1,qi=null,X=!1,ri=!1,si=null,ti=r.unstable_now(),ui=1073741822-(ti/10|0),vi=ui,ji=50,ii=0,wi=null;function xi(){ui=1073741822-((r.unstable_now()-ti)/10|0)}
	function yi(a,b){if(0!==mi){if(b<mi)return;null!==ni&&r.unstable_cancelCallback(ni)}mi=b;a=r.unstable_now()-ti;ni=r.unstable_scheduleCallback(zi,{timeout:10*(1073741822-b)-a})}function fi(a,b,c,d,e){a.expirationTime=d;0!==e||di()?0<e&&(a.timeoutHandle=ye(Ai.bind(null,a,b,c),e)):(a.pendingCommitExpirationTime=c,a.finishedWork=b)}function Ai(a,b,c){a.pendingCommitExpirationTime=c;a.finishedWork=b;xi();vi=ui;Bi(a,c)}function $h(a,b){a.expirationTime=b;a.finishedWork=null}
	function lf(){if(W)return vi;Ci();if(0===Z||1===Z)xi(),vi=ui;return vi}function Xh(a,b){null===a.nextScheduledRoot?(a.expirationTime=b,null===Y?(li=Y=a,a.nextScheduledRoot=a):(Y=Y.nextScheduledRoot=a,Y.nextScheduledRoot=li)):b>a.expirationTime&&(a.expirationTime=b);W||(X?ri&&(oi=a,Z=1073741823,Di(a,1073741823,!1)):1073741823===b?Yh(1073741823,!1):yi(a,b))}
	function Ci(){var a=0,b=null;if(null!==Y)for(var c=Y,d=li;null!==d;){var e=d.expirationTime;if(0===e){null===c||null===Y?x("244"):void 0;if(d===d.nextScheduledRoot){li=Y=d.nextScheduledRoot=null;break}else if(d===li)li=e=d.nextScheduledRoot,Y.nextScheduledRoot=e,d.nextScheduledRoot=null;else if(d===Y){Y=c;Y.nextScheduledRoot=li;d.nextScheduledRoot=null;break}else c.nextScheduledRoot=d.nextScheduledRoot,d.nextScheduledRoot=null;d=c.nextScheduledRoot}else{e>a&&(a=e,b=d);if(d===Y)break;if(1073741823===
	a)break;c=d;d=d.nextScheduledRoot}}oi=b;Z=a}var Ei=!1;function di(){return Ei?!0:r.unstable_shouldYield()?Ei=!0:!1}function zi(){try{if(!di()&&null!==li){xi();var a=li;do{var b=a.expirationTime;0!==b&&ui<=b&&(a.nextExpirationTimeToWorkOn=ui);a=a.nextScheduledRoot}while(a!==li)}Yh(0,!0)}finally{Ei=!1}}
	function Yh(a,b){Ci();if(b)for(xi(),vi=ui;null!==oi&&0!==Z&&a<=Z&&!(Ei&&ui>Z);)Di(oi,Z,ui>Z),Ci(),xi(),vi=ui;else for(;null!==oi&&0!==Z&&a<=Z;)Di(oi,Z,!1),Ci();b&&(mi=0,ni=null);0!==Z&&yi(oi,Z);ii=0;wi=null;if(null!==si)for(a=si,si=null,b=0;b<a.length;b++){var c=a[b];try{c._onComplete()}catch(d){pi||(pi=!0,qi=d)}}if(pi)throw a=qi,qi=null,pi=!1,a;}function Bi(a,b){W?x("253"):void 0;oi=a;Z=b;Di(a,b,!1);Yh(1073741823,!1)}
	function Di(a,b,c){W?x("245"):void 0;W=!0;if(c){var d=a.finishedWork;null!==d?Fi(a,d,b):(a.finishedWork=null,d=a.timeoutHandle,-1!==d&&(a.timeoutHandle=-1,ze(d)),ci(a,c),d=a.finishedWork,null!==d&&(di()?a.finishedWork=d:Fi(a,d,b)))}else d=a.finishedWork,null!==d?Fi(a,d,b):(a.finishedWork=null,d=a.timeoutHandle,-1!==d&&(a.timeoutHandle=-1,ze(d)),ci(a,c),d=a.finishedWork,null!==d&&Fi(a,d,b));W=!1}
	function Fi(a,b,c){var d=a.firstBatch;if(null!==d&&d._expirationTime>=c&&(null===si?si=[d]:si.push(d),d._defer)){a.finishedWork=b;a.expirationTime=0;return}a.finishedWork=null;a===wi?ii++:(wi=a,ii=0);r.unstable_runWithPriority(r.unstable_ImmediatePriority,function(){Zh(a,b)})}function Dh(a){null===oi?x("246"):void 0;oi.expirationTime=0;pi||(pi=!0,qi=a)}function Gi(a,b){var c=X;X=!0;try{return a(b)}finally{(X=c)||W||Yh(1073741823,!1)}}
	function Hi(a,b){if(X&&!ri){ri=!0;try{return a(b)}finally{ri=!1}}return a(b)}function Ii(a,b,c){X||W||0===gi||(Yh(gi,!1),gi=0);var d=X;X=!0;try{return r.unstable_runWithPriority(r.unstable_UserBlockingPriority,function(){return a(b,c)})}finally{(X=d)||W||Yh(1073741823,!1)}}
	function Ji(a,b,c,d,e){var f=b.current;a:if(c){c=c._reactInternalFiber;b:{2===ed(c)&&1===c.tag?void 0:x("170");var g=c;do{switch(g.tag){case 3:g=g.stateNode.context;break b;case 1:if(J(g.type)){g=g.stateNode.__reactInternalMemoizedMergedChildContext;break b}}g=g.return}while(null!==g);x("171");g=void 0}if(1===c.tag){var h=c.type;if(J(h)){c=Ne(c,h,g);break a}}c=g}else c=He;null===b.context?b.context=c:b.pendingContext=c;b=e;e=nf(d);e.payload={element:a};b=void 0===b?null:b;null!==b&&(e.callback=b);
	of();pf(f,e);qf(f,d);return d}function Ki(a,b,c,d){var e=b.current,f=lf();e=mf(f,e);return Ji(a,b,c,e,d)}function Li(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}function Mi(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:Wb,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}
	Ab=function(a,b,c){switch(b){case "input":yc(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Ka(d);e?void 0:x("90");Sb(d);yc(d,e)}}}break;case "textarea":de(a,c);break;case "select":b=c.value,null!=b&&ae(a,!!c.multiple,b,!1)}};
	function Ni(a){var b=1073741822-25*(((1073741822-lf()+500)/25|0)+1);b>=Jh&&(b=Jh-1);this._expirationTime=Jh=b;this._root=a;this._callbacks=this._next=null;this._hasChildren=this._didComplete=!1;this._children=null;this._defer=!0}Ni.prototype.render=function(a){this._defer?void 0:x("250");this._hasChildren=!0;this._children=a;var b=this._root._internalRoot,c=this._expirationTime,d=new Oi;Ji(a,b,null,c,d._onCommit);return d};
	Ni.prototype.then=function(a){if(this._didComplete)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
	Ni.prototype.commit=function(){var a=this._root._internalRoot,b=a.firstBatch;this._defer&&null!==b?void 0:x("251");if(this._hasChildren){var c=this._expirationTime;if(b!==this){this._hasChildren&&(c=this._expirationTime=b._expirationTime,this.render(this._children));for(var d=null,e=b;e!==this;)d=e,e=e._next;null===d?x("251"):void 0;d._next=e._next;this._next=b;a.firstBatch=this}this._defer=!1;Bi(a,c);b=this._next;this._next=null;b=a.firstBatch=b;null!==b&&b._hasChildren&&b.render(b._children)}else this._next=
	null,this._defer=!1};Ni.prototype._onComplete=function(){if(!this._didComplete){this._didComplete=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++)(0,a[b])()}};function Oi(){this._callbacks=null;this._didCommit=!1;this._onCommit=this._onCommit.bind(this)}Oi.prototype.then=function(a){if(this._didCommit)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
	Oi.prototype._onCommit=function(){if(!this._didCommit){this._didCommit=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++){var c=a[b];"function"!==typeof c?x("191",c):void 0;c()}}};
	function Pi(a,b,c){b=K(3,null,null,b?3:0);a={current:b,containerInfo:a,pendingChildren:null,pingCache:null,earliestPendingTime:0,latestPendingTime:0,earliestSuspendedTime:0,latestSuspendedTime:0,latestPingedTime:0,didError:!1,pendingCommitExpirationTime:0,finishedWork:null,timeoutHandle:-1,context:null,pendingContext:null,hydrate:c,nextExpirationTimeToWorkOn:0,expirationTime:0,firstBatch:null,nextScheduledRoot:null};this._internalRoot=b.stateNode=a}
	Pi.prototype.render=function(a,b){var c=this._internalRoot,d=new Oi;b=void 0===b?null:b;null!==b&&d.then(b);Ki(a,c,null,d._onCommit);return d};Pi.prototype.unmount=function(a){var b=this._internalRoot,c=new Oi;a=void 0===a?null:a;null!==a&&c.then(a);Ki(null,b,null,c._onCommit);return c};Pi.prototype.legacy_renderSubtreeIntoContainer=function(a,b,c){var d=this._internalRoot,e=new Oi;c=void 0===c?null:c;null!==c&&e.then(c);Ki(b,d,a,e._onCommit);return e};
	Pi.prototype.createBatch=function(){var a=new Ni(this),b=a._expirationTime,c=this._internalRoot,d=c.firstBatch;if(null===d)c.firstBatch=a,a._next=null;else{for(c=null;null!==d&&d._expirationTime>=b;)c=d,d=d._next;a._next=d;null!==c&&(c._next=a)}return a};function Qi(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}Gb=Gi;Hb=Ii;Ib=function(){W||0===gi||(Yh(gi,!1),gi=0)};
	function Ri(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new Pi(a,!1,b)}
	function Si(a,b,c,d,e){var f=c._reactRootContainer;if(f){if("function"===typeof e){var g=e;e=function(){var a=Li(f._internalRoot);g.call(a)}}null!=a?f.legacy_renderSubtreeIntoContainer(a,b,e):f.render(b,e)}else{f=c._reactRootContainer=Ri(c,d);if("function"===typeof e){var h=e;e=function(){var a=Li(f._internalRoot);h.call(a)}}Hi(function(){null!=a?f.legacy_renderSubtreeIntoContainer(a,b,e):f.render(b,e)})}return Li(f._internalRoot)}
	function Ti(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;Qi(b)?void 0:x("200");return Mi(a,b,null,c)}
	var Vi={createPortal:Ti,findDOMNode:function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;void 0===b&&("function"===typeof a.render?x("188"):x("268",Object.keys(a)));a=hd(b);a=null===a?null:a.stateNode;return a},hydrate:function(a,b,c){Qi(b)?void 0:x("200");return Si(null,a,b,!0,c)},render:function(a,b,c){Qi(b)?void 0:x("200");return Si(null,a,b,!1,c)},unstable_renderSubtreeIntoContainer:function(a,b,c,d){Qi(c)?void 0:x("200");null==a||void 0===a._reactInternalFiber?
	x("38"):void 0;return Si(a,b,c,!1,d)},unmountComponentAtNode:function(a){Qi(a)?void 0:x("40");return a._reactRootContainer?(Hi(function(){Si(null,null,a,!1,function(){a._reactRootContainer=null})}),!0):!1},unstable_createPortal:function(){return Ti.apply(void 0,arguments)},unstable_batchedUpdates:Gi,unstable_interactiveUpdates:Ii,flushSync:function(a,b){W?x("187"):void 0;var c=X;X=!0;try{return ki(a,b)}finally{X=c,Yh(1073741823,!1)}},unstable_createRoot:Ui,unstable_flushControlled:function(a){var b=
	X;X=!0;try{ki(a)}finally{(X=b)||W||Yh(1073741823,!1)}},__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{Events:[Ia,Ja,Ka,Ba.injectEventPluginsByName,pa,Qa,function(a){ya(a,Pa)},Eb,Fb,Dd,Da]}};function Ui(a,b){Qi(a)?void 0:x("299","unstable_createRoot");return new Pi(a,!0,null!=b&&!0===b.hydrate)}
	(function(a){var b=a.findFiberByHostInstance;return Te(n({},a,{overrideProps:null,currentDispatcherRef:Tb.ReactCurrentDispatcher,findHostInstanceByFiber:function(a){a=hd(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null}}))})({findFiberByHostInstance:Ha,bundleType:0,version:"16.8.6",rendererPackageName:"react-dom"});var Wi={default:Vi},Xi=Wi&&Vi||Wi;module.exports=Xi.default||Xi;


/***/ },
/* 1843 */
/***/ function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ },
/* 1844 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * Clamp.js 0.7.0
	 * Based on: https://github.com/xavi160/Clamp.js/commit/e313818da231b8dd8fd603dd9c9a61a9d725c22f
	 * Mixins:
	 * - https://github.com/josephschmitt/Clamp.js/pull/50
	 * - https://github.com/josephschmitt/Clamp.js/pull/49
	 *
	 * Copyright 2011-2013, Joseph Schmitt http://joe.sh
	 * Released under the WTFPL license
	 * http://sam.zoy.org/wtfpl/
	 */
	
	(function(root, factory) {
	  if (true) {
	    // AMD
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports === 'object') {
	    // Node, CommonJS-like
	    module.exports = factory();
	  } else {
	    // Browser globals
	    root.$clamp = factory();
	  }
	}(this, function() {
	  /**
	   * Clamps a text node.
	   * @param {HTMLElement} element. Element containing the text node to clamp.
	   * @param {Object} options. Options to pass to the clamper.
	   */
	  function clamp(element, options) {
	    options = options || {};
	
	    var self = this,
	      win = window,
	      opt = {
	        clamp: options.clamp || 2,
	        useNativeClamp: typeof(options.useNativeClamp) != 'undefined' ? options.useNativeClamp : true,
	        splitOnChars: options.splitOnChars || ['.', '-', '–', '—', ' '], //Split on sentences (periods), hypens, en-dashes, em-dashes, and words (spaces).
	        animate: options.animate || false,
	        truncationChar: options.truncationChar || '…',
	        truncationHTML: options.truncationHTML
	      },
	
	      sty = element.style,
	      originalText = element.innerHTML,
	
	      supportsNativeClamp = typeof(element.style.webkitLineClamp) != 'undefined',
	      clampValue = opt.clamp,
	      isCSSValue = clampValue.indexOf && (clampValue.indexOf('px') > -1 || clampValue.indexOf('em') > -1),
	      truncationHTMLContainer;
	
	    if (opt.truncationHTML) {
	      truncationHTMLContainer = document.createElement('span');
	      truncationHTMLContainer.innerHTML = opt.truncationHTML;
	    }
	
	
	    // UTILITY FUNCTIONS __________________________________________________________
	
	    /**
	     * Return the current style for an element.
	     * @param {HTMLElement} elem The element to compute.
	     * @param {string} prop The style property.
	     * @returns {number}
	     */
	    function computeStyle(elem, prop) {
	      if (!win.getComputedStyle) {
	        win.getComputedStyle = function(el, pseudo) {
	          this.el = el;
	          this.getPropertyValue = function(prop) {
	            var re = /(\-([a-z]){1})/g;
	            if (prop == 'float') prop = 'styleFloat';
	            if (re.test(prop)) {
	              prop = prop.replace(re, function() {
	                return arguments[2].toUpperCase();
	              });
	            }
	            return el.currentStyle && el.currentStyle[prop] ? el.currentStyle[prop] : null;
	          };
	          return this;
	        };
	      }
	
	      return win.getComputedStyle(elem, null).getPropertyValue(prop);
	    }
	
	    /**
	     * Returns the maximum number of lines of text that should be rendered based
	     * on the current height of the element and the line-height of the text.
	     */
	    function getMaxLines(height) {
	      var availHeight = height || (element.parentNode.clientHeight-element.offsetTop),
	        lineHeight = getLineHeight(element);
	
	      return Math.max(Math.floor(availHeight / lineHeight), 0);
	    }
	
	    /**
	     * Returns the maximum height a given element should have based on the line-
	     * height of the text and the given clamp value.
	     */
	    function getMaxHeight(clmp) {
	      var lineHeight = getLineHeight(element);
	      return lineHeight * clmp;
	    }
	
	    /**
	     * Returns the line-height of an element as an integer.
	     */
	    function getLineHeight(elem) {
	      var lh = computeStyle(elem, 'line-height');
	      if (lh == 'normal') {
	        // Normal line heights vary from browser to browser. The spec recommends
	        // a value between 1.0 and 1.2 of the font size. Using 1.1 to split the diff.
	        lh = parseFloat(computeStyle(elem, 'font-size')) * 1.2;
	      }
	      return Math.round(parseFloat(lh));
	    }
	
	
	    // MEAT AND POTATOES (MMMM, POTATOES...) ______________________________________
	    var splitOnChars = opt.splitOnChars.slice(0),
	      splitChar = splitOnChars[0],
	      chunks,
	      lastChunk;
	
	    /**
	     * Gets an element's last child. That may be another node or a node's contents.
	     */
	    function getLastChild(elem) {
	      if (!elem.lastChild) {
	        return;
	      }
	      //Current element has children, need to go deeper and get last child as a text node
	      if (elem.lastChild.children && elem.lastChild.children.length > 0) {
	        return getLastChild(Array.prototype.slice.call(elem.children).pop());
	      } else if (
	        !elem.lastChild
	        || !elem.lastChild.nodeValue
	        || elem.lastChild.nodeValue == opt.truncationChar
	        || elem.lastChild.nodeType === Node.COMMENT_NODE
	      ) {
	        // Handle scenario where the last child is white-space node
	        var sibling = elem.lastChild;
	        do {
	          if (!sibling) {
	            return;
	          }
	          // TEXT_NODE
	          if (
	            sibling.nodeType === 3
	            && ['', opt.truncationChar].indexOf(sibling.nodeValue) === -1
	            && elem.lastChild.nodeType !== Node.COMMENT_NODE
	          ) {
	            return sibling;
	          }
	          if (sibling.lastChild) {
	            var lastChild = getLastChild(sibling);
	            if (lastChild) {
	              return lastChild;
	            }
	          }
	          //Current sibling is pretty useless
	          sibling.parentNode.removeChild(sibling);
	        } while (sibling = sibling.previousSibling);
	      }
	      //This is the last child we want, return it
	      else {
	        return elem.lastChild;
	      }
	    }
	
	    /**
	     * Removes one character at a time from the text until its width or
	     * height is beneath the passed-in max param.
	     */
	    function truncate(target, maxHeight) {
	      if (!target || !maxHeight) {
	        return;
	      }
	
	      /**
	       * Resets global variables.
	       */
	      function reset() {
	        splitOnChars = opt.splitOnChars.slice(0);
	        splitChar = splitOnChars[0];
	        chunks = null;
	        lastChunk = null;
	      }
	
	      var nodeValue = target.nodeValue.replace(opt.truncationChar, '');
	
	      //Grab the next chunks
	      if (!chunks) {
	        //If there are more characters to try, grab the next one
	        if (splitOnChars.length > 0) {
	          splitChar = splitOnChars.shift();
	        }
	        //No characters to chunk by. Go character-by-character
	        else {
	          splitChar = '';
	        }
	
	        chunks = nodeValue.split(splitChar);
	      }
	
	      //If there are chunks left to remove, remove the last one and see if
	      // the nodeValue fits.
	      if (chunks.length > 1) {
	        // console.log('chunks', chunks);
	        lastChunk = chunks.pop();
	        // console.log('lastChunk', lastChunk);
	        applyEllipsis(target, chunks.join(splitChar));
	      }
	      //No more chunks can be removed using this character
	      else {
	        chunks = null;
	      }
	
	      //Insert the custom HTML before the truncation character
	      if (truncationHTMLContainer) {
	        target.nodeValue = target.nodeValue.replace(opt.truncationChar, '');
	        element.innerHTML = target.nodeValue + ' ' + truncationHTMLContainer.innerHTML + opt.truncationChar;
	      }
	
	      //Search produced valid chunks
	      if (chunks) {
	        //It fits
	        if (element.clientHeight <= maxHeight) {
	          //There's still more characters to try splitting on, not quite done yet
	          if (splitOnChars.length >= 0 && splitChar !== '') {
	            applyEllipsis(target, chunks.join(splitChar) + splitChar + lastChunk);
	            chunks = null;
	          }
	          //Finished!
	          else {
	            return element.innerHTML;
	          }
	        }
	      }
	      //No valid chunks produced
	      else {
	        //No valid chunks even when splitting by letter, time to move
	        //on to the next node
	        if (splitChar === '') {
	          applyEllipsis(target, '');
	          target = getLastChild(element);
	
	          reset();
	        }
	      }
	
	      //If you get here it means still too big, let's keep truncating
	      if (opt.animate) {
	        setTimeout(function() {
	          truncate(target, maxHeight);
	        }, opt.animate === true ? 10 : opt.animate);
	      } else {
	        return truncate(target, maxHeight);
	      }
	    }
	
	    function applyEllipsis(elem, str) {
	      elem.nodeValue = str + opt.truncationChar;
	    }
	
	
	    // CONSTRUCTOR ________________________________________________________________
	
	    if (clampValue == 'auto') {
	      clampValue = getMaxLines();
	    } else if (isCSSValue) {
	      clampValue = getMaxLines(parseInt(clampValue, 10));
	    }
	
	    var clampedText;
	    if (supportsNativeClamp && opt.useNativeClamp) {
	      sty.overflow = 'hidden';
	      sty.textOverflow = 'ellipsis';
	      sty.webkitBoxOrient = 'vertical';
	      sty.display = '-webkit-box';
	      sty.webkitLineClamp = clampValue;
	
	      if (isCSSValue) {
	        sty.height = opt.clamp + 'px';
	      }
	    } else {
	      var height = getMaxHeight(clampValue);
	      if (height < element.clientHeight) {
	        clampedText = truncate(getLastChild(element), height);
	      }
	    }
	
	    return {
	      'original': originalText,
	      'clamped': clampedText
	    };
	  }
	
	  return clamp;
	}));


/***/ },
/* 1845 */
/***/ function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	var clamp = __webpack_require__(1844);
	var pick = __webpack_require__(1755);
	var PropTypes = __webpack_require__(4);
	var ReactDOM = __webpack_require__(46);
	
	/**
	 * multuline text-overflow: ellipsis
	 */
	function Dotdotdot() {
	  if(!(this instanceof Dotdotdot)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	  this.update = this.update.bind(this);
	  this.getContainerRef = function (container) {
	    this.container = container;
	  }.bind(this);
	}
	
	Dotdotdot.prototype = Object.create(React.Component.prototype);
	Dotdotdot.prototype.componentDidMount = function() {
	  window.addEventListener('resize', this.update, false);
	  // NOTE: It's possible, not all fonts are loaded on window.load
	  window.addEventListener('load', this.update, false);
	  this.dotdotdot(ReactDOM.findDOMNode(this.container));
	};
	Dotdotdot.prototype.componentWillUnmount = function() {
	  window.removeEventListener('resize', this.update, false);
	  window.removeEventListener('load', this.update, false);
	};
	Dotdotdot.prototype.componentDidUpdate = function() {
	  this.dotdotdot(ReactDOM.findDOMNode(this.container));
	};
	
	Dotdotdot.prototype.dotdotdot = function(container) {
	  if (!container) {
	    return;
	  }
	
	  if (this.props.clamp) {
	    if (container.length) {
	      throw new Error('Please provide exacly one child to dotdotdot');
	    }
	    clamp(container, pick(this.props, [
	      'animate',
	      'clamp',
	      'splitOnChars',
	      'truncationChar',
	      'truncationHTML',
	      'useNativeClamp'
	    ]));
	  };
	};
	Dotdotdot.prototype.update = function() {
	    this.forceUpdate();
	};
	
	Dotdotdot.prototype.render = function() {
	  return React.createElement(
	    this.props.tagName,
	    {
	      ref: this.getContainerRef,
	      className: this.props.className
	    },
	    this.props.children
	  );
	};
	
	// Statics:
	Dotdotdot.propTypes = {
	  children: PropTypes.node,
	  clamp: PropTypes.oneOfType([
	    PropTypes.string,
	    PropTypes.number,
	    PropTypes.bool
	  ]).isRequired,
	  truncationChar: PropTypes.string,
	  useNativeClamp: PropTypes.bool,
	  className: PropTypes.string,
	  tagName: PropTypes.string
	};
	
	Dotdotdot.defaultProps = {
	  truncationChar: '\u2026',
	  useNativeClamp: false,
	  tagName: 'div'
	};
	
	module.exports = Dotdotdot;


/***/ },
/* 1846 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _jsImageZoom = __webpack_require__(1653);
	
	var _jsImageZoom2 = _interopRequireDefault(_jsImageZoom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ReactImageZoom = function (_React$Component) {
	  _inherits(ReactImageZoom, _React$Component);
	
	  function ReactImageZoom(props) {
	    _classCallCheck(this, ReactImageZoom);
	
	    var _this = _possibleConstructorReturn(this, (ReactImageZoom.__proto__ || Object.getPrototypeOf(ReactImageZoom)).call(this, props));
	
	    _this.container = undefined;
	    _this.getRef = _this.getRef.bind(_this);
	    return _this;
	  }
	
	  _createClass(ReactImageZoom, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.rerenderImageZoom(this.props);
	    }
	  }, {
	    key: 'UNSAFE_componentWillUnmount',
	    value: function UNSAFE_componentWillUnmount() {
	      this.imageZoom.kill();
	      this.imageZoom = void 0;
	    }
	  }, {
	    key: 'UNSAFE_componentWillReceiveProps',
	    value: function UNSAFE_componentWillReceiveProps(nextProps) {
	      if (this.props !== nextProps) {
	        this.kill();
	        this.rerenderImageZoom(nextProps);
	      }
	    }
	  }, {
	    key: 'rerenderImageZoom',
	    value: function rerenderImageZoom(props) {
	      this.imageZoom = new _jsImageZoom2.default(this.container, JSON.parse(JSON.stringify(props)));
	    }
	  }, {
	    key: 'setup',
	    value: function setup() {
	      this.imageZoom.setup();
	    }
	  }, {
	    key: 'kill',
	    value: function kill() {
	      this.imageZoom.kill();
	    }
	  }, {
	    key: 'getRef',
	    value: function getRef(ref) {
	      this.container = ref;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement('div', { ref: this.getRef });
	    }
	  }]);
	
	  return ReactImageZoom;
	}(_react2.default.Component);
	
	ReactImageZoom.propTypes = {
	  width: _propTypes2.default.number,
	  img: _propTypes2.default.string,
	  height: _propTypes2.default.number,
	  zoomWidth: _propTypes2.default.number,
	  scale: _propTypes2.default.number,
	  offset: _propTypes2.default.object,
	  zoomStyle: _propTypes2.default.string,
	  zoomLensStyle: _propTypes2.default.string,
	  zoomPosition: _propTypes2.default.oneOf(['top', 'left', 'bottom', 'right', 'original'])
	};
	
	exports.default = ReactImageZoom;
	module.exports = exports['default'];


/***/ },
/* 1847 */
/***/ function(module, exports, __webpack_require__) {

	!function(e,a){ true?module.exports=a():"function"==typeof define&&define.amd?define(a):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.es=a())}(this,function(){"use strict";var e=[{locale:"es",pluralRuleFunction:function(e,a){return a?"other":1==e?"one":"other"},fields:{year:{displayName:"año",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},minute:{displayName:"minuto",relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}}}},{locale:"es-419",parentLocale:"es"},{locale:"es-AR",parentLocale:"es-419"},{locale:"es-BO",parentLocale:"es-419"},{locale:"es-CL",parentLocale:"es-419"},{locale:"es-CO",parentLocale:"es-419"},{locale:"es-CR",parentLocale:"es-419",fields:{year:{displayName:"año",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"antier","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},minute:{displayName:"minuto",relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}}}},{locale:"es-CU",parentLocale:"es-419"},{locale:"es-DO",parentLocale:"es-419",fields:{year:{displayName:"Año",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},month:{displayName:"Mes",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},day:{displayName:"Día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},minute:{displayName:"Minuto",relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},second:{displayName:"Segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}}}},{locale:"es-EA",parentLocale:"es"},{locale:"es-EC",parentLocale:"es-419"},{locale:"es-GQ",parentLocale:"es"},{locale:"es-GT",parentLocale:"es-419",fields:{year:{displayName:"año",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"antier","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},minute:{displayName:"minuto",relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}}}},{locale:"es-HN",parentLocale:"es-419",fields:{year:{displayName:"año",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"antier","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},minute:{displayName:"minuto",relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}}}},{locale:"es-IC",parentLocale:"es"},{locale:"es-MX",parentLocale:"es-419",fields:{year:{displayName:"año",relative:{0:"este año",1:"el año próximo","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el mes próximo","-1":"el mes pasado"},relativeTime:{future:{one:"en {0} mes",other:"en {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"antier","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},minute:{displayName:"minuto",relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}}}},{locale:"es-NI",parentLocale:"es-419",fields:{year:{displayName:"año",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"antier","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},minute:{displayName:"minuto",relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}}}},{locale:"es-PA",parentLocale:"es-419",fields:{year:{displayName:"año",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"antier","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},minute:{displayName:"minuto",relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}}}},{locale:"es-PE",parentLocale:"es-419"},{locale:"es-PH",parentLocale:"es"},{locale:"es-PR",parentLocale:"es-419"},{locale:"es-PY",parentLocale:"es-419",fields:{year:{displayName:"año",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"antes de ayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},minute:{displayName:"minuto",relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}}}},{locale:"es-SV",parentLocale:"es-419",fields:{year:{displayName:"año",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"antier","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},minute:{displayName:"minuto",relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}}}},{locale:"es-US",parentLocale:"es-419"},{locale:"es-UY",parentLocale:"es-419"},{locale:"es-VE",parentLocale:"es-419"}];return e});


/***/ },
/* 1848 */
/***/ function(module, exports) {

	/** @license React v16.13.1
	 * react-is.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
	Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
	function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
	exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
	exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
	exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ },
/* 1849 */
/***/ function(module, exports, __webpack_require__) {

	!function(e,t){ true?module.exports=t(__webpack_require__(1852)):"function"==typeof define&&define.amd?define(["react"],t):"object"==typeof exports?exports.InfiniteCarousel=t(require("react")):e.InfiniteCarousel=t(e.React)}(window,function(n){return i={},r.m=o=[function(e,t,n){e.exports=n(6)()},function(e,t){e.exports=n},function(t,e,n){(function(e){var n=e&&e.pid?e.pid.toString(36):"";function o(){var e=Date.now(),t=o.last||e;return o.last=t<e?e:t+1}t.exports=t.exports.default=function(e,t){return(e||"")+""+n+o().toString(36)+(t||"")},t.exports.process=function(e,t){return(e||"")+n+o().toString(36)+(t||"")},t.exports.time=function(e,t){return(e||"")+o().toString(36)+(t||"")}}).call(this,n(15))},function(e,t,n){var o=n(16);"string"==typeof o&&(o=[[e.i,o,""]]);var r={insert:"head",singleton:!1};n(18)(o,r);o.locals&&(e.exports=o.locals)},function(e,t,n){var o=n(8),r=o&&n(9),i=n(13),a={media:function(e,t){e=i(e),"function"==typeof t&&(t={match:t}),o&&r.register(e,t),this._responsiveMediaHandlers||(this._responsiveMediaHandlers=[]),this._responsiveMediaHandlers.push({query:e,handler:t})},componentWillUnmount:function(){this._responsiveMediaHandlers&&this._responsiveMediaHandlers.forEach(function(e){o&&r.unregister(e.query,e.handler)})}};e.exports=a},function(e,t){e.exports={isFunction:function(e){return"function"==typeof e},isArray:function(e){return"[object Array]"===Object.prototype.toString.apply(e)},each:function(e,t){for(var n=0,o=e.length;n<o&&!1!==t(e[n],n);n++);}}},function(e,t,n){"use strict";var s=n(7);function o(){}function r(){}r.resetWarningCache=o,e.exports=function(){function e(e,t,n,o,r,i){if(i!==s){var a=new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");throw a.name="Invariant Violation",a}}function t(){return e}var n={array:e.isRequired=e,bool:e,func:e,number:e,object:e,string:e,symbol:e,any:e,arrayOf:t,element:e,elementType:e,instanceOf:t,node:e,objectOf:t,oneOf:t,oneOfType:t,shape:t,exact:t,checkPropTypes:r,resetWarningCache:o};return n.PropTypes=n}},function(e,t,n){"use strict";e.exports="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED"},function(e,t){var n=!("undefined"==typeof window||!window.document||!window.document.createElement);e.exports=n},function(e,t,n){var o=n(10);e.exports=new o},function(e,t,n){var i=n(11),o=n(5),a=o.each,s=o.isFunction,c=o.isArray;function r(){if(!window.matchMedia)throw new Error("matchMedia not present, legacy browsers require a polyfill");this.queries={},this.browserIsIncapable=!window.matchMedia("only all").matches}r.prototype={constructor:r,register:function(t,e,n){var o=this.queries,r=n&&this.browserIsIncapable;return o[t]||(o[t]=new i(t,r)),s(e)&&(e={match:e}),c(e)||(e=[e]),a(e,function(e){s(e)&&(e={match:e}),o[t].addHandler(e)}),this},unregister:function(e,t){var n=this.queries[e];return n&&(t?n.removeHandler(t):(n.clear(),delete this.queries[e])),this}},e.exports=r},function(e,t,n){var o=n(12),r=n(5).each;function i(e,t){this.query=e,this.isUnconditional=t,this.handlers=[],this.mql=window.matchMedia(e);var n=this;this.listener=function(e){n.mql=e.currentTarget||e,n.assess()},this.mql.addListener(this.listener)}i.prototype={constuctor:i,addHandler:function(e){var t=new o(e);this.handlers.push(t),this.matches()&&t.on()},removeHandler:function(n){var o=this.handlers;r(o,function(e,t){if(e.equals(n))return e.destroy(),!o.splice(t,1)})},matches:function(){return this.mql.matches||this.isUnconditional},clear:function(){r(this.handlers,function(e){e.destroy()}),this.mql.removeListener(this.listener),this.handlers.length=0},assess:function(){var t=this.matches()?"on":"off";r(this.handlers,function(e){e[t]()})}},e.exports=i},function(e,t){function n(e){(this.options=e).deferSetup||this.setup()}n.prototype={constructor:n,setup:function(){this.options.setup&&this.options.setup(),this.initialised=!0},on:function(){this.initialised||this.setup(),this.options.match&&this.options.match()},off:function(){this.options.unmatch&&this.options.unmatch()},destroy:function(){this.options.destroy?this.options.destroy():this.off()},equals:function(e){return this.options===e||this.options.match===e}},e.exports=n},function(e,t,n){function r(o){var r="",i=Object.keys(o);return i.forEach(function(e,t){var n=o[e];!function(e){return/[height|width]$/.test(e)}(e=a(e))||"number"!=typeof n||(n+="px"),r+=!0===n?e:!1===n?"not "+e:"("+e+": "+n+")",t<i.length-1&&(r+=" and ")}),r}var a=n(14);e.exports=function(n){var o="";return"string"==typeof n?n:n instanceof Array?(n.forEach(function(e,t){o+=r(e),t<n.length-1&&(o+=", ")}),o):r(n)}},function(e,t){e.exports=function(e){return e.replace(/[A-Z]/g,function(e){return"-"+e.toLowerCase()}).toLowerCase()}},function(e,t){var n,o,r=e.exports={};function i(){throw new Error("setTimeout has not been defined")}function a(){throw new Error("clearTimeout has not been defined")}function s(t){if(n===setTimeout)return setTimeout(t,0);if((n===i||!n)&&setTimeout)return n=setTimeout,setTimeout(t,0);try{return n(t,0)}catch(e){try{return n.call(null,t,0)}catch(e){return n.call(this,t,0)}}}!function(){try{n="function"==typeof setTimeout?setTimeout:i}catch(e){n=i}try{o="function"==typeof clearTimeout?clearTimeout:a}catch(e){o=a}}();var c,l=[],u=!1,d=-1;function f(){u&&c&&(u=!1,c.length?l=c.concat(l):d=-1,l.length&&p())}function p(){if(!u){var e=s(f);u=!0;for(var t=l.length;t;){for(c=l,l=[];++d<t;)c&&c[d].run();d=-1,t=l.length}c=null,u=!1,function(t){if(o===clearTimeout)return clearTimeout(t);if((o===a||!o)&&clearTimeout)return o=clearTimeout,clearTimeout(t);try{o(t)}catch(e){try{return o.call(null,t)}catch(e){return o.call(this,t)}}}(e)}}function h(e,t){this.fun=e,this.array=t}function g(){}r.nextTick=function(e){var t=new Array(arguments.length-1);if(1<arguments.length)for(var n=1;n<arguments.length;n++)t[n-1]=arguments[n];l.push(new h(e,t)),1!==l.length||u||s(p)},h.prototype.run=function(){this.fun.apply(null,this.array)},r.title="browser",r.browser=!0,r.env={},r.argv=[],r.version="",r.versions={},r.on=g,r.addListener=g,r.once=g,r.off=g,r.removeListener=g,r.removeAllListeners=g,r.emit=g,r.prependListener=g,r.prependOnceListener=g,r.listeners=function(e){return[]},r.binding=function(e){throw new Error("process.binding is not supported")},r.cwd=function(){return"/"},r.chdir=function(e){throw new Error("process.chdir is not supported")},r.umask=function(){return 0}},function(e,t,n){(e.exports=n(17)(!1)).push([e.i,".InfiniteCarousel {\n  position: relative;\n}\n\n.InfiniteCarouselFrame {\n  width: 100%;\n  overflow: hidden;\n}\n\n.InfiniteCarouselScrollTrack {\n  overflow-x: scroll;\n  overflow-y: hidden;\n  white-space: nowrap;\n  -webkit-overflow-scrolling: touch;\n  overflow: -moz-scrollbars-none;\n  -webkit-box-sizing: border-box;\n}\n\n.InfiniteCarouselScrollTrack::-webkit-scrollbar {\n  display: none;\n}\n\n.InfiniteCarouselSlide img {\n  width: 100%;\n}\n\n.InfiniteCarouselPaging {\n  position: absolute;\n  left: 50%;\n  bottom: -60px;\n  padding: 0;\n  transform: translateX(-20%);\n  font-family: Arial;\n  letter-spacing: 2px;\n  color: #888;\n}\n\n.InfiniteCarouselDots {\n  position: absolute;\n  left: 50%;\n  bottom: 0;\n  padding: 0;\n  transform: translateX(-50%);\n}\n\n.InfiniteCarouselDot {\n  display: inline-block;\n  list-style: none;\n  margin: 0 5px;\n  border: 0;\n  background: none;\n  cursor: pointer;\n}\n\n.InfiniteCarouselDotIcon {\n  display: block;\n  background-color: #e5e5e5;\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n}\n\n.InfiniteCarouselDotActiveIcon {\n  background-color: #48799a;\n}\n\n.InfiniteCarouselArrow {\n  display: block;\n  background: none;\n  border: none;\n  position: absolute;\n  top: 50%;\n  z-index: 2;\n  outline: none;\n  transform: translateY(-50%);\n  cursor: pointer;\n}\n\n.InfiniteCarouselArrowPrev {\n  left: 15px;\n  right: auto;\n}\n\n.InfiniteCarouselArrowNext {\n  left: auto;\n  right: 15px;\n}\n\n.InfiniteCarouselArrowIcon {\n  display: inline-block;\n  padding: 10px;\n  border: solid #e5e5e5;\n  border-width: 0 5px 5px 0;\n}\n\n.InfiniteCarouselArrowNextIcon {\n  transform: rotate(-45deg);\n}\n\n.InfiniteCarouselArrowPrevIcon {\n  transform: rotate(135deg);\n}\n",""])},function(e,t,n){"use strict";e.exports=function(n){var s=[];return s.toString=function(){return this.map(function(e){var t=function(e,t){var n=e[1]||"",o=e[3];if(!o)return n;if(t&&"function"==typeof btoa){var r=function(e){var t=btoa(unescape(encodeURIComponent(JSON.stringify(e)))),n="sourceMappingURL=data:application/json;charset=utf-8;base64,".concat(t);return"/*# ".concat(n," */")}(o),i=o.sources.map(function(e){return"/*# sourceURL=".concat(o.sourceRoot).concat(e," */")});return[n].concat(i).concat([r]).join("\n")}return[n].join("\n")}(e,n);return e[2]?"@media ".concat(e[2],"{").concat(t,"}"):t}).join("")},s.i=function(e,t){"string"==typeof e&&(e=[[null,e,""]]);for(var n={},o=0;o<this.length;o++){var r=this[o][0];null!=r&&(n[r]=!0)}for(var i=0;i<e.length;i++){var a=e[i];null!=a[0]&&n[a[0]]||(t&&!a[2]?a[2]=t:t&&(a[2]="(".concat(a[2],") and (").concat(t,")")),s.push(a))}},s}},function(e,t,r){"use strict";var n,o,u={},i=function(){return void 0===n&&(n=Boolean(window&&document&&document.all&&!window.atob)),n},a=(o={},function(e){if(void 0===o[e]){var t=document.querySelector(e);if(window.HTMLIFrameElement&&t instanceof window.HTMLIFrameElement)try{t=t.contentDocument.head}catch(e){t=null}o[e]=t}return o[e]});function d(e,t){for(var n=[],o={},r=0;r<e.length;r++){var i=e[r],a=t.base?i[0]+t.base:i[0],s={css:i[1],media:i[2],sourceMap:i[3]};o[a]?o[a].parts.push(s):n.push(o[a]={id:a,parts:[s]})}return n}function f(e,t){for(var n=0;n<e.length;n++){var o=e[n],r=u[o.id],i=0;if(r){for(r.refs++;i<r.parts.length;i++)r.parts[i](o.parts[i]);for(;i<o.parts.length;i++)r.parts.push(v(o.parts[i],t))}else{for(var a=[];i<o.parts.length;i++)a.push(v(o.parts[i],t));u[o.id]={id:o.id,refs:1,parts:a}}}}function s(t){var n=document.createElement("style");if(void 0===t.attributes.nonce){var e=r.nc;e&&(t.attributes.nonce=e)}if(Object.keys(t.attributes).forEach(function(e){n.setAttribute(e,t.attributes[e])}),"function"==typeof t.insert)t.insert(n);else{var o=a(t.insert||"head");if(!o)throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");o.appendChild(n)}return n}var c,l=(c=[],function(e,t){return c[e]=t,c.filter(Boolean).join("\n")});function p(e,t,n,o){var r=n?"":o.css;if(e.styleSheet)e.styleSheet.cssText=l(t,r);else{var i=document.createTextNode(r),a=e.childNodes;a[t]&&e.removeChild(a[t]),a.length?e.insertBefore(i,a[t]):e.appendChild(i)}}var h=null,g=0;function v(t,e){var n,o,r;if(e.singleton){var i=g++;n=h=h||s(e),o=p.bind(null,n,i,!1),r=p.bind(null,n,i,!0)}else n=s(e),o=function(e,t,n){var o=n.css,r=n.media,i=n.sourceMap;if(r&&e.setAttribute("media",r),i&&btoa&&(o+="\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(i))))," */")),e.styleSheet)e.styleSheet.cssText=o;else{for(;e.firstChild;)e.removeChild(e.firstChild);e.appendChild(document.createTextNode(o))}}.bind(null,n,e),r=function(){!function(e){if(null===e.parentNode)return;e.parentNode.removeChild(e)}(n)};return o(t),function(e){if(e){if(e.css===t.css&&e.media===t.media&&e.sourceMap===t.sourceMap)return;o(t=e)}else r()}}e.exports=function(e,c){(c=c||{}).attributes="object"==typeof c.attributes?c.attributes:{},c.singleton||"boolean"==typeof c.singleton||(c.singleton=i());var l=d(e,c);return f(l,c),function(e){for(var t=[],n=0;n<l.length;n++){var o=l[n],r=u[o.id];r&&(r.refs--,t.push(r))}e&&f(d(e,c),c);for(var i=0;i<t.length;i++){var a=t[i];if(0===a.refs){for(var s=0;s<a.parts.length;s++)a.parts[s]();delete u[a.id]}}}}},function(e,t,n){"use strict";n.r(t);var C=n(1),x=n.n(C),o=n(0),r=n.n(o),d=n(4),i=n(2),f=n.n(i);function O(){return"ontouchstart"in document.documentElement}function a(e,t){return e-t}n(3);function s(e){var t,n=e.carouselName,o=e.next,r=e.onClick;t=o?"InfiniteCarouselArrowNext":"InfiniteCarouselArrowPrev";var i;i=o?"InfiniteCarouselArrowNextIcon":"InfiniteCarouselArrowPrevIcon";var a="".concat("InfiniteCarouselArrow"," ").concat(t),s="".concat("InfiniteCarouselArrowIcon"," ").concat(i),c="".concat(n,"-button-").concat(o?"next":"previous");return x.a.createElement("button",{name:c,"data-testid":c,className:a,onClick:r,type:"button"},x.a.createElement("i",{className:s}))}s.propTypes={carouselName:r.a.string.isRequired,next:r.a.bool,onClick:r.a.func.isRequired},s.defaultProps={next:!0};var I=s;function c(e){for(var t,n,o=e.carouselName,r=e.numberOfDots,i=e.activePage,a=e.onClick,s=[],c=0;c<r;c+=1)t="InfiniteCarouselDotIcon ".concat(c===i?"InfiniteCarouselDotActiveIcon":""),n="".concat(o,"-dots-").concat(c),s.push(x.a.createElement("button",{name:n,"data-testid":n,className:"InfiniteCarouselDot","data-index":c,key:c+1,onClick:a,type:"button"},x.a.createElement("i",{className:t})));return x.a.createElement("ul",{"data-testid":"".concat(o,"-dots"),className:"InfiniteCarouselDots"},s)}c.propTypes={carouselName:r.a.string.isRequired,numberOfDots:r.a.number.isRequired,activePage:r.a.number.isRequired,onClick:r.a.func.isRequired};var k=c;function l(e){return(l="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function u(e){return function(e){if(Array.isArray(e)){for(var t=0,n=new Array(e.length);t<e.length;t++)n[t]=e[t];return n}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}function p(t,e){var n=Object.keys(t);if(Object.getOwnPropertySymbols){var o=Object.getOwnPropertySymbols(t);e&&(o=o.filter(function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable})),n.push.apply(n,o)}return n}function E(t){for(var e=1;e<arguments.length;e++){var n=null!=arguments[e]?arguments[e]:{};e%2?p(Object(n),!0).forEach(function(e){h(t,e,n[e])}):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(n)):p(Object(n)).forEach(function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(n,e))})}return t}function h(e,t,n){return t in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}function g(e,t){for(var n=0;n<t.length;n++){var o=t[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(e,o.key,o)}}function v(e,t){return!t||"object"!==l(t)&&"function"!=typeof t?function(e){if(void 0!==e)return e;throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}(e):t}function m(e){return(m=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}function y(e,t){return(y=Object.setPrototypeOf||function(e,t){return e.__proto__=t,e})(e,t)}var b=function(){function t(e){var S;return function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,t),(S=v(this,m(t).call(this,e))).setupBreakpointSettings=function(){var e=S.props,s=e.children,c=e.scrollOnDevice,t=e.breakpoints,l=S.state.scrollOnDeviceProps,n=t.map(function(e){return e.breakpoint}),u={};if(t.forEach(function(e){u[e.breakpoint]=e.settings}),0<n.length){n.sort(a),n.forEach(function(r,e){var i,a;a=(i=0===e?0:n[e-1],r-1);var t={minWidth:i,maxWidth:a};Object(d.media)(t,function(){var e=c&&O()?l:{},t=E({},S.defaultProps,{},S.props,{},u[r],{},e),n=S.getChildrenList(s,t.slidesToShow),o=n.map(function(e){return f()("slide-")});S.setState({settings:t,children:n,slideUniqueIds:o,lowerBreakpoint:i,higherBreakpoint:a},S.setDimensions)})}),n.reverse();var o={minWidth:n[0]};Object(d.media)(o,function(){var e=c&&O()?l:{},t=E({},S.defaultProps,{},S.props,{},e),n=S.getChildrenList(s,t.slidesToShow),o=n.map(function(e){return f()("slide-")});S.setState({settings:t,children:n,slideUniqueIds:o,lowerBreakpoint:void 0,higherBreakpoint:void 0},S.setDimensions)})}},S.getSideSize=function(e,t,n){var o=S.state.settings,r=o.incrementalSides,i=o.sideSize;return void 0!==e&&void 0!==t&&r?50*(n-e)/(t-e)/100:i},S.setDimensions=function(){var e,t,n=S.state,o=n.settings,r=n.lowerBreakpoint,i=n.higherBreakpoint,a=n.children,s=n.currentIndex,c=S.props,l=c.children,u=c.scrollOnDevice&&O(),d=window.innerWidth||document.documentElement.clientWidth||document.body.clientWidth,f=S.getSideSize(r,i,d),p=C.Children.count(l),h=u?p:C.Children.count(a),g=function(e){return e.getBoundingClientRect().width||e.offsetWidth||0}(S.frame)/(S.props.showSides?o.slidesToShow+2*f:o.slidesToShow)-2*o.slidesSpacing,v=l.length,m=Math.ceil(s/o.slidesToShow),y=Math.ceil(v/o.slidesToShow),b=v>o.slidesToShow?y:1,w=b<=1;t=w||u?(e=a.map(function(e,t){return t}),[].concat(e)):(e=S.getLazyLoadedIndexes(l,s),S.getVisibleIndexes(l,s)),S.setState({activePage:m,childrenCount:p,slidesCount:h,slidesWidth:g,slidePages:b,singlePage:w,lazyLoadedList:e,visibleSlideList:t,sideSize:f},function(){S.playAutoCycle()})},S.getVisibleIndexes=function(e,t){var n,o,r=[],i=S.state.settings,a=i.showSides?1:0;if(n=e.length+i.slidesToShow+a,0===t){o=n+i.slidesToShow-1;for(var s=n;s<=o;s+=1)r.push(s)}if(n=0+a,t===e.length-i.slidesToShow){o=n+i.slidesToShow-1;for(var c=n;c<=o;c+=1)r.push(c)}o=(n=t+i.slidesToShow+a)+(i.slidesToShow-1);for(var l=n;l<=o;l+=1)r.push(l);return r},S.getLazyLoadedIndexes=function(e,t){var n,o,r=S.state.lazyLoadedList,i=S.state.settings,a=i.showSides?1:0,s=[].concat(r);if(n=e.length+i.slidesToShow+a,0===t&&r.indexOf(n)<0){o=n+i.slidesToShow+a-1;for(var c=n;c<=o;c+=1)s.push(c)}n=0;var l=t===e.length-i.slidesToShow,u=s.indexOf(n)<0;if(l&&u){o=n+i.slidesToShow+a-1;for(var d=n;d<=o;d+=1)s.push(d)}o=(n=t+i.slidesToShow+a)+(i.slidesToShow-1),i.showSides&&(n-=1,o+=1);for(var f=n;f<=o;f+=1)r.indexOf(f)<0&&s.push(f);return s},S.getChildrenList=function(e,t){var n=S.props,o=n.scrollOnDevice,r=n.showSides;return Array.isArray(e)?o&&O()?e:e.length>t&&r?[].concat(u(e.slice(e.length-t-1,e.length)),u(e),u(e.slice(0,t+1))):e.length>t?[].concat(u(e.slice(e.length-t,e.length)),u(e),u(e.slice(0,t))):e:[e]},S.getTargetIndex=function(e,t){var n=S.state,o=n.childrenCount,r=n.currentIndex,i=o%t;return e<0?0===r?o-t:0:o<=e?0!=i?0:e-o:0!=i&&e===o-i?e-(t-i):e},S.onDotClick=function(e){e.preventDefault();var t=S.state,n=t.settings,o=t.animating,r=t.autoCycleTimer,i=n.slidesToShow,a=n.autoCycle;if(!o){a&&r&&(clearInterval(r),S.setState({autoCycleTimer:null}));var s=e.target.parentElement.getAttribute("data-index"),c=S.getTargetIndex(s*i,i);S.handleTrack(s*i,c),n.autoCycle&&S.playAutoCycle()}},S.onWindowResized=function(){S.setDimensions()},S.onMouseEnter=function(){var e=S.state.settings,t=e.autoCycle,n=e.pauseOnHover;t&&n&&S.pauseAutoCycle()},S.onMouseOver=function(){var e=S.state.settings,t=e.autoCycle,n=e.pauseOnHover;t&&n&&S.pauseAutoCycle()},S.onMouseLeave=function(){var e=S.state.settings,t=e.autoCycle,n=e.pauseOnHover;t&&n&&S.playAutoCycle()},S.onSwipeStart=function(e){var t=S.state.settings,n=t.swipe,o=t.draggable;if(!1===n||"ontouchend"in document&&!1===n)return null;if(!1===o&&-1!==e.type.indexOf("mouse"))return null;var r=void 0!==e.touches?e.touches[0].pageX:e.clientX,i=void 0!==e.touches?e.touches[0].pageY:e.clientY;return S.setState({dragging:!0,touchObject:{startX:r,startY:i}}),!0},S.onSwipeMove=function(e){var t=S.state,n=t.dragging,o=t.animating;if(n){if(!o){var r=void 0!==e.touches?e.touches[0].pageX:e.clientX,i=void 0!==e.touches?e.touches[0].pageY:e.clientY,a=S.state.touchObject,s=function(e,t,n,o){var r=e-t,i=n-o,a=Math.round(180*Math.atan2(i,r)/Math.PI);return a<0&&(a=360-Math.abs(a)),a<=45&&0<=a?1:a<=360&&315<=a?1:135<=a&&a<=225?-1:0}(a.startX,r,a.startY,i);0!==s&&e.preventDefault();var c=Math.round(Math.sqrt(Math.pow(r-a.startX,2)));S.setState({touchObject:{startX:a.startX,startY:a.startY,endX:r,endY:i,length:c,direction:s}})}}else e.preventDefault()},S.onSwipeEnd=function(){var e=S.state,t=e.touchObject,n=e.slidesWidth,o=e.autoCycleTimer,r=e.settings,i=e.currentIndex,a=t.length;if(0!==a&&n/2<a){var s,c;r.autoCycle&&o&&(clearInterval(o),S.setState({autoCycleTimer:null})),1===t.direction?(s=i+r.slidesToScroll,c=S.getTargetIndex(s,r.slidesToScroll)):(s=i-r.slidesToScroll,c=S.getTargetIndex(s,r.slidesToScroll),s<0&&0!==i&&(s=0)),S.handleTrack(s,c),r.autoCycle&&S.playAutoCycle()}else{S.setState({animating:!0,touchObject:{direction:-1*t.direction}},function(){setTimeout(function(){S.setState({animating:!1,dragging:!1,touchObject:{startX:0,startY:0,endX:0,endY:0,length:0,direction:-1}})},r.animationDuration)})}},S.getTrackStyles=function(){var e=S.state.settings,t=S.state,n=t.touchObject,o=t.singlePage,r=t.sideSize,i=t.animating,a=t.slidesWidth,s=t.slidesCount,c=t.currentIndex,l=a+2*e.slidesSpacing;l*=s+2*e.slidesToShow;var u=a+2*e.slidesSpacing,d=e.showSides?1:0,f=u*(e.slidesToShow+d),p=i?"transform ".concat(e.animationDuration,"ms ease"):"",h=f+u*c+(e.swipe&&n.length?n.length*n.direction:0),g=u*r;return e.showSides&&(h-=g),{position:"relative",display:"block",width:o?"100%":l,height:"auto",padding:0,transition:p,transform:o?"none":"translate(".concat(-h,"px, 0px)"),boxSizing:"border-box",MozBoxSizing:"border-box",marginLeft:o&&e.showSides?"".concat(g,"px"):"0px"}},S.getScrollTrackStyles={clear:"both",position:"relative",display:"block",width:"100%",height:"auto",padding:0,boxSizing:"border-box",MozBoxSizing:"border-box"},S.getSlideStyles=function(e){var t=S.state,n=t.slidesWidth,o=t.settings,r=S.props.scrollOnDevice&&O()?"none":"left",i=e?"1":o.sidesOpacity;return{position:"relative",float:r,display:"inline-block",width:Number.isNaN(n)?1:n,height:"auto",margin:"0 ".concat(o.slidesSpacing,"px"),opacity:i}},S.getFormatedChildren=function(e,a,s){return C.Children.map(e,function(e,t){var n=S.state,o=n.settings,r=n.slideUniqueIds,i=0<=s.indexOf(t);return!o.lazyLoad||0<=a.indexOf(t)?x.a.createElement("li",{className:"InfiniteCarouselSlide",key:r[t],style:S.getSlideStyles(i)},e):x.a.createElement("li",{className:"InfiniteCarouselSlide",key:r[t],style:S.getSlideStyles(i)},x.a.createElement("noscript",null,e),x.a.createElement("img",{alt:"placeholder",src:o.placeholderImageSrc}))})},S.autoCycle=function(){var e=S.state,t=e.settings,n=e.currentIndex+t.slidesToScroll,o=S.getTargetIndex(n,t.slidesToScroll);S.handleTrack(n,o)},S.playAutoCycle=function(){var e=S.state.settings;if(e.autoCycle){var t=setInterval(S.autoCycle,e.cycleInterval);S.setState({autoCycleTimer:t})}},S.pauseAutoCycle=function(){var e=S.state.autoCycleTimer;e&&(clearInterval(e),S.setState({autoCycleTimer:null}))},S.handleTrack=function(e,t){function n(){setTimeout(function(){S.setState({currentIndex:t,animating:!1,dragging:!1})},a.animationDuration)}var o=S.props,r=o.children,i=o.onSlideChange,a=S.state.settings,s=Math.ceil(t/a.slidesToShow),c=S.getLazyLoadedIndexes(r,t),l=S.getVisibleIndexes(r,t);e<0?S.setState({currentIndex:e,activePage:s,animating:!0,lazyLoadedList:c,visibleSlideList:l,touchObject:{startX:0,startY:0,endX:0,endY:0,length:0,direction:-1}},n):e>=r.length?S.setState({currentIndex:e,activePage:s,animating:!0,lazyLoadedList:c,visibleSlideList:l,touchObject:{startX:0,startY:0,endX:0,endY:0,length:0,direction:-1}},n):S.setState({currentIndex:t,activePage:s,animating:!0,lazyLoadedList:c,visibleSlideList:l,dragging:!1,touchObject:{startX:0,startY:0,endX:0,endY:0,length:0,direction:-1}},function(){setTimeout(function(){S.setState({animating:!1,dragging:!1})},a.animationDuration)}),i&&i(s)},S.moveToNext=function(e){var t=S.props.onNextClick,n=S.state,o=n.animating,r=n.settings,i=n.currentIndex,a=n.autoCycleTimer;if(e.preventDefault(),t&&t(e),!o){r.autoCycle&&a&&(clearInterval(a),S.setState({autoCycleTimer:null}));var s=i+r.slidesToScroll,c=S.getTargetIndex(s,r.slidesToScroll);S.handleTrack(s,c),r.autoCycle&&S.playAutoCycle()}},S.moveToPrevious=function(e){var t=S.props.onPreviousClick,n=S.state,o=n.animating,r=n.settings,i=n.currentIndex,a=n.autoCycleTimer;if(e.preventDefault(),t&&t(e),!o){r.autoCycle&&a&&(clearInterval(a),S.setState({autoCycleTimer:null}));var s=i-r.slidesToScroll,c=S.getTargetIndex(s,r.slidesToScroll);s<0&&0!==i&&(s=0),S.handleTrack(s,c),r.autoCycle&&S.playAutoCycle()}},S.getSettingsForScrollOnDevice=function(){var e=S.props.scrollOnDevice,t=S.state.scrollOnDeviceProps;return e&&O()?E({},S.defaultProps,{},S.props,{},t):E({},S.defaultProps,{},S.props)},S.init=function(){if(0<S.props.breakpoints.length)S.setupBreakpointSettings();else{var e=S.props.children,t=S.getSettingsForScrollOnDevice(),n=t.slidesToShow,o=S.getChildrenList(e,n),r=o.map(function(e){return f()("slide-")});S.setState({children:o,slideUniqueIds:r,settings:t},function(){S.setDimensions()})}},S.storeFrameRef=function(e){null!==e&&(S.frame=e)},S.state={currentIndex:0,activePage:0,children:[],lazyLoadedList:[],visibleSlideList:[],childrenCount:0,slidesCount:0,slidesWidth:1,slidePages:1,singlePage:!0,settings:{},autoCycleTimer:null,dragging:!1,touchObject:{startX:0,startY:0,endX:0,endY:0,length:0,direction:-1},scrollOnDeviceProps:{arrows:!1,dots:!1,lazyLoad:!1,autoCycle:!1},lowerBreakpoint:void 0,higherBreakpoint:void 0,slideUniqueIds:[]},S}return function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),t&&y(e,t)}(t,C["Component"]),function(e,t,n){t&&g(e.prototype,t),n&&g(e,n)}(t,[{key:"componentDidMount",value:function(){this.init(),window&&(window.addEventListener?window.addEventListener("resize",this.onWindowResized):window.attachEvent("onresize",this.onWindowResized))}},{key:"componentWillUnmount",value:function(){window.addEventListener?window.removeEventListener("resize",this.onWindowResized):window.detachEvent("onresize",this.onWindowResized);var e=this.state.autoCycleTimer;e&&clearInterval(e)}},{key:"render",value:function(){var e,t,n,o=this.props,r=o.scrollOnDevice,i=o.pagingSeparator,a=o.name,s=r&&O(),c=this.state,l=c.settings,u=c.singlePage,d=c.activePage,f=c.slidePages,p=c.dragging;if(l.arrows&&!u&&!s){if(null==l.prevArrow)e=x.a.createElement(I,{carouselName:a,next:!1,onClick:this.moveToPrevious});else{var h={onClick:this.moveToPrevious};e=x.a.cloneElement(l.prevArrow,h)}if(null==l.nextArrow)t=x.a.createElement(I,{carouselName:a,onClick:this.moveToNext});else{var g={onClick:this.moveToNext};t=x.a.cloneElement(l.nextArrow,g)}}!l.dots||u||s||(n=x.a.createElement(k,{carouselName:a,activePage:d,numberOfDots:f,onClick:this.onDotClick})),!l.paging||u||s||(n=x.a.createElement("span",{"data-testid":"".concat(a,"-paging"),className:"InfiniteCarouselPaging"},"".concat(d+1," ").concat(i," ").concat(f)));var v,m,y=this.state,b=y.children,w=y.lazyLoadedList,S=y.visibleSlideList,C=this.getFormatedChildren(b,w,S);m=r&&O()?(v=E({},this.getScrollTrackStyles),"InfiniteCarouselScrollTrack"):(v=E({},this.getTrackStyles()),"");var T=r&&O();return x.a.createElement("div",{id:a,"data-testid":a,className:"InfiniteCarousel",onFocus:this.onMouseOver,onMouseEnter:this.onMouseEnter,onMouseLeave:this.onMouseLeave,onMouseOver:this.onMouseOver},e,x.a.createElement("div",{className:"InfiniteCarouselFrame",ref:this.storeFrameRef},x.a.createElement("ul",{className:m,style:v,onMouseDown:T?null:this.onSwipeStart,onMouseLeave:p&&!T?this.onSwipeEnd:null,onMouseMove:p&&!T?this.onSwipeMove:null,onMouseUp:T?null:this.onSwipeEnd,onTouchCancel:p&&!T?this.onSwipeEnd:null,onTouchEnd:T?null:this.onSwipeEnd,onTouchMove:p&&!T?this.onSwipeMove:null,onTouchStart:T?null:this.onSwipeStart},C)),t,n)}}]),t}();b.propTypes={children:r.a.oneOfType([r.a.arrayOf(r.a.node),r.a.node]),name:r.a.string,arrows:r.a.bool,dots:r.a.bool,paging:r.a.bool,pagingSeparator:r.a.string,lazyLoad:r.a.bool,swipe:r.a.bool,draggable:r.a.bool,animationDuration:r.a.number,slidesToShow:r.a.number,slidesToScroll:r.a.number,slidesSpacing:r.a.number,autoCycle:r.a.bool,cycleInterval:r.a.number,pauseOnHover:r.a.bool,breakpoints:r.a.arrayOf(r.a.object),placeholderImageSrc:r.a.string,nextArrow:r.a.element,prevArrow:r.a.element,scrollOnDevice:r.a.bool,showSides:r.a.bool,sidesOpacity:r.a.number,sideSize:r.a.number,incrementalSides:r.a.bool,onSlideChange:r.a.func,onNextClick:r.a.func,onPreviousClick:r.a.func},b.defaultProps={children:[],name:"infinite-carousel",arrows:!0,dots:!1,paging:!1,lazyLoad:!1,swipe:!0,draggable:!1,animationDuration:500,slidesToShow:1,slidesToScroll:1,slidesSpacing:10,autoCycle:!1,cycleInterval:5e3,pauseOnHover:!0,breakpoints:[],placeholderImageSrc:"",pagingSeparator:"/",nextArrow:null,prevArrow:null,scrollOnDevice:!1,showSides:!1,sidesOpacity:1,sideSize:.5,incrementalSides:!1,onSlideChange:void 0,onNextClick:void 0,onPreviousClick:void 0};t.default=b}],r.c=i,r.d=function(e,t,n){r.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:n})},r.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},r.t=function(t,e){if(1&e&&(t=r(t)),8&e)return t;if(4&e&&"object"==typeof t&&t&&t.__esModule)return t;var n=Object.create(null);if(r.r(n),Object.defineProperty(n,"default",{enumerable:!0,value:t}),2&e&&"string"!=typeof t)for(var o in t)r.d(n,o,function(e){return t[e]}.bind(null,o));return n},r.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return r.d(t,"a",t),t},r.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},r.p="",r(r.s=19);function r(e){if(i[e])return i[e].exports;var t=i[e]={i:e,l:!1,exports:{}};return o[e].call(t.exports,t,t.exports,r),t.l=!0,t.exports}var o,i});

/***/ },
/* 1850 */
1843,
/* 1851 */
/***/ function(module, exports, __webpack_require__) {

	/** @license React v16.14.0
	 * react.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';var l=__webpack_require__(1850),n="function"===typeof Symbol&&Symbol.for,p=n?Symbol.for("react.element"):60103,q=n?Symbol.for("react.portal"):60106,r=n?Symbol.for("react.fragment"):60107,t=n?Symbol.for("react.strict_mode"):60108,u=n?Symbol.for("react.profiler"):60114,v=n?Symbol.for("react.provider"):60109,w=n?Symbol.for("react.context"):60110,x=n?Symbol.for("react.forward_ref"):60112,y=n?Symbol.for("react.suspense"):60113,z=n?Symbol.for("react.memo"):60115,A=n?Symbol.for("react.lazy"):
	60116,B="function"===typeof Symbol&&Symbol.iterator;function C(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}
	var D={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},E={};function F(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}F.prototype.isReactComponent={};F.prototype.setState=function(a,b){if("object"!==typeof a&&"function"!==typeof a&&null!=a)throw Error(C(85));this.updater.enqueueSetState(this,a,b,"setState")};F.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};
	function G(){}G.prototype=F.prototype;function H(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}var I=H.prototype=new G;I.constructor=H;l(I,F.prototype);I.isPureReactComponent=!0;var J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
	function M(a,b,c){var e,d={},g=null,k=null;if(null!=b)for(e in void 0!==b.ref&&(k=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,e)&&!L.hasOwnProperty(e)&&(d[e]=b[e]);var f=arguments.length-2;if(1===f)d.children=c;else if(1<f){for(var h=Array(f),m=0;m<f;m++)h[m]=arguments[m+2];d.children=h}if(a&&a.defaultProps)for(e in f=a.defaultProps,f)void 0===d[e]&&(d[e]=f[e]);return{$$typeof:p,type:a,key:g,ref:k,props:d,_owner:J.current}}
	function N(a,b){return{$$typeof:p,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function O(a){return"object"===typeof a&&null!==a&&a.$$typeof===p}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var P=/\/+/g,Q=[];function R(a,b,c,e){if(Q.length){var d=Q.pop();d.result=a;d.keyPrefix=b;d.func=c;d.context=e;d.count=0;return d}return{result:a,keyPrefix:b,func:c,context:e,count:0}}
	function S(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>Q.length&&Q.push(a)}
	function T(a,b,c,e){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case p:case q:g=!0}}if(g)return c(e,a,""===b?"."+U(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var k=0;k<a.length;k++){d=a[k];var f=b+U(d,k);g+=T(d,f,c,e)}else if(null===a||"object"!==typeof a?f=null:(f=B&&a[B]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),k=
	0;!(d=a.next()).done;)d=d.value,f=b+U(d,k++),g+=T(d,f,c,e);else if("object"===d)throw c=""+a,Error(C(31,"[object Object]"===c?"object with keys {"+Object.keys(a).join(", ")+"}":c,""));return g}function V(a,b,c){return null==a?0:T(a,"",b,c)}function U(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function W(a,b){a.func.call(a.context,b,a.count++)}
	function aa(a,b,c){var e=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?X(a,e,c,function(a){return a}):null!=a&&(O(a)&&(a=N(a,d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(P,"$&/")+"/")+c)),e.push(a))}function X(a,b,c,e,d){var g="";null!=c&&(g=(""+c).replace(P,"$&/")+"/");b=R(b,g,e,d);V(a,aa,b);S(b)}var Y={current:null};function Z(){var a=Y.current;if(null===a)throw Error(C(321));return a}
	var ba={ReactCurrentDispatcher:Y,ReactCurrentBatchConfig:{suspense:null},ReactCurrentOwner:J,IsSomeRendererActing:{current:!1},assign:l};exports.Children={map:function(a,b,c){if(null==a)return a;var e=[];X(a,e,null,b,c);return e},forEach:function(a,b,c){if(null==a)return a;b=R(null,null,b,c);V(a,W,b);S(b)},count:function(a){return V(a,function(){return null},null)},toArray:function(a){var b=[];X(a,b,null,function(a){return a});return b},only:function(a){if(!O(a))throw Error(C(143));return a}};
	exports.Component=F;exports.Fragment=r;exports.Profiler=u;exports.PureComponent=H;exports.StrictMode=t;exports.Suspense=y;exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=ba;
	exports.cloneElement=function(a,b,c){if(null===a||void 0===a)throw Error(C(267,a));var e=l({},a.props),d=a.key,g=a.ref,k=a._owner;if(null!=b){void 0!==b.ref&&(g=b.ref,k=J.current);void 0!==b.key&&(d=""+b.key);if(a.type&&a.type.defaultProps)var f=a.type.defaultProps;for(h in b)K.call(b,h)&&!L.hasOwnProperty(h)&&(e[h]=void 0===b[h]&&void 0!==f?f[h]:b[h])}var h=arguments.length-2;if(1===h)e.children=c;else if(1<h){f=Array(h);for(var m=0;m<h;m++)f[m]=arguments[m+2];e.children=f}return{$$typeof:p,type:a.type,
	key:d,ref:g,props:e,_owner:k}};exports.createContext=function(a,b){void 0===b&&(b=null);a={$$typeof:w,_calculateChangedBits:b,_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:v,_context:a};return a.Consumer=a};exports.createElement=M;exports.createFactory=function(a){var b=M.bind(null,a);b.type=a;return b};exports.createRef=function(){return{current:null}};exports.forwardRef=function(a){return{$$typeof:x,render:a}};exports.isValidElement=O;
	exports.lazy=function(a){return{$$typeof:A,_ctor:a,_status:-1,_result:null}};exports.memo=function(a,b){return{$$typeof:z,type:a,compare:void 0===b?null:b}};exports.useCallback=function(a,b){return Z().useCallback(a,b)};exports.useContext=function(a,b){return Z().useContext(a,b)};exports.useDebugValue=function(){};exports.useEffect=function(a,b){return Z().useEffect(a,b)};exports.useImperativeHandle=function(a,b,c){return Z().useImperativeHandle(a,b,c)};
	exports.useLayoutEffect=function(a,b){return Z().useLayoutEffect(a,b)};exports.useMemo=function(a,b){return Z().useMemo(a,b)};exports.useReducer=function(a,b,c){return Z().useReducer(a,b,c)};exports.useRef=function(a){return Z().useRef(a)};exports.useState=function(a){return Z().useState(a)};exports.version="16.14.0";


/***/ },
/* 1852 */
[2188, 1851],
/* 1853 */
/***/ function(module, exports, __webpack_require__) {

	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory();
		else if(typeof define === 'function' && define.amd)
			define([], factory);
		else if(typeof exports === 'object')
			exports["Loading"] = factory();
		else
			root["Loading"] = factory();
	})(typeof self !== 'undefined' ? self : this, function() {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, {
	/******/ 				configurable: false,
	/******/ 				enumerable: true,
	/******/ 				get: getter
	/******/ 			});
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "/";
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 7);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;
	
	/***/ }),
	/* 1 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;
	
	/***/ }),
	/* 2 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};
	
	
	/***/ }),
	/* 3 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	
	
	var emptyFunction = __webpack_require__(1);
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = emptyFunction;
	
	if (false) {
	  var printWarning = function printWarning(format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  warning = function warning(condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	
	    if (format.indexOf('Failed Composite propType: ') === 0) {
	      return; // Ignore CompositeComponent proptype check.
	    }
	
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	module.exports = warning;
	
	/***/ }),
	/* 4 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;
	
	
	/***/ }),
	/* 5 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	module.exports = emptyObject;
	
	/***/ }),
	/* 6 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	
	
	if (false) {
	  var invariant = __webpack_require__(0);
	  var warning = __webpack_require__(3);
	  var ReactPropTypesSecret = __webpack_require__(4);
	  var loggedTypeFailures = {};
	}
	
	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?Function} getStack Returns the component stack.
	 * @private
	 */
	function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
	  if (false) {
	    for (var typeSpecName in typeSpecs) {
	      if (typeSpecs.hasOwnProperty(typeSpecName)) {
	        var error;
	        // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          invariant(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'the `prop-types` package, but received `%s`.', componentName || 'React class', location, typeSpecName, typeof typeSpecs[typeSpecName]);
	          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
	        } catch (ex) {
	          error = ex;
	        }
	        warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);
	        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error.message] = true;
	
	          var stack = getStack ? getStack() : '';
	
	          warning(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
	        }
	      }
	    }
	  }
	}
	
	module.exports = checkPropTypes;
	
	
	/***/ }),
	/* 7 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(8);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(11);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _svg = __webpack_require__(14);
	
	var svgSources = _interopRequireWildcard(_svg);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Loading = function (_Component) {
	  _inherits(Loading, _Component);
	
	  function Loading() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Loading);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Loading.__proto__ || Object.getPrototypeOf(Loading)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      delayed: _this.props.delay > 0
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Loading, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var delay = this.props.delay;
	      var delayed = this.state.delayed;
	
	
	      if (delayed) {
	        this.timeout = setTimeout(function () {
	          _this2.setState({
	            delayed: false
	          });
	        }, delay);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var timeout = this.timeout;
	
	
	      if (timeout) {
	        clearTimeout(timeout);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          color = _props.color,
	          delay = _props.delay,
	          type = _props.type,
	          height = _props.height,
	          width = _props.width,
	          restProps = _objectWithoutProperties(_props, ['color', 'delay', 'type', 'height', 'width']);
	
	      var selectedType = this.state.delayed ? 'blank' : type;
	      var svg = svgSources[selectedType];
	      var style = {
	        fill: color,
	        height: height,
	        width: width
	      };
	
	      return _react2.default.createElement('div', _extends({
	        style: style,
	        dangerouslySetInnerHTML: { __html: svg }
	      }, restProps));
	    }
	  }]);
	
	  return Loading;
	}(_react.Component);
	
	Loading.propTypes = {
	  color: _propTypes2.default.string,
	  delay: _propTypes2.default.number,
	  type: _propTypes2.default.string,
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	Loading.defaultProps = {
	  color: '#fff',
	  delay: 0,
	  type: 'balls',
	  height: 64,
	  width: 64
	};
	exports.default = Loading;
	
	/***/ }),
	/* 8 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	if (true) {
	  module.exports = __webpack_require__(9);
	} else {
	  module.exports = __webpack_require__(10);
	}
	
	
	/***/ }),
	/* 9 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	/** @license React v16.3.2
	 * react.production.min.js
	 *
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	var m=__webpack_require__(2),n=__webpack_require__(0),p=__webpack_require__(5),q=__webpack_require__(1),r="function"===typeof Symbol&&Symbol["for"],t=r?Symbol["for"]("react.element"):60103,u=r?Symbol["for"]("react.portal"):60106,v=r?Symbol["for"]("react.fragment"):60107,w=r?Symbol["for"]("react.strict_mode"):60108,x=r?Symbol["for"]("react.provider"):60109,y=r?Symbol["for"]("react.context"):60110,z=r?Symbol["for"]("react.async_mode"):60111,A=r?Symbol["for"]("react.forward_ref"):
	60112,B="function"===typeof Symbol&&Symbol.iterator;function C(a){for(var b=arguments.length-1,e="http://reactjs.org/docs/error-decoder.html?invariant\x3d"+a,c=0;c<b;c++)e+="\x26args[]\x3d"+encodeURIComponent(arguments[c+1]);n(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",e)}var D={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}};
	function E(a,b,e){this.props=a;this.context=b;this.refs=p;this.updater=e||D}E.prototype.isReactComponent={};E.prototype.setState=function(a,b){"object"!==typeof a&&"function"!==typeof a&&null!=a?C("85"):void 0;this.updater.enqueueSetState(this,a,b,"setState")};E.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};function F(){}F.prototype=E.prototype;function G(a,b,e){this.props=a;this.context=b;this.refs=p;this.updater=e||D}var H=G.prototype=new F;
	H.constructor=G;m(H,E.prototype);H.isPureReactComponent=!0;var I={current:null},J=Object.prototype.hasOwnProperty,K={key:!0,ref:!0,__self:!0,__source:!0};
	function L(a,b,e){var c=void 0,d={},g=null,h=null;if(null!=b)for(c in void 0!==b.ref&&(h=b.ref),void 0!==b.key&&(g=""+b.key),b)J.call(b,c)&&!K.hasOwnProperty(c)&&(d[c]=b[c]);var f=arguments.length-2;if(1===f)d.children=e;else if(1<f){for(var k=Array(f),l=0;l<f;l++)k[l]=arguments[l+2];d.children=k}if(a&&a.defaultProps)for(c in f=a.defaultProps,f)void 0===d[c]&&(d[c]=f[c]);return{$$typeof:t,type:a,key:g,ref:h,props:d,_owner:I.current}}
	function M(a){return"object"===typeof a&&null!==a&&a.$$typeof===t}function escape(a){var b={"\x3d":"\x3d0",":":"\x3d2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var N=/\/+/g,O=[];function P(a,b,e,c){if(O.length){var d=O.pop();d.result=a;d.keyPrefix=b;d.func=e;d.context=c;d.count=0;return d}return{result:a,keyPrefix:b,func:e,context:c,count:0}}function Q(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>O.length&&O.push(a)}
	function R(a,b,e,c){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case t:case u:g=!0}}if(g)return e(c,a,""===b?"."+S(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var h=0;h<a.length;h++){d=a[h];var f=b+S(d,h);g+=R(d,f,e,c)}else if(null===a||"undefined"===typeof a?f=null:(f=B&&a[B]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),
	h=0;!(d=a.next()).done;)d=d.value,f=b+S(d,h++),g+=R(d,f,e,c);else"object"===d&&(e=""+a,C("31","[object Object]"===e?"object with keys {"+Object.keys(a).join(", ")+"}":e,""));return g}function S(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function T(a,b){a.func.call(a.context,b,a.count++)}
	function U(a,b,e){var c=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?V(a,c,e,q.thatReturnsArgument):null!=a&&(M(a)&&(b=d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(N,"$\x26/")+"/")+e,a={$$typeof:t,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}),c.push(a))}function V(a,b,e,c,d){var g="";null!=e&&(g=(""+e).replace(N,"$\x26/")+"/");b=P(b,g,c,d);null==a||R(a,"",U,b);Q(b)}
	var W={Children:{map:function(a,b,e){if(null==a)return a;var c=[];V(a,c,null,b,e);return c},forEach:function(a,b,e){if(null==a)return a;b=P(null,null,b,e);null==a||R(a,"",T,b);Q(b)},count:function(a){return null==a?0:R(a,"",q.thatReturnsNull,null)},toArray:function(a){var b=[];V(a,b,null,q.thatReturnsArgument);return b},only:function(a){M(a)?void 0:C("143");return a}},createRef:function(){return{current:null}},Component:E,PureComponent:G,createContext:function(a,b){void 0===b&&(b=null);a={$$typeof:y,
	_calculateChangedBits:b,_defaultValue:a,_currentValue:a,_changedBits:0,Provider:null,Consumer:null};a.Provider={$$typeof:x,_context:a};return a.Consumer=a},forwardRef:function(a){return{$$typeof:A,render:a}},Fragment:v,StrictMode:w,unstable_AsyncMode:z,createElement:L,cloneElement:function(a,b,e){null===a||void 0===a?C("267",a):void 0;var c=void 0,d=m({},a.props),g=a.key,h=a.ref,f=a._owner;if(null!=b){void 0!==b.ref&&(h=b.ref,f=I.current);void 0!==b.key&&(g=""+b.key);var k=void 0;a.type&&a.type.defaultProps&&
	(k=a.type.defaultProps);for(c in b)J.call(b,c)&&!K.hasOwnProperty(c)&&(d[c]=void 0===b[c]&&void 0!==k?k[c]:b[c])}c=arguments.length-2;if(1===c)d.children=e;else if(1<c){k=Array(c);for(var l=0;l<c;l++)k[l]=arguments[l+2];d.children=k}return{$$typeof:t,type:a.type,key:g,ref:h,props:d,_owner:f}},createFactory:function(a){var b=L.bind(null,a);b.type=a;return b},isValidElement:M,version:"16.3.2",__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentOwner:I,assign:m}},X=Object.freeze({default:W}),
	Y=X&&W||X;module.exports=Y["default"]?Y["default"]:Y;
	
	
	/***/ }),
	/* 10 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	/** @license React v16.3.2
	 * react.development.js
	 *
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	
	
	
	
	if (false) {
	  (function() {
	'use strict';
	
	var _assign = __webpack_require__(2);
	var invariant = __webpack_require__(0);
	var emptyObject = __webpack_require__(5);
	var warning = __webpack_require__(3);
	var emptyFunction = __webpack_require__(1);
	var checkPropTypes = __webpack_require__(6);
	
	// TODO: this is special because it gets imported during build.
	
	var ReactVersion = '16.3.2';
	
	// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	var hasSymbol = typeof Symbol === 'function' && Symbol['for'];
	
	var REACT_ELEMENT_TYPE = hasSymbol ? Symbol['for']('react.element') : 0xeac7;
	var REACT_CALL_TYPE = hasSymbol ? Symbol['for']('react.call') : 0xeac8;
	var REACT_RETURN_TYPE = hasSymbol ? Symbol['for']('react.return') : 0xeac9;
	var REACT_PORTAL_TYPE = hasSymbol ? Symbol['for']('react.portal') : 0xeaca;
	var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol['for']('react.fragment') : 0xeacb;
	var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol['for']('react.strict_mode') : 0xeacc;
	var REACT_PROVIDER_TYPE = hasSymbol ? Symbol['for']('react.provider') : 0xeacd;
	var REACT_CONTEXT_TYPE = hasSymbol ? Symbol['for']('react.context') : 0xeace;
	var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol['for']('react.async_mode') : 0xeacf;
	var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol['for']('react.forward_ref') : 0xead0;
	
	var MAYBE_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator';
	
	function getIteratorFn(maybeIterable) {
	  if (maybeIterable === null || typeof maybeIterable === 'undefined') {
	    return null;
	  }
	  var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];
	  if (typeof maybeIterator === 'function') {
	    return maybeIterator;
	  }
	  return null;
	}
	
	// Relying on the `invariant()` implementation lets us
	// have preserve the format and params in the www builds.
	
	/**
	 * Forked from fbjs/warning:
	 * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
	 *
	 * Only change is we use console.warn instead of console.error,
	 * and do nothing when 'console' is not supported.
	 * This really simplifies the code.
	 * ---
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var lowPriorityWarning = function () {};
	
	{
	  var printWarning = function (format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.warn(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  lowPriorityWarning = function (condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	var lowPriorityWarning$1 = lowPriorityWarning;
	
	var didWarnStateUpdateForUnmountedComponent = {};
	
	function warnNoop(publicInstance, callerName) {
	  {
	    var _constructor = publicInstance.constructor;
	    var componentName = _constructor && (_constructor.displayName || _constructor.name) || 'ReactClass';
	    var warningKey = componentName + '.' + callerName;
	    if (didWarnStateUpdateForUnmountedComponent[warningKey]) {
	      return;
	    }
	    warning(false, "Can't call %s on a component that is not yet mounted. " + 'This is a no-op, but it might indicate a bug in your application. ' + 'Instead, assign to `this.state` directly or define a `state = {};` ' + 'class property with the desired state in the %s component.', callerName, componentName);
	    didWarnStateUpdateForUnmountedComponent[warningKey] = true;
	  }
	}
	
	/**
	 * This is the abstract API for an update queue.
	 */
	var ReactNoopUpdateQueue = {
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    return false;
	  },
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {?function} callback Called after component is updated.
	   * @param {?string} callerName name of the calling function in the public API.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance, callback, callerName) {
	    warnNoop(publicInstance, 'forceUpdate');
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @param {?function} callback Called after component is updated.
	   * @param {?string} callerName name of the calling function in the public API.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState, callback, callerName) {
	    warnNoop(publicInstance, 'replaceState');
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @param {?function} callback Called after component is updated.
	   * @param {?string} Name of the calling function in the public API.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState, callback, callerName) {
	    warnNoop(publicInstance, 'setState');
	  }
	};
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function Component(props, context, updater) {
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	Component.prototype.isReactComponent = {};
	
	/**
	 * Sets a subset of the state. Always use this to mutate
	 * state. You should treat `this.state` as immutable.
	 *
	 * There is no guarantee that `this.state` will be immediately updated, so
	 * accessing `this.state` after calling this method may return the old value.
	 *
	 * There is no guarantee that calls to `setState` will run synchronously,
	 * as they may eventually be batched together.  You can provide an optional
	 * callback that will be executed when the call to setState is actually
	 * completed.
	 *
	 * When a function is provided to setState, it will be called at some point in
	 * the future (not synchronously). It will be called with the up to date
	 * component arguments (state, props, context). These values can be different
	 * from this.* because your function may be called after receiveProps but before
	 * shouldComponentUpdate, and this new state, props, and context will not yet be
	 * assigned to this.
	 *
	 * @param {object|function} partialState Next partial state or function to
	 *        produce next partial state to be merged with current state.
	 * @param {?function} callback Called after state is updated.
	 * @final
	 * @protected
	 */
	Component.prototype.setState = function (partialState, callback) {
	  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : void 0;
	  this.updater.enqueueSetState(this, partialState, callback, 'setState');
	};
	
	/**
	 * Forces an update. This should only be invoked when it is known with
	 * certainty that we are **not** in a DOM transaction.
	 *
	 * You may want to call this when you know that some deeper aspect of the
	 * component's state has changed but `setState` was not called.
	 *
	 * This will not invoke `shouldComponentUpdate`, but it will invoke
	 * `componentWillUpdate` and `componentDidUpdate`.
	 *
	 * @param {?function} callback Called after update is complete.
	 * @final
	 * @protected
	 */
	Component.prototype.forceUpdate = function (callback) {
	  this.updater.enqueueForceUpdate(this, callback, 'forceUpdate');
	};
	
	/**
	 * Deprecated APIs. These APIs used to exist on classic React classes but since
	 * we would like to deprecate them, we're not going to move them over to this
	 * modern base class. Instead, we define a getter that warns if it's accessed.
	 */
	{
	  var deprecatedAPIs = {
	    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
	    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
	  };
	  var defineDeprecationWarning = function (methodName, info) {
	    Object.defineProperty(Component.prototype, methodName, {
	      get: function () {
	        lowPriorityWarning$1(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]);
	        return undefined;
	      }
	    });
	  };
	  for (var fnName in deprecatedAPIs) {
	    if (deprecatedAPIs.hasOwnProperty(fnName)) {
	      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
	    }
	  }
	}
	
	function ComponentDummy() {}
	ComponentDummy.prototype = Component.prototype;
	
	/**
	 * Convenience component with default shallow equality check for sCU.
	 */
	function PureComponent(props, context, updater) {
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	var pureComponentPrototype = PureComponent.prototype = new ComponentDummy();
	pureComponentPrototype.constructor = PureComponent;
	// Avoid an extra prototype jump for these methods.
	_assign(pureComponentPrototype, Component.prototype);
	pureComponentPrototype.isPureReactComponent = true;
	
	// an immutable object with a single mutable value
	function createRef() {
	  var refObject = {
	    current: null
	  };
	  {
	    Object.seal(refObject);
	  }
	  return refObject;
	}
	
	/**
	 * Keeps track of the current owner.
	 *
	 * The current owner is the component who should own any components that are
	 * currently being constructed.
	 */
	var ReactCurrentOwner = {
	  /**
	   * @internal
	   * @type {ReactComponent}
	   */
	  current: null
	};
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	var RESERVED_PROPS = {
	  key: true,
	  ref: true,
	  __self: true,
	  __source: true
	};
	
	var specialPropKeyWarningShown = void 0;
	var specialPropRefWarningShown = void 0;
	
	function hasValidRef(config) {
	  {
	    if (hasOwnProperty.call(config, 'ref')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.ref !== undefined;
	}
	
	function hasValidKey(config) {
	  {
	    if (hasOwnProperty.call(config, 'key')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.key !== undefined;
	}
	
	function defineKeyPropWarningGetter(props, displayName) {
	  var warnAboutAccessingKey = function () {
	    if (!specialPropKeyWarningShown) {
	      specialPropKeyWarningShown = true;
	      warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName);
	    }
	  };
	  warnAboutAccessingKey.isReactWarning = true;
	  Object.defineProperty(props, 'key', {
	    get: warnAboutAccessingKey,
	    configurable: true
	  });
	}
	
	function defineRefPropWarningGetter(props, displayName) {
	  var warnAboutAccessingRef = function () {
	    if (!specialPropRefWarningShown) {
	      specialPropRefWarningShown = true;
	      warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName);
	    }
	  };
	  warnAboutAccessingRef.isReactWarning = true;
	  Object.defineProperty(props, 'ref', {
	    get: warnAboutAccessingRef,
	    configurable: true
	  });
	}
	
	/**
	 * Factory method to create a new React element. This no longer adheres to
	 * the class pattern, so do not use new to call it. Also, no instanceof check
	 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
	 * if something is a React Element.
	 *
	 * @param {*} type
	 * @param {*} key
	 * @param {string|object} ref
	 * @param {*} self A *temporary* helper to detect places where `this` is
	 * different from the `owner` when React.createElement is called, so that we
	 * can warn. We want to get rid of owner and replace string `ref`s with arrow
	 * functions, and as long as `this` and owner are the same, there will be no
	 * change in behavior.
	 * @param {*} source An annotation object (added by a transpiler or otherwise)
	 * indicating filename, line number, and/or other information.
	 * @param {*} owner
	 * @param {*} props
	 * @internal
	 */
	var ReactElement = function (type, key, ref, self, source, owner, props) {
	  var element = {
	    // This tag allows us to uniquely identify this as a React Element
	    $$typeof: REACT_ELEMENT_TYPE,
	
	    // Built-in properties that belong on the element
	    type: type,
	    key: key,
	    ref: ref,
	    props: props,
	
	    // Record the component responsible for creating this element.
	    _owner: owner
	  };
	
	  {
	    // The validation flag is currently mutative. We put it on
	    // an external backing store so that we can freeze the whole object.
	    // This can be replaced with a WeakMap once they are implemented in
	    // commonly used development environments.
	    element._store = {};
	
	    // To make comparing ReactElements easier for testing purposes, we make
	    // the validation flag non-enumerable (where possible, which should
	    // include every environment we run tests in), so the test framework
	    // ignores it.
	    Object.defineProperty(element._store, 'validated', {
	      configurable: false,
	      enumerable: false,
	      writable: true,
	      value: false
	    });
	    // self and source are DEV only properties.
	    Object.defineProperty(element, '_self', {
	      configurable: false,
	      enumerable: false,
	      writable: false,
	      value: self
	    });
	    // Two elements created in two different places should be considered
	    // equal for testing purposes and therefore we hide it from enumeration.
	    Object.defineProperty(element, '_source', {
	      configurable: false,
	      enumerable: false,
	      writable: false,
	      value: source
	    });
	    if (Object.freeze) {
	      Object.freeze(element.props);
	      Object.freeze(element);
	    }
	  }
	
	  return element;
	};
	
	/**
	 * Create and return a new ReactElement of the given type.
	 * See https://reactjs.org/docs/react-api.html#createelement
	 */
	function createElement(type, config, children) {
	  var propName = void 0;
	
	  // Reserved names are extracted
	  var props = {};
	
	  var key = null;
	  var ref = null;
	  var self = null;
	  var source = null;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      ref = config.ref;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    self = config.__self === undefined ? null : config.__self;
	    source = config.__source === undefined ? null : config.__source;
	    // Remaining properties are added to a new props object
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        props[propName] = config[propName];
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    {
	      if (Object.freeze) {
	        Object.freeze(childArray);
	      }
	    }
	    props.children = childArray;
	  }
	
	  // Resolve default props
	  if (type && type.defaultProps) {
	    var defaultProps = type.defaultProps;
	    for (propName in defaultProps) {
	      if (props[propName] === undefined) {
	        props[propName] = defaultProps[propName];
	      }
	    }
	  }
	  {
	    if (key || ref) {
	      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
	        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
	        if (key) {
	          defineKeyPropWarningGetter(props, displayName);
	        }
	        if (ref) {
	          defineRefPropWarningGetter(props, displayName);
	        }
	      }
	    }
	  }
	  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
	}
	
	/**
	 * Return a function that produces ReactElements of a given type.
	 * See https://reactjs.org/docs/react-api.html#createfactory
	 */
	
	
	function cloneAndReplaceKey(oldElement, newKey) {
	  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
	
	  return newElement;
	}
	
	/**
	 * Clone and return a new ReactElement using element as the starting point.
	 * See https://reactjs.org/docs/react-api.html#cloneelement
	 */
	function cloneElement(element, config, children) {
	  !!(element === null || element === undefined) ? invariant(false, 'React.cloneElement(...): The argument must be a React element, but you passed %s.', element) : void 0;
	
	  var propName = void 0;
	
	  // Original props are copied
	  var props = _assign({}, element.props);
	
	  // Reserved names are extracted
	  var key = element.key;
	  var ref = element.ref;
	  // Self is preserved since the owner is preserved.
	  var self = element._self;
	  // Source is preserved since cloneElement is unlikely to be targeted by a
	  // transpiler, and the original source is probably a better indicator of the
	  // true owner.
	  var source = element._source;
	
	  // Owner will be preserved, unless ref is overridden
	  var owner = element._owner;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      // Silently steal the ref from the parent.
	      ref = config.ref;
	      owner = ReactCurrentOwner.current;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    // Remaining properties override existing props
	    var defaultProps = void 0;
	    if (element.type && element.type.defaultProps) {
	      defaultProps = element.type.defaultProps;
	    }
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        if (config[propName] === undefined && defaultProps !== undefined) {
	          // Resolve default props
	          props[propName] = defaultProps[propName];
	        } else {
	          props[propName] = config[propName];
	        }
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  return ReactElement(element.type, key, ref, self, source, owner, props);
	}
	
	/**
	 * Verifies the object is a ReactElement.
	 * See https://reactjs.org/docs/react-api.html#isvalidelement
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid component.
	 * @final
	 */
	function isValidElement(object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	}
	
	var ReactDebugCurrentFrame = {};
	
	{
	  // Component that is being worked on
	  ReactDebugCurrentFrame.getCurrentStack = null;
	
	  ReactDebugCurrentFrame.getStackAddendum = function () {
	    var impl = ReactDebugCurrentFrame.getCurrentStack;
	    if (impl) {
	      return impl();
	    }
	    return null;
	  };
	}
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * Escape and wrap key so it is safe to use as a reactid
	 *
	 * @param {string} key to be escaped.
	 * @return {string} the escaped key.
	 */
	function escape(key) {
	  var escapeRegex = /[=:]/g;
	  var escaperLookup = {
	    '=': '=0',
	    ':': '=2'
	  };
	  var escapedString = ('' + key).replace(escapeRegex, function (match) {
	    return escaperLookup[match];
	  });
	
	  return '$' + escapedString;
	}
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	var userProvidedKeyEscapeRegex = /\/+/g;
	function escapeUserProvidedKey(text) {
	  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
	}
	
	var POOL_SIZE = 10;
	var traverseContextPool = [];
	function getPooledTraverseContext(mapResult, keyPrefix, mapFunction, mapContext) {
	  if (traverseContextPool.length) {
	    var traverseContext = traverseContextPool.pop();
	    traverseContext.result = mapResult;
	    traverseContext.keyPrefix = keyPrefix;
	    traverseContext.func = mapFunction;
	    traverseContext.context = mapContext;
	    traverseContext.count = 0;
	    return traverseContext;
	  } else {
	    return {
	      result: mapResult,
	      keyPrefix: keyPrefix,
	      func: mapFunction,
	      context: mapContext,
	      count: 0
	    };
	  }
	}
	
	function releaseTraverseContext(traverseContext) {
	  traverseContext.result = null;
	  traverseContext.keyPrefix = null;
	  traverseContext.func = null;
	  traverseContext.context = null;
	  traverseContext.count = 0;
	  if (traverseContextPool.length < POOL_SIZE) {
	    traverseContextPool.push(traverseContext);
	  }
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  var invokeCallback = false;
	
	  if (children === null) {
	    invokeCallback = true;
	  } else {
	    switch (type) {
	      case 'string':
	      case 'number':
	        invokeCallback = true;
	        break;
	      case 'object':
	        switch (children.$$typeof) {
	          case REACT_ELEMENT_TYPE:
	          case REACT_PORTAL_TYPE:
	            invokeCallback = true;
	        }
	    }
	  }
	
	  if (invokeCallback) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child = void 0;
	  var nextName = void 0;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (typeof iteratorFn === 'function') {
	      {
	        // Warn about using Maps as children
	        if (iteratorFn === children.entries) {
	          !didWarnAboutMaps ? warning(false, 'Using Maps as children is unsupported and will likely yield ' + 'unexpected results. Convert it to a sequence/iterable of keyed ' + 'ReactElements instead.%s', ReactDebugCurrentFrame.getStackAddendum()) : void 0;
	          didWarnAboutMaps = true;
	        }
	      }
	
	      var iterator = iteratorFn.call(children);
	      var step = void 0;
	      var ii = 0;
	      while (!(step = iterator.next()).done) {
	        child = step.value;
	        nextName = nextNamePrefix + getComponentKey(child, ii++);
	        subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead.' + ReactDebugCurrentFrame.getStackAddendum();
	      }
	      var childrenString = '' + children;
	      invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum);
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (typeof component === 'object' && component !== null && component.key != null) {
	    // Explicit key
	    return escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	function forEachSingleChild(bookKeeping, child, name) {
	  var func = bookKeeping.func,
	      context = bookKeeping.context;
	
	  func.call(context, child, bookKeeping.count++);
	}
	
	/**
	 * Iterates through children that are typically specified as `props.children`.
	 *
	 * See https://reactjs.org/docs/react-api.html#react.children.foreach
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} forEachFunc
	 * @param {*} forEachContext Context for forEachContext.
	 */
	function forEachChildren(children, forEachFunc, forEachContext) {
	  if (children == null) {
	    return children;
	  }
	  var traverseContext = getPooledTraverseContext(null, null, forEachFunc, forEachContext);
	  traverseAllChildren(children, forEachSingleChild, traverseContext);
	  releaseTraverseContext(traverseContext);
	}
	
	function mapSingleChildIntoContext(bookKeeping, child, childKey) {
	  var result = bookKeeping.result,
	      keyPrefix = bookKeeping.keyPrefix,
	      func = bookKeeping.func,
	      context = bookKeeping.context;
	
	
	  var mappedChild = func.call(context, child, bookKeeping.count++);
	  if (Array.isArray(mappedChild)) {
	    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
	  } else if (mappedChild != null) {
	    if (isValidElement(mappedChild)) {
	      mappedChild = cloneAndReplaceKey(mappedChild,
	      // Keep both the (mapped) and old keys if they differ, just as
	      // traverseAllChildren used to do for objects as children
	      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
	    }
	    result.push(mappedChild);
	  }
	}
	
	function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
	  var escapedPrefix = '';
	  if (prefix != null) {
	    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
	  }
	  var traverseContext = getPooledTraverseContext(array, escapedPrefix, func, context);
	  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
	  releaseTraverseContext(traverseContext);
	}
	
	/**
	 * Maps children that are typically specified as `props.children`.
	 *
	 * See https://reactjs.org/docs/react-api.html#react.children.map
	 *
	 * The provided mapFunction(child, key, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func The map function.
	 * @param {*} context Context for mapFunction.
	 * @return {object} Object containing the ordered map of results.
	 */
	function mapChildren(children, func, context) {
	  if (children == null) {
	    return children;
	  }
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
	  return result;
	}
	
	/**
	 * Count the number of children that are typically specified as
	 * `props.children`.
	 *
	 * See https://reactjs.org/docs/react-api.html#react.children.count
	 *
	 * @param {?*} children Children tree container.
	 * @return {number} The number of children.
	 */
	function countChildren(children, context) {
	  return traverseAllChildren(children, emptyFunction.thatReturnsNull, null);
	}
	
	/**
	 * Flatten a children object (typically specified as `props.children`) and
	 * return an array with appropriately re-keyed children.
	 *
	 * See https://reactjs.org/docs/react-api.html#react.children.toarray
	 */
	function toArray(children) {
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
	  return result;
	}
	
	/**
	 * Returns the first child in a collection of children and verifies that there
	 * is only one child in the collection.
	 *
	 * See https://reactjs.org/docs/react-api.html#react.children.only
	 *
	 * The current implementation of this function assumes that a single child gets
	 * passed without a wrapper, but the purpose of this helper function is to
	 * abstract away the particular structure of children.
	 *
	 * @param {?object} children Child collection structure.
	 * @return {ReactElement} The first and only `ReactElement` contained in the
	 * structure.
	 */
	function onlyChild(children) {
	  !isValidElement(children) ? invariant(false, 'React.Children.only expected to receive a single React element child.') : void 0;
	  return children;
	}
	
	function createContext(defaultValue, calculateChangedBits) {
	  if (calculateChangedBits === undefined) {
	    calculateChangedBits = null;
	  } else {
	    {
	      !(calculateChangedBits === null || typeof calculateChangedBits === 'function') ? warning(false, 'createContext: Expected the optional second argument to be a ' + 'function. Instead received: %s', calculateChangedBits) : void 0;
	    }
	  }
	
	  var context = {
	    $$typeof: REACT_CONTEXT_TYPE,
	    _calculateChangedBits: calculateChangedBits,
	    _defaultValue: defaultValue,
	    _currentValue: defaultValue,
	    _changedBits: 0,
	    // These are circular
	    Provider: null,
	    Consumer: null
	  };
	
	  context.Provider = {
	    $$typeof: REACT_PROVIDER_TYPE,
	    _context: context
	  };
	  context.Consumer = context;
	
	  {
	    context._currentRenderer = null;
	  }
	
	  return context;
	}
	
	function forwardRef(render) {
	  {
	    !(typeof render === 'function') ? warning(false, 'forwardRef requires a render function but was given %s.', render === null ? 'null' : typeof render) : void 0;
	  }
	
	  return {
	    $$typeof: REACT_FORWARD_REF_TYPE,
	    render: render
	  };
	}
	
	var describeComponentFrame = function (name, source, ownerName) {
	  return '\n    in ' + (name || 'Unknown') + (source ? ' (at ' + source.fileName.replace(/^.*[\\\/]/, '') + ':' + source.lineNumber + ')' : ownerName ? ' (created by ' + ownerName + ')' : '');
	};
	
	function isValidElementType(type) {
	  return typeof type === 'string' || typeof type === 'function' ||
	  // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
	  type === REACT_FRAGMENT_TYPE || type === REACT_ASYNC_MODE_TYPE || type === REACT_STRICT_MODE_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE);
	}
	
	function getComponentName(fiber) {
	  var type = fiber.type;
	
	  if (typeof type === 'function') {
	    return type.displayName || type.name;
	  }
	  if (typeof type === 'string') {
	    return type;
	  }
	  switch (type) {
	    case REACT_FRAGMENT_TYPE:
	      return 'ReactFragment';
	    case REACT_PORTAL_TYPE:
	      return 'ReactPortal';
	    case REACT_CALL_TYPE:
	      return 'ReactCall';
	    case REACT_RETURN_TYPE:
	      return 'ReactReturn';
	  }
	  if (typeof type === 'object' && type !== null) {
	    switch (type.$$typeof) {
	      case REACT_FORWARD_REF_TYPE:
	        var functionName = type.render.displayName || type.render.name || '';
	        return functionName !== '' ? 'ForwardRef(' + functionName + ')' : 'ForwardRef';
	    }
	  }
	  return null;
	}
	
	/**
	 * ReactElementValidator provides a wrapper around a element factory
	 * which validates the props passed to the element. This is intended to be
	 * used only in DEV and could be replaced by a static type checker for languages
	 * that support it.
	 */
	
	var currentlyValidatingElement = void 0;
	var propTypesMisspellWarningShown = void 0;
	
	var getDisplayName = function () {};
	var getStackAddendum = function () {};
	
	{
	  currentlyValidatingElement = null;
	
	  propTypesMisspellWarningShown = false;
	
	  getDisplayName = function (element) {
	    if (element == null) {
	      return '#empty';
	    } else if (typeof element === 'string' || typeof element === 'number') {
	      return '#text';
	    } else if (typeof element.type === 'string') {
	      return element.type;
	    } else if (element.type === REACT_FRAGMENT_TYPE) {
	      return 'React.Fragment';
	    } else {
	      return element.type.displayName || element.type.name || 'Unknown';
	    }
	  };
	
	  getStackAddendum = function () {
	    var stack = '';
	    if (currentlyValidatingElement) {
	      var name = getDisplayName(currentlyValidatingElement);
	      var owner = currentlyValidatingElement._owner;
	      stack += describeComponentFrame(name, currentlyValidatingElement._source, owner && getComponentName(owner));
	    }
	    stack += ReactDebugCurrentFrame.getStackAddendum() || '';
	    return stack;
	  };
	}
	
	function getDeclarationErrorAddendum() {
	  if (ReactCurrentOwner.current) {
	    var name = getComponentName(ReactCurrentOwner.current);
	    if (name) {
	      return '\n\nCheck the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	function getSourceInfoErrorAddendum(elementProps) {
	  if (elementProps !== null && elementProps !== undefined && elementProps.__source !== undefined) {
	    var source = elementProps.__source;
	    var fileName = source.fileName.replace(/^.*[\\\/]/, '');
	    var lineNumber = source.lineNumber;
	    return '\n\nCheck your code at ' + fileName + ':' + lineNumber + '.';
	  }
	  return '';
	}
	
	/**
	 * Warn if there's no key explicitly set on dynamic arrays of children or
	 * object keys are not valid. This allows us to keep track of children between
	 * updates.
	 */
	var ownerHasKeyUseWarning = {};
	
	function getCurrentComponentErrorInfo(parentType) {
	  var info = getDeclarationErrorAddendum();
	
	  if (!info) {
	    var parentName = typeof parentType === 'string' ? parentType : parentType.displayName || parentType.name;
	    if (parentName) {
	      info = '\n\nCheck the top-level render call using <' + parentName + '>.';
	    }
	  }
	  return info;
	}
	
	/**
	 * Warn if the element doesn't have an explicit key assigned to it.
	 * This element is in an array. The array could grow and shrink or be
	 * reordered. All children that haven't already been validated are required to
	 * have a "key" property assigned to it. Error statuses are cached so a warning
	 * will only be shown once.
	 *
	 * @internal
	 * @param {ReactElement} element Element that requires a key.
	 * @param {*} parentType element's parent's type.
	 */
	function validateExplicitKey(element, parentType) {
	  if (!element._store || element._store.validated || element.key != null) {
	    return;
	  }
	  element._store.validated = true;
	
	  var currentComponentErrorInfo = getCurrentComponentErrorInfo(parentType);
	  if (ownerHasKeyUseWarning[currentComponentErrorInfo]) {
	    return;
	  }
	  ownerHasKeyUseWarning[currentComponentErrorInfo] = true;
	
	  // Usually the current owner is the offender, but if it accepts children as a
	  // property, it may be the creator of the child that's responsible for
	  // assigning it a key.
	  var childOwner = '';
	  if (element && element._owner && element._owner !== ReactCurrentOwner.current) {
	    // Give the component that originally created this child.
	    childOwner = ' It was passed a child from ' + getComponentName(element._owner) + '.';
	  }
	
	  currentlyValidatingElement = element;
	  {
	    warning(false, 'Each child in an array or iterator should have a unique "key" prop.' + '%s%s See https://fb.me/react-warning-keys for more information.%s', currentComponentErrorInfo, childOwner, getStackAddendum());
	  }
	  currentlyValidatingElement = null;
	}
	
	/**
	 * Ensure that every element either is passed in a static location, in an
	 * array with an explicit keys property defined, or in an object literal
	 * with valid key property.
	 *
	 * @internal
	 * @param {ReactNode} node Statically passed child of any type.
	 * @param {*} parentType node's parent's type.
	 */
	function validateChildKeys(node, parentType) {
	  if (typeof node !== 'object') {
	    return;
	  }
	  if (Array.isArray(node)) {
	    for (var i = 0; i < node.length; i++) {
	      var child = node[i];
	      if (isValidElement(child)) {
	        validateExplicitKey(child, parentType);
	      }
	    }
	  } else if (isValidElement(node)) {
	    // This element was passed in a valid location.
	    if (node._store) {
	      node._store.validated = true;
	    }
	  } else if (node) {
	    var iteratorFn = getIteratorFn(node);
	    if (typeof iteratorFn === 'function') {
	      // Entry iterators used to provide implicit keys,
	      // but now we print a separate warning for them later.
	      if (iteratorFn !== node.entries) {
	        var iterator = iteratorFn.call(node);
	        var step = void 0;
	        while (!(step = iterator.next()).done) {
	          if (isValidElement(step.value)) {
	            validateExplicitKey(step.value, parentType);
	          }
	        }
	      }
	    }
	  }
	}
	
	/**
	 * Given an element, validate that its props follow the propTypes definition,
	 * provided by the type.
	 *
	 * @param {ReactElement} element
	 */
	function validatePropTypes(element) {
	  var componentClass = element.type;
	  if (typeof componentClass !== 'function') {
	    return;
	  }
	  var name = componentClass.displayName || componentClass.name;
	  var propTypes = componentClass.propTypes;
	  if (propTypes) {
	    currentlyValidatingElement = element;
	    checkPropTypes(propTypes, element.props, 'prop', name, getStackAddendum);
	    currentlyValidatingElement = null;
	  } else if (componentClass.PropTypes !== undefined && !propTypesMisspellWarningShown) {
	    propTypesMisspellWarningShown = true;
	    warning(false, 'Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?', name || 'Unknown');
	  }
	  if (typeof componentClass.getDefaultProps === 'function') {
	    !componentClass.getDefaultProps.isReactClassApproved ? warning(false, 'getDefaultProps is only used on classic React.createClass ' + 'definitions. Use a static property named `defaultProps` instead.') : void 0;
	  }
	}
	
	/**
	 * Given a fragment, validate that it can only be provided with fragment props
	 * @param {ReactElement} fragment
	 */
	function validateFragmentProps(fragment) {
	  currentlyValidatingElement = fragment;
	
	  var keys = Object.keys(fragment.props);
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    if (key !== 'children' && key !== 'key') {
	      warning(false, 'Invalid prop `%s` supplied to `React.Fragment`. ' + 'React.Fragment can only have `key` and `children` props.%s', key, getStackAddendum());
	      break;
	    }
	  }
	
	  if (fragment.ref !== null) {
	    warning(false, 'Invalid attribute `ref` supplied to `React.Fragment`.%s', getStackAddendum());
	  }
	
	  currentlyValidatingElement = null;
	}
	
	function createElementWithValidation(type, props, children) {
	  var validType = isValidElementType(type);
	
	  // We warn in this case but don't throw. We expect the element creation to
	  // succeed and there will likely be errors in render.
	  if (!validType) {
	    var info = '';
	    if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
	      info += ' You likely forgot to export your component from the file ' + "it's defined in, or you might have mixed up default and named imports.";
	    }
	
	    var sourceInfo = getSourceInfoErrorAddendum(props);
	    if (sourceInfo) {
	      info += sourceInfo;
	    } else {
	      info += getDeclarationErrorAddendum();
	    }
	
	    info += getStackAddendum() || '';
	
	    var typeString = void 0;
	    if (type === null) {
	      typeString = 'null';
	    } else if (Array.isArray(type)) {
	      typeString = 'array';
	    } else {
	      typeString = typeof type;
	    }
	
	    warning(false, 'React.createElement: type is invalid -- expected a string (for ' + 'built-in components) or a class/function (for composite ' + 'components) but got: %s.%s', typeString, info);
	  }
	
	  var element = createElement.apply(this, arguments);
	
	  // The result can be nullish if a mock or a custom function is used.
	  // TODO: Drop this when these are no longer allowed as the type argument.
	  if (element == null) {
	    return element;
	  }
	
	  // Skip key warning if the type isn't valid since our key validation logic
	  // doesn't expect a non-string/function type and can throw confusing errors.
	  // We don't want exception behavior to differ between dev and prod.
	  // (Rendering will throw with a helpful message and as soon as the type is
	  // fixed, the key warnings will appear.)
	  if (validType) {
	    for (var i = 2; i < arguments.length; i++) {
	      validateChildKeys(arguments[i], type);
	    }
	  }
	
	  if (type === REACT_FRAGMENT_TYPE) {
	    validateFragmentProps(element);
	  } else {
	    validatePropTypes(element);
	  }
	
	  return element;
	}
	
	function createFactoryWithValidation(type) {
	  var validatedFactory = createElementWithValidation.bind(null, type);
	  validatedFactory.type = type;
	  // Legacy hook: remove it
	  {
	    Object.defineProperty(validatedFactory, 'type', {
	      enumerable: false,
	      get: function () {
	        lowPriorityWarning$1(false, 'Factory.type is deprecated. Access the class directly ' + 'before passing it to createFactory.');
	        Object.defineProperty(this, 'type', {
	          value: type
	        });
	        return type;
	      }
	    });
	  }
	
	  return validatedFactory;
	}
	
	function cloneElementWithValidation(element, props, children) {
	  var newElement = cloneElement.apply(this, arguments);
	  for (var i = 2; i < arguments.length; i++) {
	    validateChildKeys(arguments[i], newElement.type);
	  }
	  validatePropTypes(newElement);
	  return newElement;
	}
	
	var React = {
	  Children: {
	    map: mapChildren,
	    forEach: forEachChildren,
	    count: countChildren,
	    toArray: toArray,
	    only: onlyChild
	  },
	
	  createRef: createRef,
	  Component: Component,
	  PureComponent: PureComponent,
	
	  createContext: createContext,
	  forwardRef: forwardRef,
	
	  Fragment: REACT_FRAGMENT_TYPE,
	  StrictMode: REACT_STRICT_MODE_TYPE,
	  unstable_AsyncMode: REACT_ASYNC_MODE_TYPE,
	
	  createElement: createElementWithValidation,
	  cloneElement: cloneElementWithValidation,
	  createFactory: createFactoryWithValidation,
	  isValidElement: isValidElement,
	
	  version: ReactVersion,
	
	  __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED: {
	    ReactCurrentOwner: ReactCurrentOwner,
	    // Used by renderers to avoid bundling object-assign twice in UMD bundles:
	    assign: _assign
	  }
	};
	
	{
	  _assign(React.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, {
	    // These should not be included in production.
	    ReactDebugCurrentFrame: ReactDebugCurrentFrame,
	    // Shim for React DOM 16.0.0 which still destructured (but not used) this.
	    // TODO: remove in React 17.0.
	    ReactComponentTreeHook: {}
	  });
	}
	
	
	
	var React$2 = Object.freeze({
		default: React
	});
	
	var React$3 = ( React$2 && React ) || React$2;
	
	// TODO: decide on the top-level export form.
	// This is hacky but makes it work with both Rollup and Jest.
	var react = React$3['default'] ? React$3['default'] : React$3;
	
	module.exports = react;
	  })();
	}
	
	
	/***/ }),
	/* 11 */
	/***/ (function(module, exports, __webpack_require__) {
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (false) {
	  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
	    Symbol.for &&
	    Symbol.for('react.element')) ||
	    0xeac7;
	
	  var isValidElement = function(object) {
	    return typeof object === 'object' &&
	      object !== null &&
	      object.$$typeof === REACT_ELEMENT_TYPE;
	  };
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = __webpack_require__(12)(isValidElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(13)();
	}
	
	
	/***/ }),
	/* 12 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	
	
	var emptyFunction = __webpack_require__(1);
	var invariant = __webpack_require__(0);
	var warning = __webpack_require__(3);
	var assign = __webpack_require__(2);
	
	var ReactPropTypesSecret = __webpack_require__(4);
	var checkPropTypes = __webpack_require__(6);
	
	module.exports = function(isValidElement, throwOnDirectAccess) {
	  /* global Symbol */
	  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	  /**
	   * Returns the iterator method function contained on the iterable object.
	   *
	   * Be sure to invoke the function with the iterable as context:
	   *
	   *     var iteratorFn = getIteratorFn(myIterable);
	   *     if (iteratorFn) {
	   *       var iterator = iteratorFn.call(myIterable);
	   *       ...
	   *     }
	   *
	   * @param {?object} maybeIterable
	   * @return {?function}
	   */
	  function getIteratorFn(maybeIterable) {
	    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }
	
	  /**
	   * Collection of methods that allow declaration and validation of props that are
	   * supplied to React components. Example usage:
	   *
	   *   var Props = require('ReactPropTypes');
	   *   var MyArticle = React.createClass({
	   *     propTypes: {
	   *       // An optional string prop named "description".
	   *       description: Props.string,
	   *
	   *       // A required enum prop named "category".
	   *       category: Props.oneOf(['News','Photos']).isRequired,
	   *
	   *       // A prop named "dialog" that requires an instance of Dialog.
	   *       dialog: Props.instanceOf(Dialog).isRequired
	   *     },
	   *     render: function() { ... }
	   *   });
	   *
	   * A more formal specification of how these methods are used:
	   *
	   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	   *   decl := ReactPropTypes.{type}(.isRequired)?
	   *
	   * Each and every declaration produces a function with the same signature. This
	   * allows the creation of custom validation functions. For example:
	   *
	   *  var MyLink = React.createClass({
	   *    propTypes: {
	   *      // An optional string or URI prop named "href".
	   *      href: function(props, propName, componentName) {
	   *        var propValue = props[propName];
	   *        if (propValue != null && typeof propValue !== 'string' &&
	   *            !(propValue instanceof URI)) {
	   *          return new Error(
	   *            'Expected a string or an URI for ' + propName + ' in ' +
	   *            componentName
	   *          );
	   *        }
	   *      }
	   *    },
	   *    render: function() {...}
	   *  });
	   *
	   * @internal
	   */
	
	  var ANONYMOUS = '<<anonymous>>';
	
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
	  var ReactPropTypes = {
	    array: createPrimitiveTypeChecker('array'),
	    bool: createPrimitiveTypeChecker('boolean'),
	    func: createPrimitiveTypeChecker('function'),
	    number: createPrimitiveTypeChecker('number'),
	    object: createPrimitiveTypeChecker('object'),
	    string: createPrimitiveTypeChecker('string'),
	    symbol: createPrimitiveTypeChecker('symbol'),
	
	    any: createAnyTypeChecker(),
	    arrayOf: createArrayOfTypeChecker,
	    element: createElementTypeChecker(),
	    instanceOf: createInstanceTypeChecker,
	    node: createNodeChecker(),
	    objectOf: createObjectOfTypeChecker,
	    oneOf: createEnumTypeChecker,
	    oneOfType: createUnionTypeChecker,
	    shape: createShapeTypeChecker,
	    exact: createStrictShapeTypeChecker,
	  };
	
	  /**
	   * inlined Object.is polyfill to avoid requiring consumers ship their own
	   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	   */
	  /*eslint-disable no-self-compare*/
	  function is(x, y) {
	    // SameValue algorithm
	    if (x === y) {
	      // Steps 1-5, 7-10
	      // Steps 6.b-6.e: +0 != -0
	      return x !== 0 || 1 / x === 1 / y;
	    } else {
	      // Step 6.a: NaN == NaN
	      return x !== x && y !== y;
	    }
	  }
	  /*eslint-enable no-self-compare*/
	
	  /**
	   * We use an Error-like object for backward compatibility as people may call
	   * PropTypes directly and inspect their output. However, we don't use real
	   * Errors anymore. We don't inspect their stack anyway, and creating them
	   * is prohibitively expensive if they are created too often, such as what
	   * happens in oneOfType() for any type before the one that matched.
	   */
	  function PropTypeError(message) {
	    this.message = message;
	    this.stack = '';
	  }
	  // Make `instanceof Error` still work for returned errors.
	  PropTypeError.prototype = Error.prototype;
	
	  function createChainableTypeChecker(validate) {
	    if (false) {
	      var manualPropTypeCallCache = {};
	      var manualPropTypeWarningCount = 0;
	    }
	    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	      componentName = componentName || ANONYMOUS;
	      propFullName = propFullName || propName;
	
	      if (secret !== ReactPropTypesSecret) {
	        if (throwOnDirectAccess) {
	          // New behavior only for users of `prop-types` package
	          invariant(
	            false,
	            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	            'Use `PropTypes.checkPropTypes()` to call them. ' +
	            'Read more at http://fb.me/use-check-prop-types'
	          );
	        } else if (false) {
	          // Old behavior for people using React.PropTypes
	          var cacheKey = componentName + ':' + propName;
	          if (
	            !manualPropTypeCallCache[cacheKey] &&
	            // Avoid spamming the console because they are often not actionable except for lib authors
	            manualPropTypeWarningCount < 3
	          ) {
	            warning(
	              false,
	              'You are manually calling a React.PropTypes validation ' +
	              'function for the `%s` prop on `%s`. This is deprecated ' +
	              'and will throw in the standalone `prop-types` package. ' +
	              'You may be seeing this warning due to a third-party PropTypes ' +
	              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',
	              propFullName,
	              componentName
	            );
	            manualPropTypeCallCache[cacheKey] = true;
	            manualPropTypeWarningCount++;
	          }
	        }
	      }
	      if (props[propName] == null) {
	        if (isRequired) {
	          if (props[propName] === null) {
	            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	          }
	          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	        }
	        return null;
	      } else {
	        return validate(props, propName, componentName, location, propFullName);
	      }
	    }
	
	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);
	
	    return chainedCheckType;
	  }
	
	  function createPrimitiveTypeChecker(expectedType) {
	    function validate(props, propName, componentName, location, propFullName, secret) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== expectedType) {
	        // `propValue` being instance of, say, date/regexp, pass the 'object'
	        // check, but we can offer a more precise error message here rather than
	        // 'of type `object`'.
	        var preciseType = getPreciseType(propValue);
	
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createAnyTypeChecker() {
	    return createChainableTypeChecker(emptyFunction.thatReturnsNull);
	  }
	
	  function createArrayOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	      }
	      var propValue = props[propName];
	      if (!Array.isArray(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	      }
	      for (var i = 0; i < propValue.length; i++) {
	        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createElementTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!isValidElement(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createInstanceTypeChecker(expectedClass) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!(props[propName] instanceof expectedClass)) {
	        var expectedClassName = expectedClass.name || ANONYMOUS;
	        var actualClassName = getClassName(props[propName]);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createEnumTypeChecker(expectedValues) {
	    if (!Array.isArray(expectedValues)) {
	       false ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
	      return emptyFunction.thatReturnsNull;
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      for (var i = 0; i < expectedValues.length; i++) {
	        if (is(propValue, expectedValues[i])) {
	          return null;
	        }
	      }
	
	      var valuesString = JSON.stringify(expectedValues);
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createObjectOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	      }
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	      }
	      for (var key in propValue) {
	        if (propValue.hasOwnProperty(key)) {
	          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	          if (error instanceof Error) {
	            return error;
	          }
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createUnionTypeChecker(arrayOfTypeCheckers) {
	    if (!Array.isArray(arrayOfTypeCheckers)) {
	       false ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	      return emptyFunction.thatReturnsNull;
	    }
	
	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (typeof checker !== 'function') {
	        warning(
	          false,
	          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
	          'received %s at index %s.',
	          getPostfixForTypeWarning(checker),
	          i
	        );
	        return emptyFunction.thatReturnsNull;
	      }
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	        var checker = arrayOfTypeCheckers[i];
	        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
	          return null;
	        }
	      }
	
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createNodeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!isNode(props[propName])) {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      for (var key in shapeTypes) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          continue;
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createStrictShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      // We need to check all keys in case some are required but missing from
	      // props.
	      var allKeys = assign({}, props[propName], shapeTypes);
	      for (var key in allKeys) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          return new PropTypeError(
	            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
	            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
	            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
	          );
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	
	    return createChainableTypeChecker(validate);
	  }
	
	  function isNode(propValue) {
	    switch (typeof propValue) {
	      case 'number':
	      case 'string':
	      case 'undefined':
	        return true;
	      case 'boolean':
	        return !propValue;
	      case 'object':
	        if (Array.isArray(propValue)) {
	          return propValue.every(isNode);
	        }
	        if (propValue === null || isValidElement(propValue)) {
	          return true;
	        }
	
	        var iteratorFn = getIteratorFn(propValue);
	        if (iteratorFn) {
	          var iterator = iteratorFn.call(propValue);
	          var step;
	          if (iteratorFn !== propValue.entries) {
	            while (!(step = iterator.next()).done) {
	              if (!isNode(step.value)) {
	                return false;
	              }
	            }
	          } else {
	            // Iterator will provide entry [k,v] tuples rather than values.
	            while (!(step = iterator.next()).done) {
	              var entry = step.value;
	              if (entry) {
	                if (!isNode(entry[1])) {
	                  return false;
	                }
	              }
	            }
	          }
	        } else {
	          return false;
	        }
	
	        return true;
	      default:
	        return false;
	    }
	  }
	
	  function isSymbol(propType, propValue) {
	    // Native Symbol.
	    if (propType === 'symbol') {
	      return true;
	    }
	
	    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	    if (propValue['@@toStringTag'] === 'Symbol') {
	      return true;
	    }
	
	    // Fallback for non-spec compliant Symbols which are polyfilled.
	    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	      return true;
	    }
	
	    return false;
	  }
	
	  // Equivalent of `typeof` but with special handling for array and regexp.
	  function getPropType(propValue) {
	    var propType = typeof propValue;
	    if (Array.isArray(propValue)) {
	      return 'array';
	    }
	    if (propValue instanceof RegExp) {
	      // Old webkits (at least until Android 4.0) return 'function' rather than
	      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	      // passes PropTypes.object.
	      return 'object';
	    }
	    if (isSymbol(propType, propValue)) {
	      return 'symbol';
	    }
	    return propType;
	  }
	
	  // This handles more types than `getPropType`. Only used for error messages.
	  // See `createPrimitiveTypeChecker`.
	  function getPreciseType(propValue) {
	    if (typeof propValue === 'undefined' || propValue === null) {
	      return '' + propValue;
	    }
	    var propType = getPropType(propValue);
	    if (propType === 'object') {
	      if (propValue instanceof Date) {
	        return 'date';
	      } else if (propValue instanceof RegExp) {
	        return 'regexp';
	      }
	    }
	    return propType;
	  }
	
	  // Returns a string that is postfixed to a warning about an invalid type.
	  // For example, "undefined" or "of type array"
	  function getPostfixForTypeWarning(value) {
	    var type = getPreciseType(value);
	    switch (type) {
	      case 'array':
	      case 'object':
	        return 'an ' + type;
	      case 'boolean':
	      case 'date':
	      case 'regexp':
	        return 'a ' + type;
	      default:
	        return type;
	    }
	  }
	
	  // Returns class name of the object, if any.
	  function getClassName(propValue) {
	    if (!propValue.constructor || !propValue.constructor.name) {
	      return ANONYMOUS;
	    }
	    return propValue.constructor.name;
	  }
	
	  ReactPropTypes.checkPropTypes = checkPropTypes;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};
	
	
	/***/ }),
	/* 13 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	
	
	var emptyFunction = __webpack_require__(1);
	var invariant = __webpack_require__(0);
	var ReactPropTypesSecret = __webpack_require__(4);
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    invariant(
	      false,
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim
	  };
	
	  ReactPropTypes.checkPropTypes = emptyFunction;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};
	
	
	/***/ }),
	/* 14 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _blank = __webpack_require__(15);
	
	Object.defineProperty(exports, 'blank', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_blank).default;
	  }
	});
	
	var _loadingBalls = __webpack_require__(16);
	
	Object.defineProperty(exports, 'balls', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_loadingBalls).default;
	  }
	});
	
	var _loadingBars = __webpack_require__(17);
	
	Object.defineProperty(exports, 'bars', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_loadingBars).default;
	  }
	});
	
	var _loadingBubbles = __webpack_require__(18);
	
	Object.defineProperty(exports, 'bubbles', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_loadingBubbles).default;
	  }
	});
	
	var _loadingCubes = __webpack_require__(19);
	
	Object.defineProperty(exports, 'cubes', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_loadingCubes).default;
	  }
	});
	
	var _loadingCylon = __webpack_require__(20);
	
	Object.defineProperty(exports, 'cylon', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_loadingCylon).default;
	  }
	});
	
	var _loadingSpin = __webpack_require__(21);
	
	Object.defineProperty(exports, 'spin', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_loadingSpin).default;
	  }
	});
	
	var _loadingSpinningBubbles = __webpack_require__(22);
	
	Object.defineProperty(exports, 'spinningBubbles', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_loadingSpinningBubbles).default;
	  }
	});
	
	var _loadingSpokes = __webpack_require__(23);
	
	Object.defineProperty(exports, 'spokes', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_loadingSpokes).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/***/ }),
	/* 15 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg class=\"icon-blank\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"></svg>\n"
	
	/***/ }),
	/* 16 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg class=\"icon-loading\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\">\n  <path transform=\"translate(-8 0)\" d=\"M4 12 A4 4 0 0 0 4 20 A4 4 0 0 0 4 12\"> \n    <animateTransform attributeName=\"transform\" type=\"translate\" values=\"-8 0; 2 0; 2 0;\" dur=\"0.8s\" repeatCount=\"indefinite\" begin=\"0\" keytimes=\"0;.25;1\" keySplines=\"0.2 0.2 0.4 0.8;0.2 0.6 0.4 0.8\" calcMode=\"spline\"  />\n  </path>\n  <path transform=\"translate(2 0)\" d=\"M4 12 A4 4 0 0 0 4 20 A4 4 0 0 0 4 12\"> \n    <animateTransform attributeName=\"transform\" type=\"translate\" values=\"2 0; 12 0; 12 0;\" dur=\"0.8s\" repeatCount=\"indefinite\" begin=\"0\" keytimes=\"0;.35;1\" keySplines=\"0.2 0.2 0.4 0.8;0.2 0.6 0.4 0.8\" calcMode=\"spline\"  />\n  </path>\n  <path transform=\"translate(12 0)\" d=\"M4 12 A4 4 0 0 0 4 20 A4 4 0 0 0 4 12\"> \n    <animateTransform attributeName=\"transform\" type=\"translate\" values=\"12 0; 22 0; 22 0;\" dur=\"0.8s\" repeatCount=\"indefinite\" begin=\"0\" keytimes=\"0;.45;1\" keySplines=\"0.2 0.2 0.4 0.8;0.2 0.6 0.4 0.8\" calcMode=\"spline\"  />\n  </path>\n  <path transform=\"translate(24 0)\" d=\"M4 12 A4 4 0 0 0 4 20 A4 4 0 0 0 4 12\"> \n    <animateTransform attributeName=\"transform\" type=\"translate\" values=\"22 0; 32 0; 32 0;\" dur=\"0.8s\" repeatCount=\"indefinite\" begin=\"0\" keytimes=\"0;.55;1\" keySplines=\"0.2 0.2 0.4 0.8;0.2 0.6 0.4 0.8\" calcMode=\"spline\"  />\n  </path>\n</svg>\n"
	
	/***/ }),
	/* 17 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\">\n  <path transform=\"translate(2)\" d=\"M0 12 V20 H4 V12z\"> \n    <animate attributeName=\"d\" values=\"M0 12 V20 H4 V12z; M0 4 V28 H4 V4z; M0 12 V20 H4 V12z; M0 12 V20 H4 V12z\" dur=\"1.2s\" repeatCount=\"indefinite\" begin=\"0\" keytimes=\"0;.2;.5;1\" keySplines=\"0.2 0.2 0.4 0.8;0.2 0.6 0.4 0.8;0.2 0.8 0.4 0.8\" calcMode=\"spline\"  />\n  </path>\n  <path transform=\"translate(8)\" d=\"M0 12 V20 H4 V12z\">\n    <animate attributeName=\"d\" values=\"M0 12 V20 H4 V12z; M0 4 V28 H4 V4z; M0 12 V20 H4 V12z; M0 12 V20 H4 V12z\" dur=\"1.2s\" repeatCount=\"indefinite\" begin=\"0.2\" keytimes=\"0;.2;.5;1\" keySplines=\"0.2 0.2 0.4 0.8;0.2 0.6 0.4 0.8;0.2 0.8 0.4 0.8\" calcMode=\"spline\"  />\n  </path>\n  <path transform=\"translate(14)\" d=\"M0 12 V20 H4 V12z\">\n    <animate attributeName=\"d\" values=\"M0 12 V20 H4 V12z; M0 4 V28 H4 V4z; M0 12 V20 H4 V12z; M0 12 V20 H4 V12z\" dur=\"1.2s\" repeatCount=\"indefinite\" begin=\"0.4\" keytimes=\"0;.2;.5;1\" keySplines=\"0.2 0.2 0.4 0.8;0.2 0.6 0.4 0.8;0.2 0.8 0.4 0.8\" calcMode=\"spline\" />\n  </path>\n  <path transform=\"translate(20)\" d=\"M0 12 V20 H4 V12z\">\n    <animate attributeName=\"d\" values=\"M0 12 V20 H4 V12z; M0 4 V28 H4 V4z; M0 12 V20 H4 V12z; M0 12 V20 H4 V12z\" dur=\"1.2s\" repeatCount=\"indefinite\" begin=\"0.6\" keytimes=\"0;.2;.5;1\" keySplines=\"0.2 0.2 0.4 0.8;0.2 0.6 0.4 0.8;0.2 0.8 0.4 0.8\" calcMode=\"spline\" />\n  </path>\n  <path transform=\"translate(26)\" d=\"M0 12 V20 H4 V12z\">\n    <animate attributeName=\"d\" values=\"M0 12 V20 H4 V12z; M0 4 V28 H4 V4z; M0 12 V20 H4 V12z; M0 12 V20 H4 V12z\" dur=\"1.2s\" repeatCount=\"indefinite\" begin=\"0.8\" keytimes=\"0;.2;.5;1\" keySplines=\"0.2 0.2 0.4 0.8;0.2 0.6 0.4 0.8;0.2 0.8 0.4 0.8\" calcMode=\"spline\" />\n  </path>\n</svg>\n"
	
	/***/ }),
	/* 18 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\">\n  <circle transform=\"translate(8 0)\" cx=\"0\" cy=\"16\" r=\"0\"> \n    <animate attributeName=\"r\" values=\"0; 4; 0; 0\" dur=\"1.2s\" repeatCount=\"indefinite\" begin=\"0\"\n      keytimes=\"0;0.2;0.7;1\" keySplines=\"0.2 0.2 0.4 0.8;0.2 0.6 0.4 0.8;0.2 0.6 0.4 0.8\" calcMode=\"spline\" />\n  </circle>\n  <circle transform=\"translate(16 0)\" cx=\"0\" cy=\"16\" r=\"0\"> \n    <animate attributeName=\"r\" values=\"0; 4; 0; 0\" dur=\"1.2s\" repeatCount=\"indefinite\" begin=\"0.3\"\n      keytimes=\"0;0.2;0.7;1\" keySplines=\"0.2 0.2 0.4 0.8;0.2 0.6 0.4 0.8;0.2 0.6 0.4 0.8\" calcMode=\"spline\" />\n  </circle>\n  <circle transform=\"translate(24 0)\" cx=\"0\" cy=\"16\" r=\"0\"> \n    <animate attributeName=\"r\" values=\"0; 4; 0; 0\" dur=\"1.2s\" repeatCount=\"indefinite\" begin=\"0.6\"\n      keytimes=\"0;0.2;0.7;1\" keySplines=\"0.2 0.2 0.4 0.8;0.2 0.6 0.4 0.8;0.2 0.6 0.4 0.8\" calcMode=\"spline\" />\n  </circle>\n</svg>\n"
	
	/***/ }),
	/* 19 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\">\n  <path transform=\"translate(-8 0)\" d=\"M0 12 V20 H8 V12z\"> \n    <animateTransform attributeName=\"transform\" type=\"translate\" values=\"-8 0; 2 0; 2 0;\" dur=\"0.8s\" repeatCount=\"indefinite\" begin=\"0\" keytimes=\"0;.25;1\" keySplines=\"0.2 0.2 0.4 0.8;0.2 0.6 0.4 0.8\" calcMode=\"spline\"  />\n  </path>\n  <path transform=\"translate(2 0)\" d=\"M0 12 V20 H8 V12z\"> \n    <animateTransform attributeName=\"transform\" type=\"translate\" values=\"2 0; 12 0; 12 0;\" dur=\"0.8s\" repeatCount=\"indefinite\" begin=\"0\" keytimes=\"0;.35;1\" keySplines=\"0.2 0.2 0.4 0.8;0.2 0.6 0.4 0.8\" calcMode=\"spline\"  />\n  </path>\n  <path transform=\"translate(12 0)\" d=\"M0 12 V20 H8 V12z\"> \n    <animateTransform attributeName=\"transform\" type=\"translate\" values=\"12 0; 22 0; 22 0;\" dur=\"0.8s\" repeatCount=\"indefinite\" begin=\"0\" keytimes=\"0;.45;1\" keySplines=\"0.2 0.2 0.4 0.8;0.2 0.6 0.4 0.8\" calcMode=\"spline\"  />\n  </path>\n  <path transform=\"translate(24 0)\" d=\"M0 12 V20 H8 V12z\"> \n    <animateTransform attributeName=\"transform\" type=\"translate\" values=\"22 0; 32 0; 32 0;\" dur=\"0.8s\" repeatCount=\"indefinite\" begin=\"0\" keytimes=\"0;.55;1\" keySplines=\"0.2 0.2 0.4 0.8;0.2 0.6 0.4 0.8\" calcMode=\"spline\"  />\n  </path>\n</svg>\n"
	
	/***/ }),
	/* 20 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\">\n  <path transform=\"translate(0 0)\" d=\"M0 12 V20 H4 V12z\">\n    <animateTransform attributeName=\"transform\" type=\"translate\" values=\"0 0; 28 0; 0 0; 0 0\" dur=\"1.5s\" begin=\"0\" repeatCount=\"indefinite\" keytimes=\"0;0.3;0.6;1\" keySplines=\"0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8\" calcMode=\"spline\" />\n  </path>\n  <path opacity=\"0.5\" transform=\"translate(0 0)\" d=\"M0 12 V20 H4 V12z\">\n    <animateTransform attributeName=\"transform\" type=\"translate\" values=\"0 0; 28 0; 0 0; 0 0\" dur=\"1.5s\" begin=\"0.1s\" repeatCount=\"indefinite\" keytimes=\"0;0.3;0.6;1\" keySplines=\"0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8\" calcMode=\"spline\" />\n  </path>\n  <path opacity=\"0.25\" transform=\"translate(0 0)\" d=\"M0 12 V20 H4 V12z\">\n    <animateTransform attributeName=\"transform\" type=\"translate\" values=\"0 0; 28 0; 0 0; 0 0\" dur=\"1.5s\" begin=\"0.2s\" repeatCount=\"indefinite\" keytimes=\"0;0.3;0.6;1\" keySplines=\"0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8\" calcMode=\"spline\" />\n  </path>\n</svg>\n"
	
	/***/ }),
	/* 21 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\">\n  <path opacity=\".25\" d=\"M16 0 A16 16 0 0 0 16 32 A16 16 0 0 0 16 0 M16 4 A12 12 0 0 1 16 28 A12 12 0 0 1 16 4\"/>\n  <path d=\"M16 0 A16 16 0 0 1 32 16 L28 16 A12 12 0 0 0 16 4z\">\n    <animateTransform attributeName=\"transform\" type=\"rotate\" from=\"0 16 16\" to=\"360 16 16\" dur=\"0.8s\" repeatCount=\"indefinite\" />\n  </path>\n</svg>\n"
	
	/***/ }),
	/* 22 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\">\n  <circle cx=\"16\" cy=\"3\" r=\"0\">\n    <animate attributeName=\"r\" values=\"0;3;0;0\" dur=\"1s\" repeatCount=\"indefinite\" begin=\"0\" keySplines=\"0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8\" calcMode=\"spline\" />\n  </circle>\n  <circle transform=\"rotate(45 16 16)\" cx=\"16\" cy=\"3\" r=\"0\">\n    <animate attributeName=\"r\" values=\"0;3;0;0\" dur=\"1s\" repeatCount=\"indefinite\" begin=\"0.125s\" keySplines=\"0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8\" calcMode=\"spline\" />\n  </circle>\n  <circle transform=\"rotate(90 16 16)\" cx=\"16\" cy=\"3\" r=\"0\">\n    <animate attributeName=\"r\" values=\"0;3;0;0\" dur=\"1s\" repeatCount=\"indefinite\" begin=\"0.25s\" keySplines=\"0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8\" calcMode=\"spline\" />\n  </circle>\n  <circle transform=\"rotate(135 16 16)\" cx=\"16\" cy=\"3\" r=\"0\">\n    <animate attributeName=\"r\" values=\"0;3;0;0\" dur=\"1s\" repeatCount=\"indefinite\" begin=\"0.375s\" keySplines=\"0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8\" calcMode=\"spline\" />\n  </circle>\n  <circle transform=\"rotate(180 16 16)\" cx=\"16\" cy=\"3\" r=\"0\">\n    <animate attributeName=\"r\" values=\"0;3;0;0\" dur=\"1s\" repeatCount=\"indefinite\" begin=\"0.5s\" keySplines=\"0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8\" calcMode=\"spline\" />\n  </circle>\n  <circle transform=\"rotate(225 16 16)\" cx=\"16\" cy=\"3\" r=\"0\">\n    <animate attributeName=\"r\" values=\"0;3;0;0\" dur=\"1s\" repeatCount=\"indefinite\" begin=\"0.625s\" keySplines=\"0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8\" calcMode=\"spline\" />\n  </circle>\n  <circle transform=\"rotate(270 16 16)\" cx=\"16\" cy=\"3\" r=\"0\">\n    <animate attributeName=\"r\" values=\"0;3;0;0\" dur=\"1s\" repeatCount=\"indefinite\" begin=\"0.75s\" keySplines=\"0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8\" calcMode=\"spline\" />\n  </circle>\n  <circle transform=\"rotate(315 16 16)\" cx=\"16\" cy=\"3\" r=\"0\">\n    <animate attributeName=\"r\" values=\"0;3;0;0\" dur=\"1s\" repeatCount=\"indefinite\" begin=\"0.875s\" keySplines=\"0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8\" calcMode=\"spline\" />\n  </circle>\n  <circle transform=\"rotate(180 16 16)\" cx=\"16\" cy=\"3\" r=\"0\">\n    <animate attributeName=\"r\" values=\"0;3;0;0\" dur=\"1s\" repeatCount=\"indefinite\" begin=\"0.5s\" keySplines=\"0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8\" calcMode=\"spline\" />\n  </circle>\n</svg>\n"
	
	/***/ }),
	/* 23 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg id=\"loading\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\">\n  <path opacity=\".1\" d=\"M14 0 H18 V8 H14 z\" transform=\"rotate(0 16 16)\">\n    <animate attributeName=\"opacity\" from=\"1\" to=\".1\" dur=\"1s\" repeatCount=\"indefinite\" begin=\"0\"/>\n  </path>\n  <path opacity=\".1\" d=\"M14 0 H18 V8 H14 z\" transform=\"rotate(45 16 16)\">\n    <animate attributeName=\"opacity\" from=\"1\" to=\".1\" dur=\"1s\" repeatCount=\"indefinite\" begin=\"0.125s\"/>\n  </path>\n  <path opacity=\".1\" d=\"M14 0 H18 V8 H14 z\" transform=\"rotate(90 16 16)\">\n    <animate attributeName=\"opacity\" from=\"1\" to=\".1\" dur=\"1s\" repeatCount=\"indefinite\" begin=\"0.25s\"/>\n  </path>\n  <path opacity=\".1\" d=\"M14 0 H18 V8 H14 z\" transform=\"rotate(135 16 16)\">\n    <animate attributeName=\"opacity\" from=\"1\" to=\".1\" dur=\"1s\" repeatCount=\"indefinite\" begin=\"0.375s\"/>\n  </path>\n  <path opacity=\".1\" d=\"M14 0 H18 V8 H14 z\" transform=\"rotate(180 16 16)\">\n    <animate attributeName=\"opacity\" from=\"1\" to=\".1\" dur=\"1s\" repeatCount=\"indefinite\" begin=\"0.5s\"/>\n  </path>\n  <path opacity=\".1\" d=\"M14 0 H18 V8 H14 z\" transform=\"rotate(225 16 16)\">\n    <animate attributeName=\"opacity\" from=\"1\" to=\".1\" dur=\"1s\" repeatCount=\"indefinite\" begin=\"0.675s\"/>\n  </path>\n  <path opacity=\".1\" d=\"M14 0 H18 V8 H14 z\" transform=\"rotate(270 16 16)\">\n    <animate attributeName=\"opacity\" from=\"1\" to=\".1\" dur=\"1s\" repeatCount=\"indefinite\" begin=\"0.75s\"/>\n  </path>\n  <path opacity=\".1\" d=\"M14 0 H18 V8 H14 z\" transform=\"rotate(315 16 16)\">\n    <animate attributeName=\"opacity\" from=\"1\" to=\".1\" dur=\"1s\" repeatCount=\"indefinite\" begin=\"0.875s\"/>\n  </path>\n</svg>\n"
	
	/***/ })
	/******/ ]);
	});
	//# sourceMappingURL=react-loading.js.map

/***/ },
/* 1854 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports,'__esModule',{value:true});var react=__webpack_require__(1),reactDom=__webpack_require__(46);function _inheritsLoose(subClass, superClass) {
	  subClass.prototype = Object.create(superClass.prototype);
	  subClass.prototype.constructor = subClass;
	
	  _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;
	    return o;
	  };
	
	  return _setPrototypeOf(o, p);
	}
	
	function _objectWithoutPropertiesLoose(source, excluded) {
	  if (source == null) return {};
	  var target = {};
	  var sourceKeys = Object.keys(source);
	  var key, i;
	
	  for (i = 0; i < sourceKeys.length; i++) {
	    key = sourceKeys[i];
	    if (excluded.indexOf(key) >= 0) continue;
	    target[key] = source[key];
	  }
	
	  return target;
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return self;
	}/**
	 * Check whether some DOM node is our Component's node.
	 */
	function isNodeFound(current, componentNode, ignoreClass) {
	  if (current === componentNode) {
	    return true;
	  } // SVG <use/> elements do not technically reside in the rendered DOM, so
	  // they do not have classList directly, but they offer a link to their
	  // corresponding element, which can have classList. This extra check is for
	  // that case.
	  // See: http://www.w3.org/TR/SVG11/struct.html#InterfaceSVGUseElement
	  // Discussion: https://github.com/Pomax/react-onclickoutside/pull/17
	
	
	  if (current.correspondingElement) {
	    return current.correspondingElement.classList.contains(ignoreClass);
	  }
	
	  return current.classList.contains(ignoreClass);
	}
	/**
	 * Try to find our node in a hierarchy of nodes, returning the document
	 * node as highest node if our node is not found in the path up.
	 */
	
	function findHighest(current, componentNode, ignoreClass) {
	  if (current === componentNode) {
	    return true;
	  } // If source=local then this event came from 'somewhere'
	  // inside and should be ignored. We could handle this with
	  // a layered approach, too, but that requires going back to
	  // thinking in terms of Dom node nesting, running counter
	  // to React's 'you shouldn't care about the DOM' philosophy.
	
	
	  while (current.parentNode) {
	    if (isNodeFound(current, componentNode, ignoreClass)) {
	      return true;
	    }
	
	    current = current.parentNode;
	  }
	
	  return current;
	}
	/**
	 * Check if the browser scrollbar was clicked
	 */
	
	function clickedScrollbar(evt) {
	  return document.documentElement.clientWidth <= evt.clientX || document.documentElement.clientHeight <= evt.clientY;
	}// ideally will get replaced with external dep
	// when rafrex/detect-passive-events#4 and rafrex/detect-passive-events#5 get merged in
	var testPassiveEventSupport = function testPassiveEventSupport() {
	  if (typeof window === 'undefined' || typeof window.addEventListener !== 'function') {
	    return;
	  }
	
	  var passive = false;
	  var options = Object.defineProperty({}, 'passive', {
	    get: function get() {
	      passive = true;
	    }
	  });
	
	  var noop = function noop() {};
	
	  window.addEventListener('testPassiveEventSupport', noop, options);
	  window.removeEventListener('testPassiveEventSupport', noop, options);
	  return passive;
	};function autoInc(seed) {
	  if (seed === void 0) {
	    seed = 0;
	  }
	
	  return function () {
	    return ++seed;
	  };
	}
	
	var uid = autoInc();var passiveEventSupport;
	var handlersMap = {};
	var enabledInstances = {};
	var touchEvents = ['touchstart', 'touchmove'];
	var IGNORE_CLASS_NAME = 'ignore-react-onclickoutside';
	/**
	 * Options for addEventHandler and removeEventHandler
	 */
	
	function getEventHandlerOptions(instance, eventName) {
	  var handlerOptions = null;
	  var isTouchEvent = touchEvents.indexOf(eventName) !== -1;
	
	  if (isTouchEvent && passiveEventSupport) {
	    handlerOptions = {
	      passive: !instance.props.preventDefault
	    };
	  }
	
	  return handlerOptions;
	}
	/**
	 * This function generates the HOC function that you'll use
	 * in order to impart onOutsideClick listening to an
	 * arbitrary component. It gets called at the end of the
	 * bootstrapping code to yield an instance of the
	 * onClickOutsideHOC function defined inside setupHOC().
	 */
	
	
	function onClickOutsideHOC(WrappedComponent, config) {
	  var _class, _temp;
	
	  var componentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
	  return _temp = _class = /*#__PURE__*/function (_Component) {
	    _inheritsLoose(onClickOutside, _Component);
	
	    function onClickOutside(props) {
	      var _this;
	
	      _this = _Component.call(this, props) || this;
	
	      _this.__outsideClickHandler = function (event) {
	        if (typeof _this.__clickOutsideHandlerProp === 'function') {
	          _this.__clickOutsideHandlerProp(event);
	
	          return;
	        }
	
	        var instance = _this.getInstance();
	
	        if (typeof instance.props.handleClickOutside === 'function') {
	          instance.props.handleClickOutside(event);
	          return;
	        }
	
	        if (typeof instance.handleClickOutside === 'function') {
	          instance.handleClickOutside(event);
	          return;
	        }
	
	        throw new Error("WrappedComponent: " + componentName + " lacks a handleClickOutside(event) function for processing outside click events.");
	      };
	
	      _this.__getComponentNode = function () {
	        var instance = _this.getInstance();
	
	        if (config && typeof config.setClickOutsideRef === 'function') {
	          return config.setClickOutsideRef()(instance);
	        }
	
	        if (typeof instance.setClickOutsideRef === 'function') {
	          return instance.setClickOutsideRef();
	        }
	
	        return reactDom.findDOMNode(instance);
	      };
	
	      _this.enableOnClickOutside = function () {
	        if (typeof document === 'undefined' || enabledInstances[_this._uid]) {
	          return;
	        }
	
	        if (typeof passiveEventSupport === 'undefined') {
	          passiveEventSupport = testPassiveEventSupport();
	        }
	
	        enabledInstances[_this._uid] = true;
	        var events = _this.props.eventTypes;
	
	        if (!events.forEach) {
	          events = [events];
	        }
	
	        handlersMap[_this._uid] = function (event) {
	          if (_this.componentNode === null) return;
	
	          if (_this.props.preventDefault) {
	            event.preventDefault();
	          }
	
	          if (_this.props.stopPropagation) {
	            event.stopPropagation();
	          }
	
	          if (_this.props.excludeScrollbar && clickedScrollbar(event)) return;
	          var current = event.target;
	
	          if (findHighest(current, _this.componentNode, _this.props.outsideClickIgnoreClass) !== document) {
	            return;
	          }
	
	          _this.__outsideClickHandler(event);
	        };
	
	        events.forEach(function (eventName) {
	          document.addEventListener(eventName, handlersMap[_this._uid], getEventHandlerOptions(_assertThisInitialized(_this), eventName));
	        });
	      };
	
	      _this.disableOnClickOutside = function () {
	        delete enabledInstances[_this._uid];
	        var fn = handlersMap[_this._uid];
	
	        if (fn && typeof document !== 'undefined') {
	          var events = _this.props.eventTypes;
	
	          if (!events.forEach) {
	            events = [events];
	          }
	
	          events.forEach(function (eventName) {
	            return document.removeEventListener(eventName, fn, getEventHandlerOptions(_assertThisInitialized(_this), eventName));
	          });
	          delete handlersMap[_this._uid];
	        }
	      };
	
	      _this.getRef = function (ref) {
	        return _this.instanceRef = ref;
	      };
	
	      _this._uid = uid();
	      return _this;
	    }
	    /**
	     * Access the WrappedComponent's instance.
	     */
	
	
	    var _proto = onClickOutside.prototype;
	
	    _proto.getInstance = function getInstance() {
	      if (WrappedComponent.prototype && !WrappedComponent.prototype.isReactComponent) {
	        return this;
	      }
	
	      var ref = this.instanceRef;
	      return ref.getInstance ? ref.getInstance() : ref;
	    };
	
	    /**
	     * Add click listeners to the current document,
	     * linked to this component's state.
	     */
	    _proto.componentDidMount = function componentDidMount() {
	      // If we are in an environment without a DOM such
	      // as shallow rendering or snapshots then we exit
	      // early to prevent any unhandled errors being thrown.
	      if (typeof document === 'undefined' || !document.createElement) {
	        return;
	      }
	
	      var instance = this.getInstance();
	
	      if (config && typeof config.handleClickOutside === 'function') {
	        this.__clickOutsideHandlerProp = config.handleClickOutside(instance);
	
	        if (typeof this.__clickOutsideHandlerProp !== 'function') {
	          throw new Error("WrappedComponent: " + componentName + " lacks a function for processing outside click events specified by the handleClickOutside config option.");
	        }
	      }
	
	      this.componentNode = this.__getComponentNode(); // return early so we dont initiate onClickOutside
	
	      if (this.props.disableOnClickOutside) return;
	      this.enableOnClickOutside();
	    };
	
	    _proto.componentDidUpdate = function componentDidUpdate() {
	      this.componentNode = this.__getComponentNode();
	    }
	    /**
	     * Remove all document's event listeners for this component
	     */
	    ;
	
	    _proto.componentWillUnmount = function componentWillUnmount() {
	      this.disableOnClickOutside();
	    }
	    /**
	     * Can be called to explicitly enable event listening
	     * for clicks and touches outside of this element.
	     */
	    ;
	
	    /**
	     * Pass-through render
	     */
	    _proto.render = function render() {
	      // eslint-disable-next-line no-unused-vars
	      var _this$props = this.props;
	          _this$props.excludeScrollbar;
	          var props = _objectWithoutPropertiesLoose(_this$props, ["excludeScrollbar"]);
	
	      if (WrappedComponent.prototype && WrappedComponent.prototype.isReactComponent) {
	        props.ref = this.getRef;
	      } else {
	        props.wrappedRef = this.getRef;
	      }
	
	      props.disableOnClickOutside = this.disableOnClickOutside;
	      props.enableOnClickOutside = this.enableOnClickOutside;
	      return react.createElement(WrappedComponent, props);
	    };
	
	    return onClickOutside;
	  }(react.Component), _class.displayName = "OnClickOutside(" + componentName + ")", _class.defaultProps = {
	    eventTypes: ['mousedown', 'touchstart'],
	    excludeScrollbar: config && config.excludeScrollbar || false,
	    outsideClickIgnoreClass: IGNORE_CLASS_NAME,
	    preventDefault: false,
	    stopPropagation: false
	  }, _class.getClass = function () {
	    return WrappedComponent.getClass ? WrappedComponent.getClass() : WrappedComponent;
	  }, _temp;
	}exports.IGNORE_CLASS_NAME=IGNORE_CLASS_NAME;exports.default=onClickOutsideHOC;

/***/ },
/* 1855 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _componentOrElement = __webpack_require__(213);
	
	var _componentOrElement2 = _interopRequireDefault(_componentOrElement);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(46);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _getContainer = __webpack_require__(220);
	
	var _getContainer2 = _interopRequireDefault(_getContainer);
	
	var _ownerDocument = __webpack_require__(132);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `<Portal/>` component renders its children into a new "subtree" outside of current component hierarchy.
	 * You can think of it as a declarative `appendChild()`, or jQuery's `$.fn.appendTo()`.
	 * The children of `<Portal/>` component will be appended to the `container` specified.
	 */
	var Portal = function (_React$Component) {
	  _inherits(Portal, _React$Component);
	
	  function Portal() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Portal);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this._mountOverlayTarget = function () {
	      if (!_this._overlayTarget) {
	        _this._overlayTarget = document.createElement('div');
	        _this._portalContainerNode = (0, _getContainer2.default)(_this.props.container, (0, _ownerDocument2.default)(_this).body);
	        _this._portalContainerNode.appendChild(_this._overlayTarget);
	      }
	    }, _this._unmountOverlayTarget = function () {
	      if (_this._overlayTarget) {
	        _this._portalContainerNode.removeChild(_this._overlayTarget);
	        _this._overlayTarget = null;
	      }
	      _this._portalContainerNode = null;
	    }, _this._renderOverlay = function () {
	      var overlay = !_this.props.children ? null : _react2.default.Children.only(_this.props.children);
	
	      // Save reference for future access.
	      if (overlay !== null) {
	        _this._mountOverlayTarget();
	
	        var initialRender = !_this._overlayInstance;
	
	        _this._overlayInstance = _reactDom2.default.unstable_renderSubtreeIntoContainer(_this, overlay, _this._overlayTarget, function () {
	          if (initialRender && _this.props.onRendered) {
	            _this.props.onRendered();
	          }
	        });
	      } else {
	        // Unrender if the component is null for transitions to null
	        _this._unrenderOverlay();
	        _this._unmountOverlayTarget();
	      }
	    }, _this._unrenderOverlay = function () {
	      if (_this._overlayTarget) {
	        _reactDom2.default.unmountComponentAtNode(_this._overlayTarget);
	        _this._overlayInstance = null;
	      }
	    }, _this.getMountNode = function () {
	      return _this._overlayTarget;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Portal.prototype.componentDidMount = function componentDidMount() {
	    this._isMounted = true;
	    this._renderOverlay();
	  };
	
	  Portal.prototype.componentDidUpdate = function componentDidUpdate() {
	    this._renderOverlay();
	  };
	
	  Portal.prototype.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps(nextProps) {
	    if (this._overlayTarget && nextProps.container !== this.props.container) {
	      this._portalContainerNode.removeChild(this._overlayTarget);
	      this._portalContainerNode = (0, _getContainer2.default)(nextProps.container, (0, _ownerDocument2.default)(this).body);
	      this._portalContainerNode.appendChild(this._overlayTarget);
	    }
	  };
	
	  Portal.prototype.componentWillUnmount = function componentWillUnmount() {
	    this._isMounted = false;
	    this._unrenderOverlay();
	    this._unmountOverlayTarget();
	  };
	
	  Portal.prototype.render = function render() {
	    return null;
	  };
	
	  return Portal;
	}(_react2.default.Component);
	
	Portal.displayName = 'Portal';
	Portal.propTypes = {
	  /**
	   * A Node, Component instance, or function that returns either. The `container` will have the Portal children
	   * appended to it.
	   */
	  container: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),
	
	  onRendered: _propTypes2.default.func
	};
	exports.default = Portal;
	module.exports = exports['default'];

/***/ },
/* 1856 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _activeElement = __webpack_require__(455);
	
	var _activeElement2 = _interopRequireDefault(_activeElement);
	
	var _contains = __webpack_require__(130);
	
	var _contains2 = _interopRequireDefault(_contains);
	
	var _inDOM = __webpack_require__(84);
	
	var _inDOM2 = _interopRequireDefault(_inDOM);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _componentOrElement = __webpack_require__(213);
	
	var _componentOrElement2 = _interopRequireDefault(_componentOrElement);
	
	var _deprecated = __webpack_require__(1759);
	
	var _deprecated2 = _interopRequireDefault(_deprecated);
	
	var _elementType = __webpack_require__(32);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(46);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _warning = __webpack_require__(59);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _ModalManager = __webpack_require__(1857);
	
	var _ModalManager2 = _interopRequireDefault(_ModalManager);
	
	var _Portal = __webpack_require__(524);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _RefHolder = __webpack_require__(1860);
	
	var _RefHolder2 = _interopRequireDefault(_RefHolder);
	
	var _addEventListener = __webpack_require__(526);
	
	var _addEventListener2 = _interopRequireDefault(_addEventListener);
	
	var _addFocusListener = __webpack_require__(1861);
	
	var _addFocusListener2 = _interopRequireDefault(_addFocusListener);
	
	var _getContainer = __webpack_require__(220);
	
	var _getContainer2 = _interopRequireDefault(_getContainer);
	
	var _ownerDocument = __webpack_require__(132);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable react/prop-types */
	
	var modalManager = new _ModalManager2.default();
	
	/**
	 * Love them or hate them, `<Modal/>` provides a solid foundation for creating dialogs, lightboxes, or whatever else.
	 * The Modal component renders its `children` node in front of a backdrop component.
	 *
	 * The Modal offers a few helpful features over using just a `<Portal/>` component and some styles:
	 *
	 * - Manages dialog stacking when one-at-a-time just isn't enough.
	 * - Creates a backdrop, for disabling interaction below the modal.
	 * - It properly manages focus; moving to the modal content, and keeping it there until the modal is closed.
	 * - It disables scrolling of the page content while open.
	 * - Adds the appropriate ARIA roles are automatically.
	 * - Easily pluggable animations via a `<Transition/>` component.
	 *
	 * Note that, in the same way the backdrop element prevents users from clicking or interacting
	 * with the page content underneath the Modal, Screen readers also need to be signaled to not to
	 * interact with page content while the Modal is open. To do this, we use a common technique of applying
	 * the `aria-hidden='true'` attribute to the non-Modal elements in the Modal `container`. This means that for
	 * a Modal to be truly modal, it should have a `container` that is _outside_ your app's
	 * React hierarchy (such as the default: document.body).
	 */
	
	var Modal = function (_React$Component) {
	  _inherits(Modal, _React$Component);
	
	  function Modal() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Modal);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Modal.prototype.omitProps = function omitProps(props, propTypes) {
	
	    var keys = Object.keys(props);
	    var newProps = {};
	    keys.map(function (prop) {
	      if (!Object.prototype.hasOwnProperty.call(propTypes, prop)) {
	        newProps[prop] = props[prop];
	      }
	    });
	
	    return newProps;
	  };
	
	  Modal.prototype.render = function render() {
	    var _props = this.props,
	        show = _props.show,
	        container = _props.container,
	        children = _props.children,
	        Transition = _props.transition,
	        backdrop = _props.backdrop,
	        className = _props.className,
	        style = _props.style,
	        onExit = _props.onExit,
	        onExiting = _props.onExiting,
	        onEnter = _props.onEnter,
	        onEntering = _props.onEntering,
	        onEntered = _props.onEntered;
	
	
	    var dialog = _react2.default.Children.only(children);
	    var filteredProps = this.omitProps(this.props, Modal.propTypes);
	
	    var mountModal = show || Transition && !this.state.exited;
	    if (!mountModal) {
	      return null;
	    }
	
	    var _dialog$props = dialog.props,
	        role = _dialog$props.role,
	        tabIndex = _dialog$props.tabIndex;
	
	
	    if (role === undefined || tabIndex === undefined) {
	      dialog = (0, _react.cloneElement)(dialog, {
	        role: role === undefined ? 'document' : role,
	        tabIndex: tabIndex == null ? '-1' : tabIndex
	      });
	    }
	
	    if (Transition) {
	      dialog = _react2.default.createElement(
	        Transition,
	        {
	          appear: true,
	          unmountOnExit: true,
	          'in': show,
	          onExit: onExit,
	          onExiting: onExiting,
	          onExited: this.handleHidden,
	          onEnter: onEnter,
	          onEntering: onEntering,
	          onEntered: onEntered
	        },
	        dialog
	      );
	    }
	
	    return _react2.default.createElement(
	      _Portal2.default,
	      {
	        ref: this.setMountNode,
	        container: container,
	        onRendered: this.onPortalRendered
	      },
	      _react2.default.createElement(
	        'div',
	        _extends({
	          ref: this.setModalNodeRef,
	          role: role || 'dialog'
	        }, filteredProps, {
	          style: style,
	          className: className
	        }),
	        backdrop && this.renderBackdrop(),
	        _react2.default.createElement(
	          _RefHolder2.default,
	          { ref: this.setDialogRef },
	          dialog
	        )
	      )
	    );
	  };
	
	  Modal.prototype.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps(nextProps) {
	    if (nextProps.show) {
	      this.setState({ exited: false });
	    } else if (!nextProps.transition) {
	      // Otherwise let handleHidden take care of marking exited.
	      this.setState({ exited: true });
	    }
	  };
	
	  Modal.prototype.UNSAFE_componentWillUpdate = function UNSAFE_componentWillUpdate(nextProps) {
	    if (!this.props.show && nextProps.show) {
	      this.checkForFocus();
	    }
	  };
	
	  Modal.prototype.componentDidMount = function componentDidMount() {
	    this._isMounted = true;
	    if (this.props.show) {
	      this.onShow();
	    }
	  };
	
	  Modal.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var transition = this.props.transition;
	
	
	    if (prevProps.show && !this.props.show && !transition) {
	      // Otherwise handleHidden will call this.
	      this.onHide();
	    } else if (!prevProps.show && this.props.show) {
	      this.onShow();
	    }
	  };
	
	  Modal.prototype.componentWillUnmount = function componentWillUnmount() {
	    var _props2 = this.props,
	        show = _props2.show,
	        transition = _props2.transition;
	
	
	    this._isMounted = false;
	
	    if (show || transition && !this.state.exited) {
	      this.onHide();
	    }
	  };
	
	  Modal.prototype.autoFocus = function autoFocus() {
	    if (!this.props.autoFocus) {
	      return;
	    }
	
	    var dialogElement = this.getDialogElement();
	    var currentActiveElement = (0, _activeElement2.default)((0, _ownerDocument2.default)(this));
	
	    if (dialogElement && !(0, _contains2.default)(dialogElement, currentActiveElement)) {
	      this.lastFocus = currentActiveElement;
	
	      if (!dialogElement.hasAttribute('tabIndex')) {
	        (0, _warning2.default)(false, 'The modal content node does not accept focus. For the benefit of ' + 'assistive technologies, the tabIndex of the node is being set ' + 'to "-1".');
	
	        dialogElement.setAttribute('tabIndex', -1);
	      }
	
	      dialogElement.focus();
	    }
	  };
	
	  Modal.prototype.restoreLastFocus = function restoreLastFocus() {
	    // Support: <=IE11 doesn't support `focus()` on svg elements (RB: #917)
	    if (this.lastFocus && this.lastFocus.focus) {
	      this.lastFocus.focus();
	      this.lastFocus = null;
	    }
	  };
	
	  Modal.prototype.getDialogElement = function getDialogElement() {
	    return _reactDom2.default.findDOMNode(this.dialog);
	  };
	
	  Modal.prototype.isTopModal = function isTopModal() {
	    return this.props.manager.isTopModal(this);
	  };
	
	  return Modal;
	}(_react2.default.Component);
	
	Modal.propTypes = _extends({}, _Portal2.default.propTypes, {
	
	  /**
	   * Set the visibility of the Modal
	   */
	  show: _propTypes2.default.bool,
	
	  /**
	   * A Node, Component instance, or function that returns either. The Modal is appended to it's container element.
	   *
	   * For the sake of assistive technologies, the container should usually be the document body, so that the rest of the
	   * page content can be placed behind a virtual backdrop as well as a visual one.
	   */
	  container: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),
	
	  /**
	   * A callback fired when the Modal is opening.
	   */
	  onShow: _propTypes2.default.func,
	
	  /**
	   * A callback fired when either the backdrop is clicked, or the escape key is pressed.
	   *
	   * The `onHide` callback only signals intent from the Modal,
	   * you must actually set the `show` prop to `false` for the Modal to close.
	   */
	  onHide: _propTypes2.default.func,
	
	  /**
	   * Include a backdrop component.
	   */
	  backdrop: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.oneOf(['static'])]),
	
	  /**
	   * A function that returns a backdrop component. Useful for custom
	   * backdrop rendering.
	   *
	   * ```js
	   *  renderBackdrop={props => <MyBackdrop {...props} />}
	   * ```
	   */
	  renderBackdrop: _propTypes2.default.func,
	
	  /**
	   * A callback fired when the escape key, if specified in `keyboard`, is pressed.
	   */
	  onEscapeKeyDown: _propTypes2.default.func,
	
	  /**
	   * Support for this function will be deprecated. Please use `onEscapeKeyDown` instead
	   * A callback fired when the escape key, if specified in `keyboard`, is pressed.
	   * @deprecated
	   */
	  onEscapeKeyUp: (0, _deprecated2.default)(_propTypes2.default.func, 'Please use onEscapeKeyDown instead for consistency'),
	
	  /**
	   * A callback fired when the backdrop, if specified, is clicked.
	   */
	  onBackdropClick: _propTypes2.default.func,
	
	  /**
	   * A style object for the backdrop component.
	   */
	  backdropStyle: _propTypes2.default.object,
	
	  /**
	   * A css class or classes for the backdrop component.
	   */
	  backdropClassName: _propTypes2.default.string,
	
	  /**
	   * A css class or set of classes applied to the modal container when the modal is open,
	   * and removed when it is closed.
	   */
	  containerClassName: _propTypes2.default.string,
	
	  /**
	   * Close the modal when escape key is pressed
	   */
	  keyboard: _propTypes2.default.bool,
	
	  /**
	   * A `react-transition-group@2.0.0` `<Transition/>` component used
	   * to control animations for the dialog component.
	   */
	  transition: _elementType2.default,
	
	  /**
	   * A `react-transition-group@2.0.0` `<Transition/>` component used
	   * to control animations for the backdrop components.
	   */
	  backdropTransition: _elementType2.default,
	
	  /**
	   * When `true` The modal will automatically shift focus to itself when it opens, and
	   * replace it to the last focused element when it closes. This also
	   * works correctly with any Modal children that have the `autoFocus` prop.
	   *
	   * Generally this should never be set to `false` as it makes the Modal less
	   * accessible to assistive technologies, like screen readers.
	   */
	  autoFocus: _propTypes2.default.bool,
	
	  /**
	   * When `true` The modal will prevent focus from leaving the Modal while open.
	   *
	   * Generally this should never be set to `false` as it makes the Modal less
	   * accessible to assistive technologies, like screen readers.
	   */
	  enforceFocus: _propTypes2.default.bool,
	
	  /**
	   * When `true` The modal will restore focus to previously focused element once
	   * modal is hidden
	   */
	  restoreFocus: _propTypes2.default.bool,
	
	  /**
	   * Callback fired before the Modal transitions in
	   */
	  onEnter: _propTypes2.default.func,
	
	  /**
	   * Callback fired as the Modal begins to transition in
	   */
	  onEntering: _propTypes2.default.func,
	
	  /**
	   * Callback fired after the Modal finishes transitioning in
	   */
	  onEntered: _propTypes2.default.func,
	
	  /**
	   * Callback fired right before the Modal transitions out
	   */
	  onExit: _propTypes2.default.func,
	
	  /**
	   * Callback fired as the Modal begins to transition out
	   */
	  onExiting: _propTypes2.default.func,
	
	  /**
	   * Callback fired after the Modal finishes transitioning out
	   */
	  onExited: _propTypes2.default.func,
	
	  /**
	   * A ModalManager instance used to track and manage the state of open
	   * Modals. Useful when customizing how modals interact within a container
	   */
	  manager: _propTypes2.default.object.isRequired
	});
	Modal.defaultProps = {
	  show: false,
	  backdrop: true,
	  keyboard: true,
	  autoFocus: true,
	  enforceFocus: true,
	  restoreFocus: true,
	  onHide: function onHide() {},
	  manager: modalManager,
	  renderBackdrop: function renderBackdrop(props) {
	    return _react2.default.createElement('div', props);
	  }
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this.state = { exited: !this.props.show };
	
	  this.renderBackdrop = function () {
	    var _props3 = _this2.props,
	        backdropStyle = _props3.backdropStyle,
	        backdropClassName = _props3.backdropClassName,
	        renderBackdrop = _props3.renderBackdrop,
	        Transition = _props3.backdropTransition;
	
	
	    var backdropRef = function backdropRef(ref) {
	      return _this2.backdrop = ref;
	    };
	
	    var backdrop = renderBackdrop({
	      ref: backdropRef,
	      style: backdropStyle,
	      className: backdropClassName,
	      onClick: _this2.handleBackdropClick
	    });
	
	    if (Transition) {
	      backdrop = _react2.default.createElement(
	        Transition,
	        {
	          appear: true,
	          'in': _this2.props.show
	        },
	        backdrop
	      );
	    }
	
	    return backdrop;
	  };
	
	  this.onPortalRendered = function () {
	    _this2.autoFocus();
	
	    if (_this2.props.onShow) {
	      _this2.props.onShow();
	    }
	  };
	
	  this.onShow = function () {
	    var doc = (0, _ownerDocument2.default)(_this2);
	    var container = (0, _getContainer2.default)(_this2.props.container, doc.body);
	
	    _this2.props.manager.add(_this2, container, _this2.props.containerClassName);
	
	    _this2._onDocumentKeydownListener = (0, _addEventListener2.default)(doc, 'keydown', _this2.handleDocumentKeyDown);
	
	    _this2._onDocumentKeyupListener = (0, _addEventListener2.default)(doc, 'keyup', _this2.handleDocumentKeyUp);
	
	    _this2._onFocusinListener = (0, _addFocusListener2.default)(_this2.enforceFocus);
	  };
	
	  this.onHide = function () {
	    _this2.props.manager.remove(_this2);
	
	    _this2._onDocumentKeydownListener.remove();
	
	    _this2._onDocumentKeyupListener.remove();
	
	    _this2._onFocusinListener.remove();
	
	    if (_this2.props.restoreFocus) {
	      _this2.restoreLastFocus();
	    }
	  };
	
	  this.setMountNode = function (ref) {
	    _this2.mountNode = ref ? ref.getMountNode() : ref;
	  };
	
	  this.setModalNodeRef = function (ref) {
	    _this2.modalNode = ref;
	  };
	
	  this.setDialogRef = function (ref) {
	    _this2.dialog = ref;
	  };
	
	  this.handleHidden = function () {
	    _this2.setState({ exited: true });
	    _this2.onHide();
	
	    if (_this2.props.onExited) {
	      var _props4;
	
	      (_props4 = _this2.props).onExited.apply(_props4, arguments);
	    }
	  };
	
	  this.handleBackdropClick = function (e) {
	    if (e.target !== e.currentTarget) {
	      return;
	    }
	
	    if (_this2.props.onBackdropClick) {
	      _this2.props.onBackdropClick(e);
	    }
	
	    if (_this2.props.backdrop === true) {
	      _this2.props.onHide();
	    }
	  };
	
	  this.handleDocumentKeyDown = function (e) {
	    if (_this2.props.keyboard && e.keyCode === 27 && _this2.isTopModal()) {
	      if (_this2.props.onEscapeKeyDown) {
	        _this2.props.onEscapeKeyDown(e);
	      }
	
	      _this2.props.onHide();
	    }
	  };
	
	  this.handleDocumentKeyUp = function (e) {
	    if (_this2.props.keyboard && e.keyCode === 27 && _this2.isTopModal()) {
	      if (_this2.props.onEscapeKeyUp) {
	        _this2.props.onEscapeKeyUp(e);
	      }
	    }
	  };
	
	  this.checkForFocus = function () {
	    if (_inDOM2.default) {
	      _this2.lastFocus = (0, _activeElement2.default)();
	    }
	  };
	
	  this.enforceFocus = function () {
	    if (!_this2.props.enforceFocus || !_this2._isMounted || !_this2.isTopModal()) {
	      return;
	    }
	
	    var dialogElement = _this2.getDialogElement();
	    var currentActiveElement = (0, _activeElement2.default)((0, _ownerDocument2.default)(_this2));
	
	    if (dialogElement && !(0, _contains2.default)(dialogElement, currentActiveElement)) {
	      dialogElement.focus();
	    }
	  };
	};
	
	Modal.Manager = _ModalManager2.default;
	
	exports.default = Modal;
	module.exports = exports['default'];

/***/ },
/* 1857 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _class = __webpack_require__(1578);
	
	var _class2 = _interopRequireDefault(_class);
	
	var _style = __webpack_require__(154);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _scrollbarSize = __webpack_require__(460);
	
	var _scrollbarSize2 = _interopRequireDefault(_scrollbarSize);
	
	var _isOverflowing = __webpack_require__(527);
	
	var _isOverflowing2 = _interopRequireDefault(_isOverflowing);
	
	var _manageAriaHidden = __webpack_require__(1863);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function findIndexOf(arr, cb) {
	  var idx = -1;
	  arr.some(function (d, i) {
	    if (cb(d, i)) {
	      idx = i;
	      return true;
	    }
	  });
	  return idx;
	}
	
	function findContainer(data, modal) {
	  return findIndexOf(data, function (d) {
	    return d.modals.indexOf(modal) !== -1;
	  });
	}
	
	function setContainerStyle(state, container) {
	  var style = { overflow: 'hidden' };
	
	  // we are only interested in the actual `style` here
	  // becasue we will override it
	  state.style = {
	    overflow: container.style.overflow,
	    paddingRight: container.style.paddingRight
	  };
	
	  if (state.overflowing) {
	    // use computed style, here to get the real padding
	    // to add our scrollbar width
	    style.paddingRight = parseInt((0, _style2.default)(container, 'paddingRight') || 0, 10) + (0, _scrollbarSize2.default)() + 'px';
	  }
	
	  (0, _style2.default)(container, style);
	}
	
	function removeContainerStyle(_ref, container) {
	  var style = _ref.style;
	
	
	  Object.keys(style).forEach(function (key) {
	    return container.style[key] = style[key];
	  });
	}
	/**
	 * Proper state managment for containers and the modals in those containers.
	 *
	 * @internal Used by the Modal to ensure proper styling of containers.
	 */
	
	var ModalManager = function ModalManager() {
	  var _this = this;
	
	  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      _ref2$hideSiblingNode = _ref2.hideSiblingNodes,
	      hideSiblingNodes = _ref2$hideSiblingNode === undefined ? true : _ref2$hideSiblingNode,
	      _ref2$handleContainer = _ref2.handleContainerOverflow,
	      handleContainerOverflow = _ref2$handleContainer === undefined ? true : _ref2$handleContainer;
	
	  _classCallCheck(this, ModalManager);
	
	  this.add = function (modal, container, className) {
	    var modalIdx = _this.modals.indexOf(modal);
	    var containerIdx = _this.containers.indexOf(container);
	
	    if (modalIdx !== -1) {
	      return modalIdx;
	    }
	
	    modalIdx = _this.modals.length;
	    _this.modals.push(modal);
	
	    if (_this.hideSiblingNodes) {
	      (0, _manageAriaHidden.hideSiblings)(container, modal.modalNode);
	    }
	
	    if (containerIdx !== -1) {
	      _this.data[containerIdx].modals.push(modal);
	      return modalIdx;
	    }
	
	    var data = {
	      modals: [modal],
	      //right now only the first modal of a container will have its classes applied
	      classes: className ? className.split(/\s+/) : [],
	
	      overflowing: (0, _isOverflowing2.default)(container)
	    };
	
	    if (_this.handleContainerOverflow) {
	      setContainerStyle(data, container);
	    }
	
	    data.classes.forEach(_class2.default.addClass.bind(null, container));
	
	    _this.containers.push(container);
	    _this.data.push(data);
	
	    return modalIdx;
	  };
	
	  this.remove = function (modal) {
	    var modalIdx = _this.modals.indexOf(modal);
	
	    if (modalIdx === -1) {
	      return;
	    }
	
	    var containerIdx = findContainer(_this.data, modal);
	    var data = _this.data[containerIdx];
	    var container = _this.containers[containerIdx];
	
	    data.modals.splice(data.modals.indexOf(modal), 1);
	
	    _this.modals.splice(modalIdx, 1);
	
	    // if that was the last modal in a container,
	    // clean up the container
	    if (data.modals.length === 0) {
	      data.classes.forEach(_class2.default.removeClass.bind(null, container));
	
	      if (_this.handleContainerOverflow) {
	        removeContainerStyle(data, container);
	      }
	
	      if (_this.hideSiblingNodes) {
	        (0, _manageAriaHidden.showSiblings)(container, modal.modalNode);
	      }
	      _this.containers.splice(containerIdx, 1);
	      _this.data.splice(containerIdx, 1);
	    } else if (_this.hideSiblingNodes) {
	      //otherwise make sure the next top modal is visible to a SR
	      (0, _manageAriaHidden.ariaHidden)(false, data.modals[data.modals.length - 1].modalNode);
	    }
	  };
	
	  this.isTopModal = function (modal) {
	    return !!_this.modals.length && _this.modals[_this.modals.length - 1] === modal;
	  };
	
	  this.hideSiblingNodes = hideSiblingNodes;
	  this.handleContainerOverflow = handleContainerOverflow;
	  this.modals = [];
	  this.containers = [];
	  this.data = [];
	};
	
	exports.default = ModalManager;
	module.exports = exports['default'];

/***/ },
/* 1858 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(32);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Portal = __webpack_require__(524);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _Position = __webpack_require__(1859);
	
	var _Position2 = _interopRequireDefault(_Position);
	
	var _RootCloseWrapper = __webpack_require__(525);
	
	var _RootCloseWrapper2 = _interopRequireDefault(_RootCloseWrapper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Built on top of `<Position/>` and `<Portal/>`, the overlay component is great for custom tooltip overlays.
	 */
	var Overlay = function (_React$Component) {
	  _inherits(Overlay, _React$Component);
	
	  function Overlay(props, context) {
	    _classCallCheck(this, Overlay);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	    _this.handleHidden = function () {
	      _this.setState({ exited: true });
	
	      if (_this.props.onExited) {
	        var _this$props;
	
	        (_this$props = _this.props).onExited.apply(_this$props, arguments);
	      }
	    };
	
	    _this.state = { exited: !props.show };
	    _this.onHiddenListener = _this.handleHidden.bind(_this);
	    return _this;
	  }
	
	  Overlay.prototype.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps(nextProps) {
	    if (nextProps.show) {
	      this.setState({ exited: false });
	    } else if (!nextProps.transition) {
	      // Otherwise let handleHidden take care of marking exited.
	      this.setState({ exited: true });
	    }
	  };
	
	  Overlay.prototype.render = function render() {
	    var _props = this.props,
	        container = _props.container,
	        containerPadding = _props.containerPadding,
	        target = _props.target,
	        placement = _props.placement,
	        shouldUpdatePosition = _props.shouldUpdatePosition,
	        rootClose = _props.rootClose,
	        children = _props.children,
	        Transition = _props.transition,
	        props = _objectWithoutProperties(_props, ['container', 'containerPadding', 'target', 'placement', 'shouldUpdatePosition', 'rootClose', 'children', 'transition']);
	
	    // Don't un-render the overlay while it's transitioning out.
	
	
	    var mountOverlay = props.show || Transition && !this.state.exited;
	    if (!mountOverlay) {
	      // Don't bother showing anything if we don't have to.
	      return null;
	    }
	
	    var child = children;
	
	    // Position is be inner-most because it adds inline styles into the child,
	    // which the other wrappers don't forward correctly.
	    child = _react2.default.createElement(
	      _Position2.default,
	      { container: container, containerPadding: containerPadding, target: target, placement: placement, shouldUpdatePosition: shouldUpdatePosition },
	      child
	    );
	
	    if (Transition) {
	      var onExit = props.onExit,
	          onExiting = props.onExiting,
	          onEnter = props.onEnter,
	          onEntering = props.onEntering,
	          onEntered = props.onEntered;
	
	      // This animates the child node by injecting props, so it must precede
	      // anything that adds a wrapping div.
	
	      child = _react2.default.createElement(
	        Transition,
	        {
	          'in': props.show,
	          appear: true,
	          onExit: onExit,
	          onExiting: onExiting,
	          onExited: this.onHiddenListener,
	          onEnter: onEnter,
	          onEntering: onEntering,
	          onEntered: onEntered
	        },
	        child
	      );
	    }
	
	    // This goes after everything else because it adds a wrapping div.
	    if (rootClose) {
	      child = _react2.default.createElement(
	        _RootCloseWrapper2.default,
	        {
	          onRootClose: props.onHide,
	          event: props.rootCloseEvent
	        },
	        child
	      );
	    }
	
	    return _react2.default.createElement(
	      _Portal2.default,
	      { container: container },
	      child
	    );
	  };
	
	  return Overlay;
	}(_react2.default.Component);
	
	Overlay.propTypes = _extends({}, _Portal2.default.propTypes, _Position2.default.propTypes, {
	
	  /**
	   * Set the visibility of the Overlay
	   */
	  show: _propTypes2.default.bool,
	
	  /**
	   * Specify whether the overlay should trigger `onHide` when the user clicks outside the overlay
	   */
	  rootClose: _propTypes2.default.bool,
	
	  /**
	   * Specify event for toggling overlay
	   */
	  rootCloseEvent: _RootCloseWrapper2.default.propTypes.event,
	
	  /**
	   * A Callback fired by the Overlay when it wishes to be hidden.
	   *
	   * __required__ when `rootClose` is `true`.
	   *
	   * @type func
	   */
	  onHide: function onHide(props) {
	    var propType = _propTypes2.default.func;
	    if (props.rootClose) {
	      propType = propType.isRequired;
	    }
	
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    return propType.apply(undefined, [props].concat(args));
	  },
	
	
	  /**
	   * A `react-transition-group@2.0.0` `<Transition/>` component
	   * used to animate the overlay as it changes visibility.
	   */
	  transition: _elementType2.default,
	
	  /**
	   * Callback fired before the Overlay transitions in
	   */
	  onEnter: _propTypes2.default.func,
	
	  /**
	   * Callback fired as the Overlay begins to transition in
	   */
	  onEntering: _propTypes2.default.func,
	
	  /**
	   * Callback fired after the Overlay finishes transitioning in
	   */
	  onEntered: _propTypes2.default.func,
	
	  /**
	   * Callback fired right before the Overlay transitions out
	   */
	  onExit: _propTypes2.default.func,
	
	  /**
	   * Callback fired as the Overlay begins to transition out
	   */
	  onExiting: _propTypes2.default.func,
	
	  /**
	   * Callback fired after the Overlay finishes transitioning out
	   */
	  onExited: _propTypes2.default.func
	});
	
	exports.default = Overlay;
	module.exports = exports['default'];

/***/ },
/* 1859 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _componentOrElement = __webpack_require__(213);
	
	var _componentOrElement2 = _interopRequireDefault(_componentOrElement);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(46);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _calculatePosition = __webpack_require__(1862);
	
	var _calculatePosition2 = _interopRequireDefault(_calculatePosition);
	
	var _getContainer = __webpack_require__(220);
	
	var _getContainer2 = _interopRequireDefault(_getContainer);
	
	var _ownerDocument = __webpack_require__(132);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The Position component calculates the coordinates for its child, to position
	 * it relative to a `target` component or node. Useful for creating callouts
	 * and tooltips, the Position component injects a `style` props with `left` and
	 * `top` values for positioning your component.
	 *
	 * It also injects "arrow" `left`, and `top` values for styling callout arrows
	 * for giving your components a sense of directionality.
	 */
	var Position = function (_React$Component) {
	  _inherits(Position, _React$Component);
	
	  function Position(props, context) {
	    _classCallCheck(this, Position);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	    _this.getTarget = function () {
	      var target = _this.props.target;
	
	      var targetElement = typeof target === 'function' ? target() : target;
	      return targetElement && _reactDom2.default.findDOMNode(targetElement) || null;
	    };
	
	    _this.maybeUpdatePosition = function (placementChanged) {
	      var target = _this.getTarget();
	
	      if (!_this.props.shouldUpdatePosition && target === _this._lastTarget && !placementChanged) {
	        return;
	      }
	
	      _this.updatePosition(target);
	    };
	
	    _this.state = {
	      positionLeft: 0,
	      positionTop: 0,
	      arrowOffsetLeft: null,
	      arrowOffsetTop: null
	    };
	
	    _this._needsFlush = false;
	    _this._lastTarget = null;
	    return _this;
	  }
	
	  Position.prototype.componentDidMount = function componentDidMount() {
	    this.updatePosition(this.getTarget());
	  };
	
	  Position.prototype.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps() {
	    this._needsFlush = true;
	  };
	
	  Position.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    if (this._needsFlush) {
	      this._needsFlush = false;
	      this.maybeUpdatePosition(this.props.placement !== prevProps.placement);
	    }
	  };
	
	  Position.prototype.render = function render() {
	    var _props = this.props,
	        children = _props.children,
	        className = _props.className,
	        props = _objectWithoutProperties(_props, ['children', 'className']);
	
	    var _state = this.state,
	        positionLeft = _state.positionLeft,
	        positionTop = _state.positionTop,
	        arrowPosition = _objectWithoutProperties(_state, ['positionLeft', 'positionTop']);
	
	    // These should not be forwarded to the child.
	
	
	    delete props.target;
	    delete props.container;
	    delete props.containerPadding;
	    delete props.shouldUpdatePosition;
	
	    var child = _react2.default.Children.only(children);
	    return (0, _react.cloneElement)(child, _extends({}, props, arrowPosition, {
	      // FIXME: Don't forward `positionLeft` and `positionTop` via both props
	      // and `props.style`.
	      positionLeft: positionLeft,
	      positionTop: positionTop,
	      className: (0, _classnames2.default)(className, child.props.className),
	      style: _extends({}, child.props.style, {
	        left: positionLeft,
	        top: positionTop
	      })
	    }));
	  };
	
	  Position.prototype.updatePosition = function updatePosition(target) {
	    this._lastTarget = target;
	
	    if (!target) {
	      this.setState({
	        positionLeft: 0,
	        positionTop: 0,
	        arrowOffsetLeft: null,
	        arrowOffsetTop: null
	      });
	
	      return;
	    }
	
	    var overlay = _reactDom2.default.findDOMNode(this);
	    var container = (0, _getContainer2.default)(this.props.container, (0, _ownerDocument2.default)(this).body);
	
	    this.setState((0, _calculatePosition2.default)(this.props.placement, overlay, target, container, this.props.containerPadding));
	  };
	
	  return Position;
	}(_react2.default.Component);
	
	Position.propTypes = {
	  /**
	   * A node, element, or function that returns either. The child will be
	   * be positioned next to the `target` specified.
	   */
	  target: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),
	
	  /**
	   * "offsetParent" of the component
	   */
	  container: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),
	  /**
	   * Minimum spacing in pixels between container border and component border
	   */
	  containerPadding: _propTypes2.default.number,
	  /**
	   * How to position the component relative to the target
	   */
	  placement: _propTypes2.default.oneOf(['top', 'right', 'bottom', 'left']),
	  /**
	   * Whether the position should be changed on each update
	   */
	  shouldUpdatePosition: _propTypes2.default.bool
	};
	
	Position.displayName = 'Position';
	
	Position.defaultProps = {
	  containerPadding: 0,
	  placement: 'right',
	  shouldUpdatePosition: false
	};
	
	exports.default = Position;
	module.exports = exports['default'];

/***/ },
/* 1860 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  children: _propTypes2.default.node
	};
	
	/**
	 * Internal helper component to allow attaching a non-conflicting ref to a
	 * child element that may not accept refs.
	 */
	
	var RefHolder = function (_React$Component) {
	  _inherits(RefHolder, _React$Component);
	
	  function RefHolder() {
	    _classCallCheck(this, RefHolder);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  RefHolder.prototype.render = function render() {
	    return this.props.children;
	  };
	
	  return RefHolder;
	}(_react2.default.Component);
	
	RefHolder.propTypes = propTypes;
	
	exports.default = RefHolder;
	module.exports = exports['default'];

/***/ },
/* 1861 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = addFocusListener;
	/**
	 * Firefox doesn't have a focusin event so using capture is easiest way to get bubbling
	 * IE8 can't do addEventListener, but does have onfocusin, so we use that in ie8
	 *
	 * We only allow one Listener at a time to avoid stack overflows
	 */
	function addFocusListener(handler) {
	  var useFocusin = !document.addEventListener;
	  var remove = void 0;
	
	  if (useFocusin) {
	    document.attachEvent('onfocusin', handler);
	    remove = function remove() {
	      return document.detachEvent('onfocusin', handler);
	    };
	  } else {
	    document.addEventListener('focus', handler, true);
	    remove = function remove() {
	      return document.removeEventListener('focus', handler, true);
	    };
	  }
	
	  return { remove: remove };
	}
	module.exports = exports['default'];

/***/ },
/* 1862 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = calculatePosition;
	
	var _offset = __webpack_require__(457);
	
	var _offset2 = _interopRequireDefault(_offset);
	
	var _position = __webpack_require__(1584);
	
	var _position2 = _interopRequireDefault(_position);
	
	var _scrollTop = __webpack_require__(458);
	
	var _scrollTop2 = _interopRequireDefault(_scrollTop);
	
	var _ownerDocument = __webpack_require__(132);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getContainerDimensions(containerNode) {
	  var width = void 0,
	      height = void 0,
	      scroll = void 0;
	
	  if (containerNode.tagName === 'BODY') {
	    width = window.innerWidth;
	    height = window.innerHeight;
	
	    scroll = (0, _scrollTop2.default)((0, _ownerDocument2.default)(containerNode).documentElement) || (0, _scrollTop2.default)(containerNode);
	  } else {
	    var _getOffset = (0, _offset2.default)(containerNode);
	
	    width = _getOffset.width;
	    height = _getOffset.height;
	
	    scroll = (0, _scrollTop2.default)(containerNode);
	  }
	
	  return { width: width, height: height, scroll: scroll };
	}
	
	function getTopDelta(top, overlayHeight, container, padding) {
	  var containerDimensions = getContainerDimensions(container);
	  var containerScroll = containerDimensions.scroll;
	  var containerHeight = containerDimensions.height;
	
	  var topEdgeOffset = top - padding - containerScroll;
	  var bottomEdgeOffset = top + padding - containerScroll + overlayHeight;
	
	  if (topEdgeOffset < 0) {
	    return -topEdgeOffset;
	  } else if (bottomEdgeOffset > containerHeight) {
	    return containerHeight - bottomEdgeOffset;
	  } else {
	    return 0;
	  }
	}
	
	function getLeftDelta(left, overlayWidth, container, padding) {
	  var containerDimensions = getContainerDimensions(container);
	  var containerWidth = containerDimensions.width;
	
	  var leftEdgeOffset = left - padding;
	  var rightEdgeOffset = left + padding + overlayWidth;
	
	  if (leftEdgeOffset < 0) {
	    return -leftEdgeOffset;
	  } else if (rightEdgeOffset > containerWidth) {
	    return containerWidth - rightEdgeOffset;
	  }
	
	  return 0;
	}
	
	function calculatePosition(placement, overlayNode, target, container, padding) {
	  var childOffset = container.tagName === 'BODY' ? (0, _offset2.default)(target) : (0, _position2.default)(target, container);
	
	  var _getOffset2 = (0, _offset2.default)(overlayNode),
	      overlayHeight = _getOffset2.height,
	      overlayWidth = _getOffset2.width;
	
	  var positionLeft = void 0,
	      positionTop = void 0,
	      arrowOffsetLeft = void 0,
	      arrowOffsetTop = void 0;
	
	  if (placement === 'left' || placement === 'right') {
	    positionTop = childOffset.top + (childOffset.height - overlayHeight) / 2;
	
	    if (placement === 'left') {
	      positionLeft = childOffset.left - overlayWidth;
	    } else {
	      positionLeft = childOffset.left + childOffset.width;
	    }
	
	    var topDelta = getTopDelta(positionTop, overlayHeight, container, padding);
	
	    positionTop += topDelta;
	    arrowOffsetTop = 50 * (1 - 2 * topDelta / overlayHeight) + '%';
	    arrowOffsetLeft = void 0;
	  } else if (placement === 'top' || placement === 'bottom') {
	    positionLeft = childOffset.left + (childOffset.width - overlayWidth) / 2;
	
	    if (placement === 'top') {
	      positionTop = childOffset.top - overlayHeight;
	    } else {
	      positionTop = childOffset.top + childOffset.height;
	    }
	
	    var leftDelta = getLeftDelta(positionLeft, overlayWidth, container, padding);
	
	    positionLeft += leftDelta;
	    arrowOffsetLeft = 50 * (1 - 2 * leftDelta / overlayWidth) + '%';
	    arrowOffsetTop = void 0;
	  } else {
	    throw new Error('calcOverlayPosition(): No such placement of "' + placement + '" found.');
	  }
	
	  return { positionLeft: positionLeft, positionTop: positionTop, arrowOffsetLeft: arrowOffsetLeft, arrowOffsetTop: arrowOffsetTop };
	}
	module.exports = exports['default'];

/***/ },
/* 1863 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.ariaHidden = ariaHidden;
	exports.hideSiblings = hideSiblings;
	exports.showSiblings = showSiblings;
	
	var BLACKLIST = ['template', 'script', 'style'];
	
	var isHidable = function isHidable(_ref) {
	  var nodeType = _ref.nodeType,
	      tagName = _ref.tagName;
	  return nodeType === 1 && BLACKLIST.indexOf(tagName.toLowerCase()) === -1;
	};
	
	var siblings = function siblings(container, mount, cb) {
	  mount = [].concat(mount);
	
	  [].forEach.call(container.children, function (node) {
	    if (mount.indexOf(node) === -1 && isHidable(node)) {
	      cb(node);
	    }
	  });
	};
	
	function ariaHidden(show, node) {
	  if (!node) {
	    return;
	  }
	  if (show) {
	    node.setAttribute('aria-hidden', 'true');
	  } else {
	    node.removeAttribute('aria-hidden');
	  }
	}
	
	function hideSiblings(container, mountNode) {
	  siblings(container, mountNode, function (node) {
	    return ariaHidden(true, node);
	  });
	}
	
	function showSiblings(container, mountNode) {
	  siblings(container, mountNode, function (node) {
	    return ariaHidden(false, node);
	  });
	}

/***/ },
/* 1864 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {!function(e,a){ true?module.exports=a(__webpack_require__(1)):"function"==typeof define&&define.amd?define(["react"],a):"object"==typeof exports?exports.ReactPaginate=a(require("react")):e.ReactPaginate=a(e.React)}(global,(function(e){return function(e){var a={};function t(r){if(a[r])return a[r].exports;var n=a[r]={i:r,l:!1,exports:{}};return e[r].call(n.exports,n,n.exports,t),n.l=!0,n.exports}return t.m=e,t.c=a,t.d=function(e,a,r){t.o(e,a)||Object.defineProperty(e,a,{enumerable:!0,get:r})},t.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},t.t=function(e,a){if(1&a&&(e=t(e)),8&a)return e;if(4&a&&"object"==typeof e&&e&&e.__esModule)return e;var r=Object.create(null);if(t.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:e}),2&a&&"string"!=typeof e)for(var n in e)t.d(r,n,function(a){return e[a]}.bind(null,n));return r},t.n=function(e){var a=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(a,"a",a),a},t.o=function(e,a){return Object.prototype.hasOwnProperty.call(e,a)},t.p="",t(t.s=4)}([function(e,a,t){e.exports=t(2)()},function(a,t){a.exports=e},function(e,a,t){"use strict";var r=t(3);function n(){}function i(){}i.resetWarningCache=n,e.exports=function(){function e(e,a,t,n,i,s){if(s!==r){var l=new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");throw l.name="Invariant Violation",l}}function a(){return e}e.isRequired=e;var t={array:e,bool:e,func:e,number:e,object:e,string:e,symbol:e,any:e,arrayOf:a,element:e,elementType:e,instanceOf:a,node:e,objectOf:a,oneOf:a,oneOfType:a,shape:a,exact:a,checkPropTypes:i,resetWarningCache:n};return t.PropTypes=t,t}},function(e,a,t){"use strict";e.exports="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED"},function(e,a,t){"use strict";t.r(a);var r=t(1),n=t.n(r),i=t(0),s=t.n(i);function l(){return(l=Object.assign||function(e){for(var a=1;a<arguments.length;a++){var t=arguments[a];for(var r in t)Object.prototype.hasOwnProperty.call(t,r)&&(e[r]=t[r])}return e}).apply(this,arguments)}var o=function(e){var a=e.pageClassName,t=e.pageLinkClassName,r=e.page,i=e.selected,s=e.activeClassName,o=e.activeLinkClassName,u=e.getEventListener,c=e.pageSelectedHandler,p=e.href,f=e.extraAriaContext,g=e.pageLabelBuilder,d=e.ariaLabel||"Page "+r+(f?" "+f:""),b=null;return i&&(b="page",d=e.ariaLabel||"Page "+r+" is your current page",a=void 0!==a?a+" "+s:s,void 0!==t?void 0!==o&&(t=t+" "+o):t=o),n.a.createElement("li",{className:a},n.a.createElement("a",l({role:"button",className:t,href:p,tabIndex:"0","aria-label":d,"aria-current":b,onKeyPress:c},u(c)),g(r)))};o.propTypes={pageSelectedHandler:s.a.func.isRequired,selected:s.a.bool.isRequired,pageClassName:s.a.string,pageLinkClassName:s.a.string,activeClassName:s.a.string,activeLinkClassName:s.a.string,extraAriaContext:s.a.string,href:s.a.string,ariaLabel:s.a.string,page:s.a.number.isRequired,getEventListener:s.a.func.isRequired,pageLabelBuilder:s.a.func.isRequired};var u=o;function c(){return(c=Object.assign||function(e){for(var a=1;a<arguments.length;a++){var t=arguments[a];for(var r in t)Object.prototype.hasOwnProperty.call(t,r)&&(e[r]=t[r])}return e}).apply(this,arguments)}var p=function(e){var a=e.breakLabel,t=e.breakClassName,r=e.breakLinkClassName,i=e.breakHandler,s=e.getEventListener,l=t||"break";return n.a.createElement("li",{className:l},n.a.createElement("a",c({className:r,role:"button",tabIndex:"0",onKeyPress:i},s(i)),a))};p.propTypes={breakLabel:s.a.oneOfType([s.a.string,s.a.node]),breakClassName:s.a.string,breakLinkClassName:s.a.string,breakHandler:s.a.func.isRequired,getEventListener:s.a.func.isRequired};var f=p;function g(e){return(g="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function d(){return(d=Object.assign||function(e){for(var a=1;a<arguments.length;a++){var t=arguments[a];for(var r in t)Object.prototype.hasOwnProperty.call(t,r)&&(e[r]=t[r])}return e}).apply(this,arguments)}function b(e,a){for(var t=0;t<a.length;t++){var r=a[t];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}function v(e,a){return(v=Object.setPrototypeOf||function(e,a){return e.__proto__=a,e})(e,a)}function m(e){var a=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Date.prototype.toString.call(Reflect.construct(Date,[],(function(){}))),!0}catch(e){return!1}}();return function(){var t,r=C(e);if(a){var n=C(this).constructor;t=Reflect.construct(r,arguments,n)}else t=r.apply(this,arguments);return h(this,t)}}function h(e,a){return!a||"object"!==g(a)&&"function"!=typeof a?y(e):a}function y(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}function C(e){return(C=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}function P(e,a,t){return a in e?Object.defineProperty(e,a,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[a]=t,e}var k=function(e){!function(e,a){if("function"!=typeof a&&null!==a)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(a&&a.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),a&&v(e,a)}(s,e);var a,t,r,i=m(s);function s(e){var a,t;return function(e,a){if(!(e instanceof a))throw new TypeError("Cannot call a class as a function")}(this,s),P(y(a=i.call(this,e)),"handlePreviousPage",(function(e){var t=a.state.selected;e.preventDefault?e.preventDefault():e.returnValue=!1,t>0&&a.handlePageSelected(t-1,e)})),P(y(a),"handleNextPage",(function(e){var t=a.state.selected,r=a.props.pageCount;e.preventDefault?e.preventDefault():e.returnValue=!1,t<r-1&&a.handlePageSelected(t+1,e)})),P(y(a),"handlePageSelected",(function(e,t){t.preventDefault?t.preventDefault():t.returnValue=!1,a.state.selected!==e?(a.setState({selected:e}),a.callCallback(e)):a.callActiveCallback(e)})),P(y(a),"getEventListener",(function(e){return P({},a.props.eventListener,e)})),P(y(a),"handleBreakClick",(function(e,t){t.preventDefault?t.preventDefault():t.returnValue=!1;var r=a.state.selected;a.handlePageSelected(r<e?a.getForwardJump():a.getBackwardJump(),t)})),P(y(a),"callCallback",(function(e){void 0!==a.props.onPageChange&&"function"==typeof a.props.onPageChange&&a.props.onPageChange({selected:e})})),P(y(a),"callActiveCallback",(function(e){void 0!==a.props.onPageActive&&"function"==typeof a.props.onPageActive&&a.props.onPageActive({selected:e})})),P(y(a),"pagination",(function(){var e=[],t=a.props,r=t.pageRangeDisplayed,i=t.pageCount,s=t.marginPagesDisplayed,l=t.breakLabel,o=t.breakClassName,u=t.breakLinkClassName,c=a.state.selected;if(i<=r)for(var p=0;p<i;p++)e.push(a.getPageElement(p));else{var g,d,b,v=r/2,m=r-v;c>i-r/2?v=r-(m=i-c):c<r/2&&(m=r-(v=c));var h=function(e){return a.getPageElement(e)};for(g=0;g<i;g++)(d=g+1)<=s||d>i-s||g>=c-v&&g<=c+m?e.push(h(g)):l&&e[e.length-1]!==b&&(b=n.a.createElement(f,{key:g,breakLabel:l,breakClassName:o,breakLinkClassName:u,breakHandler:a.handleBreakClick.bind(null,g),getEventListener:a.getEventListener}),e.push(b))}return e})),t=e.initialPage?e.initialPage:e.forcePage?e.forcePage:0,a.state={selected:t},a}return a=s,(t=[{key:"componentDidMount",value:function(){var e=this.props,a=e.initialPage,t=e.disableInitialCallback,r=e.extraAriaContext;void 0===a||t||this.callCallback(a),r&&console.warn("DEPRECATED (react-paginate): The extraAriaContext prop is deprecated. You should now use the ariaLabelBuilder instead.")}},{key:"componentDidUpdate",value:function(e){void 0!==this.props.forcePage&&this.props.forcePage!==e.forcePage&&this.setState({selected:this.props.forcePage})}},{key:"getForwardJump",value:function(){var e=this.state.selected,a=this.props,t=a.pageCount,r=e+a.pageRangeDisplayed;return r>=t?t-1:r}},{key:"getBackwardJump",value:function(){var e=this.state.selected-this.props.pageRangeDisplayed;return e<0?0:e}},{key:"hrefBuilder",value:function(e){var a=this.props,t=a.hrefBuilder,r=a.pageCount;if(t&&e!==this.state.selected&&e>=0&&e<r)return t(e+1)}},{key:"ariaLabelBuilder",value:function(e){var a=e===this.state.selected;if(this.props.ariaLabelBuilder&&e>=0&&e<this.props.pageCount){var t=this.props.ariaLabelBuilder(e+1,a);return this.props.extraAriaContext&&!a&&(t=t+" "+this.props.extraAriaContext),t}}},{key:"getPageElement",value:function(e){var a=this.state.selected,t=this.props,r=t.pageClassName,i=t.pageLinkClassName,s=t.activeClassName,l=t.activeLinkClassName,o=t.extraAriaContext,c=t.pageLabelBuilder;return n.a.createElement(u,{key:e,pageSelectedHandler:this.handlePageSelected.bind(null,e),selected:a===e,pageClassName:r,pageLinkClassName:i,activeClassName:s,activeLinkClassName:l,extraAriaContext:o,href:this.hrefBuilder(e),ariaLabel:this.ariaLabelBuilder(e),page:e+1,pageLabelBuilder:c,getEventListener:this.getEventListener})}},{key:"render",value:function(){var e=this.props,a=e.disabledClassName,t=e.pageCount,r=e.containerClassName,i=e.previousLabel,s=e.previousClassName,l=e.previousLinkClassName,o=e.previousAriaLabel,u=e.prevRel,c=e.nextLabel,p=e.nextClassName,f=e.nextLinkClassName,g=e.nextAriaLabel,b=e.nextRel,v=this.state.selected,m=s+(0===v?" ".concat(a):""),h=p+(v===t-1?" ".concat(a):""),y=0===v?"true":"false",C=v===t-1?"true":"false";return n.a.createElement("ul",{className:r},n.a.createElement("li",{className:m},n.a.createElement("a",d({className:l,href:this.hrefBuilder(v-1),tabIndex:"0",role:"button",onKeyPress:this.handlePreviousPage,"aria-disabled":y,"aria-label":o,rel:u},this.getEventListener(this.handlePreviousPage)),i)),this.pagination(),n.a.createElement("li",{className:h},n.a.createElement("a",d({className:f,href:this.hrefBuilder(v+1),tabIndex:"0",role:"button",onKeyPress:this.handleNextPage,"aria-disabled":C,"aria-label":g,rel:b},this.getEventListener(this.handleNextPage)),c)))}}])&&b(a.prototype,t),r&&b(a,r),s}(r.Component);P(k,"propTypes",{pageCount:s.a.number.isRequired,pageRangeDisplayed:s.a.number.isRequired,marginPagesDisplayed:s.a.number.isRequired,previousLabel:s.a.node,previousAriaLabel:s.a.string,prevRel:s.a.string,nextLabel:s.a.node,nextAriaLabel:s.a.string,nextRel:s.a.string,breakLabel:s.a.oneOfType([s.a.string,s.a.node]),hrefBuilder:s.a.func,onPageChange:s.a.func,onPageActive:s.a.func,initialPage:s.a.number,forcePage:s.a.number,disableInitialCallback:s.a.bool,containerClassName:s.a.string,pageClassName:s.a.string,pageLinkClassName:s.a.string,pageLabelBuilder:s.a.func,activeClassName:s.a.string,activeLinkClassName:s.a.string,previousClassName:s.a.string,nextClassName:s.a.string,previousLinkClassName:s.a.string,nextLinkClassName:s.a.string,disabledClassName:s.a.string,breakClassName:s.a.string,breakLinkClassName:s.a.string,extraAriaContext:s.a.string,ariaLabelBuilder:s.a.func,eventListener:s.a.string}),P(k,"defaultProps",{pageCount:10,pageRangeDisplayed:2,marginPagesDisplayed:3,activeClassName:"selected",previousLabel:"Previous",previousClassName:"previous",previousAriaLabel:"Previous page",prevRel:"prev",nextLabel:"Next",nextClassName:"next",nextAriaLabel:"Next page",nextRel:"next",breakLabel:"...",disabledClassName:"disabled",disableInitialCallback:!1,pageLabelBuilder:function(e){return e},eventListener:"onClick"});a.default=k}])}));
	//# sourceMappingURL=react-paginate.js.map
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1865 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = createChainableTypeChecker;
	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	// Mostly taken from ReactPropTypes.
	
	function createChainableTypeChecker(validate) {
	  function checkType(isRequired, props, propName, componentName, location, propFullName) {
	    var componentNameSafe = componentName || '<<anonymous>>';
	    var propFullNameSafe = propFullName || propName;
	
	    if (props[propName] == null) {
	      if (isRequired) {
	        return new Error('Required ' + location + ' `' + propFullNameSafe + '` was not specified ' + ('in `' + componentNameSafe + '`.'));
	      }
	
	      return null;
	    }
	
	    for (var _len = arguments.length, args = Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++) {
	      args[_key - 6] = arguments[_key];
	    }
	
	    return validate.apply(undefined, [props, propName, componentNameSafe, location, propFullNameSafe].concat(args));
	  }
	
	  var chainedCheckType = checkType.bind(null, false);
	  chainedCheckType.isRequired = checkType.bind(null, true);
	
	  return chainedCheckType;
	}

/***/ },
/* 1866 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var Button = function Button(props) {
	  return /*#__PURE__*/_react["default"].createElement("button", {
	    type: "button",
	    onClick: function onClick() {
	      return props.onClick();
	    },
	    className: 'rrt-button ' + props.className,
	    ref: props.innerRef
	  }, props.children);
	};
	
	Button.displayName = 'ReduxConfirmButton';
	var _default = Button;
	exports["default"] = _default;

/***/ },
/* 1867 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _icons = _interopRequireDefault(__webpack_require__(1872));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var Icon = /*#__PURE__*/function (_React$Component) {
	  _inherits(Icon, _React$Component);
	
	  var _super = _createSuper(Icon);
	
	  function Icon() {
	    _classCallCheck(this, Icon);
	
	    return _super.apply(this, arguments);
	  }
	
	  _createClass(Icon, [{
	    key: "render",
	    value: function render() {
	      var size = this.props.size;
	      var styles = {
	        width: size,
	        height: size
	      };
	      return /*#__PURE__*/_react["default"].createElement("svg", {
	        className: (0, _classnames["default"])(this.props.className, 'toastr-icon'),
	        xmlns: "http://www.w3.org/2000/svg",
	        preserveAspectRatio: "xMidYMid meet",
	        viewBox: "0 0 ".concat(this.props.size, " ").concat(this.props.size),
	        style: styles
	      }, (0, _icons["default"])(this.props.name));
	    }
	  }]);
	
	  return Icon;
	}(_react["default"].Component);
	
	exports["default"] = Icon;
	
	_defineProperty(Icon, "displayName", 'ReduxToastrIcon');
	
	_defineProperty(Icon, "defaultProps", {
	  size: 32
	});

/***/ },
/* 1868 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var ProgressBar = /*#__PURE__*/function (_React$Component) {
	  _inherits(ProgressBar, _React$Component);
	
	  var _super = _createSuper(ProgressBar);
	
	  function ProgressBar(props) {
	    var _this;
	
	    _classCallCheck(this, ProgressBar);
	
	    _this = _super.call(this, props);
	    _this.state = {
	      percent: 100
	    };
	    _this.intervalId = null;
	    return _this;
	  }
	
	  _createClass(ProgressBar, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var distance = 100 / (this.props.duration / 10);
	      this.intervalId = setInterval(function () {
	        var percent = _this2.state.percent - distance;
	
	        _this2.setState({
	          percent: percent > 0 ? percent : 0
	        });
	      }, 10);
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate() {
	      if (this.state.percent <= 0 && this.intervalId) {
	        clearTimeout(this.intervalId);
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      if (this.intervalId) {
	        clearTimeout(this.intervalId);
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var percent = this.state.percent;
	      return /*#__PURE__*/_react["default"].createElement("div", {
	        className: "rrt-progress-container"
	      }, /*#__PURE__*/_react["default"].createElement("div", {
	        className: "rrt-progressbar",
	        style: {
	          width: "".concat(percent, "%")
	        }
	      }));
	    }
	  }]);
	
	  return ProgressBar;
	}(_react["default"].Component);
	
	exports["default"] = ProgressBar;
	
	_defineProperty(ProgressBar, "displayName", 'ProgressBar');
	
	_defineProperty(ProgressBar, "propTypes", {
	  duration: _propTypes["default"].number.isRequired
	});

/***/ },
/* 1869 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = exports.ReduxToastr = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _reactRedux = __webpack_require__(18);
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _ToastrBox = _interopRequireDefault(__webpack_require__(1870));
	
	var _ToastrConfirm = _interopRequireDefault(__webpack_require__(1871));
	
	var actions = _interopRequireWildcard(__webpack_require__(528));
	
	var _toastrEmitter = __webpack_require__(530);
	
	var _utils = __webpack_require__(133);
	
	var _constants = __webpack_require__(314);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var ReduxToastr = /*#__PURE__*/function (_React$Component) {
	  _inherits(ReduxToastr, _React$Component);
	
	  var _super = _createSuper(ReduxToastr);
	
	  function ReduxToastr(props) {
	    var _this;
	
	    _classCallCheck(this, ReduxToastr);
	
	    _this = _super.call(this, props);
	
	    _defineProperty(_assertThisInitialized(_this), "toastrFired", {});
	
	    _defineProperty(_assertThisInitialized(_this), "toastrPositions", ['top-left', 'top-right', 'top-center', 'bottom-left', 'bottom-right', 'bottom-center']);
	
	    (0, _utils.updateConfig)(props);
	    return _this;
	  }
	
	  _createClass(ReduxToastr, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _this$props = this.props,
	          add = _this$props.add,
	          showConfirm = _this$props.showConfirm,
	          clean = _this$props.clean,
	          removeByType = _this$props.removeByType,
	          remove = _this$props.remove;
	
	      _toastrEmitter.EE.on('toastr/confirm', showConfirm);
	
	      _toastrEmitter.EE.on('add/toastr', add);
	
	      _toastrEmitter.EE.on('clean/toastr', clean);
	
	      _toastrEmitter.EE.on('removeByType/toastr', removeByType);
	
	      _toastrEmitter.EE.on('remove/toastr', remove);
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      _toastrEmitter.EE.removeListener('toastr/confirm');
	
	      _toastrEmitter.EE.removeListener('add/toastr');
	
	      _toastrEmitter.EE.removeListener('clean/toastr');
	
	      _toastrEmitter.EE.removeListener('removeByType/toastr');
	
	      _toastrEmitter.EE.removeListener('remove/toastr');
	
	      this.toastrFired = {};
	    }
	  }, {
	    key: "_addToMemory",
	    value: function _addToMemory(id) {
	      this.toastrFired[id] = true;
	    }
	  }, {
	    key: "_renderToastrForPosition",
	    value: function _renderToastrForPosition(position) {
	      var _this2 = this;
	
	      var toastrs = this.props.toastr.toastrs;
	
	      if (toastrs) {
	        return toastrs.filter(function (item) {
	          return item.position === position;
	        }).map(function (item) {
	          var mergedItem = _objectSpread(_objectSpread({}, item), {}, {
	            options: _objectSpread({
	              progressBar: _this2.props.progressBar,
	              transitionIn: _this2.props.transitionIn,
	              transitionOut: _this2.props.transitionOut,
	              closeOnToastrClick: _this2.props.closeOnToastrClick
	            }, item.options)
	          });
	
	          return /*#__PURE__*/_react["default"].createElement("div", {
	            key: item.id
	          }, /*#__PURE__*/_react["default"].createElement(_ToastrBox["default"], _extends({
	            inMemory: _this2.toastrFired,
	            addToMemory: function addToMemory() {
	              return _this2._addToMemory(item.id);
	            },
	            item: mergedItem
	          }, _this2.props)), item.options && item.options.attention && /*#__PURE__*/_react["default"].createElement("div", {
	            onClick: function onClick() {
	              if (typeof item.options.onAttentionClick === 'function') {
	                item.options.onAttentionClick(item.id);
	              } else {
	                _this2.props.remove(item.id);
	              }
	            },
	            className: "toastr-attention"
	          }));
	        });
	      }
	    }
	  }, {
	    key: "_renderToastrs",
	    value: function _renderToastrs() {
	      var _this3 = this;
	
	      var toastr = this.props.toastr;
	      var width = toastr.toastrs && toastr.toastrs[0] && toastr.toastrs[0].options && toastr.toastrs[0].options.width;
	      var style = width ? {
	        width: width
	      } : {};
	      return /*#__PURE__*/_react["default"].createElement("div", null, this.toastrPositions.map(function (position) {
	        return /*#__PURE__*/_react["default"].createElement("div", {
	          key: position,
	          className: position,
	          style: style
	        }, _this3._renderToastrForPosition(position));
	      }));
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props2 = this.props,
	          className = _this$props2.className,
	          toastr = _this$props2.toastr;
	      return /*#__PURE__*/_react["default"].createElement("div", {
	        className: (0, _classnames["default"])('redux-toastr', className),
	        "aria-live": "assertive"
	      }, toastr.confirm && /*#__PURE__*/_react["default"].createElement(_ToastrConfirm["default"], _extends({
	        confirm: toastr.confirm
	      }, this.props)), this._renderToastrs());
	    }
	  }]);
	
	  return ReduxToastr;
	}(_react["default"].Component);
	
	exports.ReduxToastr = ReduxToastr;
	
	_defineProperty(ReduxToastr, "displayName", 'ReduxToastr');
	
	_defineProperty(ReduxToastr, "propTypes", {
	  toastr: _propTypes["default"].object,
	  position: _propTypes["default"].string,
	  newestOnTop: _propTypes["default"].bool,
	  timeOut: _propTypes["default"].number,
	  confirmOptions: _propTypes["default"].object,
	  progressBar: _propTypes["default"].bool,
	  transitionIn: _propTypes["default"].oneOf(_constants.TRANSITIONS["in"]),
	  transitionOut: _propTypes["default"].oneOf(_constants.TRANSITIONS.out),
	  preventDuplicates: _propTypes["default"].bool,
	  closeOnToastrClick: _propTypes["default"].bool
	});
	
	_defineProperty(ReduxToastr, "defaultProps", {
	  position: 'top-right',
	  newestOnTop: true,
	  timeOut: 5000,
	  progressBar: false,
	  transitionIn: _constants.TRANSITIONS["in"][0],
	  transitionOut: _constants.TRANSITIONS.out[0],
	  preventDuplicates: false,
	  closeOnToastrClick: false,
	  getState: function getState(state) {
	    return state.toastr;
	  },
	  confirmOptions: {
	    okText: 'ok',
	    cancelText: 'cancel'
	  }
	});
	
	var _default = (0, _reactRedux.connect)(function (state, ownProps) {
	  return {
	    toastr: ownProps.getState ? ownProps.getState(state) : state.toastr
	  };
	}, actions)(ReduxToastr);
	
	exports["default"] = _default;

/***/ },
/* 1870 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _ProgressBar = _interopRequireDefault(__webpack_require__(1868));
	
	var _Icon = _interopRequireDefault(__webpack_require__(1867));
	
	var _utils = __webpack_require__(133);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var ToastrBox = /*#__PURE__*/function (_React$Component) {
	  _inherits(ToastrBox, _React$Component);
	
	  var _super = _createSuper(ToastrBox);
	
	  function ToastrBox(props) {
	    var _this;
	
	    _classCallCheck(this, ToastrBox);
	
	    _this = _super.call(this, props);
	
	    _defineProperty(_assertThisInitialized(_this), "handlePressEnterOrSpaceKeyToastr", function (e) {
	      if (e.key === ' ' || e.key === 'Enter') {
	        _this.handleClickToastr(e);
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "handlePressEnterOrSpaceKeyCloseButton", function (e) {
	      if (e.key === ' ' || e.key === 'Enter') {
	        _this.handleClickCloseButton(e);
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "handleClickToastr", function () {
	      var _this$props$item$opti = _this.props.item.options,
	          onToastrClick = _this$props$item$opti.onToastrClick,
	          closeOnToastrClick = _this$props$item$opti.closeOnToastrClick;
	      _this.ignoreIsHiding = true;
	
	      if (onToastrClick) {
	        onToastrClick();
	      }
	
	      if (closeOnToastrClick) {
	        _this._setShouldClose(true);
	
	        _this._removeToastr();
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "handleClickCloseButton", function (e) {
	      var onCloseButtonClick = _this.props.item.options.onCloseButtonClick;
	      e.stopPropagation();
	      _this.ignoreIsHiding = true;
	
	      if (onCloseButtonClick) {
	        onCloseButtonClick();
	      }
	
	      _this._setShouldClose(true);
	
	      _this._removeToastr();
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "mouseEnter", function () {
	      clearTimeout(_this.intervalId);
	
	      _this._setIntervalId(null);
	
	      _this._setIsHiding(false);
	
	      var progressBar = _this.props.item.options.progressBar;
	
	      var timeOut = _this._getItemTimeOut();
	
	      if (timeOut && progressBar) {
	        _this.setState({
	          progressBar: null
	        });
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "mouseLeave", function () {
	      var _this$props$item$opti2 = _this.props.item.options,
	          removeOnHover = _this$props$item$opti2.removeOnHover,
	          removeOnHoverTimeOut = _this$props$item$opti2.removeOnHoverTimeOut;
	
	      if (!_this.isHiding && (removeOnHover || _this.shouldClose)) {
	        var interval = removeOnHover === true ? removeOnHoverTimeOut || 1000 : removeOnHover;
	
	        _this._setIntervalId(setTimeout(_this._removeToastr, interval));
	
	        var progressBar = _this.props.item.options.progressBar;
	
	        var timeOut = _this._getItemTimeOut();
	
	        if (timeOut && progressBar) {
	          _this.setState({
	            progressBar: {
	              duration: interval
	            }
	          });
	        }
	      }
	    });
	
	    var _props$item$options = props.item.options,
	        transitionIn = _props$item$options.transitionIn,
	        transitionOut = _props$item$options.transitionOut;
	    _this.isHiding = false;
	    _this.shouldClose = false;
	    _this.intervalId = null;
	    _this.ignoreIsHiding = false;
	    _this.transitionIn = transitionIn || _this.props.transitionIn;
	    _this.transitionOut = transitionOut || _this.props.transitionOut; // an identifier to facilitate aria labelling for a11y for multiple instances of the component family in the DOM
	
	    _this.id = props.item.a11yId || Math.floor(Math.random() * 9999);
	    _this.state = {
	      progressBar: null
	    };
	    (0, _utils._bind)(['renderSubComponent', 'renderIcon', 'renderToastr', 'renderCloseButton', 'renderMessage', '_onAnimationComplete', '_removeToastr', '_setTransition', '_clearTransition', '_setIntervalId', '_setIsHiding', '_setShouldClose'], _assertThisInitialized(_this));
	    return _this;
	  }
	
	  _createClass(ToastrBox, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var item = this.props.item;
	      if (this.props.inMemory[item.id]) return;
	
	      var timeOut = this._getItemTimeOut();
	
	      if (timeOut) {
	        this._setIntervalId(setTimeout(this._removeToastr, timeOut));
	      }
	
	      if (timeOut && item.options.progressBar) {
	        this.setState({
	          progressBar: {
	            duration: this._getItemTimeOut()
	          }
	        });
	      }
	
	      this._setTransition();
	
	      (0, _utils.onCSSTransitionEnd)(this.toastrBoxElement, this._onAnimationComplete);
	      this.props.addToMemory(item.id);
	
	      if (this.closeButton !== undefined && !item.options.disableCloseButtonFocus) {
	        this.closeButton.focus();
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      if (this.intervalId) {
	        clearTimeout(this.intervalId);
	      } // when toast unloads the toast close button automatically focuses on the next toast control (if any)
	      // need to add a micro delay to allow the DOM to recycle
	
	
	      setTimeout(function () {
	        var toastrControls = document.querySelectorAll('.toastr-control:not(.disable-auto-focus)');
	
	        if (toastrControls.length) {
	          toastrControls[0].focus();
	        }
	      }, 50);
	    }
	  }, {
	    key: "renderSubComponent",
	    value: function renderSubComponent() {
	      var _this2 = this;
	
	      var _this$props$item = this.props.item,
	          id = _this$props$item.id,
	          options = _this$props$item.options;
	
	      var removeCurrentToastrFunc = function removeCurrentToastrFunc() {
	        return _this2.props.remove(id);
	      };
	
	      if ( /*#__PURE__*/(0, _react.isValidElement)(options.component)) {
	        return /*#__PURE__*/_react["default"].cloneElement(options.component, {
	          remove: removeCurrentToastrFunc
	        });
	      }
	
	      return /*#__PURE__*/_react["default"].createElement(options.component, {
	        remove: removeCurrentToastrFunc
	      });
	    }
	  }, {
	    key: "renderIcon",
	    value: function renderIcon() {
	      var _this$props$item2 = this.props.item,
	          type = _this$props$item2.type,
	          options = _this$props$item2.options;
	
	      if ( /*#__PURE__*/(0, _react.isValidElement)(options.icon)) {
	        return /*#__PURE__*/_react["default"].cloneElement(options.icon);
	      }
	
	      var iconName = type === 'light' ? options.icon : type;
	      return /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
	        name: iconName
	      });
	    }
	  }, {
	    key: "renderCloseButton",
	    value: function renderCloseButton() {
	      var _this3 = this;
	
	      var closeButtonAttributes = {
	        tabIndex: 0,
	        role: 'button',
	        onKeyPress: this.handlePressEnterOrSpaceKeyCloseButton
	      };
	
	      if (this.isToastrClickable) {
	        closeButtonAttributes = {};
	      }
	
	      return /*#__PURE__*/_react["default"].createElement("div", _extends({
	        className: (0, _classnames["default"])('close-toastr', 'toastr-control', {
	          'disable-auto-focus': this.props.item.options.disableCloseButtonFocus
	        }),
	        "aria-label": "toast",
	        onClick: this.handleClickCloseButton,
	        ref: function ref(_ref) {
	          return _this3.closeButton = _ref;
	        }
	      }, closeButtonAttributes), /*#__PURE__*/_react["default"].createElement("span", null, "\u2715"));
	    }
	  }, {
	    key: "renderToastr",
	    value: function renderToastr() {
	      var _this$props$item3 = this.props.item,
	          type = _this$props$item3.type,
	          options = _this$props$item3.options,
	          message = _this$props$item3.message,
	          title = _this$props$item3.title;
	      var ariaAttributes = {};
	
	      if (title) {
	        ariaAttributes['aria-labelledby'] = "dialogTitle-".concat(this.id);
	      }
	
	      if (message) {
	        ariaAttributes['aria-describedby'] = "dialogDesc-".concat(this.id);
	      }
	
	      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
	        className: "rrt-left-container"
	      }, /*#__PURE__*/_react["default"].createElement("div", {
	        className: "rrt-holder"
	      }, this.renderIcon())), options.status && type === 'light' && /*#__PURE__*/_react["default"].createElement("div", {
	        className: (0, _classnames["default"])('toastr-status', options.status)
	      }), /*#__PURE__*/_react["default"].createElement("div", _extends({
	        className: "rrt-middle-container",
	        role: "alertdialog"
	      }, ariaAttributes), title && /*#__PURE__*/_react["default"].createElement("div", {
	        id: "dialogTitle-".concat(this.id),
	        className: "rrt-title"
	      }, title), message && /*#__PURE__*/_react["default"].createElement("div", {
	        id: "dialogDesc-".concat(this.id),
	        className: "rrt-text"
	      }, message), options.component && this.renderSubComponent()), /*#__PURE__*/_react["default"].createElement("div", {
	        className: "rrt-right-container"
	      }, options.showCloseButton && this.renderCloseButton()), this.state.progressBar ? /*#__PURE__*/_react["default"].createElement(_ProgressBar["default"], this.state.progressBar) : null);
	    }
	  }, {
	    key: "renderMessage",
	    value: function renderMessage() {
	      var _this$props$item4 = this.props.item,
	          title = _this$props$item4.title,
	          message = _this$props$item4.message,
	          options = _this$props$item4.options;
	      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
	        className: "rrt-title"
	      }, title, this.renderCloseButton()), /*#__PURE__*/_react["default"].createElement("div", {
	        className: "rrt-text"
	      }, message, options.component && this.renderSubComponent()));
	    }
	  }, {
	    key: "toastr",
	    value: function toastr() {
	      if (this.props.item.type === 'message') {
	        return this.renderMessage();
	      }
	
	      return this.renderToastr();
	    }
	  }, {
	    key: "_getItemTimeOut",
	    value: function _getItemTimeOut() {
	      var item = this.props.item;
	      var timeOut = item.options.timeOut;
	
	      if (typeof timeOut === 'undefined') {
	        timeOut = this.props.timeOut;
	      }
	
	      return timeOut;
	    }
	  }, {
	    key: "_onAnimationComplete",
	    value: function _onAnimationComplete() {
	      var _this$props = this.props,
	          remove = _this$props.remove,
	          item = _this$props.item;
	      var options = item.options,
	          id = item.id;
	
	      if (this.isHiding || this.ignoreIsHiding) {
	        this._setIsHiding(false);
	
	        this.ignoreIsHiding = false;
	        remove(id);
	
	        if (options.onHideComplete) {
	          options.onHideComplete();
	        }
	      } else if (!this.isHiding && options.onShowComplete) {
	        options.onShowComplete();
	      }
	    }
	  }, {
	    key: "_removeToastr",
	    value: function _removeToastr() {
	      if (!this.isHiding) {
	        this._setIsHiding(true);
	
	        this._setTransition(true, false);
	
	        (0, _utils.onCSSTransitionEnd)(this.toastrBoxElement, this._onAnimationComplete);
	      }
	    }
	  }, {
	    key: "_setTransition",
	    value: function _setTransition(hide) {
	      var _this4 = this;
	
	      var autoRemove = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	      var animationType = hide ? this.transitionOut : this.transitionIn;
	
	      var onEndListener = function onEndListener(e) {
	        if (e && e.target == _this4.toastrBoxElement) {
	          _this4.toastrBoxElement.classList.remove(animationType);
	        }
	      };
	
	      if (this.toastrBoxElement) {
	        if (autoRemove) {
	          (0, _utils.onCSSTransitionEnd)(this.toastrBoxElement, onEndListener);
	        }
	
	        this.toastrBoxElement.classList.add(animationType);
	      }
	    }
	  }, {
	    key: "_clearTransition",
	    value: function _clearTransition() {
	      if (this.toastrBoxElement) {
	        this.toastrBoxElement.classList.remove(this.transitionIn, this.transitionOut);
	      }
	    }
	  }, {
	    key: "_setIntervalId",
	    value: function _setIntervalId(intervalId) {
	      this.intervalId = intervalId;
	    }
	  }, {
	    key: "_setIsHiding",
	    value: function _setIsHiding(val) {
	      this.isHiding = val;
	    }
	  }, {
	    key: "_setShouldClose",
	    value: function _setShouldClose(val) {
	      this.shouldClose = val;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this5 = this;
	
	      var _this$props$item5 = this.props.item,
	          options = _this$props$item5.options,
	          type = _this$props$item5.type;
	      var toastrClickAttributes = {};
	
	      if (this.isToastrClickable) {
	        toastrClickAttributes.role = 'button';
	        toastrClickAttributes.tabIndex = 0;
	        toastrClickAttributes.onClick = this.handleClickToastr;
	        toastrClickAttributes.onKeyPress = this.handlePressEnterOrSpaceKeyToastr;
	      }
	
	      return /*#__PURE__*/_react["default"].createElement("div", _extends({
	        ref: function ref(_ref2) {
	          return _this5.toastrBoxElement = _ref2;
	        },
	        className: (0, _classnames["default"])('toastr', 'animated', 'rrt-' + type, options.className),
	        onMouseEnter: this.mouseEnter,
	        onMouseLeave: this.mouseLeave
	      }, toastrClickAttributes), this.toastr());
	    }
	  }, {
	    key: "isToastrClickable",
	    get: function get() {
	      var _this$props$item$opti3 = this.props.item.options,
	          onToastrClick = _this$props$item$opti3.onToastrClick,
	          closeOnToastrClick = _this$props$item$opti3.closeOnToastrClick;
	      var hasOnToastrClick = !!onToastrClick;
	      return hasOnToastrClick || closeOnToastrClick;
	    }
	  }]);
	
	  return ToastrBox;
	}(_react["default"].Component);
	
	exports["default"] = ToastrBox;
	
	_defineProperty(ToastrBox, "displayName", 'ToastrBox');
	
	_defineProperty(ToastrBox, "propTypes", {
	  item: _propTypes["default"].shape({
	    options: _propTypes["default"].shape({
	      transitionIn: _propTypes["default"].string,
	      transitionOut: _propTypes["default"].string
	    })
	  })
	});

/***/ },
/* 1871 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _utils = __webpack_require__(133);
	
	var _Button = _interopRequireDefault(__webpack_require__(1866));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var ENTER = 13;
	var ESC = 27;
	
	var ToastrConfirm = /*#__PURE__*/function (_React$Component) {
	  _inherits(ToastrConfirm, _React$Component);
	
	  var _super = _createSuper(ToastrConfirm);
	
	  function ToastrConfirm(props) {
	    var _this;
	
	    _classCallCheck(this, ToastrConfirm);
	
	    _this = _super.call(this, props);
	    var _this$props = _this.props,
	        confirmOptions = _this$props.confirmOptions,
	        confirm = _this$props.confirm;
	    var _confirm$options = confirm.options,
	        okText = _confirm$options.okText,
	        cancelText = _confirm$options.cancelText,
	        transitionIn = _confirm$options.transitionIn,
	        transitionOut = _confirm$options.transitionOut,
	        disableCancel = _confirm$options.disableCancel,
	        closeOnShadowClick = _confirm$options.closeOnShadowClick;
	    _this.okText = okText || confirmOptions.okText;
	    _this.cancelText = cancelText || confirmOptions.cancelText;
	    _this.transitionIn = transitionIn || confirmOptions.transitionIn || props.transitionIn;
	    _this.transitionOut = transitionOut || confirmOptions.transitionOut || props.transitionOut;
	    _this.disableCancel = disableCancel || confirmOptions.disableCancel;
	    _this.closeOnShadowClick = closeOnShadowClick || confirmOptions.closeOnShadowClick;
	    (0, _utils._bind)('setTransition removeConfirm handleOnKeyUp handleOnKeyDown handleCloseOnShadowClick', _assertThisInitialized(_this));
	    _this.isKeyDown = false; // an identifier to facilitate aria labelling for a11y for multiple instances of the component family in the DOM
	
	    _this.id = Math.floor(Math.random() * 9999);
	    return _this;
	  }
	
	  _createClass(ToastrConfirm, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.isHiding = false;
	      this.hasClicked = false;
	      this.confirmHolderElement.focus();
	
	      if (this.props.confirm.show) {
	        this.setTransition(true);
	      } // when toast loads the toast close button automatically focuses on the toast control
	
	
	      if (this.closeButton !== undefined && this.closeButton.focus !== undefined) {
	        this.closeButton.focus();
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      // when toast unloads the toast close button automatically focuses on the next toast control (if any)
	      // need to add a micro delay to allow the DOM to recycle
	      setTimeout(function () {
	        if (document.getElementsByClassName('toastr-control').length > 0) {
	          document.getElementsByClassName('toastr-control')[0].focus();
	        }
	      }, 50);
	    }
	  }, {
	    key: "handleOnKeyDown",
	    value: function handleOnKeyDown(e) {
	      if ((0, _utils.keyCode)(e) == ENTER) {
	        e.preventDefault();
	      }
	
	      this.isKeyDown = true;
	    }
	  }, {
	    key: "handleCloseOnShadowClick",
	    value: function handleCloseOnShadowClick(e) {
	      if (this.closeOnShadowClick) {
	        this.handleCancelClick();
	      }
	    }
	  }, {
	    key: "handleButtonClick",
	    value: function handleButtonClick(callback) {
	      var _this2 = this;
	
	      if (this.hasClicked) return;
	      this.hasClicked = true;
	
	      var onAnimationEnd = function onAnimationEnd() {
	        _this2.removeConfirm();
	
	        if (callback) {
	          callback();
	        }
	      };
	
	      this.setTransition();
	      (0, _utils.onCSSTransitionEnd)(this.confirmElement, onAnimationEnd);
	    }
	  }, {
	    key: "handleConfirmClick",
	    value: function handleConfirmClick() {
	      var callback = this.props.confirm.options ? this.props.confirm.options.onOk : null;
	      this.handleButtonClick(callback);
	    }
	  }, {
	    key: "handleCancelClick",
	    value: function handleCancelClick() {
	      var callback = this.props.confirm.options ? this.props.confirm.options.onCancel : null;
	      this.handleButtonClick(callback);
	    }
	  }, {
	    key: "setTransition",
	    value: function setTransition(add) {
	      if (add) {
	        this.isHiding = false;
	        this.confirmElement.classList.add(this.transitionIn);
	        if ((0, _utils.isBrowser)()) return document.querySelector('body').classList.add('toastr-confirm-active');
	      }
	
	      this.isHiding = true;
	      this.confirmElement.classList.remove(this.transitionIn);
	      this.confirmElement.classList.add(this.transitionOut);
	    }
	  }, {
	    key: "removeConfirm",
	    value: function removeConfirm() {
	      this.isHiding = false;
	      this.props.hideConfirm();
	      if ((0, _utils.isBrowser)()) return document.querySelector('body').classList.remove('toastr-confirm-active');
	    }
	  }, {
	    key: "handleOnKeyUp",
	    value: function handleOnKeyUp(e) {
	      var code = (0, _utils.keyCode)(e);
	
	      if (code == ESC && !this.disableCancel) {
	        this.handleCancelClick();
	      } else if (code == ESC && this.disableCancel) {
	        this.handleConfirmClick();
	      } else if (code == ENTER && this.isKeyDown) {
	        this.isKeyDown = false;
	        this.handleConfirmClick();
	      }
	    }
	  }, {
	    key: "containsOkButton",
	    value: function containsOkButton(buttons) {
	      return buttons && buttons.filter(function (button) {
	        return button.ok === true;
	      }).length > 0;
	    }
	  }, {
	    key: "containsCancelButton",
	    value: function containsCancelButton(buttons) {
	      return buttons && buttons.filter(function (button) {
	        return button.cancel === true;
	      }).length > 0;
	    }
	  }, {
	    key: "getCustomButtonHandler",
	    value: function getCustomButtonHandler(config) {
	      var _this3 = this;
	
	      if (config.ok === true) {
	        return this.handleConfirmClick.bind(this);
	      }
	
	      if (config.cancel === true) {
	        return this.handleCancelClick.bind(this);
	      }
	
	      return function () {
	        return _this3.handleButtonClick(config.handler);
	      };
	    }
	  }, {
	    key: "getCustomButtonText",
	    value: function getCustomButtonText(config) {
	      if (config.ok === true) {
	        return this.okText;
	      }
	
	      if (config.cancel === true) {
	        return this.cancelText;
	      }
	
	      return config.text;
	    }
	  }, {
	    key: "getCustomButtonClassName",
	    value: function getCustomButtonClassName(config) {
	      if (config.ok === true) {
	        return 'rrt-ok-btn';
	      }
	
	      if (config.cancel === true) {
	        return 'rrt-cancel-btn';
	      }
	
	      return config.className;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this4 = this;
	
	      var _this$props$confirm = this.props.confirm,
	          options = _this$props$confirm.options,
	          message = _this$props$confirm.message;
	      var wrapperProps = {};
	      options.id && (wrapperProps.id = options.id);
	      return /*#__PURE__*/_react["default"].createElement("div", _extends({
	        className: "rrt-confirm-holder",
	        tabIndex: "-1",
	        ref: function ref(_ref2) {
	          return _this4.confirmHolderElement = _ref2;
	        },
	        onKeyDown: this.handleOnKeyDown,
	        onKeyUp: this.handleOnKeyUp,
	        role: "alert"
	      }, wrapperProps), /*#__PURE__*/_react["default"].createElement("div", {
	        className: "rrt-confirm animated",
	        ref: function ref(_ref) {
	          return _this4.confirmElement = _ref;
	        },
	        role: "alertdialog",
	        "aria-describedby": "dialogDesc-".concat(this.id)
	      }, message && /*#__PURE__*/_react["default"].createElement("div", {
	        className: "rrt-message",
	        id: "dialogDesc-".concat(this.id)
	      }, message), options.component && /*#__PURE__*/_react["default"].createElement(options.component, null), /*#__PURE__*/_react["default"].createElement("div", {
	        className: "rrt-buttons-holder"
	      }, !this.containsOkButton(options.buttons) && /*#__PURE__*/_react["default"].createElement(_Button["default"], {
	        tabIndex: "0",
	        innerRef: function innerRef(ref) {
	          return _this4.closeButton = ref;
	        },
	        className: "rrt-ok-btn toastr-control",
	        onClick: function onClick() {
	          return _this4.handleConfirmClick();
	        }
	      }, this.okText), !this.disableCancel && !this.containsCancelButton(options.buttons) && /*#__PURE__*/_react["default"].createElement(_Button["default"], {
	        tabIndex: "0",
	        innerRef: function innerRef(ref) {
	          return _this4.closeButton = ref;
	        },
	        className: "rrt-cancel-btn toastr-control",
	        onClick: this.handleCancelClick.bind(this)
	      }, this.cancelText), options.buttons && options.buttons.map(function (button, index) {
	        if (button.cancel === true && _this4.disableCancel) {
	          return null;
	        }
	
	        var handler = _this4.getCustomButtonHandler(button);
	
	        var text = _this4.getCustomButtonText(button);
	
	        var className = _this4.getCustomButtonClassName(button);
	
	        return /*#__PURE__*/_react["default"].createElement(_Button["default"], {
	          tabIndex: "0",
	          className: className,
	          onClick: handler,
	          key: index
	        }, text);
	      }))), /*#__PURE__*/_react["default"].createElement("div", {
	        className: "shadow",
	        onClick: this.handleCloseOnShadowClick.bind(this)
	      }));
	    }
	  }]);
	
	  return ToastrConfirm;
	}(_react["default"].Component);
	
	exports["default"] = ToastrConfirm;
	
	_defineProperty(ToastrConfirm, "displayName", 'ToastrConfirm');
	
	_defineProperty(ToastrConfirm, "propTypes", {
	  confirm: _propTypes["default"].shape({
	    options: _propTypes["default"].shape({
	      transitionIn: _propTypes["default"].string,
	      transitionOut: _propTypes["default"].string
	    })
	  })
	});

/***/ },
/* 1872 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = _default;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _default(name) {
	  switch (name) {
	    case 'success':
	      return /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
	        d: "M27 4l-15 15-7-7-5 5 12 12 20-20z"
	      }));
	
	    case 'info':
	      return /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
	        d: "M14 9.5c0-0.825 0.675-1.5 1.5-1.5h1c0.825 0 1.5 0.675 1.5 1.5v1c0 0.825-0.675 1.5-1.5 1.5h-1c-0.825 0-1.5-0.675-1.5-1.5v-1z"
	      }), /*#__PURE__*/_react["default"].createElement("path", {
	        d: "M20 24h-8v-2h2v-6h-2v-2h6v8h2z"
	      }), /*#__PURE__*/_react["default"].createElement("path", {
	        d: "M16 0c-8.837 0-16 7.163-16 16s7.163 16 16 16 16-7.163 16-16-7.163-16-16-16zM16 29c-7.18 0-13-5.82-13-13s5.82-13 13-13 13 5.82 13 13-5.82 13-13 13z"
	      }));
	
	    case 'warning':
	      return /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
	        d: "M16 2.899l13.409 26.726h-26.819l13.409-26.726zM16 0c-0.69 0-1.379 0.465-1.903 1.395l-13.659 27.222c-1.046 1.86-0.156 3.383 1.978 3.383h27.166c2.134 0 3.025-1.522 1.978-3.383h0l-13.659-27.222c-0.523-0.93-1.213-1.395-1.903-1.395v0z"
	      }), /*#__PURE__*/_react["default"].createElement("path", {
	        d: "M18 26c0 1.105-0.895 2-2 2s-2-0.895-2-2c0-1.105 0.895-2 2-2s2 0.895 2 2z"
	      }), /*#__PURE__*/_react["default"].createElement("path", {
	        d: "M16 22c-1.105 0-2-0.895-2-2v-6c0-1.105 0.895-2 2-2s2 0.895 2 2v6c0 1.105-0.895 2-2 2z"
	      }));
	
	    case 'error':
	      return /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
	        d: "M12,0C5.373,0,0,5.373,0,12s5.373,12,12,12s12-5.373,12-12S18.627,0,12,0z M12,19.66 c-0.938,0-1.58-0.723-1.58-1.66c0-0.964,0.669-1.66,1.58-1.66c0.963,0,1.58,0.696,1.58,1.66C13.58,18.938,12.963,19.66,12,19.66z M12.622,13.321c-0.239,0.815-0.992,0.829-1.243,0c-0.289-0.956-1.316-4.585-1.316-6.942c0-3.11,3.891-3.125,3.891,0 C13.953,8.75,12.871,12.473,12.622,13.321z"
	      }));
	
	    default:
	      return null;
	  }
	}

/***/ },
/* 1873 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var has = Object.prototype.hasOwnProperty
	  , prefix = '~';
	
	/**
	 * Constructor to create a storage for our `EE` objects.
	 * An `Events` instance is a plain object whose properties are event names.
	 *
	 * @constructor
	 * @private
	 */
	function Events() {}
	
	//
	// We try to not inherit from `Object.prototype`. In some engines creating an
	// instance in this way is faster than calling `Object.create(null)` directly.
	// If `Object.create(null)` is not supported we prefix the event names with a
	// character to make sure that the built-in object properties are not
	// overridden or used as an attack vector.
	//
	if (Object.create) {
	  Events.prototype = Object.create(null);
	
	  //
	  // This hack is needed because the `__proto__` property is still inherited in
	  // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
	  //
	  if (!new Events().__proto__) prefix = false;
	}
	
	/**
	 * Representation of a single event listener.
	 *
	 * @param {Function} fn The listener function.
	 * @param {*} context The context to invoke the listener with.
	 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
	 * @constructor
	 * @private
	 */
	function EE(fn, context, once) {
	  this.fn = fn;
	  this.context = context;
	  this.once = once || false;
	}
	
	/**
	 * Add a listener for a given event.
	 *
	 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
	 * @param {(String|Symbol)} event The event name.
	 * @param {Function} fn The listener function.
	 * @param {*} context The context to invoke the listener with.
	 * @param {Boolean} once Specify if the listener is a one-time listener.
	 * @returns {EventEmitter}
	 * @private
	 */
	function addListener(emitter, event, fn, context, once) {
	  if (typeof fn !== 'function') {
	    throw new TypeError('The listener must be a function');
	  }
	
	  var listener = new EE(fn, context || emitter, once)
	    , evt = prefix ? prefix + event : event;
	
	  if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
	  else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
	  else emitter._events[evt] = [emitter._events[evt], listener];
	
	  return emitter;
	}
	
	/**
	 * Clear event by name.
	 *
	 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
	 * @param {(String|Symbol)} evt The Event name.
	 * @private
	 */
	function clearEvent(emitter, evt) {
	  if (--emitter._eventsCount === 0) emitter._events = new Events();
	  else delete emitter._events[evt];
	}
	
	/**
	 * Minimal `EventEmitter` interface that is molded against the Node.js
	 * `EventEmitter` interface.
	 *
	 * @constructor
	 * @public
	 */
	function EventEmitter() {
	  this._events = new Events();
	  this._eventsCount = 0;
	}
	
	/**
	 * Return an array listing the events for which the emitter has registered
	 * listeners.
	 *
	 * @returns {Array}
	 * @public
	 */
	EventEmitter.prototype.eventNames = function eventNames() {
	  var names = []
	    , events
	    , name;
	
	  if (this._eventsCount === 0) return names;
	
	  for (name in (events = this._events)) {
	    if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
	  }
	
	  if (Object.getOwnPropertySymbols) {
	    return names.concat(Object.getOwnPropertySymbols(events));
	  }
	
	  return names;
	};
	
	/**
	 * Return the listeners registered for a given event.
	 *
	 * @param {(String|Symbol)} event The event name.
	 * @returns {Array} The registered listeners.
	 * @public
	 */
	EventEmitter.prototype.listeners = function listeners(event) {
	  var evt = prefix ? prefix + event : event
	    , handlers = this._events[evt];
	
	  if (!handlers) return [];
	  if (handlers.fn) return [handlers.fn];
	
	  for (var i = 0, l = handlers.length, ee = new Array(l); i < l; i++) {
	    ee[i] = handlers[i].fn;
	  }
	
	  return ee;
	};
	
	/**
	 * Return the number of listeners listening to a given event.
	 *
	 * @param {(String|Symbol)} event The event name.
	 * @returns {Number} The number of listeners.
	 * @public
	 */
	EventEmitter.prototype.listenerCount = function listenerCount(event) {
	  var evt = prefix ? prefix + event : event
	    , listeners = this._events[evt];
	
	  if (!listeners) return 0;
	  if (listeners.fn) return 1;
	  return listeners.length;
	};
	
	/**
	 * Calls each of the listeners registered for a given event.
	 *
	 * @param {(String|Symbol)} event The event name.
	 * @returns {Boolean} `true` if the event had listeners, else `false`.
	 * @public
	 */
	EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
	  var evt = prefix ? prefix + event : event;
	
	  if (!this._events[evt]) return false;
	
	  var listeners = this._events[evt]
	    , len = arguments.length
	    , args
	    , i;
	
	  if (listeners.fn) {
	    if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
	
	    switch (len) {
	      case 1: return listeners.fn.call(listeners.context), true;
	      case 2: return listeners.fn.call(listeners.context, a1), true;
	      case 3: return listeners.fn.call(listeners.context, a1, a2), true;
	      case 4: return listeners.fn.call(listeners.context, a1, a2, a3), true;
	      case 5: return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
	      case 6: return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
	    }
	
	    for (i = 1, args = new Array(len -1); i < len; i++) {
	      args[i - 1] = arguments[i];
	    }
	
	    listeners.fn.apply(listeners.context, args);
	  } else {
	    var length = listeners.length
	      , j;
	
	    for (i = 0; i < length; i++) {
	      if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
	
	      switch (len) {
	        case 1: listeners[i].fn.call(listeners[i].context); break;
	        case 2: listeners[i].fn.call(listeners[i].context, a1); break;
	        case 3: listeners[i].fn.call(listeners[i].context, a1, a2); break;
	        case 4: listeners[i].fn.call(listeners[i].context, a1, a2, a3); break;
	        default:
	          if (!args) for (j = 1, args = new Array(len -1); j < len; j++) {
	            args[j - 1] = arguments[j];
	          }
	
	          listeners[i].fn.apply(listeners[i].context, args);
	      }
	    }
	  }
	
	  return true;
	};
	
	/**
	 * Add a listener for a given event.
	 *
	 * @param {(String|Symbol)} event The event name.
	 * @param {Function} fn The listener function.
	 * @param {*} [context=this] The context to invoke the listener with.
	 * @returns {EventEmitter} `this`.
	 * @public
	 */
	EventEmitter.prototype.on = function on(event, fn, context) {
	  return addListener(this, event, fn, context, false);
	};
	
	/**
	 * Add a one-time listener for a given event.
	 *
	 * @param {(String|Symbol)} event The event name.
	 * @param {Function} fn The listener function.
	 * @param {*} [context=this] The context to invoke the listener with.
	 * @returns {EventEmitter} `this`.
	 * @public
	 */
	EventEmitter.prototype.once = function once(event, fn, context) {
	  return addListener(this, event, fn, context, true);
	};
	
	/**
	 * Remove the listeners of a given event.
	 *
	 * @param {(String|Symbol)} event The event name.
	 * @param {Function} fn Only remove the listeners that match this function.
	 * @param {*} context Only remove the listeners that have this context.
	 * @param {Boolean} once Only remove one-time listeners.
	 * @returns {EventEmitter} `this`.
	 * @public
	 */
	EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
	  var evt = prefix ? prefix + event : event;
	
	  if (!this._events[evt]) return this;
	  if (!fn) {
	    clearEvent(this, evt);
	    return this;
	  }
	
	  var listeners = this._events[evt];
	
	  if (listeners.fn) {
	    if (
	      listeners.fn === fn &&
	      (!once || listeners.once) &&
	      (!context || listeners.context === context)
	    ) {
	      clearEvent(this, evt);
	    }
	  } else {
	    for (var i = 0, events = [], length = listeners.length; i < length; i++) {
	      if (
	        listeners[i].fn !== fn ||
	        (once && !listeners[i].once) ||
	        (context && listeners[i].context !== context)
	      ) {
	        events.push(listeners[i]);
	      }
	    }
	
	    //
	    // Reset the array, or remove it completely if we have no more listeners.
	    //
	    if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
	    else clearEvent(this, evt);
	  }
	
	  return this;
	};
	
	/**
	 * Remove all listeners, or those of the specified event.
	 *
	 * @param {(String|Symbol)} [event] The event name.
	 * @returns {EventEmitter} `this`.
	 * @public
	 */
	EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
	  var evt;
	
	  if (event) {
	    evt = prefix ? prefix + event : event;
	    if (this._events[evt]) clearEvent(this, evt);
	  } else {
	    this._events = new Events();
	    this._eventsCount = 0;
	  }
	
	  return this;
	};
	
	//
	// Alias methods names because people roll like that.
	//
	EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
	EventEmitter.prototype.addListener = EventEmitter.prototype.on;
	
	//
	// Expose the prefix.
	//
	EventEmitter.prefixed = prefix;
	
	//
	// Allow `EventEmitter` to be imported as module namespace.
	//
	EventEmitter.EventEmitter = EventEmitter;
	
	//
	// Expose the module.
	//
	if (true) {
	  module.exports = EventEmitter;
	}


/***/ },
/* 1874 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(48);
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports.createProvider = createProvider;
	exports.default = void 0;
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(53));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _PropTypes = __webpack_require__(533);
	
	var _warning = _interopRequireDefault(__webpack_require__(315));
	
	var prefixUnsafeLifecycleMethods = typeof _react.default.forwardRef !== "undefined";
	var didWarnAboutReceivingStore = false;
	
	function warnAboutReceivingStore() {
	  if (didWarnAboutReceivingStore) {
	    return;
	  }
	
	  didWarnAboutReceivingStore = true;
	  (0, _warning.default)('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reduxjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
	}
	
	function createProvider(storeKey) {
	  var _Provider$childContex;
	
	  if (storeKey === void 0) {
	    storeKey = 'store';
	  }
	
	  var subscriptionKey = storeKey + "Subscription";
	
	  var Provider =
	  /*#__PURE__*/
	  function (_Component) {
	    (0, _inheritsLoose2.default)(Provider, _Component);
	    var _proto = Provider.prototype;
	
	    _proto.getChildContext = function getChildContext() {
	      var _ref;
	
	      return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
	    };
	
	    function Provider(props, context) {
	      var _this;
	
	      _this = _Component.call(this, props, context) || this;
	      _this[storeKey] = props.store;
	      return _this;
	    }
	
	    _proto.render = function render() {
	      return _react.Children.only(this.props.children);
	    };
	
	    return Provider;
	  }(_react.Component);
	
	  if (false) {
	    // Use UNSAFE_ event name where supported
	    var eventName = prefixUnsafeLifecycleMethods ? 'UNSAFE_componentWillReceiveProps' : 'componentWillReceiveProps';
	
	    Provider.prototype[eventName] = function (nextProps) {
	      if (this[storeKey] !== nextProps.store) {
	        warnAboutReceivingStore();
	      }
	    };
	  }
	
	  Provider.propTypes = {
	    store: _PropTypes.storeShape.isRequired,
	    children: _propTypes.default.element.isRequired
	  };
	  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = _PropTypes.storeShape.isRequired, _Provider$childContex[subscriptionKey] = _PropTypes.subscriptionShape, _Provider$childContex);
	  return Provider;
	}
	
	var _default = createProvider();
	
	exports.default = _default;

/***/ },
/* 1875 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports.createConnect = createConnect;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(35));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(43));
	
	var _connectAdvanced = _interopRequireDefault(__webpack_require__(531));
	
	var _shallowEqual = _interopRequireDefault(__webpack_require__(1883));
	
	var _mapDispatchToProps = _interopRequireDefault(__webpack_require__(1876));
	
	var _mapStateToProps = _interopRequireDefault(__webpack_require__(1877));
	
	var _mergeProps = _interopRequireDefault(__webpack_require__(1878));
	
	var _selectorFactory = _interopRequireDefault(__webpack_require__(1879));
	
	/*
	  connect is a facade over connectAdvanced. It turns its args into a compatible
	  selectorFactory, which has the signature:
	
	    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
	  
	  connect passes its args to connectAdvanced as options, which will in turn pass them to
	  selectorFactory each time a Connect component instance is instantiated or hot reloaded.
	
	  selectorFactory returns a final props selector from its mapStateToProps,
	  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
	  mergePropsFactories, and pure args.
	
	  The resulting final props selector is called by the Connect component instance whenever
	  it receives new props or store state.
	 */
	function match(arg, factories, name) {
	  for (var i = factories.length - 1; i >= 0; i--) {
	    var result = factories[i](arg);
	    if (result) return result;
	  }
	
	  return function (dispatch, options) {
	    throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
	  };
	}
	
	function strictEqual(a, b) {
	  return a === b;
	} // createConnect with default args builds the 'official' connect behavior. Calling it with
	// different options opens up some testing and extensibility scenarios
	
	
	function createConnect(_temp) {
	  var _ref = _temp === void 0 ? {} : _temp,
	      _ref$connectHOC = _ref.connectHOC,
	      connectHOC = _ref$connectHOC === void 0 ? _connectAdvanced.default : _ref$connectHOC,
	      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
	      mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? _mapStateToProps.default : _ref$mapStateToPropsF,
	      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
	      mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? _mapDispatchToProps.default : _ref$mapDispatchToPro,
	      _ref$mergePropsFactor = _ref.mergePropsFactories,
	      mergePropsFactories = _ref$mergePropsFactor === void 0 ? _mergeProps.default : _ref$mergePropsFactor,
	      _ref$selectorFactory = _ref.selectorFactory,
	      selectorFactory = _ref$selectorFactory === void 0 ? _selectorFactory.default : _ref$selectorFactory;
	
	  return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
	    if (_ref2 === void 0) {
	      _ref2 = {};
	    }
	
	    var _ref3 = _ref2,
	        _ref3$pure = _ref3.pure,
	        pure = _ref3$pure === void 0 ? true : _ref3$pure,
	        _ref3$areStatesEqual = _ref3.areStatesEqual,
	        areStatesEqual = _ref3$areStatesEqual === void 0 ? strictEqual : _ref3$areStatesEqual,
	        _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual,
	        areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? _shallowEqual.default : _ref3$areOwnPropsEqua,
	        _ref3$areStatePropsEq = _ref3.areStatePropsEqual,
	        areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? _shallowEqual.default : _ref3$areStatePropsEq,
	        _ref3$areMergedPropsE = _ref3.areMergedPropsEqual,
	        areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? _shallowEqual.default : _ref3$areMergedPropsE,
	        extraOptions = (0, _objectWithoutPropertiesLoose2.default)(_ref3, ["pure", "areStatesEqual", "areOwnPropsEqual", "areStatePropsEqual", "areMergedPropsEqual"]);
	    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
	    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
	    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
	    return connectHOC(selectorFactory, (0, _extends2.default)({
	      // used in error messages
	      methodName: 'connect',
	      // used to compute Connect's displayName from the wrapped component's displayName.
	      getDisplayName: function getDisplayName(name) {
	        return "Connect(" + name + ")";
	      },
	      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
	      shouldHandleStateChanges: Boolean(mapStateToProps),
	      // passed through to selectorFactory
	      initMapStateToProps: initMapStateToProps,
	      initMapDispatchToProps: initMapDispatchToProps,
	      initMergeProps: initMergeProps,
	      pure: pure,
	      areStatesEqual: areStatesEqual,
	      areOwnPropsEqual: areOwnPropsEqual,
	      areStatePropsEqual: areStatePropsEqual,
	      areMergedPropsEqual: areMergedPropsEqual
	    }, extraOptions));
	  };
	}
	
	var _default = createConnect();
	
	exports.default = _default;

/***/ },
/* 1876 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.whenMapDispatchToPropsIsFunction = whenMapDispatchToPropsIsFunction;
	exports.whenMapDispatchToPropsIsMissing = whenMapDispatchToPropsIsMissing;
	exports.whenMapDispatchToPropsIsObject = whenMapDispatchToPropsIsObject;
	exports.default = void 0;
	
	var _redux = __webpack_require__(163);
	
	var _wrapMapToProps = __webpack_require__(532);
	
	function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
	  return typeof mapDispatchToProps === 'function' ? (0, _wrapMapToProps.wrapMapToPropsFunc)(mapDispatchToProps, 'mapDispatchToProps') : undefined;
	}
	
	function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
	  return !mapDispatchToProps ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function (dispatch) {
	    return {
	      dispatch: dispatch
	    };
	  }) : undefined;
	}
	
	function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
	  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function (dispatch) {
	    return (0, _redux.bindActionCreators)(mapDispatchToProps, dispatch);
	  }) : undefined;
	}
	
	var _default = [whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject];
	exports.default = _default;

/***/ },
/* 1877 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.whenMapStateToPropsIsFunction = whenMapStateToPropsIsFunction;
	exports.whenMapStateToPropsIsMissing = whenMapStateToPropsIsMissing;
	exports.default = void 0;
	
	var _wrapMapToProps = __webpack_require__(532);
	
	function whenMapStateToPropsIsFunction(mapStateToProps) {
	  return typeof mapStateToProps === 'function' ? (0, _wrapMapToProps.wrapMapToPropsFunc)(mapStateToProps, 'mapStateToProps') : undefined;
	}
	
	function whenMapStateToPropsIsMissing(mapStateToProps) {
	  return !mapStateToProps ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function () {
	    return {};
	  }) : undefined;
	}
	
	var _default = [whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing];
	exports.default = _default;

/***/ },
/* 1878 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports.defaultMergeProps = defaultMergeProps;
	exports.wrapMergePropsFunc = wrapMergePropsFunc;
	exports.whenMergePropsIsFunction = whenMergePropsIsFunction;
	exports.whenMergePropsIsOmitted = whenMergePropsIsOmitted;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(35));
	
	var _verifyPlainObject = _interopRequireDefault(__webpack_require__(534));
	
	function defaultMergeProps(stateProps, dispatchProps, ownProps) {
	  return (0, _extends2.default)({}, ownProps, stateProps, dispatchProps);
	}
	
	function wrapMergePropsFunc(mergeProps) {
	  return function initMergePropsProxy(dispatch, _ref) {
	    var displayName = _ref.displayName,
	        pure = _ref.pure,
	        areMergedPropsEqual = _ref.areMergedPropsEqual;
	    var hasRunOnce = false;
	    var mergedProps;
	    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
	      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	
	      if (hasRunOnce) {
	        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
	      } else {
	        hasRunOnce = true;
	        mergedProps = nextMergedProps;
	        if (false) (0, _verifyPlainObject.default)(mergedProps, displayName, 'mergeProps');
	      }
	
	      return mergedProps;
	    };
	  };
	}
	
	function whenMergePropsIsFunction(mergeProps) {
	  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
	}
	
	function whenMergePropsIsOmitted(mergeProps) {
	  return !mergeProps ? function () {
	    return defaultMergeProps;
	  } : undefined;
	}
	
	var _default = [whenMergePropsIsFunction, whenMergePropsIsOmitted];
	exports.default = _default;

/***/ },
/* 1879 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports.impureFinalPropsSelectorFactory = impureFinalPropsSelectorFactory;
	exports.pureFinalPropsSelectorFactory = pureFinalPropsSelectorFactory;
	exports.default = finalPropsSelectorFactory;
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(43));
	
	var _verifySubselectors = _interopRequireDefault(__webpack_require__(1880));
	
	function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
	  return function impureFinalPropsSelector(state, ownProps) {
	    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
	  };
	}
	
	function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
	  var areStatesEqual = _ref.areStatesEqual,
	      areOwnPropsEqual = _ref.areOwnPropsEqual,
	      areStatePropsEqual = _ref.areStatePropsEqual;
	  var hasRunAtLeastOnce = false;
	  var state;
	  var ownProps;
	  var stateProps;
	  var dispatchProps;
	  var mergedProps;
	
	  function handleFirstCall(firstState, firstOwnProps) {
	    state = firstState;
	    ownProps = firstOwnProps;
	    stateProps = mapStateToProps(state, ownProps);
	    dispatchProps = mapDispatchToProps(dispatch, ownProps);
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    hasRunAtLeastOnce = true;
	    return mergedProps;
	  }
	
	  function handleNewPropsAndNewState() {
	    stateProps = mapStateToProps(state, ownProps);
	    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    return mergedProps;
	  }
	
	  function handleNewProps() {
	    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
	    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    return mergedProps;
	  }
	
	  function handleNewState() {
	    var nextStateProps = mapStateToProps(state, ownProps);
	    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
	    stateProps = nextStateProps;
	    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    return mergedProps;
	  }
	
	  function handleSubsequentCalls(nextState, nextOwnProps) {
	    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
	    var stateChanged = !areStatesEqual(nextState, state);
	    state = nextState;
	    ownProps = nextOwnProps;
	    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
	    if (propsChanged) return handleNewProps();
	    if (stateChanged) return handleNewState();
	    return mergedProps;
	  }
	
	  return function pureFinalPropsSelector(nextState, nextOwnProps) {
	    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
	  };
	} // TODO: Add more comments
	// If pure is true, the selector returned by selectorFactory will memoize its results,
	// allowing connectAdvanced's shouldComponentUpdate to return false if final
	// props have not changed. If false, the selector will always return a new
	// object and shouldComponentUpdate will always return true.
	
	
	function finalPropsSelectorFactory(dispatch, _ref2) {
	  var initMapStateToProps = _ref2.initMapStateToProps,
	      initMapDispatchToProps = _ref2.initMapDispatchToProps,
	      initMergeProps = _ref2.initMergeProps,
	      options = (0, _objectWithoutPropertiesLoose2.default)(_ref2, ["initMapStateToProps", "initMapDispatchToProps", "initMergeProps"]);
	  var mapStateToProps = initMapStateToProps(dispatch, options);
	  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
	  var mergeProps = initMergeProps(dispatch, options);
	
	  if (false) {
	    (0, _verifySubselectors.default)(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
	  }
	
	  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
	  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
	}

/***/ },
/* 1880 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports.default = verifySubselectors;
	
	var _warning = _interopRequireDefault(__webpack_require__(315));
	
	function verify(selector, methodName, displayName) {
	  if (!selector) {
	    throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
	  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
	    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
	      (0, _warning.default)("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
	    }
	  }
	}
	
	function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
	  verify(mapStateToProps, 'mapStateToProps', displayName);
	  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
	  verify(mergeProps, 'mergeProps', displayName);
	}

/***/ },
/* 1881 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	// encapsulates the subscription logic for connecting a component to the redux store, as
	// well as nesting subscriptions of descendant components, so that we can ensure the
	// ancestor components re-render before descendants
	var CLEARED = null;
	var nullListeners = {
	  notify: function notify() {}
	};
	
	function createListenerCollection() {
	  // the current/next pattern is copied from redux's createStore code.
	  // TODO: refactor+expose that code to be reusable here?
	  var current = [];
	  var next = [];
	  return {
	    clear: function clear() {
	      next = CLEARED;
	      current = CLEARED;
	    },
	    notify: function notify() {
	      var listeners = current = next;
	
	      for (var i = 0; i < listeners.length; i++) {
	        listeners[i]();
	      }
	    },
	    get: function get() {
	      return next;
	    },
	    subscribe: function subscribe(listener) {
	      var isSubscribed = true;
	      if (next === current) next = current.slice();
	      next.push(listener);
	      return function unsubscribe() {
	        if (!isSubscribed || current === CLEARED) return;
	        isSubscribed = false;
	        if (next === current) next = current.slice();
	        next.splice(next.indexOf(listener), 1);
	      };
	    }
	  };
	}
	
	var Subscription =
	/*#__PURE__*/
	function () {
	  function Subscription(store, parentSub, onStateChange) {
	    this.store = store;
	    this.parentSub = parentSub;
	    this.onStateChange = onStateChange;
	    this.unsubscribe = null;
	    this.listeners = nullListeners;
	  }
	
	  var _proto = Subscription.prototype;
	
	  _proto.addNestedSub = function addNestedSub(listener) {
	    this.trySubscribe();
	    return this.listeners.subscribe(listener);
	  };
	
	  _proto.notifyNestedSubs = function notifyNestedSubs() {
	    this.listeners.notify();
	  };
	
	  _proto.isSubscribed = function isSubscribed() {
	    return Boolean(this.unsubscribe);
	  };
	
	  _proto.trySubscribe = function trySubscribe() {
	    if (!this.unsubscribe) {
	      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);
	      this.listeners = createListenerCollection();
	    }
	  };
	
	  _proto.tryUnsubscribe = function tryUnsubscribe() {
	    if (this.unsubscribe) {
	      this.unsubscribe();
	      this.unsubscribe = null;
	      this.listeners.clear();
	      this.listeners = nullListeners;
	    }
	  };
	
	  return Subscription;
	}();
	
	exports.default = Subscription;

/***/ },
/* 1882 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = isPlainObject;
	
	/**
	 * @param {any} obj The object to inspect.
	 * @returns {boolean} True if the argument appears to be a plain object.
	 */
	function isPlainObject(obj) {
	  if (typeof obj !== 'object' || obj === null) return false;
	  var proto = Object.getPrototypeOf(obj);
	  if (proto === null) return true;
	  var baseProto = proto;
	
	  while (Object.getPrototypeOf(baseProto) !== null) {
	    baseProto = Object.getPrototypeOf(baseProto);
	  }
	
	  return proto === baseProto;
	}

/***/ },
/* 1883 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = shallowEqual;
	var hasOwn = Object.prototype.hasOwnProperty;
	
	function is(x, y) {
	  if (x === y) {
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    return x !== x && y !== y;
	  }
	}
	
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) return true;
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	  if (keysA.length !== keysB.length) return false;
	
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}

/***/ },
/* 1884 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createBrowserHistory = __webpack_require__(1896);
	
	var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);
	
	var _reactRouter = __webpack_require__(66);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for a <Router> that uses HTML5 history.
	 */
	var BrowserRouter = function (_React$Component) {
	  _inherits(BrowserRouter, _React$Component);
	
	  function BrowserRouter() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, BrowserRouter);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = (0, _createBrowserHistory2.default)(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  BrowserRouter.prototype.render = function render() {
	    return _react2.default.createElement(_reactRouter.Router, { history: this.history, children: this.props.children });
	  };
	
	  return BrowserRouter;
	}(_react2.default.Component);
	
	BrowserRouter.propTypes = {
	  basename: _propTypes2.default.string,
	  forceRefresh: _propTypes2.default.bool,
	  getUserConfirmation: _propTypes2.default.func,
	  keyLength: _propTypes2.default.number,
	  children: _propTypes2.default.node
	};
	exports.default = BrowserRouter;

/***/ },
/* 1885 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createHashHistory = __webpack_require__(1897);
	
	var _createHashHistory2 = _interopRequireDefault(_createHashHistory);
	
	var _reactRouter = __webpack_require__(66);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for a <Router> that uses window.location.hash.
	 */
	var HashRouter = function (_React$Component) {
	  _inherits(HashRouter, _React$Component);
	
	  function HashRouter() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, HashRouter);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = (0, _createHashHistory2.default)(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  HashRouter.prototype.render = function render() {
	    return _react2.default.createElement(_reactRouter.Router, { history: this.history, children: this.props.children });
	  };
	
	  return HashRouter;
	}(_react2.default.Component);
	
	HashRouter.propTypes = {
	  basename: _propTypes2.default.string,
	  getUserConfirmation: _propTypes2.default.func,
	  hashType: _propTypes2.default.oneOf(['hashbang', 'noslash', 'slash']),
	  children: _propTypes2.default.node
	};
	exports.default = HashRouter;

/***/ },
/* 1886 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _reactRouter = __webpack_require__(66);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _reactRouter.MemoryRouter;
	  }
	});

/***/ },
/* 1887 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRouter = __webpack_require__(66);
	
	var _Link = __webpack_require__(535);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 * A <Link> wrapper that knows if it's "active" or not.
	 */
	var NavLink = function NavLink(_ref) {
	  var to = _ref.to,
	      exact = _ref.exact,
	      strict = _ref.strict,
	      location = _ref.location,
	      activeClassName = _ref.activeClassName,
	      className = _ref.className,
	      activeStyle = _ref.activeStyle,
	      style = _ref.style,
	      getIsActive = _ref.isActive,
	      rest = _objectWithoutProperties(_ref, ['to', 'exact', 'strict', 'location', 'activeClassName', 'className', 'activeStyle', 'style', 'isActive']);
	
	  return _react2.default.createElement(_reactRouter.Route, {
	    path: (typeof to === 'undefined' ? 'undefined' : _typeof(to)) === 'object' ? to.pathname : to,
	    exact: exact,
	    strict: strict,
	    location: location,
	    children: function children(_ref2) {
	      var location = _ref2.location,
	          match = _ref2.match;
	
	      var isActive = !!(getIsActive ? getIsActive(match, location) : match);
	
	      return _react2.default.createElement(_Link2.default, _extends({
	        to: to,
	        className: isActive ? [activeClassName, className].filter(function (i) {
	          return i;
	        }).join(' ') : className,
	        style: isActive ? _extends({}, style, activeStyle) : style
	      }, rest));
	    }
	  });
	};
	
	NavLink.propTypes = {
	  to: _Link2.default.propTypes.to,
	  exact: _propTypes2.default.bool,
	  strict: _propTypes2.default.bool,
	  location: _propTypes2.default.object,
	  activeClassName: _propTypes2.default.string,
	  className: _propTypes2.default.string,
	  activeStyle: _propTypes2.default.object,
	  style: _propTypes2.default.object,
	  isActive: _propTypes2.default.func
	};
	
	NavLink.defaultProps = {
	  activeClassName: 'active'
	};
	
	exports.default = NavLink;

/***/ },
/* 1888 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _reactRouter = __webpack_require__(66);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _reactRouter.Prompt;
	  }
	});

/***/ },
/* 1889 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _reactRouter = __webpack_require__(66);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _reactRouter.Redirect;
	  }
	});

/***/ },
/* 1890 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _reactRouter = __webpack_require__(66);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _reactRouter.Route;
	  }
	});

/***/ },
/* 1891 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _reactRouter = __webpack_require__(66);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _reactRouter.Router;
	  }
	});

/***/ },
/* 1892 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _reactRouter = __webpack_require__(66);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _reactRouter.StaticRouter;
	  }
	});

/***/ },
/* 1893 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _reactRouter = __webpack_require__(66);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _reactRouter.Switch;
	  }
	});

/***/ },
/* 1894 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _reactRouter = __webpack_require__(66);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _reactRouter.matchPath;
	  }
	});

/***/ },
/* 1895 */
[2189, 1907, 1909],
/* 1896 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	__webpack_require__(536)('createBrowserHistory');
	module.exports = __webpack_require__(161).createBrowserHistory;


/***/ },
/* 1897 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	__webpack_require__(536)('createHashHistory');
	module.exports = __webpack_require__(161).createHashHistory;


/***/ },
/* 1898 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    getDerivedStateFromProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	    name: true,
	    length: true,
	    prototype: true,
	    caller: true,
	    callee: true,
	    arguments: true,
	    arity: true
	};
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	
	function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	
	        if (objectPrototype) {
	            var inheritedComponent = getPrototypeOf(sourceComponent);
	            if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	            }
	        }
	
	        var keys = getOwnPropertyNames(sourceComponent);
	
	        if (getOwnPropertySymbols) {
	            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            var key = keys[i];
	            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
	                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                try { // Avoid failures from read-only properties
	                    defineProperty(targetComponent, key, descriptor);
	                } catch (e) {}
	            }
	        }
	
	        return targetComponent;
	    }
	
	    return targetComponent;
	}
	
	module.exports = hoistNonReactStatics;


/***/ },
/* 1899 */
/***/ function(module, exports) {

	module.exports = Array.isArray || function (arr) {
	  return Object.prototype.toString.call(arr) == '[object Array]';
	};


/***/ },
/* 1900 */
[2192, 134, 161, 316],
/* 1901 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _invariant = __webpack_require__(37);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for prompting the user before navigating away
	 * from a screen with a component.
	 */
	var Prompt = function (_React$Component) {
	  _inherits(Prompt, _React$Component);
	
	  function Prompt() {
	    _classCallCheck(this, Prompt);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Prompt.prototype.enable = function enable(message) {
	    if (this.unblock) this.unblock();
	
	    this.unblock = this.context.router.history.block(message);
	  };
	
	  Prompt.prototype.disable = function disable() {
	    if (this.unblock) {
	      this.unblock();
	      this.unblock = null;
	    }
	  };
	
	  Prompt.prototype.componentWillMount = function componentWillMount() {
	    (0, _invariant2.default)(this.context.router, "You should not use <Prompt> outside a <Router>");
	
	    if (this.props.when) this.enable(this.props.message);
	  };
	
	  Prompt.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (nextProps.when) {
	      if (!this.props.when || this.props.message !== nextProps.message) this.enable(nextProps.message);
	    } else {
	      this.disable();
	    }
	  };
	
	  Prompt.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.disable();
	  };
	
	  Prompt.prototype.render = function render() {
	    return null;
	  };
	
	  return Prompt;
	}(_react2.default.Component);
	
	Prompt.propTypes = {
	  when: _propTypes2.default.bool,
	  message: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]).isRequired
	};
	Prompt.defaultProps = {
	  when: true
	};
	Prompt.contextTypes = {
	  router: _propTypes2.default.shape({
	    history: _propTypes2.default.shape({
	      block: _propTypes2.default.func.isRequired
	    }).isRequired
	  }).isRequired
	};
	exports.default = Prompt;

/***/ },
/* 1902 */
[2193, 134, 161, 539],
/* 1903 */
[2196, 134, 161, 316],
/* 1904 */
[2197, 134, 317],
/* 1905 */
[2201, 1898, 538],
/* 1906 */
/***/ function(module, exports) {

	"use strict";function isAbsolute(e){return"/"===e.charAt(0)}function spliceOne(e,t){for(var s=t,n=s+1,i=e.length;n<i;s+=1,n+=1)e[s]=e[n];e.pop()}function resolvePathname(e,t){void 0===t&&(t="");var s,n=e&&e.split("/")||[],i=t&&t.split("/")||[],l=e&&isAbsolute(e),r=t&&isAbsolute(t),o=l||r;if(e&&isAbsolute(e)?i=n:n.length&&(i.pop(),i=i.concat(n)),!i.length)return"/";if(i.length){var u=i[i.length-1];s="."===u||".."===u||""===u}else s=!1;for(var a=0,c=i.length;0<=c;c--){var f=i[c];"."===f?spliceOne(i,c):".."===f?(spliceOne(i,c),a++):a&&(spliceOne(i,c),a--)}if(!o)for(;a--;a)i.unshift("..");!o||""===i[0]||i[0]&&isAbsolute(i[0])||i.unshift("");var h=i.join("/");return s&&"/"!==h.substr(-1)&&(h+="/"),h}module.exports=resolvePathname;


/***/ },
/* 1907 */
[2202, 1906],
/* 1908 */
/***/ function(module, exports) {

	"use strict";function valueOf(e){return e.valueOf?e.valueOf():Object.prototype.valueOf.call(e)}function valueEqual(u,r){if(u===r)return!0;if(null==u||null==r)return!1;if(Array.isArray(u))return Array.isArray(r)&&u.length===r.length&&u.every(function(e,u){return valueEqual(e,r[u])});if("object"!=typeof u&&"object"!=typeof r)return!1;var e=valueOf(u),t=valueOf(r);return e!==u||t!==r?valueEqual(e,t):Object.keys(Object.assign({},u,r)).every(function(e){return valueEqual(u[e],r[e])})}module.exports=valueEqual;


/***/ },
/* 1909 */
[2203, 1908],
/* 1910 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _reactRouter = __webpack_require__(66);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _reactRouter.withRouter;
	  }
	});

/***/ },
/* 1911 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRouter = __webpack_require__(1921);
	
	var _reducer = __webpack_require__(544);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ConnectedRouter = function (_Component) {
	  _inherits(ConnectedRouter, _Component);
	
	  function ConnectedRouter() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ConnectedRouter);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.handleLocationChange = function (location) {
	      _this.store.dispatch({
	        type: _reducer.LOCATION_CHANGE,
	        payload: location
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  ConnectedRouter.prototype.componentWillMount = function componentWillMount() {
	    var _props = this.props,
	        propsStore = _props.store,
	        history = _props.history;
	
	    this.store = propsStore || this.context.store;
	
	    this.unsubscribeFromHistory = history.listen(this.handleLocationChange);
	    this.handleLocationChange(history.location);
	  };
	
	  ConnectedRouter.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (this.unsubscribeFromHistory) this.unsubscribeFromHistory();
	  };
	
	  ConnectedRouter.prototype.render = function render() {
	    return _react2.default.createElement(_reactRouter.Router, this.props);
	  };
	
	  return ConnectedRouter;
	}(_react.Component);
	
	ConnectedRouter.propTypes = {
	  store: _propTypes2.default.object,
	  history: _propTypes2.default.object,
	  children: _propTypes2.default.node
	};
	ConnectedRouter.contextTypes = {
	  store: _propTypes2.default.object
	};
	exports.default = ConnectedRouter;

/***/ },
/* 1912 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = routerMiddleware;
	
	var _actions = __webpack_require__(540);
	
	/**
	 * This middleware captures CALL_HISTORY_METHOD actions to redirect to the
	 * provided history object. This will prevent these actions from reaching your
	 * reducer or any middleware that comes after this one.
	 */
	function routerMiddleware(history) {
	  return function () {
	    return function (next) {
	      return function (action) {
	        if (action.type !== _actions.CALL_HISTORY_METHOD) {
	          return next(action);
	        }
	
	        var _action$payload = action.payload,
	            method = _action$payload.method,
	            args = _action$payload.args;
	
	        history[method].apply(history, args);
	      };
	    };
	  };
	}

/***/ },
/* 1913 */
[2189, 1924, 1926],
/* 1914 */
1898,
/* 1915 */
1899,
/* 1916 */
[2192, 135, 318, 319],
/* 1917 */
1901,
/* 1918 */
[2193, 135, 318, 543],
/* 1919 */
[2196, 135, 318, 319],
/* 1920 */
[2197, 135, 320],
/* 1921 */
[2199, 1916, 1917, 1918, 542, 319, 1919, 1920, 543, 320, 1922],
/* 1922 */
[2201, 1914, 542],
/* 1923 */
1906,
/* 1924 */
[2202, 1923],
/* 1925 */
1908,
/* 1926 */
[2203, 1925],
/* 1927 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.classNamesShape = exports.timeoutsShape = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var timeoutsShape =  false ? _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
	  enter: _propTypes.default.number,
	  exit: _propTypes.default.number,
	  appear: _propTypes.default.number
	}).isRequired]) : null;
	exports.timeoutsShape = timeoutsShape;
	var classNamesShape =  false ? _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.shape({
	  enter: _propTypes.default.string,
	  exit: _propTypes.default.string,
	  active: _propTypes.default.string
	}), _propTypes.default.shape({
	  enter: _propTypes.default.string,
	  enterDone: _propTypes.default.string,
	  enterActive: _propTypes.default.string,
	  exit: _propTypes.default.string,
	  exitDone: _propTypes.default.string,
	  exitActive: _propTypes.default.string
	})]) : null;
	exports.classNamesShape = classNamesShape;

/***/ },
/* 1928 */
/***/ function(module, exports, __webpack_require__) {

	/** @license React v16.8.6
	 * react.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';var k=__webpack_require__(1929),n="function"===typeof Symbol&&Symbol.for,p=n?Symbol.for("react.element"):60103,q=n?Symbol.for("react.portal"):60106,r=n?Symbol.for("react.fragment"):60107,t=n?Symbol.for("react.strict_mode"):60108,u=n?Symbol.for("react.profiler"):60114,v=n?Symbol.for("react.provider"):60109,w=n?Symbol.for("react.context"):60110,x=n?Symbol.for("react.concurrent_mode"):60111,y=n?Symbol.for("react.forward_ref"):60112,z=n?Symbol.for("react.suspense"):60113,aa=n?Symbol.for("react.memo"):
	60115,ba=n?Symbol.for("react.lazy"):60116,A="function"===typeof Symbol&&Symbol.iterator;function ca(a,b,d,c,e,g,h,f){if(!a){a=void 0;if(void 0===b)a=Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var l=[d,c,e,g,h,f],m=0;a=Error(b.replace(/%s/g,function(){return l[m++]}));a.name="Invariant Violation"}a.framesToPop=1;throw a;}}
	function B(a){for(var b=arguments.length-1,d="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=0;c<b;c++)d+="&args[]="+encodeURIComponent(arguments[c+1]);ca(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",d)}var C={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},D={};
	function E(a,b,d){this.props=a;this.context=b;this.refs=D;this.updater=d||C}E.prototype.isReactComponent={};E.prototype.setState=function(a,b){"object"!==typeof a&&"function"!==typeof a&&null!=a?B("85"):void 0;this.updater.enqueueSetState(this,a,b,"setState")};E.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};function F(){}F.prototype=E.prototype;function G(a,b,d){this.props=a;this.context=b;this.refs=D;this.updater=d||C}var H=G.prototype=new F;
	H.constructor=G;k(H,E.prototype);H.isPureReactComponent=!0;var I={current:null},J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
	function M(a,b,d){var c=void 0,e={},g=null,h=null;if(null!=b)for(c in void 0!==b.ref&&(h=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,c)&&!L.hasOwnProperty(c)&&(e[c]=b[c]);var f=arguments.length-2;if(1===f)e.children=d;else if(1<f){for(var l=Array(f),m=0;m<f;m++)l[m]=arguments[m+2];e.children=l}if(a&&a.defaultProps)for(c in f=a.defaultProps,f)void 0===e[c]&&(e[c]=f[c]);return{$$typeof:p,type:a,key:g,ref:h,props:e,_owner:J.current}}
	function da(a,b){return{$$typeof:p,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function N(a){return"object"===typeof a&&null!==a&&a.$$typeof===p}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var O=/\/+/g,P=[];function Q(a,b,d,c){if(P.length){var e=P.pop();e.result=a;e.keyPrefix=b;e.func=d;e.context=c;e.count=0;return e}return{result:a,keyPrefix:b,func:d,context:c,count:0}}
	function R(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>P.length&&P.push(a)}
	function S(a,b,d,c){var e=typeof a;if("undefined"===e||"boolean"===e)a=null;var g=!1;if(null===a)g=!0;else switch(e){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case p:case q:g=!0}}if(g)return d(c,a,""===b?"."+T(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var h=0;h<a.length;h++){e=a[h];var f=b+T(e,h);g+=S(e,f,d,c)}else if(null===a||"object"!==typeof a?f=null:(f=A&&a[A]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),h=
	0;!(e=a.next()).done;)e=e.value,f=b+T(e,h++),g+=S(e,f,d,c);else"object"===e&&(d=""+a,B("31","[object Object]"===d?"object with keys {"+Object.keys(a).join(", ")+"}":d,""));return g}function U(a,b,d){return null==a?0:S(a,"",b,d)}function T(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function ea(a,b){a.func.call(a.context,b,a.count++)}
	function fa(a,b,d){var c=a.result,e=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?V(a,c,d,function(a){return a}):null!=a&&(N(a)&&(a=da(a,e+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(O,"$&/")+"/")+d)),c.push(a))}function V(a,b,d,c,e){var g="";null!=d&&(g=(""+d).replace(O,"$&/")+"/");b=Q(b,g,c,e);U(a,fa,b);R(b)}function W(){var a=I.current;null===a?B("321"):void 0;return a}
	var X={Children:{map:function(a,b,d){if(null==a)return a;var c=[];V(a,c,null,b,d);return c},forEach:function(a,b,d){if(null==a)return a;b=Q(null,null,b,d);U(a,ea,b);R(b)},count:function(a){return U(a,function(){return null},null)},toArray:function(a){var b=[];V(a,b,null,function(a){return a});return b},only:function(a){N(a)?void 0:B("143");return a}},createRef:function(){return{current:null}},Component:E,PureComponent:G,createContext:function(a,b){void 0===b&&(b=null);a={$$typeof:w,_calculateChangedBits:b,
	_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:v,_context:a};return a.Consumer=a},forwardRef:function(a){return{$$typeof:y,render:a}},lazy:function(a){return{$$typeof:ba,_ctor:a,_status:-1,_result:null}},memo:function(a,b){return{$$typeof:aa,type:a,compare:void 0===b?null:b}},useCallback:function(a,b){return W().useCallback(a,b)},useContext:function(a,b){return W().useContext(a,b)},useEffect:function(a,b){return W().useEffect(a,b)},useImperativeHandle:function(a,
	b,d){return W().useImperativeHandle(a,b,d)},useDebugValue:function(){},useLayoutEffect:function(a,b){return W().useLayoutEffect(a,b)},useMemo:function(a,b){return W().useMemo(a,b)},useReducer:function(a,b,d){return W().useReducer(a,b,d)},useRef:function(a){return W().useRef(a)},useState:function(a){return W().useState(a)},Fragment:r,StrictMode:t,Suspense:z,createElement:M,cloneElement:function(a,b,d){null===a||void 0===a?B("267",a):void 0;var c=void 0,e=k({},a.props),g=a.key,h=a.ref,f=a._owner;if(null!=
	b){void 0!==b.ref&&(h=b.ref,f=J.current);void 0!==b.key&&(g=""+b.key);var l=void 0;a.type&&a.type.defaultProps&&(l=a.type.defaultProps);for(c in b)K.call(b,c)&&!L.hasOwnProperty(c)&&(e[c]=void 0===b[c]&&void 0!==l?l[c]:b[c])}c=arguments.length-2;if(1===c)e.children=d;else if(1<c){l=Array(c);for(var m=0;m<c;m++)l[m]=arguments[m+2];e.children=l}return{$$typeof:p,type:a.type,key:g,ref:h,props:e,_owner:f}},createFactory:function(a){var b=M.bind(null,a);b.type=a;return b},isValidElement:N,version:"16.8.6",
	unstable_ConcurrentMode:x,unstable_Profiler:u,__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentDispatcher:I,ReactCurrentOwner:J,assign:k}},Y={default:X},Z=Y&&X||Y;module.exports=Z.default||Z;


/***/ },
/* 1929 */
1843,
/* 1930 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(48);
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(43));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(35));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(53));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _reactRedux = __webpack_require__(18);
	
	var _createFieldProps2 = _interopRequireDefault(__webpack_require__(548));
	
	var _onChangeValue = _interopRequireDefault(__webpack_require__(553));
	
	var _eventConsts = __webpack_require__(1998);
	
	var _plain = _interopRequireDefault(__webpack_require__(27));
	
	var _isReactNative = _interopRequireDefault(__webpack_require__(555));
	
	var _validateComponentProp = _interopRequireDefault(__webpack_require__(112));
	
	var _isEvent = _interopRequireDefault(__webpack_require__(322));
	
	var propsToNotUpdateFor = ['_reduxForm'];
	
	var isObject = function isObject(entity) {
	  return entity && typeof entity === 'object';
	};
	
	var isFunction = function isFunction(entity) {
	  return entity && typeof entity === 'function';
	};
	
	var eventPreventDefault = function eventPreventDefault(event) {
	  if (isObject(event) && isFunction(event.preventDefault)) {
	    event.preventDefault();
	  }
	};
	
	var eventDataTransferGetData = function eventDataTransferGetData(event, key) {
	  if (isObject(event) && isObject(event.dataTransfer) && isFunction(event.dataTransfer.getData)) {
	    return event.dataTransfer.getData(key);
	  }
	};
	
	var eventDataTransferSetData = function eventDataTransferSetData(event, key, value) {
	  if (isObject(event) && isObject(event.dataTransfer) && isFunction(event.dataTransfer.setData)) {
	    event.dataTransfer.setData(key, value);
	  }
	};
	
	function createConnectedField(structure) {
	  var deepEqual = structure.deepEqual,
	      getIn = structure.getIn;
	
	  var getSyncError = function getSyncError(syncErrors, name) {
	    var error = _plain["default"].getIn(syncErrors, name); // Because the error for this field might not be at a level in the error structure where
	    // it can be set directly, it might need to be unwrapped from the _error property
	
	
	    return error && error._error ? error._error : error;
	  };
	
	  var getSyncWarning = function getSyncWarning(syncWarnings, name) {
	    var warning = getIn(syncWarnings, name); // Because the warning for this field might not be at a level in the warning structure where
	    // it can be set directly, it might need to be unwrapped from the _warning property
	
	    return warning && warning._warning ? warning._warning : warning;
	  };
	
	  var ConnectedField = /*#__PURE__*/function (_Component) {
	    (0, _inheritsLoose2["default"])(ConnectedField, _Component);
	
	    function ConnectedField() {
	      var _this;
	
	      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      _this = _Component.call.apply(_Component, [this].concat(args)) || this;
	      _this.ref = _react["default"].createRef();
	
	      _this.isPristine = function () {
	        return _this.props.pristine;
	      };
	
	      _this.getValue = function () {
	        return _this.props.value;
	      };
	
	      _this.handleChange = function (event) {
	        var _this$props = _this.props,
	            name = _this$props.name,
	            dispatch = _this$props.dispatch,
	            parse = _this$props.parse,
	            normalize = _this$props.normalize,
	            onChange = _this$props.onChange,
	            _reduxForm = _this$props._reduxForm,
	            previousValue = _this$props.value;
	        var newValue = (0, _onChangeValue["default"])(event, {
	          name: name,
	          parse: parse,
	          normalize: normalize
	        });
	        var defaultPrevented = false;
	
	        if (onChange) {
	          // Can't seem to find a way to extend Event in React Native,
	          // thus I simply avoid adding preventDefault() in a RN environment
	          // to prevent the following error:
	          // `One of the sources for assign has an enumerable key on the prototype chain`
	          // Reference: https://github.com/facebook/react-native/issues/5507
	          if (!_isReactNative["default"] && (0, _isEvent["default"])(event)) {
	            onChange((0, _extends2["default"])({}, event, {
	              preventDefault: function preventDefault() {
	                defaultPrevented = true;
	                return eventPreventDefault(event);
	              }
	            }), newValue, previousValue, name);
	          } else {
	            var onChangeResult = onChange(event, newValue, previousValue, name); // Return value of change handler affecting preventDefault is RN
	            // specific behavior.
	
	            if (_isReactNative["default"]) {
	              defaultPrevented = onChangeResult;
	            }
	          }
	        }
	
	        if (!defaultPrevented) {
	          // dispatch change action
	          dispatch(_reduxForm.change(name, newValue)); // call post-change callback
	
	          if (_reduxForm.asyncValidate) {
	            _reduxForm.asyncValidate(name, newValue, 'change');
	          }
	        }
	      };
	
	      _this.handleFocus = function (event) {
	        var _this$props2 = _this.props,
	            name = _this$props2.name,
	            dispatch = _this$props2.dispatch,
	            onFocus = _this$props2.onFocus,
	            _reduxForm = _this$props2._reduxForm;
	        var defaultPrevented = false;
	
	        if (onFocus) {
	          if (!_isReactNative["default"]) {
	            onFocus((0, _extends2["default"])({}, event, {
	              preventDefault: function preventDefault() {
	                defaultPrevented = true;
	                return eventPreventDefault(event);
	              }
	            }), name);
	          } else {
	            defaultPrevented = onFocus(event, name);
	          }
	        }
	
	        if (!defaultPrevented) {
	          dispatch(_reduxForm.focus(name));
	        }
	      };
	
	      _this.handleBlur = function (event) {
	        var _this$props3 = _this.props,
	            name = _this$props3.name,
	            dispatch = _this$props3.dispatch,
	            parse = _this$props3.parse,
	            normalize = _this$props3.normalize,
	            onBlur = _this$props3.onBlur,
	            _reduxForm = _this$props3._reduxForm,
	            _value = _this$props3._value,
	            previousValue = _this$props3.value;
	        var newValue = (0, _onChangeValue["default"])(event, {
	          name: name,
	          parse: parse,
	          normalize: normalize
	        }); // for checkbox and radio, if the value property of checkbox or radio equals
	        // the value passed by blur event, then fire blur action with previousValue.
	
	        if (newValue === _value && _value !== undefined) {
	          newValue = previousValue;
	        }
	
	        var defaultPrevented = false;
	
	        if (onBlur) {
	          if (!_isReactNative["default"]) {
	            onBlur((0, _extends2["default"])({}, event, {
	              preventDefault: function preventDefault() {
	                defaultPrevented = true;
	                return eventPreventDefault(event);
	              }
	            }), newValue, previousValue, name);
	          } else {
	            defaultPrevented = onBlur(event, newValue, previousValue, name);
	          }
	        }
	
	        if (!defaultPrevented) {
	          // dispatch blur action
	          dispatch(_reduxForm.blur(name, newValue)); // call post-blur callback
	
	          if (_reduxForm.asyncValidate) {
	            _reduxForm.asyncValidate(name, newValue, 'blur');
	          }
	        }
	      };
	
	      _this.handleDragStart = function (event) {
	        var _this$props4 = _this.props,
	            name = _this$props4.name,
	            onDragStart = _this$props4.onDragStart,
	            value = _this$props4.value;
	        eventDataTransferSetData(event, _eventConsts.dataKey, value == null ? '' : value);
	
	        if (onDragStart) {
	          onDragStart(event, name);
	        }
	      };
	
	      _this.handleDrop = function (event) {
	        var _this$props5 = _this.props,
	            name = _this$props5.name,
	            dispatch = _this$props5.dispatch,
	            onDrop = _this$props5.onDrop,
	            _reduxForm = _this$props5._reduxForm,
	            previousValue = _this$props5.value;
	        var newValue = eventDataTransferGetData(event, _eventConsts.dataKey);
	        var defaultPrevented = false;
	
	        if (onDrop) {
	          onDrop((0, _extends2["default"])({}, event, {
	            preventDefault: function preventDefault() {
	              defaultPrevented = true;
	              return eventPreventDefault(event);
	            }
	          }), newValue, previousValue, name);
	        }
	
	        if (!defaultPrevented) {
	          // dispatch change action
	          dispatch(_reduxForm.change(name, newValue));
	          eventPreventDefault(event);
	        }
	      };
	
	      return _this;
	    }
	
	    var _proto = ConnectedField.prototype;
	
	    _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	      var _this2 = this;
	
	      var nextPropsKeys = Object.keys(nextProps);
	      var thisPropsKeys = Object.keys(this.props); // if we have children, we MUST update in React 16
	      // https://twitter.com/erikras/status/915866544558788608
	
	      return !!(this.props.children || nextProps.children || nextPropsKeys.length !== thisPropsKeys.length || nextPropsKeys.some(function (prop) {
	        if (~(nextProps.immutableProps || []).indexOf(prop)) {
	          return _this2.props[prop] !== nextProps[prop];
	        }
	
	        return !~propsToNotUpdateFor.indexOf(prop) && !deepEqual(_this2.props[prop], nextProps[prop]);
	      }));
	    };
	
	    _proto.getRenderedComponent = function getRenderedComponent() {
	      return this.ref.current;
	    };
	
	    _proto.render = function render() {
	      var _this$props6 = this.props,
	          component = _this$props6.component,
	          forwardRef = _this$props6.forwardRef,
	          name = _this$props6.name,
	          _reduxForm = _this$props6._reduxForm,
	          normalize = _this$props6.normalize,
	          onBlur = _this$props6.onBlur,
	          onChange = _this$props6.onChange,
	          onFocus = _this$props6.onFocus,
	          onDragStart = _this$props6.onDragStart,
	          onDrop = _this$props6.onDrop,
	          immutableProps = _this$props6.immutableProps,
	          rest = (0, _objectWithoutPropertiesLoose2["default"])(_this$props6, ["component", "forwardRef", "name", "_reduxForm", "normalize", "onBlur", "onChange", "onFocus", "onDragStart", "onDrop", "immutableProps"]);
	
	      var _createFieldProps = (0, _createFieldProps2["default"])(structure, name, (0, _extends2["default"])({}, rest, {
	        form: _reduxForm.form,
	        onBlur: this.handleBlur,
	        onChange: this.handleChange,
	        onDrop: this.handleDrop,
	        onDragStart: this.handleDragStart,
	        onFocus: this.handleFocus
	      })),
	          custom = _createFieldProps.custom,
	          props = (0, _objectWithoutPropertiesLoose2["default"])(_createFieldProps, ["custom"]);
	
	      if (forwardRef) {
	        custom.ref = this.ref;
	      }
	
	      if (typeof component === 'string') {
	        var input = props.input,
	            meta = props.meta; // eslint-disable-line no-unused-vars
	        // flatten input into other props
	
	        return (0, _react.createElement)(component, (0, _extends2["default"])({}, input, {}, custom));
	      } else {
	        return (0, _react.createElement)(component, (0, _extends2["default"])({}, props, {}, custom));
	      }
	    };
	
	    return ConnectedField;
	  }(_react.Component);
	
	  ConnectedField.propTypes = {
	    component: _validateComponentProp["default"],
	    props: _propTypes["default"].object
	  };
	  var connector = (0, _reactRedux.connect)(function (state, ownProps) {
	    var name = ownProps.name,
	        _ownProps$_reduxForm = ownProps._reduxForm,
	        initialValues = _ownProps$_reduxForm.initialValues,
	        getFormState = _ownProps$_reduxForm.getFormState;
	    var formState = getFormState(state);
	    var initialState = getIn(formState, "initial." + name);
	    var initial = initialState !== undefined ? initialState : initialValues && getIn(initialValues, name);
	    var value = getIn(formState, "values." + name);
	    var submitting = getIn(formState, 'submitting');
	    var syncError = getSyncError(getIn(formState, 'syncErrors'), name);
	    var syncWarning = getSyncWarning(getIn(formState, 'syncWarnings'), name);
	    var pristine = deepEqual(value, initial);
	    return {
	      asyncError: getIn(formState, "asyncErrors." + name),
	      asyncValidating: getIn(formState, 'asyncValidating') === name,
	      dirty: !pristine,
	      pristine: pristine,
	      state: getIn(formState, "fields." + name),
	      submitError: getIn(formState, "submitErrors." + name),
	      submitFailed: getIn(formState, 'submitFailed'),
	      submitting: submitting,
	      syncError: syncError,
	      syncWarning: syncWarning,
	      initial: initial,
	      value: value,
	      _value: ownProps.value // save value passed in (for radios)
	
	    };
	  }, undefined, undefined, {
	    forwardRef: true
	  });
	  return connector(ConnectedField);
	}
	
	var _default = createConnectedField;
	exports["default"] = _default;

/***/ },
/* 1931 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(48);
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports["default"] = createConnectedFieldArray;
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(43));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(140));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(53));
	
	var _mapValues2 = _interopRequireDefault(__webpack_require__(303));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _reactRedux = __webpack_require__(18);
	
	var _redux = __webpack_require__(163);
	
	var _createFieldArrayProps = _interopRequireDefault(__webpack_require__(1942));
	
	var _plain = _interopRequireDefault(__webpack_require__(27));
	
	var _validateComponentProp = _interopRequireDefault(__webpack_require__(112));
	
	var propsToNotUpdateFor = ['_reduxForm', 'value'];
	
	function createConnectedFieldArray(structure) {
	  var deepEqual = structure.deepEqual,
	      getIn = structure.getIn,
	      size = structure.size,
	      equals = structure.equals,
	      orderChanged = structure.orderChanged;
	
	  var getSyncError = function getSyncError(syncErrors, name) {
	    // For an array, the error can _ONLY_ be under _error.
	    // This is why this getSyncError is not the same as the
	    // one in Field.
	    return _plain["default"].getIn(syncErrors, name + "._error");
	  };
	
	  var getSyncWarning = function getSyncWarning(syncWarnings, name) {
	    // For an array, the warning can _ONLY_ be under _warning.
	    // This is why this getSyncError is not the same as the
	    // one in Field.
	    return getIn(syncWarnings, name + "._warning");
	  };
	
	  var ConnectedFieldArray = /*#__PURE__*/function (_Component) {
	    (0, _inheritsLoose2["default"])(ConnectedFieldArray, _Component);
	
	    function ConnectedFieldArray() {
	      var _this;
	
	      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      _this = _Component.call.apply(_Component, [this].concat(args)) || this;
	      _this.ref = _react["default"].createRef();
	
	      _this.getValue = function (index) {
	        return _this.props.value && getIn(_this.props.value, String(index));
	      };
	
	      return _this;
	    }
	
	    var _proto = ConnectedFieldArray.prototype;
	
	    _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	      var _this2 = this;
	
	      // Update if the elements of the value array was updated.
	      var thisValue = this.props.value;
	      var nextValue = nextProps.value;
	
	      if (thisValue && nextValue) {
	        var nextValueItemsSame = equals(nextValue, thisValue); //.every(val => ~thisValue.indexOf(val))
	
	        var nextValueItemsOrderChanged = orderChanged(thisValue, nextValue);
	        var thisValueLength = thisValue.length || thisValue.size;
	        var nextValueLength = nextValue.length || nextValue.size;
	
	        if (thisValueLength !== nextValueLength || nextValueItemsSame && nextValueItemsOrderChanged || nextProps.rerenderOnEveryChange && thisValue.some(function (val, index) {
	          return !deepEqual(val, nextValue[index]);
	        })) {
	          return true;
	        }
	      }
	
	      var nextPropsKeys = Object.keys(nextProps);
	      var thisPropsKeys = Object.keys(this.props); // if we have children, we MUST update in React 16
	      // https://twitter.com/erikras/status/915866544558788608
	
	      return !!(this.props.children || nextProps.children || nextPropsKeys.length !== thisPropsKeys.length || nextPropsKeys.some(function (prop) {
	        // useful to debug rerenders
	        // if (!plain.deepEqual(this.props[ prop ], nextProps[ prop ])) {
	        //   console.info(prop, 'changed', this.props[ prop ], '==>', nextProps[ prop ])
	        // }
	        return !~propsToNotUpdateFor.indexOf(prop) && !deepEqual(_this2.props[prop], nextProps[prop]);
	      }));
	    };
	
	    _proto.getRenderedComponent = function getRenderedComponent() {
	      return this.ref.current;
	    };
	
	    _proto.render = function render() {
	      var _this$props = this.props,
	          component = _this$props.component,
	          forwardRef = _this$props.forwardRef,
	          name = _this$props.name,
	          _reduxForm = _this$props._reduxForm,
	          validate = _this$props.validate,
	          warn = _this$props.warn,
	          rerenderOnEveryChange = _this$props.rerenderOnEveryChange,
	          rest = (0, _objectWithoutPropertiesLoose2["default"])(_this$props, ["component", "forwardRef", "name", "_reduxForm", "validate", "warn", "rerenderOnEveryChange"]);
	      var props = (0, _createFieldArrayProps["default"])(structure, name, _reduxForm.form, _reduxForm.sectionPrefix, this.getValue, rest);
	
	      if (forwardRef) {
	        props.ref = this.ref;
	      }
	
	      return (0, _react.createElement)(component, props);
	    };
	
	    (0, _createClass2["default"])(ConnectedFieldArray, [{
	      key: "dirty",
	      get: function get() {
	        return this.props.dirty;
	      }
	    }, {
	      key: "pristine",
	      get: function get() {
	        return this.props.pristine;
	      }
	    }, {
	      key: "value",
	      get: function get() {
	        return this.props.value;
	      }
	    }]);
	    return ConnectedFieldArray;
	  }(_react.Component);
	
	  ConnectedFieldArray.propTypes = {
	    component: _validateComponentProp["default"],
	    props: _propTypes["default"].object,
	    rerenderOnEveryChange: _propTypes["default"].bool
	  };
	  ConnectedFieldArray.defaultProps = {
	    rerenderOnEveryChange: false
	  };
	  var connector = (0, _reactRedux.connect)(function (state, ownProps) {
	    var name = ownProps.name,
	        _ownProps$_reduxForm = ownProps._reduxForm,
	        initialValues = _ownProps$_reduxForm.initialValues,
	        getFormState = _ownProps$_reduxForm.getFormState;
	    var formState = getFormState(state);
	    var initial = getIn(formState, "initial." + name) || initialValues && getIn(initialValues, name);
	    var value = getIn(formState, "values." + name);
	    var submitting = getIn(formState, 'submitting');
	    var syncError = getSyncError(getIn(formState, 'syncErrors'), name);
	    var syncWarning = getSyncWarning(getIn(formState, 'syncWarnings'), name);
	    var pristine = deepEqual(value, initial);
	    return {
	      asyncError: getIn(formState, "asyncErrors." + name + "._error"),
	      dirty: !pristine,
	      pristine: pristine,
	      state: getIn(formState, "fields." + name),
	      submitError: getIn(formState, "submitErrors." + name + "._error"),
	      submitFailed: getIn(formState, 'submitFailed'),
	      submitting: submitting,
	      syncError: syncError,
	      syncWarning: syncWarning,
	      value: value,
	      length: size(value)
	    };
	  }, function (dispatch, ownProps) {
	    var name = ownProps.name,
	        _reduxForm = ownProps._reduxForm;
	    var arrayInsert = _reduxForm.arrayInsert,
	        arrayMove = _reduxForm.arrayMove,
	        arrayPop = _reduxForm.arrayPop,
	        arrayPush = _reduxForm.arrayPush,
	        arrayRemove = _reduxForm.arrayRemove,
	        arrayRemoveAll = _reduxForm.arrayRemoveAll,
	        arrayShift = _reduxForm.arrayShift,
	        arraySplice = _reduxForm.arraySplice,
	        arraySwap = _reduxForm.arraySwap,
	        arrayUnshift = _reduxForm.arrayUnshift;
	    return (0, _mapValues2["default"])({
	      arrayInsert: arrayInsert,
	      arrayMove: arrayMove,
	      arrayPop: arrayPop,
	      arrayPush: arrayPush,
	      arrayRemove: arrayRemove,
	      arrayRemoveAll: arrayRemoveAll,
	      arrayShift: arrayShift,
	      arraySplice: arraySplice,
	      arraySwap: arraySwap,
	      arrayUnshift: arrayUnshift
	    }, function (actionCreator) {
	      return (0, _redux.bindActionCreators)(actionCreator.bind(null, name), dispatch);
	    });
	  }, undefined, {
	    forwardRef: true
	  });
	  return connector(ConnectedFieldArray);
	}

/***/ },
/* 1932 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports["default"] = createConnectedFields;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(35));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(43));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(53));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _reactRedux = __webpack_require__(18);
	
	var _createFieldProps2 = _interopRequireDefault(__webpack_require__(548));
	
	var _plain = _interopRequireDefault(__webpack_require__(27));
	
	var _onChangeValue = _interopRequireDefault(__webpack_require__(553));
	
	var _validateComponentProp = _interopRequireDefault(__webpack_require__(112));
	
	var propsToNotUpdateFor = ['_reduxForm'];
	
	function createConnectedFields(structure) {
	  var deepEqual = structure.deepEqual,
	      getIn = structure.getIn,
	      size = structure.size;
	
	  var getSyncError = function getSyncError(syncErrors, name) {
	    // Because the error for this field might not be at a level in the error structure where
	    // it can be set directly, it might need to be unwrapped from the _error property
	    return _plain["default"].getIn(syncErrors, name + "._error") || _plain["default"].getIn(syncErrors, name);
	  };
	
	  var getSyncWarning = function getSyncWarning(syncWarnings, name) {
	    var warning = getIn(syncWarnings, name); // Because the warning for this field might not be at a level in the warning structure where
	    // it can be set directly, it might need to be unwrapped from the _warning property
	
	    return warning && warning._warning ? warning._warning : warning;
	  };
	
	  var ConnectedFields = /*#__PURE__*/function (_React$Component) {
	    (0, _inheritsLoose2["default"])(ConnectedFields, _React$Component);
	
	    function ConnectedFields(props) {
	      var _this;
	
	      _this = _React$Component.call(this, props) || this;
	      _this.onChangeFns = {};
	      _this.onFocusFns = {};
	      _this.onBlurFns = {};
	      _this.ref = _react["default"].createRef();
	
	      _this.prepareEventHandlers = function (_ref) {
	        var names = _ref.names;
	        return names.forEach(function (name) {
	          _this.onChangeFns[name] = function (event) {
	            return _this.handleChange(name, event);
	          };
	
	          _this.onFocusFns[name] = function () {
	            return _this.handleFocus(name);
	          };
	
	          _this.onBlurFns[name] = function (event) {
	            return _this.handleBlur(name, event);
	          };
	        });
	      };
	
	      _this.handleChange = function (name, event) {
	        var _this$props = _this.props,
	            dispatch = _this$props.dispatch,
	            parse = _this$props.parse,
	            _reduxForm = _this$props._reduxForm;
	        var value = (0, _onChangeValue["default"])(event, {
	          name: name,
	          parse: parse
	        });
	        dispatch(_reduxForm.change(name, value)); // call post-change callback
	
	        if (_reduxForm.asyncValidate) {
	          _reduxForm.asyncValidate(name, value, 'change');
	        }
	      };
	
	      _this.handleFocus = function (name) {
	        var _this$props2 = _this.props,
	            dispatch = _this$props2.dispatch,
	            _reduxForm = _this$props2._reduxForm;
	        dispatch(_reduxForm.focus(name));
	      };
	
	      _this.handleBlur = function (name, event) {
	        var _this$props3 = _this.props,
	            dispatch = _this$props3.dispatch,
	            parse = _this$props3.parse,
	            _reduxForm = _this$props3._reduxForm;
	        var value = (0, _onChangeValue["default"])(event, {
	          name: name,
	          parse: parse
	        }); // dispatch blur action
	
	        dispatch(_reduxForm.blur(name, value)); // call post-blur callback
	
	        if (_reduxForm.asyncValidate) {
	          _reduxForm.asyncValidate(name, value, 'blur');
	        }
	      };
	
	      _this.prepareEventHandlers(props);
	
	      return _this;
	    }
	
	    var _proto = ConnectedFields.prototype;
	
	    _proto.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      if (this.props.names !== nextProps.names && (size(this.props.names) !== size(nextProps.names) || nextProps.names.some(function (nextName) {
	        return !_this2.props._fields[nextName];
	      }))) {
	        // names has changed. The cached event handlers need to be updated
	        this.prepareEventHandlers(nextProps);
	      }
	    };
	
	    _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	      var _this3 = this;
	
	      var nextPropsKeys = Object.keys(nextProps);
	      var thisPropsKeys = Object.keys(this.props); // if we have children, we MUST update in React 16
	      // https://twitter.com/erikras/status/915866544558788608
	
	      return !!(this.props.children || nextProps.children || nextPropsKeys.length !== thisPropsKeys.length || nextPropsKeys.some(function (prop) {
	        return !~propsToNotUpdateFor.indexOf(prop) && !deepEqual(_this3.props[prop], nextProps[prop]);
	      }));
	    };
	
	    _proto.isDirty = function isDirty() {
	      var _fields = this.props._fields;
	      return Object.keys(_fields).some(function (name) {
	        return _fields[name].dirty;
	      });
	    };
	
	    _proto.getValues = function getValues() {
	      var _fields = this.props._fields;
	      return Object.keys(_fields).reduce(function (accumulator, name) {
	        return _plain["default"].setIn(accumulator, name, _fields[name].value);
	      }, {});
	    };
	
	    _proto.getRenderedComponent = function getRenderedComponent() {
	      return this.ref.current;
	    };
	
	    _proto.render = function render() {
	      var _this4 = this;
	
	      var _this$props4 = this.props,
	          component = _this$props4.component,
	          forwardRef = _this$props4.forwardRef,
	          _fields = _this$props4._fields,
	          _reduxForm = _this$props4._reduxForm,
	          rest = (0, _objectWithoutPropertiesLoose2["default"])(_this$props4, ["component", "forwardRef", "_fields", "_reduxForm"]);
	      var sectionPrefix = _reduxForm.sectionPrefix,
	          form = _reduxForm.form;
	
	      var _Object$keys$reduce = Object.keys(_fields).reduce(function (accumulator, name) {
	        var connectedProps = _fields[name];
	
	        var _createFieldProps = (0, _createFieldProps2["default"])(structure, name, (0, _extends2["default"])({}, connectedProps, {}, rest, {
	          form: form,
	          onBlur: _this4.onBlurFns[name],
	          onChange: _this4.onChangeFns[name],
	          onFocus: _this4.onFocusFns[name]
	        })),
	            custom = _createFieldProps.custom,
	            fieldProps = (0, _objectWithoutPropertiesLoose2["default"])(_createFieldProps, ["custom"]);
	
	        accumulator.custom = custom;
	        var fieldName = sectionPrefix ? name.replace(sectionPrefix + ".", '') : name;
	        return _plain["default"].setIn(accumulator, fieldName, fieldProps);
	      }, {}),
	          custom = _Object$keys$reduce.custom,
	          props = (0, _objectWithoutPropertiesLoose2["default"])(_Object$keys$reduce, ["custom"]);
	
	      if (forwardRef) {
	        props.ref = this.ref;
	      }
	
	      return _react["default"].createElement(component, (0, _extends2["default"])({}, props, {}, custom));
	    };
	
	    return ConnectedFields;
	  }(_react["default"].Component);
	
	  ConnectedFields.propTypes = {
	    component: _validateComponentProp["default"],
	    _fields: _propTypes["default"].object.isRequired,
	    props: _propTypes["default"].object
	  };
	  var connector = (0, _reactRedux.connect)(function (state, ownProps) {
	    var names = ownProps.names,
	        _ownProps$_reduxForm = ownProps._reduxForm,
	        initialValues = _ownProps$_reduxForm.initialValues,
	        getFormState = _ownProps$_reduxForm.getFormState;
	    var formState = getFormState(state);
	    return {
	      _fields: names.reduce(function (accumulator, name) {
	        var initialState = getIn(formState, "initial." + name);
	        var initial = initialState !== undefined ? initialState : initialValues && getIn(initialValues, name);
	        var value = getIn(formState, "values." + name);
	        var syncError = getSyncError(getIn(formState, 'syncErrors'), name);
	        var syncWarning = getSyncWarning(getIn(formState, 'syncWarnings'), name);
	        var submitting = getIn(formState, 'submitting');
	        var pristine = value === initial;
	        accumulator[name] = {
	          asyncError: getIn(formState, "asyncErrors." + name),
	          asyncValidating: getIn(formState, 'asyncValidating') === name,
	          dirty: !pristine,
	          initial: initial,
	          pristine: pristine,
	          state: getIn(formState, "fields." + name),
	          submitError: getIn(formState, "submitErrors." + name),
	          submitFailed: getIn(formState, 'submitFailed'),
	          submitting: submitting,
	          syncError: syncError,
	          syncWarning: syncWarning,
	          value: value,
	          _value: ownProps.value // save value passed in (for radios)
	
	        };
	        return accumulator;
	      }, {})
	    };
	  }, undefined, undefined, {
	    forwardRef: true
	  });
	  return connector(ConnectedFields);
	}

/***/ },
/* 1933 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _createField = _interopRequireDefault(__webpack_require__(1940));
	
	var _plain = _interopRequireDefault(__webpack_require__(27));
	
	var _default = (0, _createField["default"])(_plain["default"]);
	
	exports["default"] = _default;

/***/ },
/* 1934 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _createFieldArray = _interopRequireDefault(__webpack_require__(1941));
	
	var _plain = _interopRequireDefault(__webpack_require__(27));
	
	var _default = (0, _createFieldArray["default"])(_plain["default"]);
	
	exports["default"] = _default;

/***/ },
/* 1935 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _createFields = _interopRequireDefault(__webpack_require__(1943));
	
	var _plain = _interopRequireDefault(__webpack_require__(27));
	
	var _default = (0, _createFields["default"])(_plain["default"]);
	
	exports["default"] = _default;

/***/ },
/* 1936 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(48);
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(43));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(53));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _ReduxFormContext = __webpack_require__(85);
	
	var Form = /*#__PURE__*/function (_Component) {
	  (0, _inheritsLoose2["default"])(Form, _Component);
	
	  function Form(props) {
	    var _this;
	
	    _this = _Component.call(this, props) || this;
	
	    if (!props._reduxForm) {
	      throw new Error('Form must be inside a component decorated with reduxForm()');
	    }
	
	    return _this;
	  }
	
	  var _proto = Form.prototype;
	
	  _proto.componentDidMount = function componentDidMount() {
	    this.props._reduxForm.registerInnerOnSubmit(this.props.onSubmit);
	  };
	
	  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
	    if (this.props.onSubmit !== prevProps.onSubmit) {
	      this.props._reduxForm.registerInnerOnSubmit(this.props.onSubmit);
	    }
	  };
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        _reduxForm = _this$props._reduxForm,
	        rest = (0, _objectWithoutPropertiesLoose2["default"])(_this$props, ["_reduxForm"]);
	    return /*#__PURE__*/_react["default"].createElement("form", rest);
	  };
	
	  return Form;
	}(_react.Component);
	
	Form.propTypes = {
	  onSubmit: _propTypes["default"].func.isRequired,
	  _reduxForm: _propTypes["default"].object
	};
	
	var _default = (0, _ReduxFormContext.withReduxForm)(Form);
	
	exports["default"] = _default;

/***/ },
/* 1937 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(48);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _ReduxFormContext = __webpack_require__(85);
	
	var FormName = function FormName(_ref) {
	  var children = _ref.children,
	      _reduxForm = _ref._reduxForm;
	  return children({
	    form: _reduxForm && _reduxForm.form,
	    sectionPrefix: _reduxForm && _reduxForm.sectionPrefix
	  });
	};
	
	var _default = (0, _ReduxFormContext.withReduxForm)(FormName);
	
	exports["default"] = _default;

/***/ },
/* 1938 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(48);
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(35));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(43));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(53));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _prefixName = _interopRequireDefault(__webpack_require__(162));
	
	var _ReduxFormContext = __webpack_require__(85);
	
	var _validateComponentProp = _interopRequireDefault(__webpack_require__(112));
	
	var FormSection = /*#__PURE__*/function (_Component) {
	  (0, _inheritsLoose2["default"])(FormSection, _Component);
	
	  function FormSection(props) {
	    var _this;
	
	    _this = _Component.call(this, props) || this;
	
	    if (!props._reduxForm) {
	      throw new Error('FormSection must be inside a component decorated with reduxForm()');
	    }
	
	    return _this;
	  }
	
	  var _proto = FormSection.prototype;
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        _reduxForm = _this$props._reduxForm,
	        children = _this$props.children,
	        name = _this$props.name,
	        component = _this$props.component,
	        rest = (0, _objectWithoutPropertiesLoose2["default"])(_this$props, ["_reduxForm", "children", "name", "component"]);
	
	    if (_react["default"].isValidElement(children)) {
	      return (0, _react.createElement)(_ReduxFormContext.ReduxFormContext.Provider, {
	        value: (0, _extends2["default"])({}, this.props._reduxForm, {
	          sectionPrefix: (0, _prefixName["default"])(this.props, name)
	        }),
	        children: children
	      });
	    }
	
	    return (0, _react.createElement)(_ReduxFormContext.ReduxFormContext.Provider, {
	      value: (0, _extends2["default"])({}, this.props._reduxForm, {
	        sectionPrefix: (0, _prefixName["default"])(this.props, name)
	      }),
	      children: (0, _react.createElement)(component, (0, _extends2["default"])({}, rest, {
	        children: children
	      }))
	    });
	  };
	
	  return FormSection;
	}(_react.Component);
	
	FormSection.propTypes = {
	  name: _propTypes["default"].string.isRequired,
	  component: _validateComponentProp["default"]
	};
	FormSection.defaultProps = {
	  component: 'div'
	};
	
	var _default = (0, _ReduxFormContext.withReduxForm)(FormSection);
	
	exports["default"] = _default;

/***/ },
/* 1939 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _isPromise = _interopRequireDefault(__webpack_require__(293));
	
	var asyncValidation = function asyncValidation(fn, start, stop, field) {
	  start(field);
	  var promise = fn();
	
	  if (!(0, _isPromise["default"])(promise)) {
	    throw new Error('asyncValidate function passed to reduxForm must return a promise');
	  }
	
	  var handleErrors = function handleErrors(rejected) {
	    return function (errors) {
	      if (rejected) {
	        if (errors && Object.keys(errors).length) {
	          stop(errors);
	          return errors;
	        } else {
	          stop();
	          throw new Error('Asynchronous validation promise was rejected without errors.');
	        }
	      }
	
	      stop();
	      return Promise.resolve();
	    };
	  };
	
	  return promise.then(handleErrors(false), handleErrors(true));
	};
	
	var _default = asyncValidation;
	exports["default"] = _default;

/***/ },
/* 1940 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(48);
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(35));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(140));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(53));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _invariant = _interopRequireDefault(__webpack_require__(37));
	
	var _ConnectedField = _interopRequireDefault(__webpack_require__(1930));
	
	var _shallowCompare = _interopRequireDefault(__webpack_require__(557));
	
	var _prefixName = _interopRequireDefault(__webpack_require__(162));
	
	var _plain = _interopRequireDefault(__webpack_require__(27));
	
	var _ReduxFormContext = __webpack_require__(85);
	
	var _validateComponentProp = _interopRequireDefault(__webpack_require__(112));
	
	function createField(structure) {
	  var ConnectedField = (0, _ConnectedField["default"])(structure);
	  var setIn = structure.setIn;
	
	  var Field = /*#__PURE__*/function (_Component) {
	    (0, _inheritsLoose2["default"])(Field, _Component);
	
	    function Field(props) {
	      var _this;
	
	      _this = _Component.call(this, props) || this;
	      _this.ref = _react["default"].createRef();
	
	      _this.normalize = function (name, value) {
	        var normalize = _this.props.normalize;
	
	        if (!normalize) {
	          return value;
	        }
	
	        var previousValues = _this.props._reduxForm.getValues();
	
	        var previousValue = _this.value;
	        var nextValues = setIn(previousValues, name, value);
	        return normalize(value, previousValue, nextValues, previousValues, name);
	      };
	
	      if (!props._reduxForm) {
	        throw new Error('Field must be inside a component decorated with reduxForm()');
	      }
	
	      return _this;
	    }
	
	    var _proto = Field.prototype;
	
	    _proto.componentDidMount = function componentDidMount() {
	      var _this2 = this;
	
	      this.props._reduxForm.register(this.name, 'Field', function () {
	        return _this2.props.validate;
	      }, function () {
	        return _this2.props.warn;
	      });
	    };
	
	    _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
	      return (0, _shallowCompare["default"])(this, nextProps, nextState);
	    };
	
	    _proto.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps(nextProps) {
	      var oldName = (0, _prefixName["default"])(this.props, this.props.name);
	      var newName = (0, _prefixName["default"])(nextProps, nextProps.name);
	
	      if (oldName !== newName || // use deepEqual here because they could be a function or an array of functions
	      !_plain["default"].deepEqual(this.props.validate, nextProps.validate) || !_plain["default"].deepEqual(this.props.warn, nextProps.warn)) {
	        // unregister old name
	        this.props._reduxForm.unregister(oldName); // register new name
	
	
	        this.props._reduxForm.register(newName, 'Field', function () {
	          return nextProps.validate;
	        }, function () {
	          return nextProps.warn;
	        });
	      }
	    };
	
	    _proto.componentWillUnmount = function componentWillUnmount() {
	      this.props._reduxForm.unregister(this.name);
	    };
	
	    _proto.getRenderedComponent = function getRenderedComponent() {
	      (0, _invariant["default"])(this.props.forwardRef, 'If you want to access getRenderedComponent(), ' + 'you must specify a forwardRef prop to Field');
	      return this.ref.current ? this.ref.current.getRenderedComponent() : undefined;
	    };
	
	    _proto.render = function render() {
	      return (0, _react.createElement)(ConnectedField, (0, _extends2["default"])({}, this.props, {
	        name: this.name,
	        normalize: this.normalize,
	        ref: this.ref
	      }));
	    };
	
	    (0, _createClass2["default"])(Field, [{
	      key: "name",
	      get: function get() {
	        return (0, _prefixName["default"])(this.props, this.props.name);
	      }
	    }, {
	      key: "dirty",
	      get: function get() {
	        return !this.pristine;
	      }
	    }, {
	      key: "pristine",
	      get: function get() {
	        return !!(this.ref.current && this.ref.current.isPristine());
	      }
	    }, {
	      key: "value",
	      get: function get() {
	        return this.ref.current && this.ref.current.getValue();
	      }
	    }]);
	    return Field;
	  }(_react.Component);
	
	  Field.propTypes = {
	    name: _propTypes["default"].string.isRequired,
	    component: _validateComponentProp["default"],
	    format: _propTypes["default"].func,
	    normalize: _propTypes["default"].func,
	    onBlur: _propTypes["default"].func,
	    onChange: _propTypes["default"].func,
	    onFocus: _propTypes["default"].func,
	    onDragStart: _propTypes["default"].func,
	    onDrop: _propTypes["default"].func,
	    parse: _propTypes["default"].func,
	    props: _propTypes["default"].object,
	    validate: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].arrayOf(_propTypes["default"].func)]),
	    warn: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].arrayOf(_propTypes["default"].func)]),
	    forwardRef: _propTypes["default"].bool,
	    immutableProps: _propTypes["default"].arrayOf(_propTypes["default"].string),
	    _reduxForm: _propTypes["default"].object
	  };
	  return (0, _ReduxFormContext.withReduxForm)(Field);
	}
	
	var _default = createField;
	exports["default"] = _default;

/***/ },
/* 1941 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(48);
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports["default"] = createFieldArray;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(35));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(140));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(53));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _invariant = _interopRequireDefault(__webpack_require__(37));
	
	var _ConnectedFieldArray = _interopRequireDefault(__webpack_require__(1931));
	
	var _prefixName = _interopRequireDefault(__webpack_require__(162));
	
	var _ReduxFormContext = __webpack_require__(85);
	
	var _validateComponentProp = _interopRequireDefault(__webpack_require__(112));
	
	var toArray = function toArray(value) {
	  return Array.isArray(value) ? value : [value];
	};
	
	var wrapError = function wrapError(fn, key) {
	  return fn && function () {
	    var validators = toArray(fn);
	
	    for (var i = 0; i < validators.length; i++) {
	      var result = validators[i].apply(validators, arguments);
	
	      if (result) {
	        var _ref;
	
	        return _ref = {}, _ref[key] = result, _ref;
	      }
	    }
	  };
	};
	
	function createFieldArray(structure) {
	  var ConnectedFieldArray = (0, _ConnectedFieldArray["default"])(structure);
	
	  var FieldArray = /*#__PURE__*/function (_Component) {
	    (0, _inheritsLoose2["default"])(FieldArray, _Component);
	
	    function FieldArray(props) {
	      var _this;
	
	      _this = _Component.call(this, props) || this;
	      _this.ref = _react["default"].createRef();
	
	      if (!props._reduxForm) {
	        throw new Error('FieldArray must be inside a component decorated with reduxForm()');
	      }
	
	      return _this;
	    }
	
	    var _proto = FieldArray.prototype;
	
	    _proto.componentDidMount = function componentDidMount() {
	      var _this2 = this;
	
	      this.props._reduxForm.register(this.name, 'FieldArray', function () {
	        return wrapError(_this2.props.validate, '_error');
	      }, function () {
	        return wrapError(_this2.props.warn, '_warning');
	      });
	    };
	
	    _proto.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps(nextProps) {
	      var oldName = (0, _prefixName["default"])(this.props, this.props.name);
	      var newName = (0, _prefixName["default"])(nextProps, nextProps.name);
	
	      if (oldName !== newName) {
	        // unregister old name
	        this.props._reduxForm.unregister(oldName); // register new name
	
	
	        this.props._reduxForm.register(newName, 'FieldArray');
	      }
	    };
	
	    _proto.componentWillUnmount = function componentWillUnmount() {
	      this.props._reduxForm.unregister(this.name);
	    };
	
	    _proto.getRenderedComponent = function getRenderedComponent() {
	      (0, _invariant["default"])(this.props.forwardRef, 'If you want to access getRenderedComponent(), ' + 'you must specify a forwardRef prop to FieldArray');
	      return this.ref && this.ref.current.getRenderedComponent();
	    };
	
	    _proto.render = function render() {
	      return (0, _react.createElement)(ConnectedFieldArray, (0, _extends2["default"])({}, this.props, {
	        name: this.name,
	        ref: this.ref
	      }));
	    };
	
	    (0, _createClass2["default"])(FieldArray, [{
	      key: "name",
	      get: function get() {
	        return (0, _prefixName["default"])(this.props, this.props.name);
	      }
	    }, {
	      key: "dirty",
	      get: function get() {
	        return !this.ref || this.ref.current.dirty;
	      }
	    }, {
	      key: "pristine",
	      get: function get() {
	        return !!(this.ref && this.ref.current.pristine);
	      }
	    }, {
	      key: "value",
	      get: function get() {
	        return this.ref ? this.ref.current.value : undefined;
	      }
	    }]);
	    return FieldArray;
	  }(_react.Component);
	
	  FieldArray.propTypes = {
	    name: _propTypes["default"].string.isRequired,
	    component: _validateComponentProp["default"],
	    props: _propTypes["default"].object,
	    validate: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].arrayOf(_propTypes["default"].func)]),
	    warn: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].arrayOf(_propTypes["default"].func)]),
	    forwardRef: _propTypes["default"].bool,
	    _reduxForm: _propTypes["default"].object
	  };
	  return (0, _ReduxFormContext.withReduxForm)(FieldArray);
	}

/***/ },
/* 1942 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports["default"] = createFieldArrayProps;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(35));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(43));
	
	function createFieldArrayProps(_ref, name, form, sectionPrefix, getValue, _ref2) {
	  var getIn = _ref.getIn;
	  var arrayInsert = _ref2.arrayInsert,
	      arrayMove = _ref2.arrayMove,
	      arrayPop = _ref2.arrayPop,
	      arrayPush = _ref2.arrayPush,
	      arrayRemove = _ref2.arrayRemove,
	      arrayRemoveAll = _ref2.arrayRemoveAll,
	      arrayShift = _ref2.arrayShift,
	      arraySplice = _ref2.arraySplice,
	      arraySwap = _ref2.arraySwap,
	      arrayUnshift = _ref2.arrayUnshift,
	      asyncError = _ref2.asyncError,
	      dirty = _ref2.dirty,
	      length = _ref2.length,
	      pristine = _ref2.pristine,
	      submitError = _ref2.submitError,
	      state = _ref2.state,
	      submitFailed = _ref2.submitFailed,
	      submitting = _ref2.submitting,
	      syncError = _ref2.syncError,
	      syncWarning = _ref2.syncWarning,
	      value = _ref2.value,
	      props = _ref2.props,
	      rest = (0, _objectWithoutPropertiesLoose2["default"])(_ref2, ["arrayInsert", "arrayMove", "arrayPop", "arrayPush", "arrayRemove", "arrayRemoveAll", "arrayShift", "arraySplice", "arraySwap", "arrayUnshift", "asyncError", "dirty", "length", "pristine", "submitError", "state", "submitFailed", "submitting", "syncError", "syncWarning", "value", "props"]);
	  var error = syncError || asyncError || submitError;
	  var warning = syncWarning;
	  var fieldName = sectionPrefix ? name.replace(sectionPrefix + ".", '') : name;
	  var finalProps = (0, _extends2["default"])({
	    fields: {
	      _isFieldArray: true,
	      forEach: function forEach(callback) {
	        return (value || []).forEach(function (item, index) {
	          return callback(fieldName + "[" + index + "]", index, finalProps.fields);
	        });
	      },
	      get: getValue,
	      getAll: function getAll() {
	        return value;
	      },
	      insert: arrayInsert,
	      length: length,
	      map: function map(callback) {
	        return (value || []).map(function (item, index) {
	          return callback(fieldName + "[" + index + "]", index, finalProps.fields);
	        });
	      },
	      move: arrayMove,
	      name: name,
	      pop: function pop() {
	        arrayPop();
	        return getIn(value, String(length - 1));
	      },
	      push: arrayPush,
	      reduce: function reduce(callback, initial) {
	        return (value || []).reduce(function (accumulator, item, index) {
	          return callback(accumulator, fieldName + "[" + index + "]", index, finalProps.fields);
	        }, initial);
	      },
	      remove: arrayRemove,
	      removeAll: arrayRemoveAll,
	      shift: function shift() {
	        arrayShift();
	        return getIn(value, '0');
	      },
	      splice: arraySplice,
	      swap: arraySwap,
	      unshift: arrayUnshift
	    },
	    meta: {
	      dirty: dirty,
	      error: error,
	      form: form,
	      warning: warning,
	      invalid: !!error,
	      pristine: pristine,
	      submitting: submitting,
	      submitFailed: submitFailed,
	      valid: !error
	    }
	  }, props, {}, rest);
	  return finalProps;
	}

/***/ },
/* 1943 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports["default"] = createFields;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(35));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(140));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(53));
	
	var _react = __webpack_require__(1);
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _invariant = _interopRequireDefault(__webpack_require__(37));
	
	var _get = _interopRequireDefault(__webpack_require__(493));
	
	var _ConnectedFields = _interopRequireDefault(__webpack_require__(1932));
	
	var _shallowCompare = _interopRequireDefault(__webpack_require__(557));
	
	var _plain = _interopRequireDefault(__webpack_require__(27));
	
	var _prefixName = _interopRequireDefault(__webpack_require__(162));
	
	var _ReduxFormContext = __webpack_require__(85);
	
	var _validateComponentProp = _interopRequireDefault(__webpack_require__(112));
	
	var validateNameProp = function validateNameProp(prop) {
	  if (!prop) {
	    return new Error('No "names" prop was specified <Fields/>');
	  }
	
	  if (!Array.isArray(prop) && !prop._isFieldArray) {
	    return new Error('Invalid prop "names" supplied to <Fields/>. Must be either an array of strings or the fields array generated by FieldArray.');
	  }
	};
	
	var warnAndValidatePropType = _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].arrayOf(_propTypes["default"].func), _propTypes["default"].objectOf(_propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].arrayOf(_propTypes["default"].func)]))]);
	
	var fieldsPropTypes = {
	  component: _validateComponentProp["default"],
	  format: _propTypes["default"].func,
	  parse: _propTypes["default"].func,
	  props: _propTypes["default"].object,
	  forwardRef: _propTypes["default"].bool,
	  validate: warnAndValidatePropType,
	  warn: warnAndValidatePropType
	};
	
	var getFieldWarnAndValidate = function getFieldWarnAndValidate(prop, name) {
	  return Array.isArray(prop) || typeof prop === 'function' ? prop : (0, _get["default"])(prop, name, undefined);
	};
	
	function createFields(structure) {
	  var ConnectedFields = (0, _ConnectedFields["default"])(structure);
	
	  var Fields = /*#__PURE__*/function (_Component) {
	    (0, _inheritsLoose2["default"])(Fields, _Component);
	
	    function Fields(props) {
	      var _this;
	
	      _this = _Component.call(this, props) || this;
	      _this.connected = (0, _react.createRef)();
	
	      if (!props._reduxForm) {
	        throw new Error('Fields must be inside a component decorated with reduxForm()');
	      }
	
	      var error = validateNameProp(props.names);
	
	      if (error) {
	        throw error;
	      }
	
	      return _this;
	    }
	
	    var _proto = Fields.prototype;
	
	    _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	      return (0, _shallowCompare["default"])(this, nextProps);
	    };
	
	    _proto.componentDidMount = function componentDidMount() {
	      this.registerFields(this.props.names);
	    };
	
	    _proto.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps(nextProps) {
	      if (!_plain["default"].deepEqual(this.props.names, nextProps.names)) {
	        var props = this.props;
	        var unregister = props._reduxForm.unregister; // unregister old name
	
	        this.props.names.forEach(function (name) {
	          return unregister((0, _prefixName["default"])(props, name));
	        }); // register new name
	
	        this.registerFields(nextProps.names);
	      }
	    };
	
	    _proto.componentWillUnmount = function componentWillUnmount() {
	      var props = this.props;
	      var unregister = props._reduxForm.unregister;
	      this.props.names.forEach(function (name) {
	        return unregister((0, _prefixName["default"])(props, name));
	      });
	    };
	
	    _proto.registerFields = function registerFields(names) {
	      var _this2 = this;
	
	      var props = this.props;
	      var register = props._reduxForm.register;
	      names.forEach(function (name) {
	        return register((0, _prefixName["default"])(props, name), 'Field', function () {
	          return getFieldWarnAndValidate(_this2.props.validate, name);
	        }, function () {
	          return getFieldWarnAndValidate(_this2.props.warn, name);
	        });
	      });
	    };
	
	    _proto.getRenderedComponent = function getRenderedComponent() {
	      (0, _invariant["default"])(this.props.forwardRef, 'If you want to access getRenderedComponent(), ' + 'you must specify a forwardRef prop to Fields');
	      return this.connected.current ? this.connected.current.getRenderedComponent() : null;
	    };
	
	    _proto.render = function render() {
	      var props = this.props;
	      return (0, _react.createElement)(ConnectedFields, (0, _extends2["default"])({}, this.props, {
	        names: this.props.names.map(function (name) {
	          return (0, _prefixName["default"])(props, name);
	        }),
	        ref: this.connected
	      }));
	    };
	
	    (0, _createClass2["default"])(Fields, [{
	      key: "names",
	      get: function get() {
	        var props = this.props;
	        return this.props.names.map(function (name) {
	          return (0, _prefixName["default"])(props, name);
	        });
	      }
	    }, {
	      key: "dirty",
	      get: function get() {
	        return this.connected.current ? this.connected.current.isDirty() : false;
	      }
	    }, {
	      key: "pristine",
	      get: function get() {
	        return !this.dirty;
	      }
	    }, {
	      key: "values",
	      get: function get() {
	        return this.connected.current ? this.connected.current.getValues() : {};
	      }
	    }]);
	    return Fields;
	  }(_react.Component);
	
	  Fields.propTypes = (0, _extends2["default"])({
	    names: function names(props, propName) {
	      return validateNameProp(props[propName]);
	    }
	  }, fieldsPropTypes);
	  return (0, _ReduxFormContext.withReduxForm)(Fields);
	}

/***/ },
/* 1944 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports["default"] = createFormValueSelector;
	
	var _invariant = _interopRequireDefault(__webpack_require__(37));
	
	var _plain = _interopRequireDefault(__webpack_require__(27));
	
	function createFormValueSelector(_ref) {
	  var getIn = _ref.getIn;
	  return function (form, getFormState) {
	    (0, _invariant["default"])(form, 'Form value must be specified');
	
	    var nonNullGetFormState = getFormState || function (state) {
	      return getIn(state, 'form');
	    };
	
	    return function (state) {
	      for (var _len = arguments.length, fields = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        fields[_key - 1] = arguments[_key];
	      }
	
	      (0, _invariant["default"])(fields.length, 'No fields specified');
	      return fields.length === 1 ? // only selecting one field, so return its value
	      getIn(nonNullGetFormState(state), form + ".values." + fields[0]) : // selecting many fields, so return an object of field values
	      fields.reduce(function (accumulator, field) {
	        var value = getIn(nonNullGetFormState(state), form + ".values." + field);
	        return value === undefined ? accumulator : _plain["default"].setIn(accumulator, field, value);
	      }, {});
	    };
	  };
	}

/***/ },
/* 1945 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports["default"] = createValues;
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(43));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(35));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(53));
	
	var _mapValues2 = _interopRequireDefault(__webpack_require__(303));
	
	var _isEqual2 = _interopRequireDefault(__webpack_require__(1743));
	
	var _isEmpty2 = _interopRequireDefault(__webpack_require__(1742));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _reactRedux = __webpack_require__(18);
	
	var _prefixName = _interopRequireDefault(__webpack_require__(162));
	
	var _ReduxFormContext = __webpack_require__(85);
	
	function createValues(_ref) {
	  var getIn = _ref.getIn;
	  return function (firstArg) {
	    for (var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      rest[_key - 1] = arguments[_key];
	    }
	
	    // create a class that reads current form name and creates a selector
	    // return
	    return function (Component) {
	      var FormValues = /*#__PURE__*/function (_React$Component) {
	        (0, _inheritsLoose2["default"])(FormValues, _React$Component);
	
	        function FormValues(props) {
	          var _this;
	
	          _this = _React$Component.call(this, props) || this;
	
	          if (!props._reduxForm) {
	            throw new Error('formValues() must be used inside a React tree decorated with reduxForm()');
	          }
	
	          _this.updateComponent(props);
	
	          return _this;
	        }
	
	        var _proto = FormValues.prototype;
	
	        _proto.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps(props) {
	          if (typeof firstArg === 'function') {
	            this.updateComponent(props);
	          }
	        };
	
	        _proto.render = function render() {
	          var Component = this.Component;
	          return /*#__PURE__*/_react["default"].createElement(Component // so that the connected component updates props when sectionPrefix has changed
	          , (0, _extends2["default"])({
	            sectionPrefix: this.props._reduxForm.sectionPrefix
	          }, this.props));
	        };
	
	        _proto.updateComponent = function updateComponent(props) {
	          var valuesMap;
	          var resolvedFirstArg = typeof firstArg === 'function' ? firstArg(props) : firstArg;
	
	          if (typeof resolvedFirstArg === 'string') {
	            var _rest$reduce;
	
	            valuesMap = rest.reduce(function (result, k) {
	              result[k] = k;
	              return result;
	            }, (_rest$reduce = {}, _rest$reduce[resolvedFirstArg] = resolvedFirstArg, _rest$reduce));
	          } else {
	            valuesMap = resolvedFirstArg;
	          }
	
	          if ((0, _isEmpty2["default"])(valuesMap)) {
	            // maybe that empty valuesMap is ok if firstArg is a function?
	            // if this is the case, we probably should set this.Component = Component
	            throw new Error('formValues(): You must specify values to get as formValues(name1, name2, ...) or formValues({propName1: propPath1, ...}) or formValues((props) => name) or formValues((props) => ({propName1: propPath1, ...}))');
	          }
	
	          if ((0, _isEqual2["default"])(valuesMap, this._valuesMap)) {
	            // no change in valuesMap
	            return;
	          }
	
	          this._valuesMap = valuesMap;
	          this.setComponent();
	        };
	
	        _proto.setComponent = function setComponent() {
	          var _this2 = this;
	
	          var formValuesSelector = function formValuesSelector(_, _ref2) {
	            var sectionPrefix = _ref2.sectionPrefix;
	            // Yes, we're only using connect() for listening to updates.
	            // The second argument needs to be there so that connect calls
	            // the selector when props change
	            var getValues = _this2.props._reduxForm.getValues;
	            var values = getValues();
	            return (0, _mapValues2["default"])(_this2._valuesMap, function (path) {
	              return getIn(values, (0, _prefixName["default"])(_this2.props, path));
	            });
	          };
	
	          this.Component = (0, _reactRedux.connect)(formValuesSelector, function () {
	            return {};
	          } // ignore dispatch
	          )(function (_ref3) {
	            var sectionPrefix = _ref3.sectionPrefix,
	                otherProps = (0, _objectWithoutPropertiesLoose2["default"])(_ref3, ["sectionPrefix"]);
	            return /*#__PURE__*/_react["default"].createElement(Component, otherProps);
	          });
	        };
	
	        return FormValues;
	      }(_react["default"].Component);
	
	      return (0, _ReduxFormContext.withReduxForm)(FormValues);
	    };
	  };
	}

/***/ },
/* 1946 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(43));
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(208));
	
	var _actionTypes = __webpack_require__(321);
	
	var _deleteInWithCleanUp = _interopRequireDefault(__webpack_require__(1949));
	
	var _plain = _interopRequireDefault(__webpack_require__(27));
	
	var shouldDelete = function shouldDelete(_ref) {
	  var getIn = _ref.getIn;
	  return function (state, path) {
	    var initialValuesPath = null;
	
	    if (/^values/.test(path)) {
	      initialValuesPath = path.replace('values', 'initial');
	    }
	
	    var initialValueComparison = initialValuesPath ? getIn(state, initialValuesPath) === undefined : true;
	    return getIn(state, path) !== undefined && initialValueComparison;
	  };
	};
	
	var isReduxFormAction = function isReduxFormAction(action) {
	  return action && action.type && action.type.length > _actionTypes.prefix.length && action.type.substring(0, _actionTypes.prefix.length) === _actionTypes.prefix;
	};
	
	function createReducer(structure) {
	  var _behaviors;
	
	  var deepEqual = structure.deepEqual,
	      empty = structure.empty,
	      forEach = structure.forEach,
	      getIn = structure.getIn,
	      setIn = structure.setIn,
	      deleteIn = structure.deleteIn,
	      fromJS = structure.fromJS,
	      keys = structure.keys,
	      size = structure.size,
	      some = structure.some,
	      splice = structure.splice;
	  var deleteInWithCleanUp = (0, _deleteInWithCleanUp["default"])(structure)(shouldDelete);
	  var plainDeleteInWithCleanUp = (0, _deleteInWithCleanUp["default"])(_plain["default"])(shouldDelete);
	
	  var doSplice = function doSplice(state, key, field, index, removeNum, value, force) {
	    var existing = getIn(state, key + "." + field);
	    return existing || force ? setIn(state, key + "." + field, splice(existing, index, removeNum, value)) : state;
	  };
	
	  var doPlainSplice = function doPlainSplice(state, key, field, index, removeNum, value, force) {
	    var slice = getIn(state, key);
	
	    var existing = _plain["default"].getIn(slice, field);
	
	    return existing || force ? setIn(state, key, _plain["default"].setIn(slice, field, _plain["default"].splice(existing, index, removeNum, value))) : state;
	  };
	
	  var rootKeys = ['values', 'fields', 'submitErrors', 'asyncErrors'];
	
	  var arraySplice = function arraySplice(state, field, index, removeNum, value) {
	    var result = state;
	    var nonValuesValue = value != null ? empty : undefined;
	    result = doSplice(result, 'values', field, index, removeNum, value, true);
	    result = doSplice(result, 'fields', field, index, removeNum, nonValuesValue);
	    result = doPlainSplice(result, 'syncErrors', field, index, removeNum, undefined);
	    result = doPlainSplice(result, 'syncWarnings', field, index, removeNum, undefined);
	    result = doSplice(result, 'submitErrors', field, index, removeNum, undefined);
	    result = doSplice(result, 'asyncErrors', field, index, removeNum, undefined);
	    return result;
	  };
	
	  var behaviors = (_behaviors = {}, _behaviors[_actionTypes.ARRAY_INSERT] = function (state, _ref2) {
	    var _ref2$meta = _ref2.meta,
	        field = _ref2$meta.field,
	        index = _ref2$meta.index,
	        payload = _ref2.payload;
	    return arraySplice(state, field, index, 0, payload);
	  }, _behaviors[_actionTypes.ARRAY_MOVE] = function (state, _ref3) {
	    var _ref3$meta = _ref3.meta,
	        field = _ref3$meta.field,
	        from = _ref3$meta.from,
	        to = _ref3$meta.to;
	    var array = getIn(state, "values." + field);
	    var length = array ? size(array) : 0;
	    var result = state;
	
	    if (length) {
	      rootKeys.forEach(function (key) {
	        var path = key + "." + field;
	
	        if (getIn(result, path)) {
	          var value = getIn(result, path + "[" + from + "]");
	          result = setIn(result, path, splice(getIn(result, path), from, 1)); // remove
	
	          result = setIn(result, path, splice(getIn(result, path), to, 0, value)); // insert
	        }
	      });
	    }
	
	    return result;
	  }, _behaviors[_actionTypes.ARRAY_POP] = function (state, _ref4) {
	    var field = _ref4.meta.field;
	    var array = getIn(state, "values." + field);
	    var length = array ? size(array) : 0;
	    return length ? arraySplice(state, field, length - 1, 1) : state;
	  }, _behaviors[_actionTypes.ARRAY_PUSH] = function (state, _ref5) {
	    var field = _ref5.meta.field,
	        payload = _ref5.payload;
	    var array = getIn(state, "values." + field);
	    var length = array ? size(array) : 0;
	    return arraySplice(state, field, length, 0, payload);
	  }, _behaviors[_actionTypes.ARRAY_REMOVE] = function (state, _ref6) {
	    var _ref6$meta = _ref6.meta,
	        field = _ref6$meta.field,
	        index = _ref6$meta.index;
	    return arraySplice(state, field, index, 1);
	  }, _behaviors[_actionTypes.ARRAY_REMOVE_ALL] = function (state, _ref7) {
	    var field = _ref7.meta.field;
	    var array = getIn(state, "values." + field);
	    var length = array ? size(array) : 0;
	    return length ? arraySplice(state, field, 0, length) : state;
	  }, _behaviors[_actionTypes.ARRAY_SHIFT] = function (state, _ref8) {
	    var field = _ref8.meta.field;
	    return arraySplice(state, field, 0, 1);
	  }, _behaviors[_actionTypes.ARRAY_SPLICE] = function (state, _ref9) {
	    var _ref9$meta = _ref9.meta,
	        field = _ref9$meta.field,
	        index = _ref9$meta.index,
	        removeNum = _ref9$meta.removeNum,
	        payload = _ref9.payload;
	    return arraySplice(state, field, index, removeNum, payload);
	  }, _behaviors[_actionTypes.ARRAY_SWAP] = function (state, _ref10) {
	    var _ref10$meta = _ref10.meta,
	        field = _ref10$meta.field,
	        indexA = _ref10$meta.indexA,
	        indexB = _ref10$meta.indexB;
	    var result = state;
	    rootKeys.forEach(function (key) {
	      var valueA = getIn(result, key + "." + field + "[" + indexA + "]");
	      var valueB = getIn(result, key + "." + field + "[" + indexB + "]");
	
	      if (valueA !== undefined || valueB !== undefined) {
	        result = setIn(result, key + "." + field + "[" + indexA + "]", valueB);
	        result = setIn(result, key + "." + field + "[" + indexB + "]", valueA);
	      }
	    });
	    return result;
	  }, _behaviors[_actionTypes.ARRAY_UNSHIFT] = function (state, _ref11) {
	    var field = _ref11.meta.field,
	        payload = _ref11.payload;
	    return arraySplice(state, field, 0, 0, payload);
	  }, _behaviors[_actionTypes.AUTOFILL] = function (state, _ref12) {
	    var field = _ref12.meta.field,
	        payload = _ref12.payload;
	    var result = state;
	    result = deleteInWithCleanUp(result, "asyncErrors." + field);
	    result = deleteInWithCleanUp(result, "submitErrors." + field);
	    result = setIn(result, "fields." + field + ".autofilled", true);
	    result = setIn(result, "values." + field, payload);
	    return result;
	  }, _behaviors[_actionTypes.BLUR] = function (state, _ref13) {
	    var _ref13$meta = _ref13.meta,
	        field = _ref13$meta.field,
	        touch = _ref13$meta.touch,
	        payload = _ref13.payload;
	    var result = state;
	    var initial = getIn(result, "initial." + field);
	
	    if (initial === undefined && payload === '') {
	      result = deleteInWithCleanUp(result, "values." + field);
	    } else if (payload !== undefined) {
	      result = setIn(result, "values." + field, payload);
	    }
	
	    if (field === getIn(result, 'active')) {
	      result = deleteIn(result, 'active');
	    }
	
	    result = deleteIn(result, "fields." + field + ".active");
	
	    if (touch) {
	      result = setIn(result, "fields." + field + ".touched", true);
	      result = setIn(result, 'anyTouched', true);
	    }
	
	    return result;
	  }, _behaviors[_actionTypes.CHANGE] = function (state, _ref14) {
	    var _ref14$meta = _ref14.meta,
	        field = _ref14$meta.field,
	        touch = _ref14$meta.touch,
	        persistentSubmitErrors = _ref14$meta.persistentSubmitErrors,
	        payload = _ref14.payload;
	    var result = state;
	    var initial = getIn(result, "initial." + field);
	
	    if (initial === undefined && payload === '' || payload === undefined) {
	      result = deleteInWithCleanUp(result, "values." + field);
	    } else if ((0, _isFunction2["default"])(payload)) {
	      var fieldCurrentValue = getIn(state, "values." + field);
	      result = setIn(result, "values." + field, payload(fieldCurrentValue, state.values));
	    } else {
	      result = setIn(result, "values." + field, payload);
	    }
	
	    result = deleteInWithCleanUp(result, "asyncErrors." + field);
	
	    if (!persistentSubmitErrors) {
	      result = deleteInWithCleanUp(result, "submitErrors." + field);
	    }
	
	    result = deleteInWithCleanUp(result, "fields." + field + ".autofilled");
	
	    if (touch) {
	      result = setIn(result, "fields." + field + ".touched", true);
	      result = setIn(result, 'anyTouched', true);
	    }
	
	    return result;
	  }, _behaviors[_actionTypes.CLEAR_SUBMIT] = function (state) {
	    return deleteIn(state, 'triggerSubmit');
	  }, _behaviors[_actionTypes.CLEAR_SUBMIT_ERRORS] = function (state) {
	    var result = state;
	    result = deleteInWithCleanUp(result, 'submitErrors');
	    result = deleteIn(result, 'error');
	    return result;
	  }, _behaviors[_actionTypes.CLEAR_ASYNC_ERROR] = function (state, _ref15) {
	    var field = _ref15.meta.field;
	    return deleteIn(state, "asyncErrors." + field);
	  }, _behaviors[_actionTypes.CLEAR_FIELDS] = function (state, _ref16) {
	    var _ref16$meta = _ref16.meta,
	        keepTouched = _ref16$meta.keepTouched,
	        persistentSubmitErrors = _ref16$meta.persistentSubmitErrors,
	        fields = _ref16$meta.fields;
	    var result = state;
	    fields.forEach(function (field) {
	      result = deleteInWithCleanUp(result, "asyncErrors." + field);
	
	      if (!persistentSubmitErrors) {
	        result = deleteInWithCleanUp(result, "submitErrors." + field);
	      }
	
	      result = deleteInWithCleanUp(result, "fields." + field + ".autofilled");
	
	      if (!keepTouched) {
	        result = deleteIn(result, "fields." + field + ".touched");
	      }
	
	      var values = getIn(state, "initial." + field);
	      result = values ? setIn(result, "values." + field, values) : deleteInWithCleanUp(result, "values." + field);
	    });
	    var anyTouched = some(keys(getIn(result, 'registeredFields')), function (key) {
	      return getIn(result, "fields." + key + ".touched");
	    });
	    result = anyTouched ? setIn(result, 'anyTouched', true) : deleteIn(result, 'anyTouched');
	    return result;
	  }, _behaviors[_actionTypes.FOCUS] = function (state, _ref17) {
	    var field = _ref17.meta.field;
	    var result = state;
	    var previouslyActive = getIn(state, 'active');
	    result = deleteIn(result, "fields." + previouslyActive + ".active");
	    result = setIn(result, "fields." + field + ".visited", true);
	    result = setIn(result, "fields." + field + ".active", true);
	    result = setIn(result, 'active', field);
	    return result;
	  }, _behaviors[_actionTypes.INITIALIZE] = function (state, _ref18) {
	    var payload = _ref18.payload,
	        _ref18$meta = _ref18.meta,
	        keepDirty = _ref18$meta.keepDirty,
	        keepSubmitSucceeded = _ref18$meta.keepSubmitSucceeded,
	        updateUnregisteredFields = _ref18$meta.updateUnregisteredFields,
	        keepValues = _ref18$meta.keepValues;
	    var mapData = fromJS(payload);
	    var result = empty; // clean all field state
	    // persist old warnings, they will get recalculated if the new form values are different from the old values
	
	    var warning = getIn(state, 'warning');
	
	    if (warning) {
	      result = setIn(result, 'warning', warning);
	    }
	
	    var syncWarnings = getIn(state, 'syncWarnings');
	
	    if (syncWarnings) {
	      result = setIn(result, 'syncWarnings', syncWarnings);
	    } // persist old errors, they will get recalculated if the new form values are different from the old values
	
	
	    var error = getIn(state, 'error');
	
	    if (error) {
	      result = setIn(result, 'error', error);
	    }
	
	    var syncErrors = getIn(state, 'syncErrors');
	
	    if (syncErrors) {
	      result = setIn(result, 'syncErrors', syncErrors);
	    }
	
	    var registeredFields = getIn(state, 'registeredFields');
	
	    if (registeredFields) {
	      result = setIn(result, 'registeredFields', registeredFields);
	    }
	
	    var previousValues = getIn(state, 'values');
	    var previousInitialValues = getIn(state, 'initial');
	    var newInitialValues = mapData;
	    var newValues = previousValues;
	
	    if (keepDirty && registeredFields) {
	      if (!deepEqual(newInitialValues, previousInitialValues)) {
	        //
	        // Keep the value of dirty fields while updating the value of
	        // pristine fields. This way, apps can reinitialize forms while
	        // avoiding stomping on user edits.
	        //
	        // Note 1: The initialize action replaces all initial values
	        // regardless of keepDirty.
	        //
	        // Note 2: When a field is dirty, keepDirty is enabled, and the field
	        // value is the same as the new initial value for the field, the
	        // initialize action causes the field to become pristine. That effect
	        // is what we want.
	        //
	        var overwritePristineValue = function overwritePristineValue(name) {
	          var previousInitialValue = getIn(previousInitialValues, name);
	          var previousValue = getIn(previousValues, name);
	
	          if (deepEqual(previousValue, previousInitialValue)) {
	            // Overwrite the old pristine value with the new pristine value
	            var newInitialValue = getIn(newInitialValues, name); // This check prevents any 'setIn' call that would create useless
	            // nested objects, since the path to the new field value would
	            // evaluate to the same (especially for undefined values)
	
	            if (getIn(newValues, name) !== newInitialValue) {
	              newValues = setIn(newValues, name, newInitialValue);
	            }
	          }
	        };
	
	        if (!updateUnregisteredFields) {
	          forEach(keys(registeredFields), function (name) {
	            return overwritePristineValue(name);
	          });
	        }
	
	        forEach(keys(newInitialValues), function (name) {
	          var previousInitialValue = getIn(previousInitialValues, name);
	
	          if (typeof previousInitialValue === 'undefined') {
	            // Add new values at the root level.
	            var newInitialValue = getIn(newInitialValues, name);
	            newValues = setIn(newValues, name, newInitialValue);
	          }
	
	          if (updateUnregisteredFields) {
	            overwritePristineValue(name);
	          }
	        });
	      }
	    } else {
	      newValues = newInitialValues;
	    }
	
	    if (keepValues) {
	      forEach(keys(previousValues), function (name) {
	        var previousValue = getIn(previousValues, name);
	        newValues = setIn(newValues, name, previousValue);
	      });
	      forEach(keys(previousInitialValues), function (name) {
	        var previousInitialValue = getIn(previousInitialValues, name);
	        newInitialValues = setIn(newInitialValues, name, previousInitialValue);
	      });
	    }
	
	    if (keepSubmitSucceeded && getIn(state, 'submitSucceeded')) {
	      result = setIn(result, 'submitSucceeded', true);
	    }
	
	    result = setIn(result, 'values', newValues);
	    result = setIn(result, 'initial', newInitialValues);
	    return result;
	  }, _behaviors[_actionTypes.REGISTER_FIELD] = function (state, _ref19) {
	    var _ref19$payload = _ref19.payload,
	        name = _ref19$payload.name,
	        type = _ref19$payload.type;
	    var key = "registeredFields['" + name + "']";
	    var field = getIn(state, key);
	
	    if (field) {
	      var count = getIn(field, 'count') + 1;
	      field = setIn(field, 'count', count);
	    } else {
	      field = fromJS({
	        name: name,
	        type: type,
	        count: 1
	      });
	    }
	
	    return setIn(state, key, field);
	  }, _behaviors[_actionTypes.RESET] = function (state) {
	    var result = empty;
	    var registeredFields = getIn(state, 'registeredFields');
	
	    if (registeredFields) {
	      result = setIn(result, 'registeredFields', registeredFields);
	    }
	
	    var values = getIn(state, 'initial');
	
	    if (values) {
	      result = setIn(result, 'values', values);
	      result = setIn(result, 'initial', values);
	    }
	
	    return result;
	  }, _behaviors[_actionTypes.RESET_SECTION] = function (state, _ref20) {
	    var sections = _ref20.meta.sections;
	    var result = state;
	    sections.forEach(function (section) {
	      result = deleteInWithCleanUp(result, "asyncErrors." + section);
	      result = deleteInWithCleanUp(result, "submitErrors." + section);
	      result = deleteInWithCleanUp(result, "fields." + section);
	      var values = getIn(state, "initial." + section);
	      result = values ? setIn(result, "values." + section, values) : deleteInWithCleanUp(result, "values." + section);
	    });
	    var anyTouched = some(keys(getIn(result, 'registeredFields')), function (key) {
	      return getIn(result, "fields." + key + ".touched");
	    });
	    result = anyTouched ? setIn(result, 'anyTouched', true) : deleteIn(result, 'anyTouched');
	    return result;
	  }, _behaviors[_actionTypes.SUBMIT] = function (state) {
	    return setIn(state, 'triggerSubmit', true);
	  }, _behaviors[_actionTypes.START_ASYNC_VALIDATION] = function (state, _ref21) {
	    var field = _ref21.meta.field;
	    return setIn(state, 'asyncValidating', field || true);
	  }, _behaviors[_actionTypes.START_SUBMIT] = function (state) {
	    return setIn(state, 'submitting', true);
	  }, _behaviors[_actionTypes.STOP_ASYNC_VALIDATION] = function (state, _ref22) {
	    var payload = _ref22.payload;
	    var result = state;
	    result = deleteIn(result, 'asyncValidating');
	
	    if (payload && Object.keys(payload).length) {
	      var _error = payload._error,
	          fieldErrors = (0, _objectWithoutPropertiesLoose2["default"])(payload, ["_error"]);
	
	      if (_error) {
	        result = setIn(result, 'error', _error);
	      }
	
	      if (Object.keys(fieldErrors).length) {
	        result = setIn(result, 'asyncErrors', fromJS(fieldErrors));
	      }
	    } else {
	      result = deleteIn(result, 'error');
	      result = deleteIn(result, 'asyncErrors');
	    }
	
	    return result;
	  }, _behaviors[_actionTypes.STOP_SUBMIT] = function (state, _ref23) {
	    var payload = _ref23.payload;
	    var result = state;
	    result = deleteIn(result, 'submitting');
	    result = deleteIn(result, 'submitFailed');
	    result = deleteIn(result, 'submitSucceeded');
	
	    if (payload && Object.keys(payload).length) {
	      var _error = payload._error,
	          fieldErrors = (0, _objectWithoutPropertiesLoose2["default"])(payload, ["_error"]);
	
	      if (_error) {
	        result = setIn(result, 'error', _error);
	      } else {
	        result = deleteIn(result, 'error');
	      }
	
	      if (Object.keys(fieldErrors).length) {
	        result = setIn(result, 'submitErrors', fromJS(fieldErrors));
	      } else {
	        result = deleteIn(result, 'submitErrors');
	      }
	
	      result = setIn(result, 'submitFailed', true);
	    } else {
	      result = deleteIn(result, 'error');
	      result = deleteIn(result, 'submitErrors');
	    }
	
	    return result;
	  }, _behaviors[_actionTypes.SET_SUBMIT_FAILED] = function (state, _ref24) {
	    var fields = _ref24.meta.fields;
	    var result = state;
	    result = setIn(result, 'submitFailed', true);
	    result = deleteIn(result, 'submitSucceeded');
	    result = deleteIn(result, 'submitting');
	    fields.forEach(function (field) {
	      return result = setIn(result, "fields." + field + ".touched", true);
	    });
	
	    if (fields.length) {
	      result = setIn(result, 'anyTouched', true);
	    }
	
	    return result;
	  }, _behaviors[_actionTypes.SET_SUBMIT_SUCCEEDED] = function (state) {
	    var result = state;
	    result = deleteIn(result, 'submitFailed');
	    result = setIn(result, 'submitSucceeded', true);
	    return result;
	  }, _behaviors[_actionTypes.TOUCH] = function (state, _ref25) {
	    var fields = _ref25.meta.fields;
	    var result = state;
	    fields.forEach(function (field) {
	      return result = setIn(result, "fields." + field + ".touched", true);
	    });
	    result = setIn(result, 'anyTouched', true);
	    return result;
	  }, _behaviors[_actionTypes.UNREGISTER_FIELD] = function (state, _ref26) {
	    var _ref26$payload = _ref26.payload,
	        name = _ref26$payload.name,
	        destroyOnUnmount = _ref26$payload.destroyOnUnmount;
	    var result = state;
	    var key = "registeredFields['" + name + "']";
	    var field = getIn(result, key);
	
	    if (!field) {
	      return result;
	    }
	
	    var count = getIn(field, 'count') - 1;
	
	    if (count <= 0 && destroyOnUnmount) {
	      // Note: Cannot use deleteWithCleanUp here because of the flat nature of registeredFields
	      result = deleteIn(result, key);
	
	      if (deepEqual(getIn(result, 'registeredFields'), empty)) {
	        result = deleteIn(result, 'registeredFields');
	      }
	
	      var syncErrors = getIn(result, 'syncErrors');
	
	      if (syncErrors) {
	        syncErrors = plainDeleteInWithCleanUp(syncErrors, name);
	
	        if (_plain["default"].deepEqual(syncErrors, _plain["default"].empty)) {
	          result = deleteIn(result, 'syncErrors');
	        } else {
	          result = setIn(result, 'syncErrors', syncErrors);
	        }
	      }
	
	      var syncWarnings = getIn(result, 'syncWarnings');
	
	      if (syncWarnings) {
	        syncWarnings = plainDeleteInWithCleanUp(syncWarnings, name);
	
	        if (_plain["default"].deepEqual(syncWarnings, _plain["default"].empty)) {
	          result = deleteIn(result, 'syncWarnings');
	        } else {
	          result = setIn(result, 'syncWarnings', syncWarnings);
	        }
	      }
	
	      result = deleteInWithCleanUp(result, "submitErrors." + name);
	      result = deleteInWithCleanUp(result, "asyncErrors." + name);
	    } else {
	      field = setIn(field, 'count', count);
	      result = setIn(result, key, field);
	    }
	
	    return result;
	  }, _behaviors[_actionTypes.UNTOUCH] = function (state, _ref27) {
	    var fields = _ref27.meta.fields;
	    var result = state;
	    fields.forEach(function (field) {
	      return result = deleteIn(result, "fields." + field + ".touched");
	    });
	    var anyTouched = some(keys(getIn(result, 'registeredFields')), function (key) {
	      return getIn(result, "fields." + key + ".touched");
	    });
	    result = anyTouched ? setIn(result, 'anyTouched', true) : deleteIn(result, 'anyTouched');
	    return result;
	  }, _behaviors[_actionTypes.UPDATE_SYNC_ERRORS] = function (state, _ref28) {
	    var _ref28$payload = _ref28.payload,
	        syncErrors = _ref28$payload.syncErrors,
	        error = _ref28$payload.error;
	    var result = state;
	
	    if (error) {
	      result = setIn(result, 'error', error);
	      result = setIn(result, 'syncError', true);
	    } else {
	      result = deleteIn(result, 'error');
	      result = deleteIn(result, 'syncError');
	    }
	
	    if (Object.keys(syncErrors).length) {
	      result = setIn(result, 'syncErrors', syncErrors);
	    } else {
	      result = deleteIn(result, 'syncErrors');
	    }
	
	    return result;
	  }, _behaviors[_actionTypes.UPDATE_SYNC_WARNINGS] = function (state, _ref29) {
	    var _ref29$payload = _ref29.payload,
	        syncWarnings = _ref29$payload.syncWarnings,
	        warning = _ref29$payload.warning;
	    var result = state;
	
	    if (warning) {
	      result = setIn(result, 'warning', warning);
	    } else {
	      result = deleteIn(result, 'warning');
	    }
	
	    if (Object.keys(syncWarnings).length) {
	      result = setIn(result, 'syncWarnings', syncWarnings);
	    } else {
	      result = deleteIn(result, 'syncWarnings');
	    }
	
	    return result;
	  }, _behaviors);
	
	  var reducer = function reducer(state, action) {
	    if (state === void 0) {
	      state = empty;
	    }
	
	    var behavior = behaviors[action.type];
	    return behavior ? behavior(state, action) : state;
	  };
	
	  var byForm = function byForm(reducer) {
	    return function (state, action) {
	      if (state === void 0) {
	        state = empty;
	      }
	
	      if (action === void 0) {
	        action = {
	          type: 'NONE'
	        };
	      }
	
	      var form = action && action.meta && action.meta.form;
	
	      if (!form || !isReduxFormAction(action)) {
	        return state;
	      }
	
	      if (action.type === _actionTypes.DESTROY && action.meta && action.meta.form) {
	        return action.meta.form.reduce(function (result, form) {
	          return deleteInWithCleanUp(result, form);
	        }, state);
	      }
	
	      var formState = getIn(state, form);
	      var result = reducer(formState, action);
	      return result === formState ? state : setIn(state, form, result);
	    };
	  };
	  /**
	   * Adds additional functionality to the reducer
	   */
	
	
	  function decorate(target) {
	    target.plugin = function (reducers, config) {
	      var _this = this;
	
	      if (config === void 0) {
	        config = {};
	      }
	
	      // use 'function' keyword to enable 'this'
	      return decorate(function (state, action) {
	        if (state === void 0) {
	          state = empty;
	        }
	
	        if (action === void 0) {
	          action = {
	            type: 'NONE'
	          };
	        }
	
	        var callPlugin = function callPlugin(processed, key) {
	          var previousState = getIn(processed, key);
	          var nextState = reducers[key](previousState, action, getIn(state, key));
	          return nextState !== previousState ? setIn(processed, key, nextState) : processed;
	        };
	
	        var processed = _this(state, action); // run through redux-form reducer
	
	
	        var form = action && action.meta && action.meta.form;
	
	        if (form && !config.receiveAllFormActions) {
	          // this is an action aimed at forms, so only give it to the specified form's plugin
	          return reducers[form] ? callPlugin(processed, form) : processed;
	        } else {
	          // this is not a form-specific action, so send it to all the plugins
	          return Object.keys(reducers).reduce(callPlugin, processed);
	        }
	      });
	    };
	
	    return target;
	  }
	
	  return decorate(byForm(reducer));
	}
	
	var _default = createReducer;
	exports["default"] = _default;

/***/ },
/* 1947 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(48);
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports["default"] = createReduxForm;
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(140));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(53));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(35));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(43));
	
	var _merge4 = _interopRequireDefault(__webpack_require__(1747));
	
	var _mapValues2 = _interopRequireDefault(__webpack_require__(303));
	
	var _hoistNonReactStatics = _interopRequireDefault(__webpack_require__(469));
	
	var _invariant = _interopRequireDefault(__webpack_require__(37));
	
	var _isPromise = _interopRequireDefault(__webpack_require__(293));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _reactRedux = __webpack_require__(18);
	
	var _redux = __webpack_require__(163);
	
	var _actions = _interopRequireDefault(__webpack_require__(547));
	
	var _asyncValidation = _interopRequireDefault(__webpack_require__(1939));
	
	var _defaultShouldAsyncValidate = _interopRequireDefault(__webpack_require__(549));
	
	var _defaultShouldValidate = _interopRequireDefault(__webpack_require__(551));
	
	var _defaultShouldError = _interopRequireDefault(__webpack_require__(550));
	
	var _defaultShouldWarn = _interopRequireDefault(__webpack_require__(552));
	
	var _silenceEvent = _interopRequireDefault(__webpack_require__(554));
	
	var _silenceEvents = _interopRequireDefault(__webpack_require__(1951));
	
	var _generateValidator = _interopRequireDefault(__webpack_require__(1954));
	
	var _handleSubmit = _interopRequireDefault(__webpack_require__(1964));
	
	var _isValid = _interopRequireDefault(__webpack_require__(323));
	
	var _plain = _interopRequireDefault(__webpack_require__(27));
	
	var _getDisplayName = _interopRequireDefault(__webpack_require__(1999));
	
	var _isHotReloading = _interopRequireDefault(__webpack_require__(2000));
	
	var _ReduxFormContext = __webpack_require__(85);
	
	var isClassComponent = function isClassComponent(Component) {
	  return Boolean(Component && Component.prototype && typeof Component.prototype.isReactComponent === 'object');
	}; // extract field-specific actions
	
	
	var arrayInsert = _actions["default"].arrayInsert,
	    arrayMove = _actions["default"].arrayMove,
	    arrayPop = _actions["default"].arrayPop,
	    arrayPush = _actions["default"].arrayPush,
	    arrayRemove = _actions["default"].arrayRemove,
	    arrayRemoveAll = _actions["default"].arrayRemoveAll,
	    arrayShift = _actions["default"].arrayShift,
	    arraySplice = _actions["default"].arraySplice,
	    arraySwap = _actions["default"].arraySwap,
	    arrayUnshift = _actions["default"].arrayUnshift,
	    blur = _actions["default"].blur,
	    change = _actions["default"].change,
	    focus = _actions["default"].focus,
	    formActions = (0, _objectWithoutPropertiesLoose2["default"])(_actions["default"], ["arrayInsert", "arrayMove", "arrayPop", "arrayPush", "arrayRemove", "arrayRemoveAll", "arrayShift", "arraySplice", "arraySwap", "arrayUnshift", "blur", "change", "focus"]);
	var arrayActions = {
	  arrayInsert: arrayInsert,
	  arrayMove: arrayMove,
	  arrayPop: arrayPop,
	  arrayPush: arrayPush,
	  arrayRemove: arrayRemove,
	  arrayRemoveAll: arrayRemoveAll,
	  arrayShift: arrayShift,
	  arraySplice: arraySplice,
	  arraySwap: arraySwap,
	  arrayUnshift: arrayUnshift
	};
	var propsToNotUpdateFor = [].concat(Object.keys(_actions["default"]), ['array', 'asyncErrors', 'initialValues', 'syncErrors', 'syncWarnings', 'values', 'registeredFields']);
	
	var checkSubmit = function checkSubmit(submit) {
	  if (!submit || typeof submit !== 'function') {
	    throw new Error('You must either pass handleSubmit() an onSubmit function or pass onSubmit as a prop');
	  }
	
	  return submit;
	};
	
	/**
	 * The decorator that is the main API to redux-form
	 */
	function createReduxForm(structure) {
	  var deepEqual = structure.deepEqual,
	      empty = structure.empty,
	      getIn = structure.getIn,
	      setIn = structure.setIn,
	      keys = structure.keys,
	      fromJS = structure.fromJS,
	      toJS = structure.toJS;
	  var isValid = (0, _isValid["default"])(structure);
	  return function (initialConfig) {
	    var config = (0, _extends2["default"])({
	      touchOnBlur: true,
	      touchOnChange: false,
	      persistentSubmitErrors: false,
	      destroyOnUnmount: true,
	      shouldAsyncValidate: _defaultShouldAsyncValidate["default"],
	      shouldValidate: _defaultShouldValidate["default"],
	      shouldError: _defaultShouldError["default"],
	      shouldWarn: _defaultShouldWarn["default"],
	      enableReinitialize: false,
	      keepDirtyOnReinitialize: false,
	      updateUnregisteredFields: false,
	      getFormState: function getFormState(state) {
	        return getIn(state, 'form');
	      },
	      pure: true,
	      forceUnregisterOnUnmount: false,
	      submitAsSideEffect: false
	    }, initialConfig);
	    return function (WrappedComponent) {
	      var Form = /*#__PURE__*/function (_React$Component) {
	        (0, _inheritsLoose2["default"])(Form, _React$Component);
	
	        function Form() {
	          var _this;
	
	          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	          }
	
	          _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
	          _this.wrapped = _react["default"].createRef();
	          _this.destroyed = false;
	          _this.fieldCounts = {};
	          _this.fieldValidators = {};
	          _this.lastFieldValidatorKeys = [];
	          _this.fieldWarners = {};
	          _this.lastFieldWarnerKeys = [];
	          _this.innerOnSubmit = undefined;
	          _this.submitPromise = undefined;
	
	          _this.initIfNeeded = function (nextProps) {
	            var enableReinitialize = _this.props.enableReinitialize;
	
	            if (nextProps) {
	              if ((enableReinitialize || !nextProps.initialized) && !deepEqual(_this.props.initialValues, nextProps.initialValues)) {
	                var _keepDirty = nextProps.initialized && _this.props.keepDirtyOnReinitialize;
	
	                _this.props.initialize(nextProps.initialValues, _keepDirty, {
	                  keepValues: nextProps.keepValues,
	                  lastInitialValues: _this.props.initialValues,
	                  updateUnregisteredFields: nextProps.updateUnregisteredFields
	                });
	              }
	            } else if (_this.props.initialValues && (!_this.props.initialized || enableReinitialize)) {
	              _this.props.initialize(_this.props.initialValues, _this.props.keepDirtyOnReinitialize, {
	                keepValues: _this.props.keepValues,
	                updateUnregisteredFields: _this.props.updateUnregisteredFields
	              });
	            }
	          };
	
	          _this.updateSyncErrorsIfNeeded = function (nextSyncErrors, nextError, lastSyncErrors) {
	            var _this$props = _this.props,
	                error = _this$props.error,
	                updateSyncErrors = _this$props.updateSyncErrors;
	            var noErrors = (!lastSyncErrors || !Object.keys(lastSyncErrors).length) && !error;
	            var nextNoErrors = (!nextSyncErrors || !Object.keys(nextSyncErrors).length) && !nextError;
	
	            if (!(noErrors && nextNoErrors) && (!_plain["default"].deepEqual(lastSyncErrors, nextSyncErrors) || !_plain["default"].deepEqual(error, nextError))) {
	              updateSyncErrors(nextSyncErrors, nextError);
	            }
	          };
	
	          _this.clearSubmitPromiseIfNeeded = function (nextProps) {
	            var submitting = _this.props.submitting;
	
	            if (_this.submitPromise && submitting && !nextProps.submitting) {
	              delete _this.submitPromise;
	            }
	          };
	
	          _this.submitIfNeeded = function (nextProps) {
	            var _this$props2 = _this.props,
	                clearSubmit = _this$props2.clearSubmit,
	                triggerSubmit = _this$props2.triggerSubmit;
	
	            if (!triggerSubmit && nextProps.triggerSubmit) {
	              clearSubmit();
	
	              _this.submit();
	            }
	          };
	
	          _this.shouldErrorFunction = function () {
	            var _this$props3 = _this.props,
	                shouldValidate = _this$props3.shouldValidate,
	                shouldError = _this$props3.shouldError;
	            var shouldValidateOverridden = shouldValidate !== _defaultShouldValidate["default"];
	            var shouldErrorOverridden = shouldError !== _defaultShouldError["default"];
	            return shouldValidateOverridden && !shouldErrorOverridden ? shouldValidate : shouldError;
	          };
	
	          _this.validateIfNeeded = function (nextProps) {
	            var _this$props4 = _this.props,
	                validate = _this$props4.validate,
	                values = _this$props4.values;
	
	            var shouldError = _this.shouldErrorFunction();
	
	            var fieldLevelValidate = _this.generateValidator();
	
	            if (validate || fieldLevelValidate) {
	              var initialRender = nextProps === undefined;
	              var fieldValidatorKeys = Object.keys(_this.getValidators());
	              var validateParams = {
	                values: values,
	                nextProps: nextProps,
	                props: _this.props,
	                initialRender: initialRender,
	                lastFieldValidatorKeys: _this.lastFieldValidatorKeys,
	                fieldValidatorKeys: fieldValidatorKeys,
	                structure: structure
	              };
	
	              if (shouldError(validateParams)) {
	                var propsToValidate = initialRender || !nextProps ? _this.props : nextProps;
	
	                var _merge2 = (0, _merge4["default"])(validate ? validate(propsToValidate.values, propsToValidate) || {} : {}, fieldLevelValidate ? fieldLevelValidate(propsToValidate.values, propsToValidate) || {} : {}),
	                    _error = _merge2._error,
	                    nextSyncErrors = (0, _objectWithoutPropertiesLoose2["default"])(_merge2, ["_error"]);
	
	                _this.lastFieldValidatorKeys = fieldValidatorKeys;
	
	                _this.updateSyncErrorsIfNeeded(nextSyncErrors, _error, propsToValidate.syncErrors);
	              }
	            } else {
	              _this.lastFieldValidatorKeys = [];
	            }
	          };
	
	          _this.updateSyncWarningsIfNeeded = function (nextSyncWarnings, nextWarning, lastSyncWarnings) {
	            var _this$props5 = _this.props,
	                warning = _this$props5.warning,
	                updateSyncWarnings = _this$props5.updateSyncWarnings;
	            var noWarnings = (!lastSyncWarnings || !Object.keys(lastSyncWarnings).length) && !warning;
	            var nextNoWarnings = (!nextSyncWarnings || !Object.keys(nextSyncWarnings).length) && !nextWarning;
	
	            if (!(noWarnings && nextNoWarnings) && (!_plain["default"].deepEqual(lastSyncWarnings, nextSyncWarnings) || !_plain["default"].deepEqual(warning, nextWarning))) {
	              updateSyncWarnings(nextSyncWarnings, nextWarning);
	            }
	          };
	
	          _this.shouldWarnFunction = function () {
	            var _this$props6 = _this.props,
	                shouldValidate = _this$props6.shouldValidate,
	                shouldWarn = _this$props6.shouldWarn;
	            var shouldValidateOverridden = shouldValidate !== _defaultShouldValidate["default"];
	            var shouldWarnOverridden = shouldWarn !== _defaultShouldWarn["default"];
	            return shouldValidateOverridden && !shouldWarnOverridden ? shouldValidate : shouldWarn;
	          };
	
	          _this.warnIfNeeded = function (nextProps) {
	            var _this$props7 = _this.props,
	                warn = _this$props7.warn,
	                values = _this$props7.values;
	
	            var shouldWarn = _this.shouldWarnFunction();
	
	            var fieldLevelWarn = _this.generateWarner();
	
	            if (warn || fieldLevelWarn) {
	              var initialRender = nextProps === undefined;
	              var fieldWarnerKeys = Object.keys(_this.getWarners());
	              var validateParams = {
	                values: values,
	                nextProps: nextProps,
	                props: _this.props,
	                initialRender: initialRender,
	                lastFieldValidatorKeys: _this.lastFieldWarnerKeys,
	                fieldValidatorKeys: fieldWarnerKeys,
	                structure: structure
	              };
	
	              if (shouldWarn(validateParams)) {
	                var propsToWarn = initialRender || !nextProps ? _this.props : nextProps;
	
	                var _merge3 = (0, _merge4["default"])(warn ? warn(propsToWarn.values, propsToWarn) : {}, fieldLevelWarn ? fieldLevelWarn(propsToWarn.values, propsToWarn) : {}),
	                    _warning = _merge3._warning,
	                    nextSyncWarnings = (0, _objectWithoutPropertiesLoose2["default"])(_merge3, ["_warning"]);
	
	                _this.lastFieldWarnerKeys = fieldWarnerKeys;
	
	                _this.updateSyncWarningsIfNeeded(nextSyncWarnings, _warning, propsToWarn.syncWarnings);
	              }
	            }
	          };
	
	          _this.getValues = function () {
	            return _this.props.values;
	          };
	
	          _this.isValid = function () {
	            return _this.props.valid;
	          };
	
	          _this.isPristine = function () {
	            return _this.props.pristine;
	          };
	
	          _this.register = function (name, type, getValidator, getWarner) {
	            var lastCount = _this.fieldCounts[name];
	            var nextCount = (lastCount || 0) + 1;
	            _this.fieldCounts[name] = nextCount;
	
	            _this.props.registerField(name, type);
	
	            if (getValidator) {
	              _this.fieldValidators[name] = getValidator;
	            }
	
	            if (getWarner) {
	              _this.fieldWarners[name] = getWarner;
	            }
	          };
	
	          _this.unregister = function (name) {
	            var lastCount = _this.fieldCounts[name];
	            if (lastCount === 1) delete _this.fieldCounts[name];else if (lastCount != null) _this.fieldCounts[name] = lastCount - 1;
	
	            if (!_this.destroyed) {
	              var _this$props8 = _this.props,
	                  _destroyOnUnmount = _this$props8.destroyOnUnmount,
	                  forceUnregisterOnUnmount = _this$props8.forceUnregisterOnUnmount,
	                  unregisterField = _this$props8.unregisterField;
	
	              if (_destroyOnUnmount || forceUnregisterOnUnmount) {
	                unregisterField(name, _destroyOnUnmount);
	
	                if (!_this.fieldCounts[name]) {
	                  delete _this.fieldValidators[name];
	                  delete _this.fieldWarners[name];
	                  _this.lastFieldValidatorKeys = _this.lastFieldValidatorKeys.filter(function (key) {
	                    return key !== name;
	                  });
	                }
	              } else {
	                unregisterField(name, false);
	              }
	            }
	          };
	
	          _this.getFieldList = function (options) {
	            var registeredFields = _this.props.registeredFields;
	
	            if (!registeredFields) {
	              return [];
	            }
	
	            var keySeq = keys(registeredFields);
	
	            if (options) {
	              if (options.excludeFieldArray) {
	                keySeq = keySeq.filter(function (name) {
	                  return getIn(registeredFields, "['" + name + "'].type") !== 'FieldArray';
	                });
	              }
	
	              if (options.excludeUnregistered) {
	                keySeq = keySeq.filter(function (name) {
	                  return getIn(registeredFields, "['" + name + "'].count") !== 0;
	                });
	              }
	            }
	
	            return toJS(keySeq);
	          };
	
	          _this.getValidators = function () {
	            var validators = {};
	            Object.keys(_this.fieldValidators).forEach(function (name) {
	              var validator = _this.fieldValidators[name]();
	
	              if (validator) {
	                validators[name] = validator;
	              }
	            });
	            return validators;
	          };
	
	          _this.generateValidator = function () {
	            var validators = _this.getValidators();
	
	            return Object.keys(validators).length ? (0, _generateValidator["default"])(validators, structure) : undefined;
	          };
	
	          _this.getWarners = function () {
	            var warners = {};
	            Object.keys(_this.fieldWarners).forEach(function (name) {
	              var warner = _this.fieldWarners[name]();
	
	              if (warner) {
	                warners[name] = warner;
	              }
	            });
	            return warners;
	          };
	
	          _this.generateWarner = function () {
	            var warners = _this.getWarners();
	
	            return Object.keys(warners).length ? (0, _generateValidator["default"])(warners, structure) : undefined;
	          };
	
	          _this.asyncValidate = function (name, value, trigger) {
	            var _this$props9 = _this.props,
	                asyncBlurFields = _this$props9.asyncBlurFields,
	                asyncChangeFields = _this$props9.asyncChangeFields,
	                asyncErrors = _this$props9.asyncErrors,
	                asyncValidate = _this$props9.asyncValidate,
	                dispatch = _this$props9.dispatch,
	                initialized = _this$props9.initialized,
	                pristine = _this$props9.pristine,
	                shouldAsyncValidate = _this$props9.shouldAsyncValidate,
	                startAsyncValidation = _this$props9.startAsyncValidation,
	                stopAsyncValidation = _this$props9.stopAsyncValidation,
	                syncErrors = _this$props9.syncErrors,
	                values = _this$props9.values;
	            var submitting = !name;
	
	            var fieldNeedsValidation = function fieldNeedsValidation() {
	              var fieldNeedsValidationForBlur = asyncBlurFields && name && ~asyncBlurFields.indexOf(name.replace(/\[[0-9]+]/g, '[]'));
	              var fieldNeedsValidationForChange = asyncChangeFields && name && ~asyncChangeFields.indexOf(name.replace(/\[[0-9]+]/g, '[]'));
	              var asyncValidateByDefault = !(asyncBlurFields || asyncChangeFields);
	              return submitting || asyncValidateByDefault || (trigger === 'blur' ? fieldNeedsValidationForBlur : fieldNeedsValidationForChange);
	            };
	
	            if (asyncValidate) {
	              var valuesToValidate = submitting ? values : setIn(values, name, value);
	              var syncValidationPasses = submitting || !getIn(syncErrors, name);
	
	              if (fieldNeedsValidation() && shouldAsyncValidate({
	                asyncErrors: asyncErrors,
	                initialized: initialized,
	                trigger: submitting ? 'submit' : trigger,
	                blurredField: name,
	                pristine: pristine,
	                syncValidationPasses: syncValidationPasses
	              })) {
	                return (0, _asyncValidation["default"])(function () {
	                  return asyncValidate(valuesToValidate, dispatch, _this.props, name);
	                }, startAsyncValidation, stopAsyncValidation, name);
	              }
	            }
	          };
	
	          _this.submitCompleted = function (result) {
	            delete _this.submitPromise;
	            return result;
	          };
	
	          _this.submitFailed = function (error) {
	            delete _this.submitPromise;
	            throw error;
	          };
	
	          _this.listenToSubmit = function (promise) {
	            if (!(0, _isPromise["default"])(promise)) {
	              return promise;
	            }
	
	            _this.submitPromise = promise;
	            return promise.then(_this.submitCompleted, _this.submitFailed);
	          };
	
	          _this.submit = function (submitOrEvent) {
	            var _this$props10 = _this.props,
	                onSubmit = _this$props10.onSubmit,
	                blur = _this$props10.blur,
	                change = _this$props10.change,
	                dispatch = _this$props10.dispatch;
	
	            if (!submitOrEvent || (0, _silenceEvent["default"])(submitOrEvent)) {
	              // submitOrEvent is an event: fire submit if not already submitting
	              if (!_this.submitPromise) {
	                // avoid recursive stack trace if use Form with onSubmit as handleSubmit
	                if (_this.innerOnSubmit && _this.innerOnSubmit !== _this.submit) {
	                  // will call "submitOrEvent is the submit function" block below
	                  return _this.innerOnSubmit();
	                } else {
	                  return _this.listenToSubmit((0, _handleSubmit["default"])(checkSubmit(onSubmit), (0, _extends2["default"])({}, _this.props, {}, (0, _redux.bindActionCreators)({
	                    blur: blur,
	                    change: change
	                  }, dispatch)), // TODO: fix type, should be `Props`
	                  _this.props.validExceptSubmit, _this.asyncValidate, _this.getFieldList({
	                    excludeFieldArray: true,
	                    excludeUnregistered: true
	                  })));
	                }
	              }
	            } else {
	              // submitOrEvent is the submit function: return deferred submit thunk
	              return (0, _silenceEvents["default"])(function () {
	                return !_this.submitPromise && _this.listenToSubmit((0, _handleSubmit["default"])(checkSubmit(submitOrEvent), (0, _extends2["default"])({}, _this.props, {}, (0, _redux.bindActionCreators)({
	                  blur: blur,
	                  change: change
	                }, dispatch)), // TODO: fix type, should be `Props`
	                _this.props.validExceptSubmit, _this.asyncValidate, _this.getFieldList({
	                  excludeFieldArray: true,
	                  excludeUnregistered: true
	                })));
	              });
	            }
	          };
	
	          _this.reset = function () {
	            return _this.props.reset();
	          };
	
	          return _this;
	        }
	
	        var _proto = Form.prototype;
	
	        _proto.UNSAFE_componentWillMount = function UNSAFE_componentWillMount() {
	          if (!(0, _isHotReloading["default"])()) {
	            this.initIfNeeded();
	            this.validateIfNeeded();
	            this.warnIfNeeded();
	          }
	
	          (0, _invariant["default"])(this.props.shouldValidate, 'shouldValidate() is deprecated and will be removed in v9.0.0. Use shouldWarn() or shouldError() instead.');
	        };
	
	        _proto.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps(nextProps) {
	          this.initIfNeeded(nextProps);
	          this.validateIfNeeded(nextProps);
	          this.warnIfNeeded(nextProps);
	          this.clearSubmitPromiseIfNeeded(nextProps);
	          this.submitIfNeeded(nextProps);
	          var onChange = nextProps.onChange,
	              values = nextProps.values,
	              dispatch = nextProps.dispatch;
	
	          if (onChange && !deepEqual(values, this.props.values)) {
	            onChange(values, dispatch, nextProps, this.props.values);
	          }
	        };
	
	        _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	          var _this2 = this;
	
	          if (!this.props.pure) return true;
	          var _config$immutableProp = config.immutableProps,
	              immutableProps = _config$immutableProp === void 0 ? [] : _config$immutableProp; // if we have children, we MUST update in React 16
	          // https://twitter.com/erikras/status/915866544558788608
	
	          return !!(this.props.children || nextProps.children || Object.keys(nextProps).some(function (prop) {
	            // useful to debug rerenders
	            // if (!plain.deepEqual(this.props[ prop ], nextProps[ prop ])) {
	            //   console.info(prop, 'changed', this.props[ prop ], '==>', nextProps[ prop ])
	            // }
	            if (~immutableProps.indexOf(prop)) {
	              return _this2.props[prop] !== nextProps[prop];
	            }
	
	            return !~propsToNotUpdateFor.indexOf(prop) && !deepEqual(_this2.props[prop], nextProps[prop]);
	          }));
	        };
	
	        _proto.componentDidMount = function componentDidMount() {
	          if (!(0, _isHotReloading["default"])()) {
	            this.initIfNeeded(this.props);
	            this.validateIfNeeded();
	            this.warnIfNeeded();
	          }
	
	          (0, _invariant["default"])(this.props.shouldValidate, 'shouldValidate() is deprecated and will be removed in v9.0.0. Use shouldWarn() or shouldError() instead.');
	        };
	
	        _proto.componentWillUnmount = function componentWillUnmount() {
	          var _this$props11 = this.props,
	              destroyOnUnmount = _this$props11.destroyOnUnmount,
	              destroy = _this$props11.destroy;
	
	          if (destroyOnUnmount && !(0, _isHotReloading["default"])()) {
	            this.destroyed = true;
	            destroy();
	          }
	        };
	
	        _proto.render = function render() {
	          var _ref,
	              _this3 = this;
	
	          // remove some redux-form config-only props
	
	          /* eslint-disable no-unused-vars */
	          var _this$props12 = this.props,
	              anyTouched = _this$props12.anyTouched,
	              array = _this$props12.array,
	              arrayInsert = _this$props12.arrayInsert,
	              arrayMove = _this$props12.arrayMove,
	              arrayPop = _this$props12.arrayPop,
	              arrayPush = _this$props12.arrayPush,
	              arrayRemove = _this$props12.arrayRemove,
	              arrayRemoveAll = _this$props12.arrayRemoveAll,
	              arrayShift = _this$props12.arrayShift,
	              arraySplice = _this$props12.arraySplice,
	              arraySwap = _this$props12.arraySwap,
	              arrayUnshift = _this$props12.arrayUnshift,
	              asyncErrors = _this$props12.asyncErrors,
	              asyncValidate = _this$props12.asyncValidate,
	              asyncValidating = _this$props12.asyncValidating,
	              blur = _this$props12.blur,
	              change = _this$props12.change,
	              clearSubmit = _this$props12.clearSubmit,
	              destroy = _this$props12.destroy,
	              destroyOnUnmount = _this$props12.destroyOnUnmount,
	              forceUnregisterOnUnmount = _this$props12.forceUnregisterOnUnmount,
	              dirty = _this$props12.dirty,
	              dispatch = _this$props12.dispatch,
	              enableReinitialize = _this$props12.enableReinitialize,
	              error = _this$props12.error,
	              focus = _this$props12.focus,
	              form = _this$props12.form,
	              getFormState = _this$props12.getFormState,
	              immutableProps = _this$props12.immutableProps,
	              initialize = _this$props12.initialize,
	              initialized = _this$props12.initialized,
	              initialValues = _this$props12.initialValues,
	              invalid = _this$props12.invalid,
	              keepDirtyOnReinitialize = _this$props12.keepDirtyOnReinitialize,
	              keepValues = _this$props12.keepValues,
	              updateUnregisteredFields = _this$props12.updateUnregisteredFields,
	              pristine = _this$props12.pristine,
	              propNamespace = _this$props12.propNamespace,
	              registeredFields = _this$props12.registeredFields,
	              registerField = _this$props12.registerField,
	              reset = _this$props12.reset,
	              resetSection = _this$props12.resetSection,
	              setSubmitFailed = _this$props12.setSubmitFailed,
	              setSubmitSucceeded = _this$props12.setSubmitSucceeded,
	              shouldAsyncValidate = _this$props12.shouldAsyncValidate,
	              shouldValidate = _this$props12.shouldValidate,
	              shouldError = _this$props12.shouldError,
	              shouldWarn = _this$props12.shouldWarn,
	              startAsyncValidation = _this$props12.startAsyncValidation,
	              startSubmit = _this$props12.startSubmit,
	              stopAsyncValidation = _this$props12.stopAsyncValidation,
	              stopSubmit = _this$props12.stopSubmit,
	              submitAsSideEffect = _this$props12.submitAsSideEffect,
	              submitting = _this$props12.submitting,
	              submitFailed = _this$props12.submitFailed,
	              submitSucceeded = _this$props12.submitSucceeded,
	              touch = _this$props12.touch,
	              touchOnBlur = _this$props12.touchOnBlur,
	              touchOnChange = _this$props12.touchOnChange,
	              persistentSubmitErrors = _this$props12.persistentSubmitErrors,
	              syncErrors = _this$props12.syncErrors,
	              syncWarnings = _this$props12.syncWarnings,
	              unregisterField = _this$props12.unregisterField,
	              untouch = _this$props12.untouch,
	              updateSyncErrors = _this$props12.updateSyncErrors,
	              updateSyncWarnings = _this$props12.updateSyncWarnings,
	              valid = _this$props12.valid,
	              validExceptSubmit = _this$props12.validExceptSubmit,
	              values = _this$props12.values,
	              warning = _this$props12.warning,
	              rest = (0, _objectWithoutPropertiesLoose2["default"])(_this$props12, ["anyTouched", "array", "arrayInsert", "arrayMove", "arrayPop", "arrayPush", "arrayRemove", "arrayRemoveAll", "arrayShift", "arraySplice", "arraySwap", "arrayUnshift", "asyncErrors", "asyncValidate", "asyncValidating", "blur", "change", "clearSubmit", "destroy", "destroyOnUnmount", "forceUnregisterOnUnmount", "dirty", "dispatch", "enableReinitialize", "error", "focus", "form", "getFormState", "immutableProps", "initialize", "initialized", "initialValues", "invalid", "keepDirtyOnReinitialize", "keepValues", "updateUnregisteredFields", "pristine", "propNamespace", "registeredFields", "registerField", "reset", "resetSection", "setSubmitFailed", "setSubmitSucceeded", "shouldAsyncValidate", "shouldValidate", "shouldError", "shouldWarn", "startAsyncValidation", "startSubmit", "stopAsyncValidation", "stopSubmit", "submitAsSideEffect", "submitting", "submitFailed", "submitSucceeded", "touch", "touchOnBlur", "touchOnChange", "persistentSubmitErrors", "syncErrors", "syncWarnings", "unregisterField", "untouch", "updateSyncErrors", "updateSyncWarnings", "valid", "validExceptSubmit", "values", "warning"]);
	          /* eslint-enable no-unused-vars */
	
	          var reduxFormProps = (0, _extends2["default"])({
	            array: array,
	            anyTouched: anyTouched,
	            asyncValidate: this.asyncValidate,
	            asyncValidating: asyncValidating
	          }, (0, _redux.bindActionCreators)({
	            blur: blur,
	            change: change
	          }, dispatch), {
	            clearSubmit: clearSubmit,
	            destroy: destroy,
	            dirty: dirty,
	            dispatch: dispatch,
	            error: error,
	            form: form,
	            handleSubmit: this.submit,
	            initialize: initialize,
	            initialized: initialized,
	            initialValues: initialValues,
	            invalid: invalid,
	            pristine: pristine,
	            reset: reset,
	            resetSection: resetSection,
	            submitting: submitting,
	            submitAsSideEffect: submitAsSideEffect,
	            submitFailed: submitFailed,
	            submitSucceeded: submitSucceeded,
	            touch: touch,
	            untouch: untouch,
	            valid: valid,
	            warning: warning
	          });
	          var propsToPass = (0, _extends2["default"])({}, propNamespace ? (_ref = {}, _ref[propNamespace] = reduxFormProps, _ref) : reduxFormProps, {}, rest);
	
	          if (isClassComponent(WrappedComponent)) {
	            ;
	            propsToPass.ref = this.wrapped;
	          }
	
	          var _reduxForm = (0, _extends2["default"])({}, this.props, {
	            getFormState: function getFormState(state) {
	              return getIn(_this3.props.getFormState(state), _this3.props.form);
	            },
	            asyncValidate: this.asyncValidate,
	            getValues: this.getValues,
	            sectionPrefix: undefined,
	            register: this.register,
	            unregister: this.unregister,
	            registerInnerOnSubmit: function registerInnerOnSubmit(innerOnSubmit) {
	              return _this3.innerOnSubmit = innerOnSubmit;
	            }
	          });
	
	          return (0, _react.createElement)(_ReduxFormContext.ReduxFormContext.Provider, {
	            value: _reduxForm,
	            children: (0, _react.createElement)(WrappedComponent, propsToPass)
	          });
	        };
	
	        return Form;
	      }(_react["default"].Component);
	
	      Form.displayName = "Form(" + (0, _getDisplayName["default"])(WrappedComponent) + ")";
	      Form.WrappedComponent = WrappedComponent;
	      Form.propTypes = {
	        destroyOnUnmount: _propTypes["default"].bool,
	        forceUnregisterOnUnmount: _propTypes["default"].bool,
	        form: _propTypes["default"].string.isRequired,
	        immutableProps: _propTypes["default"].arrayOf(_propTypes["default"].string),
	        initialValues: _propTypes["default"].oneOfType([_propTypes["default"].array, _propTypes["default"].object]),
	        getFormState: _propTypes["default"].func,
	        onSubmitFail: _propTypes["default"].func,
	        onSubmitSuccess: _propTypes["default"].func,
	        propNamespace: _propTypes["default"].string,
	        validate: _propTypes["default"].func,
	        warn: _propTypes["default"].func,
	        touchOnBlur: _propTypes["default"].bool,
	        touchOnChange: _propTypes["default"].bool,
	        triggerSubmit: _propTypes["default"].bool,
	        persistentSubmitErrors: _propTypes["default"].bool,
	        registeredFields: _propTypes["default"].any
	      };
	      var connector = (0, _reactRedux.connect)(function (state, props) {
	        var form = props.form,
	            getFormState = props.getFormState,
	            initialValues = props.initialValues,
	            enableReinitialize = props.enableReinitialize,
	            keepDirtyOnReinitialize = props.keepDirtyOnReinitialize;
	        var formState = getIn(getFormState(state) || empty, form) || empty;
	        var stateInitial = getIn(formState, 'initial');
	        var initialized = !!stateInitial;
	        var shouldUpdateInitialValues = enableReinitialize && initialized && !deepEqual(initialValues, stateInitial);
	        var shouldResetValues = shouldUpdateInitialValues && !keepDirtyOnReinitialize;
	        var initial = initialValues || stateInitial || empty;
	
	        if (!shouldUpdateInitialValues) {
	          initial = stateInitial || empty;
	        }
	
	        var values = getIn(formState, 'values') || initial;
	
	        if (shouldResetValues) {
	          values = initial;
	        }
	
	        var pristine = shouldResetValues || deepEqual(initial, values);
	        var asyncErrors = getIn(formState, 'asyncErrors');
	
	        var syncErrors = getIn(formState, 'syncErrors') || _plain["default"].empty;
	
	        var syncWarnings = getIn(formState, 'syncWarnings') || _plain["default"].empty;
	
	        var registeredFields = getIn(formState, 'registeredFields');
	        var valid = isValid(form, getFormState, false)(state);
	        var validExceptSubmit = isValid(form, getFormState, true)(state);
	        var anyTouched = !!getIn(formState, 'anyTouched');
	        var submitting = !!getIn(formState, 'submitting');
	        var submitFailed = !!getIn(formState, 'submitFailed');
	        var submitSucceeded = !!getIn(formState, 'submitSucceeded');
	        var error = getIn(formState, 'error');
	        var warning = getIn(formState, 'warning');
	        var triggerSubmit = getIn(formState, 'triggerSubmit');
	        return {
	          anyTouched: anyTouched,
	          asyncErrors: asyncErrors,
	          asyncValidating: getIn(formState, 'asyncValidating') || false,
	          dirty: !pristine,
	          error: error,
	          initialized: initialized,
	          invalid: !valid,
	          pristine: pristine,
	          registeredFields: registeredFields,
	          submitting: submitting,
	          submitFailed: submitFailed,
	          submitSucceeded: submitSucceeded,
	          syncErrors: syncErrors,
	          syncWarnings: syncWarnings,
	          triggerSubmit: triggerSubmit,
	          values: values,
	          valid: valid,
	          validExceptSubmit: validExceptSubmit,
	          warning: warning
	        };
	      }, function (dispatch, initialProps) {
	        var bindForm = function bindForm(actionCreator) {
	          return actionCreator.bind(null, initialProps.form);
	        }; // Bind the first parameter on `props.form`
	
	
	        var boundFormACs = (0, _mapValues2["default"])(formActions, bindForm);
	        var boundArrayACs = (0, _mapValues2["default"])(arrayActions, bindForm);
	
	        var boundBlur = function boundBlur(field, value) {
	          return blur(initialProps.form, field, value, !!initialProps.touchOnBlur);
	        };
	
	        var boundChange = function boundChange(field, value) {
	          return change(initialProps.form, field, value, !!initialProps.touchOnChange, !!initialProps.persistentSubmitErrors);
	        };
	
	        var boundFocus = bindForm(focus); // Wrap action creators with `dispatch`
	
	        var connectedFormACs = (0, _redux.bindActionCreators)(boundFormACs, dispatch);
	        var connectedArrayACs = {
	          insert: (0, _redux.bindActionCreators)(boundArrayACs.arrayInsert, dispatch),
	          move: (0, _redux.bindActionCreators)(boundArrayACs.arrayMove, dispatch),
	          pop: (0, _redux.bindActionCreators)(boundArrayACs.arrayPop, dispatch),
	          push: (0, _redux.bindActionCreators)(boundArrayACs.arrayPush, dispatch),
	          remove: (0, _redux.bindActionCreators)(boundArrayACs.arrayRemove, dispatch),
	          removeAll: (0, _redux.bindActionCreators)(boundArrayACs.arrayRemoveAll, dispatch),
	          shift: (0, _redux.bindActionCreators)(boundArrayACs.arrayShift, dispatch),
	          splice: (0, _redux.bindActionCreators)(boundArrayACs.arraySplice, dispatch),
	          swap: (0, _redux.bindActionCreators)(boundArrayACs.arraySwap, dispatch),
	          unshift: (0, _redux.bindActionCreators)(boundArrayACs.arrayUnshift, dispatch)
	        };
	        return (0, _extends2["default"])({}, connectedFormACs, {}, boundArrayACs, {
	          blur: boundBlur,
	          change: boundChange,
	          array: connectedArrayACs,
	          focus: boundFocus,
	          dispatch: dispatch
	        });
	      }, undefined, {
	        forwardRef: true
	      });
	      var ConnectedForm = (0, _hoistNonReactStatics["default"])(connector(Form), WrappedComponent);
	      ConnectedForm.defaultProps = config; // build outer component to expose instance api
	
	      var ReduxForm = /*#__PURE__*/function (_React$Component2) {
	        (0, _inheritsLoose2["default"])(ReduxForm, _React$Component2);
	
	        function ReduxForm() {
	          var _this4;
	
	          for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	            args[_key2] = arguments[_key2];
	          }
	
	          _this4 = _React$Component2.call.apply(_React$Component2, [this].concat(args)) || this;
	          _this4.ref = _react["default"].createRef();
	          return _this4;
	        }
	
	        var _proto2 = ReduxForm.prototype;
	
	        _proto2.submit = function submit() {
	          return this.ref.current && this.ref.current.submit();
	        };
	
	        _proto2.reset = function reset() {
	          if (this.ref) {
	            this.ref.current.reset();
	          }
	        };
	
	        _proto2.render = function render() {
	          var _this$props13 = this.props,
	              initialValues = _this$props13.initialValues,
	              rest = (0, _objectWithoutPropertiesLoose2["default"])(_this$props13, ["initialValues"]);
	          return (0, _react.createElement)(ConnectedForm, (0, _extends2["default"])({}, rest, {
	            ref: this.ref,
	            // convert initialValues if need to
	            initialValues: fromJS(initialValues)
	          }));
	        };
	
	        (0, _createClass2["default"])(ReduxForm, [{
	          key: "valid",
	          get: function get() {
	            return !!(this.ref.current && this.ref.current.isValid());
	          }
	        }, {
	          key: "invalid",
	          get: function get() {
	            return !this.valid;
	          }
	        }, {
	          key: "pristine",
	          get: function get() {
	            return !!(this.ref.current && this.ref.current.isPristine());
	          }
	        }, {
	          key: "dirty",
	          get: function get() {
	            return !this.pristine;
	          }
	        }, {
	          key: "values",
	          get: function get() {
	            return this.ref.current ? this.ref.current.getValues() : empty;
	          }
	        }, {
	          key: "fieldList",
	          get: function get() {
	            // mainly provided for testing
	            return this.ref.current ? this.ref.current.getFieldList() : [];
	          }
	        }, {
	          key: "wrappedInstance",
	          get: function get() {
	            // for testing
	            return this.ref.current && this.ref.current.wrapped.current;
	          }
	        }]);
	        return ReduxForm;
	      }(_react["default"].Component);
	
	      var WithContext = (0, _hoistNonReactStatics["default"])((0, _ReduxFormContext.withReduxForm)(ReduxForm), WrappedComponent);
	      WithContext.defaultProps = config;
	      return WithContext;
	    };
	  };
	}

/***/ },
/* 1948 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports["default"] = createValues;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(35));
	
	var _reactRedux = __webpack_require__(18);
	
	function createValues(_ref) {
	  var getIn = _ref.getIn;
	  return function (config) {
	    var _prop$getFormState$co = (0, _extends2["default"])({
	      prop: 'values',
	      getFormState: function getFormState(state) {
	        return getIn(state, 'form');
	      }
	    }, config),
	        form = _prop$getFormState$co.form,
	        prop = _prop$getFormState$co.prop,
	        getFormState = _prop$getFormState$co.getFormState;
	
	    return (0, _reactRedux.connect)(function (state) {
	      var _ref2;
	
	      return _ref2 = {}, _ref2[prop] = getIn(getFormState(state), form + ".values"), _ref2;
	    } // ignore dispatch
	    );
	  };
	}

/***/ },
/* 1949 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _toPath2 = _interopRequireDefault(__webpack_require__(211));
	
	function createDeleteInWithCleanUp(structure) {
	  var shouldDeleteDefault = function shouldDeleteDefault(structure) {
	    return function (state, path) {
	      return structure.getIn(state, path) !== undefined;
	    };
	  };
	
	  var deepEqual = structure.deepEqual,
	      empty = structure.empty,
	      getIn = structure.getIn,
	      deleteIn = structure.deleteIn,
	      setIn = structure.setIn;
	  return function (shouldDelete) {
	    if (shouldDelete === void 0) {
	      shouldDelete = shouldDeleteDefault;
	    }
	
	    var deleteInWithCleanUp = function deleteInWithCleanUp(state, path) {
	      if (path[path.length - 1] === ']') {
	        // array path
	        var pathTokens = (0, _toPath2["default"])(path);
	        pathTokens.pop();
	        var parent = getIn(state, pathTokens.join('.'));
	        return parent ? setIn(state, path) : state;
	      }
	
	      var result = state;
	
	      if (shouldDelete(structure)(state, path)) {
	        result = deleteIn(state, path);
	      }
	
	      var dotIndex = path.lastIndexOf('.');
	
	      if (dotIndex > 0) {
	        var parentPath = path.substring(0, dotIndex);
	
	        if (parentPath[parentPath.length - 1] !== ']') {
	          var _parent = getIn(result, parentPath);
	
	          if (deepEqual(_parent, empty)) {
	            return deleteInWithCleanUp(result, parentPath);
	          }
	        }
	      }
	
	      return result;
	    };
	
	    return deleteInWithCleanUp;
	  };
	}
	
	var _default = createDeleteInWithCleanUp;
	exports["default"] = _default;

/***/ },
/* 1950 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _isEvent = _interopRequireDefault(__webpack_require__(322));
	
	var getSelectedValues = function getSelectedValues(options) {
	  var result = [];
	
	  if (options) {
	    for (var index = 0; index < options.length; index++) {
	      var option = options[index];
	
	      if (option.selected) {
	        result.push(option.value);
	      }
	    }
	  }
	
	  return result;
	};
	
	var getValue = function getValue(event, isReactNative) {
	  if ((0, _isEvent["default"])(event)) {
	    if (!isReactNative && event.nativeEvent && event.nativeEvent.text !== undefined) {
	      return event.nativeEvent.text;
	    }
	
	    if (isReactNative && event.nativeEvent !== undefined) {
	      return event.nativeEvent.text;
	    }
	
	    var detypedEvent = event;
	    var _detypedEvent$target = detypedEvent.target,
	        type = _detypedEvent$target.type,
	        value = _detypedEvent$target.value,
	        checked = _detypedEvent$target.checked,
	        files = _detypedEvent$target.files,
	        dataTransfer = detypedEvent.dataTransfer;
	
	    if (type === 'checkbox') {
	      return !!checked;
	    }
	
	    if (type === 'file') {
	      return files || dataTransfer && dataTransfer.files;
	    }
	
	    if (type === 'select-multiple') {
	      return getSelectedValues(event.target.options);
	    }
	
	    return value;
	  }
	
	  return event;
	};
	
	var _default = getValue;
	exports["default"] = _default;

/***/ },
/* 1951 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _silenceEvent = _interopRequireDefault(__webpack_require__(554));
	
	var silenceEvents = function silenceEvents(fn) {
	  return function (event) {
	    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    return (0, _silenceEvent["default"])(event) ? fn.apply(void 0, args) : fn.apply(void 0, [event].concat(args));
	  };
	};
	
	var _default = silenceEvents;
	exports["default"] = _default;

/***/ },
/* 1952 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _createFormValueSelector = _interopRequireDefault(__webpack_require__(1944));
	
	var _plain = _interopRequireDefault(__webpack_require__(27));
	
	var _default = (0, _createFormValueSelector["default"])(_plain["default"]);
	
	exports["default"] = _default;

/***/ },
/* 1953 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _createFormValues = _interopRequireDefault(__webpack_require__(1945));
	
	var _plain = _interopRequireDefault(__webpack_require__(27));
	
	var _default = (0, _createFormValues["default"])(_plain["default"]);
	
	exports["default"] = _default;

/***/ },
/* 1954 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports["default"] = generateValidator;
	
	var _plain = _interopRequireDefault(__webpack_require__(27));
	
	var toArray = function toArray(value) {
	  return Array.isArray(value) ? value : [value];
	};
	
	var getError = function getError(value, values, props, validators, name) {
	  var array = toArray(validators);
	
	  for (var i = 0; i < array.length; i++) {
	    var error = array[i](value, values, props, name);
	
	    if (error) {
	      return error;
	    }
	  }
	};
	
	function generateValidator(validators, _ref) {
	  var getIn = _ref.getIn;
	  return function (values, props) {
	    var errors = {};
	    Object.keys(validators).forEach(function (name) {
	      var value = getIn(values, name);
	      var error = getError(value, values, props, validators[name], name);
	
	      if (error) {
	        errors = _plain["default"].setIn(errors, name, error);
	      }
	    });
	    return errors;
	  };
	}

/***/ },
/* 1955 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _getFormAsyncErrors = _interopRequireDefault(__webpack_require__(1977));
	
	var _plain = _interopRequireDefault(__webpack_require__(27));
	
	var _default = (0, _getFormAsyncErrors["default"])(_plain["default"]);
	
	exports["default"] = _default;

/***/ },
/* 1956 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _getFormError = _interopRequireDefault(__webpack_require__(1978));
	
	var _plain = _interopRequireDefault(__webpack_require__(27));
	
	var _default = (0, _getFormError["default"])(_plain["default"]);
	
	exports["default"] = _default;

/***/ },
/* 1957 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _getFormInitialValues = _interopRequireDefault(__webpack_require__(1979));
	
	var _plain = _interopRequireDefault(__webpack_require__(27));
	
	var _default = (0, _getFormInitialValues["default"])(_plain["default"]);
	
	exports["default"] = _default;

/***/ },
/* 1958 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _getFormMeta = _interopRequireDefault(__webpack_require__(1980));
	
	var _plain = _interopRequireDefault(__webpack_require__(27));
	
	var _default = (0, _getFormMeta["default"])(_plain["default"]);
	
	exports["default"] = _default;

/***/ },
/* 1959 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _getFormNames = _interopRequireDefault(__webpack_require__(1981));
	
	var _plain = _interopRequireDefault(__webpack_require__(27));
	
	var _default = (0, _getFormNames["default"])(_plain["default"]);
	
	exports["default"] = _default;

/***/ },
/* 1960 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _getFormSubmitErrors = _interopRequireDefault(__webpack_require__(1982));
	
	var _plain = _interopRequireDefault(__webpack_require__(27));
	
	var _default = (0, _getFormSubmitErrors["default"])(_plain["default"]);
	
	exports["default"] = _default;

/***/ },
/* 1961 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _getFormSyncErrors = _interopRequireDefault(__webpack_require__(1983));
	
	var _plain = _interopRequireDefault(__webpack_require__(27));
	
	var _default = (0, _getFormSyncErrors["default"])(_plain["default"]);
	
	exports["default"] = _default;

/***/ },
/* 1962 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _getFormSyncWarnings = _interopRequireDefault(__webpack_require__(1984));
	
	var _plain = _interopRequireDefault(__webpack_require__(27));
	
	var _default = (0, _getFormSyncWarnings["default"])(_plain["default"]);
	
	exports["default"] = _default;

/***/ },
/* 1963 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _getFormValues = _interopRequireDefault(__webpack_require__(1985));
	
	var _plain = _interopRequireDefault(__webpack_require__(27));
	
	var _default = (0, _getFormValues["default"])(_plain["default"]);
	
	exports["default"] = _default;

/***/ },
/* 1964 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(35));
	
	var _isPromise = _interopRequireDefault(__webpack_require__(293));
	
	var _SubmissionError = __webpack_require__(546);
	
	var mergeErrors = function mergeErrors(_ref) {
	  var asyncErrors = _ref.asyncErrors,
	      syncErrors = _ref.syncErrors;
	  return asyncErrors && typeof asyncErrors.merge === 'function' ? asyncErrors.merge(syncErrors).toJS() : (0, _extends2["default"])({}, asyncErrors, {}, syncErrors);
	};
	
	var executeSubmit = function executeSubmit(submit, fields, props) {
	  var dispatch = props.dispatch,
	      submitAsSideEffect = props.submitAsSideEffect,
	      onSubmitFail = props.onSubmitFail,
	      onSubmitSuccess = props.onSubmitSuccess,
	      startSubmit = props.startSubmit,
	      stopSubmit = props.stopSubmit,
	      setSubmitFailed = props.setSubmitFailed,
	      setSubmitSucceeded = props.setSubmitSucceeded,
	      values = props.values;
	  var result;
	
	  try {
	    result = submit(values, dispatch, props);
	  } catch (submitError) {
	    var error = (0, _SubmissionError.isSubmissionError)(submitError) ? submitError.errors : undefined;
	    stopSubmit(error);
	    setSubmitFailed.apply(void 0, fields);
	
	    if (onSubmitFail) {
	      onSubmitFail(error, dispatch, submitError, props);
	    }
	
	    if (error || onSubmitFail) {
	      // if you've provided an onSubmitFail callback, don't re-throw the error
	      return error;
	    } else {
	      throw submitError;
	    }
	  }
	
	  if (submitAsSideEffect) {
	    if (result) {
	      dispatch(result);
	    }
	  } else {
	    if ((0, _isPromise["default"])(result)) {
	      startSubmit();
	      return result.then(function (submitResult) {
	        stopSubmit();
	        setSubmitSucceeded();
	
	        if (onSubmitSuccess) {
	          onSubmitSuccess(submitResult, dispatch, props);
	        }
	
	        return submitResult;
	      }, function (submitError) {
	        var error = (0, _SubmissionError.isSubmissionError)(submitError) ? submitError.errors : undefined;
	        stopSubmit(error);
	        setSubmitFailed.apply(void 0, fields);
	
	        if (onSubmitFail) {
	          onSubmitFail(error, dispatch, submitError, props);
	        }
	
	        if (error || onSubmitFail) {
	          // if you've provided an onSubmitFail callback, don't re-throw the error
	          return error;
	        } else {
	          throw submitError;
	        }
	      });
	    } else {
	      setSubmitSucceeded();
	
	      if (onSubmitSuccess) {
	        onSubmitSuccess(result, dispatch, props);
	      }
	    }
	  }
	
	  return result;
	};
	
	var handleSubmit = function handleSubmit(submit, props, valid, asyncValidate, fields) {
	  var dispatch = props.dispatch,
	      onSubmitFail = props.onSubmitFail,
	      setSubmitFailed = props.setSubmitFailed,
	      syncErrors = props.syncErrors,
	      asyncErrors = props.asyncErrors,
	      touch = props.touch,
	      persistentSubmitErrors = props.persistentSubmitErrors;
	  touch.apply(void 0, fields);
	
	  if (valid || persistentSubmitErrors) {
	    var asyncValidateResult = asyncValidate && asyncValidate();
	
	    if (asyncValidateResult) {
	      return asyncValidateResult.then(function (asyncErrors) {
	        if (asyncErrors) {
	          throw asyncErrors;
	        }
	
	        return executeSubmit(submit, fields, props);
	      })["catch"](function (asyncErrors) {
	        setSubmitFailed.apply(void 0, fields);
	
	        if (onSubmitFail) {
	          onSubmitFail(asyncErrors, dispatch, null, props);
	        }
	
	        return Promise.reject(asyncErrors);
	      });
	    } else {
	      return executeSubmit(submit, fields, props);
	    }
	  } else {
	    setSubmitFailed.apply(void 0, fields);
	    var errors = mergeErrors({
	      asyncErrors: asyncErrors,
	      syncErrors: syncErrors
	    });
	
	    if (onSubmitFail) {
	      onSubmitFail(errors, dispatch, null, props);
	    }
	
	    return errors;
	  }
	};
	
	var _default = handleSubmit;
	exports["default"] = _default;

/***/ },
/* 1965 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = createHasError;
	
	var getErrorKeys = function getErrorKeys(name, type) {
	  switch (type) {
	    case 'Field':
	      return [name, name + "._error"];
	
	    case 'FieldArray':
	      return [name + "._error"];
	
	    default:
	      throw new Error('Unknown field type');
	  }
	};
	
	function createHasError(_ref) {
	  var getIn = _ref.getIn;
	  return function (field, syncErrors, asyncErrors, submitErrors) {
	    if (!syncErrors && !asyncErrors && !submitErrors) {
	      return false;
	    }
	
	    var name = getIn(field, 'name');
	    var type = getIn(field, 'type');
	    return getErrorKeys(name, type).some(function (key) {
	      return getIn(syncErrors, key) || getIn(asyncErrors, key) || getIn(submitErrors, key);
	    });
	  };
	}

/***/ },
/* 1966 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _hasSubmitFailed = _interopRequireDefault(__webpack_require__(1986));
	
	var _plain = _interopRequireDefault(__webpack_require__(27));
	
	var _default = (0, _hasSubmitFailed["default"])(_plain["default"]);
	
	exports["default"] = _default;

/***/ },
/* 1967 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _hasSubmitSucceeded = _interopRequireDefault(__webpack_require__(1987));
	
	var _plain = _interopRequireDefault(__webpack_require__(27));
	
	var _default = (0, _hasSubmitSucceeded["default"])(_plain["default"]);
	
	exports["default"] = _default;

/***/ },
/* 1968 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _isAsyncValidating = _interopRequireDefault(__webpack_require__(1988));
	
	var _plain = _interopRequireDefault(__webpack_require__(27));
	
	var _default = (0, _isAsyncValidating["default"])(_plain["default"]);
	
	exports["default"] = _default;

/***/ },
/* 1969 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _isDirty = _interopRequireDefault(__webpack_require__(1989));
	
	var _plain = _interopRequireDefault(__webpack_require__(27));
	
	var _default = (0, _isDirty["default"])(_plain["default"]);
	
	exports["default"] = _default;

/***/ },
/* 1970 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _isInvalid = _interopRequireDefault(__webpack_require__(1990));
	
	var _plain = _interopRequireDefault(__webpack_require__(27));
	
	var _default = (0, _isInvalid["default"])(_plain["default"]);
	
	exports["default"] = _default;

/***/ },
/* 1971 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _isPristine = _interopRequireDefault(__webpack_require__(556));
	
	var _plain = _interopRequireDefault(__webpack_require__(27));
	
	var _default = (0, _isPristine["default"])(_plain["default"]);
	
	exports["default"] = _default;

/***/ },
/* 1972 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _isSubmitting = _interopRequireDefault(__webpack_require__(1991));
	
	var _plain = _interopRequireDefault(__webpack_require__(27));
	
	var _default = (0, _isSubmitting["default"])(_plain["default"]);
	
	exports["default"] = _default;

/***/ },
/* 1973 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _isValid = _interopRequireDefault(__webpack_require__(323));
	
	var _plain = _interopRequireDefault(__webpack_require__(27));
	
	var _default = (0, _isValid["default"])(_plain["default"]);
	
	exports["default"] = _default;

/***/ },
/* 1974 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports["default"] = exports.fieldArrayPropTypes = exports.fieldPropTypes = exports.fieldArrayFieldsPropTypes = exports.fieldArrayMetaPropTypes = exports.fieldMetaPropTypes = exports.fieldInputPropTypes = exports.formPropTypes = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var any = _propTypes["default"].any,
	    bool = _propTypes["default"].bool,
	    func = _propTypes["default"].func,
	    shape = _propTypes["default"].shape,
	    string = _propTypes["default"].string,
	    oneOfType = _propTypes["default"].oneOfType,
	    object = _propTypes["default"].object,
	    number = _propTypes["default"].number;
	var formPropTypes = {
	  // State:
	  anyTouched: bool.isRequired,
	  // true if any of the fields have been marked as touched
	  asyncValidating: oneOfType([bool, string]).isRequired,
	  // true if async validation is running, a string if a field triggered async validation
	  dirty: bool.isRequired,
	  // true if any values are different from initialValues
	  error: any,
	  // form-wide error from '_error' key in validation result
	  form: string.isRequired,
	  // the name of the form
	  invalid: bool.isRequired,
	  // true if there are any validation errors
	  initialized: bool.isRequired,
	  // true if the form has been initialized
	  initialValues: object,
	  // the initialValues object passed to reduxForm
	  pristine: bool.isRequired,
	  // true if the values are the same as initialValues
	  pure: bool.isRequired,
	  // if true, implements shouldComponentUpdate
	  submitting: bool.isRequired,
	  // true if the form is in the process of being submitted
	  submitAsSideEffect: bool.isRequired,
	  // true if onSubmit result will be dispatched
	  submitFailed: bool.isRequired,
	  // true if the form was submitted and failed for any reason
	  submitSucceeded: bool.isRequired,
	  // true if the form was successfully submitted
	  valid: bool.isRequired,
	  // true if there are no validation errors
	  warning: any,
	  // form-wide warning from '_warning' key in validation result
	  // Actions:
	  array: shape({
	    insert: func.isRequired,
	    // function to insert a value into an array field
	    move: func.isRequired,
	    // function to move a value within an array field
	    pop: func.isRequired,
	    // function to pop a value off of an array field
	    push: func.isRequired,
	    // function to push a value onto an array field
	    remove: func.isRequired,
	    // function to remove a value from an array field
	    removeAll: func.isRequired,
	    // function to remove all the values from an array field
	    shift: func.isRequired,
	    // function to shift a value out of an array field
	    splice: func.isRequired,
	    // function to splice a value into an array field
	    swap: func.isRequired,
	    // function to swap values in an array field
	    unshift: func.isRequired // function to unshift a value into an array field
	
	  }),
	  asyncValidate: func.isRequired,
	  // function to trigger async validation
	  autofill: func.isRequired,
	  // action to set a value of a field and mark it as autofilled
	  blur: func.isRequired,
	  // action to mark a field as blurred
	  change: func.isRequired,
	  // action to change the value of a field
	  clearAsyncError: func.isRequired,
	  // action to clear the async error of a field
	  clearFields: func.isRequired,
	  // action to clean fields values for all fields
	  clearSubmitErrors: func.isRequired,
	  // action to remove submitErrors and error
	  destroy: func.isRequired,
	  // action to destroy the form's data in Redux
	  dispatch: func.isRequired,
	  // the Redux dispatch action
	  handleSubmit: func.isRequired,
	  // function to submit the form
	  initialize: func.isRequired,
	  // action to initialize form data
	  reset: func.isRequired,
	  // action to reset the form data to previously initialized values
	  resetSection: func.isRequired,
	  // action to reset the form sections data to previously initialized values
	  touch: func.isRequired,
	  // action to mark fields as touched
	  submit: func.isRequired,
	  // action to trigger a submission of the specified form
	  untouch: func.isRequired,
	  // action to mark fields as untouched
	  // triggerSubmit
	  triggerSubmit: bool,
	  // if true, submits the form on componentWillReceiveProps
	  clearSubmit: func.isRequired // called before a triggered submit, by default clears triggerSubmit
	
	};
	exports.formPropTypes = formPropTypes;
	var fieldInputPropTypes = {
	  checked: bool,
	  name: string.isRequired,
	  onBlur: func.isRequired,
	  onChange: func.isRequired,
	  onDragStart: func.isRequired,
	  onDrop: func.isRequired,
	  onFocus: func.isRequired,
	  value: any
	};
	exports.fieldInputPropTypes = fieldInputPropTypes;
	var fieldMetaPropTypes = {
	  active: bool.isRequired,
	  asyncValidating: bool.isRequired,
	  autofilled: bool.isRequired,
	  dirty: bool.isRequired,
	  dispatch: func.isRequired,
	  error: any,
	  form: string.isRequired,
	  invalid: bool.isRequired,
	  pristine: bool.isRequired,
	  submitting: bool.isRequired,
	  submitFailed: bool.isRequired,
	  touched: bool.isRequired,
	  valid: bool.isRequired,
	  visited: bool.isRequired,
	  warning: string
	};
	exports.fieldMetaPropTypes = fieldMetaPropTypes;
	var fieldArrayMetaPropTypes = {
	  dirty: bool.isRequired,
	  error: any,
	  form: string.isRequired,
	  invalid: bool.isRequired,
	  pristine: bool.isRequired,
	  submitFailed: bool,
	  submitting: bool,
	  valid: bool.isRequired,
	  warning: string
	};
	exports.fieldArrayMetaPropTypes = fieldArrayMetaPropTypes;
	var fieldArrayFieldsPropTypes = {
	  name: string.isRequired,
	  forEach: func.isRequired,
	  get: func.isRequired,
	  getAll: func.isRequired,
	  insert: func.isRequired,
	  length: number.isRequired,
	  map: func.isRequired,
	  move: func.isRequired,
	  pop: func.isRequired,
	  push: func.isRequired,
	  reduce: func.isRequired,
	  remove: func.isRequired,
	  removeAll: func.isRequired,
	  shift: func.isRequired,
	  swap: func.isRequired,
	  unshift: func.isRequired
	};
	exports.fieldArrayFieldsPropTypes = fieldArrayFieldsPropTypes;
	var fieldPropTypes = {
	  input: shape(fieldInputPropTypes).isRequired,
	  meta: shape(fieldMetaPropTypes).isRequired
	};
	exports.fieldPropTypes = fieldPropTypes;
	var fieldArrayPropTypes = {
	  fields: shape(fieldArrayFieldsPropTypes).isRequired,
	  meta: shape(fieldArrayMetaPropTypes).isRequired
	};
	exports.fieldArrayPropTypes = fieldArrayPropTypes;
	var _default = formPropTypes;
	exports["default"] = _default;

/***/ },
/* 1975 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _createReducer = _interopRequireDefault(__webpack_require__(1946));
	
	var _plain = _interopRequireDefault(__webpack_require__(27));
	
	var _default = (0, _createReducer["default"])(_plain["default"]);
	
	exports["default"] = _default;

/***/ },
/* 1976 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _createReduxForm = _interopRequireDefault(__webpack_require__(1947));
	
	var _plain = _interopRequireDefault(__webpack_require__(27));
	
	var _default = (0, _createReduxForm["default"])(_plain["default"]);
	
	exports["default"] = _default;

/***/ },
/* 1977 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = createGetFormAsyncErrors;
	
	function createGetFormAsyncErrors(_ref) {
	  var getIn = _ref.getIn;
	  return function (form, getFormState) {
	    return function (state) {
	      var nonNullGetFormState = getFormState || function (state) {
	        return getIn(state, 'form');
	      };
	
	      return getIn(nonNullGetFormState(state), form + ".asyncErrors");
	    };
	  };
	}

/***/ },
/* 1978 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = createGetFormError;
	
	function createGetFormError(_ref) {
	  var getIn = _ref.getIn;
	  return function (form, getFormState) {
	    return function (state) {
	      var nonNullGetFormState = getFormState || function (state) {
	        return getIn(state, 'form');
	      };
	
	      return getIn(nonNullGetFormState(state), form + ".error");
	    };
	  };
	}

/***/ },
/* 1979 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = createGetFormInitialValues;
	
	function createGetFormInitialValues(_ref) {
	  var getIn = _ref.getIn;
	  return function (form, getFormState) {
	    return function (state) {
	      var nonNullGetFormState = getFormState || function (state) {
	        return getIn(state, 'form');
	      };
	
	      return getIn(nonNullGetFormState(state), form + ".initial");
	    };
	  };
	}

/***/ },
/* 1980 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = createGetFormMeta;
	
	function createGetFormMeta(_ref) {
	  var getIn = _ref.getIn,
	      empty = _ref.empty;
	  return function (form, getFormState) {
	    return function (state) {
	      var nonNullGetFormState = getFormState || function (state) {
	        return getIn(state, 'form');
	      };
	
	      return getIn(nonNullGetFormState(state), form + ".fields") || empty;
	    };
	  };
	}

/***/ },
/* 1981 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = createGetFormNames;
	
	function createGetFormNames(_ref) {
	  var getIn = _ref.getIn,
	      keys = _ref.keys;
	  return function (getFormState) {
	    return function (state) {
	      var nonNullGetFormState = getFormState || function (state) {
	        return getIn(state, 'form');
	      };
	
	      return keys(nonNullGetFormState(state));
	    };
	  };
	}

/***/ },
/* 1982 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = createGetFormSubmitErrors;
	
	function createGetFormSubmitErrors(_ref) {
	  var getIn = _ref.getIn,
	      empty = _ref.empty;
	  return function (form, getFormState) {
	    return function (state) {
	      var nonNullGetFormState = getFormState || function (state) {
	        return getIn(state, 'form');
	      };
	
	      return getIn(nonNullGetFormState(state), form + ".submitErrors") || empty;
	    };
	  };
	}

/***/ },
/* 1983 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = createGetFormSyncErrors;
	
	function createGetFormSyncErrors(_ref) {
	  var getIn = _ref.getIn,
	      empty = _ref.empty;
	  return function (form, getFormState) {
	    return function (state) {
	      var nonNullGetFormState = getFormState || function (state) {
	        return getIn(state, 'form');
	      };
	
	      return getIn(nonNullGetFormState(state), form + ".syncErrors") || empty;
	    };
	  };
	}

/***/ },
/* 1984 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = createGetFormSyncWarnings;
	
	function createGetFormSyncWarnings(_ref) {
	  var getIn = _ref.getIn,
	      empty = _ref.empty;
	  return function (form, getFormState) {
	    return function (state) {
	      var nonNullGetFormState = getFormState || function (state) {
	        return getIn(state, 'form');
	      };
	
	      return getIn(nonNullGetFormState(state), form + ".syncWarnings") || empty;
	    };
	  };
	}

/***/ },
/* 1985 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = createGetFormValues;
	
	function createGetFormValues(_ref) {
	  var getIn = _ref.getIn;
	  return function (form, getFormState) {
	    return function (state) {
	      var nonNullGetFormState = getFormState || function (state) {
	        return getIn(state, 'form');
	      };
	
	      return getIn(nonNullGetFormState(state), form + ".values");
	    };
	  };
	}

/***/ },
/* 1986 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = createHasSubmitFailed;
	
	function createHasSubmitFailed(_ref) {
	  var getIn = _ref.getIn;
	  return function (form, getFormState) {
	    return function (state) {
	      var nonNullGetFormState = getFormState || function (state) {
	        return getIn(state, 'form');
	      };
	
	      return !!getIn(nonNullGetFormState(state), form + ".submitFailed");
	    };
	  };
	}

/***/ },
/* 1987 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = createHasSubmitSucceeded;
	
	function createHasSubmitSucceeded(_ref) {
	  var getIn = _ref.getIn;
	  return function (form, getFormState) {
	    return function (state) {
	      var nonNullGetFormState = getFormState || function (state) {
	        return getIn(state, 'form');
	      };
	
	      return !!getIn(nonNullGetFormState(state), form + ".submitSucceeded");
	    };
	  };
	}

/***/ },
/* 1988 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = createIsAsyncValidating;
	
	function createIsAsyncValidating(_ref) {
	  var getIn = _ref.getIn;
	  return function (form, getFormState) {
	    return function (state) {
	      var nonNullGetFormState = getFormState || function (state) {
	        return getIn(state, 'form');
	      };
	
	      return !!getIn(nonNullGetFormState(state), form + ".asyncValidating");
	    };
	  };
	}

/***/ },
/* 1989 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports["default"] = createIsDirty;
	
	var _isPristine = _interopRequireDefault(__webpack_require__(556));
	
	function createIsDirty(structure) {
	  return function (form, getFormState) {
	    var isPristine = (0, _isPristine["default"])(structure)(form, getFormState);
	    return function (state) {
	      for (var _len = arguments.length, fields = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        fields[_key - 1] = arguments[_key];
	      }
	
	      return !isPristine.apply(void 0, [state].concat(fields));
	    };
	  };
	}

/***/ },
/* 1990 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports["default"] = createIsInvalid;
	
	var _isValid = _interopRequireDefault(__webpack_require__(323));
	
	function createIsInvalid(structure) {
	  return function (form, getFormState) {
	    var isValid = (0, _isValid["default"])(structure)(form, getFormState);
	    return function (state) {
	      return !isValid(state);
	    };
	  };
	}

/***/ },
/* 1991 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = createIsSubmitting;
	
	function createIsSubmitting(_ref) {
	  var getIn = _ref.getIn;
	  return function (form, getFormState) {
	    return function (state) {
	      var nonNullGetFormState = getFormState || function (state) {
	        return getIn(state, 'form');
	      };
	
	      return !!getIn(nonNullGetFormState(state), form + ".submitting");
	    };
	  };
	}

/***/ },
/* 1992 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _isNil2 = _interopRequireDefault(__webpack_require__(1744));
	
	var _isEqualWith2 = _interopRequireDefault(__webpack_require__(494));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var isEmpty = function isEmpty(obj) {
	  return (0, _isNil2["default"])(obj) || obj === '' || isNaN(obj);
	};
	
	var customizer = function customizer(obj, other) {
	  if (obj === other) return true;
	
	  if (!obj && !other) {
	    return isEmpty(obj) === isEmpty(other);
	  }
	
	  if (obj && other && obj._error !== other._error) return false;
	  if (obj && other && obj._warning !== other._warning) return false;
	  if (_react["default"].isValidElement(obj) || _react["default"].isValidElement(other)) return false;
	};
	
	var deepEqual = function deepEqual(a, b) {
	  return (0, _isEqualWith2["default"])(a, b, customizer);
	};
	
	var _default = deepEqual;
	exports["default"] = _default;

/***/ },
/* 1993 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _extends3 = _interopRequireDefault(__webpack_require__(35));
	
	var _toPath2 = _interopRequireDefault(__webpack_require__(211));
	
	function deleteInWithPath(state, first) {
	  if (state === undefined || state === null || first === undefined || first === null) {
	    return state;
	  }
	
	  for (var _len = arguments.length, rest = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	    rest[_key - 2] = arguments[_key];
	  }
	
	  if (rest.length) {
	    if (Array.isArray(state)) {
	      if (isNaN(first)) {
	        throw new Error("Must access array elements with a number, not \"" + String(first) + "\".");
	      }
	
	      var firstIndex = Number(first);
	
	      if (firstIndex < state.length) {
	        var result = deleteInWithPath.apply(void 0, [state && state[firstIndex]].concat(rest));
	
	        if (result !== state[firstIndex]) {
	          var copy = [].concat(state);
	          copy[firstIndex] = result;
	          return copy;
	        }
	      }
	
	      return state;
	    }
	
	    if (first in state) {
	      var _extends2;
	
	      var _result = deleteInWithPath.apply(void 0, [state && state[first]].concat(rest));
	
	      return state[first] === _result ? state : (0, _extends3["default"])({}, state, (_extends2 = {}, _extends2[first] = _result, _extends2));
	    }
	
	    return state;
	  }
	
	  if (Array.isArray(state)) {
	    if (isNaN(first)) {
	      throw new Error("Cannot delete non-numerical index from an array. Given: \"" + String(first));
	    }
	
	    var _firstIndex = Number(first);
	
	    if (_firstIndex < state.length) {
	      var _copy = [].concat(state);
	
	      _copy.splice(_firstIndex, 1);
	
	      return _copy;
	    }
	
	    return state;
	  }
	
	  if (first in state) {
	    var _copy2 = (0, _extends3["default"])({}, state);
	
	    delete _copy2[first];
	    return _copy2;
	  }
	
	  return state;
	}
	
	var deleteIn = function deleteIn(state, field) {
	  return deleteInWithPath.apply(void 0, [state].concat((0, _toPath2["default"])(field)));
	};
	
	var _default = deleteIn;
	exports["default"] = _default;

/***/ },
/* 1994 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _toPath2 = _interopRequireDefault(__webpack_require__(211));
	
	var getIn = function getIn(state, field) {
	  if (!state) {
	    return state;
	  }
	
	  var path = (0, _toPath2["default"])(field);
	  var length = path.length;
	
	  if (!length) {
	    return undefined;
	  }
	
	  var result = state;
	
	  for (var i = 0; i < length && result; ++i) {
	    result = result[path[i]];
	  }
	
	  return result;
	};
	
	var _default = getIn;
	exports["default"] = _default;

/***/ },
/* 1995 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	function keys(value) {
	  if (!value) {
	    return [];
	  }
	
	  if (Array.isArray(value)) {
	    return value.map(function (i) {
	      return i.name;
	    });
	  }
	
	  return Object.keys(value);
	}
	
	var _default = keys;
	exports["default"] = _default;

/***/ },
/* 1996 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _extends3 = _interopRequireDefault(__webpack_require__(35));
	
	var _toPath2 = _interopRequireDefault(__webpack_require__(211));
	
	var setInWithPath = function setInWithPath(state, value, path, pathIndex) {
	  var _extends2;
	
	  if (pathIndex >= path.length) {
	    return value;
	  }
	
	  var first = path[pathIndex];
	  var firstState = state && (Array.isArray(state) ? state[Number(first)] : state[first]);
	  var next = setInWithPath(firstState, value, path, pathIndex + 1);
	
	  if (!state) {
	    if (isNaN(first)) {
	      var _ref;
	
	      return _ref = {}, _ref[first] = next, _ref;
	    }
	
	    var initialized = [];
	    initialized[parseInt(first, 10)] = next;
	    return initialized;
	  }
	
	  if (Array.isArray(state)) {
	    var copy = [].concat(state);
	    copy[parseInt(first, 10)] = next;
	    return copy;
	  }
	
	  return (0, _extends3["default"])({}, state, (_extends2 = {}, _extends2[first] = next, _extends2));
	};
	
	var setIn = function setIn(state, field, value) {
	  return setInWithPath(state, value, (0, _toPath2["default"])(field), 0);
	};
	
	var _default = setIn;
	exports["default"] = _default;

/***/ },
/* 1997 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var splice = function splice(array, index, removeNum, value) {
	  array = array || [];
	
	  if (index < array.length) {
	    if (value === undefined && !removeNum) {
	      // inserting undefined
	      var _copy2 = [].concat(array);
	
	      _copy2.splice(index, 0, true); // temporary placeholder
	
	
	      _copy2[index] = undefined; // set to undefined
	
	      return _copy2;
	    }
	
	    if (value != null) {
	      var _copy3 = [].concat(array);
	
	      _copy3.splice(index, removeNum, value); // removing and adding
	
	
	      return _copy3;
	    }
	
	    var _copy = [].concat(array);
	
	    _copy.splice(index, removeNum); // removing
	
	
	    return _copy;
	  }
	
	  if (removeNum) {
	    // trying to remove non-existant item: return original array
	    return array;
	  } // trying to add outside of range: just set value
	
	
	  var copy = [].concat(array);
	  copy[index] = value;
	  return copy;
	};
	
	var _default = splice;
	exports["default"] = _default;

/***/ },
/* 1998 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.dataKey = void 0;
	var dataKey = 'text';
	exports.dataKey = dataKey;

/***/ },
/* 1999 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var getDisplayName = function getDisplayName(Comp) {
	  return Comp.displayName || Comp.name || 'Component';
	};
	
	var _default = getDisplayName;
	exports["default"] = _default;

/***/ },
/* 2000 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var isHotReloading = function isHotReloading() {
	  var castModule = module;
	  return !!(typeof castModule !== 'undefined' && castModule.hot && typeof castModule.hot.status === 'function' && castModule.hot.status() === 'apply');
	};
	
	var _default = isHotReloading;
	exports["default"] = _default;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(139)(module)))

/***/ },
/* 2001 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _createValues = _interopRequireDefault(__webpack_require__(1948));
	
	var _plain = _interopRequireDefault(__webpack_require__(27));
	
	var _default = (0, _createValues["default"])(_plain["default"]);
	
	exports["default"] = _default;

/***/ },
/* 2002 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.topPosition = topPosition;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(46);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// measures top position of DOM element
	function topPosition(domElt) {
	  if (!domElt) {
	    return 0;
	  }
	  return domElt.offsetTop + topPosition(domElt.offsetParent);
	}
	
	var ReduxLazyScroll = function (_Component) {
	  _inherits(ReduxLazyScroll, _Component);
	
	  function ReduxLazyScroll(props) {
	    _classCallCheck(this, ReduxLazyScroll);
	
	    var _this = _possibleConstructorReturn(this, (ReduxLazyScroll.__proto__ || Object.getPrototypeOf(ReduxLazyScroll)).call(this, props));
	
	    _this.scrollFunction = _this.scrollListener.bind(_this);
	    return _this;
	  }
	
	  _createClass(ReduxLazyScroll, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.attachScrollListener();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.attachScrollListener();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.detachScrollListener();
	    }
	  }, {
	    key: 'targetElement',
	    value: function targetElement() {
	      return this.props.isParentScrollable ? _reactDom2.default.findDOMNode(this) : window;
	    }
	  }, {
	    key: 'attachScrollListener',
	    value: function attachScrollListener() {
	      if (!this.props.hasMore || this.props.isFetching || this.props.errorMessage) return;
	      var el = this.targetElement();
	      el.addEventListener('scroll', this.scrollFunction, true);
	      el.addEventListener('resize', this.scrollFunction, true);
	      this.scrollListener();
	    }
	  }, {
	    key: 'windowScrollListener',
	    value: function windowScrollListener() {
	      var el = _reactDom2.default.findDOMNode(this);
	
	      var windowScrollTop = window.pageYOffset !== undefined ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop;
	      var elTotalHeight = topPosition(el) + el.offsetHeight;
	      return elTotalHeight - windowScrollTop - window.innerHeight;
	    }
	  }, {
	    key: 'parentScrollListener',
	    value: function parentScrollListener() {
	      var el = _reactDom2.default.findDOMNode(this);
	      var topScrollPos = el.scrollTop;
	      var totalContainerHeight = el.scrollHeight;
	      var containerFixedHeight = el.offsetHeight;
	      var bottomScrollPos = topScrollPos + containerFixedHeight;
	
	      return totalContainerHeight - bottomScrollPos;
	    }
	  }, {
	    key: 'scrollListener',
	    value: function scrollListener() {
	      var bottomPosition = this.props.isParentScrollable ? this.parentScrollListener() : this.windowScrollListener();
	
	      if (bottomPosition < Number(this.props.threshold)) {
	        this.detachScrollListener();
	        this.props.loadMore();
	      }
	    }
	  }, {
	    key: 'detachScrollListener',
	    value: function detachScrollListener() {
	      var el = this.targetElement();
	      el.removeEventListener('scroll', this.scrollFunction, true);
	      el.removeEventListener('resize', this.scrollFunction, true);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'redux-lazy-scroll', style: { height: this.props.parentHeight, overflow: 'scroll' } },
	        this.props.children
	      );
	    }
	  }]);
	
	  return ReduxLazyScroll;
	}(_react.Component);
	
	ReduxLazyScroll.propTypes = {
	  hasMore: _propTypes2.default.bool,
	  isFetching: _propTypes2.default.bool,
	  errorMessage: _propTypes2.default.string,
	  loadMore: _propTypes2.default.func,
	  threshold: _propTypes2.default.number,
	  isParentScrollable: _propTypes2.default.bool,
	  parentHeight: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])
	};
	ReduxLazyScroll.defaultProps = {
	  hasMore: true,
	  isFetching: false,
	  threshold: 100,
	  errorMessage: "",
	  loadMore: function loadMore() {},
	  isParentScrollable: false,
	  parentHeight: '100%'
	};
	
	exports.default = ReduxLazyScroll;

/***/ },
/* 2003 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.printBuffer = printBuffer;
	
	var _helpers = __webpack_require__(558);
	
	var _diff = __webpack_require__(2005);
	
	var _diff2 = _interopRequireDefault(_diff);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _typeof(obj) { return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj; }
	
	/**
	 * Get log level string based on supplied params
	 *
	 * @param {string | function | object} level - console[level]
	 * @param {object} action - selected action
	 * @param {array} payload - selected payload
	 * @param {string} type - log entry type
	 *
	 * @returns {string} level
	 */
	function getLogLevel(level, action, payload, type) {
	  switch (typeof level === 'undefined' ? 'undefined' : _typeof(level)) {
	    case 'object':
	      return typeof level[type] === 'function' ? level[type].apply(level, _toConsumableArray(payload)) : level[type];
	    case 'function':
	      return level(action);
	    default:
	      return level;
	  }
	}
	
	function defaultTitleFormatter(options) {
	  var timestamp = options.timestamp;
	  var duration = options.duration;
	
	  return function (action, time, took) {
	    var parts = ['action'];
	    if (timestamp) {
	      parts.push('@ ' + time);
	    }
	    parts.push(action.type);
	    if (duration) {
	      parts.push('(in ' + took.toFixed(2) + ' ms)');
	    }
	    return parts.join(' ');
	  };
	}
	
	function printBuffer(buffer, options) {
	  var logger = options.logger;
	  var actionTransformer = options.actionTransformer;
	  var _options$titleFormatt = options.titleFormatter;
	  var titleFormatter = _options$titleFormatt === undefined ? defaultTitleFormatter(options) : _options$titleFormatt;
	  var collapsed = options.collapsed;
	  var colors = options.colors;
	  var level = options.level;
	  var diff = options.diff;
	
	  buffer.forEach(function (logEntry, key) {
	    var started = logEntry.started;
	    var startedTime = logEntry.startedTime;
	    var action = logEntry.action;
	    var prevState = logEntry.prevState;
	    var error = logEntry.error;
	    var took = logEntry.took;
	    var nextState = logEntry.nextState;
	
	    var nextEntry = buffer[key + 1];
	
	    if (nextEntry) {
	      nextState = nextEntry.prevState;
	      took = nextEntry.started - started;
	    }
	
	    // Message
	    var formattedAction = actionTransformer(action);
	    var isCollapsed = typeof collapsed === 'function' ? collapsed(function () {
	      return nextState;
	    }, action) : collapsed;
	
	    var formattedTime = (0, _helpers.formatTime)(startedTime);
	    var titleCSS = colors.title ? 'color: ' + colors.title(formattedAction) + ';' : null;
	    var title = titleFormatter(formattedAction, formattedTime, took);
	
	    // Render
	    try {
	      if (isCollapsed) {
	        if (colors.title) logger.groupCollapsed('%c ' + title, titleCSS);else logger.groupCollapsed(title);
	      } else {
	        if (colors.title) logger.group('%c ' + title, titleCSS);else logger.group(title);
	      }
	    } catch (e) {
	      logger.log(title);
	    }
	
	    var prevStateLevel = getLogLevel(level, formattedAction, [prevState], 'prevState');
	    var actionLevel = getLogLevel(level, formattedAction, [formattedAction], 'action');
	    var errorLevel = getLogLevel(level, formattedAction, [error, prevState], 'error');
	    var nextStateLevel = getLogLevel(level, formattedAction, [nextState], 'nextState');
	
	    if (prevStateLevel) {
	      if (colors.prevState) logger[prevStateLevel]('%c prev state', 'color: ' + colors.prevState(prevState) + '; font-weight: bold', prevState);else logger[prevStateLevel]('prev state', prevState);
	    }
	
	    if (actionLevel) {
	      if (colors.action) logger[actionLevel]('%c action', 'color: ' + colors.action(formattedAction) + '; font-weight: bold', formattedAction);else logger[actionLevel]('action', formattedAction);
	    }
	
	    if (error && errorLevel) {
	      if (colors.error) logger[errorLevel]('%c error', 'color: ' + colors.error(error, prevState) + '; font-weight: bold', error);else logger[errorLevel]('error', error);
	    }
	
	    if (nextStateLevel) {
	      if (colors.nextState) logger[nextStateLevel]('%c next state', 'color: ' + colors.nextState(nextState) + '; font-weight: bold', nextState);else logger[nextStateLevel]('next state', nextState);
	    }
	
	    if (diff) {
	      (0, _diff2.default)(prevState, nextState, logger, isCollapsed);
	    }
	
	    try {
	      logger.groupEnd();
	    } catch (e) {
	      logger.log('—— log end ——');
	    }
	  });
	}

/***/ },
/* 2004 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  level: "log",
	  logger: console,
	  logErrors: true,
	  collapsed: undefined,
	  predicate: undefined,
	  duration: false,
	  timestamp: true,
	  stateTransformer: function stateTransformer(state) {
	    return state;
	  },
	  actionTransformer: function actionTransformer(action) {
	    return action;
	  },
	  errorTransformer: function errorTransformer(error) {
	    return error;
	  },
	  colors: {
	    title: function title() {
	      return "inherit";
	    },
	    prevState: function prevState() {
	      return "#9E9E9E";
	    },
	    action: function action() {
	      return "#03A9F4";
	    },
	    nextState: function nextState() {
	      return "#4CAF50";
	    },
	    error: function error() {
	      return "#F20404";
	    }
	  },
	  diff: false,
	  diffPredicate: undefined,
	
	  // Deprecated options
	  transformer: undefined
	};
	module.exports = exports['default'];

/***/ },
/* 2005 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = diffLogger;
	
	var _deepDiff = __webpack_require__(1575);
	
	var _deepDiff2 = _interopRequireDefault(_deepDiff);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// https://github.com/flitbit/diff#differences
	var dictionary = {
	  'E': {
	    color: '#2196F3',
	    text: 'CHANGED:'
	  },
	  'N': {
	    color: '#4CAF50',
	    text: 'ADDED:'
	  },
	  'D': {
	    color: '#F44336',
	    text: 'DELETED:'
	  },
	  'A': {
	    color: '#2196F3',
	    text: 'ARRAY:'
	  }
	};
	
	function style(kind) {
	  return 'color: ' + dictionary[kind].color + '; font-weight: bold';
	}
	
	function render(diff) {
	  var kind = diff.kind;
	  var path = diff.path;
	  var lhs = diff.lhs;
	  var rhs = diff.rhs;
	  var index = diff.index;
	  var item = diff.item;
	
	  switch (kind) {
	    case 'E':
	      return path.join('.') + ' ' + lhs + ' → ' + rhs;
	    case 'N':
	      return path.join('.') + ' ' + rhs;
	    case 'D':
	      return '' + path.join('.');
	    case 'A':
	      return [path.join('.') + '[' + index + ']', item];
	    default:
	      return null;
	  }
	}
	
	function diffLogger(prevState, newState, logger, isCollapsed) {
	  var diff = (0, _deepDiff2.default)(prevState, newState);
	
	  try {
	    if (isCollapsed) {
	      logger.groupCollapsed('diff');
	    } else {
	      logger.group('diff');
	    }
	  } catch (e) {
	    logger.log('diff');
	  }
	
	  if (diff) {
	    diff.forEach(function (elem) {
	      var kind = elem.kind;
	
	      var output = render(elem);
	
	      logger.log('%c ' + dictionary[kind].text, style(kind), output);
	    });
	  } else {
	    logger.log('—— no diff ——');
	  }
	
	  try {
	    logger.groupEnd();
	  } catch (e) {
	    logger.log('—— diff end —— ');
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 2006 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _core = __webpack_require__(2003);
	
	var _helpers = __webpack_require__(558);
	
	var _defaults = __webpack_require__(2004);
	
	var _defaults2 = _interopRequireDefault(_defaults);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Creates logger with following options
	 *
	 * @namespace
	 * @param {object} options - options for logger
	 * @param {string | function | object} options.level - console[level]
	 * @param {boolean} options.duration - print duration of each action?
	 * @param {boolean} options.timestamp - print timestamp with each action?
	 * @param {object} options.colors - custom colors
	 * @param {object} options.logger - implementation of the `console` API
	 * @param {boolean} options.logErrors - should errors in action execution be caught, logged, and re-thrown?
	 * @param {boolean} options.collapsed - is group collapsed?
	 * @param {boolean} options.predicate - condition which resolves logger behavior
	 * @param {function} options.stateTransformer - transform state before print
	 * @param {function} options.actionTransformer - transform action before print
	 * @param {function} options.errorTransformer - transform error before print
	 *
	 * @returns {function} logger middleware
	 */
	function createLogger() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	  var loggerOptions = _extends({}, _defaults2.default, options);
	
	  var logger = loggerOptions.logger;
	  var transformer = loggerOptions.transformer;
	  var stateTransformer = loggerOptions.stateTransformer;
	  var errorTransformer = loggerOptions.errorTransformer;
	  var predicate = loggerOptions.predicate;
	  var logErrors = loggerOptions.logErrors;
	  var diffPredicate = loggerOptions.diffPredicate;
	
	  // Return if 'console' object is not defined
	
	  if (typeof logger === 'undefined') {
	    return function () {
	      return function (next) {
	        return function (action) {
	          return next(action);
	        };
	      };
	    };
	  }
	
	  if (transformer) {
	    console.error('Option \'transformer\' is deprecated, use \'stateTransformer\' instead!'); // eslint-disable-line no-console
	  }
	
	  var logBuffer = [];
	
	  return function (_ref) {
	    var getState = _ref.getState;
	    return function (next) {
	      return function (action) {
	        // Exit early if predicate function returns 'false'
	        if (typeof predicate === 'function' && !predicate(getState, action)) {
	          return next(action);
	        }
	
	        var logEntry = {};
	        logBuffer.push(logEntry);
	
	        logEntry.started = _helpers.timer.now();
	        logEntry.startedTime = new Date();
	        logEntry.prevState = stateTransformer(getState());
	        logEntry.action = action;
	
	        var returnedValue = undefined;
	        if (logErrors) {
	          try {
	            returnedValue = next(action);
	          } catch (e) {
	            logEntry.error = errorTransformer(e);
	          }
	        } else {
	          returnedValue = next(action);
	        }
	
	        logEntry.took = _helpers.timer.now() - logEntry.started;
	        logEntry.nextState = stateTransformer(getState());
	
	        var diff = loggerOptions.diff && typeof diffPredicate === 'function' ? diffPredicate(getState, action) : loggerOptions.diff;
	
	        (0, _core.printBuffer)(logBuffer, _extends({}, loggerOptions, { diff: diff }));
	        logBuffer.length = 0;
	
	        if (logEntry.error) throw logEntry.error;
	        return returnedValue;
	      };
	    };
	  };
	}
	
	exports.default = createLogger;
	module.exports = exports['default'];

/***/ },
/* 2007 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	function createThunkMiddleware(extraArgument) {
	  return function (_ref) {
	    var dispatch = _ref.dispatch,
	        getState = _ref.getState;
	    return function (next) {
	      return function (action) {
	        if (typeof action === 'function') {
	          return action(dispatch, getState, extraArgument);
	        }
	
	        return next(action);
	      };
	    };
	  };
	}
	
	var thunk = createThunkMiddleware();
	thunk.withExtraArgument = createThunkMiddleware;
	
	exports['default'] = thunk;

/***/ },
/* 2008 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	function isAbsolute(pathname) {
	  return pathname.charAt(0) === '/';
	}
	
	// About 1.5x faster than the two-arg version of Array#splice()
	function spliceOne(list, index) {
	  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
	    list[i] = list[k];
	  }
	
	  list.pop();
	}
	
	// This implementation is based heavily on node's url.parse
	function resolvePathname(to) {
	  var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	
	  var toParts = to && to.split('/') || [];
	  var fromParts = from && from.split('/') || [];
	
	  var isToAbs = to && isAbsolute(to);
	  var isFromAbs = from && isAbsolute(from);
	  var mustEndAbs = isToAbs || isFromAbs;
	
	  if (to && isAbsolute(to)) {
	    // to is absolute
	    fromParts = toParts;
	  } else if (toParts.length) {
	    // to is relative, drop the filename
	    fromParts.pop();
	    fromParts = fromParts.concat(toParts);
	  }
	
	  if (!fromParts.length) return '/';
	
	  var hasTrailingSlash = void 0;
	  if (fromParts.length) {
	    var last = fromParts[fromParts.length - 1];
	    hasTrailingSlash = last === '.' || last === '..' || last === '';
	  } else {
	    hasTrailingSlash = false;
	  }
	
	  var up = 0;
	  for (var i = fromParts.length; i >= 0; i--) {
	    var part = fromParts[i];
	
	    if (part === '.') {
	      spliceOne(fromParts, i);
	    } else if (part === '..') {
	      spliceOne(fromParts, i);
	      up++;
	    } else if (up) {
	      spliceOne(fromParts, i);
	      up--;
	    }
	  }
	
	  if (!mustEndAbs) for (; up--; up) {
	    fromParts.unshift('..');
	  }if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !isAbsolute(fromParts[0]))) fromParts.unshift('');
	
	  var result = fromParts.join('/');
	
	  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';
	
	  return result;
	}
	
	exports.default = resolvePathname;
	module.exports = exports['default'];

/***/ },
/* 2009 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __exportStar = (this && this.__exportStar) || function(m, exports) {
	    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.interval = exports.iif = exports.generate = exports.fromEventPattern = exports.fromEvent = exports.from = exports.forkJoin = exports.empty = exports.defer = exports.connectable = exports.concat = exports.combineLatest = exports.bindNodeCallback = exports.bindCallback = exports.UnsubscriptionError = exports.TimeoutError = exports.SequenceError = exports.ObjectUnsubscribedError = exports.NotFoundError = exports.EmptyError = exports.ArgumentOutOfRangeError = exports.firstValueFrom = exports.lastValueFrom = exports.isObservable = exports.identity = exports.noop = exports.pipe = exports.NotificationKind = exports.Notification = exports.Subscriber = exports.Subscription = exports.Scheduler = exports.VirtualAction = exports.VirtualTimeScheduler = exports.animationFrameScheduler = exports.animationFrame = exports.queueScheduler = exports.queue = exports.asyncScheduler = exports.async = exports.asapScheduler = exports.asap = exports.AsyncSubject = exports.ReplaySubject = exports.BehaviorSubject = exports.Subject = exports.animationFrames = exports.observable = exports.ConnectableObservable = exports.Observable = void 0;
	exports.filter = exports.expand = exports.exhaustMap = exports.exhaustAll = exports.exhaust = exports.every = exports.endWith = exports.elementAt = exports.distinctUntilKeyChanged = exports.distinctUntilChanged = exports.distinct = exports.dematerialize = exports.delayWhen = exports.delay = exports.defaultIfEmpty = exports.debounceTime = exports.debounce = exports.count = exports.connect = exports.concatWith = exports.concatMapTo = exports.concatMap = exports.concatAll = exports.combineLatestWith = exports.combineLatestAll = exports.combineAll = exports.catchError = exports.bufferWhen = exports.bufferToggle = exports.bufferTime = exports.bufferCount = exports.buffer = exports.auditTime = exports.audit = exports.config = exports.NEVER = exports.EMPTY = exports.scheduled = exports.zip = exports.using = exports.timer = exports.throwError = exports.range = exports.race = exports.partition = exports.pairs = exports.onErrorResumeNext = exports.of = exports.never = exports.merge = void 0;
	exports.switchMapTo = exports.switchMap = exports.switchAll = exports.subscribeOn = exports.startWith = exports.skipWhile = exports.skipUntil = exports.skipLast = exports.skip = exports.single = exports.shareReplay = exports.share = exports.sequenceEqual = exports.scan = exports.sampleTime = exports.sample = exports.refCount = exports.retryWhen = exports.retry = exports.repeatWhen = exports.repeat = exports.reduce = exports.raceWith = exports.publishReplay = exports.publishLast = exports.publishBehavior = exports.publish = exports.pluck = exports.pairwise = exports.observeOn = exports.multicast = exports.min = exports.mergeWith = exports.mergeScan = exports.mergeMapTo = exports.mergeMap = exports.flatMap = exports.mergeAll = exports.max = exports.materialize = exports.mapTo = exports.map = exports.last = exports.isEmpty = exports.ignoreElements = exports.groupBy = exports.first = exports.findIndex = exports.find = exports.finalize = void 0;
	exports.zipWith = exports.zipAll = exports.withLatestFrom = exports.windowWhen = exports.windowToggle = exports.windowTime = exports.windowCount = exports.window = exports.toArray = exports.timestamp = exports.timeoutWith = exports.timeout = exports.timeInterval = exports.throwIfEmpty = exports.throttleTime = exports.throttle = exports.tap = exports.takeWhile = exports.takeUntil = exports.takeLast = exports.take = exports.switchScan = void 0;
	var Observable_1 = __webpack_require__(34);
	Object.defineProperty(exports, "Observable", { enumerable: true, get: function () { return Observable_1.Observable; } });
	var ConnectableObservable_1 = __webpack_require__(221);
	Object.defineProperty(exports, "ConnectableObservable", { enumerable: true, get: function () { return ConnectableObservable_1.ConnectableObservable; } });
	var observable_1 = __webpack_require__(230);
	Object.defineProperty(exports, "observable", { enumerable: true, get: function () { return observable_1.observable; } });
	var animationFrames_1 = __webpack_require__(2016);
	Object.defineProperty(exports, "animationFrames", { enumerable: true, get: function () { return animationFrames_1.animationFrames; } });
	var Subject_1 = __webpack_require__(51);
	Object.defineProperty(exports, "Subject", { enumerable: true, get: function () { return Subject_1.Subject; } });
	var BehaviorSubject_1 = __webpack_require__(559);
	Object.defineProperty(exports, "BehaviorSubject", { enumerable: true, get: function () { return BehaviorSubject_1.BehaviorSubject; } });
	var ReplaySubject_1 = __webpack_require__(326);
	Object.defineProperty(exports, "ReplaySubject", { enumerable: true, get: function () { return ReplaySubject_1.ReplaySubject; } });
	var AsyncSubject_1 = __webpack_require__(324);
	Object.defineProperty(exports, "AsyncSubject", { enumerable: true, get: function () { return AsyncSubject_1.AsyncSubject; } });
	var asap_1 = __webpack_require__(2123);
	Object.defineProperty(exports, "asap", { enumerable: true, get: function () { return asap_1.asap; } });
	Object.defineProperty(exports, "asapScheduler", { enumerable: true, get: function () { return asap_1.asapScheduler; } });
	var async_1 = __webpack_require__(63);
	Object.defineProperty(exports, "async", { enumerable: true, get: function () { return async_1.async; } });
	Object.defineProperty(exports, "asyncScheduler", { enumerable: true, get: function () { return async_1.asyncScheduler; } });
	var queue_1 = __webpack_require__(2127);
	Object.defineProperty(exports, "queue", { enumerable: true, get: function () { return queue_1.queue; } });
	Object.defineProperty(exports, "queueScheduler", { enumerable: true, get: function () { return queue_1.queueScheduler; } });
	var animationFrame_1 = __webpack_require__(2122);
	Object.defineProperty(exports, "animationFrame", { enumerable: true, get: function () { return animationFrame_1.animationFrame; } });
	Object.defineProperty(exports, "animationFrameScheduler", { enumerable: true, get: function () { return animationFrame_1.animationFrameScheduler; } });
	var VirtualTimeScheduler_1 = __webpack_require__(2121);
	Object.defineProperty(exports, "VirtualTimeScheduler", { enumerable: true, get: function () { return VirtualTimeScheduler_1.VirtualTimeScheduler; } });
	Object.defineProperty(exports, "VirtualAction", { enumerable: true, get: function () { return VirtualTimeScheduler_1.VirtualAction; } });
	var Scheduler_1 = __webpack_require__(560);
	Object.defineProperty(exports, "Scheduler", { enumerable: true, get: function () { return Scheduler_1.Scheduler; } });
	var Subscription_1 = __webpack_require__(62);
	Object.defineProperty(exports, "Subscription", { enumerable: true, get: function () { return Subscription_1.Subscription; } });
	var Subscriber_1 = __webpack_require__(164);
	Object.defineProperty(exports, "Subscriber", { enumerable: true, get: function () { return Subscriber_1.Subscriber; } });
	var Notification_1 = __webpack_require__(325);
	Object.defineProperty(exports, "Notification", { enumerable: true, get: function () { return Notification_1.Notification; } });
	Object.defineProperty(exports, "NotificationKind", { enumerable: true, get: function () { return Notification_1.NotificationKind; } });
	var pipe_1 = __webpack_require__(232);
	Object.defineProperty(exports, "pipe", { enumerable: true, get: function () { return pipe_1.pipe; } });
	var noop_1 = __webpack_require__(52);
	Object.defineProperty(exports, "noop", { enumerable: true, get: function () { return noop_1.noop; } });
	var identity_1 = __webpack_require__(56);
	Object.defineProperty(exports, "identity", { enumerable: true, get: function () { return identity_1.identity; } });
	var isObservable_1 = __webpack_require__(2130);
	Object.defineProperty(exports, "isObservable", { enumerable: true, get: function () { return isObservable_1.isObservable; } });
	var lastValueFrom_1 = __webpack_require__(2012);
	Object.defineProperty(exports, "lastValueFrom", { enumerable: true, get: function () { return lastValueFrom_1.lastValueFrom; } });
	var firstValueFrom_1 = __webpack_require__(2011);
	Object.defineProperty(exports, "firstValueFrom", { enumerable: true, get: function () { return firstValueFrom_1.firstValueFrom; } });
	var ArgumentOutOfRangeError_1 = __webpack_require__(589);
	Object.defineProperty(exports, "ArgumentOutOfRangeError", { enumerable: true, get: function () { return ArgumentOutOfRangeError_1.ArgumentOutOfRangeError; } });
	var EmptyError_1 = __webpack_require__(115);
	Object.defineProperty(exports, "EmptyError", { enumerable: true, get: function () { return EmptyError_1.EmptyError; } });
	var NotFoundError_1 = __webpack_require__(590);
	Object.defineProperty(exports, "NotFoundError", { enumerable: true, get: function () { return NotFoundError_1.NotFoundError; } });
	var ObjectUnsubscribedError_1 = __webpack_require__(591);
	Object.defineProperty(exports, "ObjectUnsubscribedError", { enumerable: true, get: function () { return ObjectUnsubscribedError_1.ObjectUnsubscribedError; } });
	var SequenceError_1 = __webpack_require__(592);
	Object.defineProperty(exports, "SequenceError", { enumerable: true, get: function () { return SequenceError_1.SequenceError; } });
	var timeout_1 = __webpack_require__(334);
	Object.defineProperty(exports, "TimeoutError", { enumerable: true, get: function () { return timeout_1.TimeoutError; } });
	var UnsubscriptionError_1 = __webpack_require__(593);
	Object.defineProperty(exports, "UnsubscriptionError", { enumerable: true, get: function () { return UnsubscriptionError_1.UnsubscriptionError; } });
	var bindCallback_1 = __webpack_require__(2013);
	Object.defineProperty(exports, "bindCallback", { enumerable: true, get: function () { return bindCallback_1.bindCallback; } });
	var bindNodeCallback_1 = __webpack_require__(2014);
	Object.defineProperty(exports, "bindNodeCallback", { enumerable: true, get: function () { return bindNodeCallback_1.bindNodeCallback; } });
	var combineLatest_1 = __webpack_require__(327);
	Object.defineProperty(exports, "combineLatest", { enumerable: true, get: function () { return combineLatest_1.combineLatest; } });
	var concat_1 = __webpack_require__(222);
	Object.defineProperty(exports, "concat", { enumerable: true, get: function () { return concat_1.concat; } });
	var connectable_1 = __webpack_require__(2015);
	Object.defineProperty(exports, "connectable", { enumerable: true, get: function () { return connectable_1.connectable; } });
	var defer_1 = __webpack_require__(223);
	Object.defineProperty(exports, "defer", { enumerable: true, get: function () { return defer_1.defer; } });
	var empty_1 = __webpack_require__(74);
	Object.defineProperty(exports, "empty", { enumerable: true, get: function () { return empty_1.empty; } });
	var forkJoin_1 = __webpack_require__(2017);
	Object.defineProperty(exports, "forkJoin", { enumerable: true, get: function () { return forkJoin_1.forkJoin; } });
	var from_1 = __webpack_require__(78);
	Object.defineProperty(exports, "from", { enumerable: true, get: function () { return from_1.from; } });
	var fromEvent_1 = __webpack_require__(2018);
	Object.defineProperty(exports, "fromEvent", { enumerable: true, get: function () { return fromEvent_1.fromEvent; } });
	var fromEventPattern_1 = __webpack_require__(2019);
	Object.defineProperty(exports, "fromEventPattern", { enumerable: true, get: function () { return fromEventPattern_1.fromEventPattern; } });
	var generate_1 = __webpack_require__(2021);
	Object.defineProperty(exports, "generate", { enumerable: true, get: function () { return generate_1.generate; } });
	var iif_1 = __webpack_require__(2022);
	Object.defineProperty(exports, "iif", { enumerable: true, get: function () { return iif_1.iif; } });
	var interval_1 = __webpack_require__(562);
	Object.defineProperty(exports, "interval", { enumerable: true, get: function () { return interval_1.interval; } });
	var merge_1 = __webpack_require__(2023);
	Object.defineProperty(exports, "merge", { enumerable: true, get: function () { return merge_1.merge; } });
	var never_1 = __webpack_require__(563);
	Object.defineProperty(exports, "never", { enumerable: true, get: function () { return never_1.never; } });
	var of_1 = __webpack_require__(328);
	Object.defineProperty(exports, "of", { enumerable: true, get: function () { return of_1.of; } });
	var onErrorResumeNext_1 = __webpack_require__(2024);
	Object.defineProperty(exports, "onErrorResumeNext", { enumerable: true, get: function () { return onErrorResumeNext_1.onErrorResumeNext; } });
	var pairs_1 = __webpack_require__(2025);
	Object.defineProperty(exports, "pairs", { enumerable: true, get: function () { return pairs_1.pairs; } });
	var partition_1 = __webpack_require__(2026);
	Object.defineProperty(exports, "partition", { enumerable: true, get: function () { return partition_1.partition; } });
	var race_1 = __webpack_require__(564);
	Object.defineProperty(exports, "race", { enumerable: true, get: function () { return race_1.race; } });
	var range_1 = __webpack_require__(2027);
	Object.defineProperty(exports, "range", { enumerable: true, get: function () { return range_1.range; } });
	var throwError_1 = __webpack_require__(565);
	Object.defineProperty(exports, "throwError", { enumerable: true, get: function () { return throwError_1.throwError; } });
	var timer_1 = __webpack_require__(113);
	Object.defineProperty(exports, "timer", { enumerable: true, get: function () { return timer_1.timer; } });
	var using_1 = __webpack_require__(2028);
	Object.defineProperty(exports, "using", { enumerable: true, get: function () { return using_1.using; } });
	var zip_1 = __webpack_require__(329);
	Object.defineProperty(exports, "zip", { enumerable: true, get: function () { return zip_1.zip; } });
	var scheduled_1 = __webpack_require__(585);
	Object.defineProperty(exports, "scheduled", { enumerable: true, get: function () { return scheduled_1.scheduled; } });
	var empty_2 = __webpack_require__(74);
	Object.defineProperty(exports, "EMPTY", { enumerable: true, get: function () { return empty_2.EMPTY; } });
	var never_2 = __webpack_require__(563);
	Object.defineProperty(exports, "NEVER", { enumerable: true, get: function () { return never_2.NEVER; } });
	__exportStar(__webpack_require__(2128), exports);
	var config_1 = __webpack_require__(165);
	Object.defineProperty(exports, "config", { enumerable: true, get: function () { return config_1.config; } });
	var audit_1 = __webpack_require__(566);
	Object.defineProperty(exports, "audit", { enumerable: true, get: function () { return audit_1.audit; } });
	var auditTime_1 = __webpack_require__(2029);
	Object.defineProperty(exports, "auditTime", { enumerable: true, get: function () { return auditTime_1.auditTime; } });
	var buffer_1 = __webpack_require__(2030);
	Object.defineProperty(exports, "buffer", { enumerable: true, get: function () { return buffer_1.buffer; } });
	var bufferCount_1 = __webpack_require__(2031);
	Object.defineProperty(exports, "bufferCount", { enumerable: true, get: function () { return bufferCount_1.bufferCount; } });
	var bufferTime_1 = __webpack_require__(2032);
	Object.defineProperty(exports, "bufferTime", { enumerable: true, get: function () { return bufferTime_1.bufferTime; } });
	var bufferToggle_1 = __webpack_require__(2033);
	Object.defineProperty(exports, "bufferToggle", { enumerable: true, get: function () { return bufferToggle_1.bufferToggle; } });
	var bufferWhen_1 = __webpack_require__(2034);
	Object.defineProperty(exports, "bufferWhen", { enumerable: true, get: function () { return bufferWhen_1.bufferWhen; } });
	var catchError_1 = __webpack_require__(2035);
	Object.defineProperty(exports, "catchError", { enumerable: true, get: function () { return catchError_1.catchError; } });
	var combineAll_1 = __webpack_require__(2036);
	Object.defineProperty(exports, "combineAll", { enumerable: true, get: function () { return combineAll_1.combineAll; } });
	var combineLatestAll_1 = __webpack_require__(567);
	Object.defineProperty(exports, "combineLatestAll", { enumerable: true, get: function () { return combineLatestAll_1.combineLatestAll; } });
	var combineLatestWith_1 = __webpack_require__(2038);
	Object.defineProperty(exports, "combineLatestWith", { enumerable: true, get: function () { return combineLatestWith_1.combineLatestWith; } });
	var concatAll_1 = __webpack_require__(330);
	Object.defineProperty(exports, "concatAll", { enumerable: true, get: function () { return concatAll_1.concatAll; } });
	var concatMap_1 = __webpack_require__(568);
	Object.defineProperty(exports, "concatMap", { enumerable: true, get: function () { return concatMap_1.concatMap; } });
	var concatMapTo_1 = __webpack_require__(2040);
	Object.defineProperty(exports, "concatMapTo", { enumerable: true, get: function () { return concatMapTo_1.concatMapTo; } });
	var concatWith_1 = __webpack_require__(2041);
	Object.defineProperty(exports, "concatWith", { enumerable: true, get: function () { return concatWith_1.concatWith; } });
	var connect_1 = __webpack_require__(331);
	Object.defineProperty(exports, "connect", { enumerable: true, get: function () { return connect_1.connect; } });
	var count_1 = __webpack_require__(2042);
	Object.defineProperty(exports, "count", { enumerable: true, get: function () { return count_1.count; } });
	var debounce_1 = __webpack_require__(2043);
	Object.defineProperty(exports, "debounce", { enumerable: true, get: function () { return debounce_1.debounce; } });
	var debounceTime_1 = __webpack_require__(2044);
	Object.defineProperty(exports, "debounceTime", { enumerable: true, get: function () { return debounceTime_1.debounceTime; } });
	var defaultIfEmpty_1 = __webpack_require__(224);
	Object.defineProperty(exports, "defaultIfEmpty", { enumerable: true, get: function () { return defaultIfEmpty_1.defaultIfEmpty; } });
	var delay_1 = __webpack_require__(2045);
	Object.defineProperty(exports, "delay", { enumerable: true, get: function () { return delay_1.delay; } });
	var delayWhen_1 = __webpack_require__(569);
	Object.defineProperty(exports, "delayWhen", { enumerable: true, get: function () { return delayWhen_1.delayWhen; } });
	var dematerialize_1 = __webpack_require__(2046);
	Object.defineProperty(exports, "dematerialize", { enumerable: true, get: function () { return dematerialize_1.dematerialize; } });
	var distinct_1 = __webpack_require__(2047);
	Object.defineProperty(exports, "distinct", { enumerable: true, get: function () { return distinct_1.distinct; } });
	var distinctUntilChanged_1 = __webpack_require__(570);
	Object.defineProperty(exports, "distinctUntilChanged", { enumerable: true, get: function () { return distinctUntilChanged_1.distinctUntilChanged; } });
	var distinctUntilKeyChanged_1 = __webpack_require__(2048);
	Object.defineProperty(exports, "distinctUntilKeyChanged", { enumerable: true, get: function () { return distinctUntilKeyChanged_1.distinctUntilKeyChanged; } });
	var elementAt_1 = __webpack_require__(2049);
	Object.defineProperty(exports, "elementAt", { enumerable: true, get: function () { return elementAt_1.elementAt; } });
	var endWith_1 = __webpack_require__(2050);
	Object.defineProperty(exports, "endWith", { enumerable: true, get: function () { return endWith_1.endWith; } });
	var every_1 = __webpack_require__(2051);
	Object.defineProperty(exports, "every", { enumerable: true, get: function () { return every_1.every; } });
	var exhaust_1 = __webpack_require__(2052);
	Object.defineProperty(exports, "exhaust", { enumerable: true, get: function () { return exhaust_1.exhaust; } });
	var exhaustAll_1 = __webpack_require__(571);
	Object.defineProperty(exports, "exhaustAll", { enumerable: true, get: function () { return exhaustAll_1.exhaustAll; } });
	var exhaustMap_1 = __webpack_require__(2053);
	Object.defineProperty(exports, "exhaustMap", { enumerable: true, get: function () { return exhaustMap_1.exhaustMap; } });
	var expand_1 = __webpack_require__(2054);
	Object.defineProperty(exports, "expand", { enumerable: true, get: function () { return expand_1.expand; } });
	var filter_1 = __webpack_require__(136);
	Object.defineProperty(exports, "filter", { enumerable: true, get: function () { return filter_1.filter; } });
	var finalize_1 = __webpack_require__(2055);
	Object.defineProperty(exports, "finalize", { enumerable: true, get: function () { return finalize_1.finalize; } });
	var find_1 = __webpack_require__(572);
	Object.defineProperty(exports, "find", { enumerable: true, get: function () { return find_1.find; } });
	var findIndex_1 = __webpack_require__(2056);
	Object.defineProperty(exports, "findIndex", { enumerable: true, get: function () { return findIndex_1.findIndex; } });
	var first_1 = __webpack_require__(2057);
	Object.defineProperty(exports, "first", { enumerable: true, get: function () { return first_1.first; } });
	var groupBy_1 = __webpack_require__(2059);
	Object.defineProperty(exports, "groupBy", { enumerable: true, get: function () { return groupBy_1.groupBy; } });
	var ignoreElements_1 = __webpack_require__(573);
	Object.defineProperty(exports, "ignoreElements", { enumerable: true, get: function () { return ignoreElements_1.ignoreElements; } });
	var isEmpty_1 = __webpack_require__(2060);
	Object.defineProperty(exports, "isEmpty", { enumerable: true, get: function () { return isEmpty_1.isEmpty; } });
	var last_1 = __webpack_require__(2061);
	Object.defineProperty(exports, "last", { enumerable: true, get: function () { return last_1.last; } });
	var map_1 = __webpack_require__(114);
	Object.defineProperty(exports, "map", { enumerable: true, get: function () { return map_1.map; } });
	var mapTo_1 = __webpack_require__(575);
	Object.defineProperty(exports, "mapTo", { enumerable: true, get: function () { return mapTo_1.mapTo; } });
	var materialize_1 = __webpack_require__(2062);
	Object.defineProperty(exports, "materialize", { enumerable: true, get: function () { return materialize_1.materialize; } });
	var max_1 = __webpack_require__(2063);
	Object.defineProperty(exports, "max", { enumerable: true, get: function () { return max_1.max; } });
	var mergeAll_1 = __webpack_require__(225);
	Object.defineProperty(exports, "mergeAll", { enumerable: true, get: function () { return mergeAll_1.mergeAll; } });
	var flatMap_1 = __webpack_require__(2058);
	Object.defineProperty(exports, "flatMap", { enumerable: true, get: function () { return flatMap_1.flatMap; } });
	var mergeMap_1 = __webpack_require__(98);
	Object.defineProperty(exports, "mergeMap", { enumerable: true, get: function () { return mergeMap_1.mergeMap; } });
	var mergeMapTo_1 = __webpack_require__(2065);
	Object.defineProperty(exports, "mergeMapTo", { enumerable: true, get: function () { return mergeMapTo_1.mergeMapTo; } });
	var mergeScan_1 = __webpack_require__(2066);
	Object.defineProperty(exports, "mergeScan", { enumerable: true, get: function () { return mergeScan_1.mergeScan; } });
	var mergeWith_1 = __webpack_require__(2067);
	Object.defineProperty(exports, "mergeWith", { enumerable: true, get: function () { return mergeWith_1.mergeWith; } });
	var min_1 = __webpack_require__(2068);
	Object.defineProperty(exports, "min", { enumerable: true, get: function () { return min_1.min; } });
	var multicast_1 = __webpack_require__(333);
	Object.defineProperty(exports, "multicast", { enumerable: true, get: function () { return multicast_1.multicast; } });
	var observeOn_1 = __webpack_require__(226);
	Object.defineProperty(exports, "observeOn", { enumerable: true, get: function () { return observeOn_1.observeOn; } });
	var pairwise_1 = __webpack_require__(2070);
	Object.defineProperty(exports, "pairwise", { enumerable: true, get: function () { return pairwise_1.pairwise; } });
	var pluck_1 = __webpack_require__(2071);
	Object.defineProperty(exports, "pluck", { enumerable: true, get: function () { return pluck_1.pluck; } });
	var publish_1 = __webpack_require__(2072);
	Object.defineProperty(exports, "publish", { enumerable: true, get: function () { return publish_1.publish; } });
	var publishBehavior_1 = __webpack_require__(2073);
	Object.defineProperty(exports, "publishBehavior", { enumerable: true, get: function () { return publishBehavior_1.publishBehavior; } });
	var publishLast_1 = __webpack_require__(2074);
	Object.defineProperty(exports, "publishLast", { enumerable: true, get: function () { return publishLast_1.publishLast; } });
	var publishReplay_1 = __webpack_require__(2075);
	Object.defineProperty(exports, "publishReplay", { enumerable: true, get: function () { return publishReplay_1.publishReplay; } });
	var raceWith_1 = __webpack_require__(2076);
	Object.defineProperty(exports, "raceWith", { enumerable: true, get: function () { return raceWith_1.raceWith; } });
	var reduce_1 = __webpack_require__(166);
	Object.defineProperty(exports, "reduce", { enumerable: true, get: function () { return reduce_1.reduce; } });
	var repeat_1 = __webpack_require__(2077);
	Object.defineProperty(exports, "repeat", { enumerable: true, get: function () { return repeat_1.repeat; } });
	var repeatWhen_1 = __webpack_require__(2078);
	Object.defineProperty(exports, "repeatWhen", { enumerable: true, get: function () { return repeatWhen_1.repeatWhen; } });
	var retry_1 = __webpack_require__(2079);
	Object.defineProperty(exports, "retry", { enumerable: true, get: function () { return retry_1.retry; } });
	var retryWhen_1 = __webpack_require__(2080);
	Object.defineProperty(exports, "retryWhen", { enumerable: true, get: function () { return retryWhen_1.retryWhen; } });
	var refCount_1 = __webpack_require__(576);
	Object.defineProperty(exports, "refCount", { enumerable: true, get: function () { return refCount_1.refCount; } });
	var sample_1 = __webpack_require__(577);
	Object.defineProperty(exports, "sample", { enumerable: true, get: function () { return sample_1.sample; } });
	var sampleTime_1 = __webpack_require__(2081);
	Object.defineProperty(exports, "sampleTime", { enumerable: true, get: function () { return sampleTime_1.sampleTime; } });
	var scan_1 = __webpack_require__(2082);
	Object.defineProperty(exports, "scan", { enumerable: true, get: function () { return scan_1.scan; } });
	var sequenceEqual_1 = __webpack_require__(2083);
	Object.defineProperty(exports, "sequenceEqual", { enumerable: true, get: function () { return sequenceEqual_1.sequenceEqual; } });
	var share_1 = __webpack_require__(579);
	Object.defineProperty(exports, "share", { enumerable: true, get: function () { return share_1.share; } });
	var shareReplay_1 = __webpack_require__(2084);
	Object.defineProperty(exports, "shareReplay", { enumerable: true, get: function () { return shareReplay_1.shareReplay; } });
	var single_1 = __webpack_require__(2085);
	Object.defineProperty(exports, "single", { enumerable: true, get: function () { return single_1.single; } });
	var skip_1 = __webpack_require__(2086);
	Object.defineProperty(exports, "skip", { enumerable: true, get: function () { return skip_1.skip; } });
	var skipLast_1 = __webpack_require__(2087);
	Object.defineProperty(exports, "skipLast", { enumerable: true, get: function () { return skipLast_1.skipLast; } });
	var skipUntil_1 = __webpack_require__(2088);
	Object.defineProperty(exports, "skipUntil", { enumerable: true, get: function () { return skipUntil_1.skipUntil; } });
	var skipWhile_1 = __webpack_require__(2089);
	Object.defineProperty(exports, "skipWhile", { enumerable: true, get: function () { return skipWhile_1.skipWhile; } });
	var startWith_1 = __webpack_require__(2090);
	Object.defineProperty(exports, "startWith", { enumerable: true, get: function () { return startWith_1.startWith; } });
	var subscribeOn_1 = __webpack_require__(227);
	Object.defineProperty(exports, "subscribeOn", { enumerable: true, get: function () { return subscribeOn_1.subscribeOn; } });
	var switchAll_1 = __webpack_require__(2091);
	Object.defineProperty(exports, "switchAll", { enumerable: true, get: function () { return switchAll_1.switchAll; } });
	var switchMap_1 = __webpack_require__(228);
	Object.defineProperty(exports, "switchMap", { enumerable: true, get: function () { return switchMap_1.switchMap; } });
	var switchMapTo_1 = __webpack_require__(2092);
	Object.defineProperty(exports, "switchMapTo", { enumerable: true, get: function () { return switchMapTo_1.switchMapTo; } });
	var switchScan_1 = __webpack_require__(2093);
	Object.defineProperty(exports, "switchScan", { enumerable: true, get: function () { return switchScan_1.switchScan; } });
	var take_1 = __webpack_require__(167);
	Object.defineProperty(exports, "take", { enumerable: true, get: function () { return take_1.take; } });
	var takeLast_1 = __webpack_require__(580);
	Object.defineProperty(exports, "takeLast", { enumerable: true, get: function () { return takeLast_1.takeLast; } });
	var takeUntil_1 = __webpack_require__(2094);
	Object.defineProperty(exports, "takeUntil", { enumerable: true, get: function () { return takeUntil_1.takeUntil; } });
	var takeWhile_1 = __webpack_require__(2095);
	Object.defineProperty(exports, "takeWhile", { enumerable: true, get: function () { return takeWhile_1.takeWhile; } });
	var tap_1 = __webpack_require__(2096);
	Object.defineProperty(exports, "tap", { enumerable: true, get: function () { return tap_1.tap; } });
	var throttle_1 = __webpack_require__(581);
	Object.defineProperty(exports, "throttle", { enumerable: true, get: function () { return throttle_1.throttle; } });
	var throttleTime_1 = __webpack_require__(2097);
	Object.defineProperty(exports, "throttleTime", { enumerable: true, get: function () { return throttleTime_1.throttleTime; } });
	var throwIfEmpty_1 = __webpack_require__(229);
	Object.defineProperty(exports, "throwIfEmpty", { enumerable: true, get: function () { return throwIfEmpty_1.throwIfEmpty; } });
	var timeInterval_1 = __webpack_require__(2098);
	Object.defineProperty(exports, "timeInterval", { enumerable: true, get: function () { return timeInterval_1.timeInterval; } });
	var timeout_2 = __webpack_require__(334);
	Object.defineProperty(exports, "timeout", { enumerable: true, get: function () { return timeout_2.timeout; } });
	var timeoutWith_1 = __webpack_require__(2099);
	Object.defineProperty(exports, "timeoutWith", { enumerable: true, get: function () { return timeoutWith_1.timeoutWith; } });
	var timestamp_1 = __webpack_require__(2100);
	Object.defineProperty(exports, "timestamp", { enumerable: true, get: function () { return timestamp_1.timestamp; } });
	var toArray_1 = __webpack_require__(582);
	Object.defineProperty(exports, "toArray", { enumerable: true, get: function () { return toArray_1.toArray; } });
	var window_1 = __webpack_require__(2101);
	Object.defineProperty(exports, "window", { enumerable: true, get: function () { return window_1.window; } });
	var windowCount_1 = __webpack_require__(2102);
	Object.defineProperty(exports, "windowCount", { enumerable: true, get: function () { return windowCount_1.windowCount; } });
	var windowTime_1 = __webpack_require__(2103);
	Object.defineProperty(exports, "windowTime", { enumerable: true, get: function () { return windowTime_1.windowTime; } });
	var windowToggle_1 = __webpack_require__(2104);
	Object.defineProperty(exports, "windowToggle", { enumerable: true, get: function () { return windowToggle_1.windowToggle; } });
	var windowWhen_1 = __webpack_require__(2105);
	Object.defineProperty(exports, "windowWhen", { enumerable: true, get: function () { return windowWhen_1.windowWhen; } });
	var withLatestFrom_1 = __webpack_require__(2106);
	Object.defineProperty(exports, "withLatestFrom", { enumerable: true, get: function () { return withLatestFrom_1.withLatestFrom; } });
	var zipAll_1 = __webpack_require__(2108);
	Object.defineProperty(exports, "zipAll", { enumerable: true, get: function () { return zipAll_1.zipAll; } });
	var zipWith_1 = __webpack_require__(2109);
	Object.defineProperty(exports, "zipWith", { enumerable: true, get: function () { return zipWith_1.zipWith; } });
	//# sourceMappingURL=index.js.map

/***/ },
/* 2010 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.createNotification = exports.nextNotification = exports.errorNotification = exports.COMPLETE_NOTIFICATION = void 0;
	exports.COMPLETE_NOTIFICATION = (function () { return createNotification('C', undefined, undefined); })();
	function errorNotification(error) {
	    return createNotification('E', undefined, error);
	}
	exports.errorNotification = errorNotification;
	function nextNotification(value) {
	    return createNotification('N', value, undefined);
	}
	exports.nextNotification = nextNotification;
	function createNotification(kind, value, error) {
	    return {
	        kind: kind,
	        value: value,
	        error: error,
	    };
	}
	exports.createNotification = createNotification;
	//# sourceMappingURL=NotificationFactories.js.map

/***/ },
/* 2011 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.firstValueFrom = void 0;
	var EmptyError_1 = __webpack_require__(115);
	var Subscriber_1 = __webpack_require__(164);
	function firstValueFrom(source, config) {
	    var hasConfig = typeof config === 'object';
	    return new Promise(function (resolve, reject) {
	        var subscriber = new Subscriber_1.SafeSubscriber({
	            next: function (value) {
	                resolve(value);
	                subscriber.unsubscribe();
	            },
	            error: reject,
	            complete: function () {
	                if (hasConfig) {
	                    resolve(config.defaultValue);
	                }
	                else {
	                    reject(new EmptyError_1.EmptyError());
	                }
	            },
	        });
	        source.subscribe(subscriber);
	    });
	}
	exports.firstValueFrom = firstValueFrom;
	//# sourceMappingURL=firstValueFrom.js.map

/***/ },
/* 2012 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.lastValueFrom = void 0;
	var EmptyError_1 = __webpack_require__(115);
	function lastValueFrom(source, config) {
	    var hasConfig = typeof config === 'object';
	    return new Promise(function (resolve, reject) {
	        var _hasValue = false;
	        var _value;
	        source.subscribe({
	            next: function (value) {
	                _value = value;
	                _hasValue = true;
	            },
	            error: reject,
	            complete: function () {
	                if (_hasValue) {
	                    resolve(_value);
	                }
	                else if (hasConfig) {
	                    resolve(config.defaultValue);
	                }
	                else {
	                    reject(new EmptyError_1.EmptyError());
	                }
	            },
	        });
	    });
	}
	exports.lastValueFrom = lastValueFrom;
	//# sourceMappingURL=lastValueFrom.js.map

/***/ },
/* 2013 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.bindCallback = void 0;
	var bindCallbackInternals_1 = __webpack_require__(561);
	function bindCallback(callbackFunc, resultSelector, scheduler) {
	    return bindCallbackInternals_1.bindCallbackInternals(false, callbackFunc, resultSelector, scheduler);
	}
	exports.bindCallback = bindCallback;
	//# sourceMappingURL=bindCallback.js.map

/***/ },
/* 2014 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.bindNodeCallback = void 0;
	var bindCallbackInternals_1 = __webpack_require__(561);
	function bindNodeCallback(callbackFunc, resultSelector, scheduler) {
	    return bindCallbackInternals_1.bindCallbackInternals(true, callbackFunc, resultSelector, scheduler);
	}
	exports.bindNodeCallback = bindNodeCallback;
	//# sourceMappingURL=bindNodeCallback.js.map

/***/ },
/* 2015 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.connectable = void 0;
	var Subject_1 = __webpack_require__(51);
	var Observable_1 = __webpack_require__(34);
	var defer_1 = __webpack_require__(223);
	var DEFAULT_CONFIG = {
	    connector: function () { return new Subject_1.Subject(); },
	    resetOnDisconnect: true,
	};
	function connectable(source, config) {
	    if (config === void 0) { config = DEFAULT_CONFIG; }
	    var connection = null;
	    var connector = config.connector, _a = config.resetOnDisconnect, resetOnDisconnect = _a === void 0 ? true : _a;
	    var subject = connector();
	    var result = new Observable_1.Observable(function (subscriber) {
	        return subject.subscribe(subscriber);
	    });
	    result.connect = function () {
	        if (!connection || connection.closed) {
	            connection = defer_1.defer(function () { return source; }).subscribe(subject);
	            if (resetOnDisconnect) {
	                connection.add(function () { return (subject = connector()); });
	            }
	        }
	        return connection;
	    };
	    return result;
	}
	exports.connectable = connectable;
	//# sourceMappingURL=connectable.js.map

/***/ },
/* 2016 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.animationFrames = void 0;
	var Observable_1 = __webpack_require__(34);
	var Subscription_1 = __webpack_require__(62);
	var performanceTimestampProvider_1 = __webpack_require__(2126);
	var animationFrameProvider_1 = __webpack_require__(586);
	function animationFrames(timestampProvider) {
	    return timestampProvider ? animationFramesFactory(timestampProvider) : DEFAULT_ANIMATION_FRAMES;
	}
	exports.animationFrames = animationFrames;
	function animationFramesFactory(timestampProvider) {
	    var schedule = animationFrameProvider_1.animationFrameProvider.schedule;
	    return new Observable_1.Observable(function (subscriber) {
	        var subscription = new Subscription_1.Subscription();
	        var provider = timestampProvider || performanceTimestampProvider_1.performanceTimestampProvider;
	        var start = provider.now();
	        var run = function (timestamp) {
	            var now = provider.now();
	            subscriber.next({
	                timestamp: timestampProvider ? now : timestamp,
	                elapsed: now - start,
	            });
	            if (!subscriber.closed) {
	                subscription.add(schedule(run));
	            }
	        };
	        subscription.add(schedule(run));
	        return subscription;
	    });
	}
	var DEFAULT_ANIMATION_FRAMES = animationFramesFactory();
	//# sourceMappingURL=animationFrames.js.map

/***/ },
/* 2017 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.forkJoin = void 0;
	var Observable_1 = __webpack_require__(34);
	var argsArgArrayOrObject_1 = __webpack_require__(594);
	var innerFrom_1 = __webpack_require__(28);
	var args_1 = __webpack_require__(64);
	var OperatorSubscriber_1 = __webpack_require__(20);
	var mapOneOrManyArgs_1 = __webpack_require__(117);
	var createObject_1 = __webpack_require__(595);
	function forkJoin() {
	    var args = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        args[_i] = arguments[_i];
	    }
	    var resultSelector = args_1.popResultSelector(args);
	    var _a = argsArgArrayOrObject_1.argsArgArrayOrObject(args), sources = _a.args, keys = _a.keys;
	    var result = new Observable_1.Observable(function (subscriber) {
	        var length = sources.length;
	        if (!length) {
	            subscriber.complete();
	            return;
	        }
	        var values = new Array(length);
	        var remainingCompletions = length;
	        var remainingEmissions = length;
	        var _loop_1 = function (sourceIndex) {
	            var hasValue = false;
	            innerFrom_1.innerFrom(sources[sourceIndex]).subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (value) {
	                if (!hasValue) {
	                    hasValue = true;
	                    remainingEmissions--;
	                }
	                values[sourceIndex] = value;
	            }, function () { return remainingCompletions--; }, undefined, function () {
	                if (!remainingCompletions || !hasValue) {
	                    if (!remainingEmissions) {
	                        subscriber.next(keys ? createObject_1.createObject(keys, values) : values);
	                    }
	                    subscriber.complete();
	                }
	            }));
	        };
	        for (var sourceIndex = 0; sourceIndex < length; sourceIndex++) {
	            _loop_1(sourceIndex);
	        }
	    });
	    return resultSelector ? result.pipe(mapOneOrManyArgs_1.mapOneOrManyArgs(resultSelector)) : result;
	}
	exports.forkJoin = forkJoin;
	//# sourceMappingURL=forkJoin.js.map

/***/ },
/* 2018 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.fromEvent = void 0;
	var innerFrom_1 = __webpack_require__(28);
	var Observable_1 = __webpack_require__(34);
	var mergeMap_1 = __webpack_require__(98);
	var isArrayLike_1 = __webpack_require__(337);
	var isFunction_1 = __webpack_require__(31);
	var mapOneOrManyArgs_1 = __webpack_require__(117);
	var nodeEventEmitterMethods = ['addListener', 'removeListener'];
	var eventTargetMethods = ['addEventListener', 'removeEventListener'];
	var jqueryMethods = ['on', 'off'];
	function fromEvent(target, eventName, options, resultSelector) {
	    if (isFunction_1.isFunction(options)) {
	        resultSelector = options;
	        options = undefined;
	    }
	    if (resultSelector) {
	        return fromEvent(target, eventName, options).pipe(mapOneOrManyArgs_1.mapOneOrManyArgs(resultSelector));
	    }
	    var _a = __read(isEventTarget(target)
	        ? eventTargetMethods.map(function (methodName) { return function (handler) { return target[methodName](eventName, handler, options); }; })
	        :
	            isNodeStyleEventEmitter(target)
	                ? nodeEventEmitterMethods.map(toCommonHandlerRegistry(target, eventName))
	                : isJQueryStyleEventEmitter(target)
	                    ? jqueryMethods.map(toCommonHandlerRegistry(target, eventName))
	                    : [], 2), add = _a[0], remove = _a[1];
	    if (!add) {
	        if (isArrayLike_1.isArrayLike(target)) {
	            return mergeMap_1.mergeMap(function (subTarget) { return fromEvent(subTarget, eventName, options); })(innerFrom_1.innerFrom(target));
	        }
	    }
	    if (!add) {
	        throw new TypeError('Invalid event target');
	    }
	    return new Observable_1.Observable(function (subscriber) {
	        var handler = function () {
	            var args = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                args[_i] = arguments[_i];
	            }
	            return subscriber.next(1 < args.length ? args : args[0]);
	        };
	        add(handler);
	        return function () { return remove(handler); };
	    });
	}
	exports.fromEvent = fromEvent;
	function toCommonHandlerRegistry(target, eventName) {
	    return function (methodName) { return function (handler) { return target[methodName](eventName, handler); }; };
	}
	function isNodeStyleEventEmitter(target) {
	    return isFunction_1.isFunction(target.addListener) && isFunction_1.isFunction(target.removeListener);
	}
	function isJQueryStyleEventEmitter(target) {
	    return isFunction_1.isFunction(target.on) && isFunction_1.isFunction(target.off);
	}
	function isEventTarget(target) {
	    return isFunction_1.isFunction(target.addEventListener) && isFunction_1.isFunction(target.removeEventListener);
	}
	//# sourceMappingURL=fromEvent.js.map

/***/ },
/* 2019 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.fromEventPattern = void 0;
	var Observable_1 = __webpack_require__(34);
	var isFunction_1 = __webpack_require__(31);
	var mapOneOrManyArgs_1 = __webpack_require__(117);
	function fromEventPattern(addHandler, removeHandler, resultSelector) {
	    if (resultSelector) {
	        return fromEventPattern(addHandler, removeHandler).pipe(mapOneOrManyArgs_1.mapOneOrManyArgs(resultSelector));
	    }
	    return new Observable_1.Observable(function (subscriber) {
	        var handler = function () {
	            var e = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                e[_i] = arguments[_i];
	            }
	            return subscriber.next(e.length === 1 ? e[0] : e);
	        };
	        var retValue = addHandler(handler);
	        return isFunction_1.isFunction(removeHandler) ? function () { return removeHandler(handler, retValue); } : undefined;
	    });
	}
	exports.fromEventPattern = fromEventPattern;
	//# sourceMappingURL=fromEventPattern.js.map

/***/ },
/* 2020 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.fromSubscribable = void 0;
	var Observable_1 = __webpack_require__(34);
	function fromSubscribable(subscribable) {
	    return new Observable_1.Observable(function (subscriber) { return subscribable.subscribe(subscriber); });
	}
	exports.fromSubscribable = fromSubscribable;
	//# sourceMappingURL=fromSubscribable.js.map

/***/ },
/* 2021 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __generator = (this && this.__generator) || function (thisArg, body) {
	    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
	    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
	    function verb(n) { return function (v) { return step([n, v]); }; }
	    function step(op) {
	        if (f) throw new TypeError("Generator is already executing.");
	        while (_) try {
	            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
	            if (y = 0, t) op = [op[0] & 2, t.value];
	            switch (op[0]) {
	                case 0: case 1: t = op; break;
	                case 4: _.label++; return { value: op[1], done: false };
	                case 5: _.label++; y = op[1]; op = [0]; continue;
	                case 7: op = _.ops.pop(); _.trys.pop(); continue;
	                default:
	                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
	                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
	                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
	                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
	                    if (t[2]) _.ops.pop();
	                    _.trys.pop(); continue;
	            }
	            op = body.call(thisArg, _);
	        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
	        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
	    }
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.generate = void 0;
	var identity_1 = __webpack_require__(56);
	var isScheduler_1 = __webpack_require__(231);
	var defer_1 = __webpack_require__(223);
	var scheduleIterable_1 = __webpack_require__(584);
	function generate(initialStateOrOptions, condition, iterate, resultSelectorOrScheduler, scheduler) {
	    var _a, _b;
	    var resultSelector;
	    var initialState;
	    if (arguments.length === 1) {
	        (_a = initialStateOrOptions, initialState = _a.initialState, condition = _a.condition, iterate = _a.iterate, _b = _a.resultSelector, resultSelector = _b === void 0 ? identity_1.identity : _b, scheduler = _a.scheduler);
	    }
	    else {
	        initialState = initialStateOrOptions;
	        if (!resultSelectorOrScheduler || isScheduler_1.isScheduler(resultSelectorOrScheduler)) {
	            resultSelector = identity_1.identity;
	            scheduler = resultSelectorOrScheduler;
	        }
	        else {
	            resultSelector = resultSelectorOrScheduler;
	        }
	    }
	    function gen() {
	        var state;
	        return __generator(this, function (_a) {
	            switch (_a.label) {
	                case 0:
	                    state = initialState;
	                    _a.label = 1;
	                case 1:
	                    if (!(!condition || condition(state))) return [3, 4];
	                    return [4, resultSelector(state)];
	                case 2:
	                    _a.sent();
	                    _a.label = 3;
	                case 3:
	                    state = iterate(state);
	                    return [3, 1];
	                case 4: return [2];
	            }
	        });
	    }
	    return defer_1.defer((scheduler
	        ?
	            function () { return scheduleIterable_1.scheduleIterable(gen(), scheduler); }
	        :
	            gen));
	}
	exports.generate = generate;
	//# sourceMappingURL=generate.js.map

/***/ },
/* 2022 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.iif = void 0;
	var defer_1 = __webpack_require__(223);
	function iif(condition, trueResult, falseResult) {
	    return defer_1.defer(function () { return (condition() ? trueResult : falseResult); });
	}
	exports.iif = iif;
	//# sourceMappingURL=iif.js.map

/***/ },
/* 2023 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.merge = void 0;
	var mergeAll_1 = __webpack_require__(225);
	var innerFrom_1 = __webpack_require__(28);
	var empty_1 = __webpack_require__(74);
	var args_1 = __webpack_require__(64);
	var from_1 = __webpack_require__(78);
	function merge() {
	    var args = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        args[_i] = arguments[_i];
	    }
	    var scheduler = args_1.popScheduler(args);
	    var concurrent = args_1.popNumber(args, Infinity);
	    var sources = args;
	    return !sources.length
	        ?
	            empty_1.EMPTY
	        : sources.length === 1
	            ?
	                innerFrom_1.innerFrom(sources[0])
	            :
	                mergeAll_1.mergeAll(concurrent)(from_1.from(sources, scheduler));
	}
	exports.merge = merge;
	//# sourceMappingURL=merge.js.map

/***/ },
/* 2024 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.onErrorResumeNext = void 0;
	var empty_1 = __webpack_require__(74);
	var onErrorResumeNext_1 = __webpack_require__(2069);
	var argsOrArgArray_1 = __webpack_require__(137);
	function onErrorResumeNext() {
	    var sources = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        sources[_i] = arguments[_i];
	    }
	    return onErrorResumeNext_1.onErrorResumeNext(argsOrArgArray_1.argsOrArgArray(sources))(empty_1.EMPTY);
	}
	exports.onErrorResumeNext = onErrorResumeNext;
	//# sourceMappingURL=onErrorResumeNext.js.map

/***/ },
/* 2025 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.pairs = void 0;
	var from_1 = __webpack_require__(78);
	function pairs(obj, scheduler) {
	    return from_1.from(Object.entries(obj), scheduler);
	}
	exports.pairs = pairs;
	//# sourceMappingURL=pairs.js.map

/***/ },
/* 2026 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.partition = void 0;
	var not_1 = __webpack_require__(2131);
	var filter_1 = __webpack_require__(136);
	var innerFrom_1 = __webpack_require__(28);
	function partition(source, predicate, thisArg) {
	    return [filter_1.filter(predicate, thisArg)(innerFrom_1.innerFrom(source)), filter_1.filter(not_1.not(predicate, thisArg))(innerFrom_1.innerFrom(source))];
	}
	exports.partition = partition;
	//# sourceMappingURL=partition.js.map

/***/ },
/* 2027 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.range = void 0;
	var Observable_1 = __webpack_require__(34);
	var empty_1 = __webpack_require__(74);
	function range(start, count, scheduler) {
	    if (count == null) {
	        count = start;
	        start = 0;
	    }
	    if (count <= 0) {
	        return empty_1.EMPTY;
	    }
	    var end = count + start;
	    return new Observable_1.Observable(scheduler
	        ?
	            function (subscriber) {
	                var n = start;
	                return scheduler.schedule(function () {
	                    if (n < end) {
	                        subscriber.next(n++);
	                        this.schedule();
	                    }
	                    else {
	                        subscriber.complete();
	                    }
	                });
	            }
	        :
	            function (subscriber) {
	                var n = start;
	                while (n < end && !subscriber.closed) {
	                    subscriber.next(n++);
	                }
	                subscriber.complete();
	            });
	}
	exports.range = range;
	//# sourceMappingURL=range.js.map

/***/ },
/* 2028 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.using = void 0;
	var Observable_1 = __webpack_require__(34);
	var innerFrom_1 = __webpack_require__(28);
	var empty_1 = __webpack_require__(74);
	function using(resourceFactory, observableFactory) {
	    return new Observable_1.Observable(function (subscriber) {
	        var resource = resourceFactory();
	        var result = observableFactory(resource);
	        var source = result ? innerFrom_1.innerFrom(result) : empty_1.EMPTY;
	        source.subscribe(subscriber);
	        return function () {
	            if (resource) {
	                resource.unsubscribe();
	            }
	        };
	    });
	}
	exports.using = using;
	//# sourceMappingURL=using.js.map

/***/ },
/* 2029 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.auditTime = void 0;
	var async_1 = __webpack_require__(63);
	var audit_1 = __webpack_require__(566);
	var timer_1 = __webpack_require__(113);
	function auditTime(duration, scheduler) {
	    if (scheduler === void 0) { scheduler = async_1.asyncScheduler; }
	    return audit_1.audit(function () { return timer_1.timer(duration, scheduler); });
	}
	exports.auditTime = auditTime;
	//# sourceMappingURL=auditTime.js.map

/***/ },
/* 2030 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.buffer = void 0;
	var lift_1 = __webpack_require__(17);
	var noop_1 = __webpack_require__(52);
	var OperatorSubscriber_1 = __webpack_require__(20);
	function buffer(closingNotifier) {
	    return lift_1.operate(function (source, subscriber) {
	        var currentBuffer = [];
	        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (value) { return currentBuffer.push(value); }, function () {
	            subscriber.next(currentBuffer);
	            subscriber.complete();
	        }));
	        closingNotifier.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function () {
	            var b = currentBuffer;
	            currentBuffer = [];
	            subscriber.next(b);
	        }, noop_1.noop));
	        return function () {
	            currentBuffer = null;
	        };
	    });
	}
	exports.buffer = buffer;
	//# sourceMappingURL=buffer.js.map

/***/ },
/* 2031 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __values = (this && this.__values) || function(o) {
	    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
	    if (m) return m.call(o);
	    if (o && typeof o.length === "number") return {
	        next: function () {
	            if (o && i >= o.length) o = void 0;
	            return { value: o && o[i++], done: !o };
	        }
	    };
	    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.bufferCount = void 0;
	var lift_1 = __webpack_require__(17);
	var OperatorSubscriber_1 = __webpack_require__(20);
	var arrRemove_1 = __webpack_require__(99);
	function bufferCount(bufferSize, startBufferEvery) {
	    if (startBufferEvery === void 0) { startBufferEvery = null; }
	    startBufferEvery = startBufferEvery !== null && startBufferEvery !== void 0 ? startBufferEvery : bufferSize;
	    return lift_1.operate(function (source, subscriber) {
	        var buffers = [];
	        var count = 0;
	        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (value) {
	            var e_1, _a, e_2, _b;
	            var toEmit = null;
	            if (count++ % startBufferEvery === 0) {
	                buffers.push([]);
	            }
	            try {
	                for (var buffers_1 = __values(buffers), buffers_1_1 = buffers_1.next(); !buffers_1_1.done; buffers_1_1 = buffers_1.next()) {
	                    var buffer = buffers_1_1.value;
	                    buffer.push(value);
	                    if (bufferSize <= buffer.length) {
	                        toEmit = toEmit !== null && toEmit !== void 0 ? toEmit : [];
	                        toEmit.push(buffer);
	                    }
	                }
	            }
	            catch (e_1_1) { e_1 = { error: e_1_1 }; }
	            finally {
	                try {
	                    if (buffers_1_1 && !buffers_1_1.done && (_a = buffers_1.return)) _a.call(buffers_1);
	                }
	                finally { if (e_1) throw e_1.error; }
	            }
	            if (toEmit) {
	                try {
	                    for (var toEmit_1 = __values(toEmit), toEmit_1_1 = toEmit_1.next(); !toEmit_1_1.done; toEmit_1_1 = toEmit_1.next()) {
	                        var buffer = toEmit_1_1.value;
	                        arrRemove_1.arrRemove(buffers, buffer);
	                        subscriber.next(buffer);
	                    }
	                }
	                catch (e_2_1) { e_2 = { error: e_2_1 }; }
	                finally {
	                    try {
	                        if (toEmit_1_1 && !toEmit_1_1.done && (_b = toEmit_1.return)) _b.call(toEmit_1);
	                    }
	                    finally { if (e_2) throw e_2.error; }
	                }
	            }
	        }, function () {
	            var e_3, _a;
	            try {
	                for (var buffers_2 = __values(buffers), buffers_2_1 = buffers_2.next(); !buffers_2_1.done; buffers_2_1 = buffers_2.next()) {
	                    var buffer = buffers_2_1.value;
	                    subscriber.next(buffer);
	                }
	            }
	            catch (e_3_1) { e_3 = { error: e_3_1 }; }
	            finally {
	                try {
	                    if (buffers_2_1 && !buffers_2_1.done && (_a = buffers_2.return)) _a.call(buffers_2);
	                }
	                finally { if (e_3) throw e_3.error; }
	            }
	            subscriber.complete();
	        }, undefined, function () {
	            buffers = null;
	        }));
	    });
	}
	exports.bufferCount = bufferCount;
	//# sourceMappingURL=bufferCount.js.map

/***/ },
/* 2032 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __values = (this && this.__values) || function(o) {
	    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
	    if (m) return m.call(o);
	    if (o && typeof o.length === "number") return {
	        next: function () {
	            if (o && i >= o.length) o = void 0;
	            return { value: o && o[i++], done: !o };
	        }
	    };
	    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.bufferTime = void 0;
	var Subscription_1 = __webpack_require__(62);
	var lift_1 = __webpack_require__(17);
	var OperatorSubscriber_1 = __webpack_require__(20);
	var arrRemove_1 = __webpack_require__(99);
	var async_1 = __webpack_require__(63);
	var args_1 = __webpack_require__(64);
	var executeSchedule_1 = __webpack_require__(100);
	function bufferTime(bufferTimeSpan) {
	    var _a, _b;
	    var otherArgs = [];
	    for (var _i = 1; _i < arguments.length; _i++) {
	        otherArgs[_i - 1] = arguments[_i];
	    }
	    var scheduler = (_a = args_1.popScheduler(otherArgs)) !== null && _a !== void 0 ? _a : async_1.asyncScheduler;
	    var bufferCreationInterval = (_b = otherArgs[0]) !== null && _b !== void 0 ? _b : null;
	    var maxBufferSize = otherArgs[1] || Infinity;
	    return lift_1.operate(function (source, subscriber) {
	        var bufferRecords = [];
	        var restartOnEmit = false;
	        var emit = function (record) {
	            var buffer = record.buffer, subs = record.subs;
	            subs.unsubscribe();
	            arrRemove_1.arrRemove(bufferRecords, record);
	            subscriber.next(buffer);
	            restartOnEmit && startBuffer();
	        };
	        var startBuffer = function () {
	            if (bufferRecords) {
	                var subs = new Subscription_1.Subscription();
	                subscriber.add(subs);
	                var buffer = [];
	                var record_1 = {
	                    buffer: buffer,
	                    subs: subs,
	                };
	                bufferRecords.push(record_1);
	                executeSchedule_1.executeSchedule(subs, scheduler, function () { return emit(record_1); }, bufferTimeSpan);
	            }
	        };
	        if (bufferCreationInterval !== null && bufferCreationInterval >= 0) {
	            executeSchedule_1.executeSchedule(subscriber, scheduler, startBuffer, bufferCreationInterval, true);
	        }
	        else {
	            restartOnEmit = true;
	        }
	        startBuffer();
	        var bufferTimeSubscriber = OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (value) {
	            var e_1, _a;
	            var recordsCopy = bufferRecords.slice();
	            try {
	                for (var recordsCopy_1 = __values(recordsCopy), recordsCopy_1_1 = recordsCopy_1.next(); !recordsCopy_1_1.done; recordsCopy_1_1 = recordsCopy_1.next()) {
	                    var record = recordsCopy_1_1.value;
	                    var buffer = record.buffer;
	                    buffer.push(value);
	                    maxBufferSize <= buffer.length && emit(record);
	                }
	            }
	            catch (e_1_1) { e_1 = { error: e_1_1 }; }
	            finally {
	                try {
	                    if (recordsCopy_1_1 && !recordsCopy_1_1.done && (_a = recordsCopy_1.return)) _a.call(recordsCopy_1);
	                }
	                finally { if (e_1) throw e_1.error; }
	            }
	        }, function () {
	            while (bufferRecords === null || bufferRecords === void 0 ? void 0 : bufferRecords.length) {
	                subscriber.next(bufferRecords.shift().buffer);
	            }
	            bufferTimeSubscriber === null || bufferTimeSubscriber === void 0 ? void 0 : bufferTimeSubscriber.unsubscribe();
	            subscriber.complete();
	            subscriber.unsubscribe();
	        }, undefined, function () { return (bufferRecords = null); });
	        source.subscribe(bufferTimeSubscriber);
	    });
	}
	exports.bufferTime = bufferTime;
	//# sourceMappingURL=bufferTime.js.map

/***/ },
/* 2033 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __values = (this && this.__values) || function(o) {
	    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
	    if (m) return m.call(o);
	    if (o && typeof o.length === "number") return {
	        next: function () {
	            if (o && i >= o.length) o = void 0;
	            return { value: o && o[i++], done: !o };
	        }
	    };
	    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.bufferToggle = void 0;
	var Subscription_1 = __webpack_require__(62);
	var lift_1 = __webpack_require__(17);
	var innerFrom_1 = __webpack_require__(28);
	var OperatorSubscriber_1 = __webpack_require__(20);
	var noop_1 = __webpack_require__(52);
	var arrRemove_1 = __webpack_require__(99);
	function bufferToggle(openings, closingSelector) {
	    return lift_1.operate(function (source, subscriber) {
	        var buffers = [];
	        innerFrom_1.innerFrom(openings).subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (openValue) {
	            var buffer = [];
	            buffers.push(buffer);
	            var closingSubscription = new Subscription_1.Subscription();
	            var emitBuffer = function () {
	                arrRemove_1.arrRemove(buffers, buffer);
	                subscriber.next(buffer);
	                closingSubscription.unsubscribe();
	            };
	            closingSubscription.add(innerFrom_1.innerFrom(closingSelector(openValue)).subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, emitBuffer, noop_1.noop)));
	        }, noop_1.noop));
	        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (value) {
	            var e_1, _a;
	            try {
	                for (var buffers_1 = __values(buffers), buffers_1_1 = buffers_1.next(); !buffers_1_1.done; buffers_1_1 = buffers_1.next()) {
	                    var buffer = buffers_1_1.value;
	                    buffer.push(value);
	                }
	            }
	            catch (e_1_1) { e_1 = { error: e_1_1 }; }
	            finally {
	                try {
	                    if (buffers_1_1 && !buffers_1_1.done && (_a = buffers_1.return)) _a.call(buffers_1);
	                }
	                finally { if (e_1) throw e_1.error; }
	            }
	        }, function () {
	            while (buffers.length > 0) {
	                subscriber.next(buffers.shift());
	            }
	            subscriber.complete();
	        }));
	    });
	}
	exports.bufferToggle = bufferToggle;
	//# sourceMappingURL=bufferToggle.js.map

/***/ },
/* 2034 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.bufferWhen = void 0;
	var lift_1 = __webpack_require__(17);
	var noop_1 = __webpack_require__(52);
	var OperatorSubscriber_1 = __webpack_require__(20);
	var innerFrom_1 = __webpack_require__(28);
	function bufferWhen(closingSelector) {
	    return lift_1.operate(function (source, subscriber) {
	        var buffer = null;
	        var closingSubscriber = null;
	        var openBuffer = function () {
	            closingSubscriber === null || closingSubscriber === void 0 ? void 0 : closingSubscriber.unsubscribe();
	            var b = buffer;
	            buffer = [];
	            b && subscriber.next(b);
	            innerFrom_1.innerFrom(closingSelector()).subscribe((closingSubscriber = OperatorSubscriber_1.createOperatorSubscriber(subscriber, openBuffer, noop_1.noop)));
	        };
	        openBuffer();
	        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (value) { return buffer === null || buffer === void 0 ? void 0 : buffer.push(value); }, function () {
	            buffer && subscriber.next(buffer);
	            subscriber.complete();
	        }, undefined, function () { return (buffer = closingSubscriber = null); }));
	    });
	}
	exports.bufferWhen = bufferWhen;
	//# sourceMappingURL=bufferWhen.js.map

/***/ },
/* 2035 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.catchError = void 0;
	var innerFrom_1 = __webpack_require__(28);
	var OperatorSubscriber_1 = __webpack_require__(20);
	var lift_1 = __webpack_require__(17);
	function catchError(selector) {
	    return lift_1.operate(function (source, subscriber) {
	        var innerSub = null;
	        var syncUnsub = false;
	        var handledResult;
	        innerSub = source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, undefined, undefined, function (err) {
	            handledResult = innerFrom_1.innerFrom(selector(err, catchError(selector)(source)));
	            if (innerSub) {
	                innerSub.unsubscribe();
	                innerSub = null;
	                handledResult.subscribe(subscriber);
	            }
	            else {
	                syncUnsub = true;
	            }
	        }));
	        if (syncUnsub) {
	            innerSub.unsubscribe();
	            innerSub = null;
	            handledResult.subscribe(subscriber);
	        }
	    });
	}
	exports.catchError = catchError;
	//# sourceMappingURL=catchError.js.map

/***/ },
/* 2036 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.combineAll = void 0;
	var combineLatestAll_1 = __webpack_require__(567);
	exports.combineAll = combineLatestAll_1.combineLatestAll;
	//# sourceMappingURL=combineAll.js.map

/***/ },
/* 2037 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	var __spreadArray = (this && this.__spreadArray) || function (to, from) {
	    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
	        to[j] = from[i];
	    return to;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.combineLatest = void 0;
	var combineLatest_1 = __webpack_require__(327);
	var lift_1 = __webpack_require__(17);
	var argsOrArgArray_1 = __webpack_require__(137);
	var mapOneOrManyArgs_1 = __webpack_require__(117);
	var pipe_1 = __webpack_require__(232);
	var args_1 = __webpack_require__(64);
	function combineLatest() {
	    var args = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        args[_i] = arguments[_i];
	    }
	    var resultSelector = args_1.popResultSelector(args);
	    return resultSelector
	        ? pipe_1.pipe(combineLatest.apply(void 0, __spreadArray([], __read(args))), mapOneOrManyArgs_1.mapOneOrManyArgs(resultSelector))
	        : lift_1.operate(function (source, subscriber) {
	            combineLatest_1.combineLatestInit(__spreadArray([source], __read(argsOrArgArray_1.argsOrArgArray(args))))(subscriber);
	        });
	}
	exports.combineLatest = combineLatest;
	//# sourceMappingURL=combineLatest.js.map

/***/ },
/* 2038 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	var __spreadArray = (this && this.__spreadArray) || function (to, from) {
	    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
	        to[j] = from[i];
	    return to;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.combineLatestWith = void 0;
	var combineLatest_1 = __webpack_require__(2037);
	function combineLatestWith() {
	    var otherSources = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        otherSources[_i] = arguments[_i];
	    }
	    return combineLatest_1.combineLatest.apply(void 0, __spreadArray([], __read(otherSources)));
	}
	exports.combineLatestWith = combineLatestWith;
	//# sourceMappingURL=combineLatestWith.js.map

/***/ },
/* 2039 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	var __spreadArray = (this && this.__spreadArray) || function (to, from) {
	    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
	        to[j] = from[i];
	    return to;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.concat = void 0;
	var lift_1 = __webpack_require__(17);
	var concatAll_1 = __webpack_require__(330);
	var args_1 = __webpack_require__(64);
	var from_1 = __webpack_require__(78);
	function concat() {
	    var args = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        args[_i] = arguments[_i];
	    }
	    var scheduler = args_1.popScheduler(args);
	    return lift_1.operate(function (source, subscriber) {
	        concatAll_1.concatAll()(from_1.from(__spreadArray([source], __read(args)), scheduler)).subscribe(subscriber);
	    });
	}
	exports.concat = concat;
	//# sourceMappingURL=concat.js.map

/***/ },
/* 2040 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.concatMapTo = void 0;
	var concatMap_1 = __webpack_require__(568);
	var isFunction_1 = __webpack_require__(31);
	function concatMapTo(innerObservable, resultSelector) {
	    return isFunction_1.isFunction(resultSelector) ? concatMap_1.concatMap(function () { return innerObservable; }, resultSelector) : concatMap_1.concatMap(function () { return innerObservable; });
	}
	exports.concatMapTo = concatMapTo;
	//# sourceMappingURL=concatMapTo.js.map

/***/ },
/* 2041 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	var __spreadArray = (this && this.__spreadArray) || function (to, from) {
	    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
	        to[j] = from[i];
	    return to;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.concatWith = void 0;
	var concat_1 = __webpack_require__(2039);
	function concatWith() {
	    var otherSources = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        otherSources[_i] = arguments[_i];
	    }
	    return concat_1.concat.apply(void 0, __spreadArray([], __read(otherSources)));
	}
	exports.concatWith = concatWith;
	//# sourceMappingURL=concatWith.js.map

/***/ },
/* 2042 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.count = void 0;
	var reduce_1 = __webpack_require__(166);
	function count(predicate) {
	    return reduce_1.reduce(function (total, value, i) { return (!predicate || predicate(value, i) ? total + 1 : total); }, 0);
	}
	exports.count = count;
	//# sourceMappingURL=count.js.map

/***/ },
/* 2043 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.debounce = void 0;
	var lift_1 = __webpack_require__(17);
	var noop_1 = __webpack_require__(52);
	var OperatorSubscriber_1 = __webpack_require__(20);
	var innerFrom_1 = __webpack_require__(28);
	function debounce(durationSelector) {
	    return lift_1.operate(function (source, subscriber) {
	        var hasValue = false;
	        var lastValue = null;
	        var durationSubscriber = null;
	        var emit = function () {
	            durationSubscriber === null || durationSubscriber === void 0 ? void 0 : durationSubscriber.unsubscribe();
	            durationSubscriber = null;
	            if (hasValue) {
	                hasValue = false;
	                var value = lastValue;
	                lastValue = null;
	                subscriber.next(value);
	            }
	        };
	        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (value) {
	            durationSubscriber === null || durationSubscriber === void 0 ? void 0 : durationSubscriber.unsubscribe();
	            hasValue = true;
	            lastValue = value;
	            durationSubscriber = OperatorSubscriber_1.createOperatorSubscriber(subscriber, emit, noop_1.noop);
	            innerFrom_1.innerFrom(durationSelector(value)).subscribe(durationSubscriber);
	        }, function () {
	            emit();
	            subscriber.complete();
	        }, undefined, function () {
	            lastValue = durationSubscriber = null;
	        }));
	    });
	}
	exports.debounce = debounce;
	//# sourceMappingURL=debounce.js.map

/***/ },
/* 2044 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.debounceTime = void 0;
	var async_1 = __webpack_require__(63);
	var lift_1 = __webpack_require__(17);
	var OperatorSubscriber_1 = __webpack_require__(20);
	function debounceTime(dueTime, scheduler) {
	    if (scheduler === void 0) { scheduler = async_1.asyncScheduler; }
	    return lift_1.operate(function (source, subscriber) {
	        var activeTask = null;
	        var lastValue = null;
	        var lastTime = null;
	        var emit = function () {
	            if (activeTask) {
	                activeTask.unsubscribe();
	                activeTask = null;
	                var value = lastValue;
	                lastValue = null;
	                subscriber.next(value);
	            }
	        };
	        function emitWhenIdle() {
	            var targetTime = lastTime + dueTime;
	            var now = scheduler.now();
	            if (now < targetTime) {
	                activeTask = this.schedule(undefined, targetTime - now);
	                subscriber.add(activeTask);
	                return;
	            }
	            emit();
	        }
	        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (value) {
	            lastValue = value;
	            lastTime = scheduler.now();
	            if (!activeTask) {
	                activeTask = scheduler.schedule(emitWhenIdle, dueTime);
	                subscriber.add(activeTask);
	            }
	        }, function () {
	            emit();
	            subscriber.complete();
	        }, undefined, function () {
	            lastValue = activeTask = null;
	        }));
	    });
	}
	exports.debounceTime = debounceTime;
	//# sourceMappingURL=debounceTime.js.map

/***/ },
/* 2045 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.delay = void 0;
	var async_1 = __webpack_require__(63);
	var delayWhen_1 = __webpack_require__(569);
	var timer_1 = __webpack_require__(113);
	function delay(due, scheduler) {
	    if (scheduler === void 0) { scheduler = async_1.asyncScheduler; }
	    var duration = timer_1.timer(due, scheduler);
	    return delayWhen_1.delayWhen(function () { return duration; });
	}
	exports.delay = delay;
	//# sourceMappingURL=delay.js.map

/***/ },
/* 2046 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.dematerialize = void 0;
	var Notification_1 = __webpack_require__(325);
	var lift_1 = __webpack_require__(17);
	var OperatorSubscriber_1 = __webpack_require__(20);
	function dematerialize() {
	    return lift_1.operate(function (source, subscriber) {
	        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (notification) { return Notification_1.observeNotification(notification, subscriber); }));
	    });
	}
	exports.dematerialize = dematerialize;
	//# sourceMappingURL=dematerialize.js.map

/***/ },
/* 2047 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.distinct = void 0;
	var lift_1 = __webpack_require__(17);
	var OperatorSubscriber_1 = __webpack_require__(20);
	var noop_1 = __webpack_require__(52);
	function distinct(keySelector, flushes) {
	    return lift_1.operate(function (source, subscriber) {
	        var distinctKeys = new Set();
	        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (value) {
	            var key = keySelector ? keySelector(value) : value;
	            if (!distinctKeys.has(key)) {
	                distinctKeys.add(key);
	                subscriber.next(value);
	            }
	        }));
	        flushes === null || flushes === void 0 ? void 0 : flushes.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function () { return distinctKeys.clear(); }, noop_1.noop));
	    });
	}
	exports.distinct = distinct;
	//# sourceMappingURL=distinct.js.map

/***/ },
/* 2048 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.distinctUntilKeyChanged = void 0;
	var distinctUntilChanged_1 = __webpack_require__(570);
	function distinctUntilKeyChanged(key, compare) {
	    return distinctUntilChanged_1.distinctUntilChanged(function (x, y) { return compare ? compare(x[key], y[key]) : x[key] === y[key]; });
	}
	exports.distinctUntilKeyChanged = distinctUntilKeyChanged;
	//# sourceMappingURL=distinctUntilKeyChanged.js.map

/***/ },
/* 2049 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.elementAt = void 0;
	var ArgumentOutOfRangeError_1 = __webpack_require__(589);
	var filter_1 = __webpack_require__(136);
	var throwIfEmpty_1 = __webpack_require__(229);
	var defaultIfEmpty_1 = __webpack_require__(224);
	var take_1 = __webpack_require__(167);
	function elementAt(index, defaultValue) {
	    if (index < 0) {
	        throw new ArgumentOutOfRangeError_1.ArgumentOutOfRangeError();
	    }
	    var hasDefaultValue = arguments.length >= 2;
	    return function (source) {
	        return source.pipe(filter_1.filter(function (v, i) { return i === index; }), take_1.take(1), hasDefaultValue ? defaultIfEmpty_1.defaultIfEmpty(defaultValue) : throwIfEmpty_1.throwIfEmpty(function () { return new ArgumentOutOfRangeError_1.ArgumentOutOfRangeError(); }));
	    };
	}
	exports.elementAt = elementAt;
	//# sourceMappingURL=elementAt.js.map

/***/ },
/* 2050 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	var __spreadArray = (this && this.__spreadArray) || function (to, from) {
	    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
	        to[j] = from[i];
	    return to;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.endWith = void 0;
	var concat_1 = __webpack_require__(222);
	var of_1 = __webpack_require__(328);
	function endWith() {
	    var values = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        values[_i] = arguments[_i];
	    }
	    return function (source) { return concat_1.concat(source, of_1.of.apply(void 0, __spreadArray([], __read(values)))); };
	}
	exports.endWith = endWith;
	//# sourceMappingURL=endWith.js.map

/***/ },
/* 2051 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.every = void 0;
	var lift_1 = __webpack_require__(17);
	var OperatorSubscriber_1 = __webpack_require__(20);
	function every(predicate, thisArg) {
	    return lift_1.operate(function (source, subscriber) {
	        var index = 0;
	        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (value) {
	            if (!predicate.call(thisArg, value, index++, source)) {
	                subscriber.next(false);
	                subscriber.complete();
	            }
	        }, function () {
	            subscriber.next(true);
	            subscriber.complete();
	        }));
	    });
	}
	exports.every = every;
	//# sourceMappingURL=every.js.map

/***/ },
/* 2052 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.exhaust = void 0;
	var exhaustAll_1 = __webpack_require__(571);
	exports.exhaust = exhaustAll_1.exhaustAll;
	//# sourceMappingURL=exhaust.js.map

/***/ },
/* 2053 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.exhaustMap = void 0;
	var map_1 = __webpack_require__(114);
	var innerFrom_1 = __webpack_require__(28);
	var lift_1 = __webpack_require__(17);
	var OperatorSubscriber_1 = __webpack_require__(20);
	function exhaustMap(project, resultSelector) {
	    if (resultSelector) {
	        return function (source) {
	            return source.pipe(exhaustMap(function (a, i) { return innerFrom_1.innerFrom(project(a, i)).pipe(map_1.map(function (b, ii) { return resultSelector(a, b, i, ii); })); }));
	        };
	    }
	    return lift_1.operate(function (source, subscriber) {
	        var index = 0;
	        var innerSub = null;
	        var isComplete = false;
	        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (outerValue) {
	            if (!innerSub) {
	                innerSub = OperatorSubscriber_1.createOperatorSubscriber(subscriber, undefined, function () {
	                    innerSub = null;
	                    isComplete && subscriber.complete();
	                });
	                innerFrom_1.innerFrom(project(outerValue, index++)).subscribe(innerSub);
	            }
	        }, function () {
	            isComplete = true;
	            !innerSub && subscriber.complete();
	        }));
	    });
	}
	exports.exhaustMap = exhaustMap;
	//# sourceMappingURL=exhaustMap.js.map

/***/ },
/* 2054 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.expand = void 0;
	var lift_1 = __webpack_require__(17);
	var mergeInternals_1 = __webpack_require__(332);
	function expand(project, concurrent, scheduler) {
	    if (concurrent === void 0) { concurrent = Infinity; }
	    concurrent = (concurrent || 0) < 1 ? Infinity : concurrent;
	    return lift_1.operate(function (source, subscriber) {
	        return mergeInternals_1.mergeInternals(source, subscriber, project, concurrent, undefined, true, scheduler);
	    });
	}
	exports.expand = expand;
	//# sourceMappingURL=expand.js.map

/***/ },
/* 2055 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.finalize = void 0;
	var lift_1 = __webpack_require__(17);
	function finalize(callback) {
	    return lift_1.operate(function (source, subscriber) {
	        try {
	            source.subscribe(subscriber);
	        }
	        finally {
	            subscriber.add(callback);
	        }
	    });
	}
	exports.finalize = finalize;
	//# sourceMappingURL=finalize.js.map

/***/ },
/* 2056 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.findIndex = void 0;
	var lift_1 = __webpack_require__(17);
	var find_1 = __webpack_require__(572);
	function findIndex(predicate, thisArg) {
	    return lift_1.operate(find_1.createFind(predicate, thisArg, 'index'));
	}
	exports.findIndex = findIndex;
	//# sourceMappingURL=findIndex.js.map

/***/ },
/* 2057 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.first = void 0;
	var EmptyError_1 = __webpack_require__(115);
	var filter_1 = __webpack_require__(136);
	var take_1 = __webpack_require__(167);
	var defaultIfEmpty_1 = __webpack_require__(224);
	var throwIfEmpty_1 = __webpack_require__(229);
	var identity_1 = __webpack_require__(56);
	function first(predicate, defaultValue) {
	    var hasDefaultValue = arguments.length >= 2;
	    return function (source) {
	        return source.pipe(predicate ? filter_1.filter(function (v, i) { return predicate(v, i, source); }) : identity_1.identity, take_1.take(1), hasDefaultValue ? defaultIfEmpty_1.defaultIfEmpty(defaultValue) : throwIfEmpty_1.throwIfEmpty(function () { return new EmptyError_1.EmptyError(); }));
	    };
	}
	exports.first = first;
	//# sourceMappingURL=first.js.map

/***/ },
/* 2058 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.flatMap = void 0;
	var mergeMap_1 = __webpack_require__(98);
	exports.flatMap = mergeMap_1.mergeMap;
	//# sourceMappingURL=flatMap.js.map

/***/ },
/* 2059 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.groupBy = void 0;
	var Observable_1 = __webpack_require__(34);
	var innerFrom_1 = __webpack_require__(28);
	var Subject_1 = __webpack_require__(51);
	var lift_1 = __webpack_require__(17);
	var OperatorSubscriber_1 = __webpack_require__(20);
	function groupBy(keySelector, elementOrOptions, duration, connector) {
	    return lift_1.operate(function (source, subscriber) {
	        var element;
	        if (!elementOrOptions || typeof elementOrOptions === 'function') {
	            element = elementOrOptions;
	        }
	        else {
	            (duration = elementOrOptions.duration, element = elementOrOptions.element, connector = elementOrOptions.connector);
	        }
	        var groups = new Map();
	        var notify = function (cb) {
	            groups.forEach(cb);
	            cb(subscriber);
	        };
	        var handleError = function (err) { return notify(function (consumer) { return consumer.error(err); }); };
	        var activeGroups = 0;
	        var teardownAttempted = false;
	        var groupBySourceSubscriber = new OperatorSubscriber_1.OperatorSubscriber(subscriber, function (value) {
	            try {
	                var key_1 = keySelector(value);
	                var group_1 = groups.get(key_1);
	                if (!group_1) {
	                    groups.set(key_1, (group_1 = connector ? connector() : new Subject_1.Subject()));
	                    var grouped = createGroupedObservable(key_1, group_1);
	                    subscriber.next(grouped);
	                    if (duration) {
	                        var durationSubscriber_1 = OperatorSubscriber_1.createOperatorSubscriber(group_1, function () {
	                            group_1.complete();
	                            durationSubscriber_1 === null || durationSubscriber_1 === void 0 ? void 0 : durationSubscriber_1.unsubscribe();
	                        }, undefined, undefined, function () { return groups.delete(key_1); });
	                        groupBySourceSubscriber.add(innerFrom_1.innerFrom(duration(grouped)).subscribe(durationSubscriber_1));
	                    }
	                }
	                group_1.next(element ? element(value) : value);
	            }
	            catch (err) {
	                handleError(err);
	            }
	        }, function () { return notify(function (consumer) { return consumer.complete(); }); }, handleError, function () { return groups.clear(); }, function () {
	            teardownAttempted = true;
	            return activeGroups === 0;
	        });
	        source.subscribe(groupBySourceSubscriber);
	        function createGroupedObservable(key, groupSubject) {
	            var result = new Observable_1.Observable(function (groupSubscriber) {
	                activeGroups++;
	                var innerSub = groupSubject.subscribe(groupSubscriber);
	                return function () {
	                    innerSub.unsubscribe();
	                    --activeGroups === 0 && teardownAttempted && groupBySourceSubscriber.unsubscribe();
	                };
	            });
	            result.key = key;
	            return result;
	        }
	    });
	}
	exports.groupBy = groupBy;
	//# sourceMappingURL=groupBy.js.map

/***/ },
/* 2060 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.isEmpty = void 0;
	var lift_1 = __webpack_require__(17);
	var OperatorSubscriber_1 = __webpack_require__(20);
	function isEmpty() {
	    return lift_1.operate(function (source, subscriber) {
	        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function () {
	            subscriber.next(false);
	            subscriber.complete();
	        }, function () {
	            subscriber.next(true);
	            subscriber.complete();
	        }));
	    });
	}
	exports.isEmpty = isEmpty;
	//# sourceMappingURL=isEmpty.js.map

/***/ },
/* 2061 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.last = void 0;
	var EmptyError_1 = __webpack_require__(115);
	var filter_1 = __webpack_require__(136);
	var takeLast_1 = __webpack_require__(580);
	var throwIfEmpty_1 = __webpack_require__(229);
	var defaultIfEmpty_1 = __webpack_require__(224);
	var identity_1 = __webpack_require__(56);
	function last(predicate, defaultValue) {
	    var hasDefaultValue = arguments.length >= 2;
	    return function (source) {
	        return source.pipe(predicate ? filter_1.filter(function (v, i) { return predicate(v, i, source); }) : identity_1.identity, takeLast_1.takeLast(1), hasDefaultValue ? defaultIfEmpty_1.defaultIfEmpty(defaultValue) : throwIfEmpty_1.throwIfEmpty(function () { return new EmptyError_1.EmptyError(); }));
	    };
	}
	exports.last = last;
	//# sourceMappingURL=last.js.map

/***/ },
/* 2062 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.materialize = void 0;
	var Notification_1 = __webpack_require__(325);
	var lift_1 = __webpack_require__(17);
	var OperatorSubscriber_1 = __webpack_require__(20);
	function materialize() {
	    return lift_1.operate(function (source, subscriber) {
	        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (value) {
	            subscriber.next(Notification_1.Notification.createNext(value));
	        }, function () {
	            subscriber.next(Notification_1.Notification.createComplete());
	            subscriber.complete();
	        }, function (err) {
	            subscriber.next(Notification_1.Notification.createError(err));
	            subscriber.complete();
	        }));
	    });
	}
	exports.materialize = materialize;
	//# sourceMappingURL=materialize.js.map

/***/ },
/* 2063 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.max = void 0;
	var reduce_1 = __webpack_require__(166);
	var isFunction_1 = __webpack_require__(31);
	function max(comparer) {
	    return reduce_1.reduce(isFunction_1.isFunction(comparer) ? function (x, y) { return (comparer(x, y) > 0 ? x : y); } : function (x, y) { return (x > y ? x : y); });
	}
	exports.max = max;
	//# sourceMappingURL=max.js.map

/***/ },
/* 2064 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	var __spreadArray = (this && this.__spreadArray) || function (to, from) {
	    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
	        to[j] = from[i];
	    return to;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.merge = void 0;
	var lift_1 = __webpack_require__(17);
	var argsOrArgArray_1 = __webpack_require__(137);
	var mergeAll_1 = __webpack_require__(225);
	var args_1 = __webpack_require__(64);
	var from_1 = __webpack_require__(78);
	function merge() {
	    var args = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        args[_i] = arguments[_i];
	    }
	    var scheduler = args_1.popScheduler(args);
	    var concurrent = args_1.popNumber(args, Infinity);
	    args = argsOrArgArray_1.argsOrArgArray(args);
	    return lift_1.operate(function (source, subscriber) {
	        mergeAll_1.mergeAll(concurrent)(from_1.from(__spreadArray([source], __read(args)), scheduler)).subscribe(subscriber);
	    });
	}
	exports.merge = merge;
	//# sourceMappingURL=merge.js.map

/***/ },
/* 2065 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.mergeMapTo = void 0;
	var mergeMap_1 = __webpack_require__(98);
	var isFunction_1 = __webpack_require__(31);
	function mergeMapTo(innerObservable, resultSelector, concurrent) {
	    if (concurrent === void 0) { concurrent = Infinity; }
	    if (isFunction_1.isFunction(resultSelector)) {
	        return mergeMap_1.mergeMap(function () { return innerObservable; }, resultSelector, concurrent);
	    }
	    if (typeof resultSelector === 'number') {
	        concurrent = resultSelector;
	    }
	    return mergeMap_1.mergeMap(function () { return innerObservable; }, concurrent);
	}
	exports.mergeMapTo = mergeMapTo;
	//# sourceMappingURL=mergeMapTo.js.map

/***/ },
/* 2066 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.mergeScan = void 0;
	var lift_1 = __webpack_require__(17);
	var mergeInternals_1 = __webpack_require__(332);
	function mergeScan(accumulator, seed, concurrent) {
	    if (concurrent === void 0) { concurrent = Infinity; }
	    return lift_1.operate(function (source, subscriber) {
	        var state = seed;
	        return mergeInternals_1.mergeInternals(source, subscriber, function (value, index) { return accumulator(state, value, index); }, concurrent, function (value) {
	            state = value;
	        }, false, undefined, function () { return (state = null); });
	    });
	}
	exports.mergeScan = mergeScan;
	//# sourceMappingURL=mergeScan.js.map

/***/ },
/* 2067 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	var __spreadArray = (this && this.__spreadArray) || function (to, from) {
	    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
	        to[j] = from[i];
	    return to;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.mergeWith = void 0;
	var merge_1 = __webpack_require__(2064);
	function mergeWith() {
	    var otherSources = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        otherSources[_i] = arguments[_i];
	    }
	    return merge_1.merge.apply(void 0, __spreadArray([], __read(otherSources)));
	}
	exports.mergeWith = mergeWith;
	//# sourceMappingURL=mergeWith.js.map

/***/ },
/* 2068 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.min = void 0;
	var reduce_1 = __webpack_require__(166);
	var isFunction_1 = __webpack_require__(31);
	function min(comparer) {
	    return reduce_1.reduce(isFunction_1.isFunction(comparer) ? function (x, y) { return (comparer(x, y) < 0 ? x : y); } : function (x, y) { return (x < y ? x : y); });
	}
	exports.min = min;
	//# sourceMappingURL=min.js.map

/***/ },
/* 2069 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	var __spreadArray = (this && this.__spreadArray) || function (to, from) {
	    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
	        to[j] = from[i];
	    return to;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.onErrorResumeNext = void 0;
	var lift_1 = __webpack_require__(17);
	var innerFrom_1 = __webpack_require__(28);
	var argsOrArgArray_1 = __webpack_require__(137);
	var OperatorSubscriber_1 = __webpack_require__(20);
	var noop_1 = __webpack_require__(52);
	function onErrorResumeNext() {
	    var sources = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        sources[_i] = arguments[_i];
	    }
	    var nextSources = argsOrArgArray_1.argsOrArgArray(sources);
	    return lift_1.operate(function (source, subscriber) {
	        var remaining = __spreadArray([source], __read(nextSources));
	        var subscribeNext = function () {
	            if (!subscriber.closed) {
	                if (remaining.length > 0) {
	                    var nextSource = void 0;
	                    try {
	                        nextSource = innerFrom_1.innerFrom(remaining.shift());
	                    }
	                    catch (err) {
	                        subscribeNext();
	                        return;
	                    }
	                    var innerSub = OperatorSubscriber_1.createOperatorSubscriber(subscriber, undefined, noop_1.noop, noop_1.noop);
	                    nextSource.subscribe(innerSub);
	                    innerSub.add(subscribeNext);
	                }
	                else {
	                    subscriber.complete();
	                }
	            }
	        };
	        subscribeNext();
	    });
	}
	exports.onErrorResumeNext = onErrorResumeNext;
	//# sourceMappingURL=onErrorResumeNext.js.map

/***/ },
/* 2070 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.pairwise = void 0;
	var lift_1 = __webpack_require__(17);
	var OperatorSubscriber_1 = __webpack_require__(20);
	function pairwise() {
	    return lift_1.operate(function (source, subscriber) {
	        var prev;
	        var hasPrev = false;
	        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (value) {
	            var p = prev;
	            prev = value;
	            hasPrev && subscriber.next([p, value]);
	            hasPrev = true;
	        }));
	    });
	}
	exports.pairwise = pairwise;
	//# sourceMappingURL=pairwise.js.map

/***/ },
/* 2071 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.pluck = void 0;
	var map_1 = __webpack_require__(114);
	function pluck() {
	    var properties = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        properties[_i] = arguments[_i];
	    }
	    var length = properties.length;
	    if (length === 0) {
	        throw new Error('list of properties cannot be empty.');
	    }
	    return map_1.map(function (x) {
	        var currentProp = x;
	        for (var i = 0; i < length; i++) {
	            var p = currentProp === null || currentProp === void 0 ? void 0 : currentProp[properties[i]];
	            if (typeof p !== 'undefined') {
	                currentProp = p;
	            }
	            else {
	                return undefined;
	            }
	        }
	        return currentProp;
	    });
	}
	exports.pluck = pluck;
	//# sourceMappingURL=pluck.js.map

/***/ },
/* 2072 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.publish = void 0;
	var Subject_1 = __webpack_require__(51);
	var multicast_1 = __webpack_require__(333);
	var connect_1 = __webpack_require__(331);
	function publish(selector) {
	    return selector ? function (source) { return connect_1.connect(selector)(source); } : function (source) { return multicast_1.multicast(new Subject_1.Subject())(source); };
	}
	exports.publish = publish;
	//# sourceMappingURL=publish.js.map

/***/ },
/* 2073 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.publishBehavior = void 0;
	var BehaviorSubject_1 = __webpack_require__(559);
	var ConnectableObservable_1 = __webpack_require__(221);
	function publishBehavior(initialValue) {
	    return function (source) {
	        var subject = new BehaviorSubject_1.BehaviorSubject(initialValue);
	        return new ConnectableObservable_1.ConnectableObservable(source, function () { return subject; });
	    };
	}
	exports.publishBehavior = publishBehavior;
	//# sourceMappingURL=publishBehavior.js.map

/***/ },
/* 2074 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.publishLast = void 0;
	var AsyncSubject_1 = __webpack_require__(324);
	var ConnectableObservable_1 = __webpack_require__(221);
	function publishLast() {
	    return function (source) {
	        var subject = new AsyncSubject_1.AsyncSubject();
	        return new ConnectableObservable_1.ConnectableObservable(source, function () { return subject; });
	    };
	}
	exports.publishLast = publishLast;
	//# sourceMappingURL=publishLast.js.map

/***/ },
/* 2075 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.publishReplay = void 0;
	var ReplaySubject_1 = __webpack_require__(326);
	var multicast_1 = __webpack_require__(333);
	var isFunction_1 = __webpack_require__(31);
	function publishReplay(bufferSize, windowTime, selectorOrScheduler, timestampProvider) {
	    if (selectorOrScheduler && !isFunction_1.isFunction(selectorOrScheduler)) {
	        timestampProvider = selectorOrScheduler;
	    }
	    var selector = isFunction_1.isFunction(selectorOrScheduler) ? selectorOrScheduler : undefined;
	    return function (source) { return multicast_1.multicast(new ReplaySubject_1.ReplaySubject(bufferSize, windowTime, timestampProvider), selector)(source); };
	}
	exports.publishReplay = publishReplay;
	//# sourceMappingURL=publishReplay.js.map

/***/ },
/* 2076 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	var __spreadArray = (this && this.__spreadArray) || function (to, from) {
	    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
	        to[j] = from[i];
	    return to;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.raceWith = void 0;
	var race_1 = __webpack_require__(564);
	var lift_1 = __webpack_require__(17);
	var identity_1 = __webpack_require__(56);
	function raceWith() {
	    var otherSources = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        otherSources[_i] = arguments[_i];
	    }
	    return !otherSources.length
	        ? identity_1.identity
	        : lift_1.operate(function (source, subscriber) {
	            race_1.raceInit(__spreadArray([source], __read(otherSources)))(subscriber);
	        });
	}
	exports.raceWith = raceWith;
	//# sourceMappingURL=raceWith.js.map

/***/ },
/* 2077 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.repeat = void 0;
	var empty_1 = __webpack_require__(74);
	var lift_1 = __webpack_require__(17);
	var OperatorSubscriber_1 = __webpack_require__(20);
	var innerFrom_1 = __webpack_require__(28);
	var timer_1 = __webpack_require__(113);
	function repeat(countOrConfig) {
	    var _a;
	    var count = Infinity;
	    var delay;
	    if (countOrConfig != null) {
	        if (typeof countOrConfig === 'object') {
	            (_a = countOrConfig.count, count = _a === void 0 ? Infinity : _a, delay = countOrConfig.delay);
	        }
	        else {
	            count = countOrConfig;
	        }
	    }
	    return count <= 0
	        ? function () { return empty_1.EMPTY; }
	        : lift_1.operate(function (source, subscriber) {
	            var soFar = 0;
	            var sourceSub;
	            var resubscribe = function () {
	                sourceSub === null || sourceSub === void 0 ? void 0 : sourceSub.unsubscribe();
	                sourceSub = null;
	                if (delay != null) {
	                    var notifier = typeof delay === 'number' ? timer_1.timer(delay) : innerFrom_1.innerFrom(delay(soFar));
	                    var notifierSubscriber_1 = OperatorSubscriber_1.createOperatorSubscriber(subscriber, function () {
	                        notifierSubscriber_1.unsubscribe();
	                        subscribeToSource();
	                    });
	                    notifier.subscribe(notifierSubscriber_1);
	                }
	                else {
	                    subscribeToSource();
	                }
	            };
	            var subscribeToSource = function () {
	                var syncUnsub = false;
	                sourceSub = source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, undefined, function () {
	                    if (++soFar < count) {
	                        if (sourceSub) {
	                            resubscribe();
	                        }
	                        else {
	                            syncUnsub = true;
	                        }
	                    }
	                    else {
	                        subscriber.complete();
	                    }
	                }));
	                if (syncUnsub) {
	                    resubscribe();
	                }
	            };
	            subscribeToSource();
	        });
	}
	exports.repeat = repeat;
	//# sourceMappingURL=repeat.js.map

/***/ },
/* 2078 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.repeatWhen = void 0;
	var Subject_1 = __webpack_require__(51);
	var lift_1 = __webpack_require__(17);
	var OperatorSubscriber_1 = __webpack_require__(20);
	function repeatWhen(notifier) {
	    return lift_1.operate(function (source, subscriber) {
	        var innerSub;
	        var syncResub = false;
	        var completions$;
	        var isNotifierComplete = false;
	        var isMainComplete = false;
	        var checkComplete = function () { return isMainComplete && isNotifierComplete && (subscriber.complete(), true); };
	        var getCompletionSubject = function () {
	            if (!completions$) {
	                completions$ = new Subject_1.Subject();
	                notifier(completions$).subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function () {
	                    if (innerSub) {
	                        subscribeForRepeatWhen();
	                    }
	                    else {
	                        syncResub = true;
	                    }
	                }, function () {
	                    isNotifierComplete = true;
	                    checkComplete();
	                }));
	            }
	            return completions$;
	        };
	        var subscribeForRepeatWhen = function () {
	            isMainComplete = false;
	            innerSub = source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, undefined, function () {
	                isMainComplete = true;
	                !checkComplete() && getCompletionSubject().next();
	            }));
	            if (syncResub) {
	                innerSub.unsubscribe();
	                innerSub = null;
	                syncResub = false;
	                subscribeForRepeatWhen();
	            }
	        };
	        subscribeForRepeatWhen();
	    });
	}
	exports.repeatWhen = repeatWhen;
	//# sourceMappingURL=repeatWhen.js.map

/***/ },
/* 2079 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.retry = void 0;
	var lift_1 = __webpack_require__(17);
	var OperatorSubscriber_1 = __webpack_require__(20);
	var identity_1 = __webpack_require__(56);
	var timer_1 = __webpack_require__(113);
	var innerFrom_1 = __webpack_require__(28);
	function retry(configOrCount) {
	    if (configOrCount === void 0) { configOrCount = Infinity; }
	    var config;
	    if (configOrCount && typeof configOrCount === 'object') {
	        config = configOrCount;
	    }
	    else {
	        config = {
	            count: configOrCount,
	        };
	    }
	    var _a = config.count, count = _a === void 0 ? Infinity : _a, delay = config.delay, _b = config.resetOnSuccess, resetOnSuccess = _b === void 0 ? false : _b;
	    return count <= 0
	        ? identity_1.identity
	        : lift_1.operate(function (source, subscriber) {
	            var soFar = 0;
	            var innerSub;
	            var subscribeForRetry = function () {
	                var syncUnsub = false;
	                innerSub = source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (value) {
	                    if (resetOnSuccess) {
	                        soFar = 0;
	                    }
	                    subscriber.next(value);
	                }, undefined, function (err) {
	                    if (soFar++ < count) {
	                        var resub_1 = function () {
	                            if (innerSub) {
	                                innerSub.unsubscribe();
	                                innerSub = null;
	                                subscribeForRetry();
	                            }
	                            else {
	                                syncUnsub = true;
	                            }
	                        };
	                        if (delay != null) {
	                            var notifier = typeof delay === 'number' ? timer_1.timer(delay) : innerFrom_1.innerFrom(delay(err, soFar));
	                            var notifierSubscriber_1 = OperatorSubscriber_1.createOperatorSubscriber(subscriber, function () {
	                                notifierSubscriber_1.unsubscribe();
	                                resub_1();
	                            }, function () {
	                                subscriber.complete();
	                            });
	                            notifier.subscribe(notifierSubscriber_1);
	                        }
	                        else {
	                            resub_1();
	                        }
	                    }
	                    else {
	                        subscriber.error(err);
	                    }
	                }));
	                if (syncUnsub) {
	                    innerSub.unsubscribe();
	                    innerSub = null;
	                    subscribeForRetry();
	                }
	            };
	            subscribeForRetry();
	        });
	}
	exports.retry = retry;
	//# sourceMappingURL=retry.js.map

/***/ },
/* 2080 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.retryWhen = void 0;
	var Subject_1 = __webpack_require__(51);
	var lift_1 = __webpack_require__(17);
	var OperatorSubscriber_1 = __webpack_require__(20);
	function retryWhen(notifier) {
	    return lift_1.operate(function (source, subscriber) {
	        var innerSub;
	        var syncResub = false;
	        var errors$;
	        var subscribeForRetryWhen = function () {
	            innerSub = source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, undefined, undefined, function (err) {
	                if (!errors$) {
	                    errors$ = new Subject_1.Subject();
	                    notifier(errors$).subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function () {
	                        return innerSub ? subscribeForRetryWhen() : (syncResub = true);
	                    }));
	                }
	                if (errors$) {
	                    errors$.next(err);
	                }
	            }));
	            if (syncResub) {
	                innerSub.unsubscribe();
	                innerSub = null;
	                syncResub = false;
	                subscribeForRetryWhen();
	            }
	        };
	        subscribeForRetryWhen();
	    });
	}
	exports.retryWhen = retryWhen;
	//# sourceMappingURL=retryWhen.js.map

/***/ },
/* 2081 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.sampleTime = void 0;
	var async_1 = __webpack_require__(63);
	var sample_1 = __webpack_require__(577);
	var interval_1 = __webpack_require__(562);
	function sampleTime(period, scheduler) {
	    if (scheduler === void 0) { scheduler = async_1.asyncScheduler; }
	    return sample_1.sample(interval_1.interval(period, scheduler));
	}
	exports.sampleTime = sampleTime;
	//# sourceMappingURL=sampleTime.js.map

/***/ },
/* 2082 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.scan = void 0;
	var lift_1 = __webpack_require__(17);
	var scanInternals_1 = __webpack_require__(578);
	function scan(accumulator, seed) {
	    return lift_1.operate(scanInternals_1.scanInternals(accumulator, seed, arguments.length >= 2, true));
	}
	exports.scan = scan;
	//# sourceMappingURL=scan.js.map

/***/ },
/* 2083 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.sequenceEqual = void 0;
	var lift_1 = __webpack_require__(17);
	var OperatorSubscriber_1 = __webpack_require__(20);
	function sequenceEqual(compareTo, comparator) {
	    if (comparator === void 0) { comparator = function (a, b) { return a === b; }; }
	    return lift_1.operate(function (source, subscriber) {
	        var aState = createState();
	        var bState = createState();
	        var emit = function (isEqual) {
	            subscriber.next(isEqual);
	            subscriber.complete();
	        };
	        var createSubscriber = function (selfState, otherState) {
	            var sequenceEqualSubscriber = OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (a) {
	                var buffer = otherState.buffer, complete = otherState.complete;
	                if (buffer.length === 0) {
	                    complete ? emit(false) : selfState.buffer.push(a);
	                }
	                else {
	                    !comparator(a, buffer.shift()) && emit(false);
	                }
	            }, function () {
	                selfState.complete = true;
	                var complete = otherState.complete, buffer = otherState.buffer;
	                complete && emit(buffer.length === 0);
	                sequenceEqualSubscriber === null || sequenceEqualSubscriber === void 0 ? void 0 : sequenceEqualSubscriber.unsubscribe();
	            });
	            return sequenceEqualSubscriber;
	        };
	        source.subscribe(createSubscriber(aState, bState));
	        compareTo.subscribe(createSubscriber(bState, aState));
	    });
	}
	exports.sequenceEqual = sequenceEqual;
	function createState() {
	    return {
	        buffer: [],
	        complete: false,
	    };
	}
	//# sourceMappingURL=sequenceEqual.js.map

/***/ },
/* 2084 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.shareReplay = void 0;
	var ReplaySubject_1 = __webpack_require__(326);
	var share_1 = __webpack_require__(579);
	function shareReplay(configOrBufferSize, windowTime, scheduler) {
	    var _a, _b, _c;
	    var bufferSize;
	    var refCount = false;
	    if (configOrBufferSize && typeof configOrBufferSize === 'object') {
	        (_a = configOrBufferSize.bufferSize, bufferSize = _a === void 0 ? Infinity : _a, _b = configOrBufferSize.windowTime, windowTime = _b === void 0 ? Infinity : _b, _c = configOrBufferSize.refCount, refCount = _c === void 0 ? false : _c, scheduler = configOrBufferSize.scheduler);
	    }
	    else {
	        bufferSize = configOrBufferSize !== null && configOrBufferSize !== void 0 ? configOrBufferSize : Infinity;
	    }
	    return share_1.share({
	        connector: function () { return new ReplaySubject_1.ReplaySubject(bufferSize, windowTime, scheduler); },
	        resetOnError: true,
	        resetOnComplete: false,
	        resetOnRefCountZero: refCount,
	    });
	}
	exports.shareReplay = shareReplay;
	//# sourceMappingURL=shareReplay.js.map

/***/ },
/* 2085 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.single = void 0;
	var EmptyError_1 = __webpack_require__(115);
	var SequenceError_1 = __webpack_require__(592);
	var NotFoundError_1 = __webpack_require__(590);
	var lift_1 = __webpack_require__(17);
	var OperatorSubscriber_1 = __webpack_require__(20);
	function single(predicate) {
	    return lift_1.operate(function (source, subscriber) {
	        var hasValue = false;
	        var singleValue;
	        var seenValue = false;
	        var index = 0;
	        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (value) {
	            seenValue = true;
	            if (!predicate || predicate(value, index++, source)) {
	                hasValue && subscriber.error(new SequenceError_1.SequenceError('Too many matching values'));
	                hasValue = true;
	                singleValue = value;
	            }
	        }, function () {
	            if (hasValue) {
	                subscriber.next(singleValue);
	                subscriber.complete();
	            }
	            else {
	                subscriber.error(seenValue ? new NotFoundError_1.NotFoundError('No matching values') : new EmptyError_1.EmptyError());
	            }
	        }));
	    });
	}
	exports.single = single;
	//# sourceMappingURL=single.js.map

/***/ },
/* 2086 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.skip = void 0;
	var filter_1 = __webpack_require__(136);
	function skip(count) {
	    return filter_1.filter(function (_, index) { return count <= index; });
	}
	exports.skip = skip;
	//# sourceMappingURL=skip.js.map

/***/ },
/* 2087 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.skipLast = void 0;
	var identity_1 = __webpack_require__(56);
	var lift_1 = __webpack_require__(17);
	var OperatorSubscriber_1 = __webpack_require__(20);
	function skipLast(skipCount) {
	    return skipCount <= 0
	        ?
	            identity_1.identity
	        : lift_1.operate(function (source, subscriber) {
	            var ring = new Array(skipCount);
	            var seen = 0;
	            source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (value) {
	                var valueIndex = seen++;
	                if (valueIndex < skipCount) {
	                    ring[valueIndex] = value;
	                }
	                else {
	                    var index = valueIndex % skipCount;
	                    var oldValue = ring[index];
	                    ring[index] = value;
	                    subscriber.next(oldValue);
	                }
	            }));
	            return function () {
	                ring = null;
	            };
	        });
	}
	exports.skipLast = skipLast;
	//# sourceMappingURL=skipLast.js.map

/***/ },
/* 2088 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.skipUntil = void 0;
	var lift_1 = __webpack_require__(17);
	var OperatorSubscriber_1 = __webpack_require__(20);
	var innerFrom_1 = __webpack_require__(28);
	var noop_1 = __webpack_require__(52);
	function skipUntil(notifier) {
	    return lift_1.operate(function (source, subscriber) {
	        var taking = false;
	        var skipSubscriber = OperatorSubscriber_1.createOperatorSubscriber(subscriber, function () {
	            skipSubscriber === null || skipSubscriber === void 0 ? void 0 : skipSubscriber.unsubscribe();
	            taking = true;
	        }, noop_1.noop);
	        innerFrom_1.innerFrom(notifier).subscribe(skipSubscriber);
	        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (value) { return taking && subscriber.next(value); }));
	    });
	}
	exports.skipUntil = skipUntil;
	//# sourceMappingURL=skipUntil.js.map

/***/ },
/* 2089 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.skipWhile = void 0;
	var lift_1 = __webpack_require__(17);
	var OperatorSubscriber_1 = __webpack_require__(20);
	function skipWhile(predicate) {
	    return lift_1.operate(function (source, subscriber) {
	        var taking = false;
	        var index = 0;
	        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (value) { return (taking || (taking = !predicate(value, index++))) && subscriber.next(value); }));
	    });
	}
	exports.skipWhile = skipWhile;
	//# sourceMappingURL=skipWhile.js.map

/***/ },
/* 2090 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.startWith = void 0;
	var concat_1 = __webpack_require__(222);
	var args_1 = __webpack_require__(64);
	var lift_1 = __webpack_require__(17);
	function startWith() {
	    var values = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        values[_i] = arguments[_i];
	    }
	    var scheduler = args_1.popScheduler(values);
	    return lift_1.operate(function (source, subscriber) {
	        (scheduler ? concat_1.concat(values, source, scheduler) : concat_1.concat(values, source)).subscribe(subscriber);
	    });
	}
	exports.startWith = startWith;
	//# sourceMappingURL=startWith.js.map

/***/ },
/* 2091 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.switchAll = void 0;
	var switchMap_1 = __webpack_require__(228);
	var identity_1 = __webpack_require__(56);
	function switchAll() {
	    return switchMap_1.switchMap(identity_1.identity);
	}
	exports.switchAll = switchAll;
	//# sourceMappingURL=switchAll.js.map

/***/ },
/* 2092 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.switchMapTo = void 0;
	var switchMap_1 = __webpack_require__(228);
	var isFunction_1 = __webpack_require__(31);
	function switchMapTo(innerObservable, resultSelector) {
	    return isFunction_1.isFunction(resultSelector) ? switchMap_1.switchMap(function () { return innerObservable; }, resultSelector) : switchMap_1.switchMap(function () { return innerObservable; });
	}
	exports.switchMapTo = switchMapTo;
	//# sourceMappingURL=switchMapTo.js.map

/***/ },
/* 2093 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.switchScan = void 0;
	var switchMap_1 = __webpack_require__(228);
	var lift_1 = __webpack_require__(17);
	function switchScan(accumulator, seed) {
	    return lift_1.operate(function (source, subscriber) {
	        var state = seed;
	        switchMap_1.switchMap(function (value, index) { return accumulator(state, value, index); }, function (_, innerValue) { return ((state = innerValue), innerValue); })(source).subscribe(subscriber);
	        return function () {
	            state = null;
	        };
	    });
	}
	exports.switchScan = switchScan;
	//# sourceMappingURL=switchScan.js.map

/***/ },
/* 2094 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.takeUntil = void 0;
	var lift_1 = __webpack_require__(17);
	var OperatorSubscriber_1 = __webpack_require__(20);
	var innerFrom_1 = __webpack_require__(28);
	var noop_1 = __webpack_require__(52);
	function takeUntil(notifier) {
	    return lift_1.operate(function (source, subscriber) {
	        innerFrom_1.innerFrom(notifier).subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function () { return subscriber.complete(); }, noop_1.noop));
	        !subscriber.closed && source.subscribe(subscriber);
	    });
	}
	exports.takeUntil = takeUntil;
	//# sourceMappingURL=takeUntil.js.map

/***/ },
/* 2095 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.takeWhile = void 0;
	var lift_1 = __webpack_require__(17);
	var OperatorSubscriber_1 = __webpack_require__(20);
	function takeWhile(predicate, inclusive) {
	    if (inclusive === void 0) { inclusive = false; }
	    return lift_1.operate(function (source, subscriber) {
	        var index = 0;
	        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (value) {
	            var result = predicate(value, index++);
	            (result || inclusive) && subscriber.next(value);
	            !result && subscriber.complete();
	        }));
	    });
	}
	exports.takeWhile = takeWhile;
	//# sourceMappingURL=takeWhile.js.map

/***/ },
/* 2096 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.tap = void 0;
	var isFunction_1 = __webpack_require__(31);
	var lift_1 = __webpack_require__(17);
	var OperatorSubscriber_1 = __webpack_require__(20);
	var identity_1 = __webpack_require__(56);
	function tap(observerOrNext, error, complete) {
	    var tapObserver = isFunction_1.isFunction(observerOrNext) || error || complete
	        ?
	            { next: observerOrNext, error: error, complete: complete }
	        : observerOrNext;
	    return tapObserver
	        ? lift_1.operate(function (source, subscriber) {
	            var _a;
	            (_a = tapObserver.subscribe) === null || _a === void 0 ? void 0 : _a.call(tapObserver);
	            var isUnsub = true;
	            source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (value) {
	                var _a;
	                (_a = tapObserver.next) === null || _a === void 0 ? void 0 : _a.call(tapObserver, value);
	                subscriber.next(value);
	            }, function () {
	                var _a;
	                isUnsub = false;
	                (_a = tapObserver.complete) === null || _a === void 0 ? void 0 : _a.call(tapObserver);
	                subscriber.complete();
	            }, function (err) {
	                var _a;
	                isUnsub = false;
	                (_a = tapObserver.error) === null || _a === void 0 ? void 0 : _a.call(tapObserver, err);
	                subscriber.error(err);
	            }, function () {
	                var _a, _b;
	                if (isUnsub) {
	                    (_a = tapObserver.unsubscribe) === null || _a === void 0 ? void 0 : _a.call(tapObserver);
	                }
	                (_b = tapObserver.finalize) === null || _b === void 0 ? void 0 : _b.call(tapObserver);
	            }));
	        })
	        :
	            identity_1.identity;
	}
	exports.tap = tap;
	//# sourceMappingURL=tap.js.map

/***/ },
/* 2097 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.throttleTime = void 0;
	var async_1 = __webpack_require__(63);
	var throttle_1 = __webpack_require__(581);
	var timer_1 = __webpack_require__(113);
	function throttleTime(duration, scheduler, config) {
	    if (scheduler === void 0) { scheduler = async_1.asyncScheduler; }
	    if (config === void 0) { config = throttle_1.defaultThrottleConfig; }
	    var duration$ = timer_1.timer(duration, scheduler);
	    return throttle_1.throttle(function () { return duration$; }, config);
	}
	exports.throttleTime = throttleTime;
	//# sourceMappingURL=throttleTime.js.map

/***/ },
/* 2098 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.TimeInterval = exports.timeInterval = void 0;
	var async_1 = __webpack_require__(63);
	var lift_1 = __webpack_require__(17);
	var OperatorSubscriber_1 = __webpack_require__(20);
	function timeInterval(scheduler) {
	    if (scheduler === void 0) { scheduler = async_1.asyncScheduler; }
	    return lift_1.operate(function (source, subscriber) {
	        var last = scheduler.now();
	        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (value) {
	            var now = scheduler.now();
	            var interval = now - last;
	            last = now;
	            subscriber.next(new TimeInterval(value, interval));
	        }));
	    });
	}
	exports.timeInterval = timeInterval;
	var TimeInterval = (function () {
	    function TimeInterval(value, interval) {
	        this.value = value;
	        this.interval = interval;
	    }
	    return TimeInterval;
	}());
	exports.TimeInterval = TimeInterval;
	//# sourceMappingURL=timeInterval.js.map

/***/ },
/* 2099 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.timeoutWith = void 0;
	var async_1 = __webpack_require__(63);
	var isDate_1 = __webpack_require__(338);
	var timeout_1 = __webpack_require__(334);
	function timeoutWith(due, withObservable, scheduler) {
	    var first;
	    var each;
	    var _with;
	    scheduler = scheduler !== null && scheduler !== void 0 ? scheduler : async_1.async;
	    if (isDate_1.isValidDate(due)) {
	        first = due;
	    }
	    else if (typeof due === 'number') {
	        each = due;
	    }
	    if (withObservable) {
	        _with = function () { return withObservable; };
	    }
	    else {
	        throw new TypeError('No observable provided to switch to');
	    }
	    if (first == null && each == null) {
	        throw new TypeError('No timeout provided.');
	    }
	    return timeout_1.timeout({
	        first: first,
	        each: each,
	        scheduler: scheduler,
	        with: _with,
	    });
	}
	exports.timeoutWith = timeoutWith;
	//# sourceMappingURL=timeoutWith.js.map

/***/ },
/* 2100 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.timestamp = void 0;
	var dateTimestampProvider_1 = __webpack_require__(335);
	var map_1 = __webpack_require__(114);
	function timestamp(timestampProvider) {
	    if (timestampProvider === void 0) { timestampProvider = dateTimestampProvider_1.dateTimestampProvider; }
	    return map_1.map(function (value) { return ({ value: value, timestamp: timestampProvider.now() }); });
	}
	exports.timestamp = timestamp;
	//# sourceMappingURL=timestamp.js.map

/***/ },
/* 2101 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.window = void 0;
	var Subject_1 = __webpack_require__(51);
	var lift_1 = __webpack_require__(17);
	var OperatorSubscriber_1 = __webpack_require__(20);
	var noop_1 = __webpack_require__(52);
	function window(windowBoundaries) {
	    return lift_1.operate(function (source, subscriber) {
	        var windowSubject = new Subject_1.Subject();
	        subscriber.next(windowSubject.asObservable());
	        var errorHandler = function (err) {
	            windowSubject.error(err);
	            subscriber.error(err);
	        };
	        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (value) { return windowSubject === null || windowSubject === void 0 ? void 0 : windowSubject.next(value); }, function () {
	            windowSubject.complete();
	            subscriber.complete();
	        }, errorHandler));
	        windowBoundaries.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function () {
	            windowSubject.complete();
	            subscriber.next((windowSubject = new Subject_1.Subject()));
	        }, noop_1.noop, errorHandler));
	        return function () {
	            windowSubject === null || windowSubject === void 0 ? void 0 : windowSubject.unsubscribe();
	            windowSubject = null;
	        };
	    });
	}
	exports.window = window;
	//# sourceMappingURL=window.js.map

/***/ },
/* 2102 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __values = (this && this.__values) || function(o) {
	    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
	    if (m) return m.call(o);
	    if (o && typeof o.length === "number") return {
	        next: function () {
	            if (o && i >= o.length) o = void 0;
	            return { value: o && o[i++], done: !o };
	        }
	    };
	    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.windowCount = void 0;
	var Subject_1 = __webpack_require__(51);
	var lift_1 = __webpack_require__(17);
	var OperatorSubscriber_1 = __webpack_require__(20);
	function windowCount(windowSize, startWindowEvery) {
	    if (startWindowEvery === void 0) { startWindowEvery = 0; }
	    var startEvery = startWindowEvery > 0 ? startWindowEvery : windowSize;
	    return lift_1.operate(function (source, subscriber) {
	        var windows = [new Subject_1.Subject()];
	        var starts = [];
	        var count = 0;
	        subscriber.next(windows[0].asObservable());
	        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (value) {
	            var e_1, _a;
	            try {
	                for (var windows_1 = __values(windows), windows_1_1 = windows_1.next(); !windows_1_1.done; windows_1_1 = windows_1.next()) {
	                    var window_1 = windows_1_1.value;
	                    window_1.next(value);
	                }
	            }
	            catch (e_1_1) { e_1 = { error: e_1_1 }; }
	            finally {
	                try {
	                    if (windows_1_1 && !windows_1_1.done && (_a = windows_1.return)) _a.call(windows_1);
	                }
	                finally { if (e_1) throw e_1.error; }
	            }
	            var c = count - windowSize + 1;
	            if (c >= 0 && c % startEvery === 0) {
	                windows.shift().complete();
	            }
	            if (++count % startEvery === 0) {
	                var window_2 = new Subject_1.Subject();
	                windows.push(window_2);
	                subscriber.next(window_2.asObservable());
	            }
	        }, function () {
	            while (windows.length > 0) {
	                windows.shift().complete();
	            }
	            subscriber.complete();
	        }, function (err) {
	            while (windows.length > 0) {
	                windows.shift().error(err);
	            }
	            subscriber.error(err);
	        }, function () {
	            starts = null;
	            windows = null;
	        }));
	    });
	}
	exports.windowCount = windowCount;
	//# sourceMappingURL=windowCount.js.map

/***/ },
/* 2103 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.windowTime = void 0;
	var Subject_1 = __webpack_require__(51);
	var async_1 = __webpack_require__(63);
	var Subscription_1 = __webpack_require__(62);
	var lift_1 = __webpack_require__(17);
	var OperatorSubscriber_1 = __webpack_require__(20);
	var arrRemove_1 = __webpack_require__(99);
	var args_1 = __webpack_require__(64);
	var executeSchedule_1 = __webpack_require__(100);
	function windowTime(windowTimeSpan) {
	    var _a, _b;
	    var otherArgs = [];
	    for (var _i = 1; _i < arguments.length; _i++) {
	        otherArgs[_i - 1] = arguments[_i];
	    }
	    var scheduler = (_a = args_1.popScheduler(otherArgs)) !== null && _a !== void 0 ? _a : async_1.asyncScheduler;
	    var windowCreationInterval = (_b = otherArgs[0]) !== null && _b !== void 0 ? _b : null;
	    var maxWindowSize = otherArgs[1] || Infinity;
	    return lift_1.operate(function (source, subscriber) {
	        var windowRecords = [];
	        var restartOnClose = false;
	        var closeWindow = function (record) {
	            var window = record.window, subs = record.subs;
	            window.complete();
	            subs.unsubscribe();
	            arrRemove_1.arrRemove(windowRecords, record);
	            restartOnClose && startWindow();
	        };
	        var startWindow = function () {
	            if (windowRecords) {
	                var subs = new Subscription_1.Subscription();
	                subscriber.add(subs);
	                var window_1 = new Subject_1.Subject();
	                var record_1 = {
	                    window: window_1,
	                    subs: subs,
	                    seen: 0,
	                };
	                windowRecords.push(record_1);
	                subscriber.next(window_1.asObservable());
	                executeSchedule_1.executeSchedule(subs, scheduler, function () { return closeWindow(record_1); }, windowTimeSpan);
	            }
	        };
	        if (windowCreationInterval !== null && windowCreationInterval >= 0) {
	            executeSchedule_1.executeSchedule(subscriber, scheduler, startWindow, windowCreationInterval, true);
	        }
	        else {
	            restartOnClose = true;
	        }
	        startWindow();
	        var loop = function (cb) { return windowRecords.slice().forEach(cb); };
	        var terminate = function (cb) {
	            loop(function (_a) {
	                var window = _a.window;
	                return cb(window);
	            });
	            cb(subscriber);
	            subscriber.unsubscribe();
	        };
	        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (value) {
	            loop(function (record) {
	                record.window.next(value);
	                maxWindowSize <= ++record.seen && closeWindow(record);
	            });
	        }, function () { return terminate(function (consumer) { return consumer.complete(); }); }, function (err) { return terminate(function (consumer) { return consumer.error(err); }); }));
	        return function () {
	            windowRecords = null;
	        };
	    });
	}
	exports.windowTime = windowTime;
	//# sourceMappingURL=windowTime.js.map

/***/ },
/* 2104 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __values = (this && this.__values) || function(o) {
	    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
	    if (m) return m.call(o);
	    if (o && typeof o.length === "number") return {
	        next: function () {
	            if (o && i >= o.length) o = void 0;
	            return { value: o && o[i++], done: !o };
	        }
	    };
	    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.windowToggle = void 0;
	var Subject_1 = __webpack_require__(51);
	var Subscription_1 = __webpack_require__(62);
	var lift_1 = __webpack_require__(17);
	var innerFrom_1 = __webpack_require__(28);
	var OperatorSubscriber_1 = __webpack_require__(20);
	var noop_1 = __webpack_require__(52);
	var arrRemove_1 = __webpack_require__(99);
	function windowToggle(openings, closingSelector) {
	    return lift_1.operate(function (source, subscriber) {
	        var windows = [];
	        var handleError = function (err) {
	            while (0 < windows.length) {
	                windows.shift().error(err);
	            }
	            subscriber.error(err);
	        };
	        innerFrom_1.innerFrom(openings).subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (openValue) {
	            var window = new Subject_1.Subject();
	            windows.push(window);
	            var closingSubscription = new Subscription_1.Subscription();
	            var closeWindow = function () {
	                arrRemove_1.arrRemove(windows, window);
	                window.complete();
	                closingSubscription.unsubscribe();
	            };
	            var closingNotifier;
	            try {
	                closingNotifier = innerFrom_1.innerFrom(closingSelector(openValue));
	            }
	            catch (err) {
	                handleError(err);
	                return;
	            }
	            subscriber.next(window.asObservable());
	            closingSubscription.add(closingNotifier.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, closeWindow, noop_1.noop, handleError)));
	        }, noop_1.noop));
	        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (value) {
	            var e_1, _a;
	            var windowsCopy = windows.slice();
	            try {
	                for (var windowsCopy_1 = __values(windowsCopy), windowsCopy_1_1 = windowsCopy_1.next(); !windowsCopy_1_1.done; windowsCopy_1_1 = windowsCopy_1.next()) {
	                    var window_1 = windowsCopy_1_1.value;
	                    window_1.next(value);
	                }
	            }
	            catch (e_1_1) { e_1 = { error: e_1_1 }; }
	            finally {
	                try {
	                    if (windowsCopy_1_1 && !windowsCopy_1_1.done && (_a = windowsCopy_1.return)) _a.call(windowsCopy_1);
	                }
	                finally { if (e_1) throw e_1.error; }
	            }
	        }, function () {
	            while (0 < windows.length) {
	                windows.shift().complete();
	            }
	            subscriber.complete();
	        }, handleError, function () {
	            while (0 < windows.length) {
	                windows.shift().unsubscribe();
	            }
	        }));
	    });
	}
	exports.windowToggle = windowToggle;
	//# sourceMappingURL=windowToggle.js.map

/***/ },
/* 2105 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.windowWhen = void 0;
	var Subject_1 = __webpack_require__(51);
	var lift_1 = __webpack_require__(17);
	var OperatorSubscriber_1 = __webpack_require__(20);
	var innerFrom_1 = __webpack_require__(28);
	function windowWhen(closingSelector) {
	    return lift_1.operate(function (source, subscriber) {
	        var window;
	        var closingSubscriber;
	        var handleError = function (err) {
	            window.error(err);
	            subscriber.error(err);
	        };
	        var openWindow = function () {
	            closingSubscriber === null || closingSubscriber === void 0 ? void 0 : closingSubscriber.unsubscribe();
	            window === null || window === void 0 ? void 0 : window.complete();
	            window = new Subject_1.Subject();
	            subscriber.next(window.asObservable());
	            var closingNotifier;
	            try {
	                closingNotifier = innerFrom_1.innerFrom(closingSelector());
	            }
	            catch (err) {
	                handleError(err);
	                return;
	            }
	            closingNotifier.subscribe((closingSubscriber = OperatorSubscriber_1.createOperatorSubscriber(subscriber, openWindow, openWindow, handleError)));
	        };
	        openWindow();
	        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (value) { return window.next(value); }, function () {
	            window.complete();
	            subscriber.complete();
	        }, handleError, function () {
	            closingSubscriber === null || closingSubscriber === void 0 ? void 0 : closingSubscriber.unsubscribe();
	            window = null;
	        }));
	    });
	}
	exports.windowWhen = windowWhen;
	//# sourceMappingURL=windowWhen.js.map

/***/ },
/* 2106 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	var __spreadArray = (this && this.__spreadArray) || function (to, from) {
	    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
	        to[j] = from[i];
	    return to;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.withLatestFrom = void 0;
	var lift_1 = __webpack_require__(17);
	var OperatorSubscriber_1 = __webpack_require__(20);
	var innerFrom_1 = __webpack_require__(28);
	var identity_1 = __webpack_require__(56);
	var noop_1 = __webpack_require__(52);
	var args_1 = __webpack_require__(64);
	function withLatestFrom() {
	    var inputs = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        inputs[_i] = arguments[_i];
	    }
	    var project = args_1.popResultSelector(inputs);
	    return lift_1.operate(function (source, subscriber) {
	        var len = inputs.length;
	        var otherValues = new Array(len);
	        var hasValue = inputs.map(function () { return false; });
	        var ready = false;
	        var _loop_1 = function (i) {
	            innerFrom_1.innerFrom(inputs[i]).subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (value) {
	                otherValues[i] = value;
	                if (!ready && !hasValue[i]) {
	                    hasValue[i] = true;
	                    (ready = hasValue.every(identity_1.identity)) && (hasValue = null);
	                }
	            }, noop_1.noop));
	        };
	        for (var i = 0; i < len; i++) {
	            _loop_1(i);
	        }
	        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (value) {
	            if (ready) {
	                var values = __spreadArray([value], __read(otherValues));
	                subscriber.next(project ? project.apply(void 0, __spreadArray([], __read(values))) : values);
	            }
	        }));
	    });
	}
	exports.withLatestFrom = withLatestFrom;
	//# sourceMappingURL=withLatestFrom.js.map

/***/ },
/* 2107 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	var __spreadArray = (this && this.__spreadArray) || function (to, from) {
	    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
	        to[j] = from[i];
	    return to;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.zip = void 0;
	var zip_1 = __webpack_require__(329);
	var lift_1 = __webpack_require__(17);
	function zip() {
	    var sources = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        sources[_i] = arguments[_i];
	    }
	    return lift_1.operate(function (source, subscriber) {
	        zip_1.zip.apply(void 0, __spreadArray([source], __read(sources))).subscribe(subscriber);
	    });
	}
	exports.zip = zip;
	//# sourceMappingURL=zip.js.map

/***/ },
/* 2108 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.zipAll = void 0;
	var zip_1 = __webpack_require__(329);
	var joinAllInternals_1 = __webpack_require__(574);
	function zipAll(project) {
	    return joinAllInternals_1.joinAllInternals(zip_1.zip, project);
	}
	exports.zipAll = zipAll;
	//# sourceMappingURL=zipAll.js.map

/***/ },
/* 2109 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	var __spreadArray = (this && this.__spreadArray) || function (to, from) {
	    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
	        to[j] = from[i];
	    return to;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.zipWith = void 0;
	var zip_1 = __webpack_require__(2107);
	function zipWith() {
	    var otherInputs = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        otherInputs[_i] = arguments[_i];
	    }
	    return zip_1.zip.apply(void 0, __spreadArray([], __read(otherInputs)));
	}
	exports.zipWith = zipWith;
	//# sourceMappingURL=zipWith.js.map

/***/ },
/* 2110 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.scheduleArray = void 0;
	var Observable_1 = __webpack_require__(34);
	function scheduleArray(input, scheduler) {
	    return new Observable_1.Observable(function (subscriber) {
	        var i = 0;
	        return scheduler.schedule(function () {
	            if (i === input.length) {
	                subscriber.complete();
	            }
	            else {
	                subscriber.next(input[i++]);
	                if (!subscriber.closed) {
	                    this.schedule();
	                }
	            }
	        });
	    });
	}
	exports.scheduleArray = scheduleArray;
	//# sourceMappingURL=scheduleArray.js.map

/***/ },
/* 2111 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.scheduleObservable = void 0;
	var innerFrom_1 = __webpack_require__(28);
	var observeOn_1 = __webpack_require__(226);
	var subscribeOn_1 = __webpack_require__(227);
	function scheduleObservable(input, scheduler) {
	    return innerFrom_1.innerFrom(input).pipe(subscribeOn_1.subscribeOn(scheduler), observeOn_1.observeOn(scheduler));
	}
	exports.scheduleObservable = scheduleObservable;
	//# sourceMappingURL=scheduleObservable.js.map

/***/ },
/* 2112 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.schedulePromise = void 0;
	var innerFrom_1 = __webpack_require__(28);
	var observeOn_1 = __webpack_require__(226);
	var subscribeOn_1 = __webpack_require__(227);
	function schedulePromise(input, scheduler) {
	    return innerFrom_1.innerFrom(input).pipe(subscribeOn_1.subscribeOn(scheduler), observeOn_1.observeOn(scheduler));
	}
	exports.schedulePromise = schedulePromise;
	//# sourceMappingURL=schedulePromise.js.map

/***/ },
/* 2113 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.scheduleReadableStreamLike = void 0;
	var scheduleAsyncIterable_1 = __webpack_require__(583);
	var isReadableStreamLike_1 = __webpack_require__(339);
	function scheduleReadableStreamLike(input, scheduler) {
	    return scheduleAsyncIterable_1.scheduleAsyncIterable(isReadableStreamLike_1.readableStreamLikeToAsyncGenerator(input), scheduler);
	}
	exports.scheduleReadableStreamLike = scheduleReadableStreamLike;
	//# sourceMappingURL=scheduleReadableStreamLike.js.map

/***/ },
/* 2114 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        if (typeof b !== "function" && b !== null)
	            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.Action = void 0;
	var Subscription_1 = __webpack_require__(62);
	var Action = (function (_super) {
	    __extends(Action, _super);
	    function Action(scheduler, work) {
	        return _super.call(this) || this;
	    }
	    Action.prototype.schedule = function (state, delay) {
	        if (delay === void 0) { delay = 0; }
	        return this;
	    };
	    return Action;
	}(Subscription_1.Subscription));
	exports.Action = Action;
	//# sourceMappingURL=Action.js.map

/***/ },
/* 2115 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        if (typeof b !== "function" && b !== null)
	            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.AnimationFrameAction = void 0;
	var AsyncAction_1 = __webpack_require__(168);
	var animationFrameProvider_1 = __webpack_require__(586);
	var AnimationFrameAction = (function (_super) {
	    __extends(AnimationFrameAction, _super);
	    function AnimationFrameAction(scheduler, work) {
	        var _this = _super.call(this, scheduler, work) || this;
	        _this.scheduler = scheduler;
	        _this.work = work;
	        return _this;
	    }
	    AnimationFrameAction.prototype.requestAsyncId = function (scheduler, id, delay) {
	        if (delay === void 0) { delay = 0; }
	        if (delay !== null && delay > 0) {
	            return _super.prototype.requestAsyncId.call(this, scheduler, id, delay);
	        }
	        scheduler.actions.push(this);
	        return scheduler._scheduled || (scheduler._scheduled = animationFrameProvider_1.animationFrameProvider.requestAnimationFrame(function () { return scheduler.flush(undefined); }));
	    };
	    AnimationFrameAction.prototype.recycleAsyncId = function (scheduler, id, delay) {
	        if (delay === void 0) { delay = 0; }
	        if ((delay != null && delay > 0) || (delay == null && this.delay > 0)) {
	            return _super.prototype.recycleAsyncId.call(this, scheduler, id, delay);
	        }
	        if (!scheduler.actions.some(function (action) { return action.id === id; })) {
	            animationFrameProvider_1.animationFrameProvider.cancelAnimationFrame(id);
	            scheduler._scheduled = undefined;
	        }
	        return undefined;
	    };
	    return AnimationFrameAction;
	}(AsyncAction_1.AsyncAction));
	exports.AnimationFrameAction = AnimationFrameAction;
	//# sourceMappingURL=AnimationFrameAction.js.map

/***/ },
/* 2116 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        if (typeof b !== "function" && b !== null)
	            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.AnimationFrameScheduler = void 0;
	var AsyncScheduler_1 = __webpack_require__(169);
	var AnimationFrameScheduler = (function (_super) {
	    __extends(AnimationFrameScheduler, _super);
	    function AnimationFrameScheduler() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    AnimationFrameScheduler.prototype.flush = function (action) {
	        this._active = true;
	        var flushId = this._scheduled;
	        this._scheduled = undefined;
	        var actions = this.actions;
	        var error;
	        action = action || actions.shift();
	        do {
	            if ((error = action.execute(action.state, action.delay))) {
	                break;
	            }
	        } while ((action = actions[0]) && action.id === flushId && actions.shift());
	        this._active = false;
	        if (error) {
	            while ((action = actions[0]) && action.id === flushId && actions.shift()) {
	                action.unsubscribe();
	            }
	            throw error;
	        }
	    };
	    return AnimationFrameScheduler;
	}(AsyncScheduler_1.AsyncScheduler));
	exports.AnimationFrameScheduler = AnimationFrameScheduler;
	//# sourceMappingURL=AnimationFrameScheduler.js.map

/***/ },
/* 2117 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        if (typeof b !== "function" && b !== null)
	            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.AsapAction = void 0;
	var AsyncAction_1 = __webpack_require__(168);
	var immediateProvider_1 = __webpack_require__(2124);
	var AsapAction = (function (_super) {
	    __extends(AsapAction, _super);
	    function AsapAction(scheduler, work) {
	        var _this = _super.call(this, scheduler, work) || this;
	        _this.scheduler = scheduler;
	        _this.work = work;
	        return _this;
	    }
	    AsapAction.prototype.requestAsyncId = function (scheduler, id, delay) {
	        if (delay === void 0) { delay = 0; }
	        if (delay !== null && delay > 0) {
	            return _super.prototype.requestAsyncId.call(this, scheduler, id, delay);
	        }
	        scheduler.actions.push(this);
	        return scheduler._scheduled || (scheduler._scheduled = immediateProvider_1.immediateProvider.setImmediate(scheduler.flush.bind(scheduler, undefined)));
	    };
	    AsapAction.prototype.recycleAsyncId = function (scheduler, id, delay) {
	        if (delay === void 0) { delay = 0; }
	        if ((delay != null && delay > 0) || (delay == null && this.delay > 0)) {
	            return _super.prototype.recycleAsyncId.call(this, scheduler, id, delay);
	        }
	        if (!scheduler.actions.some(function (action) { return action.id === id; })) {
	            immediateProvider_1.immediateProvider.clearImmediate(id);
	            scheduler._scheduled = undefined;
	        }
	        return undefined;
	    };
	    return AsapAction;
	}(AsyncAction_1.AsyncAction));
	exports.AsapAction = AsapAction;
	//# sourceMappingURL=AsapAction.js.map

/***/ },
/* 2118 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        if (typeof b !== "function" && b !== null)
	            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.AsapScheduler = void 0;
	var AsyncScheduler_1 = __webpack_require__(169);
	var AsapScheduler = (function (_super) {
	    __extends(AsapScheduler, _super);
	    function AsapScheduler() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    AsapScheduler.prototype.flush = function (action) {
	        this._active = true;
	        var flushId = this._scheduled;
	        this._scheduled = undefined;
	        var actions = this.actions;
	        var error;
	        action = action || actions.shift();
	        do {
	            if ((error = action.execute(action.state, action.delay))) {
	                break;
	            }
	        } while ((action = actions[0]) && action.id === flushId && actions.shift());
	        this._active = false;
	        if (error) {
	            while ((action = actions[0]) && action.id === flushId && actions.shift()) {
	                action.unsubscribe();
	            }
	            throw error;
	        }
	    };
	    return AsapScheduler;
	}(AsyncScheduler_1.AsyncScheduler));
	exports.AsapScheduler = AsapScheduler;
	//# sourceMappingURL=AsapScheduler.js.map

/***/ },
/* 2119 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        if (typeof b !== "function" && b !== null)
	            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.QueueAction = void 0;
	var AsyncAction_1 = __webpack_require__(168);
	var QueueAction = (function (_super) {
	    __extends(QueueAction, _super);
	    function QueueAction(scheduler, work) {
	        var _this = _super.call(this, scheduler, work) || this;
	        _this.scheduler = scheduler;
	        _this.work = work;
	        return _this;
	    }
	    QueueAction.prototype.schedule = function (state, delay) {
	        if (delay === void 0) { delay = 0; }
	        if (delay > 0) {
	            return _super.prototype.schedule.call(this, state, delay);
	        }
	        this.delay = delay;
	        this.state = state;
	        this.scheduler.flush(this);
	        return this;
	    };
	    QueueAction.prototype.execute = function (state, delay) {
	        return (delay > 0 || this.closed) ?
	            _super.prototype.execute.call(this, state, delay) :
	            this._execute(state, delay);
	    };
	    QueueAction.prototype.requestAsyncId = function (scheduler, id, delay) {
	        if (delay === void 0) { delay = 0; }
	        if ((delay != null && delay > 0) || (delay == null && this.delay > 0)) {
	            return _super.prototype.requestAsyncId.call(this, scheduler, id, delay);
	        }
	        return scheduler.flush(this);
	    };
	    return QueueAction;
	}(AsyncAction_1.AsyncAction));
	exports.QueueAction = QueueAction;
	//# sourceMappingURL=QueueAction.js.map

/***/ },
/* 2120 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        if (typeof b !== "function" && b !== null)
	            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.QueueScheduler = void 0;
	var AsyncScheduler_1 = __webpack_require__(169);
	var QueueScheduler = (function (_super) {
	    __extends(QueueScheduler, _super);
	    function QueueScheduler() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    return QueueScheduler;
	}(AsyncScheduler_1.AsyncScheduler));
	exports.QueueScheduler = QueueScheduler;
	//# sourceMappingURL=QueueScheduler.js.map

/***/ },
/* 2121 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        if (typeof b !== "function" && b !== null)
	            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.VirtualAction = exports.VirtualTimeScheduler = void 0;
	var AsyncAction_1 = __webpack_require__(168);
	var Subscription_1 = __webpack_require__(62);
	var AsyncScheduler_1 = __webpack_require__(169);
	var VirtualTimeScheduler = (function (_super) {
	    __extends(VirtualTimeScheduler, _super);
	    function VirtualTimeScheduler(schedulerActionCtor, maxFrames) {
	        if (schedulerActionCtor === void 0) { schedulerActionCtor = VirtualAction; }
	        if (maxFrames === void 0) { maxFrames = Infinity; }
	        var _this = _super.call(this, schedulerActionCtor, function () { return _this.frame; }) || this;
	        _this.maxFrames = maxFrames;
	        _this.frame = 0;
	        _this.index = -1;
	        return _this;
	    }
	    VirtualTimeScheduler.prototype.flush = function () {
	        var _a = this, actions = _a.actions, maxFrames = _a.maxFrames;
	        var error;
	        var action;
	        while ((action = actions[0]) && action.delay <= maxFrames) {
	            actions.shift();
	            this.frame = action.delay;
	            if ((error = action.execute(action.state, action.delay))) {
	                break;
	            }
	        }
	        if (error) {
	            while ((action = actions.shift())) {
	                action.unsubscribe();
	            }
	            throw error;
	        }
	    };
	    VirtualTimeScheduler.frameTimeFactor = 10;
	    return VirtualTimeScheduler;
	}(AsyncScheduler_1.AsyncScheduler));
	exports.VirtualTimeScheduler = VirtualTimeScheduler;
	var VirtualAction = (function (_super) {
	    __extends(VirtualAction, _super);
	    function VirtualAction(scheduler, work, index) {
	        if (index === void 0) { index = (scheduler.index += 1); }
	        var _this = _super.call(this, scheduler, work) || this;
	        _this.scheduler = scheduler;
	        _this.work = work;
	        _this.index = index;
	        _this.active = true;
	        _this.index = scheduler.index = index;
	        return _this;
	    }
	    VirtualAction.prototype.schedule = function (state, delay) {
	        if (delay === void 0) { delay = 0; }
	        if (Number.isFinite(delay)) {
	            if (!this.id) {
	                return _super.prototype.schedule.call(this, state, delay);
	            }
	            this.active = false;
	            var action = new VirtualAction(this.scheduler, this.work);
	            this.add(action);
	            return action.schedule(state, delay);
	        }
	        else {
	            return Subscription_1.Subscription.EMPTY;
	        }
	    };
	    VirtualAction.prototype.requestAsyncId = function (scheduler, id, delay) {
	        if (delay === void 0) { delay = 0; }
	        this.delay = scheduler.frame + delay;
	        var actions = scheduler.actions;
	        actions.push(this);
	        actions.sort(VirtualAction.sortActions);
	        return true;
	    };
	    VirtualAction.prototype.recycleAsyncId = function (scheduler, id, delay) {
	        if (delay === void 0) { delay = 0; }
	        return undefined;
	    };
	    VirtualAction.prototype._execute = function (state, delay) {
	        if (this.active === true) {
	            return _super.prototype._execute.call(this, state, delay);
	        }
	    };
	    VirtualAction.sortActions = function (a, b) {
	        if (a.delay === b.delay) {
	            if (a.index === b.index) {
	                return 0;
	            }
	            else if (a.index > b.index) {
	                return 1;
	            }
	            else {
	                return -1;
	            }
	        }
	        else if (a.delay > b.delay) {
	            return 1;
	        }
	        else {
	            return -1;
	        }
	    };
	    return VirtualAction;
	}(AsyncAction_1.AsyncAction));
	exports.VirtualAction = VirtualAction;
	//# sourceMappingURL=VirtualTimeScheduler.js.map

/***/ },
/* 2122 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.animationFrame = exports.animationFrameScheduler = void 0;
	var AnimationFrameAction_1 = __webpack_require__(2115);
	var AnimationFrameScheduler_1 = __webpack_require__(2116);
	exports.animationFrameScheduler = new AnimationFrameScheduler_1.AnimationFrameScheduler(AnimationFrameAction_1.AnimationFrameAction);
	exports.animationFrame = exports.animationFrameScheduler;
	//# sourceMappingURL=animationFrame.js.map

/***/ },
/* 2123 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.asap = exports.asapScheduler = void 0;
	var AsapAction_1 = __webpack_require__(2117);
	var AsapScheduler_1 = __webpack_require__(2118);
	exports.asapScheduler = new AsapScheduler_1.AsapScheduler(AsapAction_1.AsapAction);
	exports.asap = exports.asapScheduler;
	//# sourceMappingURL=asap.js.map

/***/ },
/* 2124 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	var __spreadArray = (this && this.__spreadArray) || function (to, from) {
	    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
	        to[j] = from[i];
	    return to;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.immediateProvider = void 0;
	var Immediate_1 = __webpack_require__(2129);
	var setImmediate = Immediate_1.Immediate.setImmediate, clearImmediate = Immediate_1.Immediate.clearImmediate;
	exports.immediateProvider = {
	    setImmediate: function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        var delegate = exports.immediateProvider.delegate;
	        return ((delegate === null || delegate === void 0 ? void 0 : delegate.setImmediate) || setImmediate).apply(void 0, __spreadArray([], __read(args)));
	    },
	    clearImmediate: function (handle) {
	        var delegate = exports.immediateProvider.delegate;
	        return ((delegate === null || delegate === void 0 ? void 0 : delegate.clearImmediate) || clearImmediate)(handle);
	    },
	    delegate: undefined,
	};
	//# sourceMappingURL=immediateProvider.js.map

/***/ },
/* 2125 */
/***/ function(module, exports) {

	"use strict";
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	var __spreadArray = (this && this.__spreadArray) || function (to, from) {
	    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
	        to[j] = from[i];
	    return to;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.intervalProvider = void 0;
	exports.intervalProvider = {
	    setInterval: function (handler, timeout) {
	        var args = [];
	        for (var _i = 2; _i < arguments.length; _i++) {
	            args[_i - 2] = arguments[_i];
	        }
	        var delegate = exports.intervalProvider.delegate;
	        if (delegate === null || delegate === void 0 ? void 0 : delegate.setInterval) {
	            return delegate.setInterval.apply(delegate, __spreadArray([handler, timeout], __read(args)));
	        }
	        return setInterval.apply(void 0, __spreadArray([handler, timeout], __read(args)));
	    },
	    clearInterval: function (handle) {
	        var delegate = exports.intervalProvider.delegate;
	        return ((delegate === null || delegate === void 0 ? void 0 : delegate.clearInterval) || clearInterval)(handle);
	    },
	    delegate: undefined,
	};
	//# sourceMappingURL=intervalProvider.js.map

/***/ },
/* 2126 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.performanceTimestampProvider = void 0;
	exports.performanceTimestampProvider = {
	    now: function () {
	        return (exports.performanceTimestampProvider.delegate || performance).now();
	    },
	    delegate: undefined,
	};
	//# sourceMappingURL=performanceTimestampProvider.js.map

/***/ },
/* 2127 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.queue = exports.queueScheduler = void 0;
	var QueueAction_1 = __webpack_require__(2119);
	var QueueScheduler_1 = __webpack_require__(2120);
	exports.queueScheduler = new QueueScheduler_1.QueueScheduler(QueueAction_1.QueueAction);
	exports.queue = exports.queueScheduler;
	//# sourceMappingURL=queue.js.map

/***/ },
/* 2128 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	//# sourceMappingURL=types.js.map

/***/ },
/* 2129 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.TestTools = exports.Immediate = void 0;
	var nextHandle = 1;
	var resolved;
	var activeHandles = {};
	function findAndClearHandle(handle) {
	    if (handle in activeHandles) {
	        delete activeHandles[handle];
	        return true;
	    }
	    return false;
	}
	exports.Immediate = {
	    setImmediate: function (cb) {
	        var handle = nextHandle++;
	        activeHandles[handle] = true;
	        if (!resolved) {
	            resolved = Promise.resolve();
	        }
	        resolved.then(function () { return findAndClearHandle(handle) && cb(); });
	        return handle;
	    },
	    clearImmediate: function (handle) {
	        findAndClearHandle(handle);
	    },
	};
	exports.TestTools = {
	    pending: function () {
	        return Object.keys(activeHandles).length;
	    }
	};
	//# sourceMappingURL=Immediate.js.map

/***/ },
/* 2130 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.isObservable = void 0;
	var Observable_1 = __webpack_require__(34);
	var isFunction_1 = __webpack_require__(31);
	function isObservable(obj) {
	    return !!obj && (obj instanceof Observable_1.Observable || (isFunction_1.isFunction(obj.lift) && isFunction_1.isFunction(obj.subscribe)));
	}
	exports.isObservable = isObservable;
	//# sourceMappingURL=isObservable.js.map

/***/ },
/* 2131 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.not = void 0;
	function not(pred, thisArg) {
	    return function (value, index) { return !pred.call(thisArg, value, index); };
	}
	exports.not = not;
	//# sourceMappingURL=not.js.map

/***/ },
/* 2132 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** @license React v0.13.6
	 * scheduler.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';Object.defineProperty(exports,"__esModule",{value:!0});var d=null,e=!1,g=3,k=-1,l=-1,m=!1,n=!1;function p(){if(!m){var a=d.expirationTime;n?q():n=!0;r(t,a)}}
	function u(){var a=d,b=d.next;if(d===b)d=null;else{var c=d.previous;d=c.next=b;b.previous=c}a.next=a.previous=null;c=a.callback;b=a.expirationTime;a=a.priorityLevel;var f=g,Q=l;g=a;l=b;try{var h=c()}finally{g=f,l=Q}if("function"===typeof h)if(h={callback:h,priorityLevel:a,expirationTime:b,next:null,previous:null},null===d)d=h.next=h.previous=h;else{c=null;a=d;do{if(a.expirationTime>=b){c=a;break}a=a.next}while(a!==d);null===c?c=d:c===d&&(d=h,p());b=c.previous;b.next=c.previous=h;h.next=c;h.previous=
	b}}function v(){if(-1===k&&null!==d&&1===d.priorityLevel){m=!0;try{do u();while(null!==d&&1===d.priorityLevel)}finally{m=!1,null!==d?p():n=!1}}}function t(a){m=!0;var b=e;e=a;try{if(a)for(;null!==d;){var c=exports.unstable_now();if(d.expirationTime<=c){do u();while(null!==d&&d.expirationTime<=c)}else break}else if(null!==d){do u();while(null!==d&&!w())}}finally{m=!1,e=b,null!==d?p():n=!1,v()}}
	var x=Date,y="function"===typeof setTimeout?setTimeout:void 0,z="function"===typeof clearTimeout?clearTimeout:void 0,A="function"===typeof requestAnimationFrame?requestAnimationFrame:void 0,B="function"===typeof cancelAnimationFrame?cancelAnimationFrame:void 0,C,D;function E(a){C=A(function(b){z(D);a(b)});D=y(function(){B(C);a(exports.unstable_now())},100)}
	if("object"===typeof performance&&"function"===typeof performance.now){var F=performance;exports.unstable_now=function(){return F.now()}}else exports.unstable_now=function(){return x.now()};var r,q,w,G=null;"undefined"!==typeof window?G=window:"undefined"!==typeof global&&(G=global);
	if(G&&G._schedMock){var H=G._schedMock;r=H[0];q=H[1];w=H[2];exports.unstable_now=H[3]}else if("undefined"===typeof window||"function"!==typeof MessageChannel){var I=null,J=function(a){if(null!==I)try{I(a)}finally{I=null}};r=function(a){null!==I?setTimeout(r,0,a):(I=a,setTimeout(J,0,!1))};q=function(){I=null};w=function(){return!1}}else{"undefined"!==typeof console&&("function"!==typeof A&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills"),
	"function"!==typeof B&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills"));var K=null,L=!1,M=-1,N=!1,O=!1,P=0,R=33,S=33;w=function(){return P<=exports.unstable_now()};var T=new MessageChannel,U=T.port2;T.port1.onmessage=function(){L=!1;var a=K,b=M;K=null;M=-1;var c=exports.unstable_now(),f=!1;if(0>=P-c)if(-1!==b&&b<=c)f=!0;else{N||(N=!0,E(V));K=a;M=b;return}if(null!==a){O=!0;try{a(f)}finally{O=!1}}};
	var V=function(a){if(null!==K){E(V);var b=a-P+S;b<S&&R<S?(8>b&&(b=8),S=b<R?R:b):R=b;P=a+S;L||(L=!0,U.postMessage(void 0))}else N=!1};r=function(a,b){K=a;M=b;O||0>b?U.postMessage(void 0):N||(N=!0,E(V))};q=function(){K=null;L=!1;M=-1}}exports.unstable_ImmediatePriority=1;exports.unstable_UserBlockingPriority=2;exports.unstable_NormalPriority=3;exports.unstable_IdlePriority=5;exports.unstable_LowPriority=4;
	exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3}var c=g,f=k;g=a;k=exports.unstable_now();try{return b()}finally{g=c,k=f,v()}};exports.unstable_next=function(a){switch(g){case 1:case 2:case 3:var b=3;break;default:b=g}var c=g,f=k;g=b;k=exports.unstable_now();try{return a()}finally{g=c,k=f,v()}};
	exports.unstable_scheduleCallback=function(a,b){var c=-1!==k?k:exports.unstable_now();if("object"===typeof b&&null!==b&&"number"===typeof b.timeout)b=c+b.timeout;else switch(g){case 1:b=c+-1;break;case 2:b=c+250;break;case 5:b=c+1073741823;break;case 4:b=c+1E4;break;default:b=c+5E3}a={callback:a,priorityLevel:g,expirationTime:b,next:null,previous:null};if(null===d)d=a.next=a.previous=a,p();else{c=null;var f=d;do{if(f.expirationTime>b){c=f;break}f=f.next}while(f!==d);null===c?c=d:c===d&&(d=a,p());
	b=c.previous;b.next=c.previous=a;a.next=c;a.previous=b}return a};exports.unstable_cancelCallback=function(a){var b=a.next;if(null!==b){if(b===a)d=null;else{a===d&&(d=b);var c=a.previous;c.next=b;b.previous=c}a.next=a.previous=null}};exports.unstable_wrapCallback=function(a){var b=g;return function(){var c=g,f=k;g=b;k=exports.unstable_now();try{return a.apply(this,arguments)}finally{g=c,k=f,v()}}};exports.unstable_getCurrentPriorityLevel=function(){return g};
	exports.unstable_shouldYield=function(){return!e&&(null!==d&&d.expirationTime<l||w())};exports.unstable_continueExecution=function(){null!==d&&p()};exports.unstable_pauseExecution=function(){};exports.unstable_getFirstCallbackNode=function(){return d};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 2133 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(2132);
	} else {
	  module.exports = require('./cjs/scheduler.development.js');
	}


/***/ },
/* 2134 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(883);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(25)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/index.js!./theme-global.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/index.js!./theme-global.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 2135 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(886);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(25)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../css-loader/index.js?importLoaders=1!../../../postcss-loader/index.js!./bootstrap.css", function() {
				var newContent = require("!!../../../css-loader/index.js?importLoaders=1!../../../postcss-loader/index.js!./bootstrap.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 2136 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(887);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(25)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!../../../../node_modules/sass-loader/index.js!./age-valid-modal.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!../../../../node_modules/sass-loader/index.js!./age-valid-modal.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 2137 */
[2204, 888],
/* 2138 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(889);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(25)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!../../../../../node_modules/sass-loader/index.js!./fraudulent-order-modal.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!../../../../../node_modules/sass-loader/index.js!./fraudulent-order-modal.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 2139 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(890);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(25)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!../../../../node_modules/sass-loader/index.js!./payment-form.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!../../../../node_modules/sass-loader/index.js!./payment-form.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 2140 */
[2204, 891],
/* 2141 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(892);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(25)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!../../../../node_modules/sass-loader/index.js!./list-item.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!../../../../node_modules/sass-loader/index.js!./list-item.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 2142 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(893);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(25)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!../../../../node_modules/sass-loader/index.js!./list.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!../../../../node_modules/sass-loader/index.js!./list.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 2143 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(894);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(25)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!../../../../node_modules/sass-loader/index.js!./category-badge.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!../../../../node_modules/sass-loader/index.js!./category-badge.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 2144 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(895);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(25)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!../../../../node_modules/sass-loader/index.js!./image-comingsoon.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!../../../../node_modules/sass-loader/index.js!./image-comingsoon.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 2145 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(896);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(25)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!../../../../node_modules/sass-loader/index.js!./product-details-quantity-selector.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!../../../../node_modules/sass-loader/index.js!./product-details-quantity-selector.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 2146 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(897);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(25)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!../../../../node_modules/sass-loader/index.js!./variant-selector.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!../../../../node_modules/sass-loader/index.js!./variant-selector.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 2147 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(898);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(25)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!../../../../../node_modules/sass-loader/index.js!./header-menu.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!../../../../../node_modules/sass-loader/index.js!./header-menu.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 2148 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(899);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(25)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!../../../../../node_modules/sass-loader/index.js!./header-styles.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!../../../../../node_modules/sass-loader/index.js!./header-styles.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 2149 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(900);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(25)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!../../../../../node_modules/sass-loader/index.js!./mobile-menu.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!../../../../../node_modules/sass-loader/index.js!./mobile-menu.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 2150 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(901);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(25)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!../../../../../node_modules/sass-loader/index.js!./search-form.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!../../../../../node_modules/sass-loader/index.js!./search-form.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 2151 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(902);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(25)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!../../../../../node_modules/sass-loader/index.js!./submenu-title.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!../../../../../node_modules/sass-loader/index.js!./submenu-title.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 2152 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(904);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(25)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!../../../../node_modules/sass-loader/index.js!./ktp-off-canvas.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!../../../../node_modules/sass-loader/index.js!./ktp-off-canvas.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 2153 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(905);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(25)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!../../../../node_modules/sass-loader/index.js!./signup-promotion.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!../../../../node_modules/sass-loader/index.js!./signup-promotion.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 2154 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(906);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(25)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!../../../../node_modules/sass-loader/index.js!./category-slider.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!../../../../node_modules/sass-loader/index.js!./category-slider.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 2155 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(907);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(25)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!../../../../../node_modules/sass-loader/index.js!./base-checkout-layout.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!../../../../../node_modules/sass-loader/index.js!./base-checkout-layout.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 2156 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(908);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(25)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!../../../../../node_modules/sass-loader/index.js!./delivery-form.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!../../../../../node_modules/sass-loader/index.js!./delivery-form.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 2157 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(909);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(25)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!../../../../../../node_modules/sass-loader/index.js!./payment-method-k-wallet.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!../../../../../../node_modules/sass-loader/index.js!./payment-method-k-wallet.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 2158 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(911);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(25)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!../../../../node_modules/sass-loader/index.js!./home-slider.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!../../../../node_modules/sass-loader/index.js!./home-slider.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 2159 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(912);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(25)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!../../../../node_modules/sass-loader/index.js!./infinite-scroller.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!../../../../node_modules/sass-loader/index.js!./infinite-scroller.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 2160 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(914);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(25)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!../../../../node_modules/sass-loader/index.js!./price-form.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!../../../../node_modules/sass-loader/index.js!./price-form.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 2161 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(915);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(25)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!../../../../node_modules/sass-loader/index.js!./product-tile.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!../../../../node_modules/sass-loader/index.js!./product-tile.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 2162 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(916);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(25)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!../../../../node_modules/sass-loader/index.js!./secondary-menu.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!../../../../node_modules/sass-loader/index.js!./secondary-menu.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 2163 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(917);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(25)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!../../../../node_modules/sass-loader/index.js!./affidavit-certification.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!../../../../node_modules/sass-loader/index.js!./affidavit-certification.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 2164 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(918);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(25)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!../../../../node_modules/sass-loader/index.js!./checkout-fail-page.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!../../../../node_modules/sass-loader/index.js!./checkout-fail-page.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 2165 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(920);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(25)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!../../../../node_modules/sass-loader/index.js!./frequent-questions.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!../../../../node_modules/sass-loader/index.js!./frequent-questions.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 2166 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(922);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(25)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!../../../../node_modules/sass-loader/index.js!./privacy.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!../../../../node_modules/sass-loader/index.js!./privacy.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 2167 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(925);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(25)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!../../../../node_modules/sass-loader/index.js!./return-policy.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!../../../../node_modules/sass-loader/index.js!./return-policy.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 2168 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(926);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(25)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!../../../../node_modules/sass-loader/index.js!./shipping-policy.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!../../../../node_modules/sass-loader/index.js!./shipping-policy.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 2169 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(927);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(25)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!../../../../node_modules/sass-loader/index.js!./show-stores.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!../../../../node_modules/sass-loader/index.js!./show-stores.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 2170 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(929);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(25)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!../../../../node_modules/sass-loader/index.js!./terms-conditions.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!../../../../node_modules/sass-loader/index.js!./terms-conditions.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 2171 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var Stylis = _interopDefault(__webpack_require__(2173));
	var _insertRulePlugin = _interopDefault(__webpack_require__(2172));
	var React = __webpack_require__(1);
	var React__default = _interopDefault(React);
	var unitless = _interopDefault(__webpack_require__(630));
	var reactIs = __webpack_require__(160);
	var memoize = _interopDefault(__webpack_require__(1752));
	var PropTypes = _interopDefault(__webpack_require__(4));
	var validAttr = _interopDefault(__webpack_require__(628));
	var merge = _interopDefault(__webpack_require__(1753));
	
	// 
	
	var interleave = (function (strings, interpolations) {
	  var result = [strings[0]];
	
	  for (var i = 0, len = interpolations.length; i < len; i += 1) {
	    result.push(interpolations[i], strings[i + 1]);
	  }
	
	  return result;
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
	  return typeof obj;
	} : function (obj) {
	  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	};
	
	var classCallCheck = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	var createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};
	
	var inherits = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }
	
	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	};
	
	var objectWithoutProperties = function (obj, keys) {
	  var target = {};
	
	  for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;
	    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	    target[i] = obj[i];
	  }
	
	  return target;
	};
	
	var possibleConstructorReturn = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && (typeof call === "object" || typeof call === "function") ? call : self;
	};
	
	// 
	var isPlainObject = (function (x) {
	  return (typeof x === 'undefined' ? 'undefined' : _typeof(x)) === 'object' && x.constructor === Object;
	});
	
	// 
	var EMPTY_ARRAY = Object.freeze([]);
	var EMPTY_OBJECT = Object.freeze({});
	
	// 
	function isFunction(test) {
	  return typeof test === 'function';
	}
	
	// 
	
	function getComponentName(target) {
	  return ( false ? typeof target === 'string' && target : false) || target.displayName || target.name || 'Component';
	}
	
	// 
	function isStatelessFunction(test) {
	  return typeof test === 'function' && !(test.prototype && test.prototype.isReactComponent);
	}
	
	// 
	function isStyledComponent(target) {
	  return target && typeof target.styledComponentId === 'string';
	}
	
	// 
	
	var SC_ATTR = typeof process !== 'undefined' && (({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_EMPTY_CART_IN_SECONDS":"720","REACT_APP_FINGERPRINT_ENDPOINT":"https://fku.staging.katapulk.com","REACT_APP_KWALLET_ENABLED":"false","REACT_APP_MAIN_STORE_API_HOST":"https://staging.api.cubalicores.com","REACT_APP_FINGERPRINT_PUBLIC_KEY":"mdaO5TIlVptg2wrFbMdU","REACT_APP_ENV":"develop","REACT_APP_RECAPTCHA_KEY":"b2ce3e581814036777f1fb9b2ccf62b4b368336a0cd142f9045d92dc8b0516670344ee2ac218b7cd98302c719eb99f127a9851f99977e1ba84d0190be8ad8473","REACT_APP_DISABLE_AUTH":"false","REACT_APP_API_HOST":"https://staging.api.cubalicores.com"}).REACT_APP_SC_ATTR || ({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_EMPTY_CART_IN_SECONDS":"720","REACT_APP_FINGERPRINT_ENDPOINT":"https://fku.staging.katapulk.com","REACT_APP_KWALLET_ENABLED":"false","REACT_APP_MAIN_STORE_API_HOST":"https://staging.api.cubalicores.com","REACT_APP_FINGERPRINT_PUBLIC_KEY":"mdaO5TIlVptg2wrFbMdU","REACT_APP_ENV":"develop","REACT_APP_RECAPTCHA_KEY":"b2ce3e581814036777f1fb9b2ccf62b4b368336a0cd142f9045d92dc8b0516670344ee2ac218b7cd98302c719eb99f127a9851f99977e1ba84d0190be8ad8473","REACT_APP_DISABLE_AUTH":"false","REACT_APP_API_HOST":"https://staging.api.cubalicores.com"}).SC_ATTR) || 'data-styled';
	
	var SC_VERSION_ATTR = 'data-styled-version';
	
	var SC_STREAM_ATTR = 'data-styled-streamed';
	
	var IS_BROWSER = typeof window !== 'undefined' && 'HTMLElement' in window;
	
	var DISABLE_SPEEDY = typeof SC_DISABLE_SPEEDY === 'boolean' && SC_DISABLE_SPEEDY || typeof process !== 'undefined' && (({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_EMPTY_CART_IN_SECONDS":"720","REACT_APP_FINGERPRINT_ENDPOINT":"https://fku.staging.katapulk.com","REACT_APP_KWALLET_ENABLED":"false","REACT_APP_MAIN_STORE_API_HOST":"https://staging.api.cubalicores.com","REACT_APP_FINGERPRINT_PUBLIC_KEY":"mdaO5TIlVptg2wrFbMdU","REACT_APP_ENV":"develop","REACT_APP_RECAPTCHA_KEY":"b2ce3e581814036777f1fb9b2ccf62b4b368336a0cd142f9045d92dc8b0516670344ee2ac218b7cd98302c719eb99f127a9851f99977e1ba84d0190be8ad8473","REACT_APP_DISABLE_AUTH":"false","REACT_APP_API_HOST":"https://staging.api.cubalicores.com"}).REACT_APP_SC_DISABLE_SPEEDY || ({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_EMPTY_CART_IN_SECONDS":"720","REACT_APP_FINGERPRINT_ENDPOINT":"https://fku.staging.katapulk.com","REACT_APP_KWALLET_ENABLED":"false","REACT_APP_MAIN_STORE_API_HOST":"https://staging.api.cubalicores.com","REACT_APP_FINGERPRINT_PUBLIC_KEY":"mdaO5TIlVptg2wrFbMdU","REACT_APP_ENV":"develop","REACT_APP_RECAPTCHA_KEY":"b2ce3e581814036777f1fb9b2ccf62b4b368336a0cd142f9045d92dc8b0516670344ee2ac218b7cd98302c719eb99f127a9851f99977e1ba84d0190be8ad8473","REACT_APP_DISABLE_AUTH":"false","REACT_APP_API_HOST":"https://staging.api.cubalicores.com"}).SC_DISABLE_SPEEDY) || ("production") !== 'production';
	
	// Shared empty execution context when generating static styles
	var STATIC_EXECUTION_CONTEXT = {};
	
	// 
	
	
	/**
	 * Parse errors.md and turn it into a simple hash of code: message
	 */
	var ERRORS =  false ? {
	  "1": "Cannot create styled-component for component: %s.\n\n",
	  "2": "Can't collect styles once you've consumed a `ServerStyleSheet`'s styles! `ServerStyleSheet` is a one off instance for each server-side render cycle.\n\n- Are you trying to reuse it across renders?\n- Are you accidentally calling collectStyles twice?\n\n",
	  "3": "Streaming SSR is only supported in a Node.js environment; Please do not try to call this method in the browser.\n\n",
	  "4": "The `StyleSheetManager` expects a valid target or sheet prop!\n\n- Does this error occur on the client and is your target falsy?\n- Does this error occur on the server and is the sheet falsy?\n\n",
	  "5": "The clone method cannot be used on the client!\n\n- Are you running in a client-like environment on the server?\n- Are you trying to run SSR on the client?\n\n",
	  "6": "Trying to insert a new style tag, but the given Node is unmounted!\n\n- Are you using a custom target that isn't mounted?\n- Does your document not have a valid head element?\n- Have you accidentally removed a style tag manually?\n\n",
	  "7": "ThemeProvider: Please return an object from your \"theme\" prop function, e.g.\n\n```js\ntheme={() => ({})}\n```\n\n",
	  "8": "ThemeProvider: Please make your \"theme\" prop an object.\n\n",
	  "9": "Missing document `<head>`\n\n",
	  "10": "Cannot find a StyleSheet instance. Usually this happens if there are multiple copies of styled-components loaded at once. Check out this issue for how to troubleshoot and fix the common cases where this situation can happen: https://github.com/styled-components/styled-components/issues/1941#issuecomment-417862021\n\n",
	  "11": "_This error was replaced with a dev-time warning, it will be deleted for v4 final._ [createGlobalStyle] received children which will not be rendered. Please use the component without passing children elements.\n\n",
	  "12": "It seems you are interpolating a keyframe declaration (%s) into an untagged string. This was supported in styled-components v3, but is not longer supported in v4 as keyframes are now injected on-demand. Please wrap your string in the css\\`\\` helper which ensures the styles are injected correctly. See https://www.styled-components.com/docs/api#css\n\n",
	  "13": "%s is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details.\n"
	} : {};
	
	/**
	 * super basic version of sprintf
	 */
	function format() {
	  var a = arguments.length <= 0 ? undefined : arguments[0];
	  var b = [];
	
	  for (var c = 1, len = arguments.length; c < len; c += 1) {
	    b.push(arguments.length <= c ? undefined : arguments[c]);
	  }
	
	  b.forEach(function (d) {
	    a = a.replace(/%[a-z]/, d);
	  });
	
	  return a;
	}
	
	/**
	 * Create an error file out of errors.md for development and a simple web link to the full errors
	 * in production mode.
	 */
	
	var StyledComponentsError = function (_Error) {
	  inherits(StyledComponentsError, _Error);
	
	  function StyledComponentsError(code) {
	    classCallCheck(this, StyledComponentsError);
	
	    for (var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      interpolations[_key - 1] = arguments[_key];
	    }
	
	    if (true) {
	      var _this = possibleConstructorReturn(this, _Error.call(this, 'An error occurred. See https://github.com/styled-components/styled-components/blob/master/packages/styled-components/src/utils/errors.md#' + code + ' for more information.' + (interpolations.length > 0 ? ' Additional arguments: ' + interpolations.join(', ') : '')));
	    } else {
	      var _this = possibleConstructorReturn(this, _Error.call(this, format.apply(undefined, [ERRORS[code]].concat(interpolations)).trim()));
	    }
	    return possibleConstructorReturn(_this);
	  }
	
	  return StyledComponentsError;
	}(Error);
	
	// 
	var SC_COMPONENT_ID = /^[^\S\n]*?\/\* sc-component-id:\s*(\S+)\s+\*\//gm;
	
	var extractComps = (function (maybeCSS) {
	  var css = '' + (maybeCSS || ''); // Definitely a string, and a clone
	  var existingComponents = [];
	  css.replace(SC_COMPONENT_ID, function (match, componentId, matchIndex) {
	    existingComponents.push({ componentId: componentId, matchIndex: matchIndex });
	    return match;
	  });
	  return existingComponents.map(function (_ref, i) {
	    var componentId = _ref.componentId,
	        matchIndex = _ref.matchIndex;
	
	    var nextComp = existingComponents[i + 1];
	    var cssFromDOM = nextComp ? css.slice(matchIndex, nextComp.matchIndex) : css.slice(matchIndex);
	    return { componentId: componentId, cssFromDOM: cssFromDOM };
	  });
	});
	
	// 
	
	var COMMENT_REGEX = /^\s*\/\/.*$/gm;
	
	// NOTE: This stylis instance is only used to split rules from SSR'd style tags
	var stylisSplitter = new Stylis({
	  global: false,
	  cascade: true,
	  keyframe: false,
	  prefix: false,
	  compress: false,
	  semicolon: true
	});
	
	var stylis = new Stylis({
	  global: false,
	  cascade: true,
	  keyframe: false,
	  prefix: true,
	  compress: false,
	  semicolon: false // NOTE: This means "autocomplete missing semicolons"
	});
	
	// Wrap `insertRulePlugin to build a list of rules,
	// and then make our own plugin to return the rules. This
	// makes it easier to hook into the existing SSR architecture
	
	var parsingRules = [];
	
	// eslint-disable-next-line consistent-return
	var returnRulesPlugin = function returnRulesPlugin(context) {
	  if (context === -2) {
	    var parsedRules = parsingRules;
	    parsingRules = [];
	    return parsedRules;
	  }
	};
	
	var parseRulesPlugin = _insertRulePlugin(function (rule) {
	  parsingRules.push(rule);
	});
	
	var _componentId = void 0;
	var _selector = void 0;
	var _selectorRegexp = void 0;
	
	var selfReferenceReplacer = function selfReferenceReplacer(match, offset, string) {
	  if (
	  // the first self-ref is always untouched
	  offset > 0 &&
	  // there should be at least two self-refs to do a replacement (.b > .b)
	  string.slice(0, offset).indexOf(_selector) !== -1 &&
	  // no consecutive self refs (.b.b); that is a precedence boost and treated differently
	  string.slice(offset - _selector.length, offset) !== _selector) {
	    return '.' + _componentId;
	  }
	
	  return match;
	};
	
	/**
	 * When writing a style like
	 *
	 * & + & {
	 *   color: red;
	 * }
	 *
	 * The second ampersand should be a reference to the static component class. stylis
	 * has no knowledge of static class so we have to intelligently replace the base selector.
	 */
	var selfReferenceReplacementPlugin = function selfReferenceReplacementPlugin(context, _, selectors) {
	  if (context === 2 && selectors.length && selectors[0].lastIndexOf(_selector) > 0) {
	    // eslint-disable-next-line no-param-reassign
	    selectors[0] = selectors[0].replace(_selectorRegexp, selfReferenceReplacer);
	  }
	};
	
	stylis.use([selfReferenceReplacementPlugin, parseRulesPlugin, returnRulesPlugin]);
	stylisSplitter.use([parseRulesPlugin, returnRulesPlugin]);
	
	var splitByRules = function splitByRules(css) {
	  return stylisSplitter('', css);
	};
	
	function stringifyRules(rules, selector, prefix) {
	  var componentId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '&';
	
	  var flatCSS = rules.join('').replace(COMMENT_REGEX, ''); // replace JS comments
	
	  var cssStr = selector && prefix ? prefix + ' ' + selector + ' { ' + flatCSS + ' }' : flatCSS;
	
	  // stylis has no concept of state to be passed to plugins
	  // but since JS is single=threaded, we can rely on that to ensure
	  // these properties stay in sync with the current stylis run
	  _componentId = componentId;
	  _selector = selector;
	  _selectorRegexp = new RegExp('\\' + _selector + '\\b', 'g');
	
	  return stylis(prefix || !selector ? '' : selector, cssStr);
	}
	
	// 
	/* eslint-disable camelcase, no-undef */
	
	var getNonce = (function () {
	  return typeof __webpack_nonce__ !== 'undefined' ? __webpack_nonce__ : null;
	});
	
	// 
	/* These are helpers for the StyleTags to keep track of the injected
	 * rule names for each (component) ID that they're keeping track of.
	 * They're crucial for detecting whether a name has already been
	 * injected.
	 * (This excludes rehydrated names) */
	
	/* adds a new ID:name pairing to a names dictionary */
	var addNameForId = function addNameForId(names, id, name) {
	  if (name) {
	    // eslint-disable-next-line no-param-reassign
	    var namesForId = names[id] || (names[id] = Object.create(null));
	    namesForId[name] = true;
	  }
	};
	
	/* resets an ID entirely by overwriting it in the dictionary */
	var resetIdNames = function resetIdNames(names, id) {
	  // eslint-disable-next-line no-param-reassign
	  names[id] = Object.create(null);
	};
	
	/* factory for a names dictionary checking the existance of an ID:name pairing */
	var hasNameForId = function hasNameForId(names) {
	  return function (id, name) {
	    return names[id] !== undefined && names[id][name];
	  };
	};
	
	/* stringifies names for the html/element output */
	var stringifyNames = function stringifyNames(names) {
	  var str = '';
	  // eslint-disable-next-line guard-for-in
	  for (var id in names) {
	    str += Object.keys(names[id]).join(' ') + ' ';
	  }
	  return str.trim();
	};
	
	/* clones the nested names dictionary */
	var cloneNames = function cloneNames(names) {
	  var clone = Object.create(null);
	  // eslint-disable-next-line guard-for-in
	  for (var id in names) {
	    clone[id] = _extends({}, names[id]);
	  }
	  return clone;
	};
	
	// 
	
	/* These are helpers that deal with the insertRule (aka speedy) API
	 * They are used in the StyleTags and specifically the speedy tag
	 */
	
	/* retrieve a sheet for a given style tag */
	var sheetForTag = function sheetForTag(tag) {
	  // $FlowFixMe
	  if (tag.sheet) return tag.sheet;
	
	  /* Firefox quirk requires us to step through all stylesheets to find one owned by the given tag */
	  var size = tag.ownerDocument.styleSheets.length;
	  for (var i = 0; i < size; i += 1) {
	    var sheet = tag.ownerDocument.styleSheets[i];
	    // $FlowFixMe
	    if (sheet.ownerNode === tag) return sheet;
	  }
	
	  /* we should always be able to find a tag */
	  throw new StyledComponentsError(10);
	};
	
	/* insert a rule safely and return whether it was actually injected */
	var safeInsertRule = function safeInsertRule(sheet, cssRule, index) {
	  /* abort early if cssRule string is falsy */
	  if (!cssRule) return false;
	
	  var maxIndex = sheet.cssRules.length;
	
	  try {
	    /* use insertRule and cap passed index with maxIndex (no of cssRules) */
	    sheet.insertRule(cssRule, index <= maxIndex ? index : maxIndex);
	  } catch (err) {
	    /* any error indicates an invalid rule */
	    return false;
	  }
	
	  return true;
	};
	
	/* deletes `size` rules starting from `removalIndex` */
	var deleteRules = function deleteRules(sheet, removalIndex, size) {
	  var lowerBound = removalIndex - size;
	  for (var i = removalIndex; i > lowerBound; i -= 1) {
	    sheet.deleteRule(i);
	  }
	};
	
	// 
	
	/* this marker separates component styles and is important for rehydration */
	var makeTextMarker = function makeTextMarker(id) {
	  return '\n/* sc-component-id: ' + id + ' */\n';
	};
	
	/* add up all numbers in array up until and including the index */
	var addUpUntilIndex = function addUpUntilIndex(sizes, index) {
	  var totalUpToIndex = 0;
	  for (var i = 0; i <= index; i += 1) {
	    totalUpToIndex += sizes[i];
	  }
	
	  return totalUpToIndex;
	};
	
	/* create a new style tag after lastEl */
	var makeStyleTag = function makeStyleTag(target, tagEl, insertBefore) {
	  var targetDocument = document;
	  if (target) targetDocument = target.ownerDocument;else if (tagEl) targetDocument = tagEl.ownerDocument;
	
	  var el = targetDocument.createElement('style');
	  el.setAttribute(SC_ATTR, '');
	  el.setAttribute(SC_VERSION_ATTR, "4.4.1");
	
	  var nonce = getNonce();
	  if (nonce) {
	    el.setAttribute('nonce', nonce);
	  }
	
	  /* Work around insertRule quirk in EdgeHTML */
	  el.appendChild(targetDocument.createTextNode(''));
	
	  if (target && !tagEl) {
	    /* Append to target when no previous element was passed */
	    target.appendChild(el);
	  } else {
	    if (!tagEl || !target || !tagEl.parentNode) {
	      throw new StyledComponentsError(6);
	    }
	
	    /* Insert new style tag after the previous one */
	    tagEl.parentNode.insertBefore(el, insertBefore ? tagEl : tagEl.nextSibling);
	  }
	
	  return el;
	};
	
	/* takes a css factory function and outputs an html styled tag factory */
	var wrapAsHtmlTag = function wrapAsHtmlTag(css, names) {
	  return function (additionalAttrs) {
	    var nonce = getNonce();
	    var attrs = [nonce && 'nonce="' + nonce + '"', SC_ATTR + '="' + stringifyNames(names) + '"', SC_VERSION_ATTR + '="' + "4.4.1" + '"', additionalAttrs];
	
	    var htmlAttr = attrs.filter(Boolean).join(' ');
	    return '<style ' + htmlAttr + '>' + css() + '</style>';
	  };
	};
	
	/* takes a css factory function and outputs an element factory */
	var wrapAsElement = function wrapAsElement(css, names) {
	  return function () {
	    var _props;
	
	    var props = (_props = {}, _props[SC_ATTR] = stringifyNames(names), _props[SC_VERSION_ATTR] = "4.4.1", _props);
	
	    var nonce = getNonce();
	    if (nonce) {
	      // $FlowFixMe
	      props.nonce = nonce;
	    }
	
	    // eslint-disable-next-line react/no-danger
	    return React__default.createElement('style', _extends({}, props, { dangerouslySetInnerHTML: { __html: css() } }));
	  };
	};
	
	var getIdsFromMarkersFactory = function getIdsFromMarkersFactory(markers) {
	  return function () {
	    return Object.keys(markers);
	  };
	};
	
	/* speedy tags utilise insertRule */
	var makeSpeedyTag = function makeSpeedyTag(el, getImportRuleTag) {
	  var names = Object.create(null);
	  var markers = Object.create(null);
	  var sizes = [];
	
	  var extractImport = getImportRuleTag !== undefined;
	  /* indicates whether getImportRuleTag was called */
	  var usedImportRuleTag = false;
	
	  var insertMarker = function insertMarker(id) {
	    var prev = markers[id];
	    if (prev !== undefined) {
	      return prev;
	    }
	
	    markers[id] = sizes.length;
	    sizes.push(0);
	    resetIdNames(names, id);
	
	    return markers[id];
	  };
	
	  var insertRules = function insertRules(id, cssRules, name) {
	    var marker = insertMarker(id);
	    var sheet = sheetForTag(el);
	    var insertIndex = addUpUntilIndex(sizes, marker);
	
	    var injectedRules = 0;
	    var importRules = [];
	    var cssRulesSize = cssRules.length;
	
	    for (var i = 0; i < cssRulesSize; i += 1) {
	      var cssRule = cssRules[i];
	      var mayHaveImport = extractImport; /* @import rules are reordered to appear first */
	      if (mayHaveImport && cssRule.indexOf('@import') !== -1) {
	        importRules.push(cssRule);
	      } else if (safeInsertRule(sheet, cssRule, insertIndex + injectedRules)) {
	        mayHaveImport = false;
	        injectedRules += 1;
	      }
	    }
	
	    if (extractImport && importRules.length > 0) {
	      usedImportRuleTag = true;
	      // $FlowFixMe
	      getImportRuleTag().insertRules(id + '-import', importRules);
	    }
	
	    sizes[marker] += injectedRules; /* add up no of injected rules */
	    addNameForId(names, id, name);
	  };
	
	  var removeRules = function removeRules(id) {
	    var marker = markers[id];
	    if (marker === undefined) return;
	    // $FlowFixMe
	    if (el.isConnected === false) return;
	
	    var size = sizes[marker];
	    var sheet = sheetForTag(el);
	    var removalIndex = addUpUntilIndex(sizes, marker) - 1;
	    deleteRules(sheet, removalIndex, size);
	    sizes[marker] = 0;
	    resetIdNames(names, id);
	
	    if (extractImport && usedImportRuleTag) {
	      // $FlowFixMe
	      getImportRuleTag().removeRules(id + '-import');
	    }
	  };
	
	  var css = function css() {
	    var _sheetForTag = sheetForTag(el),
	        cssRules = _sheetForTag.cssRules;
	
	    var str = '';
	
	    // eslint-disable-next-line guard-for-in
	    for (var id in markers) {
	      str += makeTextMarker(id);
	      var marker = markers[id];
	      var end = addUpUntilIndex(sizes, marker);
	      var size = sizes[marker];
	      for (var i = end - size; i < end; i += 1) {
	        var rule = cssRules[i];
	        if (rule !== undefined) {
	          str += rule.cssText;
	        }
	      }
	    }
	
	    return str;
	  };
	
	  return {
	    clone: function clone() {
	      throw new StyledComponentsError(5);
	    },
	
	    css: css,
	    getIds: getIdsFromMarkersFactory(markers),
	    hasNameForId: hasNameForId(names),
	    insertMarker: insertMarker,
	    insertRules: insertRules,
	    removeRules: removeRules,
	    sealed: false,
	    styleTag: el,
	    toElement: wrapAsElement(css, names),
	    toHTML: wrapAsHtmlTag(css, names)
	  };
	};
	
	var makeTextNode = function makeTextNode(targetDocument, id) {
	  return targetDocument.createTextNode(makeTextMarker(id));
	};
	
	var makeBrowserTag = function makeBrowserTag(el, getImportRuleTag) {
	  var names = Object.create(null);
	  var markers = Object.create(null);
	
	  var extractImport = getImportRuleTag !== undefined;
	
	  /* indicates whether getImportRuleTag was called */
	  var usedImportRuleTag = false;
	
	  var insertMarker = function insertMarker(id) {
	    var prev = markers[id];
	    if (prev !== undefined) {
	      return prev;
	    }
	
	    markers[id] = makeTextNode(el.ownerDocument, id);
	    el.appendChild(markers[id]);
	    names[id] = Object.create(null);
	
	    return markers[id];
	  };
	
	  var insertRules = function insertRules(id, cssRules, name) {
	    var marker = insertMarker(id);
	    var importRules = [];
	    var cssRulesSize = cssRules.length;
	
	    for (var i = 0; i < cssRulesSize; i += 1) {
	      var rule = cssRules[i];
	      var mayHaveImport = extractImport;
	      if (mayHaveImport && rule.indexOf('@import') !== -1) {
	        importRules.push(rule);
	      } else {
	        mayHaveImport = false;
	        var separator = i === cssRulesSize - 1 ? '' : ' ';
	        marker.appendData('' + rule + separator);
	      }
	    }
	
	    addNameForId(names, id, name);
	
	    if (extractImport && importRules.length > 0) {
	      usedImportRuleTag = true;
	      // $FlowFixMe
	      getImportRuleTag().insertRules(id + '-import', importRules);
	    }
	  };
	
	  var removeRules = function removeRules(id) {
	    var marker = markers[id];
	    if (marker === undefined) return;
	
	    /* create new empty text node and replace the current one */
	    var newMarker = makeTextNode(el.ownerDocument, id);
	    el.replaceChild(newMarker, marker);
	    markers[id] = newMarker;
	    resetIdNames(names, id);
	
	    if (extractImport && usedImportRuleTag) {
	      // $FlowFixMe
	      getImportRuleTag().removeRules(id + '-import');
	    }
	  };
	
	  var css = function css() {
	    var str = '';
	
	    // eslint-disable-next-line guard-for-in
	    for (var id in markers) {
	      str += markers[id].data;
	    }
	
	    return str;
	  };
	
	  return {
	    clone: function clone() {
	      throw new StyledComponentsError(5);
	    },
	
	    css: css,
	    getIds: getIdsFromMarkersFactory(markers),
	    hasNameForId: hasNameForId(names),
	    insertMarker: insertMarker,
	    insertRules: insertRules,
	    removeRules: removeRules,
	    sealed: false,
	    styleTag: el,
	    toElement: wrapAsElement(css, names),
	    toHTML: wrapAsHtmlTag(css, names)
	  };
	};
	
	var makeServerTag = function makeServerTag(namesArg, markersArg) {
	  var names = namesArg === undefined ? Object.create(null) : namesArg;
	  var markers = markersArg === undefined ? Object.create(null) : markersArg;
	
	  var insertMarker = function insertMarker(id) {
	    var prev = markers[id];
	    if (prev !== undefined) {
	      return prev;
	    }
	
	    return markers[id] = [''];
	  };
	
	  var insertRules = function insertRules(id, cssRules, name) {
	    var marker = insertMarker(id);
	    marker[0] += cssRules.join(' ');
	    addNameForId(names, id, name);
	  };
	
	  var removeRules = function removeRules(id) {
	    var marker = markers[id];
	    if (marker === undefined) return;
	    marker[0] = '';
	    resetIdNames(names, id);
	  };
	
	  var css = function css() {
	    var str = '';
	    // eslint-disable-next-line guard-for-in
	    for (var id in markers) {
	      var cssForId = markers[id][0];
	      if (cssForId) {
	        str += makeTextMarker(id) + cssForId;
	      }
	    }
	    return str;
	  };
	
	  var clone = function clone() {
	    var namesClone = cloneNames(names);
	    var markersClone = Object.create(null);
	
	    // eslint-disable-next-line guard-for-in
	    for (var id in markers) {
	      markersClone[id] = [markers[id][0]];
	    }
	
	    return makeServerTag(namesClone, markersClone);
	  };
	
	  var tag = {
	    clone: clone,
	    css: css,
	    getIds: getIdsFromMarkersFactory(markers),
	    hasNameForId: hasNameForId(names),
	    insertMarker: insertMarker,
	    insertRules: insertRules,
	    removeRules: removeRules,
	    sealed: false,
	    styleTag: null,
	    toElement: wrapAsElement(css, names),
	    toHTML: wrapAsHtmlTag(css, names)
	  };
	
	  return tag;
	};
	
	var makeTag = function makeTag(target, tagEl, forceServer, insertBefore, getImportRuleTag) {
	  if (IS_BROWSER && !forceServer) {
	    var el = makeStyleTag(target, tagEl, insertBefore);
	
	    if (DISABLE_SPEEDY) {
	      return makeBrowserTag(el, getImportRuleTag);
	    } else {
	      return makeSpeedyTag(el, getImportRuleTag);
	    }
	  }
	
	  return makeServerTag();
	};
	
	var rehydrate = function rehydrate(tag, els, extracted) {
	  /* add all extracted components to the new tag */
	  for (var i = 0, len = extracted.length; i < len; i += 1) {
	    var _extracted$i = extracted[i],
	        componentId = _extracted$i.componentId,
	        cssFromDOM = _extracted$i.cssFromDOM;
	
	    var cssRules = splitByRules(cssFromDOM);
	    tag.insertRules(componentId, cssRules);
	  }
	
	  /* remove old HTMLStyleElements, since they have been rehydrated */
	  for (var _i = 0, _len = els.length; _i < _len; _i += 1) {
	    var el = els[_i];
	    if (el.parentNode) {
	      el.parentNode.removeChild(el);
	    }
	  }
	};
	
	// 
	
	var SPLIT_REGEX = /\s+/;
	
	/* determine the maximum number of components before tags are sharded */
	var MAX_SIZE = void 0;
	if (IS_BROWSER) {
	  /* in speedy mode we can keep a lot more rules in a sheet before a slowdown can be expected */
	  MAX_SIZE = DISABLE_SPEEDY ? 40 : 1000;
	} else {
	  /* for servers we do not need to shard at all */
	  MAX_SIZE = -1;
	}
	
	var sheetRunningId = 0;
	var master = void 0;
	
	var StyleSheet = function () {
	
	  /* a map from ids to tags */
	
	  /* deferred rules for a given id */
	
	  /* this is used for not reinjecting rules via hasNameForId() */
	
	  /* when rules for an id are removed using remove() we have to ignore rehydratedNames for it */
	
	  /* a list of tags belonging to this StyleSheet */
	
	  /* a tag for import rules */
	
	  /* current capacity until a new tag must be created */
	
	  /* children (aka clones) of this StyleSheet inheriting all and future injections */
	
	  function StyleSheet() {
	    var _this = this;
	
	    var target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : IS_BROWSER ? document.head : null;
	    var forceServer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	    classCallCheck(this, StyleSheet);
	
	    this.getImportRuleTag = function () {
	      var importRuleTag = _this.importRuleTag;
	
	      if (importRuleTag !== undefined) {
	        return importRuleTag;
	      }
	
	      var firstTag = _this.tags[0];
	      var insertBefore = true;
	
	      return _this.importRuleTag = makeTag(_this.target, firstTag ? firstTag.styleTag : null, _this.forceServer, insertBefore);
	    };
	
	    sheetRunningId += 1;
	    this.id = sheetRunningId;
	    this.forceServer = forceServer;
	    this.target = forceServer ? null : target;
	    this.tagMap = {};
	    this.deferred = {};
	    this.rehydratedNames = {};
	    this.ignoreRehydratedNames = {};
	    this.tags = [];
	    this.capacity = 1;
	    this.clones = [];
	  }
	
	  /* rehydrate all SSR'd style tags */
	
	
	  StyleSheet.prototype.rehydrate = function rehydrate$$1() {
	    if (!IS_BROWSER || this.forceServer) return this;
	
	    var els = [];
	    var extracted = [];
	    var isStreamed = false;
	
	    /* retrieve all of our SSR style elements from the DOM */
	    var nodes = document.querySelectorAll('style[' + SC_ATTR + '][' + SC_VERSION_ATTR + '="' + "4.4.1" + '"]');
	
	    var nodesSize = nodes.length;
	
	    /* abort rehydration if no previous style tags were found */
	    if (!nodesSize) return this;
	
	    for (var i = 0; i < nodesSize; i += 1) {
	      var el = nodes[i];
	
	      /* check if style tag is a streamed tag */
	      if (!isStreamed) isStreamed = !!el.getAttribute(SC_STREAM_ATTR);
	
	      /* retrieve all component names */
	      var elNames = (el.getAttribute(SC_ATTR) || '').trim().split(SPLIT_REGEX);
	      var elNamesSize = elNames.length;
	      for (var j = 0, name; j < elNamesSize; j += 1) {
	        name = elNames[j];
	        /* add rehydrated name to sheet to avoid re-adding styles */
	        this.rehydratedNames[name] = true;
	      }
	
	      /* extract all components and their CSS */
	      extracted.push.apply(extracted, extractComps(el.textContent));
	
	      /* store original HTMLStyleElement */
	      els.push(el);
	    }
	
	    /* abort rehydration if nothing was extracted */
	    var extractedSize = extracted.length;
	    if (!extractedSize) return this;
	
	    /* create a tag to be used for rehydration */
	    var tag = this.makeTag(null);
	
	    rehydrate(tag, els, extracted);
	
	    /* reset capacity and adjust MAX_SIZE by the initial size of the rehydration */
	    this.capacity = Math.max(1, MAX_SIZE - extractedSize);
	    this.tags.push(tag);
	
	    /* retrieve all component ids */
	    for (var _j = 0; _j < extractedSize; _j += 1) {
	      this.tagMap[extracted[_j].componentId] = tag;
	    }
	
	    return this;
	  };
	
	  /* retrieve a "master" instance of StyleSheet which is typically used when no other is available
	   * The master StyleSheet is targeted by createGlobalStyle, keyframes, and components outside of any
	    * StyleSheetManager's context */
	
	
	  /* reset the internal "master" instance */
	  StyleSheet.reset = function reset() {
	    var forceServer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	    master = new StyleSheet(undefined, forceServer).rehydrate();
	  };
	
	  /* adds "children" to the StyleSheet that inherit all of the parents' rules
	   * while their own rules do not affect the parent */
	
	
	  StyleSheet.prototype.clone = function clone() {
	    var sheet = new StyleSheet(this.target, this.forceServer);
	
	    /* add to clone array */
	    this.clones.push(sheet);
	
	    /* clone all tags */
	    sheet.tags = this.tags.map(function (tag) {
	      var ids = tag.getIds();
	      var newTag = tag.clone();
	
	      /* reconstruct tagMap */
	      for (var i = 0; i < ids.length; i += 1) {
	        sheet.tagMap[ids[i]] = newTag;
	      }
	
	      return newTag;
	    });
	
	    /* clone other maps */
	    sheet.rehydratedNames = _extends({}, this.rehydratedNames);
	    sheet.deferred = _extends({}, this.deferred);
	
	    return sheet;
	  };
	
	  /* force StyleSheet to create a new tag on the next injection */
	
	
	  StyleSheet.prototype.sealAllTags = function sealAllTags() {
	    this.capacity = 1;
	
	    this.tags.forEach(function (tag) {
	      // eslint-disable-next-line no-param-reassign
	      tag.sealed = true;
	    });
	  };
	
	  StyleSheet.prototype.makeTag = function makeTag$$1(tag) {
	    var lastEl = tag ? tag.styleTag : null;
	    var insertBefore = false;
	
	    return makeTag(this.target, lastEl, this.forceServer, insertBefore, this.getImportRuleTag);
	  };
	
	  /* get a tag for a given componentId, assign the componentId to one, or shard */
	  StyleSheet.prototype.getTagForId = function getTagForId(id) {
	    /* simply return a tag, when the componentId was already assigned one */
	    var prev = this.tagMap[id];
	    if (prev !== undefined && !prev.sealed) {
	      return prev;
	    }
	
	    var tag = this.tags[this.tags.length - 1];
	
	    /* shard (create a new tag) if the tag is exhausted (See MAX_SIZE) */
	    this.capacity -= 1;
	
	    if (this.capacity === 0) {
	      this.capacity = MAX_SIZE;
	      tag = this.makeTag(tag);
	      this.tags.push(tag);
	    }
	
	    return this.tagMap[id] = tag;
	  };
	
	  /* mainly for createGlobalStyle to check for its id */
	
	
	  StyleSheet.prototype.hasId = function hasId(id) {
	    return this.tagMap[id] !== undefined;
	  };
	
	  /* caching layer checking id+name to already have a corresponding tag and injected rules */
	
	
	  StyleSheet.prototype.hasNameForId = function hasNameForId(id, name) {
	    /* exception for rehydrated names which are checked separately */
	    if (this.ignoreRehydratedNames[id] === undefined && this.rehydratedNames[name]) {
	      return true;
	    }
	
	    var tag = this.tagMap[id];
	    return tag !== undefined && tag.hasNameForId(id, name);
	  };
	
	  /* registers a componentId and registers it on its tag */
	
	
	  StyleSheet.prototype.deferredInject = function deferredInject(id, cssRules) {
	    /* don't inject when the id is already registered */
	    if (this.tagMap[id] !== undefined) return;
	
	    var clones = this.clones;
	
	    for (var i = 0; i < clones.length; i += 1) {
	      clones[i].deferredInject(id, cssRules);
	    }
	
	    this.getTagForId(id).insertMarker(id);
	    this.deferred[id] = cssRules;
	  };
	
	  /* injects rules for a given id with a name that will need to be cached */
	
	
	  StyleSheet.prototype.inject = function inject(id, cssRules, name) {
	    var clones = this.clones;
	
	
	    for (var i = 0; i < clones.length; i += 1) {
	      clones[i].inject(id, cssRules, name);
	    }
	
	    var tag = this.getTagForId(id);
	
	    /* add deferred rules for component */
	    if (this.deferred[id] !== undefined) {
	      // Combine passed cssRules with previously deferred CSS rules
	      // NOTE: We cannot mutate the deferred array itself as all clones
	      // do the same (see clones[i].inject)
	      var rules = this.deferred[id].concat(cssRules);
	      tag.insertRules(id, rules, name);
	
	      this.deferred[id] = undefined;
	    } else {
	      tag.insertRules(id, cssRules, name);
	    }
	  };
	
	  /* removes all rules for a given id, which doesn't remove its marker but resets it */
	
	
	  StyleSheet.prototype.remove = function remove(id) {
	    var tag = this.tagMap[id];
	    if (tag === undefined) return;
	
	    var clones = this.clones;
	
	    for (var i = 0; i < clones.length; i += 1) {
	      clones[i].remove(id);
	    }
	
	    /* remove all rules from the tag */
	    tag.removeRules(id);
	
	    /* ignore possible rehydrated names */
	    this.ignoreRehydratedNames[id] = true;
	
	    /* delete possible deferred rules */
	    this.deferred[id] = undefined;
	  };
	
	  StyleSheet.prototype.toHTML = function toHTML() {
	    return this.tags.map(function (tag) {
	      return tag.toHTML();
	    }).join('');
	  };
	
	  StyleSheet.prototype.toReactElements = function toReactElements() {
	    var id = this.id;
	
	
	    return this.tags.map(function (tag, i) {
	      var key = 'sc-' + id + '-' + i;
	      return React.cloneElement(tag.toElement(), { key: key });
	    });
	  };
	
	  createClass(StyleSheet, null, [{
	    key: 'master',
	    get: function get$$1() {
	      return master || (master = new StyleSheet().rehydrate());
	    }
	
	    /* NOTE: This is just for backwards-compatibility with jest-styled-components */
	
	  }, {
	    key: 'instance',
	    get: function get$$1() {
	      return StyleSheet.master;
	    }
	  }]);
	  return StyleSheet;
	}();
	
	// 
	
	var Keyframes = function () {
	  function Keyframes(name, rules) {
	    var _this = this;
	
	    classCallCheck(this, Keyframes);
	
	    this.inject = function (styleSheet) {
	      if (!styleSheet.hasNameForId(_this.id, _this.name)) {
	        styleSheet.inject(_this.id, _this.rules, _this.name);
	      }
	    };
	
	    this.toString = function () {
	      throw new StyledComponentsError(12, String(_this.name));
	    };
	
	    this.name = name;
	    this.rules = rules;
	
	    this.id = 'sc-keyframes-' + name;
	  }
	
	  Keyframes.prototype.getName = function getName() {
	    return this.name;
	  };
	
	  return Keyframes;
	}();
	
	// 
	
	/**
	 * inlined version of
	 * https://github.com/facebook/fbjs/blob/master/packages/fbjs/src/core/hyphenateStyleName.js
	 */
	
	var uppercasePattern = /([A-Z])/g;
	var msPattern = /^ms-/;
	
	/**
	 * Hyphenates a camelcased CSS property name, for example:
	 *
	 *   > hyphenateStyleName('backgroundColor')
	 *   < "background-color"
	 *   > hyphenateStyleName('MozTransition')
	 *   < "-moz-transition"
	 *   > hyphenateStyleName('msTransition')
	 *   < "-ms-transition"
	 *
	 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
	 * is converted to `-ms-`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenateStyleName(string) {
	  return string.replace(uppercasePattern, '-$1').toLowerCase().replace(msPattern, '-ms-');
	}
	
	// 
	
	// Taken from https://github.com/facebook/react/blob/b87aabdfe1b7461e7331abb3601d9e6bb27544bc/packages/react-dom/src/shared/dangerousStyleValue.js
	function addUnitIfNeeded(name, value) {
	  // https://github.com/amilajack/eslint-plugin-flowtype-errors/issues/133
	  // $FlowFixMe
	  if (value == null || typeof value === 'boolean' || value === '') {
	    return '';
	  }
	
	  if (typeof value === 'number' && value !== 0 && !(name in unitless)) {
	    return value + 'px'; // Presumes implicit 'px' suffix for unitless numbers
	  }
	
	  return String(value).trim();
	}
	
	// 
	
	/**
	 * It's falsish not falsy because 0 is allowed.
	 */
	var isFalsish = function isFalsish(chunk) {
	  return chunk === undefined || chunk === null || chunk === false || chunk === '';
	};
	
	var objToCssArray = function objToCssArray(obj, prevKey) {
	  var rules = [];
	  var keys = Object.keys(obj);
	
	  keys.forEach(function (key) {
	    if (!isFalsish(obj[key])) {
	      if (isPlainObject(obj[key])) {
	        rules.push.apply(rules, objToCssArray(obj[key], key));
	
	        return rules;
	      } else if (isFunction(obj[key])) {
	        rules.push(hyphenateStyleName(key) + ':', obj[key], ';');
	
	        return rules;
	      }
	      rules.push(hyphenateStyleName(key) + ': ' + addUnitIfNeeded(key, obj[key]) + ';');
	    }
	    return rules;
	  });
	
	  return prevKey ? [prevKey + ' {'].concat(rules, ['}']) : rules;
	};
	
	function flatten(chunk, executionContext, styleSheet) {
	  if (Array.isArray(chunk)) {
	    var ruleSet = [];
	
	    for (var i = 0, len = chunk.length, result; i < len; i += 1) {
	      result = flatten(chunk[i], executionContext, styleSheet);
	
	      if (result === null) continue;else if (Array.isArray(result)) ruleSet.push.apply(ruleSet, result);else ruleSet.push(result);
	    }
	
	    return ruleSet;
	  }
	
	  if (isFalsish(chunk)) {
	    return null;
	  }
	
	  /* Handle other components */
	  if (isStyledComponent(chunk)) {
	    return '.' + chunk.styledComponentId;
	  }
	
	  /* Either execute or defer the function */
	  if (isFunction(chunk)) {
	    if (isStatelessFunction(chunk) && executionContext) {
	      var _result = chunk(executionContext);
	
	      if (false) {
	        // eslint-disable-next-line no-console
	        console.warn(getComponentName(chunk) + ' is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details.');
	      }
	
	      return flatten(_result, executionContext, styleSheet);
	    } else return chunk;
	  }
	
	  if (chunk instanceof Keyframes) {
	    if (styleSheet) {
	      chunk.inject(styleSheet);
	      return chunk.getName();
	    } else return chunk;
	  }
	
	  /* Handle objects */
	  return isPlainObject(chunk) ? objToCssArray(chunk) : chunk.toString();
	}
	
	// 
	
	function css(styles) {
	  for (var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    interpolations[_key - 1] = arguments[_key];
	  }
	
	  if (isFunction(styles) || isPlainObject(styles)) {
	    // $FlowFixMe
	    return flatten(interleave(EMPTY_ARRAY, [styles].concat(interpolations)));
	  }
	
	  // $FlowFixMe
	  return flatten(interleave(styles, interpolations));
	}
	
	// 
	
	function constructWithOptions(componentConstructor, tag) {
	  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : EMPTY_OBJECT;
	
	  if (!reactIs.isValidElementType(tag)) {
	    throw new StyledComponentsError(1, String(tag));
	  }
	
	  /* This is callable directly as a template function */
	  // $FlowFixMe: Not typed to avoid destructuring arguments
	  var templateFunction = function templateFunction() {
	    return componentConstructor(tag, options, css.apply(undefined, arguments));
	  };
	
	  /* If config methods are called, wrap up a new template function and merge options */
	  templateFunction.withConfig = function (config) {
	    return constructWithOptions(componentConstructor, tag, _extends({}, options, config));
	  };
	
	  /* Modify/inject new props at runtime */
	  templateFunction.attrs = function (attrs) {
	    return constructWithOptions(componentConstructor, tag, _extends({}, options, {
	      attrs: Array.prototype.concat(options.attrs, attrs).filter(Boolean)
	    }));
	  };
	
	  return templateFunction;
	}
	
	// 
	// Source: https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
	function murmurhash(c) {
	  for (var e = c.length | 0, a = e | 0, d = 0, b; e >= 4;) {
	    b = c.charCodeAt(d) & 255 | (c.charCodeAt(++d) & 255) << 8 | (c.charCodeAt(++d) & 255) << 16 | (c.charCodeAt(++d) & 255) << 24, b = 1540483477 * (b & 65535) + ((1540483477 * (b >>> 16) & 65535) << 16), b ^= b >>> 24, b = 1540483477 * (b & 65535) + ((1540483477 * (b >>> 16) & 65535) << 16), a = 1540483477 * (a & 65535) + ((1540483477 * (a >>> 16) & 65535) << 16) ^ b, e -= 4, ++d;
	  }
	  switch (e) {
	    case 3:
	      a ^= (c.charCodeAt(d + 2) & 255) << 16;
	    case 2:
	      a ^= (c.charCodeAt(d + 1) & 255) << 8;
	    case 1:
	      a ^= c.charCodeAt(d) & 255, a = 1540483477 * (a & 65535) + ((1540483477 * (a >>> 16) & 65535) << 16);
	  }
	  a ^= a >>> 13;
	  a = 1540483477 * (a & 65535) + ((1540483477 * (a >>> 16) & 65535) << 16);
	  return (a ^ a >>> 15) >>> 0;
	}
	
	// 
	/* eslint-disable no-bitwise */
	
	/* This is the "capacity" of our alphabet i.e. 2x26 for all letters plus their capitalised
	 * counterparts */
	var charsLength = 52;
	
	/* start at 75 for 'a' until 'z' (25) and then start at 65 for capitalised letters */
	var getAlphabeticChar = function getAlphabeticChar(code) {
	  return String.fromCharCode(code + (code > 25 ? 39 : 97));
	};
	
	/* input a number, usually a hash and convert it to base-52 */
	function generateAlphabeticName(code) {
	  var name = '';
	  var x = void 0;
	
	  /* get a char and divide by alphabet-length */
	  for (x = code; x > charsLength; x = Math.floor(x / charsLength)) {
	    name = getAlphabeticChar(x % charsLength) + name;
	  }
	
	  return getAlphabeticChar(x % charsLength) + name;
	}
	
	// 
	
	function hasFunctionObjectKey(obj) {
	  // eslint-disable-next-line guard-for-in, no-restricted-syntax
	  for (var key in obj) {
	    if (isFunction(obj[key])) {
	      return true;
	    }
	  }
	
	  return false;
	}
	
	function isStaticRules(rules, attrs) {
	  for (var i = 0; i < rules.length; i += 1) {
	    var rule = rules[i];
	
	    // recursive case
	    if (Array.isArray(rule) && !isStaticRules(rule, attrs)) {
	      return false;
	    } else if (isFunction(rule) && !isStyledComponent(rule)) {
	      // functions are allowed to be static if they're just being
	      // used to get the classname of a nested styled component
	      return false;
	    }
	  }
	
	  if (attrs.some(function (x) {
	    return isFunction(x) || hasFunctionObjectKey(x);
	  })) return false;
	
	  return true;
	}
	
	// 
	
	/* combines hashStr (murmurhash) and nameGenerator for convenience */
	var hasher = function hasher(str) {
	  return generateAlphabeticName(murmurhash(str));
	};
	
	/*
	 ComponentStyle is all the CSS-specific stuff, not
	 the React-specific stuff.
	 */
	
	var ComponentStyle = function () {
	  function ComponentStyle(rules, attrs, componentId) {
	    classCallCheck(this, ComponentStyle);
	
	    this.rules = rules;
	    this.isStatic = ("production") === 'production' && isStaticRules(rules, attrs);
	    this.componentId = componentId;
	
	    if (!StyleSheet.master.hasId(componentId)) {
	      StyleSheet.master.deferredInject(componentId, []);
	    }
	  }
	
	  /*
	   * Flattens a rule set into valid CSS
	   * Hashes it, wraps the whole chunk in a .hash1234 {}
	   * Returns the hash to be injected on render()
	   * */
	
	
	  ComponentStyle.prototype.generateAndInjectStyles = function generateAndInjectStyles(executionContext, styleSheet) {
	    var isStatic = this.isStatic,
	        componentId = this.componentId,
	        lastClassName = this.lastClassName;
	
	    if (IS_BROWSER && isStatic && typeof lastClassName === 'string' && styleSheet.hasNameForId(componentId, lastClassName)) {
	      return lastClassName;
	    }
	
	    var flatCSS = flatten(this.rules, executionContext, styleSheet);
	    var name = hasher(this.componentId + flatCSS.join(''));
	    if (!styleSheet.hasNameForId(componentId, name)) {
	      styleSheet.inject(this.componentId, stringifyRules(flatCSS, '.' + name, undefined, componentId), name);
	    }
	
	    this.lastClassName = name;
	    return name;
	  };
	
	  ComponentStyle.generateName = function generateName(str) {
	    return hasher(str);
	  };
	
	  return ComponentStyle;
	}();
	
	// 
	
	var LIMIT = 200;
	
	var createWarnTooManyClasses = (function (displayName) {
	  var generatedClasses = {};
	  var warningSeen = false;
	
	  return function (className) {
	    if (!warningSeen) {
	      generatedClasses[className] = true;
	      if (Object.keys(generatedClasses).length >= LIMIT) {
	        // Unable to find latestRule in test environment.
	        /* eslint-disable no-console, prefer-template */
	        console.warn('Over ' + LIMIT + ' classes were generated for component ' + displayName + '. \n' + 'Consider using the attrs method, together with a style object for frequently changed styles.\n' + 'Example:\n' + '  const Component = styled.div.attrs(props => ({\n' + '    style: {\n' + '      background: props.background,\n' + '    },\n' + '  }))`width: 100%;`\n\n' + '  <Component />');
	        warningSeen = true;
	        generatedClasses = {};
	      }
	    }
	  };
	});
	
	// 
	
	var determineTheme = (function (props, fallbackTheme) {
	  var defaultProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : EMPTY_OBJECT;
	
	  // Props should take precedence over ThemeProvider, which should take precedence over
	  // defaultProps, but React automatically puts defaultProps on props.
	
	  /* eslint-disable react/prop-types, flowtype-errors/show-errors */
	  var isDefaultTheme = defaultProps ? props.theme === defaultProps.theme : false;
	  var theme = props.theme && !isDefaultTheme ? props.theme : fallbackTheme || defaultProps.theme;
	  /* eslint-enable */
	
	  return theme;
	});
	
	// 
	var escapeRegex = /[[\].#*$><+~=|^:(),"'`-]+/g;
	var dashesAtEnds = /(^-|-$)/g;
	
	/**
	 * TODO: Explore using CSS.escape when it becomes more available
	 * in evergreen browsers.
	 */
	function escape(str) {
	  return str
	  // Replace all possible CSS selectors
	  .replace(escapeRegex, '-')
	
	  // Remove extraneous hyphens at the start and end
	  .replace(dashesAtEnds, '');
	}
	
	// 
	
	function isTag(target) {
	  return typeof target === 'string' && ( false ? target.charAt(0) === target.charAt(0).toLowerCase() : true);
	}
	
	// 
	
	function generateDisplayName(target) {
	  // $FlowFixMe
	  return isTag(target) ? 'styled.' + target : 'Styled(' + getComponentName(target) + ')';
	}
	
	var _TYPE_STATICS;
	
	var REACT_STATICS = {
	  childContextTypes: true,
	  contextTypes: true,
	  defaultProps: true,
	  displayName: true,
	  getDerivedStateFromProps: true,
	  propTypes: true,
	  type: true
	};
	
	var KNOWN_STATICS = {
	  name: true,
	  length: true,
	  prototype: true,
	  caller: true,
	  callee: true,
	  arguments: true,
	  arity: true
	};
	
	var TYPE_STATICS = (_TYPE_STATICS = {}, _TYPE_STATICS[reactIs.ForwardRef] = {
	  $$typeof: true,
	  render: true
	}, _TYPE_STATICS);
	
	var defineProperty$1 = Object.defineProperty,
	    getOwnPropertyNames = Object.getOwnPropertyNames,
	    _Object$getOwnPropert = Object.getOwnPropertySymbols,
	    getOwnPropertySymbols = _Object$getOwnPropert === undefined ? function () {
	  return [];
	} : _Object$getOwnPropert,
	    getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor,
	    getPrototypeOf = Object.getPrototypeOf,
	    objectPrototype = Object.prototype;
	var arrayPrototype = Array.prototype;
	
	
	function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	  if (typeof sourceComponent !== 'string') {
	    // don't hoist over string (html) components
	
	    var inheritedComponent = getPrototypeOf(sourceComponent);
	
	    if (inheritedComponent && inheritedComponent !== objectPrototype) {
	      hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	    }
	
	    var keys = arrayPrototype.concat(getOwnPropertyNames(sourceComponent),
	    // $FlowFixMe
	    getOwnPropertySymbols(sourceComponent));
	
	    var targetStatics = TYPE_STATICS[targetComponent.$$typeof] || REACT_STATICS;
	
	    var sourceStatics = TYPE_STATICS[sourceComponent.$$typeof] || REACT_STATICS;
	
	    var i = keys.length;
	    var descriptor = void 0;
	    var key = void 0;
	
	    // eslint-disable-next-line no-plusplus
	    while (i--) {
	      key = keys[i];
	
	      if (
	      // $FlowFixMe
	      !KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) &&
	      // $FlowFixMe
	      !(targetStatics && targetStatics[key])) {
	        descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	
	        if (descriptor) {
	          try {
	            // Avoid failures from read-only properties
	            defineProperty$1(targetComponent, key, descriptor);
	          } catch (e) {
	            /* fail silently */
	          }
	        }
	      }
	    }
	
	    return targetComponent;
	  }
	
	  return targetComponent;
	}
	
	// 
	function isDerivedReactComponent(fn) {
	  return !!(fn && fn.prototype && fn.prototype.isReactComponent);
	}
	
	// 
	// Helper to call a given function, only once
	var once = (function (cb) {
	  var called = false;
	
	  return function () {
	    if (!called) {
	      called = true;
	      cb.apply(undefined, arguments);
	    }
	  };
	});
	
	// 
	
	var ThemeContext = React.createContext();
	
	var ThemeConsumer = ThemeContext.Consumer;
	
	/**
	 * Provide a theme to an entire react component tree via context
	 */
	
	var ThemeProvider = function (_Component) {
	  inherits(ThemeProvider, _Component);
	
	  function ThemeProvider(props) {
	    classCallCheck(this, ThemeProvider);
	
	    var _this = possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.getContext = memoize(_this.getContext.bind(_this));
	    _this.renderInner = _this.renderInner.bind(_this);
	    return _this;
	  }
	
	  ThemeProvider.prototype.render = function render() {
	    if (!this.props.children) return null;
	
	    return React__default.createElement(
	      ThemeContext.Consumer,
	      null,
	      this.renderInner
	    );
	  };
	
	  ThemeProvider.prototype.renderInner = function renderInner(outerTheme) {
	    var context = this.getContext(this.props.theme, outerTheme);
	
	    return React__default.createElement(
	      ThemeContext.Provider,
	      { value: context },
	      this.props.children
	    );
	  };
	
	  /**
	   * Get the theme from the props, supporting both (outerTheme) => {}
	   * as well as object notation
	   */
	
	
	  ThemeProvider.prototype.getTheme = function getTheme(theme, outerTheme) {
	    if (isFunction(theme)) {
	      var mergedTheme = theme(outerTheme);
	
	      if (false) {
	        throw new StyledComponentsError(7);
	      }
	
	      return mergedTheme;
	    }
	
	    if (theme === null || Array.isArray(theme) || (typeof theme === 'undefined' ? 'undefined' : _typeof(theme)) !== 'object') {
	      throw new StyledComponentsError(8);
	    }
	
	    return _extends({}, outerTheme, theme);
	  };
	
	  ThemeProvider.prototype.getContext = function getContext(theme, outerTheme) {
	    return this.getTheme(theme, outerTheme);
	  };
	
	  return ThemeProvider;
	}(React.Component);
	
	// 
	
	var CLOSING_TAG_R = /^\s*<\/[a-z]/i;
	
	var ServerStyleSheet = function () {
	  function ServerStyleSheet() {
	    classCallCheck(this, ServerStyleSheet);
	
	    /* The master sheet might be reset, so keep a reference here */
	    this.masterSheet = StyleSheet.master;
	    this.instance = this.masterSheet.clone();
	    this.sealed = false;
	  }
	
	  /**
	   * Mark the ServerStyleSheet as being fully emitted and manually GC it from the
	   * StyleSheet singleton.
	   */
	
	
	  ServerStyleSheet.prototype.seal = function seal() {
	    if (!this.sealed) {
	      /* Remove sealed StyleSheets from the master sheet */
	      var index = this.masterSheet.clones.indexOf(this.instance);
	      this.masterSheet.clones.splice(index, 1);
	      this.sealed = true;
	    }
	  };
	
	  ServerStyleSheet.prototype.collectStyles = function collectStyles(children) {
	    if (this.sealed) {
	      throw new StyledComponentsError(2);
	    }
	
	    return React__default.createElement(
	      StyleSheetManager,
	      { sheet: this.instance },
	      children
	    );
	  };
	
	  ServerStyleSheet.prototype.getStyleTags = function getStyleTags() {
	    this.seal();
	    return this.instance.toHTML();
	  };
	
	  ServerStyleSheet.prototype.getStyleElement = function getStyleElement() {
	    this.seal();
	    return this.instance.toReactElements();
	  };
	
	  ServerStyleSheet.prototype.interleaveWithNodeStream = function interleaveWithNodeStream(readableStream) {
	    var _this = this;
	
	    {
	      throw new StyledComponentsError(3);
	    }
	
	    /* the tag index keeps track of which tags have already been emitted */
	    var instance = this.instance;
	
	    var instanceTagIndex = 0;
	
	    var streamAttr = SC_STREAM_ATTR + '="true"';
	
	    var transformer = new stream.Transform({
	      transform: function appendStyleChunks(chunk, /* encoding */_, callback) {
	        var tags = instance.tags;
	
	        var html = '';
	
	        /* retrieve html for each new style tag */
	        for (; instanceTagIndex < tags.length; instanceTagIndex += 1) {
	          var tag = tags[instanceTagIndex];
	          html += tag.toHTML(streamAttr);
	        }
	
	        /* force our StyleSheets to emit entirely new tags */
	        instance.sealAllTags();
	
	        var renderedHtml = chunk.toString();
	
	        /* prepend style html to chunk, unless the start of the chunk is a closing tag in which case append right after that */
	        if (CLOSING_TAG_R.test(renderedHtml)) {
	          var endOfClosingTag = renderedHtml.indexOf('>');
	
	          this.push(renderedHtml.slice(0, endOfClosingTag + 1) + html + renderedHtml.slice(endOfClosingTag + 1));
	        } else this.push(html + renderedHtml);
	
	        callback();
	      }
	    });
	
	    readableStream.on('end', function () {
	      return _this.seal();
	    });
	
	    readableStream.on('error', function (err) {
	      _this.seal();
	
	      // forward the error to the transform stream
	      transformer.emit('error', err);
	    });
	
	    return readableStream.pipe(transformer);
	  };
	
	  return ServerStyleSheet;
	}();
	
	// 
	
	var StyleSheetContext = React.createContext();
	var StyleSheetConsumer = StyleSheetContext.Consumer;
	
	var StyleSheetManager = function (_Component) {
	  inherits(StyleSheetManager, _Component);
	
	  function StyleSheetManager(props) {
	    classCallCheck(this, StyleSheetManager);
	
	    var _this = possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.getContext = memoize(_this.getContext);
	    return _this;
	  }
	
	  StyleSheetManager.prototype.getContext = function getContext(sheet, target) {
	    if (sheet) {
	      return sheet;
	    } else if (target) {
	      return new StyleSheet(target);
	    } else {
	      throw new StyledComponentsError(4);
	    }
	  };
	
	  StyleSheetManager.prototype.render = function render() {
	    var _props = this.props,
	        children = _props.children,
	        sheet = _props.sheet,
	        target = _props.target;
	
	
	    return React__default.createElement(
	      StyleSheetContext.Provider,
	      { value: this.getContext(sheet, target) },
	       false ? React__default.Children.only(children) : children
	    );
	  };
	
	  return StyleSheetManager;
	}(React.Component);
	 false ? StyleSheetManager.propTypes = {
	  sheet: PropTypes.oneOfType([PropTypes.instanceOf(StyleSheet), PropTypes.instanceOf(ServerStyleSheet)]),
	
	  target: PropTypes.shape({
	    appendChild: PropTypes.func.isRequired
	  })
	} : void 0;
	
	// 
	
	var identifiers = {};
	
	/* We depend on components having unique IDs */
	function generateId(_ComponentStyle, _displayName, parentComponentId) {
	  var displayName = typeof _displayName !== 'string' ? 'sc' : escape(_displayName);
	
	  /**
	   * This ensures uniqueness if two components happen to share
	   * the same displayName.
	   */
	  var nr = (identifiers[displayName] || 0) + 1;
	  identifiers[displayName] = nr;
	
	  var componentId = displayName + '-' + _ComponentStyle.generateName(displayName + nr);
	
	  return parentComponentId ? parentComponentId + '-' + componentId : componentId;
	}
	
	// $FlowFixMe
	
	var StyledComponent = function (_Component) {
	  inherits(StyledComponent, _Component);
	
	  function StyledComponent() {
	    classCallCheck(this, StyledComponent);
	
	    var _this = possibleConstructorReturn(this, _Component.call(this));
	
	    _this.attrs = {};
	
	    _this.renderOuter = _this.renderOuter.bind(_this);
	    _this.renderInner = _this.renderInner.bind(_this);
	
	    if (false) {
	      _this.warnInnerRef = once(function (displayName) {
	        return (
	          // eslint-disable-next-line no-console
	          console.warn('The "innerRef" API has been removed in styled-components v4 in favor of React 16 ref forwarding, use "ref" instead like a typical component. "innerRef" was detected on component "' + displayName + '".')
	        );
	      });
	
	      _this.warnAttrsFnObjectKeyDeprecated = once(function (key, displayName) {
	        return (
	          // eslint-disable-next-line no-console
	          console.warn('Functions as object-form attrs({}) keys are now deprecated and will be removed in a future version of styled-components. Switch to the new attrs(props => ({})) syntax instead for easier and more powerful composition. The attrs key in question is "' + key + '" on component "' + displayName + '".', '\n ' + new Error().stack)
	        );
	      });
	
	      _this.warnNonStyledComponentAttrsObjectKey = once(function (key, displayName) {
	        return (
	          // eslint-disable-next-line no-console
	          console.warn('It looks like you\'ve used a non styled-component as the value for the "' + key + '" prop in an object-form attrs constructor of "' + displayName + '".\n' + 'You should use the new function-form attrs constructor which avoids this issue: attrs(props => ({ yourStuff }))\n' + "To continue using the deprecated object syntax, you'll need to wrap your component prop in a function to make it available inside the styled component (you'll still get the deprecation warning though.)\n" + ('For example, { ' + key + ': () => InnerComponent } instead of { ' + key + ': InnerComponent }'))
	        );
	      });
	    }
	    return _this;
	  }
	
	  StyledComponent.prototype.render = function render() {
	    return React__default.createElement(
	      StyleSheetConsumer,
	      null,
	      this.renderOuter
	    );
	  };
	
	  StyledComponent.prototype.renderOuter = function renderOuter() {
	    var styleSheet = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : StyleSheet.master;
	
	    this.styleSheet = styleSheet;
	
	    // No need to subscribe a static component to theme changes, it won't change anything
	    if (this.props.forwardedComponent.componentStyle.isStatic) return this.renderInner();
	
	    return React__default.createElement(
	      ThemeConsumer,
	      null,
	      this.renderInner
	    );
	  };
	
	  StyledComponent.prototype.renderInner = function renderInner(theme) {
	    var _props$forwardedCompo = this.props.forwardedComponent,
	        componentStyle = _props$forwardedCompo.componentStyle,
	        defaultProps = _props$forwardedCompo.defaultProps,
	        displayName = _props$forwardedCompo.displayName,
	        foldedComponentIds = _props$forwardedCompo.foldedComponentIds,
	        styledComponentId = _props$forwardedCompo.styledComponentId,
	        target = _props$forwardedCompo.target;
	
	
	    var generatedClassName = void 0;
	    if (componentStyle.isStatic) {
	      generatedClassName = this.generateAndInjectStyles(EMPTY_OBJECT, this.props);
	    } else {
	      generatedClassName = this.generateAndInjectStyles(determineTheme(this.props, theme, defaultProps) || EMPTY_OBJECT, this.props);
	    }
	
	    var elementToBeCreated = this.props.as || this.attrs.as || target;
	    var isTargetTag = isTag(elementToBeCreated);
	
	    var propsForElement = {};
	    var computedProps = _extends({}, this.props, this.attrs);
	
	    var key = void 0;
	    // eslint-disable-next-line guard-for-in
	    for (key in computedProps) {
	      if (false) {
	        this.warnInnerRef(displayName);
	      }
	
	      if (key === 'forwardedComponent' || key === 'as') {
	        continue;
	      } else if (key === 'forwardedRef') propsForElement.ref = computedProps[key];else if (key === 'forwardedAs') propsForElement.as = computedProps[key];else if (!isTargetTag || validAttr(key)) {
	        // Don't pass through non HTML tags through to HTML elements
	        propsForElement[key] = computedProps[key];
	      }
	    }
	
	    if (this.props.style && this.attrs.style) {
	      propsForElement.style = _extends({}, this.attrs.style, this.props.style);
	    }
	
	    propsForElement.className = Array.prototype.concat(foldedComponentIds, styledComponentId, generatedClassName !== styledComponentId ? generatedClassName : null, this.props.className, this.attrs.className).filter(Boolean).join(' ');
	
	    return React.createElement(elementToBeCreated, propsForElement);
	  };
	
	  StyledComponent.prototype.buildExecutionContext = function buildExecutionContext(theme, props, attrs) {
	    var _this2 = this;
	
	    var context = _extends({}, props, { theme: theme });
	
	    if (!attrs.length) return context;
	
	    this.attrs = {};
	
	    attrs.forEach(function (attrDef) {
	      var resolvedAttrDef = attrDef;
	      var attrDefWasFn = false;
	      var attr = void 0;
	      var key = void 0;
	
	      if (isFunction(resolvedAttrDef)) {
	        // $FlowFixMe
	        resolvedAttrDef = resolvedAttrDef(context);
	        attrDefWasFn = true;
	      }
	
	      /* eslint-disable guard-for-in */
	      // $FlowFixMe
	      for (key in resolvedAttrDef) {
	        attr = resolvedAttrDef[key];
	
	        if (!attrDefWasFn) {
	          if (isFunction(attr) && !isDerivedReactComponent(attr) && !isStyledComponent(attr)) {
	            if (false) {
	              _this2.warnAttrsFnObjectKeyDeprecated(key, props.forwardedComponent.displayName);
	            }
	
	            attr = attr(context);
	
	            if (false) {
	              _this2.warnNonStyledComponentAttrsObjectKey(key, props.forwardedComponent.displayName);
	            }
	          }
	        }
	
	        _this2.attrs[key] = attr;
	        context[key] = attr;
	      }
	      /* eslint-enable */
	    });
	
	    return context;
	  };
	
	  StyledComponent.prototype.generateAndInjectStyles = function generateAndInjectStyles(theme, props) {
	    var _props$forwardedCompo2 = props.forwardedComponent,
	        attrs = _props$forwardedCompo2.attrs,
	        componentStyle = _props$forwardedCompo2.componentStyle,
	        warnTooManyClasses = _props$forwardedCompo2.warnTooManyClasses;
	
	    // statically styled-components don't need to build an execution context object,
	    // and shouldn't be increasing the number of class names
	
	    if (componentStyle.isStatic && !attrs.length) {
	      return componentStyle.generateAndInjectStyles(EMPTY_OBJECT, this.styleSheet);
	    }
	
	    var className = componentStyle.generateAndInjectStyles(this.buildExecutionContext(theme, props, attrs), this.styleSheet);
	
	    if (false) warnTooManyClasses(className);
	
	    return className;
	  };
	
	  return StyledComponent;
	}(React.Component);
	
	function createStyledComponent(target, options, rules) {
	  var isTargetStyledComp = isStyledComponent(target);
	  var isClass = !isTag(target);
	
	  var _options$displayName = options.displayName,
	      displayName = _options$displayName === undefined ? generateDisplayName(target) : _options$displayName,
	      _options$componentId = options.componentId,
	      componentId = _options$componentId === undefined ? generateId(ComponentStyle, options.displayName, options.parentComponentId) : _options$componentId,
	      _options$ParentCompon = options.ParentComponent,
	      ParentComponent = _options$ParentCompon === undefined ? StyledComponent : _options$ParentCompon,
	      _options$attrs = options.attrs,
	      attrs = _options$attrs === undefined ? EMPTY_ARRAY : _options$attrs;
	
	
	  var styledComponentId = options.displayName && options.componentId ? escape(options.displayName) + '-' + options.componentId : options.componentId || componentId;
	
	  // fold the underlying StyledComponent attrs up (implicit extend)
	  var finalAttrs =
	  // $FlowFixMe
	  isTargetStyledComp && target.attrs ? Array.prototype.concat(target.attrs, attrs).filter(Boolean) : attrs;
	
	  var componentStyle = new ComponentStyle(isTargetStyledComp ? // fold the underlying StyledComponent rules up (implicit extend)
	  // $FlowFixMe
	  target.componentStyle.rules.concat(rules) : rules, finalAttrs, styledComponentId);
	
	  /**
	   * forwardRef creates a new interim component, which we'll take advantage of
	   * instead of extending ParentComponent to create _another_ interim class
	   */
	  var WrappedStyledComponent = void 0;
	  var forwardRef = function forwardRef(props, ref) {
	    return React__default.createElement(ParentComponent, _extends({}, props, { forwardedComponent: WrappedStyledComponent, forwardedRef: ref }));
	  };
	  forwardRef.displayName = displayName;
	  WrappedStyledComponent = React__default.forwardRef(forwardRef);
	  WrappedStyledComponent.displayName = displayName;
	
	  // $FlowFixMe
	  WrappedStyledComponent.attrs = finalAttrs;
	  // $FlowFixMe
	  WrappedStyledComponent.componentStyle = componentStyle;
	
	  // $FlowFixMe
	  WrappedStyledComponent.foldedComponentIds = isTargetStyledComp ? // $FlowFixMe
	  Array.prototype.concat(target.foldedComponentIds, target.styledComponentId) : EMPTY_ARRAY;
	
	  // $FlowFixMe
	  WrappedStyledComponent.styledComponentId = styledComponentId;
	
	  // fold the underlying StyledComponent target up since we folded the styles
	  // $FlowFixMe
	  WrappedStyledComponent.target = isTargetStyledComp ? target.target : target;
	
	  // $FlowFixMe
	  WrappedStyledComponent.withComponent = function withComponent(tag) {
	    var previousComponentId = options.componentId,
	        optionsToCopy = objectWithoutProperties(options, ['componentId']);
	
	
	    var newComponentId = previousComponentId && previousComponentId + '-' + (isTag(tag) ? tag : escape(getComponentName(tag)));
	
	    var newOptions = _extends({}, optionsToCopy, {
	      attrs: finalAttrs,
	      componentId: newComponentId,
	      ParentComponent: ParentComponent
	    });
	
	    return createStyledComponent(tag, newOptions, rules);
	  };
	
	  // $FlowFixMe
	  Object.defineProperty(WrappedStyledComponent, 'defaultProps', {
	    get: function get$$1() {
	      return this._foldedDefaultProps;
	    },
	    set: function set$$1(obj) {
	      // $FlowFixMe
	      this._foldedDefaultProps = isTargetStyledComp ? merge(target.defaultProps, obj) : obj;
	    }
	  });
	
	  if (false) {
	    // $FlowFixMe
	    WrappedStyledComponent.warnTooManyClasses = createWarnTooManyClasses(displayName);
	  }
	
	  // $FlowFixMe
	  WrappedStyledComponent.toString = function () {
	    return '.' + WrappedStyledComponent.styledComponentId;
	  };
	
	  if (isClass) {
	    hoistNonReactStatics(WrappedStyledComponent, target, {
	      // all SC-specific things should not be hoisted
	      attrs: true,
	      componentStyle: true,
	      displayName: true,
	      foldedComponentIds: true,
	      styledComponentId: true,
	      target: true,
	      withComponent: true
	    });
	  }
	
	  return WrappedStyledComponent;
	}
	
	// 
	// Thanks to ReactDOMFactories for this handy list!
	
	var domElements = ['a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'big', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'data', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meta', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'script', 'section', 'select', 'small', 'source', 'span', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'title', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr',
	
	// SVG
	'circle', 'clipPath', 'defs', 'ellipse', 'foreignObject', 'g', 'image', 'line', 'linearGradient', 'marker', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'svg', 'text', 'tspan'];
	
	// 
	
	var styled = function styled(tag) {
	  return constructWithOptions(createStyledComponent, tag);
	};
	
	// Shorthands for all valid HTML Elements
	domElements.forEach(function (domElement) {
	  styled[domElement] = styled(domElement);
	});
	
	// 
	
	var GlobalStyle = function () {
	  function GlobalStyle(rules, componentId) {
	    classCallCheck(this, GlobalStyle);
	
	    this.rules = rules;
	    this.componentId = componentId;
	    this.isStatic = isStaticRules(rules, EMPTY_ARRAY);
	
	    if (!StyleSheet.master.hasId(componentId)) {
	      StyleSheet.master.deferredInject(componentId, []);
	    }
	  }
	
	  GlobalStyle.prototype.createStyles = function createStyles(executionContext, styleSheet) {
	    var flatCSS = flatten(this.rules, executionContext, styleSheet);
	    var css = stringifyRules(flatCSS, '');
	
	    styleSheet.inject(this.componentId, css);
	  };
	
	  GlobalStyle.prototype.removeStyles = function removeStyles(styleSheet) {
	    var componentId = this.componentId;
	
	    if (styleSheet.hasId(componentId)) {
	      styleSheet.remove(componentId);
	    }
	  };
	
	  // TODO: overwrite in-place instead of remove+create?
	
	
	  GlobalStyle.prototype.renderStyles = function renderStyles(executionContext, styleSheet) {
	    this.removeStyles(styleSheet);
	    this.createStyles(executionContext, styleSheet);
	  };
	
	  return GlobalStyle;
	}();
	
	// 
	
	// place our cache into shared context so it'll persist between HMRs
	if (IS_BROWSER) {
	  window.scCGSHMRCache = {};
	}
	
	function createGlobalStyle(strings) {
	  for (var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    interpolations[_key - 1] = arguments[_key];
	  }
	
	  var rules = css.apply(undefined, [strings].concat(interpolations));
	  var id = 'sc-global-' + murmurhash(JSON.stringify(rules));
	  var style = new GlobalStyle(rules, id);
	
	  var GlobalStyleComponent = function (_React$Component) {
	    inherits(GlobalStyleComponent, _React$Component);
	
	    function GlobalStyleComponent(props) {
	      classCallCheck(this, GlobalStyleComponent);
	
	      var _this = possibleConstructorReturn(this, _React$Component.call(this, props));
	
	      var _this$constructor = _this.constructor,
	          globalStyle = _this$constructor.globalStyle,
	          styledComponentId = _this$constructor.styledComponentId;
	
	
	      if (IS_BROWSER) {
	        window.scCGSHMRCache[styledComponentId] = (window.scCGSHMRCache[styledComponentId] || 0) + 1;
	      }
	
	      /**
	       * This fixes HMR compatibility. Don't ask me why, but this combination of
	       * caching the closure variables via statics and then persisting the statics in
	       * state works across HMR where no other combination did. ¯\_(ツ)_/¯
	       */
	      _this.state = {
	        globalStyle: globalStyle,
	        styledComponentId: styledComponentId
	      };
	      return _this;
	    }
	
	    GlobalStyleComponent.prototype.componentWillUnmount = function componentWillUnmount() {
	      if (window.scCGSHMRCache[this.state.styledComponentId]) {
	        window.scCGSHMRCache[this.state.styledComponentId] -= 1;
	      }
	      /**
	       * Depending on the order "render" is called this can cause the styles to be lost
	       * until the next render pass of the remaining instance, which may
	       * not be immediate.
	       */
	      if (window.scCGSHMRCache[this.state.styledComponentId] === 0) {
	        this.state.globalStyle.removeStyles(this.styleSheet);
	      }
	    };
	
	    GlobalStyleComponent.prototype.render = function render() {
	      var _this2 = this;
	
	      if (false) {
	        // eslint-disable-next-line no-console
	        console.warn('The global style component ' + this.state.styledComponentId + ' was given child JSX. createGlobalStyle does not render children.');
	      }
	
	      return React__default.createElement(
	        StyleSheetConsumer,
	        null,
	        function (styleSheet) {
	          _this2.styleSheet = styleSheet || StyleSheet.master;
	
	          var globalStyle = _this2.state.globalStyle;
	
	
	          if (globalStyle.isStatic) {
	            globalStyle.renderStyles(STATIC_EXECUTION_CONTEXT, _this2.styleSheet);
	
	            return null;
	          } else {
	            return React__default.createElement(
	              ThemeConsumer,
	              null,
	              function (theme) {
	                // $FlowFixMe
	                var defaultProps = _this2.constructor.defaultProps;
	
	
	                var context = _extends({}, _this2.props);
	
	                if (typeof theme !== 'undefined') {
	                  context.theme = determineTheme(_this2.props, theme, defaultProps);
	                }
	
	                globalStyle.renderStyles(context, _this2.styleSheet);
	
	                return null;
	              }
	            );
	          }
	        }
	      );
	    };
	
	    return GlobalStyleComponent;
	  }(React__default.Component);
	
	  GlobalStyleComponent.globalStyle = style;
	  GlobalStyleComponent.styledComponentId = id;
	
	
	  return GlobalStyleComponent;
	}
	
	// 
	
	var replaceWhitespace = function replaceWhitespace(str) {
	  return str.replace(/\s|\\n/g, '');
	};
	
	function keyframes(strings) {
	  /* Warning if you've used keyframes on React Native */
	  if (false) {
	    // eslint-disable-next-line no-console
	    console.warn('`keyframes` cannot be used on ReactNative, only on the web. To do animation in ReactNative please use Animated.');
	  }
	
	  for (var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    interpolations[_key - 1] = arguments[_key];
	  }
	
	  var rules = css.apply(undefined, [strings].concat(interpolations));
	
	  var name = generateAlphabeticName(murmurhash(replaceWhitespace(JSON.stringify(rules))));
	
	  return new Keyframes(name, stringifyRules(rules, name, '@keyframes'));
	}
	
	// 
	
	var withTheme = (function (Component) {
	  var WithTheme = React__default.forwardRef(function (props, ref) {
	    return React__default.createElement(
	      ThemeConsumer,
	      null,
	      function (theme) {
	        // $FlowFixMe
	        var defaultProps = Component.defaultProps;
	
	        var themeProp = determineTheme(props, theme, defaultProps);
	
	        if (false) {
	          // eslint-disable-next-line no-console
	          console.warn('[withTheme] You are not using a ThemeProvider nor passing a theme prop or a theme in defaultProps in component class "' + getComponentName(Component) + '"');
	        }
	
	        return React__default.createElement(Component, _extends({}, props, { theme: themeProp, ref: ref }));
	      }
	    );
	  });
	
	  hoistNonReactStatics(WithTheme, Component);
	
	  WithTheme.displayName = 'WithTheme(' + getComponentName(Component) + ')';
	
	  return WithTheme;
	});
	
	// 
	
	/* eslint-disable */
	var __DO_NOT_USE_OR_YOU_WILL_BE_HAUNTED_BY_SPOOKY_GHOSTS = {
	  StyleSheet: StyleSheet
	};
	
	// 
	
	/* Warning if you've imported this file on React Native */
	if (false) {
	  // eslint-disable-next-line no-console
	  console.warn("It looks like you've imported 'styled-components' on React Native.\n" + "Perhaps you're looking to import 'styled-components/native'?\n" + 'Read more about this at https://www.styled-components.com/docs/basics#react-native');
	}
	
	/* Warning if there are several instances of styled-components */
	if (false) {
	  window['__styled-components-init__'] = window['__styled-components-init__'] || 0;
	
	  if (window['__styled-components-init__'] === 1) {
	    // eslint-disable-next-line no-console
	    console.warn("It looks like there are several instances of 'styled-components' initialized in this application. " + 'This may cause dynamic styles not rendering properly, errors happening during rehydration process ' + 'and makes your application bigger without a good reason.\n\n' + 'See https://s-c.sh/2BAXzed for more info.');
	  }
	
	  window['__styled-components-init__'] += 1;
	}
	
	//
	
	exports.default = styled;
	exports.createGlobalStyle = createGlobalStyle;
	exports.css = css;
	exports.isStyledComponent = isStyledComponent;
	exports.keyframes = keyframes;
	exports.ServerStyleSheet = ServerStyleSheet;
	exports.StyleSheetConsumer = StyleSheetConsumer;
	exports.StyleSheetContext = StyleSheetContext;
	exports.StyleSheetManager = StyleSheetManager;
	exports.ThemeConsumer = ThemeConsumer;
	exports.ThemeContext = ThemeContext;
	exports.ThemeProvider = ThemeProvider;
	exports.withTheme = withTheme;
	exports.__DO_NOT_USE_OR_YOU_WILL_BE_HAUNTED_BY_SPOOKY_GHOSTS = __DO_NOT_USE_OR_YOU_WILL_BE_HAUNTED_BY_SPOOKY_GHOSTS;
	//# sourceMappingURL=styled-components.browser.cjs.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(304)))

/***/ },
/* 2172 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {(function (factory) {
		 true ? (module['exports'] = factory()) :
			typeof define === 'function' && define['amd'] ? define(factory()) :
				(window['stylisRuleSheet'] = factory())
	}(function () {
	
		'use strict'
	
		return function (insertRule) {
			var delimiter = '/*|*/'
			var needle = delimiter+'}'
	
			function toSheet (block) {
				if (block)
					try {
						insertRule(block + '}')
					} catch (e) {}
			}
	
			return function ruleSheet (context, content, selectors, parents, line, column, length, ns, depth, at) {
				switch (context) {
					// property
					case 1:
						// @import
						if (depth === 0 && content.charCodeAt(0) === 64)
							return insertRule(content+';'), ''
						break
					// selector
					case 2:
						if (ns === 0)
							return content + delimiter
						break
					// at-rule
					case 3:
						switch (ns) {
							// @font-face, @page
							case 102:
							case 112:
								return insertRule(selectors[0]+content), ''
							default:
								return content + (at === 0 ? delimiter : '')
						}
					case -2:
						content.split(needle).forEach(toSheet)
				}
			}
		}
	}))
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(139)(module)))

/***/ },
/* 2173 */
/***/ function(module, exports, __webpack_require__) {

	!function(e){ true?module.exports=e(null):"function"==typeof define&&define.amd?define(e(null)):window.stylis=e(null)}(function e(a){"use strict";var r=/^\0+/g,c=/[\0\r\f]/g,s=/: */g,t=/zoo|gra/,i=/([,: ])(transform)/g,f=/,+\s*(?![^(]*[)])/g,n=/ +\s*(?![^(]*[)])/g,l=/ *[\0] */g,o=/,\r+?/g,h=/([\t\r\n ])*\f?&/g,u=/:global\(((?:[^\(\)\[\]]*|\[.*\]|\([^\(\)]*\))*)\)/g,d=/\W+/g,b=/@(k\w+)\s*(\S*)\s*/,p=/::(place)/g,k=/:(read-only)/g,g=/\s+(?=[{\];=:>])/g,A=/([[}=:>])\s+/g,C=/(\{[^{]+?);(?=\})/g,w=/\s{2,}/g,v=/([^\(])(:+) */g,m=/[svh]\w+-[tblr]{2}/,x=/\(\s*(.*)\s*\)/g,$=/([\s\S]*?);/g,y=/-self|flex-/g,O=/[^]*?(:[rp][el]a[\w-]+)[^]*/,j=/stretch|:\s*\w+\-(?:conte|avail)/,z=/([^-])(image-set\()/,N="-webkit-",S="-moz-",F="-ms-",W=59,q=125,B=123,D=40,E=41,G=91,H=93,I=10,J=13,K=9,L=64,M=32,P=38,Q=45,R=95,T=42,U=44,V=58,X=39,Y=34,Z=47,_=62,ee=43,ae=126,re=0,ce=12,se=11,te=107,ie=109,fe=115,ne=112,le=111,oe=105,he=99,ue=100,de=112,be=1,pe=1,ke=0,ge=1,Ae=1,Ce=1,we=0,ve=0,me=0,xe=[],$e=[],ye=0,Oe=null,je=-2,ze=-1,Ne=0,Se=1,Fe=2,We=3,qe=0,Be=1,De="",Ee="",Ge="";function He(e,a,s,t,i){for(var f,n,o=0,h=0,u=0,d=0,g=0,A=0,C=0,w=0,m=0,$=0,y=0,O=0,j=0,z=0,R=0,we=0,$e=0,Oe=0,je=0,ze=s.length,Je=ze-1,Re="",Te="",Ue="",Ve="",Xe="",Ye="";R<ze;){if(C=s.charCodeAt(R),R===Je)if(h+d+u+o!==0){if(0!==h)C=h===Z?I:Z;d=u=o=0,ze++,Je++}if(h+d+u+o===0){if(R===Je){if(we>0)Te=Te.replace(c,"");if(Te.trim().length>0){switch(C){case M:case K:case W:case J:case I:break;default:Te+=s.charAt(R)}C=W}}if(1===$e)switch(C){case B:case q:case W:case Y:case X:case D:case E:case U:$e=0;case K:case J:case I:case M:break;default:for($e=0,je=R,g=C,R--,C=W;je<ze;)switch(s.charCodeAt(je++)){case I:case J:case W:++R,C=g,je=ze;break;case V:if(we>0)++R,C=g;case B:je=ze}}switch(C){case B:for(g=(Te=Te.trim()).charCodeAt(0),y=1,je=++R;R<ze;){switch(C=s.charCodeAt(R)){case B:y++;break;case q:y--;break;case Z:switch(A=s.charCodeAt(R+1)){case T:case Z:R=Qe(A,R,Je,s)}break;case G:C++;case D:C++;case Y:case X:for(;R++<Je&&s.charCodeAt(R)!==C;);}if(0===y)break;R++}if(Ue=s.substring(je,R),g===re)g=(Te=Te.replace(r,"").trim()).charCodeAt(0);switch(g){case L:if(we>0)Te=Te.replace(c,"");switch(A=Te.charCodeAt(1)){case ue:case ie:case fe:case Q:f=a;break;default:f=xe}if(je=(Ue=He(a,f,Ue,A,i+1)).length,me>0&&0===je)je=Te.length;if(ye>0)if(f=Ie(xe,Te,Oe),n=Pe(We,Ue,f,a,pe,be,je,A,i,t),Te=f.join(""),void 0!==n)if(0===(je=(Ue=n.trim()).length))A=0,Ue="";if(je>0)switch(A){case fe:Te=Te.replace(x,Me);case ue:case ie:case Q:Ue=Te+"{"+Ue+"}";break;case te:if(Ue=(Te=Te.replace(b,"$1 $2"+(Be>0?De:"")))+"{"+Ue+"}",1===Ae||2===Ae&&Le("@"+Ue,3))Ue="@"+N+Ue+"@"+Ue;else Ue="@"+Ue;break;default:if(Ue=Te+Ue,t===de)Ve+=Ue,Ue=""}else Ue="";break;default:Ue=He(a,Ie(a,Te,Oe),Ue,t,i+1)}Xe+=Ue,O=0,$e=0,z=0,we=0,Oe=0,j=0,Te="",Ue="",C=s.charCodeAt(++R);break;case q:case W:if((je=(Te=(we>0?Te.replace(c,""):Te).trim()).length)>1){if(0===z)if((g=Te.charCodeAt(0))===Q||g>96&&g<123)je=(Te=Te.replace(" ",":")).length;if(ye>0)if(void 0!==(n=Pe(Se,Te,a,e,pe,be,Ve.length,t,i,t)))if(0===(je=(Te=n.trim()).length))Te="\0\0";switch(g=Te.charCodeAt(0),A=Te.charCodeAt(1),g){case re:break;case L:if(A===oe||A===he){Ye+=Te+s.charAt(R);break}default:if(Te.charCodeAt(je-1)===V)break;Ve+=Ke(Te,g,A,Te.charCodeAt(2))}}O=0,$e=0,z=0,we=0,Oe=0,Te="",C=s.charCodeAt(++R)}}switch(C){case J:case I:if(h+d+u+o+ve===0)switch($){case E:case X:case Y:case L:case ae:case _:case T:case ee:case Z:case Q:case V:case U:case W:case B:case q:break;default:if(z>0)$e=1}if(h===Z)h=0;else if(ge+O===0&&t!==te&&Te.length>0)we=1,Te+="\0";if(ye*qe>0)Pe(Ne,Te,a,e,pe,be,Ve.length,t,i,t);be=1,pe++;break;case W:case q:if(h+d+u+o===0){be++;break}default:switch(be++,Re=s.charAt(R),C){case K:case M:if(d+o+h===0)switch(w){case U:case V:case K:case M:Re="";break;default:if(C!==M)Re=" "}break;case re:Re="\\0";break;case ce:Re="\\f";break;case se:Re="\\v";break;case P:if(d+h+o===0&&ge>0)Oe=1,we=1,Re="\f"+Re;break;case 108:if(d+h+o+ke===0&&z>0)switch(R-z){case 2:if(w===ne&&s.charCodeAt(R-3)===V)ke=w;case 8:if(m===le)ke=m}break;case V:if(d+h+o===0)z=R;break;case U:if(h+u+d+o===0)we=1,Re+="\r";break;case Y:case X:if(0===h)d=d===C?0:0===d?C:d;break;case G:if(d+h+u===0)o++;break;case H:if(d+h+u===0)o--;break;case E:if(d+h+o===0)u--;break;case D:if(d+h+o===0){if(0===O)switch(2*w+3*m){case 533:break;default:y=0,O=1}u++}break;case L:if(h+u+d+o+z+j===0)j=1;break;case T:case Z:if(d+o+u>0)break;switch(h){case 0:switch(2*C+3*s.charCodeAt(R+1)){case 235:h=Z;break;case 220:je=R,h=T}break;case T:if(C===Z&&w===T&&je+2!==R){if(33===s.charCodeAt(je+2))Ve+=s.substring(je,R+1);Re="",h=0}}}if(0===h){if(ge+d+o+j===0&&t!==te&&C!==W)switch(C){case U:case ae:case _:case ee:case E:case D:if(0===O){switch(w){case K:case M:case I:case J:Re+="\0";break;default:Re="\0"+Re+(C===U?"":"\0")}we=1}else switch(C){case D:if(z+7===R&&108===w)z=0;O=++y;break;case E:if(0==(O=--y))we=1,Re+="\0"}break;case K:case M:switch(w){case re:case B:case q:case W:case U:case ce:case K:case M:case I:case J:break;default:if(0===O)we=1,Re+="\0"}}if(Te+=Re,C!==M&&C!==K)$=C}}m=w,w=C,R++}if(je=Ve.length,me>0)if(0===je&&0===Xe.length&&0===a[0].length==false)if(t!==ie||1===a.length&&(ge>0?Ee:Ge)===a[0])je=a.join(",").length+2;if(je>0){if(f=0===ge&&t!==te?function(e){for(var a,r,s=0,t=e.length,i=Array(t);s<t;++s){for(var f=e[s].split(l),n="",o=0,h=0,u=0,d=0,b=f.length;o<b;++o){if(0===(h=(r=f[o]).length)&&b>1)continue;if(u=n.charCodeAt(n.length-1),d=r.charCodeAt(0),a="",0!==o)switch(u){case T:case ae:case _:case ee:case M:case D:break;default:a=" "}switch(d){case P:r=a+Ee;case ae:case _:case ee:case M:case E:case D:break;case G:r=a+r+Ee;break;case V:switch(2*r.charCodeAt(1)+3*r.charCodeAt(2)){case 530:if(Ce>0){r=a+r.substring(8,h-1);break}default:if(o<1||f[o-1].length<1)r=a+Ee+r}break;case U:a="";default:if(h>1&&r.indexOf(":")>0)r=a+r.replace(v,"$1"+Ee+"$2");else r=a+r+Ee}n+=r}i[s]=n.replace(c,"").trim()}return i}(a):a,ye>0)if(void 0!==(n=Pe(Fe,Ve,f,e,pe,be,je,t,i,t))&&0===(Ve=n).length)return Ye+Ve+Xe;if(Ve=f.join(",")+"{"+Ve+"}",Ae*ke!=0){if(2===Ae&&!Le(Ve,2))ke=0;switch(ke){case le:Ve=Ve.replace(k,":"+S+"$1")+Ve;break;case ne:Ve=Ve.replace(p,"::"+N+"input-$1")+Ve.replace(p,"::"+S+"$1")+Ve.replace(p,":"+F+"input-$1")+Ve}ke=0}}return Ye+Ve+Xe}function Ie(e,a,r){var c=a.trim().split(o),s=c,t=c.length,i=e.length;switch(i){case 0:case 1:for(var f=0,n=0===i?"":e[0]+" ";f<t;++f)s[f]=Je(n,s[f],r,i).trim();break;default:f=0;var l=0;for(s=[];f<t;++f)for(var h=0;h<i;++h)s[l++]=Je(e[h]+" ",c[f],r,i).trim()}return s}function Je(e,a,r,c){var s=a,t=s.charCodeAt(0);if(t<33)t=(s=s.trim()).charCodeAt(0);switch(t){case P:switch(ge+c){case 0:case 1:if(0===e.trim().length)break;default:return s.replace(h,"$1"+e.trim())}break;case V:switch(s.charCodeAt(1)){case 103:if(Ce>0&&ge>0)return s.replace(u,"$1").replace(h,"$1"+Ge);break;default:return e.trim()+s.replace(h,"$1"+e.trim())}default:if(r*ge>0&&s.indexOf("\f")>0)return s.replace(h,(e.charCodeAt(0)===V?"":"$1")+e.trim())}return e+s}function Ke(e,a,r,c){var l,o=0,h=e+";",u=2*a+3*r+4*c;if(944===u)return function(e){var a=e.length,r=e.indexOf(":",9)+1,c=e.substring(0,r).trim(),s=e.substring(r,a-1).trim();switch(e.charCodeAt(9)*Be){case 0:break;case Q:if(110!==e.charCodeAt(10))break;default:for(var t=s.split((s="",f)),i=0,r=0,a=t.length;i<a;r=0,++i){for(var l=t[i],o=l.split(n);l=o[r];){var h=l.charCodeAt(0);if(1===Be&&(h>L&&h<90||h>96&&h<123||h===R||h===Q&&l.charCodeAt(1)!==Q))switch(isNaN(parseFloat(l))+(-1!==l.indexOf("("))){case 1:switch(l){case"infinite":case"alternate":case"backwards":case"running":case"normal":case"forwards":case"both":case"none":case"linear":case"ease":case"ease-in":case"ease-out":case"ease-in-out":case"paused":case"reverse":case"alternate-reverse":case"inherit":case"initial":case"unset":case"step-start":case"step-end":break;default:l+=De}}o[r++]=l}s+=(0===i?"":",")+o.join(" ")}}if(s=c+s+";",1===Ae||2===Ae&&Le(s,1))return N+s+s;return s}(h);else if(0===Ae||2===Ae&&!Le(h,1))return h;switch(u){case 1015:return 97===h.charCodeAt(10)?N+h+h:h;case 951:return 116===h.charCodeAt(3)?N+h+h:h;case 963:return 110===h.charCodeAt(5)?N+h+h:h;case 1009:if(100!==h.charCodeAt(4))break;case 969:case 942:return N+h+h;case 978:return N+h+S+h+h;case 1019:case 983:return N+h+S+h+F+h+h;case 883:if(h.charCodeAt(8)===Q)return N+h+h;if(h.indexOf("image-set(",11)>0)return h.replace(z,"$1"+N+"$2")+h;return h;case 932:if(h.charCodeAt(4)===Q)switch(h.charCodeAt(5)){case 103:return N+"box-"+h.replace("-grow","")+N+h+F+h.replace("grow","positive")+h;case 115:return N+h+F+h.replace("shrink","negative")+h;case 98:return N+h+F+h.replace("basis","preferred-size")+h}return N+h+F+h+h;case 964:return N+h+F+"flex-"+h+h;case 1023:if(99!==h.charCodeAt(8))break;return l=h.substring(h.indexOf(":",15)).replace("flex-","").replace("space-between","justify"),N+"box-pack"+l+N+h+F+"flex-pack"+l+h;case 1005:return t.test(h)?h.replace(s,":"+N)+h.replace(s,":"+S)+h:h;case 1e3:switch(o=(l=h.substring(13).trim()).indexOf("-")+1,l.charCodeAt(0)+l.charCodeAt(o)){case 226:l=h.replace(m,"tb");break;case 232:l=h.replace(m,"tb-rl");break;case 220:l=h.replace(m,"lr");break;default:return h}return N+h+F+l+h;case 1017:if(-1===h.indexOf("sticky",9))return h;case 975:switch(o=(h=e).length-10,u=(l=(33===h.charCodeAt(o)?h.substring(0,o):h).substring(e.indexOf(":",7)+1).trim()).charCodeAt(0)+(0|l.charCodeAt(7))){case 203:if(l.charCodeAt(8)<111)break;case 115:h=h.replace(l,N+l)+";"+h;break;case 207:case 102:h=h.replace(l,N+(u>102?"inline-":"")+"box")+";"+h.replace(l,N+l)+";"+h.replace(l,F+l+"box")+";"+h}return h+";";case 938:if(h.charCodeAt(5)===Q)switch(h.charCodeAt(6)){case 105:return l=h.replace("-items",""),N+h+N+"box-"+l+F+"flex-"+l+h;case 115:return N+h+F+"flex-item-"+h.replace(y,"")+h;default:return N+h+F+"flex-line-pack"+h.replace("align-content","").replace(y,"")+h}break;case 973:case 989:if(h.charCodeAt(3)!==Q||122===h.charCodeAt(4))break;case 931:case 953:if(true===j.test(e))if(115===(l=e.substring(e.indexOf(":")+1)).charCodeAt(0))return Ke(e.replace("stretch","fill-available"),a,r,c).replace(":fill-available",":stretch");else return h.replace(l,N+l)+h.replace(l,S+l.replace("fill-",""))+h;break;case 962:if(h=N+h+(102===h.charCodeAt(5)?F+h:"")+h,r+c===211&&105===h.charCodeAt(13)&&h.indexOf("transform",10)>0)return h.substring(0,h.indexOf(";",27)+1).replace(i,"$1"+N+"$2")+h}return h}function Le(e,a){var r=e.indexOf(1===a?":":"{"),c=e.substring(0,3!==a?r:10),s=e.substring(r+1,e.length-1);return Oe(2!==a?c:c.replace(O,"$1"),s,a)}function Me(e,a){var r=Ke(a,a.charCodeAt(0),a.charCodeAt(1),a.charCodeAt(2));return r!==a+";"?r.replace($," or ($1)").substring(4):"("+a+")"}function Pe(e,a,r,c,s,t,i,f,n,l){for(var o,h=0,u=a;h<ye;++h)switch(o=$e[h].call(Te,e,u,r,c,s,t,i,f,n,l)){case void 0:case false:case true:case null:break;default:u=o}if(u!==a)return u}function Qe(e,a,r,c){for(var s=a+1;s<r;++s)switch(c.charCodeAt(s)){case Z:if(e===T)if(c.charCodeAt(s-1)===T&&a+2!==s)return s+1;break;case I:if(e===Z)return s+1}return s}function Re(e){for(var a in e){var r=e[a];switch(a){case"keyframe":Be=0|r;break;case"global":Ce=0|r;break;case"cascade":ge=0|r;break;case"compress":we=0|r;break;case"semicolon":ve=0|r;break;case"preserve":me=0|r;break;case"prefix":if(Oe=null,!r)Ae=0;else if("function"!=typeof r)Ae=1;else Ae=2,Oe=r}}return Re}function Te(a,r){if(void 0!==this&&this.constructor===Te)return e(a);var s=a,t=s.charCodeAt(0);if(t<33)t=(s=s.trim()).charCodeAt(0);if(Be>0)De=s.replace(d,t===G?"":"-");if(t=1,1===ge)Ge=s;else Ee=s;var i,f=[Ge];if(ye>0)if(void 0!==(i=Pe(ze,r,f,f,pe,be,0,0,0,0))&&"string"==typeof i)r=i;var n=He(xe,f,r,0,0);if(ye>0)if(void 0!==(i=Pe(je,n,f,f,pe,be,n.length,0,0,0))&&"string"!=typeof(n=i))t=0;return De="",Ge="",Ee="",ke=0,pe=1,be=1,we*t==0?n:n.replace(c,"").replace(g,"").replace(A,"$1").replace(C,"$1").replace(w," ")}if(Te.use=function e(a){switch(a){case void 0:case null:ye=$e.length=0;break;default:if("function"==typeof a)$e[ye++]=a;else if("object"==typeof a)for(var r=0,c=a.length;r<c;++r)e(a[r]);else qe=0|!!a}return e},Te.set=Re,void 0!==a)Re(a);return Te});
	//# sourceMappingURL=stylis.min.js.map

/***/ },
/* 2174 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Module of mixed-in functions shared between node and client code
	 */
	var isObject = __webpack_require__(605);
	
	/**
	 * Clear previous timeout.
	 *
	 * @return {Request} for chaining
	 * @api public
	 */
	
	exports.clearTimeout = function _clearTimeout(){
	  this._timeout = 0;
	  clearTimeout(this._timer);
	  return this;
	};
	
	/**
	 * Override default response body parser
	 *
	 * This function will be called to convert incoming data into request.body
	 *
	 * @param {Function}
	 * @api public
	 */
	
	exports.parse = function parse(fn){
	  this._parser = fn;
	  return this;
	};
	
	/**
	 * Override default request body serializer
	 *
	 * This function will be called to convert data set via .send or .attach into payload to send
	 *
	 * @param {Function}
	 * @api public
	 */
	
	exports.serialize = function serialize(fn){
	  this._serializer = fn;
	  return this;
	};
	
	/**
	 * Set timeout to `ms`.
	 *
	 * @param {Number} ms
	 * @return {Request} for chaining
	 * @api public
	 */
	
	exports.timeout = function timeout(ms){
	  this._timeout = ms;
	  return this;
	};
	
	/**
	 * Promise support
	 *
	 * @param {Function} resolve
	 * @param {Function} reject
	 * @return {Request}
	 */
	
	exports.then = function then(resolve, reject) {
	  if (!this._fullfilledPromise) {
	    var self = this;
	    this._fullfilledPromise = new Promise(function(innerResolve, innerReject){
	      self.end(function(err, res){
	        if (err) innerReject(err); else innerResolve(res);
	      });
	    });
	  }
	  return this._fullfilledPromise.then(resolve, reject);
	}
	
	exports.catch = function(cb) {
	  return this.then(undefined, cb);
	};
	
	/**
	 * Allow for extension
	 */
	
	exports.use = function use(fn) {
	  fn(this);
	  return this;
	}
	
	
	/**
	 * Get request header `field`.
	 * Case-insensitive.
	 *
	 * @param {String} field
	 * @return {String}
	 * @api public
	 */
	
	exports.get = function(field){
	  return this._header[field.toLowerCase()];
	};
	
	/**
	 * Get case-insensitive header `field` value.
	 * This is a deprecated internal API. Use `.get(field)` instead.
	 *
	 * (getHeader is no longer used internally by the superagent code base)
	 *
	 * @param {String} field
	 * @return {String}
	 * @api private
	 * @deprecated
	 */
	
	exports.getHeader = exports.get;
	
	/**
	 * Set header `field` to `val`, or multiple fields with one object.
	 * Case-insensitive.
	 *
	 * Examples:
	 *
	 *      req.get('/')
	 *        .set('Accept', 'application/json')
	 *        .set('X-API-Key', 'foobar')
	 *        .end(callback);
	 *
	 *      req.get('/')
	 *        .set({ Accept: 'application/json', 'X-API-Key': 'foobar' })
	 *        .end(callback);
	 *
	 * @param {String|Object} field
	 * @param {String} val
	 * @return {Request} for chaining
	 * @api public
	 */
	
	exports.set = function(field, val){
	  if (isObject(field)) {
	    for (var key in field) {
	      this.set(key, field[key]);
	    }
	    return this;
	  }
	  this._header[field.toLowerCase()] = val;
	  this.header[field] = val;
	  return this;
	};
	
	/**
	 * Remove header `field`.
	 * Case-insensitive.
	 *
	 * Example:
	 *
	 *      req.get('/')
	 *        .unset('User-Agent')
	 *        .end(callback);
	 *
	 * @param {String} field
	 */
	exports.unset = function(field){
	  delete this._header[field.toLowerCase()];
	  delete this.header[field];
	  return this;
	};
	
	/**
	 * Write the field `name` and `val`, or multiple fields with one object
	 * for "multipart/form-data" request bodies.
	 *
	 * ``` js
	 * request.post('/upload')
	 *   .field('foo', 'bar')
	 *   .end(callback);
	 *
	 * request.post('/upload')
	 *   .field({ foo: 'bar', baz: 'qux' })
	 *   .end(callback);
	 * ```
	 *
	 * @param {String|Object} name
	 * @param {String|Blob|File|Buffer|fs.ReadStream} val
	 * @return {Request} for chaining
	 * @api public
	 */
	exports.field = function(name, val) {
	
	  // name should be either a string or an object.
	  if (null === name ||  undefined === name) {
	    throw new Error('.field(name, val) name can not be empty');
	  }
	
	  if (isObject(name)) {
	    for (var key in name) {
	      this.field(key, name[key]);
	    }
	    return this;
	  }
	
	  // val should be defined now
	  if (null === val || undefined === val) {
	    throw new Error('.field(name, val) val can not be empty');
	  }
	  this._getFormData().append(name, val);
	  return this;
	};
	
	/**
	 * Abort the request, and clear potential timeout.
	 *
	 * @return {Request}
	 * @api public
	 */
	exports.abort = function(){
	  if (this._aborted) {
	    return this;
	  }
	  this._aborted = true;
	  this.xhr && this.xhr.abort(); // browser
	  this.req && this.req.abort(); // node
	  this.clearTimeout();
	  this.emit('abort');
	  return this;
	};
	
	/**
	 * Enable transmission of cookies with x-domain requests.
	 *
	 * Note that for this to work the origin must not be
	 * using "Access-Control-Allow-Origin" with a wildcard,
	 * and also must set "Access-Control-Allow-Credentials"
	 * to "true".
	 *
	 * @api public
	 */
	
	exports.withCredentials = function(){
	  // This is browser-only functionality. Node side is no-op.
	  this._withCredentials = true;
	  return this;
	};
	
	/**
	 * Set the max redirects to `n`. Does noting in browser XHR implementation.
	 *
	 * @param {Number} n
	 * @return {Request} for chaining
	 * @api public
	 */
	
	exports.redirects = function(n){
	  this._maxRedirects = n;
	  return this;
	};
	
	/**
	 * Convert to a plain javascript object (not JSON string) of scalar properties.
	 * Note as this method is designed to return a useful non-this value,
	 * it cannot be chained.
	 *
	 * @return {Object} describing method, url, and data of this request
	 * @api public
	 */
	
	exports.toJSON = function(){
	  return {
	    method: this.method,
	    url: this.url,
	    data: this._data,
	    headers: this._header
	  };
	};
	
	/**
	 * Check if `obj` is a host object,
	 * we don't want to serialize these :)
	 *
	 * TODO: future proof, move to compoent land
	 *
	 * @param {Object} obj
	 * @return {Boolean}
	 * @api private
	 */
	
	exports._isHost = function _isHost(obj) {
	  var str = {}.toString.call(obj);
	
	  switch (str) {
	    case '[object File]':
	    case '[object Blob]':
	    case '[object FormData]':
	      return true;
	    default:
	      return false;
	  }
	}
	
	/**
	 * Send `data` as the request body, defaulting the `.type()` to "json" when
	 * an object is given.
	 *
	 * Examples:
	 *
	 *       // manual json
	 *       request.post('/user')
	 *         .type('json')
	 *         .send('{"name":"tj"}')
	 *         .end(callback)
	 *
	 *       // auto json
	 *       request.post('/user')
	 *         .send({ name: 'tj' })
	 *         .end(callback)
	 *
	 *       // manual x-www-form-urlencoded
	 *       request.post('/user')
	 *         .type('form')
	 *         .send('name=tj')
	 *         .end(callback)
	 *
	 *       // auto x-www-form-urlencoded
	 *       request.post('/user')
	 *         .type('form')
	 *         .send({ name: 'tj' })
	 *         .end(callback)
	 *
	 *       // defaults to x-www-form-urlencoded
	 *      request.post('/user')
	 *        .send('name=tobi')
	 *        .send('species=ferret')
	 *        .end(callback)
	 *
	 * @param {String|Object} data
	 * @return {Request} for chaining
	 * @api public
	 */
	
	exports.send = function(data){
	  var obj = isObject(data);
	  var type = this._header['content-type'];
	
	  // merge
	  if (obj && isObject(this._data)) {
	    for (var key in data) {
	      this._data[key] = data[key];
	    }
	  } else if ('string' == typeof data) {
	    // default to x-www-form-urlencoded
	    if (!type) this.type('form');
	    type = this._header['content-type'];
	    if ('application/x-www-form-urlencoded' == type) {
	      this._data = this._data
	        ? this._data + '&' + data
	        : data;
	    } else {
	      this._data = (this._data || '') + data;
	    }
	  } else {
	    this._data = data;
	  }
	
	  if (!obj || this._isHost(data)) return this;
	
	  // default to json
	  if (!type) this.type('json');
	  return this;
	};


/***/ },
/* 2175 */
/***/ function(module, exports) {

	// The node and browser modules expose versions of this with the
	// appropriate constructor function bound as first argument
	/**
	 * Issue a request:
	 *
	 * Examples:
	 *
	 *    request('GET', '/users').end(callback)
	 *    request('/users').end(callback)
	 *    request('/users', callback)
	 *
	 * @param {String} method
	 * @param {String|Function} url or callback
	 * @return {Request}
	 * @api public
	 */
	
	function request(RequestConstructor, method, url) {
	  // callback
	  if ('function' == typeof url) {
	    return new RequestConstructor('GET', method).end(url);
	  }
	
	  // url first
	  if (2 == arguments.length) {
	    return new RequestConstructor('GET', method);
	  }
	
	  return new RequestConstructor(method, url);
	}
	
	module.exports = request;


/***/ },
/* 2176 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ponyfill = __webpack_require__(2177);
	
	var _ponyfill2 = _interopRequireDefault(_ponyfill);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var root; /* global window */
	
	
	if (typeof self !== 'undefined') {
	  root = self;
	} else if (typeof window !== 'undefined') {
	  root = window;
	} else if (typeof global !== 'undefined') {
	  root = global;
	} else if (true) {
	  root = module;
	} else {
	  root = Function('return this')();
	}
	
	var result = (0, _ponyfill2['default'])(root);
	exports['default'] = result;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(139)(module)))

/***/ },
/* 2177 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports['default'] = symbolObservablePonyfill;
	function symbolObservablePonyfill(root) {
		var result;
		var _Symbol = root.Symbol;
	
		if (typeof _Symbol === 'function') {
			if (_Symbol.observable) {
				result = _Symbol.observable;
			} else {
				result = _Symbol('observable');
				_Symbol.observable = result;
			}
		} else {
			result = '@@observable';
		}
	
		return result;
	};

/***/ },
/* 2178 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(48);
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports.useUncontrolledProp = useUncontrolledProp;
	exports.default = useUncontrolled;
	
	var _extends3 = _interopRequireDefault(__webpack_require__(35));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(43));
	
	var _react = __webpack_require__(1);
	
	var Utils = _interopRequireWildcard(__webpack_require__(609));
	
	function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
	
	function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
	
	function useUncontrolledProp(propValue, defaultValue, handler) {
	  var wasPropRef = (0, _react.useRef)(propValue !== undefined);
	
	  var _useState = (0, _react.useState)(defaultValue),
	      stateValue = _useState[0],
	      setState = _useState[1];
	
	  var isProp = propValue !== undefined;
	  var wasProp = wasPropRef.current;
	  wasPropRef.current = isProp;
	  /**
	   * If a prop switches from controlled to Uncontrolled
	   * reset its value to the defaultValue
	   */
	
	  if (!isProp && wasProp && stateValue !== defaultValue) {
	    setState(defaultValue);
	  }
	
	  return [isProp ? propValue : stateValue, (0, _react.useCallback)(function (value) {
	    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    if (handler) handler.apply(void 0, [value].concat(args));
	    setState(value);
	  }, [handler])];
	}
	
	function useUncontrolled(props, config) {
	  return Object.keys(config).reduce(function (result, fieldName) {
	    var _extends2;
	
	    var _ref = result,
	        defaultValue = _ref[Utils.defaultKey(fieldName)],
	        propsValue = _ref[fieldName],
	        rest = (0, _objectWithoutPropertiesLoose2.default)(_ref, [Utils.defaultKey(fieldName), fieldName].map(_toPropertyKey));
	
	    var handlerName = config[fieldName];
	
	    var _useUncontrolledProp = useUncontrolledProp(propsValue, defaultValue, props[handlerName]),
	        value = _useUncontrolledProp[0],
	        handler = _useUncontrolledProp[1];
	
	    return (0, _extends3.default)({}, rest, (_extends2 = {}, _extends2[fieldName] = value, _extends2[handlerName] = handler, _extends2));
	  }, props);
	}

/***/ },
/* 2179 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	var _interopRequireWildcard = __webpack_require__(48);
	
	exports.__esModule = true;
	exports.default = uncontrollable;
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(43));
	
	var _extends3 = _interopRequireDefault(__webpack_require__(35));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(53));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _reactLifecyclesCompat = __webpack_require__(523);
	
	var _invariant = _interopRequireDefault(__webpack_require__(37));
	
	var Utils = _interopRequireWildcard(__webpack_require__(609));
	
	var _jsxFileName = "/Users/jquense/src/uncontrollable/src/uncontrollable.js";
	
	function uncontrollable(Component, controlledValues, methods) {
	  if (methods === void 0) {
	    methods = [];
	  }
	
	  var displayName = Component.displayName || Component.name || 'Component';
	  var canAcceptRef = Utils.canAcceptRef(Component);
	  var controlledProps = Object.keys(controlledValues);
	  var PROPS_TO_OMIT = controlledProps.map(Utils.defaultKey);
	  !(canAcceptRef || !methods.length) ?  false ? (0, _invariant.default)(false, '[uncontrollable] stateless function components cannot pass through methods ' + 'because they have no associated instances. Check component: ' + displayName + ', ' + 'attempting to pass through methods: ' + methods.join(', ')) : invariant(false) : void 0;
	
	  var UncontrolledComponent =
	  /*#__PURE__*/
	  function (_React$Component) {
	    (0, _inheritsLoose2.default)(UncontrolledComponent, _React$Component);
	
	    function UncontrolledComponent() {
	      var _this;
	
	      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
	      _this.handlers = Object.create(null);
	      controlledProps.forEach(function (propName) {
	        var handlerName = controlledValues[propName];
	
	        var handleChange = function handleChange(value) {
	          if (_this.props[handlerName]) {
	            var _this$props;
	
	            _this._notifying = true;
	
	            for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	              args[_key2 - 1] = arguments[_key2];
	            }
	
	            (_this$props = _this.props)[handlerName].apply(_this$props, [value].concat(args));
	
	            _this._notifying = false;
	          }
	
	          if (!_this.unmounted) _this.setState(function (_ref) {
	            var _extends2;
	
	            var values = _ref.values;
	            return {
	              values: (0, _extends3.default)(Object.create(null), values, (_extends2 = {}, _extends2[propName] = value, _extends2))
	            };
	          });
	        };
	
	        _this.handlers[handlerName] = handleChange;
	      });
	      if (methods.length) _this.attachRef = function (ref) {
	        _this.inner = ref;
	      };
	      var values = Object.create(null);
	      controlledProps.forEach(function (key) {
	        values[key] = _this.props[Utils.defaultKey(key)];
	      });
	      _this.state = {
	        values: values,
	        prevProps: {}
	      };
	      return _this;
	    }
	
	    var _proto = UncontrolledComponent.prototype;
	
	    _proto.shouldComponentUpdate = function shouldComponentUpdate() {
	      //let setState trigger the update
	      return !this._notifying;
	    };
	
	    UncontrolledComponent.getDerivedStateFromProps = function getDerivedStateFromProps(props, _ref2) {
	      var values = _ref2.values,
	          prevProps = _ref2.prevProps;
	      var nextState = {
	        values: (0, _extends3.default)(Object.create(null), values),
	        prevProps: {}
	      };
	      controlledProps.forEach(function (key) {
	        /**
	         * If a prop switches from controlled to Uncontrolled
	         * reset its value to the defaultValue
	         */
	        nextState.prevProps[key] = props[key];
	
	        if (!Utils.isProp(props, key) && Utils.isProp(prevProps, key)) {
	          nextState.values[key] = props[Utils.defaultKey(key)];
	        }
	      });
	      return nextState;
	    };
	
	    _proto.componentWillUnmount = function componentWillUnmount() {
	      this.unmounted = true;
	    };
	
	    _proto.render = function render() {
	      var _this2 = this;
	
	      var _this$props2 = this.props,
	          innerRef = _this$props2.innerRef,
	          props = (0, _objectWithoutPropertiesLoose2.default)(_this$props2, ["innerRef"]);
	      PROPS_TO_OMIT.forEach(function (prop) {
	        delete props[prop];
	      });
	      var newProps = {};
	      controlledProps.forEach(function (propName) {
	        var propValue = _this2.props[propName];
	        newProps[propName] = propValue !== undefined ? propValue : _this2.state.values[propName];
	      });
	      return _react.default.createElement(Component, (0, _extends3.default)({}, props, newProps, this.handlers, {
	        ref: innerRef || this.attachRef
	      }));
	    };
	
	    return UncontrolledComponent;
	  }(_react.default.Component);
	
	  (0, _reactLifecyclesCompat.polyfill)(UncontrolledComponent);
	  UncontrolledComponent.displayName = "Uncontrolled(" + displayName + ")";
	  UncontrolledComponent.propTypes = (0, _extends3.default)({
	    innerRef: function innerRef() {}
	  }, Utils.uncontrolledPropTypes(controlledValues, displayName));
	  methods.forEach(function (method) {
	    UncontrolledComponent.prototype[method] = function $proxiedMethod() {
	      var _this$inner;
	
	      return (_this$inner = this.inner)[method].apply(_this$inner, arguments);
	    };
	  });
	  var WrappedComponent = UncontrolledComponent;
	
	  if (_react.default.forwardRef) {
	    WrappedComponent = _react.default.forwardRef(function (props, ref) {
	      return _react.default.createElement(UncontrolledComponent, (0, _extends3.default)({}, props, {
	        innerRef: ref,
	        __source: {
	          fileName: _jsxFileName,
	          lineNumber: 128
	        },
	        __self: this
	      }));
	    });
	    WrappedComponent.propTypes = UncontrolledComponent.propTypes;
	  }
	
	  WrappedComponent.ControlledComponent = Component;
	  /**
	   * useful when wrapping a Component and you want to control
	   * everything
	   */
	
	  WrappedComponent.deferControlTo = function (newComponent, additions, nextMethods) {
	    if (additions === void 0) {
	      additions = {};
	    }
	
	    return uncontrollable(newComponent, (0, _extends3.default)({}, controlledValues, additions), nextMethods);
	  };
	
	  return WrappedComponent;
	}
	
	module.exports = exports["default"];

/***/ },
/* 2180 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var valueEqual = function valueEqual(a, b) {
	  if (a === b) return true;
	
	  if (a == null || b == null) return false;
	
	  if (Array.isArray(a)) return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
	    return valueEqual(item, b[index]);
	  });
	
	  var aType = typeof a === 'undefined' ? 'undefined' : _typeof(a);
	  var bType = typeof b === 'undefined' ? 'undefined' : _typeof(b);
	
	  if (aType !== bType) return false;
	
	  if (aType === 'object') {
	    var aValue = a.valueOf();
	    var bValue = b.valueOf();
	
	    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);
	
	    var aKeys = Object.keys(a);
	    var bKeys = Object.keys(b);
	
	    if (aKeys.length !== bKeys.length) return false;
	
	    return aKeys.every(function (key) {
	      return valueEqual(a[key], b[key]);
	    });
	  }
	
	  return false;
	};
	
	exports.default = valueEqual;

/***/ },
/* 2181 */
/***/ function(module, exports) {

	(function(self) {
	  'use strict';
	
	  if (self.fetch) {
	    return
	  }
	
	  var support = {
	    searchParams: 'URLSearchParams' in self,
	    iterable: 'Symbol' in self && 'iterator' in Symbol,
	    blob: 'FileReader' in self && 'Blob' in self && (function() {
	      try {
	        new Blob()
	        return true
	      } catch(e) {
	        return false
	      }
	    })(),
	    formData: 'FormData' in self,
	    arrayBuffer: 'ArrayBuffer' in self
	  }
	
	  function normalizeName(name) {
	    if (typeof name !== 'string') {
	      name = String(name)
	    }
	    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
	      throw new TypeError('Invalid character in header field name')
	    }
	    return name.toLowerCase()
	  }
	
	  function normalizeValue(value) {
	    if (typeof value !== 'string') {
	      value = String(value)
	    }
	    return value
	  }
	
	  // Build a destructive iterator for the value list
	  function iteratorFor(items) {
	    var iterator = {
	      next: function() {
	        var value = items.shift()
	        return {done: value === undefined, value: value}
	      }
	    }
	
	    if (support.iterable) {
	      iterator[Symbol.iterator] = function() {
	        return iterator
	      }
	    }
	
	    return iterator
	  }
	
	  function Headers(headers) {
	    this.map = {}
	
	    if (headers instanceof Headers) {
	      headers.forEach(function(value, name) {
	        this.append(name, value)
	      }, this)
	
	    } else if (headers) {
	      Object.getOwnPropertyNames(headers).forEach(function(name) {
	        this.append(name, headers[name])
	      }, this)
	    }
	  }
	
	  Headers.prototype.append = function(name, value) {
	    name = normalizeName(name)
	    value = normalizeValue(value)
	    var list = this.map[name]
	    if (!list) {
	      list = []
	      this.map[name] = list
	    }
	    list.push(value)
	  }
	
	  Headers.prototype['delete'] = function(name) {
	    delete this.map[normalizeName(name)]
	  }
	
	  Headers.prototype.get = function(name) {
	    var values = this.map[normalizeName(name)]
	    return values ? values[0] : null
	  }
	
	  Headers.prototype.getAll = function(name) {
	    return this.map[normalizeName(name)] || []
	  }
	
	  Headers.prototype.has = function(name) {
	    return this.map.hasOwnProperty(normalizeName(name))
	  }
	
	  Headers.prototype.set = function(name, value) {
	    this.map[normalizeName(name)] = [normalizeValue(value)]
	  }
	
	  Headers.prototype.forEach = function(callback, thisArg) {
	    Object.getOwnPropertyNames(this.map).forEach(function(name) {
	      this.map[name].forEach(function(value) {
	        callback.call(thisArg, value, name, this)
	      }, this)
	    }, this)
	  }
	
	  Headers.prototype.keys = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push(name) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.values = function() {
	    var items = []
	    this.forEach(function(value) { items.push(value) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.entries = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push([name, value]) })
	    return iteratorFor(items)
	  }
	
	  if (support.iterable) {
	    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
	  }
	
	  function consumed(body) {
	    if (body.bodyUsed) {
	      return Promise.reject(new TypeError('Already read'))
	    }
	    body.bodyUsed = true
	  }
	
	  function fileReaderReady(reader) {
	    return new Promise(function(resolve, reject) {
	      reader.onload = function() {
	        resolve(reader.result)
	      }
	      reader.onerror = function() {
	        reject(reader.error)
	      }
	    })
	  }
	
	  function readBlobAsArrayBuffer(blob) {
	    var reader = new FileReader()
	    reader.readAsArrayBuffer(blob)
	    return fileReaderReady(reader)
	  }
	
	  function readBlobAsText(blob) {
	    var reader = new FileReader()
	    reader.readAsText(blob)
	    return fileReaderReady(reader)
	  }
	
	  function Body() {
	    this.bodyUsed = false
	
	    this._initBody = function(body) {
	      this._bodyInit = body
	      if (typeof body === 'string') {
	        this._bodyText = body
	      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	        this._bodyBlob = body
	      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	        this._bodyFormData = body
	      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	        this._bodyText = body.toString()
	      } else if (!body) {
	        this._bodyText = ''
	      } else if (support.arrayBuffer && ArrayBuffer.prototype.isPrototypeOf(body)) {
	        // Only support ArrayBuffers for POST method.
	        // Receiving ArrayBuffers happens via Blobs, instead.
	      } else {
	        throw new Error('unsupported BodyInit type')
	      }
	
	      if (!this.headers.get('content-type')) {
	        if (typeof body === 'string') {
	          this.headers.set('content-type', 'text/plain;charset=UTF-8')
	        } else if (this._bodyBlob && this._bodyBlob.type) {
	          this.headers.set('content-type', this._bodyBlob.type)
	        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
	        }
	      }
	    }
	
	    if (support.blob) {
	      this.blob = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return Promise.resolve(this._bodyBlob)
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as blob')
	        } else {
	          return Promise.resolve(new Blob([this._bodyText]))
	        }
	      }
	
	      this.arrayBuffer = function() {
	        return this.blob().then(readBlobAsArrayBuffer)
	      }
	
	      this.text = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return readBlobAsText(this._bodyBlob)
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as text')
	        } else {
	          return Promise.resolve(this._bodyText)
	        }
	      }
	    } else {
	      this.text = function() {
	        var rejected = consumed(this)
	        return rejected ? rejected : Promise.resolve(this._bodyText)
	      }
	    }
	
	    if (support.formData) {
	      this.formData = function() {
	        return this.text().then(decode)
	      }
	    }
	
	    this.json = function() {
	      return this.text().then(JSON.parse)
	    }
	
	    return this
	  }
	
	  // HTTP methods whose capitalization should be normalized
	  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']
	
	  function normalizeMethod(method) {
	    var upcased = method.toUpperCase()
	    return (methods.indexOf(upcased) > -1) ? upcased : method
	  }
	
	  function Request(input, options) {
	    options = options || {}
	    var body = options.body
	    if (Request.prototype.isPrototypeOf(input)) {
	      if (input.bodyUsed) {
	        throw new TypeError('Already read')
	      }
	      this.url = input.url
	      this.credentials = input.credentials
	      if (!options.headers) {
	        this.headers = new Headers(input.headers)
	      }
	      this.method = input.method
	      this.mode = input.mode
	      if (!body) {
	        body = input._bodyInit
	        input.bodyUsed = true
	      }
	    } else {
	      this.url = input
	    }
	
	    this.credentials = options.credentials || this.credentials || 'omit'
	    if (options.headers || !this.headers) {
	      this.headers = new Headers(options.headers)
	    }
	    this.method = normalizeMethod(options.method || this.method || 'GET')
	    this.mode = options.mode || this.mode || null
	    this.referrer = null
	
	    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	      throw new TypeError('Body not allowed for GET or HEAD requests')
	    }
	    this._initBody(body)
	  }
	
	  Request.prototype.clone = function() {
	    return new Request(this)
	  }
	
	  function decode(body) {
	    var form = new FormData()
	    body.trim().split('&').forEach(function(bytes) {
	      if (bytes) {
	        var split = bytes.split('=')
	        var name = split.shift().replace(/\+/g, ' ')
	        var value = split.join('=').replace(/\+/g, ' ')
	        form.append(decodeURIComponent(name), decodeURIComponent(value))
	      }
	    })
	    return form
	  }
	
	  function headers(xhr) {
	    var head = new Headers()
	    var pairs = (xhr.getAllResponseHeaders() || '').trim().split('\n')
	    pairs.forEach(function(header) {
	      var split = header.trim().split(':')
	      var key = split.shift().trim()
	      var value = split.join(':').trim()
	      head.append(key, value)
	    })
	    return head
	  }
	
	  Body.call(Request.prototype)
	
	  function Response(bodyInit, options) {
	    if (!options) {
	      options = {}
	    }
	
	    this.type = 'default'
	    this.status = options.status
	    this.ok = this.status >= 200 && this.status < 300
	    this.statusText = options.statusText
	    this.headers = options.headers instanceof Headers ? options.headers : new Headers(options.headers)
	    this.url = options.url || ''
	    this._initBody(bodyInit)
	  }
	
	  Body.call(Response.prototype)
	
	  Response.prototype.clone = function() {
	    return new Response(this._bodyInit, {
	      status: this.status,
	      statusText: this.statusText,
	      headers: new Headers(this.headers),
	      url: this.url
	    })
	  }
	
	  Response.error = function() {
	    var response = new Response(null, {status: 0, statusText: ''})
	    response.type = 'error'
	    return response
	  }
	
	  var redirectStatuses = [301, 302, 303, 307, 308]
	
	  Response.redirect = function(url, status) {
	    if (redirectStatuses.indexOf(status) === -1) {
	      throw new RangeError('Invalid status code')
	    }
	
	    return new Response(null, {status: status, headers: {location: url}})
	  }
	
	  self.Headers = Headers
	  self.Request = Request
	  self.Response = Response
	
	  self.fetch = function(input, init) {
	    return new Promise(function(resolve, reject) {
	      var request
	      if (Request.prototype.isPrototypeOf(input) && !init) {
	        request = input
	      } else {
	        request = new Request(input, init)
	      }
	
	      var xhr = new XMLHttpRequest()
	
	      function responseURL() {
	        if ('responseURL' in xhr) {
	          return xhr.responseURL
	        }
	
	        // Avoid security warnings on getResponseHeader when not allowed by CORS
	        if (/^X-Request-URL:/m.test(xhr.getAllResponseHeaders())) {
	          return xhr.getResponseHeader('X-Request-URL')
	        }
	
	        return
	      }
	
	      xhr.onload = function() {
	        var options = {
	          status: xhr.status,
	          statusText: xhr.statusText,
	          headers: headers(xhr),
	          url: responseURL()
	        }
	        var body = 'response' in xhr ? xhr.response : xhr.responseText
	        resolve(new Response(body, options))
	      }
	
	      xhr.onerror = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.ontimeout = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.open(request.method, request.url, true)
	
	      if (request.credentials === 'include') {
	        xhr.withCredentials = true
	      }
	
	      if ('responseType' in xhr && support.blob) {
	        xhr.responseType = 'blob'
	      }
	
	      request.headers.forEach(function(value, name) {
	        xhr.setRequestHeader(name, value)
	      })
	
	      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
	    })
	  }
	  self.fetch.polyfill = true
	})(typeof self !== 'undefined' ? self : this);


/***/ },
/* 2182 */
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./en/image01.jpg": 462,
		"./es/image01.jpg": 1612
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 2182;


/***/ },
/* 2183 */
/***/ function(module, exports) {

	/* (ignored) */

/***/ },
/* 2184 */
2183,
/* 2185 */
2183,
/* 2186 */
2183,
/* 2187 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	/* jslint esnext: true */
	
	"use strict";
	var src$core$$ = __webpack_require__(__webpack_module_template_argument_0__), src$en$$ = __webpack_require__(__webpack_module_template_argument_1__);
	
	src$core$$["default"].__addLocaleData(src$en$$["default"]);
	src$core$$["default"].defaultLocale = 'en';
	
	exports["default"] = src$core$$["default"];
	
	//# sourceMappingURL=main.js.map

/***/ },
/* 2188 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(__webpack_module_template_argument_0__);
	} else {
	  module.exports = require('./cjs/react.development.js');
	}


/***/ },
/* 2189 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	"use strict";function _interopDefault(t){return t&&"object"==typeof t&&"default"in t?t.default:t}Object.defineProperty(exports,"__esModule",{value:!0});var resolvePathname=_interopDefault(__webpack_require__(__webpack_module_template_argument_0__)),valueEqual=_interopDefault(__webpack_require__(__webpack_module_template_argument_1__));__webpack_require__(607);var invariant=_interopDefault(__webpack_require__(606));function _extends(){return(_extends=Object.assign||function(t){for(var n=1;n<arguments.length;n++){var e=arguments[n];for(var a in e)Object.prototype.hasOwnProperty.call(e,a)&&(t[a]=e[a])}return t}).apply(this,arguments)}function addLeadingSlash(t){return"/"===t.charAt(0)?t:"/"+t}function stripLeadingSlash(t){return"/"===t.charAt(0)?t.substr(1):t}function hasBasename(t,n){return 0===t.toLowerCase().indexOf(n.toLowerCase())&&-1!=="/?#".indexOf(t.charAt(n.length))}function stripBasename(t,n){return hasBasename(t,n)?t.substr(n.length):t}function stripTrailingSlash(t){return"/"===t.charAt(t.length-1)?t.slice(0,-1):t}function parsePath(t){var n=t||"/",e="",a="",r=n.indexOf("#");-1!==r&&(a=n.substr(r),n=n.substr(0,r));var o=n.indexOf("?");return-1!==o&&(e=n.substr(o),n=n.substr(0,o)),{pathname:n,search:"?"===e?"":e,hash:"#"===a?"":a}}function createPath(t){var n=t.pathname,e=t.search,a=t.hash,r=n||"/";return e&&"?"!==e&&(r+="?"===e.charAt(0)?e:"?"+e),a&&"#"!==a&&(r+="#"===a.charAt(0)?a:"#"+a),r}function createLocation(t,n,e,a){var r;"string"==typeof t?(r=parsePath(t)).state=n:(void 0===(r=_extends({},t)).pathname&&(r.pathname=""),r.search?"?"!==r.search.charAt(0)&&(r.search="?"+r.search):r.search="",r.hash?"#"!==r.hash.charAt(0)&&(r.hash="#"+r.hash):r.hash="",void 0!==n&&void 0===r.state&&(r.state=n));try{r.pathname=decodeURI(r.pathname)}catch(t){throw t instanceof URIError?new URIError('Pathname "'+r.pathname+'" could not be decoded. This is likely caused by an invalid percent-encoding.'):t}return e&&(r.key=e),a?r.pathname?"/"!==r.pathname.charAt(0)&&(r.pathname=resolvePathname(r.pathname,a.pathname)):r.pathname=a.pathname:r.pathname||(r.pathname="/"),r}function locationsAreEqual(t,n){return t.pathname===n.pathname&&t.search===n.search&&t.hash===n.hash&&t.key===n.key&&valueEqual(t.state,n.state)}function createTransitionManager(){var o=null;var a=[];return{setPrompt:function(t){return o=t,function(){o===t&&(o=null)}},confirmTransitionTo:function(t,n,e,a){if(null!=o){var r="function"==typeof o?o(t,n):o;"string"==typeof r?"function"==typeof e?e(r,a):a(!0):a(!1!==r)}else a(!0)},appendListener:function(t){var n=!0;function e(){n&&t.apply(void 0,arguments)}return a.push(e),function(){n=!1,a=a.filter(function(t){return t!==e})}},notifyListeners:function(){for(var t=arguments.length,n=new Array(t),e=0;e<t;e++)n[e]=arguments[e];a.forEach(function(t){return t.apply(void 0,n)})}}}var canUseDOM=!("undefined"==typeof window||!window.document||!window.document.createElement);function getConfirmation(t,n){n(window.confirm(t))}function supportsHistory(){var t=window.navigator.userAgent;return(-1===t.indexOf("Android 2.")&&-1===t.indexOf("Android 4.0")||-1===t.indexOf("Mobile Safari")||-1!==t.indexOf("Chrome")||-1!==t.indexOf("Windows Phone"))&&(window.history&&"pushState"in window.history)}function supportsPopStateOnHashChange(){return-1===window.navigator.userAgent.indexOf("Trident")}function supportsGoWithoutReloadUsingHash(){return-1===window.navigator.userAgent.indexOf("Firefox")}function isExtraneousPopstateEvent(t){return void 0===t.state&&-1===navigator.userAgent.indexOf("CriOS")}var PopStateEvent="popstate",HashChangeEvent="hashchange";function getHistoryState(){try{return window.history.state||{}}catch(t){return{}}}function createBrowserHistory(t){void 0===t&&(t={}),canUseDOM||invariant(!1);var s=window.history,c=supportsHistory(),n=!supportsPopStateOnHashChange(),e=t,a=e.forceRefresh,h=void 0!==a&&a,r=e.getUserConfirmation,u=void 0===r?getConfirmation:r,o=e.keyLength,i=void 0===o?6:o,f=t.basename?stripTrailingSlash(addLeadingSlash(t.basename)):"";function l(t){var n=t||{},e=n.key,a=n.state,r=window.location,o=r.pathname+r.search+r.hash;return f&&(o=stripBasename(o,f)),createLocation(o,a,e)}function d(){return Math.random().toString(36).substr(2,i)}var v=createTransitionManager();function p(t){_extends(T,t),T.length=s.length,v.notifyListeners(T.location,T.action)}function g(t){isExtraneousPopstateEvent(t)||w(l(t.state))}function P(){w(l(getHistoryState()))}var m=!1;function w(n){if(m)m=!1,p();else{v.confirmTransitionTo(n,"POP",u,function(t){t?p({action:"POP",location:n}):function(t){var n=T.location,e=H.indexOf(n.key);-1===e&&(e=0);var a=H.indexOf(t.key);-1===a&&(a=0);var r=e-a;r&&(m=!0,L(r))}(n)})}}var y=l(getHistoryState()),H=[y.key];function x(t){return f+createPath(t)}function L(t){s.go(t)}var O=0;function E(t){1===(O+=t)&&1===t?(window.addEventListener(PopStateEvent,g),n&&window.addEventListener(HashChangeEvent,P)):0===O&&(window.removeEventListener(PopStateEvent,g),n&&window.removeEventListener(HashChangeEvent,P))}var S=!1;var T={length:s.length,action:"POP",location:y,createHref:x,push:function(t,n){var i=createLocation(t,n,d(),T.location);v.confirmTransitionTo(i,"PUSH",u,function(t){if(t){var n=x(i),e=i.key,a=i.state;if(c)if(s.pushState({key:e,state:a},null,n),h)window.location.href=n;else{var r=H.indexOf(T.location.key),o=H.slice(0,r+1);o.push(i.key),H=o,p({action:"PUSH",location:i})}else window.location.href=n}})},replace:function(t,n){var o="REPLACE",i=createLocation(t,n,d(),T.location);v.confirmTransitionTo(i,o,u,function(t){if(t){var n=x(i),e=i.key,a=i.state;if(c)if(s.replaceState({key:e,state:a},null,n),h)window.location.replace(n);else{var r=H.indexOf(T.location.key);-1!==r&&(H[r]=i.key),p({action:o,location:i})}else window.location.replace(n)}})},go:L,goBack:function(){L(-1)},goForward:function(){L(1)},block:function(t){void 0===t&&(t=!1);var n=v.setPrompt(t);return S||(E(1),S=!0),function(){return S&&(S=!1,E(-1)),n()}},listen:function(t){var n=v.appendListener(t);return E(1),function(){E(-1),n()}}};return T}var HashChangeEvent$1="hashchange",HashPathCoders={hashbang:{encodePath:function(t){return"!"===t.charAt(0)?t:"!/"+stripLeadingSlash(t)},decodePath:function(t){return"!"===t.charAt(0)?t.substr(1):t}},noslash:{encodePath:stripLeadingSlash,decodePath:addLeadingSlash},slash:{encodePath:addLeadingSlash,decodePath:addLeadingSlash}};function stripHash(t){var n=t.indexOf("#");return-1===n?t:t.slice(0,n)}function getHashPath(){var t=window.location.href,n=t.indexOf("#");return-1===n?"":t.substring(n+1)}function pushHashPath(t){window.location.hash=t}function replaceHashPath(t){window.location.replace(stripHash(window.location.href)+"#"+t)}function createHashHistory(t){void 0===t&&(t={}),canUseDOM||invariant(!1);var n=window.history,e=(supportsGoWithoutReloadUsingHash(),t),a=e.getUserConfirmation,i=void 0===a?getConfirmation:a,r=e.hashType,o=void 0===r?"slash":r,s=t.basename?stripTrailingSlash(addLeadingSlash(t.basename)):"",c=HashPathCoders[o],h=c.encodePath,u=c.decodePath;function f(){var t=u(getHashPath());return s&&(t=stripBasename(t,s)),createLocation(t)}var l=createTransitionManager();function d(t){_extends(E,t),E.length=n.length,l.notifyListeners(E.location,E.action)}var v=!1,p=null;function g(){var t=getHashPath(),n=h(t);if(t!==n)replaceHashPath(n);else{var e=f(),a=E.location;if(!v&&function(t,n){return t.pathname===n.pathname&&t.search===n.search&&t.hash===n.hash}(a,e))return;if(p===createPath(e))return;p=null,function(n){if(v)v=!1,d();else{l.confirmTransitionTo(n,"POP",i,function(t){t?d({action:"POP",location:n}):function(t){var n=E.location,e=y.lastIndexOf(createPath(n));-1===e&&(e=0);var a=y.lastIndexOf(createPath(t));-1===a&&(a=0);var r=e-a;r&&(v=!0,H(r))}(n)})}}(e)}}var P=getHashPath(),m=h(P);P!==m&&replaceHashPath(m);var w=f(),y=[createPath(w)];function H(t){n.go(t)}var x=0;function L(t){1===(x+=t)&&1===t?window.addEventListener(HashChangeEvent$1,g):0===x&&window.removeEventListener(HashChangeEvent$1,g)}var O=!1;var E={length:n.length,action:"POP",location:w,createHref:function(t){var n=document.querySelector("base"),e="";return n&&n.getAttribute("href")&&(e=stripHash(window.location.href)),e+"#"+h(s+createPath(t))},push:function(t,n){var o=createLocation(t,void 0,void 0,E.location);l.confirmTransitionTo(o,"PUSH",i,function(t){if(t){var n=createPath(o),e=h(s+n);if(getHashPath()!==e){p=n,pushHashPath(e);var a=y.lastIndexOf(createPath(E.location)),r=y.slice(0,a+1);r.push(n),y=r,d({action:"PUSH",location:o})}else d()}})},replace:function(t,n){var r="REPLACE",o=createLocation(t,void 0,void 0,E.location);l.confirmTransitionTo(o,r,i,function(t){if(t){var n=createPath(o),e=h(s+n);getHashPath()!==e&&(p=n,replaceHashPath(e));var a=y.indexOf(createPath(E.location));-1!==a&&(y[a]=n),d({action:r,location:o})}})},go:H,goBack:function(){H(-1)},goForward:function(){H(1)},block:function(t){void 0===t&&(t=!1);var n=l.setPrompt(t);return O||(L(1),O=!0),function(){return O&&(O=!1,L(-1)),n()}},listen:function(t){var n=l.appendListener(t);return L(1),function(){L(-1),n()}}};return E}function clamp(t,n,e){return Math.min(Math.max(t,n),e)}function createMemoryHistory(t){void 0===t&&(t={});var n=t,r=n.getUserConfirmation,e=n.initialEntries,a=void 0===e?["/"]:e,o=n.initialIndex,i=void 0===o?0:o,s=n.keyLength,c=void 0===s?6:s,h=createTransitionManager();function u(t){_extends(g,t),g.length=g.entries.length,h.notifyListeners(g.location,g.action)}function f(){return Math.random().toString(36).substr(2,c)}var l=clamp(i,0,a.length-1),d=a.map(function(t){return createLocation(t,void 0,"string"==typeof t?f():t.key||f())}),v=createPath;function p(t){var n=clamp(g.index+t,0,g.entries.length-1),e=g.entries[n];h.confirmTransitionTo(e,"POP",r,function(t){t?u({action:"POP",location:e,index:n}):u()})}var g={length:d.length,action:"POP",location:d[l],index:l,entries:d,createHref:v,push:function(t,n){var a=createLocation(t,n,f(),g.location);h.confirmTransitionTo(a,"PUSH",r,function(t){if(t){var n=g.index+1,e=g.entries.slice(0);e.length>n?e.splice(n,e.length-n,a):e.push(a),u({action:"PUSH",location:a,index:n,entries:e})}})},replace:function(t,n){var e="REPLACE",a=createLocation(t,n,f(),g.location);h.confirmTransitionTo(a,e,r,function(t){t&&(g.entries[g.index]=a,u({action:e,location:a}))})},go:p,goBack:function(){p(-1)},goForward:function(){p(1)},canGo:function(t){var n=g.index+t;return 0<=n&&n<g.entries.length},block:function(t){return void 0===t&&(t=!1),h.setPrompt(t)},listen:function(t){return h.appendListener(t)}};return g}exports.createBrowserHistory=createBrowserHistory,exports.createHashHistory=createHashHistory,exports.createMemoryHistory=createMemoryHistory,exports.createLocation=createLocation,exports.locationsAreEqual=locationsAreEqual,exports.parsePath=parsePath,exports.createPath=createPath;


/***/ },
/* 2190 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(__webpack_module_template_argument_0__);
	} else {
	  module.exports = require('./cjs/history.js');
	}


/***/ },
/* 2191 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var isarray = __webpack_require__(__webpack_module_template_argument_0__)
	
	/**
	 * Expose `pathToRegexp`.
	 */
	module.exports = pathToRegexp
	module.exports.parse = parse
	module.exports.compile = compile
	module.exports.tokensToFunction = tokensToFunction
	module.exports.tokensToRegExp = tokensToRegExp
	
	/**
	 * The main path matching regexp utility.
	 *
	 * @type {RegExp}
	 */
	var PATH_REGEXP = new RegExp([
	  // Match escaped characters that would otherwise appear in future matches.
	  // This allows the user to escape special characters that won't transform.
	  '(\\\\.)',
	  // Match Express-style parameters and un-named parameters with a prefix
	  // and optional suffixes. Matches appear as:
	  //
	  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
	  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
	  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
	  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
	].join('|'), 'g')
	
	/**
	 * Parse a string for the raw tokens.
	 *
	 * @param  {string}  str
	 * @param  {Object=} options
	 * @return {!Array}
	 */
	function parse (str, options) {
	  var tokens = []
	  var key = 0
	  var index = 0
	  var path = ''
	  var defaultDelimiter = options && options.delimiter || '/'
	  var res
	
	  while ((res = PATH_REGEXP.exec(str)) != null) {
	    var m = res[0]
	    var escaped = res[1]
	    var offset = res.index
	    path += str.slice(index, offset)
	    index = offset + m.length
	
	    // Ignore already escaped sequences.
	    if (escaped) {
	      path += escaped[1]
	      continue
	    }
	
	    var next = str[index]
	    var prefix = res[2]
	    var name = res[3]
	    var capture = res[4]
	    var group = res[5]
	    var modifier = res[6]
	    var asterisk = res[7]
	
	    // Push the current path onto the tokens.
	    if (path) {
	      tokens.push(path)
	      path = ''
	    }
	
	    var partial = prefix != null && next != null && next !== prefix
	    var repeat = modifier === '+' || modifier === '*'
	    var optional = modifier === '?' || modifier === '*'
	    var delimiter = res[2] || defaultDelimiter
	    var pattern = capture || group
	
	    tokens.push({
	      name: name || key++,
	      prefix: prefix || '',
	      delimiter: delimiter,
	      optional: optional,
	      repeat: repeat,
	      partial: partial,
	      asterisk: !!asterisk,
	      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
	    })
	  }
	
	  // Match any characters still remaining.
	  if (index < str.length) {
	    path += str.substr(index)
	  }
	
	  // If the path exists, push it onto the end.
	  if (path) {
	    tokens.push(path)
	  }
	
	  return tokens
	}
	
	/**
	 * Compile a string to a template function for the path.
	 *
	 * @param  {string}             str
	 * @param  {Object=}            options
	 * @return {!function(Object=, Object=)}
	 */
	function compile (str, options) {
	  return tokensToFunction(parse(str, options), options)
	}
	
	/**
	 * Prettier encoding of URI path segments.
	 *
	 * @param  {string}
	 * @return {string}
	 */
	function encodeURIComponentPretty (str) {
	  return encodeURI(str).replace(/[\/?#]/g, function (c) {
	    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
	  })
	}
	
	/**
	 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
	 *
	 * @param  {string}
	 * @return {string}
	 */
	function encodeAsterisk (str) {
	  return encodeURI(str).replace(/[?#]/g, function (c) {
	    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
	  })
	}
	
	/**
	 * Expose a method for transforming tokens into the path function.
	 */
	function tokensToFunction (tokens, options) {
	  // Compile all the tokens into regexps.
	  var matches = new Array(tokens.length)
	
	  // Compile all the patterns before compilation.
	  for (var i = 0; i < tokens.length; i++) {
	    if (typeof tokens[i] === 'object') {
	      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$', flags(options))
	    }
	  }
	
	  return function (obj, opts) {
	    var path = ''
	    var data = obj || {}
	    var options = opts || {}
	    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent
	
	    for (var i = 0; i < tokens.length; i++) {
	      var token = tokens[i]
	
	      if (typeof token === 'string') {
	        path += token
	
	        continue
	      }
	
	      var value = data[token.name]
	      var segment
	
	      if (value == null) {
	        if (token.optional) {
	          // Prepend partial segment prefixes.
	          if (token.partial) {
	            path += token.prefix
	          }
	
	          continue
	        } else {
	          throw new TypeError('Expected "' + token.name + '" to be defined')
	        }
	      }
	
	      if (isarray(value)) {
	        if (!token.repeat) {
	          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
	        }
	
	        if (value.length === 0) {
	          if (token.optional) {
	            continue
	          } else {
	            throw new TypeError('Expected "' + token.name + '" to not be empty')
	          }
	        }
	
	        for (var j = 0; j < value.length; j++) {
	          segment = encode(value[j])
	
	          if (!matches[i].test(segment)) {
	            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
	          }
	
	          path += (j === 0 ? token.prefix : token.delimiter) + segment
	        }
	
	        continue
	      }
	
	      segment = token.asterisk ? encodeAsterisk(value) : encode(value)
	
	      if (!matches[i].test(segment)) {
	        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
	      }
	
	      path += token.prefix + segment
	    }
	
	    return path
	  }
	}
	
	/**
	 * Escape a regular expression string.
	 *
	 * @param  {string} str
	 * @return {string}
	 */
	function escapeString (str) {
	  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
	}
	
	/**
	 * Escape the capturing group by escaping special characters and meaning.
	 *
	 * @param  {string} group
	 * @return {string}
	 */
	function escapeGroup (group) {
	  return group.replace(/([=!:$\/()])/g, '\\$1')
	}
	
	/**
	 * Attach the keys as a property of the regexp.
	 *
	 * @param  {!RegExp} re
	 * @param  {Array}   keys
	 * @return {!RegExp}
	 */
	function attachKeys (re, keys) {
	  re.keys = keys
	  return re
	}
	
	/**
	 * Get the flags for a regexp from the options.
	 *
	 * @param  {Object} options
	 * @return {string}
	 */
	function flags (options) {
	  return options && options.sensitive ? '' : 'i'
	}
	
	/**
	 * Pull out keys from a regexp.
	 *
	 * @param  {!RegExp} path
	 * @param  {!Array}  keys
	 * @return {!RegExp}
	 */
	function regexpToRegexp (path, keys) {
	  // Use a negative lookahead to match only capturing groups.
	  var groups = path.source.match(/\((?!\?)/g)
	
	  if (groups) {
	    for (var i = 0; i < groups.length; i++) {
	      keys.push({
	        name: i,
	        prefix: null,
	        delimiter: null,
	        optional: false,
	        repeat: false,
	        partial: false,
	        asterisk: false,
	        pattern: null
	      })
	    }
	  }
	
	  return attachKeys(path, keys)
	}
	
	/**
	 * Transform an array into a regexp.
	 *
	 * @param  {!Array}  path
	 * @param  {Array}   keys
	 * @param  {!Object} options
	 * @return {!RegExp}
	 */
	function arrayToRegexp (path, keys, options) {
	  var parts = []
	
	  for (var i = 0; i < path.length; i++) {
	    parts.push(pathToRegexp(path[i], keys, options).source)
	  }
	
	  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))
	
	  return attachKeys(regexp, keys)
	}
	
	/**
	 * Create a path regexp from string input.
	 *
	 * @param  {string}  path
	 * @param  {!Array}  keys
	 * @param  {!Object} options
	 * @return {!RegExp}
	 */
	function stringToRegexp (path, keys, options) {
	  return tokensToRegExp(parse(path, options), keys, options)
	}
	
	/**
	 * Expose a function for taking tokens and returning a RegExp.
	 *
	 * @param  {!Array}          tokens
	 * @param  {(Array|Object)=} keys
	 * @param  {Object=}         options
	 * @return {!RegExp}
	 */
	function tokensToRegExp (tokens, keys, options) {
	  if (!isarray(keys)) {
	    options = /** @type {!Object} */ (keys || options)
	    keys = []
	  }
	
	  options = options || {}
	
	  var strict = options.strict
	  var end = options.end !== false
	  var route = ''
	
	  // Iterate over the tokens and create our regexp string.
	  for (var i = 0; i < tokens.length; i++) {
	    var token = tokens[i]
	
	    if (typeof token === 'string') {
	      route += escapeString(token)
	    } else {
	      var prefix = escapeString(token.prefix)
	      var capture = '(?:' + token.pattern + ')'
	
	      keys.push(token)
	
	      if (token.repeat) {
	        capture += '(?:' + prefix + capture + ')*'
	      }
	
	      if (token.optional) {
	        if (!token.partial) {
	          capture = '(?:' + prefix + '(' + capture + '))?'
	        } else {
	          capture = prefix + '(' + capture + ')?'
	        }
	      } else {
	        capture = prefix + '(' + capture + ')'
	      }
	
	      route += capture
	    }
	  }
	
	  var delimiter = escapeString(options.delimiter || '/')
	  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter
	
	  // In non-strict mode we allow a slash at the end of match. If the path to
	  // match already ends with a slash, we remove it for consistency. The slash
	  // is valid at the end of a path match, not in the middle. This is important
	  // in non-ending mode, where "/test/" shouldn't match "/test//route".
	  if (!strict) {
	    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
	  }
	
	  if (end) {
	    route += '$'
	  } else {
	    // In non-ending mode, we need the capturing groups to match as much as
	    // possible by using a positive lookahead to the end or next path segment.
	    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
	  }
	
	  return attachKeys(new RegExp('^' + route, flags(options)), keys)
	}
	
	/**
	 * Normalize the given path string, returning a regular expression.
	 *
	 * An empty array can be passed in for the keys, which will hold the
	 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
	 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
	 *
	 * @param  {(string|RegExp|Array)} path
	 * @param  {(Array|Object)=}       keys
	 * @param  {Object=}               options
	 * @return {!RegExp}
	 */
	function pathToRegexp (path, keys, options) {
	  if (!isarray(keys)) {
	    options = /** @type {!Object} */ (keys || options)
	    keys = []
	  }
	
	  options = options || {}
	
	  if (path instanceof RegExp) {
	    return regexpToRegexp(path, /** @type {!Array} */ (keys))
	  }
	
	  if (isarray(path)) {
	    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
	  }
	
	  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
	}


/***/ },
/* 2192 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _warning = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _history = __webpack_require__(__webpack_module_template_argument_1__);
	
	var _Router = __webpack_require__(__webpack_module_template_argument_2__);
	
	var _Router2 = _interopRequireDefault(_Router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for a <Router> that stores location in memory.
	 */
	var MemoryRouter = function (_React$Component) {
	  _inherits(MemoryRouter, _React$Component);
	
	  function MemoryRouter() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, MemoryRouter);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = (0, _history.createMemoryHistory)(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  MemoryRouter.prototype.componentWillMount = function componentWillMount() {
	    (0, _warning2.default)(!this.props.history, "<MemoryRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { MemoryRouter as Router }`.");
	  };
	
	  MemoryRouter.prototype.render = function render() {
	    return _react2.default.createElement(_Router2.default, { history: this.history, children: this.props.children });
	  };
	
	  return MemoryRouter;
	}(_react2.default.Component);
	
	MemoryRouter.propTypes = {
	  initialEntries: _propTypes2.default.array,
	  initialIndex: _propTypes2.default.number,
	  getUserConfirmation: _propTypes2.default.func,
	  keyLength: _propTypes2.default.number,
	  children: _propTypes2.default.node
	};
	exports.default = MemoryRouter;

/***/ },
/* 2193 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(37);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _history = __webpack_require__(__webpack_module_template_argument_1__);
	
	var _generatePath = __webpack_require__(__webpack_module_template_argument_2__);
	
	var _generatePath2 = _interopRequireDefault(_generatePath);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for updating the location programmatically
	 * with a component.
	 */
	var Redirect = function (_React$Component) {
	  _inherits(Redirect, _React$Component);
	
	  function Redirect() {
	    _classCallCheck(this, Redirect);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Redirect.prototype.isStatic = function isStatic() {
	    return this.context.router && this.context.router.staticContext;
	  };
	
	  Redirect.prototype.componentWillMount = function componentWillMount() {
	    (0, _invariant2.default)(this.context.router, "You should not use <Redirect> outside a <Router>");
	
	    if (this.isStatic()) this.perform();
	  };
	
	  Redirect.prototype.componentDidMount = function componentDidMount() {
	    if (!this.isStatic()) this.perform();
	  };
	
	  Redirect.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var prevTo = (0, _history.createLocation)(prevProps.to);
	    var nextTo = (0, _history.createLocation)(this.props.to);
	
	    if ((0, _history.locationsAreEqual)(prevTo, nextTo)) {
	      (0, _warning2.default)(false, "You tried to redirect to the same route you're currently on: " + ("\"" + nextTo.pathname + nextTo.search + "\""));
	      return;
	    }
	
	    this.perform();
	  };
	
	  Redirect.prototype.computeTo = function computeTo(_ref) {
	    var computedMatch = _ref.computedMatch,
	        to = _ref.to;
	
	    if (computedMatch) {
	      if (typeof to === "string") {
	        return (0, _generatePath2.default)(to, computedMatch.params);
	      } else {
	        return _extends({}, to, {
	          pathname: (0, _generatePath2.default)(to.pathname, computedMatch.params)
	        });
	      }
	    }
	
	    return to;
	  };
	
	  Redirect.prototype.perform = function perform() {
	    var history = this.context.router.history;
	    var push = this.props.push;
	
	    var to = this.computeTo(this.props);
	
	    if (push) {
	      history.push(to);
	    } else {
	      history.replace(to);
	    }
	  };
	
	  Redirect.prototype.render = function render() {
	    return null;
	  };
	
	  return Redirect;
	}(_react2.default.Component);
	
	Redirect.propTypes = {
	  computedMatch: _propTypes2.default.object, // private, from <Switch>
	  push: _propTypes2.default.bool,
	  from: _propTypes2.default.string,
	  to: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]).isRequired
	};
	Redirect.defaultProps = {
	  push: false
	};
	Redirect.contextTypes = {
	  router: _propTypes2.default.shape({
	    history: _propTypes2.default.shape({
	      push: _propTypes2.default.func.isRequired,
	      replace: _propTypes2.default.func.isRequired
	    }).isRequired,
	    staticContext: _propTypes2.default.object
	  }).isRequired
	};
	exports.default = Redirect;

/***/ },
/* 2194 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(37);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _matchPath = __webpack_require__(__webpack_module_template_argument_1__);
	
	var _matchPath2 = _interopRequireDefault(_matchPath);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var isEmptyChildren = function isEmptyChildren(children) {
	  return _react2.default.Children.count(children) === 0;
	};
	
	/**
	 * The public API for matching a single path and rendering.
	 */
	
	var Route = function (_React$Component) {
	  _inherits(Route, _React$Component);
	
	  function Route() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Route);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      match: _this.computeMatch(_this.props, _this.context.router)
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Route.prototype.getChildContext = function getChildContext() {
	    return {
	      router: _extends({}, this.context.router, {
	        route: {
	          location: this.props.location || this.context.router.route.location,
	          match: this.state.match
	        }
	      })
	    };
	  };
	
	  Route.prototype.computeMatch = function computeMatch(_ref, router) {
	    var computedMatch = _ref.computedMatch,
	        location = _ref.location,
	        path = _ref.path,
	        strict = _ref.strict,
	        exact = _ref.exact,
	        sensitive = _ref.sensitive;
	
	    if (computedMatch) return computedMatch; // <Switch> already computed the match for us
	
	    (0, _invariant2.default)(router, "You should not use <Route> or withRouter() outside a <Router>");
	
	    var route = router.route;
	
	    var pathname = (location || route.location).pathname;
	
	    return (0, _matchPath2.default)(pathname, { path: path, strict: strict, exact: exact, sensitive: sensitive }, route.match);
	  };
	
	  Route.prototype.componentWillMount = function componentWillMount() {
	    (0, _warning2.default)(!(this.props.component && this.props.render), "You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored");
	
	    (0, _warning2.default)(!(this.props.component && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored");
	
	    (0, _warning2.default)(!(this.props.render && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored");
	  };
	
	  Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
	    (0, _warning2.default)(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');
	
	    (0, _warning2.default)(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
	
	    this.setState({
	      match: this.computeMatch(nextProps, nextContext.router)
	    });
	  };
	
	  Route.prototype.render = function render() {
	    var match = this.state.match;
	    var _props = this.props,
	        children = _props.children,
	        component = _props.component,
	        render = _props.render;
	    var _context$router = this.context.router,
	        history = _context$router.history,
	        route = _context$router.route,
	        staticContext = _context$router.staticContext;
	
	    var location = this.props.location || route.location;
	    var props = { match: match, location: location, history: history, staticContext: staticContext };
	
	    if (component) return match ? _react2.default.createElement(component, props) : null;
	
	    if (render) return match ? render(props) : null;
	
	    if (typeof children === "function") return children(props);
	
	    if (children && !isEmptyChildren(children)) return _react2.default.Children.only(children);
	
	    return null;
	  };
	
	  return Route;
	}(_react2.default.Component);
	
	Route.propTypes = {
	  computedMatch: _propTypes2.default.object, // private, from <Switch>
	  path: _propTypes2.default.string,
	  exact: _propTypes2.default.bool,
	  strict: _propTypes2.default.bool,
	  sensitive: _propTypes2.default.bool,
	  component: _propTypes2.default.func,
	  render: _propTypes2.default.func,
	  children: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.node]),
	  location: _propTypes2.default.object
	};
	Route.contextTypes = {
	  router: _propTypes2.default.shape({
	    history: _propTypes2.default.object.isRequired,
	    route: _propTypes2.default.object.isRequired,
	    staticContext: _propTypes2.default.object
	  })
	};
	Route.childContextTypes = {
	  router: _propTypes2.default.object.isRequired
	};
	exports.default = Route;

/***/ },
/* 2195 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(37);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for putting history on context.
	 */
	var Router = function (_React$Component) {
	  _inherits(Router, _React$Component);
	
	  function Router() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Router);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      match: _this.computeMatch(_this.props.history.location.pathname)
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Router.prototype.getChildContext = function getChildContext() {
	    return {
	      router: _extends({}, this.context.router, {
	        history: this.props.history,
	        route: {
	          location: this.props.history.location,
	          match: this.state.match
	        }
	      })
	    };
	  };
	
	  Router.prototype.computeMatch = function computeMatch(pathname) {
	    return {
	      path: "/",
	      url: "/",
	      params: {},
	      isExact: pathname === "/"
	    };
	  };
	
	  Router.prototype.componentWillMount = function componentWillMount() {
	    var _this2 = this;
	
	    var _props = this.props,
	        children = _props.children,
	        history = _props.history;
	
	
	    (0, _invariant2.default)(children == null || _react2.default.Children.count(children) === 1, "A <Router> may have only one child element");
	
	    // Do this here so we can setState when a <Redirect> changes the
	    // location in componentWillMount. This happens e.g. when doing
	    // server rendering using a <StaticRouter>.
	    this.unlisten = history.listen(function () {
	      _this2.setState({
	        match: _this2.computeMatch(history.location.pathname)
	      });
	    });
	  };
	
	  Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    (0, _warning2.default)(this.props.history === nextProps.history, "You cannot change <Router history>");
	  };
	
	  Router.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.unlisten();
	  };
	
	  Router.prototype.render = function render() {
	    var children = this.props.children;
	
	    return children ? _react2.default.Children.only(children) : null;
	  };
	
	  return Router;
	}(_react2.default.Component);
	
	Router.propTypes = {
	  history: _propTypes2.default.object.isRequired,
	  children: _propTypes2.default.node
	};
	Router.contextTypes = {
	  router: _propTypes2.default.object
	};
	Router.childContextTypes = {
	  router: _propTypes2.default.object.isRequired
	};
	exports.default = Router;

/***/ },
/* 2196 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(37);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _history = __webpack_require__(__webpack_module_template_argument_1__);
	
	var _Router = __webpack_require__(__webpack_module_template_argument_2__);
	
	var _Router2 = _interopRequireDefault(_Router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var addLeadingSlash = function addLeadingSlash(path) {
	  return path.charAt(0) === "/" ? path : "/" + path;
	};
	
	var addBasename = function addBasename(basename, location) {
	  if (!basename) return location;
	
	  return _extends({}, location, {
	    pathname: addLeadingSlash(basename) + location.pathname
	  });
	};
	
	var stripBasename = function stripBasename(basename, location) {
	  if (!basename) return location;
	
	  var base = addLeadingSlash(basename);
	
	  if (location.pathname.indexOf(base) !== 0) return location;
	
	  return _extends({}, location, {
	    pathname: location.pathname.substr(base.length)
	  });
	};
	
	var createURL = function createURL(location) {
	  return typeof location === "string" ? location : (0, _history.createPath)(location);
	};
	
	var staticHandler = function staticHandler(methodName) {
	  return function () {
	    (0, _invariant2.default)(false, "You cannot %s with <StaticRouter>", methodName);
	  };
	};
	
	var noop = function noop() {};
	
	/**
	 * The public top-level API for a "static" <Router>, so-called because it
	 * can't actually change the current location. Instead, it just records
	 * location changes in a context object. Useful mainly in testing and
	 * server-rendering scenarios.
	 */
	
	var StaticRouter = function (_React$Component) {
	  _inherits(StaticRouter, _React$Component);
	
	  function StaticRouter() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, StaticRouter);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.createHref = function (path) {
	      return addLeadingSlash(_this.props.basename + createURL(path));
	    }, _this.handlePush = function (location) {
	      var _this$props = _this.props,
	          basename = _this$props.basename,
	          context = _this$props.context;
	
	      context.action = "PUSH";
	      context.location = addBasename(basename, (0, _history.createLocation)(location));
	      context.url = createURL(context.location);
	    }, _this.handleReplace = function (location) {
	      var _this$props2 = _this.props,
	          basename = _this$props2.basename,
	          context = _this$props2.context;
	
	      context.action = "REPLACE";
	      context.location = addBasename(basename, (0, _history.createLocation)(location));
	      context.url = createURL(context.location);
	    }, _this.handleListen = function () {
	      return noop;
	    }, _this.handleBlock = function () {
	      return noop;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  StaticRouter.prototype.getChildContext = function getChildContext() {
	    return {
	      router: {
	        staticContext: this.props.context
	      }
	    };
	  };
	
	  StaticRouter.prototype.componentWillMount = function componentWillMount() {
	    (0, _warning2.default)(!this.props.history, "<StaticRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { StaticRouter as Router }`.");
	  };
	
	  StaticRouter.prototype.render = function render() {
	    var _props = this.props,
	        basename = _props.basename,
	        context = _props.context,
	        location = _props.location,
	        props = _objectWithoutProperties(_props, ["basename", "context", "location"]);
	
	    var history = {
	      createHref: this.createHref,
	      action: "POP",
	      location: stripBasename(basename, (0, _history.createLocation)(location)),
	      push: this.handlePush,
	      replace: this.handleReplace,
	      go: staticHandler("go"),
	      goBack: staticHandler("goBack"),
	      goForward: staticHandler("goForward"),
	      listen: this.handleListen,
	      block: this.handleBlock
	    };
	
	    return _react2.default.createElement(_Router2.default, _extends({}, props, { history: history }));
	  };
	
	  return StaticRouter;
	}(_react2.default.Component);
	
	StaticRouter.propTypes = {
	  basename: _propTypes2.default.string,
	  context: _propTypes2.default.object.isRequired,
	  location: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object])
	};
	StaticRouter.defaultProps = {
	  basename: "",
	  location: "/"
	};
	StaticRouter.childContextTypes = {
	  router: _propTypes2.default.object.isRequired
	};
	exports.default = StaticRouter;

/***/ },
/* 2197 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(37);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _matchPath = __webpack_require__(__webpack_module_template_argument_1__);
	
	var _matchPath2 = _interopRequireDefault(_matchPath);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for rendering the first <Route> that matches.
	 */
	var Switch = function (_React$Component) {
	  _inherits(Switch, _React$Component);
	
	  function Switch() {
	    _classCallCheck(this, Switch);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Switch.prototype.componentWillMount = function componentWillMount() {
	    (0, _invariant2.default)(this.context.router, "You should not use <Switch> outside a <Router>");
	  };
	
	  Switch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    (0, _warning2.default)(!(nextProps.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');
	
	    (0, _warning2.default)(!(!nextProps.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
	  };
	
	  Switch.prototype.render = function render() {
	    var route = this.context.router.route;
	    var children = this.props.children;
	
	    var location = this.props.location || route.location;
	
	    var match = void 0,
	        child = void 0;
	    _react2.default.Children.forEach(children, function (element) {
	      if (match == null && _react2.default.isValidElement(element)) {
	        var _element$props = element.props,
	            pathProp = _element$props.path,
	            exact = _element$props.exact,
	            strict = _element$props.strict,
	            sensitive = _element$props.sensitive,
	            from = _element$props.from;
	
	        var path = pathProp || from;
	
	        child = element;
	        match = (0, _matchPath2.default)(location.pathname, { path: path, exact: exact, strict: strict, sensitive: sensitive }, route.match);
	      }
	    });
	
	    return match ? _react2.default.cloneElement(child, { location: location, computedMatch: match }) : null;
	  };
	
	  return Switch;
	}(_react2.default.Component);
	
	Switch.contextTypes = {
	  router: _propTypes2.default.shape({
	    route: _propTypes2.default.object.isRequired
	  }).isRequired
	};
	Switch.propTypes = {
	  children: _propTypes2.default.node,
	  location: _propTypes2.default.object
	};
	exports.default = Switch;

/***/ },
/* 2198 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _pathToRegexp = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _pathToRegexp2 = _interopRequireDefault(_pathToRegexp);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var patternCache = {};
	var cacheLimit = 10000;
	var cacheCount = 0;
	
	var compileGenerator = function compileGenerator(pattern) {
	  var cacheKey = pattern;
	  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});
	
	  if (cache[pattern]) return cache[pattern];
	
	  var compiledGenerator = _pathToRegexp2.default.compile(pattern);
	
	  if (cacheCount < cacheLimit) {
	    cache[pattern] = compiledGenerator;
	    cacheCount++;
	  }
	
	  return compiledGenerator;
	};
	
	/**
	 * Public API for generating a URL pathname from a pattern and parameters.
	 */
	var generatePath = function generatePath() {
	  var pattern = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "/";
	  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  if (pattern === "/") {
	    return pattern;
	  }
	  var generator = compileGenerator(pattern);
	  return generator(params, { pretty: true });
	};
	
	exports.default = generatePath;

/***/ },
/* 2199 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__, __webpack_module_template_argument_6__, __webpack_module_template_argument_7__, __webpack_module_template_argument_8__, __webpack_module_template_argument_9__) {

	"use strict";
	
	exports.__esModule = true;
	exports.withRouter = exports.matchPath = exports.generatePath = exports.Switch = exports.StaticRouter = exports.Router = exports.Route = exports.Redirect = exports.Prompt = exports.MemoryRouter = undefined;
	
	var _MemoryRouter2 = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _MemoryRouter3 = _interopRequireDefault(_MemoryRouter2);
	
	var _Prompt2 = __webpack_require__(__webpack_module_template_argument_1__);
	
	var _Prompt3 = _interopRequireDefault(_Prompt2);
	
	var _Redirect2 = __webpack_require__(__webpack_module_template_argument_2__);
	
	var _Redirect3 = _interopRequireDefault(_Redirect2);
	
	var _Route2 = __webpack_require__(__webpack_module_template_argument_3__);
	
	var _Route3 = _interopRequireDefault(_Route2);
	
	var _Router2 = __webpack_require__(__webpack_module_template_argument_4__);
	
	var _Router3 = _interopRequireDefault(_Router2);
	
	var _StaticRouter2 = __webpack_require__(__webpack_module_template_argument_5__);
	
	var _StaticRouter3 = _interopRequireDefault(_StaticRouter2);
	
	var _Switch2 = __webpack_require__(__webpack_module_template_argument_6__);
	
	var _Switch3 = _interopRequireDefault(_Switch2);
	
	var _generatePath2 = __webpack_require__(__webpack_module_template_argument_7__);
	
	var _generatePath3 = _interopRequireDefault(_generatePath2);
	
	var _matchPath2 = __webpack_require__(__webpack_module_template_argument_8__);
	
	var _matchPath3 = _interopRequireDefault(_matchPath2);
	
	var _withRouter2 = __webpack_require__(__webpack_module_template_argument_9__);
	
	var _withRouter3 = _interopRequireDefault(_withRouter2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.MemoryRouter = _MemoryRouter3.default;
	exports.Prompt = _Prompt3.default;
	exports.Redirect = _Redirect3.default;
	exports.Route = _Route3.default;
	exports.Router = _Router3.default;
	exports.StaticRouter = _StaticRouter3.default;
	exports.Switch = _Switch3.default;
	exports.generatePath = _generatePath3.default;
	exports.matchPath = _matchPath3.default;
	exports.withRouter = _withRouter3.default;

/***/ },
/* 2200 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _pathToRegexp = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _pathToRegexp2 = _interopRequireDefault(_pathToRegexp);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var patternCache = {};
	var cacheLimit = 10000;
	var cacheCount = 0;
	
	var compilePath = function compilePath(pattern, options) {
	  var cacheKey = "" + options.end + options.strict + options.sensitive;
	  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});
	
	  if (cache[pattern]) return cache[pattern];
	
	  var keys = [];
	  var re = (0, _pathToRegexp2.default)(pattern, keys, options);
	  var compiledPattern = { re: re, keys: keys };
	
	  if (cacheCount < cacheLimit) {
	    cache[pattern] = compiledPattern;
	    cacheCount++;
	  }
	
	  return compiledPattern;
	};
	
	/**
	 * Public API for matching a URL pathname to a path pattern.
	 */
	var matchPath = function matchPath(pathname) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var parent = arguments[2];
	
	  if (typeof options === "string") options = { path: options };
	
	  var _options = options,
	      path = _options.path,
	      _options$exact = _options.exact,
	      exact = _options$exact === undefined ? false : _options$exact,
	      _options$strict = _options.strict,
	      strict = _options$strict === undefined ? false : _options$strict,
	      _options$sensitive = _options.sensitive,
	      sensitive = _options$sensitive === undefined ? false : _options$sensitive;
	
	
	  if (path == null) return parent;
	
	  var _compilePath = compilePath(path, { end: exact, strict: strict, sensitive: sensitive }),
	      re = _compilePath.re,
	      keys = _compilePath.keys;
	
	  var match = re.exec(pathname);
	
	  if (!match) return null;
	
	  var url = match[0],
	      values = match.slice(1);
	
	  var isExact = pathname === url;
	
	  if (exact && !isExact) return null;
	
	  return {
	    path: path, // the path pattern used to match
	    url: path === "/" && url === "" ? "/" : url, // the matched portion of the URL
	    isExact: isExact, // whether or not we matched exactly
	    params: keys.reduce(function (memo, key, index) {
	      memo[key.name] = values[index];
	      return memo;
	    }, {})
	  };
	};
	
	exports.default = matchPath;

/***/ },
/* 2201 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _hoistNonReactStatics = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _Route = __webpack_require__(__webpack_module_template_argument_1__);
	
	var _Route2 = _interopRequireDefault(_Route);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 * A public higher-order component to access the imperative API
	 */
	var withRouter = function withRouter(Component) {
	  var C = function C(props) {
	    var wrappedComponentRef = props.wrappedComponentRef,
	        remainingProps = _objectWithoutProperties(props, ["wrappedComponentRef"]);
	
	    return _react2.default.createElement(_Route2.default, {
	      children: function children(routeComponentProps) {
	        return _react2.default.createElement(Component, _extends({}, remainingProps, routeComponentProps, {
	          ref: wrappedComponentRef
	        }));
	      }
	    });
	  };
	
	  C.displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
	  C.WrappedComponent = Component;
	  C.propTypes = {
	    wrappedComponentRef: _propTypes2.default.func
	  };
	
	  return (0, _hoistNonReactStatics2.default)(C, Component);
	};
	
	exports.default = withRouter;

/***/ },
/* 2202 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(__webpack_module_template_argument_0__);
	} else {
	  module.exports = require('./cjs/resolve-pathname.js');
	}


/***/ },
/* 2203 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(__webpack_module_template_argument_0__);
	} else {
	  module.exports = require('./cjs/value-equal.js');
	}


/***/ },
/* 2204 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(__webpack_module_template_argument_0__);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(25)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!../../../../node_modules/sass-loader/index.js!./line-item.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!../../../../node_modules/sass-loader/index.js!./line-item.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }
/******/ ])));


/** WEBPACK FOOTER **
 ** static/js/main.de9eb341.js
 **/